export const iconList = {
	"metadata": {
		"name": "QuoDeck",
		"lastOpened": 1465886828284,
		"created": 1465886819533
	},
	"iconSets": [
		{
			"selection": [
				{
					"order": 1548,
					"prevSize": 32,
					"name": "500px",
					"ligatures": "500px, brand35",
					"id": 3359,
					"code": 62742,
					"tempChar": ""
				},
				{
					"name": "500px2",
					"id": 1747,
					"order": 2180,
					"prevSize": 32,
					"code": 62062,
					"tempChar": ""
				},
				{
					"order": 1596,
					"prevSize": 32,
					"ligatures": "IE, browser3",
					"name": "IE",
					"id": 3407,
					"code": 62790,
					"tempChar": ""
				},
				{
					"order": 1611,
					"prevSize": 32,
					"ligatures": "IcoMoon, icomoon",
					"name": "IcoMoon",
					"id": 3422,
					"code": 62805,
					"tempChar": ""
				},
				{
					"order": 810,
					"prevSize": 32,
					"ligatures": "accessibility",
					"name": "accessibility",
					"id": 2621,
					"code": 61370,
					"tempChar": ""
				},
				{
					"order": 811,
					"prevSize": 32,
					"ligatures": "accessibility2, disabled",
					"name": "accessibility2",
					"id": 2622,
					"code": 61371,
					"tempChar": ""
				},
				{
					"id": 265,
					"order": 2480,
					"prevSize": 32,
					"code": 59648,
					"name": "accommodate",
					"tempChar": ""
				},
				{
					"id": 266,
					"order": 2481,
					"prevSize": 32,
					"code": 59649,
					"name": "accommodate2",
					"tempChar": ""
				},
				{
					"id": 945,
					"order": 2246,
					"prevSize": 32,
					"code": 60328,
					"name": "accommodate3",
					"tempChar": ""
				},
				{
					"id": 267,
					"order": 2482,
					"prevSize": 32,
					"code": 59650,
					"name": "adapt",
					"tempChar": ""
				},
				{
					"id": 268,
					"order": 2483,
					"prevSize": 32,
					"code": 59651,
					"name": "adapt2",
					"tempChar": ""
				},
				{
					"id": 269,
					"order": 2484,
					"prevSize": 32,
					"code": 59652,
					"name": "add",
					"tempChar": ""
				},
				{
					"id": 270,
					"order": 2485,
					"prevSize": 32,
					"code": 59653,
					"name": "add2",
					"tempChar": ""
				},
				{
					"id": 946,
					"order": 2247,
					"prevSize": 32,
					"code": 60329,
					"name": "add3",
					"tempChar": ""
				},
				{
					"order": 301,
					"prevSize": 32,
					"ligatures": "address-book, contact",
					"name": "address-book",
					"id": 2112,
					"code": 60861,
					"tempChar": ""
				},
				{
					"order": 302,
					"prevSize": 32,
					"ligatures": "address-book2, contacts",
					"name": "address-book2",
					"id": 2113,
					"code": 60862,
					"tempChar": ""
				},
				{
					"order": 303,
					"prevSize": 32,
					"ligatures": "address-book3, contact2",
					"name": "address-book3",
					"id": 2114,
					"code": 60863,
					"tempChar": ""
				},
				{
					"name": "adjust",
					"id": 1241,
					"order": 1674,
					"prevSize": 32,
					"code": 61506,
					"tempChar": ""
				},
				{
					"id": 271,
					"order": 2486,
					"prevSize": 32,
					"code": 59654,
					"name": "adjust2",
					"tempChar": ""
				},
				{
					"id": 272,
					"order": 2487,
					"prevSize": 32,
					"code": 59655,
					"name": "adjust3",
					"tempChar": ""
				},
				{
					"id": 947,
					"order": 2248,
					"prevSize": 32,
					"code": 60330,
					"name": "adjust4",
					"tempChar": ""
				},
				{
					"name": "adn",
					"id": 1510,
					"order": 1943,
					"prevSize": 32,
					"code": 61808,
					"tempChar": ""
				},
				{
					"id": 273,
					"order": 2488,
					"prevSize": 32,
					"code": 59656,
					"name": "affect",
					"tempChar": ""
				},
				{
					"id": 274,
					"order": 2489,
					"prevSize": 32,
					"code": 59657,
					"name": "affect2",
					"tempChar": ""
				},
				{
					"id": 948,
					"order": 2249,
					"prevSize": 32,
					"code": 60331,
					"name": "affect3",
					"tempChar": ""
				},
				{
					"id": 275,
					"order": 2490,
					"prevSize": 32,
					"code": 59658,
					"name": "agitate",
					"tempChar": ""
				},
				{
					"id": 276,
					"order": 2491,
					"prevSize": 32,
					"code": 59659,
					"name": "agitate2",
					"tempChar": ""
				},
				{
					"id": 277,
					"order": 2492,
					"prevSize": 32,
					"code": 59660,
					"name": "agree",
					"tempChar": ""
				},
				{
					"id": 278,
					"order": 2493,
					"prevSize": 32,
					"code": 59661,
					"name": "agree2",
					"tempChar": ""
				},
				{
					"id": 949,
					"order": 2250,
					"prevSize": 32,
					"code": 60332,
					"name": "agree3",
					"tempChar": ""
				},
				{
					"id": 279,
					"order": 2494,
					"prevSize": 32,
					"code": 59662,
					"name": "aid",
					"tempChar": ""
				},
				{
					"order": 627,
					"prevSize": 32,
					"ligatures": "aid-kit, health3",
					"name": "aid-kit",
					"id": 2438,
					"code": 61187,
					"tempChar": ""
				},
				{
					"order": 628,
					"prevSize": 32,
					"ligatures": "aid-kit2, health4",
					"name": "aid-kit2",
					"id": 2439,
					"code": 61188,
					"tempChar": ""
				},
				{
					"id": 280,
					"order": 2495,
					"prevSize": 32,
					"code": 59663,
					"name": "aid2",
					"tempChar": ""
				},
				{
					"id": 950,
					"order": 2251,
					"prevSize": 32,
					"code": 60333,
					"name": "aid3",
					"tempChar": ""
				},
				{
					"order": 775,
					"prevSize": 32,
					"ligatures": "airplane, travel",
					"name": "airplane",
					"id": 2586,
					"code": 61335,
					"tempChar": ""
				},
				{
					"order": 776,
					"prevSize": 32,
					"ligatures": "airplane2, travel2",
					"name": "airplane2",
					"id": 2587,
					"code": 61336,
					"tempChar": ""
				},
				{
					"order": 777,
					"prevSize": 32,
					"ligatures": "airplane3, travel3",
					"name": "airplane3",
					"id": 2588,
					"code": 61337,
					"tempChar": ""
				},
				{
					"order": 778,
					"prevSize": 32,
					"ligatures": "airplane4, arrival",
					"name": "airplane4",
					"id": 2589,
					"code": 61338,
					"tempChar": ""
				},
				{
					"order": 341,
					"prevSize": 32,
					"ligatures": "alarm, time8",
					"name": "alarm",
					"id": 2152,
					"code": 60901,
					"tempChar": ""
				},
				{
					"order": 342,
					"prevSize": 32,
					"ligatures": "alarm-add, alarm2",
					"name": "alarm-add",
					"id": 2153,
					"code": 60902,
					"tempChar": ""
				},
				{
					"order": 344,
					"prevSize": 32,
					"ligatures": "alarm-cancel, alarm4",
					"name": "alarm-cancel",
					"id": 2155,
					"code": 60904,
					"tempChar": ""
				},
				{
					"order": 343,
					"prevSize": 32,
					"ligatures": "alarm-check, alarm3",
					"name": "alarm-check",
					"id": 2154,
					"code": 60903,
					"tempChar": ""
				},
				{
					"order": 631,
					"prevSize": 32,
					"ligatures": "alarm12, siren",
					"name": "alarm2",
					"id": 2442,
					"code": 61191,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "alarm, bell",
					"order": 3248,
					"name": "alarm3",
					"id": 183,
					"code": 59480,
					"tempChar": ""
				},
				{
					"id": 281,
					"order": 2496,
					"prevSize": 32,
					"code": 59664,
					"name": "alarm4",
					"tempChar": ""
				},
				{
					"id": 282,
					"order": 2497,
					"prevSize": 32,
					"code": 59665,
					"name": "alarm5",
					"tempChar": ""
				},
				{
					"id": 951,
					"order": 2252,
					"prevSize": 32,
					"code": 60334,
					"name": "alarm6",
					"tempChar": ""
				},
				{
					"order": 82,
					"prevSize": 32,
					"ligatures": "album, songs",
					"name": "album",
					"id": 1893,
					"code": 60642,
					"tempChar": ""
				},
				{
					"id": 283,
					"order": 2498,
					"prevSize": 32,
					"code": 59666,
					"name": "alert",
					"tempChar": ""
				},
				{
					"id": 284,
					"order": 2499,
					"prevSize": 32,
					"code": 59667,
					"name": "alert2",
					"tempChar": ""
				},
				{
					"id": 952,
					"order": 2253,
					"prevSize": 32,
					"code": 60335,
					"name": "alert3",
					"tempChar": ""
				},
				{
					"order": 448,
					"prevSize": 32,
					"ligatures": "align-bottom, align6",
					"name": "align-bottom",
					"id": 2259,
					"code": 61008,
					"tempChar": ""
				},
				{
					"name": "align-center",
					"id": 1231,
					"order": 1664,
					"prevSize": 32,
					"code": 61495,
					"tempChar": ""
				},
				{
					"order": 444,
					"prevSize": 32,
					"ligatures": "align-center-horizontal, align2",
					"name": "align-center-horizontal",
					"id": 2255,
					"code": 61004,
					"tempChar": ""
				},
				{
					"order": 447,
					"prevSize": 32,
					"ligatures": "align-center-vertical, align5",
					"name": "align-center-vertical",
					"id": 2258,
					"code": 61007,
					"tempChar": ""
				},
				{
					"name": "align-justify",
					"id": 1233,
					"order": 1666,
					"prevSize": 32,
					"code": 61497,
					"tempChar": ""
				},
				{
					"order": 443,
					"prevSize": 32,
					"ligatures": "align-left, align",
					"name": "align-left",
					"id": 2254,
					"code": 61003,
					"tempChar": ""
				},
				{
					"name": "align-left2",
					"id": 1230,
					"order": 1663,
					"prevSize": 32,
					"code": 61494,
					"tempChar": ""
				},
				{
					"order": 445,
					"prevSize": 32,
					"ligatures": "align-right, align3",
					"name": "align-right",
					"id": 2256,
					"code": 61005,
					"tempChar": ""
				},
				{
					"name": "align-right2",
					"id": 1232,
					"order": 1665,
					"prevSize": 32,
					"code": 61496,
					"tempChar": ""
				},
				{
					"order": 446,
					"prevSize": 32,
					"ligatures": "align-top, align4",
					"name": "align-top",
					"id": 2257,
					"code": 61006,
					"tempChar": ""
				},
				{
					"id": 285,
					"order": 2500,
					"prevSize": 32,
					"code": 59668,
					"name": "amaze",
					"tempChar": ""
				},
				{
					"id": 286,
					"order": 2501,
					"prevSize": 32,
					"code": 59669,
					"name": "amaze2",
					"tempChar": ""
				},
				{
					"id": 953,
					"order": 2254,
					"prevSize": 32,
					"code": 60336,
					"name": "amaze3",
					"tempChar": ""
				},
				{
					"order": 1512,
					"prevSize": 32,
					"name": "amazon",
					"ligatures": "amazon, brand",
					"id": 3323,
					"code": 62706,
					"tempChar": ""
				},
				{
					"name": "amazon2",
					"id": 1748,
					"order": 2181,
					"prevSize": 32,
					"code": 62064,
					"tempChar": ""
				},
				{
					"order": 630,
					"prevSize": 32,
					"ligatures": "ambulance, health6",
					"name": "ambulance",
					"id": 2441,
					"code": 61190,
					"tempChar": ""
				},
				{
					"name": "ambulance2",
					"id": 1401,
					"order": 1834,
					"prevSize": 32,
					"code": 61689,
					"tempChar": ""
				},
				{
					"name": "american-sign-language-interpreting, asl-interpreting",
					"id": 1796,
					"order": 2229,
					"prevSize": 32,
					"code": 62115,
					"tempChar": ""
				},
				{
					"order": 816,
					"prevSize": 32,
					"ligatures": "ammo, bullets",
					"name": "ammo",
					"id": 2627,
					"code": 61376,
					"tempChar": ""
				},
				{
					"order": 1424,
					"prevSize": 32,
					"ligatures": "ampersand, typograhy",
					"name": "ampersand",
					"id": 3235,
					"code": 62618,
					"tempChar": ""
				},
				{
					"id": 287,
					"order": 2502,
					"prevSize": 32,
					"code": 59670,
					"name": "amplify",
					"tempChar": ""
				},
				{
					"id": 288,
					"order": 2503,
					"prevSize": 32,
					"code": 59671,
					"name": "amplify2",
					"tempChar": ""
				},
				{
					"id": 954,
					"order": 2255,
					"prevSize": 32,
					"code": 60337,
					"name": "amplify3",
					"tempChar": ""
				},
				{
					"id": 289,
					"order": 2504,
					"prevSize": 32,
					"code": 59672,
					"name": "analyze",
					"tempChar": ""
				},
				{
					"id": 290,
					"order": 2505,
					"prevSize": 32,
					"code": 59673,
					"name": "analyze2",
					"tempChar": ""
				},
				{
					"order": 933,
					"prevSize": 32,
					"ligatures": "anchor, link11",
					"name": "anchor",
					"id": 2744,
					"code": 62047,
					"tempChar": ""
				},
				{
					"name": "anchor2",
					"id": 1463,
					"order": 1896,
					"prevSize": 32,
					"code": 61757,
					"tempChar": ""
				},
				{
					"order": 1569,
					"prevSize": 32,
					"ligatures": "android, brand55",
					"name": "android",
					"id": 3380,
					"code": 62763,
					"tempChar": ""
				},
				{
					"name": "android2",
					"id": 1521,
					"order": 1954,
					"prevSize": 32,
					"code": 61819,
					"tempChar": ""
				},
				{
					"name": "angellist",
					"id": 1654,
					"order": 2087,
					"prevSize": 32,
					"code": 61961,
					"tempChar": ""
				},
				{
					"order": 437,
					"prevSize": 32,
					"ligatures": "angle",
					"name": "angle",
					"id": 2248,
					"code": 60997,
					"tempChar": ""
				},
				{
					"name": "angle-double-down",
					"id": 1410,
					"order": 1843,
					"prevSize": 32,
					"code": 61699,
					"tempChar": ""
				},
				{
					"name": "angle-double-left",
					"id": 1407,
					"order": 1840,
					"prevSize": 32,
					"code": 61696,
					"tempChar": ""
				},
				{
					"name": "angle-double-right",
					"id": 1408,
					"order": 1841,
					"prevSize": 32,
					"code": 61697,
					"tempChar": ""
				},
				{
					"name": "angle-double-up",
					"id": 1409,
					"order": 1842,
					"prevSize": 32,
					"code": 61698,
					"tempChar": ""
				},
				{
					"name": "angle-down",
					"id": 1414,
					"order": 1847,
					"prevSize": 32,
					"code": 61703,
					"tempChar": ""
				},
				{
					"name": "angle-left",
					"id": 1411,
					"order": 1844,
					"prevSize": 32,
					"code": 61700,
					"tempChar": ""
				},
				{
					"name": "angle-right",
					"id": 1412,
					"order": 1845,
					"prevSize": 32,
					"code": 61701,
					"tempChar": ""
				},
				{
					"name": "angle-up",
					"id": 1413,
					"order": 1846,
					"prevSize": 32,
					"code": 61702,
					"tempChar": ""
				},
				{
					"order": 1042,
					"prevSize": 32,
					"ligatures": "angry, emoticon15",
					"name": "angry",
					"id": 2853,
					"code": 62236,
					"tempChar": ""
				},
				{
					"order": 1043,
					"prevSize": 32,
					"ligatures": "angry2, emoticon16",
					"name": "angry2",
					"id": 2854,
					"code": 62237,
					"tempChar": ""
				},
				{
					"id": 955,
					"order": 2256,
					"prevSize": 32,
					"code": 60338,
					"name": "animate",
					"tempChar": ""
				},
				{
					"id": 291,
					"order": 2506,
					"prevSize": 32,
					"code": 59674,
					"name": "announce",
					"tempChar": ""
				},
				{
					"id": 292,
					"order": 2507,
					"prevSize": 32,
					"code": 59675,
					"name": "announce2",
					"tempChar": ""
				},
				{
					"id": 956,
					"order": 2257,
					"prevSize": 32,
					"code": 60339,
					"name": "announce3",
					"tempChar": ""
				},
				{
					"order": 133,
					"prevSize": 32,
					"ligatures": "antenna, wifi5",
					"name": "antenna",
					"id": 1944,
					"code": 60693,
					"tempChar": ""
				},
				{
					"order": 138,
					"prevSize": 32,
					"ligatures": "antenna2, wifi6",
					"name": "antenna2",
					"id": 1949,
					"code": 60698,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "apartment, building2",
					"order": 3161,
					"name": "apartment",
					"id": 96,
					"code": 59393,
					"tempChar": ""
				},
				{
					"order": 721,
					"prevSize": 32,
					"ligatures": "apple, fruit",
					"name": "apple",
					"id": 2532,
					"code": 61281,
					"tempChar": ""
				},
				{
					"name": "apple2",
					"id": 1519,
					"order": 1952,
					"prevSize": 32,
					"code": 61817,
					"tempChar": ""
				},
				{
					"order": 1567,
					"prevSize": 32,
					"ligatures": "apple2, brand53",
					"name": "appleinc",
					"id": 3378,
					"code": 62761,
					"tempChar": ""
				},
				{
					"order": 827,
					"prevSize": 32,
					"ligatures": "archery, soprts2",
					"name": "archery",
					"id": 2638,
					"code": 61387,
					"tempChar": ""
				},
				{
					"order": 152,
					"prevSize": 32,
					"ligatures": "archive, office2",
					"name": "archive",
					"id": 1963,
					"code": 60712,
					"tempChar": ""
				},
				{
					"name": "archive2",
					"id": 1532,
					"order": 1965,
					"prevSize": 32,
					"code": 61831,
					"tempChar": ""
				},
				{
					"name": "area-chart",
					"id": 1644,
					"order": 2077,
					"prevSize": 32,
					"code": 61950,
					"tempChar": ""
				},
				{
					"id": 293,
					"order": 2508,
					"prevSize": 32,
					"code": 59676,
					"name": "arrest",
					"tempChar": ""
				},
				{
					"id": 294,
					"order": 2509,
					"prevSize": 32,
					"code": 59677,
					"name": "arrest2",
					"tempChar": ""
				},
				{
					"name": "arrow-circle-down",
					"id": 1340,
					"order": 1773,
					"prevSize": 32,
					"code": 61611,
					"tempChar": ""
				},
				{
					"name": "arrow-circle-left",
					"id": 1337,
					"order": 1770,
					"prevSize": 32,
					"code": 61608,
					"tempChar": ""
				},
				{
					"name": "arrow-circle-o-down",
					"id": 1204,
					"order": 1637,
					"prevSize": 32,
					"code": 61466,
					"tempChar": ""
				},
				{
					"name": "arrow-circle-o-left",
					"id": 1540,
					"order": 1973,
					"prevSize": 32,
					"code": 61840,
					"tempChar": ""
				},
				{
					"name": "arrow-circle-o-right",
					"id": 1539,
					"order": 1972,
					"prevSize": 32,
					"code": 61838,
					"tempChar": ""
				},
				{
					"name": "arrow-circle-o-up",
					"id": 1205,
					"order": 1638,
					"prevSize": 32,
					"code": 61467,
					"tempChar": ""
				},
				{
					"name": "arrow-circle-right",
					"id": 1338,
					"order": 1771,
					"prevSize": 32,
					"code": 61609,
					"tempChar": ""
				},
				{
					"name": "arrow-circle-up",
					"id": 1339,
					"order": 1772,
					"prevSize": 32,
					"code": 61610,
					"tempChar": ""
				},
				{
					"order": 1217,
					"prevSize": 32,
					"ligatures": "arrow-down, down",
					"name": "arrow-down",
					"id": 3028,
					"code": 62411,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "arrow-down-circle, down5",
					"order": 3292,
					"name": "arrow-down-circle",
					"id": 227,
					"code": 59524,
					"tempChar": ""
				},
				{
					"order": 1235,
					"prevSize": 32,
					"ligatures": "arrow-down-left, down-left",
					"name": "arrow-down-left",
					"id": 3046,
					"code": 62429,
					"tempChar": ""
				},
				{
					"order": 1243,
					"prevSize": 32,
					"ligatures": "arrow-down-left2, down-left2",
					"name": "arrow-down-left2",
					"id": 3054,
					"code": 62437,
					"tempChar": ""
				},
				{
					"order": 1251,
					"prevSize": 32,
					"ligatures": "arrow-down-left3, down-left3",
					"name": "arrow-down-left3",
					"id": 3062,
					"code": 62445,
					"tempChar": ""
				},
				{
					"order": 1307,
					"prevSize": 32,
					"ligatures": "arrow-down-left4, down-left7",
					"name": "arrow-down-left4",
					"id": 3118,
					"code": 62501,
					"tempChar": ""
				},
				{
					"order": 1315,
					"prevSize": 32,
					"ligatures": "arrow-down-left5, down-left8",
					"name": "arrow-down-left5",
					"id": 3126,
					"code": 62509,
					"tempChar": ""
				},
				{
					"order": 1233,
					"prevSize": 32,
					"ligatures": "arrow-down-right, down-right",
					"name": "arrow-down-right",
					"id": 3044,
					"code": 62427,
					"tempChar": ""
				},
				{
					"order": 1241,
					"prevSize": 32,
					"ligatures": "arrow-down-right2, down-right2",
					"name": "arrow-down-right2",
					"id": 3052,
					"code": 62435,
					"tempChar": ""
				},
				{
					"order": 1249,
					"prevSize": 32,
					"ligatures": "arrow-down-right3, down-right3",
					"name": "arrow-down-right3",
					"id": 3060,
					"code": 62443,
					"tempChar": ""
				},
				{
					"order": 1305,
					"prevSize": 32,
					"ligatures": "arrow-down-right4, down-right7",
					"name": "arrow-down-right4",
					"id": 3116,
					"code": 62499,
					"tempChar": ""
				},
				{
					"order": 1313,
					"prevSize": 32,
					"ligatures": "arrow-down-right5, down-right8",
					"name": "arrow-down-right5",
					"id": 3124,
					"code": 62507,
					"tempChar": ""
				},
				{
					"order": 1299,
					"prevSize": 32,
					"ligatures": "arrow-down10, down15",
					"name": "arrow-down10",
					"id": 3110,
					"code": 62493,
					"tempChar": ""
				},
				{
					"order": 1306,
					"prevSize": 32,
					"ligatures": "arrow-down11, down16",
					"name": "arrow-down11",
					"id": 3117,
					"code": 62500,
					"tempChar": ""
				},
				{
					"order": 1314,
					"prevSize": 32,
					"ligatures": "arrow-down12, down17",
					"name": "arrow-down12",
					"id": 3125,
					"code": 62508,
					"tempChar": ""
				},
				{
					"order": 1319,
					"prevSize": 32,
					"ligatures": "arrow-down13, down18",
					"name": "arrow-down13",
					"id": 3130,
					"code": 62513,
					"tempChar": ""
				},
				{
					"order": 1323,
					"prevSize": 32,
					"ligatures": "arrow-down14, down19",
					"name": "arrow-down14",
					"id": 3134,
					"code": 62517,
					"tempChar": ""
				},
				{
					"order": 1335,
					"prevSize": 32,
					"ligatures": "arrow-down15, down22",
					"name": "arrow-down15",
					"id": 3146,
					"code": 62529,
					"tempChar": ""
				},
				{
					"order": 1339,
					"prevSize": 32,
					"ligatures": "arrow-down16, down23",
					"name": "arrow-down16",
					"id": 3150,
					"code": 62533,
					"tempChar": ""
				},
				{
					"name": "arrow-down17",
					"id": 1272,
					"order": 1705,
					"prevSize": 32,
					"code": 61539,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "arrow-down, down4",
					"order": 3280,
					"name": "arrow-down18",
					"id": 215,
					"code": 59512,
					"tempChar": ""
				},
				{
					"order": 1218,
					"prevSize": 32,
					"ligatures": "arrow-down2, down2",
					"name": "arrow-down2",
					"id": 3029,
					"code": 62412,
					"tempChar": ""
				},
				{
					"order": 1219,
					"prevSize": 32,
					"ligatures": "arrow-down3, down3",
					"name": "arrow-down3",
					"id": 3030,
					"code": 62413,
					"tempChar": ""
				},
				{
					"order": 1220,
					"prevSize": 32,
					"ligatures": "arrow-down4, down4",
					"name": "arrow-down4",
					"id": 3031,
					"code": 62414,
					"tempChar": ""
				},
				{
					"order": 1227,
					"prevSize": 32,
					"ligatures": "arrow-down5, down5",
					"name": "arrow-down5",
					"id": 3038,
					"code": 62421,
					"tempChar": ""
				},
				{
					"order": 1234,
					"prevSize": 32,
					"ligatures": "arrow-down6, down6",
					"name": "arrow-down6",
					"id": 3045,
					"code": 62428,
					"tempChar": ""
				},
				{
					"order": 1242,
					"prevSize": 32,
					"ligatures": "arrow-down7, down7",
					"name": "arrow-down7",
					"id": 3053,
					"code": 62436,
					"tempChar": ""
				},
				{
					"order": 1250,
					"prevSize": 32,
					"ligatures": "arrow-down8, down8",
					"name": "arrow-down8",
					"id": 3061,
					"code": 62444,
					"tempChar": ""
				},
				{
					"order": 1295,
					"prevSize": 32,
					"ligatures": "arrow-down9, down14",
					"name": "arrow-down9",
					"id": 3106,
					"code": 62489,
					"tempChar": ""
				},
				{
					"order": 1221,
					"prevSize": 32,
					"ligatures": "arrow-left, left4",
					"name": "arrow-left",
					"id": 3032,
					"code": 62415,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "arrow-left-circle, left3",
					"order": 3293,
					"name": "arrow-left-circle",
					"id": 228,
					"code": 59525,
					"tempChar": ""
				},
				{
					"order": 1300,
					"prevSize": 32,
					"ligatures": "arrow-left10, left18",
					"name": "arrow-left10",
					"id": 3111,
					"code": 62494,
					"tempChar": ""
				},
				{
					"order": 1308,
					"prevSize": 32,
					"ligatures": "arrow-left11, left19",
					"name": "arrow-left11",
					"id": 3119,
					"code": 62502,
					"tempChar": ""
				},
				{
					"order": 1316,
					"prevSize": 32,
					"ligatures": "arrow-left12, left20",
					"name": "arrow-left12",
					"id": 3127,
					"code": 62510,
					"tempChar": ""
				},
				{
					"order": 1320,
					"prevSize": 32,
					"ligatures": "arrow-left13, left21",
					"name": "arrow-left13",
					"id": 3131,
					"code": 62514,
					"tempChar": ""
				},
				{
					"order": 1324,
					"prevSize": 32,
					"ligatures": "arrow-left14, left22",
					"name": "arrow-left14",
					"id": 3135,
					"code": 62518,
					"tempChar": ""
				},
				{
					"order": 1336,
					"prevSize": 32,
					"ligatures": "arrow-left15, left25",
					"name": "arrow-left15",
					"id": 3147,
					"code": 62530,
					"tempChar": ""
				},
				{
					"order": 1340,
					"prevSize": 32,
					"ligatures": "arrow-left16, left26",
					"name": "arrow-left16",
					"id": 3151,
					"code": 62534,
					"tempChar": ""
				},
				{
					"name": "arrow-left17",
					"id": 1269,
					"order": 1702,
					"prevSize": 32,
					"code": 61536,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "arrow-left, left2",
					"order": 3281,
					"name": "arrow-left18",
					"id": 216,
					"code": 59513,
					"tempChar": ""
				},
				{
					"order": 1222,
					"prevSize": 32,
					"ligatures": "arrow-left2, left5",
					"name": "arrow-left2",
					"id": 3033,
					"code": 62416,
					"tempChar": ""
				},
				{
					"order": 1223,
					"prevSize": 32,
					"ligatures": "arrow-left3, left6",
					"name": "arrow-left3",
					"id": 3034,
					"code": 62417,
					"tempChar": ""
				},
				{
					"order": 1224,
					"prevSize": 32,
					"ligatures": "arrow-left4, left7",
					"name": "arrow-left4",
					"id": 3035,
					"code": 62418,
					"tempChar": ""
				},
				{
					"order": 1228,
					"prevSize": 32,
					"ligatures": "arrow-left5, left8",
					"name": "arrow-left5",
					"id": 3039,
					"code": 62422,
					"tempChar": ""
				},
				{
					"order": 1236,
					"prevSize": 32,
					"ligatures": "arrow-left6, left9",
					"name": "arrow-left6",
					"id": 3047,
					"code": 62430,
					"tempChar": ""
				},
				{
					"order": 1244,
					"prevSize": 32,
					"ligatures": "arrow-left7, left10",
					"name": "arrow-left7",
					"id": 3055,
					"code": 62438,
					"tempChar": ""
				},
				{
					"order": 1252,
					"prevSize": 32,
					"ligatures": "arrow-left8, left11",
					"name": "arrow-left8",
					"id": 3063,
					"code": 62446,
					"tempChar": ""
				},
				{
					"order": 1296,
					"prevSize": 32,
					"ligatures": "arrow-left9, left17",
					"name": "arrow-left9",
					"id": 3107,
					"code": 62490,
					"tempChar": ""
				},
				{
					"order": 1277,
					"prevSize": 32,
					"ligatures": "arrow-resize, diagonal",
					"name": "arrow-resize",
					"id": 3088,
					"code": 62471,
					"tempChar": ""
				},
				{
					"order": 1278,
					"prevSize": 32,
					"ligatures": "arrow-resize2, diagonal2",
					"name": "arrow-resize2",
					"id": 3089,
					"code": 62472,
					"tempChar": ""
				},
				{
					"order": 1279,
					"prevSize": 32,
					"ligatures": "arrow-resize3, horizontal",
					"name": "arrow-resize3",
					"id": 3090,
					"code": 62473,
					"tempChar": ""
				},
				{
					"order": 1280,
					"prevSize": 32,
					"ligatures": "arrow-resize4, vertical",
					"name": "arrow-resize4",
					"id": 3091,
					"code": 62474,
					"tempChar": ""
				},
				{
					"order": 1281,
					"prevSize": 32,
					"ligatures": "arrow-resize5, diagonal3",
					"name": "arrow-resize5",
					"id": 3092,
					"code": 62475,
					"tempChar": ""
				},
				{
					"order": 1282,
					"prevSize": 32,
					"ligatures": "arrow-resize6, diagonal4",
					"name": "arrow-resize6",
					"id": 3093,
					"code": 62476,
					"tempChar": ""
				},
				{
					"order": 1283,
					"prevSize": 32,
					"ligatures": "arrow-resize7, horizontal2",
					"name": "arrow-resize7",
					"id": 3094,
					"code": 62477,
					"tempChar": ""
				},
				{
					"order": 1284,
					"prevSize": 32,
					"ligatures": "arrow-resize8, vertical2",
					"name": "arrow-resize8",
					"id": 3095,
					"code": 62478,
					"tempChar": ""
				},
				{
					"order": 1213,
					"prevSize": 32,
					"ligatures": "arrow-right, right3",
					"name": "arrow-right",
					"id": 3024,
					"code": 62407,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "arrow-right-circle, right3",
					"order": 3294,
					"name": "arrow-right-circle",
					"id": 229,
					"code": 59526,
					"tempChar": ""
				},
				{
					"order": 1298,
					"prevSize": 32,
					"ligatures": "arrow-right10, right17",
					"name": "arrow-right10",
					"id": 3109,
					"code": 62492,
					"tempChar": ""
				},
				{
					"order": 1304,
					"prevSize": 32,
					"ligatures": "arrow-right11, right18",
					"name": "arrow-right11",
					"id": 3115,
					"code": 62498,
					"tempChar": ""
				},
				{
					"order": 1312,
					"prevSize": 32,
					"ligatures": "arrow-right12, right19",
					"name": "arrow-right12",
					"id": 3123,
					"code": 62506,
					"tempChar": ""
				},
				{
					"order": 1318,
					"prevSize": 32,
					"ligatures": "arrow-right13, right20",
					"name": "arrow-right13",
					"id": 3129,
					"code": 62512,
					"tempChar": ""
				},
				{
					"order": 1322,
					"prevSize": 32,
					"ligatures": "arrow-right14, right21",
					"name": "arrow-right14",
					"id": 3133,
					"code": 62516,
					"tempChar": ""
				},
				{
					"order": 1334,
					"prevSize": 32,
					"ligatures": "arrow-right15, right24",
					"name": "arrow-right15",
					"id": 3145,
					"code": 62528,
					"tempChar": ""
				},
				{
					"order": 1338,
					"prevSize": 32,
					"ligatures": "arrow-right16, right25",
					"name": "arrow-right16",
					"id": 3149,
					"code": 62532,
					"tempChar": ""
				},
				{
					"name": "arrow-right17",
					"id": 1270,
					"order": 1703,
					"prevSize": 32,
					"code": 61537,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "arrow-right, right2",
					"order": 3282,
					"name": "arrow-right18",
					"id": 217,
					"code": 59514,
					"tempChar": ""
				},
				{
					"order": 1214,
					"prevSize": 32,
					"ligatures": "arrow-right2, right4",
					"name": "arrow-right2",
					"id": 3025,
					"code": 62408,
					"tempChar": ""
				},
				{
					"order": 1215,
					"prevSize": 32,
					"ligatures": "arrow-right3, right5",
					"name": "arrow-right3",
					"id": 3026,
					"code": 62409,
					"tempChar": ""
				},
				{
					"order": 1216,
					"prevSize": 32,
					"ligatures": "arrow-right4, right6",
					"name": "arrow-right4",
					"id": 3027,
					"code": 62410,
					"tempChar": ""
				},
				{
					"order": 1226,
					"prevSize": 32,
					"ligatures": "arrow-right5, right7",
					"name": "arrow-right5",
					"id": 3037,
					"code": 62420,
					"tempChar": ""
				},
				{
					"order": 1232,
					"prevSize": 32,
					"ligatures": "arrow-right6, right8",
					"name": "arrow-right6",
					"id": 3043,
					"code": 62426,
					"tempChar": ""
				},
				{
					"order": 1240,
					"prevSize": 32,
					"ligatures": "arrow-right7, right9",
					"name": "arrow-right7",
					"id": 3051,
					"code": 62434,
					"tempChar": ""
				},
				{
					"order": 1248,
					"prevSize": 32,
					"ligatures": "arrow-right8, right10",
					"name": "arrow-right8",
					"id": 3059,
					"code": 62442,
					"tempChar": ""
				},
				{
					"order": 1294,
					"prevSize": 32,
					"ligatures": "arrow-right9, right16",
					"name": "arrow-right9",
					"id": 3105,
					"code": 62488,
					"tempChar": ""
				},
				{
					"order": 1209,
					"prevSize": 32,
					"ligatures": "arrow-up, up",
					"name": "arrow-up",
					"id": 3020,
					"code": 62403,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "arrow-up-circle, up5",
					"order": 3291,
					"name": "arrow-up-circle",
					"id": 226,
					"code": 59523,
					"tempChar": ""
				},
				{
					"order": 1229,
					"prevSize": 32,
					"ligatures": "arrow-up-left, up-left",
					"name": "arrow-up-left",
					"id": 3040,
					"code": 62423,
					"tempChar": ""
				},
				{
					"order": 1237,
					"prevSize": 32,
					"ligatures": "arrow-up-left2, up-left2",
					"name": "arrow-up-left2",
					"id": 3048,
					"code": 62431,
					"tempChar": ""
				},
				{
					"order": 1245,
					"prevSize": 32,
					"ligatures": "arrow-up-left3, up-left3",
					"name": "arrow-up-left3",
					"id": 3056,
					"code": 62439,
					"tempChar": ""
				},
				{
					"order": 1301,
					"prevSize": 32,
					"ligatures": "arrow-up-left4, up-left7",
					"name": "arrow-up-left4",
					"id": 3112,
					"code": 62495,
					"tempChar": ""
				},
				{
					"order": 1309,
					"prevSize": 32,
					"ligatures": "arrow-up-left5, up-left8",
					"name": "arrow-up-left5",
					"id": 3120,
					"code": 62503,
					"tempChar": ""
				},
				{
					"order": 1231,
					"prevSize": 32,
					"ligatures": "arrow-up-right, up-right",
					"name": "arrow-up-right",
					"id": 3042,
					"code": 62425,
					"tempChar": ""
				},
				{
					"order": 1239,
					"prevSize": 32,
					"ligatures": "arrow-up-right2, up-right2",
					"name": "arrow-up-right2",
					"id": 3050,
					"code": 62433,
					"tempChar": ""
				},
				{
					"order": 1247,
					"prevSize": 32,
					"ligatures": "arrow-up-right3, up-right3",
					"name": "arrow-up-right3",
					"id": 3058,
					"code": 62441,
					"tempChar": ""
				},
				{
					"order": 1303,
					"prevSize": 32,
					"ligatures": "arrow-up-right4, up-right7",
					"name": "arrow-up-right4",
					"id": 3114,
					"code": 62497,
					"tempChar": ""
				},
				{
					"order": 1311,
					"prevSize": 32,
					"ligatures": "arrow-up-right5, up-right8",
					"name": "arrow-up-right5",
					"id": 3122,
					"code": 62505,
					"tempChar": ""
				},
				{
					"order": 1297,
					"prevSize": 32,
					"ligatures": "arrow-up10, up15",
					"name": "arrow-up10",
					"id": 3108,
					"code": 62491,
					"tempChar": ""
				},
				{
					"order": 1302,
					"prevSize": 32,
					"ligatures": "arrow-up11, up16",
					"name": "arrow-up11",
					"id": 3113,
					"code": 62496,
					"tempChar": ""
				},
				{
					"order": 1310,
					"prevSize": 32,
					"ligatures": "arrow-up12, up17",
					"name": "arrow-up12",
					"id": 3121,
					"code": 62504,
					"tempChar": ""
				},
				{
					"order": 1317,
					"prevSize": 32,
					"ligatures": "arrow-up13, up18",
					"name": "arrow-up13",
					"id": 3128,
					"code": 62511,
					"tempChar": ""
				},
				{
					"order": 1321,
					"prevSize": 32,
					"ligatures": "arrow-up14, up19",
					"name": "arrow-up14",
					"id": 3132,
					"code": 62515,
					"tempChar": ""
				},
				{
					"order": 1333,
					"prevSize": 32,
					"ligatures": "arrow-up15, up22",
					"name": "arrow-up15",
					"id": 3144,
					"code": 62527,
					"tempChar": ""
				},
				{
					"order": 1337,
					"prevSize": 32,
					"ligatures": "arrow-up16, up23",
					"name": "arrow-up16",
					"id": 3148,
					"code": 62531,
					"tempChar": ""
				},
				{
					"name": "arrow-up17",
					"id": 1271,
					"order": 1704,
					"prevSize": 32,
					"code": 61538,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "arrow-up, up4",
					"order": 3279,
					"name": "arrow-up18",
					"id": 214,
					"code": 59511,
					"tempChar": ""
				},
				{
					"order": 1210,
					"prevSize": 32,
					"ligatures": "arrow-up2, up2",
					"name": "arrow-up2",
					"id": 3021,
					"code": 62404,
					"tempChar": ""
				},
				{
					"order": 1211,
					"prevSize": 32,
					"ligatures": "arrow-up3, up3",
					"name": "arrow-up3",
					"id": 3022,
					"code": 62405,
					"tempChar": ""
				},
				{
					"order": 1212,
					"prevSize": 32,
					"ligatures": "arrow-up4, up4",
					"name": "arrow-up4",
					"id": 3023,
					"code": 62406,
					"tempChar": ""
				},
				{
					"order": 1225,
					"prevSize": 32,
					"ligatures": "arrow-up5, up5",
					"name": "arrow-up5",
					"id": 3036,
					"code": 62419,
					"tempChar": ""
				},
				{
					"order": 1230,
					"prevSize": 32,
					"ligatures": "arrow-up6, up6",
					"name": "arrow-up6",
					"id": 3041,
					"code": 62424,
					"tempChar": ""
				},
				{
					"order": 1238,
					"prevSize": 32,
					"ligatures": "arrow-up7, up7",
					"name": "arrow-up7",
					"id": 3049,
					"code": 62432,
					"tempChar": ""
				},
				{
					"order": 1246,
					"prevSize": 32,
					"ligatures": "arrow-up8, up8",
					"name": "arrow-up8",
					"id": 3057,
					"code": 62440,
					"tempChar": ""
				},
				{
					"order": 1293,
					"prevSize": 32,
					"ligatures": "arrow-up9, up14",
					"name": "arrow-up9",
					"id": 3104,
					"code": 62487,
					"tempChar": ""
				},
				{
					"name": "arrows",
					"id": 1246,
					"order": 1679,
					"prevSize": 32,
					"code": 61511,
					"tempChar": ""
				},
				{
					"name": "arrows-alt",
					"id": 1346,
					"order": 1779,
					"prevSize": 32,
					"code": 61618,
					"tempChar": ""
				},
				{
					"name": "arrows-h",
					"id": 1298,
					"order": 1731,
					"prevSize": 32,
					"code": 61566,
					"tempChar": ""
				},
				{
					"name": "arrows-v",
					"id": 1297,
					"order": 1730,
					"prevSize": 32,
					"code": 61565,
					"tempChar": ""
				},
				{
					"id": 957,
					"order": 2258,
					"prevSize": 32,
					"code": 60340,
					"name": "ascend",
					"tempChar": ""
				},
				{
					"id": 295,
					"order": 2510,
					"prevSize": 32,
					"code": 59678,
					"name": "ask",
					"tempChar": ""
				},
				{
					"id": 296,
					"order": 2511,
					"prevSize": 32,
					"code": 59679,
					"name": "ask2",
					"tempChar": ""
				},
				{
					"id": 958,
					"order": 2259,
					"prevSize": 32,
					"code": 60341,
					"name": "ask3",
					"tempChar": ""
				},
				{
					"id": 297,
					"order": 2512,
					"prevSize": 32,
					"code": 59680,
					"name": "assist",
					"tempChar": ""
				},
				{
					"id": 298,
					"order": 2513,
					"prevSize": 32,
					"code": 59681,
					"name": "assist2",
					"tempChar": ""
				},
				{
					"name": "assistive-listening-systems",
					"id": 1795,
					"order": 2228,
					"prevSize": 32,
					"code": 62114,
					"tempChar": ""
				},
				{
					"name": "asterisk",
					"id": 1278,
					"order": 1711,
					"prevSize": 32,
					"code": 61545,
					"tempChar": ""
				},
				{
					"name": "at",
					"id": 1640,
					"order": 2073,
					"prevSize": 32,
					"code": 61946,
					"tempChar": ""
				},
				{
					"order": 305,
					"prevSize": 32,
					"ligatures": "at-sign, email",
					"name": "at-sign",
					"id": 2116,
					"code": 60865,
					"tempChar": ""
				},
				{
					"order": 749,
					"prevSize": 32,
					"ligatures": "atom, science",
					"name": "atom",
					"id": 2560,
					"code": 61309,
					"tempChar": ""
				},
				{
					"order": 750,
					"prevSize": 32,
					"ligatures": "atom2, science2",
					"name": "atom2",
					"id": 2561,
					"code": 61310,
					"tempChar": ""
				},
				{
					"order": 942,
					"prevSize": 32,
					"ligatures": "attachment, paperclip",
					"name": "attachment",
					"id": 2753,
					"code": 62136,
					"tempChar": ""
				},
				{
					"order": 943,
					"prevSize": 32,
					"ligatures": "attachment2, paperclip2",
					"name": "attachment2",
					"id": 2754,
					"code": 62137,
					"tempChar": ""
				},
				{
					"id": 299,
					"order": 2514,
					"prevSize": 32,
					"code": 59682,
					"name": "attract",
					"tempChar": ""
				},
				{
					"id": 300,
					"order": 2515,
					"prevSize": 32,
					"code": 59683,
					"name": "attract2",
					"tempChar": ""
				},
				{
					"id": 959,
					"order": 2260,
					"prevSize": 32,
					"code": 60342,
					"name": "attract3",
					"tempChar": ""
				},
				{
					"name": "audio-description",
					"id": 1792,
					"order": 2225,
					"prevSize": 32,
					"code": 62110,
					"tempChar": ""
				},
				{
					"name": "automobile, car3",
					"id": 1579,
					"order": 2012,
					"prevSize": 32,
					"code": 61881,
					"tempChar": ""
				},
				{
					"id": 301,
					"order": 2516,
					"prevSize": 32,
					"code": 59684,
					"name": "avoid",
					"tempChar": ""
				},
				{
					"id": 302,
					"order": 2517,
					"prevSize": 32,
					"code": 59685,
					"name": "avoid2",
					"tempChar": ""
				},
				{
					"order": 1349,
					"prevSize": 32,
					"ligatures": "backspace, delete",
					"name": "backspace",
					"id": 3160,
					"code": 62543,
					"tempChar": ""
				},
				{
					"order": 1350,
					"prevSize": 32,
					"ligatures": "backspace2, delete2",
					"name": "backspace2",
					"id": 3161,
					"code": 62544,
					"tempChar": ""
				},
				{
					"order": 1157,
					"prevSize": 32,
					"ligatures": "backward, player6",
					"name": "backward",
					"id": 2968,
					"code": 62351,
					"tempChar": ""
				},
				{
					"order": 1162,
					"prevSize": 32,
					"ligatures": "backward2, player11",
					"name": "backward2",
					"id": 2973,
					"code": 62356,
					"tempChar": ""
				},
				{
					"name": "backward3",
					"id": 1249,
					"order": 1682,
					"prevSize": 32,
					"code": 61514,
					"tempChar": ""
				},
				{
					"order": 1048,
					"prevSize": 32,
					"ligatures": "baffled, emoticon21",
					"name": "baffled",
					"id": 2859,
					"code": 62242,
					"tempChar": ""
				},
				{
					"order": 1049,
					"prevSize": 32,
					"ligatures": "baffled2, emoticon22",
					"name": "baffled2",
					"id": 2860,
					"code": 62243,
					"tempChar": ""
				},
				{
					"order": 265,
					"prevSize": 32,
					"ligatures": "bag, cart10",
					"name": "bag",
					"id": 2076,
					"code": 60825,
					"tempChar": ""
				},
				{
					"order": 266,
					"prevSize": 32,
					"ligatures": "bag2, cart11",
					"name": "bag2",
					"id": 2077,
					"code": 60826,
					"tempChar": ""
				},
				{
					"id": 303,
					"order": 2518,
					"prevSize": 32,
					"code": 59686,
					"name": "bake",
					"tempChar": ""
				},
				{
					"id": 304,
					"order": 2519,
					"prevSize": 32,
					"code": 59687,
					"name": "bake2",
					"tempChar": ""
				},
				{
					"id": 960,
					"order": 2261,
					"prevSize": 32,
					"code": 60343,
					"name": "bake3",
					"tempChar": ""
				},
				{
					"order": 743,
					"prevSize": 32,
					"ligatures": "balance, justice",
					"name": "balance",
					"id": 2554,
					"code": 61303,
					"tempChar": ""
				},
				{
					"name": "balance-scale",
					"id": 1717,
					"order": 2150,
					"prevSize": 32,
					"code": 62030,
					"tempChar": ""
				},
				{
					"id": 305,
					"order": 2520,
					"prevSize": 32,
					"code": 59688,
					"name": "balance2",
					"tempChar": ""
				},
				{
					"id": 306,
					"order": 2521,
					"prevSize": 32,
					"code": 59689,
					"name": "balance3",
					"tempChar": ""
				},
				{
					"order": 688,
					"prevSize": 32,
					"ligatures": "balloon, party",
					"name": "balloon",
					"id": 2499,
					"code": 61248,
					"tempChar": ""
				},
				{
					"name": "ban",
					"id": 1268,
					"order": 1701,
					"prevSize": 32,
					"code": 61534,
					"tempChar": ""
				},
				{
					"name": "bank, institution, university",
					"id": 1552,
					"order": 1985,
					"prevSize": 32,
					"code": 61852,
					"tempChar": ""
				},
				{
					"name": "bar-chart, bar-chart-o",
					"id": 1299,
					"order": 1732,
					"prevSize": 32,
					"code": 61568,
					"tempChar": ""
				},
				{
					"order": 248,
					"prevSize": 32,
					"ligatures": "barcode",
					"name": "barcode",
					"id": 2059,
					"code": 60808,
					"tempChar": ""
				},
				{
					"order": 249,
					"prevSize": 32,
					"ligatures": "barcode2",
					"name": "barcode2",
					"id": 2060,
					"code": 60809,
					"tempChar": ""
				},
				{
					"name": "barcode3",
					"id": 1218,
					"order": 1651,
					"prevSize": 32,
					"code": 61482,
					"tempChar": ""
				},
				{
					"name": "bars, navicon, reorder",
					"id": 1356,
					"order": 1789,
					"prevSize": 32,
					"code": 61641,
					"tempChar": ""
				},
				{
					"order": 832,
					"prevSize": 32,
					"ligatures": "baseball, soprts5",
					"name": "baseball",
					"id": 2643,
					"code": 61392,
					"tempChar": ""
				},
				{
					"order": 1555,
					"prevSize": 32,
					"name": "basecamp",
					"ligatures": "basecamp, brand42",
					"id": 3366,
					"code": 62749,
					"tempChar": ""
				},
				{
					"order": 264,
					"prevSize": 32,
					"ligatures": "basket, cart9",
					"name": "basket",
					"id": 2075,
					"code": 60824,
					"tempChar": ""
				},
				{
					"order": 833,
					"prevSize": 32,
					"ligatures": "basketball, soprts6",
					"name": "basketball",
					"id": 2644,
					"code": 61393,
					"tempChar": ""
				},
				{
					"order": 1372,
					"prevSize": 32,
					"ligatures": "battery-0, battery7",
					"name": "battery-0",
					"id": 3183,
					"code": 62566,
					"tempChar": ""
				},
				{
					"name": "battery-02, battery-empty",
					"id": 1707,
					"order": 2140,
					"prevSize": 32,
					"code": 62020,
					"tempChar": ""
				},
				{
					"order": 1371,
					"prevSize": 32,
					"ligatures": "battery-1, battery6",
					"name": "battery-1",
					"id": 3182,
					"code": 62565,
					"tempChar": ""
				},
				{
					"name": "battery-12, battery-quarter",
					"id": 1706,
					"order": 2139,
					"prevSize": 32,
					"code": 62019,
					"tempChar": ""
				},
				{
					"order": 1370,
					"prevSize": 32,
					"ligatures": "battery-2, battery5",
					"name": "battery-2",
					"id": 3181,
					"code": 62564,
					"tempChar": ""
				},
				{
					"name": "battery-22, battery-half",
					"id": 1705,
					"order": 2138,
					"prevSize": 32,
					"code": 62018,
					"tempChar": ""
				},
				{
					"order": 1369,
					"prevSize": 32,
					"ligatures": "battery-3, battery4",
					"name": "battery-3",
					"id": 3180,
					"code": 62563,
					"tempChar": ""
				},
				{
					"name": "battery-32, battery-three-quarters",
					"id": 1704,
					"order": 2137,
					"prevSize": 32,
					"code": 62017,
					"tempChar": ""
				},
				{
					"order": 1368,
					"prevSize": 32,
					"ligatures": "battery-4, battery3",
					"name": "battery-4",
					"id": 3179,
					"code": 62562,
					"tempChar": ""
				},
				{
					"name": "battery-42, battery-full",
					"id": 1703,
					"order": 2136,
					"prevSize": 32,
					"code": 62016,
					"tempChar": ""
				},
				{
					"order": 1367,
					"prevSize": 32,
					"ligatures": "battery-5, battery2",
					"name": "battery-5",
					"id": 3178,
					"code": 62561,
					"tempChar": ""
				},
				{
					"order": 1366,
					"prevSize": 32,
					"ligatures": "battery-6, battery",
					"name": "battery-6",
					"id": 3177,
					"code": 62560,
					"tempChar": ""
				},
				{
					"order": 1373,
					"prevSize": 32,
					"ligatures": "battery-charging, battery8",
					"name": "battery-charging",
					"id": 3184,
					"code": 62567,
					"tempChar": ""
				},
				{
					"id": 307,
					"order": 2522,
					"prevSize": 32,
					"code": 59690,
					"name": "battle",
					"tempChar": ""
				},
				{
					"id": 308,
					"order": 2523,
					"prevSize": 32,
					"code": 59691,
					"name": "battle2",
					"tempChar": ""
				},
				{
					"id": 309,
					"order": 2524,
					"prevSize": 32,
					"code": 59692,
					"name": "be",
					"tempChar": ""
				},
				{
					"id": 310,
					"order": 2525,
					"prevSize": 32,
					"code": 59693,
					"name": "be2",
					"tempChar": ""
				},
				{
					"id": 961,
					"order": 2262,
					"prevSize": 32,
					"code": 60344,
					"name": "be3",
					"tempChar": ""
				},
				{
					"id": 311,
					"order": 2526,
					"prevSize": 32,
					"code": 59694,
					"name": "beat",
					"tempChar": ""
				},
				{
					"id": 312,
					"order": 2527,
					"prevSize": 32,
					"code": 59695,
					"name": "beat2",
					"tempChar": ""
				},
				{
					"order": 990,
					"prevSize": 32,
					"ligatures": "bed, sleep",
					"name": "bed",
					"id": 2801,
					"code": 62184,
					"tempChar": ""
				},
				{
					"order": 991,
					"prevSize": 32,
					"ligatures": "bed2, sleep2",
					"name": "bed2",
					"id": 2802,
					"code": 62185,
					"tempChar": ""
				},
				{
					"name": "bed3, hotel",
					"id": 1694,
					"order": 2127,
					"prevSize": 32,
					"code": 62006,
					"tempChar": ""
				},
				{
					"name": "beer",
					"id": 1404,
					"order": 1837,
					"prevSize": 32,
					"code": 61692,
					"tempChar": ""
				},
				{
					"order": 1545,
					"prevSize": 32,
					"name": "behance",
					"ligatures": "behance, brand32",
					"id": 3356,
					"code": 62739,
					"tempChar": ""
				},
				{
					"name": "behance-square",
					"id": 1575,
					"order": 2008,
					"prevSize": 32,
					"code": 61877,
					"tempChar": ""
				},
				{
					"order": 1546,
					"prevSize": 32,
					"name": "behance2",
					"ligatures": "behance2, brand33",
					"id": 3357,
					"code": 62740,
					"tempChar": ""
				},
				{
					"name": "behance3",
					"id": 1574,
					"order": 2007,
					"prevSize": 32,
					"code": 61876,
					"tempChar": ""
				},
				{
					"id": 313,
					"order": 2528,
					"prevSize": 32,
					"code": 59696,
					"name": "believe",
					"tempChar": ""
				},
				{
					"id": 314,
					"order": 2529,
					"prevSize": 32,
					"code": 59697,
					"name": "believe2",
					"tempChar": ""
				},
				{
					"id": 962,
					"order": 2263,
					"prevSize": 32,
					"code": 60345,
					"name": "believe3",
					"tempChar": ""
				},
				{
					"order": 345,
					"prevSize": 32,
					"ligatures": "bell, alarm5",
					"name": "bell",
					"id": 2156,
					"code": 60905,
					"tempChar": ""
				},
				{
					"order": 350,
					"prevSize": 32,
					"ligatures": "bell-check, alarm10",
					"name": "bell-check",
					"id": 2161,
					"code": 60910,
					"tempChar": ""
				},
				{
					"order": 351,
					"prevSize": 32,
					"ligatures": "bell-cross, alarm11",
					"name": "bell-cross",
					"id": 2162,
					"code": 60911,
					"tempChar": ""
				},
				{
					"order": 349,
					"prevSize": 32,
					"ligatures": "bell-minus, alarm9",
					"name": "bell-minus",
					"id": 2160,
					"code": 60909,
					"tempChar": ""
				},
				{
					"name": "bell-o",
					"id": 1331,
					"order": 1764,
					"prevSize": 32,
					"code": 61602,
					"tempChar": ""
				},
				{
					"order": 348,
					"prevSize": 32,
					"ligatures": "bell-plus, alarm8",
					"name": "bell-plus",
					"id": 2159,
					"code": 60908,
					"tempChar": ""
				},
				{
					"name": "bell-slash",
					"id": 1636,
					"order": 2069,
					"prevSize": 32,
					"code": 61942,
					"tempChar": ""
				},
				{
					"name": "bell-slash-o",
					"id": 1637,
					"order": 2070,
					"prevSize": 32,
					"code": 61943,
					"tempChar": ""
				},
				{
					"order": 346,
					"prevSize": 32,
					"ligatures": "bell2, alarm6",
					"name": "bell2",
					"id": 2157,
					"code": 60906,
					"tempChar": ""
				},
				{
					"order": 347,
					"prevSize": 32,
					"ligatures": "bell3, alarm7",
					"name": "bell3",
					"id": 2158,
					"code": 60907,
					"tempChar": ""
				},
				{
					"name": "bell4",
					"id": 1395,
					"order": 1828,
					"prevSize": 32,
					"code": 61683,
					"tempChar": ""
				},
				{
					"name": "bicycle",
					"id": 1651,
					"order": 2084,
					"prevSize": 32,
					"code": 61958,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "bicycle, exercise",
					"order": 3240,
					"name": "bicycle2",
					"id": 175,
					"code": 59472,
					"tempChar": ""
				},
				{
					"order": 786,
					"prevSize": 32,
					"ligatures": "bike, travel7",
					"name": "bike",
					"id": 2597,
					"code": 61346,
					"tempChar": ""
				},
				{
					"order": 767,
					"prevSize": 32,
					"ligatures": "bin, trashcan",
					"name": "bin",
					"id": 2578,
					"code": 61327,
					"tempChar": ""
				},
				{
					"order": 768,
					"prevSize": 32,
					"ligatures": "bin2, trashcan2",
					"name": "bin2",
					"id": 2579,
					"code": 61328,
					"tempChar": ""
				},
				{
					"order": 769,
					"prevSize": 32,
					"ligatures": "bin3, trashcan3",
					"name": "bin3",
					"id": 2580,
					"code": 61329,
					"tempChar": ""
				},
				{
					"order": 770,
					"prevSize": 32,
					"ligatures": "bin4, trashcan4",
					"name": "bin4",
					"id": 2581,
					"code": 61330,
					"tempChar": ""
				},
				{
					"order": 771,
					"prevSize": 32,
					"ligatures": "bin5, trashcan5",
					"name": "bin5",
					"id": 2582,
					"code": 61331,
					"tempChar": ""
				},
				{
					"order": 560,
					"prevSize": 32,
					"ligatures": "binoculars, lookup",
					"name": "binoculars",
					"id": 2371,
					"code": 61120,
					"tempChar": ""
				},
				{
					"order": 561,
					"prevSize": 32,
					"ligatures": "binoculars2, lookup2",
					"name": "binoculars2",
					"id": 2372,
					"code": 61121,
					"tempChar": ""
				},
				{
					"name": "binoculars3",
					"id": 1620,
					"order": 2053,
					"prevSize": 32,
					"code": 61925,
					"tempChar": ""
				},
				{
					"id": 315,
					"order": 2530,
					"prevSize": 32,
					"code": 59698,
					"name": "birth",
					"tempChar": ""
				},
				{
					"id": 316,
					"order": 2531,
					"prevSize": 32,
					"code": 59699,
					"name": "birth2",
					"tempChar": ""
				},
				{
					"name": "birthday-cake",
					"id": 1643,
					"order": 2076,
					"prevSize": 32,
					"code": 61949,
					"tempChar": ""
				},
				{
					"name": "bitbucket",
					"id": 1511,
					"order": 1944,
					"prevSize": 32,
					"code": 61809,
					"tempChar": ""
				},
				{
					"name": "bitbucket-square",
					"id": 1512,
					"order": 1945,
					"prevSize": 32,
					"code": 61810,
					"tempChar": ""
				},
				{
					"name": "bitcoin, btc",
					"id": 1490,
					"order": 1923,
					"prevSize": 32,
					"code": 61786,
					"tempChar": ""
				},
				{
					"name": "black-tie",
					"id": 1762,
					"order": 2195,
					"prevSize": 32,
					"code": 62078,
					"tempChar": ""
				},
				{
					"id": 317,
					"order": 2532,
					"prevSize": 32,
					"code": 59700,
					"name": "blaze",
					"tempChar": ""
				},
				{
					"id": 318,
					"order": 2533,
					"prevSize": 32,
					"code": 59701,
					"name": "blaze2",
					"tempChar": ""
				},
				{
					"id": 963,
					"order": 2264,
					"prevSize": 32,
					"code": 60346,
					"name": "blaze3",
					"tempChar": ""
				},
				{
					"id": 319,
					"order": 2534,
					"prevSize": 32,
					"code": 59702,
					"name": "blend",
					"tempChar": ""
				},
				{
					"id": 320,
					"order": 2535,
					"prevSize": 32,
					"code": 59703,
					"name": "blend2",
					"tempChar": ""
				},
				{
					"id": 964,
					"order": 2265,
					"prevSize": 32,
					"code": 60347,
					"name": "blend3",
					"tempChar": ""
				},
				{
					"name": "blind",
					"id": 1791,
					"order": 2224,
					"prevSize": 32,
					"code": 62109,
					"tempChar": ""
				},
				{
					"order": 1129,
					"prevSize": 32,
					"ligatures": "blocked, forbidden",
					"name": "blocked",
					"id": 2940,
					"code": 62323,
					"tempChar": ""
				},
				{
					"order": 39,
					"prevSize": 32,
					"ligatures": "blog, pen6",
					"name": "blog",
					"id": 1850,
					"code": 60599,
					"tempChar": ""
				},
				{
					"order": 40,
					"prevSize": 32,
					"ligatures": "blog2, pencil8",
					"name": "blog2",
					"id": 1851,
					"code": 60600,
					"tempChar": ""
				},
				{
					"order": 1560,
					"prevSize": 32,
					"ligatures": "blogger, brand47",
					"name": "blogger",
					"id": 3371,
					"code": 62754,
					"tempChar": ""
				},
				{
					"order": 1561,
					"prevSize": 32,
					"ligatures": "blogger2, brand48",
					"name": "blogger2",
					"id": 3372,
					"code": 62755,
					"tempChar": ""
				},
				{
					"id": 321,
					"order": 2536,
					"prevSize": 32,
					"code": 59704,
					"name": "bloom",
					"tempChar": ""
				},
				{
					"id": 322,
					"order": 2537,
					"prevSize": 32,
					"code": 59705,
					"name": "bloom2",
					"tempChar": ""
				},
				{
					"id": 965,
					"order": 2266,
					"prevSize": 32,
					"code": 60348,
					"name": "blow",
					"tempChar": ""
				},
				{
					"name": "bluetooth",
					"id": 1781,
					"order": 2214,
					"prevSize": 32,
					"code": 62099,
					"tempChar": ""
				},
				{
					"name": "bluetooth-b",
					"id": 1782,
					"order": 2215,
					"prevSize": 32,
					"code": 62100,
					"tempChar": ""
				},
				{
					"order": 791,
					"prevSize": 32,
					"ligatures": "boat, travel11",
					"name": "boat",
					"id": 2602,
					"code": 61351,
					"tempChar": ""
				},
				{
					"order": 1433,
					"prevSize": 32,
					"ligatures": "bold, wysiwyg5",
					"name": "bold",
					"id": 3244,
					"code": 62627,
					"tempChar": ""
				},
				{
					"order": 1439,
					"prevSize": 32,
					"ligatures": "bold2, wysiwyg11",
					"name": "bold2",
					"id": 3250,
					"code": 62633,
					"tempChar": ""
				},
				{
					"name": "bold3",
					"id": 1226,
					"order": 1659,
					"prevSize": 32,
					"code": 61490,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "bold, typography4",
					"order": 3307,
					"name": "bold4",
					"id": 242,
					"code": 59539,
					"tempChar": ""
				},
				{
					"name": "bolt, flash",
					"id": 1384,
					"order": 1817,
					"prevSize": 32,
					"code": 61671,
					"tempChar": ""
				},
				{
					"order": 745,
					"prevSize": 32,
					"ligatures": "bomb, explosive",
					"name": "bomb",
					"id": 2556,
					"code": 61305,
					"tempChar": ""
				},
				{
					"name": "bomb2",
					"id": 1617,
					"order": 2050,
					"prevSize": 32,
					"code": 61922,
					"tempChar": ""
				},
				{
					"order": 146,
					"prevSize": 32,
					"ligatures": "book, read",
					"name": "book",
					"id": 1957,
					"code": 60706,
					"tempChar": ""
				},
				{
					"order": 148,
					"prevSize": 32,
					"ligatures": "book-play, book3",
					"name": "book-play",
					"id": 1959,
					"code": 60708,
					"tempChar": ""
				},
				{
					"order": 147,
					"prevSize": 32,
					"ligatures": "book2, read2",
					"name": "book2",
					"id": 1958,
					"code": 60707,
					"tempChar": ""
				},
				{
					"order": 149,
					"prevSize": 32,
					"ligatures": "book4, read3",
					"name": "book3",
					"id": 1960,
					"code": 60709,
					"tempChar": ""
				},
				{
					"name": "book4",
					"id": 1221,
					"order": 1654,
					"prevSize": 32,
					"code": 61485,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "book, read",
					"order": 3200,
					"name": "book5",
					"id": 135,
					"code": 59432,
					"tempChar": ""
				},
				{
					"order": 150,
					"prevSize": 32,
					"ligatures": "bookmark, book5",
					"name": "bookmark",
					"id": 1961,
					"code": 60710,
					"tempChar": ""
				},
				{
					"name": "bookmark-o",
					"id": 1321,
					"order": 1754,
					"prevSize": 32,
					"code": 61591,
					"tempChar": ""
				},
				{
					"order": 953,
					"prevSize": 32,
					"ligatures": "bookmark2, ribbon",
					"name": "bookmark2",
					"id": 2764,
					"code": 62147,
					"tempChar": ""
				},
				{
					"order": 954,
					"prevSize": 32,
					"ligatures": "bookmark3, ribbon2",
					"name": "bookmark3",
					"id": 2765,
					"code": 62148,
					"tempChar": ""
				},
				{
					"order": 956,
					"prevSize": 32,
					"ligatures": "bookmark4, book6",
					"name": "bookmark4",
					"id": 2767,
					"code": 62150,
					"tempChar": ""
				},
				{
					"name": "bookmark5",
					"id": 1222,
					"order": 1655,
					"prevSize": 32,
					"code": 61486,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "bookmark, ribbon",
					"order": 3201,
					"name": "bookmark6",
					"id": 136,
					"code": 59433,
					"tempChar": ""
				},
				{
					"id": 323,
					"order": 2538,
					"prevSize": 32,
					"code": 59706,
					"name": "bookmark7",
					"tempChar": ""
				},
				{
					"id": 324,
					"order": 2539,
					"prevSize": 32,
					"code": 59707,
					"name": "bookmark8",
					"tempChar": ""
				},
				{
					"id": 966,
					"order": 2267,
					"prevSize": 32,
					"code": 60349,
					"name": "bookmark9",
					"tempChar": ""
				},
				{
					"order": 955,
					"prevSize": 32,
					"ligatures": "bookmarks, ribbons",
					"name": "bookmarks",
					"id": 2766,
					"code": 62149,
					"tempChar": ""
				},
				{
					"order": 151,
					"prevSize": 32,
					"ligatures": "books, library",
					"name": "books",
					"id": 1962,
					"code": 60711,
					"tempChar": ""
				},
				{
					"id": 325,
					"order": 2540,
					"prevSize": 32,
					"code": 59708,
					"name": "bootleg",
					"tempChar": ""
				},
				{
					"id": 326,
					"order": 2541,
					"prevSize": 32,
					"code": 59709,
					"name": "bootleg2",
					"tempChar": ""
				},
				{
					"order": 696,
					"prevSize": 32,
					"ligatures": "bottle, drink5",
					"name": "bottle",
					"id": 2507,
					"code": 61256,
					"tempChar": ""
				},
				{
					"order": 697,
					"prevSize": 32,
					"ligatures": "bottle2, drink6",
					"name": "bottle2",
					"id": 2508,
					"code": 61257,
					"tempChar": ""
				},
				{
					"order": 698,
					"prevSize": 32,
					"ligatures": "bottle3, drink7",
					"name": "bottle3",
					"id": 2509,
					"code": 61258,
					"tempChar": ""
				},
				{
					"order": 699,
					"prevSize": 32,
					"ligatures": "bottle4, drink8",
					"name": "bottle4",
					"id": 2510,
					"code": 61259,
					"tempChar": ""
				},
				{
					"id": 327,
					"order": 2542,
					"prevSize": 32,
					"code": 59710,
					"name": "bounce",
					"tempChar": ""
				},
				{
					"id": 328,
					"order": 2543,
					"prevSize": 32,
					"code": 59711,
					"name": "bounce2",
					"tempChar": ""
				},
				{
					"id": 967,
					"order": 2268,
					"prevSize": 32,
					"code": 60350,
					"name": "bounce3",
					"tempChar": ""
				},
				{
					"order": 828,
					"prevSize": 32,
					"ligatures": "bow, soprts3",
					"name": "bow",
					"id": 2639,
					"code": 61388,
					"tempChar": ""
				},
				{
					"order": 840,
					"prevSize": 32,
					"ligatures": "bowling, soprts10",
					"name": "bowling",
					"id": 2651,
					"code": 61400,
					"tempChar": ""
				},
				{
					"order": 841,
					"prevSize": 32,
					"ligatures": "bowling2, soprts11",
					"name": "bowling2",
					"id": 2652,
					"code": 61401,
					"tempChar": ""
				},
				{
					"order": 533,
					"prevSize": 32,
					"ligatures": "bowtie",
					"name": "bowtie",
					"id": 2344,
					"code": 61093,
					"tempChar": ""
				},
				{
					"order": 390,
					"prevSize": 32,
					"ligatures": "box6, inbox",
					"name": "box",
					"id": 2201,
					"code": 60950,
					"tempChar": ""
				},
				{
					"order": 391,
					"prevSize": 32,
					"ligatures": "box-add, box7",
					"name": "box-add",
					"id": 2202,
					"code": 60951,
					"tempChar": ""
				},
				{
					"order": 392,
					"prevSize": 32,
					"ligatures": "box-remove, box8",
					"name": "box-remove",
					"id": 2203,
					"code": 60952,
					"tempChar": ""
				},
				{
					"name": "braille",
					"id": 1794,
					"order": 2227,
					"prevSize": 32,
					"code": 62113,
					"tempChar": ""
				},
				{
					"order": 809,
					"prevSize": 32,
					"ligatures": "brain, head",
					"name": "brain",
					"id": 2620,
					"code": 61369,
					"tempChar": ""
				},
				{
					"order": 711,
					"prevSize": 32,
					"ligatures": "bread, food10",
					"name": "bread",
					"id": 2522,
					"code": 61271,
					"tempChar": ""
				},
				{
					"id": 329,
					"order": 2544,
					"prevSize": 32,
					"code": 59712,
					"name": "break",
					"tempChar": ""
				},
				{
					"id": 330,
					"order": 2545,
					"prevSize": 32,
					"code": 59713,
					"name": "break2",
					"tempChar": ""
				},
				{
					"id": 331,
					"order": 2546,
					"prevSize": 32,
					"code": 59714,
					"name": "brew",
					"tempChar": ""
				},
				{
					"id": 332,
					"order": 2547,
					"prevSize": 32,
					"code": 59715,
					"name": "brew2",
					"tempChar": ""
				},
				{
					"id": 968,
					"order": 2269,
					"prevSize": 32,
					"code": 60351,
					"name": "brew3",
					"tempChar": ""
				},
				{
					"order": 772,
					"prevSize": 32,
					"ligatures": "briefcase, portfolio",
					"name": "briefcase",
					"id": 2583,
					"code": 61332,
					"tempChar": ""
				},
				{
					"order": 773,
					"prevSize": 32,
					"ligatures": "briefcase2, portfolio2",
					"name": "briefcase2",
					"id": 2584,
					"code": 61333,
					"tempChar": ""
				},
				{
					"order": 774,
					"prevSize": 32,
					"ligatures": "briefcase3, portfolio3",
					"name": "briefcase3",
					"id": 2585,
					"code": 61334,
					"tempChar": ""
				},
				{
					"name": "briefcase4",
					"id": 1345,
					"order": 1778,
					"prevSize": 32,
					"code": 61617,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "briefcase, suitcase",
					"order": 3236,
					"name": "briefcase5",
					"id": 171,
					"code": 59468,
					"tempChar": ""
				},
				{
					"order": 986,
					"prevSize": 32,
					"ligatures": "brightness-contrast",
					"name": "brightness-contrast",
					"id": 2797,
					"code": 62180,
					"tempChar": ""
				},
				{
					"order": 987,
					"prevSize": 32,
					"ligatures": "brightness-high, brightness2",
					"name": "brightness-high",
					"id": 2798,
					"code": 62181,
					"tempChar": ""
				},
				{
					"order": 989,
					"prevSize": 32,
					"ligatures": "brightness-low, brightness4",
					"name": "brightness-low",
					"id": 2800,
					"code": 62183,
					"tempChar": ""
				},
				{
					"order": 988,
					"prevSize": 32,
					"ligatures": "brightness-medium, brightness3",
					"name": "brightness-medium",
					"id": 2799,
					"code": 62182,
					"tempChar": ""
				},
				{
					"id": 333,
					"order": 2548,
					"prevSize": 32,
					"code": 59716,
					"name": "broadcast",
					"tempChar": ""
				},
				{
					"id": 334,
					"order": 2549,
					"prevSize": 32,
					"code": 59717,
					"name": "broadcast2",
					"tempChar": ""
				},
				{
					"id": 969,
					"order": 2270,
					"prevSize": 32,
					"code": 60352,
					"name": "broadcast3",
					"tempChar": ""
				},
				{
					"order": 765,
					"prevSize": 32,
					"ligatures": "broom, clean",
					"name": "broom",
					"id": 2576,
					"code": 61325,
					"tempChar": ""
				},
				{
					"id": 335,
					"order": 2550,
					"prevSize": 32,
					"code": 59718,
					"name": "browse",
					"tempChar": ""
				},
				{
					"id": 336,
					"order": 2551,
					"prevSize": 32,
					"code": 59719,
					"name": "browse2",
					"tempChar": ""
				},
				{
					"order": 42,
					"prevSize": 32,
					"ligatures": "brush, paint",
					"name": "brush",
					"id": 1853,
					"code": 60602,
					"tempChar": ""
				},
				{
					"id": 337,
					"order": 2552,
					"prevSize": 32,
					"code": 59720,
					"name": "brush2",
					"tempChar": ""
				},
				{
					"id": 338,
					"order": 2553,
					"prevSize": 32,
					"code": 59721,
					"name": "brush3",
					"tempChar": ""
				},
				{
					"order": 454,
					"prevSize": 32,
					"ligatures": "bubble, comment",
					"name": "bubble",
					"id": 2265,
					"code": 61014,
					"tempChar": ""
				},
				{
					"order": 482,
					"prevSize": 32,
					"ligatures": "bubble-blocked, bubble19",
					"name": "bubble-blocked",
					"id": 2293,
					"code": 61042,
					"tempChar": ""
				},
				{
					"order": 493,
					"prevSize": 32,
					"ligatures": "bubble-cancel, bubble30",
					"name": "bubble-cancel",
					"id": 2304,
					"code": 61053,
					"tempChar": ""
				},
				{
					"order": 486,
					"prevSize": 32,
					"ligatures": "bubble-check, bubble23",
					"name": "bubble-check",
					"id": 2297,
					"code": 61046,
					"tempChar": ""
				},
				{
					"order": 464,
					"prevSize": 32,
					"ligatures": "bubble-dots, bubble5",
					"name": "bubble-dots",
					"id": 2275,
					"code": 61024,
					"tempChar": ""
				},
				{
					"order": 467,
					"prevSize": 32,
					"ligatures": "bubble-dots2, bubble8",
					"name": "bubble-dots2",
					"id": 2278,
					"code": 61027,
					"tempChar": ""
				},
				{
					"order": 475,
					"prevSize": 32,
					"ligatures": "bubble-dots3, bubble14",
					"name": "bubble-dots3",
					"id": 2286,
					"code": 61035,
					"tempChar": ""
				},
				{
					"order": 478,
					"prevSize": 32,
					"ligatures": "bubble-dots4, bubble17",
					"name": "bubble-dots4",
					"id": 2289,
					"code": 61038,
					"tempChar": ""
				},
				{
					"order": 499,
					"prevSize": 32,
					"ligatures": "bubble-first, bubble36",
					"name": "bubble-first",
					"id": 2310,
					"code": 61059,
					"tempChar": ""
				},
				{
					"order": 502,
					"prevSize": 32,
					"ligatures": "bubble-forward, bubble39",
					"name": "bubble-forward",
					"id": 2313,
					"code": 61062,
					"tempChar": ""
				},
				{
					"order": 504,
					"prevSize": 32,
					"ligatures": "bubble-forward2, bubble41",
					"name": "bubble-forward2",
					"id": 2315,
					"code": 61064,
					"tempChar": ""
				},
				{
					"order": 491,
					"prevSize": 32,
					"ligatures": "bubble-heart, bubble28",
					"name": "bubble-heart",
					"id": 2302,
					"code": 61051,
					"tempChar": ""
				},
				{
					"order": 500,
					"prevSize": 32,
					"ligatures": "bubble-last, bubble37",
					"name": "bubble-last",
					"id": 2311,
					"code": 61060,
					"tempChar": ""
				},
				{
					"order": 497,
					"prevSize": 32,
					"ligatures": "bubble-left, bubble34",
					"name": "bubble-left",
					"id": 2308,
					"code": 61057,
					"tempChar": ""
				},
				{
					"order": 465,
					"prevSize": 32,
					"ligatures": "bubble-lines, bubble6",
					"name": "bubble-lines",
					"id": 2276,
					"code": 61025,
					"tempChar": ""
				},
				{
					"order": 468,
					"prevSize": 32,
					"ligatures": "bubble-lines2, bubble9",
					"name": "bubble-lines2",
					"id": 2279,
					"code": 61028,
					"tempChar": ""
				},
				{
					"order": 476,
					"prevSize": 32,
					"ligatures": "bubble-lines3, bubble15",
					"name": "bubble-lines3",
					"id": 2287,
					"code": 61036,
					"tempChar": ""
				},
				{
					"order": 479,
					"prevSize": 32,
					"ligatures": "bubble-lines4, bubble18",
					"name": "bubble-lines4",
					"id": 2290,
					"code": 61039,
					"tempChar": ""
				},
				{
					"order": 488,
					"prevSize": 32,
					"ligatures": "bubble-link, bubble25",
					"name": "bubble-link",
					"id": 2299,
					"code": 61048,
					"tempChar": ""
				},
				{
					"order": 489,
					"prevSize": 32,
					"ligatures": "bubble-lock, bubble26",
					"name": "bubble-lock",
					"id": 2300,
					"code": 61049,
					"tempChar": ""
				},
				{
					"order": 495,
					"prevSize": 32,
					"ligatures": "bubble-minus, bubble32",
					"name": "bubble-minus",
					"id": 2306,
					"code": 61055,
					"tempChar": ""
				},
				{
					"order": 460,
					"prevSize": 32,
					"ligatures": "bubble-notification, bubble3",
					"name": "bubble-notification",
					"id": 2271,
					"code": 61020,
					"tempChar": ""
				},
				{
					"order": 496,
					"prevSize": 32,
					"ligatures": "bubble-notification2, bubble33",
					"name": "bubble-notification2",
					"id": 2307,
					"code": 61056,
					"tempChar": ""
				},
				{
					"order": 492,
					"prevSize": 32,
					"ligatures": "bubble-paperclip, bubble29",
					"name": "bubble-paperclip",
					"id": 2303,
					"code": 61052,
					"tempChar": ""
				},
				{
					"order": 494,
					"prevSize": 32,
					"ligatures": "bubble-plus, bubble31",
					"name": "bubble-plus",
					"id": 2305,
					"code": 61054,
					"tempChar": ""
				},
				{
					"order": 483,
					"prevSize": 32,
					"ligatures": "bubble-quote, bubble20",
					"name": "bubble-quote",
					"id": 2294,
					"code": 61043,
					"tempChar": ""
				},
				{
					"order": 501,
					"prevSize": 32,
					"ligatures": "bubble-reply, bubble38",
					"name": "bubble-reply",
					"id": 2312,
					"code": 61061,
					"tempChar": ""
				},
				{
					"order": 503,
					"prevSize": 32,
					"ligatures": "bubble-reply2, bubble40",
					"name": "bubble-reply2",
					"id": 2314,
					"code": 61063,
					"tempChar": ""
				},
				{
					"order": 498,
					"prevSize": 32,
					"ligatures": "bubble-right, bubble35",
					"name": "bubble-right",
					"id": 2309,
					"code": 61058,
					"tempChar": ""
				},
				{
					"order": 485,
					"prevSize": 32,
					"ligatures": "bubble-smiley, bubble22",
					"name": "bubble-smiley",
					"id": 2296,
					"code": 61045,
					"tempChar": ""
				},
				{
					"order": 490,
					"prevSize": 32,
					"ligatures": "bubble-star, bubble27",
					"name": "bubble-star",
					"id": 2301,
					"code": 61050,
					"tempChar": ""
				},
				{
					"order": 484,
					"prevSize": 32,
					"ligatures": "bubble-user, bubble21",
					"name": "bubble-user",
					"id": 2295,
					"code": 61044,
					"tempChar": ""
				},
				{
					"order": 487,
					"prevSize": 32,
					"ligatures": "bubble-video, bubble24",
					"name": "bubble-video",
					"id": 2298,
					"code": 61047,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "bubble, chat",
					"order": 3223,
					"name": "bubble10",
					"id": 158,
					"code": 59455,
					"tempChar": ""
				},
				{
					"order": 457,
					"prevSize": 32,
					"ligatures": "bubble2, comment2",
					"name": "bubble2",
					"id": 2268,
					"code": 61017,
					"tempChar": ""
				},
				{
					"order": 463,
					"prevSize": 32,
					"ligatures": "bubble4, comment3",
					"name": "bubble3",
					"id": 2274,
					"code": 61023,
					"tempChar": ""
				},
				{
					"order": 466,
					"prevSize": 32,
					"ligatures": "bubble7, comment4",
					"name": "bubble4",
					"id": 2277,
					"code": 61026,
					"tempChar": ""
				},
				{
					"order": 469,
					"prevSize": 32,
					"ligatures": "bubble10, comment5",
					"name": "bubble5",
					"id": 2280,
					"code": 61029,
					"tempChar": ""
				},
				{
					"order": 470,
					"prevSize": 32,
					"ligatures": "bubble11, comment6",
					"name": "bubble6",
					"id": 2281,
					"code": 61030,
					"tempChar": ""
				},
				{
					"order": 472,
					"prevSize": 32,
					"ligatures": "bubble12, comment7",
					"name": "bubble7",
					"id": 2283,
					"code": 61032,
					"tempChar": ""
				},
				{
					"order": 474,
					"prevSize": 32,
					"ligatures": "bubble13, comment8",
					"name": "bubble8",
					"id": 2285,
					"code": 61034,
					"tempChar": ""
				},
				{
					"order": 477,
					"prevSize": 32,
					"ligatures": "bubble16, comment9",
					"name": "bubble9",
					"id": 2288,
					"code": 61037,
					"tempChar": ""
				},
				{
					"order": 455,
					"prevSize": 32,
					"ligatures": "bubbles, comments",
					"name": "bubbles",
					"id": 2266,
					"code": 61015,
					"tempChar": ""
				},
				{
					"order": 481,
					"prevSize": 32,
					"ligatures": "bubbles10, comments10",
					"name": "bubbles10",
					"id": 2292,
					"code": 61041,
					"tempChar": ""
				},
				{
					"order": 456,
					"prevSize": 32,
					"ligatures": "bubbles2, comments2",
					"name": "bubbles2",
					"id": 2267,
					"code": 61016,
					"tempChar": ""
				},
				{
					"order": 458,
					"prevSize": 32,
					"ligatures": "bubbles3, comments3",
					"name": "bubbles3",
					"id": 2269,
					"code": 61018,
					"tempChar": ""
				},
				{
					"order": 459,
					"prevSize": 32,
					"ligatures": "bubbles4, comments4",
					"name": "bubbles4",
					"id": 2270,
					"code": 61019,
					"tempChar": ""
				},
				{
					"order": 461,
					"prevSize": 32,
					"ligatures": "bubbles5, comments5",
					"name": "bubbles5",
					"id": 2272,
					"code": 61021,
					"tempChar": ""
				},
				{
					"order": 462,
					"prevSize": 32,
					"ligatures": "bubbles6, comments6",
					"name": "bubbles6",
					"id": 2273,
					"code": 61022,
					"tempChar": ""
				},
				{
					"order": 471,
					"prevSize": 32,
					"ligatures": "bubbles7, comments7",
					"name": "bubbles7",
					"id": 2282,
					"code": 61031,
					"tempChar": ""
				},
				{
					"order": 473,
					"prevSize": 32,
					"ligatures": "bubbles8, comments8",
					"name": "bubbles8",
					"id": 2284,
					"code": 61033,
					"tempChar": ""
				},
				{
					"order": 480,
					"prevSize": 32,
					"ligatures": "bubbles9, comments9",
					"name": "bubbles9",
					"id": 2291,
					"code": 61040,
					"tempChar": ""
				},
				{
					"order": 48,
					"prevSize": 32,
					"ligatures": "bucket, color3",
					"name": "bucket",
					"id": 1859,
					"code": 60608,
					"tempChar": ""
				},
				{
					"order": 49,
					"prevSize": 32,
					"ligatures": "bucket2, color4",
					"name": "bucket2",
					"id": 1860,
					"code": 60609,
					"tempChar": ""
				},
				{
					"order": 634,
					"prevSize": 32,
					"ligatures": "bug, virus",
					"name": "bug",
					"id": 2445,
					"code": 61194,
					"tempChar": ""
				},
				{
					"order": 635,
					"prevSize": 32,
					"ligatures": "bug2, virus2",
					"name": "bug2",
					"id": 2446,
					"code": 61195,
					"tempChar": ""
				},
				{
					"name": "bug3",
					"id": 1533,
					"order": 1966,
					"prevSize": 32,
					"code": 61832,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "bug, insect",
					"order": 3265,
					"name": "bug4",
					"id": 200,
					"code": 59497,
					"tempChar": ""
				},
				{
					"id": 339,
					"order": 2554,
					"prevSize": 32,
					"code": 59722,
					"name": "build",
					"tempChar": ""
				},
				{
					"id": 340,
					"order": 2555,
					"prevSize": 32,
					"code": 59723,
					"name": "build2",
					"tempChar": ""
				},
				{
					"id": 970,
					"order": 2271,
					"prevSize": 32,
					"code": 60353,
					"name": "build3",
					"tempChar": ""
				},
				{
					"name": "building",
					"id": 1568,
					"order": 2001,
					"prevSize": 32,
					"code": 61869,
					"tempChar": ""
				},
				{
					"name": "building-o",
					"id": 1399,
					"order": 1832,
					"prevSize": 32,
					"code": 61687,
					"tempChar": ""
				},
				{
					"order": 123,
					"prevSize": 32,
					"ligatures": "bullhorn, megaphone",
					"name": "bullhorn",
					"id": 1934,
					"code": 60683,
					"tempChar": ""
				},
				{
					"name": "bullhorn2",
					"id": 1330,
					"order": 1763,
					"prevSize": 32,
					"code": 61601,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "bullhorn, megaphone",
					"order": 3249,
					"name": "bullhorn3",
					"id": 184,
					"code": 59481,
					"tempChar": ""
				},
				{
					"name": "bullseye",
					"id": 1465,
					"order": 1898,
					"prevSize": 32,
					"code": 61760,
					"tempChar": ""
				},
				{
					"id": 341,
					"order": 2556,
					"prevSize": 32,
					"code": 59724,
					"name": "burn",
					"tempChar": ""
				},
				{
					"id": 342,
					"order": 2557,
					"prevSize": 32,
					"code": 59725,
					"name": "burn2",
					"tempChar": ""
				},
				{
					"id": 343,
					"order": 2558,
					"prevSize": 32,
					"code": 59726,
					"name": "bury",
					"tempChar": ""
				},
				{
					"id": 344,
					"order": 2559,
					"prevSize": 32,
					"code": 59727,
					"name": "bury2",
					"tempChar": ""
				},
				{
					"id": 971,
					"order": 2272,
					"prevSize": 32,
					"code": 60354,
					"name": "bury3",
					"tempChar": ""
				},
				{
					"order": 784,
					"prevSize": 32,
					"ligatures": "bus, travel6",
					"name": "bus",
					"id": 2595,
					"code": 61344,
					"tempChar": ""
				},
				{
					"name": "bus2",
					"id": 1652,
					"order": 2085,
					"prevSize": 32,
					"code": 61959,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "bus, travel",
					"order": 3237,
					"name": "bus3",
					"id": 172,
					"code": 59469,
					"tempChar": ""
				},
				{
					"id": 345,
					"order": 2560,
					"prevSize": 32,
					"code": 59728,
					"name": "buy",
					"tempChar": ""
				},
				{
					"id": 346,
					"order": 2561,
					"prevSize": 32,
					"code": 59729,
					"name": "buy2",
					"tempChar": ""
				},
				{
					"id": 972,
					"order": 2273,
					"prevSize": 32,
					"code": 60355,
					"name": "buy3",
					"tempChar": ""
				},
				{
					"name": "buysellads",
					"id": 1658,
					"order": 2091,
					"prevSize": 32,
					"code": 61965,
					"tempChar": ""
				},
				{
					"name": "cab, taxi",
					"id": 1580,
					"order": 2013,
					"prevSize": 32,
					"code": 61882,
					"tempChar": ""
				},
				{
					"order": 384,
					"prevSize": 32,
					"ligatures": "cabinet, drawers",
					"name": "cabinet",
					"id": 2195,
					"code": 60944,
					"tempChar": ""
				},
				{
					"order": 728,
					"prevSize": 32,
					"ligatures": "cactus, nature7",
					"name": "cactus",
					"id": 2539,
					"code": 61288,
					"tempChar": ""
				},
				{
					"id": 347,
					"order": 2562,
					"prevSize": 32,
					"code": 59730,
					"name": "caffeinate",
					"tempChar": ""
				},
				{
					"id": 348,
					"order": 2563,
					"prevSize": 32,
					"code": 59731,
					"name": "caffeinate2",
					"tempChar": ""
				},
				{
					"id": 973,
					"order": 2274,
					"prevSize": 32,
					"code": 60356,
					"name": "caffeinate3",
					"tempChar": ""
				},
				{
					"order": 670,
					"prevSize": 32,
					"ligatures": "cake, birthday",
					"name": "cake",
					"id": 2481,
					"code": 61230,
					"tempChar": ""
				},
				{
					"id": 349,
					"order": 2564,
					"prevSize": 32,
					"code": 59732,
					"name": "calculate",
					"tempChar": ""
				},
				{
					"id": 350,
					"order": 2565,
					"prevSize": 32,
					"code": 59733,
					"name": "calculate2",
					"tempChar": ""
				},
				{
					"id": 974,
					"order": 2275,
					"prevSize": 32,
					"code": 60357,
					"name": "calculate3",
					"tempChar": ""
				},
				{
					"order": 281,
					"prevSize": 32,
					"ligatures": "calculator, compute",
					"name": "calculator",
					"id": 2092,
					"code": 60841,
					"tempChar": ""
				},
				{
					"order": 282,
					"prevSize": 32,
					"ligatures": "calculator2, compute2",
					"name": "calculator2",
					"id": 2093,
					"code": 60842,
					"tempChar": ""
				},
				{
					"order": 283,
					"prevSize": 32,
					"ligatures": "calculator3, compute3",
					"name": "calculator3",
					"id": 2094,
					"code": 60843,
					"tempChar": ""
				},
				{
					"name": "calculator4",
					"id": 1627,
					"order": 2060,
					"prevSize": 32,
					"code": 61932,
					"tempChar": ""
				},
				{
					"order": 353,
					"prevSize": 32,
					"ligatures": "calendar, date",
					"name": "calendar",
					"id": 2164,
					"code": 60913,
					"tempChar": ""
				},
				{
					"name": "calendar-check-o",
					"id": 1752,
					"order": 2185,
					"prevSize": 32,
					"code": 62068,
					"tempChar": ""
				},
				{
					"order": 359,
					"name": "calendar-day",
					"prevSize": 32,
					"ligatures": "calendar7, day",
					"id": 2170,
					"code": 60919,
					"tempChar": ""
				},
				{
					"order": 358,
					"name": "calendar-empty",
					"prevSize": 32,
					"ligatures": "calendar6, date6",
					"id": 2169,
					"code": 60918,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "calendar-full, calendar",
					"order": 3214,
					"name": "calendar-full",
					"id": 149,
					"code": 59446,
					"tempChar": ""
				},
				{
					"name": "calendar-minus-o",
					"id": 1750,
					"order": 2183,
					"prevSize": 32,
					"code": 62066,
					"tempChar": ""
				},
				{
					"name": "calendar-o",
					"id": 1453,
					"order": 1886,
					"prevSize": 32,
					"code": 61747,
					"tempChar": ""
				},
				{
					"name": "calendar-plus-o",
					"id": 1749,
					"order": 2182,
					"prevSize": 32,
					"code": 62065,
					"tempChar": ""
				},
				{
					"name": "calendar-times-o",
					"id": 1751,
					"order": 2184,
					"prevSize": 32,
					"code": 62067,
					"tempChar": ""
				},
				{
					"order": 360,
					"prevSize": 32,
					"ligatures": "calendar8, week",
					"name": "calendar-week",
					"id": 2171,
					"code": 60920,
					"tempChar": ""
				},
				{
					"order": 354,
					"prevSize": 32,
					"ligatures": "calendar2, date2",
					"name": "calendar2",
					"id": 2165,
					"code": 60914,
					"tempChar": ""
				},
				{
					"order": 355,
					"prevSize": 32,
					"ligatures": "calendar3, date3",
					"name": "calendar3",
					"id": 2166,
					"code": 60915,
					"tempChar": ""
				},
				{
					"order": 356,
					"prevSize": 32,
					"ligatures": "calendar4, date4",
					"name": "calendar4",
					"id": 2167,
					"code": 60916,
					"tempChar": ""
				},
				{
					"order": 357,
					"prevSize": 32,
					"name": "calendar5",
					"ligatures": "calendar5, date5",
					"id": 2168,
					"code": 60917,
					"tempChar": ""
				},
				{
					"name": "calendar6",
					"id": 1287,
					"order": 1720,
					"prevSize": 32,
					"code": 61555,
					"tempChar": ""
				},
				{
					"id": 351,
					"order": 2566,
					"prevSize": 32,
					"code": 59734,
					"name": "call",
					"tempChar": ""
				},
				{
					"id": 352,
					"order": 2567,
					"prevSize": 32,
					"code": 59735,
					"name": "call2",
					"tempChar": ""
				},
				{
					"id": 975,
					"order": 2276,
					"prevSize": 32,
					"code": 60358,
					"name": "call3",
					"tempChar": ""
				},
				{
					"order": 70,
					"prevSize": 32,
					"ligatures": "camera, photo",
					"name": "camera",
					"id": 1881,
					"code": 60630,
					"tempChar": ""
				},
				{
					"name": "camera-retro",
					"id": 1302,
					"order": 1735,
					"prevSize": 32,
					"code": 61571,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "camera-video, video2",
					"order": 3197,
					"name": "camera-video",
					"id": 132,
					"code": 59429,
					"tempChar": ""
				},
				{
					"order": 71,
					"prevSize": 32,
					"ligatures": "camera2, photo2",
					"name": "camera2",
					"id": 1882,
					"code": 60631,
					"tempChar": ""
				},
				{
					"order": 72,
					"prevSize": 32,
					"ligatures": "camera3, photo3",
					"name": "camera3",
					"id": 1883,
					"code": 60632,
					"tempChar": ""
				},
				{
					"name": "camera4",
					"id": 1224,
					"order": 1657,
					"prevSize": 32,
					"code": 61488,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "camera, photo",
					"order": 3198,
					"name": "camera5",
					"id": 133,
					"code": 59430,
					"tempChar": ""
				},
				{
					"order": 1132,
					"prevSize": 32,
					"ligatures": "cancel, close5",
					"name": "cancel",
					"id": 2943,
					"code": 62326,
					"tempChar": ""
				},
				{
					"order": 1127,
					"prevSize": 32,
					"ligatures": "cancel-circle, close",
					"name": "cancel-circle",
					"id": 2938,
					"code": 62321,
					"tempChar": ""
				},
				{
					"order": 1128,
					"prevSize": 32,
					"ligatures": "cancel-circle2, close2",
					"name": "cancel-circle2",
					"id": 2939,
					"code": 62322,
					"tempChar": ""
				},
				{
					"order": 1130,
					"prevSize": 32,
					"ligatures": "cancel-square, close3",
					"name": "cancel-square",
					"id": 2941,
					"code": 62324,
					"tempChar": ""
				},
				{
					"order": 1131,
					"prevSize": 32,
					"ligatures": "cancel-square2, close4",
					"name": "cancel-square2",
					"id": 2942,
					"code": 62325,
					"tempChar": ""
				},
				{
					"order": 780,
					"prevSize": 32,
					"ligatures": "car, travel4",
					"name": "car",
					"id": 2591,
					"code": 61340,
					"tempChar": ""
				},
				{
					"order": 782,
					"prevSize": 32,
					"ligatures": "car2, travel5",
					"name": "car2",
					"id": 2593,
					"code": 61342,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "car, travel2",
					"order": 3238,
					"name": "car4",
					"id": 173,
					"code": 59470,
					"tempChar": ""
				},
				{
					"name": "caret-down",
					"id": 1369,
					"order": 1802,
					"prevSize": 32,
					"code": 61655,
					"tempChar": ""
				},
				{
					"name": "caret-left",
					"id": 1371,
					"order": 1804,
					"prevSize": 32,
					"code": 61657,
					"tempChar": ""
				},
				{
					"name": "caret-right",
					"id": 1372,
					"order": 1805,
					"prevSize": 32,
					"code": 61658,
					"tempChar": ""
				},
				{
					"name": "caret-square-o-down, toggle-down",
					"id": 1480,
					"order": 1913,
					"prevSize": 32,
					"code": 61776,
					"tempChar": ""
				},
				{
					"name": "caret-square-o-left, toggle-left",
					"id": 1541,
					"order": 1974,
					"prevSize": 32,
					"code": 61841,
					"tempChar": ""
				},
				{
					"name": "caret-square-o-right, toggle-right",
					"id": 1482,
					"order": 1915,
					"prevSize": 32,
					"code": 61778,
					"tempChar": ""
				},
				{
					"name": "caret-square-o-up, toggle-up",
					"id": 1481,
					"order": 1914,
					"prevSize": 32,
					"code": 61777,
					"tempChar": ""
				},
				{
					"name": "caret-up",
					"id": 1370,
					"order": 1803,
					"prevSize": 32,
					"code": 61656,
					"tempChar": ""
				},
				{
					"id": 353,
					"order": 2568,
					"prevSize": 32,
					"code": 59736,
					"name": "carry",
					"tempChar": ""
				},
				{
					"id": 354,
					"order": 2569,
					"prevSize": 32,
					"code": 59737,
					"name": "carry2",
					"tempChar": ""
				},
				{
					"id": 976,
					"order": 2277,
					"prevSize": 32,
					"code": 60359,
					"name": "carry3",
					"tempChar": ""
				},
				{
					"order": 256,
					"prevSize": 32,
					"ligatures": "cart, purchase",
					"name": "cart",
					"id": 2067,
					"code": 60816,
					"tempChar": ""
				},
				{
					"order": 261,
					"prevSize": 32,
					"ligatures": "cart-add, cart6",
					"name": "cart-add",
					"id": 2072,
					"code": 60821,
					"tempChar": ""
				},
				{
					"order": 262,
					"prevSize": 32,
					"ligatures": "cart-add2, cart7",
					"name": "cart-add2",
					"id": 2073,
					"code": 60822,
					"tempChar": ""
				},
				{
					"name": "cart-arrow-down",
					"id": 1668,
					"order": 2101,
					"prevSize": 32,
					"code": 61976,
					"tempChar": ""
				},
				{
					"name": "cart-plus",
					"id": 1667,
					"order": 2100,
					"prevSize": 32,
					"code": 61975,
					"tempChar": ""
				},
				{
					"order": 263,
					"prevSize": 32,
					"ligatures": "cart-remove, cart8",
					"name": "cart-remove",
					"id": 2074,
					"code": 60823,
					"tempChar": ""
				},
				{
					"order": 257,
					"prevSize": 32,
					"ligatures": "cart2, purchase2",
					"name": "cart2",
					"id": 2068,
					"code": 60817,
					"tempChar": ""
				},
				{
					"order": 258,
					"prevSize": 32,
					"ligatures": "cart3, purchase3",
					"name": "cart3",
					"id": 2069,
					"code": 60818,
					"tempChar": ""
				},
				{
					"order": 259,
					"prevSize": 32,
					"ligatures": "cart4, purchase4",
					"name": "cart4",
					"id": 2070,
					"code": 60819,
					"tempChar": ""
				},
				{
					"order": 260,
					"prevSize": 32,
					"ligatures": "cart5, purchase5",
					"name": "cart5",
					"id": 2071,
					"code": 60820,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "cart, shop2",
					"order": 3206,
					"name": "cart6",
					"id": 141,
					"code": 59438,
					"tempChar": ""
				},
				{
					"order": 275,
					"prevSize": 32,
					"ligatures": "cash, money8",
					"name": "cash",
					"id": 2086,
					"code": 60835,
					"tempChar": ""
				},
				{
					"order": 276,
					"prevSize": 32,
					"ligatures": "cash2, money9",
					"name": "cash2",
					"id": 2087,
					"code": 60836,
					"tempChar": ""
				},
				{
					"order": 277,
					"prevSize": 32,
					"ligatures": "cash3, money10",
					"name": "cash3",
					"id": 2088,
					"code": 60837,
					"tempChar": ""
				},
				{
					"order": 278,
					"prevSize": 32,
					"ligatures": "cash4, money11",
					"name": "cash4",
					"id": 2089,
					"code": 60838,
					"tempChar": ""
				},
				{
					"order": 83,
					"prevSize": 32,
					"ligatures": "cassette, tape",
					"name": "cassette",
					"id": 1894,
					"code": 60643,
					"tempChar": ""
				},
				{
					"id": 977,
					"order": 2278,
					"prevSize": 32,
					"code": 60360,
					"name": "cast",
					"tempChar": ""
				},
				{
					"id": 355,
					"order": 2570,
					"prevSize": 32,
					"code": 59738,
					"name": "catch",
					"tempChar": ""
				},
				{
					"id": 356,
					"order": 2571,
					"prevSize": 32,
					"code": 59739,
					"name": "catch2",
					"tempChar": ""
				},
				{
					"order": 238,
					"prevSize": 32,
					"ligatures": "cc, creative-commons",
					"name": "cc",
					"id": 2049,
					"code": 60798,
					"tempChar": ""
				},
				{
					"name": "cc-amex",
					"id": 1633,
					"order": 2066,
					"prevSize": 32,
					"code": 61939,
					"tempChar": ""
				},
				{
					"name": "cc-diners-club",
					"id": 1715,
					"order": 2148,
					"prevSize": 32,
					"code": 62028,
					"tempChar": ""
				},
				{
					"name": "cc-discover",
					"id": 1632,
					"order": 2065,
					"prevSize": 32,
					"code": 61938,
					"tempChar": ""
				},
				{
					"name": "cc-jcb",
					"id": 1714,
					"order": 2147,
					"prevSize": 32,
					"code": 62027,
					"tempChar": ""
				},
				{
					"name": "cc-mastercard",
					"id": 1631,
					"order": 2064,
					"prevSize": 32,
					"code": 61937,
					"tempChar": ""
				},
				{
					"name": "cc-paypal",
					"id": 1634,
					"order": 2067,
					"prevSize": 32,
					"code": 61940,
					"tempChar": ""
				},
				{
					"name": "cc-stripe",
					"id": 1635,
					"order": 2068,
					"prevSize": 32,
					"code": 61941,
					"tempChar": ""
				},
				{
					"name": "cc-visa",
					"id": 1630,
					"order": 2063,
					"prevSize": 32,
					"code": 61936,
					"tempChar": ""
				},
				{
					"name": "cc2",
					"id": 1655,
					"order": 2088,
					"prevSize": 32,
					"code": 61962,
					"tempChar": ""
				},
				{
					"id": 357,
					"order": 2572,
					"prevSize": 32,
					"code": 59740,
					"name": "celebrate",
					"tempChar": ""
				},
				{
					"id": 358,
					"order": 2573,
					"prevSize": 32,
					"code": 59741,
					"name": "celebrate2",
					"tempChar": ""
				},
				{
					"id": 978,
					"order": 2279,
					"prevSize": 32,
					"code": 60361,
					"name": "celebrate3",
					"tempChar": ""
				},
				{
					"order": 237,
					"prevSize": 32,
					"ligatures": "certificate, license",
					"name": "certificate",
					"id": 2048,
					"code": 60797,
					"tempChar": ""
				},
				{
					"name": "certificate2",
					"id": 1332,
					"order": 1765,
					"prevSize": 32,
					"code": 61603,
					"tempChar": ""
				},
				{
					"name": "chain, link6",
					"id": 1348,
					"order": 1781,
					"prevSize": 32,
					"code": 61633,
					"tempChar": ""
				},
				{
					"name": "chain-broken, unlink6",
					"id": 1442,
					"order": 1875,
					"prevSize": 32,
					"code": 61735,
					"tempChar": ""
				},
				{
					"order": 993,
					"prevSize": 32,
					"ligatures": "chair",
					"name": "chair",
					"id": 2804,
					"code": 62187,
					"tempChar": ""
				},
				{
					"id": 359,
					"order": 2574,
					"prevSize": 32,
					"code": 59742,
					"name": "charge",
					"tempChar": ""
				},
				{
					"id": 360,
					"order": 2575,
					"prevSize": 32,
					"code": 59743,
					"name": "charge2",
					"tempChar": ""
				},
				{
					"id": 979,
					"order": 2280,
					"prevSize": 32,
					"code": 60362,
					"name": "charge3",
					"tempChar": ""
				},
				{
					"order": 657,
					"prevSize": 32,
					"ligatures": "chart, stats16",
					"name": "chart",
					"id": 2468,
					"code": 61217,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "chart-bars, chart2",
					"order": 3227,
					"name": "chart-bars",
					"id": 162,
					"code": 59459,
					"tempChar": ""
				},
				{
					"id": 361,
					"order": 2576,
					"prevSize": 32,
					"code": 59744,
					"name": "chart2",
					"tempChar": ""
				},
				{
					"id": 362,
					"order": 2577,
					"prevSize": 32,
					"code": 59745,
					"name": "chart3",
					"tempChar": ""
				},
				{
					"id": 980,
					"order": 2281,
					"prevSize": 32,
					"code": 60363,
					"name": "chart4",
					"tempChar": ""
				},
				{
					"id": 363,
					"order": 2578,
					"prevSize": 32,
					"code": 59746,
					"name": "chat",
					"tempChar": ""
				},
				{
					"id": 364,
					"order": 2579,
					"prevSize": 32,
					"code": 59747,
					"name": "chat2",
					"tempChar": ""
				},
				{
					"id": 981,
					"order": 2282,
					"prevSize": 32,
					"code": 60364,
					"name": "chat3",
					"tempChar": ""
				},
				{
					"name": "check",
					"id": 1191,
					"order": 1624,
					"prevSize": 32,
					"code": 61452,
					"tempChar": ""
				},
				{
					"name": "check-circle",
					"id": 1262,
					"order": 1695,
					"prevSize": 32,
					"code": 61528,
					"tempChar": ""
				},
				{
					"name": "check-circle-o",
					"id": 1267,
					"order": 1700,
					"prevSize": 32,
					"code": 61533,
					"tempChar": ""
				},
				{
					"name": "check-square",
					"id": 1475,
					"order": 1908,
					"prevSize": 32,
					"code": 61770,
					"tempChar": ""
				},
				{
					"name": "check-square-o",
					"id": 1245,
					"order": 1678,
					"prevSize": 32,
					"code": 61510,
					"tempChar": ""
				},
				{
					"order": 1384,
					"prevSize": 32,
					"ligatures": "checkbox-checked, checkbox",
					"name": "checkbox-checked",
					"id": 3195,
					"code": 62578,
					"tempChar": ""
				},
				{
					"order": 1392,
					"prevSize": 32,
					"ligatures": "checkbox-checked2, checkbox4",
					"name": "checkbox-checked2",
					"id": 3203,
					"code": 62586,
					"tempChar": ""
				},
				{
					"order": 1386,
					"prevSize": 32,
					"ligatures": "checkbox-partial, checkbox3",
					"name": "checkbox-partial",
					"id": 3197,
					"code": 62580,
					"tempChar": ""
				},
				{
					"order": 1394,
					"prevSize": 32,
					"ligatures": "checkbox-partial2, checkbox6",
					"name": "checkbox-partial2",
					"id": 3205,
					"code": 62588,
					"tempChar": ""
				},
				{
					"order": 1385,
					"prevSize": 32,
					"ligatures": "checkbox-unchecked, checkbox2",
					"name": "checkbox-unchecked",
					"id": 3196,
					"code": 62579,
					"tempChar": ""
				},
				{
					"order": 1393,
					"prevSize": 32,
					"ligatures": "checkbox-unchecked2, checkbox5",
					"name": "checkbox-unchecked2",
					"id": 3204,
					"code": 62587,
					"tempChar": ""
				},
				{
					"order": 1137,
					"prevSize": 32,
					"ligatures": "checkmark, tick",
					"name": "checkmark",
					"id": 2948,
					"code": 62331,
					"tempChar": ""
				},
				{
					"order": 1400,
					"prevSize": 32,
					"ligatures": "checkmark-circle",
					"name": "checkmark-circle",
					"id": 3211,
					"code": 62594,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "checkmark-circle, checkmark",
					"order": 3287,
					"name": "checkmark-circle2",
					"id": 222,
					"code": 59519,
					"tempChar": ""
				},
				{
					"order": 1138,
					"prevSize": 32,
					"ligatures": "checkmark2, tick2",
					"name": "checkmark2",
					"id": 2949,
					"code": 62332,
					"tempChar": ""
				},
				{
					"order": 1139,
					"prevSize": 32,
					"ligatures": "checkmark3, tick3",
					"name": "checkmark3",
					"id": 2950,
					"code": 62333,
					"tempChar": ""
				},
				{
					"order": 1140,
					"prevSize": 32,
					"ligatures": "checkmark4, tick4",
					"name": "checkmark4",
					"id": 2951,
					"code": 62334,
					"tempChar": ""
				},
				{
					"order": 1141,
					"prevSize": 32,
					"ligatures": "checkmark5, tick5",
					"name": "checkmark5",
					"id": 2952,
					"code": 62335,
					"tempChar": ""
				},
				{
					"order": 710,
					"prevSize": 32,
					"ligatures": "cheese, food9",
					"name": "cheese",
					"id": 2521,
					"code": 61270,
					"tempChar": ""
				},
				{
					"order": 723,
					"prevSize": 32,
					"ligatures": "cherry, fruit3",
					"name": "cherry",
					"id": 2534,
					"code": 61283,
					"tempChar": ""
				},
				{
					"order": 122,
					"prevSize": 32,
					"ligatures": "chess7, grid",
					"name": "chess",
					"id": 1933,
					"code": 60682,
					"tempChar": ""
				},
				{
					"order": 119,
					"prevSize": 32,
					"ligatures": "chess-bishop, chess4",
					"name": "chess-bishop",
					"id": 1930,
					"code": 60679,
					"tempChar": ""
				},
				{
					"order": 116,
					"prevSize": 32,
					"ligatures": "chess-king, chess",
					"name": "chess-king",
					"id": 1927,
					"code": 60676,
					"tempChar": ""
				},
				{
					"order": 120,
					"prevSize": 32,
					"ligatures": "chess-knight, chess5",
					"name": "chess-knight",
					"id": 1931,
					"code": 60680,
					"tempChar": ""
				},
				{
					"order": 121,
					"prevSize": 32,
					"ligatures": "chess-pawn, chess6",
					"name": "chess-pawn",
					"id": 1932,
					"code": 60681,
					"tempChar": ""
				},
				{
					"order": 117,
					"prevSize": 32,
					"ligatures": "chess-queen, chess2",
					"name": "chess-queen",
					"id": 1928,
					"code": 60677,
					"tempChar": ""
				},
				{
					"order": 118,
					"prevSize": 32,
					"ligatures": "chess-rook, chess3",
					"name": "chess-rook",
					"id": 1929,
					"code": 60678,
					"tempChar": ""
				},
				{
					"name": "chevron-circle-down",
					"id": 1460,
					"order": 1893,
					"prevSize": 32,
					"code": 61754,
					"tempChar": ""
				},
				{
					"name": "chevron-circle-left",
					"id": 1457,
					"order": 1890,
					"prevSize": 32,
					"code": 61751,
					"tempChar": ""
				},
				{
					"name": "chevron-circle-right",
					"id": 1458,
					"order": 1891,
					"prevSize": 32,
					"code": 61752,
					"tempChar": ""
				},
				{
					"name": "chevron-circle-up",
					"id": 1459,
					"order": 1892,
					"prevSize": 32,
					"code": 61753,
					"tempChar": ""
				},
				{
					"name": "chevron-down",
					"id": 1292,
					"order": 1725,
					"prevSize": 32,
					"code": 61560,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "chevron-down-circle, down6",
					"order": 3296,
					"name": "chevron-down-circle",
					"id": 231,
					"code": 59528,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "chevron-down, down3",
					"order": 3276,
					"name": "chevron-down2",
					"id": 211,
					"code": 59508,
					"tempChar": ""
				},
				{
					"name": "chevron-left",
					"id": 1257,
					"order": 1690,
					"prevSize": 32,
					"code": 61523,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "chevron-left-circle, left4",
					"order": 3297,
					"name": "chevron-left-circle",
					"id": 232,
					"code": 59529,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "chevron-left, left",
					"order": 3277,
					"name": "chevron-left2",
					"id": 212,
					"code": 59509,
					"tempChar": ""
				},
				{
					"name": "chevron-right",
					"id": 1258,
					"order": 1691,
					"prevSize": 32,
					"code": 61524,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "chevron-right-circle, right4",
					"order": 3298,
					"name": "chevron-right-circle",
					"id": 233,
					"code": 59530,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "chevron-right, right",
					"order": 3278,
					"name": "chevron-right2",
					"id": 213,
					"code": 59510,
					"tempChar": ""
				},
				{
					"name": "chevron-up",
					"id": 1291,
					"order": 1724,
					"prevSize": 32,
					"code": 61559,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "chevron-up-circle, up6",
					"order": 3295,
					"name": "chevron-up-circle",
					"id": 230,
					"code": 59527,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "chevron-up, up3",
					"order": 3275,
					"name": "chevron-up2",
					"id": 210,
					"code": 59507,
					"tempChar": ""
				},
				{
					"order": 707,
					"prevSize": 32,
					"ligatures": "chicken, food6",
					"name": "chicken",
					"id": 2518,
					"code": 61267,
					"tempChar": ""
				},
				{
					"name": "child",
					"id": 1569,
					"order": 2002,
					"prevSize": 32,
					"code": 61870,
					"tempChar": ""
				},
				{
					"order": 284,
					"prevSize": 32,
					"ligatures": "chip, cpu",
					"name": "chip",
					"id": 2095,
					"code": 60844,
					"tempChar": ""
				},
				{
					"id": 365,
					"order": 2580,
					"prevSize": 32,
					"code": 59748,
					"name": "chop",
					"tempChar": ""
				},
				{
					"id": 366,
					"order": 2581,
					"prevSize": 32,
					"code": 59749,
					"name": "chop2",
					"tempChar": ""
				},
				{
					"id": 982,
					"order": 2283,
					"prevSize": 32,
					"code": 60365,
					"name": "chop3",
					"tempChar": ""
				},
				{
					"order": 792,
					"prevSize": 32,
					"ligatures": "chopper, travel12",
					"name": "chopper",
					"id": 2603,
					"code": 61352,
					"tempChar": ""
				},
				{
					"order": 793,
					"prevSize": 32,
					"ligatures": "chopper2, travel13",
					"name": "chopper2",
					"id": 2604,
					"code": 61353,
					"tempChar": ""
				},
				{
					"order": 1594,
					"prevSize": 32,
					"ligatures": "chrome, browser",
					"name": "chrome",
					"id": 3405,
					"code": 62788,
					"tempChar": ""
				},
				{
					"name": "chrome2",
					"id": 1741,
					"order": 2174,
					"prevSize": 32,
					"code": 62056,
					"tempChar": ""
				},
				{
					"order": 1401,
					"prevSize": 32,
					"ligatures": "circle",
					"name": "circle",
					"id": 3212,
					"code": 62595,
					"tempChar": ""
				},
				{
					"order": 1493,
					"prevSize": 32,
					"ligatures": "circle-code, out5",
					"name": "circle-code",
					"id": 3304,
					"code": 62687,
					"tempChar": ""
				},
				{
					"order": 1492,
					"prevSize": 32,
					"ligatures": "circle-css, code6",
					"name": "circle-css",
					"id": 3303,
					"code": 62686,
					"tempChar": ""
				},
				{
					"order": 1255,
					"prevSize": 32,
					"ligatures": "circle-down, down9",
					"name": "circle-down",
					"id": 3066,
					"code": 62449,
					"tempChar": ""
				},
				{
					"order": 1267,
					"prevSize": 32,
					"ligatures": "circle-down-left, down-left4",
					"name": "circle-down-left",
					"id": 3078,
					"code": 62461,
					"tempChar": ""
				},
				{
					"order": 1275,
					"prevSize": 32,
					"ligatures": "circle-down-left2, down-left5",
					"name": "circle-down-left2",
					"id": 3086,
					"code": 62469,
					"tempChar": ""
				},
				{
					"order": 1265,
					"prevSize": 32,
					"ligatures": "circle-down-right, down-right4",
					"name": "circle-down-right",
					"id": 3076,
					"code": 62459,
					"tempChar": ""
				},
				{
					"order": 1273,
					"prevSize": 32,
					"ligatures": "circle-down-right2, down-right5",
					"name": "circle-down-right2",
					"id": 3084,
					"code": 62467,
					"tempChar": ""
				},
				{
					"order": 1259,
					"prevSize": 32,
					"ligatures": "circle-down2, down10",
					"name": "circle-down2",
					"id": 3070,
					"code": 62453,
					"tempChar": ""
				},
				{
					"order": 1266,
					"prevSize": 32,
					"ligatures": "circle-down3, down11",
					"name": "circle-down3",
					"id": 3077,
					"code": 62460,
					"tempChar": ""
				},
				{
					"order": 1274,
					"prevSize": 32,
					"ligatures": "circle-down4, down12",
					"name": "circle-down4",
					"id": 3085,
					"code": 62468,
					"tempChar": ""
				},
				{
					"order": 1327,
					"prevSize": 32,
					"ligatures": "circle-down5, down20",
					"name": "circle-down5",
					"id": 3138,
					"code": 62521,
					"tempChar": ""
				},
				{
					"order": 1331,
					"prevSize": 32,
					"ligatures": "circle-down6, down21",
					"name": "circle-down6",
					"id": 3142,
					"code": 62525,
					"tempChar": ""
				},
				{
					"order": 1256,
					"prevSize": 32,
					"ligatures": "circle-left, left12",
					"name": "circle-left",
					"id": 3067,
					"code": 62450,
					"tempChar": ""
				},
				{
					"order": 1260,
					"prevSize": 32,
					"ligatures": "circle-left2, left13",
					"name": "circle-left2",
					"id": 3071,
					"code": 62454,
					"tempChar": ""
				},
				{
					"order": 1268,
					"prevSize": 32,
					"ligatures": "circle-left3, left14",
					"name": "circle-left3",
					"id": 3079,
					"code": 62462,
					"tempChar": ""
				},
				{
					"order": 1276,
					"prevSize": 32,
					"ligatures": "circle-left4, left15",
					"name": "circle-left4",
					"id": 3087,
					"code": 62470,
					"tempChar": ""
				},
				{
					"order": 1328,
					"prevSize": 32,
					"ligatures": "circle-left5, left23",
					"name": "circle-left5",
					"id": 3139,
					"code": 62522,
					"tempChar": ""
				},
				{
					"order": 1332,
					"prevSize": 32,
					"ligatures": "circle-left6, left24",
					"name": "circle-left6",
					"id": 3143,
					"code": 62526,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "circle-minus, minus",
					"order": 3290,
					"name": "circle-minus",
					"id": 225,
					"code": 59522,
					"tempChar": ""
				},
				{
					"name": "circle-o",
					"id": 1419,
					"order": 1852,
					"prevSize": 32,
					"code": 61708,
					"tempChar": ""
				},
				{
					"name": "circle-o-notch",
					"id": 1599,
					"order": 2032,
					"prevSize": 32,
					"code": 61902,
					"tempChar": ""
				},
				{
					"order": 1254,
					"prevSize": 32,
					"ligatures": "circle-right, right11",
					"name": "circle-right",
					"id": 3065,
					"code": 62448,
					"tempChar": ""
				},
				{
					"order": 1258,
					"prevSize": 32,
					"ligatures": "circle-right2, right12",
					"name": "circle-right2",
					"id": 3069,
					"code": 62452,
					"tempChar": ""
				},
				{
					"order": 1264,
					"prevSize": 32,
					"ligatures": "circle-right3, right13",
					"name": "circle-right3",
					"id": 3075,
					"code": 62458,
					"tempChar": ""
				},
				{
					"order": 1272,
					"prevSize": 32,
					"ligatures": "circle-right4, right14",
					"name": "circle-right4",
					"id": 3083,
					"code": 62466,
					"tempChar": ""
				},
				{
					"order": 1326,
					"prevSize": 32,
					"ligatures": "circle-right5, right22",
					"name": "circle-right5",
					"id": 3137,
					"code": 62520,
					"tempChar": ""
				},
				{
					"order": 1330,
					"prevSize": 32,
					"ligatures": "circle-right6, right23",
					"name": "circle-right6",
					"id": 3141,
					"code": 62524,
					"tempChar": ""
				},
				{
					"order": 877,
					"prevSize": 32,
					"ligatures": "circle-small",
					"name": "circle-small",
					"id": 2688,
					"code": 61437,
					"tempChar": ""
				},
				{
					"name": "circle-thin",
					"id": 1611,
					"order": 2044,
					"prevSize": 32,
					"code": 61915,
					"tempChar": ""
				},
				{
					"order": 1253,
					"prevSize": 32,
					"ligatures": "circle-up, up9",
					"name": "circle-up",
					"id": 3064,
					"code": 62447,
					"tempChar": ""
				},
				{
					"order": 1261,
					"prevSize": 32,
					"ligatures": "circle-up-left, up-left4",
					"name": "circle-up-left",
					"id": 3072,
					"code": 62455,
					"tempChar": ""
				},
				{
					"order": 1269,
					"prevSize": 32,
					"ligatures": "circle-up-left2, up-left5",
					"name": "circle-up-left2",
					"id": 3080,
					"code": 62463,
					"tempChar": ""
				},
				{
					"order": 1263,
					"prevSize": 32,
					"ligatures": "circle-up-right, up-right4",
					"name": "circle-up-right",
					"id": 3074,
					"code": 62457,
					"tempChar": ""
				},
				{
					"order": 1271,
					"prevSize": 32,
					"ligatures": "circle-up-right2, up-right5",
					"name": "circle-up-right2",
					"id": 3082,
					"code": 62465,
					"tempChar": ""
				},
				{
					"order": 1257,
					"prevSize": 32,
					"ligatures": "circle-up2, up10",
					"name": "circle-up2",
					"id": 3068,
					"code": 62451,
					"tempChar": ""
				},
				{
					"order": 1262,
					"prevSize": 32,
					"ligatures": "circle-up3, up11",
					"name": "circle-up3",
					"id": 3073,
					"code": 62456,
					"tempChar": ""
				},
				{
					"order": 1270,
					"prevSize": 32,
					"ligatures": "circle-up4, up12",
					"name": "circle-up4",
					"id": 3081,
					"code": 62464,
					"tempChar": ""
				},
				{
					"order": 1325,
					"prevSize": 32,
					"ligatures": "circle-up5, up20",
					"name": "circle-up5",
					"id": 3136,
					"code": 62519,
					"tempChar": ""
				},
				{
					"order": 1329,
					"prevSize": 32,
					"ligatures": "circle-up6, up21",
					"name": "circle-up6",
					"id": 3140,
					"code": 62523,
					"tempChar": ""
				},
				{
					"order": 1402,
					"prevSize": 32,
					"ligatures": "circle2",
					"name": "circle2",
					"id": 3213,
					"code": 62596,
					"tempChar": ""
				},
				{
					"name": "circle3",
					"id": 1423,
					"order": 1856,
					"prevSize": 32,
					"code": 61713,
					"tempChar": ""
				},
				{
					"order": 1403,
					"prevSize": 32,
					"ligatures": "circles, record",
					"name": "circles",
					"id": 3214,
					"code": 62597,
					"tempChar": ""
				},
				{
					"order": 1404,
					"prevSize": 32,
					"ligatures": "circles2, record2",
					"name": "circles2",
					"id": 3215,
					"code": 62598,
					"tempChar": ""
				},
				{
					"order": 12,
					"prevSize": 32,
					"ligatures": "city, buildings2",
					"name": "city",
					"id": 1823,
					"code": 60572,
					"tempChar": ""
				},
				{
					"order": 92,
					"prevSize": 32,
					"ligatures": "clapboard, video4",
					"name": "clapboard",
					"id": 1903,
					"code": 60652,
					"tempChar": ""
				},
				{
					"order": 91,
					"prevSize": 32,
					"ligatures": "clapboard-play, video3",
					"name": "clapboard-play",
					"id": 1902,
					"code": 60651,
					"tempChar": ""
				},
				{
					"id": 367,
					"order": 2582,
					"prevSize": 32,
					"code": 59750,
					"name": "clean",
					"tempChar": ""
				},
				{
					"id": 368,
					"order": 2583,
					"prevSize": 32,
					"code": 59751,
					"name": "clean2",
					"tempChar": ""
				},
				{
					"id": 983,
					"order": 2284,
					"prevSize": 32,
					"code": 60366,
					"name": "clean3",
					"tempChar": ""
				},
				{
					"id": 369,
					"order": 2584,
					"prevSize": 32,
					"code": 59752,
					"name": "cleanse",
					"tempChar": ""
				},
				{
					"id": 370,
					"order": 2585,
					"prevSize": 32,
					"code": 59753,
					"name": "cleanse2",
					"tempChar": ""
				},
				{
					"id": 984,
					"order": 2285,
					"prevSize": 32,
					"code": 60367,
					"name": "cleanse3",
					"tempChar": ""
				},
				{
					"order": 1455,
					"prevSize": 32,
					"ligatures": "clear-formatting, wysiwyg27",
					"name": "clear-formatting",
					"id": 3266,
					"code": 62649,
					"tempChar": ""
				},
				{
					"id": 371,
					"order": 2586,
					"prevSize": 32,
					"code": 59754,
					"name": "climb",
					"tempChar": ""
				},
				{
					"id": 372,
					"order": 2587,
					"prevSize": 32,
					"code": 59755,
					"name": "climb2",
					"tempChar": ""
				},
				{
					"id": 985,
					"order": 2286,
					"prevSize": 32,
					"code": 60368,
					"name": "climb3",
					"tempChar": ""
				},
				{
					"order": 850,
					"prevSize": 32,
					"ligatures": "clipboard, board",
					"name": "clipboard",
					"id": 2661,
					"code": 61410,
					"tempChar": ""
				},
				{
					"order": 851,
					"prevSize": 32,
					"ligatures": "clipboard2, board2",
					"name": "clipboard2",
					"id": 2662,
					"code": 61411,
					"tempChar": ""
				},
				{
					"order": 852,
					"prevSize": 32,
					"ligatures": "clipboard3, board3",
					"name": "clipboard3",
					"id": 2663,
					"code": 61412,
					"tempChar": ""
				},
				{
					"order": 853,
					"prevSize": 32,
					"ligatures": "clipboard4, board4",
					"name": "clipboard4",
					"id": 2664,
					"code": 61413,
					"tempChar": ""
				},
				{
					"order": 854,
					"prevSize": 32,
					"ligatures": "clipboard5, board5",
					"name": "clipboard5",
					"id": 2665,
					"code": 61414,
					"tempChar": ""
				},
				{
					"order": 855,
					"prevSize": 32,
					"ligatures": "clipboard6, board6",
					"name": "clipboard6",
					"id": 2666,
					"code": 61415,
					"tempChar": ""
				},
				{
					"name": "clipboard7, paste5",
					"id": 1387,
					"order": 1820,
					"prevSize": 32,
					"code": 61674,
					"tempChar": ""
				},
				{
					"order": 335,
					"prevSize": 32,
					"ligatures": "clock, time2",
					"name": "clock",
					"id": 2146,
					"code": 60895,
					"tempChar": ""
				},
				{
					"name": "clock-o",
					"id": 1201,
					"order": 1634,
					"prevSize": 32,
					"code": 61463,
					"tempChar": ""
				},
				{
					"order": 336,
					"prevSize": 32,
					"ligatures": "clock2, time3",
					"name": "clock2",
					"id": 2147,
					"code": 60896,
					"tempChar": ""
				},
				{
					"order": 337,
					"prevSize": 32,
					"ligatures": "clock3, time4",
					"name": "clock3",
					"id": 2148,
					"code": 60897,
					"tempChar": ""
				},
				{
					"order": 338,
					"prevSize": 32,
					"ligatures": "clock4, time5",
					"name": "clock4",
					"id": 2149,
					"code": 60898,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "clock, time",
					"order": 3260,
					"name": "clock5",
					"id": 195,
					"code": 59492,
					"tempChar": ""
				},
				{
					"name": "clone",
					"id": 1716,
					"order": 2149,
					"prevSize": 32,
					"code": 62029,
					"tempChar": ""
				},
				{
					"id": 373,
					"order": 2588,
					"prevSize": 32,
					"code": 59756,
					"name": "clone2",
					"tempChar": ""
				},
				{
					"id": 374,
					"order": 2589,
					"prevSize": 32,
					"code": 59757,
					"name": "clone3",
					"tempChar": ""
				},
				{
					"name": "close, remove, times",
					"id": 1192,
					"order": 1625,
					"prevSize": 32,
					"code": 61453,
					"tempChar": ""
				},
				{
					"id": 375,
					"order": 2590,
					"prevSize": 32,
					"code": 59758,
					"name": "close2",
					"tempChar": ""
				},
				{
					"id": 376,
					"order": 2591,
					"prevSize": 32,
					"code": 59759,
					"name": "close3",
					"tempChar": ""
				},
				{
					"id": 986,
					"order": 2287,
					"prevSize": 32,
					"code": 60369,
					"name": "close4",
					"tempChar": ""
				},
				{
					"order": 887,
					"prevSize": 32,
					"ligatures": "cloud, weather",
					"name": "cloud",
					"id": 2698,
					"code": 61567,
					"tempChar": ""
				},
				{
					"order": 890,
					"prevSize": 32,
					"ligatures": "cloud-check, cloud4",
					"name": "cloud-check",
					"id": 2701,
					"code": 61615,
					"tempChar": ""
				},
				{
					"order": 894,
					"prevSize": 32,
					"ligatures": "cloud-check2, cloud8",
					"name": "cloud-check2",
					"id": 2705,
					"code": 61622,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "cloud-check, cloud5",
					"order": 3173,
					"name": "cloud-check3",
					"id": 108,
					"code": 59405,
					"tempChar": ""
				},
				{
					"order": 888,
					"prevSize": 32,
					"ligatures": "cloud-download, cloud2",
					"name": "cloud-download",
					"id": 2699,
					"code": 61583,
					"tempChar": ""
				},
				{
					"order": 892,
					"prevSize": 32,
					"ligatures": "cloud-download2, cloud6",
					"name": "cloud-download2",
					"id": 2703,
					"code": 61620,
					"tempChar": ""
				},
				{
					"name": "cloud-download3",
					"id": 1390,
					"order": 1823,
					"prevSize": 32,
					"code": 61677,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "cloud-download, cloud3",
					"order": 3171,
					"name": "cloud-download4",
					"id": 106,
					"code": 59403,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "cloud-sync, cloud4",
					"order": 3172,
					"name": "cloud-sync",
					"id": 107,
					"code": 59404,
					"tempChar": ""
				},
				{
					"order": 889,
					"prevSize": 32,
					"ligatures": "cloud-upload, cloud3",
					"name": "cloud-upload",
					"id": 2700,
					"code": 61599,
					"tempChar": ""
				},
				{
					"order": 893,
					"prevSize": 32,
					"ligatures": "cloud-upload2, cloud7",
					"name": "cloud-upload2",
					"id": 2704,
					"code": 61621,
					"tempChar": ""
				},
				{
					"name": "cloud-upload3",
					"id": 1391,
					"order": 1824,
					"prevSize": 32,
					"code": 61678,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "cloud-upload, cloud2",
					"order": 3170,
					"name": "cloud-upload4",
					"id": 105,
					"code": 59402,
					"tempChar": ""
				},
				{
					"order": 891,
					"prevSize": 32,
					"ligatures": "cloud5, weather2",
					"name": "cloud2",
					"id": 2702,
					"code": 61619,
					"tempChar": ""
				},
				{
					"name": "cloud3",
					"id": 1349,
					"order": 1782,
					"prevSize": 32,
					"code": 61634,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "cloud, weather",
					"order": 3169,
					"name": "cloud4",
					"id": 104,
					"code": 59401,
					"tempChar": ""
				},
				{
					"order": 114,
					"prevSize": 32,
					"ligatures": "clubs, cards2",
					"name": "clubs",
					"id": 1925,
					"code": 60674,
					"tempChar": ""
				},
				{
					"id": 377,
					"order": 2592,
					"prevSize": 32,
					"code": 59760,
					"name": "clutch",
					"tempChar": ""
				},
				{
					"id": 378,
					"order": 2593,
					"prevSize": 32,
					"code": 59761,
					"name": "clutch2",
					"tempChar": ""
				},
				{
					"name": "cny, jpy, rmb, yen",
					"id": 1487,
					"order": 1920,
					"prevSize": 32,
					"code": 61783,
					"tempChar": ""
				},
				{
					"order": 1491,
					"prevSize": 32,
					"ligatures": "code5, semicolon",
					"name": "code",
					"id": 3302,
					"code": 62685,
					"tempChar": ""
				},
				{
					"name": "code-fork",
					"id": 1441,
					"order": 1874,
					"prevSize": 32,
					"code": 61734,
					"tempChar": ""
				},
				{
					"name": "code2",
					"id": 1436,
					"order": 1869,
					"prevSize": 32,
					"code": 61729,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "code, embed",
					"order": 3266,
					"name": "code3",
					"id": 201,
					"code": 59498,
					"tempChar": ""
				},
				{
					"id": 379,
					"order": 2594,
					"prevSize": 32,
					"code": 59762,
					"name": "code4",
					"tempChar": ""
				},
				{
					"id": 380,
					"order": 2595,
					"prevSize": 32,
					"code": 59763,
					"name": "code5",
					"tempChar": ""
				},
				{
					"order": 1609,
					"prevSize": 32,
					"ligatures": "codepen, brand81",
					"name": "codepen",
					"id": 3420,
					"code": 62803,
					"tempChar": ""
				},
				{
					"name": "codepen2",
					"id": 1596,
					"order": 2029,
					"prevSize": 32,
					"code": 61899,
					"tempChar": ""
				},
				{
					"name": "codiepie",
					"id": 1767,
					"order": 2200,
					"prevSize": 32,
					"code": 62084,
					"tempChar": ""
				},
				{
					"order": 717,
					"prevSize": 32,
					"ligatures": "coffee2, drink13",
					"name": "coffee",
					"id": 2528,
					"code": 61277,
					"tempChar": ""
				},
				{
					"order": 716,
					"prevSize": 32,
					"ligatures": "coffee-bean, coffee",
					"name": "coffee-bean",
					"id": 2527,
					"code": 61276,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "coffee-cup, drink",
					"order": 3232,
					"name": "coffee-cup",
					"id": 167,
					"code": 59464,
					"tempChar": ""
				},
				{
					"name": "coffee2",
					"id": 1396,
					"order": 1829,
					"prevSize": 32,
					"code": 61684,
					"tempChar": ""
				},
				{
					"order": 609,
					"prevSize": 32,
					"ligatures": "cog, gear",
					"name": "cog",
					"id": 2420,
					"code": 61169,
					"tempChar": ""
				},
				{
					"order": 611,
					"prevSize": 32,
					"ligatures": "cog2, gear2",
					"name": "cog2",
					"id": 2422,
					"code": 61171,
					"tempChar": ""
				},
				{
					"order": 612,
					"prevSize": 32,
					"ligatures": "cog3, gear3",
					"name": "cog3",
					"id": 2423,
					"code": 61172,
					"tempChar": ""
				},
				{
					"order": 613,
					"prevSize": 32,
					"ligatures": "cog4, gear4",
					"name": "cog4",
					"id": 2424,
					"code": 61173,
					"tempChar": ""
				},
				{
					"order": 614,
					"prevSize": 32,
					"ligatures": "cog5, gear5",
					"name": "cog5",
					"id": 2425,
					"code": 61174,
					"tempChar": ""
				},
				{
					"order": 615,
					"prevSize": 32,
					"ligatures": "cog6, gear6",
					"name": "cog6",
					"id": 2426,
					"code": 61175,
					"tempChar": ""
				},
				{
					"order": 616,
					"prevSize": 32,
					"ligatures": "cog7, gear7",
					"name": "cog7",
					"id": 2427,
					"code": 61176,
					"tempChar": ""
				},
				{
					"name": "cog8, gear",
					"id": 1197,
					"order": 1630,
					"prevSize": 32,
					"code": 61459,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "cog, gear",
					"order": 3176,
					"name": "cog9",
					"id": 111,
					"code": 59408,
					"tempChar": ""
				},
				{
					"order": 610,
					"prevSize": 32,
					"ligatures": "cogs, gears",
					"name": "cogs",
					"id": 2421,
					"code": 61170,
					"tempChar": ""
				},
				{
					"name": "cogs2, gears",
					"id": 1304,
					"order": 1737,
					"prevSize": 32,
					"code": 61573,
					"tempChar": ""
				},
				{
					"order": 269,
					"prevSize": 32,
					"ligatures": "coin-dollar, money2",
					"name": "coin-dollar",
					"id": 2080,
					"code": 60829,
					"tempChar": ""
				},
				{
					"order": 270,
					"prevSize": 32,
					"ligatures": "coin-euro, money3",
					"name": "coin-euro",
					"id": 2081,
					"code": 60830,
					"tempChar": ""
				},
				{
					"order": 271,
					"prevSize": 32,
					"ligatures": "coin-pound, money4",
					"name": "coin-pound",
					"id": 2082,
					"code": 60831,
					"tempChar": ""
				},
				{
					"order": 272,
					"prevSize": 32,
					"ligatures": "coin-yen, money5",
					"name": "coin-yen",
					"id": 2083,
					"code": 60832,
					"tempChar": ""
				},
				{
					"order": 268,
					"prevSize": 32,
					"ligatures": "coins, money",
					"name": "coins",
					"id": 2079,
					"code": 60828,
					"tempChar": ""
				},
				{
					"id": 381,
					"order": 2596,
					"prevSize": 32,
					"code": 59764,
					"name": "collaborate",
					"tempChar": ""
				},
				{
					"id": 382,
					"order": 2597,
					"prevSize": 32,
					"code": 59765,
					"name": "collaborate2",
					"tempChar": ""
				},
				{
					"order": 530,
					"prevSize": 32,
					"ligatures": "collaboration, group6",
					"name": "collaboration",
					"id": 2341,
					"code": 61090,
					"tempChar": ""
				},
				{
					"id": 383,
					"order": 2598,
					"prevSize": 32,
					"code": 59766,
					"name": "collect",
					"tempChar": ""
				},
				{
					"id": 384,
					"order": 2599,
					"prevSize": 32,
					"code": 59767,
					"name": "collect2",
					"tempChar": ""
				},
				{
					"order": 57,
					"prevSize": 32,
					"ligatures": "color-clear, droplet4",
					"name": "color-clear",
					"id": 1868,
					"code": 60617,
					"tempChar": ""
				},
				{
					"order": 46,
					"prevSize": 32,
					"ligatures": "color-sampler, colors",
					"name": "color-sampler",
					"id": 1857,
					"code": 60606,
					"tempChar": ""
				},
				{
					"name": "columns",
					"id": 1373,
					"order": 1806,
					"prevSize": 32,
					"code": 61659,
					"tempChar": ""
				},
				{
					"order": 1418,
					"prevSize": 32,
					"ligatures": "comb",
					"name": "comb",
					"id": 3229,
					"code": 62612,
					"tempChar": ""
				},
				{
					"order": 1380,
					"prevSize": 32,
					"ligatures": "command, cmd",
					"name": "command",
					"id": 3191,
					"code": 62574,
					"tempChar": ""
				},
				{
					"name": "comment",
					"id": 1289,
					"order": 1722,
					"prevSize": 32,
					"code": 61557,
					"tempChar": ""
				},
				{
					"name": "comment-o",
					"id": 1382,
					"order": 1815,
					"prevSize": 32,
					"code": 61669,
					"tempChar": ""
				},
				{
					"name": "commenting",
					"id": 1758,
					"order": 2191,
					"prevSize": 32,
					"code": 62074,
					"tempChar": ""
				},
				{
					"name": "commenting-o",
					"id": 1759,
					"order": 2192,
					"prevSize": 32,
					"code": 62075,
					"tempChar": ""
				},
				{
					"name": "comments",
					"id": 1305,
					"order": 1738,
					"prevSize": 32,
					"code": 61574,
					"tempChar": ""
				},
				{
					"name": "comments-o",
					"id": 1383,
					"order": 1816,
					"prevSize": 32,
					"code": 61670,
					"tempChar": ""
				},
				{
					"id": 385,
					"order": 2600,
					"prevSize": 32,
					"code": 59768,
					"name": "commit",
					"tempChar": ""
				},
				{
					"id": 386,
					"order": 2601,
					"prevSize": 32,
					"code": 59769,
					"name": "commit2",
					"tempChar": ""
				},
				{
					"id": 987,
					"order": 2288,
					"prevSize": 32,
					"code": 60370,
					"name": "compare",
					"tempChar": ""
				},
				{
					"order": 321,
					"prevSize": 32,
					"ligatures": "compass, direction",
					"name": "compass",
					"id": 2132,
					"code": 60881,
					"tempChar": ""
				},
				{
					"order": 322,
					"prevSize": 32,
					"ligatures": "compass2, direction2",
					"name": "compass2",
					"id": 2133,
					"code": 60882,
					"tempChar": ""
				},
				{
					"order": 323,
					"prevSize": 32,
					"ligatures": "compass3, direction3",
					"name": "compass3",
					"id": 2134,
					"code": 60883,
					"tempChar": ""
				},
				{
					"order": 324,
					"prevSize": 32,
					"ligatures": "compass4, direction4",
					"name": "compass4",
					"id": 2135,
					"code": 60884,
					"tempChar": ""
				},
				{
					"order": 325,
					"prevSize": 32,
					"ligatures": "compass5, direction5",
					"name": "compass5",
					"id": 2136,
					"code": 60885,
					"tempChar": ""
				},
				{
					"order": 326,
					"prevSize": 32,
					"ligatures": "compass6, direction6",
					"name": "compass6",
					"id": 2137,
					"code": 60886,
					"tempChar": ""
				},
				{
					"name": "compass7",
					"id": 1479,
					"order": 1912,
					"prevSize": 32,
					"code": 61774,
					"tempChar": ""
				},
				{
					"name": "compress",
					"id": 1275,
					"order": 1708,
					"prevSize": 32,
					"code": 61542,
					"tempChar": ""
				},
				{
					"order": 1050,
					"prevSize": 32,
					"ligatures": "confused, emoticon23",
					"name": "confused",
					"id": 2861,
					"code": 62244,
					"tempChar": ""
				},
				{
					"order": 1051,
					"prevSize": 32,
					"ligatures": "confused2, emoticon24",
					"name": "confused2",
					"id": 2862,
					"code": 62245,
					"tempChar": ""
				},
				{
					"id": 387,
					"order": 2602,
					"prevSize": 32,
					"code": 59770,
					"name": "connect",
					"tempChar": ""
				},
				{
					"id": 388,
					"order": 2603,
					"prevSize": 32,
					"code": 59771,
					"name": "connect2",
					"tempChar": ""
				},
				{
					"id": 988,
					"order": 2289,
					"prevSize": 32,
					"code": 60371,
					"name": "connect3",
					"tempChar": ""
				},
				{
					"name": "connectdevelop",
					"id": 1659,
					"order": 2092,
					"prevSize": 32,
					"code": 61966,
					"tempChar": ""
				},
				{
					"order": 126,
					"prevSize": 32,
					"ligatures": "connection, wifi",
					"name": "connection",
					"id": 1937,
					"code": 60686,
					"tempChar": ""
				},
				{
					"order": 127,
					"prevSize": 32,
					"ligatures": "connection2, wifi2",
					"name": "connection2",
					"id": 1938,
					"code": 60687,
					"tempChar": ""
				},
				{
					"order": 128,
					"prevSize": 32,
					"ligatures": "connection3, wifi3",
					"name": "connection3",
					"id": 1939,
					"code": 60688,
					"tempChar": ""
				},
				{
					"order": 129,
					"prevSize": 32,
					"ligatures": "connection4, wifi4",
					"name": "connection4",
					"id": 1940,
					"code": 60689,
					"tempChar": ""
				},
				{
					"order": 639,
					"prevSize": 32,
					"ligatures": "construction, maintenance",
					"name": "construction",
					"id": 2450,
					"code": 61199,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "construction, road-sign",
					"order": 3225,
					"name": "construction2",
					"id": 160,
					"code": 59457,
					"tempChar": ""
				},
				{
					"id": 389,
					"order": 2604,
					"prevSize": 32,
					"code": 59772,
					"name": "contact",
					"tempChar": ""
				},
				{
					"id": 390,
					"order": 2605,
					"prevSize": 32,
					"code": 59773,
					"name": "contact2",
					"tempChar": ""
				},
				{
					"id": 989,
					"order": 2290,
					"prevSize": 32,
					"code": 60372,
					"name": "contact3",
					"tempChar": ""
				},
				{
					"id": 391,
					"order": 2606,
					"prevSize": 32,
					"code": 59774,
					"name": "contain",
					"tempChar": ""
				},
				{
					"id": 392,
					"order": 2607,
					"prevSize": 32,
					"code": 59775,
					"name": "contain2",
					"tempChar": ""
				},
				{
					"name": "contao",
					"id": 1746,
					"order": 2179,
					"prevSize": 32,
					"code": 62061,
					"tempChar": ""
				},
				{
					"order": 985,
					"prevSize": 32,
					"ligatures": "contrast",
					"name": "contrast",
					"id": 2796,
					"code": 62179,
					"tempChar": ""
				},
				{
					"id": 393,
					"order": 2608,
					"prevSize": 32,
					"code": 59776,
					"name": "contribute",
					"tempChar": ""
				},
				{
					"id": 394,
					"order": 2609,
					"prevSize": 32,
					"code": 59777,
					"name": "contribute2",
					"tempChar": ""
				},
				{
					"id": 395,
					"order": 2610,
					"prevSize": 32,
					"code": 59778,
					"name": "control",
					"tempChar": ""
				},
				{
					"id": 396,
					"order": 2611,
					"prevSize": 32,
					"code": 59779,
					"name": "control2",
					"tempChar": ""
				},
				{
					"order": 703,
					"prevSize": 32,
					"ligatures": "cook, chef",
					"name": "cook",
					"id": 2514,
					"code": 61263,
					"tempChar": ""
				},
				{
					"id": 397,
					"order": 2612,
					"prevSize": 32,
					"code": 59780,
					"name": "cook2",
					"tempChar": ""
				},
				{
					"id": 398,
					"order": 2613,
					"prevSize": 32,
					"code": 59781,
					"name": "cook3",
					"tempChar": ""
				},
				{
					"id": 990,
					"order": 2291,
					"prevSize": 32,
					"code": 60373,
					"name": "cook4",
					"tempChar": ""
				},
				{
					"order": 1040,
					"prevSize": 32,
					"ligatures": "cool, emoticon13",
					"name": "cool",
					"id": 2851,
					"code": 62234,
					"tempChar": ""
				},
				{
					"order": 1041,
					"prevSize": 32,
					"ligatures": "cool2, emoticon14",
					"name": "cool2",
					"id": 2852,
					"code": 62235,
					"tempChar": ""
				},
				{
					"id": 399,
					"order": 2614,
					"prevSize": 32,
					"code": 59782,
					"name": "cool3",
					"tempChar": ""
				},
				{
					"id": 400,
					"order": 2615,
					"prevSize": 32,
					"code": 59783,
					"name": "cool4",
					"tempChar": ""
				},
				{
					"order": 185,
					"prevSize": 32,
					"ligatures": "copy, duplicate",
					"name": "copy",
					"id": 1996,
					"code": 60745,
					"tempChar": ""
				},
				{
					"order": 186,
					"prevSize": 32,
					"ligatures": "copy2, duplicate2",
					"name": "copy2",
					"id": 1997,
					"code": 60746,
					"tempChar": ""
				},
				{
					"order": 201,
					"prevSize": 32,
					"ligatures": "copy3, duplicate3",
					"name": "copy3",
					"id": 2012,
					"code": 60761,
					"tempChar": ""
				},
				{
					"order": 202,
					"prevSize": 32,
					"ligatures": "copy4, duplicate4",
					"name": "copy4",
					"id": 2013,
					"code": 60762,
					"tempChar": ""
				},
				{
					"name": "copy5, files-o",
					"id": 1352,
					"order": 1785,
					"prevSize": 32,
					"code": 61637,
					"tempChar": ""
				},
				{
					"id": 401,
					"order": 2616,
					"prevSize": 32,
					"code": 59784,
					"name": "copy6",
					"tempChar": ""
				},
				{
					"id": 402,
					"order": 2617,
					"prevSize": 32,
					"code": 59785,
					"name": "copy7",
					"tempChar": ""
				},
				{
					"id": 991,
					"order": 2292,
					"prevSize": 32,
					"code": 60374,
					"name": "copy8",
					"tempChar": ""
				},
				{
					"name": "copyright",
					"id": 1639,
					"order": 2072,
					"prevSize": 32,
					"code": 61945,
					"tempChar": ""
				},
				{
					"order": 3424,
					"id": 94,
					"prevSize": 32,
					"code": 169,
					"name": "copyright2",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"id": 403,
					"order": 2618,
					"prevSize": 32,
					"code": 59786,
					"name": "cover",
					"tempChar": ""
				},
				{
					"id": 404,
					"order": 2619,
					"prevSize": 32,
					"code": 59787,
					"name": "cover2",
					"tempChar": ""
				},
				{
					"id": 992,
					"order": 2293,
					"prevSize": 32,
					"code": 60375,
					"name": "crash",
					"tempChar": ""
				},
				{
					"id": 405,
					"order": 2620,
					"prevSize": 32,
					"code": 59788,
					"name": "crave",
					"tempChar": ""
				},
				{
					"id": 406,
					"order": 2621,
					"prevSize": 32,
					"code": 59789,
					"name": "crave2",
					"tempChar": ""
				},
				{
					"id": 407,
					"order": 2622,
					"prevSize": 32,
					"code": 59790,
					"name": "create",
					"tempChar": ""
				},
				{
					"id": 408,
					"order": 2623,
					"prevSize": 32,
					"code": 59791,
					"name": "create2",
					"tempChar": ""
				},
				{
					"id": 993,
					"order": 2294,
					"prevSize": 32,
					"code": 60376,
					"name": "create3",
					"tempChar": ""
				},
				{
					"name": "creative-commons",
					"id": 1732,
					"order": 2165,
					"prevSize": 32,
					"code": 62046,
					"tempChar": ""
				},
				{
					"order": 279,
					"prevSize": 32,
					"ligatures": "credit-card, money12",
					"name": "credit-card",
					"id": 2090,
					"code": 60839,
					"tempChar": ""
				},
				{
					"name": "credit-card-alt",
					"id": 1766,
					"order": 2199,
					"prevSize": 32,
					"code": 62083,
					"tempChar": ""
				},
				{
					"order": 280,
					"prevSize": 32,
					"ligatures": "credit-card2, money13",
					"name": "credit-card2",
					"id": 2091,
					"code": 60840,
					"tempChar": ""
				},
				{
					"name": "credit-card3",
					"id": 1327,
					"order": 1760,
					"prevSize": 32,
					"code": 61597,
					"tempChar": ""
				},
				{
					"id": 409,
					"order": 2624,
					"prevSize": 32,
					"code": 59792,
					"name": "creep",
					"tempChar": ""
				},
				{
					"id": 410,
					"order": 2625,
					"prevSize": 32,
					"code": 59793,
					"name": "creep2",
					"tempChar": ""
				},
				{
					"id": 994,
					"order": 2295,
					"prevSize": 32,
					"code": 60377,
					"name": "creep3",
					"tempChar": ""
				},
				{
					"order": 1405,
					"prevSize": 32,
					"ligatures": "crop, resize",
					"name": "crop",
					"id": 3216,
					"code": 62599,
					"tempChar": ""
				},
				{
					"order": 1406,
					"prevSize": 32,
					"ligatures": "crop2, resize2",
					"name": "crop2",
					"id": 3217,
					"code": 62600,
					"tempChar": ""
				},
				{
					"name": "crop3",
					"id": 1440,
					"order": 1873,
					"prevSize": 32,
					"code": 61733,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "crop, cut",
					"order": 3299,
					"name": "crop4",
					"id": 234,
					"code": 59531,
					"tempChar": ""
				},
				{
					"id": 995,
					"order": 2296,
					"prevSize": 32,
					"code": 60378,
					"name": "crop5",
					"tempChar": ""
				},
				{
					"order": 1134,
					"prevSize": 32,
					"ligatures": "cross, cancel2",
					"name": "cross",
					"id": 2945,
					"code": 62328,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "cross-circle, cross2",
					"order": 3288,
					"name": "cross-circle",
					"id": 223,
					"code": 59520,
					"tempChar": ""
				},
				{
					"order": 1135,
					"prevSize": 32,
					"ligatures": "cross2, cancel3",
					"name": "cross2",
					"id": 2946,
					"code": 62329,
					"tempChar": ""
				},
				{
					"order": 1136,
					"prevSize": 32,
					"ligatures": "cross3, cancel4",
					"name": "cross3",
					"id": 2947,
					"code": 62330,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "cross, cancel",
					"order": 3272,
					"name": "cross4",
					"id": 207,
					"code": 59504,
					"tempChar": ""
				},
				{
					"name": "crosshairs",
					"id": 1265,
					"order": 1698,
					"prevSize": 32,
					"code": 61531,
					"tempChar": ""
				},
				{
					"order": 679,
					"prevSize": 32,
					"ligatures": "crown, king",
					"name": "crown",
					"id": 2490,
					"code": 61239,
					"tempChar": ""
				},
				{
					"id": 411,
					"order": 2626,
					"prevSize": 32,
					"code": 59794,
					"name": "cry",
					"tempChar": ""
				},
				{
					"id": 412,
					"order": 2627,
					"prevSize": 32,
					"code": 59795,
					"name": "cry2",
					"tempChar": ""
				},
				{
					"id": 996,
					"order": 2297,
					"prevSize": 32,
					"code": 60379,
					"name": "cry3",
					"tempChar": ""
				},
				{
					"order": 1062,
					"prevSize": 32,
					"ligatures": "crying, emoticon35",
					"name": "crying",
					"id": 2873,
					"code": 62256,
					"tempChar": ""
				},
				{
					"order": 1063,
					"prevSize": 32,
					"ligatures": "crying2, emoticon36",
					"name": "crying2",
					"id": 2874,
					"code": 62257,
					"tempChar": ""
				},
				{
					"order": 1607,
					"prevSize": 32,
					"ligatures": "css3",
					"name": "css3",
					"id": 3418,
					"code": 62801,
					"tempChar": ""
				},
				{
					"name": "css32",
					"id": 1462,
					"order": 1895,
					"prevSize": 32,
					"code": 61756,
					"tempChar": ""
				},
				{
					"order": 1382,
					"prevSize": 32,
					"ligatures": "ctrl, control",
					"name": "ctrl",
					"id": 3193,
					"code": 62576,
					"tempChar": ""
				},
				{
					"order": 794,
					"prevSize": 32,
					"ligatures": "cube, 3d",
					"name": "cube",
					"id": 2605,
					"code": 61354,
					"tempChar": ""
				},
				{
					"order": 795,
					"prevSize": 32,
					"ligatures": "cube2, 3d2",
					"name": "cube2",
					"id": 2606,
					"code": 61355,
					"tempChar": ""
				},
				{
					"order": 796,
					"prevSize": 32,
					"ligatures": "cube3, 3d3",
					"name": "cube3",
					"id": 2607,
					"code": 61356,
					"tempChar": ""
				},
				{
					"order": 797,
					"prevSize": 32,
					"ligatures": "cube4, 3d4",
					"name": "cube4",
					"id": 2608,
					"code": 61357,
					"tempChar": ""
				},
				{
					"name": "cube5",
					"id": 1572,
					"order": 2005,
					"prevSize": 32,
					"code": 61874,
					"tempChar": ""
				},
				{
					"name": "cubes",
					"id": 1573,
					"order": 2006,
					"prevSize": 32,
					"code": 61875,
					"tempChar": ""
				},
				{
					"order": 714,
					"prevSize": 32,
					"ligatures": "cup4, drink11",
					"name": "cup",
					"id": 2525,
					"code": 61274,
					"tempChar": ""
				},
				{
					"order": 715,
					"prevSize": 32,
					"ligatures": "cup5, drink12",
					"name": "cup2",
					"id": 2526,
					"code": 61275,
					"tempChar": ""
				},
				{
					"id": 413,
					"order": 2628,
					"prevSize": 32,
					"code": 59796,
					"name": "curdle",
					"tempChar": ""
				},
				{
					"id": 414,
					"order": 2629,
					"prevSize": 32,
					"code": 59797,
					"name": "curdle2",
					"tempChar": ""
				},
				{
					"order": 1064,
					"prevSize": 32,
					"ligatures": "cursor, pointer",
					"name": "cursor",
					"id": 2875,
					"code": 62258,
					"tempChar": ""
				},
				{
					"order": 1065,
					"prevSize": 32,
					"ligatures": "cursor2, pointer2",
					"name": "cursor2",
					"id": 2876,
					"code": 62259,
					"tempChar": ""
				},
				{
					"name": "cut, scissors4",
					"id": 1351,
					"order": 1784,
					"prevSize": 32,
					"code": 61636,
					"tempChar": ""
				},
				{
					"id": 415,
					"order": 2630,
					"prevSize": 32,
					"code": 59798,
					"name": "cut2",
					"tempChar": ""
				},
				{
					"id": 416,
					"order": 2631,
					"prevSize": 32,
					"code": 59799,
					"name": "cut3",
					"tempChar": ""
				},
				{
					"id": 997,
					"order": 2298,
					"prevSize": 32,
					"code": 60380,
					"name": "cut4",
					"tempChar": ""
				},
				{
					"name": "cutlery",
					"id": 1397,
					"order": 1830,
					"prevSize": 32,
					"code": 61685,
					"tempChar": ""
				},
				{
					"id": 417,
					"order": 2632,
					"prevSize": 32,
					"code": 59800,
					"name": "dance",
					"tempChar": ""
				},
				{
					"id": 418,
					"order": 2633,
					"prevSize": 32,
					"code": 59801,
					"name": "dance2",
					"tempChar": ""
				},
				{
					"name": "dashboard, tachometer",
					"id": 1381,
					"order": 1814,
					"prevSize": 32,
					"code": 61668,
					"tempChar": ""
				},
				{
					"name": "dashcube",
					"id": 1660,
					"order": 2093,
					"prevSize": 32,
					"code": 61968,
					"tempChar": ""
				},
				{
					"order": 405,
					"prevSize": 32,
					"ligatures": "database, db",
					"name": "database",
					"id": 2216,
					"code": 60965,
					"tempChar": ""
				},
				{
					"order": 410,
					"prevSize": 32,
					"ligatures": "database-add, db6",
					"name": "database-add",
					"id": 2221,
					"code": 60970,
					"tempChar": ""
				},
				{
					"order": 420,
					"prevSize": 32,
					"ligatures": "database-arrow, db16",
					"name": "database-arrow",
					"id": 2231,
					"code": 60980,
					"tempChar": ""
				},
				{
					"order": 419,
					"prevSize": 32,
					"ligatures": "database-check, db15",
					"name": "database-check",
					"id": 2230,
					"code": 60979,
					"tempChar": ""
				},
				{
					"order": 416,
					"prevSize": 32,
					"ligatures": "database-diff, db12",
					"name": "database-diff",
					"id": 2227,
					"code": 60976,
					"tempChar": ""
				},
				{
					"order": 417,
					"prevSize": 32,
					"ligatures": "database-edit, db13",
					"name": "database-edit",
					"id": 2228,
					"code": 60977,
					"tempChar": ""
				},
				{
					"order": 418,
					"prevSize": 32,
					"ligatures": "database-edit2, db14",
					"name": "database-edit2",
					"id": 2229,
					"code": 60978,
					"tempChar": ""
				},
				{
					"order": 413,
					"prevSize": 32,
					"ligatures": "database-export, db9",
					"name": "database-export",
					"id": 2224,
					"code": 60973,
					"tempChar": ""
				},
				{
					"order": 412,
					"prevSize": 32,
					"ligatures": "database-insert, db8",
					"name": "database-insert",
					"id": 2223,
					"code": 60972,
					"tempChar": ""
				},
				{
					"order": 409,
					"prevSize": 32,
					"ligatures": "database-menu, db5",
					"name": "database-menu",
					"id": 2220,
					"code": 60969,
					"tempChar": ""
				},
				{
					"order": 415,
					"prevSize": 32,
					"ligatures": "database-refresh, db11",
					"name": "database-refresh",
					"id": 2226,
					"code": 60975,
					"tempChar": ""
				},
				{
					"order": 411,
					"prevSize": 32,
					"ligatures": "database-remove, db7",
					"name": "database-remove",
					"id": 2222,
					"code": 60971,
					"tempChar": ""
				},
				{
					"order": 421,
					"prevSize": 32,
					"ligatures": "database-time, db17",
					"name": "database-time",
					"id": 2232,
					"code": 60981,
					"tempChar": ""
				},
				{
					"order": 422,
					"prevSize": 32,
					"ligatures": "database-time2, db18",
					"name": "database-time2",
					"id": 2233,
					"code": 60982,
					"tempChar": ""
				},
				{
					"order": 414,
					"prevSize": 32,
					"ligatures": "database-upload, db10",
					"name": "database-upload",
					"id": 2225,
					"code": 60974,
					"tempChar": ""
				},
				{
					"order": 406,
					"prevSize": 32,
					"ligatures": "database2, db2",
					"name": "database2",
					"id": 2217,
					"code": 60966,
					"tempChar": ""
				},
				{
					"order": 407,
					"prevSize": 32,
					"ligatures": "database3, db3",
					"name": "database3",
					"id": 2218,
					"code": 60967,
					"tempChar": ""
				},
				{
					"order": 408,
					"prevSize": 32,
					"ligatures": "database4, db4",
					"name": "database4",
					"id": 2219,
					"code": 60968,
					"tempChar": ""
				},
				{
					"name": "database5",
					"id": 1585,
					"order": 2018,
					"prevSize": 32,
					"code": 61888,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "database, storage",
					"order": 3174,
					"name": "database6",
					"id": 109,
					"code": 59406,
					"tempChar": ""
				},
				{
					"order": 979,
					"prevSize": 32,
					"ligatures": "day-night, sun-moon",
					"name": "day-night",
					"id": 2790,
					"code": 62173,
					"tempChar": ""
				},
				{
					"order": 980,
					"prevSize": 32,
					"ligatures": "day-night2, sun-moon2",
					"name": "day-night2",
					"id": 2791,
					"code": 62174,
					"tempChar": ""
				},
				{
					"id": 419,
					"order": 2634,
					"prevSize": 32,
					"code": 59802,
					"name": "dazzle",
					"tempChar": ""
				},
				{
					"id": 420,
					"order": 2635,
					"prevSize": 32,
					"code": 59803,
					"name": "dazzle2",
					"tempChar": ""
				},
				{
					"name": "deaf, deafness, hard-of-hearing",
					"id": 1797,
					"order": 2230,
					"prevSize": 32,
					"code": 62116,
					"tempChar": ""
				},
				{
					"id": 421,
					"order": 2636,
					"prevSize": 32,
					"code": 59804,
					"name": "decide",
					"tempChar": ""
				},
				{
					"id": 422,
					"order": 2637,
					"prevSize": 32,
					"code": 59805,
					"name": "decide2",
					"tempChar": ""
				},
				{
					"id": 998,
					"order": 2299,
					"prevSize": 32,
					"code": 60381,
					"name": "decompress",
					"tempChar": ""
				},
				{
					"id": 423,
					"order": 2638,
					"prevSize": 32,
					"code": 59806,
					"name": "decorate",
					"tempChar": ""
				},
				{
					"id": 424,
					"order": 2639,
					"prevSize": 32,
					"code": 59807,
					"name": "decorate2",
					"tempChar": ""
				},
				{
					"name": "dedent, outdent",
					"id": 1235,
					"order": 1668,
					"prevSize": 32,
					"code": 61499,
					"tempChar": ""
				},
				{
					"id": 425,
					"order": 2640,
					"prevSize": 32,
					"code": 59808,
					"name": "defend",
					"tempChar": ""
				},
				{
					"id": 426,
					"order": 2641,
					"prevSize": 32,
					"code": 59809,
					"name": "defend2",
					"tempChar": ""
				},
				{
					"order": 1582,
					"prevSize": 32,
					"ligatures": "delicious, brand68",
					"name": "delicious",
					"id": 3393,
					"code": 62776,
					"tempChar": ""
				},
				{
					"name": "delicious2",
					"id": 1560,
					"order": 1993,
					"prevSize": 32,
					"code": 61861,
					"tempChar": ""
				},
				{
					"id": 427,
					"order": 2642,
					"prevSize": 32,
					"code": 59810,
					"name": "deliver",
					"tempChar": ""
				},
				{
					"id": 428,
					"order": 2643,
					"prevSize": 32,
					"code": 59811,
					"name": "deliver2",
					"tempChar": ""
				},
				{
					"order": 15,
					"prevSize": 32,
					"ligatures": "design, pencil-ruler",
					"name": "design",
					"id": 1826,
					"code": 60575,
					"tempChar": ""
				},
				{
					"id": 429,
					"order": 2644,
					"prevSize": 32,
					"code": 59812,
					"name": "design2",
					"tempChar": ""
				},
				{
					"id": 430,
					"order": 2645,
					"prevSize": 32,
					"code": 59813,
					"name": "design3",
					"tempChar": ""
				},
				{
					"id": 999,
					"order": 2300,
					"prevSize": 32,
					"code": 60382,
					"name": "design4",
					"tempChar": ""
				},
				{
					"name": "desktop",
					"id": 1415,
					"order": 1848,
					"prevSize": 32,
					"code": 61704,
					"tempChar": ""
				},
				{
					"id": 431,
					"order": 2646,
					"prevSize": 32,
					"code": 59814,
					"name": "destroy",
					"tempChar": ""
				},
				{
					"id": 432,
					"order": 2647,
					"prevSize": 32,
					"code": 59815,
					"name": "destroy2",
					"tempChar": ""
				},
				{
					"order": 1547,
					"prevSize": 32,
					"ligatures": "deviantart, brand34",
					"name": "deviantart",
					"id": 3358,
					"code": 62741,
					"tempChar": ""
				},
				{
					"name": "deviantart2",
					"id": 1583,
					"order": 2016,
					"prevSize": 32,
					"code": 61885,
					"tempChar": ""
				},
				{
					"order": 683,
					"prevSize": 32,
					"ligatures": "diamond, gem",
					"name": "diamond",
					"id": 2494,
					"code": 61243,
					"tempChar": ""
				},
				{
					"order": 684,
					"prevSize": 32,
					"ligatures": "diamond2, gem2",
					"name": "diamond2",
					"id": 2495,
					"code": 61244,
					"tempChar": ""
				},
				{
					"order": 1390,
					"prevSize": 32,
					"ligatures": "diamond3",
					"name": "diamond3",
					"id": 3201,
					"code": 62584,
					"tempChar": ""
				},
				{
					"order": 1391,
					"prevSize": 32,
					"ligatures": "diamond4",
					"name": "diamond4",
					"id": 3202,
					"code": 62585,
					"tempChar": ""
				},
				{
					"name": "diamond5",
					"id": 1669,
					"order": 2102,
					"prevSize": 32,
					"code": 61977,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "diamond, jewelry",
					"order": 3229,
					"name": "diamond6",
					"id": 164,
					"code": 59461,
					"tempChar": ""
				},
				{
					"order": 115,
					"prevSize": 32,
					"ligatures": "diamonds, cards3",
					"name": "diamonds",
					"id": 1926,
					"code": 60675,
					"tempChar": ""
				},
				{
					"order": 108,
					"prevSize": 32,
					"ligatures": "dice, game",
					"name": "dice",
					"id": 1919,
					"code": 60668,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "dice, game",
					"order": 3178,
					"name": "dice2",
					"id": 113,
					"code": 59410,
					"tempChar": ""
				},
				{
					"id": 433,
					"order": 2648,
					"prevSize": 32,
					"code": 59816,
					"name": "die",
					"tempChar": ""
				},
				{
					"id": 434,
					"order": 2649,
					"prevSize": 32,
					"code": 59817,
					"name": "die2",
					"tempChar": ""
				},
				{
					"id": 1000,
					"order": 2301,
					"prevSize": 32,
					"code": 60383,
					"name": "die3",
					"tempChar": ""
				},
				{
					"name": "digg",
					"id": 1561,
					"order": 1994,
					"prevSize": 32,
					"code": 61862,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "dinner, food",
					"order": 3231,
					"name": "dinner",
					"id": 166,
					"code": 59463,
					"tempChar": ""
				},
				{
					"order": 332,
					"prevSize": 32,
					"ligatures": "direction7, address",
					"name": "direction",
					"id": 2143,
					"code": 60892,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "direction-ltr, typography16",
					"order": 3320,
					"name": "direction-ltr",
					"id": 255,
					"code": 59552,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "direction-rtl, typography17",
					"order": 3321,
					"name": "direction-rtl",
					"id": 256,
					"code": 59553,
					"tempChar": ""
				},
				{
					"id": 435,
					"order": 2650,
					"prevSize": 32,
					"code": 59818,
					"name": "discard",
					"tempChar": ""
				},
				{
					"id": 436,
					"order": 2651,
					"prevSize": 32,
					"code": 59819,
					"name": "discard2",
					"tempChar": ""
				},
				{
					"id": 1001,
					"order": 2302,
					"prevSize": 32,
					"code": 60384,
					"name": "discard3",
					"tempChar": ""
				},
				{
					"id": 437,
					"order": 2652,
					"prevSize": 32,
					"code": 59820,
					"name": "discover",
					"tempChar": ""
				},
				{
					"id": 438,
					"order": 2653,
					"prevSize": 32,
					"code": 59821,
					"name": "discover2",
					"tempChar": ""
				},
				{
					"id": 439,
					"order": 2654,
					"prevSize": 32,
					"code": 59822,
					"name": "discuss",
					"tempChar": ""
				},
				{
					"id": 440,
					"order": 2655,
					"prevSize": 32,
					"code": 59823,
					"name": "discuss2",
					"tempChar": ""
				},
				{
					"id": 441,
					"order": 2656,
					"prevSize": 32,
					"code": 59824,
					"name": "disguise",
					"tempChar": ""
				},
				{
					"id": 442,
					"order": 2657,
					"prevSize": 32,
					"code": 59825,
					"name": "disguise2",
					"tempChar": ""
				},
				{
					"id": 1002,
					"order": 2303,
					"prevSize": 32,
					"code": 60385,
					"name": "disguise3",
					"tempChar": ""
				},
				{
					"order": 400,
					"prevSize": 32,
					"ligatures": "disk, disc",
					"name": "disk",
					"id": 2211,
					"code": 60960,
					"tempChar": ""
				},
				{
					"order": 401,
					"prevSize": 32,
					"ligatures": "disk2, disc2",
					"name": "disk2",
					"id": 2212,
					"code": 60961,
					"tempChar": ""
				},
				{
					"order": 373,
					"prevSize": 32,
					"ligatures": "display, screen",
					"name": "display",
					"id": 2184,
					"code": 60933,
					"tempChar": ""
				},
				{
					"order": 374,
					"prevSize": 32,
					"ligatures": "display2, screen2",
					"name": "display2",
					"id": 2185,
					"code": 60934,
					"tempChar": ""
				},
				{
					"order": 375,
					"prevSize": 32,
					"ligatures": "display3, screen3",
					"name": "display3",
					"id": 2186,
					"code": 60935,
					"tempChar": ""
				},
				{
					"order": 376,
					"prevSize": 32,
					"ligatures": "display4, screen4",
					"name": "display4",
					"id": 2187,
					"code": 60936,
					"tempChar": ""
				},
				{
					"id": 443,
					"order": 2658,
					"prevSize": 32,
					"code": 59826,
					"name": "divide",
					"tempChar": ""
				},
				{
					"id": 444,
					"order": 2659,
					"prevSize": 32,
					"code": 59827,
					"name": "divide2",
					"tempChar": ""
				},
				{
					"id": 1003,
					"order": 2304,
					"prevSize": 32,
					"code": 60386,
					"name": "divide3",
					"tempChar": ""
				},
				{
					"id": 1004,
					"order": 2305,
					"prevSize": 32,
					"code": 60387,
					"name": "do",
					"tempChar": ""
				},
				{
					"name": "dollar, usd",
					"id": 1485,
					"order": 1918,
					"prevSize": 32,
					"code": 61781,
					"tempChar": ""
				},
				{
					"name": "dot-circle-o",
					"id": 1542,
					"order": 1975,
					"prevSize": 32,
					"code": 61842,
					"tempChar": ""
				},
				{
					"order": 1104,
					"prevSize": 32,
					"ligatures": "dots4, resize-handle",
					"name": "dots",
					"id": 2915,
					"code": 62298,
					"tempChar": ""
				},
				{
					"order": 393,
					"prevSize": 32,
					"ligatures": "download, save",
					"name": "download",
					"id": 2204,
					"code": 60953,
					"tempChar": ""
				},
				{
					"order": 913,
					"prevSize": 32,
					"ligatures": "download10, save16",
					"name": "download10",
					"id": 2724,
					"code": 61759,
					"tempChar": ""
				},
				{
					"name": "download11",
					"id": 1203,
					"order": 1636,
					"prevSize": 32,
					"code": 61465,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "download, down",
					"order": 3261,
					"name": "download12",
					"id": 196,
					"code": 59493,
					"tempChar": ""
				},
				{
					"id": 445,
					"order": 2660,
					"prevSize": 32,
					"code": 59828,
					"name": "download13",
					"tempChar": ""
				},
				{
					"id": 446,
					"order": 2661,
					"prevSize": 32,
					"code": 59829,
					"name": "download14",
					"tempChar": ""
				},
				{
					"id": 1005,
					"order": 2306,
					"prevSize": 32,
					"code": 60388,
					"name": "download15",
					"tempChar": ""
				},
				{
					"order": 895,
					"prevSize": 32,
					"ligatures": "download2, save8",
					"name": "download2",
					"id": 2706,
					"code": 61623,
					"tempChar": ""
				},
				{
					"order": 896,
					"prevSize": 32,
					"ligatures": "download3, save9",
					"name": "download3",
					"id": 2707,
					"code": 61624,
					"tempChar": ""
				},
				{
					"order": 901,
					"prevSize": 32,
					"ligatures": "download4, save10",
					"name": "download4",
					"id": 2712,
					"code": 61629,
					"tempChar": ""
				},
				{
					"order": 903,
					"prevSize": 32,
					"ligatures": "download5, save11",
					"name": "download5",
					"id": 2714,
					"code": 61631,
					"tempChar": ""
				},
				{
					"order": 905,
					"prevSize": 32,
					"ligatures": "download6, save12",
					"name": "download6",
					"id": 2716,
					"code": 61663,
					"tempChar": ""
				},
				{
					"order": 907,
					"prevSize": 32,
					"ligatures": "download7, save13",
					"name": "download7",
					"id": 2718,
					"code": 61695,
					"tempChar": ""
				},
				{
					"order": 909,
					"prevSize": 32,
					"ligatures": "download8, save14",
					"name": "download8",
					"id": 2720,
					"code": 61718,
					"tempChar": ""
				},
				{
					"order": 911,
					"prevSize": 32,
					"ligatures": "download9, save15",
					"name": "download9",
					"id": 2722,
					"code": 61727,
					"tempChar": ""
				},
				{
					"order": 1077,
					"prevSize": 32,
					"ligatures": "drag-left, finger8",
					"name": "drag-left",
					"id": 2888,
					"code": 62271,
					"tempChar": ""
				},
				{
					"order": 1076,
					"prevSize": 32,
					"ligatures": "drag-left-right, finger7",
					"name": "drag-left-right",
					"id": 2887,
					"code": 62270,
					"tempChar": ""
				},
				{
					"order": 1078,
					"prevSize": 32,
					"ligatures": "drag-right, finger9",
					"name": "drag-right",
					"id": 2889,
					"code": 62272,
					"tempChar": ""
				},
				{
					"id": 447,
					"order": 2662,
					"prevSize": 32,
					"code": 59830,
					"name": "draw",
					"tempChar": ""
				},
				{
					"id": 448,
					"order": 2663,
					"prevSize": 32,
					"code": 59831,
					"name": "draw2",
					"tempChar": ""
				},
				{
					"order": 385,
					"prevSize": 32,
					"ligatures": "drawer, box",
					"name": "drawer",
					"id": 2196,
					"code": 60945,
					"tempChar": ""
				},
				{
					"order": 388,
					"prevSize": 32,
					"ligatures": "drawer-in, box4",
					"name": "drawer-in",
					"id": 2199,
					"code": 60948,
					"tempChar": ""
				},
				{
					"order": 387,
					"prevSize": 32,
					"ligatures": "drawer-out, box3",
					"name": "drawer-out",
					"id": 2198,
					"code": 60947,
					"tempChar": ""
				},
				{
					"order": 386,
					"prevSize": 32,
					"ligatures": "drawer2, box2",
					"name": "drawer2",
					"id": 2197,
					"code": 60946,
					"tempChar": ""
				},
				{
					"order": 389,
					"prevSize": 32,
					"ligatures": "drawer3, box5",
					"name": "drawer3",
					"id": 2200,
					"code": 60949,
					"tempChar": ""
				},
				{
					"order": 1544,
					"prevSize": 32,
					"ligatures": "dribbble, brand31",
					"name": "dribbble",
					"id": 3355,
					"code": 62738,
					"tempChar": ""
				},
				{
					"name": "dribbble2",
					"id": 1523,
					"order": 1956,
					"prevSize": 32,
					"code": 61821,
					"tempChar": ""
				},
				{
					"id": 449,
					"order": 2664,
					"prevSize": 32,
					"code": 59832,
					"name": "drill",
					"tempChar": ""
				},
				{
					"id": 450,
					"order": 2665,
					"prevSize": 32,
					"code": 59833,
					"name": "drill2",
					"tempChar": ""
				},
				{
					"id": 1006,
					"order": 2307,
					"prevSize": 32,
					"code": 60389,
					"name": "drill3",
					"tempChar": ""
				},
				{
					"id": 451,
					"order": 2666,
					"prevSize": 32,
					"code": 59834,
					"name": "drink",
					"tempChar": ""
				},
				{
					"id": 452,
					"order": 2667,
					"prevSize": 32,
					"code": 59835,
					"name": "drink2",
					"tempChar": ""
				},
				{
					"id": 1007,
					"order": 2308,
					"prevSize": 32,
					"code": 60390,
					"name": "drink3",
					"tempChar": ""
				},
				{
					"order": 403,
					"prevSize": 32,
					"ligatures": "drive, save7",
					"name": "drive",
					"id": 2214,
					"code": 60963,
					"tempChar": ""
				},
				{
					"id": 453,
					"order": 2668,
					"prevSize": 32,
					"code": 59836,
					"name": "drive2",
					"tempChar": ""
				},
				{
					"id": 454,
					"order": 2669,
					"prevSize": 32,
					"code": 59837,
					"name": "drive3",
					"tempChar": ""
				},
				{
					"id": 1008,
					"order": 2309,
					"prevSize": 32,
					"code": 60391,
					"name": "drive4",
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "drop, droplet",
					"order": 3164,
					"name": "drop",
					"id": 99,
					"code": 59396,
					"tempChar": ""
				},
				{
					"id": 1009,
					"order": 2310,
					"prevSize": 32,
					"code": 60392,
					"name": "drop2",
					"tempChar": ""
				},
				{
					"order": 1551,
					"prevSize": 32,
					"ligatures": "dropbox, brand38",
					"name": "dropbox",
					"id": 3362,
					"code": 62745,
					"tempChar": ""
				},
				{
					"name": "dropbox2",
					"id": 1506,
					"order": 1939,
					"prevSize": 32,
					"code": 61803,
					"tempChar": ""
				},
				{
					"order": 54,
					"prevSize": 32,
					"ligatures": "droplet, color9",
					"name": "droplet",
					"id": 1865,
					"code": 60614,
					"tempChar": ""
				},
				{
					"order": 56,
					"prevSize": 32,
					"ligatures": "droplet-contrast, droplet3",
					"name": "droplet-contrast",
					"id": 1867,
					"code": 60616,
					"tempChar": ""
				},
				{
					"order": 55,
					"prevSize": 32,
					"ligatures": "droplet2, color10",
					"name": "droplet2",
					"id": 1866,
					"code": 60615,
					"tempChar": ""
				},
				{
					"name": "drupal",
					"id": 1564,
					"order": 1997,
					"prevSize": 32,
					"code": 61865,
					"tempChar": ""
				},
				{
					"order": 753,
					"prevSize": 32,
					"ligatures": "dumbbell, gym",
					"name": "dumbbell",
					"id": 2564,
					"code": 61313,
					"tempChar": ""
				},
				{
					"id": 455,
					"order": 2670,
					"prevSize": 32,
					"code": 59838,
					"name": "duplicate",
					"tempChar": ""
				},
				{
					"id": 456,
					"order": 2671,
					"prevSize": 32,
					"code": 59839,
					"name": "duplicate2",
					"tempChar": ""
				},
				{
					"order": 920,
					"prevSize": 32,
					"ligatures": "earth, globe6",
					"name": "earth",
					"id": 2731,
					"code": 61871,
					"tempChar": ""
				},
				{
					"order": 921,
					"prevSize": 32,
					"ligatures": "earth2, globe7",
					"name": "earth2",
					"id": 2732,
					"code": 61887,
					"tempChar": ""
				},
				{
					"order": 922,
					"prevSize": 32,
					"ligatures": "earth3, globe8",
					"name": "earth3",
					"id": 2733,
					"code": 61903,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "earth, globe",
					"order": 3243,
					"name": "earth4",
					"id": 178,
					"code": 59475,
					"tempChar": ""
				},
				{
					"id": 457,
					"order": 2672,
					"prevSize": 32,
					"code": 59840,
					"name": "eat",
					"tempChar": ""
				},
				{
					"id": 458,
					"order": 2673,
					"prevSize": 32,
					"code": 59841,
					"name": "eat2",
					"tempChar": ""
				},
				{
					"id": 1010,
					"order": 2311,
					"prevSize": 32,
					"code": 60393,
					"name": "eat3",
					"tempChar": ""
				},
				{
					"order": 1597,
					"prevSize": 32,
					"name": "edge",
					"ligatures": "edge, browser4",
					"id": 3408,
					"code": 62791,
					"tempChar": ""
				},
				{
					"name": "edge2",
					"id": 1765,
					"order": 2198,
					"prevSize": 32,
					"code": 62082,
					"tempChar": ""
				},
				{
					"name": "edit, pencil-square-o",
					"id": 1243,
					"order": 1676,
					"prevSize": 32,
					"code": 61508,
					"tempChar": ""
				},
				{
					"id": 459,
					"order": 2674,
					"prevSize": 32,
					"code": 59842,
					"name": "edit2",
					"tempChar": ""
				},
				{
					"id": 460,
					"order": 2675,
					"prevSize": 32,
					"code": 59843,
					"name": "edit3",
					"tempChar": ""
				},
				{
					"id": 1011,
					"order": 2312,
					"prevSize": 32,
					"code": 60394,
					"name": "edit4",
					"tempChar": ""
				},
				{
					"order": 839,
					"prevSize": 32,
					"ligatures": "eight-ball, soprts9",
					"name": "eight-ball",
					"id": 2650,
					"code": 61399,
					"tempChar": ""
				},
				{
					"order": 1168,
					"prevSize": 32,
					"ligatures": "eject, player17",
					"name": "eject",
					"id": 2979,
					"code": 62362,
					"tempChar": ""
				},
				{
					"name": "eject2",
					"id": 1256,
					"order": 1689,
					"prevSize": 32,
					"code": 61522,
					"tempChar": ""
				},
				{
					"name": "ellipsis-h",
					"id": 1466,
					"order": 1899,
					"prevSize": 32,
					"code": 61761,
					"tempChar": ""
				},
				{
					"name": "ellipsis-v",
					"id": 1467,
					"order": 1900,
					"prevSize": 32,
					"code": 61762,
					"tempChar": ""
				},
				{
					"order": 1559,
					"prevSize": 32,
					"ligatures": "ello, brand46",
					"name": "ello",
					"id": 3370,
					"code": 62753,
					"tempChar": ""
				},
				{
					"order": 1486,
					"prevSize": 32,
					"ligatures": "embed, code",
					"name": "embed",
					"id": 3297,
					"code": 62680,
					"tempChar": ""
				},
				{
					"order": 1487,
					"prevSize": 32,
					"ligatures": "embed2, code2",
					"name": "embed2",
					"id": 3298,
					"code": 62681,
					"tempChar": ""
				},
				{
					"name": "empire, ge",
					"id": 1601,
					"order": 2034,
					"prevSize": 32,
					"code": 61905,
					"tempChar": ""
				},
				{
					"id": 461,
					"order": 2676,
					"prevSize": 32,
					"code": 59844,
					"name": "encourage",
					"tempChar": ""
				},
				{
					"id": 462,
					"order": 2677,
					"prevSize": 32,
					"code": 59845,
					"name": "encourage2",
					"tempChar": ""
				},
				{
					"id": 1012,
					"order": 2313,
					"prevSize": 32,
					"code": 60395,
					"name": "enhance",
					"tempChar": ""
				},
				{
					"order": 574,
					"prevSize": 32,
					"ligatures": "enlarge, expand",
					"name": "enlarge",
					"id": 2385,
					"code": 61134,
					"tempChar": ""
				},
				{
					"id": 1013,
					"order": 2314,
					"prevSize": 32,
					"code": 60396,
					"name": "enlarge10",
					"tempChar": ""
				},
				{
					"order": 576,
					"prevSize": 32,
					"ligatures": "enlarge2, expand2",
					"name": "enlarge2",
					"id": 2387,
					"code": 61136,
					"tempChar": ""
				},
				{
					"order": 578,
					"prevSize": 32,
					"ligatures": "enlarge3, expand3",
					"name": "enlarge3",
					"id": 2389,
					"code": 61138,
					"tempChar": ""
				},
				{
					"order": 580,
					"prevSize": 32,
					"ligatures": "enlarge4, expand4",
					"name": "enlarge4",
					"id": 2391,
					"code": 61140,
					"tempChar": ""
				},
				{
					"order": 582,
					"prevSize": 32,
					"ligatures": "enlarge5, expand5",
					"name": "enlarge5",
					"id": 2393,
					"code": 61142,
					"tempChar": ""
				},
				{
					"order": 584,
					"prevSize": 32,
					"ligatures": "enlarge6, expand6",
					"name": "enlarge6",
					"id": 2395,
					"code": 61144,
					"tempChar": ""
				},
				{
					"order": 586,
					"prevSize": 32,
					"ligatures": "enlarge7, expand7",
					"name": "enlarge7",
					"id": 2397,
					"code": 61146,
					"tempChar": ""
				},
				{
					"id": 463,
					"order": 2678,
					"prevSize": 32,
					"code": 59846,
					"name": "enlarge8",
					"tempChar": ""
				},
				{
					"id": 464,
					"order": 2679,
					"prevSize": 32,
					"code": 59847,
					"name": "enlarge9",
					"tempChar": ""
				},
				{
					"order": 1144,
					"prevSize": 32,
					"ligatures": "enter, signin",
					"name": "enter",
					"id": 2955,
					"code": 62338,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "enter-down, down2",
					"order": 3263,
					"name": "enter-down",
					"id": 198,
					"code": 59495,
					"tempChar": ""
				},
				{
					"id": 1014,
					"order": 2315,
					"prevSize": 32,
					"code": 60397,
					"name": "enter10",
					"tempChar": ""
				},
				{
					"order": 1146,
					"prevSize": 32,
					"ligatures": "enter2, signin2",
					"name": "enter2",
					"id": 2957,
					"code": 62340,
					"tempChar": ""
				},
				{
					"order": 1148,
					"prevSize": 32,
					"ligatures": "enter3, signin3",
					"name": "enter3",
					"id": 2959,
					"code": 62342,
					"tempChar": ""
				},
				{
					"order": 1345,
					"prevSize": 32,
					"ligatures": "enter4, return",
					"name": "enter4",
					"id": 3156,
					"code": 62539,
					"tempChar": ""
				},
				{
					"order": 1346,
					"prevSize": 32,
					"ligatures": "enter5, return2",
					"name": "enter5",
					"id": 3157,
					"code": 62540,
					"tempChar": ""
				},
				{
					"order": 1348,
					"prevSize": 32,
					"ligatures": "enter6, arrow",
					"name": "enter6",
					"id": 3159,
					"code": 62542,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "enter, door",
					"order": 3191,
					"name": "enter7",
					"id": 126,
					"code": 59423,
					"tempChar": ""
				},
				{
					"id": 465,
					"order": 2680,
					"prevSize": 32,
					"code": 59848,
					"name": "enter8",
					"tempChar": ""
				},
				{
					"id": 466,
					"order": 2681,
					"prevSize": 32,
					"code": 59849,
					"name": "enter9",
					"tempChar": ""
				},
				{
					"order": 306,
					"prevSize": 32,
					"ligatures": "envelop, mail",
					"name": "envelop",
					"id": 2117,
					"code": 60866,
					"tempChar": ""
				},
				{
					"order": 307,
					"prevSize": 32,
					"ligatures": "envelop2, mail2",
					"name": "envelop2",
					"id": 2118,
					"code": 60867,
					"tempChar": ""
				},
				{
					"order": 308,
					"prevSize": 32,
					"ligatures": "envelop3, mail3",
					"name": "envelop3",
					"id": 2119,
					"code": 60868,
					"tempChar": ""
				},
				{
					"order": 309,
					"prevSize": 32,
					"ligatures": "envelop4, mail4",
					"name": "envelop4",
					"id": 2120,
					"code": 60869,
					"tempChar": ""
				},
				{
					"order": 310,
					"prevSize": 32,
					"ligatures": "envelop5, mail5",
					"name": "envelop5",
					"id": 2121,
					"code": 60870,
					"tempChar": ""
				},
				{
					"name": "envelope",
					"id": 1377,
					"order": 1810,
					"prevSize": 32,
					"code": 61664,
					"tempChar": ""
				},
				{
					"name": "envelope-o",
					"id": 1182,
					"order": 1615,
					"prevSize": 32,
					"code": 61443,
					"tempChar": ""
				},
				{
					"name": "envelope-square",
					"id": 1549,
					"order": 1982,
					"prevSize": 32,
					"code": 61849,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "envelope, mail",
					"order": 3184,
					"name": "envelope2",
					"id": 119,
					"code": 59416,
					"tempChar": ""
				},
				{
					"name": "envira",
					"id": 1787,
					"order": 2220,
					"prevSize": 32,
					"code": 62105,
					"tempChar": ""
				},
				{
					"id": 1015,
					"order": 2316,
					"prevSize": 32,
					"code": 60398,
					"name": "envision",
					"tempChar": ""
				},
				{
					"id": 1016,
					"order": 2317,
					"prevSize": 32,
					"code": 60399,
					"name": "equal",
					"tempChar": ""
				},
				{
					"order": 605,
					"prevSize": 32,
					"ligatures": "equalizer, sliders",
					"name": "equalizer",
					"id": 2416,
					"code": 61165,
					"tempChar": ""
				},
				{
					"order": 606,
					"prevSize": 32,
					"ligatures": "equalizer2, sliders2",
					"name": "equalizer2",
					"id": 2417,
					"code": 61166,
					"tempChar": ""
				},
				{
					"order": 607,
					"prevSize": 32,
					"ligatures": "equalizer3, sliders3",
					"name": "equalizer3",
					"id": 2418,
					"code": 61167,
					"tempChar": ""
				},
				{
					"order": 608,
					"prevSize": 32,
					"ligatures": "equalizer4, sliders4",
					"name": "equalizer4",
					"id": 2419,
					"code": 61168,
					"tempChar": ""
				},
				{
					"id": 467,
					"order": 2682,
					"prevSize": 32,
					"code": 59850,
					"name": "erase",
					"tempChar": ""
				},
				{
					"id": 468,
					"order": 2683,
					"prevSize": 32,
					"code": 59851,
					"name": "erase2",
					"tempChar": ""
				},
				{
					"id": 1017,
					"order": 2318,
					"prevSize": 32,
					"code": 60400,
					"name": "erase3",
					"tempChar": ""
				},
				{
					"order": 23,
					"prevSize": 32,
					"ligatures": "eraser, rubber",
					"name": "eraser",
					"id": 1834,
					"code": 60583,
					"tempChar": ""
				},
				{
					"order": 24,
					"prevSize": 32,
					"ligatures": "eraser2, rubber2",
					"name": "eraser2",
					"id": 1835,
					"code": 60584,
					"tempChar": ""
				},
				{
					"order": 25,
					"prevSize": 32,
					"ligatures": "eraser3, rubber3",
					"name": "eraser3",
					"id": 1836,
					"code": 60585,
					"tempChar": ""
				},
				{
					"name": "eraser4",
					"id": 1448,
					"order": 1881,
					"prevSize": 32,
					"code": 61741,
					"tempChar": ""
				},
				{
					"order": 1347,
					"prevSize": 32,
					"ligatures": "esc, escape",
					"name": "esc",
					"id": 3158,
					"code": 62541,
					"tempChar": ""
				},
				{
					"name": "eur, euro",
					"id": 1483,
					"order": 1916,
					"prevSize": 32,
					"code": 61779,
					"tempChar": ""
				},
				{
					"order": 1044,
					"prevSize": 32,
					"ligatures": "evil, emoticon17",
					"name": "evil",
					"id": 2855,
					"code": 62238,
					"tempChar": ""
				},
				{
					"order": 1045,
					"prevSize": 32,
					"ligatures": "evil2, emoticon18",
					"name": "evil2",
					"id": 2856,
					"code": 62239,
					"tempChar": ""
				},
				{
					"id": 469,
					"order": 2684,
					"prevSize": 32,
					"code": 59852,
					"name": "examine",
					"tempChar": ""
				},
				{
					"id": 470,
					"order": 2685,
					"prevSize": 32,
					"code": 59853,
					"name": "examine2",
					"tempChar": ""
				},
				{
					"name": "exchange",
					"id": 1389,
					"order": 1822,
					"prevSize": 32,
					"code": 61676,
					"tempChar": ""
				},
				{
					"name": "exclamation",
					"id": 1445,
					"order": 1878,
					"prevSize": 32,
					"code": 61738,
					"tempChar": ""
				},
				{
					"name": "exclamation-circle",
					"id": 1279,
					"order": 1712,
					"prevSize": 32,
					"code": 61546,
					"tempChar": ""
				},
				{
					"name": "exclamation-triangle, warning3",
					"id": 1285,
					"order": 1718,
					"prevSize": 32,
					"code": 61553,
					"tempChar": ""
				},
				{
					"order": 442,
					"prevSize": 32,
					"ligatures": "exclude, boolean-operation4",
					"name": "exclude",
					"id": 2253,
					"code": 61002,
					"tempChar": ""
				},
				{
					"order": 1145,
					"prevSize": 32,
					"ligatures": "exit, signout",
					"name": "exit",
					"id": 2956,
					"code": 62339,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "exit-up, up2",
					"order": 3264,
					"name": "exit-up",
					"id": 199,
					"code": 59496,
					"tempChar": ""
				},
				{
					"order": 1147,
					"prevSize": 32,
					"ligatures": "exit2, signout2",
					"name": "exit2",
					"id": 2958,
					"code": 62341,
					"tempChar": ""
				},
				{
					"order": 1149,
					"prevSize": 32,
					"ligatures": "exit3, signout3",
					"name": "exit3",
					"id": 2960,
					"code": 62343,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "exit, door2",
					"order": 3192,
					"name": "exit4",
					"id": 127,
					"code": 59424,
					"tempChar": ""
				},
				{
					"name": "expand",
					"id": 1274,
					"order": 1707,
					"prevSize": 32,
					"code": 61541,
					"tempChar": ""
				},
				{
					"id": 471,
					"order": 2686,
					"prevSize": 32,
					"code": 59854,
					"name": "expect",
					"tempChar": ""
				},
				{
					"id": 472,
					"order": 2687,
					"prevSize": 32,
					"code": 59855,
					"name": "expect2",
					"tempChar": ""
				},
				{
					"name": "expeditedssl",
					"id": 1702,
					"order": 2135,
					"prevSize": 32,
					"code": 62014,
					"tempChar": ""
				},
				{
					"id": 473,
					"order": 2688,
					"prevSize": 32,
					"code": 59856,
					"name": "experience",
					"tempChar": ""
				},
				{
					"id": 474,
					"order": 2689,
					"prevSize": 32,
					"code": 59857,
					"name": "experience2",
					"tempChar": ""
				},
				{
					"id": 1018,
					"order": 2319,
					"prevSize": 32,
					"code": 60401,
					"name": "experience3",
					"tempChar": ""
				},
				{
					"id": 475,
					"order": 2690,
					"prevSize": 32,
					"code": 59858,
					"name": "experiment",
					"tempChar": ""
				},
				{
					"id": 476,
					"order": 2691,
					"prevSize": 32,
					"code": 59859,
					"name": "experiment2",
					"tempChar": ""
				},
				{
					"id": 1019,
					"order": 2320,
					"prevSize": 32,
					"code": 60402,
					"name": "experiment3",
					"tempChar": ""
				},
				{
					"id": 1020,
					"order": 2321,
					"prevSize": 32,
					"code": 60403,
					"name": "explain",
					"tempChar": ""
				},
				{
					"id": 477,
					"order": 2692,
					"prevSize": 32,
					"code": 59860,
					"name": "explode",
					"tempChar": ""
				},
				{
					"id": 478,
					"order": 2693,
					"prevSize": 32,
					"code": 59861,
					"name": "explode2",
					"tempChar": ""
				},
				{
					"id": 479,
					"order": 2694,
					"prevSize": 32,
					"code": 59862,
					"name": "explore",
					"tempChar": ""
				},
				{
					"id": 480,
					"order": 2695,
					"prevSize": 32,
					"code": 59863,
					"name": "explore2",
					"tempChar": ""
				},
				{
					"id": 481,
					"order": 2696,
					"prevSize": 32,
					"code": 59864,
					"name": "exterminate",
					"tempChar": ""
				},
				{
					"id": 482,
					"order": 2697,
					"prevSize": 32,
					"code": 59865,
					"name": "exterminate2",
					"tempChar": ""
				},
				{
					"name": "external-link",
					"id": 1313,
					"order": 1746,
					"prevSize": 32,
					"code": 61582,
					"tempChar": ""
				},
				{
					"name": "external-link-square",
					"id": 1477,
					"order": 1910,
					"prevSize": 32,
					"code": 61772,
					"tempChar": ""
				},
				{
					"id": 483,
					"order": 2698,
					"prevSize": 32,
					"code": 59866,
					"name": "extinguish",
					"tempChar": ""
				},
				{
					"id": 484,
					"order": 2699,
					"prevSize": 32,
					"code": 59867,
					"name": "extinguish2",
					"tempChar": ""
				},
				{
					"id": 485,
					"order": 2700,
					"prevSize": 32,
					"code": 59868,
					"name": "extrude",
					"tempChar": ""
				},
				{
					"id": 486,
					"order": 2701,
					"prevSize": 32,
					"code": 59869,
					"name": "extrude2",
					"tempChar": ""
				},
				{
					"order": 944,
					"prevSize": 32,
					"ligatures": "eye, views",
					"name": "eye",
					"id": 2755,
					"code": 62138,
					"tempChar": ""
				},
				{
					"order": 947,
					"prevSize": 32,
					"ligatures": "eye-blocked, views4",
					"name": "eye-blocked",
					"id": 2758,
					"code": 62141,
					"tempChar": ""
				},
				{
					"order": 949,
					"prevSize": 32,
					"ligatures": "eye-blocked2, views6",
					"name": "eye-blocked2",
					"id": 2760,
					"code": 62143,
					"tempChar": ""
				},
				{
					"order": 951,
					"prevSize": 32,
					"ligatures": "eye-blocked3, views8",
					"name": "eye-blocked3",
					"id": 2762,
					"code": 62145,
					"tempChar": ""
				},
				{
					"order": 946,
					"prevSize": 32,
					"ligatures": "eye-minus, views3",
					"name": "eye-minus",
					"id": 2757,
					"code": 62140,
					"tempChar": ""
				},
				{
					"order": 945,
					"prevSize": 32,
					"ligatures": "eye-plus, views2",
					"name": "eye-plus",
					"id": 2756,
					"code": 62139,
					"tempChar": ""
				},
				{
					"name": "eye-slash",
					"id": 1284,
					"order": 1717,
					"prevSize": 32,
					"code": 61552,
					"tempChar": ""
				},
				{
					"order": 948,
					"prevSize": 32,
					"ligatures": "eye2, views5",
					"name": "eye2",
					"id": 2759,
					"code": 62142,
					"tempChar": ""
				},
				{
					"order": 950,
					"prevSize": 32,
					"ligatures": "eye3, views7",
					"name": "eye3",
					"id": 2761,
					"code": 62144,
					"tempChar": ""
				},
				{
					"order": 952,
					"prevSize": 32,
					"ligatures": "eye4, views9",
					"name": "eye4",
					"id": 2763,
					"code": 62146,
					"tempChar": ""
				},
				{
					"name": "eye5",
					"id": 1283,
					"order": 1716,
					"prevSize": 32,
					"code": 61550,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "eye, vision",
					"order": 3187,
					"name": "eye6",
					"id": 122,
					"code": 59419,
					"tempChar": ""
				},
				{
					"order": 51,
					"prevSize": 32,
					"ligatures": "eyedropper, color6",
					"name": "eyedropper",
					"id": 1862,
					"code": 60611,
					"tempChar": ""
				},
				{
					"order": 52,
					"prevSize": 32,
					"ligatures": "eyedropper2, color7",
					"name": "eyedropper2",
					"id": 1863,
					"code": 60612,
					"tempChar": ""
				},
				{
					"order": 53,
					"prevSize": 32,
					"ligatures": "eyedropper3, color8",
					"name": "eyedropper3",
					"id": 1864,
					"code": 60613,
					"tempChar": ""
				},
				{
					"name": "eyedropper4",
					"id": 1641,
					"order": 2074,
					"prevSize": 32,
					"code": 61947,
					"tempChar": ""
				},
				{
					"name": "fa, font-awesome",
					"id": 1812,
					"order": 2245,
					"prevSize": 32,
					"code": 62132,
					"tempChar": ""
				},
				{
					"order": 1521,
					"prevSize": 32,
					"ligatures": "facebook, brand10",
					"name": "facebook",
					"id": 3332,
					"code": 62715,
					"tempChar": ""
				},
				{
					"name": "facebook-official",
					"id": 1688,
					"order": 2121,
					"prevSize": 32,
					"code": 62000,
					"tempChar": ""
				},
				{
					"name": "facebook-square",
					"id": 1301,
					"order": 1734,
					"prevSize": 32,
					"code": 61570,
					"tempChar": ""
				},
				{
					"order": 1522,
					"prevSize": 32,
					"ligatures": "facebook2, brand11",
					"name": "facebook2",
					"id": 3333,
					"code": 62716,
					"tempChar": ""
				},
				{
					"name": "facebook3, facebook-f",
					"id": 1324,
					"order": 1757,
					"prevSize": 32,
					"code": 61594,
					"tempChar": ""
				},
				{
					"order": 617,
					"prevSize": 32,
					"ligatures": "factory, manufacture",
					"name": "factory",
					"id": 2428,
					"code": 61177,
					"tempChar": ""
				},
				{
					"id": 487,
					"order": 2702,
					"prevSize": 32,
					"code": 59870,
					"name": "fail",
					"tempChar": ""
				},
				{
					"id": 488,
					"order": 2703,
					"prevSize": 32,
					"code": 59871,
					"name": "fail2",
					"tempChar": ""
				},
				{
					"id": 489,
					"order": 2704,
					"prevSize": 32,
					"code": 59872,
					"name": "fall",
					"tempChar": ""
				},
				{
					"id": 490,
					"order": 2705,
					"prevSize": 32,
					"code": 59873,
					"name": "fall2",
					"tempChar": ""
				},
				{
					"order": 982,
					"prevSize": 32,
					"ligatures": "fan, wind",
					"name": "fan",
					"id": 2793,
					"code": 62176,
					"tempChar": ""
				},
				{
					"name": "fast-backward",
					"id": 1248,
					"order": 1681,
					"prevSize": 32,
					"code": 61513,
					"tempChar": ""
				},
				{
					"name": "fast-forward",
					"id": 1254,
					"order": 1687,
					"prevSize": 32,
					"code": 61520,
					"tempChar": ""
				},
				{
					"id": 491,
					"order": 2706,
					"prevSize": 32,
					"code": 59874,
					"name": "fasten",
					"tempChar": ""
				},
				{
					"id": 492,
					"order": 2707,
					"prevSize": 32,
					"code": 59875,
					"name": "fasten2",
					"tempChar": ""
				},
				{
					"id": 493,
					"order": 2708,
					"prevSize": 32,
					"code": 59876,
					"name": "father",
					"tempChar": ""
				},
				{
					"id": 494,
					"order": 2709,
					"prevSize": 32,
					"code": 59877,
					"name": "father2",
					"tempChar": ""
				},
				{
					"name": "fax",
					"id": 1567,
					"order": 2000,
					"prevSize": 32,
					"code": 61868,
					"tempChar": ""
				},
				{
					"order": 136,
					"prevSize": 32,
					"ligatures": "feed, wave",
					"name": "feed",
					"id": 1947,
					"code": 60696,
					"tempChar": ""
				},
				{
					"name": "feed2, rss3",
					"id": 1328,
					"order": 1761,
					"prevSize": 32,
					"code": 61598,
					"tempChar": ""
				},
				{
					"id": 495,
					"order": 2710,
					"prevSize": 32,
					"code": 59878,
					"name": "feed3",
					"tempChar": ""
				},
				{
					"id": 496,
					"order": 2711,
					"prevSize": 32,
					"code": 59879,
					"name": "feed4",
					"tempChar": ""
				},
				{
					"id": 1021,
					"order": 2322,
					"prevSize": 32,
					"code": 60404,
					"name": "feed5",
					"tempChar": ""
				},
				{
					"order": 1025,
					"prevSize": 32,
					"ligatures": "female2, gender2",
					"name": "female",
					"id": 2836,
					"code": 62219,
					"tempChar": ""
				},
				{
					"name": "female2",
					"id": 1527,
					"order": 1960,
					"prevSize": 32,
					"code": 61826,
					"tempChar": ""
				},
				{
					"order": 1151,
					"prevSize": 32,
					"ligatures": "fence",
					"name": "fence",
					"id": 2962,
					"code": 62345,
					"tempChar": ""
				},
				{
					"id": 1022,
					"order": 2323,
					"prevSize": 32,
					"code": 60405,
					"name": "ferment",
					"tempChar": ""
				},
				{
					"id": 497,
					"order": 2712,
					"prevSize": 32,
					"code": 59880,
					"name": "fight",
					"tempChar": ""
				},
				{
					"id": 498,
					"order": 2713,
					"prevSize": 32,
					"code": 59881,
					"name": "fight2",
					"tempChar": ""
				},
				{
					"id": 1023,
					"order": 2324,
					"prevSize": 32,
					"code": 60406,
					"name": "fight3",
					"tempChar": ""
				},
				{
					"name": "fighter-jet",
					"id": 1403,
					"order": 1836,
					"prevSize": 32,
					"code": 61691,
					"tempChar": ""
				},
				{
					"name": "file",
					"id": 1491,
					"order": 1924,
					"prevSize": 32,
					"code": 61787,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "file-add, file2",
					"order": 3190,
					"name": "file-add",
					"id": 125,
					"code": 59422,
					"tempChar": ""
				},
				{
					"name": "file-archive-o, file-zip-o",
					"id": 1591,
					"order": 2024,
					"prevSize": 32,
					"code": 61894,
					"tempChar": ""
				},
				{
					"name": "file-audio-o, file-sound-o",
					"id": 1592,
					"order": 2025,
					"prevSize": 32,
					"code": 61895,
					"tempChar": ""
				},
				{
					"order": 171,
					"prevSize": 32,
					"ligatures": "file-check, file13",
					"name": "file-check",
					"id": 1982,
					"code": 60731,
					"tempChar": ""
				},
				{
					"order": 172,
					"prevSize": 32,
					"ligatures": "file-check2, file14",
					"name": "file-check2",
					"id": 1983,
					"code": 60732,
					"tempChar": ""
				},
				{
					"name": "file-code-o",
					"id": 1594,
					"order": 2027,
					"prevSize": 32,
					"code": 61897,
					"tempChar": ""
				},
				{
					"order": 191,
					"prevSize": 32,
					"ligatures": "file-css, file31",
					"name": "file-css",
					"id": 2002,
					"code": 60751,
					"tempChar": ""
				},
				{
					"order": 192,
					"prevSize": 32,
					"ligatures": "file-css2, file32",
					"name": "file-css2",
					"id": 2003,
					"code": 60752,
					"tempChar": ""
				},
				{
					"order": 167,
					"prevSize": 32,
					"ligatures": "file-download, file9",
					"name": "file-download",
					"id": 1978,
					"code": 60727,
					"tempChar": ""
				},
				{
					"order": 168,
					"prevSize": 32,
					"ligatures": "file-download2, file10",
					"name": "file-download2",
					"id": 1979,
					"code": 60728,
					"tempChar": ""
				},
				{
					"order": 159,
					"prevSize": 32,
					"ligatures": "file-empty, file3",
					"name": "file-empty",
					"id": 1970,
					"code": 60719,
					"tempChar": ""
				},
				{
					"order": 160,
					"prevSize": 32,
					"ligatures": "file-empty2, file4",
					"name": "file-empty2",
					"id": 1971,
					"code": 60720,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "file-empty, file",
					"order": 3189,
					"name": "file-empty3",
					"id": 124,
					"code": 59421,
					"tempChar": ""
				},
				{
					"order": 1603,
					"prevSize": 32,
					"ligatures": "file-excel, file44",
					"name": "file-excel",
					"id": 3414,
					"code": 62797,
					"tempChar": ""
				},
				{
					"name": "file-excel-o",
					"id": 1588,
					"order": 2021,
					"prevSize": 32,
					"code": 61891,
					"tempChar": ""
				},
				{
					"order": 173,
					"prevSize": 32,
					"ligatures": "file-eye, file15",
					"name": "file-eye",
					"id": 1984,
					"code": 60733,
					"tempChar": ""
				},
				{
					"order": 174,
					"prevSize": 32,
					"ligatures": "file-eye2, file16",
					"name": "file-eye2",
					"id": 1985,
					"code": 60734,
					"tempChar": ""
				},
				{
					"name": "file-image-o, file-photo-o, file-picture-o",
					"id": 1590,
					"order": 2023,
					"prevSize": 32,
					"code": 61893,
					"tempChar": ""
				},
				{
					"order": 197,
					"prevSize": 32,
					"ligatures": "file-locked, file37",
					"name": "file-locked",
					"id": 2008,
					"code": 60757,
					"tempChar": ""
				},
				{
					"order": 198,
					"prevSize": 32,
					"ligatures": "file-locked2, file38",
					"name": "file-locked2",
					"id": 2009,
					"code": 60758,
					"tempChar": ""
				},
				{
					"order": 165,
					"prevSize": 32,
					"ligatures": "file-minus, file7",
					"name": "file-minus",
					"id": 1976,
					"code": 60725,
					"tempChar": ""
				},
				{
					"order": 166,
					"prevSize": 32,
					"ligatures": "file-minus2, file8",
					"name": "file-minus2",
					"id": 1977,
					"code": 60726,
					"tempChar": ""
				},
				{
					"name": "file-movie-o, file-video-o",
					"id": 1593,
					"order": 2026,
					"prevSize": 32,
					"code": 61896,
					"tempChar": ""
				},
				{
					"order": 179,
					"prevSize": 32,
					"ligatures": "file-music, file21",
					"name": "file-music",
					"id": 1990,
					"code": 60739,
					"tempChar": ""
				},
				{
					"order": 180,
					"prevSize": 32,
					"ligatures": "file-music2, file22",
					"name": "file-music2",
					"id": 1991,
					"code": 60740,
					"tempChar": ""
				},
				{
					"name": "file-o",
					"id": 1200,
					"order": 1633,
					"prevSize": 32,
					"code": 61462,
					"tempChar": ""
				},
				{
					"order": 1601,
					"prevSize": 32,
					"ligatures": "file-openoffice, file42",
					"name": "file-openoffice",
					"id": 3412,
					"code": 62795,
					"tempChar": ""
				},
				{
					"order": 1600,
					"prevSize": 32,
					"ligatures": "file-pdf, file41",
					"name": "file-pdf",
					"id": 3411,
					"code": 62794,
					"tempChar": ""
				},
				{
					"name": "file-pdf-o",
					"id": 1586,
					"order": 2019,
					"prevSize": 32,
					"code": 61889,
					"tempChar": ""
				},
				{
					"order": 177,
					"prevSize": 32,
					"ligatures": "file-picture, file19",
					"name": "file-picture",
					"id": 1988,
					"code": 60737,
					"tempChar": ""
				},
				{
					"order": 178,
					"prevSize": 32,
					"ligatures": "file-picture2, file20",
					"name": "file-picture2",
					"id": 1989,
					"code": 60738,
					"tempChar": ""
				},
				{
					"order": 181,
					"prevSize": 32,
					"ligatures": "file-play, file23",
					"name": "file-play",
					"id": 1992,
					"code": 60741,
					"tempChar": ""
				},
				{
					"order": 182,
					"prevSize": 32,
					"ligatures": "file-play2, file24",
					"name": "file-play2",
					"id": 1993,
					"code": 60742,
					"tempChar": ""
				},
				{
					"order": 163,
					"prevSize": 32,
					"ligatures": "file-plus, file5",
					"name": "file-plus",
					"id": 1974,
					"code": 60723,
					"tempChar": ""
				},
				{
					"order": 164,
					"prevSize": 32,
					"ligatures": "file-plus2, file6",
					"name": "file-plus2",
					"id": 1975,
					"code": 60724,
					"tempChar": ""
				},
				{
					"name": "file-powerpoint-o",
					"id": 1589,
					"order": 2022,
					"prevSize": 32,
					"code": 61892,
					"tempChar": ""
				},
				{
					"order": 193,
					"prevSize": 32,
					"ligatures": "file-presentation, file33",
					"name": "file-presentation",
					"id": 2004,
					"code": 60753,
					"tempChar": ""
				},
				{
					"order": 194,
					"prevSize": 32,
					"ligatures": "file-presentation2, file34",
					"name": "file-presentation2",
					"id": 2005,
					"code": 60754,
					"tempChar": ""
				},
				{
					"order": 199,
					"prevSize": 32,
					"ligatures": "file-spreadsheet, file39",
					"name": "file-spreadsheet",
					"id": 2010,
					"code": 60759,
					"tempChar": ""
				},
				{
					"order": 200,
					"prevSize": 32,
					"ligatures": "file-spreadsheet2, file40",
					"name": "file-spreadsheet2",
					"id": 2011,
					"code": 60760,
					"tempChar": ""
				},
				{
					"order": 195,
					"prevSize": 32,
					"ligatures": "file-stats, file35",
					"name": "file-stats",
					"id": 2006,
					"code": 60755,
					"tempChar": ""
				},
				{
					"order": 196,
					"prevSize": 32,
					"ligatures": "file-stats2, file36",
					"name": "file-stats2",
					"id": 2007,
					"code": 60756,
					"tempChar": ""
				},
				{
					"order": 157,
					"prevSize": 32,
					"ligatures": "file-text, file",
					"name": "file-text",
					"id": 1968,
					"code": 60717,
					"tempChar": ""
				},
				{
					"name": "file-text-o",
					"id": 1398,
					"order": 1831,
					"prevSize": 32,
					"code": 61686,
					"tempChar": ""
				},
				{
					"order": 175,
					"prevSize": 32,
					"ligatures": "file-text2, file17",
					"name": "file-text2",
					"id": 1986,
					"code": 60735,
					"tempChar": ""
				},
				{
					"order": 176,
					"prevSize": 32,
					"ligatures": "file-text3, file18",
					"name": "file-text3",
					"id": 1987,
					"code": 60736,
					"tempChar": ""
				},
				{
					"name": "file-text4",
					"id": 1492,
					"order": 1925,
					"prevSize": 32,
					"code": 61788,
					"tempChar": ""
				},
				{
					"order": 169,
					"prevSize": 32,
					"ligatures": "file-upload, file11",
					"name": "file-upload",
					"id": 1980,
					"code": 60729,
					"tempChar": ""
				},
				{
					"order": 170,
					"prevSize": 32,
					"ligatures": "file-upload2, file12",
					"name": "file-upload2",
					"id": 1981,
					"code": 60730,
					"tempChar": ""
				},
				{
					"order": 183,
					"prevSize": 32,
					"ligatures": "file-video, file25",
					"name": "file-video",
					"id": 1994,
					"code": 60743,
					"tempChar": ""
				},
				{
					"order": 184,
					"prevSize": 32,
					"ligatures": "file-video2, file26",
					"name": "file-video2",
					"id": 1995,
					"code": 60744,
					"tempChar": ""
				},
				{
					"order": 1602,
					"prevSize": 32,
					"ligatures": "file-word, file43",
					"name": "file-word",
					"id": 3413,
					"code": 62796,
					"tempChar": ""
				},
				{
					"name": "file-word-o",
					"id": 1587,
					"order": 2020,
					"prevSize": 32,
					"code": 61890,
					"tempChar": ""
				},
				{
					"order": 189,
					"prevSize": 32,
					"ligatures": "file-xml, file29",
					"name": "file-xml",
					"id": 2000,
					"code": 60749,
					"tempChar": ""
				},
				{
					"order": 190,
					"prevSize": 32,
					"ligatures": "file-xml2, file30",
					"name": "file-xml2",
					"id": 2001,
					"code": 60750,
					"tempChar": ""
				},
				{
					"order": 187,
					"prevSize": 32,
					"ligatures": "file-zip, file27",
					"name": "file-zip",
					"id": 1998,
					"code": 60747,
					"tempChar": ""
				},
				{
					"order": 188,
					"prevSize": 32,
					"ligatures": "file-zip2, file28",
					"name": "file-zip2",
					"id": 1999,
					"code": 60748,
					"tempChar": ""
				},
				{
					"order": 161,
					"prevSize": 32,
					"ligatures": "files-empty, files",
					"name": "files-empty",
					"id": 1972,
					"code": 60721,
					"tempChar": ""
				},
				{
					"order": 162,
					"prevSize": 32,
					"ligatures": "files-empty2, files2",
					"name": "files-empty2",
					"id": 1973,
					"code": 60722,
					"tempChar": ""
				},
				{
					"id": 499,
					"order": 2714,
					"prevSize": 32,
					"code": 59882,
					"name": "fill",
					"tempChar": ""
				},
				{
					"id": 500,
					"order": 2715,
					"prevSize": 32,
					"code": 59883,
					"name": "fill2",
					"tempChar": ""
				},
				{
					"id": 1024,
					"order": 2325,
					"prevSize": 32,
					"code": 60407,
					"name": "fill3",
					"tempChar": ""
				},
				{
					"order": 96,
					"prevSize": 32,
					"ligatures": "film, video6",
					"name": "film",
					"id": 1907,
					"code": 60656,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "film-play, video",
					"order": 3196,
					"name": "film-play",
					"id": 131,
					"code": 59428,
					"tempChar": ""
				},
				{
					"order": 97,
					"prevSize": 32,
					"ligatures": "film2, video7",
					"name": "film2",
					"id": 1908,
					"code": 60657,
					"tempChar": ""
				},
				{
					"order": 98,
					"prevSize": 32,
					"ligatures": "film3, video8",
					"name": "film3",
					"id": 1909,
					"code": 60658,
					"tempChar": ""
				},
				{
					"order": 99,
					"prevSize": 32,
					"ligatures": "film4, video9",
					"name": "film4",
					"id": 1910,
					"code": 60659,
					"tempChar": ""
				},
				{
					"name": "film5",
					"id": 1187,
					"order": 1620,
					"prevSize": 32,
					"code": 61448,
					"tempChar": ""
				},
				{
					"id": 501,
					"order": 2716,
					"prevSize": 32,
					"code": 59884,
					"name": "film6",
					"tempChar": ""
				},
				{
					"id": 502,
					"order": 2717,
					"prevSize": 32,
					"code": 59885,
					"name": "film7",
					"tempChar": ""
				},
				{
					"order": 1419,
					"prevSize": 32,
					"ligatures": "filter, funnel",
					"name": "filter",
					"id": 3230,
					"code": 62613,
					"tempChar": ""
				},
				{
					"order": 1420,
					"prevSize": 32,
					"ligatures": "filter2, funnel2",
					"name": "filter2",
					"id": 3231,
					"code": 62614,
					"tempChar": ""
				},
				{
					"order": 1421,
					"prevSize": 32,
					"ligatures": "filter3, funnel3",
					"name": "filter3",
					"id": 3232,
					"code": 62615,
					"tempChar": ""
				},
				{
					"order": 1422,
					"prevSize": 32,
					"ligatures": "filter4, funnel4",
					"name": "filter4",
					"id": 3233,
					"code": 62616,
					"tempChar": ""
				},
				{
					"name": "filter5",
					"id": 1344,
					"order": 1777,
					"prevSize": 32,
					"code": 61616,
					"tempChar": ""
				},
				{
					"id": 1025,
					"order": 2326,
					"prevSize": 32,
					"code": 60408,
					"name": "filter6",
					"tempChar": ""
				},
				{
					"id": 503,
					"order": 2718,
					"prevSize": 32,
					"code": 59886,
					"name": "find",
					"tempChar": ""
				},
				{
					"id": 504,
					"order": 2719,
					"prevSize": 32,
					"code": 59887,
					"name": "find2",
					"tempChar": ""
				},
				{
					"order": 1568,
					"prevSize": 32,
					"ligatures": "finder, brand54",
					"name": "finder",
					"id": 3379,
					"code": 62762,
					"tempChar": ""
				},
				{
					"order": 838,
					"prevSize": 32,
					"ligatures": "finish, soprts8",
					"name": "finish",
					"id": 2649,
					"code": 61398,
					"tempChar": ""
				},
				{
					"id": 1026,
					"order": 2327,
					"prevSize": 32,
					"code": 60409,
					"name": "finish2",
					"tempChar": ""
				},
				{
					"order": 746,
					"prevSize": 32,
					"ligatures": "fire, flame",
					"name": "fire",
					"id": 2557,
					"code": 61306,
					"tempChar": ""
				},
				{
					"name": "fire-extinguisher",
					"id": 1454,
					"order": 1887,
					"prevSize": 32,
					"code": 61748,
					"tempChar": ""
				},
				{
					"order": 747,
					"prevSize": 32,
					"ligatures": "fire2, flame2",
					"name": "fire2",
					"id": 2558,
					"code": 61307,
					"tempChar": ""
				},
				{
					"name": "fire3",
					"id": 1282,
					"order": 1715,
					"prevSize": 32,
					"code": 61549,
					"tempChar": ""
				},
				{
					"order": 1595,
					"prevSize": 32,
					"ligatures": "firefox, browser2",
					"name": "firefox",
					"id": 3406,
					"code": 62789,
					"tempChar": ""
				},
				{
					"name": "firefox2",
					"id": 1742,
					"order": 2175,
					"prevSize": 32,
					"code": 62057,
					"tempChar": ""
				},
				{
					"order": 1164,
					"prevSize": 32,
					"ligatures": "first, player13",
					"name": "first",
					"id": 2975,
					"code": 62358,
					"tempChar": ""
				},
				{
					"name": "first-order",
					"id": 1808,
					"order": 2241,
					"prevSize": 32,
					"code": 62128,
					"tempChar": ""
				},
				{
					"order": 1207,
					"prevSize": 32,
					"ligatures": "first2, player18",
					"name": "first2",
					"id": 3018,
					"code": 62401,
					"tempChar": ""
				},
				{
					"order": 706,
					"prevSize": 32,
					"ligatures": "fish, food5",
					"name": "fish",
					"id": 2517,
					"code": 61266,
					"tempChar": ""
				},
				{
					"id": 505,
					"order": 2720,
					"prevSize": 32,
					"code": 59888,
					"name": "fix",
					"tempChar": ""
				},
				{
					"id": 506,
					"order": 2721,
					"prevSize": 32,
					"code": 59889,
					"name": "fix2",
					"tempChar": ""
				},
				{
					"order": 934,
					"prevSize": 32,
					"ligatures": "flag, report",
					"name": "flag",
					"id": 2745,
					"code": 62063,
					"tempChar": ""
				},
				{
					"name": "flag-checkered",
					"id": 1434,
					"order": 1867,
					"prevSize": 32,
					"code": 61726,
					"tempChar": ""
				},
				{
					"name": "flag-o",
					"id": 1433,
					"order": 1866,
					"prevSize": 32,
					"code": 61725,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "flag, report",
					"order": 3183,
					"name": "flag10",
					"id": 118,
					"code": 59415,
					"tempChar": ""
				},
				{
					"id": 507,
					"order": 2722,
					"prevSize": 32,
					"code": 59890,
					"name": "flag11",
					"tempChar": ""
				},
				{
					"id": 508,
					"order": 2723,
					"prevSize": 32,
					"code": 59891,
					"name": "flag12",
					"tempChar": ""
				},
				{
					"id": 1027,
					"order": 2328,
					"prevSize": 32,
					"code": 60410,
					"name": "flag13",
					"tempChar": ""
				},
				{
					"order": 935,
					"prevSize": 32,
					"ligatures": "flag2, report2",
					"name": "flag2",
					"id": 2746,
					"code": 62079,
					"tempChar": ""
				},
				{
					"order": 936,
					"prevSize": 32,
					"ligatures": "flag3, report3",
					"name": "flag3",
					"id": 2747,
					"code": 62095,
					"tempChar": ""
				},
				{
					"order": 937,
					"prevSize": 32,
					"ligatures": "flag4, report4",
					"name": "flag4",
					"id": 2748,
					"code": 62111,
					"tempChar": ""
				},
				{
					"order": 938,
					"prevSize": 32,
					"ligatures": "flag5, report5",
					"name": "flag5",
					"id": 2749,
					"code": 62127,
					"tempChar": ""
				},
				{
					"order": 939,
					"prevSize": 32,
					"ligatures": "flag6, report6",
					"name": "flag6",
					"id": 2750,
					"code": 62133,
					"tempChar": ""
				},
				{
					"order": 940,
					"prevSize": 32,
					"ligatures": "flag7, report7",
					"name": "flag7",
					"id": 2751,
					"code": 62134,
					"tempChar": ""
				},
				{
					"order": 941,
					"prevSize": 32,
					"ligatures": "flag8, report8",
					"name": "flag8",
					"id": 2752,
					"code": 62135,
					"tempChar": ""
				},
				{
					"name": "flag9",
					"id": 1212,
					"order": 1645,
					"prevSize": 32,
					"code": 61476,
					"tempChar": ""
				},
				{
					"id": 509,
					"order": 2724,
					"prevSize": 32,
					"code": 59892,
					"name": "flake",
					"tempChar": ""
				},
				{
					"id": 510,
					"order": 2725,
					"prevSize": 32,
					"code": 59893,
					"name": "flake2",
					"tempChar": ""
				},
				{
					"name": "flask",
					"id": 1350,
					"order": 1783,
					"prevSize": 32,
					"code": 61635,
					"tempChar": ""
				},
				{
					"order": 1590,
					"prevSize": 32,
					"ligatures": "flattr, brand76",
					"name": "flattr",
					"id": 3401,
					"code": 62784,
					"tempChar": ""
				},
				{
					"order": 1540,
					"prevSize": 32,
					"ligatures": "flickr, brand27",
					"name": "flickr",
					"id": 3351,
					"code": 62734,
					"tempChar": ""
				},
				{
					"order": 1541,
					"prevSize": 32,
					"ligatures": "flickr2, brand28",
					"name": "flickr2",
					"id": 3352,
					"code": 62735,
					"tempChar": ""
				},
				{
					"order": 1542,
					"prevSize": 32,
					"ligatures": "flickr3, brand29",
					"name": "flickr3",
					"id": 3353,
					"code": 62736,
					"tempChar": ""
				},
				{
					"order": 1543,
					"prevSize": 32,
					"ligatures": "flickr4, brand30",
					"name": "flickr4",
					"id": 3354,
					"code": 62737,
					"tempChar": ""
				},
				{
					"name": "flickr5",
					"id": 1509,
					"order": 1942,
					"prevSize": 32,
					"code": 61806,
					"tempChar": ""
				},
				{
					"id": 511,
					"order": 2726,
					"prevSize": 32,
					"code": 59894,
					"name": "flip",
					"tempChar": ""
				},
				{
					"order": 433,
					"prevSize": 32,
					"ligatures": "flip-horizontal, mirror3",
					"name": "flip-horizontal",
					"id": 2244,
					"code": 60993,
					"tempChar": ""
				},
				{
					"order": 434,
					"prevSize": 32,
					"ligatures": "flip-horizontal2, mirror4",
					"name": "flip-horizontal2",
					"id": 2245,
					"code": 60994,
					"tempChar": ""
				},
				{
					"order": 431,
					"prevSize": 32,
					"ligatures": "flip-vertical, mirror",
					"name": "flip-vertical",
					"id": 2242,
					"code": 60991,
					"tempChar": ""
				},
				{
					"order": 432,
					"prevSize": 32,
					"ligatures": "flip-vertical2, mirror2",
					"name": "flip-vertical2",
					"id": 2243,
					"code": 60992,
					"tempChar": ""
				},
				{
					"order": 435,
					"prevSize": 32,
					"ligatures": "flip-vertical3, mirror5",
					"name": "flip-vertical3",
					"id": 2246,
					"code": 60995,
					"tempChar": ""
				},
				{
					"order": 436,
					"prevSize": 32,
					"ligatures": "flip-vertical4, mirror6",
					"name": "flip-vertical4",
					"id": 2247,
					"code": 60996,
					"tempChar": ""
				},
				{
					"id": 512,
					"order": 2727,
					"prevSize": 32,
					"code": 59895,
					"name": "flip2",
					"tempChar": ""
				},
				{
					"id": 513,
					"order": 2728,
					"prevSize": 32,
					"code": 59896,
					"name": "float",
					"tempChar": ""
				},
				{
					"id": 514,
					"order": 2729,
					"prevSize": 32,
					"code": 59897,
					"name": "float2",
					"tempChar": ""
				},
				{
					"id": 1028,
					"order": 2329,
					"prevSize": 32,
					"code": 60411,
					"name": "float3",
					"tempChar": ""
				},
				{
					"order": 395,
					"prevSize": 32,
					"ligatures": "floppy-disk, save2",
					"name": "floppy-disk",
					"id": 2206,
					"code": 60955,
					"tempChar": ""
				},
				{
					"order": 398,
					"prevSize": 32,
					"ligatures": "floppy-disk2, save5",
					"name": "floppy-disk2",
					"id": 2209,
					"code": 60958,
					"tempChar": ""
				},
				{
					"order": 399,
					"prevSize": 32,
					"ligatures": "floppy-disk3, save6",
					"name": "floppy-disk3",
					"id": 2210,
					"code": 60959,
					"tempChar": ""
				},
				{
					"order": 396,
					"prevSize": 32,
					"ligatures": "floppy-disks, save3",
					"name": "floppy-disks",
					"id": 2207,
					"code": 60956,
					"tempChar": ""
				},
				{
					"order": 397,
					"prevSize": 32,
					"ligatures": "floppy-disks2, save4",
					"name": "floppy-disks2",
					"id": 2208,
					"code": 60957,
					"tempChar": ""
				},
				{
					"name": "floppy-o, save",
					"id": 1354,
					"order": 1787,
					"prevSize": 32,
					"code": 61639,
					"tempChar": ""
				},
				{
					"id": 515,
					"order": 2730,
					"prevSize": 32,
					"code": 59898,
					"name": "flow",
					"tempChar": ""
				},
				{
					"id": 516,
					"order": 2731,
					"prevSize": 32,
					"code": 59899,
					"name": "flow2",
					"tempChar": ""
				},
				{
					"id": 1029,
					"order": 2330,
					"prevSize": 32,
					"code": 60412,
					"name": "flow3",
					"tempChar": ""
				},
				{
					"order": 733,
					"prevSize": 32,
					"ligatures": "flower, nature9",
					"name": "flower",
					"id": 2544,
					"code": 61293,
					"tempChar": ""
				},
				{
					"order": 734,
					"prevSize": 32,
					"ligatures": "flower2, nature10",
					"name": "flower2",
					"id": 2545,
					"code": 61294,
					"tempChar": ""
				},
				{
					"id": 517,
					"order": 2732,
					"prevSize": 32,
					"code": 59900,
					"name": "fly",
					"tempChar": ""
				},
				{
					"id": 518,
					"order": 2733,
					"prevSize": 32,
					"code": 59901,
					"name": "fly2",
					"tempChar": ""
				},
				{
					"id": 1030,
					"order": 2331,
					"prevSize": 32,
					"code": 60413,
					"name": "fly3",
					"tempChar": ""
				},
				{
					"id": 519,
					"order": 2734,
					"prevSize": 32,
					"code": 59902,
					"name": "focus",
					"tempChar": ""
				},
				{
					"id": 520,
					"order": 2735,
					"prevSize": 32,
					"code": 59903,
					"name": "focus2",
					"tempChar": ""
				},
				{
					"id": 521,
					"order": 2736,
					"prevSize": 32,
					"code": 59904,
					"name": "fold",
					"tempChar": ""
				},
				{
					"id": 522,
					"order": 2737,
					"prevSize": 32,
					"code": 59905,
					"name": "fold2",
					"tempChar": ""
				},
				{
					"id": 1031,
					"order": 2332,
					"prevSize": 32,
					"code": 60414,
					"name": "fold3",
					"tempChar": ""
				},
				{
					"order": 210,
					"prevSize": 32,
					"ligatures": "folder, directory",
					"name": "folder",
					"id": 2021,
					"code": 60770,
					"tempChar": ""
				},
				{
					"order": 218,
					"prevSize": 32,
					"ligatures": "folder-check, directory8",
					"name": "folder-check",
					"id": 2029,
					"code": 60778,
					"tempChar": ""
				},
				{
					"order": 212,
					"prevSize": 32,
					"ligatures": "folder-download, directory2",
					"name": "folder-download",
					"id": 2023,
					"code": 60772,
					"tempChar": ""
				},
				{
					"order": 229,
					"prevSize": 32,
					"ligatures": "folder-download2, directory19",
					"name": "folder-download2",
					"id": 2040,
					"code": 60789,
					"tempChar": ""
				},
				{
					"order": 231,
					"prevSize": 32,
					"ligatures": "folder-download3, directory21",
					"name": "folder-download3",
					"id": 2042,
					"code": 60791,
					"tempChar": ""
				},
				{
					"order": 219,
					"prevSize": 32,
					"ligatures": "folder-heart, directory9",
					"name": "folder-heart",
					"id": 2030,
					"code": 60779,
					"tempChar": ""
				},
				{
					"order": 216,
					"prevSize": 32,
					"ligatures": "folder-minus, directory6",
					"name": "folder-minus",
					"id": 2027,
					"code": 60776,
					"tempChar": ""
				},
				{
					"order": 217,
					"prevSize": 32,
					"ligatures": "folder-minus2, directory7",
					"name": "folder-minus2",
					"id": 2028,
					"code": 60777,
					"tempChar": ""
				},
				{
					"order": 226,
					"prevSize": 32,
					"ligatures": "folder-minus3, directory16",
					"name": "folder-minus3",
					"id": 2037,
					"code": 60786,
					"tempChar": ""
				},
				{
					"order": 228,
					"prevSize": 32,
					"ligatures": "folder-minus4, directory18",
					"name": "folder-minus4",
					"id": 2039,
					"code": 60788,
					"tempChar": ""
				},
				{
					"name": "folder-o",
					"id": 1426,
					"order": 1859,
					"prevSize": 32,
					"code": 61716,
					"tempChar": ""
				},
				{
					"order": 222,
					"prevSize": 32,
					"ligatures": "folder-open, directory12",
					"name": "folder-open",
					"id": 2033,
					"code": 60782,
					"tempChar": ""
				},
				{
					"name": "folder-open-o",
					"id": 1427,
					"order": 1860,
					"prevSize": 32,
					"code": 61717,
					"tempChar": ""
				},
				{
					"order": 234,
					"prevSize": 32,
					"ligatures": "folder-open2, directory24",
					"name": "folder-open2",
					"id": 2045,
					"code": 60794,
					"tempChar": ""
				},
				{
					"order": 236,
					"prevSize": 32,
					"ligatures": "folder-open3, directory26",
					"name": "folder-open3",
					"id": 2047,
					"code": 60796,
					"tempChar": ""
				},
				{
					"name": "folder-open4",
					"id": 1296,
					"order": 1729,
					"prevSize": 32,
					"code": 61564,
					"tempChar": ""
				},
				{
					"order": 214,
					"prevSize": 32,
					"ligatures": "folder-plus, directory4",
					"name": "folder-plus",
					"id": 2025,
					"code": 60774,
					"tempChar": ""
				},
				{
					"order": 215,
					"prevSize": 32,
					"ligatures": "folder-plus2, directory5",
					"name": "folder-plus2",
					"id": 2026,
					"code": 60775,
					"tempChar": ""
				},
				{
					"order": 225,
					"prevSize": 32,
					"ligatures": "folder-plus3, directory15",
					"name": "folder-plus3",
					"id": 2036,
					"code": 60785,
					"tempChar": ""
				},
				{
					"order": 227,
					"prevSize": 32,
					"ligatures": "folder-plus4, directory17",
					"name": "folder-plus4",
					"id": 2038,
					"code": 60787,
					"tempChar": ""
				},
				{
					"order": 220,
					"prevSize": 32,
					"ligatures": "folder-remove, directory10",
					"name": "folder-remove",
					"id": 2031,
					"code": 60780,
					"tempChar": ""
				},
				{
					"order": 211,
					"prevSize": 32,
					"ligatures": "folder-search, dicrectory",
					"name": "folder-search",
					"id": 2022,
					"code": 60771,
					"tempChar": ""
				},
				{
					"order": 213,
					"prevSize": 32,
					"ligatures": "folder-upload, directory3",
					"name": "folder-upload",
					"id": 2024,
					"code": 60773,
					"tempChar": ""
				},
				{
					"order": 230,
					"prevSize": 32,
					"ligatures": "folder-upload2, directory20",
					"name": "folder-upload2",
					"id": 2041,
					"code": 60790,
					"tempChar": ""
				},
				{
					"order": 232,
					"prevSize": 32,
					"ligatures": "folder-upload3, directory22",
					"name": "folder-upload3",
					"id": 2043,
					"code": 60792,
					"tempChar": ""
				},
				{
					"order": 221,
					"prevSize": 32,
					"ligatures": "folder2, directory11",
					"name": "folder2",
					"id": 2032,
					"code": 60781,
					"tempChar": ""
				},
				{
					"order": 223,
					"prevSize": 32,
					"ligatures": "folder3, directory13",
					"name": "folder3",
					"id": 2034,
					"code": 60783,
					"tempChar": ""
				},
				{
					"order": 224,
					"prevSize": 32,
					"ligatures": "folder4, directory14",
					"name": "folder4",
					"id": 2035,
					"code": 60784,
					"tempChar": ""
				},
				{
					"order": 233,
					"prevSize": 32,
					"ligatures": "folder5, directory23",
					"name": "folder5",
					"id": 2044,
					"code": 60793,
					"tempChar": ""
				},
				{
					"order": 235,
					"prevSize": 32,
					"ligatures": "folder6, directory25",
					"name": "folder6",
					"id": 2046,
					"code": 60795,
					"tempChar": ""
				},
				{
					"name": "folder7",
					"id": 1295,
					"order": 1728,
					"prevSize": 32,
					"code": 61563,
					"tempChar": ""
				},
				{
					"order": 1423,
					"prevSize": 32,
					"ligatures": "font, typeface",
					"name": "font",
					"id": 3234,
					"code": 62617,
					"tempChar": ""
				},
				{
					"order": 1427,
					"prevSize": 32,
					"ligatures": "font-size, wysiwyg",
					"name": "font-size",
					"id": 3238,
					"code": 62621,
					"tempChar": ""
				},
				{
					"order": 1438,
					"prevSize": 32,
					"ligatures": "font-size2, wysiwyg10",
					"name": "font-size2",
					"id": 3249,
					"code": 62632,
					"tempChar": ""
				},
				{
					"name": "font2",
					"id": 1225,
					"order": 1658,
					"prevSize": 32,
					"code": 61489,
					"tempChar": ""
				},
				{
					"name": "fonticons",
					"id": 1763,
					"order": 2196,
					"prevSize": 32,
					"code": 62080,
					"tempChar": ""
				},
				{
					"order": 826,
					"prevSize": 32,
					"ligatures": "football, soprts",
					"name": "football",
					"id": 2637,
					"code": 61386,
					"tempChar": ""
				},
				{
					"order": 731,
					"prevSize": 32,
					"ligatures": "footprint, steps3",
					"name": "footprint",
					"id": 2542,
					"code": 61291,
					"tempChar": ""
				},
				{
					"id": 1032,
					"order": 2333,
					"prevSize": 32,
					"code": 60415,
					"name": "forbid",
					"tempChar": ""
				},
				{
					"id": 523,
					"order": 2738,
					"prevSize": 32,
					"code": 59906,
					"name": "forebode",
					"tempChar": ""
				},
				{
					"id": 524,
					"order": 2739,
					"prevSize": 32,
					"code": 59907,
					"name": "forebode2",
					"tempChar": ""
				},
				{
					"order": 701,
					"prevSize": 32,
					"ligatures": "fork-knife, food",
					"name": "fork-knife",
					"id": 2512,
					"code": 61261,
					"tempChar": ""
				},
				{
					"id": 525,
					"order": 2740,
					"prevSize": 32,
					"code": 59908,
					"name": "form",
					"tempChar": ""
				},
				{
					"id": 526,
					"order": 2741,
					"prevSize": 32,
					"code": 59909,
					"name": "form2",
					"tempChar": ""
				},
				{
					"id": 527,
					"order": 2742,
					"prevSize": 32,
					"code": 59910,
					"name": "format",
					"tempChar": ""
				},
				{
					"id": 528,
					"order": 2743,
					"prevSize": 32,
					"code": 59911,
					"name": "format2",
					"tempChar": ""
				},
				{
					"id": 1033,
					"order": 2334,
					"prevSize": 32,
					"code": 60416,
					"name": "format3",
					"tempChar": ""
				},
				{
					"name": "fort-awesome",
					"id": 1769,
					"order": 2202,
					"prevSize": 32,
					"code": 62086,
					"tempChar": ""
				},
				{
					"name": "forumbee",
					"id": 1661,
					"order": 2094,
					"prevSize": 32,
					"code": 61969,
					"tempChar": ""
				},
				{
					"order": 451,
					"prevSize": 32,
					"ligatures": "forward, right2",
					"name": "forward",
					"id": 2262,
					"code": 61011,
					"tempChar": ""
				},
				{
					"order": 1158,
					"prevSize": 32,
					"ligatures": "forward2, player7",
					"name": "forward2",
					"id": 2969,
					"code": 62352,
					"tempChar": ""
				},
				{
					"order": 1163,
					"prevSize": 32,
					"ligatures": "forward3, player12",
					"name": "forward3",
					"id": 2974,
					"code": 62357,
					"tempChar": ""
				},
				{
					"name": "forward4",
					"id": 1253,
					"order": 1686,
					"prevSize": 32,
					"code": 61518,
					"tempChar": ""
				},
				{
					"id": 1034,
					"order": 2335,
					"prevSize": 32,
					"code": 60417,
					"name": "forward5",
					"tempChar": ""
				},
				{
					"order": 1591,
					"prevSize": 32,
					"ligatures": "foursquare, brand77",
					"name": "foursquare",
					"id": 3402,
					"code": 62785,
					"tempChar": ""
				},
				{
					"name": "foursquare2",
					"id": 1525,
					"order": 1958,
					"prevSize": 32,
					"code": 61824,
					"tempChar": ""
				},
				{
					"id": 529,
					"order": 2744,
					"prevSize": 32,
					"code": 59912,
					"name": "frame",
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "frame-contract, minimize",
					"order": 3301,
					"name": "frame-contract",
					"id": 236,
					"code": 59533,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "frame-expand, maximize",
					"order": 3300,
					"name": "frame-expand",
					"id": 235,
					"code": 59532,
					"tempChar": ""
				},
				{
					"id": 530,
					"order": 2745,
					"prevSize": 32,
					"code": 59913,
					"name": "frame2",
					"tempChar": ""
				},
				{
					"id": 1035,
					"order": 2336,
					"prevSize": 32,
					"code": 60418,
					"name": "frame3",
					"tempChar": ""
				},
				{
					"name": "frown-o",
					"id": 1429,
					"order": 1862,
					"prevSize": 32,
					"code": 61721,
					"tempChar": ""
				},
				{
					"order": 1060,
					"prevSize": 32,
					"ligatures": "frustrated, emoticon33",
					"name": "frustrated",
					"id": 2871,
					"code": 62254,
					"tempChar": ""
				},
				{
					"order": 1061,
					"prevSize": 32,
					"ligatures": "frustrated2, emoticon34",
					"name": "frustrated2",
					"id": 2872,
					"code": 62255,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "funnel, filter",
					"order": 3303,
					"name": "funnel",
					"id": 238,
					"code": 59535,
					"tempChar": ""
				},
				{
					"order": 992,
					"prevSize": 32,
					"ligatures": "furniture, couch",
					"name": "furniture",
					"id": 2803,
					"code": 62186,
					"tempChar": ""
				},
				{
					"name": "futbol-o, soccer-ball-o",
					"id": 1618,
					"order": 2051,
					"prevSize": 32,
					"code": 61923,
					"tempChar": ""
				},
				{
					"id": 1036,
					"order": 2337,
					"prevSize": 32,
					"code": 60419,
					"name": "gamble",
					"tempChar": ""
				},
				{
					"id": 531,
					"order": 2746,
					"prevSize": 32,
					"code": 59914,
					"name": "game",
					"tempChar": ""
				},
				{
					"id": 532,
					"order": 2747,
					"prevSize": 32,
					"code": 59915,
					"name": "game2",
					"tempChar": ""
				},
				{
					"id": 1037,
					"order": 2338,
					"prevSize": 32,
					"code": 60420,
					"name": "game3",
					"tempChar": ""
				},
				{
					"order": 109,
					"prevSize": 32,
					"ligatures": "gamepad, game2",
					"name": "gamepad",
					"id": 1920,
					"code": 60669,
					"tempChar": ""
				},
				{
					"order": 110,
					"prevSize": 32,
					"ligatures": "gamepad2, game3",
					"name": "gamepad2",
					"id": 1921,
					"code": 60670,
					"tempChar": ""
				},
				{
					"order": 111,
					"prevSize": 32,
					"ligatures": "gamepad3, game4",
					"name": "gamepad3",
					"id": 1922,
					"code": 60671,
					"tempChar": ""
				},
				{
					"name": "gamepad4",
					"id": 1431,
					"order": 1864,
					"prevSize": 32,
					"code": 61723,
					"tempChar": ""
				},
				{
					"order": 783,
					"prevSize": 32,
					"ligatures": "gas, fuel",
					"name": "gas",
					"id": 2594,
					"code": 61343,
					"tempChar": ""
				},
				{
					"id": 533,
					"order": 2748,
					"prevSize": 32,
					"code": 59916,
					"name": "gather",
					"tempChar": ""
				},
				{
					"id": 534,
					"order": 2749,
					"prevSize": 32,
					"code": 59917,
					"name": "gather2",
					"tempChar": ""
				},
				{
					"name": "gavel, legal",
					"id": 1380,
					"order": 1813,
					"prevSize": 32,
					"code": 61667,
					"tempChar": ""
				},
				{
					"name": "gbp",
					"id": 1484,
					"order": 1917,
					"prevSize": 32,
					"code": 61780,
					"tempChar": ""
				},
				{
					"name": "genderless",
					"id": 1687,
					"order": 2120,
					"prevSize": 32,
					"code": 61997,
					"tempChar": ""
				},
				{
					"name": "get-pocket",
					"id": 1738,
					"order": 2171,
					"prevSize": 32,
					"code": 62053,
					"tempChar": ""
				},
				{
					"name": "gg",
					"id": 1733,
					"order": 2166,
					"prevSize": 32,
					"code": 62048,
					"tempChar": ""
				},
				{
					"name": "gg-circle",
					"id": 1734,
					"order": 2167,
					"prevSize": 32,
					"code": 62049,
					"tempChar": ""
				},
				{
					"order": 686,
					"prevSize": 32,
					"ligatures": "gift, present",
					"name": "gift",
					"id": 2497,
					"code": 61246,
					"tempChar": ""
				},
				{
					"order": 687,
					"prevSize": 32,
					"ligatures": "gift2, present2",
					"name": "gift2",
					"id": 2498,
					"code": 61247,
					"tempChar": ""
				},
				{
					"name": "gift3",
					"id": 1280,
					"order": 1713,
					"prevSize": 32,
					"code": 61547,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "gift, birthday",
					"order": 3228,
					"name": "gift4",
					"id": 163,
					"code": 59460,
					"tempChar": ""
				},
				{
					"order": 1608,
					"prevSize": 32,
					"ligatures": "git, brand80",
					"name": "git",
					"id": 3419,
					"code": 62802,
					"tempChar": ""
				},
				{
					"name": "git-square",
					"id": 1602,
					"order": 2035,
					"prevSize": 32,
					"code": 61906,
					"tempChar": ""
				},
				{
					"name": "git2",
					"id": 1603,
					"order": 2036,
					"prevSize": 32,
					"code": 61907,
					"tempChar": ""
				},
				{
					"order": 1553,
					"prevSize": 32,
					"ligatures": "github, brand40",
					"name": "github",
					"id": 3364,
					"code": 62747,
					"tempChar": ""
				},
				{
					"name": "github-alt",
					"id": 1425,
					"order": 1858,
					"prevSize": 32,
					"code": 61715,
					"tempChar": ""
				},
				{
					"name": "github-square",
					"id": 1316,
					"order": 1749,
					"prevSize": 32,
					"code": 61586,
					"tempChar": ""
				},
				{
					"name": "github2",
					"id": 1325,
					"order": 1758,
					"prevSize": 32,
					"code": 61595,
					"tempChar": ""
				},
				{
					"name": "gitlab",
					"id": 1784,
					"order": 2217,
					"prevSize": 32,
					"code": 62102,
					"tempChar": ""
				},
				{
					"name": "gittip, gratipay",
					"id": 1529,
					"order": 1962,
					"prevSize": 32,
					"code": 61828,
					"tempChar": ""
				},
				{
					"id": 535,
					"order": 2750,
					"prevSize": 32,
					"code": 59918,
					"name": "give",
					"tempChar": ""
				},
				{
					"id": 536,
					"order": 2751,
					"prevSize": 32,
					"code": 59919,
					"name": "give2",
					"tempChar": ""
				},
				{
					"id": 1038,
					"order": 2339,
					"prevSize": 32,
					"code": 60421,
					"name": "give3",
					"tempChar": ""
				},
				{
					"id": 537,
					"order": 2752,
					"prevSize": 32,
					"code": 59920,
					"name": "glance",
					"tempChar": ""
				},
				{
					"id": 538,
					"order": 2753,
					"prevSize": 32,
					"code": 59921,
					"name": "glance2",
					"tempChar": ""
				},
				{
					"order": 692,
					"prevSize": 32,
					"ligatures": "glass, drink",
					"name": "glass",
					"id": 2503,
					"code": 61252,
					"tempChar": ""
				},
				{
					"order": 693,
					"prevSize": 32,
					"ligatures": "glass2, drink2",
					"name": "glass2",
					"id": 2504,
					"code": 61253,
					"tempChar": ""
				},
				{
					"order": 694,
					"prevSize": 32,
					"ligatures": "glass3, drink3",
					"name": "glass3",
					"id": 2505,
					"code": 61254,
					"tempChar": ""
				},
				{
					"order": 695,
					"prevSize": 32,
					"ligatures": "glass4, drink4",
					"name": "glass4",
					"id": 2506,
					"code": 61255,
					"tempChar": ""
				},
				{
					"name": "glass5",
					"id": 1179,
					"order": 1612,
					"prevSize": 32,
					"code": 61440,
					"tempChar": ""
				},
				{
					"order": 807,
					"prevSize": 32,
					"ligatures": "glasses, prescription-glasses",
					"name": "glasses",
					"id": 2618,
					"code": 61367,
					"tempChar": ""
				},
				{
					"order": 805,
					"prevSize": 32,
					"ligatures": "glasses-3d",
					"name": "glasses-3d",
					"id": 2616,
					"code": 61365,
					"tempChar": ""
				},
				{
					"order": 806,
					"prevSize": 32,
					"ligatures": "glasses-3d2",
					"name": "glasses-3d2",
					"id": 2617,
					"code": 61366,
					"tempChar": ""
				},
				{
					"order": 808,
					"prevSize": 32,
					"ligatures": "glasses2, sunglasses",
					"name": "glasses2",
					"id": 2619,
					"code": 61368,
					"tempChar": ""
				},
				{
					"name": "glide",
					"id": 1798,
					"order": 2231,
					"prevSize": 32,
					"code": 62117,
					"tempChar": ""
				},
				{
					"name": "glide-g",
					"id": 1799,
					"order": 2232,
					"prevSize": 32,
					"code": 62118,
					"tempChar": ""
				},
				{
					"name": "globe",
					"id": 1341,
					"order": 1774,
					"prevSize": 32,
					"code": 61612,
					"tempChar": ""
				},
				{
					"id": 539,
					"order": 2754,
					"prevSize": 32,
					"code": 59922,
					"name": "glow",
					"tempChar": ""
				},
				{
					"id": 540,
					"order": 2755,
					"prevSize": 32,
					"code": 59923,
					"name": "glow2",
					"tempChar": ""
				},
				{
					"id": 541,
					"order": 2756,
					"prevSize": 32,
					"code": 59924,
					"name": "glue",
					"tempChar": ""
				},
				{
					"id": 542,
					"order": 2757,
					"prevSize": 32,
					"code": 59925,
					"name": "glue2",
					"tempChar": ""
				},
				{
					"id": 1039,
					"order": 2340,
					"prevSize": 32,
					"code": 60422,
					"name": "go",
					"tempChar": ""
				},
				{
					"order": 834,
					"prevSize": 32,
					"ligatures": "golf, sports3",
					"name": "golf",
					"id": 2645,
					"code": 61394,
					"tempChar": ""
				},
				{
					"order": 835,
					"prevSize": 32,
					"ligatures": "golf2, sports4",
					"name": "golf2",
					"id": 2646,
					"code": 61395,
					"tempChar": ""
				},
				{
					"order": 1513,
					"prevSize": 32,
					"name": "google",
					"ligatures": "google, brand2",
					"id": 3324,
					"code": 62707,
					"tempChar": ""
				},
				{
					"order": 1520,
					"prevSize": 32,
					"ligatures": "google-drive, brand9",
					"name": "google-drive",
					"id": 3331,
					"code": 62714,
					"tempChar": ""
				},
				{
					"order": 1516,
					"prevSize": 32,
					"ligatures": "google-plus, brand5",
					"name": "google-plus",
					"id": 3327,
					"code": 62710,
					"tempChar": ""
				},
				{
					"name": "google-plus-circle, google-plus-official",
					"id": 1811,
					"order": 2244,
					"prevSize": 32,
					"code": 62131,
					"tempChar": ""
				},
				{
					"name": "google-plus-square",
					"id": 1366,
					"order": 1799,
					"prevSize": 32,
					"code": 61652,
					"tempChar": ""
				},
				{
					"order": 1517,
					"prevSize": 32,
					"ligatures": "google-plus2, brand6",
					"name": "google-plus2",
					"id": 3328,
					"code": 62711,
					"tempChar": ""
				},
				{
					"order": 1518,
					"prevSize": 32,
					"ligatures": "google-plus3, brand7",
					"name": "google-plus3",
					"id": 3329,
					"code": 62712,
					"tempChar": ""
				},
				{
					"name": "google-plus4",
					"id": 1367,
					"order": 1800,
					"prevSize": 32,
					"code": 61653,
					"tempChar": ""
				},
				{
					"name": "google-wallet",
					"id": 1629,
					"order": 2062,
					"prevSize": 32,
					"code": 61934,
					"tempChar": ""
				},
				{
					"order": 1514,
					"prevSize": 32,
					"name": "google2",
					"ligatures": "google2, brand3",
					"id": 3325,
					"code": 62708,
					"tempChar": ""
				},
				{
					"order": 1515,
					"prevSize": 32,
					"name": "google3",
					"ligatures": "google3, brand4",
					"id": 3326,
					"code": 62709,
					"tempChar": ""
				},
				{
					"name": "google4",
					"id": 1555,
					"order": 1988,
					"prevSize": 32,
					"code": 61856,
					"tempChar": ""
				},
				{
					"order": 1084,
					"prevSize": 32,
					"ligatures": "grab, fist",
					"name": "grab",
					"id": 2895,
					"code": 62278,
					"tempChar": ""
				},
				{
					"order": 50,
					"prevSize": 32,
					"ligatures": "gradient, color5",
					"name": "gradient",
					"id": 1861,
					"code": 60610,
					"tempChar": ""
				},
				{
					"order": 156,
					"prevSize": 32,
					"ligatures": "graduation, education",
					"name": "graduation",
					"id": 1967,
					"code": 60716,
					"tempChar": ""
				},
				{
					"name": "graduation-cap, mortar-board",
					"id": 1553,
					"order": 1986,
					"prevSize": 32,
					"code": 61853,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "graduation-hat, education",
					"order": 3193,
					"name": "graduation-hat",
					"id": 128,
					"code": 59425,
					"tempChar": ""
				},
				{
					"order": 722,
					"prevSize": 32,
					"ligatures": "grapes, fruit2",
					"name": "grapes",
					"id": 2533,
					"code": 61282,
					"tempChar": ""
				},
				{
					"order": 863,
					"prevSize": 32,
					"ligatures": "grid2, icons",
					"name": "grid",
					"id": 2674,
					"code": 61423,
					"tempChar": ""
				},
				{
					"order": 864,
					"prevSize": 32,
					"ligatures": "grid3, icons2",
					"name": "grid2",
					"id": 2675,
					"code": 61424,
					"tempChar": ""
				},
				{
					"order": 865,
					"prevSize": 32,
					"ligatures": "grid4, icons3",
					"name": "grid3",
					"id": 2676,
					"code": 61425,
					"tempChar": ""
				},
				{
					"order": 866,
					"prevSize": 32,
					"ligatures": "grid5, icons4",
					"name": "grid4",
					"id": 2677,
					"code": 61426,
					"tempChar": ""
				},
				{
					"order": 867,
					"prevSize": 32,
					"ligatures": "grid6, icons5",
					"name": "grid5",
					"id": 2678,
					"code": 61427,
					"tempChar": ""
				},
				{
					"order": 868,
					"prevSize": 32,
					"ligatures": "grid7, icons6",
					"name": "grid6",
					"id": 2679,
					"code": 61428,
					"tempChar": ""
				},
				{
					"order": 869,
					"prevSize": 32,
					"ligatures": "grid8, icons7",
					"name": "grid7",
					"id": 2680,
					"code": 61429,
					"tempChar": ""
				},
				{
					"id": 543,
					"order": 2758,
					"prevSize": 32,
					"code": 59926,
					"name": "grill",
					"tempChar": ""
				},
				{
					"id": 544,
					"order": 2759,
					"prevSize": 32,
					"code": 59927,
					"name": "grill2",
					"tempChar": ""
				},
				{
					"order": 1038,
					"prevSize": 32,
					"ligatures": "grin, emoticon11",
					"name": "grin",
					"id": 2849,
					"code": 62232,
					"tempChar": ""
				},
				{
					"order": 1039,
					"prevSize": 32,
					"ligatures": "grin2, emoticon12",
					"name": "grin2",
					"id": 2850,
					"code": 62233,
					"tempChar": ""
				},
				{
					"id": 545,
					"order": 2760,
					"prevSize": 32,
					"code": 59928,
					"name": "groom",
					"tempChar": ""
				},
				{
					"id": 546,
					"order": 2761,
					"prevSize": 32,
					"code": 59929,
					"name": "groom2",
					"tempChar": ""
				},
				{
					"name": "group, users6",
					"id": 1347,
					"order": 1780,
					"prevSize": 32,
					"code": 61632,
					"tempChar": ""
				},
				{
					"id": 547,
					"order": 2762,
					"prevSize": 32,
					"code": 59930,
					"name": "grow",
					"tempChar": ""
				},
				{
					"id": 548,
					"order": 2763,
					"prevSize": 32,
					"code": 59931,
					"name": "grow2",
					"tempChar": ""
				},
				{
					"id": 1040,
					"order": 2341,
					"prevSize": 32,
					"code": 60423,
					"name": "grow3",
					"tempChar": ""
				},
				{
					"id": 549,
					"order": 2764,
					"prevSize": 32,
					"code": 59932,
					"name": "guide",
					"tempChar": ""
				},
				{
					"id": 550,
					"order": 2765,
					"prevSize": 32,
					"code": 59933,
					"name": "guide2",
					"tempChar": ""
				},
				{
					"id": 1041,
					"order": 2342,
					"prevSize": 32,
					"code": 60424,
					"name": "guide3",
					"tempChar": ""
				},
				{
					"order": 86,
					"prevSize": 32,
					"ligatures": "guitar, music8",
					"name": "guitar",
					"id": 1897,
					"code": 60646,
					"tempChar": ""
				},
				{
					"order": 817,
					"prevSize": 32,
					"ligatures": "gun, weapon",
					"name": "gun",
					"id": 2628,
					"code": 61377,
					"tempChar": ""
				},
				{
					"order": 818,
					"prevSize": 32,
					"ligatures": "gun-forbidden, gun-ban",
					"name": "gun-forbidden",
					"id": 2629,
					"code": 61378,
					"tempChar": ""
				},
				{
					"name": "h-square",
					"id": 1405,
					"order": 1838,
					"prevSize": 32,
					"code": 61693,
					"tempChar": ""
				},
				{
					"name": "hacker-news, y-combinator-square, yc-square",
					"id": 1604,
					"order": 2037,
					"prevSize": 32,
					"code": 61908,
					"tempChar": ""
				},
				{
					"order": 1576,
					"prevSize": 32,
					"name": "hackernews",
					"ligatures": "hackernews, brand62",
					"id": 3387,
					"code": 62770,
					"tempChar": ""
				},
				{
					"order": 1417,
					"prevSize": 32,
					"ligatures": "haircut, scissors-comb",
					"name": "haircut",
					"id": 3228,
					"code": 62611,
					"tempChar": ""
				},
				{
					"id": 551,
					"order": 2766,
					"prevSize": 32,
					"code": 59934,
					"name": "hallucinate",
					"tempChar": ""
				},
				{
					"id": 552,
					"order": 2767,
					"prevSize": 32,
					"code": 59935,
					"name": "hallucinate2",
					"tempChar": ""
				},
				{
					"id": 1042,
					"order": 2343,
					"prevSize": 32,
					"code": 60425,
					"name": "hallucinate3",
					"tempChar": ""
				},
				{
					"order": 708,
					"prevSize": 32,
					"ligatures": "hamburger, food7",
					"name": "hamburger",
					"id": 2519,
					"code": 61268,
					"tempChar": ""
				},
				{
					"order": 618,
					"prevSize": 32,
					"ligatures": "hammer, tool4",
					"name": "hammer",
					"id": 2429,
					"code": 61178,
					"tempChar": ""
				},
				{
					"order": 619,
					"prevSize": 32,
					"ligatures": "hammer-wrench, tool5",
					"name": "hammer-wrench",
					"id": 2430,
					"code": 61179,
					"tempChar": ""
				},
				{
					"order": 742,
					"prevSize": 32,
					"ligatures": "hammer2, gavel",
					"name": "hammer2",
					"id": 2553,
					"code": 61302,
					"tempChar": ""
				},
				{
					"order": 1083,
					"prevSize": 32,
					"ligatures": "hand, fingers",
					"name": "hand",
					"id": 2894,
					"code": 62277,
					"tempChar": ""
				},
				{
					"name": "hand-grab-o, hand-rock-o",
					"id": 1723,
					"order": 2156,
					"prevSize": 32,
					"code": 62037,
					"tempChar": ""
				},
				{
					"name": "hand-lizard-o",
					"id": 1726,
					"order": 2159,
					"prevSize": 32,
					"code": 62040,
					"tempChar": ""
				},
				{
					"name": "hand-o-down",
					"id": 1336,
					"order": 1769,
					"prevSize": 32,
					"code": 61607,
					"tempChar": ""
				},
				{
					"name": "hand-o-left",
					"id": 1334,
					"order": 1767,
					"prevSize": 32,
					"code": 61605,
					"tempChar": ""
				},
				{
					"name": "hand-o-right",
					"id": 1333,
					"order": 1766,
					"prevSize": 32,
					"code": 61604,
					"tempChar": ""
				},
				{
					"name": "hand-o-up",
					"id": 1335,
					"order": 1768,
					"prevSize": 32,
					"code": 61606,
					"tempChar": ""
				},
				{
					"name": "hand-paper-o, hand-stop-o",
					"id": 1724,
					"order": 2157,
					"prevSize": 32,
					"code": 62038,
					"tempChar": ""
				},
				{
					"name": "hand-peace-o",
					"id": 1729,
					"order": 2162,
					"prevSize": 32,
					"code": 62043,
					"tempChar": ""
				},
				{
					"name": "hand-pointer-o",
					"id": 1728,
					"order": 2161,
					"prevSize": 32,
					"code": 62042,
					"tempChar": ""
				},
				{
					"name": "hand-scissors-o",
					"id": 1725,
					"order": 2158,
					"prevSize": 32,
					"code": 62039,
					"tempChar": ""
				},
				{
					"name": "hand-spock-o",
					"id": 1727,
					"order": 2160,
					"prevSize": 32,
					"code": 62041,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "hand, drag",
					"order": 3325,
					"name": "hand2",
					"id": 260,
					"code": 59557,
					"tempChar": ""
				},
				{
					"id": 553,
					"order": 2768,
					"prevSize": 32,
					"code": 59936,
					"name": "hang",
					"tempChar": ""
				},
				{
					"id": 554,
					"order": 2769,
					"prevSize": 32,
					"code": 59937,
					"name": "hang2",
					"tempChar": ""
				},
				{
					"order": 535,
					"prevSize": 32,
					"ligatures": "hanger, coat-hanger",
					"name": "hanger",
					"id": 2346,
					"code": 61095,
					"tempChar": ""
				},
				{
					"order": 1519,
					"prevSize": 32,
					"name": "hangouts",
					"ligatures": "hangouts, brand8",
					"id": 3330,
					"code": 62713,
					"tempChar": ""
				},
				{
					"order": 1028,
					"prevSize": 32,
					"ligatures": "happy, emoticon",
					"name": "happy",
					"id": 2839,
					"code": 62222,
					"tempChar": ""
				},
				{
					"order": 1029,
					"prevSize": 32,
					"ligatures": "happy2, emoticon2",
					"name": "happy2",
					"id": 2840,
					"code": 62223,
					"tempChar": ""
				},
				{
					"id": 555,
					"order": 2770,
					"prevSize": 32,
					"code": 59938,
					"name": "harvest",
					"tempChar": ""
				},
				{
					"id": 556,
					"order": 2771,
					"prevSize": 32,
					"code": 59939,
					"name": "harvest2",
					"tempChar": ""
				},
				{
					"name": "hashtag",
					"id": 1780,
					"order": 2213,
					"prevSize": 32,
					"code": 62098,
					"tempChar": ""
				},
				{
					"order": 532,
					"prevSize": 32,
					"ligatures": "hat",
					"name": "hat",
					"id": 2343,
					"code": 61092,
					"tempChar": ""
				},
				{
					"id": 557,
					"order": 2772,
					"prevSize": 32,
					"code": 59940,
					"name": "hate",
					"tempChar": ""
				},
				{
					"id": 558,
					"order": 2773,
					"prevSize": 32,
					"code": 59941,
					"name": "hate2",
					"tempChar": ""
				},
				{
					"id": 1043,
					"order": 2344,
					"prevSize": 32,
					"code": 60426,
					"name": "haunt",
					"tempChar": ""
				},
				{
					"name": "hdd-o",
					"id": 1329,
					"order": 1762,
					"prevSize": 32,
					"code": 61600,
					"tempChar": ""
				},
				{
					"name": "header",
					"id": 1612,
					"order": 2045,
					"prevSize": 32,
					"code": 61916,
					"tempChar": ""
				},
				{
					"order": 74,
					"prevSize": 32,
					"ligatures": "headphones, headset",
					"name": "headphones",
					"id": 1885,
					"code": 60634,
					"tempChar": ""
				},
				{
					"name": "headphones2",
					"id": 1213,
					"order": 1646,
					"prevSize": 32,
					"code": 61477,
					"tempChar": ""
				},
				{
					"order": 75,
					"prevSize": 32,
					"ligatures": "headset2, support",
					"name": "headset",
					"id": 1886,
					"code": 60635,
					"tempChar": ""
				},
				{
					"id": 559,
					"order": 2774,
					"prevSize": 32,
					"code": 59942,
					"name": "heal",
					"tempChar": ""
				},
				{
					"id": 560,
					"order": 2775,
					"prevSize": 32,
					"code": 59943,
					"name": "heal2",
					"tempChar": ""
				},
				{
					"id": 1044,
					"order": 2345,
					"prevSize": 32,
					"code": 60427,
					"name": "heal3",
					"tempChar": ""
				},
				{
					"id": 561,
					"order": 2776,
					"prevSize": 32,
					"code": 59944,
					"name": "hear",
					"tempChar": ""
				},
				{
					"id": 562,
					"order": 2777,
					"prevSize": 32,
					"code": 59945,
					"name": "hear2",
					"tempChar": ""
				},
				{
					"order": 1001,
					"prevSize": 32,
					"ligatures": "heart, like",
					"name": "heart",
					"id": 2812,
					"code": 62195,
					"tempChar": ""
				},
				{
					"order": 1005,
					"prevSize": 32,
					"ligatures": "heart-broken, heart5",
					"name": "heart-broken",
					"id": 2816,
					"code": 62199,
					"tempChar": ""
				},
				{
					"order": 1008,
					"prevSize": 32,
					"ligatures": "heart-broken2, heart8",
					"name": "heart-broken2",
					"id": 2819,
					"code": 62202,
					"tempChar": ""
				},
				{
					"order": 1011,
					"prevSize": 32,
					"ligatures": "heart-broken3, heart11",
					"name": "heart-broken3",
					"id": 2822,
					"code": 62205,
					"tempChar": ""
				},
				{
					"name": "heart-o",
					"id": 1309,
					"order": 1742,
					"prevSize": 32,
					"code": 61578,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "heart-pulse, health",
					"order": 3224,
					"name": "heart-pulse",
					"id": 159,
					"code": 59456,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "heart, love",
					"order": 3179,
					"name": "heart10",
					"id": 114,
					"code": 59411,
					"tempChar": ""
				},
				{
					"order": 1002,
					"prevSize": 32,
					"ligatures": "heart2, like2",
					"name": "heart2",
					"id": 2813,
					"code": 62196,
					"tempChar": ""
				},
				{
					"order": 1003,
					"prevSize": 32,
					"ligatures": "heart3, like3",
					"name": "heart3",
					"id": 2814,
					"code": 62197,
					"tempChar": ""
				},
				{
					"order": 1004,
					"prevSize": 32,
					"ligatures": "heart4, like4",
					"name": "heart4",
					"id": 2815,
					"code": 62198,
					"tempChar": ""
				},
				{
					"order": 1006,
					"prevSize": 32,
					"ligatures": "heart6, like5",
					"name": "heart5",
					"id": 2817,
					"code": 62200,
					"tempChar": ""
				},
				{
					"order": 1007,
					"prevSize": 32,
					"ligatures": "heart7, like6",
					"name": "heart6",
					"id": 2818,
					"code": 62201,
					"tempChar": ""
				},
				{
					"order": 1009,
					"prevSize": 32,
					"ligatures": "heart9, like7",
					"name": "heart7",
					"id": 2820,
					"code": 62203,
					"tempChar": ""
				},
				{
					"order": 1010,
					"prevSize": 32,
					"ligatures": "heart10, like8",
					"name": "heart8",
					"id": 2821,
					"code": 62204,
					"tempChar": ""
				},
				{
					"name": "heart9",
					"id": 1183,
					"order": 1616,
					"prevSize": 32,
					"code": 61444,
					"tempChar": ""
				},
				{
					"name": "heartbeat",
					"id": 1674,
					"order": 2107,
					"prevSize": 32,
					"code": 61982,
					"tempChar": ""
				},
				{
					"id": 563,
					"order": 2778,
					"prevSize": 32,
					"code": 59946,
					"name": "heat",
					"tempChar": ""
				},
				{
					"id": 564,
					"order": 2779,
					"prevSize": 32,
					"code": 59947,
					"name": "heat2",
					"tempChar": ""
				},
				{
					"order": 1020,
					"prevSize": 32,
					"ligatures": "height",
					"name": "height",
					"id": 2831,
					"code": 62214,
					"tempChar": ""
				},
				{
					"order": 1431,
					"prevSize": 32,
					"ligatures": "height2, size",
					"name": "height2",
					"id": 3242,
					"code": 62625,
					"tempChar": ""
				},
				{
					"id": 565,
					"order": 2780,
					"prevSize": 32,
					"code": 59948,
					"name": "help",
					"tempChar": ""
				},
				{
					"id": 566,
					"order": 2781,
					"prevSize": 32,
					"code": 59949,
					"name": "help2",
					"tempChar": ""
				},
				{
					"id": 567,
					"order": 2782,
					"prevSize": 32,
					"code": 59950,
					"name": "hide",
					"tempChar": ""
				},
				{
					"id": 568,
					"order": 2783,
					"prevSize": 32,
					"code": 59951,
					"name": "hide2",
					"tempChar": ""
				},
				{
					"order": 1453,
					"prevSize": 32,
					"ligatures": "highlight, wysiwyg25",
					"name": "highlight",
					"id": 3264,
					"code": 62647,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "highlight, magic-marker",
					"order": 3311,
					"name": "highlight2",
					"id": 246,
					"code": 59543,
					"tempChar": ""
				},
				{
					"order": 1054,
					"prevSize": 32,
					"ligatures": "hipster4, emoticon27",
					"name": "hipster",
					"id": 2865,
					"code": 62248,
					"tempChar": ""
				},
				{
					"order": 1055,
					"prevSize": 32,
					"ligatures": "hipster5, emoticon28",
					"name": "hipster2",
					"id": 2866,
					"code": 62249,
					"tempChar": ""
				},
				{
					"order": 334,
					"prevSize": 32,
					"ligatures": "history, time",
					"name": "history",
					"id": 2145,
					"code": 60894,
					"tempChar": ""
				},
				{
					"name": "history2",
					"id": 1610,
					"order": 2043,
					"prevSize": 32,
					"code": 61914,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "history, archive",
					"order": 3259,
					"name": "history3",
					"id": 194,
					"code": 59491,
					"tempChar": ""
				},
				{
					"order": 836,
					"prevSize": 32,
					"ligatures": "hockey, sports5",
					"name": "hockey",
					"id": 2647,
					"code": 61396,
					"tempChar": ""
				},
				{
					"id": 569,
					"order": 2784,
					"prevSize": 32,
					"code": 59952,
					"name": "hold",
					"tempChar": ""
				},
				{
					"id": 570,
					"order": 2785,
					"prevSize": 32,
					"code": 59953,
					"name": "hold2",
					"tempChar": ""
				},
				{
					"id": 1045,
					"order": 2346,
					"prevSize": 32,
					"code": 60428,
					"name": "hold3",
					"tempChar": ""
				},
				{
					"order": 2,
					"prevSize": 32,
					"ligatures": "home, house",
					"name": "home",
					"id": 1813,
					"code": 60562,
					"tempChar": ""
				},
				{
					"name": "home10",
					"id": 1199,
					"order": 1632,
					"prevSize": 32,
					"code": 61461,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "home, building",
					"order": 3160,
					"name": "home11",
					"id": 95,
					"code": 59392,
					"tempChar": ""
				},
				{
					"id": 571,
					"order": 2786,
					"prevSize": 32,
					"code": 59954,
					"name": "home12",
					"tempChar": ""
				},
				{
					"id": 572,
					"order": 2787,
					"prevSize": 32,
					"code": 59955,
					"name": "home13",
					"tempChar": ""
				},
				{
					"id": 1046,
					"order": 2347,
					"prevSize": 32,
					"code": 60429,
					"name": "home14",
					"tempChar": ""
				},
				{
					"order": 3,
					"prevSize": 32,
					"ligatures": "home2, house2",
					"name": "home2",
					"id": 1814,
					"code": 60563,
					"tempChar": ""
				},
				{
					"order": 4,
					"prevSize": 32,
					"ligatures": "home3, house3",
					"name": "home3",
					"id": 1815,
					"code": 60564,
					"tempChar": ""
				},
				{
					"order": 5,
					"prevSize": 32,
					"ligatures": "home4, house4",
					"name": "home4",
					"id": 1816,
					"code": 60565,
					"tempChar": ""
				},
				{
					"order": 6,
					"prevSize": 32,
					"ligatures": "home5, house5",
					"name": "home5",
					"id": 1817,
					"code": 60566,
					"tempChar": ""
				},
				{
					"order": 7,
					"prevSize": 32,
					"ligatures": "home6, house6",
					"name": "home6",
					"id": 1818,
					"code": 60567,
					"tempChar": ""
				},
				{
					"order": 8,
					"prevSize": 32,
					"ligatures": "home7, house7",
					"name": "home7",
					"id": 1819,
					"code": 60568,
					"tempChar": ""
				},
				{
					"order": 9,
					"prevSize": 32,
					"ligatures": "home8, house8",
					"name": "home8",
					"id": 1820,
					"code": 60569,
					"tempChar": ""
				},
				{
					"order": 10,
					"prevSize": 32,
					"ligatures": "home9, house9",
					"name": "home9",
					"id": 1821,
					"code": 60570,
					"tempChar": ""
				},
				{
					"name": "hospital-o",
					"id": 1400,
					"order": 1833,
					"prevSize": 32,
					"code": 61688,
					"tempChar": ""
				},
				{
					"order": 545,
					"prevSize": 32,
					"ligatures": "hour-glass, loading",
					"name": "hour-glass",
					"id": 2356,
					"code": 61105,
					"tempChar": ""
				},
				{
					"order": 546,
					"prevSize": 32,
					"ligatures": "hour-glass2, loading2",
					"name": "hour-glass2",
					"id": 2357,
					"code": 61106,
					"tempChar": ""
				},
				{
					"order": 547,
					"prevSize": 32,
					"ligatures": "hour-glass3, loading3",
					"name": "hour-glass3",
					"id": 2358,
					"code": 61107,
					"tempChar": ""
				},
				{
					"name": "hourglass",
					"id": 1722,
					"order": 2155,
					"prevSize": 32,
					"code": 62036,
					"tempChar": ""
				},
				{
					"name": "hourglass-1, hourglass-start",
					"id": 1719,
					"order": 2152,
					"prevSize": 32,
					"code": 62033,
					"tempChar": ""
				},
				{
					"name": "hourglass-2, hourglass-half",
					"id": 1720,
					"order": 2153,
					"prevSize": 32,
					"code": 62034,
					"tempChar": ""
				},
				{
					"name": "hourglass-3, hourglass-end",
					"id": 1721,
					"order": 2154,
					"prevSize": 32,
					"code": 62035,
					"tempChar": ""
				},
				{
					"name": "hourglass-o",
					"id": 1718,
					"order": 2151,
					"prevSize": 32,
					"code": 62032,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "hourglass, loading",
					"order": 3255,
					"name": "hourglass2",
					"id": 190,
					"code": 59487,
					"tempChar": ""
				},
				{
					"name": "houzz",
					"id": 1760,
					"order": 2193,
					"prevSize": 32,
					"code": 62076,
					"tempChar": ""
				},
				{
					"order": 1605,
					"prevSize": 32,
					"ligatures": "html-five",
					"name": "html-five",
					"id": 3416,
					"code": 62799,
					"tempChar": ""
				},
				{
					"order": 1606,
					"prevSize": 32,
					"ligatures": "html-five2",
					"name": "html-five2",
					"id": 3417,
					"code": 62800,
					"tempChar": ""
				},
				{
					"name": "html5",
					"id": 1461,
					"order": 1894,
					"prevSize": 32,
					"code": 61755,
					"tempChar": ""
				},
				{
					"id": 573,
					"order": 2788,
					"prevSize": 32,
					"code": 59956,
					"name": "hypnotize",
					"tempChar": ""
				},
				{
					"id": 574,
					"order": 2789,
					"prevSize": 32,
					"code": 59957,
					"name": "hypnotize2",
					"tempChar": ""
				},
				{
					"name": "i-cursor",
					"id": 1709,
					"order": 2142,
					"prevSize": 32,
					"code": 62022,
					"tempChar": ""
				},
				{
					"order": 712,
					"prevSize": 32,
					"ligatures": "icecream, dessert",
					"name": "icecream",
					"id": 2523,
					"code": 61272,
					"tempChar": ""
				},
				{
					"id": 575,
					"order": 2790,
					"prevSize": 32,
					"code": 59958,
					"name": "identify",
					"tempChar": ""
				},
				{
					"id": 576,
					"order": 2791,
					"prevSize": 32,
					"code": 59959,
					"name": "identify2",
					"tempChar": ""
				},
				{
					"id": 1047,
					"order": 2348,
					"prevSize": 32,
					"code": 60430,
					"name": "illuminate",
					"tempChar": ""
				},
				{
					"name": "ils, shekel, sheqel",
					"id": 1656,
					"order": 2089,
					"prevSize": 32,
					"code": 61963,
					"tempChar": ""
				},
				{
					"order": 61,
					"prevSize": 32,
					"ligatures": "image, picture",
					"name": "image",
					"id": 1872,
					"code": 60621,
					"tempChar": ""
				},
				{
					"order": 63,
					"prevSize": 32,
					"ligatures": "image-compare, diff",
					"name": "image-compare",
					"id": 1874,
					"code": 60623,
					"tempChar": ""
				},
				{
					"order": 62,
					"prevSize": 32,
					"ligatures": "image2, picture2",
					"name": "image2",
					"id": 1873,
					"code": 60622,
					"tempChar": ""
				},
				{
					"order": 65,
					"prevSize": 32,
					"ligatures": "image3, picture3",
					"name": "image3",
					"id": 1876,
					"code": 60625,
					"tempChar": ""
				},
				{
					"order": 67,
					"prevSize": 32,
					"ligatures": "image4, picture4",
					"name": "image4",
					"id": 1878,
					"code": 60627,
					"tempChar": ""
				},
				{
					"order": 68,
					"prevSize": 32,
					"ligatures": "image5, picture5",
					"name": "image5",
					"id": 1879,
					"code": 60628,
					"tempChar": ""
				},
				{
					"order": 69,
					"prevSize": 32,
					"ligatures": "image6, picture6",
					"name": "image6",
					"id": 1880,
					"code": 60629,
					"tempChar": ""
				},
				{
					"name": "image7, photo, picture-o",
					"id": 1238,
					"order": 1671,
					"prevSize": 32,
					"code": 61502,
					"tempChar": ""
				},
				{
					"order": 60,
					"prevSize": 32,
					"ligatures": "images, pictures",
					"name": "images",
					"id": 1871,
					"code": 60620,
					"tempChar": ""
				},
				{
					"order": 64,
					"prevSize": 32,
					"ligatures": "images2, pictures2",
					"name": "images2",
					"id": 1875,
					"code": 60624,
					"tempChar": ""
				},
				{
					"order": 66,
					"prevSize": 32,
					"ligatures": "images3, pictures3",
					"name": "images3",
					"id": 1877,
					"code": 60626,
					"tempChar": ""
				},
				{
					"id": 577,
					"order": 2792,
					"prevSize": 32,
					"code": 59960,
					"name": "imagine",
					"tempChar": ""
				},
				{
					"id": 578,
					"order": 2793,
					"prevSize": 32,
					"code": 59961,
					"name": "imagine2",
					"tempChar": ""
				},
				{
					"order": 899,
					"prevSize": 32,
					"ligatures": "import, load4",
					"name": "import",
					"id": 2710,
					"code": 61627,
					"tempChar": ""
				},
				{
					"order": 900,
					"prevSize": 32,
					"ligatures": "import2, load5",
					"name": "import2",
					"id": 2711,
					"code": 61628,
					"tempChar": ""
				},
				{
					"name": "inbox",
					"id": 1206,
					"order": 1639,
					"prevSize": 32,
					"code": 61468,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "inbox, drawer",
					"order": 3186,
					"name": "inbox2",
					"id": 121,
					"code": 59418,
					"tempChar": ""
				},
				{
					"name": "indent",
					"id": 1236,
					"order": 1669,
					"prevSize": 32,
					"code": 61500,
					"tempChar": ""
				},
				{
					"order": 1474,
					"prevSize": 32,
					"ligatures": "indent-decrease, wysiwyg46",
					"name": "indent-decrease",
					"id": 3285,
					"code": 62668,
					"tempChar": ""
				},
				{
					"order": 1480,
					"prevSize": 32,
					"ligatures": "indent-decrease2, wysiwyg52",
					"name": "indent-decrease2",
					"id": 3291,
					"code": 62674,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "indent-decrease, typography14",
					"order": 3318,
					"name": "indent-decrease3",
					"id": 253,
					"code": 59550,
					"tempChar": ""
				},
				{
					"order": 1473,
					"prevSize": 32,
					"ligatures": "indent-increase, wysiwyg45",
					"name": "indent-increase",
					"id": 3284,
					"code": 62667,
					"tempChar": ""
				},
				{
					"order": 1479,
					"prevSize": 32,
					"ligatures": "indent-increase2, wysiwyg51",
					"name": "indent-increase2",
					"id": 3290,
					"code": 62673,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "indent-increase, typography13",
					"order": 3317,
					"name": "indent-increase3",
					"id": 252,
					"code": 59549,
					"tempChar": ""
				},
				{
					"id": 579,
					"order": 2794,
					"prevSize": 32,
					"code": 59962,
					"name": "indulge",
					"tempChar": ""
				},
				{
					"id": 580,
					"order": 2795,
					"prevSize": 32,
					"code": 59963,
					"name": "indulge2",
					"tempChar": ""
				},
				{
					"name": "industry",
					"id": 1753,
					"order": 2186,
					"prevSize": 32,
					"code": 62069,
					"tempChar": ""
				},
				{
					"order": 1198,
					"prevSize": 32,
					"ligatures": "infinite",
					"name": "infinite",
					"id": 3009,
					"code": 62392,
					"tempChar": ""
				},
				{
					"order": 1197,
					"prevSize": 32,
					"ligatures": "infinite-square",
					"name": "infinite-square",
					"id": 3008,
					"code": 62391,
					"tempChar": ""
				},
				{
					"order": 1199,
					"prevSize": 32,
					"ligatures": "infinite2",
					"name": "infinite2",
					"id": 3010,
					"code": 62393,
					"tempChar": ""
				},
				{
					"id": 581,
					"order": 2796,
					"prevSize": 32,
					"code": 59964,
					"name": "influence",
					"tempChar": ""
				},
				{
					"id": 582,
					"order": 2797,
					"prevSize": 32,
					"code": 59965,
					"name": "influence2",
					"tempChar": ""
				},
				{
					"order": 1125,
					"prevSize": 32,
					"ligatures": "info, information",
					"name": "info",
					"id": 2936,
					"code": 62319,
					"tempChar": ""
				},
				{
					"name": "info-circle",
					"id": 1264,
					"order": 1697,
					"prevSize": 32,
					"code": 61530,
					"tempChar": ""
				},
				{
					"order": 1126,
					"prevSize": 32,
					"ligatures": "info2, information2",
					"name": "info2",
					"id": 2937,
					"code": 62320,
					"tempChar": ""
				},
				{
					"name": "info3",
					"id": 1444,
					"order": 1877,
					"prevSize": 32,
					"code": 61737,
					"tempChar": ""
				},
				{
					"id": 583,
					"order": 2798,
					"prevSize": 32,
					"code": 59966,
					"name": "inject",
					"tempChar": ""
				},
				{
					"id": 584,
					"order": 2799,
					"prevSize": 32,
					"code": 59967,
					"name": "inject2",
					"tempChar": ""
				},
				{
					"id": 1048,
					"order": 2349,
					"prevSize": 32,
					"code": 60431,
					"name": "inject3",
					"tempChar": ""
				},
				{
					"name": "inr, rupee",
					"id": 1486,
					"order": 1919,
					"prevSize": 32,
					"code": 61782,
					"tempChar": ""
				},
				{
					"order": 1458,
					"prevSize": 32,
					"ligatures": "insert-template, wysiwyg30",
					"name": "insert-template",
					"id": 3269,
					"code": 62652,
					"tempChar": ""
				},
				{
					"order": 1523,
					"prevSize": 32,
					"ligatures": "instagram, brand12",
					"name": "instagram",
					"id": 3334,
					"code": 62717,
					"tempChar": ""
				},
				{
					"name": "instagram2",
					"id": 1508,
					"order": 1941,
					"prevSize": 32,
					"code": 61805,
					"tempChar": ""
				},
				{
					"name": "internet-explorer",
					"id": 1744,
					"order": 2177,
					"prevSize": 32,
					"code": 62059,
					"tempChar": ""
				},
				{
					"order": 441,
					"prevSize": 32,
					"ligatures": "interset, boolean-operation3",
					"name": "interset",
					"id": 2252,
					"code": 61001,
					"tempChar": ""
				},
				{
					"name": "intersex, transgender",
					"id": 1678,
					"order": 2111,
					"prevSize": 32,
					"code": 61988,
					"tempChar": ""
				},
				{
					"id": 585,
					"order": 2800,
					"prevSize": 32,
					"code": 59968,
					"name": "invade",
					"tempChar": ""
				},
				{
					"id": 586,
					"order": 2801,
					"prevSize": 32,
					"code": 59969,
					"name": "invade2",
					"tempChar": ""
				},
				{
					"name": "ioxhost",
					"id": 1653,
					"order": 2086,
					"prevSize": 32,
					"code": 61960,
					"tempChar": ""
				},
				{
					"id": 587,
					"order": 2802,
					"prevSize": 32,
					"code": 59970,
					"name": "iron",
					"tempChar": ""
				},
				{
					"id": 588,
					"order": 2803,
					"prevSize": 32,
					"code": 59971,
					"name": "iron2",
					"tempChar": ""
				},
				{
					"id": 1049,
					"order": 2350,
					"prevSize": 32,
					"code": 60432,
					"name": "iron3",
					"tempChar": ""
				},
				{
					"order": 1435,
					"prevSize": 32,
					"ligatures": "italic, wysiwyg7",
					"name": "italic",
					"id": 3246,
					"code": 62629,
					"tempChar": ""
				},
				{
					"order": 1441,
					"prevSize": 32,
					"ligatures": "italic2, wysiwyg13",
					"name": "italic2",
					"id": 3252,
					"code": 62635,
					"tempChar": ""
				},
				{
					"name": "italic3",
					"id": 1227,
					"order": 1660,
					"prevSize": 32,
					"code": 61491,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "italic, typography5",
					"order": 3308,
					"name": "italic4",
					"id": 243,
					"code": 59540,
					"tempChar": ""
				},
				{
					"id": 589,
					"order": 2804,
					"prevSize": 32,
					"code": 59972,
					"name": "join",
					"tempChar": ""
				},
				{
					"id": 590,
					"order": 2805,
					"prevSize": 32,
					"code": 59973,
					"name": "join2",
					"tempChar": ""
				},
				{
					"order": 1558,
					"prevSize": 32,
					"ligatures": "joomla, brand45",
					"name": "joomla",
					"id": 3369,
					"code": 62752,
					"tempChar": ""
				},
				{
					"name": "joomla2",
					"id": 1565,
					"order": 1998,
					"prevSize": 32,
					"code": 61866,
					"tempChar": ""
				},
				{
					"name": "jsfiddle",
					"id": 1597,
					"order": 2030,
					"prevSize": 32,
					"code": 61900,
					"tempChar": ""
				},
				{
					"id": 591,
					"order": 2806,
					"prevSize": 32,
					"code": 59974,
					"name": "keep",
					"tempChar": ""
				},
				{
					"id": 592,
					"order": 2807,
					"prevSize": 32,
					"code": 59975,
					"name": "keep2",
					"tempChar": ""
				},
				{
					"id": 1050,
					"order": 2351,
					"prevSize": 32,
					"code": 60433,
					"name": "keep3",
					"tempChar": ""
				},
				{
					"order": 588,
					"prevSize": 32,
					"ligatures": "key, password",
					"name": "key",
					"id": 2399,
					"code": 61148,
					"tempChar": ""
				},
				{
					"order": 1375,
					"prevSize": 32,
					"ligatures": "key-A, button2",
					"name": "key-A",
					"id": 3186,
					"code": 62569,
					"tempChar": ""
				},
				{
					"order": 1378,
					"prevSize": 32,
					"ligatures": "key-down, button5",
					"name": "key-down",
					"id": 3189,
					"code": 62572,
					"tempChar": ""
				},
				{
					"order": 1374,
					"prevSize": 32,
					"ligatures": "key-keyboard, button",
					"name": "key-keyboard",
					"id": 3185,
					"code": 62568,
					"tempChar": ""
				},
				{
					"order": 1379,
					"prevSize": 32,
					"ligatures": "key-left, button6",
					"name": "key-left",
					"id": 3190,
					"code": 62573,
					"tempChar": ""
				},
				{
					"order": 1377,
					"prevSize": 32,
					"ligatures": "key-right, button4",
					"name": "key-right",
					"id": 3188,
					"code": 62571,
					"tempChar": ""
				},
				{
					"order": 1376,
					"prevSize": 32,
					"ligatures": "key-up, button3",
					"name": "key-up",
					"id": 3187,
					"code": 62570,
					"tempChar": ""
				},
				{
					"order": 589,
					"prevSize": 32,
					"ligatures": "key2, password2",
					"name": "key2",
					"id": 2400,
					"code": 61149,
					"tempChar": ""
				},
				{
					"order": 590,
					"prevSize": 32,
					"ligatures": "key3, password3",
					"name": "key3",
					"id": 2401,
					"code": 61150,
					"tempChar": ""
				},
				{
					"order": 591,
					"prevSize": 32,
					"ligatures": "key4, password4",
					"name": "key4",
					"id": 2402,
					"code": 61151,
					"tempChar": ""
				},
				{
					"order": 592,
					"prevSize": 32,
					"ligatures": "key5, password5",
					"name": "key5",
					"id": 2403,
					"code": 61152,
					"tempChar": ""
				},
				{
					"name": "key6",
					"id": 1303,
					"order": 1736,
					"prevSize": 32,
					"code": 61572,
					"tempChar": ""
				},
				{
					"order": 370,
					"prevSize": 32,
					"ligatures": "keyboard, typing",
					"name": "keyboard",
					"id": 2181,
					"code": 60930,
					"tempChar": ""
				},
				{
					"name": "keyboard-o",
					"id": 1432,
					"order": 1865,
					"prevSize": 32,
					"code": 61724,
					"tempChar": ""
				},
				{
					"order": 371,
					"prevSize": 32,
					"ligatures": "keyboard2, typing2",
					"name": "keyboard2",
					"id": 2182,
					"code": 60931,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "keyboard, type",
					"order": 3215,
					"name": "keyboard3",
					"id": 150,
					"code": 59447,
					"tempChar": ""
				},
				{
					"order": 593,
					"prevSize": 32,
					"ligatures": "keyhole, entrance",
					"name": "keyhole",
					"id": 2404,
					"code": 61153,
					"tempChar": ""
				},
				{
					"id": 593,
					"order": 2808,
					"prevSize": 32,
					"code": 59976,
					"name": "kick",
					"tempChar": ""
				},
				{
					"id": 594,
					"order": 2809,
					"prevSize": 32,
					"code": 59977,
					"name": "kick2",
					"tempChar": ""
				},
				{
					"id": 1051,
					"order": 2352,
					"prevSize": 32,
					"code": 60434,
					"name": "kick3",
					"tempChar": ""
				},
				{
					"id": 595,
					"order": 2810,
					"prevSize": 32,
					"code": 59978,
					"name": "kill",
					"tempChar": ""
				},
				{
					"id": 596,
					"order": 2811,
					"prevSize": 32,
					"code": 59979,
					"name": "kill2",
					"tempChar": ""
				},
				{
					"id": 597,
					"order": 2812,
					"prevSize": 32,
					"code": 59980,
					"name": "kiss",
					"tempChar": ""
				},
				{
					"id": 598,
					"order": 2813,
					"prevSize": 32,
					"code": 59981,
					"name": "kiss2",
					"tempChar": ""
				},
				{
					"id": 1052,
					"order": 2353,
					"prevSize": 32,
					"code": 60435,
					"name": "kiss3",
					"tempChar": ""
				},
				{
					"order": 620,
					"prevSize": 32,
					"ligatures": "knife, tool6",
					"name": "knife",
					"id": 2431,
					"code": 61180,
					"tempChar": ""
				},
				{
					"id": 599,
					"order": 2814,
					"prevSize": 32,
					"code": 59982,
					"name": "know",
					"tempChar": ""
				},
				{
					"id": 600,
					"order": 2815,
					"prevSize": 32,
					"code": 59983,
					"name": "know2",
					"tempChar": ""
				},
				{
					"name": "krw, won",
					"id": 1489,
					"order": 1922,
					"prevSize": 32,
					"code": 61785,
					"tempChar": ""
				},
				{
					"order": 748,
					"prevSize": 32,
					"ligatures": "lab, beta",
					"name": "lab",
					"id": 2559,
					"code": 61308,
					"tempChar": ""
				},
				{
					"order": 666,
					"prevSize": 32,
					"ligatures": "ladder, ranking",
					"name": "ladder",
					"id": 2477,
					"code": 61226,
					"tempChar": ""
				},
				{
					"order": 756,
					"prevSize": 32,
					"ligatures": "lamp, light",
					"name": "lamp",
					"id": 2567,
					"code": 61316,
					"tempChar": ""
				},
				{
					"order": 757,
					"prevSize": 32,
					"ligatures": "lamp2, light2",
					"name": "lamp2",
					"id": 2568,
					"code": 61317,
					"tempChar": ""
				},
				{
					"order": 758,
					"prevSize": 32,
					"ligatures": "lamp3, light3",
					"name": "lamp3",
					"id": 2569,
					"code": 61318,
					"tempChar": ""
				},
				{
					"order": 760,
					"prevSize": 32,
					"ligatures": "lamp4, light5",
					"name": "lamp4",
					"id": 2571,
					"code": 61320,
					"tempChar": ""
				},
				{
					"order": 761,
					"prevSize": 32,
					"ligatures": "lamp5, light6",
					"name": "lamp5",
					"id": 2572,
					"code": 61321,
					"tempChar": ""
				},
				{
					"order": 762,
					"prevSize": 32,
					"ligatures": "lamp6, light7",
					"name": "lamp6",
					"id": 2573,
					"code": 61322,
					"tempChar": ""
				},
				{
					"order": 763,
					"prevSize": 32,
					"ligatures": "lamp7, light8",
					"name": "lamp7",
					"id": 2574,
					"code": 61323,
					"tempChar": ""
				},
				{
					"order": 764,
					"prevSize": 32,
					"ligatures": "lamp8, light9",
					"name": "lamp8",
					"id": 2575,
					"code": 61324,
					"tempChar": ""
				},
				{
					"order": 873,
					"prevSize": 32,
					"ligatures": "lan, network",
					"name": "lan",
					"id": 2684,
					"code": 61433,
					"tempChar": ""
				},
				{
					"order": 874,
					"prevSize": 32,
					"ligatures": "lan2, network2",
					"name": "lan2",
					"id": 2685,
					"code": 61434,
					"tempChar": ""
				},
				{
					"order": 875,
					"prevSize": 32,
					"ligatures": "lan3, network3",
					"name": "lan3",
					"id": 2686,
					"code": 61435,
					"tempChar": ""
				},
				{
					"name": "language",
					"id": 1566,
					"order": 1999,
					"prevSize": 32,
					"code": 61867,
					"tempChar": ""
				},
				{
					"order": 1539,
					"prevSize": 32,
					"ligatures": "lanyrd, brand26",
					"name": "lanyrd",
					"id": 3350,
					"code": 62733,
					"tempChar": ""
				},
				{
					"order": 377,
					"prevSize": 32,
					"ligatures": "laptop, computer",
					"name": "laptop",
					"id": 2188,
					"code": 60937,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "laptop-phone, devices",
					"order": 3221,
					"name": "laptop-phone",
					"id": 156,
					"code": 59453,
					"tempChar": ""
				},
				{
					"name": "laptop2",
					"id": 1416,
					"order": 1849,
					"prevSize": 32,
					"code": 61705,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "laptop, computer",
					"order": 3220,
					"name": "laptop3",
					"id": 155,
					"code": 59452,
					"tempChar": ""
				},
				{
					"order": 1066,
					"prevSize": 32,
					"ligatures": "lasso",
					"name": "lasso",
					"id": 2877,
					"code": 62260,
					"tempChar": ""
				},
				{
					"order": 1067,
					"prevSize": 32,
					"ligatures": "lasso2",
					"name": "lasso2",
					"id": 2878,
					"code": 62261,
					"tempChar": ""
				},
				{
					"order": 1165,
					"prevSize": 32,
					"ligatures": "last, player14",
					"name": "last",
					"id": 2976,
					"code": 62359,
					"tempChar": ""
				},
				{
					"order": 1208,
					"prevSize": 32,
					"ligatures": "last2, player19",
					"name": "last2",
					"id": 3019,
					"code": 62402,
					"tempChar": ""
				},
				{
					"order": 1580,
					"prevSize": 32,
					"ligatures": "lastfm, brand66",
					"name": "lastfm",
					"id": 3391,
					"code": 62774,
					"tempChar": ""
				},
				{
					"name": "lastfm-square",
					"id": 1648,
					"order": 2081,
					"prevSize": 32,
					"code": 61955,
					"tempChar": ""
				},
				{
					"order": 1581,
					"prevSize": 32,
					"ligatures": "lastfm2, brand67",
					"name": "lastfm2",
					"id": 3392,
					"code": 62775,
					"tempChar": ""
				},
				{
					"name": "lastfm3",
					"id": 1647,
					"order": 2080,
					"prevSize": 32,
					"code": 61954,
					"tempChar": ""
				},
				{
					"id": 601,
					"order": 2816,
					"prevSize": 32,
					"code": 59984,
					"name": "laugh",
					"tempChar": ""
				},
				{
					"id": 602,
					"order": 2817,
					"prevSize": 32,
					"code": 59985,
					"name": "laugh2",
					"tempChar": ""
				},
				{
					"id": 603,
					"order": 2818,
					"prevSize": 32,
					"code": 59986,
					"name": "launch",
					"tempChar": ""
				},
				{
					"id": 604,
					"order": 2819,
					"prevSize": 32,
					"code": 59987,
					"name": "launch2",
					"tempChar": ""
				},
				{
					"id": 1053,
					"order": 2354,
					"prevSize": 32,
					"code": 60436,
					"name": "launch3",
					"tempChar": ""
				},
				{
					"order": 540,
					"prevSize": 32,
					"ligatures": "laundry, washing-machine",
					"name": "laundry",
					"id": 2351,
					"code": 61100,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "layers, stack",
					"order": 3302,
					"name": "layers",
					"id": 237,
					"code": 59534,
					"tempChar": ""
				},
				{
					"order": 719,
					"prevSize": 32,
					"ligatures": "leaf, nature",
					"name": "leaf",
					"id": 2530,
					"code": 61279,
					"tempChar": ""
				},
				{
					"order": 720,
					"prevSize": 32,
					"ligatures": "leaf2, nature2",
					"name": "leaf2",
					"id": 2531,
					"code": 61280,
					"tempChar": ""
				},
				{
					"name": "leaf3",
					"id": 1281,
					"order": 1714,
					"prevSize": 32,
					"code": 61548,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "leaf, nature",
					"order": 3233,
					"name": "leaf4",
					"id": 168,
					"code": 59465,
					"tempChar": ""
				},
				{
					"name": "leanpub",
					"id": 1662,
					"order": 2095,
					"prevSize": 32,
					"code": 61970,
					"tempChar": ""
				},
				{
					"id": 605,
					"order": 2820,
					"prevSize": 32,
					"code": 59988,
					"name": "learn",
					"tempChar": ""
				},
				{
					"id": 606,
					"order": 2821,
					"prevSize": 32,
					"code": 59989,
					"name": "learn2",
					"tempChar": ""
				},
				{
					"name": "lemon-o",
					"id": 1318,
					"order": 1751,
					"prevSize": 32,
					"code": 61588,
					"tempChar": ""
				},
				{
					"name": "level-down",
					"id": 1474,
					"order": 1907,
					"prevSize": 32,
					"code": 61769,
					"tempChar": ""
				},
				{
					"name": "level-up",
					"id": 1473,
					"order": 1906,
					"prevSize": 32,
					"code": 61768,
					"tempChar": ""
				},
				{
					"order": 154,
					"prevSize": 32,
					"ligatures": "library3, bank",
					"name": "library",
					"id": 1965,
					"code": 60714,
					"tempChar": ""
				},
				{
					"order": 155,
					"prevSize": 32,
					"ligatures": "library4, bank2",
					"name": "library2",
					"id": 1966,
					"code": 60715,
					"tempChar": ""
				},
				{
					"order": 1604,
					"prevSize": 32,
					"ligatures": "libreoffice, file45",
					"name": "libreoffice",
					"id": 3415,
					"code": 62798,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "license, certificate",
					"order": 3194,
					"name": "license",
					"id": 129,
					"code": 59426,
					"tempChar": ""
				},
				{
					"id": 607,
					"order": 2822,
					"prevSize": 32,
					"code": 59990,
					"name": "lick",
					"tempChar": ""
				},
				{
					"id": 608,
					"order": 2823,
					"prevSize": 32,
					"code": 59991,
					"name": "lick2",
					"tempChar": ""
				},
				{
					"name": "life-bouy, life-buoy, life-ring, life-saver, support",
					"id": 1598,
					"order": 2031,
					"prevSize": 32,
					"code": 61901,
					"tempChar": ""
				},
				{
					"order": 285,
					"prevSize": 32,
					"ligatures": "lifebuoy, support2",
					"name": "lifebuoy",
					"id": 2096,
					"code": 60845,
					"tempChar": ""
				},
				{
					"order": 1425,
					"prevSize": 32,
					"ligatures": "ligature, typography",
					"name": "ligature",
					"id": 3236,
					"code": 62619,
					"tempChar": ""
				},
				{
					"order": 1426,
					"prevSize": 32,
					"ligatures": "ligature2, typography2",
					"name": "ligature2",
					"id": 3237,
					"code": 62620,
					"tempChar": ""
				},
				{
					"id": 609,
					"order": 2824,
					"prevSize": 32,
					"code": 59992,
					"name": "light",
					"tempChar": ""
				},
				{
					"id": 610,
					"order": 2825,
					"prevSize": 32,
					"code": 59993,
					"name": "light2",
					"tempChar": ""
				},
				{
					"id": 1054,
					"order": 2355,
					"prevSize": 32,
					"code": 60437,
					"name": "light3",
					"tempChar": ""
				},
				{
					"name": "lightbulb-o",
					"id": 1388,
					"order": 1821,
					"prevSize": 32,
					"code": 61675,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "lighter, fire",
					"order": 3165,
					"name": "lighter",
					"id": 100,
					"code": 59397,
					"tempChar": ""
				},
				{
					"id": 1055,
					"order": 2356,
					"prevSize": 32,
					"code": 60438,
					"name": "like",
					"tempChar": ""
				},
				{
					"name": "line-chart",
					"id": 1646,
					"order": 2079,
					"prevSize": 32,
					"code": 61953,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "line-spacing, typography12",
					"order": 3316,
					"name": "line-spacing",
					"id": 251,
					"code": 59548,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "linearicons, perxis",
					"order": 3230,
					"name": "linearicons",
					"id": 165,
					"code": 59462,
					"tempChar": ""
				},
				{
					"order": 923,
					"prevSize": 32,
					"ligatures": "link, chain",
					"name": "link",
					"id": 2734,
					"code": 61919,
					"tempChar": ""
				},
				{
					"id": 1056,
					"order": 2357,
					"prevSize": 32,
					"code": 60439,
					"name": "link10",
					"tempChar": ""
				},
				{
					"order": 925,
					"prevSize": 32,
					"ligatures": "link3, chain2",
					"name": "link2",
					"id": 2736,
					"code": 61951,
					"tempChar": ""
				},
				{
					"order": 927,
					"prevSize": 32,
					"ligatures": "link5, chain3",
					"name": "link3",
					"id": 2738,
					"code": 61983,
					"tempChar": ""
				},
				{
					"order": 929,
					"prevSize": 32,
					"ligatures": "link7, chain4",
					"name": "link4",
					"id": 2740,
					"code": 61998,
					"tempChar": ""
				},
				{
					"order": 931,
					"prevSize": 32,
					"ligatures": "link9, chain5",
					"name": "link5",
					"id": 2742,
					"code": 62015,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "link, url",
					"order": 3267,
					"name": "link7",
					"id": 202,
					"code": 59499,
					"tempChar": ""
				},
				{
					"id": 611,
					"order": 2826,
					"prevSize": 32,
					"code": 59994,
					"name": "link8",
					"tempChar": ""
				},
				{
					"id": 612,
					"order": 2827,
					"prevSize": 32,
					"code": 59995,
					"name": "link9",
					"tempChar": ""
				},
				{
					"order": 1578,
					"prevSize": 32,
					"ligatures": "linkedin, brand64",
					"name": "linkedin",
					"id": 3389,
					"code": 62772,
					"tempChar": ""
				},
				{
					"name": "linkedin-square",
					"id": 1311,
					"order": 1744,
					"prevSize": 32,
					"code": 61580,
					"tempChar": ""
				},
				{
					"order": 1579,
					"prevSize": 32,
					"ligatures": "linkedin2, brand65",
					"name": "linkedin2",
					"id": 3390,
					"code": 62773,
					"tempChar": ""
				},
				{
					"name": "linkedin3",
					"id": 1378,
					"order": 1811,
					"prevSize": 32,
					"code": 61665,
					"tempChar": ""
				},
				{
					"name": "linux",
					"id": 1522,
					"order": 1955,
					"prevSize": 32,
					"code": 61820,
					"tempChar": ""
				},
				{
					"order": 1012,
					"prevSize": 32,
					"ligatures": "lips, mouth",
					"name": "lips",
					"id": 2823,
					"code": 62206,
					"tempChar": ""
				},
				{
					"order": 1013,
					"prevSize": 32,
					"ligatures": "lips2, mouth2",
					"name": "lips2",
					"id": 2824,
					"code": 62207,
					"tempChar": ""
				},
				{
					"order": 859,
					"prevSize": 32,
					"ligatures": "list, todo",
					"name": "list",
					"id": 2670,
					"code": 61419,
					"tempChar": ""
				},
				{
					"name": "list-alt",
					"id": 1210,
					"order": 1643,
					"prevSize": 32,
					"code": 61474,
					"tempChar": ""
				},
				{
					"order": 858,
					"prevSize": 32,
					"ligatures": "list-numbered, options",
					"name": "list-numbered",
					"id": 2669,
					"code": 61418,
					"tempChar": ""
				},
				{
					"name": "list-ol",
					"id": 1358,
					"order": 1791,
					"prevSize": 32,
					"code": 61643,
					"tempChar": ""
				},
				{
					"name": "list-ul",
					"id": 1357,
					"order": 1790,
					"prevSize": 32,
					"code": 61642,
					"tempChar": ""
				},
				{
					"order": 860,
					"prevSize": 32,
					"ligatures": "list2, todo2",
					"name": "list2",
					"id": 2671,
					"code": 61420,
					"tempChar": ""
				},
				{
					"name": "list3",
					"id": 1234,
					"order": 1667,
					"prevSize": 32,
					"code": 61498,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "list, options2",
					"order": 3274,
					"name": "list4",
					"id": 209,
					"code": 59506,
					"tempChar": ""
				},
				{
					"id": 1057,
					"order": 2358,
					"prevSize": 32,
					"code": 60440,
					"name": "listen",
					"tempChar": ""
				},
				{
					"id": 613,
					"order": 2828,
					"prevSize": 32,
					"code": 59996,
					"name": "live",
					"tempChar": ""
				},
				{
					"id": 614,
					"order": 2829,
					"prevSize": 32,
					"code": 59997,
					"name": "live2",
					"tempChar": ""
				},
				{
					"id": 1058,
					"order": 2359,
					"prevSize": 32,
					"code": 60441,
					"name": "live3",
					"tempChar": ""
				},
				{
					"id": 615,
					"order": 2830,
					"prevSize": 32,
					"code": 59998,
					"name": "load",
					"tempChar": ""
				},
				{
					"id": 616,
					"order": 2831,
					"prevSize": 32,
					"code": 59999,
					"name": "load2",
					"tempChar": ""
				},
				{
					"id": 1059,
					"order": 2360,
					"prevSize": 32,
					"code": 60442,
					"name": "load3",
					"tempChar": ""
				},
				{
					"id": 617,
					"order": 2832,
					"prevSize": 32,
					"code": 60000,
					"name": "locate",
					"tempChar": ""
				},
				{
					"id": 618,
					"order": 2833,
					"prevSize": 32,
					"code": 60001,
					"name": "locate2",
					"tempChar": ""
				},
				{
					"id": 1060,
					"order": 2361,
					"prevSize": 32,
					"code": 60443,
					"name": "locate3",
					"tempChar": ""
				},
				{
					"order": 314,
					"prevSize": 32,
					"ligatures": "location, map-marker",
					"name": "location",
					"id": 2125,
					"code": 60874,
					"tempChar": ""
				},
				{
					"name": "location-arrow",
					"id": 1439,
					"order": 1872,
					"prevSize": 32,
					"code": 61732,
					"tempChar": ""
				},
				{
					"order": 315,
					"prevSize": 32,
					"ligatures": "location2, map-marker2",
					"name": "location2",
					"id": 2126,
					"code": 60875,
					"tempChar": ""
				},
				{
					"order": 316,
					"prevSize": 32,
					"ligatures": "location3, map-marker3",
					"name": "location3",
					"id": 2127,
					"code": 60876,
					"tempChar": ""
				},
				{
					"order": 317,
					"prevSize": 32,
					"ligatures": "location4, map-marker4",
					"name": "location4",
					"id": 2128,
					"code": 60877,
					"tempChar": ""
				},
				{
					"order": 318,
					"prevSize": 32,
					"ligatures": "location5, map-marker5",
					"name": "location5",
					"id": 2129,
					"code": 60878,
					"tempChar": ""
				},
				{
					"order": 319,
					"prevSize": 32,
					"ligatures": "location6, map-marker6",
					"name": "location6",
					"id": 2130,
					"code": 60879,
					"tempChar": ""
				},
				{
					"order": 320,
					"prevSize": 32,
					"ligatures": "location7, map-marker7",
					"name": "location7",
					"id": 2131,
					"code": 60880,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "location, compass",
					"order": 3213,
					"name": "location8",
					"id": 148,
					"code": 59445,
					"tempChar": ""
				},
				{
					"order": 594,
					"prevSize": 32,
					"ligatures": "lock, secure",
					"name": "lock",
					"id": 2405,
					"code": 61154,
					"tempChar": ""
				},
				{
					"id": 1061,
					"order": 2362,
					"prevSize": 32,
					"code": 60444,
					"name": "lock10",
					"tempChar": ""
				},
				{
					"order": 595,
					"prevSize": 32,
					"ligatures": "lock2, secure2",
					"name": "lock2",
					"id": 2406,
					"code": 61155,
					"tempChar": ""
				},
				{
					"order": 596,
					"prevSize": 32,
					"ligatures": "lock3, secure3",
					"name": "lock3",
					"id": 2407,
					"code": 61156,
					"tempChar": ""
				},
				{
					"order": 597,
					"prevSize": 32,
					"ligatures": "lock4, secure4",
					"name": "lock4",
					"id": 2408,
					"code": 61157,
					"tempChar": ""
				},
				{
					"order": 599,
					"prevSize": 32,
					"ligatures": "lock5, secure5",
					"name": "lock5",
					"id": 2410,
					"code": 61159,
					"tempChar": ""
				},
				{
					"name": "lock6",
					"id": 1211,
					"order": 1644,
					"prevSize": 32,
					"code": 61475,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "lock, privacy",
					"order": 3175,
					"name": "lock7",
					"id": 110,
					"code": 59407,
					"tempChar": ""
				},
				{
					"id": 619,
					"order": 2834,
					"prevSize": 32,
					"code": 60002,
					"name": "lock8",
					"tempChar": ""
				},
				{
					"id": 620,
					"order": 2835,
					"prevSize": 32,
					"code": 60003,
					"name": "lock9",
					"tempChar": ""
				},
				{
					"name": "long-arrow-down",
					"id": 1515,
					"order": 1948,
					"prevSize": 32,
					"code": 61813,
					"tempChar": ""
				},
				{
					"name": "long-arrow-left",
					"id": 1517,
					"order": 1950,
					"prevSize": 32,
					"code": 61815,
					"tempChar": ""
				},
				{
					"name": "long-arrow-right",
					"id": 1518,
					"order": 1951,
					"prevSize": 32,
					"code": 61816,
					"tempChar": ""
				},
				{
					"name": "long-arrow-up",
					"id": 1516,
					"order": 1949,
					"prevSize": 32,
					"code": 61814,
					"tempChar": ""
				},
				{
					"id": 621,
					"order": 2836,
					"prevSize": 32,
					"code": 60004,
					"name": "look",
					"tempChar": ""
				},
				{
					"id": 622,
					"order": 2837,
					"prevSize": 32,
					"code": 60005,
					"name": "look2",
					"tempChar": ""
				},
				{
					"order": 1194,
					"prevSize": 32,
					"ligatures": "loop, repeat",
					"name": "loop",
					"id": 3005,
					"code": 62388,
					"tempChar": ""
				},
				{
					"order": 1195,
					"prevSize": 32,
					"ligatures": "loop2, repeat2",
					"name": "loop2",
					"id": 3006,
					"code": 62389,
					"tempChar": ""
				},
				{
					"order": 1196,
					"prevSize": 32,
					"ligatures": "loop3, repeat3",
					"name": "loop3",
					"id": 3007,
					"code": 62390,
					"tempChar": ""
				},
				{
					"order": 1200,
					"prevSize": 32,
					"ligatures": "loop4, repeat4",
					"name": "loop4",
					"id": 3011,
					"code": 62394,
					"tempChar": ""
				},
				{
					"id": 623,
					"order": 2838,
					"prevSize": 32,
					"code": 60006,
					"name": "love",
					"tempChar": ""
				},
				{
					"id": 624,
					"order": 2839,
					"prevSize": 32,
					"code": 60007,
					"name": "love2",
					"tempChar": ""
				},
				{
					"name": "low-vision",
					"id": 1801,
					"order": 2234,
					"prevSize": 32,
					"code": 62120,
					"tempChar": ""
				},
				{
					"order": 1460,
					"prevSize": 32,
					"ligatures": "ltr, wysiwyg32",
					"name": "ltr",
					"id": 3271,
					"code": 62654,
					"tempChar": ""
				},
				{
					"order": 1462,
					"prevSize": 32,
					"ligatures": "ltr2, wysiwyg34",
					"name": "ltr2",
					"id": 3273,
					"code": 62656,
					"tempChar": ""
				},
				{
					"order": 14,
					"prevSize": 32,
					"ligatures": "magazine, newspaper2",
					"name": "magazine",
					"id": 1825,
					"code": 60574,
					"tempChar": ""
				},
				{
					"name": "magic",
					"id": 1362,
					"order": 1795,
					"prevSize": 32,
					"code": 61648,
					"tempChar": ""
				},
				{
					"order": 623,
					"prevSize": 32,
					"ligatures": "magic-wand, wizard",
					"name": "magic-wand",
					"id": 2434,
					"code": 61183,
					"tempChar": ""
				},
				{
					"order": 624,
					"prevSize": 32,
					"ligatures": "magic-wand2, wizard2",
					"name": "magic-wand2",
					"id": 2435,
					"code": 61184,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "magic-wand, tool",
					"order": 3163,
					"name": "magic-wand3",
					"id": 98,
					"code": 59395,
					"tempChar": ""
				},
				{
					"order": 751,
					"prevSize": 32,
					"ligatures": "magnet, attract",
					"name": "magnet",
					"id": 2562,
					"code": 61311,
					"tempChar": ""
				},
				{
					"order": 752,
					"prevSize": 32,
					"ligatures": "magnet2, attract2",
					"name": "magnet2",
					"id": 2563,
					"code": 61312,
					"tempChar": ""
				},
				{
					"name": "magnet3",
					"id": 1290,
					"order": 1723,
					"prevSize": 32,
					"code": 61558,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "magnifier, search",
					"order": 3271,
					"name": "magnifier",
					"id": 206,
					"code": 59503,
					"tempChar": ""
				},
				{
					"order": 1508,
					"prevSize": 32,
					"ligatures": "mail7, contact3",
					"name": "mail",
					"id": 3319,
					"code": 62702,
					"tempChar": ""
				},
				{
					"name": "mail-forward, share5",
					"id": 1273,
					"order": 1706,
					"prevSize": 32,
					"code": 61540,
					"tempChar": ""
				},
				{
					"name": "mail-reply, reply2",
					"id": 1424,
					"order": 1857,
					"prevSize": 32,
					"code": 61714,
					"tempChar": ""
				},
				{
					"name": "mail-reply-all, reply-all2",
					"id": 1437,
					"order": 1870,
					"prevSize": 32,
					"code": 61730,
					"tempChar": ""
				},
				{
					"order": 1509,
					"prevSize": 32,
					"ligatures": "mail8, contact4",
					"name": "mail2",
					"id": 3320,
					"code": 62703,
					"tempChar": ""
				},
				{
					"order": 1510,
					"prevSize": 32,
					"ligatures": "mail9, contact5",
					"name": "mail3",
					"id": 3321,
					"code": 62704,
					"tempChar": ""
				},
				{
					"order": 1511,
					"prevSize": 32,
					"ligatures": "mail10, contact6",
					"name": "mail4",
					"id": 3322,
					"code": 62705,
					"tempChar": ""
				},
				{
					"order": 311,
					"prevSize": 32,
					"ligatures": "mailbox, mail6",
					"name": "mailbox",
					"id": 2122,
					"code": 60871,
					"tempChar": ""
				},
				{
					"id": 625,
					"order": 2840,
					"prevSize": 32,
					"code": 60008,
					"name": "make",
					"tempChar": ""
				},
				{
					"order": 1407,
					"prevSize": 32,
					"ligatures": "make-group",
					"name": "make-group",
					"id": 3218,
					"code": 62601,
					"tempChar": ""
				},
				{
					"id": 626,
					"order": 2841,
					"prevSize": 32,
					"code": 60009,
					"name": "make2",
					"tempChar": ""
				},
				{
					"order": 1024,
					"prevSize": 32,
					"ligatures": "male2, gender",
					"name": "male",
					"id": 2835,
					"code": 62218,
					"tempChar": ""
				},
				{
					"name": "male2",
					"id": 1528,
					"order": 1961,
					"prevSize": 32,
					"code": 61827,
					"tempChar": ""
				},
				{
					"order": 1021,
					"prevSize": 32,
					"ligatures": "man, male",
					"name": "man",
					"id": 2832,
					"code": 62215,
					"tempChar": ""
				},
				{
					"order": 1023,
					"prevSize": 32,
					"ligatures": "man-woman, toilet2",
					"name": "man-woman",
					"id": 2834,
					"code": 62217,
					"tempChar": ""
				},
				{
					"id": 627,
					"order": 2842,
					"prevSize": 32,
					"code": 60010,
					"name": "manage",
					"tempChar": ""
				},
				{
					"id": 628,
					"order": 2843,
					"prevSize": 32,
					"code": 60011,
					"name": "manage2",
					"tempChar": ""
				},
				{
					"id": 629,
					"order": 2844,
					"prevSize": 32,
					"code": 60012,
					"name": "manufacture",
					"tempChar": ""
				},
				{
					"id": 630,
					"order": 2845,
					"prevSize": 32,
					"code": 60013,
					"name": "manufacture2",
					"tempChar": ""
				},
				{
					"order": 327,
					"prevSize": 32,
					"ligatures": "map, guide",
					"name": "map",
					"id": 2138,
					"code": 60887,
					"tempChar": ""
				},
				{
					"name": "map-marker",
					"id": 1240,
					"order": 1673,
					"prevSize": 32,
					"code": 61505,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "map-marker, pin2",
					"order": 3211,
					"name": "map-marker2",
					"id": 146,
					"code": 59443,
					"tempChar": ""
				},
				{
					"name": "map-o",
					"id": 1756,
					"order": 2189,
					"prevSize": 32,
					"code": 62072,
					"tempChar": ""
				},
				{
					"name": "map-pin",
					"id": 1754,
					"order": 2187,
					"prevSize": 32,
					"code": 62070,
					"tempChar": ""
				},
				{
					"name": "map-signs",
					"id": 1755,
					"order": 2188,
					"prevSize": 32,
					"code": 62071,
					"tempChar": ""
				},
				{
					"order": 328,
					"prevSize": 32,
					"ligatures": "map2, guide2",
					"name": "map2",
					"id": 2139,
					"code": 60888,
					"tempChar": ""
				},
				{
					"order": 329,
					"prevSize": 32,
					"ligatures": "map3, guide3",
					"name": "map3",
					"id": 2140,
					"code": 60889,
					"tempChar": ""
				},
				{
					"order": 330,
					"prevSize": 32,
					"ligatures": "map4, guide4",
					"name": "map4",
					"id": 2141,
					"code": 60890,
					"tempChar": ""
				},
				{
					"order": 331,
					"prevSize": 32,
					"ligatures": "map5, guide5",
					"name": "map5",
					"id": 2142,
					"code": 60891,
					"tempChar": ""
				},
				{
					"name": "map6",
					"id": 1757,
					"order": 2190,
					"prevSize": 32,
					"code": 62073,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "map, guide",
					"order": 3212,
					"name": "map7",
					"id": 147,
					"code": 59444,
					"tempChar": ""
				},
				{
					"id": 631,
					"order": 2846,
					"prevSize": 32,
					"code": 60014,
					"name": "mark",
					"tempChar": ""
				},
				{
					"id": 632,
					"order": 2847,
					"prevSize": 32,
					"code": 60015,
					"name": "mark2",
					"tempChar": ""
				},
				{
					"order": 37,
					"prevSize": 32,
					"ligatures": "marker, write13",
					"name": "marker",
					"id": 1848,
					"code": 60597,
					"tempChar": ""
				},
				{
					"order": 38,
					"prevSize": 32,
					"ligatures": "marker2, write14",
					"name": "marker2",
					"id": 1849,
					"code": 60598,
					"tempChar": ""
				},
				{
					"order": 1488,
					"prevSize": 32,
					"ligatures": "markup, code3",
					"name": "markup",
					"id": 3299,
					"code": 62682,
					"tempChar": ""
				},
				{
					"id": 633,
					"order": 2848,
					"prevSize": 32,
					"code": 60016,
					"name": "marry",
					"tempChar": ""
				},
				{
					"id": 634,
					"order": 2849,
					"prevSize": 32,
					"code": 60017,
					"name": "marry2",
					"tempChar": ""
				},
				{
					"id": 1062,
					"order": 2363,
					"prevSize": 32,
					"code": 60445,
					"name": "marry3",
					"tempChar": ""
				},
				{
					"name": "mars",
					"id": 1676,
					"order": 2109,
					"prevSize": 32,
					"code": 61986,
					"tempChar": ""
				},
				{
					"name": "mars-double",
					"id": 1681,
					"order": 2114,
					"prevSize": 32,
					"code": 61991,
					"tempChar": ""
				},
				{
					"name": "mars-stroke",
					"id": 1683,
					"order": 2116,
					"prevSize": 32,
					"code": 61993,
					"tempChar": ""
				},
				{
					"name": "mars-stroke-h",
					"id": 1685,
					"order": 2118,
					"prevSize": 32,
					"code": 61995,
					"tempChar": ""
				},
				{
					"name": "mars-stroke-v",
					"id": 1684,
					"order": 2117,
					"prevSize": 32,
					"code": 61994,
					"tempChar": ""
				},
				{
					"id": 635,
					"order": 2850,
					"prevSize": 32,
					"code": 60018,
					"name": "match",
					"tempChar": ""
				},
				{
					"id": 636,
					"order": 2851,
					"prevSize": 32,
					"code": 60019,
					"name": "match2",
					"tempChar": ""
				},
				{
					"name": "maxcdn",
					"id": 1456,
					"order": 1889,
					"prevSize": 32,
					"code": 61750,
					"tempChar": ""
				},
				{
					"name": "meanpath",
					"id": 1657,
					"order": 2090,
					"prevSize": 32,
					"code": 61964,
					"tempChar": ""
				},
				{
					"id": 637,
					"order": 2852,
					"prevSize": 32,
					"code": 60020,
					"name": "measure",
					"tempChar": ""
				},
				{
					"id": 638,
					"order": 2853,
					"prevSize": 32,
					"code": 60021,
					"name": "measure2",
					"tempChar": ""
				},
				{
					"id": 1063,
					"order": 2364,
					"prevSize": 32,
					"code": 60446,
					"name": "measure3",
					"tempChar": ""
				},
				{
					"order": 674,
					"prevSize": 32,
					"ligatures": "medal, badge2",
					"name": "medal",
					"id": 2485,
					"code": 61234,
					"tempChar": ""
				},
				{
					"order": 676,
					"prevSize": 32,
					"ligatures": "medal-first, badge4",
					"name": "medal-first",
					"id": 2487,
					"code": 61236,
					"tempChar": ""
				},
				{
					"order": 677,
					"prevSize": 32,
					"ligatures": "medal-second, badge5",
					"name": "medal-second",
					"id": 2488,
					"code": 61237,
					"tempChar": ""
				},
				{
					"order": 673,
					"prevSize": 32,
					"ligatures": "medal-star, badge",
					"name": "medal-star",
					"id": 2484,
					"code": 61233,
					"tempChar": ""
				},
				{
					"order": 678,
					"prevSize": 32,
					"ligatures": "medal-third, badge6",
					"name": "medal-third",
					"id": 2489,
					"code": 61238,
					"tempChar": ""
				},
				{
					"order": 675,
					"prevSize": 32,
					"ligatures": "medal2, badge3",
					"name": "medal2",
					"id": 2486,
					"code": 61235,
					"tempChar": ""
				},
				{
					"order": 93,
					"prevSize": 32,
					"ligatures": "media, photo-music",
					"name": "media",
					"id": 1904,
					"code": 60653,
					"tempChar": ""
				},
				{
					"id": 639,
					"order": 2854,
					"prevSize": 32,
					"code": 60022,
					"name": "medicate",
					"tempChar": ""
				},
				{
					"id": 640,
					"order": 2855,
					"prevSize": 32,
					"code": 60023,
					"name": "medicate2",
					"tempChar": ""
				},
				{
					"id": 1064,
					"order": 2365,
					"prevSize": 32,
					"code": 60447,
					"name": "medicate3",
					"tempChar": ""
				},
				{
					"name": "medium",
					"id": 1698,
					"order": 2131,
					"prevSize": 32,
					"code": 62010,
					"tempChar": ""
				},
				{
					"name": "medkit",
					"id": 1402,
					"order": 1835,
					"prevSize": 32,
					"code": 61690,
					"tempChar": ""
				},
				{
					"order": 124,
					"prevSize": 32,
					"ligatures": "megaphone2, bullhorn2",
					"name": "megaphone",
					"id": 1935,
					"code": 60684,
					"tempChar": ""
				},
				{
					"name": "meh-o",
					"id": 1430,
					"order": 1863,
					"prevSize": 32,
					"code": 61722,
					"tempChar": ""
				},
				{
					"id": 641,
					"order": 2856,
					"prevSize": 32,
					"code": 60024,
					"name": "melt",
					"tempChar": ""
				},
				{
					"id": 642,
					"order": 2857,
					"prevSize": 32,
					"code": 60025,
					"name": "melt2",
					"tempChar": ""
				},
				{
					"order": 876,
					"prevSize": 32,
					"ligatures": "menu, dots3",
					"name": "menu",
					"id": 2687,
					"code": 61436,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "menu-circle, menu2",
					"order": 3286,
					"name": "menu-circle",
					"id": 221,
					"code": 59518,
					"tempChar": ""
				},
				{
					"order": 1343,
					"prevSize": 32,
					"ligatures": "menu-close, arrows5",
					"name": "menu-close",
					"id": 3154,
					"code": 62537,
					"tempChar": ""
				},
				{
					"order": 1344,
					"prevSize": 32,
					"ligatures": "menu-close2, arrows6",
					"name": "menu-close2",
					"id": 3155,
					"code": 62538,
					"tempChar": ""
				},
				{
					"order": 1341,
					"prevSize": 32,
					"ligatures": "menu-open, arrows3",
					"name": "menu-open",
					"id": 3152,
					"code": 62535,
					"tempChar": ""
				},
				{
					"order": 1342,
					"prevSize": 32,
					"ligatures": "menu-open2, arrows4",
					"name": "menu-open2",
					"id": 3153,
					"code": 62536,
					"tempChar": ""
				},
				{
					"order": 886,
					"prevSize": 32,
					"ligatures": "menu10, options7",
					"name": "menu10",
					"id": 2697,
					"code": 61551,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "menu, options",
					"order": 3273,
					"name": "menu11",
					"id": 208,
					"code": 59505,
					"tempChar": ""
				},
				{
					"order": 878,
					"prevSize": 32,
					"ligatures": "menu2, list3",
					"name": "menu2",
					"id": 2689,
					"code": 61438,
					"tempChar": ""
				},
				{
					"order": 879,
					"prevSize": 32,
					"ligatures": "menu3, list4",
					"name": "menu3",
					"id": 2690,
					"code": 61439,
					"tempChar": ""
				},
				{
					"order": 880,
					"prevSize": 32,
					"ligatures": "menu4, options2",
					"name": "menu4",
					"id": 2691,
					"code": 61455,
					"tempChar": ""
				},
				{
					"order": 881,
					"prevSize": 32,
					"ligatures": "menu5, options3",
					"name": "menu5",
					"id": 2692,
					"code": 61471,
					"tempChar": ""
				},
				{
					"order": 882,
					"prevSize": 32,
					"ligatures": "menu6, options4",
					"name": "menu6",
					"id": 2693,
					"code": 61472,
					"tempChar": ""
				},
				{
					"order": 883,
					"prevSize": 32,
					"ligatures": "menu7, list5",
					"name": "menu7",
					"id": 2694,
					"code": 61503,
					"tempChar": ""
				},
				{
					"order": 884,
					"prevSize": 32,
					"ligatures": "menu8, options5",
					"name": "menu8",
					"id": 2695,
					"code": 61519,
					"tempChar": ""
				},
				{
					"order": 885,
					"prevSize": 32,
					"ligatures": "menu9, options6",
					"name": "menu9",
					"id": 2696,
					"code": 61535,
					"tempChar": ""
				},
				{
					"name": "mercury",
					"id": 1677,
					"order": 2110,
					"prevSize": 32,
					"code": 61987,
					"tempChar": ""
				},
				{
					"order": 1206,
					"prevSize": 32,
					"ligatures": "merge, arrows2",
					"name": "merge",
					"id": 3017,
					"code": 62400,
					"tempChar": ""
				},
				{
					"id": 643,
					"order": 2858,
					"prevSize": 32,
					"code": 60026,
					"name": "merge2",
					"tempChar": ""
				},
				{
					"id": 644,
					"order": 2859,
					"prevSize": 32,
					"code": 60027,
					"name": "merge3",
					"tempChar": ""
				},
				{
					"order": 736,
					"prevSize": 32,
					"ligatures": "meter, gauge",
					"name": "meter",
					"id": 2547,
					"code": 61296,
					"tempChar": ""
				},
				{
					"order": 740,
					"prevSize": 32,
					"ligatures": "meter-fast, gauge5",
					"name": "meter-fast",
					"id": 2551,
					"code": 61300,
					"tempChar": ""
				},
				{
					"order": 739,
					"prevSize": 32,
					"ligatures": "meter-medium, gauge4",
					"name": "meter-medium",
					"id": 2550,
					"code": 61299,
					"tempChar": ""
				},
				{
					"order": 738,
					"prevSize": 32,
					"ligatures": "meter-slow, gauge3",
					"name": "meter-slow",
					"id": 2549,
					"code": 61298,
					"tempChar": ""
				},
				{
					"order": 737,
					"prevSize": 32,
					"ligatures": "meter2, gauge2",
					"name": "meter2",
					"id": 2548,
					"code": 61297,
					"tempChar": ""
				},
				{
					"order": 741,
					"prevSize": 32,
					"ligatures": "meter3, gauge6",
					"name": "meter3",
					"id": 2552,
					"code": 61301,
					"tempChar": ""
				},
				{
					"order": 139,
					"prevSize": 32,
					"ligatures": "mic, microphone",
					"name": "mic",
					"id": 1950,
					"code": 60699,
					"tempChar": ""
				},
				{
					"order": 140,
					"prevSize": 32,
					"ligatures": "mic-off, microphone2",
					"name": "mic-off",
					"id": 1951,
					"code": 60700,
					"tempChar": ""
				},
				{
					"order": 142,
					"prevSize": 32,
					"ligatures": "mic-off2, microphone4",
					"name": "mic-off2",
					"id": 1953,
					"code": 60702,
					"tempChar": ""
				},
				{
					"order": 141,
					"prevSize": 32,
					"ligatures": "mic2, microphone3",
					"name": "mic2",
					"id": 1952,
					"code": 60701,
					"tempChar": ""
				},
				{
					"order": 143,
					"prevSize": 32,
					"ligatures": "mic3, microphone5",
					"name": "mic3",
					"id": 1954,
					"code": 60703,
					"tempChar": ""
				},
				{
					"order": 144,
					"prevSize": 32,
					"ligatures": "mic4, microphone6",
					"name": "mic4",
					"id": 1955,
					"code": 60704,
					"tempChar": ""
				},
				{
					"order": 145,
					"prevSize": 32,
					"ligatures": "mic5, microphone7",
					"name": "mic5",
					"id": 1956,
					"code": 60705,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "mic, voice",
					"order": 3254,
					"name": "mic6",
					"id": 189,
					"code": 59486,
					"tempChar": ""
				},
				{
					"name": "microphone",
					"id": 1450,
					"order": 1883,
					"prevSize": 32,
					"code": 61744,
					"tempChar": ""
				},
				{
					"name": "microphone-slash",
					"id": 1451,
					"order": 1884,
					"prevSize": 32,
					"code": 61745,
					"tempChar": ""
				},
				{
					"order": 559,
					"prevSize": 32,
					"ligatures": "microscope, research",
					"name": "microscope",
					"id": 2370,
					"code": 61119,
					"tempChar": ""
				},
				{
					"order": 713,
					"prevSize": 32,
					"ligatures": "milk, drink10",
					"name": "milk",
					"id": 2524,
					"code": 61273,
					"tempChar": ""
				},
				{
					"id": 645,
					"order": 2860,
					"prevSize": 32,
					"code": 60028,
					"name": "mill",
					"tempChar": ""
				},
				{
					"id": 646,
					"order": 2861,
					"prevSize": 32,
					"code": 60029,
					"name": "mill2",
					"tempChar": ""
				},
				{
					"id": 647,
					"order": 2862,
					"prevSize": 32,
					"code": 60030,
					"name": "mine",
					"tempChar": ""
				},
				{
					"id": 648,
					"order": 2863,
					"prevSize": 32,
					"code": 60031,
					"name": "mine2",
					"tempChar": ""
				},
				{
					"order": 1116,
					"prevSize": 32,
					"ligatures": "minus, subtract2",
					"name": "minus",
					"id": 2927,
					"code": 62310,
					"tempChar": ""
				},
				{
					"order": 1122,
					"prevSize": 32,
					"ligatures": "minus-circle, remove",
					"name": "minus-circle",
					"id": 2933,
					"code": 62316,
					"tempChar": ""
				},
				{
					"order": 1124,
					"prevSize": 32,
					"ligatures": "minus-circle2, remove2",
					"name": "minus-circle2",
					"id": 2935,
					"code": 62318,
					"tempChar": ""
				},
				{
					"name": "minus-circle3",
					"id": 1260,
					"order": 1693,
					"prevSize": 32,
					"code": 61526,
					"tempChar": ""
				},
				{
					"name": "minus-square",
					"id": 1471,
					"order": 1904,
					"prevSize": 32,
					"code": 61766,
					"tempChar": ""
				},
				{
					"name": "minus-square-o",
					"id": 1472,
					"order": 1905,
					"prevSize": 32,
					"code": 61767,
					"tempChar": ""
				},
				{
					"order": 1118,
					"prevSize": 32,
					"ligatures": "minus2, subtract3",
					"name": "minus2",
					"id": 2929,
					"code": 62312,
					"tempChar": ""
				},
				{
					"order": 1120,
					"prevSize": 32,
					"ligatures": "minus3, subtract4",
					"name": "minus3",
					"id": 2931,
					"code": 62314,
					"tempChar": ""
				},
				{
					"name": "minus4",
					"id": 1277,
					"order": 1710,
					"prevSize": 32,
					"code": 61544,
					"tempChar": ""
				},
				{
					"id": 1065,
					"order": 2366,
					"prevSize": 32,
					"code": 60448,
					"name": "mix",
					"tempChar": ""
				},
				{
					"name": "mixcloud",
					"id": 1772,
					"order": 2205,
					"prevSize": 32,
					"code": 62089,
					"tempChar": ""
				},
				{
					"order": 378,
					"prevSize": 32,
					"ligatures": "mobile, cell-phone",
					"name": "mobile",
					"id": 2189,
					"code": 60938,
					"tempChar": ""
				},
				{
					"order": 379,
					"prevSize": 32,
					"ligatures": "mobile2, cell-phone2",
					"name": "mobile2",
					"id": 2190,
					"code": 60939,
					"tempChar": ""
				},
				{
					"order": 381,
					"prevSize": 32,
					"ligatures": "mobile4, cell-phone3",
					"name": "mobile3",
					"id": 2192,
					"code": 60941,
					"tempChar": ""
				},
				{
					"name": "mobile4, mobile-phone",
					"id": 1418,
					"order": 1851,
					"prevSize": 32,
					"code": 61707,
					"tempChar": ""
				},
				{
					"name": "modx",
					"id": 1768,
					"order": 2201,
					"prevSize": 32,
					"code": 62085,
					"tempChar": ""
				},
				{
					"name": "money",
					"id": 1368,
					"order": 1801,
					"prevSize": 32,
					"code": 61654,
					"tempChar": ""
				},
				{
					"order": 978,
					"prevSize": 32,
					"ligatures": "moon, night",
					"name": "moon",
					"id": 2789,
					"code": 62172,
					"tempChar": ""
				},
				{
					"name": "moon-o",
					"id": 1531,
					"order": 1964,
					"prevSize": 32,
					"code": 61830,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "moon, night",
					"order": 3168,
					"name": "moon2",
					"id": 103,
					"code": 59400,
					"tempChar": ""
				},
				{
					"order": 861,
					"prevSize": 32,
					"ligatures": "more, dots",
					"name": "more",
					"id": 2672,
					"code": 61421,
					"tempChar": ""
				},
				{
					"order": 862,
					"prevSize": 32,
					"ligatures": "more2, dots2",
					"name": "more2",
					"id": 2673,
					"code": 61422,
					"tempChar": ""
				},
				{
					"id": 649,
					"order": 2864,
					"prevSize": 32,
					"code": 60032,
					"name": "mother",
					"tempChar": ""
				},
				{
					"id": 650,
					"order": 2865,
					"prevSize": 32,
					"code": 60033,
					"name": "mother2",
					"tempChar": ""
				},
				{
					"name": "motorcycle",
					"id": 1672,
					"order": 2105,
					"prevSize": 32,
					"code": 61980,
					"tempChar": ""
				},
				{
					"order": 729,
					"prevSize": 32,
					"ligatures": "mountains, nature8",
					"name": "mountains",
					"id": 2540,
					"code": 61289,
					"tempChar": ""
				},
				{
					"order": 366,
					"prevSize": 32,
					"ligatures": "mouse, click",
					"name": "mouse",
					"id": 2177,
					"code": 60926,
					"tempChar": ""
				},
				{
					"order": 368,
					"prevSize": 32,
					"ligatures": "mouse-left, click3",
					"name": "mouse-left",
					"id": 2179,
					"code": 60928,
					"tempChar": ""
				},
				{
					"name": "mouse-pointer",
					"id": 1708,
					"order": 2141,
					"prevSize": 32,
					"code": 62021,
					"tempChar": ""
				},
				{
					"order": 369,
					"prevSize": 32,
					"ligatures": "mouse-right, click4",
					"name": "mouse-right",
					"id": 2180,
					"code": 60929,
					"tempChar": ""
				},
				{
					"order": 367,
					"prevSize": 32,
					"ligatures": "mouse2, click2",
					"name": "mouse2",
					"id": 2178,
					"code": 60927,
					"tempChar": ""
				},
				{
					"order": 1103,
					"prevSize": 32,
					"ligatures": "move, drag",
					"name": "move",
					"id": 2914,
					"code": 62297,
					"tempChar": ""
				},
				{
					"order": 1357,
					"prevSize": 32,
					"ligatures": "move-down, sort4",
					"name": "move-down",
					"id": 3168,
					"code": 62551,
					"tempChar": ""
				},
				{
					"order": 1356,
					"prevSize": 32,
					"ligatures": "move-up, sort3",
					"name": "move-up",
					"id": 3167,
					"code": 62550,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "move, arrows",
					"order": 3283,
					"name": "move2",
					"id": 218,
					"code": 59515,
					"tempChar": ""
				},
				{
					"id": 651,
					"order": 2866,
					"prevSize": 32,
					"code": 60034,
					"name": "move3",
					"tempChar": ""
				},
				{
					"id": 652,
					"order": 2867,
					"prevSize": 32,
					"code": 60035,
					"name": "move4",
					"tempChar": ""
				},
				{
					"id": 1066,
					"order": 2367,
					"prevSize": 32,
					"code": 60449,
					"name": "move5",
					"tempChar": ""
				},
				{
					"order": 95,
					"prevSize": 32,
					"ligatures": "movie, video5",
					"name": "movie",
					"id": 1906,
					"code": 60655,
					"tempChar": ""
				},
				{
					"order": 700,
					"prevSize": 32,
					"ligatures": "mug, drink9",
					"name": "mug",
					"id": 2511,
					"code": 61260,
					"tempChar": ""
				},
				{
					"id": 653,
					"order": 2868,
					"prevSize": 32,
					"code": 60036,
					"name": "mull",
					"tempChar": ""
				},
				{
					"id": 654,
					"order": 2869,
					"prevSize": 32,
					"code": 60037,
					"name": "mull2",
					"tempChar": ""
				},
				{
					"id": 1067,
					"order": 2368,
					"prevSize": 32,
					"code": 60450,
					"name": "multiply",
					"tempChar": ""
				},
				{
					"order": 1080,
					"prevSize": 32,
					"ligatures": "multitouch, finger11",
					"name": "multitouch",
					"id": 2891,
					"code": 62274,
					"tempChar": ""
				},
				{
					"order": 76,
					"prevSize": 32,
					"ligatures": "music, song",
					"name": "music",
					"id": 1887,
					"code": 60636,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "music-note, music",
					"order": 3195,
					"name": "music-note",
					"id": 130,
					"code": 59427,
					"tempChar": ""
				},
				{
					"order": 77,
					"prevSize": 32,
					"ligatures": "music2, song2",
					"name": "music2",
					"id": 1888,
					"code": 60637,
					"tempChar": ""
				},
				{
					"order": 78,
					"prevSize": 32,
					"ligatures": "music3, song3",
					"name": "music3",
					"id": 1889,
					"code": 60638,
					"tempChar": ""
				},
				{
					"order": 79,
					"prevSize": 32,
					"ligatures": "music4, song4",
					"name": "music4",
					"id": 1890,
					"code": 60639,
					"tempChar": ""
				},
				{
					"order": 80,
					"prevSize": 32,
					"ligatures": "music5, song5",
					"name": "music5",
					"id": 1891,
					"code": 60640,
					"tempChar": ""
				},
				{
					"order": 81,
					"prevSize": 32,
					"ligatures": "music6, song6",
					"name": "music6",
					"id": 1892,
					"code": 60641,
					"tempChar": ""
				},
				{
					"name": "music7",
					"id": 1180,
					"order": 1613,
					"prevSize": 32,
					"code": 61441,
					"tempChar": ""
				},
				{
					"order": 690,
					"prevSize": 32,
					"ligatures": "mustache, hipster2",
					"name": "mustache",
					"id": 2501,
					"code": 61250,
					"tempChar": ""
				},
				{
					"order": 691,
					"prevSize": 32,
					"ligatures": "mustache2, hipster3",
					"name": "mustache2",
					"id": 2502,
					"code": 61251,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "mustache, emoticon4",
					"order": 3247,
					"name": "mustache3",
					"id": 182,
					"code": 59479,
					"tempChar": ""
				},
				{
					"id": 655,
					"order": 2870,
					"prevSize": 32,
					"code": 60038,
					"name": "mute",
					"tempChar": ""
				},
				{
					"id": 656,
					"order": 2871,
					"prevSize": 32,
					"code": 60039,
					"name": "mute2",
					"tempChar": ""
				},
				{
					"id": 1068,
					"order": 2369,
					"prevSize": 32,
					"code": 60451,
					"name": "mute3",
					"tempChar": ""
				},
				{
					"id": 657,
					"order": 2872,
					"prevSize": 32,
					"code": 60040,
					"name": "navigate",
					"tempChar": ""
				},
				{
					"id": 658,
					"order": 2873,
					"prevSize": 32,
					"code": 60041,
					"name": "navigate2",
					"tempChar": ""
				},
				{
					"id": 1069,
					"order": 2370,
					"prevSize": 32,
					"code": 60452,
					"name": "navigate3",
					"tempChar": ""
				},
				{
					"order": 1445,
					"prevSize": 32,
					"ligatures": "nbsp, wysiwyg17",
					"name": "nbsp",
					"id": 3256,
					"code": 62639,
					"tempChar": ""
				},
				{
					"id": 659,
					"order": 2874,
					"prevSize": 32,
					"code": 60042,
					"name": "need",
					"tempChar": ""
				},
				{
					"id": 660,
					"order": 2875,
					"prevSize": 32,
					"code": 60043,
					"name": "need2",
					"tempChar": ""
				},
				{
					"name": "neuter",
					"id": 1686,
					"order": 2119,
					"prevSize": 32,
					"code": 61996,
					"tempChar": ""
				},
				{
					"order": 1052,
					"prevSize": 32,
					"ligatures": "neutral, emoticon25",
					"name": "neutral",
					"id": 2863,
					"code": 62246,
					"tempChar": ""
				},
				{
					"order": 1053,
					"prevSize": 32,
					"ligatures": "neutral2, emoticon26",
					"name": "neutral2",
					"id": 2864,
					"code": 62247,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "neutral, emoticon3",
					"order": 3246,
					"name": "neutral3",
					"id": 181,
					"code": 59478,
					"tempChar": ""
				},
				{
					"order": 125,
					"prevSize": 32,
					"ligatures": "new, news2",
					"name": "new",
					"id": 1936,
					"code": 60685,
					"tempChar": ""
				},
				{
					"order": 1483,
					"prevSize": 32,
					"ligatures": "new-tab, out3",
					"name": "new-tab",
					"id": 3294,
					"code": 62677,
					"tempChar": ""
				},
				{
					"order": 1484,
					"prevSize": 32,
					"ligatures": "new-tab2, out4",
					"name": "new-tab2",
					"id": 3295,
					"code": 62678,
					"tempChar": ""
				},
				{
					"order": 13,
					"prevSize": 32,
					"ligatures": "newspaper, news",
					"name": "newspaper",
					"id": 1824,
					"code": 60573,
					"tempChar": ""
				},
				{
					"name": "newspaper-o",
					"id": 1625,
					"order": 2058,
					"prevSize": 32,
					"code": 61930,
					"tempChar": ""
				},
				{
					"order": 1156,
					"prevSize": 32,
					"ligatures": "next, player5",
					"name": "next",
					"id": 2967,
					"code": 62350,
					"tempChar": ""
				},
				{
					"order": 1167,
					"prevSize": 32,
					"ligatures": "next2, player16",
					"name": "next2",
					"id": 2978,
					"code": 62361,
					"tempChar": ""
				},
				{
					"order": 304,
					"prevSize": 32,
					"ligatures": "notebook, notes",
					"name": "notebook",
					"id": 2115,
					"code": 60864,
					"tempChar": ""
				},
				{
					"order": 1107,
					"prevSize": 32,
					"ligatures": "notification, warning3",
					"name": "notification",
					"id": 2918,
					"code": 62301,
					"tempChar": ""
				},
				{
					"order": 1108,
					"prevSize": 32,
					"ligatures": "notification2, warning4",
					"name": "notification2",
					"id": 2919,
					"code": 62302,
					"tempChar": ""
				},
				{
					"order": 1554,
					"prevSize": 32,
					"name": "npm",
					"ligatures": "npm, brand41",
					"id": 3365,
					"code": 62748,
					"tempChar": ""
				},
				{
					"name": "object-group",
					"id": 1710,
					"order": 2143,
					"prevSize": 32,
					"code": 62023,
					"tempChar": ""
				},
				{
					"name": "object-ungroup",
					"id": 1711,
					"order": 2144,
					"prevSize": 32,
					"code": 62024,
					"tempChar": ""
				},
				{
					"id": 1070,
					"order": 2371,
					"prevSize": 32,
					"code": 60453,
					"name": "obviate",
					"tempChar": ""
				},
				{
					"name": "odnoklassniki",
					"id": 1736,
					"order": 2169,
					"prevSize": 32,
					"code": 62051,
					"tempChar": ""
				},
				{
					"name": "odnoklassniki-square",
					"id": 1737,
					"order": 2170,
					"prevSize": 32,
					"code": 62052,
					"tempChar": ""
				},
				{
					"order": 11,
					"prevSize": 32,
					"ligatures": "office, buildings",
					"name": "office",
					"id": 1822,
					"code": 60571,
					"tempChar": ""
				},
				{
					"order": 1443,
					"prevSize": 32,
					"ligatures": "omega, wysiwyg15",
					"name": "omega",
					"id": 3254,
					"code": 62637,
					"tempChar": ""
				},
				{
					"order": 1552,
					"prevSize": 32,
					"ligatures": "onedrive, brand39",
					"name": "onedrive",
					"id": 3363,
					"code": 62746,
					"tempChar": ""
				},
				{
					"id": 661,
					"order": 2876,
					"prevSize": 32,
					"code": 60044,
					"name": "open",
					"tempChar": ""
				},
				{
					"id": 662,
					"order": 2877,
					"prevSize": 32,
					"code": 60045,
					"name": "open2",
					"tempChar": ""
				},
				{
					"id": 1071,
					"order": 2372,
					"prevSize": 32,
					"code": 60454,
					"name": "open3",
					"tempChar": ""
				},
				{
					"name": "opencart",
					"id": 1701,
					"order": 2134,
					"prevSize": 32,
					"code": 62013,
					"tempChar": ""
				},
				{
					"name": "openid",
					"id": 1551,
					"order": 1984,
					"prevSize": 32,
					"code": 61851,
					"tempChar": ""
				},
				{
					"order": 1599,
					"prevSize": 32,
					"ligatures": "opera, browser6",
					"name": "opera",
					"id": 3410,
					"code": 62793,
					"tempChar": ""
				},
				{
					"name": "opera2",
					"id": 1743,
					"order": 2176,
					"prevSize": 32,
					"code": 62058,
					"tempChar": ""
				},
				{
					"id": 663,
					"order": 2878,
					"prevSize": 32,
					"code": 60046,
					"name": "operate",
					"tempChar": ""
				},
				{
					"id": 664,
					"order": 2879,
					"prevSize": 32,
					"code": 60047,
					"name": "operate2",
					"tempChar": ""
				},
				{
					"order": 1383,
					"prevSize": 32,
					"ligatures": "opt, option",
					"name": "opt",
					"id": 3194,
					"code": 62577,
					"tempChar": ""
				},
				{
					"name": "optin-monster",
					"id": 1700,
					"order": 2133,
					"prevSize": 32,
					"code": 62012,
					"tempChar": ""
				},
				{
					"id": 665,
					"order": 2880,
					"prevSize": 32,
					"code": 60048,
					"name": "organize",
					"tempChar": ""
				},
				{
					"id": 666,
					"order": 2881,
					"prevSize": 32,
					"code": 60049,
					"name": "organize2",
					"tempChar": ""
				},
				{
					"order": 849,
					"prevSize": 32,
					"ligatures": "outlet, power4",
					"name": "outlet",
					"id": 2660,
					"code": 61409,
					"tempChar": ""
				},
				{
					"id": 667,
					"order": 2882,
					"prevSize": 32,
					"code": 60050,
					"name": "pacify",
					"tempChar": ""
				},
				{
					"id": 668,
					"order": 2883,
					"prevSize": 32,
					"code": 60051,
					"name": "pacify2",
					"tempChar": ""
				},
				{
					"id": 1072,
					"order": 2373,
					"prevSize": 32,
					"code": 60455,
					"name": "pacify3",
					"tempChar": ""
				},
				{
					"id": 669,
					"order": 2884,
					"prevSize": 32,
					"code": 60052,
					"name": "pack",
					"tempChar": ""
				},
				{
					"id": 670,
					"order": 2885,
					"prevSize": 32,
					"code": 60053,
					"name": "pack2",
					"tempChar": ""
				},
				{
					"order": 800,
					"prevSize": 32,
					"ligatures": "package, box9",
					"name": "package",
					"id": 2611,
					"code": 61360,
					"tempChar": ""
				},
				{
					"order": 112,
					"prevSize": 32,
					"ligatures": "pacman, game5",
					"name": "pacman",
					"id": 1923,
					"code": 60672,
					"tempChar": ""
				},
				{
					"order": 1446,
					"prevSize": 32,
					"ligatures": "page-break, wysiwyg18",
					"name": "page-break",
					"id": 3257,
					"code": 62640,
					"tempChar": ""
				},
				{
					"order": 1447,
					"prevSize": 32,
					"ligatures": "page-break2, wysiwyg19",
					"name": "page-break2",
					"id": 3258,
					"code": 62641,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "page-break",
					"order": 3322,
					"name": "page-break3",
					"id": 257,
					"code": 59554,
					"tempChar": ""
				},
				{
					"order": 1454,
					"prevSize": 32,
					"ligatures": "pagebreak, wysiwyg26",
					"name": "pagebreak",
					"id": 3265,
					"code": 62648,
					"tempChar": ""
				},
				{
					"name": "pagelines",
					"id": 1537,
					"order": 1970,
					"prevSize": 32,
					"code": 61836,
					"tempChar": ""
				},
				{
					"id": 671,
					"order": 2886,
					"prevSize": 32,
					"code": 60054,
					"name": "paint",
					"tempChar": ""
				},
				{
					"name": "paint-brush",
					"id": 1642,
					"order": 2075,
					"prevSize": 32,
					"code": 61948,
					"tempChar": ""
				},
				{
					"order": 58,
					"prevSize": 32,
					"ligatures": "paint-format, format",
					"name": "paint-format",
					"id": 1869,
					"code": 60618,
					"tempChar": ""
				},
				{
					"id": 672,
					"order": 2887,
					"prevSize": 32,
					"code": 60055,
					"name": "paint2",
					"tempChar": ""
				},
				{
					"id": 1073,
					"order": 2374,
					"prevSize": 32,
					"code": 60456,
					"name": "paint3",
					"tempChar": ""
				},
				{
					"order": 44,
					"prevSize": 32,
					"ligatures": "palette, color",
					"name": "palette",
					"id": 1855,
					"code": 60604,
					"tempChar": ""
				},
				{
					"order": 45,
					"prevSize": 32,
					"ligatures": "palette2, color2",
					"name": "palette2",
					"id": 1856,
					"code": 60605,
					"tempChar": ""
				},
				{
					"order": 632,
					"prevSize": 32,
					"ligatures": "pandage, health7",
					"name": "pandage",
					"id": 2443,
					"code": 61192,
					"tempChar": ""
				},
				{
					"order": 633,
					"prevSize": 32,
					"ligatures": "pandage2, health8",
					"name": "pandage2",
					"id": 2444,
					"code": 61193,
					"tempChar": ""
				},
				{
					"order": 537,
					"prevSize": 32,
					"ligatures": "pants, trousers",
					"name": "pants",
					"id": 2348,
					"code": 61097,
					"tempChar": ""
				},
				{
					"name": "paper-plane, send",
					"id": 1608,
					"order": 2041,
					"prevSize": 32,
					"code": 61912,
					"tempChar": ""
				},
				{
					"name": "paper-plane-o, send-o",
					"id": 1609,
					"order": 2042,
					"prevSize": 32,
					"code": 61913,
					"tempChar": ""
				},
				{
					"name": "paperclip",
					"id": 1353,
					"order": 1786,
					"prevSize": 32,
					"code": 61638,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "paperclip, attachment",
					"order": 3185,
					"name": "paperclip2",
					"id": 120,
					"code": 59417,
					"tempChar": ""
				},
				{
					"order": 779,
					"prevSize": 32,
					"ligatures": "paperplane, send",
					"name": "paperplane",
					"id": 2590,
					"code": 61339,
					"tempChar": ""
				},
				{
					"name": "paragraph",
					"id": 1613,
					"order": 2046,
					"prevSize": 32,
					"code": 61917,
					"tempChar": ""
				},
				{
					"order": 1466,
					"prevSize": 32,
					"ligatures": "paragraph-center, wysiwyg38",
					"name": "paragraph-center",
					"id": 3277,
					"code": 62660,
					"tempChar": ""
				},
				{
					"order": 1470,
					"prevSize": 32,
					"ligatures": "paragraph-center2, wysiwyg42",
					"name": "paragraph-center2",
					"id": 3281,
					"code": 62664,
					"tempChar": ""
				},
				{
					"order": 1476,
					"prevSize": 32,
					"ligatures": "paragraph-center3, wysiwyg48",
					"name": "paragraph-center3",
					"id": 3287,
					"code": 62670,
					"tempChar": ""
				},
				{
					"order": 1468,
					"prevSize": 32,
					"ligatures": "paragraph-justify, wysiwyg40",
					"name": "paragraph-justify",
					"id": 3279,
					"code": 62662,
					"tempChar": ""
				},
				{
					"order": 1472,
					"prevSize": 32,
					"ligatures": "paragraph-justify2, wysiwyg44",
					"name": "paragraph-justify2",
					"id": 3283,
					"code": 62666,
					"tempChar": ""
				},
				{
					"order": 1478,
					"prevSize": 32,
					"ligatures": "paragraph-justify3, wysiwyg50",
					"name": "paragraph-justify3",
					"id": 3289,
					"code": 62672,
					"tempChar": ""
				},
				{
					"order": 1465,
					"prevSize": 32,
					"ligatures": "paragraph-left, wysiwyg37",
					"name": "paragraph-left",
					"id": 3276,
					"code": 62659,
					"tempChar": ""
				},
				{
					"order": 1469,
					"prevSize": 32,
					"ligatures": "paragraph-left2, wysiwyg41",
					"name": "paragraph-left2",
					"id": 3280,
					"code": 62663,
					"tempChar": ""
				},
				{
					"order": 1475,
					"prevSize": 32,
					"ligatures": "paragraph-left3, wysiwyg47",
					"name": "paragraph-left3",
					"id": 3286,
					"code": 62669,
					"tempChar": ""
				},
				{
					"order": 1467,
					"prevSize": 32,
					"ligatures": "paragraph-right, wysiwyg39",
					"name": "paragraph-right",
					"id": 3278,
					"code": 62661,
					"tempChar": ""
				},
				{
					"order": 1471,
					"prevSize": 32,
					"ligatures": "paragraph-right2, wysiwyg43",
					"name": "paragraph-right2",
					"id": 3282,
					"code": 62665,
					"tempChar": ""
				},
				{
					"order": 1477,
					"prevSize": 32,
					"ligatures": "paragraph-right3, wysiwyg49",
					"name": "paragraph-right3",
					"id": 3288,
					"code": 62671,
					"tempChar": ""
				},
				{
					"order": 203,
					"prevSize": 32,
					"ligatures": "paste, clipboard-file",
					"name": "paste",
					"id": 2014,
					"code": 60763,
					"tempChar": ""
				},
				{
					"order": 204,
					"prevSize": 32,
					"ligatures": "paste2, clipboard-file2",
					"name": "paste2",
					"id": 2015,
					"code": 60764,
					"tempChar": ""
				},
				{
					"order": 205,
					"prevSize": 32,
					"ligatures": "paste3, clipboard-file3",
					"name": "paste3",
					"id": 2016,
					"code": 60765,
					"tempChar": ""
				},
				{
					"order": 206,
					"prevSize": 32,
					"ligatures": "paste4, clipboard-file4",
					"name": "paste4",
					"id": 2017,
					"code": 60766,
					"tempChar": ""
				},
				{
					"id": 673,
					"order": 2888,
					"prevSize": 32,
					"code": 60056,
					"name": "paste6",
					"tempChar": ""
				},
				{
					"id": 674,
					"order": 2889,
					"prevSize": 32,
					"code": 60057,
					"name": "paste7",
					"tempChar": ""
				},
				{
					"id": 1074,
					"order": 2375,
					"prevSize": 32,
					"code": 60457,
					"name": "paste8",
					"tempChar": ""
				},
				{
					"order": 1153,
					"prevSize": 32,
					"ligatures": "pause, player2",
					"name": "pause",
					"id": 2964,
					"code": 62347,
					"tempChar": ""
				},
				{
					"name": "pause-circle",
					"id": 1774,
					"order": 2207,
					"prevSize": 32,
					"code": 62091,
					"tempChar": ""
				},
				{
					"name": "pause-circle-o",
					"id": 1775,
					"order": 2208,
					"prevSize": 32,
					"code": 62092,
					"tempChar": ""
				},
				{
					"order": 1160,
					"prevSize": 32,
					"ligatures": "pause2, player9",
					"name": "pause2",
					"id": 2971,
					"code": 62354,
					"tempChar": ""
				},
				{
					"name": "pause3",
					"id": 1251,
					"order": 1684,
					"prevSize": 32,
					"code": 61516,
					"tempChar": ""
				},
				{
					"id": 1075,
					"order": 2376,
					"prevSize": 32,
					"code": 60458,
					"name": "pause4",
					"tempChar": ""
				},
				{
					"order": 730,
					"prevSize": 32,
					"ligatures": "paw, animal",
					"name": "paw",
					"id": 2541,
					"code": 61290,
					"tempChar": ""
				},
				{
					"name": "paw2",
					"id": 1570,
					"order": 2003,
					"prevSize": 32,
					"code": 61872,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "paw, pet",
					"order": 3234,
					"name": "paw3",
					"id": 169,
					"code": 59466,
					"tempChar": ""
				},
				{
					"id": 675,
					"order": 2890,
					"prevSize": 32,
					"code": 60058,
					"name": "pay",
					"tempChar": ""
				},
				{
					"id": 676,
					"order": 2891,
					"prevSize": 32,
					"code": 60059,
					"name": "pay2",
					"tempChar": ""
				},
				{
					"id": 1076,
					"order": 2377,
					"prevSize": 32,
					"code": 60459,
					"name": "pay3",
					"tempChar": ""
				},
				{
					"order": 1593,
					"prevSize": 32,
					"ligatures": "paypal, brand79",
					"name": "paypal",
					"codes": [
						61234
					],
					"id": 3404,
					"code": 62787,
					"tempChar": ""
				},
				{
					"name": "paypal2",
					"id": 1628,
					"order": 2061,
					"prevSize": 32,
					"code": 61933,
					"tempChar": ""
				},
				{
					"order": 1026,
					"prevSize": 32,
					"ligatures": "peace",
					"name": "peace",
					"id": 2837,
					"code": 62220,
					"tempChar": ""
				},
				{
					"order": 30,
					"prevSize": 32,
					"ligatures": "pen, write8",
					"name": "pen",
					"id": 1841,
					"code": 60590,
					"tempChar": ""
				},
				{
					"order": 32,
					"prevSize": 32,
					"ligatures": "pen-minus, pen-remove",
					"name": "pen-minus",
					"id": 1843,
					"code": 60592,
					"tempChar": ""
				},
				{
					"order": 31,
					"prevSize": 32,
					"ligatures": "pen-plus, pen-add",
					"name": "pen-plus",
					"id": 1842,
					"code": 60591,
					"tempChar": ""
				},
				{
					"order": 33,
					"prevSize": 32,
					"ligatures": "pen2, write9",
					"name": "pen2",
					"id": 1844,
					"code": 60593,
					"tempChar": ""
				},
				{
					"order": 34,
					"prevSize": 32,
					"ligatures": "pen3, write10",
					"name": "pen3",
					"id": 1845,
					"code": 60594,
					"tempChar": ""
				},
				{
					"order": 35,
					"prevSize": 32,
					"ligatures": "pen4, write11",
					"name": "pen4",
					"id": 1846,
					"code": 60595,
					"tempChar": ""
				},
				{
					"order": 36,
					"prevSize": 32,
					"ligatures": "pen5, write12",
					"name": "pen5",
					"id": 1847,
					"code": 60596,
					"tempChar": ""
				},
				{
					"order": 41,
					"prevSize": 32,
					"ligatures": "pen7, write15",
					"name": "pen6",
					"id": 1852,
					"code": 60601,
					"tempChar": ""
				},
				{
					"order": 16,
					"prevSize": 32,
					"ligatures": "pencil, write",
					"name": "pencil",
					"id": 1827,
					"code": 60576,
					"tempChar": ""
				},
				{
					"order": 1413,
					"prevSize": 32,
					"ligatures": "pencil-ruler2, design2",
					"name": "pencil-ruler",
					"id": 3224,
					"code": 62607,
					"tempChar": ""
				},
				{
					"name": "pencil-square",
					"id": 1476,
					"order": 1909,
					"prevSize": 32,
					"code": 61771,
					"tempChar": ""
				},
				{
					"order": 17,
					"prevSize": 32,
					"ligatures": "pencil2, write2",
					"name": "pencil2",
					"id": 1828,
					"code": 60577,
					"tempChar": ""
				},
				{
					"order": 18,
					"prevSize": 32,
					"ligatures": "pencil3, write3",
					"name": "pencil3",
					"id": 1829,
					"code": 60578,
					"tempChar": ""
				},
				{
					"order": 19,
					"prevSize": 32,
					"ligatures": "pencil4, write4",
					"name": "pencil4",
					"id": 1830,
					"code": 60579,
					"tempChar": ""
				},
				{
					"order": 20,
					"prevSize": 32,
					"ligatures": "pencil5, write5",
					"name": "pencil5",
					"id": 1831,
					"code": 60580,
					"tempChar": ""
				},
				{
					"order": 21,
					"prevSize": 32,
					"ligatures": "pencil6, write6",
					"name": "pencil6",
					"id": 1832,
					"code": 60581,
					"tempChar": ""
				},
				{
					"order": 22,
					"prevSize": 32,
					"ligatures": "pencil7, write7",
					"name": "pencil7",
					"id": 1833,
					"code": 60582,
					"tempChar": ""
				},
				{
					"name": "pencil8",
					"id": 1239,
					"order": 1672,
					"prevSize": 32,
					"code": 61504,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "pencil, write",
					"order": 3162,
					"name": "pencil9",
					"id": 97,
					"code": 59394,
					"tempChar": ""
				},
				{
					"order": 267,
					"prevSize": 32,
					"ligatures": "percent, discount",
					"name": "percent",
					"id": 2078,
					"code": 60827,
					"tempChar": ""
				},
				{
					"name": "percent2",
					"id": 1783,
					"order": 2216,
					"prevSize": 32,
					"code": 62101,
					"tempChar": ""
				},
				{
					"id": 677,
					"order": 2892,
					"prevSize": 32,
					"code": 60060,
					"name": "perform",
					"tempChar": ""
				},
				{
					"id": 678,
					"order": 2893,
					"prevSize": 32,
					"code": 60061,
					"name": "perform2",
					"tempChar": ""
				},
				{
					"order": 286,
					"prevSize": 32,
					"ligatures": "phone, telephone",
					"name": "phone",
					"id": 2097,
					"code": 60846,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "phone-handset, telephone",
					"order": 3208,
					"name": "phone-handset",
					"id": 143,
					"code": 59440,
					"tempChar": ""
				},
				{
					"order": 299,
					"prevSize": 32,
					"ligatures": "phone-hang-up, telephone14",
					"name": "phone-hang-up",
					"id": 2110,
					"code": 60859,
					"tempChar": ""
				},
				{
					"order": 300,
					"prevSize": 32,
					"ligatures": "phone-hang-up2, telephone15",
					"name": "phone-hang-up2",
					"id": 2111,
					"code": 60860,
					"tempChar": ""
				},
				{
					"order": 294,
					"prevSize": 32,
					"ligatures": "phone-incoming, telephone9",
					"name": "phone-incoming",
					"id": 2105,
					"code": 60854,
					"tempChar": ""
				},
				{
					"order": 291,
					"prevSize": 32,
					"ligatures": "phone-minus, telephone6",
					"name": "phone-minus",
					"id": 2102,
					"code": 60851,
					"tempChar": ""
				},
				{
					"order": 293,
					"prevSize": 32,
					"ligatures": "phone-minus2, telephone8",
					"name": "phone-minus2",
					"id": 2104,
					"code": 60853,
					"tempChar": ""
				},
				{
					"order": 295,
					"prevSize": 32,
					"ligatures": "phone-outgoing, telephone10",
					"name": "phone-outgoing",
					"id": 2106,
					"code": 60855,
					"tempChar": ""
				},
				{
					"order": 290,
					"prevSize": 32,
					"ligatures": "phone-plus, telephone5",
					"name": "phone-plus",
					"id": 2101,
					"code": 60850,
					"tempChar": ""
				},
				{
					"order": 292,
					"prevSize": 32,
					"ligatures": "phone-plus2, telephone7",
					"name": "phone-plus2",
					"id": 2103,
					"code": 60852,
					"tempChar": ""
				},
				{
					"order": 288,
					"prevSize": 32,
					"ligatures": "phone-slash, telephone3",
					"name": "phone-slash",
					"id": 2099,
					"code": 60848,
					"tempChar": ""
				},
				{
					"order": 297,
					"prevSize": 32,
					"ligatures": "phone-slash2, telephone12",
					"name": "phone-slash2",
					"id": 2108,
					"code": 60857,
					"tempChar": ""
				},
				{
					"name": "phone-square",
					"id": 1322,
					"order": 1755,
					"prevSize": 32,
					"code": 61592,
					"tempChar": ""
				},
				{
					"order": 289,
					"prevSize": 32,
					"ligatures": "phone-wave, telephone4",
					"name": "phone-wave",
					"id": 2100,
					"code": 60849,
					"tempChar": ""
				},
				{
					"order": 298,
					"prevSize": 32,
					"ligatures": "phone-wave2, telephone13",
					"name": "phone-wave2",
					"id": 2109,
					"code": 60858,
					"tempChar": ""
				},
				{
					"order": 287,
					"prevSize": 32,
					"ligatures": "phone2, telephone2",
					"name": "phone2",
					"id": 2098,
					"code": 60847,
					"tempChar": ""
				},
				{
					"order": 296,
					"prevSize": 32,
					"ligatures": "phone3, telephone11",
					"name": "phone3",
					"id": 2107,
					"code": 60856,
					"tempChar": ""
				},
				{
					"name": "phone4",
					"id": 1319,
					"order": 1752,
					"prevSize": 32,
					"code": 61589,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "phone, telephone2",
					"order": 3209,
					"name": "phone5",
					"id": 144,
					"code": 59441,
					"tempChar": ""
				},
				{
					"id": 679,
					"order": 2894,
					"prevSize": 32,
					"code": 60062,
					"name": "photograph",
					"tempChar": ""
				},
				{
					"id": 680,
					"order": 2895,
					"prevSize": 32,
					"code": 60063,
					"name": "photograph2",
					"tempChar": ""
				},
				{
					"id": 1077,
					"order": 2378,
					"prevSize": 32,
					"code": 60460,
					"name": "photograph3",
					"tempChar": ""
				},
				{
					"order": 85,
					"prevSize": 32,
					"ligatures": "piano, music7",
					"name": "piano",
					"id": 1896,
					"code": 60645,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "picture, photo2",
					"order": 3199,
					"name": "picture",
					"id": 134,
					"code": 59431,
					"tempChar": ""
				},
				{
					"order": 642,
					"prevSize": 32,
					"ligatures": "pie-chart, stats",
					"name": "pie-chart",
					"id": 2453,
					"code": 61202,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "pie-chart, chart",
					"order": 3226,
					"name": "pie-chart10",
					"id": 161,
					"code": 59458,
					"tempChar": ""
				},
				{
					"order": 643,
					"prevSize": 32,
					"ligatures": "pie-chart2, stats2",
					"name": "pie-chart2",
					"id": 2454,
					"code": 61203,
					"tempChar": ""
				},
				{
					"order": 644,
					"prevSize": 32,
					"ligatures": "pie-chart3, stats3",
					"name": "pie-chart3",
					"id": 2455,
					"code": 61204,
					"tempChar": ""
				},
				{
					"order": 645,
					"prevSize": 32,
					"ligatures": "pie-chart4, stats4",
					"name": "pie-chart4",
					"id": 2456,
					"code": 61205,
					"tempChar": ""
				},
				{
					"order": 646,
					"prevSize": 32,
					"ligatures": "pie-chart5, stats5",
					"name": "pie-chart5",
					"id": 2457,
					"code": 61206,
					"tempChar": ""
				},
				{
					"order": 647,
					"prevSize": 32,
					"ligatures": "pie-chart6, stats6",
					"name": "pie-chart6",
					"id": 2458,
					"code": 61207,
					"tempChar": ""
				},
				{
					"order": 648,
					"prevSize": 32,
					"ligatures": "pie-chart7, stats7",
					"name": "pie-chart7",
					"id": 2459,
					"code": 61208,
					"tempChar": ""
				},
				{
					"order": 651,
					"prevSize": 32,
					"ligatures": "pie-chart8, stats10",
					"name": "pie-chart8",
					"id": 2462,
					"code": 61211,
					"tempChar": ""
				},
				{
					"name": "pie-chart9",
					"id": 1645,
					"order": 2078,
					"prevSize": 32,
					"code": 61952,
					"tempChar": ""
				},
				{
					"name": "pied-piper",
					"id": 1807,
					"order": 2240,
					"prevSize": 32,
					"code": 62126,
					"tempChar": ""
				},
				{
					"name": "pied-piper-alt",
					"id": 1563,
					"order": 1996,
					"prevSize": 32,
					"code": 61864,
					"tempChar": ""
				},
				{
					"name": "pied-piper-pp",
					"id": 1562,
					"order": 1995,
					"prevSize": 32,
					"code": 61863,
					"tempChar": ""
				},
				{
					"order": 273,
					"prevSize": 32,
					"ligatures": "piggy-bank, money6",
					"name": "piggy-bank",
					"id": 2084,
					"code": 60833,
					"tempChar": ""
				},
				{
					"order": 1459,
					"prevSize": 32,
					"ligatures": "pilcrow, wysiwyg31",
					"name": "pilcrow",
					"id": 3270,
					"code": 62653,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "pilcrow, typography15",
					"order": 3319,
					"name": "pilcrow2",
					"id": 254,
					"code": 59551,
					"tempChar": ""
				},
				{
					"order": 638,
					"prevSize": 32,
					"ligatures": "pill, health11",
					"name": "pill",
					"id": 2449,
					"code": 61198,
					"tempChar": ""
				},
				{
					"id": 681,
					"order": 2896,
					"prevSize": 32,
					"code": 60064,
					"name": "pin",
					"tempChar": ""
				},
				{
					"id": 682,
					"order": 2897,
					"prevSize": 32,
					"code": 60065,
					"name": "pin2",
					"tempChar": ""
				},
				{
					"id": 1078,
					"order": 2379,
					"prevSize": 32,
					"code": 60461,
					"name": "pin3",
					"tempChar": ""
				},
				{
					"id": 683,
					"order": 2898,
					"prevSize": 32,
					"code": 60066,
					"name": "ping",
					"tempChar": ""
				},
				{
					"id": 684,
					"order": 2899,
					"prevSize": 32,
					"code": 60067,
					"name": "ping2",
					"tempChar": ""
				},
				{
					"id": 1079,
					"order": 2380,
					"prevSize": 32,
					"code": 60462,
					"name": "ping3",
					"tempChar": ""
				},
				{
					"order": 831,
					"prevSize": 32,
					"ligatures": "pingpong, soprts4",
					"name": "pingpong",
					"id": 2642,
					"code": 61391,
					"tempChar": ""
				},
				{
					"order": 1586,
					"prevSize": 32,
					"name": "pinterest",
					"ligatures": "pinterest, brand72",
					"id": 3397,
					"code": 62780,
					"tempChar": ""
				},
				{
					"name": "pinterest-p",
					"id": 1689,
					"order": 2122,
					"prevSize": 32,
					"code": 62001,
					"tempChar": ""
				},
				{
					"name": "pinterest-square",
					"id": 1365,
					"order": 1798,
					"prevSize": 32,
					"code": 61651,
					"tempChar": ""
				},
				{
					"order": 1587,
					"prevSize": 32,
					"ligatures": "pinterest2, brand73",
					"name": "pinterest2",
					"id": 3398,
					"code": 62781,
					"tempChar": ""
				},
				{
					"name": "pinterest3",
					"id": 1364,
					"order": 1797,
					"prevSize": 32,
					"code": 61650,
					"tempChar": ""
				},
				{
					"order": 689,
					"prevSize": 32,
					"ligatures": "pipe, hipster",
					"name": "pipe",
					"id": 2500,
					"code": 61249,
					"tempChar": ""
				},
				{
					"order": 709,
					"prevSize": 32,
					"ligatures": "pizza, food8",
					"name": "pizza",
					"id": 2520,
					"code": 61269,
					"tempChar": ""
				},
				{
					"id": 685,
					"order": 2900,
					"prevSize": 32,
					"code": 60068,
					"name": "plan",
					"tempChar": ""
				},
				{
					"id": 686,
					"order": 2901,
					"prevSize": 32,
					"code": 60069,
					"name": "plan2",
					"tempChar": ""
				},
				{
					"id": 1080,
					"order": 2381,
					"prevSize": 32,
					"code": 60463,
					"name": "plan3",
					"tempChar": ""
				},
				{
					"name": "plane",
					"id": 1286,
					"order": 1719,
					"prevSize": 32,
					"code": 61554,
					"tempChar": ""
				},
				{
					"order": 918,
					"prevSize": 32,
					"ligatures": "planet, globe4",
					"name": "planet",
					"id": 2729,
					"code": 61839,
					"tempChar": ""
				},
				{
					"order": 919,
					"prevSize": 32,
					"ligatures": "planet2, globe5",
					"name": "planet2",
					"id": 2730,
					"code": 61855,
					"tempChar": ""
				},
				{
					"id": 687,
					"order": 2902,
					"prevSize": 32,
					"code": 60070,
					"name": "plant",
					"tempChar": ""
				},
				{
					"id": 688,
					"order": 2903,
					"prevSize": 32,
					"code": 60071,
					"name": "plant2",
					"tempChar": ""
				},
				{
					"id": 1081,
					"order": 2382,
					"prevSize": 32,
					"code": 60464,
					"name": "plant3",
					"tempChar": ""
				},
				{
					"order": 704,
					"prevSize": 32,
					"ligatures": "plate, food3",
					"name": "plate",
					"id": 2515,
					"code": 61264,
					"tempChar": ""
				},
				{
					"order": 89,
					"prevSize": 32,
					"ligatures": "play, video",
					"name": "play",
					"id": 1900,
					"code": 60649,
					"tempChar": ""
				},
				{
					"name": "play-circle",
					"id": 1469,
					"order": 1902,
					"prevSize": 32,
					"code": 61764,
					"tempChar": ""
				},
				{
					"name": "play-circle-o",
					"id": 1207,
					"order": 1640,
					"prevSize": 32,
					"code": 61469,
					"tempChar": ""
				},
				{
					"order": 90,
					"prevSize": 32,
					"ligatures": "play2, video2",
					"name": "play2",
					"id": 1901,
					"code": 60650,
					"tempChar": ""
				},
				{
					"order": 1152,
					"prevSize": 32,
					"ligatures": "play3, player",
					"name": "play3",
					"id": 2963,
					"code": 62346,
					"tempChar": ""
				},
				{
					"order": 1159,
					"prevSize": 32,
					"ligatures": "play4, player8",
					"name": "play4",
					"id": 2970,
					"code": 62353,
					"tempChar": ""
				},
				{
					"name": "play5",
					"id": 1250,
					"order": 1683,
					"prevSize": 32,
					"code": 61515,
					"tempChar": ""
				},
				{
					"id": 689,
					"order": 2904,
					"prevSize": 32,
					"code": 60072,
					"name": "play6",
					"tempChar": ""
				},
				{
					"id": 690,
					"order": 2905,
					"prevSize": 32,
					"code": 60073,
					"name": "play7",
					"tempChar": ""
				},
				{
					"id": 1082,
					"order": 2383,
					"prevSize": 32,
					"code": 60465,
					"name": "play8",
					"tempChar": ""
				},
				{
					"order": 856,
					"prevSize": 32,
					"ligatures": "playlist, music11",
					"name": "playlist",
					"id": 2667,
					"code": 61416,
					"tempChar": ""
				},
				{
					"order": 857,
					"prevSize": 32,
					"ligatures": "playlist-add, music12",
					"name": "playlist-add",
					"id": 2668,
					"code": 61417,
					"tempChar": ""
				},
				{
					"id": 691,
					"order": 2906,
					"prevSize": 32,
					"code": 60074,
					"name": "plot",
					"tempChar": ""
				},
				{
					"id": 692,
					"order": 2907,
					"prevSize": 32,
					"code": 60075,
					"name": "plot2",
					"tempChar": ""
				},
				{
					"id": 1083,
					"order": 2384,
					"prevSize": 32,
					"code": 60466,
					"name": "plot3",
					"tempChar": ""
				},
				{
					"name": "plug",
					"id": 1621,
					"order": 2054,
					"prevSize": 32,
					"code": 61926,
					"tempChar": ""
				},
				{
					"order": 1115,
					"prevSize": 32,
					"ligatures": "plus, add",
					"name": "plus",
					"id": 2926,
					"code": 62309,
					"tempChar": ""
				},
				{
					"order": 1121,
					"prevSize": 32,
					"ligatures": "plus-circle, add4",
					"name": "plus-circle",
					"id": 2932,
					"code": 62315,
					"tempChar": ""
				},
				{
					"order": 1123,
					"prevSize": 32,
					"ligatures": "plus-circle2, add5",
					"name": "plus-circle2",
					"id": 2934,
					"code": 62317,
					"tempChar": ""
				},
				{
					"name": "plus-circle3",
					"id": 1259,
					"order": 1692,
					"prevSize": 32,
					"code": 61525,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "plus-circle, plus",
					"order": 3289,
					"name": "plus-circle4",
					"id": 224,
					"code": 59521,
					"tempChar": ""
				},
				{
					"name": "plus-square",
					"id": 1406,
					"order": 1839,
					"prevSize": 32,
					"code": 61694,
					"tempChar": ""
				},
				{
					"name": "plus-square-o",
					"id": 1546,
					"order": 1979,
					"prevSize": 32,
					"code": 61846,
					"tempChar": ""
				},
				{
					"order": 1117,
					"prevSize": 32,
					"ligatures": "plus2, add2",
					"name": "plus2",
					"id": 2928,
					"code": 62311,
					"tempChar": ""
				},
				{
					"order": 1119,
					"prevSize": 32,
					"ligatures": "plus3, add3",
					"name": "plus3",
					"id": 2930,
					"code": 62313,
					"tempChar": ""
				},
				{
					"name": "plus4",
					"id": 1276,
					"order": 1709,
					"prevSize": 32,
					"code": 61543,
					"tempChar": ""
				},
				{
					"order": 130,
					"prevSize": 32,
					"ligatures": "podcast, broadcast",
					"name": "podcast",
					"id": 1941,
					"code": 60690,
					"tempChar": ""
				},
				{
					"order": 137,
					"prevSize": 32,
					"ligatures": "podcast2, broadcast2",
					"name": "podcast2",
					"id": 1948,
					"code": 60697,
					"tempChar": ""
				},
				{
					"order": 671,
					"prevSize": 32,
					"ligatures": "podium, ranking5",
					"name": "podium",
					"id": 2482,
					"code": 61231,
					"tempChar": ""
				},
				{
					"id": 693,
					"order": 2908,
					"prevSize": 32,
					"code": 60076,
					"name": "point",
					"tempChar": ""
				},
				{
					"order": 1072,
					"prevSize": 32,
					"ligatures": "point-down, finger3",
					"name": "point-down",
					"id": 2883,
					"code": 62266,
					"tempChar": ""
				},
				{
					"order": 1073,
					"prevSize": 32,
					"ligatures": "point-left, finger4",
					"name": "point-left",
					"id": 2884,
					"code": 62267,
					"tempChar": ""
				},
				{
					"order": 1071,
					"prevSize": 32,
					"ligatures": "point-right, finger2",
					"name": "point-right",
					"id": 2882,
					"code": 62265,
					"tempChar": ""
				},
				{
					"order": 1070,
					"prevSize": 32,
					"ligatures": "point-up, finger",
					"name": "point-up",
					"id": 2881,
					"code": 62264,
					"tempChar": ""
				},
				{
					"id": 694,
					"order": 2909,
					"prevSize": 32,
					"code": 60077,
					"name": "point2",
					"tempChar": ""
				},
				{
					"id": 1084,
					"order": 2385,
					"prevSize": 32,
					"code": 60467,
					"name": "point3",
					"tempChar": ""
				},
				{
					"order": 1074,
					"prevSize": 32,
					"ligatures": "pointer5, finger5",
					"name": "pointer",
					"id": 2885,
					"code": 62268,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "pointer-down, hand4",
					"order": 3328,
					"name": "pointer-down",
					"id": 263,
					"code": 59560,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "pointer-left, hand5",
					"order": 3329,
					"name": "pointer-left",
					"id": 264,
					"code": 59561,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "pointer-right, hand3",
					"order": 3327,
					"name": "pointer-right",
					"id": 262,
					"code": 59559,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "pointer-up, hand2",
					"order": 3326,
					"name": "pointer-up",
					"id": 261,
					"code": 59558,
					"tempChar": ""
				},
				{
					"id": 695,
					"order": 2910,
					"prevSize": 32,
					"code": 60078,
					"name": "poison",
					"tempChar": ""
				},
				{
					"id": 696,
					"order": 2911,
					"prevSize": 32,
					"code": 60079,
					"name": "poison2",
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "poop, toilet",
					"order": 3166,
					"name": "poop",
					"id": 101,
					"code": 59398,
					"tempChar": ""
				},
				{
					"id": 1085,
					"order": 2386,
					"prevSize": 32,
					"code": 60468,
					"name": "poop2",
					"tempChar": ""
				},
				{
					"order": 1485,
					"prevSize": 32,
					"ligatures": "popout, new-window",
					"name": "popout",
					"id": 3296,
					"code": 62679,
					"tempChar": ""
				},
				{
					"id": 1086,
					"order": 2387,
					"prevSize": 32,
					"code": 60469,
					"name": "pour",
					"tempChar": ""
				},
				{
					"order": 842,
					"prevSize": 32,
					"ligatures": "power, lightning",
					"name": "power",
					"id": 2653,
					"code": 61402,
					"tempChar": ""
				},
				{
					"order": 847,
					"prevSize": 32,
					"ligatures": "power-cord, plugin",
					"name": "power-cord",
					"id": 2658,
					"code": 61407,
					"tempChar": ""
				},
				{
					"order": 848,
					"prevSize": 32,
					"ligatures": "power-cord2, plugin2",
					"name": "power-cord2",
					"id": 2659,
					"code": 61408,
					"tempChar": ""
				},
				{
					"name": "power-off",
					"id": 1195,
					"order": 1628,
					"prevSize": 32,
					"code": 61457,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "power-switch, toggle",
					"order": 3222,
					"name": "power-switch",
					"id": 157,
					"code": 59454,
					"tempChar": ""
				},
				{
					"order": 843,
					"prevSize": 32,
					"ligatures": "power2, lightning2",
					"name": "power2",
					"id": 2654,
					"code": 61403,
					"tempChar": ""
				},
				{
					"order": 844,
					"prevSize": 32,
					"ligatures": "power3, lightning3",
					"name": "power3",
					"id": 2655,
					"code": 61404,
					"tempChar": ""
				},
				{
					"id": 697,
					"order": 2912,
					"prevSize": 32,
					"code": 60080,
					"name": "prank",
					"tempChar": ""
				},
				{
					"id": 698,
					"order": 2913,
					"prevSize": 32,
					"code": 60081,
					"name": "prank2",
					"tempChar": ""
				},
				{
					"id": 699,
					"order": 2914,
					"prevSize": 32,
					"code": 60082,
					"name": "pray",
					"tempChar": ""
				},
				{
					"id": 700,
					"order": 2915,
					"prevSize": 32,
					"code": 60083,
					"name": "pray2",
					"tempChar": ""
				},
				{
					"id": 701,
					"order": 2916,
					"prevSize": 32,
					"code": 60084,
					"name": "present",
					"tempChar": ""
				},
				{
					"id": 702,
					"order": 2917,
					"prevSize": 32,
					"code": 60085,
					"name": "present2",
					"tempChar": ""
				},
				{
					"id": 1087,
					"order": 2388,
					"prevSize": 32,
					"code": 60470,
					"name": "present3",
					"tempChar": ""
				},
				{
					"order": 94,
					"prevSize": 32,
					"ligatures": "presentation, board-play",
					"name": "presentation",
					"id": 1905,
					"code": 60654,
					"tempChar": ""
				},
				{
					"id": 703,
					"order": 2918,
					"prevSize": 32,
					"code": 60086,
					"name": "press",
					"tempChar": ""
				},
				{
					"id": 704,
					"order": 2919,
					"prevSize": 32,
					"code": 60087,
					"name": "press2",
					"tempChar": ""
				},
				{
					"id": 705,
					"order": 2920,
					"prevSize": 32,
					"code": 60088,
					"name": "prevent",
					"tempChar": ""
				},
				{
					"id": 706,
					"order": 2921,
					"prevSize": 32,
					"code": 60089,
					"name": "prevent2",
					"tempChar": ""
				},
				{
					"order": 1155,
					"prevSize": 32,
					"ligatures": "previous, player4",
					"name": "previous",
					"id": 2966,
					"code": 62349,
					"tempChar": ""
				},
				{
					"order": 1166,
					"prevSize": 32,
					"ligatures": "previous2, player15",
					"name": "previous2",
					"id": 2977,
					"code": 62360,
					"tempChar": ""
				},
				{
					"order": 239,
					"prevSize": 32,
					"ligatures": "price-tag",
					"name": "price-tag",
					"id": 2050,
					"code": 60799,
					"tempChar": ""
				},
				{
					"order": 240,
					"prevSize": 32,
					"ligatures": "price-tag2",
					"name": "price-tag2",
					"id": 2051,
					"code": 60800,
					"tempChar": ""
				},
				{
					"order": 242,
					"prevSize": 32,
					"ligatures": "price-tag3",
					"name": "price-tag3",
					"id": 2053,
					"code": 60802,
					"tempChar": ""
				},
				{
					"order": 244,
					"prevSize": 32,
					"ligatures": "price-tag4",
					"name": "price-tag4",
					"id": 2055,
					"code": 60804,
					"tempChar": ""
				},
				{
					"order": 246,
					"prevSize": 32,
					"ligatures": "price-tag5",
					"name": "price-tag5",
					"id": 2057,
					"code": 60806,
					"tempChar": ""
				},
				{
					"order": 241,
					"prevSize": 32,
					"ligatures": "price-tags",
					"name": "price-tags",
					"id": 2052,
					"code": 60801,
					"tempChar": ""
				},
				{
					"order": 243,
					"prevSize": 32,
					"ligatures": "price-tags2",
					"name": "price-tags2",
					"id": 2054,
					"code": 60803,
					"tempChar": ""
				},
				{
					"order": 245,
					"prevSize": 32,
					"ligatures": "price-tags3",
					"name": "price-tags3",
					"id": 2056,
					"code": 60805,
					"tempChar": ""
				},
				{
					"order": 247,
					"prevSize": 32,
					"ligatures": "price-tags4",
					"name": "price-tags4",
					"id": 2058,
					"code": 60807,
					"tempChar": ""
				},
				{
					"id": 707,
					"order": 2922,
					"prevSize": 32,
					"code": 60090,
					"name": "prick",
					"tempChar": ""
				},
				{
					"id": 708,
					"order": 2923,
					"prevSize": 32,
					"code": 60091,
					"name": "prick2",
					"tempChar": ""
				},
				{
					"id": 1088,
					"order": 2389,
					"prevSize": 32,
					"code": 60471,
					"name": "prick3",
					"tempChar": ""
				},
				{
					"id": 709,
					"order": 2924,
					"prevSize": 32,
					"code": 60092,
					"name": "primp",
					"tempChar": ""
				},
				{
					"id": 710,
					"order": 2925,
					"prevSize": 32,
					"code": 60093,
					"name": "primp2",
					"tempChar": ""
				},
				{
					"id": 1089,
					"order": 2390,
					"prevSize": 32,
					"code": 60472,
					"name": "primp3",
					"tempChar": ""
				},
				{
					"name": "print",
					"id": 1223,
					"order": 1656,
					"prevSize": 32,
					"code": 61487,
					"tempChar": ""
				},
				{
					"id": 711,
					"order": 2926,
					"prevSize": 32,
					"code": 60094,
					"name": "print2",
					"tempChar": ""
				},
				{
					"id": 712,
					"order": 2927,
					"prevSize": 32,
					"code": 60095,
					"name": "print3",
					"tempChar": ""
				},
				{
					"id": 1090,
					"order": 2391,
					"prevSize": 32,
					"code": 60473,
					"name": "print4",
					"tempChar": ""
				},
				{
					"order": 361,
					"prevSize": 32,
					"ligatures": "printer, print",
					"name": "printer",
					"id": 2172,
					"code": 60921,
					"tempChar": ""
				},
				{
					"order": 362,
					"prevSize": 32,
					"ligatures": "printer2, print2",
					"name": "printer2",
					"id": 2173,
					"code": 60922,
					"tempChar": ""
				},
				{
					"order": 363,
					"prevSize": 32,
					"ligatures": "printer3, print3",
					"name": "printer3",
					"id": 2174,
					"code": 60923,
					"tempChar": ""
				},
				{
					"order": 364,
					"prevSize": 32,
					"ligatures": "printer4, print4",
					"name": "printer4",
					"id": 2175,
					"code": 60924,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "printer, print",
					"order": 3188,
					"name": "printer5",
					"id": 123,
					"code": 59420,
					"tempChar": ""
				},
				{
					"name": "product-hunt",
					"id": 1771,
					"order": 2204,
					"prevSize": 32,
					"code": 62088,
					"tempChar": ""
				},
				{
					"order": 158,
					"prevSize": 32,
					"ligatures": "profile, file2",
					"name": "profile",
					"id": 1969,
					"code": 60718,
					"tempChar": ""
				},
				{
					"id": 713,
					"order": 2928,
					"prevSize": 32,
					"code": 60096,
					"name": "protect",
					"tempChar": ""
				},
				{
					"id": 714,
					"order": 2929,
					"prevSize": 32,
					"code": 60097,
					"name": "protect2",
					"tempChar": ""
				},
				{
					"id": 715,
					"order": 2930,
					"prevSize": 32,
					"code": 60098,
					"name": "publish",
					"tempChar": ""
				},
				{
					"id": 716,
					"order": 2931,
					"prevSize": 32,
					"code": 60099,
					"name": "publish2",
					"tempChar": ""
				},
				{
					"id": 717,
					"order": 2932,
					"prevSize": 32,
					"code": 60100,
					"name": "pucker",
					"tempChar": ""
				},
				{
					"id": 718,
					"order": 2933,
					"prevSize": 32,
					"code": 60101,
					"name": "pucker2",
					"tempChar": ""
				},
				{
					"id": 719,
					"order": 2934,
					"prevSize": 32,
					"code": 60102,
					"name": "pull",
					"tempChar": ""
				},
				{
					"id": 720,
					"order": 2935,
					"prevSize": 32,
					"code": 60103,
					"name": "pull2",
					"tempChar": ""
				},
				{
					"order": 625,
					"prevSize": 32,
					"ligatures": "pulse, health",
					"name": "pulse",
					"id": 2436,
					"code": 61185,
					"tempChar": ""
				},
				{
					"order": 626,
					"prevSize": 32,
					"ligatures": "pulse2, health2",
					"name": "pulse2",
					"id": 2437,
					"code": 61186,
					"tempChar": ""
				},
				{
					"id": 721,
					"order": 2936,
					"prevSize": 32,
					"code": 60104,
					"name": "purr",
					"tempChar": ""
				},
				{
					"id": 722,
					"order": 2937,
					"prevSize": 32,
					"code": 60105,
					"name": "purr2",
					"tempChar": ""
				},
				{
					"id": 1091,
					"order": 2392,
					"prevSize": 32,
					"code": 60474,
					"name": "purr3",
					"tempChar": ""
				},
				{
					"id": 723,
					"order": 2938,
					"prevSize": 32,
					"code": 60106,
					"name": "push",
					"tempChar": ""
				},
				{
					"id": 724,
					"order": 2939,
					"prevSize": 32,
					"code": 60107,
					"name": "push2",
					"tempChar": ""
				},
				{
					"order": 312,
					"prevSize": 32,
					"ligatures": "pushpin, pin",
					"name": "pushpin",
					"id": 2123,
					"code": 60872,
					"tempChar": ""
				},
				{
					"order": 313,
					"prevSize": 32,
					"ligatures": "pushpin2, pin2",
					"name": "pushpin2",
					"id": 2124,
					"code": 60873,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "pushpin, pin",
					"order": 3210,
					"name": "pushpin3",
					"id": 145,
					"code": 59442,
					"tempChar": ""
				},
				{
					"order": 801,
					"prevSize": 32,
					"ligatures": "puzzle, puzzle-piece",
					"name": "puzzle",
					"id": 2612,
					"code": 61361,
					"tempChar": ""
				},
				{
					"name": "puzzle-piece",
					"id": 1449,
					"order": 1882,
					"prevSize": 32,
					"code": 61742,
					"tempChar": ""
				},
				{
					"order": 802,
					"prevSize": 32,
					"ligatures": "puzzle2, puzzle-piece2",
					"name": "puzzle2",
					"id": 2613,
					"code": 61362,
					"tempChar": ""
				},
				{
					"order": 803,
					"prevSize": 32,
					"ligatures": "puzzle3, puzzle-piece3",
					"name": "puzzle3",
					"id": 2614,
					"code": 61363,
					"tempChar": ""
				},
				{
					"order": 804,
					"prevSize": 32,
					"ligatures": "puzzle4, puzzle-piece4",
					"name": "puzzle4",
					"id": 2615,
					"code": 61364,
					"tempChar": ""
				},
				{
					"order": 798,
					"prevSize": 32,
					"ligatures": "pyramid",
					"name": "pyramid",
					"id": 2609,
					"code": 61358,
					"tempChar": ""
				},
				{
					"order": 799,
					"prevSize": 32,
					"ligatures": "pyramid2, dualtone",
					"name": "pyramid2",
					"id": 2610,
					"code": 61359,
					"tempChar": ""
				},
				{
					"name": "qq",
					"id": 1606,
					"order": 2039,
					"prevSize": 32,
					"code": 61910,
					"tempChar": ""
				},
				{
					"order": 250,
					"prevSize": 32,
					"ligatures": "qrcode",
					"name": "qrcode",
					"id": 2061,
					"code": 60810,
					"tempChar": ""
				},
				{
					"name": "qrcode2",
					"id": 1217,
					"order": 1650,
					"prevSize": 32,
					"code": 61481,
					"tempChar": ""
				},
				{
					"order": 1109,
					"prevSize": 32,
					"ligatures": "question, help",
					"name": "question",
					"id": 2920,
					"code": 62303,
					"tempChar": ""
				},
				{
					"name": "question-circle",
					"id": 1263,
					"order": 1696,
					"prevSize": 32,
					"code": 61529,
					"tempChar": ""
				},
				{
					"name": "question-circle-o",
					"id": 1790,
					"order": 2223,
					"prevSize": 32,
					"code": 62108,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "question-circle, help",
					"order": 3285,
					"name": "question-circle2",
					"id": 220,
					"code": 59517,
					"tempChar": ""
				},
				{
					"order": 1110,
					"prevSize": 32,
					"ligatures": "question2, help2",
					"name": "question2",
					"id": 2921,
					"code": 62304,
					"tempChar": ""
				},
				{
					"order": 1111,
					"prevSize": 32,
					"ligatures": "question3, help3",
					"name": "question3",
					"id": 2922,
					"code": 62305,
					"tempChar": ""
				},
				{
					"order": 1112,
					"prevSize": 32,
					"ligatures": "question4, help4",
					"name": "question4",
					"id": 2923,
					"code": 62306,
					"tempChar": ""
				},
				{
					"order": 1113,
					"prevSize": 32,
					"ligatures": "question5, help5",
					"name": "question5",
					"id": 2924,
					"code": 62307,
					"tempChar": ""
				},
				{
					"order": 1114,
					"prevSize": 32,
					"ligatures": "question6, help6",
					"name": "question6",
					"id": 2925,
					"code": 62308,
					"tempChar": ""
				},
				{
					"name": "question7",
					"id": 1443,
					"order": 1876,
					"prevSize": 32,
					"code": 61736,
					"tempChar": ""
				},
				{
					"order": 26,
					"prevSize": 32,
					"ligatures": "quill, feather",
					"name": "quill",
					"id": 1837,
					"code": 60586,
					"tempChar": ""
				},
				{
					"order": 27,
					"prevSize": 32,
					"ligatures": "quill2, feather2",
					"name": "quill2",
					"id": 1838,
					"code": 60587,
					"tempChar": ""
				},
				{
					"order": 28,
					"prevSize": 32,
					"ligatures": "quill3, feather3",
					"name": "quill3",
					"id": 1839,
					"code": 60588,
					"tempChar": ""
				},
				{
					"order": 29,
					"prevSize": 32,
					"ligatures": "quill4, feather4",
					"name": "quill4",
					"id": 1840,
					"code": 60589,
					"tempChar": ""
				},
				{
					"name": "quote-left",
					"id": 1420,
					"order": 1853,
					"prevSize": 32,
					"code": 61709,
					"tempChar": ""
				},
				{
					"name": "quote-right",
					"id": 1421,
					"order": 1854,
					"prevSize": 32,
					"code": 61710,
					"tempChar": ""
				},
				{
					"order": 541,
					"prevSize": 32,
					"ligatures": "quotes-left, ldquo",
					"name": "quotes-left",
					"id": 2352,
					"code": 61101,
					"tempChar": ""
				},
				{
					"order": 543,
					"prevSize": 32,
					"ligatures": "quotes-left2, ldquo2",
					"name": "quotes-left2",
					"id": 2354,
					"code": 61103,
					"tempChar": ""
				},
				{
					"order": 542,
					"prevSize": 32,
					"ligatures": "quotes-right, rdquo",
					"name": "quotes-right",
					"id": 2353,
					"code": 61102,
					"tempChar": ""
				},
				{
					"order": 544,
					"prevSize": 32,
					"ligatures": "quotes-right2, rdquo2",
					"name": "quotes-right2",
					"id": 2355,
					"code": 61104,
					"tempChar": ""
				},
				{
					"name": "ra, rebel, resistance",
					"id": 1600,
					"order": 2033,
					"prevSize": 32,
					"code": 61904,
					"tempChar": ""
				},
				{
					"order": 837,
					"prevSize": 32,
					"ligatures": "racing, soprts7",
					"name": "racing",
					"id": 2648,
					"code": 61397,
					"tempChar": ""
				},
				{
					"id": 725,
					"order": 2940,
					"prevSize": 32,
					"code": 60108,
					"name": "radiate",
					"tempChar": ""
				},
				{
					"id": 726,
					"order": 2941,
					"prevSize": 32,
					"code": 60109,
					"name": "radiate2",
					"tempChar": ""
				},
				{
					"order": 383,
					"prevSize": 32,
					"ligatures": "radio3",
					"name": "radio",
					"id": 2194,
					"code": 60943,
					"tempChar": ""
				},
				{
					"order": 1395,
					"prevSize": 32,
					"ligatures": "radio-checked, radio-button",
					"name": "radio-checked",
					"id": 3206,
					"code": 62589,
					"tempChar": ""
				},
				{
					"order": 1396,
					"prevSize": 32,
					"ligatures": "radio-checked2, radio-button2",
					"name": "radio-checked2",
					"id": 3207,
					"code": 62590,
					"tempChar": ""
				},
				{
					"order": 1397,
					"prevSize": 32,
					"ligatures": "radio-unchecked, radio-button3",
					"name": "radio-unchecked",
					"id": 3208,
					"code": 62591,
					"tempChar": ""
				},
				{
					"id": 727,
					"order": 2942,
					"prevSize": 32,
					"code": 60110,
					"name": "rain",
					"tempChar": ""
				},
				{
					"id": 728,
					"order": 2943,
					"prevSize": 32,
					"code": 60111,
					"name": "rain2",
					"tempChar": ""
				},
				{
					"id": 1092,
					"order": 2393,
					"prevSize": 32,
					"code": 60475,
					"name": "rain3",
					"tempChar": ""
				},
				{
					"name": "random",
					"id": 1288,
					"order": 1721,
					"prevSize": 32,
					"code": 61556,
					"tempChar": ""
				},
				{
					"order": 667,
					"prevSize": 32,
					"ligatures": "rating, ranking2",
					"name": "rating",
					"id": 2478,
					"code": 61227,
					"tempChar": ""
				},
				{
					"order": 668,
					"prevSize": 32,
					"ligatures": "rating2, ranking3",
					"name": "rating2",
					"id": 2479,
					"code": 61228,
					"tempChar": ""
				},
				{
					"order": 669,
					"prevSize": 32,
					"ligatures": "rating3, ranking4",
					"name": "rating3",
					"id": 2480,
					"code": 61229,
					"tempChar": ""
				},
				{
					"id": 1093,
					"order": 2394,
					"prevSize": 32,
					"code": 60476,
					"name": "rattle",
					"tempChar": ""
				},
				{
					"id": 729,
					"order": 2944,
					"prevSize": 32,
					"code": 60112,
					"name": "read",
					"tempChar": ""
				},
				{
					"id": 730,
					"order": 2945,
					"prevSize": 32,
					"code": 60113,
					"name": "read2",
					"tempChar": ""
				},
				{
					"id": 1094,
					"order": 2395,
					"prevSize": 32,
					"code": 60477,
					"name": "read3",
					"tempChar": ""
				},
				{
					"order": 153,
					"prevSize": 32,
					"ligatures": "reading, library2",
					"name": "reading",
					"id": 1964,
					"code": 60713,
					"tempChar": ""
				},
				{
					"id": 731,
					"order": 2946,
					"prevSize": 32,
					"code": 60114,
					"name": "realize",
					"tempChar": ""
				},
				{
					"id": 732,
					"order": 2947,
					"prevSize": 32,
					"code": 60115,
					"name": "realize2",
					"tempChar": ""
				},
				{
					"id": 733,
					"order": 2948,
					"prevSize": 32,
					"code": 60116,
					"name": "receive",
					"tempChar": ""
				},
				{
					"id": 734,
					"order": 2949,
					"prevSize": 32,
					"code": 60117,
					"name": "receive2",
					"tempChar": ""
				},
				{
					"id": 1095,
					"order": 2396,
					"prevSize": 32,
					"code": 60478,
					"name": "receive3",
					"tempChar": ""
				},
				{
					"id": 735,
					"order": 2950,
					"prevSize": 32,
					"code": 60118,
					"name": "record",
					"tempChar": ""
				},
				{
					"id": 736,
					"order": 2951,
					"prevSize": 32,
					"code": 60119,
					"name": "record2",
					"tempChar": ""
				},
				{
					"id": 1096,
					"order": 2397,
					"prevSize": 32,
					"code": 60479,
					"name": "record3",
					"tempChar": ""
				},
				{
					"order": 107,
					"prevSize": 32,
					"ligatures": "recording, video17",
					"name": "recording",
					"id": 1918,
					"code": 60667,
					"tempChar": ""
				},
				{
					"name": "recycle",
					"id": 1578,
					"order": 2011,
					"prevSize": 32,
					"code": 61880,
					"tempChar": ""
				},
				{
					"order": 1575,
					"prevSize": 32,
					"ligatures": "reddit, brand61",
					"name": "reddit",
					"id": 3386,
					"code": 62769,
					"tempChar": ""
				},
				{
					"name": "reddit-alien",
					"id": 1764,
					"order": 2197,
					"prevSize": 32,
					"code": 62081,
					"tempChar": ""
				},
				{
					"name": "reddit-square",
					"id": 1557,
					"order": 1990,
					"prevSize": 32,
					"code": 61858,
					"tempChar": ""
				},
				{
					"name": "reddit2",
					"id": 1556,
					"order": 1989,
					"prevSize": 32,
					"code": 61857,
					"tempChar": ""
				},
				{
					"order": 424,
					"prevSize": 32,
					"ligatures": "redo, cw",
					"name": "redo",
					"id": 2235,
					"code": 60984,
					"tempChar": ""
				},
				{
					"order": 450,
					"prevSize": 32,
					"ligatures": "redo2, right",
					"name": "redo2",
					"id": 2261,
					"code": 61010,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "redo, cw",
					"order": 3257,
					"name": "redo3",
					"id": 192,
					"code": 59489,
					"tempChar": ""
				},
				{
					"id": 1097,
					"order": 2398,
					"prevSize": 32,
					"code": 60480,
					"name": "redo4",
					"tempChar": ""
				},
				{
					"id": 737,
					"order": 2952,
					"prevSize": 32,
					"code": 60120,
					"name": "reflect",
					"tempChar": ""
				},
				{
					"id": 738,
					"order": 2953,
					"prevSize": 32,
					"code": 60121,
					"name": "reflect2",
					"tempChar": ""
				},
				{
					"id": 1098,
					"order": 2399,
					"prevSize": 32,
					"code": 60481,
					"name": "reflect3",
					"tempChar": ""
				},
				{
					"name": "refresh",
					"id": 1209,
					"order": 1642,
					"prevSize": 32,
					"code": 61473,
					"tempChar": ""
				},
				{
					"id": 739,
					"order": 2954,
					"prevSize": 32,
					"code": 60122,
					"name": "refresh2",
					"tempChar": ""
				},
				{
					"id": 740,
					"order": 2955,
					"prevSize": 32,
					"code": 60123,
					"name": "refresh3",
					"tempChar": ""
				},
				{
					"id": 1099,
					"order": 2400,
					"prevSize": 32,
					"code": 60482,
					"name": "refresh4",
					"tempChar": ""
				},
				{
					"id": 1100,
					"order": 2401,
					"prevSize": 32,
					"code": 60483,
					"name": "refrigerate",
					"tempChar": ""
				},
				{
					"order": 1489,
					"prevSize": 32,
					"ligatures": "regexp, code4",
					"name": "regexp",
					"id": 3300,
					"code": 62683,
					"tempChar": ""
				},
				{
					"order": 1490,
					"prevSize": 32,
					"ligatures": "regexp2",
					"name": "regexp2",
					"id": 3301,
					"code": 62684,
					"tempChar": ""
				},
				{
					"name": "registered",
					"id": 1731,
					"order": 2164,
					"prevSize": 32,
					"code": 62045,
					"tempChar": ""
				},
				{
					"id": 741,
					"order": 2956,
					"prevSize": 32,
					"code": 60124,
					"name": "regret",
					"tempChar": ""
				},
				{
					"id": 742,
					"order": 2957,
					"prevSize": 32,
					"code": 60125,
					"name": "regret2",
					"tempChar": ""
				},
				{
					"id": 743,
					"order": 2958,
					"prevSize": 32,
					"code": 60126,
					"name": "reheat",
					"tempChar": ""
				},
				{
					"id": 744,
					"order": 2959,
					"prevSize": 32,
					"code": 60127,
					"name": "reheat2",
					"tempChar": ""
				},
				{
					"id": 1101,
					"order": 2402,
					"prevSize": 32,
					"code": 60484,
					"name": "reheat3",
					"tempChar": ""
				},
				{
					"id": 1102,
					"order": 2403,
					"prevSize": 32,
					"code": 60485,
					"name": "relax",
					"tempChar": ""
				},
				{
					"id": 745,
					"order": 2960,
					"prevSize": 32,
					"code": 60128,
					"name": "remember",
					"tempChar": ""
				},
				{
					"id": 746,
					"order": 2961,
					"prevSize": 32,
					"code": 60129,
					"name": "remember2",
					"tempChar": ""
				},
				{
					"id": 1103,
					"order": 2404,
					"prevSize": 32,
					"code": 60486,
					"name": "remember3",
					"tempChar": ""
				},
				{
					"id": 747,
					"order": 2962,
					"prevSize": 32,
					"code": 60130,
					"name": "remind",
					"tempChar": ""
				},
				{
					"id": 748,
					"order": 2963,
					"prevSize": 32,
					"code": 60131,
					"name": "remind2",
					"tempChar": ""
				},
				{
					"id": 1104,
					"order": 2405,
					"prevSize": 32,
					"code": 60487,
					"name": "remind3",
					"tempChar": ""
				},
				{
					"order": 1075,
					"prevSize": 32,
					"ligatures": "reminder, finger6",
					"name": "reminder",
					"id": 2886,
					"code": 62269,
					"tempChar": ""
				},
				{
					"order": 1530,
					"prevSize": 32,
					"name": "renren",
					"ligatures": "renren, brand19",
					"id": 3341,
					"code": 62724,
					"tempChar": ""
				},
				{
					"name": "renren2",
					"id": 1536,
					"order": 1969,
					"prevSize": 32,
					"code": 61835,
					"tempChar": ""
				},
				{
					"name": "repeat, rotate-right",
					"id": 1208,
					"order": 1641,
					"prevSize": 32,
					"code": 61470,
					"tempChar": ""
				},
				{
					"id": 1105,
					"order": 2406,
					"prevSize": 32,
					"code": 60488,
					"name": "repeat2",
					"tempChar": ""
				},
				{
					"order": 452,
					"prevSize": 32,
					"ligatures": "reply, left2",
					"name": "reply",
					"id": 2263,
					"code": 61012,
					"tempChar": ""
				},
				{
					"order": 453,
					"prevSize": 32,
					"ligatures": "reply-all, left3",
					"name": "reply-all",
					"id": 2264,
					"code": 61013,
					"tempChar": ""
				},
				{
					"id": 1106,
					"order": 2407,
					"prevSize": 32,
					"code": 60489,
					"name": "reply3",
					"tempChar": ""
				},
				{
					"id": 749,
					"order": 2964,
					"prevSize": 32,
					"code": 60132,
					"name": "report",
					"tempChar": ""
				},
				{
					"id": 750,
					"order": 2965,
					"prevSize": 32,
					"code": 60133,
					"name": "report2",
					"tempChar": ""
				},
				{
					"id": 1107,
					"order": 2408,
					"prevSize": 32,
					"code": 60490,
					"name": "report3",
					"tempChar": ""
				},
				{
					"order": 333,
					"prevSize": 32,
					"ligatures": "reset",
					"name": "reset",
					"id": 2144,
					"code": 60893,
					"tempChar": ""
				},
				{
					"id": 1108,
					"order": 2409,
					"prevSize": 32,
					"code": 60491,
					"name": "rest",
					"tempChar": ""
				},
				{
					"id": 751,
					"order": 2966,
					"prevSize": 32,
					"code": 60134,
					"name": "return",
					"tempChar": ""
				},
				{
					"id": 752,
					"order": 2967,
					"prevSize": 32,
					"code": 60135,
					"name": "return2",
					"tempChar": ""
				},
				{
					"name": "retweet",
					"id": 1293,
					"order": 1726,
					"prevSize": 32,
					"code": 61561,
					"tempChar": ""
				},
				{
					"id": 1109,
					"order": 2410,
					"prevSize": 32,
					"code": 60492,
					"name": "rewind",
					"tempChar": ""
				},
				{
					"id": 753,
					"order": 2968,
					"prevSize": 32,
					"code": 60136,
					"name": "ride",
					"tempChar": ""
				},
				{
					"id": 754,
					"order": 2969,
					"prevSize": 32,
					"code": 60137,
					"name": "ride2",
					"tempChar": ""
				},
				{
					"id": 1110,
					"order": 2411,
					"prevSize": 32,
					"code": 60493,
					"name": "ride3",
					"tempChar": ""
				},
				{
					"id": 755,
					"order": 2970,
					"prevSize": 32,
					"code": 60138,
					"name": "ring",
					"tempChar": ""
				},
				{
					"id": 756,
					"order": 2971,
					"prevSize": 32,
					"code": 60139,
					"name": "ring2",
					"tempChar": ""
				},
				{
					"id": 1111,
					"order": 2412,
					"prevSize": 32,
					"code": 60494,
					"name": "ring3",
					"tempChar": ""
				},
				{
					"order": 787,
					"prevSize": 32,
					"ligatures": "road, asphalt",
					"name": "road",
					"id": 2598,
					"code": 61347,
					"tempChar": ""
				},
				{
					"name": "road2",
					"id": 1202,
					"order": 1635,
					"prevSize": 32,
					"code": 61464,
					"tempChar": ""
				},
				{
					"order": 735,
					"prevSize": 32,
					"ligatures": "rocket, jet",
					"name": "rocket",
					"id": 2546,
					"code": 61295,
					"tempChar": ""
				},
				{
					"name": "rocket2",
					"id": 1455,
					"order": 1888,
					"prevSize": 32,
					"code": 61749,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "rocket, spaceship",
					"order": 3235,
					"name": "rocket3",
					"id": 170,
					"code": 59467,
					"tempChar": ""
				},
				{
					"id": 757,
					"order": 2972,
					"prevSize": 32,
					"code": 60140,
					"name": "roll",
					"tempChar": ""
				},
				{
					"id": 758,
					"order": 2973,
					"prevSize": 32,
					"code": 60141,
					"name": "roll2",
					"tempChar": ""
				},
				{
					"id": 1112,
					"order": 2413,
					"prevSize": 32,
					"code": 60495,
					"name": "roll3",
					"tempChar": ""
				},
				{
					"order": 425,
					"prevSize": 32,
					"ligatures": "rotate-ccw, ccw2",
					"name": "rotate-ccw",
					"id": 2236,
					"code": 60985,
					"tempChar": ""
				},
				{
					"order": 427,
					"prevSize": 32,
					"ligatures": "rotate-ccw2, ccw3",
					"name": "rotate-ccw2",
					"id": 2238,
					"code": 60987,
					"tempChar": ""
				},
				{
					"order": 429,
					"prevSize": 32,
					"ligatures": "rotate-ccw3, ccw4",
					"name": "rotate-ccw3",
					"id": 2240,
					"code": 60989,
					"tempChar": ""
				},
				{
					"order": 426,
					"prevSize": 32,
					"ligatures": "rotate-cw, cw2",
					"name": "rotate-cw",
					"id": 2237,
					"code": 60986,
					"tempChar": ""
				},
				{
					"order": 428,
					"prevSize": 32,
					"ligatures": "rotate-cw2, cw3",
					"name": "rotate-cw2",
					"id": 2239,
					"code": 60988,
					"tempChar": ""
				},
				{
					"order": 430,
					"prevSize": 32,
					"ligatures": "rotate-cw3, cw4",
					"name": "rotate-cw3",
					"id": 2241,
					"code": 60990,
					"tempChar": ""
				},
				{
					"name": "rotate-left, undo3",
					"id": 1379,
					"order": 1812,
					"prevSize": 32,
					"code": 61666,
					"tempChar": ""
				},
				{
					"name": "rouble, rub, ruble",
					"id": 1488,
					"order": 1921,
					"prevSize": 32,
					"code": 61784,
					"tempChar": ""
				},
				{
					"order": 1532,
					"prevSize": 32,
					"ligatures": "feed2, rss",
					"name": "rss",
					"id": 3343,
					"code": 62726,
					"tempChar": ""
				},
				{
					"name": "rss-square",
					"id": 1468,
					"order": 1901,
					"prevSize": 32,
					"code": 61763,
					"tempChar": ""
				},
				{
					"order": 1533,
					"prevSize": 32,
					"ligatures": "feed3, rss2",
					"name": "rss2",
					"id": 3344,
					"code": 62727,
					"tempChar": ""
				},
				{
					"order": 1461,
					"prevSize": 32,
					"ligatures": "rtl, wysiwyg33",
					"name": "rtl",
					"id": 3272,
					"code": 62655,
					"tempChar": ""
				},
				{
					"order": 1463,
					"prevSize": 32,
					"ligatures": "rtl2, wysiwyg35",
					"name": "rtl2",
					"id": 3274,
					"code": 62657,
					"tempChar": ""
				},
				{
					"id": 759,
					"order": 2974,
					"prevSize": 32,
					"code": 60142,
					"name": "rule",
					"tempChar": ""
				},
				{
					"id": 760,
					"order": 2975,
					"prevSize": 32,
					"code": 60143,
					"name": "rule2",
					"tempChar": ""
				},
				{
					"order": 1412,
					"prevSize": 32,
					"ligatures": "ruler, measure2",
					"name": "ruler",
					"id": 3223,
					"code": 62606,
					"tempChar": ""
				},
				{
					"order": 1411,
					"prevSize": 32,
					"ligatures": "rulers, measure",
					"name": "rulers",
					"id": 3222,
					"code": 62605,
					"tempChar": ""
				},
				{
					"order": 1034,
					"prevSize": 32,
					"ligatures": "sad, emoticon7",
					"name": "sad",
					"id": 2845,
					"code": 62228,
					"tempChar": ""
				},
				{
					"order": 1035,
					"prevSize": 32,
					"ligatures": "sad2, emoticon8",
					"name": "sad2",
					"id": 2846,
					"code": 62229,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "sad, emoticon2",
					"order": 3245,
					"name": "sad3",
					"id": 180,
					"code": 59477,
					"tempChar": ""
				},
				{
					"order": 1598,
					"prevSize": 32,
					"ligatures": "safari, browser5",
					"name": "safari",
					"id": 3409,
					"code": 62792,
					"tempChar": ""
				},
				{
					"name": "safari2",
					"id": 1740,
					"order": 2173,
					"prevSize": 32,
					"code": 62055,
					"tempChar": ""
				},
				{
					"order": 601,
					"prevSize": 32,
					"ligatures": "safe, vault",
					"name": "safe",
					"id": 2412,
					"code": 61161,
					"tempChar": ""
				},
				{
					"order": 134,
					"prevSize": 32,
					"ligatures": "satellite-dish",
					"name": "satellite-dish",
					"id": 1945,
					"code": 60694,
					"tempChar": ""
				},
				{
					"order": 135,
					"prevSize": 32,
					"ligatures": "satellite-dish2",
					"name": "satellite-dish2",
					"id": 1946,
					"code": 60695,
					"tempChar": ""
				},
				{
					"id": 761,
					"order": 2976,
					"prevSize": 32,
					"code": 60144,
					"name": "save2",
					"tempChar": ""
				},
				{
					"id": 762,
					"order": 2977,
					"prevSize": 32,
					"code": 60145,
					"name": "save3",
					"tempChar": ""
				},
				{
					"id": 1113,
					"order": 2414,
					"prevSize": 32,
					"code": 60496,
					"name": "save4",
					"tempChar": ""
				},
				{
					"id": 763,
					"order": 2978,
					"prevSize": 32,
					"code": 60146,
					"name": "say",
					"tempChar": ""
				},
				{
					"id": 764,
					"order": 2979,
					"prevSize": 32,
					"code": 60147,
					"name": "say2",
					"tempChar": ""
				},
				{
					"order": 744,
					"prevSize": 32,
					"ligatures": "scale, weight",
					"name": "scale",
					"id": 2555,
					"code": 61304,
					"tempChar": ""
				},
				{
					"id": 765,
					"order": 2980,
					"prevSize": 32,
					"code": 60148,
					"name": "scare",
					"tempChar": ""
				},
				{
					"id": 766,
					"order": 2981,
					"prevSize": 32,
					"code": 60149,
					"name": "scare2",
					"tempChar": ""
				},
				{
					"id": 767,
					"order": 2982,
					"prevSize": 32,
					"code": 60150,
					"name": "schedule",
					"tempChar": ""
				},
				{
					"id": 768,
					"order": 2983,
					"prevSize": 32,
					"code": 60151,
					"name": "schedule2",
					"tempChar": ""
				},
				{
					"id": 1114,
					"order": 2415,
					"prevSize": 32,
					"code": 60497,
					"name": "schedule3",
					"tempChar": ""
				},
				{
					"order": 1414,
					"prevSize": 32,
					"ligatures": "scissors, cut",
					"name": "scissors",
					"id": 3225,
					"code": 62608,
					"tempChar": ""
				},
				{
					"order": 1415,
					"prevSize": 32,
					"ligatures": "scissors2, cut2",
					"name": "scissors2",
					"id": 3226,
					"code": 62609,
					"tempChar": ""
				},
				{
					"order": 1416,
					"prevSize": 32,
					"ligatures": "scissors3, cut3",
					"name": "scissors3",
					"id": 3227,
					"code": 62610,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "screen, monitor",
					"order": 3217,
					"name": "screen",
					"id": 152,
					"code": 59449,
					"tempChar": ""
				},
				{
					"id": 1115,
					"order": 2416,
					"prevSize": 32,
					"code": 60498,
					"name": "screw",
					"tempChar": ""
				},
				{
					"order": 621,
					"prevSize": 32,
					"ligatures": "screwdriver, tool7",
					"name": "screwdriver",
					"id": 2432,
					"code": 61181,
					"tempChar": ""
				},
				{
					"order": 622,
					"prevSize": 32,
					"ligatures": "screwdriver2, tool8",
					"name": "screwdriver2",
					"id": 2433,
					"code": 61182,
					"tempChar": ""
				},
				{
					"name": "scribd",
					"id": 1773,
					"order": 2206,
					"prevSize": 32,
					"code": 62090,
					"tempChar": ""
				},
				{
					"id": 769,
					"order": 2984,
					"prevSize": 32,
					"code": 60152,
					"name": "scroll",
					"tempChar": ""
				},
				{
					"id": 770,
					"order": 2985,
					"prevSize": 32,
					"code": 60153,
					"name": "scroll2",
					"tempChar": ""
				},
				{
					"id": 1116,
					"order": 2417,
					"prevSize": 32,
					"code": 60499,
					"name": "scroll3",
					"tempChar": ""
				},
				{
					"order": 562,
					"prevSize": 32,
					"ligatures": "search, magnifier",
					"name": "search",
					"id": 2373,
					"code": 61122,
					"tempChar": ""
				},
				{
					"name": "search-minus",
					"id": 1194,
					"order": 1627,
					"prevSize": 32,
					"code": 61456,
					"tempChar": ""
				},
				{
					"name": "search-plus",
					"id": 1193,
					"order": 1626,
					"prevSize": 32,
					"code": 61454,
					"tempChar": ""
				},
				{
					"id": 1117,
					"order": 2418,
					"prevSize": 32,
					"code": 60500,
					"name": "search10",
					"tempChar": ""
				},
				{
					"order": 565,
					"prevSize": 32,
					"ligatures": "search2, magnifier4",
					"name": "search2",
					"id": 2376,
					"code": 61125,
					"tempChar": ""
				},
				{
					"order": 568,
					"prevSize": 32,
					"ligatures": "search3, magnifier7",
					"name": "search3",
					"id": 2379,
					"code": 61128,
					"tempChar": ""
				},
				{
					"order": 569,
					"prevSize": 32,
					"ligatures": "search4, magnifier8",
					"name": "search4",
					"id": 2380,
					"code": 61129,
					"tempChar": ""
				},
				{
					"order": 572,
					"prevSize": 32,
					"ligatures": "search5, magnifier11",
					"name": "search5",
					"id": 2383,
					"code": 61132,
					"tempChar": ""
				},
				{
					"order": 573,
					"prevSize": 32,
					"ligatures": "search6, magnifier12",
					"name": "search6",
					"id": 2384,
					"code": 61133,
					"tempChar": ""
				},
				{
					"name": "search7",
					"id": 1181,
					"order": 1614,
					"prevSize": 32,
					"code": 61442,
					"tempChar": ""
				},
				{
					"id": 771,
					"order": 2986,
					"prevSize": 32,
					"code": 60154,
					"name": "search8",
					"tempChar": ""
				},
				{
					"id": 772,
					"order": 2987,
					"prevSize": 32,
					"code": 60155,
					"name": "search9",
					"tempChar": ""
				},
				{
					"order": 1464,
					"prevSize": 32,
					"ligatures": "section, wysiwyg36",
					"name": "section",
					"id": 3275,
					"code": 62658,
					"tempChar": ""
				},
				{
					"id": 773,
					"order": 2988,
					"prevSize": 32,
					"code": 60156,
					"name": "see",
					"tempChar": ""
				},
				{
					"id": 774,
					"order": 2989,
					"prevSize": 32,
					"code": 60157,
					"name": "see2",
					"tempChar": ""
				},
				{
					"id": 1118,
					"order": 2419,
					"prevSize": 32,
					"code": 60501,
					"name": "see3",
					"tempChar": ""
				},
				{
					"order": 1068,
					"prevSize": 32,
					"ligatures": "select, pointer3",
					"name": "select",
					"id": 2879,
					"code": 62262,
					"tempChar": ""
				},
				{
					"order": 1069,
					"prevSize": 32,
					"ligatures": "select2, pointer4",
					"name": "select2",
					"id": 2880,
					"code": 62263,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "select, cursor",
					"order": 3242,
					"name": "select3",
					"id": 177,
					"code": 59474,
					"tempChar": ""
				},
				{
					"id": 775,
					"order": 2990,
					"prevSize": 32,
					"code": 60158,
					"name": "select4",
					"tempChar": ""
				},
				{
					"id": 776,
					"order": 2991,
					"prevSize": 32,
					"code": 60159,
					"name": "select5",
					"tempChar": ""
				},
				{
					"id": 1119,
					"order": 2420,
					"prevSize": 32,
					"code": 60502,
					"name": "select6",
					"tempChar": ""
				},
				{
					"id": 777,
					"order": 2992,
					"prevSize": 32,
					"code": 60160,
					"name": "sell",
					"tempChar": ""
				},
				{
					"id": 778,
					"order": 2993,
					"prevSize": 32,
					"code": 60161,
					"name": "sell2",
					"tempChar": ""
				},
				{
					"name": "sellsy",
					"id": 1663,
					"order": 2096,
					"prevSize": 32,
					"code": 61971,
					"tempChar": ""
				},
				{
					"id": 779,
					"order": 2994,
					"prevSize": 32,
					"code": 60162,
					"name": "send2",
					"tempChar": ""
				},
				{
					"id": 780,
					"order": 2995,
					"prevSize": 32,
					"code": 60163,
					"name": "send3",
					"tempChar": ""
				},
				{
					"id": 1120,
					"order": 2421,
					"prevSize": 32,
					"code": 60503,
					"name": "send4",
					"tempChar": ""
				},
				{
					"order": 404,
					"prevSize": 32,
					"ligatures": "server, drives",
					"name": "server",
					"id": 2215,
					"code": 60964,
					"tempChar": ""
				},
				{
					"name": "server2",
					"id": 1691,
					"order": 2124,
					"prevSize": 32,
					"code": 62003,
					"tempChar": ""
				},
				{
					"id": 1121,
					"order": 2422,
					"prevSize": 32,
					"code": 60504,
					"name": "set",
					"tempChar": ""
				},
				{
					"order": 1496,
					"prevSize": 32,
					"ligatures": "seven-segment-0, number",
					"name": "seven-segment-0",
					"id": 3307,
					"code": 62690,
					"tempChar": ""
				},
				{
					"order": 1497,
					"prevSize": 32,
					"ligatures": "seven-segment-1, number2",
					"name": "seven-segment-1",
					"id": 3308,
					"code": 62691,
					"tempChar": ""
				},
				{
					"order": 1498,
					"prevSize": 32,
					"ligatures": "seven-segment-2, number3",
					"name": "seven-segment-2",
					"id": 3309,
					"code": 62692,
					"tempChar": ""
				},
				{
					"order": 1499,
					"prevSize": 32,
					"ligatures": "seven-segment-3, number4",
					"name": "seven-segment-3",
					"id": 3310,
					"code": 62693,
					"tempChar": ""
				},
				{
					"order": 1500,
					"prevSize": 32,
					"ligatures": "seven-segment-4, number5",
					"name": "seven-segment-4",
					"id": 3311,
					"code": 62694,
					"tempChar": ""
				},
				{
					"order": 1501,
					"prevSize": 32,
					"ligatures": "seven-segment-5, number6",
					"name": "seven-segment-5",
					"id": 3312,
					"code": 62695,
					"tempChar": ""
				},
				{
					"order": 1502,
					"prevSize": 32,
					"ligatures": "seven-segment-6, number7",
					"name": "seven-segment-6",
					"id": 3313,
					"code": 62696,
					"tempChar": ""
				},
				{
					"order": 1503,
					"prevSize": 32,
					"ligatures": "seven-segment-7, number8",
					"name": "seven-segment-7",
					"id": 3314,
					"code": 62697,
					"tempChar": ""
				},
				{
					"order": 1504,
					"prevSize": 32,
					"ligatures": "seven-segment-8, number9",
					"name": "seven-segment-8",
					"id": 3315,
					"code": 62698,
					"tempChar": ""
				},
				{
					"order": 1505,
					"prevSize": 32,
					"ligatures": "seven-segment-9, number10",
					"name": "seven-segment-9",
					"id": 3316,
					"code": 62699,
					"tempChar": ""
				},
				{
					"id": 781,
					"order": 2996,
					"prevSize": 32,
					"code": 60164,
					"name": "sew",
					"tempChar": ""
				},
				{
					"id": 782,
					"order": 2997,
					"prevSize": 32,
					"code": 60165,
					"name": "sew2",
					"tempChar": ""
				},
				{
					"id": 1122,
					"order": 2423,
					"prevSize": 32,
					"code": 60505,
					"name": "sew3",
					"tempChar": ""
				},
				{
					"id": 783,
					"order": 2998,
					"prevSize": 32,
					"code": 60166,
					"name": "shake",
					"tempChar": ""
				},
				{
					"id": 784,
					"order": 2999,
					"prevSize": 32,
					"code": 60167,
					"name": "shake2",
					"tempChar": ""
				},
				{
					"order": 1481,
					"prevSize": 32,
					"ligatures": "share, out",
					"name": "share",
					"id": 3292,
					"code": 62675,
					"tempChar": ""
				},
				{
					"name": "share-alt",
					"id": 1615,
					"order": 2048,
					"prevSize": 32,
					"code": 61920,
					"tempChar": ""
				},
				{
					"name": "share-alt-square",
					"id": 1616,
					"order": 2049,
					"prevSize": 32,
					"code": 61921,
					"tempChar": ""
				},
				{
					"name": "share-square",
					"id": 1478,
					"order": 1911,
					"prevSize": 32,
					"code": 61773,
					"tempChar": ""
				},
				{
					"name": "share-square-o",
					"id": 1244,
					"order": 1677,
					"prevSize": 32,
					"code": 61509,
					"tempChar": ""
				},
				{
					"order": 1482,
					"prevSize": 32,
					"ligatures": "share2, out2",
					"name": "share2",
					"id": 3293,
					"code": 62676,
					"tempChar": ""
				},
				{
					"order": 1506,
					"prevSize": 32,
					"ligatures": "share3, social",
					"name": "share3",
					"id": 3317,
					"code": 62700,
					"tempChar": ""
				},
				{
					"order": 1507,
					"prevSize": 32,
					"ligatures": "share4, social2",
					"name": "share4",
					"id": 3318,
					"code": 62701,
					"tempChar": ""
				},
				{
					"id": 785,
					"order": 3000,
					"prevSize": 32,
					"code": 60168,
					"name": "share6",
					"tempChar": ""
				},
				{
					"id": 786,
					"order": 3001,
					"prevSize": 32,
					"code": 60169,
					"name": "share7",
					"tempChar": ""
				},
				{
					"id": 1123,
					"order": 2424,
					"prevSize": 32,
					"code": 60506,
					"name": "share8",
					"tempChar": ""
				},
				{
					"id": 787,
					"order": 3002,
					"prevSize": 32,
					"code": 60170,
					"name": "sharpen",
					"tempChar": ""
				},
				{
					"id": 788,
					"order": 3003,
					"prevSize": 32,
					"code": 60171,
					"name": "sharpen2",
					"tempChar": ""
				},
				{
					"id": 789,
					"order": 3004,
					"prevSize": 32,
					"code": 60172,
					"name": "shave",
					"tempChar": ""
				},
				{
					"id": 790,
					"order": 3005,
					"prevSize": 32,
					"code": 60173,
					"name": "shave2",
					"tempChar": ""
				},
				{
					"order": 438,
					"prevSize": 32,
					"ligatures": "shear",
					"name": "shear",
					"id": 2249,
					"code": 60998,
					"tempChar": ""
				},
				{
					"order": 819,
					"prevSize": 32,
					"ligatures": "shield, security",
					"name": "shield",
					"id": 2630,
					"code": 61379,
					"tempChar": ""
				},
				{
					"order": 820,
					"prevSize": 32,
					"ligatures": "shield-check, security2",
					"name": "shield-check",
					"id": 2631,
					"code": 61380,
					"tempChar": ""
				},
				{
					"order": 821,
					"prevSize": 32,
					"ligatures": "shield-notice, security3",
					"name": "shield-notice",
					"id": 2632,
					"code": 61381,
					"tempChar": ""
				},
				{
					"order": 822,
					"prevSize": 32,
					"ligatures": "shield2, security4",
					"name": "shield2",
					"id": 2633,
					"code": 61382,
					"tempChar": ""
				},
				{
					"order": 823,
					"prevSize": 32,
					"ligatures": "shield3, security5",
					"name": "shield3",
					"id": 2634,
					"code": 61383,
					"tempChar": ""
				},
				{
					"order": 824,
					"prevSize": 32,
					"ligatures": "shield4, security6",
					"name": "shield4",
					"id": 2635,
					"code": 61384,
					"tempChar": ""
				},
				{
					"name": "shield5",
					"id": 1452,
					"order": 1885,
					"prevSize": 32,
					"code": 61746,
					"tempChar": ""
				},
				{
					"order": 1381,
					"prevSize": 32,
					"ligatures": "shift",
					"name": "shift",
					"id": 3192,
					"code": 62575,
					"tempChar": ""
				},
				{
					"id": 791,
					"order": 3006,
					"prevSize": 32,
					"code": 60174,
					"name": "shift2",
					"tempChar": ""
				},
				{
					"id": 792,
					"order": 3007,
					"prevSize": 32,
					"code": 60175,
					"name": "shift3",
					"tempChar": ""
				},
				{
					"id": 793,
					"order": 3008,
					"prevSize": 32,
					"code": 60176,
					"name": "shine",
					"tempChar": ""
				},
				{
					"id": 794,
					"order": 3009,
					"prevSize": 32,
					"code": 60177,
					"name": "shine2",
					"tempChar": ""
				},
				{
					"id": 1124,
					"order": 2425,
					"prevSize": 32,
					"code": 60507,
					"name": "shine3",
					"tempChar": ""
				},
				{
					"order": 790,
					"prevSize": 32,
					"ligatures": "ship, travel10",
					"name": "ship",
					"id": 2601,
					"code": 61350,
					"tempChar": ""
				},
				{
					"name": "ship2",
					"id": 1670,
					"order": 2103,
					"prevSize": 32,
					"code": 61978,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "shirt, clothing",
					"order": 3204,
					"name": "shirt",
					"id": 139,
					"code": 59436,
					"tempChar": ""
				},
				{
					"name": "shirtsinbulk",
					"id": 1664,
					"order": 2097,
					"prevSize": 32,
					"code": 61972,
					"tempChar": ""
				},
				{
					"order": 1046,
					"prevSize": 32,
					"ligatures": "shocked, emoticon19",
					"name": "shocked",
					"id": 2857,
					"code": 62240,
					"tempChar": ""
				},
				{
					"order": 1047,
					"prevSize": 32,
					"ligatures": "shocked2, emoticon20",
					"name": "shocked2",
					"id": 2858,
					"code": 62241,
					"tempChar": ""
				},
				{
					"id": 795,
					"order": 3010,
					"prevSize": 32,
					"code": 60178,
					"name": "shoot",
					"tempChar": ""
				},
				{
					"id": 796,
					"order": 3011,
					"prevSize": 32,
					"code": 60179,
					"name": "shoot2",
					"tempChar": ""
				},
				{
					"id": 797,
					"order": 3012,
					"prevSize": 32,
					"code": 60180,
					"name": "shop",
					"tempChar": ""
				},
				{
					"id": 798,
					"order": 3013,
					"prevSize": 32,
					"code": 60181,
					"name": "shop2",
					"tempChar": ""
				},
				{
					"name": "shopping-bag",
					"id": 1778,
					"order": 2211,
					"prevSize": 32,
					"code": 62096,
					"tempChar": ""
				},
				{
					"name": "shopping-basket",
					"id": 1779,
					"order": 2212,
					"prevSize": 32,
					"code": 62097,
					"tempChar": ""
				},
				{
					"name": "shopping-cart",
					"id": 1294,
					"order": 1727,
					"prevSize": 32,
					"code": 61562,
					"tempChar": ""
				},
				{
					"order": 538,
					"prevSize": 32,
					"ligatures": "shorts",
					"name": "shorts",
					"id": 2349,
					"code": 61098,
					"tempChar": ""
				},
				{
					"order": 365,
					"prevSize": 32,
					"ligatures": "shredder, destroy",
					"name": "shredder",
					"id": 2176,
					"code": 60925,
					"tempChar": ""
				},
				{
					"order": 575,
					"prevSize": 32,
					"ligatures": "shrink, collapse",
					"name": "shrink",
					"id": 2386,
					"code": 61135,
					"tempChar": ""
				},
				{
					"order": 577,
					"prevSize": 32,
					"ligatures": "shrink2, collapse2",
					"name": "shrink2",
					"id": 2388,
					"code": 61137,
					"tempChar": ""
				},
				{
					"order": 579,
					"prevSize": 32,
					"ligatures": "shrink3, collapse3",
					"name": "shrink3",
					"id": 2390,
					"code": 61139,
					"tempChar": ""
				},
				{
					"order": 581,
					"prevSize": 32,
					"ligatures": "shrink4, collapse4",
					"name": "shrink4",
					"id": 2392,
					"code": 61141,
					"tempChar": ""
				},
				{
					"order": 583,
					"prevSize": 32,
					"ligatures": "shrink5, collapse5",
					"name": "shrink5",
					"id": 2394,
					"code": 61143,
					"tempChar": ""
				},
				{
					"order": 585,
					"prevSize": 32,
					"ligatures": "shrink6, collapse6",
					"name": "shrink6",
					"id": 2396,
					"code": 61145,
					"tempChar": ""
				},
				{
					"order": 587,
					"prevSize": 32,
					"ligatures": "shrink7, collapse7",
					"name": "shrink7",
					"id": 2398,
					"code": 61147,
					"tempChar": ""
				},
				{
					"order": 1201,
					"prevSize": 32,
					"ligatures": "shuffle, random",
					"name": "shuffle",
					"id": 3012,
					"code": 62395,
					"tempChar": ""
				},
				{
					"order": 1202,
					"prevSize": 32,
					"ligatures": "shuffle2, random2",
					"name": "shuffle2",
					"id": 3013,
					"code": 62396,
					"tempChar": ""
				},
				{
					"id": 1125,
					"order": 2426,
					"prevSize": 32,
					"code": 60508,
					"name": "shuffle3",
					"tempChar": ""
				},
				{
					"order": 73,
					"prevSize": 32,
					"ligatures": "shutter, camera4",
					"name": "shutter",
					"id": 1884,
					"code": 60633,
					"tempChar": ""
				},
				{
					"order": 1444,
					"prevSize": 32,
					"ligatures": "sigma, wysiwyg16",
					"name": "sigma",
					"id": 3255,
					"code": 62638,
					"tempChar": ""
				},
				{
					"name": "sign-in",
					"id": 1314,
					"order": 1747,
					"prevSize": 32,
					"code": 61584,
					"tempChar": ""
				},
				{
					"name": "sign-language, signing",
					"id": 1800,
					"order": 2233,
					"prevSize": 32,
					"code": 62119,
					"tempChar": ""
				},
				{
					"name": "sign-out",
					"id": 1310,
					"order": 1743,
					"prevSize": 32,
					"code": 61579,
					"tempChar": ""
				},
				{
					"name": "signal",
					"id": 1196,
					"order": 1629,
					"prevSize": 32,
					"code": 61458,
					"tempChar": ""
				},
				{
					"name": "simplybuilt",
					"id": 1665,
					"order": 2098,
					"prevSize": 32,
					"code": 61973,
					"tempChar": ""
				},
				{
					"order": 1531,
					"prevSize": 32,
					"name": "sina-weibo",
					"ligatures": "sina-weibo, brand20",
					"id": 3342,
					"code": 62725,
					"tempChar": ""
				},
				{
					"id": 799,
					"order": 3014,
					"prevSize": 32,
					"code": 60182,
					"name": "sing",
					"tempChar": ""
				},
				{
					"id": 800,
					"order": 3015,
					"prevSize": 32,
					"code": 60183,
					"name": "sing2",
					"tempChar": ""
				},
				{
					"id": 1126,
					"order": 2427,
					"prevSize": 32,
					"code": 60509,
					"name": "sing3",
					"tempChar": ""
				},
				{
					"id": 801,
					"order": 3016,
					"prevSize": 32,
					"code": 60184,
					"name": "sink",
					"tempChar": ""
				},
				{
					"id": 802,
					"order": 3017,
					"prevSize": 32,
					"code": 60185,
					"name": "sink2",
					"tempChar": ""
				},
				{
					"id": 803,
					"order": 3018,
					"prevSize": 32,
					"code": 60186,
					"name": "sip",
					"tempChar": ""
				},
				{
					"id": 804,
					"order": 3019,
					"prevSize": 32,
					"code": 60187,
					"name": "sip2",
					"tempChar": ""
				},
				{
					"id": 1127,
					"order": 2428,
					"prevSize": 32,
					"code": 60510,
					"name": "sip3",
					"tempChar": ""
				},
				{
					"id": 805,
					"order": 3020,
					"prevSize": 32,
					"code": 60188,
					"name": "sit",
					"tempChar": ""
				},
				{
					"id": 806,
					"order": 3021,
					"prevSize": 32,
					"code": 60189,
					"name": "sit2",
					"tempChar": ""
				},
				{
					"id": 1128,
					"order": 2429,
					"prevSize": 32,
					"code": 60511,
					"name": "sit3",
					"tempChar": ""
				},
				{
					"name": "sitemap",
					"id": 1385,
					"order": 1818,
					"prevSize": 32,
					"code": 61672,
					"tempChar": ""
				},
				{
					"id": 807,
					"order": 3022,
					"prevSize": 32,
					"code": 60190,
					"name": "skate",
					"tempChar": ""
				},
				{
					"id": 808,
					"order": 3023,
					"prevSize": 32,
					"code": 60191,
					"name": "skate2",
					"tempChar": ""
				},
				{
					"id": 1129,
					"order": 2430,
					"prevSize": 32,
					"code": 60512,
					"name": "skate3",
					"tempChar": ""
				},
				{
					"id": 1130,
					"order": 2431,
					"prevSize": 32,
					"code": 60513,
					"name": "skip",
					"tempChar": ""
				},
				{
					"order": 754,
					"prevSize": 32,
					"ligatures": "skull, skeleton",
					"name": "skull",
					"id": 2565,
					"code": 61314,
					"tempChar": ""
				},
				{
					"order": 755,
					"prevSize": 32,
					"ligatures": "skull2, skeleton2",
					"name": "skull2",
					"id": 2566,
					"code": 61315,
					"tempChar": ""
				},
				{
					"name": "skyatlas",
					"id": 1666,
					"order": 2099,
					"prevSize": 32,
					"code": 61974,
					"tempChar": ""
				},
				{
					"order": 1574,
					"prevSize": 32,
					"ligatures": "skype, brand60",
					"name": "skype",
					"id": 3385,
					"code": 62768,
					"tempChar": ""
				},
				{
					"name": "skype2",
					"id": 1524,
					"order": 1957,
					"prevSize": 32,
					"code": 61822,
					"tempChar": ""
				},
				{
					"name": "slack",
					"id": 1548,
					"order": 1981,
					"prevSize": 32,
					"code": 61848,
					"tempChar": ""
				},
				{
					"id": 809,
					"order": 3024,
					"prevSize": 32,
					"code": 60192,
					"name": "sleep",
					"tempChar": ""
				},
				{
					"id": 810,
					"order": 3025,
					"prevSize": 32,
					"code": 60193,
					"name": "sleep2",
					"tempChar": ""
				},
				{
					"id": 1131,
					"order": 2432,
					"prevSize": 32,
					"code": 60514,
					"name": "sleep3",
					"tempChar": ""
				},
				{
					"order": 1058,
					"prevSize": 32,
					"ligatures": "sleepy, emoticon31",
					"name": "sleepy",
					"id": 2869,
					"code": 62252,
					"tempChar": ""
				},
				{
					"order": 1059,
					"prevSize": 32,
					"ligatures": "sleepy2, emoticon32",
					"name": "sleepy2",
					"id": 2870,
					"code": 62253,
					"tempChar": ""
				},
				{
					"id": 811,
					"order": 3026,
					"prevSize": 32,
					"code": 60194,
					"name": "slice",
					"tempChar": ""
				},
				{
					"id": 812,
					"order": 3027,
					"prevSize": 32,
					"code": 60195,
					"name": "slice2",
					"tempChar": ""
				},
				{
					"name": "sliders",
					"id": 1614,
					"order": 2047,
					"prevSize": 32,
					"code": 61918,
					"tempChar": ""
				},
				{
					"name": "slideshare",
					"id": 1622,
					"order": 2055,
					"prevSize": 32,
					"code": 61927,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "smartphone, mobile",
					"order": 3218,
					"name": "smartphone",
					"id": 153,
					"code": 59450,
					"tempChar": ""
				},
				{
					"id": 813,
					"order": 3028,
					"prevSize": 32,
					"code": 60196,
					"name": "smell",
					"tempChar": ""
				},
				{
					"id": 814,
					"order": 3029,
					"prevSize": 32,
					"code": 60197,
					"name": "smell2",
					"tempChar": ""
				},
				{
					"id": 1132,
					"order": 2433,
					"prevSize": 32,
					"code": 60515,
					"name": "smell3",
					"tempChar": ""
				},
				{
					"order": 1030,
					"prevSize": 32,
					"ligatures": "smile, emoticon3",
					"name": "smile",
					"id": 2841,
					"code": 62224,
					"tempChar": ""
				},
				{
					"name": "smile-o",
					"id": 1428,
					"order": 1861,
					"prevSize": 32,
					"code": 61720,
					"tempChar": ""
				},
				{
					"order": 1031,
					"prevSize": 32,
					"ligatures": "smile2, emoticon4",
					"name": "smile2",
					"id": 2842,
					"code": 62225,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "smile, emoticon",
					"order": 3244,
					"name": "smile3",
					"id": 179,
					"code": 59476,
					"tempChar": ""
				},
				{
					"name": "snapchat",
					"id": 1804,
					"order": 2237,
					"prevSize": 32,
					"code": 62123,
					"tempChar": ""
				},
				{
					"name": "snapchat-ghost",
					"id": 1805,
					"order": 2238,
					"prevSize": 32,
					"code": 62124,
					"tempChar": ""
				},
				{
					"name": "snapchat-square",
					"id": 1806,
					"order": 2239,
					"prevSize": 32,
					"code": 62125,
					"tempChar": ""
				},
				{
					"id": 815,
					"order": 3030,
					"prevSize": 32,
					"code": 60198,
					"name": "snow",
					"tempChar": ""
				},
				{
					"id": 816,
					"order": 3031,
					"prevSize": 32,
					"code": 60199,
					"name": "snow2",
					"tempChar": ""
				},
				{
					"id": 1133,
					"order": 2434,
					"prevSize": 32,
					"code": 60516,
					"name": "snow3",
					"tempChar": ""
				},
				{
					"order": 959,
					"prevSize": 32,
					"ligatures": "snowflake, weather3",
					"name": "snowflake",
					"id": 2770,
					"code": 62153,
					"tempChar": ""
				},
				{
					"order": 825,
					"prevSize": 32,
					"ligatures": "soccer, sports",
					"name": "soccer",
					"id": 2636,
					"code": 61385,
					"tempChar": ""
				},
				{
					"order": 539,
					"prevSize": 32,
					"ligatures": "sock, footwear",
					"name": "sock",
					"id": 2350,
					"code": 61099,
					"tempChar": ""
				},
				{
					"id": 817,
					"order": 3032,
					"prevSize": 32,
					"code": 60200,
					"name": "solve",
					"tempChar": ""
				},
				{
					"id": 818,
					"order": 3033,
					"prevSize": 32,
					"code": 60201,
					"name": "solve2",
					"tempChar": ""
				},
				{
					"id": 1134,
					"order": 2435,
					"prevSize": 32,
					"code": 60517,
					"name": "solve3",
					"tempChar": ""
				},
				{
					"order": 1354,
					"prevSize": 32,
					"ligatures": "sort, arrows10",
					"name": "sort",
					"id": 3165,
					"code": 62548,
					"tempChar": ""
				},
				{
					"order": 1358,
					"prevSize": 32,
					"ligatures": "sort-alpha-asc, arrange",
					"name": "sort-alpha-asc",
					"id": 3169,
					"code": 62552,
					"tempChar": ""
				},
				{
					"name": "sort-alpha-asc2",
					"id": 1493,
					"order": 1926,
					"prevSize": 32,
					"code": 61789,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "sort-alpha-asc, sort",
					"order": 3323,
					"name": "sort-alpha-asc3",
					"id": 258,
					"code": 59555,
					"tempChar": ""
				},
				{
					"order": 1359,
					"prevSize": 32,
					"ligatures": "sort-alpha-desc, arrange2",
					"name": "sort-alpha-desc",
					"id": 3170,
					"code": 62553,
					"tempChar": ""
				},
				{
					"name": "sort-alpha-desc2",
					"id": 1494,
					"order": 1927,
					"prevSize": 32,
					"code": 61790,
					"tempChar": ""
				},
				{
					"order": 1362,
					"prevSize": 32,
					"ligatures": "sort-amount-asc, arrange5",
					"name": "sort-amount-asc",
					"id": 3173,
					"code": 62556,
					"tempChar": ""
				},
				{
					"name": "sort-amount-asc2",
					"id": 1495,
					"order": 1928,
					"prevSize": 32,
					"code": 61792,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "sort-amount-asc, sort2",
					"order": 3324,
					"name": "sort-amount-asc3",
					"id": 259,
					"code": 59556,
					"tempChar": ""
				},
				{
					"order": 1363,
					"prevSize": 32,
					"ligatures": "sort-amount-desc, arrange6",
					"name": "sort-amount-desc",
					"id": 3174,
					"code": 62557,
					"tempChar": ""
				},
				{
					"name": "sort-amount-desc2",
					"id": 1496,
					"order": 1929,
					"prevSize": 32,
					"code": 61793,
					"tempChar": ""
				},
				{
					"name": "sort-asc, sort-up",
					"id": 1376,
					"order": 1809,
					"prevSize": 32,
					"code": 61662,
					"tempChar": ""
				},
				{
					"name": "sort-desc, sort-down",
					"id": 1375,
					"order": 1808,
					"prevSize": 32,
					"code": 61661,
					"tempChar": ""
				},
				{
					"order": 1361,
					"prevSize": 32,
					"ligatures": "sort-numberic-desc, arrange4",
					"name": "sort-numberic-desc",
					"id": 3172,
					"code": 62555,
					"tempChar": ""
				},
				{
					"order": 1360,
					"prevSize": 32,
					"ligatures": "sort-numeric-asc, arrange3",
					"name": "sort-numeric-asc",
					"id": 3171,
					"code": 62554,
					"tempChar": ""
				},
				{
					"name": "sort-numeric-asc2",
					"id": 1497,
					"order": 1930,
					"prevSize": 32,
					"code": 61794,
					"tempChar": ""
				},
				{
					"name": "sort-numeric-desc",
					"id": 1498,
					"order": 1931,
					"prevSize": 32,
					"code": 61795,
					"tempChar": ""
				},
				{
					"order": 1364,
					"prevSize": 32,
					"ligatures": "sort-time-asc, arrange7",
					"name": "sort-time-asc",
					"id": 3175,
					"code": 62558,
					"tempChar": ""
				},
				{
					"order": 1365,
					"prevSize": 32,
					"ligatures": "sort-time-desc, arrange8",
					"name": "sort-time-desc",
					"id": 3176,
					"code": 62559,
					"tempChar": ""
				},
				{
					"order": 1355,
					"prevSize": 32,
					"ligatures": "sort2, arrows11",
					"name": "sort2",
					"id": 3166,
					"code": 62549,
					"tempChar": ""
				},
				{
					"name": "sort3, unsorted",
					"id": 1374,
					"order": 1807,
					"prevSize": 32,
					"code": 61660,
					"tempChar": ""
				},
				{
					"id": 819,
					"order": 3034,
					"prevSize": 32,
					"code": 60202,
					"name": "sound",
					"tempChar": ""
				},
				{
					"id": 820,
					"order": 3035,
					"prevSize": 32,
					"code": 60203,
					"name": "sound2",
					"tempChar": ""
				},
				{
					"id": 1135,
					"order": 2436,
					"prevSize": 32,
					"code": 60518,
					"name": "sound3",
					"tempChar": ""
				},
				{
					"order": 1572,
					"prevSize": 32,
					"ligatures": "soundcloud, brand58",
					"name": "soundcloud",
					"id": 3383,
					"code": 62766,
					"tempChar": ""
				},
				{
					"order": 1573,
					"prevSize": 32,
					"ligatures": "soundcloud2, brand59",
					"name": "soundcloud2",
					"id": 3384,
					"code": 62767,
					"tempChar": ""
				},
				{
					"name": "soundcloud3",
					"id": 1584,
					"order": 2017,
					"prevSize": 32,
					"code": 61886,
					"tempChar": ""
				},
				{
					"name": "space-shuttle",
					"id": 1547,
					"order": 1980,
					"prevSize": 32,
					"code": 61847,
					"tempChar": ""
				},
				{
					"order": 113,
					"prevSize": 32,
					"ligatures": "spades, cards",
					"name": "spades",
					"id": 1924,
					"code": 60673,
					"tempChar": ""
				},
				{
					"order": 1133,
					"prevSize": 32,
					"ligatures": "spam, notice",
					"name": "spam",
					"id": 2944,
					"code": 62327,
					"tempChar": ""
				},
				{
					"id": 821,
					"order": 3036,
					"prevSize": 32,
					"code": 60204,
					"name": "sparkle",
					"tempChar": ""
				},
				{
					"id": 822,
					"order": 3037,
					"prevSize": 32,
					"code": 60205,
					"name": "sparkle2",
					"tempChar": ""
				},
				{
					"id": 1136,
					"order": 2437,
					"prevSize": 32,
					"code": 60519,
					"name": "sparkle3",
					"tempChar": ""
				},
				{
					"id": 823,
					"order": 3038,
					"prevSize": 32,
					"code": 60206,
					"name": "speak",
					"tempChar": ""
				},
				{
					"id": 824,
					"order": 3039,
					"prevSize": 32,
					"code": 60207,
					"name": "speak2",
					"tempChar": ""
				},
				{
					"id": 1137,
					"order": 2438,
					"prevSize": 32,
					"code": 60520,
					"name": "speak3",
					"tempChar": ""
				},
				{
					"order": 1173,
					"prevSize": 32,
					"ligatures": "speaker-left, volume5",
					"name": "speaker-left",
					"id": 2984,
					"code": 62367,
					"tempChar": ""
				},
				{
					"order": 1174,
					"prevSize": 32,
					"ligatures": "speaker-right, volume6",
					"name": "speaker-right",
					"id": 2985,
					"code": 62368,
					"tempChar": ""
				},
				{
					"order": 88,
					"prevSize": 32,
					"ligatures": "speakers, music10",
					"name": "speakers",
					"id": 1899,
					"code": 60648,
					"tempChar": ""
				},
				{
					"order": 1142,
					"prevSize": 32,
					"ligatures": "spell-check, spelling",
					"name": "spell-check",
					"id": 2953,
					"code": 62336,
					"tempChar": ""
				},
				{
					"order": 1143,
					"prevSize": 32,
					"ligatures": "spell-check2, spelling2",
					"name": "spell-check2",
					"id": 2954,
					"code": 62337,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "spell-check, spelling",
					"order": 3216,
					"name": "spell-check3",
					"id": 151,
					"code": 59448,
					"tempChar": ""
				},
				{
					"order": 915,
					"prevSize": 32,
					"ligatures": "sphere, globe",
					"name": "sphere",
					"id": 2726,
					"code": 61791,
					"tempChar": ""
				},
				{
					"order": 916,
					"prevSize": 32,
					"ligatures": "sphere2, globe2",
					"name": "sphere2",
					"id": 2727,
					"code": 61807,
					"tempChar": ""
				},
				{
					"order": 917,
					"prevSize": 32,
					"ligatures": "sphere3, globe3",
					"name": "sphere3",
					"id": 2728,
					"code": 61823,
					"tempChar": ""
				},
				{
					"id": 825,
					"order": 3040,
					"prevSize": 32,
					"code": 60208,
					"name": "spin",
					"tempChar": ""
				},
				{
					"id": 826,
					"order": 3041,
					"prevSize": 32,
					"code": 60209,
					"name": "spin2",
					"tempChar": ""
				},
				{
					"id": 1138,
					"order": 2439,
					"prevSize": 32,
					"code": 60521,
					"name": "spin3",
					"tempChar": ""
				},
				{
					"order": 548,
					"prevSize": 32,
					"ligatures": "spinner, loading4",
					"name": "spinner",
					"id": 2359,
					"code": 61108,
					"tempChar": ""
				},
				{
					"order": 557,
					"prevSize": 32,
					"ligatures": "spinner10, loading13",
					"name": "spinner10",
					"id": 2368,
					"code": 61117,
					"tempChar": ""
				},
				{
					"order": 558,
					"prevSize": 32,
					"ligatures": "spinner11, loading14",
					"name": "spinner11",
					"id": 2369,
					"code": 61118,
					"tempChar": ""
				},
				{
					"name": "spinner12",
					"id": 1422,
					"order": 1855,
					"prevSize": 32,
					"code": 61712,
					"tempChar": ""
				},
				{
					"order": 549,
					"prevSize": 32,
					"ligatures": "spinner2, loading5",
					"name": "spinner2",
					"id": 2360,
					"code": 61109,
					"tempChar": ""
				},
				{
					"order": 550,
					"prevSize": 32,
					"ligatures": "spinner3, loading6",
					"name": "spinner3",
					"id": 2361,
					"code": 61110,
					"tempChar": ""
				},
				{
					"order": 551,
					"prevSize": 32,
					"ligatures": "spinner4, loading7",
					"name": "spinner4",
					"id": 2362,
					"code": 61111,
					"tempChar": ""
				},
				{
					"order": 552,
					"prevSize": 32,
					"ligatures": "spinner5, loading8",
					"name": "spinner5",
					"id": 2363,
					"code": 61112,
					"tempChar": ""
				},
				{
					"order": 553,
					"prevSize": 32,
					"ligatures": "spinner6, loading9",
					"name": "spinner6",
					"id": 2364,
					"code": 61113,
					"tempChar": ""
				},
				{
					"order": 554,
					"prevSize": 32,
					"ligatures": "spinner7, loading10",
					"name": "spinner7",
					"id": 2365,
					"code": 61114,
					"tempChar": ""
				},
				{
					"order": 555,
					"prevSize": 32,
					"ligatures": "spinner8, loading11",
					"name": "spinner8",
					"id": 2366,
					"code": 61115,
					"tempChar": ""
				},
				{
					"order": 556,
					"prevSize": 32,
					"ligatures": "spinner9, loading12",
					"name": "spinner9",
					"id": 2367,
					"code": 61116,
					"tempChar": ""
				},
				{
					"order": 1205,
					"prevSize": 32,
					"ligatures": "split, arrows",
					"name": "split",
					"id": 3016,
					"code": 62399,
					"tempChar": ""
				},
				{
					"id": 1139,
					"order": 2440,
					"prevSize": 32,
					"code": 60522,
					"name": "spook",
					"tempChar": ""
				},
				{
					"name": "spoon",
					"id": 1571,
					"order": 2004,
					"prevSize": 32,
					"code": 61873,
					"tempChar": ""
				},
				{
					"order": 702,
					"prevSize": 32,
					"ligatures": "spoon-knife, food2",
					"name": "spoon-knife",
					"id": 2513,
					"code": 61262,
					"tempChar": ""
				},
				{
					"order": 1525,
					"prevSize": 32,
					"name": "spotify",
					"ligatures": "spotify, brand14",
					"id": 3336,
					"code": 62719,
					"tempChar": ""
				},
				{
					"name": "spotify2",
					"id": 1582,
					"order": 2015,
					"prevSize": 32,
					"code": 61884,
					"tempChar": ""
				},
				{
					"order": 759,
					"prevSize": 32,
					"ligatures": "spotlight, light4",
					"name": "spotlight",
					"id": 2570,
					"code": 61319,
					"tempChar": ""
				},
				{
					"order": 957,
					"prevSize": 32,
					"ligatures": "spotlight2, featured",
					"name": "spotlight2",
					"id": 2768,
					"code": 62151,
					"tempChar": ""
				},
				{
					"order": 43,
					"prevSize": 32,
					"ligatures": "spray, paint2",
					"name": "spray",
					"id": 1854,
					"code": 60603,
					"tempChar": ""
				},
				{
					"id": 827,
					"order": 3042,
					"prevSize": 32,
					"code": 60210,
					"name": "sprout",
					"tempChar": ""
				},
				{
					"id": 828,
					"order": 3043,
					"prevSize": 32,
					"code": 60211,
					"name": "sprout2",
					"tempChar": ""
				},
				{
					"id": 829,
					"order": 3044,
					"prevSize": 32,
					"code": 60212,
					"name": "spy",
					"tempChar": ""
				},
				{
					"id": 830,
					"order": 3045,
					"prevSize": 32,
					"code": 60213,
					"name": "spy2",
					"tempChar": ""
				},
				{
					"order": 1387,
					"prevSize": 32,
					"ligatures": "square",
					"name": "square",
					"id": 3198,
					"code": 62581,
					"tempChar": ""
				},
				{
					"order": 1290,
					"prevSize": 32,
					"ligatures": "square-down, down13",
					"name": "square-down",
					"id": 3101,
					"code": 62484,
					"tempChar": ""
				},
				{
					"order": 1291,
					"prevSize": 32,
					"ligatures": "square-down-left, down-left6",
					"name": "square-down-left",
					"id": 3102,
					"code": 62485,
					"tempChar": ""
				},
				{
					"order": 1289,
					"prevSize": 32,
					"ligatures": "square-down-right, down-right6",
					"name": "square-down-right",
					"id": 3100,
					"code": 62483,
					"tempChar": ""
				},
				{
					"order": 1292,
					"prevSize": 32,
					"ligatures": "square-left, left16",
					"name": "square-left",
					"id": 3103,
					"code": 62486,
					"tempChar": ""
				},
				{
					"name": "square-o",
					"id": 1320,
					"order": 1753,
					"prevSize": 32,
					"code": 61590,
					"tempChar": ""
				},
				{
					"order": 1288,
					"prevSize": 32,
					"ligatures": "square-right, right15",
					"name": "square-right",
					"id": 3099,
					"code": 62482,
					"tempChar": ""
				},
				{
					"order": 1286,
					"prevSize": 32,
					"ligatures": "square-up, up13",
					"name": "square-up",
					"id": 3097,
					"code": 62480,
					"tempChar": ""
				},
				{
					"order": 1285,
					"prevSize": 32,
					"ligatures": "square-up-left, up-left6",
					"name": "square-up-left",
					"id": 3096,
					"code": 62479,
					"tempChar": ""
				},
				{
					"order": 1287,
					"prevSize": 32,
					"ligatures": "square-up-right, up-right6",
					"name": "square-up-right",
					"id": 3098,
					"code": 62481,
					"tempChar": ""
				},
				{
					"name": "square2",
					"id": 1355,
					"order": 1788,
					"prevSize": 32,
					"code": 61640,
					"tempChar": ""
				},
				{
					"id": 831,
					"order": 3046,
					"prevSize": 32,
					"code": 60214,
					"name": "squirt",
					"tempChar": ""
				},
				{
					"id": 832,
					"order": 3047,
					"prevSize": 32,
					"code": 60215,
					"name": "squirt2",
					"tempChar": ""
				},
				{
					"order": 207,
					"prevSize": 32,
					"ligatures": "stack, files3",
					"name": "stack",
					"id": 2018,
					"code": 60767,
					"tempChar": ""
				},
				{
					"order": 1092,
					"prevSize": 32,
					"ligatures": "stack-cancel, files11",
					"name": "stack-cancel",
					"id": 2903,
					"code": 62286,
					"tempChar": ""
				},
				{
					"order": 1093,
					"prevSize": 32,
					"ligatures": "stack-check, files12",
					"name": "stack-check",
					"id": 2904,
					"code": 62287,
					"tempChar": ""
				},
				{
					"order": 1095,
					"prevSize": 32,
					"ligatures": "stack-clubs, files14",
					"name": "stack-clubs",
					"id": 2906,
					"code": 62289,
					"tempChar": ""
				},
				{
					"order": 1098,
					"prevSize": 32,
					"ligatures": "stack-diamonds, files17",
					"name": "stack-diamonds",
					"id": 2909,
					"code": 62292,
					"tempChar": ""
				},
				{
					"order": 1090,
					"prevSize": 32,
					"ligatures": "stack-down, files9",
					"name": "stack-down",
					"id": 2901,
					"code": 62284,
					"tempChar": ""
				},
				{
					"order": 1085,
					"prevSize": 32,
					"ligatures": "stack-empty, files4",
					"name": "stack-empty",
					"id": 2896,
					"code": 62279,
					"tempChar": ""
				},
				{
					"name": "stack-exchange",
					"id": 1538,
					"order": 1971,
					"prevSize": 32,
					"code": 61837,
					"tempChar": ""
				},
				{
					"order": 1097,
					"prevSize": 32,
					"ligatures": "stack-hearts, files16",
					"name": "stack-hearts",
					"id": 2908,
					"code": 62291,
					"tempChar": ""
				},
				{
					"order": 1087,
					"prevSize": 32,
					"ligatures": "stack-minus, files6",
					"name": "stack-minus",
					"id": 2898,
					"code": 62281,
					"tempChar": ""
				},
				{
					"order": 1101,
					"prevSize": 32,
					"ligatures": "stack-music, files20",
					"name": "stack-music",
					"id": 2912,
					"code": 62295,
					"tempChar": ""
				},
				{
					"name": "stack-overflow",
					"id": 1507,
					"order": 1940,
					"prevSize": 32,
					"code": 61804,
					"tempChar": ""
				},
				{
					"order": 1089,
					"prevSize": 32,
					"ligatures": "stack-picture, files8",
					"name": "stack-picture",
					"id": 2900,
					"code": 62283,
					"tempChar": ""
				},
				{
					"order": 1102,
					"prevSize": 32,
					"ligatures": "stack-play, files21",
					"name": "stack-play",
					"id": 2913,
					"code": 62296,
					"tempChar": ""
				},
				{
					"order": 1086,
					"prevSize": 32,
					"ligatures": "stack-plus, files5",
					"name": "stack-plus",
					"id": 2897,
					"code": 62280,
					"tempChar": ""
				},
				{
					"order": 1096,
					"prevSize": 32,
					"ligatures": "stack-spades, files15",
					"name": "stack-spades",
					"id": 2907,
					"code": 62290,
					"tempChar": ""
				},
				{
					"order": 1088,
					"prevSize": 32,
					"ligatures": "stack-star, files7",
					"name": "stack-star",
					"id": 2899,
					"code": 62282,
					"tempChar": ""
				},
				{
					"order": 1094,
					"prevSize": 32,
					"ligatures": "stack-text, files13",
					"name": "stack-text",
					"id": 2905,
					"code": 62288,
					"tempChar": ""
				},
				{
					"order": 1091,
					"prevSize": 32,
					"ligatures": "stack-up, files10",
					"name": "stack-up",
					"id": 2902,
					"code": 62285,
					"tempChar": ""
				},
				{
					"order": 1099,
					"prevSize": 32,
					"ligatures": "stack-user, files18",
					"name": "stack-user",
					"id": 2910,
					"code": 62293,
					"tempChar": ""
				},
				{
					"order": 208,
					"prevSize": 32,
					"ligatures": "stack2, layers",
					"name": "stack2",
					"id": 2019,
					"code": 60768,
					"tempChar": ""
				},
				{
					"order": 209,
					"prevSize": 32,
					"ligatures": "stack3, layers2",
					"name": "stack3",
					"id": 2020,
					"code": 60769,
					"tempChar": ""
				},
				{
					"order": 1100,
					"prevSize": 32,
					"ligatures": "stack4, files19",
					"name": "stack4",
					"id": 2911,
					"code": 62294,
					"tempChar": ""
				},
				{
					"id": 833,
					"order": 3048,
					"prevSize": 32,
					"code": 60216,
					"name": "stack5",
					"tempChar": ""
				},
				{
					"id": 834,
					"order": 3049,
					"prevSize": 32,
					"code": 60217,
					"name": "stack6",
					"tempChar": ""
				},
				{
					"id": 1140,
					"order": 2441,
					"prevSize": 32,
					"code": 60523,
					"name": "stack7",
					"tempChar": ""
				},
				{
					"order": 1585,
					"prevSize": 32,
					"ligatures": "stackoverflow, brand71",
					"name": "stackoverflow",
					"id": 3396,
					"code": 62779,
					"tempChar": ""
				},
				{
					"order": 664,
					"prevSize": 32,
					"ligatures": "stairs, steps",
					"name": "stairs",
					"id": 2475,
					"code": 61224,
					"tempChar": ""
				},
				{
					"order": 663,
					"prevSize": 32,
					"ligatures": "stairs-down, descend",
					"name": "stairs-down",
					"id": 2474,
					"code": 61223,
					"tempChar": ""
				},
				{
					"order": 662,
					"prevSize": 32,
					"ligatures": "stairs-up, ascend",
					"name": "stairs-up",
					"id": 2473,
					"code": 61222,
					"tempChar": ""
				},
				{
					"order": 665,
					"prevSize": 32,
					"ligatures": "stairs2, steps2",
					"name": "stairs2",
					"id": 2476,
					"code": 61225,
					"tempChar": ""
				},
				{
					"order": 59,
					"prevSize": 32,
					"ligatures": "stamp, pattern",
					"name": "stamp",
					"id": 1870,
					"code": 60619,
					"tempChar": ""
				},
				{
					"id": 835,
					"order": 3050,
					"prevSize": 32,
					"code": 60218,
					"name": "stamp2",
					"tempChar": ""
				},
				{
					"id": 836,
					"order": 3051,
					"prevSize": 32,
					"code": 60219,
					"name": "stamp3",
					"tempChar": ""
				},
				{
					"id": 1141,
					"order": 2442,
					"prevSize": 32,
					"code": 60524,
					"name": "stamp4",
					"tempChar": ""
				},
				{
					"id": 837,
					"order": 3052,
					"prevSize": 32,
					"code": 60220,
					"name": "stand",
					"tempChar": ""
				},
				{
					"id": 838,
					"order": 3053,
					"prevSize": 32,
					"code": 60221,
					"name": "stand2",
					"tempChar": ""
				},
				{
					"order": 1000,
					"prevSize": 32,
					"ligatures": "star, rate7",
					"name": "star",
					"id": 2811,
					"code": 62194,
					"tempChar": ""
				},
				{
					"order": 994,
					"prevSize": 32,
					"ligatures": "star-empty, rate",
					"name": "star-empty",
					"id": 2805,
					"code": 62188,
					"tempChar": ""
				},
				{
					"order": 995,
					"prevSize": 32,
					"ligatures": "star-empty2, rate2",
					"name": "star-empty2",
					"id": 2806,
					"code": 62189,
					"tempChar": ""
				},
				{
					"order": 997,
					"prevSize": 32,
					"ligatures": "star-empty3, rate4",
					"name": "star-empty3",
					"id": 2808,
					"code": 62191,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "star-empty, rating3",
					"order": 3182,
					"name": "star-empty4",
					"id": 117,
					"code": 59414,
					"tempChar": ""
				},
				{
					"order": 996,
					"prevSize": 32,
					"ligatures": "star-full, rate3",
					"name": "star-full",
					"id": 2807,
					"code": 62190,
					"tempChar": ""
				},
				{
					"order": 999,
					"prevSize": 32,
					"ligatures": "star-full2, rate6",
					"name": "star-full2",
					"id": 2810,
					"code": 62193,
					"tempChar": ""
				},
				{
					"order": 998,
					"prevSize": 32,
					"ligatures": "star-half, rate5",
					"name": "star-half",
					"id": 2809,
					"code": 62192,
					"tempChar": ""
				},
				{
					"name": "star-half-empty, star-half-full, star-half-o",
					"id": 1438,
					"order": 1871,
					"prevSize": 32,
					"code": 61731,
					"tempChar": ""
				},
				{
					"name": "star-half2",
					"id": 1308,
					"order": 1741,
					"prevSize": 32,
					"code": 61577,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "star-half, rating2",
					"order": 3181,
					"name": "star-half3",
					"id": 116,
					"code": 59413,
					"tempChar": ""
				},
				{
					"name": "star-o",
					"id": 1185,
					"order": 1618,
					"prevSize": 32,
					"code": 61446,
					"tempChar": ""
				},
				{
					"name": "star2",
					"id": 1184,
					"order": 1617,
					"prevSize": 32,
					"code": 61445,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "star, rating",
					"order": 3180,
					"name": "star3",
					"id": 115,
					"code": 59412,
					"tempChar": ""
				},
				{
					"order": 958,
					"prevSize": 32,
					"ligatures": "starburst",
					"name": "starburst",
					"id": 2769,
					"code": 62152,
					"tempChar": ""
				},
				{
					"order": 672,
					"prevSize": 32,
					"ligatures": "stars",
					"name": "stars",
					"id": 2483,
					"code": 61232,
					"tempChar": ""
				},
				{
					"id": 839,
					"order": 3054,
					"prevSize": 32,
					"code": 60222,
					"name": "start",
					"tempChar": ""
				},
				{
					"id": 840,
					"order": 3055,
					"prevSize": 32,
					"code": 60223,
					"name": "start2",
					"tempChar": ""
				},
				{
					"order": 131,
					"prevSize": 32,
					"ligatures": "station, radio",
					"name": "station",
					"id": 1942,
					"code": 60691,
					"tempChar": ""
				},
				{
					"order": 132,
					"prevSize": 32,
					"ligatures": "station2, radio2",
					"name": "station2",
					"id": 1943,
					"code": 60692,
					"tempChar": ""
				},
				{
					"order": 650,
					"prevSize": 32,
					"ligatures": "stats-bars, stats9",
					"name": "stats-bars",
					"id": 2461,
					"code": 61210,
					"tempChar": ""
				},
				{
					"order": 652,
					"prevSize": 32,
					"ligatures": "stats-bars2, stats11",
					"name": "stats-bars2",
					"id": 2463,
					"code": 61212,
					"tempChar": ""
				},
				{
					"order": 653,
					"prevSize": 32,
					"ligatures": "stats-bars3, stats12",
					"name": "stats-bars3",
					"id": 2464,
					"code": 61213,
					"tempChar": ""
				},
				{
					"order": 654,
					"prevSize": 32,
					"ligatures": "stats-bars4, stats13",
					"name": "stats-bars4",
					"id": 2465,
					"code": 61214,
					"tempChar": ""
				},
				{
					"order": 655,
					"prevSize": 32,
					"ligatures": "stats-bars5, stats14",
					"name": "stats-bars5",
					"id": 2466,
					"code": 61215,
					"tempChar": ""
				},
				{
					"order": 656,
					"prevSize": 32,
					"ligatures": "stats-bars6, stats15",
					"name": "stats-bars6",
					"id": 2467,
					"code": 61216,
					"tempChar": ""
				},
				{
					"order": 659,
					"prevSize": 32,
					"ligatures": "stats-decline, stats18",
					"name": "stats-decline",
					"id": 2470,
					"code": 61219,
					"tempChar": ""
				},
				{
					"order": 661,
					"prevSize": 32,
					"ligatures": "stats-decline2, stats20",
					"name": "stats-decline2",
					"id": 2472,
					"code": 61221,
					"tempChar": ""
				},
				{
					"order": 649,
					"prevSize": 32,
					"ligatures": "stats-dots, stats8",
					"name": "stats-dots",
					"id": 2460,
					"code": 61209,
					"tempChar": ""
				},
				{
					"order": 658,
					"prevSize": 32,
					"ligatures": "stats-growth, stats17",
					"name": "stats-growth",
					"id": 2469,
					"code": 61218,
					"tempChar": ""
				},
				{
					"order": 660,
					"prevSize": 32,
					"ligatures": "stats-growth2, stats19",
					"name": "stats-growth2",
					"id": 2471,
					"code": 61220,
					"tempChar": ""
				},
				{
					"order": 705,
					"prevSize": 32,
					"ligatures": "steak, food4",
					"name": "steak",
					"id": 2516,
					"code": 61265,
					"tempChar": ""
				},
				{
					"order": 1549,
					"prevSize": 32,
					"ligatures": "steam, brand36",
					"name": "steam",
					"id": 3360,
					"code": 62743,
					"tempChar": ""
				},
				{
					"name": "steam-square",
					"id": 1577,
					"order": 2010,
					"prevSize": 32,
					"code": 61879,
					"tempChar": ""
				},
				{
					"order": 1550,
					"prevSize": 32,
					"ligatures": "steam2, brand37",
					"name": "steam2",
					"id": 3361,
					"code": 62744,
					"tempChar": ""
				},
				{
					"name": "steam3",
					"id": 1576,
					"order": 2009,
					"prevSize": 32,
					"code": 61878,
					"tempChar": ""
				},
				{
					"id": 841,
					"order": 3056,
					"prevSize": 32,
					"code": 60224,
					"name": "steer",
					"tempChar": ""
				},
				{
					"id": 842,
					"order": 3057,
					"prevSize": 32,
					"code": 60225,
					"name": "steer2",
					"tempChar": ""
				},
				{
					"order": 781,
					"prevSize": 32,
					"ligatures": "steering-wheel, drive2",
					"name": "steering-wheel",
					"id": 2592,
					"code": 61341,
					"tempChar": ""
				},
				{
					"name": "step-backward",
					"id": 1247,
					"order": 1680,
					"prevSize": 32,
					"code": 61512,
					"tempChar": ""
				},
				{
					"name": "step-forward",
					"id": 1255,
					"order": 1688,
					"prevSize": 32,
					"code": 61521,
					"tempChar": ""
				},
				{
					"order": 629,
					"prevSize": 32,
					"ligatures": "stethoscope, health5",
					"name": "stethoscope",
					"id": 2440,
					"code": 61189,
					"tempChar": ""
				},
				{
					"name": "stethoscope2",
					"id": 1393,
					"order": 1826,
					"prevSize": 32,
					"code": 61681,
					"tempChar": ""
				},
				{
					"id": 843,
					"order": 3058,
					"prevSize": 32,
					"code": 60226,
					"name": "stick",
					"tempChar": ""
				},
				{
					"id": 844,
					"order": 3059,
					"prevSize": 32,
					"code": 60227,
					"name": "stick2",
					"tempChar": ""
				},
				{
					"name": "sticky-note",
					"id": 1712,
					"order": 2145,
					"prevSize": 32,
					"code": 62025,
					"tempChar": ""
				},
				{
					"name": "sticky-note-o",
					"id": 1713,
					"order": 2146,
					"prevSize": 32,
					"code": 62026,
					"tempChar": ""
				},
				{
					"id": 845,
					"order": 3060,
					"prevSize": 32,
					"code": 60228,
					"name": "stitch",
					"tempChar": ""
				},
				{
					"id": 846,
					"order": 3061,
					"prevSize": 32,
					"code": 60229,
					"name": "stitch2",
					"tempChar": ""
				},
				{
					"id": 1142,
					"order": 2443,
					"prevSize": 32,
					"code": 60525,
					"name": "stitch3",
					"tempChar": ""
				},
				{
					"order": 1154,
					"prevSize": 32,
					"ligatures": "stop, player3",
					"name": "stop",
					"id": 2965,
					"code": 62348,
					"tempChar": ""
				},
				{
					"name": "stop-circle",
					"id": 1776,
					"order": 2209,
					"prevSize": 32,
					"code": 62093,
					"tempChar": ""
				},
				{
					"name": "stop-circle-o",
					"id": 1777,
					"order": 2210,
					"prevSize": 32,
					"code": 62094,
					"tempChar": ""
				},
				{
					"order": 1161,
					"prevSize": 32,
					"ligatures": "stop2, player10",
					"name": "stop2",
					"id": 2972,
					"code": 62355,
					"tempChar": ""
				},
				{
					"name": "stop3",
					"id": 1252,
					"order": 1685,
					"prevSize": 32,
					"code": 61517,
					"tempChar": ""
				},
				{
					"id": 847,
					"order": 3062,
					"prevSize": 32,
					"code": 60230,
					"name": "stop4",
					"tempChar": ""
				},
				{
					"id": 848,
					"order": 3063,
					"prevSize": 32,
					"code": 60231,
					"name": "stop5",
					"tempChar": ""
				},
				{
					"id": 1143,
					"order": 2444,
					"prevSize": 32,
					"code": 60526,
					"name": "stop6",
					"tempChar": ""
				},
				{
					"order": 352,
					"prevSize": 32,
					"ligatures": "stopwatch, time9",
					"name": "stopwatch",
					"id": 2163,
					"code": 60912,
					"tempChar": ""
				},
				{
					"order": 254,
					"prevSize": 32,
					"ligatures": "store, shop",
					"name": "store",
					"id": 2065,
					"code": 60814,
					"tempChar": ""
				},
				{
					"order": 255,
					"prevSize": 32,
					"ligatures": "store2, shop2",
					"name": "store2",
					"id": 2066,
					"code": 60815,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "store, shop",
					"order": 3205,
					"name": "store3",
					"id": 140,
					"code": 59437,
					"tempChar": ""
				},
				{
					"id": 849,
					"order": 3064,
					"prevSize": 32,
					"code": 60232,
					"name": "store4",
					"tempChar": ""
				},
				{
					"id": 850,
					"order": 3065,
					"prevSize": 32,
					"code": 60233,
					"name": "store5",
					"tempChar": ""
				},
				{
					"id": 1144,
					"order": 2445,
					"prevSize": 32,
					"code": 60527,
					"name": "store6",
					"tempChar": ""
				},
				{
					"id": 851,
					"order": 3066,
					"prevSize": 32,
					"code": 60234,
					"name": "stow",
					"tempChar": ""
				},
				{
					"id": 852,
					"order": 3067,
					"prevSize": 32,
					"code": 60235,
					"name": "stow2",
					"tempChar": ""
				},
				{
					"id": 853,
					"order": 3068,
					"prevSize": 32,
					"code": 60236,
					"name": "strain",
					"tempChar": ""
				},
				{
					"id": 854,
					"order": 3069,
					"prevSize": 32,
					"code": 60237,
					"name": "strain2",
					"tempChar": ""
				},
				{
					"id": 1145,
					"order": 2446,
					"prevSize": 32,
					"code": 60528,
					"name": "strain3",
					"tempChar": ""
				},
				{
					"order": 812,
					"prevSize": 32,
					"ligatures": "strategy, plan",
					"name": "strategy",
					"id": 2623,
					"code": 61372,
					"tempChar": ""
				},
				{
					"name": "street-view",
					"id": 1673,
					"order": 2106,
					"prevSize": 32,
					"code": 61981,
					"tempChar": ""
				},
				{
					"order": 1436,
					"prevSize": 32,
					"ligatures": "strikethrough, wysiwyg8",
					"name": "strikethrough",
					"id": 3247,
					"code": 62630,
					"tempChar": ""
				},
				{
					"order": 1437,
					"prevSize": 32,
					"ligatures": "strikethrough2, wysiwyg9",
					"name": "strikethrough2",
					"id": 3248,
					"code": 62631,
					"tempChar": ""
				},
				{
					"order": 1442,
					"prevSize": 32,
					"ligatures": "strikethrough3, wysiwyg14",
					"name": "strikethrough3",
					"id": 3253,
					"code": 62636,
					"tempChar": ""
				},
				{
					"name": "strikethrough4",
					"id": 1359,
					"order": 1792,
					"prevSize": 32,
					"code": 61644,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "strikethrough, typography7",
					"order": 3310,
					"name": "strikethrough5",
					"id": 245,
					"code": 59542,
					"tempChar": ""
				},
				{
					"id": 855,
					"order": 3070,
					"prevSize": 32,
					"code": 60238,
					"name": "strum",
					"tempChar": ""
				},
				{
					"id": 856,
					"order": 3071,
					"prevSize": 32,
					"code": 60239,
					"name": "strum2",
					"tempChar": ""
				},
				{
					"id": 857,
					"order": 3072,
					"prevSize": 32,
					"code": 60240,
					"name": "study",
					"tempChar": ""
				},
				{
					"id": 858,
					"order": 3073,
					"prevSize": 32,
					"code": 60241,
					"name": "study2",
					"tempChar": ""
				},
				{
					"id": 1146,
					"order": 2447,
					"prevSize": 32,
					"code": 60529,
					"name": "study3",
					"tempChar": ""
				},
				{
					"id": 859,
					"order": 3074,
					"prevSize": 32,
					"code": 60242,
					"name": "stuff",
					"tempChar": ""
				},
				{
					"id": 860,
					"order": 3075,
					"prevSize": 32,
					"code": 60243,
					"name": "stuff2",
					"tempChar": ""
				},
				{
					"order": 1583,
					"name": "stumbleupon",
					"prevSize": 32,
					"ligatures": "stumbleupon, brand69",
					"id": 3394,
					"code": 62777,
					"tempChar": ""
				},
				{
					"name": "stumbleupon-circle",
					"id": 1558,
					"order": 1991,
					"prevSize": 32,
					"code": 61859,
					"tempChar": ""
				},
				{
					"order": 1584,
					"prevSize": 32,
					"ligatures": "stumbleupon2, brand70",
					"name": "stumbleupon2",
					"id": 3395,
					"code": 62778,
					"tempChar": ""
				},
				{
					"name": "stumbleupon3",
					"id": 1559,
					"order": 1992,
					"prevSize": 32,
					"code": 61860,
					"tempChar": ""
				},
				{
					"id": 861,
					"order": 3076,
					"prevSize": 32,
					"code": 60244,
					"name": "submerge",
					"tempChar": ""
				},
				{
					"id": 862,
					"order": 3077,
					"prevSize": 32,
					"code": 60245,
					"name": "submerge2",
					"tempChar": ""
				},
				{
					"id": 1147,
					"order": 2448,
					"prevSize": 32,
					"code": 60530,
					"name": "submerge3",
					"tempChar": ""
				},
				{
					"order": 1449,
					"prevSize": 32,
					"ligatures": "subscript, wysiwyg21",
					"name": "subscript",
					"id": 3260,
					"code": 62643,
					"tempChar": ""
				},
				{
					"order": 1451,
					"prevSize": 32,
					"ligatures": "subscript2, wysiwyg23",
					"name": "subscript2",
					"id": 3262,
					"code": 62645,
					"tempChar": ""
				},
				{
					"name": "subscript3",
					"id": 1447,
					"order": 1880,
					"prevSize": 32,
					"code": 61740,
					"tempChar": ""
				},
				{
					"order": 440,
					"prevSize": 32,
					"ligatures": "subtract, boolean-operation2",
					"name": "subtract",
					"id": 2251,
					"code": 61000,
					"tempChar": ""
				},
				{
					"id": 1148,
					"order": 2449,
					"prevSize": 32,
					"code": 60531,
					"name": "subtract2",
					"tempChar": ""
				},
				{
					"name": "subway",
					"id": 1697,
					"order": 2130,
					"prevSize": 32,
					"code": 62009,
					"tempChar": ""
				},
				{
					"id": 863,
					"order": 3078,
					"prevSize": 32,
					"code": 60246,
					"name": "succeed",
					"tempChar": ""
				},
				{
					"id": 864,
					"order": 3079,
					"prevSize": 32,
					"code": 60247,
					"name": "succeed2",
					"tempChar": ""
				},
				{
					"id": 1149,
					"order": 2450,
					"prevSize": 32,
					"code": 60532,
					"name": "succeed3",
					"tempChar": ""
				},
				{
					"id": 865,
					"order": 3080,
					"prevSize": 32,
					"code": 60248,
					"name": "suck",
					"tempChar": ""
				},
				{
					"id": 866,
					"order": 3081,
					"prevSize": 32,
					"code": 60249,
					"name": "suck2",
					"tempChar": ""
				},
				{
					"name": "suitcase",
					"id": 1394,
					"order": 1827,
					"prevSize": 32,
					"code": 61682,
					"tempChar": ""
				},
				{
					"order": 976,
					"prevSize": 32,
					"ligatures": "sun, weather20",
					"name": "sun",
					"id": 2787,
					"code": 62170,
					"tempChar": ""
				},
				{
					"name": "sun-o",
					"id": 1530,
					"order": 1963,
					"prevSize": 32,
					"code": 61829,
					"tempChar": ""
				},
				{
					"order": 977,
					"prevSize": 32,
					"ligatures": "sun2, weather21",
					"name": "sun2",
					"id": 2788,
					"code": 62171,
					"tempChar": ""
				},
				{
					"order": 984,
					"prevSize": 32,
					"ligatures": "sun3, brightness",
					"name": "sun3",
					"id": 2795,
					"code": 62178,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "sun, brightness",
					"order": 3167,
					"name": "sun4",
					"id": 102,
					"code": 59399,
					"tempChar": ""
				},
				{
					"order": 1448,
					"prevSize": 32,
					"ligatures": "superscript, wysiwyg20",
					"name": "superscript",
					"id": 3259,
					"code": 62642,
					"tempChar": ""
				},
				{
					"order": 1450,
					"prevSize": 32,
					"ligatures": "superscript2, wysiwyg22",
					"name": "superscript2",
					"id": 3261,
					"code": 62644,
					"tempChar": ""
				},
				{
					"name": "superscript3",
					"id": 1446,
					"order": 1879,
					"prevSize": 32,
					"code": 61739,
					"tempChar": ""
				},
				{
					"id": 1150,
					"order": 2451,
					"prevSize": 32,
					"code": 60533,
					"name": "support2",
					"tempChar": ""
				},
				{
					"order": 1610,
					"prevSize": 32,
					"ligatures": "svg",
					"name": "svg",
					"id": 3421,
					"code": 62804,
					"tempChar": ""
				},
				{
					"id": 867,
					"order": 3082,
					"prevSize": 32,
					"code": 60250,
					"name": "swim",
					"tempChar": ""
				},
				{
					"id": 868,
					"order": 3083,
					"prevSize": 32,
					"code": 60251,
					"name": "swim2",
					"tempChar": ""
				},
				{
					"id": 1151,
					"order": 2452,
					"prevSize": 32,
					"code": 60534,
					"name": "swim3",
					"tempChar": ""
				},
				{
					"order": 845,
					"prevSize": 32,
					"ligatures": "switch2",
					"name": "switch",
					"id": 2656,
					"code": 61405,
					"tempChar": ""
				},
				{
					"order": 846,
					"prevSize": 32,
					"ligatures": "switch3",
					"name": "switch2",
					"id": 2657,
					"code": 61406,
					"tempChar": ""
				},
				{
					"id": 869,
					"order": 3084,
					"prevSize": 32,
					"code": 60252,
					"name": "switch3",
					"tempChar": ""
				},
				{
					"id": 870,
					"order": 3085,
					"prevSize": 32,
					"code": 60253,
					"name": "switch4",
					"tempChar": ""
				},
				{
					"id": 1152,
					"order": 2453,
					"prevSize": 32,
					"code": 60535,
					"name": "switch5",
					"tempChar": ""
				},
				{
					"order": 829,
					"prevSize": 32,
					"ligatures": "sword, weapon2",
					"name": "sword",
					"id": 2640,
					"code": 61389,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "sync, spinner",
					"order": 3258,
					"name": "sync",
					"id": 193,
					"code": 59490,
					"tempChar": ""
				},
				{
					"id": 871,
					"order": 3086,
					"prevSize": 32,
					"code": 60254,
					"name": "sync2",
					"tempChar": ""
				},
				{
					"id": 872,
					"order": 3087,
					"prevSize": 32,
					"code": 60255,
					"name": "sync3",
					"tempChar": ""
				},
				{
					"id": 1153,
					"order": 2454,
					"prevSize": 32,
					"code": 60536,
					"name": "sync4",
					"tempChar": ""
				},
				{
					"order": 636,
					"prevSize": 32,
					"ligatures": "syringe, health9",
					"name": "syringe",
					"id": 2447,
					"code": 61196,
					"tempChar": ""
				},
				{
					"order": 637,
					"prevSize": 32,
					"ligatures": "syringe2, health10",
					"name": "syringe2",
					"id": 2448,
					"code": 61197,
					"tempChar": ""
				},
				{
					"order": 1351,
					"prevSize": 32,
					"ligatures": "tab, arrows7",
					"name": "tab",
					"id": 3162,
					"code": 62545,
					"tempChar": ""
				},
				{
					"order": 1456,
					"prevSize": 32,
					"ligatures": "table, wysiwyg28",
					"name": "table",
					"id": 3267,
					"code": 62650,
					"tempChar": ""
				},
				{
					"order": 1457,
					"prevSize": 32,
					"ligatures": "table2, wysiwyg29",
					"name": "table2",
					"id": 3268,
					"code": 62651,
					"tempChar": ""
				},
				{
					"name": "table3",
					"id": 1361,
					"order": 1794,
					"prevSize": 32,
					"code": 61646,
					"tempChar": ""
				},
				{
					"order": 380,
					"prevSize": 32,
					"ligatures": "tablet, mobile3",
					"name": "tablet",
					"id": 2191,
					"code": 60940,
					"tempChar": ""
				},
				{
					"name": "tablet2",
					"id": 1417,
					"order": 1850,
					"prevSize": 32,
					"code": 61706,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "tablet, mobile2",
					"order": 3219,
					"name": "tablet3",
					"id": 154,
					"code": 59451,
					"tempChar": ""
				},
				{
					"name": "tag",
					"id": 1219,
					"order": 1652,
					"prevSize": 32,
					"code": 61483,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "tag, price",
					"order": 3207,
					"name": "tag2",
					"id": 142,
					"code": 59439,
					"tempChar": ""
				},
				{
					"id": 873,
					"order": 3088,
					"prevSize": 32,
					"code": 60256,
					"name": "tag3",
					"tempChar": ""
				},
				{
					"id": 874,
					"order": 3089,
					"prevSize": 32,
					"code": 60257,
					"name": "tag4",
					"tempChar": ""
				},
				{
					"id": 1154,
					"order": 2455,
					"prevSize": 32,
					"code": 60537,
					"name": "tag5",
					"tempChar": ""
				},
				{
					"name": "tags",
					"id": 1220,
					"order": 1653,
					"prevSize": 32,
					"code": 61484,
					"tempChar": ""
				},
				{
					"order": 84,
					"prevSize": 32,
					"ligatures": "tape2",
					"name": "tape",
					"id": 1895,
					"code": 60644,
					"tempChar": ""
				},
				{
					"id": 875,
					"order": 3090,
					"prevSize": 32,
					"code": 60258,
					"name": "tape2",
					"tempChar": ""
				},
				{
					"id": 876,
					"order": 3091,
					"prevSize": 32,
					"code": 60259,
					"name": "tape3",
					"tempChar": ""
				},
				{
					"order": 813,
					"prevSize": 32,
					"ligatures": "target, goal",
					"name": "target",
					"id": 2624,
					"code": 61373,
					"tempChar": ""
				},
				{
					"order": 814,
					"prevSize": 32,
					"ligatures": "target2, goal2",
					"name": "target2",
					"id": 2625,
					"code": 61374,
					"tempChar": ""
				},
				{
					"order": 815,
					"prevSize": 32,
					"ligatures": "target3, goal3",
					"name": "target3",
					"id": 2626,
					"code": 61375,
					"tempChar": ""
				},
				{
					"id": 877,
					"order": 3092,
					"prevSize": 32,
					"code": 60260,
					"name": "target4",
					"tempChar": ""
				},
				{
					"id": 878,
					"order": 3093,
					"prevSize": 32,
					"code": 60261,
					"name": "target5",
					"tempChar": ""
				},
				{
					"id": 1155,
					"order": 2456,
					"prevSize": 32,
					"code": 60538,
					"name": "target6",
					"tempChar": ""
				},
				{
					"name": "tasks",
					"id": 1343,
					"order": 1776,
					"prevSize": 32,
					"code": 61614,
					"tempChar": ""
				},
				{
					"id": 879,
					"order": 3094,
					"prevSize": 32,
					"code": 60262,
					"name": "teach",
					"tempChar": ""
				},
				{
					"id": 880,
					"order": 3095,
					"prevSize": 32,
					"code": 60263,
					"name": "teach2",
					"tempChar": ""
				},
				{
					"order": 718,
					"prevSize": 32,
					"ligatures": "teapot, drink14",
					"name": "teapot",
					"id": 2529,
					"code": 61278,
					"tempChar": ""
				},
				{
					"order": 1526,
					"prevSize": 32,
					"name": "telegram",
					"ligatures": "telegram, brand15",
					"id": 3337,
					"code": 62720,
					"tempChar": ""
				},
				{
					"name": "television, tv2",
					"id": 1745,
					"order": 2178,
					"prevSize": 32,
					"code": 62060,
					"tempChar": ""
				},
				{
					"order": 960,
					"prevSize": 32,
					"ligatures": "temperature, weather4",
					"name": "temperature",
					"id": 2771,
					"code": 62154,
					"tempChar": ""
				},
				{
					"order": 961,
					"prevSize": 32,
					"ligatures": "temperature2, weather5",
					"name": "temperature2",
					"id": 2772,
					"code": 62155,
					"tempChar": ""
				},
				{
					"name": "tencent-weibo",
					"id": 1605,
					"order": 2038,
					"prevSize": 32,
					"code": 61909,
					"tempChar": ""
				},
				{
					"order": 830,
					"prevSize": 32,
					"ligatures": "tennis, sports2",
					"name": "tennis",
					"id": 2641,
					"code": 61390,
					"tempChar": ""
				},
				{
					"order": 732,
					"prevSize": 32,
					"ligatures": "tent, camping",
					"name": "tent",
					"id": 2543,
					"code": 61292,
					"tempChar": ""
				},
				{
					"order": 1494,
					"prevSize": 32,
					"ligatures": "terminal, console",
					"name": "terminal",
					"id": 3305,
					"code": 62688,
					"tempChar": ""
				},
				{
					"name": "terminal2",
					"id": 1435,
					"order": 1868,
					"prevSize": 32,
					"code": 61728,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "text-align-center, typography9",
					"order": 3313,
					"name": "text-align-center",
					"id": 248,
					"code": 59545,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "text-align-justify, typography11",
					"order": 3315,
					"name": "text-align-justify",
					"id": 250,
					"code": 59547,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "text-align-left, typography8",
					"order": 3312,
					"name": "text-align-left",
					"id": 247,
					"code": 59544,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "text-align-right, typography10",
					"order": 3314,
					"name": "text-align-right",
					"id": 249,
					"code": 59546,
					"tempChar": ""
				},
				{
					"order": 1452,
					"prevSize": 32,
					"ligatures": "text-color, wysiwyg24",
					"name": "text-color",
					"id": 3263,
					"code": 62646,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "text-format, typography",
					"order": 3304,
					"name": "text-format",
					"id": 239,
					"code": 59536,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "text-format-remove, typography2",
					"order": 3305,
					"name": "text-format-remove",
					"id": 240,
					"code": 59537,
					"tempChar": ""
				},
				{
					"order": 1429,
					"prevSize": 32,
					"ligatures": "text-height, wysiwyg3",
					"name": "text-height",
					"id": 3240,
					"code": 62623,
					"tempChar": ""
				},
				{
					"name": "text-height2",
					"id": 1228,
					"order": 1661,
					"prevSize": 32,
					"code": 61492,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "text-size, typography3",
					"order": 3306,
					"name": "text-size",
					"id": 241,
					"code": 59538,
					"tempChar": ""
				},
				{
					"order": 1430,
					"prevSize": 32,
					"ligatures": "text-width, wysiwyg4",
					"name": "text-width",
					"id": 3241,
					"code": 62624,
					"tempChar": ""
				},
				{
					"name": "text-width2",
					"id": 1229,
					"order": 1662,
					"prevSize": 32,
					"code": 61493,
					"tempChar": ""
				},
				{
					"name": "th",
					"id": 1189,
					"order": 1622,
					"prevSize": 32,
					"code": 61450,
					"tempChar": ""
				},
				{
					"name": "th-large",
					"id": 1188,
					"order": 1621,
					"prevSize": 32,
					"code": 61449,
					"tempChar": ""
				},
				{
					"name": "th-list",
					"id": 1190,
					"order": 1623,
					"prevSize": 32,
					"code": 61451,
					"tempChar": ""
				},
				{
					"id": 881,
					"order": 3096,
					"prevSize": 32,
					"code": 60264,
					"name": "thank",
					"tempChar": ""
				},
				{
					"id": 882,
					"order": 3097,
					"prevSize": 32,
					"code": 60265,
					"name": "thank2",
					"tempChar": ""
				},
				{
					"order": 253,
					"prevSize": 32,
					"ligatures": "theater3, show",
					"name": "theater",
					"id": 2064,
					"code": 60813,
					"tempChar": ""
				},
				{
					"name": "themeisle",
					"id": 1810,
					"order": 2243,
					"prevSize": 32,
					"code": 62130,
					"tempChar": ""
				},
				{
					"id": 883,
					"order": 3098,
					"prevSize": 32,
					"code": 60266,
					"name": "think",
					"tempChar": ""
				},
				{
					"id": 884,
					"order": 3099,
					"prevSize": 32,
					"code": 60267,
					"name": "think2",
					"tempChar": ""
				},
				{
					"id": 1156,
					"order": 2457,
					"prevSize": 32,
					"code": 60539,
					"name": "think3",
					"tempChar": ""
				},
				{
					"name": "thumb-tack",
					"id": 1312,
					"order": 1745,
					"prevSize": 32,
					"code": 61581,
					"tempChar": ""
				},
				{
					"order": 1016,
					"prevSize": 32,
					"ligatures": "thumbs-down, dislike",
					"name": "thumbs-down",
					"id": 2827,
					"code": 62210,
					"tempChar": ""
				},
				{
					"order": 1017,
					"prevSize": 32,
					"ligatures": "thumbs-down2, dislike2",
					"name": "thumbs-down2",
					"id": 2828,
					"code": 62211,
					"tempChar": ""
				},
				{
					"order": 1019,
					"prevSize": 32,
					"ligatures": "thumbs-down3, dislike3",
					"name": "thumbs-down3",
					"id": 2830,
					"code": 62213,
					"tempChar": ""
				},
				{
					"name": "thumbs-down4",
					"id": 1500,
					"order": 1933,
					"prevSize": 32,
					"code": 61797,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "thumbs-down, dislike",
					"order": 3270,
					"name": "thumbs-down5",
					"id": 205,
					"code": 59502,
					"tempChar": ""
				},
				{
					"name": "thumbs-o-down",
					"id": 1307,
					"order": 1740,
					"prevSize": 32,
					"code": 61576,
					"tempChar": ""
				},
				{
					"name": "thumbs-o-up",
					"id": 1306,
					"order": 1739,
					"prevSize": 32,
					"code": 61575,
					"tempChar": ""
				},
				{
					"order": 1014,
					"prevSize": 32,
					"ligatures": "thumbs-up, like9",
					"name": "thumbs-up",
					"id": 2825,
					"code": 62208,
					"tempChar": ""
				},
				{
					"order": 1015,
					"prevSize": 32,
					"ligatures": "thumbs-up2, like10",
					"name": "thumbs-up2",
					"id": 2826,
					"code": 62209,
					"tempChar": ""
				},
				{
					"order": 1018,
					"prevSize": 32,
					"ligatures": "thumbs-up3, like11",
					"name": "thumbs-up3",
					"id": 2829,
					"code": 62212,
					"tempChar": ""
				},
				{
					"name": "thumbs-up4",
					"id": 1499,
					"order": 1932,
					"prevSize": 32,
					"code": 61796,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "thumbs-up, like",
					"order": 3269,
					"name": "thumbs-up5",
					"id": 204,
					"code": 59501,
					"tempChar": ""
				},
				{
					"id": 885,
					"order": 3100,
					"prevSize": 32,
					"code": 60268,
					"name": "thunder",
					"tempChar": ""
				},
				{
					"id": 886,
					"order": 3101,
					"prevSize": 32,
					"code": 60269,
					"name": "thunder2",
					"tempChar": ""
				},
				{
					"order": 251,
					"prevSize": 32,
					"ligatures": "ticket, theater",
					"name": "ticket",
					"id": 2062,
					"code": 60811,
					"tempChar": ""
				},
				{
					"order": 252,
					"prevSize": 32,
					"ligatures": "ticket2, theater2",
					"name": "ticket2",
					"id": 2063,
					"code": 60812,
					"tempChar": ""
				},
				{
					"name": "ticket3",
					"id": 1470,
					"order": 1903,
					"prevSize": 32,
					"code": 61765,
					"tempChar": ""
				},
				{
					"order": 534,
					"prevSize": 32,
					"ligatures": "tie",
					"name": "tie",
					"id": 2345,
					"code": 61094,
					"tempChar": ""
				},
				{
					"id": 887,
					"order": 3102,
					"prevSize": 32,
					"code": 60270,
					"name": "tie2",
					"tempChar": ""
				},
				{
					"id": 888,
					"order": 3103,
					"prevSize": 32,
					"code": 60271,
					"name": "tie3",
					"tempChar": ""
				},
				{
					"id": 1157,
					"order": 2458,
					"prevSize": 32,
					"code": 60540,
					"name": "tie4",
					"tempChar": ""
				},
				{
					"name": "times-circle",
					"id": 1261,
					"order": 1694,
					"prevSize": 32,
					"code": 61527,
					"tempChar": ""
				},
				{
					"name": "times-circle-o",
					"id": 1266,
					"order": 1699,
					"prevSize": 32,
					"code": 61532,
					"tempChar": ""
				},
				{
					"name": "tint",
					"id": 1242,
					"order": 1675,
					"prevSize": 32,
					"code": 61507,
					"tempChar": ""
				},
				{
					"id": 889,
					"order": 3104,
					"prevSize": 32,
					"code": 60272,
					"name": "toast",
					"tempChar": ""
				},
				{
					"id": 890,
					"order": 3105,
					"prevSize": 32,
					"code": 60273,
					"name": "toast2",
					"tempChar": ""
				},
				{
					"id": 1158,
					"order": 2459,
					"prevSize": 32,
					"code": 60541,
					"name": "toast3",
					"tempChar": ""
				},
				{
					"order": 47,
					"prevSize": 32,
					"ligatures": "toggle, switch",
					"name": "toggle",
					"id": 1858,
					"code": 60607,
					"tempChar": ""
				},
				{
					"order": 1399,
					"prevSize": 32,
					"ligatures": "toggle-off",
					"name": "toggle-off",
					"id": 3210,
					"code": 62593,
					"tempChar": ""
				},
				{
					"name": "toggle-off2",
					"id": 1649,
					"order": 2082,
					"prevSize": 32,
					"code": 61956,
					"tempChar": ""
				},
				{
					"order": 1398,
					"prevSize": 32,
					"ligatures": "toggle-on",
					"name": "toggle-on",
					"id": 3209,
					"code": 62592,
					"tempChar": ""
				},
				{
					"name": "toggle-on2",
					"id": 1650,
					"order": 2083,
					"prevSize": 32,
					"code": 61957,
					"tempChar": ""
				},
				{
					"order": 766,
					"prevSize": 32,
					"ligatures": "toiletpaper, toilet",
					"name": "toiletpaper",
					"id": 2577,
					"code": 61326,
					"tempChar": ""
				},
				{
					"order": 1032,
					"prevSize": 32,
					"ligatures": "tongue, emoticon5",
					"name": "tongue",
					"id": 2843,
					"code": 62226,
					"tempChar": ""
				},
				{
					"order": 1033,
					"prevSize": 32,
					"ligatures": "tongue2, emoticon6",
					"name": "tongue2",
					"id": 2844,
					"code": 62227,
					"tempChar": ""
				},
				{
					"order": 1079,
					"prevSize": 32,
					"ligatures": "touch, finger10",
					"name": "touch",
					"id": 2890,
					"code": 62273,
					"tempChar": ""
				},
				{
					"order": 1082,
					"prevSize": 32,
					"ligatures": "touch-pinch, finger13",
					"name": "touch-pinch",
					"id": 2893,
					"code": 62276,
					"tempChar": ""
				},
				{
					"order": 1081,
					"prevSize": 32,
					"ligatures": "touch-zoom, finger12",
					"name": "touch-zoom",
					"id": 2892,
					"code": 62275,
					"tempChar": ""
				},
				{
					"id": 891,
					"order": 3106,
					"prevSize": 32,
					"code": 60274,
					"name": "tower",
					"tempChar": ""
				},
				{
					"id": 892,
					"order": 3107,
					"prevSize": 32,
					"code": 60275,
					"name": "tower2",
					"tempChar": ""
				},
				{
					"name": "trademark",
					"id": 1730,
					"order": 2163,
					"prevSize": 32,
					"code": 62044,
					"tempChar": ""
				},
				{
					"order": 640,
					"prevSize": 32,
					"ligatures": "traffic-cone, construction2",
					"name": "traffic-cone",
					"id": 2451,
					"code": 61200,
					"tempChar": ""
				},
				{
					"order": 641,
					"prevSize": 32,
					"ligatures": "traffic-lights, lights",
					"name": "traffic-lights",
					"id": 2452,
					"code": 61201,
					"tempChar": ""
				},
				{
					"order": 788,
					"prevSize": 32,
					"ligatures": "train, travel8",
					"name": "train",
					"id": 2599,
					"code": 61348,
					"tempChar": ""
				},
				{
					"order": 789,
					"prevSize": 32,
					"ligatures": "train2, travel9",
					"name": "train2",
					"id": 2600,
					"code": 61349,
					"tempChar": ""
				},
				{
					"name": "train3",
					"id": 1696,
					"order": 2129,
					"prevSize": 32,
					"code": 62008,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "train, travel3",
					"order": 3239,
					"name": "train4",
					"id": 174,
					"code": 59471,
					"tempChar": ""
				},
				{
					"name": "transgender-alt",
					"id": 1679,
					"order": 2112,
					"prevSize": 32,
					"code": 61989,
					"tempChar": ""
				},
				{
					"order": 1352,
					"prevSize": 32,
					"ligatures": "transmission, arrows8",
					"name": "transmission",
					"id": 3163,
					"code": 62546,
					"tempChar": ""
				},
				{
					"order": 1353,
					"prevSize": 32,
					"ligatures": "transmission2, arrows9",
					"name": "transmission2",
					"id": 3164,
					"code": 62547,
					"tempChar": ""
				},
				{
					"id": 893,
					"order": 3108,
					"prevSize": 32,
					"code": 60276,
					"name": "transport",
					"tempChar": ""
				},
				{
					"id": 894,
					"order": 3109,
					"prevSize": 32,
					"code": 60277,
					"name": "transport2",
					"tempChar": ""
				},
				{
					"name": "trash",
					"id": 1638,
					"order": 2071,
					"prevSize": 32,
					"code": 61944,
					"tempChar": ""
				},
				{
					"name": "trash-o",
					"id": 1198,
					"order": 1631,
					"prevSize": 32,
					"code": 61460,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "trash, bin",
					"order": 3177,
					"name": "trash2",
					"id": 112,
					"code": 59409,
					"tempChar": ""
				},
				{
					"id": 895,
					"order": 3110,
					"prevSize": 32,
					"code": 60278,
					"name": "trash3",
					"tempChar": ""
				},
				{
					"id": 896,
					"order": 3111,
					"prevSize": 32,
					"code": 60279,
					"name": "trash4",
					"tempChar": ""
				},
				{
					"id": 897,
					"order": 3112,
					"prevSize": 32,
					"code": 60280,
					"name": "travel",
					"tempChar": ""
				},
				{
					"id": 898,
					"order": 3113,
					"prevSize": 32,
					"code": 60281,
					"name": "travel2",
					"tempChar": ""
				},
				{
					"id": 1159,
					"order": 2460,
					"prevSize": 32,
					"code": 60542,
					"name": "travel3",
					"tempChar": ""
				},
				{
					"id": 899,
					"order": 3114,
					"prevSize": 32,
					"code": 60282,
					"name": "treat",
					"tempChar": ""
				},
				{
					"id": 900,
					"order": 3115,
					"prevSize": 32,
					"code": 60283,
					"name": "treat2",
					"tempChar": ""
				},
				{
					"id": 1160,
					"order": 2461,
					"prevSize": 32,
					"code": 60543,
					"name": "treat3",
					"tempChar": ""
				},
				{
					"order": 724,
					"prevSize": 32,
					"ligatures": "tree, nature3",
					"name": "tree",
					"id": 2535,
					"code": 61284,
					"tempChar": ""
				},
				{
					"order": 725,
					"prevSize": 32,
					"ligatures": "tree2, nature4",
					"name": "tree2",
					"id": 2536,
					"code": 61285,
					"tempChar": ""
				},
				{
					"order": 726,
					"prevSize": 32,
					"ligatures": "tree3, nature5",
					"name": "tree3",
					"id": 2537,
					"code": 61286,
					"tempChar": ""
				},
				{
					"order": 727,
					"prevSize": 32,
					"ligatures": "tree4, nature6",
					"name": "tree4",
					"id": 2538,
					"code": 61287,
					"tempChar": ""
				},
				{
					"order": 870,
					"prevSize": 32,
					"ligatures": "tree5, branches",
					"name": "tree5",
					"id": 2681,
					"code": 61430,
					"tempChar": ""
				},
				{
					"order": 871,
					"prevSize": 32,
					"ligatures": "tree6, branches2",
					"name": "tree6",
					"id": 2682,
					"code": 61431,
					"tempChar": ""
				},
				{
					"order": 872,
					"prevSize": 32,
					"ligatures": "tree7, branches3",
					"name": "tree7",
					"id": 2683,
					"code": 61432,
					"tempChar": ""
				},
				{
					"name": "tree8",
					"id": 1581,
					"order": 2014,
					"prevSize": 32,
					"code": 61883,
					"tempChar": ""
				},
				{
					"order": 1556,
					"prevSize": 32,
					"name": "trello",
					"ligatures": "trello, brand43",
					"id": 3367,
					"code": 62750,
					"tempChar": ""
				},
				{
					"name": "trello2",
					"id": 1526,
					"order": 1959,
					"prevSize": 32,
					"code": 61825,
					"tempChar": ""
				},
				{
					"id": 901,
					"order": 3116,
					"prevSize": 32,
					"code": 60284,
					"name": "trend",
					"tempChar": ""
				},
				{
					"id": 902,
					"order": 3117,
					"prevSize": 32,
					"code": 60285,
					"name": "trend2",
					"tempChar": ""
				},
				{
					"id": 1161,
					"order": 2462,
					"prevSize": 32,
					"code": 60544,
					"name": "trend3",
					"tempChar": ""
				},
				{
					"order": 1388,
					"prevSize": 32,
					"ligatures": "triangle",
					"name": "triangle",
					"id": 3199,
					"code": 62582,
					"tempChar": ""
				},
				{
					"order": 1389,
					"prevSize": 32,
					"ligatures": "triangle2",
					"name": "triangle2",
					"id": 3200,
					"code": 62583,
					"tempChar": ""
				},
				{
					"name": "tripadvisor",
					"id": 1735,
					"order": 2168,
					"prevSize": 32,
					"code": 62050,
					"tempChar": ""
				},
				{
					"order": 680,
					"prevSize": 32,
					"ligatures": "trophy, cup",
					"name": "trophy",
					"id": 2491,
					"code": 61240,
					"tempChar": ""
				},
				{
					"order": 681,
					"prevSize": 32,
					"ligatures": "trophy2, cup2",
					"name": "trophy2",
					"id": 2492,
					"code": 61241,
					"tempChar": ""
				},
				{
					"order": 682,
					"prevSize": 32,
					"ligatures": "trophy3, cup3",
					"name": "trophy3",
					"id": 2493,
					"code": 61242,
					"tempChar": ""
				},
				{
					"order": 685,
					"prevSize": 32,
					"ligatures": "trophy4, gem3",
					"name": "trophy4",
					"id": 2496,
					"code": 61245,
					"tempChar": ""
				},
				{
					"name": "trophy5",
					"id": 1315,
					"order": 1748,
					"prevSize": 32,
					"code": 61585,
					"tempChar": ""
				},
				{
					"order": 785,
					"prevSize": 32,
					"ligatures": "truck, transit",
					"name": "truck",
					"id": 2596,
					"code": 61345,
					"tempChar": ""
				},
				{
					"name": "truck2",
					"id": 1363,
					"order": 1796,
					"prevSize": 32,
					"code": 61649,
					"tempChar": ""
				},
				{
					"order": 87,
					"prevSize": 32,
					"ligatures": "trumpet, music9",
					"name": "trumpet",
					"id": 1898,
					"code": 60647,
					"tempChar": ""
				},
				{
					"name": "try, turkish-lira",
					"id": 1545,
					"order": 1978,
					"prevSize": 32,
					"code": 61845,
					"tempChar": ""
				},
				{
					"order": 536,
					"prevSize": 32,
					"ligatures": "tshirt, shirt",
					"name": "tshirt",
					"id": 2347,
					"code": 61096,
					"tempChar": ""
				},
				{
					"name": "tty",
					"id": 1619,
					"order": 2052,
					"prevSize": 32,
					"code": 61924,
					"tempChar": ""
				},
				{
					"order": 1562,
					"prevSize": 32,
					"ligatures": "tumblr, brand49",
					"name": "tumblr",
					"id": 3373,
					"code": 62756,
					"tempChar": ""
				},
				{
					"name": "tumblr-square",
					"id": 1514,
					"order": 1947,
					"prevSize": 32,
					"code": 61812,
					"tempChar": ""
				},
				{
					"order": 1563,
					"prevSize": 32,
					"ligatures": "tumblr2, brand50",
					"name": "tumblr2",
					"id": 3374,
					"code": 62757,
					"tempChar": ""
				},
				{
					"name": "tumblr3",
					"id": 1513,
					"order": 1946,
					"prevSize": 32,
					"code": 61811,
					"tempChar": ""
				},
				{
					"id": 1162,
					"order": 2463,
					"prevSize": 32,
					"code": 60545,
					"name": "tune",
					"tempChar": ""
				},
				{
					"id": 903,
					"order": 3118,
					"prevSize": 32,
					"code": 60286,
					"name": "turn",
					"tempChar": ""
				},
				{
					"id": 904,
					"order": 3119,
					"prevSize": 32,
					"code": 60287,
					"name": "turn2",
					"tempChar": ""
				},
				{
					"order": 1566,
					"prevSize": 32,
					"ligatures": "tux, brand52",
					"name": "tux",
					"id": 3377,
					"code": 62760,
					"tempChar": ""
				},
				{
					"order": 382,
					"prevSize": 32,
					"ligatures": "tv, television",
					"name": "tv",
					"id": 2193,
					"code": 60942,
					"tempChar": ""
				},
				{
					"id": 905,
					"order": 3120,
					"prevSize": 32,
					"code": 60288,
					"name": "tweet",
					"tempChar": ""
				},
				{
					"id": 906,
					"order": 3121,
					"prevSize": 32,
					"code": 60289,
					"name": "tweet2",
					"tempChar": ""
				},
				{
					"order": 1536,
					"prevSize": 32,
					"ligatures": "twitch, brand23",
					"name": "twitch",
					"id": 3347,
					"code": 62730,
					"tempChar": ""
				},
				{
					"name": "twitch2",
					"id": 1623,
					"order": 2056,
					"prevSize": 32,
					"code": 61928,
					"tempChar": ""
				},
				{
					"order": 1527,
					"prevSize": 32,
					"ligatures": "twitter, brand16",
					"name": "twitter",
					"id": 3338,
					"code": 62721,
					"tempChar": ""
				},
				{
					"name": "twitter-square",
					"id": 1300,
					"order": 1733,
					"prevSize": 32,
					"code": 61569,
					"tempChar": ""
				},
				{
					"name": "twitter2",
					"id": 1323,
					"order": 1756,
					"prevSize": 32,
					"code": 61593,
					"tempChar": ""
				},
				{
					"id": 907,
					"order": 3122,
					"prevSize": 32,
					"code": 60290,
					"name": "type",
					"tempChar": ""
				},
				{
					"id": 908,
					"order": 3123,
					"prevSize": 32,
					"code": 60291,
					"name": "type2",
					"tempChar": ""
				},
				{
					"id": 1163,
					"order": 2464,
					"prevSize": 32,
					"code": 60546,
					"name": "type3",
					"tempChar": ""
				},
				{
					"order": 372,
					"prevSize": 32,
					"ligatures": "typewriter, typing3",
					"name": "typewriter",
					"id": 2183,
					"code": 60932,
					"tempChar": ""
				},
				{
					"order": 1428,
					"prevSize": 32,
					"ligatures": "typography3, wysiwyg2",
					"name": "typography",
					"id": 3239,
					"code": 62622,
					"tempChar": ""
				},
				{
					"order": 983,
					"prevSize": 32,
					"ligatures": "umbrella, weather23",
					"name": "umbrella",
					"id": 2794,
					"code": 62177,
					"tempChar": ""
				},
				{
					"name": "umbrella2",
					"id": 1386,
					"order": 1819,
					"prevSize": 32,
					"code": 61673,
					"tempChar": ""
				},
				{
					"order": 1434,
					"prevSize": 32,
					"ligatures": "underline, wysiwyg6",
					"name": "underline",
					"id": 3245,
					"code": 62628,
					"tempChar": ""
				},
				{
					"order": 1440,
					"prevSize": 32,
					"ligatures": "underline2, wysiwyg12",
					"name": "underline2",
					"id": 3251,
					"code": 62634,
					"tempChar": ""
				},
				{
					"name": "underline3",
					"id": 1360,
					"order": 1793,
					"prevSize": 32,
					"code": 61645,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "underline, typography6",
					"order": 3309,
					"name": "underline4",
					"id": 244,
					"code": 59541,
					"tempChar": ""
				},
				{
					"order": 423,
					"prevSize": 32,
					"ligatures": "undo, ccw",
					"name": "undo",
					"id": 2234,
					"code": 60983,
					"tempChar": ""
				},
				{
					"order": 449,
					"prevSize": 32,
					"ligatures": "undo2, left",
					"name": "undo2",
					"id": 2260,
					"code": 61009,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "undo, ccw",
					"order": 3256,
					"name": "undo4",
					"id": 191,
					"code": 59488,
					"tempChar": ""
				},
				{
					"id": 1164,
					"order": 2465,
					"prevSize": 32,
					"code": 60547,
					"name": "undo5",
					"tempChar": ""
				},
				{
					"order": 1408,
					"prevSize": 32,
					"ligatures": "ungroup",
					"name": "ungroup",
					"id": 3219,
					"code": 62602,
					"tempChar": ""
				},
				{
					"order": 3330,
					"id": 0,
					"prevSize": 32,
					"code": 33,
					"name": "uni21",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3331,
					"id": 1,
					"prevSize": 32,
					"code": 34,
					"name": "uni22",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3332,
					"id": 2,
					"prevSize": 32,
					"code": 35,
					"name": "uni23",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3333,
					"id": 3,
					"prevSize": 32,
					"code": 36,
					"name": "uni24",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3334,
					"id": 4,
					"prevSize": 32,
					"code": 37,
					"name": "uni25",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3335,
					"id": 5,
					"prevSize": 32,
					"code": 38,
					"name": "uni26",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3336,
					"id": 6,
					"prevSize": 32,
					"code": 39,
					"name": "uni27",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3337,
					"id": 7,
					"prevSize": 32,
					"code": 40,
					"name": "uni28",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3338,
					"id": 8,
					"prevSize": 32,
					"code": 41,
					"name": "uni29",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3339,
					"id": 9,
					"prevSize": 32,
					"code": 42,
					"name": "uni2a",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3340,
					"id": 10,
					"prevSize": 32,
					"code": 43,
					"name": "uni2b",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3341,
					"id": 11,
					"prevSize": 32,
					"code": 44,
					"name": "uni2c",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3342,
					"id": 12,
					"prevSize": 32,
					"code": 45,
					"name": "uni2d",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3343,
					"id": 13,
					"prevSize": 32,
					"code": 46,
					"name": "uni2e",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3344,
					"id": 14,
					"prevSize": 32,
					"code": 47,
					"name": "uni2f",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3345,
					"id": 15,
					"prevSize": 32,
					"code": 48,
					"name": "uni30",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3346,
					"id": 16,
					"prevSize": 32,
					"code": 49,
					"name": "uni31",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3347,
					"id": 17,
					"prevSize": 32,
					"code": 50,
					"name": "uni32",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3348,
					"id": 18,
					"prevSize": 32,
					"code": 51,
					"name": "uni33",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3349,
					"id": 19,
					"prevSize": 32,
					"code": 52,
					"name": "uni34",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3350,
					"id": 20,
					"prevSize": 32,
					"code": 53,
					"name": "uni35",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3351,
					"id": 21,
					"prevSize": 32,
					"code": 54,
					"name": "uni36<div><br></div>",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3352,
					"id": 22,
					"prevSize": 32,
					"code": 55,
					"name": "uni37",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3353,
					"id": 23,
					"prevSize": 32,
					"code": 56,
					"name": "uni38",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3354,
					"id": 24,
					"prevSize": 32,
					"code": 57,
					"name": "uni39",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3355,
					"id": 25,
					"prevSize": 32,
					"code": 58,
					"name": "uni3a",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3356,
					"id": 26,
					"prevSize": 32,
					"code": 59,
					"name": "uni3b",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3357,
					"id": 27,
					"prevSize": 32,
					"code": 60,
					"name": "uni3c",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3358,
					"id": 28,
					"prevSize": 32,
					"code": 61,
					"name": "uni3d",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3359,
					"id": 29,
					"prevSize": 32,
					"code": 62,
					"name": "uni3e",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3360,
					"id": 30,
					"prevSize": 32,
					"code": 63,
					"name": "uni3f",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3361,
					"id": 31,
					"prevSize": 32,
					"code": 64,
					"name": "uni40",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3362,
					"id": 32,
					"prevSize": 32,
					"code": 65,
					"name": "uni41",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3363,
					"id": 33,
					"prevSize": 32,
					"code": 66,
					"name": "uni42",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3364,
					"id": 34,
					"prevSize": 32,
					"code": 67,
					"name": "uni43",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3365,
					"id": 35,
					"prevSize": 32,
					"code": 68,
					"name": "uni44",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3366,
					"id": 36,
					"prevSize": 32,
					"code": 69,
					"name": "uni45",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3367,
					"id": 37,
					"prevSize": 32,
					"code": 70,
					"name": "uni46",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3368,
					"id": 38,
					"prevSize": 32,
					"code": 71,
					"name": "uni47",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3369,
					"id": 39,
					"prevSize": 32,
					"code": 72,
					"name": "uni48",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3370,
					"id": 40,
					"prevSize": 32,
					"code": 73,
					"name": "uni49",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3371,
					"id": 41,
					"prevSize": 32,
					"code": 74,
					"name": "uni4a",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3372,
					"id": 42,
					"prevSize": 32,
					"code": 75,
					"name": "uni4b",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3373,
					"id": 43,
					"prevSize": 32,
					"code": 76,
					"name": "uni4c",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3374,
					"id": 44,
					"prevSize": 32,
					"code": 77,
					"name": "uni4d",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3375,
					"id": 45,
					"prevSize": 32,
					"code": 78,
					"name": "uni4e",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3376,
					"id": 46,
					"prevSize": 32,
					"code": 79,
					"name": "uni4f",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3377,
					"id": 47,
					"prevSize": 32,
					"code": 80,
					"name": "uni50",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3378,
					"id": 48,
					"prevSize": 32,
					"code": 81,
					"name": "uni51",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3379,
					"id": 49,
					"prevSize": 32,
					"code": 82,
					"name": "uni52",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3380,
					"id": 50,
					"prevSize": 32,
					"code": 83,
					"name": "uni53",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3381,
					"id": 51,
					"prevSize": 32,
					"code": 84,
					"name": "uni54",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3382,
					"id": 52,
					"prevSize": 32,
					"code": 85,
					"name": "uni55",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3383,
					"id": 53,
					"prevSize": 32,
					"code": 86,
					"name": "uni56",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3384,
					"id": 54,
					"prevSize": 32,
					"code": 87,
					"name": "uni57",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3385,
					"id": 55,
					"prevSize": 32,
					"code": 88,
					"name": "uni58",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3386,
					"id": 56,
					"prevSize": 32,
					"code": 89,
					"name": "uni59",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3387,
					"id": 57,
					"prevSize": 32,
					"code": 90,
					"name": "uni5a",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3388,
					"id": 58,
					"prevSize": 32,
					"code": 91,
					"name": "uni5b",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3389,
					"id": 59,
					"prevSize": 32,
					"code": 92,
					"name": "uni5c",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3390,
					"id": 60,
					"prevSize": 32,
					"code": 93,
					"name": "uni5d",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3391,
					"id": 61,
					"prevSize": 32,
					"code": 94,
					"name": "uni5e",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3392,
					"id": 62,
					"prevSize": 32,
					"code": 95,
					"name": "uni5f",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3393,
					"id": 63,
					"prevSize": 32,
					"code": 96,
					"name": "uni60",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3394,
					"id": 64,
					"prevSize": 32,
					"code": 97,
					"name": "uni61",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3395,
					"id": 65,
					"prevSize": 32,
					"code": 98,
					"name": "uni62",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3396,
					"id": 66,
					"prevSize": 32,
					"code": 99,
					"name": "uni63",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3397,
					"id": 67,
					"prevSize": 32,
					"code": 100,
					"name": "uni64",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3398,
					"id": 68,
					"prevSize": 32,
					"code": 101,
					"name": "uni65",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3399,
					"id": 69,
					"prevSize": 32,
					"code": 102,
					"name": "uni66",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3400,
					"id": 70,
					"prevSize": 32,
					"code": 103,
					"name": "uni67",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3401,
					"id": 71,
					"prevSize": 32,
					"code": 104,
					"name": "uni68",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3402,
					"id": 72,
					"prevSize": 32,
					"code": 105,
					"name": "uni69",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3403,
					"id": 73,
					"prevSize": 32,
					"code": 106,
					"name": "uni6a",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3404,
					"id": 74,
					"prevSize": 32,
					"code": 107,
					"name": "uni6b",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3405,
					"id": 75,
					"prevSize": 32,
					"code": 108,
					"name": "uni6c",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3406,
					"id": 76,
					"prevSize": 32,
					"code": 109,
					"name": "uni6d",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3407,
					"id": 77,
					"prevSize": 32,
					"code": 110,
					"name": "uni6e",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3408,
					"id": 78,
					"prevSize": 32,
					"code": 111,
					"name": "uni6f",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3409,
					"id": 79,
					"prevSize": 32,
					"code": 112,
					"name": "uni70",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3410,
					"id": 80,
					"prevSize": 32,
					"code": 113,
					"name": "uni71",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3411,
					"id": 81,
					"prevSize": 32,
					"code": 114,
					"name": "uni72",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3412,
					"id": 82,
					"prevSize": 32,
					"code": 115,
					"name": "uni73",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3413,
					"id": 83,
					"prevSize": 32,
					"code": 116,
					"name": "uni74",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3414,
					"id": 84,
					"prevSize": 32,
					"code": 117,
					"name": "uni75",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3415,
					"id": 85,
					"prevSize": 32,
					"code": 118,
					"name": "uni76",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3416,
					"id": 86,
					"prevSize": 32,
					"code": 119,
					"name": "uni77",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3417,
					"id": 87,
					"prevSize": 32,
					"code": 120,
					"name": "uni78",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3418,
					"id": 88,
					"prevSize": 32,
					"code": 121,
					"name": "uni79",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3419,
					"id": 89,
					"prevSize": 32,
					"code": 122,
					"name": "uni7a",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3420,
					"id": 90,
					"prevSize": 32,
					"code": 123,
					"name": "uni7b",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3421,
					"id": 91,
					"prevSize": 32,
					"code": 124,
					"name": "uni7c",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3422,
					"id": 92,
					"prevSize": 32,
					"code": 125,
					"name": "uni7d",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 3423,
					"id": 93,
					"prevSize": 32,
					"code": 126,
					"name": "uni7e",
					"tempChar": "",
					"ligatures": ""
				},
				{
					"order": 1495,
					"prevSize": 32,
					"ligatures": "unicode",
					"name": "unicode",
					"id": 3306,
					"code": 62689,
					"tempChar": ""
				},
				{
					"order": 439,
					"prevSize": 32,
					"ligatures": "unite, boolean-operation",
					"name": "unite",
					"id": 2250,
					"code": 60999,
					"tempChar": ""
				},
				{
					"name": "universal-access",
					"id": 1788,
					"order": 2221,
					"prevSize": 32,
					"code": 62106,
					"tempChar": ""
				},
				{
					"order": 924,
					"prevSize": 32,
					"ligatures": "unlink, link2",
					"name": "unlink",
					"id": 2735,
					"code": 61935,
					"tempChar": ""
				},
				{
					"order": 926,
					"prevSize": 32,
					"ligatures": "unlink2, link4",
					"name": "unlink2",
					"id": 2737,
					"code": 61967,
					"tempChar": ""
				},
				{
					"order": 928,
					"prevSize": 32,
					"ligatures": "unlink3, link6",
					"name": "unlink3",
					"id": 2739,
					"code": 61984,
					"tempChar": ""
				},
				{
					"order": 930,
					"prevSize": 32,
					"ligatures": "unlink4, link8",
					"name": "unlink4",
					"id": 2741,
					"code": 61999,
					"tempChar": ""
				},
				{
					"order": 932,
					"prevSize": 32,
					"ligatures": "unlink5, link10",
					"name": "unlink5",
					"id": 2743,
					"code": 62031,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "unlink, url2",
					"order": 3268,
					"name": "unlink7",
					"id": 203,
					"code": 59500,
					"tempChar": ""
				},
				{
					"name": "unlock",
					"id": 1326,
					"order": 1759,
					"prevSize": 32,
					"code": 61596,
					"tempChar": ""
				},
				{
					"name": "unlock-alt",
					"id": 1464,
					"order": 1897,
					"prevSize": 32,
					"code": 61758,
					"tempChar": ""
				},
				{
					"id": 909,
					"order": 3124,
					"prevSize": 32,
					"code": 60292,
					"name": "unlock2",
					"tempChar": ""
				},
				{
					"id": 910,
					"order": 3125,
					"prevSize": 32,
					"code": 60293,
					"name": "unlock3",
					"tempChar": ""
				},
				{
					"id": 1165,
					"order": 2466,
					"prevSize": 32,
					"code": 60548,
					"name": "unlock4",
					"tempChar": ""
				},
				{
					"order": 598,
					"prevSize": 32,
					"ligatures": "unlocked, lock-open",
					"name": "unlocked",
					"id": 2409,
					"code": 61158,
					"tempChar": ""
				},
				{
					"order": 600,
					"prevSize": 32,
					"ligatures": "unlocked2, lock-open2",
					"name": "unlocked2",
					"id": 2411,
					"code": 61160,
					"tempChar": ""
				},
				{
					"order": 394,
					"prevSize": 32,
					"ligatures": "upload, load",
					"name": "upload",
					"id": 2205,
					"code": 60954,
					"tempChar": ""
				},
				{
					"order": 914,
					"prevSize": 32,
					"ligatures": "upload10, load12",
					"name": "upload10",
					"id": 2725,
					"code": 61775,
					"tempChar": ""
				},
				{
					"name": "upload11",
					"id": 1317,
					"order": 1750,
					"prevSize": 32,
					"code": 61587,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "upload, up",
					"order": 3262,
					"name": "upload12",
					"id": 197,
					"code": 59494,
					"tempChar": ""
				},
				{
					"id": 1166,
					"order": 2467,
					"prevSize": 32,
					"code": 60549,
					"name": "upload13",
					"tempChar": ""
				},
				{
					"order": 897,
					"prevSize": 32,
					"ligatures": "upload2, load2",
					"name": "upload2",
					"id": 2708,
					"code": 61625,
					"tempChar": ""
				},
				{
					"order": 898,
					"prevSize": 32,
					"ligatures": "upload3, load3",
					"name": "upload3",
					"id": 2709,
					"code": 61626,
					"tempChar": ""
				},
				{
					"order": 902,
					"prevSize": 32,
					"ligatures": "upload4, load6",
					"name": "upload4",
					"id": 2713,
					"code": 61630,
					"tempChar": ""
				},
				{
					"order": 904,
					"prevSize": 32,
					"ligatures": "upload5, load7",
					"name": "upload5",
					"id": 2715,
					"code": 61647,
					"tempChar": ""
				},
				{
					"order": 906,
					"prevSize": 32,
					"ligatures": "upload6, load8",
					"name": "upload6",
					"id": 2717,
					"code": 61679,
					"tempChar": ""
				},
				{
					"order": 908,
					"prevSize": 32,
					"ligatures": "upload7, load9",
					"name": "upload7",
					"id": 2719,
					"code": 61711,
					"tempChar": ""
				},
				{
					"order": 910,
					"prevSize": 32,
					"ligatures": "upload8, load10",
					"name": "upload8",
					"id": 2721,
					"code": 61719,
					"tempChar": ""
				},
				{
					"order": 912,
					"prevSize": 32,
					"ligatures": "upload9, load11",
					"name": "upload9",
					"id": 2723,
					"code": 61743,
					"tempChar": ""
				},
				{
					"id": 911,
					"order": 3126,
					"prevSize": 32,
					"code": 60294,
					"name": "urbanize",
					"tempChar": ""
				},
				{
					"id": 912,
					"order": 3127,
					"prevSize": 32,
					"code": 60295,
					"name": "urbanize2",
					"tempChar": ""
				},
				{
					"name": "usb",
					"id": 1770,
					"order": 2203,
					"prevSize": 32,
					"code": 62087,
					"tempChar": ""
				},
				{
					"order": 402,
					"prevSize": 32,
					"ligatures": "usb-stick, flash-memory",
					"name": "usb-stick",
					"id": 2213,
					"code": 60962,
					"tempChar": ""
				},
				{
					"id": 913,
					"order": 3128,
					"prevSize": 32,
					"code": 60296,
					"name": "use",
					"tempChar": ""
				},
				{
					"id": 914,
					"order": 3129,
					"prevSize": 32,
					"code": 60297,
					"name": "use2",
					"tempChar": ""
				},
				{
					"id": 1167,
					"order": 2468,
					"prevSize": 32,
					"code": 60550,
					"name": "use3",
					"tempChar": ""
				},
				{
					"order": 505,
					"prevSize": 32,
					"ligatures": "user, profile2",
					"name": "user",
					"id": 2316,
					"code": 61065,
					"tempChar": ""
				},
				{
					"order": 510,
					"prevSize": 32,
					"ligatures": "user-block, user5",
					"name": "user-block",
					"id": 2321,
					"code": 61070,
					"tempChar": ""
				},
				{
					"order": 519,
					"prevSize": 32,
					"ligatures": "user-block2, user12",
					"name": "user-block2",
					"id": 2330,
					"code": 61079,
					"tempChar": ""
				},
				{
					"order": 509,
					"prevSize": 32,
					"ligatures": "user-cancel, user4",
					"name": "user-cancel",
					"id": 2320,
					"code": 61069,
					"tempChar": ""
				},
				{
					"order": 518,
					"prevSize": 32,
					"ligatures": "user-cancel2, user11",
					"name": "user-cancel2",
					"id": 2329,
					"code": 61078,
					"tempChar": ""
				},
				{
					"order": 512,
					"prevSize": 32,
					"ligatures": "user-check, user7",
					"name": "user-check",
					"id": 2323,
					"code": 61072,
					"tempChar": ""
				},
				{
					"order": 521,
					"prevSize": 32,
					"ligatures": "user-check2, user14",
					"name": "user-check2",
					"id": 2332,
					"code": 61081,
					"tempChar": ""
				},
				{
					"order": 511,
					"prevSize": 32,
					"ligatures": "user-lock, user6",
					"name": "user-lock",
					"id": 2322,
					"code": 61071,
					"tempChar": ""
				},
				{
					"order": 520,
					"prevSize": 32,
					"ligatures": "user-lock2, user13",
					"name": "user-lock2",
					"id": 2331,
					"code": 61080,
					"tempChar": ""
				},
				{
					"name": "user-md",
					"id": 1392,
					"order": 1825,
					"prevSize": 32,
					"code": 61680,
					"tempChar": ""
				},
				{
					"order": 508,
					"prevSize": 32,
					"ligatures": "user-minus, user3",
					"name": "user-minus",
					"id": 2319,
					"code": 61068,
					"tempChar": ""
				},
				{
					"order": 517,
					"prevSize": 32,
					"ligatures": "user-minus2, user10",
					"name": "user-minus2",
					"id": 2328,
					"code": 61077,
					"tempChar": ""
				},
				{
					"order": 507,
					"prevSize": 32,
					"ligatures": "user-plus, user2",
					"name": "user-plus",
					"id": 2318,
					"code": 61067,
					"tempChar": ""
				},
				{
					"order": 516,
					"prevSize": 32,
					"ligatures": "user-plus2, user9",
					"name": "user-plus2",
					"id": 2327,
					"code": 61076,
					"tempChar": ""
				},
				{
					"name": "user-plus3",
					"id": 1692,
					"order": 2125,
					"prevSize": 32,
					"code": 62004,
					"tempChar": ""
				},
				{
					"name": "user-secret",
					"id": 1671,
					"order": 2104,
					"prevSize": 32,
					"code": 61979,
					"tempChar": ""
				},
				{
					"order": 527,
					"prevSize": 32,
					"ligatures": "user-tie, user19",
					"name": "user-tie",
					"id": 2338,
					"code": 61087,
					"tempChar": ""
				},
				{
					"name": "user-times",
					"id": 1693,
					"order": 2126,
					"prevSize": 32,
					"code": 62005,
					"tempChar": ""
				},
				{
					"order": 514,
					"prevSize": 32,
					"ligatures": "user8, profile3",
					"name": "user2",
					"id": 2325,
					"code": 61074,
					"tempChar": ""
				},
				{
					"order": 522,
					"prevSize": 32,
					"ligatures": "user15, profile4",
					"name": "user3",
					"id": 2333,
					"code": 61082,
					"tempChar": ""
				},
				{
					"order": 523,
					"prevSize": 32,
					"ligatures": "user16, profile5",
					"name": "user4",
					"id": 2334,
					"code": 61083,
					"tempChar": ""
				},
				{
					"order": 524,
					"prevSize": 32,
					"ligatures": "user17, profile6",
					"name": "user5",
					"id": 2335,
					"code": 61084,
					"tempChar": ""
				},
				{
					"order": 525,
					"prevSize": 32,
					"ligatures": "user18, profile7",
					"name": "user6",
					"id": 2336,
					"code": 61085,
					"tempChar": ""
				},
				{
					"order": 528,
					"prevSize": 32,
					"ligatures": "user20, profile8",
					"name": "user7",
					"id": 2339,
					"code": 61088,
					"tempChar": ""
				},
				{
					"name": "user8",
					"id": 1186,
					"order": 1619,
					"prevSize": 32,
					"code": 61447,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "user, persona",
					"order": 3202,
					"name": "user9",
					"id": 137,
					"code": 59434,
					"tempChar": ""
				},
				{
					"order": 506,
					"prevSize": 32,
					"ligatures": "users, group",
					"name": "users",
					"id": 2317,
					"code": 61066,
					"tempChar": ""
				},
				{
					"order": 513,
					"prevSize": 32,
					"ligatures": "users2, group2",
					"name": "users2",
					"id": 2324,
					"code": 61073,
					"tempChar": ""
				},
				{
					"order": 515,
					"prevSize": 32,
					"ligatures": "users3, group3",
					"name": "users3",
					"id": 2326,
					"code": 61075,
					"tempChar": ""
				},
				{
					"order": 526,
					"prevSize": 32,
					"ligatures": "users4, group4",
					"name": "users4",
					"id": 2337,
					"code": 61086,
					"tempChar": ""
				},
				{
					"order": 529,
					"prevSize": 32,
					"ligatures": "users5, group5",
					"name": "users5",
					"id": 2340,
					"code": 61089,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "users, group",
					"order": 3203,
					"name": "users7",
					"id": 138,
					"code": 59435,
					"tempChar": ""
				},
				{
					"order": 531,
					"prevSize": 32,
					"ligatures": "vcard, card",
					"name": "vcard",
					"id": 2342,
					"code": 61091,
					"tempChar": ""
				},
				{
					"order": 1409,
					"prevSize": 32,
					"ligatures": "vector, bezier",
					"name": "vector",
					"id": 3220,
					"code": 62603,
					"tempChar": ""
				},
				{
					"order": 1410,
					"prevSize": 32,
					"ligatures": "vector2, bezier2",
					"name": "vector2",
					"id": 3221,
					"code": 62604,
					"tempChar": ""
				},
				{
					"name": "venus",
					"id": 1675,
					"order": 2108,
					"prevSize": 32,
					"code": 61985,
					"tempChar": ""
				},
				{
					"name": "venus-double",
					"id": 1680,
					"order": 2113,
					"prevSize": 32,
					"code": 61990,
					"tempChar": ""
				},
				{
					"name": "venus-mars",
					"id": 1682,
					"order": 2115,
					"prevSize": 32,
					"code": 61992,
					"tempChar": ""
				},
				{
					"name": "viacoin",
					"id": 1695,
					"order": 2128,
					"prevSize": 32,
					"code": 62007,
					"tempChar": ""
				},
				{
					"name": "viadeo",
					"id": 1802,
					"order": 2235,
					"prevSize": 32,
					"code": 62121,
					"tempChar": ""
				},
				{
					"name": "viadeo-square",
					"id": 1803,
					"order": 2236,
					"prevSize": 32,
					"code": 62122,
					"tempChar": ""
				},
				{
					"order": 100,
					"prevSize": 32,
					"ligatures": "video-camera, video10",
					"name": "video-camera",
					"id": 1911,
					"code": 60660,
					"tempChar": ""
				},
				{
					"order": 102,
					"prevSize": 32,
					"ligatures": "video-camera-slash, video12",
					"name": "video-camera-slash",
					"id": 1913,
					"code": 60662,
					"tempChar": ""
				},
				{
					"order": 105,
					"prevSize": 32,
					"ligatures": "video-camera-slash2, video15",
					"name": "video-camera-slash2",
					"id": 1916,
					"code": 60665,
					"tempChar": ""
				},
				{
					"order": 101,
					"prevSize": 32,
					"ligatures": "video-camera2, video11",
					"name": "video-camera2",
					"id": 1912,
					"code": 60661,
					"tempChar": ""
				},
				{
					"order": 103,
					"prevSize": 32,
					"ligatures": "video-camera3, video13",
					"name": "video-camera3",
					"id": 1914,
					"code": 60663,
					"tempChar": ""
				},
				{
					"order": 104,
					"prevSize": 32,
					"ligatures": "video-camera4, video14",
					"name": "video-camera4",
					"id": 1915,
					"code": 60664,
					"tempChar": ""
				},
				{
					"order": 106,
					"prevSize": 32,
					"ligatures": "video-camera5, video16",
					"name": "video-camera5",
					"id": 1917,
					"code": 60666,
					"tempChar": ""
				},
				{
					"name": "video-camera6",
					"id": 1237,
					"order": 1670,
					"prevSize": 32,
					"code": 61501,
					"tempChar": ""
				},
				{
					"id": 915,
					"order": 3130,
					"prevSize": 32,
					"code": 60298,
					"name": "view",
					"tempChar": ""
				},
				{
					"id": 916,
					"order": 3131,
					"prevSize": 32,
					"code": 60299,
					"name": "view2",
					"tempChar": ""
				},
				{
					"order": 1537,
					"prevSize": 32,
					"ligatures": "vimeo, brand24",
					"name": "vimeo",
					"id": 3348,
					"code": 62731,
					"tempChar": ""
				},
				{
					"name": "vimeo-square",
					"id": 1544,
					"order": 1977,
					"prevSize": 32,
					"code": 61844,
					"tempChar": ""
				},
				{
					"order": 1538,
					"prevSize": 32,
					"ligatures": "vimeo2, brand25",
					"name": "vimeo2",
					"id": 3349,
					"code": 62732,
					"tempChar": ""
				},
				{
					"name": "vimeo3",
					"id": 1761,
					"order": 2194,
					"prevSize": 32,
					"code": 62077,
					"tempChar": ""
				},
				{
					"order": 1528,
					"prevSize": 32,
					"name": "vine",
					"ligatures": "vine, brand17",
					"id": 3339,
					"code": 62722,
					"tempChar": ""
				},
				{
					"name": "vine2",
					"id": 1595,
					"order": 2028,
					"prevSize": 32,
					"code": 61898,
					"tempChar": ""
				},
				{
					"id": 1168,
					"order": 2469,
					"prevSize": 32,
					"code": 60551,
					"name": "visualize",
					"tempChar": ""
				},
				{
					"order": 1529,
					"prevSize": 32,
					"name": "vk",
					"ligatures": "vk, brand18",
					"id": 3340,
					"code": 62723,
					"tempChar": ""
				},
				{
					"name": "vk2",
					"id": 1534,
					"order": 1967,
					"prevSize": 32,
					"code": 61833,
					"tempChar": ""
				},
				{
					"id": 917,
					"order": 3132,
					"prevSize": 32,
					"code": 60300,
					"name": "volley",
					"tempChar": ""
				},
				{
					"id": 918,
					"order": 3133,
					"prevSize": 32,
					"code": 60301,
					"name": "volley2",
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "volume, speaker4",
					"order": 3253,
					"name": "volume",
					"id": 188,
					"code": 59485,
					"tempChar": ""
				},
				{
					"order": 1191,
					"prevSize": 32,
					"ligatures": "volume-0, volume23",
					"name": "volume-0",
					"id": 3002,
					"code": 62385,
					"tempChar": ""
				},
				{
					"order": 1190,
					"prevSize": 32,
					"ligatures": "volume-1, volume22",
					"name": "volume-1",
					"id": 3001,
					"code": 62384,
					"tempChar": ""
				},
				{
					"order": 1189,
					"prevSize": 32,
					"ligatures": "volume-2, volume21",
					"name": "volume-2",
					"id": 3000,
					"code": 62383,
					"tempChar": ""
				},
				{
					"order": 1188,
					"prevSize": 32,
					"ligatures": "volume-3, volume20",
					"name": "volume-3",
					"id": 2999,
					"code": 62382,
					"tempChar": ""
				},
				{
					"order": 1187,
					"prevSize": 32,
					"ligatures": "volume-4, volume19",
					"name": "volume-4",
					"id": 2998,
					"code": 62381,
					"tempChar": ""
				},
				{
					"order": 1186,
					"prevSize": 32,
					"ligatures": "volume-5, volume18",
					"name": "volume-5",
					"id": 2997,
					"code": 62380,
					"tempChar": ""
				},
				{
					"name": "volume-control-phone",
					"id": 1793,
					"order": 2226,
					"prevSize": 32,
					"code": 62112,
					"tempChar": ""
				},
				{
					"order": 1177,
					"prevSize": 32,
					"ligatures": "volume-decrease, volume9",
					"name": "volume-decrease",
					"id": 2988,
					"code": 62371,
					"tempChar": ""
				},
				{
					"order": 1184,
					"prevSize": 32,
					"ligatures": "volume-decrease2, volume16",
					"name": "volume-decrease2",
					"id": 2995,
					"code": 62378,
					"tempChar": ""
				},
				{
					"order": 1185,
					"prevSize": 32,
					"ligatures": "volume-decrease3, volume17",
					"name": "volume-decrease3",
					"id": 2996,
					"code": 62379,
					"tempChar": ""
				},
				{
					"name": "volume-down",
					"id": 1215,
					"order": 1648,
					"prevSize": 32,
					"code": 61479,
					"tempChar": ""
				},
				{
					"order": 1169,
					"prevSize": 32,
					"ligatures": "volume-high, volume",
					"name": "volume-high",
					"id": 2980,
					"code": 62363,
					"tempChar": ""
				},
				{
					"order": 1178,
					"prevSize": 32,
					"ligatures": "volume-high2, volume10",
					"name": "volume-high2",
					"id": 2989,
					"code": 62372,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "volume-high, speaker",
					"order": 3250,
					"name": "volume-high3",
					"id": 185,
					"code": 59482,
					"tempChar": ""
				},
				{
					"order": 1176,
					"prevSize": 32,
					"ligatures": "volume-increase, volume8",
					"name": "volume-increase",
					"id": 2987,
					"code": 62370,
					"tempChar": ""
				},
				{
					"order": 1183,
					"prevSize": 32,
					"ligatures": "volume-increase2, volume15",
					"name": "volume-increase2",
					"id": 2994,
					"code": 62377,
					"tempChar": ""
				},
				{
					"order": 1171,
					"prevSize": 32,
					"ligatures": "volume-low, volume3",
					"name": "volume-low",
					"id": 2982,
					"code": 62365,
					"tempChar": ""
				},
				{
					"order": 1181,
					"prevSize": 32,
					"ligatures": "volume-low2, volume13",
					"name": "volume-low2",
					"id": 2992,
					"code": 62375,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "volume-low, speaker3",
					"order": 3252,
					"name": "volume-low3",
					"id": 187,
					"code": 59484,
					"tempChar": ""
				},
				{
					"order": 1170,
					"prevSize": 32,
					"ligatures": "volume-medium, volume2",
					"name": "volume-medium",
					"id": 2981,
					"code": 62364,
					"tempChar": ""
				},
				{
					"order": 1179,
					"prevSize": 32,
					"ligatures": "volume-medium2, volume11",
					"name": "volume-medium2",
					"id": 2990,
					"code": 62373,
					"tempChar": ""
				},
				{
					"order": 1180,
					"prevSize": 32,
					"ligatures": "volume-medium3, volume12",
					"name": "volume-medium3",
					"id": 2991,
					"code": 62374,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "volume-medium, speaker2",
					"order": 3251,
					"name": "volume-medium4",
					"id": 186,
					"code": 59483,
					"tempChar": ""
				},
				{
					"order": 1172,
					"prevSize": 32,
					"ligatures": "volume-mute, volume4",
					"name": "volume-mute",
					"id": 2983,
					"code": 62366,
					"tempChar": ""
				},
				{
					"order": 1175,
					"prevSize": 32,
					"ligatures": "volume-mute2, volume7",
					"name": "volume-mute2",
					"id": 2986,
					"code": 62369,
					"tempChar": ""
				},
				{
					"order": 1182,
					"prevSize": 32,
					"ligatures": "volume-mute3, volume14",
					"name": "volume-mute3",
					"id": 2993,
					"code": 62376,
					"tempChar": ""
				},
				{
					"order": 1192,
					"prevSize": 32,
					"ligatures": "volume-mute4, volume24",
					"name": "volume-mute4",
					"id": 3003,
					"code": 62386,
					"tempChar": ""
				},
				{
					"order": 1193,
					"prevSize": 32,
					"ligatures": "volume-mute5, volume25",
					"name": "volume-mute5",
					"id": 3004,
					"code": 62387,
					"tempChar": ""
				},
				{
					"name": "volume-off",
					"id": 1214,
					"order": 1647,
					"prevSize": 32,
					"code": 61478,
					"tempChar": ""
				},
				{
					"name": "volume-up",
					"id": 1216,
					"order": 1649,
					"prevSize": 32,
					"code": 61480,
					"tempChar": ""
				},
				{
					"id": 919,
					"order": 3134,
					"prevSize": 32,
					"code": 60302,
					"name": "wait",
					"tempChar": ""
				},
				{
					"id": 920,
					"order": 3135,
					"prevSize": 32,
					"code": 60303,
					"name": "wait2",
					"tempChar": ""
				},
				{
					"id": 1169,
					"order": 2470,
					"prevSize": 32,
					"code": 60552,
					"name": "wait3",
					"tempChar": ""
				},
				{
					"order": 1150,
					"prevSize": 32,
					"ligatures": "wall, bricks",
					"name": "wall",
					"id": 2961,
					"code": 62344,
					"tempChar": ""
				},
				{
					"order": 274,
					"prevSize": 32,
					"ligatures": "wallet, money7",
					"name": "wallet",
					"id": 2085,
					"code": 60834,
					"tempChar": ""
				},
				{
					"id": 921,
					"order": 3136,
					"prevSize": 32,
					"code": 60304,
					"name": "warm",
					"tempChar": ""
				},
				{
					"id": 922,
					"order": 3137,
					"prevSize": 32,
					"code": 60305,
					"name": "warm2",
					"tempChar": ""
				},
				{
					"id": 1170,
					"order": 2471,
					"prevSize": 32,
					"code": 60553,
					"name": "warm3",
					"tempChar": ""
				},
				{
					"order": 1105,
					"prevSize": 32,
					"ligatures": "warning, sign",
					"name": "warning",
					"id": 2916,
					"code": 62299,
					"tempChar": ""
				},
				{
					"order": 1106,
					"prevSize": 32,
					"ligatures": "warning2, sign2",
					"name": "warning2",
					"id": 2917,
					"code": 62300,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "warning, alert",
					"order": 3284,
					"name": "warning4",
					"id": 219,
					"code": 59516,
					"tempChar": ""
				},
				{
					"id": 923,
					"order": 3138,
					"prevSize": 32,
					"code": 60306,
					"name": "wash",
					"tempChar": ""
				},
				{
					"id": 924,
					"order": 3139,
					"prevSize": 32,
					"code": 60307,
					"name": "wash2",
					"tempChar": ""
				},
				{
					"id": 1171,
					"order": 2472,
					"prevSize": 32,
					"code": 60554,
					"name": "wash3",
					"tempChar": ""
				},
				{
					"order": 339,
					"prevSize": 32,
					"ligatures": "watch, time6",
					"name": "watch",
					"id": 2150,
					"code": 60899,
					"tempChar": ""
				},
				{
					"order": 340,
					"prevSize": 32,
					"ligatures": "watch2, time7",
					"name": "watch2",
					"id": 2151,
					"code": 60900,
					"tempChar": ""
				},
				{
					"id": 925,
					"order": 3140,
					"prevSize": 32,
					"code": 60308,
					"name": "watch3",
					"tempChar": ""
				},
				{
					"id": 926,
					"order": 3141,
					"prevSize": 32,
					"code": 60309,
					"name": "watch4",
					"tempChar": ""
				},
				{
					"id": 1172,
					"order": 2473,
					"prevSize": 32,
					"code": 60555,
					"name": "watch5",
					"tempChar": ""
				},
				{
					"order": 1203,
					"prevSize": 32,
					"ligatures": "wave2",
					"name": "wave",
					"id": 3014,
					"code": 62397,
					"tempChar": ""
				},
				{
					"order": 1204,
					"prevSize": 32,
					"ligatures": "wave3",
					"name": "wave2",
					"id": 3015,
					"code": 62398,
					"tempChar": ""
				},
				{
					"id": 927,
					"order": 3142,
					"prevSize": 32,
					"code": 60310,
					"name": "wear",
					"tempChar": ""
				},
				{
					"id": 928,
					"order": 3143,
					"prevSize": 32,
					"code": 60311,
					"name": "wear2",
					"tempChar": ""
				},
				{
					"id": 1173,
					"order": 2474,
					"prevSize": 32,
					"code": 60556,
					"name": "wear3",
					"tempChar": ""
				},
				{
					"order": 970,
					"prevSize": 32,
					"ligatures": "weather-cloud-sun, weather14",
					"name": "weather-cloud-sun",
					"id": 2781,
					"code": 62164,
					"tempChar": ""
				},
				{
					"order": 971,
					"prevSize": 32,
					"ligatures": "weather-cloud-sun2, weather15",
					"name": "weather-cloud-sun2",
					"id": 2782,
					"code": 62165,
					"tempChar": ""
				},
				{
					"order": 968,
					"prevSize": 32,
					"ligatures": "weather-cloud-wind, weather12",
					"name": "weather-cloud-wind",
					"id": 2779,
					"code": 62162,
					"tempChar": ""
				},
				{
					"order": 969,
					"prevSize": 32,
					"ligatures": "weather-cloud-wind2, weather13",
					"name": "weather-cloud-wind2",
					"id": 2780,
					"code": 62163,
					"tempChar": ""
				},
				{
					"order": 972,
					"prevSize": 32,
					"ligatures": "weather-cloudy, weather16",
					"name": "weather-cloudy",
					"id": 2783,
					"code": 62166,
					"tempChar": ""
				},
				{
					"order": 973,
					"prevSize": 32,
					"ligatures": "weather-cloudy2, weather17",
					"name": "weather-cloudy2",
					"id": 2784,
					"code": 62167,
					"tempChar": ""
				},
				{
					"order": 962,
					"prevSize": 32,
					"ligatures": "weather-lightning, weather6",
					"name": "weather-lightning",
					"id": 2773,
					"code": 62156,
					"tempChar": ""
				},
				{
					"order": 963,
					"prevSize": 32,
					"ligatures": "weather-lightning2, weather7",
					"name": "weather-lightning2",
					"id": 2774,
					"code": 62157,
					"tempChar": ""
				},
				{
					"order": 964,
					"prevSize": 32,
					"ligatures": "weather-rain, weather8",
					"name": "weather-rain",
					"id": 2775,
					"code": 62158,
					"tempChar": ""
				},
				{
					"order": 965,
					"prevSize": 32,
					"ligatures": "weather-rain2, weather9",
					"name": "weather-rain2",
					"id": 2776,
					"code": 62159,
					"tempChar": ""
				},
				{
					"order": 966,
					"prevSize": 32,
					"ligatures": "weather-snow, weather10",
					"name": "weather-snow",
					"id": 2777,
					"code": 62160,
					"tempChar": ""
				},
				{
					"order": 967,
					"prevSize": 32,
					"ligatures": "weather-snow2, weather11",
					"name": "weather-snow2",
					"id": 2778,
					"code": 62161,
					"tempChar": ""
				},
				{
					"order": 974,
					"prevSize": 32,
					"ligatures": "weather-sun-wind, weather18",
					"name": "weather-sun-wind",
					"id": 2785,
					"code": 62168,
					"tempChar": ""
				},
				{
					"order": 975,
					"prevSize": 32,
					"ligatures": "weather-sun-wind2, weather19",
					"name": "weather-sun-wind2",
					"id": 2786,
					"code": 62169,
					"tempChar": ""
				},
				{
					"order": 981,
					"prevSize": 32,
					"ligatures": "weather-windy, weather22",
					"name": "weather-windy",
					"id": 2792,
					"code": 62175,
					"tempChar": ""
				},
				{
					"id": 929,
					"order": 3144,
					"prevSize": 32,
					"code": 60312,
					"name": "weave",
					"tempChar": ""
				},
				{
					"id": 930,
					"order": 3145,
					"prevSize": 32,
					"code": 60313,
					"name": "weave2",
					"tempChar": ""
				},
				{
					"name": "wechat, weixin",
					"id": 1607,
					"order": 2040,
					"prevSize": 32,
					"code": 61911,
					"tempChar": ""
				},
				{
					"name": "weibo",
					"id": 1535,
					"order": 1968,
					"prevSize": 32,
					"code": 61834,
					"tempChar": ""
				},
				{
					"id": 931,
					"order": 3146,
					"prevSize": 32,
					"code": 60314,
					"name": "weigh",
					"tempChar": ""
				},
				{
					"id": 932,
					"order": 3147,
					"prevSize": 32,
					"code": 60315,
					"name": "weigh2",
					"tempChar": ""
				},
				{
					"id": 1174,
					"order": 2475,
					"prevSize": 32,
					"code": 60557,
					"name": "weigh3",
					"tempChar": ""
				},
				{
					"id": 933,
					"order": 3148,
					"prevSize": 32,
					"code": 60316,
					"name": "weld",
					"tempChar": ""
				},
				{
					"id": 934,
					"order": 3149,
					"prevSize": 32,
					"code": 60317,
					"name": "weld2",
					"tempChar": ""
				},
				{
					"order": 1524,
					"prevSize": 32,
					"name": "whatsapp",
					"ligatures": "whatsapp, brand13",
					"id": 3335,
					"code": 62718,
					"tempChar": ""
				},
				{
					"name": "whatsapp2",
					"id": 1690,
					"order": 2123,
					"prevSize": 32,
					"code": 62002,
					"tempChar": ""
				},
				{
					"name": "wheelchair",
					"id": 1543,
					"order": 1976,
					"prevSize": 32,
					"code": 61843,
					"tempChar": ""
				},
				{
					"name": "wheelchair-alt",
					"id": 1789,
					"order": 2222,
					"prevSize": 32,
					"code": 62107,
					"tempChar": ""
				},
				{
					"prevSize": 32,
					"ligatures": "wheelchair, disabled",
					"order": 3241,
					"name": "wheelchair2",
					"id": 176,
					"code": 59473,
					"tempChar": ""
				},
				{
					"order": 1432,
					"prevSize": 32,
					"ligatures": "width, size2",
					"name": "width",
					"id": 3243,
					"code": 62626,
					"tempChar": ""
				},
				{
					"name": "wifi",
					"id": 1626,
					"order": 2059,
					"prevSize": 32,
					"code": 61931,
					"tempChar": ""
				},
				{
					"order": 1577,
					"prevSize": 32,
					"name": "wikipedia",
					"ligatures": "wikipedia, brand63",
					"id": 3388,
					"code": 62771,
					"tempChar": ""
				},
				{
					"name": "wikipedia-w",
					"id": 1739,
					"order": 2172,
					"prevSize": 32,
					"code": 62054,
					"tempChar": ""
				},
				{
					"id": 935,
					"order": 3150,
					"prevSize": 32,
					"code": 60318,
					"name": "win",
					"tempChar": ""
				},
				{
					"id": 936,
					"order": 3151,
					"prevSize": 32,
					"code": 60319,
					"name": "win2",
					"tempChar": ""
				},
				{
					"id": 1175,
					"order": 2476,
					"prevSize": 32,
					"code": 60558,
					"name": "win3",
					"tempChar": ""
				},
				{
					"order": 1570,
					"prevSize": 32,
					"ligatures": "windows, brand56",
					"name": "windows",
					"id": 3381,
					"code": 62764,
					"tempChar": ""
				},
				{
					"name": "windows2",
					"id": 1520,
					"order": 1953,
					"prevSize": 32,
					"code": 61818,
					"tempChar": ""
				},
				{
					"order": 1571,
					"prevSize": 32,
					"ligatures": "windows8, brand57",
					"name": "windows8",
					"id": 3382,
					"code": 62765,
					"tempChar": ""
				},
				{
					"order": 1036,
					"prevSize": 32,
					"ligatures": "wink, emoticon9",
					"name": "wink",
					"id": 2847,
					"code": 62230,
					"tempChar": ""
				},
				{
					"order": 1037,
					"prevSize": 32,
					"ligatures": "wink2, emoticon10",
					"name": "wink2",
					"id": 2848,
					"code": 62231,
					"tempChar": ""
				},
				{
					"order": 1022,
					"prevSize": 32,
					"ligatures": "woman, female",
					"name": "woman",
					"id": 2833,
					"code": 62216,
					"tempChar": ""
				},
				{
					"order": 1056,
					"prevSize": 32,
					"ligatures": "wondering, emoticon29",
					"name": "wondering",
					"id": 2867,
					"code": 62250,
					"tempChar": ""
				},
				{
					"order": 1057,
					"prevSize": 32,
					"ligatures": "wondering2, emoticon30",
					"name": "wondering2",
					"id": 2868,
					"code": 62251,
					"tempChar": ""
				},
				{
					"order": 1557,
					"prevSize": 32,
					"ligatures": "wordpress, brand44",
					"name": "wordpress",
					"id": 3368,
					"code": 62751,
					"tempChar": ""
				},
				{
					"name": "wordpress2",
					"id": 1550,
					"order": 1983,
					"prevSize": 32,
					"code": 61850,
					"tempChar": ""
				},
				{
					"id": 937,
					"order": 3152,
					"prevSize": 32,
					"code": 60320,
					"name": "work",
					"tempChar": ""
				},
				{
					"id": 938,
					"order": 3153,
					"prevSize": 32,
					"code": 60321,
					"name": "work2",
					"tempChar": ""
				},
				{
					"id": 1176,
					"order": 2477,
					"prevSize": 32,
					"code": 60559,
					"name": "work3",
					"tempChar": ""
				},
				{
					"id": 939,
					"order": 3154,
					"prevSize": 32,
					"code": 60322,
					"name": "worship",
					"tempChar": ""
				},
				{
					"id": 940,
					"order": 3155,
					"prevSize": 32,
					"code": 60323,
					"name": "worship2",
					"tempChar": ""
				},
				{
					"name": "wpbeginner",
					"id": 1785,
					"order": 2218,
					"prevSize": 32,
					"code": 62103,
					"tempChar": ""
				},
				{
					"name": "wpforms",
					"id": 1786,
					"order": 2219,
					"prevSize": 32,
					"code": 62104,
					"tempChar": ""
				},
				{
					"order": 602,
					"prevSize": 32,
					"ligatures": "wrench, tool",
					"name": "wrench",
					"id": 2413,
					"code": 61162,
					"tempChar": ""
				},
				{
					"order": 603,
					"prevSize": 32,
					"ligatures": "wrench2, tool2",
					"name": "wrench2",
					"id": 2414,
					"code": 61163,
					"tempChar": ""
				},
				{
					"order": 604,
					"prevSize": 32,
					"ligatures": "wrench3, tool3",
					"name": "wrench3",
					"id": 2415,
					"code": 61164,
					"tempChar": ""
				},
				{
					"name": "wrench4",
					"id": 1342,
					"order": 1775,
					"prevSize": 32,
					"code": 61613,
					"tempChar": ""
				},
				{
					"id": 941,
					"order": 3156,
					"prevSize": 32,
					"code": 60324,
					"name": "write",
					"tempChar": ""
				},
				{
					"id": 942,
					"order": 3157,
					"prevSize": 32,
					"code": 60325,
					"name": "write2",
					"tempChar": ""
				},
				{
					"id": 1177,
					"order": 2478,
					"prevSize": 32,
					"code": 60560,
					"name": "write3",
					"tempChar": ""
				},
				{
					"order": 1588,
					"prevSize": 32,
					"ligatures": "xing, brand74",
					"name": "xing",
					"id": 3399,
					"code": 62782,
					"tempChar": ""
				},
				{
					"name": "xing-square",
					"id": 1504,
					"order": 1937,
					"prevSize": 32,
					"code": 61801,
					"tempChar": ""
				},
				{
					"order": 1589,
					"prevSize": 32,
					"ligatures": "xing2, brand75",
					"name": "xing2",
					"codes": [
						61231
					],
					"id": 3400,
					"code": 62783,
					"tempChar": ""
				},
				{
					"name": "xing3",
					"id": 1503,
					"order": 1936,
					"prevSize": 32,
					"code": 61800,
					"tempChar": ""
				},
				{
					"name": "y-combinator, yc",
					"id": 1699,
					"order": 2132,
					"prevSize": 32,
					"code": 62011,
					"tempChar": ""
				},
				{
					"order": 1564,
					"prevSize": 32,
					"ligatures": "yahoo, brand51",
					"name": "yahoo",
					"id": 3375,
					"code": 62758,
					"tempChar": ""
				},
				{
					"order": 1565,
					"prevSize": 32,
					"name": "yahoo2",
					"ligatures": "yahoo2",
					"id": 3376,
					"code": 62759,
					"tempChar": ""
				},
				{
					"name": "yahoo3",
					"id": 1554,
					"order": 1987,
					"prevSize": 32,
					"code": 61854,
					"tempChar": ""
				},
				{
					"id": 1178,
					"order": 2479,
					"prevSize": 32,
					"code": 60561,
					"name": "yell",
					"tempChar": ""
				},
				{
					"order": 1592,
					"prevSize": 32,
					"ligatures": "yelp, brand78",
					"name": "yelp",
					"id": 3403,
					"code": 62786,
					"tempChar": ""
				},
				{
					"name": "yelp2",
					"id": 1624,
					"order": 2057,
					"prevSize": 32,
					"code": 61929,
					"tempChar": ""
				},
				{
					"order": 1027,
					"prevSize": 32,
					"ligatures": "yin-yang",
					"name": "yin-yang",
					"id": 2838,
					"code": 62221,
					"tempChar": ""
				},
				{
					"name": "yoast",
					"id": 1809,
					"order": 2242,
					"prevSize": 32,
					"code": 62129,
					"tempChar": ""
				},
				{
					"order": 1534,
					"prevSize": 32,
					"ligatures": "youtube, brand21",
					"name": "youtube",
					"id": 3345,
					"code": 62728,
					"tempChar": ""
				},
				{
					"name": "youtube-play",
					"id": 1505,
					"order": 1938,
					"prevSize": 32,
					"code": 61802,
					"tempChar": ""
				},
				{
					"name": "youtube-square",
					"id": 1501,
					"order": 1934,
					"prevSize": 32,
					"code": 61798,
					"tempChar": ""
				},
				{
					"order": 1535,
					"prevSize": 32,
					"ligatures": "youtube2, brand22",
					"name": "youtube2",
					"id": 3346,
					"code": 62729,
					"tempChar": ""
				},
				{
					"name": "youtube3",
					"id": 1502,
					"order": 1935,
					"prevSize": 32,
					"code": 61799,
					"tempChar": ""
				},
				{
					"id": 943,
					"order": 3158,
					"prevSize": 32,
					"code": 60326,
					"name": "zip",
					"tempChar": ""
				},
				{
					"id": 944,
					"order": 3159,
					"prevSize": 32,
					"code": 60327,
					"name": "zip2",
					"tempChar": ""
				},
				{
					"order": 563,
					"prevSize": 32,
					"ligatures": "zoom-in, magnifier2",
					"name": "zoom-in",
					"id": 2374,
					"code": 61123,
					"tempChar": ""
				},
				{
					"order": 566,
					"prevSize": 32,
					"ligatures": "zoom-in2, magnifier5",
					"name": "zoom-in2",
					"id": 2377,
					"code": 61126,
					"tempChar": ""
				},
				{
					"order": 570,
					"prevSize": 32,
					"ligatures": "zoom-in3, magnifier9",
					"name": "zoom-in3",
					"id": 2381,
					"code": 61130,
					"tempChar": ""
				},
				{
					"order": 564,
					"prevSize": 32,
					"ligatures": "zoom-out, magnifier3",
					"name": "zoom-out",
					"id": 2375,
					"code": 61124,
					"tempChar": ""
				},
				{
					"order": 567,
					"prevSize": 32,
					"ligatures": "zoom-out2, magnifier6",
					"name": "zoom-out2",
					"id": 2378,
					"code": 61127,
					"tempChar": ""
				},
				{
					"order": 571,
					"prevSize": 32,
					"ligatures": "zoom-out3, magnifier10",
					"name": "zoom-out3",
					"id": 2382,
					"code": 61131,
					"tempChar": ""
				}
			],
			"id": 6,
			"metadata": {
				"name": "Untitled Set"
			},
			"height": 1024,
			"prevSize": 20,
			"icons": [
				{
					"id": 3359,
					"paths": [
						"M253 672.8c0.2 0.6 5.6 15.2 8.6 22.6 16.8 39.8 41 75.8 71.8 106.6s66.6 55 106.6 71.8c41.4 17.4 85.2 26.4 130.4 26.4s89.2-8.8 130.4-26.4c40-16.8 75.8-41 106.6-71.8s55-66.6 71.8-106.6c17.4-41.4 26.4-85.2 26.4-130.4s-8.8-89.2-26.4-130.4c-16.8-40-41-75.8-71.8-106.6s-66.6-55-106.6-71.8c-41.4-17.4-85.2-26.4-130.4-26.4-45.8 0-91.6 9.2-132.2 26.4-32.6 13.8-87.8 49.2-120 82.6l-0.2 0.2v-276h463.4c16.8-0.2 16.8-23.8 16.8-31.4 0-7.8 0-31.2-17-31.4h-501c-13.6 0-22 11.4-22 21.8v388.2c0 12.6 15.6 21.6 30.2 24.6 28.4 6 34.8-3 41.8-12.6l1-1.2c10.6-15.8 43.6-49 44-49.4 51.6-51.6 120.6-80 194.4-80 73.4 0 142.2 28.4 193.8 80 51.8 51.8 80.4 120.4 80.4 193.2 0 73-28.4 141.8-80 193.2-50.8 50.8-122 80-195 80-49.4 0-97.2-13.2-138.2-38.2l0.2-236c0-31.4 13.6-65.8 36.6-91.6 26.2-29.6 62.2-45.8 101.6-45.8 38 0 73.6 14.4 100.2 40.6 26.2 26 40.8 60.8 40.8 97.8 0 78.8-62 140.6-141.2 140.6-15.2 0-43-6.8-44.2-7-16-4.8-22.8 17.4-25 24.8-8.6 28.2 4.4 33.8 7 34.6 25.4 8 42.2 9.4 64.2 9.4 111.8 0 202.8-91 202.8-202.8 0-111-91-201.2-202.6-201.2-54.8 0-106.2 21-144.8 58.8-36.8 36.2-57.8 84.4-57.8 132.4v1.2c-0.2 6-0.2 147.6-0.4 194l-0.2-0.2c-21-23.2-41.8-58.8-55.6-95.2-5.4-14.2-17.6-11.8-34.2-6.6-8 2.2-30 9-25 25.2v0zM491.2 617.4c0 6.8 6.2 12.8 10 16.2l1.2 1.2c6.4 6.2 12.4 9.4 18 9.4 4.6 0 7.4-2.2 8.4-3.2 2.8-2.6 34.4-34.8 37.6-37.8l35.4 35.2c3.2 3.6 6.8 5.6 11 5.6 5.6 0 11.8-3.4 18.2-10 15.2-15.6 7.6-24 4-28l-35.8-35.8 37.4-37.6c8.2-8.8 1-18.2-6.2-25.4-10.4-10.4-20.6-13.2-27-7.2l-37.2 37.2-37.6-37.6c-2-2-4.6-3-7.2-3-5 0-11 3.4-17.6 10-11.6 11.6-14 19.6-8 26l37.6 37.4-37.4 37.4c-3.4 3.2-5 6.6-4.8 10zM573 109.8c-60 0-124 12.2-170.8 32.4-5 2-8 6-8.6 11.6-0.6 5.4 0.8 12.4 4.4 21.6 3 7.4 10.6 27.2 25.6 21.4 48-18.4 101.2-28.4 149.4-28.4 54.8 0 108 10.8 158 31.8 39.8 16.8 77.2 41.2 118 76.4 3 2.6 6.2 3.8 9.4 3.8 8 0 15.6-7.8 22.2-15.2 10.8-12.2 18.4-22.4 7.6-32.6-39-36.8-81.6-64.4-134.4-86.8-57.2-23.8-118.2-36-180.8-36zM896.4 851.2v0c-7.2-7.2-13.4-11.4-18.8-13s-10.4-0.4-14.2 3.4l-3.6 3.6c-37.2 37.2-80.6 66.4-128.8 86.8-50 21.2-103 31.8-157.6 31.8-54.8 0-107.8-10.8-157.6-31.8-48.2-20.4-91.6-49.6-128.8-86.8-38.8-38.8-68-82.2-86.8-128.8-18.4-45.6-24.4-79.8-26.4-91-0.2-1-0.4-1.8-0.4-2.4-2.6-13.2-14.8-14.2-32.2-11.4-7.2 1.2-29.4 4.6-27.4 20.4v0.4c5.8 37 16.2 73.2 30.8 107.6 23.4 55.4 57 105.2 99.8 148s92.6 76.2 148 99.8c57.4 24.2 118.4 36.6 181.2 36.6s123.8-12.4 181.2-36.6c55.4-23.4 105.2-57 148-99.8 0 0 2.4-2.4 3.8-3.8 4.4-5.4 8.6-14.4-10.2-33z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"500px",
						"brand",
						"social"
					],
					"defaultCode": 61194,
					"grid": 16
				},
				{
					"id": 1747,
					"width": 817.1399021148682,
					"paths": [
						"M800.571 884l-3.429 3.429q-64.571 65.143-148 100-88 36.571-181.143 36.571-94.286 0-181.143-36.571-84.571-36-148-100-64.571-64-100-147.429-24-58.857-30.857-108-2.286-16 27.429-20.571 29.143-4.571 32 11.429 0.571 0.571 0.571 2.286 10.286 51.429 26.286 90.857 28.571 70.857 86.857 129.143 56 56 129.143 86.857 75.429 32 157.714 32 81.714 0 157.714-32 73.143-31.429 128.571-86.857l3.429-3.429q5.714-5.714 14.286-3.429 6.857 1.714 18.857 12.571 20.571 21.143 9.714 33.143zM530.857 532.571l-37.714 37.714 36 36q12 12-4 28-9.714 9.714-18.286 9.714-5.714 0-10.857-5.714l-35.429-34.857-37.714 37.714q-2.857 2.857-8.571 2.857-8.571 0-17.714-9.143l-1.143-1.143q-10.286-8.571-10.286-16.571 0-4 4.571-9.714l37.714-37.143-37.714-37.714q-9.143-9.143 8-25.714 10.286-10.286 17.714-10.286 3.429 0 7.429 2.857l37.143 37.714 37.143-37.143q10.286-9.714 27.429 7.429 15.429 15.429 6.286 25.143zM800 565.143q0 67.429-26.286 130.286-25.714 60-72 106.286-45.714 45.714-106.857 72t-130.286 26.286-130.286-26.286-106.857-72q-46.857-46.857-71.429-106.286-8.571-18.286-8.571-22.857h-0.571q-5.143-15.429 24.571-25.143 28.571-9.143 34.286 6.857 21.143 56.571 55.429 95.429h0.571v-194.857q1.714-77.714 58.286-132.571 60-58.857 144.571-58.857 84 0 143.429 58.857t59.429 142.286q0 84-59.714 143.429t-143.143 59.429q-33.143 0-64-9.143-16-6.286-7.429-34.857 9.143-29.143 25.143-24.571l8 1.714q8 1.714 18.571 3.429t17.429 1.714q59.429 0 100.571-40.857t41.143-99.714q0-57.714-41.143-97.714-40.571-40.571-100-40.571-61.143 0-101.714 45.714-36.571 41.143-36.571 91.429v236q62.857 38.286 138.286 38.286 54.857 0 105.714-20.857t89.143-59.143 59.143-88.571 20.857-104.571q0-113.143-80.571-193.714-80-80-193.714-80-114.286 0-194.286 80-30.286 30.286-44 49.714l-1.143 1.143q-4.571 6.286-7.429 8.857t-12.286 5.429-22-1.714q-12-2.857-20.857-9.429t-8.857-15.143v-388.571q0-8.571 6-15.143t15.714-6.571h501.143q17.143 0 17.143 31.429t-17.143 31.429h-463.429v276h0.571q22.857-24 58.286-48t61.714-34.857q62.286-26.286 132-26.286 69.143 0 130.286 26.286t106.857 72q46.286 46.286 72 106.286 26.286 64 26.286 130.857zM782.286 233.143q5.143 4.571 5.143 10.286t-3.143 10.286-9.429 12q-14.857 14.857-22.286 14.857-5.143 0-9.143-4-60.571-52-118.286-76-73.143-32-157.714-32-76 0-149.714 28-15.429 5.714-25.714-21.143-5.143-14.286-4.571-21.714 1.714-9.143 9.143-11.429 74.286-32.571 170.857-32.571 93.714 0 180.571 36.571 78.286 33.143 134.286 86.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"500px"
					],
					"defaultCode": 62062,
					"grid": 14
				},
				{
					"id": 3407,
					"paths": [
						"M734.202 628.83h236.050c1.82-16.37 2.548-33.098 2.548-50.196 0-80.224-21.534-155.468-59.124-220.266 38.88-103.308 37.492-190.988-14.556-243.39-49.496-49.28-182.29-41.28-332.412 25.198-11.104-0.84-22.318-1.272-33.638-1.272-206.048 0-378.926 141.794-426.708 332.85 64.638-82.754 132.638-142.754 223.478-186.448-8.26 7.74-56.454 55.652-64.56 63.764-239.548 239.478-315.090 552.306-233.806 633.604 61.786 61.774 173.758 51.342 302.376-11.648 59.806 30.458 127.5 47.63 199.218 47.63 193.134 0 356.804-124.316 416.090-297.448h-237.868c-32.734 60.382-96.748 101.48-170.218 101.48-73.468 0-137.484-41.098-170.216-101.48-14.55-27.274-22.914-58.554-22.914-91.656v-0.722h386.26zM348.302 512.804c5.456-97.11 86.2-174.584 184.766-174.584s179.312 77.472 184.766 174.584h-369.532zM896.966 163.808c33.526 33.88 32.688 96.214 4.012 174.022-49.136-74.908-120.518-133.936-204.792-167.64 90.106-38.638 163.406-43.756 200.78-6.382zM93.482 967.256c-42.782-42.796-29.884-132.618 25.23-240.832 34.308 96.27 101.156 177.090 187.336 229.154-95.43 43.318-173.536 50.674-212.566 11.678z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"IE",
						"browser",
						"internet-explorer",
						"brand"
					],
					"defaultCode": 61242,
					"grid": 16
				},
				{
					"id": 3422,
					"paths": [
						"M259.544 511.998c0-65.416 53.030-118.446 118.446-118.446s118.446 53.030 118.446 118.446c0 65.416-53.030 118.446-118.446 118.446s-118.446-53.030-118.446-118.446zM512.004 0c-282.774 0-512.004 229.232-512.004 512s229.226 512 512.004 512c282.764 0 511.996-229.23 511.996-512 0-282.768-229.23-512-511.996-512zM379.396 959.282c-153.956-89.574-257.468-256.324-257.468-447.282s103.512-357.708 257.462-447.282c154.010 89.562 257.59 256.288 257.59 447.282 0 190.988-103.58 357.718-257.584 447.282z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"IcoMoon",
						"icomoon",
						"brand"
					],
					"defaultCode": 61257,
					"grid": 16
				},
				{
					"id": 2621,
					"paths": [
						"M416 96c0-53.018 42.98-96 96-96s96 42.982 96 96c0 53.020-42.98 96-96 96s-96-42.98-96-96z",
						"M640 320l329.596-142.172-23.77-59.424-401.826 137.596h-64l-401.826-137.596-23.77 59.424 329.596 142.172v256l-131.27 424.57 59.84 22.7 185.716-415.27h27.428l185.716 415.27 59.84-22.7-131.27-424.57z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"accessibility"
					],
					"defaultCode": 60456,
					"grid": 16
				},
				{
					"id": 2622,
					"paths": [
						"M1024 703.042l-98.876 65.916-189.124-256.958h-288v-64h256v-128h-256v-64l-128-32v416h352l209.124 278.834 199.628-133.084z",
						"M512 96c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M678.998 790.306c-57.786 83.206-154.022 137.694-262.998 137.694-176.732 0-320-143.27-320-320 0-123.944 70.47-231.42 173.524-284.572l-62.602-75.124c-123.742 72.084-206.922 206.168-206.922 359.696 0 229.75 186.25 416 416 416 134.14 0 253.43-63.508 329.502-162.074l-66.504-71.62z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"accessibility",
						"disabled"
					],
					"defaultCode": 60457,
					"grid": 16
				},
				{
					"id": 265,
					"width": 1024,
					"paths": [
						"M768 736h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM768 832h-64v-64h64v64zM320 736h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM320 832h-64v-64h64v64zM768 384h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM768 480h-64v-64h64v64zM320 384h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM320 480h-64v-64h64v64zM544 384h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM544 480h-64v-64h64v64zM768 192h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM768 288h-64v-64h64v64zM320 192h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM320 288h-64v-64h64v64zM544 192h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM544 288h-64v-64h64v64zM928 48v0c0-8.832-7.168-16-16-16h-800c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h16v512h-16c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h16v288c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-288h16c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-16v-512h16c8.832 0 16-7.168 16-16zM576 960h-128v-168.928l64-21.344 64 21.344v168.928zM864 896c0 35.296-28.704 64-64 64h-192v-192l-96-32-96 32v192h-192c-35.296 0-64-28.704-64-64v-224h704v224zM864 640h-704v-32h704v32zM864 576h-704v-448h704v448zM864 96h-704v-32h704v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"accommodate",
						"home",
						"live",
						"reside"
					],
					"grid": 32
				},
				{
					"id": 266,
					"width": 1024,
					"paths": [
						"M480 224h64v64h-64v-64zM704 480h64v-64h-64v64zM480 480h64v-64h-64v64zM112 64h800c8.832 0 16-7.168 16-16s-7.168-16-16-16h-800c-8.832 0-16 7.168-16 16s7.168 16 16 16zM256 288h64v-64h-64v64zM256 480h64v-64h-64v64zM704 288h64v-64h-64v64zM256 832h64v-64h-64v64zM480 814.144v177.856h64v-177.856l-32-10.656-32 10.656zM896 640v256c0 53.024-42.976 96-96 96h-224v-200.928l-64-21.344-64 21.344v200.928h-224c-53.024 0-96-42.976-96-96v-256h768zM352 768c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM800 768c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM896 96v480h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-800c-8.832 0-16-7.168-16-16s7.168-16 16-16h16v-480h768zM352 416c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM352 224c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM576 416c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM576 224c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM800 416c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM800 224c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM704 832h64v-64h-64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"accommodate",
						"home",
						"live",
						"reside"
					],
					"grid": 32
				},
				{
					"id": 945,
					"width": 1024,
					"paths": [
						"M864 0h-704c-17.664 0-32 14.336-32 32v0.64c0 17.312 14.048 31.36 31.36 31.36h0.64c0 17.664 14.336 32 32 32v896c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-896c17.664 0 32-14.336 32-32h0.64c17.312 0 31.36-14.048 31.36-31.36v-0.64c0-17.664-14.336-32-32-32zM576 960h-128v-192h128v192zM768 960h-160v-224h-192v224h-160v-896h512v896zM416 512h-128v160h128v-160zM384 640h-64v-96h64v96zM576 512h-128v160h128v-160zM544 640h-64v-96h64v96zM736 512h-128v160h128v-160zM704 640h-64v-96h64v96zM416 320h-128v160h128v-160zM384 448h-64v-96h64v96zM576 320h-128v160h128v-160zM544 448h-64v-96h64v96zM736 320h-128v160h128v-160zM704 448h-64v-96h64v96zM416 128h-128v160h128v-160zM384 256h-64v-96h64v96zM576 128h-128v160h128v-160zM544 256h-64v-96h64v96zM736 128h-128v160h128v-160zM704 256h-64v-96h64v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"accommodate",
						"build",
						"home",
						"live"
					],
					"grid": 32
				},
				{
					"id": 267,
					"width": 1024,
					"paths": [
						"M960 688v0c0-8.832-7.168-16-16-16h-144v-32c0-17.664-14.336-32-32-32h-160c-53.024 0-96 42.976-96 96v32h-268.544c-78.688 0-145.408-61.632-147.392-140.288-1.92-75.648 54.848-138.72 127.936-146.816v91.744c0 70.752 55.968 130.656 126.72 131.36 71.584 0.704 129.984-57.696 129.28-129.28-0.704-70.752-60.608-126.72-131.36-126.72h-92.64v-128h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32v0-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64v128.704c-90.592 8.192-161.6 85.376-159.968 178.432 1.696 96.704 83.584 172.864 180.288 172.864h267.68v32c0 53.024 42.976 96 96 96h160c17.664 0 32-14.336 32-32v-32h144c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-144v-96h144c8.832 0 16-7.168 16-16zM192 128h96v32h-96v-32zM160 192h160v64h-160v-64zM352 448c52.928 0 96 43.072 96 96s-43.072 96-96 96-96-43.072-96-96v-96h96zM768 864h-160c-35.296 0-64-28.704-64-64v-96c0-35.296 28.704-64 64-64h160v224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"adapt",
						"charge",
						"power"
					],
					"grid": 32
				},
				{
					"id": 268,
					"width": 1024,
					"paths": [
						"M944 800h-144v-96h144c8.832 0 16-7.168 16-16s-7.168-16-16-16h-144v-32c0-17.664-14.336-32-32-32h-160c-53.024 0-96 42.976-96 96v32h-268.544c-78.688 0-145.408-61.632-147.392-140.288-1.92-75.648 54.848-138.72 127.936-146.816v91.744c0 70.752 55.968 130.656 126.72 131.36 71.584 0.704 129.984-57.696 129.28-129.28-0.704-70.752-60.608-126.72-131.36-126.72h-92.64v-128h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64v128.704c-90.592 8.192-161.6 85.376-159.968 178.432 1.696 96.704 83.584 172.864 180.288 172.864h267.68v32c0 53.024 42.976 96 96 96h160c17.664 0 32-14.336 32-32v-32h144c8.832 0 16-7.168 16-16s-7.168-16-16-16zM256 448h96c52.928 0 96 43.072 96 96s-43.072 96-96 96-96-43.072-96-96v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"adapt",
						"charge",
						"power"
					],
					"grid": 32
				},
				{
					"id": 269,
					"width": 1024,
					"paths": [
						"M0 128v736c0 53.024 42.976 96 96 96h832c53.024 0 96-42.976 96-96v-736c0-53.024-42.976-96-96-96h-832c-53.024 0-96 42.976-96 96zM928 928h-832c-35.36 0-64-28.64-64-64v-736c0-35.36 28.64-64 64-64h832c35.36 0 64 28.64 64 64v736c0 35.36-28.64 64-64 64zM928 96h-832c-17.664 0-32 14.336-32 32v736c0 17.664 14.336 32 32 32h832c17.664 0 32-14.336 32-32v-736c0-17.664-14.336-32-32-32zM928 128v128h-32v-16c0-26.496-21.504-48-48-48-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-384v-16c0-26.496-21.504-48-48-48-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448s-23.488 4.8-32 12.448c-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-32v-128h832zM848 640c-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448s-23.488 4.8-32 12.448c-8.512-7.648-19.648-12.448-32-12.448s-23.488 4.8-32 12.448c-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-384v-16c0-26.496-21.504-48-48-48s-48 21.504-48 48v16h-32v-192h32v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448s23.488-4.8 32-12.448c8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h384v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h32v192h-32v-16c0-26.496-21.504-48-48-48zM832 688c0-8.832 7.168-16 16-16s16 7.168 16 16v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64zM768 688c0-8.832 7.168-16 16-16s16 7.168 16 16v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64zM704 688c0-8.832 7.168-16 16-16s16 7.168 16 16v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64zM672 752c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16v64zM192 688v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16zM192 528c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16v64zM256 528c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16v64zM288 464c0-8.832 7.168-16 16-16s16 7.168 16 16v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64zM800 528c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16v64zM832 464c0-8.832 7.168-16 16-16s16 7.168 16 16v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64zM896 480v-16c0-26.496-21.504-48-48-48-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-384v-16c0-26.496-21.504-48-48-48-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448s-23.488 4.8-32 12.448c-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-32v-192h32v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448s23.488-4.8 32-12.448c8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h384v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h32v192h-32zM192 304c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16v64zM256 304c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16v64zM288 240c0-8.832 7.168-16 16-16s16 7.168 16 16v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64zM800 304c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16v64zM832 240c0-8.832 7.168-16 16-16s16 7.168 16 16v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64zM96 864v-128h32v16c0 26.496 21.504 48 48 48s48-21.504 48-48v-16h384v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448s23.488-4.8 32-12.448c8.512 7.648 19.648 12.448 32 12.448s23.488-4.8 32-12.448c8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h32v128h-832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"add",
						"calculate",
						"play"
					],
					"grid": 32
				},
				{
					"id": 270,
					"width": 1024,
					"paths": [
						"M928 32h-832c-53.024 0-96 42.976-96 96v736c0 53.024 42.976 96 96 96h832c53.024 0 96-42.976 96-96v-736c0-53.024-42.976-96-96-96zM96 96h832c17.664 0 32 14.336 32 32v128h-64v-16c0-26.496-21.504-48-48-48-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-384v-16c0-26.496-21.504-48-48-48-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448s-23.488 4.8-32 12.448c-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-64v-128c0-17.664 14.336-32 32-32zM848 640c-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448s-23.488 4.8-32 12.448c-8.512-7.648-19.648-12.448-32-12.448s-23.488 4.8-32 12.448c-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-384v-16c0-26.496-21.504-48-48-48s-48 21.504-48 48v16h-64v-192h64v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448s23.488-4.8 32-12.448c8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h384v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h64v192h-64v-16c0-26.496-21.504-48-48-48zM896 480v-16c0-26.496-21.504-48-48-48-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-384v-16c0-26.496-21.504-48-48-48-12.352 0-23.488 4.8-32 12.448-8.512-7.648-19.648-12.448-32-12.448s-23.488 4.8-32 12.448c-8.512-7.648-19.648-12.448-32-12.448-26.496 0-48 21.504-48 48v16h-64v-192h64v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448s23.488-4.8 32-12.448c8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h384v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h64v192h-64zM928 896h-832c-17.664 0-32-14.336-32-32v-128h64v16c0 26.496 21.504 48 48 48s48-21.504 48-48v-16h384v16c0 26.496 21.504 48 48 48 12.352 0 23.488-4.8 32-12.448 8.512 7.648 19.648 12.448 32 12.448s23.488-4.8 32-12.448c8.512 7.648 19.648 12.448 32 12.448s23.488-4.8 32-12.448c8.512 7.648 19.648 12.448 32 12.448 26.496 0 48-21.504 48-48v-16h64v128c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"add",
						"calculate",
						"play"
					],
					"grid": 32
				},
				{
					"id": 946,
					"width": 1024,
					"paths": [
						"M512 0c-282.784 0-512 229.216-512 512s229.216 512 512 512 512-229.216 512-512-229.216-512-512-512zM512 960c-247.040 0-448-200.96-448-448s200.96-448 448-448c247.040 0 448 200.96 448 448s-200.96 448-448 448zM736 448h-160v-160c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v160h-160c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h160v160c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-160h160c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM736 544h-192v192h-64v-192h-192v-64h192v-192h64v192h192v64zM512 96c-229.76 0-416 186.24-416 416s186.24 416 416 416 416-186.24 416-416-186.24-416-416-416zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"add",
						"include"
					],
					"grid": 32
				},
				{
					"id": 2112,
					"paths": [
						"M192 0v1024h768v-1024h-768zM576 256.33c70.51 0 127.67 57.16 127.67 127.67s-57.16 127.67-127.67 127.67-127.67-57.16-127.67-127.67 57.16-127.67 127.67-127.67v0zM768 768h-384v-64c0-70.696 57.306-128 128-128v0h128c70.696 0 128 57.304 128 128v64z",
						"M64 64h96v192h-96v-192z",
						"M64 320h96v192h-96v-192z",
						"M64 576h96v192h-96v-192z",
						"M64 832h96v192h-96v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"address-book",
						"contact",
						"book",
						"contacts"
					],
					"defaultCode": 59947,
					"grid": 16
				},
				{
					"id": 2113,
					"paths": [
						"M928 512h32c35.346 0 64-28.654 64-64v-128h-96v192z",
						"M928 64v192h32c35.346 0 64-28.654 64-64v-128h-96z",
						"M896 576v-576h-832c-35.2 0-64 28.798-64 64v896c0 35.2 28.794 64 64 64h832v-448zM512 256.33c70.51 0 127.67 57.16 127.67 127.67s-57.16 127.67-127.67 127.67-127.67-57.16-127.67-127.67 57.16-127.67 127.67-127.67zM192 960h-64v-896h64v896zM704 768h-384v-64c0-70.696 57.306-128 128-128h128c70.696 0 128 57.304 128 128v64z",
						"M928 768h32c35.346 0 64-28.654 64-64v-128h-96v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"address-book",
						"contacts",
						"book"
					],
					"defaultCode": 59948,
					"grid": 16
				},
				{
					"id": 2114,
					"paths": [
						"M864 64h-704c-17.672 0-32 14.328-32 32v96h-64c-35.346 0-64 28.654-64 64s28.654 64 64 64h64v64h-64c-35.346 0-64 28.654-64 64s28.654 64 64 64h64v64h-64c-35.346 0-64 28.654-64 64s28.654 64 64 64h64v64h-64c-35.346 0-64 28.654-64 64s28.654 64 64 64h64v96c0 17.674 14.328 32 32 32h704c52.936 0 96-43.064 96-96v-768c0-52.934-43.064-96-96-96zM320 960h-128v-64c35.346 0 64-28.654 64-64s-28.654-64-64-64v-64c35.346 0 64-28.654 64-64s-28.654-64-64-64v-64c35.346 0 64-28.654 64-64s-28.654-64-64-64v-64c35.346 0 64-28.654 64-64s-28.654-64-64-64v-64h128v832zM768 384h-103.078c-16.084 44.354-24.922 100.822-24.922 160s8.838 115.648 24.922 160h103.078v192h-64c-33.776 0-66.26-13.926-93.944-40.272-21.35-20.316-39.872-47.936-55.050-82.088-27.732-62.4-43.006-143.954-43.006-229.64s15.274-167.24 43.006-229.64c15.18-34.154 33.702-61.772 55.050-82.088 27.684-26.346 60.17-40.272 93.944-40.272h64v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"address-book",
						"contact",
						"book",
						"contacts"
					],
					"defaultCode": 59949,
					"grid": 16
				},
				{
					"id": 1241,
					"width": 877.7139282226562,
					"paths": [
						"M438.857 822.857v-621.714q-84.571 0-156 41.714t-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"adjust"
					],
					"defaultCode": 61506,
					"grid": 14
				},
				{
					"id": 271,
					"width": 1024,
					"paths": [
						"M960 384h-52.288c-6.848-21.216-15.52-41.6-25.536-61.152l37.12-37.12c24.992-24.992 24.992-65.504 0-90.496l-90.496-90.496c-12.512-12.512-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-37.12 37.12c-19.584-10.080-39.968-18.72-61.184-25.568v-52.288c0-35.36-28.64-64-64-64h-128c-35.36 0-64 28.64-64 64v52.288c-21.216 6.848-41.6 15.52-61.152 25.536l-37.12-37.12c-12.512-12.48-28.864-18.752-45.248-18.752s-32.768 6.272-45.248 18.752l-90.528 90.496c-24.992 24.992-24.992 65.504 0 90.496l37.12 37.12c-10.048 19.584-18.688 39.968-25.536 61.184h-52.288c-35.36 0-64 28.64-64 64v128c0 35.36 28.64 64 64 64h52.288c6.848 21.216 15.52 41.6 25.536 61.152l-37.12 37.12c-24.992 24.992-24.992 65.504 0 90.496l90.496 90.496c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l37.12-37.12c19.584 10.016 39.936 18.688 61.152 25.536v52.32c0 35.36 28.64 64 64 64h128c35.36 0 64-28.64 64-64v-52.288c21.216-6.848 41.6-15.52 61.152-25.536l37.12 37.12c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l90.496-90.496c24.992-24.992 24.992-65.504 0-90.496l-37.12-37.12c10.016-19.584 18.688-39.936 25.536-61.152h52.352c35.36 0 64-28.64 64-64v-128c0-35.392-28.64-64.032-64-64.032zM992 576c0 17.632-14.368 32-32 32h-75.584l-7.168 22.144c-6.048 18.72-13.984 37.696-23.584 56.416l-10.624 20.736 53.6 53.6c12.48 12.48 12.48 32.768 0 45.248l-90.496 90.496c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376l-53.6-53.6-20.736 10.624c-18.72 9.6-37.728 17.536-56.416 23.584l-22.144 7.2v75.552c0 17.632-14.368 32-32 32h-128c-17.632 0-32-14.368-32-32v-75.584l-22.144-7.168c-18.72-6.048-37.696-13.984-56.416-23.584l-20.736-10.624-53.6 53.6c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376l-90.496-90.496c-12.48-12.48-12.48-32.768 0-45.248l53.6-53.6-10.624-20.736c-9.6-18.72-17.536-37.728-23.584-56.416l-7.2-22.144h-75.552c-17.632 0-32-14.368-32-32v-128c0-17.632 14.368-32 32-32h75.584l7.168-22.144c6.048-18.688 13.984-37.696 23.584-56.416l10.624-20.736-53.632-53.632c-6.048-6.016-9.376-14.048-9.376-22.592s3.328-16.576 9.376-22.624l90.496-90.496c6.048-6.048 14.080-9.376 22.624-9.376s16.576 3.328 22.624 9.376l53.6 53.6 20.736-10.624c18.72-9.6 37.728-17.536 56.416-23.584l22.176-7.2v-75.552c0-17.632 14.368-32 32-32h128c17.632 0 32 14.368 32 32v75.584l22.144 7.168c18.72 6.048 37.696 13.984 56.416 23.584l20.736 10.624 53.6-53.6c6.048-6.048 14.080-9.376 22.624-9.376s16.576 3.328 22.624 9.376l90.496 90.496c6.048 6.048 9.376 14.080 9.376 22.624s-3.328 16.576-9.376 22.624l-53.6 53.6 10.624 20.736c9.6 18.752 17.536 37.728 23.584 56.416l7.2 22.144h75.552c17.632 0 32 14.368 32 32v128zM512 352c-88.352 0-160 71.648-160 160s71.648 160 160 160 160-71.648 160-160-71.648-160-160-160zM512 640c-70.592 0-128-57.408-128-128s57.408-128 128-128 128 57.408 128 128c0 70.592-57.408 128-128 128zM512 416c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM512 576c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"adjust",
						"edit",
						"calibrate",
						"turn"
					],
					"grid": 32
				},
				{
					"id": 272,
					"width": 1024,
					"paths": [
						"M512 384c-70.592 0-128 57.408-128 128s57.408 128 128 128 128-57.408 128-128c0-70.592-57.408-128-128-128zM512 608c-53.024 0-96-42.976-96-96s42.976-96 96-96 96 42.976 96 96-42.976 96-96 96zM576 512c0 35.296-28.704 64-64 64s-64-28.704-64-64c0-35.296 28.704-64 64-64s64 28.704 64 64zM960 384h-52.288c-6.848-21.216-15.52-41.6-25.536-61.152l37.12-37.12c24.992-24.992 24.992-65.504 0-90.496l-90.496-90.496c-12.512-12.512-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-37.12 37.12c-19.584-10.080-39.968-18.72-61.184-25.568v-52.288c0-35.36-28.64-64-64-64h-128c-35.36 0-64 28.64-64 64v52.288c-21.216 6.848-41.6 15.52-61.152 25.536l-37.12-37.12c-12.512-12.48-28.864-18.752-45.248-18.752s-32.768 6.272-45.248 18.752l-90.528 90.496c-24.992 24.992-24.992 65.504 0 90.496l37.12 37.12c-10.048 19.584-18.688 39.968-25.536 61.184h-52.288c-35.36 0-64 28.64-64 64v128c0 35.36 28.64 64 64 64h52.288c6.848 21.216 15.52 41.6 25.536 61.152l-37.12 37.12c-24.992 24.992-24.992 65.504 0 90.496l90.496 90.496c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l37.12-37.12c19.584 10.016 39.936 18.688 61.152 25.536v52.32c0 35.36 28.64 64 64 64h128c35.36 0 64-28.64 64-64v-52.288c21.216-6.848 41.6-15.52 61.152-25.536l37.12 37.12c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l90.496-90.496c24.992-24.992 24.992-65.504 0-90.496l-37.12-37.12c10.016-19.584 18.688-39.936 25.536-61.152h52.352c35.36 0 64-28.64 64-64v-128c0-35.392-28.64-64.032-64-64.032zM512 672c-88.352 0-160-71.648-160-160s71.648-160 160-160 160 71.648 160 160-71.648 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"adjust",
						"edit",
						"calibrate",
						"turn"
					],
					"grid": 32
				},
				{
					"id": 947,
					"width": 1024,
					"paths": [
						"M512 160c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zM512 832c-176.448 0-320-143.552-320-320s143.552-320 320-320 320 143.552 320 320c0 176.448-143.552 320-320 320zM512 416c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM512 576c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64zM992 384h-50.784c-20.256-68.064-56.384-129.152-103.904-179.424l25.568-44.256c8.832-15.296 3.584-34.88-11.712-43.712l-166.272-96c-5.024-2.912-10.528-4.288-15.968-4.288-11.072 0-21.824 5.728-27.744 16l-25.536 44.224c-33.344-7.904-67.904-12.544-103.648-12.544s-70.304 4.64-103.616 12.544l-25.536-44.224c-5.92-10.272-16.672-16-27.744-16-5.44 0-10.944 1.376-15.968 4.288l-166.272 96c-15.296 8.832-20.544 28.384-11.712 43.712l25.568 44.256c-47.552 50.272-83.648 111.36-103.936 179.424h-50.784c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h50.784c20.256 68.064 56.384 129.152 103.904 179.424l-25.536 44.256c-8.832 15.296-3.584 34.88 11.712 43.712l166.272 96c5.024 2.912 10.528 4.288 15.968 4.288 11.072 0 21.824-5.728 27.744-16l25.536-44.224c33.312 7.904 67.872 12.544 103.616 12.544s70.304-4.64 103.616-12.544l25.536 44.224c5.92 10.272 16.672 16 27.744 16 5.44 0 10.944-1.376 15.968-4.288l166.272-96c15.296-8.832 20.544-28.416 11.712-43.712l-25.568-44.256c47.52-50.272 83.648-111.36 103.904-179.424h50.816c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32zM960 576h-66.528l-13.632 45.728c-16.928 56.832-47.712 109.984-89.088 153.728l-32.768 34.656 33.408 57.856-110.848 64-33.344-57.792-46.368 11.008c-30.208 7.168-60.096 10.816-88.832 10.816s-58.624-3.648-88.832-10.816l-46.368-11.008-33.344 57.792-110.848-64 33.408-57.856-32.768-34.656c-41.344-43.744-72.16-96.896-89.088-153.728l-13.632-45.728h-66.528v-128h66.528l13.632-45.728c16.928-56.832 47.744-109.984 89.088-153.728l32.768-34.656-33.44-57.856 110.848-64 33.344 57.792 46.368-11.008c30.24-7.168 60.128-10.816 88.864-10.816s58.624 3.648 88.832 10.816l46.368 11.008 33.344-57.792 110.848 64-33.408 57.856 32.768 34.656c41.344 43.744 72.16 96.896 89.088 153.728l13.632 45.728h66.528v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"adjust",
						"edit",
						"calibrate"
					],
					"grid": 32
				},
				{
					"id": 1510,
					"width": 877.7139282226562,
					"paths": [
						"M438.857 355.429l114.857 174.857h-229.714zM647.429 658.286h53.714l-262.286-394.857-262.286 394.857h53.714l59.429-91.429h298.286zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"adn"
					],
					"defaultCode": 61808,
					"grid": 14
				},
				{
					"id": 273,
					"width": 1024,
					"paths": [
						"M993.344 186.592c-12.192-16.896-31.104-26.592-51.936-26.592-43.2 0-85.6 14.88-119.36 41.856l-246.048 196.832v-46.688c0-22.688-11.872-42.496-29.664-53.856l17.12-59.968c8.64-30.208 30.656-53.312 60.448-63.328 29.728-10.048 61.28-4.96 86.464 13.92 7.104 5.312 17.12 3.904 22.4-3.2 5.312-7.072 3.872-17.088-3.2-22.4-33.184-24.896-76.48-31.904-115.84-18.656-39.328 13.248-69.632 44.96-81.024 84.864l-16.864 59.008c-1.312-0.064-2.528-0.384-3.84-0.384s-2.528 0.32-3.808 0.384l-16.864-59.008c-11.392-39.904-41.696-71.616-81.024-84.864-39.36-13.28-82.656-6.272-115.84 18.656-7.072 5.312-8.512 15.328-3.2 22.4s15.328 8.48 22.4 3.2c25.184-18.88 56.672-23.936 86.464-13.92s51.84 33.088 60.448 63.328l17.12 59.968c-17.824 11.36-29.696 31.168-29.696 53.856v46.688l-246.048-196.832c-33.76-26.976-76.16-41.856-119.36-41.856-20.832 0-39.744 9.696-51.936 26.592s-15.36 37.92-8.768 57.664l58.368 175.2c12.064 36.192 44.416 61.792 82.4 65.248l190.048 17.28-122.976 24.608c-26.976 5.376-50.4 22.144-64.192 45.952-13.824 23.808-16.736 52.416-8.032 78.528l79.808 239.424c10.624 31.904 38.112 52.8 71.68 54.592 1.504 0.064 3.040 0.128 4.512 0.128 31.712 0 59.232-17.664 72.512-46.912l61.984-136.448v38.144c0 35.36 28.64 64 64 64s64-28.64 64-64v-38.144l61.984 136.384c13.28 29.248 40.8 46.912 72.512 46.912 1.472 0 3.008-0.032 4.512-0.128 33.568-1.76 61.056-22.656 71.68-54.592l79.808-239.424c8.704-26.112 5.792-54.72-8.032-78.528s-37.216-40.576-64.192-45.952l-122.976-24.608 190.048-17.28c37.984-3.456 70.336-29.056 82.368-65.248l58.4-175.2c6.592-19.712 3.392-40.736-8.768-57.6zM448 684.544l-91.136 200.48c-9.984 21.984-30.56 29.024-46.208 28.064-15.808-0.832-35.392-9.856-43.040-32.736l-79.776-239.456c-5.792-17.408-3.84-36.48 5.344-52.352 9.216-15.872 24.8-27.040 42.816-30.656l212-42.368v169.024zM448 478.496l-282.432-25.696c-25.344-2.304-46.88-19.36-54.944-43.488l-58.4-175.2c-3.264-9.888-1.664-20.384 4.416-28.832s15.552-13.28 25.952-13.28c35.968 0 71.264 12.384 99.36 34.848l266.048 212.832v38.816zM544 800c0 17.632-14.368 32-32 32s-32-14.368-32-32v-448c0-17.632 14.368-32 32-32s32 14.368 32 32v448zM788 557.92c17.984 3.584 33.6 14.752 42.816 30.656 9.216 15.872 11.168 34.944 5.344 52.352l-79.808 239.424c-7.648 22.88-27.232 31.936-43.040 32.736-15.776 0.896-36.224-6.112-46.208-28.064l-91.104-200.48v-169.024l212 42.4zM971.776 234.112l-58.4 175.2c-8.032 24.128-29.6 41.216-54.944 43.488l-282.432 25.696v-38.816l266.048-212.832c28.096-22.464 63.392-34.848 99.36-34.848 10.4 0 19.872 4.832 25.952 13.28s7.68 18.944 4.416 28.832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"affect",
						"fly",
						"flutter"
					],
					"grid": 32
				},
				{
					"id": 274,
					"width": 1024,
					"paths": [
						"M416 832.256l-30.016 65.984c-13.28 29.248-40.8 46.912-72.512 46.912-1.472 0-3.008-0.032-4.512-0.128-33.568-1.76-61.056-22.656-71.68-54.592l-79.808-239.424c-8.704-26.112-5.792-54.72 8.032-78.528s37.216-40.576 64.192-45.952l122.976-24.608-190.048-17.28c-37.984-3.456-70.336-29.056-82.4-65.248l-58.336-175.168c-6.592-19.744-3.392-40.768 8.768-57.632s31.104-26.592 51.936-26.592c43.2 0 85.6 14.88 119.36 41.856l214.048 171.232v459.168zM993.344 186.592c-12.192-16.896-31.104-26.592-51.936-26.592-43.2 0-85.6 14.88-119.36 41.856l-214.048 171.232v459.168l29.984 65.984c13.28 29.248 40.8 46.912 72.512 46.912 1.472 0 3.008-0.032 4.512-0.128 33.568-1.76 61.056-22.656 71.68-54.592l79.808-239.424c8.704-26.112 5.792-54.72-8.032-78.528s-37.216-40.576-64.192-45.952l-122.976-24.608 190.048-17.28c37.984-3.456 70.336-29.056 82.368-65.248l58.4-175.2c6.592-19.712 3.392-40.736-8.768-57.6zM576 352c0-22.688-11.872-42.496-29.664-53.856l17.12-59.968c8.64-30.208 30.656-53.312 60.448-63.328 29.728-10.048 61.28-4.96 86.464 13.92 7.104 5.312 17.12 3.904 22.4-3.2 5.312-7.072 3.872-17.088-3.2-22.4-33.184-24.896-76.48-31.904-115.84-18.656-39.328 13.248-69.632 44.96-81.024 84.864l-16.864 59.008c-1.312-0.064-2.528-0.384-3.84-0.384s-2.528 0.32-3.808 0.384l-16.864-59.008c-11.392-39.904-41.696-71.616-81.024-84.864-39.36-13.28-82.656-6.272-115.84 18.656-7.072 5.312-8.512 15.328-3.2 22.4s15.328 8.48 22.4 3.2c25.184-18.88 56.672-23.936 86.464-13.92s51.84 33.088 60.448 63.328l17.12 59.968c-17.824 11.36-29.696 31.168-29.696 53.856v448c0 35.36 28.64 64 64 64s64-28.64 64-64v-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"affect",
						"fly",
						"flutter"
					],
					"grid": 32
				},
				{
					"id": 948,
					"width": 1024,
					"paths": [
						"M893.76 224h-6.496c-125.184 0-242.784 61.216-314.592 163.776l-25.632 36.64c8-61.856 37.44-198.016 141.344-269.056 4.704 2.688 9.824 4.64 15.616 4.64 17.664 0 32-14.336 32-32s-14.336-32-32-32c-17.6 0-31.808 14.208-31.936 31.744-114.784 77.088-147.424 219.808-156.48 288.768-1.216-0.128-2.336-0.512-3.584-0.512s-2.368 0.384-3.552 0.544c-9.056-68.96-41.696-211.68-156.48-288.768-0.16-17.568-14.368-31.776-31.968-31.776-17.664 0-32 14.336-32 32s14.336 32 32 32c5.792 0 10.912-1.952 15.616-4.64 103.936 71.040 133.344 207.232 141.344 269.056l-25.632-36.64c-71.808-102.56-189.408-163.776-314.592-163.776h-6.496c-71.808 0-130.24 58.432-130.24 130.24 0 25.792 7.552 50.784 21.888 72.256l119.36 179.072c26.24 39.36 67.648 65.12 113.696 71.616-33.28 64.192-22.112 144.928 30.336 197.344 31.872 31.872 74.272 49.44 119.328 49.44 35.68 0 69.536-11.264 97.76-31.392 2.72 2.016 5.92 3.424 9.568 3.424h0.128c3.648 0 6.848-1.408 9.568-3.392 28.224 20.128 62.080 31.392 97.76 31.392 45.056 0 87.424-17.568 119.328-49.44 52.448-52.448 63.616-133.152 30.336-197.344 46.048-6.528 87.456-32.256 113.696-71.616l119.36-179.072c14.336-21.504 21.888-46.464 21.888-72.288 0-71.808-58.432-130.24-130.24-130.24zM486.496 820.64c-20 24.992-49.856 39.328-81.92 39.328-27.968 0-54.272-10.912-74.048-30.688-36.64-36.64-40.832-95.552-9.728-137.024l24.8-33.056c8.384-11.2 8.544-26.56 0.352-37.92-6.144-8.512-15.872-13.28-25.952-13.28-3.36 0-6.784 0.544-10.112 1.632-10.272 3.424-20.96 5.152-31.744 5.152-33.664 0-64.928-16.736-83.616-44.768l-119.36-179.072c-7.328-10.848-11.168-23.584-11.168-36.704 0-36.512 29.728-66.24 66.24-66.24h6.496c104.32 0 202.336 51.008 262.144 136.48l85.472 122.112 8.864 265.664-6.72 8.384zM948.864 391.008l-119.36 179.072c-18.688 28.032-49.952 44.768-83.616 44.768-10.784 0-21.472-1.728-31.776-5.152-3.328-1.152-6.72-1.696-10.112-1.696-10.080 0-19.84 4.768-25.952 13.28-8.192 11.36-8.032 26.72 0.352 37.92l24.8 33.056c31.104 41.472 26.912 100.352-9.728 137.024-19.808 19.808-46.112 30.688-74.048 30.688-32.064 0-61.92-14.336-81.92-39.328l-6.688-8.384 8.864-265.664 85.472-122.112c59.776-85.472 157.792-136.48 262.112-136.48h6.496c36.512 0 66.24 29.728 66.24 66.24 0 13.12-3.84 25.856-11.136 36.768zM192 416h-32v-32h32v32zM224 480h-32v-32h32v32zM224 512h32v32h-32v-32zM832 384h32v32h-32v-32zM800 448h32v32h-32v-32zM768 512h32v32h-32v-32zM384 768h32v32h-32v-32zM608 768h32v32h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"affect",
						"fly",
						"flutter"
					],
					"grid": 32
				},
				{
					"id": 275,
					"width": 1024,
					"paths": [
						"M768 320v-32c0-17.664-14.336-32-32-32l-17.408-52.224c-8.704-26.144-33.184-43.776-60.704-43.776h-23.2l-22.208-133.248c-2.592-15.456-15.936-26.752-31.584-26.752h-137.792c-15.648 0-28.992 11.296-31.552 26.752l-22.208 133.248h-23.2c-27.552 0-52 17.632-60.704 43.744l-17.44 52.256c-17.664 0-32 14.336-32 32v32h-16c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h17.44l26.4 580.352c2.336 51.264 44.576 91.648 95.904 91.648h264.544c51.328 0 93.568-40.384 95.904-91.648l26.368-580.352h17.44c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-16zM443.104 32h137.792l21.344 128h-180.48l21.344-128zM288 288h23.072l24.704-74.112c4.352-13.088 16.544-21.888 30.368-21.888h291.744c13.792 0 25.984 8.8 30.368 21.888l24.672 74.112h23.072v32h-448v-32zM708.192 930.912c-1.536 34.24-29.632 61.088-63.936 61.088h-264.544c-34.304 0-62.368-26.848-63.936-61.088l-26.272-578.912h445.024l-26.336 578.912z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"agitate",
						"drink",
						"make",
						"mix",
						"shake"
					],
					"grid": 32
				},
				{
					"id": 276,
					"width": 1024,
					"paths": [
						"M657.888 160c27.552 0 52 17.632 60.704 43.776l17.408 52.224c17.664 0 32 14.336 32 32v32h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-544c-8.832 0-16-7.168-16-16s7.168-16 16-16h16v-32c0-17.664 14.336-32 32-32l17.408-52.256c8.704-26.112 33.184-43.744 60.736-43.744h291.744zM258.912 384l24.928 548.352c2.336 51.264 44.576 91.648 95.904 91.648h264.544c51.328 0 93.568-40.384 95.904-91.648l24.896-548.352h-506.176zM629.344 128l-16.864-101.248c-2.592-15.456-15.936-26.752-31.584-26.752h-137.792c-15.648 0-28.992 11.296-31.552 26.752l-16.896 101.248h234.688z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"agitate",
						"drink",
						"make",
						"mix",
						"shake"
					],
					"grid": 32
				},
				{
					"id": 277,
					"width": 1024,
					"paths": [
						"M882.752 397.248l118.624-118.624c12.512-12.512 12.512-32.768 0-45.248l-146.752-146.752c-12.512-12.512-32.768-12.512-45.248 0l-118.624 118.624c-12 12-28.288 18.752-45.248 18.752h-266.976c-16.96 0-33.248-6.752-45.248-18.752l-118.656-118.624c-12.512-12.512-32.768-12.512-45.248 0l-146.752 146.752c-12.512 12.512-12.512 32.768 0 45.248l118.624 118.624c12 12 18.752 28.288 18.752 45.248v133.504l-18.752 18.752c-24.992 24.992-24.992 65.504 0 90.496l261.504 261.504c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l18.752-18.752 18.752 18.752c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l261.504-261.504c24.992-24.992 24.992-65.504 0-90.496l-18.752-18.752v-133.504c0-16.96 6.752-33.248 18.752-45.248zM163.872 662.624c-6.048-6.048-9.376-14.080-9.376-22.624s3.328-16.576 9.376-22.624l101.504-101.504c6.048-6.048 14.080-9.376 22.624-9.376s16.576 3.328 22.624 9.376l39.424 39.424-146.752 146.752-39.424-39.424zM225.952 724.672l146.752-146.752 57.376 57.376-146.752 146.752-57.376-57.376zM305.952 804.672l146.752-146.752 57.376 57.376-146.752 146.752-57.376-57.376zM470.624 924.128c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376l-39.424-39.424 146.752-146.752 39.424 39.424c6.048 6.048 9.376 14.080 9.376 22.624s-3.328 16.576-9.376 22.624l-101.504 101.504zM598.624 924.128c-6.048 6.048-14.080 9.376-22.624 9.376s-35.648-22.4-35.648-22.4c-1.824-2.464-3.648-4.672-5.344-6.112l59.744-59.744c0.672-0.672 43.328 39.424 43.328 39.424l-39.456 39.456zM860.128 662.624l-39.424 39.424-94.080-94.048c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l94.048 94.048-57.376 57.376-94.048-94.048c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l94.048 94.048-57.376 57.376-48.704-48.704c4.352-20.48-1.312-42.688-17.248-58.624l-261.504-261.504c-12.448-12.448-28.832-18.72-45.216-18.72s-32.768 6.24-45.248 18.752l-50.752 50.752v-101.504c0-25.472-10.112-49.888-28.128-67.872l-118.624-118.624 146.752-146.752 118.624 118.624c18.016 18.016 42.432 28.128 67.872 28.128h101.504l-114.752 114.752c-24.992 24.992-24.992 65.504 0 90.496l5.504 5.504c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l78.848-78.88c24.992-24.992 65.504-24.992 90.496 0l229.472 229.472c12.544 12.512 12.544 32.8 0.064 45.28zM860.128 374.624c-18.016 18.016-28.128 42.432-28.128 67.872v101.504l-178.752-178.752c-37.504-37.504-98.272-37.504-135.776 0l-78.848 78.848c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376l-5.504-5.504c-12.48-12.48-12.48-32.768 0-45.248l137.376-137.344h120.224c25.472 0 49.888-10.112 67.872-28.128l118.656-118.624 146.752 146.752-118.624 118.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"agree",
						"shake"
					],
					"grid": 32
				},
				{
					"id": 278,
					"width": 1024,
					"paths": [
						"M430.048 635.328l-169.376 169.376-57.376-57.376 169.376-169.376 57.376 57.376zM452.672 657.952l-169.376 169.376 57.376 57.376 169.376-169.376-57.376-57.376zM310.624 515.872c-6.048-6.048-14.080-9.376-22.624-9.376s-16.576 3.328-22.624 9.376l-124.128 124.128c-12.512 12.512-12.512 32.768 0 45.248l39.424 39.424 169.376-169.376-39.424-39.424zM581.504 800c0-8.544-3.328-16.576-9.376-22.624l-39.424-39.424-169.376 169.376 39.392 39.392c12.48 12.512 32.736 12.512 45.248 0l124.16-124.096c6.048-6.048 9.376-14.080 9.376-22.624zM1001.376 233.376l-146.752-146.752c-12.512-12.512-32.768-12.512-45.248 0l-137.376 137.376h-74.976c-25.472 0-49.888 10.112-67.872 28.128l-141.248 141.248c-12.48 12.48-12.48 32.768 0 45.248l5.504 5.504c6.048 6.048 14.080 9.376 22.624 9.376s16.576-3.328 22.624-9.376l78.848-78.848c37.504-37.504 98.272-37.504 135.776 0l210.72 210.72v-160l137.376-137.376c12.48-12.48 12.48-32.768 0-45.248zM630.656 387.904c-24.992-25.024-65.536-25.024-90.528-0.032l-78.848 78.88c-12.512 12.512-28.864 18.752-45.248 18.752s-32.768-6.24-45.248-18.752l-5.504-5.504c-24.992-24.992-24.992-65.504 0-90.496l146.72-146.752h-160l-137.376-137.376c-12.512-12.512-32.768-12.512-45.248 0l-146.752 146.752c-12.512 12.512-12.512 32.768 0 45.248l137.376 137.376v160l82.752-82.752c12.48-12.48 28.864-18.752 45.248-18.752s32.768 6.24 45.248 18.752l261.504 261.504c15.904 15.904 21.6 38.112 17.248 58.624l71.328 71.328 57.376-57.376-116.704-116.704c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l116.672 116.672 57.376-57.376-116.672-116.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l116.672 116.672 39.296-39.296c12.48-12.48 12.512-32.736 0-45.248l-251.936-252.224zM535.008 904.992l41.376 41.376c12.512 12.512 32.768 12.512 45.248 0l37.12-37.152-64.032-63.968-59.712 59.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"agree",
						"shake"
					],
					"grid": 32
				},
				{
					"id": 949,
					"width": 1024,
					"paths": [
						"M993.952 305.952c18.752-18.752 18.752-49.152 0-67.872l-192-192c-9.376-9.408-21.664-14.080-33.952-14.080s-24.576 4.672-33.952 14.048l-81.92 81.952h-264.224l-97.952-97.952c-9.376-9.376-21.664-14.048-33.952-14.048s-24.576 4.672-33.952 14.048l-192 192c-18.752 18.752-18.752 49.152 0 67.872l97.952 97.952v120.224l-9.952 9.952c-40.768 40.768-40.768 107.104 0 147.872 14.432 14.432 32.32 24.096 51.808 28.288 4.096 18.976 13.504 36.992 28.192 51.712 14.432 14.432 32.32 24.096 51.808 28.288 4.096 18.976 13.504 36.992 28.192 51.712 14.4 14.4 32.256 24.096 51.712 28.288 4.192 19.456 13.856 37.312 28.288 51.712 19.744 19.744 46.016 30.624 73.952 30.624 15.2 0 29.92-3.232 43.328-9.344l18.752 18.752c21.888 21.888 50.976 33.92 81.92 33.92s60.032-12.064 81.92-33.92c17.504-17.504 28.736-39.584 32.544-63.52 23.936-3.808 45.984-15.008 63.456-32.48 17.504-17.504 28.736-39.584 32.544-63.52 23.936-3.808 45.984-15.008 63.456-32.48 17.504-17.504 28.736-39.584 32.544-63.52 23.936-3.808 45.984-15.008 63.456-32.48 21.952-21.952 33.984-51.040 33.984-81.984s-12.064-60.032-33.92-81.92l-33.984-33.92v-72.224l81.952-81.952zM811.328 596.672c-6.24-6.24-16.384-6.24-22.624 0-3.136 3.136-4.704 7.232-4.704 11.328s1.568 8.192 4.672 11.328l16.032 16.032c9.792 9.792 15.2 22.816 15.2 36.672 0 16-7.232 30.88-20.16 41.088-20.928 16.48-51.616 12.448-70.464-6.4l-13.984-13.984c-6.24-6.24-16.384-6.24-22.624 0-3.104 3.072-4.672 7.168-4.672 11.264s1.568 8.192 4.672 11.328l16.032 16.032c9.792 9.792 15.2 22.816 15.2 36.672 0 16-7.232 30.88-20.16 41.088-20.928 16.48-51.616 12.448-70.464-6.4l-13.984-13.984c-6.24-6.24-16.384-6.24-22.624 0-3.104 3.072-4.672 7.168-4.672 11.264s1.568 8.192 4.672 11.328l16.032 16.032c9.792 9.792 15.2 22.816 15.2 36.672 0 16-7.232 30.88-20.16 41.088-20.928 16.48-51.616 12.448-70.464-6.4l-34.656-34.72 58.72-58.72c23.552-23.552 30.496-60.544 13.696-89.344-13.536-23.168-35.904-34.752-58.784-36.096 8.832-25.472 3.36-54.848-16.928-75.168-13.088-13.088-29.92-19.84-47.072-20.832 8.832-25.472 3.36-54.848-16.928-75.168-20.32-20.32-49.728-25.824-75.2-16.928-1.344-22.88-12.928-45.28-36.096-58.784-28.8-16.8-65.792-9.824-89.376 13.76l-42.656 42.656v-121.376c0-4.256-1.696-8.32-4.672-11.296l-100.704-100.704 169.376-169.376 100.672 100.672c3.008 3.008 7.072 4.704 11.328 4.704h41.376l-110.048 110.048c-18.752 18.752-18.752 49.12 0 67.872l8.736 8.736c24.48 24.448 61.6 30.368 92.352 15.008l216.128-107.648c12.32-6.144 27.168-3.712 36.896 6.016l247.296 247.296c9.792 9.792 15.2 22.816 15.2 36.672 0 16-7.232 30.88-20.16 41.088-20.928 16.48-51.616 12.448-70.464-6.4l-13.984-14.016zM403.328 860.672c-15.808-15.808-15.808-41.568 0-57.376l80-80c7.904-7.904 18.304-11.872 28.672-11.872s20.768 3.968 28.672 11.872c15.808 15.808 15.808 41.568 0 57.376l-80 80c-15.808 15.84-41.536 15.84-57.344 0zM163.328 563.328l96-96c7.904-7.936 18.304-11.872 28.672-11.872s20.768 3.968 28.672 11.872c15.808 15.808 15.808 41.568 0 57.376l-96 96c-15.808 15.808-41.568 15.808-57.376 0s-15.808-41.568 0.032-57.376zM243.328 643.328l112-112c7.904-7.904 18.304-11.872 28.672-11.872s20.768 3.968 28.672 11.872c15.808 15.808 15.808 41.568 0 57.376l-112 112c-15.808 15.808-41.568 15.808-57.376 0s-15.808-41.568 0.032-57.376zM323.328 723.328l96-96c7.904-7.904 18.304-11.872 28.672-11.872s20.768 3.968 28.672 11.872c15.808 15.808 15.808 41.568 0 57.376l-96 96c-15.808 15.808-41.568 15.808-57.376 0s-15.808-41.568 0.032-57.376zM768 102.624l169.376 169.376-89.376 89.376v80l-172.704-172.704c-19.52-19.52-49.376-24.32-74.016-11.904l-215.040 108.224c-18.496 9.312-40.896 5.696-55.52-8.928l-8.736-8.736c-6.24-6.24-6.24-16.384 0-22.624l118.624-118.624c8.96-9.024 21.152-14.080 33.888-14.080h204.128l89.376-89.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"agree",
						"hold",
						"shake",
						"befriend"
					],
					"grid": 32
				},
				{
					"id": 279,
					"width": 1024,
					"paths": [
						"M928 192h-256v-32c0-53.024-42.976-96-96-96h-128c-53.024 0-96 42.976-96 96v32h-256c-53.024 0-96 42.976-96 96v640c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-640c0-53.024-42.976-96-96-96zM448 96h128c35.36 0 64 28.64 64 64v32h-32v-32c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v32h-32v-32c0-35.36 28.64-64 64-64zM576 160v32h-128v-32h128zM992 928h-960v-512h128v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-32h512v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-32h128v512zM192 448v-96h32v96h-32zM800 448v-96h32v96h-32zM992 384h-128v-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v32h-512v-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v32h-128v-96c0-35.36 28.64-64 64-64h832c35.36 0 64 28.64 64 64v96zM544 512h-64c-17.664 0-32 14.336-32 32v64h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-64v-64c0-17.664-14.336-32-32-32zM640 640v64h-96v96h-64v-96h-96v-64h96v-96h64v96h96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"aid",
						"assist",
						"help"
					],
					"grid": 32
				},
				{
					"id": 2438,
					"paths": [
						"M896 256h-192v-128c0-35.2-28.8-64-64-64h-256c-35.2 0-64 28.8-64 64v128h-192c-70.4 0-128 57.6-128 128v512c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-512c0-70.4-57.6-128-128-128zM384 128h256v128h-256v-128zM768 704h-192v192h-128v-192h-192v-128h192v-192h128v192h192v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"aid-kit",
						"health",
						"medicine",
						"medical"
					],
					"defaultCode": 60273,
					"grid": 16
				},
				{
					"id": 2439,
					"paths": [
						"M896 256h-192v-128c0-35.2-28.8-64-64-64h-256c-35.202 0-64 28.8-64 64v128h-192c-70.4 0-128 57.6-128 128v512c0 70.4 57.6 128 128 128h768c70.398 0 128-57.6 128-128v-512c0-70.4-57.602-128-128-128zM384 128h256v128h-256v-128zM960 896c0 35.29-28.71 64-64 64h-768c-35.29 0-64-28.71-64-64v-512c0-35.29 28.71-64 64-64h768c35.29 0 64 28.71 64 64v512z",
						"M768 704h-192v192h-128v-192h-192v-128h192v-192h128v192h192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"aid-kit",
						"health",
						"medicine",
						"medical"
					],
					"defaultCode": 60274,
					"grid": 16
				},
				{
					"id": 280,
					"width": 1024,
					"paths": [
						"M864 448c0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32v-32h-512v32c0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32v-32h-160v512c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-512h-160v32zM672 704c0 17.664-14.336 32-32 32h-64v64c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32v-64h-64c-17.664 0-32-14.336-32-32v-64c0-17.664 14.336-32 32-32h64v-64c0-17.664 14.336-32 32-32h64c17.664 0 32 14.336 32 32v64h64c17.664 0 32 14.336 32 32v64zM544 640h96v64h-96v96h-64v-96h-96v-64h96v-96h64v96zM928 192h-256v-32c0-53.024-42.976-96-96-96h-128c-53.024 0-96 42.976-96 96v32h-256c-53.024 0-96 42.976-96 96v96h160v-32c0-17.664 14.336-32 32-32h32c17.664 0 32 14.336 32 32v32h512v-32c0-17.664 14.336-32 32-32h32c17.664 0 32 14.336 32 32v32h160v-96c0-53.024-42.976-96-96-96zM576 192h-128v-32h128v32zM832 448h-32v-96h32v96zM224 448h-32v-96h32v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"aid",
						"assist",
						"help"
					],
					"grid": 32
				},
				{
					"id": 950,
					"width": 1024,
					"paths": [
						"M640 576h-64v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM640 672h-96v96h-64v-96h-96v-64h96v-96h64v96h96v64zM992 192h-288v-96c0-17.664-14.336-32-32-32h-320c-17.664 0-32 14.336-32 32v96h-288c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM384 128h256v96h-256v-96zM960 896h-896v-512h96v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-32h512v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-32h96v512zM960 352h-128v64h-32v-64h-576v64h-32v-64h-128v-96h896v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"aid",
						"assist",
						"help"
					],
					"grid": 32
				},
				{
					"id": 2586,
					"paths": [
						"M768 639.968l-182.82-182.822 438.82-329.15-128.010-127.996-548.52 219.442-172.7-172.706c-49.78-49.778-119.302-61.706-154.502-26.508-35.198 35.198-23.268 104.726 26.51 154.5l172.686 172.684-219.464 548.582 127.99 128.006 329.19-438.868 182.826 182.828v255.98h127.994l63.992-191.988 191.988-63.996v-127.992l-255.98 0.004z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"airplane",
						"travel",
						"flight",
						"plane",
						"transport",
						"fly",
						"vacation"
					],
					"defaultCode": 60421,
					"grid": 16
				},
				{
					"id": 2587,
					"paths": [
						"M832 448h-134.4l-281.6-384h-160l204.8 384h-236.8l-128-128h-96l128 224-128 224h96l128-128h236.8l-204.8 384h160l281.6-384h134.4c105.6 0 192-43.2 192-96s-86.4-96-192-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"airplane",
						"travel",
						"flight",
						"plane",
						"transport",
						"fly",
						"vacation"
					],
					"defaultCode": 60422,
					"grid": 16
				},
				{
					"id": 2588,
					"paths": [
						"M938.112 515.86l-210.492 76.612-533.192-248.632-150.352 54.724 412.91 292.41-210.49 76.614-164.058-76.5-82.694 30.098 200.32 199.516 781.826-284.562c33.214-12.090 50.34-48.816 38.25-82.032-12.088-33.214-48.816-50.338-82.028-38.248z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"airplane",
						"travel",
						"departure",
						"plane"
					],
					"defaultCode": 60423,
					"grid": 16
				},
				{
					"id": 2589,
					"paths": [
						"M981.892 835.86l-210.492-76.614-248.634-533.192-150.35-54.724 128.352 489.414-210.492-76.612-76.502-164.060-82.694-30.098 25.208 281.604 781.824 284.56c33.212 12.090 69.94-5.038 82.030-38.25 12.088-33.216-5.038-69.94-38.25-82.028z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"airplane",
						"arrival",
						"plane"
					],
					"defaultCode": 60424,
					"grid": 16
				},
				{
					"id": 2152,
					"paths": [
						"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
						"M512 576v-256h-64v320h256v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alarm",
						"time",
						"clock"
					],
					"defaultCode": 59987,
					"grid": 16
				},
				{
					"id": 2153,
					"paths": [
						"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
						"M704 512h-128v-128h-128v128h-128v128h128v128h128v-128h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alarm-add",
						"alarm",
						"alarm-plus",
						"clock"
					],
					"defaultCode": 59988,
					"grid": 16
				},
				{
					"id": 2155,
					"paths": [
						"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
						"M733.256 706.744l-90.512 90.512-130.744-130.746-130.746 130.744-90.51-90.51 130.746-130.744-130.744-130.746 90.508-90.508 130.746 130.744 130.744-130.746 90.512 90.51-130.746 130.746 130.746 130.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alarm-cancel",
						"alarm",
						"time",
						"alarm-cross",
						"clock"
					],
					"defaultCode": 59990,
					"grid": 16
				},
				{
					"id": 2154,
					"paths": [
						"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
						"M704 416l-256 256-96-96-64 64 160 160 320-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alarm-check",
						"alarm",
						"alarm-tick",
						"clock"
					],
					"defaultCode": 59989,
					"grid": 16
				},
				{
					"id": 2442,
					"paths": [
						"M512 192c-35.346 0-64-28.654-64-64v-64c0-35.346 28.654-64 64-64s64 28.654 64 64v64c0 35.346-28.654 64-64 64z",
						"M800 704h-32v-192c0-141.384-114.614-256-256-256-141.384 0-256 114.616-256 256v192h-32c-17.672 0-32 14.326-32 32v128c0 17.674 14.328 32 32 32h576c17.674 0 32-14.326 32-32v-128c0-17.674-14.326-32-32-32z",
						"M864 1024h-704c-17.672 0-32-14.326-32-32s14.328-32 32-32h704c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
						"M192 256c-16.378 0-32.758-6.248-45.254-18.746l-64-64c-24.994-24.994-24.994-65.516 0-90.51s65.516-24.994 90.51 0l64 64c24.994 24.994 24.994 65.516 0 90.51-12.498 12.498-28.876 18.746-45.256 18.746z",
						"M128 576h-64c-35.346 0-64-28.654-64-64s28.654-64 64-64h64c35.346 0 64 28.654 64 64s-28.654 64-64 64z",
						"M832 256c-16.378 0-32.758-6.248-45.254-18.746-24.994-24.994-24.994-65.516 0-90.51l64-64c24.992-24.994 65.516-24.994 90.508 0 24.994 24.994 24.994 65.516 0 90.51l-64 64c-12.496 12.498-28.874 18.746-45.254 18.746z",
						"M960 576h-64c-35.346 0-64-28.654-64-64s28.654-64 64-64h64c35.346 0 64 28.654 64 64s-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alarm",
						"siren",
						"emergency"
					],
					"defaultCode": 60277,
					"grid": 16
				},
				{
					"id": 183,
					"paths": [
						"M860.171 773.15c-58.576-44-92.171-111.194-92.171-184.35v-153.6c0-128.661-86.733-237.442-204.798-270.954l-0.002-36.246c0-42.347-34.451-76.8-76.8-76.8-42.347 0-76.8 34.453-76.8 76.8v36.245c-118.067 33.512-204.8 142.294-204.8 270.955v153.6c0 73.157-33.595 140.349-92.171 184.35-8.808 6.616-12.395 18.125-8.907 28.573 3.486 10.448 13.267 17.496 24.283 17.496h232.982c-1.709 8.384-2.587 16.955-2.587 25.581 0 70.579 57.421 128 128 128s128-57.421 128-128c0-8.626-0.878-17.197-2.584-25.581h232.981c11.016 0 20.795-7.046 24.283-17.496s-0.101-21.957-8.909-28.573zM460.8 128c0-14.115 11.485-25.6 25.6-25.6s25.6 11.485 25.6 25.6v26.774c-8.435-0.763-16.97-1.176-25.6-1.176s-17.166 0.413-25.6 1.176v-26.774zM563.2 844.8c0 42.347-34.453 76.8-76.8 76.8s-76.8-34.453-76.8-76.8c0-8.76 1.515-17.411 4.394-25.581h144.813c2.878 8.168 4.394 16.821 4.394 25.581zM191.571 768.019c13.075-15.826 24.437-33.051 33.744-51.27 20.362-39.858 30.685-82.906 30.685-127.949v-153.6c0-127.043 103.357-230.4 230.4-230.4s230.4 103.357 230.4 230.4v153.6c0 45.043 10.323 88.091 30.685 127.949 9.307 18.219 20.669 35.445 33.744 51.27h-589.658z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alarm",
						"bell"
					],
					"defaultCode": 59480,
					"grid": 20
				},
				{
					"id": 281,
					"width": 1024,
					"paths": [
						"M955.36 91.264v0l4.64-4.64c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-4.64 4.64c-27.584-22.56-62.336-36.64-100.736-36.64-29.696 0-57.504 8.096-81.344 22.176-17.984 10.624-20.96 35.52-6.176 50.272l76.224 76.224-26.368 26.368c-74.24-68.704-173.216-111.040-282.336-111.040s-208.096 42.336-282.304 111.072l-26.368-26.4 76.224-76.224c14.784-14.784 11.808-39.648-6.176-50.272-23.872-14.080-51.68-22.176-81.376-22.176-38.4 0-73.152 14.080-100.736 36.64v0l-4.64-4.64c-6.24-6.24-16.384-6.24-22.624 0v0c-6.24 6.24-6.24 16.384 0 22.624l4.64 4.64c-22.56 27.584-36.64 62.336-36.64 100.736 0 29.696 8.096 57.504 22.176 81.344 10.624 17.984 35.52 20.96 50.272 6.176l76.224-76.224 26.368 26.368c-68.704 74.24-111.040 173.216-111.040 282.336 0 106.72 40.544 203.744 106.592 277.408l-75.104 75.104c-18.144 18.144-20.576 47.712-3.648 66.976 9.6 10.944 22.88 16.416 36.128 16.416 12.288 0 24.576-4.672 33.952-14.048l80.544-80.544c67.392 46.944 149.184 74.688 237.536 74.688s170.144-27.744 237.504-74.72l80.544 80.544c9.376 9.376 21.664 14.048 33.952 14.048 13.28 0 26.528-5.472 36.128-16.416 16.928-19.264 14.496-48.864-3.648-66.976l-75.104-75.104c66.080-73.632 106.624-170.656 106.624-277.376 0-109.12-42.336-208.096-111.072-282.304l26.368-26.368 76.224 76.224c14.784 14.784 39.648 11.808 50.272-6.176 14.112-23.872 22.208-51.68 22.208-81.376 0-38.4-14.080-73.152-36.64-100.736zM81.696 257.056c-11.552-19.488-17.696-41.792-17.696-65.056 0-70.592 57.408-128 128-128 23.264 0 45.536 6.144 65.056 17.696l-175.36 175.36zM171.296 911.2c-4.064 4.096-8.832 4.704-11.296 4.704s-7.232-0.608-11.328-4.704-4.672-8.832-4.672-11.296c0-2.464 0.608-7.232 4.704-11.328l76.096-76.096c7.712 7.392 15.52 14.656 23.808 21.44l-77.312 77.28zM875.328 888.576c4.096 4.096 4.704 8.832 4.704 11.328 0 2.464-0.608 7.232-4.704 11.328-4.064 4.096-8.832 4.672-11.296 4.672s-7.232-0.608-11.328-4.704l-77.28-77.28c8.288-6.784 16.096-14.048 23.808-21.44l76.096 76.096zM896 512c0 211.744-172.256 384-384 384s-384-172.256-384-384 172.256-384 384-384 384 172.256 384 384zM942.304 257.056l-175.36-175.36c19.488-11.552 41.792-17.696 65.056-17.696 70.592 0 128 57.408 128 128 0 23.264-6.144 45.536-17.696 65.056zM512 512h112c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16h-128c-8.832 0-16-7.168-16-16v-192c0-8.832 7.168-16 16-16v0c8.832 0 16 7.168 16 16v176zM512 160c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zM512 832c-176.448 0-320-143.552-320-320s143.552-320 320-320 320 143.552 320 320c0 176.448-143.552 320-320 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alarm",
						"awaken",
						"wake"
					],
					"grid": 32
				},
				{
					"id": 282,
					"width": 1024,
					"paths": [
						"M955.36 91.264v0l4.64-4.64c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-4.64 4.64c-27.584-22.56-62.336-36.64-100.736-36.64-29.696 0-57.504 8.096-81.344 22.176-17.984 10.624-20.96 35.52-6.176 50.272l76.224 76.224-26.368 26.368c-74.24-68.704-173.216-111.040-282.336-111.040s-208.096 42.336-282.304 111.072l-26.368-26.4 76.224-76.224c14.784-14.784 11.808-39.648-6.176-50.272-23.872-14.080-51.68-22.176-81.376-22.176-38.4 0-73.152 14.080-100.736 36.64v0l-4.64-4.64c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l4.64 4.64c-22.56 27.584-36.64 62.336-36.64 100.736 0 29.696 8.096 57.504 22.176 81.344 10.656 17.984 35.52 20.96 50.272 6.176l76.224-76.224 26.368 26.368c-68.704 74.24-111.040 173.216-111.040 282.336 0 106.72 40.544 203.744 106.592 277.408l-75.104 75.104c-18.144 18.144-20.576 47.712-3.648 66.976 9.6 10.944 22.88 16.416 36.128 16.416 12.288 0 24.576-4.672 33.952-14.048l80.544-80.544c67.392 46.944 149.184 74.688 237.536 74.688s170.144-27.744 237.504-74.72l80.544 80.544c9.376 9.376 21.664 14.048 33.952 14.048 13.28 0 26.528-5.472 36.128-16.416 16.928-19.264 14.496-48.864-3.648-66.976l-75.104-75.104c66.080-73.632 106.624-170.656 106.624-277.376 0-109.12-42.336-208.096-111.072-282.304l26.368-26.368 76.224 76.224c14.784 14.784 39.648 11.808 50.272-6.176 14.112-23.872 22.208-51.68 22.208-81.376 0-38.4-14.080-73.152-36.64-100.736zM864 512c0 194.4-157.6 352-352 352s-352-157.6-352-352 157.6-352 352-352 352 157.6 352 352zM512 192c-176.736 0-320 143.264-320 320s143.264 320 320 320 320-143.264 320-320c0-176.736-143.264-320-320-320zM624 544h-128c-8.832 0-16-7.168-16-16v-192c0-8.832 7.168-16 16-16v0c8.832 0 16 7.168 16 16v176h112c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alarm",
						"awaken",
						"wake"
					],
					"grid": 32
				},
				{
					"id": 951,
					"width": 1024,
					"paths": [
						"M672 480h-104.864c-5.6-9.6-13.536-17.536-23.136-23.136v-168.864c0-17.664-14.336-32-32-32s-32 14.336-32 32v168.864c-19.040 11.072-32 31.488-32 55.136 0 35.36 28.64 64 64 64 23.616 0 44.032-12.96 55.136-32h104.864c17.664 0 32-14.336 32-32s-14.336-32-32-32zM512 544c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM512 160c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zM512 832c-176.448 0-320-143.552-320-320s143.552-320 320-320 320 143.552 320 320c0 176.448-143.552 320-320 320zM992 224c0-106.048-85.952-192-192-192-54.080 0-102.816 22.432-137.728 58.4-47.040-16.8-97.472-26.4-150.272-26.4s-103.232 9.6-150.272 26.4c-34.912-35.968-83.648-58.4-137.728-58.4-106.048 0-192 85.952-192 192 0 54.080 22.432 102.816 58.4 137.728-16.8 47.040-26.4 97.472-26.4 150.272 0 149.696 73.696 281.92 186.528 363.264l-24.864 74.624c-5.6 16.768 3.456 34.88 20.224 40.48 3.36 1.12 6.784 1.632 10.112 1.632 13.408 0 25.888-8.48 30.368-21.888l20.096-60.32c61.6 31.904 131.392 50.208 205.536 50.208s143.936-18.304 205.536-50.208l20.096 60.32c4.48 13.408 16.96 21.888 30.368 21.888 3.328 0 6.752-0.544 10.112-1.664 16.768-5.6 25.824-23.712 20.224-40.48l-24.864-74.624c112.832-81.312 186.528-213.536 186.528-363.232 0-52.8-9.6-103.232-26.4-150.272 35.968-34.912 58.4-83.648 58.4-137.728zM224 96c34.816 0 67.424 13.824 91.776 38.944l6.784 6.976c-77.536 39.808-140.832 103.104-180.608 180.64l-7.008-6.784c-25.12-24.352-38.944-56.96-38.944-91.776 0-70.592 57.408-128 128-128zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384zM889.056 315.776l-6.976 6.784c-39.776-77.568-103.072-140.832-180.64-180.64l6.784-6.976c24.352-25.12 56.96-38.944 91.776-38.944 70.592 0 128 57.408 128 128 0 34.816-13.824 67.424-38.944 91.776z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alarm",
						"awaken",
						"wake"
					],
					"grid": 32
				},
				{
					"id": 1893,
					"paths": [
						"M928 256h-832c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h832c17.6 0 32-14.4 32-32v-704c0-17.6-14.4-32-32-32zM768 800c0 53.020-57.306 96-128 96-70.692 0-128-42.98-128-96s57.308-96 128-96c23.322 0 45.168 4.702 64 12.876v-186.59l-256 91.43v242.284c0 53.020-57.306 96-128 96-70.692 0-128-42.98-128-96s57.308-96 128-96c23.322 0 45.168 4.702 64 12.876v-268.876l384-128v416z",
						"M864 192h-704c-17.672 0-32-14.328-32-32s14.328-32 32-32h704c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M800 64h-576c-17.672 0-32-14.328-32-32s14.328-32 32-32h576c17.674 0 32 14.328 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"album",
						"songs",
						"playlist",
						"music"
					],
					"defaultCode": 59728,
					"grid": 16
				},
				{
					"id": 283,
					"width": 1024,
					"paths": [
						"M800 801.28v-33.28c0-17.664-14.336-32-32-32h-4.256l-41.216-309.152c-10.624-79.488-78.432-138.848-158.624-138.848h-103.84c-80.192 0-148 59.36-158.592 138.848l-41.216 309.152h-4.256c-17.664 0-32 14.336-32 32v33.28c-39.264 6.080-71.456 35.904-79.424 75.872l-8.928 44.544c-3.968 19.84 11.2 38.304 31.392 38.304h689.92c20.192 0 35.328-18.464 31.392-38.272l-8.928-44.544c-7.968-39.968-40.16-69.824-79.424-75.904zM333.216 431.072c8.448-63.328 62.976-111.072 126.88-111.072h103.84c63.904 0 118.432 47.744 126.88 111.072l40.64 304.928h-219.456v-384h-50.784c-47.936 0-88.512 35.36-95.104 82.848l-41.696 301.152h-31.872l40.672-304.928zM480 736h-123.264l41.088-296.768c4.352-31.488 31.616-55.232 63.392-55.232h18.784v352zM256 768h512v32h-512v-32zM167.040 928l8.928-44.544c5.952-29.824 32.32-51.456 62.72-51.456h546.592c30.4 0 56.8 21.632 62.752 51.456l8.928 44.544h-689.92zM388.864 114.304c-2.272-8.544 2.784-17.312 11.328-19.584 8.48-2.24 17.28 2.752 19.584 11.328l33.12 123.648c2.272 8.544-2.784 17.312-11.328 19.584-1.376 0.384-2.752 0.544-4.128 0.544-7.072 0-13.536-4.704-15.456-11.872l-33.12-123.648zM917.984 419.776l-123.616 33.12c-1.408 0.384-2.784 0.544-4.16 0.544-7.072 0-13.536-4.704-15.456-11.872-2.272-8.544 2.784-17.312 11.328-19.584l123.616-33.12c8.672-2.24 17.312 2.752 19.616 11.328 2.24 8.512-2.816 17.312-11.328 19.584zM206.528 229.152c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l90.496 90.528c6.24 6.24 6.24 16.384 0 22.624-3.136 3.136-7.232 4.672-11.328 4.672s-8.16-1.568-11.296-4.672l-90.496-90.528zM704.352 319.68c-6.24-6.24-6.24-16.384 0-22.624l90.496-90.528c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-90.496 90.528c-3.136 3.136-7.232 4.672-11.328 4.672s-8.192-1.568-11.296-4.672zM229.664 452.896l-123.616-33.12c-8.544-2.272-13.6-11.072-11.328-19.584 2.304-8.544 11.008-13.536 19.616-11.328l123.616 33.12c8.544 2.272 13.6 11.072 11.328 19.584-1.952 7.168-8.416 11.872-15.456 11.872-1.376 0-2.752-0.16-4.16-0.544zM571.072 229.664l33.12-123.648c2.304-8.512 11.264-13.536 19.584-11.328 8.576 2.272 13.632 11.072 11.328 19.584l-33.12 123.648c-1.952 7.136-8.416 11.872-15.456 11.872-1.376 0-2.752-0.16-4.128-0.544-8.544-2.272-13.632-11.040-11.328-19.584z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alert",
						"aid",
						"alarm",
						"sound"
					],
					"grid": 32
				},
				{
					"id": 284,
					"width": 1024,
					"paths": [
						"M301.472 426.848c10.624-79.488 78.432-138.848 158.624-138.848h103.84c80.192 0 148 59.36 158.592 138.848l36.928 277.152h-247.456v-352h-50.784c-47.936 0-88.512 35.36-95.104 82.848l-37.248 269.152h-64.32l36.928-277.152zM421.984 237.952c1.952 7.168 8.416 11.872 15.456 11.872 1.376 0 2.752-0.16 4.128-0.544 8.576-2.272 13.632-11.072 11.328-19.584l-33.12-123.648c-2.304-8.576-11.136-13.568-19.584-11.328-8.576 2.272-13.632 11.072-11.328 19.584l33.12 123.648zM715.648 324.352c4.096 0 8.192-1.568 11.328-4.672l90.496-90.528c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-90.496 90.528c-6.24 6.24-6.24 16.384 0 22.624 3.104 3.104 7.2 4.672 11.296 4.672zM582.4 249.28c1.376 0.384 2.752 0.544 4.128 0.544 7.072 0 13.536-4.704 15.456-11.872l33.12-123.648c2.272-8.544-2.784-17.312-11.328-19.584-8.352-2.208-17.28 2.784-19.584 11.328l-33.12 123.648c-2.304 8.512 2.784 17.28 11.328 19.584zM256 736c-17.664 0-32 14.336-32 32h576c0-17.664-14.336-32-32-32h-512zM297.024 319.68c3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-90.528-90.528c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l90.496 90.528zM929.28 400.192c-2.304-8.576-10.976-13.568-19.616-11.328l-123.616 33.12c-8.544 2.272-13.6 11.072-11.328 19.584 1.952 7.168 8.416 11.872 15.456 11.872 1.376 0 2.752-0.16 4.16-0.544l123.616-33.12c8.544-2.272 13.6-11.072 11.328-19.584zM800 800h-576c-37.216 0-69.248 26.272-76.544 62.752l-11.808 58.976c-3.968 19.808 11.2 38.272 31.392 38.272h689.92c20.192 0 35.328-18.464 31.392-38.272l-11.808-58.976c-7.296-36.48-39.328-62.752-76.544-62.752zM397.824 439.232l-36.672 264.768h118.848v-320h-18.784c-31.776 0-59.040 23.744-63.392 55.232zM233.824 453.44c7.072 0 13.536-4.704 15.456-11.872 2.272-8.544-2.784-17.312-11.328-19.584l-123.616-33.12c-8.64-2.208-17.312 2.784-19.616 11.328-2.272 8.544 2.784 17.312 11.328 19.584l123.616 33.12c1.408 0.384 2.784 0.544 4.16 0.544z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alert",
						"aid",
						"alarm",
						"sound"
					],
					"grid": 32
				},
				{
					"id": 952,
					"width": 1024,
					"paths": [
						"M960 864h-32v-64c0-17.664-14.336-32-32-32h-8.448l-51.584-359.424c-22.912-159.936-162.112-280.576-323.712-280.576h-0.544c-161.6 0-300.768 120.64-323.712 280.576l-51.552 359.424h-8.448c-17.664 0-32 14.336-32 32v64h-32c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32zM827.104 800h-411.104v-247.424c0-70.112 34.848-135.232 93.184-174.112 54.112-36.064 120.544-44.96 182.272-24.416l71.872 23.968c4 12.896 7.232 26.176 9.184 39.872l54.592 382.112zM747.744 339.072l-46.144-15.392c-71.2-23.776-147.776-13.472-210.144 28.128-67.296 44.864-107.456 119.904-107.456 200.768v247.424h-187.104l54.592-382.176c18.4-128.736 130.336-225.824 260.384-225.824h0.224c101.76 0 192.192 59.552 235.648 147.072zM160 832h704v64h-704v-64zM928 960h-832v-32h832v32zM48 464c0-17.664 14.304-32 32-32h32c17.696 0 32 14.336 32 32s-14.304 32-32 32h-32c-17.696 0-32-14.336-32-32zM880 464c0-17.664 14.304-32 32-32h32c17.696 0 32 14.336 32 32s-14.304 32-32 32h-32c-17.696 0-32-14.336-32-32zM183.904 181.152c-12.512-12.512-12.512-32.736 0-45.248s32.736-12.512 45.248 0l22.624 22.624c12.512 12.512 12.512 32.736 0 45.248-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376l-22.624-22.624zM480 64v-32c0-17.664 14.304-32 32-32s32 14.336 32 32v32c0 17.664-14.304 32-32 32s-32-14.336-32-32zM772.224 203.776c-12.512-12.512-12.512-32.736 0-45.248l22.624-22.624c12.512-12.512 32.736-12.512 45.248 0s12.512 32.736 0 45.248l-22.624 22.624c-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"alert",
						"sound",
						"flash"
					],
					"grid": 32
				},
				{
					"id": 2259,
					"paths": [
						"M384 128v576h-128v-576h128zM448 64v0h-256v704h256v-704zM1024 960v-128h-1024v128zM832 768v-448h-256v448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-bottom",
						"align"
					],
					"defaultCode": 60094,
					"grid": 16
				},
				{
					"id": 1231,
					"width": 1024.0010032653809,
					"paths": [
						"M1024 768v73.143q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714zM804.571 548.571v73.143q0 14.857-10.857 25.714t-25.714 10.857h-512q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h512q14.857 0 25.714 10.857t10.857 25.714zM950.857 329.143v73.143q0 14.857-10.857 25.714t-25.714 10.857h-804.571q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h804.571q14.857 0 25.714 10.857t10.857 25.714zM731.429 109.714v73.143q0 14.857-10.857 25.714t-25.714 10.857h-365.714q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h365.714q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-center"
					],
					"defaultCode": 61495,
					"grid": 14
				},
				{
					"id": 2255,
					"paths": [
						"M896 576h-320v-128h192v-256h-192v-192h-128v192h-192v256h192v128h-320v256h320v192h128v-192h320v-256zM832 768h-640v-128h640v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-center-horizontal",
						"align"
					],
					"defaultCode": 60090,
					"grid": 16
				},
				{
					"id": 2258,
					"paths": [
						"M448 896v-320h128v192h256v-192h192v-128h-192v-192h-256v192h-128v-320h-256v320h-192v128h192v320h256zM256 832v-640h128v640h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-center-vertical",
						"align"
					],
					"defaultCode": 60093,
					"grid": 16
				},
				{
					"id": 1233,
					"width": 1024.0010032653809,
					"paths": [
						"M1024 768v73.143q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714zM1024 548.571v73.143q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714zM1024 329.143v73.143q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714zM1024 109.714v73.143q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-justify"
					],
					"defaultCode": 61497,
					"grid": 14
				},
				{
					"id": 2254,
					"paths": [
						"M896 640h-576v128h576v-128zM960 576v0 256h-704v-256h704zM64 0h128v1024h-128zM256 192h448v256h-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-left",
						"align"
					],
					"defaultCode": 60089,
					"grid": 16
				},
				{
					"id": 1230,
					"width": 1023.9999656677246,
					"paths": [
						"M1024 768v73.143q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714zM804.571 548.571v73.143q0 14.857-10.857 25.714t-25.714 10.857h-731.429q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h731.429q14.857 0 25.714 10.857t10.857 25.714zM950.857 329.143v73.143q0 14.857-10.857 25.714t-25.714 10.857h-877.714q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h877.714q14.857 0 25.714 10.857t10.857 25.714zM731.429 109.714v73.143q0 14.857-10.857 25.714t-25.714 10.857h-658.286q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h658.286q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-left"
					],
					"defaultCode": 61494,
					"grid": 14
				},
				{
					"id": 2256,
					"paths": [
						"M128 640h576v128h-576v-128zM64 576v0 256h704v-256h-704zM960 0h-128v1024h128zM768 192h-448v256h448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-right",
						"align"
					],
					"defaultCode": 60091,
					"grid": 16
				},
				{
					"id": 1232,
					"width": 1024.0010032653809,
					"paths": [
						"M1024 768v73.143q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714zM1024 548.571v73.143q0 14.857-10.857 25.714t-25.714 10.857h-731.429q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h731.429q14.857 0 25.714 10.857t10.857 25.714zM1024 329.143v73.143q0 14.857-10.857 25.714t-25.714 10.857h-877.714q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h877.714q14.857 0 25.714 10.857t10.857 25.714zM1024 109.714v73.143q0 14.857-10.857 25.714t-25.714 10.857h-658.286q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h658.286q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-right"
					],
					"defaultCode": 61496,
					"grid": 14
				},
				{
					"id": 2257,
					"paths": [
						"M384 896v-576h-128v576h128zM448 960v0h-256v-704h256v704zM1024 64v128h-1024v-128zM832 256v448h-256v-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"align-top",
						"align"
					],
					"defaultCode": 60092,
					"grid": 16
				},
				{
					"id": 285,
					"width": 1024,
					"paths": [
						"M978.752 882.752l-517.504-517.504c-12.512-12.512-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-5.504 5.504c-24.992 24.992-24.992 65.504 0 90.496l517.504 517.504c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l5.504-5.504c24.992-24.992 24.992-65.504 0-90.496zM387.872 438.624c-12.48-12.48-12.48-32.768 0-45.248l5.504-5.504c6.048-6.048 14.080-9.376 22.624-9.376s16.576 3.328 22.624 9.376l103.424 103.424-50.752 50.752-103.424-103.424zM956.128 950.624l-5.504 5.504c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376l-391.424-391.456 50.752-50.752 391.424 391.424c12.48 12.512 12.48 32.8 0 45.28zM364.48 198.24l-76.48-38.24-38.24-76.48c-5.312-10.624-15.52-15.936-25.76-15.936s-20.448 5.312-25.76 15.936l-38.24 76.48-76.48 38.24c-21.216 10.624-21.216 40.896 0 51.52l76.48 38.24 38.24 76.48c5.312 10.624 15.52 15.936 25.76 15.936s20.448-5.312 25.76-15.904l38.24-76.512 76.48-38.24c21.216-10.624 21.216-40.896 0-51.52zM264.16 264.16l-40.16 80.288-40.16-80.288-80.288-40.16 80.288-40.16 40.16-80.288 40.16 80.288 80.288 40.16-80.288 40.16zM276.448 548.928l-38.24-19.136-19.136-38.24c-2.656-5.312-7.776-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.312-10.624 20.448 0 25.76l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.592-5.312 10.592-20.448 0-25.76zM214.336 569.952l-8.128 16.288-8.16-16.288-16.288-8.16 16.288-8.16 8.16-16.288 8.16 16.288 16.288 8.16-16.32 8.16zM487.968 222.688l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.624-5.312 10.624-20.448 0-25.76l-38.24-19.136-19.136-38.24c-2.656-5.312-7.776-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.312-10.624 20.448 0 25.76zM550.048 201.664l8.16-16.288 8.16 16.288 16.288 8.16-16.288 8.16-8.16 16.256-8.16-16.288-16.288-8.16 16.288-8.128zM368 576c-26.464 0-48 21.536-48 48s21.536 48 48 48 48-21.536 48-48-21.536-48-48-48zM368 640c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16c0 8.832-7.168 16-16 16zM576 368c0 26.464 21.536 48 48 48s48-21.536 48-48-21.536-48-48-48-48 21.536-48 48zM640 368c0 8.832-7.168 16-16 16s-16-7.168-16-16c0-8.832 7.168-16 16-16s16 7.168 16 16zM416 128c26.464 0 48-21.536 48-48s-21.536-48-48-48-48 21.536-48 48 21.536 48 48 48zM416 64c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16c0-8.832 7.168-16 16-16zM144 400c0-26.464-21.536-48-48-48s-48 21.536-48 48 21.536 48 48 48 48-21.536 48-48zM96 416c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16c0 8.832-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"amaze",
						"wave",
						"perform"
					],
					"grid": 32
				},
				{
					"id": 286,
					"width": 1024,
					"paths": [
						"M461.248 365.248l103.424 103.424-96 96-103.424-103.424c-24.992-24.992-24.992-65.504 0-90.496l5.504-5.504c12.512-12.512 28.864-18.752 45.248-18.752s32.768 6.272 45.248 18.752zM487.968 222.688l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.624-5.312 10.624-20.448 0-25.76l-38.24-19.136-19.136-38.24c-2.656-5.312-7.776-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.312-10.624 20.448 0 25.76zM576 368c0 26.464 21.536 48 48 48s48-21.536 48-48-21.536-48-48-48-48 21.536-48 48zM416 128c26.464 0 48-21.536 48-48s-21.536-48-48-48-48 21.536-48 48 21.536 48 48 48zM368 576c-26.464 0-48 21.536-48 48s21.536 48 48 48 48-21.536 48-48-21.536-48-48-48zM364.48 198.24l-76.48-38.24-38.24-76.48c-5.312-10.624-15.52-15.936-25.76-15.936s-20.448 5.312-25.76 15.936l-38.24 76.48-76.48 38.24c-21.216 10.624-21.216 40.896 0 51.52l76.48 38.24 38.24 76.48c5.312 10.624 15.52 15.936 25.76 15.936s20.448-5.312 25.76-15.904l38.24-76.512 76.48-38.24c21.216-10.624 21.216-40.896 0-51.52zM978.752 882.752l-391.424-391.424-96 96 391.424 391.424c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l5.504-5.504c24.992-24.992 24.992-65.504 0-90.496zM144 400c0-26.464-21.536-48-48-48s-48 21.536-48 48 21.536 48 48 48 48-21.536 48-48zM276.448 548.928l-38.24-19.136-19.136-38.24c-2.656-5.312-7.776-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.312-10.624 20.448 0 25.76l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.592-5.312 10.592-20.448 0-25.76z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"amaze",
						"wave",
						"perform"
					],
					"grid": 32
				},
				{
					"id": 953,
					"width": 1024,
					"paths": [
						"M970.112 545.632l-272.832-90.944-9.632-28.896 28.928-12.416c11.808-4.992 19.424-16.576 19.424-29.376s-7.616-24.384-19.392-29.408l-61.472-26.336-48.8-146.368c-4.32-13.088-16.576-21.888-30.336-21.888s-26.016 8.8-30.368 21.888l-28.992 87.008-12.256-5.248-90.944-212.224c-5.056-11.808-16.64-19.424-29.44-19.424s-24.384 7.616-29.408 19.392l-90.976 212.224-212.224 90.944c-11.776 5.056-19.392 16.64-19.392 29.44s7.616 24.384 19.392 29.408l212.224 90.944 5.248 12.256-87.008 28.992c-13.056 4.384-21.856 16.64-21.856 30.4s8.8 26.016 21.888 30.368l146.368 48.8 26.336 61.472c5.024 11.744 16.608 19.36 29.408 19.36s24.384-7.616 29.408-19.392l12.416-28.928 28.896 9.632 90.944 272.832c4.32 13.056 16.576 21.856 30.336 21.856s26.016-8.8 30.368-21.888l90.944-272.832 272.832-90.944c13.056-4.32 21.856-16.576 21.856-30.336s-8.8-26.016-21.888-30.368zM646.688 646.688l-70.688 212.128-70.688-212.096-212.128-70.72 212.096-70.688 70.72-212.128 70.688 212.096 212.128 70.72-212.128 70.688zM312.384 312.384l71.616-167.136 71.616 167.136 70.208 30.080-32.32 96.928-37.92 16.256-16.256 37.92-96.928 32.32-30.080-70.208-167.072-71.68 167.136-71.616zM352 928h32v32h-32v32h-32v-32h-32v-32h32v-32h32v32zM128 704h32v32h-32v32h-32v-32h-32v-32h32v-32h32v32zM704 96h-32v-32h32v-32h32v32h32v32h-32v32h-32v-32zM992 352v32h-32v32h-32v-32h-32v-32h32v-32h32v32h32zM864 832h32v32h-32v32h-32v-32h-32v-32h32v-32h32v32zM128 160h-32v-32h32v-32h32v32h32v32h-32v32h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"amaze",
						"shine",
						"sparkle",
						"dazzle"
					],
					"grid": 32
				},
				{
					"id": 3323,
					"paths": [
						"M925.6 885.2c-112.2 82.8-274.6 126.8-414.6 126.8-196.2 0-372.8-72.4-506.4-193.2-10.4-9.4-1.2-22.4 11.4-15 144.2 84 322.6 134.4 506.8 134.4 124.2 0 260.8-25.8 386.6-79.2 18.8-8 34.8 12.6 16.2 26.2z",
						"M972.2 832c-14.4-18.4-94.8-8.8-131-4.4-11 1.2-12.6-8.2-2.8-15.2 64.2-45 169.4-32 181.6-17 12.4 15.2-3.2 120.6-63.4 171-9.2 7.8-18 3.6-14-6.6 13.8-33.8 44-109.4 29.6-127.8z",
						"M707.4 757.6l0.2 0.2c24.8-21.8 69.4-60.8 94.6-81.8 10-8 8.2-21.4 0.4-32.6-22.6-31.2-46.6-56.6-46.6-114.2v-192c0-81.4 5.6-156-54.2-212-47.2-45.2-125.6-61.2-185.6-61.2-117.2 0-248 43.8-275.4 188.6-3 15.4 8.4 23.6 18.4 25.8l119.4 13c11.2-0.6 19.2-11.6 21.4-22.8 10.2-49.8 52-74 99-74 25.4 0 54.2 9.2 69.2 32 17.2 25.4 15 60 15 89.4v16c-71.4 8-164.8 13.2-231.6 42.6-77.2 33.4-131.4 101.4-131.4 201.4 0 128 80.6 192 184.4 192 87.6 0 135.4-20.6 203-89.8 22.4 32.4 29.6 48.2 70.6 82.2 9.4 5 21 4.6 29.2-2.8zM583.2 457.2c0 48 1.2 88-23 130.6-19.6 34.8-50.6 56-85.2 56-47.2 0-74.8-36-74.8-89.2 0-105 94.2-124 183.2-124v26.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"amazon",
						"brand"
					],
					"defaultCode": 61158,
					"grid": 16
				},
				{
					"id": 1748,
					"width": 1026.2870178222656,
					"paths": [
						"M886.286 843.429q8.571-3.429 14.857-1.714t6.286 10-8.571 19.143q-7.429 9.143-25.143 24.857t-54.571 38.857-80.571 42.286-107.429 33.143-131.143 14q-68 0-136-17.714t-119.429-43.714-98.571-59.429-75.714-60-48-50q-4.571-5.143-5.714-9.429t0.571-6.857 4.571-4 6.571-1.143 6.571 2.571q109.714 66.857 171.429 94.857 222.286 100.571 456.571 51.429 108.571-22.857 223.429-77.143zM1004.571 777.714q6.286 9.143 1.429 39.714t-16.286 58.571q-19.429 47.429-48.571 70.857-9.714 8-14.857 5.143t0-13.714q12-25.714 25.429-69.429t3.714-56.286q-2.857-4-8.857-6.571t-15.429-3.429-16.857-1.429-20 0-18 1.143-17.714 1.714-12.857 1.143q-3.429 0.571-7.429 0.857t-6.286 0.571-4.857 0.571-4 0.286h-5.714t-1.714-0.286-1.143-0.857l-0.857-1.714q-3.429-9.143 26.857-22.857t58.857-17.143q26.286-4 61.714-0.571t43.429 13.714zM779.429 524.571q0 17.714 7.714 36.571t18.286 33.143 21.429 26.286 18.857 18.286l7.429 6.286-129.714 128q-22.857-21.143-45.143-43.143t-33.143-33.429l-10.857-11.429q-6.286-6.286-14.286-18.857-21.714 33.714-55.714 58.571t-72.857 36.286-80 13.143-78.571-12-67.143-37.429-47.429-64.571-17.714-92.857q0-48 16-88t41.143-66.571 60.857-47.429 70-32.571 74.286-19.714 68.286-10.571 56.857-3.714v-72.571q0-37.143-12-55.429-19.429-30.286-69.143-30.286-3.429 0-9.429 0.571t-23.143 6.857-32 16.857-32 34-27.429 54.857l-168-15.429q0-34.286 12.571-68t38.286-64.571 61.714-54.286 86.571-37.429 108.857-14q57.143 0 103.429 14.286t74 35.143 46.286 47.429 25.714 49.143 7.143 42v336.571zM395.429 536.571q0 49.143 40 76 37.714 25.143 79.429 12.571 48-14.286 65.143-70.286 8-25.714 8-57.714v-92.571q-33.714 1.143-63.429 6.857t-60.857 19.143-49.714 40.571-18.571 65.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"amazon"
					],
					"defaultCode": 62064,
					"grid": 14
				},
				{
					"id": 2441,
					"paths": [
						"M1020.622 593.69l-128-256c-5.42-10.842-16.5-17.69-28.622-17.69h-160v-96c0-17.672-14.326-32-32-32h-96v-64h-192v64h-352c-17.672 0-32 14.328-32 32v576c0 17.674 14.328 32 32 32h113.22c-10.928 18.842-17.22 40.694-17.22 64 0 70.58 57.42 128 128 128s128-57.42 128-128c0-23.306-6.292-45.158-17.22-64h354.442c-10.93 18.842-17.22 40.694-17.22 64 0 70.58 57.42 128 128 128s128-57.42 128-128c0-23.306-6.292-45.158-17.22-64h49.218c17.674 0 32-14.326 32-32v-192c0-4.968-1.156-9.868-3.378-14.31zM704 384h140.222l64 128h-204.222v-128zM960 768h-896v-512h576v288c0 17.674 14.326 32 32 32h268.222l19.778 39.554v152.446z",
						"M384 320h-128v128h-128v128h128v128h128v-128h128v-128h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ambulance",
						"health",
						"emergency"
					],
					"defaultCode": 60276,
					"grid": 16
				},
				{
					"id": 1401,
					"width": 1133.7137603759766,
					"paths": [
						"M365.714 804.571q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM146.286 512h219.429v-146.286h-90.286q-8 1.143-12.571 5.143l-111.429 111.429q-4 6.857-5.143 12.571v17.143zM877.714 804.571q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM950.857 420.571v-109.714q0-8-5.143-13.143t-13.143-5.143h-128v-128q0-8-5.143-13.143t-13.143-5.143h-109.714q-8 0-13.143 5.143t-5.143 13.143v128h-128q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h128v128q0 8 5.143 13.143t13.143 5.143h109.714q8 0 13.143-5.143t5.143-13.143v-128h128q8 0 13.143-5.143t5.143-13.143zM1097.143 109.714v658.286q0 14.857-10.857 25.714t-25.714 10.857h-109.714q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429h-219.429q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429h-73.143q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857v-237.714q0-14.857 7.429-33.143t18.286-29.143l113.143-113.143q10.857-10.857 29.143-18.286t33.143-7.429h91.429v-182.857q0-14.857 10.857-25.714t25.714-10.857h658.286q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ambulance"
					],
					"defaultCode": 61689,
					"grid": 14
				},
				{
					"id": 1796,
					"width": 1316.5739345550537,
					"paths": [
						"M589.714 548.571q-33.714-1.143-48-31.429-9.714-19.429-27.429-30.571t-38.857-11.143q-30.286 0-51.714 21.429t-21.429 51.714q0 32 20.571 50.857l5.714 4.571q19.429 17.714 46.857 17.714 21.143 0 38.857-11.143t27.429-30.571q14.286-30.286 48-31.429zM914.286 475.429q0-32-20.571-50.857l-5.714-4.571q-19.429-17.714-46.857-17.714-21.143 0-38.857 11.143t-27.429 30.571q-14.286 30.286-48 31.429 33.714 1.143 48 31.429 9.714 19.429 27.429 30.571t38.857 11.143q30.286 0 51.714-21.429t21.429-51.714zM670.857 349.143q-9.714 20-31.429 27.429t-41.714-2.286q-35.429-17.714-76.571-17.714-29.143 0-56.571 9.714 1.714 0 5.429-0.286t5.429-0.286q52.571 0 97.429 28.571t67.714 76q9.714 20.571 2 42t-28.286 31.143q-10.286 5.143-22.286 5.143 12 0 22.286 5.143 20.571 9.714 28.286 31.143t-2 42q-22.857 47.429-67.714 76t-97.429 28.571h-3.429q-9.143-1.143-25.143-2.286l-165.714-15.429-136.571 68.571q-8 4-16.571 4-22.857 0-32.571-20l-91.429-182.857q-6.286-13.143-2.286-27.143t16.571-21.429l119.429-68 84.571-152.571q9.714-88.571 52.286-166.571t111.714-135.143q17.714-14.286 40.286-12.286t36.857 19.714 12.286 40-19.714 37.143q-40 33.714-66.857 73.143 70.286-48 152.571-57.714 22.857-2.857 40.857 10.857t20.286 36.571q2.857 22.857-10.857 40.857t-36.571 20.286q-48 5.714-90.857 31.429 26.286-5.714 56.571-5.714 65.714 0 124.571 28.571 20.571 10.286 28 31.714t-2.857 42zM1221.143 257.714l91.429 182.857q6.286 13.143 2.286 27.143t-16.571 21.429l-119.429 68-84.571 152.571q-9.714 88.571-52.286 166.571t-111.714 135.143q-14.857 12.571-34.857 12.571-25.714 0-42.286-20-14.286-17.714-12.286-40t19.714-37.143q40-33.714 66.857-73.143-70.286 48-152.571 57.714-2.286 0.571-6.857 0.571-20.571 0-36.286-13.714t-18-34.286q-2.857-22.857 10.857-40.857t36.571-20.286q48-5.714 90.857-31.429-26.286 5.714-56.571 5.714-65.714 0-124.571-28.571-20.571-10.286-28-31.714t2.857-42q9.714-20 31.429-27.429t41.714 2.286q35.429 17.714 76.571 17.714 29.143 0 56.571-9.714-1.714 0-5.429 0.286t-5.429 0.286q-52.571 0-97.429-28.571t-67.714-76q-9.714-20.571-2-42t28.286-31.143q10.286-5.143 22.286-5.143-12 0-22.286-5.143-20.571-9.714-28.286-31.143t2-42q22.857-47.429 67.714-76t97.429-28.571h4q8 1.143 24 2.286l166.286 15.429 136.571-68.571q8-4 16.571-4 22.857 0 32.571 20z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"american-sign-language-interpreting",
						"asl-interpreting"
					],
					"defaultCode": 62115,
					"grid": 14
				},
				{
					"id": 2627,
					"paths": [
						"M247.736 224.258l-0.014 0.008c-2.79-4.932-6.266-9.578-10.468-13.78-24.994-24.994-65.516-24.994-90.51 0-4.202 4.202-7.678 8.848-10.468 13.78l-0.012-0.008c-50.744 77.772-72.262 225.032-72.262 352.516v0 415.484c0 17.674 14.328 32 32 32h192c17.672 0 32-14.326 32-32v-415.484c-0.002-127.484-21.52-274.744-72.266-352.516zM192 928c0 17.674-14.328 32-32 32s-32-14.326-32-32v-384c0-17.674 14.328-32 32-32s32 14.326 32 32v32.258c0 0.002 0.192 0.192 0.522 0.516h-0.522v351.226z",
						"M567.736 224.258l-0.014 0.008c-2.79-4.932-6.266-9.578-10.468-13.78-24.992-24.994-65.516-24.994-90.508 0-4.202 4.202-7.678 8.848-10.468 13.78l-0.012-0.008c-50.746 77.772-72.264 225.032-72.264 352.516v0 415.484c0 17.674 14.328 32 32 32h192c17.672 0 32-14.326 32-32v-415.484c-0.002-127.484-21.522-274.744-72.266-352.516zM512 928c0 17.674-14.328 32-32 32s-32-14.326-32-32v-384c0-17.674 14.328-32 32-32s32 14.326 32 32v32.258c0 0.002 0.192 0.192 0.522 0.516h-0.522v351.226z",
						"M887.736 224.258l-0.014 0.008c-2.79-4.932-6.266-9.578-10.468-13.78-24.992-24.994-65.516-24.994-90.508 0-4.204 4.202-7.68 8.848-10.468 13.78l-0.012-0.008c-50.746 77.772-72.266 225.032-72.266 352.516v0 415.484c0 17.674 14.328 32 32 32h192c17.672 0 32-14.326 32-32v-415.484c0-127.484-21.52-274.744-72.264-352.516zM832 928c0 17.674-14.328 32-32 32s-32-14.326-32-32v-384c0-17.674 14.328-32 32-32s32 14.326 32 32v32.258c0 0.002 0.192 0.192 0.524 0.516h-0.524v351.226z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ammo",
						"bullets"
					],
					"defaultCode": 60462,
					"grid": 16
				},
				{
					"id": 3235,
					"paths": [
						"M831.516 453.788c-60.26-20.976-125.84 24.496-127.474 88.59-1.192 22.548 21.754 39.594 43.002 31.768 17.648-6.498 17.528-19.978 21.246-35.12 3.758-15.296 15.23-27.062 31.702-27.344 11.102 0.29 32.654 8.066 32.654 31.528 0.124 40.008-24.474 77.112-62.104 91.558-16.132 6.196-34.992 8.478-52.116 4.954-24.172-4.132-36.496-18.426-54.958-30.374-10.794-9.926-23.332-18.748-37.746-26.182-106.292-54.81-254.286 24.44-241.712 152.020 1.608 22.532 26.516 36.624 46.656 26.352 14.89-7.6 15.452-20.798 18.96-34.948 10.802-43.514 47.902-77.188 94.372-74.982 16.768 0.172 43.578 11.144 58.010 26.376 23.536 24.798 25.348 56.884 21.434 88.838-12.92 105.292-97.15 196.312-207.43 193.836-174.162-1.868-244.754-231.96-146.594-358.938 32.432-41.954 78.598-70.618 129.25-85.196 18.15-5.222 41.416-1.468 51.19-21.458 8.672-17.74-1.726-39.578-20.93-44.058-43.658-15.026-81.924-24.25-113.506-61.318-24.294-28.516-37.79-64.238-38.418-101.664 1.014-73.322 58.66-142.712 138.934-150.164-0.27 0.002-0.54-0.008-0.808-0.028 88.818-4.124 161.134 61.24 165.868 150.054 0.016-0.372 0.028-0.742 0.038-1.114 0.572 20.914-15.12 38.99-36.846 38.632-6.422-0.188-11.484-2.292-17.374-5.184-24.636-15.928-5.068-44.94-25.742-62.52-21.55-18.326-55.59-0.876-53.312 27.308-0.292 24.676 12.514 50.566 30.088 67.334 50.582 48.256 139.23 25.418 154.988-45.92 23.402-112.12-73.344-223.484-177.672-246.932-84.92-19.084-175.136 12.374-230.606 79.604-60.67 73.54-71.104 180.896-23.454 263.824 15.132 26.458 35.64 49.604 59.758 67.85-93.794 46.704-160.782 148.476-163.624 256.072-3.836 145.224 104.988 261.262 243.648 289.594 126.64 25.876 266.75-24.156 336.412-135.994 32.844-52.726 48.138-119.954 36.322-179.436 38.808 5.506 79.292-3.408 112.112-25.804 68.636-46.834 111.222-184.71 5.782-221.414v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ampersand",
						"typograhy",
						"and",
						"typography"
					],
					"defaultCode": 61070,
					"grid": 16
				},
				{
					"id": 287,
					"width": 1024,
					"paths": [
						"M864 128h-256v-32c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v32h-256c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h448c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h32c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM448 96h128v32h-128v-32zM352 160h320v64c0 35.296-28.704 64-64 64h-192c-35.296 0-64-28.704-64-64v-64zM96 416h9.376l112 112-105.376 105.376-16-16v-201.376zM694.624 416h178.784l-89.408 89.376-89.376-89.376zM889.376 656l-121.376 121.376-105.344-105.376 121.376-121.376 105.344 105.376zM761.376 528l-121.376 121.376-105.344-105.376 121.376-121.376 105.344 105.376zM617.376 672l-105.376 105.376-105.344-105.376 105.344-105.344 105.376 105.344zM512 521.376l-105.376-105.376h210.784l-105.408 105.376zM489.376 544l-105.376 105.376-121.344-121.376 105.376-105.376 121.344 121.376zM361.376 672l-105.376 105.376-121.344-121.376 105.344-105.344 121.376 121.344zM240 505.376l-89.376-89.376h178.784l-89.408 89.376zM169.408 864h-9.408c-35.296 0-64-28.704-64-64v-105.344l16-16 121.376 121.344-63.968 64zM214.656 864l41.344-41.344 41.376 41.344h-82.72zM342.624 864l-64-64 105.376-105.344 105.376 105.344-64 64h-82.752zM470.656 864l41.344-41.344 41.376 41.344h-82.72zM598.624 864l-64-64 105.376-105.344 105.376 105.344-64 64h-82.752zM726.656 864l41.344-41.344 41.376 41.344h-82.72zM928 800c0 35.296-28.704 64-64 64h-9.376l-64-64 121.376-121.376 16 16v105.376zM928 617.408l-16 16-105.344-105.408 112-112h9.344v201.408zM928 384h-832v-160c0-35.296 28.704-64 64-64h160v64c0 53.024 42.976 96 96 96h192c53.024 0 96-42.976 96-96v-64h160c35.296 0 64 28.704 64 64v160zM576 224c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM384 224c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM480 224c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"amplify",
						"listen",
						"play",
						"rock",
						"strum"
					],
					"grid": 32
				},
				{
					"id": 288,
					"width": 1024,
					"paths": [
						"M134.624 656l103.040-103.040 121.376 121.376-103.040 103.040-121.376-121.376zM145.952 416l91.712 91.712 91.712-91.712h-183.424zM352 128h64v-32c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32v32h64v96c0 35.296-28.704 64-64 64h-192c-35.296 0-64-28.704-64-64v-96zM544 224c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM576 224c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM448 128h128v-32h-128v32zM384 224c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM960 384v-160c0-53.024-42.976-96-96-96h-160v96c0 53.024-42.976 96-96 96h-192c-53.024 0-96-42.976-96-96v-96h-160c-53.024 0-96 42.976-96 96v160h896zM489.376 544l-121.376-121.376-107.712 107.712 121.376 121.376 107.712-107.712zM694.624 416l91.712 91.712 91.712-91.712h-183.424zM923.296 416l-114.336 114.336 114.272 114.432c6.24 6.24 6.24 16.384 0 22.624l-132.608 132.608 30.208 30.208c6.304 6.304 6.24 16.544-0.16 22.784v0c-6.272 6.112-16.288 6.016-22.464-0.16l-30.208-30.208-30.080 30.080c-6.24 6.24-16.352 6.24-22.624 0s-6.272-16.384 0-22.656l30.080-30.080-103.040-103.040-107.712 107.712 25.376 25.376c6.24 6.24 6.24 16.352 0 22.592-6.24 6.272-16.384 6.272-22.656 0.032l-25.344-25.344-25.312 25.312c-6.272 6.272-16.48 6.24-22.72-0.096-6.176-6.272-6.112-16.32 0.096-22.528l25.312-25.312-107.712-107.712-103.040 103.040 30.048 30.048c6.24 6.24 6.24 16.352 0.032 22.592-6.24 6.272-16.384 6.272-22.656 0.032l-30.048-30.048-30.016 30.016c-6.272 6.272-16.416 6.24-22.656-0.032-6.208-6.24-6.176-16.352 0.032-22.592l30.016-30.016-132.672-132.704c-6.24-6.24-6.24-16.384 0-22.624l114.336-114.336-114.336-114.336h-36.704v384c0 53.024 42.976 96 96 96h32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h448c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h32c53.024 0 96-42.976 96-96v-384h-36.704zM617.376 416h-210.752l105.376 105.376 105.376-105.376zM889.376 656l-103.040-103.040-121.376 121.376 103.040 103.040 121.376-121.376zM619.712 674.336l-107.712-107.712-107.712 107.712 107.712 107.712 107.712-107.712zM763.712 530.336l-107.712-107.712-121.376 121.376 107.712 107.712 121.376-121.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"amplify",
						"listen",
						"play",
						"rock",
						"strum"
					],
					"grid": 32
				},
				{
					"id": 954,
					"width": 1024,
					"paths": [
						"M192 224c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64-28.64-64-64-64zM192 320c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM384 224c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64-28.64-64-64-64zM384 320c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM832 352c35.36 0 64-28.64 64-64s-28.64-64-64-64-64 28.64-64 64 28.64 64 64 64zM832 256c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM576 288c0 35.36 28.64 64 64 64s64-28.64 64-64-28.64-64-64-64-64 28.64-64 64zM672 288c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM992 128h-320v-64c0-17.664-14.336-32-32-32h-256c-17.664 0-32 14.336-32 32v64h-320c-17.664 0-32 14.336-32 32v800c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-800c0-17.664-14.336-32-32-32zM960 384h-896v-192h896v192zM64 928v-512h896v512h-896zM416 96h192v64h-192v-64zM160 512h32v32h-32v-32zM160 608h32v32h-32v-32zM160 704h32v32h-32v-32zM160 800h32v32h-32v-32zM256 512h32v32h-32v-32zM352 512h32v32h-32v-32zM256 608h32v32h-32v-32zM352 608h32v32h-32v-32zM256 704h32v32h-32v-32zM352 704h32v32h-32v-32zM256 800h32v32h-32v-32zM352 800h32v32h-32v-32zM448 512h32v32h-32v-32zM544 512h32v32h-32v-32zM448 608h32v32h-32v-32zM544 608h32v32h-32v-32zM448 704h32v32h-32v-32zM544 704h32v32h-32v-32zM448 800h32v32h-32v-32zM544 800h32v32h-32v-32zM640 512h32v32h-32v-32zM736 512h32v32h-32v-32zM640 608h32v32h-32v-32zM736 608h32v32h-32v-32zM640 704h32v32h-32v-32zM736 704h32v32h-32v-32zM640 800h32v32h-32v-32zM736 800h32v32h-32v-32zM832 512h32v32h-32v-32zM832 608h32v32h-32v-32zM832 704h32v32h-32v-32zM832 800h32v32h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"amplify",
						"listen",
						"play",
						"rock"
					],
					"grid": 32
				},
				{
					"id": 289,
					"width": 1024,
					"paths": [
						"M272 576c-79.52 0-144 64.48-144 144s64.48 144 144 144 144-64.48 144-144-64.48-144-144-144zM272 832c-61.76 0-112-50.24-112-112s50.24-112 112-112 112 50.24 112 112c0 61.76-50.24 112-112 112zM752 576c-79.52 0-144 64.48-144 144s64.48 144 144 144 144-64.48 144-144-64.48-144-144-144zM752 832c-61.76 0-112-50.24-112-112s50.24-112 112-112 112 50.24 112 112c0 61.76-50.24 112-112 112zM900.352 96.16c-29.792-1.984-55.648 16.544-64.832 42.816-3.552 10.272 4.384 21.024 15.264 21.024v0c6.912 0 12.768-4.512 15.168-11.008 4.832-13.184 18.112-22.304 33.248-20.832 16.64 1.632 28.8 16.576 28.8 33.28v448.064c-36.8-58.496-101.76-97.504-176-97.504-54.080 0-103.168 20.8-140.16 54.624l-12.544-7.168c-54.112-30.912-120.512-30.912-174.624 0l-12.544 7.168c-36.96-33.824-86.048-54.624-140.128-54.624-74.24 0-139.2 39.008-176 97.504v-448.064c0-16.704 12.16-31.648 28.8-33.28 15.136-1.472 28.416 7.648 33.248 20.832 2.368 6.496 8.256 11.008 15.168 11.008v0c10.912 0 18.848-10.752 15.232-21.024-9.152-26.272-35.008-44.8-64.832-42.816-33.952 2.24-59.616 31.968-59.616 66.016 0 98.208 0 394.208 0 553.536 0 113.344 88.864 209.088 202.144 212.192 117.568 3.232 213.856-91.072 213.856-207.904 0-48.96-17.024-93.856-45.312-129.376l5.888-3.36c44.256-25.28 98.624-25.28 142.88 0l5.888 3.36c-30.304 38.048-47.648 86.816-45.056 139.808 5.152 104.832 90.016 190.848 194.816 197.184 120.704 7.296 220.896-88.448 220.896-207.616v-557.76c0-34.048-25.664-63.84-59.648-66.080zM448 720c0 97.056-78.944 176-176 176s-176-78.944-176-176 78.944-176 176-176 176 78.944 176 176zM752 896c-97.056 0-176-78.944-176-176s78.944-176 176-176 176 78.944 176 176-78.944 176-176 176z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"analyze",
						"see",
						"wear",
						"enhance"
					],
					"grid": 32
				},
				{
					"id": 290,
					"width": 1024,
					"paths": [
						"M900.352 96.16c-29.792-1.984-55.648 16.544-64.832 42.816-3.552 10.272 4.384 21.024 15.264 21.024v0c6.912 0 12.768-4.512 15.168-11.008 4.832-13.184 18.112-22.304 33.248-20.832 16.64 1.632 28.8 16.576 28.8 33.28v448.064c-36.8-58.496-101.76-97.504-176-97.504-54.080 0-103.168 20.8-140.16 54.624l-12.544-7.168c-54.112-30.912-120.512-30.912-174.624 0l-12.544 7.168c-36.96-33.824-86.048-54.624-140.128-54.624-74.24 0-139.2 39.008-176 97.504v-448.064c0-16.704 12.16-31.648 28.8-33.28 15.136-1.472 28.416 7.648 33.248 20.832 2.368 6.496 8.256 11.008 15.168 11.008v0c10.912 0 18.848-10.752 15.232-21.024-9.152-26.272-35.008-44.8-64.832-42.816-33.952 2.24-59.616 31.968-59.616 66.016 0 98.208 0 394.208 0 553.536 0 113.344 88.864 209.088 202.144 212.192 117.568 3.232 213.856-91.072 213.856-207.904 0-48.96-17.024-93.856-45.312-129.376l5.888-3.36c44.256-25.28 98.624-25.28 142.88 0l5.888 3.36c-30.304 38.048-47.648 86.816-45.056 139.808 5.152 104.832 90.016 190.848 194.816 197.184 120.704 7.296 220.896-88.448 220.896-207.616v-557.76c0-34.048-25.664-63.84-59.648-66.080zM448 720c0 97.056-78.944 176-176 176s-176-78.944-176-176 78.944-176 176-176 176 78.944 176 176zM752 896c-97.056 0-176-78.944-176-176s78.944-176 176-176 176 78.944 176 176-78.944 176-176 176zM416 720c0 79.52-64.48 144-144 144s-144-64.48-144-144 64.48-144 144-144 144 64.48 144 144zM896 720c0 79.52-64.48 144-144 144s-144-64.48-144-144 64.48-144 144-144 144 64.48 144 144z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"analyze",
						"see",
						"wear",
						"enhance"
					],
					"grid": 32
				},
				{
					"id": 2744,
					"paths": [
						"M896 576v132.196c-80.522 82.246-193.038 161.65-320 182.508v-378.704h192v-64l-192-74.942c74.564-26.36 128-97.462 128-181.058 0-106.040-85.96-192-192-192-106.042 0-192 85.96-192 192 0 83.596 53.43 154.7 128 181.058v0.012l-192 74.93v64h192v378.704c-126.968-20.858-239.484-100.262-320-182.508v-132.196h-128v64c0 128 256 384 512 384s512-256 512-384v-64h-128zM576 192c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64c35.346 0 64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"anchor",
						"link",
						"boat",
						"sailing"
					],
					"defaultCode": 60579,
					"grid": 16
				},
				{
					"id": 1463,
					"width": 1023.9979648590088,
					"paths": [
						"M548.571 146.286q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM1024 676.571v201.143q0 12.571-11.429 17.143-4.571 1.143-6.857 1.143-7.429 0-13.143-5.143l-53.143-53.143q-68 81.714-182 129.429t-245.429 47.714-245.429-47.714-182-129.429l-53.143 53.143q-5.143 5.143-13.143 5.143-2.286 0-6.857-1.143-11.429-4.571-11.429-17.143v-201.143q0-8 5.143-13.143t13.143-5.143h201.143q12.571 0 17.143 11.429 4.571 10.857-4 20l-57.143 57.143q38.286 52 108.286 87.714t155.143 47.143v-369.714h-109.714q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h109.714v-93.143q-33.143-19.429-53.143-52.857t-20-73.429q0-60.571 42.857-103.429t103.429-42.857 103.429 42.857 42.857 103.429q0 40-20 73.429t-53.143 52.857v93.143h109.714q14.857 0 25.714 10.857t10.857 25.714v73.143q0 14.857-10.857 25.714t-25.714 10.857h-109.714v369.714q85.143-11.429 155.143-47.143t108.286-87.714l-57.143-57.143q-8.571-9.143-4-20 4.571-11.429 17.143-11.429h201.143q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"anchor"
					],
					"defaultCode": 61757,
					"grid": 14
				},
				{
					"id": 3380,
					"paths": [
						"M896 384c-35.2 0-64 28.8-64 64v256c0 35.2 28.8 64 64 64s64-28.8 64-64v-256c0-35.2-28.8-64-64-64zM128 384c-35.2 0-64 28.8-64 64v256c0 35.2 28.8 64 64 64s64-28.8 64-64v-256c0-35.2-28.802-64-64-64zM224 736c0 53.020 42.98 96 96 96v0 128c0 35.2 28.8 64 64 64s64-28.8 64-64v-128h128v128c0 35.2 28.8 64 64 64s64-28.8 64-64v-128c53.020 0 96-42.98 96-96v-352h-576v352z",
						"M798.216 320.002c-9.716-87.884-59.004-163.792-129.62-209.646l32.024-64.046c7.904-15.806 1.496-35.028-14.31-42.932s-35.030-1.496-42.932 14.312l-32.142 64.286-8.35-3.316c-28.568-9.502-59.122-14.66-90.886-14.66-31.762 0-62.316 5.158-90.888 14.656l-8.348 3.316-32.142-64.282c-7.904-15.808-27.128-22.212-42.932-14.312-15.808 7.904-22.214 27.126-14.312 42.932l32.022 64.046c-70.616 45.852-119.904 121.762-129.622 209.644v32h574.222v-31.998h-1.784zM416 256c-17.674 0-32-14.328-32-32 0-17.648 14.288-31.958 31.93-31.996 0.032 0 0.062 0.002 0.094 0.002 0.018 0 0.036-0.002 0.052-0.002 17.638 0.042 31.924 14.35 31.924 31.996 0 17.672-14.326 32-32 32zM608 256c-17.674 0-32-14.328-32-32 0-17.646 14.286-31.954 31.924-31.996 0.016 0 0.034 0.002 0.050 0.002 0.032 0 0.064-0.002 0.096-0.002 17.64 0.038 31.93 14.348 31.93 31.996 0 17.672-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"android",
						"brand",
						"os",
						"mobile"
					],
					"defaultCode": 61215,
					"grid": 16
				},
				{
					"id": 1521,
					"width": 804.570972442627,
					"paths": [
						"M281.714 276q9.143 0 15.714-6.571t6.571-15.714-6.571-15.714-15.714-6.571-15.429 6.571-6.286 15.714 6.286 15.714 15.429 6.571zM522.857 276q9.143 0 15.429-6.571t6.286-15.714-6.286-15.714-15.429-6.571-15.714 6.571-6.571 15.714 6.571 15.714 15.714 6.571zM58.857 381.143q24 0 41.143 17.143t17.143 41.143v245.714q0 24.571-16.857 41.714t-41.429 17.143-41.714-17.143-17.143-41.714v-245.714q0-24 17.143-41.143t41.714-17.143zM664.571 392v380.571q0 26.286-18.286 44.571t-44 18.286h-42.857v129.714q0 24.571-17.143 41.714t-41.714 17.143-41.714-17.143-17.143-41.714v-129.714h-78.857v129.714q0 24.571-17.143 41.714t-41.714 17.143q-24 0-41.143-17.143t-17.143-41.714l-0.571-129.714h-42.286q-26.286 0-44.571-18.286t-18.286-44.571v-380.571h524.571zM532 160.571q61.143 31.429 97.714 87.714t36.571 123.143h-528.571q0-66.857 36.571-123.143t98.286-87.714l-40.571-74.857q-4-7.429 2.857-11.429 7.429-3.429 11.429 3.429l41.143 75.429q54.286-24 114.857-24t114.857 24l41.143-75.429q4-6.857 11.429-3.429 6.857 4 2.857 11.429zM804.571 439.429v245.714q0 24.571-17.143 41.714t-41.714 17.143q-24 0-41.143-17.143t-17.143-41.714v-245.714q0-24.571 17.143-41.429t41.143-16.857q24.571 0 41.714 16.857t17.143 41.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"android"
					],
					"defaultCode": 61819,
					"grid": 14
				},
				{
					"id": 1654,
					"width": 731.4281616210938,
					"paths": [
						"M544.571 216l-65.143 187.429 66.857 12q94.286-257.714 94.286-296 0-32-21.714-32-32.571 0-74.286 128.571zM373.714 608.571l18.857 50.286q21.143-24 40.571-38.286l-18.857-3.143t-22-4-18.571-4.857zM206.857 96.571q0 56 90.857 297.714 10.286-5.714 28-5.714 8.571 0 42.857 2.857l-69.143-200.571q-42.857-125.714-70.286-125.714-10.857 0-16.571 10t-5.714 21.429zM161.714 530.286q0 20.571 29.429 68t67.143 87.429 57.143 40q8 0 14.571-7.429t6.571-15.429q0-13.714-18.286-58.286-7.429-18.286-18.286-41.143t-27.143-50.857-35.143-46.286-35.429-18.286q-11.429 0-26 15.429t-14.571 26.857zM71.429 721.714q0 23.429 14.286 59.429 33.714 82.857 104.857 129.714t160.857 46.857q129.714 0 218.286-97.143 86.857-96.571 86.857-244 0-24.571-0.571-38.286t-6.571-35.429-17.429-32q-32-28-120.857-43.143t-154.571-15.143q-21.143 0-28 6.286-6.857 2.857-6.857 20 0 19.429 12.286 34.286t31.714 22.857 44.286 13.429 50 6.571 48.571 2.286 40 0h13.143q13.714 0 22.857 10.857 8.571 10.857 10.857 31.429-16 16-54.857 30.857-34.857 12.571-53.143 26.286-36.571 26.286-62 65.143t-25.429 78.286q0 17.714 10.571 50.571t10.571 50l-1.714 6.857q-2.286 6.857-2.286 8-78.286-5.714-83.429-123.429-4.571 1.143-23.429 1.143 1.143 4 1.143 12 0 30.286-23.143 51.143t-54 20.857q-46.857 0-95.143-44.571t-48.286-90.857q0-19.429 18.857-38.286 29.714 36.571 34.286 43.429 44 59.429 76 59.429 6.857 0 15.143-4.857t8.286-11.714q0-19.429-50-82.857t-66.571-63.429q-24.571 0-40 25.429t-15.429 51.714zM6.286 726.857q0-57.714 24.286-93.143t78-50.286q-16-42.286-16-59.429 0-35.429 34.857-70.286t69.714-34.857q16.571 0 40 8.571-93.143-264-93.143-324 0-45.714 23.429-74.571t68-28.857q74.857 0 185.714 332 3.429 9.714 4.571 13.143 3.429-9.143 16.571-45.429t24.857-67.714 30.857-72.857 36.857-70.286 40.286-49.429 43.714-20.571q40.571 0 64 28t23.429 69.714q0 61.714-90.857 314.286 34.857 8.571 57.429 26.286t33.429 44.571 14.857 53.429 4 63.143q0 85.714-26.857 160t-75.429 128.571-120.571 85.714-158.857 31.429q-63.429 0-127.429-24-85.143-32.571-147.429-109.429t-62.286-163.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angellist"
					],
					"defaultCode": 61961,
					"grid": 14
				},
				{
					"id": 2248,
					"paths": [
						"M960 832h-194.932c-6.488-72.444-23.99-142.86-52.406-210.040-35.458-83.834-86.214-159.12-150.86-223.764-1.434-1.434-2.888-2.838-4.334-4.258l123.446-150.878c22.382-27.356 18.35-67.678-9.006-90.060-27.36-22.382-67.676-18.35-90.060 9.006l-567.208 693.256c-0.020 0.024-0.040 0.046-0.058 0.072l-0.114 0.138 0.002 0.004c-9.040 11.036-14.47 25.146-14.47 40.524 0 35.332 28.634 63.978 63.962 64v0.002c0.024 0 0.048-0.002 0.072-0.002h895.966c35.346 0 64-28.654 64-64s-28.654-64-64-64zM516.772 443.68c105.53 105.632 169.572 241.654 184.038 388.32h-501.754l317.716-388.32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angle"
					],
					"defaultCode": 60083,
					"grid": 16
				},
				{
					"id": 1410,
					"width": 658.2859878540039,
					"paths": [
						"M614.286 493.714q0 7.429-5.714 13.143l-266.286 266.286q-5.714 5.714-13.143 5.714t-13.143-5.714l-266.286-266.286q-5.714-5.714-5.714-13.143t5.714-13.143l28.571-28.571q5.714-5.714 13.143-5.714t13.143 5.714l224.571 224.571 224.571-224.571q5.714-5.714 13.143-5.714t13.143 5.714l28.571 28.571q5.714 5.714 5.714 13.143zM614.286 274.286q0 7.429-5.714 13.143l-266.286 266.286q-5.714 5.714-13.143 5.714t-13.143-5.714l-266.286-266.286q-5.714-5.714-5.714-13.143t5.714-13.143l28.571-28.571q5.714-5.714 13.143-5.714t13.143 5.714l224.571 224.571 224.571-224.571q5.714-5.714 13.143-5.714t13.143 5.714l28.571 28.571q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angle-double-down"
					],
					"defaultCode": 61699,
					"grid": 14
				},
				{
					"id": 1407,
					"width": 603.4289932250977,
					"paths": [
						"M358.286 786.286q0 7.429-5.714 13.143l-28.571 28.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-266.286-266.286q-5.714-5.714-5.714-13.143t5.714-13.143l266.286-266.286q5.714-5.714 13.143-5.714t13.143 5.714l28.571 28.571q5.714 5.714 5.714 13.143t-5.714 13.143l-224.571 224.571 224.571 224.571q5.714 5.714 5.714 13.143zM577.714 786.286q0 7.429-5.714 13.143l-28.571 28.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-266.286-266.286q-5.714-5.714-5.714-13.143t5.714-13.143l266.286-266.286q5.714-5.714 13.143-5.714t13.143 5.714l28.571 28.571q5.714 5.714 5.714 13.143t-5.714 13.143l-224.571 224.571 224.571 224.571q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angle-double-left"
					],
					"defaultCode": 61696,
					"grid": 14
				},
				{
					"id": 1408,
					"width": 566.8580112457275,
					"paths": [
						"M340 548.571q0 7.429-5.714 13.143l-266.286 266.286q-5.714 5.714-13.143 5.714t-13.143-5.714l-28.571-28.571q-5.714-5.714-5.714-13.143t5.714-13.143l224.571-224.571-224.571-224.571q-5.714-5.714-5.714-13.143t5.714-13.143l28.571-28.571q5.714-5.714 13.143-5.714t13.143 5.714l266.286 266.286q5.714 5.714 5.714 13.143zM559.429 548.571q0 7.429-5.714 13.143l-266.286 266.286q-5.714 5.714-13.143 5.714t-13.143-5.714l-28.571-28.571q-5.714-5.714-5.714-13.143t5.714-13.143l224.571-224.571-224.571-224.571q-5.714-5.714-5.714-13.143t5.714-13.143l28.571-28.571q5.714-5.714 13.143-5.714t13.143 5.714l266.286 266.286q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angle-double-right"
					],
					"defaultCode": 61697,
					"grid": 14
				},
				{
					"id": 1409,
					"width": 658.2901077270508,
					"paths": [
						"M614.286 749.714q0 7.429-5.714 13.143l-28.571 28.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-224.571-224.571-224.571 224.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-28.571-28.571q-5.714-5.714-5.714-13.143t5.714-13.143l266.286-266.286q5.714-5.714 13.143-5.714t13.143 5.714l266.286 266.286q5.714 5.714 5.714 13.143zM614.286 530.286q0 7.429-5.714 13.143l-28.571 28.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-224.571-224.571-224.571 224.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-28.571-28.571q-5.714-5.714-5.714-13.143t5.714-13.143l266.286-266.286q5.714-5.714 13.143-5.714t13.143 5.714l266.286 266.286q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angle-double-up"
					],
					"defaultCode": 61698,
					"grid": 14
				},
				{
					"id": 1414,
					"width": 658.2859878540039,
					"paths": [
						"M614.286 420.571q0 7.429-5.714 13.143l-266.286 266.286q-5.714 5.714-13.143 5.714t-13.143-5.714l-266.286-266.286q-5.714-5.714-5.714-13.143t5.714-13.143l28.571-28.571q5.714-5.714 13.143-5.714t13.143 5.714l224.571 224.571 224.571-224.571q5.714-5.714 13.143-5.714t13.143 5.714l28.571 28.571q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angle-down"
					],
					"defaultCode": 61703,
					"grid": 14
				},
				{
					"id": 1411,
					"width": 384.00101470947266,
					"paths": [
						"M358.286 310.857q0 7.429-5.714 13.143l-224.571 224.571 224.571 224.571q5.714 5.714 5.714 13.143t-5.714 13.143l-28.571 28.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-266.286-266.286q-5.714-5.714-5.714-13.143t5.714-13.143l266.286-266.286q5.714-5.714 13.143-5.714t13.143 5.714l28.571 28.571q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angle-left"
					],
					"defaultCode": 61700,
					"grid": 14
				},
				{
					"id": 1412,
					"width": 347.4289951324463,
					"paths": [
						"M340 548.571q0 7.429-5.714 13.143l-266.286 266.286q-5.714 5.714-13.143 5.714t-13.143-5.714l-28.571-28.571q-5.714-5.714-5.714-13.143t5.714-13.143l224.571-224.571-224.571-224.571q-5.714-5.714-5.714-13.143t5.714-13.143l28.571-28.571q5.714-5.714 13.143-5.714t13.143 5.714l266.286 266.286q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angle-right"
					],
					"defaultCode": 61701,
					"grid": 14
				},
				{
					"id": 1413,
					"width": 658.2901077270508,
					"paths": [
						"M614.286 676.571q0 7.429-5.714 13.143l-28.571 28.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-224.571-224.571-224.571 224.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-28.571-28.571q-5.714-5.714-5.714-13.143t5.714-13.143l266.286-266.286q5.714-5.714 13.143-5.714t13.143 5.714l266.286 266.286q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angle-up"
					],
					"defaultCode": 61702,
					"grid": 14
				},
				{
					"id": 2853,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM704.098 780.74c-39.174-65.148-110.544-108.74-192.098-108.74-81.556 0-152.924 43.592-192.098 108.74l-82.328-49.396c55.96-93.070 157.916-155.344 274.426-155.344 116.508 0 218.464 62.274 274.426 155.344l-82.328 49.396zM767.042 280.24c4.284 17.144-6.14 34.518-23.282 38.804-17.626 4.45-38.522 12.12-56.936 21.35 10.648 11.43 17.174 26.752 17.174 43.606 0 35.346-28.654 64-64 64s-64-28.654-64-64c0-1.17 0.036-2.33 0.098-3.484 2.032-47.454 45.212-78.946 81.592-97.138 34.742-17.37 69.102-26.060 70.548-26.422 17.146-4.288 34.518 6.138 38.806 23.284zM256.958 280.24c4.288-17.146 21.66-27.572 38.806-23.284 1.446 0.362 35.806 9.052 70.548 26.422 36.38 18.192 79.56 49.684 81.592 97.138 0.062 1.154 0.098 2.314 0.098 3.484 0 35.346-28.654 64-64 64s-64-28.654-64-64c0-16.854 6.526-32.176 17.174-43.606-18.414-9.23-39.31-16.9-56.936-21.35-17.142-4.286-27.566-21.66-23.282-38.804z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angry",
						"emoticon",
						"smiley",
						"face",
						"rage"
					],
					"defaultCode": 60688,
					"grid": 16
				},
				{
					"id": 2854,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576.094 380.516c2.032-47.454 45.21-78.948 81.592-97.138 34.742-17.372 69.104-26.060 70.548-26.422 17.146-4.288 34.52 6.138 38.806 23.284s-6.138 34.518-23.284 38.806c-17.624 4.45-38.522 12.12-56.936 21.35 10.648 11.43 17.174 26.752 17.174 43.606 0 35.346-28.654 64-64 64s-64-28.654-64-64c0.002-1.17 0.038-2.332 0.1-3.486zM256.958 280.24c4.288-17.146 21.66-27.572 38.806-23.284 1.446 0.362 35.806 9.052 70.548 26.422 36.38 18.192 79.56 49.684 81.592 97.138 0.062 1.154 0.098 2.314 0.098 3.484 0 35.346-28.654 64-64 64s-64-28.654-64-64c0-16.854 6.526-32.176 17.174-43.606-18.414-9.23-39.31-16.9-56.936-21.35-17.142-4.286-27.566-21.66-23.282-38.804zM704.098 780.74c-39.174-65.148-110.544-108.74-192.098-108.74-81.556 0-152.924 43.592-192.098 108.74l-82.328-49.396c55.96-93.070 157.916-155.344 274.426-155.344 116.508 0 218.464 62.274 274.426 155.344l-82.328 49.396z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"angry",
						"emoticon",
						"smiley",
						"face",
						"rage"
					],
					"defaultCode": 60689,
					"grid": 16
				},
				{
					"id": 955,
					"width": 1024,
					"paths": [
						"M281.44 158.272l28.704-14.112c7.52 15.232 9.856 29.28 9.856 45.088h-32c0-12.128-0.96-19.552-6.56-30.976zM288 256h32v-32h-32v32zM284.128 110.848l-14.88-14.848h18.752v-32h-64v32l37.504 37.504 22.624-22.656zM535.232 236.928l29.088-13.344c-4.448-9.664-10.080-18.784-16.832-27.104l-24.864 20.128c5.024 6.208 9.28 13.056 12.608 20.32zM352 64h-32v32h32v-32zM544 288h32c0-13.408 0.32-20.768-2.080-33.984l-31.488 5.76c1.888 10.272 1.568 17.44 1.568 28.224zM502.752 196l22.624-22.624c-1.792-1.792-3.040-3.040-4.576-4.576-11.2-11.2-15.904-15.904-16.512-16.512-0.576-0.576-0.928-0.928-1.536-1.536l-22.624 22.624 22.624 22.624zM433.088 84.896c-10.144-7.296-28-15.392-40.064-18.4l-7.488 31.488c10.304 4 23.36 9.28 30.048 13.664l17.504-26.752zM480.096 128.096c-1.856-1.856-3.2-3.2-4.736-4.736-0.384-0.384-0.8-0.8-1.152-1.152-0.704-0.704-1.792-1.792-3.232-3.232 0.864 0.864 1.696 1.696 2.368 2.368-2.016-2.016-3.68-3.68-5.12-5.12 0.928 0.928 1.888 1.856 2.752 2.752-2.816-2.816-7.136-7.136-13.504-13.504l-22.624 22.624 22.624 22.624 22.624-22.624zM794.4 794.4l-22.624 22.624 22.624 22.624 22.624-22.624-22.624-22.624zM771.776 771.776c-0.416-0.416-22.624-22.624-22.624-22.624l-22.624 22.624 22.624 22.624 22.624-22.624zM733.024 957.984c8.768 0.992 23.392 1.856 34.592 1.984 0 0 0.416-31.936 0.416-32-9.568-0.128-21.888-0.736-31.392-1.792l-3.616 31.808zM800 960h32v-32h-32v32zM884.896 884.896l-22.624 22.624 20.48 20.48h-18.752v32h64v-32l-43.104-43.104zM839.648 839.648l-22.624 22.624 22.624 22.624 22.624-22.624-22.624-22.624zM558.272 884.192l26.624 17.76 17.76-26.624-26.624-17.76-17.76 26.624zM505.024 848.672l26.624 17.76 17.76-26.624-26.624-17.76-17.76 26.624zM670.56 944.512c10.144 3.264 20.448 6.048 30.88 8.288l6.752-31.296c-9.344-2.016-18.688-4.512-27.808-7.456l-9.824 30.464zM451.776 813.184l26.624 17.76 17.76-26.624-26.624-17.76-17.76 26.624zM612.032 918.912c8.96 5.056 18.496 9.824 28.64 14.272l12.832-29.312c-8.768-3.84-17.44-8.16-25.76-12.832l-15.712 27.872zM424.192 756.32l18.72 12.48-17.76 26.624-26.624-17.76 10.976-16.448-207.36 69.12c-3.36 1.12-6.752 1.664-10.144 1.664-8.352 0-16.544-3.264-22.624-9.376l-32-32c-11.392-11.392-12.544-29.536-2.656-42.272l101.472-130.464-154.528-77.28c-10.816-5.408-17.664-16.48-17.664-28.608v-32c0-12.128 6.848-23.2 17.696-28.64l201.952-100.96c1.408-0.704 2.912-1.184 4.352-1.856v-60.544h32v47.552c29.728-10.048 61.056-15.552 92.448-15.552h104.608c9.184 0 18.176 1.184 26.944 3.040v-3.040h32v14.656c16 8.32 30.432 19.808 41.952 34.56 17.888 22.912 27.232 50.528 27.168 78.784h58.88c52.928 0 96 43.072 96 96h32c17.664 0 32 14.336 32 32s-14.336 32-32 32h-32c0 52.928-43.072 96-96 96 0.608 0.64 22.528 22.528 22.528 22.528l-22.656 22.624-22.624-22.624 22.528-22.528h-122.592l-156.992 52.32zM266.944 561.696c32.352 16.16 53.056 49.28 53.056 85.92 0 5.888 5.792 10.048 11.36 8.192l201.184-67.072c10.368-3.456 18.272-11.968 20.928-22.592l25.664-102.624c4.8-19.264 0.576-39.264-11.648-54.912s-30.592-24.608-50.432-24.608h-104.608c-34.784 0-69.088 8.096-100.16 23.648l-176.736 88.352 131.392 65.696zM570.816 640h133.184c17.632 0 32-14.368 32-32v-64c0-17.632-14.368-32-32-32h-104l-15.488 61.92c-5.312 21.216-21.088 38.272-41.856 45.184l-212.544 70.848c-20.704 6.912-42.112-8.512-42.112-30.336v-4.064l-82.656 106.24 365.472-121.792zM704 544h-32v32h32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"animate",
						"fly",
						"move"
					],
					"grid": 32
				},
				{
					"id": 291,
					"width": 1024,
					"paths": [
						"M872.224 131.104l-522.592 209.088c-4.704-11.808-16.128-20.192-29.632-20.192h-160c-17.664 0-32 14.336-32 32v0h-32c-35.36 0-64 28.64-64 64v128c0 35.36 28.64 64 64 64h32c0 17.664 14.336 32 32 32v64c0 53.024 42.976 96 96 96h128c53.024 0 96-42.976 96-96v-32l392.224 156.896c42.048 16.8 87.776-14.144 87.776-59.424v-578.944c0-45.28-45.728-76.224-87.776-59.424zM128 576h-32c-17.664 0-32-14.336-32-32v-128c0-17.664 14.336-32 32-32h32v192zM349.6 619.872l34.4 13.728v70.4h-128v-64h64c13.472 0 24.864-8.352 29.6-20.128zM160 352h160v256h-160v-256zM384 768h-128c-35.36 0-64-28.64-64-64v-64h32v64c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-57.6l32 12.8v44.8c0 35.36-28.672 64-64 64zM884.128 799.168l-532.128-212.832v-212.672l532.128-212.832c20.992-8.416 43.872 7.072 43.872 29.696v578.944c0 22.624-22.88 38.112-43.872 29.696z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"announce",
						"broadcast",
						"speak",
						"amplify"
					],
					"grid": 32
				},
				{
					"id": 292,
					"width": 1024,
					"paths": [
						"M960 190.528v578.944c0 45.28-45.728 76.224-87.776 59.424l-392.224-156.896v96c0 17.664-14.336 32-32 32h-256c-17.664 0-32-14.336-32-32v-128c-17.664 0-32-14.336-32-32v-256c0-17.664 14.336-32 32-32h160c17.664 0 32 14.336 32 32v256c0 17.664-14.336 32-32 32h-96v96h192v-89.6l-32-12.768v-307.168l488.224-195.36c42.048-16.8 87.776 14.144 87.776 59.424zM96 352c-35.36 0-64 28.64-64 64v128c0 35.36 28.64 64 64 64v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"announce",
						"broadcast",
						"speak",
						"amplify"
					],
					"grid": 32
				},
				{
					"id": 956,
					"width": 1024,
					"paths": [
						"M864 224h-72.192l-13.792-45.984c-17.888-59.616-67.2-102.112-126.88-111.872-12.704-40.832-51.68-66.144-107.136-66.144-68.032 0-112 37.696-112 96s43.968 96 112 96c52.896 0 90.944-22.976 105.376-60.544 31.744 8.32 57.504 32.192 67.328 64.96l8.288 27.584h-564.992c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h7.296l48.928 416h-24.224c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-24.256l48.928-416h7.328c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM544 128c-31.84 0-48-10.752-48-32s16.16-32 48-32 48 10.752 48 32-16.16 32-48 32zM800 960h-576v-64h576v64zM228 384h568.032l-56.48 480h-455.104l-56.448-480zM832 352h-640v-64h640v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"announce",
						"broadcast",
						"speak",
						"promote"
					],
					"grid": 32
				},
				{
					"id": 1944,
					"paths": [
						"M715.646 763.646c-12.288 0-24.568-4.686-33.944-14.058-18.742-18.746-18.742-49.134 0-67.88 93.576-93.578 93.576-245.834 0-339.412-93.574-93.576-245.834-93.576-339.41 0-45.328 45.328-70.292 105.598-70.292 169.704s24.962 124.376 70.292 169.708c18.746 18.746 18.746 49.134 0 67.88s-49.134 18.746-67.88 0c-63.462-63.464-98.412-147.84-98.412-237.588 0-89.75 34.95-174.126 98.414-237.588 131.004-131.006 344.164-131.006 475.174 0 131.006 131.006 131.006 344.17 0 475.176-9.374 9.372-21.656 14.058-33.942 14.058v0z",
						"M840.098 888.098c-12.288 0-24.568-4.686-33.944-14.058-18.744-18.742-18.744-49.132 0-67.878 162.202-162.2 162.202-426.114 0-588.312-162.2-162.198-426.114-162.2-588.31 0-162.202 162.198-162.202 426.118 0 588.312 18.746 18.746 18.746 49.136 0 67.878-18.746 18.744-49.136 18.746-67.882 0-96.706-96.706-149.962-225.28-149.962-362.040s53.256-265.334 149.96-362.040c96.704-96.706 225.28-149.96 362.040-149.96s265.332 53.256 362.040 149.96c96.7 96.706 149.96 225.28 149.96 362.040s-53.26 265.334-149.96 362.040c-9.376 9.372-21.658 14.058-33.942 14.058v0z",
						"M608 960h-32.078l0.078-337.166c38.246-22.134 64-63.462 64-110.834 0-70.694-57.308-128-128-128-70.696 0-128 57.306-128 128 0 47.372 25.752 88.7 64 110.834l-0.078 337.166h-31.922c-17.672 0-32 14.326-32 32s14.328 32 32 32h192c17.674 0 32-14.326 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"antenna",
						"wifi",
						"wireless"
					],
					"defaultCode": 59779,
					"grid": 16
				},
				{
					"id": 1949,
					"paths": [
						"M320 1024h384l-128-128v-465.166c38.248-22.134 64-63.464 64-110.834 0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128 0 47.37 25.752 88.698 64 110.834v465.166l-128 128zM711.836 160.008c35.136 43.828 56.164 99.45 56.164 159.992s-21.030 116.164-56.164 159.992l49.958 39.998c43.92-54.784 70.206-124.312 70.206-199.99s-26.288-145.206-70.206-199.99l-49.958 39.998zM262.204 120.012c-43.918 54.784-70.204 124.312-70.204 199.988s26.286 145.204 70.204 199.988l49.958-39.998c-35.132-43.826-56.162-99.448-56.162-159.99s21.030-116.164 56.164-159.99l-49.96-39.998zM112.328 0c-70.268 87.656-112.328 198.898-112.328 319.982s42.060 232.326 112.328 319.978l49.958-39.996c-61.484-76.698-98.286-174.034-98.286-279.982s36.8-203.286 98.286-279.984l-49.958-39.998zM911.672 0l-49.958 39.998c61.486 76.698 98.286 174.036 98.286 279.984s-36.8 203.288-98.288 279.984l49.958 39.998c70.272-87.656 112.33-198.898 112.33-319.982s-42.058-232.326-112.328-319.982z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"antenna",
						"wifi",
						"wireless"
					],
					"defaultCode": 59784,
					"grid": 16
				},
				{
					"id": 96,
					"paths": [
						"M716.8 307.2h51.2v51.2h-51.2v-51.2z",
						"M716.8 409.6h51.2v51.2h-51.2v-51.2z",
						"M716.8 512h51.2v51.2h-51.2v-51.2z",
						"M716.8 614.4h51.2v51.2h-51.2v-51.2z",
						"M716.8 819.2h51.2v51.2h-51.2v-51.2z",
						"M716.8 716.8h51.2v51.2h-51.2v-51.2z",
						"M307.2 307.2h51.2v51.2h-51.2v-51.2z",
						"M307.2 409.6h51.2v51.2h-51.2v-51.2z",
						"M307.2 512h51.2v51.2h-51.2v-51.2z",
						"M307.2 614.4h51.2v51.2h-51.2v-51.2z",
						"M307.2 819.2h51.2v51.2h-51.2v-51.2z",
						"M307.2 716.8h51.2v51.2h-51.2v-51.2z",
						"M204.8 307.2h51.2v51.2h-51.2v-51.2z",
						"M204.8 409.6h51.2v51.2h-51.2v-51.2z",
						"M204.8 512h51.2v51.2h-51.2v-51.2z",
						"M204.8 614.4h51.2v51.2h-51.2v-51.2z",
						"M204.8 819.2h51.2v51.2h-51.2v-51.2z",
						"M204.8 716.8h51.2v51.2h-51.2v-51.2z",
						"M409.6 307.2h51.2v51.2h-51.2v-51.2z",
						"M409.6 409.6h51.2v51.2h-51.2v-51.2z",
						"M409.6 512h51.2v51.2h-51.2v-51.2z",
						"M409.6 614.4h51.2v51.2h-51.2v-51.2z",
						"M409.6 819.2h51.2v51.2h-51.2v-51.2z",
						"M409.6 716.8h51.2v51.2h-51.2v-51.2z",
						"M947.2 972.8h-25.6v-691.2c0-39.058-29.024-79.326-66.077-91.677l-241.123-80.374v-83.949c0-8.093-3.827-15.709-10.318-20.539-6.493-4.829-14.888-6.306-22.637-3.981l-462.96 138.886c-37.73 11.32-67.285 51.043-67.285 90.434v742.4h-25.6c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h921.6c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6zM839.333 238.496c16.259 5.419 31.067 25.965 31.067 43.104v691.2h-256v-809.282l224.933 74.978zM102.4 230.4c0-16.827 14.678-36.557 30.797-41.392l430.003-129.002v912.794h-460.8v-742.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"apartment",
						"building",
						"city",
						"business",
						"work",
						"office"
					],
					"defaultCode": 59393,
					"grid": 20
				},
				{
					"id": 2532,
					"paths": [
						"M512 317.306c-84.552-86.436-448-142.060-448 268.358 0 253.564 321.036 534.29 447.93 406.386h0.14c126.896 127.904 447.93-152.822 447.93-406.386 0-410.416-363.448-354.794-448-268.358zM833.104 682.5c-24.090 92.804-103.814 179.078-197.488 240.042 97.906-116.566 158.254-313.898 99.896-466.928-17.376-45.566-37.296-84.166-59.070-116.638 115.040 38.568 209.848 138.614 156.662 343.524zM480.324 204.056c13.634-3.254 26.578-7.512 38.902-12.512-4.482 20.668-7.226 42.446-7.226 64.456h21.34c18.572-86.748 88.38-188 181.454-188 0-47.666-32.332-68-68.71-68-34.62 17.166-64.836 47.948-89.242 91.426-13.178 23.476-26.926 55.668-35.67 91.702-1.744-10.174-4.348-20.38-7.966-30.552-39.49-111.062-177.12-175.886-307.406-144.788-14.752 3.522-28.736 8.17-41.954 13.722 1.654 12.556 4.602 25.182 9.074 37.756 39.488 111.064 177.118 175.888 307.404 144.79z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"apple",
						"fruit",
						"food"
					],
					"defaultCode": 60367,
					"grid": 16
				},
				{
					"id": 1519,
					"width": 795.9989929199219,
					"paths": [
						"M796 694.286q-22.286 71.429-70.286 142.857-73.714 112-146.857 112-28 0-80-18.286-49.143-18.286-86.286-18.286-34.857 0-81.143 18.857-46.286 19.429-75.429 19.429-86.857 0-172-148-84-149.143-84-287.429 0-130.286 64.571-213.714 64-82.286 162.286-82.286 41.143 0 101.143 17.143 59.429 17.143 78.857 17.143 25.714 0 81.714-19.429 58.286-19.429 98.857-19.429 68 0 121.714 37.143 29.714 20.571 59.429 57.143-45.143 38.286-65.143 67.429-37.143 53.714-37.143 118.286 0 70.857 39.429 127.429t90.286 72zM581.143 24q0 34.857-16.571 77.714-17.143 42.857-53.143 78.857-30.857 30.857-61.714 41.143-21.143 6.286-59.429 9.714 1.714-85.143 44.571-146.857 42.286-61.143 142.857-84.571 0.571 1.714 1.429 6.286t1.429 6.286q0 2.286 0.286 5.714t0.286 5.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"apple"
					],
					"defaultCode": 61817,
					"grid": 14
				},
				{
					"id": 3378,
					"paths": [
						"M791.498 544.092c-1.294-129.682 105.758-191.876 110.542-194.966-60.152-88.020-153.85-100.078-187.242-101.472-79.742-8.074-155.596 46.948-196.066 46.948-40.368 0-102.818-45.754-168.952-44.552-86.916 1.292-167.058 50.538-211.812 128.38-90.304 156.698-23.126 388.84 64.89 515.926 43.008 62.204 94.292 132.076 161.626 129.58 64.842-2.588 89.362-41.958 167.756-41.958s100.428 41.958 169.050 40.67c69.774-1.296 113.982-63.398 156.692-125.796 49.39-72.168 69.726-142.038 70.924-145.626-1.548-0.706-136.060-52.236-137.408-207.134zM662.562 163.522c35.738-43.358 59.86-103.512 53.28-163.522-51.478 2.096-113.878 34.29-150.81 77.55-33.142 38.376-62.148 99.626-54.374 158.436 57.466 4.484 116.128-29.204 151.904-72.464z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"apple",
						"brand"
					],
					"defaultCode": 61213,
					"grid": 16
				},
				{
					"id": 2638,
					"paths": [
						"M864 192h-96v-96c0-17.672-14.326-32-32-32s-32 14.328-32 32v64c0-17.672-14.326-32-32-32s-32 14.328-32 32v114.746l-35.11 35.108c-43.364-33.734-97.82-53.854-156.89-53.854-141.16 0-256 114.84-256 256 0 141.158 114.84 256 256 256 141.158 0 256-114.842 256-256 0-59.072-20.122-113.526-53.856-156.892l35.11-35.108h114.746c17.674 0 32-14.328 32-32s-14.326-32-32-32h64c17.674 0 32-14.328 32-32s-14.326-32-32-32zM640 512c0 105.87-86.13 192-192 192s-192-86.13-192-192 86.13-192 192-192c41.408 0 79.794 13.176 111.19 35.556l-94.622 94.622c-5.286-1.414-10.836-2.178-16.568-2.178-35.346 0-64 28.654-64 64 0 35.348 28.654 64 64 64s64-28.652 64-64c0-5.732-0.764-11.282-2.178-16.568l94.622-94.622c22.378 31.396 35.556 69.782 35.556 111.19z",
						"M836 512c0-35.932-4.916-71.53-14.612-105.806-5.41-19.132-25.31-30.254-44.44-24.842s-30.254 25.308-24.842 44.44c7.892 27.898 11.894 56.904 11.894 86.208 0 174.242-141.758 316-316 316-174.244 0-316-141.758-316-316 0-174.244 141.756-316 316-316 29.304 0 58.308 4 86.208 11.892 19.13 5.414 39.030-5.708 44.44-24.842 5.412-19.132-5.71-39.028-24.842-44.44-34.276-9.694-69.874-14.61-105.806-14.61-213.944 0-388 174.056-388 388 0 111.73 47.49 212.56 123.322 283.424l-109.95 109.95c-12.498 12.496-12.498 32.758 0 45.254 6.25 6.248 14.438 9.372 22.628 9.372s16.378-3.124 22.626-9.374l115.238-115.236c61.412 40.8 135.040 64.61 214.136 64.61s152.722-23.81 214.136-64.61l115.236 115.236c6.25 6.25 14.438 9.374 22.628 9.374s16.378-3.124 22.626-9.374c12.498-12.496 12.498-32.758 0-45.254l-109.95-109.95c75.834-70.862 123.324-171.692 123.324-283.422z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"archery",
						"soprts",
						"target",
						"goal",
						"sports"
					],
					"defaultCode": 60473,
					"grid": 16
				},
				{
					"id": 1963,
					"width": 1088,
					"paths": [
						"M256 64h-192c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h192c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64zM192 808c0 13.2-10.8 24-24 24h-16c-13.2 0-24-10.8-24-24v-16c0-13.2 10.8-24 24-24h16c13.2 0 24 10.8 24 24v16zM256 640h-192v-320h192v320zM256 256h-192v-64h192v64zM640 64h-192c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h192c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64zM576 808c0 13.2-10.8 24-24 24h-16c-13.2 0-24-10.8-24-24v-16c0-13.2 10.8-24 24-24h16c13.2 0 24 10.8 24 24v16zM640 640h-192v-320h192v320zM640 256h-192v-64h192v64zM1024 64h-192c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h192c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64zM960 808c0 13.2-10.8 24-24 24h-16c-13.2 0-24-10.8-24-24v-16c0-13.2 10.8-24 24-24h16c13.2 0 24 10.8 24 24v16zM1024 640h-192v-320h192v320zM1024 256h-192v-64h192v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"archive",
						"office",
						"documents",
						"library",
						"books"
					],
					"defaultCode": 59798,
					"grid": 16
				},
				{
					"id": 1532,
					"width": 1024.0020446777344,
					"paths": [
						"M621.714 475.429q0-14.857-10.857-25.714t-25.714-10.857h-146.286q-14.857 0-25.714 10.857t-10.857 25.714 10.857 25.714 25.714 10.857h146.286q14.857 0 25.714-10.857t10.857-25.714zM950.857 365.714v548.571q0 14.857-10.857 25.714t-25.714 10.857h-804.571q-14.857 0-25.714-10.857t-10.857-25.714v-548.571q0-14.857 10.857-25.714t25.714-10.857h804.571q14.857 0 25.714 10.857t10.857 25.714zM987.429 109.714v146.286q0 14.857-10.857 25.714t-25.714 10.857h-877.714q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-14.857 10.857-25.714t25.714-10.857h877.714q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"archive"
					],
					"defaultCode": 61831,
					"grid": 14
				},
				{
					"id": 1644,
					"width": 1170.2860107421875,
					"paths": [
						"M1170.286 877.714v73.143h-1170.286v-877.714h73.143v804.571h1097.143zM950.857 292.571l146.286 512h-950.857v-329.143l256-329.143 329.143 329.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"area-chart"
					],
					"defaultCode": 61950,
					"grid": 14
				},
				{
					"id": 293,
					"width": 1024,
					"paths": [
						"M768 576c-88.224 0-160 71.776-160 160s71.776 160 160 160 160-71.776 160-160-71.776-160-160-160zM768 864c-70.688 0-128-57.312-128-128s57.312-128 128-128 128 57.312 128 128c0 70.688-57.312 128-128 128zM864 533.856v-85.856c0-15.52-11.264-27.84-25.92-30.784 15.968-17.12 25.92-39.936 25.92-65.216 0-53.024-42.976-96-96-96-2.080 0-4.032 0.48-6.080 0.608 3.712-10.208 6.080-21.088 6.080-32.608 0-53.024-42.976-96-96-96-24.992 0-47.584 9.792-64.672 25.472-3.424-49.92-44.544-89.472-95.328-89.472s-91.904 39.552-95.328 89.472c-17.088-15.68-39.68-25.472-64.672-25.472-53.024 0-96 42.976-96 96 0 11.52 2.368 22.4 6.080 32.608-2.048-0.128-4-0.608-6.080-0.608-53.024 0-96 42.976-96 96 0 25.28 9.952 48.096 25.92 65.216-14.656 2.944-25.92 15.264-25.92 30.784v85.856c-75.616 35.968-128 112.832-128 202.144 0 123.712 100.288 224 224 224s224-100.288 224-224c0-89.312-52.384-166.176-128-202.144v-85.856c0-15.52-11.264-27.84-25.92-30.784 15.968-17.12 25.92-39.936 25.92-65.216 0-11.52-2.368-22.4-6.080-32.608 2.048 0.128 4 0.608 6.080 0.608 50.784 0 91.904-39.552 95.328-89.472 17.088 15.68 39.68 25.472 64.672 25.472s47.584-9.792 64.672-25.472c3.424 49.92 44.544 89.472 95.328 89.472 2.080 0 4.032-0.48 6.080-0.608-3.712 10.208-6.080 21.088-6.080 32.608 0 25.28 9.952 48.096 25.92 65.216-14.656 2.944-25.92 15.264-25.92 30.784v85.856c-75.616 35.968-128 112.832-128 202.144 0 123.712 100.288 224 224 224s224-100.288 224-224c0-89.312-52.384-166.176-128-202.144zM832 352c0 35.296-28.704 64-64 64s-64-28.704-64-64 28.704-64 64-64 64 28.704 64 64zM256 288c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64 28.704-64 64-64zM448 736c0 105.856-86.144 192-192 192s-192-86.144-192-192c0-73.536 43.072-141.536 109.76-173.248l18.24-8.704v-106.048h128v106.080l18.24 8.672c66.688 31.712 109.76 99.712 109.76 173.248zM352 288c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64zM512 224c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64zM608 224c0-35.296 28.704-64 64-64s64 28.704 64 64-28.704 64-64 64-64-28.704-64-64zM768 928c-105.856 0-192-86.144-192-192 0-73.536 43.072-141.536 109.76-173.248l18.24-8.704v-106.048h128v106.080l18.24 8.672c66.688 31.712 109.76 99.712 109.76 173.248 0 105.856-86.144 192-192 192zM736 512c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM96 736c0 88.224 71.776 160 160 160s160-71.776 160-160-71.776-160-160-160-160 71.776-160 160zM384 736c0 70.688-57.312 128-128 128s-128-57.312-128-128c0-70.688 57.312-128 128-128s128 57.312 128 128zM224 512c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrest",
						"lock"
					],
					"grid": 32
				},
				{
					"id": 294,
					"width": 1024,
					"paths": [
						"M864 533.856v-85.856c0-15.52-11.264-27.84-25.92-30.784 15.968-17.12 25.92-39.936 25.92-65.216 0-53.024-42.976-96-96-96-2.080 0-4.032 0.48-6.080 0.608 3.712-10.208 6.080-21.088 6.080-32.608 0-53.024-42.976-96-96-96-24.992 0-47.584 9.792-64.672 25.472-3.424-49.92-44.544-89.472-95.328-89.472s-91.904 39.552-95.328 89.472c-17.088-15.68-39.68-25.472-64.672-25.472-53.024 0-96 42.976-96 96 0 11.52 2.368 22.4 6.080 32.608-2.048-0.128-4-0.608-6.080-0.608-53.024 0-96 42.976-96 96 0 25.28 9.952 48.096 25.92 65.216-14.656 2.944-25.92 15.264-25.92 30.784v85.856c-75.616 35.968-128 112.832-128 202.144 0 123.712 100.288 224 224 224s224-100.288 224-224c0-89.312-52.384-166.176-128-202.144v-85.856c0-15.52-11.264-27.84-25.92-30.784 15.968-17.12 25.92-39.936 25.92-65.216 0-11.52-2.368-22.4-6.080-32.608 2.048 0.128 4 0.608 6.080 0.608 50.784 0 91.904-39.552 95.328-89.472 17.088 15.68 39.68 25.472 64.672 25.472s47.584-9.792 64.672-25.472c3.424 49.92 44.544 89.472 95.328 89.472 2.080 0 4.032-0.48 6.080-0.608-3.712 10.208-6.080 21.088-6.080 32.608 0 25.28 9.952 48.096 25.92 65.216-14.656 2.944-25.92 15.264-25.92 30.784v85.856c-75.616 35.968-128 112.832-128 202.144 0 123.712 100.288 224 224 224s224-100.288 224-224c0-89.312-52.384-166.176-128-202.144zM256 288c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64 28.704-64 64-64zM288 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM416 736c0 88.224-71.776 160-160 160s-160-71.776-160-160 71.776-160 160-160 160 71.776 160 160zM352 288c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64zM512 224c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64zM768 288c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64 28.704-64 64-64zM800 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM672 288c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64zM768 896c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.776 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrest",
						"lock"
					],
					"grid": 32
				},
				{
					"id": 1340,
					"width": 877.7139282226562,
					"paths": [
						"M733.714 512.571q0-15.429-10.286-25.714l-52-52q-10.286-10.286-25.714-10.286t-25.714 10.286l-108 108v-286.857q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v286.857l-108-108q-10.857-10.857-25.714-10.857t-25.714 10.857l-52 52q-10.286 10.286-10.286 25.714t10.286 25.714l258.857 258.857q10.286 10.286 25.714 10.286t25.714-10.286l258.857-258.857q10.286-10.286 10.286-25.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-circle-down"
					],
					"defaultCode": 61611,
					"grid": 14
				},
				{
					"id": 1337,
					"width": 877.7139282226562,
					"paths": [
						"M731.429 548.571v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-286.857l108-108q10.857-10.857 10.857-25.714t-10.857-25.714l-52-52q-10.286-10.286-25.714-10.286t-25.714 10.286l-258.857 258.857q-10.286 10.286-10.286 25.714t10.286 25.714l258.857 258.857q10.286 10.286 25.714 10.286t25.714-10.286l52-52q10.286-10.286 10.286-25.714t-10.286-25.714l-108-108h286.857q14.857 0 25.714-10.857t10.857-25.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-circle-left"
					],
					"defaultCode": 61608,
					"grid": 14
				},
				{
					"id": 1204,
					"width": 877.7139282226562,
					"paths": [
						"M640 530.286q0 6.857-5.714 13.714l-182.286 182.286q-6.286 5.143-13.143 5.143t-13.143-5.143l-182.857-182.857q-8.571-9.143-4-20 4.571-11.429 17.143-11.429h109.714v-201.143q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v201.143h109.714q8 0 13.143 5.143t5.143 13.143zM438.857 201.143q-84.571 0-156 41.714t-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156-41.714-156-113.143-113.143-156-41.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-circle-o-down"
					],
					"defaultCode": 61466,
					"grid": 14
				},
				{
					"id": 1540,
					"width": 877.7139282226562,
					"paths": [
						"M658.286 457.143v109.714q0 7.429-5.429 12.857t-12.857 5.429h-201.143v109.714q0 8-5.143 13.143t-13.143 5.143q-6.857 0-13.714-5.714l-182.286-182.286q-5.143-5.143-5.143-13.143t5.143-13.143l182.857-182.857q5.143-5.143 13.143-5.143 7.429 0 12.857 5.429t5.429 12.857v109.714h201.143q7.429 0 12.857 5.429t5.429 12.857zM749.714 512q0-84.571-41.714-156t-113.143-113.143-156-41.714-156 41.714-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-circle-o-left"
					],
					"defaultCode": 61840,
					"grid": 14
				},
				{
					"id": 1539,
					"width": 877.7139282226562,
					"paths": [
						"M658.286 512q0 8-5.143 13.143l-182.857 182.857q-5.143 5.143-13.143 5.143-7.429 0-12.857-5.429t-5.429-12.857v-109.714h-201.143q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h201.143v-109.714q0-8 5.143-13.143t13.143-5.143q6.857 0 13.714 5.714l182.286 182.286q5.143 5.143 5.143 13.143zM749.714 512q0-84.571-41.714-156t-113.143-113.143-156-41.714-156 41.714-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-circle-o-right"
					],
					"defaultCode": 61838,
					"grid": 14
				},
				{
					"id": 1205,
					"width": 877.7139282226562,
					"paths": [
						"M638.857 500.571q-4.571 11.429-17.143 11.429h-109.714v201.143q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-201.143h-109.714q-8 0-13.143-5.143t-5.143-13.143q0-6.857 5.714-13.714l182.286-182.286q6.286-5.143 13.143-5.143t13.143 5.143l182.857 182.857q8.571 9.143 4 20zM438.857 201.143q-84.571 0-156 41.714t-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156-41.714-156-113.143-113.143-156-41.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-circle-o-up"
					],
					"defaultCode": 61467,
					"grid": 14
				},
				{
					"id": 1338,
					"width": 877.7139282226562,
					"paths": [
						"M734.286 512q0-15.429-10.286-25.714l-258.857-258.857q-10.286-10.286-25.714-10.286t-25.714 10.286l-52 52q-10.286 10.286-10.286 25.714t10.286 25.714l108 108h-286.857q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h286.857l-108 108q-10.857 10.857-10.857 25.714t10.857 25.714l52 52q10.286 10.286 25.714 10.286t25.714-10.286l258.857-258.857q10.286-10.286 10.286-25.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-circle-right"
					],
					"defaultCode": 61609,
					"grid": 14
				},
				{
					"id": 1339,
					"width": 877.7139282226562,
					"paths": [
						"M733.714 511.429q0-15.429-10.286-25.714l-258.857-258.857q-10.286-10.286-25.714-10.286t-25.714 10.286l-258.857 258.857q-10.286 10.286-10.286 25.714t10.286 25.714l52 52q10.286 10.286 25.714 10.286t25.714-10.286l108-108v286.857q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714v-286.857l108 108q10.857 10.857 25.714 10.857t25.714-10.857l52-52q10.286-10.286 10.286-25.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-circle-up"
					],
					"defaultCode": 61610,
					"grid": 14
				},
				{
					"id": 3028,
					"paths": [
						"M1024 352l-192-192-320 320-320-320-192 192 512 511.998z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"buttom"
					],
					"defaultCode": 60863,
					"grid": 16
				},
				{
					"id": 227,
					"paths": [
						"M830.336 881.538c91.869-91.869 142.464-214.016 142.464-343.938s-50.595-252.067-142.464-343.936-214.014-142.464-343.936-142.464-252.069 50.595-343.938 142.464-142.462 214.014-142.462 343.936 50.594 252.069 142.462 343.938 214.016 142.462 343.938 142.462 252.067-50.594 343.936-142.462zM51.2 537.6c0-239.97 195.23-435.2 435.2-435.2s435.2 195.23 435.2 435.2c0 239.97-195.23 435.2-435.2 435.2s-435.2-195.23-435.2-435.2z",
						"M504.499 837.299l204.8-204.8c9.998-9.995 9.998-26.206 0-36.203-9.997-9.998-26.206-9.998-36.203 0l-161.096 161.101v-526.997c0-14.138-11.461-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v526.997l-161.101-161.096c-9.995-9.998-26.206-9.998-36.203 0-4.997 4.997-7.496 11.547-7.496 18.099s2.499 13.102 7.501 18.099l204.8 204.8c9.997 10 26.202 10 36.198 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-circle",
						"down"
					],
					"defaultCode": 59524,
					"grid": 20
				},
				{
					"id": 3046,
					"paths": [
						"M736 1024l-256-256 544-544-224-224-544 544-256-255.998v735.998h736z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-left",
						"down-left",
						"arrow-bottom-left"
					],
					"defaultCode": 60881,
					"grid": 16
				},
				{
					"id": 3054,
					"paths": [
						"M832 101.488l-509.254 509.254-194.746-194.742v480h480l-194.744-194.746 509.256-509.256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-left",
						"down-left",
						"arrow-bottom-left"
					],
					"defaultCode": 60889,
					"grid": 16
				},
				{
					"id": 3062,
					"paths": [
						"M786.744 146.744l-530.744 530.744v-229.49c0-35.346-28.654-64-64-64s-64 28.654-64 64v384.002c0 25.886 15.592 49.222 39.508 59.128 7.924 3.282 16.242 4.84 24.492 4.836v0.036l384-0.002c35.344 0 64-28.654 64-63.998 0-35.348-28.656-64-64-64h-229.49l530.744-530.746c12.496-12.496 18.746-28.876 18.746-45.256 0-16.376-6.25-32.758-18.746-45.254-24.992-24.992-65.518-24.992-90.51 0v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-left",
						"down-left",
						"arrow-bottom-left"
					],
					"defaultCode": 60897,
					"grid": 16
				},
				{
					"id": 3118,
					"paths": [
						"M309.020 533.96l-181.020-181.018v543.058h543.058l-181.018-181.020 384.666-520.432-45.254-45.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-left",
						"down-left",
						"arrow-bottom-left"
					],
					"defaultCode": 60953,
					"grid": 16
				},
				{
					"id": 3126,
					"paths": [
						"M480 704h448l-192 192h-608v-608l192-192v448l480-480 160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-left",
						"down-left",
						"arrow-bottom-left"
					],
					"defaultCode": 60961,
					"grid": 16
				},
				{
					"id": 3044,
					"paths": [
						"M1024 288l-256 256-544-544-224 224 544 544-255.998 256h735.998v-736z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-right",
						"down-right",
						"arrow-bottom-right"
					],
					"defaultCode": 60879,
					"grid": 16
				},
				{
					"id": 3052,
					"paths": [
						"M101.49 192l509.254 509.256-194.744 194.744h480v-480l-194.746 194.744-509.254-509.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-right",
						"down-right",
						"arrow-bottom-right"
					],
					"defaultCode": 60887,
					"grid": 16
				},
				{
					"id": 3060,
					"paths": [
						"M146.746 237.254l530.742 530.746h-229.488c-35.346 0-64 28.654-64 64s28.654 64 64 64h384c25.884 0 49.222-15.594 59.126-39.508 3.284-7.924 4.84-16.242 4.838-24.492h0.036v-384c0-35.346-28.654-64-64-64-35.348 0-64 28.654-64 64v229.49l-530.746-530.744c-12.496-12.498-28.874-18.746-45.254-18.746s-32.758 6.248-45.254 18.746c-24.994 24.992-24.994 65.516 0 90.508z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-right",
						"down-right",
						"arrow-bottom-right"
					],
					"defaultCode": 60895,
					"grid": 16
				},
				{
					"id": 3116,
					"paths": [
						"M533.96 714.98l-181.018 181.020h543.058v-543.058l-181.020 181.018-520.432-384.666-45.254 45.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-right",
						"down-right",
						"arrow-bottom-right"
					],
					"defaultCode": 60951,
					"grid": 16
				},
				{
					"id": 3124,
					"paths": [
						"M704 544v-448l192 192v608h-608l-192-192h448l-480-480 160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down-right",
						"down-right",
						"arrow-bottom-right"
					],
					"defaultCode": 60959,
					"grid": 16
				},
				{
					"id": 3110,
					"paths": [
						"M511.998 1024l512.002-512h-320v-511.998l-384-0.002v512h-320l511.998 512zM450.508 872l-16-16h154.98l-16 16h-122.98zM557.488 888l-16 16h-58.98l-16-16h90.98zM418.508 840l-16-16h218.982l-16 16h-186.982zM386.508 808l-16-16h282.982l-16 16h-250.982zM354.508 776l-16-16h346.982l-16 16h-314.982zM322.508 744l-15.998-16h410.98l-16 16h-378.982zM290.51 712l-16-16h474.98l-16 16h-442.98zM258.51 680l-16-16h538.98l-16 16h-506.98zM226.51 648l-16-16h602.98l-16 16h-570.98zM194.51 616l-16-16h666.98l-16 16h-634.98zM498.508 920h26.98l-13.49 13.49-13.49-13.49zM640 552h-256v-16h256v16zM640 520h-256v-16h256v16zM640 488h-256v-16h256v16zM640 456h-256v-16h256v16zM640 424h-256v-16h256v16zM640 392h-256v-16h256v16zM640 360h-256v-16h256v16zM640 328h-256v-16h256v16zM640 296h-256v-16h256v16zM640 264h-256v-16h256v16zM640 232h-256v-16h256v16zM640 200h-256v-16h256v16zM640 168h-256v-16h256v16zM640 136h-256v-16h256v16zM640 104h-256v-16h256v16zM640 64.002v7.998h-256v-8l256 0.002zM384 576v-8h256v8h229.49l-8 8h-698.98l-8-8h229.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"download",
						"bottom",
						"dualtone"
					],
					"defaultCode": 60945,
					"grid": 16
				},
				{
					"id": 3117,
					"paths": [
						"M480 1024l384-384h-256l-96-640h-64l-96 640h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"download",
						"bottom"
					],
					"defaultCode": 60952,
					"grid": 16
				},
				{
					"id": 3125,
					"paths": [
						"M896 608v-256l-320 320v-672h-192v672l-320-320v256l416 416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"download",
						"bottom"
					],
					"defaultCode": 60960,
					"grid": 16
				},
				{
					"id": 3130,
					"paths": [
						"M0 576l512 448 512-448h-372.448l116.448-576h-512l116.454 576h-372.454zM331.55 64h360.902l-116.452 576h277.666l-341.666 298.958-341.668-298.958h277.668l-116.45-576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"arrow-bottom",
						"download"
					],
					"defaultCode": 60965,
					"grid": 16
				},
				{
					"id": 3134,
					"paths": [
						"M512 1024l448-1024-448 192-448-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"arrow-bottom",
						"download"
					],
					"defaultCode": 60969,
					"grid": 16
				},
				{
					"id": 3146,
					"paths": [
						"M0 256l512 512 512-512-512 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"arrow-bottom",
						"download"
					],
					"defaultCode": 60981,
					"grid": 16
				},
				{
					"id": 3150,
					"paths": [
						"M320 0h384v64h-384zM320 128h384v64h-384zM320 256h384v64h-384zM512 1024l448-448h-256v-192h-384v192h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"arrow-bottom",
						"download"
					],
					"defaultCode": 60985,
					"grid": 16
				},
				{
					"id": 1272,
					"width": 950.8569107055664,
					"paths": [
						"M920.571 475.429q0 30.286-21.143 51.429l-372 372.571q-22.286 21.143-52 21.143-30.286 0-51.429-21.143l-372-372.571q-21.714-20.571-21.714-51.429 0-30.286 21.714-52l42.286-42.857q22.286-21.143 52-21.143 30.286 0 51.429 21.143l168 168v-402.286q0-29.714 21.714-51.429t51.429-21.714h73.143q29.714 0 51.429 21.714t21.714 51.429v402.286l168-168q21.143-21.143 51.429-21.143 29.714 0 52 21.143l42.857 42.857q21.143 22.286 21.143 52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down"
					],
					"defaultCode": 61539,
					"grid": 14
				},
				{
					"id": 215,
					"paths": [
						"M504.501 990.901l307.2-307.2c9.997-9.997 9.997-26.206 0-36.203-9.998-9.998-26.206-9.998-36.205 0l-263.496 263.498v-834.195c0-14.138-11.461-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v834.195l-263.499-263.496c-9.997-9.998-26.206-9.998-36.203 0-4.998 4.998-7.498 11.549-7.498 18.101s2.499 13.102 7.499 18.101l307.2 307.2c9.997 9.998 26.205 9.998 36.202 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down"
					],
					"defaultCode": 59512,
					"grid": 20
				},
				{
					"id": 3029,
					"paths": [
						"M1024 352l-128-128-384 384-384-384-128 128 511.998 512 512.002-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"buttom"
					],
					"defaultCode": 60864,
					"grid": 16
				},
				{
					"id": 3030,
					"paths": [
						"M1024 352l-96-96-416 416-416-416-96 96 511.998 512 512.002-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"buttom"
					],
					"defaultCode": 60865,
					"grid": 16
				},
				{
					"id": 3031,
					"paths": [
						"M1024 352l-64-64-448 448-448-448-64 64 511.998 512 512.002-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"buttom"
					],
					"defaultCode": 60866,
					"grid": 16
				},
				{
					"id": 3038,
					"paths": [
						"M224 384l288 288 288-288h-576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"download",
						"bottom"
					],
					"defaultCode": 60873,
					"grid": 16
				},
				{
					"id": 3045,
					"paths": [
						"M512 992l480-480h-288v-512h-384v512h-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"download",
						"bottom"
					],
					"defaultCode": 60880,
					"grid": 16
				},
				{
					"id": 3053,
					"paths": [
						"M160 640l352 352 352-352h-288v-576h-128v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"download",
						"bottom"
					],
					"defaultCode": 60888,
					"grid": 16
				},
				{
					"id": 3061,
					"paths": [
						"M877.254 621.254l-320 320c-24.992 24.994-65.514 24.994-90.508 0l-320-320c-24.994-24.994-24.994-65.516 0-90.51 24.994-24.996 65.516-24.996 90.51 0l210.744 210.746v-613.49c0-35.346 28.654-64 64-64s64 28.654 64 64v613.49l210.746-210.746c12.496-12.496 28.876-18.744 45.254-18.744s32.758 6.248 45.254 18.746c24.994 24.994 24.994 65.514 0 90.508z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"download",
						"bottom"
					],
					"defaultCode": 60896,
					"grid": 16
				},
				{
					"id": 3106,
					"paths": [
						"M511.998 1024l512.002-512h-320v-511.998l-384-0.002v512h-320l511.998 512zM384 576v-512l256 0.002v511.998h229.49l-357.492 357.49-357.488-357.49h229.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-down",
						"down",
						"download",
						"bottom"
					],
					"defaultCode": 60941,
					"grid": 16
				},
				{
					"id": 3032,
					"paths": [
						"M672 1024l192-192-320-320 320-320-192-192-512 512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60867,
					"grid": 16
				},
				{
					"id": 228,
					"paths": [
						"M142.462 193.664c91.869-91.869 214.016-142.464 343.938-142.464s252.067 50.595 343.936 142.464 142.464 214.014 142.464 343.936-50.595 252.069-142.464 343.938-214.014 142.462-343.936 142.462-252.069-50.594-343.938-142.462-142.462-214.016-142.462-343.938 50.594-252.067 142.462-343.936zM486.4 972.8c239.97 0 435.2-195.23 435.2-435.2s-195.23-435.2-435.2-435.2c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2z",
						"M186.701 519.501l204.8-204.8c9.995-9.998 26.206-9.998 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-161.101 161.096h526.997c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6h-526.997l161.096 161.101c9.998 9.995 9.998 26.206 0 36.203-4.997 4.997-11.547 7.496-18.099 7.496s-13.102-2.499-18.099-7.501l-204.8-204.8c-10-9.997-10-26.202 0-36.198z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left-circle",
						"left"
					],
					"defaultCode": 59525,
					"grid": 20
				},
				{
					"id": 3111,
					"paths": [
						"M0 511.998l512 512.002v-320h511.998l0.002-384h-512v-320l-512 511.998zM152 450.508l16-16v154.98l-16-16v-122.98zM136 557.488l-16-16v-58.98l16-16v90.98zM184 418.508l16-16v218.982l-16-16v-186.982zM216 386.508l16-16v282.982l-16-16v-250.982zM248 354.508l16-16v346.982l-16-16v-314.982zM280 322.508l16-15.998v410.98l-16-16v-378.982zM312 290.51l16-16v474.98l-16-16v-442.98zM344 258.51l16-16v538.98l-16-16v-506.98zM376 226.51l16-16v602.98l-16-16v-570.98zM408 194.51l16-16v666.98l-16-16v-634.98zM104 498.508v26.98l-13.49-13.49 13.49-13.49zM472 640v-256h16v256h-16zM504 640v-256h16v256h-16zM536 640v-256h16v256h-16zM568 640v-256h16v256h-16zM600 640v-256h16v256h-16zM632 640v-256h16v256h-16zM664 640v-256h16v256h-16zM696 640v-256h16v256h-16zM728 640v-256h16v256h-16zM760 640v-256h16v256h-16zM792 640v-256h16v256h-16zM824 640v-256h16v256h-16zM856 640v-256h16v256h-16zM888 640v-256h16v256h-16zM920 640v-256h16v256h-16zM959.998 640h-7.998v-256h8l-0.002 256zM448 384h8v256h-8v229.49l-8-8v-698.98l8-8v229.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous",
						"dualtone"
					],
					"defaultCode": 60946,
					"grid": 16
				},
				{
					"id": 3119,
					"paths": [
						"M0 544l384-384v256l640 96v64l-640 96v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60954,
					"grid": 16
				},
				{
					"id": 3127,
					"paths": [
						"M416 128h256l-320 320h672v192h-672l320 320h-256l-416-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60962,
					"grid": 16
				},
				{
					"id": 3131,
					"paths": [
						"M448 0l-448 512 448 512v-372.452l576 116.45v-511.998l-576 116.454v-372.454zM960 331.548v360.9l-576-116.452v277.666l-298.956-341.662 298.956-341.668v277.668l576-116.452z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"arrow-previous"
					],
					"defaultCode": 60966,
					"grid": 16
				},
				{
					"id": 3135,
					"paths": [
						"M0 512l1024 448-192-448 192-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"arrow-previous"
					],
					"defaultCode": 60970,
					"grid": 16
				},
				{
					"id": 3147,
					"paths": [
						"M768 0l-512 512 512 512-255.998-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"arrow-previous"
					],
					"defaultCode": 60982,
					"grid": 16
				},
				{
					"id": 3151,
					"paths": [
						"M960 320h64v384h-64zM832 320h64v384h-64zM704 320h64v384h-64zM0 512l448-448v256h192v384h-192v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"arrow-previous"
					],
					"defaultCode": 60986,
					"grid": 16
				},
				{
					"id": 1269,
					"width": 914.2860260009766,
					"paths": [
						"M877.714 512v73.143q0 30.286-18.571 51.714t-48.286 21.429h-402.286l167.429 168q21.714 20.571 21.714 51.429t-21.714 51.429l-42.857 43.429q-21.143 21.143-51.429 21.143-29.714 0-52-21.143l-372-372.571q-21.143-21.143-21.143-51.429 0-29.714 21.143-52l372-371.429q21.714-21.714 52-21.714 29.714 0 51.429 21.714l42.857 42.286q21.714 21.714 21.714 52t-21.714 52l-167.429 167.429h402.286q29.714 0 48.286 21.429t18.571 51.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left"
					],
					"defaultCode": 61536,
					"grid": 14
				},
				{
					"id": 216,
					"paths": [
						"M33.099 519.499l307.2-307.2c9.997-9.997 26.206-9.997 36.203 0 9.998 9.998 9.998 26.206 0 36.205l-263.498 263.496h834.195c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6h-834.195l263.496 263.499c9.998 9.997 9.998 26.206 0 36.203-4.998 4.998-11.549 7.498-18.101 7.498s-13.102-2.499-18.101-7.499l-307.2-307.2c-9.998-9.997-9.998-26.205 0-36.202z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left"
					],
					"defaultCode": 59513,
					"grid": 20
				},
				{
					"id": 3033,
					"paths": [
						"M672 1024l128-128-384-384 384-384-128-128-512 511.998 512 512.002z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60868,
					"grid": 16
				},
				{
					"id": 3034,
					"paths": [
						"M672 1024l96-96-416-416 416-416-96-96-512 511.998 512 512.002z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60869,
					"grid": 16
				},
				{
					"id": 3035,
					"paths": [
						"M672 1024l64-64-448-448 448-448-64-64-512 511.998 512 512.002z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60870,
					"grid": 16
				},
				{
					"id": 3039,
					"paths": [
						"M640 224l-288 288 288 288v-576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60874,
					"grid": 16
				},
				{
					"id": 3047,
					"paths": [
						"M32 512l480 480v-288h512v-384h-512v-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60882,
					"grid": 16
				},
				{
					"id": 3055,
					"paths": [
						"M384 160l-352 352 352 352v-288h576v-128h-576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60890,
					"grid": 16
				},
				{
					"id": 3063,
					"paths": [
						"M402.746 877.254l-320-320c-24.994-24.992-24.994-65.516 0-90.51l320-320c24.994-24.992 65.516-24.992 90.51 0 24.994 24.994 24.994 65.516 0 90.51l-210.746 210.746h613.49c35.346 0 64 28.654 64 64s-28.654 64-64 64h-613.49l210.746 210.746c12.496 12.496 18.744 28.876 18.744 45.254s-6.248 32.758-18.744 45.254c-24.994 24.994-65.516 24.994-90.51 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60898,
					"grid": 16
				},
				{
					"id": 3107,
					"paths": [
						"M0 511.998l512 512.002v-320h511.998l0.002-384h-512v-320l-512 511.998zM448 384h512l-0.002 256h-511.998v229.49l-357.49-357.492 357.49-357.488v229.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-left",
						"left",
						"previous"
					],
					"defaultCode": 60942,
					"grid": 16
				},
				{
					"id": 3088,
					"paths": [
						"M960 0h-384c-35.346 0-64 28.654-64 64s28.654 64 64 64h229.488l-677.488 677.488v-229.488c0-35.346-28.654-64-64-64s-64 28.654-64 64v384c0 35.346 28.654 64 64 64h384c35.346 0 64-28.654 64-64s-28.654-64-64-64h-229.488l677.488-677.49v229.49c0 35.346 28.654 64 64 64s64-28.654 64-64v-384c0-35.346-28.654-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-resize",
						"diagonal"
					],
					"defaultCode": 60923,
					"grid": 16
				},
				{
					"id": 3089,
					"paths": [
						"M0 64v384c0 35.346 28.654 64 64 64s64-28.654 64-64v-229.488l677.488 677.488h-229.488c-35.346 0-64 28.652-64 64 0 35.346 28.654 64 64 64h384c35.346 0 64-28.654 64-64v-384c0-35.348-28.654-64-64-64s-64 28.652-64 64v229.488l-677.488-677.488h229.488c35.346 0 64-28.654 64-64s-28.652-64-64-64h-384c-35.346 0-64 28.654-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-resize",
						"diagonal"
					],
					"defaultCode": 60924,
					"grid": 16
				},
				{
					"id": 3090,
					"paths": [
						"M722.744 365.256l82.746 82.744h-586.98l82.746-82.744c12.496-12.498 18.744-28.878 18.744-45.256s-6.248-32.758-18.746-45.256c-24.994-24.992-65.516-24.992-90.51 0l-192 192c-24.994 24.996-24.994 65.518 0 90.51l192 192c24.994 24.994 65.516 24.994 90.51 0 24.994-24.992 24.994-65.516 0-90.508l-82.744-82.746h586.98l-82.746 82.744c-24.992 24.994-24.992 65.516 0 90.51 24.994 24.994 65.518 24.994 90.512 0l192-192c12.496-12.496 18.744-28.876 18.744-45.254s-6.248-32.758-18.744-45.256l-192-192c-24.994-24.992-65.518-24.992-90.512 0-24.992 24.996-24.992 65.516 0 90.512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-resize",
						"horizontal"
					],
					"defaultCode": 60925,
					"grid": 16
				},
				{
					"id": 3091,
					"paths": [
						"M658.744 722.744l-82.744 82.746v-586.98l82.744 82.746c12.498 12.496 28.878 18.744 45.256 18.744s32.758-6.248 45.256-18.746c24.992-24.994 24.992-65.516 0-90.51l-192-192c-24.996-24.994-65.516-24.994-90.51 0l-192 192c-24.994 24.994-24.994 65.516 0 90.51s65.516 24.994 90.51 0l82.744-82.744v586.98l-82.746-82.746c-24.994-24.992-65.516-24.992-90.51 0-24.994 24.994-24.994 65.518 0 90.512l192 192c12.498 12.496 28.878 18.744 45.256 18.744s32.758-6.248 45.256-18.744l192-192c24.992-24.994 24.992-65.518 0-90.512-24.996-24.992-65.516-24.992-90.512 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-resize",
						"vertical"
					],
					"defaultCode": 60926,
					"grid": 16
				},
				{
					"id": 3092,
					"paths": [
						"M544 0l194.744 194.746-543.998 543.996-194.746-194.742v480h480l-194.744-194.746 543.998-543.996 194.746 194.742v-480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-resize",
						"diagonal"
					],
					"defaultCode": 60927,
					"grid": 16
				},
				{
					"id": 3093,
					"paths": [
						"M0 480l194.746-194.744 543.996 543.998-194.742 194.746h480v-480l-194.746 194.744-543.996-543.998 194.742-194.746h-480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-resize",
						"diagonal"
					],
					"defaultCode": 60928,
					"grid": 16
				},
				{
					"id": 3094,
					"paths": [
						"M992 512l-288 288v-224h-384v224l-288-288 288-288v224h384v-224l288 288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-resize",
						"horizontal"
					],
					"defaultCode": 60929,
					"grid": 16
				},
				{
					"id": 3095,
					"paths": [
						"M512 32l288 288h-224v384h224l-288 288-288-288h224v-384h-224l288-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-resize",
						"vertical"
					],
					"defaultCode": 60930,
					"grid": 16
				},
				{
					"id": 3024,
					"paths": [
						"M352 0l-192 192 320 320-320 320 192 192 512-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60859,
					"grid": 16
				},
				{
					"id": 229,
					"paths": [
						"M830.338 193.664c-91.869-91.869-214.016-142.464-343.938-142.464s-252.067 50.595-343.936 142.464-142.464 214.014-142.464 343.936 50.595 252.069 142.464 343.938 214.014 142.462 343.936 142.462 252.069-50.594 343.938-142.462 142.462-214.016 142.462-343.938-50.594-252.067-142.462-343.936zM486.4 972.8c-239.97 0-435.2-195.23-435.2-435.2s195.23-435.2 435.2-435.2c239.97 0 435.2 195.23 435.2 435.2s-195.23 435.2-435.2 435.2z",
						"M786.099 519.501l-204.8-204.8c-9.995-9.998-26.206-9.998-36.203 0-9.998 9.997-9.998 26.206 0 36.203l161.101 161.096h-526.997c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h526.997l-161.096 161.101c-9.998 9.995-9.998 26.206 0 36.203 4.997 4.997 11.547 7.496 18.099 7.496s13.102-2.499 18.099-7.501l204.8-204.8c10-9.997 10-26.202 0-36.198z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right-circle",
						"right"
					],
					"defaultCode": 59526,
					"grid": 20
				},
				{
					"id": 3109,
					"paths": [
						"M1024 512.002l-512-512.002v320h-511.998l-0.002 384h512v320l512-511.998zM872 573.492l-16 16v-154.98l16 16v122.98zM888 466.512l16 16v58.98l-16 16v-90.98zM840 605.492l-16 16v-218.982l16 16v186.982zM808 637.492l-16 16v-282.982l16 16v250.982zM776 669.492l-16 16v-346.982l16 16v314.982zM744 701.492l-16 15.998v-410.98l16 16v378.982zM712 733.49l-16 16v-474.98l16 16v442.98zM680 765.49l-16 16v-538.98l16 16v506.98zM648 797.49l-16 16v-602.98l16 16v570.98zM616 829.49l-16 16v-666.98l16 16v634.98zM920 525.492v-26.98l13.49 13.49-13.49 13.49zM552 384v256h-16v-256h16zM520 384v256h-16v-256h16zM488 384v256h-16v-256h16zM456 384v256h-16v-256h16zM424 384v256h-16v-256h16zM392 384v256h-16v-256h16zM360 384v256h-16v-256h16zM328 384v256h-16v-256h16zM296 384v256h-16v-256h16zM264 384v256h-16v-256h16zM232 384v256h-16v-256h16zM200 384v256h-16v-256h16zM168 384v256h-16v-256h16zM136 384v256h-16v-256h16zM104 384v256h-16v-256h16zM64.002 384h7.998v256h-8l0.002-256zM576 640h-8v-256h8v-229.49l8 8v698.98l-8 8v-229.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next",
						"dualtone"
					],
					"defaultCode": 60944,
					"grid": 16
				},
				{
					"id": 3115,
					"paths": [
						"M1024 544l-384-384v256l-640 96v64l640 96v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60950,
					"grid": 16
				},
				{
					"id": 3123,
					"paths": [
						"M608 128h-256l320 320h-672v192h672l-320 320h256l416-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60958,
					"grid": 16
				},
				{
					"id": 3129,
					"paths": [
						"M576 1024l448-512-448-512v372.45l-576-116.45v512l576-116.454v372.454zM64 692.452v-360.904l576 116.452v-277.666l298.958 341.666-298.958 341.668v-277.668l-576 116.452z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"arrow-next"
					],
					"defaultCode": 60964,
					"grid": 16
				},
				{
					"id": 3133,
					"paths": [
						"M1024 512l-1024-448 192 448-192 448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"arrow-next"
					],
					"defaultCode": 60968,
					"grid": 16
				},
				{
					"id": 3145,
					"paths": [
						"M256 1024l512-512-512-512 256 512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"arrow-next"
					],
					"defaultCode": 60980,
					"grid": 16
				},
				{
					"id": 3149,
					"paths": [
						"M0 320h64v384h-64zM128 320h64v384h-64zM256 320h64v384h-64zM1024 512l-448-448v256h-192v384h192v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"arrow-next"
					],
					"defaultCode": 60984,
					"grid": 16
				},
				{
					"id": 1270,
					"width": 841.141975402832,
					"paths": [
						"M841.143 548.571q0 30.857-21.143 52l-372 372q-22.286 21.143-52 21.143-29.143 0-51.429-21.143l-42.857-42.857q-21.714-21.714-21.714-52t21.714-52l167.429-167.429h-402.286q-29.714 0-48.286-21.429t-18.571-51.714v-73.143q0-30.286 18.571-51.714t48.286-21.429h402.286l-167.429-168q-21.714-20.571-21.714-51.429t21.714-51.429l42.857-42.857q21.714-21.714 51.429-21.714 30.286 0 52 21.714l372 372q21.143 20 21.143 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right"
					],
					"defaultCode": 61537,
					"grid": 14
				},
				{
					"id": 217,
					"paths": [
						"M990.901 519.499l-307.2-307.2c-9.997-9.997-26.206-9.997-36.203 0-9.998 9.998-9.998 26.206 0 36.205l263.498 263.496h-834.195c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h834.195l-263.496 263.499c-9.998 9.997-9.998 26.206 0 36.203 4.998 4.998 11.549 7.498 18.101 7.498s13.102-2.499 18.101-7.499l307.2-307.2c9.998-9.997 9.998-26.205 0-36.202z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right"
					],
					"defaultCode": 59514,
					"grid": 20
				},
				{
					"id": 3025,
					"paths": [
						"M352 0l-128 128 384 384-384 384 128 128 512-511.998-512-512.002z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60860,
					"grid": 16
				},
				{
					"id": 3026,
					"paths": [
						"M352 0l-96 96 416 416-416 416 96 96 512-511.998-512-512.002z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60861,
					"grid": 16
				},
				{
					"id": 3027,
					"paths": [
						"M352 0l-64 64 448 448-448 448 64 64 512-511.998-512-512.002z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60862,
					"grid": 16
				},
				{
					"id": 3037,
					"paths": [
						"M384 800l288-288-288-288v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60872,
					"grid": 16
				},
				{
					"id": 3043,
					"paths": [
						"M992 512l-480-480v288h-512v384h512v288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60878,
					"grid": 16
				},
				{
					"id": 3051,
					"paths": [
						"M640 864l352-352-352-352v288h-576v128h576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60886,
					"grid": 16
				},
				{
					"id": 3059,
					"paths": [
						"M621.254 877.254l320-320c24.994-24.992 24.994-65.516 0-90.51l-320-320c-24.994-24.992-65.516-24.992-90.51 0-24.994 24.994-24.994 65.516 0 90.51l210.746 210.746h-613.49c-35.346 0-64 28.654-64 64s28.654 64 64 64h613.49l-210.746 210.746c-12.496 12.496-18.744 28.876-18.744 45.254s6.248 32.758 18.744 45.254c24.994 24.994 65.516 24.994 90.51 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60894,
					"grid": 16
				},
				{
					"id": 3105,
					"paths": [
						"M1024 512.002l-512-512.002v320h-511.998l-0.002 384h512v320l512-511.998zM576 640h-512l0.002-256h511.998v-229.49l357.49 357.492-357.49 357.488v-229.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-right",
						"right",
						"next"
					],
					"defaultCode": 60940,
					"grid": 16
				},
				{
					"id": 3020,
					"paths": [
						"M0 672l192 192 320-320 320 320 192-192-511.998-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"top"
					],
					"defaultCode": 60855,
					"grid": 16
				},
				{
					"id": 226,
					"paths": [
						"M142.464 193.662c-91.869 91.869-142.464 214.016-142.464 343.938s50.595 252.067 142.464 343.936 214.014 142.464 343.936 142.464 252.069-50.595 343.938-142.464 142.462-214.014 142.462-343.936-50.594-252.069-142.462-343.938-214.016-142.462-343.938-142.462-252.067 50.594-343.936 142.462zM921.6 537.6c0 239.97-195.23 435.2-435.2 435.2s-435.2-195.23-435.2-435.2c0-239.97 195.23-435.2 435.2-435.2s435.2 195.23 435.2 435.2z",
						"M468.301 237.901l-204.8 204.8c-9.998 9.995-9.998 26.206 0 36.203 9.997 9.998 26.206 9.998 36.203 0l161.096-161.101v526.997c0 14.138 11.461 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-526.997l161.101 161.096c9.995 9.998 26.206 9.998 36.203 0 4.997-4.997 7.496-11.547 7.496-18.099s-2.499-13.102-7.501-18.099l-204.8-204.8c-9.997-10-26.202-10-36.198 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-circle",
						"up"
					],
					"defaultCode": 59523,
					"grid": 20
				},
				{
					"id": 3040,
					"paths": [
						"M0 736l256-256 544 544 224-224-544-544 255.998-256h-735.998v736z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-left",
						"up-left",
						"arrow-top-left"
					],
					"defaultCode": 60875,
					"grid": 16
				},
				{
					"id": 3048,
					"paths": [
						"M922.51 832l-509.254-509.254 194.744-194.746h-480v480l194.746-194.746 509.254 509.256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-left",
						"up-left",
						"arrow-top-left"
					],
					"defaultCode": 60883,
					"grid": 16
				},
				{
					"id": 3056,
					"paths": [
						"M877.254 786.746l-530.744-530.746h229.49c35.346 0 64-28.654 64-64s-28.654-64-64-64h-384c-25.886 0-49.222 15.592-59.128 39.508-3.282 7.924-4.84 16.242-4.838 24.492h-0.034v384c0 35.346 28.654 64 64 64s64-28.654 64-64v-229.49l530.746 530.744c12.496 12.498 28.876 18.746 45.254 18.746s32.758-6.248 45.254-18.746c24.994-24.992 24.994-65.516 0-90.508z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-left",
						"up-left",
						"arrow-top-left"
					],
					"defaultCode": 60891,
					"grid": 16
				},
				{
					"id": 3112,
					"paths": [
						"M490.040 309.020l181.018-181.020h-543.058v543.058l181.020-181.018 520.432 384.666 45.254-45.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-left",
						"up-left",
						"arrow-top-left"
					],
					"defaultCode": 60947,
					"grid": 16
				},
				{
					"id": 3120,
					"paths": [
						"M480 320h448l-192-192h-608v608l192 192v-448l480 480 160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-left",
						"up-left",
						"arrow-top-left"
					],
					"defaultCode": 60955,
					"grid": 16
				},
				{
					"id": 3042,
					"paths": [
						"M288 0l256 256-544 544 224 224 544-544 256 255.998v-735.998h-736z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-right",
						"up-right",
						"arrow-top-right"
					],
					"defaultCode": 60877,
					"grid": 16
				},
				{
					"id": 3050,
					"paths": [
						"M192 922.51l509.256-509.256 194.744 194.746v-480h-480l194.744 194.746-509.254 509.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-right",
						"up-right",
						"arrow-top-right"
					],
					"defaultCode": 60885,
					"grid": 16
				},
				{
					"id": 3058,
					"paths": [
						"M237.254 877.254l530.746-530.744v229.49c0 35.346 28.654 64 64 64s64-28.654 64-64v-384c0-25.884-15.594-49.222-39.508-59.126-7.924-3.284-16.242-4.84-24.492-4.838v-0.036h-384c-35.346 0-64 28.654-64 64 0 35.348 28.654 64 64 64h229.49l-530.744 530.746c-12.498 12.496-18.746 28.876-18.746 45.254s6.248 32.758 18.746 45.254c24.992 24.994 65.516 24.994 90.508 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-right",
						"up-right",
						"arrow-top-right"
					],
					"defaultCode": 60893,
					"grid": 16
				},
				{
					"id": 3114,
					"paths": [
						"M714.98 490.040l181.020 181.018v-543.058h-543.058l181.018 181.020-384.666 520.432 45.254 45.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-right",
						"up-right",
						"arrow-top-right"
					],
					"defaultCode": 60949,
					"grid": 16
				},
				{
					"id": 3122,
					"paths": [
						"M544 320h-448l192-192h608v608l-192 192v-448l-480 480-160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up-right",
						"up-right",
						"arrow-top-right"
					],
					"defaultCode": 60957,
					"grid": 16
				},
				{
					"id": 3108,
					"paths": [
						"M512.002 0l-512.002 512h320v511.998l384 0.002v-512h320l-511.998-512zM573.492 152l16 16h-154.98l16-16h122.98zM466.512 136l16-16h58.98l16 16h-90.98zM605.492 184l16 16h-218.982l16-16h186.982zM637.492 216l16 16h-282.982l16-16h250.982zM669.492 248l16 16h-346.982l16-16h314.982zM701.492 280l15.998 16h-410.98l16-16h378.982zM733.49 312l16 16h-474.98l16-16h442.98zM765.49 344l16 16h-538.98l16-16h506.98zM797.49 376l16 16h-602.98l16-16h570.98zM829.49 408l16 16h-666.98l16-16h634.98zM525.492 104h-26.98l13.49-13.49 13.49 13.49zM384 472h256v16h-256v-16zM384 504h256v16h-256v-16zM384 536h256v16h-256v-16zM384 568h256v16h-256v-16zM384 600h256v16h-256v-16zM384 632h256v16h-256v-16zM384 664h256v16h-256v-16zM384 696h256v16h-256v-16zM384 728h256v16h-256v-16zM384 760h256v16h-256v-16zM384 792h256v16h-256v-16zM384 824h256v16h-256v-16zM384 856h256v16h-256v-16zM384 888h256v16h-256v-16zM384 920h256v16h-256v-16zM384 959.998v-7.998h256v8l-256-0.002zM640 448v8h-256v-8h-229.49l8-8h698.98l8 8h-229.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"upload",
						"top",
						"dualtone"
					],
					"defaultCode": 60943,
					"grid": 16
				},
				{
					"id": 3113,
					"paths": [
						"M480 0l-384 384h256l96 640h64l96-640h256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"upload",
						"top"
					],
					"defaultCode": 60948,
					"grid": 16
				},
				{
					"id": 3121,
					"paths": [
						"M64 416v256l320-320v672h192v-672l320 320v-256l-416-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"upload",
						"top"
					],
					"defaultCode": 60956,
					"grid": 16
				},
				{
					"id": 3128,
					"paths": [
						"M1024 448l-512-448-512 448h372.45l-116.45 576h512l-116.452-576h372.452zM692.452 960h-360.902l116.45-576h-277.666l341.666-298.958 341.668 298.958h-277.668l116.452 576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"arrow-top",
						"upload"
					],
					"defaultCode": 60963,
					"grid": 16
				},
				{
					"id": 3132,
					"paths": [
						"M512 0l-448 1024 448-192 448 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"arrow-top",
						"upload"
					],
					"defaultCode": 60967,
					"grid": 16
				},
				{
					"id": 3144,
					"paths": [
						"M1024 768l-512-512-512 512 512-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"arrow-top",
						"upload"
					],
					"defaultCode": 60979,
					"grid": 16
				},
				{
					"id": 3148,
					"paths": [
						"M320 960h384v64h-384zM320 832h384v64h-384zM320 704h384v64h-384zM512 0l448 448h-256v192h-384v-192h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"arrow-top",
						"upload"
					],
					"defaultCode": 60983,
					"grid": 16
				},
				{
					"id": 1271,
					"width": 950.8549499511719,
					"paths": [
						"M920.571 554.857q0 29.143-21.143 51.429l-42.857 42.857q-21.714 21.714-52 21.714-30.857 0-51.429-21.714l-168-167.429v402.286q0 29.714-21.429 48.286t-51.714 18.571h-73.143q-30.286 0-51.714-18.571t-21.429-48.286v-402.286l-168 167.429q-20.571 21.714-51.429 21.714t-51.429-21.714l-42.857-42.857q-21.714-21.714-21.714-51.429 0-30.286 21.714-52l372-372q20-21.143 51.429-21.143 30.857 0 52 21.143l372 372q21.143 22.286 21.143 52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up"
					],
					"defaultCode": 61538,
					"grid": 14
				},
				{
					"id": 214,
					"paths": [
						"M468.299 33.099l-307.2 307.2c-9.997 9.997-9.997 26.206 0 36.203 9.998 9.998 26.206 9.998 36.205 0l263.496-263.498v834.195c0 14.138 11.461 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-834.195l263.499 263.496c9.997 9.998 26.206 9.998 36.203 0 4.998-4.998 7.498-11.549 7.498-18.101s-2.499-13.102-7.499-18.101l-307.2-307.2c-9.997-9.998-26.205-9.998-36.202 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up"
					],
					"defaultCode": 59511,
					"grid": 20
				},
				{
					"id": 3021,
					"paths": [
						"M0 672l128 128 384-384 384 384 128-128-511.998-512-512.002 512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"top"
					],
					"defaultCode": 60856,
					"grid": 16
				},
				{
					"id": 3022,
					"paths": [
						"M0 672l96 96 416-416 416 416 96-96-511.998-512-512.002 512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"top"
					],
					"defaultCode": 60857,
					"grid": 16
				},
				{
					"id": 3023,
					"paths": [
						"M0 672l64 64 448-448 448 448 64-64-511.998-512-512.002 512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"top"
					],
					"defaultCode": 60858,
					"grid": 16
				},
				{
					"id": 3036,
					"paths": [
						"M800 640l-288-288-288 288h576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"upload",
						"top"
					],
					"defaultCode": 60871,
					"grid": 16
				},
				{
					"id": 3041,
					"paths": [
						"M512 32l-480 480h288v512h384v-512h288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"upload",
						"top"
					],
					"defaultCode": 60876,
					"grid": 16
				},
				{
					"id": 3049,
					"paths": [
						"M864 384l-352-352-352 352h288v576h128v-576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"upload",
						"top"
					],
					"defaultCode": 60884,
					"grid": 16
				},
				{
					"id": 3057,
					"paths": [
						"M877.254 402.746l-320-320c-24.992-24.994-65.514-24.994-90.508 0l-320 320c-24.994 24.994-24.994 65.516 0 90.51 24.994 24.996 65.516 24.996 90.51 0l210.744-210.746v613.49c0 35.346 28.654 64 64 64s64-28.654 64-64v-613.49l210.746 210.746c12.496 12.496 28.876 18.744 45.254 18.744s32.758-6.248 45.254-18.746c24.994-24.994 24.994-65.514 0-90.508z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"upload",
						"top"
					],
					"defaultCode": 60892,
					"grid": 16
				},
				{
					"id": 3104,
					"paths": [
						"M512.002 0l-512.002 512h320v511.998l384 0.002v-512h320l-511.998-512zM640 448v512l-256-0.002v-511.998h-229.49l357.492-357.49 357.488 357.49h-229.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrow-up",
						"up",
						"upload",
						"top"
					],
					"defaultCode": 60939,
					"grid": 16
				},
				{
					"id": 1246,
					"width": 1023.9999885559082,
					"paths": [
						"M1024 512q0 14.857-10.857 25.714l-146.286 146.286q-10.857 10.857-25.714 10.857t-25.714-10.857-10.857-25.714v-73.143h-219.429v219.429h73.143q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714l-146.286 146.286q-10.857 10.857-25.714 10.857t-25.714-10.857l-146.286-146.286q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857h73.143v-219.429h-219.429v73.143q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-146.286-146.286q-10.857-10.857-10.857-25.714t10.857-25.714l146.286-146.286q10.857-10.857 25.714-10.857t25.714 10.857 10.857 25.714v73.143h219.429v-219.429h-73.143q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714l146.286-146.286q10.857-10.857 25.714-10.857t25.714 10.857l146.286 146.286q10.857 10.857 10.857 25.714t-10.857 25.714-25.714 10.857h-73.143v219.429h219.429v-73.143q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857l146.286 146.286q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrows"
					],
					"defaultCode": 61511,
					"grid": 14
				},
				{
					"id": 1346,
					"width": 877.7190818786621,
					"paths": [
						"M733.143 309.143l-202.857 202.857 202.857 202.857 82.286-82.286q16.571-17.714 40-8 22.286 9.714 22.286 33.714v256q0 14.857-10.857 25.714t-25.714 10.857h-256q-24 0-33.714-22.857-9.714-22.286 8-39.429l82.286-82.286-202.857-202.857-202.857 202.857 82.286 82.286q17.714 17.143 8 39.429-9.714 22.857-33.714 22.857h-256q-14.857 0-25.714-10.857t-10.857-25.714v-256q0-24 22.857-33.714 22.286-9.714 39.429 8l82.286 82.286 202.857-202.857-202.857-202.857-82.286 82.286q-10.857 10.857-25.714 10.857-6.857 0-13.714-2.857-22.857-9.714-22.857-33.714v-256q0-14.857 10.857-25.714t25.714-10.857h256q24 0 33.714 22.857 9.714 22.286-8 39.429l-82.286 82.286 202.857 202.857 202.857-202.857-82.286-82.286q-17.714-17.143-8-39.429 9.714-22.857 33.714-22.857h256q14.857 0 25.714 10.857t10.857 25.714v256q0 24-22.286 33.714-7.429 2.857-14.286 2.857-14.857 0-25.714-10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrows-alt"
					],
					"defaultCode": 61618,
					"grid": 14
				},
				{
					"id": 1298,
					"width": 1024.0009956359863,
					"paths": [
						"M1024 512q0 14.857-10.857 25.714l-146.286 146.286q-10.857 10.857-25.714 10.857t-25.714-10.857-10.857-25.714v-73.143h-585.143v73.143q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-146.286-146.286q-10.857-10.857-10.857-25.714t10.857-25.714l146.286-146.286q10.857-10.857 25.714-10.857t25.714 10.857 10.857 25.714v73.143h585.143v-73.143q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857l146.286 146.286q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrows-h"
					],
					"defaultCode": 61566,
					"grid": 14
				},
				{
					"id": 1297,
					"width": 438.85801696777344,
					"paths": [
						"M402.286 182.857q0 14.857-10.857 25.714t-25.714 10.857h-73.143v585.143h73.143q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714l-146.286 146.286q-10.857 10.857-25.714 10.857t-25.714-10.857l-146.286-146.286q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857h73.143v-585.143h-73.143q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714l146.286-146.286q10.857-10.857 25.714-10.857t25.714 10.857l146.286 146.286q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"arrows-v"
					],
					"defaultCode": 61565,
					"grid": 14
				},
				{
					"id": 957,
					"width": 1024,
					"paths": [
						"M832 0h-160c-17.664 0-32 14.336-32 32v32h-256v-32c0-17.664-14.336-32-32-32h-160c-17.664 0-32 14.336-32 32v960c0 17.664 14.336 32 32 32h160c17.664 0 32-14.336 32-32v-64h256v64c0 17.664 14.336 32 32 32h160c17.664 0 32-14.336 32-32v-960c0-17.664-14.336-32-32-32zM320 640v-64h384v64h-384zM672 672v96h-320v-96h320zM352 544v-96h320v96h-320zM320 416v-64h384v64h-384zM352 320v-96h320v96h-320zM320 192v-64h384v64h-384zM224 64h96v32h-32v128h32v96h-32v128h32v96h-32v128h32v96h-32v128h32v64h-96v-896zM320 800h384v64h-384v-64zM800 960h-96v-64h32v-128h-32v-96h32v-128h-32v-96h32v-128h-32v-96h32v-128h-32v-32h96v896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ascend",
						"climb",
						"descend"
					],
					"grid": 32
				},
				{
					"id": 295,
					"width": 1024,
					"paths": [
						"M454.304 67.616c-202.432 25.28-364.832 190.368-387.424 393.12-12.384 111.040 16.064 214.912 71.936 298.944l-65.888 148.224c-5.376 12.096-2.752 26.272 6.624 35.616l0.928 0.928c9.376 9.376 23.52 12 35.616 6.624l148.224-65.888c84.032 55.904 187.904 84.32 298.944 71.936 202.752-22.592 367.84-185.024 393.12-387.456 36.544-292.608-209.44-538.592-502.080-502.048zM512 925.536c-81.632 0-160.672-23.872-228.608-69.056l-15.776-10.496-161.344 71.712 71.712-161.344-10.496-15.776c-45.152-67.904-69.024-146.944-69.024-228.576 0-228.032 185.504-413.536 413.536-413.536s413.536 185.504 413.536 413.536-185.504 413.536-413.536 413.536zM480 688v0c0-8.864 7.168-16 16-16v0c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16v0c-8.832 0-16-7.168-16-16zM480 624v-83.296c0-7.040 5.696-12.736 12.736-12.736h0.032c60.224 0 112.128-46.176 115.104-106.336 3.168-64.288-48.256-117.632-111.872-117.632-51.968 0-95.808 35.616-108.384 83.712-1.856 7.168-8.128 12.288-15.52 12.288v0c-10.496 0-18.144-9.952-15.52-20.096 16.64-64.16 76.48-111.072 146.464-107.712 67.808 3.264 125.312 55.2 135.328 122.336 11.456 76.832-39.904 147.584-113.6 162.592l-12.768 2.592v64.288c0 8.832-7.168 16-16 16v0c-8.832 0-16-7.168-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ask",
						"question",
						"wonder"
					],
					"grid": 32
				},
				{
					"id": 296,
					"width": 1024,
					"paths": [
						"M454.304 67.616c-202.432 25.28-364.832 190.368-387.424 393.12-12.384 111.040 16.064 214.912 71.936 298.944l-65.888 148.224c-5.376 12.096-2.752 26.272 6.624 35.616l0.928 0.928c9.376 9.376 23.52 12 35.616 6.624l148.224-65.888c84.032 55.904 187.904 84.32 298.944 71.936 202.752-22.592 367.84-185.024 393.12-387.456 36.544-292.608-209.44-538.592-502.080-502.048zM480 688v0c0-8.864 7.168-16 16-16v0c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16v0c-8.832 0-16-7.168-16-16zM480 624v-83.296c0-7.040 5.696-12.736 12.736-12.736h0.032c60.224 0 112.128-46.176 115.104-106.336 3.168-64.288-48.256-117.632-111.872-117.632-51.968 0-95.808 35.616-108.384 83.712-1.856 7.168-8.128 12.288-15.52 12.288v0c-10.496 0-18.144-9.952-15.52-20.096 16.64-64.16 76.48-111.072 146.464-107.712 67.808 3.264 125.312 55.2 135.328 122.336 11.456 76.832-39.904 147.584-113.6 162.592l-12.768 2.592v64.288c0 8.832-7.168 16-16 16v0c-8.832 0-16-7.168-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ask",
						"question",
						"wonder"
					],
					"grid": 32
				},
				{
					"id": 958,
					"width": 1024,
					"paths": [
						"M992 64h-960c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h352l105.376 105.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l105.376-105.376h352c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM960 768h-346.496l-101.504 101.504-101.504-101.504h-346.496v-640h896v640zM480 672h96v-96h-96v96zM512 608h32v32h-32v-32zM480 352c0-35.296 28.704-64 64-64s64 28.704 64 64-28.704 64-64 64h-64v128h96v-35.232c73.024-14.816 128-79.36 128-156.768 0-88.352-71.648-160-160-160s-160 71.648-160 160v32h96v-32zM416 352c0-70.592 57.408-128 128-128s128 57.408 128 128-57.408 128-128 128v32h-32v-64h32c53.024 0 96-42.976 96-96s-42.976-96-96-96-96 42.976-96 96h-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ask",
						"question",
						"wonder"
					],
					"grid": 32
				},
				{
					"id": 297,
					"width": 1024,
					"paths": [
						"M384 448c-123.712 0-224 100.288-224 224s100.288 224 224 224c123.712 0 224-100.288 224-224s-100.288-224-224-224zM384 864c-105.856 0-192-86.144-192-192s86.144-192 192-192 192 86.144 192 192-86.144 192-192 192zM832 768c-3.584 0-7.008 0.672-10.496 1.056l-18.592-65.056h29.088c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-56.512l-36.576-128h29.088c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-384c-19.264 0-38.048 1.984-56.256 5.568l-59.68-268.512c-3.264-14.624-16.224-25.056-31.232-25.056h-108.832c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h57.504l51.68 232.544c-97.984 58.272-158.72 172.672-136.672 299.136 20.96 120.352 119.968 215.904 240.896 233.248 166.88 23.904 311.296-95.36 328.704-252.928h99.52l21.056 73.664c-36.64 17.568-60.64 57.376-53.44 102.176 6.304 39.2 38.112 71.68 77.216 78.592 60.768 10.752 113.536-35.68 113.536-94.432 0-53.024-42.976-96-96-96zM768 416v32h-203.168c-15.2-12.288-31.744-22.976-49.28-32h252.448zM211.168 160h-83.168v-32h108.832l59.84 269.28-31.2 6.944-54.304-244.224zM384 928c-141.152 0-256-114.848-256-256s114.848-256 256-256c141.152 0 256 114.848 256 256s-114.848 256-256 256zM664.608 608c-11.008-48.512-34.304-92.224-66.4-128h107.424l36.576 128h-77.6zM672 672c0-10.816-0.704-21.472-1.888-32h161.888v32h-160zM824.608 927.584c-28.064-3.168-51.36-25.376-55.776-53.28-4.384-27.712 9.28-52.48 30.848-65.248l12.544 43.936c2.432 8.512 11.296 13.44 19.776 11.008s13.408-11.264 10.976-19.776l-12.576-44.064c0.064-0.064 0.064-0.096 0.096-0.16 35.968-0.8 65.504 28.224 65.504 64 0 37.728-32.8 67.936-71.392 63.584zM416 672c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"assist",
						"move",
						"ride",
						"roll",
						"walk"
					],
					"grid": 32
				},
				{
					"id": 298,
					"width": 1024,
					"paths": [
						"M96 160v-32c0-17.664 14.336-32 32-32h108.832c15.008 0 27.968 10.432 31.232 25.056l52.768 237.536c-32.32 6.56-62.848 17.984-90.88 33.504l-44.448-200.096h-57.504c-17.664 0-32-14.336-32-32zM928 864c0 53.024-42.976 96-96 96s-96-42.976-96-96c0-38.176 22.432-70.848 54.72-86.336l-21.056-73.664h-67.264c1.024-10.528 1.6-21.184 1.6-32 0-22.016-2.976-43.232-7.264-64h45.472l-36.576-128h-67.008c-30.624-40.352-70.016-73.76-116.096-96h245.472c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32h-29.088l36.576 128h56.512c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32h-29.088l18.592 65.056c3.488-0.384 6.912-1.056 10.496-1.056 53.024 0 96 42.976 96 96zM864 864c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM384 384c-159.072 0-288 128.928-288 288s128.928 288 288 288 288-128.928 288-288c0-159.072-128.928-288-288-288zM384 896c-123.712 0-224-100.288-224-224s100.288-224 224-224 224 100.288 224 224c0 123.712-100.288 224-224 224zM384 480c-106.048 0-192 85.952-192 192s85.952 192 192 192 192-85.952 192-192-85.952-192-192-192zM384 704c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"assist",
						"move",
						"ride",
						"roll",
						"walk"
					],
					"grid": 32
				},
				{
					"id": 1795,
					"width": 1026.8579406738281,
					"paths": [
						"M73.143 987.429q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714 10.857-25.714 25.714-10.857 25.714 10.857 10.857 25.714zM182.857 877.714q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714 10.857-25.714 25.714-10.857 25.714 10.857 10.857 25.714zM208.571 669.143l146.286 146.286-51.429 51.429-146.286-146.286zM402.286 658.286q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714 10.857-25.714 25.714-10.857 25.714 10.857 10.857 25.714zM806.286 475.429q0 33.714-6.571 62t-21.429 53.429-25.143 38.571-30.286 36.857q-17.714 20-26 30.857t-19.143 28.571-15.143 36.571-4.286 42.286q0 90.857-64.286 155.143t-155.143 64.286q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857q60.571 0 103.429-42.857t42.857-103.429q0-32.571 6.571-60.286t21.143-52 24.857-38 29.714-36q22.857-26.286 34-41.143t21.429-42.571 10.286-59.143q0-105.714-75.143-180.857t-180.857-75.143-180.857 75.143-75.143 180.857q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714q0-66.857 26-127.714t70.286-105.143 105.143-70.286 127.714-26 127.714 26 105.143 70.286 70.286 105.143 26 127.714zM512 548.571q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714 10.857-25.714 25.714-10.857 25.714 10.857 10.857 25.714zM676.571 475.429q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714q0-53.143-37.429-90.571t-90.571-37.429q-52.571 0-90.286 37.429t-37.714 90.571q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714q0-83.429 58.857-142.286t142.286-58.857 142.286 58.857 58.857 142.286zM901.714 310.286q5.714 14.286-0.571 28t-20.571 19.429q-5.143 2.286-13.143 2.286-10.857 0-20.286-6.286t-13.429-17.143q-38.857-101.714-128-168.571-12-9.143-14.286-24t6.857-26.857q9.714-12 24.571-14.286t26.857 6.857q104.571 78.286 152 200.571zM1021.714 264q5.143 14.286-0.857 28t-20.286 19.429q-6.286 2.286-13.143 2.286-25.143 0-34.286-23.429-52.571-136-169.714-224.571-12.571-9.143-14.571-24t7.143-26.857q9.143-12.571 24-14.571t26.857 7.143q134.286 100 194.857 256.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"assistive-listening-systems"
					],
					"defaultCode": 62114,
					"grid": 14
				},
				{
					"id": 1278,
					"width": 950.8569488525391,
					"paths": [
						"M846.857 600q26.286 14.857 34 44.286t-7.143 55.714l-36.571 62.857q-14.857 26.286-44.286 34t-55.714-7.143l-152-87.429v175.429q0 29.714-21.714 51.429t-51.429 21.714h-73.143q-29.714 0-51.429-21.714t-21.714-51.429v-175.429l-152 87.429q-26.286 14.857-55.714 7.143t-44.286-34l-36.571-62.857q-14.857-26.286-7.143-55.714t34-44.286l152-88-152-88q-26.286-14.857-34-44.286t7.143-55.714l36.571-62.857q14.857-26.286 44.286-34t55.714 7.143l152 87.429v-175.429q0-29.714 21.714-51.429t51.429-21.714h73.143q29.714 0 51.429 21.714t21.714 51.429v175.429l152-87.429q26.286-14.857 55.714-7.143t44.286 34l36.571 62.857q14.857 26.286 7.143 55.714t-34 44.286l-152 88z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"asterisk"
					],
					"defaultCode": 61545,
					"grid": 14
				},
				{
					"id": 1640,
					"width": 877.7139587402344,
					"paths": [
						"M555.429 442.857q0-61.714-30.571-96.571t-84.286-34.857q-36 0-70.857 17.429t-62.857 48.286-45.429 78.286-17.429 102.857q0 64 30.571 98.857t86 34.857q54.857 0 100.571-38t70-94.857 24.286-116.286zM877.714 512q0 63.429-21.143 112.571t-56.286 77.143-75.143 42.571-82.857 15.714q-3.429 0-8.857 0.286t-9.429 0.286q-54.286 0-81.143-30.286-16-18.857-18.857-47.429-29.714 37.714-75.143 62.857t-99.143 25.143q-92 0-142.571-54.571t-50.571-154q0-89.714 37.714-165.714t102.286-120.286 140.571-44.286q49.714 0 88.571 20.286t60.571 56.857l1.143-10.857 6.286-32q0.571-3.429 3.143-6.857t5.429-3.429h67.429q2.857 0 7.429 6.286 2.857 2.857 1.714 9.143l-68.571 350.857q-2.857 13.714-2.857 27.429 0 22.286 7.143 29.714t25.429 7.429q16-0.571 32.571-3.143t41.714-13.714 44-28.571 32.571-51.143 13.714-78.286q0-166.857-99.429-266.286t-266.286-99.429q-74.286 0-142 29.143t-116.571 78-78 116.571-29.143 142 29.143 142 78 116.571 116.571 78 142 29.143q130.286 0 231.429-82.286 6.286-5.143 13.714-4.571t12 6.857l23.429 28q4.571 6.857 4 13.714-1.143 7.429-6.857 12.571-58.286 47.429-130 73.143t-147.714 25.714q-89.143 0-170.286-34.857t-140-93.714-93.714-140-34.857-170.286 34.857-170.286 93.714-140 140-93.714 170.286-34.857q196.571 0 317.714 121.143t121.143 317.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"at"
					],
					"defaultCode": 61946,
					"grid": 14
				},
				{
					"id": 2116,
					"paths": [
						"M874.040 149.96c-96.706-96.702-225.28-149.96-362.040-149.96s-265.334 53.258-362.040 149.96c-96.702 96.706-149.96 225.28-149.96 362.040s53.258 265.334 149.96 362.040c96.706 96.702 225.28 149.96 362.040 149.96 76.76 0 150.6-16.59 219.466-49.306 31.928-15.168 45.512-53.346 30.346-85.272s-53.346-45.508-85.272-30.346c-51.572 24.502-106.93 36.924-164.54 36.924-211.738 0-384-172.262-384-384s172.262-384 384-384 384 172.262 384 384v64c0 35.29-28.71 64-64 64s-64-28.71-64-64v-256c0-35.346-28.654-64-64-64-25.982 0-48.332 15.494-58.36 37.736-38.926-23.92-84.696-37.736-133.64-37.736-141.16 0-256 114.84-256 256 0 141.158 114.84 256 256 256 66.908 0 127.892-25.812 173.548-67.99 35.246 41.56 87.818 67.99 146.452 67.99 105.87 0 192-86.13 192-192v-64c0-136.76-53.258-265.334-149.96-362.040zM512 640c-70.58 0-128-57.42-128-128s57.42-128 128-128c70.58 0 128 57.42 128 128s-57.42 128-128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"at-sign",
						"email"
					],
					"defaultCode": 59951,
					"grid": 16
				},
				{
					"id": 2560,
					"paths": [
						"M831.924 206.704v0 0zM834.050 512c104.386-99.81 155.082-197.58 121.354-256-19.26-33.356-63.36-49.296-123.48-49.296v48c42.144 0 72.766 9.458 81.912 25.296 7.218 12.504 3.2 31.73-1.446 45.658-8.906 26.71-28.286 58.664-56.042 92.404-16.848 20.478-36.27 41.122-57.874 61.642-29.764-25.698-62.876-51.258-98.796-76.058-3.514-43.48-9.090-84.916-16.458-123.518 56.19-16.666 107.186-25.418 148.682-25.422l0.022-48c-0.008 0-0.018 0-0.026 0-45.174 0.004-99.396 9.032-158.872 26.404-34.242-140.318-93.568-233.11-161.026-233.11s-126.784 92.792-161.028 233.102c-59.474-17.372-113.698-26.398-158.872-26.398-60.12 0-104.248 15.942-123.506 49.296-33.73 58.42 16.966 156.19 121.352 256-104.386 99.81-155.082 197.58-121.352 256 19.26 33.36 63.37 49.294 123.506 49.294 45.172 0 99.396-9.028 158.872-26.4 34.244 140.314 93.568 233.106 161.028 233.106 67.458 0 126.784-92.792 161.028-233.102 59.474 17.374 113.698 26.398 158.872 26.398 60.12 0 104.248-15.942 123.506-49.296 33.726-58.418-16.968-156.19-121.356-256zM762.542 512c-18.618 15.876-38.452 31.584-59.356 46.988 0.528-15.476 0.814-31.142 0.814-46.988 0-15.844-0.286-31.51-0.812-46.988 20.904 15.404 40.738 31.112 59.354 46.988zM637.292 728.866c-23.054-8.194-46.562-17.518-70.268-27.866 13.626-7.262 27.294-14.824 40.974-22.722 13.722-7.922 27.146-16.002 40.288-24.198-2.884 25.766-6.564 50.76-10.994 74.786zM584 636.708c-23.78 13.728-47.876 26.63-72 38.614-24.124-11.982-48.22-24.884-72-38.614-23.976-13.844-47.192-28.228-69.498-43.014-1.65-26.71-2.502-54.008-2.502-81.694s0.852-54.984 2.502-81.694c22.306-14.786 45.522-29.17 69.498-43.014 23.78-13.728 47.876-26.63 72-38.614 24.124 11.982 48.22 24.884 72 38.614 23.976 13.842 47.192 28.23 69.498 43.014 1.65 26.71 2.502 54.008 2.502 81.694s-0.852 54.984-2.502 81.696c-22.306 14.784-45.522 29.17-69.498 43.012zM375.712 654.080c13.14 8.196 26.564 16.276 40.288 24.198 13.68 7.898 27.346 15.46 40.974 22.722-23.704 10.348-47.214 19.67-70.266 27.864-4.43-24.026-8.112-49.020-10.996-74.784zM320.812 558.99c-20.904-15.406-40.74-31.116-59.358-46.99 18.618-15.876 38.454-31.584 59.358-46.99-0.528 15.48-0.812 31.144-0.812 46.99s0.284 31.512 0.812 46.99zM386.708 295.136c23.052 8.194 46.562 17.518 70.266 27.864-13.626 7.262-27.294 14.824-40.974 22.722-13.722 7.922-27.146 16.002-40.288 24.198 2.884-25.764 6.566-50.758 10.996-74.784zM608 345.722c-13.68-7.898-27.346-15.46-40.972-22.722 23.704-10.346 47.212-19.668 70.266-27.862 4.43 24.024 8.11 49.016 10.994 74.782-13.142-8.196-26.566-16.274-40.288-24.198zM421.18 166.816c15.34-40.908 33.322-73.668 52.002-94.736 9.738-10.986 24.378-24.080 38.818-24.080s29.078 13.094 38.818 24.080c18.68 21.068 36.66 53.828 52.002 94.736 9.312 24.834 17.478 51.978 24.45 80.952-37.138 12.926-75.832 28.824-115.268 47.532-39.438-18.71-78.132-34.608-115.27-47.536 6.97-28.972 15.136-56.116 24.448-80.948zM167.65 418.062c-27.756-33.74-47.136-65.692-56.042-92.404-4.644-13.926-8.664-33.154-1.444-45.658 9.144-15.838 39.776-25.294 81.938-25.296h0.004c41.492 0 92.486 8.752 148.674 25.418-7.368 38.604-12.942 80.040-16.456 123.522-35.92 24.798-69.036 50.36-98.8 76.058-21.604-20.52-41.026-41.162-57.874-61.64zM192.1 769.294c-42.162 0-72.792-9.456-81.936-25.294-7.22-12.504-3.2-31.73 1.444-45.658 8.906-26.71 28.286-58.662 56.042-92.402 16.848-20.478 36.27-41.122 57.874-61.642 29.762 25.7 62.878 51.26 98.798 76.058 3.514 43.482 9.088 84.916 16.456 123.522-56.19 16.664-107.184 25.416-148.678 25.416zM602.82 857.184c-15.342 40.91-33.322 73.668-52.002 94.738-9.74 10.984-24.378 24.078-38.818 24.078s-29.080-13.094-38.818-24.078c-18.68-21.070-36.662-53.828-52.002-94.736-9.312-24.834-17.478-51.978-24.45-80.952 37.138-12.928 75.832-28.824 115.268-47.534 39.44 18.71 78.132 34.61 115.27 47.536-6.972 28.972-15.136 56.116-24.448 80.948zM912.39 698.344c4.644 13.926 8.664 33.152 1.446 45.656-9.146 15.84-39.778 25.296-81.938 25.296-41.496 0-92.49-8.752-148.678-25.418 7.368-38.606 12.944-80.042 16.458-123.524 35.92-24.798 69.034-50.36 98.796-76.056 21.604 20.52 41.026 41.162 57.874 61.64 27.758 33.742 47.136 65.694 56.042 92.406z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"atom",
						"science"
					],
					"defaultCode": 60395,
					"grid": 16
				},
				{
					"id": 2561,
					"paths": [
						"M831.924 206.704v0 0zM834.050 512c104.384-99.81 155.082-197.58 121.354-256-19.26-33.356-63.36-49.296-123.48-49.296v48c42.144 0 72.766 9.458 81.912 25.296 7.218 12.504 3.2 31.73-1.446 45.658-8.906 26.71-28.288 58.664-56.042 92.404-16.848 20.478-36.27 41.122-57.874 61.642-29.764-25.698-62.876-51.258-98.796-76.058-3.514-43.48-9.090-84.916-16.458-123.518 56.19-16.666 107.186-25.418 148.682-25.422l0.022-48c-0.008 0-0.018 0-0.026 0-45.174 0.004-99.396 9.032-158.874 26.404-34.24-140.318-93.566-233.11-161.024-233.11s-126.784 92.792-161.028 233.102c-59.474-17.372-113.698-26.398-158.872-26.398-60.12 0-104.248 15.942-123.506 49.296-33.73 58.42 16.966 156.19 121.352 256-104.386 99.808-155.082 197.58-121.352 256 19.26 33.36 63.37 49.294 123.506 49.294 45.172 0 99.396-9.030 158.872-26.4 34.244 140.314 93.568 233.106 161.028 233.106 67.458 0 126.784-92.792 161.028-233.102 59.474 17.374 113.7 26.398 158.874 26.398 60.12 0 104.248-15.944 123.506-49.296 33.724-58.418-16.97-156.192-121.358-256zM762.542 512c-18.62 15.876-38.454 31.584-59.358 46.988 0.53-15.476 0.816-31.142 0.816-46.988 0-15.844-0.286-31.51-0.812-46.988 20.904 15.404 40.738 31.112 59.354 46.988zM637.292 728.868c-23.054-8.196-46.562-17.52-70.27-27.868 13.626-7.262 27.294-14.824 40.974-22.722 13.722-7.922 27.146-16 40.288-24.198-2.882 25.766-6.562 50.76-10.992 74.788zM584 636.708c-23.782 13.728-47.876 26.63-72 38.616-24.124-11.982-48.22-24.884-72-38.616-23.976-13.844-47.192-28.226-69.498-43.012-1.65-26.712-2.502-54.010-2.502-81.696s0.852-54.984 2.502-81.694c22.306-14.786 45.522-29.17 69.498-43.014 23.78-13.728 47.876-26.63 72-38.614 24.124 11.982 48.218 24.884 72 38.614 23.976 13.842 47.192 28.23 69.498 43.014 1.65 26.71 2.502 54.008 2.502 81.694s-0.852 54.984-2.502 81.696c-22.306 14.784-45.522 29.172-69.498 43.012zM375.712 654.080c13.14 8.198 26.564 16.276 40.288 24.198 13.68 7.898 27.346 15.46 40.974 22.722-23.704 10.348-47.214 19.67-70.266 27.864-4.43-24.026-8.112-49.020-10.996-74.784zM320.812 558.99c-20.904-15.406-40.74-31.116-59.358-46.99 18.618-15.876 38.454-31.584 59.358-46.99-0.528 15.48-0.812 31.144-0.812 46.99s0.284 31.512 0.812 46.99zM386.708 295.136c23.052 8.194 46.562 17.518 70.266 27.864-13.626 7.262-27.294 14.824-40.974 22.722-13.722 7.922-27.146 16.002-40.288 24.198 2.884-25.764 6.566-50.758 10.996-74.784zM608 345.722c-13.68-7.898-27.346-15.46-40.972-22.722 23.706-10.346 47.212-19.668 70.268-27.862 4.43 24.024 8.11 49.016 10.992 74.782-13.142-8.196-26.566-16.274-40.288-24.198zM421.18 166.816c15.34-40.908 33.322-73.668 52.002-94.736 9.738-10.986 24.378-24.080 38.818-24.080 14.442 0 29.078 13.094 38.818 24.080 18.68 21.068 36.658 53.828 52.002 94.736 9.312 24.834 17.478 51.978 24.45 80.952-37.136 12.926-75.832 28.824-115.268 47.532-39.438-18.71-78.132-34.608-115.27-47.536 6.97-28.972 15.136-56.116 24.448-80.948zM167.65 418.062c-27.756-33.74-47.136-65.692-56.042-92.404-4.644-13.926-8.664-33.154-1.444-45.658 9.144-15.838 39.776-25.294 81.938-25.296h0.004c41.492 0 92.486 8.752 148.674 25.418-7.368 38.604-12.942 80.040-16.456 123.522-35.92 24.798-69.036 50.36-98.8 76.058-21.604-20.52-41.026-41.162-57.874-61.64zM192.1 769.292c-42.162 0-72.792-9.456-81.936-25.292-7.22-12.504-3.2-31.73 1.444-45.658 8.906-26.708 28.286-58.662 56.042-92.4 16.848-20.48 36.27-41.124 57.874-61.644 29.762 25.702 62.878 51.262 98.798 76.058 3.514 43.482 9.088 84.916 16.456 123.524-56.19 16.662-107.184 25.412-148.678 25.412zM602.82 857.184c-15.342 40.91-33.322 73.668-52.002 94.738-9.74 10.984-24.376 24.078-38.818 24.078-14.44 0-29.080-13.094-38.818-24.078-18.68-21.070-36.662-53.828-52.002-94.736-9.312-24.834-17.478-51.978-24.45-80.952 37.138-12.93 75.832-28.824 115.268-47.536 39.44 18.71 78.13 34.61 115.27 47.538-6.972 28.972-15.136 56.116-24.448 80.948zM912.39 698.344c4.642 13.926 8.664 33.152 1.446 45.656-9.146 15.84-39.778 25.296-81.938 25.296-41.496 0-92.49-8.754-148.678-25.418 7.368-38.606 12.944-80.042 16.458-123.524 35.92-24.8 69.036-50.362 98.796-76.058 21.604 20.522 41.026 41.164 57.874 61.64 27.758 33.744 47.136 65.696 56.042 92.408zM432 512c0-44.183 35.817-80 80-80s80 35.817 80 80c0 44.183-35.817 80-80 80s-80-35.817-80-80z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"atom",
						"science"
					],
					"defaultCode": 60396,
					"grid": 16
				},
				{
					"id": 2753,
					"paths": [
						"M665.832 327.048l-64.952-64.922-324.81 324.742c-53.814 53.792-53.814 141.048 0 194.844 53.804 53.792 141.060 53.792 194.874 0l389.772-389.708c89.714-89.662 89.714-235.062 0-324.726-89.666-89.704-235.112-89.704-324.782 0l-409.23 409.178c-0.29 0.304-0.612 0.576-0.876 0.846-125.102 125.096-125.102 327.856 0 452.906 125.054 125.056 327.868 125.056 452.988 0 0.274-0.274 0.516-0.568 0.82-0.876l0.032 0.034 279.332-279.292-64.986-64.92-279.33 279.262c-0.296 0.268-0.564 0.57-0.846 0.844-89.074 89.058-233.98 89.058-323.076 0-89.062-89.042-89.062-233.922 0-322.978 0.304-0.304 0.604-0.582 0.888-0.846l-0.046-0.060 409.28-409.166c53.712-53.738 141.144-53.738 194.886 0 53.712 53.734 53.712 141.148 0 194.84l-389.772 389.7c-17.936 17.922-47.054 17.922-64.972 0-17.894-17.886-17.894-47.032 0-64.92l324.806-324.782z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"attachment",
						"paperclip"
					],
					"defaultCode": 60588,
					"grid": 16
				},
				{
					"id": 2754,
					"paths": [
						"M832 256h-576c-141.384 0-256 114.616-256 256s114.616 256 256 256h576v-64h-576c-106.040 0-192-85.96-192-192s85.96-192 192-192h576c70.694 0 128 57.308 128 128 0 70.694-57.306 128-128 128h-448c-35.346 0-64-28.654-64-64s28.654-64 64-64h448v-64h-448c-70.692 0-128 57.308-128 128 0 70.694 57.308 128 128 128h448c106.040 0 192-85.96 192-192s-85.96-192-192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"attachment",
						"paperclip"
					],
					"defaultCode": 60589,
					"grid": 16
				},
				{
					"id": 299,
					"width": 1024,
					"paths": [
						"M504.8 64.064c-211.392 3.872-376.8 185.248-376.8 396.672v403.264c0 53.024 42.976 96 96 96h64c53.024 0 96-42.976 96-96v-410.496c0-66.848 48.864-126.56 115.424-132.896 76.352-7.296 140.576 52.544 140.576 127.392v416c0 53.024 42.976 96 96 96h64c53.024 0 96-42.976 96-96v-416c0-214.464-175.808-387.872-391.2-383.936zM288 928h-64c-35.36 0-64-28.64-64-64v-64h192v64c0 35.36-28.64 64-64 64zM800 928h-64c-35.36 0-64-28.64-64-64v-64h192v64c0 35.36-28.64 64-64 64zM672 768v-320c0-88.224-71.776-160-160-160s-160 71.776-160 160v320h-192v-320c0-194.080 157.92-352 352-352s352 157.92 352 352v320h-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"attract",
						"magnetize"
					],
					"grid": 32
				},
				{
					"id": 300,
					"width": 1024,
					"paths": [
						"M128 768v-307.264c0-211.424 165.408-392.8 376.8-396.672 215.392-3.936 391.2 169.472 391.2 383.936v320h-256v-320c0-74.848-64.224-134.688-140.576-127.392-66.56 6.336-115.424 66.048-115.424 132.896v314.496h-256zM640 800v64c0 53.024 42.976 96 96 96h64c53.024 0 96-42.976 96-96v-64h-256zM128 800v64c0 53.024 42.976 96 96 96h64c53.024 0 96-42.976 96-96v-64h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"attract",
						"magnetize"
					],
					"grid": 32
				},
				{
					"id": 959,
					"width": 1024,
					"paths": [
						"M1014.72 471.68l-359.36-359.36c-72.64-72.32-168.96-112.32-271.68-112.32-102.4 0-198.72 40-271.36 112.32-149.76 149.76-149.76 393.6 0 543.36l359.36 359.040c6.080 6.080 14.4 9.28 22.4 9.28 8.32 0 16.64-3.2 22.72-9.28l181.12-181.12c6.080-6.080 9.28-14.080 9.28-22.72 0-8.32-3.2-16.64-9.28-22.4l-359.36-359.36c-12.16-11.84-18.88-28.16-18.88-45.12s6.72-33.28 18.88-45.12c24.32-24.32 66.24-24.32 90.56 0l359.36 359.040c11.84 11.84 32.96 11.84 45.12 0l181.12-181.12c12.48-12.48 12.48-32.64 0-45.12zM448 900.48l-39.040-38.72 39.040-39.040v77.76zM512 928.96l-17.92 17.92-14.080-14.4v-141.76l32-32v170.24zM608 789.12l22.080 21.76-22.080 22.080v-43.84zM544 726.72l0.64-0.96 31.36 31.36v107.84l-32 32v-170.24zM768 586.88l-42.24-41.92 42.24-42.24v84.16zM832 608.96l-21.12 21.12-10.88-11.2v-148.16l32-32v170.24zM703.040 522.24l-228.8-228.8c-48.32-48.32-132.48-48.32-180.8 0-24.32 24.32-37.76 56.32-37.76 90.56s13.44 66.24 37.76 90.56l228.8 228.8-136 135.68-228.8-228.8c-124.8-124.8-124.8-327.68 0-452.48 60.48-60.48 140.8-93.76 226.24-93.76 85.76 0 166.080 33.28 226.56 93.76l228.8 228.8-136 135.68zM896 544.96l-32 32v-165.44l32 32v101.44zM928 512.96v-37.44l18.88 18.56-18.88 18.88z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"attract",
						"magnetize"
					],
					"grid": 32
				},
				{
					"id": 1792,
					"width": 1313.1390075683594,
					"paths": [
						"M288 568h97.714l-0.571-151.429zM874.286 511.429q0-49.714-28.857-80t-83.714-30.286h-30.857v221.714h29.714q52 0 82.857-32.571t30.857-78.857zM546.286 296l0.571 432q0 8-5.429 13.714t-13.429 5.714h-123.429q-8 0-13.429-5.714t-5.429-13.714v-35.429h-166.286l-31.429 46.286q-5.714 8.571-16 8.571h-152.571q-12 0-17.429-10.286t2-20l317.714-432.571q5.143-8 15.429-8h189.714q8 0 13.714 5.714t5.714 13.714zM1018.857 511.429q0 110.286-71.714 173.143t-185.429 62.857h-154.286q-8 0-13.714-5.714t-5.714-13.714v-432q0-8 5.714-13.714t13.714-5.714h153.143q114.286 0 186.286 62.286t72 172.571zM1108 512q0 6.286-0.286 16.571t-4.571 40.857-12.286 58.286-25.429 61.714-42 58.571h-29.143q21.714-25.714 38-59.714t23.714-64 12-56 5.143-41.429l0.571-15.429q0-4.571-0.286-12.857t-4.286-34.286-11.429-52.286-23.429-63.714-37.714-71.143h24.571q23.429 26.857 41.143 61.143t26 63.714 13.143 54.857 6 40.286zM1213.143 512q0 6.286-0.286 16.571t-4.571 40.857-12.286 58.286-25.714 61.714-42.286 58.571h-29.143q21.714-25.714 38-59.714t23.714-64 12-56 5.143-41.429l0.571-15.429q0-4.571-0.286-12.857t-4.286-34.286-11.143-52.286-23.143-63.714-37.714-71.143h24.571q23.429 26.857 41.143 61.143t26 63.714 13.143 54.857 6 40.286zM1316.571 512q0 6.286-0.286 16.571t-4.571 40.857-12.286 58.286-25.429 61.714-42 58.571h-29.143q21.714-25.714 37.714-59.714t23.429-64 12-56 5.143-41.429l0.571-15.429q0-4.571-0.286-12.857t-4.286-34.286-11.143-52.286-23.143-63.714-37.714-71.143h24.571q23.429 26.857 41.143 61.143t26 63.714 13.143 54.857 5.429 40.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"audio-description"
					],
					"defaultCode": 62110,
					"grid": 14
				},
				{
					"id": 1579,
					"width": 1170.2891836166382,
					"paths": [
						"M274.286 621.714q0-37.714-26.857-64.571t-64.571-26.857-64.571 26.857-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571zM294.857 438.857h580.571l-50.857-204q-1.143-4.571-8-10t-12-5.429h-438.857q-5.143 0-12 5.429t-8 10zM1078.857 621.714q0-37.714-26.857-64.571t-64.571-26.857-64.571 26.857-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571zM1170.286 566.857v219.429q0 8-5.143 13.143t-13.143 5.143h-54.857v73.143q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714v-73.143h-585.143v73.143q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714v-73.143h-54.857q-8 0-13.143-5.143t-5.143-13.143v-219.429q0-53.143 37.429-90.571t90.571-37.429h16l60-239.429q13.143-53.714 59.429-90t102.286-36.286h438.857q56 0 102.286 36.286t59.429 90l60 239.429h16q53.143 0 90.571 37.429t37.429 90.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"automobile",
						"car"
					],
					"defaultCode": 61881,
					"grid": 14
				},
				{
					"id": 301,
					"width": 1024,
					"paths": [
						"M480 256c-141.376 0-256 114.624-256 256s114.624 256 256 256 256-114.624 256-256-114.624-256-256-256zM480 736c-123.52 0-224-100.48-224-224s100.48-224 224-224 224 100.48 224 224-100.48 224-224 224zM1001.44 601.376c12.512 12.512 12.512 32.768 0 45.248l-73.376 73.376c-6.24 6.24-16.384 6.24-22.624 0v0c-6.24-6.24-6.24-16.384 0-22.624l57.376-57.376h-66.816c-53.024 0-96-42.976-96-96v-32c0-183.712-155.584-331.744-341.92-319.264-169.888 11.392-298.080 160.288-298.080 330.56v20.704c0 53.024-42.976 96-96 96h-48c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h48c35.36 0 64-28.64 64-64v-32c0-196.608 161.184-355.552 358.592-351.936 193.792 3.552 345.408 169.92 345.408 363.744v16.512c0 39.2 28.64 67.68 64 67.68h66.816l-57.376-57.376c-6.24-6.24-6.24-16.384 0-22.624v0c6.24-6.24 16.384-6.24 22.624 0l73.376 73.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"avoid",
						"go",
						"route"
					],
					"grid": 32
				},
				{
					"id": 302,
					"width": 1024,
					"paths": [
						"M480 256c-141.376 0-256 114.624-256 256s114.624 256 256 256 256-114.624 256-256-114.624-256-256-256zM1001.44 601.376c12.512 12.512 12.512 32.768 0 45.248l-73.376 73.376c-6.24 6.24-16.384 6.24-22.624 0v0c-6.24-6.24-6.24-16.384 0-22.624l57.376-57.376h-66.816c-53.024 0-96-42.976-96-96v-32c0-183.712-155.584-331.744-341.92-319.264-169.888 11.392-298.080 160.288-298.080 330.56v20.704c0 53.024-42.976 96-96 96h-48c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h48c35.36 0 64-28.64 64-64v-32c0-196.608 161.184-355.552 358.592-351.936 193.792 3.552 345.408 169.92 345.408 363.744v16.512c0 39.2 28.64 67.68 64 67.68h66.816l-57.376-57.376c-6.24-6.24-6.24-16.384 0-22.624v0c6.24-6.24 16.384-6.24 22.624 0l73.376 73.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"avoid",
						"go",
						"route"
					],
					"grid": 32
				},
				{
					"id": 3160,
					"paths": [
						"M400 256h560v576h-560c-9.44 0-30.012-8.522-36.686-15.196l-272.804-272.804 272.804-272.804c6.674-6.674 27.246-15.196 36.686-15.196v0zM400 192v0c-26.4 0-63.274 15.274-81.942 33.942l-284.118 284.116c-18.668 18.668-18.668 49.214 0 67.882l284.12 284.12c18.666 18.666 55.54 33.94 81.94 33.94h576c26.4 0 48-21.6 48-48v-608c0-26.4-21.6-48-48-48h-576z",
						"M896 416l-96-96-128 128-128-128-96 96 128 128-128 128 96 96 128-128 128 128 96-96-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"backspace",
						"delete",
						"remove"
					],
					"defaultCode": 60995,
					"grid": 16
				},
				{
					"id": 3161,
					"paths": [
						"M976 192h-576c-26.4 0-63.274 15.274-81.942 33.942l-284.118 284.116c-18.668 18.668-18.668 49.214 0 67.882l284.12 284.12c18.666 18.666 55.54 33.94 81.94 33.94h576c26.4 0 48-21.6 48-48v-608c0-26.4-21.6-48-48-48zM896 672l-96 96-128-128-128 128-96-96 128-128-128-128 96-96 128 128 128-128 96 96-128 128 128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"backspace",
						"delete",
						"remove"
					],
					"defaultCode": 60996,
					"grid": 16
				},
				{
					"id": 2968,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM704 672l-224-160 224-160zM448 672l-224-160 224-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"backward",
						"player"
					],
					"defaultCode": 60803,
					"grid": 16
				},
				{
					"id": 2973,
					"paths": [
						"M576 160v320l320-320v704l-320-320v320l-352-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"backward",
						"player"
					],
					"defaultCode": 60808,
					"grid": 16
				},
				{
					"id": 1249,
					"width": 1020.5720672607422,
					"paths": [
						"M925.143 80.571q10.857-10.857 18.286-7.429t7.429 18.286v841.143q0 14.857-7.429 18.286t-18.286-7.429l-405.714-405.714q-4.571-5.143-7.429-10.857v405.714q0 14.857-7.429 18.286t-18.286-7.429l-405.714-405.714q-10.857-10.857-10.857-25.714t10.857-25.714l405.714-405.714q10.857-10.857 18.286-7.429t7.429 18.286v405.714q2.857-6.286 7.429-10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"backward"
					],
					"defaultCode": 61514,
					"grid": 14
				},
				{
					"id": 2859,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416z",
						"M384 416c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M352 320c53.020 0 96 42.98 96 96s-42.98 96-96 96-96-42.98-96-96 42.98-96 96-96zM352 256c-88.224 0-160 71.776-160 160s71.776 160 160 160 160-71.776 160-160-71.776-160-160-160v0z",
						"M704 416c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M672 320c53.020 0 96 42.98 96 96s-42.98 96-96 96-96-42.98-96-96 42.98-96 96-96zM672 256c-88.224 0-160 71.776-160 160s71.776 160 160 160 160-71.776 160-160-71.776-160-160-160v0z",
						"M384 704h256v64h-256v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"baffled",
						"emoticon",
						"smiley",
						"shocked",
						"face"
					],
					"defaultCode": 60694,
					"grid": 16
				},
				{
					"id": 2860,
					"paths": [
						"M384 416c0 17.674-14.326 32-32 32s-32-14.326-32-32 14.326-32 32-32 32 14.326 32 32z",
						"M704 416c0 17.674-14.326 32-32 32s-32-14.326-32-32 14.326-32 32-32 32 14.326 32 32z",
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM256 416c0-53.020 42.98-96 96-96s96 42.98 96 96-42.98 96-96 96-96-42.98-96-96zM640 768h-256v-64h256v64zM672 512c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"baffled",
						"emoticon",
						"smiley",
						"shocked",
						"face"
					],
					"defaultCode": 60695,
					"grid": 16
				},
				{
					"id": 2076,
					"paths": [
						"M704 192v-32c0-88.366-71.634-160-160-160-36.022 0-69.258 11.91-96 31.998-26.742-20.088-59.978-31.998-96-31.998-88.366 0-160 71.634-160 160v108.8l-128 19.2v672h128l64 64 640-96v-672l-192-64zM192 896h-64v-552.884l64-9.6v562.484zM544 64c52.936 0 96 43.066 96 96v41.6l-128 19.2v-60.8c0-29.062-7.788-56.29-21.332-79.78 15.266-10.236 33.612-16.22 53.332-16.22zM256 160c0-52.934 43.066-96 96-96 19.72 0 38.066 5.984 53.332 16.222-13.544 23.488-21.332 50.716-21.332 79.778v80l-128 19.2v-99.2zM832 872.884l-512 76.798v-542.566l512-76.8v542.568z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bag",
						"cart",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59911,
					"grid": 16
				},
				{
					"id": 2077,
					"paths": [
						"M704 192v-32c0-88.366-71.634-160-160-160-36.022 0-69.258 11.91-96 31.998-26.742-20.088-59.978-31.998-96-31.998-88.366 0-160 71.634-160 160v108.8l-128 19.2v672h128l64 64 640-96v-672l-192-64zM128 840v-16h64v16h-64zM192 856v16h-64v-16h64zM128 808v-16h64v16h-64zM128 776v-16h64v16h-64zM128 744v-16h64v16h-64zM128 712v-16h64v16h-64zM128 680v-16h64v16h-64zM128 648v-16h64v16h-64zM128 616v-16h64v16h-64zM128 584v-16h64v16h-64zM128 552v-16h64v16h-64zM128 520v-16h64v16h-64zM128 488v-16h64v16h-64zM128 456v-16h64v16h-64zM128 424v-16h64v16h-64zM128 392v-16h64v16h-64zM128 360v-16h64v16h-64zM128 896v-8h64v8h-64zM760 341.116l16-2.4v542.568l-16 2.398v-542.566zM744 886.084l-16 2.4v-542.568l16-2.4v542.568zM792 336.316l16-2.4v542.568l-16 2.4v-542.568zM712 348.316v542.568l-16 2.4v-542.568l16-2.4zM504 379.516l16-2.4v542.568l-16 2.4v-542.568zM488 924.484l-16 2.4v-542.568l16-2.4v542.568zM536 374.716l16-2.4v542.568l-16 2.398v-542.566zM568 369.916l16-2.4v542.568l-16 2.4v-542.568zM600 365.116l16-2.4v542.568l-16 2.398v-542.566zM632 360.316l16-2.4v542.568l-16 2.4v-542.568zM664 355.516l16-2.4v542.568l-16 2.4v-542.568zM544 64c52.936 0 96 43.066 96 96v41.6l-128 19.2v-60.8c0-29.062-7.788-56.29-21.332-79.78 15.266-10.236 33.612-16.22 53.332-16.22zM456 386.716v542.566l-16 2.4v-542.566l16-2.4zM360 401.116v542.568l-16 2.4v-542.568l16-2.4zM376 398.716l16-2.4v542.566l-16 2.4v-542.566zM408 393.916l16-2.4v542.568l-16 2.4v-542.568zM256 160c0-52.934 43.066-96 96-96 19.72 0 38.066 5.984 53.332 16.222-13.544 23.488-21.332 50.716-21.332 79.778v80l-128 19.2v-99.2zM320 407.116l8-1.2v542.568l-8 1.2v-542.568zM832 872.884l-8 1.2v-542.568l8-1.2v542.568z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bag",
						"cart",
						"ecommerce",
						"shopping",
						"dualtone"
					],
					"defaultCode": 59912,
					"grid": 16
				},
				{
					"id": 303,
					"width": 1024,
					"paths": [
						"M950.848 448l-15.072-52.736c-23.552-82.432-98.88-139.264-184.608-139.264h-478.336c-85.728 0-161.056 56.832-184.608 139.264l-15.072 52.736h-9.152c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32l47.296 212.832c9.76 43.904 48.704 75.168 93.728 75.168h613.984c44.992 0 83.968-31.264 93.728-75.168l47.264-212.832c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-9.152zM737.984 288l-19.104 47.776c-3.744 9.344-12.32 10.048-14.848 10.048s-11.136-0.736-14.848-10.048l-19.168-47.776h67.968zM545.984 288l-19.104 47.776c-3.744 9.344-12.32 10.048-14.848 10.048s-11.136-0.736-14.848-10.048l-19.168-47.776h67.968zM353.984 288l-19.104 47.776c-3.744 9.344-12.32 10.048-14.848 10.048s-11.136-0.736-14.848-10.048l-19.168-47.776h67.968zM118.976 404.032c17.6-61.632 70.88-106.112 133.248-114.336l23.168 57.952c7.328 18.336 24.832 30.176 44.576 30.176s37.248-11.84 44.576-30.176l23.872-59.648h55.136l23.84 59.648c7.328 18.336 24.832 30.176 44.576 30.176s37.248-11.84 44.576-30.176l23.872-59.648h55.136l23.84 59.648c7.328 18.336 24.832 30.176 44.576 30.176s37.248-11.84 44.576-30.176l23.168-57.952c62.4 8.224 115.648 52.704 133.248 114.336l12.608 43.968h-811.136l12.544-43.968zM818.976 800h-613.952c-29.984 0-55.968-20.832-62.464-50.112l-45.792-205.888h830.432l-45.76 205.888c-6.496 29.28-32.448 50.112-62.464 50.112zM960 512h-896v-32h896v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bake",
						"reheat",
						"heat",
						"warm"
					],
					"grid": 32
				},
				{
					"id": 304,
					"width": 1024,
					"paths": [
						"M270.304 256.224c0.864-0.032 1.664-0.224 2.528-0.224h96.96l-35.104 81.888c-3.872 8.992-12.224 9.696-14.688 9.696s-10.848-0.672-14.688-9.696l-35.008-81.664zM689.312 337.888c3.872 8.992 12.224 9.696 14.688 9.696s10.848-0.672 14.688-9.696l35.008-81.664c-0.864-0.032-1.664-0.224-2.528-0.224h-96.96l35.104 81.888zM512 347.552c2.464 0 10.848-0.672 14.688-9.696l35.104-81.856h-99.584l35.104 81.888c3.84 8.992 12.224 9.664 14.688 9.664zM64 544h896c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-9.152l-15.072-52.736c-20.192-70.656-78.528-122.208-148.768-135.584l-38.912 90.784c-7.68 17.952-24.608 29.088-44.096 29.088s-36.416-11.136-44.096-29.088l-40.512-94.464h-22.816l-40.48 94.464c-7.68 17.952-24.608 29.088-44.096 29.088s-36.416-11.136-44.096-29.088l-40.512-94.464h-22.816l-40.48 94.464c-7.68 17.952-24.608 29.088-44.096 29.088s-36.416-11.136-44.096-29.088l-38.912-90.784c-70.24 13.376-128.576 64.928-148.768 135.584l-15.072 52.736h-9.152c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32zM71.104 576l40.192 180.832c9.76 43.904 48.704 75.168 93.696 75.168h613.984c44.992 0 83.968-31.264 93.728-75.168l40.192-180.832h-881.792z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bake",
						"reheat",
						"heat",
						"warm"
					],
					"grid": 32
				},
				{
					"id": 960,
					"width": 1024,
					"paths": [
						"M928 0h-832c-17.664 0-32 14.336-32 32v960c0 17.664 14.336 32 32 32h832c17.664 0 32-14.336 32-32v-960c0-17.664-14.336-32-32-32zM896 64v160h-768v-160h768zM128 960v-704h768v704h-768zM640 352h-256v-32h256v32zM768 416h-512c-17.664 0-32 14.336-32 32v352c0 17.664 14.336 32 32 32h512c17.664 0 32-14.336 32-32v-352c0-17.664-14.336-32-32-32zM768 800h-512v-96h512v96zM768 672h-512v-224h512v224zM272 192c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM272 128c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16zM432 192c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM432 128c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16zM592 192c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM592 128c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16zM752 192c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM752 128c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bake",
						"reheat",
						"heat",
						"warm"
					],
					"grid": 32
				},
				{
					"id": 2554,
					"paths": [
						"M384 480v-32h-384v32c0 53.020 42.98 96 96 96h192c53.020 0 96-42.98 96-96z",
						"M640 480c0 53.020 42.98 96 96 96h192c53.020 0 96-42.98 96-96v-32h-384v32z",
						"M576 128h201.616l-133.588 240.458c-8.584 15.45-3.018 34.932 12.432 43.514 15.454 8.582 34.932 3.014 43.514-12.432l132.026-237.648 132.028 237.648c5.848 10.526 16.756 16.464 28.002 16.464 5.258 0 10.59-1.298 15.512-4.034 15.45-8.582 21.016-28.064 12.432-43.514l-160-288c-5.644-10.156-16.352-16.456-27.974-16.456h-256c0-35.346-28.654-64-64-64s-64 28.654-64 64h-256c-11.622 0-22.33 6.3-27.972 16.458l-160 288c-8.584 15.45-3.016 34.932 12.432 43.514 15.454 8.584 34.932 3.018 43.514-12.432l132.026-237.648 132.028 237.648c5.848 10.526 16.756 16.464 28.002 16.464 5.258 0 10.588-1.298 15.512-4.034 15.448-8.582 21.014-28.064 12.432-43.514l-133.59-240.456h201.616v768l-192 64v64h512v-64l-192-64v-768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"balance",
						"justice",
						"legal"
					],
					"defaultCode": 60389,
					"grid": 16
				},
				{
					"id": 1717,
					"width": 1243.4331817626953,
					"paths": [
						"M987.429 256l-219.429 402.286h438.857zM256 256l-219.429 402.286h438.857zM725.143 146.286q-8 22.857-26 40.857t-40.857 26v737.714h347.429q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-768q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h347.429v-737.714q-22.857-8-40.857-26t-26-40.857h-280.571q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h280.571q12-32.571 40-52.857t63.429-20.286 63.429 20.286 40 52.857h280.571q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-280.571zM621.714 155.429q18.857 0 32.286-13.429t13.429-32.286-13.429-32.286-32.286-13.429-32.286 13.429-13.429 32.286 13.429 32.286 32.286 13.429zM1243.429 658.286q0 41.714-26.571 74.857t-67.143 52-82.571 28.286-79.714 9.429-79.714-9.429-82.571-28.286-67.143-52-26.571-74.857q0-6.286 20-46.286t52.571-99.714 61.143-111.714 58.286-105.143 32-57.143q10.286-18.857 32-18.857t32 18.857q2.286 4 32 57.143t58.286 105.143 61.143 111.714 52.571 99.714 20 46.286zM512 658.286q0 41.714-26.571 74.857t-67.143 52-82.571 28.286-79.714 9.429-79.714-9.429-82.571-28.286-67.143-52-26.571-74.857q0-6.286 20-46.286t52.571-99.714 61.143-111.714 58.286-105.143 32-57.143q10.286-18.857 32-18.857t32 18.857q2.286 4 32 57.143t58.286 105.143 61.143 111.714 52.571 99.714 20 46.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"balance-scale"
					],
					"defaultCode": 62030,
					"grid": 14
				},
				{
					"id": 305,
					"width": 1024,
					"paths": [
						"M956.736 512h-14.528l-124.608-224.32c8.064-0.832 14.4-7.392 14.4-15.68 0-8.832-7.168-16-16-16h-288v-2.272c27.552-7.136 48-31.936 48-61.728 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 29.792 20.448 54.592 48 61.728v2.272h-288c-8.832 0-16 7.168-16 16 0 8.288 6.336 14.848 14.4 15.68l-124.608 224.32h-14.528c-19.584 0-35.456 17.632-31.712 36.864 17.184 88.384 95.008 155.136 188.448 155.136s171.264-66.752 188.48-155.136c3.712-19.232-12.128-36.864-31.744-36.864h-14.528l-124.416-224h236.608l-28.8 576h-113.6c-8.832 0-16 7.168-16 16s7.168 16 16 16h352c8.832 0 16-7.168 16-16s-7.168-16-16-16h-113.6l-28.8-576h236.608l-124.448 224h-14.528c-19.584 0-35.456 17.632-31.712 36.864 17.216 88.384 95.040 155.136 188.48 155.136s171.264-66.752 188.48-155.136c3.712-19.232-12.128-36.864-31.744-36.864zM380.704 544c-15.072 74.24-80.704 128-156.704 128-76.448 0-142.496-54.368-156.736-128h313.44zM329.6 512h-211.2l105.6-190.112 105.6 190.112zM480 192c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM481.632 864l28.8-576h3.136l28.8 576h-60.736zM800 321.888l105.6 190.112h-211.2l105.6-190.112zM800 672c-76.448 0-142.496-54.368-156.736-128h313.44c-15.072 74.24-80.704 128-156.704 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"balance",
						"measure",
						"weigh",
						"revenge",
						"judge"
					],
					"grid": 32
				},
				{
					"id": 306,
					"width": 1024,
					"paths": [
						"M956.736 512h-14.528l-124.608-224.32c8.064-0.832 14.4-7.392 14.4-15.68 0-8.832-7.168-16-16-16h-288v-2.272c27.552-7.136 48-31.936 48-61.728 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 29.792 20.448 54.592 48 61.728v2.272h-288c-8.832 0-16 7.168-16 16 0 8.288 6.336 14.848 14.4 15.68l-124.608 224.32h-14.528c-19.584 0-35.456 17.632-31.712 36.864 17.184 88.384 95.008 155.136 188.448 155.136s171.264-66.752 188.48-155.136c3.712-19.232-12.128-36.864-31.744-36.864h-14.528l-124.416-224h236.608l-28.8 576h-113.6c-8.832 0-16 7.168-16 16s7.168 16 16 16h352c8.832 0 16-7.168 16-16s-7.168-16-16-16h-113.6l-28.8-576h236.608l-124.448 224h-14.528c-19.584 0-35.456 17.632-31.712 36.864 17.216 88.384 95.040 155.136 188.48 155.136s171.264-66.752 188.48-155.136c3.712-19.232-12.128-36.864-31.744-36.864zM329.6 512h-211.2l105.6-190.112 105.6 190.112zM480 192c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM800 321.888l105.6 190.112h-211.2l105.6-190.112z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"balance",
						"measure",
						"weigh",
						"revenge",
						"judge"
					],
					"grid": 32
				},
				{
					"id": 2499,
					"paths": [
						"M896 448c0-247.424-171.922-448-384-448-212.076 0-384 200.576-384 448 0 222.584 139.146 407.222 321.486 442.058l-33.486 133.942h192l-33.486-133.942c182.34-34.836 321.486-219.472 321.486-442.058zM282.706 512h-96.004c-3.080-20.798-4.702-42.176-4.702-64 0-44.966 6.818-88.076 19.308-128h96.016c-12.492 39.926-19.324 83.030-19.324 128 0 21.824 1.626 43.202 4.706 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"balloon",
						"party"
					],
					"defaultCode": 60334,
					"grid": 16
				},
				{
					"id": 1268,
					"width": 877.7139739990234,
					"paths": [
						"M749.714 510.286q0-92-49.714-168.571l-430.857 430.286q78.286 50.857 169.714 50.857 63.429 0 120.857-24.857t99.143-66.571 66.286-99.714 24.571-121.429zM178.857 681.143l431.429-430.857q-77.143-52-171.429-52-84.571 0-156 41.714t-113.143 113.714-41.714 156.571q0 92.571 50.857 170.857zM877.714 510.286q0 89.714-34.857 171.429t-93.429 140.571-140 93.714-170.571 34.857-170.571-34.857-140-93.714-93.429-140.571-34.857-171.429 34.857-171.143 93.429-140.286 140-93.714 170.571-34.857 170.571 34.857 140 93.714 93.429 140.286 34.857 171.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ban"
					],
					"defaultCode": 61534,
					"grid": 14
				},
				{
					"id": 1552,
					"width": 1097.1409912109375,
					"paths": [
						"M548.571 0l548.571 219.429v73.143h-73.143q0 14.857-11.714 25.714t-27.714 10.857h-872q-16 0-27.714-10.857t-11.714-25.714h-73.143v-73.143zM146.286 365.714h146.286v438.857h73.143v-438.857h146.286v438.857h73.143v-438.857h146.286v438.857h73.143v-438.857h146.286v438.857h33.714q16 0 27.714 10.857t11.714 25.714v36.571h-950.857v-36.571q0-14.857 11.714-25.714t27.714-10.857h33.714v-438.857zM1057.714 914.286q16 0 27.714 10.857t11.714 25.714v73.143h-1097.143v-73.143q0-14.857 11.714-25.714t27.714-10.857h1018.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bank",
						"institution",
						"university"
					],
					"defaultCode": 61852,
					"grid": 14
				},
				{
					"id": 1299,
					"width": 1170.2860107421875,
					"paths": [
						"M365.714 512v292.571h-146.286v-292.571h146.286zM585.143 219.429v585.143h-146.286v-585.143h146.286zM1170.286 877.714v73.143h-1170.286v-877.714h73.143v804.571h1097.143zM804.571 365.714v438.857h-146.286v-438.857h146.286zM1024 146.286v658.286h-146.286v-658.286h146.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bar-chart",
						"bar-chart-o"
					],
					"defaultCode": 61568,
					"grid": 14
				},
				{
					"id": 2059,
					"paths": [
						"M0 192h128v640h-128zM192 192h64v640h-64zM320 192h64v640h-64zM512 192h64v640h-64zM768 192h64v640h-64zM960 192h64v640h-64zM640 192h32v640h-32zM448 192h32v640h-32zM864 192h32v640h-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"barcode"
					],
					"defaultCode": 59894,
					"grid": 16
				},
				{
					"id": 2060,
					"paths": [
						"M0 128h128v640h-128zM192 128h64v640h-64zM320 128h64v640h-64zM512 128h64v640h-64zM768 128h64v640h-64zM960 128h64v640h-64zM640 128h32v640h-32zM448 128h32v640h-32zM864 128h32v640h-32zM0 832h64v64h-64zM192 832h64v64h-64zM320 832h64v64h-64zM640 832h64v64h-64zM960 832h64v64h-64zM768 832h128v64h-128zM448 832h128v64h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"barcode"
					],
					"defaultCode": 59895,
					"grid": 16
				},
				{
					"id": 1218,
					"width": 1024,
					"paths": [
						"M36 877.714h-36v-804.571h36v804.571zM72 877.143h-18.286v-804h18.286v804zM125.714 877.143h-17.714v-804h17.714v804zM215.429 877.143h-17.714v-804h17.714v804zM305.143 877.143h-35.429v-804h35.429v804zM377.143 877.143h-17.714v-804h17.714v804zM413.143 877.143h-17.714v-804h17.714v804zM449.143 877.143h-17.714v-804h17.714v804zM538.857 877.143h-36v-804h36v804zM628.571 877.143h-36v-804h36v804zM700.571 877.143h-36v-804h36v804zM772.571 877.143h-36v-804h36v804zM826.286 877.143h-36v-804h36v804zM934.286 877.143h-53.714v-804h53.714v804zM970.286 877.143h-18.286v-804h18.286v804zM1024 877.714h-36v-804.571h36v804.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"barcode"
					],
					"defaultCode": 61482,
					"grid": 14
				},
				{
					"id": 1356,
					"width": 877.7149925231934,
					"paths": [
						"M877.714 768v73.143q0 14.857-10.857 25.714t-25.714 10.857h-804.571q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h804.571q14.857 0 25.714 10.857t10.857 25.714zM877.714 475.429v73.143q0 14.857-10.857 25.714t-25.714 10.857h-804.571q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h804.571q14.857 0 25.714 10.857t10.857 25.714zM877.714 182.857v73.143q0 14.857-10.857 25.714t-25.714 10.857h-804.571q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h804.571q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bars",
						"navicon",
						"reorder"
					],
					"defaultCode": 61641,
					"grid": 14
				},
				{
					"id": 2643,
					"paths": [
						"M768.77 879.168c0-0.002-0.004-0.006-0.008-0.008-0.080-0.088-0.146-0.16-0.228-0.246-0.006-0.008-0.012-0.014-0.018-0.020-0.246-0.264-0.472-0.51-0.718-0.774-0.006-0.008-0.012-0.016-0.020-0.022-0.082-0.088-0.14-0.154-0.222-0.242-0.004-0.006-0.012-0.012-0.016-0.018-0.164-0.176-0.308-0.332-0.472-0.51-0.012-0.014-0.024-0.026-0.036-0.038-0.058-0.066-0.132-0.144-0.194-0.21-0.016-0.018-0.032-0.036-0.046-0.050-0.060-0.066-0.144-0.158-0.206-0.222-0.008-0.008-0.016-0.018-0.024-0.026-0.082-0.088-0.15-0.164-0.23-0.252-0.012-0.012-0.022-0.024-0.032-0.036-0.062-0.066-0.136-0.146-0.196-0.212-0.018-0.020-0.038-0.042-0.054-0.060-0.062-0.066-0.118-0.126-0.178-0.196-0.018-0.016-0.036-0.036-0.052-0.054-0.070-0.078-0.152-0.168-0.224-0.246h-0.002c-0.070-0.078-0.152-0.168-0.222-0.246-0.020-0.022-0.040-0.042-0.058-0.062-0.060-0.066-0.104-0.114-0.164-0.18-0.026-0.028-0.046-0.054-0.072-0.082-0.060-0.064-0.108-0.116-0.166-0.18-0.020-0.024-0.040-0.042-0.054-0.062-0.082-0.090-0.138-0.15-0.218-0.238-0.022-0.024-0.040-0.044-0.062-0.066-0.048-0.058-0.106-0.118-0.154-0.174-0.030-0.034-0.060-0.064-0.088-0.098-0.042-0.044-0.090-0.1-0.132-0.144-0.032-0.034-0.060-0.068-0.094-0.104-0.048-0.054-0.1-0.11-0.152-0.168-0.020-0.024-0.040-0.046-0.062-0.070-0.070-0.078-0.13-0.144-0.202-0.222-0.038-0.040-0.070-0.078-0.106-0.118-0.030-0.036-0.080-0.090-0.112-0.122-0.038-0.042-0.074-0.082-0.11-0.124-0.032-0.034-0.074-0.084-0.106-0.118-0.038-0.042-0.074-0.082-0.114-0.124-0.040-0.046-0.070-0.082-0.11-0.124-0.070-0.078-0.138-0.152-0.208-0.23-0.020-0.024-0.062-0.070-0.082-0.090-0.044-0.050-0.090-0.102-0.136-0.152-0.020-0.024-0.050-0.058-0.072-0.082-0.044-0.048-0.090-0.1-0.134-0.148-0.020-0.024-0.050-0.054-0.070-0.078-0.156-0.176-0.314-0.352-0.472-0.528-0.020-0.024-0.034-0.040-0.052-0.062-0.048-0.054-0.096-0.11-0.146-0.164-0.020-0.024-0.042-0.046-0.062-0.070-0.048-0.054-0.098-0.11-0.148-0.168-0.124-0.136-0.246-0.276-0.368-0.412l-0.008-0.008c-0.054-0.060-0.11-0.124-0.164-0.186-0.012-0.012-0.028-0.032-0.038-0.042-0.056-0.062-0.114-0.124-0.17-0.188l-0.006-0.008c-0.178-0.204-0.36-0.406-0.538-0.61-0.012-0.010-0.016-0.016-0.026-0.026-0.054-0.064-0.112-0.126-0.166-0.19-0.010-0.012-0.018-0.020-0.028-0.032-0.242-0.274-0.484-0.548-0.726-0.824l-0.004-0.006c-2.164-2.462-4.304-4.954-6.418-7.462l13.316-11.22c-12.402-14.978-23.918-30.718-34.456-47.146l-16.162 10.876c-3.388-5.036-6.684-10.14-9.886-15.308l-0.004-0.012c-0.046-0.072-0.094-0.146-0.136-0.218-0.010-0.014-0.016-0.024-0.024-0.038-0.184-0.298-0.37-0.596-0.552-0.896-0.016-0.026-0.030-0.046-0.044-0.074-0.040-0.060-0.074-0.122-0.114-0.182-0.016-0.026-0.036-0.060-0.050-0.086-0.082-0.13-0.16-0.256-0.24-0.386-0.008-0.014-0.010-0.014-0.016-0.026-0.034-0.058-0.066-0.114-0.1-0.168-0.026-0.038-0.044-0.070-0.070-0.11-0.030-0.050-0.062-0.106-0.094-0.156-0.024-0.040-0.052-0.086-0.076-0.124-0.030-0.048-0.060-0.098-0.088-0.144-0.034-0.050-0.068-0.11-0.102-0.16-0.040-0.072-0.084-0.144-0.128-0.214-0.030-0.050-0.060-0.102-0.090-0.152-0.028-0.042-0.054-0.086-0.082-0.13-0.032-0.052-0.058-0.1-0.090-0.15-0.028-0.042-0.050-0.084-0.078-0.124-0.040-0.066-0.076-0.126-0.114-0.192-0.020-0.028-0.038-0.058-0.052-0.086-0.056-0.090-0.108-0.176-0.162-0.266-0.020-0.032-0.040-0.064-0.058-0.096-0.040-0.064-0.078-0.13-0.118-0.198-0.020-0.028-0.038-0.058-0.054-0.090-0.046-0.076-0.082-0.132-0.128-0.212-0.016-0.024-0.032-0.048-0.044-0.072-0.052-0.090-0.12-0.196-0.174-0.288 0-0.002-0.002-0.006-0.004-0.010-0.054-0.090-0.114-0.188-0.168-0.278-0.012-0.020-0.024-0.042-0.036-0.062-0.046-0.078-0.1-0.16-0.144-0.24-0.012-0.018-0.024-0.036-0.034-0.052-0.054-0.092-0.12-0.2-0.174-0.29-0.062-0.104-0.12-0.204-0.184-0.304-0.004-0.008-0.006-0.012-0.010-0.020-0.056-0.090-0.112-0.184-0.166-0.278-0.008-0.012-0.016-0.028-0.026-0.042-0.178-0.298-0.362-0.61-0.54-0.908-0.002-0.002-0.006-0.008-0.006-0.010-0.062-0.104-0.118-0.194-0.178-0.296-0.002-0.004-0.006-0.010-0.008-0.014-0.184-0.308-0.362-0.614-0.544-0.926-0.004-0.002-0.004-0.004-0.006-0.006-7.356-12.466-14.15-25.272-20.376-38.424l18.802-8.902c-7.076-15.584-13.32-31.624-18.724-48.042l-19.73 6.828c-4.274-12.348-8.054-24.918-11.324-37.696 0-0.004 0-0.004-0.002-0.008-0.092-0.36-0.182-0.71-0.274-1.072 0-0.002 0-0.002-0.002-0.004-0.090-0.36-0.176-0.702-0.266-1.062-0.004-0.010-0.006-0.020-0.008-0.030-0.090-0.36-0.176-0.696-0.266-1.058 0-0.004-0.002-0.010-0.004-0.016-0.088-0.36-0.172-0.7-0.262-1.060 0-0.010-0.004-0.016-0.004-0.024-0.032-0.122-0.054-0.22-0.086-0.342 0-0.004 0-0.004-0.002-0.008-0.058-0.242-0.116-0.474-0.174-0.714 0-0.002-0.002-0.008-0.002-0.008-0.030-0.122-0.056-0.23-0.084-0.352-0.002-0.004-0.002-0.004-0.004-0.010-0.058-0.24-0.114-0.472-0.172-0.712 0-0.004-0.002-0.008-0.004-0.012-0.030-0.122-0.050-0.22-0.082-0.34-0.002-0.010-0.004-0.016-0.004-0.024-0.086-0.36-0.168-0.696-0.254-1.058-0.002-0.008-0.004-0.020-0.008-0.028-0.086-0.364-0.164-0.7-0.25-1.062 0-0.008-0.004-0.016-0.004-0.020-0.086-0.362-0.168-0.708-0.25-1.070-0.002-0.004-0.004-0.008-0.004-0.012-0.084-0.364-0.166-0.714-0.248-1.076-0.002-0.002-0.002-0.006-0.002-0.010-0.086-0.364-0.166-0.714-0.248-1.078-0.002-0.004-0.002-0.008-0.002-0.010-1.476-6.482-2.82-13.010-4.034-19.588l21.318-3.924c-2.834-16.148-4.85-32.578-6.026-49.24l-17.23 1.272v-71.11l17.232 1.272c1.176-16.662 3.192-33.090 6.026-49.24l-21.318-3.924c1.212-6.578 2.556-13.104 4.034-19.586 0-0.002 0-0.006 0.002-0.010 0.082-0.362 0.162-0.716 0.248-1.080 0-0.002 0-0.006 0.002-0.008 0.082-0.362 0.164-0.712 0.248-1.076 0-0.006 0.002-0.008 0.004-0.014 0.082-0.362 0.164-0.708 0.25-1.068 0-0.006 0.004-0.014 0.004-0.020 0.086-0.364 0.164-0.702 0.25-1.062 0.004-0.008 0.006-0.020 0.008-0.030 0.086-0.362 0.168-0.698 0.254-1.058 0-0.008 0.002-0.012 0.004-0.022 0.032-0.12 0.052-0.22 0.082-0.34 0.002-0.004 0.004-0.008 0.004-0.012 0.058-0.24 0.114-0.472 0.172-0.712 0.002-0.004 0.002-0.006 0.004-0.010 0.028-0.122 0.054-0.23 0.084-0.35 0 0 0.002-0.006 0.002-0.006 0.058-0.242 0.116-0.474 0.174-0.716 0.002-0.002 0.002-0.004 0.002-0.008 0.032-0.12 0.054-0.22 0.086-0.342 0-0.008 0.004-0.014 0.004-0.024 0.090-0.36 0.174-0.702 0.262-1.060 0.002-0.006 0.004-0.010 0.004-0.016 0.090-0.362 0.176-0.698 0.266-1.058 0.002-0.010 0.004-0.020 0.008-0.030 0.090-0.362 0.176-0.704 0.266-1.062 0.002 0 0.002-0.002 0.002-0.004 0.092-0.36 0.182-0.714 0.274-1.072 0.002-0.002 0.002-0.004 0.002-0.008 3.27-12.778 7.050-25.348 11.324-37.696l19.73 6.828c5.404-16.42 11.65-32.458 18.724-48.042l-18.802-8.902c6.226-13.152 13.022-25.956 20.376-38.424 0.002-0.002 0.002-0.004 0.006-0.006 0.184-0.312 0.362-0.616 0.544-0.926 0.002-0.004 0.006-0.008 0.008-0.012 0.060-0.104 0.116-0.194 0.178-0.296 0-0.002 0.004-0.008 0.006-0.010 0.178-0.298 0.362-0.61 0.54-0.908 0.010-0.014 0.018-0.028 0.026-0.042 0.054-0.092 0.11-0.186 0.166-0.276 0.004-0.006 0.006-0.012 0.010-0.020 0.064-0.102 0.122-0.202 0.184-0.304v0c0.054-0.090 0.12-0.198 0.174-0.288 0.010-0.018 0.022-0.036 0.034-0.054 0.044-0.080 0.098-0.164 0.144-0.242 0.012-0.020 0.024-0.042 0.036-0.062 0.054-0.090 0.114-0.188 0.168-0.278 0.002-0.002 0.004-0.006 0.004-0.010 0.054-0.090 0.122-0.198 0.174-0.286 0.014-0.024 0.030-0.050 0.044-0.074 0.046-0.080 0.082-0.136 0.128-0.214 0.018-0.030 0.036-0.060 0.054-0.090 0.040-0.064 0.078-0.13 0.118-0.196 0.020-0.032 0.040-0.064 0.058-0.094 0.054-0.090 0.106-0.178 0.162-0.266 0.016-0.028 0.034-0.058 0.052-0.086 0.038-0.064 0.074-0.124 0.114-0.19 0.028-0.042 0.050-0.084 0.078-0.124 0.032-0.052 0.058-0.1 0.090-0.152 0.028-0.044 0.054-0.086 0.082-0.13 0.030-0.050 0.060-0.102 0.090-0.154 0.044-0.070 0.090-0.142 0.128-0.212 0.034-0.050 0.068-0.11 0.102-0.16 0.028-0.048 0.058-0.096 0.088-0.146 0.024-0.038 0.052-0.086 0.076-0.124 0.032-0.052 0.064-0.106 0.094-0.158 0.026-0.038 0.044-0.072 0.070-0.11 0.034-0.054 0.066-0.11 0.1-0.166 0.006-0.012 0.008-0.014 0.016-0.026 0.080-0.13 0.158-0.256 0.24-0.386 0.016-0.026 0.036-0.060 0.050-0.086 0.040-0.062 0.074-0.122 0.114-0.182 0.016-0.026 0.030-0.048 0.044-0.074 0.184-0.3 0.37-0.598 0.552-0.896 0.008-0.012 0.014-0.024 0.024-0.036 0.042-0.074 0.090-0.148 0.136-0.22l0.004-0.012c3.204-5.168 6.498-10.272 9.886-15.308l16.162 10.876c10.538-16.43 22.052-32.168 34.456-47.148l-13.316-11.22c2.114-2.508 4.254-4.998 6.418-7.462l0.004-0.004c0.242-0.276 0.484-0.55 0.726-0.826 0.010-0.010 0.018-0.020 0.028-0.030 0.054-0.064 0.112-0.124 0.166-0.19 0.010-0.010 0.014-0.016 0.026-0.026 0.178-0.202 0.36-0.406 0.538-0.608l0.006-0.006c0.056-0.062 0.114-0.126 0.17-0.19 0.010-0.012 0.026-0.032 0.038-0.042 0.054-0.062 0.11-0.124 0.164-0.186l0.008-0.008c0.122-0.136 0.244-0.276 0.368-0.414 0.050-0.056 0.1-0.112 0.148-0.168 0.020-0.022 0.042-0.046 0.062-0.070 0.050-0.054 0.098-0.108 0.146-0.164 0.020-0.022 0.034-0.040 0.052-0.062 0.158-0.176 0.316-0.352 0.472-0.528 0.020-0.022 0.050-0.056 0.070-0.078 0.044-0.050 0.090-0.1 0.134-0.15 0.022-0.022 0.052-0.060 0.072-0.084 0.046-0.050 0.092-0.1 0.136-0.15 0.020-0.022 0.062-0.068 0.082-0.090 0.068-0.080 0.136-0.154 0.208-0.232 0.040-0.044 0.070-0.080 0.11-0.124 0.040-0.042 0.076-0.084 0.114-0.124 0.032-0.034 0.074-0.084 0.106-0.118 0.036-0.040 0.072-0.080 0.11-0.122 0.032-0.032 0.082-0.088 0.112-0.122 0.036-0.040 0.068-0.078 0.106-0.118 0.070-0.078 0.13-0.146 0.202-0.222 0.024-0.024 0.042-0.046 0.062-0.070 0.052-0.058 0.104-0.114 0.152-0.168 0.034-0.036 0.062-0.070 0.094-0.104 0.042-0.044 0.092-0.1 0.132-0.144 0.028-0.034 0.058-0.066 0.088-0.098 0.048-0.056 0.106-0.116 0.154-0.172 0.024-0.022 0.042-0.044 0.062-0.066 0.080-0.088 0.136-0.15 0.218-0.24 0.016-0.020 0.036-0.040 0.054-0.062 0.058-0.066 0.106-0.116 0.166-0.182 0.026-0.028 0.046-0.054 0.072-0.082 0.060-0.066 0.104-0.112 0.164-0.178 0.020-0.022 0.040-0.042 0.058-0.064 0.070-0.078 0.152-0.168 0.222-0.246h0.002c0.072-0.076 0.154-0.168 0.224-0.246 0.018-0.018 0.036-0.038 0.052-0.054 0.060-0.068 0.116-0.128 0.178-0.196 0.018-0.020 0.038-0.040 0.054-0.060 0.058-0.066 0.132-0.148 0.196-0.214 0.010-0.012 0.020-0.022 0.032-0.034 0.080-0.088 0.148-0.164 0.23-0.252 0.008-0.008 0.016-0.016 0.024-0.024 0.060-0.066 0.144-0.156 0.206-0.222 0.016-0.018 0.032-0.034 0.046-0.050 0.060-0.066 0.134-0.146 0.194-0.212 0.012-0.012 0.024-0.024 0.036-0.038 0.164-0.178 0.308-0.334 0.472-0.51 0.004-0.004 0.012-0.010 0.016-0.016 0.082-0.088 0.14-0.154 0.222-0.242 0.008-0.006 0.014-0.014 0.020-0.022 0.246-0.264 0.472-0.51 0.718-0.774 0.006-0.006 0.012-0.012 0.018-0.020 0.082-0.086 0.148-0.158 0.228-0.246 0.004-0.002 0.008-0.006 0.008-0.008 8.568-9.196 17.502-18.038 26.762-26.536-84.374-73.662-194.738-118.298-315.534-118.298-120.798 0-231.16 44.636-315.53 118.296 9.258 8.498 18.192 17.34 26.76 26.536 0.002 0.002 0.006 0.006 0.008 0.008 0.082 0.088 0.148 0.16 0.23 0.246 0.006 0.006 0.012 0.014 0.018 0.020 0.244 0.264 0.472 0.51 0.716 0.774 0.006 0.006 0.014 0.014 0.020 0.022 0.082 0.088 0.142 0.154 0.224 0.242 0.004 0.006 0.010 0.012 0.014 0.016 0.164 0.176 0.308 0.334 0.472 0.51 0.012 0.012 0.024 0.024 0.036 0.038 0.060 0.066 0.132 0.146 0.194 0.212 0.016 0.016 0.032 0.034 0.046 0.050 0.062 0.066 0.144 0.158 0.206 0.222 0.008 0.008 0.016 0.016 0.022 0.024 0.082 0.088 0.152 0.164 0.232 0.252 0.010 0.012 0.022 0.022 0.032 0.034 0.062 0.066 0.136 0.148 0.196 0.214 0.016 0.020 0.036 0.040 0.054 0.060 0.060 0.066 0.118 0.128 0.176 0.196 0.018 0.018 0.036 0.038 0.052 0.054 0.070 0.078 0.154 0.17 0.224 0.246v0c0.070 0.078 0.154 0.168 0.224 0.246 0.020 0.022 0.038 0.042 0.058 0.064 0.060 0.066 0.104 0.114 0.164 0.178 0.026 0.028 0.046 0.054 0.072 0.082 0.060 0.066 0.106 0.116 0.166 0.182 0.018 0.022 0.038 0.042 0.054 0.062 0.082 0.090 0.138 0.15 0.218 0.24 0.022 0.022 0.040 0.044 0.062 0.066 0.050 0.058 0.106 0.118 0.156 0.172 0.030 0.032 0.060 0.064 0.088 0.098 0.042 0.044 0.090 0.1 0.132 0.144 0.032 0.034 0.062 0.068 0.094 0.104 0.050 0.054 0.1 0.11 0.152 0.168 0.020 0.024 0.042 0.046 0.064 0.070 0.070 0.078 0.13 0.144 0.202 0.222 0.036 0.040 0.070 0.078 0.106 0.118 0.030 0.034 0.082 0.090 0.112 0.122 0.038 0.042 0.074 0.082 0.11 0.122 0.030 0.034 0.074 0.084 0.104 0.118 0.038 0.042 0.074 0.082 0.112 0.124 0.040 0.044 0.072 0.080 0.112 0.124 0.070 0.078 0.138 0.152 0.208 0.232 0.020 0.022 0.062 0.068 0.082 0.090 0.044 0.050 0.090 0.1 0.136 0.15 0.020 0.024 0.052 0.060 0.074 0.084 0.044 0.048 0.090 0.1 0.134 0.15 0.020 0.022 0.050 0.054 0.072 0.078 0.156 0.176 0.314 0.352 0.472 0.528 0.020 0.022 0.034 0.040 0.054 0.062 0.048 0.056 0.096 0.11 0.146 0.164 0.020 0.022 0.042 0.046 0.062 0.070 0.048 0.056 0.098 0.112 0.148 0.168v0c0.122 0.138 0.246 0.276 0.368 0.414l0.006 0.008c0.056 0.062 0.11 0.124 0.166 0.186 0.010 0.010 0.026 0.030 0.036 0.042 0.056 0.062 0.114 0.126 0.168 0.19l0.006 0.006c0.178 0.202 0.36 0.408 0.538 0.608 0.010 0.010 0.014 0.016 0.024 0.026 0.054 0.066 0.11 0.126 0.166 0.19 0.010 0.010 0.018 0.020 0.028 0.030 0.242 0.274 0.484 0.548 0.724 0.826l0.004 0.004c2.166 2.464 4.304 4.954 6.418 7.462l-13.316 11.22c12.402 14.98 23.918 30.72 34.456 47.148l16.164-10.876c3.388 5.036 6.682 10.14 9.884 15.308l0.006 0.012c0.046 0.074 0.092 0.148 0.136 0.22 0.008 0.012 0.014 0.024 0.022 0.036 0.184 0.298 0.37 0.596 0.552 0.896 0.016 0.026 0.030 0.048 0.044 0.074 0.038 0.062 0.076 0.122 0.112 0.182 0.016 0.026 0.038 0.060 0.052 0.086 0.080 0.13 0.16 0.256 0.24 0.386 0.008 0.012 0.008 0.014 0.016 0.026 0.034 0.056 0.066 0.112 0.1 0.166 0.024 0.038 0.044 0.072 0.068 0.11 0.030 0.052 0.064 0.104 0.096 0.158 0.024 0.038 0.052 0.086 0.076 0.124 0.030 0.048 0.060 0.096 0.088 0.146 0.032 0.050 0.068 0.11 0.1 0.16 0.042 0.072 0.084 0.144 0.128 0.212 0.030 0.052 0.062 0.102 0.092 0.154 0.028 0.044 0.054 0.086 0.080 0.13 0.032 0.052 0.060 0.1 0.092 0.152 0.026 0.042 0.050 0.084 0.076 0.124 0.040 0.066 0.078 0.126 0.116 0.19 0.018 0.028 0.036 0.060 0.052 0.086 0.056 0.088 0.108 0.176 0.164 0.266 0.020 0.032 0.038 0.064 0.058 0.094 0.038 0.066 0.078 0.132 0.118 0.196 0.018 0.030 0.038 0.060 0.056 0.090 0.046 0.078 0.082 0.134 0.128 0.214 0.014 0.024 0.030 0.048 0.044 0.074 0.054 0.088 0.118 0.196 0.174 0.286 0 0.002 0.002 0.006 0.002 0.010 0.056 0.090 0.114 0.188 0.168 0.278 0.012 0.020 0.026 0.042 0.038 0.062 0.046 0.078 0.098 0.162 0.144 0.242 0.012 0.018 0.022 0.036 0.034 0.054 0.054 0.090 0.12 0.198 0.172 0.288v0c0.062 0.102 0.12 0.202 0.184 0.304 0.004 0.008 0.006 0.012 0.010 0.020 0.056 0.090 0.11 0.184 0.166 0.276 0.008 0.014 0.018 0.028 0.026 0.042 0.176 0.298 0.362 0.61 0.54 0.908 0.002 0.002 0.004 0.006 0.006 0.010 0.060 0.104 0.116 0.192 0.176 0.296 0.002 0.004 0.006 0.008 0.008 0.012 0.184 0.31 0.362 0.614 0.546 0.926 0.002 0.002 0.002 0.004 0.004 0.006 7.356 12.468 14.152 25.272 20.378 38.424l-18.804 8.904c7.076 15.584 13.32 31.622 18.724 48.042l19.73-6.828c4.274 12.348 8.056 24.918 11.326 37.696 0 0.002 0 0.004 0.002 0.008 0.092 0.358 0.182 0.712 0.274 1.072 0 0.002 0 0.002 0 0.004 0.090 0.36 0.176 0.702 0.268 1.062 0.002 0.010 0.004 0.020 0.006 0.030 0.090 0.36 0.174 0.696 0.264 1.058 0 0.006 0.002 0.010 0.004 0.016 0.088 0.36 0.174 0.7 0.262 1.060 0.002 0.010 0.004 0.016 0.006 0.024 0.030 0.122 0.054 0.222 0.084 0.342 0 0.002 0.002 0.004 0.002 0.008 0.058 0.242 0.116 0.474 0.174 0.716 0 0 0 0.006 0 0.006 0.030 0.122 0.056 0.23 0.084 0.35 0 0.004 0 0.006 0.002 0.010 0.058 0.24 0.114 0.472 0.172 0.712 0 0.004 0.002 0.008 0.004 0.012 0.030 0.122 0.052 0.22 0.082 0.34 0.002 0.008 0.004 0.014 0.006 0.022 0.086 0.362 0.166 0.696 0.252 1.058 0.002 0.008 0.006 0.020 0.008 0.030 0.086 0.362 0.166 0.7 0.25 1.062 0.002 0.006 0.004 0.014 0.004 0.020 0.086 0.36 0.166 0.706 0.25 1.068 0 0.004 0.002 0.008 0.002 0.014 0.084 0.364 0.166 0.714 0.248 1.076 0 0.002 0.002 0.006 0.002 0.008 0.084 0.364 0.166 0.716 0.248 1.080 0 0.002 0.002 0.006 0.002 0.010 1.476 6.482 2.82 13.008 4.032 19.586l-21.318 3.924c2.834 16.15 4.85 32.578 6.026 49.24l17.232-1.272v71.11l-17.232-1.274c-1.176 16.662-3.192 33.092-6.026 49.24l21.318 3.924c-1.212 6.578-2.556 13.106-4.032 19.588 0 0.002-0.002 0.006-0.002 0.010-0.082 0.364-0.164 0.714-0.248 1.078 0 0.004-0.002 0.008-0.002 0.010-0.082 0.362-0.164 0.712-0.248 1.076 0 0.004-0.002 0.008-0.002 0.012-0.084 0.364-0.166 0.708-0.25 1.070 0 0.004-0.002 0.012-0.004 0.020-0.084 0.364-0.164 0.7-0.25 1.062-0.002 0.008-0.004 0.020-0.008 0.028-0.086 0.364-0.166 0.7-0.252 1.058-0.002 0.008-0.002 0.014-0.006 0.024-0.030 0.12-0.052 0.218-0.082 0.34-0.002 0.004-0.002 0.008-0.004 0.012-0.058 0.24-0.114 0.472-0.172 0.712-0.002 0.006-0.002 0.006-0.002 0.010-0.030 0.122-0.056 0.23-0.084 0.352 0 0 0 0.006 0 0.008-0.058 0.24-0.116 0.472-0.174 0.714 0 0.004-0.002 0.004-0.002 0.008-0.030 0.122-0.054 0.22-0.084 0.342-0.002 0.008-0.004 0.014-0.006 0.024-0.088 0.362-0.172 0.702-0.262 1.060 0 0.006-0.002 0.012-0.004 0.016-0.090 0.364-0.174 0.7-0.264 1.058-0.002 0.010-0.004 0.020-0.006 0.030-0.090 0.362-0.178 0.704-0.268 1.062 0 0.002 0 0.002 0 0.004-0.092 0.362-0.182 0.712-0.274 1.072 0 0.004-0.002 0.004-0.002 0.008-3.27 12.778-7.052 25.348-11.326 37.696l-19.73-6.828c-5.404 16.42-11.65 32.458-18.724 48.042l18.804 8.902c-6.226 13.152-13.022 25.958-20.378 38.424-0.002 0.002-0.002 0.004-0.004 0.006-0.184 0.312-0.362 0.618-0.546 0.926-0.002 0.004-0.006 0.010-0.008 0.014-0.062 0.104-0.116 0.194-0.176 0.296-0.002 0.002-0.004 0.008-0.006 0.010-0.176 0.298-0.362 0.61-0.54 0.908-0.008 0.014-0.018 0.030-0.026 0.042-0.054 0.094-0.11 0.188-0.166 0.278-0.004 0.008-0.006 0.012-0.010 0.020-0.064 0.102-0.122 0.202-0.184 0.304-0.054 0.090-0.118 0.198-0.172 0.29-0.010 0.018-0.022 0.036-0.034 0.052-0.044 0.080-0.096 0.162-0.144 0.24-0.012 0.020-0.026 0.042-0.038 0.062-0.054 0.090-0.112 0.188-0.168 0.278 0 0.004-0.002 0.008-0.002 0.010-0.056 0.092-0.12 0.198-0.174 0.288-0.014 0.024-0.030 0.048-0.044 0.072-0.046 0.080-0.082 0.136-0.128 0.212-0.018 0.032-0.038 0.062-0.056 0.090-0.040 0.066-0.080 0.132-0.118 0.198-0.020 0.032-0.038 0.064-0.058 0.096-0.054 0.090-0.108 0.176-0.164 0.266-0.016 0.028-0.034 0.058-0.052 0.086-0.038 0.064-0.076 0.124-0.116 0.192-0.026 0.042-0.050 0.082-0.076 0.124-0.032 0.050-0.060 0.098-0.092 0.15-0.026 0.044-0.052 0.088-0.080 0.13-0.030 0.050-0.062 0.102-0.092 0.152-0.044 0.070-0.088 0.142-0.128 0.214-0.032 0.050-0.068 0.11-0.1 0.16-0.030 0.046-0.060 0.096-0.088 0.144-0.024 0.040-0.052 0.086-0.076 0.124-0.032 0.050-0.066 0.106-0.096 0.156-0.024 0.040-0.044 0.072-0.068 0.11-0.034 0.054-0.068 0.11-0.1 0.168-0.006 0.012-0.008 0.012-0.016 0.026-0.080 0.13-0.16 0.256-0.24 0.386-0.016 0.026-0.036 0.060-0.052 0.086-0.038 0.060-0.074 0.122-0.112 0.182-0.014 0.028-0.030 0.048-0.044 0.074-0.184 0.3-0.37 0.598-0.552 0.896-0.008 0.014-0.014 0.024-0.022 0.038-0.044 0.072-0.090 0.146-0.136 0.218l-0.006 0.012c-3.202 5.168-6.498 10.274-9.884 15.308l-16.164-10.876c-10.536 16.428-22.052 32.168-34.454 47.146l13.316 11.22c-2.114 2.51-4.254 5-6.418 7.462l-0.004 0.006c-0.242 0.276-0.484 0.55-0.724 0.824-0.010 0.012-0.018 0.020-0.028 0.032-0.056 0.062-0.112 0.124-0.166 0.19-0.010 0.010-0.014 0.016-0.024 0.026-0.178 0.204-0.36 0.406-0.538 0.61l-0.006 0.008c-0.056 0.062-0.112 0.124-0.168 0.188-0.010 0.012-0.026 0.032-0.036 0.042-0.056 0.062-0.11 0.124-0.166 0.186l-0.006 0.008c-0.122 0.136-0.246 0.276-0.368 0.412v0c-0.050 0.058-0.1 0.114-0.148 0.168-0.020 0.024-0.042 0.046-0.062 0.070-0.050 0.054-0.098 0.11-0.146 0.164-0.020 0.024-0.034 0.040-0.054 0.062-0.158 0.176-0.316 0.352-0.472 0.528-0.020 0.024-0.050 0.054-0.072 0.078-0.044 0.048-0.090 0.1-0.134 0.148-0.020 0.024-0.052 0.058-0.074 0.082-0.044 0.050-0.090 0.102-0.136 0.152-0.020 0.020-0.062 0.066-0.082 0.090-0.070 0.078-0.138 0.152-0.208 0.23-0.040 0.042-0.072 0.078-0.112 0.124-0.038 0.042-0.076 0.082-0.112 0.124-0.030 0.034-0.076 0.084-0.104 0.118-0.038 0.042-0.074 0.080-0.11 0.124-0.030 0.032-0.082 0.086-0.112 0.122-0.036 0.040-0.070 0.078-0.106 0.118-0.070 0.078-0.132 0.144-0.202 0.222-0.022 0.024-0.042 0.046-0.064 0.070-0.052 0.058-0.102 0.114-0.152 0.168-0.032 0.036-0.062 0.070-0.094 0.104-0.042 0.044-0.090 0.1-0.132 0.144-0.028 0.034-0.058 0.064-0.088 0.098-0.050 0.056-0.106 0.116-0.156 0.174-0.022 0.022-0.040 0.042-0.062 0.066-0.080 0.088-0.136 0.148-0.218 0.238-0.018 0.020-0.036 0.040-0.054 0.062-0.060 0.064-0.106 0.116-0.166 0.18-0.026 0.028-0.046 0.054-0.072 0.082-0.060 0.066-0.104 0.114-0.164 0.18-0.020 0.020-0.040 0.042-0.058 0.062-0.070 0.078-0.154 0.168-0.224 0.246v0c-0.072 0.078-0.154 0.168-0.224 0.246-0.018 0.020-0.036 0.040-0.052 0.054-0.060 0.068-0.116 0.128-0.176 0.196-0.018 0.020-0.038 0.042-0.054 0.060-0.060 0.066-0.134 0.146-0.196 0.212-0.010 0.012-0.020 0.024-0.032 0.036-0.080 0.088-0.15 0.164-0.232 0.252-0.006 0.008-0.014 0.018-0.022 0.026-0.060 0.064-0.144 0.156-0.206 0.222-0.016 0.016-0.032 0.034-0.046 0.050-0.062 0.066-0.134 0.144-0.194 0.21-0.012 0.012-0.024 0.024-0.036 0.038-0.164 0.178-0.308 0.334-0.472 0.51-0.004 0.006-0.010 0.012-0.014 0.018-0.082 0.088-0.142 0.154-0.224 0.242-0.006 0.006-0.014 0.014-0.020 0.022-0.246 0.264-0.472 0.51-0.716 0.774-0.006 0.006-0.012 0.012-0.018 0.020-0.082 0.086-0.148 0.158-0.23 0.246-0.002 0.002-0.006 0.006-0.008 0.008-8.568 9.196-17.5 18.038-26.76 26.536 84.368 73.662 194.73 118.298 315.528 118.298 120.796 0 231.16-44.636 315.532-118.296-9.26-8.498-18.194-17.34-26.762-26.536zM201.822 784.922l-17.048-11.472c11.372-16.898 21.544-34.774 30.236-53.134l17.352 8.214c1.52-3.364 3.004-6.748 4.446-10.156 4.824-11.406 9.128-22.968 12.968-34.656l-18.082-6.258c6.642-19.192 11.876-39.058 15.556-59.048l18.056 3.324c2.638-15.11 4.486-30.39 5.564-45.808l-17.99-1.328c0.748-10.11 1.098-20.376 1.096-30.598 0.002-10.22-0.35-20.488-1.096-30.598l17.99-1.328c-1.078-15.418-2.924-30.7-5.564-45.808l-18.056 3.324c-3.68-19.992-8.914-39.858-15.556-59.050l18.082-6.258c-3.838-11.688-8.144-23.25-12.968-34.656-1.442-3.41-2.926-6.794-4.448-10.158l-17.352 8.216c-8.692-18.36-18.866-36.238-30.236-53.134l17.048-11.472c-9.852-15.424-20.66-30.234-32.386-44.39l-17.288 14.566c-11.806-14.012-24.662-27.32-38.254-39.648-71.024 83.69-113.892 192.026-113.892 310.392s42.868 226.702 113.894 310.392c13.594-12.328 26.448-25.634 38.254-39.648l17.288 14.566c11.726-14.158 22.534-28.966 32.386-44.388zM846.106 233.608c-13.594 12.328-26.448 25.636-38.254 39.648l-17.288-14.568c-11.726 14.158-22.534 28.968-32.384 44.392l17.046 11.472c-11.372 16.896-21.542 34.774-30.234 53.134l-17.352-8.216c-1.522 3.364-3.006 6.75-4.448 10.158-4.824 11.406-9.128 22.968-12.968 34.656l18.082 6.258c-6.642 19.192-11.876 39.058-15.556 59.050l-18.056-3.324c-2.638 15.108-4.486 30.388-5.564 45.806l17.992 1.33c-0.748 10.11-1.1 20.376-1.098 30.598-0.002 10.22 0.35 20.488 1.098 30.598l-17.992 1.328c1.078 15.42 2.926 30.7 5.564 45.808l18.056-3.324c3.68 19.99 8.914 39.858 15.556 59.048l-18.082 6.258c3.84 11.688 8.144 23.25 12.968 34.656 1.442 3.408 2.926 6.792 4.448 10.156l17.352-8.214c8.692 18.362 18.864 36.236 30.234 53.134l-17.046 11.47c9.852 15.424 20.658 30.234 32.382 44.39l17.29-14.566c11.806 14.014 24.66 27.32 38.254 39.648 71.026-83.69 113.894-192.026 113.894-310.392s-42.868-226.702-113.894-310.392z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"baseball",
						"soprts",
						"sports",
						"ball",
						"game"
					],
					"defaultCode": 60478,
					"grid": 16
				},
				{
					"id": 3366,
					"paths": [
						"M512 106.6c-186.8 0-330.8 156.4-412.4 309.6-46 86.2-78.2 180.6-93 277.2-1.6 11-3.2 22-4.4 33.2-0.6 6-1.2 12-1.6 18-0.6 7.6-0.2 10 3.8 16.4 12 19.4 26.2 37.4 42.2 53.6 32.8 33.6 72.6 59.4 114.8 79.4 96.2 45.4 204.8 61.8 310.4 65.4 109 3.6 221-5.4 325.2-39.4 89-29 174.8-79.6 224.2-161.4 5.4-8.8 1.6-21.8 0.6-32-1.2-12.2-2.8-24.2-4.8-36.2-3.6-23.6-8.4-46.8-14.2-70-11.6-47.2-27.4-93.6-46.6-138.2-69.6-161.6-198.4-334-381.6-369.6-20.6-4-41.6-6-62.6-6zM518.4 890.2c-114.2 0-238.6-10.2-341.4-65.2-40-21.4-80.8-52.4-100-95-5.6-12.4-3.6-17.2-1-31.8 1.8-9.4 2.6-18.6 6.8-27.4 5.8-12.2 11.8-24.2 18-36.2 21-40.6 43.6-80.8 69.8-118.6 13-18.6 26.8-37 42.8-53 11.2-11.2 24.8-23.2 40.6-27 48.4-11.6 85.4 44.4 114.8 72.6 14.2 13.6 33.2 29 54.4 26.4 14.6-1.8 27.6-13.2 38-22.6 35.4-31.8 63.8-71.2 93.2-108.2 14.6-18.2 29-36.6 44.8-54 10.6-11.8 22.2-25.2 36.4-32.8 25.4-13.8 57.8 14.6 75.4 29.2 30 25 56.6 54.2 82 83.8 24.2 28.2 47.6 56.8 68.2 87.8 31.8 48 59.4 99.2 84.6 151 5.4 11.2 7.2 18.8 9.2 31.2 1.2 6.8 3.8 14.6 2.8 21.6-1.4 9.8-8.2 20.4-13.2 28.4-12 19-28.2 35.4-46 49.2-74.6 57.8-175.6 77-267.4 85.6-37.6 3.6-75.2 5-112.8 5z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"basecamp",
						"brand"
					],
					"defaultCode": 61201,
					"grid": 16
				},
				{
					"id": 2075,
					"paths": [
						"M812.988 384l-177.842-231.53c3.122-7.54 4.854-15.802 4.854-24.47 0-35.346-28.652-64-64-64-35.346 0-64 28.654-64 64s28.654 64 64 64c2.842 0 5.632-0.204 8.376-0.564l147.912 192.564h-440.574l147.912-192.564c2.742 0.36 5.534 0.564 8.374 0.564 35.346 0 64-28.654 64-64s-28.654-64-64-64-64 28.654-64 64c0 8.668 1.732 16.93 4.854 24.468l-177.842 231.532h-211.012v128h64l64 512h768l64-512h64v-128h-211.012zM320 896h-128v-128h128v128zM320 640h-128v-128h128v128zM576 896h-128v-128h128v128zM576 640h-128v-128h128v128zM832 896h-128v-128h128v128zM832 640h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"basket",
						"cart",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59910,
					"grid": 16
				},
				{
					"id": 2644,
					"paths": [
						"M958.912 512c-6.922-105.14-47.7-201.022-111.526-276.864-7.5 6.494-14.802 13.28-21.886 20.364-69.468 69.468-110.786 159.58-118.256 256.5h251.668zM796.99 183.61c-77.064-67.836-176.056-111.35-284.99-118.524v446.914h123.088c8.602-130.654 69.464-247.016 161.902-328.39zM134.5 255.5c-7.084-7.084-14.388-13.872-21.886-20.364-63.826 75.842-104.604 171.724-111.528 276.864h251.668c-7.468-96.92-48.786-187.032-118.254-256.5zM324.914 512h123.086v-446.914c-108.932 7.174-207.926 50.688-284.99 118.524 92.438 81.374 153.3 197.736 161.904 328.39zM825.5 832.5c7.084 7.084 14.388 13.872 21.886 20.366 63.826-75.842 104.604-171.724 111.526-276.866h-251.668c7.47 96.92 48.788 187.032 118.256 256.5zM635.088 576h-123.088v446.912c108.934-7.172 207.926-50.686 284.99-118.522-92.438-81.372-153.3-197.734-161.902-328.39zM1.086 576c6.922 105.14 47.7 201.024 111.526 276.864 7.5-6.492 14.802-13.28 21.886-20.364 69.468-69.468 110.786-159.58 118.256-256.5h-251.668zM163.010 904.39c77.064 67.836 176.058 111.35 284.99 118.522v-446.912h-123.086c-8.604 130.654-69.468 247.018-161.904 328.39z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"basketball",
						"soprts",
						"sports",
						"ball",
						"game"
					],
					"defaultCode": 60479,
					"grid": 16
				},
				{
					"id": 3183,
					"width": 1088,
					"paths": [
						"M896 256h-832c-35.2 0-64 28.8-64 64v512c0 35.2 28.798 64 64 64h832c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64zM896 832h-832v-512h832v512z",
						"M1056 448h-64v256h64c17.674 0 32-14.328 32-32v-192c0-17.672-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-0",
						"battery",
						"battery-empty"
					],
					"defaultCode": 61018,
					"grid": 16
				},
				{
					"id": 1707,
					"width": 1316.57368850708,
					"paths": [
						"M1243.429 329.143q30.286 0 51.714 21.429t21.429 51.714v219.429q0 30.286-21.429 51.714t-51.714 21.429v91.429q0 37.714-26.857 64.571t-64.571 26.857h-1060.571q-37.714 0-64.571-26.857t-26.857-64.571v-548.571q0-37.714 26.857-64.571t64.571-26.857h1060.571q37.714 0 64.571 26.857t26.857 64.571v91.429zM1243.429 621.714v-219.429h-73.143v-164.571q0-8-5.143-13.143t-13.143-5.143h-1060.571q-8 0-13.143 5.143t-5.143 13.143v548.571q0 8 5.143 13.143t13.143 5.143h1060.571q8 0 13.143-5.143t5.143-13.143v-164.571h73.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-0",
						"battery-empty"
					],
					"defaultCode": 62020,
					"grid": 14
				},
				{
					"id": 3182,
					"width": 1088,
					"paths": [
						"M128 384h128v384h-128v-384z",
						"M896 256h-832c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h832c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64zM896 832h-832v-512h832v512z",
						"M1056 448h-64v256h64c17.674 0 32-14.328 32-32v-192c0-17.672-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-1",
						"battery",
						"low"
					],
					"defaultCode": 61017,
					"grid": 16
				},
				{
					"id": 1706,
					"width": 1316.57368850708,
					"paths": [
						"M146.286 731.429v-438.857h292.571v438.857h-292.571zM1243.429 329.143q30.286 0 51.714 21.429t21.429 51.714v219.429q0 30.286-21.429 51.714t-51.714 21.429v91.429q0 37.714-26.857 64.571t-64.571 26.857h-1060.571q-37.714 0-64.571-26.857t-26.857-64.571v-548.571q0-37.714 26.857-64.571t64.571-26.857h1060.571q37.714 0 64.571 26.857t26.857 64.571v91.429zM1243.429 621.714v-219.429h-73.143v-164.571q0-8-5.143-13.143t-13.143-5.143h-1060.571q-8 0-13.143 5.143t-5.143 13.143v548.571q0 8 5.143 13.143t13.143 5.143h1060.571q8 0 13.143-5.143t5.143-13.143v-164.571h73.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-1",
						"battery-quarter"
					],
					"defaultCode": 62019,
					"grid": 14
				},
				{
					"id": 3181,
					"width": 1088,
					"paths": [
						"M128 384h256v384h-256v-384z",
						"M896 256h-832c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h832c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64zM896 832h-832v-512h832v512z",
						"M1056 448h-64v256h64c17.674 0 32-14.328 32-32v-192c0-17.672-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-2",
						"battery",
						"low"
					],
					"defaultCode": 61016,
					"grid": 16
				},
				{
					"id": 1705,
					"width": 1316.57368850708,
					"paths": [
						"M146.286 731.429v-438.857h512v438.857h-512zM1243.429 329.143q30.286 0 51.714 21.429t21.429 51.714v219.429q0 30.286-21.429 51.714t-51.714 21.429v91.429q0 37.714-26.857 64.571t-64.571 26.857h-1060.571q-37.714 0-64.571-26.857t-26.857-64.571v-548.571q0-37.714 26.857-64.571t64.571-26.857h1060.571q37.714 0 64.571 26.857t26.857 64.571v91.429zM1243.429 621.714v-219.429h-73.143v-164.571q0-8-5.143-13.143t-13.143-5.143h-1060.571q-8 0-13.143 5.143t-5.143 13.143v548.571q0 8 5.143 13.143t13.143 5.143h1060.571q8 0 13.143-5.143t5.143-13.143v-164.571h73.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-2",
						"battery-half"
					],
					"defaultCode": 62018,
					"grid": 14
				},
				{
					"id": 3180,
					"width": 1088,
					"paths": [
						"M128 384h384v384h-384v-384z",
						"M896 256h-832c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h832c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64zM896 832h-832v-512h832v512z",
						"M1056 448h-64v256h64c17.674 0 32-14.328 32-32v-192c0-17.672-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-3",
						"battery"
					],
					"defaultCode": 61015,
					"grid": 16
				},
				{
					"id": 1704,
					"width": 1316.57368850708,
					"paths": [
						"M146.286 731.429v-438.857h731.429v438.857h-731.429zM1243.429 329.143q30.286 0 51.714 21.429t21.429 51.714v219.429q0 30.286-21.429 51.714t-51.714 21.429v91.429q0 37.714-26.857 64.571t-64.571 26.857h-1060.571q-37.714 0-64.571-26.857t-26.857-64.571v-548.571q0-37.714 26.857-64.571t64.571-26.857h1060.571q37.714 0 64.571 26.857t26.857 64.571v91.429zM1243.429 621.714v-219.429h-73.143v-164.571q0-8-5.143-13.143t-13.143-5.143h-1060.571q-8 0-13.143 5.143t-5.143 13.143v548.571q0 8 5.143 13.143t13.143 5.143h1060.571q8 0 13.143-5.143t5.143-13.143v-164.571h73.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-3",
						"battery-three-quarters"
					],
					"defaultCode": 62017,
					"grid": 14
				},
				{
					"id": 3179,
					"width": 1088,
					"paths": [
						"M128 384h512v384h-512v-384z",
						"M896 256h-832c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h832c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64zM896 832h-832v-512h832v512z",
						"M1056 448h-64v256h64c17.674 0 32-14.328 32-32v-192c0-17.672-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-4",
						"battery"
					],
					"defaultCode": 61014,
					"grid": 16
				},
				{
					"id": 1703,
					"width": 1316.571979522705,
					"paths": [
						"M1097.143 292.571v438.857h-950.857v-438.857h950.857zM1170.286 621.714h73.143v-219.429h-73.143v-164.571q0-8-5.143-13.143t-13.143-5.143h-1060.571q-8 0-13.143 5.143t-5.143 13.143v548.571q0 8 5.143 13.143t13.143 5.143h1060.571q8 0 13.143-5.143t5.143-13.143v-164.571zM1316.571 402.286v219.429q0 30.286-21.429 51.714t-51.714 21.429v91.429q0 37.714-26.857 64.571t-64.571 26.857h-1060.571q-37.714 0-64.571-26.857t-26.857-64.571v-548.571q0-37.714 26.857-64.571t64.571-26.857h1060.571q37.714 0 64.571 26.857t26.857 64.571v91.429q30.286 0 51.714 21.429t21.429 51.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-4",
						"battery-full"
					],
					"defaultCode": 62016,
					"grid": 14
				},
				{
					"id": 3178,
					"width": 1088,
					"paths": [
						"M128 384h640v384h-640v-384z",
						"M896 256h-832c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h832c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64zM896 832h-832v-512h832v512z",
						"M1056 448h-64v256h64c17.674 0 32-14.328 32-32v-192c0-17.672-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-5",
						"battery"
					],
					"defaultCode": 61013,
					"grid": 16
				},
				{
					"id": 3177,
					"width": 1088,
					"paths": [
						"M128 384h704v384h-704v-384z",
						"M896 256h-832c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h832c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64zM896 832h-832v-512h832v512z",
						"M1056 448h-64v256h64c17.674 0 32-14.328 32-32v-192c0-17.672-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-6",
						"battery",
						"battery-full"
					],
					"defaultCode": 61012,
					"grid": 16
				},
				{
					"id": 3184,
					"width": 1088,
					"paths": [
						"M1056 448h-64v256h64c17.674 0 32-14.328 32-32v-192c0-17.672-14.326-32-32-32z",
						"M896 256h-231.832l-31.418 64h263.25v512h-369.54l-52 64h421.54c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64z",
						"M315.838 832h-251.838v-512h366.040l51.2-64h-417.24c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h218.506l33.332-64z",
						"M704 512h-236.8l172.8-352-384 480h232l-200 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battery-charging",
						"battery"
					],
					"defaultCode": 61019,
					"grid": 16
				},
				{
					"id": 307,
					"width": 1024,
					"paths": [
						"M964.672 846.048l-137.376-137.376 71.424-71.424c24.992-24.992 24.992-65.504 0-90.496l-5.504-5.504c-12.512-12.512-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-71.072 71.072-294.656-500.992c-17.152-29.184-48.896-47.328-82.752-47.328h-258.24c-17.632 0-32 14.368-32 32v258.24c0 33.856 18.144 65.568 47.328 82.752l500.992 294.688-71.072 71.072c-24.992 24.992-24.992 65.504 0 90.496l5.504 5.504c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l71.424-71.424 137.376 137.376c9.344 9.344 21.632 14.016 33.952 14.016s24.576-4.672 33.952-14.016l50.752-50.752c18.688-18.72 18.688-49.184-0.032-67.904zM354.24 96c22.592 0 43.712 12.096 55.168 31.552l298.752 508.288-24.864 24.864-564.672-564.704h235.616zM127.552 409.408c-19.456-11.424-31.552-32.576-31.552-55.168v-235.616l564.672 564.672-24.992 24.992-508.128-298.88zM614.624 876.128c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376l-5.504-5.504c-12.48-12.48-12.48-32.768 0-45.248l261.504-261.504c6.048-6.048 14.080-9.376 22.624-9.376s16.576 3.328 22.624 9.376l5.504 5.504c12.48 12.48 12.48 32.768 0 45.248l-261.504 261.504zM942.048 891.328l-50.752 50.752c-6.24 6.24-16.384 6.24-22.624 0l-137.376-137.376 73.376-73.376 137.376 137.376c6.24 6.208 6.24 16.384 0 22.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battle",
						"fight",
						"clash",
						"defend"
					],
					"grid": 32
				},
				{
					"id": 308,
					"width": 1024,
					"paths": [
						"M964.672 913.952l-50.752 50.752c-9.344 9.344-21.632 14.016-33.952 14.016s-24.576-4.672-33.952-14.016l-137.376-137.376-71.424 71.424c-12.512 12.512-28.864 18.752-45.248 18.752s-32.768-6.24-45.248-18.752l-5.504-5.504c-24.992-24.992-24.992-65.504 0-90.496l261.504-261.504c12.512-12.512 28.864-18.752 45.248-18.752s32.768 6.24 45.248 18.752l5.504 5.504c24.992 24.992 24.992 65.504 0 90.496l-71.424 71.424 137.376 137.376c18.72 18.72 18.72 49.184 0 67.904zM714.912 583.808l-131.104 131.104-472.48-277.92c-29.184-17.152-47.328-48.896-47.328-82.752v-258.24c0-17.632 14.368-32 32-32h258.24c33.856 0 65.568 18.144 82.752 47.328l277.92 472.48zM619.328 619.328c6.24-6.24 6.24-16.384 0-22.624l-496-496c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l496 496c3.104 3.104 7.2 4.672 11.296 4.672s8.192-1.568 11.328-4.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"battle",
						"fight",
						"clash",
						"defend"
					],
					"grid": 32
				},
				{
					"id": 309,
					"width": 1024,
					"paths": [
						"M672 260.736v-95.232c0-66.848-48.864-126.56-115.424-132.896-76.352-7.296-140.576 52.544-140.576 127.392 0 49.152 28.032 91.328 68.672 112.8-173.472 47.2-278.752 186.048-312.416 279.104l-103.136 41.248c-13.408 5.376-13.408 24.352 0 29.696l103.136 41.248c43.008 118.848 202.464 313.536 472.064 294.624 195.52-13.728 356.288-172.64 347.296-368.416-8.352-180.672-143.776-305.12-319.616-329.568zM256 750.848c-42.24-55.712-64-110.976-64-142.848s21.76-87.136 64-142.848v285.696zM544 256c-52.928 0-96-43.072-96-96s43.072-96 96-96c52.928 0 96 43.072 96 96v96h-96zM352 844.992c-24.064-17.504-45.28-36.704-64-56.576v-360.864c18.72-19.84 39.936-39.040 64-56.576v474.016zM448 897.536c-22.784-8.992-44.224-19.456-64-31.392v-516.288c19.776-11.936 41.216-22.368 64-31.392v579.072zM544 922.944c-22.368-3.232-43.712-7.968-64-14.144v-601.6c20.288-6.208 41.632-10.944 64-14.144v629.888zM640 926.688c-10.528 0.736-21.152 1.312-32 1.312-11.008 0-21.44-0.992-32-1.728v-636.544c10.56-0.736 20.992-1.728 32-1.728 10.848 0 21.472 0.576 32 1.312v637.376zM736 908.16c-20.352 6.592-41.696 11.648-64 14.912v-630.144c22.304 3.296 43.648 8.32 64 14.912v600.32zM768 896.16v-576.32c116.768 50.272 192 156.192 192 288.16s-75.232 237.888-192 288.16zM864 544c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32 32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"be",
						"fly",
						"pollenate",
						"buzz",
						"bumble"
					],
					"grid": 32
				},
				{
					"id": 310,
					"width": 1024,
					"paths": [
						"M672 260.736v-95.232c0-66.848-48.864-126.56-115.424-132.896-76.352-7.296-140.576 52.544-140.576 127.392 0 49.152 28.032 91.328 68.672 112.8-173.472 47.2-278.752 186.048-312.416 279.104l-103.136 41.248c-13.408 5.376-13.408 24.352 0 29.696l103.136 41.248c43.008 118.848 202.464 313.536 472.064 294.592 195.52-13.728 356.288-172.64 347.296-368.416-8.352-180.64-143.776-305.12-319.616-329.536zM256 697.504c0 15.296-19.904 21.184-28.256 8.352-1.76-2.688-2.976-4.608-3.36-5.312-0.128-0.224-0.384-0.704-0.384-0.704v-183.616c0.16-0.256 0.416-0.768 0.416-0.768l3.392-5.152c8.416-12.736 28.192-6.784 28.192 8.448v178.752zM352 812.096c0 13.12-15.328 20.096-25.376 11.648-0.448-0.352-0.864-0.736-1.312-1.088-3.424-2.912-5.312-7.2-5.312-11.648v-406.016c0-4.48 1.888-8.768 5.312-11.648 0.416-0.352 0.864-0.736 1.312-1.088 10.048-8.448 25.376-1.472 25.376 11.648v408.192zM448 873.696c0 11.104-11.52 18.688-21.6 14.048-0.576-0.256-1.12-0.512-1.696-0.8-5.376-2.496-8.704-7.936-8.704-13.856v-530.112c0-5.92 3.328-11.36 8.704-13.856 0.576-0.256 1.12-0.512 1.696-0.8 10.080-4.672 21.6 2.912 21.6 14.016v531.36zM544 904.448c0 9.568-8.672 16.896-18.080 15.136-0.416-0.096-0.864-0.16-1.28-0.224-7.296-1.376-12.64-7.712-12.64-15.136v-592.416c0-7.424 5.344-13.76 12.64-15.136 0.416-0.096 0.864-0.16 1.28-0.224 9.408-1.728 18.080 5.568 18.080 15.136v592.864zM640 912.064c0 8.256-6.56 15.072-14.816 15.36v0c-8.672 0.32-15.872-6.624-15.904-15.328l-1.248-608.064c-0.032-8.672 7.168-15.648 15.84-15.392l1.248 0.032c8.288 0.288 14.88 7.072 14.88 15.36v608.032zM736 895.584c0 6.784-4.448 12.736-10.912 14.688l-1.28 0.384c-9.856 3.008-19.808-4.384-19.808-14.688v-575.872c0-10.304 9.952-17.696 19.808-14.688l1.28 0.384c6.496 1.952 10.912 7.936 10.912 14.688v575.104zM832 576c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"be",
						"fly",
						"pollenate",
						"buzz",
						"bumble"
					],
					"grid": 32
				},
				{
					"id": 961,
					"width": 1024,
					"paths": [
						"M800 576c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM1024 672c0 194.4-157.6 352-352 352-260.512 0-499.776-233.28-579.744-320h-92.256v-64h92.256c47.68-51.712 152-155.36 283.616-230.752-152.832-0.736-356.608-30.944-262.048-198.752 22.88-40.608 48.736-63.584 76.096-73.568 88.768-32.32 193.088 72.672 261.248 159.904-3.84-110.624 8.576-258.080 97.344-290.4 27.36-9.952 61.952-8.96 105.568 7.424 176.224 66.24 49.664 214.912-65.024 313.888 27.296-4.928 54.976-7.744 82.944-7.744 194.4 0 352 157.6 352 352zM416 883.84c30.784 17.184 62.848 32.608 96 44.96v-513.728c-33.152 12.288-65.248 27.68-96 44.832v423.936zM384 478.592c-34.368 21.184-66.592 44.128-96 67.264v251.968c29.408 23.136 61.664 46.080 96 67.296v-386.528zM544 939.648c31.424 9.568 63.552 15.936 96 18.624v-572.544c-32.48 2.656-64.576 8.992-96 18.528v535.392zM515.456 305.824c123.936-99.456 165.376-171.968 161.696-198.56-2.208-16.032-35.456-29.696-45.6-33.536-26.048-9.792-47.168-12.288-61.152-7.2-33.184 12.128-61.984 91.68-54.944 239.296zM407.712 345.056c-89.504-117.632-162.688-160.064-195.904-147.968-13.952 5.088-28.544 20.576-42.208 44.8-5.312 9.44-22.016 41.312-13.376 55.008 14.272 22.72 92.608 51.616 251.488 48.16zM256 771.744v-199.776c-44.704 37.76-81.248 73.824-105.984 99.968 24.736 26.080 61.28 62.112 105.984 99.808zM960 672c0-158.816-129.184-288-288-288v576c158.816 0 288-129.184 288-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"be",
						"fly",
						"pollenate",
						"buzz"
					],
					"grid": 32
				},
				{
					"id": 311,
					"width": 1024,
					"paths": [
						"M864 160h-704c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-512c0-53.024-42.976-96-96-96zM928 768c0 35.296-28.704 64-64 64h-704c-35.296 0-64-28.704-64-64v-512c0-35.296 28.704-64 64-64h704c35.296 0 64 28.704 64 64v512zM800 496c0 8.832-7.168 16-16 16h-80c-6.88 0-12.992-4.416-15.2-10.944l-16.8-50.464-48.8 146.464c-2.208 6.56-8.352 10.944-15.2 10.944-0.32 0-0.672 0-0.992-0.032-7.264-0.448-13.28-5.728-14.688-12.832l-45.696-228.416-18.784 131.52c-1.12 7.904-7.872 13.76-15.84 13.76h-96c-6.88 0-12.992-4.416-15.2-10.944l-16.8-50.464-48.8 146.464c-2.272 6.848-8.288 11.328-16.192 10.912-7.264-0.448-13.28-5.728-14.688-12.832l-45.696-228.416-18.784 131.52c-1.12 7.904-7.872 13.76-15.84 13.76h-80c-8.832 0-16-7.168-16-16s7.168-16 16-16h66.112l30.016-210.272c1.12-7.712 7.616-13.504 15.424-13.728 7.936-0.192 14.592 5.216 16.128 12.864l52.192 260.928 44.928-134.848c4.384-13.056 25.984-13.056 30.368 0l28.352 85.056h70.592l30.016-210.272c1.12-7.712 7.616-13.504 15.424-13.728 8.256-0.192 14.592 5.216 16.128 12.864l52.192 260.928 44.928-134.848c4.384-13.056 25.984-13.056 30.368 0l28.352 85.056h68.48c8.832 0 16 7.168 16 16zM784 720c0 8.832-7.168 16-16 16h-121.376l-27.328 27.328c-3.104 3.104-7.2 4.672-11.296 4.672s-8.192-1.568-11.328-4.672l-52.672-52.704-20.672 20.672c-3.008 3.008-7.072 4.704-11.328 4.704h-153.376l-27.328 27.328c-6.24 6.24-16.384 6.24-22.624 0l-52.672-52.704-20.672 20.672c-3.008 3.008-7.072 4.704-11.328 4.704h-80c-8.832 0-16-7.168-16-16s7.168-16 16-16h73.376l27.328-27.328c6.24-6.24 16.384-6.24 22.624 0l52.672 52.704 20.672-20.672c3.008-3.008 7.072-4.704 11.328-4.704h153.376l27.328-27.328c6.24-6.24 16.384-6.24 22.624 0l52.672 52.704 20.672-20.672c3.008-3.008 7.072-4.704 11.328-4.704h128c8.832 0 16 7.168 16 16zM896 480c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM896 704c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"beat",
						"live",
						"monitor"
					],
					"grid": 32
				},
				{
					"id": 312,
					"width": 1024,
					"paths": [
						"M864 160h-704c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-512c0-53.024-42.976-96-96-96zM768 736h-121.376l-27.328 27.328c-3.104 3.104-7.2 4.672-11.296 4.672s-8.192-1.568-11.328-4.672l-52.672-52.704-20.672 20.672c-3.008 3.008-7.072 4.704-11.328 4.704h-153.376l-27.328 27.328c-6.24 6.24-16.384 6.24-22.624 0l-52.672-52.704-20.672 20.672c-3.008 3.008-7.072 4.704-11.328 4.704h-80c-8.832 0-16-7.168-16-16s7.168-16 16-16h73.376l27.328-27.328c6.24-6.24 16.384-6.24 22.624 0l52.672 52.704 20.672-20.672c3.008-3.008 7.072-4.704 11.328-4.704h153.376l27.328-27.328c6.24-6.24 16.384-6.24 22.624 0l52.672 52.704 20.672-20.672c3.008-3.008 7.072-4.704 11.328-4.704h128c8.832 0 16 7.168 16 16s-7.168 16-16 16zM784 512h-80c-6.88 0-12.992-4.416-15.2-10.944l-16.8-50.464-48.8 146.464c-2.208 6.56-8.352 10.944-15.2 10.944-0.32 0-0.672 0-0.992-0.032-7.264-0.448-13.28-5.728-14.688-12.832l-45.696-228.416-18.784 131.52c-1.12 7.904-7.872 13.76-15.84 13.76h-96c-6.88 0-12.992-4.416-15.2-10.944l-16.8-50.464-48.8 146.464c-2.272 6.848-8.288 11.328-16.192 10.912-7.264-0.448-13.28-5.728-14.688-12.832l-45.696-228.416-18.784 131.52c-1.12 7.904-7.872 13.76-15.84 13.76h-80c-8.832 0-16-7.168-16-16s7.168-16 16-16h66.112l30.016-210.272c1.12-7.712 7.616-13.504 15.424-13.728 7.936-0.192 14.592 5.216 16.128 12.864l52.192 260.928 44.928-134.848c4.384-13.056 25.984-13.056 30.368 0l28.352 85.056h70.592l30.016-210.272c1.12-7.712 7.616-13.504 15.424-13.728 8.256-0.192 14.592 5.216 16.128 12.864l52.192 260.928 44.928-134.848c4.384-13.056 25.984-13.056 30.368 0l28.352 85.056h68.48c8.832 0 16 7.168 16 16s-7.168 16-16 16zM864 736c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM864 512c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"beat",
						"live",
						"monitor"
					],
					"grid": 32
				},
				{
					"id": 2801,
					"paths": [
						"M960 320c-35.348 0-64 28.654-64 64v192h-672c-53.020 0-96-42.98-96-96v-288c0-35.346-28.654-64-64-64s-64 28.654-64 64v640h128v-128h768v128h128v-448c0-35.346-28.654-64-64-64z",
						"M352 432c0 61.856-50.144 112-112 112s-112-50.144-112-112c0-61.856 50.144-112 112-112s112 50.144 112 112z",
						"M800 384h-320c-53.020 0-96 42.98-96 96v64h512v-64c0-53.020-42.98-96-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bed",
						"sleep",
						"hotel",
						"room",
						"night"
					],
					"defaultCode": 60636,
					"grid": 16
				},
				{
					"id": 2802,
					"paths": [
						"M0 896h128v128h128v-128h512v128h128v-128h128v-64h-1024zM832 320h-640l-192 448h1024zM352 256c88.366 0 160 28.654 160 64 0-35.346 71.634-64 160-64s160 28.654 160 64v-256c0-35.346-28.652-64-64-64h-512c-35.346 0-64 28.654-64 64v256c0-35.346 71.636-64 160-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bed",
						"sleep",
						"hotel",
						"room",
						"night"
					],
					"defaultCode": 60637,
					"grid": 16
				},
				{
					"id": 1694,
					"width": 1170.2860412597656,
					"paths": [
						"M146.286 585.143h987.429q14.857 0 25.714 10.857t10.857 25.714v256h-146.286v-146.286h-877.714v146.286h-146.286v-694.857q0-14.857 10.857-25.714t25.714-10.857h73.143q14.857 0 25.714 10.857t10.857 25.714v402.286zM475.429 402.286q0-60.571-42.857-103.429t-103.429-42.857-103.429 42.857-42.857 103.429 42.857 103.429 103.429 42.857 103.429-42.857 42.857-103.429zM1170.286 548.571v-36.571q0-90.857-64.286-155.143t-155.143-64.286h-402.286q-14.857 0-25.714 10.857t-10.857 25.714v219.429h658.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bed",
						"hotel"
					],
					"defaultCode": 62006,
					"grid": 14
				},
				{
					"id": 1404,
					"width": 987.4279632568359,
					"paths": [
						"M365.714 512v-219.429h-146.286v146.286q0 30.286 21.429 51.714t51.714 21.429h73.143zM950.857 768v109.714h-658.286v-109.714l73.143-109.714h-73.143q-90.857 0-155.143-64.286t-64.286-155.143v-182.857l-36.571-36.571 18.286-73.143h274.286l18.286-73.143h548.571l18.286 109.714-36.571 18.286v457.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"beer"
					],
					"defaultCode": 61692,
					"grid": 14
				},
				{
					"id": 3356,
					"paths": [
						"M297 205.2c30.2 0 57.4 2.6 82.2 8 24.8 5.2 45.8 14 63.6 26 17.6 12 31.2 28 41.2 48 9.6 19.8 14.4 44.6 14.4 74 0 31.8-7.2 58.2-21.6 79.4-14.6 21.2-35.8 38.4-64.2 52 38.8 11.2 67.4 30.8 86.6 58.6 19.2 28 28.4 61.6 28.4 101.2 0 32-6.2 59.4-18.4 82.6-12.4 23.4-29.2 42.4-49.8 57-20.8 14.8-44.8 25.6-71.6 32.6-26.6 7-54 10.6-82.4 10.6h-305.4v-630h297zM279 459.6c24.6 0 45-5.8 61-17.6 16-11.6 23.6-30.8 23.6-57.2 0-14.6-2.6-26.8-7.8-36.2-5.4-9.4-12.4-16.8-21.4-22-8.8-5.4-18.8-9-30.6-11-11.4-2.2-23.4-3.2-35.6-3.2h-129.6v147.2h140.4zM286.6 727.8c13.6 0 26.6-1.2 38.8-4 12.4-2.8 23.4-7 32.6-13.4 9.2-6.2 17-14.4 22.6-25.2 5.6-10.6 8.2-24.2 8.2-40.8 0-32.4-9.2-55.6-27.4-69.6-18.2-13.8-42.4-20.6-72.4-20.6h-150.4v173.4h148z",
						"M725.2 725.6c18.8 18.4 45.8 27.6 81 27.6 25.2 0 47.2-6.4 65.4-19.2s29.2-26.4 33.4-40.4h110.4c-17.8 55-44.6 94-81.4 117.6-36.2 23.6-80.6 35.6-132 35.6-36 0-68.2-5.8-97.2-17.2-29-11.6-53.2-27.8-73.6-49-19.8-21.2-35.4-46.4-46.4-76-10.8-29.4-16.4-62-16.4-97.2 0-34.2 5.6-66 16.8-95.4 11.4-29.6 27-55 47.8-76.4s45.2-38.4 74-50.8c28.6-12.4 60.2-18.6 95.2-18.6 38.6 0 72.4 7.4 101.4 22.6 28.8 15 52.6 35.2 71.2 60.4s31.8 54.2 40 86.6c8.2 32.4 11 66.2 8.8 101.6h-329.4c0 35.8 12 70 31 88.2zM869 486c-14.8-16.4-40.2-25.4-70.8-25.4-20 0-36.6 3.4-49.8 10.2-13 6.8-23.6 15.2-31.8 25.2-8 10-13.6 20.8-16.8 32.2-3.2 11-5.2 21.2-5.8 30h204c-3-32-14-55.6-29-72.2z",
						"M668.4 256h255.4v62.2h-255.4v-62.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"behance",
						"brand",
						"social"
					],
					"defaultCode": 61191,
					"grid": 16
				},
				{
					"id": 1575,
					"width": 877.7150573730469,
					"paths": [
						"M713.143 73.143q68 0 116.286 48.286t48.286 116.286v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571zM285.143 282.857h-212v449.714h218.286q66.857 0 112.571-32.857t45.714-97.429q0-90.286-81.714-114.286 61.143-29.714 61.143-93.714 0-32.571-11.143-55.143t-32.286-34.571-45.143-16.857-55.429-4.857zM272.571 464.571h-100.571v-105.143h93.143q68 0 68 51.429 0 53.714-60.571 53.714zM277.714 656h-105.714v-124h108q70.857 0 70.857 64.571 0 59.429-73.143 59.429zM649.143 674.286q-38.857 0-59.429-21.714t-20.571-61.143h234.857q0.571-5.714 0.571-17.143 0-75.429-42.571-126t-116.286-50.571q-73.143 0-120 49.143t-46.857 123.429q0 77.143 45.143 124t121.714 46.857q117.143 0 152.571-109.143h-78.857q-6.286 19.429-27.143 30.857t-43.143 11.429zM643.429 465.143q64.571 0 70.857 69.714h-145.143q2.286-32 22.286-50.857t52-18.857zM550.857 313.143h182.286v44h-182.286v-44z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"behance-square"
					],
					"defaultCode": 61877,
					"grid": 14
				},
				{
					"id": 3357,
					"paths": [
						"M404.2 448.6c13-9.4 19.2-25 19.2-46.6 0-12-2-21.8-6.2-29.4-4.4-7.6-10-13.6-17.4-17.8-7.2-4.4-15.4-7.4-24.8-9-9.2-1.8-19-2.6-29-2.6h-105.4v119.6h114c20 0.2 36.6-4.6 49.6-14.2z",
						"M422 556.6c-14.8-11.2-34.4-16.8-58.8-16.8h-122.6v141h120.2c11.2 0 21.6-1 31.6-3.2s19-5.6 26.6-10.8c7.6-5 13.8-11.8 18.4-20.4s6.8-19.8 6.8-33.2c0-26.4-7.4-45.2-22.2-56.6z",
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM671.2 269.4h207.4v50.6h-207.4v-50.6zM541.6 686.4c-10 19-23.6 34.4-40.4 46.4-17 12-36.4 20.8-58.2 26.6-21.6 5.8-44 8.6-66.8 8.6h-248.2v-511.8h241.2c24.4 0 46.6 2.2 66.8 6.4 20 4.2 37.2 11.4 51.6 21.2 14.2 9.8 25.4 22.8 33.4 39 7.8 16 11.8 36.2 11.8 60 0 25.8-5.8 47.2-17.6 64.4s-29 31.2-52.2 42.2c31.6 9 54.8 25 70.2 47.6 15.6 22.8 23.2 50.2 23.2 82.2 0.2 26.2-4.8 48.6-14.8 67.2zM959.4 607.2h-267.4c0 29.2 10 57 25.2 72 15.2 14.8 37.2 22.4 65.8 22.4 20.6 0 38.2-5.2 53.2-15.6 14.8-10.4 23.8-21.4 27.2-32.8h89.6c-14.4 44.6-36.2 76.4-66 95.6-29.4 19.2-65.4 28.8-107.2 28.8-29.2 0-55.4-4.8-79-14-23.6-9.4-43.2-22.6-59.8-39.8-16.2-17.2-28.6-37.8-37.6-61.8-8.8-23.8-13.4-50.4-13.4-79 0-27.8 4.6-53.6 13.6-77.6 9.2-24 22-44.8 38.8-62 16.8-17.4 36.8-31.2 60-41.4 23.2-10 48.8-15 77.2-15 31.4 0 58.8 6 82.4 18.4 23.4 12.2 42.6 28.6 57.8 49.2s25.8 44 32.6 70.4c6.6 26 8.8 53.4 7 82.2z",
						"M776.6 463.8c-16.2 0-29.8 2.8-40.4 8.4s-19.2 12.4-25.8 20.4c-6.6 8.2-11 16.8-13.6 26.2-2.6 9-4.2 17.2-4.6 24.4h165.6c-2.4-26-11.4-45.2-23.4-58.6-12.4-13.6-32.8-20.8-57.8-20.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"behance",
						"brand",
						"social"
					],
					"defaultCode": 61192,
					"grid": 16
				},
				{
					"id": 1574,
					"width": 1170.2869873046875,
					"paths": [
						"M1056 193.714h-292v70.857h292v-70.857zM912 437.143q-51.429 0-83.429 30t-35.429 81.429h233.143q-10.286-111.429-114.286-111.429zM921.143 771.429q36 0 69.714-18.286t43.429-49.714h126.286q-57.143 175.429-244 175.429-122.286 0-194.571-75.429t-72.286-198.286q0-118.857 74.571-197.429t192.286-78.571q78.857 0 137.429 38.857t87.429 102.286 28.857 141.714q0 9.714-1.143 26.857h-376q0 63.429 32.857 98t95.143 34.571zM158.286 742.857h169.143q117.143 0 117.143-95.429 0-102.857-113.714-102.857h-172.571v198.286zM158.286 436h160.571q44.571 0 70.571-20.857t26-64.857q0-82.286-108.571-82.286h-148.571v168zM0 145.143h339.429q49.714 0 88.571 8t72.286 27.143 51.429 55.143 18 88q0 103.429-98.286 150.286 65.143 18.286 98.286 65.714t33.143 116.571q0 42.857-14 78t-37.714 59.143-56.286 40.571-69.143 24-76.571 7.429h-349.143v-720z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"behance"
					],
					"defaultCode": 61876,
					"grid": 14
				},
				{
					"id": 313,
					"width": 1024,
					"paths": [
						"M544 224c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM448 256c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM817.952 828.832l10.272 95.744c2.016 18.912-12.8 35.424-31.808 35.424h-220.416c-17.664 0-32-14.336-32-32v-32c0-17.664-14.336-32-32-32s-32 14.336-32 32v32c0 17.664-14.336 32-32 32h-220.384c-19.008 0-33.856-16.512-31.808-35.424l10.272-95.744c-87.68-17.056-147.008-104.96-124.352-195.648l43.648-174.56c21.408-85.6 73.408-156.8 142.24-204.16l2.016-18.912c10.432-97.568 92.768-171.552 190.88-171.552h102.944c98.112 0 180.448 73.984 190.912 171.552l2.016 18.912c68.864 47.392 120.864 118.592 142.24 204.16l43.648 174.56c22.688 90.688-36.64 178.592-124.32 195.648zM906.304 718.112c10.016-26.080 10.528-54.88 3.744-81.984l-42.432-169.728c-17.056-68.224-55.392-126.272-106.56-168.64l-34.176-18.656-4.32-40.16c-8.704-81.28-77.312-142.944-159.072-142.944h-102.944c-81.792 0-150.4 61.664-159.104 142.944l-4.288 40.128-34.208 18.688c-51.168 42.336-89.504 100.416-106.56 168.64l-42.432 169.792c-6.784 27.104-6.272 55.904 3.776 81.952 16.64 43.264 51.616 68.96 91.904 77.536l32.288-301.376c0.864-8.128 7.712-14.304 15.872-14.304 9.504 0 16.928 8.256 15.904 17.696l-46.080 430.304h220.384v-29.152c0-33.408 24.352-63.296 57.6-66.528 38.144-3.744 70.4 26.272 70.4 63.68v32h220.384l-46.112-430.304c-0.992-9.44 6.4-17.696 15.936-17.696 8.16 0 15.040 6.176 15.904 14.304l32.288 301.376c40.288-8.608 75.264-34.272 91.904-77.568zM672 640c0 106.048-53.952 160-160 160s-160-53.952-160-160 53.952-160 160-160 160 53.952 160 160zM640 640c0-88.512-39.488-128-128-128s-128 39.488-128 128 39.488 128 128 128 128-39.488 128-128zM400 352h224c8.832 0 16-7.168 16-16s-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"believe",
						"imagine",
						"stomp"
					],
					"grid": 32
				},
				{
					"id": 314,
					"width": 1024,
					"paths": [
						"M640 640c0 88.512-39.488 128-128 128s-128-39.488-128-128 39.488-128 128-128 128 39.488 128 128zM849.28 819.296l-35.008-324.992c-0.864-8.128-7.744-14.304-15.904-14.304-9.504 0-16.928 8.256-15.904 17.696l45.76 426.88c2.016 18.912-12.8 35.424-31.808 35.424h-220.416c-17.664 0-32-14.336-32-32v-32c0-17.664-14.336-32-32-32s-32 14.336-32 32v32c0 17.664-14.336 32-32 32h-220.384c-19.008 0-33.856-16.512-31.808-35.424l45.76-426.88c0.992-9.44-6.432-17.696-15.936-17.696-8.16 0-15.040 6.176-15.904 14.304l-35.008 324.992c-69.856-29.44-112.864-106.72-93.024-186.112l43.648-174.56c21.408-85.6 73.408-156.8 142.24-204.16l2.016-18.912c10.464-97.568 92.8-171.552 190.912-171.552h102.944c98.112 0 180.448 73.984 190.912 171.552l2.016 18.912c68.864 47.392 120.864 118.592 142.24 204.16l43.648 174.56c19.872 79.392-23.136 156.64-92.992 186.112zM544 224c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM416 224c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM384 336c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16zM672 640c0-106.048-53.952-160-160-160s-160 53.952-160 160 53.952 160 160 160 160-53.952 160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"believe",
						"imagine",
						"stomp"
					],
					"grid": 32
				},
				{
					"id": 962,
					"width": 1024,
					"paths": [
						"M788.768 290.176c-34.784-95.040-147.488-162.176-276.768-162.176s-241.984 67.136-276.768 162.176c-149.792 40.416-235.232 109.088-235.232 189.824 0 85.472 97.824 158.4 262.816 196.928 26.208 71.552 127.584 123.072 249.184 123.072s222.976-51.52 249.184-123.072c164.992-38.528 262.816-111.456 262.816-196.928 0-80.736-85.44-149.408-235.232-189.824zM736 352c0 59.584-25.472 128-224 128s-224-68.416-224-128c0-88.224 100.48-160 224-160s224 71.776 224 160zM64 480c0-47.52 72.736-98.368 192.128-129.664-0.032 0.544-0.128 1.088-0.128 1.664 0 128 114.624 160 256 160s256-32 256-160c0-0.576-0.096-1.12-0.128-1.696 119.392 31.328 192.128 82.176 192.128 129.696 0 75.68-184 160-448 160s-448-84.32-448-160zM512 736c-98.176 0-171.392-39.168-187.68-79.264 57.664 9.824 121.056 15.264 187.68 15.264s130.016-5.44 187.68-15.264c-16.288 40.096-89.504 79.264-187.68 79.264z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"believe",
						"abduct"
					],
					"grid": 32
				},
				{
					"id": 2156,
					"paths": [
						"M1025.5 800c0-288-256-224-256-448 0-18.56-1.788-34.42-5.048-47.928-16.83-113.018-92.156-203.72-189.772-231.36 0.866-3.948 1.32-8.032 1.32-12.21 0-33.278-28.8-60.502-64-60.502s-64 27.224-64 60.5c0 4.18 0.456 8.264 1.32 12.21-109.47 30.998-190.914 141.298-193.254 273.442-0.040 1.92-0.066 3.864-0.066 5.846 0 224.002-256 160.002-256 448.002 0 76.226 170.59 139.996 398.97 156.080 21.524 40.404 64.056 67.92 113.030 67.92s91.508-27.516 113.030-67.92c228.38-16.084 398.97-79.854 398.97-156.080 0-0.228-0.026-0.456-0.028-0.682l1.528 0.682zM826.246 854.096c-54.23 14.47-118.158 24.876-186.768 30.648-5.704-65.418-60.582-116.744-127.478-116.744s-121.774 51.326-127.478 116.744c-68.608-5.772-132.538-16.178-186.768-30.648-74.63-19.914-110.31-42.19-123.368-54.096 13.058-11.906 48.738-34.182 123.368-54.096 86.772-23.152 198.372-35.904 314.246-35.904s227.474 12.752 314.246 35.904c74.63 19.914 110.31 42.19 123.368 54.096-13.058 11.906-48.738 34.182-123.368 54.096z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell",
						"alarm",
						"notification"
					],
					"defaultCode": 59991,
					"grid": 16
				},
				{
					"id": 2161,
					"paths": [
						"M1024 832c-106.042 0-192-85.96-192-192v-285.090c0-140.738-109.942-258.128-256-285.084v-69.826h-128v69.824c-146.064 26.958-256 144.346-256 285.084v285.092c0 106.040-85.962 192-192 192v64h429.598c-5.208 11.424-8.11 24.118-8.11 37.49 0 49.986 40.524 90.51 90.512 90.51 49.984 0 90.51-40.524 90.51-90.51 0-13.376-2.9-26.066-8.112-37.49h429.602v-64zM448 739.782l-154.89-204.89 47.782-47.782 107.108 77.108 245.11-217.11 49.782 49.782-294.892 342.892z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell-check",
						"alarm"
					],
					"defaultCode": 59996,
					"grid": 16
				},
				{
					"id": 2162,
					"paths": [
						"M1024 832c-106.042 0-192-85.96-192-192v-285.090c0-140.738-109.942-258.128-256-285.084v-69.826h-128v69.824c-146.064 26.958-256 144.346-256 285.084v285.092c0 106.040-85.962 192-192 192v64h429.598c-5.208 11.424-8.11 24.118-8.11 37.49 0 49.986 40.524 90.51 90.512 90.51 49.984 0 90.51-40.524 90.51-90.51 0-13.376-2.9-26.066-8.112-37.49h429.602v-64zM704 608l-64 64-128-128-128 128-64-64 128-128-128-128 64-64 128 128 128-128 64 64-128 128 128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell-cross",
						"alarm",
						"alarm-cancel"
					],
					"defaultCode": 59997,
					"grid": 16
				},
				{
					"id": 2160,
					"paths": [
						"M1024 832c-106.042 0-192-85.96-192-192v-285.090c0-140.738-109.942-258.128-256-285.084v-69.826h-128v69.824c-146.064 26.958-256 144.346-256 285.084v285.092c0 106.040-85.962 192-192 192v64h429.598c-5.208 11.424-8.11 24.118-8.11 37.49 0 49.986 40.524 90.51 90.512 90.51 49.984 0 90.51-40.524 90.51-90.51 0-13.376-2.9-26.066-8.112-37.49h429.602v-64zM704 576h-384v-128h384v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell-minus",
						"alarm",
						"alarm-remove"
					],
					"defaultCode": 59995,
					"grid": 16
				},
				{
					"id": 1331,
					"width": 1023.9989929199219,
					"paths": [
						"M521.143 969.143q0-9.143-9.143-9.143-33.714 0-58-24.286t-24.286-58q0-9.143-9.143-9.143t-9.143 9.143q0 41.714 29.429 71.143t71.143 29.429q9.143 0 9.143-9.143zM140.571 804.571h742.857q-152-171.429-152-475.429 0-29.143-13.714-60t-39.429-58.857-69.429-46-96.857-18-96.857 18-69.429 46-39.429 58.857-13.714 60q0 304-152 475.429zM987.429 804.571q0 29.714-21.714 51.429t-51.429 21.714h-256q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429h-256q-29.714 0-51.429-21.714t-21.714-51.429q28.571-24 52-50.286t48.571-68.286 42.571-90.571 28.571-117.714 11.143-148.571q0-86.857 66.857-161.429t175.429-90.571q-4.571-10.857-4.571-22.286 0-22.857 16-38.857t38.857-16 38.857 16 16 38.857q0 11.429-4.571 22.286 108.571 16 175.429 90.571t66.857 161.429q0 79.429 11.143 148.571t28.571 117.714 42.571 90.571 48.571 68.286 52 50.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell-o"
					],
					"defaultCode": 61602,
					"grid": 14
				},
				{
					"id": 2159,
					"paths": [
						"M1024 832c-106.042 0-192-85.96-192-192v-285.090c0-140.738-109.942-258.128-256-285.084v-69.826h-128v69.824c-146.064 26.958-256 144.346-256 285.084v285.092c0 106.040-85.962 192-192 192v64h429.598c-5.208 11.424-8.11 24.118-8.11 37.49 0 49.986 40.524 90.51 90.512 90.51 49.984 0 90.51-40.524 90.51-90.51 0-13.376-2.9-26.066-8.112-37.49h429.602v-64zM704 576h-128v128h-128v-128h-128v-128h128v-128h128v128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell-plus",
						"alarm",
						"alarm-add"
					],
					"defaultCode": 59994,
					"grid": 16
				},
				{
					"id": 1636,
					"width": 1170.2850551605225,
					"paths": [
						"M890.286 486.857q34.857 203.429 170.286 317.714 0 29.714-21.714 51.429t-51.429 21.714h-256q0 60.571-42.857 103.429t-103.429 42.857-103.143-42.571-43.143-103.143zM585.143 978.286q9.143 0 9.143-9.143t-9.143-9.143q-33.714 0-58-24.286t-24.286-58q0-9.143-9.143-9.143t-9.143 9.143q0 41.714 29.429 71.143t71.143 29.429zM1157.714 64q4.571 5.714 4.286 13.429t-6 12.857l-1069.714 926.857q-5.714 4.571-13.429 4t-12.286-6.286l-48-54.857q-4.571-5.714-4.286-13.429t6-12.286l106.286-92q-10.857-18.286-10.857-37.714 28.571-24 52-50.286t48.571-68.286 42.571-90.571 28.571-117.714 11.143-148.571q0-86.857 66.857-161.429t175.429-90.571q-4.571-10.857-4.571-22.286 0-22.857 16-38.857t38.857-16 38.857 16 16 38.857q0 11.429-4.571 22.286 70.857 10.286 125.143 47.143t84.571 90l238.857-207.429q5.714-4.571 13.429-4t12.286 6.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell-slash"
					],
					"defaultCode": 61942,
					"grid": 14
				},
				{
					"id": 1637,
					"width": 1170.2850551605225,
					"paths": [
						"M594.286 969.143q0-9.143-9.143-9.143-33.714 0-58-24.286t-24.286-58q0-9.143-9.143-9.143t-9.143 9.143q0 41.714 29.429 71.143t71.143 29.429q9.143 0 9.143-9.143zM287.429 697.714l501.143-434.286q-24-50.286-75.714-83.714t-127.714-33.429q-53.143 0-96.857 18t-69.429 46-39.429 58.857-13.714 60q0 219.429-78.286 368.571zM1060.571 804.571q0 29.714-21.714 51.429t-51.429 21.714h-256q0 60.571-42.857 103.429t-103.429 42.857-103.143-42.571-43.143-103.143l85.143-73.714h432.571q-94.857-106.857-129.714-262.286l63.429-55.429q34.857 203.429 170.286 317.714zM1109.714 9.143l48 54.857q4.571 5.714 4.286 13.429t-6 12.857l-1069.714 926.857q-5.714 4.571-13.429 4t-12.286-6.286l-48-54.857q-4.571-5.714-4.286-13.429t6-12.286l106.286-92q-10.857-18.286-10.857-37.714 28.571-24 52-50.286t48.571-68.286 42.571-90.571 28.571-117.714 11.143-148.571q0-86.857 66.857-161.429t175.429-90.571q-4.571-10.857-4.571-22.286 0-22.857 16-38.857t38.857-16 38.857 16 16 38.857q0 11.429-4.571 22.286 70.857 10.286 125.143 47.143t84.571 90l238.857-207.429q5.714-4.571 13.429-4t12.286 6.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell-slash-o"
					],
					"defaultCode": 61943,
					"grid": 14
				},
				{
					"id": 2157,
					"paths": [
						"M1024 832c-106.042 0-192-85.96-192-192v-285.090c0-140.738-109.942-258.128-256-285.084v-69.826h-128v69.824c-146.064 26.958-256 144.346-256 285.084v285.092c0 106.040-85.962 192-192 192v64h429.598c-5.208 11.424-8.11 24.118-8.11 37.49 0 49.986 40.524 90.51 90.512 90.51 49.984 0 90.51-40.524 90.51-90.51 0-13.376-2.902-26.066-8.112-37.49h429.602v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell",
						"alarm",
						"notification"
					],
					"defaultCode": 59992,
					"grid": 16
				},
				{
					"id": 2158,
					"paths": [
						"M1024 832c-106.042 0-192-85.96-192-192v-285.090c0-140.738-109.942-258.128-256-285.084v-69.826h-128v69.824c-146.064 26.958-256 144.346-256 285.084v285.092c0 106.040-85.962 192-192 192v64h429.598c-5.208 11.424-8.11 24.118-8.11 37.49 0 49.986 40.524 90.51 90.512 90.51 49.984 0 90.51-40.524 90.51-90.51 0-13.376-2.9-26.066-8.112-37.49h429.602v-64z",
						"M990.92 384c-16.714 0-30.786-12.98-31.9-29.9-7.526-114.362-58.112-220.42-142.44-298.638-12.958-12.018-13.718-32.264-1.7-45.222 12.020-12.956 32.266-13.716 45.222-1.7 96.366 89.384 154.174 210.614 162.78 341.358 1.16 17.634-12.196 32.872-29.83 34.032-0.714 0.048-1.428 0.070-2.132 0.070z",
						"M33.082 384c-0.708 0-1.416-0.022-2.132-0.070-17.636-1.16-30.99-16.398-29.83-34.032 8.606-130.75 66.416-251.982 162.778-341.36 12.96-12.018 33.206-11.254 45.224 1.702 12.018 12.958 11.256 33.204-1.702 45.222-84.326 78.214-134.912 184.272-142.44 298.64-1.112 16.92-15.186 29.898-31.898 29.898z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell",
						"alarm",
						"notification"
					],
					"defaultCode": 59993,
					"grid": 16
				},
				{
					"id": 1395,
					"width": 1023.9989929199219,
					"paths": [
						"M521.143 969.143q0-9.143-9.143-9.143-33.714 0-58-24.286t-24.286-58q0-9.143-9.143-9.143t-9.143 9.143q0 41.714 29.429 71.143t71.143 29.429q9.143 0 9.143-9.143zM987.429 804.571q0 29.714-21.714 51.429t-51.429 21.714h-256q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429h-256q-29.714 0-51.429-21.714t-21.714-51.429q28.571-24 52-50.286t48.571-68.286 42.571-90.571 28.571-117.714 11.143-148.571q0-86.857 66.857-161.429t175.429-90.571q-4.571-10.857-4.571-22.286 0-22.857 16-38.857t38.857-16 38.857 16 16 38.857q0 11.429-4.571 22.286 108.571 16 175.429 90.571t66.857 161.429q0 79.429 11.143 148.571t28.571 117.714 42.571 90.571 48.571 68.286 52 50.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bell"
					],
					"defaultCode": 61683,
					"grid": 14
				},
				{
					"id": 1651,
					"width": 1316.570068359375,
					"paths": [
						"M435.429 658.286h-179.429q-22.857 0-32.857-20t3.714-38.286l107.429-143.429q-37.143-17.714-78.286-17.714-75.429 0-129.143 53.714t-53.714 129.143 53.714 129.143 129.143 53.714q65.714 0 116-41.429t63.429-104.857zM329.143 585.143h106.286q-10.286-48.571-42.857-84.571zM603.429 585.143l164.571-219.429h-274.286l-56.571 75.429q60 58.857 72 144h94.286zM1243.429 621.714q0-75.429-53.714-129.143t-129.143-53.714q-34.286 0-69.143 13.714l99.429 148.571q8.571 13.143 5.714 28t-15.429 22.857q-8.571 6.286-20.571 6.286-20 0-30.286-16.571l-99.429-148.571q-53.143 54.286-53.143 128.571 0 75.429 53.714 129.143t129.143 53.714 129.143-53.714 53.714-129.143zM1316.571 621.714q0 105.714-75.143 180.857t-180.857 75.143-180.857-75.143-75.143-180.857q0-55.429 22.571-104.857t62.571-85.429l-37.143-56-201.714 268q-10.286 14.857-29.143 14.857h-112.571q-13.143 93.714-85.143 156.571t-168 62.857q-105.714 0-180.857-75.143t-75.143-180.857 75.143-180.857 180.857-75.143q65.143 0 122.857 31.429l78.286-104.571h-128q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h219.429v73.143h248.571l-48.571-73.143h-126.857q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h146.286q18.857 0 30.286 16l152.571 228.571q52-25.143 109.714-25.143 105.714 0 180.857 75.143t75.143 180.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bicycle"
					],
					"defaultCode": 61958,
					"grid": 14
				},
				{
					"id": 175,
					"paths": [
						"M281.6 460.902c-42.405 0-76.902-34.499-76.902-76.902s34.499-76.902 76.902-76.902 76.902 34.499 76.902 76.902-34.498 76.902-76.902 76.902zM281.6 358.298c-14.173 0-25.702 11.531-25.702 25.702s11.531 25.702 25.702 25.702 25.702-11.531 25.702-25.702-11.53-25.702-25.702-25.702z",
						"M486.4 870.4c-14.138 0-25.6-11.461-25.6-25.6v-153.498c0-39.531 29.77-79.022 67.774-89.902l76.795-21.984-166.909-111.274-87.56 87.56c-4.8 4.802-11.312 7.499-18.101 7.499h-102.502c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h91.899l94.901-94.901c8.629-8.629 22.149-9.966 32.302-3.2l187.798 125.2c28.149 18.765 28.066 40.824 26.723 49.437s-7.974 29.653-40.498 38.966l-80.758 23.118c-16.048 4.595-30.666 23.986-30.666 40.68v153.498c0 14.139-11.462 25.6-25.6 25.6z",
						"M768 1024c-112.926 0-204.8-91.874-204.8-204.8s91.874-204.8 204.8-204.8 204.8 91.874 204.8 204.8-91.874 204.8-204.8 204.8zM768 665.6c-84.696 0-153.6 68.904-153.6 153.6s68.904 153.6 153.6 153.6 153.6-68.904 153.6-153.6-68.904-153.6-153.6-153.6z",
						"M204.749 1024c-112.899 0-204.749-91.85-204.749-204.749s91.85-204.749 204.749-204.749 204.749 91.85 204.749 204.749-91.851 204.749-204.749 204.749zM204.749 665.702c-84.667 0-153.549 68.882-153.549 153.549s68.882 153.549 153.549 153.549 153.549-68.882 153.549-153.549-68.882-153.549-153.549-153.549z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bicycle",
						"exercise",
						"travel",
						"bike"
					],
					"defaultCode": 59472,
					"grid": 20
				},
				{
					"id": 2597,
					"width": 1216,
					"paths": [
						"M992 448c-29.010 0-56.748 5.544-82.212 15.628l-182.572-319.5c-5.698-9.97-16.298-16.122-27.782-16.124l-91.432-0.004c-0.002 0 0 0-0.002 0-17.672 0-32 14.326-32 32s14.326 32 31.998 32l72.864 0.002 73.14 127.998h-310.29l-36.572-64h8.86c17.672 0 32-14.328 32-32s-14.328-32-32-32h-128c-17.672 0-32 14.328-32 32s14.328 32 32 32h45.43l50.172 87.8-72.978 121.632c-26.662-11.222-55.93-17.432-86.624-17.432-123.514 0-224 100.486-224 224s100.486 224 224 224c112.65 0 206.128-83.592 221.704-192h71.78c13.182 37.282 48.718 64 90.516 64 53.020 0 96-42.98 96-96 0-23.236-8.258-44.542-21.994-61.148l122.004-203.338 50.26 87.956c-52.478 41.032-86.27 104.906-86.27 176.53 0 123.514 100.486 224 224 224s224-100.486 224-224-100.486-224-224-224zM224 832c-88.224 0-160-71.776-160-160s71.776-160 160-160c18.648 0 36.548 3.238 53.204 9.13l-80.644 134.408c-5.932 9.884-6.086 22.198-0.408 32.228 5.68 10.034 16.318 16.234 27.846 16.234h156.78c-14.864 72.944-79.51 128-156.778 128zM280.518 640l51.532-85.884c24.406 22.388 41.872 52.228 48.73 85.884h-100.262zM517.484 640h-71.78c-8.164-56.828-37.732-106.832-80.254-141.552l54.56-90.932 115.314 201.802c-7.72 8.942-13.822 19.314-17.84 30.682zM608 704c-17.674 0-32-14.326-32-32s14.326-32 32-32 32 14.326 32 32-14.326 32-32 32zM627.134 577.912c-6.182-1.25-12.582-1.912-19.134-1.912-5.846 0-11.558 0.55-17.116 1.55l-110.6-193.55h263.198l-116.348 193.912zM992 832c-88.224 0-160-71.776-160-160 0-47.828 21.122-90.792 54.496-120.136l77.72 136.014c5.906 10.336 16.704 16.128 27.812 16.128 5.382 0 10.84-1.362 15.848-4.222 15.344-8.768 20.676-28.314 11.906-43.66l-77.764-136.086c15.74-5.19 32.528-8.038 49.982-8.038 88.224 0 160 71.776 160 160s-71.776 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bike",
						"travel",
						"bicycle",
						"transport"
					],
					"defaultCode": 60432,
					"grid": 16
				},
				{
					"id": 2578,
					"paths": [
						"M128 320v640c0 35.2 28.8 64 64 64h576c35.2 0 64-28.8 64-64v-640h-704zM320 896h-64v-448h64v448zM448 896h-64v-448h64v448zM576 896h-64v-448h64v448zM704 896h-64v-448h64v448z",
						"M848 128h-208v-80c0-26.4-21.6-48-48-48h-224c-26.4 0-48 21.6-48 48v80h-208c-26.4 0-48 21.6-48 48v80h832v-80c0-26.4-21.6-48-48-48zM576 128h-192v-63.198h192v63.198z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bin",
						"trashcan",
						"remove",
						"delete",
						"recycle",
						"dispose"
					],
					"defaultCode": 60413,
					"grid": 16
				},
				{
					"id": 2579,
					"paths": [
						"M192 1024h640l64-704h-768zM640 128v-128h-256v128h-320v192l64-64h768l64 64v-192h-320zM576 128h-128v-64h128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bin",
						"trashcan",
						"remove",
						"delete",
						"recycle",
						"dispose"
					],
					"defaultCode": 60414,
					"grid": 16
				},
				{
					"id": 2580,
					"paths": [
						"M960 160c0-88.366-214.902-160-480-160-265.096 0-480 71.634-480 160 0 6.246 1.11 12.404 3.2 18.462l124.346 717.538c0 70.694 157.696 128 352.226 128s352.228-57.306 352.228-128l124.778-717.47c2.102-6.080 3.222-12.262 3.222-18.53zM188.434 107.45c80.44-22.86 183.986-35.45 291.566-35.45s211.126 12.59 291.566 35.45c68.968 19.6 101.382 41.282 112.842 52.55-11.458 11.268-43.874 32.95-112.842 52.55-80.44 22.86-183.986 35.45-291.566 35.45s-211.126-12.59-291.566-35.45c-68.968-19.6-101.384-41.282-112.842-52.55 11.458-11.268 43.874-32.95 112.842-52.55z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bin",
						"trashcan",
						"remove",
						"delete",
						"recycle",
						"dispose"
					],
					"defaultCode": 60415,
					"grid": 16
				},
				{
					"id": 2581,
					"paths": [
						"M480 0c-265.096 0-480 71.634-480 160 0 6.246 1.11 12.404 3.2 18.462l124.346 717.538c0 70.694 157.696 128 352.226 128s352.228-57.306 352.228-128l124.778-717.47c2.102-6.080 3.222-12.262 3.222-18.53 0-88.366-214.902-160-480-160zM868.832 264h-24.070c9.134-3.556 17.81-7.248 25.994-11.064l-1.924 11.064zM735.488 808c-15.356-5.89-32.226-11.252-50.402-16h91.92l-2.782 16h-38.736zM185.37 808l-2.774-16h91.862c-18.174 4.748-35.046 10.11-50.4 16h-38.688zM602.494 776c-38.216-5.164-79.552-8-122.72-8s-84.504 2.836-122.722 8h-177.228l-2.772-16h605.52l-2.784 16h-177.294zM174.28 744l-2.774-16h616.63l-2.784 16h-611.072zM168.734 712l-2.772-16h627.74l-2.782 16h-622.186zM163.188 680l-2.772-16h638.852l-2.784 16h-633.296zM157.642 648l-2.774-16h649.962l-2.782 16h-644.406zM152.096 616l-2.772-16h661.074l-2.784 16h-655.518zM146.55 584l-2.772-16h672.184l-2.784 16h-666.628zM141.006 552l-2.774-16h683.294l-2.782 16h-677.738zM135.46 520l-2.772-16h694.406l-2.784 16h-688.85zM129.914 488l-2.772-16h705.516l-2.784 16h-699.96zM124.37 456l-2.772-16h716.626l-2.782 16h-711.072zM118.824 424l-2.772-16h727.738l-2.784 16h-722.182zM113.278 392l-2.774-16h738.848l-2.784 16h-733.29zM107.732 360l-2.772-16h749.958l-2.782 16h-744.404zM102.186 328l-2.772-16h230.464c47.234 5.18 97.684 8 150.122 8s102.886-2.82 150.12-8h230.366l-2.784 16h-755.516zM89.172 252.904c8.204 3.828 16.906 7.53 26.066 11.096h-24.142l-1.924-11.096zM162.558 280c20.096 5.912 41.696 11.264 64.57 16h-130.486l-2.772-16h68.688zM732.87 296c22.874-4.736 44.474-10.088 64.568-16h68.612l-2.784 16h-130.396zM188.434 107.45c80.44-22.86 183.986-35.45 291.566-35.45s211.126 12.59 291.566 35.45c68.968 19.6 101.382 41.282 112.842 52.55-11.458 11.268-43.874 32.95-112.842 52.55-80.44 22.86-183.986 35.45-291.566 35.45s-211.126-12.59-291.566-35.45c-68.968-19.6-101.384-41.282-112.842-52.55 11.458-11.268 43.874-32.95 112.842-52.55z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bin",
						"trashcan",
						"remove",
						"delete",
						"recycle",
						"dispose",
						"dualtone"
					],
					"defaultCode": 60416,
					"grid": 16
				},
				{
					"id": 2582,
					"paths": [
						"M384 448h64v64h-64v-64z",
						"M512 448h64v64h-64v-64z",
						"M576 640h64v64h-64v-64z",
						"M576 512h64v64h-64v-64z",
						"M640 448h64v64h-64v-64z",
						"M256 576h64v64h-64v-64z",
						"M192 384h64v64h-64v-64z",
						"M192 512h64v64h-64v-64z",
						"M320 640h64v64h-64v-64z",
						"M448 640h64v64h-64v-64z",
						"M512 576h64v64h-64v-64z",
						"M384 576h64v64h-64v-64z",
						"M448 512h64v64h-64v-64z",
						"M320 512h64v64h-64v-64z",
						"M448 768h64v64h-64v-64z",
						"M512 704h64v64h-64v-64z",
						"M384 704h64v64h-64v-64z",
						"M256 704h64v64h-64v-64z",
						"M256 448h64v64h-64v-64z",
						"M640 704h64v64h-64v-64z",
						"M576 768h64v64h-64v-64z",
						"M512 832h64v64h-64v-64z",
						"M480 0c-265.096 0-480 71.634-480 160 0 6.246 1.11 12.404 3.2 18.462l124.346 717.538c0 70.694 157.696 128 352.226 128s352.228-57.306 352.228-128l124.778-717.47c2.102-6.080 3.222-12.262 3.222-18.53 0-88.366-214.902-160-480-160zM832 448h-64v64h64v64h-64v64h-64v64h64v64h-64v64h64v64h-64v-64h-64v64h-64v64h-64v-64h-64v64h-64v-64h-64v-64h-64v64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v-64h64v-64h-64v-64h64v-64h64v64h64v64h64v-64h64v64h64v-64h64v64h64v-64h64v-64h64v64h64v64zM771.566 212.55c-80.44 22.86-183.986 35.45-291.566 35.45s-211.126-12.59-291.566-35.45c-68.968-19.6-101.384-41.282-112.842-52.55 11.458-11.268 43.874-32.95 112.842-52.55 80.44-22.86 183.986-35.45 291.566-35.45s211.126 12.59 291.566 35.45c68.968 19.6 101.382 41.282 112.842 52.55-11.458 11.268-43.872 32.95-112.842 52.55z",
						"M384 832h64v64h-64v-64z",
						"M704 512h64v64h-64v-64z",
						"M640 576h64v64h-64v-64z",
						"M704 384h64v64h-64v-64z",
						"M320 768h64v64h-64v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bin",
						"trashcan",
						"remove",
						"delete",
						"recycle",
						"dispose"
					],
					"defaultCode": 60417,
					"grid": 16
				},
				{
					"id": 2371,
					"paths": [
						"M64 0h384v64h-384zM576 0h384v64h-384zM952 320h-56v-256h-256v256h-256v-256h-256v256h-56c-39.6 0-72 32.4-72 72v560c0 39.6 32.4 72 72 72h304c39.6 0 72-32.4 72-72v-376h128v376c0 39.6 32.4 72 72 72h304c39.6 0 72-32.4 72-72v-560c0-39.6-32.4-72-72-72zM348 960h-248c-19.8 0-36-14.4-36-32s16.2-32 36-32h248c19.8 0 36 14.4 36 32s-16.2 32-36 32zM544 512h-64c-17.6 0-32-14.4-32-32s14.4-32 32-32h64c17.6 0 32 14.4 32 32s-14.4 32-32 32zM924 960h-248c-19.8 0-36-14.4-36-32s16.2-32 36-32h248c19.8 0 36 14.4 36 32s-16.2 32-36 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"binoculars",
						"lookup",
						"search",
						"find"
					],
					"defaultCode": 60206,
					"grid": 16
				},
				{
					"id": 2372,
					"paths": [
						"M960 448h-64l-64-320h-80l16-128h-192l16 128h-160l16-128h-192l16 128h-80l-64 320h-64l-64 512v64h384v-576h64v-64h128v64h64v576h384v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"binoculars",
						"lookup",
						"search",
						"find"
					],
					"defaultCode": 60207,
					"grid": 16
				},
				{
					"id": 1620,
					"width": 1024.002040863037,
					"paths": [
						"M402.286 182.857v438.857q0 14.857-10.857 25.714t-25.714 10.857v329.143q0 14.857-10.857 25.714t-25.714 10.857h-292.571q-14.857 0-25.714-10.857t-10.857-25.714v-292.571l142.286-498.857q4-13.143 17.714-13.143h242.286zM585.143 182.857v402.286h-146.286v-402.286h146.286zM1024 694.857v292.571q0 14.857-10.857 25.714t-25.714 10.857h-292.571q-14.857 0-25.714-10.857t-10.857-25.714v-329.143q-14.857 0-25.714-10.857t-10.857-25.714v-438.857h242.286q13.714 0 17.714 13.143zM420.571 18.286v128h-201.143v-128q0-8 5.143-13.143t13.143-5.143h164.571q8 0 13.143 5.143t5.143 13.143zM804.571 18.286v128h-201.143v-128q0-8 5.143-13.143t13.143-5.143h164.571q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"binoculars"
					],
					"defaultCode": 61925,
					"grid": 14
				},
				{
					"id": 315,
					"width": 1024,
					"paths": [
						"M896 480c0 282.784-154.24 544-384 544s-384-261.216-384-544 154.24-448 384-448 384 165.216 384 448zM864 480c0-256.608-134.88-416-352-416s-352 159.392-352 416c0 138.56 33.536 252.896 85.536 338.176l6.464-1.664c225.408-58.368 335.328-191.84 379.776-263.168-35.744 14.816-76.48 22.656-119.776 22.656-141.376 0-256-82.624-256-224s114.624-224 256-224 256 82.624 256 224c0 74.784-32.256 132.896-83.392 171.264-15.84 36.704-117.056 242.656-420.32 322.944 67.104 94.048 158.112 145.792 247.712 145.792 173.024 0 352-191.52 352-512zM736 352c0-132.64-112.512-192-224-192s-224 59.36-224 192c0 132.64 112.512 192 224 192s224-59.36 224-192zM448 288c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32-14.336-32-32-32zM576 288c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"birth",
						"cry",
						"wrap",
						"swaddle"
					],
					"grid": 32
				},
				{
					"id": 316,
					"width": 1024,
					"paths": [
						"M512 160c-111.488 0-224 59.36-224 192s112.512 192 224 192c111.488 0 224-59.36 224-192s-112.512-192-224-192zM448 352c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM576 352c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM896 480c0 282.784-154.24 544-384 544-116.8 0-213.92-67.712-281.344-171.232 332.8-68.448 444.608-307.904 449.248-318.208l5.248-11.68c50.816-38.368 82.848-96.352 82.848-170.88 0-141.376-114.624-224-256-224s-256 82.624-256 224 114.624 224 256 224c43.616 0 84.672-7.904 120.608-22.944-42.464 67.104-165.536 222.432-418.976 270.816l-0.448 0.096c-54.368-96.288-85.184-217.888-85.184-343.968 0-282.784 154.24-448 384-448s384 165.216 384 448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"birth",
						"cry",
						"wrap",
						"swaddle"
					],
					"grid": 32
				},
				{
					"id": 1643,
					"width": 1023.9999771118164,
					"paths": [
						"M1024 804.571v219.429h-1024v-219.429q25.714 0 48.571-8t33.714-15.714 26.857-21.429q17.143-15.429 29.429-21.714t32.286-6.286 31.714 6.286 30 21.714q16.571 14.286 26.857 21.714t33.143 15.429 49.143 8q25.714 0 48.571-8.286t33.143-15.429 27.429-21.429q12-10.857 18.571-15.429t17.714-8.571 24.857-4q20 0 32.286 6.286t29.429 21.714q16 13.714 26.857 21.429t33.714 15.714 48.571 8 48.571-8 33.714-15.714 26.857-21.429q17.143-15.429 29.429-21.714t32.286-6.286q19.429 0 31.714 6.286t29.429 21.714q16 13.714 26.857 21.429t33.714 15.714 48.571 8zM1024 621.714v109.714q-20 0-31.714-6.286t-30-21.714q-16.571-14.286-26.857-21.714t-33.143-15.429-48.571-8q-26.286 0-49.143 8t-33.143 15.429-26.857 21.714q-12.571 10.857-18.857 15.429t-17.714 8.571-25.143 4q-20 0-32.286-6.286t-29.429-21.714q-16.571-14.286-26.857-21.714t-33.143-15.429-49.143-8q-25.714 0-48.571 8.286t-33.143 15.429-27.429 21.429q-12 10.857-18.571 15.429t-17.714 8.571-24.857 4q-20 0-32.286-6.286t-29.429-21.714q-16-13.714-26.857-21.429t-33.714-15.714-48.571-8q-26.286 0-49.143 8t-33.143 15.429-26.857 21.714q-17.143 15.429-29.429 21.714t-32.286 6.286v-109.714q0-45.714 32-77.714t77.714-32h36.571v-256h146.286v256h146.286v-256h146.286v256h146.286v-256h146.286v256h36.571q45.714 0 77.714 32t32 77.714zM292.571 128q0 44-20.571 67.714t-52.571 23.714q-30.286 0-51.714-21.429t-21.429-51.714q0-16.571 5.429-29.143t13.429-19.429 17.714-16 17.714-18 13.429-25.429 5.429-38.286q21.714 0 47.429 42.286t25.714 85.714zM585.143 128q0 44-20.571 67.714t-52.571 23.714q-30.286 0-51.714-21.429t-21.429-51.714q0-16.571 5.429-29.143t13.429-19.429 17.714-16 17.714-18 13.429-25.429 5.429-38.286q21.714 0 47.429 42.286t25.714 85.714zM877.714 128q0 44-20.571 67.714t-52.571 23.714q-30.286 0-51.714-21.429t-21.429-51.714q0-16.571 5.429-29.143t13.429-19.429 17.714-16 17.714-18 13.429-25.429 5.429-38.286q21.714 0 47.429 42.286t25.714 85.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"birthday-cake"
					],
					"defaultCode": 61949,
					"grid": 14
				},
				{
					"id": 1511,
					"width": 805.1418609619141,
					"paths": [
						"M465.714 490.857q4.571 36-28.857 57.714t-63.714 3.429q-22.286-9.714-30.571-33.143t-0.286-46.857 29.714-33.143q20.571-10.286 41.429-6.857t36.571 20.286 15.714 38.571zM529.143 478.857q-8-61.143-64.571-93.714t-112.571-7.429q-36 16-57.429 50.571t-19.714 74q2.286 52 44.286 88.571t94.571 32q52-4.571 86.857-48t28.571-96zM665.714 169.143q-11.429-15.429-32-25.429t-33.143-12.571-40.571-7.143q-166.286-26.857-323.429 1.143-24.571 4-37.714 6.857t-31.429 12.571-28.571 24.571q17.143 16 43.429 26t42 12.571 50 6.571q130.286 16.571 256 0.571 36-4.571 51.143-6.857t41.429-12.286 42.857-26.571zM698.286 760.571q-4.571 14.857-8.857 43.714t-8 48-16.286 40-33.143 32.286q-49.143 27.429-108.286 40.857t-115.429 12.571-115.143-10.571q-26.286-4.571-46.571-10.286t-43.714-15.429-41.714-24.857-29.714-35.143q-14.286-54.857-32.571-166.857l3.429-9.143 10.286-5.143q127.429 84.571 289.429 84.571t290-84.571q12 3.429 13.714 13.143t-2.857 25.714-4.571 21.143zM801.714 211.429q-14.857 95.429-63.429 374.286-2.857 17.143-15.429 32t-24.857 22.857-31.143 17.714q-144 72-348.571 50.286-141.714-15.429-225.143-79.429-8.571-6.857-14.571-15.143t-9.714-20-5.143-19.429-3.429-22.571-3.143-20q-5.143-28.571-15.143-85.714t-16-92.286-13.429-84.286-12.571-90.286q1.714-14.857 10-27.714t18-21.429 25.714-17.143 26.286-12.857 27.429-10.571q71.429-26.286 178.857-36.571 216.571-21.143 386.286 28.571 88.571 26.286 122.857 69.714 9.143 11.429 9.429 29.143t-3.143 30.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bitbucket"
					],
					"defaultCode": 61809,
					"grid": 14
				},
				{
					"id": 1512,
					"width": 877.7129821777344,
					"paths": [
						"M484.571 497.143q0-24.571-23.429-37.714t-44-0.571q-24.571 11.429-24.286 41.429t24.857 40.286q22.286 13.143 46.286-2.286t20.571-41.143zM530.286 488q4.571 37.714-20.571 69.143t-62.857 34.857-68-22.857-32-64.571q-1.143-28 14.571-53.143t41.429-36.571q40-17.714 80.857 5.714t46.571 67.429zM628.571 264.571q-11.429 12-30.571 19.429t-30.286 9.143-36.286 4.571q-88.571 11.429-185.143 0-25.143-3.429-36-5.429t-30-9.143-31.143-18.571q7.429-10.857 20.571-17.714t22.857-8.857 26.857-4.857q113.143-20 233.143-0.571 18.857 2.857 29.143 4.857t24.571 9.143 22.286 18zM652.571 690.857q0-4 3.143-15.143t1.714-18.286-10-9.429q-92 60.571-208.571 60.571t-209.143-60.571l-6.857 3.429-2.857 6.857q14.857 88 23.429 120 26.857 46.286 116.571 61.714 142.286 26.286 244.571-30.286 19.429-10.857 28-29.429t12.857-48.857 7.143-40.571zM726.857 294.857q5.143-30.286-4.571-42.857-24.571-31.429-88.571-50.286-123.429-36-278.286-20.571-75.429 6.857-129.143 26.286-21.714 8.571-34 14.286t-26.857 19.429-16.857 30.857q4.571 38.857 10.857 78.857t16.571 97.714 13.714 78.286q0.571 2.857 2.857 17.714t4 20.571 6.857 15.429 12.571 16q60 45.714 162.286 57.143 148 16 251.429-36 13.714-7.429 22.571-13.143t17.714-16.571 11.143-22.857q27.429-152.571 45.714-270.286zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bitbucket-square"
					],
					"defaultCode": 61810,
					"grid": 14
				},
				{
					"id": 1490,
					"width": 757.1420135498047,
					"paths": [
						"M666.857 365.714q10.286 104-74.857 147.429 66.857 16 100 58.857t25.714 122.286q-4 40.571-18.571 71.429t-36.857 50.857-55.429 33.429-69.429 19.714-83.143 8.571v145.714h-88v-143.429q-45.714 0-69.714-0.571v144h-88v-145.714q-10.286 0-30.857-0.286t-31.429-0.286h-114.286l17.714-104.571h63.429q28.571 0 33.143-29.143v-229.714h9.143q-3.429-0.571-9.143-0.571v-164q-7.429-38.857-50.857-38.857h-63.429v-93.714l121.143 0.571q36.571 0 55.429-0.571v-144h88v141.143q46.857-1.143 69.714-1.143v-140h88v144q45.143 4 80 12.857t64.571 25.714 47.143 44.571 20.857 65.429zM544 677.143q0-20.571-8.571-36.571t-21.143-26.286-32.857-17.429-37.429-10.571-42.286-5.143-39.429-1.714-36.857 0.571-27.143 0.571v193.143q4.571 0 21.143 0.286t27.429 0.286 30.286-0.857 33.429-2.286 32.571-4.857 31.714-8 27.143-12 22.571-17.143 14-22.857 5.429-29.143zM503.429 405.143q0-18.857-7.143-33.429t-17.429-24-27.429-16-31.429-9.429-35.143-4.571-33.143-1.429-30.857 0.571-22.571 0.286v175.429q2.857 0 19.714 0.286t26.571 0 28.571-1.143 31.429-3.143 29.429-6.286 27.714-10.571 21.143-15.429 15.429-22 5.143-29.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bitcoin",
						"btc"
					],
					"defaultCode": 61786,
					"grid": 14
				},
				{
					"id": 1762,
					"width": 877.7139892578125,
					"paths": [
						"M0 73.143h877.714v877.714h-877.714v-877.714zM620 710.286l-126.286-360.571 126.286-169.714h-362.286l126.286 169.714-126.286 360.571 181.143 173.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"black-tie"
					],
					"defaultCode": 62078,
					"grid": 14
				},
				{
					"id": 317,
					"width": 1024,
					"paths": [
						"M673.28 55.424c-38.688 29.92-109.632 86.112-187.808 154.56-58.464-42.816-108.64-76.768-137.984-96.128-15.2-10.048-35.584-5.504-44.928 10.112-3.008 5.024-6.336 10.656-9.92 16.896-51.68 89.6-159.008 300.448-164.416 514.368-4.032 159.456 112.96 300.256 270.24 326.912 260.64 44.224 497.536-61.184 497.536-310.144 0-219.456-115.712-483.904-167.488-591.232-2.496-5.184-4.832-9.984-7.008-14.4-8.96-18.112-32.224-23.328-48.224-10.944zM391.392 947.040l0.384-0.896c-43.072-26.72-71.776-84.8-71.776-146.144 0-79.712 124.832-194.72 192-247.744 67.168 53.024 192 168.032 192 247.744 0 61.344-28.704 119.424-71.808 146.144l0.832 0.8c-35.584 8.256-75.616 13.056-121.024 13.056-45.248 0-85.12-4.768-120.608-12.96zM696.896 926.112c24.448-34.816 39.104-79.52 39.104-126.112 0-100.96-149.184-228.96-204.064-272.608-11.712-9.344-28.16-9.344-39.872 0-54.88 43.648-204.064 171.648-204.064 272.608 0 46.144 14.048 90.88 38.016 125.664-119.264-51.936-166.016-155.072-166.016-253.664 0-225.152 124.192-454.496 169.984-531.328 29.088 19.2 78.976 52.928 136.576 95.136l20.704 15.168 19.296-16.896c77.184-67.584 147.872-123.584 186.304-153.312 46.304 94.4 171.136 369.28 171.136 591.232 0 98.912-47.040 202.336-167.104 254.112z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blaze",
						"burn"
					],
					"grid": 32
				},
				{
					"id": 318,
					"width": 1024,
					"paths": [
						"M704 800c0 102.496-80.8 186.24-182.016 191.488-5.568 0.096-11.136 0.224-16.736 0.16-102.72-3.584-185.248-88.064-185.248-191.648 0-69.888 99.136-173.696 192-247.584v0c92.832 73.856 192 177.696 192 247.584zM728.512 80.768c-2.496-5.152-4.832-9.984-7.008-14.4-8.928-18.144-32.224-23.328-48.224-10.976-38.688 29.92-109.632 86.112-187.808 154.56-58.464-42.816-108.64-76.768-137.984-96.128-15.2-10.048-35.584-5.504-44.928 10.112-3.008 5.024-6.336 10.656-9.92 16.896-51.68 89.6-159.008 300.448-164.416 514.368-3.84 151.488 101.664 285.952 247.040 321.888-52.992-40.896-87.264-104.928-87.264-177.088 0-100.96 149.184-228.96 204.064-272.608 5.856-4.672 12.896-7.008 19.936-7.008s14.080 2.336 19.936 7.008c54.88 43.648 204.064 171.648 204.064 272.608 0 70.016-32.16 132.512-82.496 173.568 141.92-38.752 242.496-139.584 242.496-301.568 0-219.456-115.712-483.904-167.488-591.232z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blaze",
						"burn"
					],
					"grid": 32
				},
				{
					"id": 963,
					"width": 1024,
					"paths": [
						"M512 0c0 0-384 320-384 640 0 212.064 171.936 384 384 384s384-171.936 384-384c0-320-384-640-384-640zM352 800c0-113.536 112.704-232.096 160-276.864 47.296 44.768 160 163.36 160 276.864 0 88.224-71.776 160-160 160s-160-71.776-160-160zM658.144 924.352c28.544-33.536 45.856-76.896 45.856-124.352 0-160-192-320-192-320s-192 160-192 320c0 47.456 17.312 90.816 45.856 124.352-103.072-53.216-173.856-160.576-173.856-284.352 0-227.040 225.376-464.224 320-553.728 94.624 89.504 320 326.688 320 553.728 0 123.776-70.784 231.136-173.856 284.352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blaze",
						"burn"
					],
					"grid": 32
				},
				{
					"id": 319,
					"width": 1024,
					"paths": [
						"M832 160h-35.776l3.776-32c17.664 0 32-14.336 32-32v-18.752c0-8.48-3.36-16.64-9.376-22.624l-45.248-45.248c-6.016-6.016-14.144-9.376-22.624-9.376h-421.504c-8.48 0-16.64 3.36-22.624 9.376l-45.248 45.248c-6.016 6.016-9.376 14.144-9.376 22.624v18.752c0 17.664 14.336 32 32 32v0l64 544h-12.224c-12.128 0-23.2 6.848-28.608 17.696l-48.384 96.8c-4.48 8.864-6.784 18.688-6.784 28.608v144.896c0 17.664 14.336 32 32 32v0c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h320c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v0c17.664 0 32-14.336 32-32v-144.896c0-9.952-2.304-19.744-6.752-28.608l-48.384-96.8c-5.44-10.848-16.512-17.696-28.64-17.696h-12.224l21.984-186.944 102.656-51.424c21.664-10.816 35.36-32.96 35.36-57.184v-152.448c0-35.36-28.64-64-64-64zM288 96v-18.752l45.248-45.248h421.504l45.248 45.248v18.752h-512zM748.224 704l48.384 96.8c2.24 4.448 3.392 9.344 3.392 14.304v144.896h-32v32h-32v-32h-384v32h-32v-32h-32v-144.896c0-4.96 1.152-9.856 3.392-14.304l48.384-96.8h408.448zM703.776 672h-319.552l-37.664-320h394.88l-37.664 320zM342.816 320l-22.592-192h447.552l-22.592 192h-402.368zM864 376.448c0 12.192-6.784 23.168-17.696 28.608l-83.84 41.888 30.016-254.944h39.52c17.632 0 32 14.368 32 32v152.448zM576 832c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32 32 14.336 32 32zM480 832c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32 32 14.336 32 32zM672 832c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32 32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blend",
						"mix"
					],
					"grid": 32
				},
				{
					"id": 320,
					"width": 1024,
					"paths": [
						"M256 96v-18.752c0-8.48 3.36-16.64 9.376-22.624l45.248-45.248c6.016-6.016 14.144-9.376 22.624-9.376h421.504c8.48 0 16.64 3.36 22.624 9.376l45.248 45.248c6.016 6.016 9.376 14.144 9.376 22.624v18.752c0 17.664-14.336 32-32 32h-512c-17.664 0-32-14.336-32-32zM825.248 786.496c4.448 8.864 6.752 18.688 6.752 28.608v144.896c0 17.664-14.336 32-32 32 0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32h-320c0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32-17.664 0-32-14.336-32-32v-144.896c0-9.952 2.304-19.744 6.752-28.64l48.384-96.8c5.44-10.816 16.512-17.664 28.64-17.664h408.448c12.128 0 23.2 6.848 28.608 17.696l48.416 96.8zM480 832c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM576 832c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM672 832c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM832 160h-540.224l18.816 160h466.816l15.072-128h39.52c17.632 0 32 14.368 32 32v152.448c0 12.192-6.784 23.168-17.696 28.608l-83.84 41.888 11.168-94.944h-459.296l33.888 288h391.52l18.24-154.912 102.656-51.424c21.664-10.848 35.36-32.992 35.36-57.216v-152.448c0-35.36-28.64-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blend",
						"mix"
					],
					"grid": 32
				},
				{
					"id": 964,
					"width": 1024,
					"paths": [
						"M384 832h-32v-64h32v64zM480 768h-32v64h32v-64zM576 768h-32v64h32v-64zM672 768h-32v64h32v-64zM723.072 512l-15.072 128h28c15.936 0 29.44 11.712 31.68 27.456l28.064 196.544h4.256c17.696 0 32 14.304 32 32v96c0 17.696-14.304 32-32 32h-576c-17.696 0-32-14.304-32-32v-96c0-17.696 14.304-32 32-32h4.256l28.064-196.544c2.24-15.744 15.744-27.456 31.68-27.456h28l-56.48-480h-3.52c-10.272 0-19.936-4.928-25.984-13.28-5.984-8.352-7.648-19.104-4.352-28.832l32-96c4.32-13.088 16.544-21.888 30.336-21.888h448c13.792 0 25.984 8.8 30.336 21.888l32 96c3.296 9.76 1.632 20.512-4.384 28.832-6.016 8.352-15.68 13.28-25.952 13.28h-3.52l-3.776 32h39.296c17.696 0 32 14.304 32 32v256c0 17.696-14.304 32-32 32h-76.928zM703.776 128h-383.552l7.52 64h120.256v32h-116.48l7.52 64h108.96v32h-105.184l7.52 64h97.664v32h-93.888l7.52 64h86.368v32h-82.592l7.52 64h75.072v32h-71.296l7.296 64h256l63.776-544zM315.744 704l-27.424 192h447.36l-27.424-192h-392.512zM311.072 64l-10.688 32h423.232l-10.688-32h-401.856zM768 928h-512v32h512v-32zM768 448v-192h-47.488l-22.144 192h69.632z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blend",
						"mix"
					],
					"grid": 32
				},
				{
					"id": 1791,
					"width": 804.5709533691406,
					"paths": [
						"M209.143 177.714q-36.571 0-62.857-26t-26.286-63.143q0-36.571 26.286-62.571t62.857-26 62.571 26 26 62.571q0 37.143-26 63.143t-62.571 26zM524 544.571q0 28.571-17.143 38.571t-36.286 3.714-27.143-19.429l-209.714-250.286q-4-6.857-8-8.857t-6.286-0.857l-1.714 1.714q-4 4.571 2.286 12l69.714 79.429 0.571 202.286-92 261.143q-38.286 109.714-52.571 133.714-9.143 14.857-16 18.286-28.571 14.857-58.857 0.571-16.571-7.429-23.714-24.571t-5.429-32.571q1.143-9.714 112.571-353.143l2.857-237.714-48.571 93.714 20 126.857q2.286 13.714-0.571 24t-8 15.714-10.857 9.143-9.714 4.286l-4 1.143q-10.857 1.714-19.714-1.714t-13.714-9.143-8-12.571-4.286-11.143-1.143-5.429l-26.286-170.857 120.571-217.714q13.143-19.429 64.571-19.429 42.857 0 61.143 22.857l242.286 297.714q4 2.857 8 9.714l1.714 1.714-0.571 0.571q4 7.429 4 16.571zM293.714 630.286q24.571 64.571 50.571 128.571t39.714 96l13.714 31.429q20.571 53.143 24 71.429 6.286 40-20.571 55.429-20 12.571-37.714 9.143t-29.143-12.571-16.571-20h-0.571q-3.429-9.143-4.571-14.286l-70.857-200.571zM764.571 968.571q17.714 28 17.714 32.571 0 2.857-1.714 4-5.143 2.857-8.286-0.286t-8.857-14.857-9.143-17.429q-65.143-98.286-241.714-377.714 1.714 0.571 4-0.571t4-2.286l1.714-1.143q6.286-5.143 6.286-9.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blind"
					],
					"defaultCode": 62109,
					"grid": 14
				},
				{
					"id": 2940,
					"paths": [
						"M874.040 149.96c-96.706-96.702-225.28-149.96-362.040-149.96s-265.334 53.258-362.040 149.96c-96.702 96.706-149.96 225.28-149.96 362.040s53.258 265.334 149.96 362.040c96.706 96.702 225.28 149.96 362.040 149.96s265.334-53.258 362.040-149.96c96.702-96.706 149.96-225.28 149.96-362.040s-53.258-265.334-149.96-362.040zM896 512c0 82.814-26.354 159.588-71.112 222.38l-535.266-535.268c62.792-44.758 139.564-71.112 222.378-71.112 211.738 0 384 172.262 384 384zM128 512c0-82.814 26.354-159.586 71.112-222.378l535.27 535.268c-62.794 44.756-139.568 71.11-222.382 71.11-211.738 0-384-172.262-384-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blocked",
						"forbidden",
						"denied",
						"banned"
					],
					"defaultCode": 60775,
					"grid": 16
				},
				{
					"id": 1850,
					"paths": [
						"M384 0v96c73.482 0 144.712 14.37 211.716 42.71 64.768 27.394 122.958 66.632 172.948 116.624s89.228 108.18 116.624 172.948c28.342 67.004 42.712 138.238 42.712 211.718h96c0-353.46-286.54-640-640-640z",
						"M384 192v96c94.022 0 182.418 36.614 248.9 103.098 66.486 66.484 103.1 154.878 103.1 248.902h96c0-247.422-200.576-448-448-448z",
						"M480 384l-64 64-224 64-192 416 25.374 25.374 232.804-232.804c-1.412-5.286-2.178-10.84-2.178-16.57 0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64c-5.732 0-11.282-0.764-16.568-2.178l-232.804 232.804 25.372 25.374 416-192 64-224 64-64-160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blog",
						"pen",
						"feed",
						"publish",
						"broadcast",
						"write"
					],
					"defaultCode": 59685,
					"grid": 16
				},
				{
					"id": 1851,
					"paths": [
						"M384 192v96c94.022 0 182.418 36.614 248.9 103.098 66.486 66.484 103.1 154.878 103.1 248.902h96c0-247.422-200.576-448-448-448zM384 0v96c73.482 0 144.712 14.37 211.716 42.71 64.768 27.394 122.958 66.632 172.948 116.624 49.992 49.992 89.228 108.18 116.624 172.948 28.342 67.004 42.712 138.238 42.712 211.718h96c0-353.46-286.54-640-640-640z",
						"M538.51 485.492c-49.988-49.99-131.036-49.988-181.020-0.002l-357.49 357.49v181.020h181.022l357.488-357.488c49.986-49.984 49.988-131.032 0-181.020zM128 928l-64-64 320-320 64 64-320 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blog",
						"pencil",
						"feed",
						"publish",
						"broadcast",
						"write"
					],
					"defaultCode": 59686,
					"grid": 16
				},
				{
					"id": 3371,
					"paths": [
						"M957.796 384h-57.406c-35.166 0-65.988-29.742-68.39-64v0c0.004-182.668-147.258-320-331.19-320h-167.824c-183.812 0-332.856 148-332.986 330.666v362.798c0 182.654 149.174 330.536 332.984 330.536h358.42c183.948 0 332.596-147.882 332.596-330.536v-234.382c0-36.502-29.44-75.082-66.204-75.082zM320 256h192c35.2 0 64 28.8 64 64s-28.8 64-64 64h-192c-35.2 0-64-28.8-64-64s28.8-64 64-64zM704 768h-384c-35.2 0-64-28.8-64-64s28.8-64 64-64h384c35.2 0 64 28.8 64 64s-28.8 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blogger",
						"brand",
						"social"
					],
					"defaultCode": 61206,
					"grid": 16
				},
				{
					"id": 3372,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM896 648c0 137-111.4 248-249.4 248h-268.8c-138 0-249.8-111-249.8-248v-272c0-137 111.8-248 249.8-248h125.8c138 0 248.4 103 248.4 240 1.8 25.6 25 48 51.2 48h43c27.6 0 49.6 29 49.6 56.4v175.6z",
						"M704 640c0 35.2-28.8 64-64 64h-256c-35.2 0-64-28.8-64-64v0c0-35.2 28.8-64 64-64h256c35.2 0 64 28.8 64 64v0z",
						"M576 384c0 35.2-28.8 64-64 64h-128c-35.2 0-64-28.8-64-64v0c0-35.2 28.8-64 64-64h128c35.2 0 64 28.8 64 64v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blogger",
						"brand",
						"social"
					],
					"defaultCode": 61207,
					"grid": 16
				},
				{
					"id": 321,
					"width": 1024,
					"paths": [
						"M512 767.968v-224.992c107.36-8.224 192-97.504 192-206.944v-129.216c0-49.248-53.312-80.064-95.968-55.424l-112.032 64.608-112.032-64.64c-42.656-24.608-95.968 6.208-95.968 55.456v129.184c0 109.44 84.64 198.752 192 206.944v224.992c-52.704-126.304-165.824-221.088-303.296-248.128-42.56-8.384-81.28 29.44-74.24 72.256 31.392 191.456 175.168 335.936 377.536 335.936h32c202.368 0 346.144-144.48 377.568-335.904 7.040-42.816-31.68-80.64-74.24-72.256-137.504 27.040-250.624 121.824-303.328 248.128zM225.696 784.832c-47.328-52.96-78.688-120.832-91.36-196.032-3.744-22.112 16.032-41.632 38.016-37.184 165.088 33.44 292.128 173.152 306.304 344.384-100.8-0.32-188.224-38.752-252.96-111.168zM672 206.816v110.72l-144-83.072 96-55.392c21.344-12.288 48 3.104 48 27.744zM368 179.104l303.104 174.88c-9.76 96.384-97.28 169.76-198.848 156.48-88.544-11.584-152.256-91.68-152.256-180.992v-122.656c0-24.64 26.656-40.032 48-27.712zM513.312 896c14.208-171.296 141.312-311.040 306.496-344.416 21.92-4.416 41.664 14.976 38.048 37.056-29.792 181.568-165.472 306.752-344.544 307.36z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bloom",
						"grow"
					],
					"grid": 32
				},
				{
					"id": 322,
					"width": 1024,
					"paths": [
						"M512 767.968v-224.992c107.36-8.224 192-97.504 192-206.944v-129.216c0-49.248-53.312-80.064-95.968-55.424l-112.032 64.608-112.032-64.64c-42.656-24.608-95.968 6.208-95.968 55.456v129.184c0 109.44 84.64 198.752 192 206.944v224.992c-52.704-126.304-165.824-221.088-303.296-248.128-42.56-8.384-81.28 29.44-74.24 72.256 31.392 191.456 175.168 335.936 377.536 335.936h32c202.368 0 346.144-144.48 377.568-335.904 7.040-42.816-31.68-80.64-74.24-72.256-137.504 27.040-250.624 121.824-303.328 248.128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bloom",
						"grow"
					],
					"grid": 32
				},
				{
					"id": 965,
					"width": 1024,
					"paths": [
						"M336 160c-97.216 0-176 78.784-176 176s78.784 176 176 176c97.216 0 176-78.784 176-176s-78.784-176-176-176zM336 192c33.92 0 64.736 12.288 89.376 32h-178.752c24.64-19.712 55.456-32 89.376-32zM336 480c-33.92 0-64.736-12.288-89.376-32h178.784c-24.672 19.712-55.488 32-89.408 32zM455.616 416h-239.232c-6.592-9.824-11.488-20.704-15.52-32h270.304c-4.032 11.296-8.96 22.176-15.552 32zM480 336c0 5.472-1.024 10.688-1.632 16h-284.736c-0.608-5.312-1.632-10.528-1.632-16s1.024-10.688 1.632-16h284.768c0.576 5.312 1.6 10.528 1.6 16zM200.832 288c4.032-11.296 8.96-22.176 15.52-32h239.232c6.592 9.824 11.488 20.704 15.52 32h-270.272zM979.68 134.784c-5.664-4.448-12.608-6.784-19.68-6.784-2.592 0-5.184 0.32-7.776 0.96l-111.488 27.872-290.88-36.48c-56.768-56.288-134.048-88.352-213.856-88.352-167.616 0-304 136.384-304 304 0 99.168 47.52 190.432 128 247.552v312.448c0 52.928 43.072 96 96 96h160c52.928 0 96-43.072 96-96v-160c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-56.736c13.696-9.696 26.336-20.256 37.824-31.616l290.912-36.48 111.488 27.872c2.592 0.64 5.184 0.96 7.776 0.96 7.072 0 14.016-2.336 19.68-6.784 7.776-6.048 12.32-15.36 12.32-25.216v-352c0-9.856-4.544-19.168-12.32-25.216zM448 896c0 17.632-14.368 32-32 32h-160c-17.632 0-32-14.368-32-32v-312.32c34.176 15.488 72.032 24.32 112 24.32 40 0 77.856-8.768 112-24.32v312.32zM832 451.776l-312.736 39.232-7.904 8.48c-46.048 49.344-108.32 76.512-175.36 76.512-132.32 0-240-107.68-240-240s107.68-240 240-240c67.040 0 129.312 27.168 175.328 76.544l7.904 8.48 312.768 39.2v231.552zM928 471.008l-64-16v-238.016l64-16v270.016z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"blow",
						"primp",
						"heat",
						"dry"
					],
					"grid": 32
				},
				{
					"id": 1781,
					"width": 877.7119140625,
					"paths": [
						"M480.571 601.714l84.571 84.571-85.143 85.143zM480 252.571l85.143 85.143-84.571 84.571zM405.714 952l265.143-265.143-174.857-174.857 174.857-174.857-265.143-265.143v349.143l-145.714-145.714-53.143 53.143 182.857 183.429-182.857 183.429 53.143 53.143 145.714-145.714v349.143zM816.571 512q0 119.429-18.286 208.857t-50 146.857-80.286 92.857-103.714 49.429-125.429 14-125.429-14-103.714-49.429-80.286-92.857-50-146.857-18.286-208.857 18.286-208.857 50-146.857 80.286-92.857 103.714-49.429 125.429-14 125.429 14 103.714 49.429 80.286 92.857 50 146.857 18.286 208.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bluetooth"
					],
					"defaultCode": 62099,
					"grid": 14
				},
				{
					"id": 1782,
					"width": 585.1439819335938,
					"paths": [
						"M340.571 813.143l98.857-98.286-98.857-98.286v196.571zM340.571 407.429l98.857-98.286-98.857-98.286v196.571zM358.857 512l203.429 203.429-308 308.571v-406.286l-169.714 169.143-61.714-61.714 212.571-213.143-212.571-213.143 61.714-61.714 169.714 169.143v-406.286l308 308.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bluetooth-b"
					],
					"defaultCode": 62100,
					"grid": 14
				},
				{
					"id": 2602,
					"paths": [
						"M0 704v256h704c128 0 320-117 320-256h-1024zM512 64l-512 576h512zM576 192v448h320c0-320-320-448-320-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"boat",
						"travel",
						"sailing",
						"transport"
					],
					"defaultCode": 60437,
					"grid": 16
				},
				{
					"id": 3244,
					"paths": [
						"M641.542 477.004v-8.614c116.294-21.536 253.044-80.758 253.044-233.66 0-77.52-36.618-142.124-95.838-179.816-61.37-39.838-141.052-54.914-263.802-54.914h-470.546v55.99c113.060 10.766 129.212 20.458 129.212 155.056v600.834c0 131.788-15.25 143.688-129.614 155.118v57.002h400.958c134.594 0 256.268-23.692 337.026-67.838 92.606-48.448 150.74-131.362 150.74-234.738 0.002-150.74-122.748-223.96-311.18-244.42zM384.002 153.976c0-32.302 3.23-54.918 14-66.758 9.692-8.612 37.692-20.458 73.218-20.458 88.3 0 174.442 53.836 174.442 197.044 0 128.136-71.070 187.356-226.124 187.356l-35.538-0.002v-297.182zM504.608 956.164c-88.302 2.152-120.608-31.23-120.608-148.594h0.002v-291.804h31.226c186.288 0 281.036 75.376 281.036 222.892 0 151.824-102.284 216.428-191.656 217.506z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bold",
						"wysiwyg"
					],
					"defaultCode": 61079,
					"grid": 16
				},
				{
					"id": 3250,
					"paths": [
						"M707.88 484.652c37.498-44.542 60.12-102.008 60.12-164.652 0-141.16-114.842-256-256-256h-320v896h384c141.158 0 256-114.842 256-256 0-92.956-49.798-174.496-124.12-219.348zM384 192h101.5c55.968 0 101.5 57.42 101.5 128s-45.532 128-101.5 128h-101.5v-256zM543 832h-159v-256h159c58.45 0 106 57.42 106 128s-47.55 128-106 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bold",
						"wysiwyg"
					],
					"defaultCode": 61085,
					"grid": 16
				},
				{
					"id": 1226,
					"width": 804.5668640136719,
					"paths": [
						"M317.143 869.143q42.286 18.286 80 18.286 214.857 0 214.857-191.429 0-65.143-23.429-102.857-15.429-25.143-35.143-42.286t-38.571-26.571-46-14.286-48-6-54-1.143q-41.714 0-57.714 5.714 0 30.286-0.286 90.857t-0.286 90.286q0 4.571-0.571 38.571t-0.286 55.143 2.571 47.714 6.857 38zM309.143 442.857q24 4 62.286 4 46.857 0 81.714-7.429t62.857-25.429 42.571-51.143 14.571-81.143q0-40-16.571-70t-45.143-46.857-61.714-24.857-70.857-8q-28.571 0-74.286 7.429 0 28.571 2.286 86.286t2.286 86.857q0 15.429-0.286 45.714t-0.286 45.143q0 26.286 0.571 39.429zM0 950.857l1.143-53.714q8.571-2.286 48.571-9.143t60.571-15.429q4-6.857 7.143-15.429t4.857-19.143 3.143-18.571 1.714-21.429 0.286-19.429v-37.429q0-561.143-12.571-585.714-2.286-4.571-12.571-8.286t-25.429-6.286-28.286-4-27.714-2.571-17.429-1.714l-2.286-47.429q56-1.143 194.286-6.571t213.143-5.429q13.143 0 39.143 0.286t38.571 0.286q40 0 78 7.429t73.429 24 61.714 40.571 42.286 59.714 16 78.571q0 29.714-9.429 54.571t-22.286 41.143-36.857 32.857-41.714 25.714-48 22.857q88 20 146.571 76.571t58.571 141.714q0 57.143-20 102.571t-53.429 74.571-78.857 48.857-93.429 27.714-100.571 8q-25.143 0-75.429-1.714t-75.429-1.714q-60.571 0-175.429 6.286t-132 6.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bold"
					],
					"defaultCode": 61490,
					"grid": 14
				},
				{
					"id": 242,
					"paths": [
						"M512 460.8h-128c-14.138 0-25.6-11.461-25.6-25.6v-153.6c0-14.138 11.462-25.6 25.6-25.6h128c56.464 0 102.4 45.936 102.4 102.4s-45.936 102.4-102.4 102.4zM409.6 409.6h102.4c28.232 0 51.2-22.968 51.2-51.2s-22.968-51.2-51.2-51.2h-102.4v102.4z",
						"M563.2 768h-179.2c-14.138 0-25.6-11.461-25.6-25.6v-153.6c0-14.139 11.462-25.6 25.6-25.6h179.2c56.464 0 102.4 45.936 102.4 102.4s-45.936 102.4-102.4 102.4zM409.6 716.8h153.6c28.232 0 51.2-22.968 51.2-51.2s-22.968-51.2-51.2-51.2h-153.6v102.4z",
						"M563.2 921.6h-281.6c-42.347 0-76.8-34.451-76.8-76.8v-665.6c0-42.347 34.453-76.8 76.8-76.8h230.4c141.16 0 256 114.842 256 256 0 42.208-10.328 83.355-30.035 120.251 51.886 48.382 81.235 115.346 81.235 186.949 0 141.16-114.84 256-256 256zM281.6 153.6c-14.115 0-25.6 11.485-25.6 25.6v665.6c0 14.115 11.485 25.6 25.6 25.6h281.6c112.926 0 204.8-91.874 204.8-204.8 0-63.322-28.72-122.125-78.797-161.334-10.797-8.453-12.966-23.842-5.134-34.917 21.416-33.088 32.731-71.43 32.731-110.949 0-112.928-91.874-204.8-204.8-204.8h-230.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bold",
						"typography"
					],
					"defaultCode": 59539,
					"grid": 20
				},
				{
					"id": 1384,
					"width": 513.7149524688721,
					"paths": [
						"M505.714 323.429q10.286 11.429 4 25.143l-308.571 661.143q-7.429 14.286-24 14.286-2.286 0-8-1.143-9.714-2.857-14.571-10.857t-2.571-17.143l112.571-461.714-232 57.714q-2.286 0.571-6.857 0.571-10.286 0-17.714-6.286-10.286-8.571-7.429-22.286l114.857-471.429q2.286-8 9.143-13.143t16-5.143h187.429q10.857 0 18.286 7.143t7.429 16.857q0 4.571-2.857 10.286l-97.714 264.571 226.286-56q4.571-1.143 6.857-1.143 10.857 0 19.429 8.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bolt",
						"flash"
					],
					"defaultCode": 61671,
					"grid": 14
				},
				{
					"id": 2556,
					"paths": [
						"M1024 64v26.508l-37.49 37.492 37.49 37.492v26.508h-64v64h-26.51l-37.49-37.49-37.492 37.49h-26.51v-64h-64v-0.752c-13.010-0.458-25.426-3.062-37.302-7.906-29.62-12.080-49.928-35.056-69.564-57.274-19.346-21.888-37.62-42.562-63.252-51.106-32.34-10.782-77.222-19.076-107.34 2.632-14.246 10.268-25.044 27.302-32.202 50.406h5.662c26.4 0 48 21.6 48 48v27.154c183.464 43.34 320 208.14 320 404.846 0 229.75-186.25 416-416 416s-416-186.25-416-416c0-196.706 136.536-361.506 320-404.846v-27.154c0-26.4 21.6-48 48-48h24.16c10.424-46.316 30.802-80.588 60.96-102.326 41.228-29.718 98.288-33.666 165-11.428 41.954 13.984 67.994 43.446 90.966 69.438 30.356 34.348 47.482 53.726 90.504 38.416l-31.59-31.592v-26.508h64v-64h26.51l37.49 37.49 37.49-37.49h26.51v64h64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bomb",
						"explosive",
						"destroy",
						"detonate"
					],
					"defaultCode": 60391,
					"grid": 16
				},
				{
					"id": 1617,
					"width": 1024.000991821289,
					"paths": [
						"M326.286 336.571q-5.714-14.286-19.429-20t-28 0q-61.714 25.143-109.143 72.571t-72.571 109.143q-5.714 14.286 0 28t20 19.429q7.429 2.857 13.714 2.857 24 0 34.286-22.857 19.429-48 56.286-84.857t84.857-56.286q14.286-6.286 20-20t0-28zM864.571 133.143l26.286 26.286-139.429 138.857 38.857 38.857q10.857 10.857 10.857 26t-10.857 26l-36.571 36.571q50.857 92 50.857 196 0 81.714-31.714 156.286t-85.714 128.571-128.571 85.714-156.286 31.714-156.286-31.714-128.571-85.714-85.714-128.571-31.714-156.286 31.714-156.286 85.714-128.571 128.571-85.714 156.286-31.714q104 0 196 50.857l36.571-36.571q10.857-10.857 26-10.857t26 10.857l38.857 38.857zM869.143 101.143q-5.714 5.714-12.571 5.714-7.429 0-13.143-5.714l-52-51.429q-5.143-5.714-5.143-13.143t5.143-13.143q5.714-5.143 13.143-5.143t13.143 5.143l51.429 52q5.714 5.143 5.714 12.857t-5.714 12.857zM1000.571 232.571q-6.286 5.143-13.143 5.143t-13.143-5.143l-51.429-52q-5.714-5.143-5.714-12.857t5.714-12.857q5.143-5.714 12.857-5.714t12.857 5.714l52 51.429q5.143 5.714 5.143 13.143t-5.143 13.143zM1024 128q0 8-5.143 13.143t-13.143 5.143h-54.857q-8 0-13.143-5.143t-5.143-13.143 5.143-13.143 13.143-5.143h54.857q8 0 13.143 5.143t5.143 13.143zM914.286 18.286v54.857q0 8-5.143 13.143t-13.143 5.143-13.143-5.143-5.143-13.143v-54.857q0-8 5.143-13.143t13.143-5.143 13.143 5.143 5.143 13.143zM1000.571 49.714l-52 51.429q-5.714 5.714-12.571 5.714-7.429 0-13.143-5.714-5.714-5.143-5.714-12.857t5.714-12.857l51.429-52q5.714-5.143 13.143-5.143t13.143 5.143q5.143 5.714 5.143 13.143t-5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bomb"
					],
					"defaultCode": 61922,
					"grid": 14
				},
				{
					"id": 1957,
					"paths": [
						"M1016.904 230.658c-51.096-63.322-146.47-102.658-248.904-102.658s-197.808 39.336-248.904 102.658c-4.592 5.69-7.096 12.782-7.096 20.094 0-7.312-2.504-14.404-7.096-20.094-51.094-63.322-146.468-102.658-248.904-102.658s-197.81 39.336-248.904 102.658c-4.592 5.69-7.096 12.782-7.096 20.094v640c0 13.564 8.554 25.656 21.344 30.174 12.792 4.518 27.042 0.48 35.56-10.078 39.242-48.636 115.532-78.848 199.096-78.848s159.854 30.212 199.096 78.848c6.196 7.678 15.418 11.908 24.91 11.908h63.988c9.49 0 18.716-4.23 24.91-11.908 39.242-48.636 115.532-78.848 199.096-78.848 83.562 0 159.852 30.212 199.096 78.848 8.52 10.554 22.766 14.594 35.56 10.078 12.792-4.518 21.344-16.61 21.344-30.174v-640c0-7.312-2.504-14.404-7.096-20.094zM448 820.58c-52.022-33.296-120.28-52.58-192-52.58-71.718 0-139.978 19.284-192 52.578v-557.898c40.904-43.826 113.22-70.68 192-70.68s151.096 26.856 192 70.68v557.9zM960 820.578c-52.024-33.294-120.282-52.578-192-52.578s-139.976 19.284-192 52.58v-557.9c40.904-43.824 113.22-70.68 192-70.68s151.096 26.854 192 70.68v557.898z",
						"M640 320h256v64h-256v-64z",
						"M640 448h256v64h-256v-64z",
						"M640 576h192v64h-192v-64z",
						"M128 320h256v64h-256v-64z",
						"M128 448h256v64h-256v-64z",
						"M128 576h192v64h-192v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"book",
						"read",
						"reading"
					],
					"defaultCode": 59792,
					"grid": 16
				},
				{
					"id": 1959,
					"paths": [
						"M384 352l320 192-320 192v-384z",
						"M512 974.754c-9.674 0-18.83-4.376-24.904-11.906-37.65-46.66-144.478-98.848-231.096-98.848-83.564 0-159.858 30.212-199.096 78.848-8.52 10.558-22.77 14.596-35.558 10.078-12.792-4.518-21.346-16.61-21.346-30.174v-672c0-7.312 2.504-14.404 7.096-20.094 51.094-63.322 146.468-102.658 248.904-102.658 93.278 0 197.908 46.594 256 97.208 58.094-50.614 162.724-97.208 256-97.208 102.436 0 197.804 39.336 248.9 102.658 4.592 5.69 7.1 12.782 7.1 20.094v672c0 13.564-8.552 25.656-21.348 30.174-12.792 4.516-27.042 0.476-35.556-10.078-39.244-48.636-115.534-78.848-199.096-78.848-86.62 0-193.45 52.188-231.096 98.848-6.076 7.528-15.23 11.906-24.904 11.906zM256 800c93.278 0 197.908 46.594 256 97.208 58.092-50.614 162.722-97.208 256-97.208 71.714 0 139.972 19.286 192 52.578v-589.898c-40.904-43.826-113.22-70.68-192-70.68-86.62 0-193.45 52.186-231.096 98.848-6.076 7.53-15.23 11.906-24.904 11.906s-18.83-4.376-24.904-11.906c-37.65-46.662-144.48-98.848-231.096-98.848-78.784 0-151.096 26.854-192 70.68v589.898c52.022-33.292 120.282-52.578 192-52.578z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"book-play",
						"book",
						"audio-book",
						"listen"
					],
					"defaultCode": 59794,
					"grid": 16
				},
				{
					"id": 1958,
					"paths": [
						"M1016.904 230.658c-51.096-63.322-146.47-102.658-248.904-102.658s-197.808 39.336-248.904 102.658c-4.592 5.69-7.096 12.782-7.096 20.094 0-7.312-2.504-14.404-7.096-20.094-51.094-63.322-146.468-102.658-248.904-102.658s-197.81 39.336-248.904 102.658c-4.592 5.69-7.096 12.782-7.096 20.094v640c0 13.564 8.554 25.656 21.344 30.174 12.792 4.518 27.042 0.48 35.56-10.078 39.242-48.636 115.532-78.848 199.096-78.848s159.854 30.212 199.096 78.848c6.196 7.678 15.418 11.908 24.91 11.908h63.988c9.49 0 18.716-4.23 24.91-11.908 39.242-48.636 115.532-78.848 199.096-78.848 83.562 0 159.852 30.212 199.096 78.848 8.52 10.554 22.766 14.594 35.56 10.078 12.792-4.518 21.344-16.61 21.344-30.174v-640c0-7.312-2.504-14.404-7.096-20.094zM448 820.58c-52.022-33.296-120.28-52.58-192-52.58-71.718 0-139.978 19.284-192 52.578v-557.898c40.904-43.826 113.22-70.68 192-70.68s151.096 26.856 192 70.68v557.9zM960 820.578c-52.024-33.294-120.282-52.578-192-52.578s-139.976 19.284-192 52.58v-557.9c40.904-43.824 113.22-70.68 192-70.68s151.096 26.854 192 70.68v557.898z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"book",
						"read",
						"reading"
					],
					"defaultCode": 59793,
					"grid": 16
				},
				{
					"id": 1960,
					"paths": [
						"M896 128v832h-672c-53.026 0-96-42.98-96-96s42.974-96 96-96h608v-768h-640c-70.398 0-128 57.6-128 128v768c0 70.4 57.602 128 128 128h768v-896h-64z",
						"M224.056 832v0c-0.018 0.002-0.038 0-0.056 0-17.672 0-32 14.326-32 32s14.328 32 32 32c0.018 0 0.038-0.002 0.056-0.002v0.002h607.89v-64h-607.89z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"book",
						"read",
						"reading"
					],
					"defaultCode": 59795,
					"grid": 16
				},
				{
					"id": 1221,
					"width": 952.5709400177002,
					"paths": [
						"M936.571 273.143q22.857 32.571 10.286 73.714l-157.143 517.714q-10.857 36.571-43.714 61.429t-70 24.857h-527.429q-44 0-84.857-30.571t-56.857-75.143q-13.714-38.286-1.143-72.571 0-2.286 1.714-15.429t2.286-21.143q0.571-4.571-1.714-12.286t-1.714-11.143q1.143-6.286 4.571-12t9.429-13.429 9.429-13.429q13.143-21.714 25.714-52.286t17.143-52.286q1.714-5.714 0.286-17.143t-0.286-16q1.714-6.286 9.714-16t9.714-13.143q12-20.571 24-52.571t14.286-51.429q0.571-5.143-1.429-18.286t0.286-16q2.286-7.429 12.571-17.429t12.571-12.857q10.857-14.857 24.286-48.286t15.714-55.143q0.571-4.571-1.714-14.571t-1.143-15.143q1.143-4.571 5.143-10.286t10.286-13.143 9.714-12q4.571-6.857 9.429-17.429t8.571-20 9.143-20.571 11.143-18.286 15.143-13.429 20.571-6.571 27.143 3.143l-0.571 1.714q21.714-5.143 29.143-5.143h434.857q42.286 0 65.143 32t10.286 74.286l-156.571 517.714q-20.571 68-40.857 87.714t-73.429 19.714h-496.571q-15.429 0-21.714 8.571-6.286 9.143-0.571 24.571 13.714 40 82.286 40h527.429q16.571 0 32-8.857t20-23.714l171.429-564q4-12.571 2.857-32.571 21.714 8.571 33.714 24.571zM328.571 274.286q-2.286 7.429 1.143 12.857t11.429 5.429h347.429q7.429 0 14.571-5.429t9.429-12.857l12-36.571q2.286-7.429-1.143-12.857t-11.429-5.429h-347.429q-7.429 0-14.571 5.429t-9.429 12.857zM281.143 420.571q-2.286 7.429 1.143 12.857t11.429 5.429h347.429q7.429 0 14.571-5.429t9.429-12.857l12-36.571q2.286-7.429-1.143-12.857t-11.429-5.429h-347.429q-7.429 0-14.571 5.429t-9.429 12.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"book"
					],
					"defaultCode": 61485,
					"grid": 14
				},
				{
					"id": 135,
					"paths": [
						"M742.4 921.6h-512c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h512c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M844.8 153.6c-14.139 0-25.6 11.462-25.6 25.6v768c0 14.115-11.485 25.6-25.6 25.6h-563.2c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8h460.8c42.349 0 76.8-34.451 76.8-76.8v-614.4c0-42.347-34.451-76.8-76.8-76.8h-512c-42.347 0-76.8 34.453-76.8 76.8v768c0 70.579 57.421 128 128 128h563.2c42.349 0 76.8-34.451 76.8-76.8v-768c0-14.138-11.461-25.6-25.6-25.6zM179.2 102.4h512c14.115 0 25.6 11.485 25.6 25.6v614.4c0 14.115-11.485 25.6-25.6 25.6h-460.8c-28.794 0-55.392 9.563-76.8 25.67v-665.67c0-14.115 11.485-25.6 25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"book",
						"read"
					],
					"defaultCode": 59432,
					"grid": 20
				},
				{
					"id": 1961,
					"paths": [
						"M896 128v832h-672c-53.026 0-96-42.98-96-96s42.974-96 96-96h608v-768h-640c-70.398 0-128 57.6-128 128v768c0 70.4 57.602 128 128 128h768v-896h-64zM320 32h320v448l-160-160-160 160v-448z",
						"M224.056 832v0c-0.018 0.002-0.038 0-0.056 0-17.672 0-32 14.326-32 32s14.328 32 32 32c0.018 0 0.038-0.002 0.056-0.002v0.002h607.89v-64h-607.89z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark",
						"book"
					],
					"defaultCode": 59796,
					"grid": 16
				},
				{
					"id": 1321,
					"width": 731.428035736084,
					"paths": [
						"M658.286 146.286h-585.143v709.714l292.571-280.571 50.857 48.571 241.714 232v-709.714zM665.143 73.143q13.143 0 25.143 5.143 18.857 7.429 30 23.429t11.143 35.429v736.571q0 19.429-11.143 35.429t-30 23.429q-10.857 4.571-25.143 4.571-27.429 0-47.429-18.286l-252-242.286-252 242.286q-20.571 18.857-47.429 18.857-13.143 0-25.143-5.143-18.857-7.429-30-23.429t-11.143-35.429v-736.571q0-19.429 11.143-35.429t30-23.429q12-5.143 25.143-5.143h598.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark-o"
					],
					"defaultCode": 61591,
					"grid": 14
				},
				{
					"id": 2764,
					"paths": [
						"M192 0v1024l320-320 320 320v-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark",
						"ribbon"
					],
					"defaultCode": 60599,
					"grid": 16
				},
				{
					"id": 2765,
					"paths": [
						"M192 0v1024l320-320 320 320v-1024h-640zM768 869.49l-256-256-256 256v-805.49h512v805.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark",
						"ribbon"
					],
					"defaultCode": 60600,
					"grid": 16
				},
				{
					"id": 2767,
					"paths": [
						"M835.778 0h-771.778v896l64 128h768v-903.552l-60.222-120.448zM796.222 64l32 64h-188.222l-32-64h188.222zM128 64h224l32 64h-224l-32-64zM832 960h-640v-768h192v384l128-128 128 128v-384h192v768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark",
						"book"
					],
					"defaultCode": 60602,
					"grid": 16
				},
				{
					"id": 1222,
					"width": 731.428035736084,
					"paths": [
						"M665.143 73.143q13.143 0 25.143 5.143 18.857 7.429 30 23.429t11.143 35.429v736.571q0 19.429-11.143 35.429t-30 23.429q-10.857 4.571-25.143 4.571-27.429 0-47.429-18.286l-252-242.286-252 242.286q-20.571 18.857-47.429 18.857-13.143 0-25.143-5.143-18.857-7.429-30-23.429t-11.143-35.429v-736.571q0-19.429 11.143-35.429t30-23.429q12-5.143 25.143-5.143h598.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark"
					],
					"defaultCode": 61486,
					"grid": 14
				},
				{
					"id": 136,
					"paths": [
						"M793.605 1024.002c-7.331 0-14.482-3.155-19.442-8.941l-287.763-335.723-287.763 335.723c-6.971 8.131-18.269 11.067-28.318 7.349-10.048-3.715-16.718-13.298-16.718-24.010v-921.6c0-14.138 11.462-25.6 25.6-25.6h614.4c14.139 0 25.6 11.462 25.6 25.6v921.6c0 10.712-6.67 20.294-16.718 24.010-2.899 1.074-5.904 1.592-8.877 1.592zM486.4 614.4c7.474 0 14.573 3.266 19.437 8.939l262.163 305.858v-826.797h-563.2v826.797l262.163-305.858c4.864-5.674 11.963-8.939 19.437-8.939z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark",
						"ribbon"
					],
					"defaultCode": 59433,
					"grid": 20
				},
				{
					"id": 323,
					"width": 1024,
					"paths": [
						"M384 528c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16zM368 448h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16zM1024 224v576c0 53.024-42.976 96-96 96h-320c0 17.664-14.336 32-32 32h-128c-17.664 0-32-14.336-32-32h-320c-53.024 0-96-42.976-96-96v-576c0-53.024 42.976-96 96-96h544c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32h96c53.024 0 96 42.976 96 96zM672 530.752l64-64 64 64v-402.752h-128v402.752zM528 820.224l13.408-6.72c17.696-8.832 37.472-13.504 57.248-13.504h329.344v-640h-96v370.752c0 19.296-15.776 32.064-32.224 32.064-7.872 0-15.872-2.912-22.4-9.44l-41.376-41.376-41.376 41.376c-6.528 6.528-14.528 9.44-22.4 9.44-16.448 0-32.224-12.768-32.224-32.064v-370.752h-112v660.224zM96 800h329.344c19.776 0 39.552 4.672 57.248 13.504l13.408 6.72v-660.224h-400v640zM992 224c0-23.584-12.96-44-32-55.104v631.104c0 17.664-14.336 32-32 32h-329.344c-14.912 0-29.6 3.456-42.944 10.144l-29.408 14.72c-4.512 2.24-9.408 3.392-14.304 3.392s-9.792-1.12-14.304-3.392l-29.408-14.72c-13.344-6.688-28.032-10.144-42.944-10.144h-329.344c-17.664 0-32-14.336-32-32v-631.104c-19.040 11.104-32 31.52-32 55.104v576c0 35.296 28.704 64 64 64h352v32h128v-32h352c35.296 0 64-28.704 64-64v-576zM368 384h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark",
						"read",
						"save",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 324,
					"width": 1024,
					"paths": [
						"M640 128v402.752c0 19.296 15.776 32.064 32.224 32.064 7.872 0 15.872-2.912 22.4-9.44l41.376-41.376 41.376 41.376c6.528 6.528 14.528 9.44 22.4 9.44 16.448 0 32.224-12.768 32.224-32.064v-402.752h96v672h-336.896c-14.816 0-29.664 3.488-42.912 10.144l-20.192 10.080v-692.224h112zM800 530.752v-402.752c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v402.752l64-64 64 64zM432.896 800h-336.896v-672h400v692.224l-20.16-10.080c-13.28-6.624-28.128-10.144-42.944-10.144zM384 528c0-8.832-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16zM384 464c0-8.832-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16zM384 400c0-8.832-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16zM960 133.888v666.112c0 17.664-14.336 32-32 32h-336.896c-9.92 0-19.744 2.304-28.608 6.752l-36.192 18.080c-4.512 2.24-9.408 3.392-14.304 3.392s-9.824-1.12-14.304-3.392l-36.16-18.080c-8.896-4.448-18.72-6.752-28.64-6.752h-336.896c-17.664 0-32-14.336-32-32v-666.112c-37.216 13.216-64 48.384-64 90.112v576c0 53.024 42.976 96 96 96h320c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32h320c53.024 0 96-42.976 96-96v-576c0-41.728-26.784-76.896-64-90.112z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark",
						"read",
						"save",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 966,
					"width": 1024,
					"paths": [
						"M928 0h-704c-8.48 0-16.64 3.36-22.624 9.376l-96 96c-6.016 5.984-9.376 14.112-9.376 22.624v864c0 17.696 14.336 32 32 32h704c8.48 0 16.64-3.36 22.624-9.376l96-96c6.016-5.984 9.376-14.112 9.376-22.624v-864c0-17.696-14.336-32-32-32zM160 160h64v384c0 12.928 7.808 24.608 19.744 29.568 3.968 1.632 8.128 2.432 12.256 2.432 8.32 0 16.512-3.264 22.624-9.376l41.376-41.376 41.376 41.376c6.112 6.112 14.304 9.376 22.624 9.376 4.128 0 8.288-0.8 12.224-2.432 11.968-4.96 19.776-16.64 19.776-29.568v-384h384v800h-640v-800zM256 128h128v416l-64-64-64 64v-416zM896 882.752l-64 64v-786.752c0-17.664-14.336-32-32-32h-384c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32h-50.752l64-64h658.752v818.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmark",
						"read",
						"save",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 2766,
					"paths": [
						"M256 128v896l320-320 320 320v-896zM768 0h-640v896l64-64v-768h576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bookmarks",
						"ribbons"
					],
					"defaultCode": 60601,
					"grid": 16
				},
				{
					"id": 1962,
					"width": 1152,
					"paths": [
						"M224 128h-192c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-704c0-17.6-14.4-32-32-32zM192 320h-128v-64h128v64z",
						"M544 128h-192c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-704c0-17.6-14.4-32-32-32zM512 320h-128v-64h128v64z",
						"M765.088 177.48l-171.464 86.394c-15.716 7.918-22.096 27.258-14.178 42.976l287.978 571.548c7.918 15.718 27.258 22.098 42.976 14.178l171.464-86.392c15.716-7.92 22.096-27.26 14.178-42.974l-287.978-571.55c-7.92-15.718-27.26-22.1-42.976-14.18z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"books",
						"library",
						"archive"
					],
					"defaultCode": 59797,
					"grid": 16
				},
				{
					"id": 325,
					"width": 1024,
					"paths": [
						"M841.248 18.112c-5.28-11.2-16.48-18.112-28.864-18.112h-600.768c-12.384 0-23.584 6.912-28.864 18.112-24.032 51.168-86.752 211.552-86.752 493.888s62.72 442.72 86.752 493.888c5.28 11.2 16.48 18.112 28.864 18.112h600.768c12.384 0 23.584-6.912 28.864-18.112 24.032-51.168 86.752-211.552 86.752-493.888s-62.72-442.72-86.752-493.888zM288 32h524.32c8.096 17.376 21.344 49.376 34.944 96h-79.264v-16c0-8.832-7.168-16-16-16s-16 7.168-16 16v16h-384v-16c0-8.832-7.168-16-16-16s-16 7.168-16 16v16h-32v-96zM211.68 32h44.32v96h-79.296c13.632-46.656 26.88-78.656 34.976-96zM167.968 160h688.096c4.928 19.296 9.728 40.704 14.24 64h-716.576c4.512-23.296 9.312-44.704 14.24-64zM256 256v512h-32v-512h32zM128 512c0-101.216 8.352-186.336 19.936-256h44.064v512h-44.224c-11.52-69.536-19.776-154.56-19.776-256zM256 992h-44.416c-8.128-17.312-21.472-49.216-35.104-96h79.52v96zM320 992h-32v-96h32v96zM812.32 992h-460.32v-96h384v16c0 8.832 7.168 16 16 16s16-7.168 16-16v-16h79.296c-13.632 46.656-26.88 78.656-34.976 96zM856.032 864h-688.32c-4.928-19.296-9.696-40.704-14.208-64h716.736c-4.48 23.296-9.28 44.704-14.208 64zM832 768v-432c0-8.832-7.168-16-16-16s-16 7.168-16 16v432h-32v-304c0-8.832-7.168-16-16-16s-16 7.168-16 16v304h-384v-208c0-8.832-7.168-16-16-16s-16 7.168-16 16v208h-32v-512h32v80c0 8.832 7.168 16 16 16s16-7.168 16-16v-80h524.064c11.584 69.696 19.936 154.784 19.936 256s-8.352 186.304-19.936 256h-44.064zM384 416v64c0 17.664-14.336 32-32 32s-32-14.336-32-32v-64c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bootleg",
						"brew",
						"ferment"
					],
					"grid": 32
				},
				{
					"id": 326,
					"width": 1024,
					"paths": [
						"M192 768h-76.576c-11.36-70.272-19.424-155.232-19.424-256s8.064-185.728 19.424-256h76.576v512zM352 256h556.576c11.36 70.272 19.424 155.232 19.424 256s-8.064 185.728-19.424 256h-76.576v-432c0-8.832-7.168-16-16-16s-16 7.168-16 16v432h-32v-304c0-8.832-7.168-16-16-16s-16 7.168-16 16v304h-384v-208c0-8.832-7.168-16-16-16s-16 7.168-16 16v208h-32v-512h32v80c0 8.832 7.168 16 16 16s16-7.168 16-16v-80zM352 384c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32s32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM256 128v-80c0-8.832 7.168-16 16-16s16 7.168 16 16v80h32v-16c0-8.832 7.168-16 16-16s16 7.168 16 16v16h384v-16c0-8.832 7.168-16 16-16s16 7.168 16 16v16h112.768c-15.040-53.504-30.208-90.016-39.552-109.888-5.248-11.2-16.448-18.112-28.832-18.112h-600.768c-12.384 0-23.584 6.912-28.864 18.112-9.312 19.872-24.48 56.384-39.52 109.888h112.768zM224 256v512h32v-512h-32zM768 896v16c0 8.832-7.168 16-16 16s-16-7.168-16-16v-16h-384v80c0 8.832-7.168 16-16 16s-16-7.168-16-16v-80h-32v80c0 8.832-7.168 16-16 16s-16-7.168-16-16v-80h-112.768c15.040 53.504 30.208 90.016 39.552 109.888 5.248 11.2 16.448 18.112 28.832 18.112h600.768c12.384 0 23.584-6.912 28.864-18.112 9.344-19.84 24.48-56.384 39.552-109.888h-112.8zM134.816 160c-4.8 19.488-9.472 40.832-13.824 64h781.984c-4.352-23.168-8.992-44.512-13.824-64h-754.336zM889.184 864c4.8-19.488 9.472-40.832 13.824-64h-781.984c4.352 23.168 8.992 44.512 13.824 64h754.336z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bootleg",
						"brew",
						"ferment"
					],
					"grid": 32
				},
				{
					"id": 2507,
					"paths": [
						"M576 320v-256h16c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h16v256c0 101.664-128 128-128 224.538v447.462c0 17.674 14.328 32 32 32h320c17.672 0 32-14.326 32-32v-447.462c0-96.538-128-122.874-128-224.538z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bottle",
						"drink",
						"beverage"
					],
					"defaultCode": 60342,
					"grid": 16
				},
				{
					"id": 2508,
					"paths": [
						"M576 320v-256h16c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h16v256c0 101.664-128 128-128 224.538v447.462c0 17.674 14.328 32 32 32h320c17.672 0 32-14.326 32-32v-447.462c0-96.538-128-122.874-128-224.538zM640 943.698c-33.968 10.136-78.822 16.302-128 16.302s-94.030-6.166-128-16.302v-320c33.97 10.136 78.822 16.302 128 16.302s94.032-6.166 128-16.302v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bottle",
						"drink",
						"beverage"
					],
					"defaultCode": 60343,
					"grid": 16
				},
				{
					"id": 2509,
					"paths": [
						"M768 288c0-52.934-43.066-96-96-96-17.644 0-32-14.356-32-32v-128c0-17.672-14.326-32-32-32h-192c-17.672 0-32 14.328-32 32v128c0 17.644-14.356 32-32 32-52.934 0-96 43.066-96 96v64c0 24.564 9.274 47.004 24.504 64-15.23 16.996-24.504 39.436-24.504 64v64c0 24.564 9.274 47.004 24.504 64-15.23 16.996-24.504 39.436-24.504 64v64c0 24.564 9.274 47.004 24.504 64-15.23 16.996-24.504 39.436-24.504 64v64c0 52.934 43.066 96 96 96h320c52.934 0 96-43.066 96-96v-64c0-24.564-9.274-47.004-24.504-64 15.23-16.996 24.504-39.436 24.504-64v-64c0-24.564-9.274-47.004-24.504-64 15.23-16.996 24.504-39.436 24.504-64v-64c0-24.564-9.274-47.004-24.504-64 15.23-16.996 24.504-39.436 24.504-64v-64zM704 352c0 17.644-14.356 32-32 32-17.674 0-32 14.328-32 32s14.326 32 32 32c17.644 0 32 14.356 32 32v64c0 17.644-14.356 32-32 32-17.674 0-32 14.326-32 32s14.326 32 32 32c17.644 0 32 14.356 32 32v64c0 17.644-14.356 32-32 32-17.674 0-32 14.326-32 32s14.326 32 32 32c17.644 0 32 14.356 32 32v64c0 17.644-14.356 32-32 32h-320c-17.644 0-32-14.356-32-32v-64c0-17.644 14.356-32 32-32 17.672 0 32-14.326 32-32s-14.328-32-32-32c-17.644 0-32-14.356-32-32v-64c0-17.644 14.356-32 32-32 17.672 0 32-14.326 32-32s-14.328-32-32-32c-17.644 0-32-14.356-32-32v-64c0-17.644 14.356-32 32-32 17.672 0 32-14.328 32-32s-14.328-32-32-32c-17.644 0-32-14.356-32-32v-64c0-17.644 14.356-32 32-32 52.934 0 96-43.066 96-96v-32h128v32c0 52.934 43.064 96 96 96 17.644 0 32 14.356 32 32v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bottle",
						"drink",
						"water"
					],
					"defaultCode": 60344,
					"grid": 16
				},
				{
					"id": 2510,
					"paths": [
						"M768 288c0-52.934-43.066-96-96-96-17.644 0-32-14.356-32-32v-128c0-17.672-14.326-32-32-32h-192c-17.672 0-32 14.328-32 32v128c0 17.644-14.356 32-32 32-52.934 0-96 43.066-96 96v64c0 24.564 9.274 47.004 24.504 64-15.23 16.996-24.504 39.436-24.504 64v64c0 24.564 9.274 47.004 24.504 64-15.23 16.996-24.504 39.436-24.504 64v64c0 24.564 9.274 47.004 24.504 64-15.23 16.996-24.504 39.436-24.504 64v64c0 52.934 43.066 96 96 96h320c52.934 0 96-43.066 96-96v-64c0-24.564-9.274-47.004-24.504-64 15.23-16.996 24.504-39.436 24.504-64v-64c0-24.564-9.274-47.004-24.504-64 15.23-16.996 24.504-39.436 24.504-64v-64c0-24.564-9.274-47.004-24.504-64 15.23-16.996 24.504-39.436 24.504-64v-64zM656 960v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16h-16v-16h-16v16c-5.832 0-11.288-1.594-16-4.33v-11.67h-11.67c-2.736-4.712-4.33-10.168-4.33-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-11.67c2.806-4.836 6.834-8.864 11.67-11.67v11.67h16v-16h16v-4.316c4.844-2.806 8.878-6.838 11.684-11.684h4.316v-16c0-5.836-1.586-11.29-4.316-16h4.316v-16h-16v4.316c-4.71-2.728-10.164-4.316-16-4.316-5.832 0-11.288-1.594-16-4.33v-11.67h-11.67c-2.736-4.712-4.33-10.168-4.33-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-11.67c2.806-4.836 6.834-8.864 11.67-11.67v11.67h16v-16h16v-4.316c4.844-2.806 8.878-6.838 11.684-11.684h4.316v-16c0-5.836-1.586-11.29-4.316-16h4.316v-16h-16v4.316c-4.71-2.728-10.164-4.316-16-4.316-5.832 0-11.288-1.594-16-4.33v-11.67h-11.67c-2.736-4.712-4.33-10.168-4.33-16h16v-16h-16v-16h16v-16h-16v-16h16v-16h-11.67c2.806-4.834 6.834-8.864 11.67-11.67v11.67h16v-16h16v-4.316c4.844-2.806 8.876-6.838 11.684-11.684h4.316v-16c0-5.836-1.586-11.29-4.316-16h4.316v-16h-16v4.316c-4.71-2.73-10.164-4.316-16-4.316-5.832 0-11.288-1.594-16-4.33v-11.67h-11.67c-2.736-4.712-4.33-10.168-4.33-16h16v-16h-16v-48c0-17.644 14.356-32 32-32 52.934 0 96-43.066 96-96v-32h128v32c0 52.934 43.064 96 96 96 17.644 0 32 14.356 32 32v32h-16v16h16v16h-16v16h11.67c-2.806 4.834-6.834 8.864-11.67 11.67v-11.67h-16v16h-16v4.316c-4.846 2.806-8.876 6.838-11.684 11.684h-4.316v16c0 5.836 1.588 11.29 4.316 16h-4.316v16h16v-4.316c4.71 2.73 10.164 4.316 16 4.316 5.832 0 11.288 1.594 16 4.33v11.67h11.67c2.736 4.712 4.33 10.168 4.33 16h-16v16h16v16h-16v16h16v16h-16v16h11.67c-2.806 4.836-6.834 8.864-11.67 11.67v-11.67h-16v16h-16v4.316c-4.846 2.806-8.876 6.838-11.684 11.684h-4.316v16c0 5.836 1.588 11.29 4.316 16h-4.316v16h16v-4.316c4.71 2.728 10.164 4.316 16 4.316 5.832 0 11.288 1.594 16 4.33v11.67h11.67c2.736 4.712 4.33 10.168 4.33 16h-16v16h16v16h-16v16h16v16h-16v16h11.67c-2.806 4.836-6.834 8.864-11.67 11.67v-11.67h-16v16h-16v4.316c-4.846 2.806-8.876 6.838-11.684 11.684h-4.316v16c0 5.836 1.588 11.29 4.316 16h-4.316v16h16v-4.316c4.71 2.728 10.164 4.316 16 4.316 5.832 0 11.288 1.594 16 4.33v11.67h11.67c2.736 4.712 4.33 10.168 4.33 16h-16v16h16v16h-16v16h16v16h-16v16h11.67c-2.806 4.836-6.834 8.864-11.67 11.67v-11.67h-16v16h-16zM336 512h16v16h-16v-16zM352 528h16v16h-16v-16zM368 512h16v16h-16v-16zM336 544h16v16h-16v-16zM352 560h16v16h-16v-16zM368 544h16v16h-16v-16zM384 528h16v16h-16v-16zM400 512h16v16h-16v-16zM416 528h16v16h-16v-16zM432 512h16v16h-16v-16zM384 560h16v16h-16v-16zM400 544h16v16h-16v-16zM416 560h16v16h-16v-16zM432 544h16v16h-16v-16zM448 528h16v16h-16v-16zM464 512h16v16h-16v-16zM480 528h16v16h-16v-16zM496 512h16v16h-16v-16zM448 560h16v16h-16v-16zM464 544h16v16h-16v-16zM480 560h16v16h-16v-16zM496 544h16v16h-16v-16zM384 592h16v16h-16v-16zM400 576h16v16h-16v-16zM416 592h16v16h-16v-16zM432 576h16v16h-16v-16zM384 624h16v16h-16v-16zM400 608h16v16h-16v-16zM416 624h16v16h-16v-16zM432 608h16v16h-16v-16zM448 592h16v16h-16v-16zM464 576h16v16h-16v-16zM480 592h16v16h-16v-16zM496 576h16v16h-16v-16zM448 624h16v16h-16v-16zM464 608h16v16h-16v-16zM480 624h16v16h-16v-16zM496 608h16v16h-16v-16zM352 656h16v16h-16v-16zM368 640h16v16h-16v-16zM336 672h16v16h-16v-16zM352 688h16v16h-16v-16zM368 672h16v16h-16v-16zM336 704h16v16h-16v-16zM352 720h16v16h-16v-16zM368 704h16v16h-16v-16zM336 736h16v16h-16v-16zM352 752h16v16h-16v-16zM368 736h16v16h-16v-16zM384 656h16v16h-16v-16zM400 640h16v16h-16v-16zM416 656h16v16h-16v-16zM432 640h16v16h-16v-16zM384 688h16v16h-16v-16zM400 672h16v16h-16v-16zM416 688h16v16h-16v-16zM432 672h16v16h-16v-16zM448 656h16v16h-16v-16zM464 640h16v16h-16v-16zM480 656h16v16h-16v-16zM496 640h16v16h-16v-16zM448 688h16v16h-16v-16zM464 672h16v16h-16v-16zM480 688h16v16h-16v-16zM496 672h16v16h-16v-16zM384 720h16v16h-16v-16zM400 704h16v16h-16v-16zM416 720h16v16h-16v-16zM432 704h16v16h-16v-16zM384 752h16v16h-16v-16zM400 736h16v16h-16v-16zM416 752h16v16h-16v-16zM432 736h16v16h-16v-16zM448 720h16v16h-16v-16zM464 704h16v16h-16v-16zM480 720h16v16h-16v-16zM496 704h16v16h-16v-16zM448 752h16v16h-16v-16zM464 736h16v16h-16v-16zM480 752h16v16h-16v-16zM496 736h16v16h-16v-16zM352 848h16v16h-16v-16zM368 832h16v16h-16v-16zM336 864h16v16h-16v-16zM352 880h16v16h-16v-16zM368 864h16v16h-16v-16zM384 784h16v16h-16v-16zM400 768h16v16h-16v-16zM416 784h16v16h-16v-16zM432 768h16v16h-16v-16zM384 816h16v16h-16v-16zM400 800h16v16h-16v-16zM416 816h16v16h-16v-16zM432 800h16v16h-16v-16zM448 784h16v16h-16v-16zM464 768h16v16h-16v-16zM480 784h16v16h-16v-16zM496 768h16v16h-16v-16zM448 816h16v16h-16v-16zM464 800h16v16h-16v-16zM480 816h16v16h-16v-16zM496 800h16v16h-16v-16zM384 848h16v16h-16v-16zM400 832h16v16h-16v-16zM416 848h16v16h-16v-16zM432 832h16v16h-16v-16zM384 880h16v16h-16v-16zM400 864h16v16h-16v-16zM416 880h16v16h-16v-16zM432 864h16v16h-16v-16zM448 848h16v16h-16v-16zM464 832h16v16h-16v-16zM480 848h16v16h-16v-16zM496 832h16v16h-16v-16zM448 880h16v16h-16v-16zM464 864h16v16h-16v-16zM480 880h16v16h-16v-16zM496 864h16v16h-16v-16zM336 896h16v16h-16v-16zM352 912h16v16h-16v-16zM368 896h16v16h-16v-16zM336 928h16v16h-16v-16zM368 928h16v16h-16v-16zM384 912h16v16h-16v-16zM400 896h16v16h-16v-16zM416 912h16v16h-16v-16zM432 896h16v16h-16v-16zM400 928h16v16h-16v-16zM432 928h16v16h-16v-16zM448 912h16v16h-16v-16zM464 896h16v16h-16v-16zM480 912h16v16h-16v-16zM496 896h16v16h-16v-16zM464 928h16v16h-16v-16zM496 928h16v16h-16v-16zM512 528h16v16h-16v-16zM528 512h16v16h-16v-16zM544 528h16v16h-16v-16zM560 512h16v16h-16v-16zM512 560h16v16h-16v-16zM528 544h16v16h-16v-16zM544 560h16v16h-16v-16zM560 544h16v16h-16v-16zM576 528h16v16h-16v-16zM592 512h16v16h-16v-16zM608 528h16v16h-16v-16zM624 512h16v16h-16v-16zM576 560h16v16h-16v-16zM592 544h16v16h-16v-16zM608 560h16v16h-16v-16zM624 544h16v16h-16v-16zM512 592h16v16h-16v-16zM528 576h16v16h-16v-16zM544 592h16v16h-16v-16zM560 576h16v16h-16v-16zM512 624h16v16h-16v-16zM528 608h16v16h-16v-16zM544 624h16v16h-16v-16zM560 608h16v16h-16v-16zM576 592h16v16h-16v-16zM592 576h16v16h-16v-16zM608 592h16v16h-16v-16zM624 576h16v16h-16v-16zM576 624h16v16h-16v-16zM592 608h16v16h-16v-16zM608 624h16v16h-16v-16zM624 608h16v16h-16v-16zM640 528h16v16h-16v-16zM656 512h16v16h-16v-16zM672 528h16v16h-16v-16zM640 560h16v16h-16v-16zM656 544h16v16h-16v-16zM512 656h16v16h-16v-16zM528 640h16v16h-16v-16zM544 656h16v16h-16v-16zM560 640h16v16h-16v-16zM512 688h16v16h-16v-16zM528 672h16v16h-16v-16zM544 688h16v16h-16v-16zM560 672h16v16h-16v-16zM576 656h16v16h-16v-16zM592 640h16v16h-16v-16zM608 656h16v16h-16v-16zM624 640h16v16h-16v-16zM576 688h16v16h-16v-16zM592 672h16v16h-16v-16zM608 688h16v16h-16v-16zM624 672h16v16h-16v-16zM512 720h16v16h-16v-16zM528 704h16v16h-16v-16zM544 720h16v16h-16v-16zM560 704h16v16h-16v-16zM512 752h16v16h-16v-16zM528 736h16v16h-16v-16zM544 752h16v16h-16v-16zM560 736h16v16h-16v-16zM576 720h16v16h-16v-16zM592 704h16v16h-16v-16zM608 720h16v16h-16v-16zM624 704h16v16h-16v-16zM576 752h16v16h-16v-16zM592 736h16v16h-16v-16zM608 752h16v16h-16v-16zM624 736h16v16h-16v-16zM640 656h16v16h-16v-16zM656 640h16v16h-16v-16zM672 656h16v16h-16v-16zM640 688h16v16h-16v-16zM656 672h16v16h-16v-16zM672 688h16v16h-16v-16zM640 720h16v16h-16v-16zM656 704h16v16h-16v-16zM672 720h16v16h-16v-16zM640 752h16v16h-16v-16zM656 736h16v16h-16v-16zM512 784h16v16h-16v-16zM528 768h16v16h-16v-16zM544 784h16v16h-16v-16zM560 768h16v16h-16v-16zM512 816h16v16h-16v-16zM528 800h16v16h-16v-16zM544 816h16v16h-16v-16zM560 800h16v16h-16v-16zM576 784h16v16h-16v-16zM592 768h16v16h-16v-16zM608 784h16v16h-16v-16zM624 768h16v16h-16v-16zM576 816h16v16h-16v-16zM592 800h16v16h-16v-16zM608 816h16v16h-16v-16zM624 800h16v16h-16v-16zM512 848h16v16h-16v-16zM528 832h16v16h-16v-16zM544 848h16v16h-16v-16zM560 832h16v16h-16v-16zM512 880h16v16h-16v-16zM528 864h16v16h-16v-16zM544 880h16v16h-16v-16zM560 864h16v16h-16v-16zM576 848h16v16h-16v-16zM592 832h16v16h-16v-16zM608 848h16v16h-16v-16zM624 832h16v16h-16v-16zM576 880h16v16h-16v-16zM592 864h16v16h-16v-16zM608 880h16v16h-16v-16zM624 864h16v16h-16v-16zM640 848h16v16h-16v-16zM656 832h16v16h-16v-16zM672 848h16v16h-16v-16zM640 880h16v16h-16v-16zM656 864h16v16h-16v-16zM672 880h16v16h-16v-16zM512 912h16v16h-16v-16zM528 896h16v16h-16v-16zM544 912h16v16h-16v-16zM560 896h16v16h-16v-16zM528 928h16v16h-16v-16zM560 928h16v16h-16v-16zM576 912h16v16h-16v-16zM592 896h16v16h-16v-16zM608 912h16v16h-16v-16zM624 896h16v16h-16v-16zM592 928h16v16h-16v-16zM624 928h16v16h-16v-16zM640 912h16v16h-16v-16zM656 896h16v16h-16v-16zM672 912h16v16h-16v-16zM656 928h16v16h-16v-16zM336 320h16v16h-16v-16zM352 336h16v16h-16v-16zM368 320h16v16h-16v-16zM336 352h16v16h-16v-16zM352 368h16v16h-16v-16zM368 352h16v16h-16v-16zM384 336h16v16h-16v-16zM400 320h16v16h-16v-16zM416 336h16v16h-16v-16zM432 320h16v16h-16v-16zM384 368h16v16h-16v-16zM400 352h16v16h-16v-16zM416 368h16v16h-16v-16zM432 352h16v16h-16v-16zM448 336h16v16h-16v-16zM464 320h16v16h-16v-16zM480 336h16v16h-16v-16zM496 320h16v16h-16v-16zM448 368h16v16h-16v-16zM464 352h16v16h-16v-16zM480 368h16v16h-16v-16zM496 352h16v16h-16v-16zM352 464h16v16h-16v-16zM368 448h16v16h-16v-16zM336 480h16v16h-16v-16zM352 496h16v16h-16v-16zM368 480h16v16h-16v-16zM384 400h16v16h-16v-16zM400 384h16v16h-16v-16zM416 400h16v16h-16v-16zM432 384h16v16h-16v-16zM384 432h16v16h-16v-16zM400 416h16v16h-16v-16zM416 432h16v16h-16v-16zM432 416h16v16h-16v-16zM448 400h16v16h-16v-16zM464 384h16v16h-16v-16zM480 400h16v16h-16v-16zM496 384h16v16h-16v-16zM448 432h16v16h-16v-16zM464 416h16v16h-16v-16zM480 432h16v16h-16v-16zM496 416h16v16h-16v-16zM384 464h16v16h-16v-16zM400 448h16v16h-16v-16zM416 464h16v16h-16v-16zM432 448h16v16h-16v-16zM384 496h16v16h-16v-16zM400 480h16v16h-16v-16zM416 496h16v16h-16v-16zM432 480h16v16h-16v-16zM448 464h16v16h-16v-16zM464 448h16v16h-16v-16zM480 464h16v16h-16v-16zM496 448h16v16h-16v-16zM448 496h16v16h-16v-16zM464 480h16v16h-16v-16zM480 496h16v16h-16v-16zM496 480h16v16h-16v-16zM512 336h16v16h-16v-16zM528 320h16v16h-16v-16zM544 336h16v16h-16v-16zM560 320h16v16h-16v-16zM512 368h16v16h-16v-16zM528 352h16v16h-16v-16zM544 368h16v16h-16v-16zM560 352h16v16h-16v-16zM576 336h16v16h-16v-16zM592 320h16v16h-16v-16zM608 336h16v16h-16v-16zM624 320h16v16h-16v-16zM576 368h16v16h-16v-16zM592 352h16v16h-16v-16zM608 368h16v16h-16v-16zM624 352h16v16h-16v-16zM640 336h16v16h-16v-16zM656 320h16v16h-16v-16zM672 336h16v16h-16v-16zM640 368h16v16h-16v-16zM656 352h16v16h-16v-16zM512 400h16v16h-16v-16zM528 384h16v16h-16v-16zM544 400h16v16h-16v-16zM560 384h16v16h-16v-16zM512 432h16v16h-16v-16zM528 416h16v16h-16v-16zM544 432h16v16h-16v-16zM560 416h16v16h-16v-16zM576 400h16v16h-16v-16zM592 384h16v16h-16v-16zM608 400h16v16h-16v-16zM624 384h16v16h-16v-16zM576 432h16v16h-16v-16zM592 416h16v16h-16v-16zM608 432h16v16h-16v-16zM624 416h16v16h-16v-16zM512 464h16v16h-16v-16zM528 448h16v16h-16v-16zM544 464h16v16h-16v-16zM560 448h16v16h-16v-16zM512 496h16v16h-16v-16zM528 480h16v16h-16v-16zM544 496h16v16h-16v-16zM560 480h16v16h-16v-16zM576 464h16v16h-16v-16zM592 448h16v16h-16v-16zM608 464h16v16h-16v-16zM624 448h16v16h-16v-16zM576 496h16v16h-16v-16zM592 480h16v16h-16v-16zM608 496h16v16h-16v-16zM624 480h16v16h-16v-16zM640 464h16v16h-16v-16zM656 448h16v16h-16v-16zM672 464h16v16h-16v-16zM640 496h16v16h-16v-16zM656 480h16v16h-16v-16zM672 496h16v16h-16v-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bottle",
						"drink",
						"water"
					],
					"defaultCode": 60345,
					"grid": 16
				},
				{
					"id": 327,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM927.2 496h-254.304c4.288-111.168 52.448-210.816 127.616-283.040 74.816 72.224 122.432 172.096 126.688 283.040zM528 496v-399.2c94.176 3.616 180.576 38.176 248.672 94.496-80.288 77.888-131.52 185.056-135.808 304.704h-112.864zM496 496h-112.864c-4.256-119.616-55.52-226.816-135.808-304.704 68.096-56.288 154.496-90.88 248.672-94.496v399.2zM496 528v399.2c-94.176-3.616-180.576-38.176-248.672-94.496 80.288-77.888 131.52-185.056 135.808-304.704h112.864zM528 528h112.864c4.256 119.616 55.52 226.816 135.808 304.704-68.096 56.288-154.496 90.88-248.672 94.496v-399.2zM223.52 212.96c75.168 72.224 123.328 171.872 127.616 283.040h-254.336c4.256-110.944 51.872-210.816 126.72-283.040zM96.8 528h254.304c-4.288 111.168-52.448 210.816-127.616 283.040-74.816-72.224-122.432-172.096-126.688-283.040zM800.48 811.040c-75.168-72.224-123.328-171.872-127.616-283.040h254.304c-4.224 110.944-51.84 210.816-126.688 283.040z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bounce",
						"play",
						"compete",
						"shoot",
						"dribble"
					],
					"grid": 32
				},
				{
					"id": 328,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM912.096 528h-239.232c4.064 105.536 47.328 201.056 115.936 272.288 6.144 6.368 5.632 16.64-0.896 22.624-0.096 0.096-0.192 0.16-0.288 0.256-6.432 5.856-16.352 5.408-22.4-0.864-73.92-76.896-120.32-180.16-124.384-294.272h-112.832v384.096c0 8.8-7.136 15.904-15.904 15.904h-0.16c-8.8 0-15.904-7.136-15.904-15.904v-384.128h-112.832c-4.064 114.112-50.464 217.376-124.384 294.272-6.048 6.272-15.936 6.752-22.4 0.864-0.096-0.096-0.192-0.16-0.288-0.256-6.528-5.952-7.040-16.256-0.896-22.624 68.64-71.232 111.872-166.752 115.936-272.288h-239.264c-8.768 0.032-15.904-7.104-15.904-15.872v-0.16c0-8.8 7.136-15.936 15.904-15.936h239.232c-4.064-105.536-47.328-201.056-115.936-272.288-6.144-6.368-5.632-16.64 0.896-22.624 0.096-0.096 0.192-0.16 0.288-0.256 6.432-5.856 16.352-5.408 22.4 0.864 73.92 76.896 120.32 180.16 124.384 294.272h112.832v-384.064c0-8.768 7.136-15.904 15.904-15.904h0.16c8.8 0 15.936 7.136 15.936 15.904v384.096h112.832c4.064-114.112 50.464-217.376 124.384-294.272 6.048-6.272 15.936-6.752 22.4-0.864 0.096 0.096 0.192 0.16 0.288 0.256 6.528 5.952 7.040 16.256 0.896 22.624-68.64 71.232-111.872 166.752-115.936 272.288h239.232c8.8 0 15.904 7.136 15.904 15.904v0.16c0 8.768-7.136 15.904-15.904 15.904z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bounce",
						"play",
						"compete",
						"shoot",
						"dribble"
					],
					"grid": 32
				},
				{
					"id": 967,
					"width": 1024,
					"paths": [
						"M896 0h-224c-17.664 0-32 14.304-32 32h-256c0-17.696-14.336-32-32-32h-224c-17.664 0-32 14.304-32 32v96c0 17.696 14.336 32 32 32h224c17.664 0 32-14.304 32-32v-32h32v672h-160c-17.664 0-32 14.304-32 32s14.336 32 32 32h224v128h-0.32c-17.504 0-31.68 14.176-31.68 31.68v0.64c0 17.504 14.176 31.68 31.68 31.68h64.64c17.504 0 31.68-14.176 31.68-31.68v-0.64c0-17.504-14.176-31.68-31.68-31.68h-0.32v-128h224c17.664 0 32-14.304 32-32s-14.336-32-32-32h-160v-672h32v32c0 17.696 14.336 32 32 32h224c17.664 0 32-14.304 32-32v-96c0-17.696-14.336-32-32-32zM160 96v-32h160v32h-160zM480 640v-32h64v32h-64zM544 672v32h-64v-32h64zM480 576v-32h64v32h-64zM480 768v-32h64v32h-64zM544 512h-64v-416h64v416zM864 96h-160v-32h160v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bounce",
						"jump"
					],
					"grid": 32
				},
				{
					"id": 2639,
					"paths": [
						"M1014.616 54.638c5.798-5.792 9.384-13.796 9.384-22.638 0-17.672-14.326-32-32-32-150.758 0-286.068 17.61-402.172 52.342-124.182 37.148-230.264 94.994-315.296 171.928-0.876 0.792-1.736 1.602-2.608 2.398l-162.668-162.668h50.744c17.672 0 32-14.328 32-32s-14.326-32-32-32h-160v160c0 17.672 14.328 32 32 32s32-14.328 32-32v-50.744l162.694 162.692c-66.418 72.866-118.676 160.738-155.746 262.058-47.078 128.678-70.948 282.77-70.948 457.994 0 17.674 14.328 32 32 32 8.842 0 16.846-3.586 22.638-9.384l457.362-457.362 192 192v128l128 128v-173.254h173.254l-128-128h-128l-192-192 457.362-457.362zM653.034 143.498c85.534-39.916 171.644-64.93 256.96-74.746l-397.992 397.994-134.408-134.408c82.894-78.192 177.546-143.156 275.44-188.84zM68.754 909.994c9.816-85.316 34.83-171.428 74.746-256.96 45.684-97.894 110.648-192.544 188.84-275.44l134.406 134.406-397.992 397.994z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bow",
						"soprts",
						"archery",
						"arrow"
					],
					"defaultCode": 60474,
					"grid": 16
				},
				{
					"id": 2651,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM640 576c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM640 320c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM832 448c-35.348 0-64-28.654-64-64s28.652-64 64-64c35.346 0 64 28.654 64 64s-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bowling",
						"soprts",
						"ball",
						"game",
						"sports"
					],
					"defaultCode": 60486,
					"grid": 16
				},
				{
					"id": 2652,
					"paths": [
						"M919.882 425.854c-21.010-44.356-42.736-90.22-42.736-148.476 0-23.154 3.508-50.078 7.218-78.58 8.44-64.796 17.164-131.798-15.668-170.43-10.586-12.456-24.442-20.852-41.366-25.096v-3.272h-24.5c-0.624 0-1.23 0.016-1.838 0.034h-0.022c-0.604-0.018-1.212-0.034-1.842-0.034l-24.5 0.082v3.19c-16.922 4.246-30.778 12.64-41.364 25.096-32.83 38.63-24.104 105.632-15.666 170.43 3.712 28.502 7.218 55.426 7.218 78.58 0 58.256-21.726 104.122-42.734 148.476-17.402 36.734-35.294 74.52-40.544 118.318-7.772-19.736-16.768-38.73-25.65-57.482-24.012-50.692-48.842-103.11-48.842-169.688 0-26.462 4.008-57.23 8.25-89.806 9.644-74.052 19.616-150.626-17.906-194.776-12.098-14.234-27.934-23.83-47.274-28.682v-3.738h-28c-0.714 0-1.408 0.018-2.102 0.040h-0.024c-0.696-0.022-1.39-0.040-2.108-0.040l-28 0.092v3.644c-19.338 4.852-35.174 14.448-47.272 28.682-37.522 44.15-27.55 120.724-17.906 194.778 4.242 32.576 8.25 63.344 8.25 89.804 0 66.578-24.83 118.996-48.84 169.688-8.324 17.572-16.744 35.36-24.164 53.768-5.788-42.226-23.158-78.914-40.066-114.604-21.010-44.356-42.736-90.22-42.736-148.476 0-23.154 3.508-50.078 7.218-78.58 8.44-64.796 17.164-131.798-15.668-170.43-10.586-12.456-24.442-20.852-41.364-25.096v-3.27h-24.5c-0.624 0-1.232 0.016-1.838 0.034h-0.022c-0.608-0.018-1.218-0.034-1.844-0.034l-24.5 0.082v3.19c-16.922 4.246-30.778 12.64-41.364 25.096-32.832 38.63-24.106 105.632-15.668 170.43 3.712 28.502 7.218 55.426 7.218 78.58 0 58.256-21.726 104.122-42.736 148.476-20.688 43.676-42.080 88.838-42.080 143.826 0 106.594 45.148 244.712 57.276 272.27 11.72 26.624 41.274 45.726 78.364 51.886v2.164h24.5c0.274 0 0.55-0.004 0.838-0.012 0.284 0.006 0.564 0.012 0.846 0.012l24.5-0.044v-2.12c37.088-6.16 66.64-25.264 78.364-51.888 6.554-14.892 22.748-62.076 36.25-119.114 13.222 105.158 49.294 213.848 60.54 239.392 13.396 30.428 47.17 52.26 89.558 59.3v2.474h28c0.314 0 0.628-0.004 0.958-0.014 0.324 0.008 0.644 0.014 0.966 0.014l28-0.050v-2.422c42.386-7.042 76.16-28.874 89.56-59.302 11.44-25.996 48.584-138.076 61.208-244.916 13.746 59.504 30.78 109.272 37.544 124.64 11.718 26.624 41.274 45.726 78.364 51.886v2.164h24.5c0.274 0 0.548-0.004 0.838-0.012 0.284 0.006 0.564 0.012 0.846 0.012l24.5-0.044v-2.12c37.090-6.16 66.64-25.264 78.366-51.888 12.128-27.56 57.276-165.688 57.276-272.268 0.002-54.988-21.39-100.15-42.080-143.826zM445.282 68.684c4.322-5.084 12.498-11.924 33.508-12.606l0.888-0.032 0.316 0.004 0.262-0.004 0.952 0.032c21.012 0.682 29.188 7.522 33.51 12.606 18.12 21.32 14.722 72.376 8.596 123.316h-86.626c-6.128-50.94-9.526-101.996 8.594-123.316zM511.080 320h-62.16c0.010-1 0.034-1.992 0.034-2.998 0-19.17-1.804-39.942-4.218-61.002h70.528c-2.416 21.060-4.218 41.832-4.218 61.002-0.002 1.006 0.024 1.998 0.034 2.998zM547.27 939.662c-5.892 13.378-31.256 27.84-66.662 28.29l-0.608 0.006-0.608-0.008c-35.406-0.45-60.77-14.908-66.66-28.286-12.358-28.076-60.712-177.264-60.712-288.604 0-50.252 20.742-94.042 42.702-140.4 17.744-37.46 37.128-78.42 47.224-126.664h76.106c10.096 48.244 29.48 89.202 47.224 126.664 21.96 46.36 42.704 90.148 42.704 140.4 0 111.326-48.356 260.526-60.71 288.602z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bowling",
						"soprts",
						"bowling-pins",
						"game",
						"sports"
					],
					"defaultCode": 60487,
					"grid": 16
				},
				{
					"id": 2344,
					"paths": [
						"M917.156 178.106c-9.652-11.916-26.398-15.308-39.926-8.094l-281.23 149.988h-168l-281.23-149.99c-13.528-7.214-30.274-3.822-39.926 8.094-68.898 85.064-106.844 192.28-106.844 301.896 0 109.618 37.946 216.832 106.844 301.894 6.252 7.716 15.48 11.862 24.882 11.862 5.114 0 10.278-1.224 15.042-3.768l281.23-149.988h168.004l281.228 149.988c4.766 2.542 9.93 3.768 15.042 3.768 9.402 0 18.63-4.144 24.882-11.862 68.902-85.062 106.846-192.276 106.846-301.894 0-109.616-37.944-216.832-106.844-301.894zM140.71 720.688c-43.472-61.294-69.638-133.722-75.464-208.688h158.754c17.674 0 32-14.328 32-32s-14.326-32-32-32h-158.754c5.826-74.966 31.992-147.394 75.462-208.688l243.292 129.754v221.868l-243.29 129.754zM883.292 720.688l-243.292-129.754v-221.868l243.292-129.754c43.47 61.294 69.636 133.722 75.462 208.688h-158.754c-17.674 0-32 14.328-32 32s14.326 32 32 32h158.754c-5.826 74.966-31.992 147.394-75.462 208.688z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bowtie"
					],
					"defaultCode": 60179,
					"grid": 16
				},
				{
					"id": 2201,
					"paths": [
						"M64 128h896v128h-896zM128 896h768v-576h-768v576zM384 384h256v64h-256v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"box",
						"inbox",
						"archive"
					],
					"defaultCode": 60036,
					"grid": 16
				},
				{
					"id": 2202,
					"paths": [
						"M832 64h-640l-192 192v672c0 17.674 14.326 32 32 32h960c17.672 0 32-14.326 32-32v-672l-192-192zM512 832l-320-256h192v-192h256v192h192l-320 256zM154.51 192l64-64h586.978l64 64h-714.978z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"box-add",
						"box",
						"download",
						"storage",
						"inbox",
						"archive"
					],
					"defaultCode": 60037,
					"grid": 16
				},
				{
					"id": 2203,
					"paths": [
						"M832 64h-640l-192 192v672c0 17.674 14.326 32 32 32h960c17.672 0 32-14.326 32-32v-672l-192-192zM640 640v192h-256v-192h-192l320-256 320 256h-192zM154.51 192l64-64h586.976l64 64h-714.976z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"box-remove",
						"box",
						"upload",
						"storage",
						"outbox",
						"archive"
					],
					"defaultCode": 60038,
					"grid": 16
				},
				{
					"id": 1794,
					"width": 1243.4299926757812,
					"paths": [
						"M109.714 676.571q-37.714 0-64.571 26.857t-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571-26.857-64.571-64.571-26.857zM402.286 676.571q-37.714 0-64.571 26.857t-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571-26.857-64.571-64.571-26.857zM402.286 384q-37.714 0-64.571 26.857t-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571-26.857-64.571-64.571-26.857zM841.143 676.571q-37.714 0-64.571 26.857t-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571-26.857-64.571-64.571-26.857zM1133.714 676.571q-37.714 0-64.571 26.857t-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571-26.857-64.571-64.571-26.857zM841.143 384q-37.714 0-64.571 26.857t-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571-26.857-64.571-64.571-26.857zM1133.714 384q-37.714 0-64.571 26.857t-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571-26.857-64.571-64.571-26.857zM1133.714 91.429q-37.714 0-64.571 26.857t-26.857 64.571 26.857 64.571 64.571 26.857 64.571-26.857 26.857-64.571-26.857-64.571-64.571-26.857zM219.429 768q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM512 768q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM219.429 475.429q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM512 475.429q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM219.429 182.857q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM950.857 768q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM512 182.857q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM1243.429 768q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM950.857 475.429q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM1243.429 475.429q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM950.857 182.857q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM1243.429 182.857q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"braille"
					],
					"defaultCode": 62113,
					"grid": 14
				},
				{
					"id": 2620,
					"paths": [
						"M800 1024c-17.674 0-32-14.326-32-32v-32c0-196.724 58.964-265.026 110.99-325.286 43.468-50.35 81.010-93.836 81.010-218.714 0-194.094-172.262-352-384-352s-384 157.906-384 352v32c0 2.974-0.414 5.932-1.232 8.792l-52.344 183.208h85.576c17.672 0 32 14.326 32 32v128c0 14.356 17.644 32 32 32h128c17.672 0 32 14.326 32 32v128c0 17.674-14.328 32-32 32s-32-14.326-32-32v-96h-96c-49.346 0-96-46.654-96-96v-96h-96c-10.042 0-19.5-4.712-25.546-12.73-6.046-8.016-7.98-18.406-5.222-28.060l62.768-219.692v-27.518c0-111.606 46.928-216.386 132.138-295.042 84.5-78 196.676-120.958 315.862-120.958s231.362 42.958 315.862 120.958c85.21 78.656 132.138 183.438 132.138 295.042 0 148.684-49.092 205.546-96.566 260.538-49.078 56.846-95.434 110.542-95.434 283.462v32c0 17.674-14.326 32-32 32z",
						"M576 160c-141.386 0-256 78.798-256 176v16c0 88.366 71.634 160 160 160h113.166c22.134 38.248 63.462 64 110.834 64 70.694 0 128-57.306 128-128v-112c0-97.202-114.616-176-256-176z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brain",
						"head",
						"intelligence"
					],
					"defaultCode": 60455,
					"grid": 16
				},
				{
					"id": 2522,
					"paths": [
						"M832 128h-576c-52.192 0-99.578 20.94-134.218 54.852l-0.002-0.010-68.478 68.556c-32.994 34.494-53.302 81.216-53.302 132.602 0 55.912 24.472 107.364 64 142.914v465.086c0 17.674 14.328 32 32 32h767.992c0.002 0 0.004 0 0.008 0 8.846 0 16.852-3.588 22.642-9.388l63.968-63.968c5.8-5.792 9.388-13.798 9.388-22.642v-465.072c39.532-35.542 64-86.986 64-142.93 0.002-105.87-86.128-192-191.998-192zM793.636 509.44c-17.32 3.516-28.512 20.406-24.996 37.726 3.082 15.174 16.422 25.638 31.328 25.638 2.11 0 4.252-0.208 6.398-0.644 8.8-1.788 17.35-4.192 25.634-7.124v394.964h-704v-394.98c8.19 2.91 16.64 5.3 25.34 7.082 17.318 3.542 34.222-7.622 37.766-24.938 3.542-17.312-7.622-34.222-24.936-37.764-13.706-2.804-26.538-7.792-38.17-14.544v-0.024c-38.612-22.416-64-64.306-64-110.832 0-70.58 57.42-128 128-128h576c70.58 0 128 57.42 128 128 0 60.644-43.050 113.398-102.364 125.44z",
						"M256 352c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M256 864c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M448 416c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M320 672c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M512 608c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M704 672c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M640 480c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M512 800c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M768 864c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M768 352c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bread",
						"food",
						"breakfast"
					],
					"defaultCode": 60357,
					"grid": 16
				},
				{
					"id": 329,
					"width": 1024,
					"paths": [
						"M560 880c0 26.496-21.504 48-48 48s-48-21.504-48-48 21.504-48 48-48 48 21.504 48 48zM800 128v768c0 53.024-42.976 96-96 96h-384c-53.024 0-96-42.976-96-96v-768c0-53.024 42.976-96 96-96h384c53.024 0 96 42.976 96 96zM256 544h32v-137.376l-32 32v105.376zM256 841.376l46.976-46.976c-8.8-5.696-14.976-15.136-14.976-26.4v-192h-32v265.376zM393.376 960l-64-64c-6.016-6.016-9.376-14.144-9.376-22.624v-50.752l-64 64v9.376c0 35.36 28.64 64 64 64h73.376zM662.624 672c6.016 6.016 9.376 14.144 9.376 22.624v73.376h32v-192h-41.376l-48 48 48 48zM592 646.624l-48 48c-6.016 6.016-14.144 9.376-22.624 9.376h-82.752l-64 64h265.376v-73.376l-48-48zM662.624 544h41.376v-73.376l-70.624-70.624h-50.752l-38.624 38.624v114.752l48 48 48-48c6.016-6.016 14.144-9.376 22.624-9.376zM704 425.376v-146.752l-48 48v50.752l48 48zM633.376 304l70.624-70.624v-41.376h-384v160h41.376l54.624-54.624v-41.376c0-8.832 7.168-16 16-16s16 7.168 16 16v41.376c0 8.48-3.36 16.64-9.376 22.624l-48 48 48 48h82.752l38.624-38.624c6.016-6.016 14.144-9.376 22.624-9.376h41.376v-41.376c0-8.48 3.36-16.608 9.376-22.624zM320 384v169.376l118.624 118.624h82.752l48-48-48-48c-6.016-6.016-9.376-14.144-9.376-22.624v-105.376h-73.376c-8.48 0-16.64-3.36-22.624-9.376l-54.624-54.624h-41.376zM320 598.624v169.376h9.376l80-80-89.376-89.376zM764.704 915.328l-115.328-115.328h-297.376v73.376l86.624 86.624h265.376c28.576 0 52.48-18.848 60.704-44.672zM768 128c0-35.36-28.64-64-64-64h-384c-35.36 0-64 28.64-64 64v265.376l32-32v-169.376c0-17.664 14.336-32 32-32h384c17.664 0 32 14.336 32 32v576c0 17.664-14.336 32-32 32h-9.376l73.376 73.376v-745.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"break",
						"drop",
						"crack",
						"shatter"
					],
					"grid": 32
				},
				{
					"id": 330,
					"width": 1024,
					"paths": [
						"M437.824 672l-118.624-118.624v-169.376h41.376l54.624 54.624c6.016 6.016 14.144 9.376 22.624 9.376h73.376v105.376c0 8.48 3.36 16.64 9.376 22.624l48 48-48 48h-82.752zM415.2 297.376v-41.376c0-8.832 7.168-16 16-16s16 7.168 16 16v41.376c0 8.48-3.36 16.64-9.376 22.624l-48 48 48 48h82.752l38.624-38.624c6.016-6.016 14.144-9.376 22.624-9.376h41.376v-41.376c0-8.48 3.36-16.64 9.376-22.624l70.624-70.624v-41.376h-384v160h41.376l54.624-54.624zM655.2 377.376l48 48v-146.752l-48 48v50.752zM581.824 400l-38.624 38.624v114.752l48 48 48-48c6.016-6.016 14.144-9.376 22.624-9.376h41.376v-73.376l-70.624-70.624h-50.752zM319.2 598.624v169.376h9.376l80-80-89.376-89.376zM800 128v768c0 53.024-42.976 96-96 96h-384c-53.024 0-96-42.976-96-96v-768c0-53.024 42.976-96 96-96h384c53.024 0 96 42.976 96 96zM560 880c0-26.496-21.504-48-48-48s-48 21.504-48 48 21.504 48 48 48 48-21.504 48-48zM766.624 880.736c0.384-4.672-1.312-9.248-4.64-12.576l-68.16-68.16h9.376c17.664 0 32-14.336 32-32v-576c0-17.664-14.336-32-32-32h-384c-17.664 0-32 14.336-32 32v169.376l-27.328 27.328c-2.976 2.976-4.672 7.040-4.672 11.296 0 14.24 17.248 21.376 27.296 11.328l4.704-4.704v137.376h-16c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h16v192c0 11.264 6.176 20.704 14.976 26.4l-42.272 42.272c-3.008 3.008-4.704 7.072-4.704 11.328 0 14.24 17.248 21.376 27.296 11.328l36.704-36.704v50.752c0 8.48 3.36 16.64 9.376 22.624l59.328 59.328c2.976 2.976 7.072 4.672 11.296 4.672 14.24 0 21.376-17.248 11.328-27.296l-59.328-59.328v-73.376h297.376l90.784 90.784c9.664 9.664 26.208 3.552 27.264-10.048zM543.2 694.624c-5.984 6.016-14.144 9.376-22.624 9.376h-82.752l-64 64h265.376v-73.376l-48-48-48 48zM703.2 768v-192h-41.376l-48 48 48 48c6.016 6.016 9.376 14.144 9.376 22.624v73.376h32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"break",
						"drop",
						"crack",
						"shatter"
					],
					"grid": 32
				},
				{
					"id": 331,
					"width": 1024,
					"paths": [
						"M896 608h-32v-352c0-41.728-26.752-77.312-64-90.528v-5.472c0-52.928-43.072-96-96-96h-256c-52.928 0-96 43.072-96 96v142.944l-193.504 180.576c-19.456 18.176-30.496 43.584-30.496 70.208v278.272c0 53.024 42.976 96 96 96h288c53.024 0 96-42.976 96-96v-278.272c0-26.624-11.040-52.032-30.496-70.176l-193.504-180.608v-142.944c0-35.296 28.704-64 64-64h256c35.296 0 64 28.704 64 64h-64c-52.928 0-96 43.072-96 96s43.072 96 96 96 96-43.072 96-96v-55.392c19.136 11.072 32 31.744 32 55.392v352h-32c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM576 553.728v278.272c0 35.296-28.704 64-64 64h-288c-35.296 0-64-28.704-64-64v-278.272c0-17.664 7.424-34.72 20.32-46.784l187.68-175.168 187.68 175.168c12.896 12.032 20.32 29.088 20.32 46.784zM768 256c0 35.296-28.704 64-64 64s-64-28.704-64-64 28.704-64 64-64h64v64zM896 768h-96v-128h96v128zM256 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM352 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM448 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM544 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM192 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM288 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM384 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM480 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM272 800c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM368 800c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM464 736c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brew",
						"drink",
						"flavor"
					],
					"grid": 32
				},
				{
					"id": 332,
					"width": 1024,
					"paths": [
						"M896 608h-32v-352c0-41.728-26.752-77.312-64-90.528v-5.472c0-52.928-43.072-96-96-96h-256c-52.928 0-96 43.072-96 96v142.944l-193.504 180.576c-19.456 18.176-30.496 43.584-30.496 70.208v278.272c0 53.024 42.976 96 96 96h288c53.024 0 96-42.976 96-96v-278.272c0-26.624-11.040-52.032-30.496-70.176l-193.504-180.608v-142.944c0-35.296 28.704-64 64-64h256c35.296 0 64 28.704 64 64h-64c-52.928 0-96 43.072-96 96s43.072 96 96 96 96-43.072 96-96v-55.392c19.136 11.072 32 31.744 32 55.392v352h-32c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM768 256c0 35.296-28.704 64-64 64s-64-28.704-64-64 28.704-64 64-64h64v64zM256 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM352 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM448 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM544 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM192 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM288 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM384 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM480 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM272 800c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM368 800c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM464 736c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brew",
						"drink",
						"flavor"
					],
					"grid": 32
				},
				{
					"id": 968,
					"width": 1024,
					"paths": [
						"M1024 640c0-99.072-24.928-179.712-74.208-240.512 25.44-17.28 42.208-46.464 42.208-79.488 0-52.928-43.072-96-96-96h-448c0-70.592-57.408-128-128-128s-128 57.408-128 128h-64c-52.928 0-96 43.072-96 96 0 33.024 16.768 62.208 42.208 79.488-49.28 60.8-74.208 141.44-74.208 240.512 0 161.792 64.928 255.808 156.192 310.56l-18.816 18.816c-12.512 12.512-12.512 32.736 0 45.248 6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l34.144-34.144c92.448 35.968 200.512 43.52 295.232 43.52s202.784-7.552 295.232-43.52l34.144 34.144c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376c12.512-12.512 12.512-32.736 0-45.248l-18.816-18.816c91.264-54.752 156.192-148.768 156.192-310.56zM320 160c35.296 0 64 28.704 64 64 0 22.016-7.84 32-7.84 32h-112.32c0 0-7.84-9.984-7.84-32 0-35.296 28.704-64 64-64zM128 288h768c17.632 0 32 14.368 32 32s-14.368 32-32 32h-768c-17.632 0-32-14.368-32-32s14.368-32 32-32zM512 960c-314.016 0-448-95.712-448-320 0-104.32 29.664-180.032 90.72-231.552l28.992-24.448h656.576l28.992 24.448c61.056 51.52 90.72 127.232 90.72 231.552 0 224.288-133.984 320-448 320zM608 192c52.928 0 96-43.072 96-96s-43.072-96-96-96-96 43.072-96 96 43.072 96 96 96zM608 64c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brew",
						"boil",
						"curse",
						"stew"
					],
					"grid": 32
				},
				{
					"id": 2583,
					"paths": [
						"M218.51 640h229.49v-64h128v64h229.49l218.51-218.51v-101.49c0-35.2-28.8-64-64-64h-192l-128-128h-256l-128 128h-192c-35.2 0-64 28.8-64 64v101.49l218.51 218.51zM410.51 192h202.98l64 64h-330.98l64-64zM832 704h-256v64h-128v-64h-256l-192-192v384c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-384l-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"briefcase",
						"portfolio",
						"suitcase",
						"work",
						"job",
						"employee"
					],
					"defaultCode": 60418,
					"grid": 16
				},
				{
					"id": 2584,
					"paths": [
						"M928 320h-224v-128c0-35.2-28.8-64-64-64h-256c-35.204 0-64 28.8-64 64v128h-224c-52.8 0-96 43.2-96 96v448c0 52.8 43.2 96 96 96h832c52.796 0 96-43.2 96-96v-448c0-52.8-43.198-96-96-96zM384 192.114c0.032-0.040 0.074-0.082 0.116-0.114h255.774c0.042 0.036 0.080 0.076 0.116 0.114v127.886h-256.006v-127.886z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"briefcase",
						"portfolio",
						"suitcase",
						"work",
						"job",
						"employee"
					],
					"defaultCode": 60419,
					"grid": 16
				},
				{
					"id": 2585,
					"paths": [
						"M960 256h-256v-64c0-35.2-28.8-64-64-64h-256c-35.204 0-64 28.8-64 64v64h-256c-35.2 0-64 28.8-64 64v576c0 35.202 28.796 64 64 64h896c35.2 0 64-28.798 64-64v-576c0-35.2-28.8-64-64-64zM384 192.116c0.034-0.040 0.074-0.082 0.114-0.116h255.772c0.042 0.034 0.082 0.076 0.118 0.116v63.884h-256.004v-63.884zM960 512h-128v96c0 17.602-14.4 32-32 32h-64c-17.604 0-32-14.398-32-32v-96h-384v96c0 17.602-14.4 32-32 32h-64c-17.602 0-32-14.398-32-32v-96h-128v-64h896v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"briefcase",
						"portfolio",
						"suitcase",
						"work",
						"job",
						"employee"
					],
					"defaultCode": 60420,
					"grid": 16
				},
				{
					"id": 1345,
					"width": 1024,
					"paths": [
						"M365.714 146.286h292.571v-73.143h-292.571v73.143zM1024 512v274.286q0 37.714-26.857 64.571t-64.571 26.857h-841.143q-37.714 0-64.571-26.857t-26.857-64.571v-274.286h384v91.429q0 14.857 10.857 25.714t25.714 10.857h182.857q14.857 0 25.714-10.857t10.857-25.714v-91.429h384zM585.143 512v73.143h-146.286v-73.143h146.286zM1024 237.714v219.429h-1024v-219.429q0-37.714 26.857-64.571t64.571-26.857h201.143v-91.429q0-22.857 16-38.857t38.857-16h329.143q22.857 0 38.857 16t16 38.857v91.429h201.143q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"briefcase"
					],
					"defaultCode": 61617,
					"grid": 14
				},
				{
					"id": 171,
					"paths": [
						"M947.2 256h-230.4v-76.8c0-42.347-34.453-76.8-76.8-76.8h-256c-42.347 0-76.8 34.453-76.8 76.8v76.8h-230.4c-42.347 0-76.8 34.453-76.8 76.8v563.2c0 42.349 34.453 76.8 76.8 76.8h870.4c42.349 0 76.8-34.451 76.8-76.8v-563.2c0-42.347-34.451-76.8-76.8-76.8zM358.4 179.2c0-14.115 11.485-25.6 25.6-25.6h256c14.115 0 25.6 11.485 25.6 25.6v76.8h-307.2v-76.8zM76.8 307.2h870.4c14.115 0 25.6 11.485 25.6 25.6v384h-102.4v-25.6c0-14.139-11.461-25.6-25.6-25.6h-102.4c-14.139 0-25.6 11.461-25.6 25.6v25.6h-409.6v-25.6c0-14.139-11.462-25.6-25.6-25.6h-102.4c-14.138 0-25.6 11.461-25.6 25.6v25.6h-102.4v-384c0-14.115 11.485-25.6 25.6-25.6zM819.2 716.8v51.2h-51.2v-51.2h51.2zM256 716.8v51.2h-51.2v-51.2h51.2zM947.2 921.6h-870.4c-14.115 0-25.6-11.485-25.6-25.6v-128h102.4v25.6c0 14.139 11.462 25.6 25.6 25.6h102.4c14.138 0 25.6-11.461 25.6-25.6v-25.6h409.6v25.6c0 14.139 11.461 25.6 25.6 25.6h102.4c14.139 0 25.6-11.461 25.6-25.6v-25.6h102.4v128c0 14.115-11.485 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"briefcase",
						"suitcase",
						"luggage"
					],
					"defaultCode": 59468,
					"grid": 20
				},
				{
					"id": 2797,
					"paths": [
						"M512 256c-141.384 0-256 114.616-256 256s114.616 256 256 256 256-114.616 256-256-114.616-256-256-256zM512 672v-320c88.224 0 160 71.776 160 160s-71.776 160-160 160zM512 832c35.346 0 64 28.654 64 64v64c0 35.346-28.654 64-64 64s-64-28.654-64-64v-64c0-35.346 28.654-64 64-64zM512 192c-35.346 0-64-28.654-64-64v-64c0-35.346 28.654-64 64-64s64 28.654 64 64v64c0 35.346-28.654 64-64 64zM960 448c35.346 0 64 28.654 64 64s-28.654 64-64 64h-64c-35.346 0-64-28.654-64-64s28.654-64 64-64h64zM192 512c0 35.346-28.654 64-64 64h-64c-35.346 0-64-28.654-64-64s28.654-64 64-64h64c35.346 0 64 28.654 64 64zM828.784 738.274l45.256 45.256c24.992 24.992 24.992 65.516 0 90.51-24.994 24.992-65.518 24.992-90.51 0l-45.256-45.256c-24.992-24.992-24.992-65.516 0-90.51 24.994-24.992 65.518-24.992 90.51 0zM195.216 285.726l-45.256-45.256c-24.994-24.994-24.994-65.516 0-90.51s65.516-24.994 90.51 0l45.256 45.256c24.994 24.994 24.994 65.516 0 90.51s-65.516 24.994-90.51 0zM828.784 285.726c-24.992 24.992-65.516 24.992-90.51 0-24.992-24.994-24.992-65.516 0-90.51l45.256-45.254c24.992-24.994 65.516-24.994 90.51 0 24.992 24.994 24.992 65.516 0 90.51l-45.256 45.254zM195.216 738.274c24.992-24.992 65.516-24.992 90.508 0 24.994 24.994 24.994 65.518 0 90.51l-45.254 45.256c-24.994 24.992-65.516 24.992-90.51 0-24.994-24.994-24.994-65.518 0-90.51l45.256-45.256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brightness-contrast"
					],
					"defaultCode": 60632,
					"grid": 16
				},
				{
					"id": 2798,
					"paths": [
						"M512 422c-49.626 0-90 40.374-90 90s40.374 90 90 90c49.626 0 90-40.374 90-90s-40.374-90-90-90zM512 320v0c106.040 0 192 85.96 192 192s-85.96 192-192 192c-106.040 0-192-85.96-192-192s85.96-192 192-192zM941.254 850.746c24.996 24.994 24.994 65.516 0 90.508-24.994 24.996-65.514 24.996-90.508 0l-128-128c-24.996-24.994-24.996-65.514 0-90.508 24.992-24.994 65.514-24.996 90.508 0l128 128zM301.254 210.746c24.996 24.994 24.994 65.516 0 90.508-24.994 24.996-65.514 24.996-90.508 0l-128-128c-24.996-24.994-24.996-65.514 0-90.508 24.992-24.994 65.514-24.996 90.508 0l128 128zM850.744 82.746c24.994-24.996 65.516-24.994 90.508 0 24.996 24.994 24.996 65.514 0.002 90.508l-128 128c-24.996 24.996-65.516 24.996-90.508 0-24.996-24.992-24.996-65.514 0-90.508l127.998-128zM210.746 722.746c24.994-24.996 65.514-24.994 90.508 0 24.996 24.994 24.996 65.514 0 90.508l-128 128c-24.994 24.996-65.514 24.996-90.508 0-24.994-24.992-24.996-65.514 0-90.508l128-128zM512 0c35.346 0 64 28.654 64 64v128c0 35.346-28.654 64-64 64s-64-28.654-64-64v-128c0-35.346 28.654-64 64-64zM512 768c35.346 0 64 28.652 64 64v128c0 35.348-28.654 64-64 64s-64-28.652-64-64v-128c0-35.348 28.654-64 64-64zM0 512c0-35.346 28.654-64 64-64h128c35.346 0 64 28.654 64 64 0 35.348-28.654 64-64 64h-128c-35.346 0-64-28.652-64-64zM768 512c0-35.346 28.652-64 64-64h128c35.348 0 64 28.654 64 64s-28.652 64-64 64h-128c-35.348 0-64-28.654-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brightness-high",
						"brightness",
						"lightness",
						"sun"
					],
					"defaultCode": 60633,
					"grid": 16
				},
				{
					"id": 2800,
					"paths": [
						"M448 192c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM192 256c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM448 832c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM704 768c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM128 512c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM768 512c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM704 256c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM192 768c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM512 320c-106.040 0-192 85.96-192 192s85.96 192 192 192 192-85.96 192-192-85.96-192-192-192zM512 602c-49.626 0-90-40.374-90-90s40.374-90 90-90c49.626 0 90 40.374 90 90s-40.374 90-90 90z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brightness-low",
						"brightness",
						"lightness",
						"sun"
					],
					"defaultCode": 60635,
					"grid": 16
				},
				{
					"id": 2799,
					"paths": [
						"M512 422c-49.626 0-90 40.374-90 90s40.374 90 90 90c49.626 0 90-40.374 90-90s-40.374-90-90-90zM512 320v0c106.040 0 192 85.96 192 192s-85.96 192-192 192c-106.040 0-192-85.96-192-192s85.96-192 192-192zM877.254 786.746c24.996 24.994 24.994 65.516 0 90.508-24.994 24.996-65.514 24.996-90.508 0l-64-64c-24.996-24.994-24.996-65.514 0-90.508 24.992-24.994 65.514-24.996 90.508 0l64 64zM301.254 210.746c24.996 24.994 24.994 65.516 0 90.508-24.994 24.996-65.514 24.996-90.508 0l-64-64c-24.996-24.994-24.996-65.514 0-90.508 24.992-24.994 65.514-24.996 90.508 0l64 64zM786.744 146.746c24.994-24.996 65.516-24.994 90.508 0 24.996 24.994 24.996 65.514 0.002 90.508l-64 64c-24.996 24.996-65.516 24.996-90.508 0-24.996-24.992-24.996-65.514 0-90.508l63.998-64zM210.746 722.746c24.994-24.996 65.514-24.994 90.508 0 24.996 24.994 24.996 65.514 0 90.508l-64 64c-24.994 24.996-65.514 24.996-90.508 0-24.994-24.992-24.996-65.514 0-90.508l64-64zM512 64c35.346 0 64 28.654 64 64v64c0 35.346-28.654 64-64 64s-64-28.654-64-64v-64c0-35.346 28.654-64 64-64zM512 768c35.346 0 64 28.652 64 64v64c0 35.348-28.654 64-64 64s-64-28.652-64-64v-64c0-35.348 28.654-64 64-64zM64 512c0-35.346 28.654-64 64-64h64c35.346 0 64 28.654 64 64 0 35.348-28.654 64-64 64h-64c-35.346 0-64-28.652-64-64zM768 512c0-35.346 28.652-64 64-64h64c35.348 0 64 28.654 64 64s-28.652 64-64 64h-64c-35.348 0-64-28.654-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brightness-medium",
						"brightness",
						"lightness",
						"sun"
					],
					"defaultCode": 60634,
					"grid": 16
				},
				{
					"id": 333,
					"width": 1024,
					"paths": [
						"M768 384v-160c0-106.048-85.952-192-192-192h-128c-106.048 0-192 85.952-192 192v160c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h3.68c13.6 80.224 76.128 143.424 156.32 156.928v131.072c0 35.36 28.64 64 64 64h64c35.36 0 64-28.64 64-64v-131.072c80.224-13.536 142.752-76.736 156.32-156.928h3.68c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32zM288 224c0-88.224 71.776-160 160-160h128c88.224 0 160 71.776 160 160v160h-448v-160zM544 960h-64c-17.664 0-32-14.336-32-32v-128h128v128c0 17.664-14.336 32-32 32zM576 768h-128c-77.12 0-140.288-55.264-155.232-128h438.496c-14.976 72.736-78.144 128-155.264 128zM768 608h-512v-192h512v192zM480 128c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM608 128c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM544 192c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM416 192c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM672 192c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"broadcast",
						"share",
						"talk"
					],
					"grid": 32
				},
				{
					"id": 334,
					"width": 1024,
					"paths": [
						"M768 352v-128c0-106.048-85.952-192-192-192h-128c-106.048 0-192 85.952-192 192v128h512zM640 160c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM576 96c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM512 160c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM448 96c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM384 160c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM755.808 672c-22.816 64.576-78.656 113.28-147.808 124.928v131.072c0 35.36-28.64 64-64 64h-64c-35.36 0-64-28.64-64-64v-131.072c-69.152-11.648-124.992-60.352-147.808-124.928h487.616zM256 384h512c17.664 0 32 14.336 32 32v192c0 17.664-14.336 32-32 32h-512c-17.664 0-32-14.336-32-32v-192c0-17.664 14.336-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"broadcast",
						"share",
						"talk"
					],
					"grid": 32
				},
				{
					"id": 969,
					"width": 1024,
					"paths": [
						"M832 320h-64v-54.976c0-136.224-102.56-255.36-238.464-264.448-149.056-9.984-273.536 108.48-273.536 255.424v64h-64c-35.36 0-64 28.64-64 64v32c0 35.296 28.704 64 64 64v32c0 165.92 126.304 302.336 288 318.4v129.6h-160c-17.664 0-32 14.336-32 32v0c0 17.664 14.336 32 32 32h384c17.664 0 32-14.336 32-32v0c0-17.664-14.336-32-32-32h-160v-129.6c161.696-16.064 288-152.448 288-318.4v-32c35.296 0 64-28.704 64-64v-32c0-35.36-28.64-64-64-64zM320 256c0-6.624 0.32-13.152 0.992-19.616 9.184-90.24 81.152-162.208 171.392-171.392 6.464-0.672 12.992-0.992 19.616-0.992s13.152 0.32 19.616 0.992c48.736 4.96 92.032 28.416 123.072 63.008h-142.688v32h166.016c5.888 10.112 10.816 20.832 14.784 32h-180.8v32h189.12c0.704 4.128 1.472 8.192 1.888 12.384 0.672 6.464 0.992 12.992 0.992 19.616h-192v32h192v32h-192v32h192v32h-192v32h192v32h-384v-192zM320 480h384v32c0 105.856-86.144 192-192 192s-192-86.144-192-192v-32zM192 416v-32h96v32h-96zM768 512c0 141.376-114.624 256-256 256s-256-114.624-256-256v-32h32v32c0 123.712 100.288 224 224 224s224-100.288 224-224v-32h32v32zM736 416v-32h96l0.032 32h-96.032z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"broadcast",
						"share",
						"talk"
					],
					"grid": 32
				},
				{
					"id": 2576,
					"paths": [
						"M1005.254 18.746c-24.992-24.994-65.516-24.994-90.508 0l-240 240-66.746-66.746-128 111.24-454.48 138.32c-15.16 4.612-25.52 18.596-25.52 34.44v32c0 137.828 53.674 267.408 151.132 364.868 97.462 97.458 227.040 151.132 364.868 151.132h32c15.846 0 29.826-10.36 34.44-25.518l138.322-454.484 111.238-127.998-66.746-66.746 240-240c24.994-24.994 24.994-65.514 0-90.508zM521.326 952h-5.326c-53.22 0-104.998-9.328-153.502-27.16l149.502-348.84-248.036 297.642c-21.926-15.182-42.658-32.428-61.918-51.688s-36.506-39.992-51.688-61.918l297.642-248.036-348.84 149.502c-17.832-48.504-27.16-100.284-27.16-153.502v-5.326l465.7-141.734 125.362 125.362-141.736 465.698z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"broom",
						"clean",
						"sweaper"
					],
					"defaultCode": 60411,
					"grid": 16
				},
				{
					"id": 335,
					"width": 1024,
					"paths": [
						"M192 224c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM832 384h-640c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM832 480h-640v-64h640v64zM384 224c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM288 224c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM864 128h-704c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM928 800c0 35.296-28.704 64-64 64h-704c-35.296 0-64-28.704-64-64v-480h832v480zM928 288h-832v-64c0-35.296 28.704-64 64-64h704c35.296 0 64 28.704 64 64v64zM160 592c0-8.832 7.168-16 16-16h448c8.832 0 16 7.168 16 16s-7.168 16-16 16h-448c-8.832 0-16-7.168-16-16zM160 720c0-8.832 7.168-16 16-16h512c8.832 0 16 7.168 16 16s-7.168 16-16 16h-512c-8.832 0-16-7.168-16-16zM160 656c0-8.832 7.168-16 16-16h352c8.832 0 16 7.168 16 16s-7.168 16-16 16h-352c-8.832 0-16-7.168-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"browse",
						"search",
						"work"
					],
					"grid": 32
				},
				{
					"id": 336,
					"width": 1024,
					"paths": [
						"M64 800c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-448h-896v448zM160 448c0-17.664 14.336-32 32-32h640c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32h-640c-17.664 0-32-14.336-32-32v-32zM176 576h448c8.832 0 16 7.168 16 16s-7.168 16-16 16h-448c-8.832 0-16-7.168-16-16s7.168-16 16-16zM176 640h352c8.832 0 16 7.168 16 16s-7.168 16-16 16h-352c-8.832 0-16-7.168-16-16s7.168-16 16-16zM176 704h512c8.832 0 16 7.168 16 16s-7.168 16-16 16h-512c-8.832 0-16-7.168-16-16s7.168-16 16-16zM864 128h-704c-53.024 0-96 42.976-96 96v96h896v-96c0-53.024-42.976-96-96-96zM160 256c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM256 256c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM352 256c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM832 480h-640v-32h640v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"browse",
						"search",
						"work"
					],
					"grid": 32
				},
				{
					"id": 1853,
					"paths": [
						"M220.798 1023.484c-0.010 0-0.016 0-0.028 0-118.754-0.012-205.070-67.562-208.686-70.438-10.65-8.468-14.78-22.748-10.294-35.596 4.484-12.844 16.604-21.45 30.21-21.45 95.336 0 117.642-51.26 145.88-116.154 27.112-62.304 60.852-139.846 174.14-139.846 42.726 0 82.9 16.642 113.118 46.864 30.22 30.22 46.862 70.4 46.862 113.136 0 42.738-16.642 82.918-46.864 113.136-73.22 73.222-155.43 110.348-244.338 110.348z",
						"M1002.344 16.076c-26.538-23.452-67.062-20.95-90.516 5.588l-484.156 547.878c-2.848 3.27-5.96 7.208-8.462 10.878-4.23 6.206-7.734 12.692-10.542 19.356 33.846 9.524 64.868 27.6 90.414 53.146 25.7 25.7 43.842 56.942 53.318 91.030 19.064-7.916 36.13-21.254 48.624-39.582l411.844-604.122c17.98-26.314 13.978-62.522-10.524-84.172z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brush",
						"paint",
						"art"
					],
					"defaultCode": 59688,
					"grid": 16
				},
				{
					"id": 337,
					"width": 1024,
					"paths": [
						"M960 736h-448v-208c0-8.832-7.168-16-16-16s-16 7.168-16 16v208h-32v-208c0-2.656-0.8-5.088-1.984-7.296 20.64-17.6 33.984-43.456 33.984-72.704 0-53.024-42.976-96-96-96h-128c-17.664 0-32-14.336-32-32 0-12.288 6.944-22.976 17.12-28.352 9.696-5.088 14.88-15.968 14.88-26.912v-8.736c0-17.664-14.336-32-32-32h-32c-70.688 0-128 57.312-128 128v96c0 29.248 13.344 55.104 33.984 72.704-1.184 2.208-1.984 4.64-1.984 7.296v208h-32v-208c0-8.832-7.168-16-16-16s-16 7.168-16 16v216.864c-19.040 11.104-32 31.52-32 55.136 0 35.36 28.64 64 64 64h896c35.36 0 64-28.64 64-64s-28.64-64-64-64zM416 736h-32v-192c11.296 0 21.952-2.304 32-5.888v197.888zM320 736v-192h32v192h-32zM256 736v-192h32v192h-32zM192 736v-192h32v192h-32zM96 352c0-52.928 43.072-96 96-96h32l-0.096 8.608c-19.744 11.456-31.904 32.448-31.904 55.392 0 35.296 28.704 64 64 64h128c35.296 0 64 28.704 64 64s-28.704 64-64 64h-224c-35.296 0-64-28.704-64-64v-96zM128 538.112c10.048 3.584 20.704 5.888 32 5.888v192h-32v-197.888zM960 832h-896c-17.632 0-32-14.368-32-32s14.368-32 32-32h896c17.632 0 32 14.368 32 32s-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brush",
						"clean",
						"scrub"
					],
					"grid": 32
				},
				{
					"id": 338,
					"width": 1024,
					"paths": [
						"M480 528c0-8.832 7.168-16 16-16s16 7.168 16 16v176h-32v-176zM96 528v176h32v-165.888c10.048 3.584 20.704 5.888 32 5.888v160h32v-160h32v160h32v-160h32v160h32v-160h32v160h32v-160c11.296 0 21.952-2.304 32-5.888v165.888h32v-176c0-2.656-0.8-5.088-1.984-7.296 20.64-17.6 33.984-43.456 33.984-72.704 0-53.024-42.976-96-96-96h-128c-17.664 0-32-14.336-32-32 0-12.288 6.944-22.976 17.12-28.352 9.696-5.088 14.88-15.968 14.88-26.912v-8.736c0-17.664-14.336-32-32-32h-32c-70.688 0-128 57.312-128 128v96c0 29.248 13.344 55.104 33.984 72.704-1.184 2.208-1.984 4.64-1.984 7.296zM64 704v-176c0-8.832-7.168-16-16-16s-16 7.168-16 16v176h32zM1024 800v0c0-35.36-28.64-64-64-64h-896c-35.36 0-64 28.64-64 64v0c0 35.36 28.64 64 64 64h896c35.36 0 64-28.64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"brush",
						"clean",
						"scrub"
					],
					"grid": 32
				},
				{
					"id": 2265,
					"paths": [
						"M512 64c282.77 0 512 186.25 512 416 0 229.752-229.23 416-512 416-27.156 0-53.81-1.734-79.824-5.044-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60100,
					"grid": 16
				},
				{
					"id": 2293,
					"paths": [
						"M512 204c35.904 0 69.384 10.574 97.5 28.76l-248.74 248.74c-18.186-28.116-28.76-61.594-28.76-97.5 0-99.252 80.748-180 180-180zM414.5 535.238l248.738-248.738c18.19 28.116 28.762 61.594 28.762 97.5 0 99.252-80.748 180-180 180-35.906 0-69.384-10.572-97.5-28.762zM928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM512 640c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.616 256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-blocked",
						"bubble",
						"bubble-forbidden"
					],
					"defaultCode": 60128,
					"grid": 16
				},
				{
					"id": 2304,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM704 274.024l-109.976 109.976 109.976 109.976v82.024h-82.024l-109.976-109.976-109.976 109.976h-82.024v-82.024l109.976-109.976-109.976-109.976v-82.024h82.024l109.976 109.976 109.976-109.976h82.024v82.024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-cancel",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60139,
					"grid": 16
				},
				{
					"id": 2297,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM448 602.51l-205.254-237.254 58.508-58.51 146.746 114.744 274.744-242.744 58.512 58.508-333.256 365.256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-check",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60132,
					"grid": 16
				},
				{
					"id": 2275,
					"paths": [
						"M836 64h-648c-103.4 0-188 84.6-188 188v708l192-192h644c103.4 0 188-84.6 188-188v-328c0-103.4-84.6-188-188-188zM320 512c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM512 512c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM704 512c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-dots",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60110,
					"grid": 16
				},
				{
					"id": 2278,
					"paths": [
						"M836 64h-648c-103.4 0-188 84.6-188 188v708l192-192h644c103.4 0 188-84.6 188-188v-328c0-103.4-84.6-188-188-188zM896 580c0 32.524-27.476 60-60 60h-708v-388c0-32.524 27.476-60 60-60h648c32.524 0 60 27.476 60 60v328zM256 448c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM448 448c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM640 448c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-dots",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60113,
					"grid": 16
				},
				{
					"id": 2286,
					"paths": [
						"M928 64h-832c-52.8 0-96 43.2-96 96v512c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-512c0-52.8-43.2-96-96-96zM384 512h-128v-128h128v128zM576 512h-128v-128h128v128zM768 512h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-dots",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60121,
					"grid": 16
				},
				{
					"id": 2289,
					"paths": [
						"M256 384h128v128h-128zM448 384h128v128h-128zM640 384h128v128h-128zM928 64h-832c-52.8 0-96 43.2-96 96v512c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-512c0-52.8-43.2-96-96-96zM896 640h-379.142l-196.858 174.714v-174.714h-192v-448h768v448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-dots",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60124,
					"grid": 16
				},
				{
					"id": 2310,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM192 640h-64v-512h64v512zM896 448h-384v224l-288-288 288-288v224h384v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-first",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60145,
					"grid": 16
				},
				{
					"id": 2313,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM192 576c0-141.384 143.156-256 319.75-256v-224l288 288-288 288v-217.104c-97.77-19.806-193.258 2.672-255.146 69.874-28.786 31.254-47.31 68.968-56.124 110.004-5.538-18.874-8.48-38.548-8.48-58.774z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-forward",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60148,
					"grid": 16
				},
				{
					"id": 2315,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM200.48 133.226c8.812 41.036 27.338 78.75 56.124 110.004 61.888 67.202 157.376 89.68 255.146 69.874v-217.104l288 288-288 288v-224c-176.594 0-319.75-114.616-319.75-256 0-20.226 2.942-39.9 8.48-58.774z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-forward",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60150,
					"grid": 16
				},
				{
					"id": 2302,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.798 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM736 415.636l-0.25 0.25c-4.79 5.654-223.75 224.114-223.75 224.114s-218.732-218.274-223.22-223.502l-0.362-0.362 0.036-0.016c-20.224-23.738-32.454-54.492-32.454-88.12 0-75.11 60.888-136 136-136 51.96 0 97.102 29.152 120 71.984 22.898-42.832 68.040-71.984 120-71.984 75.11 0 136 60.89 136 136 0 33.39-12.054 63.958-32.026 87.624l0.026 0.012z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-heart",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60137,
					"grid": 16
				},
				{
					"id": 2311,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM512 672v-224h-384v-128h384v-224l288 288-288 288zM896 640h-64v-512h64v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-last",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60146,
					"grid": 16
				},
				{
					"id": 2308,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM832 448h-384v224l-288-288 288-288v224h384v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-left",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60143,
					"grid": 16
				},
				{
					"id": 2276,
					"paths": [
						"M836 64h-648c-103.4 0-188 84.6-188 188v708l192-192h644c103.4 0 188-84.6 188-188v-328c0-103.4-84.6-188-188-188zM640 512h-384v-64h384v64zM768 384h-512v-64h512v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-lines",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60111,
					"grid": 16
				},
				{
					"id": 2279,
					"paths": [
						"M836 64h-648c-103.4 0-188 84.6-188 188v708l192-192h644c103.4 0 188-84.6 188-188v-328c0-103.4-84.6-188-188-188zM896 580c0 32.524-27.476 60-60 60h-708v-388c0-32.524 27.476-60 60-60h648c32.524 0 60 27.476 60 60v328zM256 320h512v64h-512zM256 448h384v64h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-lines",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60114,
					"grid": 16
				},
				{
					"id": 2287,
					"paths": [
						"M928 64h-832c-52.8 0-96 43.2-96 96v512c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-512c0-52.8-43.2-96-96-96zM448 576h-256v-64h256v64zM704 448h-512v-64h512v64zM832 320h-640v-64h640v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-lines",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60122,
					"grid": 16
				},
				{
					"id": 2290,
					"paths": [
						"M192 256h640v64h-640zM192 384h512v64h-512zM192 512h256v64h-256zM928 64h-832c-52.8 0-96 43.2-96 96v512c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-512c0-52.8-43.2-96-96-96zM896 640h-379.142l-196.858 174.714v-174.714h-192v-448h768v448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-lines",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60125,
					"grid": 16
				},
				{
					"id": 2299,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM448 576h-192c-70.4 0-128-57.6-128-128v-64c0-70.4 57.6-128 128-128h192v64h-192c-16.954 0-32.986 6.696-45.146 18.854-12.158 12.16-18.854 28.192-18.854 45.146v64c0 16.954 6.696 32.986 18.854 45.146 12.16 12.158 28.192 18.854 45.146 18.854h192v64zM384 448v-64h256v64h-256zM896 448c0 70.4-57.6 128-128 128h-192v-64h192c16.954 0 32.986-6.696 45.144-18.854 12.16-12.16 18.856-28.192 18.856-45.146v-64c0-16.954-6.696-32.986-18.856-45.146-12.158-12.158-28.19-18.854-45.144-18.854h-192v-64h192c70.4 0 128 57.6 128 128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-link",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60134,
					"grid": 16
				},
				{
					"id": 2300,
					"paths": [
						"M576 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
						"M576 192h-128c-35.29 0-64 28.71-64 64v64h256v-64c0-35.29-28.71-64-64-64z",
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.798 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM768 592c0 26.4-21.6 48-48 48h-416c-26.4 0-48-21.6-48-48v-224c0-26.4 21.6-48 48-48h16v-64c0-70.58 57.42-128 128-128h128c70.58 0 128 57.42 128 128v64h16c26.4 0 48 21.6 48 48v224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-lock",
						"bubble",
						"bubble-private",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60135,
					"grid": 16
				},
				{
					"id": 2306,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM768 448h-512v-128h512v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-minus",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60141,
					"grid": 16
				},
				{
					"id": 2271,
					"paths": [
						"M512 64c-282.77 0-512 186.25-512 416 0 130.55 74.040 247.040 189.836 323.304 1.406 9.366 2.164 18.942 2.164 28.696 0 69.896-59.464 131.058-128 164.636v26.916c126.926-2.896 258.198-22.622 368.176-132.6 26.014 3.314 52.668 5.048 79.824 5.048 282.77 0 512-186.248 512-416s-229.23-416-512-416zM576 704h-128v-128h128v128zM576 512h-128v-256h128v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-notification",
						"bubble",
						"comment",
						"chat",
						"talk",
						"notification",
						"warning"
					],
					"defaultCode": 60106,
					"grid": 16
				},
				{
					"id": 2307,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM576 640h-128v-128h128v128zM576 384h-128v-256h128v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-notification",
						"bubble",
						"comment",
						"chat",
						"talk",
						"notification"
					],
					"defaultCode": 60142,
					"grid": 16
				},
				{
					"id": 2303,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM896 320c0 70.4-57.6 128-128 128h-448c-35.2 0-64-28.8-64-64v-64c0-35.2 28.8-64 64-64h352c17.674 0 32 14.328 32 32s-14.326 32-32 32h-351.886c-0.040 0.034-0.082 0.076-0.114 0.114v63.772c0.034 0.040 0.076 0.082 0.114 0.114h447.886c16.954 0 32.986-6.696 45.144-18.856 12.16-12.158 18.856-28.19 18.856-45.144v-64c0-16.954-6.696-32.986-18.856-45.146-12.158-12.158-28.19-18.854-45.144-18.854h-512c-16.954 0-32.986 6.696-45.146 18.854-12.158 12.16-18.854 28.192-18.854 45.146v192c0 16.954 6.696 32.986 18.854 45.144 12.16 12.16 28.192 18.856 45.146 18.856h416c17.674 0 32 14.328 32 32s-14.326 32-32 32h-416c-70.4 0-128-57.6-128-128v-192c0-70.4 57.6-128 128-128h512c70.4 0 128 57.6 128 128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-paperclip",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60138,
					"grid": 16
				},
				{
					"id": 2305,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM768 448h-192v192h-128v-192h-192v-128h192v-192h128v192h192v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-plus",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60140,
					"grid": 16
				},
				{
					"id": 2294,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM448 528c0 26.4-21.6 48-48 48h-160c-26.4 0-48-21.6-48-48v-336l128-96v224h80c26.4 0 48 21.6 48 48v160zM832 528c0 26.4-21.6 48-48 48h-160c-26.4 0-48-21.6-48-48v-336l128-96v224h80c26.4 0 48 21.6 48 48v160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-quote",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60129,
					"grid": 16
				},
				{
					"id": 2312,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM823.27 634.774c-8.812-41.036-27.338-78.75-56.124-110.004-61.888-67.202-157.376-89.68-255.146-69.874v217.104l-288-288 288-288v224c176.594 0 319.75 114.616 319.75 256 0 20.226-2.942 39.9-8.48 58.774z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-reply",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60147,
					"grid": 16
				},
				{
					"id": 2314,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM831.75 192c0 141.384-143.156 256-319.75 256v224l-288-288 288-288v217.104c97.77 19.806 193.258-2.672 255.146-69.874 28.786-31.254 47.31-68.968 56.124-110.004 5.538 18.874 8.48 38.548 8.48 58.774z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-reply",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60149,
					"grid": 16
				},
				{
					"id": 2309,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM192 320h384v-224l288 288-288 288v-224h-384v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-right",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60144,
					"grid": 16
				},
				{
					"id": 2296,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.798 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM320 192c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM512 640c-119.286 0-219.516-81.586-247.934-192h495.868c-28.418 110.414-128.648 192-247.934 192zM704 320c-35.348 0-64-28.654-64-64s28.652-64 64-64 64 28.654 64 64-28.652 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-smiley",
						"bubble",
						"bubble-emoticon",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60131,
					"grid": 16
				},
				{
					"id": 2301,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM712 684l-200-164.196-200 164.196 72.744-234.652-192.744-129.598h241.352l78.648-250.054 78.648 250.054h241.352l-192.744 129.598 72.744 234.652z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-star",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60136,
					"grid": 16
				},
				{
					"id": 2295,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM512 128.33c70.51 0 127.67 57.16 127.67 127.67s-57.16 127.67-127.67 127.67-127.67-57.16-127.67-127.67 57.16-127.67 127.67-127.67zM704 640h-384v-64c0-70.696 57.308-128 128-128v0h128c70.696 0 128 57.304 128 128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-user",
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60130,
					"grid": 16
				},
				{
					"id": 2298,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM832 512c0 35.2-23.040 46.72-51.2 25.6l-140.8-153.6v128c0 35.2-28.8 64-64 64h-320c-35.2 0-64-28.8-64-64v-256c0-35.2 28.8-64 64-64h320c35.2 0 64 28.8 64 64v128l140.8-153.6c28.16-21.12 51.2-9.6 51.2 25.6v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble-video",
						"bubble",
						"video-chat",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60133,
					"grid": 16
				},
				{
					"id": 158,
					"paths": [
						"M25.6 972.8c-11.507 0-21.6-7.677-24.67-18.766s1.634-22.864 11.501-28.784c86.57-51.942 122.485-127.414 135.218-162.755-94.088-72.048-147.648-171.746-147.648-276.094 0-52.704 13.23-103.755 39.323-151.736 24.902-45.794 60.406-86.806 105.526-121.899 91.504-71.17 212.802-110.365 341.55-110.365s250.046 39.195 341.552 110.366c45.118 35.093 80.624 76.104 105.526 121.899 26.091 47.979 39.322 99.030 39.322 151.734 0 52.702-13.23 103.755-39.322 151.736-24.902 45.794-60.408 86.806-105.526 121.899-91.506 71.17-212.803 110.365-341.552 110.365-52.907 0-104.8-6.627-154.437-19.707-21.974 14.637-63.040 40.605-112.086 65.005-76.163 37.89-141.528 57.102-194.277 57.102zM486.4 153.6c-239.97 0-435.2 149.294-435.2 332.8 0 92.946 51.432 182.379 141.107 245.368 8.797 6.178 12.795 17.194 10.013 27.576-5.984 22.325-26.363 83.597-80.878 142.734 66.659-23.341 138.424-63.832 191.434-100.286 6.296-4.328 14.197-5.621 21.544-3.52 48.558 13.888 99.691 20.928 151.981 20.928 239.97 0 435.2-149.294 435.2-332.8s-195.23-332.8-435.2-332.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"chat",
						"comment"
					],
					"defaultCode": 59455,
					"grid": 20
				},
				{
					"id": 2268,
					"paths": [
						"M512 192c-54.932 0-107.988 8.662-157.694 25.742-46.712 16.054-88.306 38.744-123.628 67.444-66.214 53.798-102.678 122.984-102.678 194.814 0 40.298 11.188 79.378 33.252 116.152 22.752 37.92 56.982 72.586 98.988 100.252 30.356 19.992 50.78 51.948 56.176 87.894 1.8 11.984 2.928 24.088 3.37 36.124 7.47-6.194 14.75-12.846 21.88-19.976 24.154-24.152 56.78-37.49 90.502-37.49 5.368 0 10.762 0.336 16.156 1.024 20.974 2.666 42.398 4.020 63.676 4.020 54.934 0 107.988-8.66 157.694-25.742 46.712-16.054 88.306-38.744 123.628-67.444 66.214-53.796 102.678-122.984 102.678-194.814s-36.464-141.016-102.678-194.814c-35.322-28.698-76.916-51.39-123.628-67.444-49.706-17.080-102.76-25.742-157.694-25.742zM512 64v0c282.77 0 512 186.25 512 416 0 229.752-229.23 416-512 416-27.156 0-53.81-1.734-79.824-5.044-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60103,
					"grid": 16
				},
				{
					"id": 2274,
					"paths": [
						"M836 64c103.4 0 188 84.6 188 188v328c0 103.4-84.6 188-188 188h-644l-192 192v-708c0-103.4 84.6-188 188-188h648z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60109,
					"grid": 16
				},
				{
					"id": 2277,
					"paths": [
						"M836 64h-648c-103.4 0-188 84.6-188 188v708l192-192h644c103.4 0 188-84.6 188-188v-328c0-103.4-84.6-188-188-188zM896 580c0 32.524-27.476 60-60 60h-708v-388c0-32.524 27.476-60 60-60h648c32.524 0 60 27.476 60 60v328z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60112,
					"grid": 16
				},
				{
					"id": 2280,
					"paths": [
						"M836 64h-648c-103.4 0-188 84.6-188 188v708l192-192h644c103.4 0 188-84.6 188-188v-328c0-103.4-84.6-188-188-188zM896 252v12h-768v-12c0-1.344 0.064-2.674 0.156-4h767.688c0.092 1.326 0.156 2.656 0.156 4zM895.844 584h-767.844v-16h768v12c0 1.344-0.064 2.676-0.156 4zM128 640v-8h737.416c-8.752 5.064-18.812 8-29.416 8h-708zM128 616v-16h764.424c-2.118 5.774-5.112 11.162-8.812 16h-755.612zM128 552v-16h768v16h-768zM128 520v-16h768v16h-768zM128 488v-16h768v16h-768zM128 456v-16h768v16h-768zM128 424v-16h768v16h-768zM128 392v-16h768v16h-768zM128 360v-16h768v16h-768zM128 328v-16h768v16h-768zM128 296v-16h768v16h-768zM836 192c10.604 0 20.664 2.936 29.418 8h-706.836c8.754-5.064 18.814-8 29.418-8h648zM883.612 216c3.704 4.838 6.696 10.226 8.812 16h-760.848c2.116-5.774 5.11-11.162 8.812-16h743.224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"comment",
						"chat",
						"talk",
						"dualtone"
					],
					"defaultCode": 60115,
					"grid": 16
				},
				{
					"id": 2281,
					"paths": [
						"M928 0c52.802 0 96 43.2 96 96v640c0 52.8-43.2 96-96 96h-283.428l-164.572 192-164.572-192h-219.428c-52.8 0-96-43.2-96-96v-640c0-52.8 43.2-96 96-96h832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60116,
					"grid": 16
				},
				{
					"id": 2283,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v640c0 52.8 43.2 96 96 96h219.428l164.572 192 164.572-192h283.428c52.8 0 96-43.2 96-96v-640c0-52.8-43.198-96-96-96zM896 704h-278.298l-137.702 155.316-137.7-155.316h-214.3v-576h768v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60118,
					"grid": 16
				},
				{
					"id": 2285,
					"paths": [
						"M928 64c52.8 0 96 43.2 96 96v512c0 52.8-43.2 96-96 96h-364.8l-307.2 256v-256h-160c-52.8 0-96-43.2-96-96v-512c0-52.8 43.2-96 96-96h832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60120,
					"grid": 16
				},
				{
					"id": 2288,
					"paths": [
						"M928 64h-832c-52.8 0-96 43.2-96 96v512c0 52.8 43.2 96 96 96h160v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-512c0-52.8-43.2-96-96-96zM896 640h-379.142l-196.858 174.714v-174.714h-192v-448h768v448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubble",
						"comment",
						"chat",
						"talk"
					],
					"defaultCode": 60123,
					"grid": 16
				},
				{
					"id": 2266,
					"width": 1152,
					"paths": [
						"M1088 901.166c0 45.5 26.028 84.908 64 104.184v15.938c-10.626 1.454-21.472 2.224-32.5 2.224-68.008 0-129.348-28.528-172.722-74.264-26.222 6.982-54.002 10.752-82.778 10.752-159.058 0-288-114.616-288-256s128.942-256 288-256c159.058 0 288 114.616 288 256 0 55.348-19.764 106.592-53.356 148.466-6.824 14.824-10.644 31.312-10.644 48.7zM512 0c278.458 0 504.992 180.614 511.836 405.52-49.182-21.92-103.586-33.52-159.836-33.52-95.56 0-185.816 33.446-254.138 94.178-70.846 62.972-109.862 147.434-109.862 237.822 0 44.672 9.544 87.888 27.736 127.788-5.228 0.126-10.468 0.212-15.736 0.212-27.156 0-53.81-1.734-79.824-5.044-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60101,
					"grid": 16
				},
				{
					"id": 2292,
					"width": 1152,
					"paths": [
						"M800 0c52.8 0 96 43.2 96 96v320c0 52.8-43.2 96-96 96h-364.8l-307.2 256v-256h-32c-52.8 0-96-43.2-96-96v-320c0-52.8 43.2-96 96-96h704zM1056 192c52.8 0 96 43.2 96 96v384c0 52.8-43.2 96-96 96h-160v256l-307.2-256h-204.8v-128h251.14l196.86 174.714v-174.714h192v-320h-64v-128h96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60127,
					"grid": 16
				},
				{
					"id": 2267,
					"width": 1152,
					"paths": [
						"M480 0v0c265.096 0 480 173.914 480 388.448s-214.904 388.448-480 388.448c-25.458 0-50.446-1.62-74.834-4.71-103.106 102.694-222.172 121.108-341.166 123.814v-25.134c64.252-31.354 116-88.466 116-153.734 0-9.106-0.712-18.048-2.030-26.794-108.558-71.214-177.97-179.988-177.97-301.89 0-214.534 214.904-388.448 480-388.448zM996 870.686c0 55.942 36.314 104.898 92 131.772v21.542c-103.126-2.318-197.786-18.102-287.142-106.126-21.14 2.65-42.794 4.040-64.858 4.040-95.47 0-183.408-25.758-253.614-69.040 144.674-0.506 281.26-46.854 384.834-130.672 52.208-42.252 93.394-91.826 122.414-147.348 30.766-58.866 46.366-121.582 46.366-186.406 0-10.448-0.45-20.836-1.258-31.168 72.57 59.934 117.258 141.622 117.258 231.676 0 104.488-60.158 197.722-154.24 258.764-1.142 7.496-1.76 15.16-1.76 22.966z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60102,
					"grid": 16
				},
				{
					"id": 2269,
					"width": 1152,
					"paths": [
						"M1088 901.166c0 45.5 26.028 84.908 64 104.184v15.938c-10.626 1.454-21.472 2.224-32.5 2.224-68.008 0-129.348-28.528-172.722-74.264-26.222 6.982-54.002 10.752-82.778 10.752-159.058 0-288-114.616-288-256s128.942-256 288-256c159.058 0 288 114.616 288 256 0 55.348-19.764 106.592-53.356 148.466-6.824 14.824-10.644 31.312-10.644 48.7zM230.678 221.186c-66.214 53.798-102.678 122.984-102.678 194.814 0 40.298 11.188 79.378 33.252 116.15 22.752 37.92 56.982 72.586 98.988 100.252 30.356 19.992 50.78 51.948 56.176 87.894 1.8 11.984 2.928 24.088 3.37 36.124 7.47-6.194 14.75-12.846 21.88-19.976 24.154-24.152 56.78-37.49 90.502-37.49 5.368 0 10.762 0.336 16.156 1.024 20.948 2.662 42.344 4.016 63.594 4.020v128c-27.128-0.002-53.754-1.738-79.742-5.042-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416 278.458 0 504.992 180.614 511.836 405.52-41.096-18.316-85.84-29.422-132.262-32.578-11.53-56.068-45.402-108.816-98.252-151.756-35.322-28.698-76.916-51.39-123.628-67.444-49.706-17.080-102.76-25.742-157.694-25.742-54.932 0-107.988 8.662-157.694 25.742-46.712 16.054-88.306 38.744-123.628 67.444z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60104,
					"grid": 16
				},
				{
					"id": 2270,
					"width": 1152,
					"paths": [
						"M480 128c-50.666 0-99.582 7.95-145.386 23.628-42.924 14.694-81.114 35.436-113.502 61.646-60.044 48.59-93.112 110.802-93.112 175.174 0 35.99 10.066 70.948 29.92 103.898 20.686 34.34 51.898 65.794 90.26 90.958 30.44 19.968 50.936 51.952 56.362 87.95 0.902 5.99 1.63 12.006 2.18 18.032 2.722-2.52 5.424-5.114 8.114-7.794 24.138-24.040 56.688-37.312 90.322-37.312 5.348 0 10.718 0.336 16.094 1.018 19.36 2.452 39.124 3.696 58.748 3.696 50.666 0 99.58-7.948 145.384-23.628 42.926-14.692 81.116-35.434 113.504-61.644 60.046-48.59 93.112-110.802 93.112-175.174s-33.066-126.582-93.112-175.174c-32.388-26.212-70.578-46.952-113.504-61.646-45.804-15.678-94.718-23.628-145.384-23.628zM480 0v0c265.096 0 480 173.914 480 388.448s-214.904 388.448-480 388.448c-25.458 0-50.446-1.62-74.834-4.71-103.106 102.694-222.172 121.108-341.166 123.814v-25.134c64.252-31.354 116-88.466 116-153.734 0-9.106-0.712-18.048-2.030-26.794-108.558-71.214-177.97-179.988-177.97-301.89 0-214.534 214.904-388.448 480-388.448zM996 870.686c0 55.942 36.314 104.898 92 131.772v21.542c-103.126-2.318-197.786-18.102-287.142-106.126-21.14 2.65-42.794 4.040-64.858 4.040-95.47 0-183.408-25.758-253.614-69.040 144.674-0.506 281.26-46.854 384.834-130.672 52.208-42.252 93.394-91.826 122.414-147.348 30.766-58.866 46.366-121.582 46.366-186.406 0-10.448-0.45-20.836-1.258-31.168 72.57 59.934 117.258 141.622 117.258 231.676 0 104.488-60.158 197.722-154.24 258.764-1.142 7.496-1.76 15.16-1.76 22.966z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60105,
					"grid": 16
				},
				{
					"id": 2272,
					"width": 1152,
					"paths": [
						"M768 0c70.4 0 128 57.6 128 128v320c0 70.4-57.6 128-128 128h-576l-192 192v-640c0-70.4 57.6-128 128-128h640zM1024 192c70.4 0 128 57.6 128 128v704l-192-192h-576c-70.4 0-128-57.6-128-128v-64h128v63.772c0.066 0.078 0.148 0.162 0.228 0.228h639.772v-383.77c-0.066-0.080-0.15-0.164-0.228-0.23h-63.772v-128h64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60107,
					"grid": 16
				},
				{
					"id": 2273,
					"width": 1152,
					"paths": [
						"M1024 192c70.4 0 128 57.6 128 128v704l-192-192h-576c-70.4 0-128-57.6-128-128v-64h128v63.772c0.066 0.078 0.148 0.162 0.228 0.228h639.772v-383.77c-0.066-0.080-0.15-0.164-0.228-0.23h-63.772v-128h64zM768 0h-640c-70.4 0-128 57.6-128 128v640l192-192h576c70.4 0 128-57.6 128-128v-320c0-70.4-57.6-128-128-128zM768 447.772c-0.066 0.080-0.15 0.162-0.228 0.228h-639.772v-319.772c0.066-0.080 0.15-0.162 0.23-0.228h639.542c0.078 0.066 0.162 0.15 0.228 0.23v319.542z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60108,
					"grid": 16
				},
				{
					"id": 2282,
					"paths": [
						"M928 192c52.802 0 96 43.2 96 96v448c0 52.8-43.2 96-96 96h-155.428l-164.572 192-164.572-192h-155.428c-52.8 0-96-43.2-96-96v-448c0-52.8 43.2-96 96-96h640zM128 128v512h-32c-52.8 0-96-43.2-96-96v-448c0-52.8 43.2-96 96-96h640c52.802 0 96 43.2 96 96v32h-704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60117,
					"grid": 16
				},
				{
					"id": 2284,
					"paths": [
						"M928 192h-640c-52.8 0-96 43.2-96 96v448c0 52.8 43.2 96 96 96h155.428l164.572 192 164.572-192h155.428c52.8 0 96-43.2 96-96v-448c0-52.8-43.198-96-96-96zM896 704h-150.298l-137.702 155.316-137.7-155.316h-150.3v-384h576v384zM128 128v512h-32c-52.8 0-96-43.2-96-96v-448c0-52.8 43.2-96 96-96h640c52.802 0 96 43.2 96 96v32h-704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60119,
					"grid": 16
				},
				{
					"id": 2291,
					"width": 1152,
					"paths": [
						"M800 0h-704c-52.8 0-96 43.2-96 96v320c0 52.8 43.2 96 96 96h32v256l307.2-256h364.8c52.8 0 96-43.2 96-96v-320c0-52.8-43.2-96-96-96zM768 384h-379.144l-196.856 174.714v-174.714h-64v-256h640v256zM1056 192c52.8 0 96 43.2 96 96v384c0 52.8-43.2 96-96 96h-160v256l-307.2-256h-204.8v-128h251.14l196.86 174.714v-174.714h192v-320h-64v-128h96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bubbles",
						"comments",
						"chat",
						"talk"
					],
					"defaultCode": 60126,
					"grid": 16
				},
				{
					"id": 1859,
					"paths": [
						"M848.976 361.69c-19.946-8.574-47.652-16.12-82.35-22.428-68.316-12.422-158.744-19.262-254.626-19.262s-186.31 6.84-254.626 19.262c-34.7 6.308-62.406 13.854-82.35 22.428-31.202 13.412-47.024 31.686-47.024 54.31 0 2.978 0.292 5.876 0.838 8.7l63.22 505.758c2.148 44.99 63.216 63.782 109.354 74.034 56.608 12.58 131.396 19.508 210.588 19.508 79.194 0 153.98-6.928 210.588-19.508 46.138-10.252 107.208-29.042 109.354-74.034l63.218-505.75c0.546-2.828 0.84-5.728 0.84-8.708 0-22.624-15.822-40.898-47.024-54.31zM290.488 398.618c61.68-9.426 140.348-14.618 221.512-14.618 81.162 0 159.83 5.192 221.514 14.618 38.48 5.88 62.974 12.196 78.296 17.382-15.322 5.186-39.816 11.502-78.296 17.382-61.684 9.426-140.352 14.618-221.514 14.618-81.164 0-159.832-5.192-221.512-14.618-38.482-5.88-62.976-12.196-78.298-17.382 15.322-5.186 39.816-11.502 78.298-17.382zM768.644 920.844c-5.584 4.062-24.746 15.010-78.534 24.94-49.656 9.168-112.91 14.216-178.11 14.216-65.198 0-128.452-5.048-178.11-14.216-53.79-9.93-72.95-20.876-78.536-24.94l-55.188-441.498c16.15 4.922 35.278 9.404 57.208 13.392 19.244 3.5 40.244 6.554 62.626 9.14v138.122c0 35.346 28.654 64 64 64s64-28.654 64-64v-129.038c20.928 0.684 42.322 1.038 64 1.038v288c0 17.674 14.328 32 32 32s32-14.326 32-32v-289.038c21.924-0.718 43.332-1.802 64-3.238v100.276c0 17.674 14.326 32 32 32s32-14.326 32-32v-106.122c22.382-2.586 43.382-5.642 62.626-9.14 21.928-3.988 41.056-8.47 57.208-13.392l-55.19 441.498z",
						"M876.542 130.562c-35.15-42.002-82.188-74.256-139.804-95.862-61.402-23.026-137.016-34.7-224.738-34.7-87.724 0-163.336 11.674-224.736 34.7-57.62 21.606-104.656 53.86-139.806 95.862-56.938 68.042-83.458 158.742-83.458 285.438 0 17.672 14.328 32 32 32s32-14.328 32-32c0-110.836 21.78-188.486 68.542-244.366 28.362-33.894 65.388-59.084 113.194-77.010 54.19-20.32 122.242-30.624 202.264-30.624 80.024 0 148.074 10.304 202.264 30.624 47.806 17.926 84.832 43.116 113.196 77.010 46.76 55.88 68.54 133.53 68.54 244.366 0 17.672 14.326 32 32 32s32-14.328 32-32c0-126.696-26.52-217.396-83.458-285.438z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bucket",
						"color",
						"fill",
						"art"
					],
					"defaultCode": 59694,
					"grid": 16
				},
				{
					"id": 1860,
					"paths": [
						"M876.542 130.562c-35.15-42.002-82.188-74.256-139.804-95.862-61.402-23.026-137.016-34.7-224.738-34.7-87.724 0-163.336 11.674-224.736 34.7-57.62 21.606-104.656 53.86-139.806 95.862-56.938 68.042-83.458 158.742-83.458 285.438 0 17.672 14.328 32 32 32s32-14.328 32-32c0-110.836 21.78-188.486 68.542-244.366 28.362-33.894 65.388-59.084 113.194-77.010 54.19-20.32 122.242-30.624 202.264-30.624 80.024 0 148.074 10.304 202.264 30.624 47.806 17.926 84.832 43.116 113.196 77.010 46.76 55.88 68.54 133.53 68.54 244.366 0 17.672 14.326 32 32 32s32-14.328 32-32c0-126.696-26.52-217.396-83.458-285.438z",
						"M848.976 361.69c-19.946-8.574-47.652-16.12-82.35-22.428-68.316-12.422-158.744-19.262-254.626-19.262s-186.31 6.84-254.626 19.262c-34.7 6.308-62.406 13.854-82.35 22.428-31.202 13.412-47.024 31.686-47.024 54.31 0 2.978 0.292 5.876 0.838 8.7l63.22 505.758c2.148 44.99 63.216 63.782 109.354 74.034 56.608 12.58 131.396 19.508 210.588 19.508 79.194 0 153.98-6.928 210.588-19.508 46.138-10.252 107.208-29.042 109.354-74.034l63.218-505.75c0.546-2.828 0.84-5.728 0.84-8.708 0-22.624-15.822-40.898-47.024-54.31zM733.514 433.382c-61.684 9.426-140.352 14.618-221.514 14.618-81.164 0-159.832-5.192-221.512-14.618-38.482-5.88-62.976-12.196-78.298-17.382 15.322-5.186 39.816-11.502 78.298-17.382 61.68-9.426 140.348-14.618 221.512-14.618 81.162 0 159.83 5.192 221.514 14.618 38.48 5.88 62.974 12.196 78.296 17.382-15.322 5.186-39.816 11.502-78.296 17.382z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bucket",
						"color",
						"fill",
						"art"
					],
					"defaultCode": 59695,
					"grid": 16
				},
				{
					"id": 2445,
					"paths": [
						"M960 320l64-128v-128l-96 192h-113.78c-8.548-9.378-21.106-18.342-39.46-28.622l-141.52-70.754c-31.48-15.746-86.040-28.624-121.24-28.624-35.204 0-89.762 12.878-121.246 28.626l-141.516 70.754c-18.362 10.28-30.914 19.246-39.462 28.622h-113.776l-96-192.002v128l64 128h128v128l-192 64v64l192-64v192h-64l-128 320h64l102.398-256h33.424c8.894 24.96 24.482 49.338 42.148 63.468l220.044 176.042c13.75 10.996 31.866 16.49 49.986 16.49 18.114 0 36.226-5.494 49.97-16.49l220.044-176.042c17.67-14.13 33.256-38.508 42.148-63.468h33.438l102.4 256h64l-128-320h-64v-192l192 64v-64l-192-64v-128h128zM544 896h-64v-640h64v640zM640 124.442v-60.442c0-35.2-28.8-64-64-64h-128c-35.204 0-64 28.8-64 64v60.442c36.258-16.21 90.568-28.442 128-28.442 37.426 0 91.73 12.232 128 28.442z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bug",
						"virus",
						"error",
						"beetle"
					],
					"defaultCode": 60280,
					"grid": 16
				},
				{
					"id": 2446,
					"paths": [
						"M1024 576v-64h-193.29c-5.862-72.686-31.786-139.026-71.67-192.25h161.944l70.060-280.24-62.090-15.522-57.94 231.76h-174.68c-0.892-0.694-1.796-1.374-2.698-2.056 6.71-19.502 10.362-40.422 10.362-62.194 0.002-105.76-85.958-191.498-191.998-191.498s-192 85.738-192 191.5c0 21.772 3.65 42.692 10.362 62.194-0.9 0.684-1.804 1.362-2.698 2.056h-174.68l-57.94-231.76-62.090 15.522 70.060 280.24h161.944c-39.884 53.222-65.806 119.562-71.668 192.248h-193.29v64h193.37c3.802 45.664 15.508 88.812 33.638 127.75h-123.992l-70.060 280.238 62.090 15.524 57.94-231.762h112.354c58.692 78.032 147.396 127.75 246.66 127.75s187.966-49.718 246.662-127.75h112.354l57.94 231.762 62.090-15.524-70.060-280.238h-123.992c18.13-38.938 29.836-82.086 33.636-127.75h193.37z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bug",
						"virus",
						"error"
					],
					"defaultCode": 60281,
					"grid": 16
				},
				{
					"id": 1533,
					"width": 950.8599472045898,
					"paths": [
						"M932.571 548.571q0 14.857-10.857 25.714t-25.714 10.857h-128q0 97.714-38.286 165.714l118.857 119.429q10.857 10.857 10.857 25.714t-10.857 25.714q-10.286 10.857-25.714 10.857t-25.714-10.857l-113.143-112.571q-2.857 2.857-8.571 7.429t-24 16.286-37.143 20.857-46.857 16.571-55.429 7.429v-512h-73.143v512q-29.143 0-58-7.714t-49.714-18.857-37.714-22.286-24.857-18.571l-8.571-8-104.571 118.286q-11.429 12-27.429 12-13.714 0-24.571-9.143-10.857-10.286-11.714-25.429t8.857-26.571l115.429-129.714q-33.143-65.143-33.143-156.571h-128q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h128v-168l-98.857-98.857q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857 25.714 10.857l98.857 98.857h482.286l98.857-98.857q10.857-10.857 25.714-10.857t25.714 10.857 10.857 25.714-10.857 25.714l-98.857 98.857v168h128q14.857 0 25.714 10.857t10.857 25.714zM658.286 219.429h-365.714q0-76 53.429-129.429t129.429-53.429 129.429 53.429 53.429 129.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bug"
					],
					"defaultCode": 61832,
					"grid": 14
				},
				{
					"id": 200,
					"paths": [
						"M896 614.4h-77.544c-3.19-56.282-16.878-110.243-39.965-158.814 53.056-15.624 91.909-64.739 91.909-122.786 0-14.138-11.461-25.6-25.6-25.6s-25.6 11.462-25.6 25.6c0 38.984-29.205 71.254-66.88 76.138-8.928-13.632-18.678-26.68-29.259-39.026-5.515-6.435-11.203-12.6-17.032-18.525 7.147-22.477 10.771-45.877 10.771-69.787 0-127.043-103.357-230.4-230.4-230.4s-230.4 103.357-230.4 230.4c0 23.909 3.624 47.309 10.77 69.787-5.829 5.923-11.515 12.090-17.032 18.525-10.582 12.346-20.331 25.394-29.259 39.026-37.674-4.883-66.878-37.154-66.878-76.138 0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6c0 58.046 38.853 107.162 91.907 122.784-23.086 48.573-36.773 102.534-39.965 158.816h-77.542c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h77.544c3.19 56.283 16.878 110.243 39.965 158.816-53.056 15.622-91.909 64.738-91.909 122.784 0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6c0-38.984 29.205-71.254 66.88-76.138 8.928 13.632 18.677 26.68 29.259 39.026 62.965 73.458 147.013 113.912 236.661 113.912s173.698-40.454 236.661-113.912c10.581-12.346 20.331-25.394 29.258-39.026 37.677 4.883 66.882 37.152 66.882 76.138 0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6c0-58.046-38.853-107.163-91.907-122.784 23.086-48.571 36.773-102.533 39.965-158.816h77.542c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6zM486.4 102.4c98.811 0 179.2 80.389 179.2 179.2 0 10.986-0.99 21.824-2.933 32.458-52.312-37.811-112.885-58.058-176.267-58.058s-123.955 20.246-176.267 58.058c-1.942-10.634-2.933-21.472-2.933-32.458 0-98.811 80.389-179.2 179.2-179.2zM204.8 640c0-173.306 112.678-316.072 256-331.41v662.821c-143.322-15.339-256-158.106-256-331.411zM512 971.411v-662.821c143.322 15.338 256 158.104 256 331.41s-112.678 316.072-256 331.411z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bug",
						"insect",
						"virus"
					],
					"defaultCode": 59497,
					"grid": 20
				},
				{
					"id": 339,
					"width": 1024,
					"paths": [
						"M928 640c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-32v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-32v-480c0-17.664-14.336-32-32-32v0-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32c-17.664 0-32 14.336-32 32v224h-32v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-32c-17.664 0-32 14.336-32 32v480c0 17.664 14.336 32 32 32h832c17.664 0 32-14.336 32-32v-224c0-17.664-14.336-32-32-32v-32zM800 640h96v32h-96v-32zM608 640h96v32h-96v-32zM384 128h96v32h-96v-32zM352 192h160v224h-160v-224zM160 384h96v32h-96v-32zM96 448h416v224h-416v-224zM928 928h-832v-224h832v224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"build",
						"play",
						"construct"
					],
					"grid": 32
				},
				{
					"id": 340,
					"width": 1024,
					"paths": [
						"M320 384v-192c0-17.664 14.336-32 32-32v-32c0-17.664 14.336-32 32-32h96c17.664 0 32 14.336 32 32v32c17.664 0 32 14.336 32 32v192h-224zM928 672v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-32v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-512v256c0 17.664 14.336 32 32 32h832c17.664 0 32-14.336 32-32v-224c0-17.664-14.336-32-32-32zM544 640v-224h-256v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-32c-17.664 0-32 14.336-32 32v192h480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"build",
						"play",
						"construct"
					],
					"grid": 32
				},
				{
					"id": 970,
					"width": 1024,
					"paths": [
						"M992 608h-32v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-64v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-32v-224c0-17.664-14.336-32-32-32h-32v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-32v-224c0-17.664-14.336-32-32-32h-32v-32c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-32c-17.664 0-32 14.336-32 32v800c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-288c0-17.664-14.336-32-32-32zM960 896h-896v-224h896v224zM384 352h32v32h-32v-32zM480 416v224h-416v-224h416zM128 96h32v32h-32v-32zM224 160v224h-160v-224h160zM640 608h32v32h-32v-32zM864 608h32v32h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"build",
						"play",
						"stack",
						"construct"
					],
					"grid": 32
				},
				{
					"id": 1568,
					"width": 804.5709495544434,
					"paths": [
						"M768 0q14.857 0 25.714 10.857t10.857 25.714v950.857q0 14.857-10.857 25.714t-25.714 10.857h-731.429q-14.857 0-25.714-10.857t-10.857-25.714v-950.857q0-14.857 10.857-25.714t25.714-10.857h731.429zM292.571 164.571v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143zM292.571 310.857v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143zM292.571 457.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143zM292.571 603.429v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143zM219.429 786.286v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM219.429 640v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM219.429 493.714v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM219.429 347.429v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM219.429 201.143v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM512 932.571v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM512 640v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM512 493.714v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM512 347.429v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM512 201.143v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM658.286 786.286v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM658.286 640v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM658.286 493.714v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM658.286 347.429v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM658.286 201.143v-36.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"building"
					],
					"defaultCode": 61869,
					"grid": 14
				},
				{
					"id": 1399,
					"width": 804.5709495544434,
					"paths": [
						"M219.429 749.714v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM219.429 603.429v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM365.714 603.429v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM219.429 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM658.286 749.714v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM512 603.429v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM365.714 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM219.429 310.857v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM658.286 603.429v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM512 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM365.714 310.857v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM219.429 164.571v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM658.286 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM512 310.857v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM365.714 164.571v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM658.286 310.857v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM512 164.571v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM658.286 164.571v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM512 950.857h219.429v-877.714h-658.286v877.714h219.429v-128q0-7.429 5.429-12.857t12.857-5.429h182.857q7.429 0 12.857 5.429t5.429 12.857v128zM804.571 36.571v950.857q0 14.857-10.857 25.714t-25.714 10.857h-731.429q-14.857 0-25.714-10.857t-10.857-25.714v-950.857q0-14.857 10.857-25.714t25.714-10.857h731.429q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"building-o"
					],
					"defaultCode": 61687,
					"grid": 14
				},
				{
					"id": 1934,
					"paths": [
						"M1024 429.256c0-200.926-58.792-363.938-131.482-365.226 0.292-0.006 0.578-0.030 0.872-0.030h-82.942c0 0-194.8 146.336-475.23 203.754-8.56 45.292-14.030 99.274-14.030 161.502s5.466 116.208 14.030 161.5c280.428 57.418 475.23 203.756 475.23 203.756h82.942c-0.292 0-0.578-0.024-0.872-0.032 72.696-1.288 131.482-164.298 131.482-365.224zM864.824 739.252c-9.382 0-19.532-9.742-24.746-15.548-12.63-14.064-24.792-35.96-35.188-63.328-23.256-61.232-36.066-143.31-36.066-231.124 0-87.81 12.81-169.89 36.066-231.122 10.394-27.368 22.562-49.266 35.188-63.328 5.214-5.812 15.364-15.552 24.746-15.552 9.38 0 19.536 9.744 24.744 15.552 12.634 14.064 24.796 35.958 35.188 63.328 23.258 61.23 36.068 143.312 36.068 231.122 0 87.804-12.81 169.888-36.068 231.124-10.39 27.368-22.562 49.264-35.188 63.328-5.208 5.806-15.36 15.548-24.744 15.548zM251.812 429.256c0-51.95 3.81-102.43 11.052-149.094-47.372 6.554-88.942 10.324-140.34 10.324-67.058 0-67.058 0-67.058 0l-55.466 94.686v88.17l55.46 94.686c0 0 0 0 67.060 0 51.398 0 92.968 3.774 140.34 10.324-7.236-46.664-11.048-97.146-11.048-149.096zM368.15 642.172l-127.998-24.51 81.842 321.544c4.236 16.634 20.744 25.038 36.686 18.654l118.556-47.452c15.944-6.376 22.328-23.964 14.196-39.084l-123.282-229.152zM864.824 548.73c-3.618 0-7.528-3.754-9.538-5.992-4.87-5.42-9.556-13.86-13.562-24.408-8.962-23.6-13.9-55.234-13.9-89.078s4.938-65.478 13.9-89.078c4.006-10.548 8.696-18.988 13.562-24.408 2.010-2.24 5.92-5.994 9.538-5.994 3.616 0 7.53 3.756 9.538 5.994 4.87 5.42 9.556 13.858 13.56 24.408 8.964 23.598 13.902 55.234 13.902 89.078 0 33.842-4.938 65.478-13.902 89.078-4.004 10.548-8.696 18.988-13.56 24.408-2.008 2.238-5.92 5.992-9.538 5.992z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bullhorn",
						"megaphone",
						"announcement",
						"advertisement",
						"news"
					],
					"defaultCode": 59769,
					"grid": 16
				},
				{
					"id": 1330,
					"width": 1024.0019569396973,
					"paths": [
						"M950.857 365.714q30.286 0 51.714 21.429t21.429 51.714-21.429 51.714-51.714 21.429v219.429q0 29.714-21.714 51.429t-51.429 21.714q-238.286-198.286-464-217.143-33.143 10.857-52 37.714t-17.714 57.429 22.857 52.857q-11.429 18.857-13.143 37.429t3.429 33.143 19.143 31.429 27.429 28.571 35.143 28.857q-16.571 33.143-63.714 47.429t-96.286 6.571-75.429-31.714q-4-13.143-16.857-50t-18.286-54-13.143-50.857-8.571-57.714 2-56.286 12.571-63.143h-69.714q-37.714 0-64.571-26.857t-26.857-64.571v-109.714q0-37.714 26.857-64.571t64.571-26.857h274.286q248.571 0 512-219.429 29.714 0 51.429 21.714t21.714 51.429v219.429zM877.714 710.857v-545.143q-225.143 172.571-438.857 196v154.286q215.429 24 438.857 194.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bullhorn"
					],
					"defaultCode": 61601,
					"grid": 14
				},
				{
					"id": 184,
					"paths": [
						"M992.694 158.682c-29.611-88.835-68.928-107.482-96.694-107.482-0.584 0-1.176 0.011-1.771 0.029-28.322 0.598-78.627 15.33-153.997 37.41-157.898 46.258-396.514 116.162-637.832 116.162-58.378 0-102.4 77.038-102.4 179.2s44.022 179.2 102.4 179.2c18.891 0 37.765 0.429 56.584 1.24l85.306 339.347c9.73 38.699 48.608 69.013 88.51 69.013h67.2c22.17 0 40.986-9.23 51.622-25.322 10.635-16.091 11.75-37.019 3.061-57.416l-131.926-309.634c160.552 23.672 308.307 66.95 417.474 98.931 75.37 22.082 125.675 36.813 153.997 37.411 0.595 0.018 1.187 0.029 1.771 0.029 27.766 0 67.083-18.646 96.694-107.482 20.19-60.563 31.307-140.582 31.307-225.318 0-84.734-11.117-164.755-31.306-225.318zM819.2 384c0-26.266 1.122-51.965 3.285-76.616 26.291 2.642 47.915 36.642 47.915 76.616s-21.624 73.974-47.915 76.616c-2.163-24.651-3.285-50.35-3.285-76.616zM51.2 384c0-78.136 30.325-128 51.2-128 58.117 0 115.915-3.888 172.422-10.445-12.142 38.794-18.822 86.912-18.822 138.445 0 51.549 6.68 99.658 18.821 138.443-56.507-6.555-114.306-10.443-172.421-10.443-20.875 0-51.2-49.864-51.2-128zM407.579 910.131c2.099 4.928 1.93 8.208 1.328 9.117s-3.55 2.352-8.907 2.352h-67.2c-16.349 0-34.869-14.44-38.856-30.296l-81.33-323.53c17.157 1.379 34.235 3.046 51.213 4.966l143.752 337.39zM332.24 530.051c-15.587-35.173-25.040-89.509-25.040-146.051 0-57.422 9.238-110.73 25.011-146.046 163.054-24.2 312.094-67.861 422.414-100.179 21.243-6.224 41.526-12.165 59.938-17.344-5.285 11.019-10.402 23.686-15.256 38.253-20.19 60.562-31.307 140.582-31.307 225.317s11.117 164.755 31.306 225.318c4.854 14.566 9.971 27.234 15.256 38.253-18.411-5.181-38.694-11.122-59.938-17.346-110.314-32.317-259.341-75.974-422.384-100.174zM944.122 593.128c-19.107 57.325-39.832 72.472-48.122 72.472s-29.014-15.147-48.122-72.472c-8.024-24.069-14.48-51.678-19.222-81.701 24.888-2.87 48.298-16.95 65.33-39.658 17.808-23.744 27.614-54.914 27.614-87.77 0-32.854-9.806-64.026-27.614-87.768-17.034-22.709-40.442-36.789-65.33-39.659 4.742-30.024 11.198-57.632 19.222-81.699 19.109-57.326 39.832-72.474 48.122-72.474s29.013 15.147 48.122 72.472c18.494 55.482 28.678 129.75 28.678 209.128s-10.184 153.646-28.678 209.128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bullhorn",
						"megaphone"
					],
					"defaultCode": 59481,
					"grid": 20
				},
				{
					"id": 1465,
					"width": 877.7139282226562,
					"paths": [
						"M585.143 512q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429 42.857-103.429 103.429-42.857 103.429 42.857 42.857 103.429zM658.286 512q0-90.857-64.286-155.143t-155.143-64.286-155.143 64.286-64.286 155.143 64.286 155.143 155.143 64.286 155.143-64.286 64.286-155.143zM731.429 512q0 121.143-85.714 206.857t-206.857 85.714-206.857-85.714-85.714-206.857 85.714-206.857 206.857-85.714 206.857 85.714 85.714 206.857zM804.571 512q0-74.286-29.143-142t-78-116.571-116.571-78-142-29.143-142 29.143-116.571 78-78 116.571-29.143 142 29.143 142 78 116.571 116.571 78 142 29.143 142-29.143 116.571-78 78-116.571 29.143-142zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bullseye"
					],
					"defaultCode": 61760,
					"grid": 14
				},
				{
					"id": 341,
					"width": 1024,
					"paths": [
						"M480 192c0-9.664 9.536-27.872 18.208-42.4 6.24-10.464 21.312-10.464 27.584 0 8.672 14.528 18.208 32.736 18.208 42.4 0 17.664-14.336 32-32 32s-32-14.336-32-32zM416 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM320 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM224 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM128 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM896 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM800 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM704 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM608 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM960 288v64c0 212.064-171.936 384-384 384v64h32c53.024 0 96 42.976 96 96 0 17.664-14.336 32-32 32h-320c-17.664 0-32-14.336-32-32 0-53.024 42.976-96 96-96h32v-64c-212.064 0-384-171.936-384-384v-64c0-17.664 14.336-32 32-32h832c17.664 0 32 14.336 32 32zM928 288h-64v64c0 159.072-128.928 288-288 288h-16c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h16c141.376 0 256-114.624 256-256v-64h-64v64c0 106.048-85.952 192-192 192h-16c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h16c88.352 0 160-71.648 160-160v-64h-64v64c0 53.024-42.976 96-96 96h-16c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h16c35.36 0 64-28.64 64-64v-64h-64v48c0 8.832-7.168 16-16 16v0c-8.832 0-16-7.168-16-16v-48h-64v48c0 8.832-7.168 16-16 16v0c-8.832 0-16-7.168-16-16v-48h-64v64c0 35.36 28.64 64 64 64h16c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16h-16c-53.024 0-96-42.976-96-96v-64h-64v64c0 88.352 71.648 160 160 160h16c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16h-16c-106.048 0-192-85.952-192-192v-64h-64v64c0 141.376 114.624 256 256 256h16c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16h-16c-159.072 0-288-128.928-288-288v-64h-64v64c0 194.4 157.6 352 352 352h32v128h-64c-35.296 0-64 28.704-64 64h320c0-35.296-28.704-64-64-64h-64v-128h32c194.4 0 352-157.6 352-352v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"burn",
						"celebrate",
						"light"
					],
					"grid": 32
				},
				{
					"id": 342,
					"width": 1024,
					"paths": [
						"M576 192c0-9.664 9.536-27.872 18.208-42.4 6.24-10.464 21.312-10.464 27.584 0 8.672 14.528 18.208 32.736 18.208 42.4 0 17.664-14.336 32-32 32s-32-14.336-32-32zM512 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM896 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM800 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM704 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM928 256h-32c-17.664 0-32 14.336-32 32v64c0 159.072-128.928 288-288 288h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16h16c141.376 0 256-114.624 256-256v-64c0-17.664-14.336-32-32-32v0c-17.664 0-32 14.336-32 32v64c0 106.048-85.952 192-192 192h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16h16c88.352 0 160-71.648 160-160v-64c0-17.664-14.336-32-32-32v0c-17.664 0-32 14.336-32 32v64c0 53.024-42.976 96-96 96h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16h16c35.36 0 64-28.64 64-64v-64c0-17.664-14.336-32-32-32v0c-17.664 0-32 14.336-32 32v48c0 8.832-7.168 16-16 16s-16-7.168-16-16v-48c0-17.664-14.336-32-32-32v0c-17.664 0-32 14.336-32 32v48c0 8.832-7.168 16-16 16s-16-7.168-16-16v-48c0-17.664-14.336-32-32-32v0c-17.664 0-32 14.336-32 32v64c0 35.36 28.64 64 64 64h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16c-53.024 0-96-42.976-96-96v-64c0-17.664-14.336-32-32-32v0c-17.664 0-32 14.336-32 32v64c0 88.352 71.648 160 160 160h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16c-106.048 0-192-85.952-192-192v-64c0-17.664-14.336-32-32-32v0c-17.664 0-32 14.336-32 32v64c0 141.376 114.624 256 256 256h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16c-159.072 0-288-128.928-288-288v-64c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v64c0 212.064 171.936 384 384 384v64h-32c-52.768 0-95.584 42.56-96 95.232-0.128 17.92 14.080 32.768 32 32.768h320c17.92 0 32.128-14.848 32-32.768-0.416-52.672-43.232-95.232-96-95.232h-32v-64c212.064 0 384-171.936 384-384v-64c0-17.664-14.336-32-32-32zM128 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM320 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM416 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32zM224 224c17.664 0 32-14.336 32-32 0-9.664-9.536-27.872-18.208-42.4-6.24-10.464-21.312-10.464-27.584 0-8.672 14.528-18.208 32.736-18.208 42.4 0 17.664 14.336 32 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"burn",
						"celebrate",
						"light"
					],
					"grid": 32
				},
				{
					"id": 343,
					"width": 1024,
					"paths": [
						"M528 502.656v-118.656h18.56c16.64 0 30.496-12.768 31.904-29.344l21.568-259.008c4.288-51.488-37.088-95.648-88.032-95.648s-92.32 44.16-88 95.648l21.6 259.008c1.344 16.576 15.2 29.344 31.84 29.344h18.56v118.656l-129.312 77.376c-28.96 17.344-46.688 48.64-46.688 82.4v73.568c0 191.744 137.408 265.184 179.744 283.264 7.936 3.392 16.608 3.392 24.544 0 42.304-18.080 179.712-91.52 179.712-283.264v-73.568c0-33.76-17.728-65.024-46.688-82.368l-129.312-77.408zM477.44 352l-21.568-259.008c-1.312-15.872 3.904-31.072 14.688-42.816 10.784-11.712 25.504-18.176 41.44-18.176s30.656 6.464 41.44 18.176c10.784 11.712 16 26.944 14.688 42.816l-21.568 259.008h-69.12zM672 736c0 173.632-123.424 238.4-159.904 253.76-35.968-15.392-160.096-81.024-160.096-253.76v-73.344c0-22.624 11.968-43.584 31.456-55.104l128.544-75.968 128.544 75.936c19.488 11.52 31.456 32.48 31.456 55.136v73.344z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bury",
						"plant",
						"dig"
					],
					"grid": 32
				},
				{
					"id": 344,
					"width": 1024,
					"paths": [
						"M445.568 354.656l-21.568-259.008c-4.32-51.488 37.024-95.648 88-95.648s92.32 44.16 88.032 95.648l-21.568 259.008c-1.408 16.576-15.264 29.344-31.904 29.344h-69.12c-16.64 0-30.496-12.768-31.872-29.344zM657.312 580.064l-129.312-77.408v-86.656h-32v86.656l-129.312 77.376c-28.96 17.344-46.688 48.64-46.688 82.4v73.568c0 191.744 137.408 265.184 179.744 283.264 7.936 3.392 16.608 3.392 24.544 0 42.304-18.080 179.712-91.52 179.712-283.264v-73.568c0-33.76-17.728-65.056-46.688-82.368z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bury",
						"plant",
						"dig"
					],
					"grid": 32
				},
				{
					"id": 971,
					"width": 1024,
					"paths": [
						"M982.624 169.376l-128-128c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-32 32c-6.016 5.984-9.376 14.144-9.376 22.624v114.752l-372.608 372.608-103.68-149.728c-6.272-9.088-16.256-13.792-26.336-13.792-8.128 0-16.288 3.072-22.592 9.376l-164.896 164.896c-90.496 90.496-23.104 329.856-0.48 352.48 14.080 14.048 111.84 45.408 205.536 45.408 57.088 0 112.672-11.616 146.944-45.888l164.896-164.896c14.112-14.112 12-37.568-4.416-48.928l-149.728-103.648 372.608-372.64h114.752c8.48 0 16.64-3.36 22.624-9.376l32-32c12.512-12.512 12.512-32.736 0-45.248zM123.168 639.36l137.76-137.76 97.632 141.248-240.288 240.288c-19.776-61.824-40.64-198.272 4.896-243.776zM522.432 763.072l-137.76 137.76c-17.536 17.536-53.664 27.168-101.728 27.168-55.776 0-110.208-12.576-141.728-22.592l239.968-239.968 141.248 97.632zM832 192v-82.752l82.752 82.752h-82.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bury",
						"dig"
					],
					"grid": 32
				},
				{
					"id": 2595,
					"paths": [
						"M959.046 472.24l-80-384c-3.564-14.246-16.362-24.24-31.046-24.24h-672c-14.684 0-27.484 9.994-31.044 24.24l-80 384c-0.634 2.538-0.956 5.144-0.956 7.76v384c0 17.674 14.328 32 32 32h96v64c0 35.346 28.654 64 64 64s64-28.654 64-64v-64h384v64c0 35.346 28.652 64 64 64s64-28.654 64-64v-64h96c17.674 0 32-14.326 32-32v-384c0-2.616-0.32-5.222-0.954-7.76zM352 128h320c17.674 0 32 14.328 32 32s-14.326 32-32 32h-320c-17.672 0-32-14.328-32-32s14.328-32 32-32zM256 768c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM224 512c-9.406 0-18.336-4.138-24.416-11.316-6.080-7.176-8.694-16.666-7.148-25.944l32-192c2.572-15.43 15.922-26.74 31.564-26.74h512c15.642 0 28.992 11.31 31.564 26.74l32 192c1.546 9.278-1.068 18.768-7.148 25.944-6.080 7.178-15.010 11.316-24.416 11.316h-576zM768 768c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bus",
						"travel",
						"transport",
						"public-transportation"
					],
					"defaultCode": 60430,
					"grid": 16
				},
				{
					"id": 1652,
					"width": 877.7129669189453,
					"paths": [
						"M219.429 694.857q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM804.571 694.857q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM778.286 468.571l-41.143-219.429q-2.857-13.143-12.857-21.429t-23.143-8.286h-524.571q-13.143 0-23.143 8.286t-12.857 21.429l-41.143 219.429q-2.857 17.143 8 30.286t28 13.143h606.857q17.143 0 28-13.143t8-30.286zM649.143 118.857q0-11.429-8-19.429t-19.429-8h-365.714q-11.429 0-19.429 8t-8 19.429 8 19.429 19.429 8h365.714q11.429 0 19.429-8t8-19.429zM877.714 533.143v344.571h-73.143v73.143q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714v-73.143h-438.857v73.143q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714v-73.143h-73.143v-344.571q0-64 14.286-127.429l58.857-259.429q5.143-44.571 55.714-78.286t131.429-50.857 178.571-17.143 178.571 17.143 131.429 50.857 55.714 78.286l60 259.429q13.143 58.286 13.143 127.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bus"
					],
					"defaultCode": 61959,
					"grid": 14
				},
				{
					"id": 172,
					"paths": [
						"M281.6 819.2c-42.347 0-76.8-34.451-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.453 76.8-76.8 76.8zM281.6 716.8c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M742.4 819.2c-42.349 0-76.8-34.451-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.451 76.8-76.8 76.8zM742.4 716.8c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M691.2 256h-358.4c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h358.4c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M793.6 307.2h-563.2c-14.138 0-25.6 11.462-25.6 25.6v256c0 14.139 11.462 25.6 25.6 25.6h255.89c0.030 0 0.059 0.003 0.088 0.003 0.034 0 0.069-0.003 0.102-0.003h255.81c0.030 0 0.058 0.003 0.088 0.003 0.034 0 0.069-0.003 0.102-0.003h51.12c14.139 0 25.6-11.461 25.6-25.6v-256c0-14.138-11.461-25.6-25.6-25.6zM256 358.4h512v204.8h-17.85l-147.15-98.101c-11.763-7.84-27.658-4.664-35.501 7.101-7.843 11.763-4.664 27.658 7.101 35.501l83.25 55.499h-163.699l-147.15-98.101c-11.763-7.84-27.659-4.664-35.501 7.101-7.842 11.763-4.664 27.658 7.101 35.501l83.25 55.499h-145.85v-204.8z",
						"M799.514 91.277c-69.808-26.594-166.541-40.077-287.514-40.077s-217.706 13.483-287.514 40.077c-100.906 38.44-122.086 96.874-122.086 139.123v563.2c0 61.814 44.045 113.531 102.4 125.426v53.774c0 28.232 22.968 51.2 51.2 51.2h51.2c28.232 0 51.2-22.968 51.2-51.2v-51.2h307.2v51.2c0 28.232 22.968 51.2 51.2 51.2h51.2c28.232 0 51.2-22.968 51.2-51.2v-53.774c58.355-11.894 102.4-63.611 102.4-125.426v-563.2c0-42.25-21.181-100.683-122.086-139.123zM307.2 972.8h-51.2v-51.2h51.2v51.2zM716.8 972.8v-51.2h51.2v51.2h-51.2zM870.4 793.6c0 42.349-34.451 76.8-76.8 76.8h-563.2c-42.347 0-76.8-34.451-76.8-76.8v-563.2c0-38.040 29.982-68.75 89.114-91.277 63.064-24.024 156.182-36.723 269.286-36.723s206.224 12.699 269.286 36.723c59.131 22.526 89.114 53.237 89.114 91.277v563.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"bus",
						"travel"
					],
					"defaultCode": 59469,
					"grid": 20
				},
				{
					"id": 345,
					"width": 1024,
					"paths": [
						"M833.408 288h-129.408v-55.936c0-105.12-81.024-196.8-186.080-199.968-108.736-3.264-197.92 83.904-197.92 191.904v64h-129.408c-17.12 0-31.2 13.472-31.968 30.56l-26.048 573.088c-2.496 54.656 41.152 100.352 95.872 100.352h567.072c54.72 0 98.4-45.696 95.904-100.352l-26.048-573.088c-0.768-17.088-14.848-30.56-31.968-30.56zM352 224c0-88.224 71.776-160 160-160s160 71.776 160 160v64h-32v-64c0-70.592-57.408-128-128-128s-128 57.408-128 128v64h-32v-64zM608 288h-192v-64c0-53.024 42.976-96 96-96s96 42.976 96 96v64zM164.544 893.088l26.048-573.088h642.848l26.048 573.088c1.632 36.448-27.456 66.912-63.936 66.912h-567.104c-36.48 0-65.568-30.464-63.904-66.912z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"buy",
						"purchase",
						"shop"
					],
					"grid": 32
				},
				{
					"id": 346,
					"width": 1024,
					"paths": [
						"M891.424 891.648c2.496 54.656-41.152 100.352-95.872 100.352h-567.104c-54.72 0-98.4-45.696-95.904-100.352l26.080-573.088c0.768-17.12 14.848-30.56 31.968-30.56h642.848c17.12 0 31.2 13.44 31.968 30.56l26.016 573.088zM517.92 32.096c-108.736-3.264-197.92 83.904-197.92 191.904v32h64v-32c0-70.688 57.312-128 128-128s128 57.312 128 128v32h64v-23.936c0-105.152-81.024-196.832-186.080-199.968z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"buy",
						"purchase",
						"shop"
					],
					"grid": 32
				},
				{
					"id": 972,
					"width": 1024,
					"paths": [
						"M800 944c0 26.496-21.504 48-48 48s-48-21.504-48-48 21.504-48 48-48 48 21.504 48 48zM336 896c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM960.224 288.096c20.8 0 36.064 19.552 31.040 39.744l-95.712 383.904c-3.584 14.24-16.384 24.256-31.072 24.256h-567.52l16 64h487.040c17.696 0 32 14.336 32 32s-14.304 32-32 32h-512.48c-14.688 0-27.488-10.016-31.040-24.256l-153.44-615.744h-71.040c-17.696 0-32-14.336-32-32s14.304-32 32-32h95.936c14.688 0 27.488 9.984 31.040 24.224l25.984 103.776 775.264 0.096zM919.040 352h-718.080l80 320h558.016l80.064-320zM352 416h-32v32h32v-32zM416 416h-32v32h32v-32zM480 416h-32v32h32v-32zM544 416h-32v32h32v-32zM608 416h-32v32h32v-32zM672 416h-32v32h32v-32zM736 416h-32v32h32v-32zM800 416h-32v32h32v-32zM800 480h-32v32h32v-32zM800 544h-32v32h32v-32zM736 480h-32v32h32v-32zM672 480h-32v32h32v-32zM608 480h-32v32h32v-32zM544 480h-32v32h32v-32zM480 480h-32v32h32v-32zM416 480h-32v32h32v-32zM352 480h-32v32h32v-32zM352 576v-32h-32v32h32zM416 544h-32v32h32v-32zM480 544h-32v32h32v-32zM544 544h-32v32h32v-32zM608 544h-32v32h32v-32zM672 544h-32v32h32v-32zM736 544h-32v32h32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"buy",
						"purchase",
						"shop"
					],
					"grid": 32
				},
				{
					"id": 1658,
					"width": 877.7149963378906,
					"paths": [
						"M522.857 620.571h-168l84-314.857zM572 804.571h177.714l-185.143-585.143h-251.429l-185.143 585.143h177.714l218.857-179.429zM877.714 237.714v548.571q0 67.429-48.571 116t-116 48.571h-548.571q-67.429 0-116-48.571t-48.571-116v-548.571q0-67.429 48.571-116t116-48.571h548.571q67.429 0 116 48.571t48.571 116z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"buysellads"
					],
					"defaultCode": 61965,
					"grid": 14
				},
				{
					"id": 1580,
					"width": 1170.2871084213257,
					"paths": [
						"M1042.286 512q53.143 0 90.571 37.429t37.429 90.571v219.429q0 8-5.143 13.143t-13.143 5.143h-54.857v36.571q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714v-36.571h-585.143v36.571q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714v-36.571h-54.857q-8 0-13.143-5.143t-5.143-13.143v-219.429q0-53.143 37.429-90.571t90.571-37.429h16l60-239.429q13.143-53.714 59.429-90t102.286-36.286h73.143v-128q0-8 5.143-13.143t13.143-5.143h256q8 0 13.143 5.143t5.143 13.143v128h73.143q56 0 102.286 36.286t59.429 90l60 239.429h16zM182.857 786.286q37.714 0 64.571-26.857t26.857-64.571-26.857-64.571-64.571-26.857-64.571 26.857-26.857 64.571 26.857 64.571 64.571 26.857zM294.857 512h580.571l-50.857-204q-1.143-4.571-8-10t-12-5.429h-438.857q-5.143 0-12 5.429t-8 10zM987.429 786.286q37.714 0 64.571-26.857t26.857-64.571-26.857-64.571-64.571-26.857-64.571 26.857-26.857 64.571 26.857 64.571 64.571 26.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cab",
						"taxi"
					],
					"defaultCode": 61882,
					"grid": 14
				},
				{
					"id": 2195,
					"paths": [
						"M128 1024h768v-255.998h-768v255.998zM384 864c0-17.672 14.328-32 32-32h192c17.674 0 32 14.328 32 32v64c0 17.672-14.326 32-32 32s-32-14.328-32-32v-32h-128v32c0 17.672-14.328 32-32 32s-32-14.328-32-32v-64z",
						"M128 704.002h768v-256.002h-768v256.002zM384 544c0-17.672 14.328-32 32-32h192c17.674 0 32 14.328 32 32v64c0 17.672-14.326 32-32 32s-32-14.328-32-32v-32h-128v32c0 17.672-14.328 32-32 32s-32-14.328-32-32v-64z",
						"M704 0h-384l-192 128v256h768v-256l-192-128zM640 288c0 17.672-14.326 32-32 32s-32-14.328-32-32v-32h-128v32c0 17.672-14.328 32-32 32s-32-14.328-32-32v-64c0-17.672 14.328-32 32-32h192c17.674 0 32 14.328 32 32v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cabinet",
						"drawers",
						"archive",
						"office"
					],
					"defaultCode": 60030,
					"grid": 16
				},
				{
					"id": 2539,
					"width": 1024,
					"paths": [
						"M928 320h-32v-96c0-53.020-42.98-96-96-96s-96 42.98-96 96v192c0 17.346-14.654 32-32 32h-96v-352c0-53.020-42.98-96-96-96s-96 42.98-96 96v96h-32c-17.672 0-32 14.328-32 32s14.328 32 32 32h32v320h-96c-17.346 0-32-14.654-32-32v-64c0-53.020-42.98-96-96-96s-96 42.98-96 96v64c0 123.514 100.486 224 224 224h96v256h192v-192h32c17.674 0 32-14.326 32-32s-14.326-32-32-32h-32v-128h96c123.514 0 224-100.486 224-224v-32h32c17.674 0 32-14.328 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cactus",
						"nature",
						"desert"
					],
					"defaultCode": 60374,
					"grid": 16
				},
				{
					"id": 347,
					"width": 1024,
					"paths": [
						"M512 704c88.352 0 160-71.648 160-160s-71.648-160-160-160-160 71.648-160 160 71.648 160 160 160zM512 416c70.592 0 128 57.408 128 128s-57.408 128-128 128-128-57.408-128-128c0-70.592 57.408-128 128-128zM832 128l-24.704-74.112c-4.352-13.088-16.576-21.888-30.368-21.888h-529.856c-13.792 0-26.016 8.8-30.368 21.888l-24.704 74.112c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h2.656l53.984 647.968c4.16 49.76 45.76 88.032 95.68 88.032h335.36c49.92 0 91.52-38.272 95.68-88.032l53.984-647.968h2.656c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM776.928 64l21.344 64h-572.544l21.344-64h529.856zM743.456 901.312c-2.752 32.896-30.752 58.688-63.776 58.688h-335.36c-33.024 0-61.024-25.792-63.776-58.688l-53.76-645.312h570.432l-53.76 645.312zM832 224h-640v-64h640v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caffeinate",
						"drink",
						"awaken",
						"wake"
					],
					"grid": 32
				},
				{
					"id": 348,
					"width": 1024,
					"paths": [
						"M160 224v-64c0-17.664 14.336-32 32-32l24.704-74.112c4.352-13.088 16.576-21.888 30.368-21.888h529.856c13.76 0 26.016 8.8 30.368 21.888l24.704 74.112c17.664 0 32 14.336 32 32v64c0 17.664-14.336 32-32 32h-640c-17.664 0-32-14.336-32-32zM512 416c-70.592 0-128 57.408-128 128s57.408 128 128 128 128-57.408 128-128c0-70.592-57.408-128-128-128zM826.656 288l-51.328 615.968c-4.128 49.76-45.728 88.032-95.648 88.032h-335.36c-49.92 0-91.52-38.272-95.68-88.032l-51.296-615.968h629.312zM672 544c0-88.352-71.648-160-160-160s-160 71.648-160 160 71.648 160 160 160 160-71.648 160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caffeinate",
						"drink",
						"awaken",
						"wake"
					],
					"grid": 32
				},
				{
					"id": 973,
					"width": 1024,
					"paths": [
						"M896 288c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-6.4l-20.448-102.272c-3.008-14.976-16.128-25.728-31.392-25.728h-651.52c-15.264 0-28.384 10.752-31.392 25.728l-20.448 102.272h-6.4c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h2.656l5.344 64h-5.216c-18.72 0-33.44 16-31.904 34.656l32.096 384c1.408 16.576 15.264 29.344 31.904 29.344h10.464l16.224 194.656c1.376 16.576 15.232 29.344 31.872 29.344h581.12c16.64 0 30.496-12.768 31.904-29.344l16.192-194.656h10.464c16.64 0 30.496-12.768 31.904-29.344l32.096-384c1.536-18.656-13.184-34.656-31.904-34.656h-5.216l5.344-64h2.656zM212.48 64h599.040l19.2 96h-637.44l19.2-96zM773.12 960h-522.24l-16-192h554.24l-16 192zM831.68 736h-639.36l-26.752-320h692.864l-26.752 320zM192.224 256h639.552l-10.656 128h-618.24l-10.656-128zM864 224h-704v-32h704v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caffeinate",
						"drink",
						"awaken",
						"wake"
					],
					"grid": 32
				},
				{
					"id": 2481,
					"paths": [
						"M576 321.242v-97.242c0-17.6-14.4-32-32-32h-64c-17.6 0-32 14.4-32 32v97.242c-252.562 9.842-448 77.166-448 158.758v384c0 88.366 229.23 160 512 160s512-71.634 512-160v-384c0-81.592-195.438-148.916-448-158.758zM107.016 465.59c24.278-12.75 57.502-24.816 96.084-34.89 69.448-18.134 154.666-29.664 244.902-33.384v82.684c0 17.6 14.4 32 32 32h64c17.6 0 32-14.4 32-32v-82.684c90.234 3.72 175.454 15.25 244.9 33.384 38.582 10.076 71.806 22.14 96.084 34.89 10.706 5.624 18.118 10.532 23.164 14.41-5.046 3.878-12.458 8.788-23.164 14.41-24.278 12.75-57.502 24.816-96.084 34.89-85.692 22.378-195.394 34.7-308.902 34.7s-223.21-12.322-308.902-34.7c-38.582-10.074-71.806-22.14-96.084-34.89-10.706-5.624-18.118-10.532-23.164-14.41 5.048-3.878 12.46-8.788 23.166-14.41zM960 763.498c-87.334 49.198-255.208 82.502-448 82.502s-360.666-33.304-448-82.502v-90c87.334 49.198 255.208 82.502 448 82.502s360.666-33.304 448-82.502v90zM512 160c-35.346 0-64-28.654-64-64 0-1.25 0.044-2.488 0.116-3.718 2.42-61.506 63.884-92.282 63.884-92.282s61.464 30.776 63.884 92.282c0.072 1.23 0.116 2.468 0.116 3.718 0 35.346-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cake",
						"birthday",
						"party",
						"anniversary"
					],
					"defaultCode": 60316,
					"grid": 16
				},
				{
					"id": 349,
					"width": 1024,
					"paths": [
						"M272 128c-8.832 0-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16z",
						"M400 128c-8.832 0-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16z",
						"M800 32h-576c-35.36 0-64 28.64-64 64v832c0 35.36 28.64 64 64 64h576c35.36 0 64-28.64 64-64v-832c0-35.36-28.64-64-64-64zM384 960h-160c-17.664 0-32-14.336-32-32v-160h192v192zM384 736h-192v-192h192v192zM384 512h-192v-192h192v192zM608 960h-192v-192h192v192zM608 736h-192v-192h192v192zM608 512h-192v-192h192v192zM832 928c0 17.664-14.336 32-32 32h-160v-192h192v160zM832 736h-192v-192h192v192zM832 512h-192v-192h192v192zM832 288h-640v-192c0-17.664 14.336-32 32-32h576c17.664 0 32 14.336 32 32v192z",
						"M336 128c-8.832 0-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calculate",
						"add",
						"divide",
						"multiply",
						"subtract",
						"compute"
					],
					"grid": 32
				},
				{
					"id": 350,
					"width": 1024,
					"paths": [
						"M608 512h-192v-192h192v192zM160 288v-192c0-35.36 28.64-64 64-64h576c35.36 0 64 28.64 64 64v192h-704zM384 208c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16s-16 7.168-16 16v64zM320 208c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16s-16 7.168-16 16v64zM256 208c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16s-16 7.168-16 16v64zM640 320v192h176c8.832 0 16 7.168 16 16s-7.168 16-16 16h-176v192h176c8.832 0 16 7.168 16 16s-7.168 16-16 16h-176v176c0 8.832-7.168 16-16 16s-16-7.168-16-16v-176h-192v176c0 8.832-7.168 16-16 16s-16-7.168-16-16v-176h-176c-8.832 0-16-7.168-16-16s7.168-16 16-16h176v-192h-176c-8.832 0-16-7.168-16-16s7.168-16 16-16h176v-192h-224v608c0 35.36 28.64 64 64 64h576c35.36 0 64-28.64 64-64v-608h-224zM416 736h192v-192h-192v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calculate",
						"add",
						"divide",
						"multiply",
						"subtract",
						"compute"
					],
					"grid": 32
				},
				{
					"id": 974,
					"width": 1024,
					"paths": [
						"M928 0h-800c-17.664 0-32 14.336-32 32v960c0 17.664 14.336 32 32 32h800c17.664 0 32-14.336 32-32v-960c0-17.664-14.336-32-32-32zM160 64h736v256h-736v-256zM704 480h-160v-128h160v128zM512 480h-160v-128h160v128zM512 512v128h-160v-128h160zM512 672v128h-160v-128h160zM544 672h160v128h-160v-128zM544 640v-128h160v128h-160zM736 512h160v128h-160v-128zM736 480v-128h160v128h-160zM160 352h160v128h-160v-128zM160 512h160v128h-160v-128zM160 672h160v128h-160v-128zM160 960v-128h352v128h-352zM544 960v-128h160v128h-160zM736 960v-288h160v288h-160zM224 128h32v128h-32v-128zM288 128h32v128h-32v-128zM352 128h32v128h-32v-128zM448 128v128h-32v-128h32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calculate",
						"add",
						"divide",
						"multiply",
						"subtract",
						"compute"
					],
					"grid": 32
				},
				{
					"id": 2092,
					"paths": [
						"M768 0h-512c-35.2 0-64 28.8-64 64v896c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-896c0-35.2-28.8-64-64-64zM384 960h-128v-128h128v128zM384 768h-128v-128h128v128zM384 576h-128v-128h128v128zM576 960h-128v-128h128v128zM576 768h-128v-128h128v128zM576 576h-128v-128h128v128zM768 960h-128v-128h128v128zM768 768h-128v-128h128v128zM768 576h-128v-128h128v128zM768 384h-512v-320h512v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calculator",
						"compute",
						"math",
						"arithmetic",
						"sum"
					],
					"defaultCode": 59927,
					"grid": 16
				},
				{
					"id": 2093,
					"paths": [
						"M928 1024h-896c-17.672 0-32-14.326-32-32v-960c0-17.672 14.328-32 32-32h896c17.674 0 32 14.328 32 32v960c0 17.674-14.326 32-32 32zM64 960h832v-896h-832v896z",
						"M128 128h704v192h-704v-192z",
						"M128 384h128v128h-128v-128z",
						"M320 384h128v128h-128v-128z",
						"M512 384h128v128h-128v-128z",
						"M128 576h128v128h-128v-128z",
						"M320 576h128v128h-128v-128z",
						"M512 576h128v128h-128v-128z",
						"M128 768h128v128h-128v-128z",
						"M320 768h128v128h-128v-128z",
						"M512 768h128v128h-128v-128z",
						"M704 576h128v320h-128v-320z",
						"M704 384h128v128h-128v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calculator",
						"compute",
						"math",
						"arithmetic",
						"sum"
					],
					"defaultCode": 59928,
					"grid": 16
				},
				{
					"id": 2094,
					"paths": [
						"M384 64h-320c-35.2 0-64 28.8-64 64v320c0 35.2 28.796 64 64 64h320c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM384 320h-320v-64h320v64zM896 64h-320c-35.204 0-64 28.8-64 64v832c0 35.2 28.796 64 64 64h320c35.2 0 64-28.8 64-64v-832c0-35.2-28.8-64-64-64zM896 640h-320v-64h320v64zM896 448h-320v-64h320v64zM384 576h-320c-35.2 0-64 28.8-64 64v320c0 35.2 28.796 64 64 64h320c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM384 832h-128v128h-64v-128h-128v-64h128v-128h64v128h128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calculator",
						"compute",
						"math",
						"arithmetic",
						"sum"
					],
					"defaultCode": 59929,
					"grid": 16
				},
				{
					"id": 1627,
					"width": 950.8570175170898,
					"paths": [
						"M219.429 877.714q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM438.857 877.714q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM219.429 658.286q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM658.286 877.714q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM438.857 658.286q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM219.429 438.857q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM658.286 658.286q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM438.857 438.857q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM877.714 877.714v-219.429q0-29.714-21.714-51.429t-51.429-21.714-51.429 21.714-21.714 51.429v219.429q0 29.714 21.714 51.429t51.429 21.714 51.429-21.714 21.714-51.429zM658.286 438.857q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM877.714 256v-146.286q0-14.857-10.857-25.714t-25.714-10.857h-731.429q-14.857 0-25.714 10.857t-10.857 25.714v146.286q0 14.857 10.857 25.714t25.714 10.857h731.429q14.857 0 25.714-10.857t10.857-25.714zM877.714 438.857q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM950.857 73.143v877.714q0 29.714-21.714 51.429t-51.429 21.714h-804.571q-29.714 0-51.429-21.714t-21.714-51.429v-877.714q0-29.714 21.714-51.429t51.429-21.714h804.571q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calculator"
					],
					"defaultCode": 61932,
					"grid": 14
				},
				{
					"id": 2164,
					"paths": [
						"M0 960c0 35.348 28.654 64 64 64h896c35.348 0 64-28.652 64-64v-576h-1024v576zM704 448h256v128h-256v-128zM704 640h256v128h-256v-128zM704 832h256v128h-256v-128zM384 448h256v128h-256v-128zM384 640h256v128h-256v-128zM384 832h256v128h-256v-128zM64 448h256v128h-256v-128zM64 640h256v128h-256v-128zM64 832h256v128h-256v-128zM960 128h-128v-91.428c0-20.198-14.326-36.572-32-36.572-17.672 0-32 16.374-32 36.572v91.428h-512v-91.428c0-20.198-14.326-36.572-32-36.572s-32 16.374-32 36.572v91.428h-128c-35.346 0-64 28.654-64 64v128h1024v-128c0-35.346-28.654-64-64-64zM224 288c-35.346 0-64-28.654-64-64 0-23.684 12.876-44.348 32-55.416v55.416c0 17.672 14.328 32 32 32s32-14.328 32-32v-55.416c19.124 11.068 32 31.732 32 55.416 0 35.346-28.654 64-64 64zM800 288c-35.344 0-64-28.654-64-64 0-23.684 12.876-44.348 32-55.416v55.416c0 17.672 14.328 32 32 32 17.674 0 32-14.328 32-32v-55.416c19.126 11.068 32 31.732 32 55.416 0 35.346-28.652 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar",
						"date",
						"schedule",
						"time",
						"day"
					],
					"defaultCode": 59999,
					"grid": 16
				},
				{
					"id": 1752,
					"width": 950.8559799194336,
					"paths": [
						"M744.571 550.857l-292.571 292.571q-5.714 5.143-13.143 5.143t-13.143-5.143l-164.571-164.571q-5.143-5.714-5.143-13.143t5.143-12.571l26.286-26.286q5.143-5.143 12.571-5.143t13.143 5.143l125.714 125.714 253.714-253.714q5.714-5.143 13.143-5.143t12.571 5.143l26.286 26.286q5.143 5.143 5.143 12.571t-5.143 13.143zM73.143 950.857h804.571v-585.143h-804.571v585.143zM292.571 256v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM731.429 256v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM950.857 219.429v731.429q0 29.714-21.714 51.429t-51.429 21.714h-804.571q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h73.143v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h219.429v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h73.143q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar-check-o"
					],
					"defaultCode": 62068,
					"grid": 14
				},
				{
					"id": 2170,
					"paths": [
						"M512 576c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64z",
						"M896 128v-128h-128v128h-512v-128h-128v128h-128v896h1024v-896h-128zM192 960h-128v-128h128v128zM192 768h-128v-128h128v128zM192 576h-128v-128h128v128zM192 384h-128v-128h128v128zM384 960h-128v-128h128v128zM384 768h-128v-128h128v128zM384 576h-128v-128h128v128zM384 384h-128v-128h128v128zM576 960h-128v-128h128v128zM576 768h-128v-128h128v128zM576 576h-128v-128h128v128zM576 384h-128v-128h128v128zM768 960h-128v-128h128v128zM768 768h-128v-128h128v128zM768 576h-128v-128h128v128zM768 384h-128v-128h128v128zM960 960h-128v-128h128v128zM960 768h-128v-128h128v128zM960 576h-128v-128h128v128zM960 384h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar",
						"day",
						"date",
						"schedule",
						"time"
					],
					"defaultCode": 60005,
					"grid": 16
				},
				{
					"id": 2169,
					"paths": [
						"M896 128v-128h-128v128h-512v-128h-128v128h-128v896h1024v-896h-128zM192 960h-128v-128h128v128zM192 768h-128v-128h128v128zM192 576h-128v-128h128v128zM192 384h-128v-128h128v128zM384 960h-128v-128h128v128zM384 768h-128v-128h128v128zM384 576h-128v-128h128v128zM384 384h-128v-128h128v128zM576 960h-128v-128h128v128zM576 768h-128v-128h128v128zM576 576h-128v-128h128v128zM576 384h-128v-128h128v128zM768 960h-128v-128h128v128zM768 768h-128v-128h128v128zM768 576h-128v-128h128v128zM768 384h-128v-128h128v128zM960 960h-128v-128h128v128zM960 768h-128v-128h128v128zM960 576h-128v-128h128v128zM960 384h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar",
						"date",
						"schedule",
						"time",
						"day"
					],
					"defaultCode": 60004,
					"grid": 16
				},
				{
					"id": 149,
					"paths": [
						"M947.2 102.4h-128v-25.6c0-14.138-11.461-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v25.6h-512v-25.6c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v25.6h-128c-42.347 0-76.8 34.453-76.8 76.8v716.8c0 42.349 34.453 76.8 76.8 76.8h870.4c42.349 0 76.8-34.451 76.8-76.8v-716.8c0-42.347-34.451-76.8-76.8-76.8zM76.8 153.6h128v76.8c0 14.138 11.462 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-76.8h512v76.8c0 14.138 11.461 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-76.8h128c14.115 0 25.6 11.485 25.6 25.6v128h-921.6v-128c0-14.115 11.485-25.6 25.6-25.6zM947.2 921.6h-870.4c-14.115 0-25.6-11.485-25.6-25.6v-537.6h921.6v537.6c0 14.115-11.485 25.6-25.6 25.6z",
						"M384 512h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M537.6 512h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M691.2 512h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M844.8 512h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M230.4 614.4h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M384 614.4h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M537.6 614.4h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M691.2 614.4h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M844.8 614.4h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M230.4 716.8h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M384 716.8h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M537.6 716.8h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M691.2 716.8h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M844.8 716.8h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M230.4 819.2h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M384 819.2h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M537.6 819.2h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M691.2 819.2h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M844.8 819.2h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar-full",
						"calendar",
						"date",
						"schedule"
					],
					"defaultCode": 59446,
					"grid": 20
				},
				{
					"id": 1750,
					"width": 950.8559799194336,
					"paths": [
						"M658.286 640v36.571q0 8-5.143 13.143t-13.143 5.143h-329.143q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h329.143q8 0 13.143 5.143t5.143 13.143zM73.143 950.857h804.571v-585.143h-804.571v585.143zM292.571 256v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM731.429 256v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM950.857 219.429v731.429q0 29.714-21.714 51.429t-51.429 21.714h-804.571q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h73.143v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h219.429v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h73.143q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar-minus-o"
					],
					"defaultCode": 62066,
					"grid": 14
				},
				{
					"id": 1453,
					"width": 950.8559799194336,
					"paths": [
						"M73.143 950.857h804.571v-585.143h-804.571v585.143zM292.571 256v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM731.429 256v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM950.857 219.429v731.429q0 29.714-21.714 51.429t-51.429 21.714h-804.571q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h73.143v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h219.429v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h73.143q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar-o"
					],
					"defaultCode": 61747,
					"grid": 14
				},
				{
					"id": 1749,
					"width": 950.8570175170898,
					"paths": [
						"M877.714 146.286q29.714 0 51.429 21.714t21.714 51.429v731.429q0 29.714-21.714 51.429t-51.429 21.714h-804.571q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h73.143v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h219.429v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h73.143zM658.286 91.429v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143zM219.429 91.429v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143zM877.714 950.857v-585.143h-804.571v585.143h804.571zM512 621.714h128q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-128v128q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-128h-128q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h128v-128q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar-plus-o"
					],
					"defaultCode": 62065,
					"grid": 14
				},
				{
					"id": 1751,
					"width": 950.8559799194336,
					"paths": [
						"M634.857 791.429l-26.286 26.286q-5.143 5.143-12.571 5.143t-13.143-5.143l-107.429-108-107.429 108q-5.714 5.143-13.143 5.143t-12.571-5.143l-26.286-26.286q-5.143-5.143-5.143-12.571t5.143-13.143l108-107.429-108-107.429q-5.143-5.714-5.143-13.143t5.143-12.571l26.286-26.286q5.143-5.143 12.571-5.143t13.143 5.143l107.429 107.429 107.429-107.429q5.714-5.143 13.143-5.143t12.571 5.143l26.286 26.286q5.143 5.143 5.143 12.571t-5.143 13.143l-107.429 107.429 107.429 107.429q5.143 5.714 5.143 13.143t-5.143 12.571zM73.143 950.857h804.571v-585.143h-804.571v585.143zM292.571 256v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM731.429 256v-164.571q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v164.571q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM950.857 219.429v731.429q0 29.714-21.714 51.429t-51.429 21.714h-804.571q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h73.143v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h219.429v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h73.143q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar-times-o"
					],
					"defaultCode": 62067,
					"grid": 14
				},
				{
					"id": 2171,
					"paths": [
						"M512 576c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zM768 512c0-35.4-28.6-64-64-64s-64 28.6-64 64 28.6 64 64 64 64-28.6 64-64zM960 512c0-35.4-28.6-64-64-64s-64 28.6-64 64 28.6 64 64 64 64-28.6 64-64zM384 512c0-35.4-28.6-64-64-64s-64 28.6-64 64 28.6 64 64 64 64-28.6 64-64zM192 512c0-35.4-28.6-64-64-64s-64 28.6-64 64 28.6 64 64 64 64-28.6 64-64z",
						"M896 128v-128h-128v128h-512v-128h-128v128h-128v896h1024v-896h-128zM192 960h-128v-128h128v128zM192 768h-128v-128h128v128zM192 576h-128v-128h128v128zM192 384h-128v-128h128v128zM384 960h-128v-128h128v128zM384 768h-128v-128h128v128zM384 576h-128v-128h128v128zM384 384h-128v-128h128v128zM576 960h-128v-128h128v128zM576 768h-128v-128h128v128zM576 576h-128v-128h128v128zM576 384h-128v-128h128v128zM768 960h-128v-128h128v128zM768 768h-128v-128h128v128zM768 576h-128v-128h128v128zM768 384h-128v-128h128v128zM960 960h-128v-128h128v128zM960 768h-128v-128h128v128zM960 576h-128v-128h128v128zM960 384h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar",
						"week",
						"date",
						"schedule",
						"time",
						"day"
					],
					"defaultCode": 60006,
					"grid": 16
				},
				{
					"id": 2165,
					"paths": [
						"M320 384h128v128h-128zM512 384h128v128h-128zM704 384h128v128h-128zM128 768h128v128h-128zM320 768h128v128h-128zM512 768h128v128h-128zM320 576h128v128h-128zM512 576h128v128h-128zM704 576h128v128h-128zM128 576h128v128h-128zM832 0v64h-128v-64h-448v64h-128v-64h-128v1024h960v-1024h-128zM896 960h-832v-704h832v704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar",
						"date",
						"schedule",
						"time",
						"day"
					],
					"defaultCode": 60000,
					"grid": 16
				},
				{
					"id": 2166,
					"paths": [
						"M512 448h64v64h-64v-64z",
						"M640 576h64v64h-64v-64z",
						"M640 704h64v64h-64v-64z",
						"M512 320h64v64h-64v-64z",
						"M512 576h64v64h-64v-64z",
						"M512 832h64v64h-64v-64z",
						"M512 704h64v64h-64v-64z",
						"M384 320h64v64h-64v-64z",
						"M768 576h64v64h-64v-64z",
						"M768 448h64v64h-64v-64z",
						"M768 320h64v64h-64v-64z",
						"M768 704h64v64h-64v-64z",
						"M640 320h64v64h-64v-64z",
						"M768 832h64v64h-64v-64z",
						"M640 448h64v64h-64v-64z",
						"M640 832h64v64h-64v-64z",
						"M128 448h64v64h-64v-64z",
						"M128 576h64v64h-64v-64z",
						"M256 832h64v64h-64v-64z",
						"M384 448h64v64h-64v-64z",
						"M128 832h64v64h-64v-64z",
						"M128 704h64v64h-64v-64z",
						"M128 320h64v64h-64v-64z",
						"M384 704h64v64h-64v-64z",
						"M256 704h64v64h-64v-64z",
						"M384 576h64v64h-64v-64z",
						"M384 832h64v64h-64v-64z",
						"M256 320h64v64h-64v-64z",
						"M256 576h64v64h-64v-64z",
						"M256 448h64v64h-64v-64z",
						"M768 64v-64h-128v64h-320v-64h-128v64h-192v960h960v-960h-192zM640 128h128v64h-128v-64zM192 128h128v64h-128v-64zM896 960h-832v-704h832v704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar",
						"date",
						"schedule",
						"time",
						"day"
					],
					"defaultCode": 60001,
					"grid": 16
				},
				{
					"id": 2167,
					"paths": [
						"M832 192h-64v128h-192v-128h-192v128h-192v-128h-64c-35.2 0-64 28.8-64 64v704c0 35.2 28.8 64 64 64h704c35.2 0 64-28.8 64-64v-704c0-35.2-28.8-64-64-64zM256 960h-127.886c-0.040-0.034-0.082-0.076-0.114-0.116v-127.884h128v128zM256 768h-128v-128h128v128zM256 576h-128v-128h128v128zM448 960h-128v-128h128v128zM448 768h-128v-128h128v128zM448 576h-128v-128h128v128zM640 960h-128v-128h128v128zM640 768h-128v-128h128v128zM640 576h-128v-128h128v128zM832 959.884c-0.034 0.040-0.076 0.082-0.116 0.116h-127.884v-128h128v127.884zM832 768h-128v-128h128v128zM832 576h-128v-128h128v128zM320 128c0-17.672-14.328-32-32-32s-32 14.328-32 32v128h64v-128zM704 128c0-17.672-14.328-32-32-32s-32 14.328-32 32v128h64v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar",
						"date",
						"schedule",
						"time",
						"day"
					],
					"defaultCode": 60002,
					"grid": 16
				},
				{
					"id": 2168,
					"paths": [
						"M896 128h-96v32c0 35.29-28.71 64-64 64s-64-28.71-64-64v-32h-320v32c0 35.29-28.71 64-64 64s-64-28.71-64-64v-32h-96c-35.2 0-64 28.8-64 64v704c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64v-704c0-35.2-28.8-64-64-64zM896 895.884c-0.034 0.040-0.076 0.082-0.116 0.116h-767.77c-0.040-0.034-0.082-0.076-0.114-0.116v-575.884h768v575.884zM288 192c17.672 0 32-14.328 32-32v-128c0-17.672-14.328-32-32-32s-32 14.328-32 32v128c0 17.672 14.328 32 32 32zM736 192c17.672 0 32-14.328 32-32v-128c0-17.672-14.328-32-32-32s-32 14.328-32 32v128c0 17.672 14.328 32 32 32zM576 384h-320v64h256v128h-256v64h256v128h-256v64h320zM704 832h64v-448h-128v64h64zM872 984h-720c-35.2 0-64-20.8-64-56v32c0 35.2 28.8 64 64 64h720c35.2 0 64-28.8 64-64v-32c0 35.2-28.8 56-64 56z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar",
						"date",
						"schedule",
						"time",
						"day"
					],
					"defaultCode": 60003,
					"grid": 16
				},
				{
					"id": 1287,
					"width": 950.8559799194336,
					"paths": [
						"M73.143 950.857h164.571v-164.571h-164.571v164.571zM274.286 950.857h182.857v-164.571h-182.857v164.571zM73.143 749.714h164.571v-182.857h-164.571v182.857zM274.286 749.714h182.857v-182.857h-182.857v182.857zM73.143 530.286h164.571v-164.571h-164.571v164.571zM493.714 950.857h182.857v-164.571h-182.857v164.571zM274.286 530.286h182.857v-164.571h-182.857v164.571zM713.143 950.857h164.571v-164.571h-164.571v164.571zM493.714 749.714h182.857v-182.857h-182.857v182.857zM292.571 256v-164.571q0-7.429-5.429-12.857t-12.857-5.429h-36.571q-7.429 0-12.857 5.429t-5.429 12.857v164.571q0 7.429 5.429 12.857t12.857 5.429h36.571q7.429 0 12.857-5.429t5.429-12.857zM713.143 749.714h164.571v-182.857h-164.571v182.857zM493.714 530.286h182.857v-164.571h-182.857v164.571zM713.143 530.286h164.571v-164.571h-164.571v164.571zM731.429 256v-164.571q0-7.429-5.429-12.857t-12.857-5.429h-36.571q-7.429 0-12.857 5.429t-5.429 12.857v164.571q0 7.429 5.429 12.857t12.857 5.429h36.571q7.429 0 12.857-5.429t5.429-12.857zM950.857 219.429v731.429q0 29.714-21.714 51.429t-51.429 21.714h-804.571q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h73.143v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h219.429v-54.857q0-37.714 26.857-64.571t64.571-26.857h36.571q37.714 0 64.571 26.857t26.857 64.571v54.857h73.143q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"calendar"
					],
					"defaultCode": 61555,
					"grid": 14
				},
				{
					"id": 351,
					"width": 1024,
					"paths": [
						"M320 800h384c17.664 0 32-14.336 32-32v-576c0-17.664-14.336-32-32-32h-384c-17.664 0-32 14.336-32 32v576c0 17.664 14.336 32 32 32zM320 192h384v576h-384v-576zM704 32h-384c-53.024 0-96 42.976-96 96v768c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-768c0-53.024-42.976-96-96-96zM768 896c0 35.36-28.64 64-64 64h-384c-35.36 0-64-28.64-64-64v-768c0-35.36 28.64-64 64-64h384c35.36 0 64 28.64 64 64v768zM560 880c0 26.496-21.504 48-48 48s-48-21.504-48-48 21.504-48 48-48 48 21.504 48 48zM581.44 449.984v0c20.448-21.504 31.264-52.32 24.576-85.632-7.552-37.728-38.88-68.288-76.768-74.88-60.608-10.528-113.248 35.872-113.248 94.528 0 25.632 10.208 48.768 26.56 65.984v0c-35.872 17.92-58.56 54.592-58.56 94.688v63.328c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-63.296c0-40.128-22.688-76.8-58.56-94.72zM512 320c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64c0-35.296 28.704-64 64-64zM608 608h-192v-50.72c0-31.552 15.36-60.896 41.216-78.848l14.816-7.392c12.192 5.632 25.664 8.96 39.968 8.96s27.776-3.328 39.968-8.96l14.816 7.392c25.856 17.952 41.216 47.296 41.216 78.848v50.72z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"call",
						"play",
						"ring",
						"use"
					],
					"grid": 32
				},
				{
					"id": 352,
					"width": 1024,
					"paths": [
						"M320 768h384v-576h-384v576zM384 544.704c0-40.128 22.688-76.768 58.56-94.688-16.352-17.248-26.56-40.384-26.56-66.016 0-58.656 52.64-105.056 113.248-94.496 37.888 6.592 69.216 37.152 76.768 74.88 6.688 33.312-4.128 64.096-24.576 85.632 35.904 17.92 58.56 54.592 58.56 94.688v63.296c0 17.664-14.336 32-32 32h-192c-17.664 0-32-14.336-32-32v-63.296zM608 608h-192v-50.72c0-31.552 15.36-60.896 41.216-78.848l14.816-7.392c12.192 5.632 25.664 8.96 39.968 8.96s27.776-3.328 39.968-8.96l14.816 7.392c25.856 17.952 41.216 47.296 41.216 78.848v50.72zM448 384c0-35.296 28.704-64 64-64s64 28.704 64 64c0 35.296-28.704 64-64 64s-64-28.704-64-64zM704 32h-384c-53.024 0-96 42.976-96 96v768c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-768c0-53.024-42.976-96-96-96zM512 928c-26.496 0-48-21.504-48-48s21.504-48 48-48 48 21.504 48 48-21.504 48-48 48zM736 768c0 17.664-14.336 32-32 32h-384c-17.664 0-32-14.336-32-32v-576c0-17.664 14.336-32 32-32h384c17.664 0 32 14.336 32 32v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"call",
						"play",
						"ring",
						"use"
					],
					"grid": 32
				},
				{
					"id": 975,
					"width": 1024,
					"paths": [
						"M836.672 23.84c-6.496-7.392-15.456-11.072-24.416-11.072-9.056 0-18.112 3.808-24.48 11.456l-188.928 226.688c-8.448 10.144-9.888 24.256-3.488 35.84 18.88 34.112 56.256 105.792 57.216 139.552 1.216 41.888-180.928 226.048-226.272 226.272-0.096 0-0.16 0-0.224 0-33.856 0-105.184-37.76-139.264-56.96-4.896-2.752-10.24-4.096-15.552-4.096-7.328 0-14.592 2.528-20.48 7.456l-227.008 189.184c-14.624 12.192-15.648 34.656-1.76 47.68 104.736 98.144 210.912 156.16 336.416 156.16 135.776 0 633.568-497.792 633.568-633.568 0-125.312-57.824-223.616-155.328-334.592zM812.672 94.336c13.184 15.936 24.672 31.136 35.36 46.016l-168.864 168.864c-5.056-10.432-10.752-21.696-17.248-33.984l150.752-180.896zM274.944 662.176c12.224 6.592 23.456 12.32 33.856 17.408l-169.984 169.984c-15.072-10.88-30.24-22.528-45.728-35.872l181.856-151.52zM680.864 680.864c-165.568 165.568-290.432 245.344-322.432 247.136-66.4 0-128.512-19.168-192.768-60l174.176-174.176c52.96 22.56 76.512 22.784 86.624 22.784 0.064 0 0.128 0 0.224 0 15.744-0.096 63.616-0.32 186.496-127.456 105.024-108.672 103.936-146.496 103.424-164.64-0.256-9.28-0.992-31.968-23.2-84.16l173.216-173.216c43.168 66.848 61.376 125.728 61.376 191.040-1.792 32.288-81.568 157.152-247.136 322.688z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"call",
						"ring"
					],
					"grid": 32
				},
				{
					"id": 1881,
					"paths": [
						"M304 608c0 114.876 93.124 208 208 208s208-93.124 208-208-93.124-208-208-208-208 93.124-208 208zM960 256h-224c-16-64-32-128-96-128h-256c-64 0-80 64-96 128h-224c-35.2 0-64 28.8-64 64v576c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-576c0-35.2-28.8-64-64-64zM512 892c-156.85 0-284-127.148-284-284 0-156.85 127.15-284 284-284 156.852 0 284 127.15 284 284 0 156.852-127.146 284-284 284zM960 448h-128v-64h128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"camera",
						"photo",
						"picture",
						"image"
					],
					"defaultCode": 59716,
					"grid": 16
				},
				{
					"id": 1302,
					"width": 1024.0000076293945,
					"paths": [
						"M530.286 475.429q0-8-5.143-13.143t-13.143-5.143q-37.714 0-64.571 26.857t-26.857 64.571q0 8 5.143 13.143t13.143 5.143 13.143-5.143 5.143-13.143q0-22.857 16-38.857t38.857-16q8 0 13.143-5.143t5.143-13.143zM658.286 549.714q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429 42.857-103.429 103.429-42.857 103.429 42.857 42.857 103.429zM73.143 877.714h877.714v-73.143h-877.714v73.143zM731.429 549.714q0-90.857-64.286-155.143t-155.143-64.286-155.143 64.286-64.286 155.143 64.286 155.143 155.143 64.286 155.143-64.286 64.286-155.143zM146.286 182.857h219.429v-73.143h-219.429v73.143zM73.143 292.571h877.714v-146.286h-473.143l-36.571 73.143h-368v73.143zM1024 146.286v731.429q0 30.286-21.429 51.714t-51.714 21.429h-877.714q-30.286 0-51.714-21.429t-21.429-51.714v-731.429q0-30.286 21.429-51.714t51.714-21.429h877.714q30.286 0 51.714 21.429t21.429 51.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"camera-retro"
					],
					"defaultCode": 61571,
					"grid": 14
				},
				{
					"id": 132,
					"paths": [
						"M979.496 873.131c-0.003 0-0.005 0-0.008 0-12.378-0.002-24.846-4.957-37.059-14.725l-176.038-140.832c-28.272-22.613-49.59-66.97-49.59-103.174v-153.6c0-36.203 21.318-80.56 49.589-103.174l176.037-140.83c12.216-9.773 24.686-14.726 37.066-14.726 22.155-0.002 44.509 16.675 44.509 53.931v563.2c0 14.234-3.275 26.197-9.733 35.558-8.056 11.675-20.73 18.373-34.771 18.373zM972.8 258.064l-174.427 139.542c-15.896 12.717-30.373 42.837-30.373 63.194v153.6c0 20.358 14.477 50.478 30.371 63.194l174.429 139.542v-559.072z",
						"M588.8 870.4h-512c-42.347 0-76.8-34.453-76.8-76.8v-512c0-42.347 34.453-76.8 76.8-76.8h512c42.347 0 76.8 34.453 76.8 76.8v512c0 42.347-34.453 76.8-76.8 76.8zM76.8 256c-14.115 0-25.6 11.485-25.6 25.6v512c0 14.115 11.485 25.6 25.6 25.6h512c14.115 0 25.6-11.485 25.6-25.6v-512c0-14.115-11.485-25.6-25.6-25.6h-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"camera-video",
						"video"
					],
					"defaultCode": 59429,
					"grid": 20
				},
				{
					"id": 1882,
					"paths": [
						"M960 320h-192c-5.482 0-15.236-6.028-17.69-10.932l-35.378-70.756c-13.202-26.402-45.414-46.312-74.932-46.312h-256c-29.518 0-61.732 19.91-74.932 46.31l-35.378 70.756c-2.454 4.906-12.206 10.934-17.69 10.934v-32c0-17.672-14.328-32-32-32h-128c-17.672 0-32 14.328-32 32v32c-35.29 0-64 28.71-64 64v576c0 35.29 28.71 64 64 64h896c35.29 0 64-28.71 64-64v-576c0-35.29-28.71-64-64-64zM64 960v-576h192c29.518 0 61.732-19.91 74.932-46.31l35.378-70.756c2.454-4.904 12.206-10.932 17.69-10.932h256c5.482 0 15.236 6.028 17.69 10.932l35.378 70.756c13.202 26.4 45.414 46.31 74.932 46.31h192l0.006 576h-896.006z",
						"M512 376c-145.57 0-264 118.43-264 264s118.43 264 264 264 264-118.43 264-264-118.43-264-264-264zM512 838c-109.178 0-198-88.822-198-198s88.822-198 198-198 198 88.822 198 198-88.822 198-198 198z",
						"M640 640c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128s128 57.308 128 128z",
						"M832 448h64v64h-64v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"camera",
						"photo",
						"picture",
						"image"
					],
					"defaultCode": 59717,
					"grid": 16
				},
				{
					"id": 1883,
					"paths": [
						"M832 64h-640c-70.4 0-128 57.6-128 128v640c0 70.4 57.6 128 128 128h640c70.4 0 128-57.6 128-128v-640c0-70.4-57.6-128-128-128zM672 576c0 88.224-71.776 160-160 160s-160-71.776-160-160c0-52.284 25.21-98.786 64.112-128h191.778c38.9 29.214 64.11 75.716 64.11 128zM320 192h64v128h-64v-128zM192 192h64v128h-64v-128zM832 831.772c-0.066 0.078-0.15 0.162-0.228 0.228h-639.544c-0.080-0.066-0.162-0.15-0.228-0.228v-383.772h98.256c-21.782 37.656-34.256 81.37-34.256 128 0 141.384 114.616 256 256 256s256-114.616 256-256c0-46.63-12.472-90.344-34.256-128h98.256v383.772z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"camera",
						"photo",
						"picture",
						"image"
					],
					"defaultCode": 59718,
					"grid": 16
				},
				{
					"id": 1224,
					"width": 1097.1430358886719,
					"paths": [
						"M548.571 384q68 0 116.286 48.286t48.286 116.286-48.286 116.286-116.286 48.286-116.286-48.286-48.286-116.286 48.286-116.286 116.286-48.286zM950.857 146.286q60.571 0 103.429 42.857t42.857 103.429v512q0 60.571-42.857 103.429t-103.429 42.857h-804.571q-60.571 0-103.429-42.857t-42.857-103.429v-512q0-60.571 42.857-103.429t103.429-42.857h128l29.143-77.714q10.857-28 39.714-48.286t59.143-20.286h292.571q30.286 0 59.143 20.286t39.714 48.286l29.143 77.714h128zM548.571 804.571q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"camera"
					],
					"defaultCode": 61488,
					"grid": 14
				},
				{
					"id": 133,
					"paths": [
						"M486.4 768c-127.043 0-230.4-103.357-230.4-230.4s103.357-230.4 230.4-230.4c127.043 0 230.4 103.357 230.4 230.4s-103.357 230.4-230.4 230.4zM486.4 358.4c-98.811 0-179.2 80.389-179.2 179.2s80.389 179.2 179.2 179.2 179.2-80.389 179.2-179.2-80.389-179.2-179.2-179.2z",
						"M896 921.6h-819.2c-42.347 0-76.8-34.451-76.8-76.8v-512c0-42.347 34.453-76.8 76.8-76.8h76.8c21.246 0 54.278-13.682 69.302-28.706l29.992-29.992c24.914-24.915 70.272-43.702 105.506-43.702h256c35.235 0 80.594 18.789 105.506 43.702l29.992 29.99c15.024 15.026 48.056 28.707 69.302 28.707h76.8c42.349 0 76.8 34.453 76.8 76.8v512c0 42.349-34.451 76.8-76.8 76.8zM76.8 307.2c-14.115 0-25.6 11.485-25.6 25.6v512c0 14.115 11.485 25.6 25.6 25.6h819.2c14.115 0 25.6-11.485 25.6-25.6v-512c0-14.115-11.485-25.6-25.6-25.6h-76.8c-35.235 0-80.594-18.789-105.506-43.702l-29.992-29.99c-15.024-15.026-48.056-28.707-69.302-28.707h-256c-21.246 0-54.278 13.682-69.302 28.706l-29.992 29.992c-24.914 24.915-70.272 43.702-105.506 43.702h-76.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"camera",
						"photo"
					],
					"defaultCode": 59430,
					"grid": 20
				},
				{
					"id": 2943,
					"paths": [
						"M736 0h-448l-288 288v448l288 288h448l288-288v-448l-288-288zM800 704l-96 96-192-192-192 192-96-96 192-192-192-192 96-96 192 192 192-192 96 96-192 192 192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cancel",
						"close",
						"remove",
						"delete"
					],
					"defaultCode": 60778,
					"grid": 16
				},
				{
					"id": 2938,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z",
						"M672 256l-160 160-160-160-96 96 160 160-160 160 96 96 160-160 160 160 96-96-160-160 160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cancel-circle",
						"close",
						"remove",
						"delete"
					],
					"defaultCode": 60773,
					"grid": 16
				},
				{
					"id": 2939,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM768 672l-96 96-160-160-160 160-96-96 160-160-160-160 96-96 160 160 160-160 96 96-160 160 160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cancel-circle",
						"close",
						"remove",
						"delete"
					],
					"defaultCode": 60774,
					"grid": 16
				},
				{
					"id": 2941,
					"paths": [
						"M895.772 128c0.078 0.066 0.162 0.15 0.228 0.23v767.542c-0.066 0.078-0.15 0.162-0.228 0.228h-767.544c-0.080-0.066-0.162-0.15-0.228-0.228v-767.544c0.066-0.080 0.15-0.162 0.23-0.228h767.542zM896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128v0z",
						"M672 256l-160 160-160-160-96 96 160 160-160 160 96 96 160-160 160 160 96-96-160-160 160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cancel-square",
						"close",
						"remove",
						"delete"
					],
					"defaultCode": 60776,
					"grid": 16
				},
				{
					"id": 2942,
					"paths": [
						"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM797.254 706.744l-90.508 90.51-194.746-194.746-194.746 194.746-90.508-90.508 194.746-194.746-194.746-194.748 90.508-90.506 194.746 194.744 194.746-194.744 90.508 90.508-194.744 194.746 194.744 194.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cancel-square",
						"close",
						"remove",
						"delete"
					],
					"defaultCode": 60777,
					"grid": 16
				},
				{
					"id": 2591,
					"paths": [
						"M960 512h-64c0-5.232-0.642-10.446-1.91-15.522l-64-256c-7.122-28.49-32.722-48.478-62.090-48.478h-512c-29.368 0-54.966 19.988-62.088 48.478l-64 256c-1.27 5.076-1.912 10.29-1.912 15.522h-64c-35.346 0-64 28.654-64 64v256c0 35.346 28.654 64 64 64h64v64c0 35.346 28.654 64 64 64s64-28.654 64-64v-64h512v64c0 35.346 28.654 64 64 64s64-28.654 64-64v-64h64c35.346 0 64-28.654 64-64v-256c0-35.346-28.654-64-64-64zM192 768c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64zM257.97 512l48-192h412.060l48 192h-508.060zM832 768c-35.348 0-64-28.654-64-64s28.652-64 64-64 64 28.654 64 64-28.652 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"car",
						"travel",
						"automobile",
						"transport",
						"drive",
						"vehicle",
						"transit"
					],
					"defaultCode": 60426,
					"grid": 16
				},
				{
					"id": 2593,
					"paths": [
						"M960 512h-64c0-5.232-0.642-10.446-1.91-15.522l-64-256c-7.122-28.49-32.722-48.478-62.090-48.478h-512c-29.368 0-54.966 19.988-62.088 48.478l-64 256c-1.27 5.076-1.912 10.29-1.912 15.522h-64c-35.346 0-64 28.654-64 64v256c0 35.346 28.654 64 64 64h64v64c0 35.346 28.654 64 64 64s64-28.654 64-64v-64h512v64c0 35.346 28.654 64 64 64s64-28.654 64-64v-64h64c35.346 0 64-28.654 64-64v-256c0-35.346-28.654-64-64-64zM192 768c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64zM257.97 512l48-192h412.060l48 192h-508.060zM832 768c-35.348 0-64-28.654-64-64s28.652-64 64-64 64 28.654 64 64-28.652 64-64 64z",
						"M672 128l-32.956-103.76c-3.562-14.246-16.36-24.24-31.044-24.24h-192c-14.684 0-27.484 9.994-31.044 24.24l-32.956 103.76h320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"car",
						"travel",
						"automobile",
						"taxi",
						"transport",
						"drive",
						"vehicle",
						"transit"
					],
					"defaultCode": 60428,
					"grid": 16
				},
				{
					"id": 173,
					"paths": [
						"M281.6 819.2c-42.347 0-76.8-34.451-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.453 76.8-76.8 76.8zM281.6 716.8c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M742.4 819.2c-42.349 0-76.8-34.451-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.451 76.8-76.8 76.8zM742.4 716.8c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M868.256 609.642c-6.646-40.557-28.301-164.576-51.76-211.491-15.627-31.256-55.694-55.139-119.088-70.987-51.496-12.874-117.342-19.963-185.408-19.963s-133.912 7.090-185.408 19.965c-63.394 15.848-103.461 39.733-119.090 70.987-23.458 46.915-45.112 170.933-51.758 211.491-35.778 24.512-53.344 59.99-53.344 107.157v128c0 33.373 21.403 61.829 51.2 72.397v55.603c0 28.232 22.968 51.2 51.2 51.2h51.2c28.232 0 51.2-22.968 51.2-51.2v-51.2h409.6v51.2c0 28.232 22.968 51.2 51.2 51.2h51.2c28.232 0 51.2-22.968 51.2-51.2v-55.603c29.797-10.566 51.2-39.024 51.2-72.397v-128c0-47.166-17.566-82.645-53.344-107.158zM253.298 421.048c15.186-30.37 111.014-62.648 258.702-62.648s243.517 32.278 258.702 62.648c14.718 29.437 31.026 107.306 41.139 162.966-4.998-1.472-10.166-2.845-15.512-4.118-13.656-3.251-28.434-5.862-44.2-7.971l-148.421-106.334c-11.494-8.237-27.485-5.59-35.72 5.901-8.234 11.493-5.592 27.485 5.901 35.72l80.166 57.435c-43.517-1.443-91.251-1.446-142.056-1.446-5.998 0-11.942 0-17.854 0.003l-147.146-98.102c-11.765-7.843-27.658-4.664-35.501 7.099s-4.666 27.658 7.099 35.501l84.178 56.122c-68.654 1.237-128.362 4.946-175.107 16.075-5.347 1.274-10.517 2.648-15.517 4.12 10.115-55.654 26.418-133.515 41.146-162.97zM256 972.8h-51.2v-51.2h51.2v51.2zM768 972.8v-51.2h51.2v51.2h-51.2zM870.4 844.8c0 14.115-11.485 25.6-25.6 25.6h-665.6c-14.115 0-25.6-11.485-25.6-25.6v-128c0-47.331 24.896-72.565 85.93-87.098 64.275-15.302 160.757-15.302 272.47-15.302s208.194 0 272.47 15.302c61.034 14.533 85.93 39.766 85.93 87.098v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"car",
						"travel",
						"automobile"
					],
					"defaultCode": 59470,
					"grid": 20
				},
				{
					"id": 1369,
					"width": 585.1440315246582,
					"paths": [
						"M585.143 402.286q0 14.857-10.857 25.714l-256 256q-10.857 10.857-25.714 10.857t-25.714-10.857l-256-256q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857h512q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caret-down"
					],
					"defaultCode": 61655,
					"grid": 14
				},
				{
					"id": 1371,
					"width": 402.28599548339844,
					"paths": [
						"M365.714 256v512q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-256-256q-10.857-10.857-10.857-25.714t10.857-25.714l256-256q10.857-10.857 25.714-10.857t25.714 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caret-left"
					],
					"defaultCode": 61657,
					"grid": 14
				},
				{
					"id": 1372,
					"width": 329.1440124511719,
					"paths": [
						"M329.143 512q0 14.857-10.857 25.714l-256 256q-10.857 10.857-25.714 10.857t-25.714-10.857-10.857-25.714v-512q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857l256 256q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caret-right"
					],
					"defaultCode": 61658,
					"grid": 14
				},
				{
					"id": 1480,
					"width": 877.7129821777344,
					"paths": [
						"M654.286 385.714q10.286 20-2.857 37.714l-182.857 256q-10.857 15.429-29.714 15.429t-29.714-15.429l-182.857-256q-13.143-17.714-2.857-37.714 9.714-20 32.571-20h365.714q22.857 0 32.571 20zM731.429 786.286v-548.571q0-7.429-5.429-12.857t-12.857-5.429h-548.571q-7.429 0-12.857 5.429t-5.429 12.857v548.571q0 7.429 5.429 12.857t12.857 5.429h548.571q7.429 0 12.857-5.429t5.429-12.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caret-square-o-down",
						"toggle-down"
					],
					"defaultCode": 61776,
					"grid": 14
				},
				{
					"id": 1541,
					"width": 877.7129821777344,
					"paths": [
						"M585.143 329.143v365.714q0 14.857-10.857 25.714t-25.714 10.857q-11.429 0-21.143-6.857l-256-182.857q-15.429-10.857-15.429-29.714t15.429-29.714l256-182.857q9.714-6.857 21.143-6.857 14.857 0 25.714 10.857t10.857 25.714zM731.429 786.286v-548.571q0-7.429-5.429-12.857t-12.857-5.429h-548.571q-7.429 0-12.857 5.429t-5.429 12.857v548.571q0 7.429 5.429 12.857t12.857 5.429h548.571q7.429 0 12.857-5.429t5.429-12.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caret-square-o-left",
						"toggle-left"
					],
					"defaultCode": 61841,
					"grid": 14
				},
				{
					"id": 1482,
					"width": 877.7129821777344,
					"paths": [
						"M621.714 512q0 18.857-15.429 29.714l-256 182.857q-17.714 13.143-37.714 2.857-20-9.714-20-32.571v-365.714q0-22.857 20-32.571 20-10.286 37.714 2.857l256 182.857q15.429 10.857 15.429 29.714zM731.429 786.286v-548.571q0-8-5.143-13.143t-13.143-5.143h-548.571q-8 0-13.143 5.143t-5.143 13.143v548.571q0 8 5.143 13.143t13.143 5.143h548.571q8 0 13.143-5.143t5.143-13.143zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caret-square-o-right",
						"toggle-right"
					],
					"defaultCode": 61778,
					"grid": 14
				},
				{
					"id": 1481,
					"width": 877.7129821777344,
					"paths": [
						"M654.286 638.286q-9.714 20-32.571 20h-365.714q-22.857 0-32.571-20-10.286-20 2.857-37.714l182.857-256q10.857-15.429 29.714-15.429t29.714 15.429l182.857 256q13.143 17.714 2.857 37.714zM731.429 786.286v-548.571q0-7.429-5.429-12.857t-12.857-5.429h-548.571q-7.429 0-12.857 5.429t-5.429 12.857v548.571q0 7.429 5.429 12.857t12.857 5.429h548.571q7.429 0 12.857-5.429t5.429-12.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caret-square-o-up",
						"toggle-up"
					],
					"defaultCode": 61777,
					"grid": 14
				},
				{
					"id": 1370,
					"width": 585.1440086364746,
					"paths": [
						"M585.143 694.857q0 14.857-10.857 25.714t-25.714 10.857h-512q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714l256-256q10.857-10.857 25.714-10.857t25.714 10.857l256 256q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"caret-up"
					],
					"defaultCode": 61656,
					"grid": 14
				},
				{
					"id": 353,
					"width": 1024,
					"paths": [
						"M672 166.72v-70.72c0-53.024-42.976-96-96-96h-128c-53.024 0-96 42.976-96 96v70.72c-113.888 58.304-192 176.544-192 313.28v384c0 53.024 42.976 96 96 96h32v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-32h256v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-32h32c53.024 0 96-42.976 96-96v-384c0-136.736-78.112-254.976-192-313.28zM384 96c0-35.296 28.704-64 64-64h128c35.296 0 64 28.704 64 64v56.352c-10.432-4.096-21.088-7.68-32-10.752v-45.6c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v45.6c-10.912 3.072-21.568 6.688-32 10.752v-56.352zM576 96v38.080c-20.768-3.808-42.112-6.080-64-6.080s-43.232 2.272-64 6.080v-38.080h128zM352 992h-32v-32h32v32zM704 992h-32v-32h32v32zM832 864c0 35.296-28.704 64-64 64h-512c-35.296 0-64-28.704-64-64v-128h64v80c0 26.464 21.536 48 48 48h416c26.464 0 48-21.536 48-48v-80h64v128zM352 672v48c0 8.832 7.168 16 16 16s16-7.168 16-16v-48h352v144c0 8.832-7.168 16-16 16h-416c-8.832 0-16-7.168-16-16v-144h64zM288 640v-160c0-123.52 100.48-224 224-224s224 100.48 224 224v160h-448zM832 704h-64v-224c0-141.152-114.848-256-256-256s-256 114.848-256 256v224h-64v-224c0-176.448 143.552-320 320-320s320 143.552 320 320v224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"carry",
						"pack",
						"wear",
						"smuggle"
					],
					"grid": 32
				},
				{
					"id": 354,
					"width": 1024,
					"paths": [
						"M288 672h64v48c0 8.832 7.168 16 16 16s16-7.168 16-16v-48h352v160h-448v-160zM864 480v224h-96v-224c0-141.376-114.624-256-256-256s-256 114.624-256 256v224h-96v-224c0-136.736 78.112-254.976 192-313.28v-70.72c0-53.024 42.976-96 96-96h128c53.024 0 96 42.976 96 96v70.72c113.888 58.304 192 176.544 192 313.28zM416 141.6c30.56-8.672 62.688-13.6 96-13.6s65.44 4.928 96 13.6v-45.6c0-17.632-14.368-32-32-32h-128c-17.632 0-32 14.368-32 32v45.6zM736 480c0-123.52-100.48-224-224-224s-224 100.48-224 224v160h448v-160zM768 832c0 17.664-14.336 32-32 32h-448c-17.664 0-32-14.336-32-32v-96h-96v128c0 53.024 42.976 96 96 96h32v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-32h256v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-32h32c53.024 0 96-42.976 96-96v-128h-96v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"carry",
						"pack",
						"wear",
						"smuggle"
					],
					"grid": 32
				},
				{
					"id": 976,
					"width": 1024,
					"paths": [
						"M256 864h512v-288h-512v288zM288 608h32v64h32v-64h384v224h-448v-224zM598.624 352l-86.624-86.624-86.624 86.624 86.624 86.624 86.624-86.624zM512 310.624l41.376 41.376-41.376 41.376-41.376-41.376 41.376-41.376zM672 131.168v-35.168c0-52.928-43.072-96-96-96h-128c-52.928 0-96 43.072-96 96v35.168c-136.8 62.528-224 197.12-224 348.832v480c0 17.664 14.336 32 32 32h64c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h384c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h64c17.664 0 32-14.336 32-32v-480c0-151.712-87.2-286.304-224-348.832zM832 928h-640v-448c0-176.448 143.552-320 320-320s320 143.552 320 320v448zM448 64h128c17.632 0 32 14.368 32 32v45.6c-30.56-8.672-62.688-13.6-96-13.6s-65.44 4.928-96 13.6v-45.6c0-17.632 14.368-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"carry",
						"pack",
						"wear",
						"smuggle"
					],
					"grid": 32
				},
				{
					"id": 2067,
					"paths": [
						"M384 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M1024 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M1024 512v-384h-768c0-35.346-28.654-64-64-64h-192v64h128l48.074 412.054c-29.294 23.458-48.074 59.5-48.074 99.946 0 70.696 57.308 128 128 128h768v-64h-768c-35.346 0-64-28.654-64-64 0-0.218 0.014-0.436 0.016-0.656l831.984-127.344z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart",
						"purchase",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59902,
					"grid": 16
				},
				{
					"id": 2072,
					"paths": [
						"M832 768h-544c-32.276 0-59.502-24.036-63.506-56.062l-56.992-455.938h-103.502c-35.346 0-64-28.654-64-64s28.654-64 64-64h160c32.276 0 59.502 24.034 63.506 56.062l56.992 455.938h439.226l114.738-401.582c9.708-33.986 45.134-53.664 79.12-43.956 33.986 9.71 53.666 45.134 43.956 79.12l-128 448c-7.85 27.474-32.964 46.418-61.538 46.418zM256 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM640 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM768 448h-128v128h-128v-128h-128v-128h128v-128h128v128h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart-add",
						"cart",
						"purchase",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59907,
					"grid": 16
				},
				{
					"id": 2073,
					"paths": [
						"M977.582 194.462c33.986 9.71 53.666 45.134 43.956 79.12l-128 448c-7.85 27.474-32.964 46.418-61.538 46.418h-544c-32.276 0-59.502-24.036-63.506-56.062l-56.992-455.938h-103.502c-35.346 0-64-28.654-64-64s28.654-64 64-64h160c32.276 0 59.502 24.034 63.506 56.062l56.992 455.938h439.226l114.738-401.582c9.71-33.986 45.136-53.664 79.12-43.956zM256 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM640 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM364 320h148v-192h128v192h148l-212 228z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart-add",
						"cart",
						"purchase",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59908,
					"grid": 16
				},
				{
					"id": 1668,
					"width": 950.859920501709,
					"paths": [
						"M731.429 402.286q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857l-84 83.429v-167.429q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714v167.429l-84-83.429q-10.857-10.857-25.714-10.857t-25.714 10.857-10.857 25.714 10.857 25.714l146.286 146.286q10.857 10.857 25.714 10.857t25.714-10.857l146.286-146.286q10.857-10.857 10.857-25.714zM365.714 877.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM877.714 877.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM950.857 256v292.571q0 13.714-9.143 24.286t-23.429 12.286l-596.571 69.714q0.571 4 2.571 12.286t3.429 15.143 1.429 12.571q0 9.143-13.714 36.571h525.714q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714-25.714 10.857h-585.143q-14.857 0-25.714-10.857t-10.857-25.714q0-8 6.286-22.571t16.857-34 11.714-21.714l-101.143-470.286h-116.571q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h146.286q9.143 0 16.286 3.714t11.429 8.857 7.429 14 4.286 15.143 3.143 16.857 2.571 14.571h686.286q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart-arrow-down"
					],
					"defaultCode": 61976,
					"grid": 14
				},
				{
					"id": 1667,
					"width": 950.859920501709,
					"paths": [
						"M694.857 402.286q0-14.857-10.857-25.714t-25.714-10.857h-73.143v-73.143q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714v73.143h-73.143q-14.857 0-25.714 10.857t-10.857 25.714 10.857 25.714 25.714 10.857h73.143v73.143q0 14.857 10.857 25.714t25.714 10.857 25.714-10.857 10.857-25.714v-73.143h73.143q14.857 0 25.714-10.857t10.857-25.714zM365.714 877.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM877.714 877.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM950.857 256v292.571q0 13.714-9.143 24.286t-23.429 12.286l-596.571 69.714q0.571 4 2.571 12.286t3.429 15.143 1.429 12.571q0 9.143-13.714 36.571h525.714q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714-25.714 10.857h-585.143q-14.857 0-25.714-10.857t-10.857-25.714q0-8 6.286-22.571t16.857-34 11.714-21.714l-101.143-470.286h-116.571q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h146.286q9.143 0 16.286 3.714t11.429 8.857 7.429 14 4.286 15.143 3.143 16.857 2.571 14.571h686.286q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart-plus"
					],
					"defaultCode": 61975,
					"grid": 14
				},
				{
					"id": 2074,
					"paths": [
						"M977.582 194.462c33.986 9.71 53.666 45.134 43.956 79.12l-128 448c-7.85 27.474-32.964 46.418-61.538 46.418h-544c-32.276 0-59.502-24.036-63.506-56.062l-56.992-455.938h-103.502c-35.346 0-64-28.654-64-64s28.654-64 64-64h160c32.276 0 59.502 24.034 63.506 56.062l56.992 455.938h439.226l114.738-401.582c9.71-33.986 45.136-53.664 79.12-43.956zM256 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM640 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM788 384h-148v192h-128v-192h-148l212-228z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart-remove",
						"cart",
						"cart-checkout",
						"purchase",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59909,
					"grid": 16
				},
				{
					"id": 2068,
					"paths": [
						"M847.218 576c35.2 0 71.912-27.692 81.582-61.54l92.836-324.924c9.67-33.844-11.218-61.536-46.418-61.536h-655.218c0-70.692-57.308-128-128-128h-192v128h192v544c0 53.020 42.98 96 96 96h608c35.346 0 64-28.654 64-64s-28.654-64-64-64h-576v-64h527.218zM320 256h578.806l-54.86 192h-523.946v-192z",
						"M384 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M960 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart",
						"purchase",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59903,
					"grid": 16
				},
				{
					"id": 2069,
					"paths": [
						"M847.218 576c35.2 0 71.912-27.692 81.582-61.54l92.836-324.924c9.67-33.844-11.218-61.536-46.418-61.536h-655.218c0-70.692-57.308-128-128-128h-192v128h192v544c0 53.020 42.98 96 96 96h608c35.346 0 64-28.654 64-64s-28.654-64-64-64h-576v-64h527.218zM320 448v-8h526.234l-2.288 8h-523.946zM882.806 312l-4.572 16h-558.234v-16h562.806zM320 296v-16h571.95l-4.568 16h-567.382zM873.664 344l-4.572 16h-549.092v-16h553.664zM864.522 376l-4.572 16h-539.95v-16h544.522zM855.376 408l-4.568 16h-530.808v-16h535.376zM898.806 256l-2.288 8h-576.518v-8h578.806z",
						"M384 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M960 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart",
						"purchase",
						"ecommerce",
						"shopping",
						"dualtone"
					],
					"defaultCode": 59904,
					"grid": 16
				},
				{
					"id": 2070,
					"paths": [
						"M977.582 194.462c33.986 9.71 53.666 45.134 43.956 79.12l-128 448c-7.85 27.474-32.964 46.418-61.538 46.418h-544c-32.276 0-59.502-24.036-63.506-56.062l-56.992-455.938h-103.502c-35.346 0-64-28.654-64-64s28.654-64 64-64h160c32.276 0 59.502 24.034 63.506 56.062l56.992 455.938h439.226l114.738-401.582c9.71-33.986 45.136-53.664 79.12-43.956zM256 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM640 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart",
						"purchase",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59905,
					"grid": 16
				},
				{
					"id": 2071,
					"paths": [
						"M977.582 194.462c-33.984-9.708-69.41 9.97-79.12 43.956l-5.022 17.582h-596.942l-8.992-71.938c-4.004-32.028-31.23-56.062-63.506-56.062h-160c-35.346 0-64 28.654-64 64s28.654 64 64 64h103.502l56.992 455.938c4.004 32.026 31.23 56.062 63.506 56.062h544c28.574 0 53.688-18.944 61.538-46.418l128-448c9.71-33.986-9.97-69.41-43.956-79.12zM512 512v-64h127.996v64h-127.996zM639.996 576v64h-127.996v-64h127.996zM512 384v-64h127.996v64h-127.996zM304.498 320h143.502v64h-135.502l-8-64zM320.498 448h127.502v64h-119.502l-8-64zM336.498 576h111.502v64h-103.502l-8-64zM783.724 640h-79.728v-64h98.014l-18.286 64zM820.296 512h-116.3v-64h134.586l-18.286 64zM856.868 384h-152.872v-64h171.158l-18.286 64zM256 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM640 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart",
						"purchase",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59906,
					"grid": 16
				},
				{
					"id": 141,
					"paths": [
						"M409.6 1024c-56.464 0-102.4-45.936-102.4-102.4s45.936-102.4 102.4-102.4 102.4 45.936 102.4 102.4-45.936 102.4-102.4 102.4zM409.6 870.4c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2 51.2-22.968 51.2-51.2-22.968-51.2-51.2-51.2z",
						"M768 1024c-56.464 0-102.4-45.936-102.4-102.4s45.936-102.4 102.4-102.4 102.4 45.936 102.4 102.4-45.936 102.4-102.4 102.4zM768 870.4c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2 51.2-22.968 51.2-51.2-22.968-51.2-51.2-51.2z",
						"M898.021 228.688c-12.859-15.181-32.258-23.888-53.221-23.888h-626.846l-5.085-30.506c-6.72-40.315-43.998-71.894-84.869-71.894h-51.2c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h51.2c15.722 0 31.781 13.603 34.366 29.112l85.566 513.395c6.718 40.314 43.997 71.893 84.867 71.893h512c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-512c-15.722 0-31.781-13.603-34.366-29.11l-12.63-75.784 510.206-44.366c39.69-3.451 75.907-36.938 82.458-76.234l34.366-206.194c3.448-20.677-1.952-41.243-14.813-56.424zM862.331 276.694l-34.366 206.194c-2.699 16.186-20.043 32.221-36.39 33.645l-514.214 44.714-50.874-305.246h618.314c5.968 0 10.995 2.054 14.155 5.782 3.157 3.73 4.357 9.024 3.376 14.912z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cart",
						"shop"
					],
					"defaultCode": 59438,
					"grid": 20
				},
				{
					"id": 2086,
					"width": 1088,
					"paths": [
						"M448 448h64v64h-64v-64z",
						"M0 256v576h1088v-576h-1088zM192 768h-128v-128h64v64h64v64zM192 384h-64v64h-64v-128h128v64zM672 512c17.674 0 32 14.326 32 32v128c0 17.674-14.326 32-32 32h-96v32c0 17.674-14.326 32-32 32s-32-14.326-32-32v-32h-96c-17.672 0-32-14.326-32-32s14.328-32 32-32h96v-64h-96c-17.672 0-32-14.326-32-32v-128c0-17.672 14.328-32 32-32h96v-32c0-17.672 14.326-32 32-32s32 14.328 32 32v32h96c17.674 0 32 14.328 32 32s-14.326 32-32 32h-96v64h96zM1024 768h-128v-64h64v-64h64v128zM1024 448h-64v-64h-64v-64h128v128z",
						"M576 576h64v64h-64v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cash",
						"money",
						"dollar-bill",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59921,
					"grid": 16
				},
				{
					"id": 2087,
					"width": 1088,
					"paths": [
						"M0 256v576h1088v-576h-1088zM192 768h-128v-128h64v64h64v64zM192 384h-64v64h-64v-128h128v64zM544 768c-123.514 0-224-100.486-224-224s100.486-224 224-224 224 100.486 224 224-100.486 224-224 224zM1024 768h-128v-64h64v-64h64v128zM1024 448h-64v-64h-64v-64h128v128z",
						"M544 384c-88.224 0-160 71.776-160 160s71.776 160 160 160 160-71.776 160-160-71.774-160-160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cash",
						"money",
						"bill",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59922,
					"grid": 16
				},
				{
					"id": 2088,
					"width": 1088,
					"paths": [
						"M448 576h64v64h-64v-64z",
						"M0 384v576h1088v-576h-1088zM192 896h-128v-128h64v64h64v64zM192 512h-64v64h-64v-128h128v64zM672 640c17.674 0 32 14.326 32 32v128c0 17.674-14.326 32-32 32h-96v32c0 17.674-14.326 32-32 32s-32-14.326-32-32v-32h-96c-17.672 0-32-14.326-32-32s14.328-32 32-32h96v-64h-96c-17.672 0-32-14.326-32-32v-128c0-17.672 14.328-32 32-32h96v-32c0-17.672 14.326-32 32-32s32 14.328 32 32v32h96c17.674 0 32 14.328 32 32s-14.326 32-32 32h-96v64h96zM1024 896h-128v-64h64v-64h64v128zM1024 576h-64v-64h-64v-64h128v128z",
						"M576 704h64v64h-64v-64z",
						"M64 256h960v96h-960v-96z",
						"M128 128h832v96h-832v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cash",
						"money",
						"dollar-bill",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59923,
					"grid": 16
				},
				{
					"id": 2089,
					"width": 1088,
					"paths": [
						"M64 256h960v96h-960v-96z",
						"M128 128h832v96h-832v-96z",
						"M0 384v576h1088v-576h-1088zM192 896h-128v-128h64v64h64v64zM192 512h-64v64h-64v-128h128v64zM544 896c-123.514 0-224-100.486-224-224s100.486-224 224-224 224 100.486 224 224-100.486 224-224 224zM1024 896h-128v-64h64v-64h64v128zM1024 576h-64v-64h-64v-64h128v128z",
						"M544 512c-88.224 0-160 71.776-160 160s71.776 160 160 160 160-71.776 160-160-71.774-160-160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cash",
						"money",
						"bills",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59924,
					"grid": 16
				},
				{
					"id": 1894,
					"paths": [
						"M247.064 768l-42.666 128h614.946l-42.446-128z",
						"M992 192h-960c-17.672 0-32 14.328-32 32v640c0 17.674 14.328 32 32 32h104.936l56.706-170.12c4.356-13.066 16.586-21.88 30.358-21.88h576c13.792 0 26.034 8.836 30.374 21.928l56.396 170.072h105.23c17.674 0 32-14.326 32-32v-640c0-17.672-14.326-32-32-32zM256 640c-70.692 0-128-57.306-128-128 0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.694-57.308 128-128 128zM768 640c-70.692 0-128-57.306-128-128 0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.694-57.308 128-128 128zM864 320h-704c-17.672 0-32-14.328-32-32s14.328-32 32-32h704c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M320 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
						"M832 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cassette",
						"tape",
						"audio"
					],
					"defaultCode": 59729,
					"grid": 16
				},
				{
					"id": 977,
					"width": 1024,
					"paths": [
						"M1013.984 872.736l-360.096-340.096c0.384-0.64 0.64-1.312 1.024-1.952 30.976-52.416 49.088-113.376 49.088-178.688 0-194.4-157.6-352-352-352s-352 157.6-352 352 157.6 352 352 352c65.6 0 126.784-18.272 179.36-49.504 0.416-0.256 0.832-0.384 1.248-0.64l340.096 360.128c12.384 13.12 33.152 13.408 45.888 0.672l96-96c12.768-12.768 12.48-33.536-0.608-45.92zM540.64 569.12l-86.304-91.36 5.568-17.856 17.856-5.568 91.36 86.304c-8.832 10.144-18.336 19.648-28.48 28.48zM441.856 625.44l-15.488-57.76 17.056-54.88 72.16 75.936c-22.464 15.584-47.232 28-73.728 36.704zM194.816 110.976l34.848 61.152-25.632-8.704c-3.36-1.12-6.848-1.664-10.272-1.664-8.352 0-16.544 3.264-22.624 9.376-8.608 8.608-11.584 21.376-7.68 32.896l8.704 25.664-60.576-35.84c21.76-33.024 50.144-61.216 83.232-82.88zM262.176 78.528l30.816 115.072-17.344-5.888-53.408-92.48c12.8-6.496 26.112-12.128 39.936-16.704zM336 64.8v137.664l-5.28 3.936-1.28-0.448-36.352-135.84c13.92-2.912 28.32-4.48 42.912-5.312zM187.712 275.616l5.888 17.376-114.944-31.136c4.576-13.856 10.24-27.168 16.768-40l92.288 53.76zM70.112 293.088l135.872 36.384 0.416 1.28-3.936 5.248h-137.664c0.832-14.592 2.4-28.992 5.312-42.912zM64.8 368h113.792l-52.192 69.952c-6.176 8.288-7.616 18.848-4.64 28.512l-26.432 15.424c-17.6-34.56-28.256-73.088-30.528-113.888zM147.584 488.48c1.472 0.224 2.912 0.608 4.448 0.608 0.128 0 0.288 0 0.416 0l40.352-0.512-54.88 55.392c-9.664-10.752-18.624-22.112-26.592-34.208l36.256-21.28zM160.48 566.496l78.144-78.496 16.48-0.224-60.544 105.088c-12.064-7.904-23.36-16.8-34.080-26.368zM289.568 492.128l46.432 65.632v81.44c-40.608-2.24-78.976-12.832-113.44-30.272l67.008-116.8zM302.656 455.168l-150.592 1.92 90.080-120.704-48.384-142.624 142.656 48.384 120.704-90.080-1.92 150.592 122.976 86.976-143.84 44.704-44.704 143.84-86.976-123.008zM543.712 137.664l-55.136 55.136 0.512-40.352c0.032-1.664-0.384-3.232-0.608-4.832l21.504-36.16c11.936 7.872 23.104 16.704 33.728 26.208zM488 238.624l78.336-78.336c9.568 10.688 18.464 21.952 26.368 33.984l-104.928 60.832 0.224-16.48zM639.2 336h-81.44l-65.664-46.432 116.768-67.104c17.472 34.496 28.064 72.864 30.336 113.536zM567.712 426.368l57.824 15.328c-8.736 26.528-21.152 51.36-36.768 73.888l-75.936-72.16 54.88-17.056zM606.784 403.68c1.408-2.848 2.432-5.856 2.944-9.088 1.568-9.824-1.728-19.488-8.32-26.624h37.76c-0.8 14.56-2.368 28.896-5.28 42.816l-27.104-7.104zM481.664 95.2l-15.488 27.008c-3.008-0.896-5.984-2.176-9.088-2.176-6.784 0-13.504 2.144-19.136 6.368l-69.952 52.192v-113.792c40.704 2.272 79.168 12.896 113.664 30.4zM368 639.2v-37.6c5.888 5.408 13.568 8.544 21.6 8.544 1.664 0 3.328-0.128 5.024-0.384 3.232-0.512 6.24-1.568 9.088-2.976l7.392 27.072c-14.016 2.912-28.448 4.512-43.104 5.344zM896.672 946.080l-312.032-330.4c11.008-9.728 21.376-20.096 31.072-31.072l330.4 312.032-49.44 49.44z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cast",
						"curse"
					],
					"grid": 32
				},
				{
					"id": 355,
					"width": 1024,
					"paths": [
						"M992 320h-960c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h487.392l71.456 309.6c10.016 43.552 48.832 74.4 93.536 74.4h135.264c44.704 0 83.488-30.848 93.536-74.4l71.424-309.6h7.392c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32zM708.416 640l-8.736-96h104.576l-8.736 96h-87.104zM792.672 672l-8.736 96h-63.872l-8.736-96h81.344zM696.8 512l-8.736-96h127.84l-8.736 96h-110.368zM655.936 416l8.736 96h-90.272l-22.144-96h103.68zM581.76 544h85.792l8.736 96h-72.384l-22.144-96zM622.016 718.4l-10.72-46.4h67.904l8.736 96h-3.552c-29.984 0-55.648-20.416-62.368-49.6zM881.984 718.4c-6.72 29.184-32.384 49.6-62.368 49.6h-3.552l8.736-96h67.904l-10.72 46.4zM900.096 640h-72.384l8.736-96h85.792l-22.144 96zM929.632 512h-90.272l8.736-96h103.712l-22.176 96zM992 384h-960v-32h960v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"catch",
						"capture",
						"trap",
						"chase"
					],
					"grid": 32
				},
				{
					"id": 356,
					"width": 1024,
					"paths": [
						"M992 320h-960c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h487.392l71.456 309.6c10.016 43.552 48.832 74.4 93.536 74.4h135.264c44.704 0 83.488-30.848 93.536-74.4l71.424-309.6h7.392c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32zM913.632 544h-77.216l-8.672 96h67.84c8.832 0 16 7.168 16 16s-7.168 16-16 16h-70.72l-7.36 81.44c-0.8 8.32-7.744 14.56-15.936 14.56-0.512 0-0.96 0-1.472-0.064-8.8-0.8-15.296-8.576-14.496-17.376l7.104-78.56h-81.408l7.104 78.56c0.768 8.8-5.696 16.576-14.496 17.376-0.512 0.064-0.96 0.064-1.472 0.064-8.192 0-15.168-6.24-15.904-14.56l-7.36-81.44h-70.72c-8.832 0-16-7.168-16-16s7.168-16 16-16h67.84l-8.672-96h-77.216c-8.832 0-16-7.168-16-16s7.168-16 16-16h74.336l-7.104-78.56c-0.768-8.8 5.696-16.576 14.496-17.376 8.736-0.832 16.576 5.664 17.376 14.496l7.328 81.44h110.336l7.36-81.44c0.768-8.832 8.512-15.392 17.376-14.496 8.8 0.8 15.296 8.576 14.496 17.376l-7.104 78.56h74.336c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"catch",
						"capture",
						"trap",
						"chase"
					],
					"grid": 32
				},
				{
					"id": 2049,
					"paths": [
						"M511.29 0c-140.268 0-263.714 51.91-359.11 148.694-98.172 99.6-151.47 228.648-151.47 363.322 0 136.054 51.878 262.294 150.082 360.498 98.188 98.188 225.832 151.486 360.498 151.486s265.12-53.298 366.116-152.89c95.394-93.99 145.882-218.826 145.882-359.094 0-138.878-50.488-265.126-147.286-361.918-98.186-98.188-224.444-150.098-364.712-150.098zM512.694 92.586c115.024 0 217.422 43.484 297.388 123.44 78.542 78.56 120.622 182.356 120.622 295.99 0 115.022-40.676 216.002-119.218 293.174-82.77 81.352-189.368 124.836-298.79 124.836-110.808 0-214.628-43.484-294.578-123.432-79.948-79.962-124.852-185.172-124.852-294.578 0-110.826 44.904-216.026 124.852-297.394 78.558-79.948 179.554-122.036 294.576-122.036zM506.084 426.94c-28.906-52.746-78.262-73.73-135.536-73.73-83.372 0-149.734 58.978-149.734 158.806 0 101.518 62.386 158.792 152.574 158.792 57.844 0 107.198-31.762 134.414-79.962l-63.524-32.33c-14.184 34.034-35.736 44.226-62.954 44.226-47.066 0-68.622-39.128-68.622-90.724 0-51.626 18.146-90.756 68.622-90.756 13.616 0 40.832 7.384 56.722 41.402l68.038-35.724zM801.45 426.94c-28.922-52.746-78.258-73.73-135.532-73.73-83.376 0-149.734 58.978-149.734 158.806 0 101.518 62.386 158.792 152.574 158.792 57.84 0 107.18-31.762 134.398-79.962l-63.524-32.33c-14.168 34.034-35.722 44.226-62.958 44.226-47.050 0-68.618-39.128-68.618-90.724 0-51.626 18.16-90.756 68.618-90.756 13.618 0 40.836 7.384 56.738 41.402l68.038-35.724z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc",
						"creative-commons",
						"license"
					],
					"defaultCode": 59884,
					"grid": 16
				},
				{
					"id": 1633,
					"width": 1316.5762023925781,
					"paths": [
						"M68 389.714h50.857l-25.714-61.714zM422.857 690.286l42.286-45.143-40-45.143h-93.143v28h81.143v31.429h-81.143v30.857h90.857zM513.143 645.714l56.571 62.857v-124zM677.714 618.857q0-18.857-22.857-18.857h-48v39.429h47.429q23.429 0 23.429-20.571zM842.857 616.571q0-16.571-24-16.571h-46.857v34.857h46.286q24.571 0 24.571-18.286zM684 350.286q0-16.571-24-16.571h-46.857v34.286h46.286q24.571 0 24.571-17.714zM946.286 389.714h50.857l-25.143-61.714zM399.429 301.143v154.857h-37.714v-121.143l-53.714 121.143h-32.571l-53.714-121.143v121.143h-75.429l-14.286-34.286h-77.143l-14.286 34.286h-40l66.286-154.857h54.857l62.857 146.857v-146.857h60.571l48.571 105.143 44-105.143h61.714zM717.143 618.857q0 11.429-3.143 20t-8 14.286-12.857 9.429-14.857 5.714-18 2.571-18 0.571-18.571-0.286-16.857-0.286v52h-72l-45.714-51.429-47.429 51.429h-146.286v-154.857h148.571l45.714 50.857 46.857-50.857h118.286q62.286 0 62.286 50.857zM550.857 424v32h-124v-154.857h124v32.571h-86.857v28h84.571v31.429h-84.571v30.857h86.857zM1316.571 743.429v130.857q0 31.429-22 54t-53.429 22.571h-1165.714q-31.429 0-53.429-22.571t-22-54v-387.429h63.429l14.286-34.857h31.429l14.286 34.857h124.571v-26.286l10.857 26.286h64.571l11.429-26.857v26.857h309.143v-56.571l5.714-0.571q5.714 0 5.714 8v49.143h159.429v-13.143q13.143 6.857 31.429 10.286t30 3.714 36-0.286 29.429-0.571l14.286-34.857h32l14.286 34.857h129.714v-33.143l19.429 33.143h104v-216h-102.857v25.143l-14.286-25.143h-105.714v25.143l-13.143-25.143h-142.286q-39.429 0-62.286 12.571v-12.571h-98.286v12.571q-13.714-12.571-41.714-12.571h-358.857l-24.571 55.429-24.571-55.429h-113.143v25.143l-12.571-25.143h-96.571l-44.571 102.286v-223.429q0-31.429 22-54t53.429-22.571h1165.714q31.429 0 53.429 22.571t22 54v387.429h-68.571q-29.143 0-46.286 12.571v-12.571h-101.143q-31.429 0-44.571 12.571v-12.571h-180.571v12.571q-17.714-12.571-49.714-12.571h-119.429v12.571q-13.143-12.571-52-12.571h-133.714l-30.857 33.143-28.571-33.143h-199.429v216h196l31.429-33.714 29.714 33.714h120.571v-50.857h12q33.714 0 51.429-7.429v58.286h99.429v-56.571h4.571q4.571 0 5.714 1.143t1.143 5.714v49.714h302.286q32.571 0 50.286-13.714v13.714h96q34.286 0 54.286-9.714zM883.429 609.714q0 13.143-6.857 24.571t-19.429 16.571q14.286 5.143 19.429 14.857t5.143 26.286v30.857h-37.143v-25.714q0-18.857-6.857-24.857t-26.286-6h-39.429v56.571h-37.143v-154.857h88q27.429 0 44 8.571t16.571 33.143zM725.143 342.857q0 13.714-7.143 25.143t-19.143 16.571q14.857 5.143 19.714 14.571t4.857 26.571v30.286h-37.143q0-5.143 0.286-15.143t0-14.286-1.714-10.571-4.857-9.143-10-4.857-16.857-2h-40v56h-36.571v-154.857l87.429 0.571q28 0 44.571 8.286t16.571 32.857zM1027.429 690.857v32h-123.429v-154.857h123.429v32h-86.286v28h84.571v31.429h-84.571v30.857zM784 301.143v154.857h-37.714v-154.857h37.714zM1180 673.714q0 49.143-58.286 49.143h-72v-33.143h72q19.429 0 19.429-14.286 0-9.143-9.714-12t-23.714-2.857-28.286-2-24-12.857-9.714-31.429q0-22.286 14.857-34.286t37.714-12h74.286v32.571h-68q-20.571 0-20.571 14.286 0 9.143 10 11.714t24 2.286 28 1.429 24 12.286 10 31.143zM1316.571 645.143v57.714q-13.714 20-50.286 20h-71.429v-33.143h71.429q18.857 0 18.857-14.286 0-7.429-7.143-10.857t-17.714-3.143-22.857-1.143-22.857-4.571-17.714-13.714-7.143-27.714q0-22.286 15.143-34.286t38-12h73.714v32.571h-67.429q-20.571 0-20.571 14.286 0 11.429 16.571 12.571t39.143 2.857 32.286 14.857zM1222.286 301.714v154.286h-52.571l-69.714-116v116h-75.429l-14.857-34.286h-76.571l-14.286 34.286h-42.857q-73.714 0-73.714-76 0-78.857 76-78.857h36v33.714q-4 0-16-0.571t-16.286-0.286-13.143 1.143-12.286 3.714-8.286 7.714-6.571 13.143-1.714 19.143q0 21.714 7.714 33.143t28.286 11.429h16.571l52.571-121.714h55.429l62.286 146.286v-146.286h56.571l65.143 107.429v-107.429h37.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc-amex"
					],
					"defaultCode": 61939,
					"grid": 14
				},
				{
					"id": 1715,
					"width": 1316.5701522827148,
					"paths": [
						"M490.286 709.143v-396q-60.571 23.429-98.286 77.429t-37.714 120.857 37.714 120.857 98.286 76.857zM778.286 511.429q0-66.857-37.714-120.857t-98.286-77.429v396.571q60.571-23.429 98.286-77.429t37.714-120.857zM901.143 511.429q0 90.857-44.857 168t-122 122-168 44.857q-68 0-130-26.571t-106.857-71.429-71.429-106.857-26.571-130q0-90.857 44.857-168t122-122 168-44.857 168 44.857 122 122 44.857 168zM1120 515.429q0-79.429-31.714-149.429t-84.286-117.429-122-74.857-144.286-27.429h-172q-100.571 0-184.857 46.286t-134.286 131.429-50 191.429q0 97.714 49.714 181.429t134.857 132.286 184.571 48.571h172q73.714 0 143.714-28.857t122.571-77.143 84.286-115.714 31.714-140.571zM1316.571 146.286v731.429q0 29.714-21.714 51.429t-51.429 21.714h-1170.286q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h1170.286q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc-diners-club"
					],
					"defaultCode": 62028,
					"grid": 14
				},
				{
					"id": 1632,
					"width": 1316.5700988769531,
					"paths": [
						"M178.857 444q0 29.143-20.571 48-16.571 14.857-50.857 14.857h-9.714v-125.714h9.714q34.857 0 50.857 15.429 20.571 17.714 20.571 47.429zM1193.714 406.857q0 29.714-36.571 29.714h-10.857v-57.714h11.429q36 0 36 28zM217.143 444q0-42.286-28.571-68.857t-73.714-26.571h-54.286v190.286h54.286q42.286 0 68-21.714 34.286-29.143 34.286-73.143zM234.286 538.857h37.143v-190.286h-37.143v190.286zM417.143 481.143q0-22.857-11.714-35.429t-43.143-24q-16.571-5.714-22.571-10.857t-6-13.143q0-9.143 7.714-15.143t19.714-6q16.571 0 30.286 15.429l19.429-25.143q-23.429-21.143-56-21.143-25.143 0-42.286 15.714t-17.143 38.571q0 20 10.286 31.714t36.571 20.857q21.143 7.429 25.714 10.857 10.857 6.857 10.857 19.429 0 11.429-8 19.143t-20.571 7.714q-27.429 0-40.571-25.143l-24 22.857q25.143 36.571 65.714 36.571 29.143 0 47.429-17.429t18.286-45.429zM576 532.571v-44q-21.143 21.143-44.571 21.143-28 0-46-18.571t-18-47.143q0-27.429 18-46.571t44.286-19.143q24.571 0 46.286 21.714v-44q-22.857-11.429-45.714-11.429-42.286 0-71.714 28.857t-29.429 70.571 29.143 70.571 71.429 28.857q24 0 46.286-10.857zM1280 877.714v-301.143q-37.143 22.857-82.571 48t-135.714 66.857-188.286 78.571-238.571 76.857-288 67.429h896.571q14.857 0 25.714-10.857t10.857-25.714zM793.714 445.143q0-42.857-30.286-73.143t-73.143-30.286-73.143 30.286-30.286 73.143 30.286 73.143 73.143 30.286 73.143-30.286 30.286-73.143zM880.571 544l82.286-195.429h-40.571l-51.429 128-50.857-128h-40.571l81.143 195.429h20zM979.429 538.857h105.143v-32h-68v-51.429h65.714v-32h-65.714v-42.286h68v-32.571h-105.143v190.286zM1202.857 538.857h45.714l-60-80q43.429-9.143 43.429-53.714 0-26.857-17.714-41.714t-49.714-14.857h-55.429v190.286h37.143v-76h5.143zM1316.571 149.714v724.571q0 32-22 54.286t-53.429 22.286h-1165.714q-31.429 0-53.429-22.286t-22-54.286v-724.571q0-32 22-54.286t53.429-22.286h1165.714q31.429 0 53.429 22.286t22 54.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc-discover"
					],
					"defaultCode": 61938,
					"grid": 14
				},
				{
					"id": 1714,
					"width": 1316.5701522827148,
					"paths": [
						"M1114.857 570.286q0 14.857-8.857 25.429t-22 13.429q-4.571 1.143-10.286 1.143h-87.429v-80h87.429q5.714 0 10.286 1.143 13.143 2.857 22 13.429t8.857 25.429zM1104.571 448.571q0 14.286-8.571 24t-21.714 12q-1.714 0.571-8.571 0.571h-79.429v-73.714h79.429q1.714 0 4.857 0.286t3.714 0.286q13.143 2.286 21.714 12.286t8.571 24.286zM416 542.286v-176h-130.286v176q0 33.143-21.714 54t-60 20.857q-61.714 0-130.857-33.714v64q30.286 8.571 69.143 13.143t62.286 5.143l24 0.571q187.429 0 187.429-124zM824 647.429v-64.571q-56.571 29.714-114.286 33.714-61.714 4.571-96.571-23.429t-34.857-81.143 34.857-81.143 96.571-23.429q57.714 4 114.286 33.143v-64q-27.429-6.857-57.143-11.143t-45.714-5.429l-16-1.143q-72.571-3.429-124.857 8t-80.286 34.286-40.571 50.286-12.571 60.571 12.571 60.571 40.571 50.286 80.286 34.286 124.857 8q57.714-2.286 118.857-17.714zM1243.429 581.714q0-30.857-24.571-50.571t-62.286-22.571v-1.714q32.571-4.571 50.857-23.714t18.286-45.429q0-31.429-23.429-50.286t-61.143-20.571q-1.714 0-6.857-0.286t-8-0.286h-260v291.429h280.571q42.286 0 69.429-20.857t27.143-55.143zM1316.571 146.286v731.429q0 29.714-21.714 51.429t-51.429 21.714h-1170.286q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h1170.286q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc-jcb"
					],
					"defaultCode": 62027,
					"grid": 14
				},
				{
					"id": 1631,
					"width": 1316.5701522827148,
					"paths": [
						"M383.429 533.143h-7.429q-26.857 0-26.857 18.286 0 12.571 11.429 12.571 9.714 0 16-8.571t6.857-22.286zM609.143 512.571h35.429v-1.714q0.571-2.286 0.286-3.714t-0.571-4-1.143-4.571-2.571-3.714-4.286-2.857-6.571-1.143q-16 0-20.571 21.714zM917.714 533.143h-6.857q-27.429 0-27.429 18.286 0 12.571 11.429 12.571 9.714 0 16-8.571t6.857-22.286zM1100 518.286q0-23.429-17.143-23.429-10.857 0-17.714 11.429t-6.857 29.143q0 24 16 24 11.429 0 18.571-11.429t7.143-29.714zM274.286 437.714h49.714l-25.143 149.714h-32l18.286-114.857-40.571 114.857h-22.286l-2.286-114.286-19.429 114.286h-30.286l25.143-149.714h46.286l1.143 93.143zM418.857 498.857q0 3.429-2.286 24-9.143 57.714-9.714 64.571h-26.857l0.571-12.571q-11.429 14.857-33.143 14.857-13.143 0-21.429-9.143t-8.286-24q0-22.286 14.857-34.571t41.714-12.286q8 0 13.143 0.571 0-1.714 0.286-3.143t0.571-2.571 0.286-1.714q0-11.429-20.571-11.429-16.571 0-33.714 5.714 0-2.286 4-27.429 21.714-6.286 38.286-6.286 42.286 0 42.286 35.429zM508 465.714l-4.571 28q-12.571-1.714-23.429-1.714-15.429 0-15.429 9.714 0 4.571 2.571 6.857t12.286 6.286q22.857 10.857 22.857 34.286 0 41.143-49.714 40.571-19.429 0-33.143-3.429 0-1.143 4-28 16.571 4.571 29.143 4.571 18.286 0 18.286-10.857 0-4-2.571-6.571t-12.286-7.143q-24.571-11.429-24.571-33.714 0-41.143 48-41.143 17.143 0 28.571 2.286zM558.286 465.714h16l-4 29.714h-16.571q-1.143 9.714-3.714 23.143t-4 22-1.429 10.286q0 9.143 10.857 9.143 4.571 0 9.143-1.143l-4.571 26.857q-12 4-22.857 4-24.571 0-25.714-26.857 0-6.857 4.571-32 1.714-11.429 14.286-83.429h31.429zM674.286 507.429q0 13.143-4 29.714h-63.429q-1.714 12.571 5.714 18.857t21.714 6.286q17.143 0 33.143-8l-5.143 30.857q-17.143 4.571-32.571 4.571-54.286 0-54.286-54.286 0-31.429 15.714-51.714t39.714-20.286q20 0 31.714 12t11.714 32zM753.714 465.143q-7.429 13.143-12.571 35.429-12.571-1.143-17.714 13.714t-14.286 73.143h-32l1.714-8q12.571-74.286 16.571-113.714h29.143l-1.714 18.857q8-12 14.571-16.857t16.286-2.571zM860.571 441.714l-5.143 32.571q-16-8-28.571-8-17.714 0-29.143 15.714t-11.429 40.286q0 17.143 7.714 26.857t22 9.714q12 0 27.429-7.429l-5.714 33.714q-16 4.571-28.571 4.571-25.714 0-40.857-17.429t-15.143-47.143q0-40 20.286-65.429t52.286-25.429q14.857 0 34.857 7.429zM953.143 498.857q0 10.286-2.286 24-7.429 45.143-9.714 64.571h-26.286l0.571-12.571q-11.429 14.857-33.714 14.857-13.143 0-21.143-9.143t-8-24q0-22.286 14.571-34.571t41.429-12.286q8.571 0 13.143 0.571 1.143-4 1.143-7.429 0-11.429-20.571-11.429-16.571 0-33.714 5.714 0-2.286 4.571-27.429 21.714-6.286 38.286-6.286 41.714 0 41.714 35.429zM1033.714 465.143q-8 13.714-12 35.429-13.143-1.143-18 13.143t-14.571 73.714h-32l1.714-8q10.857-59.429 16.571-113.714h29.714q0 6.286-2.286 18.857 8.571-12 15.143-16.857t15.714-2.571zM1114.286 437.714h32l-24.571 149.714h-30.286l1.714-10.857q-13.143 13.143-29.714 13.143-17.714 0-28.286-13.714t-10.571-36.571q0-30.286 15.714-52.571t36.857-22.286q17.714 0 30.286 16.571zM1177.714 512q0-84.571-41.429-156t-113.143-113.143-156.286-41.714q-103.429 0-187.429 62.857 72.571 66.286 97.714 162.286h-28.571q-25.143-85.714-90.286-144.571-65.143 58.857-90.286 144.571h-28.571q25.143-96 97.714-162.286-84-62.857-187.429-62.857-84.571 0-156.286 41.714t-113.143 113.143-41.429 156 41.429 156 113.143 113.143 156.286 41.714q103.429 0 187.429-62.857-68.571-63.429-94.286-150.857h28.571q26.286 78.857 86.857 133.143 60.571-54.286 86.857-133.143h28.571q-25.714 87.429-94.286 150.857 84 62.857 187.429 62.857 84.571 0 156.286-41.714t113.143-113.143 41.429-156zM1316.571 146.286v731.429q0 29.714-21.714 51.429t-51.429 21.714h-1170.286q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h1170.286q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc-mastercard"
					],
					"defaultCode": 61937,
					"grid": 14
				},
				{
					"id": 1634,
					"width": 1316.5701522827148,
					"paths": [
						"M425.714 517.714q0 21.143-14.571 35.143t-35.714 14q-16.571 0-26.571-9.143t-10-25.143q0-21.143 14.286-35.714t35.429-14.571q16 0 26.571 9.429t10.571 26zM874.286 432.571q0 24-12.571 32.571t-37.714 8.571l-18.286 0.571 9.714-61.143q1.143-6.286 7.429-6.286h10.286q12.571 0 20 1.143t14.286 7.143 6.857 17.429zM1074.857 517.714q0 20.571-14.571 34.857t-35.143 14.286q-16.571 0-26.857-9.143t-10.286-25.143q0-21.143 14.286-35.714t35.429-14.571q16 0 26.571 9.429t10.571 26zM293.143 420q0-33.714-22-48.857t-57.429-15.143h-91.429q-10.857 0-12 10.857l-37.143 233.143q-0.571 3.429 1.714 6.286t5.714 2.857h43.429q11.429 0 12.571-10.857l10.286-62.857q0.571-4.571 4-7.429t8.571-3.714 9.714-0.857 10.857 0.571 8 0.571q49.143 0 77.143-27.714t28-76.857zM469.714 598.286l23.429-149.143q0.571-3.429-1.714-6.286t-5.714-2.857h-43.429q-8 0-9.714 18.857-15.429-22.857-54.286-22.857-41.143 0-70 30.857t-28.857 72.571q0 33.714 19.714 53.714t52.857 20q16 0 33.143-6.857t27.429-18.286q-2.286 6.857-2.286 12 0 9.143 7.429 9.143h39.429q10.857 0 12.571-10.857zM725.143 448q0-2.857-2.286-5.429t-5.143-2.571h-44q-6.286 0-10.286 5.714l-60.571 89.143-25.143-85.714q-2.857-9.143-12.571-9.143h-42.857q-2.857 0-5.143 2.571t-2.286 5.429q0 1.143 11.143 33.714t24 70.286 13.429 40q-46.857 64-46.857 68.571 0 7.429 7.429 7.429h44q6.286 0 10.286-5.714l145.714-210.286q1.143-1.143 1.143-4zM942.286 420q0-33.714-22-48.857t-57.429-15.143h-90.857q-11.429 0-12.571 10.857l-37.143 233.143q-0.571 3.429 1.714 6.286t5.714 2.857h46.857q6.857 0 9.143-7.429l10.286-66.286q0.571-4.571 4-7.429t8.571-3.714 9.714-0.857 10.857 0.571 8 0.571q49.143 0 77.143-27.714t28-76.857zM1118.857 598.286l23.429-149.143q0.571-3.429-1.714-6.286t-5.714-2.857h-43.429q-8 0-9.714 18.857-14.857-22.857-54.286-22.857-41.143 0-70 30.857t-28.857 72.571q0 33.714 19.714 53.714t52.857 20q16.571 0 33.714-6.857t26.857-18.286q0 0.571-1.143 5.143t-1.143 6.857q0 9.143 7.429 9.143h39.429q10.857 0 12.571-10.857zM1243.429 364.571v-0.571q0-8-7.429-8h-42.286q-6.286 0-7.429 6.286l-37.143 237.714-0.571 1.143q0 2.857 2.286 5.429t5.714 2.571h37.714q10.857 0 12-10.857zM224 441.143q-2.857 20-14.857 26.286t-34.286 6.286l-18.857 0.571 9.714-61.143q1.143-6.286 7.429-6.286h10.857q22.857 0 33.143 6.571t6.857 27.714zM1316.571 146.286v731.429q0 29.714-21.714 51.429t-51.429 21.714h-1170.286q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h1170.286q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc-paypal"
					],
					"defaultCode": 61940,
					"grid": 14
				},
				{
					"id": 1635,
					"width": 1316.5701522827148,
					"paths": [
						"M912.571 516q0 39.429-12 60.571-10.857 20-29.714 20-13.143 0-23.429-5.143v-128q16.571-17.143 32.571-17.143 32.571 0 32.571 69.714zM1162.857 495.429h-62.857q3.429-56 32-56 29.143 0 30.857 56zM272 572.571q0-33.714-18.857-52.286t-57.714-32.857q-20.571-7.429-29.714-13.714t-9.143-14.286q0-14.857 21.714-14.857 33.143 0 70.857 18.857l10.286-64q-38.286-18.286-85.143-18.286-44 0-70.286 21.714-27.429 22.286-27.429 62.286 0 33.143 18.571 51.714t56.857 32.286q22.286 8 31.143 14.571t8.857 15.714q0 17.714-27.429 17.714-16.571 0-40-7.143t-41.143-17.429l-10.286 64.571q41.143 23.429 96 23.429 46.286 0 73.714-21.143 29.143-23.429 29.143-66.857zM440.571 449.714l10.857-63.429h-54.857v-77.143l-73.714 12-10.286 65.143-26.286 4.571-9.714 58.857h35.429v125.143q0 48 25.143 68.571 21.714 17.143 63.429 17.143 18.286 0 45.143-6.286v-67.429q-18.286 4-25.143 4-24 0-24-28.571v-112.571h44zM621.143 464v-79.429q-8.571-1.714-16-1.714-18.286 0-31.714 9.143t-19.143 26.286l-5.714-32h-74.857v269.143h85.714v-174.857q14.857-17.714 46.857-17.714 9.143 0 14.857 1.143zM642.286 655.429h85.714v-269.143h-85.714v269.143zM997.714 513.143q0-69.714-25.714-102.286-22.857-29.714-63.429-29.714-36.571 0-66.857 32l-4.571-26.857h-75.429v368.571l85.714-14.286v-86.286q20.571 6.286 38.857 6.286 47.429 0 76.571-32 34.857-37.143 34.857-115.429zM730.286 314.286q0-18.857-13.143-32t-32-13.143-32 13.143-13.143 32 13.143 32.286 32 13.429 32-13.429 13.143-32.286zM1243.429 518.286q0-64.571-27.429-100.571-28.571-36.571-82.286-36.571-54.857 0-86.571 37.714t-31.714 102.857q0 73.143 36 107.429 31.429 31.429 92 31.429 57.714 0 91.429-22.857l-9.143-58.857q-32.571 17.714-73.143 17.714-24.571 0-36-10.857-13.143-10.857-16-37.714h141.714q1.143-8 1.143-29.714zM1316.571 146.286v731.429q0 29.714-21.714 51.429t-51.429 21.714h-1170.286q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h1170.286q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc-stripe"
					],
					"defaultCode": 61941,
					"grid": 14
				},
				{
					"id": 1630,
					"width": 1316.5701522827148,
					"paths": [
						"M1128.571 565.714h-78.857q8-21.143 37.714-102.286l1.714-5.143q2.286-5.714 5.714-14.857t5.143-14.857l6.857 31.429zM303.429 528.571l-33.143-168.571q-6.286-30.857-42.857-30.857h-153.143l-1.143 7.429q177.714 45.143 230.286 192zM405.714 329.143l-92.571 250.286-9.714-50.857q-14.857-40-48.571-74t-74.857-50.571l77.143 291.429h100l149.143-366.286h-100.571zM485.143 696h94.857l59.429-366.857h-94.857zM924 338.286q-39.429-15.429-85.143-15.429-70.286 0-114.857 33.714t-45.143 87.429q-0.571 58.286 82.857 99.429 27.429 13.143 38.286 23.429t10.857 22.286q0 17.143-17.143 26.286t-39.429 9.143q-49.143 0-89.143-18.857l-12.571-6.286-13.143 82.286q42.286 19.429 105.714 19.429 74.286 0.571 119.143-33.714t46-91.429q0-60.571-80-99.429-28-14.286-40.571-24t-12.571-21.714q0-12.571 14-22t40.286-9.429q40-0.571 70.857 13.714l8.571 4.571zM1166.857 329.143h-73.143q-37.143 0-49.714 30.857l-140.571 336h99.429l20-54.857h121.143q2.857 12.571 11.429 54.857h88zM1316.571 146.286v731.429q0 29.714-21.714 51.429t-51.429 21.714h-1170.286q-29.714 0-51.429-21.714t-21.714-51.429v-731.429q0-29.714 21.714-51.429t51.429-21.714h1170.286q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc-visa"
					],
					"defaultCode": 61936,
					"grid": 14
				},
				{
					"id": 1655,
					"width": 1170.2860107421875,
					"paths": [
						"M448.571 576h118.286q-8 90.286-56.286 142t-122.571 51.714q-92.571 0-145.429-66.286t-52.857-180.571q0-110.857 53.143-178t133.143-67.143q84.571 0 132.571 49.714t55.429 141.143h-116q-2.857-36.571-20.286-56.571t-46.571-20q-32.571 0-50.571 34.571t-18 101.429q0 27.429 2.857 48t10.286 39.714 22.857 29.429 37.714 10.286q54.286 0 62.286-79.429zM855.429 576h117.714q-8 90.286-56 142t-122.286 51.714q-92.571 0-145.429-66.286t-52.857-180.571q0-110.857 53.143-178t133.143-67.143q84.571 0 132.571 49.714t55.429 141.143h-116.571q-2.286-36.571-20-56.571t-46.286-20q-32.571 0-50.571 34.571t-18 101.429q0 27.429 2.857 48t10.286 39.714 22.571 29.429 37.429 10.286q28 0 43.714-21.714t19.143-57.714zM1060.571 508q0-118.286-8.857-175.429t-34.571-92q-3.429-4.571-7.714-8t-12.286-8.571-9.143-6.286q-49.143-36-398.286-36-357.143 0-405.714 36-2.857 2.286-10 6.571t-12 8-8.286 8.286q-25.714 34.286-34.286 91.143t-8.571 176.286q0 118.857 8.571 175.714t34.286 91.714q3.429 4.571 8.571 8.571t11.714 8 10 6.857q25.143 18.857 136.857 28t268.857 9.143q348.571 0 398.286-37.143 2.857-2.286 9.714-6.286t11.714-8 7.714-9.143q26.286-34.286 34.857-90.857t8.571-176.571zM1170.286 73.143v877.714h-1170.286v-877.714h1170.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cc"
					],
					"defaultCode": 61962,
					"grid": 14
				},
				{
					"id": 357,
					"width": 1024,
					"paths": [
						"M896 304c0-190.336-89.728-304-240-304-99.648 0-172.064 50.592-209.952 139.776-23.744-7.776-49.824-11.776-78.048-11.776-150.272 0-240 113.664-240 304 0 139.616 94.368 239.872 193.056 265.568l-13.792 20.672c-6.56 9.856-7.168 22.432-1.568 32.832 5.568 10.464 16.384 16.928 28.192 16.928h16.16c-3.968 16.864-14.048 27.392-26.368 39.648-16.704 16.736-35.68 35.68-35.68 72.352 0 36.864 19.168 56.448 36.064 73.696 15.616 15.936 27.936 28.48 27.936 54.304 0 8.832 7.168 16 16 16s16-7.168 16-16c0-38.88-20.576-59.84-37.088-76.704-15.040-15.36-26.912-27.488-26.912-51.296 0-23.392 11.616-35.008 26.304-49.696 14.432-14.4 31.776-31.936 36.416-62.304h19.392c11.808 0 22.624-6.464 28.192-16.896 5.568-10.4 4.992-23.008-1.568-32.832l-13.792-20.672c65.248-16.992 128.448-66.72 163.872-138.72 9.984 4.256 20.064 8.064 30.24 10.72l-13.792 20.672c-6.56 9.856-7.168 22.432-1.568 32.832 5.568 10.432 16.384 16.896 28.192 16.896h19.392c4.64 30.368 21.984 47.904 36.416 62.304 14.688 14.688 26.304 26.304 26.304 49.696 0 23.808-11.872 35.936-26.912 51.296-16.512 16.864-37.088 37.824-37.088 76.704 0 8.832 7.168 16 16 16s16-7.168 16-16c0-25.824 12.32-38.368 27.936-54.304 16.896-17.248 36.064-36.832 36.064-73.696 0-36.672-18.976-55.616-35.68-72.352-12.32-12.288-22.4-22.784-26.368-39.648h16.16c11.808 0 22.624-6.464 28.192-16.896 5.568-10.4 4.992-23.008-1.568-32.832l-13.792-20.672c98.688-25.728 193.056-125.984 193.056-265.6zM333.888 736l34.112-51.2 34.112 51.2h-68.224zM386.24 670.624l-18.24 2.432-18.24-2.432c-78.784-10.432-189.76-91.392-189.76-238.624 0-81.792 20.256-272 208-272s208 190.208 208 272c0 147.232-110.976 228.192-189.76 238.624zM621.888 608l34.112-51.2 34.112 51.2h-68.224zM674.24 542.624l-18.24 2.432-18.24-2.432c-14.528-1.92-30.24-7.072-46.080-13.792 10.4-29.44 16.32-61.92 16.32-96.832 0-139.104-48.096-237.024-132.576-279.776 26.784-64.192 78.816-120.224 180.576-120.224 187.744 0 208 190.208 208 272 0 147.232-110.976 228.192-189.76 238.624zM288 224c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM288 320c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"celebrate",
						"float",
						"party"
					],
					"grid": 32
				},
				{
					"id": 358,
					"width": 1024,
					"paths": [
						"M346.912 931.296c16.512 16.864 37.088 37.824 37.088 76.704 0 8.832-7.168 16-16 16s-16-7.168-16-16c0-25.824-12.32-38.368-27.936-54.304-16.896-17.248-36.064-36.832-36.064-73.696 0-36.672 18.976-55.616 35.68-72.352 2.624-2.624 5.056-5.12 7.456-7.648h39.808c-7.264 12.256-16.32 21.984-24.64 30.304-14.688 14.688-26.304 26.304-26.304 49.696 0 23.808 11.872 35.936 26.912 51.296zM288 256c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM692.864 672h-39.808c7.264 12.256 16.32 21.984 24.64 30.304 14.688 14.688 26.304 26.304 26.304 49.696 0 23.808-11.872 35.936-26.912 51.296-16.512 16.864-37.088 37.824-37.088 76.704 0 8.832 7.168 16 16 16s16-7.168 16-16c0-25.824 12.32-38.368 27.936-54.304 16.896-17.248 36.064-36.832 36.064-73.696 0-36.672-18.976-55.616-35.68-72.352-2.624-2.592-5.088-5.12-7.456-7.648zM656 0c-88.416 0-155.296 40.032-195.712 111.328 112.736 39.488 179.712 154.752 179.712 320.672 0 51.232-11.552 98.016-30.944 137.568l-13.792 20.672c-6.56 9.856-7.168 22.432-1.568 32.832 5.568 10.464 16.384 16.928 28.192 16.928h68.224c11.808 0 22.624-6.464 28.192-16.896 5.568-10.4 4.992-23.008-1.568-32.832l-13.792-20.672c98.688-25.728 193.056-125.984 193.056-265.6 0-190.336-89.728-304-240-304zM608 432c0 45.984-11.648 91.328-29.184 126.848-35.456 72-98.624 121.728-163.872 138.72l13.792 20.672c6.56 9.856 7.168 22.432 1.568 32.832-5.568 10.464-16.384 16.928-28.192 16.928h-68.224c-11.808 0-22.624-6.464-28.192-16.896-5.568-10.4-4.992-23.008 1.568-32.832l13.792-20.672c-98.688-25.728-193.056-125.984-193.056-265.6 0-190.336 89.728-304 240-304 26.656 0 51.2 3.872 73.888 10.784 115.136 34.688 166.112 152.544 166.112 293.216zM352 288c0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64c35.36 0 64-28.64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"celebrate",
						"float",
						"party"
					],
					"grid": 32
				},
				{
					"id": 978,
					"width": 1024,
					"paths": [
						"M832.96 832h-27.616l-244.128-585.856c46.24-19.296 78.784-64.896 78.784-118.144 0-70.688-57.312-128-128-128s-128 57.312-128 128c0 53.248 32.544 98.848 78.784 118.144l-244.128 585.856h-27.616c-52.48 0-95.040 42.56-95.040 95.040v1.92c0 52.48 42.56 95.040 95.040 95.040h641.92c52.48 0 95.040-42.56 95.040-95.040v-1.92c0-52.48-42.56-95.040-95.040-95.040zM512 64c35.296 0 64 28.704 64 64s-28.704 64-64 64c-35.296 0-64-28.704-64-64s28.704-64 64-64zM531.2 340.512l-48.544 24.256 29.344-70.368 19.2 46.112zM463.84 409.952l79.712-39.84 9.728 23.36-104.288 52.128 14.848-35.648zM430.176 490.816l135.456-67.712 20.768 49.824-187.904 93.952 31.68-76.064zM379.648 612.064l219.072-109.536 9.728 23.36-243.648 121.824 14.848-35.648zM345.952 692.928l274.848-137.408 20.768 49.824-327.296 163.648 31.68-76.064zM663.616 658.304l-383.040 191.52 14.848-35.648 358.464-179.232 9.728 23.36zM675.968 687.904l20.768 49.824-252.512 126.272h-120.448l352.192-176.096zM709.056 767.36l9.728 23.36-146.56 73.28h-56.448l193.28-96.64zM731.136 820.32l18.208 43.68h-105.568l87.36-43.68zM864 928.96c0 17.12-13.92 31.040-31.040 31.040h-641.92c-17.12 0-31.040-13.92-31.040-31.040v-1.92c0-17.12 13.92-31.040 31.040-31.040h641.92c17.12 0 31.040 13.92 31.040 31.040v1.92z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"celebrate",
						"party"
					],
					"grid": 32
				},
				{
					"id": 2048,
					"paths": [
						"M64 0v1024h896v-1024h-896zM896 960h-768v-896h768v896zM192 192h320v64h-320v-64zM192 320h320v64h-320v-64zM192 448h320v64h-320v-64zM192 575.36h320v64h-320v-64zM192 704h320v64h-320v-64zM192 832h640v64h-640v-64zM832 218.508l-37.49 37.492 37.49 37.492v26.508h-64v64h-26.51l-37.49-37.49-37.49 37.49h-26.51v-64h-64v-26.508l37.49-37.492-37.49-37.492v-26.508h64v-64h26.51l37.49 37.49 37.49-37.49h26.51v64h64v26.508z",
						"M768 448v288l-64-64-64 64v-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"certificate",
						"license",
						"degree"
					],
					"defaultCode": 59883,
					"grid": 16
				},
				{
					"id": 1332,
					"width": 877.713939666748,
					"paths": [
						"M786.286 512l78.857 77.143q17.143 16 11.429 40-6.857 23.429-29.714 29.143l-107.429 27.429 30.286 106.286q6.857 23.429-10.857 40-16.571 17.714-40 10.857l-106.286-30.286-27.429 107.429q-5.714 22.857-29.143 29.714-6.857 1.143-10.857 1.143-17.714 0-29.143-12.571l-77.143-78.857-77.143 78.857q-16 17.143-40 11.429-23.429-6.286-29.143-29.714l-27.429-107.429-106.286 30.286q-23.429 6.857-40-10.857-17.714-16.571-10.857-40l30.286-106.286-107.429-27.429q-22.857-5.714-29.714-29.143-5.714-24 11.429-40l78.857-77.143-78.857-77.143q-17.143-16-11.429-40 6.857-23.429 29.714-29.143l107.429-27.429-30.286-106.286q-6.857-23.429 10.857-40 16.571-17.714 40-10.857l106.286 30.286 27.429-107.429q5.714-23.429 29.143-29.143 23.429-6.857 40 10.857l77.143 79.429 77.143-79.429q16.571-17.143 40-10.857 23.429 5.714 29.143 29.143l27.429 107.429 106.286-30.286q23.429-6.857 40 10.857 17.714 16.571 10.857 40l-30.286 106.286 107.429 27.429q22.857 5.714 29.714 29.143 5.714 24-11.429 40z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"certificate"
					],
					"defaultCode": 61603,
					"grid": 14
				},
				{
					"id": 1348,
					"width": 950.8579864501953,
					"paths": [
						"M832 694.857q0-22.857-16-38.857l-118.857-118.857q-16-16-38.857-16-24 0-41.143 18.286 1.714 1.714 10.857 10.571t12.286 12.286 8.571 10.857 7.429 14.571 2 15.714q0 22.857-16 38.857t-38.857 16q-8.571 0-15.714-2t-14.571-7.429-10.857-8.571-12.286-12.286-10.571-10.857q-18.857 17.714-18.857 41.714 0 22.857 16 38.857l117.714 118.286q15.429 15.429 38.857 15.429 22.857 0 38.857-14.857l84-83.429q16-16 16-38.286zM430.286 292q0-22.857-16-38.857l-117.714-118.286q-16-16-38.857-16-22.286 0-38.857 15.429l-84 83.429q-16 16-16 38.286 0 22.857 16 38.857l118.857 118.857q15.429 15.429 38.857 15.429 24 0 41.143-17.714-1.714-1.714-10.857-10.571t-12.286-12.286-8.571-10.857-7.429-14.571-2-15.714q0-22.857 16-38.857t38.857-16q8.571 0 15.714 2t14.571 7.429 10.857 8.571 12.286 12.286 10.571 10.857q18.857-17.714 18.857-41.714zM941.714 694.857q0 68.571-48.571 116l-84 83.429q-47.429 47.429-116 47.429-69.143 0-116.571-48.571l-117.714-118.286q-47.429-47.429-47.429-116 0-70.286 50.286-119.429l-50.286-50.286q-49.143 50.286-118.857 50.286-68.571 0-116.571-48l-118.857-118.857q-48-48-48-116.571t48.571-116l84-83.429q47.429-47.429 116-47.429 69.143 0 116.571 48.571l117.714 118.286q47.429 47.429 47.429 116 0 70.286-50.286 119.429l50.286 50.286q49.143-50.286 118.857-50.286 68.571 0 116.571 48l118.857 118.857q48 48 48 116.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chain",
						"link"
					],
					"defaultCode": 61633,
					"grid": 14
				},
				{
					"id": 1442,
					"width": 950.8569850921631,
					"paths": [
						"M250.857 726.286l-146.286 146.286q-5.714 5.143-13.143 5.143-6.857 0-13.143-5.143-5.143-5.714-5.143-13.143t5.143-13.143l146.286-146.286q5.714-5.143 13.143-5.143t13.143 5.143q5.143 5.714 5.143 13.143t-5.143 13.143zM347.429 749.714v182.857q0 8-5.143 13.143t-13.143 5.143-13.143-5.143-5.143-13.143v-182.857q0-8 5.143-13.143t13.143-5.143 13.143 5.143 5.143 13.143zM219.429 621.714q0 8-5.143 13.143t-13.143 5.143h-182.857q-8 0-13.143-5.143t-5.143-13.143 5.143-13.143 13.143-5.143h182.857q8 0 13.143 5.143t5.143 13.143zM941.714 694.857q0 68.571-48.571 116l-84 83.429q-47.429 47.429-116 47.429-69.143 0-116.571-48.571l-190.857-191.429q-12-12-24-32l136.571-10.286 156 156.571q15.429 15.429 38.857 15.714t38.857-15.143l84-83.429q16-16 16-38.286 0-22.857-16-38.857l-156.571-157.143 10.286-136.571q20 12 32 24l192 192q48 49.143 48 116.571zM589.143 281.143l-136.571 10.286-156-156.571q-16-16-38.857-16-22.286 0-38.857 15.429l-84 83.429q-16 16-16 38.286 0 22.857 16 38.857l156.571 156.571-10.286 137.143q-20-12-32-24l-192-192q-48-49.143-48-116.571 0-68.571 48.571-116l84-83.429q47.429-47.429 116-47.429 69.143 0 116.571 48.571l190.857 191.429q12 12 24 32zM950.857 329.143q0 8-5.143 13.143t-13.143 5.143h-182.857q-8 0-13.143-5.143t-5.143-13.143 5.143-13.143 13.143-5.143h182.857q8 0 13.143 5.143t5.143 13.143zM640 18.286v182.857q0 8-5.143 13.143t-13.143 5.143-13.143-5.143-5.143-13.143v-182.857q0-8 5.143-13.143t13.143-5.143 13.143 5.143 5.143 13.143zM872.571 104.571l-146.286 146.286q-6.286 5.143-13.143 5.143t-13.143-5.143q-5.143-5.714-5.143-13.143t5.143-13.143l146.286-146.286q5.714-5.143 13.143-5.143t13.143 5.143q5.143 5.714 5.143 13.143t-5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chain-broken",
						"unlink"
					],
					"defaultCode": 61735,
					"grid": 14
				},
				{
					"id": 2804,
					"paths": [
						"M896 576h-128v-448c0-35.346-28.654-64-64-64s-64 28.654-64 64v64h-320v-64c0-35.346-28.654-64-64-64s-64 28.654-64 64v448h-128v128h64v320h128v-128h448v128h128v-320h64v-128zM320 384h320v64h-320v-64zM640 256v64h-320v-64h320zM320 512h320v64h-320v-64zM704 832h-448v-128h448v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chair"
					],
					"defaultCode": 60639,
					"grid": 16
				},
				{
					"id": 359,
					"width": 1024,
					"paths": [
						"M896 192h-768c-53.024 0-96 42.976-96 96v448c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-448c0-53.024-42.976-96-96-96zM960 736c0 35.296-28.704 64-64 64h-768c-35.296 0-64-28.704-64-64v-448c0-35.296 28.704-64 64-64h768c35.296 0 64 28.704 64 64v448zM128 656c0-8.832 7.168-16 16-16h128c8.832 0 16 7.168 16 16s-7.168 16-16 16h-128c-8.832 0-16-7.168-16-16zM576 720c0 8.832-7.168 16-16 16h-416c-8.832 0-16-7.168-16-16s7.168-16 16-16h416c8.832 0 16 7.168 16 16zM336 640h128c8.832 0 16 7.168 16 16s-7.168 16-16 16h-128c-8.832 0-16-7.168-16-16s7.168-16 16-16zM672 656c0 8.832-7.168 16-16 16h-128c-8.832 0-16-7.168-16-16s7.168-16 16-16h128c8.832 0 16 7.168 16 16zM864 656c0 8.832-7.168 16-16 16h-128c-8.832 0-16-7.168-16-16s7.168-16 16-16h128c8.832 0 16 7.168 16 16zM160 512h160c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-160c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32zM160 384h160v96h-160v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"charge",
						"pay",
						"purchase",
						"regret",
						"owe"
					],
					"grid": 32
				},
				{
					"id": 360,
					"width": 1024,
					"paths": [
						"M320 480h-160v-96h160v96zM992 288v448c0 53.024-42.976 96-96 96h-768c-53.024 0-96-42.976-96-96v-448c0-53.024 42.976-96 96-96h768c53.024 0 96 42.976 96 96zM464 640h-128c-8.832 0-16 7.168-16 16s7.168 16 16 16h128c8.832 0 16-7.168 16-16s-7.168-16-16-16zM128 480c0 17.664 14.336 32 32 32h160c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-160c-17.664 0-32 14.336-32 32v96zM128 656c0 8.832 7.168 16 16 16h128c8.832 0 16-7.168 16-16s-7.168-16-16-16h-128c-8.832 0-16 7.168-16 16zM576 720c0-8.832-7.168-16-16-16h-416c-8.832 0-16 7.168-16 16s7.168 16 16 16h416c8.832 0 16-7.168 16-16zM672 656c0-8.832-7.168-16-16-16h-128c-8.832 0-16 7.168-16 16s7.168 16 16 16h128c8.832 0 16-7.168 16-16zM864 656c0-8.832-7.168-16-16-16h-128c-8.832 0-16 7.168-16 16s7.168 16 16 16h128c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"charge",
						"pay",
						"purchase",
						"regret",
						"owe"
					],
					"grid": 32
				},
				{
					"id": 979,
					"width": 1024,
					"paths": [
						"M992 352h-32v-128c0-17.664-14.336-32-32-32h-896c-17.664 0-32 14.336-32 32v576c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-128h32c17.664 0 32-14.336 32-32v-256c0-17.664-14.336-32-32-32zM896 768h-832v-512h832v512zM960 608h-32v-192h32v192zM640 448h-64l128-128h-320l-32 160h64l-64 224 288-256zM391.040 448l19.2-96h216.512l-128 128h57.088l-142.816 126.944 45.408-158.944h-67.392z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"charge",
						"power",
						"recharge"
					],
					"grid": 32
				},
				{
					"id": 2468,
					"paths": [
						"M992 960h-224v-32h-32v32h-320v-32h-32v32h-224v-32h-32v32h-64v-288h32v-32h-32v-224h32v-32h-32v-224h32v-32h-32v-128h-64v1024h1024v-96h-32zM440 392l-16 16v252.118l16-16zM408 424l-16 16v252.118l16-16zM376 708.118v-264.118l-16-8v266.334l14.522 7.262zM536 296l-16 16v252.118l16-16zM472 360l-16 16v252.118l16-16zM344 428l-16-8v266.334l16 8zM504 328l-16 16v252.118l16-16zM248 380l-16-8v266.334l16 8zM184 348l-16-8v266.334l16 8zM312 412l-16-8v266.334l16 8zM216 364l-16-8v266.334l16 8zM152 332l-16-8v266.334l16 8zM568 264l-16 16v252.118l16-16zM280 396l-16-8v266.334l16 8zM824 328l-16 16v341.466l16-24zM856 296l-16 16v325.466l16-24zM888 264l-16 16v309.466l16-24zM952 200l-16 16v277.466l16-24zM920 232l-16 16v293.466l16-24zM1016 136l-16 16v245.466l16-24zM984 168l-16 16v261.466l16-24zM696 336l-16-10.666v309.334l16 21.332zM664 314.666l-16-10.666v288l16 21.334zM600 272l-16-10.666v245.332l16 21.334zM632 293.334l-16-10.668v266.668l16 21.334zM728 357.334l-16-10.668v330.668l16 21.334zM792 360l-16 16v357.464l16-23.998zM760 378.666l-16-10.666v352.002l16 21.332zM768 832l-192-256-192 192-256-128v256h896v-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chart",
						"stats",
						"statistics",
						"dualtone",
						"plot",
						"graph"
					],
					"defaultCode": 60303,
					"grid": 16
				},
				{
					"id": 162,
					"paths": [
						"M896 1024h-819.2c-42.347 0-76.8-34.451-76.8-76.8v-819.2c0-42.347 34.453-76.8 76.8-76.8h819.2c42.349 0 76.8 34.453 76.8 76.8v819.2c0 42.349-34.451 76.8-76.8 76.8zM76.8 102.4c-14.115 0-25.6 11.485-25.6 25.6v819.2c0 14.115 11.485 25.6 25.6 25.6h819.2c14.115 0 25.6-11.485 25.6-25.6v-819.2c0-14.115-11.485-25.6-25.6-25.6h-819.2z",
						"M332.8 870.4h-102.4c-14.138 0-25.6-11.461-25.6-25.6v-460.8c0-14.138 11.462-25.6 25.6-25.6h102.4c14.138 0 25.6 11.462 25.6 25.6v460.8c0 14.139-11.462 25.6-25.6 25.6zM256 819.2h51.2v-409.6h-51.2v409.6z",
						"M537.6 870.4h-102.4c-14.138 0-25.6-11.461-25.6-25.6v-614.4c0-14.138 11.462-25.6 25.6-25.6h102.4c14.139 0 25.6 11.462 25.6 25.6v614.4c0 14.139-11.461 25.6-25.6 25.6zM460.8 819.2h51.2v-563.2h-51.2v563.2z",
						"M742.4 870.4h-102.4c-14.139 0-25.6-11.461-25.6-25.6v-256c0-14.139 11.461-25.6 25.6-25.6h102.4c14.139 0 25.6 11.461 25.6 25.6v256c0 14.139-11.461 25.6-25.6 25.6zM665.6 819.2h51.2v-204.8h-51.2v204.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chart-bars",
						"chart",
						"statistics"
					],
					"defaultCode": 59459,
					"grid": 20
				},
				{
					"id": 361,
					"width": 1024,
					"paths": [
						"M384 320h-64c-17.664 0-32 14.336-32 32v384c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-384c0-17.664-14.336-32-32-32zM384 736h-64v-384h64v384zM224 448h-64c-17.664 0-32 14.336-32 32v256c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-256c0-17.664-14.336-32-32-32zM224 736h-64v-256h64v256zM864 512h-64c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32zM864 736h-64v-192h64v192zM544 384h-64c-17.664 0-32 14.336-32 32v320c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-320c0-17.664-14.336-32-32-32zM544 736h-64v-320h64v320zM704 256h-64c-17.664 0-32 14.336-32 32v448c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-448c0-17.664-14.336-32-32-32zM704 736h-64v-448h64v448zM928 128h-832c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h832c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM992 800c0 35.296-28.704 64-64 64h-832c-35.296 0-64-28.704-64-64v-576c0-35.296 28.704-64 64-64h832c35.296 0 64 28.704 64 64v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chart",
						"work",
						"diagram",
						"graph",
						"visualize"
					],
					"grid": 32
				},
				{
					"id": 362,
					"width": 1024,
					"paths": [
						"M640 288h64v448h-64v-448zM480 736h64v-320h-64v320zM320 736h64v-384h-64v384zM160 736h64v-256h-64v256zM800 736h64v-192h-64v192zM1024 224v576c0 53.024-42.976 96-96 96h-832c-53.024 0-96-42.976-96-96v-576c0-53.024 42.976-96 96-96h832c53.024 0 96 42.976 96 96zM256 480c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v256c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-256zM416 352c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v384c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-384zM576 416c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v320c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-320zM736 288c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v448c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-448zM896 544c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chart",
						"work",
						"diagram",
						"graph",
						"visualize"
					],
					"grid": 32
				},
				{
					"id": 980,
					"width": 1024,
					"paths": [
						"M960 160h-896c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM928 864h-832v-640h832v640zM256 512h-128v320h128v-320zM224 800h-64v-256h64v256zM416 384h-128v448h128v-448zM384 800h-64v-384h64v384zM576 640h-128v192h128v-192zM544 800h-64v-128h64v128zM736 512h-128v320h128v-320zM704 800h-64v-256h64v256zM896 256h-128v576h128v-576zM864 800h-64v-512h64v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chart",
						"diagram",
						"graph",
						"visualize"
					],
					"grid": 32
				},
				{
					"id": 363,
					"width": 1024,
					"paths": [
						"M640 429.824v4.32c0 7.648-6.208 13.856-13.856 13.856h-356.32c-7.616 0-13.824-6.208-13.824-13.824v-4.32c0-7.648 6.208-13.856 13.824-13.856h356.32c7.648 0 13.856 6.208 13.856 13.824zM269.824 512h356.32c7.648 0 13.856-6.208 13.856-13.824v-4.32c0-7.648-6.208-13.856-13.856-13.856h-356.32c-7.616 0-13.824 6.208-13.824 13.824v4.32c0 7.648 6.208 13.856 13.824 13.856zM754.144 192h-356.32c-7.616 0-13.824-6.208-13.824-13.824v-4.352c0-7.616 6.208-13.824 13.824-13.824h356.32c7.648 0 13.856 6.208 13.856 13.824v4.32c0 7.648-6.208 13.856-13.856 13.856zM736 735.264l-3.424 2.496c-5.44 3.968-6.976 11.2-4.224 17.312 8.256 18.24 8.384 39.040 0.64 56.768-2.688 6.144-1.152 13.312 4.288 17.28l3.392 2.464c7.2 5.216 17.28 2.336 20.928-5.76 12.032-26.816 11.872-57.536-0.736-84.896-3.68-8.064-13.696-10.912-20.864-5.664zM320 288h601.376c14.24 0 21.408-17.248 11.328-27.328l-36.704-36.672v-96c0-35.36-28.64-64-64-64h-512c-35.36 0-64 28.64-64 64v96c0 35.36 28.64 64 64 64zM320 96h512c17.664 0 32 14.336 32 32v109.248l18.752 18.752h-562.752c-17.664 0-32-14.336-32-32v-96c0-17.664 14.336-32 32-32zM768 544v-160c0-35.36-28.64-64-64-64h-512c-35.36 0-64 28.64-64 64v160l-36.672 36.672c-10.080 10.080-2.944 27.328 11.296 27.328h601.376c35.36 0 64-28.64 64-64zM160 557.248v-173.248c0-17.664 14.336-32 32-32h512c17.664 0 32 14.336 32 32v160c0 17.664-14.336 32-32 32h-562.752l18.752-18.752zM896 864v-160c0-35.36-28.64-64-64-64h-224c-35.36 0-64 28.64-64 64v160c0 35.36 28.64 64 64 64h313.376c14.24 0 21.408-17.248 11.328-27.328l-36.704-36.672zM576 864v-160c0-17.664 14.336-32 32-32h224c17.664 0 32 14.336 32 32v173.248l18.752 18.752h-274.752c-17.664 0-32-14.336-32-32zM704 752c0 8.832-7.168 16-16 16s-16-7.168-16-16 7.168-16 16-16 16 7.168 16 16zM704 816c0 8.832-7.168 16-16 16s-16-7.168-16-16 7.168-16 16-16 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chat",
						"converse",
						"talk",
						"message"
					],
					"grid": 32
				},
				{
					"id": 364,
					"width": 1024,
					"paths": [
						"M768 544v-160c0-35.36-28.64-64-64-64h-512c-35.36 0-64 28.64-64 64v160l-36.672 36.672c-10.080 10.080-2.944 27.328 11.296 27.328h601.376c35.36 0 64-28.64 64-64zM640 498.176c0 7.616-6.208 13.824-13.824 13.824h-356.352c-7.616 0-13.824-6.208-13.824-13.824v-4.32c0-7.648 6.208-13.856 13.824-13.856h356.32c7.648 0 13.856 6.208 13.856 13.824v4.352zM640 434.176c0 7.616-6.208 13.824-13.824 13.824h-356.352c-7.616 0-13.824-6.208-13.824-13.824v-4.32c0-7.648 6.208-13.856 13.824-13.856h356.32c7.648 0 13.856 6.208 13.856 13.824v4.352zM320 288h601.376c14.24 0 21.408-17.248 11.328-27.328l-36.704-36.672v-96c0-35.36-28.64-64-64-64h-512c-35.36 0-64 28.64-64 64v96c0 35.36 28.64 64 64 64zM384 173.824c0-7.616 6.208-13.824 13.824-13.824h356.32c7.648 0 13.856 6.208 13.856 13.824v4.32c0 7.648-6.208 13.856-13.824 13.856h-356.352c-7.616 0-13.824-6.208-13.824-13.824v-4.352zM896 864v-160c0-35.36-28.64-64-64-64h-224c-35.36 0-64 28.64-64 64v160c0 35.36 28.64 64 64 64h313.376c14.24 0 21.408-17.248 11.328-27.328l-36.704-36.672zM688 832c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16c0 8.832-7.168 16-16 16zM688 768c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16c0 8.832-7.168 16-16 16zM757.664 825.824c-3.648 8.128-13.728 11.008-20.928 5.76l-3.392-2.464c-5.44-3.936-6.976-11.104-4.288-17.28 7.744-17.76 7.616-38.528-0.64-56.768-2.784-6.144-1.216-13.344 4.224-17.312l3.36-2.496c7.168-5.248 17.184-2.4 20.928 5.664 12.608 27.36 12.736 58.112 0.736 84.896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chat",
						"converse",
						"talk",
						"message"
					],
					"grid": 32
				},
				{
					"id": 981,
					"width": 1024,
					"paths": [
						"M992 128h-96v-96c0-17.664-14.336-32-32-32h-832c-17.664 0-32 14.336-32 32v640c0 17.664 14.336 32 32 32h96v160c0 17.664 14.336 32 32 32h288l105.376 105.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l105.376-105.376h288c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM960 192v640h-282.496l-101.504 101.504-101.504-101.504h-282.496v-640h768zM64 640v-576h768v96h-640c-17.664 0-32 14.336-32 32v448h-96zM320 384h512v32h-512v-32zM320 480h512v32h-512v-32zM320 576h512v32h-512v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chat",
						"converse",
						"talk",
						"message"
					],
					"grid": 32
				},
				{
					"id": 1191,
					"width": 1024,
					"paths": [
						"M954.857 323.429q0 22.857-16 38.857l-491.429 491.429q-16 16-38.857 16t-38.857-16l-284.571-284.571q-16-16-16-38.857t16-38.857l77.714-77.714q16-16 38.857-16t38.857 16l168 168.571 374.857-375.429q16-16 38.857-16t38.857 16l77.714 77.714q16 16 16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"check"
					],
					"defaultCode": 61452,
					"grid": 14
				},
				{
					"id": 1262,
					"width": 877.7139282226562,
					"paths": [
						"M733.714 419.429q0-16-10.286-26.286l-52-51.429q-10.857-10.857-25.714-10.857t-25.714 10.857l-233.143 232.571-129.143-129.143q-10.857-10.857-25.714-10.857t-25.714 10.857l-52 51.429q-10.286 10.286-10.286 26.286 0 15.429 10.286 25.714l206.857 206.857q10.857 10.857 25.714 10.857 15.429 0 26.286-10.857l310.286-310.286q10.286-10.286 10.286-25.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"check-circle"
					],
					"defaultCode": 61528,
					"grid": 14
				},
				{
					"id": 1267,
					"width": 877.7139282226562,
					"paths": [
						"M669.143 464.571l-241.143 241.143q-10.857 10.857-25.714 10.857t-25.714-10.857l-168-168q-10.857-10.857-10.857-25.714t10.857-25.714l58.286-58.286q10.857-10.857 25.714-10.857t25.714 10.857l84 84 157.143-157.143q10.857-10.857 25.714-10.857t25.714 10.857l58.286 58.286q10.857 10.857 10.857 25.714t-10.857 25.714zM749.714 512q0-84.571-41.714-156t-113.143-113.143-156-41.714-156 41.714-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"check-circle-o"
					],
					"defaultCode": 61533,
					"grid": 14
				},
				{
					"id": 1475,
					"width": 877.7129821777344,
					"paths": [
						"M391.429 742.286l350.857-350.857q10.857-10.857 10.857-25.714t-10.857-25.714l-58.286-58.286q-10.857-10.857-25.714-10.857t-25.714 10.857l-266.857 266.857-120.571-120.571q-10.857-10.857-25.714-10.857t-25.714 10.857l-58.286 58.286q-10.857 10.857-10.857 25.714t10.857 25.714l204.571 204.571q10.857 10.857 25.714 10.857t25.714-10.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"check-square"
					],
					"defaultCode": 61770,
					"grid": 14
				},
				{
					"id": 1245,
					"width": 950.2818908691406,
					"paths": [
						"M804.571 531.429v181.714q0 68-48.286 116.286t-116.286 48.286h-475.429q-68 0-116.286-48.286t-48.286-116.286v-475.429q0-68 48.286-116.286t116.286-48.286h475.429q36 0 66.857 14.286 8.571 4 10.286 13.143 1.714 9.714-5.143 16.571l-28 28q-5.714 5.714-13.143 5.714-1.714 0-5.143-1.143-13.143-3.429-25.714-3.429h-475.429q-37.714 0-64.571 26.857t-26.857 64.571v475.429q0 37.714 26.857 64.571t64.571 26.857h475.429q37.714 0 64.571-26.857t26.857-64.571v-145.143q0-7.429 5.143-12.571l36.571-36.571q5.714-5.714 13.143-5.714 3.429 0 6.857 1.714 11.429 4.571 11.429 16.571zM936.571 252l-465.143 465.143q-13.714 13.714-32.571 13.714t-32.571-13.714l-245.714-245.714q-13.714-13.714-13.714-32.571t13.714-32.571l62.857-62.857q13.714-13.714 32.571-13.714t32.571 13.714l150.286 150.286 369.714-369.714q13.714-13.714 32.571-13.714t32.571 13.714l62.857 62.857q13.714 13.714 13.714 32.571t-13.714 32.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"check-square-o"
					],
					"defaultCode": 61510,
					"grid": 14
				},
				{
					"id": 3195,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM960 960h-896v-896h896v896z",
						"M160 512l96-96 160 160 352-352 96 96-448 448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkbox-checked",
						"checkbox",
						"tick",
						"checked",
						"selected"
					],
					"defaultCode": 61030,
					"grid": 16
				},
				{
					"id": 3203,
					"paths": [
						"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM448 794.51l-237.254-237.256 90.51-90.508 146.744 146.744 306.746-306.746 90.508 90.51-397.254 397.256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkbox-checked",
						"checkbox",
						"tick",
						"checked",
						"selected"
					],
					"defaultCode": 61038,
					"grid": 16
				},
				{
					"id": 3197,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM960 960h-896v-896h896v896zM256 256h512v512h-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkbox-partial",
						"checkbox",
						"partial"
					],
					"defaultCode": 61032,
					"grid": 16
				},
				{
					"id": 3205,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM896 896h-768v-768h768v768zM320 768h384c35.2 0 64-28.8 64-64v-384c0-35.2-28.8-64-64-64h-384c-35.2 0-64 28.8-64 64v384c0 35.2 28.8 64 64 64zM320 696h384v7.884c-0.034 0.040-0.076 0.082-0.116 0.116h-383.77c-0.040-0.034-0.082-0.076-0.114-0.116v-7.884zM320.114 320h383.77c0.040 0.034 0.082 0.076 0.116 0.116v7.884h-384v-7.886c0.034-0.038 0.076-0.080 0.114-0.114zM704 344v16h-384v-16h384zM704 376v16h-384v-16h384zM704 408v16h-384v-16h384zM704 440v16h-384v-16h384zM704 472v16h-384v-16h384zM704 504v16h-384v-16h384zM704 536v16h-384v-16h384zM704 568v16h-384v-16h384zM704 600v16h-384v-16h384zM704 632v16h-384v-16h384zM704 664v16h-384v-16h384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkbox-partial",
						"checkbox",
						"box",
						"squares",
						"partial",
						"dualtone"
					],
					"defaultCode": 61040,
					"grid": 16
				},
				{
					"id": 3196,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM960 960h-896v-896h896v896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkbox-unchecked",
						"checkbox",
						"unchecked",
						"square"
					],
					"defaultCode": 61031,
					"grid": 16
				},
				{
					"id": 3204,
					"paths": [
						"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM896 896h-768v-768h768v768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkbox-unchecked",
						"checkbox",
						"unchecked",
						"square"
					],
					"defaultCode": 61039,
					"grid": 16
				},
				{
					"id": 2948,
					"paths": [
						"M864 128l-480 480-224-224-160 160 384 384 640-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkmark",
						"tick",
						"correct",
						"accept",
						"ok"
					],
					"defaultCode": 60783,
					"grid": 16
				},
				{
					"id": 3211,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM416 770l-180-214 66-66 114 112 330-288 46 46-376 410z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkmark-circle"
					],
					"defaultCode": 61046,
					"grid": 16
				},
				{
					"id": 222,
					"paths": [
						"M486.4 1024c-129.922 0-252.067-50.594-343.936-142.464s-142.464-214.014-142.464-343.936c0-129.923 50.595-252.067 142.464-343.936s214.013-142.464 343.936-142.464c129.922 0 252.067 50.595 343.936 142.464s142.464 214.014 142.464 343.936-50.594 252.067-142.464 343.936c-91.869 91.87-214.014 142.464-343.936 142.464zM486.4 102.4c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2 435.2-195.23 435.2-435.2-195.23-435.2-435.2-435.2z",
						"M384 742.4c-6.552 0-13.102-2.499-18.102-7.499l-153.6-153.6c-9.997-9.997-9.997-26.206 0-36.203 9.998-9.997 26.206-9.997 36.205 0l135.498 135.498 340.299-340.298c9.997-9.997 26.206-9.997 36.203 0 9.998 9.998 9.998 26.206 0 36.205l-358.4 358.4c-5 4.998-11.55 7.498-18.102 7.498z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkmark-circle",
						"checkmark"
					],
					"defaultCode": 59519,
					"grid": 20
				},
				{
					"id": 2949,
					"paths": [
						"M397.434 917.696l-397.868-391.6 197.378-194.27 200.49 197.332 429.62-422.852 197.378 194.27-626.998 617.12zM107.912 526.096l289.524 284.962 518.656-510.482-89.036-87.632-429.62 422.852-200.49-197.334-89.034 87.634z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkmark",
						"tick",
						"correct",
						"accept",
						"ok"
					],
					"defaultCode": 60784,
					"grid": 16
				},
				{
					"id": 2950,
					"paths": [
						"M896 160l-544 544-224-224-96 96 320 320 640-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkmark",
						"tick",
						"correct",
						"accept",
						"ok"
					],
					"defaultCode": 60785,
					"grid": 16
				},
				{
					"id": 2951,
					"paths": [
						"M983.058 64c-334.5 253.166-655.302 591.8-655.302 591.8l-231.18-207.8-96.576 98.378c95.016 89.302 315.162 325.198 389.632 413.622 209.59-350.18 427.478-611.336 634.368-850.154l-40.942-45.846z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkmark",
						"tick",
						"correct",
						"accept",
						"ok"
					],
					"defaultCode": 60786,
					"grid": 16
				},
				{
					"id": 2952,
					"paths": [
						"M877.95 215.574l-486.002 419.172-243.102-179.72-43.482 42.862 284.306 303.596 528.14-546.62-39.86-39.29zM881.384 112.248v0l143.366 141.31-635.938 658.194-389.556-415.986 142.518-140.482 246.522 182.252 493.088-425.288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"checkmark",
						"tick",
						"correct",
						"accept",
						"ok"
					],
					"defaultCode": 60787,
					"grid": 16
				},
				{
					"id": 2521,
					"paths": [
						"M1007.546 452.030l-708.798-393.93c-9.288-5.16-20.534-5.376-30.016-0.57-165.758 84.044-268.732 245.924-268.732 422.47v384c0 17.674 14.328 32 32 32h960c17.674 0 32-14.326 32-32v-383.86c0.052-11.462-6.080-22.346-16.454-28.11zM510 326c33.136 0 60 25.072 60 56 0 30.93-26.864 56-60 56s-60-25.070-60-56c0-30.928 26.864-56 60-56zM256 260.266c35.346 0 64 26.744 64 59.734 0 32.992-28.654 59.734-64 59.734s-64-26.742-64-59.734c0-32.99 28.654-59.734 64-59.734zM768 832c0-35.346-28.652-64-64-64s-64 28.654-64 64h-576v-320h896v64h-32c-53.020 0-96 42.98-96 96s42.98 96 96 96h32v64h-192z",
						"M256 640c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
						"M512 672c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M704 640c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cheese",
						"food"
					],
					"defaultCode": 60356,
					"grid": 16
				},
				{
					"id": 2534,
					"paths": [
						"M832 384c-71.086 0-133.142 38.632-166.334 96.044-66.732-19.498-129.662-44.058-188.074-73.55-78.028-39.398-148.314-87.588-208.908-143.232-77.566-71.23-124.094-142.030-140.684-174.62v-24.642c0-35.346-28.652-64-64-64s-64 28.654-64 64 28.654 64 64 64c0.41 0 0.814-0.024 1.222-0.032 7.47 103.532 48.978 244.39 109.994 370.014 37.556 77.324 79.868 144.3 125.756 199.070 1.642 1.958 3.286 3.9 4.934 5.824-31.006 34.098-49.906 79.404-49.906 129.124 0 106.040 85.962 192 192 192 106.040 0 192-85.96 192-192s-85.96-192-192-192c-33.274 0-64.568 8.466-91.852 23.36-44.066-50.94-85.9-116.208-123.364-193.34-38.322-78.9-68.956-165.756-86.976-242.98 20.792 25 46.208 52.462 76.826 80.814 64.95 60.144 140.246 112.158 223.796 154.598 61.288 31.13 127.172 57.084 196.918 77.736-2.19 11.604-3.348 23.572-3.348 35.812 0 106.040 85.96 192 192 192s192-85.96 192-192-85.96-192-192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cherry",
						"fruit",
						"food"
					],
					"defaultCode": 60369,
					"grid": 16
				},
				{
					"id": 1933,
					"paths": [
						"M896 0h128v128h-128zM896 256h128v128h-128zM896 512h128v128h-128zM896 768h128v128h-128zM768 128h128v128h-128zM768 384h128v128h-128zM768 640h128v128h-128zM768 896h128v128h-128zM640 0h128v128h-128zM640 256h128v128h-128zM640 512h128v128h-128zM640 768h128v128h-128zM512 128h128v128h-128zM512 384h128v128h-128zM512 640h128v128h-128zM512 896h128v128h-128zM384 0h128v128h-128zM384 256h128v128h-128zM384 512h128v128h-128zM384 768h128v128h-128zM256 128h128v128h-128zM256 384h128v128h-128zM256 640h128v128h-128zM256 896h128v128h-128zM128 0h128v128h-128zM128 256h128v128h-128zM128 512h128v128h-128zM128 768h128v128h-128zM0 128h128v128h-128zM0 384h128v128h-128zM0 640h128v128h-128zM0 896h128v128h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chess",
						"grid",
						"game"
					],
					"defaultCode": 59768,
					"grid": 16
				},
				{
					"id": 1930,
					"paths": [
						"M793.594 768h-627.186c29.65 73.032 158.78 128 313.592 128s283.944-54.968 313.594-128zM0 1024h90c0-2.58 2.804-11.226 11.14-20.118s16.442-11.882 18.86-11.882h270c53.438-1 90-63 90-96 0 0-300 0-360 0s-120 64-120 128zM840 896c-60 0-360 0-360 0 0 33 36.562 95 90 96h270c2.418 0 10.526 2.992 18.86 11.882 8.336 8.89 11.14 17.538 11.14 20.118h90c0-64-60-128-120-128zM480 704h313.594c-13.002-32.026-45.134-60.574-90.172-82.542 20.738-28.012 32.578-64.046 32.578-109.458 0-160.938-116.934-265.57-198.708-303.764 32.756-19.542 54.708-55.32 54.708-96.236 0-61.856-50.144-112-112-112s-112 50.144-112 112c0 40.916 21.952 76.694 54.708 96.236-81.774 38.194-198.708 142.826-198.708 303.764 0 45.412 11.84 81.446 32.578 109.458-45.036 21.968-77.17 50.518-90.17 82.542h313.592c0 0 0 0 0 0zM320 448v-64h128v-128h64v128h128v64h-128v128h-64v-128h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chess-bishop",
						"chess"
					],
					"defaultCode": 59765,
					"grid": 16
				},
				{
					"id": 1927,
					"paths": [
						"M974.048 265.5c-33.744-33.744-80.114-49.952-131.5-49.952-68.888 0-146.808 29.116-215.532 84.124-16.264-49.816-46.48-87.516-83.018-101.622v-70.050h96v-64h-96v-64h-64v64h-96v64h96v70.048c-36.536 14.106-66.752 51.804-83.016 101.618-68.722-55.006-146.642-84.124-215.53-84.12-51.386 0.004-97.758 16.208-131.5 49.952-87.478 87.478-57.084 259.7 67.882 384.666 23.358 23.358 48.372 43.388 74.166 59.986v93.764c87.658 17.57 198.908 28.086 320 28.086s232.342-10.516 320-28.086v-93.76c25.794-16.596 50.808-36.628 74.166-59.986 124.966-124.968 155.36-297.192 67.882-384.668zM163.092 378.644c1.078-0.72 6.846-3.096 18.362-3.098h0.016c31.85 0 87.628 18.586 140.010 70.968 34.574 34.574 59.32 76.362 67.896 114.652 6.118 27.32 1.534 41.496-0.014 43.736-1.072 0.718-6.832 3.098-18.36 3.098-31.856 0-87.644-18.588-140.030-70.972-34.576-34.578-59.324-76.37-67.896-114.66-6.116-27.312-1.532-41.482 0.016-43.724zM860.922 422.38c-8.574 38.29-33.32 80.078-67.892 114.648-52.386 52.386-108.172 70.972-140.030 70.972-11.524 0-17.288-2.376-18.36-3.096-1.546-2.238-6.132-16.408-0.018-43.724 8.572-38.292 33.32-80.082 67.896-114.66 52.384-52.384 108.174-70.972 140.030-70.972 11.528 0 17.29 2.376 18.36 3.096 1.548 2.24 6.134 16.416 0.014 43.736zM192 901.664v94.25c87.658 17.57 198.908 28.086 320 28.086s232.342-10.516 320-28.086v-94.25c-93.828 17.25-203.96 26.336-320 26.336s-226.172-9.086-320-26.336z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chess-king",
						"chess"
					],
					"defaultCode": 59762,
					"grid": 16
				},
				{
					"id": 1931,
					"paths": [
						"M992 960h-736l-32 64h800zM567.492 512c13.448 207.898-169.532 289.514-232.668 416h625.176c0-71.594 0-185.932 0-352 0-222.34-87.072-382.854-189.912-460.14-4.746-20.186-11.918-42.486-19.908-60.608l-12.36-28.026c-14.204-32.208-44.288-36.458-66.852-9.444l-38.626 46.236c-0.282-0.002-0.566-0.018-0.85-0.018-16.468 0-31.642 0.514-45.708 1.49l-84.532-56.356c-29.29-19.526-53.252-6.702-53.252 28.498v65.184c-25.964 14.702-47.726 32.486-72.508 51.382-64 48.798-217.852 242.132-320 357.802-94.492 107-43.45 192 46 172-4.492 84 65.508 57 114 20 111.814-85.314 361.508-45 352-192zM774.926 173.076c34.506 34.932 64.308 79.622 87.46 131.502 35.576 79.714 53.614 171.034 53.614 271.422v288l-96-96v-192c0-86.822-15.234-164.978-45.28-232.298-18.408-41.25-41.478-76.168-67.67-102.75l67.876-67.876zM160 589.256c-24.994 0-45.256-20.26-45.256-45.256 0-24.994 20.262-45.254 45.256-45.254 24.992 0 45.254 20.26 45.254 45.254 0 24.996-20.262 45.256-45.254 45.256zM481.942 287.942c-37.492 37.49-83.078 52.686-101.824 33.942-18.746-18.746-3.55-64.334 33.94-101.824s83.078-52.686 101.826-33.94c18.74 18.744 3.548 64.332-33.942 101.822z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chess-knight",
						"chess",
						"horse"
					],
					"defaultCode": 59766,
					"grid": 16
				},
				{
					"id": 1932,
					"paths": [
						"M736.020 635.96c20.366-36.73 31.98-78.986 31.98-123.96 0-103.314-61.208-192.324-149.334-232.772 32.724-29.298 53.334-71.85 53.334-119.228 0-88.366-71.634-160-160-160s-160 71.634-160 160c0 47.38 20.61 89.93 53.334 119.228-88.126 40.448-149.334 129.458-149.334 232.772 0 44.974 11.612 87.23 31.98 123.96-133.892 77.466-223.98 222.228-223.98 388.040h896c0-165.812-90.088-310.574-223.98-388.040z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chess-pawn",
						"chess"
					],
					"defaultCode": 59767,
					"grid": 16
				},
				{
					"id": 1928,
					"paths": [
						"M512 960c-114.588 0-225.762-9.934-313.042-27.968-2.338-0.482-4.656-0.974-6.958-1.468v65.352c87.658 17.568 198.908 28.084 320 28.084s232.342-10.516 320-28.086v-65.352c-2.302 0.494-4.62 0.986-6.958 1.468-87.278 18.036-198.452 27.97-313.042 27.97zM768 861.994v-29.994l-32-64h-448l-32 64v29.994c75.31 10.892 162.74 17.128 256 17.128 93.262 0.002 180.69-6.236 256-17.128zM1001.508 281.656c-29.994-29.994-78.622-29.994-108.614 0-25.45 25.448-29.292 64.308-11.552 93.822l-195.322 117.194 38.506-181.716c33.68 7.162 69.17-9.124 84.948-41.47 18.594-38.124 2.762-84.1-35.36-102.694-38.124-18.594-84.102-2.762-102.696 35.362-15.778 32.348-6.76 70.342 19.622 92.472l-118.208 140.696-42.202-168.806c33.41-8.326 58.17-38.522 58.17-74.512 0-42.416-34.384-76.8-76.798-76.8-42.416 0-76.8 34.384-76.8 76.8 0 35.99 24.76 66.186 58.172 74.512l-42.202 168.806-118.208-140.696c26.38-22.13 35.398-60.124 19.622-92.472-18.594-38.124-64.572-53.956-102.696-35.362-38.122 18.594-53.954 64.572-35.36 102.694 15.776 32.348 51.268 48.632 84.948 41.47l38.504 181.716-195.32-117.194c17.74-29.514 13.894-68.374-11.554-93.822-29.992-29.994-78.62-29.994-108.614 0-29.99 29.992-29.99 78.618 0.002 108.612 25.448 25.448 64.308 29.292 93.82 11.554l181.306 302.178h428.756l181.306-302.178c29.512 17.738 68.372 13.894 93.82-11.554 29.994-29.994 29.994-78.622 0.004-108.612z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chess-queen",
						"chess"
					],
					"defaultCode": 59763,
					"grid": 16
				},
				{
					"id": 1929,
					"paths": [
						"M192 288h576v512h-576zM768 256l128-128v-128h-128v64h-192v-64h-192v64h-192v-64h-128v128l128 128h576zM768 160l-32 32h-512l-32-32h576zM128 832h704v64h-704zM896 928h-832c0 0-49 32-64 96h960c-15-64-64-96-64-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chess-rook",
						"chess"
					],
					"defaultCode": 59764,
					"grid": 16
				},
				{
					"id": 1460,
					"width": 877.7139282226562,
					"paths": [
						"M464.571 742.286l259.429-259.429q10.857-10.857 10.857-25.714t-10.857-25.714l-58.286-58.286q-10.857-10.857-25.714-10.857t-25.714 10.857l-175.429 175.429-175.429-175.429q-10.857-10.857-25.714-10.857t-25.714 10.857l-58.286 58.286q-10.857 10.857-10.857 25.714t10.857 25.714l259.429 259.429q10.857 10.857 25.714 10.857t25.714-10.857zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-circle-down"
					],
					"defaultCode": 61754,
					"grid": 14
				},
				{
					"id": 1457,
					"width": 877.7139282226562,
					"paths": [
						"M519.429 797.143l58.286-58.286q10.857-10.857 10.857-25.714t-10.857-25.714l-175.429-175.429 175.429-175.429q10.857-10.857 10.857-25.714t-10.857-25.714l-58.286-58.286q-10.857-10.857-25.714-10.857t-25.714 10.857l-259.429 259.429q-10.857 10.857-10.857 25.714t10.857 25.714l259.429 259.429q10.857 10.857 25.714 10.857t25.714-10.857zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-circle-left"
					],
					"defaultCode": 61751,
					"grid": 14
				},
				{
					"id": 1458,
					"width": 877.7139282226562,
					"paths": [
						"M409.714 797.143l259.429-259.429q10.857-10.857 10.857-25.714t-10.857-25.714l-259.429-259.429q-10.857-10.857-25.714-10.857t-25.714 10.857l-58.286 58.286q-10.857 10.857-10.857 25.714t10.857 25.714l175.429 175.429-175.429 175.429q-10.857 10.857-10.857 25.714t10.857 25.714l58.286 58.286q10.857 10.857 25.714 10.857t25.714-10.857zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-circle-right"
					],
					"defaultCode": 61752,
					"grid": 14
				},
				{
					"id": 1459,
					"width": 877.7139282226562,
					"paths": [
						"M665.714 650.857l58.286-58.286q10.857-10.857 10.857-25.714t-10.857-25.714l-259.429-259.429q-10.857-10.857-25.714-10.857t-25.714 10.857l-259.429 259.429q-10.857 10.857-10.857 25.714t10.857 25.714l58.286 58.286q10.857 10.857 25.714 10.857t25.714-10.857l175.429-175.429 175.429 175.429q10.857 10.857 25.714 10.857t25.714-10.857zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-circle-up"
					],
					"defaultCode": 61753,
					"grid": 14
				},
				{
					"id": 1292,
					"width": 1023.9999237060547,
					"paths": [
						"M961.714 461.714l-424 423.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-424-423.429q-10.857-10.857-10.857-26t10.857-26l94.857-94.286q10.857-10.857 25.714-10.857t25.714 10.857l303.429 303.429 303.429-303.429q10.857-10.857 25.714-10.857t25.714 10.857l94.857 94.286q10.857 10.857 10.857 26t-10.857 26z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-down"
					],
					"defaultCode": 61560,
					"grid": 14
				},
				{
					"id": 231,
					"paths": [
						"M830.336 881.538c91.869-91.869 142.464-214.016 142.464-343.938s-50.595-252.067-142.464-343.936-214.014-142.464-343.936-142.464-252.069 50.595-343.938 142.464-142.462 214.014-142.462 343.936 50.594 252.069 142.462 343.938 214.016 142.462 343.938 142.462 252.067-50.594 343.936-142.462zM51.2 537.6c0-239.97 195.23-435.2 435.2-435.2s435.2 195.23 435.2 435.2c0 239.97-195.23 435.2-435.2 435.2s-435.2-195.23-435.2-435.2z",
						"M204.8 460.8c0-6.552 2.499-13.102 7.499-18.102 9.997-9.997 26.206-9.997 36.203 0l237.898 237.898 237.898-237.898c9.998-9.997 26.206-9.997 36.205 0 9.997 9.998 9.997 26.206 0 36.205l-256 256c-9.997 9.998-26.206 9.998-36.203 0l-256-256c-5-5-7.499-11.55-7.499-18.102z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-down-circle",
						"down"
					],
					"defaultCode": 59528,
					"grid": 20
				},
				{
					"id": 211,
					"paths": [
						"M0 307.2c0-6.552 2.499-13.102 7.499-18.101 9.997-9.998 26.206-9.998 36.203 0l442.698 442.698 442.699-442.698c9.997-9.998 26.206-9.998 36.203 0s9.998 26.206 0 36.203l-460.8 460.8c-9.997 9.998-26.206 9.998-36.203 0l-460.8-460.8c-5-5-7.499-11.55-7.499-18.102z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-down",
						"down"
					],
					"defaultCode": 59508,
					"grid": 20
				},
				{
					"id": 1257,
					"width": 768.0010223388672,
					"paths": [
						"M669.143 172l-303.429 303.429 303.429 303.429q10.857 10.857 10.857 25.714t-10.857 25.714l-94.857 94.857q-10.857 10.857-25.714 10.857t-25.714-10.857l-424-424q-10.857-10.857-10.857-25.714t10.857-25.714l424-424q10.857-10.857 25.714-10.857t25.714 10.857l94.857 94.857q10.857 10.857 10.857 25.714t-10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-left"
					],
					"defaultCode": 61523,
					"grid": 14
				},
				{
					"id": 232,
					"paths": [
						"M142.462 193.664c91.869-91.869 214.016-142.464 343.938-142.464s252.067 50.595 343.936 142.464 142.464 214.014 142.464 343.936-50.595 252.069-142.464 343.938-214.014 142.462-343.936 142.462-252.069-50.594-343.938-142.462-142.462-214.016-142.462-343.938 50.594-252.067 142.462-343.936zM486.4 972.8c239.97 0 435.2-195.23 435.2-435.2s-195.23-435.2-435.2-435.2c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2z",
						"M563.2 819.2c6.552 0 13.102-2.499 18.102-7.499 9.997-9.997 9.997-26.206 0-36.203l-237.898-237.898 237.898-237.898c9.997-9.998 9.997-26.206 0-36.205-9.998-9.997-26.206-9.997-36.205 0l-256 256c-9.998 9.997-9.998 26.206 0 36.203l256 256c5 5 11.55 7.499 18.102 7.499z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-left-circle",
						"left"
					],
					"defaultCode": 59529,
					"grid": 20
				},
				{
					"id": 212,
					"paths": [
						"M716.8 1024c6.552 0 13.102-2.499 18.101-7.499 9.998-9.997 9.998-26.206 0-36.203l-442.698-442.698 442.698-442.699c9.998-9.997 9.998-26.206 0-36.203s-26.206-9.998-36.203 0l-460.8 460.8c-9.998 9.997-9.998 26.206 0 36.203l460.8 460.8c5 5 11.55 7.499 18.102 7.499z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-left",
						"left"
					],
					"defaultCode": 59509,
					"grid": 20
				},
				{
					"id": 1258,
					"width": 694.8569641113281,
					"paths": [
						"M632.571 501.143l-424 424q-10.857 10.857-25.714 10.857t-25.714-10.857l-94.857-94.857q-10.857-10.857-10.857-25.714t10.857-25.714l303.429-303.429-303.429-303.429q-10.857-10.857-10.857-25.714t10.857-25.714l94.857-94.857q10.857-10.857 25.714-10.857t25.714 10.857l424 424q10.857 10.857 10.857 25.714t-10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-right"
					],
					"defaultCode": 61524,
					"grid": 14
				},
				{
					"id": 233,
					"paths": [
						"M830.338 193.664c-91.869-91.869-214.016-142.464-343.938-142.464s-252.067 50.595-343.936 142.464-142.464 214.014-142.464 343.936 50.595 252.069 142.464 343.938 214.014 142.462 343.936 142.462 252.069-50.594 343.938-142.462 142.462-214.016 142.462-343.938-50.594-252.067-142.462-343.936zM486.4 972.8c-239.97 0-435.2-195.23-435.2-435.2s195.23-435.2 435.2-435.2c239.97 0 435.2 195.23 435.2 435.2s-195.23 435.2-435.2 435.2z",
						"M409.6 819.2c-6.552 0-13.102-2.499-18.102-7.499-9.997-9.997-9.997-26.206 0-36.203l237.898-237.898-237.898-237.898c-9.997-9.998-9.997-26.206 0-36.205 9.998-9.997 26.206-9.997 36.205 0l256 256c9.998 9.997 9.998 26.206 0 36.203l-256 256c-5 5-11.55 7.499-18.102 7.499z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-right-circle",
						"right"
					],
					"defaultCode": 59530,
					"grid": 20
				},
				{
					"id": 213,
					"paths": [
						"M256 1024c-6.552 0-13.102-2.499-18.101-7.499-9.998-9.997-9.998-26.206 0-36.203l442.698-442.698-442.698-442.699c-9.998-9.997-9.998-26.206 0-36.203s26.206-9.998 36.203 0l460.8 460.8c9.998 9.997 9.998 26.206 0 36.203l-460.8 460.8c-5 5-11.55 7.499-18.102 7.499z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-right",
						"right"
					],
					"defaultCode": 59510,
					"grid": 20
				},
				{
					"id": 1291,
					"width": 1023.9999694824219,
					"paths": [
						"M961.714 760.571l-94.857 94.286q-10.857 10.857-25.714 10.857t-25.714-10.857l-303.429-303.429-303.429 303.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-94.857-94.286q-10.857-10.857-10.857-26t10.857-26l424-423.429q10.857-10.857 25.714-10.857t25.714 10.857l424 423.429q10.857 10.857 10.857 26t-10.857 26z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-up"
					],
					"defaultCode": 61559,
					"grid": 14
				},
				{
					"id": 230,
					"paths": [
						"M142.464 193.662c-91.869 91.869-142.464 214.016-142.464 343.938s50.595 252.067 142.464 343.936 214.014 142.464 343.936 142.464 252.069-50.595 343.938-142.464 142.462-214.014 142.462-343.936-50.594-252.069-142.462-343.938-214.016-142.462-343.938-142.462-252.067 50.594-343.936 142.462zM921.6 537.6c0 239.97-195.23 435.2-435.2 435.2s-435.2-195.23-435.2-435.2c0-239.97 195.23-435.2 435.2-435.2s435.2 195.23 435.2 435.2z",
						"M768 614.4c0 6.552-2.499 13.102-7.499 18.102-9.997 9.997-26.206 9.997-36.203 0l-237.898-237.898-237.898 237.898c-9.998 9.997-26.206 9.997-36.205 0-9.997-9.998-9.997-26.206 0-36.205l256-256c9.997-9.998 26.206-9.998 36.203 0l256 256c5 5 7.499 11.55 7.499 18.102z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-up-circle",
						"up"
					],
					"defaultCode": 59527,
					"grid": 20
				},
				{
					"id": 210,
					"paths": [
						"M0 768c0 6.552 2.499 13.102 7.499 18.101 9.997 9.998 26.206 9.998 36.203 0l442.698-442.698 442.699 442.698c9.997 9.998 26.206 9.998 36.203 0s9.998-26.206 0-36.203l-460.8-460.8c-9.997-9.998-26.206-9.998-36.203 0l-460.8 460.8c-5 5-7.499 11.55-7.499 18.102z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chevron-up",
						"up"
					],
					"defaultCode": 59507,
					"grid": 20
				},
				{
					"id": 2518,
					"paths": [
						"M960 768c-160 0-240-144-240-144-64 0-96 32-96 96 0 0 144 80 144 240 0 35.346 28.654 64 64 64s64-28.654 64-64v-32c0-17.674 14.326-32 32-32h32c35.346 0 64-28.654 64-64s-28.654-64-64-64z",
						"M576 672c0-53.020 42.98-96 96-96 10.926 0 21.416 1.852 31.202 5.212 9.196-31.902 9.634-66.984-0.908-95.1l-28.586-76.224c-18.54-49.438-46.122-131.266-61.292-181.838-0.002-0.002-68.416-228.050-324.416-228.050-159.058 0-288 128.942-288 288 0 256 228.054 324.41 228.054 324.41 50.574 15.172 91.95 27.586 91.946 27.59s40.444 15.174 89.882 33.71l76.228 28.584c28.116 10.542 63.2 10.104 95.102 0.906-3.36-9.784-5.212-20.274-5.212-31.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chicken",
						"food",
						"meat"
					],
					"defaultCode": 60353,
					"grid": 16
				},
				{
					"id": 1569,
					"width": 731.4300537109375,
					"paths": [
						"M678.857 313.143l-166.857 166.857v470.857q0 26.286-18.857 45.143t-45.143 18.857-45.143-18.857-18.857-45.143v-219.429h-36.571v219.429q0 26.286-18.857 45.143t-45.143 18.857-45.143-18.857-18.857-45.143v-470.857l-166.857-166.857q-16-16-16-38.857t16-38.857 38.857-16 38.857 16l130.286 130.286h210.286l130.286-130.286q16-16 38.857-16t38.857 16 16 38.857-16 38.857zM493.714 219.429q0 53.143-37.429 90.571t-90.571 37.429-90.571-37.429-37.429-90.571 37.429-90.571 90.571-37.429 90.571 37.429 37.429 90.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"child"
					],
					"defaultCode": 61870,
					"grid": 14
				},
				{
					"id": 2095,
					"paths": [
						"M928 512c17.674 0 32-14.328 32-32s-14.326-32-32-32h-96v-64h96c17.674 0 32-14.328 32-32s-14.326-32-32-32h-96v-96l-32-32h-96v-96c0-17.674-14.328-32-32-32s-32 14.326-32 32v96h-64v-96c0-17.674-14.328-32-32-32s-32 14.326-32 32v96h-64v-96c0-17.674-14.326-32-32-32s-32 14.326-32 32v96h-64v-96c0-17.674-14.326-32-32-32s-32 14.326-32 32v96h-96l-32 32v96h-96c-17.674 0-32 14.328-32 32s14.326 32 32 32h96v64h-96c-17.674 0-32 14.328-32 32s14.326 32 32 32h96v64h-96c-17.674 0-32 14.326-32 32s14.326 32 32 32h96v64h-96c-17.674 0-32 14.326-32 32s14.326 32 32 32h96v96l32 32h96v96c0 17.674 14.326 32 32 32s32-14.326 32-32v-96h64v96c0 17.674 14.326 32 32 32s32-14.326 32-32v-96h64v96c0 17.674 14.326 32 32 32 17.672 0 32-14.326 32-32v-96h64v96c0 17.674 14.326 32 32 32 17.672 0 32-14.326 32-32v-96h96l32-32v-96h96c17.674 0 32-14.326 32-32s-14.326-32-32-32h-96v-64h96c17.674 0 32-14.326 32-32s-14.326-32-32-32h-96v-64h96zM576 640h-192v-192h192v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chip",
						"cpu",
						"processor",
						"brain"
					],
					"defaultCode": 59930,
					"grid": 16
				},
				{
					"id": 365,
					"width": 1024,
					"paths": [
						"M634.464 40.224l-2.4-7.232c-5.92-17.76-25.76-26.656-42.976-19.296l-131.648 56.416c-39.84 17.088-82.72 25.888-126.080 25.888h-75.36c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h96v704c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32l-32-320v-361.632l141.088 59.936c17.216 7.36 37.056-1.536 42.976-19.296l2.4-7.232c32.832-98.528 32.832-205.024 0-303.552zM447.808 992h-63.808v-699.264c10.784 1.792 21.44 4.128 32 7.040v405.984l31.808 286.24zM331.392 256h-75.392v-128h75.392c47.936 0 94.592-9.568 138.656-28.448l70.176-30.080c21.792 79.904 21.792 165.152 0 245.088l-70.176-30.080c-44.064-18.912-90.72-28.48-138.656-28.48zM604.096 333.664l-2.4 7.232-31.84-13.664c24.864-88.064 24.864-182.4 0-270.464l31.84-13.664 2.4 7.232c30.464 91.36 30.464 191.968 0 283.328z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chop",
						"cut",
						"hack"
					],
					"grid": 32
				},
				{
					"id": 366,
					"width": 1024,
					"paths": [
						"M448 672l32 320c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32v-670.752c32.768 2.624 64.736 10.304 95.232 23.36l0.768 0.352v327.040zM659.104 192c0 51.264-8.224 102.528-24.64 151.776l-2.4 7.232c-5.92 17.76-25.76 26.656-42.976 19.296l-131.68-56.416c-39.808-17.088-82.688-25.888-126.048-25.888h-75.36c-17.664 0-32-14.336-32-32v-128c0-17.664 14.336-32 32-32h75.36c43.328 0 86.24-8.8 126.080-25.888l131.68-56.416c17.216-7.36 37.056 1.536 42.976 19.296l2.4 7.232c16.384 49.248 24.608 100.512 24.608 151.776zM593.28 192.096c0-40.288-5.152-79.328-14.336-116.832-2.368-9.632-12.8-14.88-21.92-10.976l-0.032 0.032c-7.264 3.104-11.040 11.040-9.184 18.688 8.576 35.008 13.472 71.456 13.472 109.088 0 37.696-4.896 74.208-13.504 109.28-1.888 7.68 1.92 15.616 9.216 18.72l0.032 0.032c9.12 3.872 19.488-1.376 21.856-11.008 9.248-37.568 14.4-76.672 14.4-117.024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chop",
						"cut",
						"hack"
					],
					"grid": 32
				},
				{
					"id": 982,
					"width": 1024,
					"paths": [
						"M998.624 729.376l-672-672c-12.512-12.512-32.736-12.512-45.248 0l-256 256c-6.016 5.984-9.376 14.144-9.376 22.624 0 113.056 334.944 448 448 448 8.48 0 16.64-3.36 22.624-9.376l137.376-137.376 233.376 233.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l96-96c12.512-12.512 12.512-32.736 0-45.248zM452.448 718.304c-89.152-23.36-347.392-281.6-370.752-370.752l44.032-44.032c54.208 114.112 256.64 316.512 370.752 370.752l-44.032 44.032zM520.256 650.496c-99.712-38.112-332.64-271.040-370.752-370.752l154.496-154.496 370.752 370.752-154.496 154.496zM880 802.752l-233.376-233.376 50.752-50.752 233.376 233.376-50.752 50.752zM304 192c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM304 256c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16c0 8.832-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chop",
						"cut",
						"cleave",
						"dice"
					],
					"grid": 32
				},
				{
					"id": 2603,
					"paths": [
						"M992 320c-17.674 0-32 14.328-32 32v48.894l-320 98.050v-50.944c0-70.58-57.42-128-128-128h-128v-64h352c17.674 0 32-14.328 32-32s-14.326-32-32-32h-704c-17.672 0-32 14.328-32 32s14.328 32 32 32h288v64c-67.702 0-133.532 37.108-185.364 104.49-43.57 56.64-70.636 126.958-70.636 183.51v60c0 4.738 1.030 9.234 2.876 13.28 11.494 49.62 56.060 86.72 109.124 86.72h16v64h-96c-17.644 0-32-14.356-32-32 0-17.674-14.328-32-32-32s-32 14.326-32 32c0 52.936 43.066 96 96 96h512c17.674 0 32-14.326 32-32s-14.326-32-32-32h-160v-71.12c27.944-6.322 54.062-16.654 77.472-30.292 0.976-0.454 1.944-0.944 2.888-1.506l431.64-236.082v51c0 17.672 14.326 32 32 32s32-14.328 32-32v-192c0-17.672-14.326-32-32-32zM131.726 576c7.82-36.532 27.44-78.43 53.64-112.49 22.84-29.694 70.706-79.51 134.634-79.51h64v160c0 17.644-14.356 32-32 32h-220.274zM256 832v-64h128v64h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chopper",
						"travel",
						"helicopter",
						"fly",
						"transport"
					],
					"defaultCode": 60438,
					"grid": 16
				},
				{
					"id": 2604,
					"paths": [
						"M992 320c-17.674 0-32 14.328-32 32v56l-320 93.332v-53.332c0-70.58-57.42-128-128-128h-128v-64h352c17.674 0 32-14.328 32-32s-14.326-32-32-32h-704c-17.672 0-32 14.328-32 32s14.328 32 32 32h288v64c-67.702 0-133.532 37.108-185.364 104.49-43.57 56.64-70.636 126.958-70.636 183.51v60c0 4.738 1.030 9.234 2.876 13.28 11.494 49.62 56.060 86.72 109.124 86.72h16v64h-96c-17.644 0-32-14.356-32-32 0-17.674-14.328-32-32-32s-32 14.326-32 32c0 52.936 43.066 96 96 96h512c17.674 0 32-14.326 32-32s-14.326-32-32-32h-160v-71.068c28.25-6.344 55.124-16.894 79.602-31.412 0.022-0.012 0.044-0.022 0.068-0.036l432.33-242.81v57.326c0 17.674 14.326 32 32 32s32-14.326 32-32v-192c0-17.672-14.326-32-32-32zM185.364 463.51c22.842-29.694 70.708-79.51 134.636-79.51h64v160c0 17.644-14.356 32-32 32h-220.274c7.82-36.53 27.44-78.43 53.638-112.49zM128 656v-16h224c52.934 0 96-43.064 96-96v-160h64c35.29 0 64 28.71 64 64v95.37c-0.002 0.054 0 0.11 0 0.164v0.466c0 51.37-30.064 100.012-80.42 130.12-32.694 19.548-71.278 29.88-111.58 29.88h-208c-26.468 0-48-21.534-48-48zM384 832h-128v-64h128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chopper",
						"travel",
						"helicopter",
						"fly",
						"transport"
					],
					"defaultCode": 60439,
					"grid": 16
				},
				{
					"id": 3405,
					"paths": [
						"M258.278 446.542l-146.532-253.802c93.818-117.464 238.234-192.74 400.254-192.74 187.432 0 351.31 100.736 440.532 251h-417.77c-7.504-0.65-15.092-1-22.762-1-121.874 0-224.578 83.644-253.722 196.542zM695.306 325h293.46c22.74 57.93 35.234 121.004 35.234 187 0 280.826-226.1 508.804-506.186 511.926l209.394-362.678c29.48-42.378 46.792-93.826 46.792-149.248 0-73.17-30.164-139.42-78.694-187zM326 512c0-102.56 83.44-186 186-186s186 83.44 186 186c0 102.56-83.44 186-186 186s-186-83.44-186-186zM582.182 764.442l-146.578 253.878c-246.532-36.884-435.604-249.516-435.604-506.32 0-91.218 23.884-176.846 65.696-251.024l209.030 362.054c41.868 89.112 132.476 150.97 237.274 150.97 24.3 0 47.836-3.34 70.182-9.558z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chrome",
						"browser",
						"internet",
						"brand"
					],
					"defaultCode": 61240,
					"grid": 16
				},
				{
					"id": 1741,
					"width": 1024.5709838867188,
					"paths": [
						"M510.286 0q137.143-1.143 257.714 68.571 132.571 76.571 201.143 212.571l-424-22.286q-91.429-5.143-168 42.571t-105.714 131.143l-157.714-242.286q73.143-90.857 177.714-140.286t218.857-50zM83.429 231.429l192.571 378.857q41.143 81.714 120.571 124t167.429 25.714l-131.429 257.714q-121.143-18.857-220-90t-155.714-180.571-56.857-235.143q0-152.571 83.429-280.571zM989.714 328q33.143 85.714 34 177.429t-27.714 174.857-87.429 155.429-140.571 119.714q-131.429 76-284.571 68l231.429-356q50.286-74.857 47.143-166t-60.857-158.571zM512 339.429q71.429 0 122 50.571t50.571 122-50.571 122-122 50.571-122-50.571-50.571-122 50.571-122 122-50.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"chrome"
					],
					"defaultCode": 62056,
					"grid": 14
				},
				{
					"id": 3212,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 960c-247.424 0-448-200.576-448-448s200.576-448 448-448 448 200.576 448 448-200.576 448-448 448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle"
					],
					"defaultCode": 61047,
					"grid": 16
				},
				{
					"id": 3304,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM429.254 658.744c24.994 24.994 24.994 65.518 0 90.512-12.496 12.496-28.876 18.744-45.254 18.744s-32.758-6.248-45.254-18.744l-192-192c-24.994-24.994-24.994-65.518 0-90.51l192-192c24.994-24.994 65.516-24.994 90.51 0s24.994 65.516 0 90.51l-146.746 146.744 146.744 146.744zM685.254 749.254c-24.994 24.994-65.516 24.994-90.51 0-24.994-24.992-24.994-65.516 0-90.51l146.746-146.744-146.746-146.744c-24.994-24.994-24.994-65.518 0-90.512 12.498-12.496 28.878-18.744 45.256-18.744s32.758 6.248 45.254 18.744l192 192c24.994 24.994 24.994 65.518 0 90.51l-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-code",
						"out",
						"html",
						"xml"
					],
					"defaultCode": 61139,
					"grid": 16
				},
				{
					"id": 3303,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM448 263.112c-35.346 0-64 31.838-64 71.112v71.11c0 58.91-42.98 106.666-96 106.666 53.020 0 96 47.756 96 106.666v71.112c0 39.274 28.654 71.112 64 71.112v71.11h-64c-70.58 0-128-63.8-128-142.222v-71.112c0-39.272-28.654-71.112-64-71.112v-71.11c35.346 0 64-31.838 64-71.112v-71.11c0-78.422 57.42-142.222 128-142.222h64v71.112zM832 547.554c-35.348 0-64 31.84-64 71.112v71.112c0 78.422-57.42 142.222-128 142.222h-64v-71.112c35.346 0 64-31.838 64-71.112v-71.112c0-58.908 42.98-106.664 96-106.664-53.020 0-96-47.756-96-106.666v-71.11c0-39.274-28.654-71.112-64-71.112v-71.112h64c70.58 0 128 63.8 128 142.222v71.11c0 39.274 28.652 71.112 64 71.112v71.11z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-css",
						"code",
						"curly-braces"
					],
					"defaultCode": 61138,
					"grid": 16
				},
				{
					"id": 3066,
					"paths": [
						"M312 40.544c-5.386 2.288-10.71 4.69-16 7.156v108.706c5.256-3.2 10.596-6.272 16-9.242v-106.62z",
						"M280 55.472c-5.392 2.746-10.718 5.602-16 8.532v113.984c5.24-3.898 10.574-7.678 16-11.33v-111.186z",
						"M248 73.244c-5.402 3.258-10.73 6.626-16 10.076v121.022c5.212-4.748 10.55-9.36 16-13.84v-117.258z",
						"M88 224.93c-5.576 8.218-10.898 16.622-16 25.172v523.796c5.102 8.55 10.424 16.952 16 25.172v-574.14z",
						"M456 99.764c5.302-0.714 10.636-1.33 16-1.842v-95.54h16v94.322c5.306-0.302 10.64-0.502 16-0.604v-93.718h16v93.718c5.36 0.1 10.692 0.302 16 0.604v-94.322h16v95.54c5.364 0.512 10.698 1.128 16 1.842v-96.704c-18.394-2-37.072-3.060-56-3.060s-37.606 1.060-56 3.060v96.704z",
						"M184 118.878c-5.424 4.532-10.77 9.154-16 13.902v145.254c5.1-7.484 10.436-14.796 16-21.92v-137.236z",
						"M152 147.97c-5.458 5.398-10.79 10.922-16 16.558v169.306c4.926-10.376 10.262-20.516 16-30.398v-155.466z",
						"M344 28.236c-5.376 1.866-10.708 3.82-16 5.858v104.742c5.272-2.604 10.606-5.102 16-7.486v-103.114z",
						"M24 667.276v-310.552c-6.674 20.992-12.056 42.56-16 64.628v181.296c3.944 22.068 9.326 43.636 16 64.628z",
						"M56 278.936c-5.744 11.214-11.078 22.672-16 34.346v397.434c4.922 11.674 10.256 23.132 16 34.346v-466.126z",
						"M440 5.064c-5.36 0.754-10.696 1.578-16 2.498v97.796c5.298-1.14 10.628-2.194 16-3.132v-97.162z",
						"M376 18.296c-5.366 1.474-10.708 3.004-16 4.648v101.708c5.28-2.074 10.618-4.026 16-5.886v-100.47z",
						"M408 10.58c-5.368 1.108-10.696 2.324-16 3.598v99.422c5.292-1.592 10.62-3.11 16-4.494v-98.526z",
						"M120 372.494v-189.822c-5.494 6.534-10.832 13.204-16 20.010v227.834c3.952-19.888 9.324-39.262 16-58.022z",
						"M632 14.178c-5.304-1.274-10.632-2.492-16-3.598v98.528c5.38 1.384 10.706 2.902 16 4.494v-99.424z",
						"M664 22.944c-5.292-1.644-10.634-3.172-16-4.648v100.47c5.382 1.86 10.72 3.812 16 5.886v-101.708z",
						"M600 105.358v-97.798c-5.304-0.918-10.64-1.742-16-2.498v97.162c5.372 0.94 10.702 1.992 16 3.134z",
						"M696 34.092c-5.292-2.038-10.624-3.992-16-5.858v103.114c5.394 2.384 10.728 4.882 16 7.486v-104.742z",
						"M872 720.562v155.466c5.458-5.398 10.788-10.922 16-16.558v-169.306c-4.926 10.376-10.262 20.518-16 30.398z",
						"M152 720.562c-5.738-9.88-11.074-20.024-16-30.398v169.306c5.21 5.636 10.542 11.16 16 16.558v-155.466z",
						"M856 132.78c-5.23-4.748-10.576-9.372-16-13.902v137.238c5.566 7.124 10.9 14.436 16 21.92v-145.256z",
						"M920 202.684c-5.168-6.806-10.504-13.476-16-20.010v189.822c6.676 18.76 12.050 38.134 16 58.024v-227.836z",
						"M728 47.7c-5.29-2.466-10.614-4.868-16-7.156v106.62c5.406 2.968 10.746 6.042 16 9.242v-108.706z",
						"M888 164.53c-5.212-5.636-10.542-11.162-16-16.558v155.466c5.738 9.882 11.074 20.022 16 30.398v-169.306z",
						"M824 106.058c-5.26-4.048-10.582-8.020-16-11.868v125.542c5.494 5.562 10.826 11.282 16 17.144v-130.818z",
						"M760 64.004c-5.282-2.93-10.606-5.786-16-8.532v111.186c5.426 3.652 10.76 7.432 16 11.33v-113.984z",
						"M792 83.318c-5.27-3.45-10.598-6.818-16-10.076v117.258c5.45 4.48 10.788 9.092 16 13.84v-121.022z",
						"M216 94.19c-5.418 3.846-10.74 7.818-16 11.868v130.82c5.174-5.864 10.508-11.582 16-17.144v-125.544z",
						"M120 651.506c-6.676-18.76-12.048-38.134-16-58.026v227.836c5.168 6.806 10.506 13.476 16 20.010v-189.82z",
						"M760 846.012c-5.24 3.896-10.574 7.678-16 11.33v111.188c5.394-2.746 10.718-5.604 16-8.534v-113.984z",
						"M696 885.166c-5.272 2.604-10.606 5.1-16 7.484v103.116c5.376-1.868 10.708-3.82 16-5.86v-104.74z",
						"M728 867.594c-5.254 3.2-10.594 6.272-16 9.242v106.62c5.386-2.288 10.71-4.69 16-7.154v-108.708z",
						"M600 918.642c-5.298 1.14-10.628 2.194-16 3.13v97.162c5.36-0.754 10.696-1.578 16-2.496v-97.796z",
						"M664 899.35c-5.28 2.072-10.618 4.024-16 5.884v100.47c5.366-1.474 10.708-3.006 16-4.648v-101.706z",
						"M632 910.4c-5.294 1.592-10.62 3.11-16 4.494v98.526c5.368-1.108 10.696-2.324 16-3.598v-99.422z",
						"M984 313.284c-4.92-11.674-10.256-23.132-16-34.346v466.126c5.744-11.212 11.080-22.67 16-34.346v-397.434z",
						"M824 787.124c-5.174 5.864-10.506 11.582-16 17.144v125.542c5.418-3.846 10.74-7.818 16-11.866v-130.82z",
						"M952 250.102c-5.1-8.55-10.424-16.954-16-25.172v574.14c5.576-8.22 10.9-16.622 16-25.172v-523.796z",
						"M1016 421.352c-3.942-22.068-9.326-43.636-16-64.628v310.552c6.674-20.992 12.058-42.558 16-64.626v-181.298z",
						"M920 593.48c-3.95 19.89-9.324 39.266-16 58.026v189.82c5.496-6.534 10.832-13.204 16-20.010v-227.836z",
						"M856 745.964c-5.1 7.484-10.434 14.796-16 21.92v137.236c5.424-4.53 10.77-9.154 16-13.902v-145.254z",
						"M792 819.66c-5.212 4.746-10.55 9.36-16 13.84v117.258c5.402-3.258 10.73-6.626 16-10.076v-121.022z",
						"M248 833.5c-5.45-4.48-10.788-9.094-16-13.84v121.022c5.27 3.45 10.598 6.818 16 10.076v-117.258z",
						"M280 857.342c-5.426-3.652-10.76-7.434-16-11.33v113.984c5.282 2.93 10.608 5.788 16 8.534v-111.188z",
						"M312 876.836c-5.404-2.97-10.744-6.042-16-9.242v108.708c5.29 2.464 10.614 4.868 16 7.154v-106.62z",
						"M216 804.268c-5.492-5.562-10.826-11.282-16-17.144v130.82c5.26 4.046 10.582 8.020 16 11.866v-125.542z",
						"M344 892.65c-5.394-2.384-10.728-4.88-16-7.484v104.74c5.292 2.040 10.624 3.992 16 5.86v-103.116z",
						"M568 924.236c-5.302 0.712-10.636 1.33-16 1.842v96.376c5.36-0.414 10.688-0.936 16-1.514v-96.704z",
						"M184 767.884c-5.564-7.124-10.9-14.436-16-21.92v145.254c5.23 4.748 10.576 9.374 16 13.902v-137.236z",
						"M472 926.078c-5.364-0.512-10.698-1.128-16-1.842v96.704c5.312 0.578 10.64 1.1 16 1.514v-96.376z",
						"M504 927.898c-5.36-0.102-10.694-0.302-16-0.604v96.128c5.312 0.244 10.648 0.392 16 0.474v-95.998z",
						"M376 905.234c-5.382-1.862-10.72-3.812-16-5.884v101.708c5.292 1.642 10.634 3.174 16 4.648v-100.472z",
						"M536 927.294c-5.308 0.3-10.64 0.502-16 0.604v96c5.352-0.082 10.688-0.23 16-0.474v-96.13z",
						"M408 914.894c-5.38-1.384-10.708-2.902-16-4.494v99.422c5.304 1.274 10.632 2.49 16 3.598v-98.526z",
						"M440 921.774c-5.372-0.938-10.702-1.99-16-3.13v97.796c5.304 0.918 10.64 1.742 16 2.496v-97.162z",
						"M317.256 354.744l-90.512 90.512 285.256 285.254 285.254-285.256-90.508-90.508-194.746 194.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down",
						"down",
						"circle-bottom",
						"arrow",
						"dualtone"
					],
					"defaultCode": 60901,
					"grid": 16
				},
				{
					"id": 3078,
					"paths": [
						"M1024 512c0-282.77-229.23-512-512-512s-512 229.23-512 512 229.23 512 512 512 512-229.23 512-512zM96 512c0-229.75 186.25-416 416-416s416 186.25 416 416-186.25 416-416 416-416-186.25-416-416z",
						"M704 704v-127.998h-165.492l207.53-207.53-90.51-90.512-207.532 207.532v-165.492h-127.996v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down-left",
						"down-left",
						"circle-bottom-left",
						"arrow"
					],
					"defaultCode": 60913,
					"grid": 16
				},
				{
					"id": 3086,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM320 320h127.996v165.492l207.532-207.532 90.51 90.512-207.53 207.53h165.492v127.998h-384v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down-left",
						"down-left",
						"circle-bottom-left",
						"arrow"
					],
					"defaultCode": 60921,
					"grid": 16
				},
				{
					"id": 3076,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z",
						"M704 320h-127.998v165.492l-207.53-207.53-90.512 90.51 207.532 207.532h-165.492v127.996h384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down-right",
						"down-right",
						"circle-bottom-right",
						"arrow"
					],
					"defaultCode": 60911,
					"grid": 16
				},
				{
					"id": 3084,
					"paths": [
						"M1024 512c0-282.77-229.23-512-512-512s-512 229.23-512 512 229.23 512 512 512 512-229.23 512-512zM320 704v-127.996h165.492l-207.532-207.532 90.512-90.51 207.53 207.53v-165.492h127.998v384h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down-right",
						"down-right",
						"circle-bottom-right",
						"arrow"
					],
					"defaultCode": 60919,
					"grid": 16
				},
				{
					"id": 3070,
					"paths": [
						"M1024 512c0-282.77-229.23-512-512-512s-512 229.23-512 512 229.23 512 512 512 512-229.23 512-512zM96 512c0-229.75 186.25-416 416-416s416 186.25 416 416-186.25 416-416 416-416-186.25-416-416z",
						"M317.256 354.744l-90.512 90.512 285.256 285.254 285.254-285.256-90.508-90.508-194.746 194.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down",
						"down",
						"circle-bottom",
						"arrow"
					],
					"defaultCode": 60905,
					"grid": 16
				},
				{
					"id": 3077,
					"paths": [
						"M1024 512c0-282.768-229.23-512-512-512s-512 229.232-512 512c0 282.77 229.23 512 512 512s512-229.228 512-512zM96 512c0-229.75 186.25-416 416-416s416 186.25 416 416c0 229.75-186.25 416-416 416s-416-186.248-416-416z",
						"M256 544l256 256 256-256-96-96-96 96v-288h-128v288l-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down",
						"down",
						"circle-bottom",
						"arrow"
					],
					"defaultCode": 60912,
					"grid": 16
				},
				{
					"id": 3085,
					"paths": [
						"M0 512c0 282.77 229.23 512 512 512s512-229.23 512-512-229.23-512-512-512-512 229.23-512 512zM576 192v351.998l128-127.998 96 95.998-288 288.002-288-288.002 96-95.998 128 127.998v-351.998h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down",
						"down",
						"circle-bottom",
						"arrow"
					],
					"defaultCode": 60920,
					"grid": 16
				},
				{
					"id": 3138,
					"paths": [
						"M0 512c0-282.77 229.23-512 512-512s512 229.23 512 512-229.23 512-512 512-512-229.23-512-512zM736 576h-160v-320h-128v320h-160l224 224 224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down",
						"down",
						"circle-bottom",
						"arrow",
						"download"
					],
					"defaultCode": 60973,
					"grid": 16
				},
				{
					"id": 3142,
					"paths": [
						"M0 512c0-282.77 229.23-512 512-512s512 229.23 512 512-229.23 512-512 512-512-229.23-512-512zM896 512c0-212.078-171.922-384-384-384s-384 171.922-384 384c0 212.078 171.922 384 384 384s384-171.922 384-384zM736 576h-160v-320h-128v320h-160l224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-down",
						"down",
						"circle-bottom",
						"arrow",
						"download"
					],
					"defaultCode": 60977,
					"grid": 16
				},
				{
					"id": 3067,
					"paths": [
						"M983.456 712c-2.288 5.386-4.69 10.71-7.156 16h-108.706c3.2-5.256 6.272-10.596 9.242-16h106.62z",
						"M968.528 744c-2.746 5.392-5.602 10.718-8.532 16h-113.984c3.898-5.24 7.678-10.574 11.33-16h111.186z",
						"M950.756 776c-3.258 5.402-6.626 10.73-10.076 16h-121.022c4.748-5.212 9.36-10.55 13.84-16h117.258z",
						"M799.070 936c-8.218 5.576-16.622 10.898-25.172 16h-523.796c-8.55-5.102-16.952-10.424-25.172-16h574.14z",
						"M924.236 568c0.714-5.302 1.33-10.636 1.842-16h95.54v-16h-94.322c0.302-5.306 0.502-10.64 0.604-16h93.718v-16h-93.718c-0.1-5.36-0.302-10.692-0.604-16h94.322v-16h-95.54c-0.512-5.364-1.128-10.698-1.842-16h96.704c2 18.394 3.060 37.072 3.060 56s-1.060 37.606-3.060 56h-96.704z",
						"M905.122 840c-4.532 5.424-9.154 10.77-13.902 16h-145.254c7.484-5.1 14.796-10.436 21.92-16h137.236z",
						"M876.030 872c-5.398 5.458-10.922 10.79-16.558 16h-169.306c10.376-4.926 20.516-10.262 30.398-16h155.466z",
						"M995.764 680c-1.866 5.376-3.82 10.708-5.858 16h-104.742c2.604-5.272 5.102-10.606 7.486-16h103.114z",
						"M356.724 1000h310.552c-20.992 6.674-42.56 12.056-64.628 16h-181.296c-22.068-3.944-43.636-9.326-64.628-16z",
						"M745.064 968c-11.214 5.744-22.672 11.078-34.346 16h-397.434c-11.674-4.922-23.132-10.256-34.346-16h466.126z",
						"M1018.936 584c-0.754 5.36-1.578 10.696-2.498 16h-97.796c1.14-5.298 2.194-10.628 3.132-16h97.162z",
						"M1005.704 648c-1.474 5.366-3.004 10.708-4.648 16h-101.708c2.074-5.28 4.026-10.618 5.886-16h100.47z",
						"M1013.42 616c-1.108 5.368-2.324 10.696-3.598 16h-99.422c1.592-5.292 3.11-10.62 4.494-16h98.526z",
						"M651.506 904h189.822c-6.534 5.494-13.204 10.832-20.010 16h-227.834c19.888-3.952 39.262-9.324 58.022-16z",
						"M1009.822 392c1.274 5.304 2.492 10.632 3.598 16h-98.528c-1.384-5.38-2.902-10.706-4.494-16h99.424z",
						"M1001.056 360c1.644 5.292 3.172 10.634 4.648 16h-100.47c-1.86-5.382-3.812-10.72-5.886-16h101.708z",
						"M918.642 424h97.798c0.918 5.304 1.742 10.64 2.498 16h-97.162c-0.94-5.372-1.992-10.702-3.134-16z",
						"M989.908 328c2.038 5.292 3.992 10.624 5.858 16h-103.114c-2.384-5.394-4.882-10.728-7.486-16h104.742z",
						"M303.438 152h-155.466c5.398-5.458 10.922-10.788 16.558-16h169.306c-10.376 4.926-20.518 10.262-30.398 16z",
						"M303.438 872c9.88 5.738 20.024 11.074 30.398 16h-169.306c-5.636-5.21-11.16-10.542-16.558-16h155.466z",
						"M891.22 168c4.748 5.23 9.372 10.576 13.902 16h-137.238c-7.124-5.566-14.436-10.9-21.92-16h145.256z",
						"M821.316 104c6.806 5.168 13.476 10.504 20.010 16h-189.822c-18.76-6.676-38.134-12.050-58.024-16h227.836z",
						"M976.3 296c2.466 5.29 4.868 10.614 7.156 16h-106.62c-2.968-5.406-6.042-10.746-9.242-16h108.706z",
						"M859.47 136c5.636 5.212 11.162 10.542 16.558 16h-155.466c-9.882-5.738-20.022-11.074-30.398-16h169.306z",
						"M917.942 200c4.048 5.26 8.020 10.582 11.868 16h-125.542c-5.562-5.494-11.282-10.826-17.144-16h130.818z",
						"M959.996 264c2.93 5.282 5.786 10.606 8.532 16h-111.186c-3.652-5.426-7.432-10.76-11.33-16h113.984z",
						"M940.682 232c3.45 5.27 6.818 10.598 10.076 16h-117.258c-4.48-5.45-9.092-10.788-13.84-16h121.022z",
						"M929.81 808c-3.846 5.418-7.818 10.74-11.868 16h-130.82c5.864-5.174 11.582-10.508 17.144-16h125.544z",
						"M372.494 904c18.76 6.676 38.134 12.048 58.026 16h-227.836c-6.806-5.168-13.476-10.506-20.010-16h189.82z",
						"M177.988 264c-3.896 5.24-7.678 10.574-11.33 16h-111.188c2.746-5.394 5.604-10.718 8.534-16h113.984z",
						"M138.834 328c-2.604 5.272-5.1 10.606-7.484 16h-103.116c1.868-5.376 3.82-10.708 5.86-16h104.74z",
						"M156.406 296c-3.2 5.254-6.272 10.594-9.242 16h-106.62c2.288-5.386 4.69-10.71 7.154-16h108.708z",
						"M105.358 424c-1.14 5.298-2.194 10.628-3.13 16h-97.162c0.754-5.36 1.578-10.696 2.496-16h97.796z",
						"M124.65 360c-2.072 5.28-4.024 10.618-5.884 16h-100.47c1.474-5.366 3.006-10.708 4.648-16h101.706z",
						"M113.6 392c-1.592 5.294-3.11 10.62-4.494 16h-98.526c1.108-5.368 2.324-10.696 3.598-16h99.422z",
						"M710.716 40c11.674 4.92 23.132 10.256 34.346 16h-466.126c11.212-5.744 22.67-11.080 34.346-16h397.434z",
						"M236.876 200c-5.864 5.174-11.582 10.506-17.144 16h-125.542c3.846-5.418 7.818-10.74 11.866-16h130.82z",
						"M773.898 72c8.55 5.1 16.954 10.424 25.172 16h-574.14c8.22-5.576 16.622-10.9 25.172-16h523.796z",
						"M602.648 8c22.068 3.942 43.636 9.326 64.628 16h-310.552c20.992-6.674 42.558-12.058 64.626-16h181.298z",
						"M430.52 104c-19.89 3.95-39.266 9.324-58.026 16h-189.82c6.534-5.496 13.204-10.832 20.010-16h227.836z",
						"M278.036 168c-7.484 5.1-14.796 10.434-21.92 16h-137.236c4.53-5.424 9.154-10.77 13.902-16h145.254z",
						"M204.34 232c-4.746 5.212-9.36 10.55-13.84 16h-117.258c3.258-5.402 6.626-10.73 10.076-16h121.022z",
						"M190.5 776c4.48 5.45 9.094 10.788 13.84 16h-121.022c-3.45-5.27-6.818-10.598-10.076-16h117.258z",
						"M166.658 744c3.652 5.426 7.434 10.76 11.33 16h-113.984c-2.93-5.282-5.788-10.608-8.534-16h111.188z",
						"M147.164 712c2.97 5.404 6.042 10.744 9.242 16h-108.708c-2.464-5.29-4.868-10.614-7.154-16h106.62z",
						"M219.732 808c5.562 5.492 11.282 10.826 17.144 16h-130.82c-4.046-5.26-8.020-10.582-11.866-16h125.542z",
						"M131.35 680c2.384 5.394 4.88 10.728 7.484 16h-104.74c-2.040-5.292-3.992-10.624-5.86-16h103.116z",
						"M99.764 456c-0.712 5.302-1.33 10.636-1.842 16h-96.376c0.414-5.36 0.936-10.688 1.514-16h96.704z",
						"M256.116 840c7.124 5.564 14.436 10.9 21.92 16h-145.254c-4.748-5.23-9.374-10.576-13.902-16h137.236z",
						"M97.922 552c0.512 5.364 1.128 10.698 1.842 16h-96.704c-0.578-5.312-1.1-10.64-1.514-16h96.376z",
						"M96.102 520c0.102 5.36 0.302 10.694 0.604 16h-96.128c-0.244-5.312-0.392-10.648-0.474-16h95.998z",
						"M118.766 648c1.862 5.382 3.812 10.72 5.884 16h-101.708c-1.642-5.292-3.174-10.634-4.648-16h100.472z",
						"M96.706 488c-0.3 5.308-0.502 10.64-0.604 16h-96c0.082-5.352 0.23-10.688 0.474-16h96.13z",
						"M109.106 616c1.384 5.38 2.902 10.708 4.494 16h-99.422c-1.274-5.304-2.49-10.632-3.598-16h98.526z",
						"M102.226 584c0.938 5.372 1.99 10.702 3.13 16h-97.796c-0.918-5.304-1.742-10.64-2.496-16h97.162z",
						"M669.256 706.744l-90.512 90.512-285.254-285.256 285.256-285.254 90.508 90.508-194.744 194.746z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-left",
						"left",
						"circle-previous",
						"arrow",
						"dualtone"
					],
					"defaultCode": 60902,
					"grid": 16
				},
				{
					"id": 3071,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416z",
						"M669.256 317.256l-90.512-90.512-285.254 285.256 285.256 285.254 90.508-90.508-194.744-194.746z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-left",
						"left",
						"circle-previous",
						"arrow"
					],
					"defaultCode": 60906,
					"grid": 16
				},
				{
					"id": 3079,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512c-282.77 0-512 229.23-512 512s229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416c-229.75 0-416-186.25-416-416s186.25-416 416-416z",
						"M480 256l-256 256 256 256 96-96-96-96h288v-128h-288l96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-left",
						"left",
						"circle-previous",
						"arrow"
					],
					"defaultCode": 60914,
					"grid": 16
				},
				{
					"id": 3087,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM832 576h-351.998l127.998 128-95.998 96-288.002-288 288.002-288 95.998 96-127.998 128h351.998v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-left",
						"left",
						"circle-previous",
						"arrow"
					],
					"defaultCode": 60922,
					"grid": 16
				},
				{
					"id": 3139,
					"paths": [
						"M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512-512-229.23-512-512 229.23-512 512-512zM448 736v-160h320v-128h-320v-160l-224 224 224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-left",
						"left",
						"circle-previous",
						"arrow"
					],
					"defaultCode": 60974,
					"grid": 16
				},
				{
					"id": 3143,
					"paths": [
						"M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512-512-229.23-512-512 229.23-512 512-512zM512 896c212.078 0 384-171.922 384-384s-171.922-384-384-384c-212.078 0-384 171.922-384 384s171.922 384 384 384zM448 736v-160h320v-128h-320v-160l-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-left",
						"left",
						"circle-previous",
						"arrow"
					],
					"defaultCode": 60978,
					"grid": 16
				},
				{
					"id": 225,
					"paths": [
						"M830.338 193.664c-91.869-91.869-214.016-142.464-343.938-142.464s-252.067 50.595-343.936 142.464-142.464 214.014-142.464 343.936 50.595 252.069 142.464 343.938 214.014 142.462 343.936 142.462 252.069-50.594 343.938-142.462 142.462-214.016 142.462-343.938-50.594-252.067-142.462-343.936zM486.4 972.8c-239.97 0-435.2-195.23-435.2-435.2s195.23-435.2 435.2-435.2c239.97 0 435.2 195.23 435.2 435.2s-195.23 435.2-435.2 435.2z",
						"M793.6 563.2h-614.4c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h614.4c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-minus",
						"minus"
					],
					"defaultCode": 59522,
					"grid": 20
				},
				{
					"id": 1419,
					"width": 877.7139282226562,
					"paths": [
						"M438.857 201.143q-84.571 0-156 41.714t-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156-41.714-156-113.143-113.143-156-41.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-o"
					],
					"defaultCode": 61708,
					"grid": 14
				},
				{
					"id": 1599,
					"width": 1023.9979553222656,
					"paths": [
						"M1005.714 512q0 100.571-39.143 192t-105.143 157.429-157.429 105.143-192 39.143-192-39.143-157.429-105.143-105.143-157.429-39.143-192q0-121.714 55.429-227.714t151.429-174.571 213.714-86.286v130.286q-126.286 25.714-209.429 126.286t-83.143 232q0 74.286 29.143 142t78 116.571 116.571 78 142 29.143 142-29.143 116.571-78 78-116.571 29.143-142q0-131.429-83.143-232t-209.429-126.286v-130.286q117.714 17.714 213.714 86.286t151.429 174.571 55.429 227.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-o-notch"
					],
					"defaultCode": 61902,
					"grid": 14
				},
				{
					"id": 3065,
					"paths": [
						"M40.544 712c2.288 5.386 4.69 10.71 7.156 16h108.706c-3.2-5.256-6.272-10.596-9.242-16h-106.62z",
						"M55.472 744c2.746 5.392 5.602 10.718 8.532 16h113.984c-3.898-5.24-7.678-10.574-11.33-16h-111.186z",
						"M73.244 776c3.258 5.402 6.626 10.73 10.076 16h121.022c-4.748-5.212-9.36-10.55-13.84-16h-117.258z",
						"M224.93 936c8.218 5.576 16.622 10.898 25.172 16h523.796c8.55-5.102 16.952-10.424 25.172-16h-574.14z",
						"M99.764 568c-0.714-5.302-1.33-10.636-1.842-16h-95.54v-16h94.322c-0.302-5.306-0.502-10.64-0.604-16h-93.718v-16h93.718c0.1-5.36 0.302-10.692 0.604-16h-94.322v-16h95.54c0.512-5.364 1.128-10.698 1.842-16h-96.704c-2 18.394-3.060 37.072-3.060 56s1.060 37.606 3.060 56h96.704z",
						"M118.878 840c4.532 5.424 9.154 10.77 13.902 16h145.254c-7.484-5.1-14.796-10.436-21.92-16h-137.236z",
						"M147.97 872c5.398 5.458 10.922 10.79 16.558 16h169.306c-10.376-4.926-20.516-10.262-30.398-16h-155.466z",
						"M28.236 680c1.866 5.376 3.82 10.708 5.858 16h104.742c-2.604-5.272-5.102-10.606-7.486-16h-103.114z",
						"M667.276 1000h-310.552c20.992 6.674 42.56 12.056 64.628 16h181.296c22.068-3.944 43.636-9.326 64.628-16z",
						"M278.936 968c11.214 5.744 22.672 11.078 34.346 16h397.434c11.674-4.922 23.132-10.256 34.346-16h-466.126z",
						"M5.064 584c0.754 5.36 1.578 10.696 2.498 16h97.796c-1.14-5.298-2.194-10.628-3.132-16h-97.162z",
						"M18.296 648c1.474 5.366 3.004 10.708 4.648 16h101.708c-2.074-5.28-4.026-10.618-5.886-16h-100.47z",
						"M10.58 616c1.108 5.368 2.324 10.696 3.598 16h99.422c-1.592-5.292-3.11-10.62-4.494-16h-98.526z",
						"M372.494 904h-189.822c6.534 5.494 13.204 10.832 20.010 16h227.834c-19.888-3.952-39.262-9.324-58.022-16z",
						"M14.178 392c-1.274 5.304-2.492 10.632-3.598 16h98.528c1.384-5.38 2.902-10.706 4.494-16h-99.424z",
						"M22.944 360c-1.644 5.292-3.172 10.634-4.648 16h100.47c1.86-5.382 3.812-10.72 5.886-16h-101.708z",
						"M105.358 424h-97.798c-0.918 5.304-1.742 10.64-2.498 16h97.162c0.94-5.372 1.992-10.702 3.134-16z",
						"M34.092 328c-2.038 5.292-3.992 10.624-5.858 16h103.114c2.384-5.394 4.882-10.728 7.486-16h-104.742z",
						"M720.562 152h155.466c-5.398-5.458-10.922-10.788-16.558-16h-169.306c10.376 4.926 20.518 10.262 30.398 16z",
						"M720.562 872c-9.88 5.738-20.024 11.074-30.398 16h169.306c5.636-5.21 11.16-10.542 16.558-16h-155.466z",
						"M132.78 168c-4.748 5.23-9.372 10.576-13.902 16h137.238c7.124-5.566 14.436-10.9 21.92-16h-145.256z",
						"M202.684 104c-6.806 5.168-13.476 10.504-20.010 16h189.822c18.76-6.676 38.134-12.050 58.024-16h-227.836z",
						"M47.7 296c-2.466 5.29-4.868 10.614-7.156 16h106.62c2.968-5.406 6.042-10.746 9.242-16h-108.706z",
						"M164.53 136c-5.636 5.212-11.162 10.542-16.558 16h155.466c9.882-5.738 20.022-11.074 30.398-16h-169.306z",
						"M106.058 200c-4.048 5.26-8.020 10.582-11.868 16h125.542c5.562-5.494 11.282-10.826 17.144-16h-130.818z",
						"M64.004 264c-2.93 5.282-5.786 10.606-8.532 16h111.186c3.652-5.426 7.432-10.76 11.33-16h-113.984z",
						"M83.318 232c-3.45 5.27-6.818 10.598-10.076 16h117.258c4.48-5.45 9.092-10.788 13.84-16h-121.022z",
						"M94.19 808c3.846 5.418 7.818 10.74 11.868 16h130.82c-5.864-5.174-11.582-10.508-17.144-16h-125.544z",
						"M651.506 904c-18.76 6.676-38.134 12.048-58.026 16h227.836c6.806-5.168 13.476-10.506 20.010-16h-189.82z",
						"M846.012 264c3.896 5.24 7.678 10.574 11.33 16h111.188c-2.746-5.394-5.604-10.718-8.534-16h-113.984z",
						"M885.166 328c2.604 5.272 5.1 10.606 7.484 16h103.116c-1.868-5.376-3.82-10.708-5.86-16h-104.74z",
						"M867.594 296c3.2 5.254 6.272 10.594 9.242 16h106.62c-2.288-5.386-4.69-10.71-7.154-16h-108.708z",
						"M918.642 424c1.14 5.298 2.194 10.628 3.13 16h97.162c-0.754-5.36-1.578-10.696-2.496-16h-97.796z",
						"M899.35 360c2.072 5.28 4.024 10.618 5.884 16h100.47c-1.474-5.366-3.006-10.708-4.648-16h-101.706z",
						"M910.4 392c1.592 5.294 3.11 10.62 4.494 16h98.526c-1.108-5.368-2.324-10.696-3.598-16h-99.422z",
						"M313.284 40c-11.674 4.92-23.132 10.256-34.346 16h466.126c-11.212-5.744-22.67-11.080-34.346-16h-397.434z",
						"M787.124 200c5.864 5.174 11.582 10.506 17.144 16h125.542c-3.846-5.418-7.818-10.74-11.866-16h-130.82z",
						"M250.102 72c-8.55 5.1-16.954 10.424-25.172 16h574.14c-8.22-5.576-16.622-10.9-25.172-16h-523.796z",
						"M421.352 8c-22.068 3.942-43.636 9.326-64.628 16h310.552c-20.992-6.674-42.558-12.058-64.626-16h-181.298z",
						"M593.48 104c19.89 3.95 39.266 9.324 58.026 16h189.82c-6.534-5.496-13.204-10.832-20.010-16h-227.836z",
						"M745.964 168c7.484 5.1 14.796 10.434 21.92 16h137.236c-4.53-5.424-9.154-10.77-13.902-16h-145.254z",
						"M819.66 232c4.746 5.212 9.36 10.55 13.84 16h117.258c-3.258-5.402-6.626-10.73-10.076-16h-121.022z",
						"M833.5 776c-4.48 5.45-9.094 10.788-13.84 16h121.022c3.45-5.27 6.818-10.598 10.076-16h-117.258z",
						"M857.342 744c-3.652 5.426-7.434 10.76-11.33 16h113.984c2.93-5.282 5.788-10.608 8.534-16h-111.188z",
						"M876.836 712c-2.97 5.404-6.042 10.744-9.242 16h108.708c2.464-5.29 4.868-10.614 7.154-16h-106.62z",
						"M804.268 808c-5.562 5.492-11.282 10.826-17.144 16h130.82c4.046-5.26 8.020-10.582 11.866-16h-125.542z",
						"M892.65 680c-2.384 5.394-4.88 10.728-7.484 16h104.74c2.040-5.292 3.992-10.624 5.86-16h-103.116z",
						"M924.236 456c0.712 5.302 1.33 10.636 1.842 16h96.376c-0.414-5.36-0.936-10.688-1.514-16h-96.704z",
						"M767.884 840c-7.124 5.564-14.436 10.9-21.92 16h145.254c4.748-5.23 9.374-10.576 13.902-16h-137.236z",
						"M926.078 552c-0.512 5.364-1.128 10.698-1.842 16h96.704c0.578-5.312 1.1-10.64 1.514-16h-96.376z",
						"M927.898 520c-0.102 5.36-0.302 10.694-0.604 16h96.128c0.244-5.312 0.392-10.648 0.474-16h-95.998z",
						"M905.234 648c-1.862 5.382-3.812 10.72-5.884 16h101.708c1.642-5.292 3.174-10.634 4.648-16h-100.472z",
						"M927.294 488c0.3 5.308 0.502 10.64 0.604 16h96c-0.082-5.352-0.23-10.688-0.474-16h-96.13z",
						"M914.894 616c-1.384 5.38-2.902 10.708-4.494 16h99.422c1.274-5.304 2.49-10.632 3.598-16h-98.526z",
						"M921.774 584c-0.938 5.372-1.99 10.702-3.13 16h97.796c0.918-5.304 1.742-10.64 2.496-16h-97.162z",
						"M354.744 706.744l90.512 90.512 285.254-285.256-285.256-285.254-90.508 90.508 194.744 194.746z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-right",
						"right",
						"circle-next",
						"arrow",
						"dualtone"
					],
					"defaultCode": 60900,
					"grid": 16
				},
				{
					"id": 3069,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z",
						"M354.744 706.744l90.512 90.512 285.254-285.256-285.256-285.254-90.508 90.508 194.744 194.746z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-right",
						"right",
						"circle-next",
						"arrow"
					],
					"defaultCode": 60904,
					"grid": 16
				},
				{
					"id": 3075,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z",
						"M544 768l256-256-256-256-96 96 96 96h-288v128h288l-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-right",
						"right",
						"circle-next",
						"arrow"
					],
					"defaultCode": 60910,
					"grid": 16
				},
				{
					"id": 3083,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM192 448h351.998l-127.998-128 95.998-96 288.002 288-288.002 288-95.998-96 127.998-128h-351.998v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-right",
						"right",
						"circle-next",
						"arrow"
					],
					"defaultCode": 60918,
					"grid": 16
				},
				{
					"id": 3137,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576 736v-160h-320v-128h320v-160l224 224-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-right",
						"right",
						"circle-next",
						"arrow"
					],
					"defaultCode": 60972,
					"grid": 16
				},
				{
					"id": 3141,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM576 736v-160h-320v-128h320v-160l224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-right",
						"right",
						"circle-next",
						"arrow"
					],
					"defaultCode": 60976,
					"grid": 16
				},
				{
					"id": 2688,
					"paths": [
						"M320 512c0-106.039 85.961-192 192-192s192 85.961 192 192c0 106.039-85.961 192-192 192s-192-85.961-192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-small"
					],
					"defaultCode": 60523,
					"grid": 16
				},
				{
					"id": 1611,
					"width": 877.7139282226562,
					"paths": [
						"M438.857 146.286q-74.286 0-142 29.143t-116.571 78-78 116.571-29.143 142 29.143 142 78 116.571 116.571 78 142 29.143 142-29.143 116.571-78 78-116.571 29.143-142-29.143-142-78-116.571-116.571-78-142-29.143zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-thin"
					],
					"defaultCode": 61915,
					"grid": 14
				},
				{
					"id": 3064,
					"paths": [
						"M712 983.456c5.386-2.288 10.71-4.69 16-7.156v-108.706c-5.256 3.2-10.596 6.272-16 9.242v106.62z",
						"M744 968.528c5.392-2.746 10.718-5.602 16-8.532v-113.984c-5.24 3.898-10.574 7.678-16 11.33v111.186z",
						"M776 950.756c5.402-3.258 10.73-6.626 16-10.076v-121.022c-5.212 4.748-10.55 9.36-16 13.84v117.258z",
						"M936 799.070c5.576-8.218 10.898-16.622 16-25.172v-523.796c-5.102-8.55-10.424-16.952-16-25.172v574.14z",
						"M568 924.236c-5.302 0.714-10.636 1.33-16 1.842v95.54h-16v-94.322c-5.306 0.302-10.64 0.502-16 0.604v93.718h-16v-93.718c-5.36-0.1-10.692-0.302-16-0.604v94.322h-16v-95.54c-5.364-0.512-10.698-1.128-16-1.842v96.704c18.394 2 37.072 3.060 56 3.060s37.606-1.060 56-3.060v-96.704z",
						"M840 905.122c5.424-4.532 10.77-9.154 16-13.902v-145.254c-5.1 7.484-10.436 14.796-16 21.92v137.236z",
						"M872 876.030c5.458-5.398 10.79-10.922 16-16.558v-169.306c-4.926 10.376-10.262 20.516-16 30.398v155.466z",
						"M680 995.764c5.376-1.866 10.708-3.82 16-5.858v-104.742c-5.272 2.604-10.606 5.102-16 7.486v103.114z",
						"M1000 356.724v310.552c6.674-20.992 12.056-42.56 16-64.628v-181.296c-3.944-22.068-9.326-43.636-16-64.628z",
						"M968 745.064c5.744-11.214 11.078-22.672 16-34.346v-397.434c-4.922-11.674-10.256-23.132-16-34.346v466.126z",
						"M584 1018.936c5.36-0.754 10.696-1.578 16-2.498v-97.796c-5.298 1.14-10.628 2.194-16 3.132v97.162z",
						"M648 1005.704c5.366-1.474 10.708-3.004 16-4.648v-101.708c-5.28 2.074-10.618 4.026-16 5.886v100.47z",
						"M616 1013.42c5.368-1.108 10.696-2.324 16-3.598v-99.422c-5.292 1.592-10.62 3.11-16 4.494v98.526z",
						"M904 651.506v189.822c5.494-6.534 10.832-13.204 16-20.010v-227.834c-3.952 19.888-9.324 39.262-16 58.022z",
						"M392 1009.822c5.304 1.274 10.632 2.492 16 3.598v-98.528c-5.38-1.384-10.706-2.902-16-4.494v99.424z",
						"M360 1001.056c5.292 1.644 10.634 3.172 16 4.648v-100.47c-5.382-1.86-10.72-3.812-16-5.886v101.708z",
						"M424 918.642v97.798c5.304 0.918 10.64 1.742 16 2.498v-97.162c-5.372-0.94-10.702-1.992-16-3.134z",
						"M328 989.908c5.292 2.038 10.624 3.992 16 5.858v-103.114c-5.394-2.384-10.728-4.882-16-7.486v104.742z",
						"M152 303.438v-155.466c-5.458 5.398-10.788 10.922-16 16.558v169.306c4.926-10.376 10.262-20.518 16-30.398z",
						"M872 303.438c5.738 9.88 11.074 20.024 16 30.398v-169.306c-5.21-5.636-10.542-11.16-16-16.558v155.466z",
						"M168 891.22c5.23 4.748 10.576 9.372 16 13.902v-137.238c-5.566-7.124-10.9-14.436-16-21.92v145.256z",
						"M104 821.316c5.168 6.806 10.504 13.476 16 20.010v-189.822c-6.676-18.76-12.050-38.134-16-58.024v227.836z",
						"M296 976.3c5.29 2.466 10.614 4.868 16 7.156v-106.62c-5.406-2.968-10.746-6.042-16-9.242v108.706z",
						"M136 859.47c5.212 5.636 10.542 11.162 16 16.558v-155.466c-5.738-9.882-11.074-20.022-16-30.398v169.306z",
						"M200 917.942c5.26 4.048 10.582 8.020 16 11.868v-125.542c-5.494-5.562-10.826-11.282-16-17.144v130.818z",
						"M264 959.996c5.282 2.93 10.606 5.786 16 8.532v-111.186c-5.426-3.652-10.76-7.432-16-11.33v113.984z",
						"M232 940.682c5.27 3.45 10.598 6.818 16 10.076v-117.258c-5.45-4.48-10.788-9.092-16-13.84v121.022z",
						"M808 929.81c5.418-3.846 10.74-7.818 16-11.868v-130.82c-5.174 5.864-10.508 11.582-16 17.144v125.544z",
						"M904 372.494c6.676 18.76 12.048 38.134 16 58.026v-227.836c-5.168-6.806-10.506-13.476-16-20.010v189.82z",
						"M264 177.988c5.24-3.896 10.574-7.678 16-11.33v-111.188c-5.394 2.746-10.718 5.604-16 8.534v113.984z",
						"M328 138.834c5.272-2.604 10.606-5.1 16-7.484v-103.116c-5.376 1.868-10.708 3.82-16 5.86v104.74z",
						"M296 156.406c5.254-3.2 10.594-6.272 16-9.242v-106.62c-5.386 2.288-10.71 4.69-16 7.154v108.708z",
						"M424 105.358c5.298-1.14 10.628-2.194 16-3.13v-97.162c-5.36 0.754-10.696 1.578-16 2.496v97.796z",
						"M360 124.65c5.28-2.072 10.618-4.024 16-5.884v-100.47c-5.366 1.474-10.708 3.006-16 4.648v101.706z",
						"M392 113.6c5.294-1.592 10.62-3.11 16-4.494v-98.526c-5.368 1.108-10.696 2.324-16 3.598v99.422z",
						"M40 710.716c4.92 11.674 10.256 23.132 16 34.346v-466.126c-5.744 11.212-11.080 22.67-16 34.346v397.434z",
						"M200 236.876c5.174-5.864 10.506-11.582 16-17.144v-125.542c-5.418 3.846-10.74 7.818-16 11.866v130.82z",
						"M72 773.898c5.1 8.55 10.424 16.954 16 25.172v-574.14c-5.576 8.22-10.9 16.622-16 25.172v523.796z",
						"M8 602.648c3.942 22.068 9.326 43.636 16 64.628v-310.552c-6.674 20.992-12.058 42.558-16 64.626v181.298z",
						"M104 430.52c3.95-19.89 9.324-39.266 16-58.026v-189.82c-5.496 6.534-10.832 13.204-16 20.010v227.836z",
						"M168 278.036c5.1-7.484 10.434-14.796 16-21.92v-137.236c-5.424 4.53-10.77 9.154-16 13.902v145.254z",
						"M232 204.34c5.212-4.746 10.55-9.36 16-13.84v-117.258c-5.402 3.258-10.73 6.626-16 10.076v121.022z",
						"M776 190.5c5.45 4.48 10.788 9.094 16 13.84v-121.022c-5.27-3.45-10.598-6.818-16-10.076v117.258z",
						"M744 166.658c5.426 3.652 10.76 7.434 16 11.33v-113.984c-5.282-2.93-10.608-5.788-16-8.534v111.188z",
						"M712 147.164c5.404 2.97 10.744 6.042 16 9.242v-108.708c-5.29-2.464-10.614-4.868-16-7.154v106.62z",
						"M808 219.732c5.492 5.562 10.826 11.282 16 17.144v-130.82c-5.26-4.046-10.582-8.020-16-11.866v125.542z",
						"M680 131.35c5.394 2.384 10.728 4.88 16 7.484v-104.74c-5.292-2.040-10.624-3.992-16-5.86v103.116z",
						"M456 99.764c5.302-0.712 10.636-1.33 16-1.842v-96.376c-5.36 0.414-10.688 0.936-16 1.514v96.704z",
						"M840 256.116c5.564 7.124 10.9 14.436 16 21.92v-145.254c-5.23-4.748-10.576-9.374-16-13.902v137.236z",
						"M552 97.922c5.364 0.512 10.698 1.128 16 1.842v-96.704c-5.312-0.578-10.64-1.1-16-1.514v96.376z",
						"M520 96.102c5.36 0.102 10.694 0.302 16 0.604v-96.128c-5.312-0.244-10.648-0.392-16-0.474v95.998z",
						"M648 118.766c5.382 1.862 10.72 3.812 16 5.884v-101.708c-5.292-1.642-10.634-3.174-16-4.648v100.472z",
						"M488 96.706c5.308-0.3 10.64-0.502 16-0.604v-96c-5.352 0.082-10.688 0.23-16 0.474v96.13z",
						"M616 109.106c5.38 1.384 10.708 2.902 16 4.494v-99.422c-5.304-1.274-10.632-2.49-16-3.598v98.526z",
						"M584 102.226c5.372 0.938 10.702 1.99 16 3.13v-97.796c-5.304-0.918-10.64-1.742-16-2.496v97.162z",
						"M706.744 669.256l90.512-90.512-285.256-285.254-285.254 285.256 90.508 90.508 194.746-194.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up",
						"up",
						"circle-top",
						"arrow",
						"dualtone"
					],
					"defaultCode": 60899,
					"grid": 16
				},
				{
					"id": 3072,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416z",
						"M320 704h127.998v-165.492l207.53 207.53 90.512-90.51-207.532-207.532h165.492v-127.996h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up-left",
						"up-left",
						"circle-top-left",
						"arrow"
					],
					"defaultCode": 60907,
					"grid": 16
				},
				{
					"id": 3080,
					"paths": [
						"M0 512c0 282.77 229.23 512 512 512s512-229.23 512-512-229.23-512-512-512-512 229.23-512 512zM704 320v127.996h-165.492l207.532 207.532-90.512 90.51-207.53-207.53v165.492h-127.998v-384h384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up-left",
						"up-left",
						"circle-top-left",
						"arrow"
					],
					"defaultCode": 60915,
					"grid": 16
				},
				{
					"id": 3074,
					"paths": [
						"M0 512c0 282.77 229.23 512 512 512s512-229.23 512-512-229.23-512-512-512-512 229.23-512 512zM928 512c0 229.75-186.25 416-416 416s-416-186.25-416-416 186.25-416 416-416 416 186.25 416 416z",
						"M320 320v127.998h165.492l-207.53 207.53 90.51 90.512 207.532-207.532v165.492h127.996v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up-right",
						"up-right",
						"circle-top-right",
						"arrow"
					],
					"defaultCode": 60909,
					"grid": 16
				},
				{
					"id": 3082,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM704 704h-127.996v-165.492l-207.532 207.532-90.51-90.512 207.53-207.53h-165.492v-127.998h384v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up-right",
						"up-right",
						"circle-top-right",
						"arrow"
					],
					"defaultCode": 60917,
					"grid": 16
				},
				{
					"id": 3068,
					"paths": [
						"M0 512c0 282.77 229.23 512 512 512s512-229.23 512-512-229.23-512-512-512-512 229.23-512 512zM928 512c0 229.75-186.25 416-416 416s-416-186.25-416-416 186.25-416 416-416 416 186.25 416 416z",
						"M706.744 669.256l90.512-90.512-285.256-285.254-285.254 285.256 90.508 90.508 194.746-194.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up",
						"up",
						"circle-top",
						"arrow"
					],
					"defaultCode": 60903,
					"grid": 16
				},
				{
					"id": 3073,
					"paths": [
						"M0 512c0 282.77 229.23 512 512 512s512-229.23 512-512-229.23-512-512-512-512 229.23-512 512zM928 512c0 229.75-186.25 416-416 416s-416-186.25-416-416 186.25-416 416-416 416 186.25 416 416z",
						"M768 480l-256-256-256 256 96 96 96-96v288h128v-288l96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up",
						"up",
						"circle-top",
						"arrow"
					],
					"defaultCode": 60908,
					"grid": 16
				},
				{
					"id": 3081,
					"paths": [
						"M1024 512c0-282.77-229.23-512-512-512s-512 229.23-512 512 229.23 512 512 512 512-229.23 512-512zM448 832v-351.998l-128 127.998-96-95.998 288-288 288 288-96 95.998-128-127.998v351.998h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up",
						"up",
						"circle-top",
						"arrow"
					],
					"defaultCode": 60916,
					"grid": 16
				},
				{
					"id": 3136,
					"paths": [
						"M0 512c0 282.77 229.23 512 512 512s512-229.23 512-512-229.23-512-512-512-512 229.23-512 512zM736 448h-160v320h-128v-320h-160l224-224 224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up",
						"up",
						"circle-top",
						"arrow",
						"upload"
					],
					"defaultCode": 60971,
					"grid": 16
				},
				{
					"id": 3140,
					"paths": [
						"M0 512c0 282.77 229.23 512 512 512s512-229.23 512-512-229.23-512-512-512-512 229.23-512 512zM896 512c0 212.078-171.922 384-384 384s-384-171.922-384-384c0-212.078 171.922-384 384-384s384 171.922 384 384zM736 448h-160v320h-128v-320h-160l224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle-up",
						"up",
						"circle-top",
						"arrow",
						"upload"
					],
					"defaultCode": 60975,
					"grid": 16
				},
				{
					"id": 3213,
					"paths": [
						"M0 512c0-282.77 229.23-512 512-512s512 229.23 512 512c0 282.77-229.23 512-512 512s-512-229.23-512-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle"
					],
					"defaultCode": 61048,
					"grid": 16
				},
				{
					"id": 1423,
					"width": 877.7139282226562,
					"paths": [
						"M877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circle"
					],
					"defaultCode": 61713,
					"grid": 14
				},
				{
					"id": 3214,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 832c-176.73 0-320-143.27-320-320s143.27-320 320-320 320 143.27 320 320-143.27 320-320 320z",
						"M752 512c0 132.548-107.452 240-240 240s-240-107.452-240-240c0-132.548 107.452-240 240-240s240 107.452 240 240z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circles",
						"record",
						"radio-checked"
					],
					"defaultCode": 61049,
					"grid": 16
				},
				{
					"id": 3215,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 832c-176.73 0-320-143.27-320-320s143.27-320 320-320 320 143.27 320 320-143.27 320-320 320z",
						"M512 336c97.046 0 176 78.954 176 176s-78.954 176-176 176-176-78.954-176-176 78.954-176 176-176zM512 272c-132.548 0-240 107.452-240 240s107.452 240 240 240c132.548 0 240-107.452 240-240s-107.452-240-240-240v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"circles",
						"record",
						"radio-unchecked"
					],
					"defaultCode": 61050,
					"grid": 16
				},
				{
					"id": 1823,
					"paths": [
						"M992 256h-32v-96c0-17.672-14.326-32-32-32h-96v-96c0-17.672-14.326-32-32-32s-32 14.328-32 32v96h-96c-17.674 0-32 14.328-32 32v96h-32c-17.674 0-32 14.328-32 32v160h192c35.348 0 64 28.654 64 64v448h-64v-416c0-17.674-14.326-32-32-32h-384c-17.672 0-32 14.326-32 32v416h-64v-448c0-35.346 28.654-64 64-64h128v-288c0-17.672-14.328-32-32-32h-384c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h960c17.674 0 32-14.326 32-32v-704c0-17.672-14.326-32-32-32zM704 384h-64v-64h64v64zM320 192h64v64h-64v-64zM320 320h64v64h-64v-64zM192 192h64v64h-64v-64zM128 768h-64v-64h64v64zM128 640h-64v-64h64v64zM128 512h-64v-64h64v64zM128 384h-64v-64h64v64zM128 256h-64v-64h64v64zM192 320h64v64h-64v-64zM704 960h-320v-384h320v384zM832 384h-64v-64h64v64zM960 768h-64v-128h64v128zM960 576h-64v-128h64v128zM960 384h-64v-64h64v64z",
						"M448 640h64v64h-64v-64z",
						"M576 640h64v64h-64v-64z",
						"M448 768h64v64h-64v-64z",
						"M576 768h64v64h-64v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"city",
						"buildings",
						"office",
						"work"
					],
					"defaultCode": 59658,
					"grid": 16
				},
				{
					"id": 1903,
					"paths": [
						"M64 128c-35.346 0-64 28.654-64 64v256h1024v-320h-960zM64 384v-32l160-160h128l-192 192h-96zM288 384l192-192h128l-192 192h-128zM544 384l192-192h128l-192 192h-128zM960 352l-32 32h-128l160-160v128z",
						"M0 512h1024v512h-1024v-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clapboard",
						"video",
						"cinema",
						"movie",
						"play",
						"media"
					],
					"defaultCode": 59738,
					"grid": 16
				},
				{
					"id": 1902,
					"paths": [
						"M78.302 262.54l865.444-231.884 49.69 185.452-865.444 231.884zM128 448v576h896v-576h-896zM448 896v-320l256 160-256 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clapboard-play",
						"video",
						"cinema",
						"movie",
						"play",
						"media"
					],
					"defaultCode": 59737,
					"grid": 16
				},
				{
					"id": 367,
					"width": 1024,
					"paths": [
						"M829.696 618.208l-5.92-14.784c-15.264-38.144-15.264-80.704 0-118.848l15.712-39.232c9.728-24.288 14.336-50.56 11.616-76.576-8.896-84.896-79.2-144.768-159.424-144.768h-51.68v-64c0-17.664-14.336-32-32-32h-32v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v64h-32c-17.664 0-32 14.336-32 32v64h-47.936c-45.984 0-90.976 17.792-121.824 51.872-42.56 47.040-52.704 111.968-30.496 167.552l16.448 41.152c15.264 38.144 15.264 80.704 0 118.848l-5.92 14.816c-22.624 56.672-34.272 117.152-34.272 178.208v99.552c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-99.552c0-61.056-11.648-121.536-34.304-178.24zM480 64h64v64h-64v-64zM416 160h192v64h-192v-64zM237.984 297.344c23.776-26.272 59.52-41.344 98.080-41.344h355.616c65.792 0 120.64 49.92 127.584 116.096 2.048 19.488-1.248 40.704-9.504 61.344l-15.712 39.232c-5.12 12.8-8.48 25.984-10.752 39.328h-88.736c-20.256-93.792-75.168-160-182.592-160s-162.336 66.208-182.592 160h-88.704c-2.272-13.312-5.632-26.496-10.752-39.296l-16.448-41.152c-18.304-45.824-8.928-97.248 24.512-134.208zM672 608c0 148.64-53.824 224-160 224s-160-75.36-160-224c0-148.64 53.824-224 160-224s160 75.36 160 224zM832 896c0 35.296-28.704 64-64 64h-512c-35.296 0-64-28.704-64-64v-99.552c0-57.248 10.784-113.184 32.032-166.336l5.92-14.816c9.184-22.976 13.792-47.136 13.792-71.296h80.32c-2.656 20.48-4.064 41.856-4.064 64 0 141.376 50.624 256 192 256s192-114.624 192-256c0-22.144-1.408-43.52-4.032-64h80.32c0 24.16 4.608 48.32 13.792 71.296l5.92 14.784c21.216 53.152 32 109.12 32 166.368v99.552z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clean",
						"cleanse",
						"scrub",
						"wash",
						"rinse"
					],
					"grid": 32
				},
				{
					"id": 368,
					"width": 1024,
					"paths": [
						"M416 48c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16v32h-128v-32h-16c-8.832 0-16-7.168-16-16zM200.224 484.576c3.584 8.928 6.144 18.112 8.032 27.424h121.152c20.256-93.792 75.168-160 182.592-160s162.336 66.208 182.592 160h121.152c1.888-9.312 4.48-18.496 8.032-27.424l15.712-39.232c9.728-24.288 14.336-50.56 11.616-76.576-8.896-84.896-79.2-144.768-159.424-144.768h-51.68v-64c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v64h-47.968c-45.952 0-90.944 17.792-121.792 51.872-42.56 47.040-52.704 111.968-30.496 167.552l16.48 41.152zM829.696 618.208l-5.92-14.784c-7.616-19.072-11.424-39.264-11.424-59.424h-112.384c2.624 20.48 4.032 41.856 4.032 64 0 141.376-50.624 256-192 256s-192-114.624-192-256c0-22.144 1.408-43.52 4.032-64h-112.352c0 20.16-3.808 40.352-11.424 59.424l-5.92 14.816c-22.688 56.672-34.336 117.152-34.336 178.208v99.552c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-99.552c0-61.056-11.648-121.536-34.304-178.24zM512 384c-106.176 0-160 75.36-160 224s53.824 224 160 224 160-75.36 160-224c0-148.64-53.824-224-160-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clean",
						"cleanse",
						"scrub",
						"wash",
						"rinse"
					],
					"grid": 32
				},
				{
					"id": 983,
					"width": 1024,
					"paths": [
						"M896 0h-768c-17.664 0-32 14.336-32 32v960c0 17.664 14.336 32 32 32h768c17.664 0 32-14.336 32-32v-960c0-17.664-14.336-32-32-32zM160 64h192v128h-192v-128zM864 960h-704v-736h704v736zM864 192h-480v-128h480v128zM192 96h128v32h-128v-32zM768 128h-32v-32h32v32zM832 128h-32v-32h32v32zM224 576c0 159.072 128.928 288 288 288s288-128.928 288-288c0-159.072-128.928-288-288-288s-288 128.928-288 288zM512 320c141.152 0 256 114.848 256 256s-114.848 256-256 256-256-114.848-256-256c0-141.152 114.848-256 256-256zM512 800c123.712 0 224-100.288 224-224s-100.288-224-224-224c-123.712 0-224 100.288-224 224s100.288 224 224 224zM512 384c105.856 0 192 86.144 192 192s-86.144 192-192 192-192-86.144-192-192 86.144-192 192-192zM365.696 565.472c9.28 9.28 22.080 13.696 36.416 13.696 24.32 0 53.12-12.768 76.704-36.352 37.504-37.504 47.616-88.16 22.624-113.152-9.28-9.28-22.080-13.728-36.416-13.696-24.32 0-53.12 12.768-76.704 36.352-37.472 37.504-47.616 88.16-22.624 113.152zM384.96 519.872c3.008-15.008 12.48-31.392 25.984-44.896 19.872-19.872 40.96-26.976 54.080-26.976 4.32 0 10.208 0.736 13.792 4.352 4.16 4.16 5.408 12.736 3.36 22.976-3.008 15.008-12.48 31.392-25.984 44.896-19.872 19.872-40.96 26.976-54.080 26.976-4.32 0-10.208-0.768-13.792-4.352-4.128-4.16-5.408-12.736-3.36-22.976z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clean",
						"wash",
						"dry"
					],
					"grid": 32
				},
				{
					"id": 369,
					"width": 1024,
					"paths": [
						"M747.648 427.648l-75.648-75.648v-64c0-17.664-14.336-32-32-32v-64l54.624-54.624c6.016-6.016 9.376-14.144 9.376-22.624v-50.752c0-17.664-14.336-32-32-32h-320c-17.664 0-32 14.336-32 32v40.928c0 13.76 8.8 26.016 21.888 30.368l58.912 19.648-63.648 159.136c-3.296 8.192 0.704 17.504 8.928 20.768 1.92 0.768 3.936 1.152 5.92 1.152 6.336 0 12.352-3.808 14.848-10.048l64.352-160.864 80.8 26.912v64c-17.664 0-32 14.336-32 32v64l-75.648 75.648c-54.016 54.016-84.352 127.264-84.352 203.648v264.704c0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96v-264.704c0-76.384-30.336-149.632-84.352-203.648zM352 104.928v-40.928h320v50.752l-45.28 45.248h-109.536l-165.184-55.072zM608 192v64h-64v-64h64zM512 288h128v64h-128v-64zM426.976 450.272l66.272-66.272h165.504l66.272 66.272c42.816 42.816 68.512 98.144 73.856 157.728h-445.76c5.344-59.584 31.040-114.912 73.856-157.728zM800 896c0 35.296-28.704 64-64 64h-320c-35.296 0-64-28.704-64-64v-256h448v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cleanse",
						"clean",
						"wash",
						"spray"
					],
					"grid": 32
				},
				{
					"id": 370,
					"width": 1024,
					"paths": [
						"M672 352l75.648 75.648c48.48 48.48 77.696 112.512 83.2 180.352h-509.696c5.504-67.84 34.72-131.872 83.2-180.352l75.648-75.648v-64c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32v64zM320 640v256c0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96v-256h-512zM341.888 135.296l58.912 19.648-63.648 159.136c-3.296 8.192 0.704 17.504 8.928 20.768 1.92 0.768 3.936 1.152 5.92 1.152 6.336 0 12.352-3.808 14.848-10.048l64.352-160.864 80.8 26.912v32h128v-32l54.624-54.624c6.016-6.016 9.376-14.144 9.376-22.624v-50.752c0-17.664-14.336-32-32-32h-320c-17.664 0-32 14.336-32 32v40.928c0 13.792 8.8 26.016 21.888 30.368z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cleanse",
						"clean",
						"wash",
						"spray"
					],
					"grid": 32
				},
				{
					"id": 984,
					"width": 1024,
					"paths": [
						"M640 353.952v-65.952c0-17.696-14.304-32-32-32v-32c0-17.696-14.304-32-32-32h-32v-40.512l90.176 8.256c1.952 0.16 3.904 0.256 5.824 0.256 15.904 0 31.296-5.92 43.136-16.736 13.28-12.128 20.864-29.28 20.864-47.264v-32c0-35.36-28.64-64-64-64h-350.016c-34.208 0-62.368 26.912-63.904 61.088-1.568 34.176 24.032 63.52 58.080 66.656l195.84 17.888v46.368h-32c-17.696 0-32 14.304-32 32v32c-17.696 0-32 14.304-32 32v65.728c-125.984 14.784-224 122.176-224 252.032v386.24c0 17.696 14.304 32 32 32h640c17.696 0 32-14.304 32-32v-386.24c0-129.248-97.12-236.224-224-251.808zM640 64v32l-350.016-32h350.016zM576 384h-128v-64h128v64zM480 256h64v32h-64v-32zM800 960h-576v-354.24c0-104.64 85.12-189.76 192-189.76h192v-0.448c0.768 0.064 1.472 0.448 2.24 0.448 104.64 0 189.76 85.12 189.76 189.76v354.24zM608 512h-192c-53.024 0-96 42.976-96 96v64c0 53.024 42.976 96 96 96h192c53.024 0 96-42.976 96-96v-64c0-53.024-42.976-96-96-96zM672 672c0 35.296-28.704 64-64 64h-192c-35.296 0-64-28.704-64-64v-64c0-35.296 28.704-64 64-64h192c35.296 0 64 28.704 64 64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cleanse",
						"scrub",
						"wash",
						"sanitize"
					],
					"grid": 32
				},
				{
					"id": 3266,
					"paths": [
						"M0 896h576v128h-576zM896 128h-302.56l-183.764 704h-132.288l183.762-704h-269.15v-128h704zM929.774 1024l-129.774-129.774-129.774 129.774-62.226-62.226 129.774-129.774-129.774-129.774 62.226-62.226 129.774 129.774 129.774-129.774 62.226 62.226-129.774 129.774 129.774 129.774z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clear-formatting",
						"wysiwyg",
						"remove-style"
					],
					"defaultCode": 61101,
					"grid": 16
				},
				{
					"id": 371,
					"width": 1024,
					"paths": [
						"M736 0c-35.36 0-64 28.64-64 64v64h-320v-64c0-35.36-28.64-64-64-64s-64 28.64-64 64v896c0 35.36 28.64 64 64 64s64-28.64 64-64v-64h320v64c0 35.36 28.64 64 64 64s64-28.64 64-64v-896c0-35.36-28.64-64-64-64zM704 832v32h-384v-32h384zM352 800v-128h320v128h-320zM320 640v-32h384v32h-384zM352 576v-128h320v128h-320zM320 416v-32h384v32h-384zM352 352v-128h320v128h-320zM320 192v-32h384v32h-384zM320 960c0 17.632-14.368 32-32 32s-32-14.368-32-32v-896c0-17.632 14.368-32 32-32s32 14.368 32 32v64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32v128c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32v128c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32v128c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32v64zM768 960c0 17.632-14.368 32-32 32s-32-14.368-32-32v-64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-128c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-128c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-128c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-64c0-17.632 14.368-32 32-32s32 14.368 32 32v896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"climb",
						"ascend",
						"descend"
					],
					"grid": 32
				},
				{
					"id": 372,
					"width": 1024,
					"paths": [
						"M736 0c-35.36 0-64 28.64-64 64v64h-320v-64c0-35.36-28.64-64-64-64s-64 28.64-64 64v896c0 35.36 28.64 64 64 64s64-28.64 64-64v-64h320v64c0 35.36 28.64 64 64 64s64-28.64 64-64v-896c0-35.36-28.64-64-64-64zM352 800v-128h320v128h-320zM352 576v-128h320v128h-320zM352 352v-128h320v128h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"climb",
						"ascend",
						"descend"
					],
					"grid": 32
				},
				{
					"id": 985,
					"width": 1024,
					"paths": [
						"M988.64 977.696l-380.64-761.248v-56.448h96c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v184.448l-192 384-35.392-70.752c-11.808-23.584-45.44-23.584-57.248 0l-224 448c-10.624 21.28 4.832 46.304 28.64 46.304h896c23.808 0 39.264-25.024 28.64-46.304zM608 64h64v32h-64v-32zM576 295.552l60.224 120.448-60.224 120.448-60.224-120.448 60.224-120.448zM288 615.552l28.224 56.448-28.224 56.448-28.224-56.448 28.224-56.448zM115.776 960l126.112-252.224 46.112 92.224 46.112-92.224 126.112 252.224h-344.448zM496 960l-126.112-252.224 128-256 78.112 156.224 78.112-156.224 254.112 508.224h-412.224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"climb",
						"flag",
						"succeed",
						"endeaver"
					],
					"grid": 32
				},
				{
					"id": 2661,
					"paths": [
						"M928 128h-288c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-288c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64zM896 960h-768v-768h128v96c0 17.672 14.328 32 32 32h448c17.674 0 32-14.328 32-32v-96h128v768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clipboard",
						"board"
					],
					"defaultCode": 60496,
					"grid": 16
				},
				{
					"id": 2662,
					"paths": [
						"M928 128h-288c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-288c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64zM896 960h-768v-768h128v96c0 17.672 14.328 32 32 32h448c17.674 0 32-14.328 32-32v-96h128v768z",
						"M448 858.51l-205.254-237.254 58.508-58.51 146.746 114.744 274.742-242.744 58.514 58.508z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clipboard",
						"board",
						"signup",
						"register",
						"agreement"
					],
					"defaultCode": 60497,
					"grid": 16
				},
				{
					"id": 2663,
					"paths": [
						"M928 128h-288c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-288c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64zM896 960h-768v-768h128v96c0 17.672 14.328 32 32 32h448c17.674 0 32-14.328 32-32v-96h128v768z",
						"M736 576h-448c-17.672 0-32-14.328-32-32s14.328-32 32-32h448c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M736 704h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
						"M736 832h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clipboard",
						"board",
						"list"
					],
					"defaultCode": 60498,
					"grid": 16
				},
				{
					"id": 2664,
					"paths": [
						"M256 256h512v-128h-128c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-128v128zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64z",
						"M928 128h-96v160c0 17.672-14.326 32-32 32h-576c-17.672 0-32-14.328-32-32v-160h-96c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clipboard",
						"board"
					],
					"defaultCode": 60499,
					"grid": 16
				},
				{
					"id": 2665,
					"paths": [
						"M256 256h512v-128h-128c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-128v128zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64z",
						"M928 128h-96v160c0 17.672-14.326 32-32 32h-576c-17.672 0-32-14.328-32-32v-160h-96c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32zM448 922.51l-205.254-237.254 58.508-58.51 146.746 114.744 274.742-242.744 58.514 58.508-333.256 365.256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clipboard",
						"board",
						"signup",
						"register",
						"agreement"
					],
					"defaultCode": 60500,
					"grid": 16
				},
				{
					"id": 2666,
					"paths": [
						"M256 256h512v-128h-128c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-128v128zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64z",
						"M928 128h-96v160c0 17.672-14.326 32-32 32h-576c-17.672 0-32-14.328-32-32v-160h-96c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32zM736 832h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32zM736 704h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32zM736 576h-448c-17.672 0-32-14.328-32-32s14.328-32 32-32h448c17.674 0 32 14.328 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clipboard",
						"board",
						"list"
					],
					"defaultCode": 60501,
					"grid": 16
				},
				{
					"id": 1387,
					"width": 1024.0020065307617,
					"paths": [
						"M438.857 950.857h512v-365.714h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-219.429v658.286zM585.143 128v-36.571q0-7.429-5.429-12.857t-12.857-5.429h-402.286q-7.429 0-12.857 5.429t-5.429 12.857v36.571q0 7.429 5.429 12.857t12.857 5.429h402.286q7.429 0 12.857-5.429t5.429-12.857zM731.429 512h170.857l-170.857-170.857v170.857zM1024 585.143v384q0 22.857-16 38.857t-38.857 16h-548.571q-22.857 0-38.857-16t-16-38.857v-91.429h-310.857q-22.857 0-38.857-16t-16-38.857v-768q0-22.857 16-38.857t38.857-16h621.714q22.857 0 38.857 16t16 38.857v187.429q12 7.429 20.571 16l233.143 233.143q16 16 27.429 43.429t11.429 50.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clipboard",
						"paste"
					],
					"defaultCode": 61674,
					"grid": 14
				},
				{
					"id": 2146,
					"paths": [
						"M658.744 749.256l-210.744-210.746v-282.51h128v229.49l173.256 173.254zM512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clock",
						"time",
						"schedule"
					],
					"defaultCode": 59981,
					"grid": 16
				},
				{
					"id": 1201,
					"width": 877.7139282226562,
					"paths": [
						"M512 310.857v256q0 8-5.143 13.143t-13.143 5.143h-182.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h128v-201.143q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143zM749.714 512q0-84.571-41.714-156t-113.143-113.143-156-41.714-156 41.714-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clock-o"
					],
					"defaultCode": 61463,
					"grid": 14
				},
				{
					"id": 2147,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM658.744 749.256l-210.744-210.746v-282.51h128v229.49l173.256 173.254-90.512 90.512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clock",
						"time",
						"schedule"
					],
					"defaultCode": 59982,
					"grid": 16
				},
				{
					"id": 2148,
					"paths": [
						"M768 448v128h-320v-384h128v256zM512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clock",
						"time",
						"schedule"
					],
					"defaultCode": 59983,
					"grid": 16
				},
				{
					"id": 2149,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM768 576h-320v-384h128v256h192v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clock",
						"time",
						"schedule"
					],
					"defaultCode": 59984,
					"grid": 16
				},
				{
					"id": 195,
					"paths": [
						"M835.574 876.171c88.534-91.234 137.226-211.154 137.226-338.571 0-121.352-44.152-235.912-124.834-325.36l35.234-35.237 33.101 33.099c4.997 4.998 11.547 7.498 18.099 7.498s13.102-2.499 18.099-7.499c10-9.997 10-26.206 0-36.203l-102.4-102.4c-9.995-9.998-26.208-9.998-36.205 0s-9.998 26.206 0 36.203l33.102 33.099-35.237 35.235c-89.45-80.683-204.008-124.835-325.36-124.835s-235.91 44.152-325.36 124.835l-35.237-35.235 33.098-33.098c9.998-9.997 9.998-26.206 0-36.203s-26.206-9.998-36.203 0l-102.4 102.4c-9.998 9.997-9.998 26.206 0 36.203 5 4.998 11.55 7.498 18.102 7.498s13.102-2.499 18.101-7.499l33.099-33.098 35.237 35.237c-80.685 89.45-124.837 204.008-124.837 325.36 0 127.418 48.691 247.336 137.226 338.57l-104.128 104.125c-9.998 9.997-9.998 26.21 0 36.205 5 5.002 11.55 7.501 18.102 7.501s13.102-2.499 18.101-7.501l105.448-105.446c87.304 73.114 196.41 112.947 311.651 112.947s224.349-39.834 311.651-112.946l105.443 105.445c5 5 11.554 7.501 18.102 7.501s13.102-2.499 18.099-7.501c10-9.995 10-26.208 0-36.205l-104.122-104.123zM51.2 537.6c0-239.97 195.23-435.2 435.2-435.2s435.2 195.23 435.2 435.2c0 239.97-195.23 435.2-435.2 435.2s-435.2-195.23-435.2-435.2z",
						"M774.611 371.2c-7.069-12.245-22.728-16.435-34.966-9.37l-251.917 145.445-196.344-137.482c-11.582-8.11-27.547-5.294-35.654 6.286-8.11 11.582-5.294 27.546 6.286 35.654l209.702 146.834c0.042 0.030 0.085 0.053 0.126 0.082 0.448 0.309 0.906 0.603 1.37 0.883 0.106 0.064 0.21 0.13 0.315 0.192 0.458 0.264 0.923 0.512 1.394 0.75 0.102 0.051 0.203 0.11 0.307 0.163 0.518 0.25 1.046 0.485 1.579 0.699 0.328 0.133 0.659 0.246 0.99 0.366 0.219 0.075 0.435 0.16 0.656 0.232 0.36 0.117 0.722 0.222 1.085 0.322 0.2 0.056 0.4 0.109 0.6 0.163 0.366 0.091 0.733 0.174 1.101 0.251 0.213 0.042 0.426 0.083 0.64 0.12 0.355 0.064 0.71 0.125 1.067 0.171 0.258 0.035 0.515 0.059 0.774 0.090 0.315 0.034 0.629 0.070 0.944 0.091 0.466 0.034 0.933 0.045 1.4 0.053 0.104 0 0.208 0.011 0.314 0.011 0.005 0 0.011-0.002 0.016-0.002 0.010 0 0.021 0.002 0.030 0.002 0.957 0 1.917-0.062 2.875-0.171 0.045-0.003 0.091-0.006 0.134-0.013 0.93-0.109 1.854-0.28 2.776-0.496 0.086-0.021 0.173-0.035 0.259-0.059 0.867-0.213 1.728-0.472 2.579-0.779 0.146-0.050 0.29-0.104 0.434-0.163 0.795-0.302 1.581-0.637 2.358-1.029 0.184-0.094 0.365-0.197 0.549-0.294 0.269-0.144 0.542-0.278 0.81-0.434l266.043-153.6c12.24-7.069 16.435-22.725 9.366-34.97z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clock",
						"time"
					],
					"defaultCode": 59492,
					"grid": 20
				},
				{
					"id": 1716,
					"width": 1023.9999580383301,
					"paths": [
						"M950.857 932.571v-621.714q0-7.429-5.429-12.857t-12.857-5.429h-621.714q-7.429 0-12.857 5.429t-5.429 12.857v621.714q0 7.429 5.429 12.857t12.857 5.429h621.714q7.429 0 12.857-5.429t5.429-12.857zM1024 310.857v621.714q0 37.714-26.857 64.571t-64.571 26.857h-621.714q-37.714 0-64.571-26.857t-26.857-64.571v-621.714q0-37.714 26.857-64.571t64.571-26.857h621.714q37.714 0 64.571 26.857t26.857 64.571zM804.571 91.429v91.429h-73.143v-91.429q0-7.429-5.429-12.857t-12.857-5.429h-621.714q-7.429 0-12.857 5.429t-5.429 12.857v621.714q0 7.429 5.429 12.857t12.857 5.429h91.429v73.143h-91.429q-37.714 0-64.571-26.857t-26.857-64.571v-621.714q0-37.714 26.857-64.571t64.571-26.857h621.714q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clone"
					],
					"defaultCode": 62029,
					"grid": 14
				},
				{
					"id": 373,
					"width": 1024,
					"paths": [
						"M922.208 389.408c3.84-12.16 5.792-24.672 5.792-37.408 0-70.592-57.408-128-128-128h-9.376l20.672-20.672c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-29.056 29.056c-14.176-11.008-32.192-17.76-55.616-17.76s-41.44 6.752-55.648 17.728l-29.056-29.056c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l20.704 20.704h-9.376c-38.4 0-72.704 17.152-96.16 44.064-23.456-26.784-57.504-44.064-95.84-44.064h-9.376l20.672-20.672c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-29.056 29.056c-14.176-11.008-32.192-17.76-55.616-17.76s-41.44 6.752-55.648 17.728l-29.024-29.056c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l20.672 20.704h-9.376c-70.592 0-128 57.408-128 128 0 12.736 1.952 25.248 5.792 37.408-24.032 23.744-37.792 56.064-37.792 90.592 0 45.728 24.96 87.552 64 110.080v17.92c0 47.168 25.92 88 64 110.208v81.792c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-68.224c11.168-2.944 21.952-7.328 32-13.248 10.048 5.888 20.832 10.304 32 13.248v68.224c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-81.792c38.080-22.208 64-63.040 64-110.208 0 47.168 25.92 88 64 110.208v81.792c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-68.224c11.168-2.944 21.952-7.328 32-13.248 10.048 5.888 20.832 10.304 32 13.248v68.224c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-81.792c38.080-22.208 64-63.040 64-110.208v-17.92c39.040-22.56 64-64.352 64-110.080 0-34.528-13.76-66.848-37.792-90.592zM704 224c15.84 0 64 0 64 96s-48.16 96-64 96c-15.84 0-64 0-64-96s48.16-96 64-96zM320 224c15.84 0 64 0 64 96s-48.16 96-64 96c-15.84 0-64 0-64-96s48.16-96 64-96zM256 800h-32v-68.544c10.304 2.688 20.896 4.544 32 4.544v64zM416 800h-32v-64c11.104 0 21.696-1.856 32-4.544v68.544zM480 569.76v38.24c0 53.024-42.976 96-96 96-24.704 0-46.976-9.6-64-24.928-17.024 15.328-39.296 24.928-64 24.928-53.024 0-96-42.976-96-96v-38.24c-37.152-13.216-64-48.064-64-89.76 0-34.144 17.952-63.936 44.8-80.96-7.904-13.952-12.8-29.856-12.8-47.040 0-53.024 42.976-96 96-96 2.944 0 6.272 0 9.408 0-6.304 18.88-9.408 40.576-9.408 64 0 70.688 25.312 128 96 128s96-57.312 96-128c0-23.424-3.104-45.12-9.408-64 3.136 0 6.496 0 9.408 0 53.024 0 96 42.976 96 96 0 17.184-4.896 33.088-12.8 47.040 26.848 17.024 44.8 46.816 44.8 80.96 0 41.696-26.848 76.544-64 89.76zM640 800h-32v-68.544c10.304 2.688 20.896 4.544 32 4.544v64zM800 800h-32v-64c11.104 0 21.696-1.856 32-4.544v68.544zM864 569.76v38.24c0 53.024-42.976 96-96 96-24.704 0-46.976-9.6-64-24.928-17.024 15.328-39.296 24.928-64 24.928-53.024 0-96-42.976-96-96v-44.48c20.032-22.752 32-52.128 32-83.52 0-34.528-13.76-66.848-37.792-90.592 3.84-12.16 5.792-24.672 5.792-37.408 0-20.192-5.12-39.040-13.472-56.032 17.408-24.096 45.472-39.968 77.472-39.968 2.944 0 6.272 0 9.408 0-6.304 18.88-9.408 40.576-9.408 64 0 70.688 25.312 128 96 128s96-57.312 96-128c0-23.424-3.104-45.12-9.408-64 3.104 0 6.496 0 9.408 0 53.024 0 96 42.976 96 96 0 17.184-4.896 33.088-12.8 47.040 26.848 17.024 44.8 46.816 44.8 80.96 0 41.696-26.848 76.544-64 89.76z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clone",
						"copy",
						"duplicate",
						"experiment",
						"reproduce"
					],
					"grid": 32
				},
				{
					"id": 374,
					"width": 1024,
					"paths": [
						"M596.672 203.328c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l29.056 29.056c14.208-11.008 32.224-17.76 55.648-17.76s41.44 6.752 55.648 17.728l29.056-29.056c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-31.104 31.104c13.408 22.72 19.776 52.288 19.776 85.6 0 70.688-25.312 128-96 128s-96-57.312-96-128c0-33.312 6.368-62.88 19.808-85.568l-31.136-31.104zM243.808 234.432c-13.44 22.688-19.808 52.256-19.808 85.568 0 70.688 25.312 128 96 128s96-57.312 96-128c0-33.312-6.368-62.88-19.808-85.568l31.104-31.104c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-29.056 29.056c-14.176-11.008-32.192-17.76-55.616-17.76s-41.44 6.752-55.648 17.728l-29.024-29.056c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l31.104 31.136zM922.208 389.408c3.84-12.16 5.792-24.672 5.792-37.408 0-59.776-41.472-109.248-96.96-123.168l-12.128 12.128c8.384 22.368 13.088 48.672 13.088 79.040 0 100.192-47.84 160-128 160s-128-59.808-128-160c0-30.368 4.704-56.672 13.088-79.008l-12-12c-25.632 6.336-48.384 19.744-65.248 39.072-16.864-19.232-39.488-32.672-64.992-39.040l-11.968 11.968c8.416 22.336 13.12 48.64 13.12 79.008 0 100.192-47.84 160-128 160s-128-59.808-128-160c0-30.368 4.704-56.672 13.088-79.040l-12.128-12.128c-55.488 13.92-96.96 63.392-96.96 123.168 0 12.736 1.952 25.248 5.792 37.408-24.032 23.744-37.792 56.064-37.792 90.592 0 45.728 24.96 87.552 64 110.080v17.92c0 47.168 25.92 88 64 110.208v81.792c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-68.224c11.168-2.944 21.952-7.328 32-13.248 10.048 5.888 20.832 10.304 32 13.248v68.224c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-81.792c38.080-22.208 64-63.040 64-110.208 0 47.168 25.92 88 64 110.208v81.792c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-68.224c11.168-2.944 21.952-7.328 32-13.248 10.048 5.888 20.832 10.304 32 13.248v68.224c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-81.792c38.080-22.208 64-63.040 64-110.208v-17.92c39.040-22.56 64-64.352 64-110.080 0-34.528-13.76-66.848-37.792-90.592z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clone",
						"copy",
						"duplicate",
						"experiment",
						"reproduce"
					],
					"grid": 32
				},
				{
					"id": 1192,
					"width": 804.5720062255859,
					"paths": [
						"M741.714 755.429q0 22.857-16 38.857l-77.714 77.714q-16 16-38.857 16t-38.857-16l-168-168-168 168q-16 16-38.857 16t-38.857-16l-77.714-77.714q-16-16-16-38.857t16-38.857l168-168-168-168q-16-16-16-38.857t16-38.857l77.714-77.714q16-16 38.857-16t38.857 16l168 168 168-168q16-16 38.857-16t38.857 16l77.714 77.714q16 16 16 38.857t-16 38.857l-168 168 168 168q16 16 16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"close",
						"remove",
						"times"
					],
					"defaultCode": 61453,
					"grid": 14
				},
				{
					"id": 375,
					"width": 1024,
					"paths": [
						"M896 128h-768c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM960 224v576c0 11.84-3.456 22.784-9.056 32.32l-320.32-320.32 320.32-320.32c5.6 9.536 9.056 20.48 9.056 32.32zM896 160c11.84 0 22.784 3.456 32.32 9.056l-416.32 416.32-416.32-416.32c9.536-5.6 20.48-9.056 32.32-9.056h768zM73.056 832.32c-5.6-9.536-9.056-20.48-9.056-32.32v-576c0-11.84 3.456-22.784 9.056-32.32l320.32 320.32-320.32 320.32zM128 864c-11.84 0-22.784-3.456-32.32-9.056l320.32-320.32 73.376 73.376c12.512 12.512 32.768 12.512 45.248 0l73.376-73.376 320.32 320.32c-9.536 5.6-20.48 9.056-32.32 9.056h-768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"close",
						"send",
						"deliver"
					],
					"grid": 32
				},
				{
					"id": 376,
					"width": 1024,
					"paths": [
						"M896 128h-768c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM939.328 820.672c6.24 6.24 6.24 16.384 0 22.624-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672l-308.672-308.704-84.672 84.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672l-84.672-84.704-308.672 308.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672c-6.24-6.24-6.24-16.384 0-22.624l308.704-308.704-308.704-308.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l404.704 404.672 404.672-404.704c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-308.672 308.704 308.704 308.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"close",
						"send",
						"deliver"
					],
					"grid": 32
				},
				{
					"id": 986,
					"width": 1024,
					"paths": [
						"M992 128h-960c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM638.336 487.68l321.664-278.752v600.448l-321.664-321.696zM930.624 192l-408.064 353.664c-5.984 5.184-15.008 5.184-20.992 0l-405.184-353.664h834.24zM64 206.176l322.048 281.152-322.048 322.048v-603.2zM86.624 832l323.584-323.584 70.304 61.376c8.992 7.84 20.256 11.744 31.552 11.744 11.232 0 22.496-3.904 31.456-11.648l70.56-61.152 323.296 323.264h-850.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"close",
						"send"
					],
					"grid": 32
				},
				{
					"id": 2698,
					"paths": [
						"M892.216 514.542c2.49-11.29 3.784-22.87 3.784-34.542 0-88.224-71.776-160-160-160-13.956 0-27.796 1.83-41.164 5.378-24.838-77.286-97.404-133.378-182.836-133.378-86.654 0-160.886 58.042-184.312 138.118-22.982-6.66-47.052-10.118-71.688-10.118-141.158 0-256 114.84-256 256 0 141.158 114.84 256 256 256h608c88.224 0 160-71.776 160-160 0-78.594-56.976-144.086-131.784-157.458zM864 768h-608c-105.87 0-192-86.13-192-192s86.13-192 192-192c52.024 0 100.73 20.466 137.146 57.63 12.368 12.624 32.63 12.828 45.252 0.46 12.624-12.37 12.83-32.63 0.46-45.252-15.676-15.998-33.070-29.66-51.76-40.848 12.838-57.424 64.302-99.99 124.902-99.99 70.58 0 128 57.42 128 128 0 8.706-0.876 17.398-2.602 25.832-3.542 17.316 7.624 34.222 24.938 37.764 2.164 0.444 4.32 0.656 6.448 0.656 14.884 0 28.218-10.442 31.318-25.592 2.218-10.854 3.494-21.972 3.812-33.126 10.244-3.624 21.096-5.534 32.086-5.534 52.936 0 96 43.066 96 96 0 10.964-1.88 21.784-5.484 32h-26.516c-17.674 0-32 14.326-32 32s14.326 32 32 32h64c52.936 0 96 43.064 96 96s-43.064 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud",
						"weather"
					],
					"defaultCode": 60533,
					"grid": 16
				},
				{
					"id": 2701,
					"paths": [
						"M672 576l-256 256-128-128-96 96 224 224 352-352z",
						"M256 320c-141.158 0-256 114.84-256 256 0 68.378 26.626 132.668 74.982 181.020 6.248 6.248 14.438 9.372 22.626 9.372s16.376-3.124 22.626-9.374c12.496-12.498 12.494-32.758-0.002-45.256-36.26-36.262-56.232-84.476-56.232-135.762 0-105.87 86.128-192 192-192 52.022 0 100.726 20.466 137.144 57.632 12.37 12.624 32.628 12.828 45.252 0.458s12.828-32.628 0.458-45.252c-15.678-15.998-33.070-29.66-51.76-40.848 12.836-57.424 64.3-99.99 124.9-99.99 70.58 0 128 57.42 128 128 0 8.706-0.874 17.398-2.6 25.832-3.542 17.314 7.622 34.222 24.938 37.764 2.162 0.444 4.322 0.656 6.448 0.656 14.884 0 28.216-10.44 31.316-25.592 2.222-10.854 3.494-21.972 3.814-33.126 10.244-3.624 21.096-5.534 32.086-5.534 52.934 0 96 43.066 96 96 0 10.964-1.88 21.784-5.484 32h-26.516c-17.672 0-32 14.328-32 32s14.328 32 32 32h64c52.934 0 96 43.066 96 96s-43.066 96-96 96h-64c-17.672 0-32 14.326-32 32s14.328 32 32 32h64c88.224 0 160-71.778 160-160 0-78.594-56.976-144.086-131.786-157.458 2.492-11.292 3.786-22.872 3.786-34.542 0-88.224-71.776-160-160-160-13.956 0-27.796 1.83-41.164 5.378-24.834-77.286-97.402-133.378-182.834-133.378-86.654 0-160.886 58.042-184.31 138.118-22.982-6.66-47.054-10.118-71.688-10.118v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-check",
						"cloud",
						"synced"
					],
					"defaultCode": 60536,
					"grid": 16
				},
				{
					"id": 2705,
					"paths": [
						"M892.268 514.49c2.442-11.108 3.732-22.646 3.732-34.49 0-88.366-71.634-160-160-160-14.224 0-28.014 1.868-41.134 5.352-24.796-77.352-97.288-133.352-182.866-133.352-87.348 0-161.054 58.336-184.326 138.17-22.742-6.62-46.792-10.17-71.674-10.17-141.384 0-256 114.616-256 256 0 141.382 114.616 256 256 256h608c88.366 0 160-71.632 160-160 0-78.718-56.854-144.16-131.732-157.51zM416 768l-160-160 64-64 96 96 224-224 64 64-288 288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-check",
						"cloud",
						"synced"
					],
					"defaultCode": 60540,
					"grid": 16
				},
				{
					"id": 108,
					"paths": [
						"M819.2 819.2h-486.4c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h486.4c84.696 0 153.6-68.904 153.6-153.6s-68.904-153.6-153.6-153.6c-17.576 0-34.797 2.936-51.181 8.726-11.101 3.922-23.451-0.234-29.922-10.075-6.469-9.84-5.389-22.827 2.616-31.464 17.595-18.986 27.286-43.699 27.286-69.587 0-56.464-45.936-102.4-102.4-102.4-53.997 0-98.888 42.162-102.198 95.986-0.667 10.858-8.125 20.107-18.594 23.064-10.474 2.96-21.664-1.027-27.912-9.93-47.957-68.326-126.347-109.12-209.696-109.12-141.158 0-256 114.84-256 256 0 7.77 0.352 15.611 1.045 23.301 1.269 14.082-9.117 26.525-23.198 27.795-14.080 1.278-26.525-9.117-27.795-23.198-0.83-9.211-1.251-18.598-1.251-27.898 0-169.39 137.81-307.2 307.2-307.2 82.483 0 160.917 33.286 218.149 90.933 24.093-53.746 78.16-90.933 140.251-90.933 84.696 0 153.6 68.904 153.6 153.6 0 17.71-3.024 35.056-8.818 51.386 2.931-0.123 5.87-0.186 8.818-0.186 112.926 0 204.8 91.874 204.8 204.8s-91.874 204.8-204.8 204.8z",
						"M179.2 793.6c-6.552 0-13.102-2.499-18.102-7.499l-102.4-102.4c-9.997-9.997-9.997-26.206 0-36.203s26.206-9.997 36.205 0l84.298 84.298 237.898-237.898c9.998-9.997 26.206-9.997 36.205 0 9.997 9.997 9.997 26.206 0 36.203l-256 256c-5 5-11.55 7.499-18.102 7.499z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-check",
						"cloud"
					],
					"defaultCode": 59405,
					"grid": 20
				},
				{
					"id": 2699,
					"paths": [
						"M576 576h-128v192h-160l224 224 224-224h-160z",
						"M892.216 514.542c2.49-11.29 3.784-22.87 3.784-34.542 0-88.224-71.776-160-160-160-13.956 0-27.796 1.83-41.164 5.378-24.838-77.286-97.404-133.378-182.836-133.378-86.654 0-160.886 58.042-184.312 138.118-22.982-6.66-47.052-10.118-71.688-10.118-141.158 0-256 114.84-256 256 0 61.986 22.444 121.798 63.2 168.42 40.354 46.164 95.852 76.346 156.266 84.988 1.538 0.218 3.064 0.326 4.572 0.326 15.666 0 29.354-11.514 31.638-27.472 2.502-17.496-9.652-33.708-27.146-36.208-45.262-6.474-86.864-29.116-117.144-63.754-30.558-34.956-47.386-79.81-47.386-126.3 0-105.87 86.13-192 192-192 52.024 0 100.73 20.466 137.146 57.63 12.368 12.624 32.63 12.83 45.252 0.458 12.624-12.37 12.83-32.628 0.458-45.252-15.676-15.998-33.070-29.66-51.76-40.848 12.84-57.42 64.304-99.988 124.904-99.988 70.58 0 128 57.42 128 128 0 8.706-0.876 17.398-2.602 25.832-3.542 17.316 7.624 34.222 24.938 37.764 2.164 0.444 4.32 0.656 6.448 0.656 14.884 0 28.218-10.442 31.318-25.592 2.218-10.854 3.494-21.972 3.812-33.126 10.244-3.624 21.096-5.534 32.086-5.534 52.936 0 96 43.066 96 96 0 10.964-1.88 21.784-5.484 32h-26.516c-17.674 0-32 14.326-32 32s14.326 32 32 32h64c52.934 0 96 43.066 96 96s-43.066 96-96 96h-64c-17.674 0-32 14.326-32 32s14.326 32 32 32h64c88.224 0 160-71.776 160-160 0-78.594-56.976-144.086-131.784-157.458z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-download",
						"cloud",
						"save",
						"download"
					],
					"defaultCode": 60534,
					"grid": 16
				},
				{
					"id": 2703,
					"paths": [
						"M891.004 360.060c-3.242-128.698-108.458-232.060-237.862-232.060-75.792 0-143.266 35.494-186.854 90.732-24.442-31.598-62.69-51.96-105.708-51.96-73.81 0-133.642 59.876-133.642 133.722 0 6.436 0.48 12.76 1.364 18.954-11.222-2.024-22.766-3.138-34.57-3.138-106.998-0.002-193.732 86.786-193.732 193.842 0 107.062 86.734 193.848 193.73 193.848h91.76l226.51 234.51 226.51-234.51 111.482-0.012c96.138-0.184 174.008-78.21 174.008-174.446 0-82.090-56.678-150.9-132.996-169.482zM512 832l-192-192h128v-192h128v192h128l-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-download",
						"cloud",
						"save",
						"download"
					],
					"defaultCode": 60538,
					"grid": 16
				},
				{
					"id": 1390,
					"width": 1097.1429443359375,
					"paths": [
						"M731.429 530.286q0-8-5.143-13.143t-13.143-5.143h-128v-201.143q0-7.429-5.429-12.857t-12.857-5.429h-109.714q-7.429 0-12.857 5.429t-5.429 12.857v201.143h-128q-7.429 0-12.857 5.429t-5.429 12.857q0 8 5.143 13.143l201.143 201.143q5.143 5.143 13.143 5.143t13.143-5.143l200.571-200.571q5.714-6.857 5.714-13.714zM1097.143 658.286q0 90.857-64.286 155.143t-155.143 64.286h-621.714q-105.714 0-180.857-75.143t-75.143-180.857q0-74.286 40-137.143t107.429-94.286q-1.143-17.143-1.143-24.571 0-121.143 85.714-206.857t206.857-85.714q89.143 0 163.143 49.714t107.714 132q40.571-35.429 94.857-35.429 60.571 0 103.429 42.857t42.857 103.429q0 43.429-23.429 78.857 74.286 17.714 122 77.429t47.714 136.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-download"
					],
					"defaultCode": 61677,
					"grid": 14
				},
				{
					"id": 106,
					"paths": [
						"M819.52 819.2h-128.32c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h128.32c84.518 0 153.28-68.762 153.28-153.28s-68.762-153.28-153.28-153.28c-18.005 0-35.626 3.086-52.368 9.173-11.168 4.056-23.654-0.099-30.163-10.035-6.507-9.938-5.323-23.048 2.859-31.659 18.154-19.106 28.152-44.15 28.152-70.518 0-56.464-45.936-102.4-102.4-102.4-32.858 0-62.912 15.187-82.456 41.667-11.704 15.859-18.533 34.638-19.746 54.307-0.67 10.867-8.141 20.122-18.622 23.069s-21.682-1.059-27.915-9.984l-0.238-0.342c-5.49-7.795-11.549-15.443-17.952-22.653-48.587-54.694-118.374-86.064-191.47-86.064-141.158 0-256 114.842-256 256 0 141.16 114.842 256 256 256h76.8c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6h-76.8c-169.39 0-307.2-137.81-307.2-307.2s137.81-307.2 307.2-307.2c82.050 0 160.621 32.933 218.142 90.901 4.47-9.989 10.026-19.52 16.608-28.438 28.867-39.112 75.090-62.462 123.65-62.462 84.696 0 153.6 68.904 153.6 153.6 0 17.976-3.099 35.542-9.035 52.050 3.11-0.139 6.23-0.21 9.357-0.21 112.75 0 204.48 91.73 204.48 204.48-0.002 112.75-91.731 204.48-204.482 204.48z",
						"M658.101 673.099c-9.997-9.997-26.206-9.997-36.203 0l-58.698 58.696v-194.195c0-14.139-11.461-25.6-25.6-25.6s-25.6 11.461-25.6 25.6v194.195l-58.698-58.698c-9.998-9.997-26.206-9.997-36.205 0-9.997 9.997-9.997 26.206 0 36.203l102.4 102.4c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.101-7.499l102.4-102.4c9.998-9.997 9.998-26.205 0-36.202z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-download",
						"cloud"
					],
					"defaultCode": 59403,
					"grid": 20
				},
				{
					"id": 107,
					"paths": [
						"M819.52 410.24c-3.126 0-6.245 0.070-9.357 0.21 5.938-16.507 9.037-34.074 9.037-52.050 0-84.696-68.904-153.6-153.6-153.6-48.56 0-94.782 23.35-123.65 62.462-6.582 8.918-12.138 18.451-16.608 28.44-57.522-57.97-136.093-90.902-218.142-90.902-169.39 0-307.2 137.81-307.2 307.2s137.81 307.2 307.2 307.2h512.32c112.75 0 204.48-91.73 204.48-204.48s-91.73-204.48-204.48-204.48zM819.52 768h-512.32c-141.158 0-256-114.84-256-256 0-141.158 114.842-256 256-256 73.096 0 142.883 31.37 191.469 86.066 6.403 7.21 12.462 14.858 17.952 22.653l0.238 0.342c6.234 8.923 17.427 12.93 27.915 9.984 10.482-2.947 17.952-12.202 18.622-23.069 1.213-19.669 8.040-38.448 19.746-54.307 19.546-26.482 49.6-41.669 82.458-41.669 56.464 0 102.4 45.936 102.4 102.4 0 26.368-9.998 51.413-28.152 70.518-8.182 8.611-9.366 21.722-2.859 31.659s18.994 14.093 30.163 10.035c16.746-6.086 34.365-9.173 52.368-9.173 84.518 0 153.28 68.762 153.28 153.28s-68.762 153.28-153.28 153.28z",
						"M327.867 612.318c-6.749 1.381-13.702 2.082-20.667 2.082-56.464 0-102.4-45.936-102.4-102.4v-14.997l7.499 7.499c4.998 4.998 11.549 7.498 18.101 7.498s13.102-2.499 18.101-7.499c9.998-9.997 9.998-26.206 0-36.203l-51.2-51.2c-9.997-9.998-26.206-9.998-36.203 0l-51.2 51.2c-9.998 9.997-9.998 26.206 0 36.203 9.997 9.998 26.206 9.998 36.203 0l7.499-7.498v14.997c0 84.696 68.904 153.6 153.6 153.6 10.405 0 20.81-1.050 30.928-3.118 13.853-2.834 22.784-16.362 19.95-30.213s-16.352-22.773-30.211-19.95z",
						"M468.299 519.499l-7.499 7.498v-14.997c0-84.696-68.904-153.6-153.6-153.6-10.403 0-20.81 1.050-30.928 3.12-13.851 2.834-22.782 16.36-19.949 30.211s16.36 22.784 30.211 19.949c6.749-1.381 13.701-2.080 20.667-2.080 56.464 0 102.4 45.936 102.4 102.4v14.997l-7.499-7.499c-9.997-9.997-26.206-9.997-36.203 0-9.998 9.997-9.998 26.206 0 36.203l51.2 51.2c4.998 5 11.549 7.499 18.101 7.499s13.102-2.499 18.101-7.499l51.2-51.2c9.998-9.997 9.998-26.206 0-36.203-9.997-9.997-26.205-9.997-36.202 0.002z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-sync",
						"cloud"
					],
					"defaultCode": 59404,
					"grid": 20
				},
				{
					"id": 2700,
					"paths": [
						"M512 544l-224 224h160v192h128v-192h160l-224-224z",
						"M892.216 514.542c2.49-11.29 3.784-22.87 3.784-34.542 0-88.224-71.776-160-160-160-13.956 0-27.796 1.83-41.164 5.378-24.838-77.286-97.404-133.378-182.836-133.378-86.654 0-160.886 58.042-184.312 138.118-22.982-6.66-47.052-10.118-71.688-10.118-141.158 0-256 114.84-256 256 0 61.986 22.444 121.798 63.2 168.42 40.354 46.164 95.852 76.346 156.266 84.988 1.538 0.218 3.064 0.326 4.572 0.326 15.666 0 29.354-11.514 31.638-27.472 2.502-17.496-9.652-33.708-27.146-36.208-45.262-6.474-86.864-29.116-117.144-63.754-30.558-34.956-47.386-79.81-47.386-126.3 0-105.87 86.13-192 192-192 52.024 0 100.73 20.466 137.146 57.63 12.368 12.624 32.63 12.83 45.252 0.458 12.624-12.37 12.83-32.628 0.458-45.252-15.676-15.998-33.070-29.66-51.76-40.848 12.84-57.42 64.304-99.988 124.904-99.988 70.58 0 128 57.42 128 128 0 8.706-0.876 17.398-2.602 25.832-3.542 17.316 7.624 34.222 24.938 37.764 2.164 0.444 4.32 0.656 6.448 0.656 14.884 0 28.218-10.442 31.318-25.592 2.218-10.854 3.494-21.972 3.812-33.126 10.244-3.624 21.096-5.534 32.086-5.534 52.936 0 96 43.066 96 96 0 10.964-1.88 21.784-5.484 32h-26.516c-17.674 0-32 14.326-32 32s14.326 32 32 32h64c52.934 0 96 43.066 96 96s-43.066 96-96 96h-64c-17.674 0-32 14.326-32 32s14.326 32 32 32h64c88.224 0 160-71.776 160-160 0-78.594-56.976-144.086-131.784-157.458z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-upload",
						"cloud",
						"load",
						"upload"
					],
					"defaultCode": 60535,
					"grid": 16
				},
				{
					"id": 2704,
					"paths": [
						"M892.268 386.49c2.444-11.11 3.732-22.648 3.732-34.49 0-88.366-71.634-160-160-160-14.222 0-28.014 1.868-41.132 5.352-24.798-77.352-97.29-133.352-182.868-133.352-87.348 0-161.054 58.336-184.326 138.17-22.742-6.622-46.792-10.17-71.674-10.17-141.384 0-256 114.616-256 256 0 141.388 114.616 256 256 256h128v192h256v-192h224c88.366 0 160-71.632 160-160 0-78.72-56.854-144.162-131.732-157.51zM576 640v192h-128v-192h-160l224-224 224 224h-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-upload",
						"cloud",
						"load",
						"upload"
					],
					"defaultCode": 60539,
					"grid": 16
				},
				{
					"id": 1391,
					"width": 1097.1429443359375,
					"paths": [
						"M731.429 493.714q0-8-5.143-13.143l-201.143-201.143q-5.143-5.143-13.143-5.143t-13.143 5.143l-200.571 200.571q-5.714 6.857-5.714 13.714 0 8 5.143 13.143t13.143 5.143h128v201.143q0 7.429 5.429 12.857t12.857 5.429h109.714q7.429 0 12.857-5.429t5.429-12.857v-201.143h128q7.429 0 12.857-5.429t5.429-12.857zM1097.143 658.286q0 90.857-64.286 155.143t-155.143 64.286h-621.714q-105.714 0-180.857-75.143t-75.143-180.857q0-74.286 40-137.143t107.429-94.286q-1.143-17.143-1.143-24.571 0-121.143 85.714-206.857t206.857-85.714q89.143 0 163.143 49.714t107.714 132q40.571-35.429 94.857-35.429 60.571 0 103.429 42.857t42.857 103.429q0 43.429-23.429 78.857 74.286 17.714 122 77.429t47.714 136.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-upload"
					],
					"defaultCode": 61678,
					"grid": 14
				},
				{
					"id": 105,
					"paths": [
						"M819.52 819.2h-179.52c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h179.52c84.518 0 153.28-68.762 153.28-153.28s-68.762-153.28-153.28-153.28c-18.005 0-35.626 3.086-52.368 9.173-11.168 4.056-23.654-0.099-30.163-10.035-6.507-9.938-5.323-23.048 2.859-31.659 18.154-19.106 28.152-44.15 28.152-70.518 0-56.464-45.936-102.4-102.4-102.4-32.858 0-62.912 15.187-82.456 41.667-11.704 15.859-18.533 34.638-19.746 54.307-0.67 10.867-8.141 20.122-18.622 23.069s-21.682-1.059-27.915-9.984l-0.238-0.342c-5.49-7.795-11.549-15.443-17.952-22.653-48.587-54.694-118.374-86.064-191.47-86.064-141.158 0-256 114.842-256 256 0 141.16 114.842 256 256 256h128c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6h-128c-169.39 0-307.2-137.81-307.2-307.2s137.81-307.2 307.2-307.2c82.050 0 160.621 32.933 218.142 90.901 4.47-9.989 10.026-19.52 16.608-28.438 28.867-39.112 75.090-62.462 123.65-62.462 84.696 0 153.6 68.904 153.6 153.6 0 17.976-3.099 35.542-9.035 52.050 3.11-0.139 6.23-0.21 9.357-0.21 112.75 0 204.48 91.73 204.48 204.48-0.002 112.75-91.731 204.48-204.482 204.48z",
						"M658.101 621.899l-102.4-102.4c-9.997-9.997-26.206-9.997-36.203 0l-102.4 102.4c-9.997 9.997-9.997 26.206 0 36.203s26.206 9.997 36.205 0l58.698-58.698v194.195c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-194.195l58.699 58.698c4.998 4.998 11.549 7.498 18.101 7.498s13.102-2.499 18.101-7.499c9.998-9.997 9.998-26.205 0-36.202z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud-upload",
						"cloud"
					],
					"defaultCode": 59402,
					"grid": 20
				},
				{
					"id": 2702,
					"paths": [
						"M1024 657.542c0-82.090-56.678-150.9-132.996-169.48-3.242-128.7-108.458-232.062-237.862-232.062-75.792 0-143.266 35.494-186.854 90.732-24.442-31.598-62.69-51.96-105.708-51.96-73.81 0-133.642 59.874-133.642 133.722 0 6.436 0.48 12.76 1.364 18.954-11.222-2.024-22.766-3.138-34.57-3.138-106.998-0.002-193.732 86.786-193.732 193.842 0 107.062 86.734 193.848 193.73 193.848l656.262-0.012c96.138-0.184 174.008-78.212 174.008-174.446z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud",
						"weather"
					],
					"defaultCode": 60537,
					"grid": 16
				},
				{
					"id": 1349,
					"width": 1097.1429443359375,
					"paths": [
						"M1097.143 658.286q0 90.857-64.286 155.143t-155.143 64.286h-621.714q-105.714 0-180.857-75.143t-75.143-180.857q0-75.429 40.571-138t106.857-93.429q-1.143-16-1.143-24.571 0-121.143 85.714-206.857t206.857-85.714q90.286 0 163.714 50.286t107.143 131.429q40-35.429 94.857-35.429 60.571 0 103.429 42.857t42.857 103.429q0 42.857-23.429 78.857 73.714 17.143 121.714 76.857t48 136.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud"
					],
					"defaultCode": 61634,
					"grid": 14
				},
				{
					"id": 104,
					"paths": [
						"M819.52 819.2h-512.32c-169.39 0-307.2-137.81-307.2-307.2s137.81-307.2 307.2-307.2c82.034 0 160.589 32.917 218.104 90.866 4.483-9.947 10.048-19.469 16.643-28.403 28.87-39.112 75.093-62.462 123.653-62.462 84.696 0 153.6 68.904 153.6 153.6 0 17.957-3.118 35.523-9.096 52.051 3.126-0.142 6.267-0.211 9.416-0.211 112.75 0 204.48 91.73 204.48 204.48s-91.73 204.48-204.48 204.48zM307.2 256c-141.158 0-256 114.84-256 256s114.842 256 256 256h512.32c84.518 0 153.28-68.762 153.28-153.28s-68.762-153.28-153.28-153.28c-18.128 0-35.794 3.101-52.507 9.222-11.166 4.088-23.677-0.050-30.202-9.989s-5.349-23.064 2.842-31.685c18.28-19.235 28.347-44.307 28.347-70.589 0-56.464-45.936-102.4-102.4-102.4-32.858 0-62.912 15.187-82.456 41.667-11.798 15.986-18.669 34.707-19.867 54.138-0.67 10.85-8.117 20.096-18.574 23.054-10.462 2.966-21.648-1.006-27.906-9.891-5.632-7.997-11.73-15.701-18.126-22.902-48.587-54.696-118.374-86.066-191.47-86.066z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cloud",
						"weather"
					],
					"defaultCode": 59401,
					"grid": 20
				},
				{
					"id": 1925,
					"paths": [
						"M786.832 392.772c-59.032 0-112.086 24.596-149.852 64.694-15.996 16.984-43.762 37.112-73.8 54.81 14.11-53.868 58.676-121.7 89.628-151.456 39.64-38.17 63.984-91.83 63.984-151.5 0.006-114.894-91.476-208.096-204.788-209.32-113.32 1.222-204.796 94.426-204.796 209.318 0 59.672 24.344 113.33 63.986 151.5 30.954 29.756 75.52 97.588 89.628 151.456-30.042-17.7-57.806-37.826-73.8-54.81-37.768-40.098-90.82-64.694-149.85-64.694-114.386 0-207.080 93.664-207.080 209.328 0 115.638 92.692 209.338 207.080 209.338 59.042 0 112.082-25.356 149.85-65.452 16.804-17.872 46.444-40.138 78.292-58.632-3.002 147.692-73.532 256.168-145.318 298.906v37.742h384.014v-37.74c-71.792-42.736-142.32-151.216-145.32-298.906 31.852 18.494 61.488 40.768 78.292 58.632 37.766 40.094 90.808 65.452 149.852 65.452 114.386 0 207.078-93.7 207.078-209.338-0.002-115.664-92.692-209.328-207.080-209.328z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clubs",
						"cards",
						"poker"
					],
					"defaultCode": 59760,
					"grid": 16
				},
				{
					"id": 377,
					"width": 1024,
					"paths": [
						"M628.832 260.064c7.040-10.272 11.168-22.688 11.168-36.064 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 11.712 3.392 22.56 8.864 32h-17.76c5.504-9.44 8.896-20.288 8.896-32 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 13.376 4.128 25.792 11.168 36.064-187.008 25.792-331.168 185.824-331.168 379.936v96c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-96c0-194.112-144.16-354.144-331.168-379.936zM544 224c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM416 224c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM160 800v-160c0-158.816 129.184-288 288-288h128c158.816 0 288 129.184 288 288v160h-704zM928 736c0 23.584-12.96 44-32 55.104v-151.104c0-176.736-143.264-320-320-320h-128c-176.736 0-320 143.264-320 320v151.104c-19.040-11.104-32-31.52-32-55.104v-96c0-194.080 157.92-352 352-352h128c194.080 0 352 157.92 352 352v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clutch",
						"hold",
						"carry"
					],
					"grid": 32
				},
				{
					"id": 378,
					"width": 1024,
					"paths": [
						"M864 640v192h-704v-192c0-158.816 129.184-288 288-288h128c158.816 0 288 129.184 288 288zM628.832 260.064c7.040-10.272 11.168-22.688 11.168-36.064 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 11.712 3.392 22.56 8.864 32h-17.76c5.504-9.44 8.896-20.288 8.896-32 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 13.376 4.128 25.792 11.168 36.064-187.008 25.792-331.168 185.824-331.168 379.936v96c0 41.728 26.784 76.896 64 90.112v-186.112c0-176.736 143.264-320 320-320h128c176.736 0 320 143.264 320 320v186.112c37.216-13.216 64-48.384 64-90.112v-96c0-194.112-144.16-354.144-331.168-379.936z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"clutch",
						"hold",
						"carry"
					],
					"grid": 32
				},
				{
					"id": 1487,
					"width": 586.8560771942139,
					"paths": [
						"M344.571 877.714h-98.286q-7.429 0-12.857-5.143t-5.429-13.143v-188.571h-164.571q-7.429 0-12.857-5.143t-5.429-13.143v-58.857q0-7.429 5.429-12.857t12.857-5.429h164.571v-48.571h-164.571q-7.429 0-12.857-5.143t-5.429-13.143v-59.429q0-7.429 5.429-12.857t12.857-5.429h122.286l-183.429-330.286q-4.571-9.143 0-18.286 5.714-9.143 16-9.143h110.857q10.857 0 16.571 10.286l122.857 242.857q10.857 21.714 32 71.429 5.714-13.714 17.429-38.857t15.714-34.857l109.143-240q4.571-10.857 16.571-10.857h109.143q9.714 0 15.429 9.143 5.143 8 0.571 17.714l-178.857 330.857h122.857q7.429 0 12.857 5.429t5.429 12.857v59.429q0 8-5.429 13.143t-12.857 5.143h-165.714v48.571h165.714q7.429 0 12.857 5.429t5.429 12.857v58.857q0 8-5.429 13.143t-12.857 5.143h-165.714v188.571q0 7.429-5.429 12.857t-12.857 5.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cny",
						"jpy",
						"rmb",
						"yen"
					],
					"defaultCode": 61783,
					"grid": 14
				},
				{
					"id": 3302,
					"width": 1280,
					"paths": [
						"M256 352v-128c0-53.020 42.98-96 96-96h32v-128h-32c-123.712 0-224 100.288-224 224v128c0 53.020-42.98 96-96 96h-32v128h32c53.020 0 96 42.98 96 96v128c0 123.71 100.288 224 224 224h32v-128h-32c-53.020 0-96-42.98-96-96v-128c0-62.684-25.758-119.342-67.254-160 41.496-40.658 67.254-97.316 67.254-160z",
						"M1024 352v-128c0-53.020-42.98-96-96-96h-32v-128h32c123.71 0 224 100.288 224 224v128c0 53.020 42.98 96 96 96h32v128h-32c-53.020 0-96 42.98-96 96v128c0 123.71-100.29 224-224 224h-32v-128h32c53.020 0 96-42.98 96-96v-128c0-62.684 25.758-119.342 67.254-160-41.496-40.658-67.254-97.316-67.254-160z",
						"M768 320.882c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128s128 57.308 128 128z",
						"M640 511.118c-70.692 0-128 57.308-128 128 0 68.732 32 123.216 130.156 127.852-29.19 41.126-73.156 57.366-130.156 62.7v76c0 0 256 22.332 256-266.55-0.25-70.694-57.306-128.002-128-128.002z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"code",
						"semicolon",
						"curly-braces"
					],
					"defaultCode": 61137,
					"grid": 16
				},
				{
					"id": 1441,
					"width": 585.1439819335938,
					"paths": [
						"M164.571 841.143q0-22.857-16-38.857t-38.857-16-38.857 16-16 38.857 16 38.857 38.857 16 38.857-16 16-38.857zM164.571 182.857q0-22.857-16-38.857t-38.857-16-38.857 16-16 38.857 16 38.857 38.857 16 38.857-16 16-38.857zM530.286 256q0-22.857-16-38.857t-38.857-16-38.857 16-16 38.857 16 38.857 38.857 16 38.857-16 16-38.857zM585.143 256q0 29.714-14.857 55.143t-40 39.714q-1.143 164-129.143 236.571-38.857 21.714-116 46.286-73.143 22.857-96.857 40.571t-23.714 57.143v14.857q25.143 14.286 40 39.714t14.857 55.143q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714q0-29.714 14.857-55.143t40-39.714v-468.571q-25.143-14.286-40-39.714t-14.857-55.143q0-45.714 32-77.714t77.714-32 77.714 32 32 77.714q0 29.714-14.857 55.143t-40 39.714v284q30.857-14.857 88-32.571 31.429-9.714 50-16.857t40.286-17.714 33.714-22.571 23.143-29.143 16-39.714 4.857-52.286q-25.143-14.286-40-39.714t-14.857-55.143q0-45.714 32-77.714t77.714-32 77.714 32 32 77.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"code-fork"
					],
					"defaultCode": 61734,
					"grid": 14
				},
				{
					"id": 1436,
					"width": 1097.141944885254,
					"paths": [
						"M352.571 799.429l-28.571 28.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-266.286-266.286q-5.714-5.714-5.714-13.143t5.714-13.143l266.286-266.286q5.714-5.714 13.143-5.714t13.143 5.714l28.571 28.571q5.714 5.714 5.714 13.143t-5.714 13.143l-224.571 224.571 224.571 224.571q5.714 5.714 5.714 13.143t-5.714 13.143zM690.286 189.714l-213.143 737.714q-2.286 7.429-8.857 11.143t-13.429 1.429l-35.429-9.714q-7.429-2.286-11.143-8.857t-1.429-14l213.143-737.714q2.286-7.429 8.857-11.143t13.429-1.429l35.429 9.714q7.429 2.286 11.143 8.857t1.429 14zM1065.714 561.714l-266.286 266.286q-5.714 5.714-13.143 5.714t-13.143-5.714l-28.571-28.571q-5.714-5.714-5.714-13.143t5.714-13.143l224.571-224.571-224.571-224.571q-5.714-5.714-5.714-13.143t5.714-13.143l28.571-28.571q5.714-5.714 13.143-5.714t13.143 5.714l266.286 266.286q5.714 5.714 5.714 13.143t-5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"code"
					],
					"defaultCode": 61729,
					"grid": 14
				},
				{
					"id": 201,
					"paths": [
						"M256 768c-6.552 0-13.102-2.499-18.101-7.499l-204.8-204.8c-9.998-9.997-9.998-26.206 0-36.203l204.8-204.8c9.997-9.997 26.206-9.997 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-186.699 186.699 186.698 186.699c9.998 9.997 9.998 26.206 0 36.203-4.998 4.998-11.549 7.498-18.101 7.498z",
						"M768 768c-6.552 0-13.102-2.499-18.101-7.499-9.998-9.997-9.998-26.206 0-36.203l186.698-186.698-186.698-186.699c-9.998-9.997-9.998-26.206 0-36.203 9.997-9.997 26.206-9.997 36.203 0l204.8 204.8c9.998 9.997 9.998 26.206 0 36.203l-204.8 204.8c-5 5-11.55 7.499-18.102 7.499z",
						"M383.976 768.003c-4.634 0-9.325-1.258-13.544-3.894-11.989-7.494-15.634-23.288-8.141-35.278l256-409.6c7.493-11.984 23.283-15.634 35.278-8.141 11.989 7.494 15.634 23.288 8.141 35.278l-256 409.6c-4.858 7.77-13.202 12.035-21.734 12.035z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"code",
						"embed"
					],
					"defaultCode": 59498,
					"grid": 20
				},
				{
					"id": 379,
					"width": 1024,
					"paths": [
						"M272 320h-64c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h64c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16zM224 368v0c0 8.832 7.168 16 16 16h64c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16zM240 576h64c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM208 640h64c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM704 432v0c0 8.832-7.168 16-16 16h-416c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h416c8.832 0 16 7.168 16 16zM272 512h416c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-416c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM528 384h-160c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16zM656 288h-320c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h320c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM928 128h-832c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h288v96h-48c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h352c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-48v-96h288c53.024 0 96-42.976 96-96v-512c0-53.024-42.976-96-96-96zM608 928h-192v-96h192v96zM992 736c0 35.36-28.64 64-64 64h-832c-35.36 0-64-28.64-64-64v-512c0-35.36 28.64-64 64-64h832c35.36 0 64 28.64 64 64v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"code",
						"write",
						"design",
						"program",
						"hack"
					],
					"grid": 32
				},
				{
					"id": 380,
					"width": 1024,
					"paths": [
						"M704 944c0 8.832-7.168 16-16 16h-352c-8.832 0-16-7.168-16-16s7.168-16 16-16h48v-64h256v64h48c8.832 0 16 7.168 16 16zM1024 224v512c0 53.024-42.976 96-96 96h-832c-53.024 0-96-42.976-96-96v-512c0-53.024 42.976-96 96-96h832c53.024 0 96 42.976 96 96zM320 304c0 8.832 7.168 16 16 16h320c8.832 0 16-7.168 16-16s-7.168-16-16-16h-320c-8.832 0-16 7.168-16 16zM528 352h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16zM304 352h-64c-8.832 0-16 7.168-16 16s7.168 16 16 16h64c8.832 0 16-7.168 16-16s-7.168-16-16-16zM192 304c0 8.832 7.168 16 16 16h64c8.832 0 16-7.168 16-16s-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16zM288 624c0-8.832-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16s7.168 16 16 16h64c8.832 0 16-7.168 16-16zM320 560c0-8.832-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16s7.168 16 16 16h64c8.832 0 16-7.168 16-16zM704 496c0-8.832-7.168-16-16-16h-416c-8.832 0-16 7.168-16 16s7.168 16 16 16h416c8.832 0 16-7.168 16-16zM704 432c0-8.832-7.168-16-16-16h-416c-8.832 0-16 7.168-16 16s7.168 16 16 16h416c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"code",
						"write",
						"design",
						"program",
						"hack"
					],
					"grid": 32
				},
				{
					"id": 3420,
					"paths": [
						"M945.75 368.042l-448-298.666c-10.748-7.166-24.752-7.166-35.5 0l-448 298.666c-8.902 5.934-14.25 15.926-14.25 26.624v298.666c0 10.7 5.348 20.692 14.25 26.624l448 298.666c5.374 3.584 11.562 5.376 17.75 5.376s12.376-1.792 17.75-5.376l448-298.666c8.902-5.934 14.25-15.926 14.25-26.624v-298.666c0-10.698-5.348-20.69-14.25-26.624zM480 654.876l-166.312-110.876 166.312-110.874 166.312 110.874-166.312 110.876zM512 377.542v-221.75l358.31 238.876-166.31 110.874-192-128zM448 377.542l-192 128-166.312-110.874 358.312-238.876v221.75zM198.312 544l-134.312 89.542v-179.082l134.312 89.54zM256 582.458l192 128v221.748l-358.312-238.872 166.312-110.876zM512 710.458l192-128 166.312 110.876-358.312 238.874v-221.75zM761.688 544l134.312-89.54v179.084l-134.312-89.544z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"codepen",
						"brand"
					],
					"defaultCode": 61255,
					"grid": 16
				},
				{
					"id": 1596,
					"width": 1024.0000305175781,
					"paths": [
						"M123.429 668l344.571 229.714v-205.143l-190.857-127.429zM88 585.714l110.286-73.714-110.286-73.714v147.429zM556 897.714l344.571-229.714-153.714-102.857-190.857 127.429v205.143zM512 616l155.429-104-155.429-104-155.429 104zM277.143 458.857l190.857-127.429v-205.143l-344.571 229.714zM825.714 512l110.286 73.714v-147.429zM746.857 458.857l153.714-102.857-344.571-229.714v205.143zM1024 356v312q0 23.429-19.429 36.571l-468 312q-12 7.429-24.571 7.429t-24.571-7.429l-468-312q-19.429-13.143-19.429-36.571v-312q0-23.429 19.429-36.571l468-312q12-7.429 24.571-7.429t24.571 7.429l468 312q19.429 13.143 19.429 36.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"codepen"
					],
					"defaultCode": 61899,
					"grid": 14
				},
				{
					"id": 1767,
					"width": 977.1430053710938,
					"paths": [
						"M885.143 388q31.429 0 48.857 16.286t17.429 47.714-19.429 46.857-52 15.429h-77.714v101.143h-14.286v-227.429h97.143zM977.143 725.143l-2.286 6.286-2.857 5.714q-64.571 131.429-188.857 209.143t-271.143 77.714q-104 0-198.857-40.571t-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571q139.429 0 259.714 70.857t188.286 193.143l5.714 11.429q-17.143 8.571-78 39.143t-93.429 48.286q-3.429 1.714-273.714 153.143 219.429 104.571 456.571 209.143zM512 1011.429q142.857 0 264.286-75.714t184.286-204.286l-164-73.714q-41.143 80-117.714 126.857t-166.857 46.857q-86.286 0-160-42.857t-116.571-116.571-42.857-160 42.857-160 116.571-116.571 160-42.857 160 42 116.571 116.857l160-81.714q-66.286-118.857-183.429-188t-253.143-69.143q-68 0-132.857 18t-119.429 50-100.857 78.286-78.286 100.857-50 119.429-18 132.857 18 132.857 50 119.429 78.286 100.857 100.857 78.286 119.429 50 132.857 18z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"codiepie"
					],
					"defaultCode": 62084,
					"grid": 14
				},
				{
					"id": 2528,
					"paths": [
						"M864 128h-44.222l-55.156-110.31c-5.42-10.842-16.5-17.69-28.622-17.69h-448c-12.122 0-23.202 6.848-28.622 17.69l-55.154 110.31h-44.224c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h32c0.002 1.108 0.056 2.224 0.174 3.35l64 608c1.718 16.286 15.45 28.65 31.826 28.65h448c16.376 0 30.11-12.364 31.824-28.65l64-608c0.12-1.124 0.174-2.242 0.174-3.35h32.002c17.674 0 32-14.328 32-32v-192c0-17.672-14.326-32-32-32zM307.778 64h408.446l32 64h-472.446l32-64zM316.81 960l-20.21-192h430.804l-20.21 192h-390.384zM448 640c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64c-35.346 0-64-28.654-64-64zM754.35 512h-484.7l-13.474-128h511.648l-13.474 128zM832 320h-640v-128h607.826c0.066 0 0.132 0.006 0.2 0.006 0.040 0 0.080-0.006 0.12-0.006h31.854v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"coffee",
						"drink",
						"cup",
						"beverage",
						"breakfast"
					],
					"defaultCode": 60363,
					"grid": 16
				},
				{
					"id": 2527,
					"paths": [
						"M501.372 654.774c-64.498-236.796-121.18-422.444 18.308-654.678-2.554-0.036-5.094-0.096-7.68-0.096-288 0-384 229.23-384 512 0 260.106 81.242 474.89 318.414 507.654 58.636-105.138 86.688-248.384 54.958-364.88z",
						"M577.226 4.292c-56.124 86.912-84.364 214.402-56.936 313.742 70.994 257.112 116.080 448.81-19.212 705.83 3.616 0.074 7.242 0.136 10.922 0.136 288 0 384-229.23 384-512 0-260.238-81.322-475.114-318.774-507.708z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"coffee-bean",
						"coffee"
					],
					"defaultCode": 60362,
					"grid": 16
				},
				{
					"id": 167,
					"paths": [
						"M512 768c-84.696 0-153.6-68.904-153.6-153.6s68.904-153.6 153.6-153.6 153.6 68.904 153.6 153.6-68.904 153.6-153.6 153.6zM512 512c-56.464 0-102.4 45.936-102.4 102.4s45.936 102.4 102.4 102.4c56.464 0 102.4-45.936 102.4-102.4s-45.936-102.4-102.4-102.4z",
						"M814.302 105.258l-9.050-36.195c-9.682-38.726-48.534-69.062-88.453-69.062h-409.6c-39.918 0-78.771 30.336-88.454 69.062l-9.048 36.195c-32.32 9.062-56.098 38.768-56.098 73.942v51.2c0 33.925 22.118 62.762 52.685 72.899l46.133 645.853c2.947 41.272 39.008 74.848 80.382 74.848h358.4c41.376 0 77.435-33.576 80.382-74.846l46.131-645.853c30.568-10.139 52.686-38.976 52.686-72.901v-51.2c0-35.174-23.778-64.88-56.098-73.942zM307.2 51.2h409.6c16.334 0 34.821 14.434 38.781 30.28l5.23 20.92h-497.622l5.23-20.92c3.96-15.846 22.446-30.28 38.781-30.28zM762.45 358.4h-500.898l-3.658-51.2h508.213l-3.658 51.2zM729.536 819.2h-435.070l-29.258-409.6h493.584l-29.256 409.6zM691.2 972.8h-358.4c-14.834 0-28.256-12.499-29.312-27.294l-5.365-75.106h427.755l-5.365 75.106c-1.058 14.795-14.48 27.294-29.314 27.294zM819.2 230.4c0 14.115-11.485 25.6-25.6 25.6h-563.2c-14.115 0-25.6-11.485-25.6-25.6v-51.2c0-14.093 11.446-25.558 25.531-25.597 0.030 0 0.059 0.003 0.090 0.003 0.050 0 0.099-0.006 0.149-0.006h563.030c14.115 0 25.6 11.485 25.6 25.6v51.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"coffee-cup",
						"drink",
						"coffee"
					],
					"defaultCode": 59464,
					"grid": 20
				},
				{
					"id": 1396,
					"width": 1060.5690612792969,
					"paths": [
						"M950.857 365.714q0-45.714-32-77.714t-77.714-32h-36.571v219.429h36.571q45.714 0 77.714-32t32-77.714zM0 804.571h1024q0 60.571-42.857 103.429t-103.429 42.857h-731.429q-60.571 0-103.429-42.857t-42.857-103.429zM1060.571 365.714q0 90.857-64.286 155.143t-155.143 64.286h-36.571v18.286q0 52.571-37.714 90.286t-90.286 37.714h-402.286q-52.571 0-90.286-37.714t-37.714-90.286v-420.571q0-14.857 10.857-25.714t25.714-10.857h658.286q90.857 0 155.143 64.286t64.286 155.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"coffee"
					],
					"defaultCode": 61684,
					"grid": 14
				},
				{
					"id": 2420,
					"paths": [
						"M933.79 610.25c-53.726-93.054-21.416-212.304 72.152-266.488l-100.626-174.292c-28.75 16.854-62.176 26.518-97.846 26.518-107.536 0-194.708-87.746-194.708-195.99h-201.258c0.266 33.41-8.074 67.282-25.958 98.252-53.724 93.056-173.156 124.702-266.862 70.758l-100.624 174.292c28.97 16.472 54.050 40.588 71.886 71.478 53.638 92.908 21.512 211.92-71.708 266.224l100.626 174.292c28.65-16.696 61.916-26.254 97.4-26.254 107.196 0 194.144 87.192 194.7 194.958h201.254c-0.086-33.074 8.272-66.57 25.966-97.218 53.636-92.906 172.776-124.594 266.414-71.012l100.626-174.29c-28.78-16.466-53.692-40.498-71.434-71.228zM512 719.332c-114.508 0-207.336-92.824-207.336-207.334 0-114.508 92.826-207.334 207.336-207.334 114.508 0 207.332 92.826 207.332 207.334-0.002 114.51-92.824 207.334-207.332 207.334z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cog",
						"gear",
						"preferences",
						"settings",
						"generate",
						"control",
						"options"
					],
					"defaultCode": 60255,
					"grid": 16
				},
				{
					"id": 2422,
					"paths": [
						"M1024 608.094v-192.188l-146.774-24.462c-5.958-18.132-13.222-35.668-21.694-52.5l86.454-121.034-135.896-135.898-120.826 86.304c-16.91-8.554-34.538-15.888-52.768-21.902l-24.402-146.414h-192.188l-24.402 146.416c-18.23 6.014-35.858 13.348-52.766 21.902l-120.828-86.304-135.898 135.898 86.454 121.036c-8.47 16.83-15.734 34.366-21.692 52.498l-146.774 24.46v192.188l147.118 24.52c5.96 17.968 13.21 35.348 21.642 52.030l-86.748 121.448 135.898 135.896 121.654-86.894c16.602 8.35 33.89 15.528 51.764 21.434l24.578 147.472h192.188l24.578-147.474c17.874-5.906 35.162-13.084 51.766-21.432l121.652 86.892 135.896-135.896-86.744-121.446c8.432-16.682 15.678-34.062 21.64-52.032l147.118-24.518zM512 640c-70.692 0-128-57.306-128-128 0-70.692 57.308-128 128-128 70.694 0 128 57.308 128 128 0 70.694-57.306 128-128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cog",
						"gear",
						"preferences",
						"settings",
						"generate",
						"control",
						"options"
					],
					"defaultCode": 60257,
					"grid": 16
				},
				{
					"id": 2423,
					"paths": [
						"M633.152 1024h-242.306l-24.404-146.424c-3.358-1.338-6.7-2.72-10.020-4.15l-120.792 86.282-171.338-171.334 86.116-120.562c-1.476-3.414-2.906-6.85-4.284-10.304l-146.124-24.358v-242.304l145.736-24.288c1.422-3.59 2.9-7.164 4.426-10.71l-85.87-120.216 171.338-171.338 119.982 85.702c3.642-1.576 7.308-3.098 10.998-4.564l24.236-145.432h242.306l24.238 145.43c3.69 1.466 7.358 2.988 10.998 4.564l119.982-85.702 171.336 171.338-85.872 120.214c1.53 3.548 3.006 7.122 4.428 10.714l145.738 24.288v242.304l-146.124 24.356c-1.378 3.456-2.806 6.89-4.284 10.302l86.116 120.562-171.336 171.336-120.794-86.282c-3.322 1.428-6.662 2.81-10.022 4.148l-24.404 146.428zM455.23 948h113.54l21.234-127.41 21.788-7.2c14.62-4.832 29.012-10.792 42.778-17.712l20.492-10.302 105.096 75.066 80.286-80.286-74.958-104.944 10.368-20.52c6.986-13.826 13.004-28.292 17.882-42.998l7.216-21.748 127.048-21.176v-113.542l-126.804-21.134-7.178-21.84c-4.876-14.846-10.908-29.442-17.926-43.38l-10.316-20.5 74.666-104.53-80.286-80.288-104.382 74.558-20.524-10.384c-13.996-7.082-28.666-13.168-43.602-18.096l-21.804-7.192-21.074-126.442h-113.54l-21.074 126.444-21.804 7.192c-14.93 4.926-29.598 11.014-43.598 18.098l-20.524 10.384-104.384-74.56-80.288 80.288 74.666 104.532-10.316 20.498c-7.016 13.942-13.046 28.536-17.924 43.38l-7.176 21.842-126.808 21.132v113.54l127.052 21.178 7.214 21.752c4.874 14.692 10.89 29.156 17.882 42.992l10.37 20.52-74.962 104.948 80.288 80.284 105.098-75.068 20.494 10.308c13.754 6.918 28.146 12.876 42.77 17.71l21.788 7.2 21.236 127.406zM544 384h-64c-52.8 0-96 43.2-96 96v64c0 52.8 43.2 96 96 96h64c52.8 0 96-43.2 96-96v-64c0-52.8-43.2-96-96-96zM576 544c0 17.6-14.4 32-32 32h-64c-17.6 0-32-14.4-32-32v-64c0-17.6 14.4-32 32-32h64c17.6 0 32 14.4 32 32v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cog",
						"gear",
						"preferences",
						"settings",
						"generate",
						"control",
						"options"
					],
					"defaultCode": 60258,
					"grid": 16
				},
				{
					"id": 2424,
					"paths": [
						"M1024 416l-225.738-22.574 143.66-175.582-135.768-135.764-175.582 143.658-22.572-225.738h-192l-22.574 225.738-175.582-143.658-135.764 135.764 143.658 175.582-225.738 22.574v192l225.738 22.574-143.658 175.582 135.764 135.766 175.582-143.66 22.574 225.738h192l22.572-225.738 175.582 143.66 135.768-135.766-143.66-175.582 225.738-22.574v-192zM512 704c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cog",
						"gear",
						"preferences",
						"settings",
						"generate",
						"control",
						"options"
					],
					"defaultCode": 60259,
					"grid": 16
				},
				{
					"id": 2425,
					"paths": [
						"M1024 416l-225.738-22.574 143.66-175.582-135.768-135.764-175.582 143.658-22.572-225.738h-192l-22.574 225.738-175.582-143.658-135.764 135.764 143.658 175.582-225.738 22.574v192l225.738 22.574-143.658 175.582 135.764 135.766 175.582-143.66 22.574 225.738h192l22.572-225.738 175.582 143.66 135.768-135.766-143.66-175.582 225.738-22.574v-192zM512 704c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z",
						"M576 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cog",
						"gear",
						"preferences",
						"settings",
						"generate",
						"control",
						"options"
					],
					"defaultCode": 60260,
					"grid": 16
				},
				{
					"id": 2426,
					"paths": [
						"M1024 448l-241.088-48.216 136.378-204.568-90.51-90.51-204.566 136.378-48.214-241.084h-128l-48.216 241.084-204.568-136.378-90.51 90.51 136.378 204.568-241.084 48.216v128l241.084 48.214-136.378 204.57 90.51 90.512 204.568-136.378 48.216 241.082h128l48.214-241.084 204.566 136.376 90.51-90.512-136.376-204.566 241.086-48.214v-128zM512 704c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cog",
						"gear",
						"preferences",
						"settings",
						"generate",
						"control",
						"options"
					],
					"defaultCode": 60261,
					"grid": 16
				},
				{
					"id": 2427,
					"paths": [
						"M1024 448l-241.088-48.216 136.378-204.568-90.51-90.51-204.566 136.378-48.214-241.084h-128l-48.216 241.084-204.568-136.378-90.51 90.51 136.378 204.568-241.084 48.216v128l241.084 48.214-136.378 204.57 90.51 90.512 204.568-136.378 48.216 241.082h128l48.214-241.084 204.566 136.376 90.51-90.512-136.376-204.566 241.086-48.214v-128zM512 704c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z",
						"M576 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cog",
						"gear",
						"preferences",
						"settings",
						"generate",
						"control",
						"options"
					],
					"defaultCode": 60262,
					"grid": 16
				},
				{
					"id": 1197,
					"width": 877.7160930633545,
					"paths": [
						"M585.143 512q0-60.571-42.857-103.429t-103.429-42.857-103.429 42.857-42.857 103.429 42.857 103.429 103.429 42.857 103.429-42.857 42.857-103.429zM877.714 449.714v126.857q0 6.857-4.571 13.143t-11.429 7.429l-105.714 16q-10.857 30.857-22.286 52 20 28.571 61.143 78.857 5.714 6.857 5.714 14.286t-5.143 13.143q-15.429 21.143-56.571 61.714t-53.714 40.571q-6.857 0-14.857-5.143l-78.857-61.714q-25.143 13.143-52 21.714-9.143 77.714-16.571 106.286-4 16-20.571 16h-126.857q-8 0-14-4.857t-6.571-12.286l-16-105.143q-28-9.143-51.429-21.143l-80.571 61.143q-5.714 5.143-14.286 5.143-8 0-14.286-6.286-72-65.143-94.286-96-4-5.714-4-13.143 0-6.857 4.571-13.143 8.571-12 29.143-38t30.857-40.286q-15.429-28.571-23.429-56.571l-104.571-15.429q-7.429-1.143-12-7.143t-4.571-13.429v-126.857q0-6.857 4.571-13.143t10.857-7.429l106.286-16q8-26.286 22.286-52.571-22.857-32.571-61.143-78.857-5.714-6.857-5.714-13.714 0-5.714 5.143-13.143 14.857-20.571 56.286-61.429t54-40.857q7.429 0 14.857 5.714l78.857 61.143q25.143-13.143 52-21.714 9.143-77.714 16.571-106.286 4-16 20.571-16h126.857q8 0 14 4.857t6.571 12.286l16 105.143q28 9.143 51.429 21.143l81.143-61.143q5.143-5.143 13.714-5.143 7.429 0 14.286 5.714 73.714 68 94.286 97.143 4 4.571 4 12.571 0 6.857-4.571 13.143-8.571 12-29.143 38t-30.857 40.286q14.857 28.571 23.429 56l104.571 16q7.429 1.143 12 7.143t4.571 13.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cog",
						"gear"
					],
					"defaultCode": 61459,
					"grid": 14
				},
				{
					"id": 111,
					"paths": [
						"M390.71 1008.755c-2.109 0-4.248-0.262-6.378-0.81-45.976-11.803-90.149-30.042-131.291-54.21-11.923-7.003-16.13-22.21-9.501-34.344 8.15-14.925 12.459-31.866 12.459-48.992 0-56.464-45.936-102.4-102.4-102.4-17.125 0-34.066 4.309-48.992 12.459-12.133 6.627-27.339 2.421-34.342-9.501-24.17-41.142-42.408-85.315-54.211-131.293-3.333-12.989 3.92-26.349 16.629-30.629 41.699-14.037 69.717-53.034 69.717-97.037s-28.018-83-69.718-97.040c-12.707-4.278-19.962-17.638-16.627-30.627 11.803-45.976 30.042-90.149 54.211-131.291 7.003-11.923 22.21-16.13 34.344-9.501 14.923 8.15 31.864 12.459 48.99 12.459 56.464 0 102.4-45.936 102.4-102.4 0-17.126-4.309-34.067-12.459-48.99-6.629-12.134-2.422-27.341 9.501-34.344 41.141-24.168 85.314-42.408 131.291-54.211 12.994-3.334 26.349 3.92 30.627 16.627 14.040 41.701 53.037 69.718 97.040 69.718s83-28.018 97.038-69.717c4.28-12.71 17.645-19.965 30.629-16.629 45.976 11.802 90.15 30.042 131.293 54.211 11.922 7.003 16.128 22.208 9.501 34.342-8.152 14.926-12.461 31.867-12.461 48.992 0 56.464 45.936 102.4 102.4 102.4 17.126 0 34.067-4.309 48.992-12.459 12.138-6.629 27.341-2.421 34.344 9.501 24.166 41.141 42.406 85.314 54.21 131.291 3.334 12.989-3.918 26.349-16.627 30.627-41.701 14.040-69.718 53.037-69.718 97.040s28.018 83 69.718 97.038c12.707 4.28 19.962 17.638 16.627 30.629-11.803 45.976-30.042 90.15-54.21 131.291-7.005 11.925-22.208 16.128-34.344 9.502-14.926-8.152-31.867-12.461-48.992-12.461-56.464 0-102.4 45.936-102.4 102.4 0 17.125 4.309 34.066 12.461 48.992 6.627 12.136 2.421 27.341-9.502 34.344-41.141 24.166-85.314 42.406-131.291 54.21-12.992 3.336-26.349-3.918-30.629-16.627-14.038-41.701-53.035-69.718-97.038-69.718s-83 28.018-97.040 69.718c-3.578 10.624-13.502 17.437-24.25 17.437zM512 870.4c57.715 0 109.693 32.138 135.917 82.029 26.637-8.218 52.507-18.875 77.299-31.846-5.541-16.077-8.416-33.075-8.416-50.182 0-84.696 68.904-153.6 153.6-153.6 17.107 0 34.106 2.875 50.181 8.418 12.971-24.792 23.63-50.662 31.846-77.299-49.89-26.226-82.027-78.203-82.027-135.918s32.138-109.691 82.029-135.918c-8.218-26.637-18.875-52.506-31.846-77.299-16.077 5.542-33.074 8.418-50.182 8.418-84.696 0-153.6-68.904-153.6-153.6 0-17.107 2.875-34.106 8.418-50.181-24.792-12.971-50.662-23.63-77.299-31.846-26.226 49.89-78.203 82.027-135.918 82.027s-109.691-32.138-135.917-82.027c-26.637 8.216-52.507 18.874-77.299 31.846 5.542 16.075 8.416 33.072 8.416 50.181 0 84.696-68.904 153.6-153.6 153.6-17.109 0-34.106-2.874-50.181-8.418-12.973 24.794-23.63 50.662-31.846 77.299 49.89 26.227 82.027 78.203 82.027 135.918s-32.138 109.693-82.027 135.917c8.216 26.637 18.875 52.507 31.846 77.299 16.075-5.541 33.074-8.416 50.181-8.416 84.696 0 153.6 68.904 153.6 153.6 0 17.109-2.875 34.106-8.418 50.181 24.794 12.971 50.662 23.63 77.299 31.846 26.227-49.89 78.203-82.027 135.918-82.027z",
						"M512 665.6c-84.696 0-153.6-68.904-153.6-153.6s68.904-153.6 153.6-153.6 153.6 68.904 153.6 153.6-68.904 153.6-153.6 153.6zM512 409.6c-56.464 0-102.4 45.936-102.4 102.4s45.936 102.4 102.4 102.4c56.464 0 102.4-45.936 102.4-102.4s-45.936-102.4-102.4-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cog",
						"gear",
						"preferences",
						"settings",
						"generate",
						"control",
						"options"
					],
					"defaultCode": 59408,
					"grid": 20
				},
				{
					"id": 2421,
					"paths": [
						"M363.722 722.052l41.298-57.816-45.254-45.256-57.818 41.296c-10.722-5.994-22.204-10.774-34.266-14.192l-11.682-70.084h-64l-11.68 70.086c-12.062 3.418-23.544 8.198-34.266 14.192l-57.818-41.298-45.256 45.256 41.298 57.816c-5.994 10.72-10.774 22.206-14.192 34.266l-70.086 11.682v64l70.086 11.682c3.418 12.060 8.198 23.544 14.192 34.266l-41.298 57.816 45.254 45.256 57.818-41.296c10.722 5.994 22.204 10.774 34.266 14.192l11.682 70.084h64l11.68-70.086c12.062-3.418 23.544-8.198 34.266-14.192l57.818 41.296 45.254-45.256-41.298-57.816c5.994-10.72 10.774-22.206 14.192-34.266l70.088-11.68v-64l-70.086-11.682c-3.418-12.060-8.198-23.544-14.192-34.266zM224 864c-35.348 0-64-28.654-64-64s28.652-64 64-64 64 28.654 64 64-28.652 64-64 64zM1024 384v-64l-67.382-12.25c-1.242-8.046-2.832-15.978-4.724-23.79l57.558-37.1-24.492-59.128-66.944 14.468c-4.214-6.91-8.726-13.62-13.492-20.13l39.006-56.342-45.256-45.254-56.342 39.006c-6.512-4.766-13.22-9.276-20.13-13.494l14.468-66.944-59.128-24.494-37.1 57.558c-7.812-1.892-15.744-3.482-23.79-4.724l-12.252-67.382h-64l-12.252 67.382c-8.046 1.242-15.976 2.832-23.79 4.724l-37.098-57.558-59.128 24.492 14.468 66.944c-6.91 4.216-13.62 8.728-20.13 13.494l-56.342-39.006-45.254 45.254 39.006 56.342c-4.766 6.51-9.278 13.22-13.494 20.13l-66.944-14.468-24.492 59.128 57.558 37.1c-1.892 7.812-3.482 15.742-4.724 23.79l-67.384 12.252v64l67.382 12.25c1.242 8.046 2.832 15.978 4.724 23.79l-57.558 37.1 24.492 59.128 66.944-14.468c4.216 6.91 8.728 13.618 13.494 20.13l-39.006 56.342 45.254 45.256 56.342-39.006c6.51 4.766 13.22 9.276 20.13 13.492l-14.468 66.944 59.128 24.492 37.102-57.558c7.81 1.892 15.742 3.482 23.788 4.724l12.252 67.384h64l12.252-67.382c8.044-1.242 15.976-2.832 23.79-4.724l37.1 57.558 59.128-24.492-14.468-66.944c6.91-4.216 13.62-8.726 20.13-13.492l56.342 39.006 45.256-45.256-39.006-56.342c4.766-6.512 9.276-13.22 13.492-20.13l66.944 14.468 24.492-59.13-57.558-37.1c1.892-7.812 3.482-15.742 4.724-23.79l67.382-12.25zM672 491.2c-76.878 0-139.2-62.322-139.2-139.2s62.32-139.2 139.2-139.2 139.2 62.322 139.2 139.2c0 76.878-62.32 139.2-139.2 139.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cogs",
						"gears",
						"preferences",
						"settings",
						"generate",
						"control",
						"options"
					],
					"defaultCode": 60256,
					"grid": 16
				},
				{
					"id": 1304,
					"width": 1097.143030166626,
					"paths": [
						"M512 512q0-60.571-42.857-103.429t-103.429-42.857-103.429 42.857-42.857 103.429 42.857 103.429 103.429 42.857 103.429-42.857 42.857-103.429zM950.857 804.571q0-29.714-21.714-51.429t-51.429-21.714-51.429 21.714-21.714 51.429q0 30.286 21.429 51.714t51.714 21.429 51.714-21.429 21.429-51.714zM950.857 219.429q0-29.714-21.714-51.429t-51.429-21.714-51.429 21.714-21.714 51.429q0 30.286 21.429 51.714t51.714 21.429 51.714-21.429 21.429-51.714zM731.429 460v105.714q0 5.714-4 11.143t-9.143 6l-88.571 13.714q-6.286 20-18.286 43.429 19.429 27.429 51.429 65.714 4 5.714 4 11.429 0 6.857-4 10.857-13.143 17.143-47.143 51.143t-44.857 34q-6.286 0-12-4l-65.714-51.429q-21.143 10.857-44 17.714-6.286 61.714-13.143 88.571-4 13.714-17.143 13.714h-106.286q-6.286 0-11.429-4.286t-5.714-10l-13.143-87.429q-19.429-5.714-42.857-17.714l-67.429 50.857q-4 4-11.429 4-6.286 0-12-4.571-82.286-76-82.286-91.429 0-5.143 4-10.857 5.714-8 23.429-30.286t26.857-34.857q-13.143-25.143-20-46.857l-86.857-13.714q-5.714-0.571-9.714-5.429t-4-11.143v-105.714q0-5.714 4-11.143t9.143-6l88.571-13.714q6.286-20 18.286-43.429-19.429-27.429-51.429-65.714-4-6.286-4-11.429 0-6.857 4-11.429 12.571-17.143 46.857-50.857t45.143-33.714q6.286 0 12 4l65.714 51.429q19.429-10.286 44-18.286 6.286-61.714 13.143-88 4-13.714 17.143-13.714h106.286q6.286 0 11.429 4.286t5.714 10l13.143 87.429q19.429 5.714 42.857 17.714l67.429-50.857q4.571-4 11.429-4 6.286 0 12 4.571 82.286 76 82.286 91.429 0 5.143-4 10.857-6.857 9.143-24 30.857t-25.714 34.286q13.143 27.429 19.429 46.857l86.857 13.143q5.714 1.143 9.714 6t4 11.143zM1097.143 764.571v80q0 9.143-85.143 17.714-6.857 15.429-17.143 29.714 29.143 64.571 29.143 78.857 0 2.286-2.286 4-69.714 40.571-70.857 40.571-4.571 0-26.286-26.857t-29.714-38.857q-11.429 1.143-17.143 1.143t-17.143-1.143q-8 12-29.714 38.857t-26.286 26.857q-1.143 0-70.857-40.571-2.286-1.714-2.286-4 0-14.286 29.143-78.857-10.286-14.286-17.143-29.714-85.143-8.571-85.143-17.714v-80q0-9.143 85.143-17.714 7.429-16.571 17.143-29.714-29.143-64.571-29.143-78.857 0-2.286 2.286-4 2.286-1.143 20-11.429t33.714-19.429 17.143-9.143q4.571 0 26.286 26.571t29.714 38.571q11.429-1.143 17.143-1.143t17.143 1.143q29.143-40.571 52.571-64l3.429-1.143q2.286 0 70.857 40 2.286 1.714 2.286 4 0 14.286-29.143 78.857 9.714 13.143 17.143 29.714 85.143 8.571 85.143 17.714zM1097.143 179.429v80q0 9.143-85.143 17.714-6.857 15.429-17.143 29.714 29.143 64.571 29.143 78.857 0 2.286-2.286 4-69.714 40.571-70.857 40.571-4.571 0-26.286-26.857t-29.714-38.857q-11.429 1.143-17.143 1.143t-17.143-1.143q-8 12-29.714 38.857t-26.286 26.857q-1.143 0-70.857-40.571-2.286-1.714-2.286-4 0-14.286 29.143-78.857-10.286-14.286-17.143-29.714-85.143-8.571-85.143-17.714v-80q0-9.143 85.143-17.714 7.429-16.571 17.143-29.714-29.143-64.571-29.143-78.857 0-2.286 2.286-4 2.286-1.143 20-11.429t33.714-19.429 17.143-9.143q4.571 0 26.286 26.571t29.714 38.571q11.429-1.143 17.143-1.143t17.143 1.143q29.143-40.571 52.571-64l3.429-1.143q2.286 0 70.857 40 2.286 1.714 2.286 4 0 14.286-29.143 78.857 9.714 13.143 17.143 29.714 85.143 8.571 85.143 17.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cogs",
						"gears"
					],
					"defaultCode": 61573,
					"grid": 14
				},
				{
					"id": 2080,
					"paths": [
						"M480 64c-265.096 0-480 214.904-480 480 0 265.098 214.904 480 480 480 265.098 0 480-214.902 480-480 0-265.096-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM512 512v-128h128v-64h-128v-64h-64v64h-128v256h128v128h-128v64h128v64h64v-64h128.002l-0.002-256h-128zM448 512h-64v-128h64v128zM576.002 704h-64.002v-128h64.002v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"coin-dollar",
						"money",
						"cash",
						"currency-dollar"
					],
					"defaultCode": 59915,
					"grid": 16
				},
				{
					"id": 2081,
					"paths": [
						"M480 64c-265.096 0-480 214.904-480 480s214.904 480 480 480c265.098 0 480-214.902 480-480s-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.076 0 384 171.922 384 384s-171.924 384-384 384z",
						"M670.824 644.34c-15.27-8.884-34.862-3.708-43.75 11.57-17.256 29.662-49.088 48.090-83.074 48.090h-128c-41.716 0-77.286-26.754-90.496-64h154.496c17.672 0 32-14.326 32-32s-14.328-32-32-32h-160v-64h160c17.672 0 32-14.328 32-32s-14.328-32-32-32h-154.496c13.21-37.246 48.78-64 90.496-64h128c33.986 0 65.818 18.426 83.074 48.090 8.888 15.276 28.478 20.456 43.752 11.568 15.276-8.888 20.456-28.476 11.568-43.752-28.672-49.288-81.702-79.906-138.394-79.906h-128c-77.268 0-141.914 55.056-156.78 128h-35.22c-17.672 0-32 14.328-32 32s14.328 32 32 32h32v64h-32c-17.672 0-32 14.326-32 32s14.328 32 32 32h35.22c14.866 72.944 79.512 128 156.78 128h128c56.692 0 109.72-30.62 138.394-79.91 8.888-15.276 3.708-34.864-11.57-43.75z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"coin-euro",
						"money",
						"cash",
						"currency-euro"
					],
					"defaultCode": 59916,
					"grid": 16
				},
				{
					"id": 2082,
					"paths": [
						"M480 64c-265.096 0-480 214.904-480 480s214.904 480 480 480c265.098 0 480-214.902 480-480s-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.074 0 384 171.922 384 384s-171.926 384-384 384z",
						"M608 704h-224v-128h96c17.672 0 32-14.326 32-32s-14.328-32-32-32h-96v-32c0-52.934 43.066-96 96-96 34.17 0 66.042 18.404 83.18 48.030 8.85 15.298 28.426 20.526 43.722 11.676 15.296-8.848 20.526-28.424 11.676-43.722-28.538-49.336-81.638-79.984-138.578-79.984-88.224 0-160 71.776-160 160v32h-32c-17.672 0-32 14.326-32 32s14.328 32 32 32h32v192h288c17.674 0 32-14.326 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"coin-pound",
						"money",
						"cash",
						"currency-pound"
					],
					"defaultCode": 59917,
					"grid": 16
				},
				{
					"id": 2083,
					"paths": [
						"M480 64c-265.096 0-480 214.904-480 480s214.904 480 480 480c265.098 0 480-214.902 480-480s-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.076 0 384 171.922 384 384s-171.924 384-384 384z",
						"M608 576c17.674 0 32-14.326 32-32s-14.326-32-32-32h-68.208l94.832-142.25c9.804-14.704 5.83-34.572-8.876-44.376-14.704-9.802-34.572-5.83-44.376 8.876l-101.372 152.062-101.374-152.062c-9.804-14.706-29.672-18.68-44.376-8.876-14.706 9.804-18.678 29.672-8.876 44.376l94.834 142.25h-68.208c-17.672 0-32 14.326-32 32s14.328 32 32 32h96v64h-96c-17.672 0-32 14.326-32 32s14.328 32 32 32h96v96c0 17.674 14.328 32 32 32s32-14.326 32-32v-96h96c17.674 0 32-14.326 32-32s-14.326-32-32-32h-96v-64h96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"coin-yen",
						"money",
						"cash",
						"currency-yen"
					],
					"defaultCode": 59918,
					"grid": 16
				},
				{
					"id": 2079,
					"paths": [
						"M670.666 317.334c-23.296 0-46.060 2.28-68.098 6.584-1.746-1.318-3.526-2.628-5.388-3.916 27.228-18.828 42.82-40.684 42.82-64v-64.002c0-70.692-143.268-128-320-128s-320 57.308-320 128v64c0 23.316 15.592 45.172 42.82 64-27.228 18.828-42.82 40.684-42.82 64v64c0 23.316 15.592 45.172 42.822 64-27.23 18.828-42.822 40.686-42.822 64v64c0 23.316 15.592 45.172 42.82 64-27.228 18.828-42.82 40.686-42.82 64v64c0 70.694 143.268 128 320 128 47.232 0 92.042-4.114 132.4-11.46 60.088 47.264 135.886 75.46 218.266 75.46 195.142 0 353.334-158.194 353.334-353.334s-158.192-353.332-353.334-353.332zM32 192c0-19.046 28.894-42.912 73.61-60.798 56.75-22.7 132.89-35.202 214.39-35.202s157.64 12.502 214.39 35.202c44.716 17.886 73.61 41.752 73.61 60.798s-28.894 42.912-73.61 60.798c-18.46 7.384-38.984 13.682-61.066 18.828-45.798 10.674-98.334 16.374-153.324 16.374s-107.526-5.7-153.326-16.374c-22.082-5.146-42.604-11.444-61.064-18.828-44.716-17.886-73.61-41.752-73.61-60.798zM32 576c0-14.134 15.922-30.92 42.406-45.95 58.7 28.082 146.926 45.95 245.594 45.95 3.42 0 6.812-0.046 10.204-0.094-8.376 30.16-12.872 61.934-12.872 94.76 0 0.44 0.014 0.876 0.016 1.316-54.026-0.18-105.616-5.854-150.678-16.356-22.080-5.146-42.602-11.444-61.062-18.826-44.714-17.886-73.608-41.754-73.608-60.8zM320 864c-81.5 0-157.64-12.5-214.39-35.2-44.716-17.886-73.61-41.754-73.61-60.8 0-14.134 15.922-30.92 42.406-45.95 58.7 28.082 146.926 45.95 245.594 45.95 3.648 0 7.27-0.046 10.886-0.1 9.64 33.746 24.176 65.426 42.782 94.228-17.522 1.226-35.452 1.872-53.668 1.872zM320 480c-54.988 0-107.526-5.7-153.324-16.374-22.082-5.146-42.606-11.444-61.066-18.828-44.716-17.886-73.61-41.752-73.61-60.798 0-14.134 15.922-30.92 42.404-45.95 58.7 28.082 146.926 45.95 245.596 45.95 65.922 0 127.138-8.002 178.044-21.672-49.976 28.040-92.44 67.87-123.622 115.73-17.762 1.262-35.94 1.942-54.422 1.942zM670.666 959.758c-159.66 0-289.090-129.43-289.090-289.092 0-159.66 129.43-289.090 289.090-289.090 159.662 0 289.092 129.43 289.092 289.090 0 159.662-129.43 289.092-289.092 289.092zM704 448h-64v64h-128v192h128v64h-128v64h128v64h64v-64h128v-192h-128v-64h128v-64h-128v-64zM640 640h-64v-64h64v64zM768 704v64h-64v-64h64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"coins",
						"money",
						"cash",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59914,
					"grid": 16
				},
				{
					"id": 381,
					"width": 1024,
					"paths": [
						"M800 544c-42.336 0-79.616 20.832-102.912 52.512l-152.096-84.512 152.096-84.512c23.296 31.68 60.544 52.512 102.912 52.512 70.688 0 128-57.312 128-128s-57.312-128-128-128c-70.688 0-128 57.312-128 128 0 16.832 3.456 32.832 9.344 47.584l-153.344 85.216v-166.4c63.040-7.968 112-61.184 112-126.4 0-70.688-57.312-128-128-128s-128 57.312-128 128c0 65.216 48.96 118.432 112 126.4v166.4l-153.376-85.216c5.92-14.752 9.376-30.752 9.376-47.584 0-70.688-57.312-128-128-128s-128 57.312-128 128c0 70.688 57.312 128 128 128 42.368 0 79.616-20.832 102.912-52.512l152.096 84.512-152.128 84.512c-23.264-31.68-60.512-52.512-102.88-52.512-70.688 0-128 57.312-128 128s57.312 128 128 128c70.688 0 128-57.312 128-128 0-16.832-3.456-32.832-9.376-47.584l153.376-85.216v166.4c-63.040 7.968-112 61.184-112 126.4 0 70.688 57.312 128 128 128s128-57.312 128-128c0-65.216-48.96-118.432-112-126.4v-166.4l153.376 85.216c-5.92 14.72-9.376 30.72-9.376 47.584 0 70.688 57.312 128 128 128s128-57.312 128-128c0-70.688-57.312-128-128-128zM800 256c52.928 0 96 43.072 96 96s-43.072 96-96 96c-52.928 0-96-43.072-96-96s43.072-96 96-96zM224 448c-52.928 0-96-43.072-96-96s43.072-96 96-96c52.928 0 96 43.072 96 96s-43.072 96-96 96zM224 768c-52.928 0-96-43.072-96-96s43.072-96 96-96c52.928 0 96 43.072 96 96s-43.072 96-96 96zM416 192c0-52.928 43.072-96 96-96s96 43.072 96 96c0 52.928-43.072 96-96 96s-96-43.072-96-96zM608 832c0 52.928-43.072 96-96 96s-96-43.072-96-96c0-52.928 43.072-96 96-96s96 43.072 96 96zM800 768c-52.928 0-96-43.072-96-96s43.072-96 96-96c52.928 0 96 43.072 96 96s-43.072 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"collaborate",
						"combine",
						"contribute"
					],
					"grid": 32
				},
				{
					"id": 382,
					"width": 1024,
					"paths": [
						"M800 544c-42.336 0-79.616 20.832-102.912 52.512l-152.096-84.512 152.096-84.512c23.296 31.68 60.544 52.512 102.912 52.512 70.688 0 128-57.312 128-128s-57.312-128-128-128c-70.688 0-128 57.312-128 128 0 16.832 3.456 32.832 9.344 47.584l-153.344 85.216v-166.4c63.040-7.968 112-61.184 112-126.4 0-70.688-57.312-128-128-128s-128 57.312-128 128c0 65.216 48.96 118.432 112 126.4v166.4l-153.376-85.216c5.92-14.752 9.376-30.752 9.376-47.584 0-70.688-57.312-128-128-128s-128 57.312-128 128c0 70.688 57.312 128 128 128 42.368 0 79.616-20.832 102.912-52.512l152.096 84.512-152.128 84.512c-23.264-31.68-60.512-52.512-102.88-52.512-70.688 0-128 57.312-128 128s57.312 128 128 128c70.688 0 128-57.312 128-128 0-16.832-3.456-32.832-9.376-47.584l153.376-85.216v166.4c-63.040 7.968-112 61.184-112 126.4 0 70.688 57.312 128 128 128s128-57.312 128-128c0-65.216-48.96-118.432-112-126.4v-166.4l153.376 85.216c-5.92 14.72-9.376 30.72-9.376 47.584 0 70.688 57.312 128 128 128s128-57.312 128-128c0-70.688-57.312-128-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"collaborate",
						"combine",
						"contribute"
					],
					"grid": 32
				},
				{
					"id": 2341,
					"paths": [
						"M256 224c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M160 320c-88.366 0-160 28.654-160 64v64h320v-64c0-35.346-71.634-64-160-64z",
						"M896 224c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M800 320c-88.366 0-160 28.654-160 64v64h320v-64c0-35.346-71.634-64-160-64z",
						"M576 736c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M480 832c-88.366 0-160 28.654-160 64v64h320v-64c0-35.346-71.634-64-160-64z",
						"M608 256h-256c-17.672 0-32-14.328-32-32s14.328-32 32-32h256c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M671.972 768.004c-6.1 0-12.266-1.74-17.72-5.378-14.706-9.802-18.68-29.67-8.876-44.376l128-192c9.802-14.706 29.674-18.676 44.376-8.876 14.706 9.802 18.68 29.672 8.876 44.376l-128 192c-6.168 9.25-16.316 14.254-26.656 14.254z",
						"M288.030 768.004c-10.34 0-20.488-5.004-26.656-14.254l-128-192c-9.802-14.704-5.83-34.572 8.876-44.376 14.704-9.806 34.572-5.832 44.376 8.876l128 192c9.802 14.706 5.83 34.572-8.876 44.376-5.454 3.636-11.622 5.378-17.72 5.378z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"collaboration",
						"group",
						"team"
					],
					"defaultCode": 60176,
					"grid": 16
				},
				{
					"id": 383,
					"width": 1024,
					"paths": [
						"M640 336c0 8.832-7.168 16-16 16h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16zM400 352h-64c-8.832 0-16 7.168-16 16s7.168 16 16 16h64c8.832 0 16-7.168 16-16s-7.168-16-16-16zM400 416h-64c-8.832 0-16 7.168-16 16s7.168 16 16 16h64c8.832 0 16-7.168 16-16s-7.168-16-16-16zM880.608 506.368l-95.616 8.352c-8.768 0.768-15.328 8.544-14.528 17.344 0.704 8.32 7.712 14.592 15.904 14.592 0.48 0 0.928-0.032 1.44-0.064l95.616-8.352c8.768-0.768 15.328-8.544 14.528-17.344-0.8-8.768-8.256-15.328-17.344-14.528zM990.976 850.048c4.608 52.832-34.464 99.392-87.264 104l-63.744 5.568c-2.848 0.256-5.664 0.384-8.48 0.384-49.248 0-91.168-37.664-95.52-87.648l-31.968-365.344v356.992c0 53.024-42.976 96-96 96h-64c-33.44 0-62.816-17.12-80-43.040-17.184 25.92-46.56 43.040-80 43.040h-32c-33.44 0-62.816-17.12-80-43.040-17.184 25.92-46.56 43.040-80 43.040h-64c-53.024 0-96-42.976-96-96v-640c0-53.024 42.976-96 96-96h64c53.024 0 96 42.976 96 96v56.928c17.024-15.328 39.296-24.928 64-24.928h32c24.704 0 46.976 9.6 64 24.928v-88.928c0-53.024 42.976-96 96-96h64c53.024 0 96 42.976 96 96v227.968c11.552-35.552 43.392-62.592 82.976-66.048l63.744-5.568c2.848-0.256 5.664-0.384 8.48-0.384 49.248 0 91.168 37.664 95.52 87.648l36.256 414.432zM256 864v-640c0-35.296-28.704-64-64-64h-64c-35.296 0-64 28.704-64 64v640c0 35.296 28.704 64 64 64h64c35.296 0 64-28.704 64-64zM448 352c0-35.296-28.704-64-64-64h-32c-35.296 0-64 28.704-64 64v512c0 35.296 28.704 64 64 64h32c35.296 0 64-28.704 64-64v-512zM672 192c0-35.296-28.704-64-64-64h-64c-35.296 0-64 28.704-64 64v672c0 35.296 28.704 64 64 64h64c35.296 0 64-28.704 64-64v-672zM959.104 852.832l-36.256-414.432c-2.88-32.768-30.816-58.432-63.648-58.432-1.888 0-3.776 0.096-5.696 0.256l-63.744 5.568c-17.024 1.504-32.448 9.536-43.456 22.624-10.976 13.088-16.224 29.696-14.72 46.72l36.256 414.432c2.88 32.768 30.816 58.432 63.648 58.432 1.888 0 3.776-0.096 5.696-0.256l63.744-5.568c17.024-1.504 32.448-9.536 43.456-22.624s16.224-29.696 14.72-46.72zM782.176 482.848l95.648-8.384c8.768-0.768 15.328-8.544 14.528-17.344-0.736-8.768-8.192-15.328-17.344-14.528l-95.648 8.384c-8.768 0.768-15.328 8.544-14.528 17.344 0.704 8.32 7.712 14.592 15.904 14.592 0.48 0 0.96-0.032 1.44-0.064zM624 192h-96c-8.832 0-16 7.168-16 16s7.168 16 16 16h96c8.832 0 16-7.168 16-16s-7.168-16-16-16zM624 256h-96c-8.832 0-16 7.168-16 16s7.168 16 16 16h96c8.832 0 16-7.168 16-16s-7.168-16-16-16zM208 352h-96c-8.832 0-16 7.168-16 16s7.168 16 16 16h96c8.832 0 16-7.168 16-16s-7.168-16-16-16zM208 224h-96c-8.832 0-16 7.168-16 16s7.168 16 16 16h96c8.832 0 16-7.168 16-16s-7.168-16-16-16zM208 288h-96c-8.832 0-16 7.168-16 16s7.168 16 16 16h96c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"collect",
						"read"
					],
					"grid": 32
				},
				{
					"id": 384,
					"width": 1024,
					"paths": [
						"M954.72 435.616c-4.384-49.984-46.272-87.648-95.52-87.648-2.816 0-5.632 0.128-8.48 0.384l-63.744 5.568c-39.584 3.456-71.424 30.496-82.976 66.048v-227.968c0-53.024-42.976-96-96-96h-64c-53.024 0-96 42.976-96 96v88.928c-17.024-15.328-39.296-24.928-64-24.928h-32c-24.704 0-46.976 9.6-64 24.928v-56.928c0-53.024-42.976-96-96-96h-64c-53.024 0-96 42.976-96 96v640c0 53.024 42.976 96 96 96h64c33.44 0 62.816-17.12 80-43.040 17.184 25.92 46.56 43.040 80 43.040h32c33.44 0 62.816-17.12 80-43.040 17.184 25.92 46.56 43.040 80 43.040h64c53.024 0 96-42.976 96-96v-356.992l31.968 365.344c4.352 49.984 46.272 87.648 95.52 87.648 2.816 0 5.632-0.128 8.48-0.384l63.744-5.568c52.832-4.608 91.904-51.168 87.264-104l-36.256-414.432zM208 384h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM208 320h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM208 256h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM400 448h-64c-8.832 0-16-7.168-16-16s7.168-16 16-16h64c8.832 0 16 7.168 16 16s-7.168 16-16 16zM400 384h-64c-8.832 0-16-7.168-16-16s7.168-16 16-16h64c8.832 0 16 7.168 16 16s-7.168 16-16 16zM624 352h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM624 288h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM624 224h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM764.832 468.32c-0.768-8.8 5.76-16.576 14.528-17.344l95.648-8.384c9.152-0.8 16.608 5.76 17.344 14.528 0.768 8.8-5.76 16.576-14.528 17.344l-95.648 8.384c-0.512 0.032-0.96 0.064-1.44 0.064-8.16 0-15.168-6.272-15.904-14.592zM883.392 538.24l-95.616 8.352c-0.512 0.032-0.96 0.064-1.44 0.064-8.192 0-15.2-6.272-15.904-14.592-0.768-8.8 5.76-16.576 14.528-17.344l95.616-8.352c9.088-0.8 16.576 5.76 17.344 14.528 0.8 8.832-5.728 16.576-14.528 17.344z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"collect",
						"read"
					],
					"grid": 32
				},
				{
					"id": 1868,
					"paths": [
						"M1005.256 914.744l-832-832-90.51 90.51 148.86 148.86c-28.992 48.528-53.584 99.028-72.232 151.046-40.664 113.436-44.682 236.562 12.584 345.4 65.846 125.142 198.632 205.44 340.042 205.44 111.326 0 217.296-49.776 289.478-132.010l113.266 113.266 90.512-90.512z",
						"M864.626 473.162c-65.754-183.44-205.11-348.15-352.626-473.162-51.536 43.674-102.060 92.206-148.814 144.676l530.414 530.414c5.77-67.46-5.454-136.312-28.974-201.928z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"color-clear",
						"droplet"
					],
					"defaultCode": 59703,
					"grid": 16
				},
				{
					"id": 1857,
					"paths": [
						"M736 704h-704c-17.672 0-32 14.326-32 32v192c0 17.674 14.328 32 32 32h704c17.674 0 32-14.326 32-32v-192c0-17.674-14.326-32-32-32zM640 896c-35.346 0-64-28.652-64-64s28.654-64 64-64 64 28.652 64 64-28.654 64-64 64z",
						"M768 677.158v-453.158c0-17.672-14.326-32-32-32h-192c-17.674 0-32 14.328-32 32v197.158l256 256z",
						"M1004.656 297.358l-172.656-83.336v514.658l187.566-388.592c7.682-15.918 1.008-35.046-14.91-42.73z",
						"M629.020 640l-328.43-328.432c-12.498-12.496-32.758-12.496-45.254 0l-135.764 135.766c-12.498 12.496-12.498 32.758 0 45.254l147.408 147.412h362.040z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"color-sampler",
						"colors",
						"style",
						"design",
						"art"
					],
					"defaultCode": 59692,
					"grid": 16
				},
				{
					"id": 1373,
					"width": 950.8579902648926,
					"paths": [
						"M91.429 877.714h347.429v-658.286h-365.714v640q0 7.429 5.429 12.857t12.857 5.429zM877.714 859.429v-640h-365.714v658.286h347.429q7.429 0 12.857-5.429t5.429-12.857zM950.857 164.571v694.857q0 37.714-26.857 64.571t-64.571 26.857h-768q-37.714 0-64.571-26.857t-26.857-64.571v-694.857q0-37.714 26.857-64.571t64.571-26.857h768q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"columns"
					],
					"defaultCode": 61659,
					"grid": 14
				},
				{
					"id": 3229,
					"paths": [
						"M896 320h-832c-35.346 0-64 28.654-64 64v352c0 17.674 14.328 32 32 32s32-14.326 32-32v-224h64v224c0 17.674 14.328 32 32 32s32-14.326 32-32v-224h64v224c0 17.674 14.328 32 32 32s32-14.326 32-32v-224h64v224c0 17.674 14.328 32 32 32s32-14.326 32-32v-224h64v224c0 17.674 14.326 32 32 32s32-14.326 32-32v-224h64v224c0 17.674 14.326 32 32 32s32-14.326 32-32v-224h64v224c0 17.674 14.326 32 32 32s32-14.326 32-32v-224h64v224c0 17.674 14.326 32 32 32s32-14.326 32-32v-352c0-35.346-28.654-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"comb"
					],
					"defaultCode": 61064,
					"grid": 16
				},
				{
					"id": 3191,
					"paths": [
						"M736 896c-88.224 0-160-71.776-160-160v-96h-128v96c0 88.224-71.776 160-160 160s-160-71.776-160-160 71.776-160 160-160h96v-128h-96c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160v96h128v-96c0-88.224 71.776-160 160-160s160 71.776 160 160-71.776 160-160 160h-96v128h96c88.224 0 160 71.776 160 160s-71.774 160-160 160zM640 640v96c0 52.934 43.066 96 96 96s96-43.066 96-96-43.066-96-96-96h-96zM288 640c-52.934 0-96 43.066-96 96s43.066 96 96 96 96-43.066 96-96v-96h-96zM448 576h128v-128h-128v128zM640 384h96c52.934 0 96-43.066 96-96s-43.066-96-96-96-96 43.066-96 96v96zM288 192c-52.934 0-96 43.066-96 96s43.066 96 96 96h96v-96c0-52.934-43.064-96-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"command",
						"cmd"
					],
					"defaultCode": 61026,
					"grid": 16
				},
				{
					"id": 1289,
					"width": 1023.9970550537109,
					"paths": [
						"M1024 512q0 99.429-68.571 183.714t-186.286 133.143-257.143 48.857q-40 0-82.857-4.571-113.143 100-262.857 138.286-28 8-65.143 12.571-9.714 1.143-17.429-5.143t-10-16.571v-0.571q-1.714-2.286-0.286-6.857t1.143-5.714 2.571-5.429l3.429-5.143t4-4.857 4.571-5.143q4-4.571 17.714-19.714t19.714-21.714 17.714-22.571 18.571-29.143 15.429-33.714 14.857-43.429q-89.714-50.857-141.429-125.714t-51.714-160.571q0-74.286 40.571-142t109.143-116.857 163.429-78 198.857-28.857q139.429 0 257.143 48.857t186.286 133.143 68.571 183.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"comment"
					],
					"defaultCode": 61557,
					"grid": 14
				},
				{
					"id": 1382,
					"width": 1023.9970550537109,
					"paths": [
						"M512 219.429q-116.571 0-218 39.714t-161.143 107.143-59.714 145.714q0 64 40.857 122t115.143 100.286l49.714 28.571-15.429 54.857q-13.714 52-40 98.286 86.857-36 157.143-97.714l24.571-21.714 32.571 3.429q39.429 4.571 74.286 4.571 116.571 0 218-39.714t161.143-107.143 59.714-145.714-59.714-145.714-161.143-107.143-218-39.714zM1024 512q0 99.429-68.571 183.714t-186.286 133.143-257.143 48.857q-40 0-82.857-4.571-113.143 100-262.857 138.286-28 8-65.143 12.571h-2.857q-8.571 0-15.429-6t-9.143-15.714v-0.571q-1.714-2.286-0.286-6.857t1.143-5.714 2.571-5.429l3.429-5.143t4-4.857 4.571-5.143q4-4.571 17.714-19.714t19.714-21.714 17.714-22.571 18.571-29.143 15.429-33.714 14.857-43.429q-89.714-50.857-141.429-125.714t-51.714-160.571q0-99.429 68.571-183.714t186.286-133.143 257.143-48.857 257.143 48.857 186.286 133.143 68.571 183.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"comment-o"
					],
					"defaultCode": 61669,
					"grid": 14
				},
				{
					"id": 1758,
					"width": 1024.0040283203125,
					"paths": [
						"M365.714 512q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM585.143 512q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM804.571 512q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM1024 512q0 99.429-68.571 183.714t-186.286 133.143-257.143 48.857q-62.857 0-120.571-10.286-98.857 98.857-248.571 130.857-29.714 5.714-49.143 7.429-6.857 0.571-12.571-3.429t-7.429-10.286q-2.286-8.571 11.429-21.143 2.857-2.857 13.429-12.286t14.571-13.429 13.429-14.571 13.714-18 11.714-21.143 11.429-27.429 8.286-32.857 7.143-41.429q-83.429-51.429-131.143-123.714t-47.714-154q0-99.429 68.571-183.714t186.286-133.143 257.143-48.857 257.143 48.857 186.286 133.143 68.571 183.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"commenting"
					],
					"defaultCode": 62074,
					"grid": 14
				},
				{
					"id": 1759,
					"width": 1023.9970550537109,
					"paths": [
						"M365.714 512q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM585.143 512q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM804.571 512q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM512 219.429q-116.571 0-218 39.714t-161.143 107.143-59.714 145.714q0 64 40.857 122t115.143 100.286l49.714 28.571-15.429 54.857q-13.714 52-40 98.286 86.857-36 157.143-97.714l24.571-21.714 32.571 3.429q39.429 4.571 74.286 4.571 116.571 0 218-39.714t161.143-107.143 59.714-145.714-59.714-145.714-161.143-107.143-218-39.714zM1024 512q0 99.429-68.571 183.714t-186.286 133.143-257.143 48.857q-40 0-82.857-4.571-113.143 100-262.857 138.286-28 8-65.143 12.571h-2.857q-8.571 0-15.429-6t-9.143-15.714v-0.571q-1.714-2.286-0.286-6.857t1.143-5.714 2.571-5.429l3.429-5.143t4-4.857 4.571-5.143q4-4.571 17.714-19.714t19.714-21.714 17.714-22.571 18.571-29.143 15.429-33.714 14.857-43.429q-89.714-50.857-141.429-125.714t-51.714-160.571q0-74.286 40.571-142t109.143-116.857 163.429-78 198.857-28.857 198.857 28.857 163.429 78 109.143 116.857 40.571 142z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"commenting-o"
					],
					"defaultCode": 62075,
					"grid": 14
				},
				{
					"id": 1305,
					"width": 1024.0031280517578,
					"paths": [
						"M804.571 438.857q0 79.429-53.714 146.857t-146.571 106.571-202 39.143q-49.143 0-100.571-9.143-70.857 50.286-158.857 73.143-20.571 5.143-49.143 9.143h-1.714q-6.286 0-11.714-4.571t-6.571-12q-0.571-1.714-0.571-3.714t0.286-3.714 1.143-3.429l1.429-2.857t2-3.143 2.286-2.857 2.571-2.857 2.286-2.571q2.857-3.429 13.143-14.286t14.857-16.857 12.857-16.571 14.286-22 11.714-25.143q-70.857-41.143-111.429-101.143t-40.571-128q0-79.429 53.714-146.857t146.571-106.571 202-39.143 202 39.143 146.571 106.571 53.714 146.857zM1024 585.143q0 68.571-40.571 128.286t-111.429 100.857q5.714 13.714 11.714 25.143t14.286 22 12.857 16.571 14.857 16.857 13.143 14.286q0.571 0.571 2.286 2.571t2.571 2.857 2.286 2.857 2 3.143l1.429 2.857t1.143 3.429 0.286 3.714-0.571 3.714q-1.714 8-7.429 12.571t-12.571 4q-28.571-4-49.143-9.143-88-22.857-158.857-73.143-51.429 9.143-100.571 9.143-154.857 0-269.714-75.429 33.143 2.286 50.286 2.286 92 0 176.571-25.714t150.857-73.714q71.429-52.571 109.714-121.143t38.286-145.143q0-44-13.143-86.857 73.714 40.571 116.571 101.714t42.857 131.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"comments"
					],
					"defaultCode": 61574,
					"grid": 14
				},
				{
					"id": 1383,
					"width": 1024.0031280517578,
					"paths": [
						"M402.286 219.429q-87.429 0-163.429 29.714t-120.857 80.571-44.857 109.143q0 46.857 30.286 90.286t85.143 75.429l55.429 32-20 48q19.429-11.429 35.429-22.286l25.143-17.714 30.286 5.714q44.571 8 87.429 8 87.429 0 163.429-29.714t120.857-80.571 44.857-109.143-44.857-109.143-120.857-80.571-163.429-29.714zM402.286 146.286q109.143 0 202 39.143t146.571 106.571 53.714 146.857-53.714 146.857-146.571 106.571-202 39.143q-49.143 0-100.571-9.143-70.857 50.286-158.857 73.143-20.571 5.143-49.143 9.143h-1.714q-6.286 0-11.714-4.571t-6.571-12q-0.571-1.714-0.571-3.714t0.286-3.714 1.143-3.429l1.429-2.857t2-3.143 2.286-2.857 2.571-2.857 2.286-2.571q2.857-3.429 13.143-14.286t14.857-16.857 12.857-16.571 14.286-22 11.714-25.143q-70.857-41.143-111.429-101.143t-40.571-128q0-79.429 53.714-146.857t146.571-106.571 202-39.143zM872 814.286q5.714 13.714 11.714 25.143t14.286 22 12.857 16.571 14.857 16.857 13.143 14.286q0.571 0.571 2.286 2.571t2.571 2.857 2.286 2.857 2 3.143l1.429 2.857t1.143 3.429 0.286 3.714-0.571 3.714q-1.714 8-7.429 12.571t-12.571 4q-28.571-4-49.143-9.143-88-22.857-158.857-73.143-51.429 9.143-100.571 9.143-154.857 0-269.714-75.429 33.143 2.286 50.286 2.286 92 0 176.571-25.714t150.857-73.714q71.429-52.571 109.714-121.143t38.286-145.143q0-44-13.143-86.857 73.714 40.571 116.571 101.714t42.857 131.429q0 68.571-40.571 128.286t-111.429 100.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"comments-o"
					],
					"defaultCode": 61670,
					"grid": 14
				},
				{
					"id": 385,
					"width": 1024,
					"paths": [
						"M880 384c-44.192 0-80 35.808-80 80s35.808 80 80 80 80-35.808 80-80c0-44.192-35.808-80-80-80zM880 512c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM880 320c-74.048 0-134.336 56.096-142.4 128h-67.2c-7.424-36.512-39.68-64-78.4-64s-70.976 27.488-78.4 64h-99.2c-7.424-36.512-39.68-64-78.4-64s-70.976 27.488-78.4 64h-35.2c-7.424-36.512-39.68-64-78.4-64s-70.976 27.488-78.4 64h-49.6c-8.832 0-16 7.168-16 16s7.168 16 16 16h49.6c7.424 36.512 39.68 64 78.4 64s70.976-27.488 78.4-64h35.2c7.424 36.512 39.68 64 78.4 64s70.976-27.488 78.4-64h99.232c7.424 36.512 39.68 64 78.4 64s70.976-27.488 78.4-64h67.232c8.064 71.904 68.352 128 142.4 128 79.52 0 144-64.48 144-144s-64.544-144-144.064-144zM144 512c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM336 512c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM592 512c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM880 576c-61.76 0-112-50.24-112-112s50.24-112 112-112 112 50.24 112 112c0 61.76-50.24 112-112 112z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"commit",
						"sync",
						"log",
						"code",
						"develop"
					],
					"grid": 32
				},
				{
					"id": 386,
					"width": 1024,
					"paths": [
						"M928 464c0 26.464-21.536 48-48 48s-48-21.536-48-48 21.536-48 48-48 48 21.536 48 48zM1024 464c0 79.52-64.48 144-144 144-74.048 0-134.336-56.096-142.4-128h-67.2c-7.424 36.512-39.68 64-78.4 64s-70.976-27.488-78.4-64h-99.2c-7.424 36.512-39.68 64-78.4 64s-70.976-27.488-78.4-64h-35.2c-7.424 36.512-39.68 64-78.4 64s-70.976-27.488-78.4-64h-49.6c-8.832 0-16-7.168-16-16s7.168-16 16-16h49.6c7.424-36.512 39.68-64 78.4-64s70.976 27.488 78.4 64h35.2c7.424-36.512 39.68-64 78.4-64s70.976 27.488 78.4 64h99.232c7.424-36.512 39.68-64 78.4-64s70.976 27.488 78.4 64h67.232c8.064-71.904 68.352-128 142.4-128 79.456 0 143.936 64.48 143.936 144zM960 464c0-44.192-35.808-80-80-80s-80 35.808-80 80c0 44.192 35.808 80 80 80s80-35.808 80-80z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"commit",
						"sync",
						"log",
						"code",
						"develop"
					],
					"grid": 32
				},
				{
					"id": 987,
					"width": 1024,
					"paths": [
						"M501.248 539.328l-42.4-42.4 22.624-22.624 42.368 42.368-22.592 22.656zM608.544 512h-64v32h64v-32zM416 454.624l11.328 11.328 22.624-22.624-33.952-33.952-33.952 33.952 22.624 22.624 11.328-11.328zM852.512 570.592l43.456 43.456 0.032-45.216-20.864-20.864-22.624 22.624zM693.696 496.928l-22.624-22.624-42.368 42.368 22.624 22.624 42.368-42.368zM736 454.624l11.328 11.328 22.624-22.624-33.952-33.952-33.952 33.952 22.624 22.624 11.328-11.328zM992 192v704c0 17.664-14.336 32-32 32h-896c-17.664 0-32-14.336-32-32v-704c0-17.664 14.336-32 32-32h896c17.664 0 32 14.336 32 32zM928 224h-832v640h832v-640zM373.696 496.928l-22.624-22.624-42.368 42.368 22.624 22.624 42.368-42.368zM320 646.624l89.376 89.376h109.248l96-96h96l105.632-105.632 4.96 4.96 22.624-22.624-4.96-4.96 57.12-57.12v-45.248l-79.744 79.744-14.784-14.784-22.624 22.624 14.784 14.784-96.256 96.256h-96l-96 96h-82.752l-102.624-102.624-102.624 102.624h-89.376v32h102.624l89.376-89.376zM192 512h-64v32h64v-32zM288 512h-64v32h64v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"compare",
						"chart",
						"graph",
						"visualize"
					],
					"grid": 32
				},
				{
					"id": 2132,
					"paths": [
						"M544.010 1024.004c-2.296 0-4.622-0.25-6.94-0.764-14.648-3.25-25.070-16.238-25.070-31.24v-480h-480c-15.002 0-27.992-10.422-31.24-25.070-3.25-14.646 4.114-29.584 17.708-35.928l960-448c12.196-5.688 26.644-3.144 36.16 6.372 9.516 9.514 12.060 23.966 6.372 36.16l-448 960c-5.342 11.44-16.772 18.47-28.99 18.47zM176.242 448h367.758c17.674 0 32 14.328 32 32v367.758l349.79-749.546-749.548 349.788z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"compass",
						"direction",
						"location"
					],
					"defaultCode": 59967,
					"grid": 16
				},
				{
					"id": 2133,
					"paths": [
						"M1014.626 9.374c-9.516-9.516-23.964-12.060-36.16-6.372l-960 448c-13.594 6.344-20.958 21.282-17.708 35.928 3.25 14.648 16.24 25.070 31.242 25.070h480v480c0 15.002 10.422 27.99 25.070 31.24 2.318 0.514 4.642 0.764 6.94 0.764 12.218 0 23.648-7.030 28.988-18.47l448-960c5.69-12.196 3.144-26.646-6.372-36.16zM576 847.758v-399.758l349.79-349.788-349.79 749.546z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"compass",
						"direction",
						"location"
					],
					"defaultCode": 59968,
					"grid": 16
				},
				{
					"id": 2134,
					"paths": [
						"M544.010 1024.004c-2.296 0-4.622-0.25-6.94-0.764-14.648-3.25-25.070-16.238-25.070-31.24v-480h-480c-15.002 0-27.992-10.422-31.24-25.070-3.25-14.646 4.114-29.584 17.708-35.928l960-448c12.196-5.688 26.644-3.144 36.16 6.372 9.516 9.514 12.060 23.966 6.372 36.16l-448 960c-5.342 11.44-16.772 18.47-28.99 18.47z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"compass",
						"direction",
						"location"
					],
					"defaultCode": 59969,
					"grid": 16
				},
				{
					"id": 2135,
					"paths": [
						"M619.062 480.092l84.938-114.916v-45.176h-45.176l-114.916 84.938-49.138-212.938h-29.54l-49.138 212.938-114.916-84.938h-45.176v45.176l84.938 114.916-212.938 49.138v29.54l212.938 49.138-84.938 114.916v45.176h45.176l114.916-84.938 49.138 212.938h29.54l49.138-212.938 114.916 84.938h45.176v-45.176l-84.938-114.916 212.938-49.138v-29.54l-212.938-49.138zM480 576c-17.674 0-32-14.326-32-32s14.326-32 32-32 32 14.326 32 32-14.326 32-32 32z",
						"M480 64c-265.096 0-480 214.904-480 480s214.904 480 480 480c265.098 0 480-214.902 480-480s-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384 384 171.922 384 384-171.922 384-384 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"compass",
						"direction",
						"location"
					],
					"defaultCode": 59970,
					"grid": 16
				},
				{
					"id": 2136,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM96 512c0-229.75 186.25-416 416-416 109.574 0 209.232 42.386 283.534 111.628l-411.534 176.372-176.372 411.534c-69.242-74.302-111.628-173.96-111.628-283.534zM585.166 585.166l-256.082 109.75 109.75-256.082 146.332 146.332zM512 928c-109.574 0-209.234-42.386-283.532-111.628l411.532-176.372 176.372-411.532c69.242 74.298 111.628 173.958 111.628 283.532 0 229.75-186.25 416-416 416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"compass",
						"direction",
						"location"
					],
					"defaultCode": 59971,
					"grid": 16
				},
				{
					"id": 2137,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM96 512c0-229.75 186.25-416 416-416 109.574 0 209.232 42.386 283.534 111.628l-411.534 176.372-176.372 411.534c-69.242-74.302-111.628-173.96-111.628-283.534zM576 512c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM512 928c-109.574 0-209.234-42.386-283.532-111.628l411.532-176.372 176.372-411.532c69.242 74.298 111.628 173.958 111.628 283.532 0 229.75-186.25 416-416 416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"compass",
						"direction",
						"location"
					],
					"defaultCode": 59972,
					"grid": 16
				},
				{
					"id": 1479,
					"width": 877.7139282226562,
					"paths": [
						"M365.714 621.714l146.286-73.143-146.286-73.143v146.286zM585.143 284v309.714l-292.571 146.286v-309.714zM749.714 512q0-84.571-41.714-156t-113.143-113.143-156-41.714-156 41.714-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"compass"
					],
					"defaultCode": 61774,
					"grid": 14
				},
				{
					"id": 1275,
					"width": 877.7160587310791,
					"paths": [
						"M438.857 548.571v256q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-82.286-82.286-189.714 189.714q-5.714 5.714-13.143 5.714t-13.143-5.714l-65.143-65.143q-5.714-5.714-5.714-13.143t5.714-13.143l189.714-189.714-82.286-82.286q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857h256q14.857 0 25.714 10.857t10.857 25.714zM870.286 164.571q0 7.429-5.714 13.143l-189.714 189.714 82.286 82.286q10.857 10.857 10.857 25.714t-10.857 25.714-25.714 10.857h-256q-14.857 0-25.714-10.857t-10.857-25.714v-256q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857l82.286 82.286 189.714-189.714q5.714-5.714 13.143-5.714t13.143 5.714l65.143 65.143q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"compress"
					],
					"defaultCode": 61542,
					"grid": 14
				},
				{
					"id": 2861,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM256 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM640 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM726.106 640h64.864c9.246 72.506-32.452 144.53-103.958 170.56-82.904 30.176-174.9-12.716-205.080-95.616-18.108-49.744-73.306-75.482-123.048-57.372-45.562 16.588-70.956 64.298-60.988 110.424h-64.86c-9.242-72.508 32.45-144.528 103.956-170.56 82.904-30.178 174.902 12.716 205.082 95.614 18.104 49.748 73.306 75.482 123.044 57.372 45.562-16.584 70.956-64.298 60.988-110.422z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"confused",
						"emoticon",
						"smiley",
						"face",
						"bewildered"
					],
					"defaultCode": 60696,
					"grid": 16
				},
				{
					"id": 2862,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.226 512 512 512c282.77 0 512-229.23 512-512s-229.23-512-512-512zM704 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64c0-35.346 28.654-64 64-64zM320 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64c0-35.346 28.654-64 64-64zM687.010 810.56c-82.902 30.18-174.9-12.712-205.080-95.614-18.108-49.742-73.306-75.478-123.048-57.372-45.562 16.588-70.958 64.296-60.988 110.424h-64.86c-9.244-72.508 32.45-144.532 103.956-170.56 82.904-30.18 174.902 12.712 205.082 95.614 18.108 49.742 73.306 75.476 123.046 57.37 45.562-16.584 70.958-64.294 60.988-110.422h64.864c9.24 72.506-32.454 144.532-103.96 170.56z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"confused",
						"emoticon",
						"smiley",
						"face",
						"bewildered"
					],
					"defaultCode": 60697,
					"grid": 16
				},
				{
					"id": 387,
					"width": 1024,
					"paths": [
						"M960 480c-25.344 0-47.040 14.848-57.408 36.192l-198.976-39.808c-1.888-33.632-29.504-60.384-63.616-60.384-11.84 0-22.784 3.424-32.32 9.056l-72.736-72.736c5.632-9.536 9.056-20.48 9.056-32.32 0-35.36-28.64-64-64-64-22.496 0-42.208 11.68-53.632 29.248l-74.816-24.928c0.128-1.472 0.448-2.848 0.448-4.32 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 0.544 0.16 1.056 0.16 1.6l-105.216 30.080c-11.136-18.88-31.456-31.68-54.944-31.68-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-0.544-0.16-1.056-0.16-1.6l105.216-30.048c11.136 18.848 31.456 31.648 54.944 31.648 22.496 0 42.208-11.68 53.632-29.248l74.816 24.928c-0.096 1.472-0.448 2.848-0.448 4.32 0 35.36 28.64 64 64 64 11.84 0 22.784-3.424 32.32-9.056l72.736 72.736c-5.632 9.504-9.056 20.48-9.056 32.32 0 27.008 16.8 50.016 40.448 59.392l-16.672 133.44c-31.424 4.064-55.776 30.624-55.776 63.168 0 35.36 28.64 64 64 64 24.256 0 45.088-13.632 55.936-33.504l136.096 34.016c0.32 35.104 28.8 63.488 63.968 63.488 35.36 0 64-28.64 64-64 0-21.664-10.816-40.736-27.296-52.32l52.64-140.352c2.208 0.224 4.384 0.672 6.656 0.672 35.36 0 64-28.64 64-64s-28.64-64-64-64zM64 352c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM288 288c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM448 320c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM640 448c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM608 768c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM864 832c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM870.656 736.672c-2.208-0.224-4.384-0.672-6.656-0.672-24.256 0-45.088 13.632-55.936 33.504l-136.096-34.016c-0.224-26.784-16.896-49.536-40.384-58.88l16.672-133.44c21.76-2.816 39.968-16.384 49.184-35.36l198.944 39.808c1.152 20.16 11.392 37.792 26.944 48.704l-52.672 140.352zM960 576c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"connect",
						"shine"
					],
					"grid": 32
				},
				{
					"id": 388,
					"width": 1024,
					"paths": [
						"M960 480c-25.344 0-47.040 14.848-57.408 36.192l-198.976-39.808c-1.888-33.632-29.504-60.384-63.616-60.384-11.84 0-22.784 3.424-32.32 9.056l-72.736-72.736c5.632-9.536 9.056-20.48 9.056-32.32 0-35.36-28.64-64-64-64-22.496 0-42.208 11.68-53.632 29.248l-74.816-24.928c0.128-1.472 0.448-2.848 0.448-4.32 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 0.544 0.16 1.056 0.16 1.6l-105.216 30.080c-11.136-18.88-31.456-31.68-54.944-31.68-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-0.544-0.16-1.056-0.16-1.6l105.216-30.048c11.136 18.848 31.456 31.648 54.944 31.648 22.496 0 42.208-11.68 53.632-29.248l74.816 24.928c-0.096 1.472-0.448 2.848-0.448 4.32 0 35.36 28.64 64 64 64 11.84 0 22.784-3.424 32.32-9.056l72.736 72.736c-5.632 9.504-9.056 20.48-9.056 32.32 0 27.008 16.8 50.016 40.448 59.392l-16.672 133.44c-31.424 4.064-55.776 30.624-55.776 63.168 0 35.36 28.64 64 64 64 24.256 0 45.088-13.632 55.936-33.504l136.096 34.016c0.32 35.104 28.8 63.488 63.968 63.488 35.36 0 64-28.64 64-64 0-21.664-10.816-40.736-27.296-52.32l52.64-140.352c2.208 0.224 4.384 0.672 6.656 0.672 35.36 0 64-28.64 64-64s-28.64-64-64-64zM870.656 736.672c-2.208-0.224-4.384-0.672-6.656-0.672-24.256 0-45.088 13.632-55.936 33.504l-136.096-34.016c-0.224-26.784-16.896-49.536-40.384-58.88l16.672-133.44c21.76-2.816 39.968-16.384 49.184-35.36l198.944 39.808c1.152 20.16 11.392 37.792 26.944 48.704l-52.672 140.352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"connect",
						"shine"
					],
					"grid": 32
				},
				{
					"id": 988,
					"width": 1024,
					"paths": [
						"M576 544h-96v96h96v-96zM544 608h-32v-32h32v32z",
						"M576 416h-96v96h96v-96zM544 480h-32v-32h32v32z",
						"M576 672h-96v96h96v-96zM544 736h-32v-32h32v32z",
						"M672 512v-96h32v-160h-448v160h32v224h-173.248l-114.752 114.752v205.248h992v-288h32v-160h-352zM160 896h-96v-96h96v96zM77.248 768l64-64h101.888l-73.152 64h-92.736zM288 896h-32v-64h32v64zM352 896h-32v-96h-96v96h-32v-104.736l90.688-79.328 69.312 69.312v114.752zM416 896h-32v-128l-32-32v-352h64v512zM416 352h-96v-32h96v32zM544 896h-32v-64h32v64zM608 896h-32v-96h-96v96h-32v-512h160v512zM448 352v-32h192v32h-192zM736 896h-96v-256h96v256zM736 608h-96v-32h96v32zM864 896h-32v-64h32v64zM928 896h-32v-96h-96v96h-32v-256h160v256zM960 608h-192v-32h192v32z",
						"M896 672h-96v96h96v-96zM864 736h-32v-32h32v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"connect",
						"share"
					],
					"grid": 32
				},
				{
					"id": 1659,
					"width": 1170.2870740890503,
					"paths": [
						"M1170.286 511.429q0 12-7.429 20.857t-18.857 11.143l-117.143 203.429q1.714 5.143 1.714 10.286 0 11.429-7.143 20.286t-18.571 11.143l-110.286 192.571q1.714 4.571 1.714 9.143 0 13.143-9.429 22.857t-23.143 9.714q-14.286 0-23.429-10.286h-228.571q-9.714 11.429-24.571 11.429t-24.571-11.429h-228q-9.714 11.429-24.571 11.429-13.143 0-22.857-9.429t-9.714-23.143q0-4.571 2.286-11.429l-110.286-191.429q-11.429-2.286-18.571-11.143t-7.143-20.286q0-5.143 1.714-10.286l-117.714-203.429q-11.429-2.857-18.571-11.714t-7.143-20.286q0-12 7.714-20.857t19.143-11.143l113.714-196.571q0-0.571-0.286-1.714t-0.286-1.714q0-20.571 19.429-29.143l119.429-207.429q-2.286-5.714-2.286-10.286 0-13.714 9.714-23.143t22.857-9.429q14.857 0 25.143 12h226.286q9.143-12 24.571-12t24.571 12h227.429q10.286-12 25.143-12 13.143 0 22.857 9.429t9.714 23.143q0 3.429-2.286 10.286l118.286 204.571q13.143 0.571 22.286 10t9.143 22q0 7.429-4 15.429l106.857 185.143q10.857 2.286 18 11.143t7.143 20.286zM607.429 968h222.286l-195.429-202.286h-81.714l-195.429 202.286h205.714q10.286-9.143 22.286-9.143t22.286 9.143zM64 504q0.571 2.286 0.571 7.429 0 5.714-1.143 8.571l118.857 205.714q1.143 0 2.571 0.571t3.143 1.429l2.857 1.429 107.429-113.714v-198.286l-106.857-110.857q-7.429 4.571-16.571 5.714zM563.429 56h-221.714l108.571 114.286 316.571-114.286h-160q-9.143 9.143-21.714 9.143t-21.714-9.143zM965.143 748.571q0.571-3.429 2.857-6.286l-36.571-38.857-9.714 45.143h43.429zM904.571 748.571l12.571-60-144-152-169.143 175.429 36 36.571h264.571zM854.286 958.857l9.143-16 37.143-177.143h-244l190.286 196q4.571-2.286 7.429-2.857zM330.286 968h2.857l195.429-202.286h-213.143v191.429l2.286 3.429q8 2.857 12.571 7.429zM315.429 748.571h229.714l36.571-37.714-176.571-183.429-89.714 94.857v126.286zM205.143 748.571h93.143v-108l-96 101.143q2.286 4.571 2.857 6.857zM204.571 277.143q0 0.571 0.286 1.143t0.286 1.143q0 9.143-4.571 16.571l97.714 101.143v-153.714zM315.429 237.143v177.714l87.429 89.714 169.714-179.429-127.429-134.857zM317.714 63.429l-2.286 4.571v150.857l117.143-42.286-109.143-114.857q-3.429 1.143-5.714 1.714zM826.857 56h-9.143l-354.857 128 121.714 128.571zM584.571 337.143l-169.714 180 177.714 182.286 169.143-175.429zM393.143 515.429l-77.714-80.571v162.286zM593.143 723.429l-24 25.143h48.571zM785.143 524.571l136 143.429 75.429-356.571-1.714-2.857-0.571-0.571zM981.714 296q-4.571-7.429-4.571-16.571v-1.143l-123.429-214.857q-2.857-0.571-7.429-2.857l-249.714 264.571 177.143 186.857zM298.286 225.143v-127.429l-93.143 161.143zM298.286 765.714h-93.143l93.143 161.714v-161.714zM918.286 765.714l-27.429 129.714 74.286-129.714h-46.857zM988 725.714l118.286-206.286q-1.143-5.714-1.143-8 0-0.571 1.714-9.143l-97.714-169.143-73.714 349.714 44 46.857q2.857-1.714 8.571-4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"connectdevelop"
					],
					"defaultCode": 61966,
					"grid": 14
				},
				{
					"id": 1937,
					"width": 1280,
					"paths": [
						"M640 576c105.87 0 201.87 43.066 271.402 112.598l-90.468 90.468c-46.354-46.356-110.356-75.066-180.934-75.066s-134.578 28.71-180.934 75.066l-90.468-90.468c69.532-69.532 165.532-112.598 271.402-112.598zM187.452 507.452c120.88-120.88 281.598-187.452 452.548-187.452s331.668 66.572 452.55 187.452l-90.51 90.508c-96.706-96.704-225.28-149.96-362.040-149.96-136.762 0-265.334 53.256-362.038 149.962l-90.51-90.51zM988.784 134.438c106.702 45.132 202.516 109.728 284.782 191.996v0l-90.508 90.508c-145.056-145.056-337.92-224.942-543.058-224.942-205.14 0-398 79.886-543.058 224.942l-90.51-90.51c82.268-82.266 178.082-146.862 284.784-191.994 110.504-46.738 227.852-70.438 348.784-70.438s238.278 23.7 348.784 70.438zM576 896c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"connection",
						"wifi",
						"wave"
					],
					"defaultCode": 59772,
					"grid": 16
				},
				{
					"id": 1938,
					"width": 1280,
					"paths": [
						"M640 576c105.87 0 201.87 43.066 271.402 112.598l-90.468 90.468c-46.354-46.356-110.356-75.066-180.934-75.066s-134.578 28.71-180.934 75.066l-90.468-90.468c69.532-69.532 165.532-112.598 271.402-112.598v0z",
						"M187.452 507.452c120.88-120.88 281.598-187.452 452.548-187.452s331.668 66.572 452.55 187.452l-90.51 90.508c-96.706-96.704-225.28-149.96-362.040-149.96-136.762 0-265.334 53.256-362.038 149.96l-90.51-90.508z",
						"M576 896c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64z",
						"M840 218.17c5.352 1.432 10.686 2.918 16 4.466v-132.452c-5.322-1.32-10.654-2.606-16-3.826v131.812z",
						"M808 210.33c5.352 1.188 10.684 2.44 16 3.74v-131.19c-5.324-1.112-10.654-2.188-16-3.202v130.652z",
						"M936 250.892c5.36 2.238 10.694 4.532 16 6.89v-137.94c-5.32-1.978-10.65-3.918-16-5.794v136.844z",
						"M872 227.488c5.356 1.69 10.688 3.444 16 5.25v-133.984c-5.322-1.532-10.652-3.028-16-4.46v133.194z",
						"M904 238.382c5.358 1.956 10.69 3.972 16 6.048v-135.804c-5.32-1.752-10.652-3.466-16-5.116v134.872z",
						"M712 195.324c5.346 0.494 10.68 1.038 16 1.642v-128.716c-5.324-0.518-10.658-0.98-16-1.402v128.476z",
						"M648 192.048c5.342 0.054 10.676 0.168 16 0.332v-128.060c-5.326-0.138-10.66-0.224-16-0.27v127.998z",
						"M776 203.944c5.348 0.95 10.684 1.95 16 3.010v-130.144c-5.324-0.91-10.656-1.778-16-2.59v129.724z",
						"M744 198.94c5.348 0.72 10.68 1.504 16 2.334v-129.332c-5.324-0.71-10.658-1.376-16-1.99v128.988z",
						"M680 193.026c5.344 0.272 10.678 0.598 16 0.978v-128.294c-5.324-0.326-10.66-0.592-16-0.824v128.14z",
						"M1224 376l16-16v-65.458c-5.284-4.774-10.618-9.48-16-14.116v95.574z",
						"M1192 408l16-16v-125.042c-5.29-4.346-10.622-8.632-16-12.85v153.892z",
						"M1160 394.818c5.39 4.97 10.728 10.016 16 15.156v-168.12c-5.292-3.958-10.626-7.85-16-11.686v164.65z",
						"M1256 309.346v34.654l16-16v-3.114c-5.278-5.254-10.612-10.432-16-15.54z",
						"M968 125.952v139.168c5.364 2.536 10.696 5.138 16 7.802v-140.472c-5.32-2.214-10.65-4.392-16-6.498z",
						"M1000 281.194c5.366 2.854 10.7 5.776 16 8.762v-143.46c-5.306-2.454-10.636-4.862-16-7.214v141.912z",
						"M1032 299.224c5.37 3.198 10.704 6.464 16 9.798v-146.968c-5.3-2.71-10.638-5.36-16-7.966v145.136z",
						"M1096 341.836c5.378 3.986 10.712 8.044 16 12.178v-155.828c-5.298-3.286-10.63-6.518-16-9.694v153.344z",
						"M1128 366.884c5.386 4.448 10.718 8.98 16 13.586v-161.46c-5.294-3.608-10.628-7.16-16-10.652v158.526z",
						"M1064 319.374c5.374 3.572 10.708 7.214 16 10.928v-151.040c-5.3-2.99-10.632-5.926-16-8.81v148.922z",
						"M200 330.302c5.292-3.714 10.626-7.356 16-10.928v-148.922c-5.366 2.882-10.7 5.82-16 8.81v151.040z",
						"M616 192.38c5.324-0.162 10.658-0.278 16-0.332v-128c-5.34 0.046-10.674 0.132-16 0.27v128.062z",
						"M232 309.024c5.296-3.334 10.63-6.6 16-9.798v-145.14c-5.362 2.608-10.7 5.256-16 7.966v146.972z",
						"M136 380.472c5.282-4.606 10.614-9.138 16-13.586v-158.528c-5.372 3.492-10.706 7.042-16 10.652v161.462z",
						"M264 146.494v143.46c5.3-2.986 10.634-5.908 16-8.762v-141.914c-5.362 2.354-10.694 4.764-16 7.216z",
						"M8 328l16 16v-34.656c-5.388 5.108-10.722 10.286-16 15.538v3.118z",
						"M104 409.976c5.27-5.14 10.61-10.186 16-15.156v-164.652c-5.374 3.836-10.708 7.728-16 11.686v168.122z",
						"M296 272.92c5.304-2.662 10.636-5.266 16-7.802v-139.168c-5.35 2.108-10.68 4.286-16 6.5v140.47z",
						"M40 360l16 16v-95.578c-5.382 4.636-10.716 9.342-16 14.116v65.462z",
						"M72 392l16 16v-153.89c-5.378 4.216-10.71 8.502-16 12.848v125.042z",
						"M168 354.016c5.288-4.134 10.622-8.194 16-12.178v-153.344c-5.368 3.174-10.702 6.408-16 9.694v155.828z",
						"M328 257.784c5.306-2.36 10.642-4.654 16-6.89v-136.846c-5.35 1.874-10.68 3.814-16 5.794v137.942z",
						"M552 196.964c5.322-0.604 10.656-1.148 16-1.642v-128.474c-5.342 0.422-10.676 0.884-16 1.402v128.714z",
						"M584 194.004c5.322-0.38 10.656-0.706 16-0.978v-128.14c-5.34 0.232-10.676 0.498-16 0.824v128.294z",
						"M488 206.954c5.318-1.062 10.652-2.060 16-3.010v-129.724c-5.344 0.812-10.676 1.68-16 2.59v130.144z",
						"M520 201.274c5.32-0.83 10.652-1.614 16-2.334v-128.988c-5.342 0.616-10.676 1.28-16 1.99v129.332z",
						"M392 232.738c5.312-1.806 10.644-3.562 16-5.25v-133.194c-5.346 1.432-10.678 2.926-16 4.46v133.984z",
						"M360 244.43c5.31-2.076 10.644-4.092 16-6.048v-134.872c-5.348 1.65-10.678 3.364-16 5.116v135.804z",
						"M456 214.070c5.316-1.3 10.65-2.552 16-3.74v-130.652c-5.344 1.014-10.676 2.090-16 3.202v131.19z",
						"M424 222.636c5.314-1.548 10.648-3.034 16-4.466v-131.812c-5.346 1.22-10.676 2.506-16 3.826v132.452z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"connection",
						"wifi",
						"dualtone"
					],
					"defaultCode": 59773,
					"grid": 16
				},
				{
					"id": 1939,
					"width": 1280,
					"paths": [
						"M640 576c105.87 0 201.87 43.066 271.402 112.598l-90.468 90.468c-46.354-46.356-110.356-75.066-180.934-75.066s-134.578 28.71-180.934 75.066l-90.468-90.468c69.532-69.532 165.532-112.598 271.402-112.598v0z",
						"M576 896c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64z",
						"M840 218.17c5.352 1.432 10.686 2.918 16 4.466v-132.452c-5.322-1.32-10.654-2.606-16-3.826v131.812z",
						"M808 210.33c5.352 1.188 10.684 2.44 16 3.74v-131.19c-5.324-1.112-10.654-2.188-16-3.202v130.652z",
						"M936 250.892c5.36 2.238 10.694 4.532 16 6.89v-137.94c-5.32-1.978-10.65-3.918-16-5.794v136.844z",
						"M872 227.488c5.356 1.69 10.688 3.444 16 5.25v-133.984c-5.322-1.532-10.652-3.028-16-4.46v133.194z",
						"M904 238.382c5.358 1.956 10.69 3.972 16 6.048v-135.804c-5.32-1.752-10.652-3.466-16-5.116v134.872z",
						"M712 195.324c5.346 0.494 10.68 1.038 16 1.642v-128.716c-5.324-0.518-10.658-0.98-16-1.402v128.476z",
						"M648 192.048c5.342 0.054 10.676 0.168 16 0.332v-128.060c-5.326-0.138-10.66-0.224-16-0.27v127.998z",
						"M776 203.944c5.348 0.95 10.684 1.95 16 3.010v-130.144c-5.324-0.91-10.656-1.778-16-2.59v129.724z",
						"M744 198.94c5.348 0.72 10.68 1.504 16 2.334v-129.332c-5.324-0.71-10.658-1.376-16-1.99v128.988z",
						"M680 193.026c5.344 0.272 10.678 0.598 16 0.978v-128.294c-5.324-0.326-10.66-0.592-16-0.824v128.14z",
						"M1224 376l16-16v-65.458c-5.284-4.774-10.618-9.48-16-14.116v95.574z",
						"M1192 408l16-16v-125.042c-5.29-4.346-10.622-8.632-16-12.85v153.892z",
						"M1160 394.818c5.39 4.97 10.728 10.016 16 15.156v-168.12c-5.292-3.958-10.626-7.85-16-11.686v164.65z",
						"M1256 309.346v34.654l16-16v-3.114c-5.278-5.254-10.612-10.432-16-15.54z",
						"M968 125.952v139.168c5.364 2.536 10.696 5.138 16 7.802v-140.472c-5.32-2.214-10.65-4.392-16-6.498z",
						"M1000 281.194c5.366 2.854 10.7 5.776 16 8.762v-143.46c-5.306-2.454-10.636-4.862-16-7.214v141.912z",
						"M1032 299.224c5.37 3.198 10.704 6.464 16 9.798v-146.968c-5.3-2.71-10.638-5.36-16-7.966v145.136z",
						"M1096 341.836c5.378 3.986 10.712 8.044 16 12.178v-155.828c-5.298-3.286-10.63-6.518-16-9.694v153.344z",
						"M1128 366.884c5.386 4.448 10.718 8.98 16 13.586v-161.46c-5.294-3.608-10.628-7.16-16-10.652v158.526z",
						"M1064 319.374c5.374 3.572 10.708 7.214 16 10.928v-151.040c-5.3-2.99-10.632-5.926-16-8.81v148.922z",
						"M200 330.302c5.292-3.714 10.626-7.356 16-10.928v-148.922c-5.366 2.882-10.7 5.82-16 8.81v151.040z",
						"M616 192.38c5.324-0.162 10.658-0.278 16-0.332v-128c-5.34 0.046-10.674 0.132-16 0.27v128.062z",
						"M232 309.024c5.296-3.334 10.63-6.6 16-9.798v-145.14c-5.362 2.608-10.7 5.256-16 7.966v146.972z",
						"M136 380.472c5.282-4.606 10.614-9.138 16-13.586v-158.528c-5.372 3.492-10.706 7.042-16 10.652v161.462z",
						"M264 146.494v143.46c5.3-2.986 10.634-5.908 16-8.762v-141.914c-5.362 2.354-10.694 4.764-16 7.216z",
						"M8 328l16 16v-34.656c-5.388 5.108-10.722 10.286-16 15.538v3.118z",
						"M104 409.976c5.27-5.14 10.61-10.186 16-15.156v-164.652c-5.374 3.836-10.708 7.728-16 11.686v168.122z",
						"M296 272.92c5.304-2.662 10.636-5.266 16-7.802v-139.168c-5.35 2.108-10.68 4.286-16 6.5v140.47z",
						"M40 360l16 16v-95.578c-5.382 4.636-10.716 9.342-16 14.116v65.462z",
						"M72 392l16 16v-153.89c-5.378 4.216-10.71 8.502-16 12.848v125.042z",
						"M168 354.016c5.288-4.134 10.622-8.194 16-12.178v-153.344c-5.368 3.174-10.702 6.408-16 9.694v155.828z",
						"M328 257.784c5.306-2.36 10.642-4.654 16-6.89v-136.846c-5.35 1.874-10.68 3.814-16 5.794v137.942z",
						"M552 196.964c5.322-0.604 10.656-1.148 16-1.642v-128.474c-5.342 0.422-10.676 0.884-16 1.402v128.714z",
						"M584 194.004c5.322-0.38 10.656-0.706 16-0.978v-128.14c-5.34 0.232-10.676 0.498-16 0.824v128.294z",
						"M488 206.954c5.318-1.062 10.652-2.060 16-3.010v-129.724c-5.344 0.812-10.676 1.68-16 2.59v130.144z",
						"M520 201.274c5.32-0.83 10.652-1.614 16-2.334v-128.988c-5.342 0.616-10.676 1.28-16 1.99v129.332z",
						"M392 232.738c5.312-1.806 10.644-3.562 16-5.25v-133.194c-5.346 1.432-10.678 2.926-16 4.46v133.984z",
						"M360 244.43c5.31-2.076 10.644-4.092 16-6.048v-134.872c-5.348 1.65-10.678 3.364-16 5.116v135.804z",
						"M456 214.070c5.316-1.3 10.65-2.552 16-3.74v-130.652c-5.344 1.014-10.676 2.090-16 3.202v131.19z",
						"M424 222.636c5.314-1.548 10.648-3.034 16-4.466v-131.812c-5.346 1.22-10.676 2.506-16 3.826v132.452z",
						"M776 466.172c5.364 1.468 10.696 3.038 16 4.678v-132.756c-5.312-1.29-10.646-2.506-16-3.658v131.736z",
						"M808 476.104c5.364 1.858 10.706 3.776 16 5.812v-135.184c-5.308-1.584-10.644-3.094-16-4.542v133.914z",
						"M712 453.024c5.352 0.75 10.69 1.552 16 2.466v-129.48c-5.318-0.728-10.652-1.388-16-1.982v128.996z",
						"M680 449.548c5.352 0.412 10.684 0.922 16 1.498v-128.596c-5.32-0.458-10.654-0.85-16-1.178v128.276z",
						"M744 458.536c5.36 1.1 10.692 2.292 16 3.56v-130.888c-5.316-1.004-10.648-1.938-16-2.808v130.136z",
						"M840 488.414c5.374 2.28 10.708 4.646 16 7.11v-138.33c-5.304-1.898-10.642-3.71-16-5.464v136.684z",
						"M872 503.316c5.382 2.742 10.712 5.592 16 8.528v-142.182c-5.304-2.23-10.634-4.4-16-6.484v140.138z",
						"M1032 568l16-15.998v-85.128c-5.278-4.382-10.606-8.686-16-12.884v114.010z",
						"M1064 480.624v55.376l16-16v-24.748c-5.258-4.982-10.604-9.84-16-14.628z",
						"M1000 595.97c0.676 0.668 1.368 1.318 2.040 1.99l13.96-13.96v-142.026c-5.282-3.852-10.618-7.614-16-11.292v165.288z",
						"M904 521.092c5.392 3.256 10.718 6.632 16 10.096v-147.002c-5.3-2.584-10.632-5.094-16-7.528v144.434z",
						"M968 566.846c5.408 4.53 10.754 9.154 16 13.924v-160.692c-5.292-3.386-10.62-6.71-16-9.932v156.7z",
						"M648 448.098c5.346 0.082 10.682 0.224 16 0.468v-128.078c-5.322-0.196-10.656-0.326-16-0.39v128z",
						"M936 542.106c5.4 3.844 10.732 7.802 16 11.868v-153.066c-5.292-2.964-10.63-5.838-16-8.646v149.844z",
						"M456 481.916c5.294-2.036 10.636-3.954 16-5.81v-133.914c-5.356 1.448-10.69 2.956-16 4.542v135.182z",
						"M296 580.77c5.246-4.77 10.592-9.394 16-13.924v-156.7c-5.38 3.222-10.708 6.546-16 9.932v160.692z",
						"M264 584l13.962 13.96c0.672-0.672 1.362-1.32 2.038-1.988v-165.29c-5.384 3.678-10.718 7.44-16 11.292v142.026z",
						"M328 553.972c5.268-4.064 10.598-8.024 16-11.868v-149.844c-5.37 2.808-10.708 5.682-16 8.646v153.066z",
						"M360 531.19c5.28-3.464 10.608-6.842 16-10.1v-144.432c-5.368 2.432-10.7 4.944-16 7.528v147.004z",
						"M232 552l16 16v-114.008c-5.396 4.198-10.722 8.5-16 12.884v85.124z",
						"M200 520l16 16v-55.374c-5.396 4.786-10.742 9.646-16 14.63v24.744z",
						"M584 451.044c5.318-0.576 10.648-1.086 16-1.498v-128.278c-5.346 0.328-10.68 0.72-16 1.178v128.598z",
						"M392 511.844c5.288-2.936 10.618-5.788 16-8.528v-140.138c-5.366 2.084-10.694 4.254-16 6.484v142.182z",
						"M616 448.566c5.318-0.244 10.654-0.386 16-0.468v-128c-5.344 0.064-10.678 0.194-16 0.39v128.078z",
						"M520 462.096c5.308-1.27 10.642-2.46 16-3.56v-130.134c-5.35 0.87-10.684 1.804-16 2.808v130.886z",
						"M552 455.49c5.31-0.916 10.648-1.718 16-2.466v-128.996c-5.348 0.594-10.682 1.254-16 1.982v129.48z",
						"M424 495.524c5.292-2.464 10.626-4.832 16-7.11v-136.684c-5.358 1.754-10.694 3.568-16 5.464v138.33z",
						"M488 470.85c5.306-1.642 10.636-3.21 16-4.678v-131.736c-5.354 1.152-10.688 2.37-16 3.658v132.756z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"connection",
						"wifi",
						"dualtone"
					],
					"defaultCode": 59774,
					"grid": 16
				},
				{
					"id": 1940,
					"width": 1280,
					"paths": [
						"M576 896c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64z",
						"M840 218.17c5.352 1.432 10.686 2.918 16 4.466v-132.452c-5.322-1.32-10.654-2.606-16-3.826v131.812z",
						"M808 210.33c5.352 1.188 10.684 2.44 16 3.74v-131.19c-5.324-1.112-10.654-2.188-16-3.202v130.652z",
						"M936 250.892c5.36 2.238 10.694 4.532 16 6.89v-137.94c-5.32-1.978-10.65-3.918-16-5.794v136.844z",
						"M872 227.488c5.356 1.69 10.688 3.444 16 5.25v-133.984c-5.322-1.532-10.652-3.028-16-4.46v133.194z",
						"M904 238.382c5.358 1.956 10.69 3.972 16 6.048v-135.804c-5.32-1.752-10.652-3.466-16-5.116v134.872z",
						"M712 195.324c5.346 0.494 10.68 1.038 16 1.642v-128.716c-5.324-0.518-10.658-0.98-16-1.402v128.476z",
						"M648 192.048c5.342 0.054 10.676 0.168 16 0.332v-128.060c-5.326-0.138-10.66-0.224-16-0.27v127.998z",
						"M776 203.944c5.348 0.95 10.684 1.95 16 3.010v-130.144c-5.324-0.91-10.656-1.778-16-2.59v129.724z",
						"M744 198.94c5.348 0.72 10.68 1.504 16 2.334v-129.332c-5.324-0.71-10.658-1.376-16-1.99v128.988z",
						"M680 193.026c5.344 0.272 10.678 0.598 16 0.978v-128.294c-5.324-0.326-10.66-0.592-16-0.824v128.14z",
						"M1224 376l16-16v-65.458c-5.284-4.774-10.618-9.48-16-14.116v95.574z",
						"M1192 408l16-16v-125.042c-5.29-4.346-10.622-8.632-16-12.85v153.892z",
						"M1160 394.818c5.39 4.97 10.728 10.016 16 15.156v-168.12c-5.292-3.958-10.626-7.85-16-11.686v164.65z",
						"M1256 309.346v34.654l16-16v-3.114c-5.278-5.254-10.612-10.432-16-15.54z",
						"M968 125.952v139.168c5.364 2.536 10.696 5.138 16 7.802v-140.472c-5.32-2.214-10.65-4.392-16-6.498z",
						"M1000 281.194c5.366 2.854 10.7 5.776 16 8.762v-143.46c-5.306-2.454-10.636-4.862-16-7.214v141.912z",
						"M1032 299.224c5.37 3.198 10.704 6.464 16 9.798v-146.968c-5.3-2.71-10.638-5.36-16-7.966v145.136z",
						"M1096 341.836c5.378 3.986 10.712 8.044 16 12.178v-155.828c-5.298-3.286-10.63-6.518-16-9.694v153.344z",
						"M1128 366.884c5.386 4.448 10.718 8.98 16 13.586v-161.46c-5.294-3.608-10.628-7.16-16-10.652v158.526z",
						"M1064 319.374c5.374 3.572 10.708 7.214 16 10.928v-151.040c-5.3-2.99-10.632-5.926-16-8.81v148.922z",
						"M200 330.302c5.292-3.714 10.626-7.356 16-10.928v-148.922c-5.366 2.882-10.7 5.82-16 8.81v151.040z",
						"M616 192.38c5.324-0.162 10.658-0.278 16-0.332v-128c-5.34 0.046-10.674 0.132-16 0.27v128.062z",
						"M232 309.024c5.296-3.334 10.63-6.6 16-9.798v-145.14c-5.362 2.608-10.7 5.256-16 7.966v146.972z",
						"M136 380.472c5.282-4.606 10.614-9.138 16-13.586v-158.528c-5.372 3.492-10.706 7.042-16 10.652v161.462z",
						"M264 146.494v143.46c5.3-2.986 10.634-5.908 16-8.762v-141.914c-5.362 2.354-10.694 4.764-16 7.216z",
						"M8 328l16 16v-34.656c-5.388 5.108-10.722 10.286-16 15.538v3.118z",
						"M104 409.976c5.27-5.14 10.61-10.186 16-15.156v-164.652c-5.374 3.836-10.708 7.728-16 11.686v168.122z",
						"M296 272.92c5.304-2.662 10.636-5.266 16-7.802v-139.168c-5.35 2.108-10.68 4.286-16 6.5v140.47z",
						"M40 360l16 16v-95.578c-5.382 4.636-10.716 9.342-16 14.116v65.462z",
						"M72 392l16 16v-153.89c-5.378 4.216-10.71 8.502-16 12.848v125.042z",
						"M168 354.016c5.288-4.134 10.622-8.194 16-12.178v-153.344c-5.368 3.174-10.702 6.408-16 9.694v155.828z",
						"M328 257.784c5.306-2.36 10.642-4.654 16-6.89v-136.846c-5.35 1.874-10.68 3.814-16 5.794v137.942z",
						"M552 196.964c5.322-0.604 10.656-1.148 16-1.642v-128.474c-5.342 0.422-10.676 0.884-16 1.402v128.714z",
						"M584 194.004c5.322-0.38 10.656-0.706 16-0.978v-128.14c-5.34 0.232-10.676 0.498-16 0.824v128.294z",
						"M488 206.954c5.318-1.062 10.652-2.060 16-3.010v-129.724c-5.344 0.812-10.676 1.68-16 2.59v130.144z",
						"M520 201.274c5.32-0.83 10.652-1.614 16-2.334v-128.988c-5.342 0.616-10.676 1.28-16 1.99v129.332z",
						"M392 232.738c5.312-1.806 10.644-3.562 16-5.25v-133.194c-5.346 1.432-10.678 2.926-16 4.46v133.984z",
						"M360 244.43c5.31-2.076 10.644-4.092 16-6.048v-134.872c-5.348 1.65-10.678 3.364-16 5.116v135.804z",
						"M456 214.070c5.316-1.3 10.65-2.552 16-3.74v-130.652c-5.344 1.014-10.676 2.090-16 3.202v131.19z",
						"M424 222.636c5.314-1.548 10.648-3.034 16-4.466v-131.812c-5.346 1.22-10.676 2.506-16 3.826v132.452z",
						"M776 466.172c5.364 1.468 10.696 3.038 16 4.678v-132.756c-5.312-1.29-10.646-2.506-16-3.658v131.736z",
						"M808 476.104c5.364 1.858 10.706 3.776 16 5.812v-135.184c-5.308-1.584-10.644-3.094-16-4.542v133.914z",
						"M712 453.024c5.352 0.75 10.69 1.552 16 2.466v-129.48c-5.318-0.728-10.652-1.388-16-1.982v128.996z",
						"M680 449.548c5.352 0.412 10.684 0.922 16 1.498v-128.596c-5.32-0.458-10.654-0.85-16-1.178v128.276z",
						"M744 458.536c5.36 1.1 10.692 2.292 16 3.56v-130.888c-5.316-1.004-10.648-1.938-16-2.808v130.136z",
						"M840 488.414c5.374 2.28 10.708 4.646 16 7.11v-138.33c-5.304-1.898-10.642-3.71-16-5.464v136.684z",
						"M872 503.316c5.382 2.742 10.712 5.592 16 8.528v-142.182c-5.304-2.23-10.634-4.4-16-6.484v140.138z",
						"M1032 568l16-15.998v-85.128c-5.278-4.382-10.606-8.686-16-12.884v114.010z",
						"M1064 480.624v55.376l16-16v-24.748c-5.258-4.982-10.604-9.84-16-14.628z",
						"M1000 595.97c0.676 0.668 1.368 1.318 2.040 1.99l13.96-13.96v-142.026c-5.282-3.852-10.618-7.614-16-11.292v165.288z",
						"M904 521.092c5.392 3.256 10.718 6.632 16 10.096v-147.002c-5.3-2.584-10.632-5.094-16-7.528v144.434z",
						"M968 566.846c5.408 4.53 10.754 9.154 16 13.924v-160.692c-5.292-3.386-10.62-6.71-16-9.932v156.7z",
						"M648 448.098c5.346 0.082 10.682 0.224 16 0.468v-128.078c-5.322-0.196-10.656-0.326-16-0.39v128z",
						"M936 542.106c5.4 3.844 10.732 7.802 16 11.868v-153.066c-5.292-2.964-10.63-5.838-16-8.646v149.844z",
						"M456 481.916c5.294-2.036 10.636-3.954 16-5.81v-133.914c-5.356 1.448-10.69 2.956-16 4.542v135.182z",
						"M296 580.77c5.246-4.77 10.592-9.394 16-13.924v-156.7c-5.38 3.222-10.708 6.546-16 9.932v160.692z",
						"M264 584l13.962 13.96c0.672-0.672 1.362-1.32 2.038-1.988v-165.29c-5.384 3.678-10.718 7.44-16 11.292v142.026z",
						"M328 553.972c5.268-4.064 10.598-8.024 16-11.868v-149.844c-5.37 2.808-10.708 5.682-16 8.646v153.066z",
						"M360 531.19c5.28-3.464 10.608-6.842 16-10.1v-144.432c-5.368 2.432-10.7 4.944-16 7.528v147.004z",
						"M232 552l16 16v-114.008c-5.396 4.198-10.722 8.5-16 12.884v85.124z",
						"M200 520l16 16v-55.374c-5.396 4.786-10.742 9.646-16 14.63v24.744z",
						"M584 451.044c5.318-0.576 10.648-1.086 16-1.498v-128.278c-5.346 0.328-10.68 0.72-16 1.178v128.598z",
						"M392 511.844c5.288-2.936 10.618-5.788 16-8.528v-140.138c-5.366 2.084-10.694 4.254-16 6.484v142.182z",
						"M616 448.566c5.318-0.244 10.654-0.386 16-0.468v-128c-5.344 0.064-10.678 0.194-16 0.39v128.078z",
						"M520 462.096c5.308-1.27 10.642-2.46 16-3.56v-130.134c-5.35 0.87-10.684 1.804-16 2.808v130.886z",
						"M552 455.49c5.31-0.916 10.648-1.718 16-2.466v-128.996c-5.348 0.594-10.682 1.254-16 1.982v129.48z",
						"M424 495.524c5.292-2.464 10.626-4.832 16-7.11v-136.684c-5.358 1.754-10.694 3.568-16 5.464v138.33z",
						"M488 470.85c5.306-1.642 10.636-3.21 16-4.678v-131.736c-5.354 1.152-10.688 2.37-16 3.658v132.756z",
						"M648 704.136c5.376 0.166 10.71 0.504 16 0.998v-128.364c-5.306-0.328-10.638-0.56-16-0.67v128.036z",
						"M712 714.324c5.406 1.586 10.746 3.332 16 5.262v-133.396c-5.292-1.246-10.628-2.368-16-3.39v131.524z",
						"M680 707.132c5.39 0.85 10.724 1.872 16 3.054v-130.092c-5.3-0.778-10.632-1.46-16-2.018v129.056z",
						"M776 743.21c5.474 3.448 10.812 7.092 16 10.932v-146.746c-5.274-2.284-10.608-4.446-16-6.494v142.308z",
						"M744 726.1c5.436 2.426 10.772 5.042 16 7.828v-138.704c-5.286-1.744-10.616-3.388-16-4.904v135.78z",
						"M808 767c4.448 3.876 8.764 7.896 12.934 12.066l3.066-3.066v-152.96c-5.26-2.884-10.596-5.644-16-8.286v152.246z",
						"M904 681.406v14.594l7.402-7.402c-2.434-2.434-4.906-4.824-7.402-7.192z",
						"M872 728l16-16v-44.922c-5.216-4.422-10.55-8.71-16-12.856v73.778z",
						"M840 760l16-16v-101.322c-5.242-3.58-10.576-7.038-16-10.362v127.684z",
						"M616 705.134c5.29-0.494 10.624-0.832 16-0.998v-128.036c-5.362 0.11-10.694 0.342-16 0.67v128.364z",
						"M424 744l16 16v-127.684c-5.424 3.324-10.756 6.782-16 10.362v101.322z",
						"M584 710.188c5.276-1.184 10.608-2.206 16-3.054v-129.054c-5.368 0.556-10.7 1.24-16 2.018v130.090z",
						"M376 696v-14.594c-2.498 2.368-4.97 4.758-7.402 7.192l7.402 7.402z",
						"M456 776l3.066 3.066c4.17-4.17 8.486-8.19 12.934-12.066v-152.246c-5.404 2.64-10.74 5.4-16 8.284v152.962z",
						"M392 712l16 16v-73.778c-5.45 4.144-10.784 8.432-16 12.856v44.922z",
						"M488 754.144c5.186-3.84 10.524-7.484 16-10.932v-142.31c-5.392 2.048-10.726 4.21-16 6.492v146.75z",
						"M552 719.586c5.252-1.928 10.592-3.676 16-5.262v-131.526c-5.372 1.024-10.708 2.144-16 3.39v133.398z",
						"M520 733.928c5.23-2.788 10.564-5.4 16-7.828v-135.78c-5.384 1.516-10.714 3.16-16 4.904v138.704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"connection",
						"wifi",
						"dualtone"
					],
					"defaultCode": 59775,
					"grid": 16
				},
				{
					"id": 2450,
					"paths": [
						"M1024 416v-256c0-17.6-14.4-32-32-32h-960c-17.6 0-32 14.4-32 32v256c0 17.6 14.4 32 32 32h120.35l-152.35 448h192l65.292-192h509.414l65.294 192h192l-152.35-448h120.35c17.6 0 32-14.4 32-32zM832 192l-192 192h-192l192-192h192zM256 192h192l-192 192h-192l192-192zM744.944 640h-465.886l65.292-192h335.3l65.294 192zM960 384h-128l128-128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"construction",
						"maintenance",
						"road"
					],
					"defaultCode": 60285,
					"grid": 16
				},
				{
					"id": 160,
					"paths": [
						"M1024 255.992v-76.792c0-14.138-11.461-25.6-25.6-25.6h-179.192c-0.005 0-0.011 0-0.016 0h-255.984c-0.005 0-0.011 0-0.016 0h-255.984c-0.005 0-0.011 0-0.016 0h-281.592c-14.138 0-25.6 11.462-25.6 25.6v307.2c0 14.139 11.462 25.6 25.6 25.6h76.8v307.2h-25.6c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h204.8c14.138 0 25.6-11.461 25.6-25.6s-11.462-25.6-25.6-25.6h-25.6v-153.6h512v153.6h-25.6c-14.139 0-25.6 11.461-25.6 25.6s11.461 25.6 25.6 25.6h204.8c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-25.6v-307.2h76.8c14.139 0 25.6-11.461 25.6-25.6v-230.392c0-0.005 0-0.011 0-0.016zM972.8 245.397l-215.403 215.403h-183.594l256-256h142.997v40.597zM317.803 460.8l256-256h183.594l-256 256h-183.594zM61.803 460.8l256-256h183.594l-256 256h-183.594zM245.397 204.8l-194.197 194.197v-194.197h194.197zM153.6 819.2v-307.2h51.2v307.2h-51.2zM256 614.4v-102.4h512v102.4h-512zM870.4 819.2h-51.2v-307.2h51.2v307.2zM829.803 460.8l142.997-142.997v142.997h-142.997z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"construction",
						"road-sign"
					],
					"defaultCode": 59457,
					"grid": 20
				},
				{
					"id": 389,
					"width": 1024,
					"paths": [
						"M864 320c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-32v-32c0-53.024-42.976-96-96-96h-448c-53.024 0-96 42.976-96 96v64h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v32h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v320h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v32h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v64c0 53.024 42.976 96 96 96h448c53.024 0 96-42.976 96-96v-128h32c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-32v-32h32c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-32v-32h32c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-32v-32h32zM832 256h32v32h-32v-32zM800 832c0 35.36-28.64 64-64 64h-448c-35.36 0-64-28.64-64-64v-640c0-35.36 28.64-64 64-64h448c35.36 0 64 28.64 64 64v640zM864 640v32h-32v-32h32zM864 512v32h-32v-32h32zM864 384v32h-32v-32h32zM581.44 513.984c20.448-21.504 31.264-52.32 24.576-85.632-7.552-37.728-38.88-68.288-76.768-74.88-60.608-10.528-113.248 35.872-113.248 94.528 0 25.632 10.208 48.768 26.56 65.984-35.904 17.92-58.56 54.592-58.56 94.688v63.328c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-63.296c0-40.128-22.688-76.8-58.56-94.72zM512 384c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64c0-35.296 28.704-64 64-64zM608 672h-192v-50.72c0-31.552 15.36-60.896 41.216-78.848l14.816-7.392c12.192 5.632 25.664 8.96 39.968 8.96s27.776-3.328 39.968-8.96l14.816 7.392c25.856 17.952 41.216 47.296 41.216 78.848v50.72z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"contact",
						"call"
					],
					"grid": 32
				},
				{
					"id": 390,
					"width": 1024,
					"paths": [
						"M608 621.28v50.72h-192v-50.72c0-31.552 15.36-60.896 41.216-78.848l14.816-7.392c12.192 5.632 25.664 8.96 39.968 8.96s27.776-3.328 39.968-8.96l14.816 7.392c25.856 17.952 41.216 47.296 41.216 78.848zM512 512c35.296 0 64-28.704 64-64s-28.704-64-64-64-64 28.704-64 64c0 35.296 28.704 64 64 64zM832 320v32h32c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32h-32v32h32c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32h-32v32h32c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32h-32v128c0 53.024-42.976 96-96 96h-448c-53.024 0-96-42.976-96-96v-64h-48c-8.832 0-16-7.168-16-16s7.168-16 16-16h48v-32h-48c-8.832 0-16-7.168-16-16s7.168-16 16-16h48v-320h-48c-8.832 0-16-7.168-16-16s7.168-16 16-16h48v-32h-48c-8.832 0-16-7.168-16-16s7.168-16 16-16h48v-64c0-53.024 42.976-96 96-96h448c53.024 0 96 42.976 96 96v32h32c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32h-32zM640 608.704c0-40.128-22.688-76.768-58.56-94.688 20.448-21.504 31.264-52.32 24.576-85.632-7.552-37.728-38.88-68.288-76.768-74.88-60.608-10.56-113.248 35.84-113.248 94.496 0 25.632 10.208 48.768 26.56 65.984-35.904 17.92-58.56 54.592-58.56 94.688v63.328c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-63.296z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"contact",
						"call"
					],
					"grid": 32
				},
				{
					"id": 989,
					"width": 1024,
					"paths": [
						"M960 32h-796.224c-46.432 0-89.088 31.296-97.92 76.864-11.904 61.28 34.944 115.136 94.144 115.136v64c-52.928 0-96 43.072-96 96s43.072 96 96 96v64c-52.928 0-96 43.072-96 96s43.072 96 96 96v64c-59.2 0-106.048 53.856-94.144 115.136 8.864 45.568 51.488 76.864 97.92 76.864h796.224c17.664 0 32-14.336 32-32v-896c0-17.664-14.336-32-32-32zM288 128c0 17.632-14.368 32-32 32h-96c-17.632 0-32-14.368-32-32s14.368-32 32-32h96c17.632 0 32 14.368 32 32zM256 928h-96c-17.632 0-32-14.368-32-32s14.368-32 32-32h96c17.632 0 32 14.368 32 32s-14.368 32-32 32zM128 640c0-17.632 14.368-32 32-32h96c17.632 0 32 14.368 32 32s-14.368 32-32 32h-96c-17.632 0-32-14.368-32-32zM128 384c0-17.632 14.368-32 32-32h96c17.632 0 32 14.368 32 32s-14.368 32-32 32h-96c-17.632 0-32-14.368-32-32zM311.136 928c5.472-9.44 8.864-20.288 8.864-32 0-35.328-28.672-64-64-64h-32v-128h32c35.328 0 64-28.672 64-64s-28.672-64-64-64h-32v-128h32c35.328 0 64-28.672 64-64s-28.672-64-64-64h-32v-128h32c35.328 0 64-28.672 64-64 0-11.712-3.392-22.56-8.864-32h616.864l0.032 832h-616.896zM670.080 417.44c18.976-20.128 33.92-51.232 33.92-97.44 0-53.024-42.976-96-96-96s-96 42.976-96 96c0 46.208 14.944 77.312 33.92 97.44-55.072 7.008-97.92 53.632-97.92 110.56v48h32v-48c0-44.096 35.904-80 80-80h96c44.096 0 80 35.904 80 80v48h32v-48c0-56.928-42.848-103.552-97.92-110.56zM608 256c35.296 0 64 28.704 64 64 0 79.712-50.496 96-64 96s-64-16.288-64-96c0-35.296 28.704-64 64-64zM448 672h320v32h-320v-32zM448 736h320v32h-320v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"contact"
					],
					"grid": 32
				},
				{
					"id": 391,
					"width": 1024,
					"paths": [
						"M564.832 132.064c7.040-10.272 11.168-22.688 11.168-36.064 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 13.376 4.128 25.792 11.168 36.064-187.008 25.792-331.168 185.824-331.168 379.936v384c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-384c0-194.112-144.16-354.144-331.168-379.936zM864 512v352h-96v-352c0-128.352-51.36-256.416-127.584-327.392 130.688 51.456 223.584 178.656 223.584 327.392zM471.712 167.040c-32.864 65.696-55.712 205.152-55.712 344.96v352h-128v-352c0-159.584 84.704-311.328 183.712-344.96zM448 512c0-194.176 40.352-326.72 64-349.984 23.648 23.264 64 155.808 64 349.984v352h-128v-352zM552.288 167.040c99.008 33.632 183.712 185.376 183.712 344.96v352h-128v-352c0-139.808-22.848-279.264-55.712-344.96zM480 96c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM383.584 184.608c-76.224 70.976-127.584 199.040-127.584 327.392v352h-96v-352c0-148.736 92.896-275.936 223.584-327.392zM800 960h-576c-35.296 0-64-28.704-64-64h704c0 35.296-28.704 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"contain",
						"keep",
						"trap"
					],
					"grid": 32
				},
				{
					"id": 392,
					"width": 1024,
					"paths": [
						"M564.832 132.064c7.040-10.272 11.168-22.688 11.168-36.064 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 13.376 4.128 25.792 11.168 36.064-187.008 25.792-331.168 185.824-331.168 379.936v384c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-384c0-194.112-144.16-354.144-331.168-379.936zM864 512v352h-96v-352c0-128.352-51.36-256.416-127.584-327.392 130.688 51.456 223.584 178.656 223.584 327.392zM471.712 167.040c-32.864 65.696-55.712 205.152-55.712 344.96v352h-128v-352c0-159.584 84.704-311.328 183.712-344.96zM448 512c0-194.176 40.352-326.72 64-349.984 23.648 23.264 64 155.808 64 349.984v352h-128v-352zM552.288 167.040c99.008 33.632 183.712 185.376 183.712 344.96v352h-128v-352c0-139.808-22.848-279.264-55.712-344.96zM480 96c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM383.584 184.608c-76.224 70.976-127.584 199.040-127.584 327.392v352h-96v-352c0-148.736 92.896-275.936 223.584-327.392z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"contain",
						"keep",
						"trap"
					],
					"grid": 32
				},
				{
					"id": 1746,
					"width": 1024.0000534057617,
					"paths": [
						"M78.857 73.143h112.571q-40 36.571-72 85.143-20.571 32-33.714 65.714t-17.143 71.714-4.857 68.571 6 75.429 12 72 16 78q2.286 10.857 3.429 16 29.143 136 46.286 188 32.571 97.714 86.857 157.143h-155.429q-27.429 0-46.857-19.429t-19.429-46.857v-745.143q0-27.429 19.429-46.857t46.857-19.429zM769.143 73.143h176q27.429 0 46.857 19.429t19.429 46.857v745.143q0 27.429-19.429 46.857t-46.857 19.429h-101.714q121.143-120 112-322.857l-268 57.714q-1.143 25.714-6.857 46.857t-17.714 41.143-34 34-53.429 20.857q-70.286 14.857-113.714-22.857-18.286-15.429-30.286-34.857t-29.429-73.714-36.857-147.429q-20-93.143-26-150.286t-3.143-79.429 13.143-44q11.429-23.429 35.714-41.714t58.571-25.714q25.714-6.857 47.714-3.714t38.286 9.714 30.857 20 24.571 27.429 19.714 32.286l267.429-57.143q-38.857-100-102.857-164z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"contao"
					],
					"defaultCode": 62061,
					"grid": 14
				},
				{
					"id": 2796,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM128 512c0-212.078 171.922-384 384-384v768c-212.078 0-384-171.922-384-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"contrast"
					],
					"defaultCode": 60631,
					"grid": 16
				},
				{
					"id": 393,
					"width": 1024,
					"paths": [
						"M384 320c53.024 0 96-42.976 96-96s-42.976-96-96-96-96 42.976-96 96 42.976 96 96 96zM384 160c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64 28.704-64 64-64zM576 192c53.024 0 96-42.976 96-96s-42.976-96-96-96-96 42.976-96 96 42.976 96 96 96zM576 32c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64 28.704-64 64-64zM934.752 643.392l-42.56-21.28c-21.792-155.168-145.472-244-304.832-264.928-17.6-22.496-44.64-37.184-75.36-37.184-30.656 0-57.6 14.624-75.2 36.96-133.824 17.568-242.464 83.072-286.848 195.424l-62.4 17.12c-13.92 3.84-23.552 16.48-23.552 30.912v143.2c0 14.4 9.632 27.040 23.52 30.848l62.4 17.12c20.768 52.576 55.52 94.848 100.448 126.784l-16.48 65.856c-4.992 20.224 10.272 39.776 31.104 39.776h126.016c14.688 0 27.488-9.984 31.040-24.256l3.584-14.336c27.808 4.224 56.64 6.592 86.368 6.592 40.8 0 80.096-4.096 116.992-12.064l4.96 19.808c3.552 14.272 16.352 24.256 31.040 24.256h126.016c20.832 0 36.096-19.552 31.040-39.776l-21.792-87.104c48.736-43.552 81.632-102.016 91.904-175.232l42.56-21.28c23.616-11.776 23.616-45.44 0.032-57.216zM576 416c0 13.152-3.968 23.84-8.864 32h-110.272c-4.896-8.16-8.864-18.848-8.864-32 0-35.296 28.704-64 64-64s64 28.704 64 64zM862.848 700.8l-2.336 16.64c-8.832 62.944-36.256 115.36-81.536 155.808l-14.4 12.864 26.432 105.888h-126.016l-12.48-49.888-30.272 6.528c-34.848 7.552-71.936 11.36-110.24 11.36-27.008 0-54.432-2.080-81.536-6.208l-28.8-4.384-10.656 42.592h-126.016l21.76-87.040-17.792-12.64c-41.344-29.376-71.36-67.2-89.248-112.48l-5.888-14.88-77.824-21.376v-143.2l77.856-21.344 5.888-14.88c35.648-90.176 122.688-150.624 239.488-171.52-1.92 7.52-3.232 15.264-3.232 23.36 0 11.296 2.208 21.984 5.856 32h-21.856c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-21.856c3.648-10.016 5.856-20.704 5.856-32 0-8.192-1.344-16-3.264-23.584 122.304 22.112 235.712 91.296 255.776 234.144l2.336 16.64 57.6 28.8-57.6 28.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"contribute",
						"keep",
						"save",
						"store"
					],
					"grid": 32
				},
				{
					"id": 394,
					"width": 1024,
					"paths": [
						"M480 96c0-53.024 42.976-96 96-96s96 42.976 96 96-42.976 96-96 96-96-42.976-96-96zM384 320c53.024 0 96-42.976 96-96s-42.976-96-96-96-96 42.976-96 96 42.976 96 96 96zM416 416c0 11.296 2.272 21.984 5.984 32h180.064c3.68-10.016 5.952-20.704 5.952-32 0-22.592-8.16-43.040-21.216-59.424-17.6-22.112-44.352-36.576-74.784-36.576-30.4 0-57.12 14.432-74.72 36.48-13.088 16.416-21.28 36.896-21.28 59.52zM934.752 643.392l-42.56-21.28c-19.872-141.536-124.672-227.712-263.872-257.664 7.2 15.808 11.68 33.056 11.68 51.552 0 11.136-1.952 21.728-4.672 32h20.672c8.832 0 16 7.168 16 16s-7.168 16-16 16h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h20.672c-2.72-10.272-4.672-20.864-4.672-32 0-18.496 4.48-35.776 11.712-51.616-114.656 24.704-206.016 87.456-245.76 188.032l-62.4 17.12c-13.92 3.808-23.552 16.448-23.552 30.88v143.2c0 14.4 9.632 27.040 23.52 30.848l62.4 17.12c20.768 52.576 55.52 94.848 100.448 126.784l-16.48 65.856c-4.992 20.224 10.272 39.776 31.104 39.776h126.016c14.688 0 27.488-9.984 31.040-24.256l3.584-14.336c27.808 4.224 56.64 6.592 86.368 6.592 40.8 0 80.096-4.096 116.992-12.064l4.96 19.808c3.552 14.272 16.352 24.256 31.040 24.256h126.016c20.832 0 36.096-19.552 31.040-39.776l-21.792-87.104c48.736-43.552 81.632-102.016 91.904-175.232l42.56-21.28c23.616-11.776 23.616-45.44 0.032-57.216z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"contribute",
						"keep",
						"save",
						"store"
					],
					"grid": 32
				},
				{
					"id": 395,
					"width": 1024,
					"paths": [
						"M640 0h-256c-53.024 0-96 42.976-96 96v832c0 53.024 42.976 96 96 96h256c53.024 0 96-42.976 96-96v-832c0-53.024-42.976-96-96-96zM704 928c0 35.36-28.64 64-64 64h-256c-35.36 0-64-28.64-64-64v-832c0-35.36 28.64-64 64-64h256c35.36 0 64 28.64 64 64v832zM416 224c35.36 0 64-28.64 64-64s-28.64-64-64-64-64 28.64-64 64c0 35.36 28.64 64 64 64zM416 128c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM608 96c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM608 192c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM480 320c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64zM384 320c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM608 256c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM608 352c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM608 512h-32v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-32c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h32v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32h32c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM608 608h-64v64h-64v-64h-64v-64h64v-64h64v64h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"control",
						"press",
						"watch",
						"change"
					],
					"grid": 32
				},
				{
					"id": 396,
					"width": 1024,
					"paths": [
						"M640 320c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM544 544v-64h-64v64h-64v64h64v64h64v-64h64v-64h-64zM416 192c17.632 0 32-14.368 32-32s-14.368-32-32-32-32 14.368-32 32 14.368 32 32 32zM608 128c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM736 96v832c0 53.024-42.976 96-96 96h-256c-53.024 0-96-42.976-96-96v-832c0-53.024 42.976-96 96-96h256c53.024 0 96 42.976 96 96zM352 160c0 35.36 28.64 64 64 64s64-28.64 64-64c0-35.36-28.64-64-64-64s-64 28.64-64 64zM416 384c35.36 0 64-28.64 64-64s-28.64-64-64-64-64 28.64-64 64c0 35.36 28.64 64 64 64zM640 544c0-17.664-14.336-32-32-32h-32v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-32c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h32v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32h32c17.664 0 32-14.336 32-32v-64zM672 320c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64zM672 160c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64zM448 320c0-17.632-14.368-32-32-32s-32 14.368-32 32 14.368 32 32 32 32-14.368 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"control",
						"press",
						"watch",
						"change"
					],
					"grid": 32
				},
				{
					"id": 2514,
					"paths": [
						"M768 128c-33.646 0-66.92 6.652-97.77 19.38-34.65-50.322-92.648-83.38-158.23-83.38s-123.58 33.058-158.23 83.378c-30.85-12.726-64.124-19.378-97.77-19.378-141.158 0-256 114.84-256 256 0 125.254 55.982 181.236 105.374 230.626 46.482 46.486 86.626 86.628 86.626 185.374v192c0 17.674 14.328 32 32 32h576c17.674 0 32-14.326 32-32v-192c0-98.746 40.144-138.888 86.626-185.374 49.394-49.39 105.374-105.372 105.374-230.626 0-141.16-114.842-256-256-256zM768 960h-512v-128h512v128zM873.374 569.374c-44.974 44.97-95.408 95.41-104.074 198.626h-514.6c-8.666-103.216-59.1-153.656-104.074-198.626-46.48-46.486-86.626-86.628-86.626-185.374 0-105.87 86.13-192 192-192 2.512 0 11.34 0.376 11.456 0.384 52.538 3.694 52.544 33.654 52.544 63.616v32c0 17.672 14.328 32 32 32s32-14.328 32-32v-32c0-70.58 57.42-128 128-128s128 57.42 128 128v32c0 17.672 14.326 32 32 32s32-14.328 32-32v-32c0-29.962 0.006-59.922 52.544-63.616 0.116-0.008 8.944-0.384 11.456-0.384 105.87 0 192 86.13 192 192 0 98.746-40.144 138.888-86.626 185.374z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cook",
						"chef"
					],
					"defaultCode": 60349,
					"grid": 16
				},
				{
					"id": 397,
					"width": 1024,
					"paths": [
						"M960 384l-42.496-35.392c-97.888-81.6-215.776-135.648-341.472-156.608v-32c0-17.664-14.336-32-32-32h-64.032c-17.664 0-32 14.336-32 32v32c-125.728 20.96-243.584 75.008-341.504 156.608l-42.496 35.392c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32l51.488 334.592c7.2 46.848 47.488 81.408 94.88 81.408h603.296c47.392 0 87.68-34.56 94.88-81.408l51.456-334.592c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32zM126.976 373.184c93.44-77.888 206.272-129.6 326.304-149.632l26.72-4.448v-59.104h64l0.032 59.104 26.72 4.448c120 20 232.832 71.744 326.272 149.6l12.992 10.848h-796.032l12.992-10.816zM960 448h-27.456l-55.648 361.728c-4.8 31.232-31.68 54.272-63.264 54.272h-603.264c-31.584 0-58.464-23.040-63.264-54.272l-55.648-361.728h-27.456v-32h896v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cook",
						"heat",
						"burn"
					],
					"grid": 32
				},
				{
					"id": 398,
					"width": 1024,
					"paths": [
						"M102.4 352l4.096-3.392c97.888-81.6 215.776-135.648 341.472-156.608v-32c0-17.664 14.336-32 32-32h64.032c17.664 0 32 14.336 32 32v32c125.728 20.96 243.584 75.008 341.504 156.608l4.096 3.392h-819.2zM960 384h-896c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32l51.488 334.592c7.2 46.848 47.488 81.408 94.88 81.408h603.296c47.392 0 87.68-34.56 94.88-81.408l51.456-334.592c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cook",
						"heat",
						"burn"
					],
					"grid": 32
				},
				{
					"id": 990,
					"width": 1024,
					"paths": [
						"M992 96h-960c-17.664 0-32 14.336-32 32v768c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-768c0-17.664-14.336-32-32-32zM64 864v-704h704v704h-704zM960 864h-160v-704h160v704zM240 192c-79.52 0-144 64.48-144 144s64.48 144 144 144 144-64.48 144-144-64.48-144-144-144zM240 448c-61.76 0-112-50.24-112-112s50.24-112 112-112c61.76 0 112 50.24 112 112s-50.24 112-112 112zM240 544c-79.52 0-144 64.48-144 144s64.48 144 144 144 144-64.48 144-144-64.48-144-144-144zM240 800c-61.76 0-112-50.24-112-112s50.24-112 112-112c61.76 0 112 50.24 112 112s-50.24 112-112 112zM592 544c-79.52 0-144 64.48-144 144s64.48 144 144 144 144-64.48 144-144-64.48-144-144-144zM592 800c-61.76 0-112-50.24-112-112s50.24-112 112-112c61.76 0 112 50.24 112 112s-50.24 112-112 112zM592 192c-79.52 0-144 64.48-144 144s64.48 144 144 144 144-64.48 144-144-64.48-144-144-144zM592 448c-61.76 0-112-50.24-112-112s50.24-112 112-112c61.76 0 112 50.24 112 112s-50.24 112-112 112zM880 320c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM880 256c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16zM880 448c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM880 384c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16zM880 704c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM880 640c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16zM880 736c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM880 800c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16-7.168 16-16 16zM240 608c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM240 736c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM592 608c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM592 736c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM240 256c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM240 384c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM592 256c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM592 384c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cook",
						"heat",
						"burn"
					],
					"grid": 32
				},
				{
					"id": 2851,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM800 256c17.6 0 32 14.4 32 32v96c0 35.2-28.8 64-64 64h-128c-35.2 0-64-28.8-64-64h-128c0 35.2-28.8 64-64 64h-128c-35.2 0-64-28.8-64-64v-96c0-17.6 14.4-32 32-32h192c17.6 0 32 14.4 32 32v32h128v-32c0-17.6 14.4-32 32-32h192zM512 768c93.208 0 174.772-49.818 219.546-124.278l54.88 32.934c-55.966 93.070-157.916 155.344-274.426 155.344-48.458 0-94.384-10.796-135.54-30.082l33.162-55.278c31.354 13.714 65.964 21.36 102.378 21.36z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cool",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60686,
					"grid": 16
				},
				{
					"id": 2852,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.226 512 512 512c282.77 0 512-229.23 512-512s-229.23-512-512-512zM512 832c-48.458 0-94.384-10.796-135.542-30.082l33.162-55.276c31.356 13.712 65.966 21.358 102.38 21.358 93.208 0 174.772-49.818 219.542-124.278l54.882 32.934c-55.964 93.070-157.914 155.344-274.424 155.344zM832 384c0 35.2-28.8 64-64 64h-128c-35.2 0-64-28.8-64-64h-128c0 35.2-28.8 64-64 64h-128c-35.2 0-64-28.8-64-64v-96c0-17.6 14.4-32 32-32h192c17.6 0 32 14.4 32 32v32h128v-32c0-17.6 14.4-32 32-32h192c17.6 0 32 14.4 32 32v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cool",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60687,
					"grid": 16
				},
				{
					"id": 399,
					"width": 1024,
					"paths": [
						"M889.056 753.312c44.704-69.696 70.944-152.384 70.944-241.312 0-247.424-200.576-448-448-448s-448 200.576-448 448c0 88.928 26.24 171.616 70.944 241.312l-42.816 42.816c-37.44 37.44-37.44 98.336 0 135.744 18.144 18.144 42.24 28.128 67.872 28.128s49.728-9.984 67.872-28.128l42.816-42.816c69.696 44.704 152.384 70.944 241.312 70.944s171.616-26.24 241.312-70.944l42.816 42.816c18.144 18.144 42.24 28.128 67.872 28.128s49.728-9.984 67.872-28.128c37.44-37.44 37.44-98.336 0-135.744l-42.816-42.816zM205.248 909.248c-12.512 12.512-28.864 18.752-45.248 18.752s-32.736-6.24-45.248-18.752c-24.992-24.992-24.992-65.504 0-90.496l38.816-38.816c25.728 34.336 56.16 64.8 90.496 90.496l-38.816 38.816zM96 512c0-229.376 186.624-416 416-416s416 186.624 416 416-186.624 416-416 416-416-186.624-416-416zM909.248 909.248c-12.512 12.512-28.864 18.752-45.248 18.752s-32.736-6.24-45.248-18.752l-38.816-38.816c34.336-25.728 64.8-56.16 90.496-90.496l38.816 38.816c24.992 24.992 24.992 65.504 0 90.496zM785.984 485.44c-22.944-13.248-51.52-18.208-81.504-18.208-34.496 0-70.176 6.688-101.76 14.816-4.16-12.544-10.72-23.904-19.328-33.568 42.688-43.648 88.608-103.552 88.608-160.48 0-106.048-53.952-160-160-160s-160 53.952-160 160c0 56.928 45.92 116.832 88.608 160.448-8.608 9.664-15.168 21.024-19.328 33.568-31.552-8.128-67.264-14.816-101.76-14.816-29.984 0-58.56 4.96-81.504 18.208-91.84 53.024-111.584 126.72-58.56 218.56 33.664 58.336 75.68 87.584 125.408 87.584 28.544 0 59.68-9.664 93.184-28.992 49.184-28.384 78.080-97.856 94.56-156.544 6.24 1.28 12.736 1.984 19.392 1.984s13.152-0.704 19.424-1.984c16.48 58.688 45.376 128.16 94.56 156.544 33.504 19.36 64.608 28.992 93.184 28.992 49.696 0 91.712-29.248 125.408-87.584 52.992-91.808 33.248-165.504-58.592-218.528zM384 288c0-88.512 39.488-128 128-128s128 39.488 128 128c0 45.664-40.832 99.104-81.632 140.48-13.824-7.712-29.472-12.48-46.368-12.48s-32.544 4.768-46.368 12.48c-40.8-41.376-81.632-94.816-81.632-140.48zM382.016 734.848c-28.416 16.416-54.368 24.704-77.184 24.704-37.92 0-69.888-23.424-97.664-71.584-21.984-38.080-29.344-71.584-21.856-99.552s30.592-53.312 68.704-75.296c16-9.248 38.048-13.92 65.536-13.92 32.48 0 66.592 6.592 96.64 14.528 0.64 34.144 19.2 63.712 46.624 80.256-15.456 56-41.28 118.048-80.8 140.864zM448 512c0-35.36 28.64-64 64-64s64 28.64 64 64c0 35.36-28.64 64-64 64s-64-28.64-64-64zM816.832 688c-27.808 48.16-59.744 71.584-97.696 71.584-22.784 0-48.768-8.32-77.184-24.704-39.52-22.816-65.344-84.864-80.768-140.864 27.424-16.544 45.984-46.144 46.624-80.288 30.016-7.904 64.096-14.496 96.672-14.496 27.456 0 49.504 4.672 65.504 13.92 38.080 21.984 61.184 47.328 68.704 75.296 7.488 27.968 0.128 61.472-21.856 99.552z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cool",
						"blow",
						"fan"
					],
					"grid": 32
				},
				{
					"id": 400,
					"width": 1024,
					"paths": [
						"M576 512c0 35.36-28.64 64-64 64s-64-28.64-64-64c0-35.36 28.64-64 64-64s64 28.64 64 64zM416.16 513.728c-30.048-7.936-64.16-14.528-96.64-14.528-27.488 0-49.504 4.672-65.536 13.92-38.080 21.984-61.184 47.328-68.704 75.296-7.456 28-0.096 61.504 21.888 99.584 27.808 48.16 59.744 71.584 97.664 71.584 22.784 0 48.768-8.32 77.184-24.704 39.52-22.816 65.344-84.864 80.768-140.864-27.424-16.544-45.984-46.144-46.624-80.288zM512 416c16.896 0 32.544 4.768 46.368 12.48 40.8-41.376 81.632-94.816 81.632-140.48 0-88.512-39.488-128-128-128s-128 39.488-128 128c0 45.664 40.832 99.104 81.632 140.48 13.824-7.712 29.472-12.48 46.368-12.48zM960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448 200.576-448 448-448 448 200.576 448 448zM844.544 704c53.024-91.84 33.28-165.536-58.56-218.56-22.944-13.248-51.52-18.208-81.504-18.208-34.496 0-70.176 6.688-101.76 14.816-4.16-12.544-10.72-23.904-19.328-33.568 42.688-43.648 88.608-103.552 88.608-160.48 0-106.048-53.952-160-160-160s-160 53.952-160 160c0 56.928 45.92 116.832 88.608 160.448-8.608 9.664-15.168 21.024-19.328 33.568-31.552-8.128-67.264-14.816-101.76-14.816-29.984 0-58.56 4.96-81.504 18.208-91.84 53.024-111.584 126.72-58.56 218.56 33.664 58.336 75.68 87.584 125.408 87.584 28.544 0 59.68-9.664 93.184-28.992 49.184-28.384 78.080-97.856 94.56-156.544 6.24 1.28 12.736 1.984 19.392 1.984s13.152-0.704 19.424-1.984c16.48 58.688 45.376 128.16 94.56 156.544 33.504 19.36 64.608 28.992 93.184 28.992 49.696 0.032 91.712-29.248 125.376-87.552zM769.984 513.152c-16-9.248-38.048-13.92-65.504-13.92-32.576 0-66.656 6.592-96.672 14.496-0.608 34.144-19.168 63.744-46.624 80.288 15.424 56 41.248 118.048 80.768 140.864 28.416 16.416 54.368 24.704 77.184 24.704 37.92 0 69.888-23.424 97.696-71.584 21.984-38.080 29.344-71.584 21.824-99.552-7.456-27.968-30.592-53.312-68.672-75.296zM112.256 775.968l-20.128 20.128c-37.44 37.44-37.44 98.336 0 135.744 18.144 18.176 42.24 28.16 67.872 28.16s49.728-9.984 67.872-28.128l19.904-19.872c-53.792-35.776-99.84-82.144-135.52-136.032zM911.744 775.968c-35.68 53.856-81.696 100.256-135.52 136l19.904 19.904c18.144 18.144 42.24 28.128 67.872 28.128s49.728-9.984 67.872-28.128c37.44-37.44 37.44-98.336 0-135.744l-20.128-20.16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cool",
						"blow",
						"fan"
					],
					"grid": 32
				},
				{
					"id": 1996,
					"paths": [
						"M864 128h-64v64h32v512h-256v256h-384v-768h32v-64h-64c-17.602 0-32 14.4-32 32v832c0 17.6 14.398 32 32 32h504l232-232v-632c0-17.6-14.4-32-32-32zM640 960v-192h192l-192 192zM768 128h-128v-64c0-35.2-28.8-64-64-64h-128c-35.204 0-64 28.8-64 64v64h-128v128h512v-128zM576 128h-128v-63.886c0.034-0.038 0.072-0.078 0.114-0.114h127.768c0.042 0.036 0.082 0.076 0.118 0.114v63.886z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copy",
						"duplicate",
						"clipboard"
					],
					"defaultCode": 59831,
					"grid": 16
				},
				{
					"id": 1997,
					"paths": [
						"M864 128c17.6 0 32 14.4 32 32v608l-256 256h-480c-17.602 0-32-14.4-32-32v-832c0-17.6 14.398-32 32-32h64v64h-32v768h384v-256h256v-512h-32v-64h64zM768 128h-128v-64c0-35.2-28.8-64-64-64h-128c-35.204 0-64 28.8-64 64v64h-128v128h512v-128zM576 128h-128v-63.886c0.034-0.038 0.072-0.078 0.114-0.114h127.768c0.042 0.036 0.082 0.076 0.118 0.114v63.886z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copy",
						"duplicate",
						"clipboard"
					],
					"defaultCode": 59832,
					"grid": 16
				},
				{
					"id": 2012,
					"paths": [
						"M640 256v-256h-448l-192 192v576h384v256h640v-768h-384zM192 90.51v101.49h-101.49l101.49-101.49zM64 704v-448h192v-192h320v192l-192 192v256h-320zM576 346.51v101.49h-101.49l101.49-101.49zM960 960h-512v-448h192v-192h320v640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copy",
						"duplicate",
						"files",
						"pages",
						"papers",
						"documents"
					],
					"defaultCode": 59847,
					"grid": 16
				},
				{
					"id": 2013,
					"paths": [
						"M832 256h-192v-64l-192-192h-448v768h384v256h640v-576l-192-192zM832 346.51l101.49 101.49h-101.49v-101.49zM448 90.51l101.49 101.49h-101.49v-101.49zM64 64h320v192h192v448h-512v-640zM960 960h-512v-192h192v-448h128v192h192v448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copy",
						"duplicate",
						"files",
						"pages",
						"papers",
						"documents"
					],
					"defaultCode": 59848,
					"grid": 16
				},
				{
					"id": 1352,
					"width": 1024.0010299682617,
					"paths": [
						"M969.143 219.429q22.857 0 38.857 16t16 38.857v694.857q0 22.857-16 38.857t-38.857 16h-548.571q-22.857 0-38.857-16t-16-38.857v-164.571h-310.857q-22.857 0-38.857-16t-16-38.857v-384q0-22.857 11.429-50.286t27.429-43.429l233.143-233.143q16-16 43.429-27.429t50.286-11.429h237.714q22.857 0 38.857 16t16 38.857v187.429q38.857-22.857 73.143-22.857h237.714zM658.286 341.143l-170.857 170.857h170.857v-170.857zM292.571 121.714l-170.857 170.857h170.857v-170.857zM404.571 491.429l180.571-180.571v-237.714h-219.429v237.714q0 22.857-16 38.857t-38.857 16h-237.714v365.714h292.571v-146.286q0-22.857 11.429-50.286t27.429-43.429zM950.857 950.857v-658.286h-219.429v237.714q0 22.857-16 38.857t-38.857 16h-237.714v365.714h512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copy",
						"files-o"
					],
					"defaultCode": 61637,
					"grid": 14
				},
				{
					"id": 401,
					"width": 1024,
					"paths": [
						"M624 448h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM624 512h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM624 576h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM896 192v736c0 53.024-42.976 96-96 96h-576c-53.024 0-96-42.976-96-96v-736c0-53.024 42.976-96 96-96h96c0-17.664 14.336-32 32-32h69.888c13.216-37.216 48.384-64 90.112-64s76.896 26.784 90.112 64h69.888c17.664 0 32 14.336 32 32h96c53.024 0 96 42.976 96 96zM320 192h-96v736h576v-736h-96c0 17.664-14.336 32-32 32h-320c-17.664 0-32-14.336-32-32zM352 192h320v-96h-92.48l-7.552-21.28c-9.088-25.568-33.184-42.72-59.968-42.72s-50.88 17.152-59.968 42.72l-7.552 21.28h-92.48v96zM864 192c0-35.36-28.64-64-64-64h-96v32h96c17.664 0 32 14.336 32 32v736c0 17.664-14.336 32-32 32h-576c-17.664 0-32-14.336-32-32v-736c0-17.664 14.336-32 32-32h96v-32h-96c-35.36 0-64 28.64-64 64v736c0 35.36 28.64 64 64 64h576c35.36 0 64-28.64 64-64v-736z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copy",
						"duplicate",
						"replicate",
						"clone"
					],
					"grid": 32
				},
				{
					"id": 402,
					"width": 1024,
					"paths": [
						"M320 192c0 17.664 14.336 32 32 32h320c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-69.888c-13.216-37.216-48.384-64-90.112-64s-76.896 26.784-90.112 64h-69.888c-17.664 0-32 14.336-32 32v96zM896 192v736c0 53.024-42.976 96-96 96h-576c-53.024 0-96-42.976-96-96v-736c0-53.024 42.976-96 96-96h64v64h-64c-17.664 0-32 14.336-32 32v736c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-736c0-17.664-14.336-32-32-32h-64v-64h64c53.024 0 96 42.976 96 96zM736 192c0 35.296-28.704 64-64 64h-320c-35.296 0-64-28.704-64-64h-64v736h576v-736h-64zM624 608h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16zM624 544h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16zM624 480h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copy",
						"duplicate",
						"replicate",
						"clone"
					],
					"grid": 32
				},
				{
					"id": 991,
					"width": 1024,
					"paths": [
						"M896 128h-64v-96c0-17.664-14.336-32-32-32h-672c-17.664 0-32 14.336-32 32v864c0 17.664 14.336 32 32 32h96v64c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-832c0-17.664-14.336-32-32-32zM768 864h-608v-800h608v800zM864 960h-576v-64h480c17.664 0 32-14.336 32-32v-672h64v768zM640 288h-352v-32h352v32zM640 384h-352v-32h352v32zM640 480h-352v-32h352v32zM640 576h-352v-32h352v32zM640 672h-352v-32h352v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copy",
						"duplicate",
						"replicate",
						"clone"
					],
					"grid": 32
				},
				{
					"id": 1639,
					"width": 877.7139282226562,
					"paths": [
						"M657.143 613.714v62.286q0 28.571-20.857 50.857t-53.714 34.571-67.429 18.571-67.143 6.286q-117.143 0-195.714-79.429t-78.571-197.714q0-116 77.714-193.714t193.714-77.714q19.429 0 43.143 2.571t53.143 10.286 52.857 19.429 39.429 32.286 16 46.286v62.286q0 9.143-9.143 9.143h-67.429q-9.143 0-9.143-9.143v-40q0-24.571-37.429-38.571t-78.571-14q-80 0-130.571 52.286t-50.571 135.714q0 86.286 52.286 142.571t133.429 56.286q38.857 0 78.857-13.714t40-37.714v-40q0-4 2.571-6.571t6-2.571h68q3.429 0 6.286 2.571t2.857 6.571zM438.857 146.286q-74.286 0-142 29.143t-116.571 78-78 116.571-29.143 142 29.143 142 78 116.571 116.571 78 142 29.143 142-29.143 116.571-78 78-116.571 29.143-142-29.143-142-78-116.571-116.571-78-142-29.143zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copyright"
					],
					"defaultCode": 61945,
					"grid": 14
				},
				{
					"id": 94,
					"width": 768,
					"paths": [
						"M384 819.2c-108.958 0-192.566-28.363-248.502-84.299-55.936-55.934-84.298-139.542-84.298-248.501s28.362-192.566 84.298-248.502c55.936-55.936 139.544-84.298 248.502-84.298s192.566 28.362 248.501 84.298c55.936 55.936 84.299 139.544 84.299 248.502s-28.363 192.566-84.299 248.501-139.542 84.299-248.501 84.299zM384 204.8c-94.886 0-166.312 23.317-212.298 69.302s-69.302 117.413-69.302 212.298c0 94.886 23.317 166.312 69.302 212.299 45.986 45.984 117.411 69.301 212.298 69.301s166.312-23.317 212.299-69.301c45.984-45.987 69.301-117.413 69.301-212.299s-23.317-166.312-69.301-212.298c-45.987-45.986-117.413-69.302-212.299-69.302z",
						"M384 665.6c-57.997 0-102.846-15.442-133.301-45.899-30.458-30.454-45.899-75.304-45.899-133.301s15.442-102.846 45.899-133.301c30.454-30.458 75.304-45.899 133.301-45.899 81.15 0 136.667 19.851 169.725 60.69 8.896 10.99 7.198 27.109-3.792 36.005-10.987 8.898-27.107 7.2-36.005-3.79-22.715-28.062-65.216-41.704-129.928-41.704-43.925 0-76.594 10.397-97.099 30.901-20.504 20.506-30.901 53.174-30.901 97.099s10.397 76.594 30.901 97.099 53.174 30.901 97.099 30.901c64.714 0 107.214-13.642 129.93-41.706 8.894-10.992 25.014-12.69 36.005-3.792 10.989 8.896 12.688 25.016 3.792 36.005-33.058 40.84-88.574 60.693-169.726 60.693z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"copyright"
					],
					"defaultCode": 169,
					"grid": 20
				},
				{
					"id": 403,
					"width": 1024,
					"paths": [
						"M704 496c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM704 368c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM704 432c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM928 224h-128c0-17.664-14.336-32-32-32h-672c-17.664 0-32 14.336-32 32v576c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-544c0-17.664-14.336-32-32-32zM160 864c-35.36 0-64-28.64-64-64v-576h672v576c0 24.576 9.28 47.008 24.512 64h-632.512zM928 800c0 35.296-28.704 64-64 64-35.36 0-64-28.64-64-64v-544h128v544zM704 304c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM704 624c0 8.832-7.168 16-16 16h-512c-8.832 0-16-7.168-16-16s7.168-16 16-16h512c8.832 0 16 7.168 16 16zM704 560c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM416 288h-224c-17.664 0-32 14.336-32 32v224c0 17.664 14.336 32 32 32h224c17.664 0 32-14.336 32-32v-224c0-17.664-14.336-32-32-32zM416 544h-224v-224h224v224zM704 688c0 8.832-7.168 16-16 16h-512c-8.832 0-16-7.168-16-16s7.168-16 16-16h512c8.832 0 16 7.168 16 16zM704 752c0 8.832-7.168 16-16 16h-512c-8.832 0-16-7.168-16-16s7.168-16 16-16h512c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cover",
						"deliver",
						"report"
					],
					"grid": 32
				},
				{
					"id": 404,
					"width": 1024,
					"paths": [
						"M800 224h128c17.664 0 32 14.336 32 32v544c0 50.272-38.784 91.072-88 95.2-40.32-4.096-72-37.824-72-79.2v-592zM416 320h-224v224h224v-224zM801.856 896h-641.856c-53.024 0-96-42.976-96-96v-576c0-17.664 14.336-32 32-32h640c17.664 0 32 14.336 32 32v592c0 31.36 13.024 59.648 33.856 80zM160 544c0 17.664 14.336 32 32 32h224c17.664 0 32-14.336 32-32v-224c0-17.664-14.336-32-32-32h-224c-17.664 0-32 14.336-32 32v224zM704 752c0-8.832-7.168-16-16-16h-512c-8.832 0-16 7.168-16 16s7.168 16 16 16h512c8.832 0 16-7.168 16-16zM704 688c0-8.832-7.168-16-16-16h-512c-8.832 0-16 7.168-16 16s7.168 16 16 16h512c8.832 0 16-7.168 16-16zM704 624c0-8.832-7.168-16-16-16h-512c-8.832 0-16 7.168-16 16s7.168 16 16 16h512c8.832 0 16-7.168 16-16zM704 560c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16zM704 496c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16zM704 432c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16zM704 368c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16zM704 304c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cover",
						"deliver",
						"report"
					],
					"grid": 32
				},
				{
					"id": 992,
					"width": 1024,
					"paths": [
						"M512 32c-264.672 0-480 215.328-480 480s215.328 480 480 480 480-215.328 480-480-215.328-480-480-480zM928 512c0 8.384-0.768 16.544-1.248 24.8-44.64 65.152-113.664 103.2-190.752 103.2-80.48 0-152-41.632-196.288-112.128 94.72-3.136 176.768-50.080 222.848-129.824 35.072-60.8 42.88-130.080 25.184-196.64 85.824 76.224 140.256 187.040 140.256 310.592zM740.704 164.896c34.304 71.328 32.736 150.24-5.856 217.152-40.256 69.696-112.064 111.008-195.296 113.984 44.672-83.648 45.088-178.144-0.992-257.984-35.232-61.024-91.616-102.368-158.464-120.224 41.504-13.952 85.76-21.824 131.904-21.824 84.48 0 163.040 25.472 228.704 68.896zM326.016 140.416c78.976 6.048 146.24 46.784 184.832 113.568 40.224 69.728 39.936 152.448 1.024 226.080-50.080-80.48-131.712-128.064-223.872-128.064-70.56 0-134.784 28.192-183.68 77.28 25.664-126.688 109.28-232.352 221.696-288.864zM96 512c0-8.384 0.768-16.544 1.248-24.8 44.64-65.152 113.664-103.2 190.752-103.2 80.48 0 152.032 41.632 196.32 112.16-94.624 3.264-176.8 50.048-222.88 129.792-35.072 60.8-42.88 130.080-25.184 196.64-85.824-76.224-140.256-187.040-140.256-310.592zM283.296 859.104c-34.304-71.328-32.736-150.24 5.856-217.152 40.224-69.664 112.288-110.848 195.264-113.92-44.672 83.616-45.056 178.144 1.024 257.952 35.104 60.8 91.104 102.592 157.632 120.512-41.28 13.76-85.248 21.504-131.072 21.504-84.48 0-163.040-25.472-228.704-68.896zM697.792 883.68c-78.688-5.952-146.112-46.944-184.672-113.664-40.224-69.728-39.936-152.448-1.024-226.080 50.112 80.48 131.744 128.064 223.904 128.064 70.56 0 134.784-28.192 183.68-77.28-25.664 126.784-109.376 232.448-221.888 288.96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crash",
						"spin",
						"fail",
						"pinwheel"
					],
					"grid": 32
				},
				{
					"id": 405,
					"width": 1024,
					"paths": [
						"M685.248 242.752l28.128-28.128c12.512-12.512 12.512-32.768 0-45.248l-18.752-18.752c-12.512-12.512-32.768-12.512-45.248 0l-73.376 73.376-124.128-124.128c-37.504-37.504-98.272-37.504-135.776 0l-216.224 216.256c-37.504 37.504-37.504 98.272 0 135.776l124.128 124.096-73.376 73.376c-12.512 12.512-12.512 32.768 0 45.248l18.752 18.752c12.512 12.512 32.768 12.512 45.248 0l28.128-28.128c24.992-24.992 65.504-24.992 90.496 0l238.848 238.848c37.504 37.504 98.272 37.504 135.776 0l216.224-216.224c37.504-37.504 37.504-98.272 0-135.776l-238.848-238.848c-24.992-24.992-24.992-65.504 0-90.496zM576 553.376l-78.176-78.176 78.176-78.176v156.352zM553.376 576h-156.352l78.176-78.176 78.176 78.176zM576 351.776l-100.8 100.8-105.376-105.376 142.048-142.048 64.128 64.096v82.528zM489.248 182.496l-142.048 142.048-105.248-105.216 96.8-96.8c24.992-24.992 65.504-24.992 90.496 0l60 59.968zM219.328 241.952l105.248 105.248-142.048 142.048-60-60c-24.992-24.992-24.992-65.504 0-90.496l96.8-96.8zM205.152 511.872l142.048-142.048 105.376 105.376-100.8 100.8h-82.528l-64.096-64.128zM356.064 662.816c-37.312-37.312-97.76-37.504-135.328-0.448l-28.736 28.384-18.752-18.752 64-64h338.752c17.664 0 32-14.336 32-32v-338.752l64-64 18.752 18.752-28.096 28.064c-37.504 37.472-37.536 98.304-0.032 135.776l238.88 238.88c24.992 24.992 24.992 65.504 0 90.496l-216.224 216.224c-24.992 24.992-65.504 24.992-90.496 0l-238.72-238.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crave",
						"eat",
						"snack",
						"indulge"
					],
					"grid": 32
				},
				{
					"id": 406,
					"width": 1024,
					"paths": [
						"M192 544l-92.128-92.128c-37.504-37.504-37.504-98.272 0-135.776l216.224-216.224c37.504-37.504 98.272-37.504 135.776 0l92.128 92.128v191.776l-68.8 68.8-105.376-105.376 132.704-132.704c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-132.704 132.704-95.872-95.904c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l95.872 95.872-132.672 132.672c-6.24 6.24-6.24 16.384 0 22.624 3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672l132.672-132.672 105.376 105.376-68.832 68.832h-191.776zM544 429.024l-46.176 46.176 46.176 46.176v-92.352zM924.128 572.128l-238.848-238.848c-24.992-24.992-24.992-65.504 0-90.496l28.128-28.128c12.512-12.48 12.512-32.768 0-45.248l-18.752-18.752c-12.512-12.512-32.768-12.512-45.248 0l-73.408 73.344v320c0 17.664-14.336 32-32 32h-320l-73.376 73.376c-12.512 12.512-12.512 32.768 0 45.248l18.752 18.752c12.512 12.512 32.768 12.512 45.248 0l28.128-28.128c24.992-24.992 65.504-24.992 90.496 0l238.848 238.848c37.504 37.504 98.272 37.504 135.776 0l216.224-216.224c37.504-37.472 37.504-98.272 0.032-135.744zM429.024 544h92.352l-46.176-46.176-46.176 46.176z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crave",
						"eat",
						"snack",
						"indulge"
					],
					"grid": 32
				},
				{
					"id": 407,
					"width": 1024,
					"paths": [
						"M835.872 259.904l-167.776-167.776c-17.984-18.016-42.4-28.128-67.872-28.128h-344.224c-53.024 0-96 42.976-96 96v704c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-536.224c0-25.472-10.112-49.888-28.128-67.872zM640 110.24c1.856 1.472 3.776 2.816 5.504 4.512l167.776 167.776c1.664 1.696 3.008 3.616 4.48 5.472h-113.76c-35.296 0-64-28.704-64-64v-113.76zM832 864c0 35.296-28.704 64-64 64h-512c-35.296 0-64-28.704-64-64v-704c0-35.296 28.704-64 64-64h344.224c2.656 0 5.184 0.448 7.776 0.768v127.232c0 52.928 43.072 96 96 96h127.232c0.32 2.592 0.768 5.12 0.768 7.776v536.224zM640 448h-64v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM640 544h-96v96h-64v-96h-96v-64h96v-96h64v96h96v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"create",
						"make",
						"start"
					],
					"grid": 32
				},
				{
					"id": 408,
					"width": 1024,
					"paths": [
						"M544 480h96v64h-96v96h-64v-96h-96v-64h96v-96h64v96zM864 327.776v536.224c0 53.024-42.976 96-96 96h-512c-53.024 0-96-42.976-96-96v-704c0-53.024 42.976-96 96-96h344.224c13.92 0 27.36 3.264 39.776 8.928v151.072c0 35.296 28.704 64 64 64h151.072c5.664 12.416 8.928 25.856 8.928 39.776zM672 480c0-17.664-14.336-32-32-32h-64v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64h64c17.664 0 32-14.336 32-32v-64zM704 256h128l-160-160v128c0 17.664 14.336 32 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"create",
						"make",
						"start"
					],
					"grid": 32
				},
				{
					"id": 993,
					"width": 1024,
					"paths": [
						"M384 0l-256 256v768h768v-1024h-512zM384 256h-165.504l165.632-165.632-0.128 165.632zM832 960h-640v-672h224v-224h416v896zM320 512v128h128v128h128v-128h128v-128h-128v-128h-128v128h-128zM480 544v-128h64v128h128v64h-128v128h-64v-128h-128v-64h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"create",
						"add",
						"make"
					],
					"grid": 32
				},
				{
					"id": 1732,
					"width": 1024,
					"paths": [
						"M345.714 704.571q87.429 0 146.857-59.429 8-10.286 1.714-20.571l-25.714-46.857q-3.429-7.429-13.714-9.714-9.143-1.143-15.429 6.286l-2.286 1.714q-2.286 2.286-6.571 5.714t-10 7.429-13.429 8.286-16.286 7.714-19.143 5.429-21.429 2q-43.429 0-71.429-28.571t-28-72.571q0-43.429 27.429-71.714t69.714-28.286q21.143 0 40.857 8t28.857 16l9.143 8q6.286 6.286 14.857 5.714 9.143-1.143 13.714-8l30.286-44.571q7.429-11.429-1.143-22.286-1.714-2.286-6.286-6.857t-17.143-13.429-27.714-16-38.571-12.857-49.143-5.714q-84.571 0-140.571 55.143t-56 137.429q0 83.429 55.429 138t141.143 54.571zM705.714 704.571q87.429 0 146.857-59.429 8-10.286 2.286-20.571l-25.714-46.857q-4.571-8-14.286-9.714-9.143-1.143-15.429 6.286l-2.286 1.714q-2.286 2.286-6.571 5.714t-10 7.429-13.429 8.286-16.286 7.714-19.143 5.429-21.429 2q-43.429 0-71.429-28.571t-28-72.571q0-43.429 27.429-71.714t69.714-28.286q21.143 0 40.857 8t28.857 16l9.143 8q6.286 6.286 14.857 5.714 9.143-1.143 13.714-8l30.286-44.571q7.429-11.429-1.143-22.286-1.714-2.286-6.286-6.857t-17.143-13.429-27.714-16-38.571-12.857-49.143-5.714q-84 0-140.286 55.143t-56.286 137.429q0 83.429 55.429 138t141.143 54.571zM512 91.429q-85.714 0-163.429 33.429t-134 89.714-89.714 134-33.429 163.429 33.429 163.429 89.714 134 134 89.714 163.429 33.429 163.429-33.429 134-89.714 89.714-134 33.429-163.429-33.429-163.429-89.714-134-134-89.714-163.429-33.429zM512 0q104 0 198.857 40.571t163.429 109.143 109.143 163.429 40.571 198.857-40.571 198.857-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"creative-commons"
					],
					"defaultCode": 62046,
					"grid": 14
				},
				{
					"id": 2090,
					"paths": [
						"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM96 192h832c17.346 0 32 14.654 32 32v96h-896v-96c0-17.346 14.654-32 32-32zM928 832h-832c-17.346 0-32-14.654-32-32v-288h896v288c0 17.346-14.654 32-32 32zM128 640h64v128h-64zM256 640h64v128h-64zM384 640h64v128h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"credit-card",
						"money",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59925,
					"grid": 16
				},
				{
					"id": 1766,
					"width": 1316.571044921875,
					"paths": [
						"M0 859.429v-347.429h1316.571v347.429q0 37.714-26.857 64.571t-64.571 26.857h-1133.714q-37.714 0-64.571-26.857t-26.857-64.571zM365.714 731.429v73.143h219.429v-73.143h-219.429zM146.286 731.429v73.143h146.286v-73.143h-146.286zM1225.143 73.143q37.714 0 64.571 26.857t26.857 64.571v128h-1316.571v-128q0-37.714 26.857-64.571t64.571-26.857h1133.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"credit-card-alt"
					],
					"defaultCode": 62083,
					"grid": 14
				},
				{
					"id": 2091,
					"paths": [
						"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM192 768h-64v-128h64v128zM320 768h-64v-128h64v128zM448 768h-64v-128h64v128zM992 512h-960v-192h960v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"credit-card",
						"money",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59926,
					"grid": 16
				},
				{
					"id": 1327,
					"width": 1097.1421699523926,
					"paths": [
						"M1005.714 73.143q37.714 0 64.571 26.857t26.857 64.571v694.857q0 37.714-26.857 64.571t-64.571 26.857h-914.286q-37.714 0-64.571-26.857t-26.857-64.571v-694.857q0-37.714 26.857-64.571t64.571-26.857h914.286zM91.429 146.286q-7.429 0-12.857 5.429t-5.429 12.857v128h950.857v-128q0-7.429-5.429-12.857t-12.857-5.429h-914.286zM1005.714 877.714q7.429 0 12.857-5.429t5.429-12.857v-347.429h-950.857v347.429q0 7.429 5.429 12.857t12.857 5.429h914.286zM146.286 804.571v-73.143h146.286v73.143h-146.286zM365.714 804.571v-73.143h219.429v73.143h-219.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"credit-card"
					],
					"defaultCode": 61597,
					"grid": 14
				},
				{
					"id": 409,
					"width": 1024,
					"paths": [
						"M884.416 613.056c-16.352-32.704-49.28-53.056-85.856-53.056h-31.36c-1.536-25.024-6.656-49.024-14.88-71.584l63.872-15.968c27.232-6.848 50.048-25.152 62.592-50.208l79.552-159.104c3.968-7.904 0.736-17.504-7.168-21.472s-17.504-0.704-21.472 7.168l-79.552 159.104c-8.352 16.704-23.584 28.896-41.728 33.472l-69.056 17.248c-7.968-15.392-17.344-29.888-28.128-43.264l65.952-65.952c14.208-14.208 23.488-32.224 26.816-52.096l27.776-166.72c1.44-8.704-4.448-16.96-13.152-18.4-8.704-1.536-16.96 4.416-18.4 13.152l-27.776 166.72c-2.208 13.216-8.384 25.248-17.888 34.72l-65.024 65.024c-29.504-28.448-65.792-49.824-106.24-61.568 34.208-22.976 56.704-61.984 56.704-106.272 0-70.688-57.312-128-128-128s-128 57.312-128 128c0 44.288 22.496 83.296 56.672 106.272-40.448 11.712-76.736 33.088-106.24 61.568l-64.992-65.024c-9.472-9.472-15.648-21.504-17.888-34.72l-27.776-166.72c-1.44-8.736-9.696-14.656-18.4-13.152-8.704 1.44-14.624 9.696-13.152 18.4l27.776 166.72c3.328 19.872 12.608 37.888 26.816 52.096l65.952 65.952c-10.784 13.376-20.192 27.872-28.128 43.264l-69.056-17.248c-18.144-4.576-33.376-16.736-41.728-33.472l-79.552-159.104c-3.968-7.872-13.536-11.104-21.472-7.136-7.904 3.968-11.104 13.568-7.136 21.472l79.552 159.104c12.544 25.056 35.328 43.36 62.592 50.208l63.872 15.968c-8.224 22.56-13.344 46.56-14.88 71.584h-31.36c-36.608 0-69.504 20.352-85.856 53.056l-73.888 147.776c-3.968 7.904-0.736 17.504 7.168 21.472 2.24 1.12 4.672 1.664 7.104 1.664 5.888 0 11.52-3.264 14.336-8.832l73.888-147.776c10.88-21.824 32.832-35.392 57.216-35.392h31.36c1.76 28.224 7.904 55.2 18.048 80.192l-52.896 35.264c-17.664 11.776-31.104 29.344-37.824 49.504l-55.328 165.984c-2.784 8.384 1.728 17.44 10.112 20.256 1.728 0.544 3.424 0.8 5.088 0.8 6.688 0 12.928-4.256 15.168-10.944l55.328-165.984c4.512-13.44 13.44-25.152 25.248-32.992l49.184-32.8c43.84 77.984 127.232 130.72 223.072 130.72s179.232-52.736 223.104-130.688l49.184 32.8c11.776 7.84 20.736 19.552 25.248 32.992l55.328 165.984c2.24 6.688 8.48 10.944 15.168 10.944 1.664 0 3.36-0.256 5.056-0.8 8.384-2.816 12.896-11.872 10.112-20.256l-55.328-165.984c-6.72-20.16-20.16-37.728-37.824-49.504l-52.896-35.264c10.144-24.992 16.288-52 18.048-80.192h31.36c24.384 0 46.336 13.568 57.248 35.36l73.888 147.776c2.816 5.6 8.448 8.832 14.336 8.832 2.4 0 4.832-0.544 7.136-1.696 7.904-3.968 11.104-13.568 7.168-21.472l-73.92-147.776zM416 224c0-52.928 43.072-96 96-96s96 43.072 96 96-43.072 96-96 96-96-43.072-96-96zM512 800c-123.52 0-224-100.48-224-224s100.48-224 224-224 224 100.48 224 224-100.48 224-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"creep",
						"spin",
						"crawl"
					],
					"grid": 32
				},
				{
					"id": 410,
					"width": 1024,
					"paths": [
						"M884.416 613.056c-16.352-32.704-49.28-53.056-85.856-53.056h-31.36c-1.536-25.024-6.656-49.024-14.88-71.584l63.872-15.968c27.232-6.848 50.048-25.152 62.592-50.208l79.552-159.104c3.968-7.904 0.736-17.504-7.168-21.472s-17.504-0.704-21.472 7.168l-79.552 159.104c-8.352 16.704-23.584 28.896-41.728 33.472l-69.056 17.248c-7.968-15.392-17.344-29.888-28.128-43.264l65.952-65.952c14.208-14.208 23.488-32.224 26.816-52.096l27.776-166.72c1.44-8.704-4.448-16.96-13.152-18.4-8.704-1.536-16.96 4.416-18.4 13.152l-27.776 166.72c-2.208 13.216-8.384 25.248-17.888 34.72l-65.024 65.024c-29.504-28.448-65.792-49.824-106.24-61.568 34.208-22.976 56.704-61.984 56.704-106.272 0-70.688-57.312-128-128-128s-128 57.312-128 128c0 44.288 22.496 83.296 56.672 106.272-40.448 11.712-76.736 33.088-106.24 61.568l-64.992-65.024c-9.472-9.472-15.648-21.504-17.888-34.72l-27.776-166.72c-1.44-8.736-9.696-14.656-18.4-13.152-8.704 1.44-14.624 9.696-13.152 18.4l27.776 166.72c3.328 19.872 12.608 37.888 26.816 52.096l65.952 65.952c-10.784 13.376-20.192 27.872-28.128 43.264l-69.056-17.248c-18.144-4.576-33.376-16.736-41.728-33.472l-79.552-159.104c-3.968-7.872-13.536-11.104-21.472-7.136-7.904 3.968-11.104 13.568-7.136 21.472l79.552 159.104c12.544 25.056 35.328 43.36 62.592 50.208l63.872 15.968c-8.224 22.56-13.344 46.56-14.88 71.584h-31.36c-36.608 0-69.504 20.352-85.856 53.056l-73.888 147.776c-3.968 7.904-0.736 17.504 7.168 21.472 2.24 1.12 4.672 1.664 7.104 1.664 5.888 0 11.52-3.264 14.336-8.832l73.888-147.776c10.88-21.824 32.832-35.392 57.216-35.392h31.36c1.76 28.224 7.904 55.2 18.048 80.192l-52.896 35.264c-17.664 11.776-31.104 29.344-37.824 49.504l-55.328 165.984c-2.784 8.384 1.728 17.44 10.112 20.256 1.728 0.544 3.424 0.8 5.088 0.8 6.688 0 12.928-4.256 15.168-10.944l55.328-165.984c4.512-13.44 13.44-25.152 25.248-32.992l49.184-32.8c43.84 77.984 127.232 130.72 223.072 130.72s179.232-52.736 223.104-130.688l49.184 32.8c11.776 7.84 20.736 19.552 25.248 32.992l55.328 165.984c2.24 6.688 8.48 10.944 15.168 10.944 1.664 0 3.36-0.256 5.056-0.8 8.384-2.816 12.896-11.872 10.112-20.256l-55.328-165.984c-6.72-20.16-20.16-37.728-37.824-49.504l-52.896-35.264c10.144-24.992 16.288-52 18.048-80.192h31.36c24.384 0 46.336 13.568 57.248 35.36l73.888 147.776c2.816 5.6 8.448 8.832 14.336 8.832 2.4 0 4.832-0.544 7.136-1.696 7.904-3.968 11.104-13.568 7.168-21.472l-73.92-147.776z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"creep",
						"spin",
						"crawl"
					],
					"grid": 32
				},
				{
					"id": 994,
					"width": 1024,
					"paths": [
						"M871.168 397.984c-38.752-32.8-79.904-52.48-118.112-64.192-33.568-87.2-121.984-141.792-241.056-141.792s-207.52 54.592-241.056 141.824c-38.176 11.68-79.328 31.36-118.112 64.16-95.84 81.152-147.040 216.064-152.352 401.28-0.544 17.888 14.208 32.736 32.096 32.736 17.44 0 31.36-14.112 31.872-31.52 4.832-165.44 48.16-284.128 129.024-353.056 20.384-17.376 41.76-29.792 62.912-39.264-0.32 10.528-1.088 14.272 1.248 35.328-11.744 6.4-23.488 14.048-35.008 23.296-78.688 63.104-121.056 174.912-126.112 332.576-0.576 17.888 14.144 32.64 32.032 32.64 17.408 0 31.392-14.080 31.936-31.488 3.392-104.64 26.208-234.88 114.304-292.32 4.512 10.144 10.016 19.648 16.032 28.768-60.64 44-93.632 132.16-98.272 262.4-0.608 17.856 14.144 32.64 32.064 32.64 17.056 0 31.328-13.44 31.936-30.464 2.528-72.416 16.416-179.68 78.432-216.704 7.744 6.144 15.936 11.872 24.704 17.056-42.336 36.416-66.336 101.824-70.848 196.096-0.928 18.368 13.536 34.016 31.968 34.016 16.96 0 31.104-13.44 31.872-30.4 4.48-100.576 31.232-140.672 54.016-156.448 14.56-10.080 29.92-11.712 41.824-11.008 43.072 7.936 86.72 7.776 129.76-0.544 11.52-0.064 25.76 2.272 39.136 11.52 22.784 15.776 49.536 55.84 54.016 156.448 0.768 16.96 14.88 30.4 31.872 30.4 18.4 0 32.896-15.648 32-34.016-4.512-94.272-28.512-159.68-70.848-196.096 8.768-5.184 16.96-10.944 24.736-17.088 62.016 37.28 75.84 144.32 78.4 216.736 0.48 17.056 14.752 30.496 31.808 30.496 17.888 0 32.672-14.784 32.032-32.672-4.64-130.208-37.632-218.368-98.272-262.4 6.016-9.12 11.52-18.624 16.032-28.768 88.064 57.44 110.912 187.68 114.304 292.32 0.576 17.44 14.464 31.52 31.872 31.52 17.888 0 32.672-14.752 32.128-32.608-5.056-157.664-47.392-269.472-126.112-332.576-11.552-9.248-23.296-16.864-35.008-23.296 2.368-21.184 1.568-24.928 1.248-35.456 21.12 9.504 42.528 21.984 62.912 39.36 80.864 68.928 124.224 187.616 129.024 353.056 0.512 17.408 14.432 31.52 31.872 31.52 17.888 0 32.64-14.848 32.128-32.736-5.344-185.216-56.544-320.128-152.384-401.28zM512 576c-88.576 0-192-41.92-192-160s103.424-160 192-160 192 41.92 192 160-103.424 160-192 160zM432 384c-26.464 0-48 21.536-48 48s21.536 48 48 48 48-21.536 48-48-21.536-48-48-48zM432 448c-8.832 0-16-7.168-16-16s7.168-16 16-16c8.832 0 16 7.168 16 16s-7.168 16-16 16zM592 384c-26.464 0-48 21.536-48 48s21.536 48 48 48 48-21.536 48-48-21.536-48-48-48zM592 448c-8.832 0-16-7.168-16-16s7.168-16 16-16c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"creep",
						"crawl"
					],
					"grid": 32
				},
				{
					"id": 3216,
					"paths": [
						"M832 256l192-192-64-64-192 192h-448v-192h-128v192h-192v128h192v512h512v192h128v-192h192v-128h-192v-448zM320 320h320l-320 320v-320zM384 704l320-320v320h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crop",
						"resize",
						"cut"
					],
					"defaultCode": 61051,
					"grid": 16
				},
				{
					"id": 3217,
					"paths": [
						"M320 704v-704h-128v192h-192v128h192v512h512v192h128v-192h192v-128z",
						"M704 640h128v-448h-448v128h320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crop",
						"resize",
						"cut"
					],
					"defaultCode": 61052,
					"grid": 16
				},
				{
					"id": 1440,
					"width": 950.8559789657593,
					"paths": [
						"M318.286 731.429h340v-340zM292.571 705.714l340-340h-340v340zM950.857 749.714v109.714q0 8-5.143 13.143t-13.143 5.143h-128v128q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-128h-493.714q-8 0-13.143-5.143t-5.143-13.143v-493.714h-128q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h128v-128q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v128h486.286l140.571-141.143q5.714-5.143 13.143-5.143t13.143 5.143q5.143 5.714 5.143 13.143t-5.143 13.143l-141.143 140.571v486.286h128q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crop"
					],
					"defaultCode": 61733,
					"grid": 14
				},
				{
					"id": 234,
					"paths": [
						"M998.4 768h-153.6c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h153.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M640 768h-358.4c-14.138 0-25.6-11.461-25.6-25.6v-358.4c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v332.8h332.8c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M281.6 204.8c-14.138 0-25.6-11.462-25.6-25.6v-153.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v153.6c0 14.138-11.462 25.6-25.6 25.6z",
						"M742.4 1024c-14.139 0-25.6-11.461-25.6-25.6v-691.2h-691.2c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h716.8c14.139 0 25.6 11.462 25.6 25.6v716.8c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crop",
						"cut"
					],
					"defaultCode": 59531,
					"grid": 20
				},
				{
					"id": 995,
					"width": 1024,
					"paths": [
						"M960 32h-896c-17.664 0-32 14.336-32 32v896c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-896c0-17.664-14.336-32-32-32zM928 928h-832v-832h832v832zM160 256h-32v-128h128v32h-96v96zM896 896h-128v-32h96v-96h32v128zM864 160h-96v-32h128v128h-32v-96zM256 896h-128v-128h32v96h96v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crop",
						"trim"
					],
					"grid": 32
				},
				{
					"id": 2945,
					"paths": [
						"M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cross",
						"cancel",
						"close",
						"quit",
						"remove"
					],
					"defaultCode": 60780,
					"grid": 16
				},
				{
					"id": 223,
					"paths": [
						"M733.808 723.266l-208.874-185.666 208.874-185.667c10.566-9.394 11.518-25.574 2.126-36.141-9.394-10.566-25.574-11.522-36.142-2.126l-213.392 189.682-213.392-189.68c-10.568-9.392-26.749-8.44-36.141 2.126-9.394 10.566-8.442 26.749 2.126 36.141l208.874 185.666-208.875 185.666c-10.566 9.394-11.518 25.574-2.126 36.142 5.059 5.691 12.085 8.592 19.142 8.592 6.048 0 12.122-2.131 16.998-6.466l213.394-189.683 213.392 189.683c4.878 4.334 10.949 6.466 16.998 6.466 7.058 0 14.086-2.902 19.144-8.592 9.392-10.568 8.44-26.749-2.126-36.142z",
						"M486.4 1024c-129.922 0-252.067-50.594-343.936-142.464s-142.464-214.014-142.464-343.936c0-129.923 50.595-252.067 142.464-343.936s214.013-142.464 343.936-142.464c129.922 0 252.067 50.595 343.936 142.464s142.464 214.014 142.464 343.936-50.594 252.067-142.464 343.936c-91.869 91.87-214.014 142.464-343.936 142.464zM486.4 102.4c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2 435.2-195.23 435.2-435.2-195.23-435.2-435.2-435.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cross-circle",
						"cross"
					],
					"defaultCode": 59520,
					"grid": 20
				},
				{
					"id": 2946,
					"paths": [
						"M893.254 221.254l-90.508-90.508-290.746 290.744-290.746-290.744-90.508 90.506 290.746 290.748-290.746 290.746 90.508 90.508 290.746-290.746 290.746 290.746 90.508-90.51-290.744-290.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cross",
						"cancel",
						"close",
						"quit",
						"remove"
					],
					"defaultCode": 60781,
					"grid": 16
				},
				{
					"id": 2947,
					"paths": [
						"M781.256 690.744l-90.512 90.512-178.744-178.746-178.746 178.744-90.51-90.51 178.746-178.744-178.744-178.746 90.508-90.508 178.746 178.744 178.744-178.746 90.512 90.51-178.746 178.746 178.746 178.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cross",
						"cancel",
						"close",
						"quit",
						"remove"
					],
					"defaultCode": 60782,
					"grid": 16
				},
				{
					"id": 207,
					"paths": [
						"M548.203 537.6l289.099-289.098c9.998-9.998 9.998-26.206 0-36.205-9.997-9.997-26.206-9.997-36.203 0l-289.099 289.099-289.098-289.099c-9.998-9.997-26.206-9.997-36.205 0-9.997 9.998-9.997 26.206 0 36.205l289.099 289.098-289.099 289.099c-9.997 9.997-9.997 26.206 0 36.203 5 4.998 11.55 7.498 18.102 7.498s13.102-2.499 18.102-7.499l289.098-289.098 289.099 289.099c4.998 4.998 11.549 7.498 18.101 7.498s13.102-2.499 18.101-7.499c9.998-9.997 9.998-26.206 0-36.203l-289.098-289.098z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cross",
						"cancel"
					],
					"defaultCode": 59504,
					"grid": 20
				},
				{
					"id": 1265,
					"width": 877.7149925231934,
					"paths": [
						"M684 585.143h-62.286q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h62.286q-18.286-61.714-64.286-107.714t-107.714-64.286v62.286q0 14.857-10.857 25.714t-25.714 10.857h-73.143q-14.857 0-25.714-10.857t-10.857-25.714v-62.286q-61.714 18.286-107.714 64.286t-64.286 107.714h62.286q14.857 0 25.714 10.857t10.857 25.714v73.143q0 14.857-10.857 25.714t-25.714 10.857h-62.286q18.286 61.714 64.286 107.714t107.714 64.286v-62.286q0-14.857 10.857-25.714t25.714-10.857h73.143q14.857 0 25.714 10.857t10.857 25.714v62.286q61.714-18.286 107.714-64.286t64.286-107.714zM877.714 475.429v73.143q0 14.857-10.857 25.714t-25.714 10.857h-81.714q-21.143 92-88.286 159.143t-159.143 88.286v81.714q0 14.857-10.857 25.714t-25.714 10.857h-73.143q-14.857 0-25.714-10.857t-10.857-25.714v-81.714q-92-21.143-159.143-88.286t-88.286-159.143h-81.714q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h81.714q21.143-92 88.286-159.143t159.143-88.286v-81.714q0-14.857 10.857-25.714t25.714-10.857h73.143q14.857 0 25.714 10.857t10.857 25.714v81.714q92 21.143 159.143 88.286t88.286 159.143h81.714q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crosshairs"
					],
					"defaultCode": 61531,
					"grid": 14
				},
				{
					"id": 2490,
					"paths": [
						"M256 768h512v128h-512zM960 192c-35.346 0-64 28.654-64 64 0 13.134 3.962 25.34 10.75 35.5l-234.75 156.5-24.062-192.508c31.598-3.91 56.062-30.834 56.062-63.492 0-35.346-28.654-64-64-64s-64 28.654-64 64c0 25.056 14.406 46.734 35.378 57.242l-99.378 198.758-99.378-198.758c20.972-10.508 35.378-32.186 35.378-57.242 0-35.346-28.654-64-64-64s-64 28.654-64 64c0 32.658 24.464 59.582 56.064 63.492l-24.064 192.508-234.748-156.5c6.786-10.158 10.748-22.366 10.748-35.5 0-35.346-28.654-64-64-64s-64 28.654-64 64 28.654 64 64 64c8.956 0 17.476-1.846 25.214-5.166l166.786 389.166h512l166.786-389.166c7.738 3.32 16.26 5.166 25.214 5.166 35.346 0 64-28.654 64-64s-28.654-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crown",
						"king"
					],
					"defaultCode": 60325,
					"grid": 16
				},
				{
					"id": 411,
					"width": 1024,
					"paths": [
						"M320 384c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM320 480c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM550.368 91.424c-22.752-17.28-53.984-17.376-76.8-0.192-89.312 67.328-303.968 254.144-313.248 500.288-6.816 180.832 117.44 336.992 296.352 364.256 218.912 33.344 407.328-135.232 407.328-347.776 0-252.416-222.4-447.264-313.632-516.576zM478.944 926.336c-167.52-16.896-293.888-167.584-286.56-335.808 10.016-230.176 215.232-408.992 300.352-473.504 11.328-8.608 26.976-8.608 38.304 0 87.2 66.464 300.96 253.632 300.96 490.976 0 187.36-161.824 337.6-353.056 318.336z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cry",
						"rain",
						"weep",
						"drip",
						"sob"
					],
					"grid": 32
				},
				{
					"id": 412,
					"width": 1024,
					"paths": [
						"M352 448c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM864 608c0 212.544-188.416 381.12-407.328 347.776-178.912-27.232-303.168-183.392-296.352-364.256 9.28-246.176 223.936-432.96 313.248-500.288 22.816-17.216 54.048-17.088 76.8 0.192 91.232 69.312 313.632 264.16 313.632 516.576zM384 448c0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64c35.36 0 64-28.64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cry",
						"rain",
						"weep",
						"drip",
						"sob"
					],
					"grid": 32
				},
				{
					"id": 996,
					"width": 1024,
					"paths": [
						"M512 0c-69.344 0-416 273.056-416 614.4 0 226.208 186.24 409.6 416 409.6s416-183.392 416-409.6c0-341.344-346.656-614.4-416-614.4zM512 960c-194.080 0-352-155.040-352-345.6 0-290.656 284.768-524.512 352-549.248 67.264 24.736 352 258.56 352 549.248 0 190.56-157.92 345.6-352 345.6zM266.528 714.528c-9.28 9.28-13.728 22.080-13.696 36.416 0 24.32 12.768 53.12 36.352 76.704 37.504 37.504 88.128 47.616 113.152 22.624 9.28-9.28 13.696-22.080 13.696-36.416 0-24.32-12.768-53.12-36.352-76.704-37.504-37.504-88.16-47.616-113.152-22.624zM379.648 827.648c-9.216 9.216-40.256 4.992-67.872-22.624-19.872-19.872-26.976-40.96-26.976-54.080 0-4.32 0.736-10.208 4.352-13.792 4.16-4.16 12.736-5.408 22.976-3.36 15.008 3.008 31.392 12.48 44.896 25.984 19.872 19.872 26.976 40.96 26.976 54.080 0 4.32-0.768 10.208-4.352 13.792z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cry",
						"rain",
						"weep",
						"drip",
						"sob"
					],
					"grid": 32
				},
				{
					"id": 2873,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416z",
						"M800 384h-128c-17.674 0-32-14.328-32-32s14.326-32 32-32h128c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M352 384h-128c-17.672 0-32-14.328-32-32s14.328-32 32-32h128c17.672 0 32 14.328 32 32s-14.328 32-32 32z",
						"M608 856c-8.19 0-16.378-3.124-22.626-9.374-4.582-4.582-29.42-14.626-73.374-14.626s-68.79 10.044-73.374 14.626c-12.496 12.496-32.758 12.496-45.254 0-12.498-12.496-12.498-32.758 0-45.254 30.122-30.12 92.994-33.372 118.628-33.372 25.632 0 88.506 3.252 118.626 33.374 12.498 12.496 12.498 32.758 0 45.254-6.248 6.248-14.436 9.372-22.626 9.372z",
						"M736 576c-17.674 0-32-14.326-32-32v-64c0-17.672 14.326-32 32-32s32 14.328 32 32v64c0 17.674-14.326 32-32 32z",
						"M736 768c-17.674 0-32-14.326-32-32v-64c0-17.674 14.326-32 32-32s32 14.326 32 32v64c0 17.674-14.326 32-32 32z",
						"M288 576c-17.672 0-32-14.326-32-32v-64c0-17.672 14.328-32 32-32s32 14.328 32 32v64c0 17.674-14.328 32-32 32z",
						"M288 768c-17.672 0-32-14.326-32-32v-64c0-17.674 14.328-32 32-32s32 14.326 32 32v64c0 17.674-14.328 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crying",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60708,
					"grid": 16
				},
				{
					"id": 2874,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM320 736c0 17.674-14.328 32-32 32s-32-14.326-32-32v-64c0-17.674 14.328-32 32-32s32 14.326 32 32v64zM320 544c0 17.674-14.328 32-32 32s-32-14.326-32-32v-64c0-17.672 14.328-32 32-32s32 14.328 32 32v64zM352 384h-128c-17.672 0-32-14.328-32-32s14.328-32 32-32h128c17.672 0 32 14.328 32 32s-14.328 32-32 32zM630.626 846.626c-6.248 6.25-14.436 9.374-22.626 9.374s-16.378-3.124-22.626-9.374c-4.582-4.582-29.42-14.626-73.374-14.626s-68.79 10.044-73.374 14.626c-12.496 12.496-32.758 12.496-45.254 0-12.498-12.496-12.498-32.758 0-45.254 30.122-30.12 92.994-33.372 118.628-33.372 25.632 0 88.506 3.252 118.626 33.374 12.498 12.496 12.498 32.756 0 45.252zM768 736c0 17.674-14.326 32-32 32s-32-14.326-32-32v-64c0-17.674 14.326-32 32-32s32 14.326 32 32v64zM768 544c0 17.674-14.326 32-32 32s-32-14.326-32-32v-64c0-17.672 14.326-32 32-32s32 14.328 32 32v64zM800 384h-128c-17.674 0-32-14.328-32-32s14.326-32 32-32h128c17.674 0 32 14.328 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"crying",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60709,
					"grid": 16
				},
				{
					"id": 3418,
					"paths": [
						"M152.388 48.522l-34.36 171.926h699.748l-21.884 111.054h-700.188l-33.892 171.898h699.684l-39.018 196.064-282.012 93.422-244.4-93.422 16.728-85.042h-171.898l-40.896 206.352 404.226 154.704 466.006-154.704 153.768-772.252z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"css3",
						"w3c"
					],
					"defaultCode": 61253,
					"grid": 16
				},
				{
					"id": 1462,
					"width": 1024.0000610351562,
					"paths": [
						"M157.143 73.143h860l-152 761.714-459.429 152.571-398.857-152.571 40.571-203.429h169.714l-16.571 84 241.143 92 277.714-92 38.857-193.714h-690.286l33.143-169.714h690.857l21.714-109.143h-690.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"css3"
					],
					"defaultCode": 61756,
					"grid": 14
				},
				{
					"id": 3193,
					"paths": [
						"M736.014 448c-8.908 0-17.77-3.698-24.096-10.928l-199.918-228.478-199.918 228.478c-11.636 13.3-31.856 14.65-45.154 3.010-13.3-11.638-14.648-31.854-3.010-45.154l224-256c6.076-6.944 14.854-10.928 24.082-10.928s18.006 3.984 24.082 10.928l224 256c11.638 13.3 10.292 33.516-3.010 45.154-6.070 5.312-13.582 7.918-21.058 7.918z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ctrl",
						"control"
					],
					"defaultCode": 61028,
					"grid": 16
				},
				{
					"id": 2605,
					"paths": [
						"M480 64l-480 192v448l480 256 480-256v-448l-480-192zM448 870.4l-384-204.8v-311.466l384 204.8v311.466zM82.996 291.732l397.004-158.802 397.004 158.802-397.004 211.734-397.004-211.734z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cube",
						"3d",
						"box",
						"miscellaneous"
					],
					"defaultCode": 60440,
					"grid": 16
				},
				{
					"id": 2606,
					"paths": [
						"M480 64l-480 192v448l480 256 480-256v-448l-480-192zM448 870.4l-384-204.8v-311.466l384 204.8v311.466zM82.996 291.732l397.004-158.802 397.004 158.802-397.004 211.734-397.004-211.734zM896 665.6l-384 204.8v-311.466l384-204.8v311.466z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cube",
						"3d",
						"box",
						"miscellaneous"
					],
					"defaultCode": 60441,
					"grid": 16
				},
				{
					"id": 2607,
					"paths": [
						"M488.032 0h-16.062l-471.97 252.84v456.242l470.274 314.918h19.454l470.272-314.918v-456.242l-471.968-252.84zM860.234 272l-153.038 81.984-170.020-91.084 153.036-81.984 170.022 91.084zM480 68.302l153.038 81.984-153.038 81.986-153.038-81.984 153.038-81.986zM269.786 180.916l153.038 81.986-170.022 91.082-153.038-81.984 170.022-91.084zM197.084 764.034l-133.084-89.12v-155.126l133.084 83.178v161.068zM197.084 539.286l-133.084-83.178v-130.662l133.084 71.294v142.546zM448 932.058l-196.916-131.866v-163.478l196.916 123.076v172.268zM448 696.108l-196.916-123.072v-147.368l196.916 105.492v164.948zM480 475.698l-170.020-91.082 170.020-91.084 170.022 91.082-170.022 91.084zM708.918 800.194l-196.918 131.864v-172.27l196.918-123.074v163.48zM708.918 573.036l-196.918 123.074v-164.95l196.918-105.492v147.368zM896 674.914l-133.082 89.118v-161.066l133.082-83.178v155.126zM896 456.108l-133.082 83.176v-142.544l133.082-71.294v130.662z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cube",
						"3d",
						"box"
					],
					"defaultCode": 60442,
					"grid": 16
				},
				{
					"id": 2608,
					"paths": [
						"M488.032 0h-16.062l-471.97 252.84v456.242l470.274 314.918h19.454l470.272-314.918v-456.242l-471.968-252.84zM406.1 904l-23.894-16h65.794v16h-41.9zM448 920v12.058l-18.008-12.058h18.008zM358.314 872l-23.894-16h113.58v16h-89.686zM310.526 840l-23.892-16h161.366v16h-137.474zM262.74 808l-23.892-16h209.152v16h-185.26zM214.954 776l-23.894-16h256.94v16h-233.046zM167.168 744l-23.894-16h304.726v16h-280.832zM119.38 712l-23.892-16h352.512v16h-328.62zM71.594 680l-7.594-5.086v-10.914h384v16h-376.406zM64 648v-16h384v16h-384zM64 616v-16h384v16h-384zM64 584v-16h384v16h-384zM64 552v-16h384v16h-384zM64 520v-16h333.3l29.868 16h-363.168zM64 488v-16h273.568l29.868 16h-303.436zM64 456v-16h213.834l29.868 16h-243.702zM64 424v-16h154.1l29.866 16h-183.966zM64 392v-16h94.368l29.868 16h-124.236zM64 360v-16h34.634l29.866 16h-64.5zM64 328v-2.554l4.766 2.554h-4.766zM480 475.698l-380.236-203.698 380.236-203.698 380.234 203.698-380.234 203.698z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cube",
						"3d",
						"box",
						"dualtone"
					],
					"defaultCode": 60443,
					"grid": 16
				},
				{
					"id": 1572,
					"width": 950.855978012085,
					"paths": [
						"M512 930.857l365.714-199.429v-363.429l-365.714 133.143v429.714zM475.429 436.571l398.857-145.143-398.857-145.143-398.857 145.143zM950.857 292.571v438.857q0 20-10.286 37.143t-28 26.857l-402.286 219.429q-16 9.143-34.857 9.143t-34.857-9.143l-402.286-219.429q-17.714-9.714-28-26.857t-10.286-37.143v-438.857q0-22.857 13.143-41.714t34.857-26.857l402.286-146.286q12.571-4.571 25.143-4.571t25.143 4.571l402.286 146.286q21.714 8 34.857 26.857t13.143 41.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cube"
					],
					"defaultCode": 61874,
					"grid": 14
				},
				{
					"id": 1573,
					"width": 1243.4350242614746,
					"paths": [
						"M365.714 932.571l219.429-109.714v-179.429l-219.429 93.714v195.429zM329.143 673.143l230.857-98.857-230.857-98.857-230.857 98.857zM950.857 932.571l219.429-109.714v-179.429l-219.429 93.714v195.429zM914.286 673.143l230.857-98.857-230.857-98.857-230.857 98.857zM658.286 505.714l219.429-94.286v-152l-219.429 93.714v152.571zM621.714 289.143l252-108-252-108-252 108zM1243.429 585.143v237.714q0 20.571-10.857 38.286t-29.714 26.857l-256 128q-14.286 8-32.571 8t-32.571-8l-256-128q-2.857-1.143-4-2.286-1.143 1.143-4 2.286l-256 128q-14.286 8-32.571 8t-32.571-8l-256-128q-18.857-9.143-29.714-26.857t-10.857-38.286v-237.714q0-21.714 12.286-40t32.286-27.429l248-106.286v-228.571q0-21.714 12.286-40t32.286-27.429l256-109.714q13.143-5.714 28.571-5.714t28.571 5.714l256 109.714q20 9.143 32.286 27.429t12.286 40v228.571l248 106.286q20.571 9.143 32.571 27.429t12 40z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cubes"
					],
					"defaultCode": 61875,
					"grid": 14
				},
				{
					"id": 2525,
					"width": 1088,
					"paths": [
						"M900 448h-868c-17.672 0-32 14.328-32 32 0 97.586 19.904 193.272 57.558 276.708 37.022 82.038 90.074 150.164 153.418 197.018 5.508 4.074 12.178 6.274 19.030 6.274h-134.006c-17.672 0-32 14.326-32 32s14.328 32 32 32h640c17.674 0 32-14.326 32-32s-14.326-32-32-32h-134.006c6.852 0 13.522-2.2 19.030-6.274 58.308-43.128 107.882-104.292 144.274-177.726h6.702c101.402 0 162.51-35.398 195.918-65.094 40.126-35.668 64.082-84.606 64.082-130.906 0-72.786-59.214-132-132-132zM727.122 704h-622.242c-22.824-58.732-36.76-123.974-40.096-192h702.434c-3.336 68.026-17.272 133.268-40.096 192zM920.082 657.094c-21.556 19.162-60.104 41.606-124.494 46.090 19.774-57.7 31.734-119.726 35.282-183.184h69.13c33.084 0 60 26.916 60 60 0 20.118-10.486 50.932-39.918 77.094z",
						"M288 384c-17.672 0-32-14.328-32-32v-128c0-17.672 14.328-32 32-32s32 14.328 32 32v128c0 17.672-14.326 32-32 32z",
						"M416 384c-17.672 0-32-14.328-32-32v-256c0-17.672 14.328-32 32-32s32 14.328 32 32v256c0 17.672-14.326 32-32 32z",
						"M544 384c-17.674 0-32-14.328-32-32v-128c0-17.672 14.326-32 32-32s32 14.328 32 32v128c0 17.672-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cup",
						"drink",
						"coffee",
						"break",
						"beverage",
						"hot",
						"breakfast"
					],
					"defaultCode": 60360,
					"grid": 16
				},
				{
					"id": 2526,
					"width": 1088,
					"paths": [
						"M900 448h-868c-17.672 0-32 14.328-32 32 0 97.586 19.904 193.272 57.558 276.708 37.022 82.038 90.074 150.164 153.418 197.018 5.508 4.074 12.178 6.274 19.030 6.274h-134.006c-17.672 0-32 14.326-32 32s14.328 32 32 32h640c17.674 0 32-14.326 32-32s-14.326-32-32-32h-134.006c6.852 0 13.522-2.2 19.030-6.274 58.308-43.128 107.882-104.292 144.274-177.726h6.702c101.402 0 162.51-35.398 195.918-65.094 40.126-35.668 64.082-84.606 64.082-130.906 0-72.786-59.214-132-132-132zM920.082 657.094c-21.556 19.162-60.104 41.606-124.494 46.090 19.774-57.7 31.734-119.726 35.282-183.184h69.13c33.084 0 60 26.916 60 60 0 20.118-10.486 50.932-39.918 77.094z",
						"M288 384c-17.672 0-32-14.328-32-32v-128c0-17.672 14.328-32 32-32s32 14.328 32 32v128c0 17.672-14.326 32-32 32z",
						"M416 384c-17.672 0-32-14.328-32-32v-256c0-17.672 14.328-32 32-32s32 14.328 32 32v256c0 17.672-14.326 32-32 32z",
						"M544 384c-17.674 0-32-14.328-32-32v-128c0-17.672 14.326-32 32-32s32 14.328 32 32v128c0 17.672-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cup",
						"drink",
						"coffee",
						"break",
						"beverage",
						"hot",
						"breakfast"
					],
					"defaultCode": 60361,
					"grid": 16
				},
				{
					"id": 413,
					"width": 1024,
					"paths": [
						"M288 576c-70.688 0-128 57.312-128 128s57.312 128 128 128c70.688 0 128-57.312 128-128s-57.312-128-128-128zM288 800c-52.928 0-96-43.072-96-96s43.072-96 96-96c52.928 0 96 43.072 96 96s-43.072 96-96 96zM768 768c70.688 0 128-57.312 128-128s-57.312-128-128-128c-70.688 0-128 57.312-128 128s57.312 128 128 128zM768 544c52.928 0 96 43.072 96 96s-43.072 96-96 96c-52.928 0-96-43.072-96-96s43.072-96 96-96zM916.224 369.408l-649.344-216.448c-51.744-17.248-110.080-0.832-142.048 43.328-39.072 53.984-60.832 119.488-60.832 187.712v416c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-369.856c0-27.552-17.632-52.032-43.776-60.736zM150.080 216.224c23.872-33.408 67.872-45.824 106.848-32.864l602.016 200.64h-255.488c-14.24-55.104-63.872-96-123.456-96s-109.184 40.896-123.488 96h-260.512c0-60.576 19.424-119.328 54.080-167.776zM576 416c0 52.928-43.072 96-96 96s-96-43.072-96-96h192zM389.888 384c13.248-37.152 48.448-64 90.112-64s76.832 26.848 90.112 64h-180.224zM928 800c0 35.36-28.64 64-64 64h-704c-35.36 0-64-28.64-64-64v-384h256c0 70.688 57.312 128 128 128s128-57.312 128-128h316.32c2.144 4.32 3.68 8.992 3.68 14.080v369.92z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"curdle",
						"eat",
						"snack"
					],
					"grid": 32
				},
				{
					"id": 414,
					"width": 1024,
					"paths": [
						"M384 704c0 52.928-43.072 96-96 96s-96-43.072-96-96 43.072-96 96-96c52.928 0 96 43.072 96 96zM480 512c52.928 0 96-43.072 96-96h-192c0 52.928 43.072 96 96 96zM480 320c-41.664 0-76.832 26.848-90.112 64h180.192c-13.248-37.152-48.416-64-90.080-64zM480 288c59.584 0 109.216 40.896 123.488 96h335.84c-6.624-6.24-14.080-11.584-23.104-14.592l-649.344-216.448c-51.744-17.248-110.080-0.832-142.048 43.328-39.072 53.984-60.832 119.488-60.832 187.712h292.512c14.304-55.104 63.904-96 123.488-96zM957.76 416c1.056 4.64 2.24 9.248 2.24 14.144v369.856c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-384h288c0 70.688 57.312 128 128 128s128-57.312 128-128h349.76zM416 704c0-70.688-57.312-128-128-128s-128 57.312-128 128 57.312 128 128 128c70.688 0 128-57.312 128-128zM896 640c0-70.688-57.312-128-128-128s-128 57.312-128 128 57.312 128 128 128c70.688 0 128-57.312 128-128zM768 544c-52.928 0-96 43.072-96 96s43.072 96 96 96c52.928 0 96-43.072 96-96s-43.072-96-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"curdle",
						"eat",
						"snack"
					],
					"grid": 32
				},
				{
					"id": 2875,
					"paths": [
						"M647.634 485.726l-647.634-485.726v809.542l202.134-190.61 202.136 405.068 171.73-85.866-202.134-405.068z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cursor",
						"pointer",
						"arrow"
					],
					"defaultCode": 60710,
					"grid": 16
				},
				{
					"id": 2876,
					"paths": [
						"M372.396 1025.132l-172.43-352.556-199.966 192.396v-864.972l677.754 518.636-270.174 47.666 172.57 352.842-207.754 105.988zM218.876 565.57l182.414 372.972 93.716-47.81-182.274-372.684 210.422-37.126-459.154-351.36v585.020l154.876-149.012z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cursor",
						"pointer",
						"arrow"
					],
					"defaultCode": 60711,
					"grid": 16
				},
				{
					"id": 1351,
					"width": 1019.9989471435547,
					"paths": [
						"M548.571 512q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714-25.714 10.857-25.714-10.857-10.857-25.714 10.857-25.714 25.714-10.857zM720 548.571l289.714 227.429q16 11.429 14.286 32-2.857 20-20 29.143l-73.143 36.571q-7.429 4-16.571 4-9.714 0-17.714-4.571l-394.286-221.143-62.857 37.714q-4.571 2.286-6.857 2.857 8 28 5.714 55.429-4 44-32 84.286t-75.429 70.571q-75.429 48-158.286 48-77.714 0-126.857-44.571-51.429-48-45.143-118.286 4-43.429 32-84t74.857-70.857q75.429-48 158.857-48 47.429 0 86.286 17.714 5.143-7.429 12.571-12.571l69.714-41.714-69.714-41.714q-7.429-5.143-12.571-12.571-38.857 17.714-86.286 17.714-83.429 0-158.857-48-46.857-30.286-74.857-70.857t-32-84q-2.857-33.714 8.857-64.571t36.286-53.143q48.571-45.143 126.857-45.143 82.857 0 158.286 48 47.429 29.714 75.429 70.286t32 84.571q2.286 27.429-5.714 55.429 2.286 0.571 6.857 2.857l62.857 37.714 394.286-221.143q8-4.571 17.714-4.571 9.143 0 16.571 4l73.143 36.571q17.143 9.143 20 29.143 1.714 20.571-14.286 32zM330.857 400q26.286-24 12-61.714t-60.571-66.857q-52.571-33.714-109.714-33.714-42.286 0-64.571 20.571-26.286 24-12 61.714t60.571 66.857q52.571 33.714 109.714 33.714 42.286 0 64.571-20.571zM282.286 825.714q46.286-29.143 60.571-66.857t-12-61.714q-22.286-20.571-64.571-20.571-57.143 0-109.714 33.714-46.286 29.143-60.571 66.857t12 61.714q22.286 20.571 64.571 20.571 57.143 0 109.714-33.714zM384 475.429l54.857 33.143v-6.286q0-20.571 18.857-32l8-4.571-45.143-26.857-14.857 14.857q-1.714 1.714-5.714 6.286t-6.857 6.857q-1.143 1.143-2.286 2t-1.714 1.429zM512 603.429l54.857 18.286 420.571-329.143-73.143-36.571-438.857 246.286v64.571l-91.429 54.857 5.143 4.571q1.143 1.143 4 3.429 2.286 2.286 6.286 6.857t6.286 6.857l14.857 14.857zM914.286 841.143l73.143-36.571-297.143-233.143-101.143 78.857q-1.143 1.714-7.429 4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cut",
						"scissors"
					],
					"defaultCode": 61636,
					"grid": 14
				},
				{
					"id": 415,
					"width": 1024,
					"paths": [
						"M240 96c-79.392 0-144 64.608-144 144s64.608 144 144 144 144-64.608 144-144-64.608-144-144-144zM240 352c-61.856 0-112-50.144-112-112s50.144-112 112-112 112 50.144 112 112-50.144 112-112 112zM928.032 240c0-79.392-64.608-144-144-144s-144 64.608-144 144 64.608 144 144 144 144-64.608 144-144zM672.032 240c0-61.856 50.144-112 112-112s112 50.144 112 112-50.144 112-112 112c-61.856 0-112-50.144-112-112zM784 480c132.544 0 240-107.456 240-240s-107.456-240-240-240-240 107.456-240 240c0 25.44 4.032 49.92 11.36 72.896l-44.096 55.168-43.104-53.856c7.616-23.392 11.84-48.288 11.84-74.208 0-132.544-107.456-240-240-240s-240 107.456-240 240 107.456 240 240 240c39.424 0 76.512-9.696 109.344-26.528l46.816 58.592-191.616 239.68c-55.328 69.184-58.656 164.544-12.608 236.576 5.76 8.544 15.712 14.432 26.784 14.432 9.632 0 18.176-4.352 24.032-11.104 0.064 0 268.448-335.648 268.448-335.648l267.776 334.88c5.856 7.168 14.688 11.84 24.672 11.84 11.008 0 21.216-6.112 26.976-14.592 45.952-72.032 42.56-167.264-12.704-236.416l-191.616-239.68 47.232-59.104c33.12 17.216 70.624 27.072 110.464 27.072zM357.984 413.056l-23.264 11.936c-29.728 15.264-61.6 23.008-94.72 23.008-114.688 0-208-93.312-208-208s93.312-208 208-208 208 93.312 208 208c0 21.728-3.456 43.36-10.272 64.32l-5.344 16.416 58.336 72.992-74.112 92.736-58.624-73.408zM792.96 771.744c46.656 58.368 49.408 138.848 10.944 199.136l-272.16-340.48 74.112-92.736 187.104 234.080zM218.688 970.752c-38.528-60.672-35.648-140.832 10.848-199.008l361.504-452.224-5.184-16.32c-6.528-20.512-9.856-41.76-9.856-63.2 0-114.688 93.312-208 208-208s208 93.312 208 208-93.312 208-208 208c-33.536 0-65.728-7.904-95.68-23.456l-23.328-12.128-446.304 558.336zM544 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cut",
						"trim",
						"slice"
					],
					"grid": 32
				},
				{
					"id": 416,
					"width": 1024,
					"paths": [
						"M349.344 453.472l26.336 32.928 115.072-143.968-22.592-28.224c7.616-23.392 11.84-48.288 11.84-74.208 0-132.544-107.456-240-240-240s-240 107.456-240 240 107.456 240 240 240c39.424 0 76.512-9.696 109.344-26.528zM96 240c0-79.392 64.608-144 144-144s144 64.608 144 144-64.608 144-144 144-144-64.608-144-144zM817.952 751.744c55.264 69.152 58.656 164.384 12.704 236.416-5.76 8.48-15.936 14.592-26.976 14.592-9.984 0-18.784-4.672-24.672-11.84l-247.264-309.248 115.072-143.968 171.136 214.048zM784 0c-132.544 0-240 107.456-240 240 0 25.44 4.032 49.92 11.36 72.896l-350.816 438.848c-55.328 69.184-58.656 164.544-12.608 236.576 5.76 8.544 15.712 14.432 26.784 14.432 9.632 0 18.176-4.352 24.032-11.104 0.064 0 430.784-538.72 430.784-538.72 33.12 17.216 70.624 27.072 110.464 27.072 132.544 0 240-107.456 240-240s-107.456-240-240-240zM512 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM784.032 384c-79.392 0-144-64.608-144-144s64.608-144 144-144 144 64.608 144 144-64.576 144-144 144z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cut",
						"trim",
						"slice"
					],
					"grid": 32
				},
				{
					"id": 997,
					"width": 1024,
					"paths": [
						"M1001.344 297.344l-210.72-210.72c-12.512-12.512-32.768-12.512-45.248 0l-306.752 306.752c-12.512 12.512-12.512 32.768 0 45.248l41.376 41.376-480 480c0 0 445.152-123.648 552.768-153.536 13.792-3.84 23.232-16.384 23.232-30.688v-135.776l32-32 41.344 41.632c12.48 12.576 32.832 12.608 45.344 0.064l306.656-307.072c12.512-12.512 12.512-32.768 0-45.28zM512 613.504v137.856c-64.448 17.888-184.96 51.392-294.72 81.856l330.592-330.592 37.472 37.472-73.344 73.408zM672 581.504l-165.504-165.504 73.376-73.376 165.504 165.504-73.376 73.376zM768 485.504l-165.504-165.504 167.968-167.968 163.552 167.424-166.016 166.048z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cut",
						"trim",
						"slice"
					],
					"grid": 32
				},
				{
					"id": 1397,
					"width": 804.5699615478516,
					"paths": [
						"M365.714 36.571v365.714q0 34.857-20.286 63.429t-52.857 40v445.143q0 29.714-21.714 51.429t-51.429 21.714h-73.143q-29.714 0-51.429-21.714t-21.714-51.429v-445.143q-32.571-11.429-52.857-40t-20.286-63.429v-365.714q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857 10.857 25.714v237.714q0 14.857 10.857 25.714t25.714 10.857 25.714-10.857 10.857-25.714v-237.714q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857 10.857 25.714v237.714q0 14.857 10.857 25.714t25.714 10.857 25.714-10.857 10.857-25.714v-237.714q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857 10.857 25.714zM804.571 36.571v914.286q0 29.714-21.714 51.429t-51.429 21.714h-73.143q-29.714 0-51.429-21.714t-21.714-51.429v-292.571h-128q-7.429 0-12.857-5.429t-5.429-12.857v-457.143q0-75.429 53.714-129.143t129.143-53.714h146.286q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"cutlery"
					],
					"defaultCode": 61685,
					"grid": 14
				},
				{
					"id": 417,
					"width": 1024,
					"paths": [
						"M320 736c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM480 608c0 212.064-46.208 320-192 320s-192-107.936-192-320 110.208-512 256-512c128.672 0 128 299.936 128 512zM432.416 275.904c-10.752-67.488-33.376-147.904-80.416-147.904-115.36 0-224 270.4-224 480 0 239.808 61.216 288 160 288s160-48.192 160-288v-3.36c0-102.72 0-230.56-15.584-328.736zM400.8 280.896c15.2 95.712 15.2 222.144 15.2 323.744v3.36c0 35.36-28.64 64-64 64h-128c-35.36 0-64-28.64-64-64 0-39.136 4.128-80.032 11.232-120.512l-0.672-0.352 1.248-2.464c29.76-166.272 111.232-324.672 180.192-324.672 11.904 0 34.688 32.192 48.8 120.896zM194.368 556.928l57.856-28.928-51.328-25.664c-2.912 17.984-5.024 36.224-6.528 54.592zM384 593.888l-96-48-95.552 47.776c-0.128 4.8-0.448 9.568-0.448 14.336 0 17.632 14.368 32 32 32h128c17.632 0 32-14.368 32-32v-3.36c0-3.488 0-7.2 0-10.752zM383.392 498.176l-59.616 29.824 60.16 30.080c-0.064-19.552-0.224-39.616-0.544-59.904zM369.216 285.92c-8.384-52.672-19.424-80.416-26.080-92.032-40.48 16.128-106.688 134.112-136.128 275.744l80.992 40.48 94.656-47.328c-1.6-62.336-5.152-124.608-13.44-176.864zM736 704c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM928 608c0 212.064-46.208 320-192 320s-192-107.936-192-320-0.672-512 128-512c145.792 0 256 299.936 256 512zM896 608c0-209.6-108.64-480-224-480-47.040 0-69.664 80.416-80.416 147.904-15.584 98.176-15.584 226.016-15.584 328.736v3.36c0 239.808 61.216 288 160 288s160-48.192 160-288zM864 608c0 35.36-28.64 64-64 64h-128c-35.36 0-64-28.64-64-64v-3.36c0-101.6 0-228.032 15.2-323.712 14.112-88.736 36.896-120.928 48.8-120.928 68.96 0 150.432 158.4 180.224 324.672l1.248 2.464-0.672 0.352c7.072 40.48 11.2 81.376 11.2 120.512zM823.104 502.336l-51.328 25.664 57.856 28.928c-1.504-18.368-3.616-36.608-6.528-54.592zM641.344 462.784l94.656 47.328 80.992-40.512c-29.44-141.632-95.648-259.584-136.128-275.744-6.656 11.616-17.696 39.36-26.080 92.032-8.288 52.288-11.84 114.56-13.44 176.896zM640.064 558.080l60.16-30.080-59.616-29.824c-0.32 20.288-0.48 40.352-0.544 59.904zM832 608c0-4.768-0.32-9.536-0.448-14.336l-95.552-47.776-96 48c0 3.552 0 7.264 0 10.752v3.36c0 17.632 14.368 32 32 32h128c17.632 0 32-14.368 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dance",
						"move",
						"twirl"
					],
					"grid": 32
				},
				{
					"id": 418,
					"width": 1024,
					"paths": [
						"M384 593.888c0 3.552 0 7.264 0 10.752v3.36c0 17.632-14.368 32-32 32h-128c-17.632 0-32-14.368-32-32 0-4.768 0.32-9.536 0.448-14.336l95.552-47.776 96 48zM480 608c0 212.064-46.208 320-192 320s-192-107.936-192-320 110.208-512 256-512c128.672 0 128 299.936 128 512zM320 736c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM416 604.64c0-101.6 0-228.032-15.2-323.712-14.112-88.736-36.896-120.928-48.8-120.928-68.96 0-150.432 158.4-180.224 324.672l-1.248 2.464 0.672 0.352c-7.072 40.48-11.2 81.376-11.2 120.512 0 35.36 28.64 64 64 64h128c35.36 0 64-28.64 64-64v-3.36zM383.936 558.080c-0.064-19.552-0.224-39.616-0.512-59.904l-59.648 29.824 60.16 30.080zM829.632 556.928c-1.504-18.368-3.616-36.608-6.528-54.592l-51.328 25.664 57.856 28.928zM382.656 462.784c-1.6-62.336-5.152-124.608-13.472-176.864-8.384-52.672-19.424-80.416-26.080-92.032-40.48 16.128-106.688 134.112-136.128 275.744l81.024 40.48 94.656-47.328zM200.896 502.336c-2.912 17.952-5.024 36.224-6.528 54.592l57.856-28.928-51.328-25.664zM640.608 498.176c-0.288 20.288-0.48 40.352-0.512 59.904l60.16-30.080-59.648-29.824zM928 608c0 212.064-46.208 320-192 320s-192-107.936-192-320-0.672-512 128-512c145.792 0 256 299.936 256 512zM768 736c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM864 608c0-39.136-4.128-80.032-11.232-120.512l0.672-0.352-1.248-2.464c-29.76-166.272-111.232-324.672-180.192-324.672-11.904 0-34.688 32.192-48.8 120.896-15.2 95.712-15.2 222.144-15.2 323.744v3.36c0 35.36 28.64 64 64 64h128c35.36 0 64-28.64 64-64zM736 545.888l-96 48c0 3.552 0 7.264 0 10.752v3.36c0 17.632 14.368 32 32 32h128c17.632 0 32-14.368 32-32 0-4.768-0.32-9.536-0.448-14.336l-95.552-47.776zM816.992 469.6c-29.44-141.632-95.648-259.584-136.128-275.744-6.656 11.616-17.696 39.36-26.080 92.032-8.288 52.256-11.872 114.528-13.472 176.864l94.688 47.36 80.992-40.512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dance",
						"move",
						"twirl"
					],
					"grid": 32
				},
				{
					"id": 1381,
					"width": 1024.001968383789,
					"paths": [
						"M219.429 658.286q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM329.143 402.286q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM573.714 677.143l57.714-218.286q3.429-14.857-4.286-27.714t-22-16.857-27.429 3.714-17.143 22.571l-57.714 218.286q-34.286 2.857-61.143 24.857t-36 56.286q-11.429 44 11.429 83.429t66.857 50.857 83.429-11.429 50.857-66.857q9.143-34.286-3.429-66.857t-41.143-52zM950.857 658.286q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM585.143 292.571q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM841.143 402.286q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM1024 658.286q0 149.143-80.571 276-10.857 16.571-30.857 16.571h-801.143q-20 0-30.857-16.571-80.571-126.286-80.571-276 0-104 40.571-198.857t109.143-163.429 163.429-109.143 198.857-40.571 198.857 40.571 163.429 109.143 109.143 163.429 40.571 198.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dashboard",
						"tachometer"
					],
					"defaultCode": 61668,
					"grid": 14
				},
				{
					"id": 1660,
					"width": 804.572021484375,
					"paths": [
						"M0 388.571q0-74.857 52.286-129.429t127.143-54.571h424l201.143-204.571v840q0 75.429-52.286 129.714t-127.143 54.286h-445.714q-74.857 0-127.143-54.286t-52.286-129.714v-451.429zM704 819.429l-100.571-102.857v-242.857q0-26.286-18.286-45.143t-44.571-18.857h-276.571q-26.286 0-44.571 18.857t-18.286 45.143v281.143q0 26.286 18.571 45.429t44.286 19.143h440z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dashcube"
					],
					"defaultCode": 61968,
					"grid": 14
				},
				{
					"id": 2216,
					"paths": [
						"M512 0c-282.77 0-512 71.634-512 160v128c0 88.366 229.23 160 512 160s512-71.634 512-160v-128c0-88.366-229.23-160-512-160z",
						"M512 544c-282.77 0-512-71.634-512-160v192c0 88.366 229.23 160 512 160s512-71.634 512-160v-192c0 88.366-229.23 160-512 160z",
						"M512 832c-282.77 0-512-71.634-512-160v192c0 88.366 229.23 160 512 160s512-71.634 512-160v-192c0 88.366-229.23 160-512 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database",
						"db",
						"server",
						"host",
						"storage",
						"save",
						"datecenter"
					],
					"defaultCode": 60051,
					"grid": 16
				},
				{
					"id": 2221,
					"paths": [
						"M1024 576h-128v-128h-128v128h-128v128h128v128h128v-128h128z",
						"M640 768v32c-5.39 7.348-25.318 25.744-74.12 43.338-58.422 21.062-134.38 32.662-213.88 32.662s-155.458-11.6-213.88-32.662c-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 85.106 0 163.14-13.736 224-36.59v-83.896c-3.232 1.278-6.592 2.552-10.12 3.824-58.424 21.062-134.38 32.662-213.88 32.662s-155.458-11.6-213.88-32.662c-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.124 168.942 67.996 288 67.996s224.296-26.872 288-67.996v131.996h64v-224c0-88.366-157.596-160-352-160s-352 71.634-352 160v512c0 88.366 157.596 160 352 160s352-71.634 352-160v-32h-64zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-add",
						"db"
					],
					"defaultCode": 60056,
					"grid": 16
				},
				{
					"id": 2231,
					"paths": [
						"M640 96c135.864 28.764 224 182.614 224 320 0 153.972-127.542 271.718-288 279.604v-183.604l-224 256 224 256v-185.026c214.8-13.826 384-173.682 384-358.974 0-170.476-129.812-351.584-320-384z",
						"M384 875.352c-10.582 0.418-21.254 0.648-32 0.648-79.5 0-155.458-11.6-213.88-32.662-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c57.93 37.396 150.214 63.002 256 67.336v-83.988c-67.704-2.678-131.354-13.798-181.88-32.014-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.124 168.942 67.996 288 67.996s224.296-26.872 288-67.996v195.996h64v-288c0-88.366-157.596-160-352-160s-352 71.634-352 160v512c0 88.366 157.596 160 352 160 10.79 0 21.458-0.232 32-0.664v-83.984zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-arrow",
						"db"
					],
					"defaultCode": 60066,
					"grid": 16
				},
				{
					"id": 2230,
					"paths": [
						"M384 576l-96 96 256 256 480-544-64-64-416 384z",
						"M138.12 843.338c-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c45.894 29.626 113.352 51.854 192 61.968v-83.828c-43.424-5.414-83.67-14.474-117.88-26.806-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.124 168.942 67.996 288 67.996s224.296-26.872 288-67.996v131.952l64-59.078v-164.878c0-88.366-157.596-160-352-160s-352 71.634-352 160v512c0 88.366 157.596 160 352 160 10.79 0 21.458-0.232 32-0.664v-83.984c-10.582 0.418-21.254 0.648-32 0.648-79.5 0-155.458-11.6-213.88-32.662zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-check",
						"db"
					],
					"defaultCode": 60065,
					"grid": 16
				},
				{
					"id": 2227,
					"paths": [
						"M576 896h384v128h-384v-128z",
						"M960 576h-128v-128h-128v128h-128v128h128v128h128v-128h128z",
						"M512 858.948c-48.12 11.088-103.134 17.052-160 17.052-79.5 0-155.458-11.6-213.88-32.662-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 57.616 0 111.996-6.292 160-17.448v-83.606c-48.12 11.088-103.134 17.052-160 17.052-79.5 0-155.458-11.6-213.88-32.662-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.126 168.942 67.998 288 67.998 194.404 0 352-71.634 352-160s-157.596-160-352-160-352 71.634-352 160v512c0 88.366 157.596 160 352 160 57.616 0 111.996-6.292 160-17.448v-83.604zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-diff",
						"db"
					],
					"defaultCode": 60062,
					"grid": 16
				},
				{
					"id": 2228,
					"paths": [
						"M993.97 379.476l-108.548-67.83c-29.852-18.654-69.538-9.492-88.192 20.36l-30.734 49.186 217.1 135.66 30.736-49.186c18.652-29.85 9.49-69.536-20.362-88.19z",
						"M515.314 783.168l0.448 240.832 216.652-105.172 210.908-337.524-217.1-135.658z",
						"M352 448c194.404 0 352-71.634 352-160s-157.596-160-352-160-352 71.634-352 160v512c0 88.366 157.596 160 352 160 33.282 0 65.482-2.102 96-6.026v-83.83c-30.736 3.834-63.050 5.856-96 5.856-79.5 0-155.458-11.6-213.88-32.662-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 57.616 0 111.996-6.292 160-17.448v-83.606c-48.12 11.088-103.134 17.052-160 17.052-79.5 0-155.458-11.6-213.88-32.662-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.126 168.942 67.998 288 67.998zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-edit",
						"db"
					],
					"defaultCode": 60063,
					"grid": 16
				},
				{
					"id": 2229,
					"paths": [
						"M993.97 379.476l-108.548-67.83c-29.852-18.654-69.538-9.492-88.192 20.36l-281.916 451.16 0.448 240.834 216.652-105.172 281.918-451.162c18.652-29.85 9.49-69.536-20.362-88.19zM926.142 488.028l-220.446 352.786-108.548-67.83 220.448-352.788 108.546 67.832z",
						"M352 448c194.404 0 352-71.634 352-160s-157.596-160-352-160-352 71.634-352 160v512c0 88.366 157.596 160 352 160 33.282 0 65.482-2.102 96-6.026v-83.83c-30.736 3.834-63.050 5.856-96 5.856-79.5 0-155.458-11.6-213.88-32.662-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 57.624 0 111.99-6.31 160-17.468v-83.584c-48.12 11.088-103.134 17.052-160 17.052-79.5 0-155.458-11.6-213.88-32.662-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.124 168.942 67.996 288 67.996zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-edit",
						"db"
					],
					"defaultCode": 60064,
					"grid": 16
				},
				{
					"id": 2224,
					"paths": [
						"M1024 640l-192-224v160h-256v128h256v160z",
						"M640 768v32c-5.39 7.348-25.318 25.744-74.12 43.338-58.422 21.062-134.38 32.662-213.88 32.662s-155.458-11.6-213.88-32.662c-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 57.624 0 111.992-6.31 160-17.47v-83.582c-48.12 11.088-103.134 17.052-160 17.052-79.5 0-155.458-11.6-213.88-32.662-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.124 168.942 67.996 288 67.996s224.296-26.872 288-67.996v131.996h64v-224c0-88.366-157.596-160-352-160s-352 71.634-352 160v512c0 88.366 157.596 160 352 160s352-71.634 352-160v-32h-64zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-export",
						"db"
					],
					"defaultCode": 60059,
					"grid": 16
				},
				{
					"id": 2223,
					"paths": [
						"M480 640l-224-224v160h-256v128h256v160z",
						"M672 128c-194.404 0-352 71.634-352 160s157.596 160 352 160c119.058 0 224.296-26.872 288-67.996v161.998c-5.39 7.348-25.318 25.744-74.12 43.338-58.424 21.062-134.38 32.662-213.88 32.662-56.866 0-111.878-5.964-160-17.052v83.606c48.004 11.154 102.384 17.448 160 17.448 119.058 0 224.296-26.874 288-67.996v165.992c-5.39 7.348-25.318 25.744-74.12 43.338-58.422 21.062-134.38 32.662-213.88 32.662s-155.458-11.6-213.88-32.662c-3.528-1.272-6.888-2.548-10.12-3.824v83.914c60.86 22.846 138.902 36.572 224 36.572 194.404 0 352-71.634 352-160v-512c0-88.366-157.596-160-352-160zM870.272 331.338c-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.71-35.99-68.71-43.338 5-7.348 23.47-25.744 68.71-43.338 54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-insert",
						"db"
					],
					"defaultCode": 60058,
					"grid": 16
				},
				{
					"id": 2220,
					"paths": [
						"M320 128c-176.732 0-320 71.634-320 160v512c0 88.366 143.268 160 320 160s320-71.634 320-160v-512c0-88.366-143.268-160-320-160zM576 548.858c-9.048 9.094-27.616 23.020-61.562 36.482-53.114 21.062-122.166 32.662-194.438 32.662s-141.324-11.6-194.438-32.662c-33.948-13.464-52.514-27.39-61.562-36.482v-164.848c58.382 38.856 151.318 63.99 256 63.99s197.618-25.134 256-63.99v164.848zM139.754 244.662c49.236-21.062 113.248-32.662 180.246-32.662s131.010 11.6 180.248 32.662c41.126 17.594 57.918 35.99 62.462 43.338-4.542 7.348-21.336 25.744-62.462 43.338-49.238 21.062-113.25 32.662-180.248 32.662s-131.010-11.6-180.246-32.662c-41.126-17.594-57.92-35.99-62.464-43.338 4.544-7.348 21.338-25.744 62.464-43.338zM514.438 843.338c-53.114 21.062-122.166 32.662-194.438 32.662s-141.324-11.6-194.438-32.662c-33.948-13.462-52.514-27.39-61.562-36.482v-168.844c58.382 38.856 151.318 63.99 256 63.99s197.618-25.134 256-63.99v168.844c-9.048 9.094-27.616 23.020-61.562 36.482z",
						"M704 320h320v128h-320v-128z",
						"M704 512h320v128h-320v-128z",
						"M704 704h320v128h-320v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-menu",
						"db"
					],
					"defaultCode": 60055,
					"grid": 16
				},
				{
					"id": 2226,
					"paths": [
						"M923.004 452.996c-50.316-43.010-115.62-68.996-187.004-68.996-140.95 0-258.234 101.262-283.116 235h98.562c23.058-80.174 97.062-139 184.554-139 44.798 0 86.038 15.45 118.736 41.264l-118.736 118.736h288v-288l-100.996 100.996z",
						"M736 864c-44.798 0-86.038-15.45-118.736-41.264l118.736-118.736h-288v288l100.996-100.996c50.312 43.012 115.62 68.996 187.004 68.996 140.95 0 258.232-101.262 283.116-235h-98.556c-23.064 80.174-97.068 139-184.56 139z",
						"M138.12 585.34c-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.124 168.942 67.996 288 67.996 10.79 0 21.458-0.234 32-0.666v-84.098c-10.574 0.488-21.246 0.764-32 0.764-73.698 0-144.112-11.6-198.27-32.662-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338 54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-3.924 5.768-16.16 18.346-43.124 32h121.096c4.618-10.34 7.046-21.042 7.046-32 0-88.366-157.596-160-352-160s-351.998 71.634-351.998 160v512c0 88.366 157.596 160 352 160 10.79 0 21.458-0.232 32-0.664v-83.984c-10.582 0.418-21.254 0.648-32 0.648-79.5 0-155.458-11.6-213.88-32.662-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 10.79 0 21.458-0.232 32-0.666v-83.982c-10.582 0.418-21.254 0.648-32 0.648-79.5 0-155.458-11.6-213.88-32.662z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-refresh",
						"db"
					],
					"defaultCode": 60061,
					"grid": 16
				},
				{
					"id": 2222,
					"paths": [
						"M1024 538.508l-90.508-90.508-133.492 133.492-133.492-133.492-90.508 90.508 133.492 133.492-133.492 133.492 90.508 90.508 133.492-133.492 133.492 133.492 90.508-90.508-133.492-133.492z",
						"M512 858.948c-48.12 11.088-103.134 17.052-160 17.052-79.5 0-155.458-11.6-213.88-32.662-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 57.616 0 111.996-6.292 160-17.448v-83.606c-48.12 11.088-103.134 17.052-160 17.052-79.5 0-155.458-11.6-213.88-32.662-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.126 168.942 67.998 288 67.998 194.404 0 352-71.634 352-160s-157.596-160-352-160-352 71.634-352 160v512c0 88.366 157.596 160 352 160 57.616 0 111.996-6.292 160-17.448v-83.604zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-remove",
						"db"
					],
					"defaultCode": 60057,
					"grid": 16
				},
				{
					"id": 2232,
					"paths": [
						"M352 448c194.404 0 352-71.634 352-160s-157.596-160-352-160-352 71.634-352 160v512c0 88.366 157.596 160 352 160 32.176 0 63.334-1.972 92.946-5.648-18.35-24.398-33.692-51.174-45.51-79.766-15.596 0.922-31.438 1.414-47.436 1.414-79.5 0-155.458-11.6-213.88-32.662-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 7.266 0 14.472-0.112 21.628-0.308 2.76-29.382 9.024-57.758 18.374-84.708-13.192 0.656-26.538 1.016-40 1.016-79.5 0-155.458-11.6-213.88-32.662-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.7 41.124 168.94 67.996 287.998 67.996zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z",
						"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288 288-128.942 288-288-128.942-288-288-288zM896 768h-192v-192h64v128h128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-time",
						"db"
					],
					"defaultCode": 60067,
					"grid": 16
				},
				{
					"id": 2233,
					"paths": [
						"M736 448c-159.054 0-288 128.942-288 288s128.946 288 288 288c159.056 0 288-128.942 288-288s-128.944-288-288-288zM736 940c-112.486 0-204-91.514-204-204s91.514-204 204-204 204 91.514 204 204-91.514 204-204 204z",
						"M768 704v-128h-64v192h192v-64z",
						"M352 448c194.404 0 352-71.634 352-160s-157.596-160-352-160-352 71.634-352 160v512c0 88.366 157.596 160 352 160 32.176 0 63.334-1.972 92.946-5.648-18.35-24.398-33.692-51.174-45.51-79.766-15.596 0.922-31.438 1.414-47.436 1.414-79.5 0-155.458-11.6-213.88-32.662-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 7.266 0 14.472-0.112 21.628-0.308 2.76-29.382 9.024-57.758 18.374-84.708-13.192 0.656-26.538 1.016-40 1.016-79.5 0-155.458-11.6-213.88-32.662-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.7 41.124 168.94 67.996 287.998 67.996zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-time",
						"db"
					],
					"defaultCode": 60068,
					"grid": 16
				},
				{
					"id": 2225,
					"paths": [
						"M564 843.984c-58.172 20.644-133.338 32.016-212 32.016-79.5 0-155.458-11.6-213.88-32.662-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996 7.678 0 15.298-0.118 22.854-0.336l92.116-92.118c-36.266 5.544-75.174 8.454-114.97 8.454-79.5 0-155.458-11.6-213.88-32.662-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.124 168.942 67.996 288 67.996s224.296-26.872 288-67.996v56.516l64-64v-84.52c0-88.366-157.596-160-352-160s-352 71.634-352 160v512c0 88.366 157.596 160 352 160 79.608 0 153.032-12.018 212-32.272v-83.744zM153.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.712-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338z",
						"M704 480l-224 224h160v256h128v-256h160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database-upload",
						"db"
					],
					"defaultCode": 60060,
					"grid": 16
				},
				{
					"id": 2217,
					"paths": [
						"M1024 224c0-28.41-10.048-70.76-57.916-111.178-28.44-24.012-67.39-44.95-115.776-62.23-91.348-32.626-211.494-50.592-338.308-50.592s-246.96 17.966-338.31 50.59c-48.384 17.28-87.336 38.218-115.774 62.23-47.868 40.42-57.916 82.77-57.916 111.18h-0.172v576h0.172c0 28.41 10.048 70.762 57.916 111.18 28.438 24.012 67.39 44.95 115.774 62.23 91.348 32.626 211.496 50.59 338.31 50.59s246.96-17.964 338.308-50.59c48.384-17.282 87.338-38.218 115.776-62.23 47.868-40.418 57.916-82.77 57.916-111.18v-576zM231.176 166.23c76.28-24.652 176.010-38.23 280.824-38.23 104.812 0 204.544 13.578 280.822 38.23 74.554 24.096 98.92 49.996 102.832 57.77-3.912 7.774-28.278 33.674-102.832 57.77-76.278 24.652-176.010 38.23-280.822 38.23-104.814 0-204.544-13.578-280.824-38.23-74.552-24.096-98.918-49.996-102.83-57.77 3.912-7.774 28.278-33.674 102.83-57.77zM792.824 857.77c-76.28 24.656-176.010 38.23-280.824 38.23s-204.546-13.574-280.824-38.23c-74.554-24.094-98.918-49.996-102.83-57.77h-0.174v-133.24c14.088 6.614 29.256 12.842 45.518 18.65 91.348 32.624 211.496 50.59 338.31 50.59s246.96-17.966 338.308-50.59c16.194-5.784 31.304-11.986 45.346-18.568v133.158c-3.912 7.774-28.276 33.676-102.83 57.77zM792.824 569.77c-76.28 24.654-176.010 38.23-280.824 38.23s-204.546-13.576-280.824-38.23c-74.554-24.096-98.918-49.996-102.83-57.77h-0.174v-133.24c14.088 6.612 29.256 12.842 45.518 18.65 91.35 32.624 211.496 50.59 338.31 50.59s246.96-17.966 338.308-50.59c16.194-5.784 31.304-11.986 45.346-18.568v133.158c-3.912 7.774-28.276 33.674-102.83 57.77z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database",
						"db",
						"server",
						"host",
						"storage",
						"save",
						"datecenter"
					],
					"defaultCode": 60052,
					"grid": 16
				},
				{
					"id": 2218,
					"paths": [
						"M512 0c-282.77 0-512 85.96-512 192v640c0 106.040 229.23 192 512 192s512-85.96 512-192v-640c0-106.040-229.23-192-512-192zM960 832c0 9.126-19.92 42.646-108.434 75.84-43.002 16.124-93.57 28.864-150.298 37.862-59.816 9.488-123.494 14.298-189.268 14.298-65.772 0-129.452-4.81-189.268-14.298-56.73-8.998-107.296-21.736-150.298-37.862-88.514-33.194-108.434-66.714-108.434-75.84v-227.002c87.334 59.038 255.208 99.002 448 99.002s360.666-39.964 448-99.002v227.002zM960 512c0 9.126-19.92 42.646-108.434 75.84-43.002 16.124-93.57 28.864-150.298 37.862-59.816 9.488-123.494 14.298-189.268 14.298-65.772 0-129.452-4.81-189.268-14.298-56.73-8.998-107.296-21.736-150.298-37.862-88.514-33.194-108.434-66.714-108.434-75.84v-227.002c87.334 59.036 255.208 99.002 448 99.002s360.666-39.966 448-99.002v227.002zM880.348 256c-8.684 3.924-18.23 7.884-28.782 11.84-43.002 16.126-93.57 28.864-150.298 37.862-59.816 9.488-123.494 14.298-189.268 14.298-65.772 0-129.452-4.81-189.268-14.298-56.73-8.998-107.296-21.736-150.298-37.862-10.55-3.956-20.098-7.916-28.782-11.84-64.168-28.996-79.652-55.962-79.652-64 0-9.126 19.92-42.648 108.434-75.84 43.002-16.126 93.57-28.864 150.298-37.862 59.816-9.488 123.496-14.298 189.268-14.298 65.774 0 129.452 4.81 189.268 14.298 56.728 8.998 107.296 21.736 150.298 37.862 88.514 33.192 108.434 66.714 108.434 75.84 0 8.038-15.482 35.004-79.652 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database",
						"db",
						"server",
						"host",
						"storage",
						"save",
						"datecenter"
					],
					"defaultCode": 60053,
					"grid": 16
				},
				{
					"id": 2219,
					"paths": [
						"M480 128c-194.404 0-352 71.634-352 160v512c0 88.366 157.596 160 352 160s352-71.634 352-160v-512c0-88.366-157.596-160-352-160zM281.73 244.662c54.158-21.062 124.572-32.662 198.27-32.662s144.112 11.6 198.272 32.662c45.238 17.594 63.71 35.99 68.708 43.338-4.998 7.348-23.47 25.744-68.708 43.338-54.16 21.062-124.574 32.662-198.272 32.662s-144.112-11.6-198.27-32.662c-45.24-17.594-63.71-35.99-68.71-43.338 4.998-7.348 23.47-25.744 68.71-43.338zM768 800c-5.39 7.348-25.318 25.744-74.12 43.338-58.422 21.062-134.38 32.662-213.88 32.662s-155.458-11.6-213.88-32.662c-48.802-17.594-68.728-35.99-74.12-43.338v-165.994c63.702 41.124 168.942 67.996 288 67.996s224.296-26.874 288-67.996v165.994zM768 542.002c-5.39 7.348-25.318 25.744-74.12 43.338-58.424 21.062-134.38 32.662-213.88 32.662s-155.458-11.6-213.88-32.662c-48.8-17.594-68.726-35.99-74.12-43.338v-161.998c63.702 41.124 168.942 67.996 288 67.996s224.296-26.872 288-67.996v161.998z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database",
						"db",
						"server",
						"host",
						"storage",
						"save",
						"datecenter"
					],
					"defaultCode": 60054,
					"grid": 16
				},
				{
					"id": 1585,
					"width": 877.713981628418,
					"paths": [
						"M438.857 438.857q135.429 0 253.143-24.571t185.714-72.571v97.143q0 39.429-58.857 73.143t-160 53.429-220 19.714-220-19.714-160-53.429-58.857-73.143v-97.143q68 48 185.714 72.571t253.143 24.571zM438.857 877.714q135.429 0 253.143-24.571t185.714-72.571v97.143q0 39.429-58.857 73.143t-160 53.429-220 19.714-220-19.714-160-53.429-58.857-73.143v-97.143q68 48 185.714 72.571t253.143 24.571zM438.857 658.286q135.429 0 253.143-24.571t185.714-72.571v97.143q0 39.429-58.857 73.143t-160 53.429-220 19.714-220-19.714-160-53.429-58.857-73.143v-97.143q68 48 185.714 72.571t253.143 24.571zM438.857 0q118.857 0 220 19.714t160 53.429 58.857 73.143v73.143q0 39.429-58.857 73.143t-160 53.429-220 19.714-220-19.714-160-53.429-58.857-73.143v-73.143q0-39.429 58.857-73.143t160-53.429 220-19.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database"
					],
					"defaultCode": 61888,
					"grid": 14
				},
				{
					"id": 109,
					"paths": [
						"M925.040 82.379c-25.429-16.701-61.077-31.488-105.955-43.955-89.2-24.778-207.35-38.424-332.685-38.424s-243.485 13.646-332.686 38.424c-44.877 12.467-80.526 27.254-105.955 43.955-31.69 20.813-47.758 44.774-47.758 71.221v614.4c0 26.446 16.069 50.41 47.758 71.222 25.429 16.701 61.077 31.488 105.955 43.954 89.202 24.779 207.352 38.424 332.686 38.424s243.485-13.645 332.686-38.426c44.878-12.466 80.526-27.253 105.955-43.954 31.69-20.811 47.758-44.774 47.758-71.221v-614.4c0-26.446-16.069-50.408-47.76-71.221zM167.418 87.757c84.864-23.574 198.149-36.557 318.982-36.557s234.117 12.982 318.982 36.557c91.928 25.536 116.218 54.235 116.218 65.843s-24.29 40.307-116.218 65.843c-84.866 23.574-198.149 36.557-318.982 36.557s-234.118-12.982-318.982-36.557c-91.928-25.536-116.218-54.235-116.218-65.843s24.29-40.307 116.218-65.843zM805.382 833.843c-84.866 23.574-198.149 36.557-318.982 36.557s-234.117-12.982-318.982-36.557c-91.928-25.536-116.218-54.235-116.218-65.843v-131.389c25.168 15.803 59.611 29.846 102.514 41.765 89.202 24.779 207.352 38.424 332.686 38.424s243.485-13.645 332.686-38.426c42.902-11.917 77.347-25.962 102.514-41.765v131.39c0 11.608-24.29 40.307-116.218 65.843zM805.382 629.043c-84.866 23.574-198.149 36.557-318.982 36.557s-234.117-12.982-318.982-36.557c-91.928-25.536-116.218-54.235-116.218-65.843v-131.39c25.168 15.803 59.611 29.848 102.514 41.766 89.202 24.778 207.352 38.424 332.686 38.424s243.485-13.646 332.686-38.424c42.902-11.918 77.347-25.963 102.514-41.766v131.39c0 11.608-24.29 40.307-116.218 65.843zM805.382 424.243c-84.866 23.574-198.149 36.557-318.982 36.557s-234.117-12.982-318.982-36.557c-91.928-25.536-116.218-54.235-116.218-65.843v-131.39c25.168 15.803 59.611 29.848 102.514 41.766 89.202 24.778 207.352 38.424 332.686 38.424s243.485-13.646 332.686-38.424c42.902-11.918 77.347-25.963 102.514-41.766v131.39c0 11.608-24.29 40.307-116.218 65.843z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"database",
						"storage"
					],
					"defaultCode": 59406,
					"grid": 20
				},
				{
					"id": 2790,
					"width": 1042,
					"paths": [
						"M416 448c88.224 0 160 71.776 160 160s-71.776 160-160 160-160-71.776-160-160 71.776-160 160-160zM416 384c-123.712 0-224 100.288-224 224s100.288 224 224 224c123.712 0 224-100.288 224-224s-100.288-224-224-224v0z",
						"M416 320c-17.672 0-32-14.328-32-32v-64c0-17.672 14.328-32 32-32s32 14.328 32 32v64c0 17.672-14.328 32-32 32z",
						"M416 1024c-17.672 0-32-14.328-32-32v-64c0-17.672 14.328-32 32-32s32 14.328 32 32v64c0 17.672-14.328 32-32 32z",
						"M128 608c0 17.674-14.328 32-32 32h-64c-17.672 0-32-14.326-32-32 0-17.672 14.328-32 32-32h64c17.672 0 32 14.328 32 32z",
						"M832 608c0 17.672-14.328 32-32 32h-64c-17.672 0-32-14.328-32-32s14.328-32 32-32h64c17.672 0 32 14.328 32 32z",
						"M212.354 404.354c-12.498 12.496-32.758 12.496-45.254 0l-45.254-45.254c-12.498-12.498-12.498-32.758 0-45.254 12.496-12.498 32.758-12.498 45.254 0l45.254 45.254c12.496 12.494 12.496 32.756 0 45.254z",
						"M710.156 902.156c-12.496 12.496-32.758 12.496-45.254 0l-45.256-45.254c-12.496-12.496-12.496-32.76 0-45.256s32.76-12.496 45.256 0l45.254 45.256c12.496 12.496 12.496 32.758 0 45.254z",
						"M212.354 811.646c12.498 12.498 12.496 32.758 0 45.256l-45.254 45.254c-12.498 12.496-32.758 12.498-45.254 0-12.496-12.496-12.498-32.758 0-45.254l45.254-45.256c12.494-12.496 32.758-12.496 45.254 0z",
						"M812.922 307.078c-63.784-63.782-83.738-153.76-58.392-229.314-85.534 31.528-146.53 113.756-146.53 210.236 0 123.712 100.288 224 224 224 96.478 0 178.708-60.998 210.236-146.532-75.554 25.348-165.532 5.392-229.314-58.39z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"day-night",
						"sun-moon"
					],
					"defaultCode": 60625,
					"grid": 16
				},
				{
					"id": 2791,
					"paths": [
						"M736 256c-17.804 0-35.23 1.628-52.142 4.72 87.906 63.372 145.142 166.636 145.142 283.28s-57.236 219.908-145.14 283.28c16.91 3.096 34.336 4.72 52.14 4.72 159.056 0 288-128.942 288-288s-128.942-288-288-288z",
						"M480 1024c-17.672 0-32-14.326-32-32v-64c0-17.674 14.328-32 32-32s32 14.326 32 32v64c0 17.674-14.326 32-32 32z",
						"M480 192c-17.672 0-32-14.328-32-32v-64c0-17.672 14.328-32 32-32s32 14.328 32 32v64c0 17.672-14.326 32-32 32z",
						"M160 896c-8.19 0-16.378-3.124-22.628-9.374-12.496-12.496-12.496-32.758 0-45.254l64-64c12.498-12.496 32.758-12.496 45.256 0 12.496 12.496 12.496 32.758 0 45.254l-64 64c-6.248 6.25-14.438 9.374-22.628 9.374z",
						"M224 320c-8.19 0-16.378-3.124-22.628-9.372l-64-64c-12.496-12.498-12.496-32.758 0-45.256 12.498-12.496 32.758-12.496 45.256 0l64 64c12.496 12.498 12.496 32.758 0 45.256-6.248 6.248-14.438 9.372-22.628 9.372z",
						"M96 576h-64c-17.672 0-32-14.326-32-32s14.328-32 32-32h64c17.672 0 32 14.326 32 32s-14.326 32-32 32z",
						"M480 832c-158.804 0-288-129.196-288-288s129.196-288 288-288c158.804 0 288 129.196 288 288s-129.194 288-288 288zM480 320c-123.514 0-224 100.486-224 224s100.486 224 224 224 224-100.486 224-224-100.486-224-224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"day-night",
						"sun-moon"
					],
					"defaultCode": 60626,
					"grid": 16
				},
				{
					"id": 419,
					"width": 1024,
					"paths": [
						"M582.752 476.608c23.584-11.808 23.584-45.44 0-57.248l-134.752-67.36-67.392-134.752c-5.888-11.808-17.248-17.696-28.608-17.696s-22.72 5.888-28.608 17.696l-67.392 134.752-134.752 67.392c-23.584 11.808-23.584 45.44 0 57.248l134.752 67.36 67.392 134.752c5.888 11.808 17.248 17.696 28.608 17.696s22.72-5.888 28.608-17.696l67.392-134.752 134.752-67.392zM424.16 520.16l-72.16 144.288-72.16-144.288-144.288-72.16 144.288-72.16 4.768-9.536 67.2-134.72c0 0 0.096-0.032 0.16-0.032l72.16 144.288 144.32 72.16-144.288 72.16zM885.728 226.304l-85.728-34.304-34.304-85.728c-5.344-13.408-17.536-20.096-29.696-20.096s-24.352 6.72-29.696 20.128l-34.304 85.696-85.728 34.304c-26.816 10.72-26.816 48.704 0 59.424l85.728 34.272 34.304 85.728c5.376 13.408 17.536 20.128 29.696 20.128s24.352-6.72 29.696-20.128l34.304-85.728 85.728-34.304c26.816-10.72 26.816-48.672 0-59.392zM788.128 290.304l-12.736 5.088-5.088 12.736-34.304 85.696-39.392-98.464-98.432-39.36 98.464-39.392 5.088-12.736 34.048-85.696c0.032 0 0.128-0.032 0.256-0.032l39.392 98.464 98.4 39.392-85.696 34.304zM725.728 770.304l-85.728-34.304-34.304-85.728c-5.376-13.408-17.536-20.128-29.696-20.128s-24.352 6.72-29.696 20.128l-34.304 85.728-85.728 34.304c-26.816 10.72-26.816 48.704 0 59.424l85.728 34.272 34.304 85.728c5.376 13.408 17.536 20.128 29.696 20.128s24.352-6.72 29.696-20.128l34.304-85.728 85.728-34.304c26.816-10.72 26.816-48.672 0-59.392zM628.128 834.304l-12.736 5.088-5.088 12.736-34.304 85.696-39.392-98.464-98.432-39.36 98.464-39.392 5.088-12.736 34.048-85.696c0.032 0 0.128-0.032 0.256-0.032l39.392 98.464 98.4 39.392-85.696 34.304zM870.24 563.136l-38.24-19.136-19.136-38.24c-2.624-5.312-7.744-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.312-10.624 20.448 0 25.76l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.624-5.312 10.624-20.48 0-25.76zM808.16 584.16l-8.16 16.288-8.16-16.288-16.288-8.16 16.288-8.16 8.16-16.288 8.16 16.288 16.288 8.16-16.288 8.16zM409.76 140.896l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.624-5.312 10.624-20.448 0-25.76l-38.24-19.136-19.136-38.24c-2.624-5.312-7.744-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.28-10.624 20.448 0 25.76zM471.84 119.84l8.16-16.288 8.16 16.288 16.288 8.16-16.288 8.16-8.16 16.288-8.16-16.288-16.288-8.16 16.288-8.16zM294.24 787.136l-38.24-19.136-19.136-38.24c-2.624-5.312-7.744-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.312-10.624 20.448 0 25.76l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.624-5.312 10.624-20.48 0-25.76zM232.16 808.16l-8.16 16.288-8.16-16.288-16.288-8.16 16.288-8.16 8.16-16.288 8.16 16.288 16.288 8.16-16.288 8.16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dazzle",
						"shine",
						"sparkle"
					],
					"grid": 32
				},
				{
					"id": 420,
					"width": 1024,
					"paths": [
						"M582.752 476.608c23.584-11.808 23.584-45.44 0-57.248l-134.752-67.36-67.392-134.752c-5.888-11.808-17.248-17.696-28.608-17.696s-22.72 5.888-28.608 17.696l-67.392 134.752-134.752 67.392c-23.584 11.808-23.584 45.44 0 57.248l134.752 67.36 67.392 134.752c5.888 11.808 17.248 17.696 28.608 17.696s22.72-5.888 28.608-17.696l67.392-134.752 134.752-67.392zM885.728 226.304l-85.728-34.304-34.304-85.728c-5.344-13.408-17.536-20.096-29.696-20.096s-24.352 6.72-29.696 20.128l-34.304 85.696-85.728 34.304c-26.816 10.72-26.816 48.704 0 59.424l85.728 34.272 34.304 85.728c5.376 13.408 17.536 20.128 29.696 20.128s24.352-6.72 29.696-20.128l34.304-85.728 85.728-34.304c26.816-10.72 26.816-48.672 0-59.392zM725.728 770.304l-85.728-34.304-34.304-85.728c-5.376-13.408-17.536-20.128-29.696-20.128s-24.352 6.72-29.696 20.128l-34.304 85.728-85.728 34.304c-26.816 10.72-26.816 48.704 0 59.424l85.728 34.272 34.304 85.728c5.376 13.408 17.536 20.128 29.696 20.128s24.352-6.72 29.696-20.128l34.304-85.728 85.728-34.304c26.816-10.72 26.816-48.672 0-59.392zM870.24 563.136l-38.24-19.136-19.136-38.24c-2.624-5.312-7.744-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.312-10.624 20.448 0 25.76l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.624-5.312 10.624-20.48 0-25.76zM409.76 140.896l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.624-5.312 10.624-20.448 0-25.76l-38.24-19.136-19.136-38.24c-2.624-5.312-7.744-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.28-10.624 20.448 0 25.76zM294.24 787.136l-38.24-19.136-19.136-38.24c-2.624-5.312-7.744-7.968-12.864-7.968s-10.24 2.656-12.896 7.968l-19.104 38.24-38.24 19.136c-10.624 5.312-10.624 20.448 0 25.76l38.24 19.104 19.104 38.24c2.656 5.312 7.776 7.968 12.896 7.968s10.24-2.656 12.864-7.968l19.136-38.24 38.24-19.104c10.624-5.312 10.624-20.48 0-25.76z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dazzle",
						"shine",
						"sparkle"
					],
					"grid": 32
				},
				{
					"id": 1797,
					"width": 1024.0010271072388,
					"paths": [
						"M603.429 475.429q0 14.857 10.857 25.714t25.714 10.857 25.714-10.857 10.857-25.714q0-83.429-58.857-142.286t-142.286-58.857-142.286 58.857-58.857 142.286q0 14.857 10.857 25.714t25.714 10.857 25.714-10.857 10.857-25.714q0-53.143 37.714-90.571t90.286-37.429 90.286 37.429 37.714 90.571zM477.143 146.286q-66.857 0-127.714 26t-105.143 70.286-70.286 105.143-26 127.714q0 14.857 10.857 25.714t25.714 10.857 25.714-10.857 10.857-25.714q0-105.714 75.143-180.857t180.857-75.143 180.857 75.143 75.143 180.857q0 31.429-10.286 59.143t-21.429 42.571-34 41.143q-19.429 22.286-29.714 36t-24.857 38-21.143 52-6.571 60.286q0 60.571-42.857 103.429t-103.429 42.857q-14.857 0-25.714 10.857t-10.857 25.714 10.857 25.714 25.714 10.857q90.857 0 155.143-64.286t64.286-155.143q0-23.429 4.286-42.286t15.143-36.571 19.143-28.571 26-30.857q20-23.429 30.286-36.857t25.143-38.571 21.429-53.429 6.571-62q0-66.857-26-127.714t-70.286-105.143-105.143-70.286-127.714-26zM337.714 557.143l129.143 129.143-330.857 330.857q-6.857 6.857-16.571 6.857t-16.571-6.857l-96-96q-6.857-6.857-6.857-16.571t6.857-16.571zM921.143 6.857l96 96q6.857 6.857 6.857 16.571t-6.857 17.143l-133.143 133.143-14.857 14.286-40.571 40.571q-37.714-87.429-111.429-147.429l170.286-170.286q7.429-6.857 17.143-6.857t16.571 6.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"deaf",
						"deafness",
						"hard-of-hearing"
					],
					"defaultCode": 62116,
					"grid": 14
				},
				{
					"id": 421,
					"width": 1024,
					"paths": [
						"M836.48 407.904l-73.344-64.16c-17.504-15.296-39.968-23.744-63.2-23.744h-123.936v-32h160c35.36 0 64-28.64 64-64v-96c0-35.36-28.64-64-64-64h-160v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-123.936c-23.232 0-45.696 8.448-63.2 23.744l-73.344 64.16c-14.56 12.736-14.56 35.424 0 48.16l73.344 64.16c17.504 15.328 39.968 23.776 63.2 23.776h123.936v32h-160c-35.36 0-64 28.64-64 64v96c0 35.36 28.64 64 64 64h160v448c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-448h123.936c23.264 0 45.728-8.448 63.232-23.744l73.344-64.16c14.528-12.768 14.528-35.424-0.032-48.192zM480 32h64v32h-64v-32zM281.92 240.16l-73.312-64.16 73.312-64.16c11.68-10.208 26.656-15.84 42.144-15.84h411.936c17.632 0 32 14.368 32 32v96c0 17.632-14.368 32-32 32h-411.936c-15.488 0-30.464-5.632-42.144-15.84zM480 288h64v32h-64v-32zM544 992h-64v-448h64v448zM742.080 496.16c-11.68 10.208-26.656 15.84-42.144 15.84h-411.936c-17.632 0-32-14.368-32-32v-96c0-17.632 14.368-32 32-32h411.936c15.52 0 30.464 5.632 42.144 15.84l73.344 64.16-73.344 64.16zM640 432c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM640 176c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"decide",
						"guide",
						"point",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 422,
					"width": 1024,
					"paths": [
						"M324.064 288h411.936c35.36 0 64-28.64 64-64v-96c0-35.36-28.64-64-64-64h-160v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-123.936c-23.232 0-45.696 8.448-63.2 23.744l-73.344 64.16c-14.56 12.736-14.56 35.424 0 48.16l73.344 64.16c17.504 15.328 39.968 23.776 63.2 23.776zM400 160h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16zM836.48 407.904l-73.344-64.16c-17.504-15.296-39.968-23.744-63.2-23.744h-411.936c-35.36 0-64 28.64-64 64v96c0 35.36 28.64 64 64 64h160v448c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-448h123.936c23.264 0 45.728-8.448 63.232-23.744l73.344-64.16c14.528-12.768 14.528-35.424-0.032-48.192zM624 448h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"decide",
						"guide",
						"point",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 998,
					"width": 1024,
					"paths": [
						"M836.736 604.192c-4.096-4.896-6.336-12.16-6.336-20.384v-19.456c0-12.928-7.776-24.608-19.744-29.568-11.968-4.928-25.696-2.24-34.88 6.944l-199.776 199.776v-187.296c0-56.416-22.016-109.44-61.92-149.376-23.040-23.040-37.952-53.536-41.984-85.824l-19.904-159.296c8.672-1.152 16.576-5.824 21.76-13.024 6.016-8.352 7.648-19.072 4.384-28.832l-17.952-53.856h19.616v-32c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v32h19.616l-17.952 53.888c-3.296 9.76-1.632 20.48 4.384 28.832 5.184 7.2 13.088 11.872 21.76 13.024l-19.936 159.264c-4.032 32.288-18.976 62.784-41.984 85.888-39.904 39.872-61.888 92.896-61.888 149.312v437.792c0 17.664 14.304 32 32 32h384c9.44 0 17.952-4.096 23.776-10.592 23.488 6.88 48.032 10.464 72.512 10.464 0.032 0 0.032 0 0.032 0 68.256 0 132.448-26.592 180.704-74.848 94.304-94.304 101.024-242.528 15.712-344.832zM466.752 896h-274.752v-320h320v274.752l-45.248 45.248zM740.128 667.872c17.376 23.648 27.872 52.576 27.872 84.128 0 79.392-64.608 144-144 144-31.552 0-60.48-10.496-84.128-27.872l200.256-200.256zM516.8 891.2c29.696 22.944 66.752 36.8 107.2 36.8 97.216 0 176-78.784 176-176 0-40.448-13.856-77.504-36.8-107.2l14.464-14.464c2.816 5.312 6.144 10.304 9.952 14.848 63.968 76.672 58.88 187.84-11.84 258.56-36.288 36.288-84.48 56.256-135.776 56.256-44.864 0-88.48-15.776-122.784-44.384-4.576-3.808-9.536-7.136-14.848-9.952l14.432-14.464zM392.928 64l10.656 32h-103.2l10.656-32h81.888zM235.168 450.080c33.056-33.056 54.432-76.8 60.224-123.136 0 0 24.032-197.6 24.032-198.944h65.184c0 1.344 24.032 198.944 24.032 198.944 5.792 46.336 27.2 90.080 60.256 123.2 25.344 25.344 39.68 58.432 42.112 93.856h-318.016c2.464-35.424 16.768-68.544 42.176-93.92zM192 960v-32h278.144c9.696 1.952 18.912 5.824 26.56 12.192 6.368 5.312 13.344 9.472 20.128 13.952-1.12 1.92-2.432 3.744-3.136 5.856h-321.696z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"decompress",
						"drink",
						"relax"
					],
					"grid": 32
				},
				{
					"id": 423,
					"width": 1024,
					"paths": [
						"M780.512 513.952c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM748.512 286.048c17.664 0 32 14.336 32 32s-14.336 32-32 32c-17.664 0-32-14.336-32-32 0-17.696 14.336-32 32-32zM512 32c-212.064 0-384 171.936-384 384 0 128.192 63.456 240.832 160 310.528v69.824c0 37.344 30.656 64.096 64.096 64.096 10.56 0 21.408-2.656 31.648-8.512l29.696-16.96-36.544 93.408c-8.544 21.824 8.256 43.712 29.6 43.712 3.36 0 6.816-0.544 10.304-1.696l95.2-31.744 95.2 31.744c3.488 1.152 6.944 1.696 10.304 1.696 21.344 0 38.144-21.888 29.6-43.712l-36.544-93.408 29.696 16.96c10.24 5.856 21.088 8.512 31.648 8.512 33.44 0 64.096-26.752 64.096-64.096v-69.824c96.544-69.728 160-182.368 160-310.528 0-212.064-171.936-384-384-384zM367.872 824.16c-4.992 2.848-10.304 4.32-15.776 4.32-15.424 0-32.096-12.256-32.096-32.096v-163.424c0-19.808 16.672-32.096 32.096-32.096 5.472 0 10.784 1.44 15.776 4.32l75.136 42.944c-16.64 17.216-27.008 40.608-27.008 66.528s10.368 49.28 27.040 66.56l-75.168 42.944zM512 904.928l-105.312 35.104 51.008-130.368 14.144-8.096c12.256 5.664 25.76 9.056 40.16 9.056v94.304zM448 714.656c0-35.296 28.704-64 64-64s64 28.704 64 64c0 35.296-28.704 64-64 64s-64-28.736-64-64zM617.312 940.032l-73.312-24.416v-110.848c2.752-0.992 5.504-1.952 8.16-3.168l14.144 8.096 51.008 130.336zM704 796.352c0 19.84-16.672 32.096-32.096 32.096-5.472 0-10.784-1.44-15.776-4.32l-75.136-42.944c16.672-17.28 27.040-40.672 27.040-66.56s-10.368-49.28-27.040-66.56l75.136-42.944c4.992-2.848 10.304-4.32 15.776-4.32 15.424 0 32.096 12.256 32.096 32.096v163.456zM736 686.208v-53.28c0-37.344-30.656-64.096-64.096-64.096-10.56 0-21.408 2.688-31.648 8.512l-88.096 50.336c-12.256-5.664-25.76-9.056-40.16-9.056s-27.904 3.392-40.16 9.056l-88.096-50.336c-10.24-5.856-21.088-8.512-31.648-8.512-33.44 0-64.096 26.752-64.096 64.096v53.28c-77.856-64.576-128-161.376-128-270.208 0-194.080 157.92-352 352-352s352 157.92 352 352c0 108.832-50.144 205.632-128 270.208zM577.952 179.488c0-17.664 14.336-32 32-32s32 14.336 32 32-14.336 32-32 32-32-14.336-32-32zM307.488 318.048c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.304 32 32zM512 254.4c-89.12 0-161.6 72.512-161.6 161.6s72.512 161.6 161.6 161.6 161.6-72.512 161.6-161.6-72.48-161.6-161.6-161.6zM512 545.6c-71.584 0-129.6-58.016-129.6-129.6s58.016-129.6 129.6-129.6c71.584 0 129.6 58.016 129.6 129.6s-58.016 129.6-129.6 129.6zM307.488 513.952c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM382.048 179.488c0-17.664 14.336-32 32-32s32 14.336 32 32-14.336 32-32 32-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"decorate",
						"celebrate",
						"hang"
					],
					"grid": 32
				},
				{
					"id": 424,
					"width": 1024,
					"paths": [
						"M647.104 928.384c8.544 21.824-8.256 43.712-29.6 43.712-3.36 0-6.816-0.544-10.304-1.696l-63.2-21.056v-144.576c3.264-1.152 6.4-2.432 9.504-3.904l58.4 33.376 35.2 94.144zM512 810.656c-14.912 0-28.864-3.712-41.504-9.824l-55.936 31.968-37.696 95.584c-8.544 21.824 8.256 43.712 29.6 43.712 3.36 0 6.816-0.544 10.304-1.696l95.232-31.744v-128zM512 778.656c35.36 0 64-28.64 64-64s-28.64-64-64-64c-35.36 0-64 28.64-64 64s28.64 64 64 64zM367.872 605.152c-4.992-2.848-10.304-4.32-15.776-4.32-15.424 0-32.096 12.288-32.096 32.096v161.92c0 19.84 16.672 32.096 32.096 32.096 5.472 0 10.784-1.44 15.776-4.32l74.336-42.464c-16.128-17.184-26.208-40.128-26.208-65.504 0-25.856 10.4-49.28 27.072-66.56l-75.2-42.944zM896 416c0 128.224-63.424 240.992-160 310.72v-93.792c0-37.344-30.656-64.096-64.096-64.096-10.56 0-21.408 2.656-31.648 8.512l-88.16 50.368c-12.256-5.664-25.76-9.056-40.096-9.056s-27.872 3.392-40.096 9.056l-88.16-50.368c-10.24-5.856-21.088-8.512-31.648-8.512-33.44 0-64.096 26.752-64.096 64.096v93.792c-96.576-69.728-160-182.496-160-310.72 0-212.064 171.936-384 384-384s384 171.936 384 384zM307.488 513.952c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.304 32-32zM307.488 318.048c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM414.048 211.488c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32 14.304 32 32 32zM640 416c0-70.688-57.312-128-128-128s-128 57.312-128 128c0 70.688 57.312 128 128 128s128-57.312 128-128zM641.952 179.488c0-17.664-14.336-32-32-32s-32 14.336-32 32 14.336 32 32 32 32-14.336 32-32zM780.512 513.952c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.304 32-32zM780.512 318.048c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM671.904 600.832c-5.472 0-10.784 1.44-15.776 4.32l-75.2 42.976c16.672 17.28 27.072 40.704 27.072 66.56 0 25.376-10.080 48.32-26.208 65.504l74.336 42.464c4.992 2.848 10.304 4.32 15.776 4.32 15.424 0 32.096-12.256 32.096-32.096v-161.92c0-19.872-16.672-32.128-32.096-32.128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"decorate",
						"celebrate",
						"hang"
					],
					"grid": 32
				},
				{
					"id": 1235,
					"width": 1023.9989223480225,
					"paths": [
						"M219.429 310.857v329.143q0 7.429-5.429 12.857t-12.857 5.429q-8 0-13.143-5.143l-164.571-164.571q-5.143-5.143-5.143-13.143t5.143-13.143l164.571-164.571q5.143-5.143 13.143-5.143 7.429 0 12.857 5.429t5.429 12.857zM1024 749.714v109.714q0 7.429-5.429 12.857t-12.857 5.429h-987.429q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h987.429q7.429 0 12.857 5.429t5.429 12.857zM1024 530.286v109.714q0 7.429-5.429 12.857t-12.857 5.429h-621.714q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h621.714q7.429 0 12.857 5.429t5.429 12.857zM1024 310.857v109.714q0 7.429-5.429 12.857t-12.857 5.429h-621.714q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h621.714q7.429 0 12.857 5.429t5.429 12.857zM1024 91.429v109.714q0 7.429-5.429 12.857t-12.857 5.429h-987.429q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h987.429q7.429 0 12.857 5.429t5.429 12.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dedent",
						"outdent"
					],
					"defaultCode": 61499,
					"grid": 14
				},
				{
					"id": 425,
					"width": 1024,
					"paths": [
						"M736 128v-13.408c0-15.84-11.424-29.248-27.072-31.616-44.448-6.72-134.208-18.976-196.928-18.976s-152.48 12.256-196.928 18.944c-15.648 2.368-27.072 15.808-27.072 31.648v13.408c0 79.072-57.376 144.768-132.768 157.696-15.584 2.656-27.232 15.648-27.232 31.456v322.848c0 175.328 262.432 279.456 353.408 310.304 19.968 6.752 41.248 6.752 61.216 0 90.944-30.848 353.376-134.976 353.376-310.304v-322.848c0-15.808-11.648-28.8-27.232-31.456-75.392-12.928-132.768-78.624-132.768-157.696zM864 317.344v162.656h-336v-383.648c57.28 0.896 116.448 6.272 176.704 16.576-0.48 5.088-0.704 10.080-0.704 15.072 0 94.976 69.312 174.048 160 189.344zM320 128c0-4.992-0.224-9.984-0.704-15.072 60.256-10.272 119.424-15.68 176.704-16.576v383.648h-336v-162.656c90.688-15.296 160-94.368 160-189.344zM160 640v-128h336v409.376c-81.056-27.072-336-124.672-336-281.376zM528 921.376v-409.376h336v128c0 156.704-254.944 254.304-336 281.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"defend",
						"fight",
						"protect",
						"shield",
						"guard"
					],
					"grid": 32
				},
				{
					"id": 426,
					"width": 1024,
					"paths": [
						"M868.768 285.696c-75.392-12.928-132.768-78.624-132.768-157.696v-13.408c0-15.84-11.424-29.248-27.072-31.616-44.448-6.72-134.208-18.976-196.928-18.976s-152.48 12.256-196.928 18.944c-15.648 2.368-27.072 15.808-27.072 31.648v13.408c0 79.072-57.376 144.768-132.768 157.696-15.584 2.656-27.232 15.648-27.232 31.456v322.848c0 175.328 262.432 279.456 353.408 310.304 19.968 6.752 41.248 6.752 61.216 0 90.944-30.848 353.376-134.976 353.376-310.304v-322.848c0-15.808-11.648-28.8-27.232-31.456zM848 512h-320v400c0 8.832-7.168 16-16 16s-16-7.168-16-16v-400h-320c-8.832 0-16-7.168-16-16s7.168-16 16-16h320v-368c0-8.832 7.168-16 16-16s16 7.168 16 16v368h320c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"defend",
						"fight",
						"protect",
						"shield",
						"guard"
					],
					"grid": 32
				},
				{
					"id": 3393,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM512 960v-448h-448v-448h448v448h448v448h-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"delicious",
						"brand",
						"social"
					],
					"defaultCode": 61228,
					"grid": 16
				},
				{
					"id": 1560,
					"width": 877.7129821777344,
					"paths": [
						"M841.143 786.286v-274.286h-402.286v-402.286h-274.286q-53.143 0-90.571 37.429t-37.429 90.571v274.286h402.286v402.286h274.286q53.143 0 90.571-37.429t37.429-90.571zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"delicious"
					],
					"defaultCode": 61861,
					"grid": 14
				},
				{
					"id": 427,
					"width": 1024,
					"paths": [
						"M832 96h-640c-53.024 0-96 42.976-96 96v64c0 17.664 14.336 32 32 32v544c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-544c17.664 0 32-14.336 32-32v-64c0-53.024-42.976-96-96-96zM800 896h-576c-35.36 0-64-28.64-64-64v-544h704v544c0 35.36-28.64 64-64 64zM896 256h-768v-64c0-35.36 28.64-64 64-64h640c35.36 0 64 28.64 64 64v64zM432 448h160c26.496 0 48-21.504 48-48s-21.504-48-48-48h-160c-26.496 0-48 21.504-48 48s21.504 48 48 48zM432 384h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"deliver",
						"send"
					],
					"grid": 32
				},
				{
					"id": 428,
					"width": 1024,
					"paths": [
						"M608 432c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16zM128 288h768c17.664 0 32-14.336 32-32v-64c0-53.024-42.976-96-96-96h-640c-53.024 0-96 42.976-96 96v64c0 17.664 14.336 32 32 32zM896 320v512c0 53.024-42.976 96-96 96h-576c-53.024 0-96-42.976-96-96v-512h768zM640 432c0-26.496-21.504-48-48-48h-160c-26.496 0-48 21.504-48 48s21.504 48 48 48h160c26.496 0 48-21.504 48-48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"deliver",
						"send"
					],
					"grid": 32
				},
				{
					"id": 1826,
					"paths": [
						"M1024 288v-256l-992 992h256v-64h32v64h96v-128h32v128h96v-64h32v64h96v-128h32v128h96v-64h32v64h192v-192h-64v-32h64v-96h-128v-32h128v-96h-64v-32h64v-96h-128v-32h128v-96h-64v-32h64zM832 832h-352l352-352v352z",
						"M608 0l-512 512-96 256 256-96 512-512c0-96-64-160-160-160zM224 576l-64-64 448-448 64 64-448 448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"design",
						"pencil-ruler"
					],
					"defaultCode": 59661,
					"grid": 16
				},
				{
					"id": 429,
					"width": 1024,
					"paths": [
						"M928 128h-832c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h288v96h-48c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h352c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-48v-96h288c53.024 0 96-42.976 96-96v-512c0-53.024-42.976-96-96-96zM608 928h-192v-96h192v96zM992 736c0 35.36-28.64 64-64 64h-832c-35.36 0-64-28.64-64-64v-512c0-35.36 28.64-64 64-64h832c35.36 0 64 28.64 64 64v512zM825.76 288.96c-25.024-4.928-47.2 9.6-54.816 31.040h-194.944v-32h-128v32h-194.944c-7.616-21.44-29.824-35.968-54.816-31.040-18.336 3.616-33.28 18.304-37.12 36.608-6.56 31.072 16.96 58.432 46.88 58.432 20.864 0 38.464-13.408 45.056-32h194.944v7.168c-140.416 28.704-247.84 149.056-255.552 295.872-0.48 9.184 6.816 16.96 16.032 16.96v0c8.416 0 15.488-6.528 15.904-14.944 6.688-130.080 100.288-237.12 223.616-265.248v24.192h128v-24.224c123.328 28.16 216.928 135.2 223.616 265.248 0.448 8.448 7.488 14.976 15.904 14.976v0c9.216 0 16.512-7.776 16.032-16.96-7.712-146.816-115.136-267.168-255.552-295.872v-7.168h194.944c6.624 18.592 24.192 32 45.056 32 29.92 0 53.44-27.36 46.912-58.432-3.872-18.304-18.816-32.992-37.152-36.608zM208 352c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16-7.168 16-16 16zM544 384h-64v-64h64v64zM816 352c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"design",
						"create",
						"work",
						"draw",
						"illustrate"
					],
					"grid": 32
				},
				{
					"id": 430,
					"width": 1024,
					"paths": [
						"M480 320h64v64h-64v-64zM208 320c-8.832 0-16 7.168-16 16s7.168 16 16 16 16-7.168 16-16-7.168-16-16-16zM688 928h-48v-64h-256v64h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h352c8.832 0 16-7.168 16-16s-7.168-16-16-16zM1024 224v512c0 53.024-42.976 96-96 96h-832c-53.024 0-96-42.976-96-96v-512c0-53.024 42.976-96 96-96h832c53.024 0 96 42.976 96 96zM862.912 325.568c-3.84-18.304-18.784-32.96-37.12-36.608-25.024-4.928-47.2 9.6-54.816 31.040h-194.976v-32h-128v32h-194.944c-7.616-21.44-29.824-35.968-54.816-31.040-18.336 3.616-33.28 18.304-37.12 36.608-6.56 31.072 16.96 58.432 46.88 58.432 20.864 0 38.464-13.408 45.056-32h194.944v7.168c-140.416 28.704-247.84 149.056-255.552 295.872-0.48 9.184 6.816 16.96 16.032 16.96v0c8.416 0 15.488-6.528 15.904-14.944 6.688-130.080 100.288-237.12 223.616-265.248v24.192h128v-24.224c123.328 28.16 216.928 135.2 223.616 265.248 0.448 8.448 7.488 14.976 15.904 14.976v0c9.216 0 16.512-7.776 16.032-16.96-7.712-146.816-115.136-267.168-255.552-295.872v-7.168h194.944c6.624 18.592 24.192 32 45.056 32 29.92 0 53.44-27.36 46.912-58.432zM816 320c-8.832 0-16 7.168-16 16s7.168 16 16 16 16-7.168 16-16-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"design",
						"create",
						"work",
						"draw",
						"illustrate"
					],
					"grid": 32
				},
				{
					"id": 999,
					"width": 1024,
					"paths": [
						"M256 288h-128v96h128v-96zM224 352h-64v-32h64v32zM256 416h-128v96h128v-96zM224 480h-64v-32h64v32zM192 544c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM192 704c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64zM692.672 372.672l22.624 22.624-64 64-22.624-22.624 64-64zM992 128h-50.752l-54.624-54.624c-12.512-12.512-32.736-12.512-45.248 0l-54.624 54.624h-754.752c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM512 448v128h128l256-256v416h-544v-448h320l-160 160zM544 470.624l73.376 73.376h-73.376v-73.376zM644.672 526.048l-82.752-82.752 302.080-302.048 82.752 82.752-302.080 302.048zM64 832v-640h704l-64 64h-384v512h608v-480l32-32v576h-896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"design",
						"create",
						"illustrate"
					],
					"grid": 32
				},
				{
					"id": 1415,
					"width": 1097.1500434875488,
					"paths": [
						"M1024 566.857v-475.429q0-7.429-5.429-12.857t-12.857-5.429h-914.286q-7.429 0-12.857 5.429t-5.429 12.857v475.429q0 7.429 5.429 12.857t12.857 5.429h914.286q7.429 0 12.857-5.429t5.429-12.857zM1097.143 91.429v621.714q0 37.714-26.857 64.571t-64.571 26.857h-310.857q0 21.143 9.143 44.286t18.286 40.571 9.143 24.857q0 14.857-10.857 25.714t-25.714 10.857h-292.571q-14.857 0-25.714-10.857t-10.857-25.714q0-8 9.143-25.143t18.286-40 9.143-44.571h-310.857q-37.714 0-64.571-26.857t-26.857-64.571v-621.714q0-37.714 26.857-64.571t64.571-26.857h914.286q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"desktop"
					],
					"defaultCode": 61704,
					"grid": 14
				},
				{
					"id": 431,
					"width": 1024,
					"paths": [
						"M256 384c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM256 480c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM949.056 160.832l-53.44-17.824 25.184-50.336c6.88-13.76-7.712-28.352-21.472-21.472l-50.368 25.184-17.792-53.408c-4.864-14.592-25.504-14.592-30.368 0l-17.76 53.408-50.368-25.184c-13.76-6.88-28.352 7.712-21.472 21.472l25.184 50.336-50.976 16.992h-8.992c-23.488 0-43.936-16-49.632-38.784l-5.504-22.080c-7.488-30.112-29.408-55.904-59.328-64.096-40.928-11.2-81.984 9.6-98.304 46.304l-34.944 78.656h-76.704c-17.664 0-32 14.336-32 32v54.304c-155.392 55.040-265.056 206.816-255.424 383.2 10.656 194.88 172.64 354.368 367.648 362.176 219.264 8.768 399.776-166.368 399.776-383.68 0-167.136-106.944-308.928-256-361.696v-54.304c0-17.664-14.336-32-32-32h-80.256l29.184-65.664c8.16-18.432 26.496-30.336 46.656-30.336 23.488 0 43.904 15.904 49.6 38.688l6.528 26.24c9.216 37.056 42.496 63.072 80.704 63.072h8.992l50.976 16.992-25.184 50.336c-6.88 13.76 7.712 28.352 21.472 21.472l50.336-25.184 17.824 53.44c4.864 14.592 25.504 14.592 30.368 0l17.824-53.44 50.336 25.184c13.76 6.88 28.352-7.712 21.472-21.472l-25.184-50.336 53.44-17.824c14.56-4.864 14.56-25.472-0.032-30.336zM800 608c0 194.080-157.92 352-352 352s-352-157.92-352-352 157.92-352 352-352 352 157.92 352 352zM544 192v44.576c-30.752-7.904-62.784-12.576-96-12.576s-65.248 4.672-96 12.576v-44.576h192zM870.688 230.688l-40.384-20.192-14.304 42.944-14.304-42.944-40.384 20.192 20.192-40.384-42.944-14.304 42.944-14.304-20.224-40.416 40.448 20.224 14.272-42.88 14.272 42.88 40.448-20.224-20.224 40.416 42.944 14.304-42.944 14.304 20.192 40.384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"destroy",
						"fight",
						"explode"
					],
					"grid": 32
				},
				{
					"id": 432,
					"width": 1024,
					"paths": [
						"M288 448c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM949.056 160.832l-53.44-17.824 25.184-50.336c6.88-13.76-7.712-28.352-21.472-21.472l-50.368 25.184-17.792-53.408c-4.864-14.592-25.504-14.592-30.368 0l-17.76 53.408-50.368-25.184c-13.76-6.88-28.352 7.712-21.472 21.472l25.184 50.336-50.976 16.992h-8.992c-23.488 0-43.936-16-49.632-38.784l-5.504-22.080c-7.488-30.112-29.408-55.904-59.328-64.096-40.928-11.2-81.984 9.6-98.304 46.304l-20.736 46.656h35.040l14.944-33.664c8.192-18.432 26.528-30.336 46.688-30.336 23.488 0 43.904 15.904 49.6 38.688l6.528 26.24c9.216 37.056 42.496 63.072 80.704 63.072h8.992l50.976 16.992-25.184 50.336c-6.88 13.76 7.712 28.352 21.472 21.472l50.336-25.184 17.824 53.44c4.864 14.592 25.504 14.592 30.368 0l17.824-53.44 50.336 25.184c13.76 6.88 28.352-7.712 21.472-21.472l-25.184-50.336 53.44-17.824c14.56-4.864 14.56-25.472-0.032-30.336zM832 608c0 217.312-180.512 392.448-399.776 383.68-195.008-7.808-356.992-167.296-367.648-362.176-9.632-176.384 100.032-328.16 255.424-383.2v-54.304c0-17.664 14.336-32 32-32h192c17.664 0 32 14.336 32 32v54.304c149.056 52.768 256 194.56 256 361.696zM320 448c0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64c35.36 0 64-28.64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"destroy",
						"fight",
						"explode"
					],
					"grid": 32
				},
				{
					"id": 3358,
					"paths": [
						"M829 186.2v-186.2h-186.2l-18.6 18.8-88 167.4-27.6 18.6h-313.6v255.6h172.4l15.4 18.6-187.8 358.8v186.2h186.2l18.6-18.8 88-167.4 27.6-18.6h313.6v-255.6h-172.4l-15.4-18.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"deviantart",
						"brand",
						"social"
					],
					"defaultCode": 61193,
					"grid": 16
				},
				{
					"id": 1583,
					"width": 585.1430053710938,
					"paths": [
						"M585.143 173.143l-173.143 332.571 13.714 17.714h159.429v237.143h-289.714l-25.143 17.143-81.143 156-17.143 17.143h-172v-173.143l173.143-333.143-13.714-17.143h-159.429v-237.143h289.714l25.143-17.143 81.143-156 17.143-17.143h172v173.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"deviantart"
					],
					"defaultCode": 61885,
					"grid": 14
				},
				{
					"id": 2494,
					"paths": [
						"M714.98 256l133.168 133.168-336.148 378.166-336.148-378.166 133.168-133.168h405.96zM768 128h-512l-256 256 512 576 512-576-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"diamond",
						"gem",
						"jewelry"
					],
					"defaultCode": 60329,
					"grid": 16
				},
				{
					"id": 2495,
					"paths": [
						"M768 128h-512l-256 256 512 576 512-576-256-256zM512 778.666v-2.666h-2.37l-14.222-16h16.592v-16h-30.814l-14.222-16h45.036v-16h-59.258l-14.222-16h73.48v-16h-87.704l-14.222-16h101.926v-16h-116.148l-14.222-16h130.37v-16h-144.592l-14.222-16h158.814v-16h-173.038l-14.222-16h187.26v-16h-201.482l-14.222-16h215.704v-16h-229.926l-14.222-16h244.148v-16h-258.372l-14.222-16h272.594v-16h-286.816l-14.222-16h301.038v-16h-315.26l-14.222-16h329.482v-16h-343.706l-7.344-8.262 139.072-139.072h211.978v3.334h215.314l16 16h-231.314v16h247.314l16 16h-263.314v16h279.314l16 16h-295.314v16h311.314l16 16h-327.314v16h343.312l7.738 7.738-351.050 394.928z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"diamond",
						"gem",
						"jewelry",
						"dualtone"
					],
					"defaultCode": 60330,
					"grid": 16
				},
				{
					"id": 3201,
					"paths": [
						"M512 32l-480 480 480 480 480-480-480-480zM160 512l352-352 352 352-352 352-352-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"diamond"
					],
					"defaultCode": 61036,
					"grid": 16
				},
				{
					"id": 3202,
					"paths": [
						"M31.997 512l479.995-479.995 479.995 479.995-479.995 479.995-479.995-479.995z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"diamond"
					],
					"defaultCode": 61037,
					"grid": 16
				},
				{
					"id": 1669,
					"width": 1170.2901077270508,
					"paths": [
						"M121.143 438.857l356 380-171.429-380h-184.571zM585.143 880l199.429-441.143h-398.857zM307.429 365.714l116.571-219.429h-149.714l-164.571 219.429h197.714zM693.143 818.857l356-380h-184.571zM390.286 365.714h389.714l-116.571-219.429h-156.571zM862.857 365.714h197.714l-164.571-219.429h-149.714zM943.429 88l219.429 292.571q8 10.286 7.429 23.714t-9.714 23.143l-548.571 585.143q-10.286 11.429-26.857 11.429t-26.857-11.429l-548.571-585.143q-9.143-9.714-9.714-23.143t7.429-23.714l219.429-292.571q10.286-14.857 29.143-14.857h658.286q18.857 0 29.143 14.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"diamond"
					],
					"defaultCode": 61977,
					"grid": 14
				},
				{
					"id": 164,
					"paths": [
						"M967.68 368.64l-153.6-204.8c-3.95-5.267-9.776-8.81-16.272-9.891l-307.2-51.2c-2.786-0.464-5.632-0.464-8.418 0l-307.2 51.2c-6.494 1.082-12.322 4.626-16.27 9.891l-153.6 204.8c-7.339 9.786-6.731 23.395 1.451 32.486l460.8 512c4.856 5.394 11.771 8.474 19.029 8.474s14.173-3.080 19.029-8.475l460.8-512c8.182-9.091 8.79-22.699 1.451-32.485zM654.65 358.4l-168.25 462.691-168.251-462.691h336.501zM343.405 307.2l142.995-142.995 142.995 142.995h-285.99zM560.989 166.384l189.349 31.558-63.115 94.674-126.234-126.232zM285.579 292.616l-63.117-94.674 189.349-31.558-126.232 126.232zM239.096 315.194l-152.813 30.563 91.688-122.25 61.125 91.686zM265.058 362.216l152.285 418.784-342.642-380.712 190.357-38.072zM707.744 362.216l190.357 38.072-342.643 380.712 152.286-418.784zM733.704 315.194l61.125-91.688 91.688 122.25-152.813-30.562z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"diamond",
						"jewelry"
					],
					"defaultCode": 59461,
					"grid": 20
				},
				{
					"id": 1926,
					"paths": [
						"M512 0l-320 512 320 512 320-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"diamonds",
						"cards",
						"poker"
					],
					"defaultCode": 59761,
					"grid": 16
				},
				{
					"id": 1919,
					"paths": [
						"M864 192h-512c-88 0-160 72-160 160v512c0 88 72 160 160 160h512c88 0 160-72 160-160v-512c0-88-72-160-160-160zM416 896c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96zM416 512c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96zM608 704c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96zM800 896c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96zM800 512c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96zM828.76 128c-14.93-72.804-79.71-128-156.76-128h-512c-88 0-160 72-160 160v512c0 77.046 55.196 141.83 128 156.76v-636.76c0-35.2 28.8-64 64-64h636.76z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dice",
						"game",
						"chance",
						"luck",
						"random",
						"gample"
					],
					"defaultCode": 59754,
					"grid": 16
				},
				{
					"id": 113,
					"paths": [
						"M281.6 819.2c-42.347 0-76.8-34.451-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.453 76.8-76.8 76.8zM281.6 716.8c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M281.6 614.4c-42.347 0-76.8-34.451-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.453 76.8-76.8 76.8zM281.6 512c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M281.6 409.6c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.453 76.8-76.8 76.8zM281.6 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M691.2 409.6c-42.349 0-76.8-34.453-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.451 76.8-76.8 76.8zM691.2 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M691.2 614.4c-42.349 0-76.8-34.451-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.451 76.8-76.8 76.8zM691.2 512c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M691.2 819.2c-42.349 0-76.8-34.451-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.451 76.8-76.8 76.8zM691.2 716.8c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M793.6 972.8h-614.4c-70.579 0-128-57.421-128-128v-614.4c0-70.579 57.421-128 128-128h614.4c70.579 0 128 57.421 128 128v614.4c0 70.579-57.421 128-128 128zM179.2 153.6c-42.347 0-76.8 34.453-76.8 76.8v614.4c0 42.349 34.453 76.8 76.8 76.8h614.4c42.349 0 76.8-34.451 76.8-76.8v-614.4c0-42.347-34.451-76.8-76.8-76.8h-614.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dice",
						"game",
						"random",
						"board-game"
					],
					"defaultCode": 59410,
					"grid": 20
				},
				{
					"id": 433,
					"width": 1024,
					"paths": [
						"M480 816v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16zM400 800c-8.832 0-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16zM352 672c-70.688 0-96-57.312-96-128s25.312-128 96-128 96 57.312 96 128-25.312 128-96 128zM416 544c0-96-48.16-96-64-96s-64 0-64 96 48.16 96 64 96 64 0 64-96zM560 800c-8.832 0-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16zM928 448c0 160.448-90.976 299.424-224 368.832v79.168c0 53.024-42.976 96-96 96h-192c-53.024 0-96-42.976-96-96v-79.168c-145.12-75.712-240.16-234.208-221.728-413.024 19.808-191.808 174.592-347.968 366.24-369.184 251.008-27.776 463.488 167.968 463.488 413.376zM896 448c0-231.648-206.176-416.032-444.672-379.328-154.432 23.776-281.504 142.912-314.368 295.68-37.6 174.688 45.792 344.8 197.824 424.096l17.216 8.96v98.592c0 35.36 28.64 64 64 64h192c35.36 0 64-28.64 64-64v-98.592l17.184-8.96c127.584-66.528 206.816-196.992 206.816-340.448zM768 544c0 70.688-25.312 128-96 128s-96-57.312-96-128 25.312-128 96-128 96 57.312 96 128zM736 544c0-96-48.16-96-64-96s-64 0-64 96 48.16 96 64 96 64 0 64-96zM624 800c-8.832 0-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"die",
						"end",
						"expire",
						"decompose"
					],
					"grid": 32
				},
				{
					"id": 434,
					"width": 1024,
					"paths": [
						"M416 544c0 96-48.16 96-64 96s-64 0-64-96 48.16-96 64-96 64 0 64 96zM672 448c-15.84 0-64 0-64 96s48.16 96 64 96 64 0 64-96-48.16-96-64-96zM928 448c0 160.448-90.976 299.424-224 368.832v79.168c0 53.024-42.976 96-96 96h-192c-53.024 0-96-42.976-96-96v-79.168c-145.12-75.712-240.16-234.208-221.728-413.024 19.808-191.808 174.592-347.968 366.24-369.184 251.008-27.776 463.488 167.968 463.488 413.376zM352 672c70.688 0 96-57.312 96-128s-25.312-128-96-128-96 57.312-96 128 25.312 128 96 128zM416 816c0-8.832-7.168-16-16-16s-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64zM480 816c0-8.832-7.168-16-16-16s-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64zM576 816c0-8.832-7.168-16-16-16s-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64zM640 816c0-8.832-7.168-16-16-16s-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64zM768 544c0-70.688-25.312-128-96-128s-96 57.312-96 128 25.312 128 96 128 96-57.312 96-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"die",
						"end",
						"expire",
						"decompose"
					],
					"grid": 32
				},
				{
					"id": 1000,
					"width": 1024,
					"paths": [
						"M512 0c-247.424 0-448 200.576-448 448 0 288.096 96.256 391.968 237.568 428.64l14.912 119.328c2.016 16 15.616 28.032 31.776 28.032h327.488c16.128 0 29.76-12.032 31.744-28.032l14.912-119.328c141.344-36.672 237.6-140.544 237.6-428.64 0-247.424-200.576-448-448-448zM706.336 814.688l-42.048 10.912-16.8 134.4h-71.488v-128h-32v128h-64v-128h-32v128h-71.488l-16.8-134.4-42.048-10.912c-98.528-25.536-189.664-87.648-189.664-366.688 0-211.744 172.256-384 384-384s384 172.256 384 384c0 164.896-22.976 323.456-189.664 366.688zM320 416c-70.688 0-128 71.648-128 160s57.312 160 128 160c70.688 0 128-71.648 128-160s-57.312-160-128-160zM320 704c-52.928 0-96-57.408-96-128s43.072-128 96-128 96 57.408 96 128c0 70.592-43.072 128-96 128zM704 416c-70.688 0-128 71.648-128 160s57.312 160 128 160c70.688 0 128-71.648 128-160s-57.312-160-128-160zM704 704c-52.928 0-96-57.408-96-128s43.072-128 96-128 96 57.408 96 128c0 70.592-43.072 128-96 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"die",
						"end",
						"expire",
						"decompose"
					],
					"grid": 32
				},
				{
					"id": 1561,
					"width": 1170.2860107421875,
					"paths": [
						"M187.429 161.143h116.571v561.714h-304v-398.286h187.429v-163.429zM187.429 629.143v-210.857h-70.286v210.857h70.286zM350.857 324.571v398.286h117.143v-398.286h-117.143zM350.857 161.143v116.571h117.143v-116.571h-117.143zM514.857 324.571h304.571v538.286h-304.571v-93.143h187.429v-46.857h-187.429v-398.286zM702.286 629.143v-210.857h-70.286v210.857h70.286zM866.286 324.571h304v538.286h-304v-93.143h186.857v-46.857h-186.857v-398.286zM1053.143 629.143v-210.857h-70.286v210.857h70.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"digg"
					],
					"defaultCode": 61862,
					"grid": 14
				},
				{
					"id": 166,
					"paths": [
						"M409.6 25.6c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6c0 66.843 12.915 122.715 23.293 167.608 10.112 43.749 18.099 78.302 6.637 92.718-9.525 11.978-36.712 18.942-80.938 20.778-0.114-8.314-0.189-16.669-0.19-25.109v-204.795c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v204.803c0.002 8.426-0.072 16.768-0.182 25.069-44.099-1.898-71.219-8.901-80.76-20.893-11.52-14.477-3.542-49.086 6.557-92.902 10.328-44.818 23.184-100.594 23.184-167.277 0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6c0 60.859-12.131 113.488-21.878 155.776-13.198 57.259-23.622 102.485 3.27 136.283 19.97 25.096 56.374 37.542 119.458 40.192-5.741 142.84-26.443 265.747-43.589 367.451-22.816 135.354-37.888 224.77 0.605 270.298 15.934 18.845 39.531 28.4 70.134 28.4 30.608 0 54.208-9.558 70.147-28.406 38.52-45.554 23.438-135.051 0.611-270.526-17.126-101.638-37.808-224.466-43.584-367.184 63.213-2.57 99.656-14.973 119.629-40.090 26.837-33.747 16.395-78.923 3.173-136.117-9.79-42.358-21.976-95.074-21.976-156.077zM312.651 962.534c-3.726 4.406-11 10.266-31.051 10.266-20.045 0-27.312-5.854-31.035-10.258-23.154-27.384-7.426-120.69 10.786-228.728 6.581-39.038 13.68-81.157 20.28-126.326 6.589 45.082 13.672 87.115 20.238 126.090 18.224 108.144 33.962 201.544 10.782 228.957z",
						"M813.158 725.069c-20.104-119.326-45.13-267.832-45.158-443.472v-255.997c0-11.608-7.811-21.763-19.032-24.742-11.218-2.979-23.035 1.963-28.795 12.042-103.387 180.926-154.437 457.246-156.562 468.922-1.358 7.469 0.667 15.155 5.533 20.982 4.866 5.829 12.064 9.197 19.654 9.197h114.443c-8.957 79.045-20.954 150.25-31.581 213.302-22.819 135.354-37.891 224.77 0.605 270.298 15.936 18.845 39.531 28.4 70.134 28.4 30.608 0 54.208-9.558 70.147-28.406 38.518-45.554 23.437-135.051 0.611-270.525zM620.062 460.8c12.688-59.962 45.166-198.998 96.738-323.424v144.227c0.010 63.296-3.242 123.046-8.334 179.197h-88.403zM773.451 962.534c-3.726 4.406-11 10.266-31.051 10.266-20.043 0-27.312-5.854-31.034-10.258-23.157-27.384-7.429-120.691 10.784-228.73 6.581-39.038 13.68-81.155 20.28-126.326 6.589 45.083 13.674 87.118 20.238 126.093 18.224 108.144 33.963 201.542 10.782 228.955z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dinner",
						"food",
						"fork",
						"knife"
					],
					"defaultCode": 59463,
					"grid": 20
				},
				{
					"id": 2143,
					"paths": [
						"M864 384l128-128-128-128h-288v-80c0-26.4-21.6-48-48-48h-32c-26.4 0-48 21.6-48 48v80h-320v256h320v64h-352l-96 96 96 96h352v384h128v-384h256v-192h-256v-64h288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"direction",
						"address",
						"road"
					],
					"defaultCode": 59978,
					"grid": 16
				},
				{
					"id": 255,
					"paths": [
						"M786.101 877.899l-102.4-102.4c-9.997-9.997-26.206-9.997-36.203 0-9.998 9.997-9.998 26.206 0 36.203l58.698 58.698h-475.795c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h475.795l-58.698 58.699c-9.998 9.997-9.998 26.206 0 36.203 5 4.998 11.55 7.498 18.102 7.498s13.102-2.499 18.101-7.499l102.4-102.4c9.998-9.997 9.998-26.205 0-36.202z",
						"M793.6 51.2h-435.2c-112.928 0-204.8 91.872-204.8 204.8s91.872 204.8 204.8 204.8h51.2v230.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-588.8h153.6v588.8c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-588.8h128c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6zM409.6 409.6h-51.2c-84.696 0-153.6-68.904-153.6-153.6s68.904-153.6 153.6-153.6h51.2v307.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"direction-ltr",
						"typography",
						"paragraph"
					],
					"defaultCode": 59552,
					"grid": 20
				},
				{
					"id": 256,
					"paths": [
						"M793.6 51.2h-435.2c-112.928 0-204.8 91.872-204.8 204.8s91.872 204.8 204.8 204.8h51.2v230.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-588.8h153.6v588.8c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-588.8h128c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6zM409.6 409.6h-51.2c-84.696 0-153.6-68.904-153.6-153.6s68.904-153.6 153.6-153.6h51.2v307.2z",
						"M742.4 870.4h-475.797l58.699-58.699c9.997-9.997 9.997-26.206 0-36.203s-26.206-9.997-36.205 0l-102.4 102.4c-9.997 9.997-9.997 26.206 0 36.203l102.4 102.4c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.102-7.499c9.997-9.997 9.997-26.206 0-36.203l-58.699-58.698h475.797c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"direction-rtl",
						"typography",
						"paragraph"
					],
					"defaultCode": 59553,
					"grid": 20
				},
				{
					"id": 435,
					"width": 1024,
					"paths": [
						"M864 64h-704c-35.36 0-64 28.64-64 64s28.64 64 64 64h2.56l54.368 679.648c4 49.888 45.664 88.352 95.712 88.352h398.72c50.048 0 91.712-38.464 95.68-88.352l54.4-679.648h2.56c35.36 0 64-28.64 64-64s-28.64-64-64-64zM805.344 491.328l0.032-0.032-11.936 149.312-24.768 24.768-105.376-105.376 105.376-105.376 36.672 36.704zM791.296 432l20.48-20.48-3.040 37.92-17.44-17.44zM218.72 492.576l37.952-37.952 105.376 105.376-105.376 105.376-26.24-26.24-11.712-146.56zM215.36 450.688l-3.264-40.608 21.952 21.92-18.688 18.688zM407.296 304l105.376-105.376 105.376 105.376-105.376 105.376-105.376-105.376zM618.048 560l-105.376 105.376-105.376-105.376 105.376-105.376 105.376 105.376zM490.048 432l-105.376 105.376-105.376-105.376 105.376-105.376 105.376 105.376zM384.672 582.624l105.376 105.376-105.376 105.376-105.376-105.376 105.376-105.376zM512.672 710.624l105.376 105.376-105.376 105.376-105.376-105.376 105.376-105.376zM535.296 688l105.376-105.376 105.376 105.376-105.376 105.376-105.376-105.376zM640.672 537.376l-105.376-105.376 105.376-105.376 105.376 105.376-105.376 105.376zM551.296 192h178.752l-89.376 89.376-89.376-89.376zM384.672 281.376l-89.376-89.376h178.752l-89.376 89.376zM250.048 192l112 112-105.376 105.376-48.48-48.48-13.536-168.896h55.392zM237.664 729.632l19.008-19.008 105.376 105.376-93.792 93.792c-10.848-10.496-18.144-24.704-19.424-40.672l-11.168-139.488zM297.376 925.92l87.296-87.296 89.376 89.376h-161.408c-5.28 0-10.336-0.864-15.264-2.080zM551.296 928l89.376-89.376 86.976 86.976c-5.248 1.408-10.624 2.4-16.288 2.4h-160.064zM775.168 869.088c-1.248 15.648-8.32 29.536-18.784 39.968l-93.088-93.056 105.376-105.376 17.76 17.76-11.264 140.704zM815.712 362.336l-47.040 47.040-105.376-105.376 112-112h54.048l-13.632 170.336zM864 160h-704c-17.632 0-32-14.368-32-32s14.368-32 32-32h704c17.632 0 32 14.368 32 32s-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"discard",
						"trash",
						"recycle"
					],
					"grid": 32
				},
				{
					"id": 436,
					"width": 1024,
					"paths": [
						"M489.376 688l-105.376 105.376-105.376-105.376 105.376-105.376 105.376 105.376zM489.376 432l-105.376-105.376-105.376 105.376 105.376 105.376 105.376-105.376zM406.624 816l105.376 105.376 105.376-105.376-105.376-105.376-105.376 105.376zM512 665.376l105.376-105.376-105.376-105.376-105.376 105.376 105.376 105.376zM617.376 304l-105.376-105.376-105.376 105.376 105.376 105.376 105.376-105.376zM928 128c0 35.36-28.64 64-64 64h-2.56l-54.368 679.648c-4 49.888-45.664 88.352-95.712 88.352h-398.72c-50.048 0-91.712-38.464-95.68-88.352l-54.4-679.648h-2.56c-35.36 0-64-28.64-64-64s28.64-64 64-64h704c35.36 0 64 28.64 64 64zM790.624 432l17.056-17.056c2.688-2.688 4.32-6.24 4.64-10.048 1.184-14.816-16.736-23.104-27.264-12.576l-17.056 17.056-105.376-105.376 84.704-84.704c10.080-10.048 2.912-27.296-11.328-27.296-4.256 0-8.32 1.696-11.328 4.672l-84.672 84.704-84.704-84.704c-2.976-2.976-7.040-4.672-11.296-4.672h-64c-4.256 0-8.32 1.696-11.328 4.672l-84.672 84.704-84.704-84.704c-2.976-2.976-7.040-4.672-11.296-4.672-14.24 0-21.408 17.248-11.328 27.296l84.704 84.704-105.376 105.376-17.024-17.024c-10.528-10.528-28.448-2.24-27.264 12.576 0.32 3.776 1.952 7.36 4.64 10.048l17.024 17.024-12.832 12.832c-3.328 3.328-5.024 7.904-4.64 12.576 1.088 13.6 17.6 19.68 27.264 10.048l12.832-12.832 105.376 105.376-105.376 105.376-2.464-2.464c-7.904-7.872-21.344-1.664-20.448 9.44l2.464 30.752c0.832 10.208 13.216 14.752 20.448 7.52l105.376 105.376-78.528 78.528c-7.488 7.488-5.76 20.032 3.456 25.248 6.24 3.52 14.080 2.464 19.168-2.624l78.528-78.528 84.704 84.672c2.976 3.008 7.040 4.704 11.296 4.704h64c4.256 0 8.32-1.696 11.328-4.672l84.672-84.704 78.528 78.528c5.088 5.088 12.928 6.144 19.168 2.624 9.216-5.216 10.944-17.76 3.456-25.248l-78.528-78.528 105.376-105.376c7.232 7.232 19.616 2.688 20.448-7.52l2.464-30.784c0.896-11.104-12.544-17.312-20.448-9.44l-2.464 2.496-105.376-105.376 105.376-105.376 12.832 12.832c9.664 9.664 26.176 3.552 27.264-10.048 0.384-4.672-1.312-9.28-4.64-12.576l-12.832-12.832zM534.624 432l105.376 105.376 105.376-105.376-105.376-105.376-105.376 105.376zM534.624 688l105.376 105.376 105.376-105.376-105.376-105.376-105.376 105.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"discard",
						"trash",
						"recycle"
					],
					"grid": 32
				},
				{
					"id": 1001,
					"width": 1024,
					"paths": [
						"M704 128v-96c0-17.664-14.336-32-32-32h-320c-17.664 0-32 14.336-32 32v96h-288c-17.664 0-32 14.336-32 32v160h40l115.456 677.376c2.624 15.392 15.968 26.624 31.552 26.624h649.984c15.584 0 28.928-11.232 31.552-26.624l115.456-677.376h40v-160c0-17.664-14.336-32-32-32h-288zM384 64h256v96h-256v-96zM64 192h896v64h-896v-64zM383.968 288l32 672h-95.84l-96-672h159.84zM416 288h192l-32 672h-127.936l-32.064-672zM640.032 288h159.84l-96 672h-95.872l32.032-672zM99.456 288h92.384l96 672h-73.824l-114.56-672zM809.984 960h-73.824l96-672h92.384l-114.56 672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"discard",
						"trash",
						"recycle"
					],
					"grid": 32
				},
				{
					"id": 437,
					"width": 1024,
					"paths": [
						"M908.224 704h-76.224v-128h64c17.664 0 32-14.336 32-32v-256c0-17.664-14.336-32-32-32h-64v-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v32h-32v-96c0-17.664-14.336-32-32-32h-128v-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v32h-128c-17.664 0-32 14.336-32 32v96h-32v-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v32h-64c-17.664 0-32 14.336-32 32v256c0 17.664 14.336 32 32 32h64v128h-55.008c-20.832 0-36.096 19.552-31.040 39.776l35.872 143.52c10.688 42.72 49.088 72.704 93.12 72.704h569.728c36.352 0 69.6-20.544 85.856-53.056l78.304-156.608c10.656-21.312-4.832-46.336-28.608-46.336zM768 224h32v32h-32v-32zM896 288v256h-224v-256h224zM800 576v128h-32v-128h32zM736 576v128h-192v-128h192zM480 96h32v32h-32v-32zM320 160h352v96c-17.664 0-32 14.336-32 32v256h-320v-384zM512 576v128h-32v-128h32zM448 576v128h-192v-128h192zM192 224h32v32h-32v-32zM96 544v-256h192v256h-192zM224 576v128h-32v-128h32zM829.92 892.608c-10.912 21.824-32.864 35.392-57.248 35.392h-569.728c-29.408 0-54.944-19.936-62.080-48.48l-35.872-143.52h803.232l-78.304 156.608zM256 832c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32 32 14.336 32 32zM352 832c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32 32 14.336 32 32zM448 832c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32 32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"discover",
						"float",
						"sail",
						"ship",
						"explore",
						"colonize"
					],
					"grid": 32
				},
				{
					"id": 438,
					"width": 1024,
					"paths": [
						"M908.224 704h-803.232c-20.832 0-36.096 19.552-31.040 39.776l35.872 143.52c10.688 42.72 49.088 72.704 93.12 72.704h569.728c36.352 0 69.6-20.544 85.856-53.056l78.304-156.608c10.656-21.312-4.832-46.336-28.608-46.336zM224 864c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM320 864c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM416 864c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM320 160c0-17.664 14.336-32 32-32h128v-32c0-17.664 14.336-32 32-32s32 14.336 32 32v32h128c17.664 0 32 14.336 32 32v64c-35.296 0-64 28.704-64 64v288h-96v96h-64v-96h-128c-17.632 0-32-14.368-32-32v-384zM752 256h16v-32c0-17.664 14.336-32 32-32s32 14.336 32 32v32h64c17.664 0 32 14.336 32 32v256c0 17.664-14.336 32-32 32h-64v96h-64v-96h-64c-17.632 0-32-14.368-32-32v-256c0-17.632 14.368-32 32-32h48zM64 544v-256c0-17.664 14.336-32 32-32h96v-32c0-17.664 14.336-32 32-32s32 14.336 32 32v32h32v320h-32v96h-64v-96h-96c-17.664 0-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"discover",
						"float",
						"sail",
						"ship",
						"explore",
						"colonize"
					],
					"grid": 32
				},
				{
					"id": 439,
					"width": 1024,
					"paths": [
						"M528 640h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM528 704h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM496 224h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM496 288h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM496 352h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM704 384v-224c0-53.024-42.976-96-96-96h-448c-53.024 0-96 42.976-96 96v288c0 53.024 42.976 96 96 96h128l32 32v192c0 53.024 42.976 96 96 96h128l73.376 73.376c12.512 12.512 32.768 12.512 45.248 0l73.376-73.376h128c53.024 0 96-42.976 96-96v-288c0-53.024-42.976-96-96-96h-160zM301.248 512h-141.248c-35.36 0-64-28.64-64-64v-288c0-35.36 28.64-64 64-64h448c35.36 0 64 28.64 64 64v288c0 35.36-28.64 64-64 64h-141.248l-82.752 82.752-82.752-82.752zM864 832h-141.248l-82.752 82.752-82.752-82.752h-141.248c-35.36 0-64-28.64-64-64v-160l9.376 9.376c12.512 12.512 32.768 12.512 45.248 0l73.376-73.376h128c53.024 0 96-42.976 96-96v-32h160c35.36 0 64 28.64 64 64v288c0 35.36-28.64 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"discuss",
						"chat",
						"converse",
						"talk",
						"message"
					],
					"grid": 32
				},
				{
					"id": 440,
					"width": 1024,
					"paths": [
						"M384 640l96-96h128c52.928 0 96-43.072 96-96v-288c0-52.928-43.072-96-96-96h-448c-52.928 0-96 43.072-96 96v288c0 52.928 43.072 96 96 96h128l96 96zM272 224h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16zM272 288h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16zM272 384c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224zM864 384h-128v64c0 70.592-57.408 128-128 128h-114.752l-86.624 86.624c-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376l-41.376-41.376v146.752c0 53.024 42.976 96 96 96h128l73.376 73.376c12.512 12.512 32.768 12.512 45.248 0l73.376-73.376h128c53.024 0 96-42.976 96-96v-288c0-53.024-42.976-96-96-96zM752 704h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16zM752 640h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"discuss",
						"chat",
						"converse",
						"talk",
						"message"
					],
					"grid": 32
				},
				{
					"id": 441,
					"width": 1024,
					"paths": [
						"M448 525.248c6.24 6.24 6.24 16.384 0 22.624s-16.384 6.24-22.624 0l-30.848-30.848c-49.984-49.984-131.040-49.984-181.024 0l-30.848 30.848c-6.24 6.24-16.384 6.24-22.624 0s-6.24-16.384 0-22.624l30.848-30.848c62.496-62.496 163.808-62.496 226.272 0l30.848 30.848zM406.624 570.496c12.512 12.512 12.512 32.768 0 45.248l-23.424 23.424c-21.856 21.856-51.2 33.568-82.24 32.768-29.664-0.768-57.6-14.208-78.56-35.168l-21.024-21.024c-12.512-12.512-12.512-32.768 0-45.248l23.424-23.424c21.152-21.152 49.28-32.8 79.2-32.8s58.048 11.648 79.2 32.8l23.424 23.424zM384 593.152l-23.424-23.424c-15.616-15.616-36.096-23.424-56.576-23.424s-40.96 7.808-56.576 23.424l-23.424 23.424 23.424 23.424c15.616 15.616 36.096 23.424 56.576 23.424s40.96-7.808 56.576-23.424l23.424-23.424zM960 190.72v321.28c0 274.368-165.6 307.040-350.080 318.112l-3.2 0.096c-17.216 0-36.992-8.16-59.904-17.6-10.976-4.544-29.344-12.096-34.4-12.608-5.888 0.512-24.288 8.096-35.264 12.608-22.912 9.44-42.688 17.6-59.904 17.6l-3.168-0.096c-184.48-11.072-350.080-43.744-350.080-318.112v-321.28c0-13.312 5.28-25.632 14.88-34.752 9.024-8.576 20.8-13.28 33.184-13.28 9.824 0 19.328 3.008 27.456 8.704l227.264 159.104c46.464 4.704 94.496 9.504 145.216 9.504s98.752-4.8 145.216-9.504l227.264-159.104c8.128-5.696 17.632-8.704 27.488-8.704 26.464 0 48.032 21.568 48.032 48.032zM928 190.72c0-9.44-7.744-16.032-16.064-16.032-3.072 0-6.24 0.896-9.12 2.912l-234.080 163.872c-48.384 4.928-101.28 10.528-156.736 10.528s-108.352-5.6-156.736-10.496l-234.080-163.872c-2.88-2.016-6.048-2.912-9.12-2.912-8.32-0.032-16.064 6.56-16.064 16v321.28c0 232 120.64 274.208 320 286.176 0.416 0.032 0.832 0.032 1.248 0.032 21.696 0 73.408-30.208 94.752-30.208s73.056 30.208 94.752 30.208c0.448 0 0.864 0 1.248-0.032 199.36-11.968 320-54.176 320-286.176v-321.28zM833.152 494.4c-62.496-62.496-163.808-62.496-226.272 0l-30.88 30.848c-6.24 6.24-6.24 16.384 0 22.624s16.384 6.24 22.624 0l30.848-30.848c49.984-49.984 131.040-49.984 181.024 0l30.848 30.848c6.24 6.24 16.384 6.24 22.624 0s6.24-16.384 0-22.624l-30.816-30.848zM822.624 570.496c12.512 12.512 12.512 32.768 0 45.248l-23.424 23.424c-21.856 21.856-51.2 33.568-82.24 32.768-29.664-0.768-57.6-14.208-78.56-35.168l-21.024-21.024c-12.512-12.512-12.512-32.768 0-45.248l23.424-23.424c21.152-21.152 49.28-32.8 79.2-32.8s58.048 11.648 79.2 32.8l23.424 23.424zM800 593.152l-23.424-23.424c-15.616-15.616-36.096-23.424-56.576-23.424s-40.96 7.808-56.576 23.424l-23.424 23.424 23.424 23.424c15.616 15.616 36.096 23.424 56.576 23.424s40.96-7.808 56.576-23.424l23.424-23.424z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"disguise",
						"wear",
						"mask"
					],
					"grid": 32
				},
				{
					"id": 442,
					"width": 1024,
					"paths": [
						"M776.576 569.696l23.424 23.456-23.424 23.424c-15.616 15.616-36.096 23.424-56.576 23.424s-40.96-7.808-56.576-23.424l-23.424-23.424 23.424-23.424c15.616-15.616 36.096-23.424 56.576-23.424 20.48-0.032 40.96 7.776 56.576 23.392zM304 546.272c-20.48 0-40.96 7.808-56.576 23.424l-23.424 23.456 23.424 23.424c15.616 15.616 36.096 23.424 56.576 23.424s40.96-7.808 56.576-23.424l23.424-23.424-23.424-23.424c-15.616-15.648-36.096-23.456-56.576-23.456zM960 190.72v321.28c0 274.368-165.6 307.040-350.080 318.112l-3.2 0.096c-17.216 0-36.992-8.16-59.904-17.6-10.976-4.544-29.344-12.096-34.4-12.608-5.888 0.512-24.288 8.096-35.264 12.608-22.912 9.44-42.688 17.6-59.904 17.6l-3.168-0.096c-184.48-11.072-350.080-43.744-350.080-318.112v-321.28c0-13.312 5.28-25.632 14.88-34.752 9.024-8.576 20.8-13.28 33.184-13.28 9.824 0 19.328 3.008 27.456 8.704l227.264 159.104c46.464 4.704 94.496 9.504 145.216 9.504s98.752-4.8 145.216-9.504l227.264-159.104c8.128-5.696 17.632-8.704 27.488-8.704 26.464 0 48.032 21.568 48.032 48.032zM406.624 570.496l-23.424-23.424c-21.152-21.152-49.28-32.8-79.2-32.8s-58.048 11.648-79.2 32.8l-23.424 23.424c-12.512 12.512-12.512 32.768 0 45.248l21.024 21.056c20.96 20.992 48.896 34.4 78.56 35.168 31.040 0.832 60.352-10.88 82.24-32.768l23.424-23.424c12.512-12.512 12.512-32.768 0-45.28zM448 525.248l-30.848-30.848c-62.496-62.496-163.808-62.496-226.272 0l-30.88 30.848c-6.24 6.24-6.24 16.384 0 22.624s16.384 6.24 22.624 0l30.848-30.848c49.984-49.984 131.040-49.984 181.024 0l30.848 30.848c6.24 6.24 16.384 6.24 22.624 0s6.272-16.384 0.032-22.624zM822.624 570.496l-23.424-23.424c-21.152-21.152-49.28-32.8-79.2-32.8s-58.048 11.648-79.2 32.8l-23.424 23.424c-12.512 12.512-12.512 32.768 0 45.248l21.024 21.056c20.96 20.992 48.896 34.4 78.56 35.168 31.040 0.832 60.352-10.88 82.24-32.768l23.424-23.424c12.512-12.512 12.512-32.768 0-45.28zM864 525.248l-30.848-30.848c-62.496-62.496-163.808-62.496-226.272 0l-30.88 30.848c-6.24 6.24-6.24 16.384 0 22.624s16.384 6.24 22.624 0l30.848-30.848c49.984-49.984 131.040-49.984 181.024 0l30.848 30.848c6.24 6.24 16.384 6.24 22.624 0s6.272-16.384 0.032-22.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"disguise",
						"wear",
						"mask"
					],
					"grid": 32
				},
				{
					"id": 1002,
					"width": 1024,
					"paths": [
						"M448 800h128v32h-128v-32zM960 544c0 53.024-32.384 98.592-78.432 118.016-42.304 210.432-175.072 329.984-369.568 329.984s-327.264-119.552-369.568-329.984c-46.048-19.424-78.432-64.992-78.432-118.016 0-48.896 27.552-91.488 67.968-113.024 24.128-250.848 163.808-398.976 380.032-398.976s355.904 148.128 380.032 398.976c40.416 21.536 67.968 64.128 67.968 113.024zM203.296 382.912c264.032-11.040 359.456-120 360.416-121.152 3.296-3.904 8.544-6.016 13.344-5.664 5.088 0.352 9.76 3.104 12.48 7.392 3.040 4.8 74.72 114.848 231.264 120.032-29.856-166.752-124-287.52-308.8-287.52-184.576 0-278.72 120.48-308.704 286.912zM194.848 448h634.304c-0.864-10.912-2.048-21.6-3.392-32.224-142.496-2.368-223.264-83.776-251.68-119.264-36.512 32.864-146.848 110.72-375.776 118.688-1.376 10.816-2.56 21.696-3.456 32.8zM766.272 576l5.824-32h-200.192l5.824 32h188.544zM583.552 608l5.824 32h165.28l5.824-32h-176.928zM777.92 512l5.824-32h-223.488l5.824 32h211.84zM446.272 576l5.824-32h-200.192l5.824 32h188.544zM263.552 608l5.824 32h165.28l5.824-32h-176.928zM457.92 512l5.824-32h-223.488l5.824 32h211.84zM896 544c0-35.36-28.64-64-64-64-0.288 0-15.744 0-15.744 0l-34.912 192h-218.72l-34.912-192h-31.456l-34.912 192h-218.688l-34.912-192h-15.744c-35.36 0-64 28.64-64 64 0 36.192 30.528 67.296 70.24 63.36 24.096 183.712 121.824 320.64 313.76 320.64s289.664-136.928 313.76-320.64c39.68 3.904 70.24-27.136 70.24-63.36z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"disguise",
						"hide",
						"wear",
						"mask"
					],
					"grid": 32
				},
				{
					"id": 2211,
					"paths": [
						"M512 416.496c-52.662 0-95.504 42.842-95.504 95.504s42.842 95.504 95.504 95.504 95.504-42.842 95.504-95.504-42.842-95.504-95.504-95.504z",
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM679 512c0 92.084-74.916 167-167 167s-167-74.916-167-167 74.916-167 167-167 167 74.916 167 167zM132.074 749.456l211.23-132.020c16.032 25.558 37.704 47.228 63.26 63.262l-132.018 211.23c-57.598-36.076-106.398-84.876-142.472-142.472zM680.698 406.564c-16.034-25.558-37.704-47.23-63.262-63.26l132.020-211.23c57.598 36.076 106.396 84.876 142.472 142.472l-211.23 132.018z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"disk",
						"disc",
						"record",
						"cd album",
						"save"
					],
					"defaultCode": 60046,
					"grid": 16
				},
				{
					"id": 2212,
					"paths": [
						"M512 416.496c-52.662 0-95.504 42.842-95.504 95.504s42.842 95.504 95.504 95.504c52.662 0 95.504-42.842 95.504-95.504s-42.842-95.504-95.504-95.504zM512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM878.884 247.968c-3.846-5.334-7.8-10.6-11.884-15.774 4.086 5.174 8.040 10.438 11.884 15.774zM853.516 215.952c-2.28-2.626-4.592-5.232-6.936-7.812 2.348 2.578 4.654 5.186 6.936 7.812zM845.86 207.354c-2.248-2.466-4.52-4.916-6.832-7.338 2.312 2.42 4.58 4.872 6.832 7.338zM201.022 840.008c2.786 2.642 5.604 5.236 8.45 7.796-2.842-2.562-5.666-5.154-8.45-7.796zM209.852 848.156c2.936 2.636 5.904 5.232 8.898 7.79-2.994-2.558-5.964-5.15-8.898-7.79zM272.4 895.36c-3.824-2.392-7.606-4.852-11.356-7.36h15.956l-4.6 7.36zM287 872h-48.34c3.598 2.736 7.232 5.42 10.904 8.046-10.57-7.548-20.822-15.57-30.75-24.046h78.186l-10 16zM261.008 887.974c-3.784-2.53-7.524-5.126-11.23-7.772 3.704 2.652 7.446 5.244 11.23 7.772zM307 840h-105.986c-2.906-2.758-5.786-5.546-8.626-8.388-4.884-4.884-9.61-9.89-14.244-14.962 2.252 2.472 4.528 4.928 6.844 7.352h132.012l-10 15.998zM170.446 808.004c2.292 2.64 4.618 5.258 6.972 7.854-2.36-2.592-4.68-5.214-6.972-7.854zM327 808h-156.558c-8.944-10.302-17.39-20.96-25.326-31.964 3.894 5.402 7.896 10.73 12.034 15.964h179.85l-10 16zM347 776h-201.908c-5.74-7.964-11.248-16.086-16.452-24.4 1.768 2.826 3.594 5.616 5.426 8.4h222.934l-10 16zM367 744h-226.202l25.602-16h210.6l-10 16zM387 712h-195l25.6-16h179.4l-10 16zM847.912 302.054l9.688-6.054h-210.6l-10 16h195l-25.6 16h-179.4l-10 16h163.798l-25.598 16h-143.092c7.33 4.836 14.292 10.184 20.828 16h96.664l-25.6 16h-55.186c4.468 5.090 8.658 10.43 12.542 16h17.042l-12.044 7.53c17.52 27.97 27.658 61.034 27.658 96.472 0 100.52-81.488 182.006-182.012 182.006-35.436 0-68.5-10.136-96.47-27.654l-8.53 13.646h-163.8l25.6-16h143.092c-7.33-4.836-14.29-10.184-20.828-16h-96.664l63.248-39.53c-17.518-27.968-27.658-61.034-27.658-96.47 0-100.52 81.488-182.006 182.010-182.006 35.438 0 68.5 10.136 96.468 27.654l143.132-229.008c7.698 4.818 15.234 9.884 22.63 15.162-3.718-2.66-7.476-5.262-11.276-7.802l-25.954 16h48.34c-3.608-2.744-7.252-5.434-10.932-8.068 10.58 7.556 20.842 15.584 30.78 24.068h-78.188l-10 16h105.984c-2.776-2.634-5.586-5.222-8.422-7.774 5.796 5.232 11.492 10.606 17.048 16.162 2.508 2.506 4.96 5.056 7.402 7.612h-132.012l-10 16h156.558c4.552 5.246 8.998 10.57 13.292 16h-179.85l-10 16h201.908c5.74 7.964 11.246 16.086 16.452 24.4l-47.448 29.654zM805.268 168.070c2.986 2.552 5.95 5.138 8.876 7.772-2.93-2.632-5.89-5.22-8.876-7.772zM667 264l-10 16h226.2l12.16-7.6c-1.77-2.826-3.594-5.616-5.426-8.4h-222.934zM345.6 616l-25.6 16h55.186c-4.468-5.090-8.658-10.43-12.544-16h-17.042z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"disk",
						"disc",
						"record",
						"cd album",
						"save",
						"dualtone"
					],
					"defaultCode": 60047,
					"grid": 16
				},
				{
					"id": 2184,
					"paths": [
						"M0 64v640h1024v-640h-1024zM960 640h-896v-512h896v512zM672 768h-320l-32 128-64 64h512l-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"display",
						"screen",
						"monitor",
						"computer",
						"desktop",
						"pc"
					],
					"defaultCode": 60019,
					"grid": 16
				},
				{
					"id": 2185,
					"paths": [
						"M0 64v640h1024v-640h-1024zM960 640h-896v-512h896v512zM672 768h-320l-32 128-64 64h512l-64-64zM96 456h832v16h-832zM96 424h832v16h-832zM96 488h832v16h-832zM96 392h832v16h-832zM96 520h832v16h-832zM96 584h832v16h-832zM96 552h832v16h-832zM96 200h832v16h-832zM96 360h832v16h-832zM96 232h832v16h-832zM96 168h832v16h-832zM96 328h832v16h-832zM96 296h832v16h-832zM96 264h832v16h-832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"display",
						"screen",
						"monitor",
						"computer",
						"desktop",
						"pc",
						"dualtone"
					],
					"defaultCode": 60020,
					"grid": 16
				},
				{
					"id": 2186,
					"paths": [
						"M96 472h570l-28-16h-542zM96 440h514l-28-16h-486zM96 408h458l-28-16h-430zM96 376h402l-28-16h-374zM96 504h626l-28-16h-598zM96 536h682l-28-16h-654zM96 568h738l-28-16h-710zM96 184h66l-28-16h-38zM96 584v16h794l-28-16zM96 216h122l-28-16h-94zM96 248h178l-28-16h-150zM96 312h290l-28-16h-262zM96 280h234l-28-16h-206zM96 344h346l-28-16h-318zM0 64v640h1024v-640h-1024zM960 640h-896v-512h896v512zM672 768h-320l-32 128-64 64h512l-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"display",
						"screen",
						"monitor",
						"computer",
						"desktop",
						"pc",
						"dualtone"
					],
					"defaultCode": 60021,
					"grid": 16
				},
				{
					"id": 2187,
					"paths": [
						"M1024 832v-768h-1024v768h448v64h-192v64h512v-64h-192v-64h448zM128 192h768v512h-768v-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"display",
						"screen",
						"monitor",
						"computer",
						"desktop",
						"pc"
					],
					"defaultCode": 60022,
					"grid": 16
				},
				{
					"id": 443,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 96c218.592 0 397.92 169.568 414.368 384h-414.368v-384zM512 928c-229.376 0-416-186.624-416-416 0-218.592 169.568-397.92 384-414.368v406.112c0 5.632 1.472 11.136 4.288 16l210.88 365.216c-55.36 27.296-117.376 43.040-183.168 43.040zM723.296 869.728l-190.944-330.752 270.208 270.208c-23.808 23.264-50.496 43.456-79.264 60.544zM824.416 785.792l-273.792-273.792h377.376c0 104.864-39.328 200.544-103.584 273.792z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"divide",
						"chart",
						"visualize",
						"split",
						"diagram",
						"graph",
						"share"
					],
					"grid": 32
				},
				{
					"id": 444,
					"width": 1024,
					"paths": [
						"M531.36 537.984l293.952 293.952c-25.792 25.248-54.752 47.168-86.016 65.632l-207.936-359.584zM484.288 520.512c-2.816-4.864-4.288-10.368-4.288-16v-438.912c-232.416 16.48-416 209.792-416 446.4 0 247.424 200.576 448 448 448 71.648 0 139.104-17.248 199.168-47.136l-226.88-392.352zM550.624 512l296.544 296.544c69.984-79.040 112.832-182.656 112.832-296.544h-409.376zM512 480h446.4c-16.48-232.416-209.792-416-446.4-416v416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"divide",
						"chart",
						"visualize",
						"split",
						"diagram",
						"graph",
						"share"
					],
					"grid": 32
				},
				{
					"id": 1003,
					"width": 1024,
					"paths": [
						"M512 0c-282.784 0-512 229.216-512 512s229.216 512 512 512 512-229.216 512-512-229.216-512-512-512zM512 960c-247.040 0-448-200.96-448-448s200.96-448 448-448c247.040 0 448 200.96 448 448s-200.96 448-448 448zM512 96c-229.76 0-416 186.24-416 416s186.24 416 416 416 416-186.24 416-416-186.24-416-416-416zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384zM670.4 308.352c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-316.768 316.768c-12.512 12.512-12.512 32.768 0 45.248l45.248 45.248c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l316.768-316.768c12.512-12.512 12.512-32.768 0-45.248l-45.248-45.248zM376.224 693.024l-45.248-45.248 316.736-316.768c0 0 0 0 0.032 0l45.248 45.248-316.768 316.768zM430.848 416c35.36 0 64-28.64 64-64s-28.64-64-64-64-64 28.64-64 64 28.672 64 64 64zM430.848 320c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM593.152 608c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.672-64-64-64zM593.152 704c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"divide",
						"split"
					],
					"grid": 32
				},
				{
					"id": 1004,
					"width": 1024,
					"paths": [
						"M896 0h-768c-17.664 0-32 14.336-32 32v960c0 17.664 14.336 32 32 32h768c17.664 0 32-14.336 32-32v-960c0-17.664-14.336-32-32-32zM864 960h-704v-896h704v896zM352 224h-96v96h96v-96zM320 288h-32v-32h32v32zM352 384h-96v96h96v-96zM320 448h-32v-32h32v32zM352 544h-96v96h96v-96zM320 608h-32v-32h32v32zM352 704h-96v96h96v-96zM320 768h-32v-32h32v32zM768 288h-352v-32h352v32zM768 448h-352v-32h352v32zM768 608h-352v-32h352v32zM768 768h-352v-32h352v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"do",
						"finish",
						"plan",
						"complete",
						"list"
					],
					"grid": 32
				},
				{
					"id": 1485,
					"width": 580.0010757446289,
					"paths": [
						"M558.857 677.143q0 87.429-56.857 150.571t-147.714 78v100q0 8-5.143 13.143t-13.143 5.143h-77.143q-7.429 0-12.857-5.429t-5.429-12.857v-100q-37.714-5.143-72.857-17.714t-58-25.429-42.286-27.429-26.571-21.429-10-10.286q-9.714-12-1.143-23.429l58.857-77.143q4-5.714 13.143-6.857 8.571-1.143 13.714 5.143l1.143 1.143q64.571 56.571 138.857 71.429 21.143 4.571 42.286 4.571 46.286 0 81.429-24.571t35.143-69.714q0-16-8.571-30.286t-19.143-24-33.429-21.429-37.714-18.286-45.714-18.571q-22.286-9.143-35.143-14.286t-35.143-15.143-35.714-17.714-32.286-20.286-30.571-24.286-24.857-28-20.286-33.143-12-38-4.857-44.571q0-78.857 56-138.286t145.714-76.571v-102.857q0-7.429 5.429-12.857t12.857-5.429h77.143q8 0 13.143 5.143t5.143 13.143v100.571q32.571 3.429 63.143 13.143t49.714 19.143 36.286 21.429 22.286 16.571 8.571 8q9.714 10.286 2.857 21.714l-46.286 83.429q-4.571 8.571-13.143 9.143-8 1.714-15.429-4-1.714-1.714-8.286-6.857t-22.286-15.143-33.429-18.286-42.571-14.857-48.857-6.571q-54.286 0-88.571 24.571t-34.286 63.429q0 14.857 4.857 27.429t16.857 23.714 22.571 18.857 32 17.714 34.571 15.429 40 15.714q30.286 11.429 46.286 18t43.429 20 43.143 24.286 35.429 28.571 30.286 36.286 18 43.714 7.429 53.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dollar",
						"usd"
					],
					"defaultCode": 61781,
					"grid": 14
				},
				{
					"id": 1542,
					"width": 877.7139282226562,
					"paths": [
						"M585.143 512q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429 42.857-103.429 103.429-42.857 103.429 42.857 42.857 103.429zM438.857 201.143q-84.571 0-156 41.714t-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156-41.714-156-113.143-113.143-156-41.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dot-circle-o"
					],
					"defaultCode": 61842,
					"grid": 14
				},
				{
					"id": 2915,
					"paths": [
						"M832 64h128v128h-128zM832 320h128v128h-128zM576 320h128v128h-128zM832 576h128v128h-128zM576 576h128v128h-128zM320 576h128v128h-128zM576 832h128v128h-128zM320 832h128v128h-128zM64 832h128v128h-128zM832 832h128v128h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dots",
						"resize-handle"
					],
					"defaultCode": 60750,
					"grid": 16
				},
				{
					"id": 2204,
					"paths": [
						"M512 576l256-256h-192v-256h-128v256h-192zM744.726 471.272l-71.74 71.742 260.080 96.986-421.066 157.018-421.066-157.018 260.080-96.986-71.742-71.742-279.272 104.728v256l512 192 512-192v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store",
						"arrow"
					],
					"defaultCode": 60039,
					"grid": 16
				},
				{
					"id": 2724,
					"paths": [
						"M512 319.992v-320h-64v320h-160l192 192 192-192z",
						"M704 345.6v68.93l173.004 69.202-397.004 211.732-397.004-211.732 173.004-69.202v-68.93l-256 102.4v320l480 256 480-256v-320l-256-102.4zM448 934.4l-384-204.8v-183.466l384 204.8v183.466zM896 729.6l-384 204.8v-183.466l384-204.8v183.466z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store"
					],
					"defaultCode": 60559,
					"grid": 16
				},
				{
					"id": 1203,
					"width": 950.8569869995117,
					"paths": [
						"M731.429 768q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM877.714 768q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM950.857 640v182.857q0 22.857-16 38.857t-38.857 16h-841.143q-22.857 0-38.857-16t-16-38.857v-182.857q0-22.857 16-38.857t38.857-16h265.714l77.143 77.714q33.143 32 77.714 32t77.714-32l77.714-77.714h265.143q22.857 0 38.857 16t16 38.857zM765.143 314.857q9.714 23.429-8 40l-256 256q-10.286 10.857-25.714 10.857t-25.714-10.857l-256-256q-17.714-16.571-8-40 9.714-22.286 33.714-22.286h146.286v-256q0-14.857 10.857-25.714t25.714-10.857h146.286q14.857 0 25.714 10.857t10.857 25.714v256h146.286q24 0 33.714 22.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download"
					],
					"defaultCode": 61465,
					"grid": 14
				},
				{
					"id": 196,
					"paths": [
						"M760.499 493.901c-9.995-9.997-26.206-9.997-36.203 0l-212.296 212.294v-578.195c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v578.195l-212.298-212.294c-9.998-9.997-26.206-9.997-36.205 0-9.997 9.995-9.997 26.206 0 36.203l256 256c5 4.997 11.55 7.496 18.102 7.496s13.102-2.499 18.102-7.501l256-256c9.997-9.995 9.997-26.203-0.003-36.198z",
						"M896 972.8h-819.2c-42.347 0-76.8-34.451-76.8-76.8v-102.4c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v102.4c0 14.115 11.485 25.6 25.6 25.6h819.2c14.115 0 25.6-11.485 25.6-25.6v-102.4c0-14.139 11.461-25.6 25.6-25.6s25.6 11.461 25.6 25.6v102.4c0 42.349-34.451 76.8-76.8 76.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"down",
						"arrow"
					],
					"defaultCode": 59493,
					"grid": 20
				},
				{
					"id": 445,
					"width": 1024,
					"paths": [
						"M768 288c0-141.376-114.624-256-256-256-119.712 0-219.936 82.304-247.936 193.312-112.448 11.968-200.064 107.072-200.064 222.688 0 123.712 100.288 224 224 224h128v128h-18.752c-28.512 0-42.784 34.464-22.624 54.624l114.752 114.752c12.512 12.512 32.768 12.512 45.248 0l114.752-114.752c20.16-20.16 5.888-54.624-22.624-54.624h-18.752v-128h160c106.048 0 192-85.952 192-192s-85.952-192-192-192zM626.752 832l-114.752 114.752-114.752-114.752h50.752v-224h128v224h50.752zM768 640h-160v-32h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v32h-128c-105.856 0-192-86.144-192-192 0-98.432 73.696-180.48 171.424-190.848l22.176-2.368 5.472-21.632c25.12-99.584 114.336-169.152 216.928-169.152 123.52 0 224 100.48 224 224v32h32c88.224 0 160 71.776 160 160s-71.776 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"load",
						"sync",
						"transfer"
					],
					"grid": 32
				},
				{
					"id": 446,
					"width": 1024,
					"paths": [
						"M649.376 854.624l-114.752 114.752c-12.512 12.512-32.768 12.512-45.248 0l-114.752-114.752c-20.16-20.16-5.888-54.624 22.624-54.624h18.752v-192h192v192h18.752c28.512 0 42.784 34.464 22.624 54.624zM768 288c0-141.376-114.624-256-256-256-119.712 0-219.936 82.304-247.936 193.312-112.448 11.968-200.064 107.072-200.064 222.688 0 123.712 100.288 224 224 224h96v-64h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16h288c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16v64h128c106.048 0 192-85.952 192-192s-85.952-192-192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"load",
						"sync",
						"transfer"
					],
					"grid": 32
				},
				{
					"id": 1005,
					"width": 1024,
					"paths": [
						"M992 384h-352v-288c0-17.696-14.336-32-32-32h-192c-17.664 0-32 14.304-32 32v288h-352c-17.664 0-32 14.304-32 32v512c0 17.696 14.336 32 32 32h960c17.664 0 32-14.304 32-32v-512c0-17.696-14.336-32-32-32zM448 448v-320h128v320h82.752l-146.752 146.752-146.752-146.752h82.752zM64 448h256l64 64h-320v-64zM64 544h352l64 64h-416v-64zM960 896h-896v-64h896v64zM960 800h-896v-64h896v64zM960 704h-896v-64h896v64zM960 608h-416l64-64h352v64zM960 512h-320l64-64h256v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"stack",
						"transfer"
					],
					"grid": 32
				},
				{
					"id": 2706,
					"paths": [
						"M160 448l352 352 352-352h-224v-384h-256v384z",
						"M896 512v384h-768v-384h-128v416c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-416h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store"
					],
					"defaultCode": 60541,
					"grid": 16
				},
				{
					"id": 2707,
					"paths": [
						"M160 448l352 352 352-352h-224v-384h-256v384z",
						"M18.178 984h987.644c3.614-4.998 6.754-10.352 9.366-16h-1006.376c2.61 5.648 5.754 11.002 9.366 16z",
						"M57.79 1016h908.422c9.194-4.024 17.638-9.45 25.078-16h-958.58c7.44 6.55 15.886 11.976 25.080 16z",
						"M3.058 952h1017.882c1.346-5.178 2.24-10.53 2.698-16h-1023.276c0.456 5.47 1.352 10.822 2.696 16z",
						"M1016 904v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-784v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-8v16h1024v-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store",
						"dualtone"
					],
					"defaultCode": 60542,
					"grid": 16
				},
				{
					"id": 2712,
					"paths": [
						"M896 704v128h-768v-128h-128v256h1024v-256zM768 384h-192v-320h-128v320h-192l256 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store",
						"inbox",
						"arrow"
					],
					"defaultCode": 60547,
					"grid": 16
				},
				{
					"id": 2714,
					"paths": [
						"M128 768h768v192h-768v-192z",
						"M640 384v-320h-256v320h-224l352 352 352-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store",
						"arrow"
					],
					"defaultCode": 60549,
					"grid": 16
				},
				{
					"id": 2716,
					"paths": [
						"M192 1024h640c106.038 0 192-85.962 192-192h-1024c0 106.038 85.962 192 192 192zM832 896h64v64h-64v-64zM800 256l-288 288-288-288h224v-256h128v256zM1022.8 737.23c4.908 16.924-5.694 30.77-23.56 30.77h-974.482c-17.864 0-28.466-13.846-23.558-30.77l112.084-322.462c4.908-16.922 23.542-30.768 41.406-30.768h69.31l256 256h64l256-256h69.31c17.866 0 36.498 13.846 41.406 30.768l112.084 322.462z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store"
					],
					"defaultCode": 60551,
					"grid": 16
				},
				{
					"id": 2718,
					"paths": [
						"M896 512h-160l-224 224-224-224h-160l-128 256v64h1024v-64l-128-256zM0 896h1024v64h-1024v-64zM576 320v-256h-128v256h-224l288 288 288-288h-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store"
					],
					"defaultCode": 60553,
					"grid": 16
				},
				{
					"id": 2720,
					"paths": [
						"M736 448l-256 256-256-256h160v-384h192v384zM480 704h-480v256h960v-256h-480zM896 832h-128v-64h128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store"
					],
					"defaultCode": 60555,
					"grid": 16
				},
				{
					"id": 2722,
					"paths": [
						"M800 384h-224v-256h-128v256h-224l288 256zM743.098 532.632l-33.61 29.576c111.74 22.382 186.512 63.174 186.512 109.792 0 70.694-171.922 128-384 128s-384-57.306-384-128c0-46.618 74.772-87.41 186.51-109.792l-33.608-29.576c-166.658 31.67-280.902 96.512-280.902 171.368 0 106.040 229.23 192 512 192s512-85.96 512-192c0-74.856-114.242-139.698-280.902-171.368z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"download",
						"save",
						"store",
						"arrow"
					],
					"defaultCode": 60557,
					"grid": 16
				},
				{
					"id": 2888,
					"width": 1344,
					"paths": [
						"M544 1024h608c11.034 0 21.288-5.684 27.136-15.040l160-256c9.172-14.68 5.014-33.988-9.386-43.586l-96-64c-13.608-9.074-31.864-6.422-42.334 6.136l-103.416 124.108v-487.618c0-17.672-14.328-32-32-32h-128c-17.672 0-32 14.328-32 32v199.016l-359.762 89.942c-14.244 3.56-24.238 16.358-24.238 31.042v384c0 17.674 14.326 32 32 32zM1134.264 960h-558.264v-327.016l64-16v183.016c0 17.674 14.326 32 32 32s32-14.326 32-32v-199.016l64-16v151.016c0 17.674 14.326 32 32 32s32-14.326 32-32v-167.016l64-16v247.016c0 17.674 14.328 32 32 32s32-14.326 32-32v-480h64v544c0 13.472 8.438 25.502 21.106 30.088 12.666 4.594 26.85 0.746 35.476-9.602l141.592-169.91 46.22 30.81-134.13 214.614z",
						"M768.030 444.038c5.252 0 10.578-1.294 15.496-4.024 15.458-8.576 21.034-28.054 12.458-43.508-18.308-32.99-27.984-70.51-27.984-108.506 0-123.514 100.486-224 224-224s224 100.486 224 224c0 37.996-9.674 75.516-27.978 108.5-8.576 15.454-3 34.932 12.454 43.508s34.932 2.998 43.506-12.456c23.564-42.462 36.018-90.718 36.018-139.552 0-158.804-129.196-288-288-288s-288 129.196-288 288c0 48.834 12.458 97.090 36.020 139.558 5.846 10.534 16.76 16.48 28.010 16.48z",
						"M32 256l224-224v160h384v128h-384v160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drag-left",
						"finger",
						"pointer",
						"hand",
						"touch"
					],
					"defaultCode": 60723,
					"grid": 16
				},
				{
					"id": 2887,
					"width": 1344,
					"paths": [
						"M256 192v-160l-224 224 224 224v-160h256v-128z",
						"M1088 192v-160l224 224-224 224v-160h-256v-128z",
						"M1120.004 1024h-608c-11.036 0-21.29-5.684-27.136-15.040l-160-256c-9.172-14.68-5.014-33.988 9.386-43.586l96-64c13.608-9.074 31.864-6.422 42.334 6.134l103.416 124.108v-487.616c0-17.672 14.328-32 32-32h128c17.672 0 32 14.328 32 32v199.016l359.762 89.942c14.244 3.56 24.236 16.36 24.236 31.042v384c0 17.674-14.324 32-31.998 32v0zM529.74 960h558.264v-327.016l-64-16v183.016c0 17.674-14.326 32-32 32-17.676 0-32-14.326-32-32v-199.016l-64-16v151.016c0 17.674-14.326 32-32 32s-32-14.326-32-32v-167.016l-64-16v247.016c0 17.674-14.328 32-32 32s-32-14.326-32-32v-480h-64v544c0 13.472-8.44 25.502-21.108 30.088-12.666 4.594-26.85 0.746-35.474-9.602l-141.592-169.91-46.22 30.81 134.13 214.614z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drag-left-right",
						"finger",
						"pointer",
						"touch",
						"hand"
					],
					"defaultCode": 60722,
					"grid": 16
				},
				{
					"id": 2889,
					"width": 1344,
					"paths": [
						"M800 1024h-608c-11.034 0-21.288-5.684-27.136-15.040l-160-256c-9.172-14.68-5.014-33.988 9.386-43.586l96-64c13.608-9.074 31.864-6.422 42.334 6.136l103.416 124.108v-487.618c0-17.672 14.328-32 32-32h128c17.672 0 32 14.328 32 32v199.016l359.762 89.942c14.244 3.56 24.238 16.358 24.238 31.042v384c0 17.674-14.326 32-32 32zM209.736 960h558.264v-327.016l-64-16v183.016c0 17.674-14.326 32-32 32s-32-14.326-32-32v-199.016l-64-16v151.016c0 17.674-14.326 32-32 32s-32-14.326-32-32v-167.016l-64-16v247.016c0 17.674-14.328 32-32 32s-32-14.326-32-32v-480h-64v544c0 13.472-8.438 25.502-21.106 30.088-12.666 4.594-26.85 0.746-35.476-9.602l-141.592-169.91-46.22 30.81 134.13 214.614z",
						"M575.97 444.038c-5.252 0-10.578-1.294-15.496-4.024-15.458-8.576-21.034-28.054-12.458-43.508 18.308-32.99 27.984-70.51 27.984-108.506 0-123.514-100.486-224-224-224s-224 100.486-224 224c0 37.996 9.674 75.516 27.978 108.5 8.576 15.454 3 34.932-12.454 43.508s-34.932 2.998-43.506-12.456c-23.564-42.462-36.018-90.718-36.018-139.552 0-158.804 129.196-288 288-288s288 129.196 288 288c0 48.834-12.458 97.090-36.020 139.558-5.846 10.534-16.76 16.48-28.010 16.48z",
						"M1312 256l-224-224v160h-384v128h384v160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drag-right",
						"finger",
						"pointer",
						"hand",
						"touch"
					],
					"defaultCode": 60724,
					"grid": 16
				},
				{
					"id": 447,
					"width": 1024,
					"paths": [
						"M512 192c-46.24 0-96 65.088-96 208s49.76 208 96 208 96-65.088 96-208-49.76-208-96-208zM512 576c-26.56 0-64-54.624-64-176s37.44-176 64-176 64 54.624 64 176-37.44 176-64 176zM416 0c-53.024 0-96 42.976-96 96v672c0 14.176 9.344 25.792 22.112 30.016l129.952 194.944c8.896 13.376 23.84 21.376 39.936 21.376s31.040-8 39.936-21.376l129.952-194.944c12.768-4.224 22.112-15.84 22.112-30.016v-672c0-53.024-42.976-96-96-96h-192zM416 32h192c35.36 0 64 28.64 64 64v0h-320c0-35.36 28.64-64 64-64zM352 128h320v544h-320v-544zM352 704h320v64h-320v-64zM525.312 975.2c-6.048 9.056-20.576 9.056-26.624 0l-116.8-175.2h260.192l-116.768 175.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"draw",
						"play",
						"color"
					],
					"grid": 32
				},
				{
					"id": 448,
					"width": 1024,
					"paths": [
						"M704 704v64h-384v-64h384zM608 0h-192c-53.024 0-96 42.976-96 96h384c0-53.024-42.976-96-96-96zM343.424 800l128.64 192.928c8.896 13.376 23.84 21.376 39.936 21.376s31.040-8 39.936-21.376l128.64-192.928h-337.152zM512 224c-26.56 0-64 54.624-64 176s37.44 176 64 176 64-54.624 64-176-37.44-176-64-176zM704 128v544h-384v-544h384zM608 400c0-142.912-49.76-208-96-208s-96 65.088-96 208 49.76 208 96 208 96-65.088 96-208z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"draw",
						"play",
						"color"
					],
					"grid": 32
				},
				{
					"id": 2196,
					"paths": [
						"M1016.988 652.010l-256-320c-6.074-7.592-15.266-12.010-24.988-12.010h-448c-9.72 0-18.916 4.418-24.988 12.010l-256 320c-4.538 5.674-7.012 12.724-7.012 19.99v288c0 35.346 28.654 64 64 64h896c35.348 0 64-28.654 64-64v-288c0-7.266-2.472-14.316-7.012-19.99zM960 704h-224l-128 128h-192l-128-128h-224v-20.776l239.38-299.224h417.24l239.38 299.224v20.776z",
						"M736 512h-448c-17.672 0-32-14.328-32-32s14.328-32 32-32h448c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M800 640h-576c-17.672 0-32-14.326-32-32s14.328-32 32-32h576c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drawer",
						"box",
						"inbox",
						"archive",
						"category"
					],
					"defaultCode": 60031,
					"grid": 16
				},
				{
					"id": 2199,
					"paths": [
						"M1016.988 652.010l-256-320c-11.040-13.798-31.176-16.036-44.978-4.998-13.8 11.040-16.038 31.176-4.998 44.978l248.988 311.234v20.776h-224l-128 128h-192l-128-128h-224v-20.776l248.988-311.234c11.042-13.8 8.804-33.938-4.998-44.978s-33.94-8.804-44.978 4.998l-256 320c-4.538 5.674-7.012 12.724-7.012 19.99v288c0 35.346 28.654 64 64 64h896c35.348 0 64-28.654 64-64v-288c0-7.266-2.472-14.316-7.012-19.99z",
						"M512 736l224-224h-160v-320h-128v320h-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drawer-in",
						"box",
						"inbox",
						"archive",
						"category"
					],
					"defaultCode": 60034,
					"grid": 16
				},
				{
					"id": 2198,
					"paths": [
						"M1016.988 652.010l-256-320c-11.040-13.798-31.176-16.036-44.978-4.998-13.8 11.040-16.038 31.176-4.998 44.978l248.988 311.234v20.776h-224l-128 128h-192l-128-128h-224v-20.776l248.988-311.234c11.042-13.8 8.804-33.938-4.998-44.978s-33.94-8.804-44.978 4.998l-256 320c-4.538 5.674-7.012 12.724-7.012 19.99v288c0 35.346 28.654 64 64 64h896c35.348 0 64-28.654 64-64v-288c0-7.266-2.472-14.316-7.012-19.99z",
						"M512 32l-224 224h160v320h128v-320h160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drawer-out",
						"box",
						"outbox",
						"archive",
						"category"
					],
					"defaultCode": 60033,
					"grid": 16
				},
				{
					"id": 2197,
					"paths": [
						"M1016.988 652.010l-256-320c-6.074-7.592-15.266-12.010-24.988-12.010h-448c-9.72 0-18.916 4.418-24.988 12.010l-256 320c-4.538 5.674-7.012 12.724-7.012 19.99v288c0 35.346 28.654 64 64 64h896c35.348 0 64-28.654 64-64v-288c0-7.266-2.472-14.316-7.012-19.99zM960 704h-224l-128 128h-192l-128-128h-224v-20.776l239.38-299.224h417.24l239.38 299.224v20.776z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drawer",
						"box",
						"inbox",
						"archive",
						"category"
					],
					"defaultCode": 60032,
					"grid": 16
				},
				{
					"id": 2200,
					"paths": [
						"M898.496 0l67.244 571.56-75.48 8.88-60.052-510.44h-636.416l-60.052 510.44-75.48-8.88 67.242-571.56zM256 128h512v64h-512zM256 256h512v64h-512zM256 384h512v64h-512zM256 512h512v64h-512zM992 640h-960c-17.6 0-27.446 13.66-21.88 30.358l107.76 323.284c5.566 16.698 24.52 30.358 42.12 30.358h704c17.6 0 36.552-13.66 42.12-30.358l107.762-323.286c5.566-16.696-4.282-30.356-21.882-30.356zM640 768h-256v-64h256v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drawer",
						"box",
						"inbox",
						"archive",
						"category"
					],
					"defaultCode": 60035,
					"grid": 16
				},
				{
					"id": 3355,
					"paths": [
						"M512 1024c-282.4 0-512-229.6-512-512s229.6-512 512-512c282.4 0 512 229.6 512 512s-229.6 512-512 512v0zM943.8 582c-15-4.8-135.4-40.6-272.4-18.6 57.2 157.2 80.4 285.2 85 311.8 98-66.4 168-171.4 187.4-293.2v0zM682.8 915.2c-6.6-38.4-31.8-172-93.2-331.6-1 0.4-2 0.6-2.8 1-246.8 86-335.4 257-343.2 273 74.2 57.8 167.4 92.4 268.4 92.4 60.6 0 118.4-12.4 170.8-34.8v0zM187 805c10-17 130-215.6 355.4-288.6 5.6-1.8 11.4-3.6 17.2-5.2-11-24.8-23-49.8-35.4-74.2-218.2 65.4-430.2 62.6-449.4 62.4-0.2 4.4-0.2 8.8-0.2 13.4 0 112.2 42.6 214.8 112.4 292.2v0zM84 423c19.6 0.2 199.8 1 404.4-53.2-72.4-128.8-150.6-237.2-162.2-253-122.4 57.8-214 170.6-242.2 306.2v0zM409.6 87.4c12 16.2 91.6 124.4 163.2 256 155.6-58.2 221.4-146.8 229.2-158-77.2-68.6-178.8-110.2-290-110.2-35.2 0.2-69.6 4.4-102.4 12.2v0zM850.6 236.2c-9.2 12.4-82.6 106.4-244.2 172.4 10.2 20.8 20 42 29 63.4 3.2 7.6 6.4 15 9.4 22.6 145.6-18.2 290.2 11 304.6 14-1-103.2-38-198-98.8-272.4v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dribbble",
						"brand",
						"social"
					],
					"defaultCode": 61190,
					"grid": 16
				},
				{
					"id": 1523,
					"width": 877.7139282226562,
					"paths": [
						"M585.143 857.143q-24-137.714-80-284.571h-1.143l-1.143 0.571q-9.143 3.429-24.571 9.429t-57.714 28-78.286 46.857-74.857 65.429-58.857 84.571l-8.571-6.286q105.143 85.714 238.857 85.714 75.429 0 146.286-29.714zM479.429 510.286q-12-28-30.286-63.429-177.714 53.143-384.571 53.143-0.571 4-0.571 12 0 70.857 25.143 135.143t70.857 115.143q28.571-50.857 70.571-95.143t81.429-71.143 74.571-46.286 56.857-27.429l21.143-7.429q2.286-0.571 7.429-2t7.429-2.571zM418.286 389.143q-68.571-121.714-139.429-216-78.857 37.143-133.714 106.286t-73.143 155.429q172.571 0 346.286-45.714zM809.143 571.429q-120-34.286-233.714-16.571 49.714 136.571 73.143 268 63.429-42.857 105.714-108.286t54.857-143.143zM349.143 148q-0.571 0-1.143 0.571 0.571-0.571 1.143-0.571zM686.286 230.857q-105.714-93.714-247.429-93.714-43.429 0-88.571 10.857 74.857 97.143 140.571 218.286 39.429-14.857 74.286-34.571t55.143-35.143 37.429-32.571 21.429-23.143zM813.714 508q-1.714-132.571-85.143-234.286l-0.571 0.571q-5.143 6.857-10.857 14t-24.857 25.429-40.571 34.571-57.143 37.143-75.143 36.857q14.286 30.286 25.143 54.286 1.143 3.429 3.714 10t4.286 9.429q20.571-2.857 42.571-4t42-1.143 39.429 0.857 36.571 2.286 32.286 3.143 27.429 3.714 20.857 3.429 14.286 2.571zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dribbble"
					],
					"defaultCode": 61821,
					"grid": 14
				},
				{
					"id": 449,
					"width": 1024,
					"paths": [
						"M976 192h-112v-12.224c0-12.128-6.848-23.2-17.696-28.608l-46.304-23.168c0-17.664-14.336-32-32-32h-32v-32c0-17.664-14.336-32-32-32h-640c-17.664 0-32 14.336-32 32v288c0 17.664 14.336 32 32 32h128l-96 384h-32c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h320c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32h-32l56-224h47.008c29.376 0 54.976-20 62.080-48.48l27.904-111.52h159.008c17.664 0 32-14.336 32-32v-32h32c17.664 0 32-14.336 32-32l46.304-23.168c10.848-5.408 17.696-16.48 17.696-28.608v-12.224h112c8.832 0 16-7.168 16-16s-7.168-16-16-16zM384 800v160h-320v-160h320zM319.008 768h-190.016l96-384h190.016l-96 384zM486.048 487.744c-3.552 14.272-16.352 24.256-31.040 24.256h-39.008l32-128h64l-25.952 103.744zM704 352h-640v-32h48c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-48v-32h640v288zM832 236.224l-64 32v19.776h-32v-160h32v19.776l64 32v56.448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drill",
						"bore",
						"pierce"
					],
					"grid": 32
				},
				{
					"id": 450,
					"width": 1024,
					"paths": [
						"M416 800v160c0 17.664-14.336 32-32 32h-320c-17.664 0-32-14.336-32-32v-160c0-17.664 14.336-32 32-32h320c17.664 0 32 14.336 32 32zM736 64v288c0 17.664-14.336 32-32 32h-159.008l-27.872 111.52c-7.136 28.48-32.736 48.48-62.112 48.48h-47.008l-48 192h-256l88-352h-128c-17.664 0-32-14.336-32-32v-288c0-17.664 14.336-32 32-32h640c17.664 0 32 14.336 32 32zM128 304c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM128 240c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM128 176c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM128 112c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM512 384h-64l-32 128h39.008c14.688 0 27.488-9.984 31.040-24.256l25.952-103.744zM976 192h-112v-12.224c0-12.128-6.848-23.2-17.696-28.608l-46.304-23.168c0-17.664-14.336-32-32-32v224c17.664 0 32-14.336 32-32l46.304-23.168c10.848-5.408 17.696-16.48 17.696-28.608v-12.224h112c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drill",
						"bore",
						"pierce"
					],
					"grid": 32
				},
				{
					"id": 1006,
					"width": 1024,
					"paths": [
						"M1014.24 152.864c-8.16-24.544-27.328-43.072-50.944-50.784l26.4-56.544c4.64-9.92 3.872-21.504-1.984-30.72s-16.064-14.816-26.976-14.816h-896c-10.944 0-21.12 5.568-27.008 14.816-5.888 9.216-6.624 20.8-1.984 30.72l50.528 108.288c-20.096 6.816-36.32 20.992-45.792 39.968-9.536 19.104-11.104 40.8-4.352 61.024 10.88 32.736 41.408 54.752 75.904 54.752 8.64 0 17.152-1.376 25.312-4.128l17.024-5.664 22.368 47.968c-39.584 15.232-60.672 59.264-47.136 99.904 10.944 32.768 41.44 54.752 75.936 54.752 8.64 0 17.152-1.376 25.312-4.128l13.984-4.672 22.496 48.192c-37.696 16.224-57.376 59.072-44.192 98.72 10.912 32.736 41.408 54.72 75.904 54.72 8.64 0 17.152-1.376 25.312-4.128l10.944-3.648 22.624 48.448c-35.808 17.152-54.144 58.784-41.312 97.408 10.88 32.736 41.408 54.752 75.904 54.752 8.64 0 17.152-1.376 25.312-4.128l7.936-2.656 57.984 124.224c5.216 11.296 16.544 18.496 28.992 18.496s23.744-7.2 28.992-18.464l89.984-192.864 72.864-24.288c41.824-13.952 64.544-59.328 50.592-101.152-7.2-21.632-22.944-38.592-42.72-47.584l43.072-92.256 78.56-26.208c20.288-6.752 36.704-20.992 46.272-40.128 9.536-19.104 11.104-40.8 4.352-61.024-7.648-23.072-25.056-40.832-46.784-49.312l41.376-88.608 84.352-28.096c41.824-13.952 64.544-59.328 50.592-101.152zM660.48 64.064l-542.112 180.704c-1.6 0.544-3.296 0.8-4.992 0.8-5.728 0-12.64-3.392-15.168-10.944-1.824-5.472-0.256-10.016 0.864-12.224 1.088-2.208 3.776-6.176 9.216-8l451.168-150.4 101.024 0.064zM934.624 162.944c1.664-0.544 3.392-0.832 5.088-0.832 5.728 0 12.608 3.392 15.136 10.944 2.784 8.384-1.76 17.44-10.112 20.224l-732.864 244.288c-1.632 0.576-3.296 0.832-4.992 0.832-5.728 0-12.64-3.392-15.168-10.944-2.784-8.384 1.76-17.44 10.112-20.224l732.8-244.288zM805.088 430.112c1.664-0.544 3.392-0.832 5.088-0.832 5.728 0 12.608 3.36 15.136 10.944 2.784 8.384-1.728 17.472-10.112 20.256l-509.824 169.952c-1.632 0.544-3.328 0.832-5.024 0.832-5.728 0-12.672-3.392-15.168-10.944-1.344-4.064-1.056-8.416 0.864-12.256 1.088-2.208 3.776-6.176 9.248-8l509.792-169.952zM397.504 823.264c-1.632 0.544-3.328 0.832-5.024 0.832-5.728 0-12.64-3.392-15.168-10.944-2.784-8.384 1.76-17.44 10.112-20.224l286.848-95.584c1.632-0.544 3.328-0.832 5.024-0.832 5.728 0 12.64 3.392 15.136 10.976 2.784 8.384-1.76 17.44-10.112 20.224l-286.816 95.552zM622.976 680.672l-190.4 63.456-49.6-105.824 307.36-102.464-67.36 144.832zM746.752 415.84l-404.416 134.816-49.824-106.208 521.664-173.888-67.424 145.28zM870.080 150.72l-618.016 206.016-49.984-106.144 559.744-186.592h148.64l-40.384 86.72zM458.272 64l-296.672 98.88-46.624-98.88h343.296zM512.736 916.32l-39.488-84.576 93.472-31.136-53.984 115.712z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drill",
						"bore",
						"pierce",
						"dig"
					],
					"grid": 32
				},
				{
					"id": 451,
					"width": 1024,
					"paths": [
						"M932.672 187.328c10.080-10.080 2.944-27.328-11.296-27.328h-130.752l65.568-65.568c2.56 0.64 5.056 1.568 7.808 1.568 20.128 0 35.936-18.592 31.136-39.552-2.656-11.552-12.032-20.96-23.616-23.584-20.928-4.768-39.52 11.008-39.52 31.136 0 2.752 0.928 5.248 1.568 7.808l-88.192 88.192h-642.752c-14.24 0-21.376 17.248-11.296 27.328l404.672 404.672v336h-160c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h352c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-160v-336l404.672-404.672zM758.624 192h124.128l-32 32h-124.128l32-32zM141.248 192h572.128l-32 32h-1.888c-13.12-9.248-26.848-14.016-40.992-14.016-15.872 0-29.408 5.888-41.472 14.016h-423.776l-32-32zM659.936 337.952c-15.456 15.456-30.112 28.064-46.464 28.064-10.080 0-20.8-4.8-32.736-16.736-31.232-31.232-13.664-54.208 11.328-79.2 15.456-15.456 30.112-28.064 46.464-28.064 10.080 0 20.8 4.8 32.736 16.736 31.232 31.232 13.664 54.208-11.328 79.2zM512 562.752l-306.752-306.752h355.872c-19.136 20.64-46.56 58.72-14.336 102.592l-98.784 98.784c-6.24 6.24-6.24 16.384 0 22.624s16.384 6.24 22.624 0l98.592-98.592c14.112 10.88 28.928 16.576 44.288 16.576 29.216 0 50.976-19.328 69.088-37.44 16.32-16.32 56.416-56.544 27.136-104.544h109.024l-306.752 306.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drink",
						"consume",
						"hydrate",
						"sip",
						"imbibe"
					],
					"grid": 32
				},
				{
					"id": 452,
					"width": 1024,
					"paths": [
						"M91.328 187.328c-10.080-10.080-2.944-27.328 11.296-27.328h642.752l88.192-88.192c-0.64-2.56-1.568-5.056-1.568-7.808 0-20.128 18.592-35.904 39.52-31.136 11.552 2.624 20.96 12.032 23.616 23.584 4.8 20.96-11.008 39.552-31.136 39.552-2.752 0-5.248-0.928-7.808-1.568l-65.568 65.568h130.752c14.24 0 21.408 17.248 11.328 27.328l-36.704 36.672h-216.576c-13.088-9.216-26.784-14.016-40.928-14.016-15.872 0-29.408 5.888-41.472 14.016h-469.024l-36.672-36.672zM580.736 349.248c11.936 11.936 22.656 16.736 32.736 16.736 16.32 0 31.008-12.608 46.464-28.064 24.992-24.992 42.56-47.968 11.328-79.2-11.936-11.936-22.656-16.736-32.736-16.736-16.32 0-31.008 12.608-46.464 28.064-24.992 24.992-42.56 47.968-11.328 79.2zM688 928h-160v-336l336-336h-154.24c29.28 48-10.816 88.224-27.168 104.576-18.112 18.112-39.872 37.44-69.088 37.44-15.36 0-30.176-5.696-44.288-16.576l-98.688 98.688c-3.136 3.136-7.232 4.672-11.328 4.672s-8.192-1.568-11.328-4.672c-6.24-6.24-6.24-16.384 0-22.624l98.912-98.912c-32.192-43.84-4.864-81.952 14.336-102.592h-401.12l336 336v336h-160c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h352c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drink",
						"consume",
						"hydrate",
						"sip",
						"imbibe"
					],
					"grid": 32
				},
				{
					"id": 1007,
					"width": 1024,
					"paths": [
						"M863.328 570.56c7.2-16.48 13.248-33.504 18.112-51.040 19.808-14.56 40.928-29.312 64.32-44.896 70.304-46.848 85.152-122.688 68.672-177.056-13.536-44.704-47.424-73.568-86.432-73.568-10.976 0-21.664 1.376-32 4.16v-4.16c0-105.056-193.184-160-384-160s-384 54.944-384 160v192c0 53.184 11.2 105.952 32.64 154.592-103.968 41.44-160.64 99.456-160.64 165.408 0 127.712 220.128 224 512 224s512-96.288 512-224c0-65.952-56.704-123.968-160.672-165.44zM928 288c11.52 0 20.96 14.112 25.184 28.096 9.632 31.744 0.064 76.608-42.944 105.28-17.344 11.584-33.28 22.656-48.64 33.632 1.408-12.832 2.4-25.792 2.4-39.008v-86.272l20.736-24.32c13.76-11.712 27.936-17.408 43.264-17.408zM395.648 713.824c-123.712-48.384-203.648-165.28-203.648-297.824v-138.912c55.52 44.16 177.76 74.912 320 74.912s264.48-30.752 320-74.912v138.912c0 22.432-2.464 44.384-6.88 65.664l-0.128 0.096 0.096 0.096c-21.664 104.352-94.016 191.808-196.736 232l-20.352 7.936v28.928c-14.048 6.944-43.744 17.28-96 17.28-52.544 0-82.304-10.464-96-17.152v-29.056l-20.352-7.968zM512 128c192.384 0 320 57.792 320 96s-127.616 96-320 96-320-57.792-320-96 127.616-96 320-96zM512 896c-264 0-448-84.32-448-160 0-41.28 57.984-86.208 151.328-117.28l7.328-2.432c39.616 56.992 95.68 101.696 161.312 127.36v24.352c0 0 32 32 128 32s128-32 128-32v-24.352c65.632-25.664 121.696-70.368 161.312-127.36l7.328 2.432c93.376 31.072 151.392 76 151.392 117.28 0 75.68-184 160-448 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drink",
						"consume",
						"hydrate",
						"sip"
					],
					"grid": 32
				},
				{
					"id": 2214,
					"paths": [
						"M192 896h640c106.038 0 192-85.96 192-192h-1024c0 106.040 85.962 192 192 192zM832 768h64v64h-64v-64zM960 128h-896l-64 512h1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drive",
						"save",
						"hdd",
						"hard-disk"
					],
					"defaultCode": 60049,
					"grid": 16
				},
				{
					"id": 453,
					"width": 1024,
					"paths": [
						"M844.288 576.608c-24.192-113.888-70.72-222.432-138.784-318.4h-0.032c1.856-31.776-1.6-104.096-58.944-176.256-5.6-7.040-16.128-7.648-22.848-1.696-6.272 5.536-7.392 15.104-2.176 21.632 50.88 64.096 53.632 127.488 52.096 154.112h-145.6c-8.832 0-16 7.168-16 16s7.168 16 16 16h59.808c48.448 134.912 44.992 283.456-11.808 416h-125.344l-54.176-208.128c-7.36-28.192-32.8-47.872-61.952-47.872h-206.528c-35.36 0-64 28.64-64 64v113.184c-39.2 35.136-64 86.016-64 142.816 0 106.048 85.952 192 192 192 83.552 0 154.464-53.472 180.832-128h278.336c26.4 74.528 97.28 128 180.832 128 106.048 0 192-85.952 192-192 0-101.888-79.424-185.024-179.712-191.392zM128 480h206.528c14.56 0 27.296 9.856 30.976 23.936l2.080 8.064h-271.584c0-17.632 14.368-32 32-32zM192 928c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.776 160-160 160zM642.88 800h-261.76c1.76-10.432 2.88-21.088 2.88-32 0-106.048-85.952-192-192-192-35.008 0-67.744 9.536-96 25.888v-57.888h279.936l49.984 192h171.2l8.32-19.392c58.144-135.68 63.84-289.408 17.024-428.608h64.896c60.512 88.288 102.048 186.176 124.64 289.056-96.672 10.016-172 91.68-172 190.944 0 10.912 1.12 21.568 2.88 32zM832 928c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.776 160-160 160zM832 672c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM832 832c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64zM192 672c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM192 832c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drive",
						"ride",
						"scoot"
					],
					"grid": 32
				},
				{
					"id": 454,
					"width": 1024,
					"paths": [
						"M400.672 512h-336.672c0-35.36 28.64-64 64-64h206.528c29.12 0 54.592 19.68 61.92 47.872l4.224 16.128zM832 704c-35.296 0-64 28.704-64 64s28.704 64 64 64 64-28.704 64-64-28.704-64-64-64zM192 704c-35.296 0-64 28.704-64 64s28.704 64 64 64 64-28.704 64-64-28.704-64-64-64zM1024 768c0 106.048-85.952 192-192 192-83.552 0-154.464-53.472-180.832-128h-278.336c-26.4 74.528-97.28 128-180.832 128-106.048 0-192-85.952-192-192 0-56.8 24.8-107.68 64-142.816v-81.184h344.992l41.664 160h125.344c56.8-132.544 60.288-281.088 11.808-416h-59.808c-8.832 0-16-7.168-16-16s7.168-16 16-16h145.6c1.536-26.624-1.216-90.016-52.096-154.080-5.184-6.56-4.064-16.096 2.176-21.632 6.752-5.952 17.248-5.344 22.848 1.696 57.344 72.16 60.8 144.48 58.944 176.256h0.032c68.096 95.968 114.592 204.512 138.784 318.4 100.288 6.336 179.712 89.472 179.712 191.36zM288 768c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96zM928 768c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drive",
						"ride",
						"scoot"
					],
					"grid": 32
				},
				{
					"id": 1008,
					"width": 1024,
					"paths": [
						"M192 640c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM192 736c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM832 640c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM832 736c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM960 448v-64c0-17.664-14.336-32-32-32h-256c-17.664 0-32 14.336-32 32v64c0 62.016-26.656 123.872-45.568 160h-165.92c-66.528-130.016 19.488-320 19.488-320h32.32c17.504 0 31.68-14.176 31.68-31.68v-0.64c0-17.504-14.176-31.68-31.68-31.68h-160.32c-53.024 88.352-118.432 218.336-137.824 288.512-115.424 5.856-204.032 113.28-177.44 234.848 17.824 81.504 91.936 148.64 187.264 148.64 83.552 0 154.464-53.472 180.832-128 14.336 0 278.336 0 278.336 0 26.4 74.528 97.28 128 180.832 128 106.048 0 192-85.952 192-192 0-96-64-256-64-256zM704 416h192v32h-192v-32zM192 832c-70.592 0-128-57.408-128-128s57.408-128 128-128c70.592 0 128 57.408 128 128s-57.408 128-128 128zM832 832c-54.016 0-102.432-34.304-120.512-85.344l-15.104-42.656h-344.384c0-72.32-48.288-132.736-114.176-152.544l6.048-21.952c15.36-55.584 66.208-159.68 112.832-241.536h22.304c-23.36 62.752-71.616 223.84-7.488 349.152l17.856 34.88h243.808l17.952-34.336c20.576-39.296 44.352-96.288 50.944-157.664h201.696c18.272 47.456 56.224 159.424 56.224 224 0 70.592-57.408 128-128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drive",
						"ride",
						"scoot"
					],
					"grid": 32
				},
				{
					"id": 99,
					"paths": [
						"M512 1024c-82.619 0-159.64-33.55-216.877-94.472-58.013-61.747-89.962-146.387-89.963-238.328 0-150.678 66.979-258.499 137.893-372.653 54.789-88.197 111.443-179.397 144.248-299.683 3.038-11.138 13.155-18.864 24.699-18.864s21.661 7.726 24.699 18.864c32.813 120.317 89.56 211.536 144.438 299.752 71 114.131 138.062 221.933 138.062 372.584 0 92.131-31.749 176.763-89.395 238.301-57.085 60.938-134.437 94.499-217.805 94.499zM512.003 108.208c-34.509 90.949-80.589 165.125-125.459 237.355-69.856 112.451-130.184 209.566-130.184 345.635 0 160.539 109.902 281.6 255.64 281.6 145.944 0 256-121.061 256-281.6 0-136.027-60.4-233.117-130.338-345.539-44.95-72.254-91.112-146.461-125.659-237.451z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drop",
						"droplet",
						"water",
						"color",
						"liquid"
					],
					"defaultCode": 59396,
					"grid": 20
				},
				{
					"id": 1009,
					"width": 1024,
					"paths": [
						"M825.568 780.32c8.576-8.576 11.552-21.248 7.744-32.736l-67.872-203.648c-1.568-4.704-4.224-8.992-7.744-12.512l-316.768-316.768 22.592-22.656c12.512-12.512 12.512-32.736 0-45.248l-67.872-67.872c-12.512-12.512-32.736-12.512-45.248 0l-22.656 22.624-54.592-54.624c-30.24-30.208-70.4-46.88-113.152-46.88-42.72 0-82.912 16.672-113.12 46.88-30.208 30.176-46.88 70.368-46.88 113.12s16.672 82.944 46.848 113.12l54.656 54.656-22.624 22.624c-12.512 12.512-12.512 32.736 0 45.248l67.872 67.872c12.512 12.512 32.736 12.512 45.248 0l22.624-22.624 316.8 316.768c3.52 3.52 7.808 6.144 12.512 7.712l203.648 67.872c3.328 1.12 6.72 1.664 10.112 1.664 8.352 0 16.544-3.296 22.624-9.376l45.248-45.216zM169.376 395.648l-22.624-22.624 22.624-22.624c12.512-12.512 12.512-32.736 0-45.248l-77.248-77.28c-18.144-18.112-28.128-42.208-28.128-67.872s9.984-49.76 28.128-67.872c36.256-36.224 99.456-36.288 135.776 0l77.248 77.248c12.512 12.512 32.736 12.512 45.248 0l22.656-22.624 22.624 22.624-226.304 226.272zM749.056 766.304l-177.728-59.232-17.28-17.28 45.248-45.248-22.624-22.624-45.248 45.248-22.624-22.624 45.248-45.248-22.624-22.624-45.248 45.248-22.624-22.624 45.248-45.248-22.624-22.624-45.248 45.248-22.624-22.624 45.248-45.248-22.624-22.624-45.248 45.248-22.656-22.624 45.248-45.248-22.624-22.624-45.248 45.248-22.624-22.624 45.248-45.248-22.624-22.624-45.248 45.248-22.624-22.624 45.248-45.248-22.624-22.656-45.248 45.248-22.624-22.624 135.776-135.776 334.080 334.048 59.232 177.728-17.312 17.28zM888.896 920.896c0 35.36-28.64 64-64 64s-64-28.64-64-64c0-20.64 21.824-49.92 40-70.72 12.704-14.528 35.296-14.528 48 0 18.176 20.8 40 50.080 40 70.72z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drop",
						"drip"
					],
					"grid": 32
				},
				{
					"id": 3362,
					"paths": [
						"M736 32l-224 192 288 192 224-192z",
						"M512 224l-224-192-288 192 224 192z",
						"M800 416l224 192-288 160-224-192z",
						"M512 576l-288-160-224 192 288 160z",
						"M728.156 845.57l-216.156-185.278-216.158 185.278-135.842-75.468v93.898l352 160 352-160v-93.898z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dropbox",
						"brand"
					],
					"defaultCode": 61197,
					"grid": 16
				},
				{
					"id": 1506,
					"width": 1024,
					"paths": [
						"M229.714 404l282.286 174.286-195.429 162.857-280-182.286zM793.143 721.143v61.714l-280 167.429v0.571l-0.571-0.571-0.571 0.571v-0.571l-279.429-167.429v-61.714l84 54.857 195.429-162.286v-1.143l0.571 0.571 0.571-0.571v1.143l196 162.286zM316.571 67.429l195.429 162.857-282.286 173.714-193.143-154.286zM794.286 404l193.143 154.857-279.429 182.286-196-162.857zM708 67.429l279.429 182.286-193.143 154.286-282.286-173.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dropbox"
					],
					"defaultCode": 61803,
					"grid": 14
				},
				{
					"id": 1865,
					"paths": [
						"M864.626 473.162c-65.754-183.44-205.11-348.15-352.626-473.162-147.516 125.012-286.87 289.722-352.626 473.162-40.664 113.436-44.682 236.562 12.584 345.4 65.846 125.14 198.632 205.438 340.042 205.438s274.196-80.298 340.040-205.44c57.27-108.838 53.25-231.962 12.586-345.398zM738.764 758.956c-43.802 83.252-132.812 137.044-226.764 137.044-55.12 0-108.524-18.536-152.112-50.652 13.242 1.724 26.632 2.652 40.112 2.652 117.426 0 228.668-67.214 283.402-171.242 44.878-85.292 40.978-173.848 23.882-244.338 14.558 28.15 26.906 56.198 36.848 83.932 22.606 63.062 40.024 156.34-5.368 242.604z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"droplet",
						"color",
						"water"
					],
					"defaultCode": 59700,
					"grid": 16
				},
				{
					"id": 1867,
					"paths": [
						"M864.626 473.162c-65.754-183.44-205.11-348.15-352.626-473.162-147.516 125.012-286.87 289.722-352.626 473.162-40.664 113.436-44.682 236.562 12.584 345.4 65.846 125.14 198.632 205.438 340.042 205.438s274.196-80.298 340.040-205.44c57.27-108.838 53.25-231.962 12.586-345.398zM256.916 773.86c-50.806-96.562-31.944-199.204-7.172-268.304 27.56-76.886 71.736-155.028 131.3-232.254 38.3-49.658 82.166-98.008 130.958-144.384v799.082c-105.69 0-205.816-60.504-255.086-154.14z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"droplet-contrast",
						"droplet"
					],
					"defaultCode": 59702,
					"grid": 16
				},
				{
					"id": 1866,
					"paths": [
						"M512 128.916c48.792 46.376 92.656 94.728 130.958 144.384 59.562 77.226 103.738 155.368 131.298 232.256 24.772 69.102 43.632 171.742-7.176 268.304-49.268 93.636-149.392 154.14-255.080 154.14-105.69 0-205.814-60.504-255.084-154.14-50.806-96.562-31.946-199.204-7.172-268.304 27.558-76.886 71.734-155.028 131.298-232.254 38.302-49.658 82.168-98.010 130.958-144.386v0zM512 0c-147.516 125.012-286.87 289.722-352.626 473.162-40.664 113.436-44.682 236.56 12.584 345.4 65.846 125.14 198.632 205.438 340.042 205.438 141.408 0 274.196-80.298 340.040-205.44 57.27-108.838 53.25-231.962 12.586-345.4-65.754-183.438-205.11-348.148-352.626-473.16v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"droplet",
						"color",
						"water"
					],
					"defaultCode": 59701,
					"grid": 16
				},
				{
					"id": 1564,
					"width": 877.7129516601562,
					"paths": [
						"M666.857 906.286q-2.857-10.857-13.714-2.857-17.143 12.571-49.714 22.286t-74.857 9.714q-73.714 0-110.286-28-2.857-2.286-7.429-2.286-6.286 0-14.857 6.857-4 3.429-4.286 9.143t4.286 11.429q19.429 18.286 50 26.286t58.571 7.143 56.571-2.571q23.429-2.286 48.286-11.714t37.143-17.143 16.286-11.714q6.857-6.857 4-16.571zM644.571 840.571q-10.857-26.857-22.286-34.857-13.143-8.571-43.429-8.571-26.857 0-40.571 5.714-16.571 6.857-44.571 32-14.857 13.714-6.857 25.143 5.143 4.571 10 2.571t18-13.429q1.714-1.143 6-4.857t6-4.857 5.714-4 6.571-4 7.143-2.857 8.571-2.571 9.429-1.429 11.714-0.571q15.429 0 25.429 4.286t13.143 8.286 7.714 12.571q5.714 9.714 7.143 11.429t7.143-0.571q13.143-6.857 8-19.429zM847.429 680q0-12.571-2.857-25.429t-9.429-25.714-19.429-20.857-30-8q-18.857 0-55.429 23.714t-73.714 47.714-57.714 24q-15.429 0.571-36.286-10.857t-43.429-28-47.714-33.143-57.143-28-63.429-10.857q-65.714 0.571-112.571 44.857t-48 102q-1.143 64 42.286 93.714 16.571 11.429 35.714 16.286t59.143 4.857q32.571 0 75.429-18.571t76.571-40.571 68.571-40.286 53.143-17.714q14.857 0.571 37.143 18t40.857 38.286 38.857 38.571 31.714 18.286q20 1.714 33.429-8t31.714-36q16-23.429 24.286-57.714t8.286-60.571zM877.714 588.571q0 93.714-35.429 174t-94.857 134.857-138.571 85.429-166 30.857-167.429-32.857-141.429-89.714-97.429-138-36.571-172.571q0-50.857 11.143-98.571t28-83.143 40.286-67.714 44.857-53.714 44.857-39.714 36.857-26.571 24.286-14q8-4.571 29.143-15.143t31.143-16.286 27.429-17.143 34.571-25.143q20.571-16 33.143-41.429t17.143-71.714q73.714 88.571 106.286 110.286 25.143 16.571 74.286 38.857t73.714 37.714q12 7.429 22.286 14.286t34.571 26.571 43.429 40.286 42.857 54.286 39.429 69.714 26.857 84.857 11.143 101.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"drupal"
					],
					"defaultCode": 61865,
					"grid": 14
				},
				{
					"id": 2564,
					"paths": [
						"M144 256h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-480c0-8.8-7.2-16-16-16zM48 384h-32c-8.8 0-16 4.8-16 10.666v234.666c0 5.87 7.2 10.668 16 10.668h32c8.8 0 16-4.798 16-10.666v-234.668c0-5.866-7.2-10.666-16-10.666zM800 192h-64c-17.6 0-32 14.4-32 32v224h-384v-224c0-17.6-14.4-32-32-32h-64c-17.6 0-32 14.4-32 32v576c0 17.6 14.4 32 32 32h64c17.6 0 32-14.4 32-32v-224h384v224c0 17.6 14.4 32 32 32h64c17.6 0 32-14.4 32-32v-576c0-17.6-14.4-32-32-32zM912 256h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-480c0-8.8-7.2-16-16-16zM1008 384h-32c-8.8 0-16 4.8-16 10.666v234.666c0 5.868 7.2 10.666 16 10.666h32c8.8 0 16-4.798 16-10.666v-234.666c0-5.866-7.2-10.666-16-10.666z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dumbbell",
						"gym",
						"exercise",
						"fitness"
					],
					"defaultCode": 60399,
					"grid": 16
				},
				{
					"id": 455,
					"width": 1024,
					"paths": [
						"M288 160v0c6.24 6.24 6.24 16.384 0 22.624l-52.672 52.672c-6.24 6.24-16.384 6.24-22.624 0l-20.704-20.672c-6.24-6.24-6.24-16.384 0-22.624v0c6.24-6.24 16.384-6.24 22.624 0l9.376 9.376 41.376-41.376c6.24-6.24 16.384-6.24 22.624 0zM224 489.376l-9.376-9.376c-6.24-6.24-16.384-6.24-22.624 0v0c-6.24 6.24-6.24 16.384 0 22.624l20.672 20.672c6.24 6.24 16.384 6.24 22.624 0l52.704-52.672c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-41.376 41.376zM224 617.376l-9.376-9.376c-6.24-6.24-16.384-6.24-22.624 0v0c-6.24 6.24-6.24 16.384 0 22.624l20.672 20.672c6.24 6.24 16.384 6.24 22.624 0l52.704-52.672c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-41.376 41.376zM265.376 288l-25.376 25.376-25.376-25.376c-6.24-6.24-16.384-6.24-22.624 0v0c-6.24 6.24-6.24 16.384 0 22.624l25.376 25.376-25.376 25.376c-6.24 6.24-6.24 16.384 0 22.624v0c6.24 6.24 16.384 6.24 22.624 0l25.376-25.376 25.376 25.376c6.24 6.24 16.384 6.24 22.624 0v0c6.24-6.24 6.24-16.384 0-22.624l-25.376-25.376 25.376-25.376c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0zM928 352v512c0 53.024-42.976 96-96 96h-352c-53.024 0-96-42.976-96-96v-96h-192c-53.024 0-96-42.976-96-96v-512c0-53.024 42.976-96 96-96h352c53.024 0 96 42.976 96 96v96h192c53.024 0 96 42.976 96 96zM384 736v-384c0-53.024 42.976-96 96-96h128v-96c0-35.36-28.64-64-64-64h-352c-35.36 0-64 28.64-64 64v512c0 35.36 28.64 64 64 64h192zM832 288h-352c-35.36 0-64 28.64-64 64v512c0 35.36 28.64 64 64 64h352c35.36 0 64-28.64 64-64v-512c0-35.36-28.64-64-64-64zM576 352v0c-6.24-6.24-16.384-6.24-22.624 0l-41.376 41.376-9.376-9.376c-6.24-6.24-16.384-6.24-22.624 0v0c-6.24 6.24-6.24 16.384 0 22.624l20.672 20.672c6.24 6.24 16.384 6.24 22.624 0l52.704-52.672c6.24-6.24 6.24-16.384 0-22.624zM576 640v0c-6.24-6.24-16.384-6.24-22.624 0l-41.376 41.376-9.376-9.376c-6.24-6.24-16.384-6.24-22.624 0v0c-6.24 6.24-6.24 16.384 0 22.624l20.672 20.672c6.24 6.24 16.384 6.24 22.624 0l52.704-52.672c6.24-6.24 6.24-16.384 0-22.624zM576 768v0c-6.24-6.24-16.384-6.24-22.624 0l-41.376 41.376-9.376-9.376c-6.24-6.24-16.384-6.24-22.624 0v0c-6.24 6.24-6.24 16.384 0 22.624l20.672 20.672c6.24 6.24 16.384 6.24 22.624 0l52.704-52.672c6.24-6.24 6.24-16.384 0-22.624zM502.624 576l25.376-25.376 25.376 25.376c6.24 6.24 16.384 6.24 22.624 0v0c6.24-6.24 6.24-16.384 0-22.624l-25.376-25.376 25.376-25.376c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-25.376 25.376-25.376-25.376c-6.24-6.24-16.384-6.24-22.624 0v0c-6.24 6.24-6.24 16.384 0 22.624l25.376 25.376-25.376 25.376c-6.24 6.24-6.24 16.384 0 22.624v0c6.24 6.24 16.384 6.24 22.624 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"duplicate",
						"copy",
						"work",
						"test",
						"reproduce"
					],
					"grid": 32
				},
				{
					"id": 456,
					"width": 1024,
					"paths": [
						"M352 352c0-70.592 57.408-128 128-128h160v-64c0-53.024-42.976-96-96-96h-352c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h160v-416zM192 192c6.24-6.24 16.384-6.24 22.624 0l9.376 9.376 41.376-41.376c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-52.672 52.672c-6.24 6.24-16.384 6.24-22.624 0l-20.704-20.672c-6.24-6.24-6.24-16.384 0-22.624zM288 598.624l-52.672 52.672c-6.24 6.24-16.384 6.24-22.624 0l-20.704-20.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l9.376 9.376 41.376-41.376c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624zM288 470.624l-52.672 52.672c-6.24 6.24-16.384 6.24-22.624 0l-20.704-20.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l9.376 9.376 41.376-41.376c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624zM288 361.376c6.24 6.24 6.24 16.384 0 22.624s-16.384 6.24-22.624 0l-25.376-25.376-25.376 25.376c-6.24 6.24-16.384 6.24-22.624 0s-6.24-16.384 0-22.624l25.376-25.376-25.376-25.376c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l25.376 25.376 25.376-25.376c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-25.376 25.376 25.376 25.376zM832 256h-352c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h352c53.024 0 96-42.976 96-96v-512c0-53.024-42.976-96-96-96zM576 790.624l-52.672 52.672c-6.24 6.24-16.384 6.24-22.624 0l-20.704-20.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l9.376 9.376 41.376-41.376c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624zM576 662.624l-52.672 52.672c-6.24 6.24-16.384 6.24-22.624 0l-20.704-20.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l9.376 9.376 41.376-41.376c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624zM576 553.376c6.24 6.24 6.24 16.384 0 22.624s-16.384 6.24-22.624 0l-25.376-25.376-25.376 25.376c-6.24 6.24-16.384 6.24-22.624 0s-6.24-16.384 0-22.624l25.376-25.376-25.376-25.376c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l25.376 25.376 25.376-25.376c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-25.376 25.376 25.376 25.376zM576 374.624l-52.672 52.672c-6.24 6.24-16.384 6.24-22.624 0l-20.704-20.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l9.376 9.376 41.376-41.376c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"duplicate",
						"copy",
						"work",
						"test",
						"reproduce"
					],
					"grid": 32
				},
				{
					"id": 2731,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 960.002c-62.958 0-122.872-13.012-177.23-36.452l233.148-262.29c5.206-5.858 8.082-13.422 8.082-21.26v-96c0-17.674-14.326-32-32-32-112.99 0-232.204-117.462-233.374-118.626-6-6.002-14.14-9.374-22.626-9.374h-128c-17.672 0-32 14.328-32 32v192c0 12.122 6.848 23.202 17.69 28.622l110.31 55.156v187.886c-116.052-80.956-192-215.432-192-367.664 0-68.714 15.49-133.806 43.138-192h116.862c8.488 0 16.626-3.372 22.628-9.372l128-128c6-6.002 9.372-14.14 9.372-22.628v-77.412c40.562-12.074 83.518-18.588 128-18.588 70.406 0 137.004 16.26 196.282 45.2-4.144 3.502-8.176 7.164-12.046 11.036-36.266 36.264-56.236 84.478-56.236 135.764s19.97 99.5 56.236 135.764c36.434 36.432 85.218 56.264 135.634 56.26 3.166 0 6.342-0.080 9.518-0.236 13.814 51.802 38.752 186.656-8.404 372.334-0.444 1.744-0.696 3.488-0.842 5.224-81.324 83.080-194.7 134.656-320.142 134.656z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"earth",
						"globe",
						"language",
						"web",
						"internet",
						"sphere",
						"planet"
					],
					"defaultCode": 60566,
					"grid": 16
				},
				{
					"id": 2732,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM352 93.452v34.548l-160 160h-68.050c51.126-88.378 131.58-157.648 228.050-194.548zM512 640l-228.692 257.278c-9.328-5.546-18.434-11.424-27.308-17.616v-207.662l-128-96v-160c0-17.672 14.328-32 32-32h96c0 0 96 128 256 160v96zM899.166 490.744c-15.832-53.238-29.504-58.412-99.166-82.096v-0.002c-23.828-7.47-46.256-20.63-65.136-39.51-62.482-62.484-62.482-163.79 0-226.274 4.2-4.198 8.588-8.080 13.116-11.712 127.262 79.022 212.020 220.026 212.020 380.85 0 82.95-22.57 160.618-61.866 227.24 16.474-106.492 10.398-191.826 1.032-248.496z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"earth",
						"globe",
						"language",
						"web",
						"internet",
						"sphere",
						"planet"
					],
					"defaultCode": 60567,
					"grid": 16
				},
				{
					"id": 2733,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM960.002 512c0 66.234-14.386 129.102-40.184 185.672 18.636-179.412-23.79-290.864-26.028-296.57-5.674-14.472-20.93-22.774-36.162-19.678-42.26 8.588-85.686-4.464-116.138-34.916-24.176-24.174-37.49-56.318-37.49-90.508s13.314-66.334 37.49-90.508c8.168-8.168 17.268-15.088 27.138-20.718 115.7 81.002 191.374 215.268 191.374 367.226zM320 107.138v39.606l-109.254 109.256h-66.408c44.414-63.668 104.93-115.258 175.662-148.862zM302.31 643.378l-110.31-55.156v-140.222h83.242c30.922 28.394 129.088 111.182 236.758 125.788v54.046l-192 216v-171.834c0-12.122-6.848-23.202-17.69-28.622zM512 960.002c-62.958 0-122.872-13.012-177.23-36.452l233.148-262.29c5.206-5.858 8.082-13.422 8.082-21.26v-96c0-17.674-14.326-32-32-32-112.99 0-232.204-117.462-233.374-118.626-6-6.002-14.14-9.374-22.626-9.374h-128c-17.672 0-32 14.328-32 32v192c0 12.122 6.848 23.202 17.69 28.622l110.31 55.156v187.886c-116.052-80.956-192-215.432-192-367.664 0-68.714 15.49-133.806 43.138-192h116.862c8.488 0 16.626-3.372 22.628-9.372l128-128c6-6.002 9.372-14.14 9.372-22.628v-77.412c40.562-12.074 83.518-18.588 128-18.588 70.406 0 137.004 16.26 196.282 45.2-4.144 3.502-8.176 7.164-12.046 11.036-36.266 36.264-56.236 84.478-56.236 135.764s19.97 99.5 56.236 135.764c36.434 36.432 85.218 56.264 135.634 56.26 3.166 0 6.342-0.080 9.518-0.236 13.814 51.802 38.752 186.656-8.404 372.334-0.444 1.744-0.696 3.488-0.842 5.224-81.324 83.080-194.7 134.656-320.142 134.656z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"earth",
						"globe",
						"language",
						"web",
						"internet",
						"sphere",
						"planet"
					],
					"defaultCode": 60568,
					"grid": 16
				},
				{
					"id": 178,
					"paths": [
						"M874.038 149.962c-96.704-96.704-225.278-149.962-362.038-149.962s-265.334 53.258-362.038 149.962c-96.704 96.704-149.962 225.278-149.962 362.038s53.258 265.334 149.962 362.038c96.704 96.704 225.278 149.962 362.038 149.962s265.334-53.258 362.038-149.962c96.704-96.704 149.962-225.278 149.962-362.038s-53.258-265.334-149.962-362.038zM941.918 346.178c-9.989-17.987-35.050-26.512-67.853-37.661-35.182-11.957-47.608-48.122-61.994-89.997-12.49-36.35-25.398-73.874-56.069-97.238 83.898 52.584 149.733 131.406 185.915 224.896zM798.235 521.757c3.872 34.683 7.875 70.546-35.163 118.874-11.629 13.056-18.44 31.238-25.653 50.49-16.701 44.582-32.486 86.709-99.642 87.325-1.882-2.262-7.242-10.734-11.981-37.533-4.366-24.698-6.886-56.606-9.555-90.389-4.093-51.834-8.731-110.582-21.544-159.32-16.382-62.325-43.867-99.141-84.026-112.554-17.522-5.853-35.411-8.698-54.693-8.698-14.211 0-27.125 1.522-38.517 2.864-8.875 1.045-17.258 2.034-24.341 2.034 0 0-0.002 0-0.003 0-11.987 0-25.573 0-42.278-38.29-24.021-55.053-6.304-143.267 64.202-189.787 38.661-25.509 65.336-36.392 89.2-36.392 19.026 0 39.581 6.622 68.73 22.146 34.418 18.33 61.379 20.68 81.026 20.68 7.789 0 14.85-0.419 21.682-0.826 5.726-0.339 11.134-0.661 16.139-0.661 11.259 0 20.387 1.467 31.088 8.776 19.723 13.472 29.936 43.195 40.747 74.664 16.392 47.715 34.973 101.798 93.941 121.837 7.925 2.693 21.576 7.333 31.216 11.366-8.328 8.608-22.285 21.067-35.92 33.24-8.808 7.862-18.789 16.773-29.851 26.858-31.965 29.133-28.16 63.221-24.803 93.296zM51.25 508.070c5.52 0.992 11.493 2.141 17.605 3.446 28.776 6.141 42.235 11.686 48.117 14.798-2.706 5.277-8.187 13.056-11.81 18.195-12.669 17.976-28.435 40.349-22.437 64.984 4.046 16.618 0.632 37.032-5.248 55.883-16.994-48.005-26.277-99.624-26.277-153.378 0-1.314 0.038-2.618 0.050-3.93zM512 972.8c-175.379 0-328.173-98.494-406.014-243.062 13.422-25.554 38.314-82.054 26.68-131.547 0.806-4.97 9.248-16.95 14.349-24.186 13.874-19.688 31.141-44.189 18.35-70.152-8.976-18.222-32.957-30.534-80.181-41.17-10.939-2.464-21.594-4.47-30.65-6.019 27.424-228.090 222.107-405.464 457.466-405.464 80.776 0 156.749 20.918 222.83 57.582-16.33-7.134-31.154-8.266-43.014-8.266-6.523 0-12.957 0.382-19.176 0.752-6.085 0.362-12.374 0.734-18.645 0.734-14.542 0-32.682-1.742-56.958-14.67-37.056-19.734-64.808-28.155-92.795-28.155-34.635 0-69.744 13.414-117.397 44.856-41.197 27.181-72.229 68.779-87.381 117.133-14.779 47.166-13.2 95.418 4.448 135.867 20.824 47.728 48.336 69.013 89.203 69.014 0.003 0 0.003 0 0.006 0 10.090 0 19.923-1.158 30.333-2.386 10.482-1.235 21.32-2.512 32.525-2.512 13.869 0 26.094 1.926 38.472 6.061 22.488 7.512 39.082 32.701 50.728 77.008 11.648 44.31 16.098 100.638 20.021 150.334 3.274 41.454 6.366 80.61 13.176 110.126 4.136 17.923 9.494 31.538 16.379 41.621 10.283 15.058 25.032 23.35 41.526 23.35 45.269 0 81.429-14.594 107.47-43.374 21.659-23.934 32.722-53.466 41.613-77.194 5.245-14.003 10.67-28.482 15.941-34.402 58.219-65.373 52.203-119.258 47.813-158.603-3.226-28.888-3.285-39.123 8.408-49.781 10.864-9.904 20.741-18.722 29.454-26.499 18.568-16.576 31.984-28.554 41.397-38.83 6.464-7.058 21.603-23.584 17.395-44.28-0.037-0.184-0.088-0.358-0.126-0.539 17.558 48.701 27.154 101.174 27.154 155.851 0 254.086-206.714 460.8-460.8 460.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"earth",
						"globe",
						"international",
						"language"
					],
					"defaultCode": 59475,
					"grid": 20
				},
				{
					"id": 457,
					"width": 1024,
					"paths": [
						"M992 448v-64c0-159.072-128.928-288-288-288h-384c-159.072 0-288 128.928-288 288v64c0 10.56 5.44 19.456 13.344 25.312-8.256 10.752-13.344 24.064-13.344 38.688 0 24.16 13.536 44.928 33.312 55.84-20.256 17.6-33.312 43.232-33.312 72.16v64c0 17.216 4.896 29.632 12.832 39.040-7.616 5.856-12.832 14.624-12.832 24.96v64c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-64c0-10.336-5.216-19.104-12.832-24.96 7.936-9.408 12.832-21.824 12.832-39.040v-64c0-28.928-13.056-54.56-33.312-72.16 19.776-10.912 33.312-31.68 33.312-55.84 0-14.624-5.088-27.936-13.344-38.688 7.904-5.856 13.344-14.752 13.344-25.312zM64 384c0-141.376 114.624-256 256-256h384c141.376 0 256 114.624 256 256v64h-896v-64zM960 832c0 35.36-28.64 64-64 64h-768c-35.36 0-64-28.64-64-64v-64h896v64zM960 704c0 27.744-17.792 31.616-42.496 32h-811.008c-24.704-0.384-42.496-4.256-42.496-32v-64c0-17.6 7.136-33.568 18.656-45.12l405.696 103.104c15.52 3.936 31.776 3.936 47.296 0l405.696-103.104c11.52 11.552 18.656 27.52 18.656 45.12v64zM136.512 576h751.008l-359.744 91.424c-10.336 2.624-21.184 2.624-31.52 0l-359.744-91.424zM928 544h-832c-17.664 0-32-14.336-32-32s14.336-32 32-32h832c17.664 0 32 14.336 32 32s-14.336 32-32 32zM576 256c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM384 256c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM480 192c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM672 192c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM288 192c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eat",
						"consume",
						"snack",
						"dine"
					],
					"grid": 32
				},
				{
					"id": 458,
					"width": 1024,
					"paths": [
						"M896 928h-768c-53.024 0-96-42.976-96-96v-64c0-17.664 14.336-32 32-32h896c17.664 0 32 14.336 32 32v64c0 53.024-42.976 96-96 96zM960 480h-896c-17.664 0-32 14.336-32 32v0c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v0c0-17.664-14.336-32-32-32zM992 384v32c0 17.664-14.336 32-32 32h-896c-17.664 0-32-14.336-32-32v-32c0-159.072 128.928-288 288-288h384c159.072 0 288 128.928 288 288zM352 192c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM448 256c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM544 192c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM640 256c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM736 192c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM523.84 651.936l298.368-75.936h-620.736l298.688 75.936c7.776 1.952 15.904 1.952 23.68 0zM960 576h-8.032l-420.256 106.944c-6.464 1.632-13.088 2.464-19.712 2.464s-13.248-0.832-19.712-2.464l-420.704-106.944h-7.584c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eat",
						"consume",
						"snack",
						"dine"
					],
					"grid": 32
				},
				{
					"id": 1010,
					"width": 1024,
					"paths": [
						"M662.88 521.6c11.040-0.928 25.216 0 37.792 0.96 9.824 0.704 19.328 1.376 28.224 1.376 17.344 0 42.624-2.208 61.76-21.344l224-224c12.512-12.512 12.512-32.736 0-45.248l-224-224c-12.512-12.512-32.736-12.512-45.248 0l-224 224c-37.952 37.952-41.408 76.992-38.368 108.384l-300.416-300.352c-3.936-3.936-25.152-23.584-55.808-23.584-13.632 0-33.952 4.096-53.44 23.584-10.176 10.176-14.88 25.152-14.368 45.76 2.048 81.472 94.592 316.608 258.144 478.464l-307.776 307.776c-12.512 12.512-12.512 32.736 0 45.248l96 96c12.512 12.512 32.736 12.512 45.248 0l361.376-361.376 361.376 361.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l96-96c12.512-12.512 12.512-32.736 0-45.248l-351.744-351.776zM549.824 356.64c-5.568-32.384-7.712-53.472 16.8-78.016l201.376-201.376 46.048 46.048-153.376 153.376c-6.24 6.24-6.24 16.384 0 22.624 3.136 3.136 7.232 4.704 11.328 4.704s8.192-1.568 11.328-4.672l153.376-153.376 41.376 41.376-153.376 153.376c-6.24 6.24-6.24 16.384 0 22.624 3.104 3.104 7.2 4.672 11.296 4.672s8.192-1.568 11.328-4.672l153.376-153.376 46.048 46.048-201.376 201.376c-0.288 0.256-2.976 2.592-16.512 2.592-7.392 0-15.328-0.64-23.488-1.216-10.336-0.768-21.056-1.536-31.712-1.536-24.096 0-59.424 3.328-88.288 32.16l-50.752-50.752c24.96-24.96 19.52-56.608 15.2-81.984zM128 946.752l-50.752-50.752 308.416-308.416c0.544-0.544 0.736-1.312 1.248-1.888 6.72 5.472 13.504 10.784 20.416 15.936 5.6 4.192 12.48 6.368 19.488 6.368h39.936l-338.752 338.752zM896 946.752l-370.752-370.752h-98.816c-190.528-141.952-307.136-434.496-303.552-492.864 1.312-0.832 2.688-1.376 3.936-1.376 3.616 0 8.672 3.136 10.56 4.864l809.376 809.376-50.752 50.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eat",
						"consume",
						"snack",
						"dine"
					],
					"grid": 32
				},
				{
					"id": 3408,
					"paths": [
						"M15.4 454.6c30-236.8 191.6-451.6 481.2-454.6 174.8 3.4 318.6 82.6 404.2 233.6 43 78.8 56.4 161.6 59.2 253v107.4h-642.6c3 265 390 256 556.6 139.2v215.8c-97.6 58.6-319 111-490.4 43.6-146-54.8-250-207.6-249.4-354.6-4.8-190.6 94.8-316.8 249.4-388.6-32.8 40.6-57.8 85.4-70.8 163h362.8c0 0 21.2-216.8-205.4-216.8-213.6 7.4-367.6 131.6-454.8 259v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"edge",
						"browser",
						"brand"
					],
					"defaultCode": 61243,
					"grid": 16
				},
				{
					"id": 1765,
					"width": 1023.9999694824219,
					"paths": [
						"M39.429 454.286h0.571q9.143-72 33.429-138t65.714-124 95.714-100.571 127.714-67.143 158-24.571q132 0 236.571 60.286t168 173.429q59.429 106.857 59.429 252.571v107.429h-642.857q0.571 63.429 30.571 110t78 70 108.286 32.571 121.714 1.714 118.857-26.571 99.143-48.286v215.429q-52.571 31.429-131.143 52.571t-178.571 21.714-180.571-30.286q-108-41.714-178-142.286t-71.143-212.571q-1.714-138.286 63.429-235.429t185.714-153.143q-27.429 34.286-44.571 71.714t-26.286 91.143h362.857q4.571-44-4.571-80t-26.857-58-40.286-38-46-23.429-42.857-11.714-32-4.857l-12.571-0.571q-77.143 2.857-148.286 25.429t-127.714 59.714-100.571 80.286-78.857 93.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"edge"
					],
					"defaultCode": 62082,
					"grid": 14
				},
				{
					"id": 1243,
					"width": 1019.4269714355469,
					"paths": [
						"M507.429 676.571l66.286-66.286-86.857-86.857-66.286 66.286v32h54.857v54.857h32zM758.857 265.143q-9.143-9.143-18.857 0.571l-200 200q-9.714 9.714-0.571 18.857t18.857-0.571l200-200q9.714-9.714 0.571-18.857zM804.571 604.571v108.571q0 68-48.286 116.286t-116.286 48.286h-475.429q-68 0-116.286-48.286t-48.286-116.286v-475.429q0-68 48.286-116.286t116.286-48.286h475.429q36 0 66.857 14.286 8.571 4 10.286 13.143 1.714 9.714-5.143 16.571l-28 28q-8 8-18.286 4.571-13.143-3.429-25.714-3.429h-475.429q-37.714 0-64.571 26.857t-26.857 64.571v475.429q0 37.714 26.857 64.571t64.571 26.857h475.429q37.714 0 64.571-26.857t26.857-64.571v-72q0-7.429 5.143-12.571l36.571-36.571q8.571-8.571 20-4t11.429 16.571zM749.714 182.857l164.571 164.571-384 384h-164.571v-164.571zM1003.429 258.286l-52.571 52.571-164.571-164.571 52.571-52.571q16-16 38.857-16t38.857 16l86.857 86.857q16 16 16 38.857t-16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"edit",
						"pencil-square-o"
					],
					"defaultCode": 61508,
					"grid": 14
				},
				{
					"id": 459,
					"width": 1024,
					"paths": [
						"M608 0h-192c-53.024 0-96 42.976-96 96v661.344c0 6.912 2.24 13.664 6.4 19.2l160 213.344c12.8 17.056 38.4 17.056 51.2 0l160-213.344c4.16-5.536 6.4-12.288 6.4-19.2v-661.344c0-53.024-42.976-96-96-96zM512 970.656l-32-42.656h64l-32 42.656zM568 896h-112l-96-128h304l-96 128zM672 736h-320v-384h320v384zM672 320h-320v-96h320v96zM672 192h-320v-96c0-35.296 28.704-64 64-64h192c35.296 0 64 28.704 64 64v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"edit",
						"erase",
						"write",
						"draw",
						"sketch"
					],
					"grid": 32
				},
				{
					"id": 460,
					"width": 1024,
					"paths": [
						"M704 320h-384v-96h384v96zM704 96c0-53.024-42.976-96-96-96h-192c-53.024 0-96 42.976-96 96v96h384v-96zM486.4 989.856c12.8 17.056 38.4 17.056 51.2 0l46.4-61.856h-144l46.4 61.856zM320 768l96 128h192l96-128h-384zM704 736v-384h-384v384h384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"edit",
						"erase",
						"write",
						"draw",
						"sketch"
					],
					"grid": 32
				},
				{
					"id": 1011,
					"width": 1024,
					"paths": [
						"M1001.376 233.376l-210.752-210.752c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-643.36 643.36c-3.936 3.936-6.784 8.832-8.256 14.208l-79.040 289.76c-5.728 20.992 10.496 40.448 30.72 40.448 2.784 0 5.664-0.384 8.576-1.152l289.76-79.040c5.376-1.472 10.272-4.32 14.208-8.256l643.392-643.328c12.48-12.48 12.48-32.768 0-45.248zM564.672 372.672l-192 192c-35.936 35.936-71.008 23.68-90.4 11.52l294.304-294.304c30.272 45.312-7.072 85.92-11.904 90.784zM143.264 741.888l138.816 138.816-190.88 52.096 52.064-190.912zM318.752 870.72l-1.088 0.32-164.704-164.704 0.288-1.12 105.888-105.888c16.096 11.36 38.272 21.248 62.944 21.248 23.264 0 48.672-8.768 73.184-33.28l192-192c24-23.968 54.112-80.992 12.256-136.384l42.368-42.368 165.504 165.504-488.64 488.672zM830.048 359.424l-165.504-165.504 103.456-103.424 165.504 165.504-103.456 103.424z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"edit",
						"write",
						"draw",
						"sketch"
					],
					"grid": 32
				},
				{
					"id": 2650,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 736c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z",
						"M608.132 480c19.904-16.87 31.87-39.188 31.87-64 0-53.832-56.224-96-128-96s-128 42.168-128 96c0 24.812 11.964 47.13 31.87 64-19.906 16.87-31.872 39.19-31.872 64 0 53.832 56.224 96 128 96s128-42.168 128-96c0-24.81-11.964-47.13-31.868-64zM448 416c0-13.048 24.932-32 64-32s64 18.952 64 32c0 13.044-24.92 31.99-63.97 32-0.010 0-0.020 0-0.030 0s-0.020 0-0.030 0c-39.050-0.010-63.97-18.956-63.97-32zM512 576c-39.068 0-64-18.954-64-32 0-13.044 24.92-31.992 63.97-32 0.010 0 0.020 0 0.030 0s0.020 0 0.030 0c39.050 0.008 63.97 18.956 63.97 32 0 13.046-24.932 32-64 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eight-ball",
						"soprts",
						"billiards",
						"snooker",
						"sports",
						"game"
					],
					"defaultCode": 60485,
					"grid": 16
				},
				{
					"id": 2979,
					"paths": [
						"M0 768h1024v128h-1024zM512 128l512 512h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eject",
						"player"
					],
					"defaultCode": 60814,
					"grid": 16
				},
				{
					"id": 1256,
					"width": 878.8539390563965,
					"paths": [
						"M8 559.429l405.714-405.714q10.857-10.857 25.714-10.857t25.714 10.857l405.714 405.714q10.857 10.857 7.429 18.286t-18.286 7.429h-841.143q-14.857 0-18.286-7.429t7.429-18.286zM841.714 877.714h-804.571q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-14.857 10.857-25.714t25.714-10.857h804.571q14.857 0 25.714 10.857t10.857 25.714v146.286q0 14.857-10.857 25.714t-25.714 10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eject"
					],
					"defaultCode": 61522,
					"grid": 14
				},
				{
					"id": 1466,
					"width": 804.5719680786133,
					"paths": [
						"M219.429 420.571v109.714q0 22.857-16 38.857t-38.857 16h-109.714q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h109.714q22.857 0 38.857 16t16 38.857zM512 420.571v109.714q0 22.857-16 38.857t-38.857 16h-109.714q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h109.714q22.857 0 38.857 16t16 38.857zM804.571 420.571v109.714q0 22.857-16 38.857t-38.857 16h-109.714q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h109.714q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ellipsis-h"
					],
					"defaultCode": 61761,
					"grid": 14
				},
				{
					"id": 1467,
					"width": 219.43001556396484,
					"paths": [
						"M219.429 713.143v109.714q0 22.857-16 38.857t-38.857 16h-109.714q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h109.714q22.857 0 38.857 16t16 38.857zM219.429 420.571v109.714q0 22.857-16 38.857t-38.857 16h-109.714q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h109.714q22.857 0 38.857 16t16 38.857zM219.429 128v109.714q0 22.857-16 38.857t-38.857 16h-109.714q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h109.714q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ellipsis-v"
					],
					"defaultCode": 61762,
					"grid": 14
				},
				{
					"id": 3370,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM824.636 589.598c-36.798 142.716-165.358 242.402-312.63 242.402-147.282 0-275.85-99.686-312.654-242.42-6.232-24.158 8.352-48.886 32.512-55.124 3.71-0.958 7.528-1.446 11.338-1.446 20.624 0 38.628 13.972 43.788 33.976 26.512 102.748 119.042 174.51 225.014 174.51 105.978 0 198.502-71.76 225-174.51 5.152-20.006 23.15-33.982 43.766-33.982 3.822 0 7.65 0.49 11.376 1.456 11.692 3.016 21.526 10.418 27.668 20.842 6.142 10.416 7.854 22.596 4.822 34.296z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ello",
						"brand",
						"social"
					],
					"defaultCode": 61205,
					"grid": 16
				},
				{
					"id": 3297,
					"paths": [
						"M576 736l96 96 320-320-320-320-96 96 224 224z",
						"M448 288l-96-96-320 320 320 320 96-96-224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"embed",
						"code",
						"html",
						"xml"
					],
					"defaultCode": 61132,
					"grid": 16
				},
				{
					"id": 3298,
					"width": 1280,
					"paths": [
						"M832 736l96 96 320-320-320-320-96 96 224 224z",
						"M448 288l-96-96-320 320 320 320 96-96-224-224z",
						"M701.298 150.519l69.468 18.944-191.987 704.026-69.468-18.944 191.987-704.026z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"embed",
						"code",
						"html",
						"xml"
					],
					"defaultCode": 61133,
					"grid": 16
				},
				{
					"id": 1601,
					"width": 1024,
					"paths": [
						"M499.429 936v37.714q-118.857-3.429-220-62.571t-161.714-157.429l33.143-19.429q16.571 28 41.714 56.571l37.143-32.571q84.571 96 210.286 121.143l-9.714 49.143q37.143 6.857 69.143 7.429zM157.714 633.143l-47.429 16q12.571 34.286 28 64l-32.571 18.857q-56-102.857-56-220t56-220l32.571 18.857q-17.143 32-28 64l46.857 16q-20 57.143-20 121.143 0 62.286 20.571 121.143zM873.143 734.286l33.143 19.429q-60.571 98.286-161.714 157.429t-220 62.571v-37.714q32-0.571 69.143-7.429l-9.714-49.143q125.714-25.143 210.286-121.143l37.143 32.571q25.143-28.571 41.714-56.571zM786.857 417.714l-133.143 45.714q8 24 8 48.571t-8 48.571l132.571 45.714q-17.714 52.571-56 96.571l-105.714-92.571q-32.571 38.286-84 48.571l27.429 137.714q-29.714 5.714-56 5.714t-56-5.714l27.429-137.714q-51.429-10.286-84-48.571l-105.714 92.571q-38.286-44-56-96.571l132.571-45.714q-8-24-8-48.571t8-48.571l-133.143-45.714q18.857-53.143 56.571-96.571l105.714 92.571q33.714-38.857 84-49.143l-27.429-137.143q25.143-5.714 56-5.714t56 5.714l-27.429 137.143q50.286 10.286 84 49.143l105.714-92.571q37.714 43.429 56.571 96.571zM499.429 50.286v37.714q-37.143 1.143-69.143 7.429l9.714 49.143q-125.714 24-210.286 120.571l-37.143-32q-21.714 24-41.714 56l-32.571-18.857q60.571-98.286 161.143-157.429t220-62.571zM974.286 512q0 117.143-56 220l-32.571-18.857q15.429-29.714 28-64l-47.429-16q20.571-58.857 20.571-121.143 0-64-20-121.143l46.857-16q-10.857-32-28-64l32.571-18.857q56 102.857 56 220zM905.714 270.286l-32.571 18.857q-20-32-41.714-56l-37.143 32q-84.571-96.571-210.286-120.571l9.714-49.143q-32-6.286-69.143-7.429v-37.714q119.429 3.429 220 62.571t161.143 157.429zM998.857 512q0-98.857-38.571-189.143t-103.714-155.429-155.429-103.714-189.143-38.571-189.143 38.571-155.429 103.714-103.714 155.429-38.571 189.143 38.571 189.143 103.714 155.429 155.429 103.714 189.143 38.571 189.143-38.571 155.429-103.714 103.714-155.429 38.571-189.143zM1024 512q0 104-40.571 198.857t-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571 198.857 40.571 163.429 109.143 109.143 163.429 40.571 198.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"empire",
						"ge"
					],
					"defaultCode": 61905,
					"grid": 14
				},
				{
					"id": 461,
					"width": 1024,
					"paths": [
						"M982.24 491.104c31.904-34.912 48.64-83.744 39.072-136.672-11.328-62.528-60.8-113.92-123.008-126.848-11.616-2.432-23.104-3.584-34.304-3.584-67.584 0-125.376 41.92-148.832 101.152-14.208 35.936-49.664 58.848-88.288 58.848h-229.76c-38.624 0-74.080-22.912-88.288-58.848-23.456-59.232-81.248-101.152-148.832-101.152-11.2 0-22.688 1.152-34.304 3.584-62.208 12.928-111.712 64.32-123.008 126.848-9.568 52.928 7.168 101.76 39.072 136.672 10.080 11.040 10.080 30.784 0 41.824-31.904 34.912-48.64 83.744-39.072 136.672 11.328 62.528 60.8 113.92 123.008 126.848 11.616 2.4 23.104 3.552 34.304 3.552 67.584 0 125.376-41.92 148.832-101.152 14.208-35.936 49.664-58.848 88.288-58.848h229.76c38.624 0 74.080 22.912 88.288 58.848 23.456 59.232 81.248 101.152 148.832 101.152 11.2 0 22.688-1.152 34.304-3.552 62.208-12.928 111.712-64.32 123.008-126.848 9.568-52.928-7.168-101.76-39.072-136.672-10.080-11.040-10.080-30.816 0-41.824zM989.824 663.872c-9.088 50.24-48.48 90.912-98.016 101.216-9.28 1.92-18.624 2.912-27.808 2.912-52.896 0-99.616-31.776-119.072-80.928-18.72-47.296-66.144-79.072-118.048-79.072h-229.76c-51.904 0-99.328 31.776-118.048 79.072-19.456 49.152-66.176 80.928-119.072 80.928-9.184 0-18.528-0.96-27.808-2.912-49.536-10.304-88.928-50.976-98.016-101.216-7.232-39.904 4.16-79.776 31.2-109.408 21.408-23.424 21.408-61.568 0-84.992-27.040-29.6-38.432-69.472-31.2-109.408 9.088-50.24 48.48-90.912 98.016-101.216 9.28-1.856 18.624-2.848 27.808-2.848 52.896 0 99.616 31.776 119.072 80.928 18.72 47.296 66.144 79.072 118.048 79.072h229.76c51.904 0 99.328-31.776 118.048-79.072 19.456-49.152 66.176-80.928 119.072-80.928 9.184 0 18.528 0.992 27.808 2.912 49.536 10.304 88.928 50.976 98.016 101.216 7.232 39.904-4.16 79.776-31.2 109.408-21.408 23.424-21.408 61.568 0 84.992 27.040 29.568 38.432 69.44 31.2 109.344z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"encourage",
						"die",
						"chew"
					],
					"grid": 32
				},
				{
					"id": 462,
					"width": 1024,
					"paths": [
						"M982.24 491.104c31.904-34.912 48.64-83.744 39.072-136.672-11.328-62.528-60.8-113.92-123.008-126.848-11.616-2.432-23.104-3.584-34.304-3.584-67.584 0-125.376 41.92-148.832 101.152-14.208 35.936-49.664 58.848-88.288 58.848h-229.76c-38.624 0-74.080-22.912-88.288-58.848-23.456-59.232-81.248-101.152-148.832-101.152-11.2 0-22.688 1.152-34.304 3.584-62.208 12.928-111.712 64.32-123.008 126.848-9.568 52.928 7.168 101.76 39.072 136.672 10.080 11.040 10.080 30.784 0 41.824-31.904 34.912-48.64 83.744-39.072 136.672 11.328 62.528 60.8 113.92 123.008 126.848 11.616 2.4 23.104 3.552 34.304 3.552 67.584 0 125.376-41.92 148.832-101.152 14.208-35.936 49.664-58.848 88.288-58.848h229.76c38.624 0 74.080 22.912 88.288 58.848 23.456 59.232 81.248 101.152 148.832 101.152 11.2 0 22.688-1.152 34.304-3.552 62.208-12.928 111.712-64.32 123.008-126.848 9.568-52.928-7.168-101.76-39.072-136.672-10.080-11.040-10.080-30.816 0-41.824z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"encourage",
						"die",
						"chew"
					],
					"grid": 32
				},
				{
					"id": 1012,
					"width": 1024,
					"paths": [
						"M768 544c-88.352 0-160 71.648-160 160s71.648 160 160 160 160-71.648 160-160-71.648-160-160-160zM768 832c-70.592 0-128-57.408-128-128s57.408-128 128-128 128 57.408 128 128-57.408 128-128 128zM912 64c-61.76 0-112 50.24-112 112v48c0 17.664 14.304 32 32 32s32-14.336 32-32v-48c0-26.464 21.536-48 48-48s48 21.536 48 48v359.232c-46.944-53.344-115.52-87.232-192-87.232-70.464 0-134.336 28.608-180.672 74.816-23.168-11.744-48.608-18.624-75.328-18.624s-52.16 6.88-75.328 18.624c-46.336-46.208-110.208-74.816-180.672-74.816-76.48 0-145.056 33.888-192 87.232v-359.232c0-26.464 21.536-48 48-48s48 21.536 48 48v48c0 17.664 14.304 32 32 32s32-14.336 32-32v-48c0-61.76-50.24-112-112-112s-112 50.24-112 112v528c0 141.152 114.848 256 256 256s256-114.848 256-256c0-46.944-12.928-90.848-35.072-128.704 22.592-7.744 47.52-7.744 70.112 0-22.112 37.888-35.040 81.76-35.040 128.704 0 141.152 114.848 256 256 256s256-114.848 256-256v-528c0-61.76-50.24-112-112-112zM256 896c-106.048 0-192-85.952-192-192s85.952-192 192-192 192 85.952 192 192-85.952 192-192 192zM768 896c-106.048 0-192-85.952-192-192s85.952-192 192-192 192 85.952 192 192-85.952 192-192 192zM256 544c-88.352 0-160 71.648-160 160s71.648 160 160 160 160-71.648 160-160-71.648-160-160-160zM256 832c-70.592 0-128-57.408-128-128s57.408-128 128-128 128 57.408 128 128-57.408 128-128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enhance",
						"see",
						"wear",
						"look"
					],
					"grid": 32
				},
				{
					"id": 2385,
					"paths": [
						"M128 320h-128v-256c0-35.346 28.654-64 64-64h256v128h-192v192z",
						"M1024 320h-128v-192h-192v-128h256c35.346 0 64 28.654 64 64v256z",
						"M960 1024h-256v-128h192v-192h128v256c0 35.346-28.654 64-64 64z",
						"M320 1024h-256c-35.346 0-64-28.654-64-64v-256h128v192h192v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"expand",
						"maximize",
						"fullscreen"
					],
					"defaultCode": 60220,
					"grid": 16
				},
				{
					"id": 1013,
					"width": 1024,
					"paths": [
						"M928 800h-64c0-17.664-14.336-32-32-32h-320c-17.664 0-32 14.336-32 32h-160v-320c0-42.816 27.808-78.976 67.36-91.072l138.144 276.32c3.808 7.584 10.464 13.344 18.496 16.032 8.064 2.656 16.864 2.048 24.448-1.728l28.608-14.304 17.696 35.36c7.904 15.776 27.072 22.24 42.944 14.304l57.248-28.64c15.808-7.904 22.208-27.136 14.304-42.944l-17.696-35.328 28.608-14.304c15.808-7.904 22.208-27.136 14.304-42.944l-256-512c-3.776-7.584-10.432-13.376-18.464-16.064-8.032-2.656-16.864-2.048-24.448 1.728l-171.712 85.888c-15.84 7.904-22.24 27.136-14.336 42.944l31.456 62.912c-103.488 45.216-172.96 148.832-172.96 263.84v320h-32c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h832c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM384 320c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM682.912 550.752l-114.464 57.248-24.832-49.696 114.464-57.248 24.832 49.696zM455.552 96l188.224 376.448-114.464 57.248-95.456-190.912c-1.12-2.24-2.656-4.128-4.224-5.984 11.328-11.552 18.368-27.328 18.368-44.8 0-35.36-28.64-64-64-64-2.88 0-5.632 0.48-8.416 0.832-0.512-1.696-0.48-3.52-1.28-5.152l-33.248-66.464 114.496-57.216zM192 480c0-87.36 51.648-166.24 129.056-202.592-0.576 3.456-1.056 6.944-1.056 10.592 0 20.096 9.44 37.824 23.936 49.536-52.672 26.208-87.936 80.064-87.936 142.464v352h-64v-352zM896 928h-768v-64h768v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"magnify",
						"zoom",
						"inspect"
					],
					"grid": 32
				},
				{
					"id": 2387,
					"paths": [
						"M1024 0h-416l160 160-192 192 96 96 192-192 160 160z",
						"M1024 1024v-416l-160 160-192-192-96 96 192 192-160 160z",
						"M0 1024h416l-160-160 192-192-96-96-192 192-160-160z",
						"M0 0v416l160-160 192 192 96-96-192-192 160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"expand",
						"maximize",
						"fullscreen"
					],
					"defaultCode": 60222,
					"grid": 16
				},
				{
					"id": 2389,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM960 960h-896v-896h896v896zM672 160l288-96-96 288zM336 256h32v64h-32zM400 256h32v64h-32zM464 256h32v64h-32zM528 256h32v64h-32zM592 256h32v64h-32zM656 256h32v64h-32zM336 704h32v64h-32zM400 704h32v64h-32zM464 704h32v64h-32zM528 704h32v64h-32zM592 704h32v64h-32zM656 704h32v64h-32zM256 656h64v32h-64zM256 592h64v32h-64zM256 528h64v32h-64zM256 464h64v32h-64zM256 400h64v32h-64zM256 336h64v32h-64zM704 656h64v32h-64zM704 592h64v32h-64zM704 528h64v32h-64zM704 464h64v32h-64zM704 400h64v32h-64zM704 336h64v32h-64zM160 352l-96-288 288 96zM352 864l-288 96 96-288zM864 672l96 288-288-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"expand",
						"maximize",
						"fullscreen"
					],
					"defaultCode": 60224,
					"grid": 16
				},
				{
					"id": 2391,
					"paths": [
						"M1024 352v-352h-352z",
						"M352 0h-352v352z",
						"M1024 1024v-352l-352 352z",
						"M0 1024h352l-352-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"expand",
						"maximize",
						"fullscreen"
					],
					"defaultCode": 60226,
					"grid": 16
				},
				{
					"id": 2393,
					"paths": [
						"M0 64v960h960v-960h-960zM896 960h-832v-832h832v832zM816 208h-672v672h672v-672zM784 848h-608v-608h608v608zM448 576h-128v-64h128v-128h64v128h128v64h-128v128h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"expand",
						"maximize",
						"fullscreen"
					],
					"defaultCode": 60228,
					"grid": 16
				},
				{
					"id": 2395,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM960 512v448h-896v-896h896v448z",
						"M896 128h-288l288 288z",
						"M128 896v-288l288 288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"expand",
						"maximize",
						"fullscreen"
					],
					"defaultCode": 60230,
					"grid": 16
				},
				{
					"id": 2397,
					"paths": [
						"M1024 0v416l-160-160-192 192-96-96 192-192-160-160zM448 672l-192 192 160 160h-416v-416l160 160 192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"expand",
						"maximize",
						"fullscreen"
					],
					"defaultCode": 60232,
					"grid": 16
				},
				{
					"id": 463,
					"width": 1024,
					"paths": [
						"M608 352c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM608 784c0-44.192 35.808-80 80-80s80 35.808 80 80c0 44.192-35.808 80-80 80s-80-35.808-80-80zM640 784c0 26.464 21.536 48 48 48s48-21.536 48-48-21.536-48-48-48-48 21.536-48 48zM896 928v32c0 17.664-14.336 32-32 32h-704c-17.664 0-32-14.336-32-32v-32c0-35.36 28.64-64 64-64h376.32c-6.56-9.824-11.488-20.672-15.488-32h-296.832c-17.664 0-32-14.336-32-32v-32c0-17.664 14.336-32 32-32h296.832c5.408-15.232 13.28-29.12 23.168-41.504v-246.496l-32-32h-64v64c0 17.664-14.336 32-32 32v32c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32v-32c-17.664 0-32-14.336-32-32v-64c-17.664 0-32-14.336-32-32v-160c0-17.664 14.336-32 32-32v-128c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32v128h120.224c25.472 0 49.888 10.112 67.872 28.128l103.776 103.776c18.016 17.984 28.128 42.4 28.128 67.872v302.752c19.712 24.64 32 55.488 32 89.504 0 29.6-8.992 57.12-24.32 80h24.32c35.36-0.032 64 28.608 64 63.968zM544 784c0-5.472 1.024-10.688 1.6-16h-289.6v32h289.6c-0.576-5.312-1.6-10.528-1.6-16zM320 192h128v-128h-128v128zM416 512h-64v32h64v-32zM448 416h-128v64h128v-64zM608 448v216.32c22.88-15.328 50.4-24.32 80-24.32s57.12 8.992 80 24.32v-272.544c0-16.96-6.752-33.248-18.752-45.248l-103.776-103.776c-12-12-28.256-18.752-45.248-18.752h-312.224v160h256c8.48 0 16.64 3.36 22.624 9.376l32 32c6.016 5.984 9.376 14.144 9.376 22.624zM576 784c0 61.76 50.24 112 112 112s112-50.24 112-112c0-61.76-50.24-112-112-112s-112 50.24-112 112zM832 896h-54.496c-24.64 19.712-55.488 32-89.504 32s-64.864-12.288-89.504-32h-406.496c-17.664 0-32 14.336-32 32v32h704v-32c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"experiment",
						"magnify",
						"zoom",
						"inspect"
					],
					"grid": 32
				},
				{
					"id": 464,
					"width": 1024,
					"paths": [
						"M288 416h256l32 32v200.352c30.464-25.184 69.504-40.352 112-40.352s81.536 15.168 112 40.352v-256.576c0-25.472-10.112-49.888-28.128-67.872l-103.776-103.776c-17.984-18.016-42.4-28.128-67.872-28.128h-312.224c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32zM640 320c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM320 544v-32c-17.664 0-32-14.336-32-32v-32h192v32c0 17.664-14.336 32-32 32v32c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32zM480 160h-192v-96c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32v96zM224 800v-32c0-17.664 14.336-32 32-32h262.816c-4.352 15.296-6.816 31.328-6.816 48s2.464 32.704 6.816 48h-262.816c-17.664 0-32-14.336-32-32zM896 928v32c0 17.664-14.336 32-32 32h-704c-17.664 0-32-14.336-32-32v-32c0-35.36 28.64-64 64-64h339.424c29.184 56.896 88.352 96 156.576 96 67.744 0 126.592-38.528 156-94.784 29.6 5.632 52 31.552 52 62.784zM736 784c0 26.464-21.536 48-48 48s-48-21.536-48-48 21.536-48 48-48 48 21.536 48 48zM688 640c-79.52 0-144 64.48-144 144s64.48 144 144 144 144-64.48 144-144-64.48-144-144-144zM688 864c-44.192 0-80-35.808-80-80s35.808-80 80-80 80 35.808 80 80c0 44.192-35.808 80-80 80z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enlarge",
						"experiment",
						"magnify",
						"zoom",
						"inspect"
					],
					"grid": 32
				},
				{
					"id": 2955,
					"paths": [
						"M448 832l288-288-288-288v192h-448v192h448v192z",
						"M960 1024h-704v-128h640v-704h-640v-128h704c35.346 0 64 28.654 64 64v832c0 35.346-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"signin",
						"login"
					],
					"defaultCode": 60790,
					"grid": 16
				},
				{
					"id": 198,
					"paths": [
						"M658.101 596.299c-9.997-9.997-26.206-9.997-36.203 0l-109.898 109.898v-629.397c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v629.397l-109.899-109.899c-9.997-9.997-26.206-9.997-36.203 0-9.998 9.997-9.998 26.206 0 36.203l153.6 153.6c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.101-7.499l153.6-153.6c9.998-9.997 9.998-26.205 0-36.202z",
						"M793.6 1024h-614.4c-42.347 0-76.8-34.451-76.8-76.8v-512c0-42.347 34.453-76.8 76.8-76.8h204.8c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-204.8c-14.115 0-25.6 11.485-25.6 25.6v512c0 14.115 11.485 25.6 25.6 25.6h614.4c14.115 0 25.6-11.485 25.6-25.6v-512c0-14.115-11.485-25.6-25.6-25.6h-204.8c-14.139 0-25.6-11.462-25.6-25.6s11.461-25.6 25.6-25.6h204.8c42.349 0 76.8 34.453 76.8 76.8v512c0 42.349-34.451 76.8-76.8 76.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter-down",
						"down",
						"download",
						"arrow"
					],
					"defaultCode": 59495,
					"grid": 20
				},
				{
					"id": 1014,
					"width": 1024,
					"paths": [
						"M1014.624 392.128l-123.552-123.552c-6.048-6.048-14.816-9.408-22.784-9.376-8.544 0.032-16.672 3.488-22.688 9.568-12.16 12.416-28.352 19.232-45.6 19.232-35.296 0-64-28.704-64-64 0-17.248 6.816-33.44 19.232-45.632 6.080-5.984 9.536-14.144 9.568-22.656s-3.328-16.736-9.376-22.752l-124.768-124.8c-6.016-6.016-14.144-9.408-22.656-9.408s-16.64 3.36-22.624 9.376l-574.784 574.784c-12.512 12.512-12.512 32.736 0 45.248l124.896 124.928c12.288 12.256 32.032 12.544 44.64 0.608 12.064-11.424 27.616-17.696 43.872-17.696 35.296 0 64 28.704 64 64 0 16.224-6.272 31.808-17.696 43.872-11.904 12.608-11.616 32.384 0.64 44.64l123.648 123.68c6.016 6.016 14.112 9.376 22.624 9.376s16.64-3.36 22.624-9.376l574.784-574.752c6.016-6.048 9.376-14.176 9.376-22.688s-3.36-16.608-9.376-22.624zM490.688 193.312l338.752 338.752-297.376 297.376-338.752-338.752 297.376-297.376zM417.216 944.288l-81.696-81.728c10.752-18.976 16.48-40.448 16.48-62.56 0-70.592-57.408-128-128-128-22.112 0-43.584 5.728-62.592 16.48l-82.944-82.944 92.224-92.224 338.752 338.752-92.224 92.224zM852.064 509.44l-338.752-338.752 94.688-94.688 82.176 82.208c-11.84 19.712-18.176 42.24-18.176 65.792 0 70.592 57.408 128 128 128 23.552 0 46.112-6.336 65.792-18.208l80.96 80.96-94.688 94.688zM340.672 532.672l192-192 22.624 22.624-192 192-22.624-22.624zM404.672 596.672l192-192 22.624 22.624-192 192-22.624-22.624zM468.672 660.672l192-192 22.624 22.624-192 192-22.624-22.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"access"
					],
					"grid": 32
				},
				{
					"id": 2957,
					"paths": [
						"M960 0v1024h-768v-320h64v192h448v-768h-448v192h-64v-320zM384 576h-384v-128h384v-192l256 256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"signin",
						"login"
					],
					"defaultCode": 60792,
					"grid": 16
				},
				{
					"id": 2959,
					"paths": [
						"M384 512h-320v-128h320v-128l192 192-192 192zM1024 0v832l-384 192v-192h-384v-256h64v192h320v-576l256-128h-576v256h-64v-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"signin",
						"login"
					],
					"defaultCode": 60794,
					"grid": 16
				},
				{
					"id": 3156,
					"paths": [
						"M1024 64h-192v448h-480l160-160-128-128-384 384 384 384 128-128-160-160h672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"return",
						"arrow"
					],
					"defaultCode": 60991,
					"grid": 16
				},
				{
					"id": 3157,
					"paths": [
						"M832 64v448h-384v-288l-384 384 384 384v-288h576v-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"return",
						"arrow"
					],
					"defaultCode": 60992,
					"grid": 16
				},
				{
					"id": 3159,
					"paths": [
						"M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512-512-229.23-512-512h128c0 212.078 171.922 384 384 384 212.076 0 384-171.922 384-384s-171.924-384-384-384v-128z",
						"M157.964 66.040l336 335.998 146.036-146.038v384h-384l146.040-146.038-336-336z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"arrow",
						"in"
					],
					"defaultCode": 60994,
					"grid": 16
				},
				{
					"id": 126,
					"paths": [
						"M896 102.4h-460.8c-42.347 0-76.8 34.453-76.8 76.8v153.6c0 14.138 11.462 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-153.6c0-14.115 11.485-25.6 25.6-25.6h387.278l-196.702 84.301c-35.088 15.038-62.576 56.723-62.576 94.899v486.4h-128c-14.115 0-25.6-11.485-25.6-25.6v-153.6c0-14.139-11.462-25.6-25.6-25.6s-25.6 11.461-25.6 25.6v153.6c0 42.347 34.453 76.8 76.8 76.8h128v76.8c0 22.181 9.234 40.99 25.331 51.606 8.886 5.861 19.243 8.814 30.171 8.814 8.867 0 18.109-1.946 27.242-5.859l264.277-113.261c35.091-15.038 62.579-56.723 62.579-94.901v-614.4c0-42.347-34.451-76.8-76.8-76.8zM921.6 793.6c0 17.963-15.035 40.765-31.546 47.838l-264.277 113.261c-4.912 2.107-8.163 1.955-9.062 1.363-0.894-0.59-2.315-3.518-2.315-8.862v-614.4c0-17.962 15.035-40.763 31.546-47.838l273.043-117.019c1.672 3.4 2.611 7.221 2.611 11.258v614.4z",
						"M427.701 468.299l-153.6-153.6c-9.997-9.998-26.206-9.998-36.203 0s-9.998 26.206 0 36.203l109.899 109.898h-322.197c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h322.197l-109.898 109.899c-9.998 9.997-9.998 26.206 0 36.203 4.998 4.998 11.549 7.498 18.101 7.498s13.102-2.499 18.101-7.499l153.6-153.6c9.998-9.997 9.998-26.205 0-36.202z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"door",
						"sign-in",
						"log-in",
						"login"
					],
					"defaultCode": 59423,
					"grid": 20
				},
				{
					"id": 465,
					"width": 1024,
					"paths": [
						"M931.424 448h28.576c17.664 0 32-14.336 32-32v-128c0-53.024-42.976-96-96-96h-768c-53.024 0-96 42.976-96 96v128c0 17.664 14.336 32 32 32h28.576c31.872 0 61.44 21.792 66.56 53.248 6.496 40.096-24.256 74.752-63.136 74.752h-32c-17.664 0-32 14.336-32 32v128c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-128c0-17.664-14.336-32-32-32h-32c-38.88 0-69.632-34.656-63.136-74.752 5.12-31.456 34.688-53.248 66.56-53.248zM854.848 574.176c18.272 21.504 44.96 33.824 73.152 33.824h32v128c0 35.296-28.704 64-64 64h-224v-16c0-8.832-7.168-16-16-16s-16 7.168-16 16v16h-512c-35.296 0-64-28.704-64-64v-128h32c28.192 0 54.88-12.32 73.152-33.824s26.144-49.952 21.568-78.048c-7.456-45.696-49.632-80.128-98.144-80.128h-28.576v-128c0-35.296 28.704-64 64-64h512v16c0 8.832 7.168 16 16 16s16-7.168 16-16v-16h224c35.296 0 64 28.704 64 64v128h-28.576c-48.512 0-90.688 34.432-98.144 80.128-4.576 28.096 3.296 56.544 21.568 78.048zM672 304v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 400v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 496v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 592v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 688v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM512 432c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16zM512 496c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16zM512 560c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"tear",
						"admit"
					],
					"grid": 32
				},
				{
					"id": 466,
					"width": 1024,
					"paths": [
						"M931.424 448h28.576c17.664 0 32-14.336 32-32v-128c0-53.024-42.976-96-96-96h-224v48c0 8.832-7.168 16-16 16s-16-7.168-16-16v-48h-512c-53.024 0-96 42.976-96 96v128c0 17.664 14.336 32 32 32h28.576c31.872 0 61.44 21.792 66.56 53.248 6.496 40.096-24.256 74.752-63.136 74.752h-32c-17.664 0-32 14.336-32 32v128c0 53.024 42.976 96 96 96h512v-48c0-8.832 7.168-16 16-16s16 7.168 16 16v48h224c53.024 0 96-42.976 96-96v-128c0-17.664-14.336-32-32-32h-32c-38.88 0-69.632-34.656-63.136-74.752 5.12-31.456 34.688-53.248 66.56-53.248zM496 576h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16zM496 512h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16zM496 448h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16zM672 720c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 624c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 528c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 432c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 336c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"enter",
						"tear",
						"admit"
					],
					"grid": 32
				},
				{
					"id": 2117,
					"paths": [
						"M960 128h-896c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64zM373.174 625.478l-192 139.636c-6.392 4.648-13.802 6.886-21.144 6.886-11.126 0-22.098-5.14-29.144-14.828-11.694-16.078-8.14-38.594 7.94-50.29l192-139.636c16.078-11.692 38.594-8.138 50.288 7.942s8.14 38.596-7.94 50.29zM893.116 757.174c-7.044 9.688-18.020 14.828-29.144 14.828-7.344 0-14.752-2.238-21.144-6.886l-192.006-139.64c-16.080-11.696-19.634-34.208-7.942-50.29 11.694-16.084 34.21-19.632 50.29-7.942l192.006 139.64c16.078 11.696 19.632 34.21 7.94 50.29zM885.174 317.114l-352 256c-6.31 4.592-13.742 6.886-21.174 6.886s-14.862-2.294-21.174-6.884l-352-256c-16.080-11.694-19.634-34.208-7.94-50.288 11.696-16.080 34.212-19.632 50.288-7.94l330.826 240.598 330.826-240.6c16.076-11.696 38.592-8.138 50.29 7.94 11.692 16.080 8.138 38.594-7.942 50.288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envelop",
						"mail",
						"email",
						"contact",
						"letter"
					],
					"defaultCode": 59952,
					"grid": 16
				},
				{
					"id": 2118,
					"paths": [
						"M959.884 192c0.040 0.034 0.082 0.076 0.116 0.116v639.77c-0.034 0.040-0.076 0.082-0.116 0.116h-895.77c-0.040-0.034-0.082-0.076-0.114-0.116v-639.772c0.034-0.040 0.076-0.082 0.114-0.114h895.77zM960 128h-896c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64v0z",
						"M373.174 625.478l-192 139.634c-6.392 4.65-13.802 6.888-21.144 6.888-11.126 0-22.098-5.14-29.144-14.828-11.694-16.078-8.14-38.594 7.94-50.29l192-139.636c16.078-11.692 38.594-8.136 50.288 7.942 11.694 16.080 8.14 38.598-7.94 50.29z",
						"M893.116 757.174c-7.042 9.69-18.020 14.828-29.142 14.828-7.344 0-14.752-2.238-21.144-6.884l-192.006-139.64c-16.080-11.696-19.634-34.208-7.942-50.292 11.692-16.082 34.208-19.63 50.29-7.942l192.006 139.638c16.076 11.698 19.63 34.212 7.938 50.292z",
						"M885.174 317.114l-352 256c-6.31 4.594-13.742 6.886-21.174 6.886s-14.862-2.292-21.174-6.882l-352-256c-16.080-11.694-19.634-34.208-7.94-50.288s34.212-19.632 50.288-7.94l330.826 240.596 330.826-240.6c16.076-11.696 38.592-8.138 50.29 7.94 11.692 16.080 8.138 38.594-7.942 50.288v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envelop",
						"mail",
						"email",
						"contact",
						"letter"
					],
					"defaultCode": 59953,
					"grid": 16
				},
				{
					"id": 2119,
					"paths": [
						"M960 128h-896c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64zM896 256v46l-384 226.286-384-226.286v-46h768zM128 768v-354.572l384 226.286 384-226.286v354.572h-768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envelop",
						"mail",
						"email",
						"contact",
						"letter"
					],
					"defaultCode": 59954,
					"grid": 16
				},
				{
					"id": 2120,
					"paths": [
						"M928 128h-832c-52.8 0-96 43.2-96 96v640c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-640c0-52.8-43.2-96-96-96zM398.74 550.372l-270.74 210.892v-501.642l270.74 290.75zM176.38 256h671.24l-335.62 252-335.62-252zM409.288 561.698l102.712 110.302 102.71-110.302 210.554 270.302h-626.528l210.552-270.302zM625.26 550.372l270.74-290.75v501.642l-270.74-210.892z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envelop",
						"mail",
						"email",
						"contact",
						"letter"
					],
					"defaultCode": 59955,
					"grid": 16
				},
				{
					"id": 2121,
					"paths": [
						"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.798 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM896 320l-384 288-384-288v-64l384 192 384-192v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envelop",
						"mail",
						"email",
						"contact",
						"letter"
					],
					"defaultCode": 59956,
					"grid": 16
				},
				{
					"id": 1377,
					"width": 1024.002155303955,
					"paths": [
						"M1024 405.714v453.714q0 37.714-26.857 64.571t-64.571 26.857h-841.143q-37.714 0-64.571-26.857t-26.857-64.571v-453.714q25.143 28 57.714 49.714 206.857 140.571 284 197.143 32.571 24 52.857 37.429t54 27.429 62.857 14h1.143q29.143 0 62.857-14t54-27.429 52.857-37.429q97.143-70.286 284.571-197.143 32.571-22.286 57.143-49.714zM1024 237.714q0 45.143-28 86.286t-69.714 70.286q-214.857 149.143-267.429 185.714-5.714 4-24.286 17.429t-30.857 21.714-29.714 18.571-32.857 15.429-28.571 5.143h-1.143q-13.143 0-28.571-5.143t-32.857-15.429-29.714-18.571-30.857-21.714-24.286-17.429q-52-36.571-149.714-104.286t-117.143-81.429q-35.429-24-66.857-66t-31.429-78q0-44.571 23.714-74.286t67.714-29.714h841.143q37.143 0 64.286 26.857t27.143 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envelope"
					],
					"defaultCode": 61664,
					"grid": 14
				},
				{
					"id": 1182,
					"width": 1024.0009956359863,
					"paths": [
						"M950.857 859.429v-438.857q-18.286 20.571-39.429 37.714-153.143 117.714-243.429 193.143-29.143 24.571-47.429 38.286t-49.429 27.714-58.571 14h-1.143q-27.429 0-58.571-14t-49.429-27.714-47.429-38.286q-90.286-75.429-243.429-193.143-21.143-17.143-39.429-37.714v438.857q0 7.429 5.429 12.857t12.857 5.429h841.143q7.429 0 12.857-5.429t5.429-12.857zM950.857 258.857v-14t-0.286-7.429-1.714-7.143-3.143-5.143-5.143-4.286-8-1.429h-841.143q-7.429 0-12.857 5.429t-5.429 12.857q0 96 84 162.286 110.286 86.857 229.143 181.143 3.429 2.857 20 16.857t26.286 21.429 25.429 18 28.857 15.714 24.571 5.143h1.143q11.429 0 24.571-5.143t28.857-15.714 25.429-18 26.286-21.429 20-16.857q118.857-94.286 229.143-181.143 30.857-24.571 57.429-66t26.571-75.143zM1024 237.714v621.714q0 37.714-26.857 64.571t-64.571 26.857h-841.143q-37.714 0-64.571-26.857t-26.857-64.571v-621.714q0-37.714 26.857-64.571t64.571-26.857h841.143q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envelope-o"
					],
					"defaultCode": 61443,
					"grid": 14
				},
				{
					"id": 1549,
					"width": 877.7150573730469,
					"paths": [
						"M713.143 73.143q68 0 116.286 48.286t48.286 116.286v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571zM731.429 676.571v-249.143q-17.714 20-36.571 31.429-19.429 12.571-75.714 48.571t-86.571 56.571q-56 39.429-93.714 39.429v0 0q-37.714 0-93.714-39.429-26.286-18.286-80.857-52.857t-81.429-52.857q-6.857-4.571-18.857-15.429t-17.714-15.429v249.143q0 22.857 16 38.857t38.857 16h475.429q22.857 0 38.857-16t16-38.857zM731.429 349.143q0-23.429-15.714-40t-39.143-16.571h-475.429q-22.857 0-38.857 16t-16 38.857q0 21.143 17.429 43.714t38.571 36.857q26.857 18.286 78.571 50.857t74 47.429q1.714 1.143 9.714 6.571t12 8 12 7.429 13.429 7.429 12.286 5.429 12.857 4.286 11.714 1.429 11.714-1.429 12.857-4.286 12.286-5.429 13.429-7.429 12-7.429 12-8 9.714-6.571l152.571-99.429q20-13.143 38-35.714t18-42z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envelope-square"
					],
					"defaultCode": 61849,
					"grid": 14
				},
				{
					"id": 119,
					"paths": [
						"M896 307.2h-819.2c-42.347 0-76.8 34.453-76.8 76.8v460.8c0 42.349 34.453 76.8 76.8 76.8h819.2c42.349 0 76.8-34.451 76.8-76.8v-460.8c0-42.347-34.451-76.8-76.8-76.8zM896 358.4c1.514 0 2.99 0.158 4.434 0.411l-385.632 257.090c-14.862 9.907-41.938 9.907-56.802 0l-385.634-257.090c1.443-0.253 2.92-0.411 4.434-0.411h819.2zM896 870.4h-819.2c-14.115 0-25.6-11.485-25.6-25.6v-438.566l378.4 252.267c15.925 10.618 36.363 15.925 56.8 15.925s40.877-5.307 56.802-15.925l378.398-252.267v438.566c0 14.115-11.485 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envelope",
						"mail",
						"letter",
						"email"
					],
					"defaultCode": 59416,
					"grid": 20
				},
				{
					"id": 1787,
					"width": 1023.9999771118164,
					"paths": [
						"M512 466.286q-59.429-112-91.429-158.857-79.429-115.429-198.286-181.714-19.429-10.857-40-20.571-50.857-22.857-53.714-18.286t19.429 21.714l22.286 17.714q35.429 24.571 64.286 53.429t54 66.571 40.286 64.571 40.286 74.857q5.143 9.714 7.429 14.286 25.143 48 48 87.429t56 88 66 85.714 74.857 70.571 84.857 51.714q87.429 37.714 88 34.286 0.571-1.714-28-21.143-30.286-20.571-46.286-32.571-44-33.143-102.286-120.571t-105.714-177.143zM313.714 776.571q-43.429-34.286-75.714-71.429t-56-82-40.571-88.286-33.429-106.286-29.714-119.429-34.571-144-43.714-165.143q156 0 284.286 20.571t216.571 52.571 154.857 82.571 106 98.571 62.857 113.429 32 114 7.143 113.429-5.429 98.857-11.429 82-7.429 61.143l184.571 186.857h-59.429l-160.571-162.857q-12.571 1.143-52.286 8t-69.429 10.857-78.857 3.429-91.714-9.714-95.714-33.714-102.286-63.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envira"
					],
					"defaultCode": 62105,
					"grid": 14
				},
				{
					"id": 1015,
					"width": 1024,
					"paths": [
						"M96 832c-52.928 0-96 43.072-96 96s43.072 96 96 96 96-43.072 96-96-43.072-96-96-96zM96 960c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM922.208 342.016c3.84-17.76 5.792-35.872 5.792-54.016 0-141.152-114.848-256-256-256-49.952 0-98.72 14.72-140.224 41.952-47.712-47.328-111.712-73.952-179.776-73.952-139.776 0-253.76 112.608-255.968 251.904-61.216 60.096-96.032 142.368-96.032 228.096 0 103.36 48.736 198.144 131.648 258.336-2.432 9.76-3.648 19.68-3.648 29.664 0 70.592 57.408 128 128 128 10.88 0 21.6-1.408 32.032-4.192 44.64 81.248 129.44 132.192 223.968 132.192 91.936 0 177.28-50.368 222.464-129.76 163.808-15.328 289.536-151.648 289.536-318.24 0-89.344-36.832-173.504-101.792-233.984zM256 832c-35.296 0-64-28.704-64-64s28.704-64 64-64c35.296 0 64 28.704 64 64s-28.704 64-64 64zM713.28 831.488l-19.456 0.704-8.32 17.6c-31.68 66.944-99.776 110.208-173.504 110.208-79.040 0-149.024-47.552-178.304-121.12l-4-10.048c13.728-16.608 22.304-37.6 22.304-60.832 0-53.024-42.976-96-96-96-26.176 0-49.824 10.528-67.136 27.52l-1.92-1.184c-76.992-47.008-122.944-128.64-122.944-218.336 0-72.576 31.264-142.112 85.792-190.784l11.264-10.048-1.056-23.168c0-105.888 86.112-192 192-192 58.816 0 113.664 26.592 150.4 72.896l20.544 25.888 25.216-21.344c34.592-29.312 78.592-45.44 123.84-45.44 105.888 0 192 86.112 192 192 0 18.848-2.784 37.632-8.32 55.84l-6.208 20.48 16.576 13.568c59.712 48.864 93.952 121.088 93.952 198.112 0 138.304-108.384 250.56-246.72 255.488zM384 480h-32v-64h32v64zM640 416h32v64h-32v-64zM398.848 515.872l45.248 45.248-22.624 22.624-45.248-45.248 22.624-22.624zM625.152 380.128l-45.248-45.248 22.624-22.624 45.248 45.248-22.624 22.624zM448 608h128v32h-128v-32zM448 672h128v32h-128v-32zM544 320h-64v-32h64v32zM625.152 515.872l22.624 22.624-45.248 45.248-22.624-22.624 45.248-45.248zM421.504 312.224l22.624 22.624-45.248 45.248-22.624-22.624 45.248-45.248zM480 736h64v32h-64v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"envision",
						"think",
						"imagine",
						"invent"
					],
					"grid": 32
				},
				{
					"id": 1016,
					"width": 1024,
					"paths": [
						"M512 0c-282.784 0-512 229.216-512 512s229.216 512 512 512 512-229.216 512-512-229.216-512-512-512zM512 960c-247.040 0-448-200.96-448-448s200.96-448 448-448 448 200.96 448 448-200.96 448-448 448zM512 96c-229.76 0-416 186.24-416 416s186.24 416 416 416 416-186.24 416-416-186.24-416-416-416zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384zM736 544h-448c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h448c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM736 640h-448v-64h448v64zM736 352h-448c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h448c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM736 448h-448v-64h448v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"equal",
						"match"
					],
					"grid": 32
				},
				{
					"id": 2416,
					"paths": [
						"M448 128v-16c0-26.4-21.6-48-48-48h-160c-26.4 0-48 21.6-48 48v16h-192v128h192v16c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-16h576v-128h-576zM256 256v-128h128v128h-128zM832 432c0-26.4-21.6-48-48-48h-160c-26.4 0-48 21.6-48 48v16h-576v128h576v16c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-16h192v-128h-192v-16zM640 576v-128h128v128h-128zM448 752c0-26.4-21.6-48-48-48h-160c-26.4 0-48 21.6-48 48v16h-192v128h192v16c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-16h576v-128h-576v-16zM256 896v-128h128v128h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"equalizer",
						"sliders",
						"settings",
						"preferences",
						"dashboard",
						"control"
					],
					"defaultCode": 60251,
					"grid": 16
				},
				{
					"id": 2417,
					"paths": [
						"M896 448h16c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-192h-128v192h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h16v576h128v-576zM768 256h128v128h-128v-128zM592 832c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-576h-128v576h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h16v192h128v-192h16zM448 640h128v128h-128v-128zM272 448c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-192h-128v192h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h16v576h128v-576h16zM128 256h128v128h-128v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"equalizer",
						"sliders",
						"settings",
						"preferences",
						"dashboard",
						"control"
					],
					"defaultCode": 60252,
					"grid": 16
				},
				{
					"id": 2418,
					"paths": [
						"M288 320h-128c-17.6 0-32 14.4-32 32v64c0 17.6 14.4 32 32 32h128c17.6 0 32-14.4 32-32v-64c0-17.6-14.4-32-32-32zM192 128h64v160h-64zM192 480h64v416h-64zM544 576h-128c-17.6 0-32 14.4-32 32v64c0 17.6 14.4 32 32 32h128c17.602 0 32-14.4 32-32v-64c0-17.6-14.398-32-32-32zM448.002 128h64v416h-64zM448.002 736h64v160h-64zM800 384h-128c-17.598 0-32 14.4-32 32v64c0 17.6 14.402 32 32 32h128c17.602 0 32-14.4 32-32v-64c0-17.6-14.398-32-32-32zM704 128h64v224h-64zM704 544h64v352h-64zM880 0h-800c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h800c44.112 0 80-35.888 80-80v-864c0-44.112-35.888-80-80-80zM896 944c0 8.8-7.2 16-16 16h-800c-8.8 0-16-7.2-16-16v-864c0-8.8 7.2-16 16-16h800c8.8 0 16 7.2 16 16v864z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"equalizer",
						"sliders",
						"settings",
						"preferences",
						"dashboard",
						"control"
					],
					"defaultCode": 60253,
					"grid": 16
				},
				{
					"id": 2419,
					"paths": [
						"M960 64h-896c-35.2 0-64 28.8-64 64v768c0 35.202 28.794 64 64 64h896c35.2 0 64-28.798 64-64v-768c0-35.2-28.8-64-64-64zM960 895.886c-0.040 0.040-0.074 0.082-0.122 0.114h-895.764c-0.038-0.034-0.080-0.076-0.112-0.114v-767.772c0.034-0.038 0.076-0.078 0.114-0.114h895.77c0.042 0.036 0.082 0.076 0.12 0.114l-0.006 767.772zM432 704h-48v-512h-128v512h-48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16zM592 320h48v512h128v-512h48c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-224c-8.798 0-16 7.2-16 16v96c0 8.8 7.202 16 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"equalizer",
						"sliders",
						"settings",
						"preferences",
						"dashboard",
						"control"
					],
					"defaultCode": 60254,
					"grid": 16
				},
				{
					"id": 467,
					"width": 1024,
					"paths": [
						"M956.128 572.128l-504.256-504.256c-18.72-18.72-43.296-28.096-67.872-28.096s-49.152 9.376-67.872 28.128l-248.256 248.224c-37.504 37.504-37.504 98.272 0 135.776l504.224 504.224c18.752 18.752 43.328 28.128 67.872 28.128s49.152-9.376 67.872-28.128l248.224-248.224c37.536-37.504 37.536-98.304 0.064-135.776zM90.496 338.752l248.224-248.224c12.096-12.096 28.16-18.752 45.248-18.752s33.152 6.656 45.248 18.752l240.8 240.8-338.688 338.72-240.8-240.8c-24.96-24.96-24.96-65.536-0.032-90.496zM933.504 685.248l-248.224 248.224c-12.096 12.096-28.16 18.752-45.248 18.752s-33.152-6.656-45.248-18.752l-240.8-240.8 338.752-338.752 240.8 240.8c24.896 24.992 24.896 65.568-0.032 90.528z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"erase",
						"delete",
						"remove"
					],
					"grid": 32
				},
				{
					"id": 468,
					"width": 1024,
					"paths": [
						"M308.672 692.672l-240.8-240.8c-37.504-37.504-37.504-98.272 0-135.776l248.224-248.224c18.752-18.72 43.328-28.096 67.904-28.096s49.152 9.376 67.872 28.128l240.8 240.8-384 383.968zM956.128 572.128l-240.8-240.8-384 384 240.8 240.8c18.752 18.752 43.328 28.128 67.872 28.128s49.152-9.376 67.872-28.128l248.224-248.224c37.504-37.504 37.504-98.304 0.032-135.776z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"erase",
						"delete",
						"remove"
					],
					"grid": 32
				},
				{
					"id": 1017,
					"width": 1024,
					"paths": [
						"M1001.376 425.376l-288-288c-6.016-6.016-14.144-9.376-22.624-9.376h-101.504c-8.48 0-16.64 3.36-22.624 9.376l-544 544c-12.512 12.512-12.512 32.768 0 45.248l233.376 233.376h256l489.376-489.376c12.48-12.48 12.48-32.768 0-45.248zM485.504 896h-203.008l-192-192 223.936-223.936h78.88l-207.808 207.808c-6.24 6.24-6.24 16.384 0 22.624l128 128c3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-116.736-116.672 212.576-212.576 231.424 231.424-177.92 177.952zM686.048 695.424l-231.424-231.424 196.672-196.672c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-203.36 203.36h-78.88l256.064-256.064h74.976l256 256-247.424 247.424z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"erase",
						"delete",
						"remove"
					],
					"grid": 32
				},
				{
					"id": 1834,
					"paths": [
						"M959.688 279.398c-3.682-56.024-42.77-92.21-74.302-106.744-0.186-0.086-3.49-1.562-4.922-2.136l-201.156-80.46c-13.002-5.202-27.32-7.838-42.562-7.838-36.582 0-73.054 15.462-95.182 40.354 0 0-429.738 483.604-431.036 485.276-0.048 0.052-0.092 0.096-0.138 0.15-28.134 32-46.39 64-46.39 128v64c0 48.036 34.936 99.638 79.538 117.48l189.076 75.664c29.188 11.376 77.81 37.384 137.188-15.566 4.268-3.446 8.484-7.484 12.634-12.152l4.804-5.406c0.006-0.006 0.012-0.012 0.018-0.020v0l422.136-474.906c28.38-31.92 50.606-90.382 50.606-133.094v-64c0-1.7-0.304-8.502-0.312-8.602zM162.438 645.426l426.96-480.332c10.036-11.29 29.062-18.874 47.348-18.874 6.962 0 13.46 1.126 18.792 3.26l201.156 80.46c5.596 2.24 9.512 5.488 10.216 8.48 0.708 2.992-1.342 7.648-5.348 12.154l-426.96 480.332c-10.036 11.29-29.062 18.874-47.346 18.874-6.962 0-13.462-1.126-18.794-3.26l-201.154-80.46c-5.598-2.238-9.512-5.488-10.218-8.48s1.344-7.65 5.348-12.154zM128 800v-64c0-12.482 4.82-12.482 6.878-12.482 1.712 0 4.604 0.34 8.66 1.962l201.154 80.46c20.574 8.232 39.308 35.904 39.308 58.060v64c0 12.482-4.82 12.482-6.878 12.482-1.712 0-4.604-0.34-8.66-1.962l-201.154-80.46c-20.572-8.232-39.308-35.904-39.308-58.060zM896 352c0 27.128-16.414 70.3-34.438 90.574l-413.562 465.26v-43.834c0-27.126 16.414-70.298 34.436-90.574l413.564-465.26v43.834z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eraser",
						"rubber",
						"clear"
					],
					"defaultCode": 59669,
					"grid": 16
				},
				{
					"id": 1835,
					"paths": [
						"M959.89 283.032c-0.042-1.122-0.194-3.536-0.202-3.634-3.682-56.024-42.77-92.21-74.302-106.744-0.186-0.086-3.49-1.562-4.922-2.136l-201.156-80.46c-13.002-5.202-27.32-7.838-42.562-7.838-36.582 0-73.054 15.462-95.182 40.354l-426.96 480.332c-1.436 1.616-2.778 3.272-4.076 4.944-0.048 0.052-0.092 0.096-0.138 0.15-28.134 32-46.39 64-46.39 128v64c0 48.036 34.936 99.638 79.538 117.48l189.076 75.664c29.188 11.376 77.81 37.384 137.188-15.566 4.268-3.446 8.484-7.484 12.634-12.152l4.804-5.406c0.006-0.006 0.012-0.012 0.018-0.020l422.136-474.906c28.38-31.92 50.606-90.382 50.606-133.094v-64c0-1.7-0.042-3.346-0.11-4.968zM589.396 165.094c10.036-11.29 29.062-18.874 47.348-18.874 6.962 0 13.46 1.126 18.792 3.26l201.156 80.46c5.596 2.24 9.512 5.488 10.216 8.48 0.708 2.992-1.342 7.648-5.348 12.154l-250.52 281.842-256.832-102.734 235.188-264.588zM896 352c0 27.128-16.414 70.3-34.438 90.574l-221.562 249.26v-95.668l256-288v43.834z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eraser",
						"rubber",
						"clear"
					],
					"defaultCode": 59670,
					"grid": 16
				},
				{
					"id": 1836,
					"paths": [
						"M959.688 279.398c-3.682-56.024-42.77-92.21-74.302-106.744-0.186-0.086-3.49-1.562-4.922-2.136l-201.156-80.46c-13.002-5.202-27.32-7.838-42.562-7.838-36.582 0-73.054 15.462-95.182 40.354 0 0-429.738 483.604-431.036 485.276-0.048 0.052-0.092 0.096-0.138 0.15-28.134 32-46.39 64-46.39 128v64c0 48.036 34.936 99.638 79.538 117.48l189.076 75.664c29.188 11.376 77.81 37.384 137.188-15.566 4.268-3.446 8.484-7.484 12.634-12.152l4.804-5.406c0.006-0.006 0.012-0.012 0.018-0.020v0l422.136-474.906c28.38-31.92 50.606-90.382 50.606-133.094v-64c0-1.7-0.304-8.502-0.312-8.602zM162.438 645.426l426.96-480.332c10.036-11.29 29.062-18.874 47.348-18.874 6.962 0 13.46 1.126 18.792 3.26l201.156 80.46c5.596 2.24 9.512 5.488 10.216 8.48 0.708 2.992-1.342 7.648-5.348 12.154l-426.96 480.332c-10.036 11.29-29.062 18.874-47.346 18.874-6.962 0-13.462-1.126-18.794-3.26l-201.154-80.46c-5.598-2.238-9.512-5.488-10.218-8.48s1.344-7.65 5.348-12.154z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eraser",
						"rubber",
						"clear"
					],
					"defaultCode": 59671,
					"grid": 16
				},
				{
					"id": 1448,
					"width": 1097.143144607544,
					"paths": [
						"M512 804.571l192-219.429h-438.857l-192 219.429h438.857zM1090.857 189.143q8.571 19.429 5.429 40.857t-17.429 37.429l-512 585.143q-21.714 25.143-54.857 25.143h-438.857q-21.714 0-39.714-11.714t-27.143-31.143q-8.571-19.429-5.429-40.857t17.429-37.429l512-585.143q21.714-25.143 54.857-25.143h438.857q21.714 0 39.714 11.714t27.143 31.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eraser"
					],
					"defaultCode": 61741,
					"grid": 14
				},
				{
					"id": 3158,
					"paths": [
						"M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512-512-229.23-512-512h128c0 212.078 171.922 384 384 384 212.076 0 384-171.922 384-384s-171.924-384-384-384v-128z",
						"M482.038 573.96l-336-335.998-146.038 146.038v-384h384l-146.038 146.038 336 336z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"esc",
						"escape",
						"arrow",
						"out"
					],
					"defaultCode": 60993,
					"grid": 16
				},
				{
					"id": 1483,
					"width": 579.4269704818726,
					"paths": [
						"M557.714 746.857l20 90.857q1.714 6.857-1.714 12.857t-9.714 8.286l-2.857 0.571q-2.286 1.143-6 2t-9.143 2.571-12.286 3.143-14.571 2.857-17.143 2.857-19.143 2.571-20.857 1.714-22 0.571q-133.714 0-233.714-74.571t-136-200.857h-54.286q-7.429 0-12.857-5.429t-5.429-12.857v-64.571q0-7.429 5.429-12.857t12.857-5.429h37.714q-1.143-32.571 0.571-60h-38.286q-8 0-13.143-5.143t-5.143-13.143v-65.143q0-8 5.143-13.143t13.143-5.143h56q38.286-120 139.143-193.143t228.857-73.143q58.286 0 110.857 13.143 6.286 1.714 11.429 8.571 3.429 6.286 1.714 13.714l-24.571 90.857q-1.714 7.429-8 11.143t-13.714 1.429l-2.286-0.571q-2.286-0.571-6.571-1.429l-10-2t-12.857-2-14.857-1.714-16.571-1.429-16.857-0.571q-72 0-129.143 36.571t-85.714 100.571h267.429q9.143 0 14.286 6.857 5.714 6.857 4 14.857l-13.714 65.143q-2.857 14.857-18.286 14.857h-278.857q-1.714 21.143 0 60h262.286q8.571 0 14.286 6.857 5.143 6.857 3.429 15.429l-13.714 64q-1.143 6.286-6.286 10.571t-11.429 4.286h-221.143q27.429 66.857 85.429 106t130.571 39.143q10.286 0 20.571-0.857t19.143-2 16.857-2.571 14-2.857 10.571-2.571l6.857-1.714 2.857-1.143q7.429-2.857 14.857 1.143 6.857 4 8.571 12z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eur",
						"euro"
					],
					"defaultCode": 61779,
					"grid": 14
				},
				{
					"id": 2855,
					"paths": [
						"M639.996 448c-35.346 0-64-28.654-63.998-64.002 0-1.17 0.036-2.33 0.098-3.484 2.032-47.454 45.212-78.946 81.592-97.138 34.742-17.37 69.102-26.060 70.548-26.422 17.146-4.288 34.518 6.138 38.806 23.284 4.284 17.146-6.14 34.518-23.284 38.806-17.626 4.45-38.522 12.12-56.936 21.35 10.648 11.43 17.174 26.752 17.174 43.606 0 35.346-28.654 64-64 64zM280.242 319.044c-17.144-4.286-27.568-21.66-23.282-38.804 4.286-17.146 21.66-27.572 38.806-23.284 1.444 0.362 35.806 9.050 70.548 26.422 36.382 18.19 79.56 49.684 81.592 97.138 0.062 1.154 0.098 2.316 0.098 3.484 0 35.346-28.654 64-64 64s-64-28.654-64-64c0-16.854 6.526-32.176 17.174-43.606-18.414-9.23-39.312-16.9-56.936-21.35zM512 736c81.554 0 152.924-43.592 192.098-108.74l82.328 49.396c-55.962 93.070-157.916 155.344-274.426 155.344s-218.464-62.274-274.426-155.344l82.328-49.396c39.174 65.148 110.542 108.74 192.098 108.74zM1024 64c0-45.516-9.524-88.8-26.652-128-33.576 76.836-96.448 137.932-174.494 169.178-86.194-65.96-193.936-105.178-310.854-105.178s-224.66 39.218-310.854 105.178c-78.048-31.246-140.918-92.342-174.494-169.178-17.128 39.2-26.652 82.484-26.652 128 0 73.574 24.85 141.328 66.588 195.378-42.37 74.542-66.588 160.75-66.588 252.622 0 282.77 229.23 512 512 512s512-229.23 512-512c0-91.872-24.218-178.080-66.588-252.622 41.738-54.050 66.588-121.804 66.588-195.378zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"evil",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60690,
					"grid": 16
				},
				{
					"id": 2856,
					"paths": [
						"M1024 64c0-45.516-9.524-88.8-26.652-128-33.576 76.836-96.448 137.932-174.494 169.178-86.194-65.96-193.936-105.178-310.854-105.178s-224.66 39.218-310.854 105.178c-78.048-31.246-140.918-92.342-174.494-169.178-17.128 39.2-26.652 82.484-26.652 128 0 73.574 24.85 141.328 66.588 195.378-42.37 74.542-66.588 160.75-66.588 252.622 0 282.77 229.23 512 512 512s512-229.23 512-512c0-91.872-24.218-178.080-66.588-252.622 41.738-54.050 66.588-121.804 66.588-195.378zM576.094 380.516c2.032-47.454 45.21-78.948 81.592-97.138 34.742-17.372 69.104-26.060 70.548-26.422 17.146-4.288 34.52 6.138 38.806 23.284s-6.138 34.518-23.284 38.806c-17.624 4.45-38.522 12.12-56.936 21.35 10.648 11.43 17.174 26.752 17.174 43.606 0 35.346-28.654 64-64 64s-64-28.654-64-64c0.002-1.17 0.038-2.332 0.1-3.486zM256.958 280.24c4.288-17.146 21.66-27.572 38.806-23.284 1.446 0.362 35.806 9.052 70.548 26.422 36.38 18.192 79.56 49.684 81.592 97.138 0.062 1.154 0.098 2.314 0.098 3.484 0 35.346-28.654 64-64 64s-64-28.654-64-64c0-16.854 6.526-32.176 17.174-43.606-18.414-9.23-39.31-16.9-56.936-21.35-17.142-4.286-27.566-21.66-23.282-38.804zM512 832c-116.51 0-218.464-62.274-274.426-155.344l82.328-49.396c39.174 65.148 110.542 108.74 192.098 108.74 81.554 0 152.924-43.592 192.098-108.74l82.328 49.396c-55.962 93.070-157.916 155.344-274.426 155.344z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"evil",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60691,
					"grid": 16
				},
				{
					"id": 469,
					"width": 1024,
					"paths": [
						"M768 0c-53.024 0-96 42.976-96 96 0 28.32 12.48 53.504 32 71.072v84.256c0 82.496-40.064 160.384-107.2 208.32l-52.8 37.696-52.8-37.728c-67.136-47.904-107.2-125.792-107.2-208.288v-84.256c19.52-17.568 32-42.752 32-71.072 0-53.024-42.976-96-96-96s-96 42.976-96 96c0 28.32 12.48 53.504 32 71.072v84.256c0 123.744 60.096 240.576 160.8 312.48l63.2 45.12v191.072c0 52.928-43.072 96-96 96-38.528 0-71.616-22.944-86.88-55.776 33.024-23.104 54.88-60.96 54.88-104.224 0-70.592-57.408-128-128-128s-128 57.408-128 128c0 49.472 28.416 92.032 69.632 113.248 22.528 99.872 111.776 174.752 218.368 174.752 123.52 0 224-100.48 224-224v-191.072l63.2-45.152c100.704-71.872 160.8-188.704 160.8-312.448v-84.256c19.52-17.568 32-42.752 32-71.072 0-53.024-42.976-96-96-96zM128 736c0-53.024 42.976-96 96-96s96 42.976 96 96c0 27.904-12.352 52.48-31.392 69.952-0.128-2.016-0.608-3.904-0.608-5.952v-64c0-35.328-28.672-64-64-64s-64 28.672-64 64v64c0 2.4 0.288 4.736 0.352 7.136-19.712-17.504-32.352-42.688-32.352-71.136zM810.592 143.296l-10.592 9.536v98.496c0 113.44-55.104 220.512-147.392 286.432l-76.608 54.688v207.552c0 105.856-86.144 192-192 192s-192-86.144-192-192v-64c0-17.632 14.368-32 32-32s32 14.368 32 32v64c0 70.592 57.408 128 128 128s128-57.408 128-128v-207.552l-76.608-54.72c-92.288-65.888-147.392-172.96-147.392-286.4v-98.496l-10.592-9.536c-13.792-12.416-21.408-29.216-21.408-47.296 0-35.296 28.704-64 64-64s64 28.704 64 64c0 18.080-7.616 34.88-21.408 47.296l-10.592 9.536v98.496c0 92.8 45.088 180.416 120.608 234.336l71.392 51.008 71.392-51.008c75.52-53.92 120.608-141.536 120.608-234.336v-98.496l-10.592-9.536c-13.792-12.416-21.408-29.216-21.408-47.296 0-35.296 28.704-64 64-64s64 28.704 64 64c0 18.080-7.616 34.88-21.408 47.296zM352 96c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32 32 14.336 32 32zM768 64c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"examine",
						"listen",
						"inspect"
					],
					"grid": 32
				},
				{
					"id": 470,
					"width": 1024,
					"paths": [
						"M352 736c0-70.688-57.312-128-128-128s-128 57.312-128 128c0 70.688 57.312 128 128 128s128-57.312 128-128zM192 736c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM768 0c-53.024 0-96 42.976-96 96 0 28.32 12.48 53.504 32 71.072v84.256c0 82.496-40.064 160.384-107.2 208.32l-52.8 37.696-52.8-37.728c-67.136-47.904-107.2-125.792-107.2-208.288v-84.256c19.52-17.568 32-42.752 32-71.072 0-53.024-42.976-96-96-96s-96 42.976-96 96c0 28.32 12.48 53.504 32 71.072v84.256c0 123.744 60.096 240.576 160.8 312.48l63.2 45.12v191.072c0 52.928-43.072 96-96 96-26.88 0-50.944-11.328-68.32-29.248-26.016 18.304-57.536 29.248-91.68 29.248-15.808 0-30.784-3.008-45.216-7.296 34.432 79.424 113.28 135.296 205.216 135.296 123.52 0 224-100.48 224-224v-191.072l63.2-45.152c100.704-71.872 160.8-188.704 160.8-312.448v-84.256c19.52-17.568 32-42.752 32-71.072 0-53.024-42.976-96-96-96zM320 128c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM768 128c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"examine",
						"listen",
						"inspect"
					],
					"grid": 32
				},
				{
					"id": 1389,
					"width": 1023.9989223480225,
					"paths": [
						"M1024 676.571v109.714q0 7.429-5.429 12.857t-12.857 5.429h-786.286v109.714q0 7.429-5.429 12.857t-12.857 5.429q-6.857 0-13.714-5.714l-182.286-182.857q-5.143-5.143-5.143-12.571 0-8 5.143-13.143l182.857-182.857q5.143-5.143 13.143-5.143 7.429 0 12.857 5.429t5.429 12.857v109.714h786.286q7.429 0 12.857 5.429t5.429 12.857zM1024 365.714q0 8-5.143 13.143l-182.857 182.857q-5.143 5.143-13.143 5.143-7.429 0-12.857-5.429t-5.429-12.857v-109.714h-786.286q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h786.286v-109.714q0-8 5.143-13.143t13.143-5.143q6.857 0 13.714 5.714l182.286 182.286q5.143 5.143 5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exchange"
					],
					"defaultCode": 61676,
					"grid": 14
				},
				{
					"id": 1445,
					"width": 365.71604919433594,
					"paths": [
						"M292.571 713.143v128q0 14.857-10.857 25.714t-25.714 10.857h-146.286q-14.857 0-25.714-10.857t-10.857-25.714v-128q0-14.857 10.857-25.714t25.714-10.857h146.286q14.857 0 25.714 10.857t10.857 25.714zM309.714 109.714l-16 438.857q-0.571 14.857-11.714 25.714t-26 10.857h-146.286q-14.857 0-26-10.857t-11.714-25.714l-16-438.857q-0.571-14.857 10-25.714t25.429-10.857h182.857q14.857 0 25.429 10.857t10 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exclamation"
					],
					"defaultCode": 61738,
					"grid": 14
				},
				{
					"id": 1279,
					"width": 877.7139282226562,
					"paths": [
						"M438.857 73.143q119.429 0 220.286 58.857t159.714 159.714 58.857 220.286-58.857 220.286-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857zM512 785.714v-108.571q0-8-5.143-13.429t-12.571-5.429h-109.714q-7.429 0-13.143 5.714t-5.714 13.143v108.571q0 7.429 5.714 13.143t13.143 5.714h109.714q7.429 0 12.571-5.429t5.143-13.429zM510.857 589.143l10.286-354.857q0-6.857-5.714-10.286-5.714-4.571-13.714-4.571h-125.714q-8 0-13.714 4.571-5.714 3.429-5.714 10.286l9.714 354.857q0 5.714 5.714 10t13.714 4.286h105.714q8 0 13.429-4.286t6-10z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exclamation-circle"
					],
					"defaultCode": 61546,
					"grid": 14
				},
				{
					"id": 1285,
					"width": 1023.9998817443848,
					"paths": [
						"M585.143 785.714v-108.571q0-8-5.429-13.429t-12.857-5.429h-109.714q-7.429 0-12.857 5.429t-5.429 13.429v108.571q0 8 5.429 13.429t12.857 5.429h109.714q7.429 0 12.857-5.429t5.429-13.429zM584 572l10.286-262.286q0-6.857-5.714-10.857-7.429-6.286-13.714-6.286h-125.714q-6.286 0-13.714 6.286-5.714 4-5.714 12l9.714 261.143q0 5.714 5.714 9.429t13.714 3.714h105.714q8 0 13.429-3.714t6-9.429zM576 38.286l438.857 804.571q20 36-1.143 72-9.714 16.571-26.571 26.286t-36.286 9.714h-877.714q-19.429 0-36.286-9.714t-26.571-26.286q-21.143-36-1.143-72l438.857-804.571q9.714-17.714 26.857-28t37.143-10.286 37.143 10.286 26.857 28z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exclamation-triangle",
						"warning"
					],
					"defaultCode": 61553,
					"grid": 14
				},
				{
					"id": 2253,
					"paths": [
						"M704 256v-256h-704v704h256v320h768v-768h-320zM896 392h-192v-8h192v8zM384 896v-8h512v8h-512zM384 872v-16h512v16h-512zM384 840v-16h512v16h-512zM384 808v-16h512v16h-512zM384 776v-16h512v16h-512zM384 744v-16h512v16h-512zM384 712v-8h320v-8h192v16h-512zM704 680v-16h192v16h-192zM704 648v-16h192v16h-192zM704 616v-16h192v16h-192zM704 584v-16h192v16h-192zM704 552v-16h192v16h-192zM704 520v-16h192v16h-192zM704 488v-16h192v16h-192zM704 456v-16h192v16h-192zM704 424v-16h192v16h-192zM576 256h-320v8h-128v-16h448v8zM128 576v-8h128v8h-128zM128 552v-16h128v16h-128zM128 520v-16h128v16h-128zM128 488v-16h128v16h-128zM128 456v-16h128v16h-128zM128 424v-16h128v16h-128zM128 392v-16h128v16h-128zM128 360v-16h128v16h-128zM128 328v-16h128v16h-128zM128 296v-16h128v16h-128zM576 232h-448v-16h448v16zM576 200h-448v-16h448v16zM576 168h-448v-16h448v16zM576 136h-448v-8h448v8zM320 320h320v320h-320v-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exclude",
						"boolean-operation",
						"dualtone"
					],
					"defaultCode": 60088,
					"grid": 16
				},
				{
					"id": 2956,
					"paths": [
						"M704 832l288-288-288-288v192h-448v192h448v192z",
						"M64 64h704v128h-640v704h640v128h-704c-35.346 0-64-28.654-64-64v-832c0-35.346 28.654-64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exit",
						"signout",
						"logout",
						"quit"
					],
					"defaultCode": 60791,
					"grid": 16
				},
				{
					"id": 199,
					"paths": [
						"M793.6 1024h-614.4c-42.347 0-76.8-34.453-76.8-76.8v-512c0-42.347 34.453-76.8 76.8-76.8h204.8c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-204.8c-14.115 0-25.6 11.485-25.6 25.6v512c0 14.115 11.485 25.6 25.6 25.6h614.4c14.115 0 25.6-11.485 25.6-25.6v-512c0-14.115-11.485-25.6-25.6-25.6h-204.8c-14.139 0-25.6-11.462-25.6-25.6s11.461-25.6 25.6-25.6h204.8c42.347 0 76.8 34.453 76.8 76.8v512c0 42.347-34.453 76.8-76.8 76.8z",
						"M658.099 186.699l-153.6-153.6c-9.997-9.998-26.206-9.998-36.203 0l-153.6 153.6c-9.998 9.997-9.998 26.206 0 36.203s26.206 9.998 36.203 0l109.901-109.899v578.197c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-578.197l109.901 109.898c4.997 5 11.547 7.499 18.099 7.499s13.102-2.499 18.099-7.499c10-9.997 10-26.205 0-36.202z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exit-up",
						"up",
						"upload",
						"arrow"
					],
					"defaultCode": 59496,
					"grid": 20
				},
				{
					"id": 2958,
					"paths": [
						"M768 576h-448v-128h448v-192l256 256-256 256zM640 640v384h-640v-1024h640v384h-64v-256h-320v768h320v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exit",
						"signout",
						"logout",
						"quit",
						"close"
					],
					"defaultCode": 60793,
					"grid": 16
				},
				{
					"id": 2960,
					"paths": [
						"M768 640v-128h-320v-128h320v-128l192 192zM704 576v256h-320v192l-384-192v-832h704v320h-64v-256h-512l256 128v576h256v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exit",
						"signout",
						"logout",
						"quit",
						"close"
					],
					"defaultCode": 60795,
					"grid": 16
				},
				{
					"id": 127,
					"paths": [
						"M588.8 409.6c14.139 0 25.6-11.462 25.6-25.6v-204.8c0-42.347-34.451-76.8-76.8-76.8h-460.8c-42.347 0-76.8 34.453-76.8 76.8v614.4c0 38.178 27.488 79.862 62.576 94.899l264.278 113.262c9.134 3.915 18.373 5.859 27.24 5.859 10.926-0.002 21.288-2.955 30.173-8.814 16.099-10.616 25.333-29.426 25.333-51.606v-76.8h128c42.349 0 76.8-34.451 76.8-76.8v-204.8c0-14.139-11.461-25.6-25.6-25.6s-25.6 11.461-25.6 25.6v204.8c0 14.115-11.485 25.6-25.6 25.6h-128v-486.4c0-38.176-27.488-79.861-62.576-94.899l-196.702-84.301h387.278c14.115 0 25.6 11.485 25.6 25.6v204.8c0 14.138 11.461 25.6 25.6 25.6zM326.854 284.962c16.51 7.075 31.546 29.877 31.546 47.838v614.4c0 5.344-1.421 8.272-2.317 8.862-0.898 0.589-4.15 0.742-9.061-1.362l-264.278-113.262c-16.509-7.074-31.544-29.875-31.544-47.838v-614.4c0-4.037 0.939-7.859 2.611-11.258l273.043 117.019z",
						"M939.701 468.299l-153.6-153.6c-9.997-9.998-26.206-9.998-36.203 0-9.998 9.997-9.998 26.206 0 36.203l109.899 109.898h-322.197c-14.139 0-25.6 11.462-25.6 25.6s11.461 25.6 25.6 25.6h322.197l-109.899 109.899c-9.998 9.997-9.998 26.206 0 36.203 5 4.998 11.55 7.498 18.102 7.498s13.102-2.499 18.101-7.499l153.6-153.6c9.998-9.997 9.998-26.205 0-36.202z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exit",
						"door",
						"sign-out",
						"log-out",
						"logout"
					],
					"defaultCode": 59424,
					"grid": 20
				},
				{
					"id": 1274,
					"width": 877.7159690856934,
					"paths": [
						"M431.429 603.429q0 7.429-5.714 13.143l-189.714 189.714 82.286 82.286q10.857 10.857 10.857 25.714t-10.857 25.714-25.714 10.857h-256q-14.857 0-25.714-10.857t-10.857-25.714v-256q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857l82.286 82.286 189.714-189.714q5.714-5.714 13.143-5.714t13.143 5.714l65.143 65.143q5.714 5.714 5.714 13.143zM877.714 109.714v256q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-82.286-82.286-189.714 189.714q-5.714 5.714-13.143 5.714t-13.143-5.714l-65.143-65.143q-5.714-5.714-5.714-13.143t5.714-13.143l189.714-189.714-82.286-82.286q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857h256q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"expand"
					],
					"defaultCode": 61541,
					"grid": 14
				},
				{
					"id": 471,
					"width": 1024,
					"paths": [
						"M924.992 516.928c1.728-11.68 3.008-23.776 3.008-36.928 0-123.712-68.288-256-192-256-24 0-45.888 5.088-65.632 14.048-31.712-63.456-85.152-110.048-158.368-110.048s-126.656 46.592-158.368 110.048c-19.744-8.96-41.632-14.048-65.632-14.048-123.712 0-192 132.288-192 256 0 13.152 1.28 25.248 3.008 36.928-38.752 12.352-67.008 48.224-67.008 91.072v46.848c0 72.448 28.768 141.92 80 193.152s120.704 80 193.152 80h413.728c72.448 0 141.92-28.768 193.152-80s80-120.704 80-193.152v-46.848c-0.032-42.848-28.288-78.72-67.040-91.072zM736 256c100.16 0 160 113.888 160 224 0 11.456-1.056 21.888-2.464 32h-315.136c-1.376-10.112-2.4-20.544-2.4-32 0-110.112 59.84-224 160-224zM512 160c58.848 0 103.52 39.584 130.56 94.368-64.064 46.144-98.56 137.92-98.56 225.632 0 11.328 1.248 21.632 2.4 32h-68.832c1.184-10.368 2.432-20.672 2.432-32 0-87.712-34.496-179.488-98.56-225.632 27.040-54.784 71.712-94.368 130.56-94.368zM288 256c100.16 0 160 113.888 160 224 0 11.456-1.024 21.888-2.4 32h-315.136c-1.408-10.112-2.464-20.544-2.464-32 0-110.112 59.84-224 160-224zM960 654.848c0 64.416-25.088 124.96-70.624 170.496s-106.112 70.656-170.528 70.656h-413.696c-64.416 0-124.96-25.088-170.496-70.624-45.568-45.536-70.656-106.112-70.656-170.528v-46.848c0-35.296 28.704-64 64-64h768c35.296 0 64 28.704 64 64v46.848z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"expect",
						"wait",
						"hatch",
						"count",
						"incubate"
					],
					"grid": 32
				},
				{
					"id": 472,
					"width": 1024,
					"paths": [
						"M720 928h-416c-150.208 0-272-121.792-272-272v-48c0-53.024 42.976-96 96-96h768c53.024 0 96 42.976 96 96v48c0 150.208-121.792 272-272 272zM352.096 237.44c-19.36-8.512-40.672-13.44-64.096-13.44-123.712 0-192 132.288-192 256h384c0-100.32-44.992-206.048-127.904-242.56zM736 224c-23.776 0-45.408 5.024-64.992 13.792-82.368 36.864-127.008 142.272-127.008 242.208h384c0-123.712-68.288-256-192-256zM655.072 211.712c-32.48-49.536-80.48-83.712-143.072-83.712-62.56 0-110.56 34.176-143.040 83.68 78.112 37.248 143.040 128.224 143.040 268.32 0-140.096 64.928-231.072 143.072-268.288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"expect",
						"wait",
						"hatch",
						"count",
						"incubate"
					],
					"grid": 32
				},
				{
					"id": 1702,
					"width": 1024,
					"paths": [
						"M512 36.571q-96.571 0-184.571 37.714t-151.714 101.429-101.429 151.714-37.714 184.571 37.714 184.571 101.429 151.714 151.714 101.429 184.571 37.714 184.571-37.714 151.714-101.429 101.429-151.714 37.714-184.571-37.714-184.571-101.429-151.714-151.714-101.429-184.571-37.714zM512 0q104 0 198.857 40.571t163.429 109.143 109.143 163.429 40.571 198.857-40.571 198.857-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571zM283.429 475.429q9.143 0 9.143 9.143v274.286q0 9.143-9.143 9.143h-18.286q-9.143 0-9.143-9.143v-274.286q0-9.143 9.143-9.143h18.286zM512 512q30.286 0 51.714 21.429t21.429 51.714q0 20-10 36.571t-26.571 26.286v65.143q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-65.143q-16.571-9.714-26.571-26.286t-10-36.571q0-30.286 21.429-51.714t51.714-21.429zM512 73.143q119.429 0 220.286 58.857t159.714 159.714 58.857 220.286-58.857 220.286-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857zM310.857 347.429v54.857q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143v-54.857q0-53.143 37.429-90.571t90.571-37.429 90.571 37.429 37.429 90.571v54.857q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143v-54.857q0-83.429-58.857-142.286t-142.286-58.857-142.286 58.857-58.857 142.286zM804.571 768v-292.571q0-14.857-10.857-25.714t-25.714-10.857h-512q-14.857 0-25.714 10.857t-10.857 25.714v292.571q0 14.857 10.857 25.714t25.714 10.857h512q14.857 0 25.714-10.857t10.857-25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"expeditedssl"
					],
					"defaultCode": 62014,
					"grid": 14
				},
				{
					"id": 473,
					"width": 1024,
					"paths": [
						"M192 288c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM320 320c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM852.16 533.408c6.304 56.864-38.208 106.592-95.424 106.592h-489.472c-57.216 0-101.728-49.728-95.424-106.592l10.656-96c5.408-48.64 46.496-85.408 95.424-85.408h468.16c48.928 0 90.016 36.768 95.424 85.408l10.656 96zM820.352 536.928l-10.656-96c-3.616-32.448-30.976-56.928-63.616-56.928h-468.16c-32.672 0-60 24.48-63.616 56.928l-10.656 96c-2.048 18.336 3.616 36 15.904 49.76 12.32 13.728 29.248 21.312 47.712 21.312h489.472c18.464 0 35.392-7.584 47.68-21.312 12.32-13.76 17.984-31.424 15.936-49.76zM1024 352v160c0 17.664-14.336 32-32 32h-56.896l15.008 134.976c5.568 50.144-28.608 96.032-78.24 105.056l-214.368 38.976c-5.728 1.024-11.456 1.536-17.184 1.536-25.216 0-49.728-9.952-67.872-28.128l-15.168-15.168c-12.512-12.512-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-15.2 15.2c-18.176 18.176-42.656 28.128-67.872 28.128-5.696 0-11.456-0.512-17.184-1.536l-214.368-38.976c-49.632-9.024-83.808-54.912-78.24-105.056l14.976-135.008h-56.896c-17.664 0-32-14.336-32-32v-160c0-17.664 14.336-32 32-32h81.792l4.736-42.592c5.376-48.64 46.464-85.408 95.392-85.408h596.16c48.928 0 90.016 36.768 95.424 85.408l4.704 42.592h81.792c17.664 0 32 14.336 32 32zM110.208 352h-78.208v160h60.448l17.76-160zM918.304 682.496l-44.608-401.568c-3.616-32.448-30.976-56.928-63.616-56.928h-596.16c-32.64 0-60 24.48-63.616 56.928l-44.608 401.568c-3.712 33.28 19.2 64.032 52.16 70.048l214.368 38.976c3.776 0.672 7.616 1.024 11.456 1.024 16.832 0 33.344-6.848 45.248-18.752l15.2-15.2c18.144-18.144 42.24-28.128 67.872-28.128s49.76 9.984 67.872 28.128l15.168 15.168c12.096 12.096 28.16 18.752 45.248 18.752 3.84 0 7.68-0.352 11.456-1.024l214.368-38.976c32.992-5.952 55.904-36.736 52.192-70.016zM992 352h-78.208l17.792 160h60.416v-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"experience",
						"see",
						"watch",
						"virtualize",
						"interact"
					],
					"grid": 32
				},
				{
					"id": 474,
					"width": 1024,
					"paths": [
						"M820.352 536.928c2.048 18.336-3.616 36-15.904 49.76-12.32 13.728-29.248 21.312-47.712 21.312h-489.472c-18.432 0-35.392-7.584-47.68-21.312-12.32-13.76-17.952-31.424-15.904-49.76l10.656-96c3.584-32.448 30.944-56.928 63.584-56.928h468.16c32.672 0 60 24.48 63.616 56.928l10.656 96zM992 320h-49.472l24.896 224h24.576c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32zM32 320c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h24.576l24.896-224h-49.472zM950.112 678.976c5.568 50.144-28.608 96.032-78.24 105.056l-214.368 38.976c-5.728 1.024-11.456 1.536-17.184 1.536-25.216 0-49.728-9.952-67.872-28.128l-15.168-15.168c-12.512-12.512-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-15.2 15.2c-18.176 18.176-42.656 28.128-67.872 28.128-5.696 0-11.456-0.512-17.184-1.536l-214.368-38.976c-49.632-9.024-83.808-54.912-78.24-105.056l44.576-401.6c5.408-48.64 46.496-85.408 95.424-85.408h596.16c48.928 0 90.016 36.768 95.424 85.408l44.608 401.568zM288 288c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM192 288c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM852.16 533.408l-10.656-96c-5.408-48.64-46.496-85.408-95.424-85.408h-468.16c-48.928 0-90.016 36.768-95.424 85.408l-10.656 96c-6.304 56.864 38.208 106.592 95.424 106.592h489.472c57.216 0 101.728-49.728 95.424-106.592z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"experience",
						"see",
						"watch",
						"virtualize",
						"interact"
					],
					"grid": 32
				},
				{
					"id": 1018,
					"width": 1024,
					"paths": [
						"M208 544h305.6c7.84 54.208 54.016 96 110.4 96s102.56-41.792 110.4-96h81.6c39.136 0 71.648-28.288 78.528-65.472 54.912-7.2 97.472-53.664 97.472-110.528s-42.56-103.328-97.472-110.528c-6.88-37.184-39.392-65.472-78.528-65.472h-209.6c-7.84-54.208-54.016-96-110.4-96s-102.56 41.792-110.4 96h-67.2c-7.84-54.208-54.016-96-110.4-96-61.856 0-112 50.144-112 112s50.144 112 112 112c56.384 0 102.56-41.792 110.4-96h67.232c7.84 54.208 54.016 96 110.4 96s102.56-41.792 110.4-96h209.6c21.504 0 39.552 14.304 45.632 33.856-53.088 8.8-93.664 54.592-93.664 110.144s40.576 101.344 93.632 110.144c-6.080 19.552-24.128 33.856-45.632 33.856h-81.6c-7.84-54.208-54.016-96-110.4-96s-102.56 41.792-110.4 96h-305.6c-39.136 0-71.648 28.288-78.528 65.472-54.912 7.2-97.472 53.664-97.472 110.528s42.56 103.328 97.472 110.528c6.88 37.184 39.392 65.472 78.528 65.472h81.6c7.84 54.208 54.016 96 110.4 96s102.56-41.792 110.4-96h195.232c7.84 54.208 54.016 96 110.4 96 61.856 0 112-50.144 112-112s-50.176-112-112.032-112c-56.384 0-102.56 41.792-110.4 96h-195.2c-7.84-54.208-54.016-96-110.4-96s-102.56 41.792-110.4 96h-81.6c-21.504 0-39.552-14.304-45.632-33.856 53.056-8.8 93.632-54.592 93.632-110.144s-40.576-101.344-93.632-110.144c6.080-19.552 24.128-33.856 45.632-33.856zM208 256c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM496 256c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM832 368c0-26.464 21.536-48 48-48s48 21.536 48 48-21.536 48-48 48-48-21.536-48-48zM624 480c26.464 0 48 21.536 48 48s-21.536 48-48 48-48-21.536-48-48 21.536-48 48-48zM816 800c26.464 0 48 21.536 48 48s-21.536 48-48 48-48-21.536-48-48 21.536-48 48-48zM400 800c26.464 0 48 21.536 48 48s-21.536 48-48 48-48-21.536-48-48 21.536-48 48-48zM192 688c0 26.464-21.536 48-48 48s-48-21.536-48-48 21.536-48 48-48 48 21.536 48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"experience",
						"guide",
						"connect"
					],
					"grid": 32
				},
				{
					"id": 475,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 928c-229.376 0-416-186.624-416-416s186.624-416 416-416 416 186.624 416 416-186.624 416-416 416zM512 128c-211.744 0-384 172.256-384 384s172.256 384 384 384 384-172.256 384-384-172.256-384-384-384zM512 864c-194.4 0-352-157.6-352-352s157.6-352 352-352 352 157.6 352 352-157.6 352-352 352zM512 608c-70.592 0-128-57.408-128-128 0-35.328-28.672-64-64-64s-64 28.672-64 64c0 141.152 114.848 256 256 256 35.328 0 64-28.672 64-64s-28.672-64-64-64zM512 704c-123.52 0-224-100.48-224-224 0-17.632 14.368-32 32-32s32 14.368 32 32c0 88.224 71.776 160 160 160 17.632 0 32 14.368 32 32s-14.368 32-32 32zM736 352c0-35.328-28.672-64-64-64-105.888 0-192 86.112-192 192 0 35.328 28.672 64 64 64s64-28.672 64-64c0-35.296 28.704-64 64-64 35.328 0 64-28.672 64-64zM576 480c0 17.632-14.368 32-32 32s-32-14.368-32-32c0-88.224 71.776-160 160-160 17.632 0 32 14.368 32 32s-14.368 32-32 32c-52.928 0-96 43.072-96 96zM704 512c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64-28.64-64-64-64zM704 608c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"experiment",
						"live",
						"test",
						"try",
						"multipl"
					],
					"grid": 32
				},
				{
					"id": 476,
					"width": 1024,
					"paths": [
						"M736 576c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM704 352c0-17.632-14.368-32-32-32-88.224 0-160 71.776-160 160 0 17.632 14.368 32 32 32s32-14.368 32-32c0-52.928 43.072-96 96-96 17.632 0 32-14.368 32-32zM512 640c-88.224 0-160-71.776-160-160 0-17.632-14.368-32-32-32s-32 14.368-32 32c0 123.52 100.48 224 224 224 17.632 0 32-14.368 32-32s-14.368-32-32-32zM864 512c0 194.4-157.6 352-352 352s-352-157.6-352-352 157.6-352 352-352 352 157.6 352 352zM576 672c0-35.328-28.672-64-64-64-70.592 0-128-57.408-128-128 0-35.328-28.672-64-64-64s-64 28.672-64 64c0 141.152 114.848 256 256 256 35.328 0 64-28.672 64-64zM672 416c35.328 0 64-28.672 64-64s-28.672-64-64-64c-105.888 0-192 86.112-192 192 0 35.328 28.672 64 64 64s64-28.672 64-64c0-35.296 28.704-64 64-64zM768 576c0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64 64-28.64 64-64zM960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448 200.576-448 448-448 448 200.576 448 448zM896 512c0-211.744-172.256-384-384-384s-384 172.256-384 384 172.256 384 384 384 384-172.256 384-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"experiment",
						"live",
						"test",
						"try",
						"multipl"
					],
					"grid": 32
				},
				{
					"id": 1019,
					"width": 1024,
					"paths": [
						"M906.944 883.296l-266.944-507.2v-184.096c53.024 0 96-42.976 96-96s-42.976-96-96-96h-256c-53.024 0-96 42.976-96 96s42.976 96 96 96v184.096l-266.944 507.2c-15.808 30.016-14.784 65.28 2.752 94.336 17.536 29.024 48.256 46.368 82.176 46.368h620c33.92 0 64.64-17.344 82.176-46.368 17.568-29.056 18.592-64.32 2.784-94.336zM352 96c0-17.408 13.952-31.584 31.264-32h256.736c17.664 0 32 14.336 32 32 0 17.28-13.76 31.36-30.88 32h-257.12c-17.664 0-32-14.336-32-32zM444.32 398.912c2.4-4.608 3.68-9.728 3.68-14.912v-224h128v224c0 5.184 1.28 10.304 3.68 14.912l126.912 241.088h-389.184l126.912-241.088zM849.376 944.544c-2.784 4.64-11.072 15.456-27.392 15.456h-620c-16.288 0-24.576-10.816-27.392-15.456s-8.512-16.992-0.928-31.424l126.912-241.12h422.848l126.88 241.088c7.616 14.432 1.888 26.816-0.928 31.456zM416 896h64v32h-64v-32zM416 832h64v32h-64v-32zM416 768h64v32h-64v-32zM416 704h64v32h-64v-32zM416 576h64v32h-64v-32zM416 512h64v32h-64v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"experiment",
						"mix",
						"test",
						"try"
					],
					"grid": 32
				},
				{
					"id": 1020,
					"width": 1024,
					"paths": [
						"M736 544h-224v-32h224v32zM736 576h-224v32h224v-32zM736 256h-224v32h224v-32zM736 192h-224v32h224v-32zM320 705.6v-67.2c-36.512-7.424-64-39.68-64-78.4 0-38.688 27.488-70.976 64-78.4v-163.2c-36.512-7.424-64-39.712-64-78.4 0-44.192 35.808-80 80-80s80 35.808 80 80c0 38.688-27.488 70.976-64 78.4v163.232c36.512 7.424 64 39.68 64 78.4 0 38.688-27.488 70.976-64 78.4v67.232c36.512 7.424 64 39.68 64 78.4 0 44.192-35.808 80-80 80s-80-35.872-80-80.064c0-38.688 27.488-70.976 64-78.4zM336 736c-26.464 0-48 21.536-48 48s21.536 48 48 48 48-21.536 48-48-21.536-48-48-48zM336 288c26.464 0 48-21.536 48-48s-21.536-48-48-48-48 21.536-48 48 21.536 48 48 48zM336 608c26.464 0 48-21.536 48-48s-21.536-48-48-48-48 21.536-48 48 21.536 48 48 48zM928 64v896c0 17.664-14.304 32-32 32h-768c-17.696 0-32-14.336-32-32v-896c0-17.664 14.304-32 32-32h768c17.696 0 32 14.336 32 32zM864 96h-704v832h704v-832zM736 800h-224v32h224v-32zM736 736h-224v32h224v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"explain",
						"guide",
						"diagram",
						"describe",
						"annotate"
					],
					"grid": 32
				},
				{
					"id": 477,
					"width": 1024,
					"paths": [
						"M960 512c0-63.104-30.592-118.912-77.568-153.92 8.192-57.76-9.216-118.432-53.632-162.848-37.344-37.344-86.176-55.616-135.104-55.616-9.28 0-18.56 0.672-27.744 1.952-35.040-46.976-90.848-77.568-153.952-77.568s-118.912 30.592-153.92 77.568c-9.216-1.312-18.496-1.952-27.744-1.952-48.928 0-97.76 18.272-135.104 55.616-44.416 44.416-61.856 105.088-53.664 162.848-46.976 35.008-77.568 90.816-77.568 153.92s30.592 118.912 77.568 153.92c-8.192 57.76 9.216 118.432 53.632 162.848 37.344 37.344 86.176 55.616 135.104 55.616 9.28 0 18.56-0.672 27.744-1.952 35.040 46.976 90.848 77.568 153.952 77.568s118.912-30.592 153.92-77.568c9.216 1.312 18.496 1.952 27.744 1.952 48.928 0 97.76-18.272 135.104-55.616 44.416-44.416 61.856-105.12 53.632-162.848 47.008-35.008 77.6-90.816 77.6-153.92zM863.296 640.256l-15.232 11.36 2.688 18.816c7.2 50.72-9.056 100.192-44.576 135.744-29.824 29.824-69.76 46.24-112.48 46.24-7.744 0-15.552-0.544-23.264-1.632l-18.816-2.688-11.36 15.232c-30.624 41.088-77.376 64.672-128.256 64.672s-97.632-23.584-128.256-64.704l-11.36-15.232-18.816 2.688c-7.68 1.088-15.52 1.632-23.264 1.632-42.72 0-82.656-16.416-112.48-46.24-35.552-35.552-51.776-85.024-44.576-135.744l2.688-18.816-15.232-11.36c-41.12-30.592-64.704-77.344-64.704-128.224 0-50.912 23.584-97.632 64.704-128.256l15.232-11.36-2.688-18.816c-7.2-50.72 9.056-100.192 44.608-135.712 29.824-29.824 69.76-46.24 112.48-46.24 7.744 0 15.584 0.544 23.264 1.632l18.816 2.688 11.36-15.232c30.592-41.12 77.344-64.704 128.224-64.704s97.632 23.584 128.256 64.672l11.36 15.232 18.816-2.688c7.68-1.088 15.52-1.632 23.264-1.632 42.72 0 82.656 16.416 112.48 46.24 35.552 35.552 51.776 85.024 44.576 135.744l-2.688 18.816 15.232 11.36c41.12 30.624 64.704 77.344 64.704 128.256 0 50.88-23.584 97.632-64.704 128.256zM751.808 412.672c4.032-37.216-7.648-75.776-36.16-104.32-24.864-24.896-57.408-36.928-90.016-36.928-4.768 0-9.536 0.256-14.304 0.768-23.456-29.152-59.008-48.192-99.328-48.192s-75.872 19.040-99.328 48.192c-4.736-0.512-9.504-0.768-14.304-0.768-32.608 0-65.152 12.064-90.016 36.928-28.512 28.512-40.192 67.104-36.16 104.32-29.152 23.456-48.192 59.008-48.192 99.328s19.040 75.872 48.192 99.328c-4.032 37.216 7.648 75.776 36.16 104.32 24.864 24.864 57.44 36.928 90.016 36.928 4.768 0 9.536-0.256 14.272-0.768 23.488 29.152 59.040 48.192 99.36 48.192s75.872-19.040 99.328-48.192c4.736 0.512 9.504 0.768 14.272 0.768 32.608 0 65.152-12.064 90.016-36.928 28.512-28.512 40.192-67.104 36.16-104.32 29.184-23.456 48.224-59.008 48.224-99.328s-19.040-75.872-48.192-99.328zM731.744 586.4l-13.632 10.976 1.888 17.408c3.168 29.408-6.656 57.92-26.976 78.24-17.792 17.76-41.728 27.552-67.392 27.552-3.616 0-7.232-0.192-10.848-0.576l-17.408-1.888-10.976 13.632c-18.528 23.040-45.664 36.256-74.4 36.256s-55.872-13.216-74.4-36.256l-10.976-13.632-17.408 1.888c-3.616 0.384-7.232 0.576-10.848 0.576-25.696 0-49.632-9.792-67.392-27.552-20.32-20.32-30.144-48.864-26.976-78.24l1.888-17.408-13.632-10.976c-23.040-18.528-36.256-45.664-36.256-74.4s13.216-55.872 36.256-74.4l13.632-10.976-1.888-17.408c-3.168-29.408 6.656-57.92 26.976-78.24 17.792-17.792 41.728-27.552 67.392-27.552 3.616 0 7.232 0.192 10.848 0.576l17.408 1.888 10.976-13.632c18.528-23.040 45.664-36.256 74.4-36.256s55.872 13.216 74.4 36.256l10.976 13.632 17.408-1.888c3.616-0.384 7.232-0.576 10.848-0.576 25.696 0 49.632 9.792 67.392 27.552 20.32 20.32 30.176 48.832 26.976 78.24l-1.888 17.408 13.632 10.976c23.040 18.528 36.256 45.664 36.256 74.4s-13.216 55.872-36.256 74.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"explode",
						"destroy",
						"boom"
					],
					"grid": 32
				},
				{
					"id": 478,
					"width": 1024,
					"paths": [
						"M731.744 437.6c23.040 18.528 36.256 45.664 36.256 74.4s-13.216 55.872-36.256 74.4l-13.632 10.976 1.888 17.408c3.168 29.408-6.656 57.92-26.976 78.24-17.792 17.76-41.728 27.552-67.392 27.552-3.616 0-7.232-0.192-10.848-0.576l-17.408-1.888-10.976 13.632c-18.528 23.040-45.664 36.256-74.4 36.256s-55.872-13.216-74.4-36.256l-10.976-13.632-17.408 1.888c-3.616 0.384-7.232 0.576-10.848 0.576-25.696 0-49.632-9.792-67.392-27.552-20.32-20.32-30.144-48.864-26.976-78.24l1.888-17.408-13.632-10.976c-23.040-18.528-36.256-45.664-36.256-74.4s13.216-55.872 36.256-74.4l13.632-10.976-1.888-17.408c-3.168-29.408 6.656-57.92 26.976-78.24 17.792-17.792 41.728-27.552 67.392-27.552 3.616 0 7.232 0.192 10.848 0.576l17.408 1.888 10.976-13.632c18.528-23.040 45.664-36.256 74.4-36.256s55.872 13.216 74.4 36.256l10.976 13.632 17.408-1.888c3.616-0.384 7.232-0.576 10.848-0.576 25.696 0 49.632 9.792 67.392 27.552 20.32 20.32 30.176 48.832 26.976 78.24l-1.888 17.408 13.632 10.976zM882.432 665.92c8.192 57.76-9.216 118.432-53.632 162.848-37.344 37.344-86.176 55.616-135.104 55.616-9.28 0-18.56-0.672-27.744-1.952-35.040 46.976-90.848 77.568-153.952 77.568s-118.912-30.592-153.92-77.568c-9.216 1.312-18.464 1.952-27.744 1.952-48.928 0-97.76-18.272-135.104-55.616-44.416-44.416-61.856-105.12-53.632-162.848-47.008-35.008-77.6-90.816-77.6-153.92s30.592-118.912 77.568-153.92c-8.192-57.76 9.248-118.432 53.664-162.88 37.344-37.344 86.176-55.616 135.104-55.616 9.28 0 18.56 0.672 27.744 1.952 35.008-46.944 90.816-77.536 153.92-77.536s118.912 30.592 153.92 77.568c9.216-1.312 18.464-1.952 27.744-1.952 48.928 0 97.76 18.272 135.104 55.616 44.416 44.416 61.856 105.12 53.632 162.848 47.008 35.008 77.6 90.816 77.6 153.92s-30.592 118.912-77.568 153.92zM800 512c0-40.32-19.040-75.872-48.192-99.328 4.032-37.216-7.648-75.776-36.16-104.32-24.864-24.896-57.408-36.928-90.016-36.928-4.768 0-9.536 0.256-14.304 0.768-23.456-29.152-59.008-48.192-99.328-48.192s-75.872 19.040-99.328 48.192c-4.736-0.512-9.504-0.768-14.304-0.768-32.608 0-65.152 12.064-90.016 36.928-28.512 28.512-40.192 67.104-36.16 104.32-29.152 23.456-48.192 59.008-48.192 99.328s19.040 75.872 48.192 99.328c-4.032 37.216 7.648 75.776 36.16 104.32 24.864 24.864 57.44 36.928 90.016 36.928 4.768 0 9.536-0.256 14.272-0.768 23.488 29.152 59.040 48.192 99.36 48.192s75.872-19.040 99.328-48.192c4.736 0.512 9.504 0.768 14.272 0.768 32.608 0 65.152-12.064 90.016-36.928 28.512-28.512 40.192-67.104 36.16-104.32 29.184-23.456 48.224-59.008 48.224-99.328z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"explode",
						"destroy",
						"boom"
					],
					"grid": 32
				},
				{
					"id": 479,
					"width": 1024,
					"paths": [
						"M998.912 581.664l-112.48-270.496c-14.784-43.232-45.856-78.912-85.92-99.648-6.176-47.072-45.984-83.52-94.72-83.52-53.024 0-96 42.976-96 96 0 2.208 0.384 4.288 0.64 6.4-40.448 32.256-66.432 81.856-66.432 137.6 0 7.2 0 15.712 0 24.864-9.44-5.472-20.288-8.864-32-8.864s-22.56 3.392-32 8.864c0-9.152 0-17.664 0-24.864 0-55.008-25.248-104.064-64.768-136.352 0.224-2.56 0.768-5.024 0.768-7.648 0-53.024-42.976-96-96-96-48.48 0-88.128 36.032-94.656 82.72-40.928 20.576-72.8 56.544-87.776 100.448l-112.48 270.496c-15.904 32.064-25.088 68.096-25.088 106.336 0 132.544 107.456 240 240 240 110.112 0 202.656-74.24 230.912-175.296 11.168 9.408 25.376 15.296 41.088 15.296s29.92-5.888 41.088-15.296c28.256 101.056 120.8 175.296 230.912 175.296 132.544 0 240-107.456 240-240 0-38.24-9.184-74.272-25.088-106.336zM320 160c30.688 0 56.224 21.728 62.4 50.592-23.616-11.776-50.176-18.592-78.4-18.592-14.496 0-28.352 2.272-41.824 5.568 10.016-22.080 32-37.568 57.824-37.568zM240 896c-114.688 0-208-93.312-208-208 0-26.592 5.664-53.536 16.832-80.128l5.216-12.544c34.176-68.256 104.576-115.328 185.952-115.328 114.688 0 208 93.312 208 208s-93.312 208-208 208zM448 568.608c-41.44-72-118.976-120.608-208-120.608-54.624 0-104.8 18.464-145.12 49.184l72.64-174.688 0.32-0.992c19.936-58.336 74.624-97.504 136.16-97.504 79.392 0 144 64.608 144 144v200.608zM512 736c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM544 648.864c-9.44-5.472-20.288-8.864-32-8.864s-22.56 3.392-32 8.864c0-58.208 0-136.992 0-200.864 0-17.632 14.368-32 32-32s32 14.368 32 32c0 63.872 0 142.656 0 200.864zM705.792 160c26.080 0 48.48 15.744 58.432 38.176-14.176-3.712-28.864-6.176-44.224-6.176-27.424 0-53.312 6.464-76.448 17.664 6.528-28.384 31.872-49.664 62.24-49.664zM576 368c0-79.392 64.608-144 144-144 61.536 0 116.224 39.168 136.16 97.504l0.32 0.992 0.416 0.96 72.224 173.728c-40.32-30.72-90.496-49.184-145.12-49.184-89.024 0-166.56 48.608-208 120.608v-200.608zM784 896c-114.688 0-208-93.312-208-208s93.312-208 208-208c81.376 0 151.776 47.072 185.952 115.328l5.248 12.672c11.136 26.464 16.8 53.408 16.8 80 0 114.688-93.312 208-208 208zM240 512c-97.216 0-176 78.784-176 176s78.784 176 176 176c97.216 0 176-78.784 176-176s-78.784-176-176-176zM240 832c-79.392 0-144-64.608-144-144s64.608-144 144-144 144 64.608 144 144-64.608 144-144 144zM784 512c-97.216 0-176 78.784-176 176s78.784 176 176 176c97.216 0 176-78.784 176-176s-78.784-176-176-176zM784 832c-79.392 0-144-64.608-144-144s64.608-144 144-144 144 64.608 144 144-64.608 144-144 144z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"explore",
						"enlarge",
						"search",
						"see",
						"watch",
						"browse"
					],
					"grid": 32
				},
				{
					"id": 480,
					"width": 1024,
					"paths": [
						"M416 688c0 97.216-78.784 176-176 176s-176-78.784-176-176 78.784-176 176-176 176 78.784 176 176zM784 512c-97.216 0-176 78.784-176 176s78.784 176 176 176 176-78.784 176-176-78.784-176-176-176zM1024 688c0 132.544-107.456 240-240 240-110.112 0-202.656-74.24-230.912-175.296-11.168 9.408-25.376 15.296-41.088 15.296s-29.92-5.888-41.088-15.296c-28.256 101.056-120.8 175.296-230.912 175.296-132.544 0-240-107.456-240-240 0-38.24 9.184-74.272 25.088-106.336l112.48-270.496c14.976-43.904 46.848-79.872 87.776-100.448 6.528-46.688 46.176-82.72 94.656-82.72 53.024 0 96 42.976 96 96 0 2.624-0.544 5.088-0.768 7.648 39.52 32.288 64.768 81.344 64.768 136.352 0 7.2 0 15.712 0 24.864 9.44-5.472 20.288-8.864 32-8.864s22.56 3.392 32 8.864c0-9.152 0-17.664 0-24.864 0-55.744 25.984-105.344 66.432-137.6-0.256-2.112-0.64-4.224-0.64-6.4 0-53.024 42.976-96 96-96 48.736 0 88.576 36.448 94.752 83.52 40.064 20.704 71.136 56.384 85.92 99.648l112.48 270.496c15.872 32.064 25.056 68.096 25.056 106.336zM448 688c0-114.88-93.12-208-208-208s-208 93.12-208 208 93.12 208 208 208 208-93.12 208-208zM544 704c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM992 688c0-114.88-93.12-208-208-208s-208 93.12-208 208 93.12 208 208 208 208-93.12 208-208z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"explore",
						"enlarge",
						"search",
						"see",
						"watch",
						"browse"
					],
					"grid": 32
				},
				{
					"id": 481,
					"width": 1024,
					"paths": [
						"M443.328 219.328l-20.704 20.672 20.672 20.672c6.24 6.24 6.24 16.384 0 22.624-3.104 3.136-7.2 4.704-11.296 4.704s-8.192-1.568-11.328-4.672l-20.672-20.704-20.672 20.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672c-6.24-6.24-6.24-16.384 0-22.624l20.704-20.704-20.672-20.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l20.672 20.672 20.672-20.672c6.24-6.24 16.384-6.24 22.624 0s6.272 16.352 0.032 22.624zM603.328 196.672c-6.24-6.24-16.384-6.24-22.624 0l-20.704 20.704-20.672-20.672c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l20.672 20.672-20.672 20.672c-6.24 6.24-6.24 16.384 0 22.624 3.104 3.136 7.2 4.704 11.296 4.704s8.192-1.568 11.328-4.672l20.672-20.704 20.672 20.672c3.136 3.136 7.232 4.704 11.328 4.704s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-20.704-20.704 20.672-20.672c6.272-6.272 6.272-16.384 0.032-22.656zM832 769.152v142.848c0 8.832-7.168 16-16 16s-16-7.168-16-16v-142.848c0-17.088-6.656-33.184-18.752-45.28l-80.768-80.768c-1.504 15.136-3.616 30.656-6.112 46.304 1.792 0.768 3.488 1.824 4.928 3.264l40.576 40.576c18.144 18.144 28.128 42.24 28.128 67.904v142.848c0 8.832-7.168 16-16 16s-16-7.168-16-16v-142.848c0-17.088-6.656-33.184-18.752-45.28l-29.664-29.664c-28 133.504-93.44 265.792-207.584 265.792s-179.584-132.288-207.584-265.792l-29.664 29.664c-12.096 12.096-18.752 28.16-18.752 45.28v142.848c0 8.832-7.168 16-16 16s-16-7.168-16-16v-142.848c0-25.632 9.984-49.76 28.128-67.904l40.576-40.576c1.44-1.44 3.168-2.496 4.928-3.264-2.496-15.648-4.608-31.168-6.112-46.304l-80.768 80.768c-12.096 12.096-18.752 28.16-18.752 45.28v142.848c0 8.832-7.168 16-16 16s-16-7.168-16-16v-142.848c0-25.632 9.984-49.76 28.128-67.904l100.48-100.48c-0.32-8.416-0.608-16.8-0.608-24.768 0-31.104 2.592-58.528 7.776-82.656-1.056-0.64-2.176-1.12-3.072-2.048l-72.576-72.576c-18.144-18.112-28.128-42.208-28.128-67.872v-142.848c0-8.832 7.168-16 16-16s16 7.168 16 16v142.848c0 17.088 6.656 33.184 18.752 45.28l63.136 63.136c17.056-44.288 47.008-73.664 91.84-90.272-47.072-16.64-77.728-49.824-77.728-112.992 0-106.048 85.952-192 192-192s192 85.952 192 192c0 63.168-30.656 96.352-77.728 112.992 44.832 16.608 74.784 45.984 91.84 90.272l63.136-63.136c12.096-12.096 18.752-28.16 18.752-45.28v-142.848c0-8.832 7.168-16 16-16s16 7.168 16 16v142.848c0 25.632-9.984 49.76-28.128 67.904l-72.576 72.576c-0.896 0.896-2.016 1.408-3.072 2.048 5.184 24.096 7.776 51.52 7.776 82.624 0 7.968-0.288 16.352-0.608 24.768l100.48 100.48c18.144 18.144 28.128 42.24 28.128 67.904zM496 384.384v123.072c0 81.216 31.616 157.536 89.024 214.944l56.096 56.096c22.24-72.224 30.88-148.576 30.88-202.496 0-136.192-46.624-187.776-176-191.616zM480 352c132.8 0 160-38.368 160-96 0-88.224-71.776-160-160-160s-160 71.776-160 160c0 57.632 27.2 96 160 96zM288 576c0 53.92 8.64 130.272 30.88 202.496l56.096-56.096c57.408-57.408 89.024-133.76 89.024-214.944v-123.072c-129.376 3.84-176 55.424-176 191.616zM622.24 831.008c2.688-6.24 4.96-12.704 7.392-19.072-0.288-0.256-0.672-0.352-0.928-0.64l-66.272-66.272c-38.496-38.496-66.336-84.8-82.4-135.232-16.064 50.432-43.904 96.736-82.4 135.232l-66.272 66.272c-0.288 0.288-0.64 0.384-0.928 0.64 2.432 6.4 4.704 12.864 7.392 19.072 25.184 58.848 70.368 128.992 142.176 128.992s116.992-70.144 142.24-128.992z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exterminate",
						"die",
						"kill",
						"infest"
					],
					"grid": 32
				},
				{
					"id": 482,
					"width": 1024,
					"paths": [
						"M803.872 701.248l-100.48-100.48c0.32-8.416 0.608-16.8 0.608-24.768 0-31.104-2.592-58.528-7.776-82.656 1.056-0.64 2.176-1.12 3.072-2.048l72.576-72.576c18.144-18.112 28.128-42.208 28.128-67.872v-142.848c0-8.832-7.168-16-16-16s-16 7.168-16 16v142.848c0 17.088-6.656 33.184-18.752 45.28l-63.136 63.136c-17.056-44.288-47.008-73.664-91.84-90.272 47.072-16.64 77.728-49.824 77.728-112.992 0-106.048-85.952-192-192-192s-192 85.952-192 192c0 63.168 30.656 96.352 77.728 112.992-44.832 16.608-74.784 45.984-91.84 90.272l-63.136-63.136c-12.096-12.096-18.752-28.16-18.752-45.28v-142.848c0-8.832-7.168-16-16-16s-16 7.168-16 16v142.848c0 25.632 9.984 49.76 28.128 67.904l72.576 72.576c0.896 0.896 2.016 1.408 3.072 2.048-5.184 24.096-7.776 51.52-7.776 82.624 0 7.968 0.288 16.352 0.608 24.768l-100.48 100.48c-18.144 18.144-28.128 42.24-28.128 67.904v142.848c0 8.832 7.168 16 16 16s16-7.168 16-16v-142.848c0-17.088 6.656-33.184 18.752-45.28l80.768-80.768c1.504 15.136 3.616 30.656 6.112 46.304-1.792 0.768-3.488 1.824-4.928 3.264l-40.576 40.576c-18.144 18.144-28.128 42.24-28.128 67.904v142.848c0 8.832 7.168 16 16 16s16-7.168 16-16v-142.848c0-17.088 6.656-33.184 18.752-45.28l29.664-29.664c28 133.504 93.44 265.792 207.584 265.792s179.584-132.288 207.584-265.792l29.664 29.664c12.096 12.096 18.752 28.16 18.752 45.28v142.848c0 8.832 7.168 16 16 16s16-7.168 16-16v-142.848c0-25.632-9.984-49.76-28.128-67.904l-40.576-40.576c-1.44-1.44-3.168-2.496-4.928-3.264 2.496-15.648 4.608-31.168 6.112-46.304l80.768 80.768c12.096 12.096 18.752 28.16 18.752 45.28v142.848c0 8.832 7.168 16 16 16s16-7.168 16-16v-142.848c0-25.664-9.984-49.76-28.128-67.904zM516.672 219.328c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l20.704 20.672 20.672-20.672c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-20.672 20.672 20.672 20.672c6.24 6.24 6.24 16.384 0 22.624-3.104 3.136-7.2 4.704-11.296 4.704s-8.192-1.568-11.328-4.672l-20.672-20.704-20.672 20.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672c-6.24-6.24-6.24-16.384 0-22.624l20.704-20.704-20.704-20.672zM356.672 283.328c-6.24-6.24-6.24-16.384 0-22.624l20.704-20.704-20.672-20.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l20.672 20.672 20.672-20.672c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-20.672 20.672 20.672 20.672c6.24 6.24 6.24 16.384 0 22.624-3.104 3.136-7.2 4.704-11.296 4.704s-8.192-1.568-11.328-4.672l-20.672-20.704-20.672 20.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672zM637.888 768.16c-3.84 11.168-18.080 14.464-26.432 6.112l-49.024-49.024c-38.496-38.496-66.336-84.8-82.4-135.232-16.064 50.432-43.904 96.736-82.4 135.232l-49.024 49.024c-8.352 8.352-22.592 5.088-26.432-6.112-1.984-5.792-0.512-12.192 3.808-16.512l49.024-49.024c57.408-57.408 89.024-133.76 89.024-214.944v-75.072c0-8.832 7.168-16 16-16v0c8.832 0 16 7.168 16 16v75.072c0 81.216 31.616 157.536 89.024 214.944l49.024 49.024c4.32 4.32 5.792 10.752 3.808 16.512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exterminate",
						"die",
						"kill",
						"infest"
					],
					"grid": 32
				},
				{
					"id": 1313,
					"width": 1023.9981384277344,
					"paths": [
						"M804.571 530.286v182.857q0 68-48.286 116.286t-116.286 48.286h-475.429q-68 0-116.286-48.286t-48.286-116.286v-475.429q0-68 48.286-116.286t116.286-48.286h402.286q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-402.286q-37.714 0-64.571 26.857t-26.857 64.571v475.429q0 37.714 26.857 64.571t64.571 26.857h475.429q37.714 0 64.571-26.857t26.857-64.571v-182.857q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143zM1024 36.571v292.571q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-100.571-100.571-372.571 372.571q-5.714 5.714-13.143 5.714t-13.143-5.714l-65.143-65.143q-5.714-5.714-5.714-13.143t5.714-13.143l372.571-372.571-100.571-100.571q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857h292.571q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"external-link"
					],
					"defaultCode": 61582,
					"grid": 14
				},
				{
					"id": 1477,
					"width": 877.7129821777344,
					"paths": [
						"M731.429 530.286v-274.286q0-14.857-10.857-25.714t-25.714-10.857h-274.286q-24 0-33.714 22.286-9.714 23.429 8 40l82.286 82.286-305.143 305.143q-10.857 10.857-10.857 25.714t10.857 25.714l58.286 58.286q10.857 10.857 25.714 10.857t25.714-10.857l305.143-305.143 82.286 82.286q10.286 10.857 25.714 10.857 6.857 0 14.286-2.857 22.286-9.714 22.286-33.714zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"external-link-square"
					],
					"defaultCode": 61772,
					"grid": 14
				},
				{
					"id": 483,
					"width": 1024,
					"paths": [
						"M832.064 104.96c-2.56 0-5.184 0.32-7.84 0.96l-216.224 54.080h-32c0-10.56-5.44-19.488-13.344-25.312 8.256-10.752 13.344-24.064 13.344-38.688 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 14.624 5.088 27.936 13.344 38.688-7.904 5.824-13.344 14.752-13.344 25.312-11.264 0-23.232 0-32 0-75.52 0-144.928 26.144-199.648 69.888-14.944 11.936-16.096 34.368-2.592 47.872l22.752 22.752c6.176 6.176 14.272 9.312 22.432 9.312 6.88 0 13.824-2.24 19.648-6.752 37.952-29.504 85.632-47.072 137.408-47.072 8.864 0 20.8 0 32 0v32c-88.352 0-160 71.648-160 160v448c0 53.024 42.976 96 96 96h256c53.024 0 96-42.976 96-96v-448c0-88.352-71.648-160-160-160v-32h32l216.224 54.048c2.624 0.672 5.248 0.96 7.84 0.96 17.152 0 31.936-13.92 31.936-32v-142.016c0-18.112-14.784-32.032-31.936-32.032zM512 64c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM480 160h64v128h-64v-128zM416 224c-57.472 0-111.776 18.592-156.832 53.92l-22.816-23.008c51.456-41.152 113.6-62.912 179.648-62.912h32v32h-32zM704 448v448c0 35.296-28.704 64-64 64h-256c-35.296 0-64-28.704-64-64v-448c0-70.592 57.408-128 128-128h128c70.592 0 128 57.408 128 128zM608 224h-32v-32h32v32zM832 279.008l-192-48v-46.016l192-48v142.016z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"extinguish",
						"aid",
						"burn",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 484,
					"width": 1024,
					"paths": [
						"M640 152v112l-32-8v-96l32-8zM832.064 104.96c-2.56 0-5.184 0.32-7.84 0.96l-152.224 38.080v128l152.224 38.048c2.624 0.672 5.248 0.96 7.84 0.96 17.152 0 31.936-13.92 31.936-32v-142.016c0-18.112-14.784-32.032-31.936-32.032zM736 448v448c0 53.024-42.976 96-96 96h-256c-53.024 0-96-42.976-96-96v-448c0-88.352 71.648-160 160-160v-32c-11.2 0-23.136 0-32 0-51.776 0-99.456 17.568-137.376 47.072-5.824 4.544-12.768 6.752-19.648 6.752-8.16 0-16.256-3.136-22.432-9.312l-22.784-22.752c-13.504-13.504-12.352-35.936 2.592-47.872 54.72-43.744 124.128-69.888 199.648-69.888 8.768 0 20.736 0 32 0 0-10.56 5.44-19.488 13.344-25.312-8.256-10.752-13.344-24.064-13.344-38.688 0-35.36 28.64-64 64-64s64 28.64 64 64c0 14.624-5.088 27.936-13.344 38.688 7.904 5.824 13.344 14.752 13.344 25.312v128c88.352 0 160 71.648 160 160zM544 96c0-17.632-14.368-32-32-32s-32 14.368-32 32 14.368 32 32 32 32-14.368 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"extinguish",
						"aid",
						"burn",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 485,
					"width": 1024,
					"paths": [
						"M768 64h-512c-53.024 0-96 42.976-96 96v704c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM832 864c0 35.296-28.704 64-64 64h-512c-35.296 0-64-28.704-64-64v-704c0-35.296 28.704-64 64-64h512c35.296 0 64 28.704 64 64v704zM768 128h-512c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h512c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM768 160v224h-192v-32c0-17.664-14.336-32-32-32h-160c-17.664 0-32 14.336-32 32v32h-96v-224h512zM384 448v-96h160v96h-160zM474.208 480l-10.208 12.768-10.208-12.768h20.416zM320 864v-32h384v32h-384zM736 864v-32c0-17.664-14.336-32-32-32h-384c-17.664 0-32 14.336-32 32v32h-32v-448h96v32c0 17.664 14.336 32 32 32h28.8l38.72 48.384c3.2 4 7.84 6.016 12.48 6.016s9.28-2.016 12.48-6.016l38.72-48.384h28.8c17.664 0 32-14.336 32-32v-32h192v448h-32zM416 720c0 8.832 7.168 16 16 16h192c8.832 0 16 7.168 16 16s-7.168 16-16 16h-192c-26.464 0-48-21.536-48-48s21.536-48 48-48h160c8.832 0 16-7.168 16-16s-7.168-16-16-16h-112c-17.632 0-32-14.368-32-32v-16c0-8.832 7.168-16 16-16s16 7.168 16 16v16h112c26.464 0 48 21.536 48 48s-21.536 48-48 48h-160c-8.832 0-16 7.168-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"extrude",
						"create",
						"print",
						"fabricate"
					],
					"grid": 32
				},
				{
					"id": 486,
					"width": 1024,
					"paths": [
						"M768 64h-512c-52.928 0-96 43.072-96 96v704c0 52.928 43.072 96 96 96h512c52.928 0 96-43.072 96-96v-704c0-52.928-43.072-96-96-96zM256 128h512c17.664 0 32 14.336 32 32v224h-224v-32c0-17.664-14.336-32-32-32h-160c-17.664 0-32 14.336-32 32v32h-128v-224c0-17.664 14.336-32 32-32zM768 896h-32v-64c0-17.664-14.336-32-32-32h-384c-17.664 0-32 14.336-32 32v64h-32c-17.664 0-32-14.336-32-32v-448h128v32c0 17.664 14.336 32 32 32h28.8l38.72 48.384c3.2 4 7.84 6.016 12.48 6.016s9.28-2.016 12.48-6.016l38.72-48.384h28.8c17.664 0 32-14.336 32-32v-32h224v448c0 17.664-14.336 32-32 32zM416 720c0 8.832 7.168 16 16 16h192c8.832 0 16 7.168 16 16s-7.168 16-16 16h-192c-26.464 0-48-21.536-48-48s21.536-48 48-48h160c8.832 0 16-7.168 16-16s-7.168-16-16-16h-112c-17.632 0-32-14.368-32-32v-16c0-8.832 7.168-16 16-16s16 7.168 16 16v16h112c26.464 0 48 21.536 48 48s-21.536 48-48 48h-160c-8.832 0-16 7.168-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"extrude",
						"create",
						"print",
						"fabricate"
					],
					"grid": 32
				},
				{
					"id": 2755,
					"paths": [
						"M512 192c-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.312 0 416.876-130.042 512-320-95.116-189.958-288.688-320-512-320zM764.45 361.704c60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.858-25.486-252.452-73.704-60.158-38.372-111.138-89.772-149.432-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.86-7.3-9.96 27.328-15.41 56.822-15.41 87.596 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-30.774-5.452-60.268-15.408-87.598 3.978 2.378 7.938 4.802 11.858 7.302v0zM512 416c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.982 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye",
						"views",
						"vision",
						"visit"
					],
					"defaultCode": 60590,
					"grid": 16
				},
				{
					"id": 2758,
					"paths": [
						"M945.942 14.058c-18.746-18.744-49.136-18.744-67.882 0l-202.164 202.164c-51.938-15.754-106.948-24.222-163.896-24.222-223.318 0-416.882 130.042-512 320 41.122 82.124 100.648 153.040 173.022 207.096l-158.962 158.962c-18.746 18.746-18.746 49.136 0 67.882 9.372 9.374 21.656 14.060 33.94 14.060s24.568-4.686 33.942-14.058l864-864c18.744-18.746 18.744-49.138 0-67.884zM416 320c42.24 0 78.082 27.294 90.92 65.196l-121.724 121.724c-37.902-12.838-65.196-48.68-65.196-90.92 0-53.020 42.98-96 96-96zM110.116 512c38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 54.89 17.286 105.738 46.7 147.418l-60.924 60.924c-52.446-36.842-97.202-83.882-131.66-138.342z",
						"M768 442c0-27.166-4.256-53.334-12.102-77.898l-321.808 321.808c24.568 7.842 50.742 12.090 77.91 12.090 141.382 0 256-114.618 256-256z",
						"M830.026 289.974l-69.362 69.362c1.264 0.786 2.53 1.568 3.786 2.368 60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-38.664 0-76.902-4.76-113.962-14.040l-76.894 76.894c59.718 21.462 123.95 33.146 190.856 33.146 223.31 0 416.876-130.042 512-320-45.022-89.916-112.118-166.396-193.974-222.026z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye-blocked",
						"views",
						"vision",
						"visit",
						"banned",
						"blocked",
						"forbidden",
						"private"
					],
					"defaultCode": 60593,
					"grid": 16
				},
				{
					"id": 2760,
					"paths": [
						"M512 640c70.692 0 128-57.308 128-128 0-27.254-8.542-52.498-23.062-73.256l303.36-353.918-48.594-41.65-303.338 353.894c-17.010-8.36-36.136-13.070-56.366-13.070-70.692 0-128 57.308-128 128 0 27.254 8.544 52.498 23.062 73.256l-303.358 353.918 48.592 41.652 303.338-353.894c17.010 8.358 36.134 13.068 56.366 13.068zM330.872 575.804c-7.034-19.964-10.872-41.434-10.872-63.804 0-106.040 85.958-192 192-192 12.074 0 23.882 1.126 35.34 3.258l74.162-86.524c-35.996-8.098-72.748-12.734-109.502-12.734-256 0-511.998 223.998-512 288 0 37.63 88.516 130.558 213.48 200.762l117.392-136.958zM810.52 311.24l-117.39 136.956c7.032 19.964 10.87 41.434 10.87 63.804 0 106.040-85.96 192-192 192-12.074 0-23.882-1.126-35.34-3.258l-74.162 86.524c35.998 8.098 72.748 12.734 109.502 12.734 256 0 511.994-223.998 512-288-0.004-37.63-88.518-130.56-213.48-200.76z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye-blocked",
						"views",
						"vision",
						"visit",
						"banned",
						"blocked",
						"forbidden",
						"private"
					],
					"defaultCode": 60595,
					"grid": 16
				},
				{
					"id": 2762,
					"paths": [
						"M185.918 715.536c-6.982-4.328-13.472-8.496-19.4-12.42-43.842-29.004-84.188-62.2-113.606-93.48-35.604-37.852-52.912-69.788-52.912-97.634 0-27.848 17.308-59.784 52.908-97.636 29.418-31.278 69.764-64.476 113.606-93.48 65.42-43.278 197.296-115.884 345.484-115.884 12.624 0 25.118 0.564 37.476 1.556l-68.406 95.768c-105.086 8.742-199.808 59.404-249.384 90.736-77.54 49.008-123.030 98.656-134.052 118.942 11.022 20.286 56.51 69.934 134.050 118.94 3.198 2.020 6.6 4.128 10.164 6.294l-55.928 78.298zM971.088 414.364c-29.42-31.278-69.766-64.476-113.606-93.48-32.65-21.6-81.876-50.484-141.404-74.014l114.844-160.784-61.844-44.174-640 896 61.844 44.176 140.176-196.248c54.382 19.256 116.074 33.16 180.902 33.16 148.19 0 280.062-72.604 345.482-115.882 43.842-29.004 84.188-62.202 113.606-93.478 35.602-37.854 52.91-69.79 52.912-97.644-0.002-27.844-17.31-59.78-52.912-97.632zM792.316 630.94c-54.398 34.382-163.152 92.060-280.316 92.060-42.664 0-84.204-7.654-122.414-19.042l58.074-81.302c18.906 11.020 40.88 17.346 64.34 17.346 70.694 0 128-57.306 128-128 0-38.642-17.144-73.252-44.22-96.714l62.516-87.52c56.292 19.626 103.636 46.092 134.020 65.294 77.542 49.008 123.028 98.654 134.050 118.94-11.022 20.286-56.51 69.932-134.050 118.938z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye-blocked",
						"views",
						"vision",
						"visit",
						"banned",
						"blocked",
						"forbidden",
						"private"
					],
					"defaultCode": 60597,
					"grid": 16
				},
				{
					"id": 2757,
					"paths": [
						"M640 128h384v128h-384v-128z",
						"M870.32 320h-294.32v-124.388c-21.014-2.376-42.364-3.612-64-3.612-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.31 0 416.876-130.042 512-320-37.396-74.686-90.020-140.1-153.68-192zM416 320c53.020 0 96 42.982 96 96 0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96zM764.448 662.296c-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.86-25.486-252.454-73.704-60.156-38.372-111.136-89.772-149.43-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 141.382 114.616 256 256 256 141.38 0 256-114.618 256-256 0-30.774-5.454-60.268-15.408-87.598 3.976 2.378 7.938 4.802 11.858 7.302 60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye-minus",
						"views",
						"vision",
						"visit"
					],
					"defaultCode": 60592,
					"grid": 16
				},
				{
					"id": 2756,
					"paths": [
						"M1024 128h-128v-128h-128v128h-128v128h128v128h128v-128h128z",
						"M863.862 446.028c18.436 20.478 35.192 42.53 50.022 65.972-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.86-25.486-252.454-73.704-60.156-38.372-111.136-89.772-149.43-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 141.382 114.616 256 256 256 141.38 0 256-114.618 256-256 0-0.692-0.018-1.38-0.024-2.072-109.284-28.138-190.298-126.63-191.932-244.31-21.026-2.38-42.394-3.618-64.044-3.618-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.31 0 416.876-130.042 512-320-17.64-35.23-38.676-68.394-62.65-99.054-29.28 17.178-62.272 28.71-97.488 33.082zM416 320c53.020 0 96 42.982 96 96 0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye-plus",
						"views",
						"vision",
						"visit"
					],
					"defaultCode": 60591,
					"grid": 16
				},
				{
					"id": 1284,
					"width": 1024.002031326294,
					"paths": [
						"M317.143 762.857l44.571-80.571q-49.714-36-77.714-90.857t-28-116q0-69.143 34.857-128.571-130.857 66.857-217.714 201.714 95.429 147.429 244 214.286zM539.429 329.143q0-11.429-8-19.429t-19.429-8q-71.429 0-122.571 51.143t-51.143 122.571q0 11.429 8 19.429t19.429 8 19.429-8 8-19.429q0-49.143 34.857-84t84-34.857q11.429 0 19.429-8t8-19.429zM746.857 220q0 4-0.571 5.143-60 107.429-180 323.429t-180.571 324l-28 50.857q-5.714 9.143-16 9.143-6.857 0-76.571-40-9.143-5.714-9.143-16 0-6.857 25.143-49.714-81.714-37.143-150.571-98.857t-119.143-140q-11.429-17.714-11.429-39.429t11.429-39.429q87.429-134.286 217.143-212t283.429-77.714q50.857 0 102.857 9.714l30.857-55.429q5.714-9.143 16-9.143 2.857 0 10.286 3.429t17.714 8.857 18.857 10.571 18 10.571 11.143 6.571q9.143 5.714 9.143 15.429zM768 475.429q0 79.429-45.143 144.857t-119.429 94l160-286.857q4.571 25.714 4.571 48zM1024 548.571q0 20-11.429 39.429-22.286 36.571-62.286 82.857-85.714 98.286-198.571 152.571t-239.714 54.286l42.286-75.429q121.143-10.286 224.286-78.286t172.286-175.429q-65.714-102.286-161.143-168l36-64q54.286 36.571 104.286 87.429t82.571 105.143q11.429 19.429 11.429 39.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye-slash"
					],
					"defaultCode": 61552,
					"grid": 14
				},
				{
					"id": 2759,
					"paths": [
						"M512 224c-256 0-511.998 223.998-512 288v0c0.002 64.002 256 288 512 288s511.994-223.998 512-288v0c-0.006-64.002-256-288-512-288zM512 704c-106.042 0-192-85.96-192-192s85.958-192 192-192c106.040 0 192 85.96 192 192s-85.96 192-192 192zM384 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye",
						"views",
						"vision",
						"visit"
					],
					"defaultCode": 60594,
					"grid": 16
				},
				{
					"id": 2761,
					"paths": [
						"M512 819c-148.19 0-280.064-72.604-345.484-115.882-43.842-29.004-84.188-62.202-113.606-93.48-35.602-37.854-52.91-69.79-52.91-97.636 0-27.848 17.308-59.784 52.912-97.638 29.418-31.278 69.764-64.476 113.606-93.48 65.418-43.278 197.294-115.884 345.482-115.884s280.062 72.606 345.482 115.884c43.84 29.004 84.186 62.202 113.606 93.48 35.602 37.852 52.91 69.788 52.912 97.63-0.002 27.854-17.31 59.79-52.912 97.644-29.418 31.278-69.764 64.474-113.606 93.478-65.42 43.28-197.292 115.884-345.482 115.884zM97.634 512c11.022 20.286 56.51 69.934 134.050 118.94 54.4 34.38 163.154 92.058 280.316 92.058 117.164 0 225.918-57.678 280.316-92.060 77.54-49.006 123.028-98.652 134.048-118.938-11.024-20.286-56.51-69.932-134.050-118.94-54.398-34.382-163.152-92.060-280.314-92.060s-225.916 57.678-280.314 92.060c-77.54 49.006-123.030 98.654-134.052 118.94zM384 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye",
						"views",
						"vision",
						"visit"
					],
					"defaultCode": 60596,
					"grid": 16
				},
				{
					"id": 2763,
					"paths": [
						"M512 320c-209.368 0-395.244 100.556-512 256 116.756 155.446 302.632 256 512 256s395.244-100.554 512-256c-116.756-155.444-302.632-256-512-256zM448 448c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM773.616 705.296c-39.648 20.258-81.652 35.862-124.846 46.376-44.488 10.836-90.502 16.328-136.77 16.328-46.266 0-92.282-5.492-136.768-16.324-43.194-10.518-85.198-26.122-124.846-46.376-63.020-32.202-120.222-76.41-167.64-129.298 47.418-52.888 104.62-97.1 167.64-129.298 32.336-16.522 66.242-29.946 101.082-40.040-19.888 30.242-31.468 66.434-31.468 105.336 0 106.040 85.962 192 192 192s192-85.96 192-192c0-38.902-11.582-75.094-31.466-105.34 34.838 10.096 68.744 23.52 101.082 40.042 63.022 32.198 120.218 76.408 167.638 129.298-47.42 52.886-104.618 97.1-167.638 129.296zM860.918 243.722c-108.72-55.554-226.112-83.722-348.918-83.722s-240.198 28.168-348.918 83.722c-58.772 30.032-113.732 67.904-163.082 112.076v109.206c55.338-58.566 120.694-107.754 192.194-144.29 99.62-50.904 207.218-76.714 319.806-76.714s220.186 25.81 319.804 76.716c71.502 36.536 136.858 85.724 192.196 144.29v-109.206c-49.35-44.174-104.308-82.046-163.082-112.078z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye",
						"views",
						"vision",
						"visit"
					],
					"defaultCode": 60598,
					"grid": 16
				},
				{
					"id": 1283,
					"width": 1023.9979572296143,
					"paths": [
						"M950.857 548.571q-86.857-134.857-217.714-201.714 34.857 59.429 34.857 128.571 0 105.714-75.143 180.857t-180.857 75.143-180.857-75.143-75.143-180.857q0-69.143 34.857-128.571-130.857 66.857-217.714 201.714 76 117.143 190.571 186.571t248.286 69.429 248.286-69.429 190.571-186.571zM539.429 329.143q0-11.429-8-19.429t-19.429-8q-71.429 0-122.571 51.143t-51.143 122.571q0 11.429 8 19.429t19.429 8 19.429-8 8-19.429q0-49.143 34.857-84t84-34.857q11.429 0 19.429-8t8-19.429zM1024 548.571q0 19.429-11.429 39.429-80 131.429-215.143 210.571t-285.429 79.143-285.429-79.429-215.143-210.286q-11.429-20-11.429-39.429t11.429-39.429q80-130.857 215.143-210.286t285.429-79.429 285.429 79.429 215.143 210.286q11.429 20 11.429 39.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye"
					],
					"defaultCode": 61550,
					"grid": 14
				},
				{
					"id": 122,
					"paths": [
						"M1017.429 520.474c-2.429-2.698-60.515-66.826-151.349-131.706-53.587-38.277-107.499-68.826-160.234-90.8-66.837-27.848-132.056-41.968-193.846-41.968s-127.010 14.12-193.846 41.97c-52.736 21.973-106.646 52.523-160.234 90.8-90.832 64.878-148.92 129.006-151.349 131.704-8.763 9.736-8.763 24.515 0 34.251 2.429 2.699 60.517 66.827 151.349 131.707 53.587 38.277 107.498 68.827 160.234 90.8 66.837 27.848 132.056 41.968 193.846 41.968s127.010-14.12 193.846-41.968c52.734-21.973 106.645-52.523 160.234-90.8 90.834-64.88 148.92-129.008 151.349-131.706 8.762-9.736 8.762-24.517 0-34.253zM643.789 329.643c46.458 39.074 73.011 95.923 73.011 156.757 0 112.926-91.874 204.8-204.8 204.8-112.928 0-204.8-91.874-204.8-204.8 0-60.835 26.554-117.685 73.014-156.757 42.107-13.744 86.602-22.443 131.786-22.443 45.186 0 89.682 8.699 131.789 22.443zM835.418 645.413c-78.488 55.925-198.309 122.587-323.418 122.587s-244.93-66.662-323.416-122.587c-59.24-42.21-104.574-84.89-127.458-107.813 22.888-22.928 68.222-65.606 127.458-107.813 27.13-19.331 59.2-39.942 94.72-58.643-17.766 35.224-27.304 74.52-27.304 115.256 0 141.16 114.842 256 256 256 141.16 0 256-114.84 256-256 0-40.734-9.538-80.032-27.301-115.256 35.517 18.701 67.589 39.312 94.718 58.643 59.238 42.21 104.573 84.89 127.456 107.813-22.888 22.928-68.222 65.606-127.456 107.813z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eye",
						"vision",
						"view"
					],
					"defaultCode": 59419,
					"grid": 20
				},
				{
					"id": 1862,
					"paths": [
						"M986.51 37.49c-49.988-49.986-131.032-49.986-181.020 0l-172.118 172.118-121.372-121.372-135.764 135.764 106.426 106.426-472.118 472.118c-8.048 8.048-11.468 18.958-10.3 29.456h-0.244v160c0 17.674 14.328 32 32 32h160c0 0 2.664 0 4 0 9.212 0 18.426-3.516 25.456-10.544l472.118-472.118 106.426 106.426 135.764-135.764-121.372-121.372 172.118-172.118c49.986-49.988 49.986-131.032 0-181.020zM173.090 960h-109.090v-109.090l469.574-469.572 109.088 109.088-469.572 469.574z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eyedropper",
						"color",
						"color-picker",
						"sample"
					],
					"defaultCode": 59697,
					"grid": 16
				},
				{
					"id": 1863,
					"paths": [
						"M986.51 37.49c-49.988-49.986-131.032-49.986-181.020 0l-172.118 172.118-121.372-121.372-135.764 135.764 106.426 106.426-472.118 472.118c-8.048 8.048-11.468 18.958-10.3 29.456h-0.244v160c0 17.674 14.328 32 32 32h160c0 0 2.664 0 4 0 9.212 0 18.426-3.516 25.456-10.544l472.118-472.118 106.426 106.426 135.764-135.764-121.372-121.372 172.118-172.118c49.986-49.988 49.986-131.032 0-181.020zM493.088 640h-218.176l258.664-258.662 109.088 109.088-149.576 149.574z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eyedropper",
						"color",
						"color-picker",
						"sample"
					],
					"defaultCode": 59698,
					"grid": 16
				},
				{
					"id": 1864,
					"paths": [
						"M768 320h-112c-64 0-16-64-16-192 0-15.11-1.8-26.614-4.948-35.22-15.302-53.558-64.58-92.78-123.052-92.78-58.47 0-107.75 39.222-123.052 92.78-3.146 8.606-4.948 20.11-4.948 35.22 0 128 48 192-16 192h-112v128h128v496c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16v-496h128v-128zM576 897.608c-31.298 6.378-56.014 31.094-62.392 62.392h-3.214c-6.38-31.298-31.094-56.014-62.392-62.392v-449.608h128v449.608z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eyedropper",
						"color",
						"color-picker",
						"sample"
					],
					"defaultCode": 59699,
					"grid": 16
				},
				{
					"id": 1641,
					"width": 1024.0010375976562,
					"paths": [
						"M970.286 53.714q53.714 53.714 53.714 129.429t-53.714 128.857l-128.571 127.429 59.429 59.429q5.714 5.714 5.714 13.143t-5.714 13.143l-120 120q-5.714 5.714-13.143 5.714t-13.143-5.714l-60-60-344.571 344.571q-21.143 21.143-51.429 21.143h-116l-146.286 73.143-36.571-36.571 73.143-146.286v-116q0-30.286 21.143-51.429l344.571-344.571-60-60q-5.714-5.714-5.714-13.143t5.714-13.143l120-120q5.714-5.714 13.143-5.714t13.143 5.714l59.429 59.429 127.429-128.571q53.143-53.714 128.857-53.714t129.429 53.714zM292.571 841.143l329.143-329.143-109.714-109.714-329.143 329.143v109.714h109.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"eyedropper"
					],
					"defaultCode": 61947,
					"grid": 14
				},
				{
					"id": 1812,
					"width": 898.8559722900391,
					"paths": [
						"M877.714 292.571v479.429q0 27.429-28 35.429-99.429 29.714-193.143 29.714-41.714 0-123.143-16.857t-130-16.857q-93.714 0-211.429 27.429v193.143h-91.429v-781.714q-36-14.286-57.714-46.286t-21.714-70.857q0-52 36.571-88.571t88.571-36.571 88.571 36.571 36.571 88.571q0 38.857-21.714 70.857t-57.714 46.286v38.857q108.571-25.143 196-25.143 56.571 0 113.143 8.571 8 1.143 63.714 12.857t85.429 11.714q44 0 94.286-10.286 6.286-1.143 45.714-12t50.857-10.857q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fa",
						"font-awesome"
					],
					"defaultCode": 62132,
					"grid": 14
				},
				{
					"id": 3332,
					"paths": [
						"M608 192h160v-192h-160c-123.514 0-224 100.486-224 224v96h-128v192h128v512h192v-512h160l32-192h-192v-96c0-17.346 14.654-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"facebook",
						"brand",
						"social"
					],
					"defaultCode": 61167,
					"grid": 16
				},
				{
					"id": 1688,
					"width": 877.7150707244873,
					"paths": [
						"M829.143 73.143q20 0 34.286 14.286t14.286 34.286v780.571q0 20-14.286 34.286t-34.286 14.286h-223.429v-340h113.714l17.143-132.571h-130.857v-84.571q0-32 13.429-48t52.286-16l69.714-0.571v-118.286q-36-5.143-101.714-5.143-77.714 0-124.286 45.714t-46.571 129.143v97.714h-114.286v132.571h114.286v340h-420q-20 0-34.286-14.286t-14.286-34.286v-780.571q0-20 14.286-34.286t34.286-14.286h780.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"facebook-official"
					],
					"defaultCode": 62000,
					"grid": 14
				},
				{
					"id": 1301,
					"width": 877.7150573730469,
					"paths": [
						"M713.143 73.143q68 0 116.286 48.286t48.286 116.286v548.571q0 68-48.286 116.286t-116.286 48.286h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571q0-32 13.429-48t52.286-16l69.714-0.571v-118.286q-36-5.143-101.714-5.143-77.714 0-124.286 45.714t-46.571 129.143v97.714h-114.286v132.571h114.286v340h-304q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"facebook-square"
					],
					"defaultCode": 61570,
					"grid": 14
				},
				{
					"id": 3333,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h416v-448h-128v-128h128v-64c0-105.8 86.2-192 192-192h128v128h-128c-35.2 0-64 28.8-64 64v64h192l-32 128h-160v448h288c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"facebook",
						"brand",
						"social"
					],
					"defaultCode": 61168,
					"grid": 16
				},
				{
					"id": 1324,
					"width": 602.2870178222656,
					"paths": [
						"M548 6.857v150.857h-89.714q-49.143 0-66.286 20.571t-17.143 61.714v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571q0-106.286 59.429-164.857t158.286-58.571q84 0 130.286 6.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"facebook",
						"facebook-f"
					],
					"defaultCode": 61594,
					"grid": 14
				},
				{
					"id": 2428,
					"paths": [
						"M960 896v-576l-256 192v-192l-256 192v-256l-256 192v-384h-128v832h-64v64h1024v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"factory",
						"manufacture",
						"make",
						"generate",
						"produce",
						"production"
					],
					"defaultCode": 60263,
					"grid": 16
				},
				{
					"id": 487,
					"width": 1024,
					"paths": [
						"M960 448c-38.464 0-72.544 17.312-96 44.16-23.456-26.848-57.536-44.16-96-44.16h-32v-96c0-106.048-85.952-192-192-192h-352c-106.048 0-192 85.952-192 192v352c0 88.352 71.648 160 160 160h608c88.352 0 160-71.648 160-160v-68.512c55.104-14.272 96-63.904 96-123.488v-32c0-17.664-14.336-32-32-32h-32zM736 595.744c16.704 18.976 38.72 33.184 64 39.744v36.512c-35.36 0-64-28.64-64-64v-12.256zM32 704v-96h96v219.488c-55.104-14.304-96-63.904-96-123.488zM160 608h96v224h-96v-224zM512 832h-96v-224h32c35.36 0 64 28.64 64 64v160zM384 832h-96v-224h96v224zM992 512c0 43.488-29.632 81.504-72.032 92.512l-23.968 6.208v93.28c0 70.688-57.312 128-128 128h-224v-160c0-53.024-42.976-96-96-96h-416v-224c0-88.352 71.648-160 160-160h352c88.352 0 160 71.648 160 160v256c0 53.024 42.976 96 96 96h32v-93.28l-23.968-6.208c-42.4-11.008-72.032-49.024-72.032-92.512v-32h32c27.648 0 53.184 11.808 71.904 33.216l24.096 27.552 24.096-27.552c18.72-21.408 44.256-33.216 71.904-33.216h32v32zM192 448c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM416 448c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fail",
						"swim"
					],
					"grid": 32
				},
				{
					"id": 488,
					"width": 1024,
					"paths": [
						"M288 608h96v256h-96v-256zM128 608h-128v96c0 77.408 54.976 141.952 128 156.768v-252.768zM160 864h96v-256h-96v256zM448 608h-32v256h96v-192c0-35.296-28.704-64-64-64zM1024 480v32c0 59.584-40.896 109.184-96 123.488v68.512c0 88.352-71.648 160-160 160h-224v-192c0-52.928-43.072-96-96-96h-448v-224c0-106.048 85.952-192 192-192h352c106.048 0 192 85.952 192 192v256c0 35.36 28.64 64 64 64v-36.512c-11.424-2.976-22.080-7.68-32-13.536v-173.952c38.464 0 72.544 17.312 96 44.16 23.456-26.848 57.536-44.16 96-44.16h32c17.664 0 32 14.336 32 32zM192 448c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM416 448c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fail",
						"swim"
					],
					"grid": 32
				},
				{
					"id": 489,
					"width": 1024,
					"paths": [
						"M730.336 497.28c3.68-32.32 5.664-66.016 5.664-100.48 0-13.76-0.192-27.264-0.608-40.512-0.512-17.056-14.88-30.336-31.648-30.336-0.928 0-1.888 0.032-2.816 0.128-6.784 0.608-13.12 0.864-18.944 0.864-30.4 0-47.2-6.944-47.2-6.944s36.384-4.096 78.176-34.304c9.92-7.168 15.392-19.424 13.536-31.52-20.576-134.496-79.264-222.176-214.496-222.176-174.848 0-221.984 146.208-223.936 351.2 2.752 10.848 5.376 21.184 8.16 32.032 15.296 27.904 39.52 59.168 77.12 80.768 0 0-0.8 0.064-2.304 0.064-6.176 0-24.288-1.056-48.832-11.808-2.112-0.928-4.288-1.344-6.368-1.344-9.76 0-18.080 9.408-15.68 20.032 36.896 163.968 152.352 290.688 248.512 290.688 1.28 0 2.432-0.384 3.68-0.448 32.512 72.608 78.4 136.064 142.624 180.032 2.752 1.888 5.888 2.784 9.024 2.784 5.088 0 10.080-2.432 13.184-6.944 4.992-7.296 3.168-17.248-4.16-22.24-56.704-38.848-97.888-95.296-127.808-160.448 51.2-18.816 91.328-76.096 117.184-155.36 6.336-19.392-7.36-39.264-27.616-41.696-29.888-3.616-49.568-13.312-49.568-13.312s37.696-4.128 80.448-35.872c13.728-10.176 22.72-25.856 24.672-42.848zM698.528 493.632c-0.928 8.16-5.408 15.936-11.936 20.8-34.464 25.568-64.864 29.76-64.864 29.76-14.144 1.568-25.568 12.256-28.032 26.272s4.608 27.968 17.376 34.24c2.528 1.248 25.568 12.224 60.896 16.352-24.288 74.528-59.68 122.016-99.328 135.872-101.024-256.352-45.6-621.664-44.832-626.432 1.376-8.736-4.608-16.928-13.312-18.304-8.608-1.44-16.928 4.576-18.304 13.312-3.104 19.712-57.024 374.208 42.752 635.296-69.184-8.224-161.376-101.952-200.448-237.152 14.592 3.68 25.824 4.416 32.544 4.416 3.168 0 4.832-0.16 4.832-0.16 13.856-1.376 25.536-11.552 28.448-25.152s-2.976-27.552-15.040-34.496c-25.6-14.72-46.816-36.576-63.104-64.992l-3.296-12.992-2.784-10.88c3.584-277.792 98.944-315.392 191.904-315.392 105.824 0 162.24 60.16 182.24 195.744-33.664 24.352-63.008 28.448-63.008 28.448-14.496 1.632-26.080 12.864-28.128 27.328s5.984 28.48 19.488 34.048c3.776 1.568 24.416 9.344 59.392 9.344 6.688 0 13.952-0.288 21.408-1.664 0.416 12.928 0.608 26.112 0.608 39.552 0 32.512-1.824 65.088-5.472 96.832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fall",
						"believe",
						"float",
						"fly"
					],
					"grid": 32
				},
				{
					"id": 490,
					"width": 1024,
					"paths": [
						"M730.336 497.28c3.68-32.32 5.664-66.016 5.664-100.48 0-13.76-0.192-27.264-0.608-40.512-0.512-17.056-14.88-30.336-31.648-30.336-0.928 0-1.888 0.032-2.816 0.128-6.784 0.608-13.12 0.864-18.944 0.864-30.4 0-47.2-6.944-47.2-6.944s36.384-4.096 78.176-34.304c9.92-7.168 15.392-19.424 13.536-31.52-20.576-134.496-79.264-222.176-214.496-222.176-174.848 0-221.984 146.208-223.936 351.2 2.752 10.848 5.376 21.184 8.16 32.032 15.296 27.904 39.52 59.168 77.12 80.768 0 0-0.8 0.064-2.304 0.064-6.176 0-24.288-1.056-48.832-11.808-2.112-0.928-4.288-1.344-6.368-1.344-9.76 0-18.080 9.408-15.68 20.032 36.896 163.968 152.352 290.688 248.512 290.688 1.28 0 2.432-0.384 3.68-0.448 32.512 72.608 78.4 136.064 142.624 180.032 2.752 1.888 5.888 2.784 9.024 2.784 5.088 0 10.080-2.432 13.184-6.944 4.992-7.296 3.168-17.248-4.16-22.24-56.704-38.848-97.888-95.296-127.808-160.448 51.2-18.816 91.328-76.096 117.184-155.36 6.336-19.392-7.36-39.264-27.616-41.696-29.888-3.616-49.568-13.312-49.568-13.312s37.696-4.128 80.448-35.872c13.728-10.176 22.72-25.856 24.672-42.848zM539.904 729.408c-7.2 0-13.632-4.64-15.744-11.488-79.328-255.392-30.976-573.76-28.064-592.416 1.376-8.736 9.728-14.752 18.304-13.312 8.704 1.376 14.688 9.568 13.312 18.304-0.736 4.48-49.504 326.336 27.936 577.824 3.232 10.496-4.736 21.088-15.744 21.088z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fall",
						"believe",
						"float",
						"fly"
					],
					"grid": 32
				},
				{
					"id": 2793,
					"paths": [
						"M920.906 504.602c-50.784-50.782-113.226-82.782-178.71-96.042l205.112-205.112c43.598-43.602 67.838-99.218-14.288-154.328-135.070-80.186-312.242-62.202-428.416 53.974-50.784 50.784-82.782 113.228-96.042 178.71l-205.112-205.112c-43.602-43.596-99.22-67.838-154.328 14.288-80.186 135.070-62.202 312.242 53.972 428.416 50.784 50.784 113.228 82.782 178.712 96.042l-205.112 205.114c-43.598 43.602-67.838 99.218 14.288 154.324 135.070 80.188 312.242 62.204 428.416-53.968 50.784-50.786 82.784-113.228 96.042-178.714l205.112 205.112c43.604 43.598 99.218 67.84 154.328-14.286 80.186-135.070 62.2-312.242-53.974-428.418zM512 640c-70.692 0-128-57.306-128-128 0-70.692 57.308-128 128-128 70.694 0 128 57.308 128 128 0 70.694-57.306 128-128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fan",
						"wind"
					],
					"defaultCode": 60628,
					"grid": 16
				},
				{
					"id": 1248,
					"width": 1024.0009574890137,
					"paths": [
						"M998.286 80.571q10.857-10.857 18.286-7.429t7.429 18.286v841.143q0 14.857-7.429 18.286t-18.286-7.429l-405.714-405.714q-5.143-5.143-7.429-10.857v405.714q0 14.857-7.429 18.286t-18.286-7.429l-405.714-405.714q-5.143-5.143-7.429-10.857v387.429q0 14.857-10.857 25.714t-25.714 10.857h-73.143q-14.857 0-25.714-10.857t-10.857-25.714v-804.571q0-14.857 10.857-25.714t25.714-10.857h73.143q14.857 0 25.714 10.857t10.857 25.714v387.429q2.286-6.286 7.429-10.857l405.714-405.714q10.857-10.857 18.286-7.429t7.429 18.286v405.714q2.286-6.286 7.429-10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fast-backward"
					],
					"defaultCode": 61513,
					"grid": 14
				},
				{
					"id": 1254,
					"width": 1023.9989795684814,
					"paths": [
						"M25.714 943.429q-10.857 10.857-18.286 7.429t-7.429-18.286v-841.143q0-14.857 7.429-18.286t18.286 7.429l405.714 405.714q4.571 4.571 7.429 10.857v-405.714q0-14.857 7.429-18.286t18.286 7.429l405.714 405.714q4.571 4.571 7.429 10.857v-387.429q0-14.857 10.857-25.714t25.714-10.857h73.143q14.857 0 25.714 10.857t10.857 25.714v804.571q0 14.857-10.857 25.714t-25.714 10.857h-73.143q-14.857 0-25.714-10.857t-10.857-25.714v-387.429q-2.857 5.714-7.429 10.857l-405.714 405.714q-10.857 10.857-18.286 7.429t-7.429-18.286v-405.714q-2.857 5.714-7.429 10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fast-forward"
					],
					"defaultCode": 61520,
					"grid": 14
				},
				{
					"id": 491,
					"width": 1024,
					"paths": [
						"M608 544c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM608 640c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM416 544c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM416 640c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM608 352c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM608 448c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 928c-229.376 0-416-186.624-416-416s186.624-416 416-416 416 186.624 416 416-186.624 416-416 416zM416 352c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM416 448c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM512 192c-176.736 0-320 143.264-320 320s143.264 320 320 320 320-143.264 320-320c0-176.736-143.264-320-320-320zM512 800c-158.816 0-288-129.184-288-288s129.184-288 288-288 288 129.184 288 288c0 158.816-129.184 288-288 288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fasten",
						"close",
						"button"
					],
					"grid": 32
				},
				{
					"id": 492,
					"width": 1024,
					"paths": [
						"M512 224c-158.816 0-288 129.184-288 288s129.184 288 288 288 288-129.184 288-288c0-158.816-129.184-288-288-288zM416 640c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM416 448c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM608 640c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM608 448c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 832c-176.736 0-320-143.264-320-320s143.264-320 320-320 320 143.264 320 320c0 176.736-143.264 320-320 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fasten",
						"close",
						"button"
					],
					"grid": 32
				},
				{
					"id": 493,
					"width": 1024,
					"paths": [
						"M380.832 544h41.76c21.216 0 40.864-9.376 56.16-24.096 18.752-18.016 48.736-17.792 67.2 0.672l37.504 37.504c15.584 15.584 36.064 23.36 56.576 23.36 20.48 0 40.96-7.776 56.576-23.36l7.392-7.456c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-7.424 7.424c-18.656 18.656-49.216 18.656-67.872 0l-37.504-37.504c-30.912-30.88-81.024-31.232-112.256-0.832-9.44 9.184-21.664 14.912-34.816 14.912h-37.504c0-103.104-85.952-160-192-160s-192 56.896-192 160 85.952 160 192 160c94.464 0 172.8-45.248 188.832-128zM192 640c-73.824 0-160-33.536-160-128s86.176-128 160-128 160 33.536 160 128-86.176 128-160 128zM480 384c94.464 0 172.8-45.248 188.832-128h41.76c21.216 0 40.864-9.376 56.16-24.096 18.752-18.016 48.736-17.792 67.2 0.672l37.504 37.504c15.584 15.584 36.032 23.36 56.544 23.36 20.48 0 40.96-7.776 56.576-23.36l7.424-7.456c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-7.424 7.424c-18.656 18.656-49.216 18.656-67.872 0l-37.504-37.504c-30.912-30.88-81.024-31.232-112.256-0.832-9.44 9.184-21.664 14.912-34.816 14.912h-37.504c0-103.104-85.952-160-192-160s-192 56.896-192 160 85.952 160 192 160zM480 96c73.824 0 160 33.536 160 128s-86.176 128-160 128-160-33.536-160-128 86.176-128 160-128zM961.952 823.424c-18.656 18.656-49.216 18.656-67.872 0l-37.504-37.504c-30.912-30.88-81.024-31.232-112.256-0.832-9.44 9.184-21.664 14.912-34.816 14.912h-37.504c0-103.104-85.952-160-192-160s-192 56.896-192 160 85.952 160 192 160c94.464 0 172.8-45.248 188.832-128h41.76c21.216 0 40.864-9.376 56.16-24.096 18.752-18.016 48.736-17.792 67.2 0.672l37.504 37.504c15.584 15.584 36.064 23.36 56.576 23.36 20.48 0 40.96-7.776 56.576-23.36l7.392-7.456c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-7.424 7.424zM480 928c-73.824 0-160-33.536-160-128s86.176-128 160-128 160 33.536 160 128-86.176 128-160 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"father",
						"swim",
						"reproduce"
					],
					"grid": 32
				},
				{
					"id": 494,
					"width": 1024,
					"paths": [
						"M380.832 544h41.76c21.216 0 40.864-9.376 56.16-24.096 18.752-18.016 48.736-17.792 67.2 0.672l37.504 37.504c15.584 15.584 36.064 23.36 56.576 23.36 20.48 0 40.96-7.776 56.576-23.36l7.392-7.456c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-7.424 7.424c-18.656 18.656-49.216 18.656-67.872 0l-37.504-37.504c-30.912-30.88-81.024-31.232-112.256-0.832-9.44 9.184-21.664 14.912-34.816 14.912h-37.504c0-103.104-85.952-160-192-160s-192 56.896-192 160 85.952 160 192 160c94.464 0 172.8-45.248 188.832-128zM480 384c94.464 0 172.8-45.248 188.832-128h41.76c21.216 0 40.864-9.376 56.16-24.096 18.752-18.016 48.736-17.792 67.2 0.672l37.504 37.504c15.584 15.584 36.032 23.36 56.544 23.36 20.48 0 40.96-7.776 56.576-23.36l7.424-7.456c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-7.424 7.424c-18.656 18.656-49.216 18.656-67.872 0l-37.504-37.504c-30.912-30.88-81.024-31.232-112.256-0.832-9.44 9.184-21.664 14.912-34.816 14.912h-37.504c0-103.104-85.952-160-192-160s-192 56.896-192 160 85.952 160 192 160zM961.952 823.424c-18.656 18.656-49.216 18.656-67.872 0l-37.504-37.504c-30.912-30.88-81.024-31.232-112.256-0.832-9.44 9.184-21.664 14.912-34.816 14.912h-37.504c0-103.104-85.952-160-192-160s-192 56.896-192 160 85.952 160 192 160c94.464 0 172.8-45.248 188.832-128h41.76c21.216 0 40.864-9.376 56.16-24.096 18.752-18.016 48.736-17.792 67.2 0.672l37.504 37.504c15.584 15.584 36.064 23.36 56.576 23.36 20.48 0 40.96-7.776 56.576-23.36l7.392-7.456c6.24-6.24 6.24-16.384 0-22.624v0c-6.24-6.24-16.384-6.24-22.624 0l-7.424 7.424z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"father",
						"swim",
						"reproduce"
					],
					"grid": 32
				},
				{
					"id": 1567,
					"width": 1024.0000038146973,
					"paths": [
						"M164.571 219.429q37.714 0 64.571 26.857t26.857 64.571v621.714q0 37.714-26.857 64.571t-64.571 26.857h-73.143q-37.714 0-64.571-26.857t-26.857-64.571v-621.714q0-37.714 26.857-64.571t64.571-26.857h73.143zM950.857 312.571q33.143 19.429 53.143 53.143t20 73.143v438.857q0 60.571-42.857 103.429t-103.429 42.857h-493.714q-37.714 0-64.571-26.857t-26.857-64.571v-877.714q0-22.857 16-38.857t38.857-16h384q22.857 0 50.286 11.429t43.429 27.429l86.857 86.857q16 16 27.429 43.429t11.429 50.286v93.143zM530.286 877.714v-73.143q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143zM530.286 731.429v-73.143q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143zM530.286 585.143v-73.143q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143zM676.571 877.714v-73.143q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143zM676.571 731.429v-73.143q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143zM676.571 585.143v-73.143q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143zM822.857 877.714v-73.143q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143zM822.857 731.429v-73.143q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143zM822.857 585.143v-73.143q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143zM877.714 365.714v-146.286h-91.429q-22.857 0-38.857-16t-16-38.857v-91.429h-365.714v292.571h512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fax"
					],
					"defaultCode": 61868,
					"grid": 14
				},
				{
					"id": 1947,
					"paths": [
						"M384 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM664.348 230.526c99.852 54.158 167.652 159.898 167.652 281.474s-67.8 227.316-167.652 281.474c44.066-70.126 71.652-170.27 71.652-281.474s-27.586-211.348-71.652-281.474zM288 512c0 111.204 27.584 211.348 71.652 281.474-99.852-54.16-167.652-159.898-167.652-281.474s67.8-227.314 167.652-281.474c-44.068 70.126-71.652 170.27-71.652 281.474zM96 512c0 171.9 54.404 326.184 140.652 431.722-142.302-90.948-236.652-250.314-236.652-431.722s94.35-340.774 236.652-431.722c-86.248 105.538-140.652 259.822-140.652 431.722zM787.352 80.28c142.298 90.946 236.648 250.312 236.648 431.72s-94.35 340.774-236.648 431.72c86.244-105.536 140.648-259.82 140.648-431.72s-54.404-326.184-140.648-431.72z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"feed",
						"wave",
						"radio",
						"live",
						"broadcast"
					],
					"defaultCode": 59782,
					"grid": 16
				},
				{
					"id": 1328,
					"width": 805.7119674682617,
					"paths": [
						"M219.429 768q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM512 838.286q1.143 16-9.714 27.429-10.286 12-26.857 12h-77.143q-14.286 0-24.571-9.429t-11.429-23.714q-12.571-130.857-105.429-223.714t-223.714-105.429q-14.286-1.143-23.714-11.429t-9.429-24.571v-77.143q0-16.571 12-26.857 9.714-9.714 24.571-9.714h2.857q91.429 7.429 174.857 46t148 103.714q65.143 64.571 103.714 148t46 174.857zM804.571 839.429q1.143 15.429-10.286 26.857-10.286 11.429-26.286 11.429h-81.714q-14.857 0-25.429-10t-11.143-24.286q-6.857-122.857-57.714-233.429t-132.286-192-192-132.286-233.429-58.286q-14.286-0.571-24.286-11.143t-10-24.857v-81.714q0-16 11.429-26.286 10.286-10.286 25.143-10.286h1.714q149.714 7.429 286.571 68.571t243.143 168q106.857 106.286 168 243.143t68.571 286.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"feed",
						"rss"
					],
					"defaultCode": 61598,
					"grid": 14
				},
				{
					"id": 495,
					"width": 1024,
					"paths": [
						"M704 352v-64c0-17.664-14.336-32-32-32v-24.96c0-21.568-17.472-39.040-39.040-39.040-31.456 0-56.96-25.536-56.96-56.992 0-4.672 0.576-9.312 1.696-13.824l7.040-28.16c11.808-47.232-24.032-93.024-72.736-93.024s-84.544 45.792-72.736 93.056l7.040 28.16c1.12 4.512 1.696 9.152 1.696 13.824 0 31.456-25.504 56.96-56.96 56.96-21.568 0-39.040 17.472-39.040 39.040v24.96c-17.664 0-32 14.336-32 32v64c-53.024 0-96 42.976-96 96v480c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-480c0-53.024-42.976-96-96-96zM384 231.040c0-3.872 3.168-7.040 7.040-7.040 49.056 0 88.96-39.904 88.96-88.992 0-7.264-0.896-14.528-2.656-21.568l-7.040-28.16c-3.232-12.896-0.384-26.304 7.808-36.8 8.192-10.464 20.672-16.48 33.984-16.48 13.28 0 25.6 6.016 33.792 16.48 8.192 10.496 11.040 23.904 7.808 36.8l-7.040 28.16c-1.76 7.040-2.656 14.304-2.656 21.6 0 49.056 39.904 88.96 88.96 88.96 3.872 0 7.040 3.168 7.040 7.040v24.96h-256v-24.96zM352 288h320v64h-320v-64zM768 928c0 35.296-28.704 64-64 64h-384c-35.296 0-64-28.704-64-64v-288h512v288zM768 608h-512v-160c0-35.296 28.704-64 64-64h384c35.296 0 64 28.704 64 64v160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"feed",
						"drink",
						"eat"
					],
					"grid": 32
				},
				{
					"id": 496,
					"width": 1024,
					"paths": [
						"M224 448v192h576v-192c0-53.024-42.976-96-96-96h-384c-53.024 0-96 42.976-96 96zM336 576h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16s-7.168 16-16 16zM352 464c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM320 320v-32c0-17.664 14.336-32 32-32v-24.96c0-21.568 17.472-39.040 39.040-39.040 31.456 0 56.96-25.504 56.96-56.96 0-4.672-0.576-9.312-1.696-13.856l-7.040-28.16c-11.808-47.232 24.032-93.024 72.736-93.024s84.544 45.792 72.736 93.056l-7.040 28.16c-1.12 4.512-1.696 9.152-1.696 13.792 0 31.456 25.504 56.992 56.96 56.992 21.568 0 39.040 17.472 39.040 39.040v24.96c17.664 0 32 14.336 32 32v32h-384zM224 672v256c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-256h-576zM336 864h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16s-7.168 16-16 16zM336 768h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"feed",
						"drink",
						"eat"
					],
					"grid": 32
				},
				{
					"id": 1021,
					"width": 1024,
					"paths": [
						"M736 352v0-64c0-17.664-14.336-32-32-32h-0.352c-3.552-35.872-33.888-64-70.688-64-13.76 0-24.96-11.2-24.96-24.992 0-2.048 0.256-4.096 0.736-6.048l5.856-23.392c7.072-28.288 4.832-58.944-9.92-84.096-19.744-33.728-54.592-53.472-92.672-53.472s-72.928 19.776-92.672 53.472c-14.72 25.152-16.992 55.808-9.888 84.096l5.856 23.36c0.48 2.016 0.704 4.064 0.704 6.112 0 13.76-11.2 24.96-24.96 24.96-36.8 0-67.136 28.128-70.688 64h-0.352c-17.664 0-32 14.336-32 32v64c-53.024 0-96 42.976-96 96v480c0 53.024 42.976 96 96 96h448c53.024 0 96-42.976 96-96v-480c0-53.024-42.976-96-96-96zM384 263.040c0-3.872 3.168-7.040 7.040-7.040 49.056 0 88.96-39.904 88.96-88.992 0-7.264-0.896-14.528-2.656-21.568l-7.040-28.16c-3.232-12.896-0.384-26.304 7.808-36.8 8.192-10.464 20.672-16.48 33.984-16.48 13.28 0 25.6 6.016 33.792 16.48 8.192 10.496 11.040 23.904 7.808 36.8l-7.040 28.16c-1.76 7.040-2.656 14.304-2.656 21.6 0 49.056 39.904 88.96 88.96 88.96 3.872 0 7.040 3.168 7.040 7.040v24.96h-256v-24.96zM352 320h320v64h-320v-64zM288 416h448c17.664 0 32 14.336 32 32v128h-512v-128c0-17.664 14.336-32 32-32zM736 960h-448c-17.664 0-32-14.336-32-32v-320h512v320c0 17.664-14.336 32-32 32zM384 512h-64v-32h64v32zM320 672h64v32h-64v-32zM320 768h64v32h-64v-32zM320 864h64v32h-64v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"feed",
						"drink",
						"eat"
					],
					"grid": 32
				},
				{
					"id": 2836,
					"paths": [
						"M576 633.592c146.060-29.65 256-158.782 256-313.592 0-176.732-143.27-320-320-320s-320 143.268-320 320c0 154.81 109.938 283.942 256 313.592v134.408h-192v128h192v128h128v-128h192v-128h-192v-134.408zM300.802 320c0-116.642 94.556-211.202 211.202-211.202 116.642 0 211.2 94.56 211.2 211.202 0 116.64-94.558 211.2-211.202 211.2-116.646 0-211.2-94.56-211.2-211.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"female",
						"gender",
						"sex",
						"woman"
					],
					"defaultCode": 60671,
					"grid": 16
				},
				{
					"id": 1527,
					"width": 731.4371643066406,
					"paths": [
						"M731.429 603.429q0 22.857-16 38.857t-38.857 16q-29.143 0-45.714-24.571l-129.714-194.857h-25.714v75.429l141.143 234.857q5.143 8.571 5.143 18.857 0 14.857-10.857 25.714t-25.714 10.857h-109.714v155.429q0 26.286-18.857 45.143t-45.143 18.857h-91.429q-26.286 0-45.143-18.857t-18.857-45.143v-155.429h-109.714q-14.857 0-25.714-10.857t-10.857-25.714q0-10.286 5.143-18.857l141.143-234.857v-75.429h-25.714l-129.714 194.857q-16.571 24.571-45.714 24.571-22.857 0-38.857-16t-16-38.857q0-16.571 9.143-30.286l146.286-219.429q41.714-61.143 100.571-61.143h219.429q58.857 0 100.571 61.143l146.286 219.429q9.143 13.714 9.143 30.286zM493.714 146.286q0 53.143-37.429 90.571t-90.571 37.429-90.571-37.429-37.429-90.571 37.429-90.571 90.571-37.429 90.571 37.429 37.429 90.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"female"
					],
					"defaultCode": 61826,
					"grid": 14
				},
				{
					"id": 2962,
					"paths": [
						"M800 64l-96 96v160h-128v-160l-96-96-96 96v160h-128v-160l-96-96-96 96v864h192v-192h128v192h192v-192h128v192h192v-864l-96-96zM256 768v-384h128v384h-128zM576 768v-384h128v384h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fence"
					],
					"defaultCode": 60797,
					"grid": 16
				},
				{
					"id": 1022,
					"width": 1024,
					"paths": [
						"M659.232 300.64l-51.232-30.752v-77.888c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32v77.888l-51.264 30.752c-67.072 40.224-108.736 113.824-108.736 192.064v499.296c0 17.664 14.336 32 32 32h448c17.664 0 32-14.336 32-32v-499.296c0-78.24-41.664-151.84-108.768-192.064zM704 512h-192v320h192v128h-384v-128h64v-320h-64v-19.296c0-55.872 29.76-108.448 77.664-137.184l82.336-49.408v-146.112h64v146.112l82.336 49.408c47.904 28.736 77.664 81.312 77.664 137.184v19.296zM704 800h-160v-256h160v256zM320 544h32v256h-32v-256zM576 128v0h-128v-64h128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ferment",
						"celebrate",
						"drink",
						"sip",
						"indulge",
						"pour"
					],
					"grid": 32
				},
				{
					"id": 497,
					"width": 1024,
					"paths": [
						"M600.224 669.728l-57.152 34.272 57.12 34.272c7.584 4.544 10.048 14.368 5.504 21.952-2.976 5.024-8.288 7.776-13.696 7.776-2.816 0-5.664-0.736-8.224-2.272l-71.776-43.072-71.776 43.072c-2.56 1.536-5.408 2.272-8.224 2.272-5.408 0-10.72-2.752-13.728-7.776-4.576-7.584-2.080-17.408 5.504-21.952l57.152-34.272-57.12-34.272c-7.584-4.544-10.048-14.368-5.504-21.952 4.608-7.584 14.432-9.984 21.952-5.472l71.744 43.040 71.776-43.072c7.52-4.512 17.376-2.112 21.952 5.472 4.544 7.584 2.080 17.44-5.504 21.984zM605.728 807.776c-4.576-7.584-14.4-9.984-21.952-5.472l-71.776 43.040-71.776-43.072c-7.488-4.512-17.344-2.112-21.952 5.472-4.576 7.584-2.080 17.408 5.504 21.952l57.152 34.304-57.12 34.272c-7.584 4.544-10.048 14.368-5.504 21.952 2.976 5.024 8.288 7.776 13.696 7.776 2.816 0 5.664-0.736 8.224-2.272l71.776-43.072 71.776 43.072c2.56 1.536 5.408 2.272 8.224 2.272 5.408 0 10.72-2.752 13.728-7.776 4.576-7.584 2.080-17.408-5.504-21.952l-57.152-34.272 57.12-34.272c7.616-4.544 10.080-14.4 5.536-21.952zM928 256v288.672c0 54.656-12.736 108.576-37.184 157.472l-55.456 110.848c-2.208 4.448-3.36 9.344-3.36 14.304v68.704c0 53.024-42.976 96-96 96h-448c-53.024 0-96-42.976-96-96v-68.704c0-4.96-1.152-9.856-3.392-14.304l-55.424-110.816c-24.448-48.896-37.184-102.816-37.184-157.472v-96.704c0-28.384 12.384-53.92 32-71.488 0-0.16 0-0.32 0-0.512v-120c0-123.712 100.288-224 224-224h352c123.712 0 224 100.288 224 224zM896 256c0-106.048-85.952-192-192-192h-352c-106.048 0-192 85.952-192 192v101.472c9.984-3.52 20.768-5.472 32-5.472h32c53.024 0 96 42.976 96 96v68.896c127.68 46.272 267.296 45.024 394.24-3.84 8.864-3.328 18.656 1.472 21.184 10.752 2.208 8.064-2.72 16.448-10.496 19.456-137.6 52.704-289.056 52.608-426.656-0.288-6.144-2.368-10.208-8.288-10.24-14.88l-0.032-79.968c-0.032-35.424-28.736-64.128-64.192-64.128h-31.808c-35.36 0-64 28.64-64 64v96.704c0 49.696 11.584 98.688 33.792 143.136l52.192 104.992c6.592 13.28 10.016 27.904 10.016 42.72v60.448c0 35.36 28.64 64 64 64h448c35.36 0 64-28.64 64-64v-60.448c0-14.816 3.424-29.44 10.016-42.72l52.192-104.992c22.24-44.448 33.792-93.44 33.792-143.136v-288.704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fight",
						"wear",
						"protect",
						"battle",
						"punch"
					],
					"grid": 32
				},
				{
					"id": 498,
					"width": 1024,
					"paths": [
						"M704 32h-352c-123.712 0-224 100.288-224 224v81.792c18.912-11.008 40.576-17.792 64-17.792h32c70.592 0 128 57.408 128 128v46.432c23.776 7.424 86.144 24.224 163.2 24.224 120.352 0 194.464-35.584 195.2-35.968 7.936-3.872 17.504-0.64 21.408 7.328 3.904 7.936 0.672 17.472-7.264 21.376-3.264 1.6-80.992 39.264-209.344 39.264-104.512 0-181.6-28.512-184.8-29.696-6.272-2.336-10.4-8.32-10.4-14.976v-57.984c0-52.928-43.072-96-96-96h-32c-24.672 0-46.976 9.632-64 24.96v-0.48c-19.616 17.6-32 43.136-32 71.52v96.704c0 54.656 12.736 108.576 37.184 157.472l55.424 110.816c2.24 4.448 3.392 9.344 3.392 14.304v68.704c0 53.024 42.976 96 96 96h448c53.024 0 96-42.976 96-96v-68.704c0-4.96 1.152-9.856 3.392-14.304l55.456-110.848c24.416-48.896 37.152-102.816 37.152-157.472v-288.672c0-123.712-100.288-224-224-224zM600.224 898.272c7.584 4.544 10.048 14.368 5.504 21.952-3.008 5.024-8.32 7.776-13.728 7.776-2.816 0-5.664-0.736-8.224-2.272l-71.776-43.072-71.776 43.072c-2.56 1.536-5.408 2.272-8.224 2.272-5.408 0-10.72-2.752-13.728-7.776-4.576-7.584-2.080-17.408 5.504-21.952l57.152-34.272-57.12-34.272c-7.584-4.544-10.048-14.368-5.504-21.952 4.608-7.584 14.432-9.984 21.952-5.472l71.744 43.040 71.776-43.072c7.52-4.512 17.376-2.112 21.952 5.472s2.080 17.408-5.504 21.952l-57.152 34.304 57.152 34.272zM600.224 738.272c7.584 4.544 10.048 14.368 5.504 21.952-3.008 5.024-8.32 7.776-13.728 7.776-2.816 0-5.664-0.736-8.224-2.272l-71.776-43.072-71.776 43.072c-2.56 1.536-5.408 2.272-8.224 2.272-5.408 0-10.72-2.752-13.728-7.776-4.576-7.584-2.080-17.408 5.504-21.952l57.152-34.272-57.12-34.272c-7.584-4.544-10.048-14.368-5.504-21.952 4.608-7.584 14.432-9.984 21.952-5.472l71.744 43.040 71.776-43.072c7.52-4.512 17.376-2.112 21.952 5.472s2.080 17.408-5.504 21.952l-57.152 34.304 57.152 34.272z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fight",
						"wear",
						"protect",
						"battle",
						"punch"
					],
					"grid": 32
				},
				{
					"id": 1023,
					"width": 1024,
					"paths": [
						"M964.48 839.328l-59.648-104.384 27.072-27.072c18.080-18.144 28.096-42.24 28.096-67.872s-10.016-49.728-28.128-67.872c-36.256-36.288-99.488-36.288-135.744 0l-12.704 12.736-601.952-544.608c-5.888-5.312-13.536-8.256-21.472-8.256h-96c-17.696 0-32 14.336-32 32v96c0 7.936 2.944 15.584 8.288 21.472l544.576 601.92-12.704 12.736c-18.176 18.144-28.16 42.24-28.16 67.872s9.984 49.728 28.128 67.872c36.256 36.288 99.488 36.288 135.744 0l27.072-27.072 104.384 59.68c14.592 35.68 49.184 59.52 88.672 59.52 52.928 0 96-43.072 96-96 0-39.488-23.84-74.112-59.52-88.672zM147.68 96l614.272 555.776-43.776 43.776-599.552-599.552h29.056zM96 147.68v-29.056l599.552 599.552-43.776 43.776-555.776-614.272zM662.624 886.624c-12.256 12.256-32.992 12.256-45.248 0-6.112-6.144-9.376-13.952-9.376-22.624s3.264-16.48 9.376-22.624l224-224c12.256-12.256 32.992-12.256 45.248 0 6.112 6.144 9.376 13.952 9.376 22.624s-3.264 16.48-9.376 22.624l-224 224zM867.808 907.040l-115.232-65.856 88.608-88.608 65.856 115.232c-18.4 6.4-32.832 20.832-39.232 39.232zM928 960c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fight",
						"stab",
						"clash"
					],
					"grid": 32
				},
				{
					"id": 1403,
					"width": 1097.1439056396484,
					"paths": [
						"M1097.143 548.571q-0.571 18.286-164.571 54.857l-201.143 18.286-128 36.571h-36.571l-167.429 201.143h39.429q14.857 0 25.714 2.571t10.857 6.571-10.857 6.571-25.714 2.571h-182.857v-18.286h36.571v-237.714h-91.429l-109.714 128h-54.857l-18.286-18.286v-109.714h18.286v-18.286h73.143v-4.571l-109.714-13.714v-73.143l109.714-13.714v-4.571h-73.143v-18.286h-18.286v-109.714l18.286-18.286h54.857l109.714 128h91.429v-237.714h-36.571v-18.286h182.857q14.857 0 25.714 2.571t10.857 6.571-10.857 6.571-25.714 2.571h-39.429l167.429 201.143h36.571l128 36.571 201.143 18.286q149.143 33.143 164 53.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fighter-jet"
					],
					"defaultCode": 61691,
					"grid": 14
				},
				{
					"id": 1491,
					"width": 877.713981628418,
					"paths": [
						"M585.143 292.571v-269.714q12.571 8 20.571 16l233.143 233.143q8 8 16 20.571h-269.714zM512 310.857q0 22.857 16 38.857t38.857 16h310.857v603.429q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h457.143v310.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file"
					],
					"defaultCode": 61787,
					"grid": 14
				},
				{
					"id": 125,
					"paths": [
						"M914.101 289.099l-230.4-230.4c-4.8-4.802-11.312-7.499-18.101-7.499h-486.4c-42.347 0-76.8 34.453-76.8 76.8v819.2c0 42.349 34.453 76.8 76.8 76.8h665.6c42.349 0 76.8-34.451 76.8-76.8v-640c0-6.79-2.698-13.301-7.499-18.101zM859.797 307.2h-168.597c-14.115 0-25.6-11.485-25.6-25.6v-168.597l194.197 194.197zM844.8 972.8h-665.6c-14.115 0-25.6-11.485-25.6-25.6v-819.2c0-14.115 11.485-25.6 25.6-25.6h435.2v179.2c0 42.347 34.451 76.8 76.8 76.8h179.2v588.8c0 14.115-11.485 25.6-25.6 25.6z",
						"M588.8 665.6h-128v-128c0-14.139-11.462-25.6-25.6-25.6s-25.6 11.461-25.6 25.6v128h-128c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h128v128c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-128h128c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-add",
						"file"
					],
					"defaultCode": 59422,
					"grid": 20
				},
				{
					"id": 1591,
					"width": 877.7160568237305,
					"paths": [
						"M365.714 219.429v-73.143h-73.143v73.143h73.143zM438.857 292.571v-73.143h-73.143v73.143h73.143zM365.714 365.714v-73.143h-73.143v73.143h73.143zM438.857 438.857v-73.143h-73.143v73.143h73.143zM838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-73.143v73.143h-73.143v-73.143h-292.571v877.714h731.429zM446.286 538.857l61.143 199.429q4.571 15.429 4.571 29.714 0 47.429-41.429 78.571t-104.857 31.143-104.857-31.143-41.429-78.571q0-14.286 4.571-29.714 12-36 68.571-226.286v-73.143h73.143v73.143h45.143q12.571 0 22.286 7.429t13.143 19.429zM365.714 804.571q30.286 0 51.714-10.857t21.429-25.714-21.429-25.714-51.714-10.857-51.714 10.857-21.429 25.714 21.429 25.714 51.714 10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-archive-o",
						"file-zip-o"
					],
					"defaultCode": 61894,
					"grid": 14
				},
				{
					"id": 1592,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429zM354.286 485.714q11.429 4.571 11.429 17.143v310.857q0 12.571-11.429 17.143-4.571 1.143-6.857 1.143-6.857 0-13.143-5.143l-94.857-95.429h-74.857q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h74.857l94.857-95.429q9.143-8.571 20-4zM592.571 879.429q17.714 0 28.571-13.714 73.714-90.857 73.714-207.429t-73.714-207.429q-9.143-12-24.571-13.714t-26.857 8q-12 9.714-13.429 24.857t8.286 27.143q57.143 70.286 57.143 161.143t-57.143 161.143q-9.714 12-8.286 27.143t13.429 24.286q10.286 8.571 22.857 8.571zM472 794.857q15.429 0 26.857-11.429 49.714-53.143 49.714-125.143t-49.714-125.143q-10.286-10.857-25.714-11.429t-26.286 9.714-11.429 25.429 10.286 26.571q29.714 32.571 29.714 74.857t-29.714 74.857q-10.857 11.429-10.286 26.571t11.429 25.429q11.429 9.714 25.143 9.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-audio-o",
						"file-sound-o"
					],
					"defaultCode": 61895,
					"grid": 14
				},
				{
					"id": 1982,
					"paths": [
						"M704 1024l-192-224 81.5-81.5 110.5 111.25 256-253.75 64 64-320 384z",
						"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h400c17.674 0 32-14.326 32-32s-14.326-32-32-32h-400c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v160c0 17.674 14.326 32 32 32s32-14.326 32-32v-160c0-14.332-4.372-39.35-42.194-90.924zM704 256v-153.946c22.984 17.78 50.678 41.878 81.374 72.574 30.7 30.7 54.8 58.398 72.58 81.374h-153.954z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-check",
						"file",
						"document",
						"checkmark",
						"correct",
						"tick",
						"page",
						"paper"
					],
					"defaultCode": 59817,
					"grid": 16
				},
				{
					"id": 1983,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM430 918.51l-205.254-237.254 58.508-58.51 146.746 114.744 274.742-242.744 58.514 58.508-333.256 365.256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-check",
						"file",
						"document",
						"checkmark",
						"correct",
						"tick",
						"page",
						"paper"
					],
					"defaultCode": 59818,
					"grid": 16
				},
				{
					"id": 1594,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429zM274.286 438.857q4.571-6.286 12-7.143t13.714 3.714l29.143 21.714q6.286 4.571 7.143 12t-3.714 13.714l-104 138.857 104 138.857q4.571 6.286 3.714 13.714t-7.143 12l-29.143 21.714q-6.286 4.571-13.714 3.714t-12-7.143l-129.143-172q-8-10.857 0-21.714zM732.571 610.857q8 10.857 0 21.714l-129.143 172q-4.571 6.286-12 7.143t-13.714-3.714l-29.143-21.714q-6.286-4.571-7.143-12t3.714-13.714l104-138.857-104-138.857q-4.571-6.286-3.714-13.714t7.143-12l29.143-21.714q6.286-4.571 13.714-3.714t12 7.143zM378.286 874.286q-7.429-1.143-11.714-7.429t-3.143-13.714l78.857-474.857q1.143-7.429 7.429-11.714t13.714-3.143l36 5.714q7.429 1.143 11.714 7.429t3.143 13.714l-78.857 474.857q-1.143 7.429-7.429 11.714t-13.714 3.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-code-o"
					],
					"defaultCode": 61897,
					"grid": 14
				},
				{
					"id": 2002,
					"paths": [
						"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z",
						"M416 832c-17.644 0-32-14.356-32-32v-80c0-17.996-5.976-34.62-16.044-48 10.068-13.38 16.044-30.004 16.044-48v-80c0-17.644 14.356-32 32-32 17.672 0 32-14.328 32-32s-14.328-32-32-32c-52.934 0-96 43.066-96 96v80c0 8.822-7.178 16-16 16h-16c-17.672 0-32 14.326-32 32s14.328 32 32 32h16c8.822 0 16 7.178 16 16v80c0 52.936 43.066 96 96 96 17.672 0 32-14.326 32-32s-14.326-32-32-32z",
						"M608 832c17.644 0 32-14.356 32-32v-80c0-17.996 5.976-34.62 16.042-48-10.066-13.38-16.042-30.004-16.042-48v-80c0-17.644-14.356-32-32-32-17.674 0-32-14.328-32-32s14.326-32 32-32c52.934 0 96 43.066 96 96v80c0 8.822 7.176 16 16 16h16c17.672 0 32 14.326 32 32s-14.328 32-32 32h-16c-8.824 0-16 7.178-16 16v80c0 52.936-43.066 96-96 96-17.674 0-32-14.326-32-32s14.326-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-css",
						"file",
						"document",
						"file-code",
						"file-type",
						"file-format"
					],
					"defaultCode": 59837,
					"grid": 16
				},
				{
					"id": 2003,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM384 720v80c0 17.644 14.356 32 32 32 17.674 0 32 14.326 32 32s-14.328 32-32 32c-52.934 0-96-43.064-96-96v-80c0-8.822-7.178-16-16-16h-16c-17.672 0-32-14.326-32-32s14.328-32 32-32h16c8.822 0 16-7.178 16-16v-80c0-52.934 43.066-96 96-96 17.672 0 32 14.328 32 32s-14.328 32-32 32c-17.644 0-32 14.356-32 32v80c0 17.996-5.976 34.622-16.044 48 10.068 13.378 16.044 30.004 16.044 48zM736 704h-16c-8.824 0-16 7.178-16 16v80c0 52.936-43.066 96-96 96-17.674 0-32-14.326-32-32s14.326-32 32-32c17.642 0 32-14.356 32-32v-80c0-17.996 5.974-34.622 16.042-48-10.066-13.378-16.042-30.004-16.042-48v-80c0-17.644-14.358-32-32-32-17.674 0-32-14.328-32-32s14.326-32 32-32c52.934 0 96 43.066 96 96v80c0 8.822 7.176 16 16 16h16c17.672 0 32 14.326 32 32s-14.328 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-css",
						"file",
						"document",
						"file-code",
						"file-type",
						"file-format"
					],
					"defaultCode": 59838,
					"grid": 16
				},
				{
					"id": 1978,
					"paths": [
						"M853.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-432c-44.112 0-80 35.888-80 80v240l32 704 32-704v-240c0-8.672 7.328-16 16-16 0 0 431.956-0.002 432 0v224c0 17.672 14.324 32 32 32h224l32 704 32-704c0-14.332-4.372-39.35-42.194-90.924zM640 256v-153.946c22.982 17.78 50.678 41.878 81.374 72.572 30.7 30.7 54.8 58.398 72.58 81.374h-153.954z",
						"M576 448h-192v320h-160l256 256 256-256h-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-download",
						"file",
						"document",
						"page",
						"paper"
					],
					"defaultCode": 59813,
					"grid": 16
				},
				{
					"id": 1979,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.036-17-18.312-26.924-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.854-13.304-26.924-18.312v232.118z",
						"M672 320c-17.674 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM512 992l-224-224h160v-320h128v320h160l-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-download",
						"file",
						"document",
						"page",
						"paper"
					],
					"defaultCode": 59814,
					"grid": 16
				},
				{
					"id": 1970,
					"paths": [
						"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.984 17.78 50.678 41.878 81.374 72.572zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-empty",
						"file",
						"document",
						"paper",
						"page",
						"new",
						"empty",
						"blank"
					],
					"defaultCode": 59805,
					"grid": 16
				},
				{
					"id": 1971,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.036-17-18.312-26.924-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.854-13.304-26.924-18.312v232.118z",
						"M640 288v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288c-17.674 0-32-14.328-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-empty",
						"file",
						"document",
						"paper",
						"page",
						"new",
						"empty",
						"blank"
					],
					"defaultCode": 59806,
					"grid": 16
				},
				{
					"id": 124,
					"paths": [
						"M914.101 289.099l-230.4-230.4c-4.8-4.802-11.312-7.499-18.101-7.499h-486.4c-42.347 0-76.8 34.453-76.8 76.8v819.2c0 42.349 34.453 76.8 76.8 76.8h665.6c42.349 0 76.8-34.451 76.8-76.8v-640c0-6.79-2.698-13.301-7.499-18.101zM859.797 307.2h-168.597c-14.115 0-25.6-11.485-25.6-25.6v-168.597l194.197 194.197zM870.4 947.2c0 14.115-11.485 25.6-25.6 25.6h-665.6c-14.115 0-25.6-11.485-25.6-25.6v-819.2c0-14.115 11.485-25.6 25.6-25.6h435.2v179.2c0 42.347 34.451 76.8 76.8 76.8h179.2v588.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-empty",
						"file",
						"paper",
						"new"
					],
					"defaultCode": 59421,
					"grid": 20
				},
				{
					"id": 3414,
					"paths": [
						"M743.028 384h-135.292l-95.732 141.032-95.742-141.032h-135.29l162.162 242.464-182.972 269.536h251.838v-91.576h-50.156l50.156-74.994 111.396 166.57h140.444l-182.976-269.536 162.164-242.464z",
						"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-excel",
						"file",
						"file-format",
						"xlc"
					],
					"defaultCode": 61249,
					"grid": 16
				},
				{
					"id": 1588,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429zM245.143 817.143v60.571h160.571v-60.571h-42.857l58.857-92q2.857-4 5.714-9.429t4.286-7.714 2-2.286h1.143q0.571 2.286 2.857 5.714 1.143 2.286 2.571 4.286t3.429 4.571 3.714 4.857l61.143 92h-43.429v60.571h166.286v-60.571h-38.857l-109.714-156 111.429-161.143h38.286v-61.143h-159.429v61.143h42.286l-58.857 90.857q-2.286 4-5.714 9.429t-5.143 7.714l-1.143 1.714h-1.143q-0.571-2.286-2.857-5.714-3.429-6.286-9.714-13.143l-60.571-90.857h43.429v-61.143h-165.714v61.143h38.857l108 155.429-110.857 161.714h-38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-excel-o"
					],
					"defaultCode": 61891,
					"grid": 14
				},
				{
					"id": 1984,
					"paths": [
						"M1020.806 691.65c-29.792-71.224-81.096-131.964-148.36-175.654-68.486-44.484-148.864-67.996-232.446-67.996s-163.96 23.512-232.45 67.996c-67.264 43.69-118.564 104.43-148.36 175.654-3.304 7.9-3.304 16.794 0 24.7 29.792 71.224 81.094 131.964 148.36 175.654 68.49 44.484 148.87 67.996 232.45 67.996 83.582 0 163.958-23.514 232.448-67.996 67.264-43.69 118.566-104.43 148.36-175.654 3.304-7.9 3.304-16.8-0.002-24.7zM640 640c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM837.588 838.332c-58.086 37.726-126.41 57.668-197.588 57.668s-139.5-19.942-197.586-57.668c-52.472-34.082-93.282-80.328-118.694-134.332 25.412-54.004 66.22-100.25 118.694-134.332 6.51-4.228 13.156-8.218 19.914-12-12.746 25.906-19.914 55.046-19.914 85.872 0 107.582 87.21 194.792 194.792 194.792s194.794-87.21 194.794-194.792c0-32.5-7.97-63.134-22.046-90.074 9.438 4.97 18.66 10.376 27.634 16.206 52.468 34.082 93.28 80.328 118.692 134.332-25.412 54-66.222 100.246-118.692 134.328v0z",
						"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h336c17.674 0 32-14.326 32-32s-14.326-32-32-32h-336c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v160c0 17.674 14.326 32 32 32s32-14.326 32-32v-160c0-14.332-4.372-39.35-42.194-90.924zM704 256v-153.946c22.984 17.78 50.678 41.878 81.374 72.574 30.7 30.7 54.8 58.398 72.58 81.374h-153.954z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-eye",
						"file",
						"document",
						"file-preview",
						"page",
						"paper"
					],
					"defaultCode": 59819,
					"grid": 16
				},
				{
					"id": 1985,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M368.332 1016.384c-79.454-51.604-140.162-123.618-175.564-208.25-10.668-25.518-10.666-54.77 0-80.268 35.41-84.638 96.118-156.65 175.564-208.252 80.19-52.084 174.132-79.614 271.668-79.614s191.476 27.53 271.664 79.616c16.994 11.038 33.122 23.016 48.336 35.844v-235.46h-288c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h236.478c-4.080-2.482-8.134-5.010-12.146-7.616z",
						"M1020.806 755.65c-29.792-71.224-81.096-131.964-148.36-175.654-68.486-44.484-148.864-67.996-232.446-67.996s-163.96 23.512-232.452 67.996c-67.264 43.69-118.562 104.43-148.36 175.654-3.304 7.9-3.304 16.794 0 24.7 29.792 71.224 81.094 131.964 148.36 175.654 68.492 44.484 148.872 67.996 232.452 67.996 83.582 0 163.958-23.514 232.448-67.996 67.264-43.69 118.566-104.43 148.36-175.654 3.304-7.9 3.304-16.8-0.002-24.7zM640 704c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zM837.588 902.332c-58.086 37.726-126.41 57.668-197.588 57.668s-139.5-19.942-197.586-57.668c-52.472-34.082-93.284-80.328-118.696-134.332 25.412-54.004 66.22-100.25 118.696-134.332 6.51-4.228 13.156-8.218 19.914-12-12.746 25.906-19.914 55.046-19.914 85.872 0 107.582 87.208 194.792 194.792 194.792s194.794-87.21 194.794-194.792c0-32.5-7.97-63.132-22.046-90.074 9.438 4.97 18.66 10.376 27.634 16.208 52.466 34.082 93.28 80.328 118.692 134.332-25.412 53.998-66.222 100.244-118.692 134.326v0 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-eye",
						"file",
						"document",
						"file-preview",
						"page",
						"paper"
					],
					"defaultCode": 59820,
					"grid": 16
				},
				{
					"id": 1590,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429zM731.429 694.857v182.857h-585.143v-109.714l109.714-109.714 73.143 73.143 219.429-219.429zM256 585.143q-45.714 0-77.714-32t-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714-32 77.714-77.714 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-image-o",
						"file-photo-o",
						"file-picture-o"
					],
					"defaultCode": 61893,
					"grid": 14
				},
				{
					"id": 2008,
					"paths": [
						"M917.806 229.076c-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.594-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.882 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0 0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.98 17.78 50.678 41.878 81.374 72.572v0 0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.32 32 32 32h224v624z",
						"M672 576h-32v-160c0-17.672-14.326-32-32-32h-192c-17.672 0-32 14.328-32 32v160h-32c-17.6 0-32 14.4-32 32v256c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32v-256c0-17.6-14.4-32-32-32zM448 448h128v128h-128v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-locked",
						"file",
						"document",
						"file-secure",
						"file-type",
						"file-format"
					],
					"defaultCode": 59843,
					"grid": 16
				},
				{
					"id": 2009,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.040-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.858-13.304-26.924-18.312v232.118z",
						"M448 448h128v128h-128v-128z",
						"M672 320c-17.678 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.882 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM704 864c0 17.6-14.4 32-32 32h-320c-17.6 0-32-14.4-32-32v-256c0-17.6 14.4-32 32-32h32v-160c0-17.672 14.328-32 32-32h192c17.674 0 32 14.328 32 32v160h32c17.6 0 32 14.4 32 32v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-locked",
						"file",
						"document file-secure",
						"file-type",
						"file-format"
					],
					"defaultCode": 59844,
					"grid": 16
				},
				{
					"id": 1976,
					"paths": [
						"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h400c17.674 0 32-14.326 32-32s-14.326-32-32-32h-400c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v224c0 17.674 14.326 32 32 32s32-14.326 32-32v-224c0-14.332-4.372-39.35-42.194-90.924zM704 256v-153.946c22.984 17.78 50.678 41.878 81.374 72.574 30.7 30.7 54.8 58.398 72.58 81.374h-153.954z",
						"M640 768h384v128h-384v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-minus",
						"file",
						"document",
						"file-remove",
						"delete",
						"page",
						"paper"
					],
					"defaultCode": 59811,
					"grid": 16
				},
				{
					"id": 1977,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.036-17-18.312-26.924-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.854-13.304-26.924-18.312v232.118z",
						"M504 800c0-163.214 132.786-296 296-296 58.902 0 113.836 17.298 160 47.076v-231.076h-288c-17.674 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h462.712c-62.864-54.32-102.712-134.594-102.712-224z",
						"M800 576c-123.71 0-224 100.29-224 224s100.29 224 224 224c123.708 0 224-100.29 224-224s-100.29-224-224-224zM640 832v-64h320v64h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-minus",
						"file",
						"document",
						"file-remove",
						"delete",
						"page",
						"paper"
					],
					"defaultCode": 59812,
					"grid": 16
				},
				{
					"id": 1593,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429zM438.857 438.857q29.714 0 51.429 21.714t21.714 51.429v219.429q0 29.714-21.714 51.429t-51.429 21.714h-219.429q-29.714 0-51.429-21.714t-21.714-51.429v-219.429q0-29.714 21.714-51.429t51.429-21.714h219.429zM720 440q11.429 4.571 11.429 17.143v329.143q0 12.571-11.429 17.143-4.571 1.143-6.857 1.143-8 0-13.143-5.143l-151.429-152v-51.429l151.429-152q5.143-5.143 13.143-5.143 2.286 0 6.857 1.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-movie-o",
						"file-video-o"
					],
					"defaultCode": 61896,
					"grid": 14
				},
				{
					"id": 1990,
					"paths": [
						"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z",
						"M756.288 391.252c-7.414-6.080-17.164-8.514-26.562-6.632l-320 64c-14.958 2.994-25.726 16.126-25.726 31.38v236.876c-18.832-8.174-40.678-12.876-64-12.876-70.692 0-128 42.98-128 96s57.308 96 128 96 128-42.98 128-96v-229.766l256-51.202v133.842c-18.832-8.174-40.678-12.876-64-12.876-70.692 0-128 42.98-128 96s57.308 96 128 96 128-42.98 128-96v-319.998c0-9.586-4.298-18.668-11.712-24.748z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-music",
						"file",
						"document",
						"file-song",
						"file-audio"
					],
					"defaultCode": 59825,
					"grid": 16
				},
				{
					"id": 1991,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM768 800c0 53.020-57.308 96-128 96s-128-42.98-128-96 57.308-96 128-96c23.322 0 45.168 4.702 64 12.876v-133.842l-256 51.202v229.764c0 53.020-57.308 96-128 96s-128-42.98-128-96 57.308-96 128-96c23.322 0 45.168 4.702 64 12.876v-236.876c0-15.254 10.766-28.386 25.724-31.378l320-64c9.398-1.882 19.148 0.552 26.562 6.632 7.414 6.078 11.712 15.16 11.712 24.748v319.998z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-music",
						"file",
						"document",
						"file-song",
						"file-audio"
					],
					"defaultCode": 59826,
					"grid": 16
				},
				{
					"id": 1200,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-o"
					],
					"defaultCode": 61462,
					"grid": 14
				},
				{
					"id": 3412,
					"paths": [
						"M690.22 471.682c-60.668-28.652-137.97-34.42-194.834 6.048 69.14-6.604 144.958 4.838 195.106 57.124 48-55.080 124.116-65.406 192.958-59.732-57.488-38.144-133.22-33.024-193.23-3.44v0zM665.646 605.75c-68.376-1.578-134.434 23.172-191.1 60.104-107.176-45.588-242.736-37.124-334.002 38.982 26.33-0.934 52.006-7.446 78.056-10.792 95.182-9.488 196.588 14.142 268.512 79.824 29.772-43.542 71.644-78.242 119.652-99.922 63.074-30.52 134.16-33.684 202.82-34.52-41.688-28.648-94.614-33.954-143.938-33.676z",
						"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-openoffice",
						"file",
						"file-format"
					],
					"defaultCode": 61247,
					"grid": 16
				},
				{
					"id": 3411,
					"paths": [
						"M842.012 589.48c-13.648-13.446-43.914-20.566-89.972-21.172-31.178-0.344-68.702 2.402-108.17 7.928-17.674-10.198-35.892-21.294-50.188-34.658-38.462-35.916-70.568-85.772-90.576-140.594 1.304-5.12 2.414-9.62 3.448-14.212 0 0 21.666-123.060 15.932-164.666-0.792-5.706-1.276-7.362-2.808-11.796l-1.882-4.834c-5.894-13.592-17.448-27.994-35.564-27.208l-10.916-0.344c-20.202 0-36.664 10.332-40.986 25.774-13.138 48.434 0.418 120.892 24.98 214.738l-6.288 15.286c-17.588 42.876-39.63 86.060-59.078 124.158l-2.528 4.954c-20.46 40.040-39.026 74.028-55.856 102.822l-17.376 9.188c-1.264 0.668-31.044 16.418-38.028 20.644-59.256 35.38-98.524 75.542-105.038 107.416-2.072 10.17-0.53 23.186 10.014 29.212l16.806 8.458c7.292 3.652 14.978 5.502 22.854 5.502 42.206 0 91.202-52.572 158.698-170.366 77.93-25.37 166.652-46.458 244.412-58.090 59.258 33.368 132.142 56.544 178.142 56.544 8.168 0 15.212-0.78 20.932-2.294 8.822-2.336 16.258-7.368 20.792-14.194 8.926-13.432 10.734-31.932 8.312-50.876-0.72-5.622-5.21-12.574-10.068-17.32zM211.646 814.048c7.698-21.042 38.16-62.644 83.206-99.556 2.832-2.296 9.808-8.832 16.194-14.902-47.104 75.124-78.648 105.066-99.4 114.458zM478.434 199.686c13.566 0 21.284 34.194 21.924 66.254s-6.858 54.56-16.158 71.208c-7.702-24.648-11.426-63.5-11.426-88.904 0 0-0.566-48.558 5.66-48.558v0zM398.852 637.494c9.45-16.916 19.282-34.756 29.33-53.678 24.492-46.316 39.958-82.556 51.478-112.346 22.91 41.684 51.444 77.12 84.984 105.512 4.186 3.542 8.62 7.102 13.276 10.65-68.21 13.496-127.164 29.91-179.068 49.862v0zM828.902 633.652c-4.152 2.598-16.052 4.1-23.708 4.1-24.708 0-55.272-11.294-98.126-29.666 16.468-1.218 31.562-1.838 45.102-1.838 24.782 0 32.12-0.108 56.35 6.072 24.228 6.18 24.538 18.734 20.382 21.332v0z",
						"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-pdf",
						"file",
						"file-format"
					],
					"defaultCode": 61246,
					"grid": 16
				},
				{
					"id": 1586,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429zM510.857 612q18.857 14.857 48 32 33.714-4 66.857-4 84 0 101.143 28 9.143 12.571 1.143 29.714 0 0.571-0.571 1.143l-1.143 1.143v0.571q-3.429 21.714-40.571 21.714-27.429 0-65.714-11.429t-74.286-30.286q-126.286 13.714-224 47.429-87.429 149.714-138.286 149.714-8.571 0-16-4l-13.714-6.857q-0.571-0.571-3.429-2.857-5.714-5.714-3.429-20.571 5.143-22.857 32-52.286t75.429-55.143q8-5.143 13.143 3.429 1.143 1.143 1.143 2.286 29.714-48.571 61.143-112.571 38.857-77.714 59.429-149.714-13.714-46.857-17.429-91.143t3.714-72.857q6.286-22.857 24-22.857h12.571q13.143 0 20 8.571 10.286 12 5.143 38.857-1.143 3.429-2.286 4.571 0.571 1.714 0.571 4.571v17.143q-1.143 70.286-8 109.714 31.429 93.714 83.429 136zM181.714 846.857q29.714-13.714 78.286-90.286-29.143 22.857-50 48t-28.286 42.286zM409.143 321.143q-8.571 24-1.143 75.429 0.571-4 4-25.143 0-1.714 4-24.571 0.571-2.286 2.286-4.571-0.571-0.571-0.571-1.143t-0.286-0.857-0.286-0.857q-0.571-12.571-7.429-20.571 0 0.571-0.571 1.143v1.143zM338.286 698.857q77.143-30.857 162.286-46.286-1.143-0.571-7.429-5.429t-9.143-7.714q-43.429-38.286-72.571-100.571-15.429 49.143-47.429 112.571-17.143 32-25.714 47.429zM707.429 689.714q-13.714-13.714-80-13.714 43.429 16 70.857 16 8 0 10.286-0.571 0-0.571-1.143-1.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-pdf-o"
					],
					"defaultCode": 61889,
					"grid": 14
				},
				{
					"id": 1988,
					"paths": [
						"M832 896h-640v-128l192-320 263 320 185-128v256z",
						"M832 480c0 53.020-42.98 96-96 96-53.022 0-96-42.98-96-96s42.978-96 96-96c53.020 0 96 42.98 96 96z",
						"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.984 17.78 50.678 41.878 81.374 72.572zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-picture",
						"file",
						"document",
						"file-image"
					],
					"defaultCode": 59823,
					"grid": 16
				},
				{
					"id": 1989,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM832 896h-640v-128l192-320 263 320 185-128v256zM736 576c-53.024 0-96-42.98-96-96s42.976-96 96-96c53.020 0 96 42.98 96 96s-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-picture",
						"file",
						"document",
						"file-image"
					],
					"defaultCode": 59824,
					"grid": 16
				},
				{
					"id": 1992,
					"paths": [
						"M384 384l320 224-320 224v-448z",
						"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.984 17.78 50.678 41.878 81.374 72.572zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-play",
						"file",
						"document",
						"file-media",
						"file-video"
					],
					"defaultCode": 59827,
					"grid": 16
				},
				{
					"id": 1993,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM384 832v-448l320 224-320 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-play",
						"file",
						"document",
						"file-media",
						"file-video"
					],
					"defaultCode": 59828,
					"grid": 16
				},
				{
					"id": 1974,
					"paths": [
						"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h400c17.674 0 32-14.326 32-32s-14.326-32-32-32h-400c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v224c0 17.674 14.326 32 32 32s32-14.326 32-32v-224c0-14.332-4.372-39.35-42.194-90.924zM704 256v-153.946c22.984 17.78 50.678 41.878 81.374 72.574 30.7 30.7 54.8 58.398 72.58 81.374h-153.954z",
						"M1024 768h-128v-128h-128v128h-128v128h128v128h128v-128h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-plus",
						"file",
						"document",
						"file-add",
						"new",
						"page",
						"paper"
					],
					"defaultCode": 59809,
					"grid": 16
				},
				{
					"id": 1975,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.036-17-18.312-26.924-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.854-13.304-26.924-18.312v232.118z",
						"M504 800c0-163.214 132.786-296 296-296 58.902 0 113.836 17.298 160 47.076v-231.076h-288c-17.674 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h462.712c-62.864-54.32-102.712-134.594-102.712-224z",
						"M800 576c-123.71 0-224 100.29-224 224s100.29 224 224 224c123.708 0 224-100.29 224-224s-100.29-224-224-224zM832 832v128h-64v-128h-128v-64h128v-128h64v128h128v64h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-plus",
						"file",
						"document",
						"file-add",
						"new",
						"page",
						"paper"
					],
					"defaultCode": 59810,
					"grid": 16
				},
				{
					"id": 1589,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429zM237.714 817.143v60.571h186.857v-60.571h-53.143v-95.429h78.286q43.429 0 67.429-8.571 38.286-13.143 60.857-49.714t22.571-83.429q0-46.286-21.143-80.571t-57.143-49.714q-27.429-10.857-74.286-10.857h-210.286v61.143h52.571v317.143h-52.571zM439.429 657.143h-68v-153.143h68.571q29.714 0 47.429 10.286 32 18.857 32 65.714 0 50.857-35.429 68.571-17.714 8.571-44.571 8.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-powerpoint-o"
					],
					"defaultCode": 61892,
					"grid": 14
				},
				{
					"id": 2004,
					"paths": [
						"M192 512h192v64h-192v-64zM192 640h192v64h-192v-64zM192 768h192v64h-192v-64zM576 704h188.792c-14.826 73.032-79.386 128-156.792 128-88.368 0-160-71.632-160-160 0-77.406 54.968-141.964 128-156.792v188.792zM672 448c88.366 0 160 71.632 160 160 0 10.958-1.11 21.66-3.208 32h-188.792v-188.792c10.34-2.1 21.042-3.208 32-3.208z",
						"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-presentation",
						"file",
						"document",
						"file-charts",
						"file-powerpoint",
						"file-type",
						"file-format"
					],
					"defaultCode": 59839,
					"grid": 16
				},
				{
					"id": 2005,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM384 896h-192v-64h192v64zM384 768h-192v-64h192v64zM384 640h-192v-64h192v64zM608 896c-88.37 0-160-71.632-160-160 0-77.406 54.966-141.964 128-156.792v188.792h188.792c-14.826 73.032-79.388 128-156.792 128zM828.792 704h-188.792v-188.792c10.34-2.098 21.042-3.208 32-3.208 88.366 0 160 71.632 160 160 0 10.958-1.11 21.66-3.208 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-presentation",
						"file",
						"document",
						"file-charts",
						"file-powerpoint",
						"file-type",
						"file-format"
					],
					"defaultCode": 59840,
					"grid": 16
				},
				{
					"id": 2010,
					"paths": [
						"M917.806 229.076c-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0 0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.98 17.78 50.678 41.878 81.374 72.572v0 0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.322 32 32 32h224v624z",
						"M192 448v448h640v-448h-640zM384 832h-128v-128h128v128zM384 640h-128v-128h128v128zM576 832h-128v-128h128v128zM576 640h-128v-128h128v128zM768 832h-128v-128h128v128zM768 640h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-spreadsheet",
						"file",
						"document",
						"file-excel",
						"file-type",
						"file-format"
					],
					"defaultCode": 59845,
					"grid": 16
				},
				{
					"id": 2011,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M448 704h128v128h-128v-128z",
						"M640 704h128v128h-128v-128z",
						"M640 512h128v128h-128v-128z",
						"M448 512h128v128h-128v-128z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM832 896h-640v-448h640v448z",
						"M256 512h128v128h-128v-128z",
						"M256 704h128v128h-128v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-spreadsheet",
						"file",
						"document",
						"file-excel",
						"file-type",
						"file-format"
					],
					"defaultCode": 59846,
					"grid": 16
				},
				{
					"id": 2006,
					"paths": [
						"M917.806 229.076c-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0 0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.98 17.78 50.678 41.878 81.374 72.572v0 0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.322 32 32 32h224v624z",
						"M256 320h128v576h-128v-576z",
						"M448 576h128v320h-128v-320z",
						"M640 704h128v192h-128v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-stats",
						"file",
						"document",
						"file-chart",
						"file-bars",
						"file-type",
						"file-format"
					],
					"defaultCode": 59841,
					"grid": 16
				},
				{
					"id": 2007,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.040-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.858-13.304-26.924-18.312v232.118z",
						"M672 320c-17.678 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.882 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM384 896h-128v-576h128v576zM576 896h-128v-320h128v320zM768 896h-128v-192h128v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-stats",
						"file",
						"document",
						"file-chart",
						"file-bars",
						"file-type",
						"file-format"
					],
					"defaultCode": 59842,
					"grid": 16
				},
				{
					"id": 1968,
					"paths": [
						"M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 448h448v64h-448zM256 576h448v64h-448zM256 704h448v64h-448zM256 320h448v64h-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-text",
						"file",
						"document",
						"list",
						"paper"
					],
					"defaultCode": 59803,
					"grid": 16
				},
				{
					"id": 1398,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429zM219.429 457.143q0-8 5.143-13.143t13.143-5.143h402.286q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-402.286q-8 0-13.143-5.143t-5.143-13.143v-36.571zM640 585.143q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-402.286q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h402.286zM640 731.429q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-402.286q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h402.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-text-o"
					],
					"defaultCode": 61686,
					"grid": 14
				},
				{
					"id": 1986,
					"paths": [
						"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.984 17.78 50.678 41.878 81.374 72.572zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v624z",
						"M736 832h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
						"M736 704h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
						"M736 576h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-text",
						"file",
						"document",
						"list",
						"paper",
						"page"
					],
					"defaultCode": 59821,
					"grid": 16
				},
				{
					"id": 1987,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM736 832h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32zM736 704h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32zM736 576h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-text",
						"file",
						"document",
						"list",
						"paper",
						"page"
					],
					"defaultCode": 59822,
					"grid": 16
				},
				{
					"id": 1492,
					"width": 877.713981628418,
					"paths": [
						"M838.857 272q8 8 16 20.571h-269.714v-269.714q12.571 8 20.571 16zM566.857 365.714h310.857v603.429q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h457.143v310.857q0 22.857 16 38.857t38.857 16zM658.286 786.286v-36.571q0-8-5.143-13.143t-13.143-5.143h-402.286q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h402.286q8 0 13.143-5.143t5.143-13.143zM658.286 640v-36.571q0-8-5.143-13.143t-13.143-5.143h-402.286q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h402.286q8 0 13.143-5.143t5.143-13.143zM658.286 493.714v-36.571q0-8-5.143-13.143t-13.143-5.143h-402.286q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h402.286q8 0 13.143-5.143t5.143-13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-text"
					],
					"defaultCode": 61788,
					"grid": 14
				},
				{
					"id": 1980,
					"paths": [
						"M853.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-432c-44.112 0-80 35.888-80 80v240l32 704 32-704v-240c0-8.672 7.328-16 16-16 0 0 431.956-0.002 432 0v224c0 17.672 14.324 32 32 32h224l32 704 32-704c0-14.332-4.372-39.35-42.194-90.924zM640 256v-153.946c22.982 17.78 50.678 41.878 81.374 72.572 30.7 30.7 54.8 58.398 72.58 81.374h-153.954z",
						"M384 1024h192v-320h160l-256-256-256 256h160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-upload",
						"file",
						"document",
						"page",
						"paper"
					],
					"defaultCode": 59815,
					"grid": 16
				},
				{
					"id": 1981,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.036-17-18.312-26.924-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.854-13.304-26.924-18.312v232.118z",
						"M672 320c-17.674 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM512 416l224 224h-160v320h-128v-320h-160l224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-upload",
						"file",
						"document",
						"page",
						"paper"
					],
					"defaultCode": 59816,
					"grid": 16
				},
				{
					"id": 1994,
					"paths": [
						"M917.806 229.076c-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.594-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.882 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0 0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.98 17.78 50.678 41.878 81.374 72.572v0 0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.32 32 32 32h224v624z",
						"M256 512h320v320h-320v-320z",
						"M576 640l192-128v320l-192-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-video",
						"file",
						"document",
						"file-camera"
					],
					"defaultCode": 59829,
					"grid": 16
				},
				{
					"id": 1995,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM768 896l-192-128v128h-320v-320h320v128l192-128v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-video",
						"file",
						"document",
						"file-camera"
					],
					"defaultCode": 59830,
					"grid": 16
				},
				{
					"id": 3413,
					"paths": [
						"M639.778 475.892h44.21l-51.012 226.178-66.324-318.010h-106.55l-77.114 318.010-57.816-318.010h-111.394l113.092 511.88h108.838l76.294-302.708 68.256 302.708h100.336l129.628-511.88h-170.446v91.832z",
						"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-word",
						"file",
						"file-format",
						"word",
						"docx"
					],
					"defaultCode": 61248,
					"grid": 16
				},
				{
					"id": 1587,
					"width": 877.7160568237305,
					"paths": [
						"M838.857 217.143q16 16 27.429 43.429t11.429 50.286v658.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-914.286q0-22.857 16-38.857t38.857-16h512q22.857 0 50.286 11.429t43.429 27.429zM585.143 77.714v214.857h214.857q-5.714-16.571-12.571-23.429l-178.857-178.857q-6.857-6.857-23.429-12.571zM804.571 950.857v-585.143h-237.714q-22.857 0-38.857-16t-16-38.857v-237.714h-438.857v877.714h731.429zM133.143 438.857v61.143h40l93.714 377.714h90.857l73.143-277.143q4-11.429 5.714-26.286 1.143-9.143 1.143-13.714h2.286l1.714 13.714q0.571 1.714 2 11.429t3.143 14.857l73.143 277.143h90.857l93.714-377.714h40v-61.143h-171.429v61.143h51.429l-56.571 250.286q-2.857 11.429-4 26.286l-1.143 12h-2.286l-1.714-12q-0.571-2.857-2.286-12t-2.857-14.286l-82.286-311.429h-65.143l-82.286 311.429q-1.143 5.143-2.571 14t-2 12.286l-2.286 12h-2.286l-1.143-12q-1.143-14.857-4-26.286l-56.571-250.286h51.429v-61.143h-171.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-word-o"
					],
					"defaultCode": 61890,
					"grid": 14
				},
				{
					"id": 2000,
					"paths": [
						"M480 576l-64-64-192 192 192 192 64-64-128-128 128-128z",
						"M544 832l64 64 192-192-192-192-64 64 128 128-128 128z",
						"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-xml",
						"file",
						"document",
						"file-code",
						"file-type",
						"file-format"
					],
					"defaultCode": 59835,
					"grid": 16
				},
				{
					"id": 2001,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM480 832l-64 64-192-192 192-192 64 64-128 128 128 128zM608 896l-64-64 128-128-128-128 64-64 192 192-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-xml",
						"file",
						"document",
						"file-code",
						"file-type",
						"file-format"
					],
					"defaultCode": 59836,
					"grid": 16
				},
				{
					"id": 1998,
					"paths": [
						"M917.806 229.076c-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0 0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.98 17.78 50.678 41.878 81.374 72.572v0 0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.322 32 32 32h224v624z",
						"M256 64h128v64h-128v-64z",
						"M384 128h128v64h-128v-64z",
						"M256 192h128v64h-128v-64z",
						"M384 256h128v64h-128v-64z",
						"M256 320h128v64h-128v-64z",
						"M384 384h128v64h-128v-64z",
						"M256 448h128v64h-128v-64z",
						"M384 512h128v64h-128v-64z",
						"M256 848c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-80v-64h-128v272zM448 768v64h-128v-64h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-zip",
						"file",
						"document",
						"file-compressed",
						"file-type",
						"file-format"
					],
					"defaultCode": 59833,
					"grid": 16
				},
				{
					"id": 1999,
					"paths": [
						"M704 256h232.118c-5.008-8.070-11.038-17-18.312-26.924-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.856-13.304-26.924-18.312v232.118z",
						"M672 320c-17.676 0-32-14.328-32-32v-288h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624h-288zM448 192h-128v64h128v64h-128v64h128v64h-128v64h128v64h-128v64h80c26.4 0 48 21.6 48 48v160c0 26.4-21.6 48-48 48h-160c-26.4 0-48-21.6-48-48v-272h128v-64h-128v-64h128v-64h-128v-64h128v-64h-128v-64h128v-64h-128v-64h128v64h128v64z",
						"M256 768h128v64h-128v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"file-zip",
						"file",
						"document",
						"file-compressed",
						"file-type",
						"file-format"
					],
					"defaultCode": 59834,
					"grid": 16
				},
				{
					"id": 1972,
					"paths": [
						"M917.806 357.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-368c-44.114 0-80 35.888-80 80v736c0 44.112 35.886 80 80 80h608c44.112 0 80-35.888 80-80v-496c0-14.332-4.372-39.35-42.194-90.924zM785.374 302.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-608c-8.672 0-16-7.328-16-16v-736c0-8.672 7.328-16 16-16 0 0 367.956-0.002 368 0v224c0 17.672 14.324 32 32 32h224v496z",
						"M602.924 42.196c-51.574-37.822-76.592-42.196-90.924-42.196h-368c-44.112 0-80 35.888-80 80v736c0 38.632 27.528 70.958 64 78.39v-814.39c0-8.672 7.328-16 16-16h486.876c-9.646-7.92-19.028-15.26-27.952-21.804z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"files-empty",
						"files",
						"documents",
						"papers",
						"pages"
					],
					"defaultCode": 59807,
					"grid": 16
				},
				{
					"id": 1973,
					"paths": [
						"M602.924 42.196c-51.574-37.822-76.592-42.196-90.924-42.196h-368c-44.112 0-80 35.888-80 80v736c0 38.632 27.528 70.958 64 78.39v-814.39c0-8.672 7.328-16 16-16h486.876c-9.646-7.92-19.028-15.26-27.952-21.804z",
						"M704 384h232.118c-5.008-8.070-11.036-17-18.312-26.924-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-9.924-7.276-18.854-13.304-26.924-18.312v232.118z",
						"M640 416v-288h-368c-44.114 0-80 35.888-80 80v736c0 44.112 35.886 80 80 80h608c44.112 0 80-35.888 80-80v-496h-288c-17.674 0-32-14.328-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"files-empty",
						"files",
						"documents",
						"papers",
						"pages"
					],
					"defaultCode": 59808,
					"grid": 16
				},
				{
					"id": 499,
					"width": 1024,
					"paths": [
						"M924.128 508.128l-252.128-252.128v-90.304c0-66.816-48.736-126.592-115.232-133.056-76.32-7.424-140.768 52.576-140.768 127.36v96l-32 32h-112c-114.88 0-208 93.12-208 208v396.384c0 31.904 21.696 61.536 53.152 66.72 40.064 6.624 74.848-24.256 74.848-63.104v-352l348.128 348.128c37.504 37.504 98.272 37.504 135.776 0l248.224-248.224c37.472-37.504 37.472-98.304 0-135.776zM448 160c0-59.2 53.856-106.048 115.136-94.144 45.568 8.864 76.864 51.52 76.864 97.92v60.224l-28.128-28.128c-37.504-37.504-98.272-37.504-135.776 0l-28.096 28.128v-64zM432 512c8.832 0 16-7.168 16-16v-45.056c18.592 6.624 32 24.224 32 45.056 0 26.464-21.536 48-48 48s-48-21.536-48-48c0-20.832 13.408-38.432 32-45.056v45.056c0 8.832 7.168 16 16 16zM160 512v384c0 17.632-14.336 32-32 32s-32-14.368-32-32v-400c0-97.056 78.976-176 176-176h80l-192 192zM901.504 621.248l-248.224 248.224c-24.992 24.992-65.504 24.992-90.496 0l-357.536-357.472 210.752-210.752v116.352c-44.032 8.928-74.912 53.984-60.352 102.912 7.52 25.248 28.512 45.536 53.952 52.448 53.792 14.624 102.4-25.504 102.4-76.96 0-38.688-27.488-70.976-64-78.4v-148.352l50.752-50.752c24.992-24.992 65.504-24.992 90.496 0l312.224 312.224c25.024 25.024 25.024 65.536 0.032 90.528z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fill",
						"paint",
						"spill"
					],
					"grid": 32
				},
				{
					"id": 500,
					"width": 1024,
					"paths": [
						"M338.976 288l-118.848 118.848c-18.144 18.144-28.128 42.24-28.128 67.872v421.28c0 38.848-34.784 69.728-74.848 63.104-31.456-5.184-53.152-34.816-53.152-66.72v-396.384c0-114.88 93.12-208 208-208h66.976zM924.128 508.128l-252.128-252.128v-90.304c0-66.816-48.736-126.592-115.232-133.056-76.32-7.424-140.768 52.576-140.768 127.36v336c0 8.832 7.168 16 16 16s16-7.168 16-16v-336c0-59.2 53.856-106.048 115.136-94.144 45.568 8.864 76.864 51.52 76.864 97.92v60.224l-28.128-28.128c-36.256-36.288-94.176-37.12-131.872-3.168v303.296c0 26.464-21.536 48-48 48s-48-21.536-48-48v-207.776l-141.248 141.248c-12.096 12.096-18.752 28.16-18.752 45.248v101.28l316.128 316.128c37.504 37.504 98.272 37.504 135.776 0l248.224-248.224c37.472-37.504 37.472-98.304 0-135.776z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fill",
						"paint",
						"spill"
					],
					"grid": 32
				},
				{
					"id": 1024,
					"width": 1024,
					"paths": [
						"M832 320h-32v-32c0-159.072-128.928-288-288-288s-288 128.928-288 288v32h-32c-17.664 0-32 14.336-32 32v640c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-640c0-17.664-14.336-32-32-32zM288 288c0-123.52 100.48-224 224-224s224 100.48 224 224v64h-448v-64zM512 384h64v192c0 17.632-14.368 32-32 32s-32-14.368-32-32v-192zM288 384h128v224c0 35.296-28.704 64-64 64s-64-28.704-64-64v-224zM800 960h-576v-576h32v224c0 53.024 42.976 96 96 96s96-42.976 96-96v-224h32v192c0 35.36 28.64 64 64 64s64-28.64 64-64v-192h192v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fill",
						"paint"
					],
					"grid": 32
				},
				{
					"id": 1907,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM640 64h128v128h-128v-128zM448 64h128v128h-128v-128zM256 64h128v128h-128v-128zM64 64h128v128h-128v-128zM64 256h384v512h-384v-512zM192 960h-128v-128h128v128zM384 960h-128v-128h128v128zM576 960h-128v-128h128v128zM768 960h-128v-128h128v128zM960 960h-128v-128h128v128zM960 768h-448v-512h448v512zM960 192h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"film",
						"video",
						"movie",
						"tape"
					],
					"defaultCode": 59742,
					"grid": 16
				},
				{
					"id": 131,
					"paths": [
						"M383.997 768c-3.902 0-7.822-0.891-11.445-2.702-8.674-4.336-14.152-13.2-14.152-22.898v-460.8c0-9.698 5.478-18.562 14.152-22.898 8.67-4.334 19.051-3.4 26.808 2.418l307.2 230.4c6.446 4.834 10.24 12.422 10.24 20.48s-3.794 15.645-10.24 20.48l-307.2 230.4c-4.517 3.387-9.923 5.12-15.363 5.12zM409.6 332.8v358.4l238.933-179.2-238.933-179.2z",
						"M998.4 102.4h-972.8c-14.138 0-25.6 11.462-25.6 25.6v768c0 14.139 11.462 25.6 25.6 25.6h972.8c14.139 0 25.6-11.461 25.6-25.6v-768c0-14.138-11.461-25.6-25.6-25.6zM153.6 563.2h-102.4v-102.4h102.4v102.4zM153.6 409.6h-102.4v-102.4h102.4v102.4zM51.2 614.4h102.4v102.4h-102.4v-102.4zM204.8 153.6h614.4v716.8h-614.4v-716.8zM870.4 460.8h102.4v102.4h-102.4v-102.4zM870.4 409.6v-102.4h102.4v102.4h-102.4zM870.4 614.4h102.4v102.4h-102.4v-102.4zM972.8 256h-102.4v-102.4h102.4v102.4zM153.6 153.6v102.4h-102.4v-102.4h102.4zM51.2 768h102.4v102.4h-102.4v-102.4zM870.4 870.4v-102.4h102.4v102.4h-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"film-play",
						"video",
						"movie"
					],
					"defaultCode": 59428,
					"grid": 20
				},
				{
					"id": 1908,
					"paths": [
						"M0 64v896h1024v-896h-1024zM192 896h-128v-128h128v128zM192 704h-128v-128h128v128zM192 448h-128v-128h128v128zM192 256h-128v-128h128v128zM768 896h-512v-320h512v320zM768 448h-512v-320h512v320zM960 896h-128v-128h128v128zM960 704h-128v-128h128v128zM960 448h-128v-128h128v128zM960 256h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"film",
						"video",
						"movie",
						"tape"
					],
					"defaultCode": 59743,
					"grid": 16
				},
				{
					"id": 1909,
					"paths": [
						"M0 128v768h1024v-768h-1024zM192 832h-128v-128h128v128zM192 576h-128v-128h128v128zM192 320h-128v-128h128v128zM768 832h-512v-640h512v640zM960 832h-128v-128h128v128zM960 576h-128v-128h128v128zM960 320h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"film",
						"video",
						"movie",
						"tape"
					],
					"defaultCode": 59744,
					"grid": 16
				},
				{
					"id": 1910,
					"paths": [
						"M0 128v768h1024v-768h-1024zM192 832h-128v-128h128v128zM192 576h-128v-128h128v128zM192 320h-128v-128h128v128zM768 832h-512v-640h512v640zM960 832h-128v-128h128v128zM960 576h-128v-128h128v128zM960 320h-128v-128h128v128zM384 320v384l256-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"film",
						"video",
						"movie",
						"tape",
						"play"
					],
					"defaultCode": 59745,
					"grid": 16
				},
				{
					"id": 1187,
					"width": 1097.1438789367676,
					"paths": [
						"M219.429 914.286v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714zM219.429 694.857v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714zM219.429 475.429v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714zM804.571 914.286v-292.571q0-14.857-10.857-25.714t-25.714-10.857h-438.857q-14.857 0-25.714 10.857t-10.857 25.714v292.571q0 14.857 10.857 25.714t25.714 10.857h438.857q14.857 0 25.714-10.857t10.857-25.714zM219.429 256v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714zM1024 914.286v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714zM804.571 475.429v-292.571q0-14.857-10.857-25.714t-25.714-10.857h-438.857q-14.857 0-25.714 10.857t-10.857 25.714v292.571q0 14.857 10.857 25.714t25.714 10.857h438.857q14.857 0 25.714-10.857t10.857-25.714zM1024 694.857v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714zM1024 475.429v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714zM1024 256v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714zM1097.143 164.571v768q0 37.714-26.857 64.571t-64.571 26.857h-914.286q-37.714 0-64.571-26.857t-26.857-64.571v-768q0-37.714 26.857-64.571t64.571-26.857h914.286q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"film"
					],
					"defaultCode": 61448,
					"grid": 14
				},
				{
					"id": 501,
					"width": 1024,
					"paths": [
						"M800 32h-576c-53.024 0-96 42.976-96 96v768c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-768c0-53.024-42.976-96-96-96zM704 64v192h-384v-192h384zM320 960v-192h384v192h-384zM864 896c0 35.296-28.704 64-64 64h-64v-192c0-17.664-14.336-32-32-32h-384c-17.664 0-32 14.336-32 32v192h-64c-35.296 0-64-28.704-64-64v-768c0-35.296 28.704-64 64-64h64v192c0 17.664 14.336 32 32 32h384c17.664 0 32-14.336 32-32v-192h64c35.296 0 64 28.704 64 64v768zM256 128c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM256 256c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM256 384c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM256 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM256 640c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM256 768c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM256 896c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM832 128c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM832 256c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM832 384c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM832 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM832 640c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM832 768c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM832 896c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM704 320h-384c-17.664 0-32 14.336-32 32v320c0 17.664 14.336 32 32 32h384c17.664 0 32-14.336 32-32v-320c0-17.664-14.336-32-32-32zM704 672h-384v-320h384v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"film",
						"photograph",
						"record",
						"capture",
						"develop"
					],
					"grid": 32
				},
				{
					"id": 502,
					"width": 1024,
					"paths": [
						"M320 800h384v192h-384v-192zM704 32h-384v192h384v-192zM320 672h384v-320h-384v320zM896 128v768c0 53.024-42.976 96-96 96h-64v-192c0-17.664-14.336-32-32-32h-384c-17.664 0-32 14.336-32 32v192h-64c-53.024 0-96-42.976-96-96v-768c0-53.024 42.976-96 96-96h64v192c0 17.664 14.336 32 32 32h384c17.664 0 32-14.336 32-32v-192h64c53.024 0 96 42.976 96 96zM256 896c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM256 768c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM256 640c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM256 512c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM256 384c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM256 256c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM256 128c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM736 352c0-17.664-14.336-32-32-32h-384c-17.664 0-32 14.336-32 32v320c0 17.664 14.336 32 32 32h384c17.664 0 32-14.336 32-32v-320zM832 896c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM832 768c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM832 640c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM832 512c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM832 384c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM832 256c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM832 128c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"film",
						"photograph",
						"record",
						"capture",
						"develop"
					],
					"grid": 32
				},
				{
					"id": 3230,
					"paths": [
						"M512 0c-282.77 0-512 71.634-512 160v96l384 384v320c0 35.346 57.306 64 128 64 70.692 0 128-28.654 128-64v-320l384-384v-96c0-88.366-229.23-160-512-160zM94.384 138.824c23.944-13.658 57.582-26.62 97.278-37.488 87.944-24.076 201.708-37.336 320.338-37.336 118.628 0 232.394 13.26 320.338 37.336 39.696 10.868 73.334 23.83 97.28 37.488 15.792 9.006 24.324 16.624 28.296 21.176-3.972 4.552-12.506 12.168-28.296 21.176-23.946 13.658-57.584 26.62-97.28 37.488-87.942 24.076-201.708 37.336-320.338 37.336s-232.394-13.26-320.338-37.336c-39.696-10.868-73.334-23.83-97.278-37.488-15.792-9.008-24.324-16.624-28.298-21.176 3.974-4.552 12.506-12.168 28.298-21.176z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"filter",
						"funnel"
					],
					"defaultCode": 61065,
					"grid": 16
				},
				{
					"id": 3231,
					"paths": [
						"M1024 224c0-123.712-229.23-224-512-224s-512 100.288-512 224c0 39.376 23.252 76.37 64.032 108.522h-0.032l320 292.484v334.994c0 35.346 57.308 64 128 64 70.696 0 128-28.654 128-64v-334.994l319.968-292.484c40.78-32.152 64.032-69.146 64.032-108.522zM920.344 284.264l-344.344 312.532v350.21c-10.176 5.612-32.304 12.988-64 12.988s-53.824-7.376-64-12.988v-350.21l-344.344-312.532c-14.81-11.678-39.656-36.774-39.656-60.264 0-13.068 7.486-27.436 22.248-42.708 19.678-20.354 50.58-40.082 89.366-57.050 42.54-18.61 92.582-35.316 148.738-45.708 59.29-10.97 122.424-18.534 187.648-18.534 65.222 0 128.358 7.564 187.648 18.534 56.156 10.392 106.2 27.098 148.738 45.708 38.786 16.968 69.688 36.696 89.366 57.050 14.762 15.272 22.248 29.64 22.248 42.708 0 23.49-24.846 48.586-39.656 60.264zM192 232.5c0-48.325 143.269-87.5 320-87.5s320 39.175 320 87.5c0 48.325-143.269 87.5-320 87.5s-320-39.175-320-87.5z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"filter",
						"funnel"
					],
					"defaultCode": 61066,
					"grid": 16
				},
				{
					"id": 3232,
					"paths": [
						"M0 128l384 384v384l256-64v-320l384-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"filter",
						"funnel"
					],
					"defaultCode": 61067,
					"grid": 16
				},
				{
					"id": 3233,
					"paths": [
						"M869.49 192l-293.49 293.49v296.542l-128 32v-328.542l-293.49-293.49h714.98zM1024 128h-1024l384 384v384l256-64v-320l384-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"filter",
						"funnel"
					],
					"defaultCode": 61068,
					"grid": 16
				},
				{
					"id": 1344,
					"width": 804.5709609985352,
					"paths": [
						"M801.714 168.571q9.714 23.429-8 40l-281.714 281.714v424q0 24-22.286 33.714-7.429 2.857-14.286 2.857-15.429 0-25.714-10.857l-146.286-146.286q-10.857-10.857-10.857-25.714v-277.714l-281.714-281.714q-17.714-16.571-8-40 9.714-22.286 33.714-22.286h731.429q24 0 33.714 22.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"filter"
					],
					"defaultCode": 61616,
					"grid": 14
				},
				{
					"id": 1025,
					"width": 1024,
					"paths": [
						"M160 224h32v32h-32v-32zM224 256h32v-32h-32v32zM992 576v160c0 17.664-14.336 32-32 32s-32-14.336-32-32v-160c0-17.632-14.368-32-32-32h-21.632c24.384 94.24 26.848 192.864 7.392 288h46.24c17.664 0 32 14.336 32 32v96c0 17.664-14.336 32-32 32h-864c-17.664 0-32-14.336-32-32v-96c0-17.664 14.336-32 32-32v-448c-17.664 0-32-14.336-32-32v-288c0-17.664 14.336-32 32-32h864c17.664 0 32 14.336 32 32v288c0 17.664-14.336 32-32 32h-132.224l-33.152 49.76c-5.92 8.896-15.936 14.24-26.624 14.24h-128c-10.688 0-20.704-5.344-26.624-14.24l-33.152-49.76h-196.224v448h110.208c-13.248-64.512-16.352-130.24-9.28-196.064l-78.528-104.736c-7.264-9.696-8.448-22.656-3.008-33.504 5.408-10.848 16.48-17.696 28.608-17.696h496c52.928 0 96 43.072 96 96zM896 896h-608v-544h-160v544h-32v32h800v-32zM718.88 384l21.344-32h-136.416l21.344 32h93.728zM535.552 864h272.864c20.96-72.736 26.944-149.152 18.656-224h-310.144c-8.32 75.040-2.336 151.456 18.624 224zM808.448 544h-272.864c-6.080 21.056-10.56 42.464-14.176 64h301.248c-3.616-21.568-8.128-42.976-14.208-64zM464 544l29.472 39.296c2.688-13.184 5.728-26.272 9.28-39.296h-38.752zM896 320v-224h-800v224h800z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"filter",
						"drink",
						"caffeinate",
						"brew"
					],
					"grid": 32
				},
				{
					"id": 503,
					"width": 1024,
					"paths": [
						"M864 192h-169.344c-14.912 0-29.6-3.456-42.944-10.144l-215.456-107.744c-13.312-6.656-28-10.112-42.912-10.112h-233.344c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h216c15.744 0 31.264 3.872 45.184 11.296l197.632 105.408c13.92 7.424 29.44 11.296 45.184 11.296h200c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM928 864c0 35.296-28.704 64-64 64h-200c-10.464 0-20.896-2.592-30.112-7.52l-197.664-105.408c-18.464-9.856-39.296-15.072-60.224-15.072h-216c-35.296 0-64-28.704-64-64v-576c0-35.296 28.704-64 64-64h233.344c9.888 0 19.776 2.336 28.608 6.752l215.456 107.744c17.696 8.832 37.472 13.504 57.248 13.504h169.344c35.296 0 64 28.704 64 64v576zM891.328 795.328l-36.704 36.672 36.672 36.672c6.24 6.24 6.24 16.384 0 22.624-3.104 3.136-7.2 4.704-11.296 4.704s-8.192-1.568-11.328-4.672l-36.672-36.704-36.672 36.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672c-6.24-6.24-6.24-16.384 0-22.624l36.704-36.704-36.672-36.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l36.672 36.672 36.672-36.672c6.24-6.24 16.384-6.24 22.624 0s6.272 16.352 0.032 22.624zM384 144v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM384 240v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM384 336v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM384 432v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM384 528v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM384 624v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM384 720v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 272v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 368v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 464v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 560v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 656v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 752v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16zM672 848v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"find",
						"guide",
						"follow",
						"route"
					],
					"grid": 32
				},
				{
					"id": 504,
					"width": 1024,
					"paths": [
						"M864 192h-169.344c-14.912 0-29.6-3.456-42.944-10.144l-215.456-107.744c-13.312-6.656-28-10.112-42.912-10.112h-233.344c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h216c15.744 0 31.264 3.872 45.184 11.296l197.632 105.408c13.92 7.424 29.44 11.296 45.184 11.296h200c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM384 752c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM384 656c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM384 560c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM384 464c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM384 368c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM384 272c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM384 176c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 880c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 784c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 688c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 592c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 496c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 400c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM672 304c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM891.328 868.672c6.24 6.24 6.24 16.384 0 22.624-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672l-36.672-36.704-36.672 36.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672c-6.24-6.24-6.24-16.384 0-22.624l36.704-36.704-36.672-36.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l36.672 36.672 36.672-36.672c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-36.672 36.672 36.704 36.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"find",
						"guide",
						"follow",
						"route"
					],
					"grid": 32
				},
				{
					"id": 3379,
					"paths": [
						"M569.226 778.256c-0.002-0.044-0.002-0.088-0.004-0.132 0.002 0.044 0.002 0.088 0.004 0.132z",
						"M570.596 814.538c-0.012-0.234-0.022-0.466-0.032-0.702 0.010 0.234 0.020 0.466 0.032 0.702z",
						"M569.814 796.312c-0.006-0.178-0.012-0.356-0.020-0.536 0.010 0.182 0.016 0.358 0.020 0.536z",
						"M960 0h-896c-35.2 0-64 28.8-64 64v896c0 35.2 28.8 64 64 64h493.832c0.044 0 0.088 0.006 0.132 0.006 0.042 0 0.084-0.006 0.126-0.006h401.91c35.2 0 64-28.8 64-64v-896c0-35.2-28.8-64-64-64zM192 224c0-17.672 14.328-32 32-32s32 14.328 32 32v64c0 17.672-14.328 32-32 32s-32-14.328-32-32v-64zM960 960h-375.058c-6.7-42.082-10.906-85.476-13.388-127.604 0.006 0.116 0.010 0.228 0.018 0.344-19.696 2.146-39.578 3.26-59.572 3.26-133.65 0-262.382-48.656-362.484-137.006-14.906-13.156-16.326-35.906-3.168-50.812 13.158-14.904 35.906-16.326 50.814-3.168 86.936 76.728 198.748 118.986 314.838 118.986 19.086 0 38.052-1.166 56.816-3.416-2.192-118.194 6.876-211.914 7.026-213.404 0.898-8.996-2.050-17.952-8.118-24.654-6.066-6.702-14.682-10.526-23.724-10.526h-95.174c1.384-34.614 5.082-93.814 14.958-160.188 18.864-126.76 51.994-225.77 96.152-287.812h400.064v896z",
						"M800 320c-17.674 0-32-14.328-32-32v-64c0-17.672 14.326-32 32-32s32 14.328 32 32v64c0 17.672-14.326 32-32 32z",
						"M540.496 835.232c-3.646 0.192-7.298 0.336-10.956 0.454 3.658-0.116 7.31-0.264 10.956-0.454z",
						"M512 836c4.692 0 9.374-0.074 14.050-0.196-4.676 0.122-9.358 0.196-14.050 0.196z",
						"M539.074 763.202c0.784-0.044 1.568-0.084 2.352-0.132-0.782 0.048-1.568 0.088-2.352 0.132z",
						"M525.084 763.8c1.074-0.030 2.146-0.072 3.218-0.11-1.072 0.038-2.144 0.082-3.218 0.11z",
						"M877.65 648.182c-13.156-14.91-35.908-16.322-50.812-3.168-72.642 64.114-162.658 104.136-258.022 115.57 0.43 23.278 1.294 47.496 2.754 72.156 111.954-12.21 217.786-58.614 302.912-133.746 14.908-13.156 16.326-35.906 3.168-50.812z",
						"M571.498 832.748c-4.606 0.5-9.222 0.936-13.848 1.322 4.626-0.384 9.244-0.822 13.848-1.322z",
						"M555.488 834.242c-3.906 0.312-7.822 0.576-11.742 0.806 3.92-0.226 7.834-0.496 11.742-0.806z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"finder",
						"brand",
						"mac",
						"os"
					],
					"defaultCode": 61214,
					"grid": 16
				},
				{
					"id": 2649,
					"paths": [
						"M320 384h128v128h-128v-128z",
						"M576 384h128v128h-128v-128z",
						"M960 64c-35.346 0-64 28.654-64 64v64h-768v-64c0-35.346-28.654-64-64-64s-64 28.654-64 64v832c0 35.346 28.654 64 64 64s64-28.654 64-64v-256h768v256c0 35.346 28.654 64 64 64s64-28.654 64-64v-832c0-35.346-28.654-64-64-64zM832 640v-128h-128v128h-128v-128h-128v128h-128v-128h-128v128h-64v-128h64v-128h-64v-128h64v128h128v-128h128v128h128v-128h128v128h128v-128h64v128h-64v128h64v128h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"finish",
						"soprts",
						"racing",
						"flag",
						"sports"
					],
					"defaultCode": 60484,
					"grid": 16
				},
				{
					"id": 1026,
					"width": 1024,
					"paths": [
						"M960 32h-896c-17.664 0-32 14.336-32 32v896c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-896c0-17.664-14.336-32-32-32zM928 928h-832v-832h832v832zM896 128h-768v768h768v-768zM864 864h-704v-704h704v704zM800 384l-96-96-256 256-96-96-96 96 192 192 352-352zM352 493.248l96 96 256-256 50.752 50.752-306.752 306.752-146.752-146.752 50.752-50.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"finish",
						"complete",
						"check"
					],
					"grid": 32
				},
				{
					"id": 2557,
					"paths": [
						"M321.008 1024c-68.246-142.008-31.902-223.378 20.55-300.044 57.44-83.956 72.244-167.066 72.244-167.066s45.154 58.7 27.092 150.508c79.772-88.8 94.824-230.28 82.782-284.464 180.314 126.012 257.376 398.856 153.522 601.066 552.372-312.532 137.398-780.172 65.154-832.85 24.082 52.676 28.648 141.85-20 185.126-82.352-312.276-285.972-376.276-285.972-376.276 24.082 161.044-87.296 337.144-194.696 468.73-3.774-64.216-7.782-108.528-41.55-169.98-7.58 116.656-96.732 211.748-120.874 328.628-32.702 158.286 24.496 274.18 241.748 396.622z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fire",
						"flame",
						"hot",
						"popular"
					],
					"defaultCode": 60392,
					"grid": 16
				},
				{
					"id": 1454,
					"width": 801.7149696350098,
					"paths": [
						"M292.571 109.714q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM804.571 91.429v182.857q0 9.143-6.857 14.286-4.571 4-11.429 4-2.286 0-4-0.571l-256-54.857q-6.286-1.143-10.286-6.286t-4-11.429h-146.286v58.286q63.429 13.143 104.857 63.429t41.429 116v457.143q0 14.857-10.857 25.714t-25.714 10.857h-292.571q-14.857 0-25.714-10.857t-10.857-25.714v-457.143q0-60.571 35.714-108.857t92.286-65.429v-63.429h-18.286q-33.714 0-65.714 13.429t-52.286 30.286-37.714 38-23.143 30.571-8 14q-9.714 20-32.571 20-9.143 0-16.571-4-13.143-6.857-18-21.143t2-28q2.857-5.714 8.286-14.857t21.429-30.571 34.571-40 48.571-38.286 62-30q-14.286-24-14.286-49.143 0-37.714 26.857-64.571t64.571-26.857 64.571 26.857 26.857 64.571q0 18.857-8 36.571h172.571q0-6.286 4-11.429t10.286-6.286l256-54.857q1.714-0.571 4-0.571 6.857 0 11.429 4 6.857 5.143 6.857 14.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fire-extinguisher"
					],
					"defaultCode": 61748,
					"grid": 14
				},
				{
					"id": 2558,
					"paths": [
						"M512 0c0 0-384 384-384 640 0 212.078 171.922 384 384 384s384-171.922 384-384c0-256-384-640-384-640zM512 896c-88.366 0-160-71.634-160-160 0-106.668 160-266.666 160-266.666s160 160 160 266.666c0 88.366-71.634 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fire",
						"flame",
						"hot",
						"popular"
					],
					"defaultCode": 60393,
					"grid": 16
				},
				{
					"id": 1282,
					"width": 804.5699672698975,
					"paths": [
						"M804.571 969.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-768q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h768q7.429 0 12.857 5.429t5.429 12.857zM658.286 365.714q0 44.571-14 82.286t-36.571 64.286-50 50.286-54.857 44.286-50 41.143-36.571 46.571-14 55.143q0 54.857 38.286 128l-2.286-0.571 0.571 0.571q-51.429-23.429-91.429-47.429t-79.143-57.143-64.857-70-41.429-86-15.714-105.143q0-44.571 14-82.286t36.571-64.286 50-50.286 54.857-44.286 50-41.143 36.571-46.571 14-55.143q0-53.714-37.714-128l1.714 0.571-0.571-0.571q51.429 23.429 91.429 47.429t79.143 57.143 64.857 70 41.429 86 15.714 105.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fire"
					],
					"defaultCode": 61549,
					"grid": 14
				},
				{
					"id": 3406,
					"paths": [
						"M1022.526 334.14l-11.86 76.080c0 0-16.954-140.856-37.732-193.514-31.846-80.688-46.014-80.040-46.108-79.922 21.33 54.204 17.462 83.324 17.462 83.324s-37.792-102.998-137.712-135.768c-110.686-36.282-170.57-26.364-177.488-24.486-1.050-0.008-2.064-0.010-3.030-0.010 0.818 0.062 1.612 0.146 2.426 0.212-0.034 0.020-0.090 0.042-0.082 0.052 0.45 0.548 122.306 21.302 143.916 50.996 0 0-51.76 0-103.272 14.842-2.328 0.666 189.524 23.964 228.746 215.674 0 0-21.030-43.876-47.040-51.328 17.106 52.036 12.714 150.776-3.576 199.85-2.096 6.312-4.24-27.282-36.328-41.75 10.28 73.646-0.616 190.456-51.708 222.632-3.982 2.504 32.030-115.31 7.242-69.762-142.708 218.802-311.404 100.972-387.248 49.11 38.866 8.462 112.654-1.318 145.314-25.612 0.042-0.030 0.078-0.056 0.118-0.086 35.468-24.252 56.472-41.964 75.334-37.772 18.874 4.214 31.438-14.726 16.78-31.53-14.676-16.838-50.314-39.978-98.524-27.366-34 8.904-76.134 46.522-140.448 8.432-49.364-29.25-54.012-53.546-54.45-70.376 1.218-5.966 2.754-11.536 4.576-16.624 5.682-15.87 22.912-20.658 32.494-24.438 16.256 2.792 30.262 7.862 44.968 15.406 0.19-4.894 0.252-11.39-0.018-18.76 1.41-2.802 0.538-11.252-1.722-21.58-1.302-10.308-3.42-20.974-6.752-30.692 0.012-0.002 0.020-0.010 0.030-0.014 0.056-0.018 0.108-0.040 0.156-0.070 0.078-0.044 0.146-0.112 0.208-0.19 0.012-0.020 0.030-0.034 0.044-0.052 0.082-0.124 0.154-0.272 0.198-0.466 1.020-4.618 12.022-13.524 25.718-23.1 12.272-8.58 26.702-17.696 38.068-24.752 10.060-6.248 17.72-10.882 19.346-12.098 0.618-0.466 1.358-1.012 2.164-1.636 0.15-0.116 0.3-0.232 0.454-0.354 0.094-0.074 0.19-0.148 0.286-0.226 5.41-4.308 13.484-12.448 15.178-29.578 0.004-0.042 0.010-0.080 0.012-0.122 0.050-0.504 0.092-1.014 0.13-1.534 0.028-0.362 0.050-0.726 0.072-1.096 0.014-0.284 0.032-0.566 0.044-0.856 0.030-0.674 0.050-1.364 0.060-2.064 0-0.040 0.002-0.076 0.004-0.116 0.022-1.658-0.006-3.386-0.104-5.202-0.054-1.014-0.126-1.93-0.298-2.762-0.008-0.044-0.018-0.092-0.028-0.136-0.018-0.082-0.036-0.164-0.058-0.244-0.036-0.146-0.076-0.292-0.122-0.43-0.006-0.018-0.010-0.032-0.016-0.046-0.052-0.16-0.112-0.314-0.174-0.464-0.004-0.006-0.004-0.010-0.006-0.016-1.754-4.108-8.32-5.658-35.442-6.118-0.026-0.002-0.050-0.002-0.076-0.002v0c-11.066-0.188-25.538-0.194-44.502-0.118-33.25 0.134-51.628-32.504-57.494-45.132 8.040-44.46 31.276-76.142 69.45-97.626 0.722-0.406 0.58-0.742-0.274-0.978 7.464-4.514-90.246-0.124-135.186 57.036-39.888-9.914-74.654-9.246-104.616-2.214-5.754-0.162-12.924-0.88-21.434-2.652-19.924-18.056-48.448-51.402-49.976-91.208 0 0-0.092 0.072-0.252 0.204-0.020-0.382-0.056-0.76-0.072-1.142 0 0-60.716 46.664-51.628 173.882-0.022 2.036-0.064 3.986-0.12 5.874-16.432 22.288-24.586 41.020-25.192 45.156-14.56 29.644-29.334 74.254-41.356 141.98 0 0 8.408-26.666 25.284-56.866-12.412 38.022-22.164 97.156-16.436 185.856 0 0 1.514-19.666 6.874-47.994 4.186 55.010 22.518 122.924 68.858 202.788 88.948 153.32 225.67 230.74 376.792 242.616 26.836 2.212 54.050 2.264 81.424 0.186 2.516-0.178 5.032-0.364 7.55-0.574 30.964-2.174 62.134-6.852 93.238-14.366 425.172-102.798 378.942-616.198 378.942-616.198z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"firefox",
						"browser",
						"internet",
						"brand"
					],
					"defaultCode": 61241,
					"grid": 16
				},
				{
					"id": 1742,
					"width": 1021.1410598754883,
					"paths": [
						"M516 1024q-161.714 0-288.286-86t-188.286-227.714q-33.143-74.857-38.286-172t14.857-190 63.429-178.286 102.286-138.571l-6.286 160.571q6.286-8 38.857-8.857t40 8.857q24-46.286 91.714-78.857t134-33.714q-30.857 25.714-68.286 84.857t-33.429 93.429q14.286 4.571 35.714 7.714t36 4.286 38.857 2.286 28.857 1.714q8.571 2.857 5.429 26t-17.429 43.143q-2.857 4-9.429 10.571t-32.286 20.286-57.714 19.429l8.571 108-79.429-38.286q-10.286 24.571-4.286 46.571t20.571 38 37.429 23.714 46.286 3.714q29.143-5.143 56-19.714t47.714-25.714 42-10q34.857 2.286 51.143 18.857t11.143 37.143q-0.571 1.143-1.429 3.143t-4.857 7.143-10.286 8.857-18 6-26.571 0.571q-34.286 54.286-82.571 77.429t-119.714 16.857q42.286 34.857 92.857 47.143t96.286 3.429 88.286-29.714 73.143-50 46-59.429q24.571-52 22.286-110t-21.429-107.714-44.857-71.429q49.714 21.714 78.286 45.429t44 64.286q8.571-97.143-32.857-196t-119.714-162.286q151.429 44 235.429 159.714t86.286 295.714q1.143 72.571-23.143 145.714t-70.571 136-108 112-141.429 77.429-164.857 28.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"firefox"
					],
					"defaultCode": 62057,
					"grid": 14
				},
				{
					"id": 2975,
					"paths": [
						"M128 896v-768h128v352l320-320v320l320-320v704l-320-320v320l-320-320v352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"first",
						"player"
					],
					"defaultCode": 60810,
					"grid": 16
				},
				{
					"id": 1808,
					"width": 877.7139892578125,
					"paths": [
						"M755.429 512q0 25.714-2.857 43.429l-134.857-8 128 44.571q-10.857 41.714-33.143 80.571l-122.286-58.857 101.143 90.286q-25.143 34.857-61.143 61.714l-89.714-101.714 58.857 122.857q-34.857 21.143-80 33.714l-45.143-130.286 8 137.143q-21.714 3.429-43.429 3.429t-43.429-3.429l8-136-44.571 129.143q-42.286-10.857-80-33.714l58.857-122.857-89.714 101.714q-33.714-24.571-61.714-61.714l101.714-90.286-122.286 59.429q-22.286-39.429-33.143-80.571l128-45.143-135.429 8q-2.857-24-2.857-43.429 0-20 2.857-44l136 8-128.571-45.143q10.857-41.714 33.143-80l122.286 59.429-101.143-90.857q26.286-34.857 61.143-61.714l90.286 101.714-58.857-122.857q38.286-22.286 80-33.143l44 128-7.429-134.857q20.571-3.429 42.857-3.429 21.714 0 43.429 3.429l-8 135.429 44.571-128.571q42.286 10.857 80 33.714l-58.857 122.286 90.286-101.714q34.857 26.857 61.143 61.714l-101.143 90.857 121.714-59.429q21.143 35.429 33.143 80.571l-128 44.571 135.429-8q2.857 17.714 2.857 44zM772.571 512q0-91.429-44.857-168.857t-121.714-122.286-167.143-44.857q-68 0-129.714 26.571t-106.571 71.429-71.143 107.143-26.286 130.857q0 68 26.286 130.286t71.143 107.143 106.571 71.429 129.714 26.571q90.286 0 167.143-44.857t121.714-122.286 44.857-168.286zM814.286 293.143v437.714l-375.429 218.857-375.429-218.857v-437.714l375.429-218.857zM438.857 982.286l404.571-235.429v-470.286l-404.571-234.857-404.571 234.857v470.286zM877.714 256v512l-438.857 256-438.857-256v-512l438.857-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"first-order"
					],
					"defaultCode": 62128,
					"grid": 14
				},
				{
					"id": 3018,
					"paths": [
						"M832 192l-192-192-512 512 512 512 192-192-320-320zM0 0v1024h128v-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"first",
						"player"
					],
					"defaultCode": 60853,
					"grid": 16
				},
				{
					"id": 2517,
					"paths": [
						"M1019.342 463.33c-50.012-81.95-115.734-149.972-190.062-196.71-77.632-48.818-165.206-74.62-253.252-74.62-126.264 0-247.598 52.094-345.262 147.466-55.474-65.522-119.156-115.216-185.81-144.728-12.346-5.466-26.79-2.596-36.108 7.17s-11.506 24.332-5.468 36.404l120.87 241.688-120.87 241.688c-6.038 12.072-3.85 26.636 5.468 36.402 6.172 6.468 14.59 9.912 23.16 9.912 4.37-0.002 8.778-0.896 12.948-2.742 66.656-29.514 130.336-79.206 185.808-144.726 97.666 95.372 219 147.466 345.264 147.466 88.046 0 175.622-25.802 253.252-74.62 74.328-46.738 140.050-114.76 190.062-196.71 6.248-10.236 6.248-23.104 0-33.34zM832 512c-35.348 0-64-28.654-64-64s28.652-64 64-64 64 28.654 64 64-28.652 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fish",
						"food",
						"seafood",
						"meat"
					],
					"defaultCode": 60352,
					"grid": 16
				},
				{
					"id": 505,
					"width": 1024,
					"paths": [
						"M896 864c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32 32 14.336 32 32zM944 944c-22.080 22.080-51.040 33.152-80 33.152s-57.92-11.040-80-33.152l-413.984-413.984c-25.76 8.864-53.248 13.984-82.016 13.984-141.152 0-256-114.848-256-256 0-21.184 2.848-42.912 8.512-64.576 2.88-11.104 11.488-19.808 22.592-22.816 2.784-0.768 5.6-1.12 8.384-1.12 8.384 0 16.544 3.296 22.624 9.376l84.64 84.64c12.096 12.064 28.16 18.72 45.248 18.72s33.152-6.656 45.248-18.752l24.224-24.224c12.096-12.096 18.752-28.16 18.752-45.248s-6.656-33.152-18.752-45.248l-84.608-84.64c-8.128-8.128-11.264-19.968-8.256-31.040s11.712-19.68 22.816-22.592c21.664-5.632 43.392-8.48 64.576-8.48 141.152 0 256 114.848 256 256 0 28.768-5.12 56.256-13.984 82.016l413.984 413.984c44.192 44.192 44.192 115.808 0 160zM921.376 806.624l-428.416-428.416c12.16-27.616 19.040-58.080 19.040-90.208 0-123.712-100.288-224-224-224-19.552 0-38.432 2.752-56.512 7.488l84.64 84.64c37.504 37.504 37.504 98.272 0 135.776l-24.256 24.224c-18.72 18.72-43.296 28.096-67.872 28.096s-49.152-9.376-67.872-28.128l-84.64-84.608c-4.736 18.080-7.488 36.96-7.488 56.512 0 123.712 100.288 224 224 224 32.128 0 62.592-6.88 90.208-19.040l428.416 428.416c15.328 15.328 35.712 23.776 57.376 23.776s42.048-8.448 57.376-23.776c31.616-31.648 31.616-83.104 0-114.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fix",
						"adjust",
						"edit",
						"calibrate"
					],
					"grid": 32
				},
				{
					"id": 506,
					"width": 1024,
					"paths": [
						"M944 784l-413.984-413.984c8.864-25.76 13.984-53.248 13.984-82.016 0-141.152-114.848-256-256-256-21.184 0-42.912 2.848-64.576 8.512-11.104 2.88-19.808 11.488-22.816 22.592-3.008 11.040 0.128 22.88 8.256 31.008l84.64 84.64c12.064 12.096 18.72 28.16 18.72 45.248s-6.656 33.152-18.752 45.248l-24.224 24.256c-12.096 12.064-28.16 18.72-45.248 18.72s-33.152-6.656-45.248-18.72l-84.64-84.672c-6.080-6.080-14.24-9.376-22.624-9.376-2.784 0-5.6 0.352-8.384 1.12-11.104 3.040-19.712 11.744-22.592 22.848-5.664 21.664-8.512 43.392-8.512 64.576 0 141.152 114.848 256 256 256 28.768 0 56.256-5.12 82.016-13.984l413.984 413.984c22.080 22.080 51.040 33.152 80 33.152s57.92-11.040 80-33.152c44.192-44.192 44.192-115.808 0-160zM864 896c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fix",
						"adjust",
						"edit",
						"calibrate"
					],
					"grid": 32
				},
				{
					"id": 2745,
					"paths": [
						"M0 0h128v1024h-128v-1024z",
						"M832 643.002c82.624 0 154.57-19.984 192-49.5v-512c-37.43 29.518-109.376 49.502-192 49.502s-154.57-19.984-192-49.502v512c37.43 29.516 109.376 49.5 192 49.5z",
						"M608 32.528c-46.906-19.94-115.52-32.528-192-32.528-96.396 0-180.334 19.984-224 49.502v512c43.666-29.518 127.604-49.502 224-49.502 76.48 0 145.094 12.588 192 32.528v-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"report",
						"mark"
					],
					"defaultCode": 60580,
					"grid": 16
				},
				{
					"id": 1434,
					"width": 1060.5730743408203,
					"paths": [
						"M475.429 571.429v-109.714q-103.429 9.143-219.429 66.857v105.714q117.143-54.857 219.429-62.857zM475.429 332.571v-112.571q-98.286 4.571-219.429 72v108q122.857-63.429 219.429-67.429zM950.857 597.143v-105.143q-134.286 66.286-219.429 40.571v-128q-11.429-3.429-22.286-8.571-2.857-1.714-18.857-9.714t-19.714-9.714-18-8.571-19.714-8.857-18.571-7.429-20.571-7.143-20-4.857-22.571-4.286-22.571-2.286-25.143-1.143q-13.143 0-28 1.714v126.857h10.857q58.286 0 110 16.571t112.857 46.857q10.857 5.143 22.286 8.571v107.429q24 9.714 52 9.714 68.571 0 167.429-52.571zM950.857 353.143v-108q-96.571 52-174.857 52-25.714 0-44.571-4.571v112q84.571 24 219.429-51.429zM182.857 146.286q0 20-10 36.571t-26.571 26.286v723.429q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-723.429q-16.571-9.714-26.571-26.286t-10-36.571q0-30.286 21.429-51.714t51.714-21.429 51.714 21.429 21.429 51.714zM1024 182.857v436q0 22.286-20 32.571-5.714 2.857-9.714 5.143-124.571 66.286-210.857 66.286-50.286 0-90.286-20l-16-8q-36.571-18.857-56.571-27.429t-52-16.571-65.143-8q-58.286 0-134.571 25.143t-130.571 58.286q-8.571 5.143-18.857 5.143-9.143 0-18.286-4.571-18.286-10.857-18.286-32v-424q0-20 17.714-31.429 20-12 44.857-24.286t65.143-29.714 87.143-28.286 88.571-10.857q64 0 119.429 17.714t119.429 49.143q21.714 10.857 50.857 10.857 69.714 0 177.143-64 12.571-6.857 17.714-9.714 17.714-9.143 35.429 1.143 17.714 11.429 17.714 31.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag-checkered"
					],
					"defaultCode": 61726,
					"grid": 14
				},
				{
					"id": 1433,
					"width": 1060.5730743408203,
					"paths": [
						"M950.857 597.143v-352q-96.571 52-174.857 52-46.857 0-82.857-18.286-57.143-28-105.143-43.714t-101.714-15.714q-98.857 0-230.286 72.571v342.286q140-64.571 247.429-64.571 31.429 0 59.143 4.286t56 14.857 44 17.714 47.143 22.571l16 8q25.143 12.571 57.714 12.571 68.571 0 167.429-52.571zM182.857 146.286q0 20-10 36.571t-26.571 26.286v723.429q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-723.429q-16.571-9.714-26.571-26.286t-10-36.571q0-30.286 21.429-51.714t51.714-21.429 51.714 21.429 21.429 51.714zM1024 182.857v436q0 22.286-20 32.571-5.714 2.857-9.714 5.143-124.571 66.286-210.857 66.286-50.286 0-90.286-20l-16-8q-36.571-18.857-56.571-27.429t-52-16.571-65.143-8q-58.286 0-134.571 25.143t-130.571 58.286q-8.571 5.143-18.857 5.143-9.143 0-18.286-4.571-18.286-10.857-18.286-32v-424q0-20 17.714-31.429 20-12 44.857-24.286t65.143-29.714 87.143-28.286 88.571-10.857q64 0 119.429 17.714t119.429 49.143q21.714 10.857 50.857 10.857 69.714 0 177.143-64 12.571-6.857 17.714-9.714 17.714-9.143 35.429 1.143 17.714 11.429 17.714 31.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag-o"
					],
					"defaultCode": 61725,
					"grid": 14
				},
				{
					"id": 118,
					"paths": [
						"M76.8 972.8c-14.138 0-25.6-11.461-25.6-25.6v-768c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v768c0 14.139-11.462 25.6-25.6 25.6z",
						"M179.181 512.002c-5.346 0-10.734-1.667-15.341-5.122-11.31-8.483-13.603-24.53-5.12-35.838 3.45-4.6 85.789-112.64 199.68-112.64 86.715 0 144.038 30.666 194.614 57.722 44.813 23.973 83.515 44.677 138.186 44.677 112.246 0 192.389-106.49 238.093-190.344-35.736 20.317-81.411 36.744-135.693 36.744-113.005 0-171.389-58.386-222.901-109.899-50.925-50.922-94.902-94.901-186.699-94.901-113.883 0-183.629 91.238-184.32 92.16-8.483 11.31-24.53 13.603-35.84 5.12s-13.603-24.53-5.12-35.84c3.45-4.6 86.080-112.64 225.28-112.64 113.003 0 171.389 58.386 222.901 109.899 50.925 50.922 94.904 94.901 186.699 94.901 113.883 0 183.629-91.238 184.32-92.16 7.534-10.043 21.238-13.141 32.362-7.315 11.122 5.827 16.374 18.861 12.405 30.771-1.090 3.269-27.288 80.958-79.786 159.704-31.341 47.011-65.638 84.654-101.941 111.88-46.997 35.248-97.384 53.12-149.76 53.12-67.504 0-115.715-25.79-162.338-50.733-49.669-26.57-96.582-51.667-170.462-51.667-88.576 0-158.029 91.238-158.72 92.16-5.029 6.706-12.717 10.242-20.499 10.242z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"report",
						"mark"
					],
					"defaultCode": 59415,
					"grid": 20
				},
				{
					"id": 507,
					"width": 1024,
					"paths": [
						"M832 128h-592.704c14.656-19.072 21.504-44.416 12.992-72.096-8-26.016-29.792-47.040-56.224-53.472-52.864-12.832-100.064 26.848-100.064 77.568 0 26.080 12.672 49.024 32 63.648v832.352c0 26.496 21.504 48 48 48s48-21.504 48-48v-336h608c53.024 0 96-42.976 96-96v-320c0-53.024-42.976-96-96-96zM608 160v256h-384v-256h384zM204.704 118.112l-12.704 9.888v848c0 8.832-7.168 16-16 16s-16-7.168-16-16v-848.288l-12.704-9.6c-16.032-12.096-23.104-32.096-17.248-52.064 4.96-16.96 19.552-30.048 36.928-33.216 30.4-5.568 57.024 17.728 57.024 47.168 0 14.944-7.040 28.832-19.296 38.112zM832 608h-608v-64h672c0 35.296-28.704 64-64 64zM896 512h-672v-64h672v64zM896 416h-256v-64h256v64zM896 320h-256v-64h256v64zM640 224v-64h192c35.296 0 64 28.704 64 64h-256zM256 224c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM384 224c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM320 288c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM448 288c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM512 224c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM576 352c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM448 352c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM256 352c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"mark",
						"wave"
					],
					"grid": 32
				},
				{
					"id": 508,
					"width": 1024,
					"paths": [
						"M832 128h-592.704c14.656-19.072 21.504-44.416 12.992-72.096-8-26.016-29.792-47.040-56.224-53.472-52.864-12.832-100.064 26.848-100.064 77.568 0 26.080 12.672 49.024 32 63.648v832.352c0 26.496 21.504 48 48 48s48-21.504 48-48v-336h608c53.024 0 96-42.976 96-96v-320c0-53.024-42.976-96-96-96zM544 192c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM576 352c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM480 256c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM416 192c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM448 352c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM352 256c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM288 192c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM288 320c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM880 544h-640c-8.832 0-16-7.168-16-16s7.168-16 16-16h640c8.832 0 16 7.168 16 16s-7.168 16-16 16zM880 448h-640c-8.832 0-16-7.168-16-16s7.168-16 16-16h640c8.832 0 16 7.168 16 16s-7.168 16-16 16zM880 352h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16zM880 256h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"mark",
						"wave"
					],
					"grid": 32
				},
				{
					"id": 1027,
					"width": 1024,
					"paths": [
						"M983.84 652.352l-183.84-236.352 108-243.008c9.408-21.152-6.080-44.992-29.248-44.992h-318.752l-11.552-69.248c-2.56-15.456-15.904-26.752-31.552-26.752h-452.448l-0.896-5.28c-2.88-17.408-19.328-29.248-36.8-26.304-15.648 2.624-26.112 16.256-26.144 31.584h-0.608l0.512 3.072c0.064 0.736-0.192 1.44-0.064 2.208l160 960c2.592 15.616 16.16 26.72 31.52 26.72 1.76 0 3.488-0.128 5.28-0.448 17.44-2.912 29.216-19.392 26.304-36.832l-63.104-378.72h303.552l11.552 69.248c2.56 15.456 15.904 26.752 31.552 26.752h451.456c26.656 0 41.632-30.624 25.28-51.648zM489.792 96l74.944 448h-414.528l-74.656-448h414.24zM532.256 620.288l-8.704-44.288h40.096l-31.392 44.288zM557.952 640l44.512-63.456-64-384.544h291.040l-103.584 233.024 167.232 214.976c0 0-334.048 0.128-335.2 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"mark",
						"wave"
					],
					"grid": 32
				},
				{
					"id": 2746,
					"paths": [
						"M0 0h128v1024h-128v-1024z",
						"M800 131.004c-60.548 0-116.174-7.888-160-21.068v-60.434c-43.668-29.518-127.604-49.502-224-49.502s-180.334 19.984-224 49.502v512c43.666-29.518 127.604-49.502 224-49.502 60.548 0 116.174 7.888 160 21.068v60.434c43.668 29.516 127.606 49.5 224 49.5s180.332-19.984 224-49.5v-512c-43.668 29.518-127.606 49.502-224 49.502zM608 407v68.86l-13.568-4.080c-51.732-15.558-113.432-23.78-178.432-23.78-57.814 0-112.816 6.638-160 18.75v-381.682c43.826-13.18 99.452-21.068 160-21.068 76.48 0 145.094 12.588 192 32.528v310.472zM960 554.41c-35.652 13.614-91.746 24.592-160 24.592s-124.348-10.978-160-24.592v-378.074c47.692 12.234 102.548 18.668 160 18.668 57.812 0 112.816-6.638 160-18.75v378.156z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"report",
						"mark"
					],
					"defaultCode": 60581,
					"grid": 16
				},
				{
					"id": 2747,
					"paths": [
						"M0 0h128v1024h-128v-1024z",
						"M640 64c-32 0-48-16-64-32s-32-32-64-32h-320v640h320c32 0 48 16 64 32s32 32 64 32h320v-640h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"report",
						"mark"
					],
					"defaultCode": 60582,
					"grid": 16
				},
				{
					"id": 2748,
					"paths": [
						"M0 0h128v1024h-128v-1024z",
						"M640 64c-32 0-48-16-64-32s-32-32-64-32h-320v640h320c32 0 48 16 64 32s32 32 64 32h320v-640h-320zM256 576v-512h256c4.97 0 5.49 0 18.746 13.254 3.594 3.594 7.648 7.648 12.254 11.856v490.134c-9.406-2.048-19.7-3.244-31-3.244h-256zM896 640h-256c-4.97 0-5.49 0-18.746-13.254-10.438-10.44-24.758-24.736-45.254-35.5v-478.494c16.77 8.806 37.67 15.248 64 15.248h256v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"report",
						"mark"
					],
					"defaultCode": 60583,
					"grid": 16
				},
				{
					"id": 2749,
					"paths": [
						"M508.118 122.046c-96.356-114.5-169.38-122.046-316.118-122.046v512c256.534-128 285.272 16.67 447.012 2.046 159.456-14.44 295.050-137.174 384.988-258.046-254.712 58.906-382.92 24.046-515.882-133.954zM0 0h128v1024h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"report",
						"mark"
					],
					"defaultCode": 60584,
					"grid": 16
				},
				{
					"id": 2750,
					"paths": [
						"M256 65c38.786 1.572 67.372 5.362 92.73 13.806 38.326 12.762 71.348 38.018 110.418 84.448 108.33 128.728 217.85 183.652 366.214 183.652 15.458 0 31.534-0.614 48.294-1.85-20.18 23.744-41.41 46.932-63.458 68.118-30.906 29.698-60.998 53.042-89.44 69.384-29.98 17.224-59.094 27.218-86.526 29.702-3.62 0.328-7.066 0.486-10.542 0.486-33.64 0-59.492-15.634-98.884-41.146-45.148-29.236-101.336-65.624-183.092-65.624-27.384 0-55.812 4.068-85.718 12.322v-353.298zM192 0v512c61.174-30.524 109.474-42.022 149.718-42.022 122.682 0 170.734 106.768 281.976 106.768 5.296 0 10.708-0.24 16.304-0.746 159.458-14.442 294.062-199.128 384-320-76.41 17.67-141.452 26.906-198.636 26.906-133.44 0-224.17-50.258-317.246-160.86-96.354-114.5-169.378-122.046-316.116-122.046v0zM0 0h128v1024h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"report",
						"mark"
					],
					"defaultCode": 60585,
					"grid": 16
				},
				{
					"id": 2751,
					"paths": [
						"M0 0h128v1024h-128v-1024z",
						"M192 64v512h800l-256-256 256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"report",
						"mark"
					],
					"defaultCode": 60586,
					"grid": 16
				},
				{
					"id": 2752,
					"paths": [
						"M0 0h128v1024h-128v-1024z",
						"M928.784 576c-0.012-0.002-0.030-0.002-0.040 0h-704.744c-17.672 0-32-14.326-32-32v-448c0-17.672 14.328-32 32-32h704.744c12.944 0 24.612 7.796 29.564 19.754 4.954 11.958 2.214 25.722-6.938 34.874l-201.37 201.372 200.438 200.438c6.36 5.85 10.346 14.24 10.346 23.562 0 17.674-14.326 32-32 32zM256 512h595.49l-169.372-169.374c-12.498-12.496-12.498-32.758 0-45.254l169.372-169.372h-595.49v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag",
						"report",
						"mark"
					],
					"defaultCode": 60587,
					"grid": 16
				},
				{
					"id": 1212,
					"width": 1060.5730590820312,
					"paths": [
						"M182.857 146.286q0 41.143-36.571 62.857v723.429q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-723.429q-36.571-21.714-36.571-62.857 0-30.286 21.429-51.714t51.714-21.429 51.714 21.429 21.429 51.714zM1024 182.857v436q0 14.286-7.143 22t-22.571 15.714q-122.857 66.286-210.857 66.286-34.857 0-70.571-12.571t-62-27.429-66-27.429-81.429-12.571q-109.714 0-265.143 83.429-9.714 5.143-18.857 5.143-14.857 0-25.714-10.857t-10.857-25.714v-424q0-18.286 17.714-31.429 12-8 45.143-24.571 134.857-68.571 240.571-68.571 61.143 0 114.286 16.571t125.143 50.286q21.714 10.857 50.286 10.857 30.857 0 67.143-12t62.857-26.857 50.286-26.857 31.143-12q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flag"
					],
					"defaultCode": 61476,
					"grid": 14
				},
				{
					"id": 509,
					"width": 1024,
					"paths": [
						"M1020.192 726.016l-70.688-202.048c8.992-22.112 9.92-46.208 1.6-68.896-9.184-25.088-27.776-44.704-52.352-55.232l-128.192-54.944 1.6-14.336c6.304-56.832-38.208-106.56-95.424-106.56h-323.936c-57.216 0-101.728 49.728-95.424 106.592l1.344 12.064-133.504 57.216c-24.576 10.528-43.168 30.112-52.352 55.232-8.32 22.688-7.392 46.816 1.6 68.896l-70.688 202.048c-9.792 28 0.192 57.856 24.832 74.336 11.040 7.36 23.392 11.008 35.712 11.008 15.2 0 30.24-5.536 42.496-16.448l72.608-64.8c18.336 22.688 46.080 35.968 74.944 35.968 10.016 0 20.128-1.568 30.016-4.864l28.128-9.376c16.736 28.864 47.68 48.128 82.944 48.128h238.624c34.624 0 65.024-18.624 81.92-46.624l23.584 7.84c9.888 3.328 20 4.864 30.016 4.864 28.896 0 56.608-13.28 74.944-35.968l72.608 64.8c12.224 10.912 27.296 16.448 42.496 16.448 12.288 0 24.672-3.648 35.712-11.008 24.64-16.448 34.624-46.336 24.832-74.336zM85.504 771.040c-13.6 12.16-29.12 9.408-39.072 2.72-9.984-6.656-18.464-19.936-12.416-37.184l60.096-171.712 68.64 137.248-77.248 68.928zM274.304 730.88c-30.016 9.92-63.328-3.808-77.472-32.096l-91.040-182.048c-7.968-15.936-8.992-33.92-2.848-50.656 6.112-16.704 18.528-29.792 34.88-36.8l124.576-53.408 37.632 338.72c0.288 2.496 1.024 4.8 1.504 7.2l-27.232 9.088zM697.696 711.072c-3.616 32.448-30.976 56.928-63.616 56.928h-238.624c-32.672 0-60-24.48-63.616-56.928l-42.656-384c-2.048-18.336 3.616-36 15.936-49.76 12.288-13.728 29.216-21.312 47.68-21.312h323.936c18.464 0 35.392 7.584 47.68 21.312 12.288 13.76 17.952 31.424 15.904 49.76l-42.624 384zM749.696 730.88l-22.048-7.36c0.608-2.976 1.504-5.856 1.856-8.928l37.376-336.448 119.296 51.136c16.384 7.008 28.768 20.096 34.88 36.8 6.112 16.736 5.12 34.72-2.848 50.656l-91.040 182.048c-14.144 28.32-47.456 42.016-77.472 32.096zM977.568 773.76c-9.984 6.688-25.472 9.44-39.072-2.72l-77.216-68.896 68.64-137.248 60.096 171.712c6.016 17.248-2.464 30.496-12.448 37.152z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flake",
						"bake",
						"eat"
					],
					"grid": 32
				},
				{
					"id": 510,
					"width": 1024,
					"paths": [
						"M800.512 359.584l98.24 42.112c24.576 10.528 43.168 30.112 52.352 55.232 8.128 22.144 7.296 45.664-1.12 67.36l-106.592 208.832c-18.336 21.92-45.44 34.816-73.792 34.816-8.064 0-16.192-1.312-24.256-3.456l55.168-404.896zM182.784 735.264c18.272 20.48 44.288 32.672 71.584 32.672 9.376 0 18.816-1.536 28.096-4.384l-55.232-405.568-101.984 43.712c-24.576 10.528-43.168 30.112-52.352 55.232-7.456 20.352-7.104 41.76-0.544 61.92l110.432 216.416zM60.448 565.92l-56.672 161.92c-9.792 28 0.192 57.856 24.832 74.336 11.040 7.36 23.392 11.008 35.712 11.008 15.2 0 30.24-5.536 42.496-16.448l49.088-43.808-95.456-187.008zM964 567.232l-95.136 186.4 48.32 43.104c12.224 10.912 27.296 16.448 42.496 16.448 12.288 0 24.672-3.648 35.712-11.008 24.64-16.48 34.624-46.368 24.832-74.336l-56.224-160.608zM713.984 755.968l58.176-425.28c5.184-56.128-38.816-104.832-95.424-104.832h-323.936c-57.216 0-101.728 49.728-95.424 106.592l1.344 12.064 54.912 408.768c16.896 28 47.2 46.72 81.824 46.72h238.624c33.44 0 62.688-17.6 79.904-44.032z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flake",
						"bake",
						"eat"
					],
					"grid": 32
				},
				{
					"id": 1350,
					"width": 950.8549194335938,
					"paths": [
						"M872.571 827.429q32 50.857 12.286 87.143t-80.286 36.286h-658.286q-60.571 0-80.286-36.286t12.286-87.143l287.429-453.143v-228h-36.571q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h292.571q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714-25.714 10.857h-36.571v228zM427.429 413.143l-155.429 245.143h406.857l-155.429-245.143-11.429-17.714v-249.143h-73.143v249.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flask"
					],
					"defaultCode": 61635,
					"grid": 14
				},
				{
					"id": 3401,
					"paths": [
						"M367.562 0c-243.358 0-367.562 140.162-367.562 401.856v0 549.034l238.39-238.628v-278.896c0-108.416 28.73-177.406 125.118-192.894v0c33.672-6.584 103.75-4.278 148.306-4.278v0 165.596c0 1.51 0.208 4.206 0.594 5.586v0c1.87 6.704 7.93 11.616 15.116 11.63v0c4.062 0.008 7.868-2.104 11.79-5.97v0l413.122-412.974-584.874-0.062zM785.61 311.746v278.89c0 108.414-28.736 177.414-125.116 192.894v0c-33.672 6.582-103.756 4.278-148.312 4.278v0-165.594c0-1.5-0.206-4.204-0.594-5.582v0c-1.864-6.712-7.922-11.622-15.112-11.63v0c-4.064-0.008-7.866 2.112-11.79 5.966v0l-413.124 412.966 584.874 0.066c243.354 0 367.564-140.168 367.564-401.852v0-549.028l-238.39 238.626z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flattr",
						"brand",
						"donate",
						"social"
					],
					"defaultCode": 61236,
					"grid": 16
				},
				{
					"id": 3351,
					"paths": [
						"M0 544c0-123.712 100.288-224 224-224s224 100.288 224 224c0 123.712-100.288 224-224 224s-224-100.288-224-224zM576 544c0-123.712 100.288-224 224-224s224 100.288 224 224c0 123.712-100.288 224-224 224s-224-100.288-224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flickr",
						"brand",
						"social"
					],
					"defaultCode": 61186,
					"grid": 16
				},
				{
					"id": 3352,
					"paths": [
						"M800 416c-70.58 0-128 57.42-128 128s57.42 128 128 128c70.58 0 128-57.42 128-128s-57.42-128-128-128zM800 320v0c123.71 0 224 100.288 224 224 0 123.71-100.29 224-224 224s-224-100.29-224-224c0-123.712 100.29-224 224-224zM0 544c0-123.712 100.288-224 224-224s224 100.288 224 224c0 123.712-100.288 224-224 224s-224-100.288-224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flickr",
						"brand",
						"social"
					],
					"defaultCode": 61187,
					"grid": 16
				},
				{
					"id": 3353,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM288 672c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zM736 672c-88.4 0-160-71.6-160-160s71.6-160 160-160c88.4 0 160 71.6 160 160s-71.6 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flickr",
						"brand",
						"social"
					],
					"defaultCode": 61188,
					"grid": 16
				},
				{
					"id": 3354,
					"paths": [
						"M512 0c-282.77 0-512 230.796-512 515.5s229.23 515.5 512 515.5 512-230.796 512-515.5-229.23-515.5-512-515.5zM288 672c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160c0 88.366-71.634 160-160 160zM736 672c-88.368 0-160-71.634-160-160s71.632-160 160-160 160 71.634 160 160c0 88.366-71.632 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flickr",
						"brand",
						"social"
					],
					"defaultCode": 61189,
					"grid": 16
				},
				{
					"id": 1509,
					"width": 877.7150573730469,
					"paths": [
						"M713.143 73.143q68 0 116.286 48.286t48.286 116.286v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571zM398.857 512q0-50.286-35.429-85.714t-85.714-35.429-85.714 35.429-35.429 85.714 35.429 85.714 85.714 35.429 85.714-35.429 35.429-85.714zM721.143 512q0-50.286-35.429-85.714t-85.714-35.429-85.714 35.429-35.429 85.714 35.429 85.714 85.714 35.429 85.714-35.429 35.429-85.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flickr"
					],
					"defaultCode": 61806,
					"grid": 14
				},
				{
					"id": 511,
					"width": 1024,
					"paths": [
						"M785.152 750.848c29.984-29.984 46.848-70.688 46.848-113.12v-253.728c0-53.024-42.976-96-96-96h-160v-208c0-44.192-35.808-80-80-80s-80 35.808-80 80v208h-32c-37.824 0-70.24 22.080-85.856 53.856l-59.264 59.264c-30.016 30.016-46.88 70.72-46.88 113.152v91.456c0 42.432 16.864 83.136 46.848 113.152l49.152 49.12v32c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h480c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32v-32l17.152-17.152zM768 992h-480v-160h480v160zM762.496 728.224l-26.496 26.528v45.248h-416v-45.248l-58.496-58.496c-24.032-24.032-37.504-56.576-37.504-90.528v-91.456c0-33.952 13.472-66.496 37.504-90.496l26.496-26.528v98.752c0 8.832 7.168 16 16 16s16-7.168 16-16v-112c0-35.36 28.64-64 64-64h32v48c0 8.832 7.168 16 16 16s16-7.168 16-16v-286.336c0-24.384 17.472-46.176 41.696-49.28 29.248-3.744 54.304 19.072 54.304 47.616v288c0 8.832 7.168 16 16 16s16-7.168 16-16v-48h96v48c0 8.832 7.168 16 16 16s16-7.168 16-16v-48h32c35.36 0 64 28.64 64 64v253.728c0 33.952-13.472 66.496-37.504 90.496z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flip",
						"provoke",
						"offend",
						"anger",
						"antagonize"
					],
					"grid": 32
				},
				{
					"id": 2244,
					"paths": [
						"M576 0v1024h384zM0 1024h384v-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flip-horizontal",
						"mirror"
					],
					"defaultCode": 60079,
					"grid": 16
				},
				{
					"id": 2245,
					"paths": [
						"M0 1024l448-1024v1024z",
						"M576 776v16h346.5l-7-16z",
						"M576 744v16h332.5l-7-16z",
						"M576 520v16h234.5l-7-16z",
						"M576 680v16h304.5l-7-16z",
						"M576 552v16h248.5l-7-16z",
						"M576 584v16h262.5l-7-16z",
						"M576 616v16h276.5l-7-16z",
						"M576 648v16h290.5l-7-16z",
						"M576 968v16h430.5l-7-16z",
						"M1013.5 1000h-437.5v16h444.5z",
						"M576 808v16h360.5l-7-16z",
						"M576 936v16h416.5l-7-16z",
						"M576 840v16h374.5l-7-16z",
						"M576 872v16h388.5l-7-16z",
						"M576 904v16h402.5l-7-16z",
						"M576 712v16h318.5l-7-16z",
						"M576 104v16h52.5l-7-16z",
						"M576 168v16h80.5l-7-16z",
						"M576 136v16h66.5l-7-16z",
						"M576 200v16h94.5l-7-16z",
						"M576 72v16h38.5l-7-16z",
						"M576 488v16h220.5l-7-16z",
						"M576 40v16h24.5l-7-16z",
						"M576 232v16h108.5l-7-16z",
						"M576 8v16h10.5l-7-16z",
						"M576 392v16h178.5l-7-16z",
						"M576 264v16h122.5l-7-16z",
						"M576 456v16h206.5l-7-16z",
						"M576 424v16h192.5l-7-16z",
						"M576 296v16h136.5l-7-16z",
						"M576 360v16h164.5l-7-16z",
						"M576 328v16h150.5l-7-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flip-horizontal",
						"mirror",
						"dualtone"
					],
					"defaultCode": 60080,
					"grid": 16
				},
				{
					"id": 2242,
					"paths": [
						"M0 384h1024v-384zM1024 960v-384h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flip-vertical",
						"mirror"
					],
					"defaultCode": 60077,
					"grid": 16
				},
				{
					"id": 2243,
					"paths": [
						"M1024 1024l-1024-448h1024z",
						"M1024 184v-16h-384l-36.572 16z",
						"M1024 120v-16h-237.714l-36.572 16z",
						"M1024 56v-16h-91.428l-36.572 16z",
						"M969.142 24h54.858v-16h-18.286z",
						"M1024 88v-16h-164.572l-36.57 16z",
						"M1024 216v-16h-457.142l-36.572 16z",
						"M1024 152v-16h-310.858l-36.57 16z",
						"M1024 408v-16h-896l-36.572 16z",
						"M1024 440v-16h-969.142l-36.572 16z",
						"M1024 376v-16h-822.858l-36.57 16z",
						"M1024 312v-16h-676.572l-36.57 16z",
						"M1024 280v-16h-603.428l-36.572 16z",
						"M1024 344v-16h-749.714l-36.572 16z",
						"M1024 248v-16h-530.286l-36.572 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flip-vertical",
						"mirror",
						"dualtone"
					],
					"defaultCode": 60078,
					"grid": 16
				},
				{
					"id": 2246,
					"paths": [
						"M694.628 118.628c9.152-9.154 11.886-22.918 6.936-34.874-4.952-11.958-16.622-19.754-29.564-19.754h-640c-12.944 0-24.612 7.796-29.564 19.754-1.642 3.96-2.436 8.116-2.436 12.24 0 8.328 3.252 16.512 9.374 22.634l320 320c12.496 12.496 32.758 12.496 45.254 0l320-320z",
						"M576 544c0-17.672 14.328-32 32-32h64c17.672 0 32 14.328 32 32 0 17.674-14.328 32-32 32h-64c-17.672 0-32-14.326-32-32z",
						"M384 544c0-17.672 14.326-32 32-32h64c17.674 0 32 14.328 32 32 0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32z",
						"M192 544c0-17.672 14.326-32 32-32h64c17.674 0 32 14.328 32 32 0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.328-32-32z",
						"M0 544c0-17.672 14.326-32 32-32h64c17.674 0 32 14.328 32 32s-14.326 32-32 32h-64c-17.674 0-32-14.328-32-32z",
						"M701.566 1004.246c1.64-3.96 2.436-8.118 2.436-12.238 0-8.328-3.252-16.514-9.374-22.636l-320-320c-12.496-12.496-32.758-12.496-45.254 0l-320.002 320c-9.152 9.156-11.888 22.918-6.936 34.876s16.622 19.752 29.566 19.752h640c12.944 0 24.612-7.796 29.564-19.754zM128.57 952l223.432-223.432 223.432 223.432h-446.864z",
						"M831.994 799.994c80.456-60.372 128.006-154.8 128.006-255.994 0-107.016-53.158-206.49-142.2-266.092-14.686-9.832-34.562-5.896-44.39 8.792-9.836 14.69-5.894 34.564 8.79 44.392 71.258 47.698 113.8 127.29 113.8 212.908 0 84.008-40.978 162.196-109.834 210.166l-82.166-82.166v224h224l-96.006-96.006z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flip-vertical",
						"mirror"
					],
					"defaultCode": 60081,
					"grid": 16
				},
				{
					"id": 2247,
					"paths": [
						"M54.628 329.372c-9.154-9.154-22.918-11.888-34.874-6.936-11.958 4.952-19.754 16.622-19.754 29.564v640c0 12.944 7.796 24.612 19.754 29.564 3.96 1.64 8.116 2.436 12.24 2.436 8.328 0 16.512-3.252 22.634-9.374l320-320c12.496-12.496 12.496-32.758 0-45.254l-320-320z",
						"M480 448c-17.672 0-32-14.328-32-32v-64c0-17.672 14.328-32 32-32s32 14.328 32 32v64c0 17.672-14.328 32-32 32z",
						"M480 640c-17.672 0-32-14.326-32-32v-64c0-17.674 14.328-32 32-32s32 14.326 32 32v64c0 17.674-14.328 32-32 32z",
						"M480 832c-17.672 0-32-14.326-32-32v-64c0-17.674 14.328-32 32-32s32 14.326 32 32v64c0 17.674-14.328 32-32 32z",
						"M480 1024c-17.672 0-32-14.326-32-32v-64c0-17.674 14.328-32 32-32s32 14.326 32 32v64c0 17.674-14.328 32-32 32z",
						"M940.246 322.434c-3.96-1.64-8.118-2.436-12.238-2.436-8.328 0-16.514 3.252-22.636 9.374l-320 320c-12.496 12.496-12.496 32.758 0 45.254l320 320.002c9.156 9.152 22.918 11.888 34.876 6.936s19.752-16.622 19.752-29.566v-640c0-12.944-7.796-24.612-19.754-29.564zM888 895.43l-223.432-223.432 223.432-223.43v446.862z",
						"M735.994 192.006c-60.372-80.454-154.8-128.006-255.994-128.006-107.016 0-206.49 53.158-266.092 142.198-9.832 14.686-5.896 34.562 8.792 44.392 14.69 9.834 34.564 5.894 44.392-8.792 47.698-71.256 127.29-113.798 212.908-113.798 84.008 0 162.196 40.978 210.166 109.834l-82.166 82.166h224v-224l-96.006 96.006z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flip-vertical",
						"mirror"
					],
					"defaultCode": 60082,
					"grid": 16
				},
				{
					"id": 512,
					"width": 1024,
					"paths": [
						"M238.848 718.848c-29.984-29.984-46.848-70.688-46.848-113.12v-91.456c0-42.432 16.864-83.136 46.848-113.152l49.152-49.12v144c0 8.832 7.168 16 16 16s16-7.168 16-16v-182.976c16.928-15.456 39.232-25.024 64-25.024h32v80c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-26.496 21.504-48 48-48s48 21.504 48 48v320c0 8.832 7.168 16 16 16s16-7.168 16-16v-80h96v80c0 8.832 7.168 16 16 16s16-7.168 16-16v-80h32c53.024 0 96 42.976 96 96v253.728c0 42.432-16.864 83.136-46.848 113.152l-17.152 17.12h-480l-49.152-49.152zM768 800h-480c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h480c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flip",
						"provoke",
						"offend",
						"anger",
						"antagonize"
					],
					"grid": 32
				},
				{
					"id": 513,
					"width": 1024,
					"paths": [
						"M896 384c0-212.064-171.936-384-384-384s-384 171.936-384 384c0 154.912 91.904 288.064 224 348.768v195.232c0 53.024 42.976 96 96 96h128c53.024 0 96-42.976 96-96v-195.232c132.096-60.704 224-193.856 224-348.768zM639.68 56.32c-29.344 23.808-75.84 39.68-127.68 39.68s-98.336-15.872-127.68-39.68c39.648-15.488 82.624-24.32 127.68-24.32s88.032 8.832 127.68 24.32zM480 832v-96h64v96h-64zM462.432 704c-42.72-54.368-78.432-173.568-78.432-320 0-110.112 20.352-204.352 48.512-267.744 24.256 7.392 51.040 11.744 79.488 11.744s55.232-4.352 79.488-11.744c28.16 63.392 48.512 157.632 48.512 267.744 0 146.432-35.712 265.632-78.432 320h-99.136zM160 384c0-136.704 78.496-255.168 192.64-313.44 13.408 13.44 30.080 25.312 49.888 34.528-30.976 69.984-50.528 168.736-50.528 278.912 0 134.080 28.864 251.328 72.224 320h-58.656c-125.088-57.312-205.568-182.208-205.568-320zM384 736h64v96h-64v-96zM640 928c0 35.296-28.704 64-64 64h-128c-35.296 0-64-28.704-64-64v-64h256v64zM576 832v-96h64v96h-64zM658.432 704h-58.656c43.36-68.672 72.224-185.92 72.224-320 0-110.176-19.552-208.928-50.528-278.912 19.84-9.216 36.512-21.088 49.888-34.528 114.144 58.272 192.64 176.736 192.64 313.44 0 137.792-80.48 262.688-205.568 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"float",
						"fly",
						"heat",
						"hover"
					],
					"grid": 32
				},
				{
					"id": 514,
					"width": 1024,
					"paths": [
						"M690.496 44.16c-20.384 19.84-43.648 36.736-69.696 48.992 32.544 73.28 51.2 175.52 51.2 280.544 0 131.264-29.216 256.288-75.296 325.92-5.12 7.712-15.84 9.248-23.104 3.52v0c-6.624-5.184-8-14.528-3.328-21.536 42.656-64.224 69.728-182.464 69.728-307.904 0-100.544-18.272-199.648-48.96-268.96-24.928 8.16-51.36 12.96-79.040 12.96-27.584 0-53.984-4.768-78.848-12.896-30.496 69.28-49.152 168.736-49.152 268.896 0 125.44 27.072 243.68 69.728 307.936 4.64 7.008 3.264 16.352-3.328 21.536v0c-7.296 5.728-18.016 4.192-23.104-3.52-46.080-69.664-75.296-194.688-75.296-325.952 0-105.024 18.656-207.264 51.2-280.544-26.048-12.256-49.28-29.184-69.632-49.024-122.144 64.288-205.568 192.256-205.568 339.872 0 154.912 91.904 288.064 224 348.768v195.232c0 53.024 42.976 96 96 96h128c53.024 0 96-42.976 96-96v-195.232c132.096-60.704 224-193.856 224-348.768 0-147.616-83.392-275.584-205.504-339.84zM448 832h-64v-96h64v96zM544 832h-64v-96h64v96zM640 832h-64v-96h64v96zM512 85.696c-56.672 0-108.32-21.312-147.808-56.128 45.504-19.008 95.424-29.568 147.808-29.568s102.304 10.56 147.808 29.568c-39.488 34.816-91.136 56.128-147.808 56.128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"float",
						"fly",
						"heat",
						"hover"
					],
					"grid": 32
				},
				{
					"id": 1028,
					"width": 1024,
					"paths": [
						"M991.776 141.184c-7.872 0-15.872 2.912-22.4 9.44l-60.8 60.8c-93.152-70.912-235.008-115.424-396.576-115.424-287.104 0-512 140.576-512 320 0 127.808 114.4 235.584 283.808 287.2l36.192 72.352v120.448c0 17.696 14.336 32 32 32h320c17.664 0 32-14.304 32-32v-120.448l36.192-72.352c65.408-19.936 122.88-47.968 168.416-82.624l60.8 60.8c6.528 6.528 14.528 9.44 22.4 9.44 16.448 0 32.224-12.768 32.224-32.064v-485.504c-0.032-19.296-15.808-32.064-32.256-32.064zM512 672c-191.872 0-359.744-73.28-421.984-172.448 92.32 46.144 246.752 76.448 421.984 76.448 175.072 0 329.536-30.208 421.856-76.288-62.304 99.072-230.112 172.288-421.856 172.288zM512 160c157.248 0 298.272 49.312 378.464 121.632-93.664-35.36-228.416-57.632-378.464-57.632-150.208 0-284.96 22.368-378.624 57.792 80.128-72.416 221.28-121.792 378.624-121.792zM512 256c202.24 0 351.232 38.816 425.952 82.528 8.448 14.656 14.368 29.888 17.952 45.472h-887.808c3.584-15.584 9.504-30.784 17.952-45.472 74.72-43.712 223.712-82.528 425.952-82.528zM64 416h896c0 11.616-1.92 22.976-4.704 34.208-67.2 48.096-223.84 93.792-443.296 93.792s-376.096-45.696-443.296-93.792c-2.784-11.232-4.704-22.592-4.704-34.208zM960 250.496v62.784c-7.84-12.288-16.64-24.288-27.072-35.68l27.072-27.104zM346.848 686.112c51.552 11.36 107.008 17.888 165.152 17.888s113.6-6.528 165.152-17.888l-24.928 49.888h-280.448l-24.928-49.888zM640 864h-256v-96h256v96zM932.928 554.4c10.432-11.424 19.264-23.392 27.072-35.68v62.752l-27.072-27.072z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"float",
						"fly",
						"hover"
					],
					"grid": 32
				},
				{
					"id": 2206,
					"paths": [
						"M864 0h-832c-17.6 0-32 14.4-32 32v960c0 17.6 14.4 32 32 32h960c17.6 0 32-14.4 32-32v-832l-160-160zM256 32h512v256c0 17.6-14.4 32-32 32h-448c-17.6 0-32-14.4-32-32v-256zM896 992h-768v-416c0-35.348 28.654-64 64-64h640c35.346 0 64 28.652 64 64v416z",
						"M576 64h128v192h-128v-192z",
						"M256 576h512v64h-512v-64z",
						"M256 704h512v64h-512v-64z",
						"M256 832h512v64h-512v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"floppy-disk",
						"save"
					],
					"defaultCode": 60041,
					"grid": 16
				},
				{
					"id": 2209,
					"paths": [
						"M896 0h-896v1024h1024v-896l-128-128zM512 128h128v256h-128v-256zM896 896h-768v-768h64v320h576v-320h74.978l53.022 53.018v714.982z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"floppy-disk",
						"save"
					],
					"defaultCode": 60044,
					"grid": 16
				},
				{
					"id": 2210,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z",
						"M512 352h64v128h-64v-128z",
						"M672 256h-384c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h448c17.6 0 32-14.4 32-32v-384l-96-96zM384 320h256v192h-256v-192zM704 704h-384v-64h384v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"floppy-disk",
						"save"
					],
					"defaultCode": 60045,
					"grid": 16
				},
				{
					"id": 2207,
					"paths": [
						"M704 384h64v128h-64v-128z",
						"M864 320h-160v-160l-160-160h-512c-17.6 0-32 14.4-32 32v640c0 17.6 14.4 32 32 32h288v288c0 17.6 14.4 32 32 32h640c17.6 0 32-14.4 32-32v-512l-160-160zM832 352v192c0 17.6-14.4 32-32 32h-256c-17.6 0-32-14.4-32-32v-192h320zM320 640h-192v-160c0-17.672 14.328-32 32-32h160v192zM224 256c-17.6 0-32-14.4-32-32v-192h320v192c0 17.6-14.4 32-32 32h-256zM896 960h-448v-160c0-17.674 14.328-32 32-32h384c17.674 0 32 14.326 32 32v160z",
						"M384 64h64v128h-64v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"floppy-disks",
						"save",
						"save-all"
					],
					"defaultCode": 60042,
					"grid": 16
				},
				{
					"id": 2208,
					"paths": [
						"M704 384h64v128h-64v-128z",
						"M864 320h-160v-160l-160-160h-512c-17.6 0-32 14.4-32 32v640c0 17.6 14.4 32 32 32h288v288c0 17.6 14.4 32 32 32h640c17.6 0 32-14.4 32-32v-512l-160-160zM480 768h384c8.104 0 15.48 3.036 21.118 8h-426.236c5.638-4.964 13.016-8 21.118-8zM448 960v-8h448v8h-448zM448 936v-16h448v16h-448zM448 904v-16h448v16h-448zM448 872v-16h448v16h-448zM448 840v-16h448v16h-448zM448 808v-8c0-2.768 0.388-5.44 1.048-8h445.902c0.66 2.56 1.048 5.232 1.048 8v8h-447.998zM832 352v192c0 17.6-14.4 32-32 32h-256c-17.6 0-32-14.4-32-32v-192h320zM320 456h-181.118c5.638-4.964 13.014-8 21.118-8h160v8zM128 640v-8h192v8h-192zM128 616v-16h192v16h-192zM128 584v-16h192v16h-192zM128 552v-16h192v16h-192zM128 520v-16h192v16h-192zM128 488v-8c0-2.768 0.388-5.438 1.048-8h190.952v16h-192zM224 256c-17.6 0-32-14.4-32-32v-192h320v192c0 17.6-14.4 32-32 32h-256z",
						"M384 64h64v128h-64v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"floppy-disks",
						"save",
						"save-all"
					],
					"defaultCode": 60043,
					"grid": 16
				},
				{
					"id": 1354,
					"width": 877.7160568237305,
					"paths": [
						"M219.429 877.714h438.857v-219.429h-438.857v219.429zM731.429 877.714h73.143v-512q0-8-5.714-22t-11.429-19.714l-160.571-160.571q-5.714-5.714-19.429-11.429t-22.286-5.714v237.714q0 22.857-16 38.857t-38.857 16h-329.143q-22.857 0-38.857-16t-16-38.857v-237.714h-73.143v731.429h73.143v-237.714q0-22.857 16-38.857t38.857-16h475.429q22.857 0 38.857 16t16 38.857v237.714zM512 347.429v-182.857q0-7.429-5.429-12.857t-12.857-5.429h-109.714q-7.429 0-12.857 5.429t-5.429 12.857v182.857q0 7.429 5.429 12.857t12.857 5.429h109.714q7.429 0 12.857-5.429t5.429-12.857zM877.714 365.714v530.286q0 22.857-16 38.857t-38.857 16h-768q-22.857 0-38.857-16t-16-38.857v-768q0-22.857 16-38.857t38.857-16h530.286q22.857 0 50.286 11.429t43.429 27.429l160 160q16 16 27.429 43.429t11.429 50.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"floppy-o",
						"save"
					],
					"defaultCode": 61639,
					"grid": 14
				},
				{
					"id": 515,
					"width": 1024,
					"paths": [
						"M928 672h-96v-109.664c0-26.464-21.536-48-48-48h-26.848c-2.848-6.080-7.488-11.488-14.4-14.944l-187.84-93.92c-8.576-4.288-17.696-6.72-26.944-8.288v-45.184h112.032c53.024 0 96-42.976 96-96v-32c0-53.024-42.976-96-96-96h-256c-53.024 0-96 42.976-96 96v32c0 53.024 42.976 96 96 96h112v45.184c-9.248 1.568-18.336 4-26.944 8.288l-187.84 93.92c-6.912 3.456-11.52 8.864-14.4 14.944h-26.816c-26.464 0-48 21.536-48 48v109.664h-96c-53.024 0-96 42.976-96 96v32c0 53.024 42.976 96 96 96h224c53.024 0 96-42.976 96-96v-32c0-53.024-42.976-96-96-96h-96v-109.664c0-8.832 7.2-16 16-16h29.568c2.88 4.096 6.624 7.776 11.68 10.304l187.84 93.92c13.504 6.752 28.224 10.144 42.944 10.144s29.408-3.392 42.944-10.144l187.84-93.92c5.056-2.528 8.8-6.176 11.68-10.304h29.504c8.8 0 16 7.168 16 16v109.664h-96c-53.024 0-96 42.976-96 96v32c0 53.024 42.976 96 96 96h224c53.024 0 96-42.976 96-96v-32c0-53.024-42.976-96-96-96zM320 256v-32c0-35.296 28.704-64 64-64h256c35.296 0 64 28.704 64 64v32c0 35.296-28.704 64-64 64h-256c-35.296 0-64-28.704-64-64zM384 768v32c0 35.296-28.704 64-64 64h-224c-35.296 0-64-28.704-64-64v-32c0-35.296 28.704-64 64-64h224c35.296 0 64 28.704 64 64zM540.608 621.92c-8.832 4.416-18.752 6.752-28.608 6.752-9.888 0-19.776-2.336-28.608-6.752l-187.84-93.92 187.84-93.92c8.832-4.416 18.752-6.752 28.608-6.752s19.776 2.336 28.608 6.752l187.84 93.92-187.84 93.92zM992 800c0 35.296-28.704 64-64 64h-224c-35.296 0-64-28.704-64-64v-32c0-35.296 28.704-64 64-64h224c35.296 0 64 28.704 64 64v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flow",
						"chart",
						"work",
						"diagram"
					],
					"grid": 32
				},
				{
					"id": 516,
					"width": 1024,
					"paths": [
						"M928 672h-96v-109.664c0-26.464-21.536-48-48-48h-26.848c-2.848-6.080-7.488-11.488-14.4-14.944l-187.84-93.92c-8.576-4.288-17.696-6.72-26.944-8.288v-45.184h112.032c53.024 0 96-42.976 96-96v-32c0-53.024-42.976-96-96-96h-256c-53.024 0-96 42.976-96 96v32c0 53.024 42.976 96 96 96h112v45.184c-9.248 1.568-18.336 4-26.944 8.288l-187.84 93.92c-6.912 3.456-11.52 8.864-14.4 14.944h-26.816c-26.464 0-48 21.536-48 48v109.664h-96c-53.024 0-96 42.976-96 96v32c0 53.024 42.976 96 96 96h224c53.024 0 96-42.976 96-96v-32c0-53.024-42.976-96-96-96h-96v-109.664c0-8.832 7.2-16 16-16h29.568c2.88 4.096 6.624 7.776 11.68 10.304l187.84 93.92c13.504 6.752 28.224 10.144 42.944 10.144s29.408-3.392 42.944-10.144l187.84-93.92c5.056-2.528 8.8-6.176 11.68-10.304h29.504c8.8 0 16 7.168 16 16v109.664h-96c-53.024 0-96 42.976-96 96v32c0 53.024 42.976 96 96 96h224c53.024 0 96-42.976 96-96v-32c0-53.024-42.976-96-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flow",
						"chart",
						"work",
						"diagram"
					],
					"grid": 32
				},
				{
					"id": 1029,
					"width": 1024,
					"paths": [
						"M992 704h-160v-192h-148.96c-1.344-2.272-2.432-4.672-4.416-6.624l-144-144c-1.952-1.952-4.352-3.072-6.624-4.416v-36.96h176c17.696 0 32-14.336 32-32v-224c0-17.664-14.304-32-32-32h-384c-17.696 0-32 14.336-32 32v224c0 17.664 14.304 32 32 32h176v36.96c-2.272 1.344-4.672 2.432-6.624 4.416l-144 144c-1.952 1.952-3.072 4.352-4.416 6.624h-148.96v192h-160c-17.696 0-32 14.336-32 32v224c0 17.664 14.304 32 32 32h384c17.696 0 32-14.336 32-32v-224c0-17.664-14.304-32-32-32h-192v-160h116.96c1.344 2.272 2.432 4.672 4.416 6.624l144 144c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l144-144c1.952-1.952 3.072-4.352 4.416-6.624h116.96v160h-192c-17.696 0-32 14.336-32 32v224c0 17.664 14.304 32 32 32h384c17.696 0 32-14.336 32-32v-224c0-17.664-14.304-32-32-32zM352 256v-160h320v160h-320zM384 928h-320v-160h320v160zM512 626.752l-98.752-98.752 98.752-98.752 98.752 98.752-98.752 98.752zM960 928h-320v-160h320v160zM416 160h192v32h-192v-32zM320 864h-192v-32h192v32zM896 864h-192v-32h192v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flow",
						"choose",
						"experience",
						"decide"
					],
					"grid": 32
				},
				{
					"id": 2544,
					"paths": [
						"M1011.294 377.728c-53.416-164.37-215.548-180.974-340.692-56.080 80.124-157.602 14.21-306.674-158.61-306.674s-238.714 149.070-158.62 306.666c-125.13-124.884-287.262-108.272-340.664 56.088-53.402 164.366 67.996 273.104 242.636 245.622-157.438 80.418-191.744 239.748-51.924 341.332 139.802 101.58 280.736 19.718 308.57-154.866 27.834 174.584 168.768 256.45 308.586 154.866 139.806-101.584 105.502-260.912-51.938-341.332 174.644 27.484 296.060-81.256 242.656-245.622zM511.992 685.902c-81.752 0-148.012-66.27-148.012-148.020 0-81.754 66.26-148.022 148.012-148.022 81.75 0 148.030 66.27 148.030 148.022 0 81.75-66.28 148.020-148.030 148.020z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flower",
						"nature",
						"plant",
						"green"
					],
					"defaultCode": 60379,
					"grid": 16
				},
				{
					"id": 2545,
					"paths": [
						"M686.302 1007.96c-50.636 0-98.794-21.344-135.604-60.102-14.998-15.792-27.96-34.15-38.704-54.672-10.744 20.522-23.708 38.882-38.706 54.674-36.806 38.756-84.964 60.098-135.604 60.098-44.568 0-90.814-16.414-133.734-47.466-62.548-45.248-94.098-107.302-88.834-174.734 4.096-52.504 29.852-103.010 72.216-144.938-65.638-9.616-119.9-39.292-152.81-84.65-35.398-48.784-42.866-112.508-21.028-179.434 29.246-89.622 91.028-141.024 169.504-141.024 35.52 0 72.708 10.63 109.306 30.79-6.596-54.214 3.566-106.948 30.506-150.948 38.724-63.244 107.68-99.514 189.184-99.514 81.52 0 150.484 36.28 189.212 99.54 26.936 43.996 37.096 96.712 30.498 150.916 36.596-20.156 73.786-30.788 109.298-30.788 78.47 0 140.254 51.402 169.504 141.028 21.844 66.938 14.376 130.668-21.026 179.454-32.908 45.352-87.18 75.024-152.812 84.636 42.354 41.924 68.11 92.428 72.208 144.926 5.264 67.432-26.284 129.49-88.83 174.742-42.926 31.052-89.174 47.466-133.744 47.466zM511.992 758.004c15.72 0 29.112 11.418 31.598 26.942 15.466 96.598 71.484 159.016 142.71 159.016 31.458 0 63.834-11.882 96.232-35.322 44.424-32.14 66.050-72.912 62.54-117.908-4.582-58.68-51.934-117.768-123.58-154.208-14.026-7.134-20.784-23.404-15.938-38.376s19.858-24.184 35.398-21.764c16.22 2.542 32.362 3.832 47.974 3.834 0.004 0 0.018 0 0.022 0 66.114 0 120.316-22.458 148.734-61.62 23.376-32.212 27.518-74.402 11.982-122.010-14.424-44.196-44.986-96.882-108.662-96.882-45.112 0-98.488 27.334-146.448 74.992-11.156 11.084-28.71 12.422-41.418 3.152-12.704-9.268-16.792-26.396-9.638-40.402 33.742-66.084 34.91-136.536 3.124-188.452-27.222-44.468-75.034-68.956-134.628-68.956-59.58 0-107.382 24.482-134.602 68.936-31.792 51.918-30.628 122.376 3.11 188.478 7.15 14.006 3.062 31.132-9.644 40.4s-30.26 7.928-41.416-3.154c-47.954-47.654-101.332-74.986-146.446-74.986-63.682 0-94.24 52.682-108.662 96.876-15.532 47.598-11.386 89.784 11.986 121.996 28.42 39.17 82.64 61.632 148.756 61.632 15.604 0 31.742-1.29 47.968-3.832 15.542-2.422 30.554 6.792 35.4 21.764 4.844 14.97-1.914 31.24-15.938 38.376-71.652 36.442-119.006 95.534-123.586 154.214-3.512 44.992 18.116 85.762 62.542 117.9 31.938 23.108 65.21 35.32 96.222 35.32 71.226 0 127.242-62.416 142.71-159.014 2.486-15.524 15.878-26.942 31.598-26.942z",
						"M511.992 685.902c-81.614 0-148.012-66.4-148.012-148.020s66.398-148.022 148.012-148.022c81.624 0 148.030 66.402 148.030 148.022s-66.406 148.020-148.030 148.020zM511.992 453.86c-46.324 0-84.012 37.692-84.012 84.022 0 46.328 37.688 84.020 84.012 84.020 46.334 0 84.030-37.692 84.030-84.020 0-46.33-37.696-84.022-84.030-84.022z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"flower",
						"nature",
						"plant"
					],
					"defaultCode": 60380,
					"grid": 16
				},
				{
					"id": 517,
					"width": 1024,
					"paths": [
						"M1024 608v-137.792c0-31.296-22.624-57.984-53.472-63.136l-299.552-49.92 1.024-5.152v-128c0-38.464-17.312-72.544-44.16-96h124.16c26.496 0 48-21.504 48-48s-21.504-48-48-48l-208 32c0-17.664-14.336-32-32-32s-32 14.336-32 32l-208-32c-26.496 0-48 21.504-48 48s21.504 48 48 48h124.16c-26.848 23.456-44.16 57.536-44.16 96v128l1.024 5.152-299.552 49.92c-30.848 5.152-53.472 31.872-53.472 63.136v137.792c0 35.36 28.64 64 64 64h352l33.984 169.984-131.648 43.872c-16.768 5.6-25.824 23.712-20.224 40.48l14.592 43.776c4.352 13.088 16.576 21.888 30.368 21.888h337.856c13.76 0 26.016-8.8 30.368-21.888l14.592-43.776c5.6-16.768-3.488-34.88-20.224-40.48l-131.648-43.872 33.984-169.984h352c35.36 0 64-28.64 64-64zM960 640h-344.96l50.272-251.328 299.968 49.984c15.424 2.56 26.72 15.904 26.72 31.552v137.792c0 17.664-14.336 32-32 32zM32 608v-137.792c0-15.648 11.296-28.992 26.752-31.552l299.968-49.984 50.24 251.328h-344.96c-17.664 0-32-14.336-32-32zM343.072 960l-14.592-43.776 127.264-42.432 17.216 86.208h-129.888zM680.928 960h-129.888l17.248-86.176 127.264 42.432-14.624 43.744zM753.792 64.096c7.968 0.896 14.208 7.68 14.208 15.904 0 8.832-7.168 16-16 16h-176v-4.544l177.792-27.36zM256 80c0-8.224 6.24-15.008 14.208-15.904l177.792 27.36v4.544h-176c-8.832 0-16-7.168-16-16zM506.24 960l-122.24-611.168v-124.832c0-52.928 43.072-96 96-96h64c52.928 0 96 43.072 96 96v124.832l-122.24 611.168h-11.52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fly",
						"travel",
						"glide"
					],
					"grid": 32
				},
				{
					"id": 518,
					"width": 1024,
					"paths": [
						"M447.392 992h-104.32c-13.76 0-26.016-8.8-30.368-21.888l-14.592-43.776c-5.6-16.768 3.488-34.88 20.224-40.48l101.088-33.696 27.968 139.84zM321.472 362.432l-268 44.672c-30.848 5.12-53.472 31.84-53.472 63.104v137.792c0 35.36 28.64 64 64 64h319.392l-61.92-309.568zM272 128h124.16c-26.848 23.456-44.16 57.536-44.16 96v127.904l128.032 640.096h63.776l128.192-640.832v-127.168c0-38.464-17.312-72.544-44.16-96h124.16c26.496 0 48-21.504 48-48s-21.504-48-48-48l-208 32c0-17.664-14.336-32-32-32s-32 14.336-32 32l-208-32c-26.496 0-48 21.504-48 48s21.504 48 48 48zM970.528 407.072l-268.128-44.672-61.952 309.6h319.552c35.36 0 64-28.64 64-64v-137.792c0-31.264-22.624-57.984-53.472-63.136zM705.632 885.888l-101.216-33.728-27.968 139.84h104.48c13.76 0 26.016-8.8 30.368-21.888l14.592-43.776c5.568-16.736-3.488-34.88-20.256-40.448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fly",
						"travel",
						"glide"
					],
					"grid": 32
				},
				{
					"id": 1030,
					"width": 1024,
					"paths": [
						"M1004.608 482.592l-44.608-19.136v-79.456c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v-64c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v6.336l-32-13.728v-69.216c0-81.824-24-161.056-69.376-229.12-5.92-8.928-15.936-14.272-26.624-14.272s-20.704 5.344-26.624 14.24c-45.376 68.096-69.376 147.328-69.376 229.152v69.248l-64 27.424v-20.064c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32h-96c-17.664 0-32 14.336-32 32v79.456l-44.608 19.104c-11.776 5.056-19.392 16.64-19.392 29.44v160c0 9.28 4.032 18.080 11.040 24.16 5.856 5.088 13.312 7.84 20.96 7.84 1.504 0 3.008-0.096 4.512-0.32l379.488-54.208v105.28l-118.624 118.624c-6.016 5.984-9.376 14.144-9.376 22.624v96c0 10.624 5.28 20.544 14.048 26.496 5.376 3.648 11.648 5.504 17.952 5.504 4 0 8.032-0.768 11.872-2.304l148.128-59.232v29.536c0 17.664 14.304 32 32 32s32-14.336 32-32v-29.536l148.128 59.232c3.808 1.536 7.84 2.304 11.872 2.304 6.304 0 12.576-1.856 17.952-5.504 8.768-5.952 14.048-15.872 14.048-26.496v-96c0-8.48-3.36-16.64-9.376-22.624l-118.624-118.624v-105.28l379.488 54.208c1.504 0.224 3.008 0.32 4.512 0.32 7.648 0 15.104-2.752 20.96-7.84 7.008-6.080 11.040-14.88 11.040-24.16v-160c0-12.8-7.616-24.384-19.392-29.408zM672 944.736l-96-38.4v-93.088l96 96v35.488zM544 896h-64v-652.608c0-50.816 10.944-100.48 32-146.080 21.056 45.6 32 95.232 32 146.080v652.608zM352 909.248l96-96v93.088l-96 38.4v-35.488zM160 416v41.152l-32 13.728v-54.88h32zM64 533.088l384-164.576v211.712l-384 54.88v-102.016zM256 352h32v50.272l-32 13.728v-64zM736 352v50.272l-32-13.728v-36.544h32zM576 368.544l384 164.576v102.016l-384-54.848v-211.744zM896 416v54.848l-32-13.728v-41.12h32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fly",
						"travel",
						"glide",
						"explore"
					],
					"grid": 32
				},
				{
					"id": 519,
					"width": 1024,
					"paths": [
						"M512 64c-7.712 0-15.424 0.192-23.2 0.544-258.176 12.16-456.8 234.56-456.8 493.024v114.432c0 35.36 28.64 64 64 64h4.224c12.576 83.040 55.392 128 155.776 128 0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-384c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32-62.144 0-102.208 17.248-126.688 50.080 13.216-199.744 173.056-366.304 375.488-370.016 2.4-0.032 4.832-0.064 7.2-0.064 207.712 0 376.448 165.024 383.36 371.072-24.448-33.44-64.64-51.072-127.36-51.072 0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v384c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32 100.384 0 143.2-44.96 155.776-128h4.224c35.36 0 64-28.64 64-64v-128c0-265.088-214.912-480-480-480zM288 480h32v384h-32v-384zM736 864h-32v-384h32v384zM256 512v320c-95.712 0-128-40.384-128-160s32.288-160 128-160zM768 832v-320c95.712 0 128 40.384 128 160s-32.288 160-128 160zM960 672c0 17.632-14.368 32-32 32v-160c0-229.376-186.624-416-416-416l-7.776 0.064c-225.088 4.128-408.224 196.416-408.224 428.672v147.264c-17.632 0-32-14.368-32-32v-114.432c0-247.296 187.264-449.792 426.304-461.056 7.296-0.352 14.496-0.512 21.696-0.512 247.040 0 448 200.96 448 448v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"focus",
						"hear",
						"listen",
						"code"
					],
					"grid": 32
				},
				{
					"id": 520,
					"width": 1024,
					"paths": [
						"M352 480v384c0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32v-384c0-17.664 14.336-32 32-32h32c17.664 0 32 14.336 32 32zM736 448h-32c-17.664 0-32 14.336-32 32v384c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-384c0-17.664-14.336-32-32-32zM512 64c-265.088 0-480 214.912-480 480v128c0 35.36 28.64 64 64 64h4.224c11.136 73.536 46.208 117.056 123.776 126.080v-380.128c-44.672 5.216-75.392 21.792-95.36 49.088h-32c6.912-223.68 189.984-403.040 415.36-403.040s408.448 179.36 415.36 403.072h-32c-19.968-27.296-50.688-43.872-95.36-49.088v380.096c77.568-9.024 112.64-52.544 123.776-126.080h4.224c35.36 0 64-28.64 64-64v-128c0-265.088-214.912-480-480-480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"focus",
						"hear",
						"listen",
						"code"
					],
					"grid": 32
				},
				{
					"id": 521,
					"width": 1024,
					"paths": [
						"M864 512l-329.376-329.376c-12.512-12.512-32.768-12.512-45.248 0l-329.376 329.376h-108.224c-23.776 0-39.264 25.024-28.608 46.304l160 320c5.408 10.848 16.48 17.696 28.608 17.696h600.448c12.128 0 23.2-6.848 28.608-17.696l160-320c10.656-21.28-4.832-46.304-28.608-46.304h-108.224zM818.752 512h-218.752l-72.928-291.648 291.68 291.648zM567.008 512h-110.016l55.008-220.064 55.008 220.064zM496.928 220.352l-72.928 291.648h-218.752l291.68-291.648zM211.776 864l-160-320h433.152l-270.784 320h-2.368zM256.064 864l255.936-302.464 255.936 302.464h-511.872zM812.224 864h-2.368l-270.784-320h433.152l-160 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fold",
						"float"
					],
					"grid": 32
				},
				{
					"id": 522,
					"width": 1024,
					"paths": [
						"M192 480l297.376-297.376c12.512-12.512 32.768-12.512 45.248 0l297.376 297.376h-241.024l-63.456-256.96c-1.76-7.136-8.16-12.16-15.488-12.16h-0.032c-7.328 0-13.728 4.992-15.52 12.096l-64.512 257.024h-239.968zM464.992 480h93.056l-46.144-186.88-46.912 186.88zM1000.832 558.304l-160 320c-5.408 10.848-16.48 17.696-28.608 17.696h-600.448c-12.128 0-23.2-6.848-28.608-17.696l-160-320c-10.656-21.28 4.832-46.304 28.608-46.304h920.448c23.776 0 39.264 25.024 28.608 46.304zM787.616 837.6l-251.232-297.216c-12.192-14.368-36.608-14.4-48.832 0.032l-251.328 297.248c-5.728 6.752-4.864 16.832 1.888 22.56 3.008 2.528 6.656 3.776 10.336 3.776 4.544 0 9.056-1.92 12.224-5.664l251.328-297.248 251.2 297.184c5.76 6.784 15.776 7.616 22.56 1.888 6.72-5.696 7.584-15.808 1.856-22.56z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fold",
						"float"
					],
					"grid": 32
				},
				{
					"id": 1031,
					"width": 1024,
					"paths": [
						"M1018.048 461.408c-6.88-9.632-18.464-14.624-30.272-13.12l-226.432 30.176-224.576-274.72c-6.080-7.424-15.168-11.744-24.768-11.744v0c-9.6 0-18.688 4.32-24.768 11.776l-224.192 274.752-226.752-30.24c-11.776-1.504-23.392 3.488-30.272 13.12-6.88 9.664-7.872 22.304-2.592 32.896l160 320c5.376 10.848 16.448 17.696 28.576 17.696h640c12.128 0 23.2-6.848 28.64-17.696l160-320c5.28-10.592 4.288-23.232-2.592-32.896zM936.384 519.712l-123.648 247.296-276.96-193.856 400.608-53.44zM488.224 573.12l-276.96 193.856-123.648-247.296 400.608 53.44zM512 595.52l246.4 172.48h-492.8l246.4-172.48zM512 544l-46.432-6.208 46.432-232.224 46.432 232.224-46.432 6.208zM433.76 533.568l-120.032-16 163.232-200.032-43.2 216.032zM590.24 533.568l-43.232-216.192 163.616 200.128-120.384 16.064z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fold",
						"float"
					],
					"grid": 32
				},
				{
					"id": 2021,
					"paths": [
						"M0 320h1024l-64 640h-896l-64-640zM928 192l32 64h-896l64-128h352l32 64h416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder",
						"directory",
						"category",
						"browse"
					],
					"defaultCode": 59856,
					"grid": 16
				},
				{
					"id": 2029,
					"paths": [
						"M960 256h-896l64-128h352l32 64h416zM0 320l64 640h896l64-640h-1024zM430 854.51l-205.254-237.254 58.508-58.51 146.746 114.744 274.744-242.744 58.512 58.508-333.256 365.256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-check",
						"directory",
						"folder-tick"
					],
					"defaultCode": 59864,
					"grid": 16
				},
				{
					"id": 2023,
					"paths": [
						"M960 256h-896l64-128h352l32 64h416zM0 320l64 640h896l64-640h-1024zM512 928l-288-288h224v-191.016h128v191.016h224l-288 288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-download",
						"directory",
						"folder-save"
					],
					"defaultCode": 59858,
					"grid": 16
				},
				{
					"id": 2040,
					"paths": [
						"M576 256l-128-128h-448v832h1024v-704h-448zM512 864l-224-224h160v-256h128v256h160l-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-download",
						"directory",
						"folder-save"
					],
					"defaultCode": 59875,
					"grid": 16
				},
				{
					"id": 2042,
					"paths": [
						"M576 256l-128-128h-448v832h1024v-704h-448zM960 896h-896v-704h357.49l128 128h410.51v576zM576 640v-192h-128v192h-192l256 256 256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-download",
						"directory",
						"folder-save"
					],
					"defaultCode": 59877,
					"grid": 16
				},
				{
					"id": 2030,
					"paths": [
						"M928 192h-416l-32-64h-352l-64 128h896z",
						"M0 320l64 640h896l64-640h-1024zM736 671.636l-0.25 0.252c-4.79 5.65-223.75 224.112-223.75 224.112s-218.732-218.274-223.22-223.502l-0.362-0.362 0.036-0.016c-20.224-23.738-32.454-54.492-32.454-88.12 0-75.11 60.89-136 136-136 51.962 0 97.102 29.152 120 71.984 22.898-42.832 68.040-71.984 120-71.984 75.11 0 136 60.89 136 136 0 33.392-12.054 63.958-32.024 87.626l0.024 0.010z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-heart",
						"directory",
						"folder-favorites",
						"folder-love"
					],
					"defaultCode": 59865,
					"grid": 16
				},
				{
					"id": 2027,
					"paths": [
						"M960 256h-896l64-128h352l32 64h416zM500 800c0 58.784 17.008 113.662 46.342 160h-482.342l-64-640h1024l-25.526 255.248c-52.93-46.796-122.436-75.248-198.474-75.248-165.42 0-300 134.58-300 300zM800 576c-123.71 0-224 100.29-224 224s100.29 224 224 224 224-100.29 224-224-100.29-224-224-224zM640 832v-64h320v64h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-minus",
						"directory",
						"folder-remove"
					],
					"defaultCode": 59862,
					"grid": 16
				},
				{
					"id": 2028,
					"paths": [
						"M960 256h-896l64-128h352l32 64h416zM0 320l64 640h896l64-640h-1024zM704 704h-384v-128h384v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-minus",
						"directory",
						"folder-remove"
					],
					"defaultCode": 59863,
					"grid": 16
				},
				{
					"id": 2037,
					"paths": [
						"M576 256l-128-128h-448v832h1024v-704h-448zM704 704h-384v-128h384v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-minus",
						"directory",
						"folder-remove"
					],
					"defaultCode": 59872,
					"grid": 16
				},
				{
					"id": 2039,
					"paths": [
						"M576 256l-128-128h-448v832h1024v-704h-448zM960 896h-896v-704h357.49l128 128h410.51v576zM320 576h384v128h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-minus",
						"directory",
						"folder-remove"
					],
					"defaultCode": 59874,
					"grid": 16
				},
				{
					"id": 1426,
					"width": 950.8569946289062,
					"paths": [
						"M877.714 749.714v-402.286q0-22.857-16-38.857t-38.857-16h-402.286q-22.857 0-38.857-16t-16-38.857v-36.571q0-22.857-16-38.857t-38.857-16h-182.857q-22.857 0-38.857 16t-16 38.857v548.571q0 22.857 16 38.857t38.857 16h694.857q22.857 0 38.857-16t16-38.857zM950.857 347.429v402.286q0 52.571-37.714 90.286t-90.286 37.714h-694.857q-52.571 0-90.286-37.714t-37.714-90.286v-548.571q0-52.571 37.714-90.286t90.286-37.714h182.857q52.571 0 90.286 37.714t37.714 90.286v18.286h384q52.571 0 90.286 37.714t37.714 90.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-o"
					],
					"defaultCode": 61716,
					"grid": 14
				},
				{
					"id": 2033,
					"paths": [
						"M832 960l192-512h-832l-192 512zM128 384l-128 576v-832h288l128 128h416v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-open",
						"directory",
						"category",
						"browse"
					],
					"defaultCode": 59868,
					"grid": 16
				},
				{
					"id": 1427,
					"width": 1090.8561401367188,
					"paths": [
						"M1017.714 532q0-20-30.286-20h-621.714q-22.857 0-48.857 12.286t-40.857 30l-168 207.429q-10.286 13.714-10.286 22.857 0 20 30.286 20h621.714q22.857 0 49.143-12.571t40.571-30.286l168-207.429q10.286-12.571 10.286-22.286zM365.714 438.857h438.857v-91.429q0-22.857-16-38.857t-38.857-16h-329.143q-22.857 0-38.857-16t-16-38.857v-36.571q0-22.857-16-38.857t-38.857-16h-182.857q-22.857 0-38.857 16t-16 38.857v487.429l146.286-180q25.143-30.286 66.286-50t80-19.714zM1090.857 532q0 35.429-26.286 68.571l-168.571 207.429q-24.571 30.286-66.286 50t-80 19.714h-621.714q-52.571 0-90.286-37.714t-37.714-90.286v-548.571q0-52.571 37.714-90.286t90.286-37.714h182.857q52.571 0 90.286 37.714t37.714 90.286v18.286h310.857q52.571 0 90.286 37.714t37.714 90.286v91.429h109.714q30.857 0 56.571 14t38.286 40.286q8.571 18.286 8.571 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-open-o"
					],
					"defaultCode": 61717,
					"grid": 14
				},
				{
					"id": 2045,
					"paths": [
						"M984.5 384c26.4 0 43.764 21.18 38.586 47.068l-117.672 417.864c-5.178 25.888-31.014 47.068-57.414 47.068h-672c-26.4 0-52.236-21.18-57.414-47.068l-117.672-417.864c-5.178-25.888 12.186-47.068 38.586-47.068h945zM896 176v144h-768v-208c0-26.51 21.49-48 48-48h208l32 64h432c26.51 0 48 21.49 48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-open",
						"directory",
						"category",
						"browse"
					],
					"defaultCode": 59880,
					"grid": 16
				},
				{
					"id": 2047,
					"paths": [
						"M984.5 384h-88.5v-208c0-26.51-21.49-48-48-48h-432l-32-64h-208c-26.51 0-48 21.49-48 48v272h-88.5c-26.4 0-43.764 21.18-38.586 47.068l117.672 417.864c5.178 25.888 31.014 47.068 57.414 47.068h672c26.4 0 52.236-21.18 57.414-47.068l117.672-417.864c5.178-25.888-12.186-47.068-38.586-47.068zM192 128h152.446l32 64h455.554v192h-640v-256zM843.594 832h-663.188l-110.372-384h883.932l-110.372 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-open",
						"directory",
						"category",
						"browse"
					],
					"defaultCode": 59882,
					"grid": 16
				},
				{
					"id": 1296,
					"width": 1073.7129640579224,
					"paths": [
						"M1073.714 544q0 17.714-17.714 37.714l-192 226.286q-24.571 29.143-68.857 49.429t-82 20.286h-621.714q-19.429 0-34.571-7.429t-15.143-24.571q0-17.714 17.714-37.714l192-226.286q24.571-29.143 68.857-49.429t82-20.286h621.714q19.429 0 34.571 7.429t15.143 24.571zM877.714 347.429v91.429h-475.429q-53.714 0-112.571 27.143t-93.714 68.286l-195.429 229.714q0-2.286-0.286-7.143t-0.286-7.143v-548.571q0-52.571 37.714-90.286t90.286-37.714h182.857q52.571 0 90.286 37.714t37.714 90.286v18.286h310.857q52.571 0 90.286 37.714t37.714 90.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-open"
					],
					"defaultCode": 61564,
					"grid": 14
				},
				{
					"id": 2025,
					"paths": [
						"M960 256h-896l64-128h352l32 64h416zM500 800c0 58.784 17.008 113.662 46.342 160h-482.342l-64-640h1024l-25.526 255.248c-52.93-46.796-122.436-75.248-198.474-75.248-165.42 0-300 134.58-300 300zM800 576c-123.71 0-224 100.29-224 224s100.29 224 224 224 224-100.29 224-224-100.29-224-224-224zM832 832v128h-64v-128h-128v-64h128v-128h64v128h128v64h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-plus",
						"directory",
						"folder-add"
					],
					"defaultCode": 59860,
					"grid": 16
				},
				{
					"id": 2026,
					"paths": [
						"M960 256h-896l64-128h352l32 64h416zM0 320l64 640h896l64-640h-1024zM704 704h-128v128h-128v-128h-128v-128h128v-128h128v128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-plus",
						"directory",
						"folder-add"
					],
					"defaultCode": 59861,
					"grid": 16
				},
				{
					"id": 2036,
					"paths": [
						"M576 256l-128-128h-448v832h1024v-704h-448zM704 704h-128v128h-128v-128h-128v-128h128v-128h128v128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-plus",
						"directory",
						"folder-add"
					],
					"defaultCode": 59871,
					"grid": 16
				},
				{
					"id": 2038,
					"paths": [
						"M576 256l-128-128h-448v832h1024v-704h-448zM960 896h-896v-704h357.49l128 128h410.51v576zM576 448h-128v128h-128v128h128v128h128v-128h128v-128h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-plus",
						"directory",
						"folder-add"
					],
					"defaultCode": 59873,
					"grid": 16
				},
				{
					"id": 2031,
					"paths": [
						"M960 256h-896l64-128h352l32 64h416l32 64zM0 320l64 640h896l64-640h-1024zM720 499.882l-140.118 140.118 140.118 140.118-67.882 67.882-140.118-140.118-140.118 140.118-67.882-67.882 140.118-140.118-140.118-140.118 67.882-67.882 140.118 140.118 140.118-140.118 67.882 67.882z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-remove",
						"directory",
						"folder-cross"
					],
					"defaultCode": 59866,
					"grid": 16
				},
				{
					"id": 2022,
					"paths": [
						"M928 128h-416l-32-64h-352l-64 128h896z",
						"M904.34 704h74.86l44.8-448h-1024l64 640h484.080c-104.882-37.776-180.080-138.266-180.080-256 0-149.982 122.018-272 272-272 149.98 0 272 122.018 272 272 0 21.678-2.622 43.15-7.66 64z",
						"M1002.996 913.75l-198.496-174.692c17.454-28.92 27.5-62.814 27.5-99.058 0-106.040-85.96-192-192-192s-192 85.96-192 192 85.96 192 192 192c36.244 0 70.138-10.046 99.058-27.5l174.692 198.496c22.962 26.678 62.118 28.14 87.006 3.252l5.492-5.492c24.888-24.888 23.426-64.044-3.252-87.006zM640 764c-68.484 0-124-55.516-124-124s55.516-124 124-124 124 55.516 124 124-55.516 124-124 124z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-search",
						"dicrectory",
						"browse"
					],
					"defaultCode": 59857,
					"grid": 16
				},
				{
					"id": 2024,
					"paths": [
						"M960 256h-896l64-128h352l32 64h416zM0 320l64 640h896l64-640h-1024zM576 704v191.016h-128v-191.016h-224l288-288 288 288h-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-upload",
						"directory",
						"folder-load"
					],
					"defaultCode": 59859,
					"grid": 16
				},
				{
					"id": 2041,
					"paths": [
						"M576 256l-128-128h-448v832h1024v-704h-448zM512 480l224 224h-160v256h-128v-256h-160l224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-upload",
						"directory",
						"folder-load"
					],
					"defaultCode": 59876,
					"grid": 16
				},
				{
					"id": 2043,
					"paths": [
						"M576 256l-128-128h-448v832h1024v-704h-448zM960 896h-384v-192h192l-256-256-256 256h192v192h-384v-704h357.49l128 128h410.51v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder-upload",
						"directory",
						"folder-load"
					],
					"defaultCode": 59878,
					"grid": 16
				},
				{
					"id": 2032,
					"paths": [
						"M448 128l128 128h448v704h-1024v-832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder",
						"directory",
						"category",
						"browse"
					],
					"defaultCode": 59867,
					"grid": 16
				},
				{
					"id": 2034,
					"paths": [
						"M576 256l-128-128h-448v832h1024v-704h-448zM549.49 320h410.51v8h-896v-16h477.49l8 8zM64 896v-8h896v8h-896zM64 872v-16h896v16h-896zM64 840v-16h896v16h-896zM64 808v-16h896v16h-896zM64 776v-16h896v16h-896zM64 744v-16h896v16h-896zM64 712v-16h896v16h-896zM64 680v-16h896v16h-896zM64 648v-16h896v16h-896zM64 616v-16h896v16h-896zM64 584v-16h896v16h-896zM64 552v-16h896v16h-896zM64 520v-16h896v16h-896zM64 488v-16h896v16h-896zM64 456v-16h896v16h-896zM64 424v-16h896v16h-896zM64 392v-16h896v16h-896zM64 360v-16h896v16h-896zM421.49 192l8 8h-365.49v-8h357.49zM445.49 216l16 16h-397.49v-16h381.49zM477.49 248l16 16h-429.49v-16h413.49zM509.492 280l16 16h-461.492v-16h445.492z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder",
						"directory",
						"category",
						"browse",
						"dualtone"
					],
					"defaultCode": 59869,
					"grid": 16
				},
				{
					"id": 2035,
					"paths": [
						"M421.49 192l128 128h410.51v576h-896v-704h357.49zM448 128h-448v832h1024v-704h-448l-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder",
						"directory",
						"category",
						"browse"
					],
					"defaultCode": 59870,
					"grid": 16
				},
				{
					"id": 2044,
					"paths": [
						"M984.5 256h-945c-26.4 0-43.764 21.18-38.586 47.068l117.672 545.864c5.178 25.888 31.014 47.068 57.414 47.068h672c26.398 0 52.234-21.18 57.412-47.068l117.674-545.864c5.178-25.888-12.188-47.068-38.586-47.068zM896 176c0-26.51-21.49-48-48-48h-432l-32-64h-208c-26.51 0-48 21.49-48 48v80h768v-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder",
						"directory",
						"category",
						"browse"
					],
					"defaultCode": 59879,
					"grid": 16
				},
				{
					"id": 2046,
					"paths": [
						"M984.5 256h-88.5v-80c0-26.51-21.49-48-48-48h-432l-32-64h-208c-26.51 0-48 21.49-48 48v144h-88.5c-26.4 0-43.764 21.18-38.586 47.068l117.672 545.864c5.178 25.888 31.014 47.068 57.414 47.068h672c26.4 0 52.236-21.18 57.414-47.068l117.672-545.864c5.178-25.888-12.186-47.068-38.586-47.068zM192 128h152.446l32 64h455.554v64h-640v-128zM843.594 832h-663.188l-110.372-512h883.932l-110.372 512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder",
						"directory",
						"category",
						"browse"
					],
					"defaultCode": 59881,
					"grid": 16
				},
				{
					"id": 1295,
					"width": 950.8569946289062,
					"paths": [
						"M950.857 347.429v402.286q0 52.571-37.714 90.286t-90.286 37.714h-694.857q-52.571 0-90.286-37.714t-37.714-90.286v-548.571q0-52.571 37.714-90.286t90.286-37.714h182.857q52.571 0 90.286 37.714t37.714 90.286v18.286h384q52.571 0 90.286 37.714t37.714 90.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"folder"
					],
					"defaultCode": 61563,
					"grid": 14
				},
				{
					"id": 3234,
					"paths": [
						"M799.596 16.208c-90.526 0-148.62-16.208-241.848-16.208-301.284 0-441.792 171.584-441.792 345.872 0 102.678 48.64 136.458 144.564 136.458-6.758-14.864-18.914-31.080-18.914-104.034 0-204.010 77.006-263.458 175.636-267.51 0 0-80.918 793.374-315.778 888.542v24.672h316.594l108.026-512h197.844l44.072-128h-214.908l51.944-246.19c59.446 12.156 117.542 24.316 167.532 24.316 62.148 0 118.894-18.914 149.968-162.126-37.826 12.16-78.362 16.208-122.94 16.208z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"font",
						"typeface",
						"typography",
						"font-family",
						"wysiwyg"
					],
					"defaultCode": 61069,
					"grid": 16
				},
				{
					"id": 3238,
					"paths": [
						"M128 0v320l128-192h256v832h-128v64h384v-64h-128v-832h256l128 192v-320zM256 576h128l64 96v-160h-448v160l64-96h128v384h-64v64h192v-64h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"font-size",
						"wysiwyg",
						"size",
						"typography"
					],
					"defaultCode": 61073,
					"grid": 16
				},
				{
					"id": 3249,
					"paths": [
						"M64 512h384v128h-128v384h-128v-384h-128zM960 256h-251.75v768h-136.5v-768h-251.75v-128h640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"font-size",
						"wysiwyg"
					],
					"defaultCode": 61084,
					"grid": 16
				},
				{
					"id": 1225,
					"width": 950.8590698242188,
					"paths": [
						"M414.286 319.429l-97.143 257.143q18.857 0 78 1.143t91.714 1.143q10.857 0 32.571-1.143-49.714-144.571-105.143-258.286zM0 950.857l1.143-45.143q13.143-4 32-7.143t32.571-6 28.286-8.286 25.429-16.571 17.714-28.857l135.429-352 160-413.714h73.143q4.571 8 6.286 12l117.143 274.286q18.857 44.571 60.571 147.143t65.143 156.857q8.571 19.429 33.143 82.571t41.143 96.286q11.429 25.714 20 32.571 10.857 8.571 50.286 16.857t48 11.714q3.429 21.714 3.429 32.571 0 2.286-0.286 7.429t-0.286 7.429q-36 0-108.571-4.571t-109.143-4.571q-43.429 0-122.857 4t-101.714 4.571q0-24.571 2.286-44.571l74.857-16q0.571 0 7.143-1.429t8.857-2 8.286-2.571 8.571-3.714 6.286-4.571 5.143-6.286 1.429-8q0-9.143-17.714-55.143t-41.143-101.429-24-57.143l-257.143-1.143q-14.857 33.143-43.714 111.714t-28.857 92.857q0 12.571 8 21.429t24.857 14 27.714 7.714 32.571 4.857 23.429 2.286q0.571 10.857 0.571 33.143 0 5.143-1.143 15.429-33.143 0-99.714-5.714t-99.714-5.714q-4.571 0-15.143 2.286t-12.286 2.286q-45.714 8-107.429 8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"font"
					],
					"defaultCode": 61489,
					"grid": 14
				},
				{
					"id": 1763,
					"width": 877.7139892578125,
					"paths": [
						"M0 73.143h877.714v877.714h-877.714v-877.714zM518.857 256l-6.857 18.857 42.857 47.429-17.714 65.143 14.286 14.286 61.143-32.571 61.143 32.571 14.286-14.286-17.714-65.143 42.857-47.429-6.857-18.857h-54.286l-30.286-54.857h-18.286l-30.286 54.857h-54.286zM366.286 349.143q18.286 0 25.429 9.143t6.571 36l99.429-12q0-31.429-10-52.857t-28.857-32-39.429-14.571-48.571-4q-76 0-113.714 32.857t-37.714 104.286v41.143h-54.857v73.143h43.429q11.429 0 11.429 4.571v218.286q0 8-2.857 11.429t-10.286 4l-41.714 4v50.286h256v-49.143l-85.143-8q-3.429-0.571-4.857-0.857t-2-1.429-0.286-2.286 0.571-4 0.286-5.714v-221.143h109.143l21.714-73.143h-132q-3.429 0-1.143-3.429t2.286-5.143v-45.714q0-15.429 0.857-23.143t4.286-16 11.143-11.429 20.857-3.143zM713.143 822.857v-49.143l-30.857-5.143q-4-0.571-5.429-1.429t-1.429-1.714 0.571-4.286 0.571-6.857v-297.143h-157.143l-13.143 57.714 47.429 12.571q13.143 4 13.143 15.429v211.429q0 8-3.429 10.571t-11.429 3.714l-40 5.143v49.143h201.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fonticons"
					],
					"defaultCode": 62080,
					"grid": 14
				},
				{
					"id": 2637,
					"paths": [
						"M1018.104 159.030c-8.398-76.176-76.958-144.734-153.132-153.132-206.896-22.804-475.148 15.75-659.234 199.838-184.090 184.084-222.642 452.342-199.842 659.232 8.398 76.176 76.958 144.736 153.132 153.132 206.89 22.802 475.146-15.754 659.232-199.836 184.090-184.086 222.648-452.34 199.844-659.234zM325.13 581.13c14.84-14.844 38.9-14.844 53.74 0l64 64c14.84 14.84 14.84 38.898 0 53.738-7.42 7.424-17.146 11.132-26.87 11.132s-19.45-3.708-26.87-11.13l-64-64c-14.84-14.84-14.84-38.9 0-53.74zM341.796 956.866c-58.030-29.482-111.67-68.272-159.030-115.63-47.414-47.412-86.238-101.122-115.734-159.226 3.604-43.812 10.738-90.836 23.188-139.276 4.242-16.5 8.978-32.612 14.17-48.356 18.862 105.11 69.154 201.87 146.26 278.974 77.046 77.046 173.718 127.32 278.736 146.214-67.066 22.088-132.266 32.682-187.59 37.3zM570.87 570.87c-7.42 7.422-17.146 11.13-26.87 11.13s-19.45-3.708-26.87-11.13l-64-64c-14.84-14.84-14.84-38.9 0-53.74s38.9-14.84 53.74 0l64 64c14.84 14.84 14.84 38.9 0 53.74zM698.87 442.87c-7.42 7.42-17.144 11.13-26.87 11.13s-19.45-3.71-26.87-11.13l-64-64c-14.842-14.84-14.842-38.9 0-53.74 14.84-14.84 38.898-14.84 53.738 0l64 64c14.842 14.84 14.842 38.9 0.002 53.74zM933.782 481.268c-4.24 16.5-8.976 32.612-14.17 48.356-18.864-105.11-69.154-201.87-146.26-278.974-77.046-77.046-173.716-127.32-278.734-146.214 67.066-22.088 132.264-32.682 187.586-37.298 58.030 29.484 111.67 68.272 159.030 115.63 47.414 47.414 86.238 101.124 115.734 159.23-3.602 43.808-10.736 90.832-23.186 139.27z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"football",
						"soprts",
						"rugby",
						"sports",
						"ball",
						"game"
					],
					"defaultCode": 60472,
					"grid": 16
				},
				{
					"id": 2542,
					"paths": [
						"M802.012 233.836c123.066 88.77 135.172 367.188 159.382 451.922l-229.114 90.79c-23.336-153.33-220.792-268.33-228.864-437.8-8.068-169.472 175.526-193.682 298.596-104.912zM941.218 1012.596c-182.9 66.506-193.682-179.558-193.682-179.558l238.066-96.84c0.002 0 110.964 219.908-44.384 276.398zM2.148 191.048c24.252-149.792 171.192-262.494 285.322-136.954 114.122 125.54 55.81 346.48 147.734 471.39l-226.198 97.82c-42.806-77.034-231.114-282.464-206.858-432.256zM454.374 840.156c-149.788 69.902-226.83-164.066-226.83-164.066l236.822-99.868c0 0 166.364 181.626-9.992 263.934z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"footprint",
						"steps",
						"shoes"
					],
					"defaultCode": 60377,
					"grid": 16
				},
				{
					"id": 1032,
					"width": 1024,
					"paths": [
						"M834.72 219.232c23.712-46.336 29.28-108.16 29.28-187.232 0-17.696-14.336-32-32-32-73.92 0-141.312 3.328-192 31.328-0.16-7.584-3.008-14.944-8.16-20.672-6.048-6.784-14.72-10.656-23.84-10.656h-192c-9.056 0-17.696 3.84-23.776 10.56-6.048 6.752-8.992 15.712-8.064 24.736l16.672 160.768c-15.68-2.688-31.584-4.064-47.584-4.064-114.688 0-203.2 30.656-263.072 91.104-59.296 59.84-88.8 147.744-87.712 261.216 2.72 282.688 220.128 479.68 413.536 479.68 32.352 0 68.16-10.688 102.464-30.336 38.88 19.904 80.544 30.336 121.536 30.336 184.672 0 384-183.52 384-480 0-200.928-94.848-287.968-189.28-324.768zM426.56 268.896c0.096 0.032 0.16 0.032 0.256 0.064 23.2 8.416 45.504 20.832 66.784 37.344 5.76 4.48 12.704 6.72 19.616 6.72s13.856-2.24 19.648-6.72c42.976-33.376 90.208-50.304 140.352-50.304 36.512 0 69.44 3.392 98.88 10.176 1.152 0.416 2.208 1.056 3.424 1.344 7.040 1.728 13.92 3.52 20.672 5.312 109.92 34.912 163.808 124.448 163.808 271.168 0 116.32-36.416 223.872-102.528 302.88-60.16 71.872-139.424 113.12-217.472 113.12-35.584 0-72.256-10.688-106.080-30.88-5.056-3.040-10.752-4.544-16.416-4.544-6.24 0-12.448 1.824-17.856 5.44-28.352 19.040-58.848 29.984-83.648 29.984-163.424 0-347.168-170.976-349.536-416.32-0.928-95.776 22.368-168.288 69.184-215.552 47.392-47.872 120.608-72.128 217.568-72.128 24.896 0 49.088 4.224 72.384 12.512 0.32 0.096 0.64 0.288 0.96 0.384zM628.544 135.776c24.896-56.128 75.936-69.472 171.136-71.488-1.824 87.2-13.12 137.312-58.016 164.32-22.528-3.040-45.472-4.608-68.448-4.608-21.824 0-43.104 2.88-63.68 8.384 2.336-38.912 7.744-68.672 17.056-91.84 0.16-0.288 1.472-3.424 1.952-4.768zM451.488 64h120.768l-21.344 192.192c0 0 0 0 0 0-12.992 7.2-25.6 15.488-37.664 24.864-13.408-10.432-27.52-19.392-42.048-27.104 0 0 0 0 0.032 0l-19.744-189.952zM237.856 316.8c-24.32 0-53.12 12.768-76.704 36.352-37.504 37.504-47.616 88.128-22.624 113.152 9.28 9.248 22.080 13.696 36.416 13.696 24.32 0 53.12-12.768 76.704-36.352 37.504-37.504 47.616-88.16 22.624-113.152-9.248-9.248-22.048-13.696-36.416-13.696zM255.040 376.128c-3.008 15.008-12.48 31.392-25.984 44.896-19.904 19.904-40.992 26.976-54.112 26.976-4.32 0-10.208-0.768-13.792-4.352-4.16-4.16-5.408-12.736-3.36-22.976 3.008-15.008 12.48-31.392 25.984-44.896 19.872-19.872 40.96-26.976 54.080-26.976 4.32 0 10.208 0.736 13.792 4.352 4.16 4.16 5.44 12.736 3.392 22.976z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"forbid",
						"eat",
						"pick"
					],
					"grid": 32
				},
				{
					"id": 523,
					"width": 1024,
					"paths": [
						"M1003.488 717.76l-589.952-514.848c-10.176-60.512-61.76-106.912-125.152-106.912-47.264 0-88.064 25.888-110.24 64h-74.208c-19.968 0-39.136 5.12-55.936 14.4-26.304 14.528-18.88 54.4 10.72 59.328l104.96 17.472c10.336 46.848 46.336 83.712 92.704 95.68v69.12c0 158.752 115.712 290.112 267.296 315.296l84.704 84.704v26.656l-40 53.344h-72c-8.832 0-16 7.168-16 16s7.168 16 16 16h88l56-74.656v-124.704c39.68-8.192 77.824-23.2 111.872-45.888l16.16-10.752 207.872 89.088c9.728 4.16 21.024 1.984 28.512-5.504 10.592-10.592 9.984-27.936-1.312-37.824zM160.384 218.24l-96.544-16.096c12.032-6.56 25.728-10.144 40.096-10.144h56.448v26.24zM765.088 635.776l-30.56 20.352c-29.44 19.616-63.264 33.472-100.608 41.184l-25.536 5.28v68.16l-69.344-69.344-10.176-1.696c-138.752-23.040-240.48-143.040-240.48-283.712v-93.92l-24-6.208c-42.368-10.944-72-53.568-72-91.936 0-53.376 43.072-95.968 96-95.968 46.432 0 85.792 33.728 93.6 80.192l1.888 11.296 350.112 305.568c-35.648 51.424-94.4 82.976-157.6 82.976-105.888 0-192-86.112-192-192v0c0-8.832-7.168-16-16-16s-16 7.168-16 16v0c0 123.488 100.48 224 224 224 72.544 0 140.096-35.52 181.888-93.76l195.040 170.208-188.224-80.672zM320.384 224c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"forebode",
						"fly",
						"peck"
					],
					"grid": 32
				},
				{
					"id": 524,
					"width": 1024,
					"paths": [
						"M1003.488 717.76l-229.792-200.544c-37.056 72.736-112.48 122.784-199.552 122.784-123.52 0-224-100.512-224-224 0-8.832 7.168-16 16-16s16 7.168 16 16c0 105.888 86.112 192 192 192 77.536 0 144.288-46.272 174.592-112.576l-335.2-292.512c-10.176-60.512-61.76-106.912-125.152-106.912-47.264 0-88.064 25.888-110.24 64h-74.208c-19.936 0-39.136 5.12-55.936 14.4-26.304 14.528-18.88 54.4 10.752 59.328l104.928 17.472c10.336 46.848 46.336 83.712 92.704 95.68v69.12c0 158.752 115.712 290.112 267.296 315.296l84.704 84.704v26.656l-40 53.344h-72c-8.832 0-16 7.168-16 16s7.168 16 16 16h88l56-74.656v-124.704c39.68-8.192 77.824-23.2 111.872-45.888l16.16-10.752 207.872 89.088c9.728 4.16 21.024 1.984 28.512-5.504 10.592-10.592 9.984-27.936-1.312-37.824zM288.384 256c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"forebode",
						"fly",
						"peck"
					],
					"grid": 32
				},
				{
					"id": 2512,
					"paths": [
						"M416 0c-17.672 0-32 14.328-32 32v288c0 18.97-3.238 31.558-9.624 37.412-6.014 5.514-17.732 8.442-30.138 11.544-7.276 1.82-15.632 3.912-24.24 7.016v-343.972c0-17.672-14.328-32-32-32s-32 14.328-32 32v343.968c-8.606-3.106-16.962-5.194-24.24-7.014-12.406-3.102-24.124-6.030-30.138-11.544-6.382-5.852-9.62-18.44-9.62-37.41v-288c0-17.672-14.328-32-32-32s-32 14.328-32 32v288c0 88.984 55.236 102.794 88.24 111.044 12.406 3.102 24.124 6.030 30.138 11.544 6.386 5.854 9.624 18.44 9.624 37.412v165.484c-37.282 13.182-64.002 48.72-64.002 90.516v192c0 53.020 42.98 96 96 96s96-42.98 96-96v-192c0-41.796-26.718-77.334-64-90.516v-165.484c0-18.97 3.238-31.558 9.624-37.412 6.014-5.514 17.732-8.442 30.138-11.544 33.002-8.25 88.238-22.060 88.238-111.044v-288c0-17.672-14.326-32-32-32z",
						"M832 645.484v-613.484c0-17.672-14.326-32-32-32-68.988 0-113.078 46.058-137.918 84.696-25.978 40.412-46.626 95.792-61.372 164.6-24.428 114.002-24.71 225.992-24.71 230.704 0 17.672 14.326 32 32 32h160v133.484c-37.282 13.182-64 48.718-64 90.516v192c0 53.020 42.98 96 96 96s96-42.98 96-96v-192c0-41.796-26.718-77.334-64-90.516zM663.47 261.874c16.566-76.914 47.676-166.416 104.53-191.214v377.34h-127.11c1.764-40.532 7.006-113.82 22.58-186.126z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fork-knife",
						"food",
						"restaurant"
					],
					"defaultCode": 60347,
					"grid": 16
				},
				{
					"id": 525,
					"width": 1024,
					"paths": [
						"M544 704c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM448 192c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM576 192c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM512 576c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM512 480c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM960 336c0 8.832-7.168 16-16 16h-57.376l-100.8 100.8c48.64 59.968 78.176 135.872 78.176 219.2 0 194.4-157.6 352-352 352s-352-157.6-352-352c0-83.328 29.44-159.328 78.112-219.264l-100.736-100.736h-57.376c-8.832 0-16-7.168-16-16s7.168-16 16-16h48v-48c0-8.832 7.168-16 16-16s16 7.168 16 16v57.376l99.552 99.552c10.304-10.592 21.056-20.736 32.608-30.016-2.432-4.512-4.16-9.44-4.16-14.912v-64c0-10.176 5.024-18.816 12.416-24.672-7.776-22.4-12.416-46.24-12.416-71.328 0-123.712 100.288-224 224-224s224 100.288 224 224c0 25.088-4.64 48.928-12.416 71.328 7.36 5.856 12.416 14.496 12.416 24.672v82.176c10.048 8.32 19.584 17.216 28.64 26.56l99.36-99.36v-57.376c0-8.832 7.168-16 16-16s16 7.168 16 16v48h48c8.832 0 16 7.168 16 16zM320 224c0 22.016 4.384 43.52 11.744 64h360.512c7.36-20.48 11.744-41.984 11.744-64 0-105.856-86.144-192-192-192s-192 86.144-192 192zM320 384h384v-64h-384v64zM701.6 416h-61.6v224h64v-222.144c-0.8-0.608-1.6-1.248-2.4-1.856zM736 445.536v274.464c0 8.832-7.168 16-16 16s-16-7.168-16-16v-48h-16v48c0 8.832-7.168 16-16 16s-16-7.168-16-16v-48h-16v48c0 8.832-7.168 16-16 16s-16-7.168-16-16v-304h-285.6c-80.8 59.936-130.4 154.336-130.4 256 0 176.448 143.552 320 320 320s320-143.552 320-320c0-86.272-35.872-167.2-96-226.464z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"form",
						"build",
						"roll"
					],
					"grid": 32
				},
				{
					"id": 526,
					"width": 1024,
					"paths": [
						"M726.208 288c6.144-20.32 9.792-41.664 9.792-64 0-123.712-100.288-224-224-224s-224 100.288-224 224c0 22.336 3.648 43.68 9.792 64h428.416zM576 128c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM448 128c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM640 640v-224h64v224h-64zM736 320v64h-448v-64h448zM944 320h-48v-48c0-8.832-7.168-16-16-16s-16 7.168-16 16v57.376l-99.008 99.008c-4.16-4.288-8.608-8.256-12.928-12.384h-16.064v304c0 8.832-7.168 16-16 16s-16-7.168-16-16v-48h-16v48c0 8.832-7.168 16-16 16s-16-7.168-16-16v-48h-16v48c0 8.832-7.168 16-16 16s-16-7.168-16-16v-304h-336.064c-4.32 4.128-8.768 8.096-12.928 12.384l-99.008-99.008v-57.376c0-8.832-7.168-16-16-16s-16 7.168-16 16v48h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h57.376l100.448 100.448c-48.384 60.224-77.824 136.288-77.824 219.552 0 194.4 157.6 352 352 352s352-157.6 352-352c0-83.264-29.44-159.328-77.824-219.552l100.448-100.448h57.376c8.832 0 16-7.168 16-16s-7.168-16-16-16zM512 736c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM512 640c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM512 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"form",
						"build",
						"roll"
					],
					"grid": 32
				},
				{
					"id": 527,
					"width": 1024,
					"paths": [
						"M128 160v704c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96h-576c-53.024 0-96 42.976-96 96zM672 864c0 35.296-28.704 64-64 64h-384c-35.296 0-64-28.704-64-64v-704c0-35.296 28.704-64 64-64h384c35.296 0 64 28.704 64 64v704zM864 864c0 35.296-28.704 64-64 64h-120.928c15.328-17.024 24.928-39.296 24.928-64v-64h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32c0-24.704-9.6-46.976-24.928-64h120.928c35.296 0 64 28.704 64 64v704zM544 192h-256c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h256c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32zM544 416h-256v-192h256v192zM576 528c0 8.832-7.168 16-16 16h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h288c8.832 0 16 7.168 16 16zM576 720c0 8.832-7.168 16-16 16h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h288c8.832 0 16 7.168 16 16zM576 656c0 8.832-7.168 16-16 16h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h288c8.832 0 16 7.168 16 16zM576 592c0 8.832-7.168 16-16 16h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h288c8.832 0 16 7.168 16 16zM448 784c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"format",
						"print",
						"align",
						"organize"
					],
					"grid": 32
				},
				{
					"id": 528,
					"width": 1024,
					"paths": [
						"M608 64h-384c-53.024 0-96 42.976-96 96v704c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM432 800h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16zM560 736h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h288c8.832 0 16 7.168 16 16s-7.168 16-16 16zM560 672h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h288c8.832 0 16 7.168 16 16s-7.168 16-16 16zM560 608h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h288c8.832 0 16 7.168 16 16s-7.168 16-16 16zM560 544h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h288c8.832 0 16 7.168 16 16s-7.168 16-16 16zM576 416c0 17.664-14.336 32-32 32h-256c-17.664 0-32-14.336-32-32v-192c0-17.664 14.336-32 32-32h256c17.664 0 32 14.336 32 32v192zM288 224h256v192h-256v-192zM896 160v704c0 53.024-42.976 96-96 96h-108.224c26.88-23.488 44.224-57.6 44.224-96v-64h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32c0-38.4-17.344-72.512-44.224-96h108.224c53.024 0 96 42.976 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"format",
						"print",
						"align",
						"organize"
					],
					"grid": 32
				},
				{
					"id": 1033,
					"width": 1024,
					"paths": [
						"M32 32v960h960v-960h-960zM928 928h-832v-832h832v832zM576 160h-384v416h384v-416zM544 544h-320v-352h320v352zM832 192h-224v-32h224v32zM832 256h-224v-32h224v32zM832 384h-224v-32h224v32zM832 320h-224v-32h224v32zM832 448h-224v-32h224v32zM832 576h-224v-32h224v32zM832 512h-224v-32h224v32zM832 640h-640v-32h640v32zM832 704h-640v-32h640v32zM832 768h-640v-32h640v32zM832 832h-640v-32h640v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"format",
						"print",
						"align",
						"organize"
					],
					"grid": 32
				},
				{
					"id": 1769,
					"width": 950.862060546875,
					"paths": [
						"M365.714 576v-128q0-9.143-9.143-9.143h-54.857q-9.143 0-9.143 9.143v128q0 9.143 9.143 9.143h54.857q9.143 0 9.143-9.143zM658.286 576v-128q0-9.143-9.143-9.143h-54.857q-9.143 0-9.143 9.143v128q0 9.143 9.143 9.143h54.857q9.143 0 9.143-9.143zM950.857 594.286v429.714h-365.714v-182.857q0-45.714-32-77.714t-77.714-32-77.714 32-32 77.714v182.857h-365.714v-429.714q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143v64h73.143v-356.571q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143v64h73.143v-64q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143v64h73.143v-64q0-3.429 1.429-5.429t4.857-2.857 5.429-1.143 6.571 0 5.143 0.286v-223.429q-18.286-8.571-18.286-28.571 0-13.143 9.429-22.286t22-9.143 22 9.143 9.429 22.286q0 20-18.286 28.571v9.714q25.714-5.714 47.429-5.714 12 0 34 4.286t31.143 4.286q9.714 0 26.857-4.286t21.143-4.286q9.143 0 9.143 9.143v120q0 8.571-20 12.286t-35.429 3.714q-10.286 0-31.143-4.286t-31.714-4.286q-22.857 0-51.429 6.857v76q0.571 0 5.143-0.286t6.571 0 5.429 1.143 4.857 2.857 1.429 5.429v64h73.143v-64q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143v64h73.143v-64q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143v356.571h73.143v-64q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"fort-awesome"
					],
					"defaultCode": 62086,
					"grid": 14
				},
				{
					"id": 1661,
					"width": 877.7139911651611,
					"paths": [
						"M533.714 85.714q-181.143 69.143-317.714 207.143t-204.571 320.286q-11.429-50.857-11.429-100.571 0-118.857 58.571-219.714t159.143-159.429 219.429-58.571q46.857 0 96.571 10.857zM687.429 153.714q53.143 37.143 93.714 88.571-222.286 64.571-385.429 228.857t-226.571 386.571q-53.143-41.143-88.571-92.571 64-220.571 225.714-383.429t381.143-228zM268.571 916q65.714-203.429 216.857-355.429t354-219.429q22.857 52.571 30.857 111.429-166.857 68.571-294.857 197.143t-196 296q-58.857-8-110.857-29.714zM877.714 949.143q-110.286-28.571-209.714-65.714-77.143 48-165.714 61.143 62.286-117.143 156.571-211.714t210.857-157.429q-12 86.857-57.714 162.286 37.143 100 65.714 211.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"forumbee"
					],
					"defaultCode": 61969,
					"grid": 14
				},
				{
					"id": 2262,
					"paths": [
						"M262.14 0c-113.728 206.032-132.89 520.304 313.86 509.824v-253.824l384 384-384 384v-248.372c-534.96 13.942-594.572-472.214-313.86-775.628z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"forward",
						"right",
						"arrow-right"
					],
					"defaultCode": 60097,
					"grid": 16
				},
				{
					"id": 2969,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416zM320 352l224 160-224 160zM576 352l224 160-224 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"forward",
						"player"
					],
					"defaultCode": 60804,
					"grid": 16
				},
				{
					"id": 2974,
					"paths": [
						"M512 864v-320l-320 320v-704l320 320v-320l352 352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"forward",
						"player"
					],
					"defaultCode": 60809,
					"grid": 16
				},
				{
					"id": 1253,
					"width": 881.141923904419,
					"paths": [
						"M25.714 943.429q-10.857 10.857-18.286 7.429t-7.429-18.286v-841.143q0-14.857 7.429-18.286t18.286 7.429l405.714 405.714q4.571 4.571 7.429 10.857v-405.714q0-14.857 7.429-18.286t18.286 7.429l405.714 405.714q10.857 10.857 10.857 25.714t-10.857 25.714l-405.714 405.714q-10.857 10.857-18.286 7.429t-7.429-18.286v-405.714q-2.857 5.714-7.429 10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"forward"
					],
					"defaultCode": 61518,
					"grid": 14
				},
				{
					"id": 1034,
					"width": 1024,
					"paths": [
						"M32 32v960h960v-960h-960zM928 498.752l-112-112-176 176-178.752-178.752 176-176-112-112h402.752v402.752zM96 928v-832h384l112 112-176 176 224 224 176-176 112 112v384h-832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"forward",
						"send"
					],
					"grid": 32
				},
				{
					"id": 3402,
					"paths": [
						"M851.564 90.090c-12.060-16.404-31.204-26.090-51.564-26.090h-608c-35.346 0-64 28.654-64 64v768c0 25.884 15.592 49.222 39.508 59.128 7.918 3.28 16.234 4.874 24.478 4.874 16.656 0 33.026-6.504 45.268-18.748l237.256-237.254h165.49c27.992 0 52.736-18.192 61.086-44.91l160-512c6.074-19.432 2.538-40.596-9.522-57zM672.948 320h-224.948c-35.346 0-64 28.654-64 64s28.654 64 64 64h184.948l-40 128h-144.948c-16.974 0-33.252 6.742-45.254 18.746l-146.746 146.744v-549.49h456.948l-40 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"foursquare",
						"brand",
						"social"
					],
					"defaultCode": 61237,
					"grid": 16
				},
				{
					"id": 1525,
					"width": 738.8559646606445,
					"paths": [
						"M571.429 248l21.143-110.857q2.857-13.143-5.143-22.857t-20-9.714h-406.857q-13.143 0-22 9.714t-8.857 21.143v629.143q0 4 3.429 0.571l166.286-201.143q13.143-14.857 21.714-19.143t27.429-4.286h136.571q12.571 0 21.143-8.286t10.286-16.857q13.714-74.286 21.143-109.143 2.286-12-6.571-22.857t-20.857-10.857h-168q-16.571 0-27.429-10.857t-10.857-27.429v-24q0-16.571 10.857-27.143t27.429-10.571h197.714q10.286 0 20-7.714t11.429-16.857zM701.143 121.143q-8.571 41.714-30.571 152.286t-39.714 200-20 99.143q-3.429 12.571-5.143 18.571t-8 18.571-14 18.857-22 12-33.143 5.714h-154.857q-7.429 0-12.571 5.714-4.571 5.143-243.429 282.286-12.571 14.286-33.429 16.286t-27.714-3.143q-31.429-12.571-31.429-56v-805.714q0-31.429 21.714-58.571t68.571-27.143h507.429q54.286 0 72.571 30.286t5.714 90.857zM701.143 121.143l-90.286 451.429q2.286-9.714 20-99.143t39.714-200 30.571-152.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"foursquare"
					],
					"defaultCode": 61824,
					"grid": 14
				},
				{
					"id": 529,
					"width": 1024,
					"paths": [
						"M768 160h-512c-17.664 0-32 14.336-32 32v640c0 17.664 14.336 32 32 32h512c17.664 0 32-14.336 32-32v-640c0-17.664-14.336-32-32-32zM768 832h-512v-640h512v640zM877.504 653.536c-8.064-8.064-10.080-20.384-4.96-30.592l12.544-25.056c27.008-54.048 27.008-117.664 0-171.712l-12.512-25.056c-5.088-10.208-3.104-22.528 4.96-30.592l5.248-5.248c24.992-24.992 24.992-65.504 0-90.496l-10.976-10.976c-5.024-5.024-7.808-11.776-7.808-18.784v-53.024c0-53.024-42.976-96-96-96h-53.024c-7.040 0-13.76-2.784-18.752-7.776l-10.976-10.976c-12.48-12.48-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752v0c-5.184 5.184-11.968 7.776-18.752 7.776s-13.568-2.592-18.752-7.776c-12.48-12.48-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752v0c-5.184 5.184-11.968 7.776-18.752 7.776s-13.568-2.592-18.752-7.776c-12.48-12.48-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-10.976 10.976c-4.992 4.992-11.712 7.776-18.752 7.776h-53.024c-53.024 0-96 42.976-96 96v53.024c0 7.040-2.784 13.76-7.776 18.752l-10.944 10.976c-24.992 24.992-24.992 65.536 0 90.528l5.216 5.216c8.064 8.064 10.080 20.384 4.96 30.592l-12.512 25.056c-27.040 54.048-27.040 117.664 0 171.712l12.512 25.056c5.088 10.208 3.104 22.528-4.96 30.592l-5.248 5.248c-24.992 24.992-24.992 65.504 0 90.496l10.976 10.976c4.992 4.992 7.776 11.744 7.776 18.752v53.024c0 53.024 42.976 96 96 96h53.024c7.040 0 13.76 2.784 18.752 7.776l10.976 10.976c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752c5.184-5.184 11.968-7.776 18.752-7.776s13.568 2.592 18.752 7.776v0c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752c5.184-5.184 11.968-7.776 18.752-7.776s13.568 2.592 18.752 7.776v0c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l10.976-10.976c4.992-4.992 11.712-7.776 18.752-7.776h53.024c53.024 0 96-42.976 96-96v-53.024c0-7.040 2.784-13.76 7.776-18.752l10.976-10.976c24.992-24.992 24.992-65.536 0-90.528l-5.248-5.184zM860.128 726.624l-10.976 10.976c-11.072 11.072-17.152 25.76-17.152 41.376v53.024c0 35.296-28.704 64-64 64h-53.024c-15.616 0-30.336 6.080-41.376 17.152l-10.976 10.976c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376c-11.040-11.040-25.76-17.152-41.376-17.152s-30.336 6.080-41.376 17.152c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376c-11.040-11.040-25.76-17.152-41.376-17.152s-30.336 6.080-41.376 17.152c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376l-10.976-10.976c-11.072-11.072-25.76-17.152-41.376-17.152h-53.024c-35.296 0-64-28.704-64-64v-53.024c0-15.616-6.080-30.336-17.12-41.376l-10.976-10.976c-12.48-12.48-12.48-32.768 0-45.248l5.248-5.248c17.824-17.824 22.24-44.992 10.976-67.552l-12.512-25.056c-22.4-44.8-22.4-98.304 0-143.104l12.512-25.056c11.296-22.56 6.88-49.696-10.976-67.552l-5.216-5.216c-6.080-6.016-9.408-14.048-9.408-22.592s3.328-16.576 9.376-22.624l10.944-10.976c11.072-11.040 17.152-25.728 17.152-41.376v-53.024c0-35.296 28.704-64 64-64h53.024c15.616 0 30.336-6.080 41.376-17.152l10.976-10.976c6.048-6.048 14.080-9.376 22.624-9.376s16.576 3.328 22.624 9.376c11.040 11.072 25.76 17.152 41.376 17.152s30.336-6.080 41.376-17.152c6.048-6.048 14.080-9.376 22.624-9.376s16.576 3.328 22.624 9.376c11.040 11.072 25.76 17.152 41.376 17.152s30.336-6.080 41.376-17.152c6.048-6.048 14.080-9.376 22.624-9.376s16.576 3.328 22.624 9.376l10.976 10.976c11.072 11.072 25.76 17.152 41.376 17.152h53.024c35.296 0 64 28.704 64 64v53.024c0 15.616 6.080 30.336 17.12 41.376l10.976 10.976c12.48 12.48 12.48 32.768 0 45.248l-5.248 5.248c-17.824 17.824-22.24 44.992-10.976 67.552l12.512 25.056c22.4 44.8 22.4 98.304 0 143.104l-12.544 25.056c-11.296 22.56-6.88 49.696 10.976 67.552l5.216 5.216c6.048 6.048 9.376 14.080 9.376 22.624 0.064 8.512-3.264 16.544-9.28 22.592z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"frame",
						"show",
						"hang"
					],
					"grid": 32
				},
				{
					"id": 236,
					"paths": [
						"M742.4 460.8h-102.4c-42.349 0-76.8-34.451-76.8-76.8v-102.4c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v102.4c0 14.115 11.485 25.6 25.6 25.6h102.4c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M332.8 460.8h-102.4c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h102.4c14.115 0 25.6-11.485 25.6-25.6v-102.4c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v102.4c0 42.349-34.453 76.8-76.8 76.8z",
						"M588.8 819.2c-14.139 0-25.6-11.461-25.6-25.6v-102.4c0-42.349 34.451-76.8 76.8-76.8h102.4c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6h-102.4c-14.115 0-25.6 11.485-25.6 25.6v102.4c0 14.139-11.461 25.6-25.6 25.6z",
						"M384 819.2c-14.138 0-25.6-11.461-25.6-25.6v-102.4c0-14.115-11.485-25.6-25.6-25.6h-102.4c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h102.4c42.347 0 76.8 34.451 76.8 76.8v102.4c0 14.139-11.462 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"frame-contract",
						"minimize"
					],
					"defaultCode": 59533,
					"grid": 20
				},
				{
					"id": 235,
					"paths": [
						"M947.2 358.4c-14.139 0-25.6-11.462-25.6-25.6v-102.4c0-14.115-11.485-25.6-25.6-25.6h-102.4c-14.139 0-25.6-11.462-25.6-25.6s11.461-25.6 25.6-25.6h102.4c42.349 0 76.8 34.453 76.8 76.8v102.4c0 14.138-11.461 25.6-25.6 25.6z",
						"M25.6 358.4c-14.138 0-25.6-11.462-25.6-25.6v-102.4c0-42.347 34.453-76.8 76.8-76.8h102.4c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-102.4c-14.115 0-25.6 11.485-25.6 25.6v102.4c0 14.138-11.462 25.6-25.6 25.6z",
						"M179.2 921.6h-102.4c-42.347 0-76.8-34.451-76.8-76.8v-102.4c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v102.4c0 14.115 11.485 25.6 25.6 25.6h102.4c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M896 921.6h-102.4c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h102.4c14.115 0 25.6-11.485 25.6-25.6v-102.4c0-14.139 11.461-25.6 25.6-25.6s25.6 11.461 25.6 25.6v102.4c0 42.349-34.451 76.8-76.8 76.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"frame-expand",
						"maximize",
						"view",
						"rectangle"
					],
					"defaultCode": 59532,
					"grid": 20
				},
				{
					"id": 530,
					"width": 1024,
					"paths": [
						"M256 192h512v640h-512v-640zM882.72 658.752c24.992 24.992 24.992 65.504 0 90.528l-10.976 10.976c-4.96 4.96-7.744 11.68-7.744 18.72v53.024c0 53.024-42.976 96-96 96h-53.024c-7.040 0-13.76 2.784-18.752 7.776l-10.976 10.976c-12.512 12.512-28.864 18.752-45.248 18.752s-32.768-6.24-45.248-18.752v0c-5.184-5.184-11.968-7.776-18.752-7.776s-13.568 2.592-18.752 7.776c-12.512 12.512-28.864 18.752-45.248 18.752s-32.768-6.24-45.248-18.752v0c-5.184-5.184-11.968-7.776-18.752-7.776s-13.568 2.592-18.752 7.776c-12.512 12.512-28.864 18.752-45.248 18.752s-32.768-6.24-45.248-18.752l-10.976-10.976c-4.992-4.992-11.712-7.776-18.752-7.776h-53.024c-53.024 0-96-42.976-96-96v-53.024c0-7.040-2.784-13.76-7.776-18.752l-10.976-10.976c-24.992-24.992-24.992-65.504 0-90.496l5.248-5.248c8.064-8.064 10.080-20.384 4.96-30.592l-12.512-25.056c-27.040-54.048-27.040-117.664 0-171.712l12.512-25.056c5.088-10.208 3.104-22.528-4.96-30.592l-5.216-5.216c-24.992-24.992-24.992-65.536 0-90.528l10.976-10.976c4.96-4.96 7.744-11.712 7.744-18.752v-53.024c0-53.024 42.976-96 96-96h53.024c7.040 0 13.76-2.784 18.752-7.776l10.976-10.976c12.48-12.48 28.864-18.752 45.248-18.752s32.768 6.24 45.248 18.752c5.184 5.184 11.968 7.776 18.752 7.776s13.568-2.592 18.752-7.776v0c12.48-12.48 28.864-18.752 45.248-18.752s32.768 6.24 45.248 18.752c5.184 5.184 11.968 7.776 18.752 7.776s13.568-2.592 18.752-7.776v0c12.48-12.48 28.864-18.752 45.248-18.752s32.768 6.24 45.248 18.752l10.976 10.976c4.992 4.992 11.712 7.776 18.752 7.776h53.024c53.024 0 96 42.976 96 96v53.024c0 7.040 2.784 13.76 7.776 18.752l10.976 10.976c24.992 24.992 24.992 65.504 0 90.496l-5.248 5.248c-8.064 8.064-10.080 20.384-4.96 30.592l12.512 25.056c27.008 54.048 27.040 117.664 0 171.712l-12.544 25.056c-5.088 10.208-3.104 22.528 4.96 30.592l5.248 5.248zM800 192c0-17.664-14.336-32-32-32h-512c-17.664 0-32 14.336-32 32v640c0 17.664 14.336 32 32 32h512c17.664 0 32-14.336 32-32v-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"frame",
						"show",
						"hang"
					],
					"grid": 32
				},
				{
					"id": 1035,
					"width": 1024,
					"paths": [
						"M224 896h576v-768h-576v768zM256 160h512v704h-512v-704zM928 152.736v-4.256c0-81.856-66.624-148.48-148.48-148.48-9.824 0-19.648 0.96-29.12 2.88l-140.352 28.064-51.104-17.024c-30.272-10.080-63.648-10.080-93.888 0l-51.136 17.024-140.288-28.064c-9.568-1.92-19.36-2.88-29.152-2.88-81.856 0-148.48 66.624-148.48 148.48v4.288c0 6.176 0.384 12.352 1.152 18.432l30.176 241.568-17.408 52.288c-10.080 30.272-10.080 63.616 0 93.888l17.408 52.288-30.176 241.536c-0.768 6.144-1.152 12.32-1.152 18.496v4.288c0 81.824 66.624 148.448 148.48 148.448 9.824 0 19.648-0.96 29.12-2.88l140.352-28.064 51.104 17.024c30.272 10.080 63.648 10.080 93.888 0l51.136-17.024 140.32 28.064c9.536 1.92 19.328 2.88 29.12 2.88 81.856 0 148.48-66.624 148.48-148.48v-4.288c0-6.176-0.384-12.352-1.152-18.432l-30.176-241.568 17.44-52.32c10.080-30.272 10.048-63.616 0-93.856l-17.408-52.288 30.176-241.536c0.736-6.144 1.12-12.32 1.12-18.496zM864 152.736c0 3.488-0.224 6.976-0.672 10.496l-32 256 22.016 66.048c5.728 17.216 5.76 36.192 0 53.408l-22.016 66.080 32 256.032c0.448 3.488 0.672 6.944 0.672 10.464v4.288c0 46.592-37.888 84.48-84.48 84.48-5.568 0-11.136-0.544-16.576-1.632l-156.992-31.392-67.264 22.4c-17.216 5.76-36.16 5.76-53.408 0l-67.232-22.4-157.088 31.392c-5.344 1.056-10.912 1.6-16.48 1.6-46.592 0-84.48-37.888-84.48-84.48v-4.288c0-3.488 0.224-6.976 0.672-10.496l32-256-22.016-66.048c-5.76-17.216-5.76-36.192 0-53.408l22.016-66.048-32-256.032c-0.448-3.488-0.672-6.944-0.672-10.464v-4.256c0-46.592 37.888-84.48 84.48-84.48 5.568 0 11.136 0.544 16.576 1.632l156.992 31.392 67.264-22.4c17.216-5.76 36.16-5.76 53.408 0l67.232 22.4 157.088-31.392c5.344-1.088 10.912-1.632 16.48-1.632 46.592 0 84.48 37.888 84.48 84.48v4.256zM288 832h448v-640h-448v640zM320 224h384v576h-384v-576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"frame",
						"show",
						"hang"
					],
					"grid": 32
				},
				{
					"id": 1429,
					"width": 877.7139282226562,
					"paths": [
						"M648 702.286q4.571 14.286-2.286 27.714t-21.143 18-28-2.286-18.286-21.714q-14.286-45.714-52.857-74t-86.571-28.286-86.571 28.286-52.857 74q-4.571 14.857-18 21.714t-27.714 2.286q-14.857-4.571-21.714-18t-2.286-27.714q21.143-69.143 78.857-111.429t130.286-42.286 130.286 42.286 78.857 111.429zM365.714 365.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM658.286 365.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM804.571 512q0-74.286-29.143-142t-78-116.571-116.571-78-142-29.143-142 29.143-116.571 78-78 116.571-29.143 142 29.143 142 78 116.571 116.571 78 142 29.143 142-29.143 116.571-78 78-116.571 29.143-142zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"frown-o"
					],
					"defaultCode": 61721,
					"grid": 14
				},
				{
					"id": 2871,
					"paths": [
						"M366.312 283.378c-34.742-17.37-69.102-26.060-70.548-26.422-17.146-4.288-34.518 6.138-38.806 23.284-4.284 17.144 6.14 34.518 23.282 38.804 17.626 4.45 38.522 12.12 56.936 21.35-10.648 11.43-17.174 26.752-17.174 43.606 0 35.346 28.654 64 64 64s64-28.654 64-64c0-1.17-0.036-2.33-0.098-3.484-2.032-47.454-45.212-78.946-81.592-97.138z",
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM236.498 823.664c10.706 5.324 22.756 8.336 35.502 8.336h480c12.746 0 24.796-3.012 35.502-8.338-73.378 64.914-169.828 104.338-275.502 104.338-105.672 0-202.124-39.424-275.502-104.336zM256 752v-96c0-8.674 7.328-16 16-16h112v128h-112c-8.672 0-16-7.326-16-16zM448 768v-128h128v128h-128zM640 768v-128h112c8.674 0 16 7.326 16 16v96c0 8.674-7.326 16-16 16h-112zM823.662 787.502c5.326-10.706 8.338-22.756 8.338-35.502v-96c0-44.112-35.888-80-80-80h-480c-44.112 0-80 35.888-80 80v96c0 12.746 3.012 24.796 8.336 35.502-64.912-73.378-104.336-169.828-104.336-275.502 0-229.75 186.25-416 416-416s416 186.25 416 416c0 105.674-39.424 202.124-104.338 275.502z",
						"M728.236 256.956c-1.448 0.362-35.806 9.052-70.548 26.422-36.378 18.192-79.558 49.684-81.592 97.138-0.060 1.154-0.098 2.314-0.098 3.484 0 35.346 28.654 64 64 64s64-28.654 64-64c0-16.854-6.526-32.176-17.174-43.606 18.414-9.23 39.31-16.9 56.936-21.35 17.142-4.286 27.566-21.66 23.284-38.804-4.29-17.146-21.662-27.572-38.808-23.284z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"frustrated",
						"emoticon",
						"smiley",
						"face",
						"angry"
					],
					"defaultCode": 60706,
					"grid": 16
				},
				{
					"id": 2872,
					"paths": [
						"M256 656v96c0 8.674 7.328 16 16 16h112v-128h-112c-8.672 0-16 7.326-16 16z",
						"M448 640h128v128h-128v-128z",
						"M752 640h-112v128h112c8.674 0 16-7.326 16-16v-96c0-8.674-7.326-16-16-16z",
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576.096 380.516c2.034-47.454 45.212-78.946 81.592-97.138 34.742-17.37 69.102-26.060 70.548-26.422 17.146-4.288 34.518 6.138 38.806 23.284 4.284 17.144-6.14 34.518-23.284 38.804-17.624 4.45-38.522 12.12-56.936 21.35 10.648 11.43 17.174 26.752 17.174 43.606 0 35.346-28.654 64-64 64s-64-28.654-64-64c0.002-1.17 0.040-2.33 0.1-3.484zM256.958 280.24c4.288-17.146 21.66-27.572 38.806-23.284 1.446 0.362 35.806 9.052 70.548 26.422 36.38 18.192 79.56 49.684 81.592 97.138 0.062 1.154 0.098 2.314 0.098 3.484 0 35.346-28.654 64-64 64s-64-28.654-64-64c0-16.854 6.526-32.176 17.174-43.606-18.414-9.23-39.31-16.9-56.936-21.35-17.142-4.286-27.566-21.66-23.282-38.804zM832 752c0 44.112-35.888 80-80 80h-480c-44.112 0-80-35.888-80-80v-96c0-44.112 35.888-80 80-80h480c44.112 0 80 35.888 80 80v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"frustrated",
						"emoticon",
						"smiley",
						"face",
						"angry"
					],
					"defaultCode": 60707,
					"grid": 16
				},
				{
					"id": 238,
					"paths": [
						"M830.966 169.328c-20.294-13.707-48.59-25.803-84.106-35.95-69.917-19.976-162.418-30.978-260.461-30.978-98.045 0-190.544 11.002-260.461 30.978-35.515 10.147-63.813 22.243-84.104 35.95-32.594 22.016-39.435 45.363-39.435 61.072v25.6c0 21.894 16.451 58.026 32.701 82.4l250.398 375.598c12.838 19.259 24.101 56.456 24.101 79.602v153.6c0 8.872 4.594 17.112 12.141 21.776 4.11 2.541 8.778 3.824 13.459 3.824 3.912 0 7.835-0.898 11.448-2.702l102.4-51.2c8.674-4.336 14.152-13.2 14.152-22.898v-102.4c0-23.146 11.262-60.342 24.099-79.602l250.4-375.598c16.251-24.373 32.701-60.504 32.701-82.4v-25.6c0-15.709-6.842-39.056-39.434-61.072zM240.005 182.606c65.47-18.706 152.974-29.006 246.395-29.006s180.925 10.301 246.394 29.006c70.533 20.154 86.406 41.798 86.406 47.794s-15.874 27.64-86.406 47.794c-65.469 18.706-152.973 29.006-246.394 29.006s-180.925-10.301-246.395-29.006c-70.531-20.154-86.405-41.798-86.405-47.794s15.874-27.64 86.405-47.794zM544.701 685.598c-18.338 27.504-32.701 74.946-32.701 108.002v86.578l-51.2 25.6v-112.178c0-33.056-14.363-80.496-32.701-108.002l-249.859-374.79c14.035 5.997 29.966 11.549 47.699 16.614 69.917 19.976 162.416 30.978 260.461 30.978 98.043 0 190.544-11.002 260.459-30.978 17.733-5.067 33.666-10.619 47.702-16.616l-249.861 374.792z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"funnel",
						"filter"
					],
					"defaultCode": 59535,
					"grid": 20
				},
				{
					"id": 2803,
					"paths": [
						"M896 384c-70.694 0-128 57.308-128 128v128h-512v-128c0-70.692-57.308-128-128-128s-128 57.308-128 128v256c0 70.694 57.308 128 128 128v128h64l32-128h576l32 128h64v-128c70.694 0 128-57.306 128-128v-256c0-70.692-57.306-128-128-128z",
						"M320 492v84h384v-84c0-105.104 64-172 189.708-171.97-15.562-108.424-109.048-192.030-221.708-192.030h-320c-112.66 0-206.146 83.606-221.708 192.030 125.708-0.030 189.708 66.866 189.708 171.97z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"furniture",
						"couch",
						"chair"
					],
					"defaultCode": 60638,
					"grid": 16
				},
				{
					"id": 1618,
					"width": 1024,
					"paths": [
						"M348 466.286l164-118.857 164 118.857-62.286 192h-202.857zM512 0q104 0 198.857 40.571t163.429 109.143 109.143 163.429 40.571 198.857-40.571 198.857-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571zM865.714 771.429q85.143-116 85.143-259.429v-1.714l-58.286 50.857-137.143-128 36-184.571 76.571 6.857q-85.714-117.714-222.286-161.143l30.286 70.857-164 90.857-164-90.857 30.286-70.857q-136.571 43.429-222.286 161.143l77.143-6.857 35.429 184.571-137.143 128-58.286-50.857v1.714q0 143.429 85.143 259.429l17.143-75.429 186.286 22.857 79.429 170.286-66.286 39.429q66.857 22.286 137.143 22.286t137.143-22.286l-66.286-39.429 79.429-170.286 186.286-22.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"futbol-o",
						"soccer-ball-o"
					],
					"defaultCode": 61923,
					"grid": 14
				},
				{
					"id": 1036,
					"width": 1024,
					"paths": [
						"M608 608h-64v-64h64v64zM864 544h-64v64h64v-64zM864 800h-64v64h64v-64zM608 800h-64v64h64v-64zM736 672h-64v64h64v-64zM480 160h-64v64h64v-64zM160 480h64v-64h-64v64zM288 352h64v-64h-64v64zM992 448v512c0 17.664-14.336 32-32 32h-512c-17.664 0-32-14.336-32-32v-352h-352c-17.664 0-32-14.336-32-32v-512c0-17.664 14.336-32 32-32h512c17.664 0 32 14.336 32 32v352h352c17.664 0 32 14.336 32 32zM96 544h352v-96h96v-352h-448v448zM928 480h-448v448h448v-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gamble",
						"game",
						"play",
						"roll",
						"risk"
					],
					"grid": 32
				},
				{
					"id": 531,
					"width": 1024,
					"paths": [
						"M1017.984 588.992l-68.064-296.16c-25.888-79.456-98.976-132.832-181.92-132.832-54.816 0-105.856 23.136-142.368 64h-227.264c-36.512-40.864-87.552-64-142.368-64-82.944 0-156.032 53.376-181.888 132.832l-68.096 296.288c-4 17.024-6.016 34.208-6.016 50.88 0 123.52 100.48 224 224 224 86.848 0 165.44-50.592 202.208-128h171.616c36.768 77.408 115.36 128 202.208 128 123.52 0 224-100.48 224-224-0.032-16.672-2.048-33.856-6.048-51.008zM800 832c-83.552 0-154.464-53.472-180.832-128h-214.336c-26.4 74.528-97.28 128-180.832 128-106.048 0-192-85.952-192-192 0-15.072 1.92-29.664 5.184-43.712l67.328-293.536c20.896-64.096 80.416-110.752 151.488-110.752 52.16 0 98.080 25.344 127.264 64h257.44c29.216-38.656 75.136-64 127.296-64 71.072 0 130.592 46.656 151.456 110.752l67.328 293.536c3.296 14.048 5.216 28.64 5.216 43.712 0 106.048-85.952 192-192 192zM640 352c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM640 448c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM800 320c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM800 416c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM640 512c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM640 608c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM800 480c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM800 576c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM352 416h-32v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-32c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h32v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32h32c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM352 512h-64v64h-64v-64h-64v-64h64v-64h64v64h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"game",
						"play",
						"win",
						"compete",
						"mash"
					],
					"grid": 32
				},
				{
					"id": 532,
					"width": 1024,
					"paths": [
						"M832 544c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM640 544c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM288 384h-64v64h-64v64h64v64h64v-64h64v-64h-64v-64zM640 384c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM800 352c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM1024 640c0 123.52-100.48 224-224 224-86.848 0-165.44-50.592-202.208-128h-171.616c-36.736 77.408-115.328 128-202.176 128-123.52 0-224-100.48-224-224 0-16.672 2.016-33.856 6.016-50.88l68.096-296.288c25.856-79.456 98.944-132.832 181.888-132.832 54.816 0 105.856 23.136 142.368 64h227.264c36.512-40.864 87.552-64 142.368-64 82.944 0 156.032 53.376 181.888 132.832l68.064 296.16c4.032 17.152 6.048 34.336 6.048 51.008zM384 448c0-17.664-14.336-32-32-32h-32v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-32c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h32v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32h32c17.664 0 32-14.336 32-32v-64zM704 576c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64zM704 416c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64zM864 544c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64zM864 384c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"game",
						"play",
						"win",
						"compete",
						"mash"
					],
					"grid": 32
				},
				{
					"id": 1037,
					"width": 1024,
					"paths": [
						"M915.936 800c-23.104-62.016-76.416-107.68-128.16-152.032-35.2-30.144-68.416-58.656-89.152-89.728-22.528-33.792-39.552-87.904-49.568-157.28 65.952-50.976 99.104-134.432 82.848-220.256-16.96-89.504-89.728-161.344-179.424-177.152-141.28-24.864-264.48 83.68-264.48 220.448 0 69.92 32.16 134.656 86.944 176.992-10.016 69.344-27.040 123.488-49.568 157.28-20.704 31.072-53.952 59.552-89.152 89.728-51.744 44.32-105.056 89.984-128.16 152h-44.064c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32h-44.064zM352 224c0-42.592 15.712-84.224 41.76-116.032 32.544-32.32 75.232-53.952 118.24-53.952 31.552 0 62.208 10.592 88.672 28.064 42.944 32.48 71.328 86.464 71.328 141.92 0 88.224-71.776 160-160 160s-160-71.776-160-160zM277.888 696.576c36.928-31.648 75.136-64.384 100.736-102.816 29.088-43.648 49.44-108.384 60.704-192.096 22.432 9.184 46.944 14.336 72.672 14.336s50.24-5.152 72.672-14.336c11.296 83.712 31.616 148.448 60.704 192.096 25.6 38.432 63.808 71.168 100.736 102.816 50.56 43.328 98.016 84.448 112.576 135.424h-693.408c14.56-51.008 62.048-92.128 112.608-135.424zM928 960h-832v-96h832v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"game",
						"play",
						"win"
					],
					"grid": 32
				},
				{
					"id": 1920,
					"paths": [
						"M320 320h-64v64h-64v64h64v64h64v-64h64v-64h-64zM640 368c0-26.51 21.49-48 48-48s48 21.49 48 48c0 26.51-21.49 48-48 48s-48-21.49-48-48zM736 464c0-26.51 21.49-48 48-48s48 21.49 48 48c0 26.51-21.49 48-48 48s-48-21.49-48-48zM739.472 171.852c-116.22 0-134.362 68.834-227.47 68.842-93.11-0.008-111.25-68.842-227.47-68.842-187.472 0-284.532 229.474-284.532 393.626 0 155.302 14.592 268.31 72.688 284.17 58.126 15.916 132.17-46.758 204.35-114.72 72.162-67.962 84.348-63.542 142.458-63.542l92.504 2.044 92.504-2.042c58.112 0 70.296-4.422 142.458 63.542 72.18 67.962 146.222 130.636 204.35 114.72 58.096-15.86 72.688-128.868 72.688-284.172 0-164.152-97.058-393.626-284.528-393.626zM288 576c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160-71.634 160-160 160zM736 576c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160-71.634 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gamepad",
						"game",
						"video-game",
						"controller",
						"joystick"
					],
					"defaultCode": 59755,
					"grid": 16
				},
				{
					"id": 1921,
					"paths": [
						"M951.862 315.868c-25.986-42.434-56.986-76.050-92.126-99.914-40.086-27.214-84.516-41.014-132.058-41.014-65.116 0-101.662 20.594-133.908 38.764-26.282 14.808-47.040 26.506-81.764 26.51-34.732-0.002-55.492-11.702-81.774-26.51-32.244-18.168-68.79-38.762-133.904-38.762-47.544 0-91.974 13.798-132.054 41.012-35.148 23.864-66.144 57.48-92.132 99.914-45.174 73.76-72.142 170.522-72.142 258.84 0 84.848 4.582 145.218 14.42 189.992 13.346 60.728 37.57 95.096 74.034 105.046 8.028 2.2 16.48 3.312 25.124 3.312 62.876 0 130.236-58.47 193.844-118.364 56.36-53.082 66.342-53.082 99.416-53.082 2.516 0 5.126 0.012 7.85 0.028 2.966 0.016 6.062 0.030 9.306 0.030l88.006 1.948 88.004-1.948c3.244 0 6.338-0.014 9.304-0.030 2.72-0.016 5.338-0.028 7.852-0.028 33.074 0 43.058 0 99.42 53.082 63.606 59.89 130.962 118.364 193.84 118.366 0.002 0 0.002 0 0.004 0 8.64 0 17.094-1.118 25.102-3.306 36.486-9.958 60.708-44.324 74.052-105.050 9.838-44.778 14.422-105.148 14.422-189.996 0-88.318-26.968-185.080-72.138-258.84zM947.068 750.964c-7.108 32.348-17.986 54.208-28.436 57.056-2.516 0.69-5.278 1.040-8.21 1.040-42.75-0.002-115.166-68.19-149.96-100.958-34.078-32.096-54.238-47.662-74.384-57.438-26.906-13.052-49.224-13.052-68.914-13.052-2.628 0-5.366 0.012-8.194 0.028-2.856 0.016-5.84 0.030-8.962 0.030h-0.708l-87.3 1.932-88.006-1.932c-3.126 0-6.108-0.014-8.944-0.028-2.85-0.018-5.582-0.030-8.212-0.030-19.69 0-42.008 0-68.914 13.054-20.144 9.774-40.304 25.34-74.376 57.43-34.802 32.77-107.22 100.958-149.97 100.958-2.936 0-5.7-0.352-8.272-1.052-10.396-2.838-21.27-24.696-28.378-57.042-8.82-40.138-12.928-96.146-12.928-176.252 0-37.608 5.802-78.304 16.782-117.696 10.944-39.268 26.83-76.516 45.938-107.718 21.206-34.624 45.936-61.672 73.506-80.39 29.278-19.88 61.61-29.96 96.102-29.96 48.322 0 73.42 14.142 102.502 30.528 28.902 16.284 61.66 34.74 113.184 34.744 51.504-0.006 84.26-18.46 113.176-34.752 29.062-16.376 54.164-30.52 102.488-30.52 34.488 0 66.822 10.082 96.1 29.96 27.574 18.724 52.304 45.772 73.506 80.392 19.11 31.202 34.992 68.45 45.938 107.718 10.976 39.39 16.782 80.088 16.782 117.698-0.004 80.092-4.114 136.104-12.936 176.252v0zM640 384c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64zM768 512c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64zM256 320c-70.58 0-128 57.42-128 128s57.42 128 128 128 128-57.42 128-128-57.42-128-128-128v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gamepad",
						"game",
						"video-game",
						"controller",
						"joystick"
					],
					"defaultCode": 59756,
					"grid": 16
				},
				{
					"id": 1922,
					"width": 1280,
					"paths": [
						"M992 193.588v-1.588h-672c-176.73 0-320 143.27-320 320s143.27 320 320 320c104.69 0 197.632-50.278 256.014-128h127.97c58.378 77.722 151.324 128 256.016 128 176.732 0 320-143.268 320-320 0-165.93-126.292-302.356-288-318.412zM512 576h-128v128h-128v-128h-128v-128h128v-128h128v128h128v128zM896 576c-35.348 0-64-28.654-64-64s28.652-64 64-64 64 28.654 64 64-28.652 64-64 64zM1088 576c-35.348 0-64-28.654-64-64 0-35.348 28.652-64 64-64s64 28.652 64 64c0 35.346-28.652 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gamepad",
						"game",
						"video-game",
						"controller",
						"joystick"
					],
					"defaultCode": 59757,
					"grid": 16
				},
				{
					"id": 1431,
					"width": 1097.1438903808594,
					"paths": [
						"M475.429 621.714v-73.143q0-8-5.143-13.143t-13.143-5.143h-109.714v-109.714q0-8-5.143-13.143t-13.143-5.143h-73.143q-8 0-13.143 5.143t-5.143 13.143v109.714h-109.714q-8 0-13.143 5.143t-5.143 13.143v73.143q0 8 5.143 13.143t13.143 5.143h109.714v109.714q0 8 5.143 13.143t13.143 5.143h73.143q8 0 13.143-5.143t5.143-13.143v-109.714h109.714q8 0 13.143-5.143t5.143-13.143zM804.571 658.286q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM950.857 512q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM1097.143 585.143q0 121.143-85.714 206.857t-206.857 85.714q-109.714 0-193.143-73.143h-125.714q-83.429 73.143-193.143 73.143-121.143 0-206.857-85.714t-85.714-206.857 85.714-206.857 206.857-85.714h512q121.143 0 206.857 85.714t85.714 206.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gamepad"
					],
					"defaultCode": 61723,
					"grid": 14
				},
				{
					"id": 2594,
					"paths": [
						"M950.626 265.372l-128-128c-6-6-14.14-9.372-22.626-9.372h-64c-17.674 0-32 14.328-32 32s14.326 32 32 32h34.744l64 64h-34.744c-17.674 0-32 14.328-32 32v128c0 17.672 14.326 32 32 32h96v256c0 35.29-28.71 64-64 64s-64-28.71-64-64v-160c0-17.674-14.326-32-32-32h-96v-352c0-52.812-43.188-96-96-96h-384c-52.812 0-96 43.188-96 96v800h-64v64h704v-64h-64v-384h64v128c0 70.58 57.42 128 128 128s128-57.42 128-128v-416c0-8.488-3.372-16.626-9.374-22.628zM128 352v-192c0-17.594 14.406-32 32-32h384c17.624 0 32 14.406 32 32v192c0 17.594-14.376 32-32 32h-384c-17.594 0-32-14.406-32-32zM832 384v-64h64v64h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gas",
						"fuel",
						"gas-pump",
						"gas-station",
						"oil"
					],
					"defaultCode": 60429,
					"grid": 16
				},
				{
					"id": 533,
					"width": 1024,
					"paths": [
						"M576 96c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM928 336c0 18.048-6.048 34.624-16.128 48h0.128c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16v480c0 53.024-42.976 96-96 96h-576c-53.024 0-96-42.976-96-96v-480h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16h1.728c-11.072-14.784-17.728-33.184-17.728-52.576v-4.992c0-24.32 11.040-47.296 30.016-62.464l30.016-23.968c11.68-9.344 28.288-9.344 39.968 0l29.984 24c18.976 15.168 30.016 38.144 30.016 62.432v9.568c0 18.048-6.048 34.624-16.128 48h0.128c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16v192h96v-64h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16h40.928c-15.328-17.024-24.928-39.296-24.928-64 0-59.968 29.984-115.968 79.872-149.248l96.128-64.064v-12.16c-45.216-7.744-79.808-46.976-79.808-94.368 0-52.928 43.072-96 96-96 7.616 0 15.488 1.088 24.032 3.296 14.112 3.648 23.968 16.384 23.968 30.976s-9.856 27.328-23.968 30.976c-14.144 3.68-24.032 16.32-24.032 30.752s9.888 27.104 24.032 30.752c14.112 3.648 23.968 16.384 23.968 30.976s-9.856 27.328-23.968 30.976c-2.912 0.768-5.44 0.64-8.224 1.12v12.672l96.128 64.064c49.888 33.312 79.872 89.312 79.872 149.28 0 24.704-9.6 46.976-24.928 64h40.928c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16v64h96v-192h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16h1.728c-11.072-14.784-17.728-33.184-17.728-52.576v-4.992c0-24.32 11.040-47.296 30.016-62.464l29.984-24c11.68-9.344 28.288-9.344 39.968 0l29.984 24c19.008 15.2 30.048 38.176 30.048 62.464v9.568zM512.192 192.192c5.568 0 10.848-0.928 16-2.272-27.552-7.136-48-31.936-48-61.728s20.448-54.592 48-61.728c-5.152-1.344-10.432-2.272-16-2.272-35.36 0-64 28.64-64 64 0 35.328 28.64 64 64 64zM352 448c0 35.296 28.704 64 64 64h192c35.296 0 64-28.704 64-64 0-49.376-24.544-95.232-65.632-122.624l-94.368-62.912-94.368 62.912c-41.088 27.392-65.632 73.248-65.632 122.624zM176 384c26.464 0 48-21.536 48-48v-9.568c0-14.656-6.56-28.32-18.016-37.472l-29.984-23.968-29.984 23.968c-11.456 9.184-18.016 22.816-18.016 37.504v9.536c0 26.464 21.536 48 48 48zM576 800c0-35.36-28.64-64-64-64s-64 28.64-64 64v160h128v-160zM864 416h-32v192c0 17.664-14.336 32-32 32h-96c-17.664 0-32-14.336-32-32v-64h-320v64c0 17.664-14.336 32-32 32h-96c-17.664 0-32-14.336-32-32v-192h-32v480c0 35.36 28.64 64 64 64h192v-160c0-54.72 45.792-98.752 101.152-95.872 51.936 2.72 90.848 49.312 90.848 101.312v154.56h192c35.36 0 64-28.64 64-64v-480zM896 326.432c0-14.656-6.56-28.32-18.016-37.472l-29.984-23.968-29.984 24c-11.456 9.152-18.016 22.784-18.016 37.472v9.536c0 26.464 21.536 48 48 48s48-21.536 48-48v-9.568z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gather",
						"worship",
						"pray"
					],
					"grid": 32
				},
				{
					"id": 534,
					"width": 1024,
					"paths": [
						"M576 96c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM768 400c0 8.832 7.168 16 16 16h128c8.832 0 16-7.168 16-16s-7.168-16-16-16h-0.128c10.080-13.376 16.128-29.952 16.128-48v-9.568c0-24.288-11.040-47.296-30.016-62.464l-29.984-23.968c-11.68-9.344-28.288-9.344-39.968 0l-29.984 24c-19.008 15.168-30.048 38.144-30.048 62.464v4.992c0 19.36 6.656 37.792 17.728 52.576h-1.728c-8.832-0.032-16 7.136-16 15.968zM304 544h416c8.832 0 16-7.168 16-16s-7.168-16-16-16h-40.928c15.328-17.024 24.928-39.296 24.928-64 0-59.968-29.984-115.968-79.872-149.248l-96.128-64.064v-12.672c2.784-0.48 5.28-0.352 8.224-1.12 14.112-3.648 23.968-16.384 23.968-30.976s-9.856-27.328-23.968-30.976c-14.144-3.68-24.032-16.32-24.032-30.752s9.888-27.104 24.032-30.752c14.112-3.648 23.968-16.384 23.968-30.976s-9.856-27.328-23.968-30.976c-8.544-2.208-16.384-3.296-24.032-3.296-52.928 0-96 43.072-96 96 0 47.392 34.592 86.624 79.808 94.368v12.16l-96.128 64.064c-49.888 33.248-79.872 89.248-79.872 149.216 0 24.704 9.6 46.976 24.928 64h-40.928c-8.832 0-16 7.168-16 16s7.168 16 16 16zM800 448v160h-96v-32h-384v32h-96v-160h-96v448c0 53.024 42.976 96 96 96h192v-192c0-54.72 45.792-98.752 101.152-95.872 51.936 2.72 90.848 49.312 90.848 101.312v186.56h192c53.024 0 96-42.976 96-96v-448h-96zM512 736c-35.36 0-64 28.64-64 64v192h128v-192c0-35.36-28.64-64-64-64zM96 400c0 8.832 7.168 16 16 16h128c8.832 0 16-7.168 16-16s-7.168-16-16-16h-0.128c10.080-13.376 16.128-29.952 16.128-48v-9.568c0-24.288-11.040-47.296-30.016-62.464l-29.984-23.968c-11.68-9.344-28.288-9.344-39.968 0l-29.984 24c-19.008 15.168-30.048 38.144-30.048 62.464v4.992c0 19.36 6.656 37.76 17.728 52.544h-1.728c-8.832 0-16 7.168-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gather",
						"worship",
						"pray"
					],
					"grid": 32
				},
				{
					"id": 1380,
					"width": 1034.8558959960938,
					"paths": [
						"M1012 877.714q0 30.286-21.143 51.429l-61.143 61.714q-22.286 21.143-52 21.143-30.286 0-51.429-21.143l-207.429-208q-21.714-20.571-21.714-51.429 0-30.286 24.571-54.857l-146.286-146.286-72 72q-8 8-19.429 8t-19.429-8q1.143 1.143 7.143 6.857t7.143 7.429 5.714 6.571 5.714 7.714 3.429 7.714 3.143 9.429 0.857 10.286q0 21.714-16 38.857-1.714 1.714-9.429 10.286t-10.857 11.714-10.571 9.429-12.571 8.857-12.571 5.143-14.857 2.571q-22.857 0-38.857-16l-233.143-233.143q-16-16-16-38.857 0-7.429 2.571-14.857t5.143-12.571 8.857-12.571 9.429-10.571 11.714-10.857 10.286-9.429q17.143-16 38.857-16 5.714 0 10.286 0.857t9.429 3.143 7.714 3.429 7.714 5.714 6.571 5.714 7.429 7.143 6.857 7.143q-8-8-8-19.429t8-19.429l198.857-198.857q8-8 19.429-8t19.429 8q-1.143-1.143-7.143-6.857t-7.143-7.429-5.714-6.571-5.714-7.714-3.429-7.714-3.143-9.429-0.857-10.286q0-21.714 16-38.857 1.714-1.714 9.429-10.286t10.857-11.714 10.571-9.429 12.571-8.857 12.571-5.143 14.857-2.571q22.857 0 38.857 16l233.143 233.143q16 16 16 38.857 0 7.429-2.571 14.857t-5.143 12.571-8.857 12.571-9.429 10.571-11.714 10.857-10.286 9.429q-17.143 16-38.857 16-5.714 0-10.286-0.857t-9.429-3.143-7.714-3.429-7.714-5.714-6.571-5.714-7.429-7.143-6.857-7.143q8 8 8 19.429t-8 19.429l-72 72 146.286 146.286q24.571-24.571 54.857-24.571 29.714 0 52 21.143l207.429 207.429q21.143 22.286 21.143 52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gavel",
						"legal"
					],
					"defaultCode": 61667,
					"grid": 14
				},
				{
					"id": 1484,
					"width": 582.8559789657593,
					"paths": [
						"M582.857 649.714v209.714q0 8-5.143 13.143t-13.143 5.143h-546.286q-8 0-13.143-5.143t-5.143-13.143v-85.714q0-7.429 5.429-12.857t12.857-5.429h55.429v-218.857h-54.286q-8 0-13.143-5.429t-5.143-12.857v-74.857q0-8 5.143-13.143t13.143-5.143h54.286v-127.429q0-97.714 70.571-161.143t179.714-63.429q105.714 0 191.429 71.429 5.143 4.571 5.714 11.714t-4 12.857l-58.857 72.571q-5.143 6.286-12.571 6.857-7.429 1.143-13.143-4-2.857-2.857-14.857-10.857t-39.429-18.286-53.143-10.286q-48.571 0-78.286 26.857t-29.714 70.286v122.857h174.286q7.429 0 12.857 5.143t5.429 13.143v74.857q0 7.429-5.429 12.857t-12.857 5.429h-174.286v216.571h236.571v-103.429q0-7.429 5.143-12.857t13.143-5.429h92.571q8 0 13.143 5.429t5.143 12.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gbp"
					],
					"defaultCode": 61780,
					"grid": 14
				},
				{
					"id": 1687,
					"width": 658.2860412597656,
					"paths": [
						"M585.143 548.571q0-105.714-75.143-180.857t-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143 180.857-75.143 75.143-180.857zM658.286 548.571q0 66.857-26 127.714t-70.286 105.143-105.143 70.286-127.714 26-127.714-26-105.143-70.286-70.286-105.143-26-127.714 26-127.714 70.286-105.143 105.143-70.286 127.714-26 127.714 26 105.143 70.286 70.286 105.143 26 127.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"genderless"
					],
					"defaultCode": 61997,
					"grid": 14
				},
				{
					"id": 1738,
					"width": 982.8579711914062,
					"paths": [
						"M894.286 73.143q37.143 0 62.857 26t25.714 63.143v296.571q0 100.571-38.857 192t-104.286 157.143-156.571 104.286-191.143 38.571q-100.571 0-191.714-38.571t-156.857-104.286-104.571-157.143-38.857-192v-296.571q0-36.571 26.286-62.857t62.857-26.286h805.143zM492 681.143q26.857 0 46.857-18.857l230.857-221.714q21.143-20 21.143-48.571 0-28-19.714-47.714t-47.714-19.714q-26.857 0-46.857 18.857l-184.571 177.143-184.571-177.143q-20-18.857-46.286-18.857-28 0-47.714 19.714t-19.714 47.714q0 29.143 20.571 48.571l231.429 221.714q18.857 18.857 46.286 18.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"get-pocket"
					],
					"defaultCode": 62053,
					"grid": 14
				},
				{
					"id": 1733,
					"width": 1170.2850341796875,
					"paths": [
						"M420.571 457.143l219.429 219.429-219.429 219.429-384-384 384-384 96 96-54.857 54.857-41.143-41.143-274.286 274.286 274.286 274.286 110.286-110.286-165.143-164zM749.714 128l384 384-384 384-96-96 54.857-54.857 41.143 41.143 274.286-274.286-274.286-274.286-110.286 110.286 165.143 164-54.857 54.857-219.429-219.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gg"
					],
					"defaultCode": 62048,
					"grid": 14
				},
				{
					"id": 1734,
					"width": 1024,
					"paths": [
						"M409.714 773.714l154.857-154.857-159.429-159.429-50.286 50.286 109.714 109.143-54.857 54.857-159.429-159.429 159.429-159.429 22.857 22.857 49.714-49.714-72.571-73.143-259.429 259.429zM614.286 769.143l259.429-259.429-259.429-259.429-154.857 154.857 159.429 159.429 50.286-50.286-109.714-109.143 54.857-54.857 159.429 159.429-159.429 159.429-22.857-22.857-49.714 50.286zM1024 512q0 104-40.571 198.857t-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571 198.857 40.571 163.429 109.143 109.143 163.429 40.571 198.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gg-circle"
					],
					"defaultCode": 62049,
					"grid": 14
				},
				{
					"id": 2497,
					"paths": [
						"M771.516 320c18.126-12.88 35.512-27.216 51.444-43.148 33.402-33.402 55.746-74.5 62.912-115.722 7.858-45.186-3.672-87.14-31.63-115.1-22.3-22.298-52.51-34.086-87.364-34.086-49.632 0-101.922 23.824-143.46 65.362-66.476 66.476-105.226 158.238-126.076 223.722-15.44-65.802-46.206-154.644-106.018-214.458-32.094-32.092-73.114-48.57-111.846-48.57-31.654 0-61.78 11.004-84.26 33.486-49.986 49.988-43.232 137.786 15.086 196.104 20.792 20.792 45.098 38.062 70.72 52.412h-217.024v256h64v448h768v-448.002h64v-256h-188.484zM674.326 128.218c27.724-27.724 62.322-44.274 92.55-44.274 10.7 0 25.708 2.254 36.45 12.998 26.030 26.028 11.412 86.308-31.28 128.998-43.946 43.946-103.060 74.168-154.432 94.060h-50.672c18.568-57.548 52.058-136.456 107.384-191.782zM233.934 160.89c-0.702-9.12-0.050-26.248 12.196-38.494 10.244-10.244 23.788-12.396 33.348-12.396v0c21.258 0 43.468 10.016 60.932 27.48 33.872 33.872 61.766 87.772 80.668 155.876 0.51 1.84 1.008 3.67 1.496 5.486-1.816-0.486-3.646-0.984-5.486-1.496-68.104-18.904-122.002-46.798-155.874-80.67-15.828-15.826-25.77-36.16-27.28-55.786zM448 960h-256v-416h256v416zM448 512h-320v-128h320v128zM832 960h-256v-416h256v416zM896 512h-320v-128h320v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gift",
						"present",
						"box"
					],
					"defaultCode": 60332,
					"grid": 16
				},
				{
					"id": 2498,
					"paths": [
						"M771.516 320c18.126-12.88 35.512-27.216 51.444-43.148 33.402-33.402 55.746-74.5 62.912-115.722 7.858-45.186-3.672-87.14-31.63-115.1-22.3-22.298-52.51-34.086-87.364-34.086-49.632 0-101.922 23.824-143.46 65.362-66.476 66.476-105.226 158.238-126.076 223.722-15.44-65.802-46.206-154.644-106.018-214.458-32.094-32.092-73.114-48.57-111.846-48.57-31.654 0-61.78 11.004-84.26 33.486-49.986 49.988-43.232 137.786 15.086 196.104 20.792 20.792 45.098 38.062 70.72 52.412h-217.024v256h64v448h768v-448.002h64v-256h-188.484zM674.326 128.218c27.724-27.724 62.322-44.274 92.55-44.274 10.7 0 25.708 2.254 36.45 12.998 26.030 26.028 11.412 86.308-31.28 128.998-43.946 43.946-103.060 74.168-154.432 94.060h-50.672c18.568-57.548 52.058-136.456 107.384-191.782zM261.214 216.676c-15.828-15.828-25.77-36.16-27.28-55.786-0.702-9.12-0.050-26.248 12.196-38.494 10.244-10.244 23.788-12.396 33.348-12.396v0c21.258 0 43.468 10.016 60.932 27.48 33.872 33.872 61.766 87.772 80.668 155.876 0.51 1.84 1.008 3.67 1.496 5.486-1.816-0.486-3.646-0.984-5.486-1.496-68.104-18.902-122.004-46.798-155.874-80.67zM896 544h-320v416h-128v-416h-320v-32h320v-128h128v128h320v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gift",
						"present",
						"box"
					],
					"defaultCode": 60333,
					"grid": 16
				},
				{
					"id": 1280,
					"width": 877.7160177230835,
					"paths": [
						"M530.286 774.857v-409.143h-182.857v409.143q0 14.286 10.286 22t26.286 7.714h109.714q16 0 26.286-7.714t10.286-22zM269.714 292.571h111.429l-72-92q-14.857-17.714-39.429-17.714-22.857 0-38.857 16t-16 38.857 16 38.857 38.857 16zM662.857 237.714q0-22.857-16-38.857t-38.857-16q-24.571 0-39.429 17.714l-71.429 92h110.857q22.857 0 38.857-16t16-38.857zM877.714 384v182.857q0 8-5.143 13.143t-13.143 5.143h-54.857v237.714q0 22.857-16 38.857t-38.857 16h-621.714q-22.857 0-38.857-16t-16-38.857v-237.714h-54.857q-8 0-13.143-5.143t-5.143-13.143v-182.857q0-8 5.143-13.143t13.143-5.143h251.429q-53.143 0-90.571-37.429t-37.429-90.571 37.429-90.571 90.571-37.429q61.143 0 96 44l73.143 94.286 73.143-94.286q34.857-44 96-44 53.143 0 90.571 37.429t37.429 90.571-37.429 90.571-90.571 37.429h251.429q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gift"
					],
					"defaultCode": 61547,
					"grid": 14
				},
				{
					"id": 163,
					"paths": [
						"M947.2 256h-153.67c16.107-21.408 25.67-48.006 25.67-76.8 0-70.579-57.421-128-128-128-71.181 0-130.869 56.381-160.112 89.987-17.707 20.35-32.954 42.136-44.686 63.208-11.733-21.070-26.981-42.858-44.688-63.208-29.245-33.606-88.931-89.987-160.114-89.987-70.579 0-128 57.421-128 128 0 28.794 9.563 55.392 25.669 76.8h-153.669c-14.138 0-25.6 11.462-25.6 25.6v153.6c0 14.138 11.462 25.6 25.6 25.6h25.6v486.4c0 42.349 34.453 76.8 76.8 76.8h716.8c42.349 0 76.8-34.451 76.8-76.8v-486.4h25.6c14.139 0 25.6-11.462 25.6-25.6v-153.6c0-14.138-11.461-25.6-25.6-25.6zM569.712 174.797c40.035-46.010 84.317-72.397 121.488-72.397 42.349 0 76.8 34.453 76.8 76.8s-34.451 76.8-76.8 76.8h-172.946c8.854-22.621 26.758-52.818 51.458-81.203zM563.2 972.8h-153.6v-665.6h153.6v665.6zM204.8 179.2c0-42.347 34.453-76.8 76.8-76.8 37.173 0 81.453 26.387 121.488 72.397 24.699 28.386 42.603 58.582 51.458 81.203h-172.946c-42.347 0-76.8-34.453-76.8-76.8zM51.2 307.2h307.2v102.4h-307.2v-102.4zM102.4 947.2v-486.4h256v512h-230.4c-14.115 0-25.6-11.485-25.6-25.6zM870.4 947.2c0 14.115-11.485 25.6-25.6 25.6h-230.4v-512h256v486.4zM921.6 409.6h-307.2v-102.4h307.2v102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gift",
						"birthday",
						"prize",
						"box"
					],
					"defaultCode": 59460,
					"grid": 20
				},
				{
					"id": 3419,
					"paths": [
						"M1004.692 466.394l-447.096-447.080c-25.738-25.754-67.496-25.754-93.268 0l-103.882 103.876 78.17 78.17c12.532-5.996 26.564-9.36 41.384-9.36 53.020 0 96 42.98 96 96 0 14.82-3.364 28.854-9.362 41.386l127.976 127.974c12.532-5.996 26.566-9.36 41.386-9.36 53.020 0 96 42.98 96 96s-42.98 96-96 96-96-42.98-96-96c0-14.82 3.364-28.854 9.362-41.386l-127.976-127.974c-3.042 1.456-6.176 2.742-9.384 3.876v266.968c37.282 13.182 64 48.718 64 90.516 0 53.020-42.98 96-96 96s-96-42.98-96-96c0-41.796 26.718-77.334 64-90.516v-266.968c-37.282-13.18-64-48.72-64-90.516 0-14.82 3.364-28.852 9.36-41.384l-78.17-78.17-295.892 295.876c-25.75 25.776-25.75 67.534 0 93.288l447.12 447.080c25.738 25.75 67.484 25.75 93.268 0l445.006-445.006c25.758-25.762 25.758-67.54-0.002-93.29z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"git",
						"brand"
					],
					"defaultCode": 61254,
					"grid": 16
				},
				{
					"id": 1602,
					"width": 877.7129821777344,
					"paths": [
						"M332.571 747.429q0 37.714-53.143 37.714-61.143 0-61.143-36 0-36.571 56-36.571 58.286 0 58.286 34.857zM312 481.143q0 48.571-42.286 48.571-44 0-44-48 0-51.429 44-51.429 20.571 0 31.429 14.571t10.857 36.286zM406.857 438.286v-71.429q-44.571 16.571-77.143 16.571-28.571-16.571-62.857-16.571-49.143 0-82.857 32.571t-33.714 81.714q0 28.571 16.857 58.286t42 38.286v1.714q-21.714 9.714-21.714 48.571 0 30.286 23.429 44v1.714q-64.571 21.143-64.571 79.429 0 25.714 11.429 44.857t30.857 29.143 41.143 14.571 46.286 4.571q128 0 128-107.429 0-38.286-27.429-56.571t-72-26.286q-15.429-2.857-29.429-11.714t-14-22.571q0-25.143 28-29.714 44-8.571 69.714-40t25.714-76.571q0-13.714-5.714-29.714 21.143-5.143 28-7.429zM440.571 677.714h78.286q-1.143-15.429-1.143-46.857v-221.143q0-26.286 1.143-39.429h-78.286q1.714 13.143 1.714 40.571v224q0 28.571-1.714 42.857zM731.429 668.571v-69.143q-17.143 12-38.857 12-30.286 0-30.286-46.857v-128.571h29.714q5.143 0 15.143 0.571t15.143 0.571v-66.857h-60q0-46.857 1.714-58.286h-80q2.286 13.714 2.286 31.429v26.857h-34.286v66.857q20.571-1.714 21.143-1.714 1.714 0 6.286 0.286t6.857 0.286v1.143h-1.143v124q0 21.143 1.429 36.571t6.571 32.286 14 27.714 24.857 17.714 37.714 6.857q36.571 0 61.714-13.714zM528 265.143q0-20.571-13.714-36.286t-34.286-15.714-34.571 15.429-14 36.571q0 20.571 14.286 35.714t34.286 15.143 34-15.429 14-35.429zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"git-square"
					],
					"defaultCode": 61906,
					"grid": 14
				},
				{
					"id": 1603,
					"width": 1024.0000457763672,
					"paths": [
						"M340 865.143q0-57.143-94.286-57.143-90.286 0-90.286 59.429 0 57.714 98.286 57.714 86.286 0 86.286-60zM306.286 433.714q0-34.857-17.143-58.286t-50.857-23.429q-70.857 0-70.857 82.857 0 77.143 70.857 77.143 68 0 68-78.286zM460 248.571v115.429q-20.571 6.857-45.143 12.571 9.143 24.571 9.143 48 0 72.571-41.714 123.714t-112.571 64.286q-22.857 4.571-34 15.429t-11.143 33.143q0 17.714 12.857 29.429t33.143 18.286 44.857 12.571 49.143 14.571 44.857 21.429 33.143 36.571 12.857 56.286q0 173.714-207.429 173.714-39.429 0-74.286-7.143t-66.286-23.429-50-46.857-18.571-72.857q0-94.286 104-128.571v-2.286q-38.286-23.429-38.286-72 0-62.286 36-78.286v-2.286q-41.143-13.714-68.286-62t-27.143-94.571q0-79.429 54.286-132.286t134.286-52.857q54.857 0 101.714 26.857 56 0 124.571-26.857zM641.714 752h-126.857q2.286-25.714 2.286-76.571v-348q0-53.714-2.286-73.143h126.857q-2.286 18.857-2.286 70.857v350.286q0 50.857 2.286 76.571zM985.143 625.143v112q-40.571 22.286-99.429 22.286-35.429 0-61.143-11.429t-40-28.571-22.571-44.571-10.571-52.571-2.286-58.857v-200.571h1.143v-2.286q-4 0-10.857-0.571t-10.286-0.571q-12 0-33.714 3.429v-108.571h54.857v-43.429q0-30.857-3.429-50.857h129.714q-3.429 23.429-3.429 94.286h97.714v108.571q-8.571 0-24.857-1.143t-24.286-1.143h-48.571v208.571q0 74.857 49.714 74.857 34.857 0 62.286-18.857zM656 84q0 33.143-22.286 58t-54.857 24.857q-33.143 0-56-24.857t-22.857-58q0-33.714 22.571-58.857t56.286-25.143q33.143 0 55.143 25.429t22 58.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"git"
					],
					"defaultCode": 61907,
					"grid": 14
				},
				{
					"id": 3364,
					"paths": [
						"M512.008 12.642c-282.738 0-512.008 229.218-512.008 511.998 0 226.214 146.704 418.132 350.136 485.836 25.586 4.738 34.992-11.11 34.992-24.632 0-12.204-0.48-52.542-0.696-95.324-142.448 30.976-172.504-60.41-172.504-60.41-23.282-59.176-56.848-74.916-56.848-74.916-46.452-31.778 3.51-31.124 3.51-31.124 51.4 3.61 78.476 52.766 78.476 52.766 45.672 78.27 119.776 55.64 149.004 42.558 4.588-33.086 17.852-55.68 32.506-68.464-113.73-12.942-233.276-56.85-233.276-253.032 0-55.898 20.004-101.574 52.76-137.428-5.316-12.9-22.854-64.972 4.952-135.5 0 0 43.006-13.752 140.84 52.49 40.836-11.348 84.636-17.036 128.154-17.234 43.502 0.198 87.336 5.886 128.256 17.234 97.734-66.244 140.656-52.49 140.656-52.49 27.872 70.528 10.35 122.6 5.036 135.5 32.82 35.856 52.694 81.532 52.694 137.428 0 196.654-119.778 239.95-233.79 252.624 18.364 15.89 34.724 47.046 34.724 94.812 0 68.508-0.596 123.644-0.596 140.508 0 13.628 9.222 29.594 35.172 24.566 203.322-67.776 349.842-259.626 349.842-485.768 0-282.78-229.234-511.998-511.992-511.998z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"github",
						"brand",
						"octacat",
						"social"
					],
					"defaultCode": 61199,
					"grid": 16
				},
				{
					"id": 1425,
					"width": 950.8549728393555,
					"paths": [
						"M365.714 694.857q0 22.857-7.143 46.857t-24.571 43.429-41.429 19.429-41.429-19.429-24.571-43.429-7.143-46.857 7.143-46.857 24.571-43.429 41.429-19.429 41.429 19.429 24.571 43.429 7.143 46.857zM731.429 694.857q0 22.857-7.143 46.857t-24.571 43.429-41.429 19.429-41.429-19.429-24.571-43.429-7.143-46.857 7.143-46.857 24.571-43.429 41.429-19.429 41.429 19.429 24.571 43.429 7.143 46.857zM822.857 694.857q0-68.571-39.429-116.571t-106.857-48q-23.429 0-111.429 12-40.571 6.286-89.714 6.286t-89.714-6.286q-86.857-12-111.429-12-67.429 0-106.857 48t-39.429 116.571q0 50.286 18.286 87.714t46.286 58.857 69.714 34.286 80 16.857 85.143 4h96q46.857 0 85.143-4t80-16.857 69.714-34.286 46.286-58.857 18.286-87.714zM950.857 594.286q0 118.286-34.857 189.143-21.714 44-60.286 76t-80.571 49.143-97.143 27.143-98 12.571-95.429 2.571q-44.571 0-81.143-1.714t-84.286-7.143-87.143-17.143-78.286-29.429-69.143-46.286-49.143-65.714q-35.429-70.286-35.429-189.143 0-135.429 77.714-226.286-15.429-46.857-15.429-97.143 0-66.286 29.143-124.571 61.714 0 108.571 22.571t108 70.571q84-20 176.571-20 84.571 0 160 18.286 60-46.857 106.857-69.143t108-22.286q29.143 58.286 29.143 124.571 0 49.714-15.429 96 77.714 91.429 77.714 227.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"github-alt"
					],
					"defaultCode": 61715,
					"grid": 14
				},
				{
					"id": 1316,
					"width": 877.7129821777344,
					"paths": [
						"M296.571 685.714q2.286-3.429-1.714-7.429-5.143-4-8-1.143-2.286 3.429 1.714 7.429 5.143 4 8 1.143zM280.571 662.286q-2.857-4-6.857-2.286-3.429 2.286 0 6.857 4 4.571 6.857 2.857 3.429-2.286 0-7.429zM257.143 639.429q1.143-2.286-2.857-4.571-4-1.143-4.571 1.143-1.714 2.857 2.286 4.571 4.571 1.143 5.143-1.143zM269.143 652.571q1.143-0.571 0.857-2.571t-2-3.143q-3.429-4-5.714-1.714t0.571 6.286q3.429 3.429 6.286 1.143zM318.286 695.429q1.143-4-5.143-6.286-5.143-1.714-7.429 2.286-1.143 4 5.143 6.286 5.143 1.714 7.429-2.286zM342.286 697.143q0-4.571-6.857-4.571-5.714 0-5.714 4.571t6.286 4.571 6.286-4.571zM364.571 693.143q-1.143-4-7.429-2.857t-5.143 5.143q1.143 4.571 6.857 3.429t5.714-5.714zM731.429 512q0-121.143-85.714-206.857t-206.857-85.714-206.857 85.714-85.714 206.857q0 95.429 56 171.714t144 106q10.286 1.714 15.143-2.857t4.857-11.429q0-29.714-0.571-54.286-3.429 0.571-8.857 1.429t-20.286 1.143-27.429-2.286-24.857-11.429-16.857-23.714q-13.143-33.714-32.571-42.286-1.143-0.571-2.571-2l-4.571-4.571t-4-5.429 2.286-4.286 11.143-2q3.429 0 8.571 1.143t17.143 8.857 18.857 20.286q9.143 16 21.429 24t24.857 8 21.714-2 17.143-5.429q4-26.857 18.857-39.429-28-3.429-49.143-10.571t-41.714-22.286-31.714-43.429-11.143-68.286q0-45.143 30.286-78.286-13.714-35.429 2.857-77.714 10.857-3.429 31.143 4.286t34.571 16.857l14.857 9.143q33.143-9.714 73.143-9.714t73.143 9.714q6.286-4 16.286-10.286t31.714-14.857 32.571-5.143q16.571 42.286 2.857 77.714 30.286 33.143 30.286 78.286 0 32.571-8 57.429t-20.286 40-30.571 25.429-35.714 14.857-39.143 6.857q20 17.714 20 54.286 0 22.857-0.286 50.857t-0.286 29.143q0 6.857 4.857 11.429t15.143 2.857q88-29.714 144-106t56-171.714zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"github-square"
					],
					"defaultCode": 61586,
					"grid": 14
				},
				{
					"id": 1325,
					"width": 877.7150573730469,
					"paths": [
						"M438.857 73.143q119.429 0 220.286 58.857t159.714 159.714 58.857 220.286q0 143.429-83.714 258t-216.286 158.571q-15.429 2.857-22.857-4t-7.429-17.143q0-1.714 0.286-43.714t0.286-76.857q0-55.429-29.714-81.143 32.571-3.429 58.571-10.286t53.714-22.286 46.286-38 30.286-60 11.714-86q0-68-45.143-117.714 21.143-52-4.571-116.571-16-5.143-46.286 6.286t-52.571 25.143l-21.714 13.714q-53.143-14.857-109.714-14.857t-109.714 14.857q-9.143-6.286-24.286-15.429t-47.714-22-48.571-7.714q-25.714 64.571-4.571 116.571-45.143 49.714-45.143 117.714 0 48.571 11.714 85.714t30 60 46 38.286 53.714 22.286 58.571 10.286q-22.286 20.571-28 58.857-12 5.714-25.714 8.571t-32.571 2.857-37.429-12.286-31.714-35.714q-10.857-18.286-27.714-29.714t-28.286-13.714l-11.429-1.714q-12 0-16.571 2.571t-2.857 6.571 5.143 8 7.429 6.857l4 2.857q12.571 5.714 24.857 21.714t18 29.143l5.714 13.143q7.429 21.714 25.143 35.143t38.286 17.143 39.714 4 31.714-2l13.143-2.286q0 21.714 0.286 50.571t0.286 31.143q0 10.286-7.429 17.143t-22.857 4q-132.571-44-216.286-158.571t-83.714-258q0-119.429 58.857-220.286t159.714-159.714 220.286-58.857zM166.286 703.429q1.714-4-4-6.857-5.714-1.714-7.429 1.143-1.714 4 4 6.857 5.143 3.429 7.429-1.143zM184 722.857q4-2.857-1.143-9.143-5.714-5.143-9.143-1.714-4 2.857 1.143 9.143 5.714 5.714 9.143 1.714zM201.143 748.571q5.143-4 0-10.857-4.571-7.429-9.714-3.429-5.143 2.857 0 10.286t9.714 4zM225.143 772.571q4.571-4.571-2.286-10.857-6.857-6.857-11.429-1.714-5.143 4.571 2.286 10.857 6.857 6.857 11.429 1.714zM257.714 786.857q1.714-6.286-7.429-9.143-8.571-2.286-10.857 4t7.429 8.571q8.571 3.429 10.857-3.429zM293.714 789.714q0-7.429-9.714-6.286-9.143 0-9.143 6.286 0 7.429 9.714 6.286 9.143 0 9.143-6.286zM326.857 784q-1.143-6.286-10.286-5.143-9.143 1.714-8 8.571t10.286 4.571 8-8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"github"
					],
					"defaultCode": 61595,
					"grid": 14
				},
				{
					"id": 1784,
					"width": 1023.9989223480225,
					"paths": [
						"M59.429 403.429l452.571 580-496-360q-10.286-7.429-14.286-19.714t0-24.286l57.714-176zM323.429 403.429h377.143l-188.571 580zM210.286 53.714l113.143 349.714h-264l113.143-349.714q4.571-13.143 18.857-13.143t18.857 13.143zM964.571 403.429l57.714 176q4 12 0 24.286t-14.286 19.714l-496 360 452.571-580zM964.571 403.429h-264l113.143-349.714q4.571-13.143 18.857-13.143t18.857 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gitlab"
					],
					"defaultCode": 62102,
					"grid": 14
				},
				{
					"id": 1529,
					"width": 877.7139282226562,
					"paths": [
						"M441.714 744l200-270.286q9.143-12.571 14-33.714t-3.429-48.571-35.143-45.143q-22.857-14.857-47.429-14.571t-42 10-31.143 25.714q-20.571 22.857-54.857 22.857-33.714 0-54.286-22.857-13.714-16-31.143-25.714t-42-10-48 14.571q-26.286 17.714-34.571 45.143t-3.429 48.571 14 33.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gittip",
						"gratipay"
					],
					"defaultCode": 61828,
					"grid": 14
				},
				{
					"id": 535,
					"width": 1024,
					"paths": [
						"M629.344 288l40.32-60.512c28.352-42.528-2.144-99.488-53.248-99.488h-19.072l-6.496-29.216c-7.136-32.16-31.552-59.392-63.968-65.376-43.36-8.032-83.584 19.744-92.736 61.024l-7.488 33.568h-19.072c-51.104 0-81.6 56.96-53.248 99.488l40.32 60.512h-202.656c-35.36 0-64 28.64-64 64v576c0 35.36 28.64 64 64 64h640c35.36 0 64-28.64 64-64v-576c0-35.36-28.64-64-64-64h-202.656zM380.96 209.76c-9.6-14.4-4.32-27.776-1.6-32.864s10.912-16.896 28.224-16.896h44.736l13.024-58.656c4.928-21.984 24.224-37.344 46.752-37.344s41.664 15.36 46.56 37.344l13.024 58.656h44.736c17.312 0 25.504 11.808 28.224 16.896s8 18.464-1.6 32.864l-52.16 78.24h-157.76l-52.16-78.24zM192 320h256v256h-288v-224c0-17.664 14.336-32 32-32zM160 928v-224h288v256h-256c-17.664 0-32-14.336-32-32zM480 960v-288h-320v-64h320v-288h64v288h320v64h-320v288h-64zM832 960h-256v-256h288v224c0 17.664-14.336 32-32 32zM576 576v-256h256c17.664 0 32 14.336 32 32v224h-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"give",
						"gift",
						"present"
					],
					"grid": 32
				},
				{
					"id": 536,
					"width": 1024,
					"paths": [
						"M448 576h-320v-224c0-35.36 28.64-64 64-64h256v288zM373.344 256h277.344l19.008-28.512c28.32-42.528-2.176-99.488-53.28-99.488h-19.072l-6.496-29.216c-7.136-32.16-31.552-59.392-63.968-65.376-43.36-8.032-83.584 19.744-92.736 61.024l-7.488 33.568h-19.072c-51.104 0-81.6 56.96-53.248 99.488l19.008 28.512zM832 288h-256v288h320v-224c0-35.36-28.64-64-64-64zM576 992h256c35.36 0 64-28.64 64-64v-224h-320v288zM128 928c0 35.36 28.64 64 64 64h256v-288h-320v224zM544 288h-64v320h-352v64h352v320h64v-320h352v-64h-352v-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"give",
						"gift",
						"present"
					],
					"grid": 32
				},
				{
					"id": 1038,
					"width": 1024,
					"paths": [
						"M928 224h-192c0-53.024-42.976-96-96-96 0-70.688-57.312-128-128-128s-128 57.312-128 128c-53.024 0-96 42.976-96 96h-192c-17.664 0-32 14.336-32 32v736c0 17.664 14.336 32 32 32h832c17.664 0 32-14.336 32-32v-736c0-17.664-14.336-32-32-32zM384 192h64v-64c0-35.296 28.704-64 64-64s64 28.704 64 64v64h64c17.632 0 32 14.368 32 32v32h-320v-32c0-17.632 14.368-32 32-32zM128 288h320v256h-320v-256zM128 576h320v64h-320v-64zM128 960v-288h320v288h-320zM480 960v-672h64v672h-64zM896 960h-320v-288h320v288zM896 640h-320v-64h320v64zM896 544h-320v-256h320v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"give",
						"gift",
						"present"
					],
					"grid": 32
				},
				{
					"id": 537,
					"width": 1024,
					"paths": [
						"M224 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM480 256c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM480 768c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM768 544c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM510.432 519.808c0.64-2.56 1.568-5.056 1.568-7.808 0-11.712-6.592-21.536-16-27.104v-164.896c0-8.832-7.168-16-16-16s-16 7.168-16 16v164.896c-9.408 5.568-16 15.392-16 27.104 0 17.664 14.336 32 32 32 2.752 0 5.248-0.928 7.808-1.568l172.896 172.896c3.104 3.104 7.2 4.672 11.296 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-172.896-172.896zM928 480v64c0 17.664-14.336 32-32 32h-37.792c-12.128 71.776-44.096 136.704-90.208 189.152v130.848c0 53.024-42.976 96-96 96h-384c-53.024 0-96-42.976-96-96v-130.848c-59.552-67.68-96-156.128-96-253.152s36.448-185.472 96-253.152v-130.848c0-53.024 42.976-96 96-96h384c53.024 0 96 42.976 96 96v130.848c46.144 52.416 78.112 117.376 90.208 189.152h37.792c17.664 0 32 14.336 32 32zM224 128v98.592c68.032-61.088 157.6-98.592 256-98.592s187.968 37.504 256 98.592v-98.592c0-35.296-28.704-64-64-64h-384c-35.296 0-64 28.704-64 64zM736 896v-98.592c-68.032 61.088-157.6 98.592-256 98.592s-187.968-37.504-256-98.592v98.592c0 35.296 28.704 64 64 64h384c35.296 0 64-28.704 64-64zM832 512c0-194.4-157.6-352-352-352s-352 157.6-352 352 157.6 352 352 352 352-157.6 352-352zM896 480h-33.632c0.896 10.592 1.632 21.184 1.632 32s-0.736 21.408-1.632 32h33.632v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glance",
						"wait",
						"watch",
						"wear"
					],
					"grid": 32
				},
				{
					"id": 538,
					"width": 1024,
					"paths": [
						"M480 96c-111.776 0-213.184 44.544-288 116.512v-84.512c0-53.024 42.976-96 96-96h384c53.024 0 96 42.976 96 96v84.512c-74.816-71.968-176.224-116.512-288-116.512zM192 811.488v84.512c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-84.512c-74.816 71.968-176.224 116.512-288 116.512s-213.184-44.544-288-116.512zM928 480v64c0 17.664-14.336 32-32 32h-37.76c-30.528 181.536-188.032 320-378.24 320-212.064 0-384-171.936-384-384s171.936-384 384-384c190.208 0 347.712 138.464 378.24 320h37.76c17.664 0 32 14.336 32 32zM448 224c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM224 512c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM512 800c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM683.328 692.672l-172.896-172.896c0.64-2.528 1.568-5.024 1.568-7.776 0-11.712-6.592-21.536-16-27.104v-164.896c0-8.832-7.168-16-16-16s-16 7.168-16 16v164.896c-9.408 5.568-16 15.392-16 27.104 0 17.664 14.336 32 32 32 2.752 0 5.248-0.928 7.808-1.568l172.896 172.896c3.104 3.104 7.2 4.672 11.296 4.672s8.192-1.568 11.328-4.672c6.24-6.272 6.24-16.384 0-22.656zM800 512c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glance",
						"wait",
						"watch",
						"wear"
					],
					"grid": 32
				},
				{
					"id": 2503,
					"paths": [
						"M777.784 16.856c-5.576-10.38-16.406-16.856-28.19-16.856h-475.188c-11.784 0-22.614 6.476-28.19 16.856-35.468 66.020-54.216 143.184-54.216 223.144 0 105.412 32.372 204.828 91.154 279.938 45.428 58.046 102.48 96.54 164.846 112.172v327.89h-96c-17.672 0-32 14.326-32 32s14.328 32 32 32h320c17.674 0 32-14.326 32-32s-14.326-32-32-32h-96v-327.89c62.368-15.632 119.418-54.124 164.846-112.172 58.782-75.11 91.154-174.526 91.154-279.938 0-79.96-18.748-157.122-54.216-223.144zM294.1 64h435.8c24.974 52.902 38.1 113.338 38.1 176 0 5.364-0.108 10.696-0.296 16h-511.406c-0.19-5.304-0.296-10.636-0.296-16-0.002-62.664 13.126-123.098 38.098-176z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glass",
						"drink",
						"beverage",
						"wine"
					],
					"defaultCode": 60338,
					"grid": 16
				},
				{
					"id": 2504,
					"paths": [
						"M777.784 16.856c-5.576-10.38-16.406-16.856-28.19-16.856h-475.188c-11.784 0-22.614 6.476-28.19 16.856-35.468 66.020-54.216 143.184-54.216 223.144 0 105.412 32.372 204.828 91.154 279.938 45.428 58.046 102.48 96.54 164.846 112.172v327.89h-96c-17.672 0-32 14.326-32 32s14.328 32 32 32h320c17.674 0 32-14.326 32-32s-14.326-32-32-32h-96v-327.89c62.368-15.632 119.418-54.124 164.846-112.172 58.782-75.11 91.154-174.526 91.154-279.938 0-79.96-18.748-157.122-54.216-223.144zM512 576c-141.16 0-256-150.728-256-336 0-62.664 13.126-123.098 38.098-176h435.802c24.974 52.902 38.1 113.338 38.1 176 0 185.272-114.842 336-256 336z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glass",
						"drink",
						"beverage",
						"wine"
					],
					"defaultCode": 60339,
					"grid": 16
				},
				{
					"id": 2505,
					"paths": [
						"M889.162 179.77c7.568-9.632 8.972-22.742 3.62-33.758-5.356-11.018-16.532-18.012-28.782-18.012h-704c-12.25 0-23.426 6.994-28.78 18.012-5.356 11.018-3.95 24.126 3.618 33.758l313.162 398.57v381.66h-96c-17.672 0-32 14.326-32 32s14.328 32 32 32h320c17.674 0 32-14.326 32-32s-14.326-32-32-32h-96v-381.66l313.162-398.57zM798.162 192l-100.572 128h-371.18l-100.57-128h572.322z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glass",
						"drink",
						"beverage",
						"wine"
					],
					"defaultCode": 60340,
					"grid": 16
				},
				{
					"id": 2506,
					"paths": [
						"M889.162 179.77c7.568-9.632 8.972-22.742 3.62-33.758-5.356-11.018-16.532-18.012-28.782-18.012h-704c-12.25 0-23.426 6.994-28.78 18.012-5.356 11.018-3.95 24.126 3.618 33.758l313.162 398.57v381.66h-96c-17.672 0-32 14.326-32 32s14.328 32 32 32h320c17.674 0 32-14.326 32-32s-14.326-32-32-32h-96v-381.66l313.162-398.57zM798.162 192l-286.162 364.206-286.16-364.206h572.322z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glass",
						"drink",
						"beverage",
						"wine"
					],
					"defaultCode": 60341,
					"grid": 16
				},
				{
					"id": 1179,
					"width": 1023.9999694824219,
					"paths": [
						"M970.857 106.286q0 20-24.571 44.571l-361.143 361.143v438.857h182.857q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714-25.714 10.857h-512q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h182.857v-438.857l-361.143-361.143q-24.571-24.571-24.571-44.571 0-13.143 10.286-20.857t21.714-10 24.571-2.286h804.571q13.143 0 24.571 2.286t21.714 10 10.286 20.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glass"
					],
					"defaultCode": 61440,
					"grid": 14
				},
				{
					"id": 2618,
					"paths": [
						"M729.112 699.324c-33.118 0-80.456-2.286-109.106-22.050-35.892-24.762-64.5-124.372-78.36-181.542-2.45-10.096-9.338-14.734-16.756-16.658l-12.884-1.090-13.052 1.128c-7.356 1.95-14.166 6.594-16.596 16.618-13.864 57.176-42.478 156.79-78.356 181.544-28.656 19.766-75.994 22.050-109.108 22.050-7.398 0-14.232-0.12-20.262-0.222-4.59-0.080-8.69-0.152-12.152-0.152-137.916 0-183.728-46.694-197.872-85.864-10.918-30.232-17.858-62.26-23.98-90.518-8.038-37.092-16.35-75.448-29.796-83.402l-4.526-2.68-1.964-4.878c-8.37-20.784-2.298-72.114-0.996-82.194l1.552-12.020 12.038-1.402c60.138-7.012 150.232-11.316 188.348-11.316 1.47 0 148.978 0.944 192.298 21.94 5.946 2.88 11.94 6.004 17.738 9.024 27.292 14.216 55.514 28.918 96.77 29.17 41.066-0.254 69.284-14.954 96.576-29.17 5.794-3.020 11.79-6.142 17.732-9.024 43.326-20.996 190.834-21.94 192.304-21.94 38.126 0 128.226 4.304 188.35 11.316l12.038 1.402 1.552 12.020c1.302 10.078 7.38 61.408-0.978 82.19l-1.962 4.882-4.532 2.68c-13.448 7.958-21.758 46.312-29.796 83.406-6.122 28.256-13.060 60.284-23.976 90.514-14.148 39.172-59.96 85.864-197.874 85.864-3.468 0-7.568 0.072-12.156 0.152-6.026 0.104-12.858 0.222-20.256 0.222zM827.854 390.976c-101.002 0-170.518 13.52-192.366 26.082-25.328 14.562-30.128 29.346-30.128 51.532 0 17.78 19.814 96.294 34.728 126.126 13.146 26.288 29.79 38.928 53.964 40.982 9.368 0.796 23.348 1.254 38.352 1.254 59.1 0 109.84-5.99 129.27-15.262 25.358-12.102 51.578-24.616 60.066-139.548 0.38-5.148 0.876-10.292 1.358-15.27 2.35-24.318 4.38-45.322-6.718-57.82-9.85-11.092-31.332-17.080-63.846-17.8-8.22-0.184-16.522-0.276-24.68-0.276zM196.134 390.97c-8.158 0-16.462 0.092-24.68 0.274-32.512 0.72-53.992 6.71-63.84 17.802-11.102 12.502-9.070 33.508-6.718 57.832 0.482 4.972 0.978 10.116 1.358 15.262 8.488 114.936 34.706 127.45 60.064 139.55 19.424 9.272 70.16 15.262 129.252 15.262 15.010 0 28.992-0.458 38.36-1.256 24.186-2.052 40.83-14.692 53.97-40.982 10.9-21.798 34.722-101.794 34.72-126.132 0-22.186-4.8-36.97-30.124-51.532-21.846-12.562-91.364-26.080-192.362-26.080z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glasses",
						"prescription-glasses",
						"vision",
						"optics"
					],
					"defaultCode": 60453,
					"grid": 16
				},
				{
					"id": 2616,
					"width": 1152,
					"paths": [
						"M1088 320v384h-325.49l-141.256-141.254c-12.496-12.498-28.876-18.746-45.254-18.746s-32.758 6.248-45.254 18.746l-141.256 141.254h-325.49v-384h1024zM1152 256h-1152v512h416l160-160 160 160h416v-512z",
						"M128 384v256h224l160-160v-96h-384zM320 576h-128v-128h256l-128 128z",
						"M640 384v96l160 160h224v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glasses-3d"
					],
					"defaultCode": 60451,
					"grid": 16
				},
				{
					"id": 2617,
					"width": 1152,
					"paths": [
						"M512 672v-96h-384v256h224l160-160zM192 768v-128h256l-128 128h-128z",
						"M1024 832v-256h-384v96l160 160z",
						"M664.082 6.28c-13.246-11.59-24.082-6.672-24.082 10.928v72c0 17.6 0.996 27.244 11.99 40.988l244.010 317.804h-640l244.010-317.804c10.994-13.744 11.99-23.39 11.99-40.988v-72c0-17.6-10.836-22.518-24.082-10.928l-487.918 441.72v512h416l160-160 160 160h416v-512l-487.918-441.72zM1088 896h-325.49l-141.256-141.254c-12.496-12.498-28.876-18.746-45.254-18.746s-32.758 6.248-45.254 18.746l-141.256 141.254h-325.49v-384h1024v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glasses-3d"
					],
					"defaultCode": 60452,
					"grid": 16
				},
				{
					"id": 2619,
					"paths": [
						"M1020.66 346.386c-63.076-7.36-155.586-11.56-192.376-11.56-36.798 0-156.636 4.206-191.33 21.020-34.448 16.704-68.91 40.644-124.958 40.984-56.046-0.34-90.52-24.282-124.962-40.982-34.692-16.812-154.532-21.020-191.324-21.020-36.794 0-129.3 4.204-192.376 11.558 0 0-7.506 58.098 0 76.736 32.416 19.182 34.196 109.706 62.352 187.69 28.158 77.974 159.754 77.974 189 77.974 29.248 0 101.574 4.82 136.854-19.522s65.926-143.116 74.34-177.806c7.152-29.51 36.362-30.87 44.924-30.62 0 0.086 0 0.134 0 0.134s0.438-0.044 1.198-0.088c0.756 0.042 1.192 0.088 1.192 0.088s0-0.048 0-0.134c8.566-0.25 37.77 1.11 44.926 30.62 8.406 34.696 39.056 153.466 74.34 177.806 35.278 24.342 107.608 19.522 136.85 19.522 29.246 0 160.842 0 189.006-77.974 28.158-77.984 29.93-168.506 62.354-187.69 7.5-18.64-0.010-76.736-0.010-76.736z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glasses",
						"sunglasses"
					],
					"defaultCode": 60454,
					"grid": 16
				},
				{
					"id": 1798,
					"width": 877.7129821777344,
					"paths": [
						"M494.857 294.286q0 15.429-7.429 53.714-6.286 28.571-18 85.714t-17.429 85.714q-1.143 6.286-2.571 7.143t-7.714 1.429q-11.429 1.143-17.714 1.143-33.143 0-48-28.286t-14.857-64.857q0-50.286 20-99.429t58.857-70.857q16-8 29.143-8 16 0 20.857 9.429t4.857 27.143zM772.571 536.571q0-8-22.286-43.143t-29.714-38q-12-4.571-19.429-4.571-52 0-129.143 44l-1.143-1.143q1.714-12.571 15.714-77.143t14-101.714q0-133.143-138.286-133.143-13.714 0-38.857 3.429-53.714 9.714-96.286 51.143t-63.714 95.143-21.143 108q0 83.429 46 128.571t130 45.143q14.286 0 14.286 1.714t-0.571 2.857q-2.286 19.429-14.857 66.857-8 29.714-29.429 57.714t-47.143 28q-24 0-24-26.857 0-13.714 6-27.143t14.286-22.571 16.857-16.286 14.857-11.429 6.286-4.857q0-1.714-4-5.714-13.714-12.571-33.429-20.857t-37.429-8.286q-20 0-36.286 19.429t-23.429 42.857-7.143 42.857q0 50.286 29.429 81.143t79.143 30.857q46.857 0 88.571-30.286t67.143-72 37.429-87.429q3.429-12.571 8.857-38t8.286-38q1.714-6.857 8-10.286 67.429-34.286 129.714-34.286 27.429 0 72.571 10.286 0.571 0.571 2.286 0.571 2.857 0 5.429-2.571t2.571-4.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glide"
					],
					"defaultCode": 62117,
					"grid": 14
				},
				{
					"id": 1799,
					"width": 877.1419677734375,
					"paths": [
						"M425.143 174.286q0-13.714-1.143-22t-4.857-17.143-12-13.143-21.429-4.286q-22.286 0-44.571 13.143-60 33.143-90.857 108.857t-30.857 154q0 25.143 4.857 48.857t15.143 46 30 35.714 46.571 13.429q2.286 0 10.286 0.286t11.429 0 9.143-1.714 8.571-4.857 4-9.143q9.143-44 27.429-132.286t27.429-132.286q10.857-52 10.857-83.429zM856 549.143q0 4-4.286 7.714t-8.857 3.714l-3.429-0.571q-12.571-1.714-35.429-6.286t-41.143-7.143-36-2.571q-95.429 0-200.571 53.143-8.571 4.571-12 15.429-5.714 20.571-14 60.286t-12.857 57.429q-13.143 52-40 102.571t-64.286 94-88.286 70.286-105.714 26.857q-77.143 0-122.571-47.714t-45.429-125.429q0-30.286 11.143-66.857t36-66.571 55.714-30q21.714 0 68.571 19.143t47.429 35.143q0 0.571-9.429 7.143t-22.571 17.714-26.286 25.429-22.286 34.857-9.143 42.286q0 18.857 9.429 30.286t27.714 11.429q25.714 0 48.571-18t38-44.571 27.429-60.286 18.571-61.143 9.143-51.429v-5.143q0-1.143-2-2t-4.857-0.857h-5.714t-5.714 0.286-3.429 0.286q-129.714 0-201.143-70t-71.429-199.143q0-61.714 19.714-126.286t54.857-120 89.143-95.714 116.857-51.143q29.714-5.143 60.571-5.143 213.714 0 213.714 205.714 0 56-21.714 156t-24.571 120.571l1.714 1.714q57.714-32.571 104.286-50.286t95.714-17.714q12.571 0 30.286 7.429 10.857 4 45.714 58.571t34.857 66.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glide-g"
					],
					"defaultCode": 62118,
					"grid": 14
				},
				{
					"id": 1341,
					"width": 877.7139282226562,
					"paths": [
						"M438.857 73.143q119.429 0 220.286 58.857t159.714 159.714 58.857 220.286-58.857 220.286-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857zM595.429 370.857q-1.143 0.571-5.429 5.429t-7.714 5.429q1.143 0 2.571-2.857t2.857-6.286 2-4q3.429-4 12.571-8.571 8-3.429 29.714-6.857 19.429-4.571 29.143 6.286-1.143-1.143 5.429-7.429t8.286-6.857q1.714-1.143 8.571-2.571t8.571-4.286l1.143-12.571q-6.857 0.571-10-4t-3.714-12q0 1.143-3.429 4.571 0-4-2.571-4.571t-6.571 0.571-5.143 0.571q-5.714-1.714-8.571-4.286t-4.571-9.429-2.286-8.571q-1.143-2.857-5.429-6t-5.429-6q-0.571-1.143-1.429-3.143t-1.714-3.714-2.286-3.143-3.143-1.429-4 2.857-4.286 5.714-2.571 2.857q-1.714-1.143-3.429-0.857t-2.571 0.571-2.571 1.714-2.857 2q-1.714 1.143-4.857 1.714t-4.857 1.143q8.571-2.857-0.571-6.286-5.714-2.286-9.143-1.714 5.143-2.286 4.286-6.857t-4.857-8h2.857q-0.571-2.286-4.857-4.857t-10-4.857-7.429-3.429q-4.571-2.857-19.429-5.429t-18.857-0.286q-2.857 3.429-2.571 6t2.286 8 2 7.143q0.571 3.429-3.143 7.429t-3.714 6.857q0 4 8 8.857t5.714 12.286q-1.714 4.571-9.143 9.143t-9.143 6.857q-2.857 4.571-0.857 10.571t6 9.429q1.143 1.143 0.857 2.286t-2 2.571-3.143 2.286-3.714 2l-1.714 1.143q-6.286 2.857-11.714-3.429t-7.714-14.857q-4-14.286-9.143-17.143-13.143-4.571-16.571 0.571-2.857-7.429-23.429-14.857-14.286-5.143-33.143-2.286 3.429-0.571 0-8.571-4-8.571-10.857-6.857 1.714-3.429 2.286-10t0.571-7.714q1.714-7.429 6.857-13.143 0.571-0.571 4-4.857t5.429-7.714 0.286-3.429q20 2.286 28.571-6.286 2.857-2.857 6.571-9.714t6-9.714q5.143-3.429 8-3.143t8.286 3.143 8.286 2.857q8 0.571 8.857-6.286t-4.286-11.429q6.857 0.571 1.714-9.714-2.857-4-4.571-5.143-6.857-2.286-15.429 2.857-4.571 2.286 1.143 4.571-0.571-0.571-5.429 6t-9.429 10-9.143-2.857q-0.571-0.571-3.143-7.714t-5.429-7.714q-4.571 0-9.143 8.571 1.714-4.571-6.286-8.571t-13.714-4.571q10.857-6.857-4.571-15.429-4-2.286-11.714-2.857t-11.143 2.286q-2.857 4-3.143 6.571t2.857 4.571 6 3.143 6.571 2.286 4.857 1.714q8 5.714 4.571 8-1.143 0.571-4.857 2t-6.571 2.571-3.429 2.286q-1.714 2.286 0 8t-1.143 8q-2.857-2.857-5.143-10t-4-9.429q4 5.143-14.286 3.429l-5.714-0.571q-2.286 0-9.143 1.143t-11.714 0.571-7.714-4.571q-2.286-4.571 0-11.429 0.571-2.286 2.286-1.143-2.286-1.714-6.286-5.429t-5.714-4.857q-26.286 8.571-53.714 23.429 3.429 0.571 6.857-0.571 2.857-1.143 7.429-3.714t5.714-3.143q19.429-8 24-4l2.857-2.857q8 9.143 11.429 14.286-4-2.286-17.143-0.571-11.429 3.429-12.571 6.857 4 6.857 2.857 10.286-2.286-1.714-6.571-5.714t-8.286-6.286-8.571-2.857q-9.143 0-12.571 0.571-83.429 45.714-134.286 126.857 4 4 6.857 4.571 2.286 0.571 2.857 5.143t1.429 6.286 6.571-1.714q5.143 4.571 1.714 10.857 0.571-0.571 25.143 15.429 10.857 9.714 12 12 1.714 6.286-5.714 10.286-0.571-1.143-5.143-5.143t-5.143-2.286q-1.714 2.857 0.286 10.571t6 7.143q-4 0-5.429 9.143t-1.429 20.286-0.571 13.429l1.143 0.571q-1.714 6.857 3.143 19.714t12.286 11.143q-7.429 1.714 11.429 24.571 3.429 4.571 4.571 5.143 1.714 1.143 6.857 4.286t8.571 5.714 5.714 6q2.286 2.857 5.714 12.857t8 13.429q-1.143 3.429 5.429 11.429t6 13.143q-0.571 0-1.429 0.571t-1.429 0.571q1.714 4 8.857 8t8.857 7.429q0.571 1.714 1.143 5.714t1.714 6.286 4.571 1.143q1.143-11.429-13.714-35.429-8.571-14.286-9.714-16.571-1.714-2.857-3.143-8.857t-2.571-8.286q1.143 0 3.429 0.857t4.857 2 4.286 2.286 1.143 1.714q-1.714 4 1.143 10t6.857 10.571 9.714 10.857 6.857 7.429q3.429 3.429 8 11.143t0 7.714q5.143 0 11.429 5.714t9.714 11.429q2.857 4.571 4.571 14.857t2.857 13.714q1.143 4 4.857 7.714t7.143 5.429l9.143 4.571t7.429 4q2.857 1.143 10.571 6t12.286 6.571q5.714 2.286 9.143 2.286t8.286-1.429 7.714-2q8.571-1.143 16.571 8.571t12 12q20.571 10.857 31.429 6.286-1.143 0.571 0.286 4.286t4.571 8.857 5.143 8.286 3.143 4.857q2.857 3.429 10.286 8.571t10.286 8.571q3.429-2.286 4-5.143-1.714 4.571 4 11.429t10.286 5.714q8-1.714 8-18.286-17.714 8.571-28-10.286 0-0.571-1.429-3.143t-2.286-4.857-1.429-4.857 0-4.286 2.857-1.714q5.143 0 5.714-2t-1.143-7.143-2.286-7.429q-0.571-4.571-6.286-11.429t-6.857-8.571q-2.857 5.143-9.143 4.571t-9.143-5.143q0 0.571-0.857 3.143t-0.857 3.714q-7.429 0-8.571-0.571 0.571-1.714 1.429-10t2-12.857q0.571-2.286 3.143-6.857t4.286-8.286 2.286-7.143-2.571-5.429-10-1.429q-10.857 0.571-14.857 11.429-0.571 1.714-1.714 6t-2.857 6.571-5.143 4q-4 1.714-13.714 1.143t-13.714-2.857q-7.429-4.571-12.857-16.571t-5.429-21.143q0-5.714 1.429-15.143t1.714-14.286-3.143-14q1.714-1.143 5.143-5.429t5.714-6q1.143-0.571 2.571-0.857t2.571 0 2.286-0.857 1.714-3.429q-0.571-0.571-2.286-1.714-1.714-1.714-2.286-1.714 4 1.714 16.286-0.857t15.714 0.857q8.571 6.286 12.571-1.143 0-0.571-1.429-5.429t-0.286-7.714q2.857 15.429 16.571 5.143 1.714 1.714 8.857 2.857t10 2.857q1.714 1.143 4 3.143t3.143 2.571 2.857-0.286 4.857-3.714q5.714 8 6.857 13.714 6.286 22.857 10.857 25.143 4 1.714 6.286 1.143t2.571-5.429 0-8-0.857-7.143l-0.571-4.571v-10.286l-0.571-4.571q-8.571-1.714-10.571-6.857t0.857-10.571 8.571-10.571q0.571-0.571 4.571-2t8.857-3.714 7.143-4.571q12-10.857 8.571-20 4 0 6.286-5.143-0.571 0-2.857-1.714t-4.286-2.857-2.571-1.143q5.143-2.857 1.143-9.143 2.857-1.714 4.286-6.286t4.286-5.714q5.143 6.857 12 1.143 4-4.571 0.571-9.143 2.857-4 11.714-6t10.571-5.429q4 1.143 4.571-1.143t0.571-6.857 1.714-6.857q2.286-2.857 8.571-5.143t7.429-2.857l9.714-6.286q1.714-2.286 0-2.286 10.286 1.143 17.714-6.286 5.714-6.286-3.429-11.429 1.714-3.429-1.714-5.429t-8.571-3.143q1.714-0.571 6.571-0.286t6-0.857q8.571-5.714-4-9.143-9.714-2.857-24.571 6.857zM502.286 872q117.714-20.571 200.571-108-1.714-1.714-7.143-2.571t-7.143-2q-10.286-4-13.714-4.571 0.571-4-1.429-7.429t-4.571-5.143-7.143-4.571-6.286-4q-1.143-1.143-4-3.429t-4-3.143-4.286-2.571-4.857-1.143-5.714 0.571l-1.714 0.571q-1.714 0.571-3.143 1.429t-3.143 1.714-2.286 1.714 0 1.429q-12-9.714-20.571-12.571-2.857-0.571-6.286-3.143t-6-4-5.714-0.857-6.571 4q-2.857 2.857-3.429 8.571t-1.143 7.429q-4-2.857 0-10t1.143-10.571q-1.714-3.429-6-2.571t-6.857 2.571-6.571 4.857-5.143 3.714-4.857 3.143-4.857 4.286q-1.714 2.286-3.429 6.857t-2.857 6.286q-1.143-2.286-6.571-3.714t-5.429-3.143q1.143 5.714 2.286 20t2.857 21.714q4 17.714-6.857 27.429-15.429 14.286-16.571 22.857-2.286 12.571 6.857 14.857 0 4-4.571 11.714t-4 12.286q0 3.429 1.143 9.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"globe"
					],
					"defaultCode": 61612,
					"grid": 14
				},
				{
					"id": 539,
					"width": 1024,
					"paths": [
						"M947.072 584.64c-6.784 0-13.728 2.24-19.968 7.36-60.672 49.952-138.336 80-223.104 80-15.232 0-30.656-0.96-46.304-2.976-156.256-19.968-282.752-146.496-302.752-302.752-13.12-102.624 18.112-197.824 77.024-269.408 17.728-21.536 1.056-52.16-24.544-52.16-2.56 0-5.184 0.32-7.904 0.96-218.688 52.448-379.168 254.368-366.848 491.904 12.576 242.24 211.52 441.184 453.76 453.76 8.576 0.448 17.088 0.672 25.568 0.672 226.336 0 415.776-156.736 466.336-367.552 5.28-22.016-12.224-39.808-31.264-39.808zM512 960c-7.936 0-15.904-0.192-23.904-0.608-225.76-11.744-411.776-197.728-423.488-423.488-11.168-215.776 132.832-408.864 342.4-459.104 0.032 0 0.064-0.032 0.096-0.032-67.776 82.432-97.568 186.688-83.904 293.6 21.696 169.76 160.672 308.736 330.432 330.432 16.768 2.112 33.696 3.2 50.368 3.2 88.608 0 175.072-31.008 243.232-87.008-48.448 201.952-227.424 343.008-435.232 343.008z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glow",
						"shine",
						"aim",
						"reflect"
					],
					"grid": 32
				},
				{
					"id": 540,
					"width": 1024,
					"paths": [
						"M947.072 584.64c-6.784 0-13.728 2.24-19.968 7.36-60.672 49.952-138.336 80-223.104 80-15.232 0-30.656-0.96-46.304-2.976-156.256-19.968-282.752-146.496-302.752-302.752-13.12-102.624 18.112-197.824 77.024-269.408 17.728-21.536 1.056-52.16-24.544-52.16-2.56 0-5.184 0.32-7.904 0.96-218.688 52.448-379.168 254.368-366.848 491.904 12.576 242.24 211.52 441.184 453.76 453.76 8.576 0.448 17.088 0.672 25.568 0.672 226.336 0 415.776-156.736 466.336-367.552 5.28-22.016-12.224-39.808-31.264-39.808z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glow",
						"shine",
						"aim",
						"reflect"
					],
					"grid": 32
				},
				{
					"id": 541,
					"width": 1024,
					"paths": [
						"M746.944 357.472l-74.944-37.472v-64c0-17.664-14.336-32-32-32h-5.408c-11.552-62.624-41.696-198.016-90.592-224h-64c-47.36 25.984-78.304 161.376-90.336 224h-5.664c-17.664 0-32 14.336-32 32v64l-74.944 37.472c-32.512 16.256-53.056 49.504-53.056 85.856v484.672c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-484.672c0-36.352-20.544-69.6-53.056-85.856zM490.112 32h44.096c24.832 22.272 52.416 108.224 68.064 192h-180.192c16.224-83.648 43.904-169.408 68.032-192zM384 256h256v64h-256v-64zM768 928c0 35.36-28.64 64-64 64h-384c-35.36 0-64-28.64-64-64v-484.672c0-24.256 13.696-46.4 35.392-57.248l68.16-34.080h304.896l68.192 34.080c21.664 10.848 35.36 33.024 35.36 57.248v484.672zM640 480h-256c-17.664 0-32 14.336-32 32v352c0 17.664 14.336 32 32 32h256c17.664 0 32-14.336 32-32v-352c0-17.664-14.336-32-32-32zM640 864h-256v-352h256v352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glue",
						"paste",
						"stick"
					],
					"grid": 32
				},
				{
					"id": 542,
					"width": 1024,
					"paths": [
						"M746.944 357.472l-74.944-37.472h-320l-74.944 37.472c-32.512 16.256-53.056 49.504-53.056 85.856v484.672c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-484.672c0-36.352-20.544-69.6-53.056-85.856zM672 864c0 17.664-14.336 32-32 32h-256c-17.664 0-32-14.336-32-32v-352c0-17.664 14.336-32 32-32h256c17.664 0 32 14.336 32 32v352zM628.224 192h-231.936c14.944-68.32 43.328-169.856 83.712-192h64c41.664 22.144 69.696 123.68 84.224 192zM352 288v-32c0-17.664 14.336-32 32-32h256c17.664 0 32 14.336 32 32v32h-320zM384 512h256v352h-256v-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"glue",
						"paste",
						"stick"
					],
					"grid": 32
				},
				{
					"id": 1039,
					"width": 1024,
					"paths": [
						"M1003.488 490.112l-404.128-431.072c-6.592-7.040-14.912-10.176-23.104-10.176-16.416 0-32.256 12.672-32.256 32.064v175.072h-512c-17.664 0-32 14.336-32 32v448c0 17.664 14.336 32 32 32h512v175.072c0 19.36 15.84 32.064 32.256 32.064 8.16 0 16.512-3.136 23.104-10.176l404.128-431.072c11.52-12.32 11.52-31.456 0-43.776zM608 862.144v-158.144h-544v-384h544v-158.144l328.288 350.144-328.288 350.144z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"go",
						"move",
						"continue"
					],
					"grid": 32
				},
				{
					"id": 2645,
					"paths": [
						"M417.7 774.8l54.3 153.2v96h80v-96l54.298-153.2c-30.258 7.302-61.83 11.2-94.298 11.2s-64.042-3.896-94.3-11.2zM192 384c0-176.731 143.269-320 320-320s320 143.269 320 320c0 176.731-143.269 320-320 320s-320-143.269-320-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"golf",
						"sports",
						"ball",
						"game"
					],
					"defaultCode": 60480,
					"grid": 16
				},
				{
					"id": 2646,
					"paths": [
						"M1024 544c0 53.020-42.98 96-96 96-53.022 0-96-42.98-96-96s42.978-96 96-96c53.020 0 96 42.98 96 96z",
						"M256 64v384l448-192-448-192z",
						"M384 576c-44.886 0-87.96 4.508-128 12.764v243.236h-64v-800c0-17.672-14.328-32-32-32s-32 14.328-32 32v601.082c-78.54 41.014-128 100.588-128 166.918 0 123.71 171.922 224 384 224s384-100.29 384-224-171.924-224-384-224zM448 896c-70.694 0-128-42.98-128-96s57.306-96 128-96c70.692 0 128 42.98 128 96s-57.308 96-128 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"golf",
						"sports",
						"game"
					],
					"defaultCode": 60481,
					"grid": 16
				},
				{
					"id": 3324,
					"paths": [
						"M522.2 438.8v175.6h290.4c-11.8 75.4-87.8 220.8-290.4 220.8-174.8 0-317.4-144.8-317.4-323.2s142.6-323.2 317.4-323.2c99.4 0 166 42.4 204 79l139-133.8c-89.2-83.6-204.8-134-343-134-283 0-512 229-512 512s229 512 512 512c295.4 0 491.6-207.8 491.6-500.2 0-33.6-3.6-59.2-8-84.8l-483.6-0.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google",
						"brand"
					],
					"defaultCode": 61159,
					"grid": 16
				},
				{
					"id": 3331,
					"paths": [
						"M438 640l-184.6 320h580.6l184.6-320z",
						"M992.4 576l-295.6-512h-369.6l295.6 512z",
						"M290.2 128l-290.2 502.8 184.8 320 290.2-502.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google-drive",
						"brand"
					],
					"defaultCode": 61166,
					"grid": 16
				},
				{
					"id": 3327,
					"paths": [
						"M325.8 457.4v111.8h184.8c-7.4 48-55.8 140.6-184.8 140.6-111.2 0-202-92.2-202-205.8s90.8-205.8 202-205.8c63.4 0 105.6 27 129.8 50.2l88.4-85.2c-56.8-53-130.4-85.2-218.2-85.2-180.2 0.2-325.8 145.8-325.8 326s145.6 325.8 325.8 325.8c188 0 312.8-132.2 312.8-318.4 0-21.4-2.4-37.8-5.2-54h-307.6z",
						"M1024 448h-96v-96h-96v96h-96v96h96v96h96v-96h96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google-plus",
						"brand",
						"social"
					],
					"defaultCode": 61162,
					"grid": 16
				},
				{
					"id": 1811,
					"width": 877.7139282226562,
					"paths": [
						"M524 517.143q0-18.857-3.429-36.571h-206.857v75.429h124q-6.857 43.429-42.571 68.857t-81.429 25.429q-56.571 0-96.571-40.857t-40-97.429 40-97.429 96.571-40.857q53.143 0 87.429 33.714l59.429-57.714q-61.714-57.143-146.857-57.143-91.429 0-155.429 64.286t-64 155.143 64 155.143 155.429 64.286q94.286 0 152.286-60t58-154.286zM721.143 543.429h62.286v-62.857h-62.286v-62.857h-62.857v62.857h-62.857v62.857h62.857v62.857h62.857v-62.857zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google-plus-circle",
						"google-plus-official"
					],
					"defaultCode": 62131,
					"grid": 14
				},
				{
					"id": 1366,
					"width": 877.7129821777344,
					"paths": [
						"M524 517.143q0-14.857-3.429-36.571h-206.857v75.429h124q-1.714 13.714-9.429 28.571t-21.429 30.286-38 25.429-55.143 10q-56.571 0-96.571-40.571t-40-97.714 40-97.714 96.571-40.571q52.571 0 87.429 33.714l59.429-57.714q-61.714-57.143-146.857-57.143-91.429 0-155.429 64.286t-64 155.143 64 155.143 155.429 64.286q94.286 0 152.286-60t58-154.286zM721.143 543.429h62.286v-62.857h-62.286v-62.857h-62.857v62.857h-62.857v62.857h62.857v62.857h62.857v-62.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google-plus-square"
					],
					"defaultCode": 61652,
					"grid": 14
				},
				{
					"id": 3328,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM384 768c-141.6 0-256-114.4-256-256s114.4-256 256-256c69.2 0 127 25.2 171.6 67l-69.6 66.8c-19-18.2-52.2-39.4-102-39.4-87.4 0-158.8 72.4-158.8 161.6s71.4 161.6 158.8 161.6c101.4 0 139.4-72.8 145.2-110.4h-145.2v-87.8h241.8c2.2 12.8 4 25.6 4 42.4 0 146.4-98 250.2-245.8 250.2zM896 512h-64v64h-64v-64h-64v-64h64v-64h64v64h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google-plus",
						"brand",
						"social"
					],
					"defaultCode": 61163,
					"grid": 16
				},
				{
					"id": 3329,
					"paths": [
						"M512 0c-282.8 0-512 229.2-512 512s229.2 512 512 512 512-229.2 512-512-229.2-512-512-512zM384 768c-141.6 0-256-114.4-256-256s114.4-256 256-256c69.2 0 127 25.2 171.6 67l-69.6 66.8c-19-18.2-52.2-39.4-102-39.4-87.4 0-158.8 72.4-158.8 161.6s71.4 161.6 158.8 161.6c101.4 0 139.4-72.8 145.2-110.4h-145.2v-87.8h241.8c2.2 12.8 4 25.6 4 42.4 0 146.4-98 250.2-245.8 250.2zM832 512v64h-64v-64h-64v-64h64v-64h64v64h64v64h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google-plus",
						"brand",
						"social"
					],
					"defaultCode": 61164,
					"grid": 16
				},
				{
					"id": 1367,
					"width": 1316.5720977783203,
					"paths": [
						"M821.143 521.714q0 118.857-49.714 211.714t-141.714 145.143-210.857 52.286q-85.143 0-162.857-33.143t-133.714-89.143-89.143-133.714-33.143-162.857 33.143-162.857 89.143-133.714 133.714-89.143 162.857-33.143q163.429 0 280.571 109.714l-113.714 109.143q-66.857-64.571-166.857-64.571-70.286 0-130 35.429t-94.571 96.286-34.857 132.857 34.857 132.857 94.571 96.286 130 35.429q47.429 0 87.143-13.143t65.429-32.857 44.857-44.857 28-47.429 12.286-42.286h-237.714v-144h395.429q6.857 36 6.857 69.714zM1316.571 452v120h-119.429v119.429h-120v-119.429h-119.429v-120h119.429v-119.429h120v119.429h119.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google-plus"
					],
					"defaultCode": 61653,
					"grid": 14
				},
				{
					"id": 1629,
					"width": 1041.1429634094238,
					"paths": [
						"M252 384q18.286 0 29.714 14.857 152 208 206.857 442.286h-254.857q-72.571-252-209.714-428-6.857-9.143-1.714-19.143t16.571-10h213.143zM571.429 588q-28 113.714-71.429 224.571-45.143-177.143-146.286-339.429 22.857-126.286 25.143-256.571 120.571 194.286 192.571 371.429zM628 182.857q134.286 185.143 219.714 399.143t105.429 442h-257.714q-23.429-380-316-841.143h248.571zM1024 512q0 242.286-57.714 464-38.286-320-205.143-618.857-14.286-172-60.571-333.714-2.286-9.143 3.143-16.286t14.571-7.143h205.143q12 0 22 7.429t12.857 18.857q65.714 233.714 65.714 485.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google-wallet"
					],
					"defaultCode": 61934,
					"grid": 14
				},
				{
					"id": 3325,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM519.6 896c-212.2 0-384-171.8-384-384s171.8-384 384-384c103.6 0 190.4 37.8 257.2 100.4l-104.2 100.4c-28.6-27.4-78.4-59.2-153-59.2-131.2 0-238 108.6-238 242.4s107 242.4 238 242.4c152 0 209-109.2 217.8-165.6h-217.8v-131.6h362.6c3.2 19.2 6 38.4 6 63.6 0.2 219.4-146.8 375.2-368.6 375.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google",
						"brand"
					],
					"defaultCode": 61160,
					"grid": 16
				},
				{
					"id": 3326,
					"paths": [
						"M512 0c-282.8 0-512 229.2-512 512s229.2 512 512 512 512-229.2 512-512-229.2-512-512-512zM519.6 896c-212.2 0-384-171.8-384-384s171.8-384 384-384c103.6 0 190.4 37.8 257.2 100.4l-104.2 100.4c-28.6-27.4-78.4-59.2-153-59.2-131.2 0-238 108.6-238 242.4s107 242.4 238 242.4c152 0 209-109.2 217.8-165.6h-217.8v-131.6h362.6c3.2 19.2 6 38.4 6 63.6 0.2 219.4-146.8 375.2-368.6 375.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google",
						"brand"
					],
					"defaultCode": 61161,
					"grid": 16
				},
				{
					"id": 1555,
					"width": 859.9989624023438,
					"paths": [
						"M438.857 449.143h414.286q6.857 38.286 6.857 73.143 0 124-52 221.429t-148.286 152.286-220.857 54.857q-89.714 0-170.857-34.571t-140-93.429-93.429-140-34.571-170.857 34.571-170.857 93.429-140 140-93.429 170.857-34.571q171.429 0 294.286 114.857l-119.429 114.857q-70.286-68-174.857-68-73.714 0-136.286 37.143t-99.143 100.857-36.571 139.143 36.571 139.143 99.143 100.857 136.286 37.143q49.714 0 91.429-13.714t68.571-34.286 46.857-46.857 29.429-49.714 12.857-44.571h-249.143v-150.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"google"
					],
					"defaultCode": 61856,
					"grid": 14
				},
				{
					"id": 2895,
					"paths": [
						"M768 1024h-320c-7.638 0-15.026-2.732-20.826-7.704l-224-192c-7.092-6.080-11.174-14.954-11.174-24.296v-256c0-17.674 14.328-32 32-32h96v-160c0-17.672 14.328-32 32-32h128c0 0 0 0 0 0h256c17.674 0 32 14.328 32 32v32h96c17.674 0 32 14.328 32 32v384c0 4.968-1.156 9.868-3.378 14.31l-96 192c-5.42 10.842-16.5 17.69-28.622 17.69zM459.838 960h288.384l83.778-167.554v-344.446h-64v96c0 17.674-14.326 32-32 32s-32-14.326-32-32v-160h-64v160c0 17.674-14.326 32-32 32s-32-14.326-32-32v-160h-64v160c0 17.674-14.328 32-32 32s-32-14.326-32-32v-160h-64v288c0 17.674-14.328 32-32 32s-32-14.326-32-32v-96h-64v209.282l203.838 174.718z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grab",
						"fist",
						"drag",
						"hand"
					],
					"defaultCode": 60730,
					"grid": 16
				},
				{
					"id": 1861,
					"paths": [
						"M960 0h-896c-35.2 0-64 28.8-64 64v896c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-896c0-35.2-28.8-64-64-64zM320 64v32h-32v-32h32zM288 800v-32h32v32h-32zM320 832v32h-32v-32h32zM288 736v-32h32v32h-32zM288 672v-32h32v32h-32zM288 608v-32h32v32h-32zM288 544v-32h32v32h-32zM288 480v-32h32v32h-32zM288 416v-32h32v32h-32zM288 352v-32h32v32h-32zM288 288v-32h32v32h-32zM288 224v-32h32v32h-32zM288 160v-32h32v32h-32zM288 896h32v32h-32v-32zM256 64v32h-32v-32h32zM224 800v-32h32v32h-32zM256 832v32h-32v-32h32zM224 736v-32h32v32h-32zM224 672v-32h32v32h-32zM224 608v-32h32v32h-32zM224 544v-32h32v32h-32zM224 480v-32h32v32h-32zM224 416v-32h32v32h-32zM224 352v-32h32v32h-32zM224 288v-32h32v32h-32zM224 224v-32h32v32h-32zM224 160v-32h32v32h-32zM224 896h32v32h-32v-32zM192 64v32h-32v-32h32zM160 800v-32h32v32h-32zM192 832v32h-32v-32h32zM160 736v-32h32v32h-32zM160 672v-32h32v32h-32zM160 608v-32h32v32h-32zM160 544v-32h32v32h-32zM160 480v-32h32v32h-32zM160 416v-32h32v32h-32zM160 352v-32h32v32h-32zM160 288v-32h32v32h-32zM160 224v-32h32v32h-32zM160 160v-32h32v32h-32zM160 896h32v32h-32v-32zM960 960h-128v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v-32h32v32h32v-32h32v32h32v-32h32v32h32v-32h32v32h32v-32h352v896z",
						"M480 96h32v32h-32v-32z",
						"M544 96h32v32h-32v-32z",
						"M608 96h32v32h-32v-32z",
						"M672 96h32v32h-32v-32z",
						"M512 128h32v32h-32v-32z",
						"M480 160h32v32h-32v-32z",
						"M576 128h32v32h-32v-32z",
						"M544 160h32v32h-32v-32z",
						"M416 96h32v32h-32v-32z",
						"M384 128h32v32h-32v-32z",
						"M448 128h32v32h-32v-32z",
						"M416 160h32v32h-32v-32z",
						"M608 160h32v32h-32v-32z",
						"M672 160h32v32h-32v-32z",
						"M736 96h32v32h-32v-32z",
						"M800 96h32v32h-32v-32z",
						"M736 160h32v32h-32v-32z",
						"M800 160h32v32h-32v-32z",
						"M512 192h32v32h-32v-32z",
						"M480 224h32v32h-32v-32z",
						"M576 192h32v32h-32v-32z",
						"M544 224h32v32h-32v-32z",
						"M608 224h32v32h-32v-32z",
						"M672 224h32v32h-32v-32z",
						"M512 256h32v32h-32v-32z",
						"M480 288h32v32h-32v-32z",
						"M576 256h32v32h-32v-32z",
						"M544 288h32v32h-32v-32z",
						"M384 192h32v32h-32v-32z",
						"M448 192h32v32h-32v-32z",
						"M416 224h32v32h-32v-32z",
						"M384 256h32v32h-32v-32z",
						"M448 256h32v32h-32v-32z",
						"M416 288h32v32h-32v-32z",
						"M608 288h32v32h-32v-32z",
						"M672 288h32v32h-32v-32z",
						"M736 224h32v32h-32v-32z",
						"M800 224h32v32h-32v-32z",
						"M736 288h32v32h-32v-32z",
						"M800 288h32v32h-32v-32z",
						"M512 320h32v32h-32v-32z",
						"M480 352h32v32h-32v-32z",
						"M576 320h32v32h-32v-32z",
						"M544 352h32v32h-32v-32z",
						"M608 352h32v32h-32v-32z",
						"M672 352h32v32h-32v-32z",
						"M512 384h32v32h-32v-32z",
						"M480 416h32v32h-32v-32z",
						"M576 384h32v32h-32v-32z",
						"M544 416h32v32h-32v-32z",
						"M384 320h32v32h-32v-32z",
						"M448 320h32v32h-32v-32z",
						"M416 352h32v32h-32v-32z",
						"M384 384h32v32h-32v-32z",
						"M448 384h32v32h-32v-32z",
						"M416 416h32v32h-32v-32z",
						"M608 416h32v32h-32v-32z",
						"M672 416h32v32h-32v-32z",
						"M736 352h32v32h-32v-32z",
						"M800 352h32v32h-32v-32z",
						"M736 416h32v32h-32v-32z",
						"M800 416h32v32h-32v-32z",
						"M512 448h32v32h-32v-32z",
						"M480 480h32v32h-32v-32z",
						"M576 448h32v32h-32v-32z",
						"M544 480h32v32h-32v-32z",
						"M608 480h32v32h-32v-32z",
						"M672 480h32v32h-32v-32z",
						"M512 512h32v32h-32v-32z",
						"M480 544h32v32h-32v-32z",
						"M576 512h32v32h-32v-32z",
						"M544 544h32v32h-32v-32z",
						"M384 448h32v32h-32v-32z",
						"M448 448h32v32h-32v-32z",
						"M416 480h32v32h-32v-32z",
						"M384 512h32v32h-32v-32z",
						"M448 512h32v32h-32v-32z",
						"M416 544h32v32h-32v-32z",
						"M608 544h32v32h-32v-32z",
						"M672 544h32v32h-32v-32z",
						"M736 480h32v32h-32v-32z",
						"M800 480h32v32h-32v-32z",
						"M736 544h32v32h-32v-32z",
						"M800 544h32v32h-32v-32z",
						"M512 576h32v32h-32v-32z",
						"M480 608h32v32h-32v-32z",
						"M576 576h32v32h-32v-32z",
						"M544 608h32v32h-32v-32z",
						"M608 608h32v32h-32v-32z",
						"M672 608h32v32h-32v-32z",
						"M512 640h32v32h-32v-32z",
						"M480 672h32v32h-32v-32z",
						"M576 640h32v32h-32v-32z",
						"M544 672h32v32h-32v-32z",
						"M384 576h32v32h-32v-32z",
						"M448 576h32v32h-32v-32z",
						"M416 608h32v32h-32v-32z",
						"M384 640h32v32h-32v-32z",
						"M448 640h32v32h-32v-32z",
						"M416 672h32v32h-32v-32z",
						"M608 672h32v32h-32v-32z",
						"M672 672h32v32h-32v-32z",
						"M736 608h32v32h-32v-32z",
						"M800 608h32v32h-32v-32z",
						"M736 672h32v32h-32v-32z",
						"M800 672h32v32h-32v-32z",
						"M512 704h32v32h-32v-32z",
						"M480 736h32v32h-32v-32z",
						"M576 704h32v32h-32v-32z",
						"M544 736h32v32h-32v-32z",
						"M608 736h32v32h-32v-32z",
						"M672 736h32v32h-32v-32z",
						"M512 768h32v32h-32v-32z",
						"M480 800h32v32h-32v-32z",
						"M576 768h32v32h-32v-32z",
						"M544 800h32v32h-32v-32z",
						"M384 704h32v32h-32v-32z",
						"M448 704h32v32h-32v-32z",
						"M416 736h32v32h-32v-32z",
						"M384 768h32v32h-32v-32z",
						"M448 768h32v32h-32v-32z",
						"M416 800h32v32h-32v-32z",
						"M608 800h32v32h-32v-32z",
						"M672 800h32v32h-32v-32z",
						"M736 736h32v32h-32v-32z",
						"M800 736h32v32h-32v-32z",
						"M736 800h32v32h-32v-32z",
						"M800 800h32v32h-32v-32z",
						"M512 832h32v32h-32v-32z",
						"M480 864h32v32h-32v-32z",
						"M576 832h32v32h-32v-32z",
						"M544 864h32v32h-32v-32z",
						"M608 864h32v32h-32v-32z",
						"M672 864h32v32h-32v-32z",
						"M512 896h32v32h-32v-32z",
						"M576 896h32v32h-32v-32z",
						"M384 832h32v32h-32v-32z",
						"M448 832h32v32h-32v-32z",
						"M416 864h32v32h-32v-32z",
						"M384 896h32v32h-32v-32z",
						"M448 896h32v32h-32v-32z",
						"M736 864h32v32h-32v-32z",
						"M800 864h32v32h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gradient",
						"color",
						"dualtone"
					],
					"defaultCode": 59696,
					"grid": 16
				},
				{
					"id": 1967,
					"paths": [
						"M192 587.332v148.668c0 64 143.268 160 320 160 176.73 0 320-96 320-160v-148.668l-320 160-320-160zM512 128l-512 256 512 256 415.428-207.714-31.428 271.714h64v-288l64-32-512-256zM544 398.4c-25.626 0-46.4-20.774-46.4-46.4s20.774-46.4 46.4-46.4 46.4 20.774 46.4 46.4c0 25.626-20.772 46.4-46.4 46.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"graduation",
						"education",
						"hat"
					],
					"defaultCode": 59802,
					"grid": 16
				},
				{
					"id": 1553,
					"width": 1316.5759868621826,
					"paths": [
						"M1013.714 477.714l10.286 180.571q2.286 39.429-46.857 73.143t-134.286 53.429-184.571 19.714-184.571-19.714-134.286-53.429-46.857-73.143l10.286-180.571 328 103.429q12.571 4 27.429 4t27.429-4zM1316.571 292.571q0 13.143-12.571 17.714l-640 201.143q-2.286 0.571-5.714 0.571t-5.714-0.571l-372.571-117.714q-24.571 19.429-40.571 63.714t-19.429 102q36 20.571 36 62.286 0 39.429-33.143 61.143l33.143 247.429q1.143 8-4.571 14.286-5.143 6.286-13.714 6.286h-109.714q-8.571 0-13.714-6.286-5.714-6.286-4.571-14.286l33.143-247.429q-33.143-21.714-33.143-61.143 0-41.714 37.143-63.429 6.286-118.286 56-188.571l-190.286-59.429q-12.571-4.571-12.571-17.714t12.571-17.714l640-201.143q2.286-0.571 5.714-0.571t5.714 0.571l640 201.143q12.571 4.571 12.571 17.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"graduation-cap",
						"mortar-board"
					],
					"defaultCode": 61853,
					"grid": 14
				},
				{
					"id": 128,
					"paths": [
						"M955.296 359.714l-460.8-153.6c-5.254-1.752-10.936-1.752-16.19 0l-460.8 153.6c-10.454 3.485-17.506 13.267-17.506 24.286s7.051 20.802 17.504 24.286l136.096 45.365v135.149c0 6.789 2.698 13.301 7.499 18.101 4.486 4.488 112.346 109.899 325.301 109.899 77.454 0 149.712-13.941 214.766-41.434 13.024-5.504 19.118-20.523 13.616-33.547-5.504-13.024-20.525-19.117-33.547-13.616-58.714 24.816-124.266 37.397-194.835 37.397-99.586 0-172.84-25.781-216.758-47.41-32.53-16.019-54.259-32.203-64.842-40.926v-106.547l273.504 91.168c2.627 0.877 5.362 1.314 8.096 1.314s5.467-0.437 8.096-1.314l273.504-91.168v45.686c-29.797 10.568-51.2 39.024-51.2 72.397 0 31.269 18.792 58.213 45.666 70.181l-44.901 179.61c-1.91 7.648-0.194 15.75 4.658 21.965s12.294 9.845 20.178 9.845h102.4c7.883 0 15.326-3.632 20.178-9.845s6.568-14.315 4.658-21.965l-44.901-179.61c26.874-11.968 45.666-38.912 45.666-70.181 0-33.373-21.403-61.829-51.2-72.397v-62.752l136.096-45.366c10.453-3.483 17.504-13.266 17.504-24.285s-7.051-20.802-17.504-24.286zM793.6 563.2c14.115 0 25.6 11.485 25.6 25.6s-11.485 25.6-25.6 25.6-25.6-11.485-25.6-25.6 11.485-25.6 25.6-25.6zM775.187 819.2l18.413-73.648 18.413 73.648h-36.826zM791.536 408.902l-300.928-50.155c-13.952-2.322-27.136 7.099-29.461 21.042-2.325 13.947 7.098 27.138 21.043 29.461l205.533 34.256-201.323 67.11-379.846-126.616 379.846-126.616 379.845 126.616-74.709 24.902z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"graduation-hat",
						"education",
						"university",
						"college",
						"school"
					],
					"defaultCode": 59425,
					"grid": 20
				},
				{
					"id": 2533,
					"paths": [
						"M192 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M448 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M704 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M320 736c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M576 736c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M832 736c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M448 544c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M704 544c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M992 448c-2.648 0-5.37-0.014-8.162-0.030-37.534-0.208-90.668-0.476-154.32 31.678 1.928-18.31 2.482-31.648 2.482-31.648 0-224-96-320-320-320 0 201.070 77.376 298.988 255.224 316.93-2.208 45.978-10.318 76.884-38.524 109.438-9.446 9.33-19.024 19.464-28.728 30.496-11.672 13.27-10.378 33.49 2.89 45.164 6.080 5.348 13.618 7.972 21.124 7.972 8.192 0 16.322-3.168 22.504-9.298 0.052-0.042 0.126-0.064 0.176-0.114 10.618-10.656 20.226-20.708 28.824-30.524 88.482-86.732 156.836-86.362 208-86.096 2.91 0.016 5.746 0.032 8.508 0.032 17.674 0 32-14.328 32-32s-14.324-32-31.998-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grapes",
						"fruit",
						"food"
					],
					"defaultCode": 60368,
					"grid": 16
				},
				{
					"id": 2674,
					"paths": [
						"M0 0h256v256h-256zM384 0h256v256h-256zM768 0h256v256h-256zM0 384h256v256h-256zM384 384h256v256h-256zM768 384h256v256h-256zM0 768h256v256h-256zM384 768h256v256h-256zM768 768h256v256h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grid",
						"icons",
						"apps",
						"squares"
					],
					"defaultCode": 60509,
					"grid": 16
				},
				{
					"id": 2675,
					"paths": [
						"M0 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM384 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM768 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM384 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM768 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 896c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM384 896c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM768 896c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grid",
						"icons",
						"apps",
						"circles"
					],
					"defaultCode": 60510,
					"grid": 16
				},
				{
					"id": 2676,
					"paths": [
						"M64 64h256v256h-256zM384 64h256v256h-256zM704 64h256v256h-256zM64 384h256v256h-256zM384 384h256v256h-256zM704 384h256v256h-256zM64 704h256v256h-256zM384 704h256v256h-256zM704 704h256v256h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grid",
						"icons",
						"apps",
						"squares"
					],
					"defaultCode": 60511,
					"grid": 16
				},
				{
					"id": 2677,
					"paths": [
						"M192 64v0c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM512 64v0c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM832 64v0c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM192 384v0c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM512 384v0c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM832 384v0c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM192 704v0c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM512 704v0c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM832 704v0c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grid",
						"icons",
						"apps",
						"circles"
					],
					"defaultCode": 60512,
					"grid": 16
				},
				{
					"id": 2678,
					"paths": [
						"M896 384h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM896 576h-128v-128h128v128z",
						"M576 384h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM576 576h-128v-128h128v128z",
						"M256 384h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM256 576h-128v-128h128v128z",
						"M896 64h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM896 256h-128v-128h128v128z",
						"M576 64h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM576 256h-128v-128h128v128z",
						"M256 64h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM256 256h-128v-128h128v128z",
						"M896 704h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM896 896h-128v-128h128v128z",
						"M576 704h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM576 896h-128v-128h128v128z",
						"M256 704h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM256 896h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grid",
						"icons",
						"apps",
						"squares"
					],
					"defaultCode": 60513,
					"grid": 16
				},
				{
					"id": 2679,
					"paths": [
						"M0 0h448v448h-448zM576 0h448v448h-448zM0 576h448v448h-448zM576 576h448v448h-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grid",
						"icons",
						"apps",
						"squares"
					],
					"defaultCode": 60514,
					"grid": 16
				},
				{
					"id": 2680,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM960 320h-256v-256h256v256zM384 640v-256h256v256h-256zM640 704v256h-256v-256h256zM320 640h-256v-256h256v256zM384 320v-256h256v256h-256zM704 384h256v256h-256v-256zM320 64v256h-256v-256h256zM64 704h256v256h-256v-256zM704 960v-256h256v256h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grid",
						"icons",
						"apps",
						"squares"
					],
					"defaultCode": 60515,
					"grid": 16
				},
				{
					"id": 543,
					"width": 1024,
					"paths": [
						"M880 416h-16c0-161.088-108.352-230.848-256.064-250.048 0.032 0 0.032 0 0.064 0v-37.952c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v37.952c0.032 0 0.032 0 0.064 0-147.712 19.2-256.064 88.96-256.064 250.048h-16c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h16c0 127.392 67.904 238.656 169.28 300.448l-81.664 190.56c-3.488 8.096 0.256 17.504 8.384 20.992s17.504-0.288 20.992-8.416l23.84-55.584h422.336l23.84 55.584c3.456 8.128 12.864 11.904 20.992 8.416s11.872-12.896 8.416-20.992l-81.664-190.56c101.344-61.792 169.248-173.056 169.248-300.448h16c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM448 162.56v-34.56h128v34.56c-20.768-1.664-42.112-2.56-64-2.56s-43.232 0.896-64 2.56v0zM709.44 864h-394.88l42.912-100.096c46.688 22.88 99.008 36.096 154.528 36.096s107.84-13.216 154.56-36.096l42.88 100.096zM512 768c-176.448 0-320-143.552-320-320h640c0 176.448-143.552 320-320 320zM192 416c0-224 240.864-224 320-224s320 0 320 224h-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grill",
						"cook",
						"heat",
						"barbecue"
					],
					"grid": 32
				},
				{
					"id": 544,
					"width": 1024,
					"paths": [
						"M880 416h-16c0-161.088-108.352-230.848-256.064-250.048 0.032 0 0.032 0 0.064 0v-37.952c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v37.952c0.032 0 0.032 0 0.064 0-147.712 19.2-256.064 88.96-256.064 250.048h-16c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h736c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM512 160c-21.888 0-43.232 0.896-64 2.56v0-34.56h128v34.56c-20.768-1.664-42.112-2.56-64-2.56zM694.72 748.448c92.736-56.512 156.8-154.624 167.136-268.448h-699.744c10.368 113.792 74.432 211.904 167.136 268.448l-81.664 190.56c-3.456 8.096 0.288 17.504 8.416 20.992s17.504-0.288 20.992-8.416l23.84-55.584h422.336l23.84 55.584c3.456 8.128 12.864 11.904 20.992 8.416s11.872-12.896 8.416-20.992l-81.696-190.56zM314.56 864l42.912-100.096c46.688 22.88 99.008 36.096 154.528 36.096s107.84-13.216 154.56-36.096l42.88 100.096h-394.88z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grill",
						"cook",
						"heat",
						"barbecue"
					],
					"grid": 32
				},
				{
					"id": 2849,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM192 512v64c0 140.8 115.2 256 256 256h128c140.8 0 256-115.2 256-256v-64h-640zM384 756.988c-26.538-9.458-50.924-24.822-71.544-45.446-36.406-36.402-56.456-84.54-56.456-135.542h128v180.988zM576 768h-128v-192h128v192zM711.544 711.542c-20.624 20.624-45.010 35.988-71.544 45.446v-180.988h128c0 51.002-20.048 99.14-56.456 135.542zM225.352 384c0.002 0 0 0 0 0 9.768 0 18.108-7.056 19.724-16.69 6.158-36.684 37.668-63.31 74.924-63.31s68.766 26.626 74.924 63.31c1.616 9.632 9.956 16.69 19.722 16.69 9.768 0 18.108-7.056 19.724-16.688 1.082-6.436 1.628-12.934 1.628-19.312 0-63.962-52.038-116-116-116s-116 52.038-116 116c0 6.378 0.548 12.876 1.628 19.312 1.62 9.632 9.96 16.688 19.726 16.688zM609.352 384c0.002 0 0 0 0 0 9.77 0 18.112-7.056 19.724-16.69 6.158-36.684 37.668-63.31 74.924-63.31s68.766 26.626 74.924 63.31c1.616 9.632 9.958 16.69 19.722 16.69s18.108-7.056 19.722-16.688c1.082-6.436 1.628-12.934 1.628-19.312 0-63.962-52.038-116-116-116s-116 52.038-116 116c0 6.378 0.544 12.876 1.626 19.312 1.624 9.632 9.964 16.688 19.73 16.688z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grin",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60684,
					"grid": 16
				},
				{
					"id": 2850,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.226 512 512 512c282.77 0 512-229.23 512-512s-229.23-512-512-512zM704 236c63.962 0 116 52.038 116 116 0 6.378-0.546 12.876-1.628 19.312-1.618 9.632-9.958 16.688-19.724 16.688s-18.108-7.056-19.722-16.69c-6.16-36.684-37.67-53.31-74.926-53.31s-68.766 16.626-74.924 53.31c-1.616 9.632-9.956 16.69-19.722 16.69-0.002 0 0 0-0.002 0-9.766 0-18.106-7.056-19.722-16.688-1.084-6.436-1.63-12.934-1.63-19.312 0-63.962 52.038-116 116-116zM320 236c63.962 0 116 52.038 116 116 0 6.378-0.548 12.876-1.628 19.312-1.618 9.632-9.956 16.688-19.724 16.688s-18.106-7.056-19.722-16.69c-6.16-36.684-37.67-53.31-74.926-53.31s-68.766 16.626-74.924 53.31c-1.616 9.632-9.956 16.69-19.722 16.69 0 0 0 0 0 0-9.766 0-18.106-7.056-19.724-16.688-1.082-6.436-1.63-12.934-1.63-19.312 0-63.962 52.038-116 116-116zM192 576h192v247.846c-110.094-28.606-192-129.124-192-247.846zM448 832v-256h128v256h-128zM640 823.846v-247.846h192c0 118.722-81.904 219.24-192 247.846z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grin",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60685,
					"grid": 16
				},
				{
					"id": 545,
					"width": 1024,
					"paths": [
						"M1005.856 355.168c-4.416-2.144-9.152-3.168-13.856-3.168-7.136 0-14.208 2.368-20 7.008l-39.2 31.36c-15.392 12.32-33.824 18.816-53.312 18.816-34.464 0-65.504-20.416-79.040-52-26.336-61.472-86.56-101.184-153.472-101.184-55.616 0-104.64 27.584-135.008 69.536-30.336-41.952-79.36-69.536-134.944-69.536-66.88 0-127.136 39.712-153.504 101.216-13.536 31.584-44.544 52-79.040 52-19.488 0-37.92-6.496-53.312-18.816l-39.2-31.36c-5.76-4.672-12.832-7.040-19.968-7.040-4.704 0-9.44 1.024-13.856 3.168-11.104 5.312-18.144 16.544-18.144 28.832v39.040c0 137.28 111.68 248.96 248.96 248.96h46.080c93.056 0 174.24-51.424 216.96-127.264 42.72 75.84 123.904 127.264 216.96 127.264h46.080c137.28 0 248.96-111.68 248.96-248.96v-39.040c0-12.288-7.040-23.52-18.144-28.832zM533.152 352c23.808-38.176 65.536-64 113.824-64v0c53.984 0 102.816 32.192 124.064 81.824 19.552 45.664 63.456 71.392 108.448 71.392 11.776 0 23.616-1.984 35.136-5.6l-35.104 25.088c-60.896 43.552-146.304 32.64-194.304-24.992l-16.96-20.352c-33.536-40.288-82.816-63.36-135.2-63.36h0.096zM144.48 441.184c44.992 0 88.864-25.728 108.448-71.392 21.28-49.6 70.080-81.792 124.096-81.792 48.32 0 90.016 25.824 113.856 64h0.096c-52.384 0-101.664 23.072-135.2 63.328l-16.96 20.352c-47.968 57.696-133.344 68.576-194.304 24.992l-35.104-25.088c11.456 3.648 23.296 5.6 35.072 5.6zM775.040 640h-46.080c-88.064 0-163.584-52.64-197.568-128h-38.752c-34.016 75.36-109.536 128-197.568 128h-46.112c-102.208 0-187.68-70.784-210.688-165.92l73.76 61.472c38.048 31.712 85.632 48 133.472 48 34.976 0 70.080-8.704 101.696-26.496l104.128-58.528c18.56-10.464 39.36-16.384 60.672-17.856 21.28 1.472 42.112 7.392 60.672 17.856l104.096 58.528c31.584 17.792 66.72 26.496 101.728 26.496 47.808 0 95.36-16.288 133.44-48l73.76-61.472c-22.976 95.136-108.448 165.92-210.656 165.92zM992 423.040c0 1.472-0.192 2.88-0.224 4.32l-100.352 83.584c-55.712 46.464-135.712 53.792-198.976 18.176l-104.064-58.528c-23.36-13.184-49.6-20.48-76.416-21.984-26.784 1.504-53.024 8.8-76.384 21.984l-104.096 58.528c-63.296 35.584-143.232 28.256-198.976-18.176l-100.352-83.584c0.032-1.44-0.16-2.848-0.16-4.32v-3.392l93.856 67.072c30.72 21.92 66.432 32.544 101.984 32.544 50.752 0 101.056-21.696 135.52-63.104l16.96-20.352c27.456-32.928 67.776-51.808 110.624-51.808h42.112c42.848 0 83.168 18.88 110.624 51.808l16.96 20.352c34.464 41.408 84.768 63.104 135.52 63.104 35.52 0 71.296-10.624 101.984-32.544l93.856-67.072v3.392z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"groom",
						"grow",
						"cultivate"
					],
					"grid": 32
				},
				{
					"id": 546,
					"width": 1024,
					"paths": [
						"M1005.856 355.168c-4.416-2.144-9.152-3.168-13.856-3.168-7.136 0-14.208 2.368-20 7.008l-39.2 31.36c-15.392 12.32-33.824 18.816-53.312 18.816-34.464 0-65.504-20.416-79.040-52-26.336-61.472-86.56-101.184-153.472-101.184-55.616 0-104.64 27.584-135.008 69.536-30.336-41.952-79.36-69.536-134.944-69.536-66.88 0-127.136 39.712-153.504 101.216-13.536 31.584-44.544 52-79.040 52-19.488 0-37.92-6.496-53.312-18.816l-39.2-31.36c-5.76-4.672-12.832-7.040-19.968-7.040-4.704 0-9.44 1.024-13.856 3.168-11.104 5.312-18.144 16.544-18.144 28.832v39.040c0 137.28 111.68 248.96 248.96 248.96h46.080c93.056 0 174.24-51.424 216.96-127.264 42.72 75.84 123.904 127.264 216.96 127.264h46.080c137.28 0 248.96-111.68 248.96-248.96v-39.040c0-12.288-7.040-23.52-18.144-28.832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"groom",
						"grow",
						"cultivate"
					],
					"grid": 32
				},
				{
					"id": 1347,
					"width": 1097.1430435180664,
					"paths": [
						"M338.857 512q-92.571 2.857-151.429 73.143h-76.571q-46.857 0-78.857-23.143t-32-67.714q0-201.714 70.857-201.714 3.429 0 24.857 12t55.714 24.286 68 12.286q38.286 0 76-13.143-2.857 21.143-2.857 37.714 0 79.429 46.286 146.286zM950.857 876q0 68.571-41.714 108.286t-110.857 39.714h-499.429q-69.143 0-110.857-39.714t-41.714-108.286q0-30.286 2-59.143t8-62.286 15.143-62 24.571-55.714 35.429-46.286 48.857-30.571 63.714-11.429q5.714 0 24.571 12.286t41.714 27.429 61.143 27.429 77.143 12.286 77.143-12.286 61.143-27.429 41.714-27.429 24.571-12.286q34.857 0 63.714 11.429t48.857 30.571 35.429 46.286 24.571 55.714 15.143 62 8 62.286 2 59.143zM365.714 146.286q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429 42.857-103.429 103.429-42.857 103.429 42.857 42.857 103.429zM768 365.714q0 90.857-64.286 155.143t-155.143 64.286-155.143-64.286-64.286-155.143 64.286-155.143 155.143-64.286 155.143 64.286 64.286 155.143zM1097.143 494.286q0 44.571-32 67.714t-78.857 23.143h-76.571q-58.857-70.286-151.429-73.143 46.286-66.857 46.286-146.286 0-16.571-2.857-37.714 37.714 13.143 76 13.143 33.714 0 68-12.286t55.714-24.286 24.857-12q70.857 0 70.857 201.714zM1024 146.286q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429 42.857-103.429 103.429-42.857 103.429 42.857 42.857 103.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"group",
						"users"
					],
					"defaultCode": 61632,
					"grid": 14
				},
				{
					"id": 547,
					"width": 1024,
					"paths": [
						"M869.6 880.448l-133.6-240.448h9.6c24.416 0 39.84-26.208 27.968-47.552l-133.568-240.448h10.080c24.288 0 39.712-25.984 28.096-47.328l-138.080-253.184c-6.080-11.104-17.088-16.672-28.096-16.672s-22.016 5.568-28.096 16.672l-138.080 253.184c-11.648 21.344 3.776 47.328 28.096 47.328h10.080l-133.6 240.448c-11.84 21.344 3.584 47.552 28 47.552h9.6l-133.6 240.448c-11.84 21.344 3.584 47.552 28 47.552h233.6v64c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-64h233.6c24.416 0 39.84-26.208 28-47.552zM576 992h-128v-64h128v64zM182.4 896l160-288h-64l160-288h-64.48l137.952-253.152c0 0 0.064-0.032 0.16-0.032l138.048 253.184h-64.48l160 288h-64l160 288h-659.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grow",
						"live"
					],
					"grid": 32
				},
				{
					"id": 548,
					"width": 1024,
					"paths": [
						"M608 960v32c0 17.664-14.336 32-32 32h-128c-17.664 0-32-14.336-32-32v-32h192zM869.6 880.448l-133.6-240.448h9.6c24.416 0 39.84-26.208 27.968-47.552l-133.568-240.448h10.080c24.288 0 39.712-25.984 28.096-47.328l-138.080-253.184c-6.080-11.104-17.088-16.672-28.096-16.672s-22.016 5.568-28.096 16.672l-138.080 253.184c-11.648 21.344 3.776 47.328 28.096 47.328h10.080l-133.6 240.448c-11.84 21.344 3.584 47.552 28 47.552h9.6l-133.6 240.448c-11.84 21.344 3.584 47.552 28 47.552h659.2c24.416 0 39.84-26.208 28-47.552z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grow",
						"live"
					],
					"grid": 32
				},
				{
					"id": 1040,
					"width": 1024,
					"paths": [
						"M1005.792 443.136c-4.416-2.080-9.12-3.136-13.824-3.136-7.2 0-14.336 2.432-20.096 7.136-18.496 14.912-75.776 53.664-118.56 53.664-13.12 0-22.88-3.616-30.688-11.424-12.928-12.928-24.48-25.856-35.552-38.208-45.664-51.008-88.8-99.168-179.072-99.168-34.784 0-67.584 7.648-96 22.304-28.416-14.656-61.216-22.304-96-22.304-90.272 0-133.408 48.16-179.072 99.168-11.072 12.352-22.624 25.312-35.552 38.208-7.808 7.808-17.568 11.424-30.688 11.424-42.752 0-100.064-38.752-118.528-53.664-5.792-4.704-12.928-7.104-20.128-7.104-4.704 0-9.408 1.024-13.792 3.104-11.136 5.312-18.24 16.544-18.24 28.864 0 160.16 125.024 296 304 296 74.048 0 150.368-28.448 208-76 57.632 47.552 133.952 76 208 76 178.976 0 304-135.84 304-296 0-12.32-7.104-23.552-18.208-28.864zM416 416c24.352 0 47.392 5.248 66.656 15.2 9.216 4.736 19.264 7.136 29.344 7.136s20.128-2.368 29.344-7.136c19.264-9.952 42.304-15.2 66.656-15.2 55.52 0 82.56 23.968 124.16 69.888-15.2-4.704-28.896-10.4-42.144-16.16-25.664-11.168-49.92-21.696-81.984-21.696-47.712 0-79.232 29.632-95.968 51.136-16.704-21.504-48.16-51.136-95.744-51.136-0.096 0-0.224 0-0.32 0-32.416 0.096-56.544 10.592-82.048 21.728-13.184 5.728-26.816 11.392-42.016 16.096 41.376-45.76 68.416-69.856 124.064-69.856zM552.736 642.624c-11.84-9.76-26.272-14.624-40.736-14.624s-28.896 4.864-40.736 14.624c-46.56 38.432-109.088 61.376-167.264 61.376-35.392 0-68.096-7.328-97.76-19.52 34.528-15.040 69.408-36.416 101.824-56.512 41.152-25.536 83.712-51.936 107.936-51.936 55.84 0 83.616 26.272 84.768 27.392 5.888 5.824 15.104 5.92 21.344 0.704 0.352-0.288 0.768-0.384 1.088-0.704 1.152-1.12 28.928-27.392 84.768-27.392 24.224 0 66.784 26.4 107.936 51.936 32.448 20.096 67.296 41.504 101.824 56.512-29.632 12.192-62.336 19.52-97.728 19.52-58.144 0-120.672-22.944-167.264-61.376zM855.68 664.864c-39.552-12.512-83.136-39.456-122.848-64.064-49.088-30.464-91.488-56.736-124.8-56.736-48.576 0-80.416 16.896-96 27.776-15.584-10.88-47.424-27.776-96-27.776-33.312 0-75.712 26.272-124.8 56.736-39.712 24.608-83.296 51.552-122.848 64.064-46.304-29.728-80.672-74.304-95.744-128.544 28.64 15.008 63.904 28.512 98.080 28.512 37.824 0 62.176-16.416 75.936-30.176 2.848-2.848 5.376-5.632 8.096-8.448 39.232-4.384 67.008-16.256 91.936-27.104 23.392-10.176 43.616-19.008 69.376-19.072 0.096 0 0.16 0 0.256 0 52.864 0 81.152 54.624 81.408 55.2 0.224 0.416 0.64 0.576 0.896 0.96 1.088 1.76 2.496 3.264 4.224 4.544 0.512 0.352 0.896 0.832 1.44 1.12 0.224 0.128 0.352 0.32 0.576 0.448 2.272 1.152 4.704 1.696 7.104 1.696h0.064c2.4 0 4.832-0.544 7.136-1.696 0.256-0.128 0.384-0.352 0.608-0.48 0.512-0.288 0.864-0.704 1.312-1.024 1.824-1.312 3.264-2.848 4.384-4.704 0.224-0.352 0.608-0.512 0.8-0.864 0.288-0.544 28.672-55.2 81.728-55.2 25.44 0 45.76 8.8 69.248 19.072 25.056 10.88 53.024 22.816 92.096 27.136 2.72 2.816 5.216 5.568 8.032 8.384 13.76 13.76 38.112 30.176 75.936 30.176 34.144 0 69.408-13.504 98.080-28.512-15.040 54.24-49.44 98.848-95.712 128.576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"grow",
						"groom",
						"cultivate"
					],
					"grid": 32
				},
				{
					"id": 549,
					"width": 1024,
					"paths": [
						"M708.768 507.104c16.064-7.776 27.232-24.064 27.232-43.104 0-20.864-13.408-38.464-32-45.056v-163.904c23.072-4.704 34.144-33.152 17.568-52.096l-153.472-175.424c-12.736-14.56-35.424-14.56-48.16 0l-153.472 175.392c-16.608 18.976-5.536 47.424 17.536 52.128v163.904c-18.592 6.624-32 24.192-32 45.056 0 19.040 11.168 35.328 27.232 43.104l-84.576 479.36c-3.488 19.584 11.584 37.536 31.488 37.536h435.712c19.904 0 34.976-17.952 31.52-37.568l-84.608-479.328zM740.192 869.184l-122.816 122.816h-146.752l247.552-247.552 22.016 124.736zM566.624 512h110.528l5.44 30.784-336.576 336.576 31.456-178.208 189.152-189.152zM387.168 646.208l23.68-134.208h110.528l-134.208 134.208zM416 256h256v160h-256v-160zM544 48.608l153.472 175.392h-306.944l153.472-175.392zM400 448h288c8.832 0 16 7.168 16 16s-7.168 16-16 16h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16zM336.32 934.304l353.056-353.056 22.016 124.736-286.016 286.016h-99.232l10.176-57.696zM662.624 992l84.352-84.352 14.88 84.352h-99.232z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"guide",
						"light",
						"direct",
						"warn"
					],
					"grid": 32
				},
				{
					"id": 550,
					"width": 1024,
					"paths": [
						"M521.504 512l-173.824 173.824 30.656-173.824h143.168zM709.664 512h-142.912l-228.768 228.768-31.456 178.208 403.68-403.712-0.544-3.264zM390.528 256h306.944c27.488 0 42.176-32.384 24.096-53.088l-153.472-175.392c-12.736-14.56-35.424-14.56-48.16 0l-153.472 175.392c-18.144 20.704-3.424 53.088 24.064 53.088zM384 480h320c17.664 0 32-14.336 32-32s-14.336-32-32-32v-128h-320v128c-17.664 0-32 14.336-32 32s14.336 32 32 32zM774.56 879.84l-144.16 144.16h131.456c19.904 0 34.976-17.952 31.52-37.568l-18.816-106.592zM717.024 553.728l-420.192 420.192-2.208 12.512c-3.456 19.616 11.616 37.568 31.52 37.568h67.008l345.824-345.856-21.952-124.416zM745.76 716.608l-307.36 307.392h146.752l182.624-182.624-22.016-124.768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"guide",
						"light",
						"direct",
						"warn"
					],
					"grid": 32
				},
				{
					"id": 1041,
					"width": 1024,
					"paths": [
						"M992 224h-160v-96c0-17.664-14.336-32-32-32h-768c-17.664 0-32 14.336-32 32v640c0 17.664 14.336 32 32 32h160v96c0 17.664 14.336 32 32 32h768c17.664 0 32-14.336 32-32v-640c0-17.664-14.336-32-32-32zM64 736v-576h704v352h-32v32h32v192h-704zM256 768h382.912l-382.912 78.464v-78.464zM960 864h-630.080l470.080-96v-96h32v-32h-32v-352h160v576zM352 512h64v32h-64v-32zM448 512h64v32h-64v-32zM544 512h64v32h-64v-32zM640 512h64v32h-64v-32zM928 672h-64v-32h64v32zM278.624 512h41.376v32h-41.376l36.672 36.672-22.624 22.624-52.672-52.672-52.672 52.672-22.624-22.624 52.672-52.672-52.672-52.672 22.624-22.624 52.672 52.672 52.672-52.672 22.624 22.624-36.672 36.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"guide",
						"direct",
						"instruct"
					],
					"grid": 32
				},
				{
					"id": 1897,
					"paths": [
						"M880 256l144-128c-12.076-64.668-63.332-115.924-128-128l-128 144v34.218l-181.47 181.47c-94.068-76.834-159.122-66.336-201.35-31.59-40.98 33.71-56.29 100.524-78.962 120.486-45.792 40.304-158.464-0.152-254.392 104.234-111.002 120.796-23.41 249.582 73.182 346.174 96.59 96.588 225.378 184.184 346.174 73.184 104.388-95.928 63.908-208.624 104.21-254.414 19.96-22.674 86.796-37.958 120.51-78.94 34.742-42.228 45.24-107.284-31.592-201.352l181.472-181.47h34.218zM293.13 858.87l-128-128 53.74-53.738 128 128-53.74 53.738zM480 640c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"guitar",
						"music",
						"rock",
						"song",
						"musical-instrument"
					],
					"defaultCode": 59732,
					"grid": 16
				},
				{
					"id": 2628,
					"paths": [
						"M0 192v128h56l16 128h312v96c0 52.8 43.2 96 96 96h182.858l58.92 206.222-4.524 4.524c-24.888 24.888-16.454 45.254 18.746 45.254h288v-128l-102.406-256.018c-33.896-84.78 70.408-127.982 102.406-127.982v-128c0-35.2-28.8-64-64-64zM480 576c-17.346 0-32-14.654-32-32v-96h64v64h114.286l18.288 64h-164.574z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gun",
						"weapon",
						"fire",
						"pistol",
						"firearm"
					],
					"defaultCode": 60463,
					"grid": 16
				},
				{
					"id": 2629,
					"paths": [
						"M398 448h-326l-16-128h-56v-128h590zM1024 384v-128c0-35.2-28.8-64-64-64h-148l144-192h-120l-672 896h120l192.066-256.088c1.306 0.054 2.618 0.088 3.936 0.088h182.858l58.92 206.222-4.524 4.524c-24.89 24.888-16.456 45.254 18.744 45.254h288v-128l-102.406-256.018c-33.896-84.78 70.408-127.982 102.406-127.982zM524 576l48-64h54.286l18.29 64h-120.576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"gun-forbidden",
						"gun-ban",
						"weapon",
						"fire",
						"pistol",
						"firearm"
					],
					"defaultCode": 60464,
					"grid": 16
				},
				{
					"id": 1405,
					"width": 877.7129821777344,
					"paths": [
						"M731.429 768v-512q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v182.857h-292.571v-182.857q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v512q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714v-182.857h292.571v182.857q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"h-square"
					],
					"defaultCode": 61693,
					"grid": 14
				},
				{
					"id": 1604,
					"width": 877.7129821777344,
					"paths": [
						"M462.286 573.714l152-285.143h-64l-89.714 178.286q-13.714 27.429-25.143 52.571l-24-52.571-88.571-178.286h-68.571l150.286 281.714v185.143h57.714v-181.714zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hacker-news",
						"y-combinator-square",
						"yc-square"
					],
					"defaultCode": 61908,
					"grid": 14
				},
				{
					"id": 3387,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM544 584v216h-64v-216l-175-328h72.6l134.4 252 134.4-252h72.6l-175 328z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hackernews",
						"brand",
						"ycombinator",
						"yc",
						"social"
					],
					"defaultCode": 61222,
					"grid": 16
				},
				{
					"id": 3228,
					"paths": [
						"M448 640c-23.306 0-45.158 6.292-64 17.22v-177.22c0-1.514-0.108-3.026-0.322-4.526l-64-448c-2.25-15.764-15.752-27.474-31.678-27.474s-29.426 11.71-31.678 27.474l-64 448c-0.214 1.5-0.322 3.012-0.322 4.526v177.22c-18.842-10.93-40.694-17.22-64-17.22-70.58 0-128 57.42-128 128s57.42 128 128 128 128-57.42 128-128v-256c0-17.674 14.328-32 32-32s32 14.326 32 31.998v256.002c0 51.288 30.334 95.6 73.99 116.008-6.428 13.678-9.99 28.728-9.99 43.992 0 52.934 43.066 96 96 96 17.672 0 32-14.326 32-32s-14.328-32-32-32c-17.644 0-32-14.356-32-32 0-12.62 7.342-26.216 17.72-33.254 62.218-8.66 110.28-62.182 110.28-126.746 0-70.58-57.422-128-128-128zM128 832c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zM448 832c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z",
						"M960 0h-224c-17.674 0-32 14.328-32 32s14.326 32 32 32h160v64h-160c-17.674 0-32 14.328-32 32s14.326 32 32 32h160v64h-160c-17.674 0-32 14.328-32 32s14.326 32 32 32h160v64h-160c-17.674 0-32 14.328-32 32s14.326 32 32 32h160v64h-160c-17.674 0-32 14.326-32 32s14.326 32 32 32h160v320c0 35.346 28.654 64 64 64s64-28.654 64-64v-832c0-35.346-28.654-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"haircut",
						"scissors-comb",
						"hair",
						"style"
					],
					"defaultCode": 61063,
					"grid": 16
				},
				{
					"id": 551,
					"width": 1024,
					"paths": [
						"M512 96c-212.064 0-384 171.936-384 384 0 70.688 57.312 128 128 128h122.176l-37.6 206.816c-10.72 58.944 34.56 113.184 94.464 113.184h153.952c59.904 0 105.152-54.24 94.464-113.184l-37.632-206.816h122.176c70.688 0 128-57.312 128-128 0-212.064-171.936-384-384-384zM608 160c0 52.928-43.072 96-96 96s-96-43.072-96-96c0-6.272 0.704-12.544 2.112-18.912 1.44-0.384 2.88-0.736 4.32-1.12 12.032-3.2 24.192-5.632 36.416-7.52 3.232-0.48 6.432-1.088 9.664-1.472 14.432-1.824 28.96-2.976 43.488-2.976s29.056 1.152 43.488 2.976c3.264 0.416 6.464 0.992 9.664 1.472 12.224 1.888 24.384 4.352 36.416 7.52 1.44 0.384 2.88 0.704 4.32 1.12 1.408 6.368 2.112 12.64 2.112 18.912zM651.936 820.544c3.392 18.72-1.632 37.856-13.824 52.448s-30.112 23.008-49.152 23.008h-153.952c-19.040 0-36.928-8.384-49.152-23.008s-17.248-33.728-13.824-52.448l38.688-212.544h202.592l38.624 212.544zM768 576h-512c-52.928 0-96-43.072-96-96 0-149.184 93.472-276.672 224.768-327.84-0.192 2.624-0.768 5.152-0.768 7.84 0 70.688 57.312 128 128 128s128-57.312 128-128c0-2.688-0.512-5.216-0.768-7.84 131.328 51.168 224.768 178.656 224.768 327.84 0 52.928-43.072 96-96 96zM352 288c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM352 448c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64zM672 288c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM672 448c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hallucinate",
						"imagine",
						"fantasize",
						"trip"
					],
					"grid": 32
				},
				{
					"id": 552,
					"width": 1024,
					"paths": [
						"M416 384c0 35.296-28.704 64-64 64s-64-28.704-64-64c0-35.296 28.704-64 64-64s64 28.704 64 64zM434.496 103.84c-11.488 15.808-18.496 35.136-18.496 56.16 0 52.928 43.072 96 96 96s96-43.072 96-96c0-21.024-7.008-40.352-18.496-56.16-25.056-5.152-50.944-7.84-77.504-7.84s-52.448 2.688-77.504 7.84zM651.648 640h-279.264l-31.776 174.816c-10.752 58.944 34.528 113.184 94.432 113.184h153.952c59.904 0 105.152-54.24 94.464-113.184l-31.808-174.816zM672 320c-35.296 0-64 28.704-64 64s28.704 64 64 64 64-28.704 64-64c0-35.296-28.704-64-64-64zM896 480c0 70.688-57.312 128-128 128h-512c-70.688 0-128-57.312-128-128 0-170.336 111.008-314.528 264.512-364.8-5.248 13.984-8.512 28.992-8.512 44.8 0 70.592 57.408 128 128 128s128-57.408 128-128c0-15.808-3.264-30.816-8.512-44.8 153.504 50.272 264.512 194.464 264.512 364.8zM448 384c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96zM768 384c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hallucinate",
						"imagine",
						"fantasize",
						"trip"
					],
					"grid": 32
				},
				{
					"id": 1042,
					"width": 1024,
					"paths": [
						"M856.928 508.224c33.728 0 58.656-9.76 76.224-29.856 18.304-20.96 26.848-50.944 26.848-94.368 0-176.448-143.552-320-320-320-140.96 0-266.304 94.656-306.4 228.16-152.928 24.448-269.6 158.976-269.6 315.84 0 82.4 34.624 124.192 102.944 124.192 26.24 0 55.136-5.6 88.576-12.096 9.472-1.824 19.104-3.68 28.864-5.472l-59.424 237.632c-2.4 9.568-0.256 19.68 5.824 27.424 6.048 7.776 15.36 12.32 25.216 12.32h576c9.856 0 19.168-4.544 25.216-12.32 6.048-7.744 8.224-17.888 5.824-27.424l-115.008-459.968c6.912 1.28 13.696 2.592 20.288 3.872 33.472 6.464 62.368 12.064 88.608 12.064zM671.328 449.216l119.68 478.784h-270.016l57.312-229.28c8 0.896 15.648 1.472 22.752 1.472 44.192 0 70.944-19.744 70.944-92.192 0-50.656-13.184-98.176-36.128-139.552l5.12-20.416c11.008 0.032 30.336 1.184 30.336 1.184zM640 608c0 60.192-18.048 60.192-38.912 60.192-20.064 0-46.144-5.056-76.352-10.912-41.728-8.096-89.024-17.28-140.736-17.28-20.32 0-62.144 4.224-62.88 4.352-27.584 3.424-53.728 8.256-77.856 12.928-30.208 5.856-56.288 10.912-76.352 10.912-20.864 0-38.912 0-38.912-60.192 0-23.072 3.36-45.312 9.088-66.592 7.328 1.536 14.912 2.592 22.912 2.592 53.824 0 96-35.136 96-80 0-22.976-11.232-43.168-29.312-57.536 20.736-16.224 44-29.216 69.12-38.464-4.992 9.76-7.808 20.544-7.808 32 0 44.864 42.176 80 96 80s96-35.136 96-80c0-11.456-2.816-22.24-7.808-32.032 25.184 9.28 48.512 22.336 69.248 38.592-18.048 14.4-29.44 34.464-29.44 57.44 0 44.864 42.176 80 96 80 7.968 0 15.584-0.992 22.944-2.464 5.728 21.248 9.056 43.456 9.056 66.464zM546.528 693.92l-50.528 202.080-55.072-220.224c39.328 4.736 106.208 18.272 105.6 18.144zM358.752 672.992c0-0.032 0-0.032 0 0 0.192-0.032 0.416-0.032 0.608-0.064-0.192 0-0.384 0.032-0.608 0.064zM448 400c0 26.496-28.64 48-64 48s-64-21.504-64-48 28.64-48 64-48c35.36 0 64 21.504 64 48zM202.016 428.192c13.376 8.768 21.984 21.44 21.984 35.808 0 26.496-28.64 48-64 48-4.384 0-8.608-0.512-12.736-1.152 12.8-31.072 31.488-59.104 54.752-82.656zM566.080 428.32c23.232 23.552 41.92 51.552 54.688 82.592-4.128 0.672-8.384 1.088-12.768 1.088-35.36 0-64-21.504-64-48 0-14.368 8.704-26.944 22.080-35.68zM640 416c-13.696 0-27.072 0.704-40.128 1.792-51.040-57.888-124.864-95.008-207.552-97.376 0.256-1.024 0.64-1.984 0.896-3.008 7.296 1.504 14.848 2.592 22.784 2.592 53.824 0 96-35.136 96-80 0-22.976-11.456-43.040-29.504-57.504 20.8-16.352 44.192-29.44 69.44-38.752-5.056 9.856-7.936 20.704-7.936 32.256 0 44.864 42.176 80 96 80s96-35.136 96-80c0-11.456-2.816-22.24-7.808-32.032 25.12 9.248 48.384 22.272 69.12 38.496-18.048 14.4-29.312 34.56-29.312 57.536 0 44.864 42.176 80 96 80 7.968 0 15.584-0.992 22.944-2.464 5.728 21.216 9.056 43.456 9.056 66.464 0 60.192-18.048 60.192-38.912 60.192-20.064 0-46.144-5.056-76.352-10.912-41.728-8.096-89.024-17.28-140.736-17.28zM458.368 204.352c13.184 8.736 21.632 21.376 21.632 35.648 0 26.496-28.64 48-64 48-4.256 0-8.224-0.736-12.224-1.344 12.768-30.976 31.424-58.848 54.592-82.304zM704 176c0 26.496-28.64 48-64 48s-64-21.504-64-48 28.64-48 64-48c35.36 0 64 21.504 64 48zM876.576 286.432c-4.128 0.64-8.16 1.568-12.576 1.568-35.36 0-64-21.504-64-48 0-14.368 8.512-27.136 21.888-35.904 23.2 23.456 41.888 51.392 54.688 82.336zM296.992 928l63.776-255.136c7.68-0.416 15.392-0.864 23.232-0.864s15.552 0.448 23.232 0.864l63.776 255.136h-174.016z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hallucinate",
						"imagine",
						"fantasize",
						"trip"
					],
					"grid": 32
				},
				{
					"id": 2519,
					"paths": [
						"M512 960c282.77 0 512-85.96 512-192h-1024c0 106.040 229.23 192 512 192zM928 384h-832c-52.8 0-96 43.2-96 96s43.2 96 96 96h832c52.8 0 96-43.2 96-96s-43.2-96-96-96zM512 64c-282.77 0-512 105.96-512 212v44h1024v-44c0-106.040-229.23-212-512-212zM160 256c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM288 192c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM416 256c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM608 256c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32zM736 192c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM864 256c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM0 640h1024v64h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hamburger",
						"food"
					],
					"defaultCode": 60354,
					"grid": 16
				},
				{
					"id": 2429,
					"paths": [
						"M1009.996 828.976l-301.544-301.544c-18.668-18.668-49.214-18.668-67.882 0l-22.626 22.626-184-184 302.056-302.058h-320l-142.058 142.058-14.060-14.058h-67.882v67.882l14.058 14.058-206.058 206.060 160 160 206.058-206.058 184 184-22.626 22.626c-18.668 18.668-18.668 49.214 0 67.882l301.544 301.544c18.668 18.668 49.214 18.668 67.882 0l113.136-113.136c18.67-18.666 18.67-49.214 0.002-67.882z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hammer",
						"tool",
						"fix",
						"make",
						"generate",
						"work",
						"build"
					],
					"defaultCode": 60264,
					"grid": 16
				},
				{
					"id": 2430,
					"width": 1280,
					"paths": [
						"M492.556 704.554l146.89 146.89-116.676 149.824c-21.382 27.962-59.242 30.474-84.132 5.586l-101.49-101.492c-24.89-24.888-22.376-62.748 5.584-84.13l149.824-116.678zM1273.512 262.492l-153.512 153.51-192-192 153.512-153.51c-18.488-4.244-37.738-6.49-57.512-6.49-141.384 0-256 114.616-256 256 0 50.996 14.916 98.506 40.618 138.416l-142.908 111.292-217.71-217.708 288-288h-320l-142.058 142.058-14.060-14.058h-67.882v67.882l14.058 14.058-206.058 206.060 160 160 192-192 576 575.996 96-95.996-249.708-249.71 111.292-142.908c39.908 25.702 87.42 40.618 138.416 40.618 141.384 0 256-114.616 256-256 0-19.774-2.246-39.024-6.488-57.51z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hammer-wrench",
						"tool",
						"fix",
						"make",
						"generate",
						"work",
						"build"
					],
					"defaultCode": 60265,
					"grid": 16
				},
				{
					"id": 2553,
					"paths": [
						"M1010.174 915.75l-548.634-499.458 25.534-25.598c20.894-20.954 32.188-48.030 33.918-75.61 1.002-0.45 2.002-0.912 2.958-1.442l102.99-64.402c13.934-16.392 12.916-42.268-2.284-57.502l-179.12-179.608c-15.19-15.234-40.998-16.262-57.344-2.284l-64.236 103.268c-0.526 0.966-0.99 1.966-1.44 2.974-27.502 1.736-54.5 13.056-75.398 34.006l-97.428 97.702c-20.898 20.956-32.184 48.026-33.918 75.604-1.004 0.45-2.004 0.916-2.964 1.446l-102.986 64.406c-13.942 16.39-12.916 42.264 2.276 57.496l179.12 179.604c15.194 15.238 40.996 16.262 57.35 2.286l64.228-103.27c0.528-0.958 0.988-1.96 1.442-2.966 27.502-1.738 54.504-13.050 75.398-34.004l28.292-28.372 498.122 550.114c14.436 15.944 36.7 18.518 49.474 5.712l50.356-50.488c12.764-12.808 10.196-35.132-5.706-49.614z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hammer",
						"gavel",
						"rules",
						"justice",
						"legal"
					],
					"defaultCode": 60388,
					"grid": 16
				},
				{
					"id": 2894,
					"paths": [
						"M768 1024h-320c-8.488 0-16.626-3.372-22.626-9.374l-192-192c-1.712-1.712-3.226-3.614-4.508-5.666l-160-256c-9.172-14.678-5.014-33.986 9.386-43.586l96-64c13.608-9.070 31.864-6.422 42.334 6.14l103.414 124.102v-487.616c0-17.672 14.328-32 32-32h96v-32c0-17.672 14.328-32 32-32h128c17.674 0 32 14.328 32 32v32h96c17.674 0 32 14.328 32 32v96h96c17.674 0 32 14.328 32 32v576c0 4.968-1.156 9.868-3.378 14.31l-96 192c-5.42 10.842-16.5 17.69-28.622 17.69zM461.254 960h286.968l83.778-167.554v-536.446h-64v288c0 17.674-14.326 32-32 32s-32-14.326-32-32v-416h-64v416c0 17.674-14.326 32-32 32s-32-14.326-32-32v-480h-64v480c0 17.674-14.328 32-32 32s-32-14.326-32-32v-416h-64v544c0 13.472-8.438 25.502-21.106 30.088-12.666 4.596-26.85 0.746-35.476-9.602l-141.592-169.91-46.22 30.812 141.6 226.56 180.048 180.052z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand",
						"fingers"
					],
					"defaultCode": 60729,
					"grid": 16
				},
				{
					"id": 1723,
					"width": 877.7150573730469,
					"paths": [
						"M438.857 219.429q-30.286 0-51.714 21.429t-21.429 51.714v73.143h-18.286v-53.143q0-27.429-18.286-46.571t-45.714-19.143q-26.286 0-45.143 18.857t-18.857 45.143v245.143l-18.286-17.143v-98.286q0-27.429-18.286-46.571t-45.714-19.143q-26.286 0-45.143 18.857t-18.857 45.143v128q0 26.857 20 46.857l177.143 169.143q22.286 22.286 22.286 58.286 0 14.857 10.857 25.714t25.714 10.857h365.714q14.857 0 25.714-10.857t10.857-25.714v-14.286q0-23.429 5.714-44l61.714-249.143q5.714-20.571 5.714-44v-140.571q0-27.429-18.286-46.571t-45.714-19.143q-26.286 0-45.143 18.857t-18.857 45.143v18.286h-18.286v-71.429q0-22.857-14.286-41.429t-36.571-23.143q-8-1.143-13.143-1.143-26.286 0-45.143 18.857t-18.857 45.143v73.143h-18.286v-69.714q0-29.143-18.571-51.143t-47.143-24.857q-2.857-0.571-7.429-0.571zM438.857 146.286q48 0 85.143 28.571 32.571-19.429 70.286-19.429 33.714 0 63.429 15.429t49.143 43.429q15.429-4 33.714-4 57.143 0 97.143 40.857t40 98v140.571q0 29.143-7.429 61.714l-62.286 249.143q-3.429 13.714-3.429 40.571 0 45.714-32 77.714t-77.714 32h-365.714q-48 0-78.857-33.429t-30.857-81.429l-176-169.143q-43.429-41.714-43.429-100v-128q0-56.571 40.286-96.857t96.857-40.286q6.286 0 9.143 0.571 3.429-54.286 43.143-91.429t94-37.143q29.714 0 56 12 41.143-39.429 99.429-39.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-grab-o",
						"hand-rock-o"
					],
					"defaultCode": 62037,
					"grid": 14
				},
				{
					"id": 1726,
					"width": 1170.2868576049805,
					"paths": [
						"M657.714 0q34.857 0 66.286 16t52 44l326.857 446.286q67.429 90.857 67.429 205.143v202.857q0 45.714-32 77.714t-77.714 32h-219.429q-45.714 0-77.714-32t-32-77.714v-101.143l-163.429-81.714h-312q-45.714 0-77.714-32t-32-77.714v-18.286q0-68 48.286-116.286t116.286-48.286h240l24-73.143h-392q-57.143 0-99.143-38.571t-46.571-95.143q-37.143-45.143-37.143-104v-18.286q0-45.714 32-77.714t77.714-32h548zM1097.143 914.286v-202.857q0-89.714-53.143-162.286l-327.429-446.286q-22.286-29.714-58.857-29.714h-548q-14.857 0-25.714 10.857t-10.857 25.714q0 18.286 0.857 28.286t5.429 23.143 14.286 24.571q5.714-17.714 20.286-28.571t32.286-10.857h475.429v18.286h-475.429q-14.857 0-25.714 10.857t-10.857 25.714q0 25.143 1.714 33.143 4.571 25.143 25.143 41.714t46.286 16.571h417.714q22.857 0 38.857 16t16 38.857q0 8.571-2.857 17.143l-36.571 109.714q-5.714 16.571-20 27.143t-32 10.571h-253.143q-37.714 0-64.571 26.857t-26.857 64.571v18.286q0 14.857 10.857 25.714t25.714 10.857h320.571q9.143 0 16.571 4l181.143 90.286q13.714 7.429 22 20.571t8.286 28.571v112.571q0 14.857 10.857 25.714t25.714 10.857h219.429q14.857 0 25.714-10.857t10.857-25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-lizard-o"
					],
					"defaultCode": 62040,
					"grid": 14
				},
				{
					"id": 1336,
					"width": 877.7129669189453,
					"paths": [
						"M804.571 548.571q0-48-18.286-104.571t-36.571-110.857-18.286-95.429v-18.286h-365.714v18.286q0 20-6.857 38.571t-21.143 35.714-26.286 28.571-30.857 28q-5.143 4.571-8 6.857-46.286 41.143-82.857 64-12.571 8-38.857 21.714-1.714 0.571-12.857 6t-20.571 10.571-20.286 11.429-17.429 12.286-6.571 10.571q0 40.571 17.429 66t55.714 25.429q24.571 0 48.286-8.571t38.857-18.857 31.429-18.857 27.714-8.571v329.143q0 28.571 22 50.857t51.143 22.286q29.714 0 51.429-21.714t21.714-51.429v-189.143q26.286 20 58.857 20 39.429 0 68-30.286 18.286 10.286 39.429 10.286t42-10 30-27.143q13.714 2.286 32 2.286 48.571 0 72-27.714t23.429-77.429zM731.429 109.714q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM877.714 546.286q0 81.143-44.286 131.429t-124.286 49.714l-2.857-0.571q-43.429 34.857-101.714 34.857-12.571 0-24.571-1.714-30.857 17.143-68 21.143v96.571q0 60-43.429 103.143t-103.429 43.143q-58.857 0-102.286-43.429t-43.429-102.857v-213.714q-30.857 12.571-73.143 12.571-69.143 0-107.714-46.571t-38.571-118q0-21.714 10-39.714t28.286-31.429 36-23.143 41.143-21.143 35.429-18.857q31.429-20 73.714-57.143 1.714-1.143 9.714-8t12.286-10.857 12.286-11.714 12.857-13.714 10.286-12.857 8-13.429 2.571-12.286v-164.571q0-30.286 21.429-51.714t51.714-21.429h365.714q30.286 0 51.714 21.429t21.429 51.714v164.571q0 33.714 33.714 127.429 39.429 108.571 39.429 181.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-o-down"
					],
					"defaultCode": 61607,
					"grid": 14
				},
				{
					"id": 1334,
					"width": 1023.9989547729492,
					"paths": [
						"M786.286 804.571h18.286v-365.714h-18.286q-20 0-38.571-6.857t-35.714-21.143-28.571-26.286-28-30.857q-1.143-1.714-2-2.571t-2.286-2.571-2.571-2.857q-41.143-46.286-64-82.857-8-12.571-21.714-38.857-0.571-1.714-6-12.857t-10.571-20.571-11.429-20.286-12.286-17.429-10.571-6.571q-40.571 0-66 17.429t-25.429 55.714q0 24.571 8.571 48.286t18.857 38.857 18.857 31.429 8.571 27.714h-329.143q-28.571 0-50.857 22t-22.286 51.143q0 29.714 21.714 51.429t51.429 21.714h189.143q-8.571 9.714-14.286 27.143t-5.714 31.714q0 39.429 30.286 68-10.286 18.286-10.286 39.429t10 42 27.143 30q-2.286 13.714-2.286 32 0 48.571 27.714 72t77.429 23.429q48 0 104.571-18.286t110.857-36.571 95.429-18.286zM950.857 768q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM1024 438.857v365.714q0 30.286-21.429 51.714t-51.714 21.429h-164.571q-33.714 0-127.429 33.714-108.571 39.429-181.143 39.429-81.143 0-131.429-44.286t-49.714-124.286l0.571-2.857q-34.857-43.429-34.857-101.714 0-12.571 1.714-24.571-18.857-32.571-21.143-68h-96.571q-60 0-103.143-43.429t-43.143-103.429q0-58.857 43.429-102.286t102.857-43.429h213.714q-12.571-34.286-12.571-73.143 0-69.714 46.571-108t118-38.286q21.714 0 39.714 10t31.429 28.286 23.143 36 21.143 41.143 18.857 35.429q20 31.429 57.143 73.714 1.143 1.714 8 9.714t10.857 12.286 11.714 12.286 13.714 12.857 12.857 10.286 13.429 8 12.286 2.571h164.571q30.286 0 51.714 21.429t21.429 51.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-o-left"
					],
					"defaultCode": 61605,
					"grid": 14
				},
				{
					"id": 1333,
					"width": 1024.0000076293945,
					"paths": [
						"M146.286 768q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM950.857 438.857q0-29.143-22.286-51.143t-50.857-22h-329.143q0-11.429 8.571-27.714t18.857-31.429 18.857-38.857 8.571-48.286q0-38.286-25.429-55.714t-66-17.429q-13.714 0-51.429 79.429-13.714 25.143-21.143 37.143-22.857 36.571-64 82.857-40.571 46.286-57.714 60.571-39.429 32.571-80 32.571h-18.286v365.714h18.286q41.143 0 95.429 18.286t110.571 36.571 102.571 18.286q108 0 108-95.429 0-14.857-2.857-32 17.143-9.143 27.143-30t10-42-10.286-39.429q30.286-28.571 30.286-68 0-14.286-5.714-31.714t-14.286-27.143h189.143q29.714 0 51.429-21.714t21.714-51.429zM1024 438.286q0 60-43.143 103.429t-103.143 43.429h-96.571q-2.286 35.429-21.143 68 1.714 12 1.714 24.571 0 57.714-34.286 101.714 0.571 79.429-48.571 125.429t-129.714 46q-76 0-184-39.429-93.714-33.714-127.429-33.714h-164.571q-30.286 0-51.714-21.429t-21.429-51.714v-365.714q0-30.286 21.429-51.714t51.714-21.429h164.571q5.714 0 12.286-2.571t13.429-8 12.857-10.286 13.714-12.857 11.714-12.286 10.857-12.286 8-9.714q37.143-42.286 57.143-73.714 7.429-12 18.857-35.429t21.143-41.143 23.143-36 31.429-28.286 39.714-10q71.429 0 118 38.286t46.571 108q0 38.857-12.571 73.143h213.714q59.429 0 102.857 43.429t43.429 102.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-o-right"
					],
					"defaultCode": 61604,
					"grid": 14
				},
				{
					"id": 1335,
					"width": 877.7139129638672,
					"paths": [
						"M731.429 914.286q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM804.571 477.714q0-108-95.429-108-14.857 0-32 2.857-9.143-17.143-30-27.143t-42-10-39.429 10.286q-28.571-30.286-68-30.286-14.286 0-31.714 5.714t-27.143 14.286v-189.143q0-29.714-21.714-51.429t-51.429-21.714q-29.143 0-51.143 22.286t-22 50.857v329.143q-11.429 0-27.714-8.571t-31.429-18.857-38.857-18.857-48.286-8.571q-38.286 0-55.714 25.429t-17.429 66q0 13.714 79.429 51.429 25.143 13.714 37.143 21.143 36.571 22.857 82.857 64 46.286 40.571 60.571 57.714 32.571 39.429 32.571 80v18.286h365.714v-18.286q0-41.143 18.286-95.429t36.571-110.571 18.286-102.571zM877.714 474.857q0 76-39.429 184-33.714 93.714-33.714 127.429v164.571q0 30.286-21.429 51.714t-51.714 21.429h-365.714q-30.286 0-51.714-21.429t-21.429-51.714v-164.571q0-5.714-2.571-12.286t-8-13.429-10.286-12.857-12.857-13.714-12.286-11.714-12.286-10.857-9.714-8q-42.286-37.143-73.714-57.143-12-7.429-35.429-18.857t-41.143-21.143-36-23.143-28.286-31.429-10-39.714q0-71.429 38.286-118t108-46.571q38.857 0 73.143 12.571v-213.714q0-59.429 43.429-102.857t102.286-43.429q60 0 103.429 43.143t43.429 103.143v96.571q35.429 2.286 68 21.143 12-1.714 24.571-1.714 57.714 0 101.714 34.286 79.429-0.571 125.429 48.571t46 129.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-o-up"
					],
					"defaultCode": 61606,
					"grid": 14
				},
				{
					"id": 1724,
					"width": 932.5699577331543,
					"paths": [
						"M502.857 73.143q-26.286 0-45.143 18.857t-18.857 45.143v374.857h-18.286v-301.714q0-26.286-18.857-45.143t-45.143-18.857-45.143 18.857-18.857 45.143v448l-88-117.143q-21.714-29.143-58.286-29.143-30.286 0-51.714 21.429t-21.429 51.714q0 24.571 14.857 44l219.429 292.571q21.714 29.143 58.286 29.143h393.143q19.429 0 34.857-12.571t19.429-32l43.429-231.429q2.857-18.286 2.857-33.714v-284.571q0-26.286-18.857-45.143t-45.143-18.857-45.143 18.857-18.857 45.143v155.429h-18.286v-301.714q0-26.286-18.857-45.143t-45.143-18.857-45.143 18.857-18.857 45.143v301.714h-18.286v-374.857q0-26.286-18.857-45.143t-45.143-18.857zM502.857 0q38.857 0 71.714 20.286t50.571 55.143q10.857-2.286 24-2.286 56.571 0 96.857 40.286t40.286 96.857v9.714q60-3.429 103.143 36.571t43.143 100v284.571q0 22.857-4.571 47.429l-43.429 230.857q-8 45.143-43.714 74.857t-82 29.714h-393.143q-34.286 0-65.429-15.714t-51.714-42.571l-219.429-292.571q-29.143-38.857-29.143-88 0-60.571 42.857-103.429t103.429-42.857q44.571 0 73.143 19.429v-248q0-56.571 40.286-96.857t96.857-40.286q13.143 0 24 2.286 17.714-34.857 50.571-55.143t71.714-20.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-paper-o",
						"hand-stop-o"
					],
					"defaultCode": 62038,
					"grid": 14
				},
				{
					"id": 1729,
					"width": 877.7150058746338,
					"paths": [
						"M736 369.714q34.286 0 61.143 13.143 80.571 36 80.571 129.143v101.143q0 53.714-13.143 106.286l-48.571 193.714q-12 49.143-51.714 80t-90 30.857h-381.714q-60.571 0-103.429-42.857t-42.857-103.429v-229.143l-136.571-358.857q-9.714-25.714-9.714-52 0-60.571 42.857-103.429t103.429-42.857q45.714 0 83.143 26t53.429 68.286l9.714 25.143v-64.571q0-60.571 42.857-103.429t103.429-42.857 103.429 42.857 42.857 103.429v149.143q15.429-2.857 27.429-2.857 39.429 0 72.857 20.857t50.571 56.286zM612.571 365.714q-18.857 0-34.571 10.286t-23.714 27.429l-42.286 93.143-40.571 88.571h31.429q28.571 0 51.429 18t28.571 46l88-193.143q5.714-11.429 5.714-26.286 0-26.286-18.857-45.143t-45.143-18.857zM738.857 442.857q-12.571 0-23.143 4.571t-16.571 9.143-13.429 16.857-9.714 17.429-9.714 21.143l-75.429 165.714q-5.714 11.429-5.714 26.286 0 26.286 18.857 45.143t45.143 18.857q18.857 0 34.571-10.286t23.714-27.429l91.429-201.143q5.143-10.286 5.143-21.714 0-28.571-18.286-46.571t-46.857-18zM73.143 237.714q0 12.571 4.571 26.286l141.714 371.429v39.429l58.286-63.429q24.571-26.286 60.571-26.286h113.143l60.571-133.143v-305.714q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714v365.714h-36.571l-114.286-300.571q-8-21.143-26.857-34t-41.714-12.857q-30.286 0-51.714 21.429t-21.429 51.714zM674.286 950.857q25.143 0 44.857-15.429t26-40l48.571-193.714q10.857-41.714 10.857-88.571v-52l-80.571 177.143q-9.714 21.714-30.286 34.857t-44.571 13.143q-30.286 0-53.429-19.714t-27.714-49.429q-25.143 32.571-65.143 32.571h-118.857v-18.286h118.857q26.286 0 46.286-18.857t20-45.143-17.714-45.143-44-18.857h-169.143q-28 0-46.857 20.571l-72 77.714v176q0 30.286 21.429 51.714t51.714 21.429h381.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-peace-o"
					],
					"defaultCode": 62043,
					"grid": 14
				},
				{
					"id": 1728,
					"width": 950.8538932800293,
					"paths": [
						"M365.714 73.143q-30.286 0-51.714 21.429t-21.429 51.714v512l-86.286-115.429q-23.429-30.857-61.143-30.857-29.714 0-50.857 21.714t-21.143 51.429q0 24.571 14.857 44l219.429 292.571q21.714 29.143 58.286 29.143h410.286q12.571 0 22.571-7.714t12.857-19.714l52.571-210.286q13.714-54.857 13.714-110.857v-124q0-23.429-16-40.571t-38.857-17.143-38.857 16-16 38.857h-18.286v-34.857q0-27.429-18.286-46.571t-45.714-19.143q-26.286 0-45.143 18.857t-18.857 45.143v36.571h-18.286v-51.429q0-31.429-21.143-54t-52-22.571q-30.286 0-51.714 21.429t-21.429 51.714v54.857h-18.286v-325.714q0-31.429-21.143-54t-52-22.571zM365.714 0q61.143 0 103.714 44.286t42.571 105.429v125.714q12.571-1.143 18.286-1.143 56.571 0 98.857 39.429 26.857-12 56.571-12 64.571 0 105.143 49.714 15.429-4 32-4 53.714 0 90.857 38.571t37.143 92.286v124q0 66.286-16 128.571l-52.571 210.286q-9.143 36.571-38.857 59.714t-67.429 23.143h-410.286q-34.286 0-65.429-15.714t-51.714-42.571l-219.429-292.571q-29.143-38.857-29.143-88 0-60 42.571-103.143t102.571-43.143q40.571 0 74.286 20v-312.571q0-60.571 42.857-103.429t103.429-42.857zM438.857 804.571v-219.429h-18.286v219.429h18.286zM585.143 804.571v-219.429h-18.286v219.429h18.286zM731.429 804.571v-219.429h-18.286v219.429h18.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-pointer-o"
					],
					"defaultCode": 62042,
					"grid": 14
				},
				{
					"id": 1725,
					"width": 1023.9980163574219,
					"paths": [
						"M613.143 950.857h-101.143q-93.143 0-129.143-80.571-13.143-28-13.143-58.286v-2.857q-35.429-17.143-56.286-50.571t-20.857-72.857q0-21.714 2.857-27.429h-149.143q-60.571 0-103.429-42.857t-42.857-103.429 42.857-103.429 103.429-42.857h64.571l-25.143-9.714q-42.286-16-68.286-53.429t-26-83.143q0-60.571 42.857-103.429t103.429-42.857q26.286 0 52 9.714l358.857 136.571h229.143q60.571 0 103.429 42.857t42.857 103.429v381.714q0 50.286-30.857 90t-80 51.714l-193.714 48.571q-52.571 13.143-106.286 13.143zM585.143 544.571l-88.571 40.571-93.143 42.286q-17.143 8-27.429 23.714t-10.286 34.571q0 26.286 18.857 45.143t45.143 18.857q14.857 0 26.286-5.714l193.143-88q-28-5.714-46-28.571t-18-51.429v-31.429zM768 722.286q0-26.286-18.857-45.143t-45.143-18.857q-14.857 0-26.286 5.714l-165.714 75.429q-16 7.429-21.143 9.714t-17.429 9.714-16.857 13.429-9.143 16.571-4.571 23.143q0 28.571 18 46.857t46.571 18.286q11.429 0 21.714-5.143l201.143-91.429q17.143-8 27.429-23.714t10.286-34.571zM635.429 292.571l-371.429-141.714q-13.714-4.571-26.286-4.571-30.286 0-51.714 21.429t-21.429 51.714q0 22.857 12.857 41.714t34 26.857l300.571 114.286v36.571h-365.714q-30.286 0-51.714 21.429t-21.429 51.714 21.429 51.714 51.714 21.429h305.714l133.143-60.571v-113.143q0-36 26.286-60.571l63.429-58.286h-39.429zM613.143 877.714q46.857 0 88.571-10.857l193.714-48.571q24.571-6.286 40-26t15.429-44.857v-381.714q0-30.286-21.429-51.714t-51.714-21.429h-176l-77.714 72q-20.571 18.857-20.571 46.857v169.143q0 26.286 18.857 44t45.143 17.714 45.143-20 18.857-46.286v-118.857h18.286v118.857q0 40-32.571 65.143 29.714 4.571 49.429 27.714t19.714 53.429q0 24-13.143 44.571t-34.857 30.286l-177.143 80.571h52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-scissors-o"
					],
					"defaultCode": 62039,
					"grid": 14
				},
				{
					"id": 1727,
					"width": 1097.1419830322266,
					"paths": [
						"M466.286 73.143q-27.429 0-45.429 19.429t-18 46.857q0 8 1.714 16l85.714 356.571h-14.857l-66.286-275.429q-5.143-21.714-22.571-35.429t-39.714-13.714q-26.857 0-45.143 19.429t-18.286 46.286q0 6.286 2.286 16.571 1.714 7.429 22.286 92t38.857 161.143 18.286 78.857v129.714l-175.429-131.429q-19.429-14.857-44-14.857-29.714 0-51.143 20.857t-21.429 50.571q0 38.286 32 62.857l289.714 216.571q19.429 14.857 43.429 14.857h396.571q18.857 0 33.714-11.714t19.429-30l57.143-229.143q4.571-17.143 5.714-50.286t5.143-49.143l66.286-273.143q1.714-6.857 1.714-14.857 0-26.286-18.857-45.143t-45.714-18.857q-21.714 0-39.429 14.571t-22.857 35.714l-56.571 233.143h-14.857l75.429-312.571q1.714-8 1.714-16 0-26.857-18.286-45.714t-45.714-18.857q-21.714 0-39.143 13.714t-22.571 35.429l-82.857 344h-72.571l-93.714-389.714q-5.143-21.714-22.571-35.429t-39.143-13.714zM834.857 1024h-396.571q-48.571 0-87.429-29.143l-289.714-217.143q-28.571-21.714-44.857-53.714t-16.286-67.429q0-60 42.857-102.286t102.857-42.286q14.286 0 28.286 3.143t23.714 6.286 23.429 11.714 20 13.143 22 16.857 21.429 16.286l-70.286-292.571q-4-20-4-33.714 0-53.143 34.286-92.571t86.857-45.143q8-49.714 46-82.571t88.857-32.857q47.429 0 84.571 29.429t48.571 75.714l58.857 244.571 47.429-198.857q11.429-46.286 48.571-75.714t84.571-29.429q49.714 0 87.143 30.857t47.143 79.429q53.143 5.714 88.571 44.571t35.429 92q0 17.143-4 32.571l-66.286 272.571q-2.857 12.571-2.857 38.286 0 29.143-7.429 61.714l-57.714 229.143q-10.857 42.857-45.429 70t-78.571 27.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand-spock-o"
					],
					"defaultCode": 62041,
					"grid": 14
				},
				{
					"id": 260,
					"paths": [
						"M870.4 204.8c-18.645 0-36.126 5.034-51.2 13.776v-64.976c0-56.464-45.936-102.4-102.4-102.4-21.072 0-40.674 6.403-56.973 17.358-14.008-39.88-52.021-68.558-96.627-68.558s-82.619 28.678-96.627 68.558c-16.299-10.955-35.901-17.358-56.973-17.358-56.464 0-102.4 45.936-102.4 102.4v377.52l-68.909-119.446c-13.366-24.326-35.163-41.645-61.405-48.782-25.56-6.949-52.146-3.272-74.858 10.357-46.461 27.877-64.138 90.819-39.442 140.37 1.514 3.101 34.213 70.024 136.17 273.938 48.010 96.021 100.704 164.653 156.619 203.994 43.896 30.886 74.195 32.451 79.824 32.451h256c43.573 0 84.085-14.166 120.41-42.109 34.146-26.266 63.782-64.232 88.088-112.842 47.824-95.65 73.102-227.966 73.102-382.65v-179.2c0-56.464-45.936-102.4-102.4-102.4zM921.6 486.4c0 146.774-23.41 271.174-67.698 359.752-28.888 57.776-80.565 126.648-162.702 126.648h-255.49c-2.016-0.173-23.546-2.565-56.067-26.894-32.41-24.246-82.155-75.373-135.091-181.246-103.789-207.579-135.685-272.947-135.995-273.584-0.037-0.077-0.075-0.154-0.114-0.23-12.87-25.742-3.744-59.49 19.928-73.694 10.645-6.387 23.102-8.11 35.080-4.853 12.766 3.47 23.438 12.059 30.051 24.182 0.098 0.179 0.198 0.357 0.301 0.534l79.899 138.498c16.349 29.842 34.723 42.405 54.622 37.328 19.955-5.088 30.075-25.019 30.075-59.24v-400c0-28.232 22.968-51.2 51.2-51.2s51.2 22.968 51.2 51.2v332.8c0 14.138 11.462 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-384c0-28.232 22.968-51.2 51.2-51.2s51.2 22.968 51.2 51.2v384c0 14.138 11.461 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-332.8c0-28.232 22.968-51.2 51.2-51.2s51.2 22.968 51.2 51.2v384c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-230.4c0-28.232 22.968-51.2 51.2-51.2s51.2 22.968 51.2 51.2v179.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hand",
						"drag",
						"fingers"
					],
					"defaultCode": 59557,
					"grid": 20
				},
				{
					"id": 553,
					"width": 1024,
					"paths": [
						"M672 640c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM544 640c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM416 640c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM288 640c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM608 334.688v-78.688c0-17.664-14.336-32-32-32h-48v-10.656l35.232-46.944c8.224-11.040 12.768-24.672 12.768-38.4v-32c0-35.296-28.704-64-64-64s-64 28.704-64 64v16c0 8.832 7.168 16 16 16s16-7.168 16-16v-16c0-17.632 14.368-32 32-32s32 14.368 32 32v32c0 6.88-2.272 13.696-6.4 19.2l-38.4 51.2c-2.080 2.752-3.2 6.112-3.2 9.6v16h-48c-17.664 0-32 14.336-32 32v78.688c-129.824 40.8-224 162.048-224 305.312 0 176.736 143.264 320 320 320s320-143.264 320-320c0-143.264-94.176-264.512-224-305.312zM448 256h128v64h-128v-64zM512 352c112.8 0 210.368 65.344 257.6 160h-515.2c47.232-94.656 144.8-160 257.6-160zM512 928c-112.8 0-210.368-65.344-257.6-160h515.2c-47.232 94.656-144.8 160-257.6 160zM240.8 736c-10.688-30.080-16.8-62.304-16.8-96s6.112-65.92 16.8-96h542.4c10.688 30.080 16.8 62.304 16.8 96s-6.112 65.92-16.8 96h-542.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hang",
						"celebrate",
						"decorate"
					],
					"grid": 32
				},
				{
					"id": 554,
					"width": 1024,
					"paths": [
						"M416 320v-64c0-17.664 14.336-32 32-32h48v-16c0-3.456 1.12-6.816 3.2-9.6l38.4-51.2c4.128-5.504 6.4-12.32 6.4-19.2v-32c0-17.632-14.368-32-32-32s-32 14.368-32 32v16c0 8.832-7.168 16-16 16s-16-7.168-16-16v-16c0-35.296 28.704-64 64-64s64 28.704 64 64v32c0 13.728-4.544 27.36-12.768 38.368l-35.232 46.976v10.656h48c17.664 0 32 14.336 32 32v64h-192zM650.464 352h-276.96c-68.768 33.152-124.032 89.824-154.72 160h586.4c-30.656-70.176-85.952-126.848-154.72-160zM832 640c0 33.44-5.184 65.696-14.688 96h-610.624c-9.504-30.304-14.688-62.56-14.688-96s5.184-65.696 14.688-96h610.624c9.504 30.304 14.688 62.56 14.688 96zM352 640c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM480 640c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM608 640c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM736 640c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM512 960c131.2 0 243.808-79.040 293.184-192h-586.368c49.376 112.96 161.984 192 293.184 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hang",
						"celebrate",
						"decorate"
					],
					"grid": 32
				},
				{
					"id": 2346,
					"paths": [
						"M945.306 869.082l-433.306-278.552v-31.654c39.036-22.568 64-64.666 64-110.876 0-70.58-57.42-128-128-128-54.154 0-102.662 34.29-120.706 85.328-5.89 16.662 2.84 34.946 19.504 40.836 16.66 5.888 34.944-2.842 40.836-19.504 9.022-25.516 33.282-42.66 60.366-42.66 35.29 0 64 28.71 64 64 0 27.086-17.146 51.348-42.664 60.37-12.786 4.52-21.334 16.608-21.334 30.17l-0.002 51.99-433.304 278.552c-9.16 5.888-14.696 16.030-14.696 26.918v32c0 52.936 43.066 96 96 96h768c52.936 0 96-43.064 96-96v-32c0-10.888-5.536-21.030-14.694-26.918zM896 928c0 17.644-14.356 32-32 32h-768c-17.644 0-32-14.356-32-32v-14.53l416-267.43 416 267.43v14.53z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hanger",
						"coat-hanger"
					],
					"defaultCode": 60181,
					"grid": 16
				},
				{
					"id": 3330,
					"paths": [
						"M511.8 0c-244.2 0-442.2 198-442.2 442.2 0 231.4 210.8 419 442.2 419v162.8c268.6-136.2 442.6-355.6 442.6-581.8 0-244.2-198.4-442.2-442.6-442.2zM448 512c0 53-28.6 96-64 96v-96h-128v-192h192v192zM768 512c0 53-28.6 96-64 96v-96h-128v-192h192v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hangouts",
						"brand",
						"social"
					],
					"defaultCode": 61165,
					"grid": 16
				},
				{
					"id": 2839,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM512 598.76c115.95 0 226.23-30.806 320-84.92-14.574 178.438-153.128 318.16-320 318.16-166.868 0-305.422-139.872-320-318.304 93.77 54.112 204.050 85.064 320 85.064zM256 352c0-53.019 28.654-96 64-96s64 42.981 64 96c0 53.019-28.654 96-64 96s-64-42.981-64-96zM640 352c0-53.019 28.654-96 64-96s64 42.981 64 96c0 53.019-28.654 96-64 96s-64-42.981-64-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"happy",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60674,
					"grid": 16
				},
				{
					"id": 2840,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM704 256c35.348 0 64 42.98 64 96s-28.652 96-64 96-64-42.98-64-96 28.652-96 64-96zM320 256c35.346 0 64 42.98 64 96s-28.654 96-64 96-64-42.98-64-96 28.654-96 64-96zM512 896c-166.868 0-305.422-139.872-320-318.304 93.77 54.114 204.050 85.064 320 85.064s226.23-30.806 320-84.92c-14.574 178.438-153.128 318.16-320 318.16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"happy",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60675,
					"grid": 16
				},
				{
					"id": 555,
					"width": 1024,
					"paths": [
						"M868.928 308.416l-105.312-45.12c-12.352-5.28-25.184-7.776-37.76-7.776-9.824 0-19.488 1.568-28.736 4.448-22.208-110.976-96.608-259.968-185.12-259.968s-162.912 148.992-185.12 259.936c-9.248-2.912-18.912-4.448-28.736-4.448-12.608 0-25.44 2.496-37.76 7.776l-105.312 45.12c-15.296 6.56-23.008 23.744-17.76 39.52l13.312 39.936c4.448 13.312 16.864 21.888 30.336 21.888 2.56 0 5.184-0.32 7.776-0.96l99.264-24.768v256c0 101.44 67.488 187.040 160 214.592v137.408c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-137.408c92.512-27.552 160-113.152 160-214.592v-256l99.264 24.8c2.592 0.64 5.216 0.96 7.776 0.96 13.472 0 25.888-8.576 30.336-21.888l13.312-39.936c5.28-15.776-2.464-32.992-17.76-39.52zM512 32c67.36 0 137.92 140.416 155.584 243.488-13.6 10.4-24.768 24.352-31.36 41.568l-124.224 322.944-124.224-322.944c-6.624-17.216-17.76-31.168-31.36-41.568 17.664-103.072 88.224-243.488 155.584-243.488zM843.008 377.76l-99.264-24.8c-2.56-0.64-5.152-0.96-7.744-0.96-7.072 0-14.016 2.336-19.68 6.784-7.776 6.048-12.32 15.36-12.32 25.216v256c0 84.256-56.384 159.872-137.12 183.936-13.568 4.032-22.88 16.512-22.88 30.656v137.408h-64v-137.408c0-14.144-9.312-26.624-22.88-30.656-80.736-24.064-137.12-99.68-137.12-183.936v-256c0-9.856-4.544-19.168-12.32-25.216-5.664-4.448-12.608-6.784-19.68-6.784-2.592 0-5.184 0.32-7.744 0.96l-99.264 24.8-13.312-39.936 105.312-45.12c8.064-3.456 16.512-5.216 25.152-5.216 26.304 0 50.336 16.512 59.776 41.056l124.224 322.944c4.736 12.352 16.608 20.512 29.856 20.512s25.12-8.16 29.856-20.512l124.224-322.944c9.44-24.544 33.472-41.056 59.776-41.056 8.64 0 17.12 1.76 25.152 5.216l105.312 45.12-13.312 39.936z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"harvest",
						"eat",
						"grow",
						"pop"
					],
					"grid": 32
				},
				{
					"id": 556,
					"width": 1024,
					"paths": [
						"M334.304 228.928c28.512-105.76 97.184-228.928 177.696-228.928s149.184 123.136 177.696 228.928c-37.472 11.2-68.928 39.136-83.328 76.64l-94.368 245.28-94.336-245.312c-14.432-37.472-45.888-65.408-83.36-76.608zM868.928 308.416l-105.312-45.12c-12.352-5.28-25.184-7.776-37.76-7.776-4.928 0-9.792 0.384-14.592 1.152-0.032 0-0.096 0.032-0.128 0.032-4.768 0.736-9.44 1.856-14.016 3.296v0c-26.912 8.448-49.952 28.608-60.896 57.12l-94.336 245.312c-10.528 27.36-49.216 27.36-59.744 0l-94.336-245.312c-10.976-28.512-33.984-48.64-60.928-57.12-4.544-1.44-9.216-2.528-13.952-3.264-0.064 0-0.128-0.032-0.192-0.032-4.8-0.832-9.696-1.216-14.592-1.216-12.608 0-25.44 2.496-37.76 7.776l-105.312 45.12c-15.296 6.56-23.008 23.744-17.76 39.52l13.312 39.936c4.448 13.312 16.864 21.888 30.336 21.888 2.56 0 5.184-0.32 7.776-0.96l99.264-24.768v256c0 101.44 67.488 187.040 160 214.592v137.408c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-137.408c92.512-27.552 160-113.152 160-214.592v-256l99.264 24.8c2.592 0.64 5.216 0.96 7.776 0.96 13.472 0 25.888-8.576 30.336-21.888l13.312-39.936c5.28-15.776-2.464-32.992-17.76-39.52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"harvest",
						"eat",
						"grow",
						"pop"
					],
					"grid": 32
				},
				{
					"id": 1780,
					"width": 1024.0022621154785,
					"paths": [
						"M566.286 585.143l36.571-146.286h-145.143l-36.571 146.286h145.143zM1005.143 297.143l-32 128q-4 13.714-17.714 13.714h-186.857l-36.571 146.286h177.714q8.571 0 14.286 6.857 5.714 8 3.429 16l-32 128q-2.857 13.714-17.714 13.714h-186.857l-46.286 187.429q-4 13.714-17.714 13.714h-128q-9.143 0-14.857-6.857-5.143-6.857-3.429-16l44.571-178.286h-145.143l-46.286 187.429q-4 13.714-17.714 13.714h-128.571q-8.571 0-14.286-6.857-5.143-6.857-3.429-16l44.571-178.286h-177.714q-8.571 0-14.286-6.857-5.143-6.857-3.429-16l32-128q4-13.714 17.714-13.714h186.857l36.571-146.286h-177.714q-8.571 0-14.286-6.857-5.714-8-3.429-16l32-128q2.857-13.714 17.714-13.714h186.857l46.286-187.429q4-13.714 18.286-13.714h128q8.571 0 14.286 6.857 5.143 6.857 3.429 16l-44.571 178.286h145.143l46.286-187.429q4-13.714 18.286-13.714h128q8.571 0 14.286 6.857 5.143 6.857 3.429 16l-44.571 178.286h177.714q8.571 0 14.286 6.857 5.143 6.857 3.429 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hashtag"
					],
					"defaultCode": 62098,
					"grid": 14
				},
				{
					"id": 2343,
					"paths": [
						"M832 497.15v-209.15c0-53.020-143.27-96-320-96s-320 42.98-320 96v209.15c-117.038 41.052-192 104.116-192 174.85 0 123.71 229.23 224 512 224s512-100.29 512-224c0-70.734-74.96-133.798-192-174.85zM832 672c0 53.020-143.27 96-320 96s-320-42.98-320-96v-128c0 53.020 143.27 96 320 96s320-42.98 320-96v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hat"
					],
					"defaultCode": 60178,
					"grid": 16
				},
				{
					"id": 557,
					"width": 1024,
					"paths": [
						"M824.352 143.904c-29.632-10.528-59.616-15.424-88.544-15.424-63.168 0-121.696 23.36-166.88 62.368-6.24 5.376-9.92 13.216-10.624 21.408l-5.248 59.872 58.176 69.344-114.144 95.776c-13.536 11.36-15.296 31.552-3.936 45.088l95.776 114.144-120.8 101.376 94.432-112.512-138.656-116.352 95.776-114.144c11.36-13.536 9.6-33.728-3.936-45.088l-44.832-37.6-5.248-59.872c-0.704-8.192-4.384-16.032-10.624-21.408-45.152-38.976-103.712-62.368-166.88-62.368-7.392 0-14.816 0.32-22.336 0.96-132.16 11.456-236.768 126.72-233.824 259.36 4.512 203.68 233.92 357.824 377.824 434.688 32.096 17.12 67.008 33.472 89.6 43.68 8.128 3.68 17.024 3.68 25.152 0 22.624-10.208 57.504-26.56 89.6-43.68 144.32-77.088 374.688-231.968 377.856-436.544 1.664-107.232-66.56-207.168-167.68-243.072zM424.896 795.296c-127.648-68.16-344.128-209.664-360.032-391.296-5.216-59.616 13.088-117.664 51.552-163.52 38.464-45.824 92.48-73.92 152.064-79.136 6.624-0.576 13.184-0.864 19.68-0.864 53.568 0 104.832 19.2 145.6 54.24l5.28 60.16c0.736 8.448 4.8 16.256 11.296 21.728l44.832 37.6-95.776 114.144c-11.36 13.536-9.6 33.728 3.936 45.088l114.144 95.776-95.776 114.144c-11.36 13.536-9.6 33.728 3.936 45.088l86.368 72.928v16.896c-17.312-8.128-63.36-30.304-87.104-42.976zM446.208 723.968l6.72-8 38.688 46.112-45.408-38.112zM959.136 404c-15.904 181.664-232.416 323.136-360.064 391.328-23.712 12.672-45.088 23.2-62.4 31.328l3.648-41.696c0.736-8.448-1.92-16.864-7.36-23.36l-37.6-44.832 114.144-95.776c13.536-11.36 15.296-31.552 3.936-45.088l-95.776-114.144 114.144-95.776c13.536-11.36 15.296-31.552 3.936-45.088l-49.664-59.168 4.096-46.976c40.768-35.072 92-54.24 145.6-54.24 6.496 0 13.088 0.288 19.68 0.864 59.616 5.216 113.6 33.344 152.064 79.168 38.528 45.792 56.832 103.84 51.616 163.456zM192 256c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM192 352c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hate",
						"love",
						"break"
					],
					"grid": 32
				},
				{
					"id": 558,
					"width": 1024,
					"paths": [
						"M224 320c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM992.032 386.912c-3.136 204.608-233.536 359.52-377.856 436.608-32.896 17.568-68.736 34.304-91.264 44.416-7.040 3.168-14.752 3.168-21.792 0-22.528-10.144-58.4-26.88-91.264-44.448-144.608-77.184-375.488-232.448-377.888-437.536-1.6-135.52 117.664-255.872 253.152-257.472 1.024 0 2.048-0.032 3.072-0.032 63.168 0 121.728 23.392 166.88 62.368 6.24 5.376 9.888 13.184 10.624 21.376l4.064 46.688c0.736 8.448 4.8 16.256 11.296 21.728l34.656 29.088c13.536 11.36 15.296 31.552 3.936 45.088l-75.232 89.632c-11.36 13.536-9.6 33.728 3.936 45.088l89.632 75.232c13.536 11.36 15.296 31.552 3.936 45.088l-75.232 89.632c-11.36 13.536-9.6 33.728 3.936 45.088l41.632 34.912c5.312 4.448 13.152 4.224 18.176-0.544v0c5.248-4.96 5.728-13.184 1.088-18.72l-15.648-18.72c-11.328-13.536-9.536-33.664 3.968-45.024l89.568-75.296c13.504-11.328 15.264-31.456 3.968-44.992l-75.104-90.016c-11.296-13.568-9.504-33.728 4.064-45.024l90.432-75.552c13.664-11.424 15.392-31.776 3.84-45.344l-42.016-49.248c-5.6-6.56-8.288-15.072-7.52-23.616l5.312-59.328c0.896-10.080 6.304-19.424 15.040-24.544 37.952-22.24 81.824-35.040 128.32-35.040 28.928 0 58.912 4.896 88.512 15.424 101.184 35.872 169.408 135.776 167.776 243.040zM256 320c0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64c35.36 0 64-28.672 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hate",
						"love",
						"break"
					],
					"grid": 32
				},
				{
					"id": 1043,
					"width": 1024,
					"paths": [
						"M448 352h-32c0-84.608 128-84.8 128 0h-32c0-42.304-64-42.368-64 0zM672 352h32c0-84.608-128-84.8-128 0h32c0-42.304 64-42.368 64 0zM992 480c0 52.928-43.072 96-96 96 0 52.928-43.072 96-96 96h-24.352c-94.72 188.544-307.040 288-615.648 288h-160v-118.304l20.896-7.712c-0.096-0.032 107.104-54.176 107.104-417.984 0-194.080 157.92-352 352-352 183.328 0 334.336 140.832 350.56 320h65.44c52.928 0 96 43.072 96 96zM800 544h-384v-32h343.904c5.248-32.256 8.096-64.576 8.096-96 0-158.816-129.184-288-288-288s-288 129.184-288 288c0 330.048-86.144 434.624-128 465.92v14.080h96c333.184 0 491.552-114.848 560.64-256h-304.64v-32h384c42.304 0 42.368-64 0-64zM928 480c0-17.632-14.368-32-32-32h-97.536c-1.184 22.208-3.296 43.584-6.464 64h104c17.632 0 32-14.368 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"haunt",
						"die",
						"spook",
						"scare"
					],
					"grid": 32
				},
				{
					"id": 1329,
					"width": 877.7149848937988,
					"paths": [
						"M594.286 694.857q0 18.857-13.429 32.286t-32.286 13.429-32.286-13.429-13.429-32.286 13.429-32.286 32.286-13.429 32.286 13.429 13.429 32.286zM740.571 694.857q0 18.857-13.429 32.286t-32.286 13.429-32.286-13.429-13.429-32.286 13.429-32.286 32.286-13.429 32.286 13.429 13.429 32.286zM804.571 786.286v-182.857q0-7.429-5.429-12.857t-12.857-5.429h-694.857q-7.429 0-12.857 5.429t-5.429 12.857v182.857q0 7.429 5.429 12.857t12.857 5.429h694.857q7.429 0 12.857-5.429t5.429-12.857zM101.714 512h674.286l-89.714-275.429q-2.286-7.429-9.143-12.286t-14.857-4.857h-446.857q-8 0-14.857 4.857t-9.143 12.286zM877.714 603.429v182.857q0 37.714-26.857 64.571t-64.571 26.857h-694.857q-37.714 0-64.571-26.857t-26.857-64.571v-182.857q0-14.286 9.143-42.857l112.571-346.286q9.714-30.286 36-49.143t57.714-18.857h446.857q31.429 0 57.714 18.857t36 49.143l112.571 346.286q9.143 28.571 9.143 42.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hdd-o"
					],
					"defaultCode": 61600,
					"grid": 14
				},
				{
					"id": 1612,
					"width": 1024.001937866211,
					"paths": [
						"M961.143 950.857q-25.143 0-75.714-2t-76.286-2q-25.143 0-75.429 2t-75.429 2q-13.714 0-21.143-11.714t-7.429-26q0-17.714 9.714-26.286t22.286-9.714 29.143-4 25.714-8.571q18.857-12 18.857-80l-0.571-223.429q0-12-0.571-17.714-7.429-2.286-28.571-2.286h-385.714q-21.714 0-29.143 2.286-0.571 5.714-0.571 17.714l-0.571 212q0 81.143 21.143 93.714 9.143 5.714 27.429 7.429t32.571 2 25.714 8.571 11.429 26q0 14.857-7.143 27.429t-20.857 12.571q-26.857 0-79.714-2t-79.143-2q-24.571 0-73.143 2t-72.571 2q-13.143 0-20.286-12t-7.143-25.714q0-17.143 8.857-25.714t20.571-10 27.143-4.286 24-8.571q18.857-13.143 18.857-81.714l-0.571-32.571v-464.571q0-1.714 0.286-14.857t0-20.857-0.857-22-2-24-3.714-20.857-6.286-18-9.143-10.286q-8.571-5.714-25.714-6.857t-30.286-1.143-23.429-8-10.286-25.714q0-14.857 6.857-27.429t20.571-12.571q26.286 0 79.143 2t79.143 2q24 0 72.286-2t72.286-2q14.286 0 21.429 12.571t7.143 27.429q0 17.143-9.714 24.857t-22 8.286-28.286 2.286-24.571 7.429q-20 12-20 91.429l0.571 182.857q0 12 0.571 18.286 7.429 1.714 22.286 1.714h399.429q14.286 0 21.714-1.714 0.571-6.286 0.571-18.286l0.571-182.857q0-79.429-20-91.429-10.286-6.286-33.429-7.143t-37.714-7.429-14.571-28.286q0-14.857 7.143-27.429t21.429-12.571q25.143 0 75.429 2t75.429 2q24.571 0 73.714-2t73.714-2q14.286 0 21.429 12.571t7.143 27.429q0 17.143-10 25.143t-22.857 8.286-29.429 1.714-25.143 7.143q-20 13.143-20 92l0.571 538.857q0 68 19.429 80 9.143 5.714 26.286 7.714t30.571 2.571 23.714 8.857 10.286 25.429q0 14.857-6.857 27.429t-20.571 12.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"header"
					],
					"defaultCode": 61916,
					"grid": 14
				},
				{
					"id": 1885,
					"paths": [
						"M288 576h-64v448h64c17.6 0 32-14.4 32-32v-384c0-17.6-14.4-32-32-32z",
						"M736 576c-17.602 0-32 14.4-32 32v384c0 17.6 14.398 32 32 32h64v-448h-64z",
						"M1024 512c0-282.77-229.23-512-512-512s-512 229.23-512 512c0 61.412 10.83 120.29 30.656 174.848-19.478 33.206-30.656 71.87-30.656 113.152 0 112.846 83.448 206.188 192 221.716v-443.418c-31.914 4.566-61.664 15.842-87.754 32.378-5.392-26.718-8.246-54.364-8.246-82.676 0-229.75 186.25-416 416-416s416 186.25 416 416c0 28.314-2.83 55.968-8.22 82.696-26.1-16.546-55.854-27.848-87.78-32.418v443.44c108.548-15.532 192-108.874 192-221.714 0-41.274-11.178-79.934-30.648-113.138 19.828-54.566 30.648-113.452 30.648-174.866z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"headphones",
						"headset",
						"music",
						"audio"
					],
					"defaultCode": 59720,
					"grid": 16
				},
				{
					"id": 1213,
					"width": 950.8539810180664,
					"paths": [
						"M950.857 506.286q0 94.857-34.286 179.429l-11.429 28-105.714 18.857q-12.571 47.429-51.714 78t-89.429 30.571v18.286q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-329.143q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143v18.286q40.571 0 74.286 20.286t53.143 54.571l38.857-6.857q16.571-54.286 16.571-110.286 0-84.571-50.286-159.429t-135.143-119.429-180.286-44.571-180.286 44.571-135.143 119.429-50.286 159.429q0 56 16.571 110.286l38.857 6.857q19.429-34.286 53.143-54.571t74.286-20.286v-18.286q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143v329.143q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-18.286q-50.286 0-89.429-30.571t-51.714-78l-105.714-18.857-11.429-28q-34.286-84.571-34.286-179.429 0-86.286 38.286-166.286t102.286-138.571 152-93.429 182.857-34.857 182.857 34.857 152 93.429 102.286 138.571 38.286 166.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"headphones"
					],
					"defaultCode": 61477,
					"grid": 14
				},
				{
					"id": 1886,
					"paths": [
						"M828.784 131.216c-84.616-84.616-197.12-131.216-316.784-131.216s-232.166 46.6-316.782 131.216-131.218 197.118-131.218 316.784v224c0 53.020 42.98 96 96 96s96-42.98 96-96v-128c0-53.020-42.98-96-96-96-10.724 0-21.026 1.786-30.656 5.030v-5.030c16.318-196.82 181.696-352 382.656-352s366.34 155.18 382.656 352v5.030c-9.63-3.244-19.93-5.030-30.656-5.030-53.020 0-96 42.98-96 96v128c0 53.020 42.98 96 96 96 11.222 0 21.988-1.946 32-5.484v101.484c0 17.644-14.356 32-32 32h-165.484c-13.182-37.282-48.718-64-90.516-64-53.020 0-96 42.98-96 96s42.98 96 96 96c41.796 0 77.334-26.718 90.516-64h165.484c52.936 0 96-43.064 96-96v-416c0-119.666-46.6-232.166-131.216-316.784z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"headset",
						"support",
						"headphones"
					],
					"defaultCode": 59721,
					"grid": 16
				},
				{
					"id": 559,
					"width": 1024,
					"paths": [
						"M512 384c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32c17.664 0 32 14.336 32 32zM384 448c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32s-14.336-32-32-32zM640 512c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32s-14.336-32-32-32zM544 608c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32s-14.336-32-32-32zM608 384c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32s-14.336-32-32-32zM416 576c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32s-14.336-32-32-32zM512 480c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM512 149.952c-49.984-49.984-115.488-74.976-181.024-74.976-65.504 0-131.040 24.992-181.024 74.976-99.968 99.968-99.968 262.080 0 362.048l362.048 362.048c49.984 49.984 115.488 74.976 181.024 74.976s131.008-24.96 181.024-74.976c100.512-100.512 99.968-262.080 0-362.048l-362.048-362.048zM851.424 851.424c-42.304 42.304-98.56 65.6-158.4 65.6s-116.096-23.296-158.4-65.6l-362.048-362.048c-87.328-87.328-87.328-229.44 0-316.8 42.304-42.304 98.56-65.6 158.4-65.6s116.096 23.296 158.4 65.6l362.048 362.048c87.328 87.328 87.328 229.44 0 316.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heal",
						"fix",
						"mend",
						"patch",
						"recover"
					],
					"grid": 32
				},
				{
					"id": 560,
					"width": 1024,
					"paths": [
						"M874.048 512l-362.048-362.048c-49.984-49.984-115.488-74.976-181.024-74.976-65.504 0-131.040 24.992-181.024 74.976-99.968 99.968-99.968 262.080 0 362.048l362.048 362.048c49.984 49.984 115.488 74.976 181.024 74.976s131.008-24.96 181.024-74.976c100.48-100.512 99.968-262.080 0-362.048zM352 480c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM416 640c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.336 32-32 32zM448 384c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM512 544c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.336 32-32 32zM544 672c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.336 32-32 32zM576 416c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM640 576c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heal",
						"fix",
						"mend",
						"patch",
						"recover"
					],
					"grid": 32
				},
				{
					"id": 1044,
					"width": 1024,
					"paths": [
						"M783.488 512l184.256-184.224c36.288-36.256 56.256-84.448 56.256-135.776s-19.968-99.52-56.256-135.744c-36.256-36.256-84.448-56.256-135.744-56.256s-99.488 19.968-135.776 56.256l-184.224 184.224-184.256-184.256c-36.224-36.224-84.416-56.224-135.744-56.224s-99.52 20-135.744 56.224c-36.288 36.288-56.256 84.48-56.256 135.776s19.968 99.488 56.256 135.776l184.256 184.224-184.288 184.224c-36.256 36.256-56.224 84.48-56.224 135.776s19.968 99.52 56.224 135.744c36.288 36.288 84.48 56.256 135.776 56.256s99.488-20 135.744-56.256l184.256-184.224 184.256 184.256c36.256 36.256 84.416 56.224 135.744 56.224s99.488-19.968 135.744-56.224c36.288-36.288 56.256-84.48 56.256-135.776s-19.968-99.488-56.256-135.776l-184.256-184.224zM330.912 511.904l-229.408-229.408c-24.192-24.16-37.504-56.32-37.504-90.496s13.312-66.336 37.504-90.528c24.16-24.16 56.288-37.472 90.496-37.472s66.336 13.312 90.496 37.472l640 640.032c24.192 24.16 37.504 56.32 37.504 90.496s-13.312 66.336-37.504 90.528c-24.16 24.16-56.288 37.472-90.496 37.472s-66.336-13.312-90.496-37.472l-410.592-410.624zM741.472 101.504c48.384-48.384 132.672-48.384 181.024 0 24.192 24.16 37.504 56.288 37.504 90.496s-13.312 66.336-37.504 90.496l-206.88 206.88-180.992-180.992 206.848-206.88zM282.496 922.496c-48.384 48.384-132.672 48.384-181.024 0-24.16-24.16-37.472-56.288-37.472-90.496s13.312-66.336 37.472-90.496l206.912-206.88 181.024 181.024-206.912 206.848zM498.752 640c12.096 12.096 28.16 18.752 45.248 18.752s33.152-6.656 45.248-18.752l50.752-50.752c24.96-24.96 24.96-65.568 0-90.496l-114.752-114.752c-12.096-12.096-28.16-18.752-45.248-18.752s-33.152 6.656-45.248 18.752l-50.752 50.752c-24.96 24.96-24.96 65.568 0 90.496l114.752 114.752zM406.624 457.376l50.752-50.752c6.24-6.24 14.432-9.376 22.624-9.376s16.384 3.136 22.624 9.376l114.752 114.752c12.512 12.512 12.512 32.768 0 45.248l-50.752 50.752c-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376l-114.752-114.752c-12.48-12.48-12.48-32.768 0-45.248z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heal",
						"fix",
						"mend",
						"patch",
						"recover"
					],
					"grid": 32
				},
				{
					"id": 561,
					"width": 1024,
					"paths": [
						"M192 368v256c0 8.832-7.168 16-16 16s-16-7.168-16-16v-256c0-8.832 7.168-16 16-16s16 7.168 16 16zM240 288c-8.832 0-16 7.168-16 16v384c0 8.832 7.168 16 16 16s16-7.168 16-16v-384c0-8.832-7.168-16-16-16zM432 320c-8.832 0-16 7.168-16 16v320c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16zM368 256c-8.832 0-16 7.168-16 16v448c0 8.832 7.168 16 16 16s16-7.168 16-16v-448c0-8.832-7.168-16-16-16zM496 256c-8.832 0-16 7.168-16 16v448c0 8.832 7.168 16 16 16s16-7.168 16-16v-448c0-8.832-7.168-16-16-16zM624 224c-8.832 0-16 7.168-16 16v512c0 8.832 7.168 16 16 16s16-7.168 16-16v-512c0-8.832-7.168-16-16-16zM688 320c-8.832 0-16 7.168-16 16v320c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16zM752 416c-8.832 0-16 7.168-16 16v128c0 8.832 7.168 16 16 16s16-7.168 16-16v-128c0-8.832-7.168-16-16-16zM816 384c-8.832 0-16 7.168-16 16v192c0 8.832 7.168 16 16 16s16-7.168 16-16v-192c0-8.832-7.168-16-16-16zM880 320c-8.832 0-16 7.168-16 16v320c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16zM944 384c-8.832 0-16 7.168-16 16v192c0 8.832 7.168 16 16 16s16-7.168 16-16v-192c0-8.832-7.168-16-16-16zM1008 448c-8.832 0-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16zM304 224c-8.832 0-16 7.168-16 16v512c0 8.832 7.168 16 16 16s16-7.168 16-16v-512c0-8.832-7.168-16-16-16zM560 160c-8.832 0-16 7.168-16 16v640c0 8.832 7.168 16 16 16s16-7.168 16-16v-640c0-8.832-7.168-16-16-16zM112 416c-8.832 0-16 7.168-16 16v128c0 8.832 7.168 16 16 16s16-7.168 16-16v-128c0-8.832-7.168-16-16-16zM48 448c-8.832 0-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hear",
						"sound"
					],
					"grid": 32
				},
				{
					"id": 562,
					"width": 1024,
					"paths": [
						"M560 864c-26.464 0-48-21.536-48-48v-640c0-26.464 21.536-48 48-48s48 21.536 48 48v640c0 26.464-21.536 48-48 48zM304 800c-26.464 0-48-21.536-48-48v-512c0-26.464 21.536-48 48-48s48 21.536 48 48v512c0 26.464-21.536 48-48 48zM688 704c-26.464 0-48-21.536-48-48v-320c0-26.464 21.536-48 48-48s48 21.536 48 48v320c0 26.464-21.536 48-48 48zM432 704c-26.464 0-48-21.536-48-48v-320c0-26.464 21.536-48 48-48s48 21.536 48 48v320c0 26.464-21.536 48-48 48zM176 672c-26.464 0-48-21.536-48-48v-256c0-26.464 21.536-48 48-48s48 21.536 48 48v256c0 26.464-21.536 48-48 48zM944 640c-26.464 0-48-21.536-48-48v-192c0-26.464 21.536-48 48-48s48 21.536 48 48v192c0 26.464-21.536 48-48 48zM816 608c-26.464 0-48-21.536-48-48v-128c0-26.464 21.536-48 48-48s48 21.536 48 48v128c0 26.464-21.536 48-48 48zM48 576c-26.464 0-48-21.536-48-48v-64c0-26.464 21.536-48 48-48s48 21.536 48 48v64c0 26.464-21.536 48-48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hear",
						"sound"
					],
					"grid": 32
				},
				{
					"id": 2812,
					"paths": [
						"M704 160l320 320-512 512-512-512 320-320 192 192 192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart",
						"like",
						"love",
						"favorite"
					],
					"defaultCode": 60647,
					"grid": 16
				},
				{
					"id": 2816,
					"paths": [
						"M1024 358.156c0 86.362-37.218 164.030-96.49 217.844h0.49l-320 320c-32 32-64 64-96 64s-64-32-96-64l-319.51-320c-59.272-53.814-96.49-131.482-96.49-217.844 0-162.458 131.698-294.156 294.156-294.156 55.45 0 107.302 15.364 151.572 42.036l-93.728 149.964 224 128-128 320 352-384-224-128 78.892-118.34c23.932-6.288 49.046-9.66 74.952-9.66 162.456 0 294.156 131.698 294.156 294.156z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart-broken",
						"heart",
						"like",
						"love"
					],
					"defaultCode": 60651,
					"grid": 16
				},
				{
					"id": 2819,
					"paths": [
						"M755.188 64c148.382 0 268.812 120.44 268.812 268.832 0 292.21-315.824 382.842-511.978 679.418-207.522-298.424-512.022-377.572-512.022-679.418 0-148.392 120.426-268.832 268.808-268.832 60.354 0 115.99 27.53 160.796 67.834l-77.604 124.166 224 128-128 320 352-384-224-128 61.896-92.846c35.42-21.768 75.21-35.154 117.292-35.154z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart-broken",
						"heart",
						"like",
						"love"
					],
					"defaultCode": 60654,
					"grid": 16
				},
				{
					"id": 2822,
					"paths": [
						"M752 64c150.222 0 272 121.78 272 272 0 368-512 624-512 624s-512-256-512-624c0-150.22 121.778-272 272-272 62.094 0 119.314 20.824 165.094 55.848l-85.094 136.152 224 128-128 320 352-384-224-128 71.414-107.122c32.2-13.428 67.518-20.878 104.586-20.878z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart-broken",
						"heart",
						"like",
						"love"
					],
					"defaultCode": 60657,
					"grid": 16
				},
				{
					"id": 1309,
					"width": 1024.0010013580322,
					"paths": [
						"M950.857 340.571q0-46.286-12.286-81.714t-31.429-56.286-46.571-34-53.714-17.714-56-4.571-64 14.571-63.143 36.571-49.429 41.143-34.286 35.143q-10.286 12.571-28 12.571t-28-12.571q-13.714-16-34.286-35.143t-49.429-41.143-63.143-36.571-64-14.571-56 4.571-53.714 17.714-46.571 34-31.429 56.286-12.286 81.714q0 96 106.857 202.857l332 320 331.429-319.429q107.429-107.429 107.429-203.429zM1024 340.571q0 126.286-130.857 257.143l-356 342.857q-10.286 10.286-25.143 10.286t-25.143-10.286l-356.571-344q-5.714-4.571-15.714-14.857t-31.714-37.429-38.857-55.714-30.571-69.143-13.429-78.857q0-125.714 72.571-196.571t200.571-70.857q35.429 0 72.286 12.286t68.571 33.143 54.571 39.143 43.429 38.857q20.571-20.571 43.429-38.857t54.571-39.143 68.571-33.143 72.286-12.286q128 0 200.571 70.857t72.571 196.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart-o"
					],
					"defaultCode": 61578,
					"grid": 14
				},
				{
					"id": 159,
					"paths": [
						"M486.4 972.8c-4.283 0-8.566-1.074-12.432-3.222-5.954-3.307-147.285-82.464-274.914-208.987-10.040-9.954-10.11-26.163-0.157-36.203s26.163-10.11 36.203-0.157c101.349 100.472 214.307 171.323 251.293 193.35 37-22.054 150.123-93.045 251.304-193.352 10.042-9.952 26.248-9.882 36.205 0.158 9.954 10.040 9.883 26.25-0.158 36.205-127.629 126.52-268.958 205.678-274.912 208.986-3.866 2.149-8.149 3.222-12.432 3.222z",
						"M65.478 563.216c-9.61 0-18.821-5.437-23.182-14.709-28.066-59.659-42.296-119.314-42.296-177.307 0-148.218 120.582-268.8 268.8-268.8 50.173 0 103.461 18.805 150.051 52.952 27.251 19.973 50.442 44.043 67.549 69.606 17.107-25.565 40.299-49.634 67.55-69.606 46.589-34.147 99.878-52.952 150.050-52.952 148.218 0 268.8 120.582 268.8 268.8 0 57.992-14.23 117.645-42.294 177.301-6.018 12.794-21.267 18.29-34.061 12.267-12.794-6.018-18.286-21.267-12.269-34.061 24.834-52.786 37.424-105.107 37.424-155.507 0-119.986-97.616-217.6-217.6-217.6-87.187 0-171.856 71.725-193.314 136.096-3.485 10.453-13.267 17.504-24.286 17.504s-20.802-7.051-24.286-17.504c-21.456-64.371-106.125-136.096-193.314-136.096-119.986 0-217.6 97.614-217.6 217.6 0 50.4 12.592 102.723 37.426 155.512 6.019 12.794 0.526 28.043-12.267 34.061-3.522 1.659-7.23 2.443-10.88 2.443z",
						"M538.346 768.024c-0.232 0-0.456-0.002-0.678-0.006-10.35-0.218-29.122-5.598-38.552-39.194l-62.291-221.915-41.328 167.894c-8.106 32.933-26.902 39.813-37.387 40.982-10.483 1.173-30.334-1.397-45.504-31.733l-31.005-62.010c-1.475-2.952-2.85-4.834-3.893-6-0.171 0.229-0.355 0.483-0.546 0.765-18.939 27.816-61.053 48.792-97.962 48.792h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c21.554 0 47.152-13.942 55.638-26.408 11.397-16.739 28.026-25.638 45.629-24.48 19.142 1.286 36.246 14.274 46.928 35.634l22.781 45.562 47.93-194.71c8.069-32.784 24.658-39.907 37.15-40.109 12.512-0.24 29.302 6.379 38.43 38.888l65.763 234.286 60.323-184.738c10.504-32.168 29.779-37.707 40.334-38.144 10.542-0.435 30.224 3.482 43.357 34.672l37.062 88.026c6.946 16.496 29.573 31.522 47.474 31.522h76.8c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6h-76.8c-38.24 0-79.822-27.608-94.662-62.853l-30.301-71.968-65.208 199.699c-10.598 32.454-29 37.546-39.483 37.546z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart-pulse",
						"health",
						"heart-rate"
					],
					"defaultCode": 59456,
					"grid": 20
				},
				{
					"id": 114,
					"paths": [
						"M486.4 972.8c-4.283 0-8.566-1.074-12.434-3.222-4.808-2.67-119.088-66.624-235.122-171.376-68.643-61.97-123.467-125.363-162.944-188.418-50.365-80.443-75.901-160.715-75.901-238.584 0-148.218 120.582-268.8 268.8-268.8 50.173 0 103.462 18.805 150.051 52.952 27.251 19.973 50.442 44.043 67.549 69.606 17.107-25.565 40.299-49.634 67.55-69.606 46.589-34.147 99.878-52.952 150.050-52.952 148.218 0 268.8 120.582 268.8 268.8 0 77.869-25.538 158.141-75.901 238.584-39.478 63.054-94.301 126.446-162.944 188.418-116.034 104.754-230.314 168.706-235.122 171.376-3.867 2.149-8.15 3.222-12.434 3.222zM268.8 153.6c-119.986 0-217.6 97.614-217.6 217.6 0 155.624 120.302 297.077 221.224 388.338 90.131 81.504 181.44 138.658 213.976 158.042 32.536-19.384 123.845-76.538 213.976-158.042 100.922-91.261 221.224-232.714 221.224-388.338 0-119.986-97.616-217.6-217.6-217.6-87.187 0-171.856 71.725-193.314 136.096-3.485 10.453-13.267 17.504-24.286 17.504s-20.802-7.051-24.286-17.504c-21.456-64.371-106.125-136.096-193.314-136.096z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart",
						"love",
						"like",
						"favorite"
					],
					"defaultCode": 59411,
					"grid": 20
				},
				{
					"id": 2813,
					"paths": [
						"M704 160l-192 192-192-192-320 320 512 512 512-512-320-320zM181.020 480l138.98-138.98 192 192 192-192 138.98 138.98-330.98 330.98-330.98-330.98z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart",
						"like",
						"love",
						"favorite"
					],
					"defaultCode": 60648,
					"grid": 16
				},
				{
					"id": 2814,
					"paths": [
						"M1024 358.156c0 86.362-37.218 164.030-96.49 217.844h0.49l-320 320c-32 32-64 64-96 64s-64-32-96-64l-319.51-320c-59.272-53.814-96.49-131.482-96.49-217.844 0-162.458 131.698-294.156 294.156-294.156 86.362 0 164.030 37.218 217.844 96.49 53.814-59.272 131.482-96.49 217.844-96.49 162.456 0 294.156 131.698 294.156 294.156z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart",
						"like",
						"love",
						"favorite"
					],
					"defaultCode": 60649,
					"grid": 16
				},
				{
					"id": 2815,
					"paths": [
						"M1024 358.156c0-162.458-131.7-294.156-294.156-294.156-86.362 0-164.030 37.218-217.844 96.49-53.814-59.272-131.482-96.49-217.844-96.49-162.458 0-294.156 131.698-294.156 294.156 0 86.362 37.218 164.030 96.49 217.844h-0.49l320 320c32 32 64 64 96 64s64-32 96-64l319.51-320c59.272-53.814 96.49-131.482 96.49-217.844zM841.468 481.232l-323.978 324.258c-1.678 1.678-3.532 3.532-5.49 5.48-1.96-1.95-3.814-3.802-5.49-5.48l-323.978-324.256c-35.166-31.928-54.532-75.638-54.532-123.078 0-91.618 74.538-166.156 166.156-166.156 47.44 0 91.15 19.366 123.076 54.532l94.768 104.38 94.768-104.378c31.928-35.168 75.636-54.534 123.076-54.534 91.618 0 166.156 74.538 166.156 166.156 0 47.44-19.368 91.15-54.532 123.076z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart",
						"like",
						"love",
						"favorite"
					],
					"defaultCode": 60650,
					"grid": 16
				},
				{
					"id": 2817,
					"paths": [
						"M755.188 64c-107.63 0-200.258 87.554-243.164 179-42.938-91.444-135.578-179-243.216-179-148.382 0-268.808 120.44-268.808 268.832 0 301.846 304.5 380.994 512.022 679.418 196.154-296.576 511.978-387.206 511.978-679.418 0-148.392-120.43-268.832-268.812-268.832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart",
						"like",
						"love",
						"favorite"
					],
					"defaultCode": 60652,
					"grid": 16
				},
				{
					"id": 2818,
					"paths": [
						"M513.322 1024l-52.896-72.066c-64.944-88.476-141.586-152.090-215.708-213.61-62.278-51.688-121.1-100.512-165.862-159.054-53.062-69.394-78.856-144.11-78.856-228.418 0-158.17 134.224-286.852 299.208-286.852 57.666 0 115.102 20.268 166.098 58.612 16.61 12.49 32.308 26.778 46.704 42.394 14.39-15.616 30.082-29.902 46.692-42.392 50.988-38.344 108.422-58.614 166.088-58.614 164.986 0 299.21 128.682 299.21 286.852 0 81.042-25.84 153.942-78.998 222.858-44.458 57.64-102.508 106.394-163.966 158.012-75.66 63.542-153.896 129.246-216.54 218.976l-51.174 73.302zM299.208 192c-94.406 0-171.208 71.262-171.208 158.852 0 124.252 83.248 193.346 198.466 288.98 58.888 48.876 123.84 102.786 184.542 171.308 60.57-70.664 127.252-126.664 187.706-177.438 56.014-47.042 108.922-91.476 144.934-138.166 36.206-46.94 52.352-91.562 52.352-144.684 0-87.59-76.804-158.852-171.21-158.852-47.952 0-117.040 35.294-155.416 112.786l-57.328 115.76-57.368-115.742c-38.414-77.502-107.52-112.804-155.47-112.804z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart",
						"like",
						"love",
						"favorite"
					],
					"defaultCode": 60653,
					"grid": 16
				},
				{
					"id": 2820,
					"paths": [
						"M752 64c-103.912 0-194.2 58.276-240 143.92-45.802-85.644-136.090-143.92-240-143.92-150.222 0-272 121.78-272 272 0 368 512 624 512 624s512-256 512-624c0-150.22-121.778-272-272-272z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart",
						"like",
						"love",
						"favorite"
					],
					"defaultCode": 60655,
					"grid": 16
				},
				{
					"id": 2821,
					"paths": [
						"M512 960l-27.94-13.558c-19.766-9.59-484.060-238.9-484.060-587.468 0-162.65 135.476-294.974 302-294.974 79.66 0 154.516 30.474 210 82.924 55.484-52.45 130.34-82.924 210-82.924 166.524 0 302 132.324 302 294.974 0 348.568-464.294 577.876-484.060 587.466l-27.94 13.56zM302 192c-95.944 0-174 74.904-174 166.974 0 135.952 108.246 255.232 199.052 331.36 72.5 60.78 146.124 104.702 184.948 126.162 38.824-21.46 112.448-65.382 184.948-126.162 90.806-76.126 199.052-195.408 199.052-331.36 0-92.070-78.056-166.974-174-166.974-64.672 0-123.662 34.14-153.948 89.1l-56.052 101.72-56.052-101.72c-30.286-54.96-89.276-89.1-153.948-89.1z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart",
						"like",
						"love",
						"favorite"
					],
					"defaultCode": 60656,
					"grid": 16
				},
				{
					"id": 1183,
					"width": 1023.999963760376,
					"paths": [
						"M512 950.857q-14.857 0-25.143-10.286l-356.571-344q-5.714-4.571-15.714-14.857t-31.714-37.429-38.857-55.714-30.571-69.143-13.429-78.857q0-125.714 72.571-196.571t200.571-70.857q35.429 0 72.286 12.286t68.571 33.143 54.571 39.143 43.429 38.857q20.571-20.571 43.429-38.857t54.571-39.143 68.571-33.143 72.286-12.286q128 0 200.571 70.857t72.571 196.571q0 126.286-130.857 257.143l-356 342.857q-10.286 10.286-25.143 10.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heart"
					],
					"defaultCode": 61444,
					"grid": 14
				},
				{
					"id": 1674,
					"width": 1024.0009994506836,
					"paths": [
						"M731.429 585.143h174.286q-2.857 3.429-5.714 6t-5.143 4.286l-1.714 2.286-356 342.857q-10.286 10.286-25.143 10.286t-25.143-10.286l-356.571-344q-2.857-1.143-12-11.429h210.857q12.571 0 22.571-7.714t12.857-19.714l40-160.571 108.571 381.143q3.429 11.429 13.143 18.857t22.286 7.429q12 0 21.714-7.429t13.143-18.857l83.429-277.143 32 64q10.286 20 32.571 20zM1024 340.571q0 82.857-58.857 171.429h-210.857l-63.429-126.286q-4.571-9.714-14.571-15.429t-20.857-4.571q-25.714 2.857-32 26.286l-73.714 245.714-112-392q-3.429-11.429-13.429-18.857t-22.571-7.429-22.286 7.714-12.571 19.714l-66.286 265.143h-241.714q-58.857-88.571-58.857-171.429 0-125.714 72.571-196.571t200.571-70.857q35.429 0 72.286 12.286t68.571 33.143 54.571 39.143 43.429 38.857q20.571-20.571 43.429-38.857t54.571-39.143 68.571-33.143 72.286-12.286q128 0 200.571 70.857t72.571 196.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heartbeat"
					],
					"defaultCode": 61982,
					"grid": 14
				},
				{
					"id": 563,
					"width": 1024,
					"paths": [
						"M512 802.944v-498.944c0-8.832-7.168-16-16-16s-16 7.168-16 16v498.944c-18.592 6.624-32 24.192-32 45.056 0 26.496 21.504 48 48 48s48-21.504 48-48c0-20.864-13.408-38.464-32-45.056zM496 864c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16-7.168 16-16 16zM608 712.224v-616.224c0-53.024-42.976-96-96-96h-32c-53.024 0-96 42.976-96 96v616.224c-39.072 32.288-64 81.12-64 135.776 0 97.216 78.784 176 176 176s176-78.784 176-176c0-54.656-24.928-103.488-64-135.776zM496 992c-79.392 0-144-64.608-144-144 0-43.104 19.104-83.616 52.384-111.104l1.088-0.896h26.528c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-32c0-35.296 28.704-64 64-64h32c35.296 0 64 28.704 64 64v631.296l11.616 9.6c33.28 27.488 52.384 68 52.384 111.104 0 79.392-64.608 144-144 144z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heat",
						"measure",
						"warm",
						"cool"
					],
					"grid": 32
				},
				{
					"id": 564,
					"width": 1024,
					"paths": [
						"M608 712.224v-616.224c0-53.024-42.976-96-96-96h-32c-53.024 0-96 42.976-96 96v616.224c-39.072 32.288-64 81.12-64 135.776 0 97.216 78.784 176 176 176s176-78.784 176-176c0-54.656-24.928-103.488-64-135.776zM432 128c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16c0-8.832 7.168-16 16-16zM432 224c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16c0-8.832 7.168-16 16-16zM432 320c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16c0-8.832 7.168-16 16-16zM432 416c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16c0-8.832 7.168-16 16-16zM432 512c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16c0-8.832 7.168-16 16-16zM432 608c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16c0-8.832 7.168-16 16-16zM432 736c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16c0 8.832-7.168 16-16 16zM496 896c-26.496 0-48-21.504-48-48 0-20.864 13.408-38.464 32-45.056v-498.944c0-8.832 7.168-16 16-16s16 7.168 16 16v498.944c18.592 6.624 32 24.192 32 45.056 0 26.496-21.504 48-48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"heat",
						"measure",
						"warm",
						"cool"
					],
					"grid": 32
				},
				{
					"id": 2831,
					"paths": [
						"M768 96c0 53.020-42.98 96-96 96-53.022 0-96-42.98-96-96 0-53.018 42.98-96 96-96s96 42.982 96 96z",
						"M768 256h-192c-35.346 0-64 28.654-64 64v320h64v384h80v-384h32v384h80v-384h64v-320c0-35.346-28.652-64-64-64z",
						"M384 64v-64h-320v1024h320v-64h-256v-128h128v-64h-128v-128h128v-64h-128v-128h128v-64h-128v-128h128v-64h-128v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"height"
					],
					"defaultCode": 60666,
					"grid": 16
				},
				{
					"id": 3242,
					"paths": [
						"M896 768h128l-160 192-160-192h128v-512h-128l160-192 160 192h-128zM512 192h-384v640h384v-640zM640 64v0 896h-640v-896h640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"height",
						"size"
					],
					"defaultCode": 61077,
					"grid": 16
				},
				{
					"id": 565,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 672c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.776 160-160 160zM692.544 447.168l180.736-140.608c34.624 60.704 54.72 130.688 54.72 205.44s-20.096 144.736-54.72 205.44l-180.736-140.608c7.264-20.288 11.456-42.048 11.456-64.832s-4.192-44.544-11.456-64.832zM856.512 279.104l-177.632 138.176c-17.12-30.080-42.080-55.040-72.16-72.16l138.176-177.632c43.904 29.792 81.824 67.712 111.616 111.616zM717.44 150.72l-140.608 180.736c-20.288-7.264-42.048-11.456-64.832-11.456s-44.544 4.192-64.832 11.456l-140.608-180.736c60.704-34.624 130.688-54.72 205.44-54.72s144.736 20.096 205.44 54.72zM279.104 167.488l138.176 177.632c-30.080 17.12-55.040 42.080-72.16 72.16l-177.632-138.176c29.792-43.904 67.712-81.824 111.616-111.616zM150.72 306.56l180.736 140.608c-7.264 20.288-11.456 42.048-11.456 64.832s4.192 44.544 11.456 64.832l-180.736 140.608c-34.624-60.704-54.72-130.688-54.72-205.44s20.096-144.736 54.72-205.44zM167.488 744.896l177.632-138.176c17.12 30.080 42.080 55.040 72.16 72.16l-138.176 177.632c-43.904-29.792-81.824-67.712-111.616-111.616zM306.56 873.28l140.608-180.736c20.288 7.264 42.048 11.456 64.832 11.456s44.544-4.192 64.832-11.456l140.608 180.736c-60.704 34.624-130.688 54.72-205.44 54.72s-144.736-20.096-205.44-54.72zM744.896 856.512l-138.176-177.632c30.080-17.12 55.040-42.080 72.16-72.16l177.632 138.176c-29.792 43.904-67.712 81.824-111.616 111.616z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"help",
						"aid",
						"float",
						"save",
						"drown"
					],
					"grid": 32
				},
				{
					"id": 566,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM842.272 289.28c7.456-5.856 18.432-3.936 23.328 4.192 0.064 0.096 0.128 0.192 0.16 0.288 4.128 6.88 2.528 15.744-3.776 20.704l-152.992 120.224c-7.968 6.272-19.68 3.52-24.032-5.6-0.032-0.096-0.096-0.192-0.16-0.288-3.2-6.688-1.376-14.72 4.448-19.296l153.024-120.224zM589.28 315.008l120.224-153.024c4.96-6.304 13.824-7.904 20.704-3.776 0.096 0.064 0.192 0.128 0.288 0.16 8.128 4.896 10.080 15.872 4.192 23.328l-120.192 152.992c-4.576 5.856-12.608 7.648-19.296 4.448-0.096-0.064-0.192-0.096-0.288-0.16-9.152-4.32-11.872-16-5.632-23.968zM293.504 158.4c0.096-0.064 0.192-0.128 0.288-0.16 6.88-4.128 15.744-2.528 20.704 3.776l120.224 153.024c6.272 7.968 3.52 19.68-5.6 24.032-0.096 0.032-0.192 0.096-0.288 0.16-6.688 3.2-14.72 1.376-19.296-4.448l-120.256-153.056c-5.856-7.456-3.904-18.432 4.224-23.328zM158.208 293.792c0.064-0.096 0.128-0.192 0.192-0.288 4.896-8.128 15.872-10.080 23.328-4.224l152.992 120.192c5.856 4.576 7.648 12.608 4.448 19.296-0.064 0.096-0.096 0.192-0.16 0.288-4.352 9.152-16.064 11.872-24.032 5.6l-152.992-120.16c-6.304-4.96-7.904-13.856-3.776-20.704zM181.728 734.72c-7.456 5.856-18.432 3.936-23.328-4.192-0.064-0.096-0.128-0.192-0.16-0.288-4.128-6.88-2.528-15.744 3.776-20.704l152.992-120.224c7.968-6.272 19.68-3.52 24.032 5.6 0.032 0.096 0.096 0.192 0.16 0.288 3.2 6.688 1.376 14.72-4.448 19.296l-153.024 120.224zM434.72 708.992l-120.224 152.992c-4.96 6.304-13.824 7.904-20.704 3.776-0.096-0.064-0.192-0.128-0.288-0.16-8.128-4.896-10.080-15.872-4.192-23.328l120.192-152.992c4.576-5.856 12.608-7.648 19.296-4.448 0.096 0.064 0.192 0.096 0.288 0.16 9.152 4.352 11.872 16.032 5.632 24zM352 512c0-88.352 71.648-160 160-160s160 71.648 160 160c0 88.352-71.648 160-160 160s-160-71.648-160-160zM730.496 865.6c-0.096 0.064-0.192 0.128-0.288 0.16-6.88 4.128-15.744 2.528-20.704-3.776l-120.224-152.992c-6.272-7.968-3.52-19.68 5.6-24.032 0.096-0.064 0.192-0.096 0.288-0.16 6.688-3.2 14.72-1.408 19.296 4.448l120.192 152.992c5.92 7.488 3.968 18.464-4.16 23.36zM865.792 730.208c-0.064 0.096-0.128 0.192-0.16 0.288-4.896 8.128-15.872 10.080-23.328 4.192l-152.992-120.192c-5.856-4.576-7.648-12.608-4.448-19.296 0.064-0.096 0.096-0.192 0.16-0.288 4.352-9.152 16.064-11.872 24.032-5.6l152.992 120.224c6.272 4.928 7.872 13.824 3.744 20.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"help",
						"aid",
						"float",
						"save",
						"drown"
					],
					"grid": 32
				},
				{
					"id": 567,
					"width": 1024,
					"paths": [
						"M1007.616 573.824c11.2-18.304 12.416-40.896 3.072-60.224-41.376-85.408-184.128-321.6-498.688-321.6s-457.312 236.192-498.688 321.632c-9.344 19.296-8.16 41.92 3.072 60.224 20.064 32.768 59.648 87.456 124.352 138.080l-45.568 54.304c-5.664 6.752-4.8 16.864 1.984 22.528v0c6.752 5.664 16.864 4.8 22.528-1.984l47.104-56.096c38.208 26.4 83.904 50.432 137.952 68.576l-26.72 73.344c-3.008 8.288 1.248 17.472 9.568 20.512v0c8.288 3.008 17.472-1.248 20.48-9.568l27.264-74.88c47.52 13.12 100.896 21.44 160.672 22.784v80.544c0 8.832 7.168 16 16 16v0c8.832 0 16-7.168 16-16v-80.544c59.776-1.344 113.152-9.696 160.672-22.784l27.264 74.88c3.008 8.288 12.192 12.576 20.48 9.568v0c8.288-3.008 12.576-12.192 9.568-20.512l-26.72-73.344c54.048-18.176 99.776-42.176 137.952-68.576l47.104 56.096c5.664 6.752 15.776 7.648 22.528 1.984v0c6.752-5.664 7.648-15.776 1.984-22.528l-45.568-54.304c64.704-50.656 104.288-105.344 124.352-138.112zM512 800c-293.792 0-427.488-174.464-468.48-242.56-5.504-9.152-5.984-20.256-1.312-29.888 38.656-79.328 174.080-303.552 469.792-303.552 298.624 0 431.776 223.136 469.952 303.2 4.608 9.664 4.032 20.736-1.568 29.856-41.376 67.552-176.992 242.944-468.384 242.944z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hide",
						"close",
						"sleep"
					],
					"grid": 32
				},
				{
					"id": 568,
					"width": 1024,
					"paths": [
						"M1007.616 573.824c11.2-18.304 12.416-40.896 3.072-60.224-41.376-85.408-184.128-321.6-498.688-321.6s-457.312 236.192-498.688 321.632c-9.344 19.296-8.16 41.92 3.072 60.224 20.064 32.768 59.648 87.456 124.352 138.080l-45.568 54.304c-5.664 6.752-4.8 16.864 1.984 22.528v0c6.752 5.664 16.864 4.8 22.528-1.984l47.104-56.096c38.208 26.4 83.904 50.432 137.952 68.576l-26.72 73.344c-3.008 8.288 1.248 17.472 9.568 20.512v0c8.288 3.008 17.472-1.248 20.48-9.568l27.264-74.88c47.52 13.12 100.896 21.44 160.672 22.784v80.544c0 8.832 7.168 16 16 16v0c8.832 0 16-7.168 16-16v-80.544c59.776-1.344 113.152-9.696 160.672-22.784l27.264 74.88c3.008 8.288 12.192 12.576 20.48 9.568v0c8.288-3.008 12.576-12.192 9.568-20.512l-26.72-73.344c54.048-18.176 99.776-42.176 137.952-68.576l47.104 56.096c5.664 6.752 15.776 7.648 22.528 1.984v0c6.752-5.664 7.648-15.776 1.984-22.528l-45.568-54.304c64.704-50.656 104.288-105.344 124.352-138.112z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hide",
						"close",
						"sleep"
					],
					"grid": 32
				},
				{
					"id": 3264,
					"paths": [
						"M672 96.168l239.834 207.832 0.166-0.166-208-239.666 239.918 207.748 48.082 48.084-336.36 336.36c-29.612 29.612-75.156 34.166-109.68 13.68l46.040-46.206-208-239.666 239.834 207.832 0.166-0.166-208-239.666 239.834 207.832 0.166-0.166-208-239.666 239.834 207.832 0.166-0.166-208-239.666 239.834 207.832 0.166-0.166-208-239.666 239.834 207.832 0.166-0.166-208-239.666 239.834 207.832 0.166-0.166-208-239.666 239.834 207.832 0.166-0.166-208-239.666 239.834 207.832 0.166-0.166-208-239.666 239.834 207.832 0.166-0.166-208-239.666zM720.084 48.084l-398.12 397.952c-8.378-14.116-12.574-30.074-12.574-46.038 0-23.068 8.75-46.138 26.25-63.638l336.36-336.36 48.084 48.084zM321.962 446.038l224 224-161.962 161.962h-384v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"highlight",
						"wysiwyg",
						"background-color",
						"dualtone"
					],
					"defaultCode": 61099,
					"grid": 16
				},
				{
					"id": 246,
					"paths": [
						"M1016.501 493.899c-9.997-9.998-26.206-9.998-36.203 0l-183.592 183.592c-29.944 29.944-78.669 29.944-108.613 0l-239.184-239.186c-14.426-14.426-22.37-33.712-22.37-54.306s7.944-39.88 22.37-54.306l183.592-183.594c9.998-9.997 9.998-26.206 0-36.203-9.997-9.998-26.206-9.998-36.203 0l-183.592 183.594c-24.096 24.096-37.366 56.238-37.366 90.509 0 14.605 2.432 28.818 7.064 42.192l-374.906 374.907c-4.8 4.8-7.498 11.312-7.498 18.101v76.8c0 14.139 11.462 25.6 25.6 25.6h486.4c6.789 0 13.301-2.698 18.101-7.499l170.104-170.104c13.374 4.634 27.587 7.064 42.194 7.064 34.27 0 66.414-13.27 90.509-37.366l183.592-183.592c10-9.998 10-26.206 0.002-36.203zM501.397 870.4h-450.197v-40.595l358.477-358.477c1 1.069 1.99 2.142 3.030 3.181l239.184 239.184c1.038 1.038 2.112 2.032 3.182 3.030l-153.677 153.677z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"highlight",
						"magic-marker"
					],
					"defaultCode": 59543,
					"grid": 20
				},
				{
					"id": 2865,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM256 320c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64zM640 320c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64z",
						"M675.882 540.118c-37.49-37.49-98.276-37.49-135.766 0s-37.49 98.276 0 135.766c1.204 1.204 2.434 2.368 3.684 3.492 86.528 78.512 288.2-1.842 288.2-103.376-62 40-110.45 9.786-156.118-35.882z",
						"M348.118 540.118c37.49-37.49 98.276-37.49 135.766 0s37.49 98.276 0 135.766c-1.204 1.204-2.434 2.368-3.684 3.492-86.528 78.512-288.2-1.842-288.2-103.376 62 40 110.45 9.786 156.118-35.882z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hipster",
						"emoticon",
						"smiley",
						"mustache",
						"face"
					],
					"defaultCode": 60700,
					"grid": 16
				},
				{
					"id": 2866,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM704 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM320 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM543.8 679.376c-1.25-1.124-2.48-2.29-3.684-3.492-18.74-18.74-28.112-43.3-28.118-67.864-0.004 24.562-9.376 49.124-28.118 67.864-1.204 1.204-2.434 2.368-3.684 3.492-86.524 78.512-288.196-1.842-288.196-103.376 62 40 110.45 9.786 156.118-35.882 37.49-37.49 98.276-37.49 135.766 0 18.74 18.74 28.112 43.3 28.118 67.864 0.004-24.562 9.376-49.124 28.118-67.864 37.49-37.49 98.276-37.49 135.766 0 45.664 45.668 94.114 75.882 156.114 35.882 0 101.534-201.672 181.888-288.2 103.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hipster",
						"emoticon",
						"smiley",
						"mustache",
						"face"
					],
					"defaultCode": 60701,
					"grid": 16
				},
				{
					"id": 2145,
					"width": 1088,
					"paths": [
						"M640 64c247.424 0 448 200.576 448 448s-200.576 448-448 448v-96c94.024 0 182.418-36.614 248.902-103.098s103.098-154.878 103.098-248.902c0-94.022-36.614-182.418-103.098-248.902s-154.878-103.098-248.902-103.098c-94.022 0-182.418 36.614-248.902 103.098-51.14 51.138-84.582 115.246-97.306 184.902h186.208l-224 256-224-256h164.57c31.060-217.102 217.738-384 443.43-384zM832 448v128h-256v-320h128v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"history",
						"time",
						"archive",
						"past"
					],
					"defaultCode": 59980,
					"grid": 16
				},
				{
					"id": 1610,
					"width": 877.7160301208496,
					"paths": [
						"M877.714 512q0 89.143-34.857 170.286t-93.714 140-140 93.714-170.286 34.857q-98.286 0-186.857-41.429t-150.857-116.857q-4-5.714-3.714-12.857t4.857-11.714l78.286-78.857q5.714-5.143 14.286-5.143 9.143 1.143 13.143 6.857 41.714 54.286 102.286 84t128.571 29.714q59.429 0 113.429-23.143t93.429-62.571 62.571-93.429 23.143-113.429-23.143-113.429-62.571-93.429-93.429-62.571-113.429-23.143q-56 0-107.429 20.286t-91.429 58l78.286 78.857q17.714 17.143 8 39.429-9.714 22.857-33.714 22.857h-256q-14.857 0-25.714-10.857t-10.857-25.714v-256q0-24 22.857-33.714 22.286-9.714 39.429 8l74.286 73.714q61.143-57.714 139.714-89.429t162.571-31.714q89.143 0 170.286 34.857t140 93.714 93.714 140 34.857 170.286zM512 347.429v256q0 8-5.143 13.143t-13.143 5.143h-182.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h128v-201.143q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"history"
					],
					"defaultCode": 61914,
					"grid": 14
				},
				{
					"id": 194,
					"paths": [
						"M874.038 149.962c-96.704-96.704-225.278-149.962-362.038-149.962-158.432 0-305.912 72.984-402.094 194.938v-66.938c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v152.154c0 11.71 7.946 21.928 19.296 24.811 4.941 1.256 9.979 0.979 14.555-0.581v0.003l146.096-49.754c13.384-4.558 20.538-19.102 15.979-32.486s-19.099-20.539-32.486-15.979l-76.304 25.987c86.443-113.066 221.208-180.955 366.158-180.955 254.086 0 460.8 206.714 460.8 460.8s-206.714 460.8-460.8 460.8c-169.778 0-325.323-92.936-405.938-242.541-6.706-12.446-22.235-17.099-34.68-10.392s-17.099 22.234-10.394 34.68c89.56 166.205 262.378 269.453 451.011 269.453 136.76 0 265.334-53.258 362.038-149.962s149.962-225.278 149.962-362.038c0-136.76-53.258-265.334-149.962-362.038z",
						"M512 537.6c-4.277 0-8.558-1.069-12.432-3.222l-230.4-128c-12.36-6.866-16.813-22.451-9.946-34.81s22.451-16.813 34.81-9.946l217.080 120.6 268.744-171.021c11.925-7.59 27.75-4.078 35.342 7.854 7.59 11.928 4.074 27.75-7.854 35.341l-281.6 179.2c-4.182 2.662-8.962 4.003-13.744 4.003z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"history",
						"archive",
						"clock",
						"backward",
						"ccw"
					],
					"defaultCode": 59491,
					"grid": 20
				},
				{
					"id": 2647,
					"paths": [
						"M640 844.878v31.122c0 35.346 85.96 64 192 64s192-28.654 192-64v-31.122c-33.17 31.052-112.956 47.122-192 47.122s-158.83-16.070-192-47.122zM640 808c0-35.346 85.961-64 192-64s192 28.654 192 64c0 35.346-85.961 64-192 64s-192-28.654-192-64zM908.804 192l-459.762 577.964c-31.374 36.038-252.742 25.786-369.914 7.806-0.030 0-0.058 0-0.090-0.002-53.29-5.886-67.494-27.364-76.14 20.338h-0.006c-9.86 75.41 8.65 140.666 8.65 140.666 39.126 40.938 399.216 16.804 437.498-22.894l574.96-723.878h-115.196z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hockey",
						"sports",
						"game"
					],
					"defaultCode": 60482,
					"grid": 16
				},
				{
					"id": 569,
					"width": 1024,
					"paths": [
						"M608 484.896v-68.896c0-17.664-14.336-32-32-32h-224c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h224c17.664 0 32-14.336 32-32v-68.896c9.408-5.568 16-15.36 16-27.104s-6.592-21.536-16-27.104zM352 608v-64c17.664 0 32-14.336 32-32s-14.336-32-32-32v-64h224v64h-128c-17.696 0-32 14.304-32 32s14.304 32 32 32h128v64h-224zM666.112 384c-13.216-37.216-48.384-64-90.112-64h-224c-41.728 0-76.896 26.784-90.112 64h-229.888c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h229.888c13.216 37.216 48.384 64 90.112 64h224c41.728 0 76.896-26.784 90.112-64h325.888c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32h-325.888zM32 608v-192h224v192h-224zM576 672h-224c-35.296 0-64-28.704-64-64v-192c0-35.296 28.704-64 64-64h224c35.296 0 64 28.704 64 64v192c0 35.296-28.704 64-64 64zM672 608v-192h96c52.928 0 96 43.072 96 96s-43.072 96-96 96h-96zM992 608h-140.16c26.848-23.456 44.16-57.536 44.16-96s-17.312-72.544-44.16-96h140.16v192zM224 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM128 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hold",
						"wear",
						"secure",
						"wrap"
					],
					"grid": 32
				},
				{
					"id": 570,
					"width": 1024,
					"paths": [
						"M352 416h224v64h-128c-17.696 0-32 14.304-32 32s14.304 32 32 32h128v64h-224v-64c17.664 0 32-14.336 32-32s-14.336-32-32-32v-64zM224 608c0 11.104 1.856 21.696 4.544 32h-196.544c-17.664 0-32-14.336-32-32v-192c0-17.664 14.336-32 32-32h196.544c-2.688 10.304-4.544 20.896-4.544 32v96c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32v96zM128 512c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM992 384h-128.992c39.2 29.184 64.992 75.488 64.992 128s-25.792 98.816-64.992 128h128.992c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32zM768 384h-68.544c2.688 10.304 4.544 20.896 4.544 32v192c0 11.104-1.856 21.696-4.544 32h68.544c70.688 0 128-57.312 128-128s-57.312-128-128-128zM672 608c0 11.296-2.304 21.952-5.888 32-13.216 37.216-48.384 64-90.112 64h-224c-41.728 0-76.896-26.784-90.112-64-3.584-10.048-5.888-20.704-5.888-32v-192c0-11.296 2.304-21.952 5.888-32 13.216-37.216 48.384-64 90.112-64h224c41.728 0 76.896 26.784 90.112 64 3.584 10.048 5.888 20.704 5.888 32v192zM624 512c0-11.744-6.592-21.536-16-27.104v-68.896c0-17.664-14.336-32-32-32h-224c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h224c17.664 0 32-14.336 32-32v-68.896c9.408-5.568 16-15.36 16-27.104z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hold",
						"wear",
						"secure",
						"wrap"
					],
					"grid": 32
				},
				{
					"id": 1045,
					"width": 1024,
					"paths": [
						"M890.496 544c-8.416 0-16.672-3.392-22.624-9.376l-58.496-58.496c-12.16-12.16-26.976-20.64-43.136-24.928 3.264-32.608 1.984-65.6-3.872-98.432-27.296-153.632-155.040-271.616-310.656-286.976-210.912-20.928-387.712 144.384-387.712 350.208 0 17.44 1.408 35.232 4.224 53.12-9.888 5.536-19.104 12.48-27.488 20.896-47.36 47.424-47.328 124.608 0.064 172l269.856 269.856c18.080 18.144 42.208 28.128 67.84 28.128h363.008c25.632 0 49.76-9.984 67.872-28.128l58.496-58.496c5.984-5.952 14.208-9.376 22.624-9.376h133.504v-320h-133.504zM416 128c9.696 0 19.52 0.512 29.44 1.472 125.184 12.352 232 110.944 253.952 234.464 6.528 36.768 6.112 73.696-1.184 109.696l-1.312 6.368h-344.896c-53.024 0-96 42.976-96 96l-64.64-64.64c-15.232-15.232-34.656-23.424-54.528-25.408l-1.056-4.576c-5.152-22.112-7.776-44.128-7.776-65.376 0-158.816 129.184-288 288-288zM960 800h-69.504c-25.632 0-49.76 9.984-67.872 28.128l-58.496 58.496c-5.984 5.984-14.208 9.376-22.624 9.376h-363.008c-8.416 0-16.672-3.392-22.624-9.376l-269.856-269.856c-22.464-22.464-22.496-59.008 1.248-82.784v0c10.88-10.88 25.344-16.864 40.736-16.864s29.856 5.984 40.736 16.864l138.016 138.016h333.248v-32h-288.032c-35.264 0-63.968-28.704-63.968-64s28.704-64 64-64h389.504c8.416 0 16.672 3.392 22.624 9.376l58.496 58.496c18.112 18.144 42.24 28.128 67.872 28.128h69.504v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hold",
						"carry",
						"catch"
					],
					"grid": 32
				},
				{
					"id": 1813,
					"paths": [
						"M1024 590.446l-512-397.428-512 397.428v-162.038l512-397.426 512 397.428zM896 576v384h-768v-384l384-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"house"
					],
					"defaultCode": 59648,
					"grid": 16
				},
				{
					"id": 1199,
					"width": 950.8581371307373,
					"paths": [
						"M804.571 566.857v274.286q0 14.857-10.857 25.714t-25.714 10.857h-219.429v-219.429h-146.286v219.429h-219.429q-14.857 0-25.714-10.857t-10.857-25.714v-274.286q0-0.571 0.286-1.714t0.286-1.714l328.571-270.857 328.571 270.857q0.571 1.143 0.571 3.429zM932 527.429l-35.429 42.286q-4.571 5.143-12 6.286h-1.714q-7.429 0-12-4l-395.429-329.714-395.429 329.714q-6.857 4.571-13.714 4-7.429-1.143-12-6.286l-35.429-42.286q-4.571-5.714-4-13.429t6.286-12.286l410.857-342.286q18.286-14.857 43.429-14.857t43.429 14.857l139.429 116.571v-111.429q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v233.143l125.143 104q5.714 4.571 6.286 12.286t-4 13.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home"
					],
					"defaultCode": 61461,
					"grid": 14
				},
				{
					"id": 95,
					"paths": [
						"M1017.382 622.826l-452.050-499.634c-14.051-15.533-32.992-24.086-53.333-24.086-0.002 0 0 0 0 0-20.339 0-39.282 8.555-53.334 24.086l-452.050 499.634c-9.485 10.485-8.675 26.674 1.808 36.158 4.899 4.432 11.043 6.616 17.168 6.616 6.982 0 13.938-2.838 18.992-8.426l109.016-120.491v410.517c0 42.347 34.453 76.8 76.8 76.8h563.2c42.347 0 76.8-34.453 76.8-76.8v-410.517l109.018 120.493c9.485 10.483 25.674 11.296 36.158 1.808 10.483-9.485 11.293-25.675 1.806-36.158zM614.4 972.8h-204.8v-230.4c0-14.115 11.485-25.6 25.6-25.6h153.6c14.115 0 25.6 11.485 25.6 25.6v230.4zM819.2 947.2c0 14.115-11.485 25.6-25.6 25.6h-128v-230.4c0-42.349-34.451-76.8-76.8-76.8h-153.6c-42.347 0-76.8 34.451-76.8 76.8v230.4h-128c-14.115 0-25.6-11.485-25.6-25.6v-467.106l291.832-322.552c4.222-4.667 9.68-7.237 15.368-7.237s11.146 2.57 15.366 7.235l291.834 322.552v467.107z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"building",
						"house"
					],
					"defaultCode": 59392,
					"grid": 20
				},
				{
					"id": 571,
					"width": 1024,
					"paths": [
						"M448 672h-128c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM448 832h-128v-128h128v128zM448 416h-128c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM448 576h-128v-128h128v128zM704 416h-128c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM704 576h-128v-128h128v128zM828.8 323.2l-296.512-242.624c-5.92-4.832-13.088-7.232-20.288-7.232s-14.368 2.4-20.256 7.232l-107.744 88.16v-72.736c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v203.648l-28.8 23.552c-22.272 18.24-35.2 45.504-35.2 74.304v498.496c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-498.496c0-28.8-12.928-56.064-35.2-74.304zM256 96h96v98.912l-96 78.528v-177.44zM576 960v-256h128v256h-128zM832 896c0 35.296-28.704 64-64 64h-32v-256c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v256h-288c-35.296 0-64-28.704-64-64v-498.496c0-19.264 8.544-37.344 23.488-49.536l296.512-242.624 296.512 242.624c14.944 12.192 23.488 30.24 23.488 49.536v498.496z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"live",
						"accommodate",
						"stay"
					],
					"grid": 32
				},
				{
					"id": 572,
					"width": 1024,
					"paths": [
						"M576 704h128v288h-128v-288zM320 576h128v-128h-128v128zM320 832h128v-128h-128v128zM576 576h128v-128h-128v128zM864 397.504v498.496c0 53.024-42.976 96-96 96h-32v-288c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v288h-288c-53.024 0-96-42.976-96-96v-498.496c0-28.8 12.928-56.064 35.2-74.304l28.8-23.552v-203.648c0-17.664 14.336-32 32-32h96c17.664 0 32 14.336 32 32v72.736l107.744-88.16c5.888-4.832 13.056-7.232 20.256-7.232s14.368 2.4 20.256 7.232l296.544 242.624c22.272 18.24 35.2 45.504 35.2 74.304zM480 704c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-128zM480 448c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-128zM736 448c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"live",
						"accommodate",
						"stay"
					],
					"grid": 32
				},
				{
					"id": 1046,
					"width": 1024,
					"paths": [
						"M965.184 424.704l-133.184-125.28v-203.424c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v22.88l-104.544-98.304c-6.144-5.792-14.048-8.704-21.92-8.704-7.84 0-15.712 2.88-21.856 8.608l-432.416 404.128c-21.216 19.84-7.2 55.392 21.856 55.392h14.88v512c0 17.664 14.336 32 32 32h768c17.664 0 32-14.336 32-32v-512h15.264c28.992 0 43.040-35.456 21.92-55.296zM768 128v155.168l-64-60.192v-94.976h64zM513.472 87.712l349.056 328.288h-700.32l351.264-328.288zM416 960h-128v-288h128v288zM864 960h-416v-320h-192v320h-96v-512h704v512zM768 640h-192v192h192v-192zM736 800h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"locate",
						"dwell"
					],
					"grid": 32
				},
				{
					"id": 1814,
					"paths": [
						"M1024 590.444l-512-397.426-512 397.428v-162.038l512-397.426 512 397.428zM896 576v384h-256v-256h-256v256h-256v-384l384-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"house"
					],
					"defaultCode": 59649,
					"grid": 16
				},
				{
					"id": 1815,
					"paths": [
						"M512 32l-512 512 96 96 96-96v416h256v-192h128v192h256v-416l96 96 96-96-512-512zM512 448c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.346 0 64 28.654 64 64s-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"house"
					],
					"defaultCode": 59650,
					"grid": 16
				},
				{
					"id": 1816,
					"paths": [
						"M512 32l-512 512 96 96 96-96v416h640v-416l96 96 96-96-512-512zM512 448c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.346 0 64 28.654 64 64s-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"house"
					],
					"defaultCode": 59651,
					"grid": 16
				},
				{
					"id": 1817,
					"paths": [
						"M1024 608l-192-192v-288h-128v160l-192-192-512 512v32h128v320h320v-192h128v192h320v-320h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"house"
					],
					"defaultCode": 59652,
					"grid": 16
				},
				{
					"id": 1818,
					"paths": [
						"M512 0l-512 384v192l128-96v480c0 35.2 28.798 64 64 64h640c35.2 0 64-28.8 64-64v-480l128 96v-192l-512-384zM832 959.884c-0.036 0.040-0.076 0.082-0.118 0.116h-319.882v-320h-192v320h-127.884c-0.040-0.034-0.082-0.076-0.116-0.116v-527.884l320-240 320 240v527.884zM576 448h128v128h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"house"
					],
					"defaultCode": 59653,
					"grid": 16
				},
				{
					"id": 1819,
					"paths": [
						"M294.4 384l281.6-256h-288l-281.6 256z",
						"M0 448h256v512h-256v-512z",
						"M672 128l-352 320v512h256v-256h192v256h256v-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"house"
					],
					"defaultCode": 59654,
					"grid": 16
				},
				{
					"id": 1820,
					"paths": [
						"M1024 544l-512-512-512 512 96 96 96-96v480h256v-192h128v192h256v-480l96 96 96-96zM768 960h-128v-192h-256v192h-128v-480l256-256 256 256v480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"house"
					],
					"defaultCode": 59655,
					"grid": 16
				},
				{
					"id": 1821,
					"paths": [
						"M512 32l-512 512 96 96 96-96v480h256v-192h128v192h256v-480l96 96 96-96-512-512zM264 960h-8v-480l8-8v488zM296 960h-16v-504l16-16v520zM328 960h-16v-536l16-16v552zM360 960h-16v-568l16-16v584zM392 768h-8v192h-8v-600l16-16v424zM424 768h-16v-440l16-16v456zM456 768h-16v-472l16-16v488zM488 768h-16v-504l16-16v520zM520 768h-16v-536l8-8 8 8v536zM552 768h-16v-520l16 16v504zM584 768h-16v-488l16 16v472zM616 768h-16v-456l16 16v440zM648 960h-8v-192h-8v-424l16 16v600zM680 960h-16v-584l16 16v568zM712 960h-16v-552l16 16v536zM744 960h-16v-520l16 16v504zM768 960h-8v-488l8 8v480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"home",
						"house",
						"dualtone"
					],
					"defaultCode": 59656,
					"grid": 16
				},
				{
					"id": 1400,
					"width": 804.5709495544434,
					"paths": [
						"M219.429 749.714v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM219.429 603.429v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM365.714 603.429v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM219.429 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM658.286 749.714v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM512 603.429v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM365.714 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM658.286 603.429v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM512 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM658.286 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM512 950.857h219.429v-658.286h-146.286v18.286q0 22.857-16 38.857t-38.857 16h-256q-22.857 0-38.857-16t-16-38.857v-18.286h-146.286v658.286h219.429v-128q0-7.429 5.429-12.857t12.857-5.429h182.857q7.429 0 12.857 5.429t5.429 12.857v128zM512 274.286v-182.857q0-7.429-5.429-12.857t-12.857-5.429h-36.571q-7.429 0-12.857 5.429t-5.429 12.857v54.857h-73.143v-54.857q0-7.429-5.429-12.857t-12.857-5.429h-36.571q-7.429 0-12.857 5.429t-5.429 12.857v182.857q0 7.429 5.429 12.857t12.857 5.429h36.571q7.429 0 12.857-5.429t5.429-12.857v-54.857h73.143v54.857q0 7.429 5.429 12.857t12.857 5.429h36.571q7.429 0 12.857-5.429t5.429-12.857zM804.571 256v731.429q0 14.857-10.857 25.714t-25.714 10.857h-731.429q-14.857 0-25.714-10.857t-10.857-25.714v-731.429q0-14.857 10.857-25.714t25.714-10.857h182.857v-164.571q0-22.857 16-38.857t38.857-16h256q22.857 0 38.857 16t16 38.857v164.571h182.857q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hospital-o"
					],
					"defaultCode": 61688,
					"grid": 14
				},
				{
					"id": 2356,
					"paths": [
						"M728.992 512c137.754-87.334 231.008-255.208 231.008-448 0-21.676-1.192-43.034-3.478-64h-889.042c-2.29 20.968-3.48 42.326-3.48 64 0 192.792 93.254 360.666 231.006 448-137.752 87.334-231.006 255.208-231.006 448 0 21.676 1.19 43.034 3.478 64h889.042c2.288-20.966 3.478-42.324 3.478-64 0.002-192.792-93.252-360.666-231.006-448zM160 960c0-186.912 80.162-345.414 224-397.708v-100.586c-143.838-52.29-224-210.792-224-397.706v0h704c0 186.914-80.162 345.416-224 397.706v100.586c143.838 52.294 224 210.796 224 397.708h-704zM619.626 669.594c-71.654-40.644-75.608-93.368-75.626-125.366v-64.228c0-31.994 3.804-84.914 75.744-125.664 38.504-22.364 71.808-56.348 97.048-98.336h-409.582c25.266 42.032 58.612 76.042 97.166 98.406 71.654 40.644 75.606 93.366 75.626 125.366v64.228c0 31.992-3.804 84.914-75.744 125.664-72.622 42.18-126.738 125.684-143.090 226.336h501.67c-16.364-100.708-70.53-184.248-143.212-226.406z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hour-glass",
						"loading",
						"busy",
						"wait"
					],
					"defaultCode": 60191,
					"grid": 16
				},
				{
					"id": 2357,
					"paths": [
						"M693.656 628.76c-74.802-48.688-117.656-76.002-117.656-116.76 0-40.756 42.854-68.072 117.652-116.758 120.458-75.684 202.348-224.29 202.348-395.242h-768c0 170.952 81.89 319.558 202.348 395.242 74.798 48.686 117.652 76.002 117.652 116.758 0 40.758-42.854 68.072-117.658 116.76-120.454 75.686-202.342 224.29-202.342 395.24h768c0-170.95-81.886-319.554-202.344-395.24zM259.63 193.82c-17.552-33.584-30.31-70.22-37.936-108.488h580.612c-7.626 38.268-20.382 74.904-37.938 108.488-11.786 22.552-25.534 43.388-40.932 62.18h-422.874c-15.398-18.792-29.146-39.628-40.932-62.18zM496 765.62c0 43.56-176 109.046-176 173.046h-98.306c7.626-38.266 20.382-74.9 37.934-108.484 28.616-54.752 68.766-99.418 116.114-129.166l0.578-0.364 0.572-0.374 3.088-2.010c46.71-30.398 88.058-57.322 116.020-89.532v156.884zM802.308 938.666h-98.308c0-64-176-129.486-176-173.046v-156.88c27.96 32.208 69.308 59.132 116.020 89.532l3.66 2.384 0.578 0.364c47.348 29.748 87.498 74.414 116.114 129.166 17.552 33.58 30.31 70.214 37.936 108.48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hour-glass",
						"loading",
						"busy",
						"wait"
					],
					"defaultCode": 60192,
					"grid": 16
				},
				{
					"id": 2358,
					"paths": [
						"M380.080 610.046c-95.378 51.858-165.792 158.21-183.652 285.956h631.14c-17.858-127.742-88.274-234.098-183.648-285.956-67.906-48.28-67.92-71.398-67.92-98.046s0.014-49.764 67.918-98.046c95.376-51.856 165.792-158.21 183.65-285.954h-631.14c17.86 127.742 88.276 234.098 183.652 285.954 67.904 48.282 67.92 71.398 67.92 98.046s-0.016 49.766-67.92 98.046zM128 960.002h768v63.998h-768zM128 0h768v64h-768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hour-glass",
						"loading",
						"busy",
						"wait"
					],
					"defaultCode": 60193,
					"grid": 16
				},
				{
					"id": 1722,
					"width": 877.715048789978,
					"paths": [
						"M859.429 914.286q8 0 13.143 5.143t5.143 13.143v73.143q0 8-5.143 13.143t-13.143 5.143h-841.143q-8 0-13.143-5.143t-5.143-13.143v-73.143q0-8 5.143-13.143t13.143-5.143h841.143zM74.286 877.714q1.714-31.429 9.143-61.143t17.143-54.286 26.286-49.714 30.571-43.429 36.857-39.714 37.714-34.286 40.286-31.429 38-27.143 37.143-24.571q-24.571-16-37.143-24.571t-38-27.143-40.286-31.429-37.714-34.286-36.857-39.714-30.571-43.429-26.286-49.714-17.143-54.286-9.143-61.143h729.143q-1.714 31.429-9.143 61.143t-17.143 54.286-26.286 49.714-30.571 43.429-36.857 39.714-37.714 34.286-40.286 31.429-38 27.143-37.143 24.571q24.571 16 37.143 24.571t38 27.143 40.286 31.429 37.714 34.286 36.857 39.714 30.571 43.429 26.286 49.714 17.143 54.286 9.143 61.143h-729.143zM859.429 0q8 0 13.143 5.143t5.143 13.143v73.143q0 8-5.143 13.143t-13.143 5.143h-841.143q-8 0-13.143-5.143t-5.143-13.143v-73.143q0-8 5.143-13.143t13.143-5.143h841.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hourglass"
					],
					"defaultCode": 62036,
					"grid": 14
				},
				{
					"id": 1719,
					"width": 877.7129735946655,
					"paths": [
						"M804.571 73.143q0 149.143-60.857 263.714t-152.286 175.143q91.429 60.571 152.286 175.143t60.857 263.714h54.857q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-841.143q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h54.857q0-149.143 60.857-263.714t152.286-175.143q-91.429-60.571-152.286-175.143t-60.857-263.714h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h841.143q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857zM731.429 73.143h-585.143q0 37.714 5.143 73.143h574.857q5.143-34.857 5.143-73.143zM731.429 950.857q0-74.286-19.429-142.571t-51.714-118.857-72.286-86.857-83.429-54h-131.429q-43.429 17.714-83.429 54t-72.286 86.857-51.714 118.857-19.429 142.571h585.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hourglass-1",
						"hourglass-start"
					],
					"defaultCode": 62033,
					"grid": 14
				},
				{
					"id": 1720,
					"width": 877.7129735946655,
					"paths": [
						"M804.571 73.143q0 149.143-60.857 263.714t-152.286 175.143q91.429 60.571 152.286 175.143t60.857 263.714h54.857q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-841.143q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h54.857q0-149.143 60.857-263.714t152.286-175.143q-91.429-60.571-152.286-175.143t-60.857-263.714h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h841.143q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857zM731.429 73.143h-585.143q0 117.714 48.571 219.429h488q48.571-101.714 48.571-219.429zM698.857 768q-30.857-80.571-83.143-138t-111.143-81.429h-131.429q-58.857 24-111.143 81.429t-83.143 138h520z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hourglass-2",
						"hourglass-half"
					],
					"defaultCode": 62034,
					"grid": 14
				},
				{
					"id": 1721,
					"width": 877.7129735946655,
					"paths": [
						"M804.571 73.143q0 149.143-60.857 263.714t-152.286 175.143q91.429 60.571 152.286 175.143t60.857 263.714h54.857q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-841.143q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h54.857q0-149.143 60.857-263.714t152.286-175.143q-91.429-60.571-152.286-175.143t-60.857-263.714h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h841.143q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857zM499.429 477.714q44-16.571 85.143-52.857t74-87.143 52.857-120 20-144.571h-585.143q0 75.429 20 144.571t52.857 120 74 87.143 85.143 52.857q10.857 4 17.429 13.429t6.571 20.857-6.571 20.857-17.429 13.429q-78.286 29.143-139.429 112h400q-61.143-82.857-139.429-112-10.857-4-17.429-13.429t-6.571-20.857 6.571-20.857 17.429-13.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hourglass-3",
						"hourglass-end"
					],
					"defaultCode": 62035,
					"grid": 14
				},
				{
					"id": 1718,
					"width": 877.7129735946655,
					"paths": [
						"M804.571 73.143q0 149.143-60.857 263.714t-152.286 175.143q91.429 60.571 152.286 175.143t60.857 263.714h54.857q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-841.143q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h54.857q0-149.143 60.857-263.714t152.286-175.143q-91.429-60.571-152.286-175.143t-60.857-263.714h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h841.143q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857zM499.429 477.714q44-16.571 85.143-52.857t74-87.143 52.857-120 20-144.571h-585.143q0 75.429 20 144.571t52.857 120 74 87.143 85.143 52.857q10.857 4 17.429 13.429t6.571 20.857-6.571 20.857-17.429 13.429q-44 16.571-85.143 52.857t-74 87.143-52.857 120-20 144.571h585.143q0-75.429-20-144.571t-52.857-120-74-87.143-85.143-52.857q-10.857-4-17.429-13.429t-6.571-20.857 6.571-20.857 17.429-13.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hourglass-o"
					],
					"defaultCode": 62032,
					"grid": 14
				},
				{
					"id": 190,
					"paths": [
						"M819.2 179.2v-25.6c0-20.061-12.354-37.533-36.715-51.933-17.598-10.402-42.042-19.557-72.651-27.21-59.995-14.997-139.344-23.258-223.434-23.258-84.088 0-163.438 8.261-223.432 23.259-30.61 7.653-55.053 16.806-72.653 27.21-24.362 14.398-36.715 31.87-36.715 51.931v25.6c0 134.691 81.574 255.944 204.795 307.288v102.222c-123.221 51.346-204.795 172.598-204.795 307.29v25.6c0 20.059 12.354 37.533 36.715 51.933 17.6 10.402 42.043 19.557 72.653 27.21 59.994 14.998 139.344 23.258 223.432 23.258 84.090 0 163.438-8.259 223.434-23.258 30.61-7.653 55.053-16.808 72.651-27.21 24.362-14.4 36.715-31.874 36.715-51.933v-25.6c0-134.691-81.573-255.944-204.794-307.29v-102.222c123.221-51.344 204.794-172.597 204.794-307.288zM287.322 121.309c54.56-12.194 125.261-18.909 199.078-18.909 73.819 0 144.52 6.715 199.080 18.909 58.867 13.157 76.701 27.336 81.366 32.291-4.666 4.955-22.499 19.134-81.366 32.291-54.56 12.194-125.261 18.909-199.080 18.909-73.818 0-144.518-6.715-199.078-18.909-58.869-13.157-76.702-27.336-81.37-32.291 4.667-4.955 22.501-19.134 81.37-32.291zM580.275 630.418c112.285 39.69 187.725 146.419 187.725 265.582v24.238c-2.141 2.909-16.598 18.92-82.52 33.653-54.56 12.194-125.261 18.909-199.080 18.909-73.818 0-144.52-6.715-199.078-18.907-65.915-14.731-80.378-30.741-82.522-33.653v-24.24c0-119.163 75.442-225.893 187.726-265.582 10.229-3.616 17.067-13.286 17.067-24.136v-137.363c0-10.85-6.838-20.522-17.069-24.136-101.195-35.768-172.453-125.992-185.544-230.693 15.342 6.923 34.075 13.174 55.986 18.653 59.995 14.997 139.346 23.258 223.434 23.258 84.090 0 163.438-8.261 223.434-23.259 21.91-5.477 40.642-11.73 55.986-18.653-13.093 104.699-84.35 194.923-185.544 230.693-10.23 3.616-17.069 13.288-17.069 24.136v137.363c0 10.851 6.838 20.522 17.069 24.138z",
						"M699.734 846.264c-115.798-40.933-187.734-139.586-187.734-257.464v-154.872c30.741-3.022 60.315-11.496 88.202-25.355 12.661-6.293 17.824-21.658 11.531-34.318s-21.658-17.826-34.318-11.531c-28.408 14.118-59.030 21.277-91.014 21.277s-62.605-7.158-91.013-21.278c-12.659-6.29-28.026-1.13-34.318 11.531s-1.13 28.026 11.531 34.318c27.885 13.859 57.461 22.333 88.2 25.355v154.874c0 117.878-71.936 216.531-187.734 257.464-10.762 3.803-17.706 14.272-17.022 25.666 0.682 11.394 8.826 20.96 19.963 23.453 50.294 11.254 126.824 26.218 210.394 26.218s160.099-14.963 210.394-26.218c11.139-2.494 19.282-12.059 19.965-23.453 0.68-11.394-6.261-21.862-17.024-25.666zM486.4 870.4c-44.885 0-87.093-4.464-124.762-10.478 34.070-21.573 63.706-48.766 87.586-80.626 15.019-20.035 27.45-41.557 37.174-64.211 9.726 22.654 22.155 44.174 37.174 64.211 23.88 31.858 53.515 59.051 87.586 80.626-37.666 6.014-79.874 10.478-124.758 10.478z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hourglass",
						"loading"
					],
					"defaultCode": 59487,
					"grid": 20
				},
				{
					"id": 1760,
					"width": 585.1420288085938,
					"paths": [
						"M292.571 680.571l292.571-168.571v337.714l-292.571 169.143v-338.286zM0 512v337.714l292.571-169.143zM292.571 5.143v337.714l-292.571 169.143v-337.714zM292.571 342.857l292.571-168.571v337.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"houzz"
					],
					"defaultCode": 62076,
					"grid": 14
				},
				{
					"id": 3416,
					"paths": [
						"M60.538 0l82.144 921.63 368.756 102.37 369.724-102.524 82.3-921.476h-902.924zM784.63 301.428h-432.54l10.302 115.75h411.968l-31.042 347.010-231.844 64.254-231.572-64.254-15.83-177.512h113.494l8.048 90.232 125.862 33.916 0.278-0.078 125.934-33.992 13.070-146.55h-391.74l-30.494-341.8h566.214l-10.108 113.024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"html-five",
						"w3c"
					],
					"defaultCode": 61251,
					"grid": 16
				},
				{
					"id": 3417,
					"paths": [
						"M60.538 0l82.144 921.63 368.756 102.37 369.724-102.524 82.3-921.476h-902.924zM810.762 862.824l-297.226 82.376v0.466l-0.776-0.234-0.782 0.234v-0.466l-297.222-82.376-70.242-787.486h736.496l-70.248 787.486zM650.754 530.204l-13.070 146.552-126.21 34.070-125.862-33.916-8.050-90.234h-113.49l15.83 177.512 232.076 64.176 231.342-64.176 31.040-347.012h-411.966l-10.302-115.748h432.534l10.112-113.026h-566.218l30.498 341.802z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"html-five",
						"w3c"
					],
					"defaultCode": 61252,
					"grid": 16
				},
				{
					"id": 1461,
					"width": 804.5709838867188,
					"paths": [
						"M645.714 341.143l9.143-100h-505.143l26.857 305.143h349.714l-12.571 130.286-112.571 30.286-112-30.286-7.429-80h-100l12.571 158.857 206.857 57.143h2.286v-0.571l205.143-56.571 28.571-310.857h-368l-8.571-103.429h385.143zM0 73.143h804.571l-73.143 821.714-330.286 92.571-328-92.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"html5"
					],
					"defaultCode": 61755,
					"grid": 14
				},
				{
					"id": 573,
					"width": 1024,
					"paths": [
						"M512 192c-314.336 0-457.12 235.872-498.592 321.44-9.408 19.424-8.256 42.112 3.008 60.544 45.088 73.76 188.448 258.016 495.584 258.016s450.496-184.256 495.584-258.016c11.264-18.432 12.416-41.12 3.008-60.544-41.472-85.568-184.256-321.44-498.592-321.44zM671.488 248.128c61.408 48.992 96.512 121.536 96.512 199.872 0 141.152-114.848 256-256 256s-256-114.848-256-256c0-78.272 35.072-150.752 96.384-199.744 14.272-4.608 29.216-8.448 44.608-11.84 4.512-0.992 9.12-1.76 13.696-2.624 11.36-2.176 22.976-4 34.944-5.472 5.12-0.608 10.24-1.248 15.424-1.728 9.056-0.832 18.592-1.024 27.968-1.408-112.928 11.52-201.024 106.88-201.024 222.816 0 123.712 100.288 224 224 224s224-100.288 224-224c0-121.344-96.544-219.904-216.96-223.648 14.88 0.192 29.344 0.928 43.392 2.176 6.24 0.576 12.384 1.312 18.56 2.080 9.408 1.152 18.528 2.656 27.584 4.256 7.584 1.376 15.232 2.624 22.72 4.352 4.64 1.056 9.024 2.4 13.568 3.584 8.896 2.304 17.888 4.544 26.624 7.328zM704 448c0 105.856-86.144 192-192 192s-192-86.144-192-192 86.144-192 192-192 192 86.144 192 192zM512 800c-293.792 0-427.488-174.464-468.48-242.56-5.504-9.152-5.984-20.32-1.28-29.92 26.592-54.4 98.976-176.672 237.056-248.288-39.84 54.592-61.248 123.456-53.824 197.856 13.28 133.536 121.216 242.848 254.624 257.184 173.344 18.656 319.904-116.704 319.904-286.272 0-64.032-21.312-122.752-56.768-170.432 140.448 71.264 212.512 194.816 238.848 249.92 4.576 9.536 4.064 20.544-1.408 29.632-40.832 67.968-174.464 242.88-468.672 242.88zM512 608c88.352 0 160-71.648 160-160s-71.648-160-160-160-160 71.648-160 160 71.648 160 160 160zM512 320c70.592 0 128 57.408 128 128s-57.408 128-128 128-128-57.408-128-128 57.408-128 128-128zM512 544c53.024 0 96-42.976 96-96s-42.976-96-96-96-96 42.976-96 96 42.976 96 96 96zM512 384c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64 28.704-64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hypnotize",
						"control",
						"mesmerize"
					],
					"grid": 32
				},
				{
					"id": 574,
					"width": 1024,
					"paths": [
						"M512 576c70.592 0 128-57.408 128-128s-57.408-128-128-128-128 57.408-128 128 57.408 128 128 128zM512 352c53.024 0 96 42.976 96 96s-42.976 96-96 96-96-42.976-96-96 42.976-96 96-96zM448 448c0-35.296 28.704-64 64-64s64 28.704 64 64-28.704 64-64 64-64-28.704-64-64zM512 640c105.856 0 192-86.144 192-192s-86.144-192-192-192-192 86.144-192 192 86.144 192 192 192zM512 288c88.352 0 160 71.648 160 160s-71.648 160-160 160-160-71.648-160-160 71.648-160 160-160zM256 448c0 141.152 114.848 256 256 256s256-114.848 256-256c0-140.992-114.56-255.68-255.488-255.968-0.16 0-0.32-0.032-0.512-0.032s-0.352 0.032-0.512 0.032c-140.928 0.288-255.488 114.976-255.488 255.968zM512 224c123.712 0 224 100.288 224 224s-100.288 224-224 224c-123.712 0-224-100.288-224-224s100.288-224 224-224zM1007.584 573.984c-45.088 73.76-188.448 258.016-495.584 258.016s-450.496-184.256-495.584-258.016c-11.264-18.432-12.416-41.12-3.008-60.544 32.768-67.616 129.184-228.608 323.072-293.408-68.288 52.672-112.48 135.072-112.48 227.968 0 159.072 128.928 288 288 288s288-128.928 288-288c0-92.896-44.192-175.296-112.48-227.968 193.888 64.8 290.304 225.792 323.072 293.408 9.408 19.456 8.256 42.112-3.008 60.544z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"hypnotize",
						"control",
						"mesmerize"
					],
					"grid": 32
				},
				{
					"id": 1709,
					"width": 512,
					"paths": [
						"M475.429 73.143q-182.857 0-182.857 128v237.714h73.143v73.143h-73.143v310.857q0 128 182.857 128h36.571v73.143h-36.571q-155.429 0-219.429-83.429-64 83.429-219.429 83.429h-36.571v-73.143h36.571q182.857 0 182.857-128v-310.857h-73.143v-73.143h73.143v-237.714q0-128-182.857-128h-36.571v-73.143h36.571q155.429 0 219.429 83.429 64-83.429 219.429-83.429h36.571v73.143h-36.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"i-cursor"
					],
					"defaultCode": 62022,
					"grid": 14
				},
				{
					"id": 2523,
					"paths": [
						"M832 416c0-87.106-50.71-165.826-128.254-202.516-5.512-118.65-103.758-213.484-223.746-213.484-120.002 0-218.256 94.856-223.748 213.524-75.746 35.964-128.252 113.2-128.252 202.476 0 92.552 56.424 172.174 136.68 206.276l186.542 383.714c5.356 11.018 16.53 18.010 28.78 18.010s23.424-6.992 28.78-18.010l186.542-383.714c80.252-34.104 136.676-113.724 136.676-206.276zM608 576h-256c-88.224 0-160-71.776-160-160s71.776-160 160-160c18.316 0 36.26 3.060 53.338 9.098 16.664 5.886 34.946-2.844 40.836-19.506 5.89-16.664-2.844-34.946-19.506-40.836-23.946-8.464-49.068-12.756-74.668-12.756-9.868 0-19.584 0.648-29.12 1.892 14.132-73.876 79.19-129.892 157.12-129.892 88.224 0 160 71.776 160 160 0 39.434-14.468 77.316-40.742 106.666-11.788 13.168-10.668 33.398 2.5 45.186 6.108 5.466 13.734 8.158 21.332 8.158 8.786 0 17.534-3.596 23.856-10.658 23.502-26.256 40.246-57.386 49.286-90.838 44.034 29.174 71.768 79.036 71.768 133.486 0 88.224-71.774 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"icecream",
						"dessert"
					],
					"defaultCode": 60358,
					"grid": 16
				},
				{
					"id": 575,
					"width": 1024,
					"paths": [
						"M423.008 482.784l-1.568-0.768c16.352-17.248 26.56-40.384 26.56-66.016 0-53.024-42.976-96-96-96s-96 42.976-96 96c0 25.632 10.208 48.768 26.56 65.984l-1.568 0.768c-35.616 23.776-56.992 63.744-56.992 106.528v82.72c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-82.72c0-42.784-21.376-82.752-56.992-106.496zM352 352c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64c0-35.296 28.704-64 64-64zM448 672h-192v-82.72c0-31.552 15.36-60.896 41.216-78.848l14.816-7.392c12.192 5.632 25.664 8.96 39.968 8.96s27.776-3.328 39.968-8.96l14.816 7.392c25.856 17.952 41.216 47.296 41.216 78.848v82.72zM896 160h-768c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-512c0-53.024-42.976-96-96-96zM960 768c0 35.296-28.704 64-64 64h-768c-35.296 0-64-28.704-64-64v-512c0-35.296 28.704-64 64-64h768c35.296 0 64 28.704 64 64v512zM800 528c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM800 592c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM800 464c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"identify",
						"be"
					],
					"grid": 32
				},
				{
					"id": 576,
					"width": 1024,
					"paths": [
						"M448 589.28v82.72h-192v-82.72c0-31.552 15.36-60.896 41.216-78.848l14.816-7.392c12.192 5.632 25.664 8.96 39.968 8.96s27.776-3.328 39.968-8.96l14.816 7.392c25.856 17.952 41.216 47.296 41.216 78.848zM352 480c35.296 0 64-28.704 64-64s-28.704-64-64-64-64 28.704-64 64c0 35.296 28.704 64 64 64zM992 256v512c0 53.024-42.976 96-96 96h-768c-53.024 0-96-42.976-96-96v-512c0-53.024 42.976-96 96-96h768c53.024 0 96 42.976 96 96zM480 589.28c0-42.784-21.376-82.752-56.992-106.496l-1.568-0.768c16.352-17.248 26.56-40.384 26.56-66.016 0-53.024-42.976-96-96-96s-96 42.976-96 96c0 25.632 10.208 48.768 26.56 65.984l-1.568 0.768c-35.616 23.776-56.992 63.744-56.992 106.528v82.72c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-82.72zM800 592c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16zM800 528c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16zM800 464c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"identify",
						"be"
					],
					"grid": 32
				},
				{
					"id": 1047,
					"width": 1024,
					"paths": [
						"M895.040 600.224l-128-512c-3.552-14.24-16.352-24.224-31.040-24.224h-128v-32c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v32h-128c-14.688 0-27.488 9.984-31.040 24.224l-128 512c-2.4 9.568-0.256 19.68 5.824 27.456 6.048 7.776 15.36 12.32 25.216 12.32h256v224h-192c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-192v-224h256c9.856 0 19.168-4.544 25.216-12.32 6.080-7.744 8.224-17.888 5.824-27.456zM768 960h-512v-32h512v32zM451.072 576l41.984-448h37.856l41.984 448h-121.824zM544 608v288h-64v-288h64zM480 96v-32h64v32h-64zM563.072 128h50.656l84 448h-92.64l-42.016-448zM418.912 576h-92.64l84-448h50.656l-42.016 448zM377.728 128l-84 448h-92.736l112-448h64.736zM730.272 576l-84-448h64.736l112 448h-92.736z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"illuminate",
						"light",
						"shine",
						"glow"
					],
					"grid": 32
				},
				{
					"id": 1656,
					"width": 786.2850255966187,
					"paths": [
						"M566.857 356.571v283.429q0 8-5.143 13.143t-13.143 5.143h-91.429q-8 0-13.143-5.143t-5.143-13.143v-283.429q0-64-45.714-109.714t-109.714-45.714h-155.429v658.286q0 8-5.143 13.143t-13.143 5.143h-91.429q-8 0-13.143-5.143t-5.143-13.143v-768q0-8 5.143-13.143t13.143-5.143h265.143q77.143 0 142.286 38t103.143 103.143 38 142.286zM786.286 91.429v502.857q0 77.143-38 142.286t-103.143 103.143-142.286 38h-265.143q-8 0-13.143-5.143t-5.143-13.143v-548.571q0-8 5.143-13.143t13.143-5.143h91.429q8 0 13.143 5.143t5.143 13.143v438.857h155.429q64 0 109.714-45.714t45.714-109.714v-502.857q0-8 5.143-13.143t13.143-5.143h91.429q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ils",
						"shekel",
						"sheqel"
					],
					"defaultCode": 61963,
					"grid": 14
				},
				{
					"id": 1872,
					"paths": [
						"M960 64h-896c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64zM736 192c53.020 0 96 42.982 96 96s-42.98 96-96 96-96-42.982-96-96 42.98-96 96-96zM896 832h-768v-128l224-384 256 320h64l224-192v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"image",
						"picture",
						"photo",
						"graphic"
					],
					"defaultCode": 59707,
					"grid": 16
				},
				{
					"id": 1874,
					"paths": [
						"M832 352c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M0 192v640c0 35.2 28.798 64 64 64h384v-63.998h-383.886c-0.040-0.034-0.082-0.076-0.114-0.116v-639.772c0.034-0.040 0.076-0.082 0.114-0.114h383.886v-64h-384c-35.2 0-64 28.8-64 64z",
						"M960 128h-384v-128h-64v1024h64v-128h384c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64zM960 831.886c-0.036 0.040-0.076 0.082-0.118 0.116h-383.882v-64.002h320v-320l-224 192h-64l-32-40v-408h383.882c0.042 0.034 0.082 0.076 0.118 0.116v639.77z",
						"M128 704v64h320v-328l-96-120z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"image-compare",
						"diff"
					],
					"defaultCode": 59709,
					"grid": 16
				},
				{
					"id": 1873,
					"paths": [
						"M959.884 128c0.040 0.034 0.082 0.076 0.116 0.116v767.77c-0.034 0.040-0.076 0.082-0.116 0.116h-895.77c-0.040-0.034-0.082-0.076-0.114-0.116v-767.772c0.034-0.040 0.076-0.082 0.114-0.114h895.77zM960 64h-896c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64v0z",
						"M832 288c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.98 96 96z",
						"M896 832h-768v-128l224-384 256 320h64l224-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"image",
						"picture",
						"photo",
						"graphic"
					],
					"defaultCode": 59708,
					"grid": 16
				},
				{
					"id": 1876,
					"paths": [
						"M0 64v960h1024v-960h-1024zM896 768h-768v-576h768v576zM832 576l-64-128-128 128-192-320-256 384v64h640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"image",
						"picture",
						"photo",
						"graphic",
						"polaroid"
					],
					"defaultCode": 59711,
					"grid": 16
				},
				{
					"id": 1878,
					"paths": [
						"M864 384l-224 224-192-192-320 320v96h768v-448z",
						"M928 128c17.346 0 32 14.654 32 32v704c0 17.346-14.654 32-32 32h-832c-17.346 0-32-14.654-32-32v-704c0-17.346 14.654-32 32-32h832zM928 64h-832c-52.8 0-96 43.2-96 96v704c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-704c0-52.8-43.2-96-96-96v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"image",
						"picture",
						"photo",
						"graphic"
					],
					"defaultCode": 59713,
					"grid": 16
				},
				{
					"id": 1879,
					"paths": [
						"M896 192v640h-768v-640h768zM928 64h-832c-52.8 0-96 43.2-96 96v704c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-704c0-52.8-43.2-96-96-96v0z",
						"M640 608l-192-192-256 256v96h640v-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"image",
						"picture",
						"photo",
						"graphic"
					],
					"defaultCode": 59714,
					"grid": 16
				},
				{
					"id": 1880,
					"paths": [
						"M1020.94 136h-1017.88c-1.346 5.178-2.242 10.53-2.698 16h1023.278c-0.458-5.47-1.356-10.822-2.7-16z",
						"M966.214 72h-908.424c-9.192 4.022-17.638 9.448-25.078 16h958.578c-7.44-6.552-15.882-11.978-25.076-16z",
						"M1005.822 104h-987.644c-3.614 4.998-6.754 10.352-9.366 16h1006.376c-2.612-5.648-5.754-11.002-9.366-16z",
						"M57.788 952h908.422c9.194-4.024 17.634-9.45 25.074-16h-958.574c7.44 6.55 15.884 11.976 25.078 16z",
						"M18.18 920h987.644c3.614-4.998 6.754-10.352 9.366-16h-1006.378c2.612 5.648 5.754 11.002 9.368 16z",
						"M1024 184v-16h-1024v16h8v656h-8v16h1024v-16h-8v-656h8zM88 184h16v656h-16v-656zM72 840h-16v-656h16v656zM120 184h784v656h-784v-656zM920 184h16v656h-16v-656zM952 184h16v656h-16v-656zM24 184h16v656h-16v-656zM1000 840h-16v-656h16v656z",
						"M3.060 888h1017.882c1.348-5.178 2.24-10.53 2.702-16h-1023.282c0.458 5.47 1.352 10.822 2.698 16z",
						"M864 384l-224 224-192-192-320 320v96h768v-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"image",
						"picture",
						"photo",
						"graphic",
						"dualtone"
					],
					"defaultCode": 59715,
					"grid": 16
				},
				{
					"id": 1238,
					"width": 1097.1438789367676,
					"paths": [
						"M365.714 329.143q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM950.857 548.571v256h-804.571v-109.714l182.857-182.857 91.429 91.429 292.571-292.571zM1005.714 146.286h-914.286q-7.429 0-12.857 5.429t-5.429 12.857v694.857q0 7.429 5.429 12.857t12.857 5.429h914.286q7.429 0 12.857-5.429t5.429-12.857v-694.857q0-7.429-5.429-12.857t-12.857-5.429zM1097.143 164.571v694.857q0 37.714-26.857 64.571t-64.571 26.857h-914.286q-37.714 0-64.571-26.857t-26.857-64.571v-694.857q0-37.714 26.857-64.571t64.571-26.857h914.286q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"image",
						"photo",
						"picture-o"
					],
					"defaultCode": 61502,
					"grid": 14
				},
				{
					"id": 1871,
					"width": 1152,
					"paths": [
						"M1088 128h-64v-64c0-35.2-28.8-64-64-64h-896c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h64v64c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64zM128 192v640h-64v-768h896v64h-768c-35.2 0-64 28.8-64 64zM960 352c0 53.018-42.98 96-96 96s-96-42.982-96-96 42.98-96 96-96 96 42.982 96 96zM1024 896h-768v-128l224-384 256 320h64l224-192v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"images",
						"pictures",
						"photos",
						"graphic"
					],
					"defaultCode": 59706,
					"grid": 16
				},
				{
					"id": 1875,
					"width": 1152,
					"paths": [
						"M1088 128h-64v-64c0-35.2-28.8-64-64-64h-896c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h64v64c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64zM128 192v640h-63.886c-0.040-0.034-0.082-0.076-0.114-0.116v-767.77c0.034-0.040 0.076-0.082 0.114-0.114h895.77c0.040 0.034 0.082 0.076 0.116 0.116v63.884h-768c-35.2 0-64 28.8-64 64v0zM1088 959.884c-0.034 0.040-0.076 0.082-0.116 0.116h-895.77c-0.040-0.034-0.082-0.076-0.114-0.116v-767.77c0.034-0.040 0.076-0.082 0.114-0.114h895.77c0.040 0.034 0.082 0.076 0.116 0.116v767.768z",
						"M960 352c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.98 96 96z",
						"M1024 896h-768v-128l224-384 256 320h64l224-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"images",
						"pictures",
						"photos",
						"graphics"
					],
					"defaultCode": 59710,
					"grid": 16
				},
				{
					"id": 1877,
					"paths": [
						"M768 64h-768v768h768v-768zM704 640h-640v-512h640v512zM512 320l-45.714 91.428-146.286-219.428-192 384h512zM832 246.754v649.246h-711.056l-5.016 47.722 763.794 80.278 80.278-763.792z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"images",
						"pictures",
						"photos",
						"graphics",
						"polaroids"
					],
					"defaultCode": 59712,
					"grid": 16
				},
				{
					"id": 577,
					"width": 1024,
					"paths": [
						"M971.328 836.672c-6.24-6.24-16.384-6.24-22.624 0l-39.776 39.744c-28.928 28.928-66.336 45.728-106.496 49.824l54.208-759.392c4-55.584-40.032-102.848-95.744-102.848h-497.792c-55.712 0-99.712 47.264-95.744 102.848l54.24 759.424c-40.192-4.096-77.6-20.864-106.496-49.824l-39.776-39.744c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l39.776 39.744c35.552 35.584 81.824 57.248 131.52 60.928h575.904c49.696-3.68 96.064-25.344 131.648-60.928l39.776-39.744c6.24-6.272 6.24-16.384 0-22.656zM770.208 928h-516.416l-13.728-192h543.84l-13.696 192zM786.208 704h-548.416l-38.528-539.424c-1.28-17.92 4.768-35.040 16.992-48.16 12.256-13.184 28.896-20.416 46.848-20.416h497.792c17.952 0 34.592 7.232 46.848 20.384s18.272 30.24 16.992 48.16l-38.528 539.456z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"imagine",
						"wear",
						"daydream"
					],
					"grid": 32
				},
				{
					"id": 578,
					"width": 1024,
					"paths": [
						"M205.728 704l-38.368-537.152c-3.968-55.584 40.032-102.848 95.744-102.848h497.792c55.712 0 99.712 47.264 95.744 102.848l-38.368 537.152h-612.544zM219.424 896h585.152l11.424-160h-608l11.424 160zM971.328 836.672c-6.24-6.24-16.384-6.24-22.624 0l-39.776 39.744c-28.928 28.928-66.336 45.728-106.496 49.824 0 0-21.888 1.76-32.192 1.76s-504 0-516.416 0-32.192-1.76-32.192-1.76c-40.192-4.096-77.6-20.864-106.496-49.824l-39.776-39.744c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l39.776 39.744c35.52 35.616 81.792 57.28 131.488 60.96h575.904c49.696-3.68 96.064-25.344 131.648-60.928l39.776-39.744c6.24-6.272 6.24-16.384 0-22.656z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"imagine",
						"wear",
						"daydream"
					],
					"grid": 32
				},
				{
					"id": 2710,
					"paths": [
						"M448 704h128v-192h192v-128h-192v-192h-128v192h-192v128h192v192z",
						"M896 512v384h-768v-384h-128v416c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-416h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"import",
						"load",
						"add",
						"open"
					],
					"defaultCode": 60545,
					"grid": 16
				},
				{
					"id": 2711,
					"paths": [
						"M448 704h128v-192h192v-128h-192v-192h-128v192h-192v128h192z",
						"M18.178 984h987.644c3.614-4.998 6.754-10.352 9.366-16h-1006.376c2.61 5.648 5.754 11.002 9.366 16z",
						"M57.79 1016h908.422c9.194-4.024 17.638-9.45 25.078-16h-958.58c7.44 6.55 15.886 11.976 25.080 16z",
						"M3.058 952h1017.882c1.346-5.178 2.24-10.53 2.698-16h-1023.276c0.456 5.47 1.352 10.822 2.696 16z",
						"M1016 904v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-784v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-8v16h1024v-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"import",
						"load",
						"add",
						"open",
						"dualtone"
					],
					"defaultCode": 60546,
					"grid": 16
				},
				{
					"id": 1206,
					"width": 877.7170066833496,
					"paths": [
						"M584.571 548.571h180.571q-0.571-1.714-1.429-4.571t-1.429-4.571l-121.143-283.429h-404.571l-121.143 283.429q-0.571 1.143-1.429 4.571t-1.429 4.571h180.571l54.286 109.714h182.857zM877.714 565.714v275.429q0 14.857-10.857 25.714t-25.714 10.857h-804.571q-14.857 0-25.714-10.857t-10.857-25.714v-275.429q0-35.429 14.286-70.286l136-315.429q5.714-14.286 20.857-24t30-9.714h475.429q14.857 0 30 9.714t20.857 24l136 315.429q14.286 34.857 14.286 70.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"inbox"
					],
					"defaultCode": 61468,
					"grid": 14
				},
				{
					"id": 121,
					"paths": [
						"M1001.331 531.632l-138.157-315.786c-15.272-34.906-57.075-62.246-95.174-62.246h-512c-38.099 0-79.904 27.341-95.176 62.246l-138.157 315.786c-12.71 29.056-22.667 76.658-22.667 108.368v204.8c0 42.349 34.453 76.8 76.8 76.8h870.4c42.349 0 76.8-34.451 76.8-76.8v-204.8c0-31.714-9.958-79.314-22.669-108.368zM207.733 236.368c7.227-16.522 30.234-31.568 48.267-31.568h512c18.034 0 41.038 15.046 48.269 31.568l138.157 315.786c1.557 3.558 3.082 7.59 4.547 11.95-3.84-0.595-7.77-0.904-11.773-0.904h-307.2c-14.139 0-25.6 11.461-25.6 25.6v25.6c0 56.464-45.936 102.4-102.4 102.4s-102.4-45.936-102.4-102.4v-25.6c0-14.139-11.462-25.6-25.6-25.6h-307.2c-4.002 0-7.933 0.309-11.771 0.902 1.466-4.36 2.992-8.392 4.547-11.95l138.157-315.784zM972.8 844.8c0 14.115-11.485 25.6-25.6 25.6h-870.4c-14.115 0-25.6-11.485-25.6-25.6v-204.8c0-14.115 11.485-25.6 25.6-25.6h281.6c0 84.696 68.904 153.6 153.6 153.6s153.6-68.904 153.6-153.6h281.6c14.115 0 25.6 11.485 25.6 25.6v204.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"inbox",
						"drawer"
					],
					"defaultCode": 59418,
					"grid": 20
				},
				{
					"id": 1236,
					"width": 1023.9989223480225,
					"paths": [
						"M201.143 475.429q0 8-5.143 13.143l-164.571 164.571q-5.143 5.143-13.143 5.143-7.429 0-12.857-5.429t-5.429-12.857v-329.143q0-7.429 5.429-12.857t12.857-5.429q8 0 13.143 5.143l164.571 164.571q5.143 5.143 5.143 13.143zM1024 749.714v109.714q0 7.429-5.429 12.857t-12.857 5.429h-987.429q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h987.429q7.429 0 12.857 5.429t5.429 12.857zM1024 530.286v109.714q0 7.429-5.429 12.857t-12.857 5.429h-621.714q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h621.714q7.429 0 12.857 5.429t5.429 12.857zM1024 310.857v109.714q0 7.429-5.429 12.857t-12.857 5.429h-621.714q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h621.714q7.429 0 12.857 5.429t5.429 12.857zM1024 91.429v109.714q0 7.429-5.429 12.857t-12.857 5.429h-987.429q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h987.429q7.429 0 12.857 5.429t5.429 12.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"indent"
					],
					"defaultCode": 61500,
					"grid": 14
				},
				{
					"id": 3285,
					"paths": [
						"M0 64h1024v128h-1024zM384 256h640v128h-640zM384 448h640v128h-640zM384 640h640v128h-640zM0 832h1024v128h-1024zM256 320v384l-256-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"indent-decrease",
						"wysiwyg"
					],
					"defaultCode": 61120,
					"grid": 16
				},
				{
					"id": 3291,
					"paths": [
						"M0 64h1024v128h-1024zM384 576h640v128h-640zM384 320h640v128h-640zM0 832h1024v128h-1024zM256 320v384l-256-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"indent-decrease",
						"wysiwyg"
					],
					"defaultCode": 61126,
					"grid": 16
				},
				{
					"id": 253,
					"paths": [
						"M896 256h-768c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 409.6h-409.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 563.2h-409.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 716.8h-409.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 870.4h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M332.803 716.8c-5.44 0-10.846-1.731-15.363-5.12l-204.8-153.6c-6.446-4.834-10.24-12.422-10.24-20.48s3.794-15.645 10.24-20.48l204.8-153.6c7.758-5.819 18.136-6.757 26.808-2.418 8.674 4.336 14.152 13.2 14.152 22.898v307.2c0 9.698-5.478 18.562-14.152 22.898-3.621 1.81-7.542 2.702-11.445 2.702zM170.667 537.6l136.533 102.4v-204.8l-136.533 102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"indent-decrease",
						"typography"
					],
					"defaultCode": 59550,
					"grid": 20
				},
				{
					"id": 3284,
					"paths": [
						"M0 64h1024v128h-1024zM384 256h640v128h-640zM384 448h640v128h-640zM384 640h640v128h-640zM0 832h1024v128h-1024zM0 704v-384l256 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"indent-increase",
						"wysiwyg"
					],
					"defaultCode": 61119,
					"grid": 16
				},
				{
					"id": 3290,
					"paths": [
						"M0 64h1024v128h-1024zM384 576h640v128h-640zM384 320h640v128h-640zM0 832h1024v128h-1024zM0 704v-384l256 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"indent-increase",
						"wysiwyg"
					],
					"defaultCode": 61125,
					"grid": 16
				},
				{
					"id": 252,
					"paths": [
						"M896 256h-768c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 409.6h-409.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 563.2h-409.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 716.8h-409.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 870.4h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M127.997 716.8c-3.902 0-7.822-0.891-11.445-2.702-8.674-4.336-14.152-13.2-14.152-22.898v-307.2c0-9.698 5.478-18.562 14.152-22.898 8.67-4.336 19.053-3.403 26.808 2.418l204.8 153.6c6.446 4.834 10.24 12.422 10.24 20.48s-3.794 15.645-10.24 20.48l-204.8 153.6c-4.517 3.387-9.923 5.12-15.363 5.12zM153.6 435.2v204.8l136.533-102.4-136.533-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"indent-increase",
						"typography"
					],
					"defaultCode": 59549,
					"grid": 20
				},
				{
					"id": 579,
					"width": 1024,
					"paths": [
						"M627.872 451.392c-22.464 4.896-65.728 12.608-115.872 12.608s-93.408-7.712-115.872-12.608c-8.992-1.952-14.432-11.104-11.968-19.968 2.272-8.16 10.464-13.152 18.72-11.36 20.928 4.544 62.176 11.936 109.12 11.936s88.192-7.392 109.12-11.936c8.256-1.792 16.448 3.2 18.72 11.36 2.496 8.864-2.976 17.984-11.968 19.968zM992 512c0 290.144-214.912 352-480 352s-480-61.856-480-352c0-212.064 214.912-320 480-320s480 107.936 480 320zM940.256 639.616c-24.736-1.92-44.256-22.4-44.256-47.616v-16c0-17.664-14.336-32-32-32s-32 14.336-32 32v32c0 35.36-28.64 64-64 64s-64-28.64-64-64v-32c0-17.664-14.336-32-32-32s-32 14.336-32 32v0c0 17.664-14.336 32-32 32h-64c-17.664 0-32 14.336-32 32v16c0 26.496-21.504 48-48 48s-48-21.504-48-48v-48c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 35.36-28.64 64-64 64h-32c-35.36 0-64-28.672-64-64v-32c0-17.664-14.336-32-32-32v0c-17.664 0-32 14.336-32 32v16c0 25.216-19.52 45.696-44.256 47.616 47.168 133.28 182.24 192.384 428.256 192.384s381.088-59.104 428.256-192.384zM950.88 601.984c5.888-27.424 9.12-57.152 9.12-89.984 0-212.576-241.344-288-448-288s-448 75.424-448 288c0 35.392 3.744 67.232 10.592 96.352l0.672-1.184c1.44 0.416 2.944 0.832 4.736 0.832 8.832 0 16-7.168 16-16v-16c0-35.296 28.704-64 64-64 17.088 0 33.184 6.656 45.248 18.752 12.096 12.096 18.752 28.16 18.752 45.248v32c0 8.544 3.328 16.576 9.376 22.624s14.080 9.376 22.624 9.376h32c17.632 0 32-14.368 32-32 0-35.296 28.704-64 64-64s64 28.704 64 64v48c0 8.832 7.168 16 16 16s16-7.168 16-16v-16c0-35.296 28.704-64 64-64h64c0-35.296 28.704-64 64-64s64 28.704 64 64v32c0 17.632 14.368 32 32 32s32-14.368 32-32v-32c0-35.296 28.704-64 64-64s64 28.704 64 64v16c0 8.832 7.168 16 16 16 2.144 0 4-0.416 5.6-1.024 0.48-1.984 0.608-4.128 1.056-6.144l0.224 1.152z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"indulge",
						"eat",
						"consume"
					],
					"grid": 32
				},
				{
					"id": 580,
					"width": 1024,
					"paths": [
						"M80 608c8.8 0 16-7.2 16-16v-16c0-35.296 28.704-64 64-64s64 28.704 64 64v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32 0-35.296 28.704-64 64-64s64 28.704 64 64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-16c0-35.296 28.704-64 64-64h64c0-35.296 28.704-64 64-64s64 28.704 64 64v32c0 17.664 14.336 32 32 32s32-14.336 32-32v-32c0-35.296 28.704-64 64-64s64 28.704 64 64v16c0 8.8 7.2 16 16 16h38.624c6.080-28.864 9.376-60.672 9.376-96 0-212.064-214.912-320-480-320s-480 107.936-480 320c0 35.328 3.296 67.136 9.376 96h38.624zM384.16 431.424c2.272-8.16 10.464-13.152 18.72-11.36 20.928 4.544 62.176 11.936 109.12 11.936s88.192-7.392 109.12-11.936c8.256-1.792 16.448 3.2 18.72 11.36 2.464 8.864-2.976 17.984-11.968 19.968-22.464 4.896-65.728 12.608-115.872 12.608s-93.408-7.712-115.872-12.608c-8.992-1.984-14.464-11.104-11.968-19.968zM973.888 640c-56.512 180.8-241.632 224-461.888 224s-405.376-43.2-461.888-224h29.888c26.464 0 48-21.536 48-48v-16c0-17.664 14.336-32 32-32s32 14.336 32 32v32c0 35.296 28.704 64 64 64h32c35.296 0 64-28.704 64-64 0-17.664 14.336-32 32-32s32 14.336 32 32v48c0 26.464 21.536 48 48 48s48-21.536 48-48v-16c0-17.664 14.336-32 32-32h64c17.664 0 32-14.336 32-32s14.336-32 32-32 32 14.336 32 32v32c0 35.296 28.704 64 64 64s64-28.704 64-64v-32c0-17.664 14.336-32 32-32s32 14.336 32 32v16c0 26.464 21.536 48 48 48h29.888z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"indulge",
						"eat",
						"consume"
					],
					"grid": 32
				},
				{
					"id": 1753,
					"width": 1023.9989280700684,
					"paths": [
						"M256 0q14.857 0 25.714 10.857t10.857 25.714v509.143l306.286-245.143q9.714-8 22.857-8 14.857 0 25.714 10.857t10.857 25.714v216.571l306.286-245.143q9.714-8 22.857-8 14.857 0 25.714 10.857t10.857 25.714v658.286q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-950.857q0-14.857 10.857-25.714t25.714-10.857h219.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"industry"
					],
					"defaultCode": 62069,
					"grid": 14
				},
				{
					"id": 3009,
					"paths": [
						"M783.988 752.012c-64.104 0-124.372-24.96-169.7-70.288l-102.288-102.282-102.276 102.27c-45.332 45.336-105.6 70.3-169.706 70.3-64.118 0-124.39-24.964-169.722-70.3-45.332-45.334-70.296-105.604-70.296-169.712s24.964-124.38 70.296-169.714c45.334-45.332 105.608-70.296 169.714-70.296 64.108 0 124.38 24.964 169.712 70.296l102.278 102.276 102.276-102.276c45.332-45.332 105.604-70.298 169.712-70.298 64.112 0 124.384 24.966 169.71 70.298 45.338 45.334 70.302 105.606 70.302 169.714 0 64.112-24.964 124.382-70.3 169.71-45.326 45.336-105.598 70.302-169.712 70.302zM681.72 614.288c27.322 27.31 63.64 42.354 102.268 42.352 38.634 0 74.958-15.044 102.276-42.362 27.316-27.322 42.364-63.644 42.364-102.278s-15.046-74.956-42.364-102.274c-27.32-27.318-63.64-42.364-102.276-42.364-38.632 0-74.956 15.044-102.278 42.364l-102.268 102.274 102.278 102.288zM240.012 367.362c-38.634 0-74.956 15.044-102.274 42.364-27.32 27.318-42.364 63.64-42.364 102.274 0 38.632 15.044 74.954 42.364 102.276 27.32 27.316 63.642 42.364 102.274 42.364 38.634 0 74.956-15.044 102.272-42.362l102.276-102.278-102.276-102.274c-27.318-27.32-63.64-42.366-102.272-42.364v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"infinite"
					],
					"defaultCode": 60844,
					"grid": 16
				},
				{
					"id": 3008,
					"paths": [
						"M274.010 385.442c-33.804 0-65.586 13.164-89.49 37.068s-37.068 55.686-37.068 89.49 13.164 65.584 37.070 89.49c23.904 23.902 55.686 37.068 89.49 37.068 33.806 0 65.586-13.164 89.49-37.066l89.488-89.492-89.492-89.49c-23.904-23.904-55.684-37.070-89.488-37.068z",
						"M749.99 385.442c-33.804 0-65.586 13.164-89.494 37.068l-89.484 89.49 89.494 89.502c23.906 23.896 55.686 37.058 89.484 37.056 33.804 0 65.588-13.164 89.49-37.066 23.902-23.906 37.068-55.688 37.068-89.492s-13.166-65.586-37.068-89.49c-23.904-23.904-55.686-37.068-89.49-37.068z",
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM898.486 660.496c-39.66 39.67-92.396 61.514-148.496 61.514-56.092 0-108.826-21.84-148.486-61.5l-89.504-89.498-89.492 89.484c-39.664 39.67-92.4 61.514-148.492 61.514-56.102 0-108.84-21.844-148.506-61.514-39.666-39.664-61.51-92.402-61.51-148.496s21.844-108.832 61.51-148.5c39.668-39.666 92.406-61.51 148.5-61.51s108.834 21.844 148.5 61.51l89.49 89.492 89.49-89.492c39.666-39.666 92.404-61.51 148.5-61.51 56.098 0 108.836 21.846 148.496 61.51 39.67 39.666 61.514 92.406 61.514 148.5 0 56.098-21.844 108.836-61.514 148.496z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"infinite-square"
					],
					"defaultCode": 60843,
					"grid": 16
				},
				{
					"id": 3010,
					"paths": [
						"M736 0c-159.058 0-288 128.942-288 288v160h-160c-159.058 0-288 128.942-288 288s128.942 288 288 288 288-128.942 288-288v-160h160c159.058 0 288-128.942 288-288s-128.942-288-288-288zM448 736c0 88.366-71.634 160-160 160s-160-71.634-160-160 71.634-160 160-160h160v160zM736 448h-160v-160c0-88.366 71.634-160 160-160s160 71.634 160 160-71.634 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"infinite"
					],
					"defaultCode": 60845,
					"grid": 16
				},
				{
					"id": 581,
					"width": 1024,
					"paths": [
						"M480 896c53.12 0 96-42.976 96-96v-192c0-53.024-42.432-96-96-96s-96 42.976-96 96v192c0 53.024 42.88 96 96 96zM416 608c0-35.904 28.128-64 64-64 35.904 0 64 28.096 64 64v192c0 35.296-28.704 64-64 64s-64-28.704-64-64v-192zM810.496 447.744l-24.8-37.216c-11.616-17.408-18.784-37.44-20.864-58.272l-25.824-258.24c15.040-4.416 25.504-18.912 22.784-35.296l-5.344-32c-2.56-15.424-15.904-26.72-31.552-26.72h-105.792c-15.648 0-28.992 11.296-31.552 26.752l-5.344 32c-2.72 16.384 7.712 30.848 22.72 35.296l-25.76 258.208c-0.576 5.888-1.856 11.648-3.296 17.344-1.376-5.696-2.464-11.488-3.072-17.344l-25.76-258.208c15.008-4.448 25.472-18.912 22.72-35.296l-5.344-32c-2.528-15.456-15.872-26.752-31.52-26.752h-105.792c-15.648 0-28.992 11.296-31.552 26.752l-5.344 32c-2.72 16.384 7.744 30.848 22.784 35.296l-25.824 258.24c-0.576 5.888-1.664 11.648-3.072 17.344-1.408-5.696-2.688-11.456-3.296-17.376l-25.76-258.208c15.008-4.448 25.472-18.912 22.72-35.296l-5.344-32c-2.528-15.456-15.872-26.752-31.52-26.752h-105.792c-15.648 0-28.992 11.296-31.552 26.752l-5.344 32c-2.72 16.384 7.744 30.848 22.784 35.264l-25.824 258.24c-2.080 20.832-9.248 40.832-20.864 58.272l-24.8 37.216c-14.016 21.024-21.504 45.76-21.504 71.008v441.248c0 35.36 28.64 64 64 64h576c35.36 0 64-28.64 64-64v-441.248c0-25.248-7.488-49.984-21.504-71.008zM619.104 32h105.792l5.344 32h-116.48l5.344-32zM427.104 32h105.792l5.344 32h-116.48l5.344-32zM419.008 355.456l25.952-259.456h70.080l25.952 259.456c2.592 26.048 11.552 51.072 26.080 72.832l24.832 37.216c10.496 15.776 16.096 34.304 16.096 53.248v441.248c0 17.664-14.336 32-32 32h-192c-17.664 0-32-14.336-32-32v-441.248c0-18.944 5.6-37.472 16.128-53.248l24.8-37.216c14.528-21.792 23.488-46.784 26.080-72.832zM672 544c35.872 0 64 28.096 64 64v192c0 35.296-28.704 64-64 64-11.712 0-22.56-3.392-32-8.928v-302.304c9.376-5.408 20.16-8.768 32-8.768zM320 855.072c-9.44 5.536-20.288 8.928-32 8.928-35.296 0-64-28.704-64-64v-192c0-35.904 28.128-64 64-64 11.84 0 22.624 3.36 32 8.768v302.304zM235.104 32h105.792l5.344 32h-116.48l5.344-32zM160 960v-441.248c0-18.944 5.6-37.472 16.128-53.248l24.8-37.216c14.528-21.792 23.488-46.784 26.080-72.832l25.952-259.456h70.080l25.952 259.456c1.952 19.648 7.744 38.624 16.64 56.128l-24.128 36.192c-13.824 20.704-21.184 44.992-21.408 69.888-9.984-3.648-20.768-5.664-32.096-5.664-53.568 0-96 42.976-96 96v192c0 53.024 42.88 96 96 96 11.392 0 21.92-2.72 32-6.432v70.432c0 11.712 3.392 22.56 8.864 32h-136.864c-17.664 0-32-14.336-32-32zM800 960c0 17.664-14.336 32-32 32h-136.864c5.472-9.44 8.864-20.288 8.864-32v-70.432c10.080 3.712 20.608 6.432 32 6.432 53.12 0 96-42.976 96-96v-192c0-53.024-42.432-96-96-96-11.328 0-22.112 2.016-32.096 5.632-0.224-24.896-7.616-49.184-21.408-69.888l-24.128-36.192c8.896-17.504 14.656-36.48 16.64-56.128l25.952-259.424h70.080l25.952 259.456c2.592 26.048 11.552 51.072 26.080 72.832l24.8 37.216c10.528 15.776 16.128 34.304 16.128 53.248v441.248z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"influence",
						"drink",
						"decompress"
					],
					"grid": 32
				},
				{
					"id": 582,
					"width": 1024,
					"paths": [
						"M288 544v320c-35.296 0-64-28.704-64-64v-192c0-35.904 28.128-64 64-64zM480 544c-35.872 0-64 28.096-64 64v192c0 35.296 28.704 64 64 64s64-28.704 64-64v-192c0-35.904-28.096-64-64-64zM288 960v-64c-53.12 0-96-42.976-96-96v-192c0-53.024 42.432-96 96-96 0.16 0 0.32 0.032 0.512 0.064 1.248-29.216 10.112-57.632 26.368-82.048l24.8-37.216c8.704-13.056 14.080-28.096 15.648-43.712l12.608-126.016-12.864-129.024c15.008-4.448 25.472-18.912 22.72-35.296l-5.344-32c-2.56-15.456-15.904-26.752-31.552-26.752h-105.792c-15.648 0-28.992 11.296-31.552 26.752l-5.344 32c-2.72 16.384 7.744 30.848 22.784 35.264l-25.824 258.24c-2.080 20.832-9.248 40.832-20.864 58.272l-24.8 37.216c-14.016 21.024-21.504 45.76-21.504 71.008v441.248c0 35.36 28.64 64 64 64h120.928c-15.328-17.024-24.928-39.296-24.928-64zM736 800v-192c0-35.904-28.128-64-64-64v320c35.296 0 64-28.704 64-64zM576 1024h-192c-35.328 0-64-28.672-64-64v-441.248c0-25.28 7.488-49.984 21.504-71.008l24.8-37.216c11.616-17.408 18.752-37.408 20.864-58.24 0 0 0-0.032 0-0.032l25.824-258.24c-15.040-4.416-25.504-18.912-22.784-35.296l5.344-32c2.56-15.424 15.904-26.72 31.552-26.72h105.792c15.648 0 28.992 11.296 31.552 26.752l5.344 32c2.72 16.384-7.712 30.848-22.72 35.296l3.648 36.832h-0.032l22.144 221.376c2.080 20.832 9.248 40.864 20.864 58.272l24.8 37.216c14.016 21.024 21.504 45.76 21.504 71.008v441.248c0 35.328-28.64 64-64 64v0zM576 800v-192c0-53.024-42.432-96-96-96s-96 42.976-96 96v192c0 53.024 42.88 96 96 96s96-42.976 96-96zM810.496 447.744l-24.8-37.216c-11.616-17.408-18.784-37.44-20.864-58.272l-25.824-258.24c15.040-4.416 25.504-18.912 22.784-35.296l-5.344-32c-2.56-15.424-15.904-26.72-31.552-26.72h-105.792c-15.648 0-28.992 11.296-31.552 26.752l-5.344 32c-2.72 16.384 7.712 30.848 22.72 35.296l-12.864 128.992 12.608 126.016c1.568 15.616 6.944 30.624 15.648 43.712l24.8 37.216c16.256 24.416 25.152 52.832 26.368 82.048 0.192 0 0.352-0.032 0.512-0.032 53.568 0 96 42.976 96 96v192c0 53.024-42.88 96-96 96v64c0 24.704-9.6 46.976-24.928 64h120.928c35.36 0 64-28.64 64-64v-441.248c0-25.248-7.488-49.984-21.504-71.008z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"influence",
						"drink",
						"decompress"
					],
					"grid": 32
				},
				{
					"id": 2936,
					"paths": [
						"M448 304c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4 0-48-21.6-48-48v-32z",
						"M640 768h-256v-64h64v-192h-64v-64h192v256h64z",
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"info",
						"information"
					],
					"defaultCode": 60771,
					"grid": 16
				},
				{
					"id": 1264,
					"width": 877.7139282226562,
					"paths": [
						"M585.143 786.286v-91.429q0-8-5.143-13.143t-13.143-5.143h-54.857v-292.571q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v91.429q0 8 5.143 13.143t13.143 5.143h54.857v182.857h-54.857q-8 0-13.143 5.143t-5.143 13.143v91.429q0 8 5.143 13.143t13.143 5.143h256q8 0 13.143-5.143t5.143-13.143zM512 274.286v-91.429q0-8-5.143-13.143t-13.143-5.143h-109.714q-8 0-13.143 5.143t-5.143 13.143v91.429q0 8 5.143 13.143t13.143 5.143h109.714q8 0 13.143-5.143t5.143-13.143zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"info-circle"
					],
					"defaultCode": 61530,
					"grid": 14
				},
				{
					"id": 2937,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM448 240c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4 0-48-21.6-48-48v-32zM640 832h-256v-64h64v-256h-64v-64h192v320h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"info",
						"information"
					],
					"defaultCode": 60772,
					"grid": 16
				},
				{
					"id": 1444,
					"width": 365.71499252319336,
					"paths": [
						"M365.714 768v73.143q0 14.857-10.857 25.714t-25.714 10.857h-292.571q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h36.571v-219.429h-36.571q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h219.429q14.857 0 25.714 10.857t10.857 25.714v329.143h36.571q14.857 0 25.714 10.857t10.857 25.714zM292.571 109.714v109.714q0 14.857-10.857 25.714t-25.714 10.857h-146.286q-14.857 0-25.714-10.857t-10.857-25.714v-109.714q0-14.857 10.857-25.714t25.714-10.857h146.286q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"info"
					],
					"defaultCode": 61737,
					"grid": 14
				},
				{
					"id": 583,
					"width": 1024,
					"paths": [
						"M969.376 265.376l-210.752-210.752c-12.512-12.512-32.768-12.512-45.248 0l-18.752 18.752c-12.512 12.512-12.512 32.768 0 45.248l9.376 9.376-96 96-41.376-41.376c-12.512-12.512-32.768-12.512-45.248 0l-18.752 18.752c-12.512 12.512-12.512 32.768 0 45.248l9.376 9.376-387.872 387.872c-18.016 18.016-28.128 42.432-28.128 67.904v184.224l-48 48c-8.832 8.832-8.832 23.168 0 32s23.168 8.832 32 0l48-48h184.224c25.472 0 49.888-10.112 67.872-28.128l387.904-387.872 9.376 9.376c12.512 12.512 32.768 12.512 45.248 0l18.752-18.752c12.512-12.512 12.512-32.768 0-45.248l-41.376-41.376 96-96 9.376 9.376c12.512 12.512 32.768 12.512 45.248 0l18.752-18.752c12.48-12.48 12.48-32.768 0-45.248zM818.752 480l-18.752 18.752-32-32-410.496 410.496c-12.032 12-28.288 18.752-45.28 18.752h-184.224v-184.224c0-16.96 6.752-33.248 18.752-45.248l410.496-410.528-32-32 18.752-18.752 274.752 274.752zM928 306.752l-32-32-118.624 118.624-146.752-146.752 118.624-118.624-32-32 18.752-18.752 210.752 210.752-18.752 18.752zM288 704c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM384 608c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM480 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM544 384c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"inject",
						"medicate",
						"shoot"
					],
					"grid": 32
				},
				{
					"id": 584,
					"width": 1024,
					"paths": [
						"M566.624 182.624c-12.512-12.512-32.768-12.512-45.248 0l-18.752 18.752c-12.512 12.512-12.512 32.768 0 45.248l9.376 9.376-387.872 387.872c-18.016 18.016-28.128 42.432-28.128 67.904v184.224l-48 48c-8.832 8.832-8.832 23.168 0 32s23.168 8.832 32 0l48-48h184.224c25.472 0 49.888-10.112 67.872-28.128l387.904-387.872 9.376 9.376c12.512 12.512 32.768 12.512 45.248 0l18.752-18.752c12.512-12.512 12.512-32.768 0-45.248l-274.752-274.752zM256 736c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM352 640c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM448 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM544 448c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM969.376 310.624l-18.752 18.752c-12.512 12.512-32.768 12.512-45.248 0l-9.376-9.376-73.376 73.376-192-192 73.376-73.376-9.376-9.376c-12.512-12.512-12.512-32.768 0-45.248l18.752-18.752c12.512-12.512 32.768-12.512 45.248 0l210.752 210.752c12.48 12.48 12.48 32.768 0 45.248z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"inject",
						"medicate",
						"shoot"
					],
					"grid": 32
				},
				{
					"id": 1048,
					"width": 1024,
					"paths": [
						"M800 0l-45.248 45.248 32.928 32.928-125.056 123.2-96-96-45.248 45.248 48 48-409.376 409.376v192l-160 160 64 64 160-160h192l409.376-409.376 48 48 45.248-45.248-96-96 125.056-123.2 32.928 32.928 43.392-47.104-224-224zM389.504 800h-165.504v-165.504l49.952-49.952 66.752 66.752 22.624-22.624-66.752-66.752 41.376-41.376 34.752 34.752 22.624-22.624-34.752-34.752 41.376-41.376 66.752 66.752 22.624-22.624-66.752-66.752 41.376-41.376 34.752 34.752 22.624-22.624-34.752-34.752 41.376-41.376 66.752 66.752 22.624-22.624-66.752-66.752 62.048-62.048 165.504 165.472-390.624 390.656zM754.752 338.752l-69.504-69.504 147.68-145.792 69.504 69.504-147.68 145.792z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"inject",
						"drug",
						"inoculate",
						"jab",
						"vaccinate"
					],
					"grid": 32
				},
				{
					"id": 1486,
					"width": 513.1449031829834,
					"paths": [
						"M513.143 268.571v58.286q0 8-5.143 13.143t-13.143 5.143h-96q-13.143 82.286-73.714 133.714t-157.714 62.857q95.429 101.714 262.286 306.286 8 9.143 2.286 19.429-4.571 10.286-16.571 10.286h-111.429q-9.143 0-14.286-6.857-174.857-209.714-284.571-326.286-5.143-5.143-5.143-12.571v-72.571q0-7.429 5.429-12.857t12.857-5.429h64q75.429 0 121.429-24.571t58.571-71.429h-244q-8 0-13.143-5.143t-5.143-13.143v-58.286q0-8 5.143-13.143t13.143-5.143h236q-32.571-64.571-153.143-64.571h-82.857q-7.429 0-12.857-5.429t-5.429-12.857v-76q0-8 5.143-13.143t13.143-5.143h475.429q8 0 13.143 5.143t5.143 13.143v58.286q0 8-5.143 13.143t-13.143 5.143h-133.143q26.857 34.857 36.571 82.286h97.714q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"inr",
						"rupee"
					],
					"defaultCode": 61782,
					"grid": 14
				},
				{
					"id": 3269,
					"paths": [
						"M384 192h128v64h-128zM576 192h128v64h-128zM896 192v256h-192v-64h128v-128h-64v-64zM320 384h128v64h-128zM512 384h128v64h-128zM192 256v128h64v64h-128v-256h192v64zM384 576h128v64h-128zM576 576h128v64h-128zM896 576v256h-192v-64h128v-128h-64v-64zM320 768h128v64h-128zM512 768h128v64h-128zM192 640v128h64v64h-128v-256h192v64zM960 64h-896v896h896v-896zM1024 0v0 1024h-1024v-1024h1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"insert-template",
						"wysiwyg"
					],
					"defaultCode": 61104,
					"grid": 16
				},
				{
					"id": 3334,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM704 160c0-17.6 14.4-32 32-32h128c17.6 0 32 14.4 32 32v128c0 17.6-14.4 32-32 32h-128c-17.6 0-32-14.4-32-32v-128zM512 320c106 0 192 86 192 192s-86 192-192 192c-106 0-192-86-192-192s86-192 192-192zM896 864v0c0 17.6-14.4 32-32 32h-704c-17.6 0-32-14.4-32-32v0-416h70.4c-4.2 20.6-6.4 42-6.4 64 0 176.8 143.2 320 320 320s320-143.2 320-320c0-22-2.2-43.4-6.4-64h70.4v416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"instagram",
						"brand",
						"social"
					],
					"defaultCode": 61169,
					"grid": 16
				},
				{
					"id": 1508,
					"width": 877.7139630317688,
					"paths": [
						"M585.143 512q0-60.571-42.857-103.429t-103.429-42.857-103.429 42.857-42.857 103.429 42.857 103.429 103.429 42.857 103.429-42.857 42.857-103.429zM664 512q0 93.714-65.714 159.429t-159.429 65.714-159.429-65.714-65.714-159.429 65.714-159.429 159.429-65.714 159.429 65.714 65.714 159.429zM725.714 277.714q0 21.714-15.429 37.143t-37.143 15.429-37.143-15.429-15.429-37.143 15.429-37.143 37.143-15.429 37.143 15.429 15.429 37.143zM438.857 152q-4 0-43.714-0.286t-60.286 0-55.143 1.714-58.857 5.714-40.857 10.571q-28.571 11.429-50.286 33.143t-33.143 50.286q-6.286 16.571-10.571 40.857t-5.714 58.857-1.714 55.143 0 60.286 0.286 43.714-0.286 43.714 0 60.286 1.714 55.143 5.714 58.857 10.571 40.857q11.429 28.571 33.143 50.286t50.286 33.143q16.571 6.286 40.857 10.571t58.857 5.714 55.143 1.714 60.286 0 43.714-0.286 43.714 0.286 60.286 0 55.143-1.714 58.857-5.714 40.857-10.571q28.571-11.429 50.286-33.143t33.143-50.286q6.286-16.571 10.571-40.857t5.714-58.857 1.714-55.143 0-60.286-0.286-43.714 0.286-43.714 0-60.286-1.714-55.143-5.714-58.857-10.571-40.857q-11.429-28.571-33.143-50.286t-50.286-33.143q-16.571-6.286-40.857-10.571t-58.857-5.714-55.143-1.714-60.286 0-43.714 0.286zM877.714 512q0 130.857-2.857 181.143-5.714 118.857-70.857 184t-184 70.857q-50.286 2.857-181.143 2.857t-181.143-2.857q-118.857-5.714-184-70.857t-70.857-184q-2.857-50.286-2.857-181.143t2.857-181.143q5.714-118.857 70.857-184t184-70.857q50.286-2.857 181.143-2.857t181.143 2.857q118.857 5.714 184 70.857t70.857 184q2.857 50.286 2.857 181.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"instagram"
					],
					"defaultCode": 61805,
					"grid": 14
				},
				{
					"id": 1744,
					"width": 1023.9979553222656,
					"paths": [
						"M1024 535.429q0 32-4 59.429h-657.714q0 83.429 62.571 139.714t147.143 56.286q56.571 0 106-26.571t78-74.571h241.714q-32 90.857-97.429 160.571t-152.857 107.714-183.429 38q-106.857 0-203.429-47.429-130.286 66.286-225.143 66.286-135.429 0-135.429-150.286 0-65.714 25.714-157.143 9.714-34.286 62.286-130.857 113.714-205.714 271.429-346.286-105.143 45.143-244 202.286 36-156.571 162-256.857t286.571-100.286q17.143 0 25.714 0.571 145.714-66.857 247.429-66.857 36.571 0 66.286 7.429t54 23.143 38 43.714 13.714 65.714q0 66.286-42.857 163.429 57.714 104 57.714 222.857zM984 169.714q0-47.429-30.286-75.429t-78.286-28q-61.714 0-145.143 40 69.143 26.857 127.143 75.143t97.429 111.714q29.143-77.143 29.143-123.429zM73.143 876.571q0 49.143 27.714 75.714t76.857 26.571q65.714 0 152-47.429-69.714-41.143-122-104.571t-78.571-140q-56 117.143-56 189.714zM361.143 469.143h416q-2.857-81.143-64.571-135.429t-143.429-54.286q-82.286 0-143.714 54.286t-64.286 135.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"internet-explorer"
					],
					"defaultCode": 62059,
					"grid": 14
				},
				{
					"id": 2252,
					"paths": [
						"M704 256v-256h-704v704h256v320h768v-768h-320zM640 392h-256v-8h256v8zM640 640h-256v-8h256v8zM640 616h-256v-16h256v16zM640 584h-256v-16h256v16zM640 552h-256v-16h256v16zM640 520h-256v-16h256v16zM640 488h-256v-16h256v16zM640 456h-256v-16h256v16zM640 424h-256v-16h256v16zM256 640h-192v-576h576v192h-384v384zM960 960h-640v-192h448v-448h192v640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"interset",
						"boolean-operation",
						"dualtone"
					],
					"defaultCode": 60087,
					"grid": 16
				},
				{
					"id": 1678,
					"width": 798.8558959960938,
					"paths": [
						"M585.143 18.286q0-8 5.143-13.143t13.143-5.143h164.571q14.857 0 25.714 10.857t10.857 25.714v164.571q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-76.571l-145.143 145.714q72 90.286 72 205.143 0 126.286-84.286 219.714t-208.286 107.143v75.429h54.857q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857v54.857q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-54.857h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h54.857v-75.429q-85.143-9.143-154.571-58.857t-106.571-127.714-30.286-166.571q9.143-116.571 91.429-202t198.286-98.571q67.429-8 130.286 10.857t113.143 58.857l145.714-145.143h-76.571q-8 0-13.143-5.143t-5.143-13.143v-36.571zM329.143 731.429q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"intersex",
						"transgender"
					],
					"defaultCode": 61988,
					"grid": 14
				},
				{
					"id": 585,
					"width": 1024,
					"paths": [
						"M960 320v-32c0-17.664-14.368-32-32-32h-533.056c-44.064 0-82.464 29.984-93.12 72.736l-13.824 55.264h-32c-53.024 0-96 42.976-96 96v96c-53.024 0-96 42.976-96 96v64c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-64c0-53.024-42.976-96-96-96v-96c0-53.024-42.976-96-96-96h-160l-8-32h328c17.632 0 32-14.336 32-32zM864 608c35.296 0 64 28.704 64 64v64c0 35.296-28.704 64-64 64h-704c-35.296 0-64-28.704-64-64v-64c0-35.296 28.704-64 64-64h704zM768 416c35.296 0 64 28.704 64 64v96h-640v-96c0-35.296 28.704-64 64-64h56.992l19.872-79.52c7.136-28.544 32.672-48.48 62.080-48.48h106.112c29.408 0 54.944 19.936 62.080 48.48l19.872 79.52h184.992zM590.976 320c-4.224-11.936-10.336-22.88-18.496-32h355.52v32h-337.024zM672 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM800 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM544 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM416 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM160 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM288 704c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"invade",
						"fight",
						"shoot",
						"kill",
						"attack"
					],
					"grid": 32
				},
				{
					"id": 586,
					"width": 1024,
					"paths": [
						"M160 544v-64c0-53.024 42.976-96 96-96h32l13.824-55.264c10.688-42.752 49.088-72.736 93.12-72.736h106.080c44.064 0 82.464 29.984 93.12 72.704l13.856 55.296h160c53.024 0 96 42.976 96 96v64h-704zM928 256h-342.816c19.072 16.736 33.504 38.912 40.032 64.96l7.776 31.040h295.008c17.632 0 32-14.336 32-32v-32c0-17.664-14.368-32-32-32zM960 672v64c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-64c0-53.024 42.976-96 96-96h704c53.024 0 96 42.976 96 96zM224 704c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM352 704c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM480 704c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM608 704c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM736 704c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM864 704c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"invade",
						"fight",
						"shoot",
						"kill",
						"attack"
					],
					"grid": 32
				},
				{
					"id": 1653,
					"width": 1170.2856884002686,
					"paths": [
						"M836 475.429q0 20-14.286 34.571t-34.857 14.571h-401.143q-20.571 0-34.857-14.571t-14.286-34.571 14.286-34.571 34.857-14.571h401.143q20.571 0 34.857 14.571t14.286 34.571zM958.286 475.429q0-49.143-13.143-97.143h-561.143q-20.571 0-34.857-14.286t-14.286-34.286q0-20.571 14.286-34.857t34.857-14.286h518.857q-50.286-81.714-134.286-129.714t-182.857-48q-101.143 0-187.143 50t-136 135.714-50 186.857q0 49.143 13.143 97.143h561.143q20.571 0 34.857 14.286t14.286 34.286q0 20.571-14.286 34.857t-34.857 14.286h-518.857q50.286 81.714 134.571 129.714t183.143 48q75.429 0 144.571-29.429t118.857-79.429 79.429-118.857 29.714-144.857zM1170.286 329.714q0 20-14.286 34.286t-34.857 14.286h-74.857q9.714 48.571 9.714 97.143 0 95.429-37.429 182.571t-100.286 150.286-150 100.571-182.571 37.429q-140.571 0-256.286-76t-172.286-200h-108q-20.571 0-34.857-14.286t-14.286-34.857q0-20 14.286-34.286t34.857-14.286h75.429q-9.714-48.571-9.714-97.143 0-95.429 37.429-182.571t100.286-150.286 150-100.571 183.143-37.429q140 0 255.714 76t172.286 200h107.429q20.571 0 34.857 14.286t14.286 34.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ioxhost"
					],
					"defaultCode": 61960,
					"grid": 14
				},
				{
					"id": 587,
					"width": 1024,
					"paths": [
						"M975.584 356.384l-43.584-130.72c-13.088-39.232-49.76-65.664-91.072-65.664h-74.336c-155.008 0-304.768 56.256-421.44 158.336l-11.104 9.728c-42.432 37.12-79.776 79.712-111.040 126.624l-192.32 288.448c-7.072 10.624 0.544 24.864 13.312 24.864h802.112c17.664 0 32-14.336 32-32v-32l20.16-20.16c85.696-85.696 115.616-212.48 77.312-327.456zM249.6 472.448c29.696-44.576 65.216-85.056 105.504-120.32l11.072-9.696c110.912-96.992 253.088-150.432 400.416-150.432h74.336c27.584 0 52 17.6 60.704 43.776l43.584 130.752c16.032 48.096 18.432 97.984 9.28 145.504h-57.92c-0.192 0-0.384 0.032-0.576 0.032v-16.064c0-26.496-21.504-48-48-48s-48 21.504-48 48v21.568c-10.688 1.056-21.344 2.304-32 3.712v-25.28c0-26.496-21.504-48-48-48s-48 21.504-48 48v42.72c-10.784 2.432-21.568 4.736-32.256 7.648l-103.936 28.384c-80.928 22.048-164.48 33.248-248.384 33.248h-128.192l90.368-135.552zM864 496v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16zM736 496v64c0 8.832-7.168 16-16 16s-16-7.168-16-16v-64c0-8.832 7.168-16 16-16s16 7.168 16 16zM846.112 736h-772.192l21.344-32h750.88v32zM875.648 661.216l-11.008 10.784h-748.064l21.344-32h149.536c86.72 0 173.12-11.552 256.8-34.368l103.936-28.384c8.352-2.272 16.832-4.096 25.28-5.984 5.088 21.056 23.904 36.736 46.528 36.736 26.496 0 48-21.504 48-48v-6.336c10.656-1.472 21.312-2.752 32-3.872v10.208c0 26.496 21.504 48 48 48s48-21.504 48-48c0 0 0.384-16 0.576-16h49.728c-13.664 43.232-37.088 83.616-70.656 117.216zM464.032 384h330.752c43.68 0 74.528-42.784 60.704-84.224-8.704-26.144-33.152-43.776-60.704-43.776h-28.192c-112.16 0-220.832 34.848-311.872 98.72-12.8 8.96-6.336 29.28 9.312 29.28zM766.592 288h28.192c13.792 0 25.984 8.8 30.368 21.888 3.296 9.888 1.696 20.384-4.384 28.832-6.112 8.448-15.584 13.28-25.984 13.28h-275.552c75.68-42.016 160.192-64 247.36-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"iron",
						"heat",
						"smooth"
					],
					"grid": 32
				},
				{
					"id": 588,
					"width": 1024,
					"paths": [
						"M717.888 528v-64c0-8.832 7.168-16 16-16s16 7.168 16 16v64c0 8.832-7.168 16-16 16s-16-7.168-16-16zM861.888 544c8.832 0 16-7.168 16-16v-64c0-8.832-7.168-16-16-16s-16 7.168-16 16v64c0 8.832 7.168 16 16 16zM30.688 743.136c-7.072 10.624 0.544 24.864 13.312 24.864h802.112c17.664 0 32-14.336 32-32v-32h-821.344l-26.080 39.136zM78.112 672l144.896-217.344c31.264-46.912 68.608-89.504 111.040-126.624l11.104-9.728c116.672-102.048 266.432-158.304 421.44-158.304h74.336c41.312 0 78.016 26.432 91.072 65.632l43.584 130.752c36.672 109.984 10.272 230.336-67.008 315.616h-830.464zM519.232 352h275.552c10.4 0 19.872-4.832 25.952-13.28s7.68-18.944 4.384-28.832c-4.32-13.088-16.544-21.888-30.336-21.888h-28.192c-87.168 0-171.68 21.984-247.36 64zM168.384 583.136c-7.104 10.624 0.512 24.864 13.312 24.864h119.648c86.72 0 173.12-11.552 256.8-34.368l103.936-28.384c8.352-2.272 16.832-4.096 25.28-5.984 5.344 22.144 25.92 38.368 50.112 36.608 25.408-1.856 44.416-24.352 44.416-49.856v-4.352c10.656-1.472 21.312-2.752 32-3.872v8.192c0 26.272 20.256 49.216 46.528 49.984 27.168 0.832 49.472-20.992 49.472-47.968 0 0 0.384-16 0.576-16h37.312c7.296 0 13.696-4.96 15.488-12.032 2.592-10.112-5.056-19.968-15.488-19.968h-37.312c-0.192 0-0.384 0.032-0.576 0.032v-14.016c0-26.272-20.256-49.216-46.528-49.984-27.168-0.8-49.472 20.992-49.472 47.968v21.568c-10.688 1.056-21.344 2.304-32 3.712v-23.296c0-26.272-20.256-49.216-46.528-49.984-27.168-0.8-49.472 20.992-49.472 47.968v42.72c-10.784 2.432-21.568 4.736-32.256 7.648l-103.936 28.384c-80.928 22.080-164.512 33.28-248.384 33.28h-119.616c-5.376 0-10.368 2.688-13.312 7.136z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"iron",
						"heat",
						"smooth"
					],
					"grid": 32
				},
				{
					"id": 1049,
					"width": 1024,
					"paths": [
						"M864 320h-352c-270.592 0-448 448-448 448l-64 96v32h992c17.664 0 32-14.336 32-32v-384c0-88.352-71.648-160-160-160zM512 384h352c52.928 0 96 43.072 96 96v288h-826.592c55.264-125.856 204.64-384 378.592-384zM98.24 832l21.312-32h840.448v32h-861.76zM640 704h32v32h-32v-32zM576 704h32v32h-32v-32zM512 704h32v32h-32v-32zM704 704h32v32h-32v-32zM768 704h32v32h-32v-32zM832 704h32v32h-32v-32zM896 704h32v32h-32v-32zM864 416h-352c-35.296 0-64 28.704-64 64s28.704 64 64 64h352c35.296 0 64-28.704 64-64s-28.704-64-64-64zM864 512h-352c-17.664 0-32-14.336-32-32s14.336-32 32-32h352c17.664 0 32 14.336 32 32s-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"iron",
						"smooth"
					],
					"grid": 32
				},
				{
					"id": 3246,
					"paths": [
						"M896 0v64h-130.56l-336 896h146.56v64h-448v-64h130.56l336-896h-146.56v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"italic",
						"wysiwyg"
					],
					"defaultCode": 61081,
					"grid": 16
				},
				{
					"id": 3252,
					"paths": [
						"M896 64v64h-128l-320 768h128v64h-448v-64h128l320-768h-128v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"italic",
						"wysiwyg"
					],
					"defaultCode": 61087,
					"grid": 16
				},
				{
					"id": 1227,
					"width": 585.14208984375,
					"paths": [
						"M0 949.714l9.714-48.571q3.429-1.143 46.571-12.286t63.714-21.429q16-20 23.429-57.714 0.571-4 35.429-165.143t65.143-310.571 29.714-169.429v-14.286q-13.714-7.429-31.143-10.571t-39.714-4.571-33.143-3.143l10.857-58.857q18.857 1.143 68.571 3.714t85.429 4 68.857 1.429q27.429 0 56.286-1.429t69.143-4 56.286-3.714q-2.857 22.286-10.857 50.857-17.143 5.714-58 16.286t-62 19.143q-4.571 10.857-8 24.286t-5.143 22.857-4.286 26-3.714 24q-15.429 84.571-50 239.714t-44.286 203.143q-1.143 5.143-7.429 33.143t-11.429 51.429-9.143 47.714-3.429 32.857l0.571 10.286q9.714 2.286 105.714 17.714-1.714 25.143-9.143 56.571-6.286 0-18.571 0.857t-18.571 0.857q-16.571 0-49.714-5.714t-49.143-5.714q-78.857-1.143-117.714-1.143-29.143 0-81.714 5.143t-69.143 6.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"italic"
					],
					"defaultCode": 61491,
					"grid": 14
				},
				{
					"id": 243,
					"paths": [
						"M793.6 102.4h-204.829c-0.070 0-0.142 0-0.213 0h-204.558c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h173.573l-143.362 716.8h-183.811c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h204.733c0.032 0 0.064 0.005 0.096 0.005 0.035 0 0.070-0.005 0.107-0.005h204.664c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-173.573l143.36-716.8h183.813c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"italic",
						"typography"
					],
					"defaultCode": 59540,
					"grid": 20
				},
				{
					"id": 589,
					"width": 1024,
					"paths": [
						"M1024 436.704v-0.512c0-3.808-1.408-7.456-3.872-10.368-74.592-86.688-113.472-201.504-122.528-230.816l-0.864-19.040c-0.416-8.928-7.776-15.968-16.704-15.968h-0.032v-16c0-8.832-7.168-16-16-16v0c-8.832 0-16 7.168-16 16v16h-0.032c-8.928 0-16.288 7.040-16.704 15.968l-0.864 19.040c-15.008 48.768-111.488 332.992-318.4 332.992-206.72 0-303.392-284.32-318.4-332.992l-0.864-19.040c-0.416-8.928-7.776-15.968-16.704-15.968h-0.032v-16c0-8.832-7.168-16-16-16v0c-8.832 0-16 7.168-16 16v16h-0.032c-8.928 0-16.288 7.040-16.704 15.968l-0.864 19.040c-9.056 29.376-47.872 144.256-122.528 230.944-2.464 2.88-3.872 6.56-3.872 10.368v0.384c0 14.88 18.56 21.728 28.192 10.368 1.28-1.504 2.528-3.008 3.808-4.48v229.408h-16c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h87.264l-5.76 126.56c-0.8 18.208 13.728 33.44 31.968 33.44h61.024c18.24 0 32.8-15.232 31.968-33.44l-5.728-126.56h590.56l-5.76 126.56c-0.832 18.208 13.696 33.44 31.936 33.44h61.024c18.24 0 32.8-15.232 31.968-33.44l-5.728-126.56h87.264c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-16v-229.408c1.248 1.504 2.528 3.008 3.808 4.48 9.632 11.36 28.192 4.512 28.192-10.368zM104.736 672h-40.736v-271.744c23.808-34.976 43.296-70.912 57.76-102.912l-17.024 374.656zM129.504 832l29.088-640h2.848l29.088 640h-61.024zM215.264 672l-17.024-374.688c14.592 32.256 33.728 68.608 57.76 103.904v270.784h-40.736zM352 672h-64v-228.224c18.912 22.432 40.288 43.136 64 60.832v167.392zM448 672h-64v-146.144c19.808 11.2 41.184 19.904 64 25.824v120.32zM544 672h-64v-114.144c10.4 1.28 21.024 2.144 32 2.144s21.6-0.8 32-2.080v114.080zM640 672h-64v-120.192c22.88-5.92 44.16-14.912 64-26.176v146.368zM736 672h-64v-167.52c23.744-17.728 45.056-38.496 64-60.96v228.48zM808.736 672h-40.736v-270.496c24.128-35.392 43.136-71.84 57.76-104.16l-17.024 374.656zM833.504 832l29.088-640h2.848l29.088 640h-61.024zM960 672h-40.736l-17.024-374.688c14.464 32 33.952 67.968 57.76 102.944v271.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"join",
						"attach",
						"span"
					],
					"grid": 32
				},
				{
					"id": 590,
					"width": 1024,
					"paths": [
						"M1024 436.704v-0.512c0-3.808-1.408-7.456-3.872-10.368-74.592-86.688-113.472-201.504-122.528-230.816l-0.864-19.040c-0.416-8.928-7.776-15.968-16.704-15.968h-0.032v-16c0-8.832-7.168-16-16-16v0c-8.832 0-16 7.168-16 16v16h-0.032c-8.928 0-16.288 7.040-16.704 15.968l-0.864 19.040c-15.008 48.768-111.488 332.992-318.4 332.992-206.72 0-303.392-284.32-318.4-332.992l-0.864-19.040c-0.416-8.928-7.776-15.968-16.704-15.968h-0.032v-16c0-8.832-7.168-16-16-16v0c-8.832 0-16 7.168-16 16v16h-0.032c-8.928 0-16.288 7.040-16.704 15.968l-0.864 19.040c-9.056 29.376-47.872 144.256-122.528 230.944-2.464 2.88-3.872 6.56-3.872 10.368v0.384c0 14.88 18.56 21.728 28.192 10.368 1.28-1.504 2.528-3.008 3.808-4.48v229.408h-16c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h87.264l-5.76 126.56c-0.8 18.208 13.728 33.44 31.968 33.44h61.024c18.24 0 32.8-15.232 31.968-33.44l-5.728-126.56h590.56l-5.76 126.56c-0.832 18.208 13.696 33.44 31.936 33.44h61.024c18.24 0 32.8-15.232 31.968-33.44l-5.728-126.56h87.264c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-16v-229.408c1.248 1.504 2.528 3.008 3.808 4.48 9.632 11.36 28.192 4.512 28.192-10.368zM104.736 672h-40.736v-271.744c23.808-34.976 43.296-70.912 57.76-102.912l-17.024 374.656zM215.264 672l-17.024-374.688c14.592 32.256 33.728 68.608 57.76 103.904v270.784h-40.736zM352 672h-64v-228.224c18.912 22.432 40.288 43.136 64 60.832v167.392zM448 672h-64v-146.144c19.808 11.2 41.184 19.904 64 25.824v120.32zM544 672h-64v-114.144c10.4 1.28 21.024 2.144 32 2.144s21.6-0.8 32-2.080v114.080zM640 672h-64v-120.192c22.88-5.92 44.16-14.912 64-26.176v146.368zM736 672h-64v-167.52c23.744-17.728 45.056-38.496 64-60.96v228.48zM808.736 672h-40.736v-270.496c24.128-35.392 43.136-71.84 57.76-104.16l-17.024 374.656zM960 672h-40.736l-17.024-374.688c14.464 32 33.952 67.968 57.76 102.944v271.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"join",
						"attach",
						"span"
					],
					"grid": 32
				},
				{
					"id": 3369,
					"paths": [
						"M266.004 276.678c32.832-32.844 86.002-32.844 118.804-0.032l7.826 7.868 101.104-101.156-7.874-7.88c-57.624-57.7-138.514-77.878-212.42-60.522-10.594-65.182-67.088-114.924-135.174-114.956-75.65 0-136.954 61.442-136.97 137.158 0 65.336 45.59 120 106.662 133.83-23.138 77.45-4.242 164.834 56.846 225.984l227.826 227.9 100.996-101.214-227.81-227.886c-32.682-32.722-32.742-86.126 0.184-119.094zM1022.712 137.158c0.016-75.762-61.318-137.158-136.984-137.158-69.234 0-126.478 51.444-135.682 118.238-77.074-22.664-163.784-3.496-224.64 57.408l-227.84 227.9 101.102 101.172 227.766-227.856c32.94-32.966 85.988-32.906 118.684-0.184 32.8 32.83 32.8 86.114-0.032 118.956l-7.794 7.836 101.010 101.248 7.858-7.928c60.458-60.566 79.678-146.756 57.612-223.638 67.15-8.834 118.94-66.364 118.94-135.994zM906.266 751.064c18.102-74.458-1.976-156.324-60.108-214.5l-227.49-227.992-101.102 101.122 227.52 228.012c32.94 32.996 32.864 86.096 0.184 118.848-32.802 32.814-86.004 32.814-118.836-0.030l-7.766-7.79-100.994 101.246 7.732 7.728c61.516 61.594 149.618 80.438 227.368 56.488 12.632 62.682 67.934 109.804 134.258 109.804 75.604 0 136.968-61.35 136.968-137.126 0-69.2-51.18-126.456-117.734-135.81zM612.344 528.684l-227.536 227.992c-32.71 32.768-86.034 32.828-118.944-0.124-32.818-32.904-32.832-86.098-0.044-118.97l7.808-7.774-101.086-101.124-7.734 7.712c-58.76 58.802-78.56 141.834-59.45 216.982-60.398 14.26-105.358 68.634-105.358 133.496-0.016 75.746 61.332 137.126 136.982 137.126 65.1-0.032 119.588-45.418 133.54-106.382 74.702 18.552 156.998-1.304 215.344-59.756l227.49-227.96-101.012-101.218z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"joomla",
						"brand",
						"cms"
					],
					"defaultCode": 61204,
					"grid": 16
				},
				{
					"id": 1565,
					"width": 877.7139739990234,
					"paths": [
						"M611.429 613.143l-91.429 91.429-86.286 86.857-17.143 17.143q-37.143 36.571-86.571 49.714t-98 1.143q-9.143 40-41.143 65.714t-73.714 25.714q-48.571 0-82.857-34.571t-34.286-83.143q0-41.143 25.429-73.143t64.857-41.143q-12.571-49.143 0.571-98.857t50.286-86.857l6.857-6.857 86.286 86.857-6.286 6.286q-21.143 21.143-21.143 50.857t21.143 51.429q21.143 21.143 50.857 21.143t50.857-21.143l17.143-17.143 86.286-86.857 92-91.429zM416.571 223.429l6.857 6.857-86.857 86.857-6.857-6.857q-21.143-21.143-50.857-21.143t-50.857 21.143-21.143 51.143 21.143 51.143l194.857 194.857-86.286 86.857-92-91.429-86.286-86.857-17.143-17.143q-38.857-38.286-51.429-91.143t2.857-102.571q-40-8.571-65.714-40.571t-25.714-73.714q0-48.571 34.286-83.143t82.857-34.571q43.429 0 76.286 28t39.714 70.286q48-11.429 96.857 2t85.429 50zM877.714 833.143q0 48.571-34.286 83.143t-82.857 34.571q-42.286 0-74.857-26.857t-40.571-67.429q-49.143 16-102.571 3.429t-92.286-51.429l-6.286-6.857 86.286-86.857 6.857 6.857q21.143 21.143 50.857 21.143t50.857-21.143 21.143-50.857-21.143-50.857l-195.429-195.429 86.857-86.857 178.286 178.286 16.571 17.143q36.571 36.571 50 86t1.429 98q43.429 6.286 72.286 39.143t28.857 76.857zM876.571 190.857q0 44-29.143 77.143t-72.571 39.429q14.857 48.571 1.714 100.857t-51.429 90.571l-6.857 6.857-86.286-86.857 6.857-6.857q21.143-21.143 21.143-50.857t-21.143-50.857-50.857-21.143-50.857 21.143l-195.429 195.429-86.857-86.857 92-91.429 86.857-86.857 16.571-17.143q38.286-38.286 90.857-51.143t101.714 2q6.286-42.857 39.143-72t77.429-29.143q48.571 0 82.857 34.571t34.286 83.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"joomla"
					],
					"defaultCode": 61866,
					"grid": 14
				},
				{
					"id": 1597,
					"width": 1170.2840576171875,
					"paths": [
						"M1028.571 441.143q63.429 26.286 102.571 83.143t39.143 126.571q0 93.714-67.429 160.286t-162.857 66.571q-2.286 0-6.571-0.286t-6-0.286h-695.429q-97.143-5.714-164.571-71.714t-67.429-160.286q0-62.857 31.429-116t84-84q-6.857-22.286-6.857-46.857 0-65.714 46.857-112t113.714-46.286q54.286 0 98.286 33.143 42.857-88 127.143-141.714t186.571-53.714q94.857 0 174.857 46t126.571 124.857 46.571 172q0 3.429-0.286 10.286t-0.286 10.286zM267.429 593.143q0 69.714 48 110.286t118.857 40.571q78.286 0 137.143-56.571-9.143-11.429-27.143-32.286t-24.857-28.857q-38.286 37.143-82.286 37.143-31.429 0-53.429-19.143t-22-50q0-30.286 22-49.714t52.286-19.429q25.143 0 48.286 12t41.714 31.429 37.143 42.857 39.429 46.857 44 42.857 55.429 31.429 69.429 12q69.143 0 116.857-40.857t47.714-108.857q0-69.143-48-109.714t-118.286-40.571q-81.714 0-137.714 55.429 8 9.143 16.857 19.429t19.714 22.857 16.571 19.429q37.714-36.571 81.143-36.571 29.714 0 52.571 18.857t22.857 48q0 32.571-21.143 52.286t-53.714 19.714q-24.571 0-47.143-12t-41.143-31.429-37.429-42.857-39.714-46.857-44.286-42.857-55.143-31.429-67.714-12q-69.714 0-118.286 40.286t-48.571 108.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"jsfiddle"
					],
					"defaultCode": 61900,
					"grid": 14
				},
				{
					"id": 591,
					"width": 1024,
					"paths": [
						"M768 256v-32c35.36 0 64-28.64 64-64v-64c0-35.36-28.64-64-64-64h-512c-35.36 0-64 28.64-64 64v64c0 35.36 28.64 64 64 64v32c-70.688 0-128 57.312-128 128v512c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-512c0-70.688-57.312-128-128-128zM736 256h-96v-32h96v32zM448 352h128v192h-128v-192zM416 320v-32h192v32h-192zM416 256v-32h192v32h-192zM768 64c17.632 0 32 14.368 32 32v64c0 17.632-14.368 32-32 32h-128v-128h128zM608 64v128h-192v-128h192zM224 160v-64c0-17.632 14.368-32 32-32h128v128h-128c-17.632 0-32-14.368-32-32zM288 224h96v32h-96v-32zM256 288h128v32c0 17.664 14.336 32 32 32v192c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-192c17.664 0 32-14.336 32-32v-32h128c52.928 0 96 43.072 96 96v256h-704v-256c0-52.928 43.072-96 96-96zM800 960h-576c-35.296 0-64-28.704-64-64v-224h704v224c0 35.296-28.704 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"keep",
						"store"
					],
					"grid": 32
				},
				{
					"id": 592,
					"width": 1024,
					"paths": [
						"M416 224v-192h192v192h-192zM640 224h128c35.36 0 64-28.64 64-64v-64c0-35.36-28.64-64-64-64h-128v192zM640 320c0 17.664-14.336 32-32 32v192c0 17.664-14.336 32-32 32h-128c-17.664 0-32-14.336-32-32v-192c-17.664 0-32-14.336-32-32v-64h-128c-70.688 0-128 57.312-128 128v256h768v-256c0-70.688-57.312-128-128-128h-128v64zM576 352h-128v192h128v-192zM128 672v224c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-224h-768zM608 320v-64h-192v64h192zM256 224h128v-192h-128c-35.36 0-64 28.64-64 64v64c0 35.36 28.64 64 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"keep",
						"store"
					],
					"grid": 32
				},
				{
					"id": 1050,
					"width": 1024,
					"paths": [
						"M529.952 526.048c-5.216-5.216-11.392-8.832-17.952-11.168v-114.88c0-8.832-7.168-16-16-16s-16 7.168-16 16v54.976c-2.016-2.816-4.096-5.6-6.624-8.128l-30.88-30.848c-24.96-24.96-65.536-24.96-90.496 0s-24.96 65.568 0 90.496l30.848 30.848c2.528 2.528 5.312 4.608 8.128 6.624h-54.976c-8.832 0-16 7.168-16 16s7.168 16 16 16h114.912c2.304 6.528 5.92 12.704 11.168 17.952 18.752 18.752 49.152 18.752 67.872 0 18.72-18.72 18.72-49.12 0-67.872zM450.752 514.752c-12.48 12.48-32.768 12.48-45.248 0l-30.848-30.848c-12.48-12.48-12.48-32.768 0-45.248s32.768-12.48 45.248 0l30.848 30.848c12.48 12.48 12.48 32.768 0 45.248zM654.048 686.048c-5.216 5.216-8.832 11.392-11.168 17.952h-114.88c-8.832 0-16 7.168-16 16s7.168 16 16 16h54.976c-2.816 2.016-5.6 4.096-8.128 6.624l-30.848 30.88c-24.96 24.96-24.96 65.536 0 90.496s65.568 24.96 90.496 0l30.848-30.848c2.528-2.528 4.608-5.312 6.624-8.128v54.976c0 8.832 7.168 16 16 16s16-7.168 16-16v-114.912c6.528-2.304 12.704-5.92 17.952-11.168 18.752-18.752 18.752-49.152 0-67.872-18.72-18.72-49.12-18.72-67.872 0zM642.752 810.496l-30.848 30.848c-12.48 12.48-32.768 12.48-45.248 0s-12.48-32.768 0-45.248l30.848-30.848c12.48-12.48 32.768-12.48 45.248 0s12.48 32.768 0 45.248zM757.856 215.168l-21.856-10.944v-12.224h32c17.664 0 32-14.304 32-32v-128c0-17.696-14.336-32-32-32h-512c-17.664 0-32 14.304-32 32v128c0 17.696 14.336 32 32 32h32v12.224l-21.856 10.944c-65.472 32.704-106.144 98.528-106.144 171.712v605.12c0 17.696 14.336 32 32 32h640c17.664 0 32-14.304 32-32v-605.12c0-73.184-40.672-139.008-106.144-171.712zM672 64h64v64h-64v-64zM576 64h64v64h-64v-64zM480 64h64v64h-64v-64zM384 64h64v64h-64v-64zM288 64h64v64h-64v-64zM800 960h-576v-573.12c0-48.8 27.104-92.672 70.752-114.464l21.824-10.944c21.856-10.88 35.424-32.8 35.424-57.248v-44.224h320v44.224c0 24.448 13.568 46.368 35.36 57.248l21.888 10.944c43.648 21.792 70.752 65.632 70.752 114.464v573.12z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"keep",
						"capture",
						"store"
					],
					"grid": 32
				},
				{
					"id": 2399,
					"paths": [
						"M704 0c-176.73 0-320 143.268-320 320 0 20.026 1.858 39.616 5.376 58.624l-389.376 389.376v192c0 35.346 28.654 64 64 64h64v-64h128v-128h128v-128h128l83.042-83.042c34.010 12.316 70.696 19.042 108.958 19.042 176.73 0 320-143.268 320-320s-143.27-320-320-320zM799.874 320.126c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key",
						"password",
						"login",
						"signin"
					],
					"defaultCode": 60234,
					"grid": 16
				},
				{
					"id": 3186,
					"paths": [
						"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM976 872h-156.028c-0.002 0-0.002 0.002-0.004 0.002 7.622-4.734 14.81-10.098 21.516-16.004l-0.002 0.002h134.518v16zM815.058 815.058c-21.242 21.242-49.318 32.942-79.058 32.942h-448c-29.74 0-57.816-11.7-79.058-32.942-21.244-21.242-32.942-49.318-32.942-79.058v-448c0-29.74 11.698-57.816 32.942-79.058 21.242-21.244 49.318-32.942 79.058-32.942h448c29.74 0 57.816 11.698 79.058 32.942 21.242 21.242 32.942 49.318 32.942 79.058v448c0 29.74-11.7 57.816-32.942 79.058zM976 840h-118.714c-0.002 0.002-0.002 0.004-0.004 0.004 4.368-5.082 8.432-10.428 12.146-16.030-0.006 0.010-0.010 0.018-0.016 0.026h106.588v16zM976 808h-97.274c2.632-5.184 5.008-10.516 7.074-16h90.2v16zM976 776h-85.098c-0.018 0.066-0.042 0.13-0.058 0.2 1.384-5.3 2.504-10.706 3.34-16.2h81.816v16zM976 744h-80.204c0 0.006-0.002 0.014-0.002 0.020 0.132-2.658 0.206-5.33 0.206-8.020v-8h80v16zM976 712h-80v-16h80v16zM976 680h-80v-16h80v16zM976 648h-80v-16h80v16zM976 616h-80v-16h80v16zM976 584h-80v-16h80v16zM976 552h-80v-16h80v16zM976 520h-80v-16h80v16zM976 488h-80v-16h80v16zM976 456h-80v-16h80v16zM976 424h-80v-16h80v16zM976 392h-80v-16h80v16zM976 360h-80v-16h80v16zM976 328h-80v-16h80v16zM976 296h-80v-8c0-2.69-0.072-5.362-0.206-8.020 0 0.006 0.002 0.012 0.002 0.020h80.204v16zM976 264h-81.816c-0.836-5.494-1.956-10.898-3.34-16.198 0.018 0.066 0.042 0.132 0.058 0.198h85.098v16zM976 232h-90.2c-2.066-5.484-4.442-10.816-7.074-16h97.274v16zM976 200h-106.588c0.006 0.008 0.010 0.016 0.016 0.024-3.712-5.6-7.776-10.944-12.142-16.024h118.714v16zM976 136h-88l-16 16h104v16h-120l-7 7c-29-29-69-47-113-47h-448c-88 0-160 72-160 160v448c0 44 18 84 47 113l-7 7h14.516c6.706 5.906 13.894 11.268 21.514 16.002 0 0-0.002-0.002-0.004-0.002h-52.026l-16 16h102.278c15.672 5.166 32.378 8 49.722 8h448c17.344 0 34.050-2.834 49.722-8h190.278v8c0 4.064-0.312 8.084-0.914 12.038 0.206-1.338 0.376-2.684 0.512-4.038h-855.598l-16 16h868.286c-2.76 8.698-7.024 16.882-12.66 24.252 2.026-2.65 3.876-5.404 5.542-8.252h-877.168l-16 16h880.896c-0.148 0.15-0.288 0.308-0.438 0.458-6.886 6.888-14.786 12.356-23.334 16.292h-834.248c-8.548-3.936-16.446-9.402-23.334-16.292-15.182-15.178-23.542-35.232-23.542-56.458v-768c0-21.228 8.36-41.278 23.542-56.458s35.23-23.542 56.458-23.542h768c21.226 0 41.28 8.36 56.458 23.542 0.15 0.15 0.29 0.308 0.438 0.458h-0.896l-16 16h29.166c-1.666-2.848-3.516-5.602-5.542-8.252 5.636 7.37 9.9 15.556 12.66 24.252h-52.284l-16 16h71.598c-0.134-1.354-0.306-2.7-0.512-4.040 0.602 3.954 0.914 7.974 0.914 12.040v8zM972.288 919.996c0.804-2.54 1.48-5.122 2.030-7.736-0.546 2.616-1.226 5.198-2.030 7.736zM974.358 912.080c0.252-1.214 0.468-2.438 0.662-3.666-0.194 1.228-0.412 2.452-0.662 3.666zM952.898 951.998c1.13-1.148 2.214-2.328 3.268-3.53-1.052 1.202-2.136 2.382-3.268 3.53zM956.594 947.972c0.988-1.146 1.946-2.312 2.862-3.504-0.916 1.192-1.872 2.36-2.862 3.504zM952.898 72.002c1.13 1.148 2.216 2.33 3.27 3.53-1.052-1.2-2.138-2.38-3.27-3.53zM956.594 76.026c0.988 1.148 1.946 2.316 2.864 3.508-0.916-1.194-1.876-2.362-2.864-3.508zM972.286 104.002c0.808 2.544 1.49 5.132 2.036 7.754-0.55-2.62-1.228-5.208-2.036-7.754zM974.358 111.916c0.252 1.222 0.47 2.452 0.666 3.688-0.196-1.236-0.414-2.466-0.666-3.688zM690.274 768h96.798l-235.072-512.998h-80l-235.072 512.998h96.798l58.654-128h239.24l58.654 128zM421.708 576l90.292-197.046 90.292 197.046h-180.584z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key-A",
						"button",
						"dualtone"
					],
					"defaultCode": 61021,
					"grid": 16
				},
				{
					"id": 3189,
					"paths": [
						"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM976 872h-156.028c-0.002 0-0.002 0.002-0.004 0.002 7.622-4.734 14.81-10.098 21.516-16.004l-0.002 0.002h134.518v16zM815.058 815.058c-21.242 21.242-49.318 32.942-79.058 32.942h-448c-29.74 0-57.816-11.7-79.058-32.942-21.244-21.242-32.942-49.318-32.942-79.058v-448c0-29.74 11.698-57.816 32.942-79.058 21.242-21.244 49.318-32.942 79.058-32.942h448c29.74 0 57.816 11.698 79.058 32.942 21.242 21.242 32.942 49.318 32.942 79.058v448c0 29.74-11.7 57.816-32.942 79.058zM976 840h-118.714c-0.002 0.002-0.002 0.004-0.004 0.004 4.368-5.082 8.432-10.428 12.146-16.030-0.006 0.010-0.010 0.018-0.016 0.026h106.588v16zM976 808h-97.274c2.632-5.184 5.008-10.516 7.074-16h90.2v16zM976 776h-85.098c-0.018 0.066-0.042 0.13-0.058 0.2 1.384-5.3 2.504-10.706 3.34-16.2h81.816v16zM976 744h-80.204c0 0.006-0.002 0.014-0.002 0.020 0.132-2.658 0.206-5.33 0.206-8.020v-8h80v16zM976 712h-80v-16h80v16zM976 680h-80v-16h80v16zM976 648h-80v-16h80v16zM976 616h-80v-16h80v16zM976 584h-80v-16h80v16zM976 552h-80v-16h80v16zM976 520h-80v-16h80v16zM976 488h-80v-16h80v16zM976 456h-80v-16h80v16zM976 424h-80v-16h80v16zM976 392h-80v-16h80v16zM976 360h-80v-16h80v16zM976 328h-80v-16h80v16zM976 296h-80v-8c0-2.69-0.072-5.362-0.206-8.020 0 0.006 0.002 0.012 0.002 0.020h80.204v16zM976 264h-81.816c-0.836-5.494-1.956-10.898-3.34-16.198 0.018 0.066 0.042 0.132 0.058 0.198h85.098v16zM976 232h-90.2c-2.066-5.484-4.442-10.816-7.074-16h97.274v16zM976 200h-106.588c0.006 0.008 0.010 0.016 0.016 0.024-3.712-5.6-7.776-10.944-12.142-16.024h118.714v16zM976 136h-88l-16 16h104v16h-120l-7 7c-29-29-69-47-113-47h-448c-88 0-160 72-160 160v448c0 44 18 84 47 113l-7 7h14.516c6.706 5.906 13.894 11.268 21.514 16.002 0 0-0.002-0.002-0.004-0.002h-52.026l-16 16h102.278c15.672 5.166 32.378 8 49.722 8h448c17.344 0 34.050-2.834 49.722-8h190.278v8c0 4.064-0.312 8.084-0.914 12.038 0.206-1.338 0.376-2.684 0.512-4.038h-855.598l-16 16h868.286c-2.76 8.698-7.024 16.882-12.66 24.252 2.026-2.65 3.876-5.404 5.542-8.252h-877.168l-16 16h880.896c-0.148 0.15-0.288 0.308-0.438 0.458-6.886 6.888-14.786 12.356-23.334 16.292h-834.248c-8.548-3.936-16.446-9.402-23.334-16.292-15.182-15.178-23.542-35.232-23.542-56.458v-768c0-21.228 8.36-41.278 23.542-56.458s35.23-23.542 56.458-23.542h768c21.226 0 41.28 8.36 56.458 23.542 0.15 0.15 0.29 0.308 0.438 0.458h-0.896l-16 16h29.166c-1.666-2.848-3.516-5.602-5.542-8.252 5.636 7.37 9.9 15.556 12.66 24.252h-52.284l-16 16h71.598c-0.134-1.354-0.306-2.7-0.512-4.040 0.602 3.954 0.914 7.974 0.914 12.040v8zM972.288 919.996c0.804-2.54 1.48-5.122 2.030-7.736-0.546 2.616-1.226 5.198-2.030 7.736zM974.358 912.080c0.252-1.214 0.468-2.438 0.662-3.666-0.194 1.228-0.412 2.452-0.662 3.666zM952.898 951.998c1.13-1.148 2.214-2.328 3.268-3.53-1.052 1.202-2.136 2.382-3.268 3.53zM956.594 947.972c0.988-1.146 1.946-2.312 2.862-3.504-0.916 1.192-1.872 2.36-2.862 3.504zM952.898 72.002c1.13 1.148 2.216 2.33 3.27 3.53-1.052-1.2-2.138-2.38-3.27-3.53zM956.594 76.026c0.988 1.148 1.946 2.316 2.864 3.508-0.916-1.194-1.876-2.362-2.864-3.508zM972.286 104.002c0.808 2.544 1.49 5.132 2.036 7.754-0.55-2.62-1.228-5.208-2.036-7.754zM974.358 111.916c0.252 1.222 0.47 2.452 0.666 3.688-0.196-1.236-0.414-2.466-0.666-3.688zM320 512l192 192 192-192h-128v-192h-128v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key-down",
						"button",
						"down",
						"bottom",
						"arrow",
						"dualtone"
					],
					"defaultCode": 61024,
					"grid": 16
				},
				{
					"id": 3185,
					"paths": [
						"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM976 872h-156.028c-0.002 0-0.002 0.002-0.004 0.002 7.622-4.734 14.81-10.098 21.516-16.004l-0.002 0.002h134.518v16zM815.058 815.058c-21.242 21.242-49.318 32.942-79.058 32.942h-448c-29.74 0-57.816-11.7-79.058-32.942-21.244-21.242-32.942-49.318-32.942-79.058v-448c0-29.74 11.698-57.816 32.942-79.058 21.242-21.244 49.318-32.942 79.058-32.942h448c29.74 0 57.816 11.698 79.058 32.942 21.242 21.242 32.942 49.318 32.942 79.058v448c0 29.74-11.7 57.816-32.942 79.058zM976 840h-118.714c-0.002 0.002-0.002 0.004-0.004 0.004 4.368-5.082 8.432-10.428 12.146-16.030-0.006 0.010-0.010 0.018-0.016 0.026h106.588v16zM976 808h-97.274c2.632-5.184 5.008-10.516 7.074-16h90.2v16zM976 776h-85.098c-0.018 0.066-0.042 0.13-0.058 0.2 1.384-5.3 2.504-10.706 3.34-16.2h81.816v16zM976 744h-80.204c0 0.006-0.002 0.014-0.002 0.020 0.132-2.658 0.206-5.33 0.206-8.020v-8h80v16zM976 712h-80v-16h80v16zM976 680h-80v-16h80v16zM976 648h-80v-16h80v16zM976 616h-80v-16h80v16zM976 584h-80v-16h80v16zM976 552h-80v-16h80v16zM976 520h-80v-16h80v16zM976 488h-80v-16h80v16zM976 456h-80v-16h80v16zM976 424h-80v-16h80v16zM976 392h-80v-16h80v16zM976 360h-80v-16h80v16zM976 328h-80v-16h80v16zM976 296h-80v-8c0-2.69-0.072-5.362-0.206-8.020 0 0.006 0.002 0.012 0.002 0.020h80.204v16zM976 264h-81.816c-0.836-5.494-1.956-10.898-3.34-16.198 0.018 0.066 0.042 0.132 0.058 0.198h85.098v16zM976 232h-90.2c-2.066-5.484-4.442-10.816-7.074-16h97.274v16zM976 200h-106.588c0.006 0.008 0.010 0.016 0.016 0.024-3.712-5.6-7.776-10.944-12.142-16.024h118.714v16zM976 136h-88l-16 16h104v16h-120l-7 7c-29-29-69-47-113-47h-448c-88 0-160 72-160 160v448c0 44 18 84 47 113l-7 7h14.516c6.706 5.906 13.894 11.268 21.514 16.002 0 0-0.002-0.002-0.004-0.002h-52.026l-16 16h102.278c15.672 5.166 32.378 8 49.722 8h448c17.344 0 34.050-2.834 49.722-8h190.278v8c0 4.064-0.312 8.084-0.914 12.038 0.206-1.338 0.376-2.684 0.512-4.038h-855.598l-16 16h868.286c-2.76 8.698-7.024 16.882-12.66 24.252 2.026-2.65 3.876-5.404 5.542-8.252h-877.168l-16 16h880.896c-0.148 0.15-0.288 0.308-0.438 0.458-6.886 6.888-14.786 12.356-23.334 16.292h-834.248c-8.548-3.936-16.446-9.402-23.334-16.292-15.182-15.178-23.542-35.232-23.542-56.458v-768c0-21.228 8.36-41.278 23.542-56.458s35.23-23.542 56.458-23.542h768c21.226 0 41.28 8.36 56.458 23.542 0.15 0.15 0.29 0.308 0.438 0.458h-0.896l-16 16h29.166c-1.666-2.848-3.516-5.602-5.542-8.252 5.636 7.37 9.9 15.556 12.66 24.252h-52.284l-16 16h71.598c-0.134-1.354-0.306-2.7-0.512-4.040 0.602 3.954 0.914 7.974 0.914 12.040v8zM972.288 919.996c0.804-2.54 1.48-5.122 2.030-7.736-0.546 2.616-1.226 5.198-2.030 7.736zM974.358 912.080c0.252-1.214 0.468-2.438 0.662-3.666-0.194 1.228-0.412 2.452-0.662 3.666zM952.898 951.998c1.13-1.148 2.214-2.328 3.268-3.53-1.052 1.202-2.136 2.382-3.268 3.53zM956.594 947.972c0.988-1.146 1.946-2.312 2.862-3.504-0.916 1.192-1.872 2.36-2.862 3.504zM952.898 72.002c1.13 1.148 2.216 2.33 3.27 3.53-1.052-1.2-2.138-2.38-3.27-3.53zM956.594 76.026c0.988 1.148 1.946 2.316 2.864 3.508-0.916-1.194-1.876-2.362-2.864-3.508zM972.286 104.002c0.808 2.544 1.49 5.132 2.036 7.754-0.55-2.62-1.228-5.208-2.036-7.754zM974.358 111.916c0.252 1.222 0.47 2.452 0.666 3.688-0.196-1.236-0.414-2.466-0.666-3.688z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key-keyboard",
						"button",
						"dualtone"
					],
					"defaultCode": 61020,
					"grid": 16
				},
				{
					"id": 3190,
					"paths": [
						"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM976 872h-156.028c-0.002 0-0.002 0.002-0.004 0.002 7.622-4.734 14.81-10.098 21.516-16.004l-0.002 0.002h134.518v16zM815.058 815.058c-21.242 21.242-49.318 32.942-79.058 32.942h-448c-29.74 0-57.816-11.7-79.058-32.942-21.244-21.242-32.942-49.318-32.942-79.058v-448c0-29.74 11.698-57.816 32.942-79.058 21.242-21.244 49.318-32.942 79.058-32.942h448c29.74 0 57.816 11.698 79.058 32.942 21.242 21.242 32.942 49.318 32.942 79.058v448c0 29.74-11.7 57.816-32.942 79.058zM976 840h-118.714c-0.002 0.002-0.002 0.004-0.004 0.004 4.368-5.082 8.432-10.428 12.146-16.030-0.006 0.010-0.010 0.018-0.016 0.026h106.588v16zM976 808h-97.274c2.632-5.184 5.008-10.516 7.074-16h90.2v16zM976 776h-85.098c-0.018 0.066-0.042 0.13-0.058 0.2 1.384-5.3 2.504-10.706 3.34-16.2h81.816v16zM976 744h-80.204c0 0.006-0.002 0.014-0.002 0.020 0.132-2.658 0.206-5.33 0.206-8.020v-8h80v16zM976 712h-80v-16h80v16zM976 680h-80v-16h80v16zM976 648h-80v-16h80v16zM976 616h-80v-16h80v16zM976 584h-80v-16h80v16zM976 552h-80v-16h80v16zM976 520h-80v-16h80v16zM976 488h-80v-16h80v16zM976 456h-80v-16h80v16zM976 424h-80v-16h80v16zM976 392h-80v-16h80v16zM976 360h-80v-16h80v16zM976 328h-80v-16h80v16zM976 296h-80v-8c0-2.69-0.072-5.362-0.206-8.020 0 0.006 0.002 0.012 0.002 0.020h80.204v16zM976 264h-81.816c-0.836-5.494-1.956-10.898-3.34-16.198 0.018 0.066 0.042 0.132 0.058 0.198h85.098v16zM976 232h-90.2c-2.066-5.484-4.442-10.816-7.074-16h97.274v16zM976 200h-106.588c0.006 0.008 0.010 0.016 0.016 0.024-3.712-5.6-7.776-10.944-12.142-16.024h118.714v16zM976 136h-88l-16 16h104v16h-120l-7 7c-29-29-69-47-113-47h-448c-88 0-160 72-160 160v448c0 44 18 84 47 113l-7 7h14.516c6.706 5.906 13.894 11.268 21.514 16.002 0 0-0.002-0.002-0.004-0.002h-52.026l-16 16h102.278c15.672 5.166 32.378 8 49.722 8h448c17.344 0 34.050-2.834 49.722-8h190.278v8c0 4.064-0.312 8.084-0.914 12.038 0.206-1.338 0.376-2.684 0.512-4.038h-855.598l-16 16h868.286c-2.76 8.698-7.024 16.882-12.66 24.252 2.026-2.65 3.876-5.404 5.542-8.252h-877.168l-16 16h880.896c-0.148 0.15-0.288 0.308-0.438 0.458-6.886 6.888-14.786 12.356-23.334 16.292h-834.248c-8.548-3.936-16.446-9.402-23.334-16.292-15.182-15.178-23.542-35.232-23.542-56.458v-768c0-21.228 8.36-41.278 23.542-56.458s35.23-23.542 56.458-23.542h768c21.226 0 41.28 8.36 56.458 23.542 0.15 0.15 0.29 0.308 0.438 0.458h-0.896l-16 16h29.166c-1.666-2.848-3.516-5.602-5.542-8.252 5.636 7.37 9.9 15.556 12.66 24.252h-52.284l-16 16h71.598c-0.134-1.354-0.306-2.7-0.512-4.040 0.602 3.954 0.914 7.974 0.914 12.040v8zM972.288 919.996c0.804-2.54 1.48-5.122 2.030-7.736-0.546 2.616-1.226 5.198-2.030 7.736zM974.358 912.080c0.252-1.214 0.468-2.438 0.662-3.666-0.194 1.228-0.412 2.452-0.662 3.666zM952.898 951.998c1.13-1.148 2.214-2.328 3.268-3.53-1.052 1.202-2.136 2.382-3.268 3.53zM956.594 947.972c0.988-1.146 1.946-2.312 2.862-3.504-0.916 1.192-1.872 2.36-2.862 3.504zM952.898 72.002c1.13 1.148 2.216 2.33 3.27 3.53-1.052-1.2-2.138-2.38-3.27-3.53zM956.594 76.026c0.988 1.148 1.946 2.316 2.864 3.508-0.916-1.194-1.876-2.362-2.864-3.508zM972.286 104.002c0.808 2.544 1.49 5.132 2.036 7.754-0.55-2.62-1.228-5.208-2.036-7.754zM974.358 111.916c0.252 1.222 0.47 2.452 0.666 3.688-0.196-1.236-0.414-2.466-0.666-3.688zM512 320l-192 192 192 192v-128h192v-128h-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key-left",
						"button",
						"left",
						"arrow",
						"dualtone"
					],
					"defaultCode": 61025,
					"grid": 16
				},
				{
					"id": 3188,
					"paths": [
						"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM976 872h-156.028c-0.002 0-0.002 0.002-0.004 0.002 7.622-4.734 14.81-10.098 21.516-16.004l-0.002 0.002h134.518v16zM815.058 815.058c-21.242 21.242-49.318 32.942-79.058 32.942h-448c-29.74 0-57.816-11.7-79.058-32.942-21.244-21.242-32.942-49.318-32.942-79.058v-448c0-29.74 11.698-57.816 32.942-79.058 21.242-21.244 49.318-32.942 79.058-32.942h448c29.74 0 57.816 11.698 79.058 32.942 21.242 21.242 32.942 49.318 32.942 79.058v448c0 29.74-11.7 57.816-32.942 79.058zM976 840h-118.714c-0.002 0.002-0.002 0.004-0.004 0.004 4.368-5.082 8.432-10.428 12.146-16.030-0.006 0.010-0.010 0.018-0.016 0.026h106.588v16zM976 808h-97.274c2.632-5.184 5.008-10.516 7.074-16h90.2v16zM976 776h-85.098c-0.018 0.066-0.042 0.13-0.058 0.2 1.384-5.3 2.504-10.706 3.34-16.2h81.816v16zM976 744h-80.204c0 0.006-0.002 0.014-0.002 0.020 0.132-2.658 0.206-5.33 0.206-8.020v-8h80v16zM976 712h-80v-16h80v16zM976 680h-80v-16h80v16zM976 648h-80v-16h80v16zM976 616h-80v-16h80v16zM976 584h-80v-16h80v16zM976 552h-80v-16h80v16zM976 520h-80v-16h80v16zM976 488h-80v-16h80v16zM976 456h-80v-16h80v16zM976 424h-80v-16h80v16zM976 392h-80v-16h80v16zM976 360h-80v-16h80v16zM976 328h-80v-16h80v16zM976 296h-80v-8c0-2.69-0.072-5.362-0.206-8.020 0 0.006 0.002 0.012 0.002 0.020h80.204v16zM976 264h-81.816c-0.836-5.494-1.956-10.898-3.34-16.198 0.018 0.066 0.042 0.132 0.058 0.198h85.098v16zM976 232h-90.2c-2.066-5.484-4.442-10.816-7.074-16h97.274v16zM976 200h-106.588c0.006 0.008 0.010 0.016 0.016 0.024-3.712-5.6-7.776-10.944-12.142-16.024h118.714v16zM976 136h-88l-16 16h104v16h-120l-7 7c-29-29-69-47-113-47h-448c-88 0-160 72-160 160v448c0 44 18 84 47 113l-7 7h14.516c6.706 5.906 13.894 11.268 21.514 16.002 0 0-0.002-0.002-0.004-0.002h-52.026l-16 16h102.278c15.672 5.166 32.378 8 49.722 8h448c17.344 0 34.050-2.834 49.722-8h190.278v8c0 4.064-0.312 8.084-0.914 12.038 0.206-1.338 0.376-2.684 0.512-4.038h-855.598l-16 16h868.286c-2.76 8.698-7.024 16.882-12.66 24.252 2.026-2.65 3.876-5.404 5.542-8.252h-877.168l-16 16h880.896c-0.148 0.15-0.288 0.308-0.438 0.458-6.886 6.888-14.786 12.356-23.334 16.292h-834.248c-8.548-3.936-16.446-9.402-23.334-16.292-15.182-15.178-23.542-35.232-23.542-56.458v-768c0-21.228 8.36-41.278 23.542-56.458s35.23-23.542 56.458-23.542h768c21.226 0 41.28 8.36 56.458 23.542 0.15 0.15 0.29 0.308 0.438 0.458h-0.896l-16 16h29.166c-1.666-2.848-3.516-5.602-5.542-8.252 5.636 7.37 9.9 15.556 12.66 24.252h-52.284l-16 16h71.598c-0.134-1.354-0.306-2.7-0.512-4.040 0.602 3.954 0.914 7.974 0.914 12.040v8zM972.288 919.996c0.804-2.54 1.48-5.122 2.030-7.736-0.546 2.616-1.226 5.198-2.030 7.736zM974.358 912.080c0.252-1.214 0.468-2.438 0.662-3.666-0.194 1.228-0.412 2.452-0.662 3.666zM952.898 951.998c1.13-1.148 2.214-2.328 3.268-3.53-1.052 1.202-2.136 2.382-3.268 3.53zM956.594 947.972c0.988-1.146 1.946-2.312 2.862-3.504-0.916 1.192-1.872 2.36-2.862 3.504zM952.898 72.002c1.13 1.148 2.216 2.33 3.27 3.53-1.052-1.2-2.138-2.38-3.27-3.53zM956.594 76.026c0.988 1.148 1.946 2.316 2.864 3.508-0.916-1.194-1.876-2.362-2.864-3.508zM972.286 104.002c0.808 2.544 1.49 5.132 2.036 7.754-0.55-2.62-1.228-5.208-2.036-7.754zM974.358 111.916c0.252 1.222 0.47 2.452 0.666 3.688-0.196-1.236-0.414-2.466-0.666-3.688zM512 704l192-192-192-192v128h-192v128h192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key-right",
						"button",
						"right",
						"arrow",
						"dualtone"
					],
					"defaultCode": 61023,
					"grid": 16
				},
				{
					"id": 3187,
					"paths": [
						"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM976 872h-156.028c-0.002 0-0.002 0.002-0.004 0.002 7.622-4.734 14.81-10.098 21.516-16.004l-0.002 0.002h134.518v16zM815.058 815.058c-21.242 21.242-49.318 32.942-79.058 32.942h-448c-29.74 0-57.816-11.7-79.058-32.942-21.244-21.242-32.942-49.318-32.942-79.058v-448c0-29.74 11.698-57.816 32.942-79.058 21.242-21.244 49.318-32.942 79.058-32.942h448c29.74 0 57.816 11.698 79.058 32.942 21.242 21.242 32.942 49.318 32.942 79.058v448c0 29.74-11.7 57.816-32.942 79.058zM976 840h-118.714c-0.002 0.002-0.002 0.004-0.004 0.004 4.368-5.082 8.432-10.428 12.146-16.030-0.006 0.010-0.010 0.018-0.016 0.026h106.588v16zM976 808h-97.274c2.632-5.184 5.008-10.516 7.074-16h90.2v16zM976 776h-85.098c-0.018 0.066-0.042 0.13-0.058 0.2 1.384-5.3 2.504-10.706 3.34-16.2h81.816v16zM976 744h-80.204c0 0.006-0.002 0.014-0.002 0.020 0.132-2.658 0.206-5.33 0.206-8.020v-8h80v16zM976 712h-80v-16h80v16zM976 680h-80v-16h80v16zM976 648h-80v-16h80v16zM976 616h-80v-16h80v16zM976 584h-80v-16h80v16zM976 552h-80v-16h80v16zM976 520h-80v-16h80v16zM976 488h-80v-16h80v16zM976 456h-80v-16h80v16zM976 424h-80v-16h80v16zM976 392h-80v-16h80v16zM976 360h-80v-16h80v16zM976 328h-80v-16h80v16zM976 296h-80v-8c0-2.69-0.072-5.362-0.206-8.020 0 0.006 0.002 0.012 0.002 0.020h80.204v16zM976 264h-81.816c-0.836-5.494-1.956-10.898-3.34-16.198 0.018 0.066 0.042 0.132 0.058 0.198h85.098v16zM976 232h-90.2c-2.066-5.484-4.442-10.816-7.074-16h97.274v16zM976 200h-106.588c0.006 0.008 0.010 0.016 0.016 0.024-3.712-5.6-7.776-10.944-12.142-16.024h118.714v16zM976 136h-88l-16 16h104v16h-120l-7 7c-29-29-69-47-113-47h-448c-88 0-160 72-160 160v448c0 44 18 84 47 113l-7 7h14.516c6.706 5.906 13.894 11.268 21.514 16.002 0 0-0.002-0.002-0.004-0.002h-52.026l-16 16h102.278c15.672 5.166 32.378 8 49.722 8h448c17.344 0 34.050-2.834 49.722-8h190.278v8c0 4.064-0.312 8.084-0.914 12.038 0.206-1.338 0.376-2.684 0.512-4.038h-855.598l-16 16h868.286c-2.76 8.698-7.024 16.882-12.66 24.252 2.026-2.65 3.876-5.404 5.542-8.252h-877.168l-16 16h880.896c-0.148 0.15-0.288 0.308-0.438 0.458-6.886 6.888-14.786 12.356-23.334 16.292h-834.248c-8.548-3.936-16.446-9.402-23.334-16.292-15.182-15.178-23.542-35.232-23.542-56.458v-768c0-21.228 8.36-41.278 23.542-56.458s35.23-23.542 56.458-23.542h768c21.226 0 41.28 8.36 56.458 23.542 0.15 0.15 0.29 0.308 0.438 0.458h-0.896l-16 16h29.166c-1.666-2.848-3.516-5.602-5.542-8.252 5.636 7.37 9.9 15.556 12.66 24.252h-52.284l-16 16h71.598c-0.134-1.354-0.306-2.7-0.512-4.040 0.602 3.954 0.914 7.974 0.914 12.040v8zM972.288 919.996c0.804-2.54 1.48-5.122 2.030-7.736-0.546 2.616-1.226 5.198-2.030 7.736zM974.358 912.080c0.252-1.214 0.468-2.438 0.662-3.666-0.194 1.228-0.412 2.452-0.662 3.666zM952.898 951.998c1.13-1.148 2.214-2.328 3.268-3.53-1.052 1.202-2.136 2.382-3.268 3.53zM956.594 947.972c0.988-1.146 1.946-2.312 2.862-3.504-0.916 1.192-1.872 2.36-2.862 3.504zM952.898 72.002c1.13 1.148 2.216 2.33 3.27 3.53-1.052-1.2-2.138-2.38-3.27-3.53zM956.594 76.026c0.988 1.148 1.946 2.316 2.864 3.508-0.916-1.194-1.876-2.362-2.864-3.508zM972.286 104.002c0.808 2.544 1.49 5.132 2.036 7.754-0.55-2.62-1.228-5.208-2.036-7.754zM974.358 111.916c0.252 1.222 0.47 2.452 0.666 3.688-0.196-1.236-0.414-2.466-0.666-3.688zM704 512l-192-192-192 192h128v192h128v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key-up",
						"button",
						"up",
						"arrow",
						"top",
						"dualtone"
					],
					"defaultCode": 61022,
					"grid": 16
				},
				{
					"id": 2400,
					"paths": [
						"M1002.132 314.242l-101.106-101.104c-24.792-24.794-65.37-65.368-90.162-90.164l-101.106-101.104c-24.792-24.794-68.954-29.166-98.13-9.716l-276.438 184.292c-29.176 19.452-40.218 61.028-24.536 92.39l70.486 140.974c2.154 4.306 4.646 8.896 7.39 13.66l-356.53 356.53-32 224h192v-64h128v-128h128v-128h128v-71.186c6.396 3.812 12.534 7.216 18.192 10.044l140.97 70.488c31.366 15.682 72.94 4.638 92.39-24.538l184.294-276.44c19.454-29.172 15.078-73.33-9.714-98.126zM150.628 854.626l-45.254-45.254 311.572-311.57 45.254 45.254-311.572 311.57zM917.020 423.764l-45.256 45.256c-12.446 12.444-32.808 12.444-45.254 0l-271.53-271.53c-12.446-12.444-12.446-32.81 0-45.254l45.256-45.256c12.446-12.444 32.808-12.444 45.254 0l271.53 271.53c12.446 12.444 12.446 32.81 0 45.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key",
						"password",
						"login",
						"signin"
					],
					"defaultCode": 60235,
					"grid": 16
				},
				{
					"id": 2401,
					"paths": [
						"M732 0c-161.010 0-292 130.99-292 292 0 67.558 23.070 129.826 61.736 179.356l-427.192 427.188c-14.056 14.056-14.056 36.852 0 50.908 7.030 7.034 16.242 10.548 25.456 10.548 9.212 0 18.426-3.516 25.456-10.544l130.544-130.544 77.090 77.088-66.544 66.544c-14.056 14.056-14.056 36.852 0 50.908 7.028 7.032 16.242 10.548 25.454 10.548 9.21 0 18.426-3.516 25.456-10.544l184-184c14.060-14.056 14.060-36.852 0-50.908-14.056-14.058-36.854-14.058-50.912 0l-66.544 66.542-77.088-77.090 245.734-245.734c49.53 38.664 111.796 61.734 179.352 61.734 161.012 0 292.002-130.99 292.002-292s-130.99-292-292-292zM732 512c-121.308 0-220-98.692-220-220s98.692-220 220-220c121.306 0 220 98.692 220 220s-98.69 220-220 220z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key",
						"password",
						"login",
						"signin"
					],
					"defaultCode": 60236,
					"grid": 16
				},
				{
					"id": 2402,
					"paths": [
						"M732 0c-161.010 0-292 130.99-292 292 0 67.558 23.070 129.826 61.736 179.356l-427.192 427.188c-14.058 14.058-14.058 36.852 0 50.91 7.030 7.032 16.242 10.546 25.456 10.546 9.212 0 18.426-3.516 25.456-10.544l34.544-34.544 98.544 98.542c7.030 7.030 16.244 10.546 25.456 10.546s18.426-3.516 25.456-10.544c14.058-14.058 14.058-36.852 0-50.91l-98.544-98.546 77.088-77.088 98.544 98.542c7.030 7.030 16.244 10.546 25.456 10.546s18.426-3.516 25.456-10.544c14.058-14.058 14.058-36.852 0-50.91l-98.544-98.546 213.734-213.734c49.53 38.664 111.796 61.734 179.354 61.734 161.010 0 292-130.99 292-292s-130.99-292-292-292zM732 512c-121.308 0-220-98.692-220-220s98.692-220 220-220 220 98.692 220 220-98.69 220-220 220z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key",
						"password",
						"login",
						"signin"
					],
					"defaultCode": 60237,
					"grid": 16
				},
				{
					"id": 2403,
					"paths": [
						"M960 384h-482.256c-44.264-76.516-126.99-128-221.744-128-141.384 0-256 114.616-256 256 0 141.382 114.616 256 256 256 94.754 0 177.478-51.484 221.744-128h34.256l64-64h64v64h64l64-64h64v64h64l128-128-64-128zM192 602.51c-49.988 0-90.51-40.524-90.51-90.51 0-49.988 40.522-90.51 90.51-90.51s90.51 40.522 90.51 90.51c0 49.986-40.522 90.51-90.51 90.51zM512 480v-32h384l16 32h-400z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key",
						"password",
						"login",
						"signin"
					],
					"defaultCode": 60238,
					"grid": 16
				},
				{
					"id": 1303,
					"width": 961.7139434814453,
					"paths": [
						"M475.429 292.571q0-45.714-32-77.714t-77.714-32-77.714 32-32 77.714q0 24 10.857 47.429-23.429-10.857-47.429-10.857-45.714 0-77.714 32t-32 77.714 32 77.714 77.714 32 77.714-32 32-77.714q0-24-10.857-47.429 23.429 10.857 47.429 10.857 45.714 0 77.714-32t32-77.714zM961.714 694.857q0 9.714-28 37.714t-37.714 28q-5.143 0-16.286-9.143t-20.857-18.857-22-22.857-14-14.857l-54.857 54.857 125.714 125.714q16 16 16 38.857 0 24-22.286 46.286t-46.286 22.286q-22.857 0-38.857-16l-383.429-383.429q-100.571 74.857-208.571 74.857-93.143 0-151.714-58.571t-58.571-151.714q0-91.429 54.286-178.857t141.714-141.714 178.857-54.286q93.143 0 151.714 58.571t58.571 151.714q0 108-74.857 208.571l202.857 202.857 54.857-54.857q-1.714-1.714-14.857-14t-22.857-22-18.857-20.857-9.143-16.286q0-9.714 28-37.714t37.714-28q7.429 0 13.143 5.714 3.429 3.429 26.286 25.429t46.857 45.429 49.429 49.143 41.714 44.571 16.286 23.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"key"
					],
					"defaultCode": 61572,
					"grid": 14
				},
				{
					"id": 2181,
					"width": 1152,
					"paths": [
						"M1088 128h-1024c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h1024c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64zM640 256h128v128h-128v-128zM832 448v128h-128v-128h128zM448 256h128v128h-128v-128zM640 448v128h-128v-128h128zM256 256h128v128h-128v-128zM448 448v128h-128v-128h128zM128 256h64v128h-64v-128zM128 448h128v128h-128v-128zM192 768h-64v-128h64v128zM768 768h-512v-128h512v128zM1024 768h-192v-128h192v128zM1024 576h-128v-128h128v128zM1024 384h-192v-128h192v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"keyboard",
						"typing",
						"type"
					],
					"defaultCode": 60016,
					"grid": 16
				},
				{
					"id": 1432,
					"width": 1097.142951965332,
					"paths": [
						"M219.429 667.429v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM292.571 521.143v54.857q0 9.143-9.143 9.143h-128q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h128q9.143 0 9.143 9.143zM219.429 374.857v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM804.571 667.429v54.857q0 9.143-9.143 9.143h-493.714q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h493.714q9.143 0 9.143 9.143zM438.857 521.143v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM365.714 374.857v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM585.143 521.143v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM512 374.857v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM731.429 521.143v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM950.857 667.429v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM658.286 374.857v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM804.571 374.857v54.857q0 9.143-9.143 9.143h-54.857q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM950.857 374.857v201.143q0 9.143-9.143 9.143h-128q-9.143 0-9.143-9.143v-54.857q0-9.143 9.143-9.143h64v-137.143q0-9.143 9.143-9.143h54.857q9.143 0 9.143 9.143zM1024 804.571v-512h-950.857v512h950.857zM1097.143 292.571v512q0 30.286-21.429 51.714t-51.714 21.429h-950.857q-30.286 0-51.714-21.429t-21.429-51.714v-512q0-30.286 21.429-51.714t51.714-21.429h950.857q30.286 0 51.714 21.429t21.429 51.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"keyboard-o"
					],
					"defaultCode": 61724,
					"grid": 14
				},
				{
					"id": 2182,
					"paths": [
						"M896 256h-832c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h832c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64zM896 767.884c-0.034 0.040-0.076 0.082-0.116 0.116h-831.77c-0.040-0.034-0.082-0.076-0.114-0.116v-447.77c0.034-0.040 0.076-0.082 0.114-0.114h831.77c0.040 0.034 0.082 0.076 0.116 0.116v447.768zM256 640h448v64h-448zM704 512h64v64h-64zM576 512h64v64h-64zM448 512h64v64h-64zM320 512h64v64h-64zM192 512h64v64h-64zM640 384h64v64h-64zM768 384h64v64h-64zM512 384h64v64h-64zM384 384h64v64h-64zM256 384h64v64h-64zM128 384h64v64h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"keyboard",
						"typing",
						"type"
					],
					"defaultCode": 60017,
					"grid": 16
				},
				{
					"id": 150,
					"paths": [
						"M896 819.2h-819.2c-42.347 0-76.8-34.451-76.8-76.8v-409.6c0-42.347 34.453-76.8 76.8-76.8h819.2c42.349 0 76.8 34.453 76.8 76.8v409.6c0 42.349-34.451 76.8-76.8 76.8zM76.8 307.2c-14.115 0-25.6 11.485-25.6 25.6v409.6c0 14.115 11.485 25.6 25.6 25.6h819.2c14.115 0 25.6-11.485 25.6-25.6v-409.6c0-14.115-11.485-25.6-25.6-25.6h-819.2z",
						"M179.2 409.6h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M844.8 409.6h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M230.4 512h-102.4c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h102.4c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M179.2 716.8h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M588.8 716.8h-307.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h307.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M742.4 716.8h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M844.8 614.4h-153.6c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h128v-76.8c0-14.139 11.461-25.6 25.6-25.6s25.6 11.461 25.6 25.6v102.4c0 14.139-11.461 25.6-25.6 25.6z",
						"M281.6 614.4h-153.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h153.6c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M307.2 384c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M409.6 384c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M512 384c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M614.4 384c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M716.8 384c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M358.4 486.4c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M460.8 486.4c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M563.2 486.4c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M665.6 486.4c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M768 486.4c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M409.6 588.8c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M512 588.8c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M614.4 588.8c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"keyboard",
						"type",
						"typing"
					],
					"defaultCode": 59447,
					"grid": 20
				},
				{
					"id": 2404,
					"paths": [
						"M768 256c0-141.384-114.614-256-256-256s-256 114.616-256 256c0 97.826 54.878 182.822 135.52 225.916l-135.52 542.084h512l-135.52-542.084c80.642-43.094 135.52-128.092 135.52-225.916z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"keyhole",
						"entrance",
						"signin",
						"login"
					],
					"defaultCode": 60239,
					"grid": 16
				},
				{
					"id": 593,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM927.936 513.536l-91.488-99.2 40.8-101.248c32.32 59.136 50.752 126.912 50.752 198.912 0 0.512-0.064 1.024-0.064 1.536zM649.376 119.808l-137.376 54.976-137.376-54.976c43.072-15.136 89.184-23.808 137.376-23.808s94.304 8.672 137.376 23.808zM146.752 313.088l40.832 101.248-91.52 99.2c0-0.512-0.064-1.024-0.064-1.536 0-72 18.432-139.776 50.752-198.912zM175.36 755.392l131.584 26.336 26.336 105.344c-63.040-30.176-117.28-75.584-157.92-131.68zM370.144 902.56l-32.16-128.608c-3.008-12-12.64-21.184-24.768-23.616l-162.176-32.416c-27.616-48.192-45.952-102.272-52.32-160l112.416-121.856c8.384-9.088 10.784-22.208 6.144-33.664l-49.76-123.328c41.184-60.736 98.24-109.632 164.832-141.696l167.776 67.104c7.616 3.040 16.128 3.040 23.776 0l167.776-67.104c66.624 32.096 123.648 80.992 164.832 141.728l-49.728 123.296c-4.64 11.456-2.24 24.576 6.144 33.664l112.416 121.856c-6.368 57.728-24.736 111.808-52.32 160l-162.176 32.416c-12.128 2.432-21.76 11.616-24.768 23.616l-32.16 128.608c-44.416 16.16-92.032 25.44-141.92 25.44s-97.504-9.28-141.856-25.44zM690.752 887.072l26.336-105.344 131.584-26.336c-40.672 56.096-94.912 101.504-157.92 131.68zM684.576 435.040l-154.816-103.2c-10.752-7.168-24.736-7.168-35.488 0l-154.816 103.2c-11.584 7.712-16.832 22.048-13.024 35.424l50.944 178.336c3.904 13.728 16.48 23.2 30.752 23.2h207.712c14.272 0 26.848-9.472 30.784-23.2l50.944-178.336c3.84-13.376-1.44-27.712-12.992-35.424zM408.128 640l-50.944-178.336 154.816-103.2 154.816 103.2-50.944 178.336h-207.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"kick",
						"game",
						"play"
					],
					"grid": 32
				},
				{
					"id": 594,
					"width": 1024,
					"paths": [
						"M512 358.464l154.816 103.2-50.944 178.336h-207.712l-50.944-178.336 154.784-103.2zM960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448 200.576-448 448-448 448 200.576 448 448zM368.064 151.648l132.032 52.832c3.84 1.536 7.872 2.304 11.904 2.304s8.064-0.736 11.872-2.304l132.064-52.832c13.44-5.376 13.248-24.576-0.32-29.6-0.16-0.064-0.288-0.096-0.416-0.16-3.68-1.376-7.776-1.248-11.456 0.192l-131.744 52.704-131.744-52.704c-3.648-1.472-7.744-1.568-11.456-0.192-0.16 0.064-0.288 0.096-0.448 0.16-13.568 5.024-13.728 24.224-0.288 29.6zM123.776 531.456l87.584-95.648c8.256-8.992 10.656-22.144 6.112-33.504l-37.92-94.848c-4.928-12.288-21.888-13.472-28.48-1.984-0.096 0.128-0.16 0.256-0.224 0.384-2.4 4.192-2.688 9.28-0.896 13.76l37.824 94.592-87.36 95.392c-2.752 3.008-4.32 7.008-4.224 11.104 0 0.16 0 0.352 0 0.512 0.352 14.208 17.984 20.768 27.584 10.24zM362.56 872.192l-24.576-98.272c-3.008-11.936-12.704-21.184-24.8-23.616l-125.696-25.12c-14.016-2.816-24.32 12.96-16.128 24.64 0.096 0.128 0.192 0.256 0.256 0.384 2.336 3.328 5.92 5.6 9.92 6.4l125.376 25.088 24.512 98.016c1.152 4.672 4.352 8.608 8.736 10.592 0.128 0.064 0.256 0.128 0.416 0.192 12.096 5.472 25.216-5.408 21.984-18.304zM646.624 648.8l50.944-178.336c3.84-13.376-1.44-27.712-13.024-35.424l-154.816-103.2c-10.752-7.168-24.736-7.168-35.488 0l-154.816 103.2c-11.584 7.712-16.832 22.048-13.024 35.424l50.944 178.336c3.936 13.728 16.512 23.2 30.784 23.2h207.712c14.304 0 26.88-9.472 30.784-23.2zM836.512 725.184l-125.728 25.152c-12.064 2.432-21.792 11.68-24.768 23.616l-24.576 98.272c-3.232 12.896 9.888 23.776 21.984 18.272 0.128-0.064 0.256-0.128 0.416-0.192 4.384-1.984 7.584-5.92 8.736-10.592l24.512-98.016 125.376-25.088c4-0.8 7.552-3.072 9.92-6.4 0.096-0.128 0.192-0.256 0.288-0.384 8.16-11.68-2.144-27.456-16.16-24.64zM927.776 521.216c0-0.16 0-0.352 0-0.512 0.096-4.096-1.472-8.096-4.224-11.104l-87.36-95.36 38.080-94.144c1.824-4.48 1.536-9.568-0.864-13.792-0.064-0.128-0.16-0.256-0.224-0.384-6.592-11.488-23.52-10.368-28.48 1.92l-38.208 94.432c-4.608 11.36-2.208 24.576 6.048 33.6l87.616 95.648c9.664 10.496 27.296 3.936 27.616-10.304z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"kick",
						"game",
						"play"
					],
					"grid": 32
				},
				{
					"id": 1051,
					"width": 1024,
					"paths": [
						"M512 32c-264.672 0-480 215.328-480 480s215.328 480 480 480 480-215.328 480-480-215.328-480-480-480zM927.776 507.424l-124.128-90.176 47.296-145.568c47.488 66.784 75.872 147.968 76.832 235.744zM827.168 241.248l-55.136 169.728-86.112 25.568-157.92-114.72v-88.544l144.512-104.992c60.064 25.216 112.768 64.288 154.656 112.96zM606.304 640h-188.608l-58.272-179.392 152.576-110.848 152.608 110.848-58.304 179.392zM512 96c43.296 0 85.056 6.688 124.32 19.008l-124.32 90.336-124.32-90.336c39.264-12.32 81.024-19.008 124.32-19.008zM351.488 128.288l144.512 104.992v88.544l-157.92 114.72-86.112-25.568-55.136-169.728c41.888-48.672 94.592-87.744 154.656-112.96zM173.056 271.68l47.296 145.568-124.128 90.176c0.96-87.776 29.344-168.96 76.832-235.744zM157.216 728.096c-32.992-53.952-54.112-115.808-59.488-182.208l143.936-104.576 86.144 25.568 60.448 186.080-52.832 75.104h-178.208zM178.88 760.096h152.896l47.36 145.76c-80.768-27.328-150.24-78.784-200.256-145.76zM512 928c-33.024 0-64.992-4.288-95.808-11.584l-55.008-169.312 52.8-75.104h196l52.8 75.104-55.008 169.312c-30.784 7.296-62.752 11.584-95.776 11.584zM644.896 905.856l47.36-145.76h152.896c-50.048 66.976-119.52 118.432-200.256 145.76zM866.784 728.096h-178.24l-52.832-75.104 60.448-186.080 86.144-25.568 143.936 104.576c-5.344 66.368-26.464 128.192-59.456 182.176z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"kick",
						"game",
						"play"
					],
					"grid": 32
				},
				{
					"id": 595,
					"width": 1024,
					"paths": [
						"M912 256c-26.496 0-48 21.504-48 48v13.536l-558.816-42.976c-5.76-0.448-11.488-0.672-17.184-0.672v-17.888c0-17.664-14.336-32-32-32h-32v-32c0-35.36-28.64-64-64-64h-2.944c-6.592-18.592-24.192-32-45.056-32-26.496 0-48 21.504-48 48s21.504 48 48 48c20.864 0 38.464-13.408 45.056-32h2.944c17.664 0 32 14.336 32 32v32h-32c-17.664 0-32 14.336-32 32v85.28c-39.424 40.256-64 95.36-64 156.608v28.224c0 61.824 24.992 117.376 65.088 157.728-0.704 6.624-1.088 13.344-1.088 20.16 0 106.048 85.952 192 192 192 95.904 0 175.136-70.368 189.472-162.272l354.528-27.264v13.536c0 26.496 21.504 48 48 48s48-21.504 48-48v-416c0-26.496-21.504-48-48-48zM112 160c-8.832 0-16-7.168-16-16s7.168-16 16-16 16 7.168 16 16-7.168 16-16 16zM256 256v20.416c-35.232 5.024-67.936 18.208-96 37.824v-58.24h96zM320 864c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.776 160-160 160zM511.872 701.44c-1.376-104.832-86.688-189.44-191.872-189.44-85.376 0-157.664 55.776-182.592 132.832-25.824-32.704-41.408-73.888-41.408-118.72v-28.224c0-105.888 86.016-192 191.712-192 4.96 0 9.984 0.192 15.008 0.576l561.28 43.168v324.736l-352.128 27.072zM928 720c0 8.832-7.168 16-16 16s-16-7.168-16-16v-416c0-8.832 7.168-16 16-16s16 7.168 16 16v416zM352 704c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"kill",
						"live",
						"warn"
					],
					"grid": 32
				},
				{
					"id": 596,
					"width": 1024,
					"paths": [
						"M320 512c-106.048 0-192 85.952-192 192s85.952 192 192 192 192-85.952 192-192-85.952-192-192-192zM320 736c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM960 304v416c0 26.496-21.504 48-48 48s-48-21.504-48-48v-13.536l-322.016 24.768c1.152-8.928 2.016-17.984 2.016-27.232 0-123.52-100.48-224-224-224-105.44 0-193.76 73.376-217.408 171.648-24.288-35.68-38.592-78.816-38.592-125.536v-28.224c0-61.248 24.576-116.32 64-156.608v-85.28c0-17.664 14.336-32 32-32h32v-32c0-17.664-14.336-32-32-32h-2.944c-6.592 18.592-24.192 32-45.056 32-26.496 0-48-21.504-48-48s21.504-48 48-48c20.864 0 38.464 13.408 45.056 32h2.944c35.36 0 64 28.64 64 64v32h32c17.664 0 32 14.336 32 32v17.888c5.696 0 11.424 0.224 17.184 0.672l558.816 42.976v-13.536c0-26.496 21.504-48 48-48s48 21.504 48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"kill",
						"live",
						"warn"
					],
					"grid": 32
				},
				{
					"id": 597,
					"width": 1024,
					"paths": [
						"M672 160c-60.576 0-116.16 26.432-160 70.432-43.84-44-99.424-70.432-160-70.432-141.376 0-256 143.264-256 320v32c0 229.76 186.24 352 416 352s416-122.24 416-352v-32c0-176.736-114.624-320-256-320zM352 192c50.048 0 97.536 21.088 137.344 61.024l22.656 22.72 22.656-22.72c39.808-39.936 87.296-61.024 137.344-61.024 123.52 0 224 129.184 224 288h-768c0-158.816 100.48-288 224-288zM512 832c-177.152 0-384-83.808-384-320h768c0 236.192-206.848 320-384 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"kiss",
						"pucker"
					],
					"grid": 32
				},
				{
					"id": 598,
					"width": 1024,
					"paths": [
						"M928 480h-832c0-176.736 114.624-320 256-320 60.576 0 116.16 26.432 160 70.432 43.84-44 99.424-70.432 160-70.432 141.376 0 256 143.264 256 320zM512 864c229.76 0 416-122.24 416-352h-832c0 229.76 186.24 352 416 352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"kiss",
						"pucker"
					],
					"grid": 32
				},
				{
					"id": 1052,
					"width": 1024,
					"paths": [
						"M704 224c-81.632 0-152.864 43.808-192 109.056-39.136-65.248-110.368-109.056-192-109.056-160 0-288 160-288 224s128 352 480 352 480-288 480-352-128-224-288-224zM320 288c56.576 0 107.808 29.152 137.12 77.984 11.552 19.264 32.384 31.072 54.88 31.072s43.328-11.808 54.88-31.072c29.312-48.832 80.544-77.984 137.12-77.984 115.808 0 207.648 113.12 222.080 152.32-67.424 16.864-241.44 55.68-414.080 55.68-172.192 0-345.92-38.656-413.664-55.584 15.552-41.12 106.752-152.416 221.664-152.416zM512 736c-271.744 0-382.304-188.128-409.088-261.504 76.512 18.464 243.456 53.504 409.088 53.504 165.376 0 332-34.912 408.672-53.408-27.328 74.88-138.048 261.408-408.672 261.408z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"kiss",
						"talk",
						"smooch",
						"smirk",
						"smile"
					],
					"grid": 32
				},
				{
					"id": 2431,
					"paths": [
						"M832 640h-640c-106.040 0-192 85.96-192 192s85.96 192 192 192h640c106.040 0 192-85.96 192-192s-85.96-192-192-192zM192 896c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64z",
						"M192 576h177.898l187.322-269.562c60.514-87.078 38.976-206.722-48.102-267.234l-378.15 544.168c19.568-4.806 40.004-7.372 61.032-7.372z",
						"M832 512h-339.692l-44.308 63.758v0.242h384c73.208 0 139.328 30.896 186.032 80.324-21.202-82.974-96.45-144.324-186.032-144.324z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"knife",
						"tool",
						"army"
					],
					"defaultCode": 60266,
					"grid": 16
				},
				{
					"id": 599,
					"width": 1024,
					"paths": [
						"M686.656 420v0c9.984 0 17.76 9.088 15.776 18.88-6.816 33.664-31.456 60.768-63.552 71.648 17.248 22.656 28.928 49.76 32.192 79.456 0.992 9.056-6.4 16.896-15.52 16.896h-0.384c-8.352 0-15.040-6.336-15.968-14.56-3.52-31.008-18.176-58.656-39.808-78.912-19.584-18.304-44.896-30.56-72.896-33.728-8.224-0.864-14.496-7.584-14.496-15.808v0c0-9.408 8.128-17.024 17.472-15.968 31.392 3.552 59.872 16.608 83.168 35.68 28.992-1.984 52.8-23.136 58.4-50.976 1.504-7.36 8.096-12.608 15.616-12.608zM401.92 660h0.032c7.52 0 14.112-5.216 15.584-12.576 2.4-12 8.16-22.816 16.288-31.392 8.896-9.408 20.608-16.128 33.792-18.784 7.392-1.504 12.704-8.032 12.704-15.616v-0.032c0-9.92-8.96-17.728-18.688-15.776-37.984 7.52-67.968 37.504-75.488 75.488-1.952 9.728 5.856 18.688 15.776 18.688zM960 560c0 239.52-148 408.352-377.024 430.144-2.112 0.192-4.192 0.288-6.272 0.288-35.68 0-64.736-28.704-64.736-64.128 0 35.456-29.024 64.128-64.704 64.128-2.080 0-4.16-0.096-6.272-0.288-228.992-21.792-376.992-190.624-376.992-430.144 0-267.072 169.184-502.976 377.12-525.856 2.336-0.256 4.672-0.384 6.976-0.384 35.232 0 63.904 29.024 63.936 64.256 0-35.296 28.672-64.256 63.904-64.256 2.304 0 4.608 0.128 6.976 0.384 207.936 22.88 377.088 258.784 377.088 525.856zM836.288 832c56.736-66.016 91.328-156.512 91.648-270.368-49.6 7.232-88.864 46.688-95.072 96.544-0.992 7.808-7.328 13.824-15.2 13.824h-1.216c-9.248 0-16.512-7.776-15.488-16.736 7.68-65.76 60.096-117.6 125.856-125.536-6.528-124.448-52.448-243.648-123.104-330.272-18.656 22.784-29.312 50.72-29.312 80.544 0 29.312 9.792 57.152 27.84 79.712 5.152 6.432 4.832 15.616-0.992 21.44v0c-6.656 6.656-17.76 6.304-23.648-1.024-16.48-20.512-27.424-44.512-32.288-70.176-12.896 6.048-26.752 9.44-40.736 9.44-18.784 0-37.568-5.472-53.728-16.384-8.032-5.408-8.832-16.992-1.984-23.808l0.288-0.288c5.312-5.312 13.6-6.464 19.776-2.336 22.4 15.040 52.288 14.176 74.048-2.24 1.312-36.864 15.168-71.264 39.328-98.944-56.832-60.416-126.528-101.024-202.88-109.44-1.152-0.128-2.336-0.192-3.456-0.192-17.376 0-31.904 14.432-31.904 32.256v253.984c0 17.664-13.696 32-32.032 32s-32-14.336-32-32v-253.984c0-17.824-14.528-32.256-31.904-32.256-1.152 0-2.304 0.064-3.456 0.192-37.984 4.192-74.272 16.448-108.256 34.944 0.448 30.624 22.4 56.096 51.424 61.856 7.328 1.472 12.48 8.096 12.48 15.552v0c0 9.952-9.056 17.728-18.848 15.776-37.696-7.52-67.488-37.216-75.2-74.848-67.424 46.304-123.072 118.688-160.256 203.808 48.352 4.512 91.392 27.104 122.656 60.832 22.464-5.984 43.328-16.448 61.248-31.264 6.368-5.28 15.648-4.928 21.504 0.928l0.032 0.032c6.592 6.592 6.272 17.536-0.864 23.488-18.080 15.072-38.624 26.56-60.768 34.112 16.192 25.344 26.688 54.656 29.472 86.208 0.8 9.024-6.528 16.736-15.584 16.736h-0.416c-8.384 0-15.2-6.368-15.968-14.656-7.264-79.584-73.248-142.144-154.112-144.832-23.68 64.256-37.216 134.24-37.216 205.376 0 136.256 48.608 239.552 126.016 307.072 45.024-46.56 47.904-119.008 8.288-168.64-5.12-6.432-4.8-15.584 1.024-21.408v0c6.656-6.656 17.76-6.272 23.68 1.056 16.768 20.896 27.488 45.056 32.224 70.144 30.208-14.208 66.24-12.032 94.4 6.912 8.064 5.408 8.96 17.024 2.112 23.872l-0.288 0.288c-5.312 5.312-13.6 6.464-19.776 2.336-22.432-15.040-52.352-14.176-74.144 2.304-1.344 37.216-15.52 73.824-42.592 102.912 55.712 40.288 123.36 64.416 197.12 71.424 1.088 0.096 2.176 0.16 3.232 0.16 17.76 0 32.704-13.984 32.704-32.128v-190.304c0-17.664 14.336-32 32-32h0.032c17.664 0 32 14.336 32 32v190.336c0 18.144 14.944 32.128 32.704 32.128 1.056 0 2.144-0.064 3.232-0.16 87.68-8.352 166.624-40.992 227.2-96.096-45.568-5.92-86.048-27.84-115.808-59.968-22.464 5.984-43.328 16.448-61.248 31.264-6.368 5.28-15.648 4.928-21.504-0.928l-0.032-0.032c-6.592-6.592-6.272-17.536 0.864-23.488 18.048-15.072 38.624-26.56 60.768-34.112-16.224-25.44-26.752-54.88-29.472-86.528-0.8-8.864 6.368-16.416 15.264-16.416h1.216c8.16 0 14.72 6.080 15.392 13.984 7.104 81.696 75.872 146.016 159.392 146.016h4.288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"know",
						"think",
						"wonder"
					],
					"grid": 32
				},
				{
					"id": 600,
					"width": 1024,
					"paths": [
						"M605.184 39.84c-4.8-1.152-9.536-1.696-14.208-1.696-33.888 0-62.976 28.672-62.976 64.384v268.16c0 8.832-7.168 16-16 16s-16-7.168-16-16v-268.16c0-35.712-29.088-64.384-62.976-64.384-4.672 0-9.44 0.544-14.208 1.696-213.76 51.136-354.816 274.208-354.816 506.88 0 236.672 119.872 407.488 357.632 441.376 3.2 0.448 6.368 0.672 9.504 0.672 35.104 0 64.864-27.776 64.864-63.968v-204.8c0-8.832 7.168-16 16-16s16 7.168 16 16v204.8c0 36.192 29.76 63.968 64.864 63.968 3.136 0 6.304-0.224 9.504-0.672 237.76-33.92 357.632-204.704 357.632-441.376 0-232.672-141.056-455.744-354.816-506.88zM318.72 114.24l0.32-0.192c8.768-5.376 19.84-0.896 23.296 8.768 7.488 20.864 25.536 36.736 47.68 41.152 7.328 1.472 12.48 8.096 12.48 15.584v0c0 9.952-9.056 17.728-18.848 15.776-33.312-6.656-60.48-30.624-71.648-62.080-2.528-7.104 0.256-15.072 6.72-19.008zM155.744 357.92c-10.144-1.632-16.288-12-12.448-21.536l0.288-0.672c2.72-6.688 9.664-10.976 16.768-9.824 43.392 6.912 81.888 28.448 110.496 59.296 22.464-5.984 43.328-16.448 61.248-31.264 6.368-5.28 15.648-4.928 21.504 0.928l0.032 0.032c6.592 6.592 6.272 17.536-0.864 23.488-18.080 15.072-38.624 26.56-60.768 34.112 16.192 25.344 26.688 54.656 29.472 86.208 0.8 9.024-6.528 16.736-15.584 16.736h-0.416c-8.384 0-15.2-6.368-15.968-14.656-6.656-72.8-62.4-131.36-133.76-142.848zM385.92 780.256l-0.288 0.288c-5.312 5.312-13.6 6.464-19.744 2.336-22.432-15.040-52.352-14.176-74.144 2.304-1.152 31.968-11.808 63.52-31.968 90.24-5.44 7.2-15.68 8.672-22.752 3.072l-0.032-0.032c-6.656-5.28-8-14.912-2.848-21.696 35.296-46.368 34.816-111.392-1.632-157.12-5.12-6.432-4.8-15.584 1.024-21.408v0c6.656-6.656 17.76-6.272 23.68 1.056 16.768 20.896 27.488 45.056 32.224 70.144 30.208-14.208 66.24-12.032 94.4 6.912 8.032 5.44 8.96 17.024 2.080 23.904zM482.496 582.912c0 7.552-5.28 14.112-12.704 15.616-13.152 2.656-24.896 9.376-33.792 18.784-8.096 8.576-13.888 19.36-16.288 31.392-1.472 7.36-8.064 12.576-15.584 12.576h-0.032c-9.92 0-17.728-8.96-15.776-18.688 7.52-37.984 37.504-67.968 75.488-75.488 9.728-1.92 18.688 5.888 18.688 15.776v0.032zM651.040 280.384l0.288-0.288c5.312-5.312 13.6-6.464 19.776-2.336 22.4 15.008 52.288 14.176 74.048-2.24 1.056-30.144 10.528-58.624 27.136-83.136 5.76-8.48 18.144-9.12 24.96-1.44l0.128 0.128c4.704 5.28 5.504 13.152 1.536 18.976-14.272 20.896-22.272 45.312-22.272 71.168 0 29.312 9.792 57.152 27.84 79.712 5.152 6.432 4.832 15.616-0.992 21.44v0c-6.656 6.656-17.76 6.304-23.648-1.024-16.48-20.512-27.424-44.512-32.288-70.176-12.896 6.048-26.752 9.44-40.736 9.44-18.784 0-37.568-5.472-53.728-16.416-8.064-5.408-8.896-16.96-2.048-23.808zM528.64 480.96c-8.192-0.928-14.464-7.648-14.464-15.872 0-9.408 8.128-17.024 17.472-15.968 31.392 3.552 59.84 16.608 83.168 35.68 28.992-1.984 52.8-23.168 58.432-50.976 1.472-7.36 8.064-12.576 15.584-12.576 9.984 0 17.76 9.088 15.776 18.88-6.816 33.664-31.456 60.768-63.552 71.648 17.248 22.656 28.928 49.76 32.192 79.456 0.992 9.056-6.4 16.896-15.52 16.896h-0.384c-8.352 0-15.040-6.336-15.968-14.56-3.52-31.008-18.176-58.656-39.808-78.912-19.584-18.272-44.896-30.528-72.928-33.696zM815.232 856.256l-0.096 0.096c-3.584 4.384-9.312 6.656-14.88 5.664-41.856-7.488-78.976-28.576-106.752-58.56-22.464 5.984-43.328 16.448-61.248 31.264-6.368 5.28-15.648 4.928-21.504-0.928l-0.032-0.032c-6.592-6.592-6.272-17.536 0.864-23.488 18.048-15.072 38.624-26.56 60.768-34.112-16.256-25.44-26.752-54.88-29.472-86.528-0.768-8.832 6.4-16.416 15.264-16.416h1.216c8.16 0 14.72 6.080 15.392 13.984 6.272 72.288 60.864 130.976 131.2 143.552 11.872 2.080 16.928 16.224 9.28 25.504zM918.272 565.216c-43.904 11.296-77.536 48.352-83.232 94.176-0.96 7.808-7.296 13.824-15.168 13.824h-1.216c-9.248 0-16.512-7.776-15.488-16.736 6.912-59.232 50.144-107.2 106.752-121.92 9.76-2.528 19.392 4.832 19.744 14.912v0.032c0.256 7.264-4.384 13.92-11.392 15.712z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"know",
						"think",
						"wonder"
					],
					"grid": 32
				},
				{
					"id": 1489,
					"width": 1024.0010137557983,
					"paths": [
						"M293.714 682.857l46.286-170.857h-90.857l42.857 171.429q0.571 0.571 0.571 1.714t0.571 1.714q0-0.571 0.286-2t0.286-2zM360 438.857l20-73.143h-166.857l18.286 73.143h128.571zM469.714 438.857h79.429l-20-73.143h-40zM726.286 683.429l44.571-171.429h-92.571l46.286 170.857q0 0.571 0.286 2t0.857 2q0-0.571 0.286-1.714t0.286-1.714zM789.714 438.857l18.857-73.143h-169.714l19.429 73.143h131.429zM1024 457.143v36.571q0 8-5.143 13.143t-13.143 5.143h-121.714l-93.714 352q-4 13.714-17.714 13.714h-90.857q-13.714 0-17.714-13.714l-94.857-352h-119.429l-95.429 352q-4 13.714-17.714 13.714h-90.857q-6.286 0-11.143-4t-6-9.714l-91.429-352h-118.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h100l-18.857-73.143h-81.143q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h62.286l-50.857-196.571q-2.857-8.571 2.857-16 5.714-6.857 14.857-6.857h78.286q14.857 0 17.714 13.714l51.429 205.714h205.143l55.429-205.714q4-13.714 17.714-13.714h72q13.714 0 17.714 13.714l56 205.714h208.571l53.143-205.714q2.857-13.714 17.714-13.714h78.286q9.143 0 14.857 6.857 5.714 7.429 2.857 16l-52 196.571h63.429q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-82.857l-19.429 73.143h102.286q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"krw",
						"won"
					],
					"defaultCode": 61785,
					"grid": 14
				},
				{
					"id": 2559,
					"paths": [
						"M956.29 804.482l-316.29-527.024v-213.458h32c17.6 0 32-14.4 32-32s-14.4-32-32-32h-320c-17.6 0-32 14.4-32 32s14.4 32 32 32h32v213.458l-316.288 527.024c-72.442 120.734-16.512 219.518 124.288 219.518h640c140.8 0 196.73-98.784 124.29-219.518zM241.038 640l206.962-344.938v-231.062h128v231.062l206.964 344.938h-541.926z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lab",
						"beta",
						"beaker",
						"test",
						"experiment"
					],
					"defaultCode": 60394,
					"grid": 16
				},
				{
					"id": 2477,
					"paths": [
						"M768 0c-35.346 0-64 28.654-64 64v128h-384v-128c0-35.346-28.654-64-64-64s-64 28.654-64 64v896c0 35.348 28.654 64 64 64s64-28.652 64-64v-128h384v128c0 35.348 28.654 64 64 64 35.348 0 64-28.652 64-64v-896c0-35.346-28.652-64-64-64zM704 704h-384v-128h384v128zM704 448h-384v-128h384v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ladder",
						"ranking"
					],
					"defaultCode": 60312,
					"grid": 16
				},
				{
					"id": 2567,
					"paths": [
						"M954.040 461.4l-320-448c-6.006-8.408-15.706-13.4-26.040-13.4h-256c-10.334 0-20.034 4.992-26.040 13.4l-320 448c-6.968 9.754-7.9 22.584-2.414 33.242s16.468 17.358 28.454 17.358h352v96c0 24.818-26.478 41.366-69.678 66.308-27.45 15.848-55.834 32.234-79.006 55.458-28.742 28.804-43.316 63.2-43.316 102.234 0 56.024 4.5 118.792 58.25 154.624 46.684 31.124 122.52 37.376 229.75 37.376s183.066-6.252 229.75-37.376c53.748-35.832 58.25-98.6 58.25-154.624 0-39.034-14.574-73.43-43.314-102.234-23.172-23.222-51.556-39.61-79.006-55.458-43.2-24.942-69.68-41.49-69.68-66.308v-96h352c11.986 0 22.968-6.7 28.454-17.358s4.552-23.488-2.414-33.242zM94.182 448l45.714-64h680.208l45.714 64h-771.636z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lamp",
						"light"
					],
					"defaultCode": 60402,
					"grid": 16
				},
				{
					"id": 2568,
					"paths": [
						"M954.040 461.4l-320-448c-6.006-8.408-15.706-13.4-26.040-13.4h-256c-10.334 0-20.034 4.992-26.040 13.4l-320 448c-6.968 9.754-7.9 22.584-2.414 33.242s16.468 17.358 28.454 17.358h352v96c0 24.818-26.478 41.366-69.678 66.308-27.45 15.848-55.834 32.234-79.006 55.458-28.742 28.804-43.316 63.2-43.316 102.234 0 56.024 4.5 118.792 58.25 154.624 46.684 31.124 122.52 37.376 229.75 37.376s183.066-6.252 229.75-37.376c53.748-35.832 58.25-98.6 58.25-154.624 0-39.034-14.574-73.43-43.314-102.234-23.172-23.222-51.556-39.61-79.006-55.458-43.2-24.942-69.68-41.49-69.68-66.308v-96h352c11.986 0 22.968-6.7 28.454-17.358s4.552-23.488-2.414-33.242zM368.468 64h223.066l182.858 256h-588.782l182.858-256zM613.68 729.734c56.198 32.446 90.32 55.52 90.32 102.266 0 60.964-7.508 86.544-29.75 101.376-27.994 18.662-86.088 26.624-194.25 26.624s-166.256-7.962-194.25-26.624c-22.242-14.832-29.75-40.412-29.75-101.376 0-46.746 34.124-69.82 90.322-102.266 47.66-27.518 101.678-58.704 101.678-121.734v-96h64v96c0 63.030 54.020 94.216 101.68 121.734zM94.182 448l45.714-64h680.208l45.714 64h-771.636z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lamp",
						"light"
					],
					"defaultCode": 60403,
					"grid": 16
				},
				{
					"id": 2569,
					"paths": [
						"M896 576v-384c0-35.346-28.654-64-64-64h-704c-35.346 0-64 28.654-64 64v384h320v320h-32c-17.672 0-32 14.326-32 32s14.328 32 32 32h-64c-17.672 0-32 14.326-32 32s14.328 32 32 32h384c17.674 0 32-14.326 32-32s-14.326-32-32-32h-64c17.674 0 32-14.326 32-32s-14.326-32-32-32h-32v-320h128v192c0 35.346 28.654 64 64 64s64-28.654 64-64-28.654-64-64-64v-128h128zM768 192h64v320h-64v-320zM192 512h-64v-320h64v320zM320 512h-64v-320h64v320zM448 512h-64v-320h64v320zM576 512h-64v-320h64v320zM704 512h-64v-320h64v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lamp",
						"light"
					],
					"defaultCode": 60404,
					"grid": 16
				},
				{
					"id": 2571,
					"paths": [
						"M512 0c-212.078 0-384 171.922-384 384 0 142.132 77.226 266.218 192 332.618v243.382l64 64h256l64-64v-243.382c114.776-66.398 192-190.484 192-332.618 0-212.078-171.922-384-384-384zM320 320c0-35.346 28.654-64 64-64s64 28.654 64 64v288c0 17.674-14.326 32-32 32s-32-14.326-32-32v-224c-35.346 0-64-28.654-64-64zM608 832h-192c-17.6 0-32-14.4-32-32s14.4-32 32-32h192c17.6 0 32 14.4 32 32s-14.4 32-32 32zM640 384v224c0 17.674-14.326 32-32 32s-32-14.326-32-32v-288c0-35.346 28.652-64 64-64s64 28.654 64 64-28.652 64-64 64zM608 960h-192c-17.6 0-32-14.4-32-32s14.4-32 32-32h192c17.6 0 32 14.4 32 32s-14.4 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lamp",
						"light",
						"idea",
						"tip",
						"bulb"
					],
					"defaultCode": 60406,
					"grid": 16
				},
				{
					"id": 2572,
					"paths": [
						"M896 384c0-212.078-171.922-384-384-384s-384 171.922-384 384c0 142.132 77.226 266.218 192 332.618v243.382l64 64h256l64-64v-243.382c114.776-66.4 192-190.486 192-332.618zM608 832h-192c-17.6 0-32-14.4-32-32s14.4-32 32-32h192c17.6 0 32 14.4 32 32s-14.4 32-32 32zM640 677.458v-293.458c35.348 0 64-28.654 64-64s-28.652-64-64-64-64 28.654-64 64v377.624c-20.84 4.208-42.254 6.376-64 6.376-21.748 0-43.16-2.166-64-6.376v-377.624c0-35.346-28.654-64-64-64s-64 28.654-64 64 28.654 64 64 64v293.458c-36.206-15.802-69.5-38.406-98.274-67.18-60.44-60.444-93.726-140.802-93.726-226.278 0-85.474 33.286-165.834 93.726-226.274s140.8-93.726 226.274-93.726c85.472 0 165.834 33.286 226.276 93.726 60.438 60.44 93.724 140.798 93.724 226.274s-33.286 165.834-93.724 226.278c-28.776 28.768-62.068 51.374-98.276 67.18zM608 960h-192c-17.6 0-32-14.4-32-32s14.4-32 32-32h192c17.6 0 32 14.4 32 32s-14.4 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lamp",
						"light",
						"idea",
						"tip",
						"bulb"
					],
					"defaultCode": 60407,
					"grid": 16
				},
				{
					"id": 2573,
					"paths": [
						"M512 0c-212.078 0-384 171.922-384 384 0 142.132 77.226 266.218 192 332.618v243.382l64 64h256l64-64v-243.382c114.776-66.398 192-190.484 192-332.618 0-212.078-171.922-384-384-384zM448 680v-16h128v16h-128zM576 696v1.624c-20.84 4.208-42.254 6.376-64 6.376-21.748 0-43.16-2.166-64-6.376v-1.624h128zM448 648v-16h128v16h-128zM448 616v-16h128v16h-128zM448 584v-16h128v16h-128zM448 552v-16h128v16h-128zM448 520v-16h128v16h-128zM448 488v-16h128v16h-128zM448 456v-16h128v16h-128zM448 424v-16h128v16h-128zM448 392v-16h128v16h-128zM448 360v-16h128v16h-128zM448 328v-8c0-2.71-0.188-5.376-0.516-8h129.032c-0.328 2.624-0.516 5.29-0.516 8v8h-128zM580.67 296h-137.34c0 0.002 0.002 0.006 0.002 0.008-2.352-5.812-5.53-11.196-9.394-16.012 0 0.002 0.002 0.002 0.004 0.004h156.112c-3.854 4.814-7.032 10.194-9.384 16zM579.272 299.802c-0.008 0.022-0.016 0.044-0.024 0.068 0.008-0.022 0.016-0.044 0.024-0.068zM444.752 299.874c-0.008-0.026-0.018-0.050-0.026-0.078 0.008 0.026 0.018 0.052 0.026 0.078zM414.986 264c0.006 0.004 0.012 0.008 0.020 0.012-9.188-5.098-19.756-8.012-31.006-8.012s-21.818 2.914-31.004 8.012c0.006-0.004 0.012-0.008 0.020-0.012h-137.826c4.416-10.926 9.436-21.604 15.056-31.99-2.846 5.258-5.544 10.588-8.082 15.99h579.676c2.474 5.268 4.792 10.606 6.972 16h-137.826c0.008 0.004 0.018 0.010 0.026 0.014-9.188-5.1-19.758-8.014-31.012-8.014s-21.824 2.914-31.012 8.014c0.008-0.004 0.018-0.010 0.026-0.014h-194.028zM606.328 265.578c-0.028 0.016-0.054 0.036-0.082 0.052 0.028-0.018 0.054-0.036 0.082-0.052zM603.714 267.286c-0.034 0.022-0.062 0.046-0.094 0.068 0.032-0.022 0.064-0.046 0.094-0.068zM601.192 269.122c-0.030 0.022-0.054 0.042-0.082 0.064 0.022-0.022 0.052-0.044 0.082-0.064zM598.752 271.080c-0.014 0.012-0.030 0.024-0.042 0.038 0.012-0.014 0.028-0.026 0.042-0.038zM596.412 273.156c-0.002 0.002-0.004 0.002-0.006 0.004 0.002-0.002 0.004-0.002 0.006-0.004zM431.936 277.618c0 0 0-0.002 0 0 0-0.002 0 0 0 0zM429.822 275.34c-0.002-0.002-0.006-0.006-0.008-0.008 0.002 0.002 0.004 0.004 0.008 0.008zM427.608 273.174c-0.008-0.008-0.018-0.016-0.026-0.024 0.008 0.008 0.016 0.016 0.026 0.024zM425.304 271.128c-0.020-0.018-0.040-0.036-0.060-0.052 0.020 0.018 0.040 0.036 0.060 0.052zM422.902 269.194c-0.032-0.024-0.064-0.050-0.096-0.076 0.032 0.026 0.064 0.052 0.096 0.076zM420.378 267.354c-0.032-0.022-0.064-0.046-0.096-0.068 0.034 0.022 0.064 0.046 0.096 0.068zM417.748 265.626c-0.026-0.016-0.050-0.032-0.076-0.048 0.026 0.016 0.050 0.032 0.076 0.048zM320.516 328h-123.654c-0.462 2.636-0.894 5.28-1.292 7.932 1.208-8.056 2.724-16.038 4.53-23.932h120.416c-0.328 2.624-0.516 5.29-0.516 8s0.188 5.376 0.516 8zM204.208 296c-0.744 2.614-1.454 5.24-2.132 7.876 2.774-10.806 6.114-21.432 9.998-31.85-0.986 2.644-1.936 5.302-2.852 7.974h124.834c0-0.002 0.002-0.002 0.004-0.004-3.864 4.816-7.042 10.202-9.394 16.012 0-0.002 0.002-0.004 0.002-0.008h-120.46zM323.274 299.796c-0.008 0.026-0.018 0.050-0.026 0.078 0.008-0.026 0.018-0.052 0.026-0.078zM200.118 311.924c0.608-2.652 1.25-5.292 1.924-7.92-0.674 2.628-1.316 5.268-1.924 7.92zM350.328 265.578c-0.026 0.016-0.050 0.032-0.076 0.048 0.026-0.016 0.050-0.032 0.076-0.048zM347.716 267.286c-0.032 0.022-0.064 0.046-0.096 0.068 0.034-0.022 0.064-0.046 0.096-0.068zM345.194 269.12c-0.034 0.024-0.064 0.050-0.096 0.076 0.032-0.026 0.064-0.052 0.096-0.076zM342.756 271.076c-0.020 0.018-0.040 0.036-0.060 0.052 0.020-0.016 0.040-0.034 0.060-0.052zM340.418 273.15c-0.008 0.008-0.016 0.016-0.026 0.024 0.010-0.008 0.018-0.016 0.026-0.024zM338.186 275.332c-0.002 0.002-0.006 0.006-0.008 0.008 0.004-0.004 0.006-0.006 0.008-0.008zM336.066 277.616c-0.002 0-0.002 0.002 0 0-0.002 0.002-0.002 0 0 0zM212.12 271.902c0.988-2.646 2.008-5.278 3.066-7.896-1.058 2.618-2.080 5.25-3.066 7.896zM700.752 340.13c-0.008 0.022-0.016 0.044-0.024 0.068 0.008-0.024 0.016-0.046 0.024-0.068zM700.728 299.802c0.008 0.022 0.016 0.044 0.024 0.068-0.008-0.022-0.016-0.044-0.024-0.068zM699.33 344h130.206c-0.664-5.358-1.462-10.684-2.39-15.978 1.848 10.534 3.182 21.202 3.974 31.978h-141.176c3.858-4.814 7.034-10.194 9.386-16v0zM703.484 328c0.328-2.624 0.516-5.29 0.516-8s-0.188-5.376-0.516-8h120.416c1.208 5.296 2.292 10.628 3.238 16h-123.654zM699.33 296c-2.352-5.806-5.528-11.186-9.386-16h124.836c1.808 5.284 3.482 10.618 5.014 16h-120.464zM819.792 296.008c0.746 2.626 1.462 5.264 2.14 7.912-0.676-2.648-1.39-5.286-2.14-7.912zM821.954 303.986c0.684 2.662 1.334 5.332 1.95 8.012-0.618-2.682-1.268-5.352-1.95-8.012zM808.82 264.020c1.048 2.602 2.066 5.218 3.046 7.848-0.98-2.63-1.994-5.244-3.046-7.848zM811.944 272.068c0.972 2.614 1.912 5.238 2.816 7.876-0.904-2.638-1.844-5.264-2.816-7.876zM683.594 273.16c-0.002-0.002-0.004-0.002-0.006-0.004 0.002 0.002 0.004 0.002 0.006 0.004zM681.292 271.118c-0.018-0.012-0.032-0.026-0.042-0.038 0.012 0.012 0.026 0.024 0.042 0.038zM678.892 269.186c-0.030-0.022-0.054-0.042-0.082-0.064 0.028 0.020 0.056 0.042 0.082 0.064zM676.378 267.354c-0.034-0.022-0.062-0.042-0.098-0.068 0.036 0.022 0.068 0.046 0.098 0.068zM673.754 265.628c-0.028-0.016-0.054-0.036-0.082-0.052 0.028 0.018 0.054 0.036 0.082 0.052zM640 568h133.91c-3.844 5.446-7.886 10.774-12.086 16h-121.824v-16zM640 536h153.75c2.846-5.258 5.542-10.584 8.082-15.986-5.154 10.964-10.958 21.638-17.364 31.986h-144.468v-16zM640 520v-16h168.812c-2.18 5.394-4.498 10.732-6.972 16h-161.84zM640 488v-16h179.792c-1.534 5.382-3.208 10.716-5.016 16h-174.776zM814.762 488.050c-0.906 2.642-1.846 5.272-2.822 7.888 0.974-2.616 1.916-5.244 2.822-7.888zM811.872 496.126c-0.982 2.634-2.002 5.256-3.052 7.864 1.050-2.608 2.066-5.228 3.052-7.864zM640 456v-16h187.138c-1.42 8.092-3.156 16.1-5.188 24.016 0.686-2.662 1.334-5.334 1.95-8.016h-183.9zM821.938 464.076c-0.68 2.65-1.394 5.29-2.14 7.918 0.744-2.628 1.458-5.268 2.14-7.918zM640 424v-16h191.12c-0.792 10.776-2.126 21.444-3.974 31.978 0.928-5.292 1.726-10.62 2.39-15.978h-189.536zM640 392v-8c11.254 0 21.824-2.914 31.012-8.014-0.008 0.004-0.018 0.010-0.026 0.014h160.916c-0.066-2.678-0.164-5.35-0.294-8.016 0.264 5.316 0.392 10.656 0.392 16.016s-0.128 10.7-0.392 16.016c0.13-2.666 0.228-5.338 0.294-8.016h-191.902zM831.596 400.236c-0.126 2.582-0.286 5.16-0.474 7.73 0.188-2.572 0.344-5.148 0.474-7.73zM683.594 366.84c-0.002 0.002-0.004 0.002-0.006 0.004 0.002-0.002 0.004-0.002 0.006-0.004zM681.292 368.882c-0.018 0.012-0.032 0.026-0.042 0.038 0.012-0.012 0.026-0.024 0.042-0.038zM678.892 370.814c-0.030 0.022-0.054 0.042-0.082 0.064 0.028-0.020 0.056-0.042 0.082-0.064zM676.378 372.646c-0.034 0.022-0.062 0.042-0.098 0.068 0.036-0.022 0.068-0.046 0.098-0.068zM673.754 374.372c-0.028 0.016-0.054 0.036-0.082 0.052 0.028-0.018 0.054-0.036 0.082-0.052zM831.122 360.036c0.192 2.57 0.348 5.148 0.474 7.73-0.13-2.584-0.286-5.16-0.474-7.73zM784.444 215.96c-1.614-2.604-3.264-5.188-4.952-7.75 1.692 2.562 3.338 5.146 4.952 7.75zM692.958 120c-4.174-2.874-8.406-5.644-12.7-8.306 14.882 9.234 29.078 19.744 42.45 31.476-2.78-2.438-5.586-4.836-8.436-7.17h-404.546c6.906-5.654 14.022-10.978 21.314-16h361.918zM331.048 119.996c2.086-1.438 4.188-2.848 6.306-4.234-2.116 1.386-4.22 2.796-6.306 4.234zM337.362 115.758c2.11-1.38 4.234-2.734 6.374-4.062-2.14 1.328-4.266 2.682-6.374 4.062zM343.802 111.656c2.124-1.318 4.26-2.61 6.412-3.874-2.15 1.264-4.288 2.556-6.412 3.874zM350.316 107.722c12.904-7.582 26.288-14.23 40.082-19.894-0.142 0.058-0.286 0.112-0.426 0.17h244.058c13.644 5.624 26.886 12.22 39.658 19.724-2.156-1.268-4.328-2.51-6.512-3.724h-310.352c-2.184 1.216-4.352 2.458-6.508 3.724zM673.784 107.78c2.156 1.266 4.296 2.56 6.424 3.88-2.128-1.32-4.268-2.614-6.424-3.88zM732.338 151.94c-2.636-2.506-5.32-4.948-8.028-7.352 2.708 2.406 5.392 4.846 8.028 7.352zM627.848 85.528c-1.198-0.464-2.404-0.906-3.608-1.356 1.204 0.45 2.41 0.892 3.608 1.356zM621.14 83.020c-1.254-0.454-2.516-0.89-3.778-1.33 1.262 0.44 2.524 0.876 3.778 1.33zM614.406 80.674c-1.304-0.438-2.614-0.868-3.922-1.29 1.308 0.422 2.618 0.852 3.922 1.29zM607.682 78.498c-1.368-0.426-2.736-0.848-4.112-1.256 1.376 0.408 2.744 0.83 4.112 1.256zM601.046 76.512c-1.468-0.424-2.938-0.848-4.414-1.25 1.478 0.402 2.946 0.826 4.414 1.25zM595.118 74.862c-3.782-1.008-7.578-1.958-11.402-2.83 3.824 0.872 7.62 1.822 11.402 2.83zM583.578 72h-143.156c23.214-5.278 47.186-8 71.578-8 24.39 0 48.364 2.722 71.578 8zM396.148 85.53c1.208-0.468 2.426-0.914 3.64-1.368-1.214 0.454-2.432 0.9-3.64 1.368zM402.854 83.024c1.26-0.458 2.528-0.896 3.794-1.336-1.268 0.438-2.534 0.88-3.794 1.336zM409.586 80.676c1.31-0.44 2.622-0.872 3.938-1.294-1.314 0.424-2.628 0.854-3.938 1.294zM416.306 78.502c1.374-0.428 2.75-0.852 4.128-1.262-1.378 0.41-2.754 0.834-4.128 1.262zM422.934 76.516c1.478-0.426 2.956-0.852 4.44-1.256-1.486 0.404-2.962 0.83-4.44 1.256zM428.836 74.876c3.814-1.020 7.65-1.978 11.506-2.856-3.856 0.876-7.69 1.836-11.506 2.856zM299.69 144.588c-2.728 2.424-5.432 4.884-8.090 7.412h440.802c1.976 1.88 3.936 3.788 5.874 5.726 3.364 3.36 6.624 6.792 9.816 10.274h-472.182c-4.77 5.204-9.344 10.542-13.732 16h499.644c-4.38-5.452-8.954-10.784-13.712-15.98 11.494 12.542 21.884 25.84 31.124 39.792-1.734-2.628-3.506-5.234-5.326-7.812h-523.816c-1.814 2.572-3.582 5.17-5.312 7.79 11.806-17.826 25.48-34.6 40.944-50.064 4.542-4.54 9.208-8.908 13.966-13.138v0zM309.722 136.004c-2.846 2.33-5.65 4.728-8.426 7.164 2.776-2.438 5.58-4.834 8.426-7.164zM244.476 208.26c-1.682 2.56-3.332 5.14-4.942 7.74h544.936c6.404 10.346 12.208 21.016 17.36 31.978-2.538-5.398-5.234-10.724-8.078-15.978h-563.5c4.38-8.098 9.128-16.018 14.224-23.74v0zM195.562 335.98c-0.398 2.652-0.762 5.312-1.094 7.982 0.332-2.67 0.698-5.33 1.094-7.982zM194.464 344h130.206c0-0.002-0.002-0.006-0.002-0.008 2.352 5.812 5.53 11.196 9.394 16.012 0-0.002-0.002-0.002-0.004-0.004h-141.176c-0.392 5.308-0.654 10.644-0.784 16h160.916c-0.006-0.004-0.012-0.008-0.020-0.012 9.188 5.098 19.756 8.012 31.006 8.012v8h-191.902c0.13 5.356 0.392 10.692 0.784 16h191.118v16h-189.536c0.666 5.366 1.468 10.7 2.398 16h187.138v16h-183.9c-5.342-23.346-8.1-47.46-8.1-72 0-13.48 0.832-26.832 2.464-40zM323.248 340.126c0.008 0.026 0.018 0.050 0.026 0.078-0.008-0.026-0.018-0.052-0.026-0.078zM336.064 362.382c0 0 0 0.002 0 0 0 0.002 0 0 0 0zM338.178 364.66c0.002 0.002 0.006 0.006 0.008 0.008-0.002-0.002-0.004-0.004-0.008-0.008zM340.392 366.826c0.008 0.008 0.018 0.016 0.026 0.024-0.008-0.008-0.016-0.016-0.026-0.024zM342.696 368.872c0.020 0.018 0.040 0.036 0.060 0.052-0.020-0.018-0.040-0.036-0.060-0.052zM345.098 370.806c0.032 0.024 0.064 0.050 0.096 0.076-0.032-0.026-0.064-0.052-0.096-0.076zM347.622 372.646c0.032 0.022 0.064 0.046 0.096 0.068-0.034-0.022-0.064-0.046-0.096-0.068zM350.252 374.374c0.026 0.016 0.050 0.032 0.076 0.048-0.026-0.016-0.050-0.032-0.076-0.048zM384 472v16h-174.778c-1.81-5.284-3.484-10.618-5.014-16h179.792zM204.202 471.98c-0.742-2.614-1.454-5.236-2.13-7.872 0.678 2.634 1.386 5.258 2.13 7.872zM202.044 464.004c-0.678-2.644-1.326-5.3-1.934-7.966 0.61 2.666 1.256 5.322 1.934 7.966zM212.118 496.094c0.988 2.648 2.010 5.284 3.070 7.906h168.812v16h-161.838c2.54 5.406 5.242 10.738 8.088 16h153.75v16h-144.468c1.606 2.596 3.252 5.17 4.932 7.726-13.196-20.004-24.022-41.33-32.346-63.632v0zM209.224 488.006c0.914 2.67 1.866 5.328 2.85 7.97-0.986-2.642-1.936-5.298-2.85-7.97zM384 568v16h-121.824c-6.182-7.696-11.988-15.624-17.392-23.786 1.728 2.62 3.494 5.214 5.306 7.786h133.91zM262.186 584.012c4.384 5.458 8.956 10.79 13.722 15.988h108.092v16h-92.398c2.812 2.674 5.67 5.282 8.562 7.838-4.924-4.36-9.748-8.87-14.44-13.56-8.38-8.382-16.218-17.156-23.538-26.266zM300.786 624.39c2.948 2.594 5.934 5.13 8.96 7.61h74.254v16h-52.968c6.246 4.296 12.624 8.364 19.128 12.19-17.422-10.244-33.948-22.21-49.374-35.8zM384 664v13.458c-11.564-5.044-22.826-10.792-33.744-17.208 2.174 1.278 4.362 2.528 6.562 3.752l27.182-0.002zM608 832h-192c-17.6 0-32-14.4-32-32s14.4-32 32-32h192c17.6 0 32 14.4 32 32s-14.4 32-32 32zM640 664h27.178c2.202-1.222 4.384-2.472 6.556-3.748-10.914 6.412-22.174 12.158-33.734 17.206v-13.458zM673.878 660.164c6.486-3.818 12.854-7.876 19.086-12.164h-52.964v-16h74.252c-12.802 10.476-26.294 19.882-40.374 28.164zM714.252 632c3.028-2.478 6.016-5.018 8.964-7.614-2.946 2.598-5.936 5.136-8.964 7.614zM723.83 623.842c2.876-2.544 5.724-5.138 8.524-7.798-2.8 2.66-5.646 5.248-8.524 7.798zM732.398 616h-92.398v-16h108.094c-3.194 3.482-6.458 6.916-9.818 10.278-1.938 1.936-3.9 3.844-5.878 5.722zM761.812 584.014c-4.38 5.452-8.95 10.784-13.708 15.976 4.762-5.198 9.328-10.526 13.708-15.976zM779.548 559.708c1.674-2.544 3.31-5.112 4.912-7.696-1.598 2.584-3.234 5.15-4.912 7.696zM773.922 567.982c1.806-2.56 3.566-5.148 5.29-7.756-1.728 2.606-3.484 5.196-5.29 7.756zM608 960h-192c-17.6 0-32-14.4-32-32s14.4-32 32-32h192c17.6 0 32 14.4 32 32s-14.4 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lamp",
						"light",
						"idea",
						"tip",
						"bulb",
						"dualtone"
					],
					"defaultCode": 60408,
					"grid": 16
				},
				{
					"id": 2574,
					"width": 1023.9999999999999,
					"paths": [
						"M320 640c-0.25 106.040 85.962 128 192 128 106.040 0 191.75-21.96 192-128s127.75-143.268 128-320-143.27-320-320-320c-176.732 0-319.75 143.268-320 320s128.25 213.96 128 320z",
						"M512 832c-78.986 0-144.596-17.554-157.636-97.008-1.548 10.724-2.364 21.752-2.364 33.008 0 106.040 71.634 128 160 128s160-21.96 160-128c0-11.256-0.816-22.284-2.364-33.008-13.042 79.454-78.65 97.008-157.636 97.008z",
						"M512 960c-63.188 0-115.676-17.554-126.108-97.008-1.24 10.724-1.892 21.752-1.892 33.008 0 106.040 57.308 128 128 128 70.694 0 128-21.96 128-128 0-11.256-0.652-22.284-1.89-33.008-10.434 79.454-62.92 97.008-126.11 97.008z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lamp",
						"light",
						"idea",
						"tip",
						"bulb"
					],
					"defaultCode": 60409,
					"grid": 16
				},
				{
					"id": 2575,
					"paths": [
						"M512 64c68.51 0 132.896 26.696 181.302 75.17 48.266 48.334 74.792 112.522 74.698 180.738-0.112 78.708-31.016 120.828-63.734 165.422-30.048 40.954-64.108 87.372-64.266 154.518-0.076 32.636-11.276 41.41-22.738 47.602-20.336 10.982-55.752 16.55-105.262 16.55-76.074 0-105.296-13.286-116.416-24.432-2.88-2.888-11.65-11.678-11.584-39.416 0.16-67.41-34.11-113.942-64.346-154.996-32.792-44.524-63.764-86.578-63.654-165.066 0.098-68.45 26.764-132.774 75.086-181.122 48.318-48.344 112.568-74.968 180.914-74.968zM512 0c-176.732 0-319.75 143.268-320 320s128.25 213.96 128 320 85.962 128 192 128c106.040 0 191.75-21.96 192-128s127.75-143.268 128-320-143.27-320-320-320v0z",
						"M512 832c-78.986 0-144.596-17.554-157.636-97.008-1.548 10.724-2.364 21.752-2.364 33.008 0 106.040 71.634 128 160 128s160-21.96 160-128c0-11.256-0.816-22.284-2.364-33.008-13.042 79.454-78.65 97.008-157.636 97.008z",
						"M512 960c-63.188 0-115.676-17.554-126.108-97.008-1.24 10.724-1.892 21.752-1.892 33.008 0 106.040 57.308 128 128 128 70.694 0 128-21.96 128-128 0-11.256-0.652-22.284-1.89-33.008-10.434 79.454-62.92 97.008-126.11 97.008z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lamp",
						"light",
						"idea",
						"tip",
						"bulb"
					],
					"defaultCode": 60410,
					"grid": 16
				},
				{
					"id": 2684,
					"paths": [
						"M1024 896v-384h-256v-256h-256v-192h-512v384h192v64h-64v64h256v-64h-64v-64h192v-128h192v192h-192v384h192v64h-64v64h256v-64h-64v-64h192zM448 384h-384v-256h384v256zM576 832v-256h384v256h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lan",
						"network",
						"p2p",
						"connection"
					],
					"defaultCode": 60519,
					"grid": 16
				},
				{
					"id": 2685,
					"paths": [
						"M928 512h-416v-128h96c17.674 0 32-14.328 32-32v-256c0-17.672-14.326-32-32-32h-256c-17.672 0-32 14.328-32 32v256c0 17.672 14.328 32 32 32h96v128h-416c-17.672 0-32 14.326-32 32s14.328 32 32 32h160v128h-96c-17.672 0-32 14.326-32 32v256c0 17.674 14.328 32 32 32h256c17.672 0 32-14.326 32-32v-256c0-17.674-14.328-32-32-32h-96v-128h448v128h-96c-17.674 0-32 14.326-32 32v256c0 17.674 14.326 32 32 32h256c17.674 0 32-14.326 32-32v-256c0-17.674-14.326-32-32-32h-96v-128h160c17.674 0 32-14.326 32-32s-14.326-32-32-32zM384 128h192v192h-192v-192zM320 960h-192v-192h192v192zM832 960h-192v-192h192v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lan",
						"network",
						"p2p",
						"connection"
					],
					"defaultCode": 60520,
					"grid": 16
				},
				{
					"id": 2686,
					"width": 1280,
					"paths": [
						"M832 736l96 96 320-320-320-320-96 96 224 224-224 224z",
						"M448 288l-96-96-320 320 320 320 96-96-224-224 224-224z",
						"M512 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
						"M704 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
						"M896 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lan",
						"network"
					],
					"defaultCode": 60521,
					"grid": 16
				},
				{
					"id": 1566,
					"width": 877.7130014896393,
					"paths": [
						"M373.714 616q-0.571 1.714-7.143-0.286t-18-6.571l-11.429-5.143q-25.143-11.429-49.714-28-4-2.857-23.429-18t-21.714-16.286q-38.286 58.857-76.571 103.429-46.286 54.286-60 62.857-2.286 1.143-11.143 2.286t-10.571 0q3.429-2.286 46.857-52.571 12-13.714 48.857-65.714t44.857-67.429q9.714-17.143 29.143-56.286t20.571-44.286q-4.571-0.571-62.857 18.857-4.571 1.143-15.714 4.286t-19.714 5.429-9.714 2.857q-1.143 1.143-1.143 6t-0.571 5.429q-2.857 5.714-17.714 8.571-13.143 4-26.857 0-10.286-2.286-16-12-2.286-3.429-2.857-13.143 3.429-1.143 14-2.857t16.857-3.429q33.143-9.143 60-18.286 57.143-20 58.286-20 5.714-1.143 24.571-11.143t25.143-12.286q5.143-1.714 12.286-4.571t8.286-3.143 3.429 0.286q1.143 6.857-0.571 18.857 0 1.143-7.143 15.429t-15.143 30.571-9.714 19.143q-14.286 28.571-44 74.857l36.571 16q6.857 3.429 42.571 18.286t38.571 16q2.286 0.571 6 14.571t2.571 17.429zM256.571 338.286q1.714 8.571-2.286 16-6.857 13.143-28.571 21.714-17.143 6.857-34.286 6.857-14.857-1.714-28-14.857-8-8.571-10.286-23.429l0.571-1.714q1.714 1.714 11.143 2.857t15.143 0 33.143-9.143q20.571-6.857 31.429-8 9.714 0 12 9.714zM655.429 412l36 129.714-79.429-24zM22.286 869.143l396.571-132.571v-589.714l-396.571 133.143v589.143zM731.429 688l58.286 17.714-103.429-375.429-57.143-17.714-123.429 306.286 58.286 17.714 25.714-62.857 120.571 37.143zM444 138.286l327.429 105.143v-217.143zM621.714 894.286l90.286 7.429-30.857 91.429-22.857-37.714q-74.286 47.429-157.714 61.714-33.143 6.857-52 6.857h-48q-45.143 0-114-22.286t-104.857-48.571q-4.571-4-4.571-9.143 0-4.571 2.857-7.714t7.429-3.143q2.286 0 10.286 4.286t17.429 9.429 11.714 6.286q41.714 21.143 91.143 35.143t90 14q54.286 0 95.429-8.286t89.714-28.857q8.571-4 17.429-8.857t19.429-10.857 16.286-9.429zM877.714 277.714v616.571l-442.286-140.571q-8 3.429-214.286 72.857t-210.286 69.429q-7.429 0-10.286-7.429 0-0.571-0.571-1.714v-616q1.714-5.143 2.286-5.714 2.857-3.429 11.429-6.286 60.571-20 85.143-28.571v-219.429l318.857 113.143q1.143 0 91.714-31.429t180.571-62 92.286-30.571q11.429 0 11.429 12v238.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"language"
					],
					"defaultCode": 61867,
					"grid": 14
				},
				{
					"id": 3350,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM822.4 768.8l-348.4 114c-79.6 26-87.6 21.8-123.6-89.6l-88-272.6c-21-64.6-85-238.6-95.8-272-20-62-20-65.4 97-103.4 91.6-30 95.4-29 128.6 74.4 26.8 83.2 44 150.4 71.6 235.4l75 232 239.6-78.4c47.2-15.6 63-14.8 76.4 43.4l9.6 44c11.2 51-14.6 64-42 72.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lanyrd",
						"brand"
					],
					"defaultCode": 61185,
					"grid": 16
				},
				{
					"id": 2188,
					"paths": [
						"M896 704v-512c0-35.2-28.8-64-64-64h-640c-35.2 0-64 28.8-64 64v512h-128v192h1024v-192h-128zM640 832h-256v-64h256v64zM832 704h-640v-511.886c0.034-0.040 0.076-0.082 0.114-0.114h639.77c0.040 0.034 0.082 0.076 0.116 0.116v511.884z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"laptop",
						"computer",
						"pc"
					],
					"defaultCode": 60023,
					"grid": 16
				},
				{
					"id": 156,
					"paths": [
						"M588.8 716.8h-409.6c-42.347 0-76.8-34.451-76.8-76.8v-409.6c0-42.347 34.453-76.8 76.8-76.8h665.6c42.349 0 76.8 34.453 76.8 76.8v51.2c0 14.138-11.461 25.6-25.6 25.6s-25.6-11.462-25.6-25.6v-51.2c0-14.115-11.485-25.6-25.6-25.6h-665.6c-14.115 0-25.6 11.485-25.6 25.6v409.6c0 14.115 11.485 25.6 25.6 25.6h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M588.8 921.6h-512c-42.347 0-76.8-34.453-76.8-76.8v-51.2c0-14.139 11.462-25.6 25.6-25.6h563.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6h-537.6v25.6c0 14.115 11.485 25.6 25.6 25.6h512c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M947.2 921.6h-204.8c-42.347 0-76.8-34.453-76.8-76.8v-409.6c0-42.347 34.453-76.8 76.8-76.8h204.8c42.347 0 76.8 34.453 76.8 76.8v409.6c0 42.347-34.453 76.8-76.8 76.8zM742.4 409.6c-14.115 0-25.6 11.485-25.6 25.6v409.6c0 14.115 11.485 25.6 25.6 25.6h204.8c14.115 0 25.6-11.485 25.6-25.6v-409.6c0-14.115-11.485-25.6-25.6-25.6h-204.8z",
						"M844.8 819.2c-6.736 0-13.328-2.736-18.098-7.504-4.766-4.768-7.502-11.36-7.502-18.096s2.736-13.344 7.502-18.098c4.754-4.766 11.362-7.502 18.098-7.502s13.344 2.736 18.096 7.502c4.768 4.754 7.504 11.346 7.504 18.098 0 6.736-2.736 13.344-7.504 18.096-4.768 4.768-11.36 7.504-18.096 7.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"laptop-phone",
						"devices",
						"responsive"
					],
					"defaultCode": 59453,
					"grid": 20
				},
				{
					"id": 1416,
					"width": 1097.1438789367676,
					"paths": [
						"M237.714 731.429q-37.714 0-64.571-26.857t-26.857-64.571v-402.286q0-37.714 26.857-64.571t64.571-26.857h621.714q37.714 0 64.571 26.857t26.857 64.571v402.286q0 37.714-26.857 64.571t-64.571 26.857h-621.714zM219.429 237.714v402.286q0 7.429 5.429 12.857t12.857 5.429h621.714q7.429 0 12.857-5.429t5.429-12.857v-402.286q0-7.429-5.429-12.857t-12.857-5.429h-621.714q-7.429 0-12.857 5.429t-5.429 12.857zM1005.714 768h91.429v54.857q0 22.857-26.857 38.857t-64.571 16h-914.286q-37.714 0-64.571-16t-26.857-38.857v-54.857h1005.714zM594.286 822.857q9.143 0 9.143-9.143t-9.143-9.143h-91.429q-9.143 0-9.143 9.143t9.143 9.143h91.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"laptop"
					],
					"defaultCode": 61705,
					"grid": 14
				},
				{
					"id": 155,
					"paths": [
						"M179.2 716.8h665.6c42.349 0 76.8-34.451 76.8-76.8v-409.6c0-42.347-34.451-76.8-76.8-76.8h-665.6c-42.347 0-76.8 34.453-76.8 76.8v409.6c0 42.349 34.453 76.8 76.8 76.8zM153.6 230.4c0-14.115 11.485-25.6 25.6-25.6h665.6c14.115 0 25.6 11.485 25.6 25.6v409.6c0 14.115-11.485 25.6-25.6 25.6h-665.6c-14.115 0-25.6-11.485-25.6-25.6v-409.6z",
						"M998.4 768h-972.8c-14.138 0-25.6 11.461-25.6 25.6v51.2c0 42.349 34.453 76.8 76.8 76.8h870.4c42.349 0 76.8-34.451 76.8-76.8v-51.2c0-14.139-11.461-25.6-25.6-25.6zM947.2 870.4h-870.4c-14.115 0-25.6-11.485-25.6-25.6v-25.6h921.6v25.6c0 14.115-11.485 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"laptop",
						"computer",
						"pc"
					],
					"defaultCode": 59452,
					"grid": 20
				},
				{
					"id": 2877,
					"paths": [
						"M953.198 330.062c-43.284-161.532-209.66-270.062-414.010-270.062-51.24 0-103.026 6.916-153.92 20.552-123.344 33.050-229.458 102.216-298.8 194.762-71.29 95.148-95.542 203.566-68.288 305.284 17.786 66.376 56.37 123.792 109.82 168.418v242.984c0 17.674 14.328 32 32 32s32-14.326 32-32v-165.484c10.012 3.54 20.776 5.484 32 5.484 13.95 0 27.192-3 39.152-8.352 51.566 17.528 108.64 27.014 169.038 27.014 51.24 0 103.026-6.916 153.922-20.552 123.342-33.050 229.458-102.218 298.796-194.762 71.292-95.148 95.544-203.568 68.29-305.286zM224 768c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM567.476 760.562c-44.818 12.010-90.336 18.1-135.286 18.1-41.022 0-80.15-5.006-116.428-14.38 2.752-8.942 4.24-18.438 4.24-28.282 0-53.020-42.98-96-96-96-28.874 0-54.748 12.764-72.346 32.936-30.568-31.53-52.686-69.020-63.926-110.972-21.416-79.918-1.398-166.388 56.362-243.476 59.71-79.694 151.98-139.494 259.812-168.388 44.818-12.012 90.334-18.1 135.284-18.1 171.304 0 309.732 87.084 344.462 216.698 45.096 168.304-96.74 353.066-316.174 411.864z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lasso"
					],
					"defaultCode": 60712,
					"grid": 16
				},
				{
					"id": 2878,
					"paths": [
						"M448 778.404c-5.276 0.166-10.548 0.258-15.812 0.258-41.022 0-80.15-5.006-116.428-14.38 2.752-8.942 4.24-18.438 4.24-28.282 0-53.020-42.98-96-96-96-28.874 0-54.748 12.764-72.346 32.936-30.568-31.53-52.686-69.020-63.926-110.972-21.416-79.918-1.398-166.388 56.362-243.476 59.71-79.694 151.98-139.494 259.812-168.388 44.82-12.012 90.336-18.1 135.286-18.1 171.304 0 309.732 87.084 344.462 216.698 14.482 54.054 9.658 109.8-10.8 162.532l59.356 44.624c33.296-73.654 40.896-151.506 20.992-225.792-43.284-161.532-209.66-270.062-414.010-270.062-51.24 0-103.026 6.916-153.92 20.552-123.344 33.050-229.458 102.216-298.8 194.762-71.29 95.148-95.542 203.566-68.288 305.284 17.786 66.376 56.37 123.792 109.82 168.418v242.984c0 17.674 14.328 32 32 32s32-14.326 32-32v-165.484c10.012 3.54 20.776 5.484 32 5.484 13.95 0 27.192-3 39.152-8.352 51.566 17.528 108.64 27.014 169.038 27.014 5.264 0 10.536-0.092 15.812-0.238v-72.020zM224 768c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32z",
						"M512 320v638.612l227.442-183.732 283.308-70.88z",
						"M797.018 746.162l-114.542 57.132 110.028 220.596 0.056-0.15 114.438-57.080z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lasso"
					],
					"defaultCode": 60713,
					"grid": 16
				},
				{
					"id": 2976,
					"paths": [
						"M896 128v768h-128v-352l-320 320v-320l-320 320v-704l320 320v-320l320 320v-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"last",
						"player"
					],
					"defaultCode": 60811,
					"grid": 16
				},
				{
					"id": 3019,
					"paths": [
						"M192 832l192 192 512-512-512-512-192 192 320 320zM1024 1024v-1024h-128v1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"last",
						"player"
					],
					"defaultCode": 60854,
					"grid": 16
				},
				{
					"id": 3391,
					"paths": [
						"M451.6 766.2l-37.6-102c0 0-61 68-152.4 68-81 0-138.4-70.4-138.4-183 0-144.2 72.8-195.8 144.2-195.8 103.2 0 136 66.8 164.2 152.4l37.6 117.2c37.6 113.8 108 205.2 310.8 205.2 145.4 0 244-44.6 244-161.8 0-95-54-144.2-154.8-167.8l-75-16.4c-51.6-11.8-66.8-32.8-66.8-68 0-39.8 31.6-63.4 83.2-63.4 56.4 0 86.8 21.2 91.4 71.6l117.2-14c-9.4-105.6-82.2-149-201.8-149-105.6 0-208.8 39.8-208.8 167.8 0 79.8 38.8 130.2 136 153.6l79.8 18.8c59.8 14 79.8 38.8 79.8 72.8 0 43.4-42.2 61-122 61-118.4 0-167.8-62.2-195.8-147.8l-38.8-117.2c-49-152.6-127.6-208.8-283.6-208.8-172.4 0-264 109-264 294.4 0 178.2 91.4 274.4 255.8 274.4 132.4 0 195.8-62.2 195.8-62.2v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lastfm",
						"brand",
						"social"
					],
					"defaultCode": 61226,
					"grid": 16
				},
				{
					"id": 1648,
					"width": 877.7129821777344,
					"paths": [
						"M818.286 601.143q0-98.857-133.714-136.571-20-5.714-30.286-9.429t-21.714-14.286-16.571-26.571q0-1.143-1.143-4.857t-1.714-6.857-0.571-4.286q0-20.571 14-34t34.571-13.429q30.857 0 40.571 8.571h-0.571q11.429 8.571 22.286 29.143l53.143-40.571q-22.286-30.857-28-36.571-18.857-16.571-38.571-22.286t-48.857-5.714q-45.714 0-81.143 32.857t-35.429 78.571q0 4 1.143 13.143 9.143 54.857 36.857 80t84.857 41.714q16.571 4.571 28 8.857t25.714 12.286 22 19.714 7.714 26.571v2.857q0.571 33.143-23.143 53.143t-57.429 20q-55.429 0-95.429-82.286-13.143-26.857-29.429-69.429t-27.429-71.714-30.857-63.143-42.286-54.571-59.143-34.571-84-14q-57.714 0-109.714 32t-82.286 84.571-28.571 109.714v0.571q2.286 61.714 28.857 113.714t76.286 84.286 112 32.286q106.286 0 159.429-62.857 11.429-15.429 17.714-29.143l-34.286-62.286q-24 45.714-56.571 66.286t-83.429 20.571q-65.714 0-109.143-49.714t-43.429-116.571q0-60 46.857-108t106.286-48q64 0 97.143 30.571t59.429 98.571q4.571 12 14.571 39.143t16.286 43.714 18 42.571 22 42.286 26 35.714 31.714 30.571 37.714 18.857 45.714 7.714q61.143 0 104.571-39.714t43.429-99.714zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lastfm-square"
					],
					"defaultCode": 61955,
					"grid": 14
				},
				{
					"id": 3392,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM746.6 760.8c-177.6 0-239.2-80-272-179.6l-32.8-102.6c-24.6-75-53.4-133.4-143.6-133.4-62.6 0-126.2 45.2-126.2 171.4 0 98.6 50.2 160.2 121.2 160.2 80 0 133.4-59.6 133.4-59.6l32.8 89.2c0 0-55.4 54.4-171.4 54.4-144 0-224-84-224-240 0-162.2 80-257.6 231-257.6 136.6 0 205.2 49.2 248.4 182.6l33.8 102.6c24.6 75 67.8 129.4 171.4 129.4 69.8 0 106.8-15.4 106.8-53.4 0-29.8-17.4-51.4-69.8-63.6l-69.8-16.4c-85.2-20.6-119-64.6-119-134.4 0-111.8 90.4-146.8 182.6-146.8 104.6 0 168.4 38 176.6 130.4l-102.6 12.4c-4.2-44.2-30.8-62.6-80-62.6-45.2 0-72.8 20.6-72.8 55.4 0 30.8 13.4 49.2 58.4 59.6l65.6 14.4c88.2 20.6 135.4 63.6 135.4 146.8 0 102.2-86.2 141.2-213.4 141.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lastfm",
						"brand",
						"social"
					],
					"defaultCode": 61227,
					"grid": 16
				},
				{
					"id": 1647,
					"width": 1024.0021667480469,
					"paths": [
						"M738.286 402.286q0 3.429 5.714 23.429 5.714 16.571 14.286 28.286t23.429 19.429 25.143 11.429 31.429 9.429q185.714 52 185.714 189.714 0 83.429-60.286 138.571t-145.429 55.143q-33.714 0-63.714-10.571t-52.286-26-44-42.571-36-50-30.571-59.143-24.857-58.857-22.571-60.857-20.286-54.286q-18.286-46.286-35.143-76.286t-42-55.143-59.429-36.571-81.143-11.429q-54.857 0-104.571 31.714t-78.857 82.571-29.143 105.714q0 91.429 60.857 159.714t150.571 68.286q101.143 0 147.429-54.286 32-36 47.429-66.286l48 86.857q-8.571 19.429-25.143 40l0.571 0.571q-74.857 86.857-221.714 86.857-84 0-154-45.143t-108.857-118.571-38.857-156.857q0-60 24.857-117.714t66.286-100.857 98.286-69.429 116.857-26.286q49.714 0 90.857 10.857t70.571 28.571 54.286 45.714 41.429 56.571 33.429 66.857 28.857 71.143 28.571 74.571 31.429 72.571q54.857 114.286 133.143 114.286 46.286 0 79.143-27.714t32.857-73.429q0-24-10.857-41.143t-28.857-26.286-41.429-18-48.286-15.429-50-19.429-46.286-29.714-37.143-46.857-22.286-70q-1.714-9.143-1.714-18.857 0-62.857 50-109.714t113.429-44.571q44.571 1.714 68.857 8.286t51.714 30.571h-0.571q6.857 6.286 13.143 14t14.857 20.571 10.857 15.714l-73.714 56.571q-14.857-28-30.857-40v-0.571q-13.143-12-55.429-12-28 0-48 18.857t-20 47.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lastfm"
					],
					"defaultCode": 61954,
					"grid": 14
				},
				{
					"id": 601,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 928c-229.376 0-416-186.624-416-416s186.624-416 416-416 416 186.624 416 416-186.624 416-416 416zM241.664 416h-0.032c-9.92 0-17.728-8.96-15.776-18.688 8.704-44.032 47.616-77.312 94.144-77.312s85.44 33.28 94.176 77.312c1.92 9.728-5.888 18.688-15.808 18.688h-0.032c-7.456 0-14.112-5.12-15.552-12.448-5.792-29.344-31.744-51.552-62.784-51.552s-56.992 22.208-62.784 51.552c-1.44 7.328-8.096 12.448-15.552 12.448zM782.368 416h-0.032c-7.456 0-14.112-5.12-15.552-12.448-5.792-29.344-31.744-51.552-62.784-51.552s-56.992 22.208-62.784 51.552c-1.44 7.328-8.096 12.448-15.552 12.448h-0.032c-9.92 0-17.728-8.96-15.776-18.688 8.704-44.032 47.616-77.312 94.144-77.312s85.44 33.28 94.176 77.312c1.92 9.728-5.888 18.688-15.808 18.688zM768 608c0-64-114.624-96-256-96s-256 32-256 96c0 11.072 0.928 21.888 2.304 32.576 0.192 1.44 0.448 2.816 0.64 4.256 17.888 123.872 124.192 219.168 253.056 219.168 128.832 0 235.136-95.264 253.056-219.168 0.224-1.44 0.448-2.848 0.672-4.288 1.344-10.688 2.272-21.504 2.272-32.544zM512 544c140.224 0 224 32.544 224 64 0 7.808-0.448 15.712-1.344 23.648-38.432-11.136-107.296-23.648-222.656-23.648s-184.224 12.512-222.656 23.648c-0.896-7.936-1.344-15.84-1.344-23.648 0-31.456 83.776-64 224-64zM512 832c-104.416 0-192.096-71.904-216.832-168.736 33.696-10.176 99.616-23.264 216.832-23.264s183.136 13.056 216.832 23.264c-24.736 96.832-112.416 168.736-216.832 168.736z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"laugh",
						"yell",
						"smile",
						"grin"
					],
					"grid": 32
				},
				{
					"id": 602,
					"width": 1024,
					"paths": [
						"M736 608c0 7.808-0.448 15.712-1.344 23.648-38.432-11.136-107.296-23.648-222.656-23.648s-184.224 12.512-222.656 23.648c-0.896-7.936-1.344-15.84-1.344-23.648 0-31.456 83.776-64 224-64s224 32.544 224 64zM295.168 663.264c24.736 96.832 112.416 168.736 216.832 168.736s192.096-71.904 216.832-168.736c-33.696-10.176-99.616-23.264-216.832-23.264s-183.136 13.088-216.832 23.264zM960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448 200.576-448 448-448 448 200.576 448 448zM257.216 403.552c5.792-29.344 31.744-51.552 62.784-51.552s56.992 22.208 62.784 51.552c1.44 7.328 8.096 12.448 15.552 12.448h0.032c9.92 0 17.728-8.96 15.776-18.688-8.704-44.032-47.616-77.312-94.144-77.312s-85.44 33.28-94.176 77.312c-1.92 9.728 5.888 18.688 15.808 18.688h0.032c7.456 0 14.112-5.12 15.552-12.448zM768 608c0-64-114.624-96-256-96s-256 32-256 96c0 11.072 0.928 21.888 2.304 32.576 0.192 1.44 0.448 2.816 0.64 4.256 17.888 123.872 124.192 219.168 253.056 219.168 128.832 0 235.136-95.264 253.056-219.168 0.224-1.44 0.448-2.848 0.672-4.288 1.344-10.688 2.272-21.504 2.272-32.544zM798.176 397.312c-8.736-44.032-47.648-77.312-94.176-77.312s-85.44 33.28-94.176 77.312c-1.92 9.728 5.888 18.688 15.808 18.688h0.032c7.456 0 14.112-5.12 15.552-12.448 5.792-29.344 31.744-51.552 62.784-51.552s56.992 22.208 62.784 51.552c1.44 7.328 8.096 12.448 15.552 12.448h0.032c9.92 0 17.728-8.96 15.808-18.688z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"laugh",
						"yell",
						"smile",
						"grin"
					],
					"grid": 32
				},
				{
					"id": 603,
					"width": 1024,
					"paths": [
						"M512 256c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM512 416c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64zM747.776 551.84c11.776-51.84 20.224-109.152 20.224-167.84 0-189.312-149.888-313.76-220.288-361.728-21.6-14.752-49.824-14.752-71.424 0-70.4 47.968-220.288 172.416-220.288 361.728 0 64.608 6.624 121.44 16.288 170.464l-66.048 44.032c-8.896 5.952-14.24 15.936-14.24 26.624v130.464c0 18.24 14.944 32.032 31.936 32.032 3.328 0 6.752-0.544 10.176-1.664l107.072-35.68c6.56 11.52 10.816 17.728 10.816 17.728l-17.952 53.888c-6.912 20.704 8.512 42.112 30.336 42.112h19.040c-2.72 10.272-4.672 20.864-4.672 32 0 39.136 9.824 74.176 18.56 97.664 6.432 17.28 25.952 25.792 42.784 18.336 8.8-3.904 18.944-8.64 29.664-14.112 12.288 7.872 23.712 14.24 32.224 18.72 9.376 4.928 20.384 5.024 29.76 0.128 3.968-2.080 8.544-4.544 13.568-7.392 9.024-5.12 20.096-5.664 29.504-1.312 3.104 1.44 6.080 2.784 8.928 4.032 16.928 7.488 36.352-0.992 42.816-18.336 8.768-23.488 18.56-58.528 18.56-97.664 0-11.136-1.952-21.728-4.672-32h19.040c21.856 0 37.28-21.408 30.368-42.112l-17.856-53.952c0 0 3.36-6.496 8.864-18.368l109.024 36.352c3.392 1.12 6.816 1.664 10.176 1.664 16.992 0 31.936-13.76 31.936-32.032v-130.464c0-10.688-5.344-20.704-14.24-26.624l-69.984-46.688zM224 755.616v-130.464l55.648-37.088c14.176 58.464 32.096 103.2 46.656 133.472l-102.304 34.080zM596.576 982.624c-6.784-3.008-14.464-6.56-22.528-10.56v0c-9.952-4.96-21.728-4.384-31.168 1.472v0c-9.856 6.112-18.912 11.136-25.824 14.752-7.872-4.128-18.528-10.048-29.984-17.376v0c-9.6-6.144-21.728-6.72-31.872-1.536v0c-9.984 5.12-19.52 9.568-27.776 13.216-7.744-20.8-16.672-52.192-16.672-86.592 0-11.296 2.272-21.984 5.984-32h31.264c0 20.64 21.824 49.92 40 70.72 12.672 14.496 35.328 14.496 48 0 18.176-20.8 40-50.080 40-70.72h31.232c3.712 10.016 5.984 20.704 5.984 32 0 34.528-8.896 65.856-16.64 86.624zM480 864h64c-0.48 8.416-14.208 29.088-32.032 49.664-17.824-20.576-31.552-41.312-31.968-49.664zM364.384 832l21.28-64h252.576l21.344 64h-295.2zM651.84 736h-281.92c-22.304-39.136-81.92-161.6-81.92-352 0-173.344 140.736-290.144 206.272-335.104 10.72-7.36 24.832-7.392 35.584-0.032 65.536 44.8 206.144 161.248 206.144 335.136 0 154.656-61.536 302.816-84.16 352zM800 755.616l-106.24-35.424c13.6-32.544 31.232-79.744 45.92-135.264l60.32 40.192v130.496zM512 192c-88.224 0-160 71.776-160 160s71.776 160 160 160 160-71.776 160-160-71.776-160-160-160zM512 480c-70.688 0-128-57.312-128-128s57.312-128 128-128c70.688 0 128 57.312 128 128s-57.312 128-128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"launch",
						"fly",
						"orbit",
						"blast"
					],
					"grid": 32
				},
				{
					"id": 604,
					"width": 1024,
					"paths": [
						"M817.76 598.496l-69.984-46.656c11.776-51.84 20.224-109.152 20.224-167.84 0-189.312-149.888-313.76-220.288-361.728-21.6-14.752-49.824-14.752-71.424 0-70.4 47.968-220.288 172.416-220.288 361.728 0 64.608 6.624 121.44 16.288 170.464l-66.048 44.032c-8.896 5.952-14.24 15.936-14.24 26.624v130.464c0 18.24 14.944 32.032 31.936 32.032 3.328 0 6.752-0.544 10.176-1.664l107.072-35.68c6.56 11.52 10.816 17.728 10.816 17.728l-17.952 53.888c-6.912 20.704 8.512 42.112 30.368 42.112h295.2c21.856 0 37.248-21.408 30.368-42.112l-17.984-53.888c0 0 3.36-6.496 8.864-18.368l109.024 36.352c3.392 1.12 6.816 1.664 10.176 1.664 16.992 0 31.936-13.76 31.936-32.032v-130.464c0-10.72-5.344-20.704-14.24-26.656zM512 512c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.776 160-160 160zM576 352c0 35.296-28.704 64-64 64s-64-28.704-64-64c0-35.296 28.704-64 64-64s64 28.704 64 64zM512 224c-70.688 0-128 57.312-128 128s57.312 128 128 128c70.688 0 128-57.312 128-128s-57.312-128-128-128zM512 448c-53.024 0-96-42.976-96-96s42.976-96 96-96 96 42.976 96 96-42.976 96-96 96zM378.784 896h266.432c0 39.136-9.824 74.176-18.56 97.664-6.464 17.344-25.92 25.824-42.816 18.336-2.848-1.248-5.824-2.592-8.928-4.032-9.408-4.352-20.512-3.808-29.504 1.312-5.024 2.848-9.6 5.344-13.568 7.392-9.408 4.928-20.384 4.8-29.792-0.128-8.512-4.48-19.936-10.848-32.224-18.72-10.688 5.472-20.864 10.24-29.664 14.112-16.864 7.456-36.352-1.056-42.784-18.336-8.768-23.424-18.592-58.464-18.592-97.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"launch",
						"fly",
						"orbit",
						"blast"
					],
					"grid": 32
				},
				{
					"id": 1053,
					"width": 1024,
					"paths": [
						"M973.76 47.488c-62.144-62.144-360.832-92.928-521.824 68.032-47.968 47.968-84.896 89.792-114.816 129.984-58.752-10.72-112.768 6.88-157.44 51.52l-113.44 113.44c-12.544 12.544-12.544 32.864 0 45.376l45.504 45.504c12.544 12.544 32.864 12.544 45.376 0 27.424-27.424 56.224-36.576 87.488-27.648-0.864 53.696 14.944 104.928 47.232 152.896-7.712 11.040-17.472 23.616-25.856 34.048-10.272 12.768-9.184 31.136 2.368 42.72l49.536 49.536c11.584 11.584 29.952 12.64 42.72 2.368 10.432-8.384 22.976-18.176 34.048-25.856 47.968 32.288 99.2 48.064 152.896 47.232 8.928 31.264-0.224 60.032-27.648 87.488-12.544 12.544-12.544 32.864 0 45.376l45.504 45.504c12.544 12.544 32.864 12.544 45.376 0l113.472-113.472c44.672-44.672 62.24-98.72 51.488-157.472 40.192-29.888 82.016-66.848 129.984-114.816 160.96-160.928 130.176-459.616 68.032-521.76zM284.224 420.352c-51.52-22.816-102.976-17.76-148 14.688l-1.888-1.888 90.752-90.752c31.2-31.2 66.368-41.568 107.008-32.192-22.112 35.936-39.008 72.736-47.872 110.144zM342.848 687.104l-8.704-8.704c40.384-60.032 100.896-135.712 171.936-208.48l33.92 11.296 11.296 33.92c-72.672 70.976-148.48 131.616-208.448 171.968zM678.816 796.192l-90.752 90.752-1.888-1.888c32.48-45.056 37.504-96.48 14.72-148 37.408-8.864 74.24-25.792 110.112-47.84 9.408 40.64-0.992 75.776-32.192 106.976zM577.664 709.92l-12.48 1.376c-38.944 4.256-75.52-2.944-110.912-21.28l-5.856-3.008c-8.864-4.896-17.6-11.008-26.336-17.376 44.384-33.888 102.656-82.304 166.016-145.632l-22.688-68.064-68.064-22.688c-63.36 63.36-111.776 121.632-145.632 166.016-6.4-8.736-12.448-17.472-17.376-26.336l-3.008-5.888c-18.336-35.392-25.536-71.968-21.28-110.88l1.344-12.48c13.664-80.32 74.656-171.36 185.984-282.688 139.936-139.936 402.912-96.256 431.072-68.064 28.16 28.16 71.872 291.168-68.064 431.072-111.36 111.232-202.432 172.224-282.72 185.92zM215.2 776.704c-12.032-12.032-27.584-18.4-45.024-18.4-43.904 0-88.16 42.048-96.608 50.464-72.736 72.768-73.568 178.656-73.568 183.136v32.096h32.096c4.48 0 110.368-0.832 183.104-73.568 40.064-40.064 72.512-101.216 32.096-141.632l-32.096-32.096zM169.824 905.056c-31.104 31.072-72.128 44.544-101.376 50.336 5.76-29.056 19.2-69.92 50.432-101.152 15.104-15.008 39.872-31.712 50.912-32.128l31.648 31.136c1.472 7.488-12.864 32.896-31.616 51.808zM724.192 168.704c-70.88 0-128.352 57.472-128.352 128.352s57.472 128.352 128.352 128.352 128.352-57.472 128.352-128.352c0-70.88-57.472-128.352-128.352-128.352zM724.192 393.312c-53.056 0-96.256-43.2-96.256-96.256s43.2-96.256 96.256-96.256c53.088 0 96.256 43.2 96.256 96.256s-43.2 96.256-96.256 96.256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"launch",
						"fly",
						"orbit",
						"blast",
						"explore"
					],
					"grid": 32
				},
				{
					"id": 2351,
					"paths": [
						"M896 0h-768c-35.2 0-64 28.8-64 64v896c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64v-896c0-35.2-28.8-64-64-64zM640 64c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM128 96c0-17.672 14.328-32 32-32h192c17.672 0 32 14.328 32 32s-14.328 32-32 32h-192c-17.672 0-32-14.328-32-32zM512 896c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256zM832 192c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z",
						"M512 640c-32-96-160-96-192 0 0 106.040 85.96 192 192 192s192-85.96 192-192c-32 96-160 96-192 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"laundry",
						"washing-machine"
					],
					"defaultCode": 60186,
					"grid": 16
				},
				{
					"id": 237,
					"paths": [
						"M512 614.4c-3.379 0-6.758-0.669-9.934-2.006l-486.4-204.8c-9.493-3.997-15.666-13.293-15.666-23.594s6.173-19.597 15.666-23.594l486.4-204.8c6.354-2.675 13.517-2.675 19.869 0l486.4 204.8c9.493 3.997 15.666 13.293 15.666 23.594s-6.173 19.597-15.666 23.594l-486.4 204.8c-3.176 1.338-6.555 2.006-9.934 2.006zM91.57 384l420.43 177.024 420.43-177.024-420.43-177.024-420.43 177.024z",
						"M512 768c-3.379 0-6.758-0.669-9.934-2.006l-486.4-204.8c-13.030-5.486-19.146-20.498-13.659-33.528s20.498-19.146 33.528-13.659l476.466 200.618 476.466-200.618c13.029-5.483 28.042 0.63 33.528 13.659 5.488 13.032-0.63 28.042-13.659 33.528l-486.4 204.8c-3.176 1.338-6.555 2.006-9.934 2.006z",
						"M512 921.6c-3.379 0-6.758-0.669-9.934-2.006l-486.4-204.8c-13.030-5.486-19.146-20.498-13.659-33.528s20.498-19.144 33.528-13.659l476.466 200.618 476.466-200.618c13.029-5.483 28.042 0.63 33.528 13.659 5.488 13.032-0.63 28.042-13.659 33.528l-486.4 204.8c-3.176 1.338-6.555 2.006-9.934 2.006z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"layers",
						"stack"
					],
					"defaultCode": 59534,
					"grid": 20
				},
				{
					"id": 2530,
					"paths": [
						"M1011.328 134.496c-110.752-83.928-281.184-134.034-455.91-134.034-216.12 0-392.226 75.456-483.16 207.020-42.708 61.79-66.33 134.958-70.208 217.474-3.454 73.474 8.884 154.726 36.684 242.146 94.874-284.384 359.82-507.102 665.266-507.102 0 0-285.826 75.232-465.524 308.192-0.112 0.138-2.494 3.090-6.614 8.698-36.080 48.278-67.538 103.162-91.078 165.328-39.87 94.83-76.784 224.948-76.784 381.782h128c0 0-19.43-122.222 14.36-262.79 55.89 7.556 105.858 11.306 150.852 11.306 117.678 0 201.37-25.46 263.388-80.124 55.568-48.978 86.198-114.786 118.624-184.456 49.524-106.408 105.654-227.010 268.654-320.152 9.33-5.332 15.362-14.992 16.056-25.716s-4.040-21.080-12.606-27.572z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"leaf",
						"nature",
						"plant",
						"tea",
						"green",
						"vegan",
						"vegetarian"
					],
					"defaultCode": 60365,
					"grid": 16
				},
				{
					"id": 2531,
					"paths": [
						"M1011.328 134.496c-110.752-83.928-281.184-134.034-455.91-134.034-216.12 0-392.226 75.456-483.16 207.020-42.708 61.79-66.33 134.958-70.208 217.474-4.136 88.020 14.37 187.198 55.002 294.776-37.478 91.374-57.868 185.444-57.868 272.268 0 17.674 14.328 32 32 32s32-14.326 32-32c0-76.682 18.726-162.256 52.38-245.424 94.22 17.422 173.576 25.942 241.648 25.942 117.678 0 201.37-25.46 263.388-80.124 55.568-48.978 86.198-114.786 118.624-184.456 49.524-106.408 105.654-227.010 268.654-320.152 9.33-5.332 15.362-14.992 16.056-25.716 0.694-10.726-4.040-21.082-12.606-27.574zM681.2 480.93c-30.8 66.178-57.4 123.332-102.918 163.452-49.642 43.756-119.888 64.134-221.070 64.134-60.45 0-130.996-7.25-214.474-22.052 15.256-30.482 32.458-60.248 51.46-88.686 44.304-66.302 96.344-123.598 154.674-170.298 63.004-50.442 131.748-87.058 204.324-108.83 16.928-5.078 26.534-22.918 21.456-39.846-5.078-16.926-22.91-26.54-39.846-21.456-80.474 24.142-156.49 64.574-225.932 120.17-63.454 50.8-119.938 112.944-167.888 184.702-16.16 24.184-31.060 49.076-44.672 74.428-23.064-75.838-33.29-145.834-30.334-208.688 3.308-70.368 23.132-132.304 58.926-184.088 40.696-58.878 101.33-104.512 180.214-135.634 72.59-28.638 159.142-43.776 250.298-43.776 139.012 0 278.818 35.522 377.598 94.43-148.128 99.246-205.192 221.86-251.816 322.038z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"leaf",
						"nature",
						"plant",
						"tea",
						"green",
						"vegan",
						"vegetarian"
					],
					"defaultCode": 60366,
					"grid": 16
				},
				{
					"id": 1281,
					"width": 1023.9979602098465,
					"paths": [
						"M731.429 402.286q0-14.857-10.857-25.714t-25.714-10.857q-98.286 0-181.714 28.286t-148.286 76.571-134.571 125.429q-10.857 12-10.857 25.714 0 14.857 10.857 25.714t25.714 10.857q13.714 0 25.714-10.857 15.429-13.714 42.286-40.571t38.286-37.714q78.286-70.857 153.429-100.571t179.143-29.714q14.857 0 25.714-10.857t10.857-25.714zM1024 289.143q0 54.286-11.429 110.286-26.286 128-105.429 218.857t-204.286 153.143q-122.286 61.714-250.286 61.714-84.571 0-163.429-26.857-8.571-2.857-50.286-24t-54.857-21.143q-9.143 0-22.571 18.286t-25.714 40-30 40-34.286 18.286q-17.143 0-29.143-6.286t-17.714-13.714-15.429-24q-1.143-2.286-3.429-6.286t-3.143-5.714-1.714-5.429-0.857-7.714q0-20 17.714-42t38.857-37.429 38.857-32 17.714-27.429q0-2.286-8-21.714t-9.143-25.143q-5.143-29.143-5.143-59.429 0-65.714 24.857-125.714t68-105.429 97.429-79.429 116.571-54.571q31.429-10.286 82.857-14.571t102.571-5.143 102-3.429 93.429-13.714 64.857-32.286l16.857-16.857t16.857-16 15.429-11.429 20.857-9.143 24.857-2.571q22.286 0 40.286 26.286t27.143 64 13.714 70.857 4.571 54.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"leaf"
					],
					"defaultCode": 61548,
					"grid": 14
				},
				{
					"id": 168,
					"paths": [
						"M1017.987 9.117c-4.862-5.779-12.030-9.115-19.582-9.117l-26.114-0.008c-258.027-0.091-461.854-0.163-611.93 35.728-80.627 19.283-142.987 48.411-190.643 89.051-51.387 43.819-86.445 101.243-107.178 175.549-13.771 49.363-20.213 138.478 6.96 227.178 10.043 32.787 25.696 63.682 46.584 92.093-62.246 97.517-116.085 226.014-116.085 378.81 0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6c0-235.789 139.654-410.651 222.901-493.899 59.741-59.739 127.301-110.166 195.378-145.824 63.373-33.195 123.933-51.477 170.522-51.477 14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6c-55.506 0-122.686 19.822-194.278 57.323-72.603 38.030-144.467 91.621-207.822 154.976-26.726 26.726-58.899 62.346-90.824 105.994-12.403-19.496-21.998-40.173-28.619-61.79-25.597-83.555-16.19-164.038-6.597-198.422 73.206-262.397 351.32-263.072 855.925-262.89-60.16 321.93-172.331 530.309-333.613 619.571-149.582 82.786-298.008 37.613-354.877 14.346-12.005-4.912-24.051-10.949-35.802-17.944-12.147-7.227-27.858-3.243-35.091 8.904-7.232 12.149-3.245 27.859 8.902 35.093 13.923 8.288 28.256 15.464 42.602 21.334 31.843 13.027 83.144 29.706 146.704 35.184 14.034 1.21 27.928 1.814 41.672 1.814 75.189 0 145.893-18.077 210.682-53.934 82.37-45.587 153.675-119.736 211.938-220.384 68.315-118.018 119.699-274.534 152.723-465.205 1.29-7.443-0.774-15.074-5.637-20.853z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"leaf",
						"nature",
						"green",
						"plant"
					],
					"defaultCode": 59465,
					"grid": 20
				},
				{
					"id": 1662,
					"width": 1170.2860913276672,
					"paths": [
						"M1081.714 224l88.571 726.857q-74.857 0-146.857-32.571-114.286-52-224.571-52-129.143 0-213.714 84.571-84.571-84.571-213.714-84.571-110.286 0-224.571 52-73.143 32.571-144 32.571h-2.857l88.571-726.857q128-72.571 275.429-72.571 133.143 0 221.143 60.571 88-60.571 221.143-60.571 147.429 0 275.429 72.571zM798.857 788q73.714 0 132.571 16.286t148.571 53.429l-70.857-583.429q-97.714-44.571-210.286-44.571-128 0-213.714 80.571-85.714-80.571-213.714-80.571-112.571 0-210.286 44.571l-70.857 583.429q60-24.571 94.571-37.143t84.857-22.571 101.714-10q115.429 0 213.714 61.714 98.286-61.714 213.714-61.714zM821.714 768.571l-31.429-518.286q-120.571 2.286-205.143 88.571-86.857-88.571-213.714-88.571-100.571 0-192 37.714l-65.143 537.714q70.857-29.143 130.571-43.429t126.571-14.286q119.429 0 213.714 58.286 98.286-61.143 213.714-58.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"leanpub"
					],
					"defaultCode": 61970,
					"grid": 14
				},
				{
					"id": 605,
					"width": 1024,
					"paths": [
						"M956.992 413.312c25.568-11.168 25.568-47.456 0-58.624l-406.528-177.856c-12.256-5.376-25.344-8.032-38.464-8.032s-26.208 2.688-38.464 8.064l-406.528 177.824c-25.568 11.2-25.568 47.456 0 58.624l188.992 82.688v106.24c0 36.352 20.544 69.6 53.056 85.856v0c63.904 31.936 133.408 47.904 202.944 47.904s139.040-15.968 202.912-47.904v0c32.544-16.256 53.088-49.504 53.088-85.856v-106.24l128-56v232c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32v-246.016l28.992-12.672zM736 602.24c0 24.384-13.568 46.336-35.392 57.248-58.24 29.12-123.488 44.512-188.608 44.512s-130.368-15.392-188.608-44.512c-21.824-10.912-35.392-32.864-35.392-57.248v-92.224l185.536 81.152c12.256 5.376 25.376 8.064 38.464 8.064 13.12 0 26.208-2.688 38.464-8.064l185.536-81.184v92.256zM537.664 561.856c-8.128 3.552-16.768 5.376-25.664 5.376s-17.504-1.792-25.664-5.376l-406.496-177.856 406.496-177.856c8.16-3.552 16.768-5.344 25.664-5.344s17.504 1.792 25.664 5.376l406.496 177.824-35.776 15.648-367.776-29.408c-5.184-10.72-15.936-18.24-28.608-18.24-17.664 0-32 14.336-32 32s14.336 32 32 32c10.784 0 19.872-5.696 25.664-13.888l308.672 24.704-308.672 135.040z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"learn",
						"wear",
						"graduate",
						"accomplish"
					],
					"grid": 32
				},
				{
					"id": 606,
					"width": 1024,
					"paths": [
						"M960 704v96c0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32v-96c0-17.664 14.336-32 32-32v-241.248l-358.336-28.672c-5.792 8.224-14.88 13.92-25.664 13.92-17.664 0-32-14.336-32-32s14.336-32 32-32c12.672 0 23.424 7.52 28.608 18.24l357.952 28.64c16.512 1.312 29.44 15.328 29.44 31.904v241.216c17.664 0 32 14.336 32 32zM512 631.2c-17.504 0-35.008-3.552-51.296-10.688l-204.704-89.568v71.264c0 36.352 20.544 69.6 53.056 85.856v0c63.904 31.968 133.408 47.936 202.944 47.936s139.040-15.968 202.912-47.904v0c32.544-16.256 53.088-49.504 53.088-85.856v-71.264l-204.704 89.568c-16.288 7.104-33.792 10.656-51.296 10.656zM956.992 354.688l-406.528-177.856c-12.256-5.376-25.344-8.032-38.464-8.032s-26.208 2.688-38.464 8.064l-406.528 177.824c-25.568 11.2-25.568 47.456 0 58.624l406.496 177.888c24.48 10.688 52.512 10.688 76.96 0l301.312-131.872-302.016-24.16c-10.784 8.288-23.872 12.832-37.76 12.832-35.296 0-64-28.704-64-64s28.704-64 64-64c17.664 0 33.984 7.168 45.792 19.488l343.328 27.456c26.944 2.144 48.8 21.312 56.032 46.24 25.376-11.232 25.344-47.328-0.16-58.496z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"learn",
						"wear",
						"graduate",
						"accomplish"
					],
					"grid": 32
				},
				{
					"id": 1318,
					"width": 877.1450176239014,
					"paths": [
						"M804 472q0-25.143-4-64.857t-10.286-55.143q-6.857-17.143-9.714-25.143t-5.143-20.857-2.286-27.714q0-13.143 2.857-39.143t2.857-38.571q0-21.143-5.714-31.429-2.286-0.571-7.429-0.571-10.857 0-33.143 2.571t-33.714 2.571q-34.286 0-100.571-13.714t-100-13.714q-24.571 0-54 6.571t-48.571 13.429-51.143 19.429q-78.286 30.857-115.429 58.857-54.857 41.714-91.143 108.286t-50.286 134.857-14 142q0 22.857 7.143 68.571t7.143 69.143q0 13.143-6.286 38t-6.286 37.429 6.857 20.857 19.429 8.286q13.714 0 41.429-6.286t42-6.286q32.571 0 96.857 8.857t96.857 8.857q103.429 0 162.286-20.571 73.714-25.714 134.571-87.143t94.857-140.286 34-157.143zM877.143 470.857q0 94.286-40 187.143t-112 164.571-160.571 103.143q-70.857 25.143-186.286 25.143-32.571 0-97.143-8.286t-96.571-8.286q-13.714 0-41.429 8.286t-42 8.286q-41.714 0-70.571-31.714t-28.857-73.429q0-13.714 6.286-38.857t6.286-38.286q0-22.857-7.143-68.857t-7.143-69.429q0-63.429 10.286-124.286t31.143-119.714 57.429-110.857 85.714-89.143q44.571-33.714 132.571-68.571 110.857-44.571 180.571-44.571 34.286 0 100.286 13.714t99.143 13.714q10.857 0 32.571-2.857t33.143-2.857q46.286 0 67.429 28.857t21.143 76.857q0 13.143-2.857 38.857t-2.857 38.857q0 5.714 0.571 10.571t1.714 9.714 2.286 7.714 3.714 9.143 3.714 9.714q9.143 22.857 14.286 67.714t5.143 78z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lemon-o"
					],
					"defaultCode": 61588,
					"grid": 14
				},
				{
					"id": 1474,
					"width": 588.5720386505127,
					"paths": [
						"M18.286 146.286h402.286q7.429 0 12.857 5.429t5.429 13.429v493.143h109.714q22.857 0 33.143 21.143t-5.143 39.429l-182.857 219.429q-10.286 12.571-28 12.571t-28-12.571l-182.857-219.429q-14.857-17.714-5.143-39.429 10.286-21.143 33.143-21.143h109.714v-365.714h-182.857q-8 0-14.286-6.286l-91.429-109.714q-7.429-8-2.286-19.429 5.143-10.857 16.571-10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"level-down"
					],
					"defaultCode": 61769,
					"grid": 14
				},
				{
					"id": 1473,
					"width": 589.1439800262451,
					"paths": [
						"M581.714 344.571q-10.286 21.143-33.143 21.143h-109.714v493.714q0 8-5.143 13.143t-13.143 5.143h-402.286q-12 0-16.571-10.286-4.571-11.429 2.286-20l91.429-109.714q5.143-6.286 14.286-6.286h182.857v-365.714h-109.714q-22.857 0-33.143-21.143-9.714-21.143 5.143-38.857l182.857-219.429q10.286-12.571 28-12.571t28 12.571l182.857 219.429q15.429 18.286 5.143 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"level-up"
					],
					"defaultCode": 61768,
					"grid": 14
				},
				{
					"id": 1965,
					"width": 1088,
					"paths": [
						"M1024 960v-64h-64v-384h64v-64h-192v64h64v384h-192v-384h64v-64h-192v64h64v384h-192v-384h64v-64h-192v64h64v384h-192v-384h64v-64h-192v64h64v384h-64v64h-64v64h1088v-64h-64z",
						"M512 0h64l512 320v64h-1088v-64l512-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"library",
						"bank",
						"building"
					],
					"defaultCode": 59800,
					"grid": 16
				},
				{
					"id": 1966,
					"paths": [
						"M960 448h-128v448h-128v-448h-128v448h-128v-448h-128v448h-128v-448h-128v512h-64v64h1024v-64h-64v-512z",
						"M544 0h-64l-480 320v64h1024v-64l-480-320zM512 256c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"library",
						"bank",
						"building"
					],
					"defaultCode": 59801,
					"grid": 16
				},
				{
					"id": 3415,
					"paths": [
						"M534.626 22.628c-12.444-12.444-37.026-22.628-54.626-22.628h-384c-17.6 0-32 14.4-32 32v960c0 17.6 14.4 32 32 32h768c17.6 0 32-14.4 32-32v-576c0-17.6-10.182-42.182-22.626-54.626l-338.748-338.746zM832 960h-704v-896h351.158c2.916 0.48 8.408 2.754 10.81 4.478l337.556 337.554c1.722 2.402 3.996 7.894 4.476 10.81v543.158zM864 0h-192c-17.6 0-21.818 10.182-9.374 22.626l210.746 210.746c12.446 12.446 22.628 8.228 22.628-9.372v-192c0-17.6-14.4-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"libreoffice",
						"file",
						"file-format"
					],
					"defaultCode": 61250,
					"grid": 16
				},
				{
					"id": 129,
					"paths": [
						"M947.2 921.6h-870.4c-42.347 0-76.8-34.451-76.8-76.8v-665.6c0-42.347 34.453-76.8 76.8-76.8h870.4c42.349 0 76.8 34.453 76.8 76.8v665.6c0 42.349-34.451 76.8-76.8 76.8zM76.8 153.6c-14.115 0-25.6 11.485-25.6 25.6v665.6c0 14.115 11.485 25.6 25.6 25.6h870.4c14.115 0 25.6-11.485 25.6-25.6v-665.6c0-14.115-11.485-25.6-25.6-25.6h-870.4z",
						"M486.4 307.2h-307.2c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h307.2c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M486.4 460.8h-307.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h307.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M486.4 563.2h-307.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h307.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M486.4 665.6h-307.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h307.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M435.2 768h-256c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h256c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M918.677 335.043l-41.646-30.258-15.909-48.957h-51.475l-41.646-30.258-41.645 30.258h-51.475l-15.909 48.957-41.646 30.258 15.909 48.957-15.909 48.957 41.646 30.259 6.752 20.774c-0.077 0.794-0.123 1.597-0.123 2.41v256c0 10.355 6.237 19.69 15.803 23.651 9.568 3.965 20.578 1.77 27.899-5.55l58.698-58.698 58.699 58.699c4.898 4.899 11.443 7.501 18.107 7.499 3.298 0 6.624-0.637 9.79-1.949 9.566-3.963 15.803-13.298 15.803-23.653v-256c0-0.813-0.046-1.616-0.122-2.41l6.752-20.774 41.646-30.259-15.91-48.957 15.91-48.957zM677.514 354.6l25.010-18.17 9.554-29.4h30.912l25.011-18.173 25.011 18.171h30.912l9.554 29.4 25.010 18.17-9.554 29.402 9.554 29.4-25.010 18.171-9.554 29.4h-30.912l-25.011 18.173-25.011-18.171h-30.912l-9.554-29.4-25.010-18.171 9.554-29.402-9.554-29.4zM786.101 647.499c-9.997-9.997-26.206-9.997-36.203 0l-33.098 33.098v-168.426h9.555l41.645 30.258 41.645-30.256h9.555v168.426l-33.099-33.099z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"license",
						"certificate"
					],
					"defaultCode": 59426,
					"grid": 20
				},
				{
					"id": 607,
					"width": 1024,
					"paths": [
						"M432 192c-26.496 0-48 21.504-48 48v320c0 26.496 21.504 48 48 48s48-21.504 48-48v-320c0-26.496-21.504-48-48-48zM448 560c0 8.832-7.168 16-16 16s-16-7.168-16-16v-320c0-8.832 7.168-16 16-16s16 7.168 16 16v320zM592 192c-26.496 0-48 21.504-48 48v320c0 26.496 21.504 48 48 48s48-21.504 48-48v-320c0-26.496-21.504-48-48-48zM608 560c0 8.832-7.168 16-16 16s-16-7.168-16-16v-320c0-8.832 7.168-16 16-16s16 7.168 16 16v320zM512 0c-141.376 0-256 114.624-256 256v416c0 53.024 42.976 96 96 96h96v192c0 35.36 28.64 64 64 64s64-28.64 64-64v-192h96c53.024 0 96-42.976 96-96v-416c0-141.376-114.624-256-256-256zM544 960c0 17.632-14.368 32-32 32s-32-14.368-32-32v-192h64v192zM736 672c0 35.296-28.704 64-64 64h-320c-35.296 0-64-28.704-64-64v-416c0-123.52 100.48-224 224-224s224 100.48 224 224v416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lick",
						"eat",
						"indulge",
						"treat",
						"melt"
					],
					"grid": 32
				},
				{
					"id": 608,
					"width": 1024,
					"paths": [
						"M576 800v160c0 35.36-28.64 64-64 64s-64-28.64-64-64v-160h128zM768 256v416c0 53.024-42.976 96-96 96h-320c-53.024 0-96-42.976-96-96v-416c0-141.376 114.624-256 256-256s256 114.624 256 256zM448 208c0-8.832-7.168-16-16-16s-16 7.168-16 16v384c0 8.832 7.168 16 16 16s16-7.168 16-16v-384zM608 208c0-8.832-7.168-16-16-16s-16 7.168-16 16v384c0 8.832 7.168 16 16 16s16-7.168 16-16v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lick",
						"eat",
						"indulge",
						"treat",
						"melt"
					],
					"grid": 32
				},
				{
					"id": 1598,
					"width": 1024,
					"paths": [
						"M512 0q104 0 198.857 40.571t163.429 109.143 109.143 163.429 40.571 198.857-40.571 198.857-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571zM512 73.143q-108.571 0-206.286 51.429l110.857 110.857q46.857-16 95.429-16t95.429 16l110.857-110.857q-97.714-51.429-206.286-51.429zM124.571 718.286l110.857-110.857q-16-46.857-16-95.429t16-95.429l-110.857-110.857q-51.429 97.714-51.429 206.286t51.429 206.286zM512 950.857q108.571 0 206.286-51.429l-110.857-110.857q-46.857 16-95.429 16t-95.429-16l-110.857 110.857q97.714 51.429 206.286 51.429zM512 731.429q90.857 0 155.143-64.286t64.286-155.143-64.286-155.143-155.143-64.286-155.143 64.286-64.286 155.143 64.286 155.143 155.143 64.286zM788.571 607.429l110.857 110.857q51.429-97.714 51.429-206.286t-51.429-206.286l-110.857 110.857q16 46.857 16 95.429t-16 95.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"life-bouy",
						"life-buoy",
						"life-ring",
						"life-saver",
						"support"
					],
					"defaultCode": 61901,
					"grid": 14
				},
				{
					"id": 2096,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM320 512c0-106.040 85.96-192 192-192s192 85.96 192 192-85.96 192-192 192-192-85.96-192-192zM925.98 683.476v0l-177.42-73.49c12.518-30.184 19.44-63.276 19.44-97.986s-6.922-67.802-19.44-97.986l177.42-73.49c21.908 52.822 34.020 110.73 34.020 171.476s-12.114 118.654-34.020 171.476v0zM683.478 98.020v0 0l-73.49 177.42c-30.184-12.518-63.276-19.44-97.988-19.44s-67.802 6.922-97.986 19.44l-73.49-177.422c52.822-21.904 110.732-34.018 171.476-34.018 60.746 0 118.654 12.114 171.478 34.020zM98.020 340.524l177.422 73.49c-12.518 30.184-19.442 63.276-19.442 97.986s6.922 67.802 19.44 97.986l-177.42 73.49c-21.906-52.822-34.020-110.73-34.020-171.476s12.114-118.654 34.020-171.476zM340.524 925.98l73.49-177.42c30.184 12.518 63.276 19.44 97.986 19.44s67.802-6.922 97.986-19.44l73.49 177.42c-52.822 21.904-110.73 34.020-171.476 34.020-60.744 0-118.654-12.114-171.476-34.020z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lifebuoy",
						"support",
						"help"
					],
					"defaultCode": 59931,
					"grid": 16
				},
				{
					"id": 3236,
					"paths": [
						"M768 871.822c0-0.040 0.002-0.076 0.002-0.116l-0.344-436.562-127.492 6.19h-251.93v-21.494c0-81.542 5.8-162.976 17.24-194.716 7.896-21.948 22.598-41.744 43.698-58.836 20.618-16.702 41.178-25.17 61.11-25.17 16.772 0 30.702 2.878 41.402 8.554 15.026 8.562 29.716 22.964 43.67 42.818 36.95 52.504 51.99 66.454 60.094 72.376 13.804 10.094 30.512 15.212 49.658 15.212 18.668 0 34.962-6.97 48.436-20.714 13.372-13.636 20.15-30.682 20.15-50.666 0-21.452-8.916-44.204-26.502-67.622-17.184-22.888-43.708-41.742-78.834-56.032-34.322-13.964-72.94-21.044-114.778-21.044-60.716 0-116.012 14.596-164.356 43.384-48.424 28.834-85.558 68.952-110.37 119.24-22.994 46.604-21.334 134.706-22.732 214.712h-125.732v71.402h125.598v324.668c0 71.666-21.906 91.008-30.216 101.324-11.436 14.202-32.552 29.104-60.444 29.104h-38.654v56.166h385.326v-56.168h-6.708c-91.144 0-117.020-9.832-117.020-120.842 0-0.018 0-0.034 0-0.048l-0.038-334.206h140.204c74.404 0 91.496 3.444 95.392 4.924 4.706 1.79 10.798 4.832 13.084 9.144 0.868 1.684 5.194 25.008 5.194 82.972v250.67c0 58.454-7.124 77.896-11.45 84.402-9.248 14.194-20.41 22.066-54.66 22.904v56.248h293.61v-55.846c-91.608 0-101.608-9.82-101.608-96.332z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ligature",
						"typography",
						"font"
					],
					"defaultCode": 61071,
					"grid": 16
				},
				{
					"id": 3237,
					"paths": [
						"M855.328 917.454c-11.734 0-83.62-13.2-88.020-29.338-10.274-39.612-11.738-82.152-11.738-130.568v-540.974c0-80.686 16.138-127.632 16.138-127.632-1.468-7.334-8.804-23.472-17.604-23.472h-4.404c-4.4 0-55.746 32.276-102.692 32.276-38.14-0.002-61.89-33.746-105.902-33.746-185.106 0-271.942 150.31-271.942 363.032v11.072c0 4.402-2.934 8.804-7.336 8.804h-60.148c-7.336 0-22.006 41.078-22.006 60.148 0 5.87 1.466 8.8 4.4 8.8h77.754c4.402 0 7.336 5.872 7.336 10.27 0 130.566-1.466 259.298-1.466 259.298 0 20.54-1.466 66.016-10.27 102.692-4.4 16.138-71.884 29.338-89.488 29.338-7.334 0-7.334 35.212 0 42.546 60.148-2.934 99.758-7.334 159.908-7.334 55.75 0 98.292 4.4 156.974 7.334 2.934-8.802 2.934-42.546-4.4-42.546-11.736 0-83.624-13.2-88.022-29.338-10.27-39.612-10.27-82.152-11.738-130.568v-232.888c0-4.402 4.402-8.804 8.802-8.804h151.104c10.27-20.538 17.606-45.476 17.606-58.68 0-8.802 0-10.27-7.336-10.27h-162.84c-2.934 0-7.336-4.402-7.336-7.334v-52.82c0-130.568 53.482-245.538 142.97-245.538 63.372 0 118.666 41.060 118.666 197.922 0 0.006 0 0.012 0 0.018 0.208 4.036 0.314 7.294 0.314 9.452v436.816c0 20.54-1.47 66.016-10.27 102.692-4.404 16.138-71.884 29.338-89.492 29.338-7.336 0-7.336 35.212 0 42.546 60.15-2.934 99.762-7.334 159.912-7.334 55.746 0 98.288 4.4 156.972 7.334 2.928-8.8 2.928-42.544-4.406-42.544z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ligature",
						"typography",
						"font"
					],
					"defaultCode": 61072,
					"grid": 16
				},
				{
					"id": 609,
					"width": 1024,
					"paths": [
						"M864 480v-64c0-51.136-40.128-92.576-90.528-95.456 18.528-23.456 26.528-57.792 26.528-96.544 0-62.432-40.608-138.4-68.992-183.872-6.208-9.952-16.608-14.912-27.008-14.912s-20.8 4.96-27.008 14.912c-28.384 45.472-68.992 121.44-68.992 183.872 0 38.752 8 73.088 26.528 96.544-50.4 2.88-90.528 44.32-90.528 95.456v64h-32c0-35.36-28.64-64-64-64v-384c0-17.664-14.336-32-32-32h-224c-53.024 0-96 42.976-96 96v320c0 53.024 42.976 96 96 96h224v416c0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96v-416c0-17.664-14.336-32-32-32h-32zM703.872 57.216c0 0 0.032 0 0.064 0 41.312 66.208 64.064 125.44 64.064 166.784 0 96-48.16 96-64 96s-64 0-64-96c0-41.376 22.784-100.672 63.872-166.784zM576 416c0-35.296 28.704-64 64-64h128c35.296 0 64 28.704 64 64v64h-96c0-17.664-14.336-32-32-32s-32 14.336-32 32h-96v-64zM480 480h-32v-32c17.664 0 32 14.368 32 32zM192 480c-35.296 0-64-28.704-64-64v-320c0-35.296 28.704-64 64-64h224v448h-224zM896 928c0 35.296-28.704 64-64 64h-320c-35.296 0-64-28.704-64-64v-416h448v416zM672 416c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM736 416c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"light",
						"burn",
						"smoke"
					],
					"grid": 32
				},
				{
					"id": 610,
					"width": 1024,
					"paths": [
						"M896 480h-32v-64c0-51.136-40.128-92.576-90.528-95.456 18.528-23.456 26.528-57.792 26.528-96.544 0-62.432-40.608-138.4-68.992-183.872-6.208-9.952-16.608-14.912-27.008-14.912s-20.8 4.96-27.008 14.912c-28.384 45.472-68.992 121.44-68.992 183.872 0 38.752 8 73.088 26.528 96.544-50.4 2.88-90.528 44.32-90.528 95.456v64h-32c0-35.36-28.64-64-64-64v-384c0-17.664-14.336-32-32-32h-224c-53.024 0-96 42.976-96 96v320c0 53.024 42.976 96 96 96h224v416c0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96v-416c0-17.664-14.336-32-32-32zM448 480v-32c17.664 0 32 14.368 32 32h-32zM640 448c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM672 480c0-17.664 14.336-32 32-32s32 14.336 32 32h-64zM768 448c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"light",
						"burn",
						"smoke"
					],
					"grid": 32
				},
				{
					"id": 1054,
					"width": 1024,
					"paths": [
						"M560.96 4.864c-10.368-6.464-23.552-6.464-33.952 0-11.040 6.912-271.008 172.16-271.008 411.136 0 57.568 17.408 113.856 49.472 161.28l-296.096 296.096c-12.512 12.512-12.512 32.736 0 45.248l96 96c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l320.224-320.224c24.032 6.368 48.544 9.6 73.152 9.6 158.816 0 288-129.216 288-288 0-238.976-259.968-404.224-271.040-411.136zM406.784 575.872c3.904 8.96 9.344 17.376 16.64 24.704 7.328 7.328 15.776 12.768 24.736 16.672l-324.832 324.8-41.376-41.376 324.832-324.8zM480 592c-12.8 0-24.864-4.992-33.952-14.080-9.056-9.056-14.048-21.088-14.048-33.92s4.992-24.864 14.080-33.92l64-64c9.056-9.056 21.12-14.080 33.92-14.080s24.864 4.992 33.952 14.080c9.056 9.056 14.048 21.12 14.048 33.92s-4.992 24.864-14.080 33.92l-64 64c-9.056 9.088-21.12 14.080-33.92 14.080zM544 640c-21.344 0-42.592-3.68-63.456-9.888l6.816-6.816c17.952-1.664 35.456-8.992 49.216-22.72l64-64c31.264-31.232 31.264-81.888 0-113.12-15.648-15.648-36.096-23.456-56.576-23.456s-40.928 7.808-56.576 23.424l-64 64c-13.76 13.76-21.088 31.296-22.752 49.248l-26.496 26.496c-20.512-32-54.176-69.376-54.176-147.168 0-171.2 169.12-306.016 224.032-345.28 54.912 39.168 223.968 173.632 223.968 345.28 0 123.52-100.512 224-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"light",
						"glow",
						"strike"
					],
					"grid": 32
				},
				{
					"id": 1388,
					"width": 585.1440048217773,
					"paths": [
						"M420.571 329.143q0 7.429-5.429 12.857t-12.857 5.429-12.857-5.429-5.429-12.857q0-26.286-30.857-40.571t-60.571-14.286q-7.429 0-12.857-5.429t-5.429-12.857 5.429-12.857 12.857-5.429q28.571 0 56.857 9.143t49.714 30.857 21.429 51.429zM512 329.143q0-41.143-19.714-76.571t-51.429-58-70.286-35.429-78-12.857-78 12.857-70.286 35.429-51.429 58-19.714 76.571q0 57.714 38.857 102.857 5.714 6.286 17.429 18.857t17.429 18.857q73.143 87.429 80.571 170.286h130.286q7.429-82.857 80.571-170.286 5.714-6.286 17.429-18.857t17.429-18.857q38.857-45.143 38.857-102.857zM585.143 329.143q0 88.571-58.857 153.143-25.714 28-42.571 49.714t-34 54.571-19.429 61.429q26.857 16 26.857 46.857 0 21.143-14.286 36.571 14.286 15.429 14.286 36.571 0 29.714-25.714 46.286 7.429 13.143 7.429 26.857 0 26.286-18 40.571t-44.286 14.286q-11.429 25.143-34.286 40t-49.714 14.857-49.714-14.857-34.286-40q-26.286 0-44.286-14.286t-18-40.571q0-13.714 7.429-26.857-25.714-16.571-25.714-46.286 0-21.143 14.286-36.571-14.286-15.429-14.286-36.571 0-30.857 26.857-46.857-2.286-28.571-19.429-61.429t-34-54.571-42.571-49.714q-58.857-64.571-58.857-153.143 0-56.571 25.429-105.429t66.857-81.143 93.714-50.857 106.571-18.571 106.571 18.571 93.714 50.857 66.857 81.143 25.429 105.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lightbulb-o"
					],
					"defaultCode": 61675,
					"grid": 14
				},
				{
					"id": 100,
					"paths": [
						"M896 460.8h-35.328l-43.786-88.186c-4.325-8.707-13.208-14.214-22.93-14.214h-205.157c-14.139 0-25.6 11.462-25.6 25.6v76.8h-62.021l-197.41-341.922c-7.069-12.243-22.725-16.443-34.97-9.37l-177.362 102.4c-12.245 7.069-16.44 22.726-9.37 34.97l204.8 354.723c4.742 8.213 13.346 12.805 22.194 12.805 4.342 0 8.746-1.107 12.776-3.434l138.962-80.23v416.458c0 14.139 11.462 25.6 25.6 25.6h409.6c14.139 0 25.6-11.461 25.6-25.6v-460.8c0-14.139-11.461-25.6-25.6-25.6zM870.4 768h-51.2v-153.6h51.2v153.6zM614.4 409.6h163.686l25.422 51.2h-189.109v-51.2zM318.408 553.832l-179.2-310.382 133.021-76.8 179.2 310.382-133.021 76.8zM512 921.6v-409.6h332.638c0.061 0 0.12 0.006 0.181 0.006 0.035 0 0.074-0.006 0.11-0.006h25.47v51.2h-76.8c-14.139 0-25.6 11.461-25.6 25.6v204.8c0 14.139 11.461 25.6 25.6 25.6h76.8v102.4h-358.4z",
						"M793.6 307.2c-38.41 0-57.083-18.142-65.984-33.363-16.923-28.938-14.094-72.59 8.654-133.448 15.293-40.915 34.219-74.72 35.018-76.139 4.534-8.061 13.064-13.050 22.312-13.050s17.778 4.989 22.312 13.050c0.798 1.419 19.725 35.224 35.018 76.139 22.749 60.859 25.578 104.51 8.654 133.448-8.901 15.221-27.574 33.363-65.984 33.363zM793.602 135.144c-3.232 7.454-6.502 15.461-9.581 23.73-23.218 62.379-15.211 83.984-12.205 89.12 1.282 2.19 4.685 8.006 21.784 8.006 17.101 0 20.506-5.821 21.787-8.011 3.021-5.165 11.050-26.891-12.418-89.674-3.021-8.085-6.214-15.894-9.368-23.171z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lighter",
						"fire"
					],
					"defaultCode": 59397,
					"grid": 20
				},
				{
					"id": 1055,
					"width": 1024,
					"paths": [
						"M810.176 73.6c-113.28-29.632-227.424 11.232-296.8 95.808-0.736 0.896-2.016 0.896-2.72 0-69.408-84.576-183.52-125.44-296.8-95.808-136.928 35.84-222.304 171.072-212.672 312.256 24.544 360.8 435.744 574.144 510.816 574.144s486.272-213.344 510.848-574.112c9.632-141.216-75.744-276.448-212.672-312.288zM512 896c-56.864-0.192-434.368-206.56-447.648-526.656-4.096-98.656 52.16-193.536 144.96-227.296 107.456-39.072 220.064 6.56 272.96 98.56 13.472 23.424 45.984 23.424 59.424 0 52.896-92 165.504-137.664 272.96-98.56 92.8 33.76 149.056 128.64 144.96 227.296-13.248 320.096-390.752 526.464-447.616 526.656zM237.856 188.8c-24.32 0-53.12 12.768-76.704 36.352-37.504 37.504-47.616 88.128-22.624 113.152 9.28 9.248 22.080 13.696 36.416 13.696 24.32 0 53.12-12.768 76.704-36.352 37.504-37.472 47.648-88.128 22.656-113.12-9.28-9.28-22.080-13.728-36.448-13.728zM255.040 248.128c-3.008 15.040-12.48 31.392-26.016 44.896-19.872 19.904-40.96 26.976-54.080 26.976-4.32 0-10.208-0.768-13.792-4.352-4.16-4.16-5.408-12.736-3.36-22.976 3.008-15.008 12.48-31.392 25.984-44.896 19.872-19.872 40.992-26.976 54.080-26.976 4.32 0 10.208 0.736 13.792 4.352 4.16 4.16 5.44 12.736 3.392 22.976z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"like",
						"love"
					],
					"grid": 32
				},
				{
					"id": 1646,
					"width": 1170.2860107421875,
					"paths": [
						"M1170.286 877.714v73.143h-1170.286v-877.714h73.143v804.571h1097.143zM1097.143 164.571v248.571q0 12-11.143 16.857t-20.286-4.286l-69.143-69.143-361.714 361.714q-5.714 5.714-13.143 5.714t-13.143-5.714l-133.143-133.143-237.714 237.714-109.714-109.714 334.286-334.286q5.714-5.714 13.143-5.714t13.143 5.714l133.143 133.143 265.143-265.143-69.143-69.143q-9.143-9.143-4.286-20.286t16.857-11.143h248.571q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"line-chart"
					],
					"defaultCode": 61953,
					"grid": 14
				},
				{
					"id": 251,
					"paths": [
						"M947.2 256h-512c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h512c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M947.2 460.8h-512c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h512c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M947.2 665.6h-512c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h512c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M947.2 870.4h-512c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h512c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M263.498 698.699l-58.698 58.696v-439.592l58.698 58.698c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.102-7.499c9.997-9.997 9.997-26.206 0-36.203l-102.4-102.4c-9.998-9.997-26.206-9.997-36.205 0l-102.4 102.4c-9.997 9.998-9.997 26.206 0 36.203 9.998 9.997 26.206 9.997 36.205 0l58.698-58.698v439.592l-58.698-58.698c-9.998-9.997-26.206-9.997-36.205 0-9.997 9.997-9.997 26.206 0 36.203l102.4 102.4c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.102-7.499l102.4-102.4c9.997-9.997 9.997-26.206 0-36.203s-26.206-9.997-36.205 0.002z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"line-spacing",
						"typography",
						"line-height"
					],
					"defaultCode": 59548,
					"grid": 20
				},
				{
					"id": 165,
					"paths": [
						"M998.4 819.2h-25.6c-29.667 0-51.2 32.299-51.2 76.8 0 14.115-11.485 25.6-25.6 25.6s-25.6-11.485-25.6-25.6v-51.2c0-14.139-11.461-25.6-25.6-25.6-7.074 0-13.475 2.869-18.109 7.504-10.027-4.806-21.248-7.504-33.091-7.504-42.349 0-76.8 34.451-76.8 76.8 0 8.974 1.563 17.587 4.403 25.6h-55.603c-20.762 0-52.194-14.162-65.949-29.71l-53.472-60.445 471.395-532.882c8.221-9.294 8.459-22.888 1.238-32.41l-153.533-204.714c-4.834-6.446-12.422-10.24-20.48-10.24h-665.6c-8.058 0-15.645 3.794-20.48 10.24l-153.539 204.718c-7.216 9.522-6.974 23.112 1.245 32.403l471.395 532.882-53.472 60.446c-14.802 16.733-40.723 29.71-53.149 29.71h-12.8v-25.6c0-42.349-34.453-76.8-76.8-76.8-14.413 0-27.906 3.998-39.442 10.931-6.52-6.925-14.97-10.931-24.558-10.931-15.762 0-27.496 12.459-35.957 23.314-7.773 9.97-15.813 22.981-22.638 36.634l-5.405 10.81v-45.157c0-14.139-11.462-25.6-25.6-25.6s-25.6 11.461-25.6 25.6v51.2c0 14.115-11.485 25.6-25.6 25.6s-25.6-11.485-25.6-25.6v-153.6c0-14.139-11.462-25.6-25.6-25.6s-25.6 11.461-25.6 25.6v153.6c0 42.347 34.453 76.8 76.8 76.8 14.413 0 27.906-3.998 39.442-10.933 6.518 6.926 14.97 10.933 24.558 10.933 15.762 0 27.496-12.459 35.957-23.314 7.773-9.97 15.813-22.981 22.638-36.634l5.405-10.81v45.157c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-51.2c0-14.115 11.485-25.6 25.6-25.6s25.6 11.485 25.6 25.6v51.2c0 14.139 11.462 25.6 25.6 25.6h38.4c28.467 0 67.803-20.2 91.498-46.986l49.302-55.733 49.301 55.731c23.696 26.787 68.534 46.987 104.299 46.987h128c19.654 0 37.602-7.43 51.2-19.618 13.598 12.187 31.546 19.618 51.2 19.618 42.349 0 76.8-34.451 76.8-76.8 0-12.749 3.099-21.594 5.278-25.6h20.322c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6zM58.6 280.267l133.4-177.867h640l133.4 177.867-453.4 512.539-453.4-512.539zM793.6 921.6c-14.115 0-25.6-11.485-25.6-25.6s11.485-25.6 25.6-25.6 25.6 11.485 25.6 25.6-11.485 25.6-25.6 25.6z",
						"M128 768c6.736 0 13.344-2.736 18.096-7.504 4.768-4.768 7.504-11.36 7.504-18.096s-2.736-13.328-7.504-18.098c-4.752-4.766-11.36-7.502-18.096-7.502s-13.328 2.736-18.096 7.502c-4.768 4.754-7.504 11.362-7.504 18.098s2.736 13.344 7.504 18.096c4.768 4.768 11.36 7.504 18.096 7.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"linearicons",
						"perxis",
						"diamond"
					],
					"defaultCode": 59462,
					"grid": 20
				},
				{
					"id": 2734,
					"paths": [
						"M440.236 635.766c-13.31 0-26.616-5.076-36.77-15.23-95.134-95.136-95.134-249.934 0-345.070l192-192c46.088-46.086 107.36-71.466 172.534-71.466s126.448 25.38 172.536 71.464c95.132 95.136 95.132 249.934 0 345.070l-87.766 87.766c-20.308 20.308-53.23 20.308-73.54 0-20.306-20.306-20.306-53.232 0-73.54l87.766-87.766c54.584-54.586 54.584-143.404 0-197.99-26.442-26.442-61.6-41.004-98.996-41.004s-72.552 14.562-98.996 41.006l-192 191.998c-54.586 54.586-54.586 143.406 0 197.992 20.308 20.306 20.306 53.232 0 73.54-10.15 10.152-23.462 15.23-36.768 15.23z",
						"M256 1012c-65.176 0-126.45-25.38-172.534-71.464-95.134-95.136-95.134-249.934 0-345.070l87.764-87.764c20.308-20.306 53.234-20.306 73.54 0 20.308 20.306 20.308 53.232 0 73.54l-87.764 87.764c-54.586 54.586-54.586 143.406 0 197.992 26.44 26.44 61.598 41.002 98.994 41.002s72.552-14.562 98.998-41.006l192-191.998c54.584-54.586 54.584-143.406 0-197.992-20.308-20.308-20.306-53.232 0-73.54 20.306-20.306 53.232-20.306 73.54 0.002 95.132 95.134 95.132 249.932 0.002 345.068l-192.002 192c-46.090 46.088-107.364 71.466-172.538 71.466z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"link",
						"chain",
						"url",
						"uri",
						"anchor"
					],
					"defaultCode": 60569,
					"grid": 16
				},
				{
					"id": 1056,
					"width": 1024,
					"paths": [
						"M957.44 65.6c-43.744-43.744-101.088-65.6-158.4-65.6s-114.656 21.856-158.4 65.6l-113.152 113.152c-53.792 53.792-74.368 128.128-62.016 197.76l-88.992 89.952c-13.056-2.336-26.304-3.488-39.52-3.488-57.28 0-114.528 21.792-158.24 65.472l-113.12 113.152c-87.488 87.488-87.488 229.312 0 316.768 43.744 43.776 101.088 65.632 158.4 65.632s114.656-21.856 158.4-65.6l113.152-113.152c53.792-53.792 74.368-128.128 61.984-197.76l88.992-89.952c13.056 2.336 26.304 3.488 39.52 3.488 57.28 0 114.528-21.76 158.24-65.472l113.152-113.152c87.456-87.488 87.456-229.312 0-316.8zM450.272 800l-113.152 113.152c-30.208 30.208-70.368 46.848-113.12 46.848s-82.912-16.64-113.152-46.848c-62.4-62.4-62.4-163.904 0-226.272l113.152-113.152c30.144-30.144 70.272-46.752 112.992-46.752 7.552 0 15.072 0.928 22.528 1.984l-203.392 203.136c-37.44 37.44-37.44 98.336 0 135.776 18.112 18.144 42.24 28.128 67.872 28.128s49.76-9.984 67.872-28.128l203.392-202.624c6.72 49.504-9.664 99.424-44.992 134.752zM641.216 292.352c10.56-6.88 22.688-10.336 34.816-10.336 16.32 0 32.64 6.208 45.12 18.624 25.056 24.928 25.184 65.44 0.256 90.496 0 0-337.44 339.744-340.48 341.888-10.56 6.88-22.688 10.336-34.816 10.336-16.32 0-32.64-6.208-45.12-18.624-25.056-24.928-25.184-65.44-0.256-90.496 0 0 337.44-339.744 340.48-341.888zM248.672 684.832c0.992 23.296 10.112 46.304 27.904 64 16.672 16.576 38.496 25.92 61.76 27.328l-69.088 69.088c-12.48 12.512-28.864 18.752-45.248 18.752s-32.768-6.24-45.248-18.752c-24.992-24.992-24.992-65.504 0-90.496l69.92-69.92zM773.472 340.096c-1.12-24-10.72-46.464-27.904-63.52-16.8-16.704-38.752-26.048-62.208-27.392l70.432-70.432c12.48-12.512 28.864-18.752 45.248-18.752s32.768 6.24 45.248 18.752c24.992 24.992 24.992 65.504 0 90.496l-70.816 70.848zM912.16 337.152l-113.152 113.152c-30.144 30.144-70.272 46.72-112.992 46.72-7.392 0-14.752-0.928-22.080-1.952l202.976-203.168c37.44-37.44 37.44-98.336 0-135.776-18.112-18.144-42.24-28.128-67.872-28.128s-49.76 9.984-67.872 28.128l-203.328 203.072c-6.88-49.664 9.504-99.776 44.928-135.2l113.152-113.152c30.208-30.208 70.368-46.848 113.12-46.848s82.912 16.64 113.152 46.848c62.368 62.4 62.368 163.904-0.032 226.304z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"link",
						"connect",
						"ui"
					],
					"grid": 32
				},
				{
					"id": 2736,
					"paths": [
						"M320 704c17.6 17.6 47.274 16.726 65.942-1.942l316.118-316.116c18.668-18.668 19.54-48.342 1.94-65.942s-47.274-16.726-65.942 1.942l-316.116 316.116c-18.668 18.668-19.542 48.342-1.942 65.942zM476.888 675.112c4.56 9.050 6.99 19.16 6.99 29.696 0 17.616-6.744 34.060-18.992 46.308l-163.382 163.382c-12.248 12.248-28.694 18.992-46.308 18.992s-34.060-6.744-46.308-18.992l-99.382-99.382c-12.248-12.248-18.992-28.694-18.992-46.308s6.744-34.060 18.992-46.308l163.382-163.382c12.248-12.248 28.694-18.994 46.308-18.994 10.536 0 20.644 2.43 29.696 6.99l65.338-65.338c-27.87-21.41-61.44-32.16-95.034-32.16-39.986 0-79.972 15.166-110.308 45.502l-163.382 163.382c-60.67 60.67-60.67 159.948 0 220.618l99.382 99.382c30.334 30.332 70.32 45.5 110.306 45.5 39.988 0 79.974-15.168 110.308-45.502l163.382-163.382c55.82-55.82 60.238-144.298 13.344-205.344l-65.34 65.34zM978.498 144.884l-99.382-99.382c-30.334-30.336-70.32-45.502-110.308-45.502-39.986 0-79.972 15.166-110.308 45.502l-163.382 163.382c-55.82 55.82-60.238 144.298-13.342 205.342l65.338-65.34c-4.558-9.050-6.988-19.16-6.988-29.694 0-17.616 6.744-34.060 18.992-46.308l163.382-163.382c12.248-12.248 28.694-18.994 46.308-18.994s34.060 6.746 46.308 18.994l99.382 99.382c12.248 12.248 18.992 28.694 18.992 46.308s-6.744 34.060-18.992 46.308l-163.382 163.382c-12.248 12.248-28.694 18.992-46.308 18.992-10.536 0-20.644-2.43-29.696-6.99l-65.338 65.338c27.872 21.41 61.44 32.16 95.034 32.16 39.988 0 79.974-15.168 110.308-45.502l163.382-163.382c60.67-60.666 60.67-159.944 0-220.614z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"link",
						"chain",
						"url",
						"uri",
						"anchor"
					],
					"defaultCode": 60571,
					"grid": 16
				},
				{
					"id": 2738,
					"paths": [
						"M288 1024c-158.804 0-288-129.196-288-288s129.196-288 288-288c35.346 0 64 28.654 64 64s-28.654 64-64 64c-88.224 0-160 71.776-160 160s71.776 160 160 160 160-71.776 160-160c0-35.346 28.654-64 64-64s64 28.654 64 64c0 158.804-129.196 288-288 288z",
						"M736 576c-35.346 0-64-28.654-64-64s28.654-64 64-64c88.224 0 160-71.776 160-160s-71.776-160-160-160-160 71.776-160 160c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-158.804 129.196-288 288-288s288 129.196 288 288-129.196 288-288 288z",
						"M384 704c-16.378 0-32.758-6.248-45.254-18.746-24.994-24.992-24.994-65.516 0-90.508l256-256c24.992-24.994 65.516-24.994 90.508 0 24.994 24.994 24.994 65.516 0 90.51l-256 256c-12.496 12.496-28.876 18.744-45.254 18.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"link",
						"chain",
						"url",
						"uri",
						"anchor"
					],
					"defaultCode": 60573,
					"grid": 16
				},
				{
					"id": 2740,
					"paths": [
						"M549.49 645.49l-215.352 215.352c-22.672 22.672-53.068 35.158-85.59 35.158-32.482 0-62.832-12.46-85.46-35.090-22.632-22.634-35.094-52.994-35.088-85.486 0.006-32.51 12.492-62.898 35.158-85.564l215.354-215.352-90.51-90.508-215.354 215.35c-96.838 96.84-96.868 255.27-0.068 352.070 48.38 48.382 112.18 72.58 175.968 72.58 63.836 0 127.664-24.212 176.1-72.65l215.352-215.35-90.51-90.51z",
						"M645.49 549.492l215.352-215.354c22.672-22.672 35.158-53.066 35.158-85.588 0-32.482-12.46-62.832-35.090-85.458-22.634-22.636-52.994-35.098-85.486-35.092-32.51 0.006-62.898 12.492-85.564 35.156l-215.352 215.356-90.508-90.51 215.35-215.352c96.84-96.838 255.27-96.87 352.070-0.070 48.382 48.382 72.58 112.18 72.58 175.97 0 63.836-24.212 127.662-72.65 176.1l-215.35 215.35-90.51-90.508z",
						"M416 672.005l-64-64 255.997-255.997 64 64-255.997 255.997z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"link",
						"chain",
						"url",
						"uri",
						"anchor"
					],
					"defaultCode": 60575,
					"grid": 16
				},
				{
					"id": 2742,
					"width": 1088,
					"paths": [
						"M448 768h-192c-141.16 0-256-114.842-256-256 0-141.16 114.84-256 256-256h192c35.346 0 64 28.654 64 64s-28.654 64-64 64h-192c-70.58 0-128 57.42-128 128s57.42 128 128 128h192c35.346 0 64 28.654 64 64s-28.654 64-64 64z",
						"M832 768h-192c-35.346 0-64-28.654-64-64s28.654-64 64-64h192c70.58 0 128-57.42 128-128s-57.42-128-128-128h-192c-35.346 0-64-28.654-64-64s28.654-64 64-64h192c141.158 0 256 114.84 256 256 0 141.158-114.842 256-256 256z",
						"M704 576h-320c-35.346 0-64-28.654-64-64s28.654-64 64-64h320c35.346 0 64 28.654 64 64s-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"link",
						"chain",
						"url",
						"uri",
						"anchor"
					],
					"defaultCode": 60577,
					"grid": 16
				},
				{
					"id": 202,
					"paths": [
						"M546.917 665.512c-48.275 0-96.55-18.376-133.301-55.128-9.998-9.997-9.998-26.206 0-36.203s26.205-9.997 36.203 0c53.539 53.541 140.656 53.541 194.197 0l186.166-186.166c53.539-53.539 53.539-140.656 0-194.197-53.541-53.539-140.656-53.538-194.197 0l-157.082 157.083c-9.998 9.997-26.206 9.997-36.203 0-9.998-9.998-9.998-26.206 0-36.205l157.083-157.083c73.502-73.501 193.101-73.501 266.603 0s73.502 193.101 0 266.603l-186.168 186.168c-36.752 36.752-85.027 55.128-133.302 55.128z",
						"M239.717 972.712c-48.275 0-96.55-18.376-133.302-55.128-73.501-73.502-73.501-193.101 0-266.603l186.166-186.166c73.501-73.501 193.101-73.501 266.603 0 9.998 9.998 9.998 26.206 0 36.203-9.997 9.998-26.206 9.998-36.203 0-53.541-53.541-140.656-53.541-194.197 0l-186.165 186.166c-53.539 53.541-53.539 140.656 0 194.197s140.656 53.541 194.195 0l157.083-157.083c9.997-9.997 26.206-9.997 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-157.083 157.083c-36.75 36.752-85.026 55.128-133.301 55.128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"link",
						"url"
					],
					"defaultCode": 59499,
					"grid": 20
				},
				{
					"id": 611,
					"width": 1024,
					"paths": [
						"M958.4 65.6c-43.744-43.744-101.088-65.6-158.4-65.6s-114.656 21.856-158.4 65.6l-96 96c-63.104 63.104-80.192 154.4-52.224 233.248l-98.368 98.368c-24.224-8.608-49.568-13.216-75.008-13.216-57.312 0-114.656 21.856-158.4 65.6l-96 96c-87.456 87.488-87.456 229.312 0 316.768 43.744 43.744 101.088 65.632 158.4 65.632s114.656-21.856 158.368-65.6l96-96c63.104-63.104 80.192-154.4 52.224-233.28l98.368-98.368c24.256 8.64 49.6 13.248 75.040 13.248 57.312 0 114.656-21.856 158.368-65.6l96-96c87.488-87.488 87.488-229.312 0.032-316.8zM767.52 346.976c-1.184-22.848-10.176-45.408-27.648-62.848-17.472-17.472-40-26.432-62.848-27.648l77.728-77.728c12.096-12.096 28.16-18.752 45.248-18.752s33.152 6.656 45.248 18.752c12.096 12.096 18.752 28.16 18.752 45.248s-6.656 33.152-18.752 45.248l-77.728 77.728zM626.752 306.752c12.096-12.096 28.16-18.752 45.248-18.752s33.152 6.656 45.248 18.752c12.096 12.096 18.752 28.16 18.752 45.248s-6.656 33.152-18.752 45.248l-320 320c-12.096 12.096-28.16 18.752-45.248 18.752s-33.152-6.656-45.248-18.752c-12.096-12.096-18.752-28.16-18.752-45.248s6.656-33.152 18.752-45.248l320-320zM256.48 677.024c1.184 22.848 10.176 45.408 27.648 62.848 17.472 17.472 40 26.432 62.848 27.648l-77.728 77.728c-12.096 12.096-28.16 18.752-45.248 18.752s-33.152-6.656-45.248-18.752c-12.096-12.096-18.752-28.16-18.752-45.248s6.656-33.152 18.752-45.248l77.728-77.728zM455.776 839.776l-96 96c-36.288 36.256-84.512 56.224-135.776 56.224-51.296 0-99.488-19.968-135.776-56.224-74.848-74.848-74.848-196.672 0-271.52l96-96c36.288-36.288 84.48-56.256 135.776-56.256 16.96 0 33.472 2.592 49.44 6.816l-213.312 213.312c-37.504 37.472-37.504 98.272 0 135.744 18.752 18.752 43.296 28.128 67.872 28.128s49.12-9.376 67.872-28.128l212.544-212.544c16.768 63.872 1.312 134.464-48.64 184.448zM935.776 359.776l-96 96c-36.288 36.256-84.512 56.224-135.776 56.224-16.96 0-33.472-2.592-49.44-6.816l213.312-213.312c37.504-37.472 37.504-98.272 0-135.744-18.752-18.752-43.296-28.128-67.872-28.128s-49.12 9.376-67.872 28.128l-212.544 212.544c-16.768-63.84-1.312-134.464 48.64-184.416l96-96c36.288-36.288 84.48-56.256 135.776-56.256s99.488 19.968 135.776 56.224c74.848 74.88 74.848 196.672 0 271.552z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"link",
						"connect",
						"ui"
					],
					"grid": 32
				},
				{
					"id": 612,
					"width": 1024,
					"paths": [
						"M530.624 629.12c27.968 78.88 10.88 170.144-52.224 233.28l-96 96c-43.776 43.744-101.088 65.6-158.4 65.6s-114.656-21.888-158.4-65.6c-87.488-87.488-87.488-229.28 0-316.768l96-96c43.744-43.776 101.056-65.632 158.4-65.632 25.44 0 50.784 4.608 75.008 13.248l-238.88 238.88c-18.144 18.144-28.128 42.24-28.128 67.872s9.984 49.76 28.128 67.872c18.112 18.144 42.24 28.128 67.872 28.128s49.728-9.984 67.872-28.128l238.752-238.752zM958.4 65.6c-43.744-43.744-101.088-65.6-158.4-65.6s-114.656 21.856-158.4 65.6l-96 96c-63.104 63.104-80.192 154.4-52.224 233.248l238.752-238.752c18.144-18.112 42.24-28.096 67.872-28.096s49.728 9.984 67.872 28.128c18.144 18.112 28.128 42.208 28.128 67.872s-9.984 49.76-28.128 67.872l-238.912 238.912c24.256 8.608 49.6 13.216 75.040 13.216 57.312 0 114.656-21.856 158.368-65.6l96-96c87.488-87.488 87.488-229.312 0.032-316.8zM288 672c0 17.088 6.656 33.152 18.752 45.248s28.16 18.752 45.248 18.752 33.152-6.656 45.248-18.752l320-320c12.096-12.096 18.752-28.16 18.752-45.248s-6.656-33.152-18.752-45.248c-12.096-12.096-28.16-18.752-45.248-18.752s-33.152 6.656-45.248 18.752l-320 320c-12.096 12.096-18.752 28.16-18.752 45.248z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"link",
						"connect",
						"ui"
					],
					"grid": 32
				},
				{
					"id": 3389,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM384 832h-128v-448h128v448zM320 320c-35.4 0-64-28.6-64-64s28.6-64 64-64c35.4 0 64 28.6 64 64s-28.6 64-64 64zM832 832h-128v-256c0-35.4-28.6-64-64-64s-64 28.6-64 64v256h-128v-448h128v79.4c26.4-36.2 66.8-79.4 112-79.4 79.6 0 144 71.6 144 160v288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"linkedin",
						"brand",
						"social"
					],
					"defaultCode": 61224,
					"grid": 16
				},
				{
					"id": 1311,
					"width": 877.7129821777344,
					"paths": [
						"M135.429 808h132v-396.571h-132v396.571zM276 289.143q-0.571-29.714-20.571-49.143t-53.143-19.429-54 19.429-20.857 49.143q0 29.143 20.286 48.857t52.857 19.714h0.571q33.714 0 54.286-19.714t20.571-48.857zM610.286 808h132v-227.429q0-88-41.714-133.143t-110.286-45.143q-77.714 0-119.429 66.857h1.143v-57.714h-132q1.714 37.714 0 396.571h132v-221.714q0-21.714 4-32 8.571-20 25.714-34t42.286-14q66.286 0 66.286 89.714v212zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"linkedin-square"
					],
					"defaultCode": 61580,
					"grid": 14
				},
				{
					"id": 3390,
					"paths": [
						"M384 384h177.106v90.782h2.532c24.64-44.194 84.958-90.782 174.842-90.782 186.946 0 221.52 116.376 221.52 267.734v308.266h-184.61v-273.278c0-65.184-1.334-149.026-96.028-149.026-96.148 0-110.82 70.986-110.82 144.292v278.012h-184.542v-576z",
						"M64 384h192v576h-192v-576z",
						"M256 224c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"linkedin",
						"brand",
						"social"
					],
					"defaultCode": 61225,
					"grid": 16
				},
				{
					"id": 1378,
					"width": 877.7139511108398,
					"paths": [
						"M199.429 357.143v566.286h-188.571v-566.286h188.571zM211.429 182.286q0.571 41.714-28.857 69.714t-77.429 28h-1.143q-46.857 0-75.429-28t-28.571-69.714q0-42.286 29.429-70t76.857-27.714 76 27.714 29.143 70zM877.714 598.857v324.571h-188v-302.857q0-60-23.143-94t-72.286-34q-36 0-60.286 19.714t-36.286 48.857q-6.286 17.143-6.286 46.286v316h-188q1.143-228 1.143-369.714t-0.571-169.143l-0.571-27.429h188v82.286h-1.143q11.429-18.286 23.429-32t32.286-29.714 49.714-24.857 65.429-8.857q97.714 0 157.143 64.857t59.429 190z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"linkedin"
					],
					"defaultCode": 61665,
					"grid": 14
				},
				{
					"id": 1522,
					"width": 874.8569793701172,
					"paths": [
						"M378.857 234.857q-6.286 0.571-8.857 6t-4.857 5.429q-2.857 0.571-2.857-2.857 0-6.857 10.857-8.571h5.714zM428.571 242.857q-2.286 0.571-6.571-3.714t-10-2.571q13.714-6.286 18.286 1.143 1.714 3.429-1.714 5.143zM228 486.857q-2.286-0.571-3.429 1.714t-2.571 7.143-3.143 7.714-5.714 7.429q-4 5.714-0.571 6.857 2.286 0.571 7.143-4t7.143-10.286q0.571-1.714 1.143-4t1.143-3.429 0.857-2.571 0.286-2.286v-1.714t-0.571-1.429-1.714-1.143zM716.571 692q0-10.286-31.429-24 2.286-8.571 4.286-15.714t2.857-14.857 1.714-12.286 0.286-12.857-0.571-11.143-2-12.571-2.286-11.714-2.857-14.286-3.143-15.143q-5.714-27.429-26.857-58.857t-41.143-42.857q13.714 11.429 32.571 47.429 49.714 92.571 30.857 158.857-6.286 22.857-28.571 24-17.714 2.286-22-10.571t-4.571-47.714-6.571-61.143q-5.143-22.286-11.143-39.429t-11.143-26-8.857-14-7.429-8.571-4.286-4q-8-35.429-17.714-58.857t-16.857-32-13.429-18.857-8.571-22.857q-2.286-12 3.429-30.571t2.571-28.286-25.429-14.286q-8.571-1.714-25.429-10.286t-20.286-9.143q-4.571-0.571-6.286-14.857t4.571-29.143 20.571-15.429q21.143-1.714 29.143 17.143t2.286 33.143q-6.286 10.857-1.143 15.143t17.143 0.286q7.429-2.286 7.429-20.571v-21.143q-2.857-17.143-7.714-28.571t-12-17.429-13.429-8.571-15.429-4.286q-61.143 4.571-50.857 76.571 0 8.571-0.571 8.571-5.143-5.143-16.857-6t-18.857 0.286-8.857-2.857q0.571-32.571-9.143-51.429t-25.714-19.429q-15.429-0.571-23.714 15.714t-9.429 34q-0.571 8.571 2 21.143t7.429 21.429 8.857 7.714q5.714-1.714 9.143-8 2.286-5.143-4-4.571-4 0-8.857-8.286t-5.429-19.143q-0.571-12.571 5.143-21.143t19.429-8q9.714 0 15.429 12t5.429 22.286-0.857 12.571q-12.571 8.571-17.714 16.571-4.571 6.857-15.714 13.429t-11.714 7.143q-7.429 8-8.857 15.429t4.286 10.286q8 4.571 14.286 11.143t9.143 10.857 10.571 7.429 20.286 3.714q26.857 1.143 58.286-8.571 1.143-0.571 13.143-4t19.714-6 16.857-7.429 12-10q5.143-8 11.429-4.571 2.857 1.714 3.714 4.857t-1.714 6.857-9.429 5.429q-11.429 3.429-32.286 12.286t-26 11.143q-25.143 10.857-40 13.143-14.286 2.857-45.143-1.143-5.714-1.143-5.143 1.143t9.714 10.857q14.286 13.143 38.286 12.571 9.714-0.571 20.571-4t20.571-8 19.143-10 17.143-9.714 14-6.857 10-1.429 4.857 6.286q0 1.143-0.571 2.571t-2.286 2.857-3.429 2.571-4.857 2.857-5.143 2.571-5.714 2.857-5.429 2.571q-16 8-38.571 25.143t-38 24.571-28 0.571q-12-6.286-36-41.714-12.571-17.714-14.286-12.571-0.571 1.714-0.571 5.714 0 14.286-8.571 32.286t-16.857 31.714-12 33.143 6.571 36q-13.143 3.429-35.714 51.429t-27.143 80.571q-1.143 10.286-0.857 39.429t-3.143 33.714q-4.571 13.714-16.571 1.714-18.286-17.714-20.571-53.714-1.143-16 2.286-32 2.286-10.857-0.571-10.286l-2.286 2.857q-20.571 37.143 5.714 94.857 2.857 6.857 14.286 16t13.714 11.429q11.429 13.143 59.429 51.714t53.143 43.714q9.143 8.571 10 21.714t-8 24.571-26 13.143q4.571 8.571 16.571 25.429t16 30.857 4 40.286q26.286-13.714 4-52.571-2.286-4.571-6-9.143t-5.429-6.857-1.143-3.429q1.714-2.857 7.429-5.429t11.429 1.429q26.286 29.714 94.857 20.571 76-8.571 101.143-49.714 13.143-21.714 19.429-17.143 6.857 3.429 5.714 29.714-0.571 14.286-13.143 52.571-5.143 13.143-3.429 21.429t13.714 8.857q1.714-10.857 8.286-44t7.714-51.429q1.143-12-3.714-42t-4.286-55.429 13.143-40.286q8.571-10.286 29.143-10.286 0.571-21.143 19.714-30.286t41.429-6 34.286 12.857zM357.714 219.429q1.714-9.714-1.429-17.143t-6.571-8.571q-5.143-1.143-5.143 4 1.143 2.857 2.857 3.429 5.714 0 4 8.571-1.714 11.429 4.571 11.429 1.714 0 1.714-1.714zM597.143 332q-1.143-4.571-3.714-6.571t-7.429-2.857-8.286-3.143q-2.857-1.714-5.429-4.571t-4-4.571-3.143-3.714-2.286-2.286-2.286 0.857q-8 9.143 4 24.857t22.286 18q5.143 0.571 8.286-4.571t2-11.429zM495.429 210.286q0-6.286-2.857-11.143t-6.286-7.143-5.143-1.714q-8 0.571-4 4l2.286 1.143q8 2.286 10.286 17.714 0 1.714 4.571-1.143zM526.286 77.143q0-1.143-1.429-2.857t-5.143-4-5.429-3.429q-8.571-8.571-13.714-8.571-5.143 0.571-6.571 4.286t-0.571 7.429-0.286 7.143q-0.571 2.286-3.429 6t-3.429 5.143 1.714 4.857q2.286 1.714 4.571 0t6.286-5.143 8.571-5.143q0.571-0.571 5.143-0.571t8.571-1.143 5.143-4zM849.143 843.429q11.429 6.857 17.714 14t6.857 13.714-1.429 12.857-8.857 12.571-13.429 11.143-17.143 10.571-18 9.429-18.286 8.857-15.429 7.429q-21.714 10.857-48.857 32t-43.143 36.571q-9.714 9.143-38.857 11.143t-50.857-8.286q-10.286-5.143-16.857-13.429t-9.429-14.571-12.571-11.143-26.857-5.429q-25.143-0.571-74.286-0.571-10.857 0-32.571 0.857t-33.143 1.429q-25.143 0.571-45.429 8.571t-30.571 17.143-24.857 16.286-30.571 6.571q-16.571-0.571-63.429-17.714t-83.429-24.571q-10.857-2.286-29.143-5.429t-28.571-5.143-22.571-5.429-19.143-8.286-9.714-11.143q-5.714-13.143 4-38t10.286-31.143q0.571-9.143-2.286-22.857t-5.714-24.286-2.571-20.857 6-15.429q8-6.857 32.571-8t34.286-6.857q17.143-10.286 24-20t6.857-29.143q12 41.714-18.286 60.571-18.286 11.429-47.429 8.571-19.429-1.714-24.571 5.714-7.429 8.571 2.857 32.571 1.143 3.429 4.571 10.286t4.857 10.286 2.571 9.714 0.571 12.571q0 8.571-9.714 28t-8 27.429q1.714 9.714 21.143 14.857 11.429 3.429 48.286 10.571t56.857 11.714q13.714 3.429 42.286 12.571t47.143 13.143 31.714 2.286q24.571-3.429 36.857-16t13.143-27.429-4.286-33.429-10.857-29.714-11.429-20.857q-69.143-108.571-96.571-138.286-38.857-42.286-64.571-22.857-6.286 5.143-8.571-8.571-1.714-9.143-1.143-21.714 0.571-16.571 5.714-29.714t13.714-26.857 12.571-24q4.571-12 15.143-41.143t16.857-44.571 17.143-34.857 22.286-30.857q62.857-81.714 70.857-111.429-6.857-64-9.143-177.143-1.143-51.429 13.714-86.571t60.571-59.714q22.286-12 59.429-12 30.286-0.571 60.571 7.714t50.857 23.714q32.571 24 52.286 69.429t16.857 84.286q-2.857 54.286 17.143 122.286 19.429 64.571 76 124.571 31.429 33.714 56.857 93.143t34 109.143q4.571 28 2.857 48.286t-6.857 31.714-11.429 12.571q-5.714 1.143-13.429 10.857t-15.429 20.286-23.143 19.143-34.857 8q-10.286-0.571-18-2.857t-12.857-7.714-7.714-8.857-6.571-11.714-5.143-11.143q-12.571-21.143-23.429-17.143t-16 28 4 55.429q11.429 40 0.571 111.429-5.714 37.143 10.286 57.429t41.714 18.857 48.571-20.286q33.714-28 51.143-38t59.143-24.286q30.286-10.286 44-20.857t10.571-19.714-14.286-16.286-29.429-13.429q-18.857-6.286-28.286-27.429t-8.571-41.429 8.857-27.143q0.571 17.714 4.571 32.286t8.286 23.143 11.714 16.286 12 10.857 12.286 7.429 9.429 5.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"linux"
					],
					"defaultCode": 61820,
					"grid": 14
				},
				{
					"id": 2823,
					"paths": [
						"M1024 440.156l-10.026-0.314c-123.85-7.154-233.328-133.842-357.974-133.842-128 0-144 48-144 48s-16-48-144-48c-124.646 0-234.124 126.688-357.974 133.842l-10.026 0.314c0 0 320 57.844 512 57.844s512-57.844 512-57.844zM512 590c-168.798 0-448-98-498.76-136.84 144.012 110.194 249.24 306.84 498.76 306.84s354.746-196.644 498.76-306.84c-50.76 38.84-329.962 136.84-498.76 136.84z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lips",
						"mouth",
						"kiss"
					],
					"defaultCode": 60658,
					"grid": 16
				},
				{
					"id": 2824,
					"paths": [
						"M964.514 371.116c-29.21 0-128.932-53.362-128.932-53.362-56.852-31.712-121.29-67.656-193.982-67.656-53.766 0-97.3 8.512-129.6 25.318-32.298-16.806-75.834-25.318-129.602-25.318-72.694 0-137.13 35.944-193.982 67.656 0 0-99.72 53.362-128.932 53.362-44.59 0-90.608 59.304-31.376 114.774 31.81 24.34 62.216 54.708 94.408 86.858 46.996 46.938 95.592 95.47 156.506 133.782 72.086 45.336 148.292 67.376 232.978 67.376 84.684 0 160.89-22.040 232.978-67.376 60.912-38.31 109.51-86.844 156.504-133.782 32.192-32.15 62.6-62.518 94.408-86.858 59.234-55.47 13.214-114.774-31.376-114.774zM512 716.302c-224.57 0-319.276-176.982-448.888-276.16 45.684 34.958 296.968 133.158 448.888 133.158s403.204-98.202 448.886-133.158c-129.612 99.178-224.318 276.16-448.886 276.16zM512 480.5c-172.802 0-460.804-52.060-460.804-52.060l9.024-0.282c111.464-6.44 209.996-120.458 322.18-120.458 115.202 0 129.602 43.2 129.602 43.2s14.4-43.2 129.6-43.2c112.184 0 210.714 114.020 322.182 120.458l9.022 0.282c-0.004 0-288.006 52.060-460.806 52.060z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lips",
						"mouth",
						"kiss"
					],
					"defaultCode": 60659,
					"grid": 16
				},
				{
					"id": 2670,
					"paths": [
						"M0 0h256v256h-256zM384 64h640v128h-640zM0 384h256v256h-256zM384 448h640v128h-640zM0 768h256v256h-256zM384 832h640v128h-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"list",
						"todo",
						"bullet",
						"menu",
						"options"
					],
					"defaultCode": 60505,
					"grid": 16
				},
				{
					"id": 1210,
					"width": 1024.0009956359863,
					"paths": [
						"M219.429 676.571v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM219.429 530.286v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM219.429 384v36.571q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857zM877.714 676.571v36.571q0 7.429-5.429 12.857t-12.857 5.429h-548.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h548.571q7.429 0 12.857 5.429t5.429 12.857zM877.714 530.286v36.571q0 7.429-5.429 12.857t-12.857 5.429h-548.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h548.571q7.429 0 12.857 5.429t5.429 12.857zM877.714 384v36.571q0 7.429-5.429 12.857t-12.857 5.429h-548.571q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h548.571q7.429 0 12.857 5.429t5.429 12.857zM950.857 786.286v-475.429q0-7.429-5.429-12.857t-12.857-5.429h-841.143q-7.429 0-12.857 5.429t-5.429 12.857v475.429q0 7.429 5.429 12.857t12.857 5.429h841.143q7.429 0 12.857-5.429t5.429-12.857zM1024 164.571v621.714q0 37.714-26.857 64.571t-64.571 26.857h-841.143q-37.714 0-64.571-26.857t-26.857-64.571v-621.714q0-37.714 26.857-64.571t64.571-26.857h841.143q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"list-alt"
					],
					"defaultCode": 61474,
					"grid": 14
				},
				{
					"id": 2669,
					"paths": [
						"M384 832h640v128h-640zM384 448h640v128h-640zM384 64h640v128h-640zM192 0v256h-64v-192h-64v-64zM128 526v50h128v64h-192v-146l128-60v-50h-128v-64h192v146zM256 704v320h-192v-64h128v-64h-128v-64h128v-64h-128v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"list-numbered",
						"options"
					],
					"defaultCode": 60504,
					"grid": 16
				},
				{
					"id": 1358,
					"width": 1032.5710163116455,
					"paths": [
						"M217.714 925.714q0 45.714-31.143 72t-77.429 26.286q-60.571 0-98.286-37.714l32.571-50.286q28 25.714 60.571 25.714 16.571 0 28.857-8.286t12.286-24.286q0-36.571-60-32l-14.857-32q4.571-5.714 18.571-24.857t24.286-30.857 21.143-22v-0.571q-9.143 0-27.714 0.571t-27.714 0.571v30.286h-60.571v-86.857h190.286v50.286l-54.286 65.714q29.143 6.857 46.286 28t17.143 50.286zM218.857 567.429v90.857h-206.857q-3.429-20.571-3.429-30.857 0-29.143 13.429-53.143t32.286-38.857 37.714-27.143 32.286-24.857 13.429-25.714q0-14.286-8.286-22t-22.571-7.714q-26.286 0-46.286 33.143l-48.571-33.714q13.714-29.143 40.857-45.429t60.286-16.286q41.714 0 70.286 23.714t28.571 64.286q0 28.571-19.429 52.286t-42.857 36.857-43.143 28.857-20.286 30h72.571v-34.286h60zM1024 749.714v109.714q0 7.429-5.429 12.857t-12.857 5.429h-694.857q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-8 5.143-13.143t13.143-5.143h694.857q7.429 0 12.857 5.429t5.429 12.857zM219.429 236v56.571h-191.429v-56.571h61.143q0-23.429 0.286-69.714t0.286-69.143v-6.857h-1.143q-4.571 9.714-28.571 30.857l-40.571-43.429 77.714-72.571h60.571v230.857h61.714zM1024 457.143v109.714q0 7.429-5.429 12.857t-12.857 5.429h-694.857q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-8 5.143-13.143t13.143-5.143h694.857q7.429 0 12.857 5.429t5.429 12.857zM1024 164.571v109.714q0 7.429-5.429 12.857t-12.857 5.429h-694.857q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h694.857q7.429 0 12.857 5.429t5.429 12.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"list-ol"
					],
					"defaultCode": 61643,
					"grid": 14
				},
				{
					"id": 1357,
					"width": 1024.0010375976562,
					"paths": [
						"M219.429 804.571q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM219.429 512q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM1024 749.714v109.714q0 7.429-5.429 12.857t-12.857 5.429h-694.857q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h694.857q7.429 0 12.857 5.429t5.429 12.857zM219.429 219.429q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM1024 457.143v109.714q0 7.429-5.429 12.857t-12.857 5.429h-694.857q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h694.857q7.429 0 12.857 5.429t5.429 12.857zM1024 164.571v109.714q0 7.429-5.429 12.857t-12.857 5.429h-694.857q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h694.857q7.429 0 12.857 5.429t5.429 12.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"list-ul"
					],
					"defaultCode": 61642,
					"grid": 14
				},
				{
					"id": 2671,
					"paths": [
						"M384 64h640v128h-640v-128zM384 448h640v128h-640v-128zM384 832h640v128h-640v-128zM0 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 896c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"list",
						"todo",
						"bullet",
						"menu",
						"options"
					],
					"defaultCode": 60506,
					"grid": 16
				},
				{
					"id": 1234,
					"width": 1023.9999904632568,
					"paths": [
						"M146.286 749.714v109.714q0 7.429-5.429 12.857t-12.857 5.429h-109.714q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h109.714q7.429 0 12.857 5.429t5.429 12.857zM146.286 530.286v109.714q0 7.429-5.429 12.857t-12.857 5.429h-109.714q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h109.714q7.429 0 12.857 5.429t5.429 12.857zM146.286 310.857v109.714q0 7.429-5.429 12.857t-12.857 5.429h-109.714q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h109.714q7.429 0 12.857 5.429t5.429 12.857zM1024 749.714v109.714q0 7.429-5.429 12.857t-12.857 5.429h-768q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h768q7.429 0 12.857 5.429t5.429 12.857zM146.286 91.429v109.714q0 7.429-5.429 12.857t-12.857 5.429h-109.714q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h109.714q7.429 0 12.857 5.429t5.429 12.857zM1024 530.286v109.714q0 7.429-5.429 12.857t-12.857 5.429h-768q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h768q7.429 0 12.857 5.429t5.429 12.857zM1024 310.857v109.714q0 7.429-5.429 12.857t-12.857 5.429h-768q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h768q7.429 0 12.857 5.429t5.429 12.857zM1024 91.429v109.714q0 7.429-5.429 12.857t-12.857 5.429h-768q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h768q7.429 0 12.857 5.429t5.429 12.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"list"
					],
					"defaultCode": 61498,
					"grid": 14
				},
				{
					"id": 209,
					"paths": [
						"M998.4 819.2h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M998.4 563.2h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M998.4 307.2h-768c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M76.8 358.4c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.453 76.8-76.8 76.8zM76.8 256c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M76.8 614.4c-42.347 0-76.8-34.451-76.8-76.8 0-42.347 34.453-76.8 76.8-76.8s76.8 34.453 76.8 76.8c0 42.349-34.453 76.8-76.8 76.8zM76.8 512c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M76.8 870.4c-42.347 0-76.8-34.451-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.453 76.8-76.8 76.8zM76.8 768c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"list",
						"options",
						"menu"
					],
					"defaultCode": 59506,
					"grid": 20
				},
				{
					"id": 1057,
					"width": 1024,
					"paths": [
						"M960.768 580.032c-35.008-36.096-79.936-58.592-128.768-65.504v-130.528c0-176.448-143.552-320-320-320s-320 143.552-320 320v130.528c-48.832 6.944-93.76 29.408-128.768 65.504-42.528 43.84-64.96 101.664-63.136 162.848 3.616 119.712 107.648 217.12 231.968 217.12h23.936c35.296 0 64-28.704 64-64v-320c0-35.296-28.704-64-64-64v-128c0-141.152 114.848-256 256-256s256 114.848 256 256v128c-35.296 0-64 28.704-64 64v320c0 35.296 28.704 64 64 64h23.936c124.32 0 228.352-97.408 231.968-217.12 1.856-61.184-20.576-119.008-63.136-162.848zM64.096 740.928c-1.344-43.712 14.656-85.024 45.056-116.352 22.816-23.52 51.488-39.072 82.848-45.408v311.584c-71.232-16.992-125.728-77.44-127.904-149.824zM256.064 896h-24c-2.752 0-5.344-0.64-8.064-0.768v-319.232h32l0.064 320zM768 896v-320h32v319.232c-2.72 0.128-5.312 0.768-8.064 0.768h-23.936zM832 890.752v-311.584c31.36 6.304 60.032 21.888 82.848 45.408 30.4 31.328 46.4 72.64 45.056 116.352-2.176 72.384-56.672 132.832-127.904 149.824z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"listen",
						"hear"
					],
					"grid": 32
				},
				{
					"id": 613,
					"width": 1024,
					"paths": [
						"M533.216 50.336c-12.096-10.72-30.304-10.72-42.4 0-2.464 2.176-4.64 4.128-6.144 5.472-82.048 74.432-324.672 314.656-324.672 552.064 0 129.536 160.352 215.072 255.936 254.496 14.656 6.048 57.248 29.76 80.064 42.688v70.816c0 8.832 7.168 16 16 16v0c8.832 0 16-7.168 16-16v-70.816c22.816-12.928 65.376-36.64 80.064-42.656 95.584-39.456 255.936-124.96 255.936-254.528 0-237.376-242.592-477.6-324.64-552.064-1.504-1.344-3.68-3.296-6.144-5.472zM528 296.928l125.856-75.52c27.168 32.544 54.4 68.576 79.328 107.072l-205.184 123.136v-154.688zM496 451.616l-205.184-123.104c24.928-38.496 52.16-74.56 79.328-107.104l125.856 75.52v154.688zM496 488.928v186.688l-287.808-172.704c14.528-50.752 37.568-100.544 65.504-147.36l222.304 133.376zM528 488.928l222.304-133.376c27.968 46.816 51.008 96.64 65.504 147.36l-287.808 172.704v-186.688zM632.8 196.768l-104.8 62.848v-170.784c26.336 24.416 64.48 61.92 104.8 107.936zM496 88.832v170.784l-104.768-62.88c40.32-45.984 78.432-83.488 104.768-107.904zM428.16 832.8c-88.192-36.384-236.16-114.016-236.16-224.928 0-24.128 3.232-48.32 8.192-72.416l295.808 177.504v155.392c-22.304-12.48-53.984-29.824-67.84-35.552zM595.84 832.832c-13.888 5.728-45.568 23.072-67.84 35.52v-155.392l295.808-177.504c4.96 24.096 8.192 48.288 8.192 72.416 0 110.912-147.968 188.544-236.16 224.96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"live",
						"die",
						"grow"
					],
					"grid": 32
				},
				{
					"id": 614,
					"width": 1024,
					"paths": [
						"M539.36 55.84c-1.504-1.376-3.68-3.296-6.144-5.504-12.096-10.72-30.304-10.72-42.4 0-2.464 2.176-4.64 4.128-6.144 5.472-82.048 74.432-324.672 314.656-324.672 552.064 0 129.536 160.352 215.072 255.936 254.496 14.656 6.048 57.248 29.76 80.064 42.688v70.816c0 8.832 7.168 16 16 16s16-7.168 16-16v-70.816c22.816-12.928 65.376-36.64 80.064-42.656 95.584-39.456 255.936-124.96 255.936-254.528 0-237.376-242.592-477.6-324.64-552.032zM813.696 541.536l-285.696 171.392v139.392c0 8.832-7.168 16-16 16s-16-7.168-16-16v-139.392l-285.696-171.424c-6.016-3.616-8.992-10.72-7.296-17.536v0c2.56-10.464 14.528-15.424 23.776-9.888l269.216 161.536v-186.688l-208.256-124.928c-7.712-4.608-10.080-14.688-5.28-22.272v0c4.64-7.328 14.304-9.632 21.76-5.152l191.776 115.072v-154.72l-109.632-65.792c-8.48-5.088-10.368-16.576-3.936-24.128 5.088-5.952 13.696-7.328 20.384-3.328l93.184 55.936v-154.784c0-8.832 7.168-16 16-16v0c8.832 0 16 7.168 16 16v154.784l93.184-55.904c6.688-4.032 15.328-2.624 20.384 3.328 6.432 7.52 4.544 19.008-3.936 24.128l-109.632 65.76v154.688l191.776-115.072c7.456-4.48 17.12-2.176 21.76 5.152 4.8 7.584 2.4 17.664-5.28 22.272l-208.256 124.96v186.688l269.216-161.536c9.248-5.536 21.184-0.576 23.776 9.888v0c1.696 6.816-1.28 13.952-7.296 17.568z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"live",
						"die",
						"grow"
					],
					"grid": 32
				},
				{
					"id": 1058,
					"width": 1024,
					"paths": [
						"M960 96h-896c-17.664 0-32 14.336-32 32v768c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-768c0-17.664-14.336-32-32-32zM928 864h-832v-704h832v704zM336 544h-208v-32h195.488l60.96-243.872c3.552-14.24 27.488-14.24 31.072 0l112.48 449.92 80.48-321.92c3.552-14.24 27.488-14.24 31.072 0l28.96 115.872h227.488v32h-240c-7.328 0-13.76-4.992-15.52-12.128l-16.48-65.92-80.48 321.92c-1.76 7.136-8.192 12.128-15.52 12.128s-13.76-4.992-15.52-12.128l-112.48-449.888-48.48 193.92c-1.76 7.104-8.192 12.096-15.52 12.096zM192 800h-64v-32h64v32zM192 672h-64v-32h64v32zM192 416h-64v-32h64v32zM192 288h-64v-32h64v32zM832 768h64v32h-64v-32zM832 640h64v32h-64v-32zM896 416h-64v-32h64v32zM896 288h-64v-32h64v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"live",
						"chart",
						"beat"
					],
					"grid": 32
				},
				{
					"id": 615,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM927.936 510.464c-121.856 60.448-262.080 60-383.072 0 116-76.928 190.656-200.736 204.736-339.456 107.264 74.976 177.824 199.040 178.336 339.456zM718.72 151.52c-8.736 135.488-79.488 256.704-191.648 331.296-8.576-139.104-78.304-265.472-191.456-347.040 53.664-25.248 113.28-39.776 176.384-39.776 75.264 0 145.76 20.416 206.72 55.52zM303.072 152.832c113.024 75.328 182.656 196.832 191.168 331.488-124.8-62.112-269.216-64.896-396.448-7.616 11.68-138.304 91.296-257.28 205.28-323.872zM96.064 513.504c121.856-60.384 262.144-59.936 383.104 0.032-116.096 76.96-190.72 200.64-204.8 339.424-107.264-74.976-177.792-199.040-178.304-339.456zM305.344 872.512c8.736-135.552 79.296-256.672 191.584-331.328 8.576 139.264 78.304 265.44 191.488 347.008-53.632 25.28-113.28 39.808-176.416 39.808-75.264 0-145.696-20.384-206.656-55.488zM720.992 871.104c-113.088-75.328-182.752-196.64-191.232-331.488 65.12 32.416 135.584 48.736 206.144 48.736 64.8 0 129.44-14.56 190.368-42.048-11.424 138.688-91.040 258.048-205.28 324.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"load",
						"crash",
						"spin",
						"wait"
					],
					"grid": 32
				},
				{
					"id": 616,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM915.776 550.784c-57.856 24.544-118.816 37.568-179.936 37.568-70.56 0-140.992-16.32-206.144-48.736 7.936 126.048 69.408 240.256 169.792 316.16 9.376 7.072 8.032 21.376-2.464 26.624-0.448 0.224-0.896 0.448-1.312 0.672-5.248 2.592-11.584 1.984-16.256-1.568-107.872-81.664-174.208-204.768-182.56-340.288-104.992 69.824-173.44 180.288-189.024 305.152-1.44 11.648-14.464 17.6-24.256 11.168-0.384-0.256-0.736-0.48-1.12-0.736-4.896-3.232-7.52-9.056-6.816-14.88 16.832-134.24 90.464-253.44 203.456-328.352-112.96-56-242.752-60.032-358.688-11.136-10.688 4.512-22.432-3.552-21.824-15.136 0.032-0.512 0.064-0.992 0.096-1.504 0.32-5.92 4-11.232 9.472-13.536 124.672-52.544 264.608-48.352 386.016 12.064-7.968-125.888-69.408-240.256-169.728-316.16-9.344-7.072-8-21.344 2.496-26.592 0.416-0.224 0.864-0.416 1.28-0.64 5.248-2.592 11.584-1.984 16.256 1.568 107.84 81.664 174.144 204.928 182.496 340.32 104.896-69.76 173.472-180.288 189.088-305.12 1.44-11.616 14.464-17.6 24.256-11.168 0.32 0.224 0.672 0.448 0.992 0.672 4.896 3.232 7.552 9.056 6.816 14.88-16.864 134.24-90.496 253.504-203.392 328.384 113.024 56.032 242.752 60.064 358.656 11.104 10.72-4.512 22.432 3.584 21.824 15.2 0 0.16-0.032 0.32-0.032 0.448-0.288 5.952-3.968 11.264-9.44 13.568z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"load",
						"crash",
						"spin",
						"wait"
					],
					"grid": 32
				},
				{
					"id": 1059,
					"width": 1024,
					"paths": [
						"M881.696 244.512l6.56-52.512h7.744c17.696 0 32-14.304 32-32v-128c0-17.696-14.304-32-32-32h-768c-17.696 0-32 14.304-32 32v128c0 17.696 14.304 32 32 32h7.744l6.56 52.512c12.448 99.552 77.12 186.72 168.8 227.456l90.112 40.032-90.080 40.032c-91.68 40.736-156.384 127.904-168.8 227.456l-6.592 52.512h-7.744c-17.696 0-32 14.304-32 32v128c0 17.696 14.304 32 32 32h768c17.696 0 32-14.304 32-32v-128c0-17.696-14.304-32-32-32h-7.744l-6.56-52.512c-12.448-99.552-77.12-186.72-168.8-227.456l-90.112-40.032 90.080-40.032c91.712-40.736 156.384-127.904 168.832-227.456zM160 128v-64h704v64h-704zM205.824 236.576l-9.568-76.576h631.52l-9.568 76.576c-5.408 43.072-23.712 82.88-50.88 115.424h-510.656c-27.168-32.544-45.472-72.352-50.848-115.424zM337.12 610.528l90.112-40.064c1.472-0.64 2.528-1.728 3.904-2.496-4.064 42.944-26.944 81.984-63.296 106.208l-67.488 44.992c-37.088 24.704-68.48 56.096-93.184 93.184l-5.536 8.288 4.16-33.216c9.696-77.408 60.032-145.216 131.328-176.896zM864 896v64h-704v-64h704zM686.88 610.528c71.328 31.68 121.632 99.456 131.328 176.896l4.16 33.216-5.536-8.288c-24.704-37.088-56.096-68.48-93.184-93.184l-67.488-44.992c-36.352-24.224-59.232-63.264-63.296-106.208 1.408 0.736 2.464 1.856 3.936 2.496l90.080 40.064zM596.736 453.536c-23.392 10.432-36.736 32.832-36.736 58.464v42.368c0 58.976 29.312 113.696 78.368 146.432l67.488 44.992c33.568 22.368 61.952 50.752 84.32 84.32l22.592 33.888h-601.536l22.592-33.888c22.368-33.568 50.752-61.952 84.32-84.32l67.488-44.992c49.056-32.736 78.368-87.456 78.368-146.432v-42.368c0-25.632-13.344-48.032-36.768-58.496l-90.080-40.032c-17.504-7.776-33.664-17.76-48.352-29.472h446.368c-14.656 11.712-30.848 21.696-48.32 29.472l-90.112 40.064z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"load",
						"wait"
					],
					"grid": 32
				},
				{
					"id": 617,
					"width": 1024,
					"paths": [
						"M512 32c-194.4 0-352 157.6-352 352 0 207.808 183.264 415.616 285.312 515.232 37.088 36.192 96.288 36.192 133.344 0 102.080-99.616 285.344-307.424 285.344-515.232 0-194.4-157.6-352-352-352zM556.544 875.936c-24.8 24.256-64.256 24.256-89.056 0-98.752-96.64-275.488-296.864-275.488-491.936 0-176.448 143.552-320 320-320s320 143.552 320 320c0 195.072-176.736 395.296-275.456 491.936zM512 192c-106.048 0-192 85.952-192 192s85.952 192 192 192 192-85.952 192-192-85.952-192-192-192zM512 544c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.776 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"locate",
						"pin",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 618,
					"width": 1024,
					"paths": [
						"M512 32c-194.4 0-352 157.6-352 352 0 207.808 183.264 415.616 285.312 515.232 37.088 36.192 96.288 36.192 133.344 0 102.080-99.616 285.344-307.424 285.344-515.232 0-194.4-157.6-352-352-352zM512 576c-106.048 0-192-85.952-192-192s85.952-192 192-192 192 85.952 192 192-85.952 192-192 192zM672 384c0 88.224-71.776 160-160 160s-160-71.776-160-160 71.776-160 160-160 160 71.776 160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"locate",
						"pin",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 1060,
					"width": 1024,
					"paths": [
						"M512 0c-212.064 0-384 171.936-384 384 0 217.76 277.856 528.16 360.864 616 6.336 6.688 14.72 10.048 23.136 10.048s16.8-3.36 23.136-10.048c83.008-87.84 360.864-398.24 360.864-616 0-212.064-171.936-384-384-384zM512 930.944c-158.848-173.12-320-400.352-320-546.944 0-176.448 143.552-320 320-320s320 143.552 320 320c0 146.592-161.152 373.824-320 546.944zM512 192c-106.048 0-192 85.952-192 192s85.952 192 192 192 192-85.952 192-192-85.952-192-192-192zM512 544c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.776 160-160 160zM512 256c-70.688 0-128 57.312-128 128s57.312 128 128 128c70.688 0 128-57.312 128-128s-57.312-128-128-128zM512 480c-52.928 0-96-43.072-96-96s43.072-96 96-96c52.928 0 96 43.072 96 96s-43.072 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"locate",
						"pin",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 2125,
					"paths": [
						"M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"location",
						"map-marker",
						"pin"
					],
					"defaultCode": 59960,
					"grid": 16
				},
				{
					"id": 1439,
					"width": 804.5729446411133,
					"paths": [
						"M800.571 199.429l-365.714 731.429q-9.714 20-32.571 20-2.857 0-8.571-1.143-12.571-2.857-20.286-12.857t-7.714-22.571v-329.143h-329.143q-12.571 0-22.571-7.714t-12.857-20.286 2.286-24 16.571-17.143l731.429-365.714q7.429-4 16.571-4 15.429 0 25.714 10.857 8.571 8 10.571 19.714t-3.714 22.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"location-arrow"
					],
					"defaultCode": 61732,
					"grid": 14
				},
				{
					"id": 2126,
					"paths": [
						"M512 0c-176.732 0-320 143.268-320 320 0 320 320 576 320 576s320-256 320-576c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192c106.040 0 192 85.96 192 192s-85.96 192-192 192zM786.256 697.63c-14.182 22.274-28.876 43.38-43.656 63.226 2.346 1.102 4.666 2.216 6.942 3.354 48.67 24.338 70.458 51.582 70.458 67.79s-21.788 43.452-70.458 67.79c-61.28 30.638-147.86 48.21-237.542 48.21s-176.262-17.572-237.542-48.21c-48.672-24.338-70.458-51.582-70.458-67.79s21.786-43.452 70.458-67.79c2.276-1.136 4.596-2.252 6.94-3.354-14.78-19.846-29.474-40.954-43.654-63.226-67.874 34.632-109.744 82.052-109.744 134.37 0 106.040 171.922 192 384 192s384-85.96 384-192c0-52.318-41.87-99.738-109.744-134.37z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"location",
						"map-marker",
						"pin"
					],
					"defaultCode": 59961,
					"grid": 16
				},
				{
					"id": 2127,
					"paths": [
						"M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 516c-108.248 0-196-87.752-196-196s87.752-196 196-196 196 87.752 196 196-87.752 196-196 196zM388 320c0-68.483 55.517-124 124-124s124 55.517 124 124c0 68.483-55.517 124-124 124s-124-55.517-124-124z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"location",
						"map-marker",
						"pin"
					],
					"defaultCode": 59962,
					"grid": 16
				},
				{
					"id": 2128,
					"paths": [
						"M512 0c-176.732 0-320 143.268-320 320 0 320 320 576 320 576s320-256 320-576c0-176.732-143.27-320-320-320zM512 516c-108.248 0-196-87.752-196-196s87.752-196 196-196 196 87.752 196 196-87.752 196-196 196zM388 320c0 68.484 55.516 124 124 124s124-55.516 124-124-55.516-124-124-124c-68.484 0-124 55.516-124 124zM786.256 697.63c-14.182 22.274-28.876 43.38-43.656 63.226 2.346 1.102 4.666 2.216 6.942 3.354 48.67 24.338 70.458 51.582 70.458 67.79s-21.788 43.452-70.458 67.79c-61.28 30.638-147.86 48.21-237.542 48.21s-176.262-17.572-237.542-48.21c-48.672-24.338-70.458-51.582-70.458-67.79s21.786-43.452 70.458-67.79c2.276-1.136 4.596-2.252 6.94-3.354-14.78-19.846-29.474-40.954-43.654-63.226-67.874 34.632-109.744 82.052-109.744 134.37 0 106.040 171.922 192 384 192s384-85.96 384-192c0-52.318-41.87-99.738-109.744-134.37z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"location",
						"map-marker",
						"pin"
					],
					"defaultCode": 59963,
					"grid": 16
				},
				{
					"id": 2129,
					"paths": [
						"M512 0c-212.078 0-384 171.922-384 384 0 384 384 640 384 640s384-256 384-640c0-212.078-171.922-384-384-384zM512 448c-70.692 0-128-57.308-128-128s57.308-128 128-128c70.694 0 128 57.308 128 128s-57.306 128-128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"location",
						"map-marker",
						"pin"
					],
					"defaultCode": 59964,
					"grid": 16
				},
				{
					"id": 2130,
					"paths": [
						"M512 0c-212.078 0-384 171.922-384 384 0 384 384 640 384 640s384-256 384-640c0-212.078-171.922-384-384-384zM645.982 792.746c-49.436 58.186-99.51 102.9-133.982 130.97-34.474-28.070-84.548-72.788-133.982-130.97-50.238-59.128-90.060-120.502-118.362-182.408-34.278-74.97-51.656-151.124-51.656-226.338 0-81.202 31.622-157.542 89.040-214.96s133.758-89.040 214.96-89.040c81.204 0 157.542 31.622 214.96 89.040s89.040 133.758 89.040 214.96c0 75.214-17.378 151.368-51.654 226.338-28.304 61.906-68.126 123.28-118.364 182.408zM512 192c-70.692 0-128 57.308-128 128s57.308 128 128 128c70.694 0 128-57.308 128-128s-57.306-128-128-128zM512 384c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.346 0 64 28.654 64 64s-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"location",
						"map-marker",
						"pin"
					],
					"defaultCode": 59965,
					"grid": 16
				},
				{
					"id": 2131,
					"paths": [
						"M512 0c-176.73 0-320 134.314-320 300 0 240 256 321.46 256 660v32c0 16.898 13.102 30.726 29.7 31.91v0.090h66.3c17.672 0 32-14.326 32-32v-32c0-338.54 256-420 256-660 0-165.686-143.27-300-320-300z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"location",
						"map-marker",
						"pin"
					],
					"defaultCode": 59966,
					"grid": 16
				},
				{
					"id": 148,
					"paths": [
						"M435.202 1024.002c-2.205 0-4.435-0.285-6.642-0.878-11.186-3.003-18.96-13.142-18.96-24.723v-384h-384c-11.581 0-21.72-7.774-24.723-18.96-3.005-11.184 1.874-22.994 11.898-28.795l972.8-563.2c10.037-5.811 22.726-4.147 30.928 4.053 8.202 8.202 9.864 20.891 4.053 30.93l-563.2 972.8c-4.658 8.045-13.186 12.774-22.154 12.774zM120.912 563.2h314.288c14.138 0 25.6 11.461 25.6 25.6v314.288l467.346-807.234-807.234 467.346z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"location",
						"compass",
						"direction"
					],
					"defaultCode": 59445,
					"grid": 20
				},
				{
					"id": 2405,
					"paths": [
						"M896 384h-64v-320c0-35.2-28.8-64-64-64h-512c-35.2 0-64 28.8-64 64v320h-64c-35.204 0-64 28.8-64 64v512c0 35.2 28.796 64 64 64h768c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64zM576 832h-128l27.84-139.2c-16.808-11.532-27.84-30.874-27.84-52.8 0-35.346 28.654-64 64-64s64 28.654 64 64c0 21.926-11.032 41.268-27.84 52.8l27.84 139.2zM704 384h-384v-256h384v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock",
						"secure",
						"private",
						"encrypted"
					],
					"defaultCode": 60240,
					"grid": 16
				},
				{
					"id": 1061,
					"width": 1024,
					"paths": [
						"M864 416h-96v-160c0-141.376-114.624-256-256-256s-256 114.624-256 256v160h-96c-17.664 0-32 14.336-32 32v544c0 17.664 14.336 32 32 32h704c17.664 0 32-14.336 32-32v-544c0-17.664-14.336-32-32-32zM320 256c0-105.856 86.144-192 192-192s192 86.144 192 192v192h-64v-192c0-70.592-57.408-128-128-128s-128 57.408-128 128v192h-64v-192zM576 256v160h-128v-160c0-35.36 28.64-64 64-64s64 28.64 64 64zM832 960h-640v-480h640v480zM448 832c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-88.928c19.52-17.568 32-42.752 32-71.072 0-53.024-42.976-96-96-96s-96 42.976-96 96c0 28.32 12.48 53.504 32 71.072v88.928zM512 608c35.296 0 64 28.704 64 64 0 18.080-7.616 34.88-21.408 47.296l-10.592 9.536v103.168h-64v-103.168l-10.592-9.536c-13.792-12.416-21.408-29.216-21.408-47.296 0-35.296 28.704-64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock",
						"unlock",
						"secure"
					],
					"grid": 32
				},
				{
					"id": 2406,
					"paths": [
						"M832 448h-64v-192c0-141.384-114.616-256-256-256s-256 114.616-256 256v192h-64c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h640c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64zM512 832c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM640 448h-256v-192c0-70.58 57.42-128 128-128s128 57.42 128 128v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock",
						"secure",
						"private",
						"encrypted"
					],
					"defaultCode": 60241,
					"grid": 16
				},
				{
					"id": 2407,
					"paths": [
						"M832 448h-64v-192c0-141.384-114.616-256-256-256s-256 114.616-256 256v192h-64c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h640c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64zM384 256c0-70.58 57.42-128 128-128s128 57.42 128 128v192h-256v-192zM832 640l-320 32 320 32-320 32 320 32-320 32 320 32-320 32 320 32-320 32 319.894 31.99c-0.004 0.002-0.006 0.006-0.010 0.010h-639.768c-0.004-0.004-0.006-0.008-0.010-0.010l319.894-31.99-320-32 320-32-320-32 320-32-320-32 320-32-320-32 320-32-320-32 320-32-320-32 320-32-319.896-31.99c0.004-0.004 0.006-0.008 0.010-0.010h639.77c0.004 0.002 0.006 0.008 0.010 0.010l-319.894 31.99 320 32-320 32 320 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock",
						"secure",
						"private",
						"encrypted",
						"dualtone"
					],
					"defaultCode": 60242,
					"grid": 16
				},
				{
					"id": 2408,
					"paths": [
						"M592 448h-16v-192c0-105.87-86.13-192-192-192h-128c-105.87 0-192 86.13-192 192v192h-16c-26.4 0-48 21.6-48 48v480c0 26.4 21.6 48 48 48h544c26.4 0 48-21.6 48-48v-480c0-26.4-21.6-48-48-48zM192 256c0-35.29 28.71-64 64-64h128c35.29 0 64 28.71 64 64v192h-256v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock",
						"secure",
						"private",
						"encrypted"
					],
					"defaultCode": 60243,
					"grid": 16
				},
				{
					"id": 2410,
					"paths": [
						"M592 448h-16v-192c0-105.87-86.13-192-192-192h-128c-105.87 0-192 86.13-192 192v192h-16c-26.4 0-48 21.6-48 48v480c0 26.4 21.6 48 48 48h544c26.4 0 48-21.6 48-48v-480c0-26.4-21.6-48-48-48zM384 896h-128l27.84-139.2c-16.808-11.532-27.84-30.874-27.84-52.8 0-35.346 28.654-64 64-64s64 28.654 64 64c0 21.926-11.032 41.268-27.84 52.8l27.84 139.2zM448 448h-256v-192c0-35.29 28.71-64 64-64h128c35.29 0 64 28.71 64 64v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock",
						"secure",
						"private",
						"encrypted"
					],
					"defaultCode": 60245,
					"grid": 16
				},
				{
					"id": 1211,
					"width": 658.2880783081055,
					"paths": [
						"M182.857 438.857h292.571v-109.714q0-60.571-42.857-103.429t-103.429-42.857-103.429 42.857-42.857 103.429v109.714zM658.286 493.714v329.143q0 22.857-16 38.857t-38.857 16h-548.571q-22.857 0-38.857-16t-16-38.857v-329.143q0-22.857 16-38.857t38.857-16h18.286v-109.714q0-105.143 75.429-180.571t180.571-75.429 180.571 75.429 75.429 180.571v109.714h18.286q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock"
					],
					"defaultCode": 61475,
					"grid": 14
				},
				{
					"id": 110,
					"paths": [
						"M742.4 409.6h-25.6v-76.8c0-127.043-103.357-230.4-230.4-230.4s-230.4 103.357-230.4 230.4v76.8h-25.6c-42.347 0-76.8 34.453-76.8 76.8v409.6c0 42.347 34.453 76.8 76.8 76.8h512c42.347 0 76.8-34.453 76.8-76.8v-409.6c0-42.347-34.453-76.8-76.8-76.8zM307.2 332.8c0-98.811 80.389-179.2 179.2-179.2s179.2 80.389 179.2 179.2v76.8h-358.4v-76.8zM768 896c0 14.115-11.485 25.6-25.6 25.6h-512c-14.115 0-25.6-11.485-25.6-25.6v-409.6c0-14.115 11.485-25.6 25.6-25.6h512c14.115 0 25.6 11.485 25.6 25.6v409.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock",
						"privacy",
						"encryption",
						"security"
					],
					"defaultCode": 59407,
					"grid": 20
				},
				{
					"id": 619,
					"width": 1024,
					"paths": [
						"M736 448v-150.592c0-122.656-94.496-229.6-217.12-233.28-126.848-3.84-230.88 97.856-230.88 223.872v160h-32c-53.024 0-96 42.976-96 96v320c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-320c0-53.024-42.976-96-96-96h-32zM320 288c0-105.856 86.144-192 192-192s192 86.144 192 192v160h-32v-160c0-88.224-71.776-160-160-160s-160 71.776-160 160v160h-32v-160zM640 448h-256v-160c0-70.688 57.312-128 128-128s128 57.312 128 128v160zM768 928h-512c-35.36 0-64-28.64-64-64v-320c0-35.36 28.64-64 64-64h512c35.36 0 64 28.64 64 64v320c0 35.36-28.64 64-64 64zM576 640c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 21.92 11.040 41.216 27.84 52.768l-20.192 100.96c-3.968 19.808 11.2 38.272 31.392 38.272h49.92c20.192 0 35.328-18.464 31.392-38.272l-20.192-100.96c16.8-11.552 27.84-30.848 27.84-52.768zM516.768 699.040l20.192 100.96h-49.92l20.192-100.96 4.128-20.704-17.408-11.936c-8.736-6.016-13.952-15.872-13.952-26.4 0-17.632 14.368-32 32-32s32 14.368 32 32c0 10.528-5.216 20.384-13.952 26.4l-17.408 11.936 4.128 20.704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock",
						"unlock",
						"secure"
					],
					"grid": 32
				},
				{
					"id": 620,
					"width": 1024,
					"paths": [
						"M530.048 666.4l-17.408 11.936 24.32 121.664h-49.92l24.32-121.664-17.408-11.936c-8.736-6.016-13.952-15.872-13.952-26.4 0-17.632 14.368-32 32-32s32 14.368 32 32c0 10.528-5.216 20.384-13.952 26.4zM384 416v-128c0-70.688 57.312-128 128-128s128 57.312 128 128v128h96v-118.592c0-122.656-94.496-229.6-217.12-233.28-126.848-3.84-230.88 97.856-230.88 223.872v128h96zM864 544v320c0 53.024-42.976 96-96 96h-512c-53.024 0-96-42.976-96-96v-320c0-53.024 42.976-96 96-96h512c53.024 0 96 42.976 96 96zM548.16 692.768c16.8-11.552 27.84-30.848 27.84-52.768 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 21.92 11.040 41.216 27.84 52.768l-20.192 100.96c-3.968 19.808 11.2 38.272 31.392 38.272h49.92c20.192 0 35.328-18.464 31.392-38.272l-20.192-100.96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"lock",
						"unlock",
						"secure"
					],
					"grid": 32
				},
				{
					"id": 1515,
					"width": 438.857027053833,
					"paths": [
						"M437.143 742.286q4.571 10.857-2.857 20l-200 219.429q-5.714 5.714-13.143 5.714-8 0-13.714-5.714l-202.857-219.429q-7.429-9.143-2.857-20 5.143-10.857 16.571-10.857h128v-713.143q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v713.143h128q12 0 16.571 10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"long-arrow-down"
					],
					"defaultCode": 61813,
					"grid": 14
				},
				{
					"id": 1517,
					"width": 1060.5709915161133,
					"paths": [
						"M1024 457.143v109.714q0 8-5.143 13.143t-13.143 5.143h-713.143v128q0 12-10.857 16.571t-20-2.857l-219.429-200q-5.714-5.714-5.714-13.143 0-8 5.714-13.714l219.429-202.286q9.143-8 20-3.429 10.857 5.143 10.857 16.571v128h713.143q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"long-arrow-left"
					],
					"defaultCode": 61815,
					"grid": 14
				},
				{
					"id": 1518,
					"width": 987.4290380477905,
					"paths": [
						"M987.429 510.286q0 8-5.714 13.714l-219.429 202.286q-9.143 8-20 3.429-10.857-5.143-10.857-16.571v-128h-713.143q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h713.143v-128q0-12 10.857-16.571t20 2.857l219.429 200q5.714 5.714 5.714 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"long-arrow-right"
					],
					"defaultCode": 61816,
					"grid": 14
				},
				{
					"id": 1516,
					"width": 438.8590087890625,
					"paths": [
						"M437.143 281.714q-5.143 10.857-16.571 10.857h-128v713.143q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-713.143h-128q-12 0-16.571-10.857t2.857-20l200-219.429q5.714-5.714 13.143-5.714 8 0 13.714 5.714l202.857 219.429q7.429 9.143 2.857 20z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"long-arrow-up"
					],
					"defaultCode": 61814,
					"grid": 14
				},
				{
					"id": 621,
					"width": 1024,
					"paths": [
						"M576 495.968c0 97.056 78.944 176 176 176s176-78.944 176-176c0-55.392-20.896-112-176-112s-176 56.64-176 112zM896 495.968c0 79.392-64.608 144-144 144s-144-64.608-144-144c0-31.84 0-80 144-80s144 48.16 144 80zM272 384c-155.104 0-176 56.608-176 112 0 97.056 78.944 176 176 176s176-78.944 176-176c0-55.392-20.928-112-176-112zM272 639.968c-79.392 0-144-64.608-144-144 0-31.84 0-79.968 144-79.968s144 48.128 144 80c0 79.392-64.608 143.968-144 143.968zM752 320c-77.056 0-134.176 13.184-173.856 40.256-21.44-4.064-43.36-6.144-65.312-6.144-22.304 0-44.672 2.112-66.688 6.304-39.712-27.168-96.928-40.416-174.144-40.416h-240c-17.664 0-32 14.336-32 32v37.504c0 25.44 10.112 49.856 28.096 67.872l3.904 3.872v34.752c0 132.32 107.68 240 240 240 15.392 0 31.008-1.472 46.432-4.384 111.136-20.96 193.568-124.128 193.568-237.216 0 113.088 82.368 216.224 193.536 237.184 15.424 2.912 31.072 4.384 46.496 4.384 132.352 0 240-107.68 240-240v-34.752l3.872-3.872c17.984-17.984 28.096-42.4 28.096-67.872v-37.472c0-17.664-14.336-32-32-32h-240zM992 389.472c0 16.96-6.752 33.248-18.752 45.248l-13.248 13.28c0 0 0 29.856 0 48 0 114.88-93.12 208-208 208-13.248 0-26.816-1.248-40.544-3.84-96.96-18.304-168.16-106.912-167.456-205.568 0 0 0-46.592-32-46.592s-32 46.624-32 46.624c0.704 98.656-70.56 187.264-167.488 205.536-13.728 2.592-27.264 3.84-40.48 3.84-114.88 0-208-93.12-208-208-0.032-18.144-0.032-48-0.032-48l-13.248-13.248c-12-12.032-18.752-28.288-18.752-45.28v-37.472c0 0 180.032 0 240 0 68.192 0 129.088 10.56 166.432 42.784 16.096-4.64 49.408-8.672 74.368-8.672 24.512 0 49.024 2.816 72.96 8.48 37.984-32.192 98.208-42.592 166.24-42.592 59.968 0 240 0 240 0v37.472z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"look",
						"see",
						"watch",
						"wear"
					],
					"grid": 32
				},
				{
					"id": 622,
					"width": 1024,
					"paths": [
						"M416 496c0 79.392-64.608 144-144 144s-144-64.608-144-144c0-31.84 0-80 144-80s144 48.16 144 80zM1024 352v37.504c0 25.472-10.112 49.888-28.128 67.872l-3.872 3.872v34.752c0 132.32-107.648 240-240 240-15.424 0-31.072-1.472-46.496-4.384-111.136-20.992-193.504-124.096-193.504-237.184 0 113.088-82.4 216.256-193.568 237.216-15.424 2.88-31.040 4.352-46.432 4.352-132.352 0-240-107.68-240-240v-34.752l-3.904-3.904c-17.984-17.984-28.096-42.4-28.096-67.84v-37.504c0-17.664 14.336-32 32-32h240c77.248 0 134.432 13.248 174.112 40.448 22.016-4.192 44.384-6.304 66.688-6.304 21.984 0 43.872 2.048 65.312 6.144 39.712-27.072 96.832-40.288 173.888-40.288h240c17.664 0 32 14.336 32 32zM448 496c0-55.392-20.896-112-176-112s-176 56.608-176 112c0 97.056 78.944 176 176 176s176-78.944 176-176zM928 496c0-55.392-20.896-112-176-112s-176 56.608-176 112c0 97.056 78.944 176 176 176s176-78.944 176-176zM752 416c-144 0-144 48.16-144 80 0 79.392 64.608 144 144 144s144-64.608 144-144c0-31.84 0-80-144-80z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"look",
						"see",
						"watch",
						"wear"
					],
					"grid": 32
				},
				{
					"id": 3005,
					"paths": [
						"M128 320h640v192l256-256-256-256v192h-768v384h128zM896 704h-640v-192l-256 256 256 256v-192h768v-384h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"loop",
						"repeat",
						"player"
					],
					"defaultCode": 60840,
					"grid": 16
				},
				{
					"id": 3006,
					"paths": [
						"M512 208c-100.252 0-189.54 46.802-246.326 119.256l-76.776-57.582c74.32-95.764 191.494-157.674 323.102-157.674v-112l160 160-160 160v-112zM512 816c100.254 0 189.542-46.802 246.326-119.256l76.776 57.582c-74.32 95.764-191.494 157.674-323.102 157.674v112l-160-160 160-160v112zM201.6 512c0 100.364 49.928 189.508 126.724 244.902l-57.584 76.78c-100.108-72.928-165.14-189.966-165.14-321.682h-105.6l160-160 160 160h-118.4zM918.4 512h105.6l-160 160-160-160h118.4c0-100.364-49.928-189.508-126.724-244.902l57.584-76.778c100.108 72.926 165.14 189.962 165.14 321.68z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"loop",
						"repeat",
						"player",
						"reload",
						"refresh",
						"update",
						"synchronize",
						"arrows"
					],
					"defaultCode": 60841,
					"grid": 16
				},
				{
					"id": 3007,
					"paths": [
						"M889.68 166.32c-93.608-102.216-228.154-166.32-377.68-166.32-282.77 0-512 229.23-512 512h96c0-229.75 186.25-416 416-416 123.020 0 233.542 53.418 309.696 138.306l-149.696 149.694h352v-352l-134.32 134.32z",
						"M928 512c0 229.75-186.25 416-416 416-123.020 0-233.542-53.418-309.694-138.306l149.694-149.694h-352v352l134.32-134.32c93.608 102.216 228.154 166.32 377.68 166.32 282.77 0 512-229.23 512-512h-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"loop",
						"repeat",
						"player",
						"reload",
						"refresh",
						"update",
						"synchronize",
						"arrows"
					],
					"defaultCode": 60842,
					"grid": 16
				},
				{
					"id": 3011,
					"paths": [
						"M320 640v-192h192l-256-256-256 256h192v320h384l-128-128zM832 576v-320h-384l128 128h128v192h-192l256 256 256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"loop",
						"repeat",
						"player"
					],
					"defaultCode": 60846,
					"grid": 16
				},
				{
					"id": 623,
					"width": 1024,
					"paths": [
						"M704 128c-76.576 0-145.088 33.792-192 87.072-46.912-53.28-115.424-87.072-192-87.072-141.376 0-256 114.624-256 256 0 195.52 206.464 361.536 339.072 448 41.12 26.816 75.168 45.984 93.728 56 9.568 5.152 20.864 5.152 30.432 0 18.528-10.016 52.576-29.184 93.696-56 132.576-86.432 339.072-252.48 339.072-448 0-141.376-114.624-256-256-256zM512 859.808c-74.752-40.576-416-238.816-416-475.808 0-123.52 100.48-224 224-224 64.096 0 125.344 27.776 168 76.224l24 27.264 24-27.264c42.656-48.448 103.904-76.224 168-76.224 123.52 0 224 100.48 224 224 0 236.992-341.248 435.232-416 475.808zM256 256c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM256 352c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"love",
						"like",
						"hate"
					],
					"grid": 32
				},
				{
					"id": 624,
					"width": 1024,
					"paths": [
						"M288 320c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM960 384c0 195.52-206.496 361.568-339.104 448-41.12 26.784-75.136 45.984-93.696 56-9.568 5.152-20.864 5.152-30.432 0-18.56-10.016-52.608-29.184-93.728-56-132.576-86.464-339.040-252.48-339.040-448 0-141.376 114.624-256 256-256 76.576 0 145.088 33.792 192 87.072 46.912-53.28 115.424-87.072 192-87.072 141.376 0 256 114.624 256 256zM320 320c0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64c35.36 0 64-28.672 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"love",
						"like",
						"hate"
					],
					"grid": 32
				},
				{
					"id": 1801,
					"width": 1024.0009765625,
					"paths": [
						"M191.429 774.857q-1.143 0-3.429-1.143-49.143-32.571-96.286-82.857t-79.714-102.857q-12-17.143-12-39.429 0-5.143 1.143-10.857t2.286-10.286 4-10.286 4.857-9.143 6-9.714 5.714-8.571 6.857-8.857 6.286-8.286q105.143-143.429 258.286-208.571-62.857-113.143-62.857-120.571 0-10.857 9.714-16.571 66.286-36.571 73.143-36.571 10.286 0 16 9.143l70.857 130.857q52.571-10.857 109.714-10.857 152 0 284.286 78.571t216.286 211.143q11.429 17.714 11.429 39.429t-11.429 39.429q-52 81.143-124.857 144.857t-159.143 100.286q62.857 113.143 62.857 120.571 0 11.429-9.714 16.571-66.286 36.571-72.571 36.571-10.857 0-16.571-9.143l-70.857-130.857-36.571-68-253.714-468.571 4-4q-33.143 13.714-56.571 26.857 1.714 2.857 72.571 133.714t138.857 256.571 68 127.429q0 4-5.143 5.143-7.429 1.714-41.143 1.714-32.571 0-34.286-4l-260.571-480.571q-22.286 16-46.857 38.857 13.714 24.571 122.286 224.857t108.571 202.571q0 5.714-6.286 5.714-8 0-47.143-12.571t-41.429-16l-60.571-112.571-128-236q-25.143 30.286-44.571 60.571 1.143 1.714 10.286 14.286t13.143 19.429l100.571 186.857q0 5.714-5.714 5.714zM665.714 716.571l28 52q156-63.429 257.143-220-102.857-158.286-262.286-222.286 38.286 36.571 58.857 84.857t20.571 100.857q0 60.571-26.857 114.571t-75.429 90zM484.571 365.714q0 11.429 8 19.429t19.429 8q49.143 0 84 34.857t34.857 84q0 11.429 8 19.429t19.429 8 19.429-8 8-19.429q0-72-50.857-122.857t-122.857-50.857q-11.429 0-19.429 8t-8 19.429zM693.714 328.571l-5.143-2.286 4 4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"low-vision"
					],
					"defaultCode": 62120,
					"grid": 14
				},
				{
					"id": 3271,
					"paths": [
						"M512 0c-141.384 0-256 114.616-256 256s114.616 256 256 256v512h128v-896h128v896h128v-896h128v-128h-512zM0 704l256-256-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ltr",
						"wysiwyg",
						"left-to-right",
						"direction"
					],
					"defaultCode": 61106,
					"grid": 16
				},
				{
					"id": 3273,
					"paths": [
						"M448 0c-106.040 0-192 85.96-192 192s85.96 192 192 192v320h64v-640h64v640h64v-640h128v-64h-320z",
						"M768 832v160l192-192-192-192v160h-512v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ltr",
						"wysiwyg",
						"left-to-right",
						"direction"
					],
					"defaultCode": 61108,
					"grid": 16
				},
				{
					"id": 1825,
					"paths": [
						"M672 384h128c17.674 0 32-14.328 32-32s-14.326-32-32-32h-128c-17.674 0-32 14.328-32 32s14.326 32 32 32z",
						"M672 256h128c17.674 0 32-14.328 32-32s-14.326-32-32-32h-128c-17.674 0-32 14.328-32 32s14.326 32 32 32z",
						"M672 512h128c17.674 0 32-14.328 32-32s-14.326-32-32-32h-128c-17.674 0-32 14.328-32 32s14.326 32 32 32z",
						"M224 768h576c17.674 0 32-14.326 32-32s-14.326-32-32-32h-576c-17.672 0-32 14.326-32 32s14.328 32 32 32z",
						"M224 640h576c17.674 0 32-14.326 32-32s-14.326-32-32-32h-576c-17.672 0-32 14.326-32 32s14.328 32 32 32z",
						"M928 0h-736c-40.854 0-72.82 11.314-95.016 33.63-22.106 22.228-33.204 54.036-32.984 94.37v864.002c0 17.672 14.328 31.998 32 31.998h704c17.674 0 32-14.326 32-32v-32h96c17.674 0 32-14.326 32-32v-896c0-17.672-14.326-32-32-32zM896 896h-768.002l0.002-768.174c-0.124-22.85 4.708-39.356 14.364-49.064 9.74-9.796 26.442-14.762 49.636-14.762h704v832z",
						"M544 128h-320c-17.6 0-32 14.4-32 32v320c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32v-320c0-17.6-14.4-32-32-32zM512 448h-256v-64c0-35.346 28.654-64 64-64h64c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64h64c35.346 0 64 28.654 64 64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"magazine",
						"newspaper",
						"news"
					],
					"defaultCode": 59660,
					"grid": 16
				},
				{
					"id": 1362,
					"width": 966.2859859466553,
					"paths": [
						"M680 332l167.429-167.429-61.143-61.143-167.429 167.429zM935.429 164.571q0 15.429-10.286 25.714l-734.857 734.857q-10.286 10.286-25.714 10.286t-25.714-10.286l-113.143-113.143q-10.286-10.286-10.286-25.714t10.286-25.714l734.857-734.857q10.286-10.286 25.714-10.286t25.714 10.286l113.143 113.143q10.286 10.286 10.286 25.714zM163.429 56l56 17.143-56 17.143-17.143 56-17.143-56-56-17.143 56-17.143 17.143-56zM363.429 148.571l112 34.286-112 34.286-34.286 112-34.286-112-112-34.286 112-34.286 34.286-112zM894.857 421.714l56 17.143-56 17.143-17.143 56-17.143-56-56-17.143 56-17.143 17.143-56zM529.143 56l56 17.143-56 17.143-17.143 56-17.143-56-56-17.143 56-17.143 17.143-56z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"magic"
					],
					"defaultCode": 61648,
					"grid": 14
				},
				{
					"id": 2434,
					"paths": [
						"M256 192l-128-128h-64v64l128 128zM320 0h64v128h-64zM576 320h128v64h-128zM640 128v-64h-64l-128 128 64 64zM0 320h128v64h-128zM320 576h64v128h-64zM64 576v64h64l128-128-64-64zM1010 882l-636.118-636.118c-18.668-18.668-49.214-18.668-67.882 0l-60.118 60.118c-18.668 18.668-18.668 49.214 0 67.882l636.118 636.118c18.668 18.668 49.214 18.668 67.882 0l60.118-60.118c18.668-18.668 18.668-49.214 0-67.882zM480 544l-192-192 64-64 192 192-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"magic-wand",
						"wizard"
					],
					"defaultCode": 60269,
					"grid": 16
				},
				{
					"id": 2435,
					"paths": [
						"M516.362 451.818l188.772-58.68-193.134-136.584v-256.554l-206.936 149.068-241.064-85.068 85.066 241.066-149.066 206.934h256l137.134 193.136 58.682-188.774 444.184 507.638 128-128-507.638-444.182zM404.654 404.656l-39.158 125.972-76.168-106.020h-131.904l78.894-105.722-42.36-124.928 124.928 42.364 105.724-78.894v131.904l106.016 76.168-125.972 39.156z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"magic-wand",
						"wizard"
					],
					"defaultCode": 60270,
					"grid": 16
				},
				{
					"id": 98,
					"paths": [
						"M588.8 358.4c-14.139 0-25.6-11.462-25.6-25.6 0-70.579-57.421-128-128-128-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6c70.579 0 128-57.421 128-128 0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6c0 70.579 57.421 128 128 128 14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6c-70.579 0-128 57.421-128 128 0 14.138-11.461 25.6-25.6 25.6zM527.426 179.2c25.11 15.136 46.238 36.264 61.374 61.376 15.136-25.112 36.264-46.24 61.376-61.376-25.112-15.136-46.24-36.264-61.376-61.376-15.136 25.112-36.264 46.24-61.374 61.376z",
						"M76.8 512c-14.138 0-25.6-11.462-25.6-25.6 0-14.115-11.485-25.6-25.6-25.6-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6c14.115 0 25.6-11.485 25.6-25.6 0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6c0 14.115 11.485 25.6 25.6 25.6 14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6c-14.115 0-25.6 11.485-25.6 25.6 0 14.138-11.462 25.6-25.6 25.6z",
						"M929.101 816.096l-541.995-541.994c-14.466-14.466-33.752-22.432-54.306-22.432s-39.84 7.966-54.306 22.432l-29.992 29.992c-14.466 14.466-22.432 33.752-22.432 54.306s7.966 39.84 22.432 54.306l541.994 541.992c14.464 14.466 33.75 22.434 54.304 22.434s39.84-7.965 54.306-22.434l29.994-29.992c14.466-14.464 22.432-33.752 22.432-54.304s-7.965-39.842-22.43-54.306zM284.706 340.298l29.992-29.992c4.795-4.795 11.224-7.435 18.102-7.435s13.307 2.64 18.102 7.435l73.691 73.693-66.197 66.197-73.691-73.691c-9.982-9.984-9.982-26.224 0-36.206zM892.894 888.502l-29.994 29.992c-4.794 4.794-11.224 7.434-18.099 7.434s-13.306-2.64-18.099-7.434l-432.102-432.099 66.197-66.195 432.098 432.099c9.981 9.981 9.981 26.222 0 36.203z",
						"M179.2 256c-14.138 0-25.6-11.462-25.6-25.6 0-42.347-34.453-76.8-76.8-76.8-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6c42.347 0 76.8-34.453 76.8-76.8 0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6c0 42.347 34.453 76.8 76.8 76.8 14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6c-42.347 0-76.8 34.453-76.8 76.8 0 14.138-11.462 25.6-25.6 25.6zM153.52 128c9.725 7.304 18.376 15.957 25.68 25.68 7.304-9.725 15.957-18.376 25.68-25.68-9.725-7.304-18.376-15.957-25.68-25.68-7.304 9.723-15.957 18.376-25.68 25.68z",
						"M179.2 768c-14.138 0-25.6-11.461-25.6-25.6 0-42.347-34.453-76.8-76.8-76.8-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6c42.347 0 76.8-34.453 76.8-76.8 0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6c0 42.347 34.453 76.8 76.8 76.8 14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6c-42.347 0-76.8 34.453-76.8 76.8 0 14.139-11.462 25.6-25.6 25.6zM153.52 640c9.725 7.302 18.376 15.957 25.68 25.68 7.304-9.723 15.957-18.374 25.68-25.68-9.725-7.302-18.376-15.957-25.68-25.68-7.304 9.723-15.957 18.378-25.68 25.68z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"magic-wand",
						"tool",
						"wizard"
					],
					"defaultCode": 59395,
					"grid": 20
				},
				{
					"id": 2562,
					"paths": [
						"M384 384v256c0 70.58 57.42 128 128 128 70.578 0 128-57.42 128-128v-256h256v256c0 212.078-171.922 384-384 384s-384-171.922-384-384v-256h256z",
						"M896 176v144h-256v-144c0-26.4 21.6-48 48-48h160c26.4 0 48 21.6 48 48z",
						"M384 176v144h-256v-144c0-26.4 21.6-48 48-48h160c26.4 0 48 21.6 48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"magnet",
						"attract"
					],
					"defaultCode": 60397,
					"grid": 16
				},
				{
					"id": 2563,
					"paths": [
						"M896 0h-256l64 576c0 106.040-85.96 192-192 192s-192-85.96-192-192l64-576h-256l-64 576c0 247.424 200.576 448 448 448s448-200.576 448-448l-64-576zM777.874 841.874c-71.018 71.014-165.44 110.126-265.874 110.126s-194.856-39.112-265.872-110.126c-70.116-70.118-109.13-163.048-110.11-262.054l36.092-324.82h111.114l-35.224 317.010v3.99c0 70.518 27.46 136.814 77.324 186.676 49.862 49.864 116.158 77.324 186.676 77.324s136.814-27.46 186.676-77.324c49.864-49.862 77.324-116.158 77.324-186.676v-3.988l-0.44-3.962-34.782-313.050h111.114l36.090 324.818c-0.98 99.006-39.994 191.938-110.108 262.056z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"magnet",
						"attract"
					],
					"defaultCode": 60398,
					"grid": 16
				},
				{
					"id": 1290,
					"width": 877.7139282226562,
					"paths": [
						"M877.714 475.429v73.143q0 114.857-56.286 206.857t-156.571 143.714-226 51.714-226-51.714-156.571-143.714-56.286-206.857v-73.143q0-14.857 10.857-25.714t25.714-10.857h219.429q14.857 0 25.714 10.857t10.857 25.714v73.143q0 29.714 13.429 51.429t30.571 32.571 40.571 17.143 36.571 7.429 25.143 1.143 25.143-1.143 36.571-7.429 40.571-17.143 30.571-32.571 13.429-51.429v-73.143q0-14.857 10.857-25.714t25.714-10.857h219.429q14.857 0 25.714 10.857t10.857 25.714zM292.571 109.714v219.429q0 14.857-10.857 25.714t-25.714 10.857h-219.429q-14.857 0-25.714-10.857t-10.857-25.714v-219.429q0-14.857 10.857-25.714t25.714-10.857h219.429q14.857 0 25.714 10.857t10.857 25.714zM877.714 109.714v219.429q0 14.857-10.857 25.714t-25.714 10.857h-219.429q-14.857 0-25.714-10.857t-10.857-25.714v-219.429q0-14.857 10.857-25.714t25.714-10.857h219.429q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"magnet"
					],
					"defaultCode": 61558,
					"grid": 14
				},
				{
					"id": 206,
					"paths": [
						"M966.070 981.101l-304.302-331.965c68.573-71.754 106.232-165.549 106.232-265.136 0-102.57-39.942-199-112.47-271.53s-168.96-112.47-271.53-112.47-199 39.942-271.53 112.47-112.47 168.96-112.47 271.53 39.942 199.002 112.47 271.53 168.96 112.47 271.53 112.47c88.362 0 172.152-29.667 240.043-84.248l304.285 331.947c5.050 5.507 11.954 8.301 18.878 8.301 6.179 0 12.378-2.226 17.293-6.728 10.421-9.555 11.126-25.749 1.571-36.171zM51.2 384c0-183.506 149.294-332.8 332.8-332.8s332.8 149.294 332.8 332.8-149.294 332.8-332.8 332.8-332.8-149.294-332.8-332.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"magnifier",
						"search"
					],
					"defaultCode": 59503,
					"grid": 20
				},
				{
					"id": 3319,
					"paths": [
						"M853.31 0h-682.62c-93.88 0-170.69 76.784-170.69 170.658v682.656c0 93.876 76.81 170.686 170.69 170.686h682.622c93.938 0 170.688-76.81 170.688-170.686v-682.656c0-93.874-76.75-170.658-170.69-170.658zM256 256h512c9.138 0 18.004 1.962 26.144 5.662l-282.144 329.168-282.144-329.17c8.14-3.696 17.006-5.66 26.144-5.66zM192 704v-384c0-1.34 0.056-2.672 0.14-4l187.664 218.94-185.598 185.6c-1.444-5.338-2.206-10.886-2.206-16.54zM768 768h-512c-5.654 0-11.202-0.762-16.54-2.206l182.118-182.118 90.422 105.496 90.424-105.494 182.116 182.118c-5.34 1.442-10.886 2.204-16.54 2.204zM832 704c0 5.654-0.762 11.2-2.206 16.54l-185.598-185.598 187.664-218.942c0.084 1.328 0.14 2.66 0.14 4v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mail",
						"contact",
						"support",
						"newsletter",
						"letter",
						"email",
						"envelop",
						"social"
					],
					"defaultCode": 61154,
					"grid": 16
				},
				{
					"id": 1273,
					"width": 1024.0031433105469,
					"paths": [
						"M1024 365.714q0 14.857-10.857 25.714l-292.571 292.571q-10.857 10.857-25.714 10.857t-25.714-10.857-10.857-25.714v-146.286h-128q-56 0-100.286 3.429t-88 12.286-76 24.286-60.286 39.714-45.714 57.714-27.714 79.143-10 103.429q0 31.429 2.857 70.286 0 3.429 1.429 13.429t1.429 15.143q0 8.571-4.857 14.286t-13.429 5.714q-9.143 0-16-9.714-4-5.143-7.429-12.571t-7.714-17.143-6-13.714q-72.571-162.857-72.571-257.714 0-113.714 30.286-190.286 92.571-230.286 500-230.286h128v-146.286q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857l292.571 292.571q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mail-forward",
						"share"
					],
					"defaultCode": 61540,
					"grid": 14
				},
				{
					"id": 1424,
					"width": 1024.0030403137207,
					"paths": [
						"M1024 640q0 94.857-72.571 257.714-1.714 4-6 13.714t-7.714 17.143-7.429 12.571q-6.857 9.714-16 9.714-8.571 0-13.429-5.714t-4.857-14.286q0-5.143 1.429-15.143t1.429-13.429q2.857-38.857 2.857-70.286 0-57.714-10-103.429t-27.714-79.143-45.714-57.714-60.286-39.714-76-24.286-88-12.286-100.286-3.429h-128v146.286q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-292.571-292.571q-10.857-10.857-10.857-25.714t10.857-25.714l292.571-292.571q10.857-10.857 25.714-10.857t25.714 10.857 10.857 25.714v146.286h128q407.429 0 500 230.286 30.286 76.571 30.286 190.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mail-reply",
						"reply"
					],
					"defaultCode": 61714,
					"grid": 14
				},
				{
					"id": 1437,
					"width": 1023.999927520752,
					"paths": [
						"M365.714 618.286v40q0 24-22.286 33.714-7.429 2.857-14.286 2.857-15.429 0-25.714-10.857l-292.571-292.571q-10.857-10.857-10.857-25.714t10.857-25.714l292.571-292.571q16.571-17.714 40-8 22.286 9.714 22.286 33.714v39.429l-226.857 227.429q-10.857 10.857-10.857 25.714t10.857 25.714zM1024 640q0 33.143-9.714 76.286t-22 78.857-27.429 71.429-23.143 51.714l-11.429 22.857q-4.571 9.714-16 9.714-3.429 0-5.143-0.571-14.286-4.571-13.143-19.429 24.571-228.571-60.571-322.857-36.571-40.571-97.429-63.143t-152.857-30v143.429q0 24-22.286 33.714-7.429 2.857-14.286 2.857-15.429 0-25.714-10.857l-292.571-292.571q-10.857-10.857-10.857-25.714t10.857-25.714l292.571-292.571q16.571-17.714 40-8 22.286 9.714 22.286 33.714v149.714q234.857 16 342.286 126.286 96.571 98.857 96.571 290.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mail-reply-all",
						"reply-all"
					],
					"defaultCode": 61730,
					"grid": 14
				},
				{
					"id": 3320,
					"paths": [
						"M853.342 0h-682.656c-93.874 0-170.686 76.81-170.686 170.69v682.622c0 93.938 76.812 170.688 170.686 170.688h682.656c93.876 0 170.658-76.75 170.658-170.69v-682.62c0-93.88-76.782-170.69-170.658-170.69zM853.342 128c7.988 0 15.546 2.334 22.020 6.342l-363.362 300.404-363.354-300.4c6.478-4.010 14.044-6.346 22.040-6.346h682.656zM170.686 896c-1.924 0-3.82-0.146-5.684-0.408l225.626-312.966-29.256-29.254-233.372 233.37v-611.138l384 464.396 384-464.394v611.136l-233.372-233.37-29.254 29.254 225.628 312.968c-1.858 0.26-3.746 0.406-5.662 0.406h-682.654z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mail",
						"contact",
						"support",
						"newsletter",
						"letter",
						"email",
						"envelop",
						"social"
					],
					"defaultCode": 61155,
					"grid": 16
				},
				{
					"id": 3321,
					"paths": [
						"M853.342 0h-682.656c-93.874 0-170.686 76.81-170.686 170.69v682.622c0 93.938 76.812 170.688 170.686 170.688h682.656c93.876 0 170.658-76.75 170.658-170.69v-682.62c0-93.88-76.782-170.69-170.658-170.69zM182.628 886.626l-77.256-77.254 256-256 29.256 29.254-208 304zM153.372 198.628l29.256-29.256 329.372 265.374 329.374-265.374 29.254 29.256-358.628 422.626-358.628-422.626zM841.374 886.626l-208-304 29.254-29.254 256 256-77.254 77.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mail",
						"contact",
						"support",
						"newsletter",
						"letter",
						"email",
						"envelop",
						"social"
					],
					"defaultCode": 61156,
					"grid": 16
				},
				{
					"id": 3322,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM256 256h512c9.138 0 18.004 1.962 26.144 5.662l-282.144 329.168-282.144-329.17c8.14-3.696 17.006-5.66 26.144-5.66zM192 704v-384c0-1.34 0.056-2.672 0.14-4l187.664 218.942-185.598 185.598c-1.444-5.336-2.206-10.886-2.206-16.54zM768 768h-512c-5.654 0-11.202-0.762-16.54-2.208l182.118-182.118 90.422 105.498 90.424-105.494 182.116 182.12c-5.34 1.44-10.886 2.202-16.54 2.202zM832 704c0 5.654-0.762 11.2-2.206 16.54l-185.6-185.598 187.666-218.942c0.084 1.328 0.14 2.66 0.14 4v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mail",
						"contact",
						"support",
						"newsletter",
						"letter",
						"email",
						"envelop",
						"social"
					],
					"defaultCode": 61157,
					"grid": 16
				},
				{
					"id": 2122,
					"paths": [
						"M992 192h-384c-17.674 0-32 14.328-32 32s14.326 32 32 32h352v448h-768v-448h96c17.672 0 32-14.328 32-32s-14.328-32-32-32h-256c-17.672 0-32 14.328-32 32v512c0 17.674 14.328 32 32 32h288v224c0 17.674 14.328 32 32 32h256c17.674 0 32-14.326 32-32v-224h352c17.674 0 32-14.326 32-32v-512c0-17.672-14.326-32-32-32zM64 256h64v448h-64v-448zM576 960h-192v-192h192v192z",
						"M480 512c53.020 0 96-42.98 96-96 0-41.796-26.718-77.334-64-90.516v-197.484h128v-128h-256v416c0 53.020 42.98 96 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mailbox",
						"mail",
						"inbox"
					],
					"defaultCode": 59957,
					"grid": 16
				},
				{
					"id": 625,
					"width": 1024,
					"paths": [
						"M768 288h-64c0-52.192-25.248-98.88-64-128 0-53.024-42.976-96-96-96s-96 42.976-96 96c0 24.704 9.6 46.976 24.928 64h-88.928c-70.688 0-128 57.312-128 128h-32c-53.024 0-96 42.976-96 96 0 43.168 28.704 79.264 67.904 91.328l48.32 338.24c6.752 47.296 47.264 82.432 95.040 82.432h345.472c47.776 0 88.288-35.136 95.040-82.432l50.016-350.144c39.296-21.824 66.208-63.264 66.208-111.424 0-70.688-57.312-128-128-128zM544 96c35.296 0 64 28.704 64 64s-28.704 64-64 64c-35.296 0-64-28.704-64-64s28.704-64 64-64zM748.096 873.056c-4.48 31.328-31.712 54.944-63.36 54.944h-345.472c-31.648 0-58.88-23.616-63.36-54.944l-47.008-329.056h566.208l-47.008 329.056zM768 512h-544c-35.296 0-64-28.704-64-64s28.704-64 64-64h64v-32c0-52.928 43.072-96 96-96h160c40.064 0 74.336-24.576 88.704-59.488 24.096 23.2 39.296 55.488 39.296 91.488v32h96c52.928 0 96 43.072 96 96s-43.072 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"make",
						"bake",
						"eat",
						"indulge"
					],
					"grid": 32
				},
				{
					"id": 3218,
					"paths": [
						"M320 128h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64z",
						"M704 384h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64zM704 192h128v128h-128v-128z",
						"M320 640h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64zM320 832h-128v-128h128v128z",
						"M832 640h-128c-35.2 0-64 28.8-64 64v128c0 35.2 28.8 64 64 64h128c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64z",
						"M896 512h-64c-85.476 0-165.834-33.286-226.274-93.724-60.44-60.442-93.726-140.802-93.726-226.276v-64c0-70.4-57.6-128-128-128h-256c-70.4 0-128 57.6-128 128v256c0 70.4 57.6 128 128 128h64c85.476 0 165.834 33.286 226.274 93.724 60.44 60.442 93.726 140.802 93.726 226.276v64c0 70.4 57.6 128 128 128h256c70.4 0 128-57.6 128-128v-256c0-70.4-57.6-128-128-128zM960 896c0 16.954-6.696 32.986-18.856 45.144-12.158 12.16-28.19 18.856-45.144 18.856h-256c-16.954 0-32.986-6.696-45.144-18.856-12.16-12.158-18.856-28.19-18.856-45.144v-64c0-212.078-171.922-384-384-384h-64c-16.954 0-32.986-6.696-45.146-18.854-12.158-12.16-18.854-28.192-18.854-45.146v-256c0-16.954 6.696-32.986 18.854-45.146 12.16-12.158 28.192-18.854 45.146-18.854h256c16.954 0 32.986 6.696 45.146 18.854 12.158 12.16 18.854 28.192 18.854 45.146v64c0 212.078 171.922 384 384 384h64c16.954 0 32.986 6.696 45.144 18.856 12.16 12.158 18.856 28.19 18.856 45.144v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"make-group"
					],
					"defaultCode": 61053,
					"grid": 16
				},
				{
					"id": 626,
					"width": 1024,
					"paths": [
						"M480 160c0-35.296 28.704-64 64-64s64 28.704 64 64-28.704 64-64 64c-35.296 0-64-28.704-64-64zM244.224 877.568c6.752 47.296 47.264 82.432 95.040 82.432h345.472c47.776 0 88.288-35.136 95.040-82.432l43.072-301.568h-621.696l43.072 301.568zM768 288h-64c0-52.192-25.248-98.88-64-128 0 52.928-43.072 96-96 96-28.64 0-54.112-12.864-71.712-32.832 0.224 0.256 0.416 0.576 0.64 0.832h-88.928c-70.688 0-128 57.312-128 128h-32c-53.024 0-96 42.976-96 96s42.976 96 96 96h544c70.688 0 128-57.312 128-128s-57.312-128-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"make",
						"bake",
						"eat",
						"indulge"
					],
					"grid": 32
				},
				{
					"id": 2835,
					"paths": [
						"M640 0v128h165.49l-245.032 245.034c-50.588-33.506-111.238-53.034-176.458-53.034-176.73 0-320 143.268-320 320 0 176.73 143.268 320 320 320s320-143.27 320-320c0-65.218-19.53-125.872-53.034-176.458l245.034-245.032v165.49h128v-384h-384zM384 851.2c-116.642 0-211.2-94.56-211.2-211.2s94.558-211.202 211.2-211.202c116.64 0 211.2 94.558 211.2 211.202 0 116.64-94.558 211.2-211.2 211.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"male",
						"gender",
						"sex",
						"man"
					],
					"defaultCode": 60670,
					"grid": 16
				},
				{
					"id": 1528,
					"width": 585.1460723876953,
					"paths": [
						"M585.143 402.286v237.714q0 22.857-16 38.857t-38.857 16-38.857-16-16-38.857v-201.143h-36.571v521.143q0 26.286-18.857 45.143t-45.143 18.857-45.143-18.857-18.857-45.143v-265.143h-36.571v265.143q0 26.286-18.857 45.143t-45.143 18.857-45.143-18.857-18.857-45.143v-521.143h-36.571v201.143q0 22.857-16 38.857t-38.857 16-38.857-16-16-38.857v-237.714q0-45.714 32-77.714t77.714-32h365.714q45.714 0 77.714 32t32 77.714zM420.571 146.286q0 53.143-37.429 90.571t-90.571 37.429-90.571-37.429-37.429-90.571 37.429-90.571 90.571-37.429 90.571 37.429 37.429 90.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"male"
					],
					"defaultCode": 61827,
					"grid": 14
				},
				{
					"id": 2832,
					"paths": [
						"M576 96c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M576 256h-192c-35.346 0-64 28.654-64 64v320h64v384h80v-384h32v384h80v-384h64v-320c0-35.346-28.652-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"man",
						"male",
						"gender",
						"sex"
					],
					"defaultCode": 60667,
					"grid": 16
				},
				{
					"id": 2834,
					"paths": [
						"M256 96c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M832 96c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M256 256h-192c-35.346 0-64 28.654-64 64v320h64v384h80v-384h32v384h80v-384h64v-320c0-35.346-28.652-64-64-64z",
						"M975 512l49-35.5-133.286-206.116c-5.92-8.98-15.958-14.384-26.714-14.384h-256c-10.756 0-20.792 5.404-26.714 14.384l-133.286 206.116 49 35.5 110.644-143.596 38.458 89.74-134.102 245.856h122.666l21.334 320h64v-320h32v320h64l21.334-320h122.666l-134.104-245.858 38.458-89.74 110.646 143.598z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"man-woman",
						"toilet",
						"bathroom",
						"sex",
						"gender"
					],
					"defaultCode": 60669,
					"grid": 16
				},
				{
					"id": 627,
					"width": 1024,
					"paths": [
						"M224 257.6v-81.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v81.6c-54.208 7.84-96 54.016-96 110.4s41.792 102.56 96 110.4v369.6c0 8.832 7.168 16 16 16s16-7.168 16-16v-369.6c54.208-7.84 96-54.016 96-110.4s-41.792-102.56-96-110.4zM208 448c-44.096 0-80-35.904-80-80 0-44.128 35.904-80 80-80s80 35.872 80 80c0 44.096-35.904 80-80 80zM512 545.6v-369.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v369.6c-54.208 7.84-96 54.016-96 110.4s41.792 102.56 96 110.4v81.6c0 8.832 7.168 16 16 16s16-7.168 16-16v-81.6c54.208-7.84 96-54.016 96-110.4s-41.792-102.56-96-110.4zM496 736c-44.096 0-80-35.904-80-80 0-44.128 35.904-80 80-80s80 35.872 80 80c0 44.096-35.904 80-80 80zM896 464c0-56.384-41.792-102.56-96-110.4v-177.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v177.6c-54.208 7.84-96 54.016-96 110.4s41.792 102.56 96 110.4v273.6c0 8.832 7.168 16 16 16s16-7.168 16-16v-273.6c54.208-7.84 96-54.016 96-110.4zM784 544c-44.096 0-80-35.904-80-80 0-44.128 35.904-80 80-80s80 35.872 80 80c0 44.096-35.904 80-80 80z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"manage",
						"adjust",
						"slide",
						"calibrate"
					],
					"grid": 32
				},
				{
					"id": 628,
					"width": 1024,
					"paths": [
						"M608 656c0 61.856-50.144 112-112 112s-112-50.144-112-112 50.144-112 112-112 112 50.144 112 112zM512 513.632v-337.632c0-8.832-7.168-16-16-16s-16 7.168-16 16v337.632c5.312-0.608 10.528-1.632 16-1.632s10.688 1.024 16 1.632zM480 798.368v49.632c0 8.832 7.168 16 16 16s16-7.168 16-16v-49.632c-5.312 0.608-10.528 1.632-16 1.632s-10.688-1.024-16-1.632zM768 606.368v241.632c0 8.832 7.168 16 16 16s16-7.168 16-16v-241.632c-5.312 0.608-10.528 1.632-16 1.632s-10.688-1.024-16-1.632zM800 321.632v-145.632c0-8.832-7.168-16-16-16s-16 7.168-16 16v145.632c5.312-0.608 10.528-1.632 16-1.632s10.688 1.024 16 1.632zM224 225.632v-49.632c0-8.832-7.168-16-16-16s-16 7.168-16 16v49.632c5.312-0.608 10.528-1.632 16-1.632s10.688 1.024 16 1.632zM192 510.368v337.632c0 8.832 7.168 16 16 16s16-7.168 16-16v-337.632c-5.312 0.608-10.528 1.632-16 1.632s-10.688-1.024-16-1.632zM208 256c-61.856 0-112 50.144-112 112s50.144 112 112 112 112-50.144 112-112-50.144-112-112-112zM784 352c-61.856 0-112 50.144-112 112s50.144 112 112 112 112-50.144 112-112-50.144-112-112-112z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"manage",
						"adjust",
						"slide",
						"calibrate"
					],
					"grid": 32
				},
				{
					"id": 629,
					"width": 1024,
					"paths": [
						"M864 416h-2.656l-26.88-322.656c-1.408-16.576-15.264-29.344-31.904-29.344h-69.12c-16.64 0-30.496 12.768-31.904 29.344l-26.88 322.656h-37.344l-26.88-322.656c-1.376-16.576-15.232-29.344-31.872-29.344h-69.12c-16.64 0-30.496 12.768-31.904 29.344l-26.88 322.656h-290.656c-53.024 0-96 42.976-96 96v352c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-352c0-53.024-42.976-96-96-96zM733.44 96h69.12l26.656 320h-122.432l26.656-320zM509.44 96h69.12l26.656 320h-122.432l26.656-320zM384 928v-160h112v160h-112zM528 928v-160h112v160h-112zM928 864c0 35.296-28.704 64-64 64h-192v-160c0-17.664-14.336-32-32-32h-256c-17.664 0-32 14.336-32 32v160h-192c-35.296 0-64-28.704-64-64v-352c0-35.296 28.704-64 64-64h704c35.296 0 64 28.704 64 64v352zM256 736h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM256 832h-64v-64h64v64zM832 736h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM832 832h-64v-64h64v64zM832 544h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM832 640h-64v-64h64v64zM640 544h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM640 640h-64v-64h64v64zM448 544h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM448 640h-64v-64h64v64zM256 544h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM256 640h-64v-64h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"manufacture",
						"make",
						"produce",
						"pollute"
					],
					"grid": 32
				},
				{
					"id": 630,
					"width": 1024,
					"paths": [
						"M528 768h112v192h-112v-192zM576 640h64v-64h-64v64zM384 640h64v-64h-64v64zM384 960h112v-192h-112v192zM192 640h64v-64h-64v64zM192 832h64v-64h-64v64zM768 832h64v-64h-64v64zM768 640h64v-64h-64v64zM960 512v352c0 53.024-42.976 96-96 96h-192v-192c0-17.664-14.336-32-32-32h-256c-17.664 0-32 14.336-32 32v192h-192c-53.024 0-96-42.976-96-96v-352c0-53.024 42.976-96 96-96h290.656l26.88-322.656c1.408-16.576 15.264-29.344 31.904-29.344h69.12c16.64 0 30.496 12.768 31.904 29.344l26.88 322.656h37.344l26.88-322.656c1.376-16.576 15.232-29.344 31.872-29.344h69.12c16.64 0 30.496 12.768 31.904 29.344l26.88 322.656h2.656c53.024 0 96 42.976 96 96zM288 768c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM288 576c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM480 576c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM672 576c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM864 768c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM864 576c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"manufacture",
						"make",
						"produce",
						"pollute"
					],
					"grid": 32
				},
				{
					"id": 2138,
					"paths": [
						"M352 128c-123.71 0-224 100.288-224 224 0 47.598 14.858 91.716 40.17 128.002l183.83 223.998 183.83-223.998c25.314-36.286 40.17-80.404 40.17-128.002 0-123.712-100.288-224-224-224zM352 448c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z",
						"M992 0h-960c-17.672 0-32 14.328-32 32v960c0 17.674 14.328 32 32 32h960c17.674 0 32-14.326 32-32v-960c0-17.672-14.326-32-32-32zM64 960v-64h512v-128h-512v-704h576v896h-576zM960 960h-192v-64h192v64zM960 768h-192v-704h192v704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map",
						"guide"
					],
					"defaultCode": 59973,
					"grid": 16
				},
				{
					"id": 1240,
					"width": 585.1460762023926,
					"paths": [
						"M438.857 365.714q0-60.571-42.857-103.429t-103.429-42.857-103.429 42.857-42.857 103.429 42.857 103.429 103.429 42.857 103.429-42.857 42.857-103.429zM585.143 365.714q0 62.286-18.857 102.286l-208 442.286q-9.143 18.857-27.143 29.714t-38.571 10.857-38.571-10.857-26.571-29.714l-208.571-442.286q-18.857-40-18.857-102.286 0-121.143 85.714-206.857t206.857-85.714 206.857 85.714 85.714 206.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map-marker"
					],
					"defaultCode": 61505,
					"grid": 14
				},
				{
					"id": 146,
					"paths": [
						"M512 1024c-7.856 0-15.277-3.606-20.13-9.784-2.931-3.73-72.587-92.864-143.229-224.51-41.581-77.491-74.742-153.568-98.565-226.118-30.043-91.499-45.277-177.758-45.277-256.387 0-169.39 137.81-307.2 307.2-307.2s307.2 137.81 307.2 307.2c0 78.629-15.234 164.888-45.278 256.386-23.822 72.55-56.984 148.629-98.565 226.118-70.64 131.646-140.298 220.781-143.229 224.51-4.851 6.179-12.272 9.786-20.128 9.786zM512 51.2c-141.158 0-256 114.842-256 256 0 166.597 74.914 341.176 137.758 458.296 46.186 86.074 92.634 154.306 118.237 189.938 25.709-35.789 72.429-104.432 118.688-190.76 62.643-116.902 137.317-291.163 137.317-457.474 0-141.158-114.84-256-256-256z",
						"M512 460.8c-84.696 0-153.6-68.904-153.6-153.6s68.904-153.6 153.6-153.6 153.6 68.904 153.6 153.6-68.904 153.6-153.6 153.6zM512 204.8c-56.464 0-102.4 45.936-102.4 102.4s45.936 102.4 102.4 102.4c56.464 0 102.4-45.936 102.4-102.4s-45.936-102.4-102.4-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map-marker",
						"pin",
						"location"
					],
					"defaultCode": 59443,
					"grid": 20
				},
				{
					"id": 1756,
					"width": 1170.2869338989258,
					"paths": [
						"M1154.286 6.286q16 11.429 16 30.286v804.571q0 11.429-6.286 20.571t-16.571 13.143l-365.714 146.286q-13.714 6.286-27.429 0l-352-140.571-352 140.571q-5.714 2.857-13.714 2.857-10.857 0-20.571-6.286-16-11.429-16-30.286v-804.571q0-11.429 6.286-20.571t16.571-13.143l365.714-146.286q13.714-6.286 27.429 0l352 140.571 352-140.571q18.286-7.429 34.286 3.429zM420.571 83.429v725.714l329.143 131.429v-725.714zM73.143 207.429v725.714l310.857-124v-725.714zM1097.143 816.571v-725.714l-310.857 124v725.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map-o"
					],
					"defaultCode": 62072,
					"grid": 14
				},
				{
					"id": 1754,
					"width": 585.14208984375,
					"paths": [
						"M292.571 621.714q37.714 0 73.143-8.571v374.286q0 14.857-10.857 25.714t-25.714 10.857h-73.143q-14.857 0-25.714-10.857t-10.857-25.714v-374.286q34.857 8.571 73.143 8.571zM292.571 0q121.143 0 206.857 85.714t85.714 206.857-85.714 206.857-206.857 85.714-206.857-85.714-85.714-206.857 85.714-206.857 206.857-85.714zM292.571 128q8 0 13.143-5.143t5.143-13.143-5.143-13.143-13.143-5.143q-83.429 0-142.286 58.857t-58.857 142.286q0 8 5.143 13.143t13.143 5.143 13.143-5.143 5.143-13.143q0-68 48.286-116.286t116.286-48.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map-pin"
					],
					"defaultCode": 62070,
					"grid": 14
				},
				{
					"id": 1755,
					"width": 1024.0009841918945,
					"paths": [
						"M997.143 169.714q5.714 5.714 5.714 13.143t-5.714 13.143l-80.571 80.571q-16 16-38.857 16h-768q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-14.857 10.857-25.714t25.714-10.857h329.143v-36.571q0-14.857 10.857-25.714t25.714-10.857h73.143q14.857 0 25.714 10.857t10.857 25.714v36.571h292.571q22.857 0 38.857 16zM438.857 694.857h146.286v292.571q0 14.857-10.857 25.714t-25.714 10.857h-73.143q-14.857 0-25.714-10.857t-10.857-25.714v-292.571zM914.286 438.857q14.857 0 25.714 10.857t10.857 25.714v146.286q0 14.857-10.857 25.714t-25.714 10.857h-768q-22.857 0-38.857-16l-80.571-80.571q-5.714-5.714-5.714-13.143t5.714-13.143l80.571-80.571q16-16 38.857-16h292.571v-109.714h146.286v109.714h329.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map-signs"
					],
					"defaultCode": 62071,
					"grid": 14
				},
				{
					"id": 2139,
					"paths": [
						"M768 160l-512-128-256 160v832l256-160 512 128 256-160v-832l-256 160zM704 910.032l-384-96v-700.062l384 96v700.062z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map",
						"guide"
					],
					"defaultCode": 59974,
					"grid": 16
				},
				{
					"id": 2140,
					"paths": [
						"M768 160l-512-128-256 160v832l256-160 512 128 256-160v-832l-256 160zM320 814.032v-700.062l8 2v700.062l-8-2zM344 820.032v-700.062l16 4v700.062l-16-4zM376 828.032v-700.062l16 4v700.062l-16-4zM408 836.032v-700.062l16 4v700.062l-16-4zM440 844.032v-700.062l16 4v700.062l-16-4zM472 852.032v-700.062l16 4v700.062l-16-4zM504 860.032v-700.062l16 4v700.062l-16-4zM536 868.032v-700.062l16 4v700.062l-16-4zM568 876.032v-700.062l16 4v700.062l-16-4zM600 884.032v-700.062l16 4v700.062l-16-4zM632 892.032v-700.062l16 4v700.062l-16-4zM664 900.032v-700.062l16 4v700.062l-16-4zM704 910.032l-8-2v-700.062l8 2v700.062z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map",
						"guide",
						"dualtone"
					],
					"defaultCode": 59975,
					"grid": 16
				},
				{
					"id": 2141,
					"paths": [
						"M0 192l320-128v768l-320 128z",
						"M384 32l320 192v736l-320-160z",
						"M768 224l256-192v768l-256 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map",
						"guide"
					],
					"defaultCode": 59976,
					"grid": 16
				},
				{
					"id": 2142,
					"paths": [
						"M672 192l-320-128-352 128v768l352-128 320 128 352-128v-768l-352 128zM384 145.73l256 102.4v630.138l-256-102.398v-630.14zM64 236.828l256-93.090v631.8l-256 93.088v-631.798zM960 787.172l-256 93.092v-631.8l256-93.090v631.798z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map",
						"guide"
					],
					"defaultCode": 59977,
					"grid": 16
				},
				{
					"id": 1757,
					"width": 1023.9999904632568,
					"paths": [
						"M292.571 0q7.429 0 12.857 5.429t5.429 12.857v841.143q0 11.429-9.714 16l-274.286 146.286q-4 2.286-8.571 2.286-7.429 0-12.857-5.429t-5.429-12.857v-841.143q0-11.429 9.714-16l274.286-146.286q4-2.286 8.571-2.286zM1005.714 0q7.429 0 12.857 5.429t5.429 12.857v841.143q0 11.429-9.714 16l-274.286 146.286q-4 2.286-8.571 2.286-7.429 0-12.857-5.429t-5.429-12.857v-841.143q0-11.429 9.714-16l274.286-146.286q4-2.286 8.571-2.286zM365.714 0q4.571 0 8 1.714l292.571 146.286q10.286 5.714 10.286 16.571v841.143q0 7.429-5.429 12.857t-12.857 5.429q-4.571 0-8-1.714l-292.571-146.286q-10.286-5.714-10.286-16.571v-841.143q0-7.429 5.429-12.857t12.857-5.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map"
					],
					"defaultCode": 62073,
					"grid": 14
				},
				{
					"id": 147,
					"paths": [
						"M960.659 55.024c-7.549-4.664-16.971-5.088-24.907-1.122l-295.752 147.875-295.752-147.875c-7.206-3.603-15.691-3.603-22.898 0l-307.2 153.6c-8.672 4.336-14.15 13.2-14.15 22.898v768c0 8.872 4.594 17.112 12.141 21.776 4.11 2.541 8.779 3.824 13.461 3.824 3.912 0 7.834-0.898 11.446-2.702l295.752-147.875 295.752 147.875c7.206 3.603 15.693 3.603 22.899 0l307.2-153.6c8.674-4.336 14.152-13.2 14.152-22.898v-768c-0.003-8.872-4.597-17.112-12.144-21.776zM307.2 828.978l-256 128v-710.755l256-128v710.755zM358.4 118.222l256 128v710.757l-256-128v-710.757zM921.6 828.978l-256 128v-710.755l256-128v710.755z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"map",
						"guide",
						"address"
					],
					"defaultCode": 59444,
					"grid": 20
				},
				{
					"id": 631,
					"width": 1024,
					"paths": [
						"M608 0h-192c-53.024 0-96 42.976-96 96v640c0 17.664 14.336 32 32 32h10.656l46.048 138.112c4.352 13.088 16.576 21.888 30.368 21.888h8.928v39.008c0 14.688 9.984 27.488 24.224 31.040l64 16c2.624 0.672 5.248 0.96 7.84 0.96 17.152 0 31.936-13.92 31.936-32v-55.008h8.928c13.76 0 26.016-8.8 30.368-21.888l46.048-138.112h10.656c17.664 0 32-14.336 32-32v-640c0-53.024-42.976-96-96-96zM416 32h192c35.296 0 64 28.704 64 64v160h-64c-17.632 0-32 14.368-32 32v128h-128v-128c0-17.632-14.368-32-32-32h-64v-160c0-35.296 28.704-64 64-64zM544 983.008l-64-16v-39.008h64v55.008zM584.928 896h-145.856l-42.656-128h231.2l-42.688 128zM352 736v-448h64v128c0 17.632 14.368 32 32 32h128c17.632 0 32-14.368 32-32v-128h64v448h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mark",
						"edit",
						"write",
						"draw",
						"highlight"
					],
					"grid": 32
				},
				{
					"id": 632,
					"width": 1024,
					"paths": [
						"M608 288h96v448c0 17.664-14.336 32-32 32h-320c-17.664 0-32-14.336-32-32v-448h96v128c0 17.632 14.368 32 32 32h128c17.632 0 32-14.368 32-32v-128zM408.704 906.112c4.352 13.088 16.576 21.888 30.368 21.888h145.856c13.76 0 26.016-8.8 30.368-21.888l35.36-106.112h-277.344l35.392 106.112zM448 967.008c0 14.688 9.984 27.488 24.224 31.040l64 16c2.624 0.672 5.248 0.96 7.84 0.96 17.152 0 31.936-13.92 31.936-32v-23.008h-128v7.008zM608 0h-192c-53.024 0-96 42.976-96 96v160h96c17.632 0 32 14.368 32 32v128h128v-128c0-17.632 14.368-32 32-32h96v-160c0-53.024-42.976-96-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mark",
						"edit",
						"write",
						"draw",
						"highlight"
					],
					"grid": 32
				},
				{
					"id": 1848,
					"paths": [
						"M1006.476 211.262c-21.974-53.048-63.706-106.424-114.494-146.444-53.044-41.798-109.856-64.818-159.966-64.818-38.876 0-72.2 13.61-99.042 40.452l-458.97 458.964c-4.644 4.642-8.214 10.246-10.462 16.414l-160.822 425.22c-5.988 16.438-1.91 34.856 10.46 47.224l22.54 22.542c8.592 8.592 20.096 13.184 31.83 13.184 5.164 0 10.374-0.89 15.398-2.72l425.23-160.82c6.168-2.248 11.772-5.818 16.416-10.46l458.97-458.964c44.4-44.404 52.54-108.246 22.912-179.774zM479.656 767.656l-223.306-223.306 384.004-383.996 223.304 223.304-384.002 383.998z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"marker",
						"write",
						"highlight",
						"pencil"
					],
					"defaultCode": 59683,
					"grid": 16
				},
				{
					"id": 1849,
					"paths": [
						"M1006.476 211.262c-21.974-53.048-63.706-106.424-114.494-146.444-53.044-41.798-109.856-64.818-159.966-64.818-38.876 0-72.2 13.61-99.042 40.452l-458.97 458.964c-4.644 4.642-8.214 10.246-10.462 16.414l-160.822 425.22c-5.988 16.438-1.91 34.856 10.46 47.224l22.54 22.542c8.592 8.592 20.096 13.184 31.83 13.184 5.164 0 10.374-0.89 15.398-2.72l425.23-160.82c6.168-2.248 11.772-5.818 16.416-10.46l458.97-458.964c44.4-44.404 52.54-108.246 22.912-179.774zM479.656 767.656l-223.306-223.306 384.004-383.996 223.304 223.304-384.002 383.998z",
						"M552 952h472v-16h-456z",
						"M520 984h504v-16h-488z",
						"M488 1016h536v-16h-520z",
						"M616 888h408v-16h-392z",
						"M584 920h440v-16h-424z",
						"M648 856h376v-16h-360z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"marker",
						"write",
						"highlight",
						"pencil",
						"dualtone"
					],
					"defaultCode": 59684,
					"grid": 16
				},
				{
					"id": 3299,
					"width": 1536,
					"paths": [
						"M1088 448v-128h-128v-128h-128v128h-128v-128h-128v128h-128v128h128v128h-128v128h128v128h128v-128h128v128h128v-128h128v-128h-128v-128h128zM832 576h-128v-128h128v128z",
						"M557.254 109.254l-90.508-90.508-466.746 466.744v53.020l466.746 466.746 90.508-90.512-402.744-402.744z",
						"M978.746 109.254l90.508-90.508 466.746 466.744v53.020l-466.746 466.746-90.508-90.512 402.744-402.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"markup",
						"code"
					],
					"defaultCode": 61134,
					"grid": 16
				},
				{
					"id": 633,
					"width": 1024,
					"paths": [
						"M564.384 260l92.736-127.52c8.704-12 8.064-28.384-1.568-39.648l-69.984-81.632c-6.080-7.104-14.944-11.2-24.288-11.2h-98.56c-9.344 0-18.208 4.096-24.288 11.168l-69.984 81.632c-9.632 11.264-10.304 27.648-1.568 39.648l92.736 127.52c-187.232 25.632-331.616 185.76-331.616 380.032 0 212.064 171.936 384 384 384s384-171.936 384-384c0-194.272-144.384-354.4-331.616-380zM437.152 128l41.504 103.776-75.456-103.776h33.952zM620.8 128l-75.488 103.776 41.536-103.776h33.952zM552.352 128l-40.352 100.928-40.352-100.928h80.704zM473.888 96l32-64h12.224l32 64h-76.224zM616.128 96h-30.24l-32-64h7.392l54.848 64zM462.72 32h7.392l-32 64h-30.24l54.848-64zM512 992c-194.080 0-352-157.92-352-352s157.92-352 352-352 352 157.92 352 352-157.92 352-352 352zM512 320c-176.736 0-320 143.264-320 320s143.264 320 320 320 320-143.264 320-320-143.264-320-320-320zM512 928c-158.816 0-288-129.184-288-288s129.184-288 288-288 288 129.184 288 288c0 158.816-129.184 288-288 288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"marry",
						"like",
						"love",
						"marry",
						"wear",
						"commit"
					],
					"grid": 32
				},
				{
					"id": 634,
					"width": 1024,
					"paths": [
						"M512.16 19.456l38.144 76.544h-76.256l38.112-76.544zM552.352 128h-80.352l40.192 100.736 40.16-100.736zM896 640c0 212.064-171.936 384-384 384s-384-171.936-384-384c0-194.272 144.384-354.4 331.616-380l-92.736-127.52c-8.704-12-8.064-28.384 1.568-39.648l69.984-81.632c6.080-7.104 14.944-11.2 24.288-11.2h23.36l-47.808 96h-38.272c-8.832 0-16 7.168-16 16s7.168 16 16 16h37.536l49.024 122.88c2.432 6.080 8.32 10.080 14.848 10.080h21.504c6.56 0 12.448-4 14.848-10.080l49.024-122.88h37.216c8.832 0 16-7.168 16-16s-7.168-16-16-16h-37.952l-47.808-96h23.040c9.344 0 18.208 4.096 24.288 11.168l69.984 81.632c9.632 11.264 10.304 27.648 1.568 39.648l-92.736 127.52c187.232 25.632 331.616 185.76 331.616 380.032zM800 640c0-159.072-128.928-288-288-288s-288 128.928-288 288c0 159.072 128.928 288 288 288s288-128.928 288-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"marry",
						"like",
						"love",
						"marry",
						"wear",
						"commit"
					],
					"grid": 32
				},
				{
					"id": 1062,
					"width": 1024,
					"paths": [
						"M512 320c-158.816 0-288 129.184-288 288s129.184 288 288 288c158.816 0 288-129.184 288-288s-129.184-288-288-288zM512 864c-141.376 0-256-114.624-256-256s114.624-256 256-256 256 114.624 256 256-114.624 256-256 256zM619.488 206.816l48.928-96.096c4.704-9.088 4.8-19.872 0.224-29.056l-32-64c-5.44-10.816-16.512-17.664-28.64-17.664h-192c-12.128 0-23.2 6.848-28.608 17.696l-32 64c-4.576 9.152-4.512 19.968 0.224 29.056l49.792 95.84c-178.016 47.072-309.408 208.608-309.408 401.408 0 229.76 186.24 416 416 416s416-186.24 416-416c0-192.48-130.976-353.76-308.512-401.184zM512 256c21.472 0 42.88 2.24 64 5.952v0.128c163.808 30.144 288 173.376 288 345.92 0 194.4-157.6 352-352 352s-352-157.6-352-352c0-172.512 124.192-315.776 288-345.92v-0.128c21.12-3.712 42.528-5.952 64-5.952zM487.104 225.248l-50.464-97.248h150.688l-50.464 97.248c-8.256-0.512-16.448-1.248-24.864-1.248s-16.608 0.736-24.896 1.248zM435.776 64h152.448l15.744 32h-183.904l15.712-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"marry",
						"shine",
						"wed",
						"propose"
					],
					"grid": 32
				},
				{
					"id": 1676,
					"width": 877.7129821777344,
					"paths": [
						"M841.143 73.143q14.857 0 25.714 10.857t10.857 25.714v237.714q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-149.714l-218.286 218.857q72 89.143 72 205.143 0 66.857-26 127.714t-70.286 105.143-105.143 70.286-127.714 26-127.714-26-105.143-70.286-70.286-105.143-26-127.714 26-127.714 70.286-105.143 105.143-70.286 127.714-26q116 0 205.143 72l218.286-218.286h-149.143q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h237.714zM329.143 877.714q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mars"
					],
					"defaultCode": 61986,
					"grid": 14
				},
				{
					"id": 1681,
					"width": 1093.1423034667969,
					"paths": [
						"M877.714 237.714q0-8 5.143-13.143t13.143-5.143h164.571q14.857 0 25.714 10.857t10.857 25.714v164.571q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-76.571l-145.143 145.714q43.429 54.286 61.429 122.286t5.429 141.143q-17.714 104-94.857 178.286t-181.714 89.143q-120 16.571-219.714-45.714t-138-171.429q-66.857-3.429-126.286-32.857t-101.429-76-64.857-110-18.286-131.429q5.143-77.143 44.571-144t104-109.429 141.714-51.143q67.429-8 130 10.857t113.429 58.857l145.714-145.143h-76.571q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h164.571q14.857 0 25.714 10.857t10.857 25.714v164.571q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-76.571l-145.143 145.714q33.714 42.286 53.143 96.571 104 5.143 187.429 70.857l145.714-145.143h-76.571q-8 0-13.143-5.143t-5.143-13.143v-36.571zM585.143 475.429q0-11.429-2.286-33.143-92.571 14.286-154.857 85.714t-62.286 166.857q0 11.429 2.286 33.143 92.571-14.286 154.857-85.714t62.286-166.857zM73.143 475.429q0 96 63.429 168t157.714 85.143q-1.714-16.571-1.714-33.714 0-120 77.143-211.143t193.143-112.286q-30.286-68.571-93.429-110.286t-140.286-41.714q-105.714 0-180.857 75.143t-75.143 180.857zM621.714 950.857q105.714 0 180.857-75.143t75.143-180.857q0-96-63.429-168t-157.714-85.143q1.714 16.571 1.714 33.714 0 120-77.143 211.143t-193.143 112.286q30.286 68.571 93.429 110.286t140.286 41.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mars-double"
					],
					"defaultCode": 61991,
					"grid": 14
				},
				{
					"id": 1683,
					"width": 877.7140197753906,
					"paths": [
						"M841.143 73.143q14.857 0 25.714 10.857t10.857 25.714v237.714q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-149.714l-121.714 122.286 80 80q5.143 5.714 5.143 13.143t-5.143 12.571l-26.286 26.286q-5.143 5.143-12.571 5.143t-13.143-5.143l-80-80.571-44.571 45.143q72 89.143 72 205.143 0 66.857-26 127.714t-70.286 105.143-105.143 70.286-127.714 26-127.714-26-105.143-70.286-70.286-105.143-26-127.714 26-127.714 70.286-105.143 105.143-70.286 127.714-26q116 0 205.143 72l44.571-44.571-98.286-98.286q-5.143-5.714-5.143-13.143t5.143-12.571l26.286-26.286q5.143-5.143 12.571-5.143t13.143 5.143l98.286 98.286 121.714-121.714h-149.143q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h237.714zM329.143 877.714q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mars-stroke"
					],
					"defaultCode": 61993,
					"grid": 14
				},
				{
					"id": 1685,
					"width": 1088.5711059570312,
					"paths": [
						"M1086.286 522.857q10.857 10.857 10.857 25.714t-10.857 25.714l-168 168q-5.143 5.714-12.857 5.714t-12.857-5.714l-25.714-25.714q-5.714-5.143-5.714-12.857t5.714-12.857l105.714-105.714h-168v128q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-128h-75.429q-13.714 124-107.143 208.286t-219.714 84.286q-95.429 0-174.857-49.714t-121.143-134.857-30.857-182.286q8.571-76 50.286-140.286t107.429-104 142.286-46q88.571-6.857 166.857 30t128 106.286 58.857 155.143h75.429v-128q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143v128h168l-105.714-105.714q-5.714-5.143-5.714-12.857t5.714-12.857l25.714-25.714q5.143-5.714 12.857-5.714t12.857 5.714zM329.143 804.571q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mars-stroke-h"
					],
					"defaultCode": 61995,
					"grid": 14
				},
				{
					"id": 1684,
					"width": 652.5720415115356,
					"paths": [
						"M365.714 368q124 13.714 208.286 107.143t84.286 219.714q0 95.429-49.714 174.857t-134.857 121.143-182.286 30.857q-76-8.571-140.286-50.286t-104-107.429-46-142.286q-6.857-88.571 30-166.857t106.286-128 155.143-58.857v-75.429h-91.429q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h91.429v-94.286l-52.571 52.571q-5.714 5.143-13.143 5.143t-12.571-5.143l-26.286-26.286q-5.143-5.143-5.143-12.571t5.143-13.143l115.429-114.857q10.857-10.857 25.714-10.857t25.714 10.857l115.429 114.857q5.143 5.714 5.143 13.143t-5.143 12.571l-26.286 26.286q-5.143 5.143-12.571 5.143t-13.143-5.143l-52.571-52.571v94.286h91.429q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-91.429v75.429zM329.143 950.857q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mars-stroke-v"
					],
					"defaultCode": 61994,
					"grid": 14
				},
				{
					"id": 635,
					"width": 1024,
					"paths": [
						"M877.024 743.040c-10.816-28.928-28.672-54.72-50.496-76.544-30.016-30.016-81.824-81.824-117.088-117.088-24-24-37.44-56.512-37.44-90.464v-362.944c0-17.664-14.336-32-32-32h-480c-17.664 0-32 14.336-32 32v496.48c0 50.912 20.224 99.744 56.224 135.776l183.776 183.744c30.944 30.944 71.456 46.4 112 46.4s81.088-15.456 112-46.4c0 0 9.888-11.584 14.368-17.6l17.6 17.6c30.944 30.944 71.456 46.4 112 46.4 91.872 0 189.696-85.376 141.056-215.36zM260.288 759.040l-53.44-53.44c-30.208-30.208-46.848-70.4-46.848-113.12v-27.488c64.832 14.688 112 71.296 112 139.008 0 18.976-3.968 37.408-11.712 55.040zM390.624 889.376l-106.624-106.624c13.024-24.896 20-51.264 20-78.752 0-85.312-61.088-156.192-144-171.488v-436.512h32v112c0 8.832 7.168 16 16 16s16-7.168 16-16v-112h32v112c0 8.832 7.168 16 16 16s16-7.168 16-16v-112h32v112c0 8.832 7.168 16 16 16s16-7.168 16-16v-112h32v362.944c0 42.432 16.864 83.136 46.848 113.152l138.528 138.528c2.912 2.912 5.184 6.304 7.776 9.472-0.352 0-0.768-0.064-1.12-0.064-97.056 0-176 78.944-176 176 0 0.384 0.064 0.8 0.064 1.152-3.136-2.624-6.528-4.864-9.472-7.808zM569.376 889.376c-23.872 23.872-55.616 37.024-89.376 37.024-15.872 0-31.2-3.136-45.568-8.704-1.472-7.872-2.4-15.104-2.4-21.696 0-79.392 64.608-144 144-144 6.592 0 13.824 0.928 21.664 2.4 5.568 14.368 8.704 29.728 8.704 45.6 0 33.76-13.152 65.504-37.024 89.376zM646.624 889.376l-23.264-23.264c26.976-58.528 16.864-129.92-31.36-178.144l-138.528-138.528c-23.968-23.968-37.472-56.544-37.472-90.464v-362.976h32v112c0 8.832 7.168 16 16 16s16-7.168 16-16v-112h32v112c0 8.832 7.168 16 16 16s16-7.168 16-16v-112h32v112c0 8.832 7.168 16 16 16s16-7.168 16-16v-112h32v362.944c0 42.432 16.864 83.136 46.848 113.152l138.528 138.528c2.912 2.912 5.184 6.304 7.776 9.472-0.352 0-0.768-0.064-1.12-0.064-97.056 0-176 78.944-176 176 0 0.384 0.064 0.8 0.064 1.152-3.136-2.624-6.528-4.864-9.472-7.808zM825.376 889.376c-23.872 23.872-55.616 37.024-89.376 37.024-15.872 0-31.2-3.136-45.568-8.704-1.472-7.872-2.4-15.104-2.4-21.696 0-79.392 64.608-144 144-144 6.592 0 13.824 0.928 21.664 2.4 5.568 14.368 8.704 29.728 8.704 45.6 0 33.76-13.152 65.504-37.024 89.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"match",
						"wear"
					],
					"grid": 32
				},
				{
					"id": 636,
					"width": 1024,
					"paths": [
						"M272 704c0 31.552-10.496 60.512-27.744 84.256l-60-60c-36.032-36.032-56.256-84.864-56.256-135.776v-32.48c79.392 0 144 64.608 144 144zM592 688l-138.528-138.528c-23.968-24-37.472-56.576-37.472-90.496v-394.976h-64v144c0 8.832-7.168 16-16 16s-16-7.168-16-16v-144h-32v144c0 8.832-7.168 16-16 16s-16-7.168-16-16v-144h-32v144c0 8.832-7.168 16-16 16s-16-7.168-16-16v-144h-32c-17.664 0-32 14.336-32 32v432c97.216 0 176 78.784 176 176 0 40.448-13.792 77.568-36.704 107.296l100.704 100.704c30.944 30.944 71.456 46.4 112 46.4 40.384 0 80.704-15.392 111.584-46.048 18.816-21.696 31.776-46.208 31.776-46.208 26.976-58.56 16.864-129.92-31.36-178.144zM877.024 743.040c-10.816-28.928-28.672-54.72-50.496-76.544-30.016-30.016-81.824-81.824-117.088-117.088-24-24-37.44-56.512-37.44-90.464v-362.944c0-17.664-14.336-32-32-32h-32v144c0 8.832-7.168 16-16 16s-16-7.168-16-16v-144h-32v144c0 8.832-7.168 16-16 16s-16-7.168-16-16v-144h-64v394.944c0 25.632 9.984 49.76 28.128 67.872l138.528 138.528c55.872 55.872 71.072 141.952 37.792 214.144l-0.352 0.8-0.416 0.768c-0.448 0.864-9.12 16.928-22.464 35.2 30.24 27.776 68.384 42.144 106.784 42.144 91.84 0 189.664-85.376 141.024-215.36z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"match",
						"wear"
					],
					"grid": 32
				},
				{
					"id": 1456,
					"width": 1009.1450500488281,
					"paths": [
						"M997.143 441.714l-93.714 436h-190.857l101.714-475.429q7.429-32-8.571-50.286-15.429-18.857-47.429-18.857h-96.571l-116.571 544.571h-190.857l116.571-544.571h-163.429l-116.571 544.571h-190.857l116.571-544.571-87.429-186.857h729.143q57.714 0 108.286 23.143t84.286 64.857q34.286 41.714 46.286 96.286t0 111.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"maxcdn"
					],
					"defaultCode": 61750,
					"grid": 14
				},
				{
					"id": 1657,
					"width": 877.7149963378906,
					"paths": [
						"M749.143 481.143v65.143q0 13.714-7.714 21.714t-21.429 8h-115.429q-13.714 0-21.714-8t-8-21.714v-65.143q0-13.714 8-21.714t21.714-8h115.429q13.714 0 21.429 8t7.714 21.714zM469.143 612.571v-142.857q0-30.286-18.571-48.857t-48.857-18.571h-76q-38.857 0-54.857 29.714-16-29.714-54.857-29.714h-74.286q-30.286 0-48.857 18.571t-18.571 48.857v142.857q0 12.571 12 12.571h31.429q12.571 0 12.571-12.571v-131.429q0-13.714 7.714-21.714t22-8h53.714q13.714 0 21.714 8t8 21.714v131.429q0 12.571 12 12.571h30.857q12.571 0 12.571-12.571v-131.429q0-13.714 8-21.714t21.714-8h55.429q13.714 0 21.429 8t7.714 21.714v131.429q0 12.571 12.571 12.571h31.429q12 0 12-12.571zM805.714 557.714v-88q0-30.286-18.857-48.857t-49.143-18.571h-150.857q-30.286 0-49.143 18.571t-18.857 48.857v234.286q0 12 12.571 12h31.429q12 0 12-12v-102.857q17.714 24 53.714 24h109.143q30.286 0 49.143-18.571t18.857-48.857zM877.714 205.714v612.571q0 54.857-38.857 93.714t-93.714 38.857h-612.571q-54.857 0-93.714-38.857t-38.857-93.714v-612.571q0-54.857 38.857-93.714t93.714-38.857h612.571q54.857 0 93.714 38.857t38.857 93.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"meanpath"
					],
					"defaultCode": 61964,
					"grid": 14
				},
				{
					"id": 637,
					"width": 1024,
					"paths": [
						"M512 96c-247.424 0-448 200.576-448 448 0 97.728 31.392 188.032 84.576 261.568 34.080 47.136 102.656 56.576 145.088 16.832 57.12-53.568 133.824-86.4 218.336-86.4s161.216 32.832 218.336 86.4c42.432 39.776 111.008 30.304 145.088-16.832 53.184-73.536 84.576-163.84 84.576-261.568 0-247.424-200.576-448-448-448zM846.432 791.168c-22.432 30.176-66.656 33.824-94.144 8.128-64.416-60.256-150.208-95.296-240.288-95.296s-175.872 35.040-240.32 95.296c-27.488 25.696-71.68 22.048-94.144-8.128-52.608-70.752-81.536-156.736-81.536-247.168 0-229.376 186.624-416 416-416s416 186.624 416 416c0 90.432-28.928 176.416-81.568 247.168zM480 192c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM747.328 404.672c6.24 6.24 6.24 16.384 0 22.624l-204.896 204.896c0.64 2.56 1.568 5.056 1.568 7.808 0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32 2.752 0 5.248 0.928 7.808 1.568l204.896-204.896c6.24-6.24 16.352-6.24 22.624 0zM783.52 272.48c12.512 12.512 12.512 32.768 0 45.248-12.512 12.512-32.768 12.512-45.248 0-12.512-12.512-12.512-32.768 0-45.248 12.512-12.512 32.768-12.512 45.248 0zM896 544c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM192 544c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM285.728 272.48c12.512 12.512 12.512 32.768 0 45.248-12.512 12.512-32.768 12.512-45.248 0-12.512-12.512-12.512-32.768 0-45.248s32.736-12.512 45.248 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"measure",
						"drive",
						"quantify"
					],
					"grid": 32
				},
				{
					"id": 638,
					"width": 1024,
					"paths": [
						"M512 96c-247.424 0-448 200.576-448 448 0 97.728 31.392 188.032 84.576 261.568 34.080 47.136 102.656 56.576 145.088 16.832 57.12-53.568 133.824-86.4 218.336-86.4s161.216 32.832 218.336 86.4c42.432 39.776 111.008 30.304 145.088-16.832 53.184-73.536 84.576-163.84 84.576-261.568 0-247.424-200.576-448-448-448zM160 576c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM512 160c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM285.728 317.728c-12.512 12.512-32.768 12.512-45.248 0-12.512-12.512-12.512-32.768 0-45.248s32.768-12.512 45.248 0c12.48 12.48 12.48 32.736 0 45.248zM747.328 427.328l-204.896 204.896c0.64 2.528 1.568 5.024 1.568 7.776 0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32 2.752 0 5.248 0.928 7.808 1.568l204.896-204.896c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.656zM783.52 317.728c-12.512 12.512-32.768 12.512-45.248 0-12.512-12.512-12.512-32.768 0-45.248 12.512-12.512 32.768-12.512 45.248 0s12.512 32.736 0 45.248zM864 576c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"measure",
						"drive",
						"quantify"
					],
					"grid": 32
				},
				{
					"id": 1063,
					"width": 1024,
					"paths": [
						"M928 128h-896c-17.664 0-32 14.336-32 32v640c0 53.024 42.976 96 96 96h896c17.664 0 32-14.336 32-32v-640c0-53.024-42.976-96-96-96zM960 512c0 17.632-14.368 32-32 32h-768c-8.832 0-16 7.168-16 16s7.168 16 16 16h800v128c0 17.632-14.368 32-32 32h-768c-8.832 0-16 7.168-16 16s7.168 16 16 16h800v64h-864c-17.632 0-32-14.368-32-32v-128h800c8.832 0 16-7.168 16-16s-7.168-16-16-16h-768c-17.632 0-32-14.368-32-32v-128h800c8.832 0 16-7.168 16-16s-7.168-16-16-16h-32v-128h-32v128h-64v-64h-32v64h-64v-128h-32v128h-64v-64h-32v64h-64v-128h-32v128h-64v-64h-32v64h-64v-128h-32v128h-64v-64h-32v64h-64v-256h864c17.632 0 32 14.368 32 32v288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"measure",
						"quantify"
					],
					"grid": 32
				},
				{
					"id": 2485,
					"paths": [
						"M832 320c0-50.638-39.214-92.090-88.93-95.712 32.592-37.716 31.012-94.754-4.796-130.562-35.806-35.808-92.846-37.388-130.558-4.798-3.626-49.714-45.076-88.928-95.716-88.928s-92.088 39.214-95.712 88.928c-37.714-32.59-94.754-31.008-130.562 4.798-35.806 35.808-37.388 92.846-4.798 130.562-49.712 3.624-88.928 45.074-88.928 95.712s39.214 92.088 88.928 95.712c-32.59 37.714-31.008 94.754 4.798 130.56 26.588 26.588 64.878 34.288 98.274 23.154v422.574l128-128 128 128v-422.572c33.396 11.13 71.686 3.436 98.274-23.154 35.808-35.806 37.388-92.844 4.796-130.56 49.716-3.624 88.93-45.076 88.93-95.714zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192c106.040 0 192 85.96 192 192s-85.96 192-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medal",
						"badge",
						"award",
						"prize",
						"certificate"
					],
					"defaultCode": 60320,
					"grid": 16
				},
				{
					"id": 2487,
					"paths": [
						"M724.55 391.42l180.438-391.42h-221.504l-147.884 320.806c-7.802-0.516-15.666-0.806-23.6-0.806-7.932 0-15.798 0.29-23.6 0.806l-147.884-320.806h-221.504l180.436 391.42c-84.72 64.28-139.448 166.032-139.448 280.58 0 194.404 157.596 352 352 352s352-157.596 352-352c0-114.548-54.728-216.3-139.45-280.58zM724.448 64h80.544l-135.098 293.17-1.032-0.344c-21.404-10.674-44.040-19.24-67.646-25.408l123.232-267.418zM219.008 64h80.546l123.23 267.418c-23.608 6.166-46.244 14.734-67.646 25.408l-1.032 0.344-135.098-293.17zM512 928c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.616 256-256 256z",
						"M608 768h-32v-224c0-17.674-14.326-32-32-32h-64c-17.672 0-32 14.326-32 32s14.328 32 32 32h32v192h-32c-17.672 0-32 14.326-32 32s14.328 32 32 32h128c17.674 0 32-14.326 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medal-first",
						"badge",
						"award",
						"prize"
					],
					"defaultCode": 60322,
					"grid": 16
				},
				{
					"id": 2488,
					"paths": [
						"M724.55 391.42l180.438-391.42h-221.504l-147.884 320.806c-7.802-0.516-15.666-0.806-23.6-0.806-7.932 0-15.798 0.29-23.6 0.806l-147.884-320.806h-221.504l180.436 391.42c-84.72 64.28-139.448 166.032-139.448 280.58 0 194.404 157.596 352 352 352s352-157.596 352-352c0-114.548-54.728-216.3-139.45-280.58zM724.448 64h80.544l-135.098 293.17-1.032-0.344c-21.404-10.674-44.040-19.24-67.646-25.408l123.232-267.418zM219.008 64h80.546l123.23 267.418c-23.608 6.166-46.244 14.734-67.646 25.408l-1.032 0.344-135.098-293.17zM512 928c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.616 256-256 256z",
						"M608 832h-192c-17.672 0-32-14.326-32-32v-128c0-17.674 14.328-32 32-32h160v-64h-160c-17.672 0-32-14.326-32-32s14.328-32 32-32h192c17.674 0 32 14.326 32 32v128c0 17.674-14.326 32-32 32h-160v64h160c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medal-second",
						"badge",
						"award",
						"prize"
					],
					"defaultCode": 60323,
					"grid": 16
				},
				{
					"id": 2484,
					"width": 1024,
					"paths": [
						"M480 309.668l86.556 266.386h280.094l-226.6 164.638 86.552 266.386-226.602-164.634-226.602 164.634 86.554-266.386-226.602-164.638h280.096z",
						"M448 0h64v256h-64v-256z",
						"M576 0v397.714l128-109.714v-288z",
						"M384 0v397.714l-128-109.714v-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medal-star",
						"badge",
						"award",
						"prize"
					],
					"defaultCode": 60319,
					"grid": 16
				},
				{
					"id": 2489,
					"paths": [
						"M724.55 391.42l180.438-391.42h-221.504l-147.884 320.806c-7.802-0.516-15.666-0.806-23.6-0.806-7.932 0-15.798 0.29-23.6 0.806l-147.884-320.806h-221.504l180.436 391.42c-84.72 64.28-139.448 166.032-139.448 280.58 0 194.404 157.596 352 352 352s352-157.596 352-352c0-114.548-54.728-216.3-139.45-280.58zM724.448 64h80.544l-135.098 293.17-1.032-0.344c-21.404-10.674-44.040-19.24-67.646-25.408l123.232-267.418zM219.008 64h80.546l123.23 267.418c-23.608 6.166-46.244 14.734-67.646 25.408l-1.032 0.344-135.098-293.17zM512 928c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.616 256-256 256z",
						"M608 512h-192c-17.672 0-32 14.326-32 32s14.328 32 32 32h160v64h-160c-17.672 0-32 14.326-32 32s14.328 32 32 32h160v64h-160c-17.672 0-32 14.326-32 32s14.328 32 32 32h192c17.674 0 32-14.326 32-32v-256c0-17.674-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medal-third",
						"badge",
						"award",
						"prize"
					],
					"defaultCode": 60324,
					"grid": 16
				},
				{
					"id": 2486,
					"paths": [
						"M724.55 391.42l180.438-391.42h-221.504l-147.884 320.806c-7.802-0.516-15.666-0.806-23.6-0.806-7.932 0-15.798 0.29-23.6 0.806l-147.884-320.806h-221.504l180.436 391.42c-84.72 64.28-139.448 166.032-139.448 280.58 0 194.404 157.596 352 352 352s352-157.596 352-352c0-114.548-54.728-216.3-139.45-280.58zM724.448 64h80.544l-135.098 293.17-1.032-0.344c-21.404-10.674-44.040-19.24-67.646-25.408l123.232-267.418zM219.008 64h80.546l123.23 267.418c-23.608 6.166-46.244 14.734-67.646 25.408l-1.032 0.344-135.098-293.17zM512 928c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.616 256-256 256z",
						"M512 584c48.524 0 88 39.476 88 88s-39.476 88-88 88c-48.522 0-88-39.476-88-88s39.478-88 88-88zM512 512c-88.366 0-160 71.634-160 160s71.634 160 160 160 160-71.634 160-160-71.634-160-160-160v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medal",
						"badge",
						"award",
						"prize"
					],
					"defaultCode": 60321,
					"grid": 16
				},
				{
					"id": 1904,
					"paths": [
						"M1024 864c0 53.020-57.306 96-128 96-70.696 0-128-42.98-128-96s57.306-96 128-96c23.32 0 45.168 4.704 64 12.876v-186.59l-256 91.43v242.284c0 53.020-57.306 96-128 96s-128-42.98-128-96 57.306-96 128-96c23.322 0 45.168 4.704 64 12.876v-268.876l384-128v416z",
						"M288 192c-52.934 0-96 43.066-96 96s43.066 96 96 96 96-43.066 96-96-43.064-96-96-96z",
						"M544 64h-140.222l-23.156-46.31c-5.42-10.842-16.5-17.69-28.622-17.69h-128c-12.12 0-23.2 6.848-28.622 17.69l-23.154 46.31h-140.224c-17.672 0-32 14.328-32 32v384c0 17.674 14.328 32 32 32h512c17.674 0 32-14.326 32-32v-384c0-17.672-14.326-32-32-32zM288 448c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.774 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"media",
						"photo-music"
					],
					"defaultCode": 59739,
					"grid": 16
				},
				{
					"id": 639,
					"width": 1024,
					"paths": [
						"M768 0h-512c-53.024 0-96 42.976-96 96v64c0 17.664 14.336 32 32 32h32v736c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-736h32c17.664 0 32-14.336 32-32v-64c0-53.024-42.976-96-96-96zM512 640v-64h96v-96h64v96h96v64h-96v96h-64v-96h-96zM704 544v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64h64v192h-384v-512h384v192h-64zM768 320h-384c-17.664 0-32 14.336-32 32v512c0 17.664 14.336 32 32 32h384v32c0 35.36-28.64 64-64 64h-384c-35.36 0-64-28.64-64-64v-736h512v128zM832 160h-640v-64c0-35.36 28.64-64 64-64h512c35.36 0 64 28.64 64 64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medicate",
						"drug",
						"ingest"
					],
					"grid": 32
				},
				{
					"id": 640,
					"width": 1024,
					"paths": [
						"M800 896v32c0 53.024-42.976 96-96 96h-384c-53.024 0-96-42.976-96-96v-704h576v96h-416c-17.664 0-32 14.336-32 32v512c0 17.664 14.336 32 32 32h416zM576 640v96h64v-96h96v-64h-96v-96h-64v96h-96v64h96zM384 352h416v512h-416v-512zM448 640c0 17.664 14.336 32 32 32h64v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-64v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64h-64c-17.664 0-32 14.336-32 32v64zM192 192h640c17.664 0 32-14.336 32-32v-64c0-53.024-42.976-96-96-96h-512c-53.024 0-96 42.976-96 96v64c0 17.664 14.336 32 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medicate",
						"drug",
						"ingest"
					],
					"grid": 32
				},
				{
					"id": 1064,
					"width": 1024,
					"paths": [
						"M926.4 369.152l-271.552-271.552c-42.304-42.304-98.56-65.6-158.368-65.6s-116.096 23.296-158.4 65.6c-69.824 69.856-83.904 174.912-40.896 259.328-36.992 6.368-72.672 19.168-105.184 37.92-152.8 88.256-205.344 284.352-117.152 437.152 56.992 98.72 163.296 160 277.408 160 55.872 0 111.104-14.784 159.744-42.88 82.656-47.744 138.944-129.856 155.072-222.368 31.296 15.936 66.080 24.416 101.792 24.416 0 0 0 0 0.032 0 59.488 0 115.424-23.168 157.504-65.248 87.328-87.328 87.328-229.44 0-316.768zM798.048 331.328l-196.672 196.672c-6.176-10.72-13.088-20.768-20.384-30.368l191.68-191.68 25.376 25.376zM383.328 142.848c30.208-30.208 70.4-46.848 113.152-46.848s82.912 16.64 113.152 46.848l140.448 140.448-190.080 190.080c-43.008-45.088-98.656-73.952-158.080-84.48l-23.584-26.080c-57.216-63.296-55.040-159.904 4.992-219.968zM480 893.696c-38.912 22.464-83.072 34.336-127.744 34.336-91.328 0-176.384-49.056-221.984-128.064-24.192-41.92-34.848-87.872-33.888-133.056l479.488 128.48c-21.728 39.616-53.952 74.112-95.872 98.304zM589.824 766.016l-490.784-131.488c2.88-19.36 7.968-38.304 15.136-56.512l490.752 131.488c-2.88 19.328-7.936 38.304-15.104 56.512zM128.096 548.608c21.76-39.616 53.984-74.112 95.904-98.304 38.912-22.464 83.072-34.336 127.744-34.336 0.832 0 1.632 0.16 2.464 0.16l0.064 0.16 2.848 0.032c89.248 1.888 171.872 50.272 216.576 127.68 24.192 41.92 34.88 87.872 33.888 133.088l-479.488-128.48zM616.416 558.208l204.288-204.288 25.376 25.376-216.576 216.576c-3.52-12.672-7.744-25.28-13.088-37.664zM661.28 645.76l-19.136-17.28 226.56-226.56 12.448 12.448c4.384 4.384 7.84 9.408 11.648 14.176l-223.328 223.328c-2.688-2.112-5.632-3.808-8.192-6.112zM734.368 683.008c-12.992-2.848-25.376-7.552-37.216-13.504l213.344-213.344c5.952 11.84 10.784 24.16 13.6 37.152l-189.728 189.696zM881.152 640.672c-28.256 28.224-65.344 44-104.992 45.792l151.072-151.072c-1.952 39.744-17.76 76.96-46.080 105.28z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medicate",
						"drug",
						"ingest"
					],
					"grid": 32
				},
				{
					"id": 1698,
					"width": 1024.0000438690186,
					"paths": [
						"M341.143 240.571v670.286q0 14.286-7.143 24.286t-20.857 10q-9.714 0-18.857-4.571l-265.714-133.143q-12-5.714-20.286-19.143t-8.286-26.571v-651.429q0-11.429 5.714-19.429t16.571-8q8 0 25.143 8.571l292 146.286q1.714 1.714 1.714 2.857zM377.714 298.286l305.143 494.857-305.143-152v-342.857zM1024 308.571v602.286q0 14.286-8 23.143t-21.714 8.857-26.857-7.429l-252-125.714zM1022.286 240q0 1.714-146.571 239.714t-171.714 278.571l-222.857-362.286 185.143-301.143q9.714-16 29.714-16 8 0 14.857 3.429l309.143 154.286q2.286 1.143 2.286 3.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medium"
					],
					"defaultCode": 62010,
					"grid": 14
				},
				{
					"id": 1402,
					"width": 1023.9999389648438,
					"paths": [
						"M731.429 640v-109.714q0-8-5.143-13.143t-13.143-5.143h-128v-128q0-8-5.143-13.143t-13.143-5.143h-109.714q-8 0-13.143 5.143t-5.143 13.143v128h-128q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h128v128q0 8 5.143 13.143t13.143 5.143h109.714q8 0 13.143-5.143t5.143-13.143v-128h128q8 0 13.143-5.143t5.143-13.143zM365.714 219.429h292.571v-73.143h-292.571v73.143zM146.286 219.429v731.429h-18.286q-52.571 0-90.286-37.714t-37.714-90.286v-475.429q0-52.571 37.714-90.286t90.286-37.714h18.286zM822.857 219.429v731.429h-621.714v-731.429h91.429v-91.429q0-22.857 16-38.857t38.857-16h329.143q22.857 0 38.857 16t16 38.857v91.429h91.429zM1024 347.429v475.429q0 52.571-37.714 90.286t-90.286 37.714h-18.286v-731.429h18.286q52.571 0 90.286 37.714t37.714 90.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"medkit"
					],
					"defaultCode": 61690,
					"grid": 14
				},
				{
					"id": 1935,
					"paths": [
						"M128 384h-128v320h128v-64l128.018 36.578c-0.004 0.484-0.018 0.968-0.018 1.458v89.964c0 35.204 28.798 64 64 64h128c35.2 0 64-28.796 64-64v-18.286l320 91.43v-594.284l-704 201.14v-64zM320 694.86l127.856 36.53v36.61h-127.856v-73.14zM896 228.572v630.858l128 36.57v-704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"megaphone",
						"bullhorn",
						"announcement",
						"advertisement",
						"news"
					],
					"defaultCode": 59770,
					"grid": 16
				},
				{
					"id": 1430,
					"width": 877.7139282226562,
					"paths": [
						"M658.286 621.714q0 14.857-10.857 25.714t-25.714 10.857h-365.714q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h365.714q14.857 0 25.714 10.857t10.857 25.714zM365.714 365.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM658.286 365.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM804.571 512q0-74.286-29.143-142t-78-116.571-116.571-78-142-29.143-142 29.143-116.571 78-78 116.571-29.143 142 29.143 142 78 116.571 116.571 78 142 29.143 142-29.143 116.571-78 78-116.571 29.143-142zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"meh-o"
					],
					"defaultCode": 61722,
					"grid": 14
				},
				{
					"id": 641,
					"width": 1024,
					"paths": [
						"M832 336c0-44.192-35.808-80-80-80h-16v-32c0-123.712-100.288-224-224-224s-224 100.288-224 224v32h-16c-44.192 0-80 35.808-80 80 0 42.816 33.728 77.504 76.032 79.616l214.048 561.888c5.248 13.728 17.568 20.608 29.888 20.608s24.672-6.88 29.92-20.608l157.408-413.184c10.4 7.296 23.040 11.68 36.704 11.68 35.36 0 64-28.64 64-64 0-36.384-20.576-72.352-38.432-96.96 39.616-4.8 70.432-38.144 70.432-79.040zM676.352 534.72l-164.352 431.392-209.568-550.112h407.296c-17.664 24.608-37.728 60.096-37.728 96 0 8.032 1.664 15.616 4.352 22.72zM768 512c0 17.632-14.368 32-32 32s-32-14.368-32-32c0-26.528 16.32-56.192 32-78.048 15.68 21.856 32 51.52 32 78.048zM752 384h-480c-26.464 0-48-21.536-48-48s21.536-48 48-48h48v-64c0-105.856 86.144-192 192-192s192 86.144 192 192v64h48c26.464 0 48 21.536 48 48s-21.536 48-48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"melt",
						"eat",
						"lick"
					],
					"grid": 32
				},
				{
					"id": 642,
					"width": 1024,
					"paths": [
						"M761.568 415.040c0.896 1.248 1.984 2.624 2.944 3.936 16.768 24.064 35.488 58.592 35.488 93.024 0 35.296-28.704 64-64 64s-64-28.704-64-64c0-35.84 20.288-71.84 37.504-96l-441.472-0.384c-42.304-2.112-76.032-36.8-76.032-79.616 0-44.192 35.808-80 80-80h16v-32c0-123.712 100.288-224 224-224s224 100.288 224 224v32h16c44.192 0 80 35.808 80 80 0 40.896-30.816 74.24-70.432 79.040zM640 512c0-22.496 6.368-44.16 14.944-64h-374.56l201.728 529.504c5.248 13.728 17.568 20.608 29.888 20.608s24.672-6.88 29.92-20.608l145.888-382.976c-28.448-16.672-47.808-47.232-47.808-82.528z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"melt",
						"eat",
						"lick"
					],
					"grid": 32
				},
				{
					"id": 2687,
					"paths": [
						"M832 448c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM512 448c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM192 448c70.692 0 128 57.308 128 128s-57.308 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"dots",
						"more"
					],
					"defaultCode": 60522,
					"grid": 16
				},
				{
					"id": 221,
					"paths": [
						"M486.4 1024c-129.922 0-252.067-50.594-343.936-142.464s-142.464-214.014-142.464-343.936c0-129.923 50.595-252.067 142.464-343.936s214.013-142.464 343.936-142.464c129.922 0 252.067 50.595 343.936 142.464s142.464 214.014 142.464 343.936-50.594 252.067-142.464 343.936c-91.869 91.87-214.014 142.464-343.936 142.464zM486.4 102.4c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2 435.2-195.23 435.2-435.2-195.23-435.2-435.2-435.2z",
						"M742.4 409.6h-512c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h512c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M742.4 563.2h-512c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h512c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M742.4 716.8h-512c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h512c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu-circle",
						"menu"
					],
					"defaultCode": 59518,
					"grid": 20
				},
				{
					"id": 3154,
					"paths": [
						"M256 192l256 256 256-256zM768 896l-256-256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu-close",
						"arrows",
						"contract"
					],
					"defaultCode": 60989,
					"grid": 16
				},
				{
					"id": 3155,
					"paths": [
						"M256 256l256 256 256-256zM768 832l-256-256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu-close",
						"arrows",
						"contract"
					],
					"defaultCode": 60990,
					"grid": 16
				},
				{
					"id": 3152,
					"paths": [
						"M768 448l-256-256-256 256zM256 640l256 256 256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu-open",
						"arrows"
					],
					"defaultCode": 60987,
					"grid": 16
				},
				{
					"id": 3153,
					"paths": [
						"M256 256l256 256 256-256zM255.996 575.996l256 256 256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu-open",
						"arrows",
						"down"
					],
					"defaultCode": 60988,
					"grid": 16
				},
				{
					"id": 2697,
					"width": 1408,
					"paths": [
						"M0 192h896v128h-896v-128z",
						"M0 448h896v128h-896v-128z",
						"M0 704h896v128h-896v-128z",
						"M1376 576l-192-192-192 192h384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"options",
						"hamburger"
					],
					"defaultCode": 60532,
					"grid": 16
				},
				{
					"id": 208,
					"paths": [
						"M896 307.2h-768c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 563.2h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 819.2h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"options",
						"list"
					],
					"defaultCode": 59505,
					"grid": 20
				},
				{
					"id": 2689,
					"width": 1088,
					"paths": [
						"M1024 0h-960c-35.2 0-64 28.8-64 64v192c0 35.2 28.8 64 64 64h128v640c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64v-896c0-35.2-28.8-64-64-64zM960 896h-640v-128h640v128zM960 704h-640v-128h640v128zM960 512h-640v-128h640v128zM832 320l-160-192h320l-160 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"list",
						"options"
					],
					"defaultCode": 60524,
					"grid": 16
				},
				{
					"id": 2690,
					"paths": [
						"M64 192h896v192h-896zM64 448h896v192h-896zM64 704h896v192h-896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"list",
						"options",
						"lines",
						"hamburger"
					],
					"defaultCode": 60525,
					"grid": 16
				},
				{
					"id": 2691,
					"width": 1408,
					"paths": [
						"M0 192h896v192h-896v-192zM0 448h896v192h-896v-192zM0 704h896v192h-896v-192z",
						"M992 576l192 192 192-192z",
						"M1376 512l-192-192-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"options",
						"hamburger"
					],
					"defaultCode": 60526,
					"grid": 16
				},
				{
					"id": 2692,
					"width": 1408,
					"paths": [
						"M0 192h896v192h-896v-192zM0 448h896v192h-896v-192zM0 704h896v192h-896v-192z",
						"M992 448l192 192 192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"options",
						"hamburger"
					],
					"defaultCode": 60527,
					"grid": 16
				},
				{
					"id": 2693,
					"width": 1408,
					"paths": [
						"M0 192h896v192h-896v-192zM0 448h896v192h-896v-192zM0 704h896v192h-896v-192z",
						"M992 640l192-192 192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"options",
						"hamburger"
					],
					"defaultCode": 60528,
					"grid": 16
				},
				{
					"id": 2694,
					"paths": [
						"M64 192h896v128h-896v-128z",
						"M64 448h896v128h-896v-128z",
						"M64 704h896v128h-896v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"list",
						"options",
						"lines",
						"hamburger"
					],
					"defaultCode": 60529,
					"grid": 16
				},
				{
					"id": 2695,
					"width": 1408,
					"paths": [
						"M0 192h896v128h-896v-128z",
						"M0 448h896v128h-896v-128z",
						"M0 704h896v128h-896v-128z",
						"M992 576l192 192 192-192h-384z",
						"M1376 448l-192-192-192 192h384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"options",
						"hamburger"
					],
					"defaultCode": 60530,
					"grid": 16
				},
				{
					"id": 2696,
					"width": 1408,
					"paths": [
						"M0 192h896v128h-896v-128z",
						"M0 448h896v128h-896v-128z",
						"M0 704h896v128h-896v-128z",
						"M992 448l192 192 192-192h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"menu",
						"options",
						"hamburger"
					],
					"defaultCode": 60531,
					"grid": 16
				},
				{
					"id": 1677,
					"width": 658.2860565185547,
					"paths": [
						"M474.286 180.571q82.857 41.143 133.429 120.286t50.571 174.571q0 126.286-84.286 219.714t-208.286 107.143v75.429h54.857q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857v54.857q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-54.857h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h54.857v-75.429q-124-13.714-208.286-107.143t-84.286-219.714q0-95.429 50.571-174.571t133.429-120.286q-94.286-54.857-130.286-156-3.429-9.143 2-16.857t15.143-7.714h39.429q12 0 16.571 11.429 25.143 60.571 80 97.714t122.286 37.143 122.286-37.143 80-97.714q4.571-11.429 21.143-11.429h34.857q9.714 0 15.143 7.714t2 16.857q-36 101.143-130.286 156zM329.143 731.429q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mercury"
					],
					"defaultCode": 61987,
					"grid": 14
				},
				{
					"id": 3017,
					"paths": [
						"M576 320h224l-288-288-288 288h224v229.49l-381.254 381.256 90.51 90.508 418.744-418.744z",
						"M546.737 765.265l90.507-90.507 255.997 255.997-90.507 90.507-255.997-255.997z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"merge",
						"arrows"
					],
					"defaultCode": 60852,
					"grid": 16
				},
				{
					"id": 643,
					"width": 1024,
					"paths": [
						"M736 32v117.952c0 42.432-16.864 83.136-46.88 113.152l-170.016 170.016c-2.496 2.496-4.768 5.184-7.072 7.808-2.4-2.56-4.576-5.312-7.072-7.808l-170.080-170.048c-30.016-29.952-46.88-70.624-46.88-113.056v-118.016c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v118.080c0 93.312 37.088 182.784 103.072 248.768l170.048 170.016c30.016 30.016 46.88 70.72 46.88 113.152v149.984h-18.752c-28.512 0-42.784 34.464-22.624 54.624l114.752 114.752c12.512 12.512 32.768 12.512 45.248 0l114.752-114.752c20.16-20.16 5.888-54.624-22.624-54.624h-18.752v-149.952c0-42.432 16.864-83.136 46.88-113.152l170.016-170.016c66.016-66.016 103.104-155.52 103.104-248.864v-118.016c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32zM626.752 864l-114.752 114.752-114.752-114.752h50.752v-181.984c0-51.264-19.968-99.488-56.224-135.744l-170.080-170.048c-60.416-60.448-93.696-140.8-93.696-226.24v-117.984h128v117.984c0 51.264 19.968 99.488 56.224 135.744l170.080 170.048c60.416 60.448 93.696 140.8 93.696 226.24v181.984h50.752zM896 149.984c0 85.472-33.28 165.824-93.728 226.272l-170.048 170.016c-14.656 14.656-26.208 31.456-35.296 49.408-11.904-47.328-33.44-91.584-63.904-130.4 2.816-3.232 5.6-6.496 8.64-9.536l170.048-170.016c36.32-36.256 56.288-84.48 56.288-135.744v-117.984h128v117.984z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"merge",
						"combine",
						"flow"
					],
					"grid": 32
				},
				{
					"id": 644,
					"width": 1024,
					"paths": [
						"M649.376 886.624l-114.752 114.752c-12.512 12.512-32.768 12.512-45.248 0l-114.752-114.752c-20.16-20.16-5.888-54.624 22.624-54.624h18.752v-149.984c0-42.432-16.864-83.168-46.88-113.152l-170.048-170.016c-65.984-65.952-103.072-155.456-103.072-248.768v-118.080c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32v118.016c0 42.4 16.864 83.072 46.848 113.056l170.080 170.048c2.496 2.496 4.672 5.248 7.072 7.808 0 0 0.032-0.032 0.032-0.032 61.376 65.184 95.968 151.232 95.968 241.024v150.080h18.752c28.512 0 42.784 34.464 22.624 54.624zM896 0h-128c-17.664 0-32 14.336-32 32v117.952c0 42.432-16.864 83.136-46.88 113.152l-154.784 154.784c48.96 51.584 82.080 114.272 96.768 182.464 6.72-11.264 14.336-22.016 23.776-31.456l170.016-170.016c66.016-66.016 103.104-155.52 103.104-248.864v-118.016c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"merge",
						"combine",
						"flow"
					],
					"grid": 32
				},
				{
					"id": 2547,
					"paths": [
						"M512 64c282.77 0 512 229.23 512 512 0 192.792-106.576 360.666-264.008 448h-495.984c-157.432-87.334-264.008-255.208-264.008-448 0-282.77 229.23-512 512-512zM801.914 865.914c77.438-77.44 120.086-180.398 120.086-289.914h-90v-64h85.038c-7.014-44.998-21.39-88.146-42.564-128h-106.474v-64h64.284c-9.438-11.762-19.552-23.096-30.37-33.914-46.222-46.22-101.54-80.038-161.914-99.798v69.712h-64v-85.040c-20.982-3.268-42.36-4.96-64-4.96s-43.018 1.69-64 4.96v85.040h-64v-69.712c-60.372 19.76-115.692 53.576-161.914 99.798-10.818 10.818-20.932 22.152-30.37 33.914h64.284v64h-106.476c-21.174 39.854-35.552 83.002-42.564 128h85.040v64h-90c0 109.516 42.648 212.474 120.086 289.914 10.71 10.71 21.924 20.728 33.56 30.086h192.354l36.572-512h54.856l36.572 512h192.354c11.636-9.358 22.852-19.378 33.56-30.086z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"meter",
						"gauge",
						"dashboard",
						"speedometer",
						"performance"
					],
					"defaultCode": 60382,
					"grid": 16
				},
				{
					"id": 2551,
					"paths": [
						"M512 256c-282.77 0-512 229.228-512 512h64c0-212.078 171.922-384 384-384 112.818 0 214.272 48.652 284.526 126.122l-173.528 138.824c-14.554-5.752-30.398-8.946-46.998-8.946-70.692 0-128 57.306-128 128s57.308 128 128 128c70.694 0 128-57.306 128-128 0-16.602-3.196-32.446-8.946-47.002l134.804-168.506c41.748 61.446 66.142 135.626 66.142 215.508h192c0-282.772-229.23-512-512-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"meter-fast",
						"gauge",
						"dashboard",
						"speedometer",
						"performance"
					],
					"defaultCode": 60386,
					"grid": 16
				},
				{
					"id": 2550,
					"paths": [
						"M512 256c-282.77 0-512 229.228-512 512h64c0-212.078 171.922-384 384-384 9.6 0 19.108 0.386 28.532 1.080l-28.532 272.048h0.066c-38.284 22.126-64.066 63.476-64.066 110.872 0 70.694 57.308 128 128 128 70.694 0 128-57.306 128-128 0-47.396-25.782-88.746-64.064-110.872h0.066l-27.244-259.76c163.2 44.262 283.242 193.422 283.242 370.632h192c0-282.772-229.23-512-512-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"meter-medium",
						"gauge",
						"dashboard",
						"speedometer",
						"performance"
					],
					"defaultCode": 60385,
					"grid": 16
				},
				{
					"id": 2549,
					"paths": [
						"M512 256c-282.77 0-512 229.228-512 512h64c0-116.418 51.806-220.726 133.622-291.148l195.322 244.15c-5.75 14.554-8.944 30.398-8.944 46.998 0 70.694 57.308 128 128 128 70.694 0 128-57.306 128-128s-57.306-128-128-128c-16.6 0-32.444 3.194-46.998 8.946l-241.044-192.84c63.056-45.376 140.426-72.108 224.042-72.108 212.076 0 384 171.92 384 383.998h192c0-282.768-229.23-511.996-512-511.996z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"meter-slow",
						"gauge",
						"dashboard",
						"speedometer",
						"performance"
					],
					"defaultCode": 60384,
					"grid": 16
				},
				{
					"id": 2548,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM302.836 834.152c11.106-30.632 17.164-63.688 17.164-98.152 0-124.35-78.81-230.292-189.208-270.606 10.21-84.924 48.254-163.498 109.678-224.924 72.53-72.526 168.96-112.47 271.53-112.47s199 39.944 271.53 112.47c61.428 61.426 99.468 140 109.682 224.924-110.402 40.314-189.212 146.256-189.212 270.606 0 34.468 6.060 67.52 17.166 98.15-61.706 40.242-133.77 61.85-209.166 61.85-75.394 0-147.458-21.608-209.164-61.848zM551.754 640.996c13.878 3.494 24.246 16.080 24.246 31.004v64c0 17.6-14.4 32-32 32h-64c-17.6 0-32-14.4-32-32v-64c0-14.924 10.368-27.51 24.246-31.004l23.754-448.996h32l23.754 448.996z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"meter",
						"gauge",
						"dashboard",
						"speedometer",
						"performance"
					],
					"defaultCode": 60383,
					"grid": 16
				},
				{
					"id": 2552,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384 384 171.922 384 384-171.922 384-384 384zM448 256c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64zM640 320c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64zM256 320c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64z",
						"M528 384h-32l-48 320v64c0 35.346 28.654 64 64 64s64-28.654 64-64v-64l-48-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"meter",
						"gauge",
						"dashboard",
						"speedometer",
						"performance"
					],
					"defaultCode": 60387,
					"grid": 16
				},
				{
					"id": 1950,
					"paths": [
						"M480 704c88.366 0 160-71.634 160-160v-384c0-88.366-71.634-160-160-160s-160 71.634-160 160v384c0 88.366 71.636 160 160 160zM704 448v96c0 123.71-100.29 224-224 224-123.712 0-224-100.29-224-224v-96h-64v96c0 148.238 112.004 270.3 256 286.22v129.78h-128v64h320v-64h-128v-129.78c143.994-15.92 256-137.982 256-286.22v-96h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mic",
						"microphone",
						"voice",
						"audio"
					],
					"defaultCode": 59785,
					"grid": 16
				},
				{
					"id": 1951,
					"paths": [
						"M640 160c0-88.366-71.632-160-160-160-88.366 0-160 71.634-160 160v344.236l320-320v-24.236zM257.174 567.062c-0.774-7.582-1.174-15.274-1.174-23.062v-96h-64v96c0 26.9 3.706 52.934 10.604 77.632l54.57-54.57zM704 544c0 123.71-100.29 224-224 224-66.626 0-126.43-29.114-167.458-75.288l45.38-45.38c29.336 34.648 73.118 56.668 122.078 56.668 88.368 0 160-71.632 160-160v-178.746l256.626-256.628-45.254-45.254-211.372 211.372-638 640.63 45.254 45.254 219.972-222.6c45.908 50.31 109.398 84.302 180.774 92.194v129.778h-128v64h320v-64h-128v-129.78c143.994-15.92 256-137.982 256-286.22v-96h-64v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mic-off",
						"microphone",
						"mute",
						"audio"
					],
					"defaultCode": 59786,
					"grid": 16
				},
				{
					"id": 1953,
					"paths": [
						"M687.032 112.968c-30.126-66.616-97.166-112.968-175.032-112.968-106.040 0-192 85.96-192 192v256c0 10.106 0.786 20.026 2.29 29.71l364.742-364.742z",
						"M244.714 555.286c-13.348-33.178-20.714-69.386-20.714-107.286 0-4.692 0.114-9.438 0.336-14.106 1.27-26.48-19.166-48.974-45.644-50.246-26.46-1.26-48.974 19.166-50.244 45.646-0.298 6.194-0.448 12.488-0.448 18.706 0 64.782 16.124 125.86 44.548 179.452l72.166-72.166z",
						"M845.292 383.556c-26.478 1.278-46.908 23.778-45.63 50.256 0.224 4.688 0.34 9.46 0.34 14.186 0 158.894-129.196 288.166-288 288.166-54.89 0-106.236-15.454-149.934-42.23l70.916-70.916c24.1 10.9 50.848 16.98 79.020 16.98 106.040 0 192-85.96 192-192v-96l287.996-287.998-64-64-928 928 64 64 228.79-228.79c45.548 31.794 98.266 53.992 155.21 63.59v133.2c0 35.346 28.654 64 64 64s64-28.654 64-64v-133.2c181.378-30.574 320-188.784 320-378.8 0-6.26-0.152-12.59-0.454-18.812-1.276-26.478-23.746-46.918-50.254-45.632z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mic-off",
						"microphone",
						"mute",
						"audio"
					],
					"defaultCode": 59788,
					"grid": 16
				},
				{
					"id": 1952,
					"paths": [
						"M896 448c0-6.26-0.152-12.59-0.454-18.812-1.278-26.478-23.746-46.918-50.256-45.632-26.478 1.278-46.908 23.778-45.63 50.256 0.224 4.688 0.34 9.46 0.34 14.186 0 158.894-129.196 288.166-288 288.166s-288-129.272-288-288.166c0-4.692 0.114-9.438 0.336-14.106 1.27-26.48-19.166-48.974-45.644-50.246-26.46-1.26-48.974 19.166-50.244 45.646-0.298 6.196-0.448 12.49-0.448 18.708 0 190.018 138.622 348.226 320 378.8v133.2c0 35.346 28.654 64 64 64s64-28.654 64-64v-133.2c181.378-30.574 320-188.782 320-378.8z",
						"M512 0c-106.040 0-192 85.96-192 192v256c0 106.040 85.96 192 192 192s192-85.96 192-192v-256c0-106.040-85.96-192-192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mic",
						"microphone",
						"voice",
						"audio"
					],
					"defaultCode": 59787,
					"grid": 16
				},
				{
					"id": 1954,
					"paths": [
						"M896 448c0-6.26-0.152-12.59-0.454-18.812-1.278-26.478-23.746-46.918-50.256-45.632-26.478 1.278-46.908 23.778-45.63 50.256 0.224 4.688 0.34 9.46 0.34 14.186 0 158.894-129.196 288.166-288 288.166s-288-129.272-288-288.166c0-4.692 0.114-9.438 0.336-14.106 1.27-26.48-19.166-48.974-45.644-50.246-26.46-1.26-48.974 19.166-50.244 45.646-0.298 6.196-0.448 12.49-0.448 18.708 0 190.018 138.622 348.226 320 378.8v133.2c0 35.346 28.654 64 64 64s64-28.654 64-64v-133.2c181.378-30.574 320-188.782 320-378.8z",
						"M512 96c52.936 0 96 43.066 96 96v256c0 52.934-43.064 96-96 96-52.934 0-96-43.066-96-96v-256c0-52.934 43.066-96 96-96zM512 0c-106.040 0-192 85.96-192 192v256c0 106.040 85.96 192 192 192s192-85.96 192-192v-256c0-106.040-85.96-192-192-192v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mic",
						"microphone",
						"voice",
						"audio"
					],
					"defaultCode": 59789,
					"grid": 16
				},
				{
					"id": 1955,
					"paths": [
						"M256 576c0 70.4 57.6 128 128 128h256c70.4 0 128-57.6 128-128v-192h-512v192z",
						"M928 320h-128c-17.674 0-32 14.328-32 32s14.326 32 32 32h32v192c0 105.87-86.13 192-192 192h-256c-105.87 0-192-86.13-192-192v-192h32c17.672 0 32-14.328 32-32s-14.328-32-32-32h-128c-17.672 0-32 14.328-32 32s14.328 32 32 32h32v192c0 141.158 114.84 256 256 256h64v128h-96c-17.672 0-32 14.326-32 32s14.328 32 32 32h320c17.674 0 32-14.326 32-32s-14.326-32-32-32h-96v-128h64c141.158 0 256-114.842 256-256v-192h32c17.674 0 32-14.328 32-32s-14.326-32-32-32z",
						"M640 0h-256c-70.4 0-128 57.6-128 128v192h512v-192c0-70.4-57.6-128-128-128zM352 240c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM352 176c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM352 112c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM416 240c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM416 176c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM416 112c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM480 240c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM480 176c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM480 112c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM544 240c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM544 176c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM544 112c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM608 240c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM608 176c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM608 112c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM672 240c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM672 176c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16zM672 112c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mic",
						"microphone",
						"voice",
						"audio"
					],
					"defaultCode": 59790,
					"grid": 16
				},
				{
					"id": 1956,
					"paths": [
						"M458.106 336.092l-458.106 559.908c0 64 64 128 128 128l559.906-458.11c-112.37-28.956-200.84-117.426-229.8-229.798z",
						"M582.964 79.096c-43.96 45.966-70.964 108.28-70.964 176.904 0 141.384 114.616 256 256 256 68.624 0 130.938-27.004 176.902-70.962-184.020-32.784-329.16-177.918-361.938-361.942z",
						"M768 0c-46.030 0-89.212 12.156-126.538 33.42 15.988 185.408 163.708 333.128 349.116 349.116 21.266-37.322 33.42-80.508 33.42-126.536 0-141.384-114.612-256-255.998-256zM864 64c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM736 128c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32zM800 192c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32zM864 256c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32zM928 320c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32zM928 192c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mic",
						"microphone",
						"voice",
						"audio",
						"interview"
					],
					"defaultCode": 59791,
					"grid": 16
				},
				{
					"id": 189,
					"paths": [
						"M486.4 716.8c-98.811 0-179.2-80.389-179.2-179.2v-307.2c0-98.811 80.389-179.2 179.2-179.2s179.2 80.389 179.2 179.2v307.2c0 98.811-80.389 179.2-179.2 179.2zM486.4 102.4c-70.579 0-128 57.421-128 128v307.2c0 70.579 57.421 128 128 128s128-57.421 128-128v-307.2c0-70.579-57.421-128-128-128z",
						"M819.2 537.6c0-14.139-11.461-25.6-25.6-25.6s-25.6 11.461-25.6 25.6c0 155.275-126.325 281.6-281.6 281.6s-281.6-126.325-281.6-281.6c0-14.139-11.462-25.6-25.6-25.6s-25.6 11.461-25.6 25.6c0 174.894 135.608 318.71 307.2 331.826v103.374h-76.8c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h204.8c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-76.8v-103.374c171.59-13.115 307.2-156.931 307.2-331.826z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mic",
						"voice",
						"record"
					],
					"defaultCode": 59486,
					"grid": 20
				},
				{
					"id": 1450,
					"width": 658.2860565185547,
					"paths": [
						"M658.286 402.286v73.143q0 126.286-84.286 219.714t-208.286 107.143v75.429h146.286q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714-25.714 10.857h-365.714q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h146.286v-75.429q-124-13.714-208.286-107.143t-84.286-219.714v-73.143q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857 10.857 25.714v73.143q0 105.714 75.143 180.857t180.857 75.143 180.857-75.143 75.143-180.857v-73.143q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857 10.857 25.714zM512 182.857v292.571q0 75.429-53.714 129.143t-129.143 53.714-129.143-53.714-53.714-129.143v-292.571q0-75.429 53.714-129.143t129.143-53.714 129.143 53.714 53.714 129.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"microphone"
					],
					"defaultCode": 61744,
					"grid": 14
				},
				{
					"id": 1451,
					"width": 804.5699787139893,
					"paths": [
						"M154.857 540l-57.714 57.714q-24-58.857-24-122.286v-73.143q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857 10.857 25.714v73.143q0 30.286 8.571 64.571zM791.429 196l-206.286 206.286v73.143q0 75.429-53.714 129.143t-129.143 53.714q-31.429 0-62.286-10.857l-54.857 54.857q55.429 29.143 117.143 29.143 105.714 0 180.857-75.143t75.143-180.857v-73.143q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857 10.857 25.714v73.143q0 126.286-84.286 219.714t-208.286 107.143v75.429h146.286q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714-25.714 10.857h-365.714q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h146.286v-75.429q-71.429-7.429-134.286-46.286l-145.143 145.143q-5.714 5.714-13.143 5.714t-13.143-5.714l-46.857-46.857q-5.714-5.714-5.714-13.143t5.714-13.143l705.143-705.143q5.714-5.714 13.143-5.714t13.143 5.714l46.857 46.857q5.714 5.714 5.714 13.143t-5.714 13.143zM574.286 120.571l-354.857 354.857v-292.571q0-75.429 53.714-129.143t129.143-53.714q58.286 0 105.429 33.714t66.571 86.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"microphone-slash"
					],
					"defaultCode": 61745,
					"grid": 14
				},
				{
					"id": 2370,
					"paths": [
						"M512 928c-51.886 0-101.57-9.576-147.414-27.008-27.83 33.316-44.586 76.204-44.586 123.008h384c0-46.804-16.756-89.692-44.586-123.008-45.844 17.432-95.526 27.008-147.414 27.008zM640 576v128h86.656c-3.554 3.962-7.216 7.854-11.010 11.646-54.394 54.396-126.718 84.354-203.646 84.354s-149.25-29.958-203.646-84.354c-54.396-54.394-84.354-126.718-84.354-203.646 0-72.652 28.7-143.124 77.542-196.388l235.166 182.906 78.586-101.038-511.050-397.48-104.244 81.080 225.588 175.458c-59.522 67.67-97.588 158.316-97.588 255.462 0 212.078 171.922 384 384 384 142.132 0 266.218-77.224 332.616-192h179.384v-128h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"microscope",
						"research",
						"lab"
					],
					"defaultCode": 60205,
					"grid": 16
				},
				{
					"id": 2524,
					"paths": [
						"M896 416.098v-0.098h-0.004c0.006-6.11-1.728-12.286-5.372-17.75l-122.624-183.938v-182.312c0-17.672-14.326-32-32-32h-512c-17.672 0-32 14.328-32 32v182.31l-122.506 183.76c-0.020 0.030-0.040 0.060-0.060 0.088l-0.060 0.090 0.002 0.004c-3.392 5.082-5.376 11.182-5.376 17.748v576c0 17.674 14.328 32 32 32h768c17.674 0 32-14.326 32-32v-575.778c0-0.042 0-0.082 0-0.124zM256 64h448v128h-448v-128zM241.126 256h435.082l-85.332 128h-435.082l85.332-128zM128 448h448v512h-448v-512zM640 960v-534.312l96-144 96 144v534.312h-192z",
						"M256 576h192v256h-192v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"milk",
						"drink",
						"food",
						"breakfast"
					],
					"defaultCode": 60359,
					"grid": 16
				},
				{
					"id": 645,
					"width": 1024,
					"paths": [
						"M528 368c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM528 464c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM886.688 635.744l-134.912-116.928-16.32-89.696c-2.88-15.904-10.432-33.664-20.544-52.064l171.744-148.832c14.048-12.16 14.816-33.664 1.664-46.816l-109.76-109.792c-13.12-13.12-34.656-12.352-46.816 1.664l-134.048 154.688c-18.464-19.2-35.328-35.68-47.84-47.616-12.32-11.712-31.456-11.712-43.744 0-12.512 11.936-29.376 28.416-47.84 47.616l-134.048-154.656c-12.16-14.048-33.664-14.816-46.816-1.664l-109.792 109.792c-13.12 13.12-12.352 34.656 1.664 46.816l171.744 148.864c-10.080 18.432-17.632 36.16-20.544 52.064l-16.32 89.696-134.912 116.928c-14.048 12.16-14.816 33.664-1.664 46.816l90.368 90.368-20.288 111.584c-7.104 39.264 23.104 75.424 63.008 75.424h454.624c39.936 0 70.112-36.16 62.976-75.456l-20.288-111.616 90.368-90.368c13.152-13.12 12.384-34.624-1.664-46.816zM528 203.52c14.24 13.504 31.168 30.24 48.768 48.64l-48.768 56.256-48.768-56.256c17.6-18.368 34.528-35.136 48.768-48.64zM544 928h-64v-128h64v128zM755.328 928h-179.328v-128c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v128h-147.328c-19.968 0-35.040-18.080-31.456-37.728l16.832-92.288c12.672 6.272 28.384 4.032 38.208-7.264l203.776-235.104 203.776 235.104c9.824 11.328 25.568 13.568 38.24 7.232l16.8 92.32c3.52 19.648-11.584 37.728-31.52 37.728zM755.936 769.728l-227.936-263.008-227.936 263.008-109.792-109.792 263.008-227.936-263.008-227.936 109.792-109.792 227.936 263.008 227.936-263.008 109.792 109.792-263.008 227.936 263.008 227.936-109.792 109.792zM342.816 485.408l9.184-50.528c1.984-10.944 6.944-23.36 13.632-36.48l38.784 33.6-61.6 53.408zM713.184 485.376l-61.6-53.376 38.784-33.6c6.688 13.12 11.648 25.536 13.632 36.512l9.184 50.464z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mill",
						"spin",
						"energize"
					],
					"grid": 32
				},
				{
					"id": 646,
					"width": 1024,
					"paths": [
						"M300.064 801.728c0.384 0 0.768 0 1.152-0.032 8.864-0.32 17.216-4.32 23.040-11.008l203.776-235.104 203.776 235.104c5.824 6.72 14.176 10.72 23.040 11.008 0.384 0 0.768 0.032 1.152 0.032 8.48 0 16.608-3.36 22.624-9.376l109.792-109.792c6.272-6.272 9.664-14.88 9.344-23.776s-4.32-17.216-11.008-23.040l-235.168-203.744 235.104-203.776c6.72-5.824 10.72-14.176 11.008-23.040s-3.072-17.472-9.344-23.776l-109.792-109.792c-6.016-6.016-14.144-9.376-22.624-9.376-0.384 0-0.768 0-1.152 0.032-8.864 0.32-17.216 4.32-23.040 11.008l-203.744 235.136-203.776-235.104c-5.824-6.72-14.144-10.72-23.040-11.040-0.384 0-0.768-0.032-1.152-0.032-8.48 0-16.608 3.36-22.624 9.376l-109.76 109.824c-6.304 6.272-9.696 14.88-9.376 23.744s4.32 17.216 11.008 23.040l235.104 203.776-235.104 203.776c-6.72 5.824-10.72 14.176-11.008 23.040s3.072 17.472 9.344 23.776l109.792 109.792c6.048 5.984 14.176 9.344 22.656 9.344zM528 368c35.36 0 64 28.64 64 64s-28.64 64-64 64c-35.36 0-64-28.64-64-64s28.64-64 64-64zM496 432c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM313.344 468.576l7.168-39.424c1.248-6.944 3.648-14.336 6.528-21.888l28.544 24.736-42.24 36.576zM700.448 432l28.512-24.704c2.848 7.552 5.248 14.944 6.528 21.888l7.168 39.424-42.208-36.608zM818.272 884.544c7.168 39.296-23.040 75.456-62.944 75.456h-179.328v-160c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v160h-147.328c-39.936 0-70.112-36.16-62.976-75.456l13.344-73.312 3.744 3.744c12.096 12.096 28.16 18.752 45.248 18.752h0.576l1.728-0.032c17.664-0.64 34.464-8.672 46.080-22.048l179.584-207.2 179.584 207.2c11.584 13.376 28.384 21.408 46.080 22.048l0.576 0.032 1.728 0.032c17.088 0 33.152-6.656 45.248-18.752l3.744-3.744 13.312 73.28zM480.832 205.12c9.408-9.376 18.208-17.984 25.312-24.768 12.288-11.712 31.456-11.712 43.744 0 7.104 6.784 15.904 15.36 25.312 24.736l-47.2 54.464-47.168-54.432zM480 800h64v160h-64v-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mill",
						"spin",
						"energize"
					],
					"grid": 32
				},
				{
					"id": 647,
					"width": 1024,
					"paths": [
						"M978.752 850.752l-402.752-402.752 9.376-9.376c12.512-12.512 12.512-32.768 0-45.248l-18.752-18.752c-12.512-12.512-12.512-32.768 0-45.248l210.752-210.752c12.512-12.512 12.512-32.768 0-45.248l-20.384-20.384c-18.496-18.496-43.104-28.128-67.904-28.128-16.96 0-34.016 4.48-49.344 13.696l-255.744 153.44-96-96-58.464-19.488c-6.656-2.208-13.472-3.296-20.256-3.296-16.704 0-33.056 6.56-45.248 18.752l-72.064 72.064c-17.152 17.152-23.136 42.496-15.456 65.504l19.488 58.464 96 96-153.44 255.712c-22.656 37.76-16.704 86.112 14.432 117.28l20.384 20.384c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l210.752-210.752c6.24-6.24 14.432-9.376 22.624-9.376s16.384 3.136 22.624 9.376l18.752 18.752c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l9.376-9.376 402.752 402.752c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l37.504-37.504c24.992-24.992 24.992-65.504 0-90.496zM114.592 186.656l72.064-72.064c6.048-6.048 14.080-9.376 22.624-9.376 3.424 0 6.848 0.544 10.112 1.632l26.336 8.768-130.080 130.112-8.768-26.336c-3.872-11.552-0.896-24.096 7.712-32.736zM415.872 562.624l-18.624-18.624c-12.096-12.096-28.16-18.752-45.248-18.752s-33.152 6.656-45.248 18.752l-210.752 210.752-20.384-20.384c-20.8-20.8-24.768-52.96-9.632-78.176l166.304-277.152-102.336-102.368 146.752-146.752 102.368 102.368 277.152-166.304c9.952-5.984 21.312-9.12 32.896-9.12 17.12 0 33.216 6.656 45.28 18.752l20.352 20.384-210.752 210.752c-24.96 24.96-24.96 65.568 0 90.496l18.624 18.624-146.752 146.752zM956.128 918.624l-37.504 37.504c-6.048 6.048-14.080 9.376-22.624 9.376s-16.576-3.328-22.624-9.376l-402.88-402.88 82.752-82.752 402.88 402.88c12.48 12.48 12.48 32.768 0 45.248z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mine",
						"dig",
						"hack"
					],
					"grid": 32
				},
				{
					"id": 648,
					"width": 1024,
					"paths": [
						"M374.624 566.624c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-210.752 210.752c-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376l-20.384-20.384c-31.136-31.136-37.088-79.488-14.432-117.28l153.44-255.712-96-96-19.488-58.464c-7.68-23.008-1.664-48.352 15.456-65.504l72.064-72.064c12.192-12.192 28.544-18.752 45.248-18.752 6.784 0 13.6 1.088 20.224 3.296l58.496 19.488 96 96 255.712-153.44c15.328-9.184 32.416-13.696 49.344-13.696 24.832 0 49.408 9.6 67.904 28.128l20.384 20.384c12.512 12.512 12.512 32.768 0 45.248l-210.752 210.752c-12.512 12.512-12.512 32.768 0 45.248l18.752 18.752c12.256 12.256 12.32 31.904 0.544 44.448l-148.096 148.096c-6.112 5.76-13.92 8.832-21.792 8.832-8.192 0-16.384-3.136-22.624-9.376l-18.752-18.752zM978.752 850.752l-380.128-380.128-128 128 380.128 380.128c12.512 12.512 28.864 18.752 45.248 18.752s32.768-6.24 45.248-18.752l37.504-37.504c24.992-24.992 24.992-65.504 0-90.496z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mine",
						"dig",
						"hack"
					],
					"grid": 32
				},
				{
					"id": 2927,
					"paths": [
						"M0 320h1024v384h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"minus",
						"subtract",
						"minimize",
						"line"
					],
					"defaultCode": 60762,
					"grid": 16
				},
				{
					"id": 2933,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM256 448h512v128h-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"minus-circle",
						"remove",
						"subtract"
					],
					"defaultCode": 60768,
					"grid": 16
				},
				{
					"id": 2935,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM832 576h-640v-128h640v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"minus-circle",
						"remove",
						"subtract"
					],
					"defaultCode": 60770,
					"grid": 16
				},
				{
					"id": 1260,
					"width": 877.7139282226562,
					"paths": [
						"M694.857 548.571v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-438.857q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h438.857q14.857 0 25.714-10.857t10.857-25.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"minus-circle"
					],
					"defaultCode": 61526,
					"grid": 14
				},
				{
					"id": 1471,
					"width": 877.7129821777344,
					"paths": [
						"M731.429 548.571v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-512q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h512q14.857 0 25.714-10.857t10.857-25.714zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"minus-square"
					],
					"defaultCode": 61766,
					"grid": 14
				},
				{
					"id": 1472,
					"width": 804.5689392089844,
					"paths": [
						"M658.286 457.143v36.571q0 8-5.143 13.143t-13.143 5.143h-475.429q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h475.429q8 0 13.143 5.143t5.143 13.143zM731.429 713.143v-475.429q0-37.714-26.857-64.571t-64.571-26.857h-475.429q-37.714 0-64.571 26.857t-26.857 64.571v475.429q0 37.714 26.857 64.571t64.571 26.857h475.429q37.714 0 64.571-26.857t26.857-64.571zM804.571 237.714v475.429q0 68-48.286 116.286t-116.286 48.286h-475.429q-68 0-116.286-48.286t-48.286-116.286v-475.429q0-68 48.286-116.286t116.286-48.286h475.429q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"minus-square-o"
					],
					"defaultCode": 61767,
					"grid": 14
				},
				{
					"id": 2929,
					"paths": [
						"M0 416v192c0 17.672 14.328 32 32 32h960c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32h-960c-17.672 0-32 14.328-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"minus",
						"subtract",
						"minimize",
						"line"
					],
					"defaultCode": 60764,
					"grid": 16
				},
				{
					"id": 2931,
					"paths": [
						"M64 448h896v128h-896v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"minus",
						"subtract",
						"line"
					],
					"defaultCode": 60766,
					"grid": 16
				},
				{
					"id": 1277,
					"width": 804.5709762573242,
					"paths": [
						"M804.571 420.571v109.714q0 22.857-16 38.857t-38.857 16h-694.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h694.857q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"minus"
					],
					"defaultCode": 61544,
					"grid": 14
				},
				{
					"id": 1065,
					"width": 1024,
					"paths": [
						"M992 544v-352c0-88.224-71.776-160-160-160h-640c-88.224 0-160 71.776-160 160v352h192v128c-52.928 0-96 43.072-96 96v128c0 52.928 43.072 96 96 96h64c52.928 0 96-43.072 96-96v-128c0-52.928-43.072-96-96-96v-128h704zM192 896v-128c0-17.632 14.368-32 32-32v192c-17.632 0-32-14.368-32-32zM320 768v128c0 17.632-14.368 32-32 32v-192c17.632 0 32 14.368 32 32zM192 96h640c52.928 0 96 43.072 96 96v224h-832v-224c0-52.928 43.072-96 96-96zM96 448h832v32h-832v-32zM480 256h352c35.36 0 64-28.64 64-64s-28.64-64-64-64h-352c-35.36 0-64 28.64-64 64s28.64 64 64 64zM480 160h352c17.632 0 32 14.368 32 32s-14.368 32-32 32h-352c-17.632 0-32-14.368-32-32s14.368-32 32-32zM160 384h-32v-32h32v32zM224 384h-32v-32h32v32zM288 384h-32v-32h32v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mix",
						"bake",
						"blend",
						"make",
						"stir"
					],
					"grid": 32
				},
				{
					"id": 1772,
					"width": 1316.5709533691406,
					"paths": [
						"M940 627.429q0-33.714-19.429-60.857t-49.714-39.143q-4 25.714-13.143 52.571-4 13.714-15.714 21.714t-25.429 8q-6.857 0-13.714-1.714-17.714-5.714-25.714-22t-2.286-33.429q13.143-40.571 13.143-81.714 0-70.286-34.857-130t-94.857-94.571-130.286-34.857q-76.571 0-141.143 41.714t-95.429 110.857q61.714 16 107.429 60.571 12.571 13.143 12.571 31.429t-12.571 30.857-30.857 12.571-31.429-12.571q-42.857-42.857-102.857-42.857-60.571 0-103.429 42.571t-42.857 103.143 42.857 103.143 103.429 42.571h597.714q45.143 0 76.857-31.714t31.714-76.286zM1027.429 627.429q0 81.143-57.429 138.286t-138.571 57.143h-597.714q-96.571 0-165.143-68.286t-68.571-164.857q0-87.429 57.143-152.571t142.286-77.714q35.429-105.143 126.286-170.286t202.286-65.143q134.286 0 233.429 90.571t112.286 222.571q66.286 14.286 110 67.714t43.714 122.571zM1170.286 627.429q0 100-55.429 182.286-13.143 18.857-36.571 18.857-13.714 0-24.571-7.429-14.857-9.714-18.286-27.714t6.857-32.857q40.571-59.429 40.571-133.143t-40.571-133.143q-10.286-14.857-6.857-32.571t18.286-28 32.857-6.571 28.286 18.571q55.429 81.143 55.429 181.714zM1316.571 627.429q0 139.429-76.571 253.143-13.143 19.429-36.571 19.429-13.143 0-24-7.429-14.857-10.286-18.571-28t6.571-32.571q61.714-93.714 61.714-204.571 0-111.429-61.714-204-10.286-14.857-6.571-32.857t18.571-27.714q14.857-10.286 32.571-6.857t28 18.857q76.571 113.143 76.571 252.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mixcloud"
					],
					"defaultCode": 62089,
					"grid": 14
				},
				{
					"id": 2189,
					"paths": [
						"M736 0h-448c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM384 48h256v32h-256v-32zM512 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM768 768h-512v-640h512v640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mobile",
						"cell-phone",
						"handheld"
					],
					"defaultCode": 60024,
					"grid": 16
				},
				{
					"id": 2190,
					"paths": [
						"M768 0h-576c-35.2 0-64 28.798-64 64v896c0 35.2 28.798 64 64 64h576c35.2 0 64-28.8 64-64v-896c0-35.202-28.8-64-64-64zM480 977.782c-27.492 0-49.782-22.29-49.782-49.782s22.29-49.782 49.782-49.782 49.782 22.29 49.782 49.782-22.29 49.782-49.782 49.782zM768 832h-576v-704h576v704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mobile",
						"cell-phone",
						"handheld",
						"tablet",
						"phablet"
					],
					"defaultCode": 60025,
					"grid": 16
				},
				{
					"id": 2192,
					"paths": [
						"M672 0c-17.676 0-32 14.326-32 32v96h-352c-17.672 0-32 14.326-32 32v832c0 17.672 14.328 32 32 32h384c17.674 0 32-14.328 32-32v-960c0-17.674-14.326-32-32-32zM384 960h-64v-64h64v64zM384 832h-64v-64h64v64zM384 704h-64v-64h64v64zM512 960h-64v-64h64v64zM512 832h-64v-64h64v64zM512 704h-64v-64h64v64zM640 960h-64v-64h64v64zM640 832h-64v-64h64v64zM640 704h-64v-64h64v64zM640 576h-320v-384h320v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mobile",
						"cell-phone",
						"handheld"
					],
					"defaultCode": 60027,
					"grid": 16
				},
				{
					"id": 1418,
					"width": 438.85701751708984,
					"paths": [
						"M265.143 804.571q0-18.857-13.429-32.286t-32.286-13.429-32.286 13.429-13.429 32.286 13.429 32.286 32.286 13.429 32.286-13.429 13.429-32.286zM384 713.143v-402.286q0-7.429-5.429-12.857t-12.857-5.429h-292.571q-7.429 0-12.857 5.429t-5.429 12.857v402.286q0 7.429 5.429 12.857t12.857 5.429h292.571q7.429 0 12.857-5.429t5.429-12.857zM274.286 228.571q0-9.143-9.143-9.143h-91.429q-9.143 0-9.143 9.143t9.143 9.143h91.429q9.143 0 9.143-9.143zM438.857 219.429v585.143q0 29.714-21.714 51.429t-51.429 21.714h-292.571q-29.714 0-51.429-21.714t-21.714-51.429v-585.143q0-29.714 21.714-51.429t51.429-21.714h292.571q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mobile",
						"mobile-phone"
					],
					"defaultCode": 61707,
					"grid": 14
				},
				{
					"id": 1768,
					"width": 1023.9999389648438,
					"paths": [
						"M815.429 405.143l-350.857-220.571 52.571-86.286h488.571zM231.429 556.571l-105.143-66.286v-490.286l676 424.571zM813.714 479.429l84 54.286v490.286l-304-191.429zM792.571 467.429l-285.714 458.286h-488.571l203.429-326.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"modx"
					],
					"defaultCode": 62085,
					"grid": 14
				},
				{
					"id": 1368,
					"width": 1097.143886566162,
					"paths": [
						"M438.857 658.286h219.429v-54.857h-73.143v-256h-65.143l-84.571 78.286 44 45.714q24-21.143 31.429-32.571h1.143v164.571h-73.143v54.857zM731.429 512q0 40-12 81.143t-34 76.571-58 57.714-78.857 22.286-78.857-22.286-58-57.714-34-76.571-12-81.143 12-81.143 34-76.571 58-57.714 78.857-22.286 78.857 22.286 58 57.714 34 76.571 12 81.143zM1024 658.286v-292.571q-60.571 0-103.429-42.857t-42.857-103.429h-658.286q0 60.571-42.857 103.429t-103.429 42.857v292.571q60.571 0 103.429 42.857t42.857 103.429h658.286q0-60.571 42.857-103.429t103.429-42.857zM1097.143 182.857v658.286q0 14.857-10.857 25.714t-25.714 10.857h-1024q-14.857 0-25.714-10.857t-10.857-25.714v-658.286q0-14.857 10.857-25.714t25.714-10.857h1024q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"money"
					],
					"defaultCode": 61654,
					"grid": 14
				},
				{
					"id": 2789,
					"paths": [
						"M715.812 64.48c-60.25-34.784-124.618-55.904-189.572-64.48 122.936 160.082 144.768 384.762 37.574 570.42-107.2 185.67-312.688 279.112-512.788 252.68 39.898 51.958 90.376 97.146 150.628 131.934 245.908 141.974 560.37 57.72 702.344-188.198 141.988-245.924 57.732-560.372-188.186-702.356z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"moon",
						"night",
						"sleep"
					],
					"defaultCode": 60624,
					"grid": 16
				},
				{
					"id": 1531,
					"width": 841.7138977050781,
					"paths": [
						"M721.143 744.571q-30.857 5.143-62.857 5.143-104 0-192.571-51.429t-140-140-51.429-192.571q0-109.714 59.429-204-114.857 34.286-187.714 130.857t-72.857 219.429q0 74.286 29.143 142t78 116.571 116.571 78 142 29.143q82.286 0 156.286-35.143t126-98zM837.143 696q-53.714 116-162 185.429t-236.286 69.429q-89.143 0-170.286-34.857t-140-93.714-93.714-140-34.857-170.286q0-87.429 32.857-167.143t89.143-138 134.571-94 165.714-39.143q25.143-1.143 34.857 22.286 10.286 23.429-8.571 41.143-49.143 44.571-75.143 103.714t-26 124.857q0 84.571 41.714 156t113.143 113.143 156 41.714q67.429 0 130.286-29.143 23.429-10.286 41.143 7.429 8 8 10 19.429t-2.571 21.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"moon-o"
					],
					"defaultCode": 61830,
					"grid": 14
				},
				{
					"id": 103,
					"paths": [
						"M524.8 1024c-140.179 0-271.968-54.589-371.090-153.71s-153.71-230.91-153.71-371.090c0-115.242 37-224.010 106.997-314.546 33.528-43.365 73.674-81.155 119.325-112.323 46.050-31.44 96.664-55.424 150.437-71.285 9.819-2.901 20.424 0.336 26.957 8.222s7.738 18.906 3.064 28.016c-33.006 64.339-48.379 125.702-48.379 193.115 0 239.97 195.23 435.2 435.2 435.2 67.414 0 128.776-15.371 193.115-48.378 9.107-4.674 20.13-3.469 28.016 3.064s11.12 17.134 8.224 26.957c-15.861 53.773-39.845 104.387-71.286 150.435-31.166 45.65-68.958 85.797-112.323 119.325-90.536 69.998-199.306 106.997-314.546 106.997zM336.397 69.896c-172.741 73.982-285.197 240.059-285.197 429.304 0 261.144 212.456 473.6 473.6 473.6 189.234 0 355.314-112.475 429.304-285.197-52.406 19.598-105.373 29.197-160.504 29.197-129.922 0-252.067-50.594-343.936-142.462-91.869-91.87-142.464-214.016-142.464-343.938 0-55.131 9.6-108.098 29.197-160.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"moon",
						"night"
					],
					"defaultCode": 59400,
					"grid": 20
				},
				{
					"id": 2672,
					"paths": [
						"M384 64h256v256h-256zM384 384h256v256h-256zM384 704h256v256h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"more",
						"dots",
						"menu"
					],
					"defaultCode": 60507,
					"grid": 16
				},
				{
					"id": 2673,
					"paths": [
						"M384 192c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM384 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM384 832c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"more",
						"dots",
						"menu"
					],
					"defaultCode": 60508,
					"grid": 16
				},
				{
					"id": 649,
					"width": 1024,
					"paths": [
						"M256 256c-141.376 0-256 114.624-256 256s114.624 256 256 256 256-114.624 256-256-114.624-256-256-256zM256 736c-123.52 0-224-100.48-224-224s100.48-224 224-224 224 100.48 224 224-100.48 224-224 224zM768 256c-141.376 0-256 114.624-256 256s114.624 256 256 256 256-114.624 256-256-114.624-256-256-256zM768 736c-123.52 0-224-100.48-224-224s100.48-224 224-224 224 100.48 224 224-100.48 224-224 224zM256 416c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM256 576c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64zM288 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM768 416c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM768 576c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64zM800 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mother",
						"seduce",
						"feed"
					],
					"grid": 32
				},
				{
					"id": 650,
					"width": 1024,
					"paths": [
						"M768 448c-35.296 0-64 28.704-64 64s28.704 64 64 64 64-28.704 64-64-28.704-64-64-64zM768 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM768 256c-141.376 0-256 114.624-256 256s114.624 256 256 256 256-114.624 256-256-114.624-256-256-256zM768 608c-53.024 0-96-42.976-96-96s42.976-96 96-96 96 42.976 96 96-42.976 96-96 96zM256 448c-35.296 0-64 28.704-64 64s28.704 64 64 64 64-28.704 64-64-28.704-64-64-64zM256 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM256 256c-141.376 0-256 114.624-256 256s114.624 256 256 256 256-114.624 256-256-114.624-256-256-256zM256 608c-53.024 0-96-42.976-96-96s42.976-96 96-96 96 42.976 96 96-42.976 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mother",
						"seduce",
						"feed"
					],
					"grid": 32
				},
				{
					"id": 1672,
					"width": 1321.7149658203125,
					"paths": [
						"M1314.857 592q6.857 58.857-12.571 113.429t-56.571 93.429-90.571 60.571-112.286 17.714q-92-6.286-159.714-71.429t-76.857-156.571q-6.857-63.429 15.714-120.286t67.714-97.429l-40.571-61.143q-54.857 45.714-86.286 110.857t-31.429 139.429q0 15.429-10.571 26.571t-26 11.143h-185.714q-13.143 93.714-85.143 156.571t-168 62.857q-105.714 0-180.857-75.143t-75.143-180.857 75.143-180.857 180.857-75.143q43.429 0 86.857 15.429l13.714-25.714q-70.286-62.857-173.714-62.857h-36.571q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h73.143q44.571 0 82.857 7.714t66.571 22 40.857 22.571 29.143 20.857h358.286l-48.571-73.143h-126.857q-17.143 0-28-12.857t-8-30q2.286-13.143 13.143-21.714t24.571-8.571h144.571q18.857 0 30.286 16l40 60 65.143-65.143q10.857-10.857 26.286-10.857h57.714q14.857 0 25.714 10.857t10.857 25.714v73.143q0 14.857-10.857 25.714t-25.714 10.857h-102.286l65.714 98.286q74.857-36 157.143-20.571 81.714 14.857 139.429 76.857t67.429 144.857zM256 804.571q65.714 0 116-41.429t63.429-104.857h-179.429q-20 0-31.429-17.714-10.286-18.286-0.571-36l84-158.286q-26.857-7.429-52-7.429-75.429 0-129.143 53.714t-53.714 129.143 53.714 129.143 129.143 53.714zM1060.571 804.571q75.429 0 129.143-53.714t53.714-129.143-53.714-129.143-129.143-53.714q-34.286 0-69.143 13.714l99.429 148.571q8.571 13.143 5.714 28t-15.429 22.857q-8.571 6.286-20.571 6.286-20 0-30.286-16.571l-99.429-148.571q-53.143 54.286-53.143 128.571 0 75.429 53.714 129.143t129.143 53.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"motorcycle"
					],
					"defaultCode": 61980,
					"grid": 14
				},
				{
					"id": 2540,
					"width": 1152,
					"paths": [
						"M1139.814 973.648l-313.6-448c-5.986-8.552-15.772-13.648-26.214-13.648s-20.226 5.094-26.214 13.648l-66.586 95.122-200.984-287.12c-5.988-8.556-15.774-13.65-26.216-13.65s-20.228 5.094-26.216 13.65l-448 640c-6.842 9.776-7.678 22.546-2.168 33.128 5.512 10.584 16.452 17.222 28.384 17.222h1081.6c11.932 0 22.874-6.638 28.382-17.222 5.512-10.582 4.676-23.354-2.168-33.13zM480 407.802l162.54 232.198h-85.284l-54.628-54.626c-12.498-12.496-32.758-12.496-45.256 0l-54.626 54.626h-85.284l162.538-232.198zM944.66 960l-200.166-285.954 2.372 1.66 53.134-75.906 252.14 360.2h-107.48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mountains",
						"nature",
						"hiking"
					],
					"defaultCode": 60375,
					"grid": 16
				},
				{
					"id": 2177,
					"paths": [
						"M640 78.858v305.142h-256v-305.142c-95.598 22.234-192 73.19-192 177.142v424c0 154.636 143.268 280 320 280 176.726 0 320-125.364 320-280v-424c0-103.952-96.402-154.908-192-177.142zM576 67.866c-23.446-2.708-45.358-3.866-64-3.866-18.64 0-40.552 1.158-64 3.866v252.134h128v-252.134z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mouse",
						"click"
					],
					"defaultCode": 60012,
					"grid": 16
				},
				{
					"id": 2179,
					"paths": [
						"M480 64c-96 0-288 37.36-288 192v424c0 154.636 128.942 280 288 280 159.056 0 288-125.364 288-280v-424c0-154.64-192-192-288-192zM704 680c0 57.354-23.074 111.372-64.968 152.102-20.574 20.004-44.554 35.714-71.27 46.706-27.746 11.406-57.272 17.192-87.762 17.192s-60.018-5.786-87.762-17.196c-26.716-10.988-50.7-26.702-71.274-46.706-41.892-40.726-64.964-94.744-64.964-152.098v-232h448v232zM704 384h-192v-256c37.736 3.266 82.844 13.808 120.408 31.756 23.61 11.282 41.59 24.782 53.442 40.126 12.21 15.814 18.15 34.172 18.15 56.118v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mouse-left",
						"click",
						"click-left"
					],
					"defaultCode": 60014,
					"grid": 16
				},
				{
					"id": 1708,
					"width": 665.1429786682129,
					"paths": [
						"M647.429 596q17.714 17.143 8 39.429-9.714 22.857-33.714 22.857h-218.286l114.857 272q5.714 14.286 0 28t-19.429 20l-101.143 42.857q-14.286 5.714-28 0t-20-19.429l-109.143-258.286-178.286 178.286q-10.857 10.857-25.714 10.857-6.857 0-13.714-2.857-22.857-9.714-22.857-33.714v-859.429q0-24 22.857-33.714 6.857-2.857 13.714-2.857 15.429 0 25.714 10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mouse-pointer"
					],
					"defaultCode": 62021,
					"grid": 14
				},
				{
					"id": 2180,
					"paths": [
						"M479.998 64c-95.998 0-287.998 37.36-287.998 192v424c0 154.636 128.942 280 287.998 280s288.002-125.364 288.002-280v-424c0-154.64-192-192-288.002-192zM256 256c0-21.948 5.938-40.304 18.152-56.12 11.848-15.344 29.83-28.844 53.44-40.126 37.564-17.95 82.672-28.49 120.408-31.754v256h-192v-128zM704 680c0 57.354-23.074 111.372-64.968 152.102-20.574 20.004-44.554 35.714-71.27 46.706-27.746 11.408-57.274 17.194-87.764 17.194-30.488 0-60.016-5.786-87.762-17.196-26.714-10.988-50.698-26.702-71.272-46.706-41.892-40.728-64.964-94.748-64.964-152.102v-231.998h448v232z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mouse-right",
						"click",
						"click-right"
					],
					"defaultCode": 60015,
					"grid": 16
				},
				{
					"id": 2178,
					"paths": [
						"M795.518 636.29l-153.6-256c-71.064-118.444-222.786-158.668-342.79-92.634-25.86-46.47-43.128-90.45-43.128-127.656 0-34.97 7.58-80.302 43.686-97.66 2.736-1.316 6.87-3.302 10.94-7.374 12.498-12.498 12.498-32.758 0-45.256-10.532-10.532-26.58-12.188-38.842-4.968-51.452 24.828-79.784 79.956-79.784 155.258 0 51.982 22.11 108.018 54.898 165.58-85.88 80.696-107.118 212.958-44.016 318.13l153.6 256c48.002 80.006 132.79 124.328 219.76 124.328 44.822 0 90.236-11.782 131.468-36.52 121.238-72.74 160.55-229.992 87.808-351.228zM472.138 595.65c-9.152 5.824-19.376 8.606-29.474 8.606-18.18 0-35.97-9.006-46.456-25.48l-73.542-115.564c-16.306-25.626-8.752-59.622 16.876-75.93 25.624-16.308 59.62-8.754 75.93 16.874l73.542 115.564c16.306 25.628 8.752 59.622-16.876 75.93z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mouse",
						"click"
					],
					"defaultCode": 60013,
					"grid": 16
				},
				{
					"id": 2914,
					"paths": [
						"M1024 512l-256-192v128h-192v-192h128l-192-256-192 256h128v192h-192v-128l-256 192 256 192v-128h192v192h-128l192 256 192-256h-128v-192h192v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"move",
						"drag",
						"arrows"
					],
					"defaultCode": 60749,
					"grid": 16
				},
				{
					"id": 3168,
					"paths": [
						"M768 704v-384h-64v384h-160l192 192 192-192z",
						"M320 256v192h-192v-192h192zM384 192h-320v320h320v-320z",
						"M64 640h96v64h-96v-64z",
						"M192 640h96v64h-96v-64z",
						"M320 640h64v96h-64v-96z",
						"M64 864h64v96h-64v-96z",
						"M160 896h96v64h-96v-64z",
						"M288 896h96v64h-96v-64z",
						"M64 736h64v96h-64v-96z",
						"M320 768h64v96h-64v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"move-down",
						"sort",
						"arrange"
					],
					"defaultCode": 61003,
					"grid": 16
				},
				{
					"id": 3167,
					"paths": [
						"M704 512v384h64v-384h160l-192-192-192 192z",
						"M64 192h96v64h-96v-64z",
						"M192 192h96v64h-96v-64z",
						"M320 192h64v96h-64v-96z",
						"M64 416h64v96h-64v-96z",
						"M160 448h96v64h-96v-64z",
						"M288 448h96v64h-96v-64z",
						"M64 288h64v96h-64v-96z",
						"M320 320h64v96h-64v-96z",
						"M320 704v192h-192v-192h192zM384 640h-320v320h320v-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"move-up",
						"sort",
						"arrange"
					],
					"defaultCode": 61002,
					"grid": 16
				},
				{
					"id": 218,
					"paths": [
						"M939.701 519.499l-153.6-153.6c-9.997-9.998-26.206-9.998-36.203 0-9.998 9.997-9.998 26.206 0 36.203l109.899 109.898h-347.797v-347.797l109.899 109.898c4.998 5 11.549 7.499 18.101 7.499s13.102-2.499 18.101-7.499c9.998-9.997 9.998-26.206 0-36.203l-153.6-153.6c-9.997-9.998-26.206-9.998-36.203 0l-153.6 153.6c-9.998 9.997-9.998 26.206 0 36.203s26.206 9.998 36.203 0l109.899-109.898v347.797h-347.797l109.898-109.899c9.998-9.997 9.998-26.206 0-36.203-9.997-9.998-26.206-9.998-36.203 0l-153.6 153.6c-9.998 9.997-9.998 26.206 0 36.203l153.6 153.6c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.101-7.499c9.998-9.997 9.998-26.206 0-36.203l-109.898-109.898h347.797v347.797l-109.899-109.899c-9.997-9.997-26.206-9.997-36.203 0-9.998 9.997-9.998 26.206 0 36.203l153.6 153.6c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.101-7.499l153.6-153.6c9.998-9.997 9.998-26.206 0-36.203-9.997-9.997-26.206-9.997-36.203 0l-109.898 109.899v-347.797h347.797l-109.899 109.899c-9.998 9.997-9.998 26.206 0 36.203 5 4.998 11.55 7.498 18.102 7.498s13.102-2.499 18.101-7.499l153.6-153.6c9.998-9.997 9.998-26.205 0-36.202z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"move",
						"arrows"
					],
					"defaultCode": 59515,
					"grid": 20
				},
				{
					"id": 651,
					"width": 1024,
					"paths": [
						"M1001.376 489.376l-114.752-114.752c-20.16-20.16-54.624-5.888-54.624 22.624v18.752h-224v-224h18.752c28.512 0 42.784-34.464 22.624-54.624l-114.752-114.752c-12.512-12.512-32.768-12.512-45.248 0l-114.752 114.752c-20.16 20.16-5.888 54.624 22.624 54.624h18.752v224h-224v-18.752c0-28.512-34.464-42.784-54.624-22.624l-114.752 114.752c-12.512 12.512-12.512 32.768 0 45.248l114.752 114.752c20.16 20.16 54.624 5.888 54.624-22.624v-18.752h224v224h-18.752c-28.512 0-42.784 34.464-22.624 54.624l114.752 114.752c12.512 12.512 32.768 12.512 45.248 0l114.752-114.752c20.16-20.16 5.888-54.624-22.624-54.624h-18.752v-224h224v18.752c0 28.512 34.464 42.784 54.624 22.624l114.752-114.752c12.48-12.48 12.48-32.768 0-45.248zM397.248 160l114.752-114.752 114.752 114.752h-50.752v256h-128v-256h-50.752zM626.752 864l-114.752 114.752-114.752-114.752h50.752v-256h128v256h50.752zM160 576v50.752l-114.752-114.752 114.752-114.752v50.752h704v-50.752l114.752 114.752-114.752 114.752v-50.752h-704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"move",
						"adjust",
						"edit",
						"position"
					],
					"grid": 32
				},
				{
					"id": 652,
					"width": 1024,
					"paths": [
						"M374.624 137.376l114.752-114.752c12.512-12.512 32.768-12.512 45.248 0l114.752 114.752c20.16 20.16 5.888 54.624-22.624 54.624h-18.752v192h-192v-192h-18.752c-28.512 0-42.784-34.464-22.624-54.624zM1001.376 489.376l-114.752-114.752c-20.16-20.16-54.624-5.888-54.624 22.624v18.752h-640v-18.752c0-28.512-34.464-42.784-54.624-22.624l-114.752 114.752c-12.512 12.512-12.512 32.768 0 45.248l114.752 114.752c20.16 20.16 54.624 5.888 54.624-22.624v-18.752h640v18.752c0 28.512 34.464 42.784 54.624 22.624l114.752-114.752c12.48-12.48 12.48-32.768 0-45.248zM626.752 832h-18.752v-192h-192v192h-18.752c-28.512 0-42.784 34.464-22.624 54.624l114.752 114.752c12.512 12.512 32.768 12.512 45.248 0l114.752-114.752c20.16-20.16 5.888-54.624-22.624-54.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"move",
						"adjust",
						"edit",
						"position"
					],
					"grid": 32
				},
				{
					"id": 1066,
					"width": 1024,
					"paths": [
						"M1001.376 489.376l-178.752-178.752c-20.192-20.192-54.624-5.792-54.624 22.624v50.752h-128v-128h50.752c28.512 0 42.784-34.464 22.624-54.624l-178.752-178.752c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-178.752 178.752c-20.16 20.16-5.888 54.624 22.624 54.624h50.752v128h-128v-50.752c0-28.416-34.432-42.816-54.624-22.624l-178.752 178.752c-12.512 12.512-12.512 32.768 0 45.248l178.752 178.752c20.192 20.192 54.624 5.792 54.624-22.624v-50.752h128v128h-50.752c-28.512 0-42.784 34.464-22.624 54.624l178.752 178.752c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l178.752-178.752c20.16-20.16 5.888-54.624-22.624-54.624h-50.752v-128h128v50.752c0 28.416 34.432 42.816 54.624 22.624l178.752-178.752c12.48-12.48 12.48-32.768 0-45.248zM512 90.496l101.504 101.504h-37.504v224h-128v-224h-37.504l101.504-101.504zM512 933.504l-101.504-101.504h37.504v-224h128v224h37.504l-101.504 101.504zM832 613.504v-37.504h-640v37.504l-101.504-101.504 101.504-101.504v37.504h640v-37.504l101.504 101.504-101.504 101.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"move",
						"adjust",
						"edit",
						"position"
					],
					"grid": 32
				},
				{
					"id": 1906,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 113.618c60.374 0 109.316 48.942 109.316 109.318 0 60.374-48.944 109.316-109.316 109.316-60.376 0-109.316-48.942-109.316-109.316 0-60.376 48.94-109.318 109.316-109.318zM115.556 414.728c0-60.374 48.942-109.316 109.318-109.316 60.374 0 109.316 48.942 109.316 109.316 0 60.376-48.942 109.318-109.316 109.318-60.374-0.002-109.318-48.944-109.318-109.318zM338.402 845.288c-60.374 0-109.316-48.942-109.316-109.316s48.944-109.318 109.316-109.318c60.374 0 109.318 48.944 109.318 109.318s-48.944 109.316-109.318 109.316zM512 576c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.346 0 64 28.654 64 64s-28.654 64-64 64zM685.598 845.938c-60.376 0-109.316-48.942-109.316-109.316s48.942-109.318 109.316-109.318c60.374 0 109.316 48.944 109.316 109.318s-48.944 109.316-109.316 109.316zM799.124 524.696c-60.374 0-109.316-48.942-109.316-109.318 0-60.374 48.944-109.316 109.316-109.316 60.376 0 109.318 48.942 109.318 109.316 0.002 60.374-48.94 109.318-109.318 109.318z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"movie",
						"video",
						"wheel",
						"film"
					],
					"defaultCode": 59741,
					"grid": 16
				},
				{
					"id": 2511,
					"paths": [
						"M960 320h-192v-96c0-88.366-171.922-160-384-160s-384 71.634-384 160v640c0 88.366 171.922 160 384 160s384-71.634 384-160v-96h192c35.346 0 64-28.654 64-64v-320c0-35.346-28.654-64-64-64zM176.056 258.398c-36.994-12.19-59.408-25.246-71.41-34.398 12.004-9.152 34.416-22.208 71.41-34.398 57.942-19.090 131.79-29.602 207.944-29.602s150.004 10.512 207.944 29.602c36.994 12.188 59.408 25.246 71.41 34.398-12.002 9.152-34.416 22.208-71.41 34.398-57.94 19.090-131.79 29.602-207.944 29.602s-150.002-10.512-207.944-29.602zM896 640h-128v-192h128v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mug",
						"drink",
						"glass",
						"beverage"
					],
					"defaultCode": 60346,
					"grid": 16
				},
				{
					"id": 653,
					"width": 1024,
					"paths": [
						"M832 256h-286.112l-92.416-184.8c-3.808-7.648-10.368-13.344-18.464-16.064-8.16-2.688-16.832-2.080-24.48 1.728l-22.592 11.296-14.496-28.96c-3.808-7.648-10.368-13.344-18.464-16.064-8.16-2.72-16.832-2.080-24.48 1.728l-35.328 17.664c-15.776 7.872-22.208 27.136-14.336 42.944l87.584 175.168c-9.632 5.504-16.416 15.456-16.416 27.36v64c-13.408 0-27.040 0-32 0-88.352 0-160 71.648-160 160s71.648 160 160 160c5.344 0 20.576 0 34.88 0 15.264 90.784 94.016 160 189.12 160v64c0 17.664-14.336 32-32 32-35.36 0-64 28.64-64 64 0 17.664 14.336 32 32 32h256c17.664 0 32-14.336 32-32 0-35.36-28.64-64-64-64-17.664 0-32-14.336-32-32v-64c106.048 0 192-85.952 192-192v-352c0-17.664-14.336-32-32-32zM424.832 85.472l85.28 170.528h-28.224l-79.616-159.232 22.56-11.296zM344.832 53.472l101.248 202.528h-44.192l-92.416-184.832 35.36-17.696zM320 640c-70.592 0-128-57.408-128-128s57.408-128 128-128h32v32h-32c-52.928 0-96 43.072-96 96s43.072 96 96 96h32v32h-32zM352 448v128c-13.248 0-26.72 0-32 0-35.36 0-64-28.64-64-64s28.64-64 64-64c5.28 0 18.752 0 32 0zM704 960c17.632 0 32 14.368 32 32h-256c0-17.632 14.368-32 32-32 35.296 0 64-28.704 64-64v-64h64v64c0 35.296 28.704 64 64 64zM832 640c0 88.224-71.776 160-160 160h-128c-88.224 0-160-71.776-160-160v-352h448v352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mull",
						"drink",
						"warm",
						"imbibe",
						"spice"
					],
					"grid": 32
				},
				{
					"id": 654,
					"width": 1024,
					"paths": [
						"M280.832 85.472c-7.872-15.808-1.44-35.072 14.336-42.944l35.36-17.696c7.616-3.808 16.32-4.448 24.48-1.728 8.096 2.72 14.656 8.416 18.464 16.064l14.496 28.96 22.592-11.296c7.616-3.808 16.32-4.416 24.48-1.728 8.096 2.72 14.656 8.416 18.464 16.064l76.384 152.832h-179.776l-69.28-138.528zM864 288v352c0 106.048-85.952 192-192 192v64c0 17.664 14.336 32 32 32 35.36 0 64 28.64 64 64 0 17.664-14.336 32-32 32h-256c-17.664 0-32-14.336-32-32 0-35.36 28.64-64 64-64 17.664 0 32-14.336 32-32v-64c-95.104 0-173.856-69.216-189.12-160-14.272 0-29.536 0-34.88 0-93.536 0-168.352-80.288-159.264-175.712 7.936-83.2 82.56-144.288 166.144-144.288h25.12v-64c0-17.664 14.336-32 32-32h448c17.664 0 32 14.336 32 32zM352 448c-13.248 0-26.72 0-32 0-35.36 0-64 28.64-64 64s28.64 64 64 64c5.28 0 18.752 0 32 0v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mull",
						"drink",
						"warm",
						"imbibe",
						"spice"
					],
					"grid": 32
				},
				{
					"id": 1067,
					"width": 1024,
					"paths": [
						"M715.648 353.6l-45.248-45.248c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-113.152 113.152-113.152-113.152c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-45.248 45.248c-12.512 12.512-12.512 32.768 0 45.248l113.152 113.152-113.152 113.152c-12.512 12.512-12.512 32.768 0 45.248l45.248 45.248c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l113.152-113.152 113.152 113.152c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l45.248-45.248c12.512-12.512 12.512-32.768 0-45.248l-113.152-113.152 113.152-113.152c12.512-12.48 12.512-32.736 0-45.248zM557.248 512l135.776 135.776-45.248 45.248-135.776-135.776-135.776 135.776-45.248-45.248 135.776-135.776-135.776-135.776 45.248-45.248 135.776 135.776 135.744-135.744c0 0 0 0 0.032 0l45.248 45.248-135.776 135.744zM512 0c-282.784 0-512 229.216-512 512s229.216 512 512 512 512-229.216 512-512-229.216-512-512-512zM512 960c-247.424 0-448-200.576-448-448s200.576-448 448-448 448 200.576 448 448-200.576 448-448 448zM512 96c-229.76 0-416 186.24-416 416s186.24 416 416 416 416-186.24 416-416-186.24-416-416-416zM512 896c-212.064 0-384-171.936-384-384s171.936-384 384-384 384 171.936 384 384c0 212.064-171.936 384-384 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"multiply",
						"close"
					],
					"grid": 32
				},
				{
					"id": 2891,
					"paths": [
						"M992 1024h-608c-11.038 0-21.292-5.684-27.136-15.040l-160-256c-9.172-14.68-5.014-33.988 9.386-43.586l96-64c13.608-9.074 31.864-6.422 42.334 6.134l103.416 124.11v-487.618c0-17.672 14.328-32 32-32h128c17.672 0 32 14.328 32 32v199.016l359.762 89.942c14.244 3.56 24.234 16.362 24.234 31.042v384c0 17.674-14.322 32-31.996 32v0zM401.736 960h558.264v-327.016l-64-16v183.016c0 17.674-14.326 32-32 32-17.678 0-32-14.326-32-32v-199.016l-64-16v151.016c0 17.674-14.326 32-32 32-17.676 0-32-14.326-32-32v-167.016l-64-16v247.016c0 17.674-14.328 32-32 32s-32-14.326-32-32v-480h-64v544c0 13.472-8.442 25.502-21.11 30.088-12.666 4.594-26.85 0.746-35.472-9.602l-141.592-169.91-46.22 30.81 134.13 214.614z",
						"M736 320c-17.676 0-32-14.328-32-32 0-88.224-71.778-160-160-160-88.224 0-160 71.776-160 160 0 17.672-14.328 32-32 32s-32-14.328-32-32c0-123.514 100.486-224 224-224s224 100.486 224 224c0 17.672-14.326 32-32 32z",
						"M159.976 938.452c-4.602 0-9.276-0.998-13.708-3.104-43.118-20.484-79.612-52.558-105.538-92.756-26.646-41.31-40.73-89.236-40.73-138.592 0-141.158 114.84-256 256-256 38.378 0 75.298 8.294 109.732 24.652 15.964 7.584 22.756 26.672 15.174 42.634-7.584 15.962-26.674 22.754-42.634 15.174-25.788-12.25-53.466-18.46-82.272-18.46-105.87 0-192 86.13-192 192 0 73.754 43.072 141.874 109.728 173.54 15.962 7.584 22.756 26.672 15.172 42.634-5.476 11.532-16.956 18.278-28.924 18.278z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"multitouch",
						"finger",
						"pointer",
						"touch",
						"hand"
					],
					"defaultCode": 60726,
					"grid": 16
				},
				{
					"id": 1887,
					"paths": [
						"M812.158 294.412c-87.050-122.21-78.88-35.914-163.208-279.684l-89.178-14.728-99.218 732.95c-223.632-127.958-364.672 3.468-328.984 168.886 18.92 87.712 161.432 170.274 301.8 88.78 66.342-39.89 87.672-104.22 96.14-149.838l70.876-543.852c252.89 222.974 172.142 357.892 119.85 513.244 107.498-44.334 275.88-239.888 91.922-515.758z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"music",
						"song",
						"audio",
						"sound",
						"note"
					],
					"defaultCode": 59722,
					"grid": 16
				},
				{
					"id": 130,
					"paths": [
						"M1014.803 57.146c-5.826-4.864-13.509-6.891-20.982-5.533l-563.2 102.4c-12.173 2.213-21.021 12.816-21.021 25.187v583.632c-6.986-4.722-14.629-9.181-22.936-13.336-42.166-21.085-97.662-32.696-156.264-32.696s-114.098 11.611-156.264 32.696c-47.806 23.902-74.136 57.749-74.136 95.304s26.33 71.402 74.136 95.304c42.166 21.085 97.662 32.696 156.264 32.696s114.098-11.611 156.264-32.696c47.806-23.902 74.136-57.749 74.136-95.304v-516.294l512-94.549v426.475c-6.984-4.722-14.629-9.182-22.936-13.336-42.166-21.085-97.662-32.696-156.264-32.696s-114.098 11.611-156.264 32.696c-47.808 23.902-74.136 57.749-74.136 95.304s26.328 71.402 74.136 95.304c42.166 21.085 97.662 32.696 156.264 32.696s114.098-11.611 156.264-32.696c47.808-23.902 74.136-57.749 74.136-95.304v-665.6c0-7.59-3.368-14.79-9.197-19.654zM230.4 921.6c-102.563 0-179.2-40.547-179.2-76.8s76.637-76.8 179.2-76.8 179.2 40.547 179.2 76.8-76.637 76.8-179.2 76.8zM460.8 276.438v-75.874l512-93.091v74.416l-512 94.549zM793.6 819.2c-102.565 0-179.2-40.547-179.2-76.8s76.635-76.8 179.2-76.8c102.566 0 179.2 40.547 179.2 76.8s-76.634 76.8-179.2 76.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"music-note",
						"music",
						"song",
						"audio"
					],
					"defaultCode": 59427,
					"grid": 20
				},
				{
					"id": 1888,
					"paths": [
						"M320 192v527.406c-29.098-9.874-61.642-15.406-96-15.406-123.712 0-224 71.634-224 160s100.288 160 224 160 224-71.634 224-160v-303.156l448-122.182v152.744c-29.098-9.874-61.642-15.406-96-15.406-123.71 0-224 71.634-224 160s100.29 160 224 160 224-71.634 224-160v-736l-704 192zM448 461.338v-97.338l448-122.182v97.338l-448 122.182z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"music",
						"song",
						"audio",
						"sound",
						"note"
					],
					"defaultCode": 59723,
					"grid": 16
				},
				{
					"id": 1889,
					"paths": [
						"M320 192l704-192v736c0 88.366-100.29 160-224 160s-224-71.634-224-160c0-88.366 100.29-160 224-160 34.358 0 66.902 5.532 96 15.406v-329.588l-448 122.182v480c0 88.366-100.288 160-224 160s-224-71.634-224-160c0-88.366 100.288-160 224-160 34.358 0 66.902 5.532 96 15.406v-527.406z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"music",
						"song",
						"audio",
						"sound",
						"note"
					],
					"defaultCode": 59724,
					"grid": 16
				},
				{
					"id": 1890,
					"paths": [
						"M960 0l-576 128v624.040c-40.658-29.64-97.316-48.040-160-48.040-123.712 0-224 71.632-224 160 0 88.366 100.288 160 224 160s224-71.634 224-160v-413.416l512-113.778v287.234c-40.658-29.64-97.316-48.040-160-48.040-123.71 0-224 71.632-224 160 0 88.366 100.29 160 224 160s224-71.634 224-160v-736h-64zM960 254.852l-512 113.778v-126.852l512-113.778v126.852z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"music",
						"song",
						"audio",
						"sound",
						"note"
					],
					"defaultCode": 59725,
					"grid": 16
				},
				{
					"id": 1891,
					"paths": [
						"M960 0h64v736c0 88.366-100.29 160-224 160s-224-71.634-224-160c0-88.368 100.29-160 224-160 62.684 0 119.342 18.4 160 48.040v-368.040l-512 113.778v494.222c0 88.366-100.288 160-224 160s-224-71.634-224-160c0-88.368 100.288-160 224-160 62.684 0 119.342 18.4 160 48.040v-624.040l576-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"music",
						"song",
						"audio",
						"sound",
						"note"
					],
					"defaultCode": 59726,
					"grid": 16
				},
				{
					"id": 1892,
					"paths": [
						"M960 0l-576 128v624.040c-40.658-29.64-97.316-48.040-160-48.040-123.712 0-224 71.632-224 160 0 88.366 100.288 160 224 160s224-71.634 224-160v-413.416l512-113.778v287.234c-40.658-29.64-97.316-48.040-160-48.040-123.71 0-224 71.632-224 160 0 88.366 100.29 160 224 160s224-71.634 224-160v-736h-64zM224 948c-84.706 0-148-44.348-148-84s63.294-84 148-84 148 44.348 148 84-63.294 84-148 84zM800 820c-84.708 0-148-44.348-148-84s63.292-84 148-84 148 44.348 148 84-63.292 84-148 84zM960 254.852l-512 113.778v-126.852l512-113.778v126.852z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"music",
						"song",
						"audio",
						"sound",
						"note"
					],
					"defaultCode": 59727,
					"grid": 16
				},
				{
					"id": 1180,
					"width": 877.7108917236328,
					"paths": [
						"M877.714 128v640q0 28.571-19.429 50.857t-49.143 34.571-59.143 18.286-55.143 6-55.143-6-59.143-18.286-49.143-34.571-19.429-50.857 19.429-50.857 49.143-34.571 59.143-18.286 55.143-6q60 0 109.714 22.286v-306.857l-438.857 135.429v405.143q0 28.571-19.429 50.857t-49.143 34.571-59.143 18.286-55.143 6-55.143-6-59.143-18.286-49.143-34.571-19.429-50.857 19.429-50.857 49.143-34.571 59.143-18.286 55.143-6q60 0 109.714 22.286v-552.571q0-17.714 10.857-32.286t28-20.286l475.429-146.286q6.857-2.286 16-2.286 22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"music"
					],
					"defaultCode": 61441,
					"grid": 14
				},
				{
					"id": 2501,
					"paths": [
						"M937.274 513.374c-13.5-4.086-28.078 1.142-35.898 12.876-20.948 31.418-47 48.722-73.364 48.722-26.092 0-50.758-17.318-62.838-44.122l-0.444-0.984c-14.676-32.566-29.852-66.24-52.148-93.58-28.296-34.694-63.482-52.286-104.582-52.286-52.284 0-98.786 25.21-128 64.112-29.214-38.902-75.716-64.112-128-64.112-41.1 0-76.286 17.592-104.582 52.288-22.296 27.338-37.472 61.012-52.148 93.578l-0.444 0.986c-12.080 26.8-36.746 44.12-62.84 44.122-26.36 0-52.414-17.302-73.36-48.722-7.822-11.734-22.402-16.962-35.9-12.876-13.496 4.082-22.726 16.522-22.726 30.624 0 68.744 26.826 126.612 77.578 167.348 45.516 36.532 108.88 56.652 178.422 56.652 66.414 0 130.212-24.176 179.64-68.074 17.64-15.666 32.532-33.154 44.36-51.752 11.828 18.598 26.718 36.086 44.36 51.752 49.43 43.898 113.226 68.074 179.64 68.074 69.542 0 132.906-20.12 178.422-56.652 50.752-40.736 77.578-98.604 77.578-167.348 0-14.102-9.23-26.542-22.726-30.626z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mustache",
						"hipster"
					],
					"defaultCode": 60336,
					"grid": 16
				},
				{
					"id": 2502,
					"paths": [
						"M937.274 513.374c-13.5-4.086-28.078 1.142-35.898 12.876-20.948 31.418-47 48.722-73.364 48.722-26.092 0-50.758-17.318-62.838-44.122l-0.444-0.984c-14.676-32.566-29.852-66.24-52.148-93.58-28.296-34.694-63.482-52.286-104.582-52.286-52.284 0-98.786 25.21-128 64.112-29.214-38.902-75.716-64.112-128-64.112-41.1 0-76.286 17.592-104.582 52.288-22.296 27.338-37.472 61.012-52.148 93.578l-0.444 0.986c-12.080 26.8-36.746 44.12-62.84 44.122-26.36 0-52.414-17.302-73.36-48.722-7.822-11.734-22.402-16.962-35.9-12.876-13.496 4.082-22.726 16.522-22.726 30.624 0 68.744 26.826 126.612 77.578 167.348 45.516 36.532 108.88 56.652 178.422 56.652 66.414 0 130.212-24.176 179.64-68.074 17.64-15.666 32.532-33.154 44.36-51.752 11.828 18.598 26.718 36.086 44.36 51.752 49.43 43.898 113.226 68.074 179.64 68.074 69.542 0 132.906-20.12 178.422-56.652 50.752-40.736 77.578-98.604 77.578-167.348 0-14.102-9.23-26.542-22.726-30.626zM393.144 652.074c-37.706 33.484-86.41 51.926-137.144 51.926-85.182 0-137.328-31.134-165.378-72.008 16.244 5.524 30.67 6.98 41.366 6.98 51.216-0.002 98.784-32.12 121.186-81.824l0.446-0.988c30.328-67.296 52.084-108.16 98.38-108.16 52.934 0 96 43.066 96 96 0 37.72-19.994 77.112-54.856 108.074zM704 704c-50.732 0-99.438-18.442-137.142-51.926-34.864-30.962-54.858-70.354-54.858-108.074 0-52.934 43.066-96 96-96 46.294 0 68.052 40.864 98.382 108.162l0.444 0.986c22.402 49.708 69.97 81.824 121.186 81.824 10.972 0 25.872-1.534 42.628-7.418-36.162 52.146-105 72.446-166.64 72.446z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mustache",
						"hipster"
					],
					"defaultCode": 60337,
					"grid": 16
				},
				{
					"id": 182,
					"paths": [
						"M486.4 1024c-129.922 0-252.067-50.594-343.936-142.464s-142.464-214.014-142.464-343.936c0-129.923 50.595-252.067 142.464-343.936s214.013-142.464 343.936-142.464c129.922 0 252.067 50.595 343.936 142.464s142.464 214.014 142.464 343.936-50.594 252.067-142.464 343.936c-91.869 91.87-214.014 142.464-343.936 142.464zM486.4 102.4c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2 435.2-195.23 435.2-435.2-195.23-435.2-435.2-435.2z",
						"M332.8 409.6c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.453 76.8-76.8 76.8zM332.8 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M640 409.6c-42.349 0-76.8-34.453-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.451 76.8-76.8 76.8zM640 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M815.258 626.352c-5.658-8.979-16.27-13.53-26.678-11.454-9.582 1.917-18.819 2.888-27.454 2.888-0.002 0-0.006 0-0.010 0-44.645-0.003-71.763-25.77-100.47-53.053-27.28-25.925-55.49-52.733-97.445-52.733-30.563 0-58.021 13.475-76.8 34.776-18.779-21.301-46.237-34.776-76.8-34.776-41.954 0-70.163 26.808-97.443 52.733-28.709 27.283-55.826 53.051-100.47 53.051-8.643 0-17.883-0.97-27.466-2.888-10.402-2.083-21.019 2.475-26.678 11.454s-5.19 20.517 1.178 29.008c59.243 78.992 135.293 95.573 188.658 95.573 31.79 0 57.109-5.984 69.373-9.552 27.166-7.902 52.106-27.757 69.648-52.627 17.542 24.87 42.482 44.723 69.648 52.627 12.266 3.566 37.587 9.554 69.374 9.552 53.366-0.002 129.416-16.584 188.656-95.573 6.371-8.49 6.84-20.029 1.181-29.006zM402.45 692.219c-9.646 2.806-29.63 7.514-55.070 7.514-29.939 0-69.050-6.722-105.958-33.501 47.877-9.141 79.642-39.328 106.006-64.384 25.213-23.962 41.706-38.648 62.173-38.648 28.232 0 51.2 22.968 51.2 51.2 0 31.275-28.358 69.094-58.35 77.819zM625.422 699.733c-25.437 0.002-45.424-4.706-55.070-7.514-29.994-8.725-58.352-46.544-58.352-77.819 0-28.232 22.968-51.2 51.2-51.2 20.469 0 36.962 14.686 62.176 38.646 26.365 25.053 58.13 55.238 106.005 64.382-36.907 26.781-76.019 33.504-105.958 33.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mustache",
						"emoticon",
						"perxis",
						"hipster"
					],
					"defaultCode": 59479,
					"grid": 20
				},
				{
					"id": 655,
					"width": 1024,
					"paths": [
						"M671.936 152.48c-5.504 0-11.136 1.44-16.416 4.608l-248.736 149.248c-14.912 8.96-32 13.696-49.376 13.696h-133.408c-53.024 0-96 42.976-96 96v32c-35.36 0-64 28.64-64 64s28.64 64 64 64v32c0 53.024 42.976 96 96 96h129.728c19.712 0 38.912 6.048 55.040 17.344l244.864 171.392c5.76 4.032 12.064 5.824 18.24 5.824 16.608 0 32.096-13.184 32.096-32.064v-682.016c0.032-18.72-15.328-32.032-32.032-32.032zM96 512c0-17.632 14.368-32 32-32v64c-17.632 0-32-14.368-32-32zM672 866.528l-244.864-171.392c-21.632-15.136-47.008-23.136-73.408-23.136h-129.728c-35.296 0-64-28.704-64-64v-192c0-35.296 28.704-64 64-64h133.408c23.2 0 45.952-6.304 65.856-18.24l248.736-149.216v681.984zM955.328 580.672c6.24 6.24 6.24 16.384 0 22.624-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672l-68.672-68.704-68.672 68.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672c-6.24-6.24-6.24-16.384 0-22.624l68.704-68.704-68.672-68.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l68.672 68.672 68.672-68.672c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-68.672 68.672 68.704 68.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mute",
						"sound"
					],
					"grid": 32
				},
				{
					"id": 656,
					"width": 1024,
					"paths": [
						"M671.936 152.48c-5.504 0-11.136 1.44-16.416 4.608l-248.736 149.248c-14.912 8.96-32 13.696-49.376 13.696h-133.408c-53.024 0-96 42.976-96 96v32c-35.36 0-64 28.64-64 64s28.64 64 64 64v32c0 53.024 42.976 96 96 96h129.728c19.712 0 38.912 6.048 55.040 17.344l244.864 171.392c5.76 4.032 12.064 5.824 18.24 5.824 16.608 0 32.096-13.184 32.096-32.064v-682.016c0.032-18.72-15.328-32.032-32.032-32.032zM955.328 580.672c6.24 6.24 6.24 16.384 0 22.624-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672l-68.672-68.704-68.672 68.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672c-6.24-6.24-6.24-16.384 0-22.624l68.704-68.704-68.672-68.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l68.672 68.672 68.672-68.672c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-68.672 68.672 68.704 68.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mute",
						"sound"
					],
					"grid": 32
				},
				{
					"id": 1068,
					"width": 1024,
					"paths": [
						"M639.936 119.68c-5.376 0-10.88 1.376-16.064 4.416l-335.872 195.904h-256c-17.664 0-32 14.336-32 32v320c0 17.664 14.336 32 32 32h256l335.872 195.936c5.184 3.040 10.688 4.416 16.064 4.416 16.704 0 32.064-13.344 32.064-32.032v-720.608c0-18.688-15.328-32.032-32.064-32.032zM288 640h-224v-256h224v256zM512 760.576l-192-112v-273.152l0.256-0.16 191.744-111.84v497.152zM608 816.576l-64-37.344v-534.464l64-37.344v609.152zM992.224 594.976c12.384 12.384 12.384 32.416 0 44.8l-0.448 0.448c-12.384 12.384-32.416 12.384-44.8 0l-82.976-82.976-82.976 82.976c-12.384 12.384-32.416 12.384-44.8 0l-0.448-0.448c-12.384-12.384-12.384-32.416 0-44.8l82.976-82.976-82.976-82.976c-12.384-12.384-12.384-32.416 0-44.8l0.448-0.448c12.384-12.384 32.416-12.384 44.8 0l82.976 82.976 82.976-82.976c12.384-12.384 32.416-12.384 44.8 0l0.448 0.448c12.384 12.384 12.384 32.416 0 44.8l-82.976 82.976 82.976 82.976z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"mute",
						"quiet",
						"silence"
					],
					"grid": 32
				},
				{
					"id": 657,
					"width": 1024,
					"paths": [
						"M480 288h-32v-128h22.624l73.376 73.376v-73.376h32v128h-22.624l-73.376-73.376v73.376zM960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448 200.576-448 448-448 448 200.576 448 448zM928 512c0-229.376-186.624-416-416-416s-416 186.624-416 416 186.624 416 416 416 416-186.624 416-416zM588.992 461.024l124 230.304c7.52 13.984-7.712 29.184-21.664 21.664l-230.304-124c-11.040-5.952-20.064-14.976-26.016-26.016l-124-230.304c-7.52-13.952 7.712-29.184 21.664-21.664l230.304 124c11.040 5.952 20.064 14.976 26.016 26.016zM659.52 659.52l-103.264-191.776-191.776-103.264 103.264 191.776 191.776 103.264zM489.376 489.376c-12.512 12.512-12.512 32.768 0 45.248 12.512 12.512 32.768 12.512 45.248 0 12.512-12.512 12.512-32.768 0-45.248-12.48-12.512-32.768-12.512-45.248 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"navigate",
						"guide",
						"direct"
					],
					"grid": 32
				},
				{
					"id": 658,
					"width": 1024,
					"paths": [
						"M364.48 364.48l103.264 191.776 191.776 103.264-103.264-191.776-191.776-103.264zM534.624 534.624c-12.512 12.512-32.768 12.512-45.248 0-12.512-12.512-12.512-32.768 0-45.248 12.512-12.512 32.768-12.512 45.248 0 12.512 12.48 12.512 32.768 0 45.248zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM448 160h22.624l73.376 73.376v-73.376h32v128h-22.624l-73.376-73.376v73.376h-32v-128zM691.328 712.992l-230.304-124c-11.040-5.952-20.064-14.976-26.016-26.016l-124-230.304c-7.52-13.952 7.712-29.184 21.664-21.664l230.304 124c11.040 5.952 20.064 14.976 26.016 26.016l124 230.304c7.52 13.952-7.712 29.184-21.664 21.664z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"navigate",
						"guide",
						"direct"
					],
					"grid": 32
				},
				{
					"id": 1069,
					"width": 1024,
					"paths": [
						"M512 0c-282.784 0-512 229.216-512 512s229.216 512 512 512 512-229.216 512-512-229.216-512-512-512zM512 960c-247.040 0-448-200.96-448-448s200.96-448 448-448 448 200.96 448 448c0 247.040-200.96 448-448 448zM512 96c-229.76 0-416 186.24-416 416s186.24 416 416 416 416-186.24 416-416-186.24-416-416-416zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384zM720.864 270.976c-5.728 0-11.68 1.632-17.472 5.376l-226.304 146.432c-24.864 9.728-44.576 29.44-54.304 54.304l-146.432 226.304c-15.008 23.2 3.808 49.632 26.784 49.632 5.728 0 11.68-1.632 17.472-5.376l226.304-146.432c24.864-9.728 44.576-29.44 54.304-54.304l146.432-226.304c15.008-23.2-3.808-49.632-26.784-49.632zM512 448c35.36 0 64 28.64 64 64s-28.64 64-64 64-64-28.64-64-64c0-35.36 28.64-64 64-64zM303.2 720.8l117.28-181.248c9.248 30.72 33.248 54.72 63.968 63.968l-181.248 117.28zM603.52 484.48c-9.248-30.72-33.248-54.72-63.968-63.968l181.184-117.184-117.216 181.152z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"navigate",
						"guide",
						"direct"
					],
					"grid": 32
				},
				{
					"id": 3256,
					"paths": [
						"M448 576h-192v-128h192v-192h128v192h192v128h-192v192h-128zM1024 640v384h-1024v-384h128v256h768v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"nbsp",
						"wysiwyg"
					],
					"defaultCode": 61091,
					"grid": 16
				},
				{
					"id": 659,
					"width": 1024,
					"paths": [
						"M768 398.144c0-29.152-13.248-56.736-36.032-74.976l-99.936-79.968c-15.2-12.128-24.032-30.528-24.032-49.952v-1.248c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32v1.248c0 19.456-8.832 37.824-24.032 49.984l-99.936 79.968c-22.784 18.208-36.032 45.76-36.032 74.944v81.856c0 19.232 8.64 36.256 22.080 48-13.44 11.744-22.080 28.768-22.080 48v128c0 19.232 8.64 36.256 22.080 48-13.44 11.744-22.080 28.768-22.080 48v128c0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96v-128c0-19.232-8.64-36.256-22.080-48 13.44-11.744 22.080-28.768 22.080-48v-128c0-19.232-8.64-36.256-22.080-48 13.44-11.744 22.080-28.768 22.080-48v-81.856zM416 32h192v128h-192v-128zM411.968 268.192c22.784-18.208 36.032-45.792 36.032-74.944v-1.248h128v1.248c0 29.152 13.248 56.736 36.032 74.976l68.704 54.976h-337.472l68.704-55.008zM736 480c0 17.664-14.336 32-32 32h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16c17.664 0 32 14.336 32 32v128c0 17.664-14.336 32-32 32h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16c17.664 0 32 14.336 32 32v128c0 35.36-28.64 64-64 64h-320c-35.36 0-64-28.64-64-64v-128c0-17.664 14.336-32 32-32h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16c-17.664 0-32-14.336-32-32v-128c0-17.664 14.336-32 32-32h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16c-17.664 0-32-14.336-32-32v-81.856c0-17.6 7.552-34.112 20.192-46.144h407.616c12.64 12.032 20.192 28.512 20.192 46.144v81.856z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"need",
						"drink"
					],
					"grid": 32
				},
				{
					"id": 660,
					"width": 1024,
					"paths": [
						"M384 160v-128c0-17.664 14.336-32 32-32h192c17.664 0 32 14.336 32 32v128c0 17.664-14.336 32-32 32h-192c-17.664 0-32-14.336-32-32zM632.032 243.2c-6.624-5.312-11.808-11.968-15.808-19.2h-208.448c-4 7.264-9.152 13.92-15.808 19.2l-99.936 79.968c-22.784 18.24-36.032 45.792-36.032 74.976v81.856c0 19.232 8.64 36.256 22.080 48-13.44 11.744-22.080 28.768-22.080 48v128c0 19.232 8.64 36.256 22.080 48-13.44 11.744-22.080 28.768-22.080 48v128c0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96v-128c0-19.232-8.64-36.256-22.080-48 13.44-11.744 22.080-28.768 22.080-48v-128c0-19.232-8.64-36.256-22.080-48 13.44-11.744 22.080-28.768 22.080-48v-81.856c0-29.152-13.248-56.736-36.032-74.976l-99.936-79.968z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"need",
						"drink"
					],
					"grid": 32
				},
				{
					"id": 1686,
					"width": 658.2850189208984,
					"paths": [
						"M658.286 329.143q0 126.286-84.286 219.714t-208.286 107.143v349.714q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-349.714q-124-13.714-208.286-107.143t-84.286-219.714q0-66.857 26-127.714t70.286-105.143 105.143-70.286 127.714-26 127.714 26 105.143 70.286 70.286 105.143 26 127.714zM329.143 585.143q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"neuter"
					],
					"defaultCode": 61996,
					"grid": 14
				},
				{
					"id": 2863,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM256 320c0 35.346 28.654 64 64 64s64-28.654 64-64-28.654-64-64-64-64 28.654-64 64zM640 320c0 35.346 28.654 64 64 64s64-28.654 64-64-28.654-64-64-64-64 28.654-64 64zM384 704h256v64h-256v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"neutral",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60698,
					"grid": 16
				},
				{
					"id": 2864,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.226 512 512 512c282.77 0 512-229.23 512-512s-229.23-512-512-512zM640 768h-256v-64h256v64zM704 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64c0-35.346 28.654-64 64-64zM320 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64c0-35.346 28.654-64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"neutral",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60699,
					"grid": 16
				},
				{
					"id": 181,
					"paths": [
						"M486.4 1024c-129.922 0-252.067-50.594-343.936-142.464s-142.464-214.014-142.464-343.936c0-129.923 50.595-252.067 142.464-343.936s214.013-142.464 343.936-142.464c129.922 0 252.067 50.595 343.936 142.464s142.464 214.014 142.464 343.936-50.594 252.067-142.464 343.936c-91.869 91.87-214.014 142.464-343.936 142.464zM486.4 102.4c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2 435.2-195.23 435.2-435.2-195.23-435.2-435.2-435.2z",
						"M691.2 665.6h-409.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M640 409.6c-42.349 0-76.8-34.453-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.451 76.8-76.8 76.8zM640 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M332.8 409.6c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.453 76.8-76.8 76.8zM332.8 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"neutral",
						"emoticon"
					],
					"defaultCode": 59478,
					"grid": 20
				},
				{
					"id": 1936,
					"paths": [
						"M896 192h-768c-70.4 0-128 57.6-128 128v448c0 70.4 57.6 128 128 128h768c70.398 0 128-57.6 128-128v-448c0-70.4-57.602-128-128-128zM320 704h-64l-128-213.334v213.334h-64v-320h64l128 213.334v-213.334h64v320zM576 448h-128v64h128v64h-128v64h128v63.998l-192 0.002v-320h192v64zM960 704h-95.998l-64.002-128-64 128h-96v-320h64v256l64-128h64.002l63.998 127.996v-255.996h64v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"new",
						"news",
						"advertisement"
					],
					"defaultCode": 59771,
					"grid": 16
				},
				{
					"id": 3294,
					"paths": [
						"M704 832h-512v-512h288l128-128h-544v768h768v-544l-128 128v288z",
						"M1024 0h-416l160 160-480 480 96 96 480-480 160 160v-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"new-tab",
						"out",
						"external",
						"outside",
						"popout",
						"link",
						"blank"
					],
					"defaultCode": 61129,
					"grid": 16
				},
				{
					"id": 3295,
					"paths": [
						"M192 64v768h768v-768h-768zM896 768h-640v-640h640v640zM128 896v-672l-64-64v800h800l-64-64h-672z",
						"M352 256l160 160-192 192 96 96 192-192 160 160v-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"new-tab",
						"out",
						"external",
						"outside",
						"popout",
						"link",
						"blank"
					],
					"defaultCode": 61130,
					"grid": 16
				},
				{
					"id": 1824,
					"paths": [
						"M896 256v-128h-896v704c0 35.346 28.654 64 64 64h864c53.022 0 96-42.978 96-96v-544h-128zM832 832h-768v-640h768v640zM128 320h640v64h-640zM512 448h256v64h-256zM512 576h256v64h-256zM512 704h192v64h-192zM128 448h320v320h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"newspaper",
						"news",
						"paper"
					],
					"defaultCode": 59659,
					"grid": 16
				},
				{
					"id": 1625,
					"width": 1170.288070678711,
					"paths": [
						"M585.143 292.571h-219.429v219.429h219.429v-219.429zM658.286 658.286v73.143h-365.714v-73.143h365.714zM658.286 219.429v365.714h-365.714v-365.714h365.714zM1024 658.286v73.143h-292.571v-73.143h292.571zM1024 512v73.143h-292.571v-73.143h292.571zM1024 365.714v73.143h-292.571v-73.143h292.571zM1024 219.429v73.143h-292.571v-73.143h292.571zM146.286 768v-548.571h-73.143v548.571q0 14.857 10.857 25.714t25.714 10.857 25.714-10.857 10.857-25.714zM1097.143 768v-621.714h-877.714v621.714q0 18.857-6.286 36.571h847.429q14.857 0 25.714-10.857t10.857-25.714zM1170.286 73.143v694.857q0 45.714-32 77.714t-77.714 32h-950.857q-45.714 0-77.714-32t-32-77.714v-621.714h146.286v-73.143h1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"newspaper-o"
					],
					"defaultCode": 61930,
					"grid": 14
				},
				{
					"id": 2967,
					"paths": [
						"M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512-512-229.23-512-512 229.23-512 512-512zM512 928c229.75 0 416-186.25 416-416s-186.25-416-416-416-416 186.25-416 416 186.25 416 416 416z",
						"M576 512l-256-192v384z",
						"M704 320h-128v384h128v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"next",
						"player"
					],
					"defaultCode": 60802,
					"grid": 16
				},
				{
					"id": 2978,
					"paths": [
						"M768 128v768h-128v-352l-320 320v-704l320 320v-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"next",
						"player"
					],
					"defaultCode": 60813,
					"grid": 16
				},
				{
					"id": 2115,
					"paths": [
						"M864 64h-704c-17.672 0-32 14.328-32 32v96h-64c-35.346 0-64 28.654-64 64s28.654 64 64 64h64v64h-64c-35.346 0-64 28.654-64 64s28.654 64 64 64h64v64h-64c-35.346 0-64 28.654-64 64s28.654 64 64 64h64v64h-64c-35.346 0-64 28.654-64 64s28.654 64 64 64h64v96c0 17.674 14.328 32 32 32h704c52.936 0 96-43.064 96-96v-768c0-52.934-43.064-96-96-96zM192 896c35.346 0 64-28.654 64-64s-28.654-64-64-64v-64c35.346 0 64-28.654 64-64s-28.654-64-64-64v-64c35.346 0 64-28.654 64-64s-28.654-64-64-64v-64c35.346 0 64-28.654 64-64s-28.654-64-64-64v-64h128v832h-128v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"notebook",
						"notes",
						"book",
						"journal"
					],
					"defaultCode": 59950,
					"grid": 16
				},
				{
					"id": 2918,
					"paths": [
						"M512 96c-111.118 0-215.584 43.272-294.156 121.844s-121.844 183.038-121.844 294.156c0 111.118 43.272 215.584 121.844 294.156s183.038 121.844 294.156 121.844c111.118 0 215.584-43.272 294.156-121.844s121.844-183.038 121.844-294.156c0-111.118-43.272-215.584-121.844-294.156s-183.038-121.844-294.156-121.844zM512 0v0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512zM448 704h128v128h-128zM448 192h128v384h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"notification",
						"warning",
						"notice",
						"note",
						"exclamation"
					],
					"defaultCode": 60753,
					"grid": 16
				},
				{
					"id": 2919,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576 832h-128v-128h128v128zM576 576h-128v-384h128v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"notification",
						"warning",
						"notice",
						"note",
						"exclamation"
					],
					"defaultCode": 60754,
					"grid": 16
				},
				{
					"id": 3365,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM832 832h-128v-512h-192v512h-320v-640h640v640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"npm",
						"brand"
					],
					"defaultCode": 61200,
					"grid": 16
				},
				{
					"id": 1710,
					"width": 1170.2849426269531,
					"paths": [
						"M1170.286 219.429h-73.143v585.143h73.143v219.429h-219.429v-73.143h-731.429v73.143h-219.429v-219.429h73.143v-585.143h-73.143v-219.429h219.429v73.143h731.429v-73.143h219.429v219.429zM1024 73.143v73.143h73.143v-73.143h-73.143zM73.143 73.143v73.143h73.143v-73.143h-73.143zM146.286 950.857v-73.143h-73.143v73.143h73.143zM950.857 877.714v-73.143h73.143v-585.143h-73.143v-73.143h-731.429v73.143h-73.143v585.143h73.143v73.143h731.429zM1097.143 950.857v-73.143h-73.143v73.143h73.143zM731.429 365.714h219.429v438.857h-512v-146.286h-219.429v-438.857h512v146.286zM292.571 585.143h365.714v-292.571h-365.714v292.571zM877.714 731.429v-292.571h-146.286v219.429h-219.429v73.143h365.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"object-group"
					],
					"defaultCode": 62023,
					"grid": 14
				},
				{
					"id": 1711,
					"width": 1316.5691528320312,
					"paths": [
						"M1316.571 438.857h-73.143v365.714h73.143v219.429h-219.429v-73.143h-512v73.143h-219.429v-219.429h73.143v-73.143h-219.429v73.143h-219.429v-219.429h73.143v-365.714h-73.143v-219.429h219.429v73.143h512v-73.143h219.429v219.429h-73.143v73.143h219.429v-73.143h219.429v219.429zM1170.286 292.571v73.143h73.143v-73.143h-73.143zM804.571 73.143v73.143h73.143v-73.143h-73.143zM73.143 73.143v73.143h73.143v-73.143h-73.143zM146.286 731.429v-73.143h-73.143v73.143h73.143zM877.714 658.286h-73.143v73.143h73.143v-73.143zM219.429 658.286h512v-73.143h73.143v-365.714h-73.143v-73.143h-512v73.143h-73.143v365.714h73.143v73.143zM512 950.857v-73.143h-73.143v73.143h73.143zM1243.429 950.857v-73.143h-73.143v73.143h73.143zM1170.286 804.571v-365.714h-73.143v-73.143h-219.429v219.429h73.143v219.429h-219.429v-73.143h-219.429v73.143h73.143v73.143h512v-73.143h73.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"object-ungroup"
					],
					"defaultCode": 62024,
					"grid": 14
				},
				{
					"id": 1070,
					"width": 1024,
					"paths": [
						"M960 512v-128c0-123.52-100.512-224-224-224h-148.096l-81.888-114.592c-8.096-11.328-22.528-16.096-35.808-11.872-13.216 4.224-22.208 16.544-22.208 30.464v55.136l-24.544 40.864h-135.456c-123.488 0-224 100.48-224 224v128h-64v64h96c17.696 0 32-14.336 32-32v-160c0-88.224 71.776-160 160-160h134.4l-19.2 32h-51.2l21.344 64h-21.344v32h320v-32h-21.344l21.344-64h-54.848l-22.848-32h141.696c88.224 0 160 71.776 160 160v160c0 17.664 14.304 32 32 32h96v-64h-64zM480 190.208v65.792h-39.488l39.488-65.792zM616.928 320h-209.856l-10.656-32h231.2l-10.688 32zM512 256v-92.128l65.824 92.128h-65.824zM0 928h1024v64h-1024v-64zM256 736v64h64v32h-32v32h544v-32h-32v-48c0-44.096-35.872-80-80-80s-80 35.904-80 80v48h-32v-48c0-44.096-35.872-80-80-80s-80 35.904-80 80v48h-32v-48c0-44.096-35.872-80-80-80h-48c-17.664 0-32 14.336-32 32zM672 784c0-26.464 21.536-48 48-48s48 21.536 48 48v48h-32v-48c0-8.832-7.168-16-16-16s-16 7.168-16 16v48h-32v-48zM480 784c0-26.464 21.536-48 48-48s48 21.536 48 48v48h-32v-48c0-8.832-7.168-16-16-16s-16 7.168-16 16v48h-32v-48zM384 784v48h-32v-64h-64v-32h48c26.464 0 48 21.536 48 48zM704 576c17.696 0 32-14.336 32-32v-64c0-52.928-43.072-96-96-96h-256c-52.928 0-96 43.072-96 96v64c0 17.664 14.304 32 32 32h384zM352 480c0-17.632 14.336-32 32-32h256c17.664 0 32 14.368 32 32v32h-320v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"obviate",
						"bypass",
						"avoid",
						"endanger"
					],
					"grid": 32
				},
				{
					"id": 1736,
					"width": 731.4248657226562,
					"paths": [
						"M365.714 518.286q-107.429 0-183.429-76t-76-182.857q0-107.429 76-183.429t183.429-76 183.429 76 76 183.429q0 106.857-76 182.857t-183.429 76zM365.714 131.429q-52.571 0-90 37.429t-37.429 90.571q0 52.571 37.429 90t90 37.429 90-37.429 37.429-90q0-53.143-37.429-90.571t-90-37.429zM664.571 549.714q7.429 15.429 8.571 28.286t-2.571 23.143-15.143 22-24.286 21.143-35.143 23.714q-65.714 41.714-180 53.714l41.714 41.143 152.571 152.571q17.143 17.714 17.143 42.286t-17.143 41.714l-6.857 7.429q-17.714 17.143-42.286 17.143t-42.286-17.143q-38.286-38.857-152.571-153.143l-152.571 153.143q-17.714 17.143-42.286 17.143t-41.714-17.143l-6.857-7.429q-17.714-17.143-17.714-41.714t17.714-42.286l193.714-193.714q-116-12-181.143-53.714-22.286-14.286-35.143-23.714t-24.286-21.143-15.143-22-2.571-23.143 8.571-28.286q5.714-11.429 16-20t24-12.571 32 1.143 37.143 20q2.857 2.286 8.571 6.286t24.571 14 39.429 17.429 52.571 13.714 64.571 6.286q52 0 99.429-14.571t68.571-28.857l21.714-14.286q18.857-14.857 37.143-20t32-1.143 24 12.571 16 20z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"odnoklassniki"
					],
					"defaultCode": 62051,
					"grid": 14
				},
				{
					"id": 1737,
					"width": 877.7129821777344,
					"paths": [
						"M529.714 331.429q0 37.714-26.571 64.286t-64.286 26.571-64.286-26.571-26.571-64.286 26.571-64.286 64.286-26.571 64.286 26.571 26.571 64.286zM652 538.857q-5.714-11.429-16-18.286t-27.143-5.429-34.571 15.714q-5.714 4.571-16.571 11.429t-46.286 18.286-72.571 11.429-70.857-10.286-49.143-20.571l-15.429-10.286q-17.714-14.286-34.571-15.714t-27.143 5.429-16 18.286q-12.571 25.714-1.143 42.571t49.714 42q47.429 30.286 129.143 38.286l-29.143 29.714q-81.143 81.143-109.143 108.571-12.571 12.571-12.571 30t12.571 30l5.143 5.143q12.571 12.571 30 12.571t30-12.571l109.143-109.143q65.143 65.714 109.143 109.143 12.571 12.571 30 12.571t30-12.571l5.143-5.143q12.571-12.571 12.571-30t-12.571-30l-109.143-108.571-29.714-29.714q80.571-8 128.571-38.286 38.286-25.143 49.714-42t-1.143-42.571zM624 331.429q0-76.571-54.286-130.857t-130.857-54.286-130.857 54.286-54.286 130.857 54.286 130.857 130.857 54.286 130.857-54.286 54.286-130.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"odnoklassniki-square"
					],
					"defaultCode": 62052,
					"grid": 14
				},
				{
					"id": 1822,
					"paths": [
						"M0 1024h512v-1024h-512v1024zM320 128h128v128h-128v-128zM320 384h128v128h-128v-128zM320 640h128v128h-128v-128zM64 128h128v128h-128v-128zM64 384h128v128h-128v-128zM64 640h128v128h-128v-128zM576 320h448v64h-448zM576 1024h128v-256h192v256h128v-576h-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"office",
						"buildings",
						"work"
					],
					"defaultCode": 59657,
					"grid": 16
				},
				{
					"id": 3254,
					"paths": [
						"M704 896h256l64-128v256h-384v-214.214c131.112-56.484 224-197.162 224-361.786 0-214.432-157.598-382.266-352-382.266-194.406 0-352 167.832-352 382.266 0 164.624 92.886 305.302 224 361.786v214.214h-384v-256l64 128h256v-32.59c-187.63-66.46-320-227.402-320-415.41 0-247.424 229.23-448 512-448s512 200.576 512 448c0 188.008-132.37 348.95-320 415.41v32.59z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"omega",
						"wysiwyg",
						"symbols"
					],
					"defaultCode": 61089,
					"grid": 16
				},
				{
					"id": 3363,
					"paths": [
						"M350.868 828.388c-60.274-15.060-93.856-62.97-93.962-134.064-0.032-22.726 1.612-33.62 7.286-48.236 13.908-35.834 50.728-62.872 99.176-72.822 24.11-4.95 31.536-10.266 31.536-22.572 0-3.862 2.872-15.36 6.378-25.552 15.932-46.306 45.43-84.91 76.948-100.702 32.99-16.526 49.642-20.254 89.548-20.040 56.674 0.304 84.952 12.598 124.496 54.128l21.75 22.842 19.484-6.742c94.3-32.636 188.306 22.916 195.888 115.756l2.072 25.398 18.57 6.65c53.032 19.004 77.96 58.904 73.442 117.556-2.958 38.358-20.89 68.98-49.3 84.184l-13.356 7.146-296.822 0.57c-228.094 0.44-300.6-0.368-313.134-3.5v0zM103.218 785.966c-36.176-9.086-74.506-42.854-92.48-81.47-10.196-21.906-10.738-25.128-10.738-63.88 0-36.864 0.87-42.778 8.988-61.080 17.11-38.582 49.894-66.46 91.030-77.408 8.684-2.312 16.842-6 18.128-8.196 1.29-2.198 2.722-14.164 3.182-26.592 2.866-77.196 50.79-145.214 117.708-167.056 36.154-11.8 83.572-12.898 122.896 3.726 12.47 5.274 11.068 6.404 37.438-30.14 15.594-21.612 45.108-44.49 70.9-58.18 27.838-14.776 56.792-21.584 91.412-21.494 96.768 0.252 180.166 64.22 211.004 161.848 9.854 31.192 9.362 39.926-2.26 40.184-5.072 0.112-19.604 3.064-32.292 6.558l-23.072 6.358-21.052-22.25c-59.362-62.734-156.238-76.294-238.592-33.396-32.9 17.138-59.34 41.746-79.31 73.81-14.236 22.858-32.39 65.504-32.39 76.094 0 7.51-5.754 11.264-30.332 19.782-76.094 26.376-120.508 87.282-120.476 165.218 0.010 28.368 6.922 63.074 16.52 82.956 3.618 7.494 5.634 14.622 4.484 15.836-2.946 3.106-97.608 2.060-110.696-1.228v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"onedrive",
						"brand",
						"skydrive"
					],
					"defaultCode": 61198,
					"grid": 16
				},
				{
					"id": 661,
					"width": 1024,
					"paths": [
						"M896 192h-32v-32c0-53.024-42.976-96-96-96h-512c-53.024 0-96 42.976-96 96v32h-32c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM864 224h32c11.84 0 22.784 3.456 32.32 9.056l-64.32 64.32v-73.376zM192 160c0-35.296 28.704-64 64-64h512c35.296 0 64 28.704 64 64v169.376l-320 320-320-320v-169.376zM128 224h32v73.376l-64.32-64.32c9.536-5.6 20.48-9.056 32.32-9.056zM64 864v-576c0-11.84 3.456-22.784 9.056-32.32l320.32 320.32-320.32 320.32c-5.6-9.536-9.056-20.48-9.056-32.32zM896 928h-768c-11.84 0-22.784-3.456-32.32-9.056l320.32-320.32 73.376 73.376c12.512 12.512 32.768 12.512 45.248 0l73.376-73.376 320.32 320.32c-9.536 5.6-20.48 9.056-32.32 9.056zM960 864c0 11.84-3.456 22.784-9.056 32.32l-320.32-320.32 320.32-320.32c5.6 9.536 9.056 20.48 9.056 32.32v576zM384 240c0-8.832 7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16zM384 304c0-8.832 7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16zM624 384h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"open",
						"send",
						"write",
						"mail"
					],
					"grid": 32
				},
				{
					"id": 662,
					"width": 1024,
					"paths": [
						"M160 297.376l352 352 352-352v-137.376c0-53.024-42.976-96-96-96h-512c-53.024 0-96 42.976-96 96v137.376zM400 224h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16zM400 288h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16zM400 352h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16zM992 288v576c0 53.024-42.976 96-96 96h-768c-53.024 0-96-42.976-96-96v-576c0-53.024 42.976-96 96-96v73.376l-20.672-20.704c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l308.672 308.704-308.672 308.672c-6.24 6.24-6.24 16.384 0 22.624 3.104 3.136 7.2 4.704 11.296 4.704s8.192-1.568 11.328-4.672l308.672-308.704 84.672 84.672c3.136 3.136 7.232 4.704 11.328 4.704s8.192-1.568 11.328-4.672l84.672-84.704 308.672 308.672c3.136 3.136 7.232 4.704 11.328 4.704s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-308.704-308.704 308.672-308.672c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-20.672 20.672v-73.376c53.024 0 96 42.976 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"open",
						"send",
						"write",
						"mail"
					],
					"grid": 32
				},
				{
					"id": 1071,
					"width": 1024,
					"paths": [
						"M998.4 364.8l-102.496-76.864 0.064-63.904c0-17.696-14.304-32.032-32-32.032h-95.968l-236.8-177.6c-5.696-4.256-12.448-6.4-19.2-6.4s-13.504 2.144-19.2 6.4l-236.8 177.6h-96c-17.664 0-32 14.336-32 32v64l-102.4 76.8c-16.128 12.096-25.6 31.040-25.6 51.2v576c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-576c0-20.16-9.472-39.104-25.6-51.2zM957.344 414.016l-93.344 69.984v-140l93.344 70.016zM512 80l192 144h-384l192-144zM192 256h640v252l-133.312 100h-373.376l-133.312-100v-252zM656.032 640l-115.2 86.4c-16.96 12.672-40.672 12.672-57.632 0l-115.2-86.4h288.032zM160 344v140l-93.344-70.016 93.344-69.984zM64 960v-508l400 300c14.112 10.592 31.072 15.904 48 15.904s33.888-5.312 48-15.904l400-300v508h-896zM768 320h-512v32h512v-32zM768 416h-512v32h512v-32zM768 512h-512v32h512v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"open",
						"send",
						"write",
						"mail"
					],
					"grid": 32
				},
				{
					"id": 1701,
					"width": 1317.7101974487305,
					"paths": [
						"M870.857 892q0 38.857-27.429 66.286t-66.286 27.429-66.571-27.429-27.714-66.286 27.714-66.571 66.571-27.714 66.286 27.714 27.429 66.571zM442.857 892q0 38.857-27.714 66.286t-66.571 27.429-66.286-27.429-27.429-66.286 27.429-66.571 66.286-27.714 66.571 27.714 27.714 66.571zM0 38.286q32.571 34.286 63.143 59.714t69.143 46.857 77.714 36 94.857 26 114.286 18 142.857 10.571 173.714 5.429 212.857 1.429q79.429 0 139.714 2.857t103.429 9.429 70.857 15.714 40.571 22.571 13.714 29.429-11.143 36.571-32.286 43.714-51.143 52-66.286 59.714-79.429 68q-105.714 89.714-163.429 141.143 16.571-29.143 43.714-62.286t53.714-60.286 54-56.286 47.429-52.286 30.857-46 7.429-40-26-31.714-66.571-23.429-116.571-13.429-173.714-2.857q-96 1.143-179.429-3.429t-146.286-13.143-116.857-23.429-91.143-29.429-70-35.714-52.286-38-38.857-40.857-28.857-39.714-22.857-38.857-20.857-34z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"opencart"
					],
					"defaultCode": 62013,
					"grid": 14
				},
				{
					"id": 1551,
					"width": 1023.9979858398438,
					"paths": [
						"M620.571 0v877.714l-155.429 73.143q-130.286-11.429-236.571-58.286t-167.429-119.143-61.143-155.714q0-80 57.429-150.571t157.143-117.429 223.714-61.714v98.286q-124 21.714-203.714 85.714t-79.714 145.714q0 86.857 88.286 152.571t222 82.857v-777.143zM1002.857 332.571l21.143 222.857-300-65.143 84-47.429q-68-40-160-56.571v-98.286q158.286 18.857 274.857 89.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"openid"
					],
					"defaultCode": 61851,
					"grid": 14
				},
				{
					"id": 3410,
					"paths": [
						"M1024 512v0 0c0 151.6-66 288-170.8 381.6-131.4 64-253.8 19.2-294.2-8.8 129-28.2 226.4-184.2 226.4-372.8s-97.4-344.6-226.4-373c40.6-28 163-72.8 294.2-8.8 104.8 93.8 170.8 230.2 170.8 381.8v0 0z",
						"M343.4 223.4c-56.6 66.8-93.2 165.6-95.6 276.6 0 0.2 0 23.8 0 24.2 2.4 110.8 39.2 209.6 95.8 276.4 73.4 95.4 182.6 155.8 304.6 155.8 75 0 145.2-22.8 205.2-62.6-90.8 81-210.4 130.2-341.4 130.2-8.2 0-16.4-0.2-24.4-0.6-271.4-12.8-487.6-236.8-487.6-511.4 0-282.8 229.2-512 512-512 0.6 0 1.2 0 2 0 130.4 0.4 249.2 49.6 339.4 130.4-60-39.8-130.2-62.8-205.2-62.8-122 0-231.2 60.4-304.8 155.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"opera",
						"browser",
						"internet",
						"brand"
					],
					"defaultCode": 61245,
					"grid": 16
				},
				{
					"id": 1743,
					"width": 1024.0010375976562,
					"paths": [
						"M853.143 130.286q-94.286-62.857-205.143-62.857-88.571 0-167.429 41.714t-137.143 114.286q-42.857 53.143-68.286 124.571t-27.714 152v24q2.286 80.571 27.714 152t68.286 124.571q58.286 72.571 137.143 114.286t167.429 41.714q110.857 0 205.143-62.857-69.143 61.714-156.857 96t-184.286 34.286q-16.571 0-24.571-0.571-100-4.571-190.286-46.857t-155.429-110.286-103.429-160.571-38.286-193.714q0-104 40.571-198.857t109.143-163.429 163.429-109.143 198.857-40.571h1.714q96 0.571 183.143 34.571t156.286 95.714zM1024 512q0 109.714-44 207.143t-121.714 169.429q-59.429 36-126.857 36-78.286 0-145.714-48 88-32 144.857-133.143t56.857-231.429q0-129.714-56.571-230.857t-144.571-133.714q68-47.429 145.143-47.429 68 0 129.143 37.143 77.143 71.429 120.286 168.571t43.143 206.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"opera"
					],
					"defaultCode": 62058,
					"grid": 14
				},
				{
					"id": 663,
					"width": 1024,
					"paths": [
						"M896 384v-32c0-176.448-143.552-320-320-320h-128c-176.448 0-320 143.552-320 320v32c-53.024 0-96 42.976-96 96v160c0 53.024 42.976 96 96 96h64c17.664 0 32-14.336 32-32v-352c0-123.52 100.512-224 224-224h128c123.488 0 224 100.48 224 224v384c0 88.224-71.776 160-160 160h-32c0-35.36-28.64-64-64-64h-64c-35.36 0-64 28.64-64 64v32c0 35.36 28.64 64 64 64h64c35.36 0 64-28.64 64-64h32c105.888 0 192-86.112 192-192h64c53.024 0 96-42.976 96-96v-160c0-53.024-42.976-96-96-96zM576 928c0 17.632-14.368 32-32 32h-64c-17.632 0-32-14.368-32-32v-32c0-17.632 14.368-32 32-32h64c17.632 0 32 14.368 32 32v32zM192 704h-64c-35.296 0-64-28.704-64-64v-160c0-35.296 28.704-64 64-64h64v288zM576 96h-128c-141.152 0-256 114.848-256 256v32h-32v-32c0-158.784 129.184-288 288-288h128c158.816 0 288 129.216 288 288v32h-32v-32c0-141.152-114.848-256-256-256zM960 640c0 35.296-28.704 64-64 64h-64v-288h64c35.296 0 64 28.704 64 64v160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"operate",
						"hear",
						"listen",
						"speak"
					],
					"grid": 32
				},
				{
					"id": 664,
					"width": 1024,
					"paths": [
						"M992 480v160c0 53.024-42.976 96-96 96h-64c0 105.888-86.112 192-192 192h-32c0 35.36-28.64 64-64 64h-64c-35.36 0-64-28.64-64-64v-32c0-35.36 28.64-64 64-64h64c35.36 0 64 28.64 64 64h32c88.352 0 160-71.648 160-160v-320c0-17.664 14.336-32 32-32v-32c0-141.152-114.848-256-256-256h-128c-141.152 0-256 114.848-256 256v32c17.664 0 32 14.336 32 32v288c0 17.664-14.336 32-32 32h-64c-53.024 0-96-42.976-96-96v-160c0-53.024 42.976-96 96-96v-32c0-176.448 143.552-320 320-320h128c176.448 0 320 143.552 320 320v32c53.024 0 96 42.976 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"operate",
						"hear",
						"listen",
						"speak"
					],
					"grid": 32
				},
				{
					"id": 3194,
					"paths": [
						"M928 832h-256c-12.646 0-24.106-7.448-29.242-19.004l-247.554-556.996h-299.204c-17.672 0-32-14.328-32-32s14.328-32 32-32h320c12.646 0 24.106 7.448 29.242 19.004l247.556 556.996h235.202c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
						"M928 256h-320c-17.674 0-32-14.328-32-32s14.326-32 32-32h320c17.674 0 32 14.328 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"opt",
						"option",
						"alt"
					],
					"defaultCode": 61029,
					"grid": 16
				},
				{
					"id": 1700,
					"width": 1312.0000762939453,
					"paths": [
						"M273.143 957.143q-4.571 9.143-15.429 19.714t-21.143 14.571q-14.286 5.143-29.429-2t-16.286-18q-0.571-12.571 22.857-31.429t38.857-21.714q13.143-2.286 19.429 12.286t1.143 26.571zM1039.429 957.143q4 9.143 14.857 19.714t21.714 14.571q14.286 5.143 29.429-2t15.714-18q1.143-12.571-22.571-31.429t-39.143-21.714q-12.571-2.286-18.857 12.286t-1.143 26.571zM1066.857 894.857q7.429 15.429 32.286 34t44.286 23.714q25.714 7.429 46.857-2.571t21.143-28.857q0-26.286-38.571-57.429t-66-34q-22.857-2.857-36.286 21.429t-3.714 43.714zM244.571 894.857q-7.429 15.429-32 34t-44 23.714q-25.714 7.429-46.857-2.571t-21.143-28.857q0-26.286 38.571-57.429t66-34q22.857-2.857 36 21.429t3.429 43.714zM661.714 252.571h0.571q-23.429 0-43.429 8.571 15.429 4.571 25.143 17.429t9.714 28.286q0 20-15.429 34.286t-37.143 14.286q-29.714 0-45.714-24.571-2.857 13.143-2.857 24 0 42.286 32 72.286t77.143 30q45.714 0 77.714-30t32-72.286-32-72.286-77.714-30zM835.429 128q-56.571-62.286-126-75.143t-140.286 25.429q15.429-34.286 47.143-55.143t67.429-22.571 69.429 9.714 56.857 42.571 25.429 75.143zM1264 836q4.571 6.286-6.286 24 4 13.143 4 22.857 0.571 32-25.429 64.286t-62.571 52.286-67.429 21.143q-27.429 1.143-52.571-12.286t-37.714-37.429q-392.571 14.286-719.429 0-13.143 23.429-38 37.143t-52.857 12.571q-49.143-1.714-102.571-46t-52.857-91.714q1.143-12.571 4-22.857-10.857-17.714-6.286-24 3.429-5.714 17.714-0.571 8-12.571 23.429-29.143-4-16.571 1.143-21.714 6.286-5.714 22.286 2.286 16.571-11.429 33.714-19.429 0-16.571 7.429-21.143 13.143-6.857 29.143 9.143 20-2.857 34.857 1.143 10.286 2.286 21.714 10.857v-41.714q-6.286 0-10.286-1.143-30.286-5.714-55.429-25.429t-31.429-50q-5.143-21.714 0-46.286 8.571-35.429 53.143-54.286 1.143-9.714 10.857-20.286t20.571-13.429 18.857 4.286 10.857 17.429h7.429q26.286 2.857 34.286 13.143 1.714 1.714 2.857 4 5.714-0.571 17.429-2t17.429-2q-8.571-6.286-17.143-9.714-13.143-22.857-52-24.571 0-3.429 0.571-5.714-35.429-1.143-67.714-10.571t-48.286-27.143q-18.286-20.571-24.286-52.571t-1.429-64q9.143-72 51.429-102.286 13.143-9.143 29.714-2.571t18.286 23.143q0 0.571 0.857 8t1.429 12 1.714 11.429 3.143 10.857 4.857 5.714q15.429 8 43.429 6.857 27.429-26.286 56-42.286-22.857-2.286-92.571 8l26.857-26.286q34.857-33.143 93.143-63.429 82.857-41.714 161.143-49.143-11.429-4.571-23.429-8.857t-26.857-8-24.286-6-27.143-6.286-24.571-5.714q340-72 516.571 79.429 56 48 90.286 126.857 48.571 5.714 69.143-5.143h0.571q2.857-1.714 4.857-5.714t3.143-10.857 1.714-11.143 1.714-12.286l0.571-8q1.714-16 18.286-22.857t29.714 2.857q41.714 29.714 52 101.714 4 32.571-2 64.571t-24.286 52q-16 18.286-47.714 27.714t-66 10.571v5.714q-40.571 1.143-54.286 24.571-8 2.857-17.714 9.714 6.286 0.571 18.286 2t17.143 2q0.571-2.286 2.857-4.571 9.143-10.286 34.286-13.143h7.429q2.857-10.286 10.857-17.143t18.857-4.571 20.571 13.143 10.857 20.571q45.143 18.286 53.143 54.286 5.143 22.857 0.571 46.286-6.857 30.286-32 50.286t-55.429 25.143q-5.714 1.143-9.714 1.143 0 28-0.571 41.714 11.429-8.571 21.714-10.857 14.857-4 34.857-1.143 16-16 29.143-9.143 8 5.143 8 21.143 18.857 9.143 33.714 19.429 15.429-7.429 21.714-2.286 5.714 5.714 1.143 21.714 16 17.143 23.429 29.143 13.143-4.571 17.714 0.571zM1106.857 292q0 16.571-5.143 30.857 46.857 18.286 64 75.429 2.286-21.143-5.429-56.286t-23.714-51.714q-11.429-10.857-20.571-9.714t-9.143 11.429zM1062.286 349.143q20 24 27.143 62t-0.286 71.143q38.286-7.429 55.429-25.714 7.429-8 10.286-16-1.714-36.571-17.714-65.429t-45.143-38q-8.571 8.571-29.714 12zM1041.143 351.429q-17.143 0-25.143-0.571 24 65.714 30.286 136.571 12 0 24.571-1.714 9.143-38.857 0.571-77.143t-30.286-57.143zM147.429 398.286q17.143-57.143 64-75.429-5.143-14.286-5.143-30.857 0-10.286-9.429-11.429t-20.286 9.714q-16 16.571-23.714 51.714t-5.429 56.286zM168 456.571q16.571 17.714 55.429 25.714-7.429-33.143-0.286-71.143t27.143-62v0q-21.143-3.429-29.714-12-29.143 9.143-44.857 37.714t-18 65.714q5.143 9.714 10.286 16zM269.143 487.429q8-70.857 41.714-134.286-10.857 2.286-31.429 10.286l-25.714 10.857v-0.571q-26.286 50.857-11.429 112 14.286 1.714 26.857 1.714zM819.429 509.714q4.571 21.714 9.429 62t6.571 51.143q1.714 10.286 5.429 12.286t13.429-2.571q22.857-11.429 35.429-48.857t13.143-71.714q-13.714-1.143-83.429-2.286zM658.286 143.429q-66.286 0-113.714 47.143t-47.429 113.429q0 66.857 47.429 114t113.714 47.143 113.714-47.143 47.429-114q0-66.286-47.429-113.429t-113.714-47.143zM788.571 508.571q-60.571-1.143-120.571 0v-0.571q-0.571 15.429 1.429 49.143t7.714 37.714q16.571 8 53.429 8.286t54.571-6q5.143-1.714 6.286-22.286t-0.286-39.714-2.571-26.571zM635.429 622.286q4.571-2.286 5.429-27.429t-0.286-50.286-2.286-36v-0.571q-121.143 1.714-122.286 1.714-2.286 11.429-4 35.429t0 47.429 8 26.286q19.429 8.571 57.714 9.143t57.714-5.714zM410.286 514.286q-9.143 33.714 2.571 67.714t44.286 48.286q8.571 4.571 13.714 2.857t6.857-12q1.714-9.143 4.571-51.429t5.714-58.857q-39.429 1.143-77.714 3.429zM337.714 586.286q1.714 13.143-19.429 20.571 75.429 80.571 155.143 137.143t174.571 88q98.286-28 177.429-83.429t167.714-142.857q-18.857-7.429-17.143-19.429l1.714-5.143q-9.714-1.143-28.571-3.143t-27.429-2.571q-14.857 51.429-46.857 75.429-29.143 21.714-46.857-0.571-2.857-3.429-5.143-8-4-7.429-9.714-35.429-1.143 2.857-2.857 5.143t-4.286 4-4.571 3.143-5.429 2.286l-5.714 1.429t-6.857 1.143l-6.857 0.857t-7.714 0.571-7.714 0.286q-60.571 5.143-93.143-6.286-2.286 9.714-5.714 15.143t-12 8.571-13.143 4-20.571 2q-1.143 0-1.714 0.286t-1.714 0.286h-1.714q-102.286 9.714-116-22.857-1.143 36-32 30.857-26.857-4.571-52-30.857-6.857-7.429-11.429-14.857-9.714-16.571-14.857-37.143-33.143 3.429-49.714 5.714 0.571 1.143 2.286 5.714zM289.714 945.143q1.714-8 1.714-17.143-9.714-40.571-29.143-74.286t-41.714-40q-23.429-6.857-58 8.286t-59.714 45.714-22.286 61.429q20 30.286 57.143 53.143t68 24q29.143 1.143 53.714-16t30.286-45.143zM291.429 847.429q13.143 36 15.429 68 111.429-64.571 224-99.429-56-29.714-103.143-68.571t-102.571-94.286q-3.429 2.286-16.571 7.429 0 1.143-0.571 2.857t-0.571 2.286q17.714 10.286 12.571 21.143-6.857 13.143-32 19.429-5.714 7.429-16.571 13.714h-0.571q-1.143 47.429 0.571 85.714 10.857 19.429 20 41.714zM330.857 942.286q304 12 654.286 0-145.143-84-244.571-112-43.429 20-89.143 32.571-4.571 1.714-9.143 0-37.143-12-73.714-28-118.857 34.286-237.714 107.429h-0.571v0.571q0.571 0 0.571-0.571zM1007.429 916q2.286-30.857 16-68.571 8-21.714 18.857-40.571l-0.571 0.571q1.714-44 1.714-87.429-8.571-4.571-17.143-14.286-24-5.143-32-18.857-5.143-11.429 12.571-21.714-1.143-2.286-1.143-5.143-9.143-2.286-16-6.857-116.571 108.571-218.857 162.286 113.143 33.714 236.571 100.571zM1231.429 929.143q2.857-30.857-22.286-61.429t-59.429-45.714-58.286-8.286q-21.714 6.286-41.429 40.286t-29.429 74q0 9.143 1.714 17.143 5.714 28 30.286 45.143t53.714 16q30.857-1.143 68-24t57.143-53.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"optin-monster"
					],
					"defaultCode": 62012,
					"grid": 14
				},
				{
					"id": 665,
					"width": 1024,
					"paths": [
						"M320 608h-192c-17.664 0-32 14.336-32 32v224c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-224c0-17.664-14.336-32-32-32zM320 864h-192v-224h192v224zM320 352h-192c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32zM320 544h-192v-160h192v160zM608 128h-192c-17.664 0-32 14.336-32 32v256c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-256c0-17.664-14.336-32-32-32zM608 416h-192v-256h192v256zM608 480h-192c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM608 640h-192v-128h192v128zM896 640h-192c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32zM896 864h-192v-192h192v192zM896 128h-192c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32zM896 320h-192v-160h192v160zM352 144c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM352 208c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM352 272c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM640 752c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM640 816c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM640 880c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM928 432c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM928 496c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM928 560c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"organize",
						"format",
						"read"
					],
					"grid": 32
				},
				{
					"id": 666,
					"width": 1024,
					"paths": [
						"M320 608h-192c-17.664 0-32 14.336-32 32v224c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-224c0-17.664-14.336-32-32-32zM320 352h-192c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32zM608 128h-192c-17.664 0-32 14.336-32 32v256c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-256c0-17.664-14.336-32-32-32zM608 480h-192c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM896 640h-192c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32zM896 128h-192c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32zM352 144c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM352 208c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM352 272c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM640 752c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM640 816c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM640 880c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM928 432c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM928 496c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM928 560c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"organize",
						"format",
						"read"
					],
					"grid": 32
				},
				{
					"id": 2660,
					"paths": [
						"M256 320h64v256h-64zM704 320h64v192h-64zM759.992 64h-495.984c-157.432 87.334-264.008 255.208-264.008 448s106.576 360.666 264.008 448h495.984c157.432-87.334 264.008-255.208 264.008-448s-106.576-360.666-264.008-448zM742.836 896h-461.672c-62.716-37.792-115.526-90.574-153.36-153.452-41.74-69.368-63.804-149.090-63.804-230.548s22.064-161.178 63.804-230.55c37.836-62.876 90.644-115.658 153.36-153.45h461.672c62.714 37.792 115.526 90.574 153.36 153.45 41.742 69.372 63.804 149.094 63.804 230.55 0 81.458-22.062 161.18-63.804 230.548-37.834 62.878-90.644 115.66-153.36 153.452zM512 640c-70.692 0-128 28.654-128 64v128h256v-128c0-35.346-57.306-64-128-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"outlet",
						"power"
					],
					"defaultCode": 60495,
					"grid": 16
				},
				{
					"id": 667,
					"width": 1024,
					"paths": [
						"M224 672h122.464c-16.512 28.288-26.464 60.864-26.464 96 0 106.048 85.952 192 192 192s192-85.952 192-192c0-35.136-9.952-67.712-26.464-96h122.464c35.36 0 64-28.64 64-64s-28.64-64-64-64h-32v-9.632c0-33.728-17.696-64.96-46.624-82.336l-66.784-40.064c-28.896-17.344-46.592-48.608-46.592-82.336v-0.032c0-27.36 6.368-54.368 18.624-78.848l3.264-6.496c6.656-13.312 10.112-28 10.112-42.912v-9.344c0-70.688-57.312-128-128-128s-128 57.312-128 128v9.344c0 14.912 3.456 29.6 10.144 42.944l3.264 6.496c12.224 24.48 18.592 51.456 18.592 78.848v0.032c0 33.728-17.696 64.96-46.624 82.304l-66.784 40.064c-28.896 17.344-46.592 48.608-46.592 82.336v9.632h-32c-35.36 0-64 28.64-64 64s28.64 64 64 64zM512 928c-88.224 0-160-71.776-160-160 0-36.192 12.64-69.184 32.992-96h43.616c-27.136 23.36-44.608 57.472-44.608 96 0 70.592 57.408 128 128 128s128-57.408 128-128c0-38.528-17.472-72.64-44.608-96h43.616c20.352 26.816 32.992 59.808 32.992 96 0 88.224-71.776 160-160 160zM512 672c53.024 0 96 42.976 96 96s-42.976 96-96 96-96-42.976-96-96 42.976-96 96-96zM288 534.368c0-22.368 11.904-43.392 31.072-54.88l66.784-40.064c38.336-23.008 62.144-65.088 62.144-109.792 0-32.16-7.616-64.384-21.984-93.152l-3.264-6.496c-4.416-8.864-6.752-18.752-6.752-28.64v-9.344c0-52.928 43.072-96 96-96s96 43.072 96 96v9.344c0 9.888-2.336 19.776-6.752 28.608l-3.264 6.496c-14.368 28.8-21.984 61.024-21.984 93.184 0 44.704 23.808 86.752 62.144 109.76l66.784 40.064c19.168 11.52 31.072 32.544 31.072 54.912v9.632h-448v-9.632zM224 576h576c17.632 0 32 14.368 32 32s-14.368 32-32 32h-576c-17.632 0-32-14.368-32-32s14.368-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pacify",
						"quiet",
						"calm"
					],
					"grid": 32
				},
				{
					"id": 668,
					"width": 1024,
					"paths": [
						"M800 544h-576c-35.36 0-64 28.64-64 64s28.64 64 64 64h122.464c-16.512 28.288-26.464 60.864-26.464 96 0 106.048 85.952 192 192 192s192-85.952 192-192c0-35.136-9.952-67.712-26.464-96h122.464c35.36 0 64-28.64 64-64s-28.64-64-64-64zM512 864c-53.024 0-96-42.976-96-96s42.976-96 96-96 96 42.976 96 96-42.976 96-96 96zM258.912 512c5.952-24.768 21.344-46.56 43.68-59.968l66.784-40.064c28.928-17.344 46.624-48.608 46.624-82.336v-0.032c0-27.36-6.368-54.368-18.624-78.848l-3.264-6.496c-6.656-13.312-10.112-28-10.112-42.912v-9.344c0-70.688 57.312-128 128-128s128 57.312 128 128v9.344c0 14.912-3.456 29.6-10.144 42.944l-3.264 6.496c-12.224 24.48-18.592 51.456-18.592 78.848v0.032c0 33.728 17.696 64.96 46.624 82.304l66.784 40.064c22.368 13.408 37.76 35.2 43.68 59.968h-506.176z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pacify",
						"quiet",
						"calm"
					],
					"grid": 32
				},
				{
					"id": 1072,
					"width": 1024,
					"paths": [
						"M850.24 255.584c-42.88-151.136-180.128-255.584-338.24-255.584s-295.36 104.448-338.24 255.584c-110.624 72.896-173.76 177.376-173.76 288.416 0 128.096 83.552 246.176 224.096 317.696 53.344 98.976 165.056 162.304 287.904 162.304s234.56-63.328 287.904-162.304c140.544-71.52 224.096-189.6 224.096-317.696 0-111.040-63.136-215.52-173.76-288.416zM64 544c0-176.448 200.96-320 448-320s448 143.552 448 320c0 100.608-65.472 190.4-167.456 249.12 4.736-18.4 7.456-37.472 7.456-57.12 0-75.776-37.088-143.84-95.968-190.72-19.808-15.776-32.032-39.136-32.032-64.48v-0.8c0-17.664-14.336-32-32-32h-256c-17.664 0-32 14.336-32 32v0.8c0 25.312-12.224 48.704-32.032 64.48-58.88 46.88-95.968 114.944-95.968 190.72 0 19.616 2.72 38.656 7.424 57.024-0.256-0.128-0.48-0.256-0.704-0.384-101.536-58.72-166.72-148.288-166.72-248.64zM353.28 212.128c0 0 0 0 0 0 34.592-50.752 92.832-84.128 158.72-84.128s124.128 33.376 158.72 84.096c0 0 0 0 0 0-49.76-12.768-103.008-20.096-158.72-20.096s-108.96 7.328-158.72 20.128zM512 960c-141.152 0-256-100.48-256-224 0-62.88 30.56-123.264 83.872-165.696 28.032-22.304 44.128-54.912 44.128-90.304h256v0.8c0 34.56 16.096 67.2 44.128 89.504 53.312 42.432 83.872 102.816 83.872 165.696 0 123.52-114.848 224-256 224zM512 64c122.144 0 228.928 76.32 269.984 188.992-21.184-10.592-43.776-19.68-67.2-27.712-35.712-76.288-112.96-129.28-202.784-129.28s-167.072 52.992-202.784 129.28c-23.424 8.032-46.016 17.12-67.2 27.712 41.056-112.672 147.84-188.992 269.984-188.992z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pacify",
						"quiet",
						"calm"
					],
					"grid": 32
				},
				{
					"id": 669,
					"width": 1024,
					"paths": [
						"M864 256c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32h-64v-64c0-53.024-42.976-96-96-96h-128c-53.024 0-96 42.976-96 96v64h-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32-53.024 0-96 42.976-96 96v448c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-448c0-53.024-42.976-96-96-96zM768 256h64v128h-64v-128zM384 192c0-35.36 28.64-64 64-64h128c35.36 0 64 28.64 64 64v64h-32v-64c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v64h-32v-64zM576 192v64h-128v-64h128zM192 256h64v128h-64v-128zM928 800c0 35.36-28.64 64-64 64h-704c-35.36 0-64-28.64-64-64v-448c0-35.36 28.64-64 64-64v96c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-96h448v96c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-96c35.36 0 64 28.64 64 64v448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pack",
						"travel",
						"work",
						"carry"
					],
					"grid": 32
				},
				{
					"id": 670,
					"width": 1024,
					"paths": [
						"M256 384h-64v-128h64v128zM832 256h-64v128h64v-128zM960 352v448c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-448c0-53.024 42.976-96 96-96v128c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-128h64v-64c0-52.928 43.072-96 96-96h128c52.928 0 96 43.072 96 96v64h64v128c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-128c53.024 0 96 42.976 96 96zM608 192c0-17.632-14.336-32-32-32h-128c-17.664 0-32 14.368-32 32v64h192v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pack",
						"travel",
						"work",
						"carry"
					],
					"grid": 32
				},
				{
					"id": 2611,
					"paths": [
						"M704 0l-640 128v704l192 192 640-128v-704l-192-192zM688.222 52.106l151.208 151.208-526.864 105.374-151.206-151.21 526.862-105.372zM320 356.15l8-1.6v606.098l-8 1.602v-606.1zM344 351.35l16-3.2v606.1l-16 3.2v-606.1zM376 344.95l16-3.2v606.098l-16 3.2v-606.098zM408 338.55l16-3.2v606.098l-16 3.2v-606.098zM440 332.15l16-3.2v606.098l-16 3.202v-606.1zM472 325.75l16-3.2v606.1l-16 3.2v-606.1zM504 319.35l16-3.2v606.1l-16 3.2v-606.1zM536 312.952l16-3.2v606.098l-16 3.2v-606.098zM568 306.55l16-3.2v606.098l-16 3.202v-606.1zM600 300.15l16-3.2v606.1l-16 3.2v-606.1zM632 293.75l16-3.2v606.1l-16 3.2v-606.1zM664 287.35l16-3.2v606.1l-16 3.2v-606.1zM696 280.952l16-3.2v606.098l-16 3.202v-606.1zM728 274.55l16-3.2v606.098l-16 3.202v-606.1zM760 268.15l16-3.2v606.1l-16 3.2v-606.1zM792 261.75l16-3.2v606.1l-16 3.2v-606.1zM824 255.35l8-1.6v606.098l-8 1.602v-606.1z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"package",
						"box",
						"book",
						"dualtone"
					],
					"defaultCode": 60446,
					"grid": 16
				},
				{
					"id": 1923,
					"paths": [
						"M964.73 178.804c-93.902-109.45-233.21-178.804-388.73-178.804-282.77 0-512 229.23-512 512s229.23 512 512 512c155.52 0 294.828-69.356 388.728-178.804l-324.728-333.196 324.73-333.196zM704 120.602c39.432 0 71.398 31.964 71.398 71.398 0 39.432-31.966 71.398-71.398 71.398s-71.398-31.966-71.398-71.398c0-39.432 31.966-71.398 71.398-71.398z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pacman",
						"game",
						"arcade"
					],
					"defaultCode": 59758,
					"grid": 16
				},
				{
					"id": 3257,
					"paths": [
						"M0 512h128v64h-128zM192 512h192v64h-192zM448 512h128v64h-128zM640 512h192v64h-192zM896 512h128v64h-128zM880 0l16 448h-768l16-448h96l16 384h512l16-384zM144 1024l-16-384h768l-16 384h-96l-16-256h-512l-16 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"page-break",
						"wysiwyg"
					],
					"defaultCode": 61092,
					"grid": 16
				},
				{
					"id": 3258,
					"paths": [
						"M0 512h128v64h-128zM192 512h192v64h-192zM448 512h128v64h-128zM640 512h192v64h-192zM896 512h128v64h-128zM880 0l16 448h-768l16-448h32l16 384h640l16-384zM144 1024l-16-384h768l-16 384h-32l-16-320h-640l-16 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"page-break",
						"wysiwyg"
					],
					"defaultCode": 61093,
					"grid": 16
				},
				{
					"id": 257,
					"paths": [
						"M896 460.8h-768c-42.347 0-76.8-34.453-76.8-76.8v-307.2c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v307.2c0 14.115 11.485 25.6 25.6 25.6h768c14.115 0 25.6-11.485 25.6-25.6v-307.2c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v307.2c0 42.347-34.451 76.8-76.8 76.8z",
						"M76.8 563.2h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M230.4 563.2h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M384 563.2h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M537.6 563.2h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M691.2 563.2h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M844.8 563.2h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M998.4 563.2h-51.2c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M947.2 1024c-14.139 0-25.6-11.461-25.6-25.6v-307.2c0-14.115-11.485-25.6-25.6-25.6h-768c-14.115 0-25.6 11.485-25.6 25.6v307.2c0 14.139-11.462 25.6-25.6 25.6s-25.6-11.461-25.6-25.6v-307.2c0-42.349 34.453-76.8 76.8-76.8h768c42.349 0 76.8 34.451 76.8 76.8v307.2c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"page-break"
					],
					"defaultCode": 59554,
					"grid": 20
				},
				{
					"id": 3265,
					"paths": [
						"M256 384v-384h768v384h-64v-320h-640v320zM1024 576v448h-768v-448h64v384h640v-384zM512 448h128v64h-128zM320 448h128v64h-128zM704 448h128v64h-128zM896 448h128v64h-128zM0 288l192 192-192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pagebreak",
						"wysiwyg"
					],
					"defaultCode": 61100,
					"grid": 16
				},
				{
					"id": 1537,
					"width": 801.145133972168,
					"paths": [
						"M801.143 630.286q-18.286 45.714-43.429 78.857t-52 50.571-56.571 26.571-58 8.286-55.143-4.857-49.429-12.571-39.714-15.714-26.286-12.857l-9.714-5.714q-64.571 130.286-165.429 205.429t-219.714 75.714q-10.857 0-18.286-7.429t-7.429-18.286 7.429-18 18.286-7.143q98.857-0.571 184.286-61.429t143.714-168.286q-20.571 8-41.143 13.143t-47.429 7.429-52-1.429-53.143-16.286-52.571-33.714-48.286-57.143-42.571-83.429q65.143-26.857 122.286-32.571t95.714 4.286 71.143 32.286 50.571 44 32.286 46.857q30.286-74.857 45.143-166.286-4 0.571-10.286 1.429t-26.571 1.429-39.714-0.286-46.571-5.714-50.571-13.143-48-24.286-42.857-37.143-31.143-54-16.286-72.857q40-16 76.286-20.857t64.286 0.571 52.571 17.143 42 28.571 32 34.857 24 36 15.714 32 9.143 22.571l2.286 9.143q6.857-69.714 6.857-111.429-4.571-3.429-12.286-9.143t-28-25.429-36.286-40.857-30.857-53.143-18.857-64.286 6.857-72.571 40-79.143q41.714 14.286 72.857 35.143t48.286 43.714 27.429 48.571 11.714 50.857-0.286 48.857-7.429 43.714-10.857 35.429-9.714 24l-4 8.571q0.571 2.857 0.571 28.857t-0.571 40.857q1.714-4 5.714-10.571t17.429-24.571 28.857-33.143 40.571-31.714 52.286-25.429 64-8.286 75.714 13.714q-1.143 44.571-12.286 80.857t-28.571 59.714-39.714 40.857-46.571 26-48.286 13.714-45.714 5.429-38.571-0.571-26.571-2.571l-9.714-1.714q-13.143 84-41.714 161.714 3.429-4 10.286-10.571t28.286-23.429 44.286-30 56.857-24 67.143-11.429 73.714 13.429 78.286 44.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pagelines"
					],
					"defaultCode": 61836,
					"grid": 14
				},
				{
					"id": 671,
					"width": 1024,
					"paths": [
						"M800 608c0-53.024-42.976-96-96-96h-160l25.696-410.944c3.2-51.232-34.528-98.848-85.824-100.96-53.824-2.24-97.184 42.528-93.888 95.744l26.016 416.16h-160c-53.024 0-96 42.976-96 96v64c0 17.664 14.336 32 32 32v224c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-224c17.664 0 32-14.336 32-32v-64zM330.816 959.104c31.456-5.184 53.184-34.816 53.184-66.72v-92.384c0-17.632 14.368-32 32-32 17.664 0 32 14.368 32 32 0 35.264 28.704 63.968 63.968 64 16.448 0 31.2 11.648 31.872 28.096 1.504 36.704 26.336 67.904 62.944 67.904h34.304c36 0 60.672-30.144 62.976-66.080 1.088-16.672 14.976-29.92 31.936-29.92v64c0 35.36-28.64 64-64 64h-384c-35.36 0-64-28.64-64-64v-96c17.632 0 32 14.368 32 32v32c0 38.848 34.752 69.696 74.816 63.104zM736 832c-35.36 0-64 28.64-64 64 0 17.664-14.336 32-32 32h-32c-17.664 0-32-12.672-32-32 0-34.72-29.344-64-64-64-17.664 0-32-14.336-32-32 0-35.36-28.672-64-64-64s-64 28.64-64 64v96c0 17.664-14.336 32-32 32s-32-14.336-32-32v-32c0-35.328-28.64-64-64-64v-96h512v128zM768 672h-576v-64c0-35.296 28.704-64 64-64h194.048l-28.128-450.176c-1.024-16.192 4.544-31.648 15.68-43.456 11.104-11.84 26.176-18.368 42.4-18.368s31.296 6.528 42.4 18.336c11.104 11.84 16.672 27.264 15.68 43.456l-28.128 450.208h194.048c35.296 0 64 28.704 64 64v64zM512 96c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paint",
						"apply",
						"color"
					],
					"grid": 32
				},
				{
					"id": 1642,
					"width": 1022.8569793701172,
					"paths": [
						"M922.857 0q40 0 70 26.571t30 66.571q0 36-25.714 86.286-189.714 359.429-265.714 429.714-55.429 52-124.571 52-72 0-123.714-52.857t-51.714-125.429q0-73.143 52.571-121.143l364.571-330.857q33.714-30.857 74.286-30.857zM403.429 590.857q22.286 43.429 60.857 74.286t86 43.429l0.571 40.571q2.286 121.714-74 198.286t-199.143 76.571q-70.286 0-124.571-26.571t-87.143-72.857-49.429-104.571-16.571-125.714q4 2.857 23.429 17.143t35.429 25.429 33.714 20.857 26.286 9.714q23.429 0 31.429-21.143 14.286-37.714 32.857-64.286t39.714-43.429 50.286-27.143 58.857-14.571 71.429-6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paint-brush"
					],
					"defaultCode": 61948,
					"grid": 14
				},
				{
					"id": 1869,
					"paths": [
						"M1024 576v-384h-192v-64c0-35.2-28.8-64-64-64h-704c-35.2 0-64 28.8-64 64v192c0 35.2 28.8 64 64 64h704c35.2 0 64-28.8 64-64v-64h128v256h-576v128h-32c-17.674 0-32 14.326-32 32v320c0 17.674 14.326 32 32 32h128c17.674 0 32-14.326 32-32v-320c0-17.674-14.326-32-32-32h-32v-64h576zM768 192h-704v-64h704v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paint-format",
						"format",
						"color"
					],
					"defaultCode": 59704,
					"grid": 16
				},
				{
					"id": 672,
					"width": 1024,
					"paths": [
						"M192 704h576c17.664 0 32-14.336 32-32v-64c0-53.024-42.976-96-96-96h-160l25.696-410.944c3.2-51.232-34.528-98.848-85.824-100.96-53.824-2.24-97.184 42.528-93.888 95.744l26.016 416.16h-160c-53.024 0-96 42.976-96 96v64c0 17.664 14.336 32 32 32zM480 64c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM288 928v-32c0-35.328-28.64-64-64-64h-32v-96h576v128h-32c-35.36 0-64 28.64-64 64 0 17.664-14.336 32-32 32h-32c-17.664 0-32-12.672-32-32 0-34.72-29.344-64-64-64-17.664 0-32-14.336-32-32 0-35.36-28.672-64-64-64s-64 28.64-64 64v96c0 17.664-14.336 32-32 32s-32-14.336-32-32zM768 896v32c0 53.024-42.976 96-96 96h-384c-53.024 0-96-42.976-96-96v-64h32c17.632 0 32 14.368 32 32v32c0 38.848 34.784 69.696 74.816 63.104 31.456-5.184 53.184-34.816 53.184-66.72v-92.384c0-17.632 14.368-32 32-32 17.664 0 32 14.368 32 32 0 35.264 28.672 63.968 63.968 64 16.448 0 31.2 11.648 31.872 28.096 1.504 36.704 26.336 67.904 62.944 67.904h34.304c36 0 60.672-30.144 62.976-66.080 1.088-16.672 14.976-29.92 31.936-29.92h32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paint",
						"apply",
						"color"
					],
					"grid": 32
				},
				{
					"id": 1073,
					"width": 1024,
					"paths": [
						"M864 480c0-53.024-42.976-96-96-96h-160v-288c0-53.024-42.976-96-96-96s-96 42.976-96 96v288h-160c-53.024 0-96 42.976-96 96v192h64l-32 352h640l-32-352h64v-192zM672 960v-192h-32v192h-192v-192h-32v192h-32v-256h-32v256h-89.92l29.088-320h441.664l29.088 320h-89.92zM800 608h-576v-128c0-17.632 14.368-32 32-32h224v-352c0-17.632 14.368-32 32-32s32 14.368 32 32v352h224c17.632 0 32 14.368 32 32v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paint",
						"apply",
						"color"
					],
					"grid": 32
				},
				{
					"id": 1855,
					"paths": [
						"M515.080 128c-329.092 0-515.080 218.704-515.080 378.694 0 243.774 218.708 380.954 400.616 425.912 181.924 44.976 250.344-37.53 247.428-132.606-3.542-115.5 54.146-116.992 95.040-112.918 40.862 4.102 280.916 59.528 280.916-124.43 0-227.652-179.856-434.652-508.92-434.652zM448 192c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM160 576.492c-17.946 0-32.492-14.546-32.492-32.492s14.546-32.492 32.492-32.492 32.492 14.546 32.492 32.492-14.546 32.492-32.492 32.492zM256 448c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM512 704c-70.692 0-128-42.98-128-96s57.308-96 128-96c70.694 0 128 42.98 128 96s-57.306 96-128 96zM736 448c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"palette",
						"color",
						"paint",
						"art"
					],
					"defaultCode": 59690,
					"grid": 16
				},
				{
					"id": 1856,
					"paths": [
						"M512 128c-282.77 0-512 200.576-512 448 0 165.894 103.058 310.718 256.202 388.156 86.372 42.68 160.232 11.632 108.292-61.74-27.776-27.75-44.494-63.456-44.494-102.416 0-88.366 85.96-160 192-160s192 71.634 192 160c0 38.96-16.718 74.664-44.492 102.414-51.94 73.37 21.91 104.418 108.278 61.748 153.152-77.436 256.214-222.264 256.214-388.162 0-247.424-229.23-448-512-448zM128 640c-35.346 0-64-28.652-64-64s28.654-64 64-64 64 28.652 64 64-28.654 64-64 64zM256 439.426c-45.916 26.51-97.464 23.186-115.138-7.426-17.672-30.612 5.222-76.916 51.138-103.426s97.464-23.186 115.138 7.426c17.674 30.612-5.222 76.916-51.138 103.426zM512 384c-70.692 0-128-42.98-128-96s57.308-96 128-96c70.694 0 128 42.98 128 96s-57.306 96-128 96zM768 439.426c-45.916-26.51-68.812-72.814-51.138-103.426s69.222-33.936 115.138-7.426 68.812 72.814 51.138 103.426-69.222 33.936-115.138 7.426zM896 640c-35.346 0-64-28.652-64-64s28.654-64 64-64 64 28.652 64 64-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"palette",
						"color",
						"paint",
						"art"
					],
					"defaultCode": 59691,
					"grid": 16
				},
				{
					"id": 2443,
					"paths": [
						"M953.702 70.294c-93.726-93.726-245.684-93.726-339.41 0l-543.996 544c-93.726 93.726-93.726 245.686 0 339.41 93.726 93.726 245.686 93.726 339.41 0l543.996-544c93.726-93.724 93.726-245.684 0-339.41zM928 128c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM864 64c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM896 224c0 17.672-14.326 32-32 32s-32-14.328-32-32 14.326-32 32-32 32 14.328 32 32zM800 128c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM736 64c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM768 224c0 17.672-14.326 32-32 32s-32-14.328-32-32 14.326-32 32-32 32 14.328 32 32zM672 128c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM224 704c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32zM288 768c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32zM160 640c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32zM192 800c0 17.674-14.328 32-32 32s-32-14.326-32-32 14.328-32 32-32 32 14.326 32 32zM96 704c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32zM96 896c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM160 960c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM224 896c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM288 960c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM352 896c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM502.628 758.626c-6.248 6.25-14.438 9.374-22.628 9.374s-16.378-3.124-22.626-9.374l-192-192c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.496 32.758-12.496 45.254 0l192 192c12.498 12.498 12.498 32.758 0 45.254zM758.628 502.626c-6.248 6.25-14.438 9.374-22.628 9.374s-16.378-3.124-22.626-9.374l-192-192c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.498 32.758-12.498 45.254 0l192 192c12.498 12.498 12.498 32.758 0 45.254zM800 320c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32zM864 384c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32zM928 320c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pandage",
						"health",
						"patch",
						"bandid",
						"fix",
						"aid"
					],
					"defaultCode": 60278,
					"grid": 16
				},
				{
					"id": 2444,
					"paths": [
						"M953.702 70.294c-93.726-93.726-245.684-93.726-339.41 0l-543.996 544c-93.726 93.726-93.726 245.686 0 339.41 93.726 93.726 245.686 93.726 339.41 0l543.996-544c93.726-93.724 93.726-245.684 0-339.41zM928 128c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM864 64c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM896 224c0 17.672-14.326 32-32 32s-32-14.328-32-32 14.326-32 32-32 32 14.328 32 32zM800 128c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM736 64c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM768 224c0 17.672-14.326 32-32 32s-32-14.328-32-32 14.326-32 32-32 32 14.328 32 32zM672 128c17.674 0 32 14.328 32 32s-14.326 32-32 32-32-14.328-32-32 14.326-32 32-32zM224 704c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32zM288 768c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32zM160 640c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32zM192 800c0 17.674-14.328 32-32 32s-32-14.326-32-32 14.328-32 32-32 32 14.326 32 32zM96 704c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32zM96 896c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM160 960c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM224 896c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM288 960c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM352 896c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.326 32-32 32zM502.628 758.626c-6.248 6.25-14.438 9.374-22.628 9.374s-16.378-3.124-22.626-9.374l-192-192c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.496 32.758-12.496 45.254 0l192 192c12.498 12.498 12.498 32.758 0 45.254zM758.628 502.626c-6.248 6.25-14.438 9.374-22.628 9.374s-16.378-3.124-22.626-9.374l-192-192c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.498 32.758-12.498 45.254 0l192 192c12.498 12.498 12.498 32.758 0 45.254zM800 320c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32zM864 384c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32zM928 320c-17.674 0-32-14.328-32-32s14.326-32 32-32 32 14.328 32 32-14.326 32-32 32z",
						"M127.334 466.748l339.408-339.414-57.040-57.038c-46.862-46.862-108.284-70.294-169.704-70.294s-122.842 23.432-169.704 70.294c-93.726 93.726-93.726 245.684 0 339.41l57.040 57.042z",
						"M896.664 557.254l-339.41 339.41 57.040 57.040c46.864 46.864 108.286 70.294 169.706 70.294 61.422 0 122.844-23.432 169.706-70.294 93.726-93.726 93.726-245.686 0-339.41l-57.042-57.040z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pandage",
						"health",
						"patch",
						"bandid",
						"fix",
						"aid"
					],
					"defaultCode": 60279,
					"grid": 16
				},
				{
					"id": 2348,
					"paths": [
						"M829.938 0h-699.876l-68.266 1024h317.824l100.38-679.496 100.382 679.496h317.824l-68.268-1024zM256 128h-64v-64h64v64zM448 128h-128v-64h128v64zM640 128h-128v-64h128v64zM768 128h-64v-64h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pants",
						"trousers"
					],
					"defaultCode": 60183,
					"grid": 16
				},
				{
					"id": 1608,
					"width": 1025.7150566577911,
					"paths": [
						"M1008 6.286q18.857 13.714 15.429 36.571l-146.286 877.714q-2.857 16.571-18.286 25.714-8 4.571-17.714 4.571-6.286 0-13.714-2.857l-258.857-105.714-138.286 168.571q-10.286 13.143-28 13.143-7.429 0-12.571-2.286-10.857-4-17.429-13.429t-6.571-20.857v-199.429l493.714-605.143-610.857 528.571-225.714-92.571q-21.143-8-22.857-31.429-1.143-22.857 18.286-33.714l950.857-548.571q8.571-5.143 18.286-5.143 11.429 0 20.571 6.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paper-plane",
						"send"
					],
					"defaultCode": 61912,
					"grid": 14
				},
				{
					"id": 1609,
					"width": 1025.143033504486,
					"paths": [
						"M1008 6.286q18.857 13.714 15.429 36.571l-146.286 877.714q-2.857 16.571-18.286 25.714-8 4.571-17.714 4.571-6.286 0-13.714-2.857l-301.143-122.857-170.286 186.857q-10.286 12-26.857 12-8 0-13.143-2.286-10.857-4-17.143-13.429t-6.286-20.857v-258.286l-269.714-110.286q-21.143-8-22.857-31.429-1.714-22.286 18.286-33.714l950.857-548.571q20-12 38.857 1.143zM812.571 862.857l126.286-756-819.429 472.571 192 78.286 493.143-365.143-273.143 455.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paper-plane-o",
						"send-o"
					],
					"defaultCode": 61913,
					"grid": 14
				},
				{
					"id": 1353,
					"width": 804.5719909667969,
					"paths": [
						"M802.286 791.429q0 66.857-45.143 112t-112 45.143q-77.143 0-134.286-57.143l-444-443.429q-64.571-65.714-64.571-154.857 0-90.857 62.857-154.286t153.714-63.429q90.286 0 156 64.571l345.714 346.286q5.714 5.714 5.714 12.571 0 9.143-17.429 26.571t-26.571 17.429q-7.429 0-13.143-5.714l-346.286-346.857q-45.143-44-103.429-44-60.571 0-102.286 42.857t-41.714 103.429q0 60 43.429 103.429l443.429 444q36 36 82.857 36 36.571 0 60.571-24t24-60.571q0-46.857-36-82.857l-332-332q-14.857-13.714-34.286-13.714-16.571 0-27.429 10.857t-10.857 27.429q0 18.286 14.286 33.714l234.286 234.286q5.714 5.714 5.714 12.571 0 9.143-17.714 26.857t-26.857 17.714q-6.857 0-12.571-5.714l-234.286-234.286q-36-34.857-36-85.143 0-46.857 32.571-79.429t79.429-32.571q50.286 0 85.143 36l332 332q57.143 56 57.143 134.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paperclip"
					],
					"defaultCode": 61638,
					"grid": 14
				},
				{
					"id": 120,
					"paths": [
						"M486.4 1024c-127.043 0-230.4-103.357-230.4-230.4v-614.4c0-98.811 80.389-179.2 179.2-179.2s179.2 80.389 179.2 179.2v563.2c0 70.579-57.421 128-128 128s-128-57.421-128-128v-307.2c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v307.2c0 42.349 34.453 76.8 76.8 76.8 42.349 0 76.8-34.451 76.8-76.8v-563.2c0-70.579-57.421-128-128-128s-128 57.421-128 128v614.4c0 98.811 80.389 179.2 179.2 179.2s179.2-80.389 179.2-179.2v-358.4c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v358.4c0 127.043-103.357 230.4-230.4 230.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paperclip",
						"attachment"
					],
					"defaultCode": 59417,
					"grid": 20
				},
				{
					"id": 2590,
					"paths": [
						"M448 704l393.636 140.488 182.364-797.356zM320 659.908l704-612.776-1024 506.462zM448 771.954v252.046l185.752-185.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paperplane",
						"send",
						"flight",
						"fly",
						"plane",
						"airplane",
						"speed"
					],
					"defaultCode": 60425,
					"grid": 16
				},
				{
					"id": 1613,
					"width": 744.0061187744141,
					"paths": [
						"M730.286 108v41.714q0 16.571-10.571 34.857t-24.286 18.286q-28.571 0-30.857 0.571-14.857 3.429-18.286 17.714-1.714 6.286-1.714 36.571v658.286q0 14.286-10.286 24.571t-24.571 10.286h-61.714q-14.286 0-24.571-10.286t-10.286-24.571v-696h-81.714v696q0 14.286-10 24.571t-24.857 10.286h-61.714q-14.857 0-24.857-10.286t-10-24.571v-283.429q-84-6.857-140-33.714-72-33.143-109.714-102.286-36.571-66.857-36.571-148 0-94.857 50.286-163.429 50.286-67.429 119.429-90.857 63.429-21.143 238.286-21.143h273.714q14.286 0 24.571 10.286t10.286 24.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph"
					],
					"defaultCode": 61917,
					"grid": 14
				},
				{
					"id": 3277,
					"paths": [
						"M0 192h1024v64h-1024zM192 320h640v64h-640zM192 576h640v64h-640zM192 832h640v64h-640zM0 448h1024v64h-1024zM0 704h1024v64h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-center",
						"wysiwyg",
						"align center",
						"center"
					],
					"defaultCode": 61112,
					"grid": 16
				},
				{
					"id": 3281,
					"paths": [
						"M0 64h1024v128h-1024zM192 256h640v128h-640zM192 640h640v128h-640zM0 448h1024v128h-1024zM0 832h1024v128h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-center",
						"wysiwyg",
						"align-center",
						"center"
					],
					"defaultCode": 61116,
					"grid": 16
				},
				{
					"id": 3287,
					"paths": [
						"M0 64h1024v128h-1024zM192 320h640v128h-640zM192 832h640v128h-640zM0 576h1024v128h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-center",
						"wysiwyg",
						"align-center",
						"center"
					],
					"defaultCode": 61122,
					"grid": 16
				},
				{
					"id": 3279,
					"paths": [
						"M0 320h1024v64h-1024zM0 576h1024v64h-1024zM0 832h1024v64h-1024zM0 192h1024v64h-1024zM0 448h1024v64h-1024zM0 704h1024v64h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-justify",
						"wysiwyg",
						"justify"
					],
					"defaultCode": 61114,
					"grid": 16
				},
				{
					"id": 3283,
					"paths": [
						"M0 64h1024v128h-1024zM0 256h1024v128h-1024zM0 448h1024v128h-1024zM0 640h1024v128h-1024zM0 832h1024v128h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-justify",
						"wysiwyg",
						"justify"
					],
					"defaultCode": 61118,
					"grid": 16
				},
				{
					"id": 3289,
					"paths": [
						"M0 64h1024v128h-1024zM0 576h1024v128h-1024zM0 320h1024v128h-1024zM0 832h1024v128h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-justify",
						"wysiwyg",
						"justify"
					],
					"defaultCode": 61124,
					"grid": 16
				},
				{
					"id": 3276,
					"paths": [
						"M0 192h1024v64h-1024zM0 320h704v64h-704zM0 448h1024v64h-1024zM0 576h704v64h-704zM0 704h1024v64h-1024zM0 832h704v64h-704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-left",
						"wysiwyg",
						"align left",
						"left"
					],
					"defaultCode": 61111,
					"grid": 16
				},
				{
					"id": 3280,
					"paths": [
						"M0 64h1024v128h-1024zM0 256h640v128h-640zM0 640h640v128h-640zM0 448h1024v128h-1024zM0 832h1024v128h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-left",
						"wysiwyg",
						"align-left",
						"left"
					],
					"defaultCode": 61115,
					"grid": 16
				},
				{
					"id": 3286,
					"paths": [
						"M0 64h1024v128h-1024zM0 320h640v128h-640zM0 832h640v128h-640zM0 576h1024v128h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-left",
						"wysiwyg",
						"align-left",
						"left"
					],
					"defaultCode": 61121,
					"grid": 16
				},
				{
					"id": 3278,
					"paths": [
						"M0 192h1024v64h-1024zM320 320h704v64h-704zM0 448h1024v64h-1024zM320 576h704v64h-704zM0 704h1024v64h-1024zM320 832h704v64h-704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-right",
						"wysiwyg",
						"align right",
						"right"
					],
					"defaultCode": 61113,
					"grid": 16
				},
				{
					"id": 3282,
					"paths": [
						"M0 64h1024v128h-1024zM384 256h640v128h-640zM384 640h640v128h-640zM0 448h1024v128h-1024zM0 832h1024v128h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-right",
						"wysiwyg",
						"align-right",
						"right"
					],
					"defaultCode": 61117,
					"grid": 16
				},
				{
					"id": 3288,
					"paths": [
						"M0 64h1024v128h-1024zM384 320h640v128h-640zM384 832h640v128h-640zM0 576h1024v128h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paragraph-right",
						"wysiwyg",
						"align-right",
						"right"
					],
					"defaultCode": 61123,
					"grid": 16
				},
				{
					"id": 2014,
					"paths": [
						"M704 128h-128v-64c0-35.2-28.8-64-64-64h-128c-35.204 0-64 28.8-64 64v64h-128v128h512v-128zM512 128h-128v-63.886c0.034-0.038 0.072-0.078 0.114-0.114h127.768c0.042 0.036 0.082 0.076 0.118 0.114v63.886zM832 320v-160c0-17.6-14.4-32-32-32h-64v64h32v128h-384v448h-256v-576h32v-64h-64c-17.602 0-32 14.4-32 32v640c0 17.6 14.398 32 32 32h288v192h448l192-192v-512h-192zM832 933.49v-101.49h101.49l-101.49 101.49zM960 768h-192v192h-320v-576h512v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paste",
						"clipboard-file"
					],
					"defaultCode": 59849,
					"grid": 16
				},
				{
					"id": 2015,
					"paths": [
						"M832 320v-160c0-17.6-14.4-32-32-32h-224v-64c0-35.2-28.8-64-64-64h-128c-35.204 0-64 28.8-64 64v64h-224c-17.602 0-32 14.4-32 32v640c0 17.6 14.398 32 32 32h288v192h448l192-192v-512h-192zM384 64.114c0.034-0.038 0.072-0.078 0.114-0.114h127.768c0.042 0.036 0.082 0.076 0.118 0.114v63.886h-128v-63.886zM192 256v-64h512v64h-512zM832 933.49v-101.49h101.49l-101.49 101.49zM960 768h-192v192h-320v-576h512v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paste",
						"clipboard-file"
					],
					"defaultCode": 59850,
					"grid": 16
				},
				{
					"id": 2016,
					"paths": [
						"M512 512v128h32l32-64h64v256h-48v64h224v-64h-48v-256h64l32 64h32v-128z",
						"M832 320v-160c0-17.6-14.4-32-32-32h-224v-64c0-35.2-28.8-64-64-64h-128c-35.204 0-64 28.8-64 64v64h-224c-17.602 0-32 14.4-32 32v640c0 17.6 14.398 32 32 32h288v192h640v-704h-192zM384 64.114c0.034-0.038 0.072-0.078 0.114-0.114h127.768c0.042 0.036 0.082 0.076 0.118 0.114v63.886h-128v-63.886zM192 256v-64h512v64h-512zM960 960h-512v-576h512v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paste",
						"clipboard-file"
					],
					"defaultCode": 59851,
					"grid": 16
				},
				{
					"id": 2017,
					"paths": [
						"M704 128h-128v-64c0-35.2-28.8-64-64-64h-128c-35.204 0-64 28.8-64 64v64h-128v128h512v-128zM512 128h-128v-63.886c0.034-0.038 0.072-0.078 0.114-0.114h127.768c0.042 0.036 0.082 0.076 0.118 0.114v63.886zM832 320v-160c0-17.6-14.4-32-32-32h-64v64h32v128h-192l-192 192v256h-256v-576h32v-64h-64c-17.602 0-32 14.4-32 32v640c0 17.6 14.398 32 32 32h288v192h640v-704h-192zM576 410.51v101.49h-101.49l101.49-101.49zM960 960h-512v-384h192v-192h320v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paste",
						"clipboard-file"
					],
					"defaultCode": 59852,
					"grid": 16
				},
				{
					"id": 673,
					"width": 1024,
					"paths": [
						"M644.448 352h-36.448v-64c0-17.664-14.336-32-32-32h-16v-1.184c0-2.272 0.544-4.544 1.568-6.592l5.152-10.304c21.344-42.688 12.992-94.080-20.8-127.872-4.512-4.512-5.6-11.328-2.752-17.024l11.776-23.552c5.728-11.456 6.656-24.48 2.624-36.672-4.064-12.16-12.608-22.016-24.096-27.744-23.648-11.872-52.544-2.208-64.384 21.472l-11.808 23.584c-21.344 42.688-12.992 94.080 20.8 127.872 4.512 4.512 5.6 11.328 2.752 17.024l-5.152 10.304c-7.648 15.296-11.68 32.416-11.68 49.504v1.184h-16c-17.664 0-32 14.336-32 32v64h-36.448c-51.232 0-93.44 40.256-95.904 91.424l-26.048 547.040c-0.864 18.272 13.696 33.536 31.968 33.536h444.864c18.272 0 32.832-15.264 31.968-33.536l-26.048-547.040c-2.432-51.168-44.64-91.424-95.904-91.424zM500.704 155.36c-24.032-24.032-29.984-60.576-14.816-90.944l11.776-23.552c2.816-5.6 8.48-8.864 14.368-8.864 2.4 0 4.832 0.544 7.136 1.696 3.84 1.92 6.656 5.216 8.032 9.248 1.344 4.064 1.024 8.384-0.864 12.224l-11.808 23.552c-8.992 17.984-5.472 39.68 8.736 53.952 24.032 24.032 29.984 60.576 14.816 90.944l-5.152 10.304c-3.232 6.464-4.928 13.696-4.928 20.896v1.184h-32v-1.184c0-12.16 2.88-24.352 8.32-35.232l5.152-10.304c8.992-17.984 5.472-39.648-8.768-53.92zM448 288h128v64h-128v-64zM315.616 444.96c1.632-34.176 29.696-60.96 63.936-60.96h264.896c34.208 0 62.304 26.784 63.936 60.96l21.472 451.040h-435.712l21.472-451.040zM289.568 992l3.040-64h438.784l3.040 64h-444.864zM838.272 90.848l-96-19.2c-2.144-0.416-4.256-0.64-6.336-0.64-17.216 0-31.936 13.984-31.936 32v81.92c0 18.016 14.688 32 31.936 32 2.080 0 4.192-0.192 6.336-0.64l96-19.2c14.976-2.944 25.728-16.064 25.728-31.328v-43.52c0-15.264-10.752-28.384-25.728-31.392zM832 165.76l-96 19.2 0.064-81.92 95.936 19.2v43.52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paste",
						"clean",
						"brush",
						"squeeze"
					],
					"grid": 32
				},
				{
					"id": 674,
					"width": 1024,
					"paths": [
						"M478.080 177.984c-33.792-33.792-42.144-85.184-20.8-127.872l11.776-23.552c11.872-23.68 40.736-33.344 64.384-21.472 11.488 5.728 20.032 15.584 24.096 27.744 4.032 12.16 3.136 25.184-2.624 36.672l-11.776 23.552c-2.848 5.664-1.728 12.512 2.752 17.024 30.208 30.176 39.936 74.4 26.464 113.92h-103.424c1.856-6.368 3.808-12.768 6.752-18.688l5.152-10.304c2.848-5.696 1.76-12.544-2.752-17.024zM761.92 896l-21.536-452.576c-2.464-51.168-44.672-91.424-95.936-91.424h-36.448v-64c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v64h-36.448c-51.232 0-93.44 40.256-95.904 91.424l-21.568 452.576h499.84zM260.576 928l-2.976 62.464c-0.864 18.272 13.696 33.536 31.968 33.536h444.864c18.272 0 32.832-15.264 31.968-33.536l-2.976-62.464h-502.848zM838.272 90.848l-96-19.2c-2.144-0.416-4.256-0.64-6.336-0.64-17.216 0-31.936 13.984-31.936 32v81.92c0 18.016 14.688 32 31.936 32 2.080 0 4.192-0.192 6.336-0.64l96-19.2c14.976-2.944 25.728-16.064 25.728-31.328v-43.52c0-15.264-10.752-28.384-25.728-31.392z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paste",
						"clean",
						"brush",
						"squeeze"
					],
					"grid": 32
				},
				{
					"id": 1074,
					"width": 1024,
					"paths": [
						"M704 320h-32v-64c0-17.664-14.336-32-32-32h-32l-66.048-176.096c-5.184-13.856-17.568-20.768-29.952-20.768s-24.768 6.912-29.952 20.768l-66.048 176.096h-32c-17.664 0-32 14.336-32 32v64h-32c-70.688 0-128 57.312-128 128v544c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-544c0-70.688-57.312-128-128-128zM512 150.272l39.648 105.728h-79.296l39.648-105.728zM416 288h192v64h-192v-64zM768 960h-512v-512c0-35.296 28.704-64 64-64h384c35.296 0 64 28.704 64 64v512zM640 480h-256c-17.664 0-32 14.336-32 32v320c0 17.664 14.336 32 32 32h256c17.664 0 32-14.336 32-32v-320c0-17.664-14.336-32-32-32zM640 832h-256v-320h256v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paste",
						"glue"
					],
					"grid": 32
				},
				{
					"id": 2964,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416zM320 320h128v384h-128zM576 320h128v384h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pause",
						"player"
					],
					"defaultCode": 60799,
					"grid": 16
				},
				{
					"id": 1774,
					"width": 877.7139282226562,
					"paths": [
						"M402.286 676.571v-329.143q0-8-5.143-13.143t-13.143-5.143h-146.286q-8 0-13.143 5.143t-5.143 13.143v329.143q0 8 5.143 13.143t13.143 5.143h146.286q8 0 13.143-5.143t5.143-13.143zM658.286 676.571v-329.143q0-8-5.143-13.143t-13.143-5.143h-146.286q-8 0-13.143 5.143t-5.143 13.143v329.143q0 8 5.143 13.143t13.143 5.143h146.286q8 0 13.143-5.143t5.143-13.143zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pause-circle"
					],
					"defaultCode": 62091,
					"grid": 14
				},
				{
					"id": 1775,
					"width": 877.7139282226562,
					"paths": [
						"M438.857 73.143q119.429 0 220.286 58.857t159.714 159.714 58.857 220.286-58.857 220.286-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857zM438.857 822.857q84.571 0 156-41.714t113.143-113.143 41.714-156-41.714-156-113.143-113.143-156-41.714-156 41.714-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714zM493.714 694.857q-8 0-13.143-5.143t-5.143-13.143v-329.143q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v329.143q0 8-5.143 13.143t-13.143 5.143h-109.714zM274.286 694.857q-8 0-13.143-5.143t-5.143-13.143v-329.143q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v329.143q0 8-5.143 13.143t-13.143 5.143h-109.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pause-circle-o"
					],
					"defaultCode": 62092,
					"grid": 14
				},
				{
					"id": 2971,
					"paths": [
						"M128 128h320v768h-320zM576 128h320v768h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pause",
						"player"
					],
					"defaultCode": 60806,
					"grid": 16
				},
				{
					"id": 1251,
					"width": 877.7150535583496,
					"paths": [
						"M877.714 109.714v804.571q0 14.857-10.857 25.714t-25.714 10.857h-292.571q-14.857 0-25.714-10.857t-10.857-25.714v-804.571q0-14.857 10.857-25.714t25.714-10.857h292.571q14.857 0 25.714 10.857t10.857 25.714zM365.714 109.714v804.571q0 14.857-10.857 25.714t-25.714 10.857h-292.571q-14.857 0-25.714-10.857t-10.857-25.714v-804.571q0-14.857 10.857-25.714t25.714-10.857h292.571q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pause"
					],
					"defaultCode": 61516,
					"grid": 14
				},
				{
					"id": 1075,
					"width": 1024,
					"paths": [
						"M384 928h-288v-832h288v832zM416 32h-352c-17.664 0-32 14.336-32 32v896c0 17.664 14.336 32 32 32h352c17.664 0 32-14.336 32-32v-896c0-17.664-14.336-32-32-32v0zM928 928h-288v-832h288v832zM608 32c-17.664 0-32 14.336-32 32v896c0 17.664 14.336 32 32 32h352c17.664 0 32-14.336 32-32v-896c0-17.664-14.336-32-32-32h-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pause",
						"play",
						"stop",
						"delay"
					],
					"grid": 32
				},
				{
					"id": 2541,
					"paths": [
						"M534.338 551.998c-125.328 0-245.338 56.072-322.772 281.738s93.432 207.678 201.274 161.044c104.412-45.146 144.158-52.034 269.916 7.748 118.39 56.282 219.578-2.458 177.362-125.736s-184.452-324.794-325.78-324.794zM297.272 43.572c-71.442 17.074-109.21 114.158-84.36 216.84s102.91 172.082 174.352 155.006c0.33-0.080 0.66-0.16 0.988-0.242 71.442-17.074 109.21-114.158 84.36-216.84-10.698-44.2-31.252-82.232-56.896-109.854-33.93-36.55-76.766-54.876-117.456-45.152-0.33 0.080-0.66 0.16-0.988 0.242zM711.136 39.992c-71.9-15.042-147.542 56.636-168.948 160.096-12.304 59.466-4.014 116.488 18.914 157.086 16.962 30.038 41.938 51.084 72.512 57.482 0.258 0.054 0.516 0.106 0.776 0.16 71.898 15.042 147.54-56.636 168.946-160.096 21.408-103.46-19.526-199.526-91.426-214.568-0.258-0.056-0.516-0.108-0.774-0.16zM20.59 573.722c39.502 91.356 122.75 143.29 185.938 115.992 36.158-15.62 57.914-53.792 62.508-100.712 3.436-35.078-2.72-75.042-19.62-114.126-0.022-0.052-0.044-0.104-0.068-0.156-39.502-91.356-122.75-143.29-185.938-115.994s-82.39 123.482-42.888 214.84c0.022 0.052 0.046 0.104 0.068 0.156zM817.548 673.574c35.964 15.786 78.538 5.782 115.852-22.672 28.082-21.41 53.188-53.27 70.26-92.452 39.758-91.246 20.892-187.642-42.138-215.308-0.272-0.12-0.544-0.238-0.82-0.354-63.030-27.666-146.354 23.876-186.112 115.124-39.758 91.246-20.892 187.644 42.138 215.308 0.272 0.12 0.546 0.238 0.82 0.354z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paw",
						"animal",
						"pet",
						"footprint"
					],
					"defaultCode": 60376,
					"grid": 16
				},
				{
					"id": 1570,
					"width": 950.8560180664062,
					"paths": [
						"M445.714 269.714q0 34.286-10.857 64.857t-36 52.857-60 22.286q-43.429 0-78.857-32.857t-52.571-77.429-17.143-86.286q0-34.286 10.857-64.857t36-52.857 60-22.286q44 0 79.143 32.857t52.286 77.143 17.143 86.571zM250.286 545.714q0 45.714-24 79.429t-68 33.714q-43.429 0-80.857-31.714t-57.429-76.286-20-86.857q0-45.714 24-79.714t68-34q43.429 0 80.857 31.714t57.429 76.571 20 87.143zM475.429 530.286q67.429 0 145.714 55.714t130.857 135.429 52.571 145.429q0 26.286-9.714 43.714t-27.714 25.714-36.857 11.429-43.429 3.143q-38.857 0-107.143-25.714t-104.286-25.714q-37.714 0-110 25.429t-114.571 25.429q-104.571 0-104.571-83.429 0-49.143 32-109.429t79.714-110 107.143-83.429 110.286-33.714zM612 409.714q-34.857 0-60-22.286t-36-52.857-10.857-64.857q0-42.286 17.143-86.571t52.286-77.143 79.143-32.857q34.857 0 60 22.286t36 52.857 10.857 64.857q0 41.714-17.143 86.286t-52.571 77.429-78.857 32.857zM858.857 350.286q44 0 68 34t24 79.714q0 42.286-20 86.857t-57.429 76.286-80.857 31.714q-44 0-68-33.714t-24-79.429q0-42.286 20-87.143t57.429-76.571 80.857-31.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paw"
					],
					"defaultCode": 61872,
					"grid": 14
				},
				{
					"id": 169,
					"paths": [
						"M153.6 614.4c-57.421 0-102.4-67.712-102.4-154.155s44.979-154.155 102.4-154.155 102.4 67.712 102.4 154.155-44.979 154.155-102.4 154.155zM153.6 357.291c-24.168 0-51.2 44.030-51.2 102.955s27.032 102.954 51.2 102.954 51.2-44.030 51.2-102.955-27.032-102.954-51.2-102.954z",
						"M358.299 409.6c-57.365 0-102.299-67.469-102.299-153.6s44.934-153.6 102.299-153.6 102.299 67.469 102.299 153.6-44.934 153.6-102.299 153.6zM358.299 153.6c-24.122 0-51.099 43.792-51.099 102.4s26.978 102.4 51.099 102.4 51.099-43.792 51.099-102.4-26.978-102.4-51.099-102.4z",
						"M614.4 409.6c-57.421 0-102.4-67.469-102.4-153.6s44.979-153.6 102.4-153.6 102.4 67.469 102.4 153.6-44.979 153.6-102.4 153.6zM614.4 153.6c-24.168 0-51.2 43.792-51.2 102.4s27.032 102.4 51.2 102.4 51.2-43.792 51.2-102.4-27.032-102.4-51.2-102.4z",
						"M819.2 614.4c-57.421 0-102.4-67.712-102.4-154.155s44.979-154.155 102.4-154.155 102.4 67.712 102.4 154.155-44.979 154.155-102.4 154.155zM819.2 357.291c-24.168 0-51.2 44.030-51.2 102.955s27.032 102.954 51.2 102.954 51.2-44.030 51.2-102.955-27.032-102.954-51.2-102.954z",
						"M665.6 921.6c-44.434 0-74.482-15.032-100.99-28.293-24.573-12.291-45.792-22.907-78.21-22.907-32.298 0-53.52 10.606-78.093 22.888-26.555 13.27-56.654 28.312-101.107 28.312-28.446 0-55.258-15.501-73.557-42.53-32.104-47.421-32.619-119.362-1.413-197.378 56.152-140.381 148.794-220.893 254.17-220.893s198.018 80.512 254.168 220.893c31.206 78.018 30.693 149.958-1.413 197.378-18.298 27.029-45.109 42.53-73.555 42.53zM486.4 819.2c44.507 0 74.582 15.043 101.115 28.317 24.546 12.278 45.742 22.883 78.085 22.883 11.182 0 22.539-7.301 31.16-20.034 22.096-32.635 20.701-88.582-3.728-149.658-47.971-119.928-123.285-188.709-206.632-188.709-83.346 0-158.661 68.781-206.632 188.707-24.43 61.075-25.824 117.022-3.728 149.658 8.621 12.734 19.978 20.035 31.16 20.035 32.371 0 53.618-10.618 78.218-22.912 26.533-13.259 56.605-28.288 100.982-28.288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paw",
						"pet",
						"print"
					],
					"defaultCode": 59466,
					"grid": 20
				},
				{
					"id": 675,
					"width": 1024,
					"paths": [
						"M96 352c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM128 704c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM896 320c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM672 512c0 106.048-53.952 192-160 192s-160-85.952-160-192 53.952-192 160-192 160 85.952 160 192zM640 512c0-77.344-33.632-160-128-160s-128 82.656-128 160c0 77.344 33.632 160 128 160s128-82.656 128-160zM896 640c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM992 392.96v311.040c0 35.36-28.64 64-64 64h-309.952l-219.168 219.168c-12.512 12.512-28.864 18.752-45.248 18.752s-32.768-6.24-45.248-18.752l-219.936-219.936c-29.536-3.52-52.704-27.008-55.744-56.672-18.88-23.168-19.104-56.128-0.704-79.52v-311.040c0-35.36 28.64-64 64-64h309.952l219.168-219.168c12.512-12.512 28.864-18.752 45.248-18.752s32.768 6.24 45.248 18.752l219.936 219.936c29.536 3.52 52.704 26.976 55.744 56.672 18.88 23.168 19.104 56.128 0.704 79.52zM451.232 256h438.336l-196.544-196.544c-6.048-6.048-14.080-9.376-22.624-9.376s-16.576 3.328-22.624 9.376l-196.544 196.544zM572.768 768h-438.336l196.544 196.544c6.048 6.048 14.080 9.376 22.624 9.376s16.576-3.328 22.624-9.376l196.544-196.544zM960 320c0-17.632-14.368-32-32-32h-832c-17.632 0-32 14.368-32 32v384c0 17.632 14.368 32 32 32h832c17.632 0 32-14.368 32-32v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pay",
						"buy",
						"charge"
					],
					"grid": 32
				},
				{
					"id": 676,
					"width": 1024,
					"paths": [
						"M586.048 800l-187.168 187.168c-12.512 12.512-28.864 18.752-45.248 18.752s-32.768-6.24-45.248-18.752l-187.2-187.168h464.864zM902.816 224l-187.168-187.168c-12.512-12.512-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-187.2 187.168h464.864zM512 352c-94.368 0-128 82.656-128 160s33.632 160 128 160 128-82.656 128-160c0-77.344-33.632-160-128-160zM992 704c0 35.36-28.64 64-64 64 0 0-837.056-0.48-839.584-0.768-29.536-3.52-52.704-27.008-55.744-56.672-0.224-2.208-0.672-390.56-0.672-390.56 0-35.36 28.64-64 64-64 0 0 837.056 0.48 839.584 0.768 29.536 3.52 52.704 27.008 55.744 56.672 0.224 2.208 0.672 390.56 0.672 390.56zM160 672c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM160 352c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM672 512c0-106.048-53.952-192-160-192s-160 85.952-160 192 53.952 192 160 192 160-85.952 160-192zM928 672c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM928 352c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pay",
						"buy",
						"charge"
					],
					"grid": 32
				},
				{
					"id": 1076,
					"width": 1024,
					"paths": [
						"M960 736h-32l-64-576v-128c0-17.664-14.336-32-32-32h-640c-17.664 0-32 14.336-32 32v128l-64 576h-32c-17.664 0-32 14.336-32 32v224c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-224c0-17.664-14.336-32-32-32zM224 64h576v96h-576v-96zM220.832 192h582.336l64 576h-710.336l64-576zM928 960h-832v-160h832v160zM352 256c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM352 352c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM512 256c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM512 352c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM672 256c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM672 352c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM352 416c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM352 512c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM512 416c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM512 512c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM672 416c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM672 512c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM352 576c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM352 672c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM512 576c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM512 672c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM672 576c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM672 672c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM640 896h-256v-32h256v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pay",
						"buy",
						"charge"
					],
					"grid": 32
				},
				{
					"id": 3404,
					"paths": [
						"M930 308.6c-47.8 212.2-195.4 324.2-428 324.2h-77.4l-53.8 341.6h-64.8l-3.4 22c-2.2 14.6 9 27.6 23.6 27.6h165.6c19.6 0 36.2-14.2 39.4-33.6l1.6-8.4 31.2-197.8 2-10.8c3-19.4 19.8-33.6 39.4-33.6h24.6c160.4 0 286-65.2 322.8-253.6 13.8-71.6 8.6-132.4-22.8-177.6z",
						"M831 77.2c-47.4-54-133.2-77.2-242.8-77.2h-318.2c-22.4 0-41.6 16.2-45 38.4l-132.6 840.4c-2.6 16.6 10.2 31.6 27 31.6h196.6l49.4-313-1.6 9.8c3.4-22.2 22.4-38.4 44.8-38.4h93.4c183.4 0 327-74.4 369-290 1.2-6.4 2.4-12.6 3.2-18.6 12.4-79.6 0-134-43.2-183z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paypal",
						"brand",
						"donate"
					],
					"defaultCode": 61239,
					"grid": 16
				},
				{
					"id": 1628,
					"width": 881.7139358520508,
					"paths": [
						"M868 369.143q10.286 48-2.286 116.571-49.714 253.714-322.857 253.714h-25.143q-14.286 0-25.143 9.429t-13.714 24.286l-2.286 10.857-31.429 197.714-1.143 8.571q-2.857 14.857-14 24.286t-25.429 9.429h-143.429q-12 0-18.857-8.571t-5.143-20.571q5.143-32 15.143-96t15.143-96 15.429-95.714 15.429-95.714q2.857-21.143 24.571-21.143h74.857q76 1.143 134.857-12 100-22.286 164-82.286 58.286-54.286 88.571-140.571 13.714-40 20-76 0.571-3.429 1.429-4.286t2-0.571 3.429 2q45.143 33.714 56 92.571zM769.714 208q0 61.143-26.286 134.857-45.714 133.143-172.571 180-64.571 22.857-144 24 0 0.571-51.429 0.571l-51.429-0.571q-57.143 0-67.429 54.857-1.143 4.571-48.571 302.857-0.571 5.714-6.857 5.714h-168.571q-12.571 0-20.857-9.429t-6.571-22l132.571-840.571q2.857-16.571 15.714-27.429t29.429-10.857h341.714q19.429 0 55.714 7.429t63.714 18.286q61.143 23.429 93.429 70.286t32.286 112z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"paypal"
					],
					"defaultCode": 61933,
					"grid": 14
				},
				{
					"id": 2837,
					"paths": [
						"M512 0c-282.768 0-512 229.23-512 512s229.232 512 512 512c282.77 0 512-229.23 512-512s-229.23-512-512-512zM928 512c0 94.956-31.624 185.038-89.848 258.27l-278.152-278.152v-393.368c92.954 10.614 179.012 51.95 246.156 119.094 78.572 78.572 121.844 183.038 121.844 294.156zM464 925.25c-77.13-8.806-149.502-38.784-210.27-87.096l210.27-210.272v297.368zM560 627.882l210.27 210.27c-60.768 48.314-133.138 78.292-210.27 87.098v-297.368zM217.844 217.844c67.144-67.144 153.202-108.48 246.156-119.094v393.368l-278.152 278.154c-58.224-73.234-89.848-163.316-89.848-258.272 0-111.118 43.272-215.584 121.844-294.156z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"peace"
					],
					"defaultCode": 60672,
					"grid": 16
				},
				{
					"id": 1841,
					"paths": [
						"M928.002 384.006l-287.996-287.998 95.998-96 287.998 287.998-96 96zM624 176l224 224-144 368-576 256-41.374-41.376 344.806-344.802c5.286 1.414 10.836 2.178 16.568 2.178 35.346 0 64-28.654 64-64s-28.654-64-64-64-64 28.654-64 64c0 5.73 0.764 11.282 2.178 16.57l-344.804 344.806-41.374-41.376 256-576 368-144z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pen",
						"write",
						"edit"
					],
					"defaultCode": 59676,
					"grid": 16
				},
				{
					"id": 1843,
					"width": 1216,
					"paths": [
						"M1120.002 384.006l-287.996-287.998 95.998-96 287.996 287.998-95.998 96zM816 176l224 224-144 368-576 256-41.376-41.376 344.806-344.802c5.286 1.414 10.836 2.178 16.568 2.178 35.346 0 64-28.654 64-64s-28.654-64-64-64-64 28.654-64 64c0 5.73 0.764 11.282 2.178 16.57l-344.802 344.806-41.374-41.376 256-576 368-144z",
						"M0 128h384v128h-384v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pen-minus",
						"pen-remove"
					],
					"defaultCode": 59678,
					"grid": 16
				},
				{
					"id": 1842,
					"width": 1216,
					"paths": [
						"M1120.002 384.006l-287.996-287.998 95.998-96 287.996 287.998-95.998 96zM816 176l224 224-144 368-576 256-41.376-41.376 344.806-344.802c5.286 1.414 10.836 2.178 16.568 2.178 35.346 0 64-28.654 64-64s-28.654-64-64-64-64 28.654-64 64c0 5.73 0.764 11.282 2.178 16.57l-344.802 344.806-41.374-41.376 256-576 368-144z",
						"M384 128h-128v-128h-128v128h-128v128h128v128h128v-128h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pen-plus",
						"pen-add"
					],
					"defaultCode": 59677,
					"grid": 16
				},
				{
					"id": 1844,
					"paths": [
						"M1018.17 291.89l-286.058-286.058c-9.334-9.334-21.644-7.234-27.356 4.666l-38.354 79.904 267.198 267.198 79.904-38.354c11.9-5.712 14-18.022 4.666-27.356z",
						"M615.384 135.384l-263.384 21.95c-17.5 2.166-32.080 5.898-37.090 28.752-0.006 0.024-0.012 0.042-0.018 0.066-71.422 343.070-314.892 677.848-314.892 677.848l57.374 57.374 271.986-271.99c-5.996-12.53-9.36-26.564-9.36-41.384 0-53.020 42.98-96 96-96s96 42.98 96 96-42.98 96-96 96c-14.82 0-28.852-3.364-41.384-9.36l-271.988 271.986 57.372 57.374c0 0 334.778-243.47 677.848-314.892 0.024-0.006 0.042-0.012 0.066-0.018 22.854-5.010 26.586-19.59 28.752-37.090l21.95-263.384-273.232-273.232z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pen",
						"write",
						"edit"
					],
					"defaultCode": 59679,
					"grid": 16
				},
				{
					"id": 1845,
					"paths": [
						"M768 128h-448l-32-128h512z",
						"M768 192h-448l-128 288 256 544h64v-517.484c-37.282-13.182-64-48.72-64-90.516 0-53.018 42.98-96 96-96s96 42.982 96 96c0 41.794-26.718 77.334-64 90.516v517.484h64l256-544-128-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pen",
						"write",
						"edit"
					],
					"defaultCode": 59680,
					"grid": 16
				},
				{
					"id": 1846,
					"paths": [
						"M651.852 156.444l52.148-156.444h-448l52.148 156.444-148.148 355.556 256 512h128l256-512-148.148-355.556zM615.206 64l-21.334 64h-227.744l-21.334-64h270.412zM512 944.89v-374.374c37.282-13.182 64-48.718 64-90.516 0-53.020-42.98-96-96-96s-96 42.98-96 96c0 41.796 26.718 77.334 64 90.516v374.376l-217.658-435.314 132.324-317.578h234.666l132.322 317.578-217.654 435.312z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pen",
						"write",
						"edit"
					],
					"defaultCode": 59681,
					"grid": 16
				},
				{
					"id": 1847,
					"paths": [
						"M532.054 244.052c-42.41 41.142-128.196 126.27-143.268 141.358-117.626 117.614-393.8 445.24-388.714 638.52 193.28 5.102 520.896-271.094 638.526-388.708 15.088-15.090 100.216-100.882 141.346-143.28l-247.89-247.89zM944.678 204.18l-18.044-18.014 97.366-80.444-105.72-105.722-80.444 97.372-18.036-18.078c-55.792-3.262-145.764 50.75-234.43 122.080l237.258 237.26c26.828-33.376 51.048-66.866 70.844-98.712 59.528 49.078 15.528 193.078-235.67 381.882l46.198 46.196c224-160 369-352 228.526-504.46 8.378-22.158 13.142-42.464 12.152-59.36z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pen",
						"write",
						"edit"
					],
					"defaultCode": 59682,
					"grid": 16
				},
				{
					"id": 1852,
					"paths": [
						"M1024 160c0-88.366-71.634-160-160-160-52.348 0-98.818 25.144-128.008 64.008l-575.992 575.992 224 224 575.992-575.992c38.864-29.19 64.008-75.66 64.008-128.008z",
						"M0 1024l96-320 224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pen",
						"write",
						"pencil"
					],
					"defaultCode": 59687,
					"grid": 16
				},
				{
					"id": 1827,
					"paths": [
						"M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil",
						"write",
						"edit"
					],
					"defaultCode": 59662,
					"grid": 16
				},
				{
					"id": 3224,
					"paths": [
						"M249.562 14.154c-5.964-8.882-15.986-14.21-26.676-14.154-10.7 0.040-20.672 5.422-26.574 14.346l-127 192c-3.464 5.236-5.312 11.376-5.312 17.654v736c0 35.29 28.708 64 64 64h192c35.29 0 64-28.71 64-64v-736c0-6.356-1.894-12.57-5.44-17.846l-128.998-192zM197.868 128h51.082l71.050 105.752 0.022 662.248h-192.022v-662.374l69.868-105.626z",
						"M224 832c17.672 0 32-14.326 32-32v-512c0-17.672-14.328-32-32-32s-32 14.328-32 32v512c0 17.674 14.328 32 32 32z",
						"M512 0v1024h384v-1024h-384zM832 128h-64v64h64v64h-128v64h128v64h-64v64h64v64h-128v64h128v64h-64v64h64v64h-128v64h128v128h-256v-896h256v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil-ruler",
						"design"
					],
					"defaultCode": 61059,
					"grid": 16
				},
				{
					"id": 1476,
					"width": 877.7129821777344,
					"paths": [
						"M230.857 633.143l86.857 86.857-29.714 29.714h-32v-54.857h-54.857v-32zM467.429 410.286q8 7.429-1.714 17.143l-166.286 166.286q-9.714 9.714-17.143 1.714-8-7.429 1.714-17.143l166.286-166.286q9.714-9.714 17.143-1.714zM310.857 804.571l310.857-310.857-164.571-164.571-310.857 310.857v164.571h164.571zM658.286 457.143l52.571-52.571q16-16 16-38.857t-16-38.857l-86.857-86.857q-16-16-38.857-16t-38.857 16l-52.571 52.571zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil-square"
					],
					"defaultCode": 61771,
					"grid": 14
				},
				{
					"id": 1828,
					"paths": [
						"M732.458 3.542l-572.458 572.458-160 448 447.666-160 572.792-572.458c32-128-160-320-288-288zM288 704l-64-64 544-544 64 64-544 544z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil",
						"write",
						"edit"
					],
					"defaultCode": 59663,
					"grid": 16
				},
				{
					"id": 1829,
					"paths": [
						"M762.238 0c-10.208 0-20.17 1.138-29.78 3.542l-572.458 572.458-160 448 447.666-160 572.792-572.458c29.598-118.392-132.442-291.542-258.22-291.542zM417.618 769.618l-163.392-163.392 480-480 163.534 163.532-480.142 479.86z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil",
						"write",
						"edit"
					],
					"defaultCode": 59664,
					"grid": 16
				},
				{
					"id": 1830,
					"paths": [
						"M732.458 3.542l-572.458 572.458h96v64h64v64h64v64h64v95.668l572.458-572.126c32-128-160-320-288-288z",
						"M384 832h-64v-64h-64v-64h-64v-64h-54.858l-137.142 384 384-137.244z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil",
						"write",
						"edit"
					],
					"defaultCode": 59665,
					"grid": 16
				},
				{
					"id": 1831,
					"paths": [
						"M768 544v352h-640v-640h352l128-128h-512c-52.8 0-96 43.2-96 96v704c0 52.8 43.2 96 96 96h704c52.8 0 96-43.2 96-96v-512l-128 128z",
						"M864 0l-608 608v160h160l608-608c0-96-64-160-160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil",
						"write",
						"edit"
					],
					"defaultCode": 59666,
					"grid": 16
				},
				{
					"id": 1832,
					"paths": [
						"M384 640l128-64 448-448-64-64-448 448-64 128zM289.3 867.098c-31.632-66.728-65.666-100.762-132.396-132.394l99.096-272.792 128-77.912 384-384h-192l-384 384-192 640 640-192 384-384v-192l-384 384-77.912 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil",
						"write",
						"edit"
					],
					"defaultCode": 59667,
					"grid": 16
				},
				{
					"id": 1833,
					"paths": [
						"M768 544v352h-640v-640h352l128-128h-512c-52.8 0-96 43.2-96 96v704c0 52.8 43.2 96 96 96h704c52.798 0 96-43.2 96-96v-512l-128 128z",
						"M864 0l-608 608v160h160l608-608c0-96-64-160-160-160zM416 640l-48-48 480-480 48 48-480 480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil",
						"write",
						"edit"
					],
					"defaultCode": 59668,
					"grid": 16
				},
				{
					"id": 1239,
					"width": 865.7150573730469,
					"paths": [
						"M207.429 877.714l52-52-134.286-134.286-52 52v61.143h73.143v73.143h61.143zM506.286 347.429q0-12.571-12.571-12.571-5.714 0-9.714 4l-309.714 309.714q-4 4-4 9.714 0 12.571 12.571 12.571 5.714 0 9.714-4l309.714-309.714q4-4 4-9.714zM475.429 237.714l237.714 237.714-475.429 475.429h-237.714v-237.714zM865.714 292.571q0 30.286-21.143 51.429l-94.857 94.857-237.714-237.714 94.857-94.286q20.571-21.714 51.429-21.714 30.286 0 52 21.714l134.286 133.714q21.143 22.286 21.143 52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil"
					],
					"defaultCode": 61504,
					"grid": 14
				},
				{
					"id": 97,
					"paths": [
						"M978.101 45.898c-28.77-28.768-67.018-44.611-107.701-44.611-40.685 0-78.933 15.843-107.701 44.611l-652.8 652.8c-2.645 2.645-4.678 5.837-5.957 9.354l-102.4 281.6c-3.4 9.347-1.077 19.818 5.957 26.85 4.885 4.888 11.43 7.499 18.104 7.499 2.933 0 5.891-0.502 8.744-1.541l281.6-102.4c3.515-1.28 6.709-3.312 9.354-5.958l652.8-652.8c28.768-28.768 44.613-67.018 44.613-107.702s-15.843-78.933-44.613-107.701zM293.114 873.883l-224.709 81.71 81.712-224.707 566.683-566.683 142.997 142.997-566.683 566.683zM941.899 225.098l-45.899 45.899-142.997-142.997 45.899-45.899c19.098-19.098 44.49-29.614 71.498-29.614s52.4 10.518 71.499 29.616c19.098 19.098 29.616 44.49 29.616 71.498s-10.52 52.4-29.616 71.498z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pencil",
						"write",
						"edit"
					],
					"defaultCode": 59394,
					"grid": 20
				},
				{
					"id": 2078,
					"paths": [
						"M640 640h64v128h-64v-128z",
						"M320 256h64v128h-64v-128z",
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM256 224c0-17.672 14.328-32 32-32h128c17.672 0 32 14.328 32 32v192c0 17.672-14.328 32-32 32h-128c-17.672 0-32-14.328-32-32v-192zM768 800c0 17.674-14.326 32-32 32h-128c-17.674 0-32-14.326-32-32v-192c0-17.674 14.326-32 32-32h128c17.674 0 32 14.326 32 32v192zM764.416 246.102l-448 576c-7.096 9.124-17.714 13.9-28.442 13.9-7.724 0-15.506-2.474-22.076-7.586-15.694-12.206-18.522-34.824-6.316-50.518l448-576c12.206-15.694 34.822-18.522 50.518-6.316 15.698 12.208 18.524 34.826 6.316 50.52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"percent",
						"discount"
					],
					"defaultCode": 59913,
					"grid": 16
				},
				{
					"id": 1783,
					"width": 877.7129516601562,
					"paths": [
						"M731.429 731.429q0-29.714-21.714-51.429t-51.429-21.714-51.429 21.714-21.714 51.429 21.714 51.429 51.429 21.714 51.429-21.714 21.714-51.429zM292.571 292.571q0-29.714-21.714-51.429t-51.429-21.714-51.429 21.714-21.714 51.429 21.714 51.429 51.429 21.714 51.429-21.714 21.714-51.429zM877.714 731.429q0 90.857-64.286 155.143t-155.143 64.286-155.143-64.286-64.286-155.143 64.286-155.143 155.143-64.286 155.143 64.286 64.286 155.143zM822.857 109.714q0 11.429-7.429 21.714l-603.429 804.571q-10.857 14.857-29.143 14.857h-91.429q-14.857 0-25.714-10.857t-10.857-25.714q0-11.429 7.429-21.714l603.429-804.571q10.857-14.857 29.143-14.857h91.429q14.857 0 25.714 10.857t10.857 25.714zM438.857 292.571q0 90.857-64.286 155.143t-155.143 64.286-155.143-64.286-64.286-155.143 64.286-155.143 155.143-64.286 155.143 64.286 64.286 155.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"percent"
					],
					"defaultCode": 62101,
					"grid": 14
				},
				{
					"id": 677,
					"width": 1024,
					"paths": [
						"M832 384h-160.928c35.232-92.32 64.928-222.656 64.928-256 0-54.72-45.792-98.752-101.152-95.872-51.936 2.72-90.848 49.312-90.848 101.312v250.56h-64v-250.56c0-51.968-38.912-98.592-90.848-101.312-55.36-2.88-101.152 41.152-101.152 95.872 0 33.344 29.696 163.68 64.928 256h-160.928c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h30.112l-24.128 410.368c-3.264 55.136 40.608 101.632 95.84 101.632h436.384c55.232 0 99.072-46.496 95.84-101.632l-24.16-410.368h30.112c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32zM576 128c0-35.296 28.704-64 64-64s64 28.704 64 64c0 27.296-29.824 163.36-67.2 256h-60.8v-256zM320 128c0-35.296 28.704-64 64-64s64 28.704 64 64v256h-60.8c-37.376-92.64-67.2-228.704-67.2-256zM229.92 892.256l18.592-316.256h526.944l18.592 316.256c2.176 36.736-27.040 67.744-63.872 67.744h-436.352c-36.832 0-66.048-31.008-63.904-67.744zM250.4 544l3.776-64h515.648l3.776 64h-523.2zM832 448h-640v-32h640v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"perform",
						"disappear",
						"trick"
					],
					"grid": 32
				},
				{
					"id": 678,
					"width": 1024,
					"paths": [
						"M220.224 512h583.52l3.776 64h-591.040l3.744-64zM192 384c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-640zM480 352v-218.56c0-51.968-38.912-98.592-90.848-101.312-55.36-2.88-101.152 41.152-101.152 95.872 0 29.664 23.488 135.904 53.472 224h138.528zM214.592 608l-16.608 282.368c-3.264 55.136 40.608 101.632 95.84 101.632h436.384c55.232 0 99.072-46.496 95.84-101.632l-16.64-282.368h-594.816zM682.528 352c29.984-88.096 53.472-194.336 53.472-224 0-54.72-45.792-98.752-101.152-95.872-51.936 2.72-90.848 49.312-90.848 101.312v218.56h138.528z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"perform",
						"disappear",
						"trick"
					],
					"grid": 32
				},
				{
					"id": 2097,
					"paths": [
						"M966.086 176.82c-28.44-24.012-67.39-44.95-115.776-62.23-91.348-32.624-211.496-50.59-338.31-50.59 0 0 0 0-0.002 0-126.814 0-246.962 17.966-338.31 50.592-48.384 17.28-87.336 38.216-115.774 62.23-47.87 40.418-57.918 82.768-57.918 111.18l0.004 64c0 16.972 6.744 33.25 18.746 45.25l32 32c12.236 12.238 28.602 18.748 45.268 18.748 7.992 0 16.052-1.496 23.756-4.578l160-64c24.298-9.72 40.23-33.254 40.23-59.422v-111.642c58.562-10.68 124.22-16.358 191.998-16.358 0 0 0 0 0.002 0 67.78 0 133.438 5.678 191.998 16.358v111.642c0 26.17 15.932 49.704 40.232 59.422l160 64c7.704 3.082 15.764 4.578 23.754 4.578 16.666 0 33.032-6.51 45.27-18.746l32-32c12-12.002 18.742-28.278 18.744-45.25l0.004-64c0-28.414-10.048-70.764-57.916-111.184z",
						"M955.606 796.134c-0.978-3.424-24.424-84.826-64.37-167.582-57.828-119.804-155.236-180.552-283.236-180.552h-192c-128 0-225.408 60.748-283.236 180.552-39.946 82.756-63.39 164.158-64.368 167.582-12.002 42.008-5.446 83.918 17.988 114.982 23.432 31.068 61.928 48.884 105.616 48.884h640c43.69 0 82.186-17.816 105.618-48.882 23.434-31.066 29.99-72.976 17.988-114.984zM512 832c-70.692 0-128-57.308-128-128s57.308-128 128-128c70.694 0 128 57.308 128 128s-57.306 128-128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone",
						"telephone",
						"contact",
						"support",
						"call"
					],
					"defaultCode": 59932,
					"grid": 16
				},
				{
					"id": 143,
					"paths": [
						"M819.2 1024c-90.691 0-187.154-25.699-286.706-76.386-91.794-46.736-182.48-113.654-262.258-193.522-79.763-79.853-146.595-170.624-193.272-262.498-50.608-99.61-76.269-196.102-76.269-286.795 0-58.774 54.765-115.55 78.31-137.232 33.85-31.17 87.104-67.568 125.794-67.568 19.245 0 41.803 12.589 70.994 39.616 21.782 20.17 46.27 47.51 70.814 79.067 14.794 19.021 88.592 116.267 88.592 162.917 0 38.27-43.25 64.853-89.037 92.998-17.694 10.875-35.992 22.122-49.226 32.73-14.114 11.315-16.645 17.288-17.061 18.629 48.602 121.128 197.141 269.651 318.203 318.184 1.085-0.341 7.067-2.699 18.592-17.075 10.608-13.234 21.854-31.531 32.73-49.227 28.144-45.789 54.726-89.038 92.998-89.038 46.648 0 143.896 73.798 162.917 88.592 31.557 24.546 58.898 49.032 79.067 70.816 27.029 29.189 39.616 51.747 39.616 70.992 0 38.701-36.378 92.115-67.528 126.099-21.693 23.662-78.491 78.701-137.272 78.701zM204.477 51.203c-13.731 0.262-50.634 17.054-90.789 54.029-38.115 35.099-61.792 73.25-61.792 99.568 0 344.523 423.093 768 767.304 768 26.28 0 64.418-23.795 99.528-62.099 37.003-40.366 53.806-77.413 54.069-91.178-1.662-9.728-28.57-47.563-102.232-104.283-63.322-48.762-114.699-74.886-127.901-75.237-0.925 0.274-6.656 2.467-18.277 17.222-10.104 12.832-20.912 30.418-31.366 47.424-28.683 46.666-55.774 90.744-95.122 90.744-6.336 0-12.597-1.219-18.608-3.624-134.376-53.75-293.31-212.685-347.061-347.061-6.456-16.138-7.485-41.414 24.272-70.184 16.882-15.293 40.25-29.656 62.848-43.546 17.006-10.453 34.59-21.261 47.422-31.366 14.755-11.619 16.95-17.352 17.222-18.277-0.352-13.203-26.475-64.579-75.237-127.902-56.72-73.659-94.554-100.568-104.282-102.23z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-handset",
						"telephone",
						"phone",
						"call",
						"contact"
					],
					"defaultCode": 59440,
					"grid": 20
				},
				{
					"id": 2110,
					"paths": [
						"M1017.378 575.994c8.004 55.482 13.216 131.392-11.664 160.446-41.142 48.044-301.712 48.044-301.712-48.042 0-48.398 42.856-80.134 1.712-128.178-40.472-47.262-113.026-48.030-193.714-48.042-80.686 0.012-153.242 0.78-193.714 48.042-41.142 48.046 1.714 79.78 1.714 128.178 0 96.086-260.57 96.086-301.714 48.044-24.878-29.054-19.668-104.964-11.662-160.446 6.16-37.038 21.724-76.996 71.548-127.994 0-0.002 0.002-0.002 0.002-0.004 74.738-69.742 187.846-126.738 429.826-127.968v-0.030c1.344 0 2.664 0.010 4 0.014 1.338-0.004 2.656-0.014 4-0.014v0.028c241.98 1.23 355.088 58.226 429.826 127.968 0.002 0.002 0.002 0.004 0.002 0.004 49.824 50.996 65.39 90.954 71.55 127.994z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-hang-up",
						"telephone",
						"contact",
						"support",
						"call"
					],
					"defaultCode": 59945,
					"grid": 16
				},
				{
					"id": 2111,
					"paths": [
						"M848.764 777.598c33.858 0 116.116-4.066 148.94-41.708 16.49-18.9 25.048-47.63 26.168-87.83 0.698-25.058-1.456-54.836-6.406-88.506l-0.128-0.822c-8.422-49.712-32.1-91.902-76.774-136.796l-1.266-1.214c-60.216-55.166-158.264-118.22-385.596-125.596v-0.724l-83.406 0.028v0.698c-227.332 7.376-325.38 70.43-385.596 125.596l-1.268 1.218c-44.67 44.888-68.348 87.076-76.77 136.792l-0.13 0.822c-4.948 33.668-7.102 63.446-6.406 88.506 1.12 40.198 9.678 68.928 26.164 87.828 32.832 37.644 115.104 41.708 148.952 41.708 45.96 0 89.218-6.942 121.802-19.548 65.434-25.314 75.204-67.756 75.204-90.8 0-22.138-6.59-40.382-11.884-55.040-8.152-22.564-8.724-25.414 0.934-36.486 26.71-30.62 86.94-30.632 150.694-30.644 63.766 0.012 123.998 0.022 150.706 30.646 9.66 11.072 9.088 13.922 0.938 36.484-5.296 14.66-11.886 32.904-11.886 55.040 0 23.042 9.772 65.482 75.208 90.796 32.586 12.606 75.84 19.55 121.798 19.552 0.004 0 0.004 0 0.008 0zM511.994 469.078c-77.948 0.014-158.548 0.028-207.968 56.686-39.384 45.154-24.208 87.164-15.14 112.264 3.95 10.94 7.364 20.388 7.364 29.218 0 11.658-42.71 34.35-121.006 34.35-51.138 0-84.73-10.294-91.952-16.010-4.534-6.106-12.948-37.196-1.626-114.558 4.050-23.598 13.87-53.314 55.044-94.878 53.472-48.764 144.24-104.586 371.778-105.72l2.82-0.016 0.754 0.002 0.436-0.002 3.016 0.016c227.568 1.134 318.328 56.97 371.794 105.74 41.166 41.562 50.98 71.268 55.030 94.864 11.324 77.366 2.906 108.45-1.632 114.556-7.218 5.716-40.806 16.008-91.948 16.008-78.298-0.002-121.008-22.692-121.008-34.35 0-8.83 3.414-18.276 7.366-29.216 9.068-25.102 24.246-67.114-15.142-112.266-49.42-56.66-130.020-56.674-207.98-56.688z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-hang-up",
						"telephone",
						"contact",
						"support",
						"call"
					],
					"defaultCode": 59946,
					"grid": 16
				},
				{
					"id": 2105,
					"paths": [
						"M733.256 381.256l226.744-226.746-90.512-90.51-226.744 226.744-130.744-130.744v352h352z",
						"M704 640c-64 64-64 128-128 128s-128-64-192-128-128-128-128-192 64-64 128-128-128-256-192-256-192 192-192 192c0 128 131.5 387.5 256 512s384 256 512 256c0 0 192-128 192-192s-192-256-256-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-incoming",
						"telephone",
						"contact",
						"phone",
						"support",
						"call"
					],
					"defaultCode": 59940,
					"grid": 16
				},
				{
					"id": 2102,
					"paths": [
						"M704 640c64-64 256 128 256 192s-192 192-192 192c-128 0-387.5-131.5-512-256s-256-384-256-512c0 0 128-192 192-192s256 192 192 256-128 64-128 128 64 128 128 192 128 128 192 128 64-64 128-128zM736 0c-159.056 0-288 128.942-288 288s128.944 288 288 288 288-128.942 288-288-128.944-288-288-288zM895.752 320h-319.504v-64h319.504v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-minus",
						"telephone",
						"contact",
						"contact-remove",
						"support",
						"call"
					],
					"defaultCode": 59937,
					"grid": 16
				},
				{
					"id": 2104,
					"paths": [
						"M704 640c64-64 256 128 256 192s-192 192-192 192c-128 0-387.5-131.5-512-256s-256-384-256-512c0 0 128-192 192-192s256 192 192 256-128 64-128 128 64 128 128 192 128 128 192 128 64-64 128-128zM576 192h384v128h-384zM576 192h384v128h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-minus",
						"telephone",
						"contact",
						"contact-remove",
						"support",
						"call"
					],
					"defaultCode": 59939,
					"grid": 16
				},
				{
					"id": 2106,
					"paths": [
						"M704 640c-64 64-64 128-128 128s-128-64-192-128-128-128-128-192 64-64 128-128-128-256-192-256-192 192-192 192c0 128 131.5 387.5 256 512s384 256 512 256c0 0 192-128 192-192s-192-256-256-192z",
						"M602.512 512l226.744-226.744 130.744 130.744v-352h-352l130.744 130.744-226.744 226.746z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-outgoing",
						"telephone",
						"phone",
						"support",
						"call"
					],
					"defaultCode": 59941,
					"grid": 16
				},
				{
					"id": 2101,
					"paths": [
						"M704 640c64-64 256 128 256 192s-192 192-192 192c-128 0-387.5-131.5-512-256s-256-384-256-512c0 0 128-192 192-192s256 192 192 256-128 64-128 128 64 128 128 192 128 128 192 128 64-64 128-128zM736 0c-159.056 0-288 128.942-288 288s128.944 288 288 288 288-128.942 288-288-128.944-288-288-288zM768 320v127.752h-64v-127.752h-127.752v-64h127.752v-127.752h64v127.752h127.752v64h-127.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-plus",
						"telephone",
						"contact",
						"contact-add",
						"support",
						"call"
					],
					"defaultCode": 59936,
					"grid": 16
				},
				{
					"id": 2103,
					"paths": [
						"M704 640c64-64 256 128 256 192s-192 192-192 192c-128 0-387.5-131.5-512-256s-256-384-256-512c0 0 128-192 192-192s256 192 192 256-128 64-128 128 64 128 128 192 128 128 192 128 64-64 128-128zM960 320h-128v128h-128v-128h-128v-128h128v-128h128v128h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-plus",
						"telephone",
						"contact",
						"contact-add",
						"support",
						"call"
					],
					"defaultCode": 59938,
					"grid": 16
				},
				{
					"id": 2099,
					"paths": [
						"M321.26 574.74c-37.366-42.246-65.26-84.492-65.26-126.74 0-64 64-64 128-128s-128-256-192-256-192 192-192 192c0 107.636 92.99 308.25 196.608 443.392l124.652-124.652z",
						"M704 640c-64 64-64 128-128 128-41.556 0-83.114-26.998-124.67-63.446l430.612-430.614c18.744-18.746 18.744-49.138 0-67.882-18.746-18.744-49.136-18.744-67.882 0l-736 736c-18.746 18.746-18.746 49.136 0 67.882 9.372 9.374 21.656 14.060 33.94 14.060s24.568-4.686 33.942-14.058l180.876-180.876c135.108 102.944 334.126 194.934 441.182 194.934 0 0 192-128 192-192s-192-256-256-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-slash",
						"telephone",
						"contact",
						"phone-cancel",
						"call"
					],
					"defaultCode": 59934,
					"grid": 16
				},
				{
					"id": 2108,
					"paths": [
						"M807.31 1024h-12.11c-65.656 0-164.424-30.696-270.976-84.212-104.108-52.292-199.156-117.622-260.774-179.236-61.618-61.618-126.946-156.664-179.236-260.772-53.52-106.556-84.214-205.324-84.214-270.982v-12.112l6.716-10.076c1.334-2 33.116-49.534 73.356-97.82 42.21-50.65 97.26-108.79 148.728-108.79 44.432 0 99.506 44.564 128.382 71.128 22.172 20.398 76.412 74.278 101.11 133.906 26.14 63.108 3.448 99.128-12.41 114.982-27.332 27.332-54.24 43.962-75.862 57.326-33.994 21.010-38.288 25.524-38.288 40.256 0 46.36 58.024 104.386 114.134 160.504 56.138 56.134 114.166 114.162 160.53 114.162 14.732 0 19.248-4.294 40.256-38.288 13.366-21.624 29.996-48.532 57.328-75.864 15.952-15.952 37.094-24.382 61.148-24.382 26.066 0 55.768 9.972 88.278 29.64 25.7 15.544 52.914 37.026 78.71 62.114 21.558 20.966 91.884 93.716 91.884 149.716 0 51.468-58.14 106.522-108.792 148.728-48.288 40.24-95.82 72.022-97.82 73.354l-10.078 6.718zM80.424 240.564c3.69 53.558 31.24 135.628 75.278 223.306 47.894 95.352 109.32 185.116 164.316 240.11 54.996 54.992 144.756 116.424 240.112 164.316 87.678 44.040 169.742 71.59 223.298 75.28 15.568-10.836 46.39-32.88 77.362-58.452 72.868-60.158 82.144-86.454 83.138-90.16-1.822-11.636-23.552-49.972-70.106-94.56-47.826-45.808-89.868-66.672-108.692-66.672-2.408 0-3.95 0.318-4.58 0.952-20.746 20.746-33.506 41.39-45.844 61.356-22.082 35.728-47.114 76.226-108.306 76.226-79.5 0-149.444-69.94-217.080-137.574-67.654-67.656-137.588-137.594-137.588-217.092 0-61.196 40.496-86.226 76.228-108.308 19.964-12.338 40.61-25.098 61.352-45.842 1.198-1.196 2.112-8.574-2.96-22.708-10.588-29.506-40.378-69.934-77.744-105.504-40.45-38.504-70.86-53.694-79.586-55.16-3.76 1.014-30.166 10.384-90.534 83.6-25.476 30.894-47.306 61.422-58.064 76.886v0z",
						"M48 1024c-12.284 0-24.568-4.686-33.942-14.058-18.746-18.746-18.746-49.136 0-67.882l736-736c18.746-18.744 49.136-18.744 67.882 0 18.744 18.746 18.744 49.138 0 67.882l-736 736c-9.372 9.372-21.656 14.058-33.94 14.058z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-slash",
						"telephone",
						"phone-cancel",
						"contact",
						"call"
					],
					"defaultCode": 59943,
					"grid": 16
				},
				{
					"id": 1322,
					"width": 877.7129821777344,
					"paths": [
						"M731.429 681.714q0-6.286-1.143-9.143-1.714-4.571-22-16.857t-50.571-28.286l-30.286-16.571q-2.857-1.714-10.857-7.429t-14.286-8.571-12-2.857q-10.286 0-26.857 18.571t-32.571 37.429-25.143 18.857q-4 0-9.429-2t-8.857-3.714-9.714-5.429-8-4.857q-56.571-31.429-97.429-72.286t-72.286-97.429q-1.143-1.714-4.857-8t-5.429-9.714-3.714-8.857-2-9.429q0-7.429 11.714-19.143t25.714-22 25.714-22.571 11.714-20.857q0-5.714-2.857-12t-8.571-14.286-7.429-10.857q-1.714-3.429-8.571-16.286t-14.286-26-15.143-27.143-14.286-23.143-9.429-10.286-9.143-1.143q-27.429 0-57.714 12.571-26.286 12-45.714 54t-19.429 74.571q0 9.143 1.429 19.429t2.857 17.429 5.143 18.857 5.714 16.857 7.143 18.857 6.286 17.143q34.286 93.714 123.714 183.143t183.143 123.714q3.429 1.143 17.143 6.286t18.857 7.143 16.857 5.714 18.857 5.143 17.429 2.857 19.429 1.429q32.571 0 74.571-19.429t54-45.714q12.571-30.286 12.571-57.714zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-square"
					],
					"defaultCode": 61592,
					"grid": 14
				},
				{
					"id": 2100,
					"paths": [
						"M704 640c64-64 256 128 256 192s-192 192-192 192c-128 0-387.5-131.5-512-256s-256-384-256-512c0 0 128-192 192-192s256 192 192 256-128 64-128 128 64 128 128 192 128 128 192 128 64-64 128-128z",
						"M736 512c-17.674 0-32-14.328-32-32 0-88.224-71.776-160-160-160-17.674 0-32-14.328-32-32s14.326-32 32-32c123.514 0 224 100.486 224 224 0 17.672-14.326 32-32 32z",
						"M864 512c-17.674 0-32-14.328-32-32 0-158.804-129.196-288-288-288-17.674 0-32-14.328-32-32s14.326-32 32-32c194.094 0 352 157.906 352 352 0 17.672-14.326 32-32 32z",
						"M992 512c-17.674 0-32-14.328-32-32 0-229.382-186.618-416-416-416-17.674 0-32-14.328-32-32s14.326-32 32-32c128.212 0 248.752 49.928 339.412 140.588s140.588 211.2 140.588 339.412c0 17.672-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-wave",
						"telephone",
						"contact",
						"support",
						"call"
					],
					"defaultCode": 59935,
					"grid": 16
				},
				{
					"id": 2109,
					"paths": [
						"M807.31 1024h-12.11c-65.656 0-164.424-30.696-270.976-84.212-104.108-52.292-199.156-117.622-260.774-179.236-61.618-61.618-126.946-156.664-179.236-260.772-53.52-106.556-84.214-205.324-84.214-270.982v-12.112l6.716-10.076c1.334-2 33.116-49.534 73.356-97.82 42.21-50.65 97.26-108.79 148.728-108.79 44.432 0 99.506 44.564 128.382 71.128 22.172 20.398 76.412 74.278 101.11 133.906 26.14 63.108 3.448 99.128-12.41 114.982-27.332 27.332-54.24 43.962-75.862 57.326-33.994 21.010-38.288 25.524-38.288 40.256 0 46.36 58.024 104.386 114.134 160.504 56.138 56.134 114.166 114.162 160.53 114.162 14.732 0 19.248-4.294 40.256-38.288 13.366-21.624 29.996-48.532 57.328-75.864 15.952-15.952 37.094-24.382 61.148-24.382 26.066 0 55.768 9.972 88.278 29.64 25.7 15.544 52.914 37.026 78.71 62.114 21.558 20.966 91.884 93.716 91.884 149.716 0 51.468-58.14 106.522-108.792 148.728-48.288 40.24-95.82 72.022-97.82 73.354l-10.078 6.718zM80.424 240.564c3.69 53.558 31.24 135.628 75.278 223.306 47.894 95.352 109.32 185.116 164.316 240.11 54.996 54.992 144.756 116.424 240.112 164.316 87.678 44.040 169.742 71.59 223.298 75.28 15.568-10.836 46.39-32.88 77.362-58.452 72.868-60.158 82.144-86.454 83.138-90.16-1.822-11.636-23.552-49.972-70.106-94.56-47.826-45.808-89.868-66.672-108.692-66.672-2.408 0-3.95 0.318-4.58 0.952-20.746 20.746-33.506 41.39-45.844 61.356-22.082 35.728-47.114 76.226-108.306 76.226-79.5 0-149.444-69.94-217.080-137.574-67.654-67.656-137.588-137.594-137.588-217.092 0-61.196 40.496-86.226 76.228-108.308 19.964-12.338 40.61-25.098 61.352-45.842 1.198-1.196 2.112-8.574-2.96-22.708-10.588-29.506-40.378-69.934-77.744-105.504-40.45-38.504-70.86-53.694-79.586-55.16-3.76 1.014-30.166 10.384-90.534 83.6-25.476 30.894-47.306 61.422-58.064 76.886v0z",
						"M736 512c-17.674 0-32-14.328-32-32 0-88.224-71.776-160-160-160-17.674 0-32-14.328-32-32s14.326-32 32-32c123.514 0 224 100.486 224 224 0 17.672-14.326 32-32 32z",
						"M864 512c-17.674 0-32-14.328-32-32 0-158.804-129.196-288-288-288-17.674 0-32-14.328-32-32s14.326-32 32-32c194.094 0 352 157.906 352 352 0 17.672-14.326 32-32 32z",
						"M992 512c-17.674 0-32-14.328-32-32 0-229.382-186.618-416-416-416-17.674 0-32-14.328-32-32s14.326-32 32-32c128.212 0 248.752 49.928 339.412 140.588s140.588 211.2 140.588 339.412c0 17.672-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone-wave",
						"telephone",
						"contact",
						"support",
						"call"
					],
					"defaultCode": 59944,
					"grid": 16
				},
				{
					"id": 2098,
					"paths": [
						"M704 640c-64 64-64 128-128 128s-128-64-192-128-128-128-128-192 64-64 128-128-128-256-192-256-192 192-192 192c0 128 131.5 387.5 256 512s384 256 512 256c0 0 192-128 192-192s-192-256-256-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone",
						"telephone",
						"contact",
						"support",
						"call"
					],
					"defaultCode": 59933,
					"grid": 16
				},
				{
					"id": 2107,
					"paths": [
						"M807.31 1024h-12.11c-65.656 0-164.424-30.696-270.976-84.212-104.108-52.292-199.158-117.622-260.774-179.238-61.618-61.616-126.946-156.664-179.236-260.772-53.52-106.554-84.214-205.322-84.214-270.98v-12.112l6.718-10.076c1.334-2 33.114-49.534 73.354-97.82 42.21-50.65 97.26-108.79 148.728-108.79 44.43 0 99.506 44.564 128.382 71.128 22.172 20.398 76.412 74.278 101.11 133.906 26.14 63.108 3.446 99.128-12.41 114.982-27.332 27.332-54.24 43.962-75.862 57.326-33.994 21.010-38.288 25.524-38.288 40.256 0 46.36 58.024 104.386 114.136 160.504 56.138 56.134 114.166 114.162 160.53 114.162 14.732 0 19.248-4.294 40.256-38.288 13.364-21.624 29.996-48.532 57.328-75.864 15.95-15.95 37.094-24.382 61.148-24.382 26.066 0 55.768 9.972 88.278 29.642 25.698 15.544 52.914 37.024 78.71 62.112 21.556 20.966 91.882 93.714 91.882 149.716 0 51.468-58.14 106.52-108.792 148.728-48.288 40.24-95.82 72.022-97.82 73.354l-10.078 6.718zM80.424 240.564c3.69 53.558 31.24 135.628 75.278 223.306 47.894 95.354 109.32 185.116 164.316 240.11 54.996 54.996 144.756 116.424 240.112 164.316 87.678 44.040 169.742 71.59 223.298 75.28 15.57-10.836 46.392-32.88 77.362-58.45 72.868-60.16 82.144-86.454 83.138-90.162-1.822-11.636-23.552-49.972-70.104-94.56-47.826-45.808-89.868-66.672-108.692-66.672-2.408 0-3.95 0.32-4.58 0.952-20.746 20.746-33.506 41.39-45.844 61.354-22.082 35.73-47.114 76.228-108.308 76.228-79.5 0-149.442-69.94-217.080-137.574-67.654-67.656-137.588-137.594-137.588-217.092 0-61.196 40.498-86.226 76.23-108.308 19.964-12.338 40.608-25.098 61.352-45.842 1.196-1.196 2.11-8.574-2.962-22.708-10.588-29.506-40.378-69.934-77.744-105.504-40.45-38.504-70.86-53.694-79.586-55.16-3.76 1.014-30.166 10.384-90.534 83.6-25.476 30.894-47.306 61.422-58.064 76.886z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone",
						"telephone",
						"contact",
						"support",
						"call"
					],
					"defaultCode": 59942,
					"grid": 16
				},
				{
					"id": 1319,
					"width": 804.5699625015259,
					"paths": [
						"M804.571 708.571q0 15.429-5.714 40.286t-12 39.143q-12 28.571-69.714 60.571-53.714 29.143-106.286 29.143-15.429 0-30-2t-32.857-7.143-27.143-8.286-31.714-11.714-28-10.286q-56-20-100-47.429-73.143-45.143-151.143-123.143t-123.143-151.143q-27.429-44-47.429-100-1.714-5.143-10.286-28t-11.714-31.714-8.286-27.143-7.143-32.857-2-30q0-52.571 29.143-106.286 32-57.714 60.571-69.714 14.286-6.286 39.143-12t40.286-5.714q8 0 12 1.714 10.286 3.429 30.286 43.429 6.286 10.857 17.143 30.857t20 36.286 17.714 30.571q1.714 2.286 10 14.286t12.286 20.286 4 16.286q0 11.429-16.286 28.571t-35.429 31.429-35.429 30.286-16.286 26.286q0 5.143 2.857 12.857t4.857 11.714 8 13.714 6.571 10.857q43.429 78.286 99.429 134.286t134.286 99.429q1.143 0.571 10.857 6.571t13.714 8 11.714 4.857 12.857 2.857q10.286 0 26.286-16.286t30.286-35.429 31.429-35.429 28.571-16.286q8 0 16.286 4t20.286 12.286 14.286 10q14.286 8.571 30.571 17.714t36.286 20 30.857 17.143q40 20 43.429 30.286 1.714 4 1.714 12z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone"
					],
					"defaultCode": 61589,
					"grid": 14
				},
				{
					"id": 144,
					"paths": [
						"M916.19 455.509c-53.283 0.002-149.901-19.214-180.016-49.326-18.466-18.466-22.854-41.64-26.381-60.262-4.344-22.931-6.95-29.755-17.010-34.077-46.194-19.853-112.456-31.238-181.8-31.238-68.621 0-134.16 11.189-179.81 30.699-9.939 4.248-12.499 11.050-16.741 33.938-3.459 18.672-7.765 41.91-26.234 60.381-16.814 16.813-51.976 28.36-78.512 35.086-34.218 8.674-70.85 13.646-100.502 13.646-33.982 0-56.965-6.461-70.258-19.755-20.021-20.019-32.797-47.4-35.050-75.12-1.901-23.365 2.6-57.979 34.824-90.205 52.315-52.315 122.699-93.11 209.195-121.253 79.549-25.882 170.093-39.562 261.842-39.562 92.378 0 183.67 13.848 264.006 40.048 87.304 28.472 158.35 69.688 211.163 122.499 53.766 53.765 40.451 125.102 0.629 164.928-13.173 13.17-35.856 19.571-69.347 19.573zM510.986 229.405c77.157 0 148.901 12.571 202.014 35.398 36.51 15.69 42.632 48 47.099 71.59 2.672 14.104 4.979 26.285 12.28 33.586 12.915 12.914 87.362 34.331 143.811 34.33 24.638 0 32.398-4.219 33.4-4.835 15.851-16.061 35.757-55.621-0.885-92.261-92.392-92.392-256.493-147.552-438.966-147.552-180.973 0-343.526 54.51-434.832 145.818-14.76 14.76-21.488 31.533-19.998 49.853 1.258 15.462 8.72 31.445 19.986 42.827 0.965 0.606 8.846 5 34.291 5 56.242 0 130.12-21.048 142.811-33.738 7.226-7.227 9.482-19.403 12.094-33.502 4.382-23.659 10.386-56.061 46.963-71.691 52.538-22.456 123.541-34.822 199.931-34.822z",
						"M844.8 921.6h-665.6c-34.347 0-66.043-13.509-89.248-38.040-23.206-24.531-34.936-56.928-33.032-91.222 0.218-3.928 6.024-97.307 65.029-191.453 34.904-55.694 81.181-100.088 137.541-131.946 69.658-39.374 154.613-59.339 252.51-59.339s182.853 19.965 252.509 59.339c56.363 31.858 102.637 76.251 137.542 131.946 59.005 94.146 64.811 187.525 65.030 191.453 1.904 34.296-9.827 66.691-33.034 91.222s-54.901 38.040-89.248 38.040zM512 460.8c-159.592 0-275.859 55.696-345.574 165.541-52.726 83.077-58.336 168.038-58.387 168.888-1.114 20.050 5.67 38.942 19.107 53.146s31.923 22.026 52.054 22.026h665.6c20.131 0 38.618-7.822 52.054-22.027 13.435-14.203 20.222-33.096 19.104-53.195-0.046-0.798-5.658-85.762-58.384-168.837-69.715-109.845-185.984-165.541-345.574-165.541z",
						"M512 819.2c-84.696 0-153.6-68.904-153.6-153.6s68.904-153.6 153.6-153.6 153.6 68.904 153.6 153.6-68.904 153.6-153.6 153.6zM512 563.2c-56.464 0-102.4 45.936-102.4 102.4s45.936 102.4 102.4 102.4c56.464 0 102.4-45.936 102.4-102.4s-45.936-102.4-102.4-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"phone",
						"telephone",
						"call",
						"contact"
					],
					"defaultCode": 59441,
					"grid": 20
				},
				{
					"id": 679,
					"width": 1024,
					"paths": [
						"M896 224h-160l-37.472-74.944c-16.256-32.512-49.504-53.056-85.856-53.056h-201.344c-36.352 0-69.6 20.544-85.856 53.056l-37.472 74.944h-160c-53.024 0-96 42.976-96 96v480c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-480c0-53.024-42.976-96-96-96zM960 800c0 35.296-28.704 64-64 64h-768c-35.296 0-64-28.704-64-64v-480c0-35.296 28.704-64 64-64h179.776l46.304-92.608c10.912-21.824 32.864-35.392 57.248-35.392h201.344c24.384 0 46.336 13.568 57.248 35.392l46.304 92.608h179.776c35.296 0 64 28.704 64 64v480zM256 320c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-64zM224 384h-96v-64h96v64zM512 288c-141.376 0-256 114.624-256 256s114.624 256 256 256 256-114.624 256-256-114.624-256-256-256zM512 768c-123.52 0-224-100.48-224-224s100.48-224 224-224 224 100.48 224 224-100.48 224-224 224zM512 352c-106.048 0-192 85.952-192 192s85.952 192 192 192 192-85.952 192-192-85.952-192-192-192zM512 704c-88.224 0-160-71.776-160-160s71.776-160 160-160 160 71.776 160 160-71.776 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"photograph",
						"capture",
						"snap"
					],
					"grid": 32
				},
				{
					"id": 680,
					"width": 1024,
					"paths": [
						"M672 544c0 88.224-71.776 160-160 160s-160-71.776-160-160 71.776-160 160-160 160 71.776 160 160zM128 384h96v-64h-96v64zM736 544c0 123.52-100.48 224-224 224s-224-100.48-224-224 100.48-224 224-224 224 100.48 224 224zM704 544c0-106.048-85.952-192-192-192s-192 85.952-192 192 85.952 192 192 192 192-85.952 192-192zM992 320v480c0 53.024-42.976 96-96 96h-768c-53.024 0-96-42.976-96-96v-480c0-53.024 42.976-96 96-96h160l37.472-74.944c16.256-32.512 49.504-53.056 85.856-53.056h201.344c36.352 0 69.6 20.544 85.856 53.056l37.472 74.944h160c53.024 0 96 42.976 96 96zM256 384v-64c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32zM768 544c0-141.376-114.624-256-256-256s-256 114.624-256 256 114.624 256 256 256 256-114.624 256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"photograph",
						"capture",
						"snap"
					],
					"grid": 32
				},
				{
					"id": 1077,
					"width": 1024,
					"paths": [
						"M736 224l-54.496-81.76c-5.952-8.896-15.936-14.24-26.624-14.24h-285.76c-10.688 0-20.704 5.344-26.624 14.24l-54.496 81.76h-64v-32h-128v32h-64c-17.664 0-32 14.336-32 32v608c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-608c0-17.664-14.336-32-32-32h-256zM960 832h-896v-384h200.384c-5.28 20.48-8.384 41.856-8.384 64 0 141.376 114.624 256 256 256s256-114.624 256-256c0-22.144-3.104-43.52-8.384-64h200.384v384zM512 288c123.52 0 224 100.48 224 224s-100.48 224-224 224-224-100.48-224-224 100.48-224 224-224zM960 416h-210.784c-37.984-93.792-129.792-160-237.216-160s-199.232 66.208-237.216 160h-210.784v-128h258.24l64-96h251.488l64 96h258.272v128zM512 704c106.048 0 192-85.952 192-192s-85.952-192-192-192-192 85.952-192 192 85.952 192 192 192zM512 352c88.224 0 160 71.776 160 160s-71.776 160-160 160-160-71.776-160-160 71.776-160 160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"photograph",
						"capture",
						"snap"
					],
					"grid": 32
				},
				{
					"id": 1896,
					"paths": [
						"M0 0v1024h960v-1024h-960zM192 960h-128v-896h64v640h64v256zM448.002 960h-192v-256h64v-640h64v640h64v256zM704 960h-192v-256h64v-640h64v640h64v256zM896 960h-128v-256h64v-640h64v896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"piano",
						"music",
						"song",
						"audio",
						"musical-instrument"
					],
					"defaultCode": 59731,
					"grid": 16
				},
				{
					"id": 134,
					"paths": [
						"M947.2 1024h-870.4c-42.347 0-76.8-34.451-76.8-76.8v-870.4c0-42.347 34.453-76.8 76.8-76.8h870.4c42.349 0 76.8 34.453 76.8 76.8v870.4c0 42.349-34.451 76.8-76.8 76.8zM76.8 51.2c-14.115 0-25.6 11.485-25.6 25.6v870.4c0 14.115 11.485 25.6 25.6 25.6h870.4c14.115 0 25.6-11.485 25.6-25.6v-870.4c0-14.115-11.485-25.6-25.6-25.6h-870.4z",
						"M665.6 460.8c-56.464 0-102.4-45.936-102.4-102.4s45.936-102.4 102.4-102.4 102.4 45.936 102.4 102.4-45.936 102.4-102.4 102.4zM665.6 307.2c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2 51.2-22.968 51.2-51.2-22.968-51.2-51.2-51.2z",
						"M896 102.4h-768c-14.138 0-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6h768c14.139 0 25.6-11.461 25.6-25.6v-614.4c0-14.138-11.461-25.6-25.6-25.6zM153.6 598.533l164.318-184.858c4.203-4.728 9.694-7.371 15.462-7.44 5.725-0.090 11.322 2.438 15.638 7.062l283.27 303.502h-478.69v-118.267zM870.4 716.8h-168.075l-315.875-338.437c-14.269-15.288-33.312-23.605-53.691-23.325-20.354 0.246-39.214 8.992-53.107 24.621l-126.051 141.808v-367.867h716.8v563.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"picture",
						"photo",
						"polaroid"
					],
					"defaultCode": 59431,
					"grid": 20
				},
				{
					"id": 2453,
					"paths": [
						"M448 576v-448c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448c0-72.034-17.028-140.084-47.236-200.382l-400.764 200.382zM912.764 247.618c-73.552-146.816-225.374-247.618-400.764-247.618v448l400.764-200.382z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart",
						"stats",
						"statistics",
						"graph"
					],
					"defaultCode": 60288,
					"grid": 16
				},
				{
					"id": 161,
					"paths": [
						"M435.2 1024c-116.246 0-225.534-45.269-307.733-127.467s-127.467-191.488-127.467-307.733c0-116.246 45.269-225.534 127.467-307.733s191.486-127.467 307.733-127.467c14.138 0 25.6 11.462 25.6 25.6v384h384c14.139 0 25.6 11.461 25.6 25.6 0 116.245-45.269 225.534-127.467 307.733s-191.488 127.467-307.733 127.467zM409.6 205.643c-199.842 13.226-358.4 180.026-358.4 383.157 0 211.739 172.262 384 384 384 203.131 0 369.931-158.558 383.157-358.4h-383.157c-14.138 0-25.6-11.461-25.6-25.6v-383.157z",
						"M947.2 512h-409.6c-14.139 0-25.6-11.462-25.6-25.6v-409.6c0-14.138 11.461-25.6 25.6-25.6 116.245 0 225.534 45.269 307.733 127.467s127.467 191.486 127.467 307.733c0 14.138-11.461 25.6-25.6 25.6zM563.2 460.8h357.557c-12.664-191.374-166.184-344.891-357.557-357.557v357.557z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart",
						"chart",
						"statistics"
					],
					"defaultCode": 59458,
					"grid": 20
				},
				{
					"id": 2454,
					"paths": [
						"M448 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448h-448v-448zM576 0v448h448c0-247.424-200.576-448-448-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart",
						"stats",
						"statistics",
						"graph"
					],
					"defaultCode": 60289,
					"grid": 16
				},
				{
					"id": 2455,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM295.006 904c-9.068-5.032-17.942-10.372-26.612-16h487.226c-8.672 5.63-17.55 10.966-26.624 16h-433.99zM697.27 920c-13.112 5.962-26.566 11.3-40.316 16h-289.906c-13.744-4.698-27.188-10.040-40.292-16h370.514zM245.358 872c-6.934-5.146-13.728-10.47-20.346-16h573.982c-6.618 5.528-13.404 10.856-20.338 16h-533.298zM190.554 824h588.192l16 16h-587.842c-5.584-5.196-11.038-10.528-16.35-16zM586.746 632l16 16h-517.672c-1.684-5.292-3.268-10.624-4.76-16h506.432zM76.168 616c-1.258-5.294-2.398-10.634-3.466-16h482.044l16 16h-494.578zM618.746 664l16 16h-538.122c-2.14-5.288-4.2-10.616-6.142-16h528.264zM650.746 696l16 16h-555.682c-2.634-5.274-5.162-10.61-7.592-16h547.274zM682.746 728l16 16h-570.032c-3.192-5.264-6.282-10.598-9.26-16h563.292zM714.746 760l16 16h-580.688c-3.834-5.248-7.556-10.582-11.164-16h575.852zM746.746 792l16 16h-587.010c-4.602-5.224-9.076-10.562-13.434-16h584.444zM530.746 576l8 8h-468.938c-0.43-2.66-0.856-5.324-1.238-8h462.176zM512 64v448h-448c0-247.424 200.576-448 448-448zM427.38 952h169.226c-27.4 5.238-55.68 8-84.608 8-28.93 0-57.212-2.76-84.618-8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart",
						"stats",
						"statistics",
						"graph",
						"dualtone"
					],
					"defaultCode": 60290,
					"grid": 16
				},
				{
					"id": 2456,
					"paths": [
						"M512 0c282.77 0 512 229.23 512 512h-512v-512zM448 3.976c-252.562 31.496-448 246.93-448 508.024 0 282.77 229.23 512 512 512 261.094 0 476.53-195.438 508.026-448h-572.026v-572.024zM367.068 88h16.932v16h-57.234c13.154-5.98 26.606-11.316 40.302-16zM295.018 120h88.982v16h-115.616c8.698-5.644 17.58-10.98 26.634-16zM245.328 152h138.672v16h-158.98c6.626-5.534 13.396-10.874 20.308-16zM206.876 184h177.124v16h-193.464c5.322-5.482 10.77-10.816 16.34-16zM175.74 216h208.26v16h-221.706c4.35-5.424 8.83-10.76 13.446-16zM150.048 248h233.952v16h-245.116c3.598-5.408 7.324-10.74 11.164-16zM128.708 280h255.292v16h-264.52c2.968-5.39 6.034-10.728 9.228-16zM111.098 312h272.902v16h-280.498c2.424-5.38 4.958-10.714 7.596-16zM96.646 344h287.354v16h-293.456c1.936-5.372 3.962-10.708 6.102-16zM85.124 376h298.876v16h-303.662c1.49-5.368 3.098-10.698 4.786-16zM76.226 408h307.774v16h-311.276c1.072-5.358 2.238-10.692 3.502-16zM69.81 440h314.19v16h-316.472c0.672-5.352 1.418-10.688 2.282-16zM65.792 472h318.208v16h-319.334c0.286-5.346 0.65-10.682 1.126-16zM64 512c0-2.67 0.044-5.334 0.092-8h319.908v16h-319.902c-0.046-2.664-0.098-5.328-0.098-8zM64.64 536h319.36v16h-318.22c-0.466-5.316-0.86-10.648-1.14-16zM67.442 568h316.558v16h-314.244c-0.856-5.316-1.648-10.644-2.314-16zM72.614 600h311.386v16h-307.874c-1.262-5.312-2.446-10.642-3.512-16zM512 960c-28.724 0-57.026-2.702-84.746-8h169.046c-27.592 5.276-55.802 8-84.3 8zM656.724 936h-289.78c-9.868-3.378-19.642-7.092-29.306-11.18-3.68-1.556-7.33-3.17-10.958-4.82h370.436c-13.196 5.988-26.676 11.322-40.392 16zM728.932 904h-434.002c-9.072-5.028-17.956-10.36-26.64-16h487.298c-8.712 5.648-17.602 10.986-26.656 16zM778.668 872h-533.418c-6.898-5.124-13.648-10.466-20.26-16h573.976c-6.63 5.538-13.392 10.878-20.298 16zM817.13 840h-610.248c-3.94-3.67-7.842-7.392-11.666-11.216-1.578-1.578-3.12-3.186-4.67-4.784h642.928c-5.298 5.458-10.75 10.792-16.344 16zM848.288 808h-672.558c-4.622-5.238-9.112-10.572-13.468-16h699.454c-4.348 5.426-8.82 10.766-13.428 16zM873.962 776h-723.964c-3.842-5.256-7.576-10.586-11.18-16h746.31c-3.602 5.41-7.326 10.742-11.166 16zM895.294 744h-766.674c-3.188-5.262-6.246-10.604-9.216-16h785.144c-2.976 5.394-6.058 10.728-9.254 16zM912.962 712h-801.946c-2.634-5.28-5.192-10.604-7.624-16h817.16c-2.428 5.38-4.95 10.718-7.59 16zM927.392 680h-830.81c-2.148-5.304-4.208-10.634-6.144-16h843.082c-1.94 5.376-3.984 10.708-6.128 16zM941.43 640c-0.796 2.676-1.624 5.342-2.47 8h-853.944c-1.692-5.308-3.294-10.638-4.784-16h303.768v8h557.43z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart",
						"stats",
						"statistics",
						"graph",
						"dualtone"
					],
					"defaultCode": 60291,
					"grid": 16
				},
				{
					"id": 2457,
					"paths": [
						"M448 576v-572.024c-252.562 31.496-448 246.93-448 508.024 0 282.77 229.23 512 512 512 261.094 0 476.53-195.438 508.026-448h-572.026zM809.58 846.888c-82.014 72.942-187.696 113.112-297.58 113.112-60.508 0-119.172-11.836-174.362-35.18-53.34-22.56-101.256-54.874-142.42-96.038-41.166-41.162-73.478-89.080-96.038-142.42-23.344-55.19-35.18-113.854-35.18-174.362 0-109.884 40.17-215.566 113.112-297.578 55.866-62.816 127.634-108.242 206.888-131.85v557.428h557.43c-23.61 79.256-69.036 151.022-131.85 206.888zM512 0c282.77 0 512 229.23 512 512h-512v-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart",
						"stats",
						"statistics",
						"graph"
					],
					"defaultCode": 60292,
					"grid": 16
				},
				{
					"id": 2458,
					"paths": [
						"M448 3.976v572.024h572.026c-31.496 252.562-246.932 448-508.026 448-282.77 0-512-229.23-512-512 0-261.094 195.438-476.528 448-508.024zM512 0v512h512c0-282.77-229.23-512-512-512zM576 440h378.272c0.428 2.662 0.84 5.328 1.22 8h-379.492v-8zM657.084 88c9.858 3.378 19.624 7.096 29.278 11.18 3.682 1.556 7.33 3.17 10.958 4.82h-121.32v-16h81.084zM576 72v-3.494c7.006 0.998 13.976 2.166 20.91 3.494h-20.91zM729.070 120c9.070 5.028 17.956 10.36 26.64 16h-179.71v-16h153.070zM778.75 152c6.896 5.124 13.646 10.466 20.26 16h-223.010v-16h202.75zM817.118 184c3.94 3.67 7.842 7.392 11.666 11.216 1.578 1.58 3.12 3.186 4.672 4.784h-257.456v-16h241.118zM848.27 216c4.624 5.238 9.112 10.574 13.468 16h-285.738v-16h272.27zM874.002 248c3.844 5.256 7.576 10.586 11.182 16h-309.184v-16h298.002zM895.38 280c3.188 5.262 6.244 10.604 9.216 16h-328.596v-16h319.38zM912.984 312c2.634 5.28 5.192 10.604 7.624 16h-344.608v-16h336.984zM927.452 344c2.148 5.302 4.18 10.638 6.116 16h-357.568v-16h351.452zM939.004 376c1.692 5.308 3.292 10.64 4.782 16h-367.786v-16h363.004zM947.894 408c1.262 5.31 2.424 10.644 3.49 16h-375.384v-16h371.894z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart",
						"stats",
						"statistics",
						"graph",
						"dualtone"
					],
					"defaultCode": 60293,
					"grid": 16
				},
				{
					"id": 2459,
					"paths": [
						"M448 576v-572.024c-252.562 31.496-448 246.93-448 508.024 0 282.77 229.23 512 512 512 261.094 0 476.53-195.438 508.026-448h-572.026z",
						"M512 512h512c0-282.77-229.23-512-512-512v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart",
						"stats",
						"statistics",
						"graph"
					],
					"defaultCode": 60294,
					"grid": 16
				},
				{
					"id": 2462,
					"paths": [
						"M976 192c26.4 0 48-21.6 48-48v-96c0-26.4-21.6-48-48-48h-96c-26.4 0-48 21.6-48 48v16h-640v-16c0-26.4-21.6-48-48-48h-96c-26.4 0-48 21.6-48 48v96c0 26.4 21.6 48 48 48h16v640h-16c-26.4 0-48 21.6-48 48v96c0 26.4 21.6 48 48 48h96c26.4 0 48-21.6 48-48v-16h640v16c0 26.4 21.6 48 48 48h96c26.4 0 48-21.6 48-48v-96c0-26.4-21.6-48-48-48h-16v-640h16zM896 64h64v64h-64v-64zM64 64h64v64h-64v-64zM128 960h-64v-64h64v64zM960 960h-64v-64h64v64zM896 832h-16c-26.4 0-48 21.6-48 48v16h-640v-16c0-26.4-21.6-48-48-48h-16v-640h16c26.4 0 48-21.6 48-48v-16h640v16c0 26.4 21.6 48 48 48h16v640zM512 256v256h256c0-141.384-114.616-256-256-256zM448 576v-311.934c-110.414 28.418-192 128.65-192 247.934 0 141.384 114.616 256 256 256 119.286 0 219.516-81.586 247.934-192h-311.934z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart",
						"stats",
						"statistics",
						"chart"
					],
					"defaultCode": 60297,
					"grid": 16
				},
				{
					"id": 1645,
					"width": 987.4279174804688,
					"paths": [
						"M438.857 508.571l312 312q-60.571 61.714-141.429 96t-170.571 34.286q-119.429 0-220.286-58.857t-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857v435.429zM545.714 512h441.714q0 89.714-34.286 170.571t-96 141.429zM950.857 438.857h-438.857v-438.857q119.429 0 220.286 58.857t159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pie-chart"
					],
					"defaultCode": 61952,
					"grid": 14
				},
				{
					"id": 1807,
					"width": 1316.573946237564,
					"paths": [
						"M1316.571 0q-39.429 26.286-71.429 52.571t-50.857 46.286-34 40.857-21.429 32.857-12.571 25.429-8 16.857q-5.714 10.286-20.286 78t-27.714 94q-8.571 16.571-28.571 34.571t-38.571 28.857-41.429 23.429-27.429 16q-26.857 17.714-86.286 132-194.857-8-360 90.286-52.571 30.286-173.143 102.286 26.857-9.143 49.143-17.714t31.429-12.571l8.571-4q40.571-15.429 93.143-36.857t76.286-30.571 61.714-19.714 81.429-18q106.286-17.714 265.714 4 0.571 0 5.714 1.714 6.286 3.429 8 9.714t-1.714 12.571l-110.857 197.143q-8.571 16.571-26.857 12.571-73.143-13.714-202.286-13.714-83.429 0-229.714 25.429t-224 26.571q-46.857 0.571-85.143-7.429t-61.143-21.143-34.857-22.857-18.857-19.429l-0.571-0.571v-1.143q0-3.429 3.429-3.429 78.857 0 212-31.429 109.714-209.143 214-299.429t219.143-90.286q2.857 0 8.286 0.286t21.714 2.857 31.429 6.857 35.143 14 36 22.571 30.857 33.714 22.857 47.143l58.286-101.143q1.143-2.286 12-24.286t25.429-49.429 34.857-62.571 48-76.286 57.429-78.286q37.714-46.857 73.143-80.857t69.429-55.143 52.857-30.571 50.286-22.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pied-piper"
					],
					"defaultCode": 62126,
					"grid": 14
				},
				{
					"id": 1563,
					"width": 1164.5690155029297,
					"paths": [
						"M698.286 530.857q42.857-1.714 82 11.714t67.429 33.429 57.714 54 48 61.714 43.143 68.857q18.857 32 44.857 62.286t43.143 46 56.571 50.571q-27.429 17.143-62 32.857t-79.143 33.714-65.143 27.143q-25.143-21.143-42.286-65.714t-24.857-94-18.857-103.143-24.286-96.286-41.429-70.286-70-27.714l-5.714 1.143-3.429 2.286q2.286 2.857 7.429 8 3.429 2.857 16 13.429t14.571 12.571 10.857 10.286 10.286 11.714 6.571 12 6 15.714 2.571 17.714 2.286 23.143l0.571 18.857q0.571 14.857-1.429 32.857t-4.286 29.714-7.143 33.429-6.571 30.286q-20-0.571-57.714 5.429t-56 6q-22.286 0-41.143-5.714-1.143-9.143-1.143-26.857 0-42.286 1.714-54.857 1.143-7.429 18-23.714t32.571-33.714 15.143-29.429q-13.714-1.143-24.571 13.714-20.571 30.286-63.714 56.857t-78 26.571q-14.286 0-43.143-36t-60.857-79.714-48-55.143q-3.429-2.286-15.429-17.143-275.429 64-293.143 64-9.143 0-16-6.286t-6.857-15.429q0-8.571 4.857-15.143t12.857-8.286l277.714-60.571q-4.571-8-4.571-14.286t3.143-10 9.143-6.571 11.429-4 13.143-2.571 10.571-2.571q2.286-0.571 8.857-4.286t10-3.714q8.571 0 16 9.143t11.429 18.857q93.143-21.143 98.286-21.143 9.714 0 16.857 6.286t7.143 16q0 8.571-4.857 14.857t-13.429 8l-104 22.857-0.571 9.143q-0.571 14.857 46.571 67.143t59.714 52.286q26.857 0 68-45.714t41.143-73.714q0-20.571-13.429-30.286t-29.143-10.571-29.143-6.571-13.429-19.429q0-9.143 5.714-19.429l-38.857-10.857q24.571-25.143 24.571-66.857 0-14.857-2.857-33.143 46.857-9.143 82.286-9.143 25.143 0 40.857 0.857t27.714 4.857 17.714 7.714 11.714 14 8.857 19.143 9.714 27.143 13.714 34.286l28.571-14.286q-1.714 22.857-13.143 34.286t-24.286 12-22.857 3.714-9.429 11.714zM732.571 396.571q-2.857-2.857-7.714-8.857t-6.857-8.286-6-6.571-5.714-6l-4.571-4.571t-4.857-4.286-4.571-2.857-4.857-2.571q-4-1.714-8.286-2.857t-11.714-1.429-12.571-0.286h-40q-72 0-124 24.571 9.143-17.143 20.571-26.571t30.857-16.857 37.429-20.571 26.286-20.857 28.571-31.429 24.857-28.857q6.857 5.143 16 18t18.286 20.857 21.714 7.429l6.857-0.571v43.429l12.571 0.571q141.143-54.286 212-108.571 16-12 28.571-22.286t24.286-21.429 18.857-17.714 16.857-19.429 13.714-17.714 14-21.143 13.143-21.714 15.429-27.143 16.857-30.286l4-5.143q-1.143 30.286-24.571 79.429-45.143 94.286-117.143 150.857t-174.857 81.143q-8 1.714-24 4.286t-28.571 5.429-22.286 8q1.714 10.857 14 26.286t12.286 19.429q0 6.286-14.857 17.143zM606.286 922.857q22.286-14.857 75.143-27.143t83.714-12.286q5.143 0 12.857 8.857t16 24.286 14.857 28.571 13.714 29.143 8.286 18.857q-69.143 25.714-139.429 25.714-34.857 0-71.429-6.286zM469.714 553.143l27.429-6.857 62.286 101.143-41.714 27.429zM756 848.571q1.714 8.571 1.714 9.143 0 4-10 8.286t-26.286 7.429-30.857 5.429-30.571 4.286-18.286 2.571l-4-24.571q12-1.143 34.571-4.857t41.143-5.714 34.571-2h8zM494.857 489.714l-54.857 11.429-3.429-9.714q5.714-0.571 18.571-4t19.714-3.429q10.857 0 20 5.714zM606.286 852h17.714l5.714 47.429-23.429 6.857v-54.286zM1114.286 0.571v0zM1114.286 0.571l-0.571 2.857-1.143 1.143 0.571-1.714zM1114.286 0.571l0.571-0.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pied-piper-alt"
					],
					"defaultCode": 61864,
					"grid": 14
				},
				{
					"id": 1562,
					"width": 877.7129821777344,
					"paths": [
						"M597.714 582.857q0 36.571-21.714 62.286t-52 25.714q-24.571 0-40-8.571v-158.286q16-9.714 40-9.714 30.286 0 52 26t21.714 62.571zM401.714 338.286q0 36.571-21.714 62.571t-52 26q-24.571 0-40-8.571v-158.286q16-9.714 40-9.714 30.286 0 52 25.714t21.714 62.286zM722.857 584.571q0-76.571-50.286-130.857t-121.714-54.286q-11.429 0-22.286 1.714-13.143 44.571-44.571 77.714-49.714 54.286-120.571 57.714v363.429l120.571-23.429v-117.714q29.143 10.857 66.857 10.857 71.429 0 121.714-54.286t50.286-130.857zM526.857 340.571q0-76.571-50.571-130.857t-122-54.286q-42.286 0-80.571 20.571h-106.286v480l120.571-23.429v-117.714q31.429 10.857 66.286 10.857 71.429 0 122-54.286t50.571-130.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pied-piper-pp"
					],
					"defaultCode": 61863,
					"grid": 14
				},
				{
					"id": 2084,
					"paths": [
						"M961.5 384h-97.482c-22.96-43.788-57.322-82.47-99.984-113.424 0.348-27.518 10.698-53.788 29.282-74.11 3.76-4.114 7.854-7.974 12.166-11.478 10.266-8.336 14.346-22.126 10.27-34.706s-15.468-21.356-28.672-22.086c-2.344-0.13-4.724-0.196-7.080-0.196-56.65 0-104.792 37.006-121.6 88.102-45.12-15.52-94.554-24.102-146.4-24.102-207.576 0-376.656 137.258-383.74 308.8-3.746-0.124-7.562-0.116-11.426-0.118-43.674 0.732-50.068-50.692-52.148-84.994-4.134-38.226-61.898-38.79-63.996 0.622-7.412 24.65 0.608 62.924 7.83 86.172 16.74 54.462 63.86 80.33 117.348 84.998 4.382 0.31 8.62-0.012 12.664-0.836 12.378 43.176 35.244 82.956 66.252 117.356v0c2.622 2.91 5.318 5.772 8.054 8.602 14.424 16.938 43.162 58.346 43.162 119.398v64c0 35.346 42.98 64 96 64s96-28.654 96-64v-68.45c20.816 2.91 42.192 4.45 64 4.45s43.184-1.54 64-4.45v68.45c0 35.346 42.98 64 96 64s96-28.654 96-64v-64c0-61.060 28.742-102.466 43.164-119.4 2.734-2.828 5.424-5.684 8.042-8.588 0-0.002 0.012-0.012 0.012-0.012h-0.002c17.752-19.694 32.82-41.154 44.798-64h97.484c35.348 0 64-57.306 64-128 0.002-70.692-28.65-128-63.998-128zM608 320h-192c-17.672 0-32-14.328-32-32s14.328-32 32-32h192c17.674 0 32 14.328 32 32s-14.326 32-32 32zM768 512c-35.346 0-64-28.652-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.348-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"piggy-bank",
						"money",
						"save",
						"ecommerce"
					],
					"defaultCode": 59919,
					"grid": 16
				},
				{
					"id": 3270,
					"paths": [
						"M384 0h512v128h-128v896h-128v-896h-128v896h-128v-512c-141.384 0-256-114.616-256-256s114.616-256 256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pilcrow",
						"wysiwyg"
					],
					"defaultCode": 61105,
					"grid": 16
				},
				{
					"id": 254,
					"paths": [
						"M793.6 102.4h-435.2c-112.928 0-204.8 91.872-204.8 204.8s91.872 204.8 204.8 204.8h51.2v384c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-742.4h153.6v742.4c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-742.4h128c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6zM409.6 460.8h-51.2c-84.696 0-153.6-68.904-153.6-153.6s68.904-153.6 153.6-153.6h51.2v307.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pilcrow",
						"typography",
						"paragraph"
					],
					"defaultCode": 59551,
					"grid": 20
				},
				{
					"id": 2449,
					"paths": [
						"M939.646 84.354c-56.228-56.23-129.948-84.354-203.646-84.354-73.714 0-147.404 28.112-203.646 84.354l-448 448c-112.47 112.47-112.472 294.822 0 407.292 56.236 56.236 129.942 84.354 203.646 84.354s147.412-28.118 203.644-84.354l448-448c112.474-112.47 112.474-294.822 0.002-407.292zM457.374 265.374l128-128c12.496-12.498 32.758-12.498 45.254 0 12.498 12.496 12.498 32.758 0 45.254l-128 128c-6.248 6.248-14.438 9.372-22.628 9.372s-16.378-3.124-22.626-9.374c-12.498-12.496-12.498-32.756 0-45.252zM432.25 880.25c-38.53 38.53-89.76 59.75-144.25 59.75s-105.718-21.22-144.25-59.75c-38.53-38.532-59.75-89.76-59.75-144.25s21.218-105.718 59.75-144.25l208-208 288.5 288.5-208 208z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pill",
						"health",
						"medicine"
					],
					"defaultCode": 60284,
					"grid": 16
				},
				{
					"id": 681,
					"width": 1024,
					"paths": [
						"M977.28 942.816l-324.928-379.168 125.024-125.024c12.512-12.512 12.512-32.768 0-45.248l-28.128-28.128c-12.512-12.512-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-4.352 4.352-281.824-230.592c22.944-25.12 22.464-63.968-1.824-88.256l-28.128-28.128c-12.512-12.512-32.768-12.512-45.248 0l-274.752 274.752c-12.512 12.512-12.512 32.768 0 45.248l28.128 28.128c12.448 12.448 28.704 18.624 44.992 18.624 15.52 0 31.040-5.632 43.264-16.8l230.592 281.824-4.352 4.352c-24.992 24.992-24.992 65.504 0 90.496l28.128 28.128c12.512 12.512 32.768 12.512 45.248 0l125.152-125.152 379.040 325.056c4.576 3.936 10.24 5.888 15.904 5.888 6.272 0 12.544-2.4 17.28-7.168 9.024-9.024 9.568-23.488 1.28-33.184zM45.248 320l274.752-274.752 28.128 28.128c12.032 12.032 12.416 31.392 0.832 44.064l-12.384 12.448-219.136 219.072c-5.952 5.44-13.664 8.448-21.696 8.448-8.448 0-16.384-3.296-22.368-9.28l-28.128-28.128zM161.856 349.856l188.064-188.064 281.76 230.56-239.328 239.328-230.496-281.824zM416 754.752l-28.128-28.128c-12.48-12.48-12.48-32.768 0-45.248l293.504-293.504c6.048-6.048 14.080-9.376 22.624-9.376s16.576 3.328 22.624 9.376l28.128 28.128-338.752 338.752zM586.688 629.312l43.008-43.008 259.264 302.656-302.272-259.648z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pin",
						"save",
						"affix",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 682,
					"width": 1024,
					"paths": [
						"M976 976c-4.736 4.736-11.008 7.168-17.28 7.168-5.632 0-11.296-1.952-15.904-5.888l-354.688-304.16 85.088-85.088 304.032 354.784c8.32 9.696 7.776 24.16-1.248 33.184zM777.376 393.376l-28.128-28.128c-12.512-12.512-28.864-18.752-45.248-18.752s-32.768 6.24-45.248 18.752l-4.352 4.352-281.824-230.592c22.944-25.12 22.464-63.968-1.824-88.256l-28.128-28.128c-12.512-12.512-32.768-12.512-45.248 0l-274.752 274.752c-12.512 12.512-12.512 32.768 0 45.248l28.128 28.128c12.448 12.448 28.704 18.624 44.992 18.624 15.52 0 31.040-5.632 43.264-16.8l230.592 281.824-4.352 4.352c-24.992 24.992-24.992 65.504 0 90.496l28.128 28.128c12.512 12.512 32.768 12.512 45.248 0l338.752-338.752c12.48-12.48 12.48-32.768 0-45.248z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pin",
						"save",
						"affix",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 1078,
					"width": 1024,
					"paths": [
						"M1016.992 972l-358.176-447.712c29.632-52.608 45.184-111.68 45.184-172.288 0-194.080-157.92-352-352-352s-352 157.92-352 352 157.92 352 352 352c60.608 0 119.68-15.552 172.288-45.184l447.712 358.176c5.888 4.704 12.928 7.008 20 7.008 8.224 0 16.416-3.168 22.624-9.376 11.52-11.52 12.576-29.888 2.368-42.624zM352 640c-158.816 0-288-129.184-288-288s129.184-288 288-288c158.816 0 288 129.184 288 288s-129.184 288-288 288zM553.664 600.32c17.12-13.92 32.736-29.536 46.656-46.656l186.752 233.408-233.408-186.752zM352 96c-53.024 0-96 28.64-96 64 0 13.12 5.92 25.312 16.064 35.456 17.216 17.216 46.592 28.544 79.936 28.544 53.024 0 96-28.64 96-64 0-13.12-5.92-25.312-16.064-35.456-17.216-17.216-46.592-28.544-79.936-28.544zM402.144 178.624c-12.768 8.512-31.040 13.376-50.144 13.376-28.128 0-48.032-9.92-57.312-19.168-3.040-3.072-6.688-7.776-6.688-12.832 0-13.056 24.928-32 64-32 28.128 0 48.032 9.92 57.312 19.168 3.040 3.072 6.688 7.744 6.688 12.832 0 5.888-5.184 12.832-13.856 18.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pin",
						"save",
						"affix",
						"mark"
					],
					"grid": 32
				},
				{
					"id": 683,
					"width": 1024,
					"paths": [
						"M943.2 850.944l-231.2-213.408c146.208-175.584 106.656-361.216-119.84-531.328-63.84-47.936-139.744-71.776-215.072-71.776-91.456 0-182.112 35.136-249.28 105.024-155.584 161.824-109.472 376.672 51.008 537.184 17.76 17.76 35.68 32.864 53.664 46.656-10.88 29.024-13.152 62.272 4.352 98.496 18.592 38.528 55.232 67.456 97.664 73.088 69.728 9.248 130.304-37.664 143.008-101.824 53.792-10.368 107.36-37.152 160.064-80.992l213.664 231.040c24.704 26.72 66.72 27.488 92.384 1.664l1.6-1.6c25.536-25.792 24.64-67.616-2.016-92.224zM201.44 653.984c-123.232-123.232-210.432-326.144-50.592-492.384 59.008-61.376 139.36-95.2 226.208-95.2 70.176 0 139.744 23.232 195.872 65.376 93.216 70.016 152.576 141.92 178.272 214.368l-321.088 321.12c-21.664-16.832-48.544-27.264-78.112-27.264-43.296 0-81.44 21.632-104.608 54.56-15.36-12.128-30.688-25.312-45.952-40.576zM352 864c-52.928 0-96-43.072-96-96s43.072-96 96-96c52.928 0 96 43.072 96 96s-43.072 96-96 96zM920.48 922.272c-12.864 12.864-33.824 12.448-46.144-0.928l-233.92-253.408-23.36 19.456c-45.696 38.048-91.872 61.44-137.952 71.872-1.792-26.112-11.264-49.888-26.368-69.376l308.288-308.288c0.352 0.128 0.256 0.096 0.64 0.192 15.744 77.984-9.312 157.28-74.24 235.264l-19.456 23.36 253.408 233.92c13.344 12.32 13.76 33.28 0.928 46.144l-1.824 1.792z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ping",
						"play",
						"compete"
					],
					"grid": 32
				},
				{
					"id": 684,
					"width": 1024,
					"paths": [
						"M480 768c0 70.688-57.312 128-128 128s-128-57.312-128-128 57.312-128 128-128 128 57.312 128 128zM943.2 850.944l-231.2-213.408c77.184-92.704 102.080-188.16 75.552-282.688l-312.32 312.32c22.624 27.616 36.768 62.432 36.768 100.832 0 5.536-1.088 10.752-1.632 16.128 42.72-13.6 85.216-37.216 127.168-72.16l213.664 231.040c24.704 26.72 66.72 27.488 92.384 1.664l1.6-1.6c25.568-25.696 24.672-67.52-1.984-92.128zM352 608c38.272 0 72.992 14.080 100.576 36.576l323.328-323.328c-30.144-73.12-91.008-145.376-183.744-215.040-63.84-47.936-139.744-71.776-215.072-71.776-91.456 0-182.112 35.136-249.28 105.024-155.584 161.824-109.472 376.672 51.008 537.184 9.216 9.216 18.464 17.664 27.712 25.6 25.184-55.424 80.736-94.24 145.472-94.24z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ping",
						"play",
						"compete"
					],
					"grid": 32
				},
				{
					"id": 1079,
					"width": 1024,
					"paths": [
						"M738.944 200.352c-15.072-18.656-31.552-36.928-49.248-54.624-150.912-150.944-395.744-151.744-545.728-1.76s-149.184 394.784 1.76 545.728c179.776 179.776 376.032 172.128 500.608 107.2l152.992 183.552c12.064 14.464 33.952 15.456 47.296 2.144l136-136c13.344-13.344 12.32-35.232-2.144-47.296l-181.28-151.072c26.656-45.952 42.112-95.040 46.144-146.656 35.84-9.92 66.656-31.712 88.608-63.584 34.688-50.368 37.024-118.624 5.696-171.168-43.104-72.256-129.792-96.416-200.704-66.464zM869.28 415.968c-37.504 37.504-98.496 37.504-136 0s-37.504-98.496 0-136c37.504-37.504 98.496-37.504 136 0s37.504 98.496 0 136zM190.72 643.968c-125.536-125.952-126.144-329.92-1.376-454.688l0.384-0.384c125.184-124.768 329.312-123.648 455.040 2.496 23.584 23.648 43.2 47.872 60.672 72.256-44.32 50.368-42.912 126.88 5.184 174.976 20 20 44.992 31.648 70.976 35.68 0.128 77.088-30.72 150.752-94.048 214.080-112.832 112.448-319.712 133.28-496.832-44.416zM826.112 912.48l-146.016-175.232c10.496-8.16 20.672-16.768 30.080-26.176 0.16-0.16 0.352-0.352 0.512-0.512 9.728-9.728 18.688-19.776 27.104-30.048l174.688 145.568-86.368 86.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ping",
						"play",
						"compete"
					],
					"grid": 32
				},
				{
					"id": 2642,
					"paths": [
						"M960 96c0 53.020-42.98 96-96 96-53.022 0-96-42.98-96-96s42.98-96 96-96c53.018 0 96 42.98 96 96z",
						"M970.256 850.344l-190.634-178.358c-31.774-24.968-21.928-31.992-9.368-63.986 0.032-0.076 0.048-0.144 0.078-0.218 60.8-134.302 29.83-305.418-89.078-424.332-79.246-79.246-181.7-119.45-280.972-119.45-88.586 0-174.638 32-239.458 96.822-137.464 137.464-127.334 370.47 22.626 520.432 79.242 79.24 181.676 119.432 280.942 119.432 49.668 0 98.54-10.056 143.324-30.322 0.098-0.040 0.188-0.066 0.288-0.108 15.908-6.246 25.83-11.586 34.764-11.586 9.030 0 17.044 5.458 29.222 20.952l178.358 190.634c8.722 11.106 20.97 16.76 33.334 16.76 10.748 0 21.582-4.276 30.264-12.958l60.118-60.12c18.662-18.664 16.952-47.284-3.808-63.594v0zM327.328 696.672l369.35-369.35c10.998 22.756 19.294 46.64 24.714 71.284l-322.85 322.852c-18.388-4.054-36.58-9.794-54.458-17.238-5.662-2.36-11.244-4.888-16.756-7.548v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pingpong",
						"soprts",
						"table-tennis",
						"sports",
						"game"
					],
					"defaultCode": 60477,
					"grid": 16
				},
				{
					"id": 3397,
					"paths": [
						"M512 68.4c-245 0-443.6 198.6-443.6 443.6 0 188 117 348.4 282 413-3.8-35-7.4-89 1.6-127.2 8-34.6 52-220.4 52-220.4s-13.2-26.6-13.2-65.8c0-61.6 35.8-107.8 80.2-107.8 37.8 0 56.2 28.4 56.2 62.4 0 38-24.2 95-36.8 147.6-10.6 44.2 22 80.2 65.6 80.2 78.8 0 139.4-83.2 139.4-203.2 0-106.2-76.4-180.4-185.2-180.4-126.2 0-200.2 94.6-200.2 192.6 0 38.2 14.6 79 33 101.2 3.6 4.4 4.2 8.2 3 12.8-3.4 14-10.8 44.2-12.4 50.4-2 8.2-6.4 9.8-14.8 6-55.4-25.8-90-106.8-90-171.8 0-140 101.6-268.4 293-268.4 153.8 0 273.4 109.6 273.4 256.2 0 152.8-96.4 276-230.2 276-45 0-87.2-23.4-101.6-51 0 0-22.2 84.6-27.6 105.4-10 38.6-37 86.8-55.2 116.2 41.6 12.8 85.6 19.8 131.4 19.8 245 0 443.6-198.6 443.6-443.6 0-245.2-198.6-443.8-443.6-443.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pinterest",
						"brand",
						"social"
					],
					"defaultCode": 61232,
					"grid": 16
				},
				{
					"id": 1689,
					"width": 731.4300537109375,
					"paths": [
						"M0 341.143q0-61.714 21.429-116.286t59.143-95.143 86.857-70.286 105.714-44.571 115.429-14.857q90.286 0 168 38t126.286 110.571 48.571 164q0 54.857-10.857 107.429t-34.286 101.143-57.143 85.429-82.857 58.857-108 22q-38.857 0-77.143-18.286t-54.857-50.286q-5.714 22.286-16 64.286t-13.429 54.286-11.714 40.571-14.857 40.571-18.286 35.714-26.286 44.286-35.429 49.429l-8 2.857-5.143-5.714q-8.571-89.714-8.571-107.429 0-52.571 12.286-118t38-164.286 29.714-116q-18.286-37.143-18.286-96.571 0-47.429 29.714-89.143t75.429-41.714q34.857 0 54.286 23.143t19.429 58.571q0 37.714-25.143 109.143t-25.143 106.857q0 36 25.714 59.714t62.286 23.714q31.429 0 58.286-14.286t44.857-38.857 32-54.286 21.714-63.143 11.429-63.429 3.714-56.857q0-98.857-62.571-154t-163.143-55.143q-114.286 0-190.857 74t-76.571 187.714q0 25.143 7.143 48.571t15.429 37.143 15.429 26 7.143 17.429q0 16-8.571 41.714t-21.143 25.714q-1.143 0-9.714-1.714-29.143-8.571-51.714-32t-34.857-54-18.571-61.714-6.286-60.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pinterest-p"
					],
					"defaultCode": 62001,
					"grid": 14
				},
				{
					"id": 1365,
					"width": 877.7119750976562,
					"paths": [
						"M713.143 73.143q68 0 116.286 48.286t48.286 116.286v548.571q0 68-48.286 116.286t-116.286 48.286h-414.286q48.571-69.714 61.714-120 5.143-19.429 30.286-119.429 12 22.286 42 38.286t64.286 16q103.429 0 168.857-84.286t65.429-213.429q0-48-20-92.857t-55.143-79.429-87.143-55.429-112.571-20.857q-59.429 0-111.143 16.286t-87.429 43.714-61.429 62.571-38 73.143-12.286 75.714q0 58.286 22.571 102.857t66.571 62.857q7.429 2.857 13.429 0t8.286-10.857q5.714-25.143 8.571-34.857 3.429-13.143-6.286-24-28.571-35.429-28.571-85.714 0-85.714 59.143-146.571t154.571-60.857q85.143 0 132.857 46.286t47.714 120q0 96-38.571 163.429t-99.143 67.429q-34.286 0-55.429-24.857t-13.143-59.143q4.571-19.429 15.143-52.857t16.857-58.286 6.286-42.571q0-28-15.143-46.571t-43.143-18.571q-34.857 0-59.143 32.286t-24.286 79.714q0 41.143 13.714 69.143l-56 236.571q-13.714 57.143-4 145.143h-104.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pinterest-square"
					],
					"defaultCode": 61651,
					"grid": 14
				},
				{
					"id": 3398,
					"paths": [
						"M512 0c-282.4 0-512 229.6-512 512s229.6 512 512 512 512-229.6 512-512-229.6-512-512-512zM512 955.6c-45.8 0-89.8-7-131.4-19.8 18-29.4 45.2-77.8 55.2-116.2 5.4-20.8 27.6-105.4 27.6-105.4 14.4 27.6 56.8 51 101.6 51 133.8 0 230.2-123 230.2-276 0-146.6-119.6-256.2-273.4-256.2-191.4 0-293 128.6-293 268.4 0 65 34.6 146 90 171.8 8.4 4 12.8 2.2 14.8-6 1.4-6.2 9-36.2 12.4-50.4 1-4.4 0.6-8.4-3-12.8-18.4-22.2-33-63.2-33-101.2 0-97.8 74-192.6 200.2-192.6 109 0 185.2 74.2 185.2 180.4 0 120-60.6 203.2-139.4 203.2-43.6 0-76.2-36-65.6-80.2 12.6-52.8 36.8-109.6 36.8-147.6 0-34-18.2-62.4-56.2-62.4-44.6 0-80.2 46-80.2 107.8 0 39.2 13.2 65.8 13.2 65.8s-44 185.8-52 220.4c-9 38.4-5.4 92.2-1.6 127.2-165-64.4-282-224.8-282-412.8 0-245 198.6-443.6 443.6-443.6s443.6 198.6 443.6 443.6c0 245-198.6 443.6-443.6 443.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pinterest",
						"brand",
						"social"
					],
					"defaultCode": 61233,
					"grid": 16
				},
				{
					"id": 1364,
					"width": 877.7100830078125,
					"paths": [
						"M877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857q-63.429 0-124.571-18.286 33.714-53.143 44.571-93.714 5.143-19.429 30.857-120.571 11.429 22.286 41.714 38.571t65.143 16.286q69.143 0 123.429-39.143t84-107.714 29.714-154.286q0-65.143-34-122.286t-98.571-93.143-145.714-36q-60 0-112 16.571t-88.286 44-62.286 63.143-38.286 74-12.286 76.571q0 59.429 22.857 104.571t66.857 63.429q17.143 6.857 21.714-11.429 1.143-4 4.571-17.714t4.571-17.143q3.429-13.143-6.286-24.571-29.143-34.857-29.143-86.286 0-86.286 59.714-148.286t156.286-62q86.286 0 134.571 46.857t48.286 121.714q0 97.143-39.143 165.143t-100.286 68q-34.857 0-56-24.857t-13.143-59.714q4.571-20 15.143-53.429t17.143-58.857 6.571-43.143q0-28.571-15.429-47.429t-44-18.857q-35.429 0-60 32.571t-24.571 81.143q0 41.714 14.286 69.714l-56.571 238.857q-9.714 40-7.429 101.143-117.714-52-190.286-160.571t-72.571-241.714q0-119.429 58.857-220.286t159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pinterest"
					],
					"defaultCode": 61650,
					"grid": 14
				},
				{
					"id": 2500,
					"paths": [
						"M960 448c-151.518 0-240.638 99.82-319.27 187.888-63.29 70.892-117.95 132.112-192.73 132.112-59.384 0-64-73.478-64-96v-128c0-17.674-14.328-32-32-32h-320c-17.672 0-32 14.326-32 32v128c0 147.43 39.5 250.396 117.4 306.040 64.346 45.96 136.112 45.96 170.6 45.96 95.388 0 181.55-34.188 263.41-104.516 69.318-59.552 124.686-134.786 178.228-207.542 78.958-107.286 147.146-199.942 230.362-199.942h64v-64h-64z",
						"M86.004 448.002c-5.292 0-10.398-2.634-13.418-7.282-4.102-6.31-3.25-14.624 2.042-19.974 33.918-34.28 52.542-70.908 56.932-111.978 3.916-36.618-3.506-71.794-10.686-105.816-10.088-47.806-19.618-92.962 7.128-130.716 25.874-36.52 83.046-59.432 179.922-72.102 6.576-0.862 12.996 2.424 16.148 8.254 3.154 5.832 2.384 13.002-1.932 18.032-68.808 80.162-68.48 147.086-68.19 206.134 0.2 40.588 0.386 78.926-20.734 115.492-22.858 39.572-67.836 71.004-141.55 98.916-1.852 0.704-3.77 1.040-5.662 1.040z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pipe",
						"hipster"
					],
					"defaultCode": 60335,
					"grid": 16
				},
				{
					"id": 2520,
					"paths": [
						"M1000.034 358.648l-950.124-356.296c-13.558-5.084-28.846-1.776-39.090 8.466-10.242 10.242-13.552 25.526-8.466 39.090l356.296 950.124c5.422 14.458 19.236 23.968 34.576 23.968 0.494 0 0.992-0.012 1.488-0.032 165.024-6.61 320.382-74.726 437.456-191.8s185.192-272.432 191.8-437.456c0.64-15.926-9.010-30.468-23.936-36.064zM252.86 507.528c38.91-12.25 67.14-48.57 67.14-91.528 0-53.020-42.98-96-96-96-13.678 0-26.678 2.876-38.45 8.034l-85.49-227.976 790.83 296.56c-34.14 256.814-237.458 460.12-494.272 494.26l-143.758-383.35z",
						"M640 640c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128s128 57.308 128 128z",
						"M576 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pizza",
						"food"
					],
					"defaultCode": 60355,
					"grid": 16
				},
				{
					"id": 685,
					"width": 1024,
					"paths": [
						"M544 480v-32c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32zM320 448h192v32h-192v-32zM416 352v-32c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32zM192 320h192v32h-192v-32zM736 608v-32c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32zM512 576h192v32h-192v-32zM864 160h-64v-48c0-8.832-7.168-16-16-16s-16 7.168-16 16v48h-32v-48c0-8.832-7.168-16-16-16s-16 7.168-16 16v48h-384v-48c0-8.832-7.168-16-16-16s-16 7.168-16 16v48h-32v-48c0-8.832-7.168-16-16-16s-16 7.168-16 16v48h-64c-53.024 0-96 42.976-96 96v544c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-544c0-53.024-42.976-96-96-96zM928 800c0 35.36-28.64 64-64 64h-704c-35.36 0-64-28.64-64-64v-544c0-35.36 28.64-64 64-64h704c35.36 0 64 28.64 64 64v544zM832 672h-96c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32zM832 736h-96v-32h96v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plan",
						"chart",
						"diagram",
						"organize",
						"manage"
					],
					"grid": 32
				},
				{
					"id": 686,
					"width": 1024,
					"paths": [
						"M704 608h-192v-32h192v32zM512 448h-192v32h192v-32zM384 320h-192v32h192v-32zM736 736h96v-32h-96v32zM960 256v544c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-544c0-53.024 42.976-96 96-96h64v-48c0-8.832 7.168-16 16-16s16 7.168 16 16v48h32v-48c0-8.832 7.168-16 16-16s16 7.168 16 16v48h384v-48c0-8.832 7.168-16 16-16s16 7.168 16 16v48h32v-48c0-8.832 7.168-16 16-16s16 7.168 16 16v48h64c53.024 0 96 42.976 96 96zM192 384h192c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32zM320 512h192c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32zM512 640h192c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32zM864 704c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plan",
						"chart",
						"diagram",
						"organize",
						"manage"
					],
					"grid": 32
				},
				{
					"id": 1080,
					"width": 1024,
					"paths": [
						"M480 448h-384v96h384v-96zM448 512h-320v-32h320v32zM192 672h512v-96h-512v96zM224 608h448v32h-448v-32zM704 928h224v-96h-224v96zM736 864h160v32h-160v-32zM448 800h416v-96h-416v96zM480 736h352v32h-352v-32zM992 160h-96v-64c0-52.928-43.072-96-96-96s-96 43.072-96 96v64h-384v-64c0-52.928-43.072-96-96-96s-96 43.072-96 96v64h-96c-17.664 0-32 14.336-32 32v800c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-800c0-17.664-14.336-32-32-32zM768 96c0-17.664 14.336-32 32-32s32 14.336 32 32v160c0 17.632-14.368 32-32 32s-32-14.368-32-32v-160zM192 96c0-17.664 14.336-32 32-32s32 14.336 32 32v160c0 17.632-14.368 32-32 32s-32-14.368-32-32v-160zM960 960h-896v-576h896v576zM960 352h-896v-128h96v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h448v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h96v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plan",
						"chart",
						"diagram",
						"organize",
						"manage"
					],
					"grid": 32
				},
				{
					"id": 1286,
					"width": 810.8590090274811,
					"paths": [
						"M786.286 91.429q25.143 29.714 6.857 84.571t-61.714 98.286l-92 92 91.429 397.714q2.857 10.857-6.857 18.857l-73.143 54.857q-4 3.429-10.857 3.429-2.286 0-4-0.571-8.571-1.714-12-9.143l-159.429-290.286-148 148 30.286 110.857q2.857 9.714-4.571 17.714l-54.857 54.857q-5.143 5.143-13.143 5.143h-1.143q-8.571-1.143-13.714-7.429l-108-144-144-108q-6.286-4-7.429-13.143-0.571-7.429 5.143-14.286l54.857-55.429q5.143-5.143 13.143-5.143 3.429 0 4.571 0.571l110.857 30.286 148-148-290.286-159.429q-8-4.571-9.714-13.714-1.143-9.143 5.143-15.429l73.143-73.143q8-7.429 17.143-4.571l380 90.857 91.429-91.429q43.429-43.429 98.286-61.714t84.571 6.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plane"
					],
					"defaultCode": 61554,
					"grid": 14
				},
				{
					"id": 2729,
					"paths": [
						"M1009.83 224.578c-19.978-34.604-60.376-52.15-120.076-52.15-43.018 0-96.052 9.37-155.17 26.68-62.786-44.756-139.6-71.108-222.584-71.108-212.078 0-384 171.922-384 384 0 12.154 0.596 24.168 1.702 36.034-10.85 10.358-21.152 20.67-30.84 30.9-38.206 40.344-65.502 77.88-81.134 111.568-13.614 29.342-25.354 72.098-3.96 109.152 19.978 34.604 60.378 52.15 120.078 52.15 43.142 0 96.36-9.426 155.682-26.832 62.768 44.706 139.538 71.028 222.472 71.028 212.078 0 384-171.922 384-384 0-12.2-0.608-24.252-1.726-36.16 10.712-10.238 20.884-20.43 30.462-30.544 38.206-40.344 65.504-77.882 81.134-111.57 13.614-29.34 25.356-72.094 3.96-109.148zM871.006 394.416c-70.516 74.464-176.244 154.094-297.708 224.222-167.47 96.692-339.966 159.168-439.454 159.168-34.834 0-51.764-7.826-55.992-15.15-7.598-13.158 5.152-57.886 70.186-127.96 7.886 23.394 17.958 45.786 29.984 66.922 81.216-13.472 211.258-59.872 359.276-145.332 115.614-66.75 215.56-141.818 281.428-211.376 9.498-10.030 17.538-19.226 24.328-27.546-12.412-21.066-26.786-40.84-42.854-59.082 33.76-7.726 64.064-11.852 89.552-11.852 34.832 0 51.762 7.826 55.99 15.15 7.776 13.462-5.714 59.948-74.736 132.836z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"planet",
						"globe",
						"space"
					],
					"defaultCode": 60564,
					"grid": 16
				},
				{
					"id": 2730,
					"paths": [
						"M1010.73 224.060c-19.83-34.35-60.042-51.766-119.512-51.766-43.348 0-96.856 9.496-156.524 27.046-62.85-44.894-139.74-71.34-222.694-71.34-211.738 0-384 172.262-384 384 0 12.318 0.608 24.496 1.748 36.52-11.004 10.49-21.446 20.934-31.256 31.292-38.25 40.392-65.57 77.956-81.202 111.644-13.548 29.2-25.242 71.722-4.018 108.484 19.832 34.35 60.042 51.766 119.514 51.766 43.342 0 96.854-9.508 156.508-27.056 62.854 44.9 139.748 71.35 222.706 71.35 211.738 0 384-172.262 384-384 0-12.316-0.608-24.49-1.746-36.512 11-10.492 21.444-20.936 31.256-31.298 38.25-40.392 65.57-77.954 81.202-111.646 13.548-29.2 25.242-71.722 4.018-108.484zM512 192c152.468 0 280.354 107.19 312.302 250.166-67.028 60.35-153.582 122.008-250.032 177.692-96.16 55.52-193.964 99.776-278.812 127.526-63.562-58.522-103.458-142.376-103.458-235.384 0-176.448 143.552-320 320-320zM75.626 763.942c-6.754-11.698-0.128-54.030 71.868-131.114 16.67 50.16 43.424 95.752 77.846 134.376-34.946 8.138-66.296 12.504-92.554 12.504-35.432 0-52.76-8.146-57.16-15.766zM512 832c-51.566 0-100.312-12.278-143.496-34.036 76.494-28.792 159.314-68.148 241.768-115.752 82.090-47.394 157.616-99.22 221.158-151.348-9.8 167.7-149.314 301.136-319.43 301.136zM876.506 391.172c-16.67-50.162-43.424-95.754-77.85-134.378 34.956-8.146 66.296-12.5 92.56-12.5 35.432 0 52.758 8.144 57.158 15.766 6.756 11.698 0.13 54.030-71.868 131.112z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"planet",
						"globe",
						"space"
					],
					"defaultCode": 60565,
					"grid": 16
				},
				{
					"id": 687,
					"width": 1024,
					"paths": [
						"M854.752 296.704c-6.432-17.696-40.416-24-83.712-24-13.408 0-27.68 0.608-42.336 1.664 19.68-69.152 30.72-138.592 6.464-152.608-3.104-1.792-6.688-2.624-10.688-2.624-30.048 0-83.808 47.328-130.688 97.536-16.864-84.384-47.136-184.672-81.792-184.672s-64.928 100.288-81.824 184.64c-46.912-50.176-100.64-97.536-130.688-97.536-4 0-7.584 0.832-10.688 2.624-24.256 14.016-13.184 83.456 6.496 152.608-14.656-1.056-28.96-1.664-42.336-1.664-43.296 0-77.28 6.304-83.712 24-12.896 35.424 87.424 106.56 164.448 151.296h-77.696c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32l32 256c-17.664 0-32 14.336-32 32v0c0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96v0c0-17.664-14.336-32-32-32l32-256c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-77.696c77.024-44.704 177.344-115.84 164.448-151.264zM672 960h-320c-35.36 0-64-28.64-64-64h448c0 35.36-28.64 64-64 64zM703.744 864h-383.488l-32-256h447.488l-32 256zM768 576h-512v-96h512v96zM623.936 448h-223.84c-73.984-32.8-174.88-108.448-196.224-138.56 7.776-2.176 22.592-4.736 49.088-4.736 12.064 0 25.536 0.544 40.032 1.568l45.568 3.296-12.512-43.968c-19.104-67.2-20-98.752-18.72-111.904 14.784 6.816 47.072 28.736 99.456 84.8l42.528 45.504 12.224-61.088c17.696-88.352 38.208-137.472 50.464-154.336 12.256 16.864 32.768 65.984 50.432 154.304l12.224 61.088 42.528-45.504c52.448-56.128 84.736-78.016 99.456-84.832 1.312 13.12 0.416 44.672-18.72 111.936l-12.48 43.968 45.568-3.296c14.528-1.056 28-1.568 40.032-1.568 26.496 0 41.28 2.56 49.088 4.736-21.312 30.144-122.208 105.792-196.192 138.592z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plant",
						"grow",
						"live"
					],
					"grid": 32
				},
				{
					"id": 688,
					"width": 1024,
					"paths": [
						"M169.248 296.704c6.432-17.728 40.416-24 83.712-24 13.408 0 27.68 0.608 42.336 1.664-19.68-69.152-30.72-138.592-6.464-152.608 3.104-1.792 6.656-2.624 10.688-2.624 30.048 0 83.808 47.36 130.688 97.536 16.864-84.384 47.136-184.672 81.792-184.672s64.928 100.288 81.824 184.64c46.912-50.176 100.64-97.536 130.688-97.536 4 0 7.584 0.832 10.688 2.624 24.256 14.016 13.184 83.456-6.464 152.608 14.656-1.056 28.928-1.664 42.336-1.664 43.296 0 77.28 6.304 83.712 24 10.112 27.808-49.472 77.536-112.832 119.296h-459.904c-63.328-41.728-122.944-91.488-112.8-119.264zM256 448c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32l28 224h456l28-224c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-512zM736 864h-448c-17.664 0-32 14.336-32 32 0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96 0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plant",
						"grow",
						"live"
					],
					"grid": 32
				},
				{
					"id": 1081,
					"width": 1024,
					"paths": [
						"M854.784 73.536c-6.048-6.144-14.272-9.536-22.784-9.536-1.76 0-3.52 0.128-5.248 0.448l-159.712 26.624c-28.8 4.8-56.48 13.728-82.656 26.656-9.504-16.192-20-31.488-31.296-45.632l-48.064-60.064c-6.112-7.616-15.296-12.032-25.024-12.032s-18.912 4.416-24.992 12l-48.064 60.064c-24.896 31.104-44.736 65.6-59.264 102.88-28.064-11.552-57.312-19.52-87.36-23.84l-159.808-22.784c-1.504-0.224-3.008-0.32-4.512-0.32-8.48 0-16.704 3.36-22.752 9.504-7.136 7.2-10.4 17.344-8.864 27.36l20.224 131.36c19.584 127.488 101.472 230.304 212.192 279.776h-40.8c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h39.744l16 128h-23.744c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h448c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-23.744l16-128h39.744c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-192v-97.696c131.2-13.952 239.488-112.672 263.552-244.96l23.936-131.616c1.856-10.24-1.376-20.768-8.704-28.192zM776.576 221.888c-20.448 112.48-118.24 194.112-232.576 194.112h-15.2c-9.536-30.784-23.392-59.712-40.896-86.112 22.304-89.568 94.816-159.904 189.664-175.712l114.848-19.136-15.84 86.848zM704 960h-384v-32h384v32zM643.744 896h-263.488l-24-192h311.488l-24 192zM736 672h-448v-32h448v32zM134.176 197.792l117.088 16.736c148.64 21.216 260.736 150.464 260.736 300.608v92.864h-32v-64h-32c-150.976 0-277.184-108.288-300.16-257.504l-13.664-88.704zM480 83.232l23.072 28.832c17.056 21.312 30.304 45.088 41.472 69.76-36.512 30.656-64.32 70.688-80.448 116.128-19.776-23.296-42.656-44-68.16-61.216 11.616-45.152 31.648-87.968 60.992-124.672l23.072-28.832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plant",
						"grow",
						"live",
						"refresh"
					],
					"grid": 32
				},
				{
					"id": 2515,
					"paths": [
						"M33.088 832h957.826c17.674 0 32-14.326 32-32v-64c0-0.702-0.024-1.402-0.068-2.102-8.526-129.484-65.444-249.888-160.268-339.028-79.578-74.806-179.562-121.508-286.578-134.87v-68h32c17.674 0 32-14.328 32-32s-14.326-32-32-32h-192c-17.672 0-32 14.328-32 32s14.328 32 32 32h32v68c-107.014 13.362-207 60.066-286.576 134.872-94.824 89.138-151.742 209.542-160.268 339.026-0.046 0.7-0.070 1.4-0.070 2.102v64c0.002 17.674 14.328 32 32.002 32z",
						"M992 896h-960c-17.672 0-32 14.326-32 32s14.328 32 32 32h960c17.674 0 32-14.326 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plate",
						"food"
					],
					"defaultCode": 60350,
					"grid": 16
				},
				{
					"id": 1900,
					"paths": [
						"M981.188 160.108c-143.632-20.65-302.332-32.108-469.186-32.108-166.86 0-325.556 11.458-469.194 32.108-27.53 107.726-42.808 226.75-42.808 351.892 0 125.14 15.278 244.166 42.808 351.89 143.638 20.652 302.336 32.11 469.194 32.11 166.854 0 325.552-11.458 469.186-32.11 27.532-107.724 42.812-226.75 42.812-351.89 0-125.142-15.28-244.166-42.812-351.892zM384.002 704v-384l320 192-320 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play",
						"video",
						"movie"
					],
					"defaultCode": 59735,
					"grid": 16
				},
				{
					"id": 1469,
					"width": 877.7139282226562,
					"paths": [
						"M438.857 73.143q119.429 0 220.286 58.857t159.714 159.714 58.857 220.286-58.857 220.286-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857zM658.286 543.429q18.286-10.286 18.286-31.429t-18.286-31.429l-310.857-182.857q-17.714-10.857-36.571-0.571-18.286 10.857-18.286 32v365.714q0 21.143 18.286 32 9.143 4.571 18.286 4.571 9.714 0 18.286-5.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play-circle"
					],
					"defaultCode": 61764,
					"grid": 14
				},
				{
					"id": 1207,
					"width": 877.7139282226562,
					"paths": [
						"M676.571 512q0 21.143-18.286 31.429l-310.857 182.857q-8.571 5.143-18.286 5.143-9.143 0-18.286-4.571-18.286-10.857-18.286-32v-365.714q0-21.143 18.286-32 18.857-10.286 36.571 0.571l310.857 182.857q18.286 10.286 18.286 31.429zM749.714 512q0-84.571-41.714-156t-113.143-113.143-156-41.714-156 41.714-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play-circle-o"
					],
					"defaultCode": 61469,
					"grid": 14
				},
				{
					"id": 1901,
					"paths": [
						"M384 361.85v300.3l260.066-150.142zM0 256v640h1024v-640h-1024zM960 832h-896v-64h896v64zM960 704h-896v-384h896v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play",
						"video",
						"movie"
					],
					"defaultCode": 59736,
					"grid": 16
				},
				{
					"id": 2963,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416zM384 288l384 224-384 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play",
						"player"
					],
					"defaultCode": 60798,
					"grid": 16
				},
				{
					"id": 2970,
					"paths": [
						"M192 128l640 384-640 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play",
						"player"
					],
					"defaultCode": 60805,
					"grid": 16
				},
				{
					"id": 1250,
					"width": 804.0000019073486,
					"paths": [
						"M790.857 529.714l-758.857 421.714q-13.143 7.429-22.571 1.714t-9.429-20.571v-841.143q0-14.857 9.429-20.571t22.571 1.714l758.857 421.714q13.143 7.429 13.143 17.714t-13.143 17.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play"
					],
					"defaultCode": 61515,
					"grid": 14
				},
				{
					"id": 689,
					"width": 1024,
					"paths": [
						"M928 160h-800c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h800c53.024 0 96-42.976 96-96v-512c0-53.024-42.976-96-96-96zM832 192h96v384h-96v-384zM608 192v384h-96v-384h96zM416 192v384h-96v-384h96zM128 192h96v384h-96v-384zM128 832c-35.296 0-64-28.704-64-64v-512c0-23.584 12.96-44 32-55.104v375.104c0 17.664 14.336 32 32 32h32v224h-32zM192 832v-224h32c17.664 0 32-14.336 32-32v-384h32v384c0 17.664 14.336 32 32 32h32v224h-160zM384 832v-224h32c17.664 0 32-14.336 32-32v-384h32v384c0 17.664 14.336 32 32 32h32v224h-160zM576 832v-224h32c17.664 0 32-14.336 32-32v-384h64v640h-128zM736 832v-640h64v384c0 17.664 14.336 32 32 32h32v224h-128zM992 768c0 35.296-28.704 64-64 64h-32v-224h32c17.664 0 32-14.336 32-32v-375.104c19.040 11.104 32 31.52 32 55.104v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play",
						"sound",
						"perform"
					],
					"grid": 32
				},
				{
					"id": 690,
					"width": 1024,
					"paths": [
						"M544 864h-160v-256h32c17.664 0 32-14.336 32-32v-416h32v416c0 17.664 14.336 32 32 32h32v256zM416 576v-416h-96v416h96zM800 576v-416h-64v704h128v-256h-32c-17.664 0-32-14.336-32-32zM224 160h-96v416h96v-416zM352 864v-256h-32c-17.664 0-32-14.336-32-32v-416h-32v416c0 17.664-14.336 32-32 32h-32v256h160zM160 608h-32c-17.664 0-32-14.336-32-32v-410.112c-37.216 13.216-64 48.384-64 90.112v512c0 53.024 42.976 96 96 96h32v-256zM960 165.888v410.112c0 17.664-14.336 32-32 32h-32v256h32c53.024 0 96-42.976 96-96v-512c0-41.728-26.784-76.896-64-90.112zM704 160h-64v416c0 17.664-14.336 32-32 32h-32v256h128v-704zM608 576v-416h-96v416h96zM928 160h-96v416h96v-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play",
						"sound",
						"perform"
					],
					"grid": 32
				},
				{
					"id": 1082,
					"width": 1024,
					"paths": [
						"M128 138.88l696.48 373.12-696.48 373.12v-746.24zM96.032 53.408c-16.768 0-32.032 13.44-32.032 32.032v853.12c0 18.624 15.264 32.032 32.032 32.032 5.024 0 10.176-1.216 15.072-3.84l796.224-426.56c22.528-12.064 22.528-44.352 0-56.416l-796.224-426.528c-4.896-2.656-10.048-3.84-15.072-3.84v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"play",
						"listen",
						"pause"
					],
					"grid": 32
				},
				{
					"id": 2667,
					"paths": [
						"M832 0h-128v713.118c-20.020-5.9-41.556-9.118-64-9.118-106.042 0-192 71.632-192 160 0 88.366 85.958 160 192 160 106.040 0 192-71.634 192-160v-672l192 64v-128l-192-128z",
						"M322.004 896h-322.004v128h373.68c-28.132-38.128-45.976-82.086-51.676-128z",
						"M373.68 704h-373.68v128h322.004c5.7-45.912 23.544-89.872 51.676-128z",
						"M576 581.732v-69.732h-576v128h438.384c40.152-29.258 87.29-49.132 137.616-58.268z",
						"M0 320h576v128h-576v-128z",
						"M0 128h576v128h-576v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"playlist",
						"music",
						"songs"
					],
					"defaultCode": 60502,
					"grid": 16
				},
				{
					"id": 2668,
					"paths": [
						"M832 0h-128v713.118c-20.020-5.9-41.556-9.118-64-9.118-106.042 0-192 71.632-192 160 0 88.366 85.958 160 192 160 106.040 0 192-71.634 192-160v-672l192 64v-128l-192-128z",
						"M322.004 896h-322.004v128h373.68c-28.132-38.128-45.976-82.086-51.676-128z",
						"M373.68 704h-373.68v128h322.004c5.7-45.912 23.544-89.872 51.676-128z",
						"M576 581.732v-69.732h-576v128h438.384c40.152-29.258 87.29-49.132 137.616-58.268z",
						"M450 192h-130v-128h-128v128h-130v128h130v128h128v-128h130z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"playlist-add",
						"music",
						"songs"
					],
					"defaultCode": 60503,
					"grid": 16
				},
				{
					"id": 691,
					"width": 1024,
					"paths": [
						"M128 640c35.36 0 64-28.64 64-64 0-14.4-4.928-27.52-12.928-38.208l178.784-223.488c8 3.584 16.8 5.696 26.144 5.696 17.056 0 32.48-6.784 43.936-17.664l151.296 94.528c-1.92 6.080-3.232 12.416-3.232 19.136 0 35.36 28.64 64 64 64s64-28.64 64-64c0-13.216-4-25.504-10.88-35.68l173.856-195.584c8.736 4.48 18.528 7.264 29.024 7.264 35.36 0 64-28.64 64-64s-28.64-64-64-64-64 28.64-64 64c0 13.216 4 25.504 10.88 35.68l-173.856 195.584c-8.736-4.48-18.528-7.264-29.024-7.264-17.056 0-32.48 6.784-43.968 17.664l-151.264-94.56c1.92-6.080 3.232-12.416 3.232-19.104 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 14.4 4.928 27.52 12.928 38.208l-178.784 223.488c-8-3.584-16.8-5.696-26.144-5.696-35.36 0-64 28.64-64 64s28.64 64 64 64zM896 96c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM640 384c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM384 224c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM128 544c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM896 672c-21.664 0-40.736 10.816-52.32 27.296l-140.352-52.64c0.224-2.208 0.672-4.384 0.672-6.656 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 2.272 0.448 4.448 0.672 6.656l-140.352 52.64c-11.584-16.48-30.656-27.296-52.32-27.296-29.792 0-54.592 20.448-61.728 48h-132.544c-7.136-27.552-31.936-48-61.728-48-35.36 0-64 28.64-64 64s28.64 64 64 64c29.792 0 54.592-20.448 61.728-48h132.512c7.168 27.552 31.968 48 61.76 48 35.36 0 64-28.64 64-64 0-2.272-0.448-4.448-0.672-6.656l140.352-52.64c11.584 16.48 30.656 27.296 52.32 27.296s40.736-10.816 52.32-27.296l140.352 52.64c-0.224 2.208-0.672 4.384-0.672 6.656 0 35.36 28.64 64 64 64s64-28.64 64-64c0-35.36-28.64-64-64-64zM128 768c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM384 768c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM640 672c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM896 768c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plot",
						"chart",
						"visualize",
						"correlate"
					],
					"grid": 32
				},
				{
					"id": 692,
					"width": 1024,
					"paths": [
						"M128 640c35.36 0 64-28.64 64-64 0-14.4-4.928-27.52-12.928-38.208l178.784-223.488c8 3.584 16.8 5.696 26.144 5.696 17.056 0 32.48-6.784 43.936-17.664l151.296 94.528c-1.92 6.080-3.232 12.416-3.232 19.136 0 35.36 28.64 64 64 64s64-28.64 64-64c0-13.216-4-25.504-10.88-35.68l173.856-195.584c8.736 4.48 18.528 7.264 29.024 7.264 35.36 0 64-28.64 64-64s-28.64-64-64-64-64 28.64-64 64c0 13.216 4 25.504 10.88 35.68l-173.856 195.584c-8.736-4.48-18.528-7.264-29.024-7.264-17.056 0-32.48 6.784-43.968 17.664l-151.264-94.56c1.92-6.080 3.232-12.416 3.232-19.104 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 14.4 4.928 27.52 12.928 38.208l-178.784 223.488c-8-3.584-16.8-5.696-26.144-5.696-35.36 0-64 28.64-64 64s28.64 64 64 64zM896 672c-21.664 0-40.736 10.816-52.32 27.296l-140.352-52.64c0.224-2.208 0.672-4.384 0.672-6.656 0-35.36-28.64-64-64-64s-64 28.64-64 64c0 2.272 0.448 4.448 0.672 6.656l-140.352 52.64c-11.584-16.48-30.656-27.296-52.32-27.296-29.792 0-54.592 20.448-61.728 48h-132.544c-7.136-27.552-31.936-48-61.728-48-35.36 0-64 28.64-64 64s28.64 64 64 64c29.792 0 54.592-20.448 61.728-48h132.512c7.168 27.552 31.968 48 61.76 48 35.36 0 64-28.64 64-64 0-2.272-0.448-4.448-0.672-6.656l140.352-52.64c11.584 16.48 30.656 27.296 52.32 27.296s40.736-10.816 52.32-27.296l140.352 52.64c-0.224 2.208-0.672 4.384-0.672 6.656 0 35.36 28.64 64 64 64s64-28.64 64-64c0-35.36-28.64-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plot",
						"chart",
						"visualize",
						"correlate"
					],
					"grid": 32
				},
				{
					"id": 1083,
					"width": 1024,
					"paths": [
						"M640 256h-384v160h32v146.752l-96-96-160 160v301.248h576v-512h32v-160zM274.72 640h-165.472l82.752-82.752 82.72 82.752zM224 864h-32v-64h32v64zM256 864v-96h-96v96h-64v-192h224v192h-64zM480 864h-64v-64h64v64zM544 864h-32v-96h-128v96h-32v-480h192v480zM576 352h-256v-32h256v32zM512 608h-128v128h128v-128zM480 704h-64v-64h64v64zM512 448h-128v128h128v-128zM480 544h-64v-64h64v64zM608 224h-32v-32h32v32zM608 160h-32v-32h32v32zM640 128h32v32h-32v-32zM704 128h32v32h-32v-32zM768 128h32v32h-32v-32zM832 128h32v32h-32v-32zM896 128h32v32h-32v-32zM992 128v32h-32v-32h32zM960 192h32v32h-32v-32zM960 256h32v32h-32v-32zM960 320h32v32h-32v-32zM960 384h32v32h-32v-32zM960 448h32v32h-32v-32zM960 512h32v32h-32v-32zM960 576h32v32h-32v-32zM960 640h32v32h-32v-32zM960 704h32v32h-32v-32zM960 768h32v32h-32v-32zM960 832h32v32h-32v-32zM960 896h32v32h-32v-32zM896 896h32v32h-32v-32zM832 896h32v32h-32v-32zM768 896h32v32h-32v-32zM704 896h32v32h-32v-32zM640 896h32v32h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plot",
						"plan",
						"envision"
					],
					"grid": 32
				},
				{
					"id": 1621,
					"width": 1023.9989318847656,
					"paths": [
						"M1002.857 258.857q21.143 21.143 21.143 51.429t-21.143 52l-229.143 228.571 85.714 85.714-91.429 91.429q-93.143 93.143-222.571 106.571t-235.143-57.429l-206.857 206.857h-103.429v-103.429l206.857-206.857q-70.857-105.714-57.429-235.143t106.571-222.571l91.429-91.429 85.714 85.714 228.571-229.143q21.714-21.143 52-21.143t51.429 21.143 21.143 51.714-21.143 51.714l-228.571 229.143 133.714 133.714 229.143-228.571q21.714-21.143 52-21.143t51.429 21.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plug"
					],
					"defaultCode": 61926,
					"grid": 14
				},
				{
					"id": 2926,
					"paths": [
						"M1024 320h-320v-320h-384v320h-320v384h320v320h384v-320h320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus",
						"add",
						"sum"
					],
					"defaultCode": 60761,
					"grid": 16
				},
				{
					"id": 2932,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM768 576h-192v192h-128v-192h-192v-128h192v-192h128v192h192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus-circle",
						"add",
						"sum"
					],
					"defaultCode": 60767,
					"grid": 16
				},
				{
					"id": 2934,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576 576v256h-128v-256h-256v-128h256v-256h128v256h256v128h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus-circle",
						"add",
						"sum"
					],
					"defaultCode": 60769,
					"grid": 16
				},
				{
					"id": 1259,
					"width": 877.7139282226562,
					"paths": [
						"M694.857 548.571v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-146.286v-146.286q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v146.286h-146.286q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h146.286v146.286q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714v-146.286h146.286q14.857 0 25.714-10.857t10.857-25.714zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus-circle"
					],
					"defaultCode": 61525,
					"grid": 14
				},
				{
					"id": 224,
					"paths": [
						"M830.338 193.664c-91.869-91.869-214.016-142.464-343.938-142.464s-252.067 50.595-343.936 142.464-142.464 214.014-142.464 343.936 50.595 252.069 142.464 343.938 214.014 142.462 343.936 142.462 252.069-50.594 343.938-142.462 142.462-214.016 142.462-343.938-50.594-252.067-142.462-343.936zM486.4 972.8c-239.97 0-435.2-195.23-435.2-435.2s195.23-435.2 435.2-435.2c239.97 0 435.2 195.23 435.2 435.2s-195.23 435.2-435.2 435.2z",
						"M793.6 512h-281.6v-281.6c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v281.6h-281.6c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h281.6v281.6c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-281.6h281.6c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus-circle",
						"plus",
						"cross"
					],
					"defaultCode": 59521,
					"grid": 20
				},
				{
					"id": 1406,
					"width": 877.7129821777344,
					"paths": [
						"M731.429 548.571v-73.143q0-14.857-10.857-25.714t-25.714-10.857h-182.857v-182.857q0-14.857-10.857-25.714t-25.714-10.857h-73.143q-14.857 0-25.714 10.857t-10.857 25.714v182.857h-182.857q-14.857 0-25.714 10.857t-10.857 25.714v73.143q0 14.857 10.857 25.714t25.714 10.857h182.857v182.857q0 14.857 10.857 25.714t25.714 10.857h73.143q14.857 0 25.714-10.857t10.857-25.714v-182.857h182.857q14.857 0 25.714-10.857t10.857-25.714zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus-square"
					],
					"defaultCode": 61694,
					"grid": 14
				},
				{
					"id": 1546,
					"width": 804.5689392089844,
					"paths": [
						"M658.286 457.143v36.571q0 8-5.143 13.143t-13.143 5.143h-201.143v201.143q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-201.143h-201.143q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h201.143v-201.143q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143v201.143h201.143q8 0 13.143 5.143t5.143 13.143zM731.429 713.143v-475.429q0-37.714-26.857-64.571t-64.571-26.857h-475.429q-37.714 0-64.571 26.857t-26.857 64.571v475.429q0 37.714 26.857 64.571t64.571 26.857h475.429q37.714 0 64.571-26.857t26.857-64.571zM804.571 237.714v475.429q0 68-48.286 116.286t-116.286 48.286h-475.429q-68 0-116.286-48.286t-48.286-116.286v-475.429q0-68 48.286-116.286t116.286-48.286h475.429q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus-square-o"
					],
					"defaultCode": 61846,
					"grid": 14
				},
				{
					"id": 2928,
					"paths": [
						"M992 384h-352v-352c0-17.672-14.328-32-32-32h-192c-17.672 0-32 14.328-32 32v352h-352c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h352v352c0 17.672 14.328 32 32 32h192c17.672 0 32-14.328 32-32v-352h352c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus",
						"add",
						"sum"
					],
					"defaultCode": 60763,
					"grid": 16
				},
				{
					"id": 2930,
					"paths": [
						"M960 448h-384v-384h-128v384h-384v128h384v384h128v-384h384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus",
						"add",
						"sum"
					],
					"defaultCode": 60765,
					"grid": 16
				},
				{
					"id": 1276,
					"width": 804.5719833374023,
					"paths": [
						"M804.571 420.571v109.714q0 22.857-16 38.857t-38.857 16h-237.714v237.714q0 22.857-16 38.857t-38.857 16h-109.714q-22.857 0-38.857-16t-16-38.857v-237.714h-237.714q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h237.714v-237.714q0-22.857 16-38.857t38.857-16h109.714q22.857 0 38.857 16t16 38.857v237.714h237.714q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"plus"
					],
					"defaultCode": 61543,
					"grid": 14
				},
				{
					"id": 1941,
					"paths": [
						"M1024 512c0-282.77-229.23-512-512-512s-512 229.23-512 512c0 220.054 138.836 407.664 333.686 480.068l-13.686 31.932h384l-13.686-31.932c194.85-72.404 333.686-260.014 333.686-480.068zM486.79 634.826c-22.808-9.788-38.79-32.436-38.79-58.826 0-35.346 28.654-64 64-64s64 28.654 64 64c0 26.39-15.978 49.044-38.786 58.834l-25.214-58.834-25.21 58.826zM538.268 637.292c58.092-12.118 101.732-63.602 101.732-125.292 0-70.694-57.306-128-128-128-70.692 0-128 57.306-128 128 0 61.692 43.662 113.122 101.76 125.228l-74.624 174.122c-91.23-39.15-155.136-129.784-155.136-235.35 0-141.384 114.616-268 256-268s256 126.616 256 268c0 105.566-63.906 196.2-155.136 235.35l-74.596-174.058zM688.448 987.708l-73.924-172.486c126.446-42.738 217.476-162.346 217.476-303.222 0-176.73-143.268-320-320-320-176.73 0-320 143.27-320 320 0 140.876 91.030 260.484 217.476 303.222l-73.924 172.486c-159.594-68.488-271.386-227.034-271.386-411.708 0-247.332 200.502-459.834 447.834-459.834s447.834 212.502 447.834 459.834c0 184.674-111.792 343.22-271.386 411.708z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"podcast",
						"broadcast",
						"live",
						"radio",
						"feed"
					],
					"defaultCode": 59776,
					"grid": 16
				},
				{
					"id": 1948,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512 0 141.382 57.306 269.382 149.96 362.038l45.254-45.252c-81.070-81.076-131.214-193.076-131.214-316.786 0-247.424 200.576-448 448-448s448 200.576 448 448c0 123.71-50.144 235.71-131.216 316.786l45.256 45.252c92.652-92.656 149.96-220.656 149.96-362.038 0-282.77-229.23-512-512-512zM512 192c-176.732 0-320 143.268-320 320 0 88.368 35.818 168.368 93.724 226.274l45.278-45.276c-46.322-46.322-74.972-110.314-74.972-180.998 0-141.368 114.602-255.97 255.97-255.97s255.968 114.602 255.968 255.97c0 70.684-28.65 134.676-74.972 180.998l45.278 45.276c57.91-57.906 93.726-137.906 93.726-226.274 0-176.732-143.27-320-320-320v0zM602.51 602.51c23.164-23.164 37.49-55.164 37.49-90.51 0-70.692-57.308-128-128-128-70.694 0-128 57.308-128 128 0 35.346 14.328 67.346 37.49 90.51l45.254-45.254c-11.58-11.582-18.744-27.582-18.744-45.256 0-35.346 28.654-64 64-64s64 28.654 64 64c0 17.674-7.164 33.674-18.744 45.256l45.254 45.254zM488 576l-168 448h384l-168-448h-48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"podcast",
						"broadcast",
						"radio",
						"feed"
					],
					"defaultCode": 59783,
					"grid": 16
				},
				{
					"id": 2482,
					"paths": [
						"M704 448v-256h-384v192h-320v512h1024v-448h-320zM256 704h-128v64h128v64h-192v-192h128v-64h-128v-64h192v192zM576 640h-64v-256h-64v-64h128v320zM960 832h-192v-64h128v-64h-128v-64h128v-64h-128v-64h192v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"podium",
						"ranking",
						"standings",
						"winers",
						"rating",
						"sports"
					],
					"defaultCode": 60317,
					"grid": 16
				},
				{
					"id": 693,
					"width": 1024,
					"paths": [
						"M939.424 320h-267.424l-49.152-49.152c-29.984-29.984-70.688-46.848-113.12-46.848h-91.456c-42.432 0-83.136 16.864-113.152 46.848l-49.12 49.152h-32c0-17.664-14.336-32-32-32h-160c-17.664 0-32 14.336-32 32v480c0 17.664 14.336 32 32 32h160c17.664 0 32-14.336 32-32h32l17.152 17.152c29.984 29.984 70.688 46.848 113.12 46.848h253.728c53.024 0 96-42.976 96-96v-288h208c46.912 0 84.384-40.352 79.584-88.256-4.16-41.632-42.304-71.744-84.16-71.744zM192 800h-160v-480h160v480zM991.584 406.304c-3.104 24.192-24.864 41.696-49.248 41.696h-286.336c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v96h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v96h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v32c0 35.36-28.64 64-64 64h-253.728c-33.952 0-66.496-13.472-90.528-37.504l-26.496-26.496h-45.248v-416h45.248l58.496-58.496c24.032-24.032 56.576-37.504 90.528-37.504h91.456c33.952 0 66.496 13.472 90.496 37.504l58.528 58.496h285.248c28.544 0 51.36 25.056 47.584 54.304z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"point",
						"select",
						"direct"
					],
					"grid": 32
				},
				{
					"id": 2883,
					"paths": [
						"M960 416v160c0 52.934-43.066 96-96 96-17.104 0-33.176-4.494-47.098-12.368-17.076 26.662-46.96 44.368-80.902 44.368-24.564 0-47.004-9.276-64-24.504-16.996 15.228-39.436 24.504-64 24.504-11.214 0-21.986-1.934-32-5.484v229.484c0 52.934-43.066 96-96 96-52.936 0-96-43.066-96-96v-394.676l-176.018 93.836c-14.538 8.398-31.126 12.84-47.982 12.84-52.936 0-96-43.066-96-96 0-26.368 10.472-50.952 29.488-69.226 0.248-0.238 0.496-0.47 0.75-0.7l239.17-218.074h-45.408c-17.674 0-32-14.326-32-32v-192c0-17.674 14.326-32 32-32h640c17.674 0 32 14.326 32 32v192c0 17.674-14.326 32-32 32h-44.222l72.842 145.69c2.224 4.442 3.38 9.342 3.38 14.31zM896 160c0-17.674-14.326-32-32-32s-32 14.326-32 32 14.326 32 32 32 32-14.326 32-32zM896 423.554l-83.778-167.554h-383.824l-290.82 265.168c-6.18 6.066-9.578 14.162-9.578 22.832 0 17.644 14.356 32 32 32 5.458 0 10.612-1.308 15.324-3.894 0.53-0.324 1.070-0.632 1.622-0.926l224-119.416c9.92-5.288 21.884-4.986 31.52 0.8 9.638 5.782 15.534 16.196 15.534 27.436v448c0 17.644 14.356 32 32 32s32-14.356 32-32v-320c0-17.672 14.326-32 32-32s32 14.328 32 32c0 17.644 14.356 32 32 32s32-14.356 32-32c0-17.674 14.326-32 32-32s32 14.326 32 32c0 17.644 14.356 32 32 32s32-14.356 32-32v-32c0-17.674 14.326-32 32-32s32 14.326 32 32c0 17.644 14.356 32 32 32s32-14.356 32-32v-152.446z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"point-down",
						"finger",
						"direction",
						"hand"
					],
					"defaultCode": 60718,
					"grid": 16
				},
				{
					"id": 2884,
					"paths": [
						"M608 960h-160c-52.934 0-96-43.066-96-96 0-17.104 4.494-33.176 12.368-47.098-26.662-17.076-44.368-46.958-44.368-80.902 0-24.564 9.276-47.004 24.504-64-15.228-16.996-24.504-39.436-24.504-64 0-11.214 1.934-21.986 5.484-32h-229.484c-52.934 0-96-43.066-96-96 0-52.936 43.066-96 96-96h394.676l-93.836-176.018c-8.398-14.536-12.84-31.126-12.84-47.982 0-52.936 43.066-96 96-96 26.368 0 50.952 10.472 69.224 29.488 0.238 0.248 0.472 0.496 0.7 0.75l218.076 239.17v-45.408c0-17.674 14.326-32 32-32h192c17.674 0 32 14.326 32 32v640c0 17.674-14.326 32-32 32h-192c-17.674 0-32-14.326-32-32v-44.222l-145.69 72.844c-4.442 2.222-9.34 3.378-14.31 3.378zM864 896c17.674 0 32-14.326 32-32s-14.326-32-32-32-32 14.326-32 32 14.326 32 32 32zM600.446 896l167.554-83.778v-383.824l-265.168-290.82c-6.066-6.18-14.162-9.578-22.832-9.578-17.644 0-32 14.356-32 32 0 5.458 1.308 10.612 3.894 15.324 0.324 0.53 0.632 1.070 0.926 1.622l119.416 224c5.29 9.92 4.988 21.884-0.798 31.52-5.784 9.638-16.198 15.534-27.438 15.534h-448c-17.644 0-32 14.356-32 32s14.356 32 32 32h320c17.672 0 32 14.326 32 32s-14.328 32-32 32c-17.644 0-32 14.356-32 32s14.356 32 32 32c17.674 0 32 14.326 32 32s-14.326 32-32 32c-17.644 0-32 14.356-32 32s14.356 32 32 32h32c17.674 0 32 14.326 32 32s-14.326 32-32 32c-17.644 0-32 14.356-32 32s14.356 32 32 32h152.446z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"point-left",
						"finger",
						"direction",
						"hand"
					],
					"defaultCode": 60719,
					"grid": 16
				},
				{
					"id": 2882,
					"paths": [
						"M416 960h160c52.934 0 96-43.066 96-96 0-17.104-4.494-33.176-12.368-47.098 26.664-17.076 44.368-46.958 44.368-80.902 0-24.564-9.276-47.004-24.504-64 15.228-16.996 24.504-39.436 24.504-64 0-11.214-1.934-21.986-5.484-32h229.484c52.934 0 96-43.066 96-96s-43.066-96-96-96h-394.676l93.836-176.018c8.4-14.536 12.84-31.126 12.84-47.982 0-52.934-43.066-96-96-96-26.368 0-50.954 10.472-69.226 29.49-0.238 0.248-0.47 0.496-0.7 0.75l-218.074 239.17v-45.41c0-17.672-14.326-32-32-32h-192c-17.674 0-32 14.328-32 32v640c0 17.674 14.326 32 32 32h192c17.674 0 32-14.326 32-32v-44.222l145.69 72.844c4.444 2.222 9.342 3.378 14.31 3.378zM160 896c-17.674 0-32-14.326-32-32s14.326-32 32-32 32 14.326 32 32-14.326 32-32 32zM423.556 896l-167.556-83.778v-383.824l265.168-290.818c6.066-6.18 14.162-9.58 22.832-9.58 17.644 0 32 14.356 32 32 0 5.46-1.308 10.612-3.894 15.324-0.324 0.53-0.632 1.070-0.926 1.622l-119.418 224c-5.288 9.92-4.986 21.884 0.8 31.52 5.784 9.638 16.198 15.534 27.438 15.534h448c17.644 0 32 14.356 32 32s-14.356 32-32 32h-320c-17.672 0-32 14.326-32 32s14.328 32 32 32c17.644 0 32 14.356 32 32s-14.356 32-32 32c-17.674 0-32 14.326-32 32s14.326 32 32 32c17.644 0 32 14.356 32 32s-14.356 32-32 32h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32c17.644 0 32 14.356 32 32s-14.356 32-32 32h-152.444z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"point-right",
						"finger",
						"direction",
						"hand"
					],
					"defaultCode": 60717,
					"grid": 16
				},
				{
					"id": 2881,
					"paths": [
						"M960 608v-160c0-52.934-43.066-96-96-96-17.104 0-33.176 4.494-47.098 12.368-17.076-26.664-46.958-44.368-80.902-44.368-24.564 0-47.004 9.274-64 24.504-16.996-15.23-39.436-24.504-64-24.504-11.214 0-21.986 1.934-32 5.484v-229.484c0-52.934-43.066-96-96-96s-96 43.066-96 96v394.676l-176.018-93.836c-14.536-8.4-31.126-12.84-47.982-12.84-52.934 0-96 43.066-96 96 0 26.368 10.472 50.954 29.49 69.226 0.248 0.238 0.496 0.47 0.75 0.7l239.17 218.074h-45.41c-17.672 0-32 14.326-32 32v192c0 17.674 14.328 32 32 32h640c17.674 0 32-14.326 32-32v-192c0-17.674-14.326-32-32-32h-44.222l72.844-145.69c2.222-4.442 3.378-9.342 3.378-14.31zM896 864c0 17.674-14.326 32-32 32s-32-14.326-32-32 14.326-32 32-32 32 14.326 32 32zM896 600.446l-83.776 167.554h-383.826l-290.818-265.166c-6.18-6.070-9.58-14.164-9.58-22.834 0-17.644 14.356-32 32-32 5.46 0 10.612 1.31 15.324 3.894 0.53 0.324 1.070 0.632 1.622 0.926l224 119.416c9.92 5.288 21.884 4.986 31.52-0.8 9.638-5.782 15.534-16.196 15.534-27.436v-448c0-17.644 14.356-32 32-32s32 14.356 32 32v320c0 17.672 14.326 32 32 32s32-14.328 32-32c0-17.644 14.356-32 32-32s32 14.356 32 32c0 17.672 14.326 32 32 32s32-14.328 32-32c0-17.644 14.356-32 32-32s32 14.356 32 32v32c0 17.672 14.326 32 32 32s32-14.328 32-32c0-17.644 14.356-32 32-32s32 14.356 32 32v152.446z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"point-up",
						"finger",
						"direction",
						"hand"
					],
					"defaultCode": 60716,
					"grid": 16
				},
				{
					"id": 694,
					"width": 1024,
					"paths": [
						"M224 800c0 17.664-14.336 32-32 32h-160c-17.664 0-32-14.336-32-32v-480c0-17.664 14.336-32 32-32h160c17.664 0 32 14.336 32 32v480zM656 736c-8.832 0-16-7.168-16-16s7.168-16 16-16h80v-96h-80c-8.832 0-16-7.168-16-16s7.168-16 16-16h80v-96h-80c-8.832 0-16-7.168-16-16s7.168-16 16-16h304c35.36 0 64-28.64 64-64v0c0-35.36-28.64-64-64-64h-288l-49.12-49.12c-30.016-30.016-70.72-46.88-113.152-46.88h-91.456c-42.432 0-83.136 16.864-113.152 46.848l-49.12 49.152v480l17.152 17.152c29.984 29.984 70.688 46.848 113.12 46.848h253.728c53.024 0 96-42.976 96-96v-32h-80z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"point",
						"select",
						"direct"
					],
					"grid": 32
				},
				{
					"id": 1084,
					"width": 1024,
					"paths": [
						"M928 320h-320c0-52.928-43.072-96-96-96h-160c-20.992 0-41.632 7.008-58.272 19.744l-174.816 108.256h-86.912c-17.664 0-32 14.336-32 32v384c0 17.664 14.336 32 32 32h85.984l95.104 66.208c18.816 17.408 49.76 29.792 74.912 29.792h315.136c50.624 0 96.192-37.12 100.512-87.584 1.728-20.256-2.848-39.328-12-55.52 26.624-17.056 44.352-46.944 44.352-80.896 0-17.12-4.512-33.184-12.384-47.104 26.656-17.056 44.384-46.944 44.384-80.896 0-11.232-1.952-21.984-5.472-32h165.472c53.024 0 96-42.976 96-96s-42.976-96-96-96zM128 736h-64v-320h64v320zM928 448h-256c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32 14.368 32 32s-14.336 32-32 32h-32c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32 14.368 32 32s-14.336 32-32 32h-32c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32 14.368 32 32s-14.336 32-32 32h-320c-9.12 0-25.568-6.816-32-13.248l-96-67.328v-349.6l168.864-104.576c0 0 15.904-9.248 23.136-9.248h160c17.664 0 32 14.368 32 32 0 5.376 0 32 0 32h-128c-8.832 0-16 7.168-16 16s7.168 16 16 16h512c17.664 0 32 14.336 32 32s-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"point",
						"direct"
					],
					"grid": 32
				},
				{
					"id": 2885,
					"paths": [
						"M768 1024h-320c-8.488 0-16.626-3.372-22.626-9.374l-192-192c-1.712-1.712-3.226-3.614-4.508-5.666l-160-256c-9.172-14.678-5.014-33.986 9.386-43.586l96-64c13.608-9.070 31.864-6.422 42.334 6.14l103.414 124.102v-487.616c0-17.672 14.328-32 32-32h128c17.672 0 32 14.328 32 32v199.014l359.762 89.94c14.244 3.562 24.238 16.362 24.238 31.046v384c0 4.968-1.156 9.868-3.378 14.31l-96 192c-5.42 10.842-16.5 17.69-28.622 17.69zM461.254 960h286.968l83.778-167.554v-351.46l-64-16v183.014c0 17.674-14.326 32-32 32s-32-14.326-32-32v-199.014l-64-16v151.014c0 17.674-14.326 32-32 32s-32-14.326-32-32v-167.014l-64-16v247.014c0 17.674-14.328 32-32 32s-32-14.326-32-32v-480h-64v544c0 13.472-8.438 25.502-21.106 30.088-12.666 4.596-26.85 0.746-35.476-9.602l-141.592-169.91-46.22 30.812 141.6 226.56 180.048 180.052z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pointer",
						"finger",
						"drag",
						"hand",
						"touch"
					],
					"defaultCode": 60720,
					"grid": 16
				},
				{
					"id": 263,
					"paths": [
						"M870.4 614.4c-21.072 0-40.674-6.403-56.973-17.358-14.008 39.88-52.021 68.558-96.627 68.558-21.072 0-40.674-6.403-56.973-17.358-14.008 39.88-52.021 68.558-96.627 68.558-18.645 0-36.125-5.034-51.2-13.776v167.376c0 56.464-45.936 102.4-102.4 102.4s-102.4-45.936-102.4-102.4v-377.52l-68.909 119.446c-13.366 24.326-35.163 41.645-61.405 48.782-25.56 6.949-52.146 3.272-74.858-10.357-46.461-27.877-64.138-90.819-39.442-140.37 1.514-3.101 34.213-70.024 136.17-273.938 48.010-96.021 100.704-164.653 156.619-203.994 43.896-30.886 74.195-32.451 79.824-32.451h256c43.41 0 83.571 12.566 119.371 37.352 34.603 23.957 64.469 58.984 88.768 104.11 48.059 89.251 73.461 217.381 73.461 370.538 0 56.464-45.936 102.4-102.4 102.4zM854.259 165.738c-28.134-52.251-79.262-114.538-163.059-114.538h-255.49c-2.016 0.173-23.546 2.565-56.067 26.894-32.41 24.246-82.155 75.373-135.091 181.246-103.789 207.579-135.685 272.947-135.995 273.584-0.037 0.077-0.075 0.154-0.114 0.23-12.87 25.742-3.744 59.49 19.928 73.694 10.645 6.387 23.102 8.11 35.080 4.853 12.766-3.47 23.438-12.059 30.051-24.182 0.098-0.179 0.198-0.357 0.301-0.534l79.899-138.498c16.349-29.842 34.723-42.405 54.622-37.328 19.955 5.088 30.075 25.019 30.075 59.24v400c0 28.232 22.968 51.2 51.2 51.2s51.2-22.968 51.2-51.2v-332.8c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v76.8c0 28.232 22.968 51.2 51.2 51.2s51.2-22.968 51.2-51.2v-76.8c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v25.6c0 28.232 22.968 51.2 51.2 51.2s51.2-22.968 51.2-51.2v-76.8c0-14.139 11.461-25.6 25.6-25.6s25.6 11.461 25.6 25.6v25.6c0 28.232 22.968 51.2 51.2 51.2s51.2-22.968 51.2-51.2c0-144.712-23.286-264.448-67.341-346.262z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pointer-down",
						"hand",
						"index",
						"finger"
					],
					"defaultCode": 59560,
					"grid": 20
				},
				{
					"id": 264,
					"paths": [
						"M409.6 870.4c0-21.072 6.403-40.674 17.358-56.973-39.88-14.008-68.558-52.021-68.558-96.627 0-21.072 6.403-40.674 17.358-56.973-39.88-14.008-68.558-52.021-68.558-96.627 0-18.645 5.034-36.125 13.776-51.2h-167.376c-56.464 0-102.4-45.936-102.4-102.4s45.936-102.4 102.4-102.4h377.52l-119.446-68.909c-24.326-13.366-41.645-35.163-48.782-61.405-6.949-25.56-3.272-52.146 10.357-74.858 27.877-46.461 90.819-64.138 140.37-39.442 3.101 1.514 70.024 34.213 273.938 136.17 96.021 48.010 164.653 100.704 203.994 156.619 30.886 43.896 32.451 74.195 32.451 79.824v256c0 43.41-12.566 83.571-37.352 119.371-23.957 34.603-58.984 64.469-104.11 88.768-89.251 48.059-217.381 73.461-370.538 73.461-56.464 0-102.4-45.936-102.4-102.4zM858.262 854.259c52.251-28.134 114.538-79.262 114.538-163.059v-255.49c-0.173-2.016-2.565-23.546-26.894-56.067-24.246-32.41-75.373-82.155-181.246-135.091-207.579-103.789-272.947-135.685-273.584-135.995-0.077-0.037-0.154-0.075-0.23-0.114-25.742-12.87-59.49-3.744-73.694 19.928-6.387 10.645-8.11 23.102-4.853 35.080 3.47 12.766 12.059 23.438 24.182 30.051 0.179 0.098 0.357 0.198 0.534 0.301l138.498 79.899c29.842 16.349 42.405 34.723 37.328 54.622-5.088 19.955-25.019 30.075-59.24 30.075h-400c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2h332.8c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-76.8c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2h76.8c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6h-25.6c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2h76.8c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6h-25.6c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2c144.712 0 264.448-23.286 346.262-67.341z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pointer-left",
						"hand",
						"index",
						"finger"
					],
					"defaultCode": 59561,
					"grid": 20
				},
				{
					"id": 262,
					"paths": [
						"M614.4 870.4c0-21.072-6.403-40.674-17.358-56.973 39.88-14.008 68.558-52.021 68.558-96.627 0-21.072-6.403-40.674-17.358-56.973 39.88-14.008 68.558-52.021 68.558-96.627 0-18.645-5.034-36.125-13.776-51.2h167.376c56.464 0 102.4-45.936 102.4-102.4s-45.936-102.4-102.4-102.4h-377.52l119.446-68.909c24.326-13.366 41.645-35.163 48.782-61.405 6.949-25.56 3.272-52.146-10.357-74.858-27.877-46.461-90.819-64.138-140.37-39.442-3.101 1.514-70.024 34.213-273.938 136.17-96.021 48.010-164.653 100.704-203.994 156.619-30.886 43.896-32.451 74.195-32.451 79.824v256c0 43.41 12.566 83.571 37.352 119.371 23.957 34.603 58.984 64.469 104.11 88.768 89.251 48.059 217.381 73.461 370.538 73.461 56.464 0 102.4-45.936 102.4-102.4zM165.738 854.259c-52.251-28.134-114.538-79.262-114.538-163.059v-255.49c0.173-2.016 2.565-23.546 26.894-56.067 24.246-32.41 75.373-82.155 181.246-135.091 207.579-103.789 272.947-135.685 273.584-135.995 0.077-0.037 0.154-0.075 0.23-0.114 25.742-12.87 59.49-3.744 73.694 19.928 6.387 10.645 8.11 23.102 4.853 35.080-3.47 12.766-12.059 23.438-24.182 30.051-0.179 0.098-0.357 0.198-0.534 0.301l-138.498 79.899c-29.842 16.349-42.405 34.723-37.328 54.622 5.088 19.955 25.019 30.075 59.24 30.075h400c28.232 0 51.2 22.968 51.2 51.2s-22.968 51.2-51.2 51.2h-332.8c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h76.8c28.232 0 51.2 22.968 51.2 51.2s-22.968 51.2-51.2 51.2h-76.8c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h25.6c28.232 0 51.2 22.968 51.2 51.2s-22.968 51.2-51.2 51.2h-76.8c-14.139 0-25.6 11.461-25.6 25.6s11.461 25.6 25.6 25.6h25.6c28.232 0 51.2 22.968 51.2 51.2s-22.968 51.2-51.2 51.2c-144.712 0-264.448-23.286-346.262-67.341z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pointer-right",
						"hand",
						"index",
						"finger"
					],
					"defaultCode": 59559,
					"grid": 20
				},
				{
					"id": 261,
					"paths": [
						"M870.4 409.6c-21.072 0-40.674 6.403-56.973 17.358-14.008-39.88-52.021-68.558-96.627-68.558-21.072 0-40.674 6.403-56.973 17.358-14.008-39.88-52.021-68.558-96.627-68.558-18.645 0-36.125 5.034-51.2 13.776v-167.376c0-56.464-45.936-102.4-102.4-102.4s-102.4 45.936-102.4 102.4v377.52l-68.909-119.446c-13.366-24.326-35.163-41.645-61.405-48.782-25.56-6.949-52.146-3.272-74.858 10.357-46.461 27.877-64.138 90.819-39.442 140.37 1.514 3.101 34.213 70.024 136.17 273.938 48.010 96.021 100.704 164.653 156.619 203.994 43.896 30.886 74.195 32.451 79.824 32.451h256c43.41 0 83.571-12.566 119.371-37.352 34.603-23.957 64.469-58.984 88.768-104.11 48.059-89.251 73.461-217.381 73.461-370.538 0-56.464-45.936-102.4-102.4-102.4zM854.259 858.262c-28.134 52.251-79.262 114.538-163.059 114.538h-255.49c-2.016-0.173-23.546-2.565-56.067-26.894-32.41-24.246-82.155-75.373-135.091-181.246-103.789-207.579-135.685-272.947-135.995-273.584-0.037-0.077-0.075-0.154-0.114-0.23-12.87-25.742-3.744-59.49 19.928-73.694 10.645-6.387 23.102-8.11 35.080-4.853 12.766 3.47 23.438 12.059 30.051 24.182 0.098 0.179 0.198 0.357 0.301 0.534l79.899 138.498c16.349 29.842 34.723 42.405 54.622 37.328 19.955-5.088 30.075-25.019 30.075-59.24v-400c0-28.232 22.968-51.2 51.2-51.2s51.2 22.968 51.2 51.2v332.8c0 14.138 11.462 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-76.8c0-28.232 22.968-51.2 51.2-51.2s51.2 22.968 51.2 51.2v76.8c0 14.138 11.461 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-25.6c0-28.232 22.968-51.2 51.2-51.2s51.2 22.968 51.2 51.2v76.8c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-25.6c0-28.232 22.968-51.2 51.2-51.2s51.2 22.968 51.2 51.2c0 144.712-23.286 264.448-67.341 346.262z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pointer-up",
						"hand",
						"index",
						"finger"
					],
					"defaultCode": 59558,
					"grid": 20
				},
				{
					"id": 695,
					"width": 1024,
					"paths": [
						"M672 416v-64h64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-91.424l22.208-155.488c2.752-19.264-12.192-36.512-31.68-36.512h-246.208c-19.488 0-34.432 17.248-31.68 36.512l22.208 155.488h-91.424c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h64v64c-88.352 0-160 71.648-160 160v320c0 53.024 42.976 96 96 96h448c53.024 0 96-42.976 96-96v-320c0-88.352-71.648-160-160-160zM635.104 96l-22.848 160h-200.48l-22.848-160h246.176zM288 320v-32h448v32h-448zM736 960h-448c-35.36 0-64-28.64-64-64v-320c0-70.688 57.312-128 128-128h32v-96h256v96h32c70.688 0 128 57.312 128 128v320c0 35.36-28.64 64-64 64zM600.832 789.472l-53.056 26.528 53.056 26.528c7.904 3.968 11.136 13.568 7.168 21.472v0c-3.936 7.904-13.568 11.104-21.472 7.168l-74.528-37.28-74.528 37.28c-7.904 3.936-17.504 0.736-21.472-7.168v0c-3.936-7.904-0.736-17.504 7.168-21.472l53.056-26.528-53.056-26.528c-7.904-3.968-11.136-13.568-7.168-21.472v0c3.936-7.904 13.568-11.104 21.472-7.168l74.528 37.28 74.528-37.28c7.904-3.936 17.504-0.736 21.472 7.168v0c3.968 7.904 0.736 17.504-7.168 21.472zM448 698.112v5.888c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-5.888c36.384-12.928 32.192-16.256 32-55.456-0.256-52.128-40.768-96.928-92.864-98.624-54.432-1.728-99.136 41.888-99.136 95.968 0 41.728-5.216 44.896 32 58.112zM447.84 654.080c0.096-4.16 0.16-8.832 0.16-14.080 0-35.296 28.704-64 64-64s64 28.704 64 64c0 5.248 0.064 9.92 0.16 14.080 0.064 3.296 0.128 6.848 0.096 9.728-2.336 0.992-5.824 2.336-10.976 4.16l-21.28 7.552v28.48h-64v-28.48l-21.28-7.552c-5.152-1.824-8.608-3.168-10.976-4.16 0-2.88 0.064-6.432 0.096-9.728z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"poison",
						"die",
						"drink",
						"kill"
					],
					"grid": 32
				},
				{
					"id": 696,
					"width": 1024,
					"paths": [
						"M374.848 224l-17.632-123.488c-2.752-19.264 12.192-36.512 31.68-36.512h246.208c19.488 0 34.432 17.248 31.68 36.512l-17.632 123.488h-274.304zM832 576v320c0 53.024-42.976 96-96 96h-448c-53.024 0-96-42.976-96-96v-320c0-88.352 71.648-160 160-160v-64h-64c-17.664 0-32-14.336-32-32v-32c0-17.664 14.336-32 32-32h448c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32h-64v64c88.352 0 160 71.648 160 160zM448 698.112v5.888c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-5.888c36.384-12.928 32.192-16.256 32-55.456-0.256-52.128-40.768-96.928-92.864-98.592-54.432-1.76-99.136 41.856-99.136 95.936 0 41.728-5.216 44.896 32 58.112zM547.776 816l53.056-26.528c7.904-3.968 11.136-13.568 7.168-21.472v0c-3.968-7.904-13.568-11.104-21.472-7.168l-74.528 37.28-74.528-37.28c-7.904-3.936-17.504-0.736-21.472 7.168v0c-3.968 7.904-0.736 17.504 7.168 21.472l53.056 26.528-53.056 26.528c-7.904 3.968-11.136 13.568-7.168 21.472v0c3.968 7.904 13.568 11.104 21.472 7.168l74.528-37.28 74.528 37.28c7.904 3.936 17.504 0.736 21.472-7.168v0c3.968-7.904 0.736-17.504-7.168-21.472l-53.056-26.528zM480 675.52v28.48h64v-28.48c0 0 29.92-10.752 32.256-11.744 0-2.848-0.256-18.528-0.256-23.776 0-35.296-28.704-64-64-64s-64 28.704-64 64c0 5.248-0.256 20.928-0.256 23.808 2.336 0.992 32.256 11.712 32.256 11.712z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"poison",
						"die",
						"drink",
						"kill"
					],
					"grid": 32
				},
				{
					"id": 101,
					"paths": [
						"M873.333 681.107c-3.966-2.246-8.048-4.443-12.222-6.6 48.915-38.344 60.49-80.262 60.49-111.307 0-72.674-61.078-135.928-162.541-174.525 5.875-17.965 8.941-36.88 8.941-55.875 0-98.811-80.389-179.2-179.2-179.2-35.035 0-76.8-8.883-76.8-51.2 0-23.198 29.574-48.541 39.872-55.547 9.354-6.28 13.501-17.936 10.218-28.712s-13.224-18.141-24.49-18.141c-80.245 0-162.696 26.368-226.211 72.346-32.41 23.461-58.131 50.595-76.45 80.65-19.998 32.814-30.139 67.47-30.139 103.005 0 14.744 1.243 29.392 3.608 43.797-43.469 20.992-80.192 48.712-107.018 80.933-32.835 39.437-50.19 84.83-50.19 131.27 0 27.966 6.277 56.472 18.206 84.035-45.49 43.71-69.406 93.979-69.406 146.365 0 78.094 52.608 150.328 148.133 203.397 90.773 50.43 210.906 78.203 338.267 78.203 130.957 0 249.787-17.029 334.603-47.949 125.461-45.738 151.797-110.542 151.797-156.851 0-37.291-17.256-91.518-99.467-138.093zM803.466 927.949c-79.336 28.923-191.939 44.851-317.066 44.851-118.806 0-230.107-25.485-313.402-71.76-78.542-43.634-121.798-99.974-121.798-158.64 0-40.826 21.002-74.779 44.366-99.936 5.885 8.378 12.307 16.573 19.277 24.526 40.771 46.536 97.469 82.053 159.65 100.005 2.371 0.685 4.762 1.011 7.112 1.011 11.114 0 21.347-7.294 24.584-18.504 3.922-13.584-3.91-27.774-17.494-31.698-106.206-30.662-186.294-119.141-186.294-205.805 0-62.675 45.037-122.826 119.269-161.555 26.826 73.859 83.443 135.219 153.798 160.091 2.822 0.998 5.701 1.47 8.533 1.47 10.544 0 20.421-6.566 24.136-17.074 4.712-13.33-2.274-27.957-15.603-32.669-77.837-27.517-136.533-116.192-136.533-206.264 0-51.818 30.333-102.312 85.411-142.179 38.090-27.571 84.11-46.995 131.971-56.328-7.397 13.192-12.582 28.349-12.582 44.907 0 49.502 33.626 102.4 128 102.4 70.579 0 128 57.421 128 128 0 13.867-2.157 27.296-6.403 40.131-20.886-5.683-43.034-10.453-66.326-14.205-13.955-2.246-27.098 7.245-29.346 21.203-2.246 13.958 7.245 27.098 21.205 29.346 71.034 11.442 131.246 33.152 174.128 62.787 27.528 19.022 60.342 50.277 60.342 91.138 0 33.022-21.93 62.36-65.202 87.318-46.827-16.661-101.688-28.875-162.229-35.946-14.043-1.654-26.758 8.413-28.397 22.456s8.414 26.758 22.456 28.397c86.328 10.085 159.312 30.91 211.066 60.23 33.534 18.995 73.506 50.645 73.506 93.544 0 54.286-64.242 89.101-118.134 108.749z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"poop",
						"toilet",
						"feces",
						"crap"
					],
					"defaultCode": 59398,
					"grid": 20
				},
				{
					"id": 1085,
					"width": 1024,
					"paths": [
						"M384 224h-96v-32h96v32zM832 64v96c0 17.664-14.336 32-32 32h-32v256c17.664 0 32 14.336 32 32v96c0 17.664-14.336 32-32 32v9.824c0 65.504-39.296 123.552-100.128 147.872-36.352 14.56-59.872 49.28-59.872 88.48v9.824h64c35.296 0 64 28.704 64 64v64c0 17.664-14.336 32-32 32h-448c-17.664 0-32-14.336-32-32v-64c0-35.296 28.704-64 64-64h64v-9.824c0-39.168-23.52-73.888-59.872-88.448-60.832-24.352-100.128-82.4-100.128-147.904v-9.824c-17.664 0-32-14.336-32-32v-96c0-17.664 14.336-32 32-32v-256h-32c-17.664 0-32-14.336-32-32v-96c0-35.296 28.704-64 64-64h576c35.296 0 64 28.704 64 64zM704 576h-448v41.824c0 39.168 23.52 73.888 59.872 88.448 60.832 24.352 100.128 82.4 100.128 147.904v41.824h128v-41.824c0-65.504 39.296-123.552 100.128-147.872 36.352-14.56 59.872-49.28 59.872-88.48v-41.824zM672 928h-384v32h384v-32zM192 128h576v-64h-576v64zM704 160h-448v320h448v-320zM736 544v-32h-512v32h512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"poop",
						"smell",
						"stink",
						"sit",
						"flush"
					],
					"grid": 32
				},
				{
					"id": 3296,
					"paths": [
						"M928 128h-576c-52.8 0-96 43.2-96 96v96h-160c-52.8 0-96 43.2-96 96v384c0 52.8 43.2 96 96 96h576c52.8 0 96-43.2 96-96v-96h160c52.8 0 96-43.2 96-96v-384c0-52.8-43.198-96-96-96zM704 800c0 17.346-14.654 32-32 32h-576c-17.346 0-32-14.654-32-32v-384c0-17.346 14.654-32 32-32h160v224c0 52.8 43.2 96 96 96h352v96zM960 608c0 17.346-14.654 32-32 32h-576c-17.346 0-32-14.654-32-32v-384c0-17.346 14.654-32 32-32h576c17.346 0 32 14.654 32 32v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"popout",
						"new-window"
					],
					"defaultCode": 61131,
					"grid": 16
				},
				{
					"id": 1086,
					"width": 1024,
					"paths": [
						"M768 0h-512c-17.696 0-32 14.336-32 32v320c0 147.968 112.224 270.144 256 286.112v321.888h-128c-17.696 0-32 14.336-32 32s14.304 32 32 32h320c17.696 0 32-14.336 32-32s-14.304-32-32-32h-128v-321.888c143.776-16 256-138.144 256-286.112v-320c0-17.664-14.304-32-32-32zM736 64v160h-448v-160h448zM512 576c-123.488 0-224-100.48-224-224v-96h448v96c0 123.52-100.512 224-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pour",
						"drink",
						"indulge",
						"ferment"
					],
					"grid": 32
				},
				{
					"id": 2653,
					"paths": [
						"M384 0l-384 512h384l-256 512 896-640h-512l384-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"power",
						"lightning",
						"bolt",
						"electricity"
					],
					"defaultCode": 60488,
					"grid": 16
				},
				{
					"id": 2658,
					"paths": [
						"M1024 282.5l-90.506-90.5-178.746 178.752-101.5-101.502 178.75-178.75-90.5-90.5-178.75 178.75-114.748-114.75-86.626 86.624 512.002 512 86.624-86.622-114.752-114.752 178.752-178.75z",
						"M794.040 673.79l-443.824-443.824c-95.818 114.904-204.52 292.454-129.396 445.216l-132.248 132.248c-31.112 31.114-31.112 82.024 0 113.136l14.858 14.858c31.114 31.114 82.026 31.114 113.138 0l132.246-132.244c152.764 75.132 330.318-33.566 445.226-129.39z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"power-cord",
						"plugin",
						"extension"
					],
					"defaultCode": 60493,
					"grid": 16
				},
				{
					"id": 2659,
					"paths": [
						"M720 592l176-176-64-64-176 176-160-160 176-176-64-64-176 176-110.058-110.058c-18.668-18.668-48.342-19.542-65.942-1.942s-16.726 47.274 1.942 65.942l73.040 73.040-128 128c-84.348 84.348-97.532 212.912-39.55 311.082l-144.686 144.682c-24.994 24.992-24.994 65.516 0 90.508 12.496 12.498 28.876 18.746 45.254 18.746s32.758-6.248 45.254-18.746l144.682-144.684c98.17 57.98 226.734 44.794 311.082-39.55l128.002-128 73.040 73.040c18.666 18.666 48.34 19.54 65.94 1.94s16.726-47.274-1.942-65.942l-110.058-110.058z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"power-cord",
						"plugin",
						"extension"
					],
					"defaultCode": 60494,
					"grid": 16
				},
				{
					"id": 1195,
					"width": 877.7170104980469,
					"paths": [
						"M877.714 512q0 89.143-34.857 170.286t-93.714 140-140 93.714-170.286 34.857-170.286-34.857-140-93.714-93.714-140-34.857-170.286q0-104 46-196t129.429-154.286q24.571-18.286 54.571-14.286t47.714 28.571q18.286 24 14 54t-28.286 48.286q-56 42.286-86.571 103.429t-30.571 130.286q0 59.429 23.143 113.429t62.571 93.429 93.429 62.571 113.429 23.143 113.429-23.143 93.429-62.571 62.571-93.429 23.143-113.429q0-69.143-30.571-130.286t-86.571-103.429q-24-18.286-28.286-48.286t14-54q17.714-24.571 48-28.571t54.286 14.286q83.429 62.286 129.429 154.286t46 196zM512 73.143v365.714q0 29.714-21.714 51.429t-51.429 21.714-51.429-21.714-21.714-51.429v-365.714q0-29.714 21.714-51.429t51.429-21.714 51.429 21.714 21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"power-off"
					],
					"defaultCode": 61457,
					"grid": 14
				},
				{
					"id": 157,
					"paths": [
						"M486.4 614.4c-14.138 0-25.6-11.461-25.6-25.6v-460.8c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v460.8c0 14.139-11.462 25.6-25.6 25.6z",
						"M486.4 972.8c-102.57 0-199-39.944-271.53-112.47-72.528-72.528-112.47-168.96-112.47-271.53 0-84.395 26.859-164.478 77.674-231.594 49.15-64.915 118.979-113.394 196.624-136.501 13.55-4.034 27.805 3.683 31.838 17.234s-3.683 27.805-17.234 31.838c-139.955 41.654-237.702 172.84-237.702 319.022 0 183.506 149.294 332.8 332.8 332.8s332.8-149.294 332.8-332.8c0-146.187-97.75-277.374-237.71-319.024-13.552-4.034-21.267-18.288-17.234-31.838 4.032-13.552 18.29-21.267 31.837-17.235 77.646 23.106 147.48 71.582 196.632 136.499 50.816 67.115 77.675 147.202 77.675 231.598 0 102.57-39.942 199.002-112.47 271.53-72.528 72.526-168.96 112.47-271.53 112.47z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"power-switch",
						"toggle"
					],
					"defaultCode": 59454,
					"grid": 20
				},
				{
					"id": 2654,
					"paths": [
						"M704 0l-576 576h352l-160 448 576-576h-352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"power",
						"lightning",
						"bolt",
						"electricity"
					],
					"defaultCode": 60489,
					"grid": 16
				},
				{
					"id": 2655,
					"paths": [
						"M0 704l320-512 320 320 384-256-320 576-320-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"power",
						"lightning",
						"bolt",
						"electricity"
					],
					"defaultCode": 60490,
					"grid": 16
				},
				{
					"id": 697,
					"width": 1024,
					"paths": [
						"M275.488 513.984c3.36 8.16-0.512 17.536-8.672 20.896l-29.568 12.256c-1.984 0.832-4.064 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888-3.36-8.16 0.512-17.536 8.672-20.896l29.568-12.256c8.096-3.392 17.536 0.512 20.896 8.672zM763.296 327.904c2.048 0 4.128-0.384 6.112-1.216l29.568-12.256c8.16-3.36 12.032-12.736 8.672-20.896s-12.736-12.064-20.896-8.672l-29.568 12.256c-8.16 3.36-12.032 12.736-8.672 20.896 2.56 6.176 8.512 9.888 14.784 9.888zM414.016 652.512c-8.128-3.392-17.504 0.512-20.896 8.672l-12.224 29.6c-3.36 8.192 0.512 17.536 8.672 20.896 1.984 0.832 4.064 1.216 6.112 1.216 6.272 0 12.224-3.712 14.784-9.888l12.224-29.6c3.36-8.192-0.512-17.536-8.672-20.896zM609.984 179.488c1.984 0.832 4.064 1.216 6.112 1.216 6.272 0 12.224-3.712 14.784-9.888l12.224-29.6c3.36-8.192-0.512-17.536-8.672-20.896-8.128-3.424-17.504 0.512-20.896 8.672l-12.224 29.6c-3.36 8.192 0.512 17.536 8.672 20.896zM613.536 703.008c2.56 6.144 8.512 9.888 14.784 9.888 2.048 0 4.096-0.384 6.112-1.216 8.16-3.36 12.032-12.704 8.672-20.896l-12.224-29.6c-3.36-8.16-12.704-12.064-20.896-8.672-8.16 3.36-12.032 12.704-8.672 20.896l12.224 29.6zM410.464 128.992c-3.36-8.16-12.768-12.096-20.896-8.672-8.16 3.36-12.032 12.704-8.672 20.896l12.224 29.6c2.56 6.144 8.512 9.888 14.784 9.888 2.048 0 4.096-0.384 6.112-1.216 8.16-3.36 12.032-12.704 8.672-20.896l-12.224-29.6zM757.184 534.88l29.568 12.256c1.984 0.832 4.064 1.216 6.112 1.216 6.272 0 12.224-3.712 14.784-9.888 3.36-8.16-0.512-17.536-8.672-20.896l-29.568-12.256c-8.096-3.424-17.536 0.512-20.896 8.672-3.36 8.128 0.512 17.504 8.672 20.896zM266.816 297.12l-29.536-12.256c-8.16-3.424-17.536 0.512-20.928 8.672s0.512 17.536 8.672 20.896l29.568 12.256c1.984 0.832 4.064 1.216 6.112 1.216 6.272 0 12.224-3.712 14.784-9.888 3.36-8.128-0.512-17.504-8.672-20.896zM576 794.24v72.704c0 18.944 5.6 37.472 16.128 53.248l14.72 22.080c14.176 21.248-1.088 49.728-26.656 49.728h-136.416c-25.568 0-40.8-28.48-26.624-49.76l14.72-22.080c10.528-15.744 16.128-34.272 16.128-53.216v-72.704c-183.648-30.88-323.232-191.712-319.936-384.896 3.392-200.672 167.424-368.896 367.936-377.024 5.376-0.224 10.688-0.32 16-0.32 212.064 0 384 171.936 384 384 0 190.208-138.464 347.712-320 378.24zM544 866.944v-99.776l26.688-4.48c169.952-28.576 293.312-174.368 293.312-346.688 0-194.080-157.92-352-352-352-4.864 0-9.76 0.096-14.688 0.288-182.848 7.424-334.144 162.464-337.248 345.6-2.944 172.512 123.136 324.192 293.248 352.8l26.688 4.48v99.776c0 25.344-7.424 49.92-21.504 71.008l-14.688 22.048h136.416l-14.72-22.080c-14.080-21.088-21.504-45.632-21.504-70.976z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"prank",
						"sit",
						"trick",
						"fart",
						"embarrass"
					],
					"grid": 32
				},
				{
					"id": 698,
					"width": 1024,
					"paths": [
						"M896 416c0-212.064-171.936-384-384-384-5.312 0-10.624 0.096-16 0.32-200.512 8.128-364.544 176.352-367.936 377.024-3.296 193.184 136.288 354.016 319.936 384.896v72.704c0 18.944-5.6 37.472-16.128 53.248l-14.72 22.080c-14.176 21.248 1.088 49.728 26.656 49.728h136.416c25.568 0 40.8-28.48 26.624-49.76l-14.72-22.080c-10.528-15.744-16.128-34.272-16.128-53.216v-72.704c181.536-30.528 320-188.032 320-378.24zM757.184 297.12l29.568-12.256c8.16-3.392 17.536 0.512 20.896 8.672s-0.512 17.536-8.672 20.896l-29.568 12.256c-1.984 0.832-4.064 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888-3.36-8.128 0.512-17.504 8.672-20.896zM748.512 513.984c3.36-8.16 12.8-12.096 20.896-8.672l29.568 12.256c8.16 3.36 12.032 12.736 8.672 20.896-2.56 6.144-8.512 9.888-14.784 9.888-2.048 0-4.128-0.384-6.112-1.216l-29.568-12.256c-8.16-3.392-12.032-12.768-8.672-20.896zM601.312 158.592l12.224-29.6c3.392-8.16 12.736-12.096 20.896-8.672 8.16 3.36 12.032 12.704 8.672 20.896l-12.224 29.6c-2.56 6.144-8.512 9.888-14.784 9.888-2.048 0-4.096-0.384-6.112-1.216-8.16-3.36-12.032-12.704-8.672-20.896zM609.984 652.512c8.192-3.392 17.504 0.512 20.896 8.672l12.224 29.6c3.36 8.192-0.512 17.536-8.672 20.896-1.984 0.832-4.064 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888l-12.224-29.6c-3.36-8.192 0.512-17.536 8.672-20.896zM266.816 534.88l-29.568 12.256c-1.984 0.832-4.064 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888-3.36-8.16 0.512-17.536 8.672-20.896l29.568-12.256c8.128-3.392 17.536 0.512 20.896 8.672 3.36 8.128-0.512 17.504-8.672 20.896zM275.488 318.016c-2.56 6.144-8.512 9.888-14.784 9.888-2.048 0-4.128-0.384-6.112-1.216l-29.568-12.256c-8.16-3.36-12.032-12.736-8.672-20.896s12.768-12.096 20.928-8.672l29.568 12.256c8.128 3.392 12 12.768 8.64 20.896zM422.688 673.408l-12.224 29.6c-2.56 6.144-8.512 9.888-14.784 9.888-2.048 0-4.096-0.384-6.112-1.216-8.16-3.36-12.032-12.704-8.672-20.896l12.224-29.6c3.392-8.16 12.768-12.064 20.896-8.672 8.16 3.36 12.032 12.704 8.672 20.896zM414.016 179.488c-1.984 0.832-4.064 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888l-12.224-29.6c-3.36-8.192 0.512-17.536 8.672-20.896 8.128-3.424 17.504 0.512 20.896 8.672l12.224 29.6c3.36 8.192-0.512 17.536-8.672 20.896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"prank",
						"sit",
						"trick",
						"fart",
						"embarrass"
					],
					"grid": 32
				},
				{
					"id": 699,
					"width": 1024,
					"paths": [
						"M768 0c-35.36 0-64 28.64-64 64 0 11.84 3.456 22.816 9.056 32.32l-40.736 40.736c-9.504-5.6-20.48-9.056-32.32-9.056-35.36 0-64 28.64-64 64 0 11.84 3.456 22.816 9.056 32.32l-40.736 40.736c-9.504-5.6-20.48-9.056-32.32-9.056s-22.816 3.456-32.32 9.056l-40.736-40.736c5.6-9.504 9.056-20.48 9.056-32.32 0-35.36-28.64-64-64-64-11.84 0-22.816 3.456-32.32 9.056l-40.736-40.736c5.6-9.504 9.056-20.48 9.056-32.32 0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64c11.84 0 22.816-3.456 32.32-9.056l40.736 40.736c-5.6 9.504-9.056 20.48-9.056 32.32 0 35.36 28.64 64 64 64 11.84 0 22.816-3.456 32.32-9.056l40.736 40.736c-5.6 9.504-9.056 20.48-9.056 32.32 0 29.792 20.448 54.592 48 61.728v36.512c-27.552 7.168-48 31.968-48 61.76s20.448 54.592 48 61.728v34.272h-16c-17.664 0-32 14.336-32 32v64h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64v192c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-192h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-64v-64c0-17.664-14.336-32-32-32h-16v-34.272c27.552-7.136 48-31.936 48-61.728s-20.448-54.592-48-61.728v-36.512c27.552-7.168 48-31.968 48-61.76 0-11.84-3.456-22.816-9.056-32.32l40.736-40.736c9.504 5.6 20.48 9.056 32.32 9.056 35.36 0 64-28.64 64-64 0-11.84-3.456-22.816-9.056-32.32l40.736-40.736c9.504 5.6 20.48 9.056 32.32 9.056 35.36 0 64-28.64 64-64s-28.64-64-64-64zM256 96c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM384 224c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM544 608v96h96v64h-96v224h-64v-224h-96v-64h96v-96h64zM544 480c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM512 352c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM640 224c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM768 96c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pray",
						"believe",
						"worship",
						"hope"
					],
					"grid": 32
				},
				{
					"id": 700,
					"width": 1024,
					"paths": [
						"M768 0c-35.36 0-64 28.64-64 64 0 11.84 3.456 22.816 9.056 32.32l-40.736 40.736c-9.504-5.6-20.48-9.056-32.32-9.056-35.36 0-64 28.64-64 64 0 11.84 3.456 22.816 9.056 32.32l-40.736 40.736c-9.504-5.6-20.48-9.056-32.32-9.056s-22.816 3.456-32.32 9.056l-40.736-40.736c5.6-9.504 9.056-20.48 9.056-32.32 0-35.36-28.64-64-64-64-11.84 0-22.816 3.456-32.32 9.056l-40.736-40.736c5.6-9.504 9.056-20.48 9.056-32.32 0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64c11.84 0 22.816-3.456 32.32-9.056l40.736 40.736c-5.6 9.504-9.056 20.48-9.056 32.32 0 35.36 28.64 64 64 64 11.84 0 22.816-3.456 32.32-9.056l40.736 40.736c-5.6 9.504-9.056 20.48-9.056 32.32 0 29.792 20.448 54.592 48 61.728v36.512c-27.552 7.168-48 31.968-48 61.76s20.448 54.592 48 61.728v34.272h-16c-17.664 0-32 14.336-32 32v64h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64v192c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-192h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-64v-64c0-17.664-14.336-32-32-32h-16v-34.272c27.552-7.136 48-31.936 48-61.728s-20.448-54.592-48-61.728v-36.512c27.552-7.168 48-31.968 48-61.76 0-11.84-3.456-22.816-9.056-32.32l40.736-40.736c9.504 5.6 20.48 9.056 32.32 9.056 35.36 0 64-28.64 64-64 0-11.84-3.456-22.816-9.056-32.32l40.736-40.736c9.504 5.6 20.48 9.056 32.32 9.056 35.36 0 64-28.64 64-64s-28.64-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pray",
						"believe",
						"worship",
						"hope"
					],
					"grid": 32
				},
				{
					"id": 701,
					"width": 1024,
					"paths": [
						"M624 400c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM624 464c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM624 528c0 8.832-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16zM864 160h-224c0-53.024-42.976-96-96-96h-64c-53.024 0-96 42.976-96 96h-224c-53.024 0-96 42.976-96 96v416c0 53.024 42.976 96 96 96h195.744l-81.472 135.776c-4.576 7.584-2.080 17.408 5.504 21.952 2.56 1.536 5.408 2.272 8.224 2.272 5.408 0 10.72-2.752 13.728-7.776l91.328-152.224h102.944v144c0 8.832 7.168 16 16 16s16-7.168 16-16v-144h102.944l91.328 152.224c3.008 5.024 8.32 7.776 13.728 7.776 2.816 0 5.664-0.736 8.224-2.272 7.584-4.544 10.048-14.368 5.504-21.952l-81.472-135.776h195.744c53.024 0 96-42.976 96-96v-416c0-53.024-42.976-96-96-96zM416 160c0-35.296 28.704-64 64-64h64c35.296 0 64 28.704 64 64v32h-192v-32zM928 672c0 35.296-28.704 64-64 64h-704c-35.296 0-64-28.704-64-64v-416c0-35.296 28.704-64 64-64h224c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32h224c35.296 0 64 28.704 64 64v416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"present",
						"share",
						"speak"
					],
					"grid": 32
				},
				{
					"id": 702,
					"width": 1024,
					"paths": [
						"M384 192v-32c0-53.024 42.976-96 96-96h64c53.024 0 96 42.976 96 96v32c0 17.664-14.336 32-32 32h-192c-17.664 0-32-14.336-32-32zM960 256v416c0 53.024-42.976 96-96 96h-195.744l81.472 135.776c4.576 7.584 2.080 17.408-5.504 21.952-2.56 1.536-5.408 2.272-8.224 2.272-5.408 0-10.72-2.752-13.728-7.776l-91.328-152.224h-102.944v144c0 8.832-7.168 16-16 16s-16-7.168-16-16v-144h-102.944l-91.328 152.224c-3.008 5.024-8.32 7.776-13.728 7.776-2.816 0-5.664-0.736-8.224-2.272-7.584-4.544-10.048-14.368-5.504-21.952l81.472-135.776h-195.744c-53.024 0-96-42.976-96-96v-416c0-53.024 42.976-96 96-96h192v32c0 35.296 28.704 64 64 64h192c35.296 0 64-28.704 64-64v-32h192c53.024 0 96 42.976 96 96zM624 528c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16zM624 464c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16zM624 400c0-8.832-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"present",
						"share",
						"speak"
					],
					"grid": 32
				},
				{
					"id": 1087,
					"width": 1024,
					"paths": [
						"M171.328 587.328l-22.624-22.624 235.296-235.328 160 160 265.376-265.376h-73.376v-32h128v128h-32v-73.376l-288 288-160-160-212.672 212.704zM992 96v608c0 17.664-14.336 32-32 32h-256v32c0 17.664-14.336 32-32 32h-64v64h160c17.664 0 32 14.336 32 32v96c0 17.664-14.336 32-32 32h-480c-17.664 0-32-14.336-32-32v-96c0-17.664 14.336-32 32-32h128v-64h-64c-17.664 0-32-14.336-32-32v-32h-256c-17.664 0-32-14.336-32-32v-608c0-17.664 14.336-32 32-32h320v-32c0-17.664 14.336-32 32-32h192c17.664 0 32 14.336 32 32v32h320c17.664 0 32 14.336 32 32zM448 96h128v-32h-128v32zM320 928v32h416v-32h-416zM544 896v-128h-64v128h64zM640 704h-256v32h256v-32zM928 128h-832v544h832v-544z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"present",
						"share",
						"speak",
						"trend"
					],
					"grid": 32
				},
				{
					"id": 1905,
					"paths": [
						"M912 0h-864c-26.4 0-48 21.6-48 48v736c0 26.4 21.6 48 48 48h285.088l-130.544 130.544c-14.058 14.058-14.058 36.852 0 50.91 7.030 7.030 16.244 10.546 25.456 10.546s18.426-3.516 25.456-10.544l181.456-181.456h13.088v160c0 17.674 14.328 32 32 32s32-14.326 32-32v-160h13.090l181.456 181.456c7.028 7.028 16.242 10.544 25.454 10.544s18.426-3.516 25.456-10.544c14.060-14.058 14.060-36.852 0-50.91l-130.546-130.546h285.090c26.4 0 48-21.6 48-48v-736c0-26.4-21.6-48-48-48zM384 192l256 160-256 160v-320zM800 704h-640c-17.672 0-32-14.326-32-32s14.328-32 32-32h640c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"presentation",
						"board-play"
					],
					"defaultCode": 59740,
					"grid": 16
				},
				{
					"id": 703,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 928c-229.376 0-416-186.624-416-416s186.624-416 416-416 416 186.624 416 416-186.624 416-416 416zM512 128c-159.072 0-288 128.928-288 288v96c0 158.816 129.184 288 288 288s288-129.184 288-288v-96c0-159.072-128.928-288-288-288zM512 160c141.152 0 256 114.848 256 256s-114.848 256-256 256c-141.152 0-256-114.848-256-256s114.848-256 256-256zM512 768c-126.4 0-231.424-92.16-252.064-212.768 49.088 88.672 143.52 148.768 252.064 148.768s202.976-60.096 252.064-148.768c-20.64 120.608-125.664 212.768-252.064 212.768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"press",
						"push"
					],
					"grid": 32
				},
				{
					"id": 704,
					"width": 1024,
					"paths": [
						"M768 416c0 141.152-114.848 256-256 256s-256-114.848-256-256c0-141.152 114.848-256 256-256s256 114.848 256 256zM960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448 200.576-448 448-448 448 200.576 448 448zM800 416c0-159.072-128.928-288-288-288s-288 128.928-288 288v96c0 158.816 129.184 288 288 288s288-129.184 288-288v-96zM512 704c-108.544 0-202.976-60.096-252.064-148.768 20.64 120.608 125.664 212.768 252.064 212.768s231.424-92.16 252.064-212.768c-49.088 88.672-143.52 148.768-252.064 148.768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"press",
						"push"
					],
					"grid": 32
				},
				{
					"id": 705,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 928c-229.376 0-416-186.624-416-416s186.624-416 416-416 416 186.624 416 416-186.624 416-416 416zM544 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM512 128c-35.296 0-64 28.704-64 64s28.704 64 64 64c35.296 0 64-28.704 64-64s-28.704-64-64-64zM512 224c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.336 32-32 32zM832 448c-35.296 0-64 28.704-64 64s28.704 64 64 64c35.296 0 64-28.704 64-64s-28.704-64-64-64zM832 544c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.336 32-32 32zM256 512c0-35.296-28.704-64-64-64s-64 28.704-64 64c0 35.296 28.704 64 64 64s64-28.704 64-64zM160 512c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM853.12 352c0-35.296-28.704-64-64-64s-64 28.704-64 64c0 35.296 28.704 64 64 64s64-28.704 64-64zM757.12 352c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM671.968 170.88c-35.296 0-64 28.704-64 64s28.704 64 64 64c35.296 0 64-28.704 64-64s-28.704-64-64-64zM671.968 266.88c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.304 32-32 32zM352 298.88c35.296 0 64-28.704 64-64s-28.704-64-64-64c-35.296 0-64 28.704-64 64s28.704 64 64 64zM352 202.88c17.664 0 32 14.336 32 32s-14.336 32-32 32c-17.664 0-32-14.336-32-32 0-17.696 14.336-32 32-32zM234.88 416c35.296 0 64-28.704 64-64s-28.704-64-64-64c-35.296 0-64 28.704-64 64s28.704 64 64 64zM234.88 320c17.664 0 32 14.336 32 32s-14.336 32-32 32c-17.664 0-32-14.336-32-32s14.304-32 32-32zM234.88 608c-35.296 0-64 28.704-64 64s28.704 64 64 64c35.296 0 64-28.704 64-64s-28.704-64-64-64zM234.88 704c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.336 32-32 32zM352.032 725.12c-35.296 0-64 28.704-64 64s28.704 64 64 64c35.296 0 64-28.704 64-64s-28.736-64-64-64zM352.032 821.12c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32 0 17.696-14.336 32-32 32zM704 789.12c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM821.12 672c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32 17.696 0 32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"prevent",
						"medicate",
						"control",
						"choose"
					],
					"grid": 32
				},
				{
					"id": 706,
					"width": 1024,
					"paths": [
						"M192 544c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.336 32-32 32zM671.968 202.88c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32 0-17.696-14.304-32-32-32zM234.88 384c17.664 0 32-14.336 32-32s-14.336-32-32-32c-17.664 0-32 14.336-32 32s14.304 32 32 32zM352.032 757.12c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32s-14.336-32-32-32zM512 160c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32s-14.336-32-32-32zM821.12 352c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32 17.696 0 32-14.336 32-32zM234.88 640c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32s-14.336-32-32-32zM832 480c-17.664 0-32 14.336-32 32s14.336 32 32 32c17.664 0 32-14.336 32-32s-14.336-32-32-32zM960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448 200.576-448 448-448 448 200.576 448 448zM288 234.88c0 35.296 28.704 64 64 64s64-28.704 64-64c0-35.296-28.704-64-64-64s-64 28.704-64 64zM170.88 352c0 35.296 28.704 64 64 64s64-28.704 64-64c0-35.296-28.704-64-64-64s-64 28.704-64 64zM192 576c35.296 0 64-28.704 64-64s-28.704-64-64-64c-35.296 0-64 28.704-64 64s28.704 64 64 64zM298.88 672c0-35.296-28.704-64-64-64s-64 28.704-64 64c0 35.296 28.704 64 64 64s64-28.704 64-64zM416.032 789.12c0-35.296-28.704-64-64-64s-64 28.704-64 64c0 35.296 28.704 64 64 64 35.264 0 64-28.704 64-64zM544 832c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM576 192c0-35.296-28.704-64-64-64s-64 28.704-64 64c0 35.296 28.704 64 64 64s64-28.704 64-64zM704 789.12c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.304 32-32zM735.968 234.88c0-35.296-28.704-64-64-64s-64 28.704-64 64c0 35.296 28.704 64 64 64s64-28.704 64-64zM789.12 416c35.296 0 64-28.704 64-64s-28.704-64-64-64c-35.296 0-64 28.704-64 64s28.704 64 64 64zM821.12 672c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32 17.696 0 32-14.336 32-32zM896 512c0-35.296-28.704-64-64-64s-64 28.704-64 64c0 35.296 28.704 64 64 64s64-28.704 64-64zM352 266.88c17.664 0 32-14.336 32-32s-14.336-32-32-32c-17.664 0-32 14.336-32 32s14.336 32 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"prevent",
						"medicate",
						"control",
						"choose"
					],
					"grid": 32
				},
				{
					"id": 2966,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z",
						"M448 512l256-192v384z",
						"M320 320h128v384h-128v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"previous",
						"player"
					],
					"defaultCode": 60801,
					"grid": 16
				},
				{
					"id": 2977,
					"paths": [
						"M256 896v-768h128v352l320-320v704l-320-320v352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"previous",
						"player"
					],
					"defaultCode": 60812,
					"grid": 16
				},
				{
					"id": 2050,
					"paths": [
						"M384 512h64v128h-64zM512 704h64v128h-64zM800.886 286.058l-231.104-252.116c-17.114-18.668-50.914-33.942-75.116-33.942h-29.334c-24.2 0-58 15.274-75.112 33.942l-231.106 252.116c-17.114 18.668-31.114 55.542-31.114 81.942v608c0 26.4 19.8 48 44 48h616c24.202 0 44-21.6 44-48v-608c0-26.4-14-63.274-31.114-81.942zM640 512h-128v128h128v256h-128v64h-64v-64h-128v-64h128v-128h-128v-256h128v-64h64v64h128v64zM530 160c0 27.614-22.386 50-50 50s-50-22.386-50-50 22.386-50 50-50 50 22.386 50 50z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"price-tag"
					],
					"defaultCode": 59885,
					"grid": 16
				},
				{
					"id": 2051,
					"paths": [
						"M976 0h-384c-26.4 0-63.274 15.274-81.942 33.942l-476.116 476.116c-18.668 18.668-18.668 49.214 0 67.882l412.118 412.118c18.668 18.668 49.214 18.668 67.882 0l476.118-476.118c18.666-18.666 33.94-55.54 33.94-81.94v-384c0-26.4-21.6-48-48-48zM736 384c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"price-tag"
					],
					"defaultCode": 59886,
					"grid": 16
				},
				{
					"id": 2053,
					"paths": [
						"M960 64v368c0 9.44-8.522 30.012-15.196 36.686l-464.804 464.804-389.49-389.49 464.804-464.804c6.674-6.674 27.246-15.196 36.686-15.196h368zM976 0h-384c-26.4 0-63.274 15.274-81.942 33.942l-476.116 476.116c-18.668 18.668-18.668 49.214 0 67.882l412.118 412.118c9.334 9.334 21.638 14 33.942 14s24.608-4.666 33.942-14l476.118-476.118c18.664-18.666 33.938-55.54 33.938-81.94v-384c0-26.4-21.6-48-48-48v0z",
						"M832 288c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"price-tag"
					],
					"defaultCode": 59888,
					"grid": 16
				},
				{
					"id": 2055,
					"paths": [
						"M990.058 510.058l-284.116-284.116c-18.668-18.668-55.542-33.942-81.942-33.942h-576c-26.4 0-48 21.6-48 48v608c0 26.4 21.6 48 48 48h576c26.4 0 63.274-15.274 81.942-33.942l284.118-284.118c18.666-18.666 18.666-49.214-0.002-67.882zM672 640c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"price-tag"
					],
					"defaultCode": 59890,
					"grid": 16
				},
				{
					"id": 2057,
					"paths": [
						"M624 256c9.44 0 30.012 8.522 36.686 15.196l272.804 272.804-272.804 272.804c-6.674 6.674-27.246 15.196-36.686 15.196h-560v-576h560zM624 192h-576c-26.4 0-48 21.6-48 48v608c0 26.4 21.6 48 48 48h576c26.4 0 63.274-15.274 81.942-33.942l284.118-284.118c18.668-18.668 18.668-49.214 0-67.882l-284.118-284.116c-18.668-18.668-55.542-33.942-81.942-33.942v0z",
						"M768 544c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"price-tag"
					],
					"defaultCode": 59892,
					"grid": 16
				},
				{
					"id": 2052,
					"width": 1280,
					"paths": [
						"M1232 0h-384c-26.4 0-63.274 15.274-81.942 33.942l-476.116 476.116c-18.668 18.668-18.668 49.214 0 67.882l412.118 412.118c18.668 18.668 49.214 18.668 67.882 0l476.118-476.118c18.666-18.666 33.94-55.54 33.94-81.94v-384c0-26.4-21.6-48-48-48zM992 384c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z",
						"M128 544l544-544h-80c-26.4 0-63.274 15.274-81.942 33.942l-476.116 476.116c-18.668 18.668-18.668 49.214 0 67.882l412.118 412.118c18.668 18.668 49.214 18.668 67.882 0l30.058-30.058-416-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"price-tags"
					],
					"defaultCode": 59887,
					"grid": 16
				},
				{
					"id": 2054,
					"width": 1280,
					"paths": [
						"M1216 64v368c0 9.44-8.522 30.012-15.196 36.686l-464.804 464.804-389.49-389.49 464.804-464.804c6.674-6.674 27.246-15.196 36.686-15.196h368zM1232 0h-384c-26.4 0-63.274 15.274-81.942 33.942l-476.116 476.116c-18.668 18.668-18.668 49.214 0 67.882l412.118 412.118c9.334 9.334 21.636 14 33.942 14s24.608-4.666 33.942-14l476.118-476.118c18.664-18.666 33.938-55.54 33.938-81.94v-384c0-26.4-21.6-48-48-48v0z",
						"M1088 288c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M634.512 0h-42.512c-26.4 0-63.274 15.274-81.942 33.942l-476.116 476.116c-18.668 18.668-18.668 49.214 0 67.882l412.118 412.118c9.334 9.334 21.638 14 33.942 14s24.608-4.666 33.942-14l11.312-11.312-434.746-434.746 544.002-544z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"price-tags"
					],
					"defaultCode": 59889,
					"grid": 16
				},
				{
					"id": 2056,
					"width": 1152,
					"paths": [
						"M1118.058 638.058l-284.116-284.116c-18.668-18.668-55.542-33.942-81.942-33.942h-576c-26.4 0-48 21.6-48 48v608c0 26.4 21.6 48 48 48h576c26.4 0 63.274-15.274 81.942-33.942l284.118-284.118c18.666-18.666 18.666-49.214-0.002-67.882zM800 768c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z",
						"M64 256h672l-30.058-30.058c-18.668-18.668-55.542-33.942-81.942-33.942h-576c-26.4 0-48 21.6-48 48v608c0 26.4 21.6 48 48 48h16v-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"price-tags"
					],
					"defaultCode": 59891,
					"grid": 16
				},
				{
					"id": 2058,
					"width": 1152,
					"paths": [
						"M752 384c9.44 0 30.012 8.522 36.686 15.196l272.804 272.804-272.804 272.804c-6.674 6.674-27.246 15.196-36.686 15.196h-560v-576h560zM752 320h-576c-26.4 0-48 21.6-48 48v608c0 26.4 21.6 48 48 48h576c26.4 0 63.274-15.274 81.942-33.942l284.118-284.118c18.668-18.668 18.668-49.214 0-67.882l-284.118-284.116c-18.668-18.668-55.542-33.942-81.942-33.942v0z",
						"M896 672c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M64 832v-576h672l-30.058-30.058c-18.668-18.668-55.542-33.942-81.942-33.942h-576c-26.4 0-48 21.6-48 48v608c0 26.4 21.6 48 48 48h16v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"price-tags"
					],
					"defaultCode": 59893,
					"grid": 16
				},
				{
					"id": 707,
					"width": 1024,
					"paths": [
						"M896 384h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-16c0-12.096-2.88-23.424-7.68-33.696l18.976-18.976c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-15.744 15.744c-10.336-9.216-22.848-15.968-36.928-18.848v-17.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v17.6c-13.824 2.816-26.112 9.408-36.352 18.336l-15.264-15.264c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l18.304 18.304c-5.024 10.464-8.064 22.048-8.064 34.4v16h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v41.376l-4.672-4.672c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l17.504 17.504c-8.8 11.552-22.56 19.168-38.208 19.168s-29.408-7.616-38.176-19.2l17.504-17.504c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-4.704 4.704v-73.376h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-48c0-5.472-1.024-10.688-1.6-16h17.6c8.832 0 16-7.168 16-16s-7.168-16-16-16h-24.832c-7.168-20.16-18.176-38.432-32.928-53.312l15.392-15.392c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-17.984 17.984c-18.016-11.424-38.784-18.56-61.024-21.056v-17.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v17.6c-21.984 2.464-42.464 9.472-60.32 20.704l-17.632-17.632c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l14.816 14.816c-15.008 14.976-26.176 33.504-33.408 53.888h-24.832c-8.832 0-16 7.168-16 16s7.168 16 16 16h17.6c-0.576 5.312-1.6 10.528-1.6 16v48h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v64h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v73.376l-4.672-4.672c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l17.504 17.504c-8.8 11.552-22.56 19.168-38.208 19.168-12 0-22.816-4.544-31.232-11.84 1.824-0.768 3.552-1.856 5.056-3.36l21.504-21.504c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-19.84 19.84c-0.512-2.752-0.864-5.6-0.864-8.512v-48h32c8.832 0 16-7.168 16-16s-7.168-16-16-16h-32v-64h32c8.832 0 16-7.168 16-16s-7.168-16-16-16h-32v-16c0-9.696-1.984-18.88-5.152-27.488 0.192 0 0.352 0.096 0.512 0.096 4.096 0 8.192-1.568 11.328-4.672l20.64-20.64c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-20.64 20.64c-1.184 1.184-1.92 2.592-2.656 4-11.424-13.856-27.168-24-45.408-27.712v-17.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v17.6c-13.824 2.816-26.112 9.44-36.352 18.368l-15.264-15.296c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l18.304 18.304c-5.024 10.464-8.064 22.048-8.064 34.4v16h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v64h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v64h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v32c0 10.912 1.12 21.568 2.88 32h-18.88c-8.832 0-16 7.168-16 16s7.168 16 16 16h27.168c7.712 21.824 19.136 41.888 33.696 59.264l-20.224 20.224c-6.24 6.24-6.24 16.384 0 22.624 3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672l20.16-20.16c17.664 15.104 38.144 26.976 60.544 34.88v27.168c0 8.832 7.168 16 16 16s16-7.168 16-16v-18.88c10.432 1.76 21.088 2.88 32 2.88 10.24 0 19.776 2.624 28.384 6.912l-18.144 18.112c-6.24 6.24-6.24 16.384 0 22.624 3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672l19.84-19.84c7.072 10.304 11.264 22.752 11.264 36.192v32h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v64h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h21.888c13.216 37.216 48.384 64 90.112 64h96c41.728 0 76.896-26.784 90.112-64h21.888c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-32c0-10.304 2.656-19.904 6.976-28.512l18.336 18.336c3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-20-20c10.24-7.072 22.624-11.2 36.032-11.2 10.912 0 21.568-1.12 32-2.88v18.88c0 8.832 7.168 16 16 16s16-7.168 16-16v-27.168c22.56-8 43.168-19.968 60.96-35.264 0.032 0.064 0.064 0.128 0.096 0.16l20.64 20.64c3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-20.64-20.64c-0.096-0.096-0.192-0.096-0.256-0.192 14.464-17.312 25.76-37.248 33.408-58.944h27.136c8.832 0 16-7.168 16-16s-7.168-15.968-16-15.968h-18.88c1.76-10.432 2.88-21.088 2.88-32v-32zM704 576c-52.928 0-96 43.072-96 96v224c0 35.296-28.704 64-64 64h-96c-35.296 0-64-28.704-64-64v-128c0-52.928-43.072-96-96-96-88.224 0-160-71.776-160-160v-272c0-26.464 21.536-48 48-48s48 21.536 48 48v192c0 44.096 35.904 80 80 80s80-35.904 80-80v-256c0-61.76 50.24-112 112-112s112 50.24 112 112v160c0 44.096 35.904 80 80 80s80-35.904 80-80v-96c0-26.464 21.536-48 48-48s48 21.536 48 48v176c0 88.224-71.776 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"prick",
						"grow",
						"stand"
					],
					"grid": 32
				},
				{
					"id": 708,
					"width": 1024,
					"paths": [
						"M896 384h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-16c0-12.096-2.88-23.424-7.68-33.696l18.976-18.976c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-15.744 15.744c-10.336-9.216-22.848-15.968-36.928-18.848v-17.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v17.6c-13.824 2.816-26.112 9.408-36.352 18.336l-15.264-15.264c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l18.304 18.304c-5.024 10.464-8.064 22.048-8.064 34.4v16h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v41.376l-4.672-4.672c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l17.504 17.504c-8.8 11.552-22.56 19.168-38.208 19.168s-29.408-7.616-38.176-19.2l17.504-17.504c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-4.704 4.704v-73.376h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-48c0-5.472-1.024-10.688-1.6-16h17.6c8.832 0 16-7.168 16-16s-7.168-16-16-16h-24.832c-7.168-20.16-18.176-38.432-32.928-53.312l15.392-15.392c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-17.984 17.984c-18.016-11.424-38.784-18.56-61.024-21.056v-17.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v17.6c-21.984 2.464-42.464 9.472-60.32 20.704l-17.632-17.632c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l14.816 14.816c-15.008 14.976-26.176 33.504-33.408 53.888h-24.832c-8.832 0-16 7.168-16 16s7.168 16 16 16h17.6c-0.576 5.312-1.6 10.528-1.6 16v48h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v64h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v73.376l-4.672-4.672c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l17.504 17.504c-8.8 11.552-22.56 19.168-38.208 19.168-12 0-22.816-4.544-31.232-11.84 1.824-0.768 3.552-1.856 5.056-3.36l21.504-21.504c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-19.84 19.84c-0.512-2.752-0.864-5.6-0.864-8.512v-48h32c8.832 0 16-7.168 16-16s-7.168-16-16-16h-32v-64h32c8.832 0 16-7.168 16-16s-7.168-16-16-16h-32v-16c0-9.696-1.984-18.88-5.152-27.488 0.192 0 0.352 0.096 0.512 0.096 4.096 0 8.192-1.568 11.328-4.672l20.64-20.64c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-20.64 20.64c-1.184 1.184-1.92 2.592-2.656 4-11.424-13.856-27.168-24-45.408-27.712v-17.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v17.6c-13.824 2.816-26.112 9.44-36.352 18.368l-15.264-15.296c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l18.304 18.304c-5.024 10.464-8.064 22.048-8.064 34.4v16h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v64h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v64h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v32c0 10.912 1.12 21.568 2.88 32h-18.88c-8.832 0-16 7.168-16 16s7.168 16 16 16h27.168c7.712 21.824 19.136 41.888 33.696 59.264l-20.224 20.224c-6.24 6.24-6.24 16.384 0 22.624 3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672l20.16-20.16c17.664 15.104 38.144 26.976 60.544 34.88v27.168c0 8.832 7.168 16 16 16s16-7.168 16-16v-18.88c10.432 1.76 21.088 2.88 32 2.88 10.24 0 19.776 2.624 28.384 6.912l-18.144 18.112c-6.24 6.24-6.24 16.384 0 22.624 3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672l19.84-19.84c7.072 10.304 11.264 22.752 11.264 36.192v32h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v64h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h21.888c13.216 37.216 48.384 64 90.112 64h96c41.728 0 76.896-26.784 90.112-64h21.888c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-64h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-32c0-10.304 2.656-19.904 6.976-28.512l18.336 18.336c3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-20-20c10.24-7.072 22.624-11.2 36.032-11.2 10.912 0 21.568-1.12 32-2.88v18.88c0 8.832 7.168 16 16 16s16-7.168 16-16v-27.168c22.56-8 43.168-19.968 60.96-35.264 0.032 0.064 0.064 0.128 0.096 0.16l20.64 20.64c3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-20.64-20.64c-0.096-0.096-0.192-0.096-0.256-0.192 14.464-17.312 25.76-37.248 33.408-58.944h27.136c8.832 0 16-7.168 16-16s-7.168-15.968-16-15.968h-18.88c1.76-10.432 2.88-21.088 2.88-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"prick",
						"grow",
						"stand"
					],
					"grid": 32
				},
				{
					"id": 1088,
					"width": 1024,
					"paths": [
						"M480 512h32v32h-32v-32zM512 448h32v-32h-32v32zM512 320h-32v32h32v-32zM512 256h32v-32h-32v32zM512 128h-32v32h32v-32zM768 224v64h32v32h-32c0 77.28-55.072 141.92-128 156.768v35.232h32v32h-32v32h128c17.664 0 32 14.336 32 32v96c0 17.664-14.336 32-32 32h-39.744l-16 128h23.744c17.664 0 32 14.336 32 32v96c0 17.664-14.336 32-32 32h-448c-17.664 0-32-14.336-32-32v-96c0-17.664 14.336-32 32-32h23.744l-16-128h-39.744c-17.664 0-32-14.336-32-32v-96c0-17.664 14.336-32 32-32h128v-3.232c-72.928-14.848-128-79.488-128-156.768h-32v-32h32v-64h-32v-32h32.352c1.792-45.12 32.608-85.856 77.184-94.272 17.856-3.36 35.040-1.696 50.464 3.744v-37.472h-32v-32h32.512c2.688-62.912 47.808-118.816 110.592-126.912 69.088-8.896 129.376 37.728 142.336 101.344 16-6.208 34.144-8.224 52.896-4.704 44.704 8.352 75.808 49.024 77.376 94.272h32.288v32h-32zM704 928h-384v32h384v-32zM380.256 896h263.488l24-192h-311.488l24 192zM288 640v32h448v-32h-448zM704 192c0-17.664-14.368-32-32-32s-32 14.336-32 32v128c0 17.664-14.336 32-32 32h-32v-224c0-35.296-28.704-64-64-64s-64 28.704-64 64v320h-32c-17.664 0-32-14.336-32-32v-128c0-17.664-14.368-32-32-32s-32 14.336-32 32v128c0 52.928 43.072 96 96 96h32v96h128v-192h32c52.928 0 96-43.072 96-96v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"prick",
						"grow",
						"stand"
					],
					"grid": 32
				},
				{
					"id": 709,
					"width": 1024,
					"paths": [
						"M928.096 98.496l-0.224-0.224c-27.904-27.904-64.608-41.984-101.408-41.984-34.112 0-68.288 12.096-95.584 36.512l-439.328 393.12c0 0-265.728 87.488-279.872 138.272-31.456 112.832 0.704 239.68 96.512 323.84 58.4 51.296 131.136 75.968 204.288 75.968 30.688 0 61.44-4.352 91.2-12.864 53.28-15.264 136.736-276.256 136.736-276.288l393.152-439.392c50.752-56.704 48.352-143.168-5.472-196.96zM394.88 980.352c-26.944 7.744-54.688 11.648-82.4 11.648-13.568 0-26.944-1.216-40.16-3.104l76.128-131.904c4.448-7.648 1.824-17.44-5.856-21.856-7.584-4.416-17.44-1.824-21.856 5.856l-81.6 141.376c-40.64-10.848-78.304-30.656-109.888-58.4-0.768-0.672-1.376-1.472-2.112-2.144l140.128-140.128c6.24-6.24 6.24-16.384 0-22.624s-16.384-6.24-22.624 0l-140 140.032c-29.184-32.576-50.112-70.528-61.76-111.264l142.464-82.24c7.648-4.416 10.272-14.176 5.856-21.856-4.416-7.648-14.144-10.336-21.856-5.856l-133.824 77.28c-6.336-39.424-4.48-80.512 6.592-120.928 15.872-23.584 133.056-74.848 240.864-111.68l220.992 220.992c-39.424 118.656-88.704 225.152-109.088 236.8zM517.792 712.16l-203.552-203.552 72.512-64.864 195.936 195.936-64.896 72.48zM909.728 274.112l-305.696 341.664-193.408-193.408 341.664-305.696c20.448-18.304 46.816-28.352 74.24-28.384 29.76 0 57.728 11.584 78.976 32.832 41.728 41.76 43.616 108.96 4.224 152.992z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"primp",
						"groom",
						"color"
					],
					"grid": 32
				},
				{
					"id": 710,
					"width": 1024,
					"paths": [
						"M605.536 662.080l-65.056 72.704-248.896-248.896 72.704-65.056 241.248 241.248zM928.096 98.496l-0.224-0.224c-27.904-27.904-64.608-41.984-101.408-41.984-34.112 0-68.288 12.096-95.584 36.512l-342.72 306.688 238.72 238.72 306.688-342.752c50.752-56.704 48.352-143.168-5.472-196.96zM529.056 768.64c-24.544 70.912-83.968 230.624-125.376 242.464-29.76 8.544-60.512 12.896-91.2 12.896-73.152 0-145.888-24.672-204.288-75.968-95.808-84.16-127.968-211.008-96.512-323.84 11.040-39.584 174.528-101.312 246.272-126.656l271.104 271.104zM188.672 702.72c7.648-4.416 10.272-14.176 5.856-21.856-4.416-7.648-14.144-10.336-21.856-5.856l-123.68 71.392c-6.080 3.488-9.152 10.528-7.616 17.376 2.368 10.496 14.24 15.712 23.584 10.336l123.712-71.392zM141.824 907.616l128.8-128.8c6.88-6.88 6.176-18.432-2.048-24.352-6.464-4.672-15.552-3.296-21.184 2.336l-128.192 128.192c-6.208 6.208-6.24 16.32-0.064 22.56v0c6.272 6.304 16.448 6.336 22.688 0.064zM345.92 832.288c-7.584-4.416-17.44-1.824-21.856 5.856l-70.432 122.016c-5.472 9.504 0 21.568 10.752 23.68v0c6.72 1.312 13.504-1.76 16.928-7.68l70.432-121.984c4.48-7.68 1.856-17.472-5.824-21.888z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"primp",
						"groom",
						"color"
					],
					"grid": 32
				},
				{
					"id": 1089,
					"width": 1024,
					"paths": [
						"M672 544v-192c0-17.664-14.336-32-32-32v-276.16c0-21.664-21.088-37.088-41.76-30.464l-192 61.408c-13.248 4.224-22.24 16.544-22.24 30.464v214.752c-17.664 0-32 14.336-32 32v192c-17.664 0-32 14.336-32 32v416c0 17.664 14.336 32 32 32h320c17.664 0 32-14.336 32-32v-416c0-17.664-14.336-32-32-32zM448 128l128-39.232v231.232h-128v-192zM416 352h192v192h-128v-160h-32v160h-32v-192zM640 960h-192v-352h-32v352h-32v-384h256v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"primp",
						"groom"
					],
					"grid": 32
				},
				{
					"id": 1223,
					"width": 950.8590908050537,
					"paths": [
						"M219.429 877.714h512v-146.286h-512v146.286zM219.429 512h512v-219.429h-91.429q-22.857 0-38.857-16t-16-38.857v-91.429h-365.714v365.714zM877.714 548.571q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM950.857 548.571v237.714q0 7.429-5.429 12.857t-12.857 5.429h-128v91.429q0 22.857-16 38.857t-38.857 16h-548.571q-22.857 0-38.857-16t-16-38.857v-91.429h-128q-7.429 0-12.857-5.429t-5.429-12.857v-237.714q0-45.143 32.286-77.429t77.429-32.286h36.571v-310.857q0-22.857 16-38.857t38.857-16h384q22.857 0 50.286 11.429t43.429 27.429l86.857 86.857q16 16 27.429 43.429t11.429 50.286v146.286h36.571q45.143 0 77.429 32.286t32.286 77.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"print"
					],
					"defaultCode": 61487,
					"grid": 14
				},
				{
					"id": 711,
					"width": 1024,
					"paths": [
						"M592 704h-160c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16zM592 736h-160c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h160c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM592 800h-160c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h160c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16zM992 352v256c0 53.024-42.976 96-96 96h-32v160c0 53.024-42.976 96-96 96h-512c-53.024 0-96-42.976-96-96v-160h-32c-53.024 0-96-42.976-96-96v-256c0-53.024 42.976-96 96-96h32v-96c0-53.024 42.976-96 96-96h512c53.024 0 96 42.976 96 96v96h32c53.024 0 96 42.976 96 96zM192 256h640v-96c0-35.36-28.64-64-64-64h-512c-35.36 0-64 28.64-64 64v96zM832 576h-640v288c0 35.36 28.64 64 64 64h512c35.36 0 64-28.64 64-64v-288zM896 288h-768c-35.36 0-64 28.64-64 64v256c0 35.36 28.64 64 64 64h32v-96h-16c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h736c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16h-16v96h32c35.36 0 64-28.64 64-64v-256c0-35.36-28.64-64-64-64zM160 400c0-26.496 21.504-48 48-48s48 21.504 48 48-21.504 48-48 48-48-21.504-48-48zM192 400c0 8.832 7.168 16 16 16s16-7.168 16-16-7.168-16-16-16-16 7.168-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"print",
						"publish"
					],
					"grid": 32
				},
				{
					"id": 712,
					"width": 1024,
					"paths": [
						"M160 224v-64c0-53.024 42.976-96 96-96h512c53.024 0 96 42.976 96 96v64h-704zM992 352v256c0 53.024-42.976 96-96 96v-128h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-800c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v128c-53.024 0-96-42.976-96-96v-256c0-53.024 42.976-96 96-96h768c53.024 0 96 42.976 96 96zM256 400c0-26.496-21.504-48-48-48s-48 21.504-48 48 21.504 48 48 48 48-21.504 48-48zM208 384c-8.832 0-16 7.168-16 16s7.168 16 16 16 16-7.168 16-16-7.168-16-16-16zM160 864v-288h704v288c0 53.024-42.976 96-96 96h-512c-53.024 0-96-42.976-96-96zM416 688c0 8.832 7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16zM416 752c0 8.832 7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16zM416 816c0 8.832 7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"print",
						"publish"
					],
					"grid": 32
				},
				{
					"id": 1090,
					"width": 1024,
					"paths": [
						"M992 320h-160v-288c0-17.664-14.336-32-32-32h-576c-17.664 0-32 14.336-32 32v288h-160c-17.664 0-32 14.336-32 32v384c0 17.664 14.336 32 32 32h160v224c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-224h160c17.664 0 32-14.336 32-32v-384c0-17.664-14.336-32-32-32zM256 64h512v288h-512v-288zM256 608h512v352h-512v-352zM960 704h-160v-96c0-17.664-14.336-32-32-32h-512c-17.664 0-32 14.336-32 32v96h-160v-320h896v320zM128 448h32v32h-32v-32zM192 448h32v32h-32v-32zM320 672h384v32h-384v-32zM320 768h384v32h-384v-32zM320 864h384v32h-384v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"print",
						"publish"
					],
					"grid": 32
				},
				{
					"id": 2172,
					"paths": [
						"M1018.626 462.25l-128-192c-5.934-8.902-15.926-14.25-26.626-14.25h-96v-224c0-17.672-14.326-32-32-32h-448c-17.672 0-32 14.328-32 32v224h-96c-10.7 0-20.69 5.348-26.626 14.25l-128 192c-3.504 5.256-5.374 11.432-5.374 17.75v320c0 17.674 14.328 32 32 32h147.602l-49.96 149.88c-3.252 9.758-1.618 20.484 4.398 28.83 6.016 8.344 15.674 13.29 25.96 13.29h704c10.288 0 19.946-4.946 25.958-13.29 6.016-8.346 7.652-19.072 4.398-28.83l-49.96-149.88h147.604c17.674 0 32-14.326 32-32v-320c0-6.318-1.868-12.494-5.374-17.75zM320 64h384v256h-384v-256zM204.398 960l106.666-320h401.872l106.666 320h-615.204zM960 768h-136.936l-56.708-170.12c-4.354-13.066-16.582-21.88-30.356-21.88h-448c-13.774 0-26.002 8.814-30.358 21.88l-56.704 170.12h-136.938v-278.312l113.126-169.688h78.874v32c0 17.672 14.328 32 32 32h448c17.674 0 32-14.328 32-32v-32h78.876l113.124 169.688v278.312z",
						"M608 704h-192c-17.672 0-32 14.326-32 32s14.328 32 32 32h192c17.674 0 32-14.326 32-32s-14.326-32-32-32z",
						"M672 832h-320c-17.672 0-32 14.326-32 32s14.328 32 32 32h320c17.674 0 32-14.326 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"printer",
						"print"
					],
					"defaultCode": 60007,
					"grid": 16
				},
				{
					"id": 2173,
					"paths": [
						"M608 704h-192c-17.672 0-32 14.326-32 32s14.328 32 32 32h192c17.674 0 32-14.326 32-32s-14.326-32-32-32z",
						"M672 832h-320c-17.672 0-32 14.326-32 32s14.328 32 32 32h320c17.674 0 32-14.326 32-32s-14.326-32-32-32z",
						"M1018.626 462.25l-128-192c-5.934-8.902-15.926-14.25-26.626-14.25h-96v-224c0-17.672-14.326-32-32-32h-448c-17.672 0-32 14.328-32 32v224h-96c-10.7 0-20.69 5.348-26.626 14.25l-128 192c-3.504 5.256-5.374 11.432-5.374 17.75v320c0 17.674 14.328 32 32 32h147.602l-49.96 149.88c-3.252 9.758-1.618 20.484 4.398 28.83 6.016 8.344 15.674 13.29 25.96 13.29h704c10.288 0 19.946-4.946 25.958-13.29 6.016-8.346 7.652-19.072 4.398-28.83l-49.96-149.88h147.604c17.674 0 32-14.326 32-32v-320c0-6.318-1.868-12.494-5.374-17.75zM320 64h384v256h-384v-256zM204.398 960l106.666-320h401.872l106.666 320h-615.204z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"printer",
						"print"
					],
					"defaultCode": 60008,
					"grid": 16
				},
				{
					"id": 2174,
					"paths": [
						"M256 64h512v128h-512v-128z",
						"M960 256h-896c-35.2 0-64 28.8-64 64v320c0 35.2 28.794 64 64 64h192v256h512v-256h192c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM128 448c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64zM704 896h-384v-320h384v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"printer",
						"print"
					],
					"defaultCode": 60009,
					"grid": 16
				},
				{
					"id": 2175,
					"paths": [
						"M896 576v256h-768v-256h-128v384h1024v-384zM832 64h-640v704h640v-704zM704 640h-384v-64h384v64zM704 448h-384v-64h384v64zM704 256h-384v-64h384v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"printer",
						"print"
					],
					"defaultCode": 60010,
					"grid": 16
				},
				{
					"id": 123,
					"paths": [
						"M947.2 204.8h-76.8v-128c0-42.347-34.453-76.8-76.8-76.8h-563.2c-42.347 0-76.8 34.453-76.8 76.8v128h-76.8c-42.347 0-76.8 34.453-76.8 76.8v460.8c0 42.349 34.453 76.8 76.8 76.8h76.8v128c0 42.347 34.453 76.8 76.8 76.8h563.2c42.347 0 76.8-34.453 76.8-76.8v-128h76.8c42.349 0 76.8-34.451 76.8-76.8v-460.8c0-42.347-34.451-76.8-76.8-76.8zM204.8 76.8c0-14.115 11.485-25.6 25.6-25.6h563.2c14.115 0 25.6 11.485 25.6 25.6v128h-614.4v-128zM793.6 972.8h-563.2c-14.115 0-25.6-11.485-25.6-25.6v-332.8h614.4v332.8c0 14.115-11.485 25.6-25.6 25.6zM972.8 742.4c0 14.115-11.485 25.6-25.6 25.6h-76.8v-153.6h25.6c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-768c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h25.6v153.6h-76.8c-14.115 0-25.6-11.485-25.6-25.6v-460.8c0-14.115 11.485-25.6 25.6-25.6h870.4c14.115 0 25.6 11.485 25.6 25.6v460.8z",
						"M742.4 716.8h-460.8c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h460.8c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M742.4 819.2h-460.8c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h460.8c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M742.4 921.6h-460.8c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h460.8c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M844.8 460.8c-42.349 0-76.8-34.453-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.451 76.8-76.8 76.8zM844.8 358.4c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"printer",
						"print"
					],
					"defaultCode": 59420,
					"grid": 20
				},
				{
					"id": 1771,
					"width": 1024,
					"paths": [
						"M657.143 435.429q0 32-22.571 54.286t-54.571 22.286h-144.571v-153.714h144.571q32 0 54.571 22.571t22.571 54.571zM759.429 435.429q0-74.286-52.286-126.857t-127.143-52.571h-247.429v512h102.857v-153.714h144.571q74.286 0 126.857-52.286t52.571-126.571zM1024 512q0 104-40.571 198.857t-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571 198.857 40.571 163.429 109.143 109.143 163.429 40.571 198.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"product-hunt"
					],
					"defaultCode": 62088,
					"grid": 14
				},
				{
					"id": 1969,
					"paths": [
						"M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 576h448v64h-448zM256 704h448v64h-448zM320 288c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM480 384h-128c-52.8 0-96 28.8-96 64v64h320v-64c0-35.2-43.2-64-96-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"profile",
						"file",
						"document",
						"page",
						"user",
						"paper"
					],
					"defaultCode": 59804,
					"grid": 16
				},
				{
					"id": 713,
					"width": 1024,
					"paths": [
						"M543.68 65.6c0.032-0.576 0.32-1.024 0.32-1.6 0-17.664-14.336-32-32-32s-32 14.336-32 32c0 0.576 0.288 1.024 0.32 1.6-214.912 16.224-384.32 195.328-384.32 414.4v46.336c0 7.68 4.768 14.944 12.192 17.024 9.696 2.72 19.232-3.264 21.184-12.512 6.048-29.056 31.808-50.848 62.624-50.848s56.576 21.792 62.656 50.816c1.6 7.744 8.544 13.184 16.416 13.184h1.536c8.192 0 15.104-5.44 16.736-13.184 6.080-29.024 31.84-50.816 62.656-50.816s56.576 21.792 62.656 50.816c1.6 7.744 8.544 13.184 16.416 13.184h1.568c8.16 0 15.104-5.408 16.736-13.12 3.808-17.952 15.232-33.024 30.624-41.984v373.76c0 16.704-12.224 31.648-28.864 33.216-19.072 1.792-35.136-13.152-35.136-31.872v-3.616c0-15.68-12.704-28.384-28.384-28.384h-39.232c-15.744 0-28.416 12.896-28.384 28.608 0.128 68.832 53.056 128 121.824 131.232 73.504 3.488 134.176-55.104 134.176-127.84v-336c0 8.832 7.168 16 16 16h0.928c7.904 0 14.816-5.44 16.448-13.184 6.048-29.024 31.808-50.816 62.624-50.816s56.576 21.792 62.656 50.816c1.6 7.744 8.544 13.184 16.416 13.184h1.824c7.904 0 14.816-5.44 16.448-13.184 6.080-29.024 31.84-50.816 62.656-50.816 30.56 0 56.128 21.408 62.464 50.048 1.6 7.2 7.488 13.12 14.848 13.856 10.144 1.024 18.688-6.912 18.688-16.832v-47.072c0-219.072-169.408-398.176-384.32-414.4zM544 864c0 52.928-43.072 96-96 96s-96-43.072-96-96h32c0 35.296 28.704 64 64 64s64-28.704 64-64v-384c11.712 0 22.56 3.392 32 8.864v375.136zM832 448c-33.344 0-62.784 17.088-80 42.976-17.216-25.888-46.656-42.976-80-42.976s-62.784 17.088-80 42.976c-17.216-25.888-46.656-42.976-80-42.976s-62.784 17.088-80 42.976c-17.216-25.888-46.656-42.976-80-42.976s-62.784 17.088-80 42.976c-17.216-25.888-46.656-42.976-80-42.976-24.544 0-46.944 9.248-63.936 24.448 4.032-208.288 174.72-376.448 383.936-376.448s379.904 168.16 383.936 376.448c-16.992-15.2-39.392-24.448-63.936-24.448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"protect",
						"rain"
					],
					"grid": 32
				},
				{
					"id": 714,
					"width": 1024,
					"paths": [
						"M576 573.344v290.656c0 72.736-60.672 131.328-134.176 127.84-68.768-3.232-121.696-62.4-121.824-131.232-0.032-15.712 12.64-28.608 28.384-28.608h39.232c15.68 0 28.384 12.704 28.384 28.384v3.616c0 18.72 16.064 33.664 35.136 31.84 16.64-1.6 28.864-16.512 28.864-33.216v-323.552c0.16-0.608 0.544-1.088 0.672-1.696 3.072-14.688 16.256-25.376 31.328-25.376s28.256 10.688 31.328 25.376c3.616 17.28 16.448 30.656 32.672 35.968zM543.68 65.6c0.032-0.576 0.32-1.024 0.32-1.6 0-17.664-14.336-32-32-32s-32 14.336-32 32c0 0.576 0.288 1.024 0.32 1.6-214.912 16.224-384.32 195.328-384.32 414.4v46.336c0 7.68 4.768 14.944 12.192 17.024 9.696 2.72 19.232-3.264 21.184-12.512 6.048-29.056 31.808-50.848 62.624-50.848s56.576 21.792 62.656 50.816c1.6 7.744 8.544 13.184 16.416 13.184h1.536c8.192 0 15.104-5.44 16.736-13.184 6.080-29.024 31.84-50.816 62.656-50.816s56.576 21.792 62.656 50.816c1.6 7.744 8.544 13.184 16.416 13.184h1.568c8.16 0 15.104-5.408 16.736-13.12 3.808-17.952 15.232-33.024 30.624-41.984v-0.288c9.408-5.472 20.352-8.608 32-8.608 30.816 0 56.576 21.792 62.656 50.816 1.6 7.744 8.544 13.184 16.416 13.184h1.824c7.904 0 14.816-5.44 16.448-13.184 6.080-29.024 31.84-50.816 62.656-50.816s56.576 21.792 62.656 50.816c1.6 7.744 8.544 13.184 16.416 13.184h1.824c7.904 0 14.816-5.44 16.448-13.184 6.080-29.024 31.84-50.816 62.656-50.816 30.56 0 56.128 21.408 62.464 50.048 1.6 7.2 7.488 13.12 14.848 13.856 10.144 1.024 18.688-6.912 18.688-16.832v-47.072c0-219.072-169.408-398.176-384.32-414.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"protect",
						"rain"
					],
					"grid": 32
				},
				{
					"id": 715,
					"width": 1024,
					"paths": [
						"M368 304c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16zM544 416h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16zM576 352h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16zM896 128v768c0 53.024-42.976 96-96 96h-576c-53.024 0-96-42.976-96-96v-768c0-53.024 42.976-96 96-96h576c53.024 0 96 42.976 96 96zM704 960c35.296 0 64-28.704 64-64v-768c0-35.296-28.704-64-64-64h-480c-35.296 0-64 28.704-64 64v768c0 35.296 28.704 64 64 64h480zM864 128c0-35.296-28.704-64-64-64h-24.928c15.328 17.024 24.928 39.296 24.928 64v768c0 24.704-9.6 46.976-24.928 64h24.928c35.296 0 64-28.704 64-64v-768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"publish",
						"read"
					],
					"grid": 32
				},
				{
					"id": 716,
					"width": 1024,
					"paths": [
						"M896 128v768c0 53.024-42.976 96-96 96h-12.224c26.88-23.488 44.224-57.6 44.224-96v-768c0-38.4-17.344-72.512-44.224-96h12.224c53.024 0 96 42.976 96 96zM800 896c0 53.024-42.976 96-96 96h-480c-53.024 0-96-42.976-96-96v-768c0-53.024 42.976-96 96-96h480c53.024 0 96 42.976 96 96v768zM368 304c0 8.832 7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16zM560 432c0-8.832-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16zM592 368c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"publish",
						"read"
					],
					"grid": 32
				},
				{
					"id": 717,
					"width": 1024,
					"paths": [
						"M928 256h-832c-53.024 0-96 42.976-96 96 0 282.784 229.216 512 512 512s512-229.216 512-512c0-53.024-42.976-96-96-96zM496 767.2c-130.72-4.992-245.92-70.4-318.752-169.248l318.752-289.792v459.040zM528 308.16l318.752 289.76c-72.832 98.848-188.032 164.256-318.752 169.248v-459.008zM864.896 571.2l-311.52-283.2h374.624v64c0 80.48-23.36 155.456-63.104 219.2zM470.624 288l-311.52 283.2c-39.744-63.744-63.104-138.72-63.104-219.2v-64h374.624zM512 832c-264.672 0-480-215.328-480-480 0-23.584 12.96-44 32-55.104v55.104c0 247.424 200.576 448 448 448s448-200.576 448-448v-55.104c19.040 11.104 32 31.52 32 55.104 0 264.672-215.328 480-480 480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pucker",
						"eat",
						"squeeze",
						"suck"
					],
					"grid": 32
				},
				{
					"id": 718,
					"width": 1024,
					"paths": [
						"M177.856 598.752l318.144-290.496v458.912c-130.368-4.96-245.28-70.016-318.144-168.416zM505.792 256h-409.792v96c0 80.864 23.552 156.16 63.648 220.096l346.144-316.096zM846.144 598.752l-318.144-290.496v458.912c130.368-4.96 245.28-70.016 318.144-168.416zM960 261.888c0 29.568 0 59.712 0 90.112 0 247.424-200.576 448-448 448s-448-200.576-448-448c0-20.416 0-52.352 0-90.112-37.216 13.216-64 48.384-64 90.112 0 282.784 229.216 512 512 512s512-229.216 512-512c0-41.728-26.784-76.896-64-90.112zM928 256h-409.792l346.176 316.064c40.064-63.904 63.616-139.2 63.616-220.064v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pucker",
						"eat",
						"squeeze",
						"suck"
					],
					"grid": 32
				},
				{
					"id": 719,
					"width": 1024,
					"paths": [
						"M512 800c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM512 896c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM889.568 428.768c-20.864-28.032-64.448-76.768-114.816-76.768-56.96 0-105.216 62.304-121.792 86.496-14.112-12.64-29.632-23.52-46.656-32 21.856-37.376 38.848-77.024 49.76-118.496h4.96c66.208 0 123.648-44.832 139.712-109.088l13.824-55.296c6.432-25.728-9.216-51.776-34.944-58.176-3.904-0.96-7.808-1.44-11.648-1.44-21.504 0-41.088 14.56-46.528 36.384l-13.824 55.264c-4.512 18.048-18.976 30.88-36.544 34.688 0.416-8 0.928-15.936 0.928-23.968v-118.368c0-26.496-21.504-48-48-48s-48 21.504-48 48v118.368c0 75.68-22.24 148.256-64 210.976-41.76-62.72-64-135.328-64-210.976v-118.368c0-26.496-21.504-48-48-48s-48 21.504-48 48v118.368c0 8.032 0.512 15.968 0.928 23.936-17.568-3.808-32.064-16.64-36.544-34.656l-13.824-55.264c-5.44-21.824-24.992-36.384-46.528-36.384-3.84 0-7.744 0.48-11.648 1.44-25.728 6.4-41.376 32.48-34.944 58.176l13.824 55.328c16.064 64.224 73.472 109.056 139.712 109.056h4.96c10.912 41.504 27.904 81.12 49.76 118.496-17.024 8.48-32.544 19.36-46.656 32-16.576-24.192-64.832-86.496-121.824-86.496-50.432 0-94.048 48.864-114.912 76.864-8.512 11.424-8.512 26.848 0 38.24 20.864 28.032 64.48 76.896 114.912 76.896 24.384 0 47.072-11.488 66.464-26.464-2.688 6.688-5.632 13.248-7.648 20.288l-58.304 204c-16.352 57.184-6.752 118.656 26.24 168.128 47.52 71.264 127.456 114.048 213.024 114.048h45.984c85.6 0 165.536-42.784 212.992-113.984 32.992-49.472 42.592-110.944 26.24-168.128l-58.304-204c-2.016-7.040-4.96-13.6-7.648-20.288 19.424 14.912 42.144 26.4 66.496 26.4 50.368 0 93.952-48.736 114.848-76.768 8.544-11.488 8.544-27.008-0.032-38.464zM608 166.368v-118.368c0-8.832 7.168-16 16-16s16 7.168 16 16v118.368c0 5.824-0.32 11.616-0.64 17.376l-0.256 4.96c-0.48 9.952 3.68 19.552 11.264 25.984 5.824 4.96 13.184 7.584 20.704 7.584 2.24 0 4.512-0.224 6.784-0.736 30.208-6.528 53.504-28.832 60.832-58.208l13.824-55.264c1.76-7.072 8.128-12.064 15.456-12.064 1.312 0 2.624 0.16 3.904 0.48 5.6 1.376 8.544 5.152 9.824 7.264s3.2 6.496 1.792 12.096l-13.824 55.264c-12.448 50.016-57.152 84.896-108.64 84.896h-4.96c-14.528 0-27.264 9.792-30.944 23.872-10.688 40.672-27.424 78.816-48.736 114.432-10.56-3.36-21.408-5.984-32.544-7.648 41.856-66.272 64.16-142.112 64.16-220.288zM398.88 279.872c-3.68-14.080-16.384-23.872-30.944-23.872h-4.96c-51.488 0-96.192-34.88-108.672-84.832l-13.824-55.328c-1.408-5.568 0.512-9.952 1.792-12.064s4.256-5.888 9.824-7.264c1.312-0.352 2.624-0.512 3.936-0.512 7.328 0 13.696 4.992 15.488 12.128l13.824 55.264c7.328 29.344 30.624 51.648 60.832 58.176 2.24 0.48 4.512 0.736 6.752 0.736 7.52 0 14.848-2.656 20.704-7.584 7.584-6.432 11.744-16.032 11.264-25.984l-0.256-4.96c-0.32-5.792-0.64-11.584-0.64-17.408v-118.368c0-8.832 7.168-16 16-16s16 7.168 16 16v118.368c0 78.144 22.304 154.016 64.16 220.256-11.136 1.696-21.984 4.288-32.544 7.648-21.312-35.584-38.048-73.728-48.736-114.4zM249.216 512c-26.016 0-59.36-23.872-89.184-64.128 29.856-40 63.168-63.872 89.184-63.872s59.36 23.872 89.184 64.128c-29.824 40-63.136 63.872-89.184 63.872zM743.488 750.656c13.792 48.256 5.728 99.84-22.112 141.6-41.632 62.464-111.328 99.744-186.368 99.744h-45.984c-75.072 0-144.736-37.28-186.368-99.744-27.84-41.76-35.904-93.344-22.112-141.6l58.304-204c21.952-76.928 93.152-130.656 173.152-130.656s151.2 53.728 173.184 130.624l58.304 204.032zM774.752 512c-34.048 0-69.92-38.144-89.344-64.064 19.328-25.92 55.072-63.936 89.344-63.936 26.016 0 59.36 23.872 89.184 64.128-29.824 40-63.168 63.872-89.184 63.872zM416 704c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM672 704c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pull",
						"fly",
						"prance"
					],
					"grid": 32
				},
				{
					"id": 720,
					"width": 1024,
					"paths": [
						"M544 864c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM889.568 467.232c-20.864 28.032-64.448 76.768-114.816 76.768-24.352 0-47.040-11.488-66.432-26.432 2.688 6.688 5.632 13.216 7.648 20.288l58.304 204c16.352 57.184 6.752 118.656-26.24 168.128-47.52 71.232-127.456 114.016-213.024 114.016h-45.984c-85.6 0-165.536-42.784-212.992-113.984-32.992-49.472-42.592-110.944-26.24-168.128l58.304-204c2.016-7.040 4.96-13.6 7.648-20.288-19.424 14.912-42.144 26.4-66.528 26.4-50.432 0-94.048-48.864-114.912-76.864-8.512-11.424-8.512-26.848 0-38.24 20.864-28.032 64.48-76.896 114.912-76.896 56.992 0 105.216 62.304 121.792 86.496 14.144-12.64 29.664-23.52 46.656-32-21.824-37.376-38.816-76.992-49.728-118.496h-4.96c-66.24 0-123.648-44.832-139.712-109.056l-13.824-55.328c-6.432-25.696 9.216-51.776 34.944-58.176 3.904-0.96 7.808-1.44 11.648-1.44 21.536 0 41.088 14.56 46.528 36.384l13.824 55.296c4.512 18.016 18.976 30.848 36.544 34.656-0.416-8-0.928-15.936-0.928-23.968v-118.368c0-26.496 21.504-48 48-48s48 21.504 48 48v118.368c0 75.68 22.24 148.256 64 210.976 41.76-62.72 64-135.328 64-210.976v-118.368c0-26.496 21.504-48 48-48s48 21.504 48 48v118.368c0 8.032-0.512 15.968-0.928 23.936 17.568-3.808 32.064-16.64 36.544-34.688l13.824-55.264c5.44-21.792 25.024-36.352 46.528-36.352 3.84 0 7.744 0.48 11.648 1.44 25.728 6.4 41.376 32.48 34.944 58.176l-13.824 55.296c-16.064 64.256-73.472 109.088-139.712 109.088h-4.96c-10.912 41.504-27.904 81.12-49.76 118.496 17.024 8.48 32.512 19.36 46.656 32 16.576-24.192 64.8-86.496 121.792-86.496 50.368 0 93.952 48.736 114.848 76.768 8.544 11.456 8.544 26.976-0.032 38.464zM416 704c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM576 864c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64zM672 704c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pull",
						"fly",
						"prance"
					],
					"grid": 32
				},
				{
					"id": 2436,
					"paths": [
						"M210.746 576l246.628-246.626c9.15-9.154 22.914-11.892 34.874-6.938 11.956 4.952 19.752 16.622 19.752 29.564v242.746l137.374-137.374c9.15-9.152 22.914-11.89 34.874-6.938 11.956 4.954 19.752 16.624 19.752 29.566v96h247.862c43.596-72.498 72.138-153.124 72.138-240 0-150.22-121.78-272-272-272-103.912 0-194.202 58.276-240 143.92-45.802-85.644-136.090-143.92-240-143.92-150.222 0-272 121.78-272 272 0 86.876 28.542 167.502 72.138 240h138.608z",
						"M672 640c-17.674 0-32-14.326-32-32v-50.746l-137.374 137.374c-6.122 6.124-14.306 9.374-22.634 9.376-4.124 0-8.28-0.796-12.24-2.438-11.954-4.954-19.752-16.622-19.752-29.566v-242.746l-201.372 201.372c-6 6.002-14.14 9.374-22.626 9.374h-108.158c151.034 197.428 396.156 320 396.156 320s245.124-122.572 396.156-320h-236.156z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pulse",
						"health",
						"medicine",
						"medical"
					],
					"defaultCode": 60271,
					"grid": 16
				},
				{
					"id": 2437,
					"paths": [
						"M480.016 960.002c-1.096 0-2.2-0.056-3.308-0.172-14.478-1.498-26.124-12.578-28.336-26.964l-102.094-663.606-91.040 409.682c-3.254 14.64-16.24 25.058-31.238 25.058h-192c-17.672 0-32-14.326-32-32s14.328-32 32-32h166.33l122.432-550.942c3.34-15.030 16.91-25.53 32.294-25.042 15.386 0.508 28.23 11.9 30.572 27.116l109.388 711.022 149.022-397.392c4.76-12.694 17.026-21.010 30.554-20.758 13.554 0.25 25.478 9.014 29.766 21.876l97.642 292.926 33.642-100.926c4.356-13.066 16.584-21.88 30.358-21.88h128c17.674 0 32 14.326 32 32s-14.326 32-32 32h-104.936l-56.708 170.12c-4.354 13.066-16.582 21.88-30.356 21.88s-26.002-8.814-30.358-21.88l-99.418-298.25-160.262 427.368c-4.718 12.582-16.732 20.762-29.946 20.764z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pulse",
						"health",
						"medicine",
						"medical"
					],
					"defaultCode": 60272,
					"grid": 16
				},
				{
					"id": 721,
					"width": 1024,
					"paths": [
						"M480 320c0 8.832-7.168 16-16 16s-16-7.168-16-16c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 8.832-7.168 16-16 16s-16-7.168-16-16c0-35.296 28.704-64 64-64s64 28.704 64 64zM512 372c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM406.688 396l-66.432-22.144c-8.384-2.784-17.472 1.76-20.256 10.144v0c-2.784 8.384 1.728 17.44 10.112 20.224l35.296 11.776-35.296 11.744c-8.384 2.816-12.896 11.872-10.112 20.256v0c2.784 8.384 11.84 12.928 20.256 10.112l66.432-22.144c8.576-2.848 14.4-10.912 14.4-19.968v-0.032c-0.032-9.056-5.824-17.088-14.4-19.968zM902.048 96.128l-69.184 191.2c39.808 80.256 63.136 242.4 63.136 352.672 0 300.448-171.936 320-384 320h-128c-0.704 0-1.568 0-2.496 0-28.896 0-150.144-4.832-226.4-80.288-38.656-38.272-59.104-87.968-59.104-143.712 0-28.736 12.896-54.24 32.896-71.84-0.288-8.064-0.896-15.616-0.896-24.16 0-107.68 22.368-267.68 60.48-346.88l-66.816-200.416c-7.168-21.536 9.472-42.176 30.208-42.176 3.36 0 6.816 0.544 10.272 1.696l182.048 60.672c50.784-31.296 107.552-48.896 167.808-48.896 59.2 0 115.008 16.992 165.088 47.264l185.536-56.64c3.232-0.992 6.432-1.44 9.536-1.44 21.088 0 37.728 21.312 29.888 42.944zM871.968 85.248l-199.2 60.832-12.224-7.392c-46.816-28.352-96.8-42.688-148.544-42.688-52.736 0-103.52 14.848-150.976 44.16l-12.736 7.872-196.064-65.376 70.72 212.672-5.632 11.68c-35.392 73.568-57.312 230.144-57.312 332.992 0 2.048 0.16 3.872 0.192 5.824 10.016-3.552 20.608-5.824 31.808-5.824 53.024 0 96 42.976 96 96 0 5.12 0.64 5.728 2.144 7.232 11.232 11.104 38.144 18.432 61.856 22.048v-109.28c0-8.832 7.168-16 16-16s16 7.168 16 16v112h64v-112c0-8.832 7.168-16 16-16s16 7.168 16 16v112h64v-112c0-8.832 7.168-16 16-16s16 7.168 16 16v112h64v-112c0-8.832 7.168-16 16-16s16 7.168 16 16v144h-288.992c-0.032 0-0.064 0-0.064 0-18.016 0-86.752-5.792-115.296-34.016-10.24-10.048-11.648-20.8-11.648-29.984 0-37.504-32.384-67.552-70.656-63.648-34.4 3.488-58.304 34.944-57.248 69.504 1.376 44.64 18.4 84.32 49.504 115.136 68.32 67.584 181.856 71.008 203.904 71.008h130.496c212.64 0 352-20.032 352-288 0-104.8-22.848-263.968-59.808-338.464l-6.080-12.256 73.856-204.032zM381.984 768c0.352 0 0.672 0 1.024 0h-1.44c0.128 0 0.288 0 0.416 0zM640 320c0 8.832 7.168 16 16 16s16-7.168 16-16c0-35.296-28.704-64-64-64s-64 28.704-64 64c0 8.832 7.168 16 16 16s16-7.168 16-16c0-17.664 14.336-32 32-32s32 14.336 32 32zM602.944 415.968v0.032c0 9.056 5.792 17.088 14.4 19.968l66.432 22.144c8.352 2.816 17.44-1.728 20.224-10.112v0c2.784-8.384-1.728-17.44-10.112-20.256l-35.296-11.744 35.296-11.744c8.384-2.816 12.896-11.872 10.112-20.256v0c-2.784-8.384-11.84-12.928-20.256-10.112l-66.432 22.144c-8.576 2.848-14.368 10.88-14.368 19.936z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"purr",
						"sit"
					],
					"grid": 32
				},
				{
					"id": 722,
					"width": 1024,
					"paths": [
						"M872.128 53.184c-3.104 0-6.304 0.448-9.536 1.44l-185.536 56.64c-50.048-30.272-105.856-47.264-165.056-47.264-60.256 0-117.024 17.6-167.776 48.928l-182.080-60.704c-3.456-1.152-6.912-1.696-10.272-1.696-20.736 0-37.376 20.64-30.208 42.176l66.816 200.416c-36.224 75.264-58.176 223.392-60.288 330.368 17.024-9.44 37.888-15.488 63.808-15.488 85.792 0 119.584 68.288 128.032 116 6.944 3.104 18.016 6.688 31.968 9.152v-77.152c0-8.832 7.168-16 16-16s16 7.168 16 16v80h64v-80c0-8.832 7.168-16 16-16s16 7.168 16 16v80h64v-80c0-8.832 7.168-16 16-16s16 7.168 16 16v80h64v-80c0-8.832 7.168-16 16-16s16 7.168 16 16v112c0 0-240.64 0-288.992 0-0.352 0-0.672 0-1.024 0-0.128 0-0.288 0-0.416 0h1.44c-48.384 0-82.464-15.712-92.832-24.768-0.032 0-5.824-103.232-98.176-103.232-76.672 0-92.16 66.048-95.232 88.512-0.16 2.464-0.768 5.056-0.768 7.488 0 55.744 20.448 105.44 59.104 143.712 76.224 75.456 197.504 80.288 226.4 80.288 0.928 0 1.792 0 2.496 0h128c212.064 0 384-19.552 384-320 0-110.272-23.328-272.416-63.136-352.672l69.184-191.2c7.84-21.632-8.8-42.944-29.92-42.944zM421.056 416.032c0 9.056-5.792 17.088-14.4 19.968l-66.432 22.144c-8.352 2.784-17.44-1.76-20.224-10.144v0c-2.784-8.384 1.728-17.44 10.112-20.256l35.296-11.744-35.296-11.744c-8.384-2.816-12.896-11.872-10.112-20.256v0c2.784-8.384 11.84-12.928 20.256-10.112l66.432 22.144c8.576 2.88 14.4 10.912 14.4 19.968v0.032zM464 336c-8.832 0-16-7.168-16-16 0-17.664-14.336-32-32-32s-32 14.336-32 32c0 8.832-7.168 16-16 16s-16-7.168-16-16c0-35.296 28.704-64 64-64s64 28.704 64 64c0 8.832-7.168 16-16 16zM512 436c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM576 320c0 8.832-7.168 16-16 16s-16-7.168-16-16c0-35.296 28.704-64 64-64s64 28.704 64 64c0 8.832-7.168 16-16 16s-16-7.168-16-16c0-17.664-14.336-32-32-32s-32 14.336-32 32zM693.888 427.744c8.384 2.816 12.896 11.872 10.112 20.256v0c-2.784 8.384-11.84 12.928-20.256 10.112l-66.432-22.144c-8.576-2.848-14.4-10.912-14.4-19.968v-0.032c0-9.056 5.792-17.088 14.4-19.968l66.432-22.144c8.384-2.784 17.472 1.76 20.256 10.144v0c2.784 8.384-1.728 17.44-10.112 20.224l-35.296 11.776 35.296 11.744z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"purr",
						"sit"
					],
					"grid": 32
				},
				{
					"id": 1091,
					"width": 1024,
					"paths": [
						"M980.064 638.272c-24.256-48.48-51.712-103.36-52.064-251.328-0.128-48.128-34.464-90.080-79.904-97.6-60.192-10.048-112.096 36.48-112.096 94.656 0 195.456 41.824 279.104 72.352 340.16 16.256 32.48 23.648 47.296 23.648 75.84 0 20.224-5.248 31.296-32 32h-42.24l-47.744-739.648c-2.208-34.144-29.792-59.936-64.16-59.936-21.568 0-40.864 10.4-52.96 28.576l-66.016 99.008h-221.76l-66.048-99.104c-12.096-18.080-31.392-28.48-52.928-28.48-34.4 0-61.984 25.792-64.16 59.936l-55.712 863.488c-1.152 17.6 5.12 35.072 17.152 47.904 12.064 12.896 29.088 20.256 46.688 20.256h669.888c90.048 0 224-59.648 224-224 0-73.888-23.328-120.544-43.936-161.728zM800 960h-669.856l8.256-128h117.6v-32h-115.552l2.080-32h113.472v-32h-111.424l2.080-32h109.344v-32h-107.296l2.080-32h105.216v-32h-103.168l33.024-511.552 85.024 127.552h290.24l85.024-127.52 33.024 511.52h-103.168v32h105.216l2.080 32h-107.296v32h109.344l2.080 32h-111.424v32h113.504l2.080 32h-115.584v32h117.632l4.128 64h103.072c58.688-1.536 95.168-38.304 95.168-96 0-43.648-12.736-69.152-30.4-104.48-27.68-55.328-65.6-131.168-65.6-311.52 0-19.488 17.792-34.816 37.696-31.52 14.72 2.432 26.272 17.664 26.304 34.624 0.384 163.008 31.424 225.056 58.816 279.808 19.136 38.208 37.184 74.336 37.184 133.088 0 126.56-104.672 160-160 160zM288 320h64v32h-64v-32zM480 320h64v32h-64v-32zM434.752 384h-37.504c-28.512 0-42.784 34.464-22.624 54.624l18.752 18.752c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l18.752-18.752c20.16-20.16 5.888-54.624-22.624-54.624zM416 434.752l-18.752-18.752h37.504l-18.752 18.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"purr",
						"sit"
					],
					"grid": 32
				},
				{
					"id": 723,
					"width": 1024,
					"paths": [
						"M960 448v-32c0-182.496-138.88-332.544-316.704-350.24-18.88-1.888-35.296 13.056-35.296 32.032v318.208h-330.624l-50.496-138.944c-4.608-12.64-16.608-21.056-30.080-21.056h-4.8c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h4.768l59.392 163.264c1.056 115.264 57.6 216.992 144.096 280.448l-20.416 40.864c-8.864-2.688-18.080-4.576-27.84-4.576-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96c0-31.808-15.648-59.776-39.488-77.248l18.592-37.184c52.928 31.808 114.656 50.432 180.896 50.432s127.968-18.624 180.896-50.432l18.592 37.184c-23.84 17.472-39.488 45.44-39.488 77.248 0 53.024 42.976 96 96 96s96-42.976 96-96-42.976-96-96-96c-9.76 0-18.976 1.888-27.84 4.576l-20.416-40.864c87.328-64.064 144.256-167.104 144.256-283.712zM96 288v-32h64v32h-64zM352 928c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64zM928 864c0 35.296-28.704 64-64 64s-64-28.704-64-64c0-35.296 28.704-64 64-64s64 28.704 64 64zM640 97.6c161.472 16.096 288 152.768 288 318.4h-288v-318.4zM288 448h640c0 176.448-143.552 320-320 320s-320-143.552-320-320zM384 864c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM832 864c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"push",
						"walk",
						"father",
						"mother",
						"birth"
					],
					"grid": 32
				},
				{
					"id": 724,
					"width": 1024,
					"paths": [
						"M960 448v-32h-682.624l-50.496-138.944c-4.608-12.64-16.608-21.056-30.080-21.056h-4.8c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h4.768l59.392 163.264c1.056 115.264 57.6 216.992 144.096 280.448l-20.416 40.864c-8.864-2.688-18.080-4.576-27.84-4.576-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96c0-31.808-15.648-59.776-39.488-77.248l18.592-37.184c52.928 31.808 114.656 50.432 180.896 50.432s127.968-18.624 180.896-50.432l18.592 37.184c-23.84 17.472-39.488 45.44-39.488 77.248 0 53.024 42.976 96 96 96s96-42.976 96-96-42.976-96-96-96c-9.76 0-18.976 1.888-27.84 4.576l-20.416-40.864c87.328-64.064 144.256-167.104 144.256-283.712zM352 896c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM864 832c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM958.496 384h-350.496v-286.208c0-18.944 16.416-33.92 35.296-32.032 167.296 16.64 300.064 150.496 315.2 318.24z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"push",
						"walk",
						"father",
						"mother",
						"birth"
					],
					"grid": 32
				},
				{
					"id": 2123,
					"paths": [
						"M544 0l-96 96 96 96-224 256h-224l176 176-272 360.616v39.384h39.384l360.616-272 176 176v-224l256-224 96 96 96-96-480-480zM448 544l-64-64 224-224 64 64-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pushpin",
						"pin"
					],
					"defaultCode": 59958,
					"grid": 16
				},
				{
					"id": 2124,
					"paths": [
						"M512 0c-141.384 0-256 114.616-256 256 0 119.286 81.586 219.516 192 247.934v488.066l128-128v-360.066c110.414-28.418 192-128.65 192-247.934 0-141.384-114.614-256-256-256zM448 256c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pushpin",
						"pin"
					],
					"defaultCode": 59959,
					"grid": 16
				},
				{
					"id": 145,
					"paths": [
						"M921.6 347.797l-270.997-270.997c-9.65-9.65-22.507-14.965-36.203-14.965s-26.554 5.314-36.203 14.965l-14.997 14.997c-14.834 14.834-25.6 40.826-25.6 61.803v51.2c0 7.288-5.45 20.446-10.603 25.6l-142.997 142.997c-5.152 5.154-18.312 10.603-25.6 10.603h-51.2c-20.978 0-46.97 10.766-61.803 25.6l-14.997 14.997c-19.963 19.963-19.963 52.443 0 72.406l79.534 79.534-253.426 329.453c-7.84 10.192-6.902 24.619 2.189 33.71 4.966 4.966 11.522 7.499 18.109 7.499 5.477 0 10.974-1.75 15.602-5.309l329.453-253.426 79.536 79.534c9.65 9.651 22.507 14.966 36.203 14.966s26.554-5.314 36.203-14.966l14.997-14.997c14.834-14.834 25.6-40.826 25.6-61.803v-51.2c0-7.288 5.45-20.446 10.603-25.6l142.997-142.997c5.154-5.154 18.312-10.603 25.6-10.603h51.2c20.976 0 46.968-10.766 61.803-25.6l14.997-14.997c9.65-9.65 14.966-22.507 14.966-36.203s-5.317-26.554-14.966-36.203zM216.757 781.642l129.688-168.594 38.906 38.906-168.594 129.688zM870.4 398.997c-5.154 5.154-18.312 10.603-25.6 10.603h-51.2c-20.976 0-46.968 10.766-61.803 25.6l-142.997 142.997c-14.834 14.834-25.6 40.826-25.6 61.803v51.2c0 7.288-5.45 20.446-10.603 25.6l-14.93 14.958c-0.006 0.003-0.032 0.008-0.067 0.008v0.032l-270.997-270.998 14.998-14.998c5.152-5.154 18.312-10.603 25.6-10.603h51.2c20.978 0 46.97-10.766 61.803-25.6l142.995-142.995c14.834-14.834 25.6-40.826 25.6-61.803v-51.2c0-7.288 5.45-20.446 10.603-25.6l14.997-14.997 270.997 270.997-14.997 14.997z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pushpin",
						"pin",
						"location"
					],
					"defaultCode": 59442,
					"grid": 20
				},
				{
					"id": 2612,
					"paths": [
						"M958.33 256.25h-168.45c-43.43-0.066-86.696-3.006-44.504-77.458 42.276-74.6 72.118-179.042-97.604-179.042-169.714 0-139.87 104.442-97.594 179.042 42.192 74.452-1.076 77.388-44.51 77.458h-183.876c-36.12 0-65.67 29.556-65.67 65.668v204.378c0 43.512 11.808 87.026-62.786 44.756-74.592-42.274-193.336-72.114-193.336 97.604 0 169.708 118.74 139.87 193.34 97.596 74.594-42.274 62.786 1.24 62.786 44.76v147.566c0 36.124 29.554 65.67 65.67 65.67h183.622c43.52 0 87.034-17.412 44.764-92.008-42.274-74.59-72.122-179.038 97.594-179.038s139.876 104.442 97.6 179.038c-42.27 74.598 1.246 92.010 44.762 92.010h168.192c36.124 0 65.674-29.554 65.674-65.67v-636.664c0-36.114-29.55-65.666-65.674-65.666z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"puzzle",
						"puzzle-piece",
						"extension",
						"addon",
						"app"
					],
					"defaultCode": 60447,
					"grid": 16
				},
				{
					"id": 1449,
					"width": 950.8591086864471,
					"paths": [
						"M950.857 627.429q0 46.286-25.429 77.143t-70.571 30.857q-23.429 0-44.286-10t-33.714-21.714-32.286-21.714-40.571-10q-62.857 0-62.857 70.857 0 22.286 9.143 65.714t8.571 65.714v2.857q-12.571 0-18.857 0.571-19.429 1.714-55.714 6.571t-66 7.714-56 2.857q-34.857 0-58.857-15.143t-24-47.714q0-21.143 10-40.571t21.714-32.286 21.714-33.714 10-44.286q0-45.143-30.857-70.571t-77.143-25.429q-48 0-81.714 26t-33.714 72.857q0 24.571 8.571 47.429t19.143 36.857 19.143 30.286 8.571 28.857q0 25.714-26.286 50.857-21.143 20-66.857 20-54.286 0-140-13.714-5.143-1.143-15.714-2.286t-15.714-2.286l-7.429-1.143q-0.571 0-1.714-0.571-1.143 0-1.143-0.571v-585.143q1.143 0.571 10 2t19.429 2.857 12.286 2q85.714 13.714 140 13.714 45.714 0 66.857-20 26.286-25.143 26.286-50.857 0-12.571-8.571-28.857t-19.143-30.286-19.143-36.857-8.571-47.429q0-46.857 33.714-72.857t82.286-26q45.714 0 76.571 25.429t30.857 70.571q0 23.429-10 44.286t-21.714 33.714-21.714 32.286-10 40.571q0 32.571 24 47.714t58.857 15.143q36.571 0 102.857-8.571t93.143-9.714v1.143q-0.571 1.143-2 10t-2.857 19.429-2 12.286q-13.714 85.714-13.714 140 0 45.714 20 66.857 25.143 26.286 50.857 26.286 12.571 0 28.857-8.571t30.286-19.143 36.857-19.143 47.429-8.571q46.857 0 72.857 33.714t26 81.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"puzzle-piece"
					],
					"defaultCode": 61742,
					"grid": 14
				},
				{
					"id": 2613,
					"paths": [
						"M930.72 1024h-156.94c-49.416 0-71.356-19.806-81.058-36.422-14.714-25.202-10.874-58.012 11.42-97.52 24.266-42.996 32.382-77.584 22.272-94.9-9.466-16.212-39.82-25.14-85.472-25.14-45.65 0-76.002 8.928-85.468 25.14-10.112 17.314-1.992 51.904 22.272 94.896 22.294 39.51 26.138 72.32 11.422 97.522-9.702 16.616-31.64 36.422-81.058 36.422h-158.54c-51.434 0-93.278-41.958-93.278-93.536v-138.276c0-5.588 0.178-10.918 0.35-16.074 0.042-1.26 0.088-2.632 0.13-4.060-3.164 1.56-6.886 3.526-11.24 6.004-28.022 15.946-87.59 34.954-129.852 34.954-34.792 0-63.784-13.16-83.844-38.056-21.422-26.588-31.836-64.584-31.836-116.162 0-51.582 10.414-89.582 31.834-116.17 20.058-24.896 49.052-38.056 83.846-38.056 42.262 0 101.83 19.008 129.846 34.956 4.352 2.476 8.076 4.442 11.238 6-0.042-1.43-0.088-2.804-0.13-4.068-0.172-5.15-0.35-10.476-0.35-16.058l-0.8-175.366c0-51.72 41.844-93.68 93.278-93.68h158.776c4.68-0.008 16.684-0.028 24.492-1.176-1.346-4.576-4.312-12.134-10.828-23.68-37.318-66.124-44.652-135.494-21.802-174.626 22.034-37.736 69.384-56.868 140.734-56.868 71.358 0 118.71 19.134 140.746 56.872 22.85 39.132 15.514 108.502-21.802 174.626-6.516 11.546-9.482 19.104-10.83 23.68 7.81 1.148 19.82 1.166 24.54 1.174h157.132c51.434 0 93.28 41.958 93.28 93.532l0.8 580.536c0 51.622-41.846 93.58-93.28 93.58zM748.052 955.252c1.864 1.462 9.428 4.748 25.726 4.748h156.942c16.144 0 29.28-13.25 29.28-29.536l-0.8-580.538c0-16.328-13.134-29.576-29.28-29.576h-157.182c-25.644-0.040-64.324-0.1-82.208-30.784-17.174-29.462-0.914-65.204 12.81-89.524 24.266-42.996 32.382-93.586 22.272-110.9-9.468-16.214-39.822-25.142-85.478-25.142-45.648 0-76.002 8.928-85.468 25.14-10.11 17.314-1.992 67.906 22.274 110.904 13.722 24.32 29.982 60.058 12.812 89.52-17.884 30.682-56.566 30.746-82.162 30.788h-158.83c-16.144 0-29.278 13.25-29.278 29.534l0.8 175.366c0 4.66 0.16 9.442 0.314 14.068 0.75 22.412 1.524 45.59-14.65 62.318-6.104 6.31-16.956 13.836-33.998 13.838-0.002 0-0.008 0-0.010 0-15.454 0-33.362-6.27-58.068-20.328-29.678-16.892-76.458-26.578-98.192-26.578-14.134 0-51.68 0-51.68 90.224 0 90.216 37.544 90.216 51.678 90.216 21.732 0 68.516-9.688 98.196-26.578 24.706-14.058 42.616-20.33 58.074-20.33 17.046 0 27.902 7.526 34.006 13.838 16.176 16.724 15.4 39.902 14.65 62.314-0.156 4.63-0.316 9.416-0.316 13.934v138.276c0 16.286 13.134 29.536 29.278 29.536h158.54c16.296 0 23.864-3.286 25.726-4.746 0.276-1.774 0.866-11.25-11.828-33.742-37.316-66.122-44.652-119.49-21.802-158.624 22.034-37.736 69.386-56.87 140.738-56.87 71.356 0 118.708 19.134 140.742 56.872 22.85 39.13 15.514 92.5-21.802 158.624-12.692 22.492-12.1 31.968-11.826 33.738z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"puzzle",
						"puzzle-piece",
						"extension",
						"addon",
						"app"
					],
					"defaultCode": 60448,
					"grid": 16
				},
				{
					"id": 2614,
					"paths": [
						"M1004.312 464.266l-108.388-108.388c-83.46-83.524 23.382-76.848 85.414-132.49 0.31-0.278 0.618-0.56 0.926-0.844 1.438-1.314 2.86-2.65 4.246-4.036 49.986-49.988 49.986-131.030 0-181.020-49.988-49.986-131.032-49.986-181.020 0-1.386 1.386-2.722 2.808-4.038 4.246-0.284 0.308-0.564 0.616-0.844 0.924-55.652 62.044-48.96 168.922-132.542 85.364l-108.332-108.332c-26.252-26.254-69.21-26.254-95.466 0l-108.282 108.282c-0.010 0.010-0.020 0.018-0.030 0.028-83.61 83.608-76.908-23.288-132.566-85.338-0.28-0.31-0.562-0.618-0.844-0.926-1.316-1.438-2.652-2.86-4.038-4.246-49.986-49.986-131.030-49.986-181.020 0-49.986 49.988-49.986 131.032 0 181.020 1.384 1.386 2.806 2.722 4.246 4.038 0.306 0.284 0.616 0.564 0.924 0.844 62.052 55.658 168.946 48.958 85.34 132.566-0.010 0.010-0.016 0.020-0.028 0.030l-108.28 108.28c-26.254 26.254-26.254 69.214 0 95.468l108.302 108.302c0.002 0.002 0.002 0.004 0.004 0.006 83.608 83.61-23.288 76.908-85.338 132.566-0.31 0.28-0.618 0.562-0.926 0.844-1.438 1.316-2.86 2.652-4.246 4.038-49.986 49.986-49.986 131.030 0 181.020 49.988 49.986 131.032 49.986 181.020 0 1.386-1.384 2.722-2.806 4.038-4.246 0.284-0.306 0.564-0.616 0.844-0.924 55.652-62.046 48.96-168.922 132.54-85.366l108.338 108.338c26.254 26.25 69.214 26.25 95.466 0l125.834-125.834c50.132-64.45-44.844-62.904-101.91-114.090-0.308-0.28-0.618-0.56-0.924-0.844-1.44-1.314-2.862-2.65-4.246-4.038-49.986-49.988-49.986-131.032 0-181.020 49.99-49.986 131.034-49.986 181.020 0 1.384 1.386 2.72 2.808 4.038 4.246 0.282 0.308 0.564 0.616 0.844 0.926 51.186 57.064 49.638 152.042 114.090 101.908l125.834-125.834c26.252-26.254 26.252-69.214 0-95.468z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"puzzle",
						"puzzle-piece",
						"extension",
						"addon",
						"app"
					],
					"defaultCode": 60449,
					"grid": 16
				},
				{
					"id": 2615,
					"paths": [
						"M511.986 1024c26.892 0 52.128-10.426 71.054-29.352l118.166-118.168 1.454-1.868c6.68-8.59 27.012-34.728 19.448-66.342-7.86-32.85-38.144-47.112-67.436-60.904-18.118-8.534-36.852-17.356-50.894-29.92l-0.684-0.624c-0.892-0.812-1.774-1.634-2.69-2.552-31.384-31.386-31.384-82.458 0-113.844 15.206-15.204 35.422-23.578 56.922-23.578s41.716 8.374 56.876 23.536c0.896 0.898 1.76 1.822 2.744 2.898l0.4 0.436c12.604 14.052 21.444 32.824 29.992 50.978 14.492 30.772 32.524 69.068 74.88 69.076 0.004 0 0.008 0 0.012 0 16.982 0 34.106-6.898 52.35-21.090l1.866-1.452 118.172-118.17c39.174-39.182 39.174-102.936-0.004-142.12l-100.332-100.334c-6.392-6.396-10.498-11.248-13.118-14.748 6.084-3.404 14.516-7.374 21.326-10.582 20.946-9.86 47.010-22.134 69.272-42.104 0.392-0.35 0.78-0.704 1.176-1.068 1.94-1.77 3.646-3.394 5.192-4.942 29.558-29.56 45.838-68.86 45.838-110.662s-16.28-81.104-45.836-110.664c-29.558-29.556-68.858-45.836-110.658-45.836s-81.098 16.278-110.676 45.854c-1.546 1.55-3.1 3.18-4.754 4.988l-1.164 1.276c-20.044 22.346-32.316 48.412-42.178 69.356-3.206 6.812-7.178 15.246-10.582 21.33-3.506-2.624-8.372-6.742-14.784-13.154l-100.292-100.292c-18.932-18.932-44.166-29.358-71.056-29.358s-52.128 10.426-71.060 29.358l-100.27 100.272c-6.428 6.428-11.302 10.554-14.814 13.182-3.402-6.082-7.37-14.514-10.578-21.324-9.858-20.948-22.13-47.016-42.188-69.378-0.364-0.406-0.732-0.81-1.010-1.11-1.808-1.98-3.372-3.622-4.914-5.162-29.558-29.558-68.856-45.836-110.658-45.836-41.8 0-81.1 16.278-110.662 45.836-61.016 61.020-61.016 160.306-0.022 221.304 1.524 1.526 3.136 3.064 5.072 4.834 0.39 0.362 0.788 0.724 1.232 1.124 22.348 20.044 48.414 32.316 69.358 42.176 6.812 3.206 15.244 7.178 21.328 10.582-2.63 3.512-6.752 8.384-13.178 14.81l-100.264 100.272c-18.934 18.932-29.36 44.17-29.36 71.062s10.426 52.128 29.358 71.060l100.264 100.268c6.426 6.428 10.552 11.3 13.18 14.812-6.084 3.404-14.518 7.374-21.328 10.58-20.944 9.862-47.010 22.134-69.358 42.178l-1.136 1.036c-1.988 1.82-3.63 3.384-5.148 4.902-61.014 61.016-61.016 160.3 0.002 221.326 29.56 29.556 68.858 45.836 110.658 45.836s81.098-16.28 110.64-45.816c1.508-1.506 3.040-3.112 4.812-5.048 0.302-0.324 0.612-0.666 1.010-1.108l0.134-0.148c20.042-22.346 32.314-48.412 42.176-69.356 3.206-6.812 7.178-15.246 10.582-21.33 3.506 2.624 8.372 6.742 14.786 13.152l100.296 100.3c18.93 18.93 44.166 29.354 71.058 29.354zM321.394 801.064c-42.362 0-60.396 38.306-74.888 69.084-8.538 18.138-17.368 36.892-29.95 50.938l-0.582 0.634c-0.828 0.908-1.668 1.81-2.56 2.702-15.204 15.204-35.42 23.578-56.922 23.578s-41.716-8.374-56.918-23.576c-31.386-31.39-31.386-82.46 0.020-113.866 0.876-0.88 1.782-1.722 2.632-2.502l0.742-0.676c14.040-12.552 32.766-21.368 50.876-29.896 29.076-13.688 62.030-29.204 68.192-64.518 5.884-33.734-17.578-62.276-38.678-83.378l-100.262-100.266c-4.578-4.578-7.098-10.728-7.098-17.32s2.52-12.744 7.098-17.322l97.654-97.65 1.636-1.104 2.378-2.922c20.718-20.952 43.028-48.976 37.274-81.966-6.16-35.314-39.114-50.83-68.19-64.518-18.158-8.55-36.932-17.388-50.926-29.942l-0.652-0.598c-0.906-0.828-1.806-1.664-2.696-2.556-31.384-31.386-31.384-82.456-0.002-113.842 15.206-15.204 35.424-23.578 56.924-23.578 21.502 0 41.716 8.372 56.928 23.584 0.878 0.878 1.72 1.782 2.644 2.792l0.448 0.49c12.606 14.054 21.444 32.828 29.99 50.986 14.488 30.78 32.514 69.086 74.88 69.084 0.004 0 0.014 0 0.018 0 22.948-0.006 45.296-12.030 72.378-38.958l100.882-100.882c4.578-4.578 10.73-7.1 17.324-7.1 6.59 0 12.742 2.52 17.322 7.1l100.292 100.296c27.352 27.346 49.854 39.54 72.966 39.54 0.004 0 0.012 0 0.012 0 42.356-0.008 60.392-38.308 74.882-69.084 8.546-18.156 17.386-36.932 29.88-50.862l0.636-0.698c0.848-0.924 1.702-1.842 2.574-2.714 15.206-15.204 35.422-23.578 56.922-23.578 21.502 0 41.716 8.374 56.918 23.574 15.202 15.204 23.576 35.42 23.576 56.922s-8.374 41.716-23.596 56.94c-0.862 0.864-1.752 1.694-2.648 2.512l-0.624 0.572c-14.052 12.606-32.826 21.446-50.982 29.994-29.070 13.688-62.020 29.202-68.186 64.508-5.884 33.712 17.532 62.226 38.602 83.31l100.338 100.342c9.388 9.39 9.388 25.258 0.004 34.644l-114.24 114.24c-3.398-6.076-7.348-14.466-10.542-21.248-9.862-20.94-22.136-47.002-42.284-69.466l-0.924-1.010c-1.742-1.906-3.334-3.578-4.904-5.152-29.556-29.558-68.856-45.836-110.658-45.836-41.798 0-81.1 16.278-110.66 45.836-61.016 61.020-61.016 160.304-0.058 221.262 1.562 1.57 3.224 3.156 5.228 4.988l1.114 1.012c22.344 20.044 48.404 32.314 69.346 42.176 6.782 3.194 15.172 7.146 21.25 10.542l-114.242 114.242c-4.576 4.576-10.724 7.096-17.316 7.096-6.594 0-12.746-2.522-17.322-7.096l-100.298-100.3c-27.352-27.346-49.858-39.54-72.972-39.54z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"puzzle",
						"puzzle-piece",
						"extension",
						"addon",
						"app"
					],
					"defaultCode": 60450,
					"grid": 16
				},
				{
					"id": 2609,
					"paths": [
						"M480.002 64.054l-463.298 681.968 463.298 277.978 463.298-277.978-463.298-681.968zM107.692 725.978l340.308-500.93v705.116l-340.308-204.186zM512.002 225.048l340.31 500.93-340.31 204.186v-705.116z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pyramid"
					],
					"defaultCode": 60444,
					"grid": 16
				},
				{
					"id": 2610,
					"paths": [
						"M480.002 64.054l-463.298 681.968 463.298 277.978 463.298-277.978-463.298-681.968zM107.692 725.978l340.308-500.93v705.116l-340.308-204.186zM512.002 920h16.94l-16.94 10.164v-10.164zM512.002 904v-16h70.274l-26.666 16h-43.608zM512.002 872v-16h123.608l-26.668 16h-96.94zM512.002 840v-16h176.942l-26.668 16h-150.274zM512.002 808v-16h230.274l-26.666 16h-203.608zM512.002 776v-16h283.608l-26.666 16h-256.942zM512.002 744v-16h336.942l-26.666 16h-310.276zM527.596 248l10.87 16h-26.462v-16h15.592zM549.334 280l10.87 16h-48.2v-16h37.33zM571.074 312l10.87 16h-69.94v-16h59.070zM592.812 344l10.872 16h-91.68v-16h80.808zM614.552 376l10.87 16h-113.418v-16h102.548zM636.292 408l10.872 16h-135.16v-16h124.288zM658.032 440l10.87 16h-156.898v-16h146.028zM679.772 472l10.87 16h-178.638v-16h167.768zM701.51 504l10.87 16h-200.378v-16h189.508zM723.25 536l10.87 16h-222.118v-16h211.248zM744.988 568l10.872 16h-243.858v-16h232.986zM766.728 600l10.87 16h-265.596v-16h254.726zM788.466 632l10.872 16h-287.336v-16h276.464zM810.208 664l10.87 16h-309.076v-16h298.206zM831.948 696l10.87 16h-330.816v-16h319.946z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"pyramid",
						"dualtone"
					],
					"defaultCode": 60445,
					"grid": 16
				},
				{
					"id": 1606,
					"width": 1024.001838684082,
					"paths": [
						"M154.286 460.571q-4.571-10.857-4.571-29.714 0-11.429 6.286-28t13.714-25.714q-0.571-12.571 4.286-30.286t12.857-24.571q0-79.429 52.857-164.857t124.286-119.714q79.429-37.714 185.143-37.714 76 0 152 31.429 28 12 51.429 27.429t40.571 32 31.429 38.857 24 42.286 18.571 48.286 14.571 51.143 12.571 56l0.571 2.857q31.429 47.429 31.429 85.714 0 8-5.143 22.857t-5.143 21.714q0 0.571 0.857 2t2 2.857 1.143 2q44 65.143 68.857 122.571t24.857 119.143q0 24.571-11.143 57.143t-31.714 32.571q-5.143 0-11.143-4.286t-10.857-10-10.857-14.857-9.143-15.143-7.714-14.857-5.143-10q-0.571-0.571-1.714-0.571l-2.857 2.286q-33.714 88-75.429 127.429 11.429 11.429 35.143 22t39.429 23.714 20.286 37.143q-1.143 2.286-2.286 9.143t-4 10.286q-36.571 55.429-172.571 55.429-30.286 0-63.143-5.143t-56-11.429-59.714-17.143q-8.571-2.857-13.143-4-8-2.286-26.286-2.571t-22.857-0.857q-23.429 25.714-72.857 37.143t-96.286 11.429q-20 0-39.429-0.857t-53.143-5.143-57.714-11.714-42.571-22.857-18.571-36.571q0-22.857 5.714-34t23.429-27.714q6.286-1.143 23.143-7.429t28.286-6.857q2.286 0 8-1.143 1.143-1.143 1.143-2.286l-1.143-1.714q-27.429-6.286-61.714-60.286t-41.714-89.429l-2.857-1.714q-2.286 0-6.857 11.429-10.286 23.429-31.143 42.571t-44.286 21.429h-0.571q-2.286 0-3.429-2.571t-2.857-3.143q-13.143-30.857-13.143-57.143 0-157.143 144-266.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"qq"
					],
					"defaultCode": 61910,
					"grid": 14
				},
				{
					"id": 2061,
					"paths": [
						"M320 64h-256v256h256v-256zM384 0v0 384h-384v-384h384zM128 128h128v128h-128zM960 64h-256v256h256v-256zM1024 0v0 384h-384v-384h384zM768 128h128v128h-128zM320 704h-256v256h256v-256zM384 640v0 384h-384v-384h384zM128 768h128v128h-128zM448 0h64v64h-64zM512 64h64v64h-64zM448 128h64v64h-64zM512 192h64v64h-64zM448 256h64v64h-64zM512 320h64v64h-64zM448 384h64v64h-64zM448 512h64v64h-64zM512 576h64v64h-64zM448 640h64v64h-64zM512 704h64v64h-64zM448 768h64v64h-64zM512 832h64v64h-64zM448 896h64v64h-64zM512 960h64v64h-64zM960 512h64v64h-64zM64 512h64v64h-64zM128 448h64v64h-64zM0 448h64v64h-64zM256 448h64v64h-64zM320 512h64v64h-64zM384 448h64v64h-64zM576 512h64v64h-64zM640 448h64v64h-64zM704 512h64v64h-64zM768 448h64v64h-64zM832 512h64v64h-64zM896 448h64v64h-64zM960 640h64v64h-64zM576 640h64v64h-64zM640 576h64v64h-64zM704 640h64v64h-64zM832 640h64v64h-64zM896 576h64v64h-64zM960 768h64v64h-64zM576 768h64v64h-64zM640 704h64v64h-64zM768 704h64v64h-64zM832 768h64v64h-64zM896 704h64v64h-64zM960 896h64v64h-64zM640 832h64v64h-64zM704 896h64v64h-64zM768 832h64v64h-64zM832 896h64v64h-64zM640 960h64v64h-64zM768 960h64v64h-64zM896 960h64v64h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"qrcode"
					],
					"defaultCode": 59896,
					"grid": 16
				},
				{
					"id": 1217,
					"width": 804.5709838867188,
					"paths": [
						"M219.429 658.286v73.143h-73.143v-73.143h73.143zM219.429 219.429v73.143h-73.143v-73.143h73.143zM658.286 219.429v73.143h-73.143v-73.143h73.143zM73.143 804h219.429v-218.857h-219.429v218.857zM73.143 365.714h219.429v-219.429h-219.429v219.429zM512 365.714h219.429v-219.429h-219.429v219.429zM365.714 512v365.714h-365.714v-365.714h365.714zM658.286 804.571v73.143h-73.143v-73.143h73.143zM804.571 804.571v73.143h-73.143v-73.143h73.143zM804.571 512v219.429h-219.429v-73.143h-73.143v219.429h-73.143v-365.714h219.429v73.143h73.143v-73.143h73.143zM365.714 73.143v365.714h-365.714v-365.714h365.714zM804.571 73.143v365.714h-365.714v-365.714h365.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"qrcode"
					],
					"defaultCode": 61481,
					"grid": 14
				},
				{
					"id": 2920,
					"paths": [
						"M448 704h128v128h-128zM704 256c35.346 0 64 28.654 64 64v192l-192 128h-128v-64l192-128v-64h-320v-128h384zM512 96c-111.118 0-215.584 43.272-294.156 121.844s-121.844 183.038-121.844 294.156c0 111.118 43.272 215.584 121.844 294.156s183.038 121.844 294.156 121.844c111.118 0 215.584-43.272 294.156-121.844s121.844-183.038 121.844-294.156c0-111.118-43.272-215.584-121.844-294.156s-183.038-121.844-294.156-121.844zM512 0v0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question",
						"help",
						"support"
					],
					"defaultCode": 60755,
					"grid": 16
				},
				{
					"id": 1263,
					"width": 877.7139282226562,
					"paths": [
						"M512 786.286v-109.714q0-8-5.143-13.143t-13.143-5.143h-109.714q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h109.714q8 0 13.143-5.143t5.143-13.143zM658.286 402.286q0-50.286-31.714-93.143t-79.143-66.286-97.143-23.429q-138.857 0-212 121.714-8.571 13.714 4.571 24l75.429 57.143q4 3.429 10.857 3.429 9.143 0 14.286-6.857 30.286-38.857 49.143-52.571 19.429-13.714 49.143-13.714 27.429 0 48.857 14.857t21.429 33.714q0 21.714-11.429 34.857t-38.857 25.714q-36 16-66 49.429t-30 71.714v20.571q0 8 5.143 13.143t13.143 5.143h109.714q8 0 13.143-5.143t5.143-13.143q0-10.857 12.286-28.286t31.143-28.286q18.286-10.286 28-16.286t26.286-20 25.429-27.429 16-34.571 7.143-46.286zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question-circle"
					],
					"defaultCode": 61529,
					"grid": 14
				},
				{
					"id": 1790,
					"width": 877.7139282226562,
					"paths": [
						"M502.857 685.714v91.429q0 8-5.143 13.143t-13.143 5.143h-91.429q-8 0-13.143-5.143t-5.143-13.143v-91.429q0-8 5.143-13.143t13.143-5.143h91.429q8 0 13.143 5.143t5.143 13.143zM649.143 402.286q0 28.571-8.571 51.429t-26 39.429-29.714 25.143-34 20.571q-18.286 10.286-26.571 16t-14.857 13.714-6.571 16.571v18.286q0 8-5.143 13.143t-13.143 5.143h-91.429q-8 0-13.143-5.143t-5.143-13.143v-38.857q0-20 6-36.857t13.714-27.143 22.286-20.286 23.429-14.571 25.429-12q30.286-14.286 42.857-24.571t12.571-28q0-24-24.857-40.857t-54.571-16.857q-32 0-54.286 15.429-16.571 11.429-45.714 47.429-5.143 6.857-14.286 6.857-6.286 0-10.857-3.429l-61.714-46.857q-5.714-4-6.857-11.429t2.857-13.143q69.714-109.714 199.429-109.714 73.714 0 136.286 51.143t62.571 122.571zM438.857 146.286q-74.286 0-142 29.143t-116.571 78-78 116.571-29.143 142 29.143 142 78 116.571 116.571 78 142 29.143 142-29.143 116.571-78 78-116.571 29.143-142-29.143-142-78-116.571-116.571-78-142-29.143zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question-circle-o"
					],
					"defaultCode": 62108,
					"grid": 14
				},
				{
					"id": 220,
					"paths": [
						"M830.338 193.664c-91.869-91.869-214.016-142.464-343.938-142.464s-252.067 50.595-343.936 142.464-142.464 214.014-142.464 343.936 50.595 252.069 142.464 343.938 214.014 142.462 343.936 142.462 252.069-50.594 343.938-142.462 142.462-214.016 142.462-343.938-50.594-252.067-142.462-343.936zM486.4 972.8c-239.97 0-435.2-195.23-435.2-435.2s195.23-435.2 435.2-435.2c239.97 0 435.2 195.23 435.2 435.2s-195.23 435.2-435.2 435.2z",
						"M486.4 768c-14.138 0-25.6-11.461-25.6-25.6v-102.4c0-14.139 11.462-25.6 25.6-25.6 98.811 0 179.2-80.389 179.2-179.2s-80.389-179.2-179.2-179.2-179.2 80.389-179.2 179.2c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-127.043 103.357-230.4 230.4-230.4 127.042 0 230.4 103.357 230.4 230.4 0 118.389-89.763 216.211-204.8 228.987v78.213c0 14.139-11.462 25.6-25.6 25.6z",
						"M486.4 921.6c-0.002 0 0 0 0 0-14.139 0-25.6-11.462-25.6-25.6v-51.2c0-14.138 11.462-25.6 25.6-25.6 0 0 0 0 0 0 14.139 0 25.6 11.462 25.6 25.6v51.2c0 14.138-11.464 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question-circle",
						"help"
					],
					"defaultCode": 59517,
					"grid": 20
				},
				{
					"id": 2921,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.226 512 512 512c282.77 0 512-229.23 512-512s-229.23-512-512-512zM576 832h-128v-128h128v128zM768 512l-192 128h-128v-64l192-128v-64h-320v-128h384c35.346 0 64 28.654 64 64v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question",
						"help",
						"support"
					],
					"defaultCode": 60756,
					"grid": 16
				},
				{
					"id": 2922,
					"paths": [
						"M576 768c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64z",
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z",
						"M512 640.25c-26.51 0-48-21.49-48-48v-32c0-33.618 12.964-63.854 38.532-89.87 18.864-19.194 41.778-33.59 63.936-47.512 45.564-28.624 65.532-43.978 65.532-70.868 0-29.252-16.88-48.788-31.042-60.026-22.734-18.040-54.328-27.974-88.958-27.974-52.534 0-99.792 35.082-114.924 85.314-7.648 25.382-34.422 39.758-59.806 32.114-25.382-7.648-39.76-34.422-32.114-59.806 13.112-43.52 40.398-82.63 76.832-110.124 37.71-28.456 82.668-43.498 130.012-43.498 56.208 0 108.994 17.322 148.63 48.776 43.444 34.474 67.37 82.496 67.37 135.224 0 82.76-63.846 122.872-110.462 152.158-39.112 24.57-57.538 38.114-57.538 56.092v32c0 26.51-21.49 48-48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question",
						"help",
						"support"
					],
					"defaultCode": 60757,
					"grid": 16
				},
				{
					"id": 2923,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 832c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM617.538 504.158c-39.112 24.57-57.538 38.114-57.538 56.092v32c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-33.618 12.964-63.854 38.532-89.87 18.864-19.194 41.778-33.59 63.936-47.512 45.564-28.624 65.532-43.978 65.532-70.868 0-29.252-16.88-48.788-31.042-60.026-22.734-18.040-54.328-27.974-88.958-27.974-52.534 0-99.792 35.082-114.924 85.314-7.648 25.382-34.422 39.758-59.806 32.114-25.382-7.648-39.76-34.422-32.114-59.806 13.112-43.52 40.398-82.63 76.832-110.124 37.71-28.456 82.668-43.498 130.012-43.498 56.208 0 108.994 17.322 148.63 48.776 43.444 34.474 67.37 82.496 67.37 135.224 0 82.76-63.846 122.872-110.462 152.158z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question",
						"help",
						"support"
					],
					"defaultCode": 60758,
					"grid": 16
				},
				{
					"id": 2924,
					"paths": [
						"M384 832h192v192h-192zM800 64c53.020 0 96 42.98 96 96v288l-320 192v128h-192v-192l320-192v-128h-512v-192h608z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question",
						"help",
						"support"
					],
					"defaultCode": 60759,
					"grid": 16
				},
				{
					"id": 2925,
					"paths": [
						"M512 832c-35.346 0-64-28.652-64-63.998v-65.758c0-90.218 71.964-158.51 141.56-224.552 56.26-53.392 114.44-108.602 114.44-157.692 0-95.568-69.262-192-224-192-114.376 0-210.086 85.564-222.63 199.032-3.882 35.132-35.494 60.47-70.644 56.58-35.132-3.884-60.464-35.512-56.58-70.644 9.462-85.606 50.042-164.628 114.266-222.508 64.724-58.334 148.392-90.46 235.588-90.46 94.376 0 181.382 29.656 244.996 83.504 69.002 58.412 107.004 142.4 107.004 236.496 0 104.084-81.992 181.892-154.334 250.54-47.654 45.222-101.668 96.48-101.668 131.704l0.002 65.754c0 35.348-28.652 64.002-64 64.002z",
						"M576 960c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question",
						"help",
						"support"
					],
					"defaultCode": 60760,
					"grid": 16
				},
				{
					"id": 1443,
					"width": 636.5749053955078,
					"paths": [
						"M402.286 717.714v137.143q0 9.143-6.857 16t-16 6.857h-137.143q-9.143 0-16-6.857t-6.857-16v-137.143q0-9.143 6.857-16t16-6.857h137.143q9.143 0 16 6.857t6.857 16zM582.857 374.857q0 30.857-8.857 57.714t-20 43.714-31.429 34-32.857 24.857-34.857 20.286q-23.429 13.143-39.143 37.143t-15.714 38.286q0 9.714-6.857 18.571t-16 8.857h-137.143q-8.571 0-14.571-10.571t-6-21.429v-25.714q0-47.429 37.143-89.429t81.714-62q33.714-15.429 48-32t14.286-43.429q0-24-26.571-42.286t-61.429-18.286q-37.143 0-61.714 16.571-20 14.286-61.143 65.714-7.429 9.143-17.714 9.143-6.857 0-14.286-4.571l-93.714-71.429q-7.429-5.714-8.857-14.286t3.143-16q91.429-152 265.143-152 45.714 0 92 17.714t83.429 47.429 60.571 72.857 23.429 90.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"question"
					],
					"defaultCode": 61736,
					"grid": 14
				},
				{
					"id": 1837,
					"paths": [
						"M0 1024c128-384 463-1024 1024-1024-263 211-384 704-576 704s-192 0-192 0l-192 320h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quill",
						"feather",
						"write",
						"edit"
					],
					"defaultCode": 59672,
					"grid": 16
				},
				{
					"id": 1838,
					"paths": [
						"M0 1024h64l192-320c0 0 0 0 192 0s313-493 576-704c-561 0-896 640-1024 1024zM392 576h-72c0 0 177-320 448-448 0 0-243 215-376 448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quill",
						"feather",
						"write",
						"edit"
					],
					"defaultCode": 59673,
					"grid": 16
				},
				{
					"id": 1839,
					"paths": [
						"M1018.498 14.060c-5.952-8.792-15.878-14.060-26.498-14.060-139.288 0-270.688 22.364-390.55 66.468-120.674 44.404-226.834 109.8-315.532 194.372-187.050 178.35-285.918 443.16-285.918 763.16h96c0-59.146 46.816-256 128-256 49.744 0 147.864-4.89 246.12-37.642 105.658-35.218 182.812-92.378 229.32-169.894 4.994-8.322 5.94-18.46 2.572-27.564s-10.684-16.186-19.89-19.256c-1.27-0.424-21.538-7.050-57.74-11.604 102.498-45.976 216.154-112.736 267.058-197.576 5.216-8.694 6.004-19.344 2.124-28.708-3.878-9.366-11.968-16.34-21.802-18.798-1.716-0.43-30.612-7.544-74.426-11.878 119.918-61.080 195.398-128.748 224.376-201.192 3.942-9.862 2.74-21.036-3.214-29.828zM762.52 190.962c-84.598 42.4-162.944 66.156-163.714 66.388-16.65 4.996-26.268 22.37-21.66 39.13 4.606 16.762 21.756 26.772 38.618 22.564 35.212-8.804 74.070-13.268 115.498-13.268 28.582 0 54.428 2.156 75.1 4.728-44.27 46.666-117.226 93-214.484 135.868-96.764 42.65-183.438 66.52-184.294 66.752-16.636 4.538-26.686 21.442-22.724 38.224 3.96 16.786 20.51 27.402 37.418 24.028 45.124-9.026 89.268-13.602 131.206-13.602 25.262 0 46.556 1.688 63.404 3.826-110.994 127.72-325.252 138.4-392.888 138.4-75.882 0-122.386 65.314-149.504 127.802 28.656-211.83 115.576-391.144 255.586-524.642 82.324-78.494 181.060-139.266 293.468-180.628 96.382-35.464 200.946-55.988 311.544-61.202-34.422 42.99-92.954 85.728-172.574 125.632z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quill",
						"feather",
						"write",
						"edit"
					],
					"defaultCode": 59674,
					"grid": 16
				},
				{
					"id": 1840,
					"paths": [
						"M0 1024c0-146.61 24.154-300.694 71.788-426.418 46.046-121.534 112.876-228.736 198.634-318.626 84.922-89.014 185.74-158.31 299.652-205.966 115.772-48.432 241.578-72.99 373.926-72.99 5.44 0 10.508 2.764 13.454 7.338s3.364 10.332 1.114 15.284c-33.392 73.464-118.486 141.56-252.914 202.398-19.080 8.636-37.99 16.58-56.262 23.826 12.48-0.442 25.158-0.664 38.032-0.664 75.258 0 128.65 7.662 130.886 7.988 5.372 0.782 9.976 4.234 12.238 9.168 2.26 4.932 1.866 10.676-1.048 15.254-48.312 75.92-153.852 146.008-313.688 208.318-13.156 5.128-26.166 9.994-38.886 14.584 9.356-0.274 18.704-0.412 28.042-0.412 74.416 0 120.208 8.844 122.124 9.22 5.518 1.086 10.060 4.99 11.964 10.284 1.904 5.292 0.89 11.196-2.672 15.546-145.89 178.31-245.564 229.868-444.384 229.868-45.278 0-80.514 39.288-104.728 116.772-19.202 61.444-23.272 139.228-23.272 139.228z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quill",
						"feather",
						"write",
						"edit"
					],
					"defaultCode": 59675,
					"grid": 16
				},
				{
					"id": 1420,
					"width": 950.8570098876953,
					"paths": [
						"M438.857 548.571v219.429q0 45.714-32 77.714t-77.714 32h-219.429q-45.714 0-77.714-32t-32-77.714v-402.286q0-59.429 23.143-113.429t62.571-93.429 93.429-62.571 113.429-23.143h36.571q14.857 0 25.714 10.857t10.857 25.714v73.143q0 14.857-10.857 25.714t-25.714 10.857h-36.571q-60.571 0-103.429 42.857t-42.857 103.429v18.286q0 22.857 16 38.857t38.857 16h128q45.714 0 77.714 32t32 77.714zM950.857 548.571v219.429q0 45.714-32 77.714t-77.714 32h-219.429q-45.714 0-77.714-32t-32-77.714v-402.286q0-59.429 23.143-113.429t62.571-93.429 93.429-62.571 113.429-23.143h36.571q14.857 0 25.714 10.857t10.857 25.714v73.143q0 14.857-10.857 25.714t-25.714 10.857h-36.571q-60.571 0-103.429 42.857t-42.857 103.429v18.286q0 22.857 16 38.857t38.857 16h128q45.714 0 77.714 32t32 77.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quote-left"
					],
					"defaultCode": 61709,
					"grid": 14
				},
				{
					"id": 1421,
					"width": 950.8569793701172,
					"paths": [
						"M438.857 182.857v402.286q0 59.429-23.143 113.429t-62.571 93.429-93.429 62.571-113.429 23.143h-36.571q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h36.571q60.571 0 103.429-42.857t42.857-103.429v-18.286q0-22.857-16-38.857t-38.857-16h-128q-45.714 0-77.714-32t-32-77.714v-219.429q0-45.714 32-77.714t77.714-32h219.429q45.714 0 77.714 32t32 77.714zM950.857 182.857v402.286q0 59.429-23.143 113.429t-62.571 93.429-93.429 62.571-113.429 23.143h-36.571q-14.857 0-25.714-10.857t-10.857-25.714v-73.143q0-14.857 10.857-25.714t25.714-10.857h36.571q60.571 0 103.429-42.857t42.857-103.429v-18.286q0-22.857-16-38.857t-38.857-16h-128q-45.714 0-77.714-32t-32-77.714v-219.429q0-45.714 32-77.714t77.714-32h219.429q45.714 0 77.714 32t32 77.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quote-right"
					],
					"defaultCode": 61710,
					"grid": 14
				},
				{
					"id": 2352,
					"paths": [
						"M225 448c123.712 0 224 100.29 224 224 0 123.712-100.288 224-224 224s-224-100.288-224-224l-1-32c0-247.424 200.576-448 448-448v128c-85.474 0-165.834 33.286-226.274 93.726-11.634 11.636-22.252 24.016-31.83 37.020 11.438-1.8 23.16-2.746 35.104-2.746zM801 448c123.71 0 224 100.29 224 224 0 123.712-100.29 224-224 224s-224-100.288-224-224l-1-32c0-247.424 200.576-448 448-448v128c-85.474 0-165.834 33.286-226.274 93.726-11.636 11.636-22.254 24.016-31.832 37.020 11.44-1.8 23.16-2.746 35.106-2.746z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quotes-left",
						"ldquo"
					],
					"defaultCode": 60187,
					"grid": 16
				},
				{
					"id": 2354,
					"paths": [
						"M384 64v896h-384v-448zM960 64v896h-384v-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quotes-left",
						"ldquo"
					],
					"defaultCode": 60189,
					"grid": 16
				},
				{
					"id": 2353,
					"paths": [
						"M800 640c-123.712 0-224-100.29-224-224 0-123.712 100.288-224 224-224s224 100.288 224 224l1 32c0 247.424-200.576 448-448 448v-128c85.474 0 165.834-33.286 226.274-93.726 11.634-11.636 22.252-24.016 31.83-37.020-11.438 1.8-23.16 2.746-35.104 2.746zM224 640c-123.71 0-224-100.29-224-224 0-123.712 100.29-224 224-224s224 100.288 224 224l1 32c0 247.424-200.576 448-448 448v-128c85.474 0 165.834-33.286 226.274-93.726 11.636-11.636 22.254-24.016 31.832-37.020-11.44 1.8-23.16 2.746-35.106 2.746z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quotes-right",
						"rdquo"
					],
					"defaultCode": 60188,
					"grid": 16
				},
				{
					"id": 2355,
					"paths": [
						"M576 960v-896h384v448zM0 960v-896h384v448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quotes-right",
						"rdquo"
					],
					"defaultCode": 60190,
					"grid": 16
				},
				{
					"id": 1600,
					"width": 1022.8528137207031,
					"paths": [
						"M10.857 499.429q4.571-124 66.286-232t174.286-181.714h2.857q0 0.571-0.571 1.714-4.571 4.571-16 19.143t-29.714 43.714-34.286 63.143-25.429 77.429-8 86 22.286 90 62 88q28.571 28.571 58.286 39.714t51.714 6.571 39.714-13.429 26.857-18.571l9.143-9.143q22.286-29.143 30.286-66.571t3.714-70-12-61.143-15.143-45.714l-8-16.571q-5.714-14.286-17.429-28.286t-24.571-23.429-24.857-16.857-20-10.857l-7.429-3.429 59.429-65.714q22.286 9.714 44.571 29.714t33.714 34.857l10.857 15.429q0.571-27.429-10.571-59.143t-23.143-50l-11.429-17.714 92-104.571 91.429 103.429q-18.857 26.286-30 58.571t-12.857 51.714l-2.286 18.857q12.571-21.143 35.143-41.429t38.571-30l16-9.714 58.857 65.714q-25.143 8-48.571 28.571t-34.286 37.143l-10.857 16.571q-17.714 32-27.429 76.286t-4 97.143 32.571 89.429q18.857 25.714 44.286 34.571t48.571 3.143 43.429-15.143 32.857-19.143l12-9.143q34.286-30.286 55.143-65.714t27.714-69.429 5.714-69.429-10.286-67.429-21.143-61.429-26-53.143-25.714-41.143-19.714-27.143l-7.429-9.714q-8-7.429-4-7.429l5.714 1.714q22.857 16.571 35.714 26.286t35.429 28.571 36.571 33.143 33.429 37.143 31.714 44 26 50.286 21.714 58.857 13.429 66.857 6 77.714q1.714 148-61.714 265.714t-178.286 183.429-260.571 65.714q-105.714 0-200.571-42.286t-162-113.143-105.143-167.429-34.571-201.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ra",
						"rebel",
						"resistance"
					],
					"defaultCode": 61904,
					"grid": 14
				},
				{
					"id": 2648,
					"paths": [
						"M384 192h128v128h-128v-128zM512 320v128c64 0 64 64 128 64v-128c-64 0-64-64-128-64zM640 256h128v128h-128v-128zM640 64c-32 0-48-16-64-32s-32-32-64-32h-320v640h320c32 0 48 16 64 32s32 32 64 32h320v-640h-320zM896 384h-128v128h128v128h-128v-128h-128v128c-32 0-48-16-64-32s-32-32-64-32v-128h-128v128h-128v-128h128v-128h-128v-128h128v-128h128v128c32 0 48 16 64 32s32 32 64 32v-128h128v128h128v128z",
						"M0 0h128v1024h-128v-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"racing",
						"soprts",
						"flag",
						"sports"
					],
					"defaultCode": 60483,
					"grid": 16
				},
				{
					"id": 725,
					"width": 1024,
					"paths": [
						"M512 192c-176.736 0-320 143.264-320 320s143.264 320 320 320 320-143.264 320-320-143.264-320-320-320zM512 800c-158.816 0-288-129.184-288-288s129.184-288 288-288 288 129.184 288 288c0 158.816-129.184 288-288 288zM322.72 88.832c-3.36-8.16 0.512-17.536 8.672-20.896 8.256-3.36 17.536 0.512 20.896 8.672l36.704 88.704c3.36 8.16-0.512 17.536-8.672 20.896-1.984 0.832-4.096 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888l-36.704-88.704zM701.28 919.168c3.36 8.16-0.512 17.536-8.672 20.896-1.984 0.832-4.096 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888l-36.704-88.704c-3.36-8.16 0.512-17.536 8.672-20.896 8.192-3.392 17.536 0.544 20.896 8.672l36.704 88.704zM75.936 323.36c3.36-8.128 12.736-12.032 20.896-8.672l88.672 36.736c8.16 3.36 12.032 12.736 8.672 20.896-2.56 6.144-8.512 9.888-14.784 9.888-2.016 0-4.128-0.384-6.112-1.216l-88.672-36.736c-8.16-3.36-12.032-12.704-8.672-20.896zM948.064 684.64c-2.56 6.144-8.512 9.888-14.784 9.888-2.016 0-4.128-0.384-6.112-1.216l-88.672-36.736c-8.16-3.36-12.032-12.736-8.672-20.896 3.36-8.128 12.736-12.064 20.896-8.672l88.672 36.736c8.16 3.36 12.032 12.704 8.672 20.896zM194.176 635.648c3.36 8.16-0.512 17.536-8.672 20.896l-88.672 36.736c-1.984 0.832-4.096 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888-3.36-8.16 0.512-17.536 8.672-20.896l88.672-36.736c8.192-3.392 17.536 0.544 20.896 8.672zM829.824 372.352c-3.36-8.16 0.512-17.536 8.672-20.896l88.672-36.736c8.224-3.36 17.536 0.512 20.896 8.672s-0.512 17.536-8.672 20.896l-88.672 36.736c-1.984 0.832-4.096 1.216-6.112 1.216-6.304 0-12.224-3.712-14.784-9.888zM388.992 842.72l-36.704 88.704c-2.56 6.144-8.512 9.888-14.784 9.888-2.016 0-4.128-0.384-6.112-1.216-8.16-3.36-12.032-12.736-8.672-20.896l36.704-88.704c3.36-8.128 12.768-12.064 20.896-8.672 8.192 3.36 12.064 12.736 8.672 20.896zM635.008 165.28l36.704-88.704c3.392-8.16 12.704-12.032 20.896-8.672 8.16 3.36 12.032 12.736 8.672 20.896l-36.704 88.704c-2.56 6.144-8.512 9.888-14.784 9.888-2.016 0-4.128-0.384-6.112-1.216-8.192-3.36-12.064-12.736-8.672-20.896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"radiate",
						"shine",
						"warm"
					],
					"grid": 32
				},
				{
					"id": 726,
					"width": 1024,
					"paths": [
						"M512 192c-176.736 0-320 143.264-320 320s143.264 320 320 320 320-143.264 320-320-143.264-320-320-320zM322.72 88.832c-3.36-8.16 0.512-17.536 8.672-20.896 8.256-3.36 17.536 0.512 20.896 8.672l36.704 88.704c3.36 8.16-0.512 17.536-8.672 20.896-1.984 0.832-4.096 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888l-36.704-88.704zM701.28 919.168c3.36 8.16-0.512 17.536-8.672 20.896-1.984 0.832-4.096 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888l-36.704-88.704c-3.36-8.16 0.512-17.536 8.672-20.896 8.192-3.392 17.536 0.544 20.896 8.672l36.704 88.704zM75.936 323.36c3.36-8.128 12.736-12.032 20.896-8.672l88.672 36.736c8.16 3.36 12.032 12.736 8.672 20.896-2.56 6.144-8.512 9.888-14.784 9.888-2.016 0-4.128-0.384-6.112-1.216l-88.672-36.736c-8.16-3.36-12.032-12.704-8.672-20.896zM948.064 684.64c-2.56 6.144-8.512 9.888-14.784 9.888-2.016 0-4.128-0.384-6.112-1.216l-88.672-36.736c-8.16-3.36-12.032-12.736-8.672-20.896 3.36-8.128 12.736-12.064 20.896-8.672l88.672 36.736c8.16 3.36 12.032 12.704 8.672 20.896zM194.176 635.648c3.36 8.16-0.512 17.536-8.672 20.896l-88.672 36.736c-1.984 0.832-4.096 1.216-6.112 1.216-6.272 0-12.224-3.712-14.784-9.888-3.36-8.16 0.512-17.536 8.672-20.896l88.672-36.736c8.192-3.392 17.536 0.544 20.896 8.672zM829.824 372.352c-3.36-8.16 0.512-17.536 8.672-20.896l88.672-36.736c8.224-3.36 17.536 0.512 20.896 8.672s-0.512 17.536-8.672 20.896l-88.672 36.736c-1.984 0.832-4.096 1.216-6.112 1.216-6.304 0-12.224-3.712-14.784-9.888zM388.992 842.72l-36.704 88.704c-2.56 6.144-8.512 9.888-14.784 9.888-2.016 0-4.128-0.384-6.112-1.216-8.16-3.36-12.032-12.736-8.672-20.896l36.704-88.704c3.36-8.128 12.768-12.064 20.896-8.672 8.192 3.36 12.064 12.736 8.672 20.896zM635.008 165.28l36.704-88.704c3.392-8.16 12.704-12.032 20.896-8.672 8.16 3.36 12.032 12.736 8.672 20.896l-36.704 88.704c-2.56 6.144-8.512 9.888-14.784 9.888-2.016 0-4.128-0.384-6.112-1.216-8.192-3.36-12.064-12.736-8.672-20.896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"radiate",
						"shine",
						"warm"
					],
					"grid": 32
				},
				{
					"id": 2194,
					"paths": [
						"M960 320h-655.92l635.408-258.132c15.836-6.458 23.926-24.364 18.036-40.582-6.036-16.614-24.396-25.188-41.012-19.154l-869.774 320.268c-26.882 7.584-46.738 32.378-46.738 61.6v576c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-576c0-35.2-28.8-64-64-64zM128 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64zM128 768c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64zM192 448v64h-128v-128h448v128h-256v-64h-64zM736 960c-123.71 0-224-100.29-224-224s100.29-224 224-224 224 100.29 224 224-100.288 224-224 224z",
						"M704 608c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M832 608c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M704 736c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M640 672c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M768 672c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M832 736c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M704 864c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M832 864c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M896 672c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M640 800c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M768 800c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M896 800c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"radio"
					],
					"defaultCode": 60029,
					"grid": 16
				},
				{
					"id": 3206,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM320 512c0-106.039 85.961-192 192-192s192 85.961 192 192c0 106.039-85.961 192-192 192s-192-85.961-192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"radio-checked",
						"radio-button"
					],
					"defaultCode": 61041,
					"grid": 16
				},
				{
					"id": 3207,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 640c-70.692 0-128-57.306-128-128 0-70.692 57.308-128 128-128 70.694 0 128 57.308 128 128 0 70.694-57.306 128-128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"radio-checked",
						"radio-button"
					],
					"defaultCode": 61042,
					"grid": 16
				},
				{
					"id": 3208,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"radio-unchecked",
						"radio-button",
						"circle"
					],
					"defaultCode": 61043,
					"grid": 16
				},
				{
					"id": 727,
					"width": 1024,
					"paths": [
						"M768 320c0-141.376-114.624-256-256-256-119.712 0-219.936 82.304-247.936 193.312-112.448 11.968-200.064 107.072-200.064 222.688 0 117.888 91.136 214.304 206.752 223.136-8.864 19.328-14.752 41.12-14.752 64.864 0 53.024 42.976 96 96 96s96-42.976 96-96c0-23.68-5.504-45.056-13.728-64l337.056-0.16c104.48-1.792 188.672-86.912 188.672-191.84 0-106.048-85.952-192-192-192zM352 832c-35.296 0-64-28.704-64-64 0-54.592 40.416-98.336 64.416-119.52 23.84 20.352 63.584 62.848 63.584 119.52 0 35.296-28.704 64-64 64zM760.864 672h-344.256c-14.336-21.024-30.912-37.28-43.712-48.16-11.936-10.144-29.568-9.984-41.312 0.384-12.48 10.976-28.704 27.232-42.944 47.776h-0.64c-79.488 0-153.504-47.712-179.872-122.688-44.512-126.528 39.264-247.392 159.328-260.16l22.176-2.368 3.776-14.944c22.656-89.792 95.552-161.216 187.296-173.696 137.376-18.72 255.296 88.064 255.296 221.856v32h32c93.504 0 168.512 80.608 159.232 175.968-8.128 83.136-82.848 144.032-166.368 144.032zM619.68 720.064c-25.152 22.080-65.728 65.664-74.144 122.816-8.224 55.872 29.472 111.776 85.696 116.736 56.992 5.024 104.768-39.712 104.768-95.616 0-69.664-46.592-119.936-74.848-144-12-10.208-29.632-10.336-41.472 0.064zM640 928c-35.296 0-64-28.704-64-64 0-54.592 40.416-98.336 64.416-119.52 23.84 20.352 63.584 62.848 63.584 119.52 0 35.296-28.704 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rain",
						"hail",
						"shower",
						"drizzle"
					],
					"grid": 32
				},
				{
					"id": 728,
					"width": 1024,
					"paths": [
						"M448 768c0 53.024-42.976 96-96 96-2.88 0-5.792-0.128-8.736-0.384-56.256-4.96-93.92-60.896-85.696-116.736 8.416-57.152 48.992-100.736 74.144-122.816 5.888-5.184 13.248-7.744 20.64-7.744s14.816 2.592 20.8 7.68c28.256 24.064 74.848 74.336 74.848 144zM661.152 720c-11.968-10.208-29.632-10.304-41.44 0.064-25.152 22.080-65.728 65.664-74.144 122.816-8.224 55.872 29.472 111.776 85.696 116.736 56.96 5.024 104.736-39.712 104.736-95.616 0-69.664-46.592-119.936-74.848-144zM768 320c0-141.376-114.624-256-256-256-119.712 0-219.936 82.304-247.936 193.312-112.448 11.968-200.064 107.072-200.064 222.688 0 106.592 74.56 195.424 174.304 218.016 18.624-45.504 51.264-79.584 72.256-98.016 11.52-10.112 26.368-15.68 41.728-15.68 15.2 0 29.952 5.44 41.568 15.328 23.040 19.616 56.992 55.36 74.56 104.352l302.88-0.16c104.512-1.792 188.704-86.912 188.704-191.84 0-106.048-85.952-192-192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rain",
						"hail",
						"shower",
						"drizzle"
					],
					"grid": 32
				},
				{
					"id": 1092,
					"width": 1024,
					"paths": [
						"M160 704h32v32h-32v-32zM160 800h32v-32h-32v32zM160 864h32v-32h-32v32zM160 928h32v-32h-32v32zM224 768h32v-32h-32v32zM224 832h32v-32h-32v32zM224 896h32v-32h-32v32zM224 960h32v-32h-32v32zM288 736h32v-32h-32v32zM288 800h32v-32h-32v32zM288 864h32v-32h-32v32zM288 928h32v-32h-32v32zM352 768h32v-32h-32v32zM352 832h32v-32h-32v32zM352 896h32v-32h-32v32zM352 960h32v-32h-32v32zM416 736h32v-32h-32v32zM416 800h32v-32h-32v32zM416 864h32v-32h-32v32zM416 928h32v-32h-32v32zM480 768h32v-32h-32v32zM480 832h32v-32h-32v32zM480 896h32v-32h-32v32zM480 960h32v-32h-32v32zM544 736h32v-32h-32v32zM544 800h32v-32h-32v32zM544 864h32v-32h-32v32zM544 928h32v-32h-32v32zM608 768h32v-32h-32v32zM608 832h32v-32h-32v32zM608 896h32v-32h-32v32zM608 960h32v-32h-32v32zM672 736h32v-32h-32v32zM672 800h32v-32h-32v32zM672 864h32v-32h-32v32zM672 928h32v-32h-32v32zM800 736h32v-32h-32v32zM800 800h32v-32h-32v32zM800 864h32v-32h-32v32zM800 928h32v-32h-32v32zM736 768h32v-32h-32v32zM736 832h32v-32h-32v32zM736 896h32v-32h-32v32zM736 960h32v-32h-32v32zM1024 480c0 105.888-86.112 192-192 192h-608c-123.52 0-224-100.48-224-224 0-128.384 110.112-232.224 238.624-223.52 41.248-131.68 165.248-224.48 305.376-224.48 166.496 0 303.68 127.808 318.656 290.432 91.328 14.72 161.344 94.144 161.344 189.568zM960 480c0-70.592-57.408-128-128-128-17.664 0-32-14.336-32-32 0-141.152-114.848-256-256-256-120.096 0-225.344 85.184-250.304 202.528-3.68 17.152-20.512 28.192-37.664 24.704-10.56-2.144-21.312-3.232-32.032-3.232-88.224 0-160 71.776-160 160s71.776 160 160 160h608c70.592 0 128-57.408 128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rain",
						"hail",
						"shower",
						"drizzle"
					],
					"grid": 32
				},
				{
					"id": 1288,
					"width": 1023.9998998641968,
					"paths": [
						"M380.571 274.857q-34.286 52.571-78.286 156-12.571-25.714-21.143-41.429t-23.143-36.286-29.143-32.286-36-20-46.571-8.286h-128q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h128q142.857 0 234.286 128.571zM1024 731.429q0 8-5.143 13.143l-182.857 182.857q-5.143 5.143-13.143 5.143-7.429 0-12.857-5.429t-5.429-12.857v-109.714q-18.286 0-48.571 0.286t-46.286 0.571-41.714-0.571-40.571-2.857-36.571-6-36-10.571-33.143-16.286-33.714-22.857-31.429-30.571-32-39.714q33.714-53.143 77.714-156 12.571 25.714 21.143 41.429t23.143 36.286 29.143 32.286 36 20 46.571 8.286h146.286v-109.714q0-8 5.143-13.143t13.143-5.143q6.857 0 13.714 5.714l182.286 182.286q5.143 5.143 5.143 13.143zM1024 219.429q0 8-5.143 13.143l-182.857 182.857q-5.143 5.143-13.143 5.143-7.429 0-12.857-5.429t-5.429-12.857v-109.714h-146.286q-27.429 0-49.714 8.571t-39.429 25.714-29.143 35.143-25.714 44.286q-18.286 35.429-44.571 97.714-16.571 37.714-28.286 63.429t-30.857 60-36.571 57.143-42.286 47.429-51.429 39.143-60.857 24-73.143 9.429h-128q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h128q27.429 0 49.714-8.571t39.429-25.714 29.143-35.143 25.714-44.286q18.286-35.429 44.571-97.714 16.571-37.714 28.286-63.429t30.857-60 36.571-57.143 42.286-47.429 51.429-39.143 60.857-24 73.143-9.429h146.286v-109.714q0-8 5.143-13.143t13.143-5.143q6.857 0 13.714 5.714l182.286 182.286q5.143 5.143 5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"random"
					],
					"defaultCode": 61556,
					"grid": 14
				},
				{
					"id": 2478,
					"paths": [
						"M64 832v128l448-224 448 224v-128l-448-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rating",
						"ranking",
						"rate",
						"standing"
					],
					"defaultCode": 60313,
					"grid": 16
				},
				{
					"id": 2479,
					"paths": [
						"M64 832v128l448-224 448 224v-128l-448-224zM64 576v128l448-224 448 224v-128l-448-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rating",
						"ranking",
						"rate",
						"standing"
					],
					"defaultCode": 60314,
					"grid": 16
				},
				{
					"id": 2480,
					"paths": [
						"M64 832v128l448-224 448 224v-128l-448-224zM64 576v128l448-224 448 224v-128l-448-224zM512 96l-448 224v128l448-224 448 224v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rating",
						"ranking",
						"rate",
						"standing"
					],
					"defaultCode": 60315,
					"grid": 16
				},
				{
					"id": 1093,
					"width": 1024,
					"paths": [
						"M864 704c-32.544 0-62.784 9.888-88.096 26.656l-180.896-180.896c48.064-58.112 76.992-132.608 76.992-213.76 0-185.28-150.72-336-336-336s-336 150.72-336 336 150.72 336 336 336c81.152 0 155.648-28.928 213.76-76.992l180.896 180.896c-16.768 25.312-26.656 55.552-26.656 88.096 0 88.224 71.776 160 160 160s160-71.776 160-160-71.776-160-160-160zM192 566.336c-11.232-7.040-21.952-14.752-32-23.328v-127.008h160v-160h160v-150.336c11.232 7.040 21.952 14.752 32 23.328v159.008h-160v160h-160v118.336zM64 336c0-149.984 122.016-272 272-272 39.936 0 77.792 8.864 112 24.416v135.584h-160v160h-160v126.912c-39.872-47.328-64-108.32-64-174.912zM224 583.584v-103.584h160v-160h160v-158.912c39.872 47.328 64 108.32 64 174.912 0 149.984-122.016 272-272 272-39.936 0-77.792-8.864-112-24.416zM864 960c-52.928 0-96-43.072-96-96s43.072-96 96-96 96 43.072 96 96-43.072 96-96 96zM864 800c-35.296 0-64 28.704-64 64s28.704 64 64 64c35.296 0 64-28.704 64-64s-28.704-64-64-64zM864 896c-17.664 0-32-14.336-32-32s14.336-32 32-32c17.664 0 32 14.336 32 32s-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rattle",
						"play",
						"sound",
						"shake",
						"annoy"
					],
					"grid": 32
				},
				{
					"id": 729,
					"width": 1024,
					"paths": [
						"M928 128h-832c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h320c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32h320c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM928 160v640h-329.344c-19.776 0-39.552 4.672-57.248 13.504l-13.408 6.72v-660.224h400zM496 160v660.224l-13.408-6.72c-17.696-8.832-37.472-13.504-57.248-13.504h-329.344v-640h400zM992 800c0 35.296-28.704 64-64 64h-352v32h-128v-32h-352c-35.296 0-64-28.704-64-64v-576c0-23.584 12.96-44 32-55.104v631.104c0 17.664 14.336 32 32 32h329.344c14.912 0 29.6 3.456 42.944 10.144l29.408 14.72c4.512 2.24 9.408 3.392 14.304 3.392s9.792-1.12 14.304-3.392l29.408-14.72c13.344-6.688 28.032-10.144 42.944-10.144h329.344c17.664 0 32-14.336 32-32v-631.104c19.040 11.104 32 31.52 32 55.104v576zM192 400c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16zM192 464c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16zM192 528c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16zM640 400c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16zM640 464c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16zM640 528c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"read",
						"publish",
						"study"
					],
					"grid": 32
				},
				{
					"id": 730,
					"width": 1024,
					"paths": [
						"M475.84 810.144l20.16 10.080v-692.224h-400v672h336.896c14.816 0 29.664 3.52 42.944 10.144zM368 544h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16zM368 480h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16zM368 416h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16zM1024 224v576c0 53.024-42.976 96-96 96h-320c0 17.664-14.336 32-32 32h-128c-17.664 0-32-14.336-32-32h-320c-53.024 0-96-42.976-96-96v-576c0-41.728 26.784-76.896 64-90.112v666.112c0 17.664 14.336 32 32 32h336.896c9.952 0 19.744 2.304 28.64 6.752l36.16 18.080c4.512 2.24 9.408 3.392 14.304 3.392s9.792-1.12 14.304-3.392l36.192-18.080c8.864-4.448 18.688-6.752 28.608-6.752h336.896c17.664 0 32-14.336 32-32v-666.112c37.216 13.216 64 48.384 64 90.112zM528 128v692.224l20.192-10.080c13.248-6.656 28.096-10.144 42.912-10.144h336.896v-672h-400zM816 544h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16zM816 480h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16zM816 416h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"read",
						"publish",
						"study"
					],
					"grid": 32
				},
				{
					"id": 1094,
					"width": 1024,
					"paths": [
						"M896 0h-640l-118.624 118.624c-6.016 6.016-9.376 14.144-9.376 22.624v850.752c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-32l32-32h32c17.664 0 32-14.336 32-32v-864c0-17.664-14.336-32-32-32zM192 154.496l64-64v782.88l-64 64v-782.88zM214.624 960l64-64h526.88l-64 64h-526.88zM864 864h-576v-800h576v800zM736 288h-320v-32h320v32zM736 384h-320v-32h320v32zM736 480h-320v-32h320v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"read",
						"study"
					],
					"grid": 32
				},
				{
					"id": 1964,
					"paths": [
						"M352 160c0-88.366 71.634-160 160-160s160 71.634 160 160c0 88.366-71.634 160-160 160s-160-71.634-160-160zM1009.976 728.020l-256-320c-12.63-15.788-31.212-23.994-49.968-24.008l-0.008-0.012-384.008 0.014c-18.756 0.014-37.338 8.22-49.968 24.004l-256 320c-16.804 21.004-18.68 50.276-4.696 73.254 11.762 19.326 32.628 30.73 54.658 30.73 4.164 0 8.372-0.408 12.564-1.246l179.45-35.888v229.132h512v-229.132l179.45 35.89c4.194 0.838 8.398 1.246 12.562 1.246 22.030 0 42.898-11.406 54.658-30.73 13.986-22.978 12.11-52.25-4.694-73.254zM704 651.534l-51.45-10.292c-34.65-6.936-68.376 15.544-75.308 50.208-6.932 34.66 15.546 68.376 50.208 75.308l76.55 15.31v49.932l-192 64-192-64v-49.932l76.552-15.31c34.66-6.932 57.138-40.648 50.206-75.308-6.932-34.662-40.652-57.128-75.308-50.208l-51.45 10.292v-139.534l192 64 192-64v139.534z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reading",
						"library",
						"student",
						"book"
					],
					"defaultCode": 59799,
					"grid": 16
				},
				{
					"id": 731,
					"width": 1024,
					"paths": [
						"M512 32c-212.064 0-352 171.936-352 384 0 184.736 152.352 325.92 205.76 369.76 6.816 5.6 14.752 9.408 23.136 11.712l18.176 109.056c5.152 30.848 31.872 53.472 63.136 53.472h9.792c0 17.664 14.336 32 32 32v0c17.664 0 32-14.336 32-32h9.792c31.296 0 57.984-22.624 63.136-53.472l18.176-109.056c8.384-2.304 16.32-6.112 23.136-11.712 53.408-43.84 205.76-185.024 205.76-369.76 0-212.064-139.936-384-352-384zM553.792 928h-83.584c-15.648 0-28.992-11.296-31.552-26.752l-16.896-101.248h180.448l-16.864 101.248c-2.56 15.424-15.904 26.752-31.552 26.752zM637.952 761.024c-5.504 4.512-12.576 6.976-19.968 6.976h-211.968c-7.392 0-14.464-2.464-19.936-6.976-45.536-37.344-194.080-172.64-194.080-345.024 0-203.968 134.592-352 320-352s320 148.032 320 352c0 172.384-148.544 307.68-194.048 345.024zM608 544c-13.28 0-25.6 4.032-35.84 10.976-8.704-24.96-32.224-42.976-60.16-42.976s-51.456 18.016-60.16 42.976c-10.24-6.944-22.56-10.976-35.84-10.976-35.36 0-64 28.64-64 64s28.64 64 64 64c11.712 0 22.56-3.392 32-8.864v104.864h32v-136.896c9.44 5.504 20.288 8.896 32 8.896s22.56-3.392 32-8.864v136.864h32v-104.864c9.44 5.472 20.288 8.864 32 8.864 35.36 0 64-28.64 64-64s-28.64-64-64-64zM416 640c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM512 608c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.336 32-32 32zM608 640c-17.632 0-32-14.368-32-32s14.368-32 32-32c17.632 0 32 14.368 32 32s-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"realize",
						"light",
						"think",
						"glow"
					],
					"grid": 32
				},
				{
					"id": 732,
					"width": 1024,
					"paths": [
						"M634.656 800l-17.76 106.528c-5.12 30.848-31.808 53.472-63.104 53.472h-9.792c0 17.664-14.336 32-32 32s-32-14.336-32-32h-9.792c-31.296 0-57.984-22.624-63.136-53.472l-17.728-106.528h245.312zM480 768c22.080 0 44.128 0 64 0v-136.864c-9.44 5.472-20.288 8.864-32 8.864s-22.56-3.392-32-8.864v136.864zM544 576c0-17.632-14.368-32-32-32s-32 14.368-32 32 14.368 32 32 32 32-14.368 32-32zM640 608c0-17.632-14.368-32-32-32s-32 14.368-32 32 14.368 32 32 32c17.664 0 32-14.368 32-32zM512 32c-212.064 0-352 171.936-352 384 0 149.536 99.68 270.368 166.016 334.272 11.936 11.488 27.744 17.728 44.32 17.728h77.664v-104.864c-14.432 8.416-32.16 11.872-51.264 5.856-22.4-7.040-40-26.88-43.808-50.048-6.656-40.192 24.16-74.944 63.072-74.944 13.28 0 25.6 4.032 35.84 10.976 8.704-24.96 32.224-42.976 60.16-42.976s51.456 18.016 60.16 42.976c10.24-6.944 22.56-10.976 35.84-10.976 38.912 0 69.728 34.752 63.104 74.912-3.84 23.168-21.44 43.008-43.808 50.048-19.136 6.016-36.832 2.56-51.264-5.856v104.896h77.664c16.576 0 32.384-6.24 44.32-17.728 66.304-63.904 165.984-184.736 165.984-334.272 0-212.064-139.936-384-352-384zM384 608c0 17.632 14.368 32 32 32s32-14.368 32-32-14.368-32-32-32-32 14.368-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"realize",
						"light",
						"think",
						"glow"
					],
					"grid": 32
				},
				{
					"id": 733,
					"width": 1024,
					"paths": [
						"M864 336c0 8.832-7.168 16-16 16h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16zM960 304v336c0 17.664-14.336 32-32 32h-384v256c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32v-256h-320c-17.664 0-32-14.336-32-32v-336c0-79.52 64.48-144 144-144h208v-64c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32v64h208c79.52 0 144 64.48 144 144zM448 352h64v-160h64v-96h-128v256zM512 672h-64v256h64v-256zM640 640v-336c0-45.504 21.536-85.6 54.496-112h-86.496c0 17.664-14.336 32-32 32h-32v128c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32v-160h-208c-61.76 0-112 50.24-112 112v336h544zM928 304c0-61.76-50.24-112-112-112h-32c-61.76 0-112 50.24-112 112v336h256v-336z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"receive",
						"send"
					],
					"grid": 32
				},
				{
					"id": 734,
					"width": 1024,
					"paths": [
						"M544 704v224c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32v-224h128zM608 672v-368c0-59.52 29.792-112.128 75.136-144h-75.136c0 35.296-28.704 64-64 64v128c0 35.296-28.704 64-64 64h-32c-35.296 0-64-28.704-64-64v-192h-176c-79.52 0-144 64.48-144 144v336c0 17.664 14.336 32 32 32h512zM960 304v336c0 17.664-14.336 32-32 32h-288v-368c0-79.392 64.608-144 144-144h32c79.52 0 144 64.48 144 144zM864 336c0-8.832-7.168-16-16-16h-96c-8.832 0-16 7.168-16 16s7.168 16 16 16h96c8.832 0 16-7.168 16-16zM416 96v256c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-160h32c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"receive",
						"send"
					],
					"grid": 32
				},
				{
					"id": 1095,
					"width": 1024,
					"paths": [
						"M800 160h-96v-64c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v64h-224c-123.52 0-224 100.48-224 224v352c0 17.664 14.336 32 32 32h352v160c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-160h352c17.664 0 32-14.336 32-32v-352c0-123.52-100.48-224-224-224zM512 128h128v96h-64v192h-64v-288zM384 704h-320v-320c0-88.224 71.776-160 160-160s160 71.776 160 160v320zM576 896h-128v-160h128v160zM960 704h-544v-320c0-66.816-34.176-125.6-85.952-160h149.952v224h128v-192h64v-32h130.464v0.256c87.072 1.344 157.536 72.352 157.536 159.744v320zM160 352h128v32h-128v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"receive",
						"send"
					],
					"grid": 32
				},
				{
					"id": 735,
					"width": 1024,
					"paths": [
						"M896 192h-768c-53.024 0-96 42.976-96 96v448c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-448c0-53.024-42.976-96-96-96zM271.264 800l22.304-55.776c9.792-24.448 33.12-40.224 59.424-40.224h318.016c26.336 0 49.632 15.776 59.424 40.224l22.304 55.776h-481.472zM960 736c0 35.296-28.704 64-64 64h-108.8l-27.072-67.648c-14.56-36.448-49.856-60.352-89.12-60.352h-318.016c-39.264 0-74.56 23.904-89.12 60.352l-27.072 67.648h-108.8c-35.296 0-64-28.704-64-64v-448c0-35.296 28.704-64 64-64h768c35.296 0 64 28.704 64 64v448zM736 384h-448c-53.024 0-96 42.976-96 96s42.976 96 96 96h448c53.024 0 96-42.976 96-96s-42.976-96-96-96zM664.928 416c-15.328 17.024-24.928 39.296-24.928 64s9.6 46.976 24.928 64h-305.824c15.296-17.024 24.896-39.296 24.896-64s-9.6-46.976-24.928-64h305.856zM224 480c0-35.296 28.704-64 64-64s64 28.704 64 64c0 35.296-28.704 64-64 64s-64-28.704-64-64zM736 544c-35.296 0-64-28.704-64-64s28.704-64 64-64c35.296 0 64 28.704 64 64s-28.704 64-64 64zM160 736c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM96 288c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM928 736c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM928 288c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"record",
						"play",
						"mix",
						"tape"
					],
					"grid": 32
				},
				{
					"id": 736,
					"width": 1024,
					"paths": [
						"M800 480c0 35.296-28.704 64-64 64s-64-28.704-64-64c0-35.296 28.704-64 64-64s64 28.704 64 64zM288 416c-35.296 0-64 28.704-64 64s28.704 64 64 64c35.296 0 64-28.704 64-64s-28.704-64-64-64zM992 288v448c0 53.024-42.976 96-96 96h-96.16l-39.68-99.648c-14.592-36.448-49.888-60.352-89.152-60.352h-318.016c-39.264 0-74.56 23.904-89.12 60.352l-39.776 99.648h-96.096c-53.024 0-96-42.976-96-96v-448c0-53.024 42.976-96 96-96h768c53.024 0 96 42.976 96 96zM160 736c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM160 288c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM832 480c0-53.024-42.976-96-96-96h-448c-53.024 0-96 42.976-96 96s42.976 96 96 96h448c53.024 0 96-42.976 96-96zM928 736c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM928 288c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM671.008 704h-318.016c-26.336 0-49.632 15.776-59.424 40.224l-35.008 87.776h506.816l-34.944-87.776c-9.792-24.448-33.088-40.224-59.424-40.224zM359.072 416c15.328 17.024 24.928 39.296 24.928 64s-9.6 46.976-24.928 64h305.824c-15.296-17.024-24.896-39.296-24.896-64s9.6-46.976 24.928-64h-305.856z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"record",
						"play",
						"mix",
						"tape"
					],
					"grid": 32
				},
				{
					"id": 1096,
					"width": 1024,
					"paths": [
						"M991.904 125.408c-6.176 0-12.512 1.824-18.24 5.824l-269.664 188.768v-128c0-17.664-14.336-32-32-32h-640c-17.664 0-32 14.336-32 32v640c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-128l269.664 188.768c5.728 4.032 12.064 5.824 18.24 5.824 16.608 0 32.096-13.184 32.096-32.064v-709.056c0-18.88-15.488-32.064-32.096-32.064zM640 800h-576v-576h576v576zM960 805.088l-288-201.6v-182.944l288-201.6v586.144zM192 352h-32v-32h32v32zM256 352h-32v-32h32v32zM160 704h384v-256h-384v256zM192 480h320v192h-320v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"record",
						"capture",
						"document"
					],
					"grid": 32
				},
				{
					"id": 1918,
					"paths": [
						"M704 256c0 106.039-85.961 192-192 192s-192-85.961-192-192c0-106.039 85.961-192 192-192s192 85.961 192 192z",
						"M608 640c17.674 0 32-14.326 32-32s-14.326-32-32-32h-192c-17.672 0-32 14.326-32 32v384c0 17.674 14.328 32 32 32h192c17.674 0 32-14.326 32-32s-14.326-32-32-32h-160v-128h160c17.674 0 32-14.326 32-32s-14.326-32-32-32h-160v-128h160z",
						"M256 704c0-70.58-57.42-128-128-128h-96c-17.672 0-32 14.326-32 32v384c0 17.674 14.328 32 32 32s32-14.326 32-32v-160h44.222l87.156 174.31c5.608 11.214 16.908 17.698 28.646 17.698 4.808 0 9.694-1.090 14.286-3.386 15.808-7.902 22.214-27.124 14.312-42.932l-77.382-154.764c47.26-18.84 80.76-65.030 80.76-118.926zM128 768h-64v-128h64c35.29 0 64 28.71 64 64s-28.71 64-64 64z",
						"M992 960h-96c-35.29 0-64-28.71-64-64v-192c0-35.29 28.71-64 64-64h96c17.674 0 32-14.326 32-32s-14.326-32-32-32h-96c-70.58 0-128 57.42-128 128v192c0 70.58 57.42 128 128 128h96c17.674 0 32-14.326 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"recording",
						"video"
					],
					"defaultCode": 59753,
					"grid": 16
				},
				{
					"id": 1578,
					"width": 1026.2860107421875,
					"paths": [
						"M477.714 668l-8.571 210.286-1.143 12.571-240-16.571q-20.571-1.714-38.286-18t-26.857-37.429q-6.286-15.429-8.286-31.429t2.286-37.143 6.857-31.429 12.286-36.571 10.857-30.286q44.571 6.857 290.857 16zM256.571 333.143l102.857 216.571-84-52.571q-36 41.143-63.714 82.571t-41.429 71.429-22.571 54-10.571 36l-2.286 12-108.571-204q-9.714-14.857-10.286-32t3.429-26.857l4.571-10.286q20-36 65.143-107.429l-80-49.143zM960 628.571l-107.429 205.143q-6.857 16.571-20.857 26.571t-24.857 11.714l-10.286 2.286q-40.571 4-125.143 6.857l4.571 93.714-131.429-209.714 120.571-206.857 4 98.857q97.143 9.143 161.714 2.857t97.143-18.857zM511.429 100.571q-26.857 36-151.429 248.571l-181.143-106.857-10.857-6.857 128.571-203.429q11.429-17.714 34.286-25.714t45.714-5.714q13.714 1.143 27.714 6.857t24 12 23.714 18.857 20.571 19.714 20.571 22.571 18.286 20zM885.714 276l121.143 207.429q10.286 21.143 7.143 43.429t-15.714 42.286q-7.429 11.429-18.857 21.143t-21.714 16-27.714 12.571-26.857 9.143-29.429 8-26.286 6.857q-19.429-41.143-151.429-249.143l178.857-111.429zM804 146.857l81.143-47.429-125.714 213.143-239.429-11.429 86.286-49.143q-19.429-50.857-42.857-94.857t-43.143-70.571-36.857-45.714-26.857-26.571l-9.714-7.429 231.429 0.571q17.714-1.714 33.143 6t22.286 16.286l6.286 8.571q22.286 34.857 64 108.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"recycle"
					],
					"defaultCode": 61880,
					"grid": 14
				},
				{
					"id": 3386,
					"paths": [
						"M256 640c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM640 640c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM643.112 776.778c16.482-12.986 40.376-10.154 53.364 6.332s10.152 40.378-6.334 53.366c-45.896 36.158-115.822 59.524-178.142 59.524-62.322 0-132.248-23.366-178.144-59.522-16.486-12.99-19.32-36.882-6.332-53.368 12.99-16.482 36.882-19.318 53.366-6.332 26.422 20.818 78.722 43.222 131.11 43.222s104.688-22.404 131.112-43.222zM1024 512c0-70.692-57.308-128-128-128-48.116 0-89.992 26.57-111.852 65.82-65.792-35.994-145.952-59.246-233.28-64.608l76.382-171.526 146.194 42.2c13.152 37.342 48.718 64.114 90.556 64.114 53.020 0 96-42.98 96-96s-42.98-96-96-96c-36.56 0-68.342 20.442-84.554 50.514l-162.906-47.024c-18.224-5.258-37.538 3.722-45.252 21.052l-103.77 233.026c-85.138 5.996-163.262 29.022-227.636 64.236-21.864-39.25-63.766-65.804-111.882-65.804-70.692 0-128 57.308-128 128 0 52.312 31.402 97.254 76.372 117.102-8.070 24.028-12.372 49.104-12.372 74.898 0 176.73 200.576 320 448 320 247.422 0 448-143.27 448-320 0-25.792-4.3-50.862-12.368-74.886 44.97-19.85 76.368-64.802 76.368-117.114zM864 188c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zM64 512c0-35.29 28.71-64 64-64 25.508 0 47.572 15.004 57.846 36.646-33.448 25.366-61.166 54.626-81.666 86.738-23.524-9.47-40.18-32.512-40.18-59.384zM512 948c-205.45 0-372-109.242-372-244s166.55-244 372-244c205.45 0 372 109.242 372 244s-166.55 244-372 244zM919.82 571.384c-20.5-32.112-48.218-61.372-81.666-86.738 10.276-21.642 32.338-36.646 57.846-36.646 35.29 0 64 28.71 64 64 0 26.872-16.656 49.914-40.18 59.384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reddit",
						"brand",
						"social"
					],
					"defaultCode": 61221,
					"grid": 16
				},
				{
					"id": 1764,
					"width": 1024.0010070800781,
					"paths": [
						"M1024 483.429q0 33.143-16.857 60.286t-45.429 41.429q6.857 26.286 6.857 54.857 0 88.571-60.857 164t-166 119.143-228.571 43.714-228.286-43.714-165.714-119.143-60.857-164q0-26.857 6.286-53.714-29.143-14.286-46.857-42t-17.714-60.857q0-46.857 33.143-80.286t80.571-33.429q48.571 0 82.857 36 124.571-86.857 294.286-92.571l66.286-297.714q1.714-7.429 8.571-12t14.857-2.857l210.857 46.286q10.286-21.143 30.857-34t45.143-12.857q35.429 0 60.571 24.857t25.143 60.286-25.143 60.571-60.571 25.143-60.286-24.857-24.857-60.286l-190.857-42.286-59.429 269.714q171.429 5.143 296.571 91.429 33.143-34.857 81.714-34.857 47.429 0 80.571 33.429t33.143 80.286zM238.857 597.143q0 35.429 24.857 60.571t60.286 25.143 60.571-25.143 25.143-60.571-25.143-60.286-60.571-24.857q-34.857 0-60 25.143t-25.143 60zM701.714 800q6.286-6.286 6.286-14.857t-6.286-14.857q-5.714-5.714-14.286-5.714t-14.857 5.714q-23.429 24-69.143 35.429t-91.429 11.429-91.429-11.429-69.143-35.429q-6.286-5.714-14.857-5.714t-14.286 5.714q-6.286 5.714-6.286 14.571t6.286 15.143q24.571 24.571 67.714 38.857t70 16.857 52 2.571 52-2.571 70-16.857 67.714-38.857zM700 682.857q35.429 0 60.286-25.143t24.857-60.571q0-34.857-25.143-60t-60-25.143q-35.429 0-60.571 24.857t-25.143 60.286 25.143 60.571 60.571 25.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reddit-alien"
					],
					"defaultCode": 62081,
					"grid": 14
				},
				{
					"id": 1557,
					"width": 877.7129821777344,
					"paths": [
						"M536.571 645.143q7.429 7.429 0 14.857-30.286 30.286-97.714 30.286t-97.714-30.286q-7.429-7.429 0-14.857 2.857-3.429 7.429-3.429t7.429 3.429q24 24 82.857 24t82.857-24q2.857-3.429 7.429-3.429t7.429 3.429zM386.286 556q0 17.714-13.143 30.857t-30.857 13.143-30.857-13.143-13.143-30.857q0-18.286 12.857-31.143t31.143-12.857 31.143 12.857 12.857 31.143zM579.429 556q0 17.714-13.143 30.857t-30.857 13.143-30.857-13.143-13.143-30.857q0-18.286 12.857-31.143t31.143-12.857 31.143 12.857 12.857 31.143zM702.286 497.143q0-24-17.143-41.143t-41.714-17.143q-24 0-41.714 17.714-64.571-44.571-152.571-46.857l30.857-138.857 97.714 22.286q0.571 18.286 13.429 30.857t30.571 12.571q18.286 0 31.143-12.857t12.857-31.143-12.857-31.143-31.143-12.857q-27.429 0-39.429 24.571l-108-24q-9.714-2.857-12 7.429l-34.286 153.143q-88 3.429-151.429 47.429-17.143-18.286-42.286-18.286-24.571 0-41.714 17.143t-17.143 41.143q0 17.143 9.143 31.429t24 21.714q-2.857 14.286-2.857 27.429 0 69.714 68.571 119.143t165.143 49.429q97.143 0 165.714-49.429t68.571-119.143q0-14.286-3.429-28 14.286-7.429 23.143-21.429t8.857-31.143zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reddit-square"
					],
					"defaultCode": 61858,
					"grid": 14
				},
				{
					"id": 1556,
					"width": 1024,
					"paths": [
						"M625.714 666.857q9.143 9.143 0 17.714-35.429 35.429-113.714 35.429t-113.714-35.429q-9.143-8.571 0-17.714 3.429-3.429 8.571-3.429t8.571 3.429q27.429 28 96.571 28 68.571 0 96.571-28 3.429-3.429 8.571-3.429t8.571 3.429zM450.286 563.429q0 21.143-14.857 36t-36 14.857-36.286-14.857-15.143-36q0-21.714 15.143-36.571t36.286-14.857 36 15.143 14.857 36.286zM676 563.429q0 21.143-15.143 36t-36.286 14.857-36-14.857-14.857-36 14.857-36.286 36-15.143 36.286 14.857 15.143 36.571zM819.429 494.857q0-28-20-48t-48.571-20-49.143 20.571q-74.286-51.429-177.714-54.857l36-161.714 114.286 25.714q0 21.143 14.857 36t36 14.857 36.286-15.143 15.143-36.286-15.143-36.286-36.286-15.143q-30.857 0-45.714 28.571l-126.286-28q-10.857-2.857-14.286 9.143l-39.429 178.286q-102.857 4-176.571 55.429-20-21.143-49.714-21.143-28.571 0-48.571 20t-20 48q0 20 10.571 36.571t28.286 25.143q-3.429 15.429-3.429 32 0 81.143 80 138.857t192.571 57.714q113.143 0 193.143-57.714t80-138.857q0-18.286-4-32.571 17.143-8.571 27.429-24.857t10.286-36.286zM1024 512q0 104-40.571 198.857t-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571 198.857 40.571 163.429 109.143 109.143 163.429 40.571 198.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reddit"
					],
					"defaultCode": 61857,
					"grid": 14
				},
				{
					"id": 2235,
					"paths": [
						"M0 576c0 152.924 67.048 290.184 173.35 384l84.666-96c-79.726-70.364-130.016-173.304-130.016-288 0-212.076 171.93-384 384-384 106.042 0 202.038 42.986 271.53 112.478l-143.53 143.522h384v-384l-149.97 149.978c-92.654-92.658-220.644-149.978-362.030-149.978-282.77 0-512 229.23-512 512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"redo",
						"cw",
						"arrow"
					],
					"defaultCode": 60070,
					"grid": 16
				},
				{
					"id": 2261,
					"paths": [
						"M576 248.372v-248.372l384 384-384 384v-253.824c-446.75-10.482-427.588 303.792-313.86 509.824-280.712-303.414-221.1-789.57 313.86-775.628z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"redo",
						"right",
						"arrow-right"
					],
					"defaultCode": 60096,
					"grid": 16
				},
				{
					"id": 192,
					"paths": [
						"M127.467 229.867c82.198-82.198 191.488-127.467 307.733-127.467 116.246 0 225.534 45.269 307.733 127.467s127.467 191.486 127.467 307.733v66.197l109.899-109.899c9.997-9.997 26.206-9.997 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-153.6 153.6c-5 5-11.55 7.499-18.102 7.499s-13.102-2.499-18.101-7.499l-153.6-153.6c-9.998-9.997-9.998-26.206 0-36.203 9.997-9.997 26.206-9.997 36.203 0l109.898 109.899v-66.197c0-211.738-172.262-384-384-384-211.739 0-384 172.262-384 384 0 211.739 172.261 384 384 384 14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6c-116.245 0-225.534-45.269-307.733-127.467s-127.467-191.488-127.467-307.733c0-116.246 45.269-225.534 127.467-307.733z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"redo",
						"cw",
						"arrow"
					],
					"defaultCode": 59489,
					"grid": 20
				},
				{
					"id": 1097,
					"width": 1024,
					"paths": [
						"M991.776 45.184c-7.872 0-15.872 2.912-22.4 9.44l-95.328 95.328c-92.672-92.64-220.672-149.952-362.048-149.952-282.784 0-512 229.216-512 512s229.216 512 512 512 512-229.216 512-512c0-21.728 0-434.752 0-434.752 0-19.296-15.776-32.064-32.224-32.064zM960 416h-258.752l125.088-123.904c-69.536-99.072-184.384-164.096-314.336-164.096-211.744 0-384 172.256-384 384s172.256 384 384 384 384-172.256 384-384c0-21.664-2.592-43.36-6.176-64h70.176v64c0 247.040-200.96 448-448 448s-448-200.96-448-448c0-247.040 200.96-448 448-448 119.68 0 232.16 46.592 316.768 131.2l45.248 45.248 85.984-85.952v261.504zM662.624 448h195.264c3.84 20.544 6.112 42.336 6.112 64 0 194.4-157.6 352-352 352s-352-157.6-352-352 157.6-352 352-352c109.632 0 207.168 50.4 271.712 128.96l-132.416 131.712c-10.048 10.080-2.912 27.328 11.328 27.328z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"redo",
						"repeat",
						"refresh",
						"reload"
					],
					"grid": 32
				},
				{
					"id": 737,
					"width": 1024,
					"paths": [
						"M448 128c-176.736 0-320 143.264-320 320s143.264 320 320 320c176.736 0 320-143.264 320-320s-143.264-320-320-320zM448 736c-158.816 0-288-129.184-288-288s129.184-288 288-288c158.816 0 288 129.184 288 288s-129.184 288-288 288zM936.32 762.88l-137.6-91.744c41.12-64.512 65.28-140.928 65.28-223.136 0-229.76-186.24-416-416-416s-416 186.24-416 416 186.24 416 416 416c82.208 0 158.592-24.16 223.136-65.312l91.744 137.6c23.2 34.784 62.24 55.68 104.064 55.68 69.056 0.032 125.056-55.968 125.056-125.024 0-41.824-20.896-80.864-55.68-104.064zM866.944 960c-31.2 0-60.128-15.488-77.44-41.44l-109.152-163.68-26.432 16.864c-61.856 39.424-133.056 60.256-205.92 60.256-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384c0 72.864-20.832 144.096-60.288 205.92l-16.864 26.432 163.68 109.152c25.984 17.28 41.472 46.24 41.472 77.44 0 51.296-41.76 93.056-93.056 93.056zM896 864c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reflect",
						"look"
					],
					"grid": 32
				},
				{
					"id": 738,
					"width": 1024,
					"paths": [
						"M936.32 762.88l-137.6-91.744c41.12-64.512 65.28-140.928 65.28-223.136 0-229.76-186.24-416-416-416s-416 186.24-416 416 186.24 416 416 416c82.208 0 158.592-24.16 223.136-65.312l91.744 137.6c23.2 34.784 62.24 55.68 104.064 55.68 69.056 0.032 125.056-55.968 125.056-125.024 0-41.824-20.896-80.864-55.68-104.064zM448 768c-176.736 0-320-143.264-320-320s143.264-320 320-320c176.736 0 320 143.264 320 320s-143.264 320-320 320zM864 896c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM736 448c0 158.816-129.184 288-288 288s-288-129.184-288-288c0-158.816 129.184-288 288-288s288 129.184 288 288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reflect",
						"look"
					],
					"grid": 32
				},
				{
					"id": 1098,
					"width": 1024,
					"paths": [
						"M608 0c-229.376 0-416 186.624-416 416 0 64.48 15.264 128.288 44.288 186.112-53.568 44.704-122.624 102.144-180.096 149.312-33.472 27.456-53.888 68-56 111.232-2.112 43.264 14.24 85.632 44.896 116.288 29.024 29.056 67.616 45.056 108.672 45.056 46.336 0 89.728-20.544 119.072-56.384l147.744-180.608c58.176 29.504 122.432 44.992 187.424 44.992 229.376 0 416-186.624 416-416s-186.624-416-416-416zM608 768c-194.080 0-352-157.92-352-352s157.92-352 352-352 352 157.92 352 352-157.92 352-352 352zM64.096 865.792c1.248-25.568 12.864-48.64 32.672-64.896 65.472-53.728 146.592-121.312 197.536-163.872 25.056 35.488 55.936 66.432 91.296 91.616l-162.336 198.4c-17.12 20.96-42.432 32.96-69.504 32.96-23.936 0-46.464-9.344-63.424-26.304-18.176-18.144-27.488-42.272-26.24-67.904zM608 96c-176.448 0-320 143.552-320 320s143.552 320 320 320c176.448 0 320-143.552 320-320s-143.552-320-320-320zM608 704c-159.072 0-288-128.928-288-288s128.928-288 288-288c159.072 0 288 128.928 288 288s-128.928 288-288 288zM160 896h-32v-32h32v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reflect",
						"primp",
						"see",
						"look"
					],
					"grid": 32
				},
				{
					"id": 1209,
					"width": 877.7150115966797,
					"paths": [
						"M863.429 603.429q0 2.857-0.571 4-36.571 153.143-153.143 248.286t-273.143 95.143q-83.429 0-161.429-31.429t-139.143-89.714l-73.714 73.714q-10.857 10.857-25.714 10.857t-25.714-10.857-10.857-25.714v-256q0-14.857 10.857-25.714t25.714-10.857h256q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714l-78.286 78.286q40.571 37.714 92 58.286t106.857 20.571q76.571 0 142.857-37.143t106.286-102.286q6.286-9.714 30.286-66.857 4.571-13.143 17.143-13.143h109.714q7.429 0 12.857 5.429t5.429 12.857zM877.714 146.286v256q0 14.857-10.857 25.714t-25.714 10.857h-256q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714l78.857-78.857q-84.571-78.286-199.429-78.286-76.571 0-142.857 37.143t-106.286 102.286q-6.286 9.714-30.286 66.857-4.571 13.143-17.143 13.143h-113.714q-7.429 0-12.857-5.429t-5.429-12.857v-4q37.143-153.143 154.286-248.286t274.286-95.143q83.429 0 162.286 31.714t140 89.429l74.286-73.714q10.857-10.857 25.714-10.857t25.714 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"refresh"
					],
					"defaultCode": 61473,
					"grid": 14
				},
				{
					"id": 739,
					"width": 1024,
					"paths": [
						"M765.632 64h-507.264c-18.56 0-33.248 15.744-31.904 34.272l55.168 772.576c3.584 50.24 45.376 89.152 95.744 89.152h269.216c50.368 0 92.16-38.912 95.744-89.152l55.168-772.576c1.376-18.528-13.312-34.272-31.872-34.272zM765.632 96l-11.424 160h-484.416l-11.424-160h507.264zM710.464 868.576c-2.4 33.312-30.432 59.424-63.84 59.424h-269.216c-33.408 0-61.472-26.112-63.84-59.424l-41.472-580.576h479.84l-41.472 580.576zM425.376 521.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l50.752-50.752c12.512-12.512 12.512-32.768 0-45.248l-50.752-50.752c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-50.752 50.752c-12.512 12.512-12.512 32.768 0 45.248l50.752 50.752zM447.968 397.248v0 0l50.784 50.752-50.752 50.752-50.752-50.752 50.72-50.752zM630.624 534.624c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-50.752 50.752c-12.512 12.512-12.512 32.768 0 45.248l50.752 50.752c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l50.752-50.752c12.512-12.512 12.512-32.768 0-45.248l-50.752-50.752zM608 658.752l-50.752-50.752 50.752-50.752 50.752 50.752-50.752 50.752zM470.624 694.624c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-50.752 50.752c-12.512 12.512-12.512 32.768 0 45.248l50.752 50.752c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l50.752-50.752c12.512-12.512 12.512-32.768 0-45.248l-50.752-50.752zM448 818.752l-50.752-50.752 50.752-50.752 50.752 50.752-50.752 50.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"refresh",
						"drink"
					],
					"grid": 32
				},
				{
					"id": 740,
					"width": 1024,
					"paths": [
						"M448 717.248l50.752 50.752-50.752 50.752-50.752-50.752 50.752-50.752zM786.272 256l11.264-157.728c1.344-18.528-13.344-34.272-31.904-34.272h-507.264c-18.56 0-33.248 15.744-31.904 34.272l11.264 157.728h548.544zM498.752 448l-50.784-50.752-50.72 50.752 50.752 50.752 50.752-50.752zM607.968 557.248l-50.72 50.752 50.752 50.752 50.752-50.752-50.784-50.752zM784 288l-41.632 582.848c-3.584 50.24-45.376 89.152-95.744 89.152h-269.216c-50.368 0-92.16-38.912-95.744-89.152l-41.664-582.848h544zM374.624 470.624l50.752 50.752c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l50.752-50.752c12.512-12.512 12.512-32.768 0-45.248l-50.752-50.752c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-50.752 50.752c-12.48 12.48-12.48 32.768 0 45.248zM521.376 745.376l-50.752-50.752c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-50.752 50.752c-12.512 12.512-12.512 32.768 0 45.248l50.752 50.752c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l50.752-50.752c12.48-12.48 12.48-32.768 0-45.248zM681.376 585.376l-50.752-50.752c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-50.752 50.752c-12.512 12.512-12.512 32.768 0 45.248l50.752 50.752c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l50.752-50.752c12.48-12.48 12.48-32.768 0-45.248z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"refresh",
						"drink"
					],
					"grid": 32
				},
				{
					"id": 1099,
					"width": 1024,
					"paths": [
						"M855.52 170.304c-6.080-6.56-14.592-10.304-23.52-10.304h-84.896l20.448-122.752c1.536-9.28-1.056-18.752-7.136-25.952-6.080-7.168-15.008-11.296-24.416-11.296h-96c-15.648 0-28.992 11.296-31.552 26.752l-22.208 133.248h-394.24c-8.928 0-17.44 3.744-23.52 10.304-6.048 6.56-9.088 15.36-8.384 24.256l64 800c1.344 16.608 15.232 29.44 31.904 29.44h512c16.672 0 30.56-12.832 31.904-29.44l64-800c0.704-8.896-2.336-17.696-8.384-24.256zM672 544l-128 128 128 128 86.144-86.144-19.68 246.144h-258.464l96-96-128-128-128 128 96 96h-130.464l-40.96-512h107.424l-96 96 128 128 128-128-96-96h363.424l-15.072 188.352-92.352-92.352zM754.752 672l-82.752 82.752-82.752-82.752 82.752-82.752 82.752 82.752zM448 946.752l-82.752-82.752 82.752-82.752 82.752 82.752-82.752 82.752zM384 461.248l82.752 82.752-82.752 82.752-82.752-82.752 82.752-82.752zM781.984 416h-539.968l-15.36-192h570.688l-15.36 192zM667.104 64h31.104l-21.344 128h-31.104l21.344-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"refresh",
						"drink",
						"hydrate",
						"sip"
					],
					"grid": 32
				},
				{
					"id": 1100,
					"width": 1024,
					"paths": [
						"M704 0h-384c-88.224 0-160 71.776-160 160v800c0 17.664 14.336 32 32 32h64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h256c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h64c17.664 0 32-14.336 32-32v-800c0-88.224-71.776-160-160-160zM224 928v-480h576v480h-576zM320 64h384c52.928 0 96 43.072 96 96v256h-576v-256c0-52.928 43.072-96 96-96zM320 352h-32v-128h32v128zM288 512h32v128h-32v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"refrigerate",
						"keep",
						"cool",
						"preserve"
					],
					"grid": 32
				},
				{
					"id": 3300,
					"width": 1344,
					"paths": [
						"M957.704 456.574c-51.764-29.886-122.572-54.652-183.37-72.574 60.796-17.922 131.606-42.688 183.37-72.574 30.61-17.674 41.098-56.816 23.426-87.426-17.674-30.61-56.816-41.1-87.426-23.426-51.764 29.886-108.616 78.824-154.536 122.512 14.876-61.61 28.832-135.314 28.832-195.086 0-35.346-28.654-64-64-64s-64 28.654-64 64c0 59.772 13.956 133.476 28.832 195.088-45.918-43.69-102.772-92.628-154.536-122.514-30.61-17.674-69.752-7.184-87.426 23.426-17.672 30.61-7.184 69.752 23.426 87.426 51.764 29.886 122.572 54.652 183.368 72.574-60.794 17.922-131.602 42.688-183.368 72.574-30.612 17.674-41.098 56.816-23.424 87.426s56.814 41.1 87.424 23.426c51.766-29.886 108.618-78.824 154.536-122.512-14.876 61.612-28.832 135.314-28.832 195.086 0 35.348 28.654 64 64 64s64-28.652 64-64c0-59.772-13.956-133.474-28.832-195.088 45.92 43.69 102.772 92.626 154.536 122.514 30.612 17.674 69.752 7.184 87.426-23.426 17.67-30.61 7.184-69.752-23.426-87.426z",
						"M448 864c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M0 1024l256-1024h128l-256 1024z",
						"M960 1024l256-1024h128l-256 1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"regexp",
						"code"
					],
					"defaultCode": 61135,
					"grid": 16
				},
				{
					"id": 3301,
					"paths": [
						"M969.578 0h-719.052c-35.952 0-70.79 28.306-77.416 62.904l-172.010 898.192c-6.626 34.598 17.368 62.904 53.322 62.904h719.050c35.954 0 70.79-28.306 77.416-62.904l172.012-898.192c6.628-34.598-17.368-62.904-53.322-62.904zM765.704 584.574c30.612 17.674 41.098 56.816 23.428 87.426-17.676 30.61-56.814 41.1-87.428 23.426-51.764-29.886-108.616-78.824-154.536-122.514 14.876 61.616 28.832 135.316 28.832 195.088 0 35.348-28.654 64-64 64s-64-28.652-64-64c0-59.772 13.956-133.472 28.832-195.086-45.918 43.688-102.77 92.624-154.536 122.512-30.61 17.674-69.75 7.184-87.424-23.426s-7.188-69.752 23.424-87.426c51.766-29.886 122.574-54.652 183.368-72.574-60.796-17.922-131.604-42.688-183.368-72.574-30.61-17.674-41.098-56.816-23.426-87.426 17.674-30.61 56.816-41.1 87.426-23.426 51.764 29.886 108.618 78.824 154.536 122.514-14.876-61.612-28.832-135.316-28.832-195.088 0-35.346 28.654-64 64-64s64 28.654 64 64c0 59.772-13.956 133.476-28.832 195.086 45.92-43.688 102.772-92.626 154.536-122.512 30.612-17.674 69.752-7.184 87.428 23.426 17.672 30.61 7.184 69.752-23.428 87.426-51.764 29.886-122.572 54.652-183.37 72.574 60.798 17.922 131.606 42.688 183.37 72.574z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"regexp"
					],
					"defaultCode": 61136,
					"grid": 16
				},
				{
					"id": 1731,
					"width": 1024,
					"paths": [
						"M595.429 401.714q0-50.286-34.286-69.143-18.857-10.286-66.857-10.286h-70.286v160.571h92.571q37.714 0 58.286-21.143t20.571-60zM625.143 564.571l117.143 213.143q4.571 9.714-0.571 17.714-4.571 9.143-15.429 9.143h-86.857q-11.429 0-16-9.714l-110.857-208.571h-88.571v200q0 8-5.143 13.143t-13.143 5.143h-76.571q-8 0-13.143-5.143t-5.143-13.143v-548.571q0-8 5.143-13.143t13.143-5.143h168q73.143 0 108.571 13.714 48.571 17.714 76.571 62.286t28 102.857q0 52.571-24.286 94.571t-66 62.571q3.429 5.714 5.143 9.143zM512 91.429q-85.714 0-163.429 33.429t-134 89.714-89.714 134-33.429 163.429 33.429 163.429 89.714 134 134 89.714 163.429 33.429 163.429-33.429 134-89.714 89.714-134 33.429-163.429-33.429-163.429-89.714-134-134-89.714-163.429-33.429zM1024 512q0 104-40.571 198.857t-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571 198.857 40.571 163.429 109.143 109.143 163.429 40.571 198.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"registered"
					],
					"defaultCode": 62045,
					"grid": 14
				},
				{
					"id": 741,
					"width": 1024,
					"paths": [
						"M916.224 401.408l-538.784-179.584c-6.592-17.216-17.952-31.936-32.544-42.752 9.536-13.44 27.136-30.208 57.376-34.176 7.776-1.056 13.728-7.328 13.728-15.136v-1.6c0-9.312-8.288-16.256-17.536-15.040-41.568 5.408-68.384 29.6-82.752 51.424-8.832-2.688-18.016-4.544-27.712-4.544-21.376 0-40.96 7.232-56.896 19.072-41.024-1.952-81.536 15.040-106.272 49.216-39.072 53.984-60.832 119.488-60.832 187.712v416c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-369.888c0-27.52-17.632-52-43.776-60.704zM288 192c35.296 0 64 28.704 64 64s-28.704 64-64 64c-35.296 0-64-28.704-64-64s28.704-64 64-64zM150.080 248.224c12.832-17.952 31.552-29.376 52.096-34.432-6.304 12.8-10.176 26.976-10.176 42.208 0 53.024 42.976 96 96 96 52.448 0 94.912-42.112 95.84-94.336l475.136 158.336h-762.976c0-60.576 19.424-119.328 54.080-167.776zM928 832c0 35.36-28.64 64-64 64h-704c-35.36 0-64-28.64-64-64v-96h832v96zM928 704h-832v-64h832v64zM928 608h-832v-160h828.32c2.144 4.32 3.68 8.992 3.68 14.080v145.92z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"regret",
						"eat",
						"enjoy"
					],
					"grid": 32
				},
				{
					"id": 742,
					"width": 1024,
					"paths": [
						"M960 462.112v145.888h-896v-160h893.76c1.056 4.64 2.24 9.248 2.24 14.112zM64 704h896v-64h-896v64zM64 832c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-96h-896v96zM320 320c44.192 0 80-35.808 80-80 0-31.84-18.752-59.104-45.664-71.968 10.4-10.336 25.696-20.224 47.936-23.136 7.776-1.056 13.728-7.328 13.728-15.136v-1.6c0-9.312-8.288-16.256-17.536-15.040-38.752 5.056-64.192 26.4-79.168 46.944-43.84 0.384-79.296 36-79.296 79.936 0 44.192 35.808 80 80 80zM916.224 401.408l-484.224-161.408c0 61.76-50.24 112-112 112s-112-50.24-112-112c0-22.368 6.752-43.104 18.080-60.608-39.264-0.352-77.504 16.128-101.248 48.896-39.072 53.984-60.832 119.488-60.832 187.712h875.328c-6.592-6.24-14.080-11.584-23.104-14.592z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"regret",
						"eat",
						"enjoy"
					],
					"grid": 32
				},
				{
					"id": 743,
					"width": 1024,
					"paths": [
						"M928 160h-832c-53.024 0-96 42.976-96 96v480c0 53.024 42.976 96 96 96h32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h512c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h32c53.024 0 96-42.976 96-96v-480c0-53.024-42.976-96-96-96zM992 736c0 35.296-28.704 64-64 64h-832c-35.296 0-64-28.704-64-64v-480c0-35.296 28.704-64 64-64h832c35.296 0 64 28.704 64 64v480zM736 224h-640c-17.664 0-32 14.336-32 32v480c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-480c0-17.664-14.336-32-32-32zM736 736h-640v-480h640v480zM928 288h-96c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM928 384h-96v-64h96v64zM864 576c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM960 576c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM864 480c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM960 480c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM960 672c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM864 672c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reheat",
						"cook",
						"heat",
						"warm"
					],
					"grid": 32
				},
				{
					"id": 744,
					"width": 1024,
					"paths": [
						"M832 320h96v64h-96v-64zM96 736h640v-480h-640v480zM1024 256v480c0 53.024-42.976 96-96 96h-32c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32h-512c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32h-32c-53.024 0-96-42.976-96-96v-480c0-53.024 42.976-96 96-96h832c53.024 0 96 42.976 96 96zM768 256c0-17.664-14.336-32-32-32h-640c-17.664 0-32 14.336-32 32v480c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-480zM864 672c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM864 576c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM864 480c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM960 672c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM960 576c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM960 480c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM960 320c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reheat",
						"cook",
						"heat",
						"warm"
					],
					"grid": 32
				},
				{
					"id": 1101,
					"width": 1024,
					"paths": [
						"M992 160h-960c-17.664 0-32 14.336-32 32v608c0 17.664 14.336 32 32 32h96c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h512c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h96c17.664 0 32-14.336 32-32v-608c0-17.664-14.336-32-32-32zM64 768v-544h640v544h-640zM960 768h-224v-544h224v544zM96 736h576v-480h-576v480zM640 288v416h-512v-416h512zM800 320h-32v-32h32v32zM864 320h-32v-32h32v32zM928 320h-32v-32h32v32zM800 384h-32v-32h32v32zM864 384h-32v-32h32v32zM928 384h-32v-32h32v32zM800 448h-32v-32h32v32zM864 448h-32v-32h32v32zM928 448h-32v-32h32v32zM848 704c44.192 0 80-35.808 80-80s-35.808-80-80-80c-44.192 0-80 35.808-80 80s35.808 80 80 80zM848 576c26.464 0 48 21.536 48 48s-21.536 48-48 48-48-21.536-48-48 21.536-48 48-48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reheat",
						"cook",
						"warm"
					],
					"grid": 32
				},
				{
					"id": 1102,
					"width": 1024,
					"paths": [
						"M864 480h32v32h-32v-32zM160 480h-32v32h32v-32zM1024 448v96c0 27.296-11.904 53.184-32 71.2v184.8c0 17.664-14.336 32-32 32h-64c0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32h-576c0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32h-64c-17.664 0-32-14.336-32-32v-184.8c-20.096-18.016-32-43.904-32-71.2v-96c0-27.296 11.904-53.184 32-71.2v-72.8c0-79.392 64.608-144 144-144h672c79.392 0 144 64.608 144 144v72.8c20.096 18.016 32 43.904 32 71.2zM96 576v192h128v-320c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32zM256 448v64h96v-288h-176c-44.128 0-80 35.904-80 80v80h96c35.36 0 64 28.64 64 64zM256 768h512v-128h-512v128zM768 608v-64h-512v64h512zM640 224h-256v288h256v-288zM832 384h96v-80c0-44.096-35.872-80-80-80h-176v288h96v-64c0-35.36 28.64-64 64-64zM800 768h128v-192c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"relax",
						"rest",
						"sit"
					],
					"grid": 32
				},
				{
					"id": 745,
					"width": 1024,
					"paths": [
						"M768 896v-48.704c115.968-80.96 192-215.168 192-367.296 0-247.424-200.576-448-448-448s-448 200.576-448 448c0 152.16 76.032 286.336 192 367.296v48.704c-53.024 0-96 42.976-96 96 0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32 0-53.024-42.976-96-96-96zM291.264 832c-23.392-14.72-45.216-31.616-65.152-50.528 176.544-58.336 395.392-58.304 571.776 0.032-19.936 18.88-41.76 35.808-65.12 50.496h-441.504zM368.544 608l143.232-334.752c0.032 0 0.096-0.032 0.224-0.032l143.456 334.784h-286.912zM96 480c0-229.376 186.624-416 416-416s416 186.624 416 416c0 105.856-39.968 202.336-105.344 275.776-90.336-31.872-192.064-48.544-294.656-50.112v-65.664h127.456c22.976 0 38.464-23.488 29.408-44.608l-143.456-334.752c-5.536-12.928-17.472-19.392-29.408-19.392s-23.872 6.464-29.408 19.392l-143.456 334.752c-9.056 21.12 6.432 44.608 29.408 44.608h127.456v65.696c-102.56 1.568-204.288 18.176-294.688 50.048-65.376-73.44-105.312-169.92-105.312-275.744zM288 864h448v32h-448v-32zM192 992c0-35.296 28.704-64 64-64h512c35.296 0 64 28.704 64 64h-640zM352 192c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM640 352c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM672 192c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM288 448c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM192 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM224 288c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM224 640c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM800 352c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM736 480c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM832 640c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM512 128c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"remember",
						"snow",
						"travel",
						"collect",
						"shake"
					],
					"grid": 32
				},
				{
					"id": 746,
					"width": 1024,
					"paths": [
						"M655.488 604.736h-286.944l143.232-334.752c0.032 0 0.096-0.032 0.224-0.032l143.488 334.784zM64 480c0-247.424 200.576-448 448-448s448 200.576 448 448c0 143.264-67.936 270.016-172.608 352h-550.784c-104.672-81.984-172.608-208.736-172.608-352zM832 640c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM800 352c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM736 480c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM672 192c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM640 352c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM512 128c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM352 192c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM288 448c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM224 288c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM224 640c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM219.040 771.2c0.096 0.096 0.192 0.192 0.288 0.288 4.192 4.16 10.336 5.504 15.968 3.744 171.808-54.368 381.664-54.336 553.344 0.032 5.632 1.792 11.808 0.416 15.968-3.744 0.096-0.096 0.192-0.192 0.288-0.288 8.608-8.576 5.12-23.136-6.432-26.784-84.128-26.624-176.928-40.608-270.496-42.048v-65.664h127.456c22.976 0 38.464-23.488 29.408-44.608l-143.424-334.752c-5.536-12.96-17.472-19.424-29.408-19.424s-23.872 6.464-29.408 19.392l-143.456 334.752c-9.056 21.12 6.432 44.608 29.408 44.608h127.456v65.696c-93.504 1.44-186.336 15.36-270.496 41.984-11.584 3.68-15.072 18.24-6.464 26.816zM160 544c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM768 896v-32h-512v32c-53.024 0-96 42.976-96 96 0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32 0-53.024-42.976-96-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"remember",
						"snow",
						"travel",
						"collect",
						"shake"
					],
					"grid": 32
				},
				{
					"id": 1103,
					"width": 1024,
					"paths": [
						"M744.416 320.352c-20.256-1.728-39.328 2.848-55.52 12-17.056-26.624-46.944-44.352-80.896-44.352-17.12 0-33.184 4.512-47.104 12.384-17.056-26.656-46.944-44.384-80.896-44.384-11.232 0-21.984 1.952-32 5.472v-35.84c34.304 14.24 80.064 30.368 112 30.368 44.096 0 80-35.904 80-80s-35.904-80-80-80c-31.936 0-77.696 16.128-112 30.368v-30.368c0-59.2-53.856-106.048-115.136-94.144-45.568 8.864-76.864 51.488-76.864 97.92v26.592c-34.304-14.24-80.064-30.368-112-30.368-44.096 0-80 35.904-80 80s35.904 80 80 80c31.936 0 77.696-16.128 112-30.368v190.368c-52.928 0-96 43.072-96 96v160c0 20.992 7.008 41.632 19.744 58.272l108.256 174.816v86.912c0 17.664 14.336 32 32 32h384c17.664 0 32-14.336 32-32v-85.984l66.208-95.104c17.408-18.816 29.792-49.76 29.792-74.912v-315.136c0-50.624-37.12-96.192-87.584-100.512zM560 160c8.832 0 16 7.168 16 16s-7.168 16-16 16c-14.784 0-38.752-6.912-63.36-16 24.576-9.088 48.544-16 63.36-16zM144 192c-8.832 0-16-7.168-16-16s7.168-16 16-16c14.784 0 38.752 6.912 63.36 16-24.576 9.088-48.544 16-63.36 16zM320 96c0-17.664 14.368-32 32-32s32 14.336 32 32v32h-64v-32zM320 160h64v32h-64v-32zM672 960h-320v-64h320v64zM768 736c0 9.12-6.816 25.568-13.248 32l-67.328 96h-349.6l-106.784-172.032c-4.544-5.664-7.040-12.736-7.040-19.968v-160c0-17.664 14.368-32 32-32 5.376 0 32 0 32 0v128c0 8.832 7.168 16 16 16s16-7.168 16-16v-384h64v128c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664 14.368-32 32-32s32 14.336 32 32v32c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664 14.368-32 32-32s32 14.336 32 32v32c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664 14.368-32 32-32s32 14.336 32 32v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"remember",
						"remind",
						"tie",
						"recall"
					],
					"grid": 32
				},
				{
					"id": 747,
					"width": 1024,
					"paths": [
						"M785.152 750.848c29.984-29.984 46.848-70.688 46.848-113.12v-253.728c0-53.024-42.976-96-96-96h-288v-54.848l39.776 17.056c8.256 3.552 16.736 5.184 24.96 5.184 33.376-0.032 63.264-26.944 63.264-63.392s-29.888-63.36-63.264-63.36c-8.256 0-16.704 1.632-24.96 5.184l-39.776 17.024v-70.848c0-46.912-40.352-84.384-88.256-79.584-41.632 4.16-71.744 42.304-71.744 84.16v66.304l-39.776-17.056c-8.256-3.552-16.704-5.184-24.96-5.184-33.376 0-63.264 26.912-63.264 63.36s29.888 63.36 63.264 63.36c8.256 0 16.704-1.632 24.96-5.184l39.776-17.024v118.848l-49.152 49.152c-29.984 29.984-46.848 70.688-46.848 113.12v91.456c0 42.432 16.864 83.136 46.848 113.152l49.152 49.12v32c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h480c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32v-32l17.152-17.152zM448 185.664l52.352-22.432c4.032-1.728 8.192-2.592 12.352-2.592 15.072 0 31.296 11.968 31.296 31.36s-16.224 31.36-31.264 31.36c-4.192 0-8.352-0.864-12.352-2.592l-52.384-22.432v-12.672zM320 80c0-26.464 21.536-48 48-48s48 21.536 48 48v84.576l-22.208 9.504c-5.76-8.288-14.912-14.080-25.792-14.080s-20.032 5.792-25.792 14.080l-22.208-9.504v-84.576zM235.648 220.768c-4.032 1.728-8.192 2.592-12.384 2.592-15.040 0-31.264-11.968-31.264-31.36s16.224-31.36 31.264-31.36c4.192 0 8.352 0.864 12.352 2.592l52.384 22.432v12.672l-52.352 22.432zM768 992h-480v-160h480v160zM762.528 728.224l-26.528 26.528v45.248h-416v-45.248l-58.496-58.496c-24.032-24.032-37.504-56.576-37.504-90.528v-91.456c0-33.952 13.472-66.496 37.504-90.496l58.496-58.528v-145.824l22.208-9.504c5.76 8.288 14.912 14.080 25.792 14.080s20.032-5.792 25.792-14.080l22.208 9.504v148.576c0 8.832 7.168 16 16 16s16-7.168 16-16v-48h96v48c0 8.832 7.168 16 16 16s16-7.168 16-16v-48h96v48c0 8.832 7.168 16 16 16s16-7.168 16-16v-48h32c35.36 0 64 28.64 64 64v253.728c0 33.952-13.472 66.496-37.472 90.496z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"remind",
						"remember",
						"tie"
					],
					"grid": 32
				},
				{
					"id": 748,
					"width": 1024,
					"paths": [
						"M327.488 132.928c-12.576-6.464-26.080-12.736-39.488-18.496v-50.432c0-35.36 28.64-64 64-64s64 28.64 64 64v50.432c-13.408 5.76-26.912 12.032-39.488 18.496-7.552-3.168-15.84-4.928-24.512-4.928s-16.96 1.76-24.512 4.928zM736 288h-32v80c0 8.832-7.168 16-16 16s-16-7.168-16-16v-80h-96v80c0 8.832-7.168 16-16 16s-16-7.168-16-16v-80h-96v80c0 8.832-7.168 16-16 16s-16-7.168-16-16v-98.432c-13.408-5.76-26.912-12.064-39.488-18.496-7.552 3.168-15.84 4.928-24.512 4.928s-16.96-1.76-24.512-4.928c-12.576 6.464-26.080 12.736-39.488 18.496v82.432l-49.12 49.12c-30.016 30.016-46.88 70.72-46.88 113.152v91.456c0 42.432 16.864 83.136 46.848 113.152l49.152 49.12h480l17.152-17.152c29.984-29.984 46.848-70.688 46.848-113.12v-253.728c0-53.024-42.976-96-96-96zM768 800h-480c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h480c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32zM224 256c-35.296 0-64-28.704-64-64s28.704-64 64-64c23.648 0 77.344 27.104 104.992 41.952 5.824-6.080 13.92-9.952 23.008-9.952s17.184 3.872 23.008 9.952c27.648-14.848 81.344-41.952 104.992-41.952 35.296 0 64 28.704 64 64s-28.704 64-64 64c-23.648 0-77.344-27.104-104.992-41.952-5.824 6.080-13.92 9.952-23.008 9.952s-17.184-3.872-23.008-9.952c-27.648 14.848-81.344 41.952-104.992 41.952zM401.792 192c33.248 17.12 67.328 32 78.208 32 17.632 0 32-14.336 32-32s-14.368-32-32-32c-10.88 0-44.96 14.88-78.208 32zM224 224c10.88 0 44.96-14.88 78.208-32-33.248-17.12-67.328-32-78.208-32-17.632 0-32 14.336-32 32s14.368 32 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"remind",
						"remember",
						"tie"
					],
					"grid": 32
				},
				{
					"id": 1104,
					"width": 1024,
					"paths": [
						"M992 160h-96v-64c0-52.928-43.072-96-96-96s-96 43.072-96 96v64h-384v-64c0-52.928-43.072-96-96-96s-96 43.072-96 96v64h-96c-17.664 0-32 14.336-32 32v800c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-800c0-17.664-14.336-32-32-32zM768 96c0-17.664 14.336-32 32-32s32 14.336 32 32v160c0 17.632-14.368 32-32 32s-32-14.368-32-32v-160zM192 96c0-17.664 14.336-32 32-32s32 14.336 32 32v160c0 17.632-14.368 32-32 32s-32-14.368-32-32v-160zM960 960h-896v-576h896v576zM960 352h-896v-128h96v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h448v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h96v128zM96 416v512h832v-512h-832zM256 896h-128v-128h128v128zM256 736h-128v-128h128v128zM256 576h-128v-128h128v128zM416 896h-128v-128h128v128zM416 736h-128v-128h128v128zM416 576h-128v-128h128v128zM576 896h-128v-128h128v128zM576 736h-128v-128h128v128zM576 576h-128v-128h128v128zM736 896h-128v-128h128v128zM736 736h-128v-128h128v128zM736 576h-128v-128h128v128zM896 896h-128v-128h128v128zM896 736h-128v-128h128v128zM896 576h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"remind",
						"plan",
						"schedule",
						"expect",
						"anticipate"
					],
					"grid": 32
				},
				{
					"id": 2886,
					"paths": [
						"M871.762 448.954l-359.762-89.94v-95.368c64.782 37.408 118.534 56.354 160 56.354 88.224 0 160-71.776 160-160s-71.774-160-160-160c-45.286 0-105.23 22.608-178.184 67.17-4.186-2.010-8.86-3.17-13.816-3.17h-128c-4.956 0-9.628 1.16-13.816 3.17-72.952-44.562-132.896-67.17-178.184-67.17-88.224 0-160 71.776-160 160s71.776 160 160 160c41.468 0 95.22-18.946 160-56.354v319.97l-103.414-124.104c-10.47-12.562-28.726-15.21-42.334-6.14l-96 64c-14.4 9.598-18.558 28.906-9.386 43.586l160 256c1.284 2.050 2.796 3.954 4.508 5.664l192 192c6 6.004 14.138 9.376 22.626 9.376h319.998c12.124 0 23.204-6.848 28.624-17.69l96-192c2.222-4.444 3.376-9.342 3.376-14.31v-319.998c0-14.684-9.992-27.484-24.236-31.046zM768 160c0 52.934-43.064 96-96 96-43.070 0-107.35-33.638-160-67.206v-57.586c52.65-33.57 116.93-67.208 160-67.208 52.936 0 96 43.066 96 96zM160 256c-52.934 0-96-43.066-96-96s43.066-96 96-96c43.070 0 107.35 33.638 160 67.206v57.588c-52.65 33.568-116.93 67.206-160 67.206zM832 792.446l-83.778 167.554h-286.968l-180.048-180.050-141.6-226.562 46.22-30.81 141.592 169.91c8.624 10.348 22.808 14.198 35.474 9.602 12.67-4.588 21.108-16.618 21.108-30.090v-448.92c12.612-8.664 23.496-16.524 32-22.828 8.504 6.302 19.388 14.164 32 22.828v384.92c0 17.674 14.328 32 32 32s32-14.326 32-32v-183.014l64 16v167.014c0 17.674 14.326 32 32 32s32-14.326 32-32v-151.014l64 16v199.014c0 17.674 14.324 32 32 32 17.674 0 32-14.326 32-32v-183.014l64 16v287.46z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reminder",
						"finger",
						"hand"
					],
					"defaultCode": 60721,
					"grid": 16
				},
				{
					"id": 3341,
					"paths": [
						"M425.2 10.6c-241.2 40.6-425.2 250.4-425.2 503.2 0 125.6 45.6 240.6 120.8 329.6 178.6-86.4 303.6-282 304.4-509.8v-323z",
						"M598.8 10.6c241.2 40.6 425.2 250.4 425.2 503.2 0 125.6-45.6 240.6-120.8 329.6-178.6-86.4-303.6-282-304.4-509.8v-323z",
						"M510.2 642.6c-31.8 131.6-126.8 244-245 318.8 72.8 39.8 156.2 62.6 245 62.6s172.2-22.8 245-62.6c-118.2-74.8-213.2-187.2-245-318.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"renren",
						"brand",
						"social"
					],
					"defaultCode": 61176,
					"grid": 16
				},
				{
					"id": 1536,
					"width": 877.7129821777344,
					"paths": [
						"M647.429 897.143q-97.714 53.714-210.286 53.714-112 0-209.714-53.714 78.857-49.714 134.571-120.571t75.143-153.143q20 82.286 75.714 153.143t134.571 120.571zM364.571 81.143v277.143q0 144-72.286 262.571t-188.857 175.143q-103.429-122.857-103.429-282.857 0-106.857 47.714-199.714t131.143-154 185.714-78.286zM877.714 513.143q0 160-103.429 282.857-116.571-56.571-188.857-175.143t-72.286-262.571v-277.143q102.286 17.143 185.714 78.286t131.143 154 47.714 199.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"renren"
					],
					"defaultCode": 61835,
					"grid": 14
				},
				{
					"id": 1208,
					"width": 877.7160339355469,
					"paths": [
						"M877.714 146.286v256q0 14.857-10.857 25.714t-25.714 10.857h-256q-24 0-33.714-22.857-9.714-22.286 8-39.429l78.857-78.857q-84.571-78.286-199.429-78.286-59.429 0-113.429 23.143t-93.429 62.571-62.571 93.429-23.143 113.429 23.143 113.429 62.571 93.429 93.429 62.571 113.429 23.143q68 0 128.571-29.714t102.286-84q4-5.714 13.143-6.857 8 0 14.286 5.143l78.286 78.857q5.143 4.571 5.429 11.714t-4.286 12.857q-62.286 75.429-150.857 116.857t-186.857 41.429q-89.143 0-170.286-34.857t-140-93.714-93.714-140-34.857-170.286 34.857-170.286 93.714-140 140-93.714 170.286-34.857q84 0 162.571 31.714t139.714 89.429l74.286-73.714q16.571-17.714 40-8 22.286 9.714 22.286 33.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"repeat",
						"rotate-right"
					],
					"defaultCode": 61470,
					"grid": 14
				},
				{
					"id": 1105,
					"width": 1024,
					"paths": [
						"M1023.392 492.896c-9.76-150.784-139.872-268.896-296.16-268.896h-215.232v-18.752c0-35.328-28.8-64.064-64.224-64.064v0c-16.896 0-32.896 6.688-45.024 18.816l-64 64h-50.752c-79.296 0-155.904 33.184-210.144 91.072-55.008 58.688-82.432 135.424-77.216 216.032 9.728 150.784 139.84 268.896 296.128 268.896h215.232v18.752c0 35.328 28.8 64.064 64.224 64.064 16.896 0 32.896-6.688 45.024-18.816l64-64h50.752c79.296 0 155.904-33.184 210.176-91.072 55.008-58.688 82.432-135.424 77.216-216.032zM576 818.752v-82.752h-279.232c-122.656 0-224.704-91.808-232.288-209.024-8.448-130.4 94.4-238.976 223.52-238.976h32l-41.376 41.376c-12.512 12.512-12.512 32.768 0 45.248l41.376 41.376h-32c-58.816 0-104.352 52.576-94.72 111.872 7.424 45.696 49.632 80.128 98.144 80.128h284.576v-82.752l146.752 146.752-146.752 146.752zM352 448l73.376 73.376c6.528 6.528 14.528 9.44 22.4 9.44 16.448 0 32.224-12.768 32.224-32.064v-50.752h252.576c31.872 0 61.44 21.792 66.56 53.248 6.496 40.096-24.256 74.752-63.136 74.752h-64l-73.376-73.376c-6.528-6.528-14.528-9.44-22.4-9.44-16.448 0-32.224 12.768-32.224 32.064v50.752h-252.576c-31.872 0-61.44-21.792-66.56-53.248-6.496-40.096 24.256-74.752 63.136-74.752h64zM736 736h-32l41.376-41.376c12.512-12.512 12.512-32.768 0-45.248l-41.376-41.376h32c58.816 0 104.352-52.576 94.72-111.872-7.424-45.696-49.632-80.128-98.144-80.128h-284.576v82.752l-146.752-146.752 146.752-146.72v82.72h279.232c122.656 0 224.704 91.808 232.288 209.024 8.448 130.4-94.4 238.976-223.52 238.976z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"repeat",
						"redo",
						"loop"
					],
					"grid": 32
				},
				{
					"id": 2263,
					"paths": [
						"M448 775.628v248.372l-384-384 384-384v253.824c446.75 10.48 427.588-303.792 313.862-509.824 280.71 303.414 221.1 789.57-313.862 775.628z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reply",
						"left",
						"arrow-left"
					],
					"defaultCode": 60098,
					"grid": 16
				},
				{
					"id": 2264,
					"width": 1088,
					"paths": [
						"M907.766 0c113.726 206.032 146.984 520.304-299.766 509.824v-221.824l-352 352 352 352v-216.372c448 0 580.476-472.214 299.766-775.628z",
						"M416 352l-64-64-352 352 320 320 64-64-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reply-all",
						"left",
						"arrow-left"
					],
					"defaultCode": 60099,
					"grid": 16
				},
				{
					"id": 1106,
					"width": 1024,
					"paths": [
						"M32 992h960v-960h-960v960zM928 928h-832v-384l112-112 176 176 224-224-176-176 112-112h384v832zM96 96h402.752l-112 112 176 176-178.752 178.752-176-176-112 112v-402.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reply",
						"send",
						"mail"
					],
					"grid": 32
				},
				{
					"id": 749,
					"width": 1024,
					"paths": [
						"M256 336v0c0-8.832 7.168-16 16-16h96c8.832 0 16 7.168 16 16v0c0 8.832-7.168 16-16 16h-96c-8.832 0-16-7.168-16-16zM272 416h96c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-96c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM960 256v576c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-576c0-53.024 42.976-96 96-96 0 0 14.336-32 32-32h98.944c6.624-18.592 24.224-32 45.056-32s38.432 13.408 45.056 32h66.944c17.664 0 32 14.336 32 32h384c53.024 0 96 42.976 96 96zM192 480h256v-320h-64v80c0 28.544-25.056 51.36-54.304 47.584-24.192-3.104-41.696-24.864-41.696-49.248v-6.336c0-8.832 7.168-16 16-16v0c8.832 0 16 7.168 16 16v8c0 9.696 8.672 17.408 18.688 15.776 7.872-1.28 13.312-8.704 13.312-16.672v-79.104h-160v320zM927.232 839.744c-16.928 14.912-38.912 24.256-63.232 24.256h-704c-24.32 0-46.304-9.344-63.232-24.256 3.872 31.648 30.528 56.256 63.232 56.256h704c32.704 0 59.36-24.608 63.232-56.256zM928 256c0-35.36-28.64-64-64-64h-384v288c0 17.664-14.336 32-32 32h-256c-17.664 0-32-14.336-32-32v-288c-35.36 0-64 28.64-64 64v512c0 35.36 28.64 64 64 64h704c35.36 0 64-28.64 64-64v-512zM854.112 449.216c-1.952-0.8-4.032-1.216-6.112-1.216h-128c-8.832 0-16 7.168-16 16s7.168 16 16 16h89.376l-96 96h-50.752l-59.328-59.328c-6.24-6.24-16.384-6.24-22.624 0l-91.296 91.328h-121.376c-4.256 0-8.32 1.696-11.328 4.672l-91.296 91.328h-89.376c-8.832 0-16 7.168-16 16s7.168 16 16 16h96c4.256 0 8.32-1.696 11.328-4.672l91.296-91.328h121.376c4.256 0 8.32-1.696 11.328-4.672l84.672-84.672 52.672 52.672c3.008 2.976 7.072 4.672 11.328 4.672h64c4.256 0 8.32-1.696 11.328-4.672l100.672-100.704v89.376c0 8.832 7.168 16 16 16s16-7.168 16-16v-128c0-2.080-0.416-4.16-1.216-6.112-1.632-3.904-4.768-7.040-8.672-8.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"report",
						"work",
						"visualize"
					],
					"grid": 32
				},
				{
					"id": 750,
					"width": 1024,
					"paths": [
						"M480 160v0c0-17.664-14.336-32-32-32h-33.632c1.056 5.184 1.632 10.528 1.632 16v64c0 44.096-35.872 80-80 80-3.424 0-6.88-0.224-10.4-0.672-39.68-5.088-69.6-39.904-69.6-80.992v-4.64c0-24.448 17.568-46.272 41.824-49.312 7.84-0.992 15.36-0.064 22.176 2.368v-10.752c0-8.832 7.168-16 16-16s16 7.168 16 16v63.104c0 8-5.472 15.424-13.376 16.704-0.896 0.128-1.76 0.192-2.624 0.192-8.832 0-16-7.2-16-16v-8c0-9.728-8.672-17.408-18.688-15.776-7.872 1.28-13.312 8.672-13.312 16.64v5.184c0 24.896 18.112 47.104 42.88 49.696 1.728 0.16 3.424 0.256 5.12 0.256 26.464 0 48-21.536 48-48v-64c0-26.496-21.504-48-48-48-20.864 0-38.464 13.408-45.056 32h-98.944c-17.664 0-32 14.336-32 32v320c0 17.664 14.336 32 32 32h256c17.664 0 32-14.336 32-32v-320zM368 416h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM368 352h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM960 819.776v12.224c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-12.224c23.488 26.88 57.6 44.224 96 44.224h704c38.4 0 72.512-17.344 96-44.224zM160 832h704c53.024 0 96-42.976 96-96v-480c0-53.024-42.976-96-96-96h-352v320c0 35.296-28.704 64-64 64h-256c-35.296 0-64-28.704-64-64v-314.112c-37.216 13.216-64 48.384-64 90.112v480c0 53.024 42.976 96 96 96zM176 704h89.376l91.328-91.328c2.976-2.976 7.040-4.672 11.296-4.672h121.376l91.328-91.328c6.24-6.24 16.384-6.24 22.624 0l59.296 59.328h50.752l96-96h-89.376c-8.832 0-16-7.168-16-16s7.168-16 16-16h128c2.080 0 4.16 0.416 6.112 1.216 3.904 1.632 7.040 4.736 8.672 8.672 0.8 1.952 1.216 4.032 1.216 6.112v128c0 8.832-7.168 16-16 16s-16-7.168-16-16v-89.376l-100.672 100.672c-3.008 3.008-7.072 4.704-11.328 4.704h-64c-4.256 0-8.32-1.696-11.328-4.672l-52.672-52.704-84.672 84.672c-3.008 3.008-7.072 4.704-11.328 4.704h-121.376l-91.328 91.328c-2.976 2.976-7.040 4.672-11.296 4.672h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"report",
						"work",
						"visualize"
					],
					"grid": 32
				},
				{
					"id": 1107,
					"width": 1024,
					"paths": [
						"M160 288h576v32h-576v-32zM160 416h256v288h-256v-288zM192 672h192v-224h-192v224zM512 448h224v-32h-224v32zM512 512h224v-32h-224v32zM512 640h224v-32h-224v32zM512 576h224v-32h-224v32zM512 704h224v-32h-224v32zM1024 224v544c0 70.592-57.408 128-128 128h-768c-70.592 0-128-57.408-128-128v-608c0-17.664 14.336-32 32-32h832c17.664 0 32 14.336 32 32v32h96c17.664 0 32 14.336 32 32zM960 256h-96v448h-32v-512h-768v576c0 35.296 28.704 64 64 64h768c35.296 0 64-28.704 64-64v-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"report",
						"read",
						"write"
					],
					"grid": 32
				},
				{
					"id": 2144,
					"paths": [
						"M264.082 576c-5.272 20.456-8.082 41.898-8.082 64 0 141.384 114.616 256 256 256s256-114.616 256-256-114.616-256-256-256v192l-320-256 320-256v192c212.078 0 384 171.922 384 384s-171.922 384-384 384-384-171.922-384-384c0-21.81 1.86-43.184 5.354-64h130.728z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"reset"
					],
					"defaultCode": 59979,
					"grid": 16
				},
				{
					"id": 1108,
					"width": 1024,
					"paths": [
						"M896 0h-768c-17.664 0-32 14.304-32 32v960c0 17.696 14.336 32 32 32h768c17.664 0 32-14.304 32-32v-960c0-17.696-14.336-32-32-32zM864 64v224h-40.864c5.472-9.44 8.864-20.288 8.864-32v-96c0-35.36-28.64-64-64-64h-160c-35.36 0-64 28.64-64 64v96c0 11.712 3.392 22.56 8.864 32h-81.76c5.504-9.44 8.896-20.288 8.896-32v-96c0-35.36-28.64-64-64-64h-160c-35.36 0-64 28.64-64 64v96c0 11.712 3.392 22.56 8.864 32h-40.864v-224h704zM224 256v-96c0-17.632 14.368-32 32-32h160c17.632 0 32 14.368 32 32v96c0 17.632-14.368 32-32 32h-160c-17.632 0-32-14.368-32-32zM864 320v128h-704v-128h704zM576 256v-96c0-17.632 14.368-32 32-32h160c17.632 0 32 14.368 32 32v96c0 17.632-14.368 32-32 32h-160c-17.632 0-32-14.368-32-32zM160 960v-480h704v480h-704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rest",
						"sleep",
						"make",
						"nap",
						"lie"
					],
					"grid": 32
				},
				{
					"id": 751,
					"width": 1024,
					"paths": [
						"M815.872 54.592c-3.936 0-7.936 1.472-11.2 4.704l-36.672 36.704-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-36.672-36.672c-3.264-3.264-7.264-4.704-11.2-4.704-8.224-0.032-16.128 6.368-16.128 16v882.752c0 9.632 7.904 16.032 16.128 16.032 3.936 0 7.936-1.472 11.2-4.704l36.672-36.704 41.376 41.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 41.376 41.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 41.376 41.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 41.376 41.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 36.672 36.672c3.264 3.264 7.264 4.704 11.2 4.704 8.224 0 16.128-6.4 16.128-16.032v-882.72c0-9.632-7.904-16.032-16.128-16.032zM800 914.752l-9.376-9.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-9.376 9.376v-805.504l9.376 9.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 41.376 41.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 41.376 41.376c6.016 6.016 14.144 9.376 22.624 9.376v0c8.48 0 16.64-3.36 22.624-9.376l41.376-41.376 41.376 41.376c6.272 6.24 14.464 9.376 22.624 9.376 8.192 0 16.384-3.136 22.624-9.376l41.376-41.376 41.376 41.376c5.984 6.016 14.144 9.376 22.624 9.376s16.64-3.36 22.624-9.376l9.376-9.376v805.504zM512 240c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16zM512 528c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16zM320 336c0-8.832 7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16h-96c-8.832 0-16-7.168-16-16zM704 336c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM704 240c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM704 432c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM704 528c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM704 720c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM448 720c0 8.832-7.168 16-16 16h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16zM320 432c0-8.832 7.168-16 16-16h128c8.832 0 16 7.168 16 16s-7.168 16-16 16h-128c-8.832 0-16-7.168-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"return",
						"buy",
						"pay",
						"purchase",
						"shop"
					],
					"grid": 32
				},
				{
					"id": 752,
					"width": 1024,
					"paths": [
						"M815.872 54.592c-3.936 0-7.936 1.472-11.2 4.704l-36.672 36.704-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-41.376-41.376c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-41.376 41.376-36.672-36.672c-3.264-3.264-7.264-4.704-11.2-4.704-8.224-0.032-16.128 6.368-16.128 16v882.752c0 9.632 7.904 16.032 16.128 16.032 3.936 0 7.936-1.472 11.2-4.704l36.672-36.704 41.376 41.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 41.376 41.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 41.376 41.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 41.376 41.376c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l41.376-41.376 36.672 36.672c3.264 3.264 7.264 4.704 11.2 4.704 8.224 0 16.128-6.4 16.128-16.032v-882.72c0-9.632-7.904-16.032-16.128-16.032zM512 240c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16zM512 528c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16zM320 336c0-8.832 7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16h-96c-8.832 0-16-7.168-16-16zM704 336c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM704 240c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM704 432c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM704 528c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM704 720c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM448 720c0 8.832-7.168 16-16 16h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16zM320 432c0-8.832 7.168-16 16-16h128c8.832 0 16 7.168 16 16s-7.168 16-16 16h-128c-8.832 0-16-7.168-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"return",
						"buy",
						"pay",
						"purchase",
						"shop"
					],
					"grid": 32
				},
				{
					"id": 1293,
					"width": 1097.1450004577637,
					"paths": [
						"M731.429 859.429q0 7.429-5.429 12.857t-12.857 5.429h-548.571q-4.571 0-7.714-1.143t-5.143-4-3.143-4.571-1.714-6.571-0.571-6.571v-342.857h-109.714q-14.857 0-25.714-10.857t-10.857-25.714q0-13.714 8.571-23.429l182.857-219.429q10.857-12.571 28-12.571t28 12.571l182.857 219.429q8.571 9.714 8.571 23.429 0 14.857-10.857 25.714t-25.714 10.857h-109.714v219.429h329.143q9.143 0 14.286 6.286l91.429 109.714q4 6.286 4 12zM1097.143 621.714q0 13.714-8.571 23.429l-182.857 219.429q-11.429 13.143-28 13.143t-28-13.143l-182.857-219.429q-8.571-9.714-8.571-23.429 0-14.857 10.857-25.714t25.714-10.857h109.714v-219.429h-329.143q-9.143 0-14.286-6.857l-91.429-109.714q-4-5.143-4-11.429 0-7.429 5.429-12.857t12.857-5.429h548.571q4.571 0 7.714 1.143t5.143 4 3.143 4.571 1.714 6.571 0.571 6.571v342.857h109.714q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"retweet"
					],
					"defaultCode": 61561,
					"grid": 14
				},
				{
					"id": 1109,
					"width": 1024,
					"paths": [
						"M927.84 65.984c-6.72 0-13.6 2.144-19.68 6.944l-236.16 186.432v-161.312c0-19.008-15.584-32.064-32.16-32.064-6.72 0-13.6 2.144-19.68 6.944l-524.352 413.952c-16.224 12.8-16.224 37.408 0 50.24l524.352 413.952c6.048 4.8 12.96 6.944 19.68 6.944 16.544 0 32.16-13.056 32.16-32.064v-161.344l236.16 186.464c6.048 4.8 12.96 6.944 19.68 6.944 16.544 0 32.16-13.056 32.16-32.064v-827.904c0-19.040-15.584-32.064-32.16-32.064zM455.552 512l440.448-347.712v695.424l-440.448-347.712zM608 859.936l-440.704-347.936 440.704-347.936v186.816l-172.256 136c-16.224 12.8-16.224 37.408 0 50.24l172.256 136v186.816z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rewind",
						"replay",
						"previous"
					],
					"grid": 32
				},
				{
					"id": 753,
					"width": 1024,
					"paths": [
						"M880 576c-16.768 0-32.544 3.52-47.488 8.8-4.928-1.728-9.984-3.040-15.136-4.224-14.176-18.816-30.176-38.4-49.088-58.4-39.264-41.536-93.312-87.52-164.096-126.784l21.696-43.392h126.112c8.832 0 16-7.168 16-16s-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h30.112l-14.272 28.544c-71.616-35.552-158.912-63.424-263.936-74.176l36.608-146.368h83.488c8.832 0 16-7.168 16-16s-7.168-16-16-16h-83.52c-14.688 0-27.488 9.984-31.040 24.224l-74.72 298.88c-11.328-1.888-22.88-3.104-34.72-3.104-114.88 0-208 93.12-208 208s93.12 208 208 208 208-93.12 208-208c0-86.944-53.376-161.344-129.12-192.416 71.072 1.024 257.792 15.52 429.344 129.376-45.344 24.224-76.224 72.032-76.224 127.040 0 79.52 64.48 144 144 144 16.896 0 32.832-3.392 47.776-8.896 15.136 5.408 31.232 8.896 48.224 8.896 79.52 0 144-64.48 144-144s-64.48-144-144-144zM384 656c0 97.056-78.944 176-176 176s-176-78.944-176-176 78.944-176 176-176c9.184 0 18.112 0.928 26.944 2.272l-42.464 169.856c-2.112 8.576 3.072 17.248 11.648 19.392 1.312 0.32 2.592 0.48 3.872 0.48 7.2 0 13.728-4.832 15.52-12.128l42.464-169.856c68.608 24.064 118.016 89.28 118.016 165.984zM280.608 431.584l23.424-93.76c262.4 25.408 413.024 162.528 490.688 266.688-1.6 1.184-3.008 2.528-4.576 3.776-197.568-160.928-433.152-176.384-509.536-176.704zM784 832c-61.76 0-112-50.24-112-112 0-48.8 31.488-90.080 75.104-105.408 6.944 5.184 13.824 10.624 20.704 16.16-19.616 24.608-31.808 55.36-31.808 89.248 0 45.248 21.312 85.152 53.952 111.552-1.984 0.128-3.936 0.448-5.952 0.448zM880 832c-61.76 0-112-50.24-112-112 0-25.984 9.248-49.6 24.128-68.608 26.208 23.296 51.584 49.312 75.456 78.72 3.136 3.84 7.744 5.888 12.416 5.888 2.688 0 5.408-0.672 7.872-2.048 6.784-3.84 9.824-12.032 7.2-19.36-0.928-2.56-16.192-43.808-53.024-99.488 11.904-4.352 24.576-7.104 37.952-7.104 61.76 0 112 50.24 112 112s-50.24 112-112 112z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ride",
						"play",
						"cycle"
					],
					"grid": 32
				},
				{
					"id": 754,
					"width": 1024,
					"paths": [
						"M925.184 703.776c-1.824-4.992-18.24-48.576-56.448-106.368l-13.344-18.688c8-1.536 16.128-2.72 24.608-2.72 79.52 0 144 64.48 144 144s-64.48 144-144 144-144-64.48-144-144c0-22.144 5.632-42.72 14.656-61.376l19.424 15.936c27.008 24.032 51.168 49.248 72.672 75.712 9.152 11.264 22.752 17.728 37.248 17.728 8.16 0 16.288-2.112 23.456-6.112 20.576-11.648 29.632-36.032 21.728-58.112zM242.72 451.136l-50.24 200.992c-2.112 8.576 3.072 17.248 11.648 19.392 1.312 0.32 2.592 0.48 3.872 0.48 7.2 0 13.728-4.832 15.52-12.128l49.088-196.416 14.432 0.224c-0.064-0.032-0.128-0.064-0.192-0.096 71.072 1.024 257.792 15.52 429.344 129.376-0.256 0.128-0.48 0.32-0.768 0.48 18.368 12.16 36.64 25.12 54.496 39.68l22.176 18.304c26.208 23.296 51.584 49.312 75.456 78.72 3.168 3.808 7.776 5.856 12.448 5.856 2.688 0 5.408-0.672 7.872-2.048 6.784-3.84 9.824-12.032 7.2-19.36-0.928-2.56-16.192-43.808-53.024-99.488l-24.992-34.88c-14.112-18.688-29.984-38.144-48.768-57.984-39.264-41.536-93.312-87.52-164.096-126.784l21.696-43.456h126.112c8.832 0 16-7.168 16-16s-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16h30.112l-14.272 28.544c-71.616-35.552-158.912-63.424-263.936-74.176l36.608-146.368h83.488c8.832 0 16-7.168 16-16s-7.168-16-16-16h-83.52c-14.688 0-27.488 9.984-31.040 24.224l-74.72 298.912zM343.776 499.008c-17.984-1.696-33.76-2.656-46.272-3.040l-42.912 171.648c-5.344 21.408-24.512 36.384-46.592 36.384-3.744 0-7.552-0.448-11.648-1.44-25.632-6.432-41.28-32.512-34.912-58.208l49.056-196.256c-0.832 0-1.664-0.096-2.496-0.096-114.88 0-208 93.12-208 208s93.12 208 208 208 208-93.12 208-208c0-62.848-28.16-118.88-72.224-156.992zM704 720c0-29.44 7.68-56.96 20.544-81.344-12.256-9.024-24.64-17.312-37.088-25.216-29.088 26.336-47.456 64.224-47.456 106.56 0 77.6 61.504 140.416 138.368 143.424-44.928-31.904-74.368-84.256-74.368-143.424z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ride",
						"play",
						"cycle"
					],
					"grid": 32
				},
				{
					"id": 1110,
					"width": 1024,
					"paths": [
						"M960 416h-5.088c-10.88-75.808-40.608-145.344-84.48-203.936l3.584-3.584c12.512-12.512 12.512-32.768 0-45.248l-45.248-45.248c-12.512-12.512-32.768-12.512-45.248 0l-3.584 3.584c-58.592-43.872-128.128-73.6-203.936-84.48v-5.088c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v5.088c-75.808 10.88-145.344 40.608-203.936 84.48l-3.584-3.616c-12.512-12.512-32.768-12.512-45.248 0l-45.28 45.248c-12.512 12.512-12.512 32.768 0 45.248l3.584 3.584c-43.872 58.592-73.6 128.128-84.48 203.936h-5.056c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h4.544c10.88 75.872 40.96 145.44 84.928 204l-3.52 3.52c-12.512 12.512-12.512 32.768 0 45.248l45.248 45.248c12.512 12.512 32.768 12.512 45.248 0l3.68-3.68c20.32 15.2 41.824 28.896 64.608 40.544l-37.152 102.176c-7.552 20.896 7.904 42.976 30.112 42.976h420.64c22.208 0 37.664-22.080 30.080-42.944l-37.152-102.176c22.784-11.616 44.288-25.344 64.608-40.544l3.68 3.68c12.512 12.512 32.768 12.512 45.248 0l45.248-45.248c12.512-12.512 12.512-32.768 0-45.248l-3.52-3.52c43.968-58.56 74.048-128.128 84.928-204h4.544c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM416 480c0-52.928 43.072-96 96-96s96 43.072 96 96c0 33.568-17.376 63.072-43.552 80.224l-22.368-61.536c-5.12-14.048-17.6-21.056-30.080-21.056s-24.96 7.008-30.080 21.056l-22.368 61.536c-26.176-17.152-43.552-46.656-43.552-80.224zM511.712 509.664c0.032 0 0.128-0.032 0.288-0.032l163.776 450.368h-327.616l163.552-450.336zM574.432 587.68v0l1.024 2.848c0.384-0.224 0.704-0.512 1.088-0.736l114.592 114.592c-18.56 14.816-38.656 27.808-60.544 37.76l7.584 20.896-63.744-175.36zM714.912 682.912l-112.768-112.768c16-15.808 27.744-35.776 33.6-58.144h161.856c-7.424 66.56-37.632 125.952-82.688 170.912zM640 480c0-23.712-6.88-45.6-18.112-64.64l114.912-114.912c39.456 49.28 63.2 111.648 63.2 179.552h-160zM602.496 389.504c-15.872-15.872-36.096-27.168-58.496-32.96v-162.656c66.624 7.392 126.528 37.536 171.552 82.56l-113.056 113.056zM512 352c-23.68 0-45.6 6.88-64.64 18.112l-114.912-114.912c49.28-39.456 111.648-63.2 179.552-63.2v160zM308.448 276.448l113.056 113.056c-15.872 15.872-27.168 36.096-32.96 58.496h-162.656c7.392-66.624 37.536-126.528 82.56-171.552zM384 480c0 23.744 6.56 45.888 17.92 64.832l-114.272 114.272c-39.488-49.216-63.648-111.2-63.648-179.104h160zM421.824 570.144c7.968 7.872 16.928 14.752 26.688 20.384l6.72-18.464-61.856 170.048c-31.744-14.432-59.936-34.912-84.32-59.232l112.768-112.736zM686.144 821.888l-22.368 11.424-22.144-60.896c112.064-49.76 190.368-161.856 190.368-292.416 0-176.736-143.264-320-320-320s-320 143.264-320 320c0 130.56 78.304 242.656 190.4 292.416l-22.144 60.896-22.368-11.424c-17.248-8.8-33.568-18.848-48.992-29.856 8.608-12.48 7.968-29.408-3.136-40.512l-45.248-45.248c-11.2-11.2-28.32-11.776-40.832-2.944-33.888-47.232-56.672-101.952-66.304-160.416 15.008-2.624 26.624-15.136 26.624-30.912v-64c0-15.68-11.488-28.128-26.4-30.88 9.792-59.040 32.928-113.472 66.432-160.192 12.448 8.544 29.344 7.872 40.416-3.2l45.248-45.248c11.072-11.072 11.744-27.968 3.2-40.416 46.72-33.504 101.184-56.64 160.192-66.432 2.784 14.88 15.232 26.368 30.912 26.368h64c15.68 0 28.128-11.488 30.88-26.4 59.040 9.792 113.472 32.928 160.192 66.432-8.544 12.448-7.872 29.344 3.2 40.416l45.248 45.248c11.072 11.072 27.968 11.744 40.416 3.2 33.504 46.72 56.64 101.184 66.432 160.192-14.88 2.784-26.368 15.232-26.368 30.912v64c0 15.776 11.616 28.288 26.656 30.912-9.632 58.432-32.384 113.184-66.304 160.416-12.48-8.832-29.632-8.256-40.832 2.944l-45.248 45.248c-11.104 11.104-11.744 28.064-3.136 40.512-15.456 11.008-31.744 21.056-48.992 29.856z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ride",
						"play"
					],
					"grid": 32
				},
				{
					"id": 755,
					"width": 1024,
					"paths": [
						"M384 320c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64-28.64-64-64-64zM384 416c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM839.008 736h-3.040c-23.136-32.352-35.968-71.232-35.968-111.52v-176.48c0-141.248-101.728-258.496-235.872-283.040 10.304-14.528 14.912-33.376 9.76-53.472-5.888-23.008-25.44-41.504-48.736-46.144-41.12-8.192-77.152 23.008-77.152 62.656 0 13.792 4.448 26.496 11.904 36.928-134.144 24.576-235.904 141.824-235.904 283.072v176.48c0 40.288-12.832 79.168-35.968 111.52h-3.040c-14.688 0-27.488 9.984-31.040 24.224l-16 64c-5.056 20.192 10.208 39.776 31.040 39.776h279.008v28.576c0 31.872 21.792 61.44 53.248 66.56 40.096 6.496 74.752-24.256 74.752-63.136v-32h279.008c20.832 0 36.096-19.552 31.040-39.776l-16-64c-3.552-14.24-16.352-24.224-31.040-24.224zM512 96c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM256 624.48v-176.48c0-141.152 114.848-256 256-256s256 114.848 256 256v176.48c0 39.776 10.304 77.952 29.632 111.52h-571.264c19.328-33.568 29.632-71.744 29.632-111.52zM544 896c0 17.632-14.368 32-32 32s-32-14.368-32-32v-32h64v32zM168.992 832l16-64h654.016l16 64h-686.016z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ring",
						"alarm",
						"alert"
					],
					"grid": 32
				},
				{
					"id": 756,
					"width": 1024,
					"paths": [
						"M886.048 824.224c5.056 20.192-10.208 39.776-31.040 39.776h-686.016c-20.832 0-36.096-19.552-31.040-39.776l16-64c3.552-14.24 16.352-24.224 31.040-24.224h654.016c14.688 0 27.488 9.984 31.040 24.224l16 64zM448 896c0 35.36 28.64 64 64 64s64-28.64 64-64h-128zM384 352c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM817.888 704h-611.776c11.392-24.768 17.888-51.744 17.888-79.52v-176.48c0-141.248 101.76-258.496 235.904-283.040-7.424-10.464-11.904-23.168-11.904-36.96 0-39.648 36.032-70.88 77.152-62.688 23.296 4.64 42.848 23.136 48.736 46.144 5.152 20.128 0.544 38.976-9.76 53.472 134.144 24.576 235.872 141.824 235.872 283.072v176.48c0 27.776 6.496 54.752 17.888 79.52zM448 384c0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64 64-28.64 64-64zM544 128c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ring",
						"alarm",
						"alert"
					],
					"grid": 32
				},
				{
					"id": 1111,
					"width": 1024,
					"paths": [
						"M928 800c-96 0-96-352-96-352 0-147.264-99.616-270.976-235.008-308.224 6.784-13.184 11.008-27.904 11.008-43.776 0-53.024-42.976-96-96-96s-96 42.976-96 96c0 15.872 4.224 30.592 11.008 43.776-135.392 37.248-235.008 160.96-235.008 308.224 0 0 0 352-96 352-17.664 0-32 14.336-32 32s14.336 32 32 32h292.512c-2.656 10.272-4.512 20.896-4.512 32 0 70.688 57.312 128 128 128s128-57.312 128-128c0-11.104-1.856-21.728-4.512-32h292.512c17.664 0 32-14.336 32-32s-14.336-32-32-32zM480 96c0-17.632 14.368-32 32-32s32 14.368 32 32-14.368 32-32 32-32-14.368-32-32zM256 448c0-141.152 114.848-256 256-256s256 114.848 256 256c0 3.776 0.128 93.408 12.576 184.64 2.24 16.416 5.888 42.56 12.544 71.36h-562.272c6.656-28.8 10.304-54.944 12.544-71.36 12.48-91.232 12.608-180.864 12.608-184.64zM512 960c-35.296 0-64-28.704-64-64 0-4.352 0.8-9.408 2.496-15.968l12.416-48.032h98.144l12.448 48.032c1.696 6.56 2.496 11.616 2.496 15.968 0 35.296-28.704 64-64 64zM195.136 800c11.648-19.616 20.352-41.888 27.136-64h579.456c6.784 22.112 15.488 44.384 27.136 64h-633.728z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ring",
						"alarm"
					],
					"grid": 32
				},
				{
					"id": 2598,
					"paths": [
						"M704 1024h320l-256-1024h-192l32 256h-192l32-256h-192l-256 1024h320l32-256h320l32 256zM368 640l32-256h224l32 256h-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"road",
						"asphalt",
						"travel"
					],
					"defaultCode": 60433,
					"grid": 16
				},
				{
					"id": 1202,
					"width": 1097.1370468139648,
					"paths": [
						"M634.857 569.143v-2.286l-13.714-182.857q-0.571-7.429-6.286-12.857t-13.143-5.429h-106.286q-7.429 0-13.143 5.429t-6.286 12.857l-13.714 182.857v2.286q-0.571 6.857 4.571 11.429t12 4.571h139.429q6.857 0 12-4.571t4.571-11.429zM1068.571 836q0 41.714-26.286 41.714h-402.286q7.429 0 12.571-5.429t4.571-12.857l-11.429-146.286q-0.571-7.429-6.286-12.857t-13.143-5.429h-155.429q-7.429 0-13.143 5.429t-6.286 12.857l-11.429 146.286q-0.571 7.429 4.571 12.857t12.571 5.429h-402.286q-26.286 0-26.286-41.714 0-30.857 14.857-66.286l238.286-596.571q4.571-10.857 14.857-18.857t21.714-8h193.714q-7.429 0-13.143 5.429t-6.286 12.857l-8.571 109.714q-0.571 8 4.571 13.143t12.571 5.143h94.857q7.429 0 12.571-5.143t4.571-13.143l-8.571-109.714q-0.571-7.429-6.286-12.857t-13.143-5.429h193.714q11.429 0 21.714 8t14.857 18.857l238.286 596.571q14.857 35.429 14.857 66.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"road"
					],
					"defaultCode": 61464,
					"grid": 14
				},
				{
					"id": 2546,
					"paths": [
						"M704 64l-320 320h-192l-192 256c0 0 203.416-56.652 322.066-30.084l-322.066 414.084 421.902-328.144c58.838 134.654-37.902 328.144-37.902 328.144l256-192v-192l320-320 64-320-320 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rocket",
						"jet",
						"speed",
						"spaceship",
						"fast"
					],
					"defaultCode": 60381,
					"grid": 16
				},
				{
					"id": 1455,
					"width": 964.5709629058838,
					"paths": [
						"M822.857 256q0-22.857-16-38.857t-38.857-16-38.857 16-16 38.857 16 38.857 38.857 16 38.857-16 16-38.857zM950.857 91.429q0 142.286-43.143 246t-144.857 206q-46.286 45.714-111.429 100.571l-11.429 216.571q-1.143 9.143-9.143 14.857l-219.429 128q-4 2.286-9.143 2.286-6.857 0-13.143-5.143l-36.571-36.571q-7.429-8-4.571-18.286l48.571-157.714-160.571-160.571-157.714 48.571q-1.714 0.571-5.143 0.571-8 0-13.143-5.143l-36.571-36.571q-9.714-10.857-2.857-22.286l128-219.429q5.714-8 14.857-9.143l216.571-11.429q54.857-65.143 100.571-111.429 107.429-106.857 204.571-147.429t246.286-40.571q8 0 13.714 5.429t5.714 12.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rocket"
					],
					"defaultCode": 61749,
					"grid": 14
				},
				{
					"id": 170,
					"paths": [
						"M691.2 460.8c-70.579 0-128-57.421-128-128s57.421-128 128-128 128 57.421 128 128-57.421 128-128 128zM691.2 256c-42.347 0-76.8 34.453-76.8 76.8s34.453 76.8 76.8 76.8 76.8-34.453 76.8-76.8-34.453-76.8-76.8-76.8z",
						"M25.603 1024c-6.675 0-13.219-2.613-18.106-7.499-7.034-7.034-9.355-17.502-5.957-26.85 78.781-216.648 161.613-326.499 246.195-326.499 27.883 0 53.979 11.96 77.566 35.546 37.283 37.283 38.611 74.394 33.162 98.96-17.125 77.187-126.171 152.822-324.115 224.802-2.853 1.038-5.813 1.541-8.746 1.541zM247.736 714.354c-25.354 0-55.19 22.214-86.282 64.237-30.578 41.33-61.274 100.205-91.525 175.477 68.352-27.478 123.302-55.379 163.806-83.205 54.648-37.542 70.808-66.562 74.742-84.294 3.944-17.779-2.395-34.682-19.382-51.667-13.826-13.826-27.354-20.547-41.36-20.547z",
						"M998.4 0c-132.848 0-251.256 22.534-351.939 66.981-82.997 36.638-154.075 88.075-211.258 152.882-10.674 12.098-20.552 24.334-29.691 36.586-44.142 2.942-89.275 20.47-134.362 52.221-38.13 26.851-76.459 64.014-113.923 110.458-62.965 78.054-101.706 154.987-103.325 158.226-5.605 11.211-2.25 24.814 7.904 32.166 4.501 3.258 9.758 4.856 14.992 4.856 6.573 0 13.109-2.52 18.064-7.434 0.243-0.24 24.714-24.299 66.469-47.926 34.41-19.474 87.461-42.336 151.613-46.384 16.219 41.541 62.662 91.181 84.954 113.47 22.291 22.291 71.931 68.734 113.472 84.955-4.046 64.152-26.91 117.202-46.382 151.611-23.629 41.757-47.686 66.227-47.89 66.432-8.878 8.878-10.006 22.885-2.666 33.070 4.952 6.87 12.77 10.634 20.782 10.634 3.867 0 7.779-0.877 11.434-2.704 3.237-1.619 80.17-40.36 158.226-103.325 46.443-37.464 83.606-75.794 110.458-113.922 31.75-45.088 49.278-90.221 52.221-134.363 12.251-9.139 24.49-19.019 36.586-29.693 64.806-57.181 116.243-128.259 152.883-211.258 44.443-100.682 66.979-219.091 66.979-351.939v-25.6h-25.6zM159.102 502.187c48.797-70.8 123.384-158.595 207.446-186.232-33.222 58.203-50.422 111.691-56.611 145.555-59.323 3.626-110.467 20.89-150.835 40.677zM521.87 864.781c19.762-40.35 36.995-91.453 40.619-150.718 33.859-6.187 87.336-23.384 145.528-56.597-27.658 83.92-115.381 158.49-186.147 207.315zM770.262 550.405c-106.48 93.952-216.794 115.195-232.662 115.195-0.102 0-10.581-0.23-38.867-20.136-19.728-13.883-42.682-33.618-64.63-55.566-21.95-21.95-41.683-44.902-55.566-64.632-19.906-28.285-20.136-38.763-20.136-38.866 0-15.869 21.243-126.182 115.197-232.662 112.416-127.406 284.533-197.059 498.894-202.227-5.17 214.358-74.822 386.477-202.229 498.894z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rocket",
						"spaceship",
						"space",
						"fast"
					],
					"defaultCode": 59467,
					"grid": 20
				},
				{
					"id": 757,
					"width": 1024,
					"paths": [
						"M416 624c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM512 624c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM416 304c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM512 304c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM768 224c-22.56 0-64 16.608-64 96s41.44 96 64 96 64-16.608 64-96-41.44-96-64-96zM768 384c-15.456 0-32-16.8-32-64s16.544-64 32-64c15.456 0 32 16.8 32 64s-16.544 64-32 64zM320 304c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM768 64h-512c-106.048 0-192 114.624-192 256v544c0 53.024 42.976 96 96 96h352c53.024 0 96-42.976 96-96v-288h160c106.048 0 192-114.624 192-256s-85.952-256-192-256zM577.664 288h-17.664c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v288h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v224c0 35.36-28.64 64-64 64h-352c-35.36 0-64-28.64-64-64v-224h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16v-288h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-14.176c11.168-108.384 77.728-192 158.176-192h419.136c-52.448 38.72-89.728 109.248-97.472 192zM608 544v-82.592c17.056 34.208 40.064 62.624 67.136 82.592h-67.136zM768 544c-88.224 0-160-100.48-160-224s71.776-224 160-224 160 100.48 160 224-71.776 224-160 224zM224 304c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM224 624c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16zM320 624c0 8.832-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"roll",
						"poop",
						"wipe"
					],
					"grid": 32
				},
				{
					"id": 758,
					"width": 1024,
					"paths": [
						"M768 320c0-47.2 16.544-64 32-64s32 16.8 32 64-16.544 64-32 64c-15.456 0-32-16.8-32-64zM800 96c88.352 0 160 100.288 160 224s-71.648 224-160 224-160-100.288-160-224c0-123.712 71.648-224 160-224zM736 320c0 79.392 41.44 96 64 96s64-16.608 64-96-41.44-96-64-96-64 16.608-64 96zM608 640v224c0 53.024-42.976 96-96 96h-352c-53.024 0-96-42.976-96-96v-224h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-288h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-46.336c11.84-126.24 92.448-224 190.336-224h527.456c-90.176 10.336-162.624 105.12-173.792 224h-49.664c-8.832 0-16 7.168-16 16s7.168 16 16 16h48c0 10.848 0 32 0 32v256h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48zM224 624c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM224 304c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM320 624c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM320 304c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM416 624c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM416 304c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM512 624c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM512 304c0-8.832-7.168-16-16-16h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h32c8.832 0 16-7.168 16-16zM640 461.216v114.784h145.952c-60.864-5.952-113.984-50.624-145.952-114.784z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"roll",
						"poop",
						"wipe"
					],
					"grid": 32
				},
				{
					"id": 1112,
					"width": 1024,
					"paths": [
						"M256 416c22.56 0 64-16.608 64-96s-41.44-96-64-96-64 16.608-64 96 41.44 96 64 96zM256 256c15.456 0 32 16.8 32 64s-16.544 64-32 64c-15.456 0-32-16.8-32-64s16.544-64 32-64zM768 32h-512c-123.52 0-224 129.184-224 288s100.48 288 224 288h128v352c0 17.664 14.336 32 32 32h544c17.664 0 32-14.336 32-32v-640c0-158.816-100.48-288-224-288zM256 96c88.224 0 160 100.48 160 224s-71.776 224-160 224-160-100.48-160-224 71.776-224 160-224zM416 461.408v82.592h-67.136c27.072-19.968 50.080-48.384 67.136-82.592zM928 608h-32v32h32v288h-480v-288h32v-32h-32v-288h32v-32h-33.664c-7.776-82.752-45.024-153.28-97.472-192h419.136c80.448 0 147.008 83.616 158.176 192h-30.176v32h32v288zM512 288h32v32h-32v-32zM576 288h32v32h-32v-32zM640 288h32v32h-32v-32zM704 288h32v32h-32v-32zM768 288h32v32h-32v-32zM832 288h32v32h-32v-32zM512 608h32v32h-32v-32zM576 608h32v32h-32v-32zM640 608h32v32h-32v-32zM704 608h32v32h-32v-32zM768 608h32v32h-32v-32zM832 608h32v32h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"roll",
						"poop",
						"wipe"
					],
					"grid": 32
				},
				{
					"id": 2236,
					"paths": [
						"M64 512h640v512h-640v-512z",
						"M544 256h-96v-160l-192 192 192 192v-160h96c194.094 0 352 157.906 352 352v128c0 17.674 14.326 32 32 32s32-14.326 32-32v-128c0-229.382-186.618-416-416-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rotate-ccw",
						"ccw"
					],
					"defaultCode": 60071,
					"grid": 16
				},
				{
					"id": 2238,
					"paths": [
						"M128 576c0-247.422 200.576-448 448-448s448 200.578 448 448c0 173.374-98.492 323.73-242.566 398.208 106.62-65.99 178.566-190.926 178.566-334.208 0-212.078-157.596-384-352-384-174.412 0-319.154 138.392-347.086 320h123.086l-192 224-192-224h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rotate-ccw",
						"ccw",
						"arrow"
					],
					"defaultCode": 60073,
					"grid": 16
				},
				{
					"id": 2240,
					"width": 1152,
					"paths": [
						"M704 64c-247.424 0-448 200.576-448 448h-224l288 288 288-288h-224c0-176.73 143.27-320 320-320 176.732 0 320 143.27 320 320 0 176.732-143.268 320-320 320v128c247.424 0 448-200.576 448-448s-200.576-448-448-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rotate-ccw",
						"ccw",
						"arrow"
					],
					"defaultCode": 60075,
					"grid": 16
				},
				{
					"id": 2237,
					"paths": [
						"M960 512h-640v512h640v-512z",
						"M480 256h96v-160l192 192-192 192v-160h-96c-194.094 0-352 157.906-352 352v128c0 17.674-14.326 32-32 32s-32-14.326-32-32v-128c0-229.382 186.618-416 416-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rotate-cw",
						"cw"
					],
					"defaultCode": 60072,
					"grid": 16
				},
				{
					"id": 2239,
					"paths": [
						"M896 576c0-247.422-200.576-448-448-448s-448 200.578-448 448c0 173.374 98.492 323.73 242.566 398.208-106.62-65.99-178.566-190.926-178.566-334.208 0-212.078 157.596-384 352-384 174.412 0 319.154 138.392 347.086 320h-123.086l192 224 192-224h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rotate-cw",
						"cw",
						"arrow"
					],
					"defaultCode": 60074,
					"grid": 16
				},
				{
					"id": 2241,
					"width": 1152,
					"paths": [
						"M448 64c247.424 0 448 200.576 448 448h224l-288 288-288-288h224c0-176.73-143.27-320-320-320-176.732 0-320 143.27-320 320 0 176.732 143.268 320 320 320v128c-247.424 0-448-200.576-448-448s200.576-448 448-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rotate-cw",
						"cw",
						"arrow"
					],
					"defaultCode": 60076,
					"grid": 16
				},
				{
					"id": 1379,
					"width": 877.7160301208496,
					"paths": [
						"M877.714 512q0 89.143-34.857 170.286t-93.714 140-140 93.714-170.286 34.857q-98.286 0-186.857-41.429t-150.857-116.857q-4-5.714-3.714-12.857t4.857-11.714l78.286-78.857q5.714-5.143 14.286-5.143 9.143 1.143 13.143 6.857 41.714 54.286 102.286 84t128.571 29.714q59.429 0 113.429-23.143t93.429-62.571 62.571-93.429 23.143-113.429-23.143-113.429-62.571-93.429-93.429-62.571-113.429-23.143q-56 0-107.429 20.286t-91.429 58l78.286 78.857q17.714 17.143 8 39.429-9.714 22.857-33.714 22.857h-256q-14.857 0-25.714-10.857t-10.857-25.714v-256q0-24 22.857-33.714 22.286-9.714 39.429 8l74.286 73.714q61.143-57.714 139.714-89.429t162.571-31.714q89.143 0 170.286 34.857t140 93.714 93.714 140 34.857 170.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rotate-left",
						"undo"
					],
					"defaultCode": 61666,
					"grid": 14
				},
				{
					"id": 1488,
					"width": 731.4280920028687,
					"paths": [
						"M596 322.857q0-57.143-37.143-92.571t-97.714-35.429h-182.857v256h182.857q60.571 0 97.714-35.429t37.143-92.571zM731.429 322.857q0 110.286-72.286 180t-186.571 69.714h-194.286v67.429h288.571q8 0 13.143 5.143t5.143 13.143v73.143q0 8-5.143 13.143t-13.143 5.143h-288.571v109.714q0 8-5.429 13.143t-12.857 5.143h-95.429q-8 0-13.143-5.143t-5.143-13.143v-109.714h-128q-8 0-13.143-5.143t-5.143-13.143v-73.143q0-8 5.143-13.143t13.143-5.143h128v-67.429h-128q-8 0-13.143-5.143t-5.143-13.143v-85.143q0-7.429 5.143-12.857t13.143-5.429h128v-359.429q0-8 5.143-13.143t13.143-5.143h308q114.286 0 186.571 69.714t72.286 180z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rouble",
						"rub",
						"ruble"
					],
					"defaultCode": 61784,
					"grid": 14
				},
				{
					"id": 3343,
					"paths": [
						"M136.294 750.93c-75.196 0-136.292 61.334-136.292 136.076 0 75.154 61.1 135.802 136.292 135.802 75.466 0 136.494-60.648 136.494-135.802-0.002-74.742-61.024-136.076-136.494-136.076zM0.156 347.93v196.258c127.784 0 247.958 49.972 338.458 140.512 90.384 90.318 140.282 211.036 140.282 339.3h197.122c-0.002-372.82-303.282-676.070-675.862-676.070zM0.388 0v196.356c455.782 0 826.756 371.334 826.756 827.644h196.856c0-564.47-459.254-1024-1023.612-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"feed",
						"rss",
						"social"
					],
					"defaultCode": 61178,
					"grid": 16
				},
				{
					"id": 1468,
					"width": 877.7129821777344,
					"paths": [
						"M292.571 731.429q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM493.143 785.143q-7.429-132.571-101.143-226.286t-226.286-101.143q-8-0.571-13.714 5.143t-5.714 13.143v73.143q0 7.429 4.857 12.571t12.286 5.714q88 6.286 150.857 69.143t69.143 150.857q0.571 7.429 5.714 12.286t12.571 4.857h73.143q7.429 0 13.143-5.714t5.143-13.714zM712.571 785.714q-2.857-88-32-170t-79.714-148.571-117.143-117.143-148.571-79.714-170-32q-8-0.571-13.143 5.143-5.714 5.714-5.714 13.143v73.143q0 7.429 5.143 12.571t12.571 5.714q116.571 4 216 63.714t159.143 159.143 63.714 216q0.571 7.429 5.714 12.571t12.571 5.143h73.143q7.429 0 13.143-5.714 6.286-5.143 5.143-13.143zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rss-square"
					],
					"defaultCode": 61763,
					"grid": 14
				},
				{
					"id": 3344,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM279 831.2c-48 0-87-38.6-87-86.6 0-47.6 39-86.8 87-86.8 48.2 0 87 39.2 87 86.8 0 48-39 86.6-87 86.6zM497.4 832c0-81.8-31.8-158.8-89.4-216.4-57.8-57.8-134.4-89.6-216-89.6v-125.2c237.6 0 431.2 193.4 431.2 431.2h-125.8zM719.6 832c0-291-236.6-528-527.4-528v-125.2c360 0 653 293.2 653 653.2h-125.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"feed",
						"rss",
						"social"
					],
					"defaultCode": 61179,
					"grid": 16
				},
				{
					"id": 3272,
					"paths": [
						"M256 0c-141.384 0-256 114.616-256 256s114.616 256 256 256v512h128v-896h128v896h128v-896h128v-128h-512zM1024 192l-256 256 256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rtl",
						"wysiwyg",
						"right-to-left",
						"direction"
					],
					"defaultCode": 61107,
					"grid": 16
				},
				{
					"id": 3274,
					"paths": [
						"M448 0c-106.040 0-192 85.96-192 192s85.96 192 192 192v320h64v-640h64v640h64v-640h128v-64h-320z",
						"M256 768v-160l-192 192 192 192v-160h512v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rtl",
						"wysiwyg",
						"right-to-left",
						"direction"
					],
					"defaultCode": 61109,
					"grid": 16
				},
				{
					"id": 759,
					"width": 1024,
					"paths": [
						"M640 0h-256c-53.024 0-96 42.976-96 96v832c0 53.024 42.976 96 96 96h256c53.024 0 96-42.976 96-96v-832c0-53.024-42.976-96-96-96zM704 928c0 35.36-28.64 64-64 64h-256c-35.36 0-64-28.64-64-64h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-64h112c8.832 0 16-7.168 16-16s-7.168-16-16-16h-112v-64h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-64h112c8.832 0 16-7.168 16-16s-7.168-16-16-16h-112v-64h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-64h112c8.832 0 16-7.168 16-16s-7.168-16-16-16h-112v-64h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-64h112c8.832 0 16-7.168 16-16s-7.168-16-16-16h-112v-64h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48v-32c0-35.36 28.64-64 64-64h256c35.36 0 64 28.64 64 64v832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rule",
						"grow",
						"measure",
						"quantify"
					],
					"grid": 32
				},
				{
					"id": 760,
					"width": 1024,
					"paths": [
						"M640 0h-256c-53.024 0-96 42.976-96 96v832c0 53.024 42.976 96 96 96h256c53.024 0 96-42.976 96-96v-832c0-53.024-42.976-96-96-96zM336 128h32c8.832 0 16 7.168 16 16s-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16zM368 928h-32c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16s-7.168 16-16 16zM432 832h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM320 720c0-8.832 7.168-16 16-16h32c8.832 0 16 7.168 16 16s-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16zM432 640h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM320 528c0-8.832 7.168-16 16-16h32c8.832 0 16 7.168 16 16s-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16zM432 448h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM320 336c0-8.832 7.168-16 16-16h32c8.832 0 16 7.168 16 16s-7.168 16-16 16h-32c-8.832 0-16-7.168-16-16zM432 256h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rule",
						"grow",
						"measure",
						"quantify"
					],
					"grid": 32
				},
				{
					"id": 3223,
					"paths": [
						"M1024 512h-1024v384h1024v-384zM896 832v-64h-64v64h-64v-128h-64v128h-64v-64h-64v64h-64v-128h-64v128h-64v-64h-64v64h-64v-128h-64v128h-128v-256h896v256h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ruler",
						"measure",
						"size"
					],
					"defaultCode": 61058,
					"grid": 16
				},
				{
					"id": 3222,
					"paths": [
						"M512 128v-128h-384v128h-128v384h128v512h384v-512h512v-384h-512zM128 448h-64v-256h64v256zM448 128h-128v64h128v64h-128v64h128v64h-128v64h128v64h-128v64h128v64h-128v64h128v64h-128v64h128v128h-256v-896h256v64zM960 448h-64v-128h-64v128h-64v-128h-64v128h-64v-128h-64v128h-64v-256h448v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"rulers",
						"measure",
						"size"
					],
					"defaultCode": 61057,
					"grid": 16
				},
				{
					"id": 2845,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM256 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM640 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM319.902 780.74l-82.328-49.396c55.962-93.070 157.916-155.344 274.426-155.344 116.508 0 218.462 62.274 274.426 155.344l-82.328 49.396c-39.174-65.148-110.542-108.74-192.098-108.74-81.558 0-152.924 43.592-192.098 108.74z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sad",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60680,
					"grid": 16
				},
				{
					"id": 2846,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM704 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM320 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM704.098 780.74c-39.174-65.148-110.544-108.74-192.098-108.74-81.556 0-152.924 43.592-192.098 108.74l-82.328-49.396c55.96-93.070 157.916-155.344 274.426-155.344 116.508 0 218.464 62.274 274.426 155.344l-82.328 49.396z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sad",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60681,
					"grid": 16
				},
				{
					"id": 180,
					"paths": [
						"M486.4 1024c-129.922 0-252.067-50.594-343.936-142.464s-142.464-214.014-142.464-343.936c0-129.923 50.595-252.067 142.464-343.936s214.013-142.464 343.936-142.464c129.922 0 252.067 50.595 343.936 142.464s142.464 214.014 142.464 343.936-50.594 252.067-142.464 343.936c-91.869 91.87-214.014 142.464-343.936 142.464zM486.4 102.4c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2 435.2-195.23 435.2-435.2-195.23-435.2-435.2-435.2z",
						"M332.8 409.6c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.453 76.8-76.8 76.8zM332.8 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M640 409.6c-42.349 0-76.8-34.453-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.451 76.8-76.8 76.8zM640 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M281.562 768.002c-5.352 0-10.747-1.672-15.355-5.133-11.304-8.491-13.586-24.539-5.094-35.843 25.686-34.195 59.344-62.531 97.338-81.941 39.858-20.362 82.907-30.685 127.95-30.685s88.091 10.323 127.949 30.685c37.992 19.408 71.653 47.742 97.339 81.938 8.491 11.304 6.211 27.352-5.094 35.843-11.307 8.493-27.352 6.21-35.843-5.094-44-58.576-111.194-92.171-184.35-92.171s-140.35 33.597-184.35 92.174c-5.029 6.696-12.712 10.227-20.488 10.227z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sad",
						"emoticon"
					],
					"defaultCode": 59477,
					"grid": 20
				},
				{
					"id": 3409,
					"paths": [
						"M512 0c-282.8 0-512 229.2-512 512s229.2 512 512 512 512-229.2 512-512-229.2-512-512-512zM958.4 472.8l-1-10.6c0.2 3.6 0.6 7 1 10.6zM888.4 268.8l-7.2-10.8c2.4 3.6 4.8 7.2 7.2 10.8zM860.6 230.6l-4.4-5.4c1.6 1.8 3 3.6 4.4 5.4zM798.6 167.6l-5.4-4.4c2 1.6 3.6 3 5.4 4.4zM766 142.8l-10.8-7.2c3.6 2.4 7.2 4.8 10.8 7.2zM561.8 66.8l-10.8-1c3.6 0.2 7.2 0.6 10.8 1zM472.8 65.6l-10.8 1c3.6-0.2 7.2-0.6 10.8-1zM268.8 135.6l-10.8 7.2c3.6-2.4 7.2-4.8 10.8-7.2zM230.6 163.4l-5.2 4.2c1.8-1.4 3.4-2.8 5.2-4.2zM167.6 225.4l-4.4 5.4c1.6-1.8 3-3.6 4.4-5.4zM142.8 258l-7.2 10.8c2.4-3.6 4.8-7.2 7.2-10.8zM66.8 462.2l-1 10.8c0.2-3.6 0.6-7.2 1-10.8zM65.6 551.2l1 10.8c-0.2-3.6-0.6-7.2-1-10.8zM135.6 755l7.2 10.8c-2.4-3.4-4.8-7-7.2-10.8zM144 767.6l79.8-53.4-8.8-13.4-79.8 53.4c-36.2-56.2-60-120.8-68-190.4l47.8-4.8-1.6-16-47.8 4.8c-0.8-9.2-1.2-18.6-1.4-28h96v-16h-96c0.2-9.4 0.6-18.6 1.4-28l47.8 4.6 1.6-16-47.8-4.6c8-69.6 32-134.2 68.2-190.4l79.8 53.4 8.8-13.4-80-53c5.4-7.6 10.8-15.2 16.6-22.4l37 30.4 10.2-12.4-37-30.4c6-7.2 12.4-14 18.8-20.8l67.8 67.8 11.4-11.4-67.8-67.8c6.8-6.4 13.6-12.8 20.6-18.8l30.4 37.2 12.4-10.2-30.4-37c7.4-5.8 14.8-11.4 22.4-16.8l53.4 79.8 13.4-8.8-53.4-79.8c56.2-36.2 120.8-60 190.4-68l4.8 47.8 16-1.6-4.8-47.8c9.2-0.8 18.6-1.2 28-1.4v96h16v-96c9.4 0.2 18.6 0.6 28 1.4l-4.6 47.8 16 1.6 4.6-47.8c69.6 8 134.2 32 190.4 68.2l-53.4 79.8 13.4 8.8 53.4-79.8c7.6 5.4 15.2 10.8 22.4 16.6l-30.4 37 12.4 10.2 30.4-37c7.2 6 14 12.4 20.8 18.8l-25.6 25-350 233.4-233.4 350-25 25c-6.4-6.8-12.8-13.6-18.8-20.6l37-30.4-10.2-12.4-37 30.4c-5.8-7.2-11.2-14.8-16.6-22.4zM167.6 798.6c-1.4-1.8-2.8-3.4-4.2-5.2l4.2 5.2zM225.4 856.4l5.2 4.2c-1.8-1.4-3.4-2.8-5.2-4.2zM258 881l10.8 7.2c-3.6-2.2-7.2-4.6-10.8-7.2zM462.2 957.2l10.8 1c-3.6-0.2-7.2-0.6-10.8-1zM551.2 958.4l10.6-1c-3.6 0.2-7 0.6-10.6 1zM755.2 888.4l10.8-7.2c-3.6 2.4-7.2 4.8-10.8 7.2zM793.4 860.6l5.4-4.4c-1.8 1.6-3.6 3-5.4 4.4zM828.4 829.2l0.8-0.8c-0.2 0.2-0.6 0.6-0.8 0.8zM856.4 798.6l4.4-5.4c-1.6 1.8-3 3.6-4.4 5.4zM863.4 790l-37-30.4-10.2 12.4 37 30.4c-6 7.2-12.4 14-18.8 20.8l-67.8-67.8-11.4 11.4 67.8 67.8c-6.8 6.4-13.6 12.8-20.6 18.8l-30.4-37.2-12.4 10.2 30.4 37c-7.4 5.8-14.8 11.4-22.4 16.8l-53.4-79.8-13.4 8.8 53.4 79.8c-56.2 36.2-120.8 60-190.4 68l-4.8-47.8-16 1.6 4.8 47.8c-9.2 0.8-18.6 1.2-28 1.4v-96h-16v96c-9.4-0.2-18.6-0.6-28-1.4l4.6-47.8-16-1.6-4.6 47.8c-69.6-8-134.2-32-190.4-68.2l53.4-79.8-13.4-8.8-53 79.8c-7.6-5.4-15.2-10.8-22.4-16.6l30.4-37-12.4-10.2-30.4 37c-7.2-6-14-12.4-20.8-18.8l25.2-25 350-233.4 233.4-350 25-25c6.4 6.8 12.8 13.6 18.8 20.6l-37 30.4 10.2 12.4 37-30.4c5.8 7.4 11.4 14.8 16.8 22.4l-79.8 53.4 8.8 13.4 79.8-53.4c36.2 56.2 60 120.8 68 190.4l-47.8 4.8 1.6 16 47.8-4.8c0.8 9.2 1.2 18.6 1.4 28h-96v16h96c-0.2 9.4-0.6 18.6-1.4 28l-47.8-4.6-1.6 16 47.8 4.6c-8 69.6-32 134.2-68.2 190.4l-79.8-53.4-8.8 13.4 79.8 53.4c-5.2 7.2-10.8 14.6-16.6 22zM958.4 551c-0.4 3.6-0.6 7.2-1 10.8l1-10.8zM888.4 755.2c-2.4 3.6-4.8 7.2-7.2 10.8l7.2-10.8z",
						"M432.535 71.075l18.73 94.157-15.693 3.122-18.73-94.157 15.693-3.122z",
						"M591.656 952.95l-18.73-94.157 15.693-3.122 18.73 94.157-15.693 3.122z",
						"M389.628 80.89l13.939 45.931-15.31 4.646-13.939-45.931 15.31-4.646z",
						"M634.434 942.887l-13.939-45.931 15.31-4.646 13.939 45.931-15.31 4.646z",
						"M348.014 95.099l36.739 88.694-14.782 6.123-36.739-88.694 14.782-6.123z",
						"M676.123 928.965l-36.739-88.694 14.782-6.123 36.739 88.694-14.782 6.123z",
						"M293.62 120.659l14.11-7.544 22.632 42.331-14.11 7.544-22.632-42.331z",
						"M730.101 903.289l-14.11 7.544-22.632-42.331 14.11-7.544 22.632 42.331z",
						"M120.601 293.826l42.336 22.622-7.541 14.112-42.336-22.622 7.541-14.112z",
						"M903.244 730.195l-42.336-22.622 7.541-14.112 42.336 22.622-7.541 14.112z",
						"M183.811 384.623l-88.694-36.739 6.123-14.782 88.694 36.739-6.123 14.782z",
						"M840.32 639.301l88.694 36.739-6.123 14.782-88.694-36.739 6.123-14.782z",
						"M85.543 374.387l45.936 13.93-4.643 15.312-45.936-13.93 4.643-15.312z",
						"M938.308 649.667l-45.936-13.93 4.643-15.312 45.936 13.93-4.643 15.312z",
						"M74.069 416.782l94.157 18.73-3.122 15.693-94.157-18.73 3.122-15.693z",
						"M949.741 607.243l-94.157-18.73 3.122-15.693 94.157 18.73-3.122 15.693z",
						"M70.965 591.548l94.157-18.73 3.122 15.693-94.157 18.73-3.122-15.693z",
						"M952.842 432.427l-94.157 18.73-3.122-15.693 94.157-18.73 3.122 15.693z",
						"M80.974 634.514l45.931-13.939 4.646 15.31-45.931 13.939-4.646-15.31z",
						"M942.969 389.707l-45.931 13.939-4.646-15.31 45.931-13.939 4.646 15.31z",
						"M101.142 690.912l-6.123-14.782 88.694-36.739 6.123 14.782-88.694 36.739z",
						"M922.794 333.231l6.122 14.782-88.694 36.73-6.122-14.782 88.694-36.73z",
						"M120.824 730.267l-7.544-14.11 42.331-22.632 7.544 14.11-42.331 22.632z",
						"M903.455 293.785l7.544 14.11-42.331 22.632-7.544-14.11 42.331-22.632z",
						"M307.878 910.846l-14.11-7.542 22.627-42.331 14.11 7.542-22.627 42.331z",
						"M716.073 113.074l14.112 7.541-22.622 42.336-14.112-7.541 22.622-42.336z",
						"M333.267 922.799l36.739-88.694 14.782 6.123-36.739 88.694-14.782-6.123z",
						"M690.884 101.11l-36.739 88.694-14.782-6.123 36.739-88.694 14.782 6.123z",
						"M389.634 943.028l-15.31-4.645 13.934-45.931 15.31 4.645-13.934 45.931z",
						"M634.349 80.882l15.312 4.642-13.925 45.936-15.312-4.642 13.925-45.936z",
						"M432.472 952.839l-15.693-3.122 18.73-94.157 15.693 3.122-18.73 94.157z",
						"M591.536 70.969l15.693 3.122-18.73 94.157-15.693-3.122 18.73-94.157z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"safari",
						"browser",
						"internet",
						"brand"
					],
					"defaultCode": 61244,
					"grid": 16
				},
				{
					"id": 1740,
					"width": 1024,
					"paths": [
						"M542.286 510.286q0 14.857-9.429 25.714t-23.714 10.857q-14.857 0-25.714-9.429t-10.857-23.714q0-14.857 9.714-25.714t24-10.857 25.143 9.429 10.857 23.714zM550.857 543.429l200-332q-5.143 4.571-38.571 35.714t-71.714 66.571-78 72.571-66.857 63.143-28.857 29.429l-199.429 331.429q4-4 38.286-35.429t72-66.571 77.714-72.571 66.857-63.429 28.571-28.857zM920.571 512q0 114.857-59.429 212-1.714-1.143-9.714-6.286t-15.143-9.429-9.429-4.286q-7.429 0-7.429 7.429 0 5.714 33.714 25.143-42.286 64-105.429 108.857t-138 63.143l-9.143-38.286q-0.571-5.714-8.571-5.714-2.857 0-4.571 3.143t-1.143 5.429l9.143 38.857q-41.143 8.571-83.429 8.571-113.714 0-212.571-60 0.571-1.143 7.429-11.714t12.286-19.143 5.429-10.857q0-7.429-7.429-7.429-3.429 0-9.714 8.286t-12.857 19.714-7.714 13.143q-64.571-42.857-109.714-107.143t-62.857-139.714l39.429-8.571q5.714-1.714 5.714-8.571 0-2.857-3.143-4.571t-6-1.143l-38.857 8.571q-8-41.143-8-79.429 0-117.714 62.286-216.571 1.143 0.571 10.571 6.857t17.143 10.857 10 4.571q7.429 0 7.429-6.857 0-3.429-7.143-8.857t-18.571-12.286l-11.429-6.857q44-64 108-108t139.429-61.143l8.571 38.286q1.143 5.714 8.571 5.714 2.857 0 4.571-3.143t1.143-6l-8.571-37.714q40.571-7.429 76.571-7.429 116.571 0 216.571 62.286-22.286 32-22.286 37.143 0 7.429 6.857 7.429 6.286 0 27.429-36.571 63.429 42.857 107.143 106.286t61.429 137.714l-32 6.857q-5.714 1.143-5.714 9.143 0 2.857 3.143 4.571t5.429 1.143l32.571-7.429q8 41.143 8 80zM969.143 512q0-93.143-36.286-177.714t-97.429-145.714-145.714-97.429-177.714-36.286-177.714 36.286-145.714 97.429-97.429 145.714-36.286 177.714 36.286 177.714 97.429 145.714 145.714 97.429 177.714 36.286 177.714-36.286 145.714-97.429 97.429-145.714 36.286-177.714zM1024 512q0 104-40.571 198.857t-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571 198.857 40.571 163.429 109.143 109.143 163.429 40.571 198.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"safari"
					],
					"defaultCode": 62055,
					"grid": 14
				},
				{
					"id": 2412,
					"paths": [
						"M960 0h-832c-35.346 0-64 28.654-64 64v64h-32c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h32v256h-32c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h32v64c0 35.346 28.654 64 64 64h832c35.346 0 64-28.654 64-64v-896c0-35.346-28.654-64-64-64zM896 896h-704v-768h704v768z",
						"M640 544c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M256 192v640h576v-640h-576zM544 704c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160-71.634 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"safe",
						"vault",
						"backup"
					],
					"defaultCode": 60247,
					"grid": 16
				},
				{
					"id": 1945,
					"paths": [
						"M1022.246 40.022c3.738-10.56 1.416-22.786-7.034-31.234-8.45-8.45-20.676-10.772-31.236-7.034l-0.022-0.022-351.392 124.852c-21.654-14.946-43.366-28.556-64.914-40.596-71.954-40.204-138.922-61.454-193.666-61.454-43.458 0-79.994 13.564-105.656 39.226-12.86 12.86-22.526 28.162-29.050 45.57-30.318 65.122-47.276 137.716-47.276 214.284 0 280.774 227.612 508.386 508.386 508.386 76.864 0 149.722-17.092 215.040-47.626 17.208-6.59 32.308-16.196 44.812-28.7 48.432-48.43 52.030-131.134 10.132-232.88-17.528-42.566-42.304-87.014-72.938-131.404l124.814-351.368zM771.73 565.956c-5.546 15.614 2.614 32.766 18.224 38.314 3.322 1.18 6.71 1.738 10.044 1.738 12.338 0 23.9-7.672 28.27-19.962l41.766-117.546c16.908 27.812 31.040 55.256 41.956 81.766 27.338 66.396 30.942 121.026 9.402 142.562-9.266 9.264-24.438 13.96-45.102 13.96-74.192 0-212.444-63.39-354.064-205.014-83.304-83.302-147.814-174.434-181.65-256.604-27.34-66.398-30.944-121.024-9.404-142.562 9.262-9.262 24.438-13.96 45.102-13.96 42.526 0 106.104 20.848 179.294 65.296l-117.612 41.79c-15.612 5.546-23.772 22.7-18.224 38.312 5.546 15.614 22.7 23.772 38.312 18.224l420.764-149.502-292.020 292.020c-11.716 11.716-11.716 30.71 0 42.426 5.856 5.858 13.534 8.786 21.212 8.786s15.356-2.928 21.212-8.788l292.020-292.020-149.502 420.764z",
						"M576 992v-32c0-15.84-1.932-31.226-5.548-45.952-96.492-21.036-186.18-65.482-262.206-130.514-68.368 29.388-116.246 97.332-116.246 176.466v32c0 17.674 14.326 32 32 32h320c17.674 0 32-14.326 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"satellite-dish"
					],
					"defaultCode": 59780,
					"grid": 16
				},
				{
					"id": 1946,
					"paths": [
						"M960 0c-35.346 0-64 28.654-64 64 0 11.216 2.892 21.752 7.962 30.918l-352.024 251.586c34.188 48.832 76.726 91.372 125.562 125.552l251.58-352.018c9.168 5.068 19.706 7.962 30.92 7.962 35.346 0 64-28.654 64-64s-28.654-64-64-64z",
						"M862.458 343.966l-39.608 55.42c38.71 51.116 69.236 102.548 89.138 150.878 27.338 66.396 30.942 121.026 9.402 142.562-9.268 9.264-24.44 13.958-45.104 13.958-74.192 0-212.444-63.388-354.064-205.012-83.302-83.302-147.812-174.434-181.648-256.604-27.34-66.398-30.944-121.024-9.404-142.562 9.262-9.262 24.438-13.96 45.102-13.96 55.456 0 146.706 35.426 248.4 112.46l55.33-39.544c-37.176-29.192-75.010-54.708-112.356-75.576-71.954-40.204-138.922-61.454-193.666-61.454-43.458 0-79.994 13.564-105.656 39.226-12.86 12.86-22.526 28.162-29.050 45.57-30.316 65.124-47.274 137.718-47.274 214.286 0 280.772 227.612 508.386 508.386 508.386 76.864 0 149.72-17.092 215.040-47.624 17.208-6.59 32.308-16.198 44.812-28.702 48.432-48.43 52.030-131.134 10.13-232.88-23.78-57.76-60.898-118.982-107.91-178.828z",
						"M576 992v-32c0-15.84-1.932-31.226-5.546-45.952-96.494-21.038-186.18-65.482-262.208-130.514-68.368 29.388-116.246 97.332-116.246 176.466v32c0 17.674 14.326 32 32 32h320c17.674 0 32-14.326 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"satellite-dish"
					],
					"defaultCode": 59781,
					"grid": 16
				},
				{
					"id": 761,
					"width": 1024,
					"paths": [
						"M864 64h-704c-53.024 0-96 42.976-96 96v704c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM800 96v288h-576v-288h576zM320 928v-256h384v256h-384zM928 864c0 35.296-28.704 64-64 64h-128v-256c0-17.664-14.336-32-32-32h-384c-17.664 0-32 14.336-32 32v256h-128c-35.296 0-64-28.704-64-64v-704c0-35.296 28.704-64 64-64h32v288c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-288h32c35.296 0 64 28.704 64 64v704zM640 352h96c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32zM640 160h96v160h-96v-160zM640 752c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM640 816c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"save",
						"keep",
						"store"
					],
					"grid": 32
				},
				{
					"id": 762,
					"width": 1024,
					"paths": [
						"M640 160h96v160h-96v-160zM800 384h-576v-320h576v320zM768 160c0-17.664-14.336-32-32-32h-96c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-160zM864 64h-32v320c0 17.664-14.336 32-32 32h-576c-17.664 0-32-14.336-32-32v-320h-32c-53.024 0-96 42.976-96 96v704c0 53.024 42.976 96 96 96h128v-288c0-17.664 14.336-32 32-32h384c17.664 0 32 14.336 32 32v288h128c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM320 672h384v288h-384v-288zM384 784c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16zM384 848c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"save",
						"keep",
						"store"
					],
					"grid": 32
				},
				{
					"id": 1113,
					"width": 1024,
					"paths": [
						"M864 32h-800c-17.664 0-32 14.336-32 32v896c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-800l-128-128zM256 96h512v320h-512v-320zM928 928h-832v-832h128v320c0 17.664 14.336 32 32 32h512c17.664 0 32-14.336 32-32v-320h37.504l90.496 90.528v741.472zM288 832h448c17.664 0 32-14.336 32-32v-224c0-17.664-14.336-32-32-32h-448c-17.664 0-32 14.336-32 32v224c0 17.664 14.336 32 32 32zM288 576h448v224h-448v-224zM576 384h160v-256h-160v256zM608 160h96v192h-96v-192zM320 608h384v32h-384v-32zM320 672h384v32h-384v-32zM320 736h384v32h-384v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"save",
						"keep",
						"store"
					],
					"grid": 32
				},
				{
					"id": 763,
					"width": 1024,
					"paths": [
						"M640 528c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM624 576h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16zM956.384 569.696c-25.28 202.432-190.368 364.832-393.12 387.456-111.040 12.384-214.912-16.064-298.944-71.936l-148.224 65.888c-12.096 5.376-26.272 2.752-35.616-6.624l-0.928-0.928c-9.376-9.376-12-23.52-6.624-35.616l65.888-148.224c-55.904-84.032-84.32-187.904-71.936-298.944 22.592-202.784 184.992-367.872 387.424-393.152 292.64-36.544 538.624 209.44 502.080 502.080zM921.28 451.936c-25.376-179.168-170.048-323.84-349.216-349.216-278.528-39.424-514.464 200.736-467.648 480.352 9.824 58.656 34.144 114.016 67.072 163.552l6.496 9.76-71.712 161.344 161.344-71.712 9.76 6.496c49.536 32.928 104.896 57.248 163.552 67.072 279.616 46.816 519.808-189.12 480.352-467.648zM624 384h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16zM624 448h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"say",
						"speak",
						"talk",
						"message"
					],
					"grid": 32
				},
				{
					"id": 764,
					"width": 1024,
					"paths": [
						"M454.304 67.616c-202.432 25.28-364.832 190.368-387.424 393.12-12.384 111.040 16.064 214.912 71.936 298.944l-65.888 148.224c-5.376 12.096-2.752 26.272 6.624 35.616l0.928 0.928c9.376 9.376 23.52 12 35.616 6.624l148.224-65.888c84.032 55.904 187.904 84.32 298.944 71.936 202.752-22.592 367.84-185.024 393.12-387.456 36.544-292.608-209.44-538.592-502.080-502.048zM624 608h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16 0 8.864-7.168 16-16 16zM624 544h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16zM624 480h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16zM624 416h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"say",
						"speak",
						"talk",
						"message"
					],
					"grid": 32
				},
				{
					"id": 2555,
					"paths": [
						"M864 64h-768c-52.8 0-96 43.2-96 96v768c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-768c0-52.8-43.198-96-96-96zM672 512h-160v-224c0-17.672-14.328-32-32-32s-32 14.328-32 32v224h-160l-123.722-123.722c57.456-116.288 177.234-196.278 315.722-196.278s258.266 79.99 315.722 196.278l-123.722 123.722z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scale",
						"weight",
						"fitness"
					],
					"defaultCode": 60390,
					"grid": 16
				},
				{
					"id": 765,
					"width": 1024,
					"paths": [
						"M880 288h-112c0-17.664-14.336-32-32-32h-448c-17.664 0-32 14.336-32 32h-112c-8.832 0-16 7.168-16 16s7.168 16 16 16h112v8.928c0 13.76 8.8 26.016 21.888 30.368l74.112 24.704v160c0 17.664 14.336 32 32 32v224c0 17.664 14.336 32 32 32h32v160c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-160h32c17.664 0 32-14.336 32-32v-224c17.664 0 32-14.336 32-32v-160l74.112-24.704c13.088-4.352 21.888-16.576 21.888-30.368v-8.928h112c8.832 0 16-7.168 16-16s-7.168-16-16-16zM544 992h-64v-160h64v160zM608 800h-80v-144c0-8.832-7.168-16-16-16s-16 7.168-16 16v144h-80v-224h192v224zM736 328.928l-74.112 24.704c-13.088 4.352-21.888 16.608-21.888 30.368v160h-256v-160c0-13.76-8.8-26.016-21.888-30.368l-74.112-24.704v-40.928h448v40.928zM608 160v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48c0-53.024-42.976-96-96-96s-96 42.976-96 96h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v32c0 53.024 42.976 96 96 96s96-42.976 96-96zM576 160c0 35.296-28.704 64-64 64s-64-28.704-64-64v-32h128v32zM448 96c0-35.296 28.704-64 64-64s64 28.704 64 64h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scare",
						"stand",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 766,
					"width": 1024,
					"paths": [
						"M256 288c0-17.664 14.336-32 32-32h448c17.664 0 32 14.336 32 32v40.928c0 13.76-8.8 26.016-21.888 30.368l-74.112 24.704v160c0 17.664-14.336 32-32 32h-256c-17.664 0-32-14.336-32-32v-160l-74.112-24.704c-13.088-4.352-21.888-16.576-21.888-30.368v-40.928zM384 608v192c0 17.664 14.336 32 32 32h80v-144c0-8.832 7.168-16 16-16s16 7.168 16 16v144h80c17.664 0 32-14.336 32-32v-192h-256zM608 160v-32h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-48c0-53.024-42.976-96-96-96s-96 42.976-96 96h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h48v32c0 53.024 42.976 96 96 96s96-42.976 96-96zM448 864v128c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-128h-128zM224 288h-80c-8.832 0-16 7.168-16 16s7.168 16 16 16h80v-32zM880 288h-80v32h80c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scare",
						"stand",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 767,
					"width": 1024,
					"paths": [
						"M384 496c0-8.832 7.168-16 16-16h16c17.664 0 32 14.336 32 32v208c0 8.832-7.168 16-16 16s-16-7.168-16-16v-208h-16c-8.832 0-16-7.168-16-16zM560 512h16v208c0 8.832 7.168 16 16 16s16-7.168 16-16v-208c0-17.664-14.336-32-32-32h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16zM960 256v608c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-608c0-53.024 42.976-96 96-96h32v-32c0-35.36 28.64-64 64-64s64 28.64 64 64v32h384v-32c0-35.36 28.64-64 64-64s64 28.64 64 64v32h32c53.024 0 96 42.976 96 96zM736 224c0 17.632 14.368 32 32 32s32-14.368 32-32v-96c0-17.632-14.368-32-32-32s-32 14.368-32 32v96zM224 224c0 17.632 14.368 32 32 32s32-14.368 32-32v-96c0-17.632-14.368-32-32-32s-32 14.368-32 32v96zM927.232 871.744c-16.928 14.912-38.912 24.256-63.232 24.256h-704c-24.32 0-46.304-9.344-63.232-24.256 3.872 31.584 30.592 56.256 63.232 56.256h704c32.64 0 59.36-24.672 63.232-56.256zM928 384h-832v416c0 35.296 28.704 64 64 64h704c35.296 0 64-28.704 64-64v-416zM928 256c0-35.296-28.704-64-64-64h-32v32c0 35.36-28.64 64-64 64s-64-28.64-64-64v-32h-384v32c0 35.36-28.64 64-64 64s-64-28.64-64-64v-32h-32c-35.296 0-64 28.704-64 64v96h832v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"schedule",
						"plan"
					],
					"grid": 32
				},
				{
					"id": 768,
					"width": 1024,
					"paths": [
						"M224 224v-128c0-17.632 14.368-32 32-32s32 14.368 32 32v128c0 17.632-14.368 32-32 32s-32-14.368-32-32zM960 256v512c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-512c0-53.024 42.976-96 96-96h32v64c0 35.36 28.64 64 64 64s64-28.64 64-64v-64h384v64c0 35.36 28.64 64 64 64s64-28.64 64-64v-64h32c53.024 0 96 42.976 96 96zM448 512c0-17.664-14.336-32-32-32h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v208c0 8.832 7.168 16 16 16s16-7.168 16-16v-208zM608 512c0-17.664-14.336-32-32-32h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v208c0 8.832 7.168 16 16 16s16-7.168 16-16v-208zM928 368c0-8.832-7.168-16-16-16h-800c-8.832 0-16 7.168-16 16s7.168 16 16 16h800c8.832 0 16-7.168 16-16zM768 256c17.632 0 32-14.368 32-32v-128c0-17.632-14.368-32-32-32s-32 14.368-32 32v128c0 17.632 14.368 32 32 32zM160 896c-38.4 0-72.512-17.344-96-44.224v12.224c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-12.224c-23.488 26.88-57.6 44.224-96 44.224h-704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"schedule",
						"plan"
					],
					"grid": 32
				},
				{
					"id": 1114,
					"width": 1024,
					"paths": [
						"M992 160h-96v-64c0-52.928-43.072-96-96-96s-96 43.072-96 96v64h-384v-64c0-52.928-43.072-96-96-96s-96 43.072-96 96v64h-96c-17.664 0-32 14.336-32 32v800c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-800c0-17.664-14.336-32-32-32zM768 96c0-17.664 14.336-32 32-32s32 14.336 32 32v160c0 17.632-14.368 32-32 32s-32-14.368-32-32v-160zM192 96c0-17.664 14.336-32 32-32s32 14.336 32 32v160c0 17.632-14.368 32-32 32s-32-14.368-32-32v-160zM960 960h-896v-576h896v576zM960 352h-896v-128h96v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h448v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h96v128zM320 864h128v-384h-192v128h64v256zM288 576v-64h128v320h-64v-256h-64zM576 864h96c53.024 0 96-42.976 96-96v-192c0-53.024-42.976-96-96-96h-96c-53.024 0-96 42.976-96 96v192c0 53.024 42.976 96 96 96zM512 576c0-35.296 28.704-64 64-64h96c35.296 0 64 28.704 64 64v192c0 35.296-28.704 64-64 64h-96c-35.296 0-64-28.704-64-64v-192zM608 768h32c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32zM608 608h32v128h-32v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"schedule",
						"plan"
					],
					"grid": 32
				},
				{
					"id": 3225,
					"paths": [
						"M781.958 1024c-54.416-0.002-122.372-33.216-151.618-107.404-4.068-9.68-8.542-21.428-13.718-35.018-16.57-43.498-41.612-109.232-67.784-136.46-9.58-9.968-16.99-17.198-22.946-23.008-5.346-5.214-9.842-9.602-13.892-14.038-4.050 4.438-8.546 8.824-13.896 14.044-5.952 5.808-13.36 13.038-22.936 23-26.172 27.232-51.216 92.976-67.79 136.478-5.172 13.582-9.646 25.322-13.712 34.998-29.25 74.19-97.204 107.408-151.616 107.408-10.606 0-20.276-1.292-28.746-3.836-53.544-16.092-86.024-75.878-80.822-148.772l0.744-8.412c6.574-58.808 42.398-116.916 100.87-163.612 50.688-40.476 110.62-65.624 156.408-65.624 9.060 0 17.424 0.988 25.038 2.944l31.422-64.418c-32.296-80.828-78.304-201.548-114.246-307.292-20.030-58.926-34.896-107.188-44.188-143.442-14.704-57.382-13.766-76.786-7.832-88.264l17.202-33.272 214.106 438.93 214.092-438.928 17.204 33.27c5.934 11.478 6.876 30.882-7.83 88.264-9.292 36.252-24.158 84.514-44.186 143.44-35.94 105.736-81.948 226.458-114.246 307.292l31.422 64.418c7.612-1.956 15.974-2.944 25.036-2.944 45.79 0 105.722 25.148 156.412 65.628 49.99 39.924 83.426 88.194 96.18 138.104l2.358-1.128 3.070 35.044c5.206 72.89-27.27 132.676-80.808 148.772-8.47 2.544-18.142 3.836-28.746 3.836-0.004 0.002-0.006 0.002-0.006 0.002zM693.682 881.896c37.872 68.706 71.708 78.982 88.526 78.982 22.894 0 40.036-18.476 43.382-36.338 2.194-11.742 2.592-23.828 1.184-35.922-5.674-48.312-38.676-89.796-65.356-116.088-36.668-36.13-77.778-60.124-104.17-70.6-2.626-0.914-4.242-1.052-4.978-1.052-0.51 0-0.708 0.062-0.71 0.062-7.686 4.992-16.876 63.040 42.122 180.956zM366.26 701.93c-26.23 10.48-67.090 34.472-103.528 70.602-26.52 26.29-59.312 67.776-64.95 116.104-1.408 12.060-1.012 24.138 1.178 35.906 3.322 17.86 20.358 36.338 43.112 36.338 16.712 0 50.34-10.278 87.982-78.98 58.624-117.876 49.528-175.888 41.806-180.986 0 0.002-0.002 0.002-0.008 0.002-0.040 0-0.25-0.036-0.64-0.036-0.734-0.002-2.336 0.136-4.952 1.050z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scissors",
						"cut"
					],
					"defaultCode": 61060,
					"grid": 16
				},
				{
					"id": 3226,
					"paths": [
						"M297.9 0l-17.202 33.272c-5.934 11.478-6.872 30.882 7.832 88.264 9.292 36.254 24.158 84.514 44.188 143.442 25.29 74.404 55.558 156.206 82.532 226.324l61.15-125.366-178.5-365.936zM891.516 871.392l-3.070-35.044-2.358 1.128c-12.754-49.91-46.19-98.18-96.18-138.104-50.69-40.48-110.624-65.628-156.412-65.628-9.060 0-17.424 0.988-25.036 2.944l-31.422-64.418c32.298-80.834 78.306-201.558 114.246-307.292 20.028-58.926 34.894-107.188 44.186-143.44 14.706-57.382 13.764-76.786 7.83-88.264l-17.204-33.27-310.554 636.684c-7.612-1.956-15.978-2.944-25.038-2.944-45.788 0-105.72 25.148-156.408 65.624-58.472 46.696-94.296 104.804-100.868 163.612l-0.744 8.412c-5.202 72.892 27.278 132.68 80.822 148.772 8.47 2.544 18.14 3.836 28.746 3.836 54.412 0 122.366-33.218 151.616-107.406 4.066-9.676 8.54-21.416 13.712-34.998 16.572-43.502 41.618-109.246 67.79-136.478 9.578-9.962 16.986-17.192 22.936-23 5.35-5.22 9.846-9.608 13.896-14.044 4.050 4.436 8.546 8.822 13.892 14.038 5.956 5.81 13.366 13.040 22.946 23.008 26.172 27.228 51.212 92.962 67.784 136.46 5.176 13.59 9.65 25.338 13.718 35.018 29.246 74.188 97.202 107.402 151.618 107.404 0.002 0 0.004 0 0.004 0 10.604 0 20.276-1.292 28.746-3.836 53.536-16.098 86.010-75.882 80.806-148.774zM330.054 881.898c-37.642 68.704-71.27 78.98-87.982 78.98-22.754 0-39.79-18.478-43.112-36.338-2.19-11.768-2.586-23.846-1.178-35.906 5.636-48.328 38.43-89.814 64.95-116.104 36.438-36.128 77.298-60.122 103.528-70.602 2.616-0.914 4.218-1.050 4.952-1.050 0.388 0 0.6 0.036 0.64 0.036 0.006 0 0.008 0 0.008-0.002 7.722 5.098 16.818 63.112-41.806 180.986zM825.59 924.542c-3.348 17.862-20.488 36.338-43.382 36.338-16.816 0-50.654-10.278-88.526-78.982-58.998-117.916-49.808-175.964-42.124-180.956 0.002 0 0.202-0.062 0.71-0.062 0.736 0 2.352 0.138 4.978 1.052 26.392 10.476 67.502 34.468 104.17 70.6 26.68 26.292 59.682 67.776 65.356 116.088 1.41 12.092 1.012 24.178-1.182 35.922z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scissors",
						"cut"
					],
					"defaultCode": 61061,
					"grid": 16
				},
				{
					"id": 3227,
					"paths": [
						"M913.826 679.694c-66.684-104.204-181.078-150.064-255.51-102.434-6.428 4.116-12.334 8.804-17.744 13.982l-79.452-124.262 183.462-287.972c15.016-27.73 20.558-60.758 13.266-93.974-6.972-31.75-24.516-58.438-48.102-77.226l-12.278-7.808-217.468 340.114-217.47-340.114-12.276 7.806c-23.586 18.79-41.13 45.476-48.1 77.226-7.292 33.216-1.75 66.244 13.264 93.974l183.464 287.972-79.454 124.262c-5.41-5.178-11.316-9.868-17.744-13.982-74.432-47.63-188.826-1.77-255.51 102.434-66.68 104.2-60.398 227.286 14.032 274.914 74.43 47.632 188.824 1.77 255.508-102.432l164.286-257.87 164.288 257.872c66.684 104.202 181.078 150.064 255.508 102.432 74.428-47.63 80.71-170.716 14.030-274.914zM234.852 800.43c-30.018 46.904-68.534 69.726-94.572 75.446-0.004 0-0.004 0-0.004 0-8.49 1.868-20.294 3.010-28.324-2.128-8.898-5.694-14.804-20.748-15.8-40.276-1.616-31.644 9.642-68.836 30.888-102.034 30.014-46.906 68.53-69.726 94.562-75.444 8.496-1.866 20.308-3.010 28.336 2.126 8.898 5.694 14.802 20.75 15.798 40.272 1.618 31.65-9.64 68.84-30.884 102.038zM480 512c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM863.85 833.47c-0.996 19.528-6.902 34.582-15.8 40.276-8.030 5.138-19.834 3.996-28.324 2.128 0 0 0 0-0.004 0-26.040-5.718-64.554-28.542-94.572-75.446-21.244-33.198-32.502-70.388-30.884-102.038 0.996-19.522 6.9-34.578 15.798-40.272 8.028-5.136 19.84-3.992 28.336-2.126 26.034 5.716 64.548 28.538 94.562 75.444 21.246 33.198 32.502 70.39 30.888 102.034z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scissors",
						"cut"
					],
					"defaultCode": 61062,
					"grid": 16
				},
				{
					"id": 152,
					"paths": [
						"M896 102.4h-819.2c-42.347 0-76.8 34.453-76.8 76.8v512c0 42.349 34.453 76.8 76.8 76.8h384v102.4h-179.2c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h409.6c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-179.2v-102.4h384c42.349 0 76.8-34.451 76.8-76.8v-512c0-42.347-34.451-76.8-76.8-76.8zM921.6 691.2c0 14.115-11.485 25.6-25.6 25.6h-819.2c-14.115 0-25.6-11.485-25.6-25.6v-512c0-14.115 11.485-25.6 25.6-25.6h819.2c14.115 0 25.6 11.485 25.6 25.6v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"screen",
						"monitor"
					],
					"defaultCode": 59449,
					"grid": 20
				},
				{
					"id": 1115,
					"width": 1024,
					"paths": [
						"M532.672 532.672l288-288 22.624 22.624-288 288-22.624-22.624zM468.672 468.672l22.624 22.624 288-288-22.624-22.624-288 288zM1014.624 278.624l-448 448c-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376l-25.376-25.376-25.376 25.376c-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376l-41.376-41.376-178.752 178.752 9.376 9.376c12.512 12.512 12.512 32.736 0 45.248l-96 96c-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376l-64-64c-12.512-12.512-12.512-32.736 0-45.248l96-96c12.512-12.512 32.736-12.512 45.248 0l9.376 9.376 178.752-178.752-41.376-41.376c-12.512-12.512-12.512-32.736 0-45.248l25.376-25.376-25.376-25.376c-12.512-12.512-12.512-32.768 0-45.248l448-448c6.24-6.24 14.432-9.376 22.624-9.376s16.384 3.136 22.624 9.376l224 224c12.512 12.48 12.512 32.768 0 45.248zM146.752 896l-18.752-18.752-50.752 50.752 18.752 18.752 50.752-50.752zM946.752 256l-178.752-178.752-402.752 402.752 178.752 178.752 402.752-402.752zM473.376 633.376l-82.752-82.752-25.376 25.376 82.752 82.752 25.376-25.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"screw",
						"adjust",
						"calibrate",
						"twist",
						"tighten"
					],
					"grid": 32
				},
				{
					"id": 2432,
					"paths": [
						"M1014.512 790.512l-397.024-397.024c-22.060-22.062-76.82-4.308-130.744 39.516l-294.744-294.744-32-74.26-102.464-64-57.536 57.536 64 102.464 74.26 32 294.746 294.744c-43.826 53.926-61.58 108.684-39.52 130.744 0.006 0.006 0.012 0.010 0.018 0.016l397.006 397.008c25.952 25.95 97.13-3.158 158.988-65.016 61.856-61.856 90.962-133.038 65.014-158.984zM890.87 890.87c-7.42 7.42-17.144 11.13-26.87 11.13s-19.45-3.71-26.87-11.13l-320-320c-14.842-14.84-14.842-38.898 0-53.738 14.84-14.84 38.898-14.84 53.738 0l320 320c14.842 14.838 14.842 38.898 0.002 53.738z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"screwdriver",
						"tool",
						"fix",
						"make",
						"build"
					],
					"defaultCode": 60267,
					"grid": 16
				},
				{
					"id": 2433,
					"paths": [
						"M1014.512 790.512l-217.79-217.79c-41.53 9.522-86.882-1.864-119.232-34.212-32.35-32.35-43.734-77.704-34.212-119.232l-25.79-25.79c-22.060-22.062-76.82-4.308-130.744 39.516l-294.744-294.744-32-74.26-102.464-64-57.536 57.536 64 102.464 74.26 32 294.746 294.744c-43.826 53.926-61.58 108.684-39.52 130.744 0.006 0.006 0.012 0.010 0.018 0.016l25.774 25.774c41.53-9.522 86.882 1.862 119.232 34.212 32.352 32.352 43.736 77.704 34.212 119.232l217.788 217.79c25.952 25.95 97.13-3.158 158.988-65.016 61.856-61.856 90.962-133.038 65.014-158.984zM890.87 890.87c-7.42 7.42-17.144 11.13-26.87 11.13s-19.45-3.71-26.87-11.13l-320-320c-14.842-14.84-14.842-38.898 0-53.738 14.84-14.84 38.898-14.84 53.738 0l320 320c14.842 14.838 14.842 38.898 0.002 53.738z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"screwdriver",
						"tool",
						"fix",
						"make",
						"build"
					],
					"defaultCode": 60268,
					"grid": 16
				},
				{
					"id": 1773,
					"width": 877.7140502929688,
					"paths": [
						"M857.143 885.143q0 50.857-36 87.143t-87.429 36.286-87.714-36.286-36.286-87.143q0-51.429 36.286-87.714t87.714-36.286 87.429 36.286 36 87.714zM724 724.571q-65.714 8.571-110 58.571t-44.286 117.429q0 42.286 18.857 78.857-83.429 44.571-216.571 44.571-62.286 0-114.857-12t-87.714-31.143-63.143-43.714-43.429-48.571-25.429-47.429-13.429-38-3.429-22.571q0-10.857 2.571-24.286t10.571-32 20.857-33.143 36.571-24.857 54-10.286 53.714 10 36 23.429 20.286 30.286 10 28 2.286 19.143q0 19.429-13.143 46.286 16 15.429 46.857 24t53.143 9.714l22.857 0.571q65.714 0 108.571-29.143t42.857-76q0-14.857-5.143-27.714t-18-25.429-28.286-23.429-42.286-25.143-53.429-27.143-68.286-32.286q-16-7.429-24.571-11.429-66.286-31.429-106.857-57.143t-70-58.286-41.143-71.714-11.714-92.857q0-44.571 11.714-85.714t37.714-78.571 64.286-65.143 95.143-44 126.571-16.286q68.571 0 125.714 14.857t94 38.286 62.571 53.714 36.571 60.286 10.857 59.143q0 26.286-8.571 47.143t-20.857 33.143-27.714 20.571-28 11.143-22.286 2.857h-22.857t-22.286-2.857-25.143-8-23.429-16-21.143-26.286-13.714-40.286-5.714-55.714q-8.571-9.143-33.714-14.571t-46.286-6l-21.143-0.571q-38.857 0-67.143 17.714t-40.286 40-12 43.429q0 13.714 2.857 24.571t13.714 26.286 30.286 29.143 55.429 30.571 85.714 33.429q43.429 14.286 79.143 30.571t62.286 31.714 47.429 33.714 34.571 34 23.429 35.714 15.143 35.429 8.286 36.286 3.429 35.429 0.571 35.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scribd"
					],
					"defaultCode": 62090,
					"grid": 14
				},
				{
					"id": 769,
					"width": 1024,
					"paths": [
						"M480 464c0-8.832 7.168-16 16-16h192c8.832 0 16 7.168 16 16s-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16zM480 528c0-8.832 7.168-16 16-16h192c8.832 0 16 7.168 16 16s-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16zM480 592c0-8.832 7.168-16 16-16h192c8.832 0 16 7.168 16 16s-7.168 16-16 16h-192c-8.832 0-16-7.168-16-16zM768 64h-544c-53.024 0-96 42.976-96 96v64c0 17.664 14.336 32 32 32h128v512h-128c-17.664 0-32 14.336-32 32v64c0 53.024 42.976 96 96 96h544c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM288 864c0 35.36-28.64 64-64 64-35.296 0-64-28.704-64-64v-64h128v64zM288 224h-128v-64c0-35.296 28.704-64 64-64 35.36 0 64 28.64 64 64v64zM832 864c0 17.088-6.656 33.152-18.752 45.248s-28.16 18.752-45.248 18.752h-472.512c15.232-16.992 24.512-39.424 24.512-64v-704c0-24.576-9.28-47.008-24.512-64h472.512c35.296 0 64 28.704 64 64v704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scroll",
						"read",
						"write"
					],
					"grid": 32
				},
				{
					"id": 770,
					"width": 1024,
					"paths": [
						"M768 64h-481.856c20.832 20.352 33.856 48.64 33.856 80v736c0 31.36-13.024 59.648-33.856 80h481.856c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM688 608h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16s-7.168 16-16 16zM688 544h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16s-7.168 16-16 16zM688 480h-192c-8.832 0-16-7.168-16-16s7.168-16 16-16h192c8.832 0 16 7.168 16 16s-7.168 16-16 16zM128 224v-64c0-50.272 38.784-91.072 88-95.2 40.32 4.096 72 37.824 72 79.2v112h-128c-17.664 0-32-14.336-32-32zM216 959.2c-49.216-4.128-88-44.928-88-95.2v-64c0-17.664 14.336-32 32-32h128v112c0 41.376-31.68 75.104-72 79.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scroll",
						"read",
						"write"
					],
					"grid": 32
				},
				{
					"id": 1116,
					"width": 1024,
					"paths": [
						"M416 704h288v32h-288v-32zM416 640h288v-32h-288v32zM416 544h288v-32h-288v32zM416 352h288v-32h-288v32zM416 448h288v-32h-288v32zM864 128v768c0 70.592-57.408 128-128 128h-512c-70.592 0-128-57.408-128-128v-96c0-17.664 14.336-32 32-32h128v-512h-128c-17.664 0-32-14.336-32-32v-96c0-70.592 57.408-128 128-128h512c70.592 0 128 57.408 128 128zM800 896v-768c0-35.36-28.64-64-64-64h-440.928c15.328 17.024 24.928 39.296 24.928 64v768c0 24.704-9.6 46.976-24.928 64h440.928c35.36 0 64-28.64 64-64zM160 128v64h128v-64c0-35.296-28.704-64-64-64s-64 28.704-64 64zM160 832v64c0 35.296 28.704 64 64 64s64-28.704 64-64v-64h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"scroll",
						"read",
						"write"
					],
					"grid": 32
				},
				{
					"id": 2373,
					"paths": [
						"M1024 864l-300.486-300.486c28.384-53.576 44.486-114.66 44.486-179.514 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c64.854 0 125.938-16.102 179.514-44.486l300.486 300.486 160-160zM128 384c0-141.384 114.616-256 256-256s256 114.616 256 256-114.616 256-256 256-256-114.616-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search",
						"magnifier",
						"magnifying-glass",
						"inspect",
						"find"
					],
					"defaultCode": 60208,
					"grid": 16
				},
				{
					"id": 1194,
					"width": 950.8559875488281,
					"paths": [
						"M585.143 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-329.143q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h329.143q7.429 0 12.857 5.429t5.429 12.857zM658.286 475.429q0-105.714-75.143-180.857t-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143 180.857-75.143 75.143-180.857zM950.857 950.857q0 30.286-21.429 51.714t-51.714 21.429q-30.857 0-51.429-21.714l-196-195.429q-102.286 70.857-228 70.857-81.714 0-156.286-31.714t-128.571-85.714-85.714-128.571-31.714-156.286 31.714-156.286 85.714-128.571 128.571-85.714 156.286-31.714 156.286 31.714 128.571 85.714 85.714 128.571 31.714 156.286q0 125.714-70.857 228l196 196q21.143 21.143 21.143 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search-minus"
					],
					"defaultCode": 61456,
					"grid": 14
				},
				{
					"id": 1193,
					"width": 950.8559875488281,
					"paths": [
						"M585.143 457.143v36.571q0 7.429-5.429 12.857t-12.857 5.429h-128v128q0 7.429-5.429 12.857t-12.857 5.429h-36.571q-7.429 0-12.857-5.429t-5.429-12.857v-128h-128q-7.429 0-12.857-5.429t-5.429-12.857v-36.571q0-7.429 5.429-12.857t12.857-5.429h128v-128q0-7.429 5.429-12.857t12.857-5.429h36.571q7.429 0 12.857 5.429t5.429 12.857v128h128q7.429 0 12.857 5.429t5.429 12.857zM658.286 475.429q0-105.714-75.143-180.857t-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143 180.857-75.143 75.143-180.857zM950.857 950.857q0 30.286-21.429 51.714t-51.714 21.429q-30.857 0-51.429-21.714l-196-195.429q-102.286 70.857-228 70.857-81.714 0-156.286-31.714t-128.571-85.714-85.714-128.571-31.714-156.286 31.714-156.286 85.714-128.571 128.571-85.714 156.286-31.714 156.286 31.714 128.571 85.714 85.714 128.571 31.714 156.286q0 125.714-70.857 228l196 196q21.143 21.143 21.143 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search-plus"
					],
					"defaultCode": 61454,
					"grid": 14
				},
				{
					"id": 1117,
					"width": 1024,
					"paths": [
						"M384 96c-159.072 0-288 128.928-288 288s128.928 288 288 288 288-128.928 288-288c0-159.072-128.928-288-288-288zM384 640c-141.376 0-256-114.624-256-256s114.624-256 256-256 256 114.624 256 256-114.624 256-256 256zM1014.624 854.624l-224-224c-12.512-12.512-32.768-12.512-45.248 0l-34.752 34.752-33.536-33.536c56.608-66.912 90.912-153.312 90.912-247.84 0-212.064-171.936-384-384-384s-384 171.936-384 384c0 212.064 171.936 384 384 384 94.528 0 180.928-34.304 247.84-90.912l33.536 33.536-34.752 34.752c-12.512 12.512-12.512 32.768 0 45.248l224 224c12.512 12.512 32.768 12.512 45.248 0l114.752-114.752c12.512-12.48 12.512-32.736 0-45.248zM384 704c-176.736 0-320-143.264-320-320s143.264-320 320-320 320 143.264 320 320c0 176.736-143.264 320-320 320zM877.248 946.752l-178.752-178.752 69.504-69.504 178.752 178.752-69.504 69.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search",
						"find",
						"magnify",
						"zoom",
						"look"
					],
					"grid": 32
				},
				{
					"id": 2376,
					"paths": [
						"M637.542 557.848c41.806-57.89 66.458-128.984 66.458-205.848 0-194.404-157.596-352-352-352s-352 157.596-352 352 157.596 352 352 352c76.864 0 147.958-24.652 205.848-66.458l338.152 386.458 128-128-386.458-338.152zM352 608c-141.384 0-256-114.616-256-256s114.616-256 256-256c141.382 0 256 114.616 256 256s-114.614 256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search",
						"magnifier",
						"magnifying-glass",
						"inspect",
						"find"
					],
					"defaultCode": 60211,
					"grid": 16
				},
				{
					"id": 2379,
					"paths": [
						"M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.068 91.842-154.078 91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c95.098 0 182.108-34.586 249.176-91.844-1 21.662 9.36 48.478 31.926 73.552l206.294 242.552c35.322 39.246 93.022 42.554 128.22 7.356s31.892-92.898-7.354-128.22zM384 640c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search",
						"magnifier",
						"magnifying-glass",
						"inspect",
						"find"
					],
					"defaultCode": 60214,
					"grid": 16
				},
				{
					"id": 2380,
					"paths": [
						"M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.066 91.842-154.078 91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c95.098 0 182.11-34.586 249.176-91.844-1 21.662 9.36 48.476 31.926 73.55l206.294 242.554c35.322 39.246 93.022 42.554 128.218 7.356 35.2-35.198 31.894-92.898-7.352-128.22zM574.522 584h-381.042c-5.388-5.12-10.562-10.464-15.524-16h412.088c-4.962 5.536-10.134 10.88-15.522 16zM303.088 648c-14.028-4.282-27.58-9.648-40.562-16h242.95c-12.982 6.352-26.534 11.718-40.562 16h-161.826zM234.178 616c-7.702-4.968-15.134-10.312-22.284-16h344.212c-7.15 5.688-14.584 11.032-22.286 16h-299.642zM164.664 552c-3.994-5.192-7.806-10.528-11.43-16h461.532c-3.624 5.472-7.436 10.808-11.43 16h-438.672zM143.402 520c-2.972-5.23-5.788-10.562-8.42-16h498.036c-2.632 5.438-5.448 10.77-8.42 16h-481.196zM127.872 488c-2.142-5.256-4.142-10.588-5.962-16h524.18c-1.822 5.412-3.82 10.744-5.964 16h-512.254zM117.078 456c-1.424-5.274-2.71-10.606-3.824-16h541.492c-1.114 5.394-2.4 10.726-3.822 16h-533.846zM107.556 384c0-2.676 0.048-5.342 0.124-8h552.638c0.076 2.658 0.124 5.324 0.124 8s-0.046 5.342-0.124 8h-552.638c-0.076-2.658-0.124-5.324-0.124-8zM193.48 184h381.040c5.388 5.12 10.56 10.464 15.524 16h-412.086c4.96-5.536 10.132-10.88 15.522-16zM464.912 120c14.028 4.282 27.58 9.648 40.562 16h-242.948c12.982-6.352 26.534-11.718 40.562-16h161.824zM533.82 152c7.702 4.968 15.134 10.314 22.286 16h-344.212c7.15-5.686 14.584-11.032 22.286-16h299.64zM603.334 216c3.994 5.192 7.806 10.526 11.43 16h-461.53c3.624-5.474 7.436-10.808 11.43-16h438.67zM624.596 248c2.972 5.232 5.788 10.564 8.42 16h-498.034c2.632-5.436 5.448-10.768 8.42-16h481.194zM640.124 280c2.144 5.256 4.14 10.588 5.962 16h-524.176c1.822-5.412 3.82-10.744 5.962-16h512.252zM650.92 312c1.424 5.274 2.71 10.606 3.824 16h-541.492c1.114-5.394 2.4-10.726 3.824-16h533.844zM657.542 344c0.77 5.286 1.384 10.622 1.85 16h-550.784c0.464-5.378 1.080-10.714 1.848-16h547.086zM659.39 408c-0.464 5.378-1.080 10.714-1.85 16h-547.084c-0.768-5.286-1.384-10.622-1.848-16h550.782z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search",
						"magnifier",
						"lookup",
						"find",
						"dualtone"
					],
					"defaultCode": 60215,
					"grid": 16
				},
				{
					"id": 2383,
					"paths": [
						"M320 0c176.732 0 320.002 143.27 320.002 320 0 65.24-19.542 125.908-53.064 176.502 0.010-0.014 0.020-0.030 0.030-0.044l70.36 70.36c34.872-19.222 67.694-22.816 84.442-6.070l271.528 271.528c24.994 24.996 4.732 85.782-45.254 135.77-49.988 49.984-110.772 70.246-135.764 45.254l-271.53-271.534c-16.75-16.746-13.152-49.566 6.066-84.442l-70.356-70.356c0.042-0.032 0.086-0.058 0.126-0.090-50.612 33.56-111.308 53.122-176.586 53.122-176.73 0-320-143.27-320-320s143.27-320 320-320zM138.98 501.018c48.352 48.354 112.642 74.982 181.020 74.982 68.38 0 132.668-26.628 181.022-74.982 48.352-48.352 74.978-112.64 74.978-181.018s-26.626-132.666-74.978-181.020c-48.354-48.354-112.642-74.98-181.022-74.98-68.378 0-132.668 26.628-181.020 74.98-48.352 48.354-74.98 112.64-74.98 181.020s26.628 132.666 74.98 181.018zM512 320c0 28.794-6.35 56.102-17.708 80.618-14.522-133.984-120.924-240.386-254.908-254.91 24.514-11.36 51.824-17.708 80.616-17.708 106.042 0 192 85.958 192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search",
						"magnifier",
						"magnifying-glass",
						"inspect",
						"find"
					],
					"defaultCode": 60218,
					"grid": 16
				},
				{
					"id": 2384,
					"paths": [
						"M881.396 943.872l-254.424-373.772c-6.672-9.828-20.468-12.866-30.65-6.758l-32.138 19.336c-10.174 6.1-13.984 19.69-8.458 30.222l210.562 400.128c5.526 10.504 18.354 14.112 28.542 7.98l80.202-48.186c10.184-6.11 13.034-19.12 6.364-28.95zM592.644 532.122c96.208-61.292 100.376-221.064 9.494-363.75-77.28-121.306-194.778-185.5-287.376-164.402-21.294 4.172-48.494 15.522-75.86 32.95-27.366 17.442-49.208 37.286-61.958 54.864-58.252 75.008-49.71 208.604 27.556 329.876 90.9 142.692 237.454 206.46 333.688 145.16l54.456-34.698zM557.954 477.662c-63.492 40.43-175.456-16.974-244.506-125.408-69.072-108.392-73.782-234.126-10.28-274.586 63.444-40.434 175.438 17 244.486 125.416 69.060 108.378 73.754 234.132 10.3 274.578z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search",
						"magnifier",
						"magnifying-glass",
						"inspect",
						"find"
					],
					"defaultCode": 60219,
					"grid": 16
				},
				{
					"id": 1181,
					"width": 950.8559875488281,
					"paths": [
						"M658.286 475.429q0-105.714-75.143-180.857t-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143 180.857-75.143 75.143-180.857zM950.857 950.857q0 29.714-21.714 51.429t-51.429 21.714q-30.857 0-51.429-21.714l-196-195.429q-102.286 70.857-228 70.857-81.714 0-156.286-31.714t-128.571-85.714-85.714-128.571-31.714-156.286 31.714-156.286 85.714-128.571 128.571-85.714 156.286-31.714 156.286 31.714 128.571 85.714 85.714 128.571 31.714 156.286q0 125.714-70.857 228l196 196q21.143 21.143 21.143 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search"
					],
					"defaultCode": 61442,
					"grid": 14
				},
				{
					"id": 771,
					"width": 1024,
					"paths": [
						"M352 64c-158.816 0-288 129.184-288 288s129.184 288 288 288c158.816 0 288-129.184 288-288s-129.184-288-288-288zM352 608c-141.376 0-256-114.624-256-256s114.624-256 256-256 256 114.624 256 256-114.624 256-256 256zM681.376 598.624l-9.376 9.376-41.408-41.408c55.52-72 84.224-165.728 69.632-266.624-21.6-149.344-140.512-271.136-289.472-295.2-240.256-38.848-444.832 165.728-405.984 405.984 24.064 148.96 145.856 267.872 295.2 289.472 100.896 14.592 194.656-14.112 266.624-69.632l41.408 41.408-9.376 9.376c-12.48 12.512-12.48 32.768 0 45.248l233.376 233.376c35.36 35.36 92.64 35.36 128 0v0c35.36-35.36 35.36-92.64 0-128l-233.376-233.376c-12.48-12.48-32.768-12.48-45.248 0zM32 352c0-176.448 143.552-320 320-320s320 143.552 320 320-143.552 320-320 320c-176.448 0-320-143.552-320-320zM591.072 609.824c6.496-6.016 12.736-12.256 18.752-18.752l39.552 39.552-18.752 18.752-39.552-39.552zM620.64 703.36l83.136-82.336 233.6 233.6c22.848 22.848 22.848 59.904 0 82.752v0c-22.848 22.848-59.904 22.848-82.752 0l-233.984-234.016z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search",
						"find",
						"magnify",
						"zoom",
						"inspect",
						"look"
					],
					"grid": 32
				},
				{
					"id": 772,
					"width": 1024,
					"paths": [
						"M608 352c0 141.376-114.624 256-256 256s-256-114.624-256-256 114.624-256 256-256 256 114.624 256 256zM960 960c-35.36 35.36-92.64 35.36-128 0l-233.376-233.376c-12.512-12.512-12.512-32.768 0-45.248l9.376-9.376-41.408-41.408c-72 55.52-165.76 84.224-266.624 69.632-149.344-21.6-271.136-140.512-295.2-289.472-38.816-240.224 165.76-444.8 405.984-405.984 148.96 24.064 267.872 145.856 289.472 295.2 14.592 100.896-14.112 194.656-69.632 266.624l41.408 41.408 9.376-9.376c12.512-12.512 32.768-12.512 45.248 0l233.376 233.376c35.36 35.36 35.36 92.64 0 128zM640 352c0-158.816-129.184-288-288-288s-288 129.184-288 288 129.184 288 288 288c158.816 0 288-129.184 288-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"search",
						"find",
						"magnify",
						"zoom",
						"inspect",
						"look"
					],
					"grid": 32
				},
				{
					"id": 3275,
					"paths": [
						"M495.964 1024c-49.36 0-91.116-14.406-124.104-42.82-33.224-28.614-50.068-62.038-50.068-99.344 0-18.128 6.6-33.756 19.622-46.458 13.232-12.914 29.782-19.744 47.85-19.744 18.002 0 34.194 6.41 46.826 18.542 12.472 11.972 18.796 27.824 18.796 47.104 0 11.318-1.85 23.818-5.494 37.146-3.616 13.178-4.376 19.938-4.376 23.292 0 3.682 0.924 8.076 7.774 12.756 12.76 8.824 28.066 13.084 46.876 13.084 22.576 0 42.718-7.858 61.574-24.022 18.578-15.942 27.612-32.318 27.612-50.056 0-19.736-5.27-36.826-16.12-52.242-18.336-25.758-52.878-55.954-102.612-89.668-79.858-53.454-133.070-99.766-162.58-141.52-22.89-32.684-34.476-67.89-34.476-104.704 0-37.062 12.142-73.948 36.092-109.63 20.508-30.554 50.8-58.12 90.228-82.138-21.096-22.7-36.896-44.064-47.094-63.688-12.872-24.76-19.398-50.372-19.398-76.122 0-47.814 18.91-89.16 56.206-122.89 37.32-33.76 83.86-50.878 138.322-50.878 50.086 0 92.206 14.082 125.182 41.852 33.328 28.082 50.222 60.898 50.222 97.54 0 18.656-6.986 35.364-20.766 49.66l-0.276 0.282c-7.976 7.924-22.618 17.37-47.046 17.37-19.148 0-35.934-6.272-48.54-18.136-12.558-11.794-18.93-25.918-18.93-41.966 0-6.934 1.702-17.416 5.352-32.98 1.778-7.364 2.668-14.142 2.668-20.25 0-10.338-3.726-18.272-11.724-24.966-8.282-6.93-20.108-10.302-36.142-10.302-24.868 0-45.282 7.562-62.41 23.118-17.19 15.606-25.544 34.088-25.544 56.508 0 20.156 4.568 36.762 13.58 49.362 17.112 23.938 46.796 49.79 88.22 76.836 84.17 54.588 142.902 104.672 174.518 148.826 23.35 33.12 35.152 68.34 35.152 104.792 0 36.598-11.882 73.496-35.318 109.676-20.208 31.18-50.722 59.276-90.884 83.71 22.178 23.466 37.812 44.042 47.554 62.538 12.082 22.97 18.208 48.048 18.208 74.542 0 49.664-18.926 91.862-56.244 125.422-37.34 33.554-83.866 50.566-138.288 50.566zM446.416 356.346c-48.222 28.952-71.712 62.19-71.712 101.314 0 22.756 6.498 43.13 19.86 62.278 19.936 27.926 59.27 62.054 116.804 101.288 24.358 16.586 46.36 32.712 65.592 48.060 49.060-29.504 72.956-62.366 72.956-100.178 0-20.598-8.142-42.774-24.204-65.916-16.808-24.196-52.85-55.796-107.128-93.914-28.328-19.562-52.558-37.334-72.168-52.932z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"section",
						"wysiwyg"
					],
					"defaultCode": 61110,
					"grid": 16
				},
				{
					"id": 773,
					"width": 1024,
					"paths": [
						"M686.752 219.456v0c0 0-0.032 0-0.032 0-51.264-17.024-109.184-27.456-174.72-27.456s-123.456 10.432-174.72 27.424c0 0 0 0 0 0v0c-193.792 64.32-290.208 225.056-323.456 293.216-9.6 19.712-8.832 42.688 2.592 61.376 45.12 73.792 188.48 257.984 495.584 257.984s450.464-184.192 495.584-257.984c11.424-18.72 12.224-41.664 2.592-61.376-33.248-68.16-129.664-228.896-323.424-293.184zM352.384 248.256c47.040-15.168 100.096-24.256 159.616-24.256 57.952 0 113.504 8.992 159.488 24.128 61.408 48.992 96.512 121.536 96.512 199.872 0 141.152-114.848 256-256 256s-256-114.848-256-256c0-78.272 35.072-150.752 96.384-199.744zM512 800c-293.792 0-427.488-174.464-468.48-242.56-5.504-9.152-5.984-20.32-1.28-29.92 26.624-54.432 99.072-176.8 237.28-248.416-35.744 48.928-56.8 109.216-55.456 174.784 3.104 151.488 128.8 278.080 280.288 281.984 162.56 4.224 295.648-126.272 295.648-287.872 0-63.936-21.28-122.624-56.608-170.368 140.352 71.264 212.352 194.752 238.688 249.856 4.576 9.536 4.064 20.544-1.408 29.632-40.832 67.968-174.464 242.88-468.672 242.88zM357.088 409.888c-3.040 12.256-5.088 24.896-5.088 38.112 0 88.352 71.648 160 160 160s160-71.648 160-160-71.648-160-160-160c-29.312 0-56.416 8.288-79.904 22.176-11.744-13.472-28.832-22.176-48.096-22.176-35.36 0-64 28.64-64 64 0 25.696 15.232 47.712 37.088 57.888zM448 352c0-4.608-0.544-9.088-1.472-13.408 19.232-11.552 41.472-18.592 65.472-18.592 70.592 0 128 57.408 128 128s-57.408 128-128 128-128-57.408-128-128c0-11.264 1.632-22.112 4.48-32.448 33.216-2.336 59.52-29.76 59.52-63.552zM384 320c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"see",
						"view",
						"watch",
						"observe"
					],
					"grid": 32
				},
				{
					"id": 774,
					"width": 1024,
					"paths": [
						"M352 352c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM384 448c0 70.592 57.408 128 128 128s128-57.408 128-128-57.408-128-128-128c-24 0-46.24 7.040-65.472 18.592 0.928 4.32 1.472 8.8 1.472 13.408 0 33.792-26.304 61.216-59.52 63.552-2.848 10.336-4.48 21.184-4.48 32.448zM1010.176 512.64c-33.248-68.16-129.632-228.896-323.424-293.184v0c0 0 0 0 0 0 68.736 52.608 113.248 135.264 113.248 228.544 0 159.072-128.928 288-288 288s-288-128.928-288-288c0-93.28 44.512-175.936 113.28-228.576 0 0 0 0 0 0v0c-193.792 64.32-290.208 225.056-323.456 293.216-9.6 19.712-8.832 42.688 2.592 61.376 45.12 73.792 188.48 257.984 495.584 257.984s450.464-184.192 495.584-257.984c11.424-18.688 12.192-41.664 2.592-61.376zM511.808 192c0.064 0 0.128 0 0.192 0s0.128 0 0.192 0c141.056 0.096 255.808 114.912 255.808 256 0 141.152-114.848 256-256 256s-256-114.848-256-256c0-141.088 114.752-255.904 255.808-256zM320 352c0 25.696 15.232 47.712 37.088 57.888-3.040 12.256-5.088 24.896-5.088 38.112 0 88.352 71.648 160 160 160s160-71.648 160-160-71.648-160-160-160c-29.312 0-56.416 8.288-79.904 22.176-11.744-13.472-28.832-22.176-48.096-22.176-35.36 0-64 28.64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"see",
						"view",
						"watch",
						"observe"
					],
					"grid": 32
				},
				{
					"id": 1118,
					"width": 1024,
					"paths": [
						"M512 160c-333.856 0-512 294.72-512 352s178.144 352 512 352 512-294.72 512-352-178.144-352-512-352zM538.752 225.408c128.64 13.44 229.248 122.464 229.248 254.592 0 141.152-114.848 256-256 256s-256-114.848-256-256c0-132.128 100.608-241.152 229.248-254.592 8.896-0.48 17.536-1.408 26.752-1.408s17.856 0.928 26.752 1.408zM512 800c-290.24 0-434.304-248.256-447.392-288 9.856-29.92 94.016-177.952 258.816-249.312-60.832 52.8-99.424 130.464-99.424 217.312 0 159.072 128.928 288 288 288s288-128.928 288-288c0-86.848-38.592-164.512-99.392-217.312 164.8 71.392 248.96 219.392 258.816 249.312-13.12 39.744-157.184 288-447.424 288zM352 480c0 88.352 71.648 160 160 160s160-71.648 160-160-71.648-160-160-160-160 71.648-160 160zM640 480c0 70.592-57.408 128-128 128s-128-57.408-128-128c0-70.592 57.408-128 128-128s128 57.408 128 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"see",
						"view",
						"watch",
						"observe"
					],
					"grid": 32
				},
				{
					"id": 2879,
					"paths": [
						"M3.060 696h188.94v-16h-191.638c0.458 5.468 1.352 10.822 2.698 16z",
						"M18.18 728h173.82v-16h-183.188c2.612 5.648 5.754 11.002 9.368 16z",
						"M57.788 760h134.212v-16h-159.29c7.44 6.55 15.884 11.976 25.078 16z",
						"M838.214 8h-780.424c-9.192 4.022-17.638 9.448-25.078 16h830.578c-7.44-6.552-15.882-11.978-25.076-16z",
						"M877.822 40h-859.644c-3.614 4.998-6.754 10.352-9.366 16h878.376c-2.612-5.648-5.754-11.002-9.366-16z",
						"M892.94 72h-889.88c-1.346 5.178-2.242 10.53-2.698 16h895.278c-0.458-5.47-1.356-10.822-2.7-16z",
						"M896 408v-16h-32.002l21.334 16z",
						"M896 360h-74.668l21.334 16h53.334z",
						"M967.634 613.726l-647.634-485.726v809.542l202.132-190.61 138.262 277.068 171.73-85.866-138.256-277.068z",
						"M120 120h656v208l3.998 1 20 15h96.002v-16h-8v-208h8v-16h-896v16h8v528h-8v16h192v-16h-72v-528zM104 648h-16v-528h16v528zM72 648h-16v-528h16v528zM792 328v-208h16v208h-16zM824 120h16v208h-16v-208zM872 328h-16v-208h16v208zM24 120h16v528h-16v-528z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"select",
						"pointer",
						"dualtone"
					],
					"defaultCode": 60714,
					"grid": 16
				},
				{
					"id": 2880,
					"paths": [
						"M832.124 938.132v0l-138.256-277.066 273.764-47.34-647.632-485.726v809.542l202.132-190.61 138.262 277.068z",
						"M64 672v-576c0-17.346 14.654-32 32-32h704c17.346 0 32 14.654 32 32v256l64 48v-304c0-52.8-43.2-96-96-96h-704c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h96v-64h-96c-17.346 0-32-14.654-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"select",
						"pointer"
					],
					"defaultCode": 60715,
					"grid": 16
				},
				{
					"id": 177,
					"paths": [
						"M281.6 768h-204.8c-42.347 0-76.8-34.451-76.8-76.8v-614.4c0-42.347 34.453-76.8 76.8-76.8h716.8c42.349 0 76.8 34.453 76.8 76.8v358.4c0 14.138-11.461 25.6-25.6 25.6s-25.6-11.462-25.6-25.6v-358.4c0-14.115-11.485-25.6-25.6-25.6h-716.8c-14.115 0-25.6 11.485-25.6 25.6v614.4c0 14.115 11.485 25.6 25.6 25.6h204.8c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M665.608 1024.006c-10.16 0-19.773-6.090-23.776-16.099l-86.882-217.203-151.685 173.354c-7.022 8.027-18.285 10.859-28.269 7.106-9.986-3.75-16.597-13.298-16.597-23.963v-768c0-10.133 5.976-19.312 15.243-23.411 9.266-4.101 20.078-2.347 27.576 4.469l563.2 512c7.827 7.114 10.472 18.309 6.658 28.173s-13.301 16.37-23.877 16.37h-218.187l88.357 220.893c5.251 13.128-1.134 28.027-14.261 33.277l-128 51.2c-3.118 1.246-6.338 1.837-9.501 1.837zM563.198 716.8c1.432 0 2.874 0.12 4.31 0.366 8.781 1.501 16.152 7.456 19.459 15.726l92.893 232.232 80.462-32.184-92.893-232.232c-3.155-7.888-2.192-16.826 2.57-23.859s12.704-11.25 21.2-11.25h189.782l-471.382-428.53v641.997l134.334-153.525c4.904-5.606 11.954-8.742 19.264-8.742z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"select",
						"cursor"
					],
					"defaultCode": 59474,
					"grid": 20
				},
				{
					"id": 775,
					"width": 1024,
					"paths": [
						"M800 64h-576c-53.024 0-96 42.976-96 96v704c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM864 864c0 35.296-28.704 64-64 64h-576c-35.296 0-64-28.704-64-64v-704c0-35.296 28.704-64 64-64h576c35.296 0 64 28.704 64 64v704zM320 160c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM320 320c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64zM320 416c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM320 576c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64zM320 672c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM320 832c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64c0 35.296-28.704 64-64 64zM352 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM736 208c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM736 272c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM736 464c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM736 528c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM736 720c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16zM736 784c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16s7.168-16 16-16h224c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"select",
						"study",
						"test",
						"answer",
						"choose"
					],
					"grid": 32
				},
				{
					"id": 776,
					"width": 1024,
					"paths": [
						"M384 768c0 35.296-28.704 64-64 64s-64-28.704-64-64c0-35.296 28.704-64 64-64s64 28.704 64 64zM320 192c-35.296 0-64 28.704-64 64s28.704 64 64 64 64-28.704 64-64c0-35.296-28.704-64-64-64zM384 512c0 35.296-28.704 64-64 64s-64-28.704-64-64c0-35.296 28.704-64 64-64s64 28.704 64 64zM352 512c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM896 160v704c0 53.024-42.976 96-96 96h-576c-53.024 0-96-42.976-96-96v-704c0-53.024 42.976-96 96-96h576c53.024 0 96 42.976 96 96zM416 768c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96zM416 512c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96zM416 256c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96zM736 784c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM736 720c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM736 528c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM736 464c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM736 272c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM736 208c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"select",
						"study",
						"test",
						"answer",
						"choose"
					],
					"grid": 32
				},
				{
					"id": 1119,
					"width": 1024,
					"paths": [
						"M96 320h-64v-96h64v96zM96 384h-64v96h64v-96zM96 544h-64v96h64v-96zM224 992h96v-64h-96v64zM96 704h-64v96h64v-96zM480 32h-96v64h96v-64zM800 32h-96v64h96v-64zM960 32h-96v64h64v64h64v-96c0-17.664-14.336-32-32-32zM640 32h-96v64h96v-64zM320 32h-96v64h96v-64zM928 480h64v-96h-64v96zM928 320h64v-96h-64v96zM96 96h64v-64h-96c-17.664 0-32 14.336-32 32v96h64v-64zM928 928h-64v64h96c17.664 0 32-14.336 32-32v-96h-64v64zM96 864h-64v96c0 17.664 14.336 32 32 32h96v-64h-64v-64zM704 992h96v-64h-96v64zM928 640h64v-96h-64v96zM544 992h96v-64h-96v64zM384 992h96v-64h-96v64zM928 800h64v-96h-64v96zM128 128h768v768h-768v-768zM160 864h704v-704h-704v704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"select"
					],
					"grid": 32
				},
				{
					"id": 777,
					"width": 1024,
					"paths": [
						"M448 880c0-8.832 7.168-16 16-16h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16zM448 608c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM544 608c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM640 608c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM640 512c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM544 512c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM448 512c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM448 416c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM544 416c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM640 416c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM592 128h-96c-8.832 0-16 7.168-16 16s7.168 16 16 16h96c8.832 0 16-7.168 16-16s-7.168-16-16-16zM592 192h-96c-8.832 0-16 7.168-16 16s7.168 16 16 16h96c8.832 0 16-7.168 16-16s-7.168-16-16-16zM896 768v128c0 53.024-42.976 96-96 96h-512c-53.024 0-96-42.976-96-96v-128l54.016-459.232c5.696-48.32 46.656-84.768 95.36-84.768h74.624v-160c0-17.664 14.336-32 32-32h192c17.664 0 32 14.336 32 32v160h74.624c48.672 0 89.664 36.448 95.328 84.768l54.048 459.232zM448 288h192v-224h-192v224zM224.224 768h639.552l-53.568-455.488c-3.808-32.224-31.136-56.512-63.584-56.512h-74.624v32h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-288c-8.832 0-16-7.168-16-16s7.168-16 16-16h16v-32h-74.624c-32.448 0-59.776 24.288-63.584 56.512l-53.568 455.488zM864 800h-640v96c0 35.296 28.704 64 64 64h512c35.296 0 64-28.704 64-64v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sell",
						"buy",
						"return"
					],
					"grid": 32
				},
				{
					"id": 778,
					"width": 1024,
					"paths": [
						"M892.224 736l-50.24-427.232c-5.696-48.32-46.656-84.768-95.36-84.768h-42.624v64h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-352c-8.832 0-16-7.168-16-16s7.168-16 16-16h16v-64h-42.624c-48.704 0-89.664 36.448-95.36 84.768l-50.24 427.232h696.448zM640 416c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM640 512c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM640 608c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM544 416c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM544 512c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM544 608c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM448 416c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM448 512c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM448 608c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM640 32h-192c-17.664 0-32 14.336-32 32v224h256v-224c0-17.664-14.336-32-32-32zM592 224h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM592 160h-96c-8.832 0-16-7.168-16-16s7.168-16 16-16h96c8.832 0 16 7.168 16 16s-7.168 16-16 16zM192 896c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-128h-704v128zM464 864h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sell",
						"buy",
						"return"
					],
					"grid": 32
				},
				{
					"id": 1663,
					"width": 1170.2850952148438,
					"paths": [
						"M857.143 783.429v-418.857q0-12-8.571-20.571t-20-8.571h-53.143q-11.429 0-20 8.571t-8.571 20.571v418.857q0 11.429 8.571 20t20 8.571h53.143q11.429 0 20-8.571t8.571-20zM694.857 783.429v-303.429q0-11.429-8.571-20t-20-8.571h-57.714q-11.429 0-20 8.571t-8.571 20v303.429q0 11.429 8.571 20t20 8.571h57.714q11.429 0 20-8.571t8.571-20zM528 783.429v-245.143q0-11.429-8.571-20t-20-8.571h-57.714q-11.429 0-20 8.571t-8.571 20v245.143q0 11.429 8.571 20t20 8.571h57.714q11.429 0 20-8.571t8.571-20zM361.143 783.429v-206.857q0-11.429-8.571-20t-20-8.571h-57.714q-11.429 0-20 8.571t-8.571 20v206.857q0 11.429 8.571 20t20 8.571h57.714q11.429 0 20-8.571t8.571-20zM1170.286 700q0 94.857-67.429 162.286t-162.286 67.429h-710.857q-94.857 0-162.286-67.429t-67.429-162.286q0-66.286 36-122.571t96-84.857q-5.714-19.429-5.714-41.714 0-64.571 46-110.571t110.571-46q58.286 0 102.857 38.286 25.714-104.571 110.857-171.429t193.143-66.857q85.143 0 157.143 42t114 114 42 157.143q0 37.714-8 69.714 77.143 18.857 126.286 81.429t49.143 141.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sellsy"
					],
					"defaultCode": 61971,
					"grid": 14
				},
				{
					"id": 779,
					"width": 1024,
					"paths": [
						"M805.824 831.392l162.272-731.456c5.824-26.208-21.28-47.488-45.376-35.648l-801.056 394.144c-71.232 35.040-71.552 136.512-0.544 172l166.88 83.456v207.52c0 28.512 34.464 42.784 54.624 22.624l140.512-140.576 186.016 92.992c55.872 27.968 123.136-4.064 136.672-65.056zM683.52 867.872l-274.016-137.024 520.992-607.84-155.872 701.504c-9.056 40.64-53.888 61.984-91.104 43.36zM371.872 725.6l-51.872 142.016v-156.864l394.336-384.704-342.464 399.552zM135.84 487.168l741.12-364.48-576 561.92-165.504-82.752c-47.36-23.68-47.136-91.328 0.384-114.688zM343.008 898.368l49.984-139.968 60 29.984-109.984 109.984z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"send",
						"fly",
						"fold",
						"throw"
					],
					"grid": 32
				},
				{
					"id": 780,
					"width": 1024,
					"paths": [
						"M344.768 755.808l-52 182.112c-2.848-4.672-4.768-10.176-4.768-16.512v-178.24l418.88-409.376-362.112 422.016zM320.544 953.152c7.776-0.064 15.648-2.688 22.080-9.12l116.416-116.448-88.704-44.352-49.792 169.92zM922.72 64.288l-801.056 394.144c-71.232 35.040-71.552 136.512-0.544 172l156.48 78.24 601.248-587.392c6.528-6.368 16.512-7.488 24.288-2.752 10.432 6.4 12.672 20.608 4.704 29.92l-521.6 607.232 282.88 140.8c55.872 27.936 123.136-4.096 136.64-65.088l162.272-731.456c5.888-26.208-21.216-47.488-45.312-35.648z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"send",
						"fly",
						"fold",
						"throw"
					],
					"grid": 32
				},
				{
					"id": 1120,
					"width": 1024,
					"paths": [
						"M992 256h-210.752l-224-224c-24.928-24.96-65.568-24.96-90.496 0l-224 224h-210.752c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM930.624 320l-258.624 224v-224h258.624zM512 77.248l210.752 210.752h-82.752v283.872l-117.44 101.792c-5.984 5.184-15.008 5.184-20.992 0l-117.568-102.624v-283.040h-82.752l210.752-210.752zM352 320v223.104l-255.616-223.104h255.616zM64 341.056v-6.88l322.048 281.152-322.048 322.048v-596.32zM86.624 960l323.584-323.584 70.304 61.376c8.992 7.84 20.256 11.744 31.552 11.744 11.232 0 22.496-3.904 31.456-11.648l70.56-61.152 323.296 323.264h-850.752zM960 937.376l-321.664-321.696 321.664-278.752v600.448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"send",
						"forward",
						"reply",
						"mail"
					],
					"grid": 32
				},
				{
					"id": 2215,
					"paths": [
						"M832 0h-640l-192 256h1024l-192-256z",
						"M0 320v192h1024v-192h-1024zM960 448h-64v-64h64v64z",
						"M0 576v192h1024v-192h-1024zM960 704h-64v-64h64v64z",
						"M0 832v192h1024v-192h-1024zM960 960h-64v-64h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"server",
						"drives"
					],
					"defaultCode": 60050,
					"grid": 16
				},
				{
					"id": 1691,
					"width": 1024,
					"paths": [
						"M73.143 804.571h585.143v-73.143h-585.143v73.143zM73.143 512h585.143v-73.143h-585.143v73.143zM969.143 768q0-22.857-16-38.857t-38.857-16-38.857 16-16 38.857 16 38.857 38.857 16 38.857-16 16-38.857zM73.143 219.429h585.143v-73.143h-585.143v73.143zM969.143 475.429q0-22.857-16-38.857t-38.857-16-38.857 16-16 38.857 16 38.857 38.857 16 38.857-16 16-38.857zM969.143 182.857q0-22.857-16-38.857t-38.857-16-38.857 16-16 38.857 16 38.857 38.857 16 38.857-16 16-38.857zM1024 658.286v219.429h-1024v-219.429h1024zM1024 365.714v219.429h-1024v-219.429h1024zM1024 73.143v219.429h-1024v-219.429h1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"server"
					],
					"defaultCode": 62003,
					"grid": 14
				},
				{
					"id": 1121,
					"width": 1024,
					"paths": [
						"M336 448c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM336 576c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM768 496c0-44.192-35.808-80-80-80s-80 35.808-80 80c0 44.192 35.808 80 80 80s80-35.808 80-80zM640 496c0-26.464 21.536-48 48-48s48 21.536 48 48-21.536 48-48 48-48-21.536-48-48zM528 608c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM528 736c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM576 336c0-44.192-35.808-80-80-80s-80 35.808-80 80c0 44.192 35.808 80 80 80s80-35.808 80-80zM448 336c0-26.464 21.536-48 48-48s48 21.536 48 48-21.536 48-48 48-48-21.536-48-48zM640 384h-32v-96h32v96zM384 640h32v96h-32v-96zM384 416h-96v-32h96v32zM640 608h96v32h-96v-32zM960 384h-86.24c-38.496-108.48-125.28-195.264-233.76-233.76v-86.24c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v86.24c-108.48 38.496-195.264 125.28-233.76 233.76h-86.24c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h86.24c38.496 108.48 125.28 195.264 233.76 233.76v86.24c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-86.24c108.48-38.496 195.264-125.28 233.76-233.76h86.24c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32zM928 576h-70.080c3.808-20.768 6.080-42.112 6.080-64s-2.272-43.232-6.080-64h70.080v128zM448 928v-70.080c20.768 3.808 42.112 6.080 64 6.080s43.232-2.272 64-6.080v70.080h-128zM512 832c-176.448 0-320-143.552-320-320s143.552-320 320-320 320 143.552 320 320-143.552 320-320 320zM96 448h70.080c-3.808 20.768-6.080 42.112-6.080 64s2.272 43.232 6.080 64h-70.080v-128zM576 96v70.080c-20.768-3.808-42.112-6.080-64-6.080s-43.232 2.272-64 6.080v-70.080h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"set",
						"eat",
						"dine",
						"sit"
					],
					"grid": 32
				},
				{
					"id": 3307,
					"paths": [
						"M704 128l64-64-64-64h-384l-64 64 64 64zM768 96l-64 64v256l64 64 64-64v-256zM320 416.002v-256.002l-64-64-64 64v256.002l64 64zM704 608v256l64 64 64-64v-256l-64-64zM320 864v-256l-64-64-64 64v256l64 64zM320 896l-64 64 64 64h384l64-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-0",
						"number",
						"zero"
					],
					"defaultCode": 61142,
					"grid": 16
				},
				{
					"id": 3308,
					"paths": [
						"M768 96l-64 64v256l64 64 64-64v-256zM704 608v256l64 64 64-64v-256l-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-1",
						"number",
						"one"
					],
					"defaultCode": 61143,
					"grid": 16
				},
				{
					"id": 3309,
					"paths": [
						"M256 64l64-64h384l64 64-64 64h-384zM768 480l-64-64v-256l64-64 64 64v256zM256 928l-64-64v-256l64-64 64 64v256zM256 512l64-64h384l64 64-64 64h-384zM256 960l64-64h384l64 64-64 64h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-2",
						"number",
						"two"
					],
					"defaultCode": 61144,
					"grid": 16
				},
				{
					"id": 3310,
					"paths": [
						"M256 64l64-64h384l64 64-64 64h-384zM768 480l-64-64v-256l64-64 64 64v256zM768 928l-64-64v-256l64-64 64 64v256zM256 512l64-64h384l64 64-64 64h-384zM256 960l64-64h384l64 64-64 64h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-3",
						"number",
						"three"
					],
					"defaultCode": 61145,
					"grid": 16
				},
				{
					"id": 3311,
					"paths": [
						"M768 480l-64-64v-256l64-64 64 64v256zM256 480.002l-64-64v-256.002l64-64 64 64v256.002zM768 928l-64-64v-256l64-64 64 64v256zM256 512l64-64h384l64 64-64 64h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-4",
						"number",
						"four"
					],
					"defaultCode": 61146,
					"grid": 16
				},
				{
					"id": 3312,
					"paths": [
						"M256 64l64-64h384l64 64-64 64h-384zM256 480.002l-64-64v-256.002l64-64 64 64v256.002zM768 928l-64-64v-256l64-64 64 64v256zM256 512l64-64h384l64 64-64 64h-384zM256 960l64-64h384l64 64-64 64h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-5",
						"number",
						"five"
					],
					"defaultCode": 61147,
					"grid": 16
				},
				{
					"id": 3313,
					"paths": [
						"M256 64l64-64h384l64 64-64 64h-384zM256 480.002l-64-64v-256.002l64-64 64 64v256.002zM768 928l-64-64v-256l64-64 64 64v256zM256 928l-64-64v-256l64-64 64 64v256zM256 512l64-64h384l64 64-64 64h-384zM256 960l64-64h384l64 64-64 64h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-6",
						"number",
						"six"
					],
					"defaultCode": 61148,
					"grid": 16
				},
				{
					"id": 3314,
					"paths": [
						"M256 64l64-64h384l64 64-64 64h-384zM768 480l-64-64v-256l64-64 64 64v256zM768 928l-64-64v-256l64-64 64 64v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-7",
						"number"
					],
					"defaultCode": 61149,
					"grid": 16
				},
				{
					"id": 3315,
					"paths": [
						"M704 128l64-64-64-64h-384l-64 64 64 64zM768 96l-64 64v256l64 64 64-64v-256zM320 416.002v-256.002l-64-64-64 64v256.002l64 64zM704 608v256l64 64 64-64v-256l-64-64zM320 864v-256l-64-64-64 64v256l64 64zM256 512l64 64h384l64-64-64-64h-384zM320 896l-64 64 64 64h384l64-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-8",
						"number",
						"eight"
					],
					"defaultCode": 61150,
					"grid": 16
				},
				{
					"id": 3316,
					"paths": [
						"M256 64l64-64h384l64 64-64 64h-384zM768 480l-64-64v-256l64-64 64 64v256zM256 480.002l-64-64v-256.002l64-64 64 64v256.002zM768 928l-64-64v-256l64-64 64 64v256zM256 512l64-64h384l64 64-64 64h-384zM256 960l64-64h384l64 64-64 64h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"seven-segment-9",
						"number",
						"nine"
					],
					"defaultCode": 61151,
					"grid": 16
				},
				{
					"id": 781,
					"width": 1024,
					"paths": [
						"M928 768v-544c0-53.024-42.976-96-96-96h-640c-53.024 0-96 42.976-96 96v256c0 17.664 14.336 32 32 32v32c0 17.664 14.336 32 32 32h64v48c0 8.832 7.168 16 16 16s16-7.168 16-16v-48h64c17.664 0 32-14.336 32-32v-32c17.664 0 32-14.336 32-32h192v288h-480c-35.36 0-64 28.64-64 64v32c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-32c0-35.36-28.64-64-64-64zM320 544h-160v-32h160v32zM352 448v32h-224v-256c0-35.296 28.704-64 64-64h640c35.296 0 64 28.704 64 64v544h-288v-320h-256zM960 864h-896v-32c0-17.632 14.368-32 32-32h832c17.632 0 32 14.368 32 32v32zM528 224c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM528 352c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM752 384c44.192 0 80-35.808 80-80s-35.808-80-80-80c-44.192 0-80 35.808-80 80s35.808 80 80 80zM752 256c26.464 0 48 21.536 48 48s-21.536 48-48 48-48-21.536-48-48 21.536-48 48-48zM768 544h-32c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32zM768 672h-32v-32h32v32zM768 608h-32v-32h32v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sew",
						"stitch",
						"fix"
					],
					"grid": 32
				},
				{
					"id": 782,
					"width": 1024,
					"paths": [
						"M704 304c0-26.464 21.536-48 48-48s48 21.536 48 48-21.536 48-48 48-48-21.536-48-48zM736 608h32v-32h-32v32zM736 672h32v-32h-32v32zM528 352c26.464 0 48-21.536 48-48s-21.536-48-48-48-48 21.536-48 48 21.536 48 48 48zM928 768h-832c-35.36 0-64 28.64-64 64v32c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-32c0-35.36-28.64-64-64-64zM240 640c8.832 0 16-7.168 16-16v-48h64c17.664 0 32-14.336 32-32h-224c0 17.664 14.336 32 32 32h64v48c0 8.832 7.168 16 16 16zM96 480v-256c0-53.024 42.976-96 96-96h640c53.024 0 96 42.976 96 96v512h-352v-256h-192c0 17.664-14.336 32-32 32h-224c-17.664 0-32-14.336-32-32zM800 576c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-96zM672 304c0 44.192 35.808 80 80 80s80-35.808 80-80c0-44.192-35.808-80-80-80s-80 35.808-80 80zM448 304c0 44.192 35.808 80 80 80s80-35.808 80-80c0-44.192-35.808-80-80-80s-80 35.808-80 80z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sew",
						"stitch",
						"fix"
					],
					"grid": 32
				},
				{
					"id": 1122,
					"width": 1024,
					"paths": [
						"M992 384c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32h-32v-32c0-17.664-14.336-32-32-32h-832c-17.664 0-32 14.336-32 32v256c0 17.664 14.336 32 32 32h32v32c0 17.664 14.336 32 32 32h96v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64h96c17.664 0 32-14.336 32-32v-32h64c17.664 0 32 14.336 32 32v288h-480c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-192c0-17.664-14.336-32-32-32h-32v-320h32zM352 384h-160v-32h160v32zM480 320h-352v-192h768v608h-320v-320c0-52.928-43.072-96-96-96zM960 896h-896v-128h896v128zM928 320v-128h32v128h-32zM736 672c53.024 0 96-42.976 96-96s-42.976-96-96-96-96 42.976-96 96 42.976 96 96 96zM736 512c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64c0-35.296 28.704-64 64-64zM736 416c53.024 0 96-42.976 96-96s-42.976-96-96-96-96 42.976-96 96 42.976 96 96 96zM736 256c35.296 0 64 28.704 64 64s-28.704 64-64 64-64-28.704-64-64c0-35.296 28.704-64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sew",
						"stitch",
						"mend"
					],
					"grid": 32
				},
				{
					"id": 783,
					"width": 1024,
					"paths": [
						"M608 128c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM448 96c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM738.88 319.712l51.584 567.584c5.12 56.224-39.136 104.704-95.584 104.704h-365.76c-56.448 0-100.704-48.48-95.616-104.704l51.616-567.584c-41.536-1.888-72.832-43.008-56.864-87.36 8.864-24.704 33.504-40.352 59.744-40.352h2.752c15.904-103.328 108.736-160 221.248-160s205.344 56.672 221.248 160h2.752c26.24 0 50.88 15.648 59.744 40.352 15.968 44.352-15.328 85.472-56.864 87.36zM323.104 192h377.792c-14.848-81.44-86.272-118.016-157.248-126.176-1.024 16.768-14.624 30.176-31.648 30.176s-30.624-13.408-31.648-30.176c-70.976 8.16-142.4 44.736-157.248 126.176zM288 288h448c17.632 0 32-14.368 32-32s-14.368-32-32-32h-448c-17.632 0-32 14.368-32 32s14.368 32 32 32zM267.776 864h2.912c16.672 0 30.368-12.512 31.872-29.12l34.56-384c0.832-9.056-2.112-17.76-8.256-24.448-5.376-5.888-12.64-8.96-20.448-9.76l-40.64 447.328zM758.528 896h-5.184c-33.12 0-60.768-25.28-63.744-58.272l-34.592-384c-3.2-35.36 23.040-65.76 57.632-69.088l-5.856-64.64h-389.568l-5.856 64.64c34.592 3.328 60.832 33.728 57.664 69.088l-34.56 384c-3.008 32.992-30.656 58.272-63.776 58.272h-5.216c0 34.912 28 64 63.648 64h365.76c35.648 0 63.648-29.088 63.648-64zM715.552 416.672c-7.808 0.8-15.040 3.872-20.416 9.76-6.144 6.72-9.056 15.392-8.256 24.448l34.592 384c1.504 16.608 15.2 29.12 31.872 29.12h2.88l-40.672-447.328zM576 448v384c0 35.36-28.64 64-64 64s-64-28.64-64-64v-384c0-35.36 28.64-64 64-64s64 28.64 64 64zM544 448c0-17.632-14.368-32-32-32s-32 14.368-32 32v384c0 17.632 14.368 32 32 32s32-14.368 32-32v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shake",
						"cook",
						"flavor"
					],
					"grid": 32
				},
				{
					"id": 784,
					"width": 1024,
					"paths": [
						"M285.12 320h453.76c41.536-1.888 72.832-43.008 56.864-87.36-8.864-24.704-33.504-40.352-59.744-40.352h-2.752c-15.904-103.328-108.736-160.288-221.248-160.288s-205.344 56.96-221.248 160.288h-2.752c-26.24 0-50.88 15.648-59.744 40.352-15.968 44.352 15.328 85.472 56.864 87.36zM576 128c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM512 64c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM448 128c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM768.736 896c-33.024 0-60.576-25.248-63.424-58.144l-33.664-384.64c-3.232-37.216 26.080-69.216 63.456-69.216h0.16c3.264 0 6.432 0.416 9.568 0.896l-3.008-32.896h-459.648l-3.008 32.896c3.168-0.48 6.304-0.896 9.568-0.896h0.16c37.376 0 66.688 32 63.424 69.216l-33.664 384.64c-2.848 32.896-30.4 58.144-63.392 58.144h-0.16c-7.616 0-14.784-1.632-21.504-4.064-2.304 54.208 40.64 100.064 95.52 100.064h365.76c54.88 0 97.824-45.856 95.52-100.064-6.72 2.432-13.888 4.064-21.504 4.064h-0.16zM576 832c0 35.36-28.64 64-64 64s-64-28.64-64-64v-384c0-35.36 28.64-64 64-64s64 28.64 64 64v384zM735.264 416c4.544 0 8.736 1.088 12.64 2.784l39.84 438.208c-5.504 4.16-11.808 7.008-19.008 7.008-16.544 0-30.112-12.448-31.552-28.928l-33.664-384.64c-0.8-8.96 2.144-17.536 8.192-24.16 6.080-6.624 14.368-10.272 23.36-10.272h0.192zM544 448v384c0 17.632-14.368 32-32 32s-32-14.368-32-32v-384c0-17.632 14.368-32 32-32s32 14.368 32 32zM255.104 864c-7.072 0-13.344-2.848-18.816-7.008l39.84-438.208c3.872-1.696 8.096-2.784 12.608-2.784h0.16c8.992 0 17.28 3.648 23.36 10.272s8.992 15.2 8.192 24.16l-33.664 384.64c-1.408 16.48-14.976 28.928-31.68 28.928z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shake",
						"cook",
						"flavor"
					],
					"grid": 32
				},
				{
					"id": 3292,
					"paths": [
						"M640 448v128h192v320h-640v-320h192v-128h-320v576h896v-576z",
						"M448 320v512h128v-512h224l-288-288-288 288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share",
						"out",
						"external",
						"outside"
					],
					"defaultCode": 61127,
					"grid": 16
				},
				{
					"id": 1615,
					"width": 877.7140197753906,
					"paths": [
						"M694.857 585.143q76 0 129.429 53.429t53.429 129.429-53.429 129.429-129.429 53.429-129.429-53.429-53.429-129.429q0-6.857 1.143-19.429l-205.714-102.857q-52.571 49.143-124.571 49.143-76 0-129.429-53.429t-53.429-129.429 53.429-129.429 129.429-53.429q72 0 124.571 49.143l205.714-102.857q-1.143-12.571-1.143-19.429 0-76 53.429-129.429t129.429-53.429 129.429 53.429 53.429 129.429-53.429 129.429-129.429 53.429q-72 0-124.571-49.143l-205.714 102.857q1.143 12.571 1.143 19.429t-1.143 19.429l205.714 102.857q52.571-49.143 124.571-49.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share-alt"
					],
					"defaultCode": 61920,
					"grid": 14
				},
				{
					"id": 1616,
					"width": 877.7129821777344,
					"paths": [
						"M731.429 682.857q0-50.286-35.714-86.286t-86-36q-48 0-82.857 33.143l-137.714-68.571q1.143-9.143 1.143-13.143t-1.143-13.143l137.714-68.571q34.857 33.143 82.857 33.143 50.286 0 86-36t35.714-86.286-35.714-86-86-35.714-86.286 35.714-36 86q0 4 1.143 13.143l-137.714 68.571q-35.429-32.571-82.857-32.571-50.286 0-86 35.714t-35.714 86 35.714 86 86 35.714q47.429 0 82.857-32.571l137.714 68.571q-1.143 9.143-1.143 13.143 0 50.286 36 86t86.286 35.714 86-35.714 35.714-86zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share-alt-square"
					],
					"defaultCode": 61921,
					"grid": 14
				},
				{
					"id": 1478,
					"width": 877.7129821777344,
					"paths": [
						"M574.286 629.143l201.143-201.143q10.857-10.857 10.857-25.714t-10.857-25.714l-201.143-201.143q-17.143-17.714-39.429-8-22.857 9.714-22.857 33.714v91.429q-68 0-123.429 11.143t-92.857 29.143-65.143 45.143-43.714 54.571-25.429 62.286-12.286 63.714-2.857 63.143q0 103.429 95.429 230.857 5.714 6.857 14.286 6.857 4 0 7.429-1.714 12.571-5.143 10.857-18.857-25.143-202.286 35.429-270.286 26.286-29.714 74.286-43.143t128-13.429v91.429q0 24 22.857 33.714 6.857 2.857 13.714 2.857 14.857 0 25.714-10.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share-square"
					],
					"defaultCode": 61773,
					"grid": 14
				},
				{
					"id": 1244,
					"width": 950.8549499511719,
					"paths": [
						"M804.571 565.143v148q0 68-48.286 116.286t-116.286 48.286h-475.429q-68 0-116.286-48.286t-48.286-116.286v-475.429q0-68 48.286-116.286t116.286-48.286h145.714q7.429 0 12.857 5.429t5.429 12.857q0 15.429-14.857 18.286-44 14.857-76 34.286-5.714 2.286-9.143 2.286h-64q-37.714 0-64.571 26.857t-26.857 64.571v475.429q0 37.714 26.857 64.571t64.571 26.857h475.429q37.714 0 64.571-26.857t26.857-64.571v-122.286q0-10.857 10.286-16.571 16-7.429 30.857-21.143 9.143-9.143 20-4.571 12 5.143 12 16.571zM940 281.714l-219.429 219.429q-10.286 10.857-25.714 10.857-6.857 0-14.286-2.857-22.286-9.714-22.286-33.714v-109.714h-91.429q-184.571 0-250.286 74.857-68 78.286-42.286 270.286 1.714 13.143-11.429 19.429-4.571 1.143-6.857 1.143-9.143 0-14.857-7.429-5.714-8-12-17.714t-22.571-39.143-28.286-56.857-22-65.143-10-69.714q0-28 2-52t8-51.429 16-50.286 26.857-46.571 39.143-42.286 54-35.143 71.143-27.714 91.143-17.429 112.286-6.286h91.429v-109.714q0-24 22.286-33.714 7.429-2.857 14.286-2.857 14.857 0 25.714 10.857l219.429 219.429q10.857 10.857 10.857 25.714t-10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share-square-o"
					],
					"defaultCode": 61509,
					"grid": 14
				},
				{
					"id": 3293,
					"paths": [
						"M256 640c0 0 58.824-192 384-192v192l384-256-384-256v192c-256 0-384 159.672-384 320zM704 768h-576v-384h125.876c10.094-11.918 20.912-23.334 32.488-34.18 43.964-41.19 96.562-72.652 156.114-93.82h-442.478v640h832v-268.624l-128 85.334v55.29z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share",
						"out",
						"external",
						"outside"
					],
					"defaultCode": 61128,
					"grid": 16
				},
				{
					"id": 3317,
					"paths": [
						"M864 704c-45.16 0-85.92 18.738-115.012 48.83l-431.004-215.502c1.314-8.252 2.016-16.706 2.016-25.328s-0.702-17.076-2.016-25.326l431.004-215.502c29.092 30.090 69.852 48.828 115.012 48.828 88.366 0 160-71.634 160-160s-71.634-160-160-160-160 71.634-160 160c0 8.622 0.704 17.076 2.016 25.326l-431.004 215.504c-29.092-30.090-69.852-48.83-115.012-48.83-88.366 0-160 71.636-160 160 0 88.368 71.634 160 160 160 45.16 0 85.92-18.738 115.012-48.828l431.004 215.502c-1.312 8.25-2.016 16.704-2.016 25.326 0 88.368 71.634 160 160 160s160-71.632 160-160c0-88.364-71.634-160-160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share",
						"social"
					],
					"defaultCode": 61152,
					"grid": 16
				},
				{
					"id": 3318,
					"paths": [
						"M384 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM512 256c70.692 0 134.692 28.654 181.020 74.98l90.51-90.51c-69.49-69.49-165.49-112.47-271.53-112.47-167.192 0-309.4 106.862-362.12 256h-149.88v128h256c0-141.384 114.616-256 256-256zM768 512c0 141.384-114.616 256-256 256-70.692 0-134.692-28.654-181.020-74.98l-90.51 90.51c69.492 69.49 165.492 112.47 271.53 112.47 167.192 0 309.4-106.862 362.12-256h149.88v-128h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share",
						"social"
					],
					"defaultCode": 61153,
					"grid": 16
				},
				{
					"id": 785,
					"width": 1024,
					"paths": [
						"M928.832 224.832c-8.64-8.64-19.904-12.896-31.136-12.896-12.032 0-24.032 4.896-32.768 14.592l-113.344 125.952c-42.464-63.552-109.536-109.184-187.488-123.488 7.424-10.496 11.904-23.2 11.904-36.992 0-29.312-19.808-53.76-46.688-61.344 3.776-22.784 18.848-66.656 78.688-66.656h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16c-78.816 0-105.92 57.856-110.944 97.952-28.096 6.752-49.056 31.872-49.056 62.048 0 13.792 4.48 26.496 11.904 36.96-77.952 14.336-145.024 59.936-187.488 123.488l-113.344-125.92c-8.736-9.696-20.736-14.592-32.768-14.592-11.264 0-22.528 4.288-31.136 12.896-17.216 17.216-17.216 45.12 0 62.304l141.28 141.28c-5.024 16.64-8.576 33.888-10.56 51.584h-47.168c-24.192 0-46.592 16.704-50.144 40.64-3.68 24.8 11.648 46.368 33.504 53.056 12.384 147.456 115.136 269.056 253.024 308.576-25.92 15.36-46.048 39.424-56.096 68.224-7.104 20.352 9.12 41.504 30.656 41.504h244.64c21.536 0 37.792-21.152 30.72-41.504-10.016-28.8-30.176-52.864-56.096-68.224 137.888-39.52 240.608-161.12 253.024-308.576 21.856-6.688 37.184-28.256 33.504-53.056-3.584-23.936-25.952-40.64-50.176-40.64h-47.168c-1.984-17.696-5.536-34.944-10.56-51.552l141.28-141.28c17.216-17.216 17.216-45.12 0-62.336zM512 160c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM512 256c130.304 0 237.952 97.92 253.792 224h-507.584c15.84-126.080 123.488-224 253.792-224zM117.792 264.544c-4.704-4.704-4.704-12.352 0-17.056 2.912-2.912 6.24-3.52 8.512-3.52 2.016 0 5.856 0.512 8.96 4l120.288 133.632c-2.368 4.608-4.64 9.248-6.752 13.984l-131.008-131.040zM634.528 960h-245.024c13.216-37.248 48.8-64 90.528-64h64c41.696 0 77.28 26.752 90.496 64zM512 864c-165.568 0-301.44-126.624-317.632-288h635.264c-16.192 161.376-152.064 288-317.632 288zM848 512c8.832 0 16 7.168 16 16s-7.168 16-16 16h-672c-8.832 0-16-7.168-16-16s7.168-16 16-16h672zM906.208 264.544l-131.040 131.040c-2.112-4.736-4.384-9.376-6.752-13.984l120.288-133.632c3.136-3.488 6.976-4 8.992-4 2.272 0 5.6 0.608 8.512 3.52 4.704 4.672 4.704 12.352 0 17.056z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share",
						"eat",
						"scoop"
					],
					"grid": 32
				},
				{
					"id": 786,
					"width": 1024,
					"paths": [
						"M792.448 448c-8.416-36.928-23.904-71.072-44.992-101.088-42.624-60.576-107.776-104.064-183.36-117.92 7.424-10.496 11.904-23.2 11.904-36.992 0-29.312-19.808-53.76-46.688-61.344 3.776-22.784 18.848-66.656 78.688-66.656h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16c-78.816 0-105.92 57.856-110.944 97.952-28.096 6.752-49.056 31.872-49.056 62.048 0 13.792 4.48 26.496 11.904 36.96-76.48 14.048-142.336 58.336-184.928 120.064-20.32 29.504-35.232 62.912-43.424 98.976h560.896z",
						"M250.688 328.32l-91.616-101.792c-8.736-9.696-20.736-14.592-32.768-14.592-11.264 0-22.528 4.288-31.136 12.896-17.216 17.216-17.216 45.12 0 62.304l116.512 116.512c9.792-26.88 22.752-52.32 39.008-75.328z",
						"M928.832 224.832c-8.64-8.64-19.904-12.896-31.136-12.896-12.032 0-24.032 4.896-32.768 14.592l-91.616 101.824c16.256 23.040 29.28 48.416 39.040 75.328l116.512-116.512c17.184-17.216 17.184-45.12-0.032-62.336z",
						"M845.28 480h-666.56c-24.192 0-46.592 16.704-50.144 40.64-3.68 24.8 11.648 46.368 33.504 53.056 12.384 147.456 115.136 269.056 253.024 308.576-25.92 15.36-46.048 39.424-56.096 68.224-7.104 20.352 9.12 41.504 30.656 41.504h244.64c21.536 0 37.792-21.152 30.72-41.504-10.016-28.8-30.176-52.864-56.096-68.224 137.888-39.52 240.608-161.12 253.024-308.576 21.856-6.688 37.184-28.256 33.504-53.056-3.584-23.936-25.952-40.64-50.176-40.64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share",
						"eat",
						"scoop"
					],
					"grid": 32
				},
				{
					"id": 1123,
					"width": 1024,
					"paths": [
						"M1001.376 361.376l-233.376-233.376v-96c0-17.664-14.336-32-32-32h-672c-17.664 0-32 14.336-32 32v960c0 17.664 14.336 32 32 32h672c17.664 0 32-14.336 32-32v-352l233.376-233.376c12.48-12.48 12.48-32.768 0-45.248zM327.008 635.872c50.816-342.496 363.776-347.808 376.992-347.872 17.664 0 32-14.336 32-32v-69.504l197.504 197.504-197.504 197.504v-69.504c0-17.664-14.336-32-32-32-183.744 0-306.56 85.184-376.992 155.872zM704 960h-608v-896h608v192c0 0-68.352 0.032-149.632 32h-330.368v32h265.408c-27.616 16.608-55.008 37.6-80.352 64h-185.056v32h157.44c-14.56 19.008-28.032 40.224-39.968 64h-117.472v32h103.136c-7.968 19.744-14.88 41.088-20.64 64h-82.496v32h75.488c-1.44 7.616-2.944 15.2-4.128 23.168-3.2 21.6 13.888 37.536 31.968 37.536 7.744 0 15.648-2.912 22.208-9.568 16.288-16.448 35.936-34.048 59.008-51.136h167.456v-32h-118.304c63.168-36.064 144.704-64 246.304-64v448zM224 672h352v32h-352v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"share",
						"forward",
						"send",
						"distribute"
					],
					"grid": 32
				},
				{
					"id": 787,
					"width": 1024,
					"paths": [
						"M864 388.16v-228.16c0-53.024-42.976-96-96-96h-512c-53.024 0-96 42.976-96 96v228.16c0 15.168 10.912 27.232 25.536 31.264 40.608 11.168 70.464 48.384 70.464 92.576s-29.856 81.408-70.464 92.576c-14.624 4-25.536 16.096-25.536 31.264v228.16c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-228.16c0-15.168-10.912-27.232-25.536-31.264-40.608-11.168-70.464-48.384-70.464-92.576s29.856-81.408 70.464-92.576c14.624-4 25.536-16.096 25.536-31.264zM384 928v-608c0-70.592 57.408-128 128-128 11.104 0 21.696 1.856 32 4.544v731.456h-160zM576 928v-718.208c38.080 22.208 64 63.040 64 110.208v608h-64zM736 512c0 59.52 40.864 109.696 96 123.936v228.064c0 35.296-28.704 64-64 64h-96v-608c0-88.352-71.648-160-160-160s-160 71.648-160 160v608h-96c-35.296 0-64-28.704-64-64v-228.064c55.136-14.24 96-64.416 96-123.936s-40.864-109.696-96-123.936v-228.064c0-35.296 28.704-64 64-64h512c35.296 0 64 28.704 64 64v228.064c-55.136 14.24-96 64.416-96 123.936zM512 576c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sharpen",
						"draw"
					],
					"grid": 32
				},
				{
					"id": 788,
					"width": 1024,
					"paths": [
						"M640 320v640h-64v-750.208c38.080 22.208 64 63.040 64 110.208zM838.464 419.424c14.624-4 25.536-16.096 25.536-31.264v-228.16c0-53.024-42.976-96-96-96h-512c-53.024 0-96 42.976-96 96v228.16c0 15.168 10.912 27.232 25.536 31.264 40.608 11.168 70.464 48.384 70.464 92.576s-29.856 81.408-70.464 92.576c-14.624 4-25.536 16.096-25.536 31.264v228.16c0 53.024 42.976 96 96 96h96v-640c0-88.352 71.648-160 160-160s160 71.648 160 160v640h96c53.024 0 96-42.976 96-96v-228.16c0-15.168-10.912-27.232-25.536-31.264-40.608-11.168-70.464-48.384-70.464-92.576s29.856-81.408 70.464-92.576zM512 192c11.104 0 21.696 1.856 32 4.544v763.456h-160v-640c0-70.592 57.408-128 128-128zM512 576c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sharpen",
						"draw"
					],
					"grid": 32
				},
				{
					"id": 789,
					"width": 1024,
					"paths": [
						"M480 608c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM480 704c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM752 32c-8.832 0-16 7.168-16 16v80h-32v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-64v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-32v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-64v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-32v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-64v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-32v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v176c0 53.024 42.976 96 96 96v0l-35.872 35.872c-18.016 18.016-28.128 42.432-28.128 67.904v129.664c0 57.6 5.184 115.072 15.488 171.744l34.176 188c8.288 45.632 48.064 78.816 94.464 78.816h223.776c46.4 0 86.144-33.184 94.464-78.816l34.176-188c10.272-56.672 15.456-114.144 15.456-171.744v-129.664c0-25.472-10.112-49.888-28.128-67.872l-35.872-35.904c53.024 0 96-42.976 96-96v-176c0-8.832-7.168-16-16-16zM576 960h-192v-288c0-52.928 43.072-96 96-96s96 43.072 96 96v288zM685.248 378.496c12 12.032 18.752 28.288 18.752 45.28v129.664c0 55.68-5.024 111.232-14.976 165.984l-34.176 188.032c-4.544 24.928-23.264 44.064-46.848 50.24v-285.696c0-70.688-57.312-128-128-128s-128 57.312-128 128v285.696c-23.616-6.176-42.304-25.312-46.848-50.24l-34.176-188c-9.952-54.784-14.976-110.336-14.976-166.016v-129.664c0-16.96 6.752-33.248 18.752-45.248l58.496-58.528h293.504l58.496 58.496zM736 224c0 35.296-28.704 64-64 64h-384c-35.296 0-64-28.704-64-64v-64h512v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shave",
						"groom",
						"trim"
					],
					"grid": 32
				},
				{
					"id": 790,
					"width": 1024,
					"paths": [
						"M512 672c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM288 320h384c53.024 0 96-42.976 96-96v-176c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-32v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-64v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-32v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-64v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-32v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-64v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v80h-32v-80c0-8.832-7.168-16-16-16s-16 7.168-16 16v176c0 53.024 42.976 96 96 96zM704 352h-448l-3.872 3.872c-18.016 18.016-28.128 42.432-28.128 67.904v129.664c0 57.6 5.184 115.072 15.488 171.744l34.176 188c7.328 40.256 39.104 70.72 78.336 77.408v-318.592c0-70.688 57.312-128 128-128s128 57.312 128 128v318.56c39.232-6.656 71.008-37.152 78.336-77.408l34.176-188c10.304-56.64 15.488-114.112 15.488-171.712v-129.664c0-25.472-10.112-49.888-28.128-67.872l-3.872-3.904zM576 672v320h-192v-320c0-52.928 43.072-96 96-96s96 43.072 96 96zM544 672c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shave",
						"groom",
						"trim"
					],
					"grid": 32
				},
				{
					"id": 2249,
					"paths": [
						"M576 960h-512c-22.18 0-42.78-11.484-54.442-30.354-11.662-18.868-12.722-42.43-2.802-62.268l384-768c10.842-21.682 33.004-35.378 57.244-35.378h512c22.182 0 42.782 11.486 54.442 30.354 11.662 18.868 12.72 42.428 2.802 62.268l-384 768c-10.842 21.682-33.002 35.378-57.244 35.378zM167.556 832h368.89l320-640h-368.89l-320 640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shear"
					],
					"defaultCode": 60084,
					"grid": 16
				},
				{
					"id": 2630,
					"paths": [
						"M879.326 195.908l-351.998-192c-4.774-2.606-10.048-3.908-15.322-3.908s-10.548 1.302-15.326 3.908l-352.004 192c-10.28 5.606-16.676 16.382-16.676 28.092v256c0 140.788 36.312 254.616 111.012 347.99 58.364 72.956 138.144 132.366 258.68 192.63 4.504 2.252 9.408 3.378 14.31 3.378s9.806-1.126 14.31-3.378c120.534-60.268 200.31-119.678 258.674-192.63 74.702-93.374 111.014-207.202 111.014-347.99l0.002-256c0-11.71-6.396-22.486-16.676-28.092zM800 480c0 60.998-7.508 114.184-22.954 162.598-14.868 46.606-36.792 87.632-67.022 125.422-44.742 55.928-106.512 103.48-198.022 152.008 0 0-0.002-0.002-0.002-0.002v-815.124l0.004-0.002 287.998 157.090-0.002 218.010z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shield",
						"security",
						"defense",
						"protection",
						"anti virus"
					],
					"defaultCode": 60465,
					"grid": 16
				},
				{
					"id": 2631,
					"paths": [
						"M879.324 195.908l-351.996-192c-4.774-2.606-10.048-3.908-15.322-3.908-5.276 0-10.548 1.302-15.326 3.908l-352.004 192c-10.28 5.606-16.676 16.382-16.676 28.092v256c0 140.79 36.31 254.618 111.012 347.99 58.364 72.956 138.144 132.366 258.68 192.628 4.504 2.252 9.408 3.378 14.31 3.378s9.804-1.126 14.308-3.378c120.536-60.268 200.31-119.678 258.674-192.628 74.704-93.372 111.016-207.2 111.016-347.99l0.002-256c0-11.71-6.396-22.486-16.678-28.092zM416 722.912l-178.912-178.912 50.912-50.912 128 128 320-320 50.912 50.912-370.912 370.912z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shield-check",
						"security",
						"defense",
						"protection",
						"anti virus"
					],
					"defaultCode": 60466,
					"grid": 16
				},
				{
					"id": 2632,
					"paths": [
						"M879.324 195.908l-351.996-192c-4.774-2.606-10.048-3.908-15.322-3.908-5.276 0-10.548 1.302-15.326 3.908l-352.004 192c-10.28 5.606-16.676 16.382-16.676 28.092v256c0 140.79 36.31 254.618 111.012 347.99 58.364 72.956 138.144 132.366 258.68 192.628 4.504 2.252 9.408 3.378 14.31 3.378s9.804-1.126 14.308-3.378c120.536-60.268 200.31-119.678 258.674-192.628 74.704-93.372 111.016-207.2 111.016-347.99l0.002-256c0-11.71-6.396-22.486-16.678-28.092zM576 832h-128v-128h128v128zM576 640h-128v-448h128v448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shield-notice",
						"security",
						"defense",
						"protection",
						"anti virus"
					],
					"defaultCode": 60467,
					"grid": 16
				},
				{
					"id": 2633,
					"paths": [
						"M512.004 104.9l287.998 157.090-0.002 218.010c0 60.998-7.508 114.184-22.954 162.598-14.868 46.606-36.792 87.632-67.022 125.422-44.742 55.928-106.512 103.48-198.022 152.008-91.506-48.526-153.288-96.084-198.026-152.008-30.232-37.792-52.156-78.816-67.024-125.422-15.444-48.414-22.952-101.6-22.952-162.598v-218.008l288.004-157.092zM512.006 0c-5.274 0-10.548 1.302-15.326 3.908l-352.004 192c-10.28 5.606-16.676 16.382-16.676 28.092v256c0 140.788 36.312 254.616 111.012 347.99 58.364 72.956 138.144 132.366 258.68 192.63 4.504 2.252 9.408 3.378 14.31 3.378s9.806-1.126 14.31-3.378c120.534-60.268 200.31-119.678 258.674-192.63 74.702-93.374 111.014-207.202 111.014-347.99l0.002-256c0-11.71-6.396-22.486-16.676-28.092l-351.998-192c-4.774-2.606-10.048-3.908-15.322-3.908v0z",
						"M320 318.982v161.018c0 50.944 6.022 94.586 18.412 133.422 11.236 35.216 27.764 66.17 50.53 94.626 29.178 36.474 68.076 68.816 123.062 101.854 54.984-33.036 93.878-65.376 123.060-101.854 22.764-28.456 39.292-59.408 50.526-94.626 12.388-38.836 18.41-82.478 18.41-133.422l0.002-161.020-191.998-104.726-192.004 104.728z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shield",
						"security",
						"defense",
						"protection",
						"anti virus"
					],
					"defaultCode": 60468,
					"grid": 16
				},
				{
					"id": 2634,
					"paths": [
						"M960 0l-448 128-448-128c0 0-4.5 51.698 0 128l448 140.090 448-140.090c4.498-76.302 0-128 0-128zM72.19 195.106c23.986 250.696 113.49 672.234 439.81 828.894 326.32-156.66 415.824-578.198 439.81-828.894l-439.81 165.358-439.81-165.358z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shield",
						"security",
						"defense",
						"protection",
						"anti virus"
					],
					"defaultCode": 60469,
					"grid": 16
				},
				{
					"id": 2635,
					"paths": [
						"M960 0l-448 128-448-128c0 0-4.5 51.698 0 128l448 140.090 448-140.090c4.498-76.302 0-128 0-128zM72.19 195.106c23.986 250.696 113.49 672.234 439.81 828.894 326.32-156.66 415.824-578.198 439.81-828.894l-439.81 165.358-439.81-165.358zM489.478 420.37l9.654 3.63h-324.684c-1.28-5.352-2.526-10.688-3.734-16h285.864l32.9 12.37zM201.24 312l42.556 16h-89.156c-0.942-5.376-1.854-10.712-2.73-16h49.33zM286.352 344l42.556 16h-168.342c-1.050-5.372-2.056-10.7-3.038-16h128.824zM371.464 376l42.556 16h-246.86c-1.162-5.362-2.286-10.694-3.376-16h207.68zM875.244 292.268c-15.26 99.14-42.012 216.834-88.9 327.602-65.866 155.594-158.056 267.144-274.344 332.070v-15.94h-26.54c-7.964-5.104-15.81-10.432-23.532-16h50.072v-16h-71.136c-6.452-5.16-12.81-10.498-19.080-16h90.216v-16h-107.67c-5.442-5.2-10.812-10.532-16.106-16h123.776v-16h-138.75c-4.692-5.212-9.304-10.564-13.872-16h152.622v-16h-165.662c-4.122-5.232-8.178-10.578-12.194-16h177.856v-16h-189.39c-3.656-5.24-7.248-10.594-10.81-16h200.2v-16h-210.458c-3.284-5.268-6.54-10.586-9.738-16h220.196v-16h-229.378c-2.954-5.266-5.864-10.604-8.742-16h238.12v-16h-246.444c-2.676-5.278-5.324-10.602-7.93-16h254.374v-16h-261.922c-2.426-5.276-4.812-10.618-7.174-16h269.096v-16h-275.956c-2.226-5.32-4.416-10.652-6.55-16h282.506v-16h-288.738c-2.030-5.326-4.028-10.658-5.97-16h294.708v-16h-300.386c-1.852-5.33-3.676-10.664-5.446-16h305.832v-16h-311.008c-1.69-5.336-3.354-10.67-4.966-16h315.974v-16h-320.696c-1.542-5.34-3.056-10.676-4.524-16h325.22v-16h-329.522c-1.406-5.346-2.782-10.682-4.116-16h333.638v-11.162l363.244-136.57z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shield",
						"security",
						"defense",
						"protection",
						"anti virus",
						"dualtone"
					],
					"defaultCode": 60470,
					"grid": 16
				},
				{
					"id": 1452,
					"width": 731.4259643554688,
					"paths": [
						"M621.714 548.571v-365.714h-256v649.714q68-36 121.714-78.286 134.286-105.143 134.286-205.714zM731.429 109.714v438.857q0 49.143-19.143 97.429t-47.429 85.714-67.429 72.857-72.286 58.857-69.143 44.286-51.143 28.286-24.286 11.429q-6.857 3.429-14.857 3.429t-14.857-3.429q-9.143-4-24.286-11.429t-51.143-28.286-69.143-44.286-72.286-58.857-67.429-72.857-47.429-85.714-19.143-97.429v-438.857q0-14.857 10.857-25.714t25.714-10.857h658.286q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shield"
					],
					"defaultCode": 61746,
					"grid": 14
				},
				{
					"id": 3192,
					"paths": [
						"M672 896h-320c-17.672 0-32-14.326-32-32v-352h-128c-12.942 0-24.612-7.796-29.564-19.754-4.954-11.958-2.214-25.722 6.936-34.874l320-320c12.498-12.496 32.758-12.496 45.254 0l320 320c9.152 9.152 11.89 22.916 6.938 34.874s-16.62 19.754-29.564 19.754h-128v352c0 17.674-14.326 32-32 32zM384 832h256v-352c0-17.672 14.326-32 32-32h82.744l-242.744-242.746-242.744 242.746h82.744c17.672 0 32 14.328 32 32v352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shift"
					],
					"defaultCode": 61027,
					"grid": 16
				},
				{
					"id": 791,
					"width": 1024,
					"paths": [
						"M496 96c-238.592 0-432 193.408-432 432s193.408 432 432 432c238.592 0 432-193.408 432-432s-193.408-432-432-432zM496 928c-220.576 0-400-179.424-400-400s179.424-400 400-400 400 179.424 400 400-179.424 400-400 400zM688 256c-44.192 0-80 35.808-80 80 0 38.688 27.488 70.976 64 78.4v33.6c0 35.296-28.704 64-64 64h-96v-97.6c36.512-7.424 64-39.68 64-78.4 0-44.192-35.808-80-80-80s-80 35.808-80 80c0 38.688 27.488 70.976 64 78.4v97.6h-160v-97.6c36.512-7.424 64-39.68 64-78.4 0-44.192-35.808-80-80-80s-80 35.808-80 80c0 38.688 27.488 70.976 64 78.4v227.232c-36.512 7.424-64 39.68-64 78.4 0 44.16 35.808 79.968 80 79.968s80-35.808 80-80c0-38.688-27.488-70.976-64-78.4v-97.6h160v97.6c-36.512 7.424-64 39.68-64 78.4 0 44.192 35.808 80 80 80s80-35.808 80-80c0-38.688-27.488-70.976-64-78.4v-97.6h96c52.928 0 96-43.072 96-96v-33.6c36.512-7.424 64-39.68 64-78.4 0-44.192-35.808-80-80-80zM448 336c0-26.464 21.536-48 48-48s48 21.536 48 48-21.536 48-48 48-48-21.536-48-48zM256 336c0-26.464 21.536-48 48-48s48 21.536 48 48-21.536 48-48 48-48-21.536-48-48zM352 720c0 26.464-21.536 48-48 48s-48-21.536-48-48 21.536-48 48-48 48 21.536 48 48zM544 720c0 26.464-21.536 48-48 48s-48-21.536-48-48 21.536-48 48-48 48 21.536 48 48zM688 384c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shift",
						"drive",
						"cruise"
					],
					"grid": 32
				},
				{
					"id": 792,
					"width": 1024,
					"paths": [
						"M304 384c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM448 720c0 26.464 21.536 48 48 48s48-21.536 48-48-21.536-48-48-48-48 21.536-48 48zM256 720c0 26.464 21.536 48 48 48s48-21.536 48-48-21.536-48-48-48-48 21.536-48 48zM688 288c-26.464 0-48 21.536-48 48s21.536 48 48 48 48-21.536 48-48-21.536-48-48-48zM928 528c0 238.592-193.408 432-432 432s-432-193.408-432-432c0-238.592 193.408-432 432-432s432 193.408 432 432zM768 336c0-44.192-35.808-80-80-80s-80 35.808-80 80c0 38.688 27.488 70.976 64 78.4v33.6c0 35.296-28.704 64-64 64h-96v-97.6c36.512-7.424 64-39.68 64-78.4 0-44.192-35.808-80-80-80s-80 35.808-80 80c0 38.688 27.488 70.976 64 78.4v97.6h-160v-97.6c36.512-7.424 64-39.68 64-78.4 0-44.192-35.808-80-80-80s-80 35.808-80 80c0 38.688 27.488 70.976 64 78.4v227.232c-36.512 7.424-64 39.68-64 78.4 0 44.16 35.808 79.968 80 79.968s80-35.808 80-80c0-38.688-27.488-70.976-64-78.4v-97.6h160v97.6c-36.512 7.424-64 39.68-64 78.4 0 44.192 35.808 80 80 80s80-35.808 80-80c0-38.688-27.488-70.976-64-78.4v-97.6h96c52.928 0 96-43.072 96-96v-33.6c36.512-7.424 64-39.712 64-78.4zM544 336c0-26.464-21.536-48-48-48s-48 21.536-48 48 21.536 48 48 48 48-21.536 48-48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shift",
						"drive",
						"cruise"
					],
					"grid": 32
				},
				{
					"id": 793,
					"width": 1024,
					"paths": [
						"M320 450.656c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM320 546.656c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM672 731.744v-439.488c0-19.232-16.864-34.144-35.968-31.744l-192 24c-16 1.984-28.032 15.584-28.032 31.744v3.744h-320c-53.024 0-96 42.976-96 96v192c0 53.024 42.976 96 96 96h320v3.744c0 16.128 12.032 29.76 28.032 31.744l192 24c19.104 2.4 35.968-12.48 35.968-31.744zM448 316.256l192-24v439.488l-192-24v-391.488zM32 608v-192c0-35.36 28.64-64 64-64h320v320h-320c-35.36 0-64-28.64-64-64zM1024 448.096l-320 31.84v-32l320-31.84v32zM1024 768.64l-320-95.936v-33.312l320 95.872v33.376zM1024 288.704l-320 96.256v-33.696l320-95.84v33.28zM1024 607.936l-320-31.84v-32l320 31.84v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shine",
						"light",
						"gleam",
						"glow"
					],
					"grid": 32
				},
				{
					"id": 794,
					"width": 1024,
					"paths": [
						"M384 320h-288c-53.024 0-96 42.976-96 96v192c0 53.024 42.976 96 96 96h288v-384zM256 578.656c-35.36 0-64-28.64-64-64s28.64-64 64-64c35.36 0 64 28.64 64 64s-28.64 64-64 64zM288 514.656c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM704 639.424l320 95.872v33.344l-320-95.936v-33.28zM672 292.256v439.488c0 19.264-16.864 34.144-35.968 31.744l-192-24c-16-1.984-28.032-15.584-28.032-31.744v-391.488c0-16.128 12.032-29.76 28.032-31.744l192-24c19.104-2.4 35.968 12.48 35.968 31.744zM1024 255.456v33.248l-320 96.256v-33.696l320-95.808zM704 544.064l320 31.84v32l-320-31.84v-32zM704 447.904l320-31.84v32l-320 31.84v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shine",
						"light",
						"gleam",
						"glow"
					],
					"grid": 32
				},
				{
					"id": 1124,
					"width": 1024,
					"paths": [
						"M971.744 590.112c-12.768-24.16-19.232-50.432-19.232-78.112s6.464-53.952 19.232-78.112l13.888-26.272c7.84-14.816 2.912-33.152-11.264-42.048l-25.152-15.808c-23.136-14.528-41.888-34.048-55.712-58.016-13.856-23.968-21.376-49.984-22.4-77.28l-1.088-29.632c-0.608-16.736-14.016-30.144-30.752-30.784l-29.184-1.12c-18.848-0.736-37.728-4.16-55.2-11.328-34.528-14.112-61.792-36.768-80.672-66.784l-15.808-25.152c-8.896-14.176-27.264-19.104-42.048-11.264l-26.272 13.888c-24.128 12.736-50.4 19.2-78.080 19.2s-53.952-6.464-78.112-19.232l-26.272-13.888c-14.816-7.84-33.152-2.912-42.048 11.264l-15.808 25.152c-18.88 30.048-46.144 52.672-80.672 66.784-17.472 7.136-36.32 10.592-55.2 11.328l-29.152 1.12c-16.736 0.64-30.112 14.080-30.752 30.784l-1.088 29.664c-1.024 27.296-8.544 53.312-22.4 77.28-13.824 23.968-32.576 43.488-55.712 58.016l-25.152 15.808c-14.176 8.896-19.104 27.264-11.264 42.048l13.888 26.272c12.768 24.16 19.232 50.432 19.232 78.112s-6.464 53.952-19.232 78.112l-13.888 26.24c-7.84 14.816-2.912 33.152 11.264 42.048l25.152 15.808c23.136 14.528 41.888 34.048 55.712 58.016 13.856 23.968 21.376 49.984 22.4 77.28l1.088 29.632c0.608 16.736 14.016 30.144 30.752 30.784l29.152 1.12c18.848 0.736 37.728 4.16 55.2 11.296 34.528 14.112 61.792 36.768 80.672 66.784l15.808 25.152c8.896 14.176 27.264 19.104 42.048 11.264l26.272-13.888c24.16-12.768 50.432-19.232 78.112-19.232s53.952 6.464 78.112 19.232l26.272 13.888c14.816 7.84 33.152 2.912 42.048-11.264l15.808-25.152c18.88-30.048 46.144-52.672 80.672-66.784 17.472-7.136 36.32-10.592 55.168-11.328l29.184-1.12c16.736-0.64 30.112-14.080 30.752-30.784l1.088-29.632c1.024-27.296 8.544-53.312 22.4-77.28s32.576-43.488 55.712-58.016l25.152-15.808c14.176-8.896 19.104-27.264 11.264-42.048l-13.888-26.208zM915.168 620.032c-31.744 19.936-58.048 47.2-77.12 80.224s-29.536 69.44-30.912 106.912c-37.504 1.44-74.272 12.064-106.88 30.88-32.992 19.072-60.288 45.344-80.224 77.12-33.152-17.536-69.92-26.656-108.032-26.656s-74.88 9.152-108.032 26.656c-19.936-31.744-47.2-58.048-80.224-77.12-32.608-18.848-69.408-29.44-106.88-30.88-1.376-37.472-11.872-73.92-30.912-106.912-19.072-33.024-45.344-60.288-77.12-80.224 17.536-33.152 26.656-69.92 26.656-108.032s-9.152-74.88-26.656-108.032c31.744-19.936 58.048-47.2 77.12-80.224s29.536-69.44 30.912-106.912c37.504-1.44 74.272-12.064 106.88-30.88 33.024-19.072 60.288-45.344 80.224-77.12 33.152 17.536 69.92 26.656 108.032 26.656s74.88-9.152 108.032-26.656c19.936 31.744 47.2 58.048 80.224 77.12 32.608 18.848 69.408 29.44 106.88 30.88 1.376 37.472 11.872 73.92 30.912 106.912 19.072 32.992 45.344 60.288 77.12 80.224-17.536 33.152-26.656 69.92-26.656 108.032s9.12 74.88 26.656 108.032zM512 160c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zM512 832c-176.448 0-320-143.552-320-320s143.552-320 320-320 320 143.552 320 320c0 176.448-143.552 320-320 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shine",
						"gleam",
						"glow"
					],
					"grid": 32
				},
				{
					"id": 2601,
					"paths": [
						"M272.662 809.958c17.91-26.25 47.526-41.914 79.312-41.914h0.282c31.822 0.094 61.358 15.794 79.174 42.042 10.012 14.194 45.792 53.918 80.572 53.918 34.854 0 70.708-39.896 80.66-54.044 17.912-26.252 47.53-41.916 79.312-41.916h0.282c31.82 0.094 61.354 15.792 79.17 42.038 9.238 13.098 40.434 47.928 72.534 53.22 61.502-102.84 136.040-351.302 136.040-351.302l-131.626-56.412-52.918-317.502c-6.924-41.544-45.338-74.086-87.456-74.086h-352c-42.116 0-80.532 32.542-87.456 74.086l-52.916 317.502-131.628 56.412c0 0 74.54 248.46 136.042 351.3 32.174-5.304 63.436-40.284 72.62-53.342zM576 128h112c10.738 0 22.56 10.014 24.326 20.608l46.174 277.036-212.040-90.874 29.54-206.77zM311.674 148.608c1.764-10.592 13.588-20.608 24.326-20.608h112l29.538 206.77-212.038 90.874 46.174-277.036z",
						"M832 1024.004c-73.142 0-129.156-45.232-160-77.792-30.844 32.56-86.858 77.792-160 77.792s-129.158-45.232-160-77.792c-30.842 32.56-86.858 77.792-160 77.792-111.84 0-183.624-105.748-186.626-110.25-9.802-14.706-5.83-34.572 8.876-44.376 14.68-9.79 34.508-5.842 44.328 8.804 0.74 1.090 56.266 81.82 133.422 81.82 77.288 0 132.874-81.008 133.426-81.826 5.95-8.814 15.916-14.134 26.548-14.134 0.032 0 0.062 0 0.092 0 10.666 0.032 20.642 5.336 26.56 14.21 0.5 0.742 56.086 81.75 133.374 81.75 77.29 0 132.874-81.008 133.426-81.826 5.952-8.814 15.916-14.134 26.546-14.134 0.032 0 0.062 0 0.094 0 10.666 0.032 20.642 5.336 26.558 14.21 0.502 0.742 56.086 81.75 133.376 81.75s132.874-81.008 133.426-81.826c9.866-14.622 29.732-18.534 44.376-8.708 14.646 9.826 18.608 29.612 8.824 44.286-3 4.502-74.786 110.25-186.626 110.25z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ship",
						"travel",
						"transport",
						"boat",
						"sailing"
					],
					"defaultCode": 60436,
					"grid": 16
				},
				{
					"id": 1670,
					"width": 1170.2848663330078,
					"paths": [
						"M1034.857 888.571q10.857-10.857 25.714-10.857t25.714 10.857l73.143 73.143-51.429 51.429-47.429-47.429-47.429 47.429q-10.286 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-73.143-73.143 51.429-51.429 47.429 47.429 47.429-47.429q10.857-10.857 25.714-10.857t25.714 10.857l47.429 47.429 47.429-47.429q10.857-10.857 25.714-10.857t25.714 10.857l47.429 47.429 47.429-47.429q10.857-10.857 25.714-10.857t25.714 10.857l47.429 47.429 47.429-47.429q10.857-10.857 25.714-10.857t25.714 10.857l47.429 47.429 47.429-47.429q10.857-10.857 25.714-10.857t25.714 10.857l47.429 47.429 47.429-47.429q10.857-10.857 25.714-10.857t25.714 10.857l47.429 47.429zM135.429 866.857q-10.857 10.857-25.714 10.857t-25.714-10.857l-73.143-73.143 51.429-51.429 47.429 46.857 47.429-46.857q10.857-10.857 25.714-10.857t25.714 10.857l47.429 46.857 36.571-36.571v-167.429l-120-179.429q-9.714-14.857-4-32.286t22.857-23.143l101.143-33.143v-170.857h73.143v-73.143h146.286v-73.143h146.286v73.143h146.286v73.143h73.143v170.857l101.143 33.143q17.143 5.714 22.857 23.143t-4 32.286l-120 179.429v167.429l10.857-10.286q10.857-10.857 25.714-10.857t25.714 10.857l47.429 46.857 47.429-46.857q10.857-10.857 25.714-10.857t25.714 10.857l73.143 73.143-51.429 51.429-47.429-47.429-47.429 47.429q-10.286 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429-47.429 47.429q-10.857 10.857-25.714 10.857t-25.714-10.857l-47.429-47.429zM365.714 219.429v73.143l219.429-73.143 219.429 73.143v-73.143h-73.143v-73.143h-292.571v73.143h-73.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ship"
					],
					"defaultCode": 61978,
					"grid": 14
				},
				{
					"id": 139,
					"paths": [
						"M691.2 972.8h-409.6c-42.347 0-76.8-34.451-76.8-76.8v-476.482l-119.904 39.968c-13.414 4.472-27.91-2.778-32.381-16.19l-51.2-153.6c-4.029-12.086 1.442-25.296 12.837-30.994l307.2-153.6c7.936-3.968 17.36-3.542 24.907 1.122s12.141 12.904 12.141 21.776c0 70.579 57.421 128 128 128s128-57.421 128-128c0-8.872 4.594-17.112 12.141-21.776 7.547-4.666 16.971-5.090 24.907-1.122l307.2 153.6c11.395 5.698 16.867 18.907 12.837 30.994l-51.2 153.6c-4.47 13.411-18.966 20.662-32.381 16.19l-119.904-39.968v476.482c0 42.349-34.451 76.8-76.8 76.8zM230.398 358.4c5.307 0 10.555 1.65 14.97 4.832 6.675 4.811 10.632 12.539 10.632 20.768v512c0 14.115 11.485 25.6 25.6 25.6h409.6c14.115 0 25.6-11.485 25.6-25.6v-512c0-8.229 3.957-15.957 10.632-20.768 6.677-4.811 15.258-6.123 23.064-3.518l129.314 43.104 36.083-108.25-254.624-127.312c-17.946 79.995-89.538 139.944-174.869 139.944-85.333 0-156.925-59.949-174.869-139.944l-254.624 127.312 36.083 108.25 129.314-43.104c2.645-0.88 5.378-1.314 8.094-1.314z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shirt",
						"clothing",
						"tee",
						"tshirt"
					],
					"defaultCode": 59436,
					"grid": 20
				},
				{
					"id": 1664,
					"width": 877.7129516601562,
					"paths": [
						"M0 0h877.714v795.429l-443.429 193.143-434.286-193.143v-795.429zM820.571 758.286v-529.143h-763.429v529.143l377.714 168zM820.571 172v-114.857h-763.429v114.857h763.429zM103.429 342.286v65.714h-21.143v-65.714h21.143zM103.429 426.857v65.714h-21.143v-65.714h21.143zM103.429 511.429v65.714h-21.143v-65.714h21.143zM103.429 596v65.714h-21.143v-65.714h21.143zM103.429 680.571v65.714h-21.143v-65.714h21.143zM118.286 762.286l8.571-19.429 60 26.857-8.571 18.857zM196 796.571l8.571-19.429 60 26.286-8.571 19.429zM273.143 830.857l8.571-19.429 60 26.286-8.571 19.429zM350.857 864.571l8.571-18.857 59.429 26.286-8.571 19.429zM455.429 872l60-26.286 8.571 18.857-60 26.857zM532.571 837.714l60-26.286 8.571 19.429-60 26.286zM610.286 803.429l60-26.286 8.571 19.429-60 26.286zM687.429 769.714l60-26.857 8.571 19.429-60 26.286zM148 84v20.571h-65.143v-20.571h65.143zM240.571 84v20.571h-65.714v-20.571h65.714zM333.143 84v20.571h-65.714v-20.571h65.714zM425.143 84v20.571h-65.143v-20.571h65.143zM517.714 84v20.571h-65.143v-20.571h65.143zM610.286 84v20.571h-65.714v-20.571h65.714zM702.857 84v20.571h-65.714v-20.571h65.714zM794.857 84v20.571h-65.143v-20.571h65.143zM103.429 278.286v45.143h-21.143v-65.714h65.714v20.571h-44.571zM240.571 257.714v20.571h-65.714v-20.571h65.714zM333.143 257.714v20.571h-65.714v-20.571h65.714zM425.143 257.714v20.571h-65.143v-20.571h65.143zM517.714 257.714v20.571h-65.143v-20.571h65.143zM610.286 257.714v20.571h-65.714v-20.571h65.714zM702.857 257.714v20.571h-65.714v-20.571h65.714zM774.286 323.429v-45.143h-44.571v-20.571h65.714v65.714h-21.143zM774.286 408v-65.714h21.143v65.714h-21.143zM774.286 492.571v-65.714h21.143v65.714h-21.143zM774.286 577.143v-65.714h21.143v65.714h-21.143zM774.286 661.714v-65.714h21.143v65.714h-21.143zM774.286 746.286v-65.714h21.143v65.714h-21.143zM434.286 726.286q-73.714 0-126.286-52.286t-52.571-126.571q0-73.714 52.571-126.286t126.286-52.571q74.286 0 126.571 52.571t52.286 126.286q0 74.286-52.286 126.571t-126.571 52.286zM340 508.571q0 20.571 11.143 32.286t28.286 14.286 36.571 4 36.571 1.143 28.286 5.143 11.143 17.429q0 28-64 28-55.429 0-70.286-29.143h-1.714l-17.714 36q38.286 24 92.571 24 16.571 0 32.286-2.857t31.714-9.143 26-18.857 10-30.286q0-26.286-15.714-39.714t-38.571-15.429-45.429-1.714-38.286-2.857-15.714-14.571q0-12 11.714-18.857t23.143-8.571 23.429-1.714q19.429 0 40.286 6.286t29.429 19.429h1.714l17.143-33.143q-1.714-0.571-12-4.857t-12.857-5.143-11.143-4-12.571-4-11.429-2.571-13.714-2.286-13.143-0.571q-16.571 0-32.286 2.857t-30.857 9.429-24.571 19.429-9.429 30.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shirtsinbulk"
					],
					"defaultCode": 61972,
					"grid": 14
				},
				{
					"id": 2857,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM384 704c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM640 352c0-53.019 28.654-96 64-96s64 42.981 64 96c0 53.019-28.654 96-64 96s-64-42.981-64-96zM256 352c0-53.019 28.654-96 64-96s64 42.981 64 96c0 53.019-28.654 96-64 96s-64-42.981-64-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shocked",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60692,
					"grid": 16
				},
				{
					"id": 2858,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM320 448c-35.346 0-64-42.98-64-96s28.654-96 64-96 64 42.98 64 96-28.654 96-64 96zM512 832c-70.692 0-128-57.308-128-128s57.308-128 128-128c70.692 0 128 57.308 128 128s-57.308 128-128 128zM704 448c-35.346 0-64-42.98-64-96s28.654-96 64-96 64 42.98 64 96-28.654 96-64 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shocked",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60693,
					"grid": 16
				},
				{
					"id": 795,
					"width": 1024,
					"paths": [
						"M992 256h-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32h-672c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32h-32c-17.664 0-32 14.336-32 32v169.184c-18.976 11.136-32 31.296-32 54.816v16c0 8.832 7.168 16 16 16s16-7.168 16-16v-16c0-17.632 14.336-32 32-32h26.656l-40.032 240.224c-9.76 58.496 35.392 111.776 94.688 111.776h125.344c46.912 0 86.976-33.92 94.688-80.224l18.656-111.776h110.688c46.912 0 86.976-33.92 94.688-80.224l13.28-79.776h197.344c17.664 0 32-14.336 32-32h128c17.664 0 32-14.336 32-32v-32c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM333.792 746.528c-5.152 30.976-31.712 53.472-63.104 53.472h-125.376c-18.848 0-36.64-8.256-48.832-22.624s-17.408-33.28-14.304-51.904l40.928-245.472h32.448l-41.792 250.752c-3.264 19.488 11.776 37.248 31.552 37.248h125.344c15.648 0 28.992-11.296 31.552-26.752l43.584-261.248h32.448l-44.448 266.528zM188 480h125.344l-42.656 256h-125.376l42.688-256zM557.792 554.528c-5.152 30.976-31.712 53.472-63.104 53.472h-104.928l21.344-128h26.336c-11.648 36.672-3.264 78.272 25.76 107.328 3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624-22.944-22.944-27.296-57.024-13.92-84.672h98.336l-12.48 74.496zM800 416v32h-736v-64h744.896c-5.504 9.44-8.896 20.288-8.896 32zM960 416h-128c0-17.664 14.336-32 32-32h96v32zM992 352h-928v-64h928v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shoot",
						"kill",
						"control",
						"murder",
						"aim",
						"protection",
						"fire"
					],
					"grid": 32
				},
				{
					"id": 796,
					"width": 1024,
					"paths": [
						"M992 256h-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32h-672c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32h-32c-17.664 0-32 14.336-32 32v169.184c-18.976 11.136-32 31.296-32 54.816v16c0 8.832 7.168 16 16 16s16-7.168 16-16v-16c0-17.632 14.336-32 32-32h26.656l-40.032 240.224c-9.76 58.496 35.392 111.776 94.688 111.776h125.344c46.912 0 86.976-33.92 94.688-80.224l18.656-111.776h110.688c46.912 0 86.976-33.92 94.688-80.224l13.28-79.776h197.344c17.664 0 32-14.336 32-32h128c17.664 0 32-14.336 32-32v-32c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM302.24 741.248c-2.56 15.456-15.936 26.752-31.552 26.752h-125.376c-19.776 0-34.816-17.76-31.552-37.248l37.344-224c2.56-15.456 15.904-26.752 31.552-26.752h125.344c19.776 0 34.816 17.76 31.552 37.248l-37.312 224zM557.792 554.528c-5.152 30.976-31.712 53.472-63.104 53.472h-104.928l21.344-128h26.336c-11.648 36.672-3.264 78.272 25.76 107.328 3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624-22.944-22.944-27.296-57.024-13.92-84.672h98.336l-12.48 74.496zM944 416h-864c-8.832 0-16-7.168-16-16s7.168-16 16-16h864c8.832 0 16 7.168 16 16s-7.168 16-16 16zM182.656 512h125.344l-37.344 224h-125.344l37.344-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shoot",
						"kill",
						"control",
						"murder",
						"aim",
						"protection",
						"fire"
					],
					"grid": 32
				},
				{
					"id": 797,
					"width": 1024,
					"paths": [
						"M256 800h192c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32zM256 640h192v128h-192v-128zM934.816 216.64c-3.84-50.016-45.536-88.64-95.712-88.64h-654.208c-50.176 0-91.872 38.624-95.712 88.64l-20.288 263.616c-2.624 34.4 24.544 63.744 59.040 63.744h0.064v256c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-256h0.064c34.496 0 61.664-29.344 59.040-63.744l-20.288-263.616zM768 512v-352h64v352h-64zM192 160h64v352h-64v-352zM288 160h64v352h-64v-352zM384 160h64v352h-64v-352zM480 160h64v352h-64v-352zM576 160h64v352h-64v-352zM672 160h64v352h-64v-352zM133.12 512c-18.656 0-33.344-15.872-31.904-34.464l19.872-258.464c1.888-24.512 17.504-44.832 38.912-53.92v346.848h-26.88zM736 864h-128v-224h128v224zM864 800c0 35.36-28.64 64-64 64h-32v-224c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v224h-352c-35.36 0-64-28.64-64-64v-256h704v256zM890.88 512h-26.88v-346.848c21.408 9.088 37.024 29.408 38.912 53.952l19.872 258.464c1.44 18.56-13.248 34.432-31.904 34.432z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shop",
						"buy"
					],
					"grid": 32
				},
				{
					"id": 798,
					"width": 1024,
					"paths": [
						"M256 672h192v96h-192v-96zM608 896h128v-224h-128v224zM896 576v224c0 53.024-42.976 96-96 96h-32v-224c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v224h-352c-53.024 0-96-42.976-96-96v-224h768zM480 672c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-96zM68.896 480.256l20.288-263.616c3.84-50.016 45.536-88.64 95.712-88.64h654.208c50.176 0 91.872 38.624 95.712 88.64l20.288 263.616c2.656 34.368-24.512 63.68-58.944 63.744h-768.32c-34.432-0.032-61.568-29.376-58.944-63.744zM832 496c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16s-16 7.168-16 16v320zM736 496c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16s-16 7.168-16 16v320zM640 496c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16s-16 7.168-16 16v320zM544 496c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16s-16 7.168-16 16v320zM448 496c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16s-16 7.168-16 16v320zM352 496c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16s-16 7.168-16 16v320zM256 496c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16s-16 7.168-16 16v320zM160 496c0 8.832 7.168 16 16 16s16-7.168 16-16v-320c0-8.832-7.168-16-16-16s-16 7.168-16 16v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shop",
						"buy"
					],
					"grid": 32
				},
				{
					"id": 1778,
					"width": 1023.9989204406738,
					"paths": [
						"M1004 804.571l20 178.857q1.714 16-9.143 28.571-10.857 12-27.429 12h-950.857q-16.571 0-27.429-12-10.857-12.571-9.143-28.571l20-178.857h984zM950.857 325.143l49.143 442.857h-976l49.143-442.857q1.714-13.714 12-23.143t24.571-9.429h146.286v73.143q0 30.286 21.429 51.714t51.714 21.429 51.714-21.429 21.429-51.714v-73.143h219.429v73.143q0 30.286 21.429 51.714t51.714 21.429 51.714-21.429 21.429-51.714v-73.143h146.286q14.286 0 24.571 9.429t12 23.143zM731.429 219.429v146.286q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714v-146.286q0-60.571-42.857-103.429t-103.429-42.857-103.429 42.857-42.857 103.429v146.286q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714v-146.286q0-90.857 64.286-155.143t155.143-64.286 155.143 64.286 64.286 155.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shopping-bag"
					],
					"defaultCode": 62096,
					"grid": 14
				},
				{
					"id": 1779,
					"width": 1170.2867813110352,
					"paths": [
						"M1097.143 438.857q30.286 0 51.714 21.429t21.429 51.714-21.429 51.714-51.714 21.429h-8.571l-65.714 378.286q-4.571 26.286-25.143 43.429t-46.857 17.143h-731.429q-26.286 0-46.857-17.143t-25.143-43.429l-65.714-378.286h-8.571q-30.286 0-51.714-21.429t-21.429-51.714 21.429-51.714 51.714-21.429h1024zM277.143 896q14.857-1.143 24.857-12.857t8.857-26.571l-18.286-237.714q-1.143-14.857-12.857-24.857t-26.571-8.857-24.857 12.857-8.857 26.571l18.286 237.714q1.143 14.286 11.714 24t24.857 9.714h2.857zM512 859.429v-237.714q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714v237.714q0 14.857 10.857 25.714t25.714 10.857 25.714-10.857 10.857-25.714zM731.429 859.429v-237.714q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714v237.714q0 14.857 10.857 25.714t25.714 10.857 25.714-10.857 10.857-25.714zM932.571 862.286l18.286-237.714q1.143-14.857-8.857-26.571t-24.857-12.857-26.571 8.857-12.857 24.857l-18.286 237.714q-1.143 14.857 8.857 26.571t24.857 12.857h2.857q14.286 0 24.857-9.714t11.714-24zM272 166.857l-53.143 235.429h-75.429l57.714-252q10.857-50.286 50.857-82t91.429-31.714h95.429q0-14.857 10.857-25.714t25.714-10.857h219.429q14.857 0 25.714 10.857t10.857 25.714h95.429q51.429 0 91.429 31.714t50.857 82l57.714 252h-75.429l-53.143-235.429q-6.286-25.143-26-41.143t-45.429-16h-95.429q0 14.857-10.857 25.714t-25.714 10.857h-219.429q-14.857 0-25.714-10.857t-10.857-25.714h-95.429q-25.714 0-45.429 16t-26 41.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shopping-basket"
					],
					"defaultCode": 62097,
					"grid": 14
				},
				{
					"id": 1294,
					"width": 950.858943939209,
					"paths": [
						"M365.714 877.714q0 29.714-21.714 51.429t-51.429 21.714-51.429-21.714-21.714-51.429 21.714-51.429 51.429-21.714 51.429 21.714 21.714 51.429zM877.714 877.714q0 29.714-21.714 51.429t-51.429 21.714-51.429-21.714-21.714-51.429 21.714-51.429 51.429-21.714 51.429 21.714 21.714 51.429zM950.857 256v292.571q0 13.714-9.429 24.286t-23.143 12.286l-596.571 69.714q7.429 34.286 7.429 40 0 9.143-13.714 36.571h525.714q14.857 0 25.714 10.857t10.857 25.714-10.857 25.714-25.714 10.857h-585.143q-14.857 0-25.714-10.857t-10.857-25.714q0-6.286 4.571-18t9.143-20.571 12.286-22.857 8.857-16.857l-101.143-470.286h-116.571q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714 25.714-10.857h146.286q9.143 0 16.286 3.714t11.143 8.857 7.429 14 4.571 14.857 3.143 16.857 2.571 14.857h686.286q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shopping-cart"
					],
					"defaultCode": 61562,
					"grid": 14
				},
				{
					"id": 2349,
					"paths": [
						"M896 192h-832l-64 704h384l96-382.208 96 382.208h384l-64-704zM256 320h-128v-64h128v64zM448 320h-128v-64h128v64zM640 320h-128v-64h128v64zM832 320h-128v-64h128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shorts"
					],
					"defaultCode": 60184,
					"grid": 16
				},
				{
					"id": 2176,
					"paths": [
						"M288 1024c-17.672 0-32-14.326-32-32v-320c0-17.674 14.328-32 32-32s32 14.326 32 32v320c0 17.674-14.326 32-32 32z",
						"M416 960c-17.672 0-32-14.326-32-32v-256c0-17.674 14.328-32 32-32s32 14.326 32 32v256c0 17.674-14.326 32-32 32z",
						"M544 960c-17.674 0-32-14.326-32-32v-256c0-17.674 14.326-32 32-32s32 14.326 32 32v256c0 17.674-14.326 32-32 32z",
						"M672 1024c-17.674 0-32-14.326-32-32v-320c0-17.674 14.326-32 32-32s32 14.326 32 32v320c0 17.674-14.326 32-32 32z",
						"M928 320h-160v64h-576v-64h-160c-17.672 0-32 14.328-32 32v384c0 17.674 14.328 32 32 32h160v-192h576v192h160c17.674 0 32-14.326 32-32v-384c0-17.672-14.326-32-32-32z",
						"M256 0h448v320h-448v-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shredder",
						"destroy",
						"delete",
						"remove"
					],
					"defaultCode": 60011,
					"grid": 16
				},
				{
					"id": 2386,
					"paths": [
						"M192 0h128v256c0 35.346-28.654 64-64 64h-256v-128h192v-192z",
						"M704 0h128v192h192v128h-256c-35.346 0-64-28.654-64-64v-256z",
						"M768 704h256v128h-192v192h-128v-256c0-35.346 28.654-64 64-64z",
						"M0 704h256c35.346 0 64 28.654 64 64v256h-128v-192h-192v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shrink",
						"collapse",
						"minimize",
						"contract"
					],
					"defaultCode": 60221,
					"grid": 16
				},
				{
					"id": 2388,
					"paths": [
						"M576 448h416l-160-160 192-192-96-96-192 192-160-160z",
						"M576 576v416l160-160 192 192 96-96-192-192 160-160z",
						"M448 575.996h-416l160 160-192 192 96 96 192-192 160 160z",
						"M448 448v-416l-160 160-192-192-96 96 192 192-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shrink",
						"collapse",
						"minimize",
						"contract"
					],
					"defaultCode": 60223,
					"grid": 16
				},
				{
					"id": 2390,
					"paths": [
						"M928 288l-288 96 96-288zM528 0h32v64h-32zM592 0h32v64h-32zM656 0h32v64h-32zM720 0h32v64h-32zM784 0h32v64h-32zM848 0h32v64h-32zM914 0h32v64h-32zM144 0h32v64h-32zM208 0h32v64h-32zM272 0h32v64h-32zM336 0h32v64h-32zM400 0h32v64h-32zM464 0h32v64h-32zM288 96l96 288-288-96zM96 736l288-96-96 288zM736 928l-96-288 288 96zM80 0h32v64h-32zM528 960h32v64h-32zM592 960h32v64h-32zM656 960h32v64h-32zM720 960h32v64h-32zM784 960h32v64h-32zM848 960h32v64h-32zM914 960h32v64h-32zM144 960h32v64h-32zM208 960h32v64h-32zM272 960h32v64h-32zM336 960h32v64h-32zM400 960h32v64h-32zM464 960h32v64h-32zM80 960h32v64h-32zM1 465h64v32h-64zM1 401h64v32h-64zM1 337h64v32h-64zM1 273h64v32h-64zM1 209h64v32h-64zM1 145h64v32h-64zM1 79h64v32h-64zM1 849h64v32h-64zM1 785h64v32h-64zM1 721h64v32h-64zM1 657h64v32h-64zM1 593h64v32h-64zM1 529h64v32h-64zM1 913h64v32h-64zM961 465h64v32h-64zM961 401h64v32h-64zM961 337h64v32h-64zM961 273h64v32h-64zM961 209h64v32h-64zM961 145h64v32h-64zM961 79h64v32h-64zM961 849h64v32h-64zM961 785h64v32h-64zM961 721h64v32h-64zM961 657h64v32h-64zM961 593h64v32h-64zM961 529h64v32h-64zM961 913h64v32h-64zM640 384h-256v256h256v-256zM704 320v0 384h-384v-384h384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shrink",
						"collapse",
						"minimize",
						"contract"
					],
					"defaultCode": 60225,
					"grid": 16
				},
				{
					"id": 2392,
					"paths": [
						"M640 32v352h352z",
						"M32 384h352v-352z",
						"M640 640v352l352-352z",
						"M384 640h-352l352 352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shrink",
						"collapse",
						"minimize",
						"contract"
					],
					"defaultCode": 60227,
					"grid": 16
				},
				{
					"id": 2394,
					"paths": [
						"M768 256h-576v576h576v-576zM704 768h-448v-448h448v448zM80 144v800h800v-800h-800zM848 912h-736v-736h736v736zM320 512h320v64h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shrink",
						"collapse",
						"minimize",
						"contract"
					],
					"defaultCode": 60229,
					"grid": 16
				},
				{
					"id": 2396,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM960 512v448h-896v-896h896v448z",
						"M640 384h288l-288-288z",
						"M384 640v288l-288-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shrink",
						"collapse",
						"minimize",
						"contract"
					],
					"defaultCode": 60231,
					"grid": 16
				},
				{
					"id": 2398,
					"paths": [
						"M448 576v416l-160-160-192 192-96-96 192-192-160-160zM1024 96l-192 192 160 160h-416v-416l160 160 192-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shrink",
						"collapse",
						"minimize",
						"contract"
					],
					"defaultCode": 60233,
					"grid": 16
				},
				{
					"id": 3012,
					"paths": [
						"M768 704h-101.49l-160-160 160-160h101.49v160l224-224-224-224v160h-128c-16.974 0-33.252 6.744-45.254 18.746l-178.746 178.744-178.746-178.746c-12-12-28.28-18.744-45.254-18.744h-192v128h165.49l160 160-160 160h-165.49v128h192c16.974 0 33.252-6.742 45.254-18.746l178.746-178.744 178.746 178.744c12.002 12.004 28.28 18.746 45.254 18.746h128v160l224-224-224-224v160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shuffle",
						"random",
						"player"
					],
					"defaultCode": 60847,
					"grid": 16
				},
				{
					"id": 3013,
					"paths": [
						"M886.628 649.374c-9.148-9.152-22.91-11.886-34.874-6.938-11.956 4.952-19.754 16.62-19.754 29.564v96h-114.744l-224-224 224-224h114.744v96c0 12.942 7.796 24.612 19.754 29.564 3.958 1.64 8.118 2.436 12.238 2.436 8.328 0 16.514-3.252 22.634-9.374l128-128c12.498-12.498 12.498-32.758 0-45.256l-128-128c-9.148-9.15-22.91-11.888-34.874-6.936-11.954 4.954-19.752 16.624-19.752 29.566v96h-128c-8.486 0-16.626 3.372-22.626 9.372l-233.374 233.372-233.372-233.372c-6.002-6-14.14-9.372-22.628-9.372h-160c-17.672 0-32 14.328-32 32s14.328 32 32 32h146.746l224 224-224 224h-146.746c-17.672 0-32 14.326-32 32s14.328 32 32 32h160c8.488 0 16.626-3.372 22.628-9.374l233.372-233.372 233.374 233.374c6 6.002 14.14 9.374 22.626 9.374h128v96c0 12.944 7.796 24.612 19.754 29.564 3.958 1.64 8.118 2.436 12.238 2.436 8.328 0 16.514-3.252 22.634-9.374l128-128c12.498-12.496 12.498-32.758 0-45.254l-127.998-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shuffle",
						"random",
						"player"
					],
					"defaultCode": 60848,
					"grid": 16
				},
				{
					"id": 1125,
					"width": 1024,
					"paths": [
						"M781.248 512l233.376-233.376c12.512-12.512 12.512-32.768 0-45.248l-224-224c-20.16-20.16-54.624-5.888-54.624 22.624v128h-32c-127.104 0-207.072 79.776-266.976 168.544-61.6-81.216-156.704-168.544-309.024-168.544h-96c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h96c85.504 0 138.048 56.096 200.832 160-62.784 103.904-115.328 160-200.832 160h-96c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h96c152.32 0 247.424-87.328 309.024-168.544 59.904 88.768 139.872 168.544 266.976 168.544h32v128c0 28.512 34.464 42.784 54.624 22.624l224-224c12.512-12.512 12.512-32.768 0-45.248l-233.376-233.376zM128 288h-64v-64h64c113.376 0 200.928 55.36 283.84 179.584l8.576 12.832c-8.256 14.368-32.128 56.928-36.032 63.776-59.776-99.456-130.496-192.192-256.384-192.192zM411.84 620.416c-82.912 124.224-170.464 179.584-283.84 179.584h-64v-64h64c132.448 0 203.84-102.656 265.696-207.776 0 0 39.616-71.424 46.080-82.816l26.048-43.008c56.16-92.64 123.904-178.4 238.176-178.4h96v-114.752l146.752 146.752-146.752 146.752v-114.752h-96c-94.080 0-149.92 86.336-218.464 208.32 0 0-29.44 55.872-45.76 82.272l-27.936 41.824zM736 352v320h-32c-52.288 0-90.848-49.536-153.792-160 62.944-110.464 101.504-160 153.792-160h32zM800 914.752v-114.752h-96c-114.272 0-182.016-85.76-238.144-178.4l-8.256-13.632c13.12-21.248 25.664-42.56 37.472-63.488 64.32 112.992 119.232 191.52 208.928 191.52h96v-114.752l146.752 146.752-146.752 146.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shuffle",
						"randomize"
					],
					"grid": 32
				},
				{
					"id": 1884,
					"paths": [
						"M327.25 448l255.806-443.068c-23.228-3.226-46.94-4.932-71.056-4.932-139.708 0-266.322 55.982-358.702 146.706l173.952 301.294z",
						"M475.052 320h511.692c-59.172-146.166-183.862-258.776-337.672-301.414l-174.020 301.414z",
						"M364.2 640l-255.798-443.056c-67.916 86.878-108.402 196.236-108.402 315.056 0 44.2 5.6 87.088 16.13 128h348.070z",
						"M659.802 384l255.798 443.056c67.914-86.878 108.4-196.236 108.4-315.056 0-44.198-5.602-87.088-16.13-128h-348.068z",
						"M548.948 704h-511.692c59.172 146.166 183.862 258.776 337.67 301.414l174.022-301.414z",
						"M696.75 575.998l-255.806 443.070c23.228 3.224 46.942 4.932 71.056 4.932 139.708 0 266.324-55.98 358.704-146.706l-173.954-301.296z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"shutter",
						"camera"
					],
					"defaultCode": 59719,
					"grid": 16
				},
				{
					"id": 3255,
					"paths": [
						"M941.606 734.708l44.394-94.708h38l-64 384h-960v-74.242l331.546-391.212-331.546-331.546v-227h980l44 256h-34.376l-18.72-38.88c-35.318-73.364-61.904-89.12-138.904-89.12h-662l353.056 353.056-297.42 350.944h542.364c116.008 0 146.648-41.578 173.606-97.292z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sigma",
						"wysiwyg",
						"symbols"
					],
					"defaultCode": 61090,
					"grid": 16
				},
				{
					"id": 1314,
					"width": 877.7149925231934,
					"paths": [
						"M676.571 512q0 14.857-10.857 25.714l-310.857 310.857q-10.857 10.857-25.714 10.857t-25.714-10.857-10.857-25.714v-164.571h-256q-14.857 0-25.714-10.857t-10.857-25.714v-219.429q0-14.857 10.857-25.714t25.714-10.857h256v-164.571q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857l310.857 310.857q10.857 10.857 10.857 25.714zM877.714 310.857v402.286q0 68-48.286 116.286t-116.286 48.286h-182.857q-7.429 0-12.857-5.429t-5.429-12.857q0-2.286-0.571-11.429t-0.286-15.143 1.714-13.429 5.714-11.143 11.714-3.714h182.857q37.714 0 64.571-26.857t26.857-64.571v-402.286q0-37.714-26.857-64.571t-64.571-26.857h-178.286t-6.571-0.571-6.571-1.714-4.571-3.143-4-5.143-1.143-7.714q0-2.286-0.571-11.429t-0.286-15.143 1.714-13.429 5.714-11.143 11.714-3.714h182.857q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sign-in"
					],
					"defaultCode": 61584,
					"grid": 14
				},
				{
					"id": 1800,
					"width": 949.7150115966797,
					"paths": [
						"M474.857 384.571q18.286 0 33.714 10.286l126.857 84.571q34.857 22.857 62.857 55.429l83.429 97.143q22.857 26.286 16.571 60.571l-41.143 236q-3.429 18.286-16.857 30.571t-31.714 14.571l-301.143 32-201.143 18.286h-5.143q-22.286 0-38.571-16t-16.286-38.857q0-21.143 15.429-36.571t37.143-18.286l148.571-18.286h-256q-23.429 0-39.714-17.143t-15.143-40.571q1.143-22.286 18.286-37.143t39.429-14.857l252.571-0.571-297.714-36.571q-23.429-2.857-37.714-21.143t-10.857-41.714q3.429-20 19.714-32.857t37.429-12.857h5.714l274.857 34.286-200.571-53.714q-21.714-5.714-35.429-23.714t-10.286-39.143q3.429-20.571 18.857-33.429t35.429-12.857q3.429 0 11.429 1.143l256 54.857 124 21.143q0.571 0 1.714 0.286t1.714 0.286q13.143 0 17.429-13.143t-7.143-20.571l-106.286-71.429q-20-13.143-24-36.286t10.286-42q15.429-21.714 43.429-21.714zM434.857 500l106.286 71.429-124.571-21.143-2.857-1.143-20.571-21.714-136-149.714q-0.571-0.571-1.429-2t-1.429-2q-13.714-17.714-10.571-40t21.429-36.571q17.714-13.143 38.857-10t36.571 19.143l81.143 84-2.286 2.286t-2.857 2.286q-18.286 25.714-13.143 56.571t31.429 48.571zM941.714 240.571l8.571 152q2.286 41.714-6.286 84l-27.429 125.143q-6.857 33.714-38.286 49.714l-60.571 30.857q1.143-35.429-22.286-62.286l-83.429-97.143q-30.286-34.857-66.857-58.857l-126.857-84.571q-19.429-13.143-43.429-13.143-29.143 0-50.286 21.143l-134.286-178.286q-14.286-18.857-10.286-42t23.429-36.286q18.857-12.571 40.857-8t35.714 22.857l152 201.143-149.714-260q-12-20-6-42.857t27.143-33.714q20-10.286 41.429-3.429t32.857 26.286l137.714 240-77.714-192.571q-8.571-20-2.571-42.286t25.429-32q21.143-10.857 43.429-3.429t32 29.143l110.286 237.143 57.714 112q4.571 8.571 13.143 10t15.429-4.286 6.286-14.857l-6.857-128q-1.143-23.429 14.857-40.571t39.429-17.714q22.286 0 38.286 16.286t17.143 38.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sign-language",
						"signing"
					],
					"defaultCode": 62119,
					"grid": 14
				},
				{
					"id": 1310,
					"width": 896.0000305175781,
					"paths": [
						"M365.714 822.857q0 2.286 0.571 11.429t0.286 15.143-1.714 13.429-5.714 11.143-11.714 3.714h-182.857q-68 0-116.286-48.286t-48.286-116.286v-402.286q0-68 48.286-116.286t116.286-48.286h182.857q7.429 0 12.857 5.429t5.429 12.857q0 2.286 0.571 11.429t0.286 15.143-1.714 13.429-5.714 11.143-11.714 3.714h-182.857q-37.714 0-64.571 26.857t-26.857 64.571v402.286q0 37.714 26.857 64.571t64.571 26.857h178.286t6.571 0.571 6.571 1.714 4.571 3.143 4 5.143 1.143 7.714zM896 512q0 14.857-10.857 25.714l-310.857 310.857q-10.857 10.857-25.714 10.857t-25.714-10.857-10.857-25.714v-164.571h-256q-14.857 0-25.714-10.857t-10.857-25.714v-219.429q0-14.857 10.857-25.714t25.714-10.857h256v-164.571q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857l310.857 310.857q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sign-out"
					],
					"defaultCode": 61579,
					"grid": 14
				},
				{
					"id": 1196,
					"width": 1023.9999914169312,
					"paths": [
						"M146.286 822.857v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM365.714 749.714v182.857q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-182.857q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM585.143 603.429v329.143q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-329.143q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM804.571 384v548.571q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-548.571q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM1024 91.429v841.143q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-841.143q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"signal"
					],
					"defaultCode": 61458,
					"grid": 14
				},
				{
					"id": 1665,
					"width": 1170.288917541504,
					"paths": [
						"M493.143 589.714q0-64-45.429-109.429t-109.429-45.429-109.143 45.429-45.143 109.429 45.143 109.143 109.143 45.143 109.429-45.143 45.429-109.143zM986.286 589.143q0-64-45.143-109.143t-109.143-45.143-109.429 45.143-45.429 109.143q0 64.571 45.429 109.714t109.429 45.143 109.143-45.429 45.143-109.429zM1170.286 126.857v770.286q0 25.143-18 43.143t-43.714 18h-1046.857q-25.714 0-43.714-18t-18-43.143v-770.286q0-25.143 18-43.143t43.714-18h246.286q25.143 0 43.429 18t18.286 43.143v92h430.857v-92q0-25.143 18.286-43.143t43.429-18h246.286q25.714 0 43.714 18t18 43.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"simplybuilt"
					],
					"defaultCode": 61973,
					"grid": 14
				},
				{
					"id": 3342,
					"paths": [
						"M430.2 898c-169.6 16.8-316-60-327-171.2-11-111.4 117.6-215 287-231.8 169.6-16.8 316 60 326.8 171.2 11.2 111.4-117.4 215.2-286.8 231.8zM769.2 528.6c-14.4-4.4-24.4-7.2-16.8-26.2 16.4-41.2 18-76.6 0.2-102-33.2-47.4-124.2-45-228.4-1.2 0 0-32.8 14.2-24.4-11.6 16-51.6 13.6-94.6-11.4-119.6-56.6-56.6-207 2.2-336 131.2-96.4 96.2-152.4 198.8-152.4 287.4 0 169.2 217.2 272.2 429.6 272.2 278.4 0 463.8-161.8 463.8-290.2 0-77.8-65.4-121.8-124.2-140z",
						"M954.2 218.6c-67.2-74.6-166.4-103-258-83.6v0c-21.2 4.6-34.6 25.4-30 46.4 4.6 21.2 25.2 34.6 46.4 30 65.2-13.8 135.6 6.4 183.4 59.4s60.8 125.2 40.2 188.4v0c-6.6 20.6 4.6 42.6 25.2 49.4 20.6 6.6 42.6-4.6 49.4-25.2v-0.2c28.8-88.4 10.6-190-56.6-264.6z",
						"M850.8 312c-32.8-36.4-81.2-50.2-125.6-40.6-18.2 3.8-29.8 22-26 40.2 4 18.2 22 29.8 40 25.8v0c21.8-4.6 45.4 2.2 61.4 19.8 16 17.8 20.4 42 13.4 63.2v0c-5.6 17.6 4 36.8 21.8 42.6 17.8 5.6 36.8-4 42.6-21.8 14-43.4 5.2-93-27.6-129.2z",
						"M439.6 696.6c-6 10.2-19 15-29.2 10.8-10.2-4-13.2-15.6-7.4-25.4 6-9.8 18.6-14.6 28.6-10.8 10 3.6 13.6 15 8 25.4zM385.4 765.8c-16.4 26.2-51.6 37.6-78 25.6-26-11.8-33.8-42.2-17.4-67.8 16.2-25.4 50.2-36.8 76.4-25.8 26.6 11.4 35.2 41.6 19 68zM447 580.6c-80.6-21-171.8 19.2-206.8 90.2-35.8 72.4-1.2 153 80.2 179.4 84.4 27.2 184-14.6 218.6-92.6 34.2-76.6-8.4-155.2-92-177z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sina-weibo",
						"brand",
						"social"
					],
					"defaultCode": 61177,
					"grid": 16
				},
				{
					"id": 799,
					"width": 1024,
					"paths": [
						"M768 240c0-21.664-14.464-39.776-34.208-45.76-14.56-109.6-108.192-194.24-221.792-194.24s-207.232 84.64-221.792 194.24c-19.744 5.984-34.208 24.096-34.208 45.76s14.464 39.776 34.208 45.76c6.752 50.656 30.24 96 64.992 130.080l52.16 521.728c4.896 49.056 46.208 86.432 95.52 86.432h18.24c49.312 0 90.624-37.376 95.52-86.432l52.16-521.728c34.752-34.080 58.24-79.424 64.992-130.080 19.744-5.984 34.208-24.096 34.208-45.76zM512 32c94.976 0 174.048 69.312 189.344 160h-378.688c15.296-90.688 94.368-160 189.344-160zM584.8 934.368c-3.296 32.864-30.656 57.632-63.68 57.632h-18.24c-33.024 0-60.384-24.768-63.68-57.632l-49.056-490.56c35.072 22.816 76.864 36.192 121.856 36.192s86.784-13.376 121.856-36.192l-49.056 490.56zM512 448c-94.976 0-174.048-69.312-189.344-160h378.656c-15.264 90.688-94.336 160-189.312 160zM720 256h-416c-8.832 0-16-7.168-16-16s7.168-16 16-16h416c8.832 0 16 7.168 16 16s-7.168 16-16 16zM512 512c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sing",
						"speak",
						"announce"
					],
					"grid": 32
				},
				{
					"id": 800,
					"width": 1024,
					"paths": [
						"M297.728 160c27.552-92.48 112.864-160 214.272-160s186.72 67.52 214.272 160h-428.544zM726.272 320c-10.912 36.768-30.784 69.632-57.44 95.808l-52.16 521.728c-4.928 49.088-46.24 86.464-95.552 86.464h-18.24c-49.312 0-90.624-37.376-95.52-86.432l-52.16-521.728c-26.688-26.208-46.56-59.072-57.472-95.84h428.544zM544 544c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM720 192h-416c-26.496 0-48 21.504-48 48v0c0 26.496 21.504 48 48 48h416c26.496 0 48-21.504 48-48v0c0-26.496-21.504-48-48-48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sing",
						"speak",
						"announce"
					],
					"grid": 32
				},
				{
					"id": 1126,
					"width": 1024,
					"paths": [
						"M320 168.416v625.76c-26.816-16.192-59.808-26.176-96-26.176-88.352 0-160 57.312-160 128s71.648 128 160 128 160-57.312 160-128v-510.24l480-112.928v393.344c-26.816-16.192-59.808-26.176-96-26.176-88.352 0-160 57.312-160 128s71.648 128 160 128 160-57.312 160-128v-727.584c0-20.64-19.232-35.872-39.328-31.136l-544 128c-14.464 3.392-24.672 16.288-24.672 31.136zM224 960c-51.136 0-96-29.92-96-64s44.864-64 96-64 96 29.92 96 64-44.864 64-96 64zM384 320v-126.24l480-112.928v126.208l-480 112.96zM768 832c-51.136 0-96-29.92-96-64s44.864-64 96-64 96 29.92 96 64-44.864 64-96 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sing",
						"listen",
						"play"
					],
					"grid": 32
				},
				{
					"id": 801,
					"width": 1024,
					"paths": [
						"M910.336 832c-7.456 0-14.112 5.12-15.552 12.448-5.792 29.344-31.744 51.552-62.784 51.552s-56.992-22.208-62.784-51.552c-1.44-7.328-8.096-12.448-15.552-12.448h-3.296c-7.456 0-14.112 5.088-15.552 12.384-6.368 32.32-37.12 55.968-72.224 50.944-31.872-4.576-54.592-33.44-54.592-65.568v-29.76h224c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-224v-32h224c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-224v-32h224c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-224v-241.408c0-22.464-22.528-37.92-43.488-29.856l-310.976 119.584c-37.088 14.272-61.536 49.888-61.536 89.6v606.080c-31.040 0-56.992-22.208-62.784-51.552-1.44-7.328-8.096-12.448-15.552-12.448h-0.032c-9.92 0-17.728 8.96-15.776 18.688 8.704 44.032 47.616 77.312 94.144 77.312 33.408 0 62.784-17.184 80-43.136 17.216 25.952 46.592 43.136 80 43.136s62.784-17.184 80-43.136c17.216 25.952 46.592 43.136 80 43.136s62.784-17.184 80-43.136c17.216 25.952 46.592 43.136 80 43.136s62.784-17.184 80-43.136c17.216 25.952 46.592 43.136 80 43.136 46.528 0 85.44-33.28 94.176-77.312 1.92-9.728-5.888-18.688-15.808-18.688h-0.032zM800 384h32v64h-32v-64zM608 384h160v64h-160v-64zM832 544v64h-32v-64h32zM608 544h160v64h-160v-64zM800 704h32v64h-32v-64zM608 704h160v64h-160v-64zM576 829.76c0 32.16-22.752 60.992-54.56 65.568-35.104 5.056-65.888-18.624-72.224-50.944-1.44-7.296-8.128-12.384-15.584-12.384h-3.296c-7.456 0-14.112 5.12-15.552 12.448-5.792 29.344-31.744 51.552-62.784 51.552s-56.992-22.208-62.784-51.552c-1.44-7.328-8.096-12.448-15.552-12.448h-3.328c-7.456 0-14.080 5.088-15.552 12.384-3.648 18.24-15.168 33.6-30.784 42.688v-597.152c0-26.496 16.32-50.24 41.024-59.744l310.976-119.584v719.168zM432 576c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM432 512c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16zM432 768c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM432 704c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16zM432 384c26.496 0 48-21.504 48-48s-21.504-48-48-48-48 21.504-48 48 21.504 48 48 48zM432 320c8.832 0 16 7.168 16 16s-7.168 16-16 16-16-7.168-16-16 7.168-16 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sink",
						"float",
						"fail"
					],
					"grid": 32
				},
				{
					"id": 802,
					"width": 1024,
					"paths": [
						"M864 544c0-17.664-14.336-32-32-32h-192v128h192c17.664 0 32-14.336 32-32v-64zM800 592c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM448 528c0 8.832-7.168 16-16 16s-16-7.168-16-16 7.168-16 16-16 16 7.168 16 16zM448 720c0 8.832-7.168 16-16 16s-16-7.168-16-16 7.168-16 16-16 16 7.168 16 16zM832 672h-192v128h192c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM800 752c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32zM448 336c0 8.832-7.168 16-16 16s-16-7.168-16-16 7.168-16 16-16 16 7.168 16 16zM910.368 832h-0.032c-7.456 0-14.112 5.12-15.552 12.448-5.792 29.344-31.744 51.552-62.784 51.552s-56.992-22.208-62.784-51.552c-1.44-7.328-8.096-12.448-15.552-12.448h-3.296c-7.456 0-14.112 5.088-15.552 12.384-6.368 32.32-37.12 55.968-72.224 50.944-31.072-4.448-53.312-32.096-54.368-63.328h-0.224v-721.408c0-22.464-22.528-37.92-43.488-29.856l-310.976 119.584c-37.088 14.272-61.536 49.888-61.536 89.6v606.080c-31.040 0-56.992-22.208-62.784-51.552-1.44-7.328-8.096-12.448-15.552-12.448h-0.032c-9.92 0-17.728 8.96-15.776 18.688 8.704 44.032 47.616 77.312 94.144 77.312 33.408 0 62.784-17.184 80-43.136 17.216 25.952 46.592 43.136 80 43.136s62.784-17.184 80-43.136c17.216 25.952 46.592 43.136 80 43.136s62.784-17.184 80-43.136c17.216 25.952 46.592 43.136 80 43.136s62.784-17.184 80-43.136c17.216 25.952 46.592 43.136 80 43.136 46.528 0 85.44-33.28 94.176-77.312 1.92-9.728-5.888-18.688-15.808-18.688zM432 768c-26.496 0-48-21.504-48-48s21.504-48 48-48 48 21.504 48 48-21.504 48-48 48zM432 576c-26.496 0-48-21.504-48-48s21.504-48 48-48 48 21.504 48 48-21.504 48-48 48zM432 384c-26.496 0-48-21.504-48-48s21.504-48 48-48 48 21.504 48 48-21.504 48-48 48zM640 480h192c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-192v128zM784 384c8.832 0 16 7.168 16 16v32c0 8.832-7.168 16-16 16s-16-7.168-16-16v-32c0-8.832 7.168-16 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sink",
						"float",
						"fail"
					],
					"grid": 32
				},
				{
					"id": 803,
					"width": 1024,
					"paths": [
						"M768 224h-224v-64l73.376-73.376c12.512-12.512 12.512-32.768 0-45.248l-18.752-18.752c-12.512-12.512-32.768-12.512-45.248 0l-96 96c-6.016 6.016-9.376 14.144-9.376 22.624v82.752h-192c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h1.44l26.4 580.352c2.336 51.264 44.576 91.648 95.904 91.648h264.544c51.328 0 93.568-40.384 95.904-91.648l26.368-580.352h1.44c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32zM480 141.248l96-96 18.752 18.752-82.752 82.752v77.248h-32v-82.752zM708.192 898.912c-1.536 34.176-29.696 61.088-63.936 61.088h-264.544c-34.208 0-62.368-26.912-63.936-61.088l-19.008-418.912h430.464l-19.040 418.912zM728.704 448h-433.408l-5.824-128h445.024l-5.792 128zM768 288h-512v-32h512v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sip",
						"drink",
						"refresh",
						"shake"
					],
					"grid": 32
				},
				{
					"id": 804,
					"width": 1024,
					"paths": [
						"M224 288v-32c0-17.664 14.336-32 32-32h192v-82.752c0-8.48 3.36-16.64 9.376-22.624l96-96c12.512-12.512 32.768-12.512 45.248 0l18.752 18.752c12.512 12.512 12.512 32.768 0 45.248l-73.376 73.376v64h224c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32h-512c-17.664 0-32-14.336-32-32zM759.264 480l5.824-128h-506.176l5.824 128h494.528zM266.176 512l17.664 388.352c2.336 51.264 44.576 91.648 95.904 91.648h264.544c51.328 0 93.568-40.384 95.904-91.648l17.632-388.352h-491.648z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sip",
						"drink",
						"refresh",
						"shake"
					],
					"grid": 32
				},
				{
					"id": 1127,
					"width": 1024,
					"paths": [
						"M982.624 182.624c9.152-9.152 11.904-22.912 6.944-34.88-4.96-11.936-16.64-19.744-29.568-19.744h-188.256l39.392-63.040c9.344-14.976 4.8-34.72-10.176-44.096-14.976-9.344-34.72-4.8-44.096 10.176l-60.608 96.96h-632.256c-12.928 0-24.608 7.808-29.568 19.744-4.96 11.968-2.208 25.728 6.944 34.88l438.624 438.624v306.752h-128c-17.664 0-32 14.336-32 32s14.336 32 32 32h320c17.664 0 32-14.336 32-32s-14.336-32-32-32h-128v-306.752l438.624-438.624zM672 304c0 26.464-21.536 48-48 48s-48-21.536-48-48 21.536-48 48-48 48 21.536 48 48zM568.992 361.856l-99.2 158.688-232.544-232.544h308.352c-1.024 5.184-1.6 10.528-1.6 16 0 22.816 9.664 43.264 24.992 57.856zM596.16 378.752c8.704 3.232 18.016 5.248 27.84 5.248 44.192 0 80-35.808 80-80 0-5.472-0.576-10.816-1.6-16h84.352l-274.752 274.752-18.976-18.976 103.136-165.024zM818.752 256h-131.104c-2.656-3.488-5.44-6.816-8.608-9.856l33.824-54.144h169.888l-64 64zM675.136 192l-23.296 37.248c-8.704-3.232-18.016-5.248-27.84-5.248-26.080 0-49.024 12.672-63.648 32h-355.104l-64-64h533.888z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sip",
						"drink",
						"party",
						"indulge",
						"imbibe"
					],
					"grid": 32
				},
				{
					"id": 805,
					"width": 1024,
					"paths": [
						"M960 512c0-66.976-51.648-121.344-117.184-126.912l-20.608-154.464c-12.704-95.392-94.080-166.624-190.304-166.624h-239.808c-96.224 0-177.6 71.232-190.304 166.624l-20.608 154.464c-65.536 5.568-117.184 59.904-117.184 126.912 0 40.032 18.752 75.328 47.52 98.784l-41.312 247.936c-3.264 19.52 11.776 37.28 31.552 37.28h26.24v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32h512v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32h26.272c19.776 0 34.816-17.76 31.552-37.248l-41.344-247.968c28.768-23.488 47.52-58.784 47.52-98.784zM224 928h-64v-32h64v32zM288 864h-186.24l44.384-266.272-14.4-11.744c-22.72-18.528-35.744-45.504-35.744-73.984 0-52.928 43.072-96 96-96s96 43.072 96 96v352zM704 864h-384v-224h384c0 79.456 0 175.2 0 224zM704 608h-384v-64h384c0 16.672 0 38.816 0 64zM704 512h-384c0-63.392-46.176-115.648-106.656-125.856l20.16-151.296c10.56-79.168 78.752-138.848 158.592-138.848h239.808c79.872 0 148.032 59.68 158.592 138.848l20.16 151.296c-60.48 10.208-106.656 62.464-106.656 125.856zM864 928h-64v-32h64v32zM922.272 864h-186.272v-352c0-52.928 43.072-96 96-96s96 43.072 96 96c0 28.48-13.024 55.456-35.744 73.984l-14.4 11.744 44.416 266.272zM545.952 315.328c6.24 6.24 6.24 16.384 0 22.624s-16.384 6.24-22.624 0l-11.328-11.328-11.328 11.328c-6.24 6.24-16.384 6.24-22.624 0s-6.24-16.384 0-22.624l11.328-11.328-11.328-11.328c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l11.328 11.328 11.328-11.328c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-11.328 11.328 11.328 11.328z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sit",
						"relax"
					],
					"grid": 32
				},
				{
					"id": 806,
					"width": 1024,
					"paths": [
						"M192 352c88.224 0 160 71.776 160 160h320c0-88.224 71.776-160 160-160 2.208 0 4.288 0.576 6.496 0.672l-16.288-122.048c-12.704-95.392-94.080-166.624-190.304-166.624h-239.808c-96.224 0-177.6 71.232-190.304 166.624l-16.288 122.048c2.208-0.096 4.288-0.672 6.496-0.672zM478.048 292.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l11.328 11.328 11.328-11.328c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-11.328 11.328 11.328 11.328c6.24 6.24 6.24 16.384 0 22.624s-16.384 6.24-22.624 0l-11.328-11.328-11.328 11.328c-6.24 6.24-16.384 6.24-22.624 0s-6.24-16.384 0-22.624l11.328-11.328-11.328-11.328z",
						"M960 512c0-66.976-51.648-121.344-117.184-126.912l-0.032-0.256c-3.584-0.352-7.104-0.832-10.784-0.832-70.592 0-128 57.408-128 128v384h64v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32h26.272c19.776 0 34.816-17.76 31.552-37.248l-41.344-247.968c28.768-23.488 47.52-58.784 47.52-98.784z",
						"M320 512c0-70.592-57.408-128-128-128-3.68 0-7.2 0.48-10.784 0.832l-0.032 0.256c-65.536 5.568-117.184 59.904-117.184 126.912 0 40.032 18.752 75.328 47.52 98.784l-41.312 247.936c-3.264 19.52 11.776 37.28 31.552 37.28h26.24v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32h64v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sit",
						"relax"
					],
					"grid": 32
				},
				{
					"id": 1128,
					"width": 1024,
					"paths": [
						"M160 544h32v32h-32v-32zM832 576h32v-32h-32v32zM384 352h32v-32h-32v32zM608 352h32v-32h-32v32zM1024 512v96c0 59.52-40.864 109.696-96 123.936v196.064c0 17.664-14.336 32-32 32h-32c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32h-448c0 17.664-14.336 32-32 32h-64c-17.664 0-32-14.336-32-32h-32c-17.664 0-32-14.336-32-32v-196.064c-55.136-14.24-96-64.416-96-123.936v-96c0-70.592 57.408-128 128-128v-64c0-158.816 129.184-288 288-288h192c158.816 0 288 129.184 288 288v64c70.592 0 128 57.408 128 128zM288 512c0-35.296-28.704-64-64-64h-96c-35.296 0-64 28.704-64 64v96c0 35.296 28.704 64 64 64h32v224h128v-384zM704 704h-384v192h384v-192zM704 576h-384v96h384v-96zM800 416h32v-96c0-123.52-100.48-224-224-224h-192c-123.52 0-224 100.48-224 224v96h32c53.024 0 96 42.976 96 96v32h384v-32c0-53.024 42.976-96 96-96zM960 512c0-35.296-28.704-64-64-64h-96c-35.296 0-64 28.704-64 64v384h128v-224h32c35.296 0 64-28.704 64-64v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sit",
						"relax",
						"recline"
					],
					"grid": 32
				},
				{
					"id": 1385,
					"width": 1024.0010299682617,
					"paths": [
						"M1024 713.143v182.857q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-182.857q0-22.857 16-38.857t38.857-16h54.857v-109.714h-292.571v109.714h54.857q22.857 0 38.857 16t16 38.857v182.857q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-182.857q0-22.857 16-38.857t38.857-16h54.857v-109.714h-292.571v109.714h54.857q22.857 0 38.857 16t16 38.857v182.857q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-182.857q0-22.857 16-38.857t38.857-16h54.857v-109.714q0-29.714 21.714-51.429t51.429-21.714h292.571v-109.714h-54.857q-22.857 0-38.857-16t-16-38.857v-182.857q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857v182.857q0 22.857-16 38.857t-38.857 16h-54.857v109.714h292.571q29.714 0 51.429 21.714t21.714 51.429v109.714h54.857q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sitemap"
					],
					"defaultCode": 61672,
					"grid": 14
				},
				{
					"id": 807,
					"width": 1024,
					"paths": [
						"M352 800c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM704 768c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM928 668.928v35.072c0 41.952-27.072 77.28-64.576 90.336 0.064 1.92 0.576 3.712 0.576 5.664 0 88.352-71.648 160-160 160s-160-71.648-160-160h-64c0 88.352-71.648 160-160 160s-160-71.648-160-160c0-1.952 0.512-3.744 0.576-5.664-37.504-13.056-64.576-48.384-64.576-90.336v-544c0-53.024 42.976-96 96-96h181.056c44.064 0 82.464 29.984 93.12 72.704l63.84 255.392c8.608 34.4 35.456 61.248 69.856 69.856l206.912 51.744c71.264 17.824 121.216 81.824 121.216 155.232zM448 800c0-70.592-57.408-128-128-128s-128 57.408-128 128 57.408 128 128 128c70.592 0 128-57.408 128-128zM832 800c0-70.592-57.408-128-128-128s-128 57.408-128 128 57.408 128 128 128c70.592 0 128-57.408 128-128zM896 668.928c0-58.72-39.968-109.92-96.96-124.192l-206.912-51.744c-40.416-10.112-72.832-38.944-87.904-77.024h-168.224c-8.832 0-16-7.168-16-16s7.168-16 16-16h159.040l-8-32h-151.040c-8.832 0-16-7.168-16-16s7.168-16 16-16h143.008l-8-32h-135.008c-8.832 0.032-16-7.136-16-15.968s7.168-16 16-16h127.008l-8-32h-119.008c-8.832 0-16-7.168-16-16s7.168-16 16-16h111.008l-11.872-47.52c-7.136-28.48-32.736-48.48-62.080-48.48h-181.056c-35.36 0-64 28.64-64 64v544c0 25.632 15.264 47.584 37.12 57.728 17.216-69.76 79.776-121.728 154.88-121.728 77.408 0 141.952 54.976 156.768 128h70.464c14.816-73.024 79.36-128 156.768-128 75.104 0 137.664 51.968 154.88 121.728 21.856-10.144 37.12-32.096 37.12-57.728v-35.072z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"skate",
						"roll",
						"fall"
					],
					"grid": 32
				},
				{
					"id": 808,
					"width": 1024,
					"paths": [
						"M704 640c-88.352 0-160 71.648-160 160s71.648 160 160 160 160-71.648 160-160c0-1.952-0.512-3.744-0.576-5.664-3.040-85.696-72.992-154.336-159.424-154.336zM704 832c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM320 640c-86.432 0-156.384 68.64-159.424 154.336-0.064 1.92-0.576 3.712-0.576 5.664 0 88.352 71.648 160 160 160s160-71.648 160-160-71.648-160-160-160zM320 832c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM806.816 513.696l-206.912-51.744c-34.4-8.608-61.248-35.456-69.856-69.856l-63.84-255.392c-10.72-42.72-49.12-72.704-93.152-72.704h-181.056c-53.024 0-96 42.976-96 96v544c0 29.056 13.184 54.752 33.632 72.256 11.744-94.688 92.544-168.256 190.368-168.256 105.856 0 192 86.144 192 192 0-105.856 86.144-192 192-192 97.824 0 178.624 73.568 190.368 168.256 20.448-17.504 33.632-43.2 33.632-72.256v-35.072c0-73.44-49.952-137.408-121.184-155.232zM336 192h105.856c8.832 0 16 7.168 16 16s-7.168 16-16 16h-105.856c-8.832 0-16-7.168-16-16s7.168-16 16-16zM336 256h121.568c8.832 0 16 7.168 16 16s-7.168 16-16 16h-121.568c-8.832 0-16-7.168-16-16s7.168-16 16-16zM336 320h136.512c8.832 0 16 7.168 16 16s-7.168 16-16 16h-136.512c-8.832 0-16-7.168-16-16s7.168-16 16-16zM489.376 416h-153.376c-8.832 0-16-7.168-16-16s7.168-16 16-16h153.376c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"skate",
						"roll",
						"fall"
					],
					"grid": 32
				},
				{
					"id": 1129,
					"width": 1024,
					"paths": [
						"M736 384h-85.184c-46.432 0-86.144-33.152-94.464-78.816l-35.328-194.368c-8.32-45.664-48.032-78.816-94.432-78.816h-266.592c-52.928 0-96 43.072-96 96v576c0 31.552 15.712 60.416 40.288 78.048-5.472 16.192-8.288 33.088-8.288 49.952 0 88.224 71.776 160 160 160s160-71.776 160-160c0-10.848-1.12-21.504-3.328-32h166.688c-2.24 10.496-3.36 21.152-3.36 32 0 88.224 71.776 160 160 160s160-71.776 160-160c0-12.256-1.408-24.288-4.256-36.096 39.456-11.904 68.256-48.608 68.256-91.904v-96c0-123.488-100.48-224-224-224zM160 96h266.592c15.456 0 28.704 11.072 31.488 26.272l6.848 37.728h-112.928v32h118.752l5.824 32h-124.576v32h130.4l5.824 32h-136.224v32h142.336c2.304 11.232 5.952 21.824 10.4 32h-152.736v32h171.456c9.216 12.192 20 22.912 32.192 32h-203.648v32h384c88.224 0 160 71.776 160 160v32h-768v-512c0-17.664 14.368-32 32-32zM352 832c0 52.928-43.072 96-96 96s-96-43.072-96-96c0-52.928 43.072-96 96-96s96 43.072 96 96zM832 832c0 52.928-43.072 96-96 96s-96-43.072-96-96c0-52.928 43.072-96 96-96s96 43.072 96 96zM864 736h-44.16c-22.496-19.68-51.616-32-83.84-32s-61.344 12.32-83.84 32h-312.32c-22.496-19.68-51.584-32-83.84-32-33.728 0-64.16 13.312-87.040 34.624l-15.712-3.36c-14.624-3.168-25.248-16.288-25.248-31.264v-32h768v32c0 17.664-14.368 32-32 32zM192 832c0 35.296 28.704 64 64 64s64-28.704 64-64c0-35.296-28.704-64-64-64s-64 28.704-64 64zM288 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM672 832c0 35.296 28.704 64 64 64s64-28.704 64-64c0-35.296-28.704-64-64-64s-64 28.704-64 64zM768 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"skate",
						"roll"
					],
					"grid": 32
				},
				{
					"id": 1130,
					"width": 1024,
					"paths": [
						"M64 98.048v827.936c0 19.008 15.584 32.064 32.16 32.064 6.72 0 13.632-2.144 19.68-6.944l236.16-186.464v161.344c0 19.008 15.584 32.064 32.16 32.064 6.72 0 13.632-2.144 19.68-6.944l524.352-413.952c16.224-12.8 16.224-37.408 0-50.24l-524.352-413.984c-6.080-4.8-12.96-6.944-19.68-6.944-16.576 0-32.16 13.024-32.16 32.064v161.344l-236.16-186.464c-6.080-4.8-12.96-6.944-19.68-6.944-16.576 0-32.16 13.024-32.16 32.064zM128 859.712v-695.424l440.448 347.712-440.448 347.712zM416 673.12l172.256-136c16.224-12.8 16.224-37.408 0-50.24l-172.256-136v-186.816l440.704 347.936-440.704 347.936v-186.816z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"skip",
						"forward",
						"next"
					],
					"grid": 32
				},
				{
					"id": 2565,
					"paths": [
						"M819.412 204.588c-90.66-90.66-211.2-140.588-339.412-140.588s-248.75 49.928-339.412 140.588-140.588 211.2-140.588 339.412c0 17.672 14.328 32 32 32 123.514 0 224 100.486 224 224v128c0 17.674 14.328 32 32 32s32-14.326 32-32v-128c0-17.674 14.328-32 32-32s32 14.326 32 32v192c0 17.674 14.328 32 32 32s32-14.326 32-32v-192c0-17.674 14.326-32 32-32s32 14.326 32 32v192c0 17.674 14.328 32 32 32s32-14.326 32-32v-192c0-17.674 14.326-32 32-32s32 14.326 32 32v128c0 17.674 14.328 32 32 32s32-14.326 32-32v-128c0-123.514 100.486-224 224-224 17.674 0 32-14.328 32-32 0-128.212-49.928-248.75-140.588-339.412zM384 448c0 35.2-28.8 64-64 64h-64c-35.2 0-64-28.8-64-64v-64c0-35.2 28.8-64 64-64h64c35.2 0 64 28.8 64 64v64zM768 448c0 35.2-28.8 64-64 64h-64c-35.2 0-64-28.8-64-64v-64c0-35.2 28.8-64 64-64h64c35.2 0 64 28.8 64 64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"skull",
						"skeleton",
						"death",
						"danger"
					],
					"defaultCode": 60400,
					"grid": 16
				},
				{
					"id": 2566,
					"paths": [
						"M416 1024c-17.672 0-32-14.326-32-32v-256c0-17.674 14.328-32 32-32s32 14.326 32 32v256c0 17.674-14.328 32-32 32z",
						"M544 1024c-17.674 0-32-14.326-32-32v-256c0-17.674 14.326-32 32-32s32 14.326 32 32v256c0 17.674-14.326 32-32 32z",
						"M672 960c-17.674 0-32-14.326-32-32v-128c0-147.62 111.638-269.652 254.922-286.114-15.476-215.384-195.66-385.886-414.922-385.886-219.26 0-399.446 170.502-414.922 385.886 143.282 16.462 254.922 138.494 254.922 286.114v128c0 17.674-14.328 32-32 32s-32-14.326-32-32v-128c0-123.514-100.486-224-224-224-17.672 0-32-14.328-32-32 0-128.212 49.928-248.75 140.588-339.412s211.2-140.588 339.412-140.588 248.752 49.928 339.412 140.588 140.588 211.2 140.588 339.412c0 17.672-14.326 32-32 32-123.514 0-224 100.486-224 224v128c0 17.674-14.326 32-32 32z",
						"M384 448c0 35.2-28.8 64-64 64h-64c-35.2 0-64-28.8-64-64v-64c0-35.2 28.8-64 64-64h64c35.2 0 64 28.8 64 64v64z",
						"M768 448c0 35.2-28.8 64-64 64h-64c-35.2 0-64-28.8-64-64v-64c0-35.2 28.8-64 64-64h64c35.2 0 64 28.8 64 64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"skull",
						"skeleton",
						"death",
						"danger"
					],
					"defaultCode": 60401,
					"grid": 16
				},
				{
					"id": 1666,
					"width": 1170.2861022949219,
					"paths": [
						"M965.714 449.714q84.571 0 144.571 56.286t60 139.714q0 89.714-62.286 149.429t-152.571 59.714q-48.571 0-92.571-15.714t-78.857-42-67.429-60.571-62.286-72.286-59.143-75.714-62-72-66.857-60.571-77.714-42-90.857-15.714q-88 0-143.714 52.286t-55.714 139.714q0 89.714 59.429 142.857t150.286 53.143q57.143 0 118.857-21.429t110.286-56.286q2.857-2.286 12-10.571t17.143-13.714 12.571-5.429q8 0 14 6t6 14q0 13.714-34.286 44-57.714 50.286-134 81.143t-148.857 30.857q-76 0-140.286-33.143t-102.857-94.286-38.571-137.714q0-117.143 80.857-194.857t198.571-77.714q68.571 0 129.429 24.857t106 64.571 86.571 87.429 79.429 95.714 76.286 87.714 85.429 64.571 98.571 24.857q58.286 0 96.286-35.143t38-92.857q0-54.286-36.857-90.857t-91.143-36.571q-17.143 0-46.571 10.571t-39.143 10.571q-11.429 0-20.286-8.571t-8.857-20q0-10.286 4.857-32.571t4.857-33.714q0-90.857-61.429-150.286t-152.286-59.429q-33.143 0-63.714 10.571t-48 23.143-31.714 23.143-18.857 10.571q-8.571 0-14.571-6t-6-14.571q0-10.857 14.286-26.286 33.714-38.286 84-59.143t104-20.857q109.143 0 181.714 71.714t72.571 180.286q0 21.143-2.286 37.714 32.571-8.571 65.714-8.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"skyatlas"
					],
					"defaultCode": 61974,
					"grid": 14
				},
				{
					"id": 3385,
					"paths": [
						"M425.6 37.4c-1.6-1-3.4-1.8-5-2.6-1.8 0.4-3.4 0.6-5.2 1l10.2 1.6z",
						"M36.8 421c-0.4 1.8-0.6 3.6-0.8 5.2 1 1.6 1.6 3.2 2.6 4.8l-1.8-10z",
						"M986.8 602.6c0.4-1.8 0.6-3.6 1-5.4-1-1.6-1.6-3.2-2.6-4.8l1.6 10.2z",
						"M592 983c1.6 1 3.4 1.8 5 2.6 1.8-0.4 3.6-0.6 5.4-0.8l-10.4-1.8z",
						"M987.8 597.2c-0.4 1.8-0.6 3.6-1 5.4l-1.8-10.4c1 1.8 1.8 3.4 2.8 5 5.2-28.8 8-58.2 8-87.6 0-65.2-12.8-128.6-38-188.2-24.4-57.6-59.2-109.4-103.6-153.8s-96.2-79.2-153.6-103.6c-59.6-25.2-123-38-188.2-38-30.8 0-61.6 2.8-91.6 8.6 0 0-0.2 0-0.2 0 1.6 0.8 3.4 1.6 5 2.6l-10.2-1.6c1.8-0.4 3.4-0.6 5.2-1-41.2-21.8-87.4-33.6-134.2-33.6-76.4 0-148.4 29.8-202.4 83.8s-83.8 126-83.8 202.4c0 48.6 12.6 96.6 36 138.8 0.4-1.8 0.6-3.6 0.8-5.2l1.8 10.2c-1-1.6-1.8-3.2-2.6-4.8-4.8 27.4-7.2 55.4-7.2 83.4 0 65.2 12.8 128.6 38 188.2 24.4 57.6 59.2 109.2 103.6 153.6s96.2 79.2 153.8 103.6c59.6 25.2 123 38 188.2 38 28.4 0 56.8-2.6 84.6-7.6-1.6-1-3.2-1.8-5-2.6l10.4 1.8c-1.8 0.4-3.6 0.6-5.4 0.8 42.8 24.2 91.4 37.2 140.8 37.2 76.4 0 148.4-29.8 202.4-83.8s83.8-126 83.8-202.4c-0.2-48.6-12.8-96.6-36.4-139.2zM514.2 805.8c-171.8 0-248.6-84.4-248.6-147.8 0-32.4 24-55.2 57-55.2 73.6 0 54.4 105.6 191.6 105.6 70.2 0 109-38.2 109-77.2 0-23.4-11.6-49.4-57.8-60.8l-152.8-38.2c-123-30.8-145.4-97.4-145.4-160 0-129.8 122.2-178.6 237-178.6 105.8 0 230.4 58.4 230.4 136.4 0 33.4-29 52.8-62 52.8-62.8 0-51.2-86.8-177.6-86.8-62.8 0-97.4 28.4-97.4 69s49.6 53.6 92.6 63.4l113.2 25.2c123.8 27.6 155.2 100 155.2 168 0 105.4-81 184.2-244.4 184.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"skype",
						"brand",
						"social"
					],
					"defaultCode": 61220,
					"grid": 16
				},
				{
					"id": 1524,
					"width": 877.7149887084961,
					"paths": [
						"M670.286 607.429q0-28.571-11.143-52.286t-27.714-39.143-41.714-28-47.143-19.429-50-13.143l-59.429-13.714q-17.143-4-25.143-6t-20-6.571-17.143-9.143-9.429-12-4.286-17.143q0-44 82.286-44 24.571 0 44 6.857t30.857 16.286 21.714 19.143 22.857 16.571 27.429 6.857q26.857 0 43.143-18.286t16.286-44q0-31.429-32-56.857t-81.143-38.571-104-13.143q-38.857 0-75.429 8.857t-68.286 26.857-50.857 49.714-19.143 73.429q0 34.857 10.857 60.857t32 43.143 45.714 27.714 58.857 18.571l83.429 20.571q51.429 12.571 64 20.571 18.286 11.429 18.286 34.286 0 22.286-22.857 36.857t-60 14.571q-29.143 0-52.286-9.143t-37.143-22-26-25.714-26.286-22-30.857-9.143q-28.571 0-43.143 17.143t-14.571 42.857q0 52.571 69.714 90t166.286 37.429q41.714 0 80-10.571t70-30.571 50.571-53.429 18.857-75.143zM877.714 731.429q0 90.857-64.286 155.143t-155.143 64.286q-74.286 0-133.714-45.714-44 9.143-85.714 9.143-81.714 0-156.286-31.714t-128.571-85.714-85.714-128.571-31.714-156.286q0-41.714 9.143-85.714-45.714-59.429-45.714-133.714 0-90.857 64.286-155.143t155.143-64.286q74.286 0 133.714 45.714 44-9.143 85.714-9.143 81.714 0 156.286 31.714t128.571 85.714 85.714 128.571 31.714 156.286q0 41.714-9.143 85.714 45.714 59.429 45.714 133.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"skype"
					],
					"defaultCode": 61822,
					"grid": 14
				},
				{
					"id": 1548,
					"width": 950.8549728393555,
					"paths": [
						"M868 443.429q35.429 0 59.143 23.143t23.714 58q0 55.429-53.143 74.286l-98.286 33.714 32 95.429q4 12 4 26.857 0 33.714-24 58.286t-57.714 24.571q-26.857 0-48.857-15.429t-30.571-41.143l-31.429-94.286-177.143 60.571 31.429 93.714q4.571 13.714 4.571 26.857 0 33.714-24 58.286t-58.286 24.571q-26.857 0-48.571-15.429t-30.286-41.143l-31.429-93.143-87.429 30.286q-16.571 5.143-28.571 5.143-34.857 0-58-22.857t-23.143-57.714q0-26.857 15.714-48.571t40.857-30.286l89.143-30.286-60-178.857-89.143 30.857q-14.857 4.571-27.429 4.571-34.286 0-57.714-23.143t-23.429-57.429q0-26.857 15.714-48.571t40.857-30.286l89.714-30.286-30.286-90.857q-4.571-13.714-4.571-26.857 0-34.286 24-58.571t58.286-24.286q26.857 0 48.571 15.429t30.286 41.143l30.857 91.429 177.143-60-30.857-91.429q-4.571-13.714-4.571-26.857 0-33.714 24.286-58.286t58-24.571q26.857 0 48.857 15.714t30.571 40.857l30.286 92 92.571-31.429q12-3.429 24.571-3.429 34.286 0 58.571 22.571t24.286 56.286q0 25.714-17.143 46.571t-42.286 29.429l-89.714 30.857 60 180.571 93.714-32q13.714-4.571 26.286-4.571zM414.286 593.143l177.143-60-60-180-177.143 61.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"slack"
					],
					"defaultCode": 61848,
					"grid": 14
				},
				{
					"id": 809,
					"width": 1024,
					"paths": [
						"M800 64h-576c-53.024 0-96 42.976-96 96v704c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM224 96h576c35.296 0 64 28.704 64 64v192h-704v-192c0-35.296 28.704-64 64-64zM864 384v96h-704v-96h704zM800 928h-576c-35.296 0-64-28.704-64-64v-352h704v352c0 35.296-28.704 64-64 64zM224 320h224c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-224c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32zM224 160h224v128h-224v-128zM576 320h224c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-224c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32zM576 160h224v128h-224v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sleep",
						"charge",
						"relax"
					],
					"grid": 32
				},
				{
					"id": 810,
					"width": 1024,
					"paths": [
						"M800 288h-224v-128h224v128zM448 160h-224v128h224v-128zM896 512v-96h-768v96h768zM128 544v320c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-320h-768zM128 384v-224c0-53.024 42.976-96 96-96h576c53.024 0 96 42.976 96 96v224h-768zM544 288c0 17.664 14.336 32 32 32h224c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-224c-17.664 0-32 14.336-32 32v128zM192 288c0 17.664 14.336 32 32 32h224c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-224c-17.664 0-32 14.336-32 32v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sleep",
						"charge",
						"relax"
					],
					"grid": 32
				},
				{
					"id": 1131,
					"width": 1024,
					"paths": [
						"M512 0c-282.784 0-512 229.216-512 512s229.216 512 512 512 512-229.216 512-512-229.216-512-512-512zM336.256 100c-69.888 74.56-112.256 174.336-112.256 284 0 229.376 186.624 416 416 416 109.504 0 209.248-42.080 283.776-111.744-68.608 159.616-227.296 271.744-411.776 271.744-247.040 0-448-200.96-448-448 0-184.672 112.352-343.52 272.256-412zM960 512c0 34.272-4.224 67.52-11.552 99.584-69.792 94.72-181.696 156.416-308.448 156.416-212.064 0-384-171.936-384-384 0-126.752 61.696-238.656 156.416-308.448 32.064-7.328 65.312-11.552 99.584-11.552 247.040 0 448 200.96 448 448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sleep",
						"shine"
					],
					"grid": 32
				},
				{
					"id": 2869,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416z",
						"M640 672c0 88.366-57.308 160-128.002 160s-128.002-71.634-128.002-160c0-88.366 57.308-160 128.002-160s128.002 71.634 128.002 160z",
						"M416 340c-8.19 0-16.378-3.124-22.626-9.374-19.334-19.332-63.412-19.332-82.746 0-12.496 12.498-32.758 12.498-45.254 0-12.498-12.496-12.498-32.758 0-45.254 44.528-44.53 128.726-44.53 173.254 0 12.498 12.496 12.498 32.758 0 45.254-6.248 6.25-14.438 9.374-22.628 9.374z",
						"M736 340c-8.19 0-16.378-3.124-22.626-9.374-19.332-19.332-63.414-19.332-82.746 0-12.496 12.498-32.758 12.498-45.254 0-12.498-12.496-12.498-32.758 0-45.254 44.528-44.53 128.726-44.53 173.254 0 12.498 12.496 12.498 32.758 0 45.254-6.248 6.25-14.438 9.374-22.628 9.374z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sleepy",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60704,
					"grid": 16
				},
				{
					"id": 2870,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM310.628 330.626c-12.496 12.498-32.758 12.498-45.254 0-12.498-12.496-12.498-32.758 0-45.254 44.528-44.53 128.726-44.53 173.254 0 12.498 12.496 12.498 32.758 0 45.254-6.248 6.25-14.438 9.374-22.628 9.374s-16.378-3.124-22.626-9.374c-19.334-19.332-63.412-19.332-82.746 0zM511.998 832c-70.694 0-128.002-71.634-128.002-160s57.308-160 128.002-160 128.002 71.634 128.002 160-57.308 160-128.002 160zM758.628 330.626c-6.248 6.25-14.438 9.374-22.628 9.374s-16.378-3.124-22.626-9.374c-19.332-19.332-63.414-19.332-82.746 0-12.496 12.498-32.758 12.498-45.254 0-12.498-12.496-12.498-32.758 0-45.254 44.528-44.53 128.726-44.53 173.254 0 12.498 12.498 12.498 32.758 0 45.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sleepy",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60705,
					"grid": 16
				},
				{
					"id": 811,
					"width": 1024,
					"paths": [
						"M852.416 130.144c-98.592-62.144-215.264-98.144-340.416-98.144s-241.824 36-340.416 98.144c-41.184 25.952-56.8 78.432-36.16 122.496l318.624 679.712c11.52 24.544 34.72 36.832 57.952 36.832s46.432-12.288 57.952-36.832l318.624-679.712c20.64-44.064 5.024-96.544-36.16-122.496zM344.096 622.432c10.944-8.896 24.736-14.432 39.904-14.432 35.296 0 64 28.704 64 64 0 30.912-22.048 56.8-51.264 62.72l-52.64-112.288zM701.76 575.776c-34.24-1.216-61.76-29.248-61.76-63.776 0-35.296 28.704-64 64-64 18.944 0 35.872 8.416 47.552 21.568l-49.792 106.208zM765.696 439.392c-16.672-14.368-37.952-23.392-61.696-23.392-53.024 0-96 42.976-96 96 0 47.36 34.336 86.464 79.456 94.336l-146.464 312.448c-8 17.088-24.192 18.432-28.96 18.432s-20.96-1.344-28.96-18.432l-72.704-155.072c40.128-11.424 69.632-47.904 69.632-91.712 0-53.024-42.976-96-96-96-20 0-38.432 6.304-53.792 16.8l-144.928-309.216c88.512-74.624 202.144-120.384 326.72-120.384s238.208 45.76 326.72 120.384l-73.024 155.808zM859.584 239.072l-6.688 14.24c-93.056-75.936-211.392-122.112-340.896-122.112s-247.84 46.176-340.928 122.112l-6.656-14.24c-13.76-29.312-3.328-64.512 24.224-81.856 96.768-60.992 208.576-93.216 323.36-93.216s226.592 32.224 323.36 93.216c27.552 17.344 37.984 52.544 24.224 81.856zM384 352c0 53.024 42.976 96 96 96s96-42.976 96-96-42.976-96-96-96-96 42.976-96 96zM544 352c0 35.296-28.704 64-64 64s-64-28.704-64-64 28.704-64 64-64 64 28.704 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"slice",
						"cook",
						"eat"
					],
					"grid": 32
				},
				{
					"id": 812,
					"width": 1024,
					"paths": [
						"M767.808 510.24l-24.192 51.616c-10.912 8.704-24.576 14.144-39.616 14.144-35.296 0-64-28.704-64-64s28.704-64 64-64c34.688 0 62.88 27.776 63.808 62.24zM480 288c-35.296 0-64 28.704-64 64s28.704 64 64 64 64-28.704 64-64-28.704-64-64-64zM864.224 304.576l-76.032 162.208c-16.192-30.080-47.616-50.784-84.192-50.784-53.024 0-96 42.976-96 96s42.976 96 96 96c6.464 0 12.768-0.672 18.88-1.92l-152.928 326.272c-11.52 24.544-34.72 36.832-57.952 36.832s-46.432-12.288-57.952-36.832l-77.408-165.12c2.496 0.224 4.832 0.768 7.36 0.768 53.024 0 96-42.976 96-96s-42.976-96-96-96c-32.256 0-60.64 16.032-78.048 40.448l-146.176-311.872c91.872-87.36 215.744-141.376 352.224-141.376s260.352 54.016 352.224 141.376zM576 352c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96zM145.472 274.048c96.736-88.448 225.12-142.848 366.528-142.848s269.792 54.4 366.528 142.848l10.048-21.408c20.672-44.064 5.024-96.544-36.16-122.496-98.592-62.144-215.264-98.144-340.416-98.144s-241.824 36-340.416 98.144c-41.184 25.952-56.8 78.432-36.16 122.496l10.048 21.408zM448 672c0-35.296-28.704-64-64-64-28.672 0-52.736 19.104-60.832 45.152l36.576 78.016c7.488 3.072 15.648 4.832 24.256 4.832 35.296 0 64-28.704 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"slice",
						"cook",
						"eat"
					],
					"grid": 32
				},
				{
					"id": 1614,
					"width": 877.7139892578125,
					"paths": [
						"M201.143 804.571v73.143h-201.143v-73.143h201.143zM402.286 731.429q14.857 0 25.714 10.857t10.857 25.714v146.286q0 14.857-10.857 25.714t-25.714 10.857h-146.286q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-14.857 10.857-25.714t25.714-10.857h146.286zM493.714 512v73.143h-493.714v-73.143h493.714zM128 219.429v73.143h-128v-73.143h128zM877.714 804.571v73.143h-420.571v-73.143h420.571zM329.143 146.286q14.857 0 25.714 10.857t10.857 25.714v146.286q0 14.857-10.857 25.714t-25.714 10.857h-146.286q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-14.857 10.857-25.714t25.714-10.857h146.286zM694.857 438.857q14.857 0 25.714 10.857t10.857 25.714v146.286q0 14.857-10.857 25.714t-25.714 10.857h-146.286q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-14.857 10.857-25.714t25.714-10.857h146.286zM877.714 512v73.143h-128v-73.143h128zM877.714 219.429v73.143h-493.714v-73.143h493.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sliders"
					],
					"defaultCode": 61918,
					"grid": 14
				},
				{
					"id": 1622,
					"width": 1024.00612449646,
					"paths": [
						"M498.857 422.857q0 47.429-36.286 81.429t-87.143 34-87.143-34-36.286-81.429q0-48 36.286-81.714t87.143-33.714 87.143 33.714 36.286 81.714zM785.714 422.857q0 47.429-36 81.429t-87.429 34q-50.857 0-87.143-34t-36.286-81.429q0-48 36.286-81.714t87.143-33.714q51.429 0 87.429 33.714t36 81.714zM914.286 525.714v-381.143q0-49.714-18.286-70.571t-63.429-20.857h-635.429q-47.429 0-64.286 19.429t-16.857 72v384.571q24.571 13.143 50.571 22.857t46.286 16 46.286 10.571 40.571 6.286 40 2.286 33.429 0.286 32.286-1.143 25.429-1.143q38.857-0.571 54.286 15.429 3.429 3.429 5.714 5.143 14.857 14.286 34.857 29.143 4-52 67.429-49.714 2.857 0 20.857 0.857t24.571 1.143 26 0.571 30.286-0.571 31.143-2.571 34.857-4.857 35.429-7.714 38.286-11.143 38.571-15.429 41.143-19.714zM1007.429 522.857q-69.143 85.143-212.571 144 48 162.857-13.143 265.714-37.714 64.571-104.571 84.571-59.429 18.286-104-8.571-49.143-29.143-46.857-93.714l-0.571-186.286v-0.571q-4.571-1.143-14-3.429t-13.429-2.857l-0.571 193.143q2.286 65.143-47.429 93.714-45.143 26.857-104.571 8.571-66.857-20.571-104-85.714-60-102.857-12.571-264.571-143.429-58.857-212.571-144-14.286-21.143-2.286-36t34.286 0.571q1.714 1.143 6.286 4t6.286 4.571v-396.571q0-41.143 26.857-70.286t65.143-29.143h718.286q38.286 0 65.143 29.143t26.857 70.286v396.571l12-8.571q22.286-15.429 34.286-0.571t-2.286 36z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"slideshare"
					],
					"defaultCode": 61927,
					"grid": 14
				},
				{
					"id": 153,
					"paths": [
						"M537.6 921.6h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M742.4 1024h-460.8c-42.347 0-76.8-34.451-76.8-76.8v-870.4c0-42.347 34.453-76.8 76.8-76.8h460.8c42.349 0 76.8 34.453 76.8 76.8v870.4c0 42.349-34.451 76.8-76.8 76.8zM281.6 51.2c-14.115 0-25.6 11.485-25.6 25.6v870.4c0 14.115 11.485 25.6 25.6 25.6h460.8c14.115 0 25.6-11.485 25.6-25.6v-870.4c0-14.115-11.485-25.6-25.6-25.6h-460.8z",
						"M691.2 819.2h-358.4c-14.138 0-25.6-11.461-25.6-25.6v-665.6c0-14.138 11.462-25.6 25.6-25.6h358.4c14.139 0 25.6 11.462 25.6 25.6v665.6c0 14.139-11.461 25.6-25.6 25.6zM358.4 768h307.2v-614.4h-307.2v614.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"smartphone",
						"mobile",
						"phone",
						"cellular"
					],
					"defaultCode": 59450,
					"grid": 20
				},
				{
					"id": 813,
					"width": 1024,
					"paths": [
						"M821.92 642.208c6.304-9.92 10.080-21.6 10.080-34.208v-64c0-66.368-50.688-120.288-115.36-126.72 2.080-5.376 3.36-11.168 3.36-17.28v-32c0-97.216-78.784-176-176-176h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h15.808c7.392 0.192 16.192 3.104 16.192 16s-8.8 15.808-16 16h-48c-29.888 0-57.664 9.184-80.704 24.832-2.88-25.536-20.608-46.336-44.48-53.696 18.88-30.24 45.184-76.448 45.184-99.136 0-35.36-28.64-64-64-64-35.328 0-64 28.64-64 64 0 22.688 26.304 68.896 45.216 99.136-20.128 6.208-35.84 21.952-42.080 42.080-30.24-18.912-76.448-45.216-99.136-45.216-35.328 0-64 28.64-64 64s28.64 64 64 64c22.688 0 68.896-26.304 99.136-45.216 8.064 26.112 32.096 45.216 60.864 45.216 3.136 0 6.112-0.48 9.12-0.928-5.568 15.36-9.12 31.68-9.12 48.928 0 5.632 1.152 10.976 2.944 16h-2.944c-70.688 0-128 57.312-128 128v64c0 12.608 3.776 24.288 10.080 34.208-77.888 10.784-138.080 76.928-138.080 157.792v32c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-32c0-80.864-60.192-147.008-138.080-157.792zM160 320c-17.632 0-32-14.368-32-32s14.336-32 31.968-32c9.792 0.256 37.664 13.568 68.704 32-31.040 18.432-58.912 31.744-68.672 32zM288 128c0-17.632 14.368-32 32-32s32 14.368 32 31.968c-0.256 9.792-13.568 37.664-32 68.736-18.432-31.040-31.744-58.912-32-68.704zM320 320c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM928 832c0 35.36-28.64 64-64 64h-704c-35.36 0-64-28.64-64-64v-32c0-70.688 57.312-128 128-128h48c8.832 0 16-7.168 16-16s-7.168-16-16-16h-16c-17.664 0-32-14.336-32-32v-64c0-53.024 42.976-96 96-96h80c8.832 0 16-7.168 16-16s-7.168-16-16-16h-32c-8.928 0-16.032-7.328-16-16.288 0.16-61.6 50.336-111.712 112-111.712h48c19.296 0 48-12.768 48-48 0-5.696-0.736-10.784-2.080-15.328 72.896 7.008 130.080 68.64 130.080 143.328v32c0 8.832-7.168 16-16 16h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h80c53.024 0 96 42.976 96 96v64c0 17.664-14.336 32-32 32h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h48c70.688 0 128 57.312 128 128v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"smell",
						"stink",
						"poop"
					],
					"grid": 32
				},
				{
					"id": 814,
					"width": 1024,
					"paths": [
						"M821.92 642.208c6.304-9.92 10.080-21.6 10.080-34.208v-64c0-66.368-50.688-120.288-115.36-126.72 2.080-5.376 3.36-11.168 3.36-17.28v-32c0-97.216-78.784-176-176-176h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h15.808c7.392 0.192 16.192 3.104 16.192 16s-8.8 15.808-16 16h-48c-29.888 0-57.664 9.184-80.704 24.832-2.88-25.536-20.608-46.336-44.48-53.696 18.88-30.24 45.184-76.448 45.184-99.136 0-35.36-28.64-64-64-64-35.328 0-64 28.64-64 64 0 22.688 26.304 68.896 45.216 99.136-20.128 6.208-35.84 21.952-42.080 42.080-30.24-18.912-76.448-45.216-99.136-45.216-35.328 0-64 28.64-64 64s28.64 64 64 64c22.688 0 68.896-26.304 99.136-45.216 8.064 26.112 32.096 45.216 60.864 45.216 3.136 0 6.112-0.48 9.12-0.928-5.568 15.36-9.12 31.68-9.12 48.928 0 5.632 1.152 10.976 2.944 16h-2.944c-70.688 0-128 57.312-128 128v64c0 12.608 3.776 24.288 10.080 34.208-77.888 10.784-138.080 76.928-138.080 157.792v32c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-32c0-80.864-60.192-147.008-138.080-157.792zM448 416c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM608 704c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM688 608c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"smell",
						"stink",
						"poop"
					],
					"grid": 32
				},
				{
					"id": 1132,
					"width": 1024,
					"paths": [
						"M909.792 488.736c-18.912-211.488-187.008-376.32-397.792-391.584v-65.152h-192v64h-32v64h32v32h-64v96.352c-154.016 64.256-256 215.648-256 383.648 0 96.608 33.984 190.176 96 264.928v55.072h640v-55.072c23.392-28.224 42.816-59.232 58.016-92.576 21.696 12.832 45.568 19.648 69.984 19.648 88.224 0 160-86.112 160-192 0-85.504-47.584-159.456-114.208-183.264zM480 160c198.688 0 359.744 155.456 367.232 354.112-11.232 1.856-22.112 4.896-32.224 10.144-10.048-179.552-154.944-323.296-335.008-331.456v-32.8zM784 544v4.032c-1.12 1.184-2.272 2.272-3.36 3.488-37.248-112.416-125.152-201.728-236.64-241.184v-75.84c137.952 35.584 240 160.448 240 309.504zM384 96h64v128h-64v-128zM320 256h192v64h-192v-64zM749.856 781.984c-15.104 45.408-38.624 86.464-69.888 121.984l-7.968 9.088v14.944h-512v-14.944l-7.968-9.056c-14.816-16.832-27.776-34.912-39.008-53.888-31.84-53.824-49.024-115.2-49.024-178.112 0-138.336 81.824-263.296 206.432-320h289.92c98.208 44.32 170.144 130.592 196.48 232.96 0 0 0 0 0 0-13.088 25.056-20.832 54.88-20.832 87.040 0 32.512 7.872 62.656 21.184 87.904l-7.328 22.080zM864 800c-52.928 0-96-57.408-96-128s43.072-128 96-128c52.928 0 96 57.408 96 128s-43.072 128-96 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"smell",
						"spray",
						"squirt"
					],
					"grid": 32
				},
				{
					"id": 2841,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM256 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM640 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM704.098 627.26l82.328 49.396c-55.962 93.070-157.916 155.344-274.426 155.344s-218.464-62.274-274.426-155.344l82.328-49.396c39.174 65.148 110.542 108.74 192.098 108.74s152.924-43.592 192.098-108.74z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"smile",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60676,
					"grid": 16
				},
				{
					"id": 1428,
					"width": 877.7139282226562,
					"paths": [
						"M648 614.286q-21.143 69.143-78.857 111.429t-130.286 42.286-130.286-42.286-78.857-111.429q-4.571-14.286 2.286-27.714t21.714-18q14.286-4.571 27.714 2.286t18 21.714q14.286 45.714 52.857 74t86.571 28.286 86.571-28.286 52.857-74q4.571-14.857 18.286-21.714t28-2.286 21.143 18 2.286 27.714zM365.714 365.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM658.286 365.714q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM804.571 512q0-74.286-29.143-142t-78-116.571-116.571-78-142-29.143-142 29.143-116.571 78-78 116.571-29.143 142 29.143 142 78 116.571 116.571 78 142 29.143 142-29.143 116.571-78 78-116.571 29.143-142zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"smile-o"
					],
					"defaultCode": 61720,
					"grid": 14
				},
				{
					"id": 2842,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM704 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM320 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM512 832c-116.51 0-218.464-62.274-274.426-155.344l82.328-49.396c39.174 65.148 110.542 108.74 192.098 108.74s152.924-43.592 192.098-108.74l82.328 49.396c-55.962 93.070-157.916 155.344-274.426 155.344z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"smile",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60677,
					"grid": 16
				},
				{
					"id": 179,
					"paths": [
						"M486.4 1024c-129.922 0-252.067-50.594-343.936-142.464s-142.464-214.014-142.464-343.936c0-129.923 50.595-252.067 142.464-343.936s214.013-142.464 343.936-142.464c129.922 0 252.067 50.595 343.936 142.464s142.464 214.014 142.464 343.936-50.594 252.067-142.464 343.936c-91.869 91.87-214.014 142.464-343.936 142.464zM486.4 102.4c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2 435.2-195.23 435.2-435.2-195.23-435.2-435.2-435.2z",
						"M332.8 409.6c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.453 76.8-76.8 76.8zM332.8 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M640 409.6c-42.349 0-76.8-34.453-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.451 76.8-76.8 76.8zM640 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M486.4 870.4c-183.506 0-332.8-149.294-332.8-332.8 0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6c0 155.275 126.325 281.6 281.6 281.6s281.6-126.325 281.6-281.6c0-14.139 11.461-25.6 25.6-25.6s25.6 11.461 25.6 25.6c0 183.506-149.294 332.8-332.8 332.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"smile",
						"emoticon"
					],
					"defaultCode": 59476,
					"grid": 20
				},
				{
					"id": 1804,
					"width": 877.7139282226562,
					"paths": [
						"M730.857 656q0-12.571-12.571-15.429-38.286-8.571-67.429-33.714t-45.714-61.714q-4-10.857-4-14.286 0-8.571 11.143-14.857t24.571-9.714 24.571-11.714 11.143-20.857q0-10.857-10.571-18t-22-7.143q-6.857 0-18.286 4.571t-17.714 4.571q-2.286 0-6.857-1.143 2.857-54.286 2.857-65.143 0-45.143-9.714-65.143-20.571-44.571-58.857-69.429t-86.857-24.857q-113.714 0-157.143 94.286-9.714 20-9.714 65.143 0 10.857 2.857 65.143-2.286 1.143-8 1.143-6.857 0-18.286-4.286t-17.143-4.286q-12 0-22 6.857t-10 18.286q0 12 11.143 20.286t24.571 11.714 24.571 9.714 11.143 14.857q0 3.429-4 14.286-36.571 78.857-113.143 95.429-12.571 2.857-12.571 15.429 0 26.286 78.286 38.857 1.143 2.857 3.429 14.857t6.571 17.429 13.429 5.429q6.857 0 21.429-2.571t22.571-2.571q20 0 38.286 8.571t30.857 18.571 32.857 18.571 43.714 8.571q24.571 0 45.143-8.571t32.857-18.571 30.571-18.571 38.286-8.571q8 0 22.571 2.286t22 2.286q9.143 0 13.143-5.714t6.286-17.143 3.429-14.286q78.286-12.571 78.286-38.857zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"snapchat"
					],
					"defaultCode": 62123,
					"grid": 14
				},
				{
					"id": 1805,
					"width": 950.8528900146484,
					"paths": [
						"M484.571 73.143q76.571-0.571 137.429 39.143t93.429 110q15.429 33.143 15.429 102.286 0 26.857-5.143 109.143 8 4 16 4 10.286 0 29.143-7.714t29.143-7.714q16.571 0 32 10.286t15.429 26.286q0 18.286-18 30.857t-39.429 18-39.429 16.571-18 27.143q0 8.571 6.857 24.571 21.143 46.857 58.571 85.714t82.571 57.714q16 6.857 45.714 13.143 16 3.429 16 20 0 40-125.143 58.857-4 6.286-6.286 22.286t-8 26.571-18.857 10.571q-11.429 0-35.429-3.714t-36.571-3.714q-21.143 0-35.429 2.857-18.286 2.857-36 12.857t-33.143 21.714-33.143 23.143-43.429 19.143-56.571 7.714q-29.714 0-55.143-7.714t-42.857-19.143-32.857-23.143-33.143-21.714-35.429-12.857q-14.857-2.857-36-2.857-13.714 0-37.429 4.286t-33.429 4.286q-14.286 0-20-10.571t-8-27.143-6.286-22.857q-125.143-18.857-125.143-58.857 0-16.571 16-20 29.714-6.286 45.714-13.143 44.571-18.286 82.571-57.714t58.571-85.714q6.857-16 6.857-24.571 0-16-18-27.143t-39.714-16.857-39.714-18-18-30q0-15.429 14.857-26t31.429-10.571q8.571 0 27.429 7.429t30.286 7.429q10.286 0 18.286-4-5.143-81.143-5.143-108.571 0-69.714 15.429-102.857 36.571-78.286 98.286-113.143t150.857-36z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"snapchat-ghost"
					],
					"defaultCode": 62124,
					"grid": 14
				},
				{
					"id": 1806,
					"width": 877.7129821777344,
					"paths": [
						"M731.429 656q0-12.571-12.571-15.429-38.286-8-67.429-33.143t-45.714-62.286q-4-8-4-14.286 0-8.571 11.143-14.857t24.286-9.714 24.286-11.714 11.143-20.857q0-10.857-10.571-18t-22-7.143q-6.286 0-17.714 4.571t-18.286 4.571q-2.286 0-6.857-1.143 2.857-36 2.857-65.714 0-44.571-9.714-65.143-20.571-44.571-58.571-69.429t-87.143-24.857q-113.143 0-157.143 94.286-10.286 21.714-10.286 65.714 0 21.714 3.429 65.143-5.714 1.143-8.571 1.143-6.286 0-18-4.571t-17.429-4.571q-11.429 0-21.429 7.143t-10 18.571q0 12 11.143 20.286t24.286 11.714 24.286 9.714 11.143 14.857q0 6.286-4 14.286-36.571 78.857-113.143 95.429-12.571 2.857-12.571 15.429 0 26.857 78.857 39.429 1.143 2.857 3.429 14.857t6.286 17.429 13.143 5.429q7.429 0 22-2.857t22-2.857q20 0 38.571 8.571t31.143 18.571 32.857 18.571 43.714 8.571q24.571 0 45.143-8.571t32.857-18.571 30.857-18.571 38.571-8.571q7.429 0 22.286 2.571t22.286 2.571q8.571 0 12.857-5.429t6.571-17.714 2.857-14q78.857-12.571 78.857-39.429zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"snapchat-square"
					],
					"defaultCode": 62125,
					"grid": 14
				},
				{
					"id": 815,
					"width": 1024,
					"paths": [
						"M916.512 571.616l-118.336 31.712-158.176-91.328 158.176-91.328 118.336 31.712c17.056 4.576 34.624-5.568 39.2-22.624l16.576-61.824c4.576-17.056-5.568-34.624-22.624-39.2l-82.144-21.984 22.016-82.144c4.576-17.056-5.568-34.624-22.624-39.2l-61.824-16.576c-17.056-4.576-34.624 5.568-39.2 22.624l-31.712 118.336-158.176 91.36v-182.656l86.624-86.624c12.48-12.512 12.48-32.768 0-45.248l-45.248-45.248c-12.48-12.48-32.768-12.512-45.248 0l-60.128 60.096-60.128-60.096c-12.512-12.48-32.768-12.48-45.248 0l-45.248 45.248c-12.512 12.512-12.512 32.768 0 45.248l86.624 86.624v182.656l-158.176-91.328-31.712-118.336c-4.576-17.088-22.112-27.2-39.2-22.624l-61.792 16.544c-17.088 4.576-27.2 22.144-22.624 39.2l21.984 82.144-82.112 22.016c-17.056 4.576-27.2 22.112-22.624 39.2l16.576 61.824c4.576 17.056 22.112 27.2 39.2 22.624l118.336-31.712 158.144 91.296-158.176 91.328-118.336-31.712c-17.056-4.576-34.624 5.568-39.2 22.624l-16.576 61.824c-4.576 17.056 5.568 34.624 22.624 39.2l82.112 22.016-22.016 82.144c-4.576 17.056 5.568 34.624 22.624 39.2l61.824 16.576c17.056 4.576 34.624-5.568 39.2-22.624l31.712-118.336 158.208-91.392v182.656l-86.624 86.624c-12.48 12.512-12.48 32.768 0 45.248l45.248 45.248c12.48 12.48 32.768 12.512 45.248 0l60.128-60.096 60.128 60.096c12.512 12.48 32.768 12.48 45.248 0l45.248-45.248c12.512-12.512 12.512-32.768 0-45.248l-86.624-86.624v-182.656l158.176 91.328 31.712 118.336c4.576 17.056 22.112 27.2 39.2 22.624l61.824-16.576c17.056-4.576 27.2-22.112 22.624-39.2l-22.016-82.144 82.112-22.016c17.056-4.576 27.2-22.112 22.624-39.2l-16.576-61.824c-4.544-17.024-22.112-27.136-39.168-22.56zM836.608 725.536l22.016 82.144-61.824 16.544-35.168-131.136-217.632-125.664v251.328l96 96-45.248 45.248-60.128-60.096c-12.512-12.48-32.768-12.48-45.248 0l-60.128 60.096-45.248-45.248 96-96v-251.328l-217.632 125.664-35.168 131.136-61.792-16.544 22.016-82.144c4.576-17.056-5.568-34.624-22.624-39.2l-82.144-22.016 16.544-61.792 131.136 35.136 217.664-125.664-217.664-125.664-131.136 35.136-16.544-61.792 82.112-22.016c17.056-4.576 27.2-22.112 22.624-39.2l-21.984-82.144 61.792-16.544 35.168 131.136 217.632 125.664v-251.328l-96-96 45.248-45.248 60.128 60.096c12.512 12.48 32.768 12.48 45.248 0l60.128-60.096 45.248 45.248-96 96v251.328l217.632-125.664 35.168-131.136 61.824 16.576-22.016 82.144c-4.576 17.056 5.568 34.624 22.624 39.2l82.112 22.016-16.544 61.76-131.136-35.136-217.664 125.664 217.664 125.664 131.136-35.136 16.576 61.824-82.112 22.016c-17.088 4.544-27.232 22.080-22.656 39.168z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"snow",
						"fall"
					],
					"grid": 32
				},
				{
					"id": 816,
					"width": 1024,
					"paths": [
						"M916.512 571.616l-118.336 31.712-158.176-91.328 158.176-91.328 118.336 31.712c17.056 4.576 34.624-5.568 39.2-22.624l16.576-61.824c4.576-17.056-5.568-34.624-22.624-39.2l-82.144-21.984 22.016-82.144c4.576-17.056-5.568-34.624-22.624-39.2l-61.824-16.576c-17.056-4.576-34.624 5.568-39.2 22.624l-31.712 118.336-158.176 91.36v-182.656l86.624-86.624c12.48-12.512 12.48-32.768 0-45.248l-45.248-45.248c-12.48-12.48-32.768-12.512-45.248 0l-60.128 60.096-60.128-60.096c-12.512-12.48-32.768-12.48-45.248 0l-45.248 45.248c-12.512 12.512-12.512 32.768 0 45.248l86.624 86.624v182.656l-158.176-91.328-31.712-118.336c-4.576-17.088-22.112-27.2-39.2-22.624l-61.792 16.544c-17.088 4.576-27.2 22.144-22.624 39.2l21.984 82.144-82.112 22.016c-17.056 4.576-27.2 22.112-22.624 39.2l16.576 61.824c4.576 17.056 22.112 27.2 39.2 22.624l118.336-31.712 158.144 91.296-158.176 91.328-118.336-31.712c-17.056-4.576-34.624 5.568-39.2 22.624l-16.576 61.824c-4.576 17.056 5.568 34.624 22.624 39.2l82.112 22.016-22.016 82.144c-4.576 17.056 5.568 34.624 22.624 39.2l61.824 16.576c17.056 4.576 34.624-5.568 39.2-22.624l31.712-118.336 158.208-91.392v182.656l-86.624 86.624c-12.48 12.512-12.48 32.768 0 45.248l45.248 45.248c12.48 12.48 32.768 12.512 45.248 0l60.128-60.096 60.128 60.096c12.512 12.48 32.768 12.48 45.248 0l45.248-45.248c12.512-12.512 12.512-32.768 0-45.248l-86.624-86.624v-182.656l158.176 91.328 31.712 118.336c4.576 17.056 22.112 27.2 39.2 22.624l61.824-16.576c17.056-4.576 27.2-22.112 22.624-39.2l-22.016-82.144 82.112-22.016c17.056-4.576 27.2-22.112 22.624-39.2l-16.576-61.824c-4.544-17.024-22.112-27.136-39.168-22.56z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"snow",
						"fall"
					],
					"grid": 32
				},
				{
					"id": 1133,
					"width": 1024,
					"paths": [
						"M992 832v-32c0-17.696-14.336-32-32-32v-256c0-247.040-200.96-448-448-448s-448 200.96-448 448v256c-17.664 0-32 14.304-32 32v32c-17.664 0-32 14.304-32 32v128c0 17.696 14.336 32 32 32h960c17.664 0 32-14.304 32-32v-128c0-17.696-14.336-32-32-32zM128 512c0-211.744 172.256-384 384-384s384 172.256 384 384v224h-256v-160l-128-96-128 96v160h-256v-224zM928 864h-832v-32h832v32zM608 592v144h-192v-144l96-72 96 72zM128 768h768v32h-768v-32zM960 960h-896v-64h896v64zM384 224h-32v-32h32v32zM352 320h-32v-32h32v32zM320 416h-32v-32h32v32zM288 512h-32v-32h32v32zM224 576h32v32h-32v-32zM192 672h32v32h-32v-32zM256 352h-32v-32h32v32zM224 448h-32v-32h32v32zM192 544h-32v-32h32v32zM480 192h-32v-32h32v32zM448 288h-32v-32h32v32zM384 352h32v32h-32v-32zM352 448h32v32h-32v-32zM320 544h32v32h-32v-32zM288 640h32v32h-32v-32zM544 256h-32v-32h32v32zM480 320h32v32h-32v-32zM448 416h32v32h-32v-32zM640 224h-32v-32h32v32zM608 320h-32v-32h32v32zM544 384h32v32h-32v-32zM704 288h-32v-32h32v32zM640 352h32v32h-32v-32zM608 448h32v32h-32v-32zM768 352h-32v-32h32v32zM704 416h32v32h-32v-32zM704 544h-32v-32h32v32zM832 416h-32v-32h32v32zM768 480h32v32h-32v-32zM736 576h32v32h-32v-32zM704 672h32v32h-32v-32zM832 544h32v32h-32v-32zM800 640h32v32h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"snow",
						"travel",
						"shake"
					],
					"grid": 32
				},
				{
					"id": 2770,
					"paths": [
						"M979.846 725.668l-110.52-63.804 95.954-55.218-48.448-84.182-144.712 83.276-162.992-94.106 162.356-93.738 145.348 83.642 48.448-84.184-96.584-55.58 110.832-63.988-48.564-84.116-110.512 63.802 0.154-110.7-97.126-0.136-0.242 166.962-162.992 94.102v-187.478l145.112-84.050-48.682-84.046-96.43 55.854v-127.98h-97.128v127.614l-95.794-55.488-48.68 84.046 144.474 83.688v188.206l-162.358-93.736-0.238-167.694-97.126 0.136 0.158 111.436-110.832-63.99-48.568 84.116 110.516 63.806-95.95 55.214 48.45 84.184 144.708-83.278 162.998 94.106-162.362 93.74-145.344-83.642-48.45 84.182 96.582 55.58-110.83 63.988 48.564 84.118 110.514-63.804-0.154 110.702 97.126 0.136 0.238-166.964 162.994-94.106v187.482l-145.11 84.046 48.68 84.052 96.43-55.856v127.98h97.128v-127.612l95.794 55.488 48.682-84.052-144.476-83.684v-188.202l162.356 93.734 0.242 167.694 97.126-0.136-0.156-111.434 110.834 63.994z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"snowflake",
						"weather",
						"winter"
					],
					"defaultCode": 60605,
					"grid": 16
				},
				{
					"id": 2636,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 864c-27.458 0-54.43-3.146-80.524-9.222l-61.728-119.726 68.010-93.608h148.484l68.010 93.608-61.728 119.726c-26.094 6.076-53.066 9.222-80.524 9.222zM375.588 187.318l120.412 60.626v115.68l-120.204 87.332-109.978-35.734-20.424-133.088c5.642-6.524 11.542-12.874 17.704-19.036 32.812-32.81 70.964-58.33 112.49-75.78zM760.902 263.098c6.16 6.16 12.060 12.51 17.704 19.034l-20.424 133.090-109.976 35.734-120.206-87.332v-115.68l120.412-60.626c41.528 17.45 79.68 42.97 112.49 75.78zM255.896 445.646l110.058 35.76 45.896 141.252-67.98 93.566-133.002-21.72c-28.168-46.29-45.18-98.492-49.656-153.26l94.684-95.598zM813.13 694.504l-133.002 21.72-67.98-93.566 45.896-141.252 110.058-35.76 94.684 95.598c-4.476 54.768-21.488 106.972-49.656 153.26zM851.41 172.588c27.354 27.352 51.050 57.498 70.878 90.084l-116.982 1.51c-39.708-46.95-90.474-84.23-148.292-107.828l-34.682-111.622c26.064 6.134 51.61 14.448 76.494 24.972 57.156 24.178 108.492 58.792 152.584 102.884zM172.588 172.588c44.092-44.092 95.428-78.708 152.584-102.88 24.884-10.526 50.43-18.838 76.494-24.972l-34.68 111.622c-57.816 23.6-108.584 60.878-148.292 107.828l-116.982-1.512c19.828-32.588 43.524-62.732 70.876-90.086zM32 512c0-13.218 0.556-26.348 1.608-39.39l95.418 67.46c4.602 63.684 24.74 123.050 56.632 174.356l-37.536 110.636c-32.596-37.792-58.91-80.116-78.416-126.234-25.020-59.156-37.706-122.014-37.706-186.828zM326.608 954.878l93.682-69.93c29.39 7.204 60.098 11.052 91.71 11.052s62.318-3.848 91.708-11.050l93.684 69.93c-58.738 24.62-121.1 37.12-185.392 37.12s-126.654-12.5-185.392-37.122zM954.292 698.828c-19.508 46.118-45.82 88.442-78.416 126.234l-37.536-110.636c31.892-51.306 52.032-110.674 56.632-174.356l95.416-67.458c1.056 13.040 1.612 26.17 1.612 39.388 0 64.814-12.688 127.672-37.708 186.828z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"soccer",
						"sports",
						"football",
						"ball",
						"game"
					],
					"defaultCode": 60471,
					"grid": 16
				},
				{
					"id": 2350,
					"paths": [
						"M814.652 590.262l-270.676-101.502c-58.844-22.070-75.472-43.666-83.98-61.88-11.996-25.692-11.996-57.99-11.996-106.88v-288c0-17.672-14.328-32-32-32h-384c-17.672 0-32 14.328-32 32v576c0 92.85 58.412 177.136 145.348 209.738l512 192c25.342 9.504 51.792 14.322 78.62 14.322 92.858-0.002 177.158-58.438 209.772-145.408 43.366-115.65-15.438-245.022-131.088-288.39zM320 64h64v64h-64v-64zM192 64h64v64h-64v-64zM64 64h64v64h-64v-64zM307.414 810.16c8.144-23.208 12.586-48.154 12.586-74.144 0-123.704-100.282-223.986-223.984-223.986-10.872 0-21.558 0.786-32.016 2.282v-322.312h320v128c0 53.296 0 95.394 18.008 133.958 19.542 41.844 56.394 71.060 119.496 94.726l270.676 101.504c21.896 8.21 40.904 20.77 56.492 36.288-84.554 32.026-144.672 113.746-144.672 209.524 0 21.632 3.082 42.542 8.806 62.328-11.188-1.652-22.222-4.478-32.986-8.516l-372.406-139.652z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sock",
						"footwear"
					],
					"defaultCode": 60185,
					"grid": 16
				},
				{
					"id": 817,
					"width": 1024,
					"paths": [
						"M704 512c17.92 0 35.2 7.776 47.392 21.376 6.080 6.752 14.72 10.624 23.808 10.624h88.8c17.664 0 32-14.336 32-32v-96c0-52.928-43.072-96-96-96h-224v-49.6c39.040-22.592 64-64.512 64-110.4 0-70.592-57.408-128-128-128s-128 57.408-128 128c0 45.888 24.96 87.808 64 110.4v49.6h-224c-52.928 0-96 43.072-96 96v96c0 17.664 14.336 32 32 32h88.8c9.088 0 17.76-3.872 23.808-10.624 12.192-13.6 29.472-21.376 47.392-21.376 35.296 0 64 28.704 64 64s-28.704 64-64 64c-17.92 0-35.2-7.776-47.392-21.376-6.080-6.752-14.72-10.624-23.808-10.624h-88.8c-17.664 0-32 14.336-32 32v224c0 52.928 43.072 96 96 96h224c17.664 0 32-14.336 32-32v-88.8c0-9.088-3.872-17.76-10.624-23.808-13.6-12.192-21.376-29.472-21.376-47.392 0-35.296 28.704-64 64-64s64 28.704 64 64c0 17.92-7.776 35.2-21.376 47.392-6.752 6.048-10.624 14.72-10.624 23.808v88.8c0 17.664 14.336 32 32 32h224c52.928 0 96-43.072 96-96v-224c0-17.664-14.336-32-32-32h-88.8c-9.088 0-17.76 3.872-23.808 10.624-12.192 13.6-29.472 21.376-47.392 21.376-35.296 0-64-28.704-64-64s28.704-64 64-64zM704 672c27.296 0 53.184-11.904 71.2-32h88.8v224c0 35.296-28.704 64-64 64h-224v-88.8c20.096-18.016 32-43.904 32-71.2 0-52.928-43.072-96-96-96s-96 43.072-96 96c0 27.296 11.904 53.184 32 71.2v88.8h-224c-35.296 0-64-28.704-64-64v-224h88.8c18.016 20.096 43.904 32 71.2 32 52.928 0 96-43.072 96-96s-43.072-96-96-96c-27.296 0-53.184 11.904-71.2 32h-88.8v-96c0-35.296 28.704-64 64-64h256v-101.888c-37.152-13.28-64-48.448-64-90.112 0-52.928 43.072-96 96-96s96 43.072 96 96c0 41.664-26.848 76.832-64 90.112v101.888h256c35.296 0 64 28.704 64 64v96h-88.8c-18.016-20.096-43.904-32-71.2-32-52.928 0-96 43.072-96 96s43.072 96 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"solve",
						"think",
						"puzzle"
					],
					"grid": 32
				},
				{
					"id": 818,
					"width": 1024,
					"paths": [
						"M704 512c17.92 0 35.2 7.776 47.392 21.376 6.080 6.752 14.72 10.624 23.808 10.624h88.8c17.664 0 32-14.336 32-32v-96c0-52.928-43.072-96-96-96h-224v-49.6c39.040-22.592 64-64.512 64-110.4 0-70.592-57.408-128-128-128s-128 57.408-128 128c0 45.888 24.96 87.808 64 110.4v49.6h-224c-52.928 0-96 43.072-96 96v96c0 17.664 14.336 32 32 32h88.8c9.088 0 17.76-3.872 23.808-10.624 12.192-13.6 29.472-21.376 47.392-21.376 35.296 0 64 28.704 64 64s-28.704 64-64 64c-17.92 0-35.2-7.776-47.392-21.376-6.080-6.752-14.72-10.624-23.808-10.624h-88.8c-17.664 0-32 14.336-32 32v224c0 52.928 43.072 96 96 96h224c17.664 0 32-14.336 32-32v-88.8c0-9.088-3.872-17.76-10.624-23.808-13.6-12.192-21.376-29.472-21.376-47.392 0-35.296 28.704-64 64-64s64 28.704 64 64c0 17.92-7.776 35.2-21.376 47.392-6.752 6.048-10.624 14.72-10.624 23.808v88.8c0 17.664 14.336 32 32 32h224c52.928 0 96-43.072 96-96v-224c0-17.664-14.336-32-32-32h-88.8c-9.088 0-17.76 3.872-23.808 10.624-12.192 13.6-29.472 21.376-47.392 21.376-35.296 0-64-28.704-64-64s28.704-64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"solve",
						"think",
						"puzzle"
					],
					"grid": 32
				},
				{
					"id": 1134,
					"width": 1024,
					"paths": [
						"M960 32h-896c-17.696 0-32 14.336-32 32v896c0 17.664 14.304 32 32 32h896c17.696 0 32-14.336 32-32v-896c0-17.664-14.304-32-32-32zM96 96h416v192h93.92l8.96-17.248c5.376-10.336 12.896-14.752 25.12-14.752 21.248 0 32 16.16 32 48s-10.752 48-32 48c-12.224 0-19.744-4.416-25.12-14.752l-8.96-17.248h-93.92v192h-192v-42.496c19.328-10.048 32-27.424 32-53.504 0-44.192-35.808-64-80-64s-80 19.808-80 64c0 26.080 12.672 43.488 32 53.504v42.496h-128v-416zM512 928h-416v-384h160v-93.92l-17.248-8.96c-10.336-5.376-14.752-12.896-14.752-25.12 0-21.248 16.16-32 48-32s48 10.752 48 32c0 12.224-4.416 19.744-14.752 25.12l-17.248 8.96v93.92h224v160h-42.496c-7.552-14.592-22.976-32-53.504-32-15.008 0-64 5.76-64 80s48.992 80 64 80c30.528 0 45.952-17.408 53.504-32h42.496v128zM928 928h-384v-160h-93.952l-8.96 17.28c-5.344 10.304-12.864 14.72-25.088 14.72-21.216 0-32-16.16-32-48s10.784-48 32-48c12.224 0 19.744 4.416 25.088 14.72l8.96 17.28h93.952v-192h160v42.496c-19.328 10.048-32 27.424-32 53.504 0 44.192 35.808 64 80 64s80-19.808 80-64c0-26.080-12.672-43.488-32-53.504v-42.496h128v384zM928 512h-160v93.92l17.248 8.96c10.336 5.376 14.752 12.896 14.752 25.12 0 21.248-16.16 32-48 32s-48-10.752-48-32c0-12.224 4.416-19.744 14.752-25.12l17.248-8.96v-93.92h-192v-160h42.496c10.048 19.328 27.424 32 53.504 32 44.192 0 64-35.808 64-80s-19.808-80-64-80c-26.080 0-43.488 12.672-53.504 32h-42.496v-160h384v416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"solve",
						"play",
						"think",
						"ponder",
						"puzzle"
					],
					"grid": 32
				},
				{
					"id": 3165,
					"paths": [
						"M384 256v704h-128v-704h-160l224-224 224 224zM640 768v-704h128v704h160l-224 224-224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort",
						"arrows",
						"arrange"
					],
					"defaultCode": 61000,
					"grid": 16
				},
				{
					"id": 3169,
					"paths": [
						"M320 768v-768h-128v768h-160l224 224 224-224h-160z",
						"M928 1024h-256c-11.8 0-22.644-6.496-28.214-16.9-5.566-10.404-4.958-23.030 1.59-32.85l222.832-334.25h-196.208c-17.672 0-32-14.328-32-32s14.328-32 32-32h256c11.8 0 22.644 6.496 28.214 16.9 5.566 10.404 4.958 23.030-1.59 32.85l-222.83 334.25h196.206c17.672 0 32 14.328 32 32s-14.328 32-32 32z",
						"M1020.622 401.686l-192.002-384c-5.42-10.842-16.502-17.69-28.622-17.69-12.122 0-23.202 6.848-28.624 17.69l-191.996 384c-7.904 15.806-1.496 35.030 14.31 42.932 4.594 2.296 9.476 3.386 14.288 3.386 11.736 0 23.040-6.484 28.644-17.698l55.156-110.31h216.446l55.156 110.31c7.902 15.806 27.124 22.21 42.932 14.31 15.808-7.902 22.216-27.124 14.312-42.93zM723.778 255.996l76.22-152.446 76.224 152.446h-152.444z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-alpha-asc",
						"arrange",
						"alphabetic"
					],
					"defaultCode": 61004,
					"grid": 16
				},
				{
					"id": 1493,
					"width": 964.0010967254639,
					"paths": [
						"M680.571 233.143h101.143l-41.143-124.571-6.857-26.857q-1.143-9.143-1.143-11.429h-2.286l-1.714 11.429q0 0.571-2 10.286t-4.286 16.571zM420.571 822.857q0 6.857-5.714 13.714l-182.286 182.286q-5.714 5.143-13.143 5.143-6.857 0-13.143-5.143l-182.857-182.857q-8.571-9.143-4-20 4.571-11.429 17.143-11.429h109.714v-786.286q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v786.286h109.714q8 0 13.143 5.143t5.143 13.143zM898.286 890.857v133.143h-333.714v-51.429l210.857-302.286q6.857-10.286 12-15.429l6.286-5.143v-1.714q-1.143 0-3.714 0.286t-4.286 0.286q-6.857 1.714-17.143 1.714h-132.571v65.714h-68.571v-130.857h324v50.857l-210.857 302.857q-3.429 4.571-12 14.857l-6.286 6.286v1.143l8-1.143q5.143-1.143 17.143-1.143h141.714v-68h69.143zM949.143 378.286v60.571h-164.571v-60.571h42.857l-26.857-82.286h-138.857l-26.857 82.286h42.857v60.571h-164v-60.571h40l131.429-378.286h92.571l131.429 378.286h40z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-alpha-asc"
					],
					"defaultCode": 61789,
					"grid": 14
				},
				{
					"id": 258,
					"paths": [
						"M453.301 749.899c-9.997-9.997-26.206-9.997-36.203 0l-161.098 161.098v-885.397c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v885.397l-161.099-161.098c-9.997-9.997-26.206-9.997-36.203 0s-9.998 26.206 0 36.203l204.8 204.8c5 4.998 11.55 7.498 18.102 7.498s13.102-2.499 18.101-7.499l204.8-204.8c9.998-9.997 9.998-26.205 0-36.202z",
						"M1021.93 373.915l-153.6-358.4c-4.032-9.413-13.29-15.515-23.53-15.515s-19.498 6.102-23.53 15.515l-153.6 358.4c-5.57 12.995 0.45 28.045 13.445 33.614 13 5.57 28.045-0.451 33.614-13.446l59.179-138.083h141.781l59.179 138.085c4.16 9.707 13.61 15.523 23.542 15.522 3.365 0 6.784-0.667 10.072-2.075 12.997-5.57 19.018-20.621 13.446-33.616zM795.851 204.8l48.949-114.211 48.949 114.211h-97.898z",
						"M947.2 1024h-204.8c-9.125 0-17.562-4.858-22.142-12.75-4.579-7.894-4.613-17.629-0.085-25.552l182.914-320.098h-160.686c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h204.8c9.125 0 17.562 4.858 22.142 12.75 4.579 7.894 4.613 17.629 0.085 25.552l-182.914 320.098h160.686c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-alpha-asc",
						"sort",
						"arrange",
						"alphabetic"
					],
					"defaultCode": 59555,
					"grid": 20
				},
				{
					"id": 3170,
					"paths": [
						"M320 768v-768h-128v768h-160l224 224 224-224h-160z",
						"M928 448h-256c-11.8 0-22.644-6.496-28.214-16.9-5.566-10.406-4.958-23.030 1.59-32.85l222.832-334.25h-196.208c-17.672 0-32-14.328-32-32s14.328-32 32-32h256c11.8 0 22.644 6.496 28.214 16.9 5.566 10.406 4.958 23.030-1.59 32.85l-222.83 334.25h196.206c17.672 0 32 14.328 32 32s-14.328 32-32 32z",
						"M1020.622 977.69l-192.002-384c-5.42-10.842-16.502-17.69-28.622-17.69-12.122 0-23.202 6.848-28.624 17.69l-191.996 384c-7.904 15.806-1.496 35.030 14.31 42.932 4.594 2.296 9.476 3.386 14.288 3.386 11.736 0 23.040-6.484 28.644-17.698l55.158-110.31h216.446l55.156 110.31c7.902 15.806 27.124 22.21 42.932 14.31 15.806-7.902 22.214-27.124 14.31-42.93zM723.778 832l76.22-152.446 76.226 152.446h-152.446z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-alpha-desc",
						"arrange",
						"alphabetic"
					],
					"defaultCode": 61005,
					"grid": 16
				},
				{
					"id": 1494,
					"width": 964.0010967254639,
					"paths": [
						"M680.571 818.286h101.143l-41.143-124.571-6.857-26.857q-1.143-9.143-1.143-11.429h-2.286l-1.714 11.429q0 0.571-2 10.286t-4.286 16.571zM420.571 822.857q0 6.857-5.714 13.714l-182.286 182.286q-5.714 5.143-13.143 5.143-6.857 0-13.143-5.143l-182.857-182.857q-8.571-9.143-4-20 4.571-11.429 17.143-11.429h109.714v-786.286q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v786.286h109.714q8 0 13.143 5.143t5.143 13.143zM949.143 963.429v60.571h-164.571v-60.571h42.857l-26.857-82.286h-138.857l-26.857 82.286h42.857v60.571h-164v-60.571h40l131.429-378.286h92.571l131.429 378.286h40zM898.286 305.714v133.143h-333.714v-51.429l210.857-302.286q6.857-10.286 12-15.429l6.286-5.143v-1.714q-1.143 0-3.714 0.286t-4.286 0.286q-6.857 1.714-17.143 1.714h-132.571v65.714h-68.571v-130.857h324v50.857l-210.857 302.857q-3.429 4.571-12 14.857l-6.286 5.714v1.714l8-1.714q5.143-0.571 17.143-0.571h141.714v-68h69.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-alpha-desc"
					],
					"defaultCode": 61790,
					"grid": 14
				},
				{
					"id": 3173,
					"paths": [
						"M320 768v-768h-128v768h-160l224 224 224-224h-160z",
						"M448 576h576v128h-576v-128z",
						"M448 384h448v128h-448v-128z",
						"M448 192h320v128h-320v-128z",
						"M448 0h192v128h-192v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-amount-asc",
						"arrange"
					],
					"defaultCode": 61008,
					"grid": 16
				},
				{
					"id": 1495,
					"width": 1038.8570537567139,
					"paths": [
						"M420.571 822.857q0 6.857-5.714 13.714l-182.286 182.286q-5.714 5.143-13.143 5.143-6.857 0-13.143-5.143l-182.857-182.857q-8.571-9.143-4-20 4.571-11.429 17.143-11.429h109.714v-786.286q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v786.286h109.714q8 0 13.143 5.143t5.143 13.143zM1024 896v109.714q0 8-5.143 13.143t-13.143 5.143h-475.429q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h475.429q8 0 13.143 5.143t5.143 13.143zM914.286 603.429v109.714q0 8-5.143 13.143t-13.143 5.143h-365.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h365.714q8 0 13.143 5.143t5.143 13.143zM804.571 310.857v109.714q0 8-5.143 13.143t-13.143 5.143h-256q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h256q8 0 13.143 5.143t5.143 13.143zM694.857 18.286v109.714q0 8-5.143 13.143t-13.143 5.143h-146.286q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h146.286q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-amount-asc"
					],
					"defaultCode": 61792,
					"grid": 14
				},
				{
					"id": 259,
					"paths": [
						"M453.301 749.899c-9.997-9.997-26.206-9.997-36.203 0l-161.098 161.098v-885.397c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v885.397l-161.099-161.098c-9.997-9.997-26.206-9.997-36.203 0s-9.998 26.206 0 36.203l204.8 204.8c5 4.998 11.55 7.498 18.102 7.498s13.102-2.499 18.101-7.499l204.8-204.8c9.998-9.997 9.998-26.205 0-36.202z",
						"M691.2 256h-102.4c-14.139 0-25.6-11.462-25.6-25.6v-102.4c0-14.138 11.461-25.6 25.6-25.6h102.4c14.139 0 25.6 11.462 25.6 25.6v102.4c0 14.138-11.461 25.6-25.6 25.6zM614.4 204.8h51.2v-51.2h-51.2v51.2z",
						"M793.6 460.8h-204.8c-14.139 0-25.6-11.462-25.6-25.6v-102.4c0-14.138 11.461-25.6 25.6-25.6h204.8c14.139 0 25.6 11.462 25.6 25.6v102.4c0 14.138-11.461 25.6-25.6 25.6zM614.4 409.6h153.6v-51.2h-153.6v51.2z",
						"M896 665.6h-307.2c-14.139 0-25.6-11.461-25.6-25.6v-102.4c0-14.139 11.461-25.6 25.6-25.6h307.2c14.139 0 25.6 11.461 25.6 25.6v102.4c0 14.139-11.461 25.6-25.6 25.6zM614.4 614.4h256v-51.2h-256v51.2z",
						"M998.4 870.4h-409.6c-14.139 0-25.6-11.461-25.6-25.6v-102.4c0-14.139 11.461-25.6 25.6-25.6h409.6c14.139 0 25.6 11.461 25.6 25.6v102.4c0 14.139-11.461 25.6-25.6 25.6zM614.4 819.2h358.4v-51.2h-358.4v51.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-amount-asc",
						"sort",
						"arrange"
					],
					"defaultCode": 59556,
					"grid": 20
				},
				{
					"id": 3174,
					"paths": [
						"M320 768v-768h-128v768h-160l224 224 224-224h-160z",
						"M448 0h576v128h-576v-128z",
						"M448 192h448v128h-448v-128z",
						"M448 384h320v128h-320v-128z",
						"M448 576h192v128h-192v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-amount-desc",
						"arrange"
					],
					"defaultCode": 61009,
					"grid": 16
				},
				{
					"id": 1496,
					"width": 1038.8570537567139,
					"paths": [
						"M694.857 896v109.714q0 8-5.143 13.143t-13.143 5.143h-146.286q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h146.286q8 0 13.143 5.143t5.143 13.143zM420.571 822.857q0 6.857-5.714 13.714l-182.286 182.286q-5.714 5.143-13.143 5.143-6.857 0-13.143-5.143l-182.857-182.857q-8.571-9.143-4-20 4.571-11.429 17.143-11.429h109.714v-786.286q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v786.286h109.714q8 0 13.143 5.143t5.143 13.143zM804.571 603.429v109.714q0 8-5.143 13.143t-13.143 5.143h-256q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h256q8 0 13.143 5.143t5.143 13.143zM914.286 310.857v109.714q0 8-5.143 13.143t-13.143 5.143h-365.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h365.714q8 0 13.143 5.143t5.143 13.143zM1024 18.286v109.714q0 8-5.143 13.143t-13.143 5.143h-475.429q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h475.429q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-amount-desc"
					],
					"defaultCode": 61793,
					"grid": 14
				},
				{
					"id": 1376,
					"width": 585.1440086364746,
					"paths": [
						"M585.143 402.286q0 14.857-10.857 25.714t-25.714 10.857h-512q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714l256-256q10.857-10.857 25.714-10.857t25.714 10.857l256 256q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-asc",
						"sort-up"
					],
					"defaultCode": 61662,
					"grid": 14
				},
				{
					"id": 1375,
					"width": 585.1440315246582,
					"paths": [
						"M585.143 621.714q0 14.857-10.857 25.714l-256 256q-10.857 10.857-25.714 10.857t-25.714-10.857l-256-256q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857h512q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-desc",
						"sort-down"
					],
					"defaultCode": 61661,
					"grid": 14
				},
				{
					"id": 3172,
					"paths": [
						"M320 768v-768h-128v768h-160l224 224 224-224h-160z",
						"M864 1024c-17.674 0-32-14.328-32-32v-352h-32c-17.674 0-32-14.328-32-32s14.326-32 32-32h64c17.674 0 32 14.328 32 32v384c0 17.672-14.326 32-32 32z",
						"M928 0h-192c-17.674 0-32 14.326-32 32v192c0 17.674 14.326 32 32 32h160v128h-160c-17.674 0-32 14.326-32 32s14.326 32 32 32h192c17.674 0 32-14.326 32-32v-384c0-17.674-14.326-32-32-32zM768 64h128v128h-128v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-numberic-desc",
						"arrange"
					],
					"defaultCode": 61007,
					"grid": 16
				},
				{
					"id": 3171,
					"paths": [
						"M320 768v-768h-128v768h-160l224 224 224-224h-160z",
						"M864 448c-17.674 0-32-14.328-32-32v-352h-32c-17.674 0-32-14.328-32-32s14.326-32 32-32h64c17.674 0 32 14.328 32 32v384c0 17.672-14.326 32-32 32z",
						"M928 576h-192c-17.674 0-32 14.326-32 32v192c0 17.674 14.326 32 32 32h160v128h-160c-17.674 0-32 14.326-32 32s14.326 32 32 32h192c17.674 0 32-14.326 32-32v-384c0-17.674-14.326-32-32-32zM768 640h128v128h-128v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-numeric-asc",
						"arrange"
					],
					"defaultCode": 61006,
					"grid": 16
				},
				{
					"id": 1497,
					"width": 864.0000591278076,
					"paths": [
						"M769.143 750.286q0-36-25.143-66.286t-58.857-30.286q-29.714 0-47.429 21.143t-17.714 53.714 20.857 54.286 59.714 21.714q28.571 0 48.571-15.429t20-38.857zM420.571 822.857q0 6.857-5.714 13.714l-182.286 182.286q-5.714 5.143-13.143 5.143-6.857 0-13.143-5.143l-182.857-182.857q-8.571-9.143-4-20 4.571-11.429 17.143-11.429h109.714v-786.286q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v786.286h109.714q8 0 13.143 5.143t5.143 13.143zM849.143 783.429q0 35.429-7.429 69.429t-23.429 65.143-38.857 54.571-56.286 37.429-72.857 14q-35.429 0-61.714-9.143-13.714-4.571-24-8.571l22.286-64.571q8.571 4 17.714 6.286 21.143 7.429 42.857 7.429 48 0 76.857-33.429t38-83.143h-1.143q-12 13.143-35.143 21.143t-48.286 8q-60.571 0-98.857-40.857t-38.286-98.571q0-60 41.143-101.714t103.429-41.714q70.286 0 117.143 54t46.857 144.286zM832 373.714v65.143h-268v-65.143h95.429v-246.857q0-4 0.286-10.857t0.286-9.714v-9.143h-1.143l-4 6.857q-4.571 7.429-14.857 17.714l-35.429 33.143-46.857-49.143 109.714-105.714h70.286v373.714h94.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-numeric-asc"
					],
					"defaultCode": 61794,
					"grid": 14
				},
				{
					"id": 1498,
					"width": 864.0000591278076,
					"paths": [
						"M769.143 165.143q0-36-25.143-66.286t-58.857-30.286q-29.714 0-47.429 21.143t-17.714 53.714 20.857 54.286 59.714 21.714q28.571 0 48.571-15.429t20-38.857zM420.571 822.857q0 6.857-5.714 13.714l-182.286 182.286q-5.714 5.143-13.143 5.143-6.857 0-13.143-5.143l-182.857-182.857q-8.571-9.143-4-20 4.571-11.429 17.143-11.429h109.714v-786.286q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v786.286h109.714q8 0 13.143 5.143t5.143 13.143zM832 958.857v65.143h-268v-65.143h95.429v-246.857q0-4 0.286-10.857t0.286-9.714v-9.143h-1.143l-4 6.857q-4.571 7.429-14.857 17.714l-35.429 33.143-46.857-49.143 109.714-105.714h70.286v373.714h94.286zM849.143 198.286q0 35.429-7.429 69.429t-23.429 65.143-38.857 54.571-56.286 37.429-72.857 14q-35.429 0-61.714-9.143-13.714-4.571-24-8.571l22.286-64.571q8.571 4 17.714 6.286 21.143 7.429 42.857 7.429 48 0 76.857-33.429t38-83.143h-1.143q-12 13.143-35.143 21.143t-48.286 8q-60.571 0-98.857-40.857t-38.286-98.571q0-60 41.143-101.714t103.429-41.714q70.286 0 117.143 54t46.857 144.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-numeric-desc"
					],
					"defaultCode": 61795,
					"grid": 14
				},
				{
					"id": 3175,
					"paths": [
						"M320 768v-768h-128v768h-160l224 224 224-224h-160z",
						"M672 128c-17.674 0-32 14.328-32 32v192c0 17.672 14.326 32 32 32h128c17.674 0 32-14.328 32-32s-14.326-32-32-32h-96v-160c0-17.672-14.326-32-32-32z",
						"M1024 320c0-176.448-143.55-320-320-320s-320 143.552-320 320v32c0 17.672 14.328 32 32 32s32-14.328 32-32v-32c0-141.16 114.842-256 256-256s256 114.84 256 256c0 119.068-81.708 219.41-192 247.9v-119.9l-192 160 192 160v-134.434c145.888-29.73 256-159.030 256-313.566z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-time-asc",
						"arrange",
						"date"
					],
					"defaultCode": 61010,
					"grid": 16
				},
				{
					"id": 3176,
					"paths": [
						"M320 768v-768h-128v768h-160l224 224 224-224h-160z",
						"M672 128c-17.674 0-32 14.328-32 32v192c0 17.672 14.326 32 32 32h128c17.674 0 32-14.328 32-32s-14.326-32-32-32h-96v-160c0-17.672-14.326-32-32-32z",
						"M384 320c0-176.448 143.552-320 320-320s320 143.552 320 320v32c0 17.672-14.328 32-32 32s-32-14.328-32-32v-32c0-141.16-114.842-256-256-256s-256 114.84-256 256c0 119.068 81.708 219.41 192 247.9v-119.9l192 160-192 160v-134.434c-145.886-29.73-256-159.030-256-313.566z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort-time-desc",
						"arrange",
						"date"
					],
					"defaultCode": 61011,
					"grid": 16
				},
				{
					"id": 3166,
					"paths": [
						"M416 704h224v-704h128v704h224l-288 288-288-288zM384 320v704h-128v-704h-224l288-288 288 288h-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort",
						"arrows",
						"arrange"
					],
					"defaultCode": 61001,
					"grid": 16
				},
				{
					"id": 1374,
					"width": 585.1440086364746,
					"paths": [
						"M585.143 621.714q0 14.857-10.857 25.714l-256 256q-10.857 10.857-25.714 10.857t-25.714-10.857l-256-256q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857h512q14.857 0 25.714 10.857t10.857 25.714zM585.143 402.286q0 14.857-10.857 25.714t-25.714 10.857h-512q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714l256-256q10.857-10.857 25.714-10.857t25.714 10.857l256 256q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sort",
						"unsorted"
					],
					"defaultCode": 61660,
					"grid": 14
				},
				{
					"id": 819,
					"width": 1024,
					"paths": [
						"M671.936 152.48c-5.504 0-11.136 1.44-16.416 4.608l-248.736 149.248c-14.912 8.96-32 13.696-49.376 13.696h-133.408c-53.024 0-96 42.976-96 96v32c-35.36 0-64 28.64-64 64s28.64 64 64 64v32c0 53.024 42.976 96 96 96h129.728c19.712 0 38.912 6.048 55.040 17.344l244.864 171.392c5.76 4.032 12.064 5.824 18.24 5.824 16.608 0 32.096-13.184 32.096-32.064v-682.016c0.032-18.72-15.328-32.032-32.032-32.032zM96 512c0-17.632 14.368-32 32-32v64c-17.632 0-32-14.368-32-32zM672 866.528l-244.864-171.392c-21.632-15.136-47.008-23.136-73.408-23.136h-129.728c-35.296 0-64-28.704-64-64v-192c0-35.296 28.704-64 64-64h133.408c23.2 0 45.952-6.304 65.856-18.24l248.736-149.216v681.984zM873.728 697.696c-4.096 0-8.192-1.568-11.328-4.672-6.24-6.24-6.24-16.384 0-22.624 87.328-87.328 87.328-229.44 0-316.768-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0c99.808 99.808 99.808 262.208 0 362.016-3.104 3.104-7.2 4.672-11.296 4.672zM828.448 652.448c-4.096 0-8.192-1.568-11.328-4.672-6.24-6.24-6.24-16.384 0-22.624 30.208-30.24 46.88-70.432 46.88-113.152s-16.672-82.912-46.88-113.152c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0c36.288 36.288 56.256 84.48 56.256 135.776s-19.968 99.488-56.256 135.776c-3.104 3.104-7.2 4.672-11.296 4.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sound",
						"hear",
						"mute"
					],
					"grid": 32
				},
				{
					"id": 820,
					"width": 1024,
					"paths": [
						"M671.936 152.48c-5.504 0-11.136 1.44-16.416 4.608l-248.736 149.248c-14.912 8.96-32 13.696-49.376 13.696h-133.408c-53.024 0-96 42.976-96 96v32c-35.36 0-64 28.64-64 64s28.64 64 64 64v32c0 53.024 42.976 96 96 96h129.728c19.712 0 38.912 6.048 55.040 17.344l244.864 171.392c5.76 4.032 12.064 5.824 18.24 5.824 16.608 0 32.096-13.184 32.096-32.064v-682.016c0.032-18.72-15.328-32.032-32.032-32.032zM873.728 697.696c-4.096 0-8.192-1.568-11.328-4.672-6.24-6.24-6.24-16.384 0-22.624 87.328-87.328 87.328-229.44 0-316.768-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0c99.808 99.808 99.808 262.208 0 362.016-3.104 3.104-7.2 4.672-11.296 4.672zM828.448 652.448c-4.096 0-8.192-1.568-11.328-4.672-6.24-6.24-6.24-16.384 0-22.624 30.208-30.24 46.88-70.432 46.88-113.152s-16.672-82.912-46.88-113.152c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0c36.288 36.288 56.256 84.48 56.256 135.776s-19.968 99.488-56.256 135.776c-3.104 3.104-7.2 4.672-11.296 4.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sound",
						"hear",
						"mute"
					],
					"grid": 32
				},
				{
					"id": 1135,
					"width": 1024,
					"paths": [
						"M639.936 119.68c-5.376 0-10.88 1.376-16.064 4.416l-335.872 195.904h-256c-17.664 0-32 14.336-32 32v320c0 17.664 14.336 32 32 32h256l335.872 195.936c5.184 3.040 10.688 4.416 16.064 4.416 16.704 0 32.064-13.344 32.064-32.032v-720.608c0-18.688-15.328-32.032-32.064-32.032zM64 640v-256h224v256h-224zM320 648.576v-273.152l0.256-0.16 191.744-111.84v497.152l-192-112zM608 816.576l-64-37.344v-534.464l64-37.344v609.152zM864 512c0 59.84-23.328 116.096-65.632 158.368-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376c-12.512-12.512-12.512-32.736 0-45.248 30.208-30.208 46.88-70.4 46.88-113.12s-16.672-82.912-46.88-113.12c-12.512-12.512-12.512-32.736 0-45.248s32.736-12.512 45.248 0c42.304 42.272 65.632 98.528 65.632 158.368zM911.52 783.52c-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376c-12.512-12.512-12.512-32.736 0-45.248 124.768-124.768 124.768-327.776 0-452.576-12.512-12.512-12.512-32.736 0-45.248s32.736-12.512 45.248 0c149.728 149.728 149.728 393.376 0 543.072z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sound",
						"play",
						"blare"
					],
					"grid": 32
				},
				{
					"id": 3383,
					"paths": [
						"M891.96 514.204c-18.086 0-35.348 3.52-51.064 9.856-10.506-114.358-110.29-204.060-232-204.060-29.786 0-58.682 5.63-84.318 15.164-9.96 3.702-12.578 7.52-12.578 14.916v402.714c0 7.766 6.24 14.234 14.124 14.996 0.336 0.034 363.536 0.21 365.89 0.21 72.904 0 131.986-56.816 131.986-126.894s-59.134-126.902-132.040-126.902zM400 768h32l16-224.22-16-223.78h-32l-16 223.78zM304 768h-32l-16-162.75 16-157.25h32l16 160zM144 768h32l16-128-16-128h-32l-16 128zM16 704h32l16-64-16-64h-32l-16 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"soundcloud",
						"brand",
						"social"
					],
					"defaultCode": 61218,
					"grid": 16
				},
				{
					"id": 3384,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM176 704h-32l-16-96 16-96h32l16 96-16 96zM304 704h-32l-16-128 16-128h32l16 128-16 128zM432 704h-32l-16-192 16-192h32l16 192-16 192zM825.2 704c-2 0-301.2-0.2-301.4-0.2-6.4-0.6-11.6-6.2-11.8-12.8v-345.2c0-6.4 2.2-9.6 10.4-12.8 21.2-8.2 45-13 69.6-13 100.2 0 182.4 76.8 191.2 175 13-5.4 27.2-8.4 42-8.4 60 0 108.8 48.8 108.8 108.8s-48.8 108.6-108.8 108.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"soundcloud",
						"brand",
						"social"
					],
					"defaultCode": 61219,
					"grid": 16
				},
				{
					"id": 1584,
					"width": 1316.5721454620361,
					"paths": [
						"M448 784l9.143-137.714-9.143-298.857q-0.571-5.714-4.286-9.714t-9.429-4q-5.143 0-9.143 4t-4 9.714l-8 298.857 8 137.714q0.571 5.714 4.286 9.429t8.857 3.714q12.571 0 13.714-13.143zM617.143 767.429l6.286-120.571-6.857-334.857q0-9.143-7.429-13.714-4.571-2.857-9.143-2.857t-9.143 2.857q-7.429 4.571-7.429 13.714l-0.571 3.429-5.714 330.857q0 0.571 6.286 134.857v0.571q0 5.714 3.429 9.714 5.143 6.286 13.143 6.286 6.286 0 11.429-5.143 5.143-4 5.143-11.429zM20 573.143l11.429 73.143-11.429 72q-1.143 5.143-5.143 5.143t-5.143-5.143l-9.714-72 9.714-73.143q1.143-5.143 5.143-5.143t5.143 5.143zM69.143 528l14.857 118.286-14.857 116q-1.143 5.143-5.714 5.143-5.143 0-5.143-5.714l-13.143-115.429 13.143-118.286q0-5.143 5.143-5.143 4.571 0 5.714 5.143zM121.714 506.286l14.286 140-14.286 135.429q0 6.286-6.286 6.286-5.714 0-6.857-6.286l-12-135.429 12-140q1.143-6.857 6.857-6.857 6.286 0 6.286 6.857zM175.429 502.286l13.143 144-13.143 139.429q-1.143 7.429-8 7.429-7.429 0-7.429-7.429l-12-139.429 12-144q0-7.429 7.429-7.429 6.857 0 8 7.429zM229.143 512.571l12 133.714-12 140.571q-1.143 9.143-9.143 9.143-3.429 0-6-2.571t-2.571-6.571l-11.429-140.571 11.429-133.714q0-3.429 2.571-6t6-2.571q8 0 9.143 8.571zM282.857 429.143l12 217.143-12 140.571q0 4-2.857 7.143t-6.857 3.143q-9.143 0-10.286-10.286l-10.286-140.571 10.286-217.143q1.143-10.286 10.286-10.286 4 0 6.857 3.143t2.857 7.143zM336.571 380l10.857 267.429-10.857 139.429q0 4.571-3.143 7.714t-7.714 3.143q-10.286 0-11.429-10.857l-9.143-139.429 9.143-267.429q1.143-10.857 11.429-10.857 4.571 0 7.714 3.143t3.143 7.714zM392.571 357.143l10.286 289.143-10.286 138.286q-1.143 12-12.571 12-10.857 0-12-12l-9.143-138.286 9.143-289.143q0-5.143 3.714-8.857t8.286-3.714q5.143 0 8.571 3.714t4 8.857zM616.571 781.143v0 0zM503.429 354.857l8.571 291.429-8.571 136.571q0 5.714-4.286 10t-10 4.286-9.714-4-4.571-10.286l-8-136.571 8-291.429q0-6.286 4.286-10.286t10-4 10 4 4.286 10.286zM560 365.714l8 281.143-8 134.857q0 6.286-4.571 10.857t-10.857 4.571-10.857-4.571-5.143-10.857l-6.857-134.857 6.857-281.143q0.571-6.857 5.143-11.429t10.857-4.571 10.571 4.571 4.857 11.429zM681.143 646.857l-8 132q0 7.429-5.143 12.571t-12.571 5.143-12.571-5.143-5.714-12.571l-3.429-65.143-3.429-66.857 6.857-363.429v-1.714q1.143-8.571 6.857-13.714 5.143-4 11.429-4 4.571 0 8.571 2.857 8 4.571 9.143 14.857zM1316.571 636q0 66.857-47.429 114t-114.286 47.143h-449.143q-7.429-1.143-12.571-6.286t-5.143-12.571v-513.714q0-13.143 16-18.857 48.571-19.429 103.429-19.429 111.429 0 193.143 75.143t91.429 184.857q30.286-12.571 62.857-12.571 66.857 0 114.286 47.429t47.429 114.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"soundcloud"
					],
					"defaultCode": 61886,
					"grid": 14
				},
				{
					"id": 1547,
					"width": 1243.428092956543,
					"paths": [
						"M354.286 640q-62.857 36.571-153.143 36.571h-73.143v-36.571h-36.571q-7.429 0-12.857-13.429t-5.429-32.286q0-13.714 4-28-33.143-1.143-55.143-6t-22-11.714 22-11.714 55.143-6q-4-14.286-4-28 0-18.857 5.429-32.286t12.857-13.429h36.571v-36.571h73.143q90.286 0 153.143 36.571h636q24 4 60.857 10.286t46 8q50.857 8.571 85.714 23.143t47.714 27.143 12.857 22.857-12.857 22.857-47.714 27.143-85.714 23.143q-9.143 1.714-46 8t-60.857 10.286h-636zM993.714 496q30.286 20.571 30.286 52.571t-30.286 52.571l46.286 17.143q38.857-27.429 38.857-69.714t-38.857-69.714zM357.143 649.143h580q-124 21.714-260.571 45.714-32.571 0-64.571 13.714t-47.429 27.429l-16 13.714-164.571 164.571q-14.857 14.857-40.286 25.714t-51.143 10.857h-54.857l-53.143-265.143h16.571q89.714 0 156-36.571zM201.143 411.429h-16.571l53.143-265.143h54.857q26.286 0 51.429 10.857t40 25.714l164.571 164.571q2.286 2.286 6.286 6t17.429 13.143 27.714 16.571 35.143 13.143 41.429 6l260.571 45.714h-580q-66.286-36.571-156-36.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"space-shuttle"
					],
					"defaultCode": 61847,
					"grid": 14
				},
				{
					"id": 1924,
					"paths": [
						"M817.57 348.15c-193.566-143.858-260.266-259.018-305.566-348.148v0c-0.004 0-0.004-0.002-0.004-0.002v0.002c-45.296 89.13-112 204.292-305.566 348.148-330.036 245.286-19.376 587.668 253.758 399.224-17.796 116.93-78.53 202.172-140.208 238.882v37.744h384.032v-37.74c-61.682-36.708-122.41-121.954-140.212-238.884 273.136 188.446 583.8-153.94 253.766-399.226z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spades",
						"cards",
						"poker"
					],
					"defaultCode": 59759,
					"grid": 16
				},
				{
					"id": 2944,
					"paths": [
						"M1024 736l-288-736h-448l-288 288v448l288 288h448l288-288v-448l-288-288zM576 832h-128v-128h128v128zM576 576h-128v-384h128v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spam",
						"notice",
						"notification",
						"exclamation"
					],
					"defaultCode": 60779,
					"grid": 16
				},
				{
					"id": 821,
					"width": 1024,
					"paths": [
						"M953.888 234.656l-93.184-130.464c-18.016-25.216-47.104-40.192-78.112-40.192h-541.184c-31.008 0-60.096 14.976-78.112 40.192l-93.184 130.464c-22.976 32.16-23.872 75.136-2.304 108.256l390.592 598.912c12.64 19.36 33.12 29.024 53.6 29.024s40.992-9.664 53.6-29.024l390.592-598.912c21.6-33.12 20.672-76.096-2.304-108.256zM927.872 253.248c7.488 10.496 11.328 22.56 11.776 34.752h-216.416l110.688-166.016c0.224 0.288 93.952 131.264 93.952 131.264zM512 897.216l-150.592-577.216h301.152l-150.56 577.216zM362.144 288l149.856-174.816 149.856 174.816h-299.712zM808.8 101.952l-115.616 173.408-153.76-179.36h243.168c9.184 0 18.048 2.272 26.208 5.952zM484.576 96l-153.76 179.392-115.616-173.44c8.16-3.68 17.024-5.952 26.208-5.952h243.168zM190.080 121.984l110.688 166.016h-216.416c0.448-12.192 4.288-24.256 11.776-34.752 0 0 93.728-130.976 93.952-131.264zM94.624 325.408c-1.12-1.696-1.568-3.616-2.496-5.408h236.224l158.016 605.696c-0.352-0.48-0.832-0.864-1.152-1.376l-390.592-598.912zM538.816 924.32c-0.352 0.512-0.8 0.896-1.152 1.376l157.984-605.696h236.224c-0.928 1.792-1.376 3.712-2.464 5.408l-390.592 598.912z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sparkle",
						"shine"
					],
					"grid": 32
				},
				{
					"id": 822,
					"width": 1024,
					"paths": [
						"M692.704 242.368l115.552-174.528c-8.288-2.336-16.832-3.84-25.664-3.84h-243.904l154.016 178.368z",
						"M837.312 81.92l-115.232 174.080h243.072c-2.88-7.424-6.464-14.656-11.232-21.344l-93.184-130.464c-6.432-8.96-14.592-16.096-23.424-22.272z",
						"M696.32 288l-178.496 682.144c18.464-1.664 36.352-10.848 47.776-28.352l390.592-598.912c10.88-16.672 16-35.872 15.52-54.912h-275.392z",
						"M331.296 242.368l154.016-178.368h-243.904c-8.832 0-17.376 1.504-25.696 3.84l115.584 174.528z",
						"M327.68 288h-275.392c-0.48 19.040 4.64 38.208 15.52 54.912l390.592 598.912c11.424 17.504 29.312 26.656 47.776 28.352l-178.496-682.176z",
						"M301.92 256l-115.232-174.080c-8.832 6.176-16.992 13.312-23.392 22.272l-93.184 130.464c-4.8 6.688-8.384 13.92-11.232 21.344h243.040z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sparkle",
						"shine"
					],
					"grid": 32
				},
				{
					"id": 1136,
					"width": 1024,
					"paths": [
						"M1015.68 239.392l-110.848-221.696c-5.408-10.848-16.48-17.696-28.608-17.696h-728.448c-12.128 0-23.2 6.848-28.608 17.696l-110.848 221.696c-5.12 10.272-4.384 22.496 1.984 32.064l475.072 712.608c6.336 9.504 16.48 14.24 26.624 14.24s20.288-4.736 26.624-14.24l475.072-712.608c6.368-9.568 7.136-21.792 1.984-32.064zM678.688 256l-166.688 611.2-166.688-611.2h333.376zM344.992 224l167.008-139.168 167.008 139.168h-334.016zM536.992 64h304.384l-138.336 138.368-166.048-138.368zM320.96 202.368l-138.336-138.368h304.384l-166.048 138.368zM297.376 224h-209.824l69.952-139.872 139.872 139.872zM312.128 256l162.848 597.12-398.048-597.12h235.2zM711.872 256h235.232l-398.080 597.12 162.848-597.12zM726.624 224l139.904-139.872 69.92 139.872h-209.824z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sparkle",
						"shine"
					],
					"grid": 32
				},
				{
					"id": 823,
					"width": 1024,
					"paths": [
						"M832 288v-32c0-17.664-14.336-32-32-32h-256v-40.864c19.040-11.104 32-31.52 32-55.136v-60.576c0-31.872-21.792-61.44-53.248-66.56-40.096-6.496-74.752 24.256-74.752 63.136v64c0 23.616 12.96 44.032 32 55.136v40.864h-256c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32l60.64 544h-28.64c-17.664 0-32 14.336-32 32v32c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-32c0-17.664-14.336-32-32-32h-28.64l60.64-544c17.664 0 32-14.336 32-32zM480 64c0-17.632 14.368-32 32-32s32 14.368 32 32v64c0 17.632-14.368 32-32 32s-32-14.368-32-32v-64zM800 992h-576v-32h576v32zM224 256h576v32h-576v-32zM768 896v32h-512v-32h512zM707.2 864h-390.4l-57.248-544h504.896l-57.248 544z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"speak",
						"broadcast",
						"talk"
					],
					"grid": 32
				},
				{
					"id": 824,
					"width": 1024,
					"paths": [
						"M192 288v-32c0-17.664 14.336-32 32-32h256v-40.864c-19.040-11.104-32-31.52-32-55.136v-64c0-38.88 34.656-69.632 74.752-63.136 31.456 5.12 53.248 34.688 53.248 66.56v60.576c0 23.616-12.96 44.032-32 55.136v40.864h256c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32v0h-576c-17.664 0-32-14.336-32-32zM227.552 352l53.504 480h461.856l53.504-480h-568.864zM800 928v-32c0-17.664-14.336-31.968-31.968-32h-512.064c-17.632 0-31.968 14.336-31.968 32v32c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"speak",
						"broadcast",
						"talk"
					],
					"grid": 32
				},
				{
					"id": 1137,
					"width": 1024,
					"paths": [
						"M768 352h-512v-32h512v32zM768 416h-512v32h512v-32zM768 512h-512v32h512v-32zM1024 96v704c0 17.664-14.336 32-32 32h-352l-105.376 105.376c-6.24 6.24-14.432 9.376-22.624 9.376s-16.384-3.136-22.624-9.376l-105.376-105.376h-352c-17.664 0-32-14.336-32-32v-704c0-17.664 14.336-32 32-32h960c17.664 0 32 14.336 32 32zM960 128h-896v640h346.496l101.504 101.504 101.504-101.504h346.496v-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"speak",
						"say",
						"talk",
						"tell"
					],
					"grid": 32
				},
				{
					"id": 2984,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.376l-246.626-246.624h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.876-6.936 11.956 4.954 19.752 16.622 19.752 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z",
						"M928 768h-320c-17.674 0-32-14.326-32-32v-448c0-17.672 14.326-32 32-32s32 14.328 32 32v416h288c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"speaker-left",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60819,
					"grid": 16
				},
				{
					"id": 2985,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.376l-246.626-246.624h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.876-6.936 11.956 4.954 19.752 16.622 19.752 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z",
						"M950.628 713.374l-137.924-137.924c82.302-6.502 147.296-75.506 147.296-159.45 0-88.224-71.776-160-160-160h-192c-17.674 0-32 14.328-32 32v448c0 17.674 14.326 32 32 32s32-14.326 32-32v-160h82.746l182.626 182.626c6.25 6.25 14.44 9.374 22.628 9.374s16.378-3.124 22.626-9.374c12.5-12.496 12.5-32.756 0.002-45.252zM640 320h160c52.934 0 96 43.066 96 96s-43.066 96-96 96h-160v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"speaker-right",
						"volume",
						"audio",
						"player"
					],
					"defaultCode": 60820,
					"grid": 16
				},
				{
					"id": 1899,
					"paths": [
						"M800 0h-576c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h576c52.8 0 96-43.2 96-96v-832c0-52.8-43.198-96-96-96zM512 64c70.694 0 128 57.308 128 128s-57.306 128-128 128c-70.692 0-128-57.308-128-128s57.308-128 128-128zM512 960c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z",
						"M512 512c-106.040 0-192 85.96-192 192s85.96 192 192 192 192-85.96 192-192-85.96-192-192-192zM512 768c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.346 0 64 28.654 64 64s-28.654 64-64 64z",
						"M576 192c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"speakers",
						"music",
						"audio",
						"sound-system"
					],
					"defaultCode": 59734,
					"grid": 16
				},
				{
					"id": 2953,
					"paths": [
						"M128 256h128v192h64v-384c0-35.2-28.8-64-64-64h-128c-35.2 0-64 28.8-64 64v384h64v-192zM128 64h128v128h-128v-128zM960 64v-64h-192c-35.202 0-64 28.8-64 64v320c0 35.2 28.798 64 64 64h192v-64h-192v-320h192zM640 160v-96c0-35.2-28.8-64-64-64h-192v448h192c35.2 0 64-28.8 64-64v-96c0-35.2-8.8-64-44-64 35.2 0 44-28.8 44-64zM576 384h-128v-128h128v128zM576 192h-128v-128h128v128zM832 576l-416 448-224-288 82-70 142 148 352-302z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spell-check",
						"spelling",
						"correct"
					],
					"defaultCode": 60788,
					"grid": 16
				},
				{
					"id": 2954,
					"paths": [
						"M130.018 640l57.6-192h264.764l57.6 192h113.63l-191.994-640h-223.236l-192 640h113.636zM283.618 128h72.764l57.6 192h-187.964l57.6-192z",
						"M896 480l-352 352-128-128-96 96 224 224 448-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spell-check",
						"spelling",
						"correct"
					],
					"defaultCode": 60789,
					"grid": 16
				},
				{
					"id": 151,
					"paths": [
						"M230.4 716.8c-14.138 0-25.6 11.461-25.6 25.6v0.070c-21.408-16.107-48.006-25.67-76.8-25.67-70.579 0-128 57.421-128 128s57.421 128 128 128c28.794 0 55.392-9.563 76.8-25.67v0.070c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-204.8c0-14.139-11.462-25.6-25.6-25.6zM128 921.6c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.453 76.8-76.8 76.8z",
						"M435.2 716.8c-28.794 0-55.392 9.563-76.8 25.67v-204.87c0-14.139-11.462-25.6-25.6-25.6s-25.6 11.461-25.6 25.6v409.6c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-0.070c21.408 16.107 48.006 25.67 76.8 25.67 70.579 0 128-57.421 128-128s-57.421-128-128-128zM435.2 921.6c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.453 76.8-76.8 76.8z",
						"M742.4 972.8c-70.579 0-128-57.421-128-128s57.421-128 128-128c22.496 0 44.632 5.925 64.014 17.136 12.238 7.080 16.422 22.739 9.344 34.978-7.082 12.24-22.744 16.421-34.978 9.344-11.603-6.71-24.875-10.258-38.381-10.258-42.347 0-76.8 34.453-76.8 76.8s34.453 76.8 76.8 76.8c13.509 0 26.782-3.547 38.382-10.258 12.235-7.078 27.898-2.899 34.978 9.341 7.080 12.237 2.899 27.899-9.341 34.978-19.382 11.213-41.52 17.139-64.019 17.139z",
						"M588.8 537.6c-6.552 0-13.102-2.499-18.101-7.499l-153.6-153.6c-9.997-9.998-9.997-26.206 0-36.205 9.998-9.997 26.206-9.997 36.205 0l135.496 135.499 340.299-340.298c9.997-9.997 26.206-9.997 36.203 0 9.998 9.998 9.998 26.206 0 36.205l-358.4 358.4c-5 4.998-11.55 7.498-18.102 7.498z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spell-check",
						"spelling"
					],
					"defaultCode": 59448,
					"grid": 20
				},
				{
					"id": 2726,
					"paths": [
						"M480 64c-265.096 0-480 214.904-480 480 0 265.098 214.904 480 480 480 265.098 0 480-214.902 480-480 0-265.096-214.902-480-480-480zM751.59 704c8.58-40.454 13.996-83.392 15.758-128h127.446c-3.336 44.196-13.624 87.114-30.68 128h-112.524zM208.41 384c-8.58 40.454-13.996 83.392-15.758 128h-127.444c3.336-44.194 13.622-87.114 30.678-128h112.524zM686.036 384c9.614 40.962 15.398 83.854 17.28 128h-191.316v-128h174.036zM512 320v-187.338c14.59 4.246 29.044 11.37 43.228 21.37 26.582 18.74 52.012 47.608 73.54 83.486 14.882 24.802 27.752 52.416 38.496 82.484h-155.264zM331.232 237.516c21.528-35.878 46.956-64.748 73.54-83.486 14.182-10 28.638-17.124 43.228-21.37v187.34h-155.264c10.746-30.066 23.616-57.68 38.496-82.484zM448 384v128h-191.314c1.88-44.146 7.666-87.038 17.278-128h174.036zM95.888 704c-17.056-40.886-27.342-83.804-30.678-128h127.444c1.762 44.608 7.178 87.546 15.758 128h-112.524zM256.686 576h191.314v128h-174.036c-9.612-40.96-15.398-83.854-17.278-128zM448 768v187.34c-14.588-4.246-29.044-11.372-43.228-21.37-26.584-18.74-52.014-47.61-73.54-83.486-14.882-24.804-27.75-52.418-38.498-82.484h155.266zM628.768 850.484c-21.528 35.876-46.958 64.746-73.54 83.486-14.184 9.998-28.638 17.124-43.228 21.37v-187.34h155.266c-10.746 30.066-23.616 57.68-38.498 82.484zM512 704v-128h191.314c-1.88 44.146-7.666 87.040-17.28 128h-174.034zM767.348 512c-1.762-44.608-7.178-87.546-15.758-128h112.524c17.056 40.886 27.344 83.806 30.68 128h-127.446zM830.658 320h-95.9c-18.638-58.762-44.376-110.294-75.316-151.428 42.536 20.34 81.058 47.616 114.714 81.272 21.48 21.478 40.362 44.938 56.502 70.156zM185.844 249.844c33.658-33.658 72.18-60.932 114.714-81.272-30.942 41.134-56.676 92.666-75.316 151.428h-95.898c16.138-25.218 35.022-48.678 56.5-70.156zM129.344 768h95.898c18.64 58.762 44.376 110.294 75.318 151.43-42.536-20.34-81.058-47.616-114.714-81.274-21.48-21.478-40.364-44.938-56.502-70.156zM774.156 838.156c-33.656 33.658-72.18 60.934-114.714 81.274 30.942-41.134 56.678-92.668 75.316-151.43h95.9c-16.14 25.218-35.022 48.678-56.502 70.156z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sphere",
						"globe",
						"internet"
					],
					"defaultCode": 60561,
					"grid": 16
				},
				{
					"id": 2727,
					"paths": [
						"M480 64c-265.096 0-480 214.904-480 480 0 265.098 214.904 480 480 480 265.098 0 480-214.902 480-480 0-265.096-214.902-480-480-480zM751.59 704c8.58-40.454 13.996-83.39 15.758-128h127.448c-3.338 44.196-13.624 87.114-30.682 128h-112.524zM686.036 384c9.616 40.962 15.398 83.854 17.282 128h-191.318v-128h174.036zM512 320v-187.338c14.59 4.246 29.042 11.37 43.228 21.37 26.582 18.74 52.012 47.608 73.54 83.486 14.882 24.802 27.752 52.416 38.496 82.484l-155.264-0.002zM331.232 237.516c21.528-35.878 46.956-64.748 73.54-83.486 14.182-10 28.638-17.124 43.228-21.37v187.34h-155.264c10.746-30.066 23.616-57.68 38.496-82.484zM448 384v128h-191.314c1.88-44.146 7.666-87.038 17.278-128h174.036zM256.686 576h191.314v128h-174.036c-9.612-40.96-15.398-83.854-17.278-128zM448 768v187.34c-14.588-4.246-29.044-11.372-43.228-21.37-26.584-18.74-52.014-47.612-73.54-83.486-14.882-24.804-27.75-52.418-38.498-82.484h155.266zM628.768 850.484c-21.528 35.876-46.958 64.746-73.54 83.486-14.186 9.998-28.638 17.124-43.228 21.37v-187.34h155.266c-10.746 30.066-23.616 57.68-38.498 82.484zM512 704v-128h191.314c-1.88 44.146-7.666 87.040-17.282 128h-174.032zM767.348 512c-1.762-44.608-7.178-87.546-15.758-128h112.524c17.056 40.886 27.344 83.806 30.682 128h-127.448zM830.658 320h-95.9c-18.638-58.762-44.376-110.294-75.316-151.428 42.538 20.34 81.058 47.616 114.714 81.272 21.48 21.478 40.362 44.938 56.502 70.156zM774.156 838.156c-33.656 33.658-72.18 60.934-114.714 81.274 30.944-41.132 56.678-92.668 75.316-151.43h95.9c-16.14 25.218-35.022 48.678-56.502 70.156z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sphere",
						"globe",
						"internet"
					],
					"defaultCode": 60562,
					"grid": 16
				},
				{
					"id": 2728,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM530.070 940.684c-7.542 16.664-13.868 25.988-18.070 31.032-4.204-5.042-10.53-14.368-18.072-31.032-11.584-25.598-22.49-61.058-31.536-102.546-0.556-2.552-1.104-5.132-1.646-7.728 16.858 1.046 33.954 1.59 51.254 1.59s34.396-0.544 51.256-1.592c-0.542 2.596-1.090 5.176-1.646 7.728-9.048 41.488-19.954 76.95-31.54 102.548zM512 784c-20.29 0-40.38-0.774-60.216-2.31-7.106-44.054-12.402-92.37-15.716-143.092 24.778 0.92 50.128 1.402 75.932 1.402 25.802 0 51.154-0.482 75.934-1.404-3.314 50.724-8.612 99.040-15.716 143.092-19.838 1.538-39.926 2.312-60.218 2.312zM512 592c-26.45 0-52.678-0.522-78.458-1.542-1.020-25.78-1.542-52.008-1.542-78.458s0.522-52.678 1.542-78.458c25.78-1.020 52.008-1.542 78.458-1.542s52.678 0.522 78.458 1.542c1.020 25.78 1.542 52.008 1.542 78.458s-0.522 52.678-1.542 78.458c-25.78 1.020-52.008 1.542-78.458 1.542zM240 512c0-20.29 0.774-40.38 2.312-60.216 44.054-7.106 92.368-12.402 143.092-15.716-0.922 24.778-1.404 50.128-1.404 75.932 0 25.802 0.482 51.154 1.404 75.934-50.724-3.314-99.038-8.612-143.092-15.714-1.538-19.84-2.312-39.928-2.312-60.22zM193.592 563.256c-2.596-0.542-5.176-1.090-7.73-1.646-41.49-9.046-76.95-19.954-102.548-31.54-16.664-7.542-25.99-13.868-31.030-18.070 5.040-4.202 14.366-10.528 31.030-18.070 25.598-11.586 61.060-22.49 102.548-31.536 2.554-0.556 5.134-1.104 7.73-1.646-1.048 16.858-1.592 33.954-1.592 51.252 0 17.3 0.544 34.396 1.592 51.256zM493.928 83.314c7.542-16.664 13.868-25.988 18.072-31.028 4.204 5.040 10.532 14.366 18.070 31.030 11.586 25.598 22.488 61.060 31.54 102.548 0.556 2.552 1.104 5.132 1.646 7.728-16.86-1.048-33.956-1.592-51.256-1.592s-34.396 0.544-51.254 1.592c0.542-2.596 1.090-5.176 1.646-7.73 9.046-41.49 19.952-76.95 31.536-102.548zM512 240c20.292 0 40.38 0.774 60.216 2.312 7.106 44.054 12.402 92.368 15.716 143.092-24.778-0.922-50.13-1.404-75.932-1.404-25.804 0-51.154 0.482-75.932 1.404 3.314-50.724 8.61-99.038 15.716-143.092 19.836-1.54 39.924-2.312 60.216-2.312zM638.596 436.068c50.724 3.316 99.040 8.61 143.092 15.716 1.538 19.836 2.312 39.926 2.312 60.216 0 20.292-0.774 40.38-2.312 60.216-44.052 7.106-92.368 12.402-143.092 15.716 0.922-24.778 1.404-50.13 1.404-75.932 0-25.804-0.482-51.154-1.404-75.932zM830.408 460.748c2.596 0.542 5.176 1.090 7.728 1.646 41.488 9.046 76.95 19.95 102.546 31.536 16.664 7.542 25.988 13.868 31.032 18.070-5.042 4.204-14.368 10.532-31.032 18.070-25.6 11.586-61.058 22.488-102.546 31.54-2.552 0.556-5.132 1.104-7.728 1.646 1.048-16.86 1.592-33.956 1.592-51.256 0-17.298-0.544-34.394-1.592-51.252zM825.742 410.848c-4.764-38.028-12.15-74.538-21.862-109.014 15.666 7.576 30.598 15.77 44.716 24.594 41.304 25.814 73.406 55.394 95.414 87.916 8.328 12.304 15.020 24.84 20.108 37.55-34.13-16.012-81.46-29.996-138.376-41.046zM760.446 324.976c6.646 25.142 11.886 50.978 15.73 77.362-42.948-6.48-90.012-11.424-139.976-14.536-3.114-49.964-8.056-97.030-14.536-139.976 26.382 3.842 52.218 9.082 77.362 15.728 16.188 4.28 31.862 9.094 47.026 14.394 5.3 15.166 10.114 30.84 14.394 47.028zM613.152 198.258c-11.050-56.916-25.036-104.248-41.048-138.378 12.71 5.088 25.248 11.78 37.552 20.108 32.522 22.008 62.1 54.11 87.914 95.414 8.824 14.12 17.022 29.052 24.596 44.718-34.476-9.712-70.986-17.1-109.014-21.862zM414.346 79.986c12.304-8.328 24.84-15.018 37.55-20.106-16.012 34.13-29.998 81.46-41.046 138.378-38.028 4.762-74.538 12.15-109.014 21.862 7.574-15.666 15.77-30.6 24.594-44.72 25.814-41.302 55.394-73.406 87.916-95.414zM324.976 263.552c25.142-6.646 50.978-11.884 77.362-15.728-6.48 42.948-11.424 90.012-14.536 139.976-49.964 3.112-97.030 8.056-139.976 14.536 3.842-26.384 9.082-52.22 15.728-77.364 4.28-16.188 9.094-31.862 14.396-47.028 15.164-5.3 30.838-10.112 47.026-14.392zM198.258 410.848c-56.916 11.050-104.248 25.034-138.378 41.046 5.088-12.71 11.78-25.248 20.108-37.552 22.008-32.522 54.11-62.1 95.414-87.916 14.12-8.824 29.052-17.020 44.718-24.594-9.712 34.478-17.1 70.988-21.862 109.016zM59.88 572.106c34.13 16.014 81.46 29.998 138.378 41.046 4.764 38.030 12.15 74.54 21.862 109.016-15.666-7.574-30.6-15.772-44.72-24.596-41.302-25.814-73.406-55.392-95.414-87.914-8.326-12.304-15.018-24.844-20.106-37.552zM263.552 699.028c-6.646-25.142-11.884-50.98-15.728-77.364 42.948 6.48 90.012 11.422 139.976 14.536 3.112 49.964 8.056 97.030 14.536 139.976-26.384-3.842-52.22-9.080-77.364-15.726-16.188-4.28-31.862-9.094-47.026-14.394-5.3-15.168-10.114-30.842-14.394-47.028zM410.848 825.742c11.050 56.916 25.034 104.248 41.046 138.376-12.71-5.088-25.248-11.78-37.552-20.108-32.522-22.008-62.1-54.11-87.916-95.414-8.824-14.12-17.020-29.050-24.596-44.718 34.478 9.714 70.99 17.1 109.018 21.864zM609.658 944.012c-12.306 8.328-24.844 15.020-37.554 20.11 16.014-34.13 29.998-81.46 41.048-138.378 38.028-4.764 74.54-12.15 109.016-21.864-7.574 15.668-15.772 30.6-24.596 44.718-25.814 41.304-55.392 73.406-87.914 95.414zM699.026 760.446c-25.142 6.646-50.978 11.886-77.362 15.728 6.478-42.946 11.422-90.010 14.536-139.974 49.964-3.114 97.030-8.056 139.976-14.536-3.844 26.382-9.082 52.218-15.728 77.364-4.28 16.186-9.092 31.86-14.392 47.024-15.168 5.3-30.844 10.114-47.030 14.394zM825.742 613.152c56.916-11.050 104.248-25.036 138.378-41.048-5.090 12.71-11.782 25.248-20.11 37.552-22.008 32.522-54.11 62.1-95.414 87.914-14.12 8.824-29.050 17.022-44.716 24.596 9.712-34.476 17.098-70.986 21.862-109.014zM840.098 183.902c42.628 42.628 76.092 92.256 99.458 147.502 1.040 2.456 2.026 4.926 3.020 7.396-40.846-39.584-95.292-73.16-159.2-98.176-25.018-63.906-58.592-118.352-98.176-159.2 2.468 0.996 4.94 1.982 7.394 3.020 55.248 23.368 104.876 56.832 147.504 99.458zM183.902 183.904c42.628-42.628 92.256-76.090 147.502-99.458 2.454-1.038 4.924-2.024 7.39-3.018-39.582 40.846-73.156 95.292-98.17 159.196-63.906 25.016-118.352 58.59-159.198 98.172 0.994-2.466 1.98-4.936 3.018-7.39 23.368-55.248 56.832-104.874 99.458-147.502zM183.904 840.098c-42.628-42.626-76.090-92.256-99.458-147.502-1.038-2.456-2.024-4.924-3.018-7.39 40.846 39.582 95.292 73.156 159.196 98.172 25.016 63.904 58.59 118.352 98.174 159.198-2.468-0.992-4.938-1.978-7.392-3.018-55.248-23.37-104.874-56.832-147.502-99.46zM840.098 840.098c-42.626 42.628-92.256 76.092-147.502 99.458-2.456 1.040-4.926 2.026-7.394 3.020 39.584-40.846 73.158-95.292 98.176-159.2 63.906-25.018 118.354-58.592 159.2-98.176-0.994 2.468-1.98 4.94-3.020 7.394-23.37 55.248-56.832 104.876-99.46 147.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sphere",
						"globe",
						"internet"
					],
					"defaultCode": 60563,
					"grid": 16
				},
				{
					"id": 825,
					"width": 1024,
					"paths": [
						"M828.768 195.2c-174.944-174.944-458.624-174.944-633.568 0s-174.944 458.624 0 633.568 458.624 174.944 633.568 0 174.976-458.592 0-633.568zM816.896 794.272l-227.904-227.904 180.96-22.624c8-0.992 14.304-4.288 18.88-8.864 16.768-16.768 10.464-50.976-18.88-54.656l-180.96-22.624 227.904-227.904c147.296 159.040 147.296 405.568 0 564.576zM480 515.84v-7.68c0-7.52 2.912-14.592 8.256-19.904 5.312-5.344 12.384-8.256 20-8.256 1.152 0 2.336 0.064 3.488 0.224l254.272 31.776-254.272 31.776c-1.152 0.16-2.304 0.224-3.584 0.224-15.52 0-28.16-12.64-28.16-28.16zM794.272 207.104l-245.504 245.504-33.056-4.128c-2.464-0.32-7.552-0.48-7.552-0.48-10.784 0-20.736 3.072-29.504 8.032l-248.928-248.928c159.008-147.296 405.536-147.296 564.544 0zM207.104 229.728l248.928 248.928c-4.96 8.768-8.032 18.72-8.032 29.504v7.68c0 10.784 3.072 20.736 8.032 29.504l-248.928 248.928c-147.296-159.008-147.296-405.536 0-564.544zM229.728 816.896l248.928-248.928c8.768 4.96 18.72 8.032 29.504 8.032 0 0 5.088-0.16 7.552-0.48l33.056-4.128 245.504 245.504c-159.008 147.296-405.536 147.296-564.544 0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spin",
						"play"
					],
					"grid": 32
				},
				{
					"id": 826,
					"width": 1024,
					"paths": [
						"M960 512c0 117.952-45.92 224.928-120.448 304.928l-248.96-248.96c52.256-6.208 123.264-15.232 192.736-24.224 37.184-4.8 37.184-58.656 0-63.456-69.472-8.992-140.48-18.016-192.736-24.224l248.96-248.96c74.528 79.968 120.448 186.944 120.448 304.896zM480 512c0 17.632 14.368 32 32 32 6.24-0.032 44.8-3.2 267.2-32-222.4-28.8-260.96-31.968-267.2-32-17.632 0-32 14.368-32 32zM457.056 544.32c-5.6-9.504-9.056-20.48-9.056-32.32s3.456-22.816 9.056-32.32l-272.608-272.608c-74.528 80-120.448 186.976-120.448 304.928s45.92 224.928 120.448 304.928l272.608-272.608zM549.984 572.608c-19.456 2.112-33.088 3.392-37.984 3.392-11.84 0-22.816-3.456-32.32-9.056l-272.608 272.608c80 74.528 186.976 120.448 304.928 120.448s224.928-45.92 304.928-120.448l-266.944-266.944zM479.68 457.056c9.504-5.6 20.48-9.056 32.32-9.056 4.896 0 18.528 1.28 37.984 3.392l266.944-266.944c-80-74.528-186.976-120.448-304.928-120.448s-224.928 45.92-304.928 120.448l272.608 272.608z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spin",
						"play"
					],
					"grid": 32
				},
				{
					"id": 1138,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384zM512 160c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zM512 192c82.464 0 157.504 31.648 214.304 83.072l-177.312 177.312-33.024-4.128c-1.312-0.16-2.624-0.256-3.968-0.256-11.84 0-22.784 3.456-32.32 9.056l-181.984-181.984c56.8-51.424 131.84-83.072 214.304-83.072zM512 544c-17.664 0-32-14.336-32-32s14.336-32 32-32l256 32-256 32zM192 512c0-82.464 31.648-157.504 83.072-214.304l182.016 182.016c-5.632 9.504-9.088 20.448-9.088 32.288s3.456 22.784 9.056 32.32l-182.016 182.016c-51.424-56.832-83.040-131.872-83.040-214.336zM512 832c-82.464 0-157.504-31.648-214.304-83.072l182.016-182.016c9.504 5.632 20.448 9.088 32.288 9.088 1.344 0 2.656-0.096 3.968-0.256l33.024-4.128 177.312 177.312c-56.8 51.424-131.84 83.072-214.304 83.072zM748.928 726.304l-159.712-159.712 182.752-22.848c16-1.984 28.032-15.616 28.032-31.744s-12.032-29.76-28.032-31.744l-182.752-22.848 159.712-159.712c51.424 56.8 83.072 131.84 83.072 214.304s-31.616 157.504-83.072 214.304z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spin",
						"play"
					],
					"grid": 32
				},
				{
					"id": 2359,
					"paths": [
						"M384 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM655.53 240.47c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM832 512c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM719.53 783.53c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM448.002 896c0 0 0 0 0 0 0-35.346 28.654-64 64-64s64 28.654 64 64c0 0 0 0 0 0 0 35.346-28.654 64-64 64s-64-28.654-64-64zM176.472 783.53c0 0 0 0 0 0 0-35.346 28.654-64 64-64s64 28.654 64 64c0 0 0 0 0 0 0 35.346-28.654 64-64 64s-64-28.654-64-64zM144.472 240.47c0 0 0 0 0 0 0-53.019 42.981-96 96-96s96 42.981 96 96c0 0 0 0 0 0 0 53.019-42.981 96-96 96s-96-42.981-96-96zM56 512c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.765-32.235 72-72 72s-72-32.235-72-72z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60194,
					"grid": 16
				},
				{
					"id": 2368,
					"paths": [
						"M0.042 513.618l-0.022 0.004c0 0 0.012 0.090 0.028 0.222 0.11 3.878 0.55 7.676 1.322 11.352 0.204 1.746 0.428 3.66 0.674 5.774 0.222 1.886 0.46 3.914 0.718 6.078 0.374 2.566 0.77 5.292 1.19 8.176 0.856 5.746 1.8 12.124 2.908 18.958 1.348 6.446 2.804 13.414 4.364 20.864 0.71 3.718 1.776 7.504 2.786 11.406 1.024 3.89 2.078 7.894 3.16 12.004 0.566 2.042 1.040 4.132 1.708 6.208 0.656 2.074 1.32 4.176 1.988 6.3 1.348 4.234 2.726 8.566 4.136 12.988 0.352 1.106 0.708 2.21 1.064 3.324 0.408 1.102 0.814 2.208 1.226 3.316 0.826 2.218 1.658 4.458 2.502 6.714 1.696 4.496 3.422 9.078 5.18 13.742 1.968 4.566 3.97 9.214 6.004 13.934 1.018 2.348 2.044 4.714 3.078 7.098 1.048 2.376 2.27 4.704 3.408 7.074 2.322 4.714 4.678 9.496 7.062 14.332 2.47 4.786 5.208 9.512 7.846 14.328 1.336 2.398 2.68 4.808 4.028 7.23 1.368 2.41 2.902 4.75 4.356 7.14 2.95 4.738 5.93 9.524 8.934 14.348 12.64 18.894 26.676 37.566 42.21 55.278 15.712 17.578 32.726 34.25 50.692 49.602 18.18 15.136 37.264 28.902 56.726 41.114 19.604 12.036 39.644 22.312 59.376 31.144 5.004 2.040 9.964 4.062 14.878 6.066 2.462 0.972 4.868 2.032 7.336 2.918 2.47 0.868 4.93 1.734 7.376 2.594 4.898 1.684 9.678 3.468 14.484 4.992 4.832 1.43 9.604 2.844 14.312 4.242 2.356 0.672 4.66 1.426 7.004 2.012 2.346 0.574 4.676 1.14 6.986 1.704 4.606 1.118 9.142 2.214 13.604 3.296 4.5 0.868 8.926 1.722 13.27 2.558 2.166 0.41 4.31 0.82 6.434 1.222 1.062 0.2 2.118 0.398 3.166 0.598 1.060 0.148 2.118 0.292 3.166 0.442 4.192 0.582 8.292 1.152 12.3 1.71 1.998 0.274 3.972 0.546 5.922 0.816 1.946 0.286 3.904 0.378 5.814 0.57 3.822 0.336 7.544 0.664 11.164 0.98 3.616 0.304 7.104 0.688 10.526 0.738 0.23 0.008 0.452 0.016 0.682 0.026 0.614 34.812 29.008 62.846 63.968 62.846 0.542 0 1.080-0.028 1.62-0.042v0.022c0 0 0.090-0.012 0.224-0.028 3.878-0.11 7.674-0.55 11.35-1.322 1.748-0.204 3.662-0.426 5.776-0.672 1.884-0.222 3.912-0.462 6.076-0.718 2.566-0.376 5.292-0.772 8.176-1.192 5.746-0.856 12.124-1.8 18.958-2.908 6.446-1.348 13.414-2.804 20.864-4.362 3.718-0.712 7.504-1.778 11.406-2.786 3.892-1.026 7.894-2.080 12.004-3.162 2.044-0.566 4.132-1.040 6.208-1.708 2.074-0.656 4.174-1.318 6.3-1.988 4.232-1.348 8.564-2.726 12.988-4.134 1.104-0.354 2.21-0.708 3.324-1.066 1.1-0.406 2.206-0.814 3.316-1.226 2.216-0.824 4.456-1.658 6.714-2.5 4.496-1.698 9.078-3.424 13.74-5.182 4.568-1.968 9.216-3.97 13.936-6.004 2.348-1.018 4.714-2.044 7.098-3.078 2.376-1.048 4.702-2.27 7.074-3.408 4.714-2.322 9.494-4.678 14.33-7.062 4.786-2.47 9.512-5.208 14.328-7.846 2.398-1.336 4.808-2.678 7.23-4.028 2.41-1.366 4.75-2.9 7.14-4.354 4.738-2.952 9.524-5.93 14.35-8.936 18.89-12.64 37.564-26.674 55.278-42.21 17.574-15.712 34.248-32.726 49.602-50.69 15.136-18.182 28.902-37.264 41.112-56.728 12.036-19.602 22.314-39.644 31.142-59.376 2.042-5.002 4.062-9.964 6.068-14.878 0.974-2.462 2.032-4.868 2.918-7.334 0.87-2.472 1.732-4.932 2.592-7.376 1.686-4.898 3.468-9.678 4.994-14.484 1.432-4.832 2.846-9.604 4.24-14.31 0.674-2.358 1.43-4.66 2.016-7.004 0.57-2.348 1.138-4.676 1.702-6.988 1.118-4.606 2.216-9.14 3.296-13.602 0.868-4.502 1.72-8.928 2.558-13.272 0.41-2.164 0.818-4.308 1.222-6.434 0.2-1.060 0.398-2.116 0.596-3.164 0.148-1.062 0.296-2.118 0.444-3.168 0.582-4.19 1.152-8.292 1.708-12.3 0.278-1.996 0.55-3.97 0.82-5.922 0.284-1.946 0.376-3.902 0.568-5.812 0.336-3.822 0.664-7.546 0.98-11.164 0.304-3.616 0.686-7.106 0.738-10.528 0.020-0.534 0.040-1.044 0.058-1.574 35.224-0.146 63.732-28.738 63.732-63.992 0-0.542-0.028-1.080-0.042-1.62h0.022c0 0-0.012-0.090-0.028-0.224-0.11-3.878-0.55-7.674-1.322-11.35-0.204-1.748-0.428-3.662-0.674-5.776-0.222-1.886-0.46-3.914-0.718-6.076-0.374-2.566-0.77-5.294-1.19-8.176-0.856-5.746-1.8-12.124-2.908-18.958-1.348-6.444-2.804-13.414-4.364-20.862-0.71-3.72-1.776-7.506-2.786-11.408-1.024-3.892-2.078-7.894-3.16-12.002-0.566-2.044-1.040-4.134-1.708-6.208-0.656-2.076-1.32-4.174-1.988-6.3-1.348-4.234-2.726-8.566-4.136-12.99-0.352-1.102-0.708-2.21-1.064-3.324-0.408-1.1-0.814-2.206-1.226-3.316-0.826-2.216-1.658-4.454-2.502-6.714-1.696-4.498-3.422-9.080-5.18-13.74-1.968-4.57-3.97-9.216-6.004-13.936-1.020-2.348-2.044-4.714-3.078-7.098-1.048-2.376-2.27-4.702-3.408-7.076-2.322-4.714-4.678-9.494-7.062-14.33-2.47-4.786-5.208-9.512-7.846-14.328-1.336-2.398-2.68-4.808-4.028-7.23-1.368-2.41-2.902-4.75-4.356-7.14-2.95-4.74-5.93-9.524-8.934-14.35-12.64-18.892-26.676-37.564-42.21-55.278-15.712-17.576-32.726-34.25-50.692-49.602-18.18-15.136-37.264-28.902-56.726-41.112-19.604-12.036-39.644-22.314-59.376-31.142-5.004-2.040-9.964-4.062-14.878-6.068-2.462-0.974-4.868-2.032-7.336-2.918-2.47-0.87-4.93-1.734-7.376-2.592-4.898-1.684-9.678-3.468-14.484-4.994-4.832-1.432-9.604-2.846-14.312-4.242-2.356-0.672-4.66-1.428-7.004-2.014-2.346-0.572-4.676-1.138-6.986-1.702-4.606-1.118-9.142-2.216-13.604-3.298-4.5-0.868-8.926-1.72-13.27-2.558-2.166-0.412-4.31-0.82-6.434-1.222-1.062-0.2-2.118-0.398-3.166-0.596-1.060-0.148-2.118-0.296-3.166-0.442-4.192-0.584-8.292-1.154-12.3-1.71-1.998-0.276-3.972-0.55-5.922-0.82-1.946-0.284-3.904-0.376-5.814-0.57-3.822-0.336-7.544-0.664-11.164-0.98-3.616-0.304-7.104-0.686-10.526-0.738-0.852-0.032-1.674-0.062-2.512-0.092-0.65-34.78-29.028-62.778-63.966-62.778-0.542 0-1.080 0.028-1.62 0.042l-0.002-0.022c0 0-0.090 0.012-0.222 0.028-3.878 0.11-7.676 0.55-11.352 1.322-1.748 0.204-3.662 0.426-5.776 0.672-1.884 0.222-3.912 0.462-6.076 0.718-2.566 0.376-5.292 0.772-8.176 1.192-5.746 0.856-12.124 1.8-18.958 2.908-6.446 1.348-13.414 2.804-20.864 4.362-3.718 0.712-7.504 1.778-11.406 2.786-3.892 1.026-7.894 2.080-12.004 3.162-2.044 0.566-4.132 1.040-6.208 1.708-2.074 0.656-4.174 1.318-6.3 1.988-4.232 1.348-8.564 2.726-12.988 4.134-1.104 0.354-2.21 0.708-3.324 1.066-1.1 0.406-2.206 0.814-3.316 1.226-2.216 0.824-4.456 1.658-6.714 2.5-4.496 1.698-9.078 3.424-13.74 5.182-4.568 1.968-9.216 3.97-13.936 6.004-2.348 1.018-4.714 2.044-7.098 3.078-2.376 1.048-4.702 2.27-7.074 3.408-4.714 2.322-9.494 4.678-14.33 7.062-4.786 2.47-9.512 5.208-14.328 7.846-2.398 1.336-4.808 2.678-7.23 4.028-2.41 1.366-4.75 2.9-7.14 4.354-4.738 2.952-9.524 5.93-14.35 8.936-18.89 12.64-37.564 26.674-55.278 42.21-17.574 15.712-34.248 32.726-49.602 50.69-15.136 18.182-28.902 37.264-41.112 56.728-12.036 19.602-22.314 39.644-31.142 59.376-2.042 5.002-4.062 9.964-6.068 14.878-0.974 2.462-2.032 4.868-2.918 7.334-0.87 2.472-1.732 4.932-2.592 7.376-1.686 4.898-3.468 9.678-4.994 14.484-1.432 4.832-2.846 9.604-4.24 14.31-0.674 2.358-1.43 4.66-2.016 7.004-0.57 2.348-1.138 4.676-1.702 6.988-1.118 4.606-2.216 9.14-3.296 13.602-0.868 4.502-1.72 8.928-2.558 13.272-0.41 2.164-0.818 4.308-1.222 6.434-0.2 1.060-0.398 2.116-0.596 3.164-0.148 1.062-0.296 2.118-0.444 3.168-0.582 4.19-1.152 8.292-1.708 12.3-0.278 1.996-0.55 3.97-0.82 5.922-0.284 1.946-0.376 3.902-0.568 5.812-0.336 3.822-0.664 7.546-0.98 11.164-0.304 3.616-0.686 7.106-0.738 10.528-0.020 0.548-0.040 1.076-0.058 1.62-34.376 1.112-61.902 29.304-61.902 63.946 0 0.542 0.028 1.078 0.042 1.618zM73.518 448.706c0.042-0.196 0.086-0.384 0.128-0.58 0.644-3.248 1.632-6.542 2.556-9.942 0.934-3.388 1.894-6.876 2.88-10.454 0.516-1.78 0.934-3.602 1.546-5.406 0.596-1.802 1.202-3.628 1.81-5.476 1.218-3.682 2.464-7.45 3.736-11.294 0.316-0.958 0.634-1.924 0.956-2.892 0.37-0.954 0.74-1.914 1.114-2.876 0.746-1.924 1.5-3.868 2.26-5.83 1.52-3.904 3.070-7.882 4.646-11.93 1.768-3.96 3.566-7.99 5.392-12.080 0.908-2.038 1.824-4.090 2.746-6.156 0.932-2.060 2.036-4.072 3.052-6.126 2.070-4.084 4.17-8.222 6.294-12.412 2.202-4.142 4.654-8.224 6.998-12.392 1.184-2.074 2.374-4.16 3.57-6.256 1.21-2.086 2.586-4.102 3.876-6.166 2.616-4.098 5.256-8.232 7.918-12.402 11.234-16.298 23.632-32.398 37.33-47.638 13.874-15.104 28.842-29.404 44.598-42.548 15.974-12.928 32.686-24.65 49.676-35.022 17.13-10.194 34.6-18.838 51.734-26.258 4.35-1.7 8.662-3.382 12.934-5.050 2.136-0.812 4.216-1.71 6.36-2.444 2.146-0.714 4.28-1.428 6.404-2.136 4.25-1.386 8.382-2.888 12.548-4.142 4.184-1.174 8.314-2.332 12.392-3.474 2.038-0.55 4.026-1.19 6.054-1.662 2.030-0.458 4.044-0.914 6.044-1.368 3.978-0.91 7.896-1.806 11.748-2.688 3.888-0.686 7.71-1.36 11.462-2.022 1.868-0.33 3.716-0.658 5.546-0.98 0.914-0.162 1.824-0.324 2.728-0.484 0.916-0.112 1.828-0.222 2.734-0.332 3.612-0.448 7.148-0.882 10.604-1.31 1.72-0.216 3.422-0.432 5.102-0.644 1.674-0.226 3.364-0.266 5.010-0.408 3.292-0.238 6.498-0.472 9.616-0.7 3.11-0.218 6.11-0.524 9.058-0.508 5.848-0.132 11.32-0.256 16.38-0.372 4.664 0.168 8.948 0.324 12.818 0.462 1.914 0.054 3.726 0.108 5.432 0.156 2.122 0.134 4.108 0.26 5.958 0.378 2.13 0.138 4.060 0.266 5.82 0.38 3.256 0.51 6.592 0.782 9.99 0.782 0.466 0 0.93-0.026 1.396-0.036 0.132 0.008 0.224 0.014 0.224 0.014v-0.020c31.14-0.778 56.75-23.784 61.556-53.754 0.542 0.12 1.064 0.236 1.612 0.356 3.246 0.644 6.542 1.632 9.942 2.556 3.386 0.934 6.876 1.894 10.454 2.88 1.778 0.516 3.602 0.934 5.404 1.546 1.802 0.596 3.63 1.202 5.478 1.812 3.68 1.218 7.448 2.464 11.292 3.736 0.96 0.316 1.924 0.634 2.892 0.956 0.956 0.37 1.914 0.74 2.876 1.112 1.926 0.746 3.868 1.5 5.83 2.26 3.904 1.52 7.884 3.070 11.932 4.646 3.96 1.768 7.988 3.566 12.080 5.392 2.038 0.908 4.088 1.824 6.156 2.746 2.060 0.932 4.072 2.036 6.126 3.054 4.082 2.070 8.222 4.17 12.41 6.294 4.144 2.202 8.226 4.654 12.394 6.998 2.074 1.184 4.16 2.374 6.256 3.572 2.086 1.21 4.102 2.586 6.166 3.876 4.098 2.616 8.23 5.256 12.402 7.918 16.296 11.234 32.398 23.632 47.636 37.33 15.104 13.874 29.406 28.842 42.55 44.598 12.928 15.974 24.648 32.686 35.020 49.676 10.196 17.13 18.84 34.6 26.26 51.736 1.698 4.348 3.382 8.662 5.050 12.932 0.812 2.136 1.71 4.216 2.444 6.36 0.714 2.146 1.428 4.28 2.136 6.404 1.386 4.25 2.888 8.384 4.142 12.548 1.174 4.184 2.33 8.316 3.474 12.392 0.55 2.038 1.19 4.026 1.66 6.054 0.46 2.030 0.916 4.046 1.368 6.046 0.91 3.978 1.808 7.896 2.688 11.748 0.688 3.888 1.362 7.71 2.024 11.462 0.33 1.868 0.656 3.716 0.98 5.548 0.162 0.914 0.324 1.824 0.484 2.728 0.11 0.916 0.222 1.828 0.332 2.734 0.446 3.612 0.882 7.148 1.31 10.604 0.216 1.72 0.432 3.42 0.642 5.1 0.226 1.674 0.268 3.364 0.41 5.010 0.238 3.292 0.472 6.498 0.7 9.616 0.218 3.11 0.524 6.11 0.508 9.058 0.132 5.848 0.256 11.32 0.372 16.38-0.168 4.664-0.324 8.948-0.462 12.818-0.054 1.914-0.108 3.726-0.156 5.432-0.134 2.122-0.26 4.108-0.378 5.958-0.138 2.13-0.266 4.060-0.38 5.82-0.498 3.256-0.768 6.592-0.768 9.99 0 0.468 0.026 0.93 0.036 1.396-0.008 0.132-0.016 0.224-0.016 0.224h0.022c0.768 30.766 23.236 56.128 52.682 61.37-0.066 0.296-0.13 0.584-0.198 0.884-0.644 3.248-1.632 6.542-2.556 9.942-0.934 3.388-1.894 6.876-2.88 10.454-0.516 1.78-0.934 3.602-1.546 5.406-0.596 1.802-1.202 3.628-1.81 5.476-1.218 3.682-2.464 7.45-3.736 11.294-0.316 0.958-0.634 1.924-0.956 2.892-0.37 0.954-0.74 1.914-1.114 2.876-0.746 1.924-1.5 3.868-2.26 5.83-1.52 3.904-3.070 7.882-4.646 11.93-1.768 3.96-3.566 7.99-5.392 12.080-0.908 2.038-1.824 4.090-2.746 6.156-0.932 2.060-2.036 4.072-3.052 6.126-2.070 4.084-4.17 8.222-6.294 12.412-2.202 4.142-4.654 8.224-6.998 12.392-1.184 2.074-2.374 4.16-3.57 6.256-1.21 2.086-2.586 4.102-3.876 6.166-2.616 4.098-5.256 8.232-7.918 12.402-11.234 16.298-23.632 32.398-37.33 47.638-13.874 15.104-28.842 29.404-44.598 42.548-15.974 12.928-32.686 24.65-49.676 35.022-17.13 10.194-34.6 18.838-51.734 26.258-4.35 1.7-8.662 3.382-12.934 5.050-2.136 0.812-4.216 1.71-6.36 2.444-2.146 0.714-4.28 1.428-6.404 2.136-4.25 1.386-8.382 2.888-12.548 4.142-4.184 1.174-8.314 2.332-12.392 3.474-2.038 0.55-4.026 1.19-6.054 1.662-2.030 0.458-4.044 0.914-6.044 1.368-3.978 0.91-7.896 1.806-11.748 2.688-3.888 0.686-7.71 1.36-11.462 2.022-1.868 0.33-3.716 0.658-5.546 0.98-0.914 0.162-1.824 0.324-2.728 0.484-0.916 0.112-1.828 0.222-2.734 0.332-3.612 0.448-7.148 0.882-10.604 1.31-1.72 0.216-3.422 0.432-5.102 0.644-1.674 0.226-3.364 0.266-5.010 0.408-3.292 0.238-6.498 0.472-9.616 0.7-3.11 0.218-6.11 0.524-9.058 0.508-5.848 0.132-11.32 0.256-16.38 0.372-4.664-0.168-8.948-0.324-12.818-0.462-1.914-0.054-3.726-0.108-5.432-0.156-2.122-0.134-4.108-0.26-5.958-0.378-2.13-0.138-4.060-0.266-5.82-0.38-3.256-0.51-6.592-0.782-9.99-0.782-0.466 0-0.93 0.026-1.396 0.036-0.132-0.008-0.224-0.014-0.224-0.014v0.020c-31.004 0.774-56.524 23.586-61.488 53.364-3.2-0.64-6.446-1.61-9.792-2.522-3.386-0.934-6.876-1.894-10.454-2.878-1.778-0.516-3.602-0.938-5.404-1.546-1.802-0.598-3.63-1.204-5.478-1.812-3.68-1.218-7.448-2.464-11.292-3.738-0.96-0.316-1.924-0.632-2.892-0.954-0.956-0.372-1.914-0.742-2.876-1.114-1.926-0.746-3.868-1.5-5.83-2.258-3.904-1.524-7.884-3.070-11.932-4.648-3.96-1.77-7.988-3.566-12.080-5.39-2.038-0.91-4.088-1.824-6.156-2.746-2.060-0.934-4.072-2.036-6.126-3.054-4.082-2.070-8.222-4.172-12.41-6.296-4.144-2.2-8.226-4.652-12.394-6.996-2.074-1.184-4.16-2.376-6.256-3.57-2.086-1.21-4.102-2.586-6.166-3.878-4.098-2.614-8.23-5.254-12.402-7.918-16.296-11.23-32.398-23.632-47.636-37.328-15.104-13.876-29.406-28.84-42.55-44.598-12.928-15.972-24.648-32.684-35.020-49.676-10.196-17.128-18.84-34.602-26.26-51.734-1.698-4.352-3.382-8.664-5.050-12.934-0.812-2.136-1.71-4.218-2.444-6.36-0.714-2.148-1.428-4.282-2.136-6.406-1.386-4.25-2.888-8.382-4.142-12.546-1.174-4.184-2.33-8.316-3.474-12.394-0.55-2.036-1.19-4.024-1.66-6.054-0.46-2.028-0.916-4.042-1.368-6.042-0.91-3.98-1.808-7.898-2.688-11.75-0.688-3.886-1.362-7.71-2.024-11.46-0.33-1.868-0.656-3.718-0.98-5.546-0.162-0.914-0.324-1.824-0.484-2.73-0.11-0.914-0.222-1.828-0.332-2.734-0.446-3.61-0.882-7.148-1.31-10.602-0.216-1.722-0.432-3.422-0.642-5.102-0.226-1.676-0.268-3.364-0.41-5.012-0.238-3.29-0.472-6.496-0.7-9.614-0.218-3.11-0.524-6.11-0.508-9.058-0.132-5.848-0.256-11.32-0.372-16.382 0.168-4.664 0.324-8.946 0.462-12.816 0.054-1.914 0.108-3.726 0.156-5.434 0.134-2.122 0.26-4.106 0.378-5.958 0.138-2.128 0.266-4.058 0.38-5.82 0.496-3.26 0.766-6.596 0.766-9.994 0-0.466-0.026-0.93-0.036-1.396 0.008-0.132 0.016-0.224 0.016-0.224h-0.022c-0.78-31.38-24.134-57.154-54.44-61.674z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60203,
					"grid": 16
				},
				{
					"id": 2369,
					"paths": [
						"M1024 384h-384l143.53-143.53c-72.53-72.526-168.96-112.47-271.53-112.47s-199 39.944-271.53 112.47c-72.526 72.53-112.47 168.96-112.47 271.53s39.944 199 112.47 271.53c72.53 72.526 168.96 112.47 271.53 112.47s199-39.944 271.528-112.472c6.056-6.054 11.86-12.292 17.456-18.668l96.32 84.282c-93.846 107.166-231.664 174.858-385.304 174.858-282.77 0-512-229.23-512-512s229.23-512 512-512c141.386 0 269.368 57.326 362.016 149.984l149.984-149.984v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"refresh",
						"repeat",
						"busy",
						"wait",
						"arrow"
					],
					"defaultCode": 60204,
					"grid": 16
				},
				{
					"id": 1422,
					"width": 1024,
					"paths": [
						"M300.571 796.571q0 30.286-21.429 51.714t-51.714 21.429q-29.714 0-51.429-21.714t-21.714-51.429q0-30.286 21.429-51.714t51.714-21.429 51.714 21.429 21.429 51.714zM585.143 914.286q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM182.857 512q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM869.714 796.571q0 29.714-21.714 51.429t-51.429 21.714q-30.286 0-51.714-21.429t-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM318.857 227.429q0 37.714-26.857 64.571t-64.571 26.857-64.571-26.857-26.857-64.571 26.857-64.571 64.571-26.857 64.571 26.857 26.857 64.571zM987.429 512q0 30.286-21.429 51.714t-51.714 21.429-51.714-21.429-21.429-51.714 21.429-51.714 51.714-21.429 51.714 21.429 21.429 51.714zM621.714 109.714q0 45.714-32 77.714t-77.714 32-77.714-32-32-77.714 32-77.714 77.714-32 77.714 32 32 77.714zM924.571 227.429q0 53.143-37.714 90.571t-90.286 37.429q-53.143 0-90.571-37.429t-37.429-90.571q0-52.571 37.429-90.286t90.571-37.714q52.571 0 90.286 37.714t37.714 90.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner"
					],
					"defaultCode": 61712,
					"grid": 14
				},
				{
					"id": 2360,
					"paths": [
						"M1024 512c-1.278-66.862-15.784-133.516-42.576-194.462-26.704-61-65.462-116.258-113.042-161.92-47.552-45.696-103.944-81.82-164.984-105.652-61.004-23.924-126.596-35.352-191.398-33.966-64.81 1.282-129.332 15.374-188.334 41.356-59.048 25.896-112.542 63.47-156.734 109.576-44.224 46.082-79.16 100.708-102.186 159.798-23.114 59.062-34.128 122.52-32.746 185.27 1.286 62.76 14.964 125.148 40.134 182.206 25.088 57.1 61.476 108.828 106.11 151.548 44.61 42.754 97.472 76.504 154.614 98.72 57.118 22.304 118.446 32.902 179.142 31.526 60.708-1.29 120.962-14.554 176.076-38.914 55.15-24.282 105.116-59.48 146.366-102.644 41.282-43.14 73.844-94.236 95.254-149.43 13.034-33.458 21.88-68.4 26.542-103.798 1.246 0.072 2.498 0.12 3.762 0.12 35.346 0 64-28.652 64-64 0-1.796-0.094-3.572-0.238-5.332h0.238zM922.306 681.948c-23.472 53.202-57.484 101.4-99.178 141.18-41.67 39.81-91 71.186-144.244 91.79-53.228 20.678-110.29 30.452-166.884 29.082-56.604-1.298-112.596-13.736-163.82-36.474-51.25-22.666-97.684-55.49-135.994-95.712-38.338-40.198-68.528-87.764-88.322-139.058-19.87-51.284-29.228-106.214-27.864-160.756 1.302-54.552 13.328-108.412 35.254-157.69 21.858-49.3 53.498-93.97 92.246-130.81 38.73-36.868 84.53-65.87 133.874-84.856 49.338-19.060 102.136-28.006 154.626-26.644 52.5 1.306 104.228 12.918 151.562 34.034 47.352 21.050 90.256 51.502 125.624 88.782 35.396 37.258 63.21 81.294 81.39 128.688 18.248 47.392 26.782 98.058 25.424 148.496h0.238c-0.144 1.76-0.238 3.536-0.238 5.332 0 33.012 24.992 60.174 57.086 63.624-6.224 34.822-16.53 68.818-30.78 100.992z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60195,
					"grid": 16
				},
				{
					"id": 2361,
					"paths": [
						"M512 303.096c-32.964 0-59.686-26.724-59.686-59.686v-179.060c0-32.964 26.722-59.686 59.686-59.686 32.962 0 59.688 26.722 59.688 59.686v179.060c0 32.964-26.726 59.686-59.688 59.686z",
						"M512 996.956c-20.602 0-37.304-16.702-37.304-37.304v-179.060c0-20.602 16.702-37.304 37.304-37.304 20.604 0 37.304 16.704 37.304 37.304v179.060c0 20.602-16.7 37.304-37.304 37.304z",
						"M377.756 335.36c-19.34 0-38.146-10.034-48.512-27.988l-89.53-155.070c-15.452-26.764-6.282-60.986 20.482-76.438 26.762-15.45 60.986-6.284 76.438 20.482l89.53 155.072c15.452 26.764 6.282 60.986-20.482 76.438-8.81 5.084-18.432 7.504-27.926 7.504z",
						"M735.856 933.256c-11.602 0-22.886-6.022-29.108-16.792l-89.53-155.070c-9.27-16.056-3.77-36.592 12.29-45.864 16.056-9.264 36.59-3.77 45.864 12.292l89.532 155.068c9.27 16.058 3.768 36.592-12.292 45.864-5.286 3.048-11.060 4.502-16.756 4.502z",
						"M279.344 429.94c-8.86 0-17.838-2.256-26.064-7.006l-155.072-89.53c-24.978-14.422-33.538-46.362-19.116-71.342 14.42-24.978 46.364-33.538 71.342-19.116l155.070 89.53c24.98 14.422 33.538 46.362 19.116 71.34-9.668 16.756-27.226 26.124-45.276 26.124z",
						"M899.648 765.674c-5.064 0-10.196-1.29-14.894-4.004l-155.068-89.53c-14.274-8.24-19.164-26.494-10.924-40.768 8.242-14.276 26.496-19.166 40.766-10.924l155.070 89.532c14.274 8.24 19.164 26.492 10.924 40.766-5.53 9.574-15.562 14.928-25.874 14.928z",
						"M243.41 560.496h-179.060c-26.784 0-48.496-21.712-48.496-48.496s21.712-48.496 48.496-48.496h179.060c26.784 0 48.496 21.712 48.496 48.496s-21.712 48.496-48.496 48.496z",
						"M959.65 541.844c-0.002 0 0 0 0 0h-179.060c-16.482-0.002-29.844-13.364-29.844-29.844s13.364-29.844 29.844-29.844c0.002 0 0 0 0 0h179.060c16.482 0 29.844 13.362 29.844 29.844 0 16.48-13.364 29.844-29.844 29.844z",
						"M124.366 780.598c-15.472 0-30.518-8.028-38.81-22.39-12.362-21.41-5.026-48.79 16.384-61.148l155.072-89.532c21.41-12.368 48.79-5.028 61.15 16.384 12.362 21.412 5.026 48.79-16.384 61.15l-155.072 89.53c-7.050 4.070-14.748 6.006-22.34 6.006z",
						"M744.632 407.552c-10.314 0-20.346-5.352-25.874-14.926-8.24-14.274-3.35-32.526 10.924-40.768l155.070-89.528c14.272-8.236 32.526-3.352 40.768 10.922 8.24 14.274 3.35 32.526-10.924 40.768l-155.070 89.528c-4.7 2.714-9.83 4.004-14.894 4.004z",
						"M288.136 940.716c-6.962 0-14.016-1.774-20.48-5.504-19.626-11.332-26.35-36.428-15.020-56.054l89.53-155.070c11.33-19.628 36.426-26.352 56.054-15.022 19.626 11.332 26.35 36.43 15.020 56.054l-89.53 155.072c-7.598 13.166-21.392 20.524-35.574 20.524z",
						"M646.266 309.242c-5.062 0-10.196-1.29-14.894-4.002-14.274-8.242-19.164-26.494-10.924-40.766l89.534-155.070c8.24-14.274 26.492-19.166 40.766-10.922 14.274 8.242 19.164 26.494 10.924 40.766l-89.532 155.070c-5.53 9.57-15.56 14.924-25.874 14.924z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60196,
					"grid": 16
				},
				{
					"id": 2362,
					"paths": [
						"M192 512c0-12.18 0.704-24.196 2.030-36.022l-184.98-60.104c-5.916 31.14-9.050 63.264-9.050 96.126 0 147.23 62.166 279.922 161.654 373.324l114.284-157.296c-52.124-56.926-83.938-132.758-83.938-216.028zM832 512c0 83.268-31.812 159.102-83.938 216.028l114.284 157.296c99.488-93.402 161.654-226.094 161.654-373.324 0-32.862-3.132-64.986-9.048-96.126l-184.98 60.104c1.324 11.828 2.028 23.842 2.028 36.022zM576 198.408c91.934 18.662 169.544 76.742 214.45 155.826l184.978-60.102c-73.196-155.42-222.24-268.060-399.428-290.156v194.432zM233.55 354.232c44.906-79.084 122.516-137.164 214.45-155.826v-194.43c-177.188 22.096-326.23 134.736-399.426 290.154l184.976 60.102zM644.556 803.328c-40.39 18.408-85.272 28.672-132.556 28.672s-92.166-10.264-132.554-28.67l-114.292 157.31c73.206 40.366 157.336 63.36 246.846 63.36s173.64-22.994 246.848-63.36l-114.292-157.312z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60197,
					"grid": 16
				},
				{
					"id": 2363,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 256c141.384 0 256 114.616 256 256s-114.616 256-256 256-256-114.616-256-256 114.616-256 256-256zM817.47 817.47c-81.594 81.594-190.080 126.53-305.47 126.53-115.392 0-223.876-44.936-305.47-126.53s-126.53-190.078-126.53-305.47c0-115.39 44.936-223.876 126.53-305.47l67.882 67.882c0 0 0 0 0 0-131.006 131.006-131.006 344.17 0 475.176 63.462 63.462 147.838 98.412 237.588 98.412 89.748 0 174.124-34.95 237.588-98.412 131.006-131.006 131.006-344.168 0-475.176l67.882-67.882c81.594 81.594 126.53 190.080 126.53 305.47 0 115.392-44.936 223.876-126.53 305.47z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60198,
					"grid": 16
				},
				{
					"id": 2364,
					"paths": [
						"M384 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM790.994 512c0 0 0 0 0 0 0-57.993 47.013-105.006 105.006-105.006s105.006 47.013 105.006 105.006c0 0 0 0 0 0 0 57.993-47.013 105.006-105.006 105.006s-105.006-47.013-105.006-105.006zM688.424 783.53c0-52.526 42.58-95.106 95.106-95.106s95.106 42.58 95.106 95.106c0 52.526-42.58 95.106-95.106 95.106s-95.106-42.58-95.106-95.106zM425.862 896c0-47.573 38.565-86.138 86.138-86.138s86.138 38.565 86.138 86.138c0 47.573-38.565 86.138-86.138 86.138s-86.138-38.565-86.138-86.138zM162.454 783.53c0-43.088 34.93-78.018 78.018-78.018s78.018 34.93 78.018 78.018c0 43.088-34.93 78.018-78.018 78.018s-78.018-34.93-78.018-78.018zM57.338 512c0-39.026 31.636-70.662 70.662-70.662s70.662 31.636 70.662 70.662c0 39.026-31.636 70.662-70.662 70.662s-70.662-31.636-70.662-70.662zM176.472 240.472c0 0 0 0 0 0 0-35.346 28.654-64 64-64s64 28.654 64 64c0 0 0 0 0 0 0 35.346-28.654 64-64 64s-64-28.654-64-64zM899.464 240.472c0 64.024-51.906 115.934-115.936 115.934-64.024 0-115.936-51.91-115.936-115.934 0-64.032 51.912-115.934 115.936-115.934 64.030 0 115.936 51.902 115.936 115.934z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60199,
					"grid": 16
				},
				{
					"id": 2365,
					"paths": [
						"M416 928c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM0 512c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM832 512c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM121.844 217.844c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM710.156 806.156c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM121.844 806.156c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM710.156 217.844c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60200,
					"grid": 16
				},
				{
					"id": 2366,
					"paths": [
						"M512 1024c-136.76 0-265.334-53.258-362.040-149.96-96.702-96.706-149.96-225.28-149.96-362.040 0-96.838 27.182-191.134 78.606-272.692 50-79.296 120.664-143.372 204.356-185.3l43 85.832c-68.038 34.084-125.492 86.186-166.15 150.67-41.746 66.208-63.812 142.798-63.812 221.49 0 229.382 186.618 416 416 416s416-186.618 416-416c0-78.692-22.066-155.282-63.81-221.49-40.66-64.484-98.114-116.584-166.15-150.67l43-85.832c83.692 41.928 154.358 106.004 204.356 185.3 51.422 81.558 78.604 175.854 78.604 272.692 0 136.76-53.258 265.334-149.96 362.040-96.706 96.702-225.28 149.96-362.040 149.96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60201,
					"grid": 16
				},
				{
					"id": 2367,
					"paths": [
						"M512 0c-278.748 0-505.458 222.762-511.848 499.974 5.92-241.864 189.832-435.974 415.848-435.974 229.75 0 416 200.576 416 448 0 53.020 42.98 96 96 96s96-42.98 96-96c0-282.77-229.23-512-512-512zM512 1024c278.748 0 505.458-222.762 511.848-499.974-5.92 241.864-189.832 435.974-415.848 435.974-229.75 0-416-200.576-416-448 0-53.020-42.98-96-96-96s-96 42.98-96 96c0 282.77 229.23 512 512 512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"busy",
						"wait"
					],
					"defaultCode": 60202,
					"grid": 16
				},
				{
					"id": 3016,
					"paths": [
						"M352 0h-352v352l130.746-130.746 317.254 317.256v485.49h128v-538.51l-354.744-354.744z",
						"M960 0h-352l130.746 130.746-192 192 90.508 90.51 192-192.002 130.746 130.746z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"split",
						"arrows"
					],
					"defaultCode": 60851,
					"grid": 16
				},
				{
					"id": 1139,
					"width": 1024,
					"paths": [
						"M991.936 478.272c-14.752-272.704-216.896-478.368-470.208-478.368l-10.432 0.096c-268.768 6.016-479.296 216.832-479.296 480v448c0 38.592 25.568 96 96 96s96-57.408 96-95.616c0.384-14.784 6.208-32.384 32-32.384s31.616 17.6 32 32c0 38.592 25.568 96 96 96s96-57.408 96-95.616c0.384-14.784 6.208-32.384 32-32.384s31.616 17.6 32 32c0 38.592 25.568 96 96 96s96-57.408 96-95.616c0.384-14.784 6.208-32.384 32-32.384s31.616 17.6 32 32c0 38.592 25.568 96 96 96s96-57.408 96-96c0 0 0.768-434.752-0.064-449.728zM928 927.616c-0.384 14.784-6.208 32.384-32 32.384s-31.616-17.6-32-32c0-38.592-25.568-96-96-96s-96 57.408-96 95.616c-0.384 14.784-6.208 32.384-32 32.384s-31.616-17.6-32-32c0-38.592-25.568-96-96-96s-96 57.408-96 95.616c-0.384 14.784-6.208 32.384-32 32.384s-31.616-17.6-32-32c0-38.592-25.568-96-96-96s-96 57.408-96 95.616c-0.384 14.784-6.208 32.384-32 32.384s-31.616-17.6-32-32v-448c0-228.064 183.040-410.784 416.704-416l8.992-0.096c218.752 0 393.408 179.616 406.336 417.856 0.704 12.512-0.032 445.856-0.032 445.856zM384 384c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM384 480c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM640 384c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM640 480c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spook",
						"believe",
						"cease",
						"scare",
						"visit"
					],
					"grid": 32
				},
				{
					"id": 1571,
					"width": 438.8600158691406,
					"paths": [
						"M402.286 301.714q0 82.857-32.571 139.143t-86.857 77.429l25.714 469.143q1.143 14.857-9.143 25.714t-25.143 10.857h-109.714q-14.857 0-25.143-10.857t-9.143-25.714l25.714-469.143q-54.286-21.143-86.857-77.429t-32.571-139.143q0-73.143 24.286-142.571t67.143-114.286 91.429-44.857 91.429 44.857 67.143 114.286 24.286 142.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spoon"
					],
					"defaultCode": 61873,
					"grid": 14
				},
				{
					"id": 2513,
					"paths": [
						"M224 0c-106.040 0-192 100.288-192 224 0 105.924 63.022 194.666 147.706 217.998l-31.788 518.124c-2.154 35.132 24.882 63.878 60.082 63.878h32c35.2 0 62.236-28.746 60.082-63.878l-31.788-518.124c84.684-23.332 147.706-112.074 147.706-217.998 0-123.712-85.96-224-192-224zM869.334 0l-53.334 320h-40l-26.666-320h-26.668l-26.666 320h-40l-53.334-320h-26.666v416c0 17.672 14.326 32 32 32h83.338l-31.42 512.122c-2.154 35.132 24.882 63.878 60.082 63.878h32c35.2 0 62.236-28.746 60.082-63.878l-31.42-512.122h83.338c17.674 0 32-14.328 32-32v-416h-26.666z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spoon-knife",
						"food",
						"restaurant"
					],
					"defaultCode": 60348,
					"grid": 16
				},
				{
					"id": 3336,
					"paths": [
						"M512 0c-281.6 0-512 230.4-512 512s230.4 512 512 512 512-230.4 512-512-227.8-512-512-512zM747.6 739.8c-10.2 15.4-28.2 20.4-43.6 10.2-120.4-74.2-271.4-89.6-450.6-48.6-18 5.2-33.2-7.6-38.4-23-5.2-18 7.6-33.2 23-38.4 194.6-43.6 363.6-25.6 496.6 56.4 18 7.6 20.6 28 13 43.4zM809 599c-12.8 18-35.8 25.6-53.8 12.8-138.2-84.4-348.2-110-509.4-58.8-20.4 5.2-43.6-5.2-48.6-25.6-5.2-20.4 5.2-43.6 25.6-48.6 186.8-56.4 417.2-28.2 576 69.2 15.2 7.6 23 33.2 10.2 51zM814 455.6c-163.8-97.2-437.8-107.6-594-58.8-25.6 7.6-51.2-7.6-58.8-30.8-7.6-25.6 7.6-51.2 30.8-58.8 181.8-53.8 481.2-43.6 670.8 69.2 23 12.8 30.8 43.6 18 66.6-13 17.8-43.6 25.4-66.8 12.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spotify",
						"brand",
						"social"
					],
					"defaultCode": 61171,
					"grid": 16
				},
				{
					"id": 1582,
					"width": 877.7139282226562,
					"paths": [
						"M644 691.429q0-18.286-17.143-29.143-110.286-65.714-255.429-65.714-76 0-164 19.429-24 5.143-24 29.714 0 11.429 7.714 19.714t20.286 8.286q2.857 0 21.143-4.571 75.429-15.429 138.857-15.429 129.143 0 226.857 58.857 10.857 6.286 18.857 6.286 10.857 0 18.857-7.714t8-19.714zM698.857 568.571q0-22.857-20-34.857-135.429-80.571-313.143-80.571-87.429 0-173.143 24-27.429 7.429-27.429 36.571 0 14.286 10 24.286t24.286 10q4 0 21.143-4.571 69.714-18.857 143.429-18.857 159.429 0 278.857 70.857 13.714 7.429 21.714 7.429 14.286 0 24.286-10t10-24.286zM760.571 426.857q0-26.857-22.857-40-72-41.714-167.429-63.143t-196-21.429q-116.571 0-208 26.857-13.143 4-22 14.571t-8.857 27.714q0 17.714 11.714 29.714t29.429 12q6.286 0 22.857-4.571 76-21.143 175.429-21.143 90.857 0 176.857 19.429t144.857 54.286q12 6.857 22.857 6.857 16.571 0 28.857-11.714t12.286-29.429zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spotify"
					],
					"defaultCode": 61884,
					"grid": 14
				},
				{
					"id": 2570,
					"paths": [
						"M128 0h704v64h-704v-64z",
						"M320 320v704h320v-704l168-224h-656l168 224zM576 672c0 53.020-42.98 96-96 96s-96-42.98-96-96v-128c0-53.020 42.98-96 96-96s96 42.98 96 96v128z",
						"M480 704c-17.672 0-32-14.326-32-32v-64c0-17.674 14.328-32 32-32s32 14.326 32 32v64c0 17.674-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spotlight",
						"light",
						"flashlight"
					],
					"defaultCode": 60405,
					"grid": 16
				},
				{
					"id": 2768,
					"paths": [
						"M997.216 879.078c0.006 0.004 0.010 0.008 0.016 0.012l-7.010-7.090h-2.268c-8.438-5.864-18.166-11.23-28.974-16h15.422l-15.822-16h-49.76c-23.528-5.14-49.504-8-76.82-8-27.324 0-53.306 2.86-76.838 8.004 0.006-0.002 0.012-0.002 0.018-0.004h-169.704l8.712 16h110.83c0.002 0 0.004-0.002 0.006-0.002-10.814 4.772-20.546 10.14-28.986 16.006 0.002 0 0.004-0.002 0.006-0.004h-73.14l8.712 16h45.802c0.004-0.004 0.008-0.008 0.012-0.012-4.696 5.114-8.528 10.464-11.384 16.016 0.002-0.002 0.002-0.004 0.002-0.004h-25.716l8.712 16h11.624c0.002-0.010 0.004-0.018 0.006-0.028-0.44 2.648-0.674 5.324-0.674 8.028 0 2.696 0.234 5.362 0.668 8h-2.908l6.030 11.072 0.006-0.002c17.688 43.884 95.226 76.93 188.204 76.93 106.040 0 192-42.98 192-96 0-17.87-9.776-34.596-26.784-48.922zM661.51 883.816c0 0.002-0.002 0.002-0.004 0.004 0.002-0.002 0.004-0.002 0.004-0.004zM642.764 911.716c-0.044 0.13-0.086 0.262-0.13 0.392 0.042-0.13 0.084-0.26 0.13-0.392zM644.368 907.582c-0.078 0.18-0.158 0.36-0.234 0.54 0.074-0.182 0.156-0.36 0.234-0.54zM642.72 944.152c0.032 0.092 0.058 0.186 0.092 0.278-0.030-0.092-0.060-0.186-0.092-0.278zM641.212 938.786c0.004 0.016 0.008 0.032 0.010 0.044-0.002-0.014-0.006-0.030-0.010-0.044zM641.886 941.458c0.024 0.078 0.042 0.158 0.066 0.236-0.022-0.078-0.044-0.158-0.066-0.236zM358.43 840c-31.37-5.14-66.006-8-102.43-8-36.422 0-71.058 2.86-102.426 8h-79.752l-16.878 16h29.746c0.036-0.012 0.076-0.024 0.112-0.036-14.456 4.778-27.462 10.156-38.74 16.036h-7.998l-16.88 16h0.044c-14.906 12.178-23.228 25.722-23.228 40 0 53.020 114.616 96 256 96 130.168 0 237.64-36.432 253.874-83.588l0.042 0.004 2.114-4.416h-0.922c0.58-2.638 0.892-5.304 0.892-8s-0.312-5.366-0.892-8.004c0 0.002 0 0.002 0 0.004h8.58l7.658-16h-23.412c-3.804-5.542-8.91-10.89-15.162-16h46.232l7.656-16h-78.72c0 0 0.002 0.002 0.004 0.002-11.25-5.866-24.222-11.232-38.636-16.002h125.012l7.658-16h-199.55c-0.002 0 0 0 0.002 0zM506.49 908.122c-0.102-0.18-0.208-0.36-0.312-0.54 0.104 0.18 0.21 0.36 0.312 0.54zM508.488 912.108c-0.058-0.128-0.114-0.26-0.172-0.388 0.060 0.128 0.114 0.256 0.172 0.388zM467.474 873.89v0 0zM864.28 200h-115.274l-16.882 16h124.5zM848.964 232h-133.718l-16.878 16h142.938zM894.91 136h-78.386l-16.88 16h87.608zM879.596 168h-96.832l-16.88 16h106.054zM910.226 104h-59.942l-16.882 16h69.166zM925.542 72h-41.5l-16.88 16h50.72zM956.172 8h-4.612l-16.88 16h13.834zM940.856 40h-23.056l-16.878 16h32.278zM818.334 296h-170.606l-16.88 16h179.83zM833.65 264h-152.164l-16.878 16h161.384zM787.704 360h-207.496l-16.878 16h216.716zM803.020 328h-189.052l-16.878 16h198.272zM942.76 824l-15.82-16h-353.648l7.658-16h330.17l-15.822-16h-306.69l7.658-16h283.212l-15.82-16h-259.736l7.658-16h236.256l-15.82-16h-212.778l7.656-16h189.302l-15.82-16h-165.824l7.658-16h142.344l-15.82-16h-118.866l7.658-16h95.388l-15.822-16h-71.908l7.656-16h48.432l-15.82-16h-24.954l7.658-16h1.474l-0.994-1.006 7.176-14.994h-22.002l-15.82-16h45.48l7.658-16h-68.958l-15.822-16h92.438l7.658-16h-115.916l-15.82-16h139.394l7.656-16h-162.872l-15.82-16h186.35l7.658-16h-209.828l-15.82-16h233.304l7.658-16h-225.936l-15.924 15.092-14.924-15.092h-174.116l8.716 16h179.366l-16.878 16h-153.776l8.714 16h128.182l-16.88 16h-102.588l8.714 16h76.994l-16.88 16h-51.4l8.714 16h25.808l-16.88 16h-0.214l0.072 0.134-16.738 15.866h25.38l8.712 16h-50.97l-16.88 16h76.564l8.714 16h-102.158l-16.88 16h127.752l8.714 16h-153.346l-16.88 16h178.94l8.714 16h-204.532l-16.88 16h230.126l8.714 16h-255.72l-16.878 16h281.312l8.714 16h-306.906l-16.88 16h332.498l8.716 16h-358.094l-16.88 16h383.686l8.716 16h-409.282l-16.878 16h434.872l8.714 16h-460.466l-16.88 16h474.93l5.206-10.876 5.924 10.876zM228.208 184h81.728l-15.82-16h-74.62zM193.354 120h53.3l-15.82-16h-46.194zM210.782 152h67.514l-15.822-16h-60.406zM175.926 88h39.088l-15.822-16h-31.98zM151.73 24l-15.82-16h-3.552l8.712 16zM263.064 248h110.154l-15.82-16h-103.048zM158.498 56h24.874l-15.82-16h-17.768zM245.636 216h95.942l-15.82-16h-88.836zM297.92 312h138.582l-15.822-16h-131.474zM280.492 280h124.368l-15.82-16h-117.262zM315.348 344h152.794l-15.82-16h-145.688zM332.776 376h167.008l-15.822-16h-159.9z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spotlight",
						"featured",
						"lights",
						"dualtone",
						"highlight"
					],
					"defaultCode": 60603,
					"grid": 16
				},
				{
					"id": 1854,
					"paths": [
						"M512 224c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M384 224c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M384 96c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M256 224c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M128 224c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M64 288c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M192 160c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M128 96c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M64 160c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M64 32c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M320 160c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M256 96c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M192 32c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M320 288c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M192 288c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M128 352c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M448 160c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M924.782 275.702c-26.964-6.742-58.526-11.856-92.782-15.192v-100.51c0-17.672-42.98-32-96-32s-96 14.328-96 32v32h32c17.674 0 32 14.328 32 32s-14.326 33.95-32 33.95l-0.008 0.006c-46.632 2.896-89.594 8.952-124.774 17.746-24.538 6.134-99.218 24.804-99.218 76.298v576c0 51.496 74.68 70.164 99.218 76.3 50.816 12.704 117.86 19.7 188.782 19.7s137.964-6.996 188.782-19.7c24.538-6.136 99.218-24.804 99.218-76.3v-576c0-51.494-74.68-70.164-99.218-76.298zM960 670.246c-14.162-5.27-27.302-8.566-35.218-10.544-43.096-10.776-97.878-17.424-156.782-19.202v223.5c0 17.674-14.326 32-32 32s-32-14.326-32-32v-223.5c-58.902 1.778-113.686 8.426-156.782 19.202-7.916 1.978-21.056 5.276-35.218 10.544v-252.49c14.162 5.27 27.302 8.564 35.218 10.544 43.096 10.774 97.878 17.422 156.782 19.2v193c10.554-0.318 21.224-0.5 32-0.5s21.446 0.182 32 0.5v-193c58.902-1.778 113.686-8.426 156.782-19.2 7.916-1.98 21.056-5.274 35.218-10.544v252.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spray",
						"paint",
						"art"
					],
					"defaultCode": 59689,
					"grid": 16
				},
				{
					"id": 827,
					"width": 1024,
					"paths": [
						"M672.032 320c66.848 0 118.176-46.56 143.2-74.816 10.72-12.096 10.72-30.24 0-42.336-25.024-28.288-76.352-74.848-143.2-74.848-59.072 0-105.92 36.288-133.312 64.256l-10.944-65.568c-2.976-17.824-28.608-17.824-31.552 0l-10.912 65.536c-27.392-27.936-74.272-64.224-133.312-64.224-66.848 0-118.176 46.56-143.2 74.816-10.72 12.096-10.72 30.24 0 42.336 25.024 28.288 76.352 74.848 143.2 74.848 50.848 0 92.576-26.912 120.704-52.256l-19.36 116.256h-197.344c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32l32 256c-17.664 0-32 14.336-32 32v0c0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96v0c0-17.664-14.336-32-32-32l32-256c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-197.344l-19.392-116.256c28.16 25.344 69.888 52.256 120.768 52.256zM672.032 160c54.24 0 97.792 39.904 119.104 63.936-21.408 24.064-65.152 64.064-119.104 64.064-54.24 0-97.792-39.904-119.104-63.936 21.408-24.064 65.152-64.064 119.104-64.064zM352 288c-54.24 0-97.792-39.904-119.104-63.936 21.408-24.064 65.152-64.064 119.104-64.064 54.24 0 97.792 39.904 119.104 63.936-21.408 24.064-65.152 64.064-119.104 64.064zM672 896h-320c-35.36 0-64-28.64-64-64h448c0 35.36-28.64 64-64 64zM703.744 800h-383.488l-32-256h447.488l-32 256zM768 416v96h-512v-96h512zM485.76 384l26.24-157.344 26.24 157.344h-52.48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sprout",
						"grow",
						"live"
					],
					"grid": 32
				},
				{
					"id": 828,
					"width": 1024,
					"paths": [
						"M208.8 245.184c-10.72-12.096-10.72-30.24 0-42.336 25.024-28.288 76.352-74.848 143.2-74.848 59.040 0 105.888 36.288 133.28 64.256l10.912-65.536c2.976-17.824 28.576-17.824 31.552 0l10.912 65.568c27.424-28 74.304-64.288 133.376-64.288 66.848 0 118.176 46.56 143.2 74.816 10.72 12.096 10.72 30.24 0 42.336-25.024 28.288-76.352 74.848-143.2 74.848-50.848 0-92.608-26.912-120.736-52.256l14.048 84.256h-106.656l14.048-84.256c-28.16 25.344-69.888 52.256-120.736 52.256-66.848 0-118.176-46.56-143.2-74.816zM256 384c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32l28 224h456l28-224c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-512zM736 800h-448c-17.664 0-32 14.336-32 32 0 53.024 42.976 96 96 96h320c53.024 0 96-42.976 96-96 0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sprout",
						"grow",
						"live"
					],
					"grid": 32
				},
				{
					"id": 829,
					"width": 1024,
					"paths": [
						"M896 160c-35.36 0-64 28.64-64 64v19.168l-259.264 57.6c-8.192-25.888-32.128-44.768-60.736-44.768-35.36 0-64 28.64-64 64v19.168l-259.264 57.6c-8.192-25.888-32.128-44.768-60.736-44.768-35.36 0-64 28.64-64 64v192c0 35.36 28.64 64 64 64 28.608 0 52.544-18.88 60.736-44.768l259.264 57.6v19.168c0 35.36 28.64 64 64 64 28.608 0 52.544-18.88 60.736-44.768l259.264 57.6v19.168c0 35.36 28.64 64 64 64s64-28.64 64-64v-576c0-35.36-28.64-64-64-64zM160 608c0 17.632-14.368 32-32 32s-32-14.368-32-32v-192c0-17.632 14.368-32 32-32s32 14.368 32 32v192zM192 595.168v-166.336l256-56.896v280.096l-256-56.864zM544 704c0 17.632-14.368 32-32 32s-32-14.368-32-32v-384c0-17.632 14.368-32 32-32s32 14.368 32 32v384zM576 691.168v-358.336l256-56.896v472.096l-256-56.864zM928 800c0 17.632-14.368 32-32 32s-32-14.368-32-32v-576c0-17.632 14.368-32 32-32s32 14.368 32 32v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spy",
						"enlarge",
						"see",
						"gaze",
						"look"
					],
					"grid": 32
				},
				{
					"id": 830,
					"width": 1024,
					"paths": [
						"M416 677.472l-227.296-50.176c-8.224 25.856-32.128 44.704-60.704 44.704-35.36 0-64-28.64-64-64v-192c0-35.36 28.64-64 64-64 28.544 0 52.416 18.784 60.672 44.576l227.328-50.464v331.36zM800 250.112l-227.328 50.496c-8.256-25.824-32.128-44.608-60.672-44.608-35.36 0-64 28.64-64 64v384c0 35.36 28.64 64 64 64 28.576 0 52.48-18.848 60.704-44.704l227.296 50.176v-523.36zM896 160c-35.36 0-64 28.64-64 64v576c0 35.36 28.64 64 64 64s64-28.64 64-64v-576c0-35.36-28.64-64-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"spy",
						"enlarge",
						"see",
						"gaze",
						"look"
					],
					"grid": 32
				},
				{
					"id": 3198,
					"paths": [
						"M0 0h1024v1024h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square"
					],
					"defaultCode": 61033,
					"grid": 16
				},
				{
					"id": 3101,
					"paths": [
						"M0 1023.998v-1023.998h1024v1024l-1024-0.002zM896 128h-768v767.998l768 0.002v-768z",
						"M224 512l288 288 288-288h-224v-320h-128v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square-down",
						"down",
						"circle-bottom",
						"arrow"
					],
					"defaultCode": 60936,
					"grid": 16
				},
				{
					"id": 3102,
					"paths": [
						"M1024 1024v-1024h-1024v1024h1024zM128 128h768v768h-768v-768z",
						"M672 256l-256 256-160-160v416h416l-160-160 256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square-down-left",
						"down-left",
						"square-bottom-left",
						"arrow"
					],
					"defaultCode": 60937,
					"grid": 16
				},
				{
					"id": 3100,
					"paths": [
						"M1024 0h-1024v1024h1024v-1024zM128 896v-768h768v768h-768z",
						"M256 352l256 256-160 160h416v-416l-160 160-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square-down-right",
						"down-right",
						"square-bottom-right",
						"arrow"
					],
					"defaultCode": 60935,
					"grid": 16
				},
				{
					"id": 3103,
					"paths": [
						"M0.002 1024h1023.998v-1024h-1024l0.002 1024zM896 128v768h-767.998l-0.002-768h768z",
						"M512 800l-288-288 288-288v224h320v128h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square-left",
						"left",
						"circle-previous",
						"arrow"
					],
					"defaultCode": 60938,
					"grid": 16
				},
				{
					"id": 1320,
					"width": 804.5689392089844,
					"paths": [
						"M640 146.286h-475.429q-37.714 0-64.571 26.857t-26.857 64.571v475.429q0 37.714 26.857 64.571t64.571 26.857h475.429q37.714 0 64.571-26.857t26.857-64.571v-475.429q0-37.714-26.857-64.571t-64.571-26.857zM804.571 237.714v475.429q0 68-48.286 116.286t-116.286 48.286h-475.429q-68 0-116.286-48.286t-48.286-116.286v-475.429q0-68 48.286-116.286t116.286-48.286h475.429q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square-o"
					],
					"defaultCode": 61590,
					"grid": 14
				},
				{
					"id": 3099,
					"paths": [
						"M1023.998 0h-1023.998v1024h1024l-0.002-1024zM128 896v-768h767.998l0.002 768h-768z",
						"M512 224l288 288-288 288v-224h-320v-128h320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square-right",
						"right",
						"circle-next",
						"arrow"
					],
					"defaultCode": 60934,
					"grid": 16
				},
				{
					"id": 3097,
					"paths": [
						"M0 0.002v1023.998h1024v-1024l-1024 0.002zM896 896h-768v-767.998l768-0.002v768z",
						"M224 512l288-288 288 288h-224v320h-128v-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square-up",
						"up",
						"circle-top",
						"arrow"
					],
					"defaultCode": 60932,
					"grid": 16
				},
				{
					"id": 3096,
					"paths": [
						"M0 1024h1024v-1024h-1024v1024zM896 128v768h-768v-768h768z",
						"M768 672l-256-256 160-160h-416v416l160-160 256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square-up-left",
						"up-left",
						"square-top-left",
						"arrow"
					],
					"defaultCode": 60931,
					"grid": 16
				},
				{
					"id": 3098,
					"paths": [
						"M0 0v1024h1024v-1024h-1024zM896 896h-768v-768h768v768z",
						"M352 768l256-256 160 160v-416h-416l160 160-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square-up-right",
						"up-right",
						"square-top-right",
						"arrow"
					],
					"defaultCode": 60933,
					"grid": 16
				},
				{
					"id": 1355,
					"width": 877.7129821777344,
					"paths": [
						"M877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"square"
					],
					"defaultCode": 61640,
					"grid": 14
				},
				{
					"id": 831,
					"width": 1024,
					"paths": [
						"M992 512h-160c0-17.664-14.336-32-32-32h-160c-17.664 0-32 14.336-32 32h-64c0-17.664-14.336-32-32-32v-32h220.384c65.856 0 123.744-48.224 130.848-113.696 8.352-77.088-51.808-142.304-127.232-142.304h-480c-59.584 0-109.184 40.896-123.488 96h-4.512c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32v96c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h85.344l-17.376 156.48c-2.112 18.944 12.704 35.52 31.776 35.52h92.256c17.664 0 32-14.336 32-32v-96h64c17.664 0 32-14.336 32-32v-32h160c17.664 0 32-14.336 32-32h64c0 17.664 14.336 32 32 32h160c17.664 0 32-14.336 32-32v-64h160c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32zM608 544v32h-64v-32h64zM163.52 296.032c10.976-42.4 48.992-72.032 92.48-72.032h480c52.928 0 96 43.072 96 96s-43.072 96-96 96h-480c-43.488 0-81.504-29.632-92.512-72.032l-6.176-23.968 6.208-23.968zM132.512 352c14.304 55.104 63.904 96 123.488 96h128v32h-256v-128h4.512zM320 736h-64v-32h64v32zM512 672h-288v192h-92.256l21.344-192h-121.088v-160h32v-160h-32v-64h64v224h320v-64h64v64h32v160zM544 640v-32h64v32h-64zM800 672h-160v-160h160v160zM992 576h-160v-32h160v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"squirt",
						"fight",
						"play",
						"spray",
						"shoot",
						"soak"
					],
					"grid": 32
				},
				{
					"id": 832,
					"width": 1024,
					"paths": [
						"M1024 544v32c0 17.664-14.336 32-32 32h-128v-96h128c17.664 0 32 14.336 32 32zM832 640v32c0 17.664-14.336 32-32 32h-160c-17.664 0-32-14.336-32-32h-64c0 17.664-14.336 32-32 32h-160v32c0 17.664-14.336 32-32 32h-64v96c0 17.664-14.336 32-32 32h-92.256c-19.072 0-33.92-16.576-31.808-35.52l17.408-156.48h-85.344c-17.664 0-32-14.336-32-32v-160c0-17.664 14.336-32 32-32v-96c-17.664 0-32-14.336-32-32v-64c0-17.664 14.336-32 32-32h64c17.664 0 32 14.336 32 32h4.512c14.304-55.104 63.904-96 123.488-96h480c75.392 0 135.584 65.216 127.232 142.304-7.104 65.472-64.992 113.696-130.848 113.696h-220.384v32c17.664 0 32 14.336 32 32h32v96h-32v32h64v-128c0-17.664 14.336-32 32-32h160c17.664 0 32 14.304 32 31.968v128.032zM320 704h-64v32h64v-32zM384 448h-128c-59.584 0-109.216-40.896-123.488-96h-4.512v128h256v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"squirt",
						"fight",
						"play",
						"spray",
						"shoot",
						"soak"
					],
					"grid": 32
				},
				{
					"id": 2018,
					"paths": [
						"M880 256h-48v-48c0-44.112-35.888-80-80-80h-48v-48c0-44.112-35.886-80-80-80h-480c-44.112 0-80 35.888-80 80v608c0 44.114 35.888 80 80 80h48v48c0 44.114 35.888 80 80 80h48v48c0 44.112 35.888 80 80 80h480c44.112 0 80-35.888 80-80v-608c0-44.112-35.888-80-80-80zM144.002 704c-8.8 0-16-7.2-16-16v-608c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v48h-368.002c-44.112 0-80 35.888-80 80v496h-47.998zM272 832c-8.8 0-16-7.2-16-16v-608c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v48h-368c-44.112 0-80 35.888-80 80v496h-48zM896 944c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-608c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v608z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack",
						"files",
						"archive",
						"category",
						"papers",
						"documents",
						"layers"
					],
					"defaultCode": 59853,
					"grid": 16
				},
				{
					"id": 2903,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.958-199.608 57.24zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM832 572.118v67.882h-67.882l-92.118-92.118-92.118 92.118h-67.882v-67.882l92.118-92.118-92.118-92.118v-67.882h67.882l92.118 92.118 92.118-92.118h67.882v67.882l-92.118 92.118z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-cancel",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60738,
					"grid": 16
				},
				{
					"id": 2904,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.958-199.608 57.24zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM384 768v-640h576v160l-45.256-45.252-274.744 242.742-146.746-114.744-58.508 58.51 205.254 237.254 320-350.728v452.218h-576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-check",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60739,
					"grid": 16
				},
				{
					"id": 2906,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM448 480c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM704 480c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM768 310c0 29.792-13.582 56.396-34.88 74-29.12 31-29.12 64-29.12 96v64c0 64 0 128 64 128v32h-192v-32c64 0 64-64 64-128v-64c0-32 0-65-29.12-96-21.298-17.604-34.88-44.208-34.88-74 0-53.020 42.98-96 96-96s96 42.98 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-clubs",
						"files",
						"papers",
						"pages",
						"cards",
						"clubs"
					],
					"defaultCode": 60741,
					"grid": 16
				},
				{
					"id": 2909,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.958-199.608 57.24zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM672 704l-160-256 160-256 160 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-diamonds",
						"files",
						"papers",
						"pages",
						"cards",
						"diamonds"
					],
					"defaultCode": 60744,
					"grid": 16
				},
				{
					"id": 2901,
					"paths": [
						"M1024 832v-768h-704v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504zM384 128h576v640h-576v-640zM320 196.466v635.534h162.75l-174.116 24.47-90.74-645.656 102.106-14.348zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM928 448l-256 256-256-256h160v-192h192v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-down",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60736,
					"grid": 16
				},
				{
					"id": 2896,
					"paths": [
						"M1024 832v-768h-704v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504zM384 128h576v640h-576v-640zM320 196.466v635.534h162.75l-174.116 24.47-90.74-645.656 102.106-14.348zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-empty",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60731,
					"grid": 16
				},
				{
					"id": 1538,
					"width": 731.4300537109375,
					"paths": [
						"M719.429 716v37.714q0 48.571-32.857 82.571t-79.143 34h-32.571l-148.571 153.714v-153.714h-302.286q-46.286 0-79.143-34t-32.857-82.571v-37.714h707.429zM719.429 529.714v145.714h-707.429v-145.714h707.429zM719.429 342.286v145.714h-707.429v-145.714h707.429zM719.429 262.286v38.286h-707.429v-38.286q0-48 32.857-82t79.143-34h483.429q46.286 0 79.143 34t32.857 82z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-exchange"
					],
					"defaultCode": 61837,
					"grid": 14
				},
				{
					"id": 2908,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.958-199.608 57.24zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM891.262 346.63c3.060 8.542 4.738 19.534 4.738 33.37 0 160-224 160-224 320 0-160-224-160-224-320 0-13.834 1.676-24.826 4.738-33.368 14.46-50.032 52.57-86.632 107.262-86.632 44.476 0 91.272 38.216 112 74.164 20.728-35.948 67.524-74.164 112-74.164 54.69 0 92.8 36.6 107.262 86.63z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-hearts",
						"files",
						"papers",
						"pages",
						"cards",
						"hearts"
					],
					"defaultCode": 60743,
					"grid": 16
				},
				{
					"id": 2898,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM512 448h320v64h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-minus",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60733,
					"grid": 16
				},
				{
					"id": 2912,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.958-199.608 57.24zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM544 704c-53.020 0-96-42.98-96-96s42.98-96 96-96c11.222 0 21.988 1.944 32 5.484v-261.484l320-64v352c0 53.020-42.98 96-96 96s-96-42.98-96-96c0-53.018 42.98-96 96-96 11.222 0 21.988 1.944 32 5.484v-120.684l-192 38.4v236.8c0 53.020-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-music",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60747,
					"grid": 16
				},
				{
					"id": 1507,
					"width": 877.7129821777344,
					"paths": [
						"M736.571 932.571h-638.857v-274.286h-91.429v365.714h821.714v-365.714h-91.429v274.286zM198.286 633.143l18.857-89.714 447.429 94.286-18.857 89.143zM257.143 419.429l38.286-83.429 414.286 193.714-38.286 82.857zM372 216l58.286-70.286 350.857 293.143-58.286 70.286zM598.857 0l272.571 366.286-73.143 54.857-272.571-366.286zM188.571 840.571v-90.857h457.143v90.857h-457.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-overflow"
					],
					"defaultCode": 61804,
					"grid": 14
				},
				{
					"id": 2900,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM640 704h-192l64-256h64l149.334 149.334 42.666-85.334h64l64 192zM704 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-picture",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60735,
					"grid": 16
				},
				{
					"id": 2913,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.958-199.608 57.24zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM576 256l320 192-320 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-play",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60748,
					"grid": 16
				},
				{
					"id": 2897,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM832 512h-128v128h-64v-128h-128v-64h128v-128h64v128h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-plus",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60732,
					"grid": 16
				},
				{
					"id": 2907,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.958-199.608 57.24zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM672 132c0 181 224 188 224 348 0 53.020-42.98 96-96 96s-96-42.98-96-96v64c0 64 0 128 64 128v32h-192v-32c64 0 64-64 64-128v-64c0 53.020-42.98 96-96 96s-96-42.98-96-96c0-160 224-167 224-348z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-spades",
						"files",
						"papers",
						"pages",
						"cards",
						"spades"
					],
					"defaultCode": 60742,
					"grid": 16
				},
				{
					"id": 2899,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM672 244.092l45.78 140.898h148.148l-119.854 87.078 45.78 140.896-119.854-87.080-119.854 87.080 45.78-140.896-119.854-87.078h148.148z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-star",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60734,
					"grid": 16
				},
				{
					"id": 2905,
					"paths": [
						"M1024 832v-768h-704v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504zM384 128h576v640h-576v-640zM320 196.466v635.534h162.75l-174.116 24.47-90.74-645.656 102.106-14.348zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM448 192h448v64h-448zM448 320h448v64h-448zM448 448h448v64h-448zM448 576h320v64h-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-text",
						"files",
						"papers",
						"pages",
						"lists"
					],
					"defaultCode": 60740,
					"grid": 16
				},
				{
					"id": 2902,
					"paths": [
						"M1024 832v-768h-704v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504zM384 128h576v640h-576v-640zM320 196.466v635.534h162.75l-174.116 24.47-90.74-645.656 102.106-14.348zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM416 448l256-256 256 256h-160v192h-192v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-up",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60737,
					"grid": 16
				},
				{
					"id": 2910,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.958-199.608 57.24zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM832 576v64h-320v-64c0-35.2 28.8-64 64-64h192c35.2 0 64 28.8 64 64zM576 416c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack-user",
						"files",
						"papers",
						"pages"
					],
					"defaultCode": 60745,
					"grid": 16
				},
				{
					"id": 2019,
					"paths": [
						"M1024 320l-512-256-512 256 512 256 512-256zM512 148.97l342.058 171.030-342.058 171.030-342.058-171.030 342.058-171.030zM921.444 460.722l102.556 51.278-512 256-512-256 102.556-51.278 409.444 204.722zM921.444 652.722l102.556 51.278-512 256-512-256 102.556-51.278 409.444 204.722z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack",
						"layers"
					],
					"defaultCode": 59854,
					"grid": 16
				},
				{
					"id": 2020,
					"paths": [
						"M512 576l-512-256 512-256 512 256zM921.444 460.722l102.556 51.278-512 256-512-256 102.556-51.278 409.444 204.722zM921.444 652.722l102.556 51.278-512 256-512-256 102.556-51.278 409.444 204.722z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack",
						"layers"
					],
					"defaultCode": 59855,
					"grid": 16
				},
				{
					"id": 2911,
					"paths": [
						"M320 64v73.896l-167.616 23.556 10.888 77.48-163.272 46.818 211.69 738.25 652.066-186.976 35.74-5.024h124.504v-768h-704zM251.456 952.26l-179.716-626.742 99.686-28.584 87.844 625.044 191.794-26.956-199.608 57.238zM308.632 856.47l-90.74-645.656 102.108-14.348v635.534h162.75l-174.118 24.47zM960 768h-576v-640h576v640zM448 456h448v16h-448zM448 488h448v16h-448zM448 552h448v16h-448zM448 520h448v16h-448zM448 584h448v16h-448zM448 680h448v16h-448zM448 616h448v16h-448zM448 648h448v16h-448zM448 296h448v16h-448zM448 232h448v16h-448zM448 264h448v16h-448zM448 200h448v16h-448zM448 424h448v16h-448zM448 392h448v16h-448zM448 328h448v16h-448zM448 360h448v16h-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack",
						"files",
						"papers",
						"pages",
						"dualtone"
					],
					"defaultCode": 60746,
					"grid": 16
				},
				{
					"id": 833,
					"width": 1024,
					"paths": [
						"M896 832h-24.928c15.328-17.024 24.928-39.296 24.928-64 0-50.784-39.552-91.904-89.472-95.328 15.68-17.088 25.472-39.68 25.472-64.672 0-50.784-39.552-91.904-89.472-95.328 15.68-17.088 25.472-39.68 25.472-64.672 0-50.784-39.552-91.904-89.472-95.328 15.68-17.088 25.472-39.68 25.472-64.672 0-53.024-42.976-96-96-96h-32v-64c0-35.36-28.64-64-64-64s-64 28.64-64 64v64h-32c-53.024 0-96 42.976-96 96 0 24.992 9.792 47.584 25.472 64.672-49.92 3.424-89.472 44.544-89.472 95.328 0 24.992 9.792 47.584 25.472 64.672-49.92 3.424-89.472 44.544-89.472 95.328 0 24.992 9.792 47.584 25.472 64.672-49.92 3.424-89.472 44.544-89.472 95.328 0 24.704 9.6 46.976 24.928 64h-24.928c-35.36 0-64 28.64-64 64s28.64 64 64 64h768c35.36 0 64-28.64 64-64s-28.64-64-64-64zM480 128c0-17.632 14.368-32 32-32s32 14.368 32 32v64h-64v-64zM416 224h192c35.296 0 64 28.704 64 64s-28.704 64-64 64h-192c-35.296 0-64-28.704-64-64s28.704-64 64-64zM352 384h320c35.296 0 64 28.704 64 64s-28.704 64-64 64h-320c-35.296 0-64-28.704-64-64s28.704-64 64-64zM288 544h448c35.296 0 64 28.704 64 64s-28.704 64-64 64h-448c-35.296 0-64-28.704-64-64s28.704-64 64-64zM160 768c0-35.296 28.704-64 64-64h576c35.296 0 64 28.704 64 64s-28.704 64-64 64h-576c-35.296 0-64-28.704-64-64zM896 928h-768c-17.632 0-32-14.368-32-32s14.368-32 32-32h768c17.632 0 32 14.368 32 32s-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack",
						"play",
						"learn"
					],
					"grid": 32
				},
				{
					"id": 834,
					"width": 1024,
					"paths": [
						"M320 288c0-35.36 28.64-64 64-64h64v-96c0-35.36 28.64-64 64-64s64 28.64 64 64v96h64c35.36 0 64 28.64 64 64s-28.64 64-64 64h-256c-35.36 0-64-28.64-64-64zM320 512h384c35.36 0 64-28.64 64-64s-28.64-64-64-64h-384c-35.36 0-64 28.64-64 64s28.64 64 64 64zM256 672h512c35.36 0 64-28.64 64-64s-28.64-64-64-64h-512c-35.36 0-64 28.64-64 64s28.64 64 64 64zM192 832h640c35.36 0 64-28.64 64-64s-28.64-64-64-64h-640c-35.36 0-64 28.64-64 64s28.64 64 64 64zM912 864h-800c-26.496 0-48 21.504-48 48s21.504 48 48 48h800c26.496 0 48-21.504 48-48s-21.504-48-48-48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack",
						"play",
						"learn"
					],
					"grid": 32
				},
				{
					"id": 1140,
					"width": 1024,
					"paths": [
						"M1000.832 593.696l-40.832-81.696h12.224c23.776 0 39.264-25.024 28.608-46.304l-224-448c-5.408-10.848-16.48-17.696-28.608-17.696h-472.448c-12.128 0-23.2 6.848-28.608 17.696l-224 448c-10.656 21.28 4.832 46.304 28.608 46.304h12.224l-40.832 81.696c-10.656 21.28 4.832 46.304 28.608 46.304h12.224l-40.832 81.696c-10.656 21.28 4.832 46.304 28.608 46.304h12.224l-40.832 81.696c-10.656 21.28 4.832 46.304 28.608 46.304h12.224l-40.832 81.696c-10.656 21.28 4.832 46.304 28.608 46.304h920.448c23.776 0 39.264-25.024 28.608-46.304l-40.832-81.696h12.224c23.776 0 39.264-25.024 28.608-46.304l-40.832-81.696h12.224c23.776 0 39.264-25.024 28.608-46.304l-40.832-81.696h12.224c23.776 0 39.264-25.024 28.608-46.304zM103.552 960l48-96h720.896l48 96h-816.896zM103.552 832l48-96h720.896l48 96h-816.896zM103.552 704l48-96h720.896l48 96h-816.896zM103.552 576l48-96h720.896l48 96h-816.896zM103.552 448l192-384h432.896l192 384h-816.896zM635.776 192h-251.776l16-32h219.776l16 32zM667.776 256h-315.776l16-32h283.776l16 32zM683.776 288l16 32h-379.776l16-32h347.776z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stack",
						"organize"
					],
					"grid": 32
				},
				{
					"id": 3396,
					"paths": [
						"M1024 640v384h-1024v-384h128v256h768v-256zM192 704h640v128h-640zM207.152 565.466l27.698-124.964 624.832 138.496-27.698 124.964zM279.658 308.558l54.092-116.006 580.032 270.464-54.092 116.006zM991.722 361.476l-77.922 101.55-507.746-389.608 56.336-73.418h58.244z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stackoverflow",
						"brand",
						"social"
					],
					"defaultCode": 61231,
					"grid": 16
				},
				{
					"id": 2475,
					"paths": [
						"M320 128l-64 64v128l-128 128v192l-128 128v192h704l64-64v-128h-704l128-128h640l64-64v-128h-704l128-128h640l64-64v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stairs",
						"steps"
					],
					"defaultCode": 60310,
					"grid": 16
				},
				{
					"id": 2474,
					"paths": [
						"M256 128v192h192v192h192v192h192v192h192v128h-320v-192h-192v-192h-192v-192h-192v-192h-128v-128zM448 0l474 480 102-96v256h-256l90-96-474-480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stairs-down",
						"descend",
						"steps"
					],
					"defaultCode": 60309,
					"grid": 16
				},
				{
					"id": 2473,
					"paths": [
						"M768 128v192h-192v192h-192v192h-192v192h-192v128h320v-192h192v-192h192v-192h192v-192h128v-128zM64 640l474-480 102 96v-256h-256l90 96-474 480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stairs-up",
						"ascend",
						"steps"
					],
					"defaultCode": 60308,
					"grid": 16
				},
				{
					"id": 2476,
					"paths": [
						"M1024 320v-192h-704l-64 64v128l-128 128v192l-128 128v192h704l64-64v-128h-704l8-8h709.726l15.182-16h-708.908l16-16h708.092l15.182-16h-707.274l16-16h706.456l15.18-16h-705.636l16-16h704.818l15.182-16h-704l8-8h704v-192h-704l8-8h705.528l15.78-16h-705.308l16-16h705.092l15.782-16h-704.874l16-16h704.654l15.782-16h-704.436l16-16h704.218l15.782-16h-704l8-8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stairs",
						"steps",
						"dualtone"
					],
					"defaultCode": 60311,
					"grid": 16
				},
				{
					"id": 1870,
					"paths": [
						"M992 704h-320c-53.020 0-96-42.98-96-96v-234.94c74.57-26.36 128-97.464 128-181.060 0-106.040-85.96-192-192-192s-192 85.96-192 192c0 83.596 53.43 154.7 128 181.060v234.94c0 53.020-42.98 96-96 96h-320c-17.672 0-32 14.326-32 32v128c0 17.674 14.328 32 32 32h960c17.674 0 32-14.326 32-32v-128c0-17.674-14.326-32-32-32z",
						"M64 928v64c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-64h-896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stamp",
						"pattern",
						"rubber-stamp"
					],
					"defaultCode": 59705,
					"grid": 16
				},
				{
					"id": 835,
					"width": 1024,
					"paths": [
						"M768 160h-512c-17.664 0-32 14.336-32 32v640c0 17.664 14.336 32 32 32h512c17.664 0 32-14.336 32-32v-640c0-17.664-14.336-32-32-32zM768 832h-512v-640h512v640zM896 192v-32c0-53.024-42.976-96-96-96h-64c0 17.664-14.336 32-32 32s-32-14.336-32-32h-128c0 17.664-14.336 32-32 32s-32-14.336-32-32h-128c0 17.664-14.336 32-32 32s-32-14.336-32-32h-64c-53.024 0-96 42.976-96 96v32c17.664 0 32 14.336 32 32s-14.336 32-32 32v128c17.664 0 32 14.336 32 32s-14.336 32-32 32v128c17.664 0 32 14.336 32 32s-14.336 32-32 32v128c17.664 0 32 14.336 32 32s-14.336 32-32 32v32c0 53.024 42.976 96 96 96h64c0-17.664 14.336-32 32-32s32 14.336 32 32h128c0-17.664 14.336-32 32-32s32 14.336 32 32h128c0-17.664 14.336-32 32-32s32 14.336 32 32h64c53.024 0 96-42.976 96-96v-32c-17.664 0-32-14.336-32-32s14.336-32 32-32v-128c-17.664 0-32-14.336-32-32s14.336-32 32-32v-128c-17.664 0-32-14.336-32-32s14.336-32 32-32v-128c-17.664 0-32-14.336-32-32s14.336-32 32-32zM864 168.576c-19.104 11.104-32 31.776-32 55.424s12.896 44.32 32 55.424v81.184c-19.104 11.072-32 31.776-32 55.424s12.896 44.32 32 55.424v81.184c-19.104 11.072-32 31.776-32 55.424s12.896 44.32 32 55.424v81.184c-19.104 11.072-32 31.776-32 55.424s12.896 44.32 32 55.424v8.48c0 35.296-28.704 64-64 64h-40.576c-11.072-19.104-31.776-32-55.424-32s-44.32 12.896-55.424 32h-81.184c-11.072-19.104-31.776-32-55.424-32s-44.32 12.896-55.424 32h-81.184c-11.072-19.104-31.776-32-55.424-32s-44.32 12.896-55.424 32h-40.512c-35.296 0-64-28.704-64-64v-8.576c19.104-11.104 32-31.776 32-55.424s-12.896-44.32-32-55.424v-81.184c19.104-11.072 32-31.744 32-55.392s-12.896-44.32-32-55.424v-81.184c19.104-11.072 32-31.744 32-55.392s-12.896-44.32-32-55.424v-81.152c19.104-11.104 32-31.776 32-55.424s-12.896-44.32-32-55.424v-8.576c0-35.296 28.704-64 64-64h40.576c11.104 19.104 31.776 32 55.424 32s44.32-12.896 55.424-32h81.184c11.072 19.104 31.744 32 55.392 32s44.32-12.896 55.424-32h81.184c11.072 19.104 31.744 32 55.392 32s44.32-12.896 55.424-32h40.576c35.296 0 64 28.704 64 64v8.576zM534.624 617.376l88.608-88.608c26.4-26.4 26.752-69.92 0.8-96.736l-0.064-0.064c-13.248-13.248-30.624-19.872-47.968-19.872s-34.72 6.624-47.968 19.872l-16.032 16.032-16.032-16.032c-13.248-13.248-30.624-19.872-47.968-19.872s-34.72 6.624-47.968 19.872l-0.064 0.064c-25.952 26.816-25.6 70.336 0.8 96.736l88.608 88.608c12.48 12.48 32.768 12.48 45.248 0zM422.656 454.592c6.752-6.752 15.776-10.496 25.344-10.496s18.56 3.744 25.344 10.496l38.656 38.656 38.656-38.656c6.752-6.752 15.776-10.496 25.344-10.496s18.56 3.744 25.408 10.56c6.784 6.784 10.496 15.776 10.496 25.344s-3.744 18.56-10.496 25.344l-89.408 89.408-89.408-89.408c-6.784-6.784-10.496-15.776-10.496-25.344s3.744-18.56 10.56-25.408z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stamp",
						"send",
						"mail",
						"deliver"
					],
					"grid": 32
				},
				{
					"id": 836,
					"width": 1024,
					"paths": [
						"M256 832h512v-640h-512v640zM399.968 432.032l0.064-0.064c13.248-13.248 30.624-19.872 47.968-19.872s34.72 6.624 47.968 19.872l16.032 16.032 16.032-16.032c13.248-13.248 30.624-19.872 47.968-19.872s34.72 6.624 47.968 19.872l0.064 0.064c25.952 26.816 25.6 70.336-0.8 96.736l-88.608 88.608c-12.512 12.512-32.768 12.512-45.248 0l-88.608-88.608c-26.4-26.4-26.752-69.92-0.8-96.736zM896 192v-32c0-53.024-42.976-96-96-96h-64c0 17.664-14.336 32-32 32s-32-14.336-32-32h-128c0 17.664-14.336 32-32 32s-32-14.336-32-32h-128c0 17.664-14.336 32-32 32s-32-14.336-32-32h-64c-53.024 0-96 42.976-96 96v32c17.664 0 32 14.336 32 32s-14.336 32-32 32v128c17.664 0 32 14.336 32 32s-14.336 32-32 32v128c17.664 0 32 14.336 32 32s-14.336 32-32 32v128c17.664 0 32 14.336 32 32s-14.336 32-32 32v32c0 53.024 42.976 96 96 96h64c0-17.664 14.336-32 32-32s32 14.336 32 32h128c0-17.664 14.336-32 32-32s32 14.336 32 32h128c0-17.664 14.336-32 32-32s32 14.336 32 32h64c53.024 0 96-42.976 96-96v-32c-17.664 0-32-14.336-32-32s14.336-32 32-32v-128c-17.664 0-32-14.336-32-32s14.336-32 32-32v-128c-17.664 0-32-14.336-32-32s14.336-32 32-32v-128c-17.664 0-32-14.336-32-32s14.336-32 32-32zM800 832c0 17.664-14.336 32-32 32h-512c-17.664 0-32-14.336-32-32v-640c0-17.664 14.336-32 32-32h512c17.664 0 32 14.336 32 32v640zM422.592 505.344c-6.784-6.784-10.496-15.776-10.496-25.344s3.744-18.56 10.56-25.408c6.752-6.752 15.776-10.496 25.344-10.496s18.56 3.744 25.344 10.496l38.656 38.656 38.656-38.656c6.752-6.752 15.776-10.496 25.344-10.496s18.56 3.744 25.408 10.56c6.784 6.784 10.496 15.776 10.496 25.344s-3.744 18.56-10.496 25.344l-89.408 89.408-89.408-89.408z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stamp",
						"send",
						"mail",
						"deliver"
					],
					"grid": 32
				},
				{
					"id": 1141,
					"width": 1024,
					"paths": [
						"M960 64v-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32h-64c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32h-64c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32h-64c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32h-64c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32h-64c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32v64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32v64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32v64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32v64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32v64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32v64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h64c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h64c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h64c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h64c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h64c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32v-64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32v-64c17.664 0 32-14.336 32-32zM864 928h-672v-832h672v832zM832 128h-608v768h608v-768zM800 864h-544v-704h544v704zM416 768h-128v-32h128v32zM416 832h-128v-32h128v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stamp",
						"send",
						"mail",
						"deliver"
					],
					"grid": 32
				},
				{
					"id": 837,
					"width": 1024,
					"paths": [
						"M593.696 225.792c28.064-23.488 46.304-58.336 46.304-97.792 0-70.688-57.312-128-128-128s-128 57.312-128 128c0 39.456 18.24 74.304 46.304 97.792-79.936 8.896-142.304 75.904-142.304 158.208v192c0 53.024 42.976 96 96 96v256c0 53.024 42.976 96 96 96h64c53.024 0 96-42.976 96-96v-256c53.024 0 96-42.976 96-96v-192c0-82.304-62.368-149.312-142.304-158.208zM416 128c0-52.928 43.072-96 96-96s96 43.072 96 96c0 52.928-43.072 96-96 96s-96-43.072-96-96zM608 928c0 35.36-28.64 64-64 64h-16v-271.168c0-7.968-5.44-15.36-13.312-16.608-10.048-1.632-18.688 6.048-18.688 15.776v272h-16c-35.36 0-64-28.64-64-64v-320h192v320zM704 576c0 35.296-28.704 64-64 64v-240c0-8.832-7.168-16-16-16s-16 7.168-16 16v176h-192v-176c0-8.832-7.168-16-16-16s-16 7.168-16 16v240c-35.296 0-64-28.704-64-64v-192c0-70.688 57.312-128 128-128h128c70.688 0 128 57.312 128 128v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stand",
						"use"
					],
					"grid": 32
				},
				{
					"id": 838,
					"width": 1024,
					"paths": [
						"M384 608h256v320c0 53.024-42.976 96-96 96h-16v-304c0-8.832-7.168-16-16-16s-16 7.168-16 16v304h-16c-53.024 0-96-42.976-96-96v-320zM576 224h-128c-88.352 0-160 71.648-160 160v192c0 41.728 26.784 76.896 64 90.112v-266.112c0-8.832 7.168-16 16-16s16 7.168 16 16v176h256v-176c0-8.832 7.168-16 16-16s16 7.168 16 16v266.112c37.216-13.216 64-48.384 64-90.112v-192c0-88.352-71.648-160-160-160zM512 192c53.024 0 96-42.976 96-96s-42.976-96-96-96-96 42.976-96 96 42.976 96 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stand",
						"use"
					],
					"grid": 32
				},
				{
					"id": 2811,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM718.9 830.386l-206.9-140.772-206.9 140.774 69.948-240.276-197.82-153.272 250.13-7.724 84.642-235.502 84.64 235.502 250.13 7.724-197.818 153.272 69.948 240.274z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star",
						"rate",
						"favorite",
						"bookmark"
					],
					"defaultCode": 60646,
					"grid": 16
				},
				{
					"id": 2805,
					"paths": [
						"M808.654 1009.706c-6.578 0-13.156-2.024-18.754-6.072l-277.9-201.006-277.9 201.004c-11.228 8.124-26.408 8.092-37.606-0.070-11.198-8.166-15.868-22.61-11.568-35.784l106.056-325.026-277.736-200.92c-11.242-8.132-15.96-22.584-11.688-35.784 4.274-13.2 16.568-22.142 30.444-22.142l343.458-0.012 106.12-325.128c4.296-13.164 16.574-22.072 30.42-22.072s26.124 8.908 30.42 22.072l106.122 325.128 343.458 0.012c13.876 0 26.168 8.942 30.442 22.142 4.276 13.2-0.446 27.65-11.688 35.784l-277.734 200.922 106.056 325.026c4.298 13.174-0.372 27.618-11.568 35.784-5.618 4.092-12.234 6.142-18.854 6.142zM130.826 447.902l216.57 156.674c11.264 8.146 15.978 22.636 11.666 35.852l-82.788 253.716 216.974-156.936c11.192-8.096 26.316-8.098 37.508 0l216.972 156.934-82.788-253.714c-4.312-13.214 0.402-27.706 11.666-35.852l216.568-156.674-267.852-0.008c-13.846 0-26.122-8.908-30.418-22.070l-82.904-254-82.904 253.998c-4.296 13.164-16.572 22.070-30.42 22.070l-267.85 0.010z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-empty",
						"rate",
						"star",
						"favorite",
						"bookmark"
					],
					"defaultCode": 60640,
					"grid": 16
				},
				{
					"id": 2806,
					"paths": [
						"M1022.442 406.048c-4.274-13.2-16.566-22.142-30.442-22.142l-343.458-0.012-106.122-325.128c-4.296-13.164-16.572-22.072-30.42-22.072s-26.124 8.908-30.42 22.072l-106.12 325.128-343.46 0.012c-13.876 0-26.168 8.942-30.444 22.142-4.274 13.2 0.446 27.65 11.688 35.784l277.736 200.922-106.056 325.026c-4.298 13.174 0.37 27.618 11.568 35.784 11.198 8.162 26.378 8.194 37.606 0.070l277.902-201.006 277.9 201.004c5.598 4.048 12.176 6.072 18.754 6.072 6.62 0 13.236-2.048 18.854-6.142 11.198-8.166 15.868-22.61 11.568-35.784l-106.056-325.024 277.734-200.922c11.242-8.132 15.962-22.582 11.688-35.784zM676.606 604.576c-11.264 8.146-15.978 22.636-11.666 35.852l82.788 253.714-216.972-156.934c-5.596-4.048-12.176-6.072-18.754-6.072v-559.312l82.904 253.998c4.296 13.164 16.572 22.070 30.418 22.070l267.852 0.008-216.57 156.676z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-empty",
						"rate",
						"star"
					],
					"defaultCode": 60641,
					"grid": 16
				},
				{
					"id": 2808,
					"paths": [
						"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538zM512 753.498l-223.462 117.48 42.676-248.83-180.786-176.222 249.84-36.304 111.732-226.396 111.736 226.396 249.836 36.304-180.788 176.222 42.678 248.83-223.462-117.48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-empty",
						"rate",
						"star",
						"favorite",
						"bookmark"
					],
					"defaultCode": 60643,
					"grid": 16
				},
				{
					"id": 117,
					"paths": [
						"M281.57 426.67c-12.29 0-23.134-8.874-25.221-21.395-2.325-13.946 7.098-27.136 21.043-29.461l89.541-14.923 19.77-39.539c6.323-12.646 21.701-17.773 34.346-11.45 12.646 6.323 17.771 21.701 11.45 34.346l-25.6 51.2c-3.664 7.326-10.61 12.458-18.69 13.803l-102.4 17.067c-1.424 0.237-2.842 0.352-4.238 0.352z",
						"M128 512c-6.552 0-13.102-2.499-18.101-7.499l-51.2-51.2c-6.781-6.781-9.203-16.782-6.277-25.914s10.71-15.862 20.17-17.438l102.4-17.067c13.957-2.326 27.136 7.099 29.461 21.043 2.325 13.946-7.098 27.136-21.043 29.461l-53.331 8.89 16.024 16.026c9.998 9.997 9.998 26.206 0 36.203-5 4.997-11.55 7.496-18.102 7.496z",
						"M759.434 768.005c-12.29 0-23.134-8.875-25.221-21.397l-17.066-102.4c-1.36-8.155 1.302-16.464 7.15-22.309l51.2-51.2c9.997-9.997 26.206-9.997 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-41.885 41.885 14.899 89.406c2.325 13.946-7.098 27.136-21.043 29.459-1.422 0.237-2.838 0.352-4.238 0.352z",
						"M793.598 972.8c-4.205 0-8.422-1.034-12.256-3.126l-153.606-83.784c-12.413-6.768-16.986-22.32-10.216-34.731 6.766-12.414 22.32-16.99 34.731-10.216l107.453 58.61-8.424-50.542c-2.325-13.947 7.098-27.136 21.042-29.461 13.955-2.322 27.136 7.096 29.461 21.042l17.067 102.4c1.61 9.661-2.434 19.394-10.413 25.070-4.418 3.144-9.619 4.739-14.838 4.739z",
						"M273.098 716.805c-1.398 0-2.814-0.115-4.238-0.354-13.946-2.325-23.366-15.514-21.043-29.461l6.368-38.205-41.885-41.885c-9.998-9.997-9.998-26.206 0-36.203s26.206-9.997 36.203 0l51.2 51.2c5.846 5.845 8.509 14.155 7.15 22.31l-8.533 51.2c-2.088 12.522-12.934 21.397-25.222 21.397z",
						"M230.402 972.8c-5.221 0-10.421-1.595-14.842-4.739-7.981-5.677-12.022-15.41-10.413-25.069l25.6-153.598c2.325-13.947 15.514-23.368 29.461-21.043 13.946 2.323 23.366 15.514 21.043 29.459l-16.957 101.742 56.246-30.68c12.41-6.771 27.963-2.197 34.733 10.214 6.77 12.413 2.197 27.963-10.216 34.733l-102.4 55.854c-3.834 2.093-8.051 3.126-12.256 3.126z",
						"M435.222 861.096c-9.067 0-17.85-4.827-22.498-13.347-6.77-12.411-2.197-27.963 10.216-34.731l76.8-41.891c7.64-4.168 16.875-4.168 24.517 0l25.595 13.962c12.413 6.768 16.986 22.32 10.216 34.731-6.766 12.414-22.32 16.99-34.731 10.216l-13.338-7.274-64.541 35.203c-3.893 2.123-8.094 3.131-12.237 3.131z",
						"M896 512c-6.552 0-13.102-2.499-18.101-7.499-9.998-9.997-9.998-26.206 0-36.203l16.024-16.026-104.53-17.422c-13.947-2.325-23.368-15.514-21.043-29.461s15.533-23.368 29.459-21.043l153.6 25.6c9.459 1.576 17.243 8.307 20.17 17.438s0.504 19.133-6.277 25.914l-51.2 51.2c-5 5.003-11.55 7.502-18.102 7.502z",
						"M691.234 418.138c-1.398 0-2.816-0.115-4.24-0.352l-51.202-8.533c-8.078-1.346-15.026-6.477-18.688-13.802l-51.2-102.395c-6.323-12.646-1.198-28.024 11.448-34.346 12.643-6.323 28.024-1.197 34.346 11.448l45.37 90.736 38.344 6.39c13.946 2.325 23.366 15.514 21.042 29.461-2.086 12.518-12.933 21.392-25.219 21.392z",
						"M460.779 256.005c-3.846 0-7.754-0.87-11.429-2.707-12.646-6.323-17.771-21.701-11.45-34.346l51.2-102.4c4.338-8.674 13.203-14.152 22.899-14.152 0 0 0 0 0 0 9.698 0 18.562 5.478 22.898 14.152l25.598 51.2c6.323 12.646 1.197 28.024-11.448 34.346-12.646 6.325-28.024 1.198-34.346-11.45l-2.702-5.403-28.301 56.603c-4.486 8.971-13.53 14.157-22.92 14.157z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-empty",
						"rating"
					],
					"defaultCode": 59414,
					"grid": 20
				},
				{
					"id": 2807,
					"paths": [
						"M1022.442 406.048c-4.274-13.2-16.566-22.142-30.442-22.142l-343.458-0.012-106.122-325.128c-4.296-13.164-16.572-22.072-30.42-22.072s-26.124 8.908-30.42 22.072l-106.12 325.128-343.46 0.012c-13.876 0-26.168 8.942-30.444 22.142-4.274 13.2 0.446 27.65 11.688 35.784l277.736 200.922-106.056 325.026c-4.298 13.174 0.37 27.618 11.568 35.784 11.198 8.162 26.378 8.194 37.606 0.070l277.902-201.006 277.9 201.004c5.598 4.048 12.176 6.072 18.754 6.072 6.62 0 13.236-2.048 18.854-6.142 11.198-8.166 15.868-22.61 11.568-35.784l-106.056-325.024 277.734-200.922c11.242-8.132 15.962-22.582 11.688-35.784z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-full",
						"rate",
						"star",
						"favorite",
						"bookmark"
					],
					"defaultCode": 60642,
					"grid": 16
				},
				{
					"id": 2810,
					"paths": [
						"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-full",
						"rate",
						"star",
						"favorite",
						"bookmark"
					],
					"defaultCode": 60645,
					"grid": 16
				},
				{
					"id": 2809,
					"paths": [
						"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538zM512 753.498l-0.942 0.496 0.942-570.768 111.736 226.396 249.836 36.304-180.788 176.222 42.678 248.83-223.462-117.48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-half",
						"rate",
						"star"
					],
					"defaultCode": 60644,
					"grid": 16
				},
				{
					"id": 1438,
					"width": 950.8538436889648,
					"paths": [
						"M677.714 546.857l146.857-142.857-241.143-35.429-17.143-34.286-90.857-184v550.286l33.714 17.714 181.714 96-34.286-202.857-6.857-37.714zM936 397.143l-207.429 202.286 49.143 285.714q2.857 18.857-3.429 29.429t-19.429 10.571q-9.714 0-22.857-6.857l-256.571-134.857-256.571 134.857q-13.143 6.857-22.857 6.857-13.143 0-19.429-10.571t-3.429-29.429l49.143-285.714-208-202.286q-18.286-18.286-13.143-34t30.857-19.714l286.857-41.714 128.571-260q11.429-23.429 28-23.429 16 0 28 23.429l128.571 260 286.857 41.714q25.714 4 30.857 19.714t-13.714 34z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-half-empty",
						"star-half-full",
						"star-half-o"
					],
					"defaultCode": 61731,
					"grid": 14
				},
				{
					"id": 1308,
					"width": 475.4299831390381,
					"paths": [
						"M475.429 18.286v765.143l-256.571 134.857q-12.571 6.857-22.857 6.857-12 0-18-8.286t-6-20.286q0-3.429 1.143-11.429l49.143-285.714-208-202.286q-14.286-15.429-14.286-27.429 0-21.143 32-26.286l286.857-41.714 128.571-260q10.857-23.429 28-23.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-half"
					],
					"defaultCode": 61577,
					"grid": 14
				},
				{
					"id": 116,
					"paths": [
						"M793.598 972.8c-4.205 0-8.422-1.034-12.256-3.126l-153.595-83.778c-12.413-6.768-16.986-22.32-10.218-34.731 6.77-12.414 22.322-16.992 34.733-10.216l107.442 58.603-8.424-50.542c-2.325-13.947 7.098-27.136 21.042-29.461 13.941-2.33 27.136 7.096 29.461 21.042l17.067 102.4c1.611 9.661-2.434 19.394-10.413 25.070-4.418 3.144-9.619 4.739-14.838 4.739z",
						"M759.434 768.005c-12.29 0-23.134-8.875-25.221-21.397l-17.066-102.4c-1.36-8.155 1.302-16.464 7.15-22.309l51.2-51.2c9.997-9.997 26.206-9.997 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-41.885 41.885 14.899 89.406c2.325 13.946-7.098 27.136-21.043 29.459-1.422 0.237-2.838 0.35-4.238 0.352z",
						"M896 512c-6.552 0-13.102-2.499-18.101-7.499-9.998-9.997-9.998-26.206 0-36.203l16.024-16.026-104.53-17.422c-13.947-2.325-23.368-15.514-21.043-29.461s15.533-23.368 29.459-21.043l153.6 25.6c9.459 1.576 17.243 8.307 20.17 17.438s0.504 19.133-6.277 25.914l-51.2 51.2c-5 5.003-11.55 7.502-18.102 7.502z",
						"M691.232 418.136c-1.398 0-2.814-0.115-4.238-0.352l-51.2-8.533c-8.080-1.346-15.027-6.477-18.69-13.802l-51.2-102.395c-6.323-12.646-1.198-28.024 11.448-34.346 12.643-6.323 28.024-1.197 34.346 11.448l45.37 90.736 38.341 6.39c13.947 2.325 23.368 15.514 21.043 29.461-2.085 12.518-12.933 21.392-25.219 21.392z",
						"M230.402 972.8c-5.221 0-10.421-1.595-14.842-4.739-7.981-5.677-12.022-15.41-10.413-25.069l49.034-294.206-195.482-195.485c-6.781-6.781-9.203-16.782-6.277-25.914s10.71-15.862 20.17-17.438l294.341-49.058 122.17-244.339c4.336-8.674 13.202-14.152 22.898-14.152 0 0 0 0 0 0 9.698 0 18.562 5.478 22.898 14.152l25.6 51.2c6.322 12.646 1.195 28.024-11.45 34.346-12.646 6.325-28.024 1.198-34.347-11.45l-2.701-5.403-105.101 210.203c-3.664 7.326-10.61 12.458-18.69 13.803l-258.133 43.022 169.626 169.626c5.846 5.845 8.509 14.155 7.149 22.309l-42.557 255.344 235.446-128.426c7.642-4.17 16.875-4.166 24.518 0l25.603 13.966c12.411 6.77 16.984 22.32 10.214 34.733-6.77 12.411-22.318 16.984-34.733 10.214l-13.344-7.278-269.341 146.912c-3.835 2.093-8.053 3.126-12.258 3.126z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-half",
						"rating"
					],
					"defaultCode": 59413,
					"grid": 20
				},
				{
					"id": 1185,
					"width": 950.856954574585,
					"paths": [
						"M649.714 573.714l174.857-169.714-241.143-35.429-108-218.286-108 218.286-241.143 35.429 174.857 169.714-41.714 240.571 216-113.714 215.429 113.714zM950.857 369.714q0 12.571-14.857 27.429l-207.429 202.286 49.143 285.714q0.571 4 0.571 11.429 0 28.571-23.429 28.571-10.857 0-22.857-6.857l-256.571-134.857-256.571 134.857q-12.571 6.857-22.857 6.857-12 0-18-8.286t-6-20.286q0-3.429 1.143-11.429l49.143-285.714-208-202.286q-14.286-15.429-14.286-27.429 0-21.143 32-26.286l286.857-41.714 128.571-260q10.857-23.429 28-23.429t28 23.429l128.571 260 286.857 41.714q32 5.143 32 26.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star-o"
					],
					"defaultCode": 61446,
					"grid": 14
				},
				{
					"id": 1184,
					"width": 950.856954574585,
					"paths": [
						"M950.857 369.714q0 12.571-14.857 27.429l-207.429 202.286 49.143 285.714q0.571 4 0.571 11.429 0 12-6 20.286t-17.429 8.286q-10.857 0-22.857-6.857l-256.571-134.857-256.571 134.857q-12.571 6.857-22.857 6.857-12 0-18-8.286t-6-20.286q0-3.429 1.143-11.429l49.143-285.714-208-202.286q-14.286-15.429-14.286-27.429 0-21.143 32-26.286l286.857-41.714 128.571-260q10.857-23.429 28-23.429t28 23.429l128.571 260 286.857 41.714q32 5.143 32 26.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star"
					],
					"defaultCode": 61445,
					"grid": 14
				},
				{
					"id": 115,
					"paths": [
						"M793.598 972.8c-4.205 0-8.422-1.034-12.258-3.126l-269.341-146.912-269.341 146.912c-8.598 4.691-19.118 4.061-27.098-1.613-7.981-5.677-12.022-15.41-10.413-25.069l49.034-294.206-195.483-195.485c-6.781-6.781-9.203-16.782-6.277-25.914s10.712-15.862 20.17-17.438l294.341-49.058 122.17-244.339c4.336-8.674 13.2-14.152 22.898-14.152s18.562 5.478 22.898 14.152l122.17 244.339 294.341 49.058c9.459 1.576 17.243 8.307 20.17 17.438s0.504 19.133-6.277 25.914l-195.483 195.485 49.034 294.206c1.61 9.659-2.434 19.392-10.413 25.069-4.419 3.144-9.621 4.739-14.84 4.739zM512 768c4.219 0 8.437 1.042 12.259 3.126l235.445 128.426-42.557-255.344c-1.36-8.155 1.302-16.464 7.15-22.309l169.626-169.626-258.131-43.022c-8.080-1.346-15.027-6.477-18.69-13.803l-105.102-210.205-105.102 210.205c-3.664 7.326-10.61 12.458-18.69 13.803l-258.131 43.022 169.624 169.626c5.846 5.845 8.509 14.155 7.15 22.309l-42.557 255.344 235.446-128.426c3.821-2.085 8.040-3.126 12.259-3.126z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"star",
						"rating",
						"favorite"
					],
					"defaultCode": 59412,
					"grid": 20
				},
				{
					"id": 2769,
					"paths": [
						"M512.002 80.014l81.096-80.014 52.39 101.158 101.852-51.042 18.572 112.402 112.64-17.068-17.072 112.638 112.404 18.574-51.040 101.85 101.156 52.392-80.014 81.096 80.014 81.096-101.156 52.392 51.040 101.85-112.404 18.574 17.072 112.638-112.64-17.068-18.572 112.402-101.852-51.042-52.39 101.158-81.096-80.014-81.1 80.014-52.392-101.158-101.848 51.042-18.574-112.402-112.638 17.068 17.072-112.638-112.402-18.574 51.038-101.85-101.158-52.392 80.016-81.096-80.016-81.096 101.158-52.392-51.038-101.85 112.402-18.574-17.072-112.638 112.638 17.068 18.574-112.402 101.848 51.042 52.392-101.158z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"starburst"
					],
					"defaultCode": 60604,
					"grid": 16
				},
				{
					"id": 2483,
					"width": 1088,
					"paths": [
						"M288.002 457.722l59.276 182.434h191.82l-155.188 112.75 59.278 182.434-155.186-112.748-155.188 112.748 59.278-182.434-155.19-112.75h191.824z",
						"M544 9.722l59.278 182.434h191.82l-155.188 112.75 59.278 182.434-155.188-112.748-155.186 112.748 59.278-182.434-155.19-112.75h191.824z",
						"M800 457.722l59.278 182.434h191.82l-155.188 112.75 59.278 182.434-155.188-112.748-155.188 112.748 59.278-182.434-155.188-112.75h191.824z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stars"
					],
					"defaultCode": 60318,
					"grid": 16
				},
				{
					"id": 839,
					"width": 1024,
					"paths": [
						"M384 688c0-8.832 7.168-16 16-16h224c8.832 0 16 7.168 16 16s-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16zM400 768h224c8.832 0 16-7.168 16-16s-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16zM928 416v416c0 53.024-42.976 96-96 96h-640c-53.024 0-96-42.976-96-96v-392.864c-19.040-11.104-32-31.52-32-55.136 0-18.976 8.448-35.872 21.568-47.584l-2.048-15.616c-6.88-52.544 30.144-100.768 82.72-107.648l634.56-83.168c4.224-0.544 8.448-0.832 12.608-0.832 47.456 0 88.736 35.2 95.072 83.552l8.32 63.456c2.304 17.536-10.048 33.6-27.584 35.872l-549.024 71.968h555.808c17.664 0 32 14.336 32 32zM438.624 416l128 128h146.752l-128-128h-146.752zM246.624 416l128 128h146.752l-128-128h-146.752zM201.376 416h-18.24c-11.104 19.040-31.52 32-55.136 32v96h201.376l-128-128zM874.176 205.568l-55.648 83.488 66.528-8.704-8.32-63.456c-0.512-3.936-1.376-7.712-2.56-11.328zM725.824 172.096l-94.304 141.44 144.8-18.976 78.624-117.888c-11.264-9.696-25.792-15.52-41.536-15.52-2.784 0-5.6 0.192-8.448 0.544l-79.136 10.4zM538.816 196.608l-94.304 141.44 144.864-18.976 94.304-141.44-144.864 18.976zM351.808 221.12l-94.304 141.44 144.864-18.976 94.304-141.44-144.864 18.976zM115.264 316.672l0.608 4.576c3.936-0.768 7.968-1.248 12.128-1.248 31.008 0 56.832 22.048 62.72 51.328l24.672-3.232 94.304-141.44-139.296 18.24c-16.96 2.208-32.032 10.912-42.432 24.48-10.432 13.536-14.944 30.336-12.704 47.296zM128 416c17.632 0 32-14.368 32-32s-14.368-32-32-32-32 14.368-32 32 14.368 32 32 32zM896 576h-768v256c0 35.296 28.704 64 64 64h640c35.296 0 64-28.704 64-64v-256zM896 534.624l-118.624-118.624h-146.752l128 128h137.376v-9.376zM896 416h-73.376l73.376 73.376v-73.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"start",
						"cut",
						"direct",
						"film"
					],
					"grid": 32
				},
				{
					"id": 840,
					"width": 1024,
					"paths": [
						"M566.624 544l-160-160h146.752l160 160h-146.752zM128 480c-11.296 0-21.952-2.304-32-5.888v69.888h233.376l-116.32-116.32c-15.968 30.944-47.84 52.32-85.056 52.32zM885.088 280.352c17.504-2.304 29.856-18.368 27.552-35.872l-4.16-31.744c-1.824-13.952-6.848-26.624-13.824-37.888l-76.544 114.336 66.976-8.832zM775.904 294.72l96.8-144.576c-16.512-13.088-37.152-20.96-59.296-20.96-4.16 0-8.352 0.256-12.608 0.832l-51.2 6.72-118.56 177.056 144.864-19.072zM905.376 544l-160-160h-146.752l160 160h146.752zM521.376 544l-160-160h-137.376c0 2.912-0.448 5.664-0.8 8.448l151.424 151.552h146.752zM192 384c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64zM96 576h832v256c0 53.024-42.976 96-96 96h-640c-53.024 0-96-42.976-96-96v-256zM384 720c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16zM384 784c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16s-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16zM896 384h-105.376l137.376 137.376v-105.376c0-17.664-14.336-32-32-32zM588.832 319.36l118.592-177.12-144.8 18.976-118.656 177.216 144.864-19.072zM401.76 344l118.688-177.248-144.768 18.944-118.592 177.344 144.672-19.040zM220.608 360l112.864-168.768-167.232 21.92c-45.344 5.952-78.976 42.688-82.976 86.4 13.408-7.136 28.48-11.552 44.736-11.552 44.672 0 81.888 30.656 92.608 72z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"start",
						"cut",
						"direct",
						"film"
					],
					"grid": 32
				},
				{
					"id": 1942,
					"paths": [
						"M640 320c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128 0 45.354 23.608 85.166 59.184 107.904l-162.572 596.096h78.776l17.454-64h270.316l17.456 64h78.776l-162.572-596.096c35.574-22.738 59.182-62.55 59.182-107.904zM594.794 768h-165.588l17.454-64h130.68l17.454 64zM464.116 640l47.884-175.578 47.884 175.578h-95.768zM394.296 896l17.456-64h200.498l17.454 64h-235.408zM664.348 38.526c99.852 54.158 167.652 159.898 167.652 281.474s-67.8 227.316-167.652 281.474c44.066-70.126 71.652-170.27 71.652-281.474s-27.586-211.348-71.652-281.474zM856.348 38.526c99.852 54.158 167.652 159.898 167.652 281.474s-67.8 227.316-167.652 281.474c44.066-70.126 71.652-170.27 71.652-281.474s-27.586-211.348-71.652-281.474zM359.652 601.474c-99.852-54.16-167.652-159.898-167.652-281.474s67.8-227.314 167.652-281.474c-44.068 70.126-71.652 170.27-71.652 281.474s27.584 211.348 71.652 281.474zM0 320c0-121.576 67.8-227.314 167.652-281.474-44.068 70.126-71.652 170.27-71.652 281.474s27.584 211.348 71.652 281.474c-99.852-54.16-167.652-159.898-167.652-281.474z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"station",
						"radio",
						"broadcast",
						"live"
					],
					"defaultCode": 59777,
					"grid": 16
				},
				{
					"id": 1943,
					"paths": [
						"M200.194 726.176l41.15-90.528c-88.918-76.354-145.344-189.53-145.344-315.648 0-98.228 34.244-188.596 91.392-259.844l-75.124-60.134c-72.734 90.508-112.268 202.196-112.268 319.978 0 136.76 53.256 265.336 149.96 362.040 15.914 15.912 32.704 30.62 50.234 44.136z",
						"M782.656 635.646l41.148 90.53c17.534-13.516 34.322-28.224 50.234-44.136 96.704-96.704 149.962-225.28 149.962-362.040 0-117.78-39.534-229.468-112.268-319.978l-75.124 60.134c57.148 71.248 91.392 161.616 91.392 259.844 0 126.118-56.426 239.294-145.344 315.646z",
						"M704.396 463.474l43.52 95.744c0.554-0.548 1.12-1.078 1.672-1.63 122.162-122.164 130.388-315.752 24.718-447.56l-74.942 59.99c68.292 85.186 69.97 206.494 5.032 293.456z",
						"M274.412 557.588c0.552 0.552 1.118 1.082 1.672 1.63l43.52-95.744c-64.938-86.962-63.26-208.272 5.032-293.458l-74.942-59.99c-105.67 131.81-97.444 325.398 24.718 447.562z",
						"M640 320c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128 0 37.312 15.974 70.886 41.448 94.282l-277.146 609.718h105.452l58.182-128h400.128l58.182 128h105.452l-277.146-609.718c25.474-23.396 41.448-56.97 41.448-94.282zM512 455.86l83.702 184.14h-167.402l83.7-184.14zM682.972 832h-341.946l58.182-128h225.582l58.182 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"station",
						"radio",
						"broadcast",
						"live"
					],
					"defaultCode": 59778,
					"grid": 16
				},
				{
					"id": 2461,
					"paths": [
						"M976 192c26.4 0 48-21.6 48-48v-96c0-26.4-21.6-48-48-48h-96c-26.4 0-48 21.6-48 48v16h-640v-16c0-26.4-21.6-48-48-48h-96c-26.4 0-48 21.6-48 48v96c0 26.4 21.6 48 48 48h16v640h-16c-26.4 0-48 21.6-48 48v96c0 26.4 21.6 48 48 48h96c26.4 0 48-21.6 48-48v-16h640v16c0 26.4 21.6 48 48 48h96c26.4 0 48-21.6 48-48v-96c0-26.4-21.6-48-48-48h-16v-640h16zM896 64h64v64h-64v-64zM64 64h64v64h-64v-64zM128 960h-64v-64h64v64zM960 960h-64v-64h64v64zM896 832h-16c-26.4 0-48 21.6-48 48v16h-640v-16c0-26.4-21.6-48-48-48h-16v-640h16c26.4 0 48-21.6 48-48v-16h640v16c0 26.4 21.6 48 48 48h16v640zM256 256h128v512h-128zM448 512h128v256h-128zM640 384h128v384h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-bars",
						"stats",
						"statistics",
						"chart"
					],
					"defaultCode": 60296,
					"grid": 16
				},
				{
					"id": 2463,
					"paths": [
						"M0 832h1024v128h-1024zM128 576h128v192h-128zM320 320h128v448h-128zM512 512h128v256h-128zM704 128h128v640h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-bars",
						"stats",
						"statistics",
						"chart"
					],
					"defaultCode": 60298,
					"grid": 16
				},
				{
					"id": 2464,
					"paths": [
						"M640 256h-256v768h256v-768zM448 328v-8h128v8h-128zM448 360v-16h128v16h-128zM448 392v-16h128v16h-128zM448 424v-16h128v16h-128zM448 456v-16h128v16h-128zM448 488v-16h128v16h-128zM448 520v-16h128v16h-128zM448 552v-16h128v16h-128zM448 584v-16h128v16h-128zM448 616v-16h128v16h-128zM448 648v-16h128v16h-128zM448 680v-16h128v16h-128zM448 712v-16h128v16h-128zM448 744v-16h128v16h-128zM448 776v-16h128v16h-128zM448 808v-16h128v16h-128zM448 840v-16h128v16h-128zM448 872v-16h128v16h-128zM448 904v-16h128v16h-128zM448 936v-16h128v16h-128zM448 960v-8h128v8h-128zM0 576h256v448h-256zM768 0h256v1024h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-bars",
						"stats",
						"statistics",
						"chart",
						"dualtone"
					],
					"defaultCode": 60299,
					"grid": 16
				},
				{
					"id": 2465,
					"paths": [
						"M288 384h-192c-17.6 0-32 14.4-32 32v576c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-576c0-17.6-14.4-32-32-32zM288 960h-192v-256h192v256zM608 256h-192c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-704c0-17.6-14.4-32-32-32zM608 960h-192v-320h192v320zM928 128h-192c-17.6 0-32 14.4-32 32v832c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-832c0-17.6-14.4-32-32-32zM928 960h-192v-384h192v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-bars",
						"stats",
						"statistics",
						"chart"
					],
					"defaultCode": 60300,
					"grid": 16
				},
				{
					"id": 2466,
					"paths": [
						"M608 256h-192c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-704c0-17.6-14.4-32-32-32zM608 960h-192v-328h192v328zM608 616h-192v-16h192v16zM608 584h-192v-16h192v16zM608 552h-192v-16h192v16zM608 520h-192v-16h192v16zM608 488h-192v-16h192v16zM608 456h-192v-16h192v16zM608 424h-192v-16h192v16zM608 392h-192v-16h192v16zM608 360h-192v-16h192v16zM608 328h-192v-8h192v8zM288 384h-192c-17.6 0-32 14.4-32 32v576c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-576c0-17.6-14.4-32-32-32zM288 960h-192v-264h192v264zM288 680h-192v-16h192v16zM288 648h-192v-16h192v16zM288 616h-192v-16h192v16zM288 584h-192v-16h192v16zM288 552h-192v-16h192v16zM288 520h-192v-16h192v16zM288 488h-192v-16h192v16zM288 456h-192v-8h192v8zM928 128h-192c-17.6 0-32 14.4-32 32v832c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-832c0-17.6-14.4-32-32-32zM928 960h-192v-392h192v392zM928 552h-192v-16h192v16zM928 520h-192v-16h192v16zM928 488h-192v-16h192v16zM928 456h-192v-16h192v16zM928 424h-192v-16h192v16zM928 392h-192v-16h192v16zM928 360h-192v-16h192v16zM928 328h-192v-16h192v16zM928 296h-192v-16h192v16zM928 264h-192v-16h192v16zM928 232h-192v-16h192v16zM928 200h-192v-8h192v8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-bars",
						"stats",
						"statistics",
						"chart"
					],
					"defaultCode": 60301,
					"grid": 16
				},
				{
					"id": 2467,
					"paths": [
						"M288 384h-192c-17.6 0-32 14.4-32 32v576c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-576c0-17.6-14.4-32-32-32zM288 704v8h-192v-8h192zM96 904v-16h192v16h-192zM288 920v16h-192v-16h192zM96 872v-16h192v16h-192zM96 840v-16h192v16h-192zM96 808v-16h192v16h-192zM96 776v-16h192v16h-192zM96 744v-16h192v16h-192zM96 960v-8h192v8h-192zM608 256h-192c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-704c0-17.6-14.4-32-32-32zM608 640v8h-192v-8h192zM416 904v-16h192v16h-192zM608 920v16h-192v-16h192zM416 872v-16h192v16h-192zM416 840v-16h192v16h-192zM416 808v-16h192v16h-192zM416 776v-16h192v16h-192zM416 744v-16h192v16h-192zM416 712v-16h192v16h-192zM416 680v-16h192v16h-192zM416 960v-8h192v8h-192zM928 128h-192c-17.6 0-32 14.4-32 32v832c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32v-832c0-17.6-14.4-32-32-32zM928 576v8h-192v-8h192zM736 904v-16h192v16h-192zM928 920v16h-192v-16h192zM736 872v-16h192v16h-192zM736 840v-16h192v16h-192zM736 808v-16h192v16h-192zM736 776v-16h192v16h-192zM736 744v-16h192v16h-192zM736 712v-16h192v16h-192zM736 680v-16h192v16h-192zM736 648v-16h192v16h-192zM736 616v-16h192v16h-192zM736 960v-8h192v8h-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-bars",
						"stats",
						"statistics",
						"chart"
					],
					"defaultCode": 60302,
					"grid": 16
				},
				{
					"id": 2470,
					"paths": [
						"M192 419.882v604.118h-128v-732.118l128 128z",
						"M384 611.882v412.118h-128v-540.118l128 128z",
						"M576 1024h-128v-348.118l128-128v476.118z",
						"M913.942 462.058l-273.942-273.94-192 192-270.058-270.060-67.884 67.884 337.942 337.94 192-192 206.058 206.060-110.058 110.058h288v-288z",
						"M832 704h128v320h-128v-320z",
						"M640 704h128v320h-128v-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-decline",
						"stats",
						"bars",
						"graph",
						"statistics",
						"down"
					],
					"defaultCode": 60305,
					"grid": 16
				},
				{
					"id": 2472,
					"paths": [
						"M736 768l112-112-240-240-192 192-416-416 64-64 352 352 192-192 304 304 112-112v288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-decline",
						"stats",
						"bars",
						"graph",
						"statistics",
						"down"
					],
					"defaultCode": 60307,
					"grid": 16
				},
				{
					"id": 2460,
					"paths": [
						"M128 896h896v128h-1024v-1024h128zM288 832c-53.020 0-96-42.98-96-96s42.98-96 96-96c2.828 0 5.622 0.148 8.388 0.386l103.192-171.986c-9.84-15.070-15.58-33.062-15.58-52.402 0-53.020 42.98-96 96-96s96 42.98 96 96c0 19.342-5.74 37.332-15.58 52.402l103.192 171.986c2.766-0.238 5.56-0.386 8.388-0.386 2.136 0 4.248 0.094 6.35 0.23l170.356-298.122c-10.536-15.408-16.706-34.036-16.706-54.11 0-53.020 42.98-96 96-96s96 42.98 96 96c0 53.020-42.98 96-96 96-2.14 0-4.248-0.094-6.35-0.232l-170.356 298.124c10.536 15.406 16.706 34.036 16.706 54.11 0 53.020-42.98 96-96 96s-96-42.98-96-96c0-19.34 5.74-37.332 15.578-52.402l-103.19-171.984c-2.766 0.238-5.56 0.386-8.388 0.386s-5.622-0.146-8.388-0.386l-103.192 171.986c9.84 15.068 15.58 33.060 15.58 52.4 0 53.020-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-dots",
						"stats",
						"plot",
						"statistics",
						"chart"
					],
					"defaultCode": 60295,
					"grid": 16
				},
				{
					"id": 2469,
					"paths": [
						"M736 0l110.058 110.058-270.058 270.060-192-192-352 352 67.882 67.882 284.118-284.118 192 192 337.942-337.94 110.058 110.058v-288z",
						"M832 419.882v604.118h128v-732.118z",
						"M640 611.882v412.118h128v-540.118z",
						"M448 1024h128v-348.118l-128-128z",
						"M256 1024h128v-540.118l-128 128z",
						"M64 803.882v220.118h128v-348.118z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-growth",
						"stats",
						"improvement",
						"bars",
						"graph",
						"statistics",
						"up"
					],
					"defaultCode": 60304,
					"grid": 16
				},
				{
					"id": 2471,
					"paths": [
						"M736 256l112 112-240 240-192-192-416 416 64 64 352-352 192 192 304-304 112 112v-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stats-growth",
						"stats",
						"improvement",
						"bars",
						"graph",
						"statistics",
						"up"
					],
					"defaultCode": 60306,
					"grid": 16
				},
				{
					"id": 2516,
					"paths": [
						"M1024 448c0-176.448-143.55-320-320-320-61.238 0-121.316 16.824-173.738 48.652-52.572 31.918-93.806 76.684-119.242 129.458-22.806 47.316-83.656 77.89-155.020 77.89h-64c-105.87 0-192 86.13-192 192v64c0 95.45 55.632 179.98 156.646 238.020 92.010 52.864 218.21 81.98 355.354 81.98 139.18 0 266.97-42.39 359.832-119.364 47.984-39.774 85.444-87.508 111.338-141.876 27.094-56.886 40.83-119.72 40.83-186.76 0-9.71-0.46-19.314-1.312-28.804 0.86-11.596 1.312-23.326 1.312-35.196zM830.99 727.364c-81.404 67.476-194.69 104.636-318.99 104.636-126.132 0-241.008-26.094-323.468-73.472-56.81-32.642-124.532-90.806-124.532-182.528 0-70.58 57.42-128 128-128h64c44.122 0 86.656-9.432 123-27.274 40.982-20.118 71.99-50.142 89.67-86.828 40.91-84.874 135.482-141.898 235.33-141.898 141.158 0 256 114.84 256 256 0 112.804-44.61 209.406-129.010 279.364z",
						"M704 264c-71.662 0-141.762 41.598-170.468 101.16-24.748 51.344-67.212 92.908-122.802 120.198-46.166 22.662-99.67 34.642-154.73 34.642h-64c-30.878 0-56 25.122-56 56 0 45.988 29.742 86.396 88.402 120.098 71.718 41.208 173.856 63.902 287.598 63.902 107.558 0 204.528-31.278 273.042-88.070 68.318-56.628 102.958-131.97 102.958-223.93 0-101.458-82.542-184-184-184zM704 512c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"steak",
						"food",
						"meat"
					],
					"defaultCode": 60351,
					"grid": 16
				},
				{
					"id": 3360,
					"paths": [
						"M704 288c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM958.392 129.608c-87.478-87.476-229.306-87.476-316.786 0-35.578 35.578-56.684 80.146-63.322 126.392v0l-204.694 310.228c-27.506 1.41-54.776 8.416-79.966 21.016l-157.892-123.424c-36.55-28.574-89.342-22.102-117.912 14.448-28.572 36.55-22.102 89.342 14.448 117.912l155.934 121.892c-16.96 66.782 0.672 140.538 52.93 192.794 78.906 78.904 206.832 78.904 285.736 0 48.466-48.466 67.15-115.428 56.076-178.166l249.054-222.986c46.248-6.638 90.816-27.744 126.394-63.322 87.478-87.476 87.478-229.306 0-316.784zM384 902.698c-74.39 0-134.698-60.304-134.698-134.698 0-0.712 0.042-1.414 0.054-2.124l66.912 52.304c15.36 12.006 33.582 17.824 51.674 17.824 24.962 0 49.672-11.080 66.238-32.272 28.572-36.55 22.102-89.342-14.448-117.912l-63.5-49.636c8.962-1.878 18.248-2.88 27.768-2.88 74.392 0 134.698 60.304 134.698 134.698s-60.306 134.696-134.698 134.696zM800 448c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160-71.634 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"steam",
						"brand",
						"social"
					],
					"defaultCode": 61195,
					"grid": 16
				},
				{
					"id": 1577,
					"width": 877.7150573730469,
					"paths": [
						"M709.714 369.714q0-45.714-32.571-78t-78.286-32.286-78 32.571-32.286 77.714q0 45.714 32.286 78t78 32.286 78.286-32.286 32.571-78zM361.143 705.714q0 47.429-33.143 80.286t-80 32.857q-32 0-58.857-16.571t-41.143-44q29.714 11.429 56 22.857 34.286 13.714 68.571-0.857t48.571-49.429q13.714-34.286-0.857-68.571t-49.429-48l-46.857-18.857q12.571-2.857 24-2.857 46.857 0 80 32.857t33.143 80.286zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-87.429l98.286 39.429q11.429 52.571 53.429 86.857t96.286 34.286q59.429 0 103.429-40t49.714-98.857l197.143-144q85.714 0 146-60.286t60.286-145.429q0-85.714-60.286-146t-146-60.286q-84.571 0-144.571 59.714t-61.143 144.286l-128.571 184q-5.143-0.571-16-0.571-42.857 0-78.286 21.143l-169.714-68v-267.429q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286zM736.571 370.857q0 57.143-40.571 97.429t-97.714 40.286-97.429-40.286-40.286-97.429 40.286-97.714 97.429-40.571q57.714 0 98 40.286t40.286 98z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"steam-square"
					],
					"defaultCode": 61879,
					"grid": 14
				},
				{
					"id": 3361,
					"paths": [
						"M303.922 836.010c27.144 0 53.786-13.136 69.972-37.416 25.734-38.602 15.302-90.754-23.298-116.488l-66.074-44.048c11.308-3.080 23.194-4.756 35.478-4.756 74.392 0 134.696 60.304 134.696 134.698s-60.306 134.698-134.698 134.698c-72.404 0-131.444-57.132-134.548-128.774l71.954 47.968c14.322 9.548 30.506 14.118 46.518 14.118zM853.34 0c93.876 0 170.66 76.812 170.66 170.688v682.628c0 93.936-76.784 170.684-170.66 170.684h-682.652c-93.876 0-170.688-76.75-170.688-170.682v-203.028l121.334 80.888c-11.652 63.174 6.938 130.83 55.798 179.69 78.904 78.904 206.83 78.904 285.736 0 48.468-48.466 67.15-115.43 56.076-178.166l249.056-222.988c46.248-6.638 90.816-27.744 126.394-63.322 87.476-87.476 87.476-229.306 0-316.784-87.48-87.478-229.308-87.478-316.786 0-35.578 35.578-56.684 80.146-63.322 126.392v0l-204.694 310.23c-31.848 1.632-63.378 10.764-91.726 27.392l-217.866-145.244v-277.69c0-93.876 76.81-170.688 170.686-170.688h682.654zM896 288c0-88.366-71.634-160-160-160s-160 71.634-160 160 71.634 160 160 160 160-71.634 160-160zM640 288c0-53.020 42.98-96 96-96s96 42.98 96 96-42.98 96-96 96-96-42.98-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"steam",
						"brand",
						"social"
					],
					"defaultCode": 61196,
					"grid": 16
				},
				{
					"id": 1576,
					"width": 1023.9989624023438,
					"paths": [
						"M904 332.571q0 57.714-40.857 98.571t-98.571 40.857-98.571-40.857-40.857-98.571 40.857-98.571 98.571-40.857 98.571 40.857 40.857 98.571zM464 756.571q0-59.429-41.714-101.143t-101.143-41.714q-15.429 0-30.857 3.429l59.429 24q44 17.714 62.571 60.857t0.857 86.571q-17.714 44-61.143 62.286t-86.857 0.571q-12-4.571-35.429-14t-34.857-14q18.286 34.286 52 55.143t74.286 20.857q59.429 0 101.143-41.714t41.714-101.143zM938.286 333.143q0-72-51.143-123.143t-123.143-51.143q-72.571 0-123.714 51.143t-51.143 123.143q0 72.571 51.143 123.429t123.714 50.857q72 0 123.143-50.857t51.143-123.429zM1024 333.143q0 108-76.286 184t-183.714 76l-249.714 182.286q-6.857 73.714-62.286 124.571t-130.857 50.857q-69.143 0-122.286-43.429t-67.429-109.714l-131.429-52.571v-245.143l222.286 89.714q45.143-27.429 98.857-27.429 7.429 0 20 1.143l162.286-232.571q1.143-106.857 77.429-182.286t183.143-75.429q107.429 0 183.714 76.286t76.286 183.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"steam"
					],
					"defaultCode": 61878,
					"grid": 14
				},
				{
					"id": 841,
					"width": 1024,
					"paths": [
						"M512 192c-176.448 0-320 143.552-320 320s143.552 320 320 320 320-143.552 320-320c0-176.448-143.552-320-320-320zM576 231.392c32.096 7.296 62.080 19.968 89.12 36.992l-89.12 89.12v-126.112zM476.8 226.368c11.552-1.408 23.264-2.368 35.2-2.368s23.648 0.96 35.2 2.368v163.168c-11.264-3.264-22.912-5.536-35.2-5.536s-23.936 2.272-35.2 5.504v-163.136zM608 512c0 52.928-43.072 96-96 96s-96-43.072-96-96c0-52.928 43.072-96 96-96s96 43.072 96 96zM448 231.392v126.112l-89.12-89.12c27.040-17.024 57.024-29.696 89.12-36.992zM334.944 285.184l115.328 115.328c-20.96 11.648-38.144 28.8-49.792 49.792l-115.328-115.328c14.528-18.592 31.232-35.296 49.792-49.792zM268.384 358.88l88.64 88.64-125.408-0.384c7.296-31.776 19.904-61.472 36.768-88.256zM224 512c0-12.256 1.024-24.224 2.496-36.096l163.136 0.48c-3.296 11.392-5.632 23.168-5.632 35.616 0 12.16 2.24 23.68 5.408 34.784l-163.168-0.448c-1.344-11.296-2.24-22.688-2.24-34.336zM231.168 575.136l126.784 0.384-89.568 89.568c-17.184-27.264-29.952-57.536-37.216-89.952zM448 792.608c-32.096-7.296-62.080-19.968-89.12-36.992l89.12-89.12v126.112zM334.944 738.816c-18.56-14.496-35.264-31.2-49.792-49.792l115.328-115.328c11.648 20.96 28.8 38.144 49.792 49.792l-115.328 115.328zM547.2 797.632c-11.552 1.408-23.264 2.368-35.2 2.368s-23.648-0.96-35.2-2.368v-163.168c11.264 3.264 22.912 5.536 35.2 5.536s23.936-2.272 35.2-5.504v163.136zM576 792.608v-126.112l89.12 89.12c-27.040 17.024-57.024 29.696-89.12 36.992zM689.056 738.816l-115.328-115.328c20.96-11.648 38.144-28.8 49.792-49.792l115.328 115.328c-14.528 18.592-31.232 35.296-49.792 49.792zM755.616 665.12l-88.64-88.64 125.408 0.384c-7.328 31.776-19.904 61.472-36.768 88.256zM800 512c0 12.256-1.024 24.224-2.496 36.064l-163.136-0.48c3.296-11.36 5.632-23.136 5.632-35.584 0-12.16-2.24-23.68-5.408-34.784l163.168 0.48c1.344 11.264 2.24 22.656 2.24 34.304zM792.832 448.864l-126.784-0.384 89.568-89.568c17.184 27.264 29.952 57.536 37.216 89.952zM623.488 450.304c-11.648-20.96-28.8-38.144-49.792-49.792l115.328-115.328c18.56 14.528 35.264 31.2 49.792 49.792l-115.328 115.328zM960.192 449.376l-37.44-0.128c-10.24-67.52-36.576-129.6-75.168-182.336l26.432-26.432c12.512-12.512 12.512-32.768 0-45.248l-45.248-45.248c-6.24-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-26.432 26.432c-52.416-38.368-114.048-64.608-181.088-75.008v-37.408c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v37.408c-67.040 10.368-128.672 36.608-181.088 74.976l-26.432-26.432c-6.272-6.24-14.432-9.376-22.624-9.376s-16.384 3.136-22.624 9.376l-45.28 45.28c-12.512 12.512-12.512 32.768 0 45.248l26.432 26.432c-38.112 52.096-64.256 113.28-74.784 179.84l-37.408-0.128c-17.664-0.064-32.032 14.24-32.096 31.904l-0.192 64c-0.064 17.664 14.24 32.032 31.904 32.096l37.44 0.128c10.24 67.52 36.576 129.6 75.168 182.336l-26.432 26.432c-12.512 12.512-12.512 32.768 0 45.248l45.248 45.248c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l26.432-26.432c52.416 38.368 114.048 64.608 181.088 74.976v37.44c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-37.408c67.040-10.368 128.672-36.608 181.088-74.976l26.432 26.432c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l45.248-45.248c12.512-12.512 12.512-32.768 0-45.248l-26.432-26.432c38.112-52.096 64.256-113.28 74.784-179.84l37.408 0.128c17.664 0.064 32.032-14.24 32.096-31.904l0.192-64c0.096-17.696-14.208-32.064-31.872-32.128zM97.728 545.92l-33.824-0.096c-1.76 0-3.2-1.44-3.2-3.2l0.192-64c0-1.76 1.44-3.2 3.2-3.2l33.728 0.096c-1.024 12.064-1.824 24.16-1.824 36.48 0 11.456 0.8 22.72 1.728 33.92zM803.904 170.336c0.608-0.608 1.376-0.928 2.272-0.928s1.632 0.32 2.272 0.928l45.248 45.248c1.056 1.056 1.056 3.456 0 4.512l-23.808 23.808c-15.168-17.952-31.808-34.624-49.792-49.792l23.808-23.776zM476.8 64c0-1.76 1.44-3.2 3.2-3.2h64c1.76 0 3.2 1.44 3.2 3.2v33.792c-11.616-0.992-23.328-1.792-35.2-1.792s-23.584 0.8-35.2 1.792v-33.792zM170.336 220.096c-1.056-1.056-1.056-3.456 0-4.512l45.248-45.248c0.608-0.64 1.376-0.96 2.272-0.96s1.632 0.32 2.272 0.928l23.808 23.808c-17.984 15.2-34.624 31.84-49.792 49.824l-23.808-23.84zM220.096 853.664c-0.608 0.608-1.376 0.928-2.272 0.928s-1.632-0.32-2.272-0.928l-45.248-45.248c-1.056-1.056-1.056-3.456 0-4.512l23.808-23.808c15.168 17.952 31.808 34.624 49.792 49.792l-23.808 23.776zM547.2 960c0 1.76-1.44 3.2-3.2 3.2h-64c-1.76 0-3.2-1.44-3.2-3.2v-33.792c11.616 0.992 23.328 1.792 35.2 1.792s23.584-0.8 35.2-1.792v33.792zM853.664 803.904c1.056 1.056 1.056 3.456 0 4.512l-45.248 45.248c-0.608 0.608-1.376 0.928-2.272 0.928s-1.632-0.32-2.272-0.928l-23.808-23.808c17.952-15.168 34.624-31.808 49.792-49.792l23.808 23.84zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384zM963.104 545.376c0 1.76-1.44 3.2-3.2 3.2l-33.728-0.096c1.024-12.064 1.824-24.16 1.824-36.48 0-11.456-0.8-22.72-1.728-33.92l33.824 0.096c1.76 0 3.2 1.44 3.2 3.2l-0.192 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"steer",
						"drive",
						"spin",
						"turn"
					],
					"grid": 32
				},
				{
					"id": 842,
					"width": 1024,
					"paths": [
						"M149.952 240.48c-12.512-12.512-12.512-32.768 0-45.248l45.248-45.248c12.512-12.512 32.768-12.512 45.248 0l26.56 26.56c-34.624 25.344-65.12 55.84-90.496 90.496l-26.56-26.56zM847.488 756.96c-25.376 34.624-55.872 65.152-90.496 90.496l26.56 26.56c12.512 12.512 32.768 12.512 45.248 0l45.248-45.248c12.512-12.512 12.512-32.768 0-45.248l-26.56-26.56zM576 101.44v-37.44c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v37.44c20.928-3.232 42.176-5.44 64-5.44s43.072 2.208 64 5.44zM448 922.56v37.44c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-37.44c-20.928 3.232-42.176 5.44-64 5.44s-43.072-2.208-64-5.44zM176.512 756.96l-26.56 26.56c-12.512 12.512-12.512 32.768 0 45.248l45.248 45.248c12.512 12.512 32.768 12.512 45.248 0l26.56-26.56c-34.624-25.344-65.12-55.84-90.496-90.496zM847.488 267.040l26.56-26.56c12.512-12.512 12.512-32.768 0-45.248l-45.248-45.248c-12.512-12.512-32.768-12.512-45.248 0l-26.56 26.56c34.624 25.344 65.12 55.84 90.496 90.496zM64 448c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h37.44c-3.232-20.928-5.44-42.176-5.44-64s2.208-43.072 5.44-64h-37.44zM960 448h-37.44c3.264 20.928 5.44 42.176 5.44 64s-2.208 43.072-5.44 64h37.44c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM896 512c0 212.064-171.936 384-384 384s-384-171.936-384-384c0-212.064 171.936-384 384-384s384 171.936 384 384zM778.784 335.712l-112.288 112.288h159.040c-8.288-40.8-24.48-78.72-46.752-112.288zM576 357.504l112.288-112.288c-33.568-22.272-71.488-38.464-112.288-46.752v159.040zM335.712 245.216l112.288 112.288v-159.040c-40.8 8.288-78.72 24.48-112.288 46.752zM198.464 448h159.040l-112.288-112.288c-22.272 33.568-38.464 71.488-46.752 112.288zM245.216 688.288l112.288-112.288h-159.040c8.288 40.8 24.48 78.72 46.752 112.288zM448 666.496l-112.288 112.288c33.568 22.272 71.488 38.432 112.288 46.752v-159.040zM512 672c88.224 0 160-71.776 160-160s-71.776-160-160-160-160 71.776-160 160 71.776 160 160 160zM688.288 778.784l-112.288-112.288v159.040c40.8-8.288 78.72-24.48 112.288-46.752zM825.536 576h-159.040l112.288 112.288c22.272-33.568 38.464-71.488 46.752-112.288zM512 384c-70.688 0-128 57.312-128 128s57.312 128 128 128c70.688 0 128-57.312 128-128s-57.312-128-128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"steer",
						"drive",
						"spin",
						"turn"
					],
					"grid": 32
				},
				{
					"id": 2592,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 128c190.27 0 348.188 138.392 378.66 320h-197.64c-26.362-74.562-97.43-128-181.020-128s-154.658 53.438-181.020 128h-197.64c30.472-181.608 188.392-320 378.66-320zM448 890.66c-160.792-26.98-287.68-153.868-314.66-314.66h186.66c70.692 0 128 57.306 128 128v186.66zM512 576c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.346 0 64 28.654 64 64s-28.654 64-64 64zM576 890.66v-186.66c0-70.694 57.306-128 128-128h186.66c-26.978 160.792-153.866 287.682-314.66 314.66z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"steering-wheel",
						"drive"
					],
					"defaultCode": 60427,
					"grid": 16
				},
				{
					"id": 1247,
					"width": 585.1450614929199,
					"paths": [
						"M559.429 80.571q10.857-10.857 18.286-7.429t7.429 18.286v841.143q0 14.857-7.429 18.286t-18.286-7.429l-405.714-405.714q-5.143-5.143-7.429-10.857v387.429q0 14.857-10.857 25.714t-25.714 10.857h-73.143q-14.857 0-25.714-10.857t-10.857-25.714v-804.571q0-14.857 10.857-25.714t25.714-10.857h73.143q14.857 0 25.714 10.857t10.857 25.714v387.429q2.286-6.286 7.429-10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"step-backward"
					],
					"defaultCode": 61512,
					"grid": 14
				},
				{
					"id": 1255,
					"width": 585.1408863067627,
					"paths": [
						"M25.714 943.429q-10.857 10.857-18.286 7.429t-7.429-18.286v-841.143q0-14.857 7.429-18.286t18.286 7.429l405.714 405.714q4.571 4.571 7.429 10.857v-387.429q0-14.857 10.857-25.714t25.714-10.857h73.143q14.857 0 25.714 10.857t10.857 25.714v804.571q0 14.857-10.857 25.714t-25.714 10.857h-73.143q-14.857 0-25.714-10.857t-10.857-25.714v-387.429q-2.857 5.714-7.429 10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"step-forward"
					],
					"defaultCode": 61521,
					"grid": 14
				},
				{
					"id": 2440,
					"paths": [
						"M896 384c-70.694 0-128 57.308-128 128 0 47.372 25.752 88.7 64 110.834v241.166c0 52.936-43.064 96-96 96h-256c-52.934 0-96-43.064-96-96v-96h32c17.672 0 32-14.326 32-32v-49.984c68.248-26.726 127.96-82.92 175.764-166.342 52.676-91.924 80.236-202.226 80.236-263.674v-96c0-52.934-43.066-96-96-96h-96c-35.348 0-64 28.654-64 64s28.652 64 64 64 64-28.654 64-64h32c17.644 0 32 14.356 32 32v96c0 69.25-36.974 171.142-71.764 231.854-72.058 125.75-157.364 152.146-216.236 152.146s-144.176-26.396-216.236-152.146c-46.612-81.344-71.764-180.168-71.764-231.854v-96c0-17.644 14.356-32 32-32h32c0 35.346 28.654 64 64 64s64-28.654 64-64-28.654-64-64-64h-96c-52.934 0-96 43.066-96 96v96c0 61.448 27.56 171.75 80.236 263.674 47.804 83.422 107.516 139.616 175.764 166.342v49.984c0 17.674 14.328 32 32 32h32v96c0 88.224 71.776 160 160 160h256c88.224 0 160-71.776 160-160v-224c70.694 0 128-57.306 128-128 0-70.692-57.306-128-128-128zM896 576c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64c0 35.29-28.71 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stethoscope",
						"health",
						"medical-device",
						"doctor"
					],
					"defaultCode": 60275,
					"grid": 16
				},
				{
					"id": 1393,
					"width": 804.5709381103516,
					"paths": [
						"M731.429 402.286q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM804.571 402.286q0 35.429-20.286 63.429t-52.857 40v225.714q0 90.857-75.143 155.143t-180.857 64.286-180.857-64.286-75.143-155.143v-75.429q-93.714-11.429-156.571-73.143t-62.857-144v-292.571q0-14.857 10.857-25.714t25.714-10.857q3.429 0 9.143 1.143 9.714-17.143 26.857-27.429t37.143-10.286q30.286 0 51.714 21.429t21.429 51.714-21.429 51.714-51.714 21.429q-18.857 0-36.571-10.286v229.714q0 60.571 53.714 103.429t129.143 42.857 129.143-42.857 53.714-103.429v-229.714q-17.714 10.286-36.571 10.286-30.286 0-51.714-21.429t-21.429-51.714 21.429-51.714 51.714-21.429q20 0 37.143 10.286t26.857 27.429q5.714-1.143 9.143-1.143 14.857 0 25.714 10.857t10.857 25.714v292.571q0 82.286-62.857 144t-156.571 73.143v75.429q0 60.571 53.714 103.429t129.143 42.857 129.143-42.857 53.714-103.429v-225.714q-32.571-12-52.857-40t-20.286-63.429q0-45.714 32-77.714t77.714-32 77.714 32 32 77.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stethoscope"
					],
					"defaultCode": 61681,
					"grid": 14
				},
				{
					"id": 843,
					"width": 1024,
					"paths": [
						"M512 320c-105.856 0-192 86.144-192 192s86.144 192 192 192 192-86.144 192-192-86.144-192-192-192zM512 672c-88.352 0-160-71.648-160-160s71.648-160 160-160 160 71.648 160 160-71.648 160-160 160zM512 256c-141.152 0-256 114.848-256 256s114.848 256 256 256 256-114.848 256-256c0-141.152-114.848-256-256-256zM512 736c-123.52 0-224-100.48-224-224s100.48-224 224-224 224 100.48 224 224-100.48 224-224 224zM944 928h-266.368c165.344-65.888 282.368-227.136 282.368-416 0-247.424-200.576-448-448-448s-448 200.576-448 448 200.576 448 448 448h432c8.832 0 16-7.168 16-16s-7.168-16-16-16zM96 512c0-229.376 186.624-416 416-416s416 186.624 416 416-186.624 416-416 416-416-186.624-416-416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stick",
						"fix",
						"repair"
					],
					"grid": 32
				},
				{
					"id": 844,
					"width": 1024,
					"paths": [
						"M512 288c-123.52 0-224 100.48-224 224s100.48 224 224 224 224-100.48 224-224-100.48-224-224-224zM512 672c-88.352 0-160-71.648-160-160s71.648-160 160-160 160 71.648 160 160-71.648 160-160 160zM944 928h-266.368c165.344-65.888 282.368-227.136 282.368-416 0-247.424-200.576-448-448-448s-448 200.576-448 448 200.576 448 448 448h432c8.832 0 16-7.168 16-16s-7.168-16-16-16zM256 512c0-141.152 114.848-256 256-256s256 114.848 256 256c0 141.152-114.848 256-256 256s-256-114.848-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stick",
						"fix",
						"repair"
					],
					"grid": 32
				},
				{
					"id": 1712,
					"width": 877.713981628418,
					"paths": [
						"M585.143 713.143v237.714h-530.286q-22.857 0-38.857-16t-16-38.857v-768q0-22.857 16-38.857t38.857-16h768q22.857 0 38.857 16t16 38.857v530.286h-237.714q-22.857 0-38.857 16t-16 38.857zM658.286 731.429h217.714q-8.571 46.857-37.143 75.429l-105.143 105.143q-28.571 28.571-75.429 37.143v-217.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sticky-note"
					],
					"defaultCode": 62025,
					"grid": 14
				},
				{
					"id": 1713,
					"width": 877.7119064331055,
					"paths": [
						"M800 731.429h-141.714v141.714q16.571-5.714 23.429-12.571l105.714-105.714q6.857-6.857 12.571-23.429zM640 658.286h164.571v-512h-731.429v731.429h512v-164.571q0-22.857 16-38.857t38.857-16zM877.714 128v585.143q0 22.857-11.429 50.286t-27.429 43.429l-105.143 105.143q-16 16-43.429 27.429t-50.286 11.429h-585.143q-22.857 0-38.857-16t-16-38.857v-768q0-22.857 16-38.857t38.857-16h768q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sticky-note-o"
					],
					"defaultCode": 62026,
					"grid": 14
				},
				{
					"id": 845,
					"width": 1024,
					"paths": [
						"M832 160l54.624-54.624c6.016-6.016 9.376-14.144 9.376-22.624v-18.752c0-17.664-14.336-32-32-32h-704c-17.664 0-32 14.336-32 32v18.752c0 8.48 3.36 16.64 9.376 22.624l54.624 54.624v704l-54.624 54.624c-6.016 6.016-9.376 14.144-9.376 22.624v18.752c0 17.664 14.336 32 32 32h704c17.664 0 32-14.336 32-32v-18.752c0-8.48-3.36-16.64-9.376-22.624l-54.624-54.624v-704zM160 82.752v-18.752h704v18.752l-45.248 45.248h-613.504l-45.248-45.248zM577.344 160l-199.744 47.552-153.6-36.576v-10.976h353.344zM800 810.976l-222.656 53.024h-265.088l487.744-116.128v63.104zM224 587.872l151.744 36.128-151.744 36.128v-72.256zM224 693.024l220.8-52.576 132.544 31.552-353.344 84.128v-63.104zM224 789.024l422.4-100.576 132.544 31.552-554.944 132.128v-63.104zM800 692.128l-576-137.152v-63.104l576 137.152v63.104zM800 596.128l-576-137.152v-63.104l576 137.152v63.104zM800 500.128l-576-137.152v-63.104l576 137.152v63.104zM800 308.128l-151.744-36.128 151.744-36.128v72.256zM800 341.024v63.104l-576-137.152v-63.104l576 137.152zM864 941.248v18.752h-704v-18.752l45.248-45.248h613.504l45.248 45.248zM715.456 864l84.544-20.128v20.128h-84.544zM800 202.976l-220.8 52.576-132.544-31.552 268.8-64h84.544v42.976z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stitch",
						"sew",
						"mend",
						"repair"
					],
					"grid": 32
				},
				{
					"id": 846,
					"width": 1024,
					"paths": [
						"M137.376 105.376c-6.016-6.016-9.376-14.144-9.376-22.624v-18.752c0-17.664 14.336-32 32-32h704c17.664 0 32 14.336 32 32v18.752c0 8.48-3.36 16.64-9.376 22.624l-54.624 54.624h-640l-54.624-54.624zM800 735.232v-30.464c0-7.424-5.088-13.856-12.288-15.552l-544-129.536c-10.048-2.4-19.712 5.216-19.712 15.552 0 7.392 5.088 13.856 12.288 15.552l139.456 33.216-139.456 33.216c-7.2 1.696-12.288 8.128-12.288 15.552 0 10.336 9.664 17.952 19.712 15.552l201.088-47.872 132.544 31.552-341.056 81.216c-7.2 1.696-12.288 8.128-12.288 15.552 0 10.336 9.664 17.952 19.712 15.552l402.688-95.872 132.544 31.552-470.432 112h-116.512v-636.128l588.288 140.448c10.048 2.4 19.712-5.216 19.712-15.552 0-7.424-5.088-13.856-12.288-15.552l-139.456-33.216 139.456-33.216c7.2-1.696 12.288-8.128 12.288-15.552v0c0-10.336-9.664-17.952-19.712-15.552l-201.088 47.872-132.544-31.552 134.4-32h250.944v640h-385.344l341.056-81.216c7.2-1.696 12.288-8.128 12.288-15.552zM224 287.232c0 7.392 5.088 13.856 12.288 15.552l544 129.536c10.048 2.4 19.712-5.216 19.712-15.552 0-7.424-5.088-13.856-12.288-15.552l-544-129.536c-10.048-2.4-19.712 5.216-19.712 15.552zM224 383.232c0 7.392 5.088 13.856 12.288 15.552l544 129.536c10.048 2.4 19.712-5.216 19.712-15.552 0-7.424-5.088-13.856-12.288-15.552l-544-129.536c-10.048-2.4-19.712 5.216-19.712 15.552zM800 608.768c0-7.424-5.088-13.856-12.288-15.552l-544-129.536c-10.048-2.4-19.712 5.216-19.712 15.552 0 7.392 5.088 13.856 12.288 15.552l544 129.536c10.048 2.4 19.712-5.216 19.712-15.552zM312.256 192l65.344 15.552 65.344-15.552h-130.688zM832 864v0h-640l-54.624 54.624c-6.016 6.016-9.376 14.144-9.376 22.624v18.752c0 17.664 14.336 32 32 32h704c17.664 0 32-14.336 32-32v-18.752c0-8.48-3.36-16.64-9.376-22.624l-54.624-54.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stitch",
						"sew",
						"mend",
						"repair"
					],
					"grid": 32
				},
				{
					"id": 1142,
					"width": 1024,
					"paths": [
						"M848 710.624l91.328-91.328-22.624-22.624-84.704 84.704v-297.376c0-79.328-29.024-151.744-76.8-207.648-33.504-102.368-129.664-176.352-243.2-176.352s-209.696 73.984-243.2 176.352c-47.776 55.904-76.8 128.32-76.8 207.648v608c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-233.376l84.672 84.672 22.624-22.624-91.296-91.296v-18.752zM320 256c0-105.856 86.144-192 192-192s192 86.144 192 192v64c0 105.856-86.144 192-192 192s-192-86.144-192-192v-64zM768 960h-512v-224h32v32h32v-32h32v32h32v-32h32v32h32v-32h32v32h32v-32h32v32h32v-32h32v32h32v-32h32v32h32v-32h64v224zM768 704h-64v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-32h-32v32h-32v-320c0-43.296 11.264-85.6 32-123.168v59.168c0 123.712 100.288 224 224 224s224-100.288 224-224v-59.168c20.736 37.568 32 79.872 32 123.168v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stitch",
						"heal",
						"sew",
						"mend",
						"repair"
					],
					"grid": 32
				},
				{
					"id": 2965,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416zM320 320h384v384h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stop",
						"player"
					],
					"defaultCode": 60800,
					"grid": 16
				},
				{
					"id": 1776,
					"width": 877.7139282226562,
					"paths": [
						"M621.714 676.571v-329.143q0-8-5.143-13.143t-13.143-5.143h-329.143q-8 0-13.143 5.143t-5.143 13.143v329.143q0 8 5.143 13.143t13.143 5.143h329.143q8 0 13.143-5.143t5.143-13.143zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stop-circle"
					],
					"defaultCode": 62093,
					"grid": 14
				},
				{
					"id": 1777,
					"width": 877.7139282226562,
					"paths": [
						"M438.857 73.143q119.429 0 220.286 58.857t159.714 159.714 58.857 220.286-58.857 220.286-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857zM438.857 822.857q84.571 0 156-41.714t113.143-113.143 41.714-156-41.714-156-113.143-113.143-156-41.714-156 41.714-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714zM274.286 694.857q-8 0-13.143-5.143t-5.143-13.143v-329.143q0-8 5.143-13.143t13.143-5.143h329.143q8 0 13.143 5.143t5.143 13.143v329.143q0 8-5.143 13.143t-13.143 5.143h-329.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stop-circle-o"
					],
					"defaultCode": 62094,
					"grid": 14
				},
				{
					"id": 2972,
					"paths": [
						"M128 128h768v768h-768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stop",
						"player",
						"square"
					],
					"defaultCode": 60807,
					"grid": 16
				},
				{
					"id": 1252,
					"width": 877.7149925231934,
					"paths": [
						"M877.714 109.714v804.571q0 14.857-10.857 25.714t-25.714 10.857h-804.571q-14.857 0-25.714-10.857t-10.857-25.714v-804.571q0-14.857 10.857-25.714t25.714-10.857h804.571q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stop"
					],
					"defaultCode": 61517,
					"grid": 14
				},
				{
					"id": 847,
					"width": 1024,
					"paths": [
						"M343.584 137.376l-206.208 206.208c-6.016 5.984-9.376 14.112-9.376 22.624v291.616c0 8.48 3.36 16.64 9.376 22.624l206.208 206.208c5.984 5.984 14.144 9.344 22.624 9.344h291.584c8.48 0 16.64-3.36 22.624-9.376l206.208-206.208c6.016-5.984 9.376-14.144 9.376-22.624v-291.616c0-8.48-3.36-16.64-9.376-22.624l-206.208-206.208c-5.984-5.984-14.144-9.344-22.624-9.344h-291.584c-8.48 0-16.64 3.36-22.624 9.376zM864 657.792l-206.208 206.208h-291.584l-206.208-206.208v-291.616l206.208-206.176h291.584l206.208 206.208v291.584zM657.792 64h-291.616c-25.472 0-49.888 10.112-67.872 28.128l-206.176 206.176c-18.016 18.016-28.128 42.432-28.128 67.904v291.616c0 25.472 10.112 49.888 28.128 67.872l206.208 206.208c17.984 17.984 42.4 28.096 67.872 28.096h291.616c25.472 0 49.888-10.112 67.872-28.128l206.208-206.208c17.984-17.984 28.096-42.4 28.096-67.872v-291.616c0-25.472-10.112-49.888-28.128-67.872l-206.208-206.208c-17.984-17.984-42.4-28.096-67.872-28.096zM909.248 703.072l-206.208 206.208c-12 11.968-28.256 18.72-45.248 18.72h-291.616c-16.96 0-33.248-6.752-45.248-18.752l-206.208-206.208c-11.968-12-18.72-28.256-18.72-45.248v-291.616c0-16.96 6.752-33.248 18.752-45.248l206.208-206.208c12-11.968 28.256-18.72 45.248-18.72h291.616c16.96 0 33.248 6.752 45.248 18.752l206.208 206.208c11.968 12 18.72 28.256 18.72 45.248v291.616c0 16.96-6.752 33.216-18.752 45.248zM594.752 338.752l-82.752 82.752-82.752-82.752c-12.512-12.512-32.768-12.512-45.248 0l-45.248 45.248c-12.512 12.512-12.512 32.768 0 45.248l82.752 82.752-82.752 82.752c-12.512 12.512-12.512 32.768 0 45.248l45.248 45.248c12.512 12.512 32.768 12.512 45.248 0l82.752-82.752 82.752 82.752c12.512 12.512 32.768 12.512 45.248 0l45.248-45.248c12.512-12.512 12.512-32.768 0-45.248l-82.752-82.752 82.752-82.752c12.512-12.512 12.512-32.768 0-45.248l-45.248-45.248c-12.48-12.512-32.768-12.512-45.248 0zM662.624 617.376l-45.248 45.248-105.376-105.376-105.376 105.376-45.248-45.248 105.376-105.376-105.376-105.376 45.248-45.248 105.376 105.376 105.376-105.376 45.248 45.248-105.376 105.376 105.376 105.376z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stop",
						"halt"
					],
					"grid": 32
				},
				{
					"id": 848,
					"width": 1024,
					"paths": [
						"M617.376 361.376l45.248 45.248-105.376 105.376 105.376 105.376-45.248 45.248-105.376-105.376-105.376 105.376-45.248-45.248 105.376-105.376-105.376-105.376 45.248-45.248 105.376 105.376 105.376-105.376zM657.792 160l206.208 206.208v291.616l-206.208 206.176h-291.584l-206.208-206.208v-291.616l206.208-206.176h291.584zM685.248 384l-45.248-45.248c-12.512-12.512-32.768-12.512-45.248 0l-82.752 82.752-82.752-82.752c-12.512-12.512-32.768-12.512-45.248 0l-45.248 45.248c-12.512 12.512-12.512 32.768 0 45.248l82.752 82.752-82.752 82.752c-12.512 12.512-12.512 32.768 0 45.248l45.248 45.248c12.512 12.512 32.768 12.512 45.248 0l82.752-82.752 82.752 82.752c12.512 12.512 32.768 12.512 45.248 0l45.248-45.248c12.512-12.512 12.512-32.768 0-45.248l-82.752-82.752 82.752-82.752c12.512-12.48 12.512-32.768 0-45.248zM960 366.208v291.616c0 25.472-10.112 49.888-28.128 67.872l-206.208 206.208c-17.984 17.984-42.4 28.096-67.872 28.096h-291.616c-25.472 0-49.888-10.112-67.872-28.128l-206.208-206.208c-17.984-17.984-28.096-42.4-28.096-67.872v-291.616c0-25.472 10.112-49.888 28.128-67.872l206.208-206.208c17.984-17.984 42.4-28.096 67.872-28.096h291.616c25.472 0 49.888 10.112 67.872 28.128l206.208 206.208c17.984 17.984 28.096 42.4 28.096 67.872zM896 366.208c0-8.48-3.36-16.64-9.376-22.624l-206.208-206.208c-5.984-6.016-14.144-9.376-22.624-9.376h-291.616c-8.48 0-16.64 3.36-22.624 9.376l-206.208 206.208c-5.984 5.984-9.344 14.112-9.344 22.624v291.616c0 8.48 3.36 16.64 9.376 22.624l206.208 206.208c5.984 5.984 14.144 9.344 22.624 9.344h291.616c8.48 0 16.64-3.36 22.624-9.376l206.208-206.208c5.984-5.984 9.344-14.144 9.344-22.624v-291.584z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stop",
						"halt"
					],
					"grid": 32
				},
				{
					"id": 1143,
					"width": 1024,
					"paths": [
						"M982.624 303.808l-262.432-262.432c-6.016-6.016-14.144-9.376-22.624-9.376h-371.136c-8.48 0-16.64 3.36-22.624 9.376l-262.432 262.432c-6.016 6.016-9.376 14.144-9.376 22.624v371.136c0 8.512 3.36 16.64 9.376 22.624l262.432 262.432c6.016 6.016 14.144 9.376 22.624 9.376h371.136c8.48 0 16.64-3.36 22.624-9.376l262.432-262.432c6.016-6.016 9.376-14.144 9.376-22.624v-371.136c0-8.48-3.36-16.608-9.376-22.624zM928 684.32l-243.68 243.68h-344.64l-243.68-243.68v-344.64l243.68-243.68h344.64l243.68 243.68v344.64zM352.928 128l-224.928 224.928v318.112l224.928 224.96h318.112l224.96-224.928v-318.112l-224.928-224.96h-318.144zM864 657.792l-206.208 206.208h-291.616l-206.176-206.208v-291.616l206.208-206.176h291.616l206.176 206.208v291.584z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stop",
						"halt"
					],
					"grid": 32
				},
				{
					"id": 2163,
					"paths": [
						"M512.002 193.212v-65.212h128v-64c0-35.346-28.654-64-64.002-64h-191.998c-35.346 0-64 28.654-64 64v64h128v65.212c-214.798 16.338-384 195.802-384 414.788 0 229.75 186.25 416 416 416s416-186.25 416-416c0-218.984-169.202-398.448-384-414.788zM706.276 834.274c-60.442 60.44-140.798 93.726-226.274 93.726s-165.834-33.286-226.274-93.726c-60.44-60.44-93.726-140.8-93.726-226.274s33.286-165.834 93.726-226.274c58.040-58.038 134.448-91.018 216.114-93.548l-21.678 314.020c-1.86 26.29 12.464 37.802 31.836 37.802s33.698-11.512 31.836-37.802l-21.676-314.022c81.666 2.532 158.076 35.512 216.116 93.55 60.44 60.44 93.726 140.8 93.726 226.274s-33.286 165.834-93.726 226.274z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stopwatch",
						"time",
						"speed",
						"meter",
						"chronometer"
					],
					"defaultCode": 59998,
					"grid": 16
				},
				{
					"id": 2065,
					"paths": [
						"M896 960v-384h-768v384h-64v64h896v-64h-64zM512 896h-256v-192h256v192z",
						"M896 64h-768l-128 256v192h192v-128h64v128h128v-128h64v128h128v-128h64v128h128v-128h64v128h192v-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"store",
						"shop",
						"market",
						"building"
					],
					"defaultCode": 59900,
					"grid": 16
				},
				{
					"id": 2066,
					"paths": [
						"M416 576h-192c-17.672 0-32 14.326-32 32v192c0 17.674 14.328 32 32 32h192c17.672 0 32-14.326 32-32v-192c0-17.674-14.328-32-32-32zM384 768h-128v-128h128v128z",
						"M1024 384v-288c0-17.672-14.326-32-32-32h-960c-17.672 0-32 14.328-32 32v288c0 47.274 25.78 88.612 64 110.78v465.22h-32c-17.672 0-32 14.326-32 32s14.328 32 32 32h960c17.674 0 32-14.326 32-32s-14.326-32-32-32h-32v-465.22c38.22-22.168 64-63.506 64-110.78zM640 128h128v256c0 35.29-28.71 64-64 64-35.292 0-64-28.71-64-64v-256zM256 128h128v256c0 35.29-28.71 64-64 64-35.292 0-64-28.71-64-64v-256zM768 960h-128v-256h128v256zM896 960h-64v-288c0-17.674-14.326-32-32-32h-192c-17.674 0-32 14.326-32 32v288h-448v-448c38.204 0 72.526-16.844 96-43.472 23.474 26.628 57.796 43.472 96 43.472s72.526-16.844 96-43.472c23.474 26.628 57.796 43.472 96 43.472s72.528-16.844 96-43.47c23.472 26.626 57.796 43.47 96 43.47s72.528-16.844 96-43.47c23.472 26.626 57.796 43.47 96 43.47v448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"store",
						"shop",
						"market",
						"building"
					],
					"defaultCode": 59901,
					"grid": 16
				},
				{
					"id": 140,
					"paths": [
						"M921.6 486.4v-51.2c0-3.974-0.925-7.894-2.702-11.448l-102.4-204.8c-4.336-8.674-13.2-14.152-22.898-14.152h-614.4c-9.698 0-18.562 5.478-22.898 14.152l-102.4 204.8c-1.778 3.554-2.702 7.474-2.702 11.448v51.2c0 41.786 20.131 78.955 51.2 102.33v332.87h-25.6c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h819.2c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-25.598v-332.87c31.067-23.376 51.198-60.544 51.198-102.33zM588.8 563.2c-42.347 0-76.8-34.453-76.8-76.8v-25.6h153.6v25.6c0 42.347-34.453 76.8-76.8 76.8zM102.4 486.4v-25.6h153.6v25.6c0 42.347-34.453 76.8-76.8 76.8s-76.8-34.453-76.8-76.8zM460.8 256v153.6h-146.413l38.4-153.6h108.013zM620.013 256l38.4 153.6h-146.413v-153.6h108.013zM307.2 460.8h153.6v25.6c0 42.347-34.453 76.8-76.8 76.8s-76.8-34.453-76.8-76.8v-25.6zM716.8 460.8h153.6v25.6c0 42.347-34.453 76.8-76.8 76.8s-76.8-34.453-76.8-76.8v-25.6zM854.578 409.6h-143.39l-38.4-153.6h104.99l76.8 153.6zM195.022 256h104.99l-38.4 153.6h-143.39l76.8-153.6zM153.6 611.826c8.274 1.686 16.835 2.574 25.6 2.574 41.827 0 79.029-20.168 102.4-51.29 23.371 31.122 60.573 51.29 102.4 51.29s79.029-20.168 102.4-51.29c18.474 24.598 45.589 42.354 76.8 48.714v309.776h-409.6v-309.774zM819.202 921.6h-204.802v-309.774c31.211-6.362 58.325-24.115 76.8-48.714 23.371 31.12 60.573 51.288 102.4 51.288 8.766 0 17.326-0.89 25.602-2.576v309.776z",
						"M716.8 742.4c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6z",
						"M230.4 768c-6.552 0-13.102-2.499-18.102-7.499-9.997-9.997-9.997-26.206 0-36.203l51.2-51.2c9.998-9.997 26.206-9.997 36.205 0 9.997 9.997 9.997 26.206 0 36.203l-51.2 51.2c-5 5-11.55 7.499-18.102 7.499z",
						"M281.6 870.4c-6.552 0-13.102-2.499-18.101-7.499-9.998-9.997-9.998-26.206 0-36.203l153.6-153.6c9.997-9.997 26.206-9.997 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-153.6 153.6c-5 5-11.55 7.499-18.102 7.499z",
						"M435.2 870.4c-6.552 0-13.102-2.499-18.102-7.499-9.997-9.997-9.997-26.206 0-36.203l51.2-51.2c9.998-9.997 26.206-9.997 36.205 0s9.998 26.206 0 36.203l-51.2 51.2c-5 5-11.55 7.499-18.102 7.499z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"store",
						"shop",
						"market"
					],
					"defaultCode": 59437,
					"grid": 20
				},
				{
					"id": 849,
					"width": 1024,
					"paths": [
						"M789.376 160h-53.376c0-53.024-42.976-96-96-96h-256c-53.024 0-96 42.976-96 96h-53.376c-56.992 0-101.44 49.376-95.488 106.048l47.808 454.336c3.168 29.984 20.224 56.768 46.080 72.256l229.536 137.728c15.2 9.12 32.288 13.664 49.376 13.664s34.176-4.544 49.408-13.664l229.536-137.728c25.856-15.52 42.912-42.272 46.080-72.256l47.84-454.336c6.016-56.672-38.432-106.048-95.424-106.048zM384 96h256c35.296 0 64 28.704 64 64h-384c0-35.296 28.704-64 64-64zM853.024 262.688l-47.84 454.336c-2.080 19.872-13.568 37.888-30.72 48.192l-229.536 137.728c-9.952 5.952-21.344 9.12-32.928 9.12s-22.976-3.168-32.928-9.12l-229.536-137.728c-17.152-10.272-28.64-28.288-30.72-48.192l-47.84-454.336c-1.92-18.272 3.776-35.872 16.096-49.504 12.288-13.664 29.184-21.184 47.552-21.184h554.752c18.368 0 35.264 7.52 47.552 21.184s18.016 31.232 16.096 49.504zM821.184 259.36l-3.328 31.84c-0.864 8.224-7.808 14.336-15.904 14.336-0.576 0-1.12-0.032-1.696-0.096-8.768-0.928-15.168-8.8-14.24-17.568l3.36-31.872c0.896-8.8 8.992-15.264 17.568-14.24 8.8 0.928 15.168 8.832 14.24 17.6zM444.992 826.496c-3.008 4.992-8.288 7.776-13.728 7.776-2.784 0-5.632-0.736-8.224-2.272l-53.376-32c-7.584-4.544-10.016-14.368-5.472-21.952 4.544-7.552 14.368-10.016 21.952-5.472l53.376 32c7.552 4.512 10.016 14.336 5.472 21.92zM248.16 553.44c-8.096 0-15.040-6.112-15.904-14.336l-6.528-61.92c-0.928-8.768 5.44-16.672 14.24-17.568 8.672-1.056 16.672 5.44 17.568 14.24l6.528 61.92c0.928 8.768-5.44 16.672-14.24 17.568-0.544 0.064-1.12 0.096-1.664 0.096zM235.136 429.632c-8.096 0-15.040-6.112-15.904-14.336l-6.528-61.92c-0.928-8.768 5.44-16.672 14.24-17.568 8.48-1.088 16.672 5.44 17.568 14.24l6.528 61.92c0.928 8.768-5.44 16.672-14.24 17.568-0.544 0.064-1.12 0.096-1.664 0.096zM261.184 677.248c-8.096 0-15.040-6.112-15.904-14.336l-6.528-61.92c-0.928-8.768 5.44-16.672 14.24-17.568 8.64-1.024 16.672 5.44 17.568 14.24l6.528 61.92c0.928 8.768-5.44 16.672-14.24 17.568-0.544 0.064-1.088 0.096-1.664 0.096zM798.272 476.896l-6.528 61.888c-0.864 8.224-7.808 14.336-15.904 14.336-0.576 0-1.12-0.032-1.696-0.096-8.8-0.928-15.168-8.8-14.24-17.568l6.528-61.888c0.928-8.8 8.8-15.2 17.568-14.24 8.832 0.896 15.232 8.768 14.272 17.568zM785.248 600.672l-6.528 61.92c-0.864 8.224-7.808 14.336-15.904 14.336-0.576 0-1.12-0.032-1.696-0.096-8.8-0.928-15.168-8.8-14.24-17.568l6.528-61.92c0.928-8.8 8.864-15.168 17.568-14.24 8.832 0.928 15.2 8.8 14.272 17.568zM553.344 841.888c4.544 7.584 2.080 17.408-5.472 21.952l-19.392 11.648c-4.992 2.976-10.656 4.576-16.48 4.576s-11.488-1.568-16.48-4.576l-19.104-11.488c-7.584-4.544-10.016-14.368-5.472-21.952s14.368-10.048 21.952-5.472l19.104 11.456 19.392-11.648c7.616-4.512 17.408-2.080 21.952 5.504zM811.328 353.088l-6.528 61.92c-0.864 8.224-7.808 14.336-15.904 14.336-0.576 0-1.12-0.032-1.696-0.096-8.8-0.928-15.168-8.8-14.24-17.568l6.528-61.92c0.896-8.768 8.992-15.2 17.568-14.24 8.832 0.896 15.2 8.768 14.272 17.568zM660.096 777.856c4.544 7.584 2.080 17.408-5.472 21.952l-53.376 32c-2.592 1.536-5.408 2.272-8.224 2.272-5.44 0-10.72-2.752-13.728-7.776-4.544-7.584-2.080-17.408 5.472-21.952l53.376-32c7.584-4.512 17.44-2.080 21.952 5.504zM222.048 305.504c-8.096 0-15.040-6.112-15.904-14.336l-3.328-31.84c-0.928-8.768 5.44-16.64 14.24-17.568 8.512-1.056 16.64 5.472 17.568 14.24l3.328 31.84c0.928 8.768-5.44 16.672-14.24 17.568-0.544 0.064-1.12 0.096-1.664 0.096zM338.368 762.272c-3.008 4.992-8.288 7.776-13.728 7.776-2.784 0-5.632-0.736-8.224-2.272l-53.376-32c-7.584-4.544-10.016-14.368-5.472-21.952 4.544-7.552 14.368-10.016 21.952-5.472l53.376 32c7.552 4.512 10.016 14.336 5.472 21.92zM766.72 713.792c4.544 7.584 2.080 17.408-5.472 21.952l-53.376 32c-2.592 1.536-5.408 2.272-8.224 2.272-5.44 0-10.72-2.752-13.728-7.776-4.544-7.584-2.080-17.408 5.472-21.952l53.376-32c7.584-4.512 17.408-2.080 21.952 5.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"store",
						"keep",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 850,
					"width": 1024,
					"paths": [
						"M293.888 128c13.216-37.216 48.384-64 90.112-64h256c41.728 0 76.896 26.784 90.112 64h-436.224zM884.832 266.048l-47.84 454.336c-3.168 29.984-20.224 56.768-46.080 72.256l-229.536 137.728c-15.2 9.12-32.288 13.664-49.408 13.664s-34.176-4.544-49.376-13.664l-229.536-137.728c-25.856-15.52-42.912-42.272-46.080-72.256l-47.808-454.336c-5.984-56.672 38.464-106.048 95.456-106.048h554.72c57.024 0 101.472 49.376 95.488 106.048zM222.048 305.504c0.544 0 1.12-0.032 1.696-0.096 8.768-0.928 15.168-8.8 14.24-17.568l-3.36-31.84c-0.928-8.768-9.056-15.296-17.568-14.24-8.8 0.928-15.168 8.8-14.24 17.568l3.328 31.84c0.864 8.224 7.808 14.336 15.904 14.336zM235.136 429.632c0.576 0 1.12-0.032 1.696-0.096 8.8-0.928 15.168-8.8 14.24-17.568l-6.528-61.92c-0.928-8.8-9.088-15.328-17.568-14.24-8.8 0.928-15.168 8.8-14.24 17.568l6.528 61.92c0.832 8.224 7.776 14.336 15.872 14.336zM248.16 553.44c0.576 0 1.12-0.032 1.696-0.096 8.8-0.928 15.168-8.8 14.24-17.568l-6.528-61.92c-0.928-8.8-8.896-15.264-17.568-14.24-8.8 0.928-15.168 8.8-14.24 17.568l6.528 61.92c0.832 8.224 7.776 14.336 15.872 14.336zM261.184 677.248c0.576 0 1.12-0.032 1.696-0.096 8.8-0.928 15.168-8.8 14.24-17.568l-6.528-61.92c-0.928-8.768-8.96-15.264-17.568-14.24-8.8 0.928-15.168 8.8-14.24 17.568l6.528 61.92c0.832 8.224 7.776 14.336 15.872 14.336zM332.864 740.32l-53.376-32c-7.584-4.544-17.408-2.080-21.952 5.472-4.544 7.584-2.080 17.408 5.472 21.952l53.376 32c2.592 1.536 5.408 2.272 8.224 2.272 5.44 0 10.72-2.752 13.728-7.776 4.576-7.552 2.112-17.376-5.472-21.92zM439.488 804.544l-53.376-32c-7.584-4.544-17.408-2.080-21.952 5.472-4.544 7.584-2.080 17.408 5.472 21.952l53.376 32c2.592 1.536 5.408 2.272 8.224 2.272 5.44 0 10.72-2.752 13.728-7.776 4.576-7.552 2.112-17.376-5.472-21.92zM553.344 841.888c-4.544-7.584-14.336-10.016-21.952-5.472l-19.392 11.616-19.136-11.488c-7.584-4.576-17.408-2.080-21.952 5.472s-2.080 17.44 5.504 21.984l19.136 11.456c4.96 3.008 10.656 4.576 16.48 4.576 5.792 0 11.488-1.568 16.48-4.576l19.392-11.648c7.552-4.512 10.016-14.336 5.44-21.92zM660.096 777.856c-4.544-7.584-14.368-10.016-21.952-5.472l-53.376 32c-7.584 4.544-10.016 14.368-5.472 21.952 3.008 4.992 8.288 7.776 13.728 7.776 2.784 0 5.632-0.736 8.224-2.272l53.376-32c7.584-4.576 10.048-14.432 5.472-21.984zM766.72 713.792c-4.544-7.584-14.368-10.016-21.952-5.472l-53.376 32c-7.584 4.544-10.016 14.368-5.472 21.952 3.008 4.992 8.288 7.776 13.728 7.776 2.784 0 5.632-0.736 8.224-2.272l53.376-32c7.552-4.576 10.016-14.4 5.472-21.984zM785.248 600.672c0.928-8.768-5.44-16.672-14.24-17.568-8.704-0.928-16.672 5.44-17.568 14.24l-6.528 61.92c-0.928 8.768 5.44 16.672 14.24 17.568 0.576 0.064 1.12 0.096 1.696 0.096 8.096 0 15.040-6.112 15.904-14.336l6.496-61.92zM798.272 476.896c0.928-8.768-5.44-16.672-14.24-17.568-8.768-0.96-16.672 5.44-17.568 14.24l-6.528 61.888c-0.928 8.768 5.44 16.672 14.24 17.568 0.576 0.064 1.12 0.096 1.696 0.096 8.096 0 15.040-6.112 15.904-14.336l6.496-61.888zM811.328 353.088c0.928-8.768-5.44-16.672-14.24-17.568-8.576-0.96-16.672 5.44-17.568 14.24l-6.528 61.92c-0.928 8.768 5.44 16.672 14.24 17.568 0.576 0.064 1.12 0.096 1.696 0.096 8.096 0 15.040-6.112 15.904-14.336l6.496-61.92zM821.184 259.36c0.928-8.768-5.44-16.672-14.24-17.568-8.576-1.056-16.672 5.44-17.568 14.208l-3.328 31.84c-0.928 8.768 5.44 16.672 14.24 17.568 0.576 0.064 1.12 0.096 1.696 0.096 8.096 0 15.040-6.112 15.904-14.336l3.296-31.808z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"store",
						"keep",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 1144,
					"width": 1024,
					"paths": [
						"M960 64h-896c-17.664 0-32 14.336-32 32v800c0 17.664 14.336 32 32 32h32c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h640c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32h32c17.664 0 32-14.336 32-32v-800c0-17.664-14.336-32-32-32zM96 864v-160h832v160h-832zM928 512v160h-832v-160h832zM96 480v-160h832v160h-832zM928 288h-832v-160h832v160zM480 736h64v32h-64v-32zM544 576h-64v-32h64v32zM480 352h64v32h-64v-32zM544 192h-64v-32h64v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"store",
						"pull",
						"stow"
					],
					"grid": 32
				},
				{
					"id": 851,
					"width": 1024,
					"paths": [
						"M224 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM192 704c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM832 704c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM736 704c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM736 480c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM916.96 400c25.92 17.184 43.040 46.56 43.040 80v64c0 33.44-17.12 62.816-43.040 80 25.92 17.184 43.040 46.56 43.040 80v64c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-64c0-33.44 17.12-62.816 43.040-80-25.92-17.184-43.040-46.56-43.040-80v-64c0-33.44 17.12-62.816 43.040-80-25.92-17.184-43.040-46.56-43.040-80v-64c0-53.024 42.976-96 96-96h704c53.024 0 96 42.976 96 96v64c0 33.44-17.12 62.816-43.040 80zM864 640h-704c-35.296 0-64 28.704-64 64v64c0 35.296 28.704 64 64 64h704c35.296 0 64-28.704 64-64v-64c0-35.296-28.704-64-64-64zM864 416h-704c-35.296 0-64 28.704-64 64v64c0 35.296 28.704 64 64 64h704c35.296 0 64-28.704 64-64v-64c0-35.296-28.704-64-64-64zM928 256c0-35.296-28.704-64-64-64h-704c-35.296 0-64 28.704-64 64v64c0 35.296 28.704 64 64 64h704c35.296 0 64-28.704 64-64v-64zM832 256c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM832 480c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM736 256c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM192 256c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stow",
						"save",
						"stack",
						"store"
					],
					"grid": 32
				},
				{
					"id": 852,
					"width": 1024,
					"paths": [
						"M896 640h-768c-35.36 0-64 28.64-64 64v64c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-64c0-35.36-28.64-64-64-64zM192 768c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM736 768c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM832 768c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM896 416h-768c-35.36 0-64 28.64-64 64v64c0 35.36 28.64 64 64 64h768c35.36 0 64-28.64 64-64v-64c0-35.36-28.64-64-64-64zM192 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM736 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM832 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM864 160h-704c-53.024 0-96 42.976-96 96v64c0 35.36 28.64 64 64 64h768c35.36 0 64-28.64 64-64v-64c0-53.024-42.976-96-96-96zM192 320c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM736 320c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM832 320c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stow",
						"save",
						"stack",
						"store"
					],
					"grid": 32
				},
				{
					"id": 853,
					"width": 1024,
					"paths": [
						"M480 544c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM320 576c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM704 576c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM512 448c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM320 448c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM704 448c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM416 512c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM224 512c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM800 512c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM608 512c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM416 384c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM224 384c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM800 384c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM608 384c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM416 640c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM608 640c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM992 240c0 8.832-7.168 16-16 16h-16v32c0 221.824-161.376 405.472-373.024 441.248 32.192 23.296 53.28 60.672 52.992 103.616-0.096 17.312-14.624 31.136-31.968 31.136h-197.504c-14.624 0-26.496-11.872-26.496-26.496v-4.256c0-41.632 19.808-80.384 51.52-104.256-210.912-36.32-371.52-219.68-371.52-440.992v-32h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16h928c8.832 0 16 7.168 16 16zM510.784 736.32c-7.488 0-15.104 0.832-22.656 2.464-41.408 8.96-71.552 48.064-72.128 93.216h192c0-52.736-43.616-95.68-97.216-95.68zM928 256h-832v32c0 229.376 186.624 416 416 416s416-186.624 416-416v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strain",
						"cook",
						"prepare"
					],
					"grid": 32
				},
				{
					"id": 854,
					"width": 1024,
					"paths": [
						"M976 224h-928c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v32c0 221.312 160.608 404.672 371.52 440.992-31.712 23.904-51.52 62.624-51.52 104.256v4.256c0 14.624 11.872 26.496 26.496 26.496h197.504c17.344 0 31.872-13.824 32-31.168 0.288-42.912-20.832-80.32-52.992-103.616 211.616-35.744 372.992-219.392 372.992-441.216v-32h16c8.832 0 16-7.168 16-16s-7.168-16-16-16zM224 512c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM224 384c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM320 576c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM320 448c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM416 640c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM416 512c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM416 384c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM512 576c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM512 448c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM608 640c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM608 512c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM608 384c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM704 576c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM704 448c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM800 512c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM800 384c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strain",
						"cook",
						"prepare"
					],
					"grid": 32
				},
				{
					"id": 1145,
					"width": 1024,
					"paths": [
						"M992.32 192h-32.32c0-17.696-14.304-32-32-32h-832c-17.696 0-32 14.304-32 32h-32.32c-17.504 0-31.68 14.176-31.68 31.68v0.64c0 17.504 14.176 31.68 31.68 31.68h32.32c0 186.56 118.112 353.28 288.704 418.528-40.896 41.28-64.704 97.44-64.704 157.472 0 17.696 14.304 32 32 32h384c17.696 0 32-14.304 32-32 0-60.032-23.808-116.192-64.704-157.472 170.592-65.248 288.704-231.968 288.704-418.528h32.32c17.504 0 31.68-14.176 31.68-31.68v-0.64c0-17.504-14.176-31.68-31.68-31.68zM355.232 800c9.44-46.464 39.232-86.848 82.336-109.568 8.96-4.736 14.976-13.28 16.608-22.912 18.944 2.656 38.144 4.48 57.824 4.48s38.88-1.824 57.824-4.48c1.664 9.632 7.648 18.176 16.608 22.912 43.136 22.72 72.896 63.104 82.336 109.568h-313.536zM896 256c0 54.4-11.52 106.080-32 152.992v-24.992h-32v32h28.64c-44.416 96.384-127.392 171.328-229.248 204.736-10.368 3.328-20.864 6.208-31.424 8.672-28.32 6.688-57.664 10.592-87.968 10.592-154.592 0-287.808-92.032-348.64-224h28.64v-32h-32v24.992c-20.48-46.912-32-98.592-32-152.992v-32h768v32zM384 384h-32v-32h32v32zM448 352h-32v-32h32v32zM384 320h-32v-32h32v32zM320 352h-32v-32h32v32zM320 416h-32v-32h32v32zM384 448h-32v-32h32v32zM448 416h-32v-32h32v32zM192 352h-32v-32h32v32zM672 384h-32v-32h32v32zM736 352h-32v-32h32v32zM672 320h-32v-32h32v32zM608 352h-32v-32h32v32zM608 416h-32v-32h32v32zM672 448h-32v-32h32v32zM736 416h-32v-32h32v32zM864 352h-32v-32h32v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strain",
						"filter"
					],
					"grid": 32
				},
				{
					"id": 2623,
					"paths": [
						"M224 448c123.514 0 224-100.486 224-224s-100.486-224-224-224-224 100.486-224 224 100.486 224 224 224zM224 64c88.224 0 160 71.776 160 160s-71.776 160-160 160-160-71.776-160-160 71.776-160 160-160z",
						"M773 192h155l-192-192-192 192h155c0 57.046-16.028 117.858-46.352 175.858-31.068 59.426-77.266 116.114-133.596 163.938-127.002 107.824-297.844 167.204-481.052 167.204-20.434 0-37 16.566-37 37s16.566 37 37 37c200.732 0 388.582-65.626 528.948-184.794 63.526-53.932 115.838-118.27 151.28-186.062 35.834-68.54 54.772-141.206 54.772-210.144z",
						"M877.254 832l137.374-137.374c12.498-12.496 12.498-32.758 0-45.254-12.496-12.496-32.758-12.496-45.254 0l-137.374 137.374-137.374-137.374c-12.496-12.496-32.758-12.496-45.254 0-12.498 12.496-12.498 32.758 0 45.254l137.374 137.374-137.374 137.374c-12.498 12.496-12.498 32.758 0 45.254 6.25 6.248 14.44 9.372 22.628 9.372s16.378-3.124 22.626-9.374l137.374-137.372 137.374 137.374c6.248 6.248 14.438 9.372 22.626 9.372s16.378-3.124 22.626-9.374c12.498-12.496 12.498-32.758 0-45.254l-137.372-137.372z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strategy",
						"plan"
					],
					"defaultCode": 60458,
					"grid": 16
				},
				{
					"id": 1673,
					"width": 804.5780868530273,
					"paths": [
						"M804.571 877.714q0 36-35.143 64.857t-93.714 46.286-128.571 26.286-144.857 8.857-144.857-8.857-128.571-26.286-93.714-46.286-35.143-64.857q0-28 18.857-50.571t52-38 67.429-25.429 74.857-16.857q14.857-2.857 27.429 6t14.857 23.714q2.857 14.857-6 27.429t-23.714 14.857q-33.143 5.714-60.571 13.429t-43.714 14.571-27.714 13.429-15.714 11.143-4.857 6.857q1.714 6.286 15.429 15.143t41.714 18.857 65.143 18.571 91.714 14.286 115.143 5.714 115.143-5.714 91.714-14.286 65.143-18.857 41.714-19.143 15.429-15.714q-0.571-2.286-4.857-6.286t-15.714-10.857-27.714-13.429-43.714-14.286-60.571-13.429q-14.857-2.286-23.714-14.857t-6-27.429q2.286-14.857 14.857-23.714t27.429-6q40.571 6.857 74.857 16.857t67.429 25.429 52 38 18.857 50.571zM585.143 365.714v219.429q0 14.857-10.857 25.714t-25.714 10.857h-36.571v219.429q0 14.857-10.857 25.714t-25.714 10.857h-146.286q-14.857 0-25.714-10.857t-10.857-25.714v-219.429h-36.571q-14.857 0-25.714-10.857t-10.857-25.714v-219.429q0-30.286 21.429-51.714t51.714-21.429h219.429q30.286 0 51.714 21.429t21.429 51.714zM530.286 146.286q0 53.143-37.429 90.571t-90.571 37.429-90.571-37.429-37.429-90.571 37.429-90.571 90.571-37.429 90.571 37.429 37.429 90.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"street-view"
					],
					"defaultCode": 61981,
					"grid": 14
				},
				{
					"id": 3247,
					"paths": [
						"M960 512v64h-181.914c34.048 45.762 53.914 100.79 53.914 160 0 159.058-143.27 288-320 288-164.712 0-300.334-112.004-318.024-256h129.984c7.006 28.31 23.21 54.74 47.394 76.506 36.896 33.206 86.846 51.494 140.646 51.494s103.75-18.288 140.646-51.494c33.116-29.804 51.354-68.34 51.354-108.506s-18.238-78.702-51.354-108.506c-36.896-33.206-86.846-51.494-140.646-51.494h-448v-64h896zM512 448h-266.086c-34.048-45.762-53.914-100.79-53.914-160 0-159.058 143.268-288 320-288 164.71 0 300.334 112.004 318.022 256h-129.982c-7.008-28.31-23.212-54.74-47.394-76.504-36.896-33.208-86.846-51.496-140.646-51.496s-103.75 18.288-140.646 51.496c-33.116 29.802-51.354 68.338-51.354 108.504s18.238 78.702 51.354 108.504c36.896 33.208 86.846 51.496 140.646 51.496z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strikethrough",
						"wysiwyg"
					],
					"defaultCode": 61082,
					"grid": 16
				},
				{
					"id": 3248,
					"paths": [
						"M64 0v320l128-192h256v320h128v-320h256l128 192v-320zM576 960v-320h-128v320h-128l-64 64h512l-64-64zM0 512h1024v64h-1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strikethrough",
						"wysiwyg"
					],
					"defaultCode": 61083,
					"grid": 16
				},
				{
					"id": 3253,
					"paths": [
						"M1024 512v64h-234.506c27.504 38.51 42.506 82.692 42.506 128 0 70.878-36.66 139.026-100.58 186.964-59.358 44.518-137.284 69.036-219.42 69.036-82.138 0-160.062-24.518-219.42-69.036-63.92-47.938-100.58-116.086-100.58-186.964h128c0 69.382 87.926 128 192 128s192-58.618 192-128c0-69.382-87.926-128-192-128h-512v-64h299.518c-2.338-1.654-4.656-3.324-6.938-5.036-63.92-47.94-100.58-116.086-100.58-186.964s36.66-139.024 100.58-186.964c59.358-44.518 137.282-69.036 219.42-69.036 82.136 0 160.062 24.518 219.42 69.036 63.92 47.94 100.58 116.086 100.58 186.964h-128c0-69.382-87.926-128-192-128s-192 58.618-192 128c0 69.382 87.926 128 192 128 78.978 0 154.054 22.678 212.482 64h299.518z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strikethrough",
						"wysiwyg"
					],
					"defaultCode": 61088,
					"grid": 16
				},
				{
					"id": 1359,
					"width": 1023.9989233016968,
					"paths": [
						"M1005.714 512q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-987.429q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h987.429zM276 475.429q-16-20-29.143-45.714-27.429-55.429-27.429-107.429 0-103.429 76.571-176.571 76-72.571 224.571-72.571 28.571 0 95.429 10.857 37.714 6.857 101.143 27.429 5.714 21.714 12 67.429 8 70.286 8 104.571 0 10.286-2.857 25.714l-6.857 1.714-48-3.429-8-1.143q-28.571-85.143-58.857-117.143-50.286-52-120-52-65.143 0-104 33.714-38.286 33.143-38.286 83.429 0 41.714 37.714 80t159.429 73.714q39.429 11.429 98.857 37.714 33.143 16 54.286 29.714h-424.571zM565.714 621.714h234.857q4 22.286 4 52.571 0 63.429-23.429 121.143-13.143 31.429-40.571 59.429-21.143 20-62.286 46.286-45.714 27.429-87.429 37.714-45.714 12-116 12-65.143 0-111.429-13.143l-80-22.857q-32.571-9.143-41.143-16-4.571-4.571-4.571-12.571v-7.429q0-61.714-1.143-89.143-0.571-17.143 0-38.857l1.143-21.143v-25.143l58.286-1.143q8.571 19.429 17.143 40.571t12.857 32 7.143 15.429q20 32.571 45.714 53.714 24.571 20.571 60 32.571 33.714 12.571 75.429 12.571 36.571 0 79.429-15.429 44-14.857 69.714-49.143 26.857-34.857 26.857-73.714 0-48-46.286-89.714-19.429-16.571-78.286-40.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strikethrough"
					],
					"defaultCode": 61644,
					"grid": 14
				},
				{
					"id": 245,
					"paths": [
						"M844.8 102.4h-716.8c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h332.8v230.4c0 14.138 11.462 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-230.4h332.8c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6z",
						"M486.4 921.6c-14.138 0-25.6-11.461-25.6-25.6v-204.8c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v204.8c0 14.139-11.462 25.6-25.6 25.6z",
						"M947.2 614.4h-921.6c-14.138 0-25.6-11.461-25.6-25.6v-102.4c0-14.139 11.462-25.6 25.6-25.6h921.6c14.139 0 25.6 11.461 25.6 25.6v102.4c0 14.139-11.461 25.6-25.6 25.6zM51.2 563.2h870.4v-51.2h-870.4v51.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strikethrough",
						"typography"
					],
					"defaultCode": 59542,
					"grid": 20
				},
				{
					"id": 855,
					"width": 1024,
					"paths": [
						"M896 32c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM960 224c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM800 64c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM1024 160c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM970.048 74.048l-20.096-20.096c-6.24-6.24-14.432-9.376-22.624-9.376-7.872 0-15.744 2.88-21.92 8.704l-310.336 292.064c-29.504-16.032-63.136-25.344-99.072-25.344-73.6 0-138.144 38.336-175.104 96.032-0.32 0-0.608-0.032-0.896-0.032-159.072 0-288 128.928-288 288s128.928 288 288 288 288-128.928 288-288c0-0.288-0.032-0.576-0.032-0.896 57.696-36.96 96.032-101.504 96.032-175.104 0-35.936-9.312-69.568-25.344-99.072l292.064-310.336c11.872-12.576 11.552-32.32-0.672-44.544zM590.688 676.16l-14.752 9.44v17.504l0.032 1.696 0.032 0.224c-0.576 140.704-115.2 254.976-256 254.976-141.152 0-256-114.848-256-256 0-140.832 114.336-255.488 255.040-256l0.608 0.032h18.72l9.44-14.752c32.64-50.88 88.032-81.28 148.192-81.28 26.56 0 51.584 6.176 74.176 16.768l-162.176 152.64c-13.152 12.384-13.472 33.152-0.704 45.92l49.344 49.344c6.272 6.272 14.432 9.376 22.624 9.376 8.512 0 16.992-3.36 23.296-10.080l152.64-162.176c10.624 22.624 16.8 47.648 16.8 74.208 0 60.16-30.4 115.552-81.312 148.16zM479.296 594.048l-49.344-49.344 497.344-468.128c0 0 0 0 0.032 0v0l20.096 20.096-468.128 497.376zM320 608c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM320 768c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strum",
						"play",
						"pick",
						"perform",
						"rock"
					],
					"grid": 32
				},
				{
					"id": 856,
					"width": 1024,
					"paths": [
						"M384 704c0 35.296-28.704 64-64 64s-64-28.704-64-64 28.704-64 64-64 64 28.704 64 64zM685.952 444.512c11.36 25.6 18.048 53.696 18.048 83.488 0 73.6-38.336 138.144-96.032 175.104 0 0.32 0.032 0.608 0.032 0.896 0 159.072-128.928 288-288 288s-288-128.928-288-288c0-159.072 128.928-288 288-288 0.288 0 0.576 0.032 0.896 0.032 36.96-57.696 101.504-96.032 175.104-96.032 29.792 0 57.888 6.688 83.488 18.048l-182.464 171.712c-9.376 8.832-14.848 21.312-15.072 34.208-0.192 12.928 4.928 25.536 14.048 34.656l49.344 49.344c9.056 9.056 21.12 14.048 34.688 14.048 12.896-0.224 25.344-5.696 34.208-15.104l171.712-182.4zM416 704c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96zM413.952 544.48c-0.064 4.288 1.632 8.512 4.672 11.552l49.344 49.344c3.040 3.008 7.040 4.672 11.328 4.672 4.544-0.064 8.704-1.92 11.648-5.024l468.128-497.376c5.984-6.336 5.824-16.128-0.32-22.272l-20.096-20.096c-3.040-3.008-7.040-4.672-11.328-4.672-4.096 0-8 1.536-10.976 4.352l-497.376 468.096c-3.104 2.944-4.96 7.104-5.024 11.424zM864 0c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM928 192c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM768 96c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM992 128c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"strum",
						"play",
						"pick",
						"perform",
						"rock"
					],
					"grid": 32
				},
				{
					"id": 857,
					"width": 1024,
					"paths": [
						"M864 672v-448c0-17.664-14.336-32-32-32h-640c-17.664 0-32 14.336-32 32v448c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32zM192 224h640v448h-640v-448zM928 736v-512c0-53.024-42.976-96-96-96h-640c-53.024 0-96 42.976-96 96v512c-35.36 0-64 28.64-64 64s28.64 64 64 64h832c35.36 0 64-28.64 64-64s-28.64-64-64-64zM128 224c0-35.296 28.704-64 64-64h640c35.296 0 64 28.704 64 64v512h-768v-512zM928 832h-832c-17.632 0-32-14.368-32-32s14.368-32 32-32h320c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32h320c17.632 0 32 14.368 32 32s-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"study",
						"play",
						"work"
					],
					"grid": 32
				},
				{
					"id": 858,
					"width": 1024,
					"paths": [
						"M992 800c0 35.36-28.64 64-64 64h-832c-35.36 0-64-28.64-64-64s28.64-64 64-64h320c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32h320c35.36 0 64 28.64 64 64zM832 224h-640v384h640v-384zM96 704v-480c0-53.024 42.976-96 96-96h640c53.024 0 96 42.976 96 96v480h-832zM160 608c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-384c0-17.664-14.336-32-32-32h-640c-17.664 0-32 14.336-32 32v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"study",
						"play",
						"work"
					],
					"grid": 32
				},
				{
					"id": 1146,
					"width": 1024,
					"paths": [
						"M640 192h-544v160h544v-160zM608 320h-480v-96h480v96zM928 192h-256v192h256v-192zM896 352h-192v-128h192v128zM928 416h-256v192h256v-192zM896 576h-192v-128h192v128zM928 640h-256v192h256v-192zM896 800h-192v-128h192v128zM416 288h-96v-32h96v32zM832 288h-64v-32h64v32zM832 512h-64v-32h64v32zM832 736h-64v-32h64v32zM992 96h-960c-17.664 0-32 14.336-32 32v768c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-448h416v448c0 17.664 14.336 32 32 32h384c17.664 0 32-14.336 32-32v-768c0-17.664-14.336-32-32-32zM960 864h-320v-480h-544v480h-32v-704h896v704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"study",
						"work",
						"sit"
					],
					"grid": 32
				},
				{
					"id": 859,
					"width": 1024,
					"paths": [
						"M700.128 647.104c-18.016-18.016-28.128-42.432-28.128-67.904v-169.088c37.216-13.216 64-48.384 64-90.112v-64c0-41.728-26.784-76.896-64-90.112v-37.888c0-35.36-28.64-64-64-64 0-35.36-28.64-64-64-64h-96c-35.36 0-64 28.64-64 64v96h-63.008c13.824-27.168 31.008-64.128 31.008-80 0-26.496-21.504-48-48-48s-48 21.504-48 48c0 16.96 19.584 57.92 33.728 85.344-38.080 12.736-65.728 48.288-65.728 90.656v64c0 41.728 26.784 76.896 64 90.112v204.32c0 84.864 33.728 166.272 93.728 226.272l130.272 130.272c35.36 35.36 81.664 53.024 128 53.024s92.64-17.664 128-53.024c70.688-70.688 70.688-185.312 0-256l-67.872-67.872zM608 96c17.632 0 32 14.368 32 32v32h-128v-32c0-17.632 14.368-32 32-32h64zM416 64c0-17.632 14.368-32 32-32h96c17.632 0 32 14.368 32 32h-32c-35.36 0-64 28.64-64 64v32h-64v-96zM288 80c0-8.832 7.168-16 16-16s16 7.168 16 15.552c-0.512 6.272-6.784 22.464-16 42.368-9.216-19.808-15.488-35.872-16-41.92zM256 320v-64c0-35.296 28.704-64 64-64h320c35.296 0 64 28.704 64 64v64c0 35.296-28.704 64-64 64h-320c-35.296 0-64-28.704-64-64zM404.352 818.080c-54.4-54.4-84.352-126.72-84.352-203.648v-22.752c72.768 14.944 128 78.176 128 155.296 0 32.512-10.432 62.272-27.296 87.456l-16.352-16.352zM745.376 948.352c-28.16 28.16-65.568 43.648-105.376 43.648s-77.216-15.488-105.376-43.648l-90.784-90.784c22.368-31.328 36.16-69.152 36.16-110.592 0-95.104-69.216-173.856-160-189.088v-141.888h320v163.2c0 34.176 13.312 66.336 37.504 90.496l67.872 67.872c58.112 58.144 58.112 152.672 0 210.784z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stuff",
						"give",
						"share",
						"receive"
					],
					"grid": 32
				},
				{
					"id": 860,
					"width": 1024,
					"paths": [
						"M544 64h64c35.36 0 64 28.64 64 64h-192c0-35.36 28.64-64 64-64zM544 32h55.136c-11.104-19.040-31.52-32-55.136-32h-96c-35.36 0-64 28.64-64 64v64h64c0-52.928 43.072-96 96-96zM288.896 587.904c-0.32 0-0.576 0.096-0.896 0.096v26.432c0 84.864 33.728 166.272 93.728 226.272l18.272 18.272c29.152-28.736 47.296-68.576 47.296-112.672 0-87.328-71.072-158.4-158.4-158.4zM768 714.976l-67.872-67.872c-18.016-18.016-28.128-42.432-28.128-67.904v-131.2h-384v107.968c0.288 0 0.608-0.032 0.896-0.032 105.152 0 190.4 85.248 190.4 190.4 0 52.992-21.664 100.864-56.576 135.392l89.28 89.28c35.36 35.328 81.664 52.992 128 52.992s92.64-17.664 128-53.024c70.688-70.688 70.688-185.312 0-256zM320 416c-53.024 0-96-42.976-96-96v-64c0-42.368 27.648-77.92 65.728-90.656-14.144-27.424-33.728-68.384-33.728-85.344 0-26.496 21.504-48 48-48s48 21.504 48 48c0 15.872-17.184 52.832-31.008 80h319.008c53.024 0 96 42.976 96 96v64c0 53.024-42.976 96-96 96h-320zM288 80c0.512 6.048 6.784 22.112 16 41.92 9.216-19.904 15.488-36.096 16-42.368 0-8.384-7.168-15.552-16-15.552s-16 7.168-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stuff",
						"give",
						"share",
						"receive"
					],
					"grid": 32
				},
				{
					"id": 3394,
					"paths": [
						"M512 320c-35.2 0-64 28.8-64 64v256c0 105.8-86.2 192-192 192s-192-86.2-192-192v-128h128v128c0 35.2 28.8 64 64 64s64-28.8 64-64v-256c0-105.8 86.2-192 192-192s192 86.2 192 178v62l-82 24-46-24v-62c0-21.2-28.8-50-64-50z",
						"M960 640c0 105.8-86.2 192-192 192s-192-86.2-192-206v-124l46 24 82-24v124c0 49.2 28.8 78 64 78s64-28.8 64-64v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stumbleupon",
						"brand",
						"social"
					],
					"defaultCode": 61229,
					"grid": 16
				},
				{
					"id": 1558,
					"width": 877.7139282226562,
					"paths": [
						"M494.857 479.429l51.429-15.429v-35.429q0-45.143-33.143-77.143t-78.857-32-78.857 31.714-33.143 76.857v161.714q0 11.429-8 19.143t-18.857 7.714-18.571-7.714-7.714-19.143v-68.571h-86.286v69.714q0 46.857 32.857 79.429t79.714 32.571q46.286 0 79.143-32.286t32.857-78v-160q0-10.857 7.714-18.857t19.143-8q10.857 0 18.571 8t7.714 18.857v30.857zM685.143 590.857v-69.714h-85.714v72q0 11.429-7.714 19.143t-19.143 7.714q-10.857 0-18.571-8t-7.714-18.857v-70.286l-51.429 14.857-34.286-16v70.286q0 45.714 33.143 78.286t79.429 32.571 79.143-32.571 32.857-79.429zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stumbleupon-circle"
					],
					"defaultCode": 61859,
					"grid": 14
				},
				{
					"id": 3395,
					"paths": [
						"M852 0h-680c-94.6 0-172 77.4-172 172v680c0 94.6 77.4 172 172 172h680c94.6 0 172-77.4 172-172v-680c0-94.6-77.4-172-172-172zM512 320c-35.29 0-64 28.71-64 64v256c0 105.872-86.13 192-192 192s-192-86.128-192-192v-128h128v128c0 35.29 28.71 64 64 64s64-28.71 64-64v-256c0-105.87 86.13-192 192-192s192 86.13 192 178v62l-82 24-46-24v-62c0-21.29-28.71-50-64-50zM960 640c0 105.872-86.13 192-192 192s-192-86.128-192-206v-124l46 24 82-24v124c0 49.29 28.71 78 64 78s64-28.71 64-64v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stumbleupon",
						"brand",
						"social"
					],
					"defaultCode": 61230,
					"grid": 16
				},
				{
					"id": 1559,
					"width": 1097.1409301757812,
					"paths": [
						"M606.857 406.857v-67.429q0-24-17.143-41.143t-41.143-17.143-41.143 17.143-17.143 41.143v349.714q0 100-72 170.857t-173.143 70.857q-101.714 0-173.429-71.714t-71.714-173.429v-152h187.429v149.714q0 24.571 17.143 41.429t41.143 16.857 41.143-16.857 17.143-41.429v-354.286q0-97.714 72.286-166.857t172.286-69.143q100.571 0 172.571 69.714t72 168v77.714l-111.429 33.143zM909.714 533.714h187.429v152q0 101.714-71.714 173.429t-173.429 71.714q-101.143 0-173.143-71.143t-72-171.714v-153.143l74.857 34.857 111.429-33.143v154.286q0 24 17.143 40.857t41.143 16.857 41.143-16.857 17.143-40.857v-157.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"stumbleupon"
					],
					"defaultCode": 61860,
					"grid": 14
				},
				{
					"id": 861,
					"width": 1024,
					"paths": [
						"M448 544c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM448 704c-35.296 0-64-28.704-64-64s28.704-64 64-64c35.296 0 64 28.704 64 64s-28.704 64-64 64zM672 544c-53.024 0-96 42.976-96 96s42.976 96 96 96 96-42.976 96-96-42.976-96-96-96zM672 704c-35.296 0-64-28.704-64-64s28.704-64 64-64c35.296 0 64 28.704 64 64s-28.704 64-64 64zM928 416h-32l-55.072 55.072c-52.352-72.032-137.056-119.072-232.928-119.072h-32v-32c0-17.664-14.336-32-32-32v-128c0-35.36-28.64-64-64-64h-96c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h32v64c-17.664 0-32 14.336-32 32v32h-32c-125.344 0-231.68 80.224-271.264 192-19.104 54.912-21.952 114.336-6.656 170.56 32.896 122.848 144.672 213.44 277.92 213.44h256c95.872 0 180.576-47.040 232.896-119.072l55.104 55.072h32c17.664 0 32-14.336 32-32v-160l-32-32 32-32v-160c0-17.664-14.336-32-32-32zM384 192v-64h96c17.632 0 32 14.368 32 32v128h-64v-96h-64zM416 320h128v32h-128v-32zM96 640c0-22.144 3.104-43.488 8.416-64h119.552c35.296 0 64 28.704 64 64s-28.704 64-64 64h-119.552c-5.28-20.512-8.416-41.856-8.416-64zM608 896h-256c-107.2 0-199.072-66.304-237.152-160h109.12c53.024 0 96-42.976 96-96s-42.976-96-96-96h-109.12c38.080-93.696 129.952-160 237.152-160h256c141.152 0 256 114.848 256 256s-114.848 256-256 256zM928 685.248v146.752h-18.752l-50.56-50.56c21.696-38.336 34.624-82.144 36.672-128.832l32.64 32.64zM928 594.752l-32.64 32.64c-2.016-46.688-14.976-90.496-36.672-128.832l50.56-50.56h18.752v146.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"submerge",
						"float",
						"spy",
						"sink"
					],
					"grid": 32
				},
				{
					"id": 862,
					"width": 1024,
					"paths": [
						"M512 640c0 35.296-28.704 64-64 64s-64-28.704-64-64c0-35.296 28.704-64 64-64s64 28.704 64 64zM384 224h32v32h128v-96c0-35.36-28.64-64-64-64h-96c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32zM287.968 640c0-35.296-28.704-64-64-64h-151.808c-9.6 42.112-9.824 85.728-0.064 128h151.904c35.264 0 63.968-28.704 63.968-64zM672 576c-35.296 0-64 28.704-64 64s28.704 64 64 64c35.296 0 64-28.704 64-64s-28.704-64-64-64zM960 608l-32 32 32 32v160c0 17.664-14.336 32-32 32h-32l-55.104-55.104c-52.352 72.064-137.024 119.104-232.896 119.104h-256c-125.344 0-231.648-80.192-271.2-192h143.168c53.024 0 96-42.976 96-96s-42.976-96-96-96h-143.232c39.584-111.776 145.92-192 271.264-192h32v-32c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32v32h32c95.872 0 180.576 47.040 232.928 119.104l55.072-55.104h32c17.664 0 32 14.336 32 32v160zM544 640c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96zM768 640c0-53.024-42.976-96-96-96s-96 42.976-96 96 42.976 96 96 96 96-42.976 96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"submerge",
						"float",
						"spy",
						"sink"
					],
					"grid": 32
				},
				{
					"id": 1147,
					"width": 1024,
					"paths": [
						"M304 608c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM304 736c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM496 608c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM496 736c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM688 608c-44.192 0-80 35.808-80 80s35.808 80 80 80c44.192 0 80-35.808 80-80s-35.808-80-80-80zM688 736c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48zM1014.624 425.376l-64-64c-12.512-12.512-32.736-12.512-45.248 0l-83.84 83.84c-36.032-16.096-75.392-29.216-117.536-39.168v-86.048c0-8.48-3.36-16.64-9.376-22.624l-64-64c-5.984-6.016-14.144-9.376-22.624-9.376h-32v-192c0-17.664-14.336-32-32-32h-160c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h32v64h-64c-17.664 0-32 14.336-32 32v150.016c-195.296 45.952-320 154.912-320 281.984 0 170.464 224.896 304 512 304 112 0 220.896-21.632 309.536-61.216l83.84 83.84c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l64-64c6.016-5.984 9.376-14.144 9.376-22.624v-480c0-8.48-3.36-16.64-9.376-22.624zM416 64h96v192h-32v-160h-64v-32zM384 288h210.752l45.248 45.248v92.832c-40.8-6.4-83.616-10.080-128-10.080s-87.2 3.68-128 10.080v-138.080zM960 914.752l-32 32-70.336-70.336c44.192-26.048 79.136-57.056 102.336-91.424v129.76zM512 928c-242.848 0-448-109.92-448-240s205.152-240 448-240 448 109.92 448 240-205.152 240-448 240zM960 590.976c-23.2-34.368-58.112-65.376-102.336-91.424l70.336-70.304 32 32v129.728z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"submerge",
						"float",
						"spy",
						"sink"
					],
					"grid": 32
				},
				{
					"id": 3260,
					"paths": [
						"M768 910v50h128v64h-192v-146l128-60v-50h-128v-64h192v146zM676 256h-136l-188 188-188-188h-136l256 256-256 256h136l188-188 188 188h136l-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"subscript",
						"wysiwyg"
					],
					"defaultCode": 61095,
					"grid": 16
				},
				{
					"id": 3262,
					"paths": [
						"M194.018 832l57.6-192h264.764l57.6 192h113.632l-192-640h-223.232l-192 640h113.636zM347.618 320h72.764l57.6 192h-187.964l57.6-192zM1024 192l-160 256-160-256h320z",
						"M864 832h-64c-17.644 0-32-14.356-32-32s14.356-32 32-32h128c17.674 0 32-14.328 32-32s-14.326-32-32-32h-128c-52.936 0-96 43.066-96 96 0 24.568 9.29 47.002 24.524 64 17.588 19.624 43.112 32 71.476 32h64c17.644 0 32 14.356 32 32s-14.356 32-32 32h-128c-17.674 0-32 14.328-32 32s14.326 32 32 32h128c52.936 0 96-43.066 96-96 0-24.568-9.29-47.002-24.524-64-17.588-19.624-43.108-32-71.476-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"subscript",
						"wysiwyg"
					],
					"defaultCode": 61097,
					"grid": 16
				},
				{
					"id": 1447,
					"width": 880.5710144042969,
					"paths": [
						"M512.571 782.286v95.429h-141.714l-90.857-144-13.714-24q-4.571-5.143-6.286-12h-1.714l-5.143 12q-5.714 11.429-14.286 25.143l-88.571 142.857h-147.429v-95.429h73.143l112.571-166.286-105.714-155.429h-78.286v-96h157.714l79.429 130.286q1.143 2.286 13.143 24 4.571 5.143 6.286 12h1.714q1.714-5.143 6.286-12l14.286-24 80-130.286h146.857v96h-71.429l-105.143 152.571 116.571 169.143h62.286zM877.714 906.286v117.714h-293.714l-2.286-15.429q-1.714-25.714-1.714-26.286 0-36.571 14.857-66.857t37.143-49.429 48-37.143 48-31.143 37.143-30.857 14.857-36.571q0-21.714-16.857-35.714t-40.286-14q-29.143 0-55.429 22.286-8 6.286-20.571 21.714l-60-52.571q14.857-21.143 36-37.714 45.714-37.143 107.429-37.143 62.857 0 101.714 34t38.857 90.571q0 37.714-19.714 67.714t-48 49.143-56.857 35.714-49.714 36-23.429 41.714h132.571v-45.714h72z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"subscript"
					],
					"defaultCode": 61740,
					"grid": 14
				},
				{
					"id": 2251,
					"paths": [
						"M704 320v-320h-704v704h320v320h704v-704h-320zM576 256h-320v8h-128v-16h448v8zM128 576v-8h128v8h-128zM128 552v-16h128v16h-128zM128 520v-16h128v16h-128zM128 488v-16h128v16h-128zM128 456v-16h128v16h-128zM128 424v-16h128v16h-128zM128 392v-16h128v16h-128zM128 360v-16h128v16h-128zM128 328v-16h128v16h-128zM128 296v-16h128v16h-128zM576 232h-448v-16h448v16zM576 200h-448v-16h448v16zM576 168h-448v-16h448v16zM576 136h-448v-8h448v8zM960 960h-576v-576h576v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"subtract",
						"boolean-operation",
						"dualtone"
					],
					"defaultCode": 60086,
					"grid": 16
				},
				{
					"id": 1148,
					"width": 1024,
					"paths": [
						"M512 0c-282.784 0-512 229.216-512 512s229.216 512 512 512 512-229.216 512-512-229.216-512-512-512zM512 960c-247.040 0-448-200.96-448-448s200.96-448 448-448c247.040 0 448 200.96 448 448s-200.96 448-448 448zM512 96c-229.76 0-416 186.24-416 416s186.24 416 416 416 416-186.24 416-416-186.24-416-416-416zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384zM736 448h-448c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h448c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM736 544h-448v-64h448v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"subtract",
						"remove"
					],
					"grid": 32
				},
				{
					"id": 1697,
					"width": 877.7129516601562,
					"paths": [
						"M621.714 0q105.714 0 180.857 53.429t75.143 129.429v512q0 74.286-71.714 126.857t-174.571 55.429l121.714 115.429q9.143 8.571 4.571 20t-17.143 11.429h-603.429q-12.571 0-17.143-11.429t4.571-20l121.714-115.429q-102.857-2.857-174.571-55.429t-71.714-126.857v-512q0-76 75.143-129.429t180.857-53.429h365.714zM164.571 749.714q37.714 0 64.571-26.857t26.857-64.571-26.857-64.571-64.571-26.857-64.571 26.857-26.857 64.571 26.857 64.571 64.571 26.857zM402.286 438.857v-292.571h-310.857v292.571h310.857zM713.143 749.714q37.714 0 64.571-26.857t26.857-64.571-26.857-64.571-64.571-26.857-64.571 26.857-26.857 64.571 26.857 64.571 64.571 26.857zM804.571 438.857v-292.571h-329.143v292.571h329.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"subway"
					],
					"defaultCode": 62009,
					"grid": 14
				},
				{
					"id": 863,
					"width": 1024,
					"paths": [
						"M608 336c0 8.832-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16h160c8.832 0 16 7.168 16 16zM592 384h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16zM852.256 820.448l-126.816-19.328-46.688 119.488c-10.336 26.464-47.488 27.328-59.040 1.376l-107.712-242.048-107.712 242.048c-11.552 25.952-48.704 25.12-59.040-1.376l-46.688-119.456-126.816 19.328c-28.096 4.288-47.424-27.456-30.688-50.432l141.728-195.008c-56.096-57.664-90.784-136.256-90.784-223.040 0-188.672 163.264-339.2 356.192-318.016 148.192 16.256 267.936 137.92 282.272 286.304 9.568 99.232-26.368 190.144-89.216 254.72l141.728 195.008c16.672 22.976-2.624 54.72-30.72 50.432zM481.216 670.432c-66.304-6.336-126.624-32.896-174.848-73.44l-139.392 191.808 152.128-23.168 56 143.328 106.112-238.528zM512 640c158.816 0 288-129.184 288-288s-129.184-288-288-288-288 129.184-288 288c0 158.816 129.184 288 288 288zM857.056 788.832l-139.392-191.808c-48.256 40.544-108.576 67.104-174.848 73.44l106.144 238.528 56-143.328 152.096 23.168zM768 352c0 141.376-114.624 256-256 256s-256-114.624-256-256 114.624-256 256-256 256 114.624 256 256zM736 352c0-123.52-100.48-224-224-224s-224 100.48-224 224 100.48 224 224 224 224-100.48 224-224zM592 256h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"succeed",
						"win",
						"achieve"
					],
					"grid": 32
				},
				{
					"id": 864,
					"width": 1024,
					"paths": [
						"M263.712 601.248c61.376 61.152 145.216 99.488 237.824 102.24l-97.248 218.528c-11.552 25.952-48.704 25.12-59.040-1.376l-46.688-119.488-126.816 19.328c-28.096 4.288-47.424-27.456-30.688-50.432l122.656-168.8zM882.944 770.016l-122.656-168.768c-61.376 61.152-145.216 99.488-237.824 102.24l97.248 218.528c11.552 25.952 48.704 25.12 59.040-1.376l46.688-119.488 126.816 19.328c28.096 4.256 47.392-27.488 30.688-50.464zM741.248 575.008c-58.144 59.744-139.296 96.992-229.248 96.992s-171.104-37.248-229.248-96.992c-56.064-57.632-90.752-136.224-90.752-223.008 0-188.672 163.264-339.2 356.192-318.016 148.192 16.256 267.936 137.92 282.272 286.304 9.6 99.232-26.368 190.144-89.216 254.72zM768 352c0-141.376-114.624-256-256-256s-256 114.624-256 256 114.624 256 256 256 256-114.624 256-256zM736 352c0 123.52-100.48 224-224 224s-224-100.48-224-224 100.48-224 224-224 224 100.48 224 224zM608 400c0-8.832-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16zM608 336c0-8.832-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16zM608 272c0-8.832-7.168-16-16-16h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"succeed",
						"win",
						"achieve"
					],
					"grid": 32
				},
				{
					"id": 1149,
					"width": 1024,
					"paths": [
						"M512 96c-159.072 0-288 128.928-288 288s128.928 288 288 288 288-128.928 288-288-128.928-288-288-288zM512 640c-141.152 0-256-114.848-256-256s114.848-256 256-256 256 114.848 256 256-114.848 256-256 256zM903.072 808.992l-139.776-135.040c84-72.864 136.288-181.376 132.544-302.176-6.24-198.592-169.408-363.456-367.936-371.456-5.312-0.224-10.624-0.32-15.904-0.32-212.096 0-384 171.904-384 384 0 115.872 51.552 219.52 132.736 289.92l-139.776 135.040c-20.704 20.032-6.56 55.040 22.208 55.040h144.832l112.256 112.256c6.464 6.464 14.528 9.408 22.432 9.408 15.392 0 30.272-11.104 32.032-28.864l19.072-190.752c12.576 1.28 25.312 1.952 38.208 1.952s25.632-0.672 38.208-1.92l19.072 190.72c1.76 17.76 16.64 28.864 32.032 28.864 7.904 0 15.968-2.944 22.432-9.408l112.256-112.256h144.832c28.768 0 42.912-35.008 22.24-55.008zM512 704c-176.448 0-320-143.552-320-320s143.552-320 320-320 320 143.552 320 320-143.552 320-320 320zM397.76 883.232c-76-76-6.88-6.88-83.232-83.232h-92.16c90.080-87.040 65.696-63.456 114.72-110.816 24 13.792 49.696 24.832 76.832 32.704-5.024 49.824-0.864 8.256-16.16 161.344zM709.504 800l-83.232 83.232c-15.328-153.408-11.648-116.544-16.128-161.376 27.136-7.872 52.832-18.912 76.832-32.704l114.688 110.848h-92.16zM448 352h32v160h96v-256h-128v96zM480 288h64v192h-32v-160h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"succeed",
						"win",
						"achieve"
					],
					"grid": 32
				},
				{
					"id": 865,
					"width": 1024,
					"paths": [
						"M641.248 32.704l-0.096-0.064c-40.832-20.256-84.16-29.888-126.88-29.888-104.832 0-205.76 57.92-255.808 158.016l-21.6 43.296c-23.712 47.424-4.48 105.088 42.944 128.8l20.256 10.144c13.792 6.88 28.448 10.144 42.848 10.144 35.232 0 69.12-19.456 85.952-53.088l21.056-42.144c12.544-25.088 37.824-39.584 64.064-39.584 10.752 0 21.664 2.432 31.936 7.584 35.36 17.664 49.664 60.64 32 96l-276.736 553.504c-23.84 47.68-4.288 105.632 43.584 129.12l19.616 9.632c13.6 6.656 28 9.824 42.208 9.824 35.232 0 69.12-19.456 85.92-53.088l277.248-554.464c70.72-141.44 13.12-313.408-128.512-383.744zM514.304 34.784c22.56 0 44.608 3.296 66.080 9.152l-303.584 151.776 10.304-20.608c43.264-86.56 130.336-140.32 227.2-140.32zM560.224 197.28c-14.336-7.168-30.304-10.944-46.24-10.944-39.52 0-75.008 21.952-92.672 57.248l-21.056 42.144c-10.912 21.824-32.896 35.392-57.312 35.392-9.952 0-19.552-2.272-28.544-6.784l-20.32-10.112c-24.48-12.256-37.504-38.208-34.784-63.968l362.368-181.184c1.76 0.832 3.616 1.44 5.376 2.304 44.736 22.208 80.992 56.32 105.696 98.4l-136.384 68.192c-9.344-12.48-21.28-23.264-36.128-30.688zM606.528 336.224c12.96-25.92 13.888-54.72 5.088-80.16l135.488-67.744c2.784 6.464 5.44 12.992 7.68 19.744 14.080 42.048 16.704 86.016 8.48 128.384l-209.152 104.576 52.416-104.8zM329.792 889.728l72.48-144.96 223.392-111.712-104.16 208.288-195.104 97.568c0-0.032-0.032-0.064-0.032-0.096-5.472-16.288-4.256-33.728 3.424-49.088zM463.904 956.608c-10.912 21.824-32.864 35.392-57.312 35.392-9.792 0-19.232-2.208-28.128-6.56l-19.616-9.632c-5.408-2.656-10.112-6.176-14.464-10.112l153.312-76.64-33.792 67.552zM649.536 585.344l-223.424 111.712 104.16-208.288 221.344-110.688c-3.072 8.128-6.56 16.16-10.496 24.064l-91.584 183.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"suck",
						"eat",
						"treat",
						"lick",
						"hang"
					],
					"grid": 32
				},
				{
					"id": 866,
					"width": 1024,
					"paths": [
						"M482.592 512.608l308.64-154.304c-4.96 19.712-11.968 39.232-21.44 58.144l-72.512 145.056-318.816 159.392 104.128-208.288zM577.92 321.92l-71.488 142.976 291.616-145.792c5.344-49.92-2.432-99.936-22.208-145.12l-193.28 96.64c4.672 16.512 3.648 34.72-4.64 51.296zM301.184 875.424c-12.64 25.28-12.768 53.344-3.264 77.728l271.328-135.648 104.16-208.288-318.816 159.424-53.408 106.784zM620.512 23.84c-34.656-13.952-70.624-21.088-106.208-21.088-104.832 0-205.76 57.92-255.808 158.016l-21.632 43.296c-2.368 4.672-3.936 9.504-5.472 14.336l389.12-194.56zM314.176 980.8c8.224 9.632 18.496 17.792 30.592 23.712l19.616 9.632c13.6 6.688 28 9.856 42.208 9.856 35.232 0 69.12-19.456 85.92-53.088l52.864-105.728-231.2 115.616zM279.776 332.864l20.256 10.144c13.792 6.88 28.448 10.144 42.848 10.144 35.232 0 69.12-19.456 85.952-53.088l21.088-42.144c12.544-25.088 37.824-39.584 64.064-39.584 10.752 0 21.664 2.432 31.936 7.584 8.416 4.192 15.52 9.92 21.408 16.544l194.048-97.024c-24.352-42.112-59.808-78.208-104.48-103.968l-429.504 214.72c3.104 31.776 21.728 61.312 52.384 76.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"suck",
						"eat",
						"treat",
						"lick",
						"hang"
					],
					"grid": 32
				},
				{
					"id": 1394,
					"width": 1023.9999389648438,
					"paths": [
						"M365.714 219.429h292.571v-73.143h-292.571v73.143zM164.571 219.429v731.429h-36.571q-52.571 0-90.286-37.714t-37.714-90.286v-475.429q0-52.571 37.714-90.286t90.286-37.714h36.571zM804.571 219.429v731.429h-585.143v-731.429h73.143v-91.429q0-22.857 16-38.857t38.857-16h329.143q22.857 0 38.857 16t16 38.857v91.429h73.143zM1024 347.429v475.429q0 52.571-37.714 90.286t-90.286 37.714h-36.571v-731.429h36.571q52.571 0 90.286 37.714t37.714 90.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"suitcase"
					],
					"defaultCode": 61682,
					"grid": 14
				},
				{
					"id": 2787,
					"paths": [
						"M512 256c-141.384 0-256 114.616-256 256 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-141.384-114.616-256-256-256zM512 832c35.346 0 64 28.654 64 64v64c0 35.346-28.654 64-64 64s-64-28.654-64-64v-64c0-35.346 28.654-64 64-64zM512 192c-35.346 0-64-28.654-64-64v-64c0-35.346 28.654-64 64-64s64 28.654 64 64v64c0 35.346-28.654 64-64 64zM960 448c35.346 0 64 28.654 64 64s-28.654 64-64 64h-64c-35.348 0-64-28.654-64-64s28.652-64 64-64h64zM192 512c0 35.346-28.654 64-64 64h-64c-35.346 0-64-28.654-64-64s28.654-64 64-64h64c35.346 0 64 28.654 64 64zM828.784 738.274l45.256 45.258c24.992 24.99 24.992 65.516 0 90.508-24.994 24.992-65.518 24.992-90.51 0l-45.256-45.256c-24.992-24.99-24.992-65.516 0-90.51 24.994-24.992 65.518-24.992 90.51 0zM195.216 285.726l-45.256-45.256c-24.994-24.994-24.994-65.516 0-90.51s65.516-24.994 90.51 0l45.256 45.256c24.994 24.994 24.994 65.516 0 90.51s-65.516 24.994-90.51 0zM828.784 285.726c-24.992 24.992-65.516 24.992-90.51 0-24.992-24.994-24.992-65.516 0-90.51l45.256-45.254c24.992-24.994 65.516-24.994 90.51 0 24.992 24.994 24.992 65.516 0 90.51l-45.256 45.254zM195.216 738.274c24.992-24.992 65.518-24.992 90.508 0 24.994 24.994 24.994 65.52 0 90.51l-45.254 45.256c-24.994 24.992-65.516 24.992-90.51 0s-24.994-65.518 0-90.508l45.256-45.258z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sun",
						"weather"
					],
					"defaultCode": 60622,
					"grid": 16
				},
				{
					"id": 1530,
					"width": 1024.0000190734863,
					"paths": [
						"M841.143 512q0-66.857-26-127.714t-70.286-105.143-105.143-70.286-127.714-26-127.714 26-105.143 70.286-70.286 105.143-26 127.714 26 127.714 70.286 105.143 105.143 70.286 127.714 26 127.714-26 105.143-70.286 70.286-105.143 26-127.714zM998.857 670.286q-2.286 8.571-11.429 11.429l-166.857 54.857v174.857q0 9.143-7.429 14.857-8.571 5.714-16.571 2.286l-166.857-53.714-102.857 141.714q-5.714 7.429-14.857 7.429t-14.857-7.429l-102.857-141.714-166.857 53.714q-8 3.429-16.571-2.286-7.429-5.714-7.429-14.857v-174.857l-166.857-54.857q-9.143-2.857-11.429-11.429-2.857-9.714 2.286-16.571l102.857-141.714-102.857-141.714q-5.143-7.429-2.286-16.571 2.286-8.571 11.429-11.429l166.857-54.857v-174.857q0-9.143 7.429-14.857 8.571-5.714 16.571-2.286l166.857 53.714 102.857-141.714q5.143-6.857 14.857-6.857t14.857 6.857l102.857 141.714 166.857-53.714q8-3.429 16.571 2.286 7.429 5.714 7.429 14.857v174.857l166.857 54.857q9.143 2.857 11.429 11.429 2.857 9.143-2.286 16.571l-102.857 141.714 102.857 141.714q5.143 6.857 2.286 16.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sun-o"
					],
					"defaultCode": 61829,
					"grid": 14
				},
				{
					"id": 2788,
					"paths": [
						"M512 832c35.346 0 64 28.654 64 64v64c0 35.346-28.654 64-64 64s-64-28.654-64-64v-64c0-35.346 28.654-64 64-64zM512 192c-35.346 0-64-28.654-64-64v-64c0-35.346 28.654-64 64-64s64 28.654 64 64v64c0 35.346-28.654 64-64 64zM960 448c35.346 0 64 28.654 64 64s-28.654 64-64 64h-64c-35.348 0-64-28.654-64-64s28.652-64 64-64h64zM192 512c0 35.346-28.654 64-64 64h-64c-35.346 0-64-28.654-64-64s28.654-64 64-64h64c35.346 0 64 28.654 64 64zM828.784 738.274l45.256 45.258c24.992 24.99 24.992 65.516 0 90.508-24.994 24.992-65.518 24.992-90.51 0l-45.256-45.256c-24.992-24.99-24.992-65.516 0-90.51 24.994-24.992 65.518-24.992 90.51 0zM195.216 285.726l-45.256-45.256c-24.994-24.994-24.994-65.516 0-90.51s65.516-24.994 90.51 0l45.256 45.256c24.994 24.994 24.994 65.516 0 90.51s-65.516 24.994-90.51 0zM828.784 285.726c-24.992 24.992-65.516 24.992-90.51 0-24.992-24.994-24.992-65.516 0-90.51l45.256-45.254c24.992-24.994 65.516-24.994 90.51 0 24.992 24.994 24.992 65.516 0 90.51l-45.256 45.254zM195.216 738.274c24.992-24.992 65.518-24.992 90.508 0 24.994 24.994 24.994 65.52 0 90.51l-45.254 45.256c-24.994 24.992-65.516 24.992-90.51 0s-24.994-65.518 0-90.508l45.256-45.258z",
						"M512 256c-141.384 0-256 114.616-256 256 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-141.384-114.616-256-256-256zM512 672c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160-71.634 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sun",
						"weather"
					],
					"defaultCode": 60623,
					"grid": 16
				},
				{
					"id": 2795,
					"paths": [
						"M919.95 512l91.212-113.93-131.614-63.072 32.75-142.224-145.948 0.28-32.204-142.348-131.368 63.574-90.778-114.28-90.778 114.28-131.372-63.576-32.204 142.348-145.946-0.28 32.748 142.224-131.61 63.074 91.214 113.93-91.214 113.93 131.614 63.072-32.748 142.224 145.946-0.28 32.204 142.35 131.372-63.576 90.774 114.28 90.778-114.28 131.372 63.576 32.204-142.35 145.948 0.28-32.75-142.224 131.614-63.072-91.216-113.93zM512 841c-175.53 0-317.826-147.298-317.826-329s142.296-329 317.826-329c175.532 0 317.826 147.298 317.826 329s-142.294 329-317.826 329zM256 512c0-141.385 114.615-256 256-256s256 114.615 256 256c0 141.385-114.615 256-256 256s-256-114.615-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sun",
						"brightness",
						"day",
						"lightness"
					],
					"defaultCode": 60630,
					"grid": 16
				},
				{
					"id": 102,
					"paths": [
						"M486.4 767.622c-126.834 0-230.022-103.187-230.022-230.022s103.189-230.022 230.022-230.022 230.022 103.189 230.022 230.022-103.189 230.022-230.022 230.022zM486.4 358.778c-98.603 0-178.822 80.219-178.822 178.822s80.219 178.822 178.822 178.822 178.822-80.219 178.822-178.822-80.219-178.822-178.822-178.822z",
						"M486.4 256c-14.138 0-25.6-11.462-25.6-25.6v-153.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v153.6c0 14.138-11.462 25.6-25.6 25.6z",
						"M486.4 1024c-14.138 0-25.6-11.461-25.6-25.6v-153.6c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v153.6c0 14.139-11.462 25.6-25.6 25.6z",
						"M179.2 563.2h-153.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h153.6c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M947.2 563.2h-153.6c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h153.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M230.4 307.2c-6.552 0-13.102-2.499-18.101-7.498l-102.4-102.4c-9.998-9.998-9.998-26.206 0-36.203s26.206-9.998 36.203 0l102.4 102.4c9.998 9.998 9.998 26.206 0 36.203-4.998 4.998-11.55 7.498-18.102 7.498z",
						"M128 921.6c-6.552 0-13.102-2.499-18.101-7.499-9.998-9.997-9.998-26.206 0-36.203l102.4-102.4c9.997-9.997 26.206-9.997 36.203 0s9.998 26.206 0 36.203l-102.4 102.4c-5 5-11.55 7.499-18.102 7.499z",
						"M844.8 921.6c-6.552 0-13.102-2.499-18.101-7.499l-102.4-102.4c-9.998-9.997-9.998-26.206 0-36.203 9.997-9.997 26.206-9.997 36.203 0l102.4 102.4c9.998 9.997 9.998 26.206 0 36.203-5 5-11.55 7.499-18.102 7.499z",
						"M742.4 307.2c-6.552 0-13.102-2.499-18.101-7.499-9.998-9.997-9.998-26.206 0-36.203l102.4-102.4c9.997-9.998 26.206-9.998 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-102.4 102.4c-5 5-11.55 7.499-18.102 7.499z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sun",
						"brightness",
						"weather"
					],
					"defaultCode": 59399,
					"grid": 20
				},
				{
					"id": 3259,
					"paths": [
						"M768 206v50h128v64h-192v-146l128-60v-50h-128v-64h192v146zM676 256h-136l-188 188-188-188h-136l256 256-256 256h136l188-188 188 188h136l-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"superscript",
						"wysiwyg"
					],
					"defaultCode": 61094,
					"grid": 16
				},
				{
					"id": 3261,
					"paths": [
						"M194.018 832l57.6-192h264.764l57.6 192h113.632l-192-640h-223.232l-192 640h113.636zM347.618 320h72.764l57.6 192h-187.964l57.6-192zM704 832l160-256 160 256h-320z",
						"M864 128h-64c-17.644 0-32-14.356-32-32s14.356-32 32-32h128c17.674 0 32-14.328 32-32s-14.326-32-32-32h-128c-52.936 0-96 43.066-96 96 0 24.568 9.288 47.002 24.524 64 17.588 19.624 43.11 32 71.476 32h64c17.644 0 32 14.356 32 32s-14.356 32-32 32h-128c-17.674 0-32 14.328-32 32s14.326 32 32 32h128c52.936 0 96-43.066 96-96 0-24.568-9.288-47.002-24.524-64-17.588-19.624-43.108-32-71.476-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"superscript",
						"wysiwyg"
					],
					"defaultCode": 61096,
					"grid": 16
				},
				{
					"id": 1446,
					"width": 879.4280090332031,
					"paths": [
						"M512.571 782.286v95.429h-141.714l-90.857-144-13.714-24q-4.571-5.143-6.286-12h-1.714l-5.143 12q-5.714 11.429-14.286 25.143l-88.571 142.857h-147.429v-95.429h73.143l112.571-166.286-105.714-155.429h-78.286v-96h157.714l79.429 130.286q1.143 2.286 13.143 24 4.571 5.143 6.286 12h1.714q1.714-5.143 6.286-12l14.286-24 80-130.286h146.857v96h-71.429l-105.143 152.571 116.571 169.143h62.286zM876.571 394.286v117.714h-293.714l-1.714-15.429q-2.286-16-2.286-26.286 0-36.571 14.857-66.857t37.143-49.429 48-37.143 48-31.143 37.143-30.857 14.857-36.571q0-21.714-16.857-35.714t-40.286-14q-29.143 0-55.429 22.286-8 6.286-20.571 21.714l-60-52.571q14.857-21.143 36-37.714 47.429-37.143 107.429-37.143 62.857 0 101.714 34t38.857 90.571q0 32-14 58.857t-35.429 43.714-46.571 33.429-46.857 28.857-37.429 29.429-17.429 36h132.571v-45.714h72z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"superscript"
					],
					"defaultCode": 61739,
					"grid": 14
				},
				{
					"id": 1150,
					"width": 1024,
					"paths": [
						"M384 364.128c0 52.288 18.432 103.232 51.904 143.392l11.648 13.984c26.848 32.224 48.512 68.16 64.416 106.432 15.936-38.272 37.568-74.208 64.416-106.432l11.648-13.984c33.536-40.16 51.968-91.072 51.968-143.392v-44.128h-256v44.128zM416 352h192v12.128c0 44.832-15.808 88.48-44.512 122.912l-11.648 13.984c-14.72 17.664-28.032 36.416-39.84 56.064-11.808-19.68-25.12-38.4-39.84-56.064l-11.648-13.984c-28.704-34.432-44.512-78.080-44.512-122.912v-12.128zM800 0h-576c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h32v172.128c0 82.176 28.96 162.208 81.6 225.344l11.648 13.984c43.040 51.68 66.752 117.152 66.752 184.384v44.16c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32v-44.16c0-67.232 23.712-132.704 66.752-184.384l11.648-13.984c52.608-63.136 81.6-143.168 81.6-225.344v-172.128h32c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM768 128h-512v-64h512v64zM704 364.128c0 67.232-23.712 132.704-66.752 184.384l-11.648 13.984c-52.64 63.136-81.6 143.168-81.6 225.344v76.16h-64v-76.16c0-82.176-28.96-162.208-81.6-225.344l-11.648-13.984c-43.040-51.648-66.752-117.12-66.752-184.384v-204.128h64v128h256v-128h64v204.128zM448 896h128v64h-128v-64zM416 160h192v96h-192v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"support",
						"aid",
						"walk",
						"injure"
					],
					"grid": 32
				},
				{
					"id": 3421,
					"paths": [
						"M928 416c-28.428 0-53.958 12.366-71.536 32h-189.956l134.318-134.318c26.312 1.456 53.11-7.854 73.21-27.956 37.49-37.49 37.49-98.274 0-135.764s-98.274-37.49-135.766 0c-20.102 20.102-29.41 46.898-27.956 73.21l-134.314 134.318v-189.954c19.634-17.578 32-43.108 32-71.536 0-53.020-42.98-96-96-96s-96 42.98-96 96c0 28.428 12.366 53.958 32 71.536v189.954l-134.318-134.318c1.454-26.312-7.856-53.11-27.958-73.21-37.49-37.49-98.274-37.49-135.764 0-37.49 37.492-37.49 98.274 0 135.764 20.102 20.102 46.898 29.412 73.212 27.956l134.32 134.318h-189.956c-17.578-19.634-43.108-32-71.536-32-53.020 0-96 42.98-96 96s42.98 96 96 96c28.428 0 53.958-12.366 71.536-32h189.956l-134.318 134.318c-26.314-1.456-53.11 7.854-73.212 27.956-37.49 37.492-37.49 98.276 0 135.766 37.492 37.49 98.274 37.49 135.764 0 20.102-20.102 29.412-46.898 27.958-73.21l134.316-134.32v189.956c-19.634 17.576-32 43.108-32 71.536 0 53.020 42.98 96 96 96s96-42.98 96-96c0-28.428-12.366-53.958-32-71.536v-189.956l134.318 134.318c-1.456 26.312 7.854 53.11 27.956 73.21 37.492 37.49 98.276 37.49 135.766 0s37.49-98.274 0-135.766c-20.102-20.102-46.898-29.41-73.21-27.956l-134.32-134.316h189.956c17.576 19.634 43.108 32 71.536 32 53.020 0 96-42.98 96-96s-42.982-96-96.002-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 61256,
					"grid": 16
				},
				{
					"id": 867,
					"width": 1024,
					"paths": [
						"M926.016 462.624c-35.136-38.080-85.76-78.624-142.016-78.624-78.688 0-146.208 79.168-175.872 120.096l-108.928-81.696c-5.92-4.448-12.576-6.464-19.072-6.464-16.576 0-32.128 13.12-32.128 32.064v160c0 18.944 15.552 32.064 32.128 32.064 6.496 0 13.152-2.016 19.072-6.464l108.928-81.696c29.664 40.896 97.184 120.096 175.872 120.096 56.256 0 106.88-40.544 142.016-78.624 34.112-36.992 34.112-93.76 0-130.752zM480 608v-160l106.656 80-106.656 80zM902.496 571.68c-28.768 31.168-72.672 68.32-118.496 68.32-62.432 0-124.608-70.24-153.792-112 29.184-41.728 91.36-112 153.792-112 45.824 0 89.728 37.152 118.496 68.32 22.976 24.896 22.976 62.464 0 87.36zM855.616 512c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM288.128 320.064c6.496 0 13.152-2.016 19.072-6.464l108.928-81.696c29.664 40.896 97.184 120.096 175.872 120.096 56.256 0 106.88-40.544 142.016-78.624 34.144-36.992 34.144-93.76 0-130.784-35.136-38.048-85.76-78.592-142.016-78.592-78.688 0-146.208 79.168-175.872 120.096l-108.928-81.696c-5.92-4.448-12.576-6.464-19.072-6.464-16.576 0-32.128 13.12-32.128 32.064v160c0 18.944 15.552 32.064 32.128 32.064zM592 96c45.824 0 89.728 37.152 118.496 68.32 22.976 24.896 22.976 62.464 0 87.392-28.768 31.136-72.672 68.288-118.496 68.288-62.432 0-124.608-70.24-153.792-112 29.184-41.728 91.328-112 153.792-112zM288 128l106.656 80-106.656 80v-160zM608 192c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM400 672c-78.688 0-146.208 79.168-175.872 120.096l-108.928-81.696c-5.92-4.448-12.576-6.464-19.072-6.464-16.576 0-32.128 13.12-32.128 32.064v160c0 18.944 15.552 32.064 32.128 32.064 6.496 0 13.152-2.016 19.072-6.464l108.928-81.696c29.664 40.896 97.184 120.096 175.872 120.096 56.256 0 106.88-40.544 142.016-78.624 34.144-36.992 34.144-93.76 0-130.784-35.136-38.048-85.76-78.592-142.016-78.592zM96 896v-160l106.656 80-106.656 80zM518.496 859.68c-28.768 31.168-72.672 68.32-118.496 68.32-62.432 0-124.608-70.24-153.792-112 29.184-41.728 91.328-112 153.792-112 45.824 0 89.728 37.152 118.496 68.32 22.976 24.896 22.976 62.464 0 87.36zM480 800c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"swim",
						"gather"
					],
					"grid": 32
				},
				{
					"id": 868,
					"width": 1024,
					"paths": [
						"M288.128 320.064c6.496 0 13.152-2.016 19.072-6.464l108.928-81.696c29.664 40.896 97.184 120.096 175.872 120.096 56.256 0 106.88-40.544 142.016-78.624 34.144-36.992 34.144-93.76 0-130.784-35.136-38.048-85.76-78.592-142.016-78.592-78.688 0-146.208 79.168-175.872 120.096l-108.928-81.696c-5.92-4.448-12.576-6.464-19.072-6.464-16.576 0-32.128 13.12-32.128 32.064v160c0 18.944 15.552 32.064 32.128 32.064zM640 160c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM926.016 462.624c-35.136-38.080-85.76-78.624-142.016-78.624-78.688 0-146.208 79.168-175.872 120.096l-108.928-81.696c-5.92-4.448-12.576-6.464-19.072-6.464-16.576 0-32.128 13.12-32.128 32.064v160c0 18.944 15.552 32.064 32.128 32.064 6.496 0 13.152-2.016 19.072-6.464l108.928-81.696c29.664 40.896 97.184 120.096 175.872 120.096 56.256 0 106.88-40.544 142.016-78.624 34.112-36.992 34.112-93.76 0-130.752zM823.616 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM400 672c-78.688 0-146.208 79.168-175.872 120.096l-108.928-81.696c-5.92-4.448-12.576-6.464-19.072-6.464-16.576 0-32.128 13.12-32.128 32.064v160c0 18.944 15.552 32.064 32.128 32.064 6.496 0 13.152-2.016 19.072-6.464l108.928-81.696c29.664 40.896 97.184 120.096 175.872 120.096 56.256 0 106.88-40.544 142.016-78.624 34.144-36.992 34.144-93.76 0-130.784-35.136-38.048-85.76-78.592-142.016-78.592zM448 832c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"swim",
						"gather"
					],
					"grid": 32
				},
				{
					"id": 1151,
					"width": 1024,
					"paths": [
						"M1024 512c0-282.304-229.696-512-512-512h-96c-85.728 0-167.328 25.792-237.408 74.784l-129.056-70.816c-12.992-7.168-29.216-4.448-39.2 6.624-9.92 11.008-10.976 27.424-2.496 39.648l78.24 112.864c-55.68 72.512-86.080 161.376-86.080 252.896 0 76.832 20.96 151.104 60.832 216.32-54.144 74.432-38.976 184.384-38.208 189.44 2.016 14.016 13.024 25.024 27.072 27.072 0.672 0.096 17.536 2.496 41.664 2.496 48.576 0 115.392-9.28 162.176-52.576 7.648 3.328 15.168 6.336 22.592 9.056 8.192 21.504 17.344 40.32 27.424 56.256-32.512 51.616-46.272 118.432-46.944 121.632-1.92 9.408 0.544 19.168 6.592 26.624 6.112 7.36 15.2 11.68 24.8 11.68h112c54.592 0 93.696-24.256 107.008-64h4.992c136 0 260.064-38.624 350.976-108.992 4.672 0.16 9.088 0.256 13.312 0.256 23.936 0 40.64-2.336 41.312-2.432 14.080-1.984 25.184-13.056 27.232-27.168 0.16-1.152 3.52-25.344 2.048-57.92 51.168-71.52 77.12-156.16 77.12-251.744zM352.288 242.72c-1.12 15.584-5.984 37.728-22.912 54.656-17.376 17.376-40.192 22.112-56.384 22.976l-135.136-194.944 214.432 117.312zM212.672 749.248c-33.12 33.12-90.208 38.048-121.312 38.048-2.464 0-4.832-0.032-7.136-0.064-0.736-32.928 3.584-90.24 36.256-126.112 27.296 32.864 60.16 60.768 96.864 83.040-1.504 1.696-3.008 3.392-4.672 5.088zM512 896h-32c-17.696 0-32 14.336-32 32 0 21.248-16.16 32-48 32h-70.112c8.352-25.184 21.056-55.424 37.696-75.648 9.76-11.808 9.76-28.896 0-40.704-10.24-12.416-20-30.016-28.736-51.424 24.928 5.088 50.72 7.776 77.152 7.776 101.152 0 192.896-39.424 261.472-103.328 0.192-0.096 0.448-0.192 0.64-0.288 11.392 25.28 29.664 51.168 54.016 75.52 21.152 21.152 48.672 33.024 75.904 39.648-78.24 54.464-181.888 84.448-296.032 84.448zM906.72 708.544c-6.816-26.080-18.592-52.192-38.848-72.416-32.672-32.672-68.256-55.68-101.28-63.968 21.312-47.744 33.408-100.48 33.408-156.16 0-8.832-7.168-16-16-16s-16 7.168-16 16h-0.096c0.032 0.352 0.064 0.832 0.096 1.088-0.16 54.752-13.248 106.4-35.808 152.608 0.032 0 0.064 0 0.096 0-8.8 18.336-3.296 30.336 8.8 30.912 28.768 1.408 67.744 21.728 104.16 58.144 25.664 25.664 34.528 64.992 37.12 97.472 0 0.16-0.064 0.32-0.064 0.48 0.896 11.296 1.056 21.728 0.832 30.464-7.808 0.128-17.024 0.032-27.008-0.64-31.776-2.144-74.432-10.336-101.408-37.28-28.032-28.032-46.208-57.984-54.912-83.2-4.352-12.544-22.464-14.016-32.928-3.36 0-0.064-0.064-0.128-0.096-0.16-63.872 64.992-152.64 105.472-250.784 105.472-46.592 0-91.008-9.312-131.776-25.824-6.72-2.816-13.664-5.984-20.768-9.44-117.792-56.96-199.456-177.344-199.456-316.736 0-81.696 28.928-160.768 81.152-223.872l101.536 146.464c6.048 8.736 15.872 13.824 26.4 13.824 0.608 0 1.216-0.032 1.856-0.064 19.968-1.152 51.968-7.264 77.056-32.352 24.256-24.256 30.784-54.944 32.224-75.008 0.896-12.384-5.696-24-16.608-29.984l-155.36-85.248c59.968-42.88 130.016-65.76 203.744-65.76h96c247.040 0 448 200.96 448 448 0 73.952-17.952 139.904-53.28 196.544zM288 560c0 8.832-7.168 16-16 16h-64c-8.832 0-16-7.168-16-16s7.168-16 16-16h64c8.832 0 16 7.168 16 16zM512 560c0 8.832-7.168 16-16 16h-64c-8.832 0-16-7.168-16-16s7.168-16 16-16h64c8.832 0 16 7.168 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"swim"
					],
					"grid": 32
				},
				{
					"id": 2656,
					"paths": [
						"M640 146.588v135.958c36.206 15.804 69.5 38.408 98.274 67.18 60.442 60.44 93.726 140.8 93.726 226.274s-33.286 165.834-93.726 226.274c-60.44 60.44-140.798 93.726-226.274 93.726s-165.834-33.286-226.274-93.726c-60.44-60.44-93.726-140.8-93.726-226.274s33.286-165.834 93.726-226.274c28.774-28.774 62.068-51.378 98.274-67.182v-135.956c-185.048 55.080-320 226.472-320 429.412 0 247.424 200.578 448 448 448 247.424 0 448-200.576 448-448 0-202.94-134.95-374.332-320-429.412zM448 0h128v512h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"switch"
					],
					"defaultCode": 60491,
					"grid": 16
				},
				{
					"id": 2657,
					"paths": [
						"M640 480c0 17.6-14.4 32-32 32h-192c-17.6 0-32-14.4-32-32v-192c0-17.6 14.4-32 32-32h192c17.6 0 32 14.4 32 32v192z",
						"M960 0h-896c-35.2 0-64 28.8-64 64v896c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-896c0-35.2-28.8-64-64-64zM128 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM128 192c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM704 800c0 17.674-14.326 32-32 32h-320c-17.672 0-32-14.326-32-32v-576c0-17.672 14.328-32 32-32h320c17.674 0 32 14.328 32 32v576zM896 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM896 192c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"switch"
					],
					"defaultCode": 60492,
					"grid": 16
				},
				{
					"id": 869,
					"width": 1024,
					"paths": [
						"M704 64h-384c-53.024 0-96 42.976-96 96v704c0 53.024 42.976 96 96 96h384c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM768 864c0 35.296-28.704 64-64 64h-384c-35.296 0-64-28.704-64-64v-704c0-35.296 28.704-64 64-64h384c35.296 0 64 28.704 64 64v704zM608 288h-192c-17.664 0-32 14.336-32 32v384c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-384c0-17.664-14.336-32-32-32zM608 320v128h-192v-128h192zM416 704v-224h192v224h-192zM544 832c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM480 192c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"switch",
						"light",
						"control",
						"flip"
					],
					"grid": 32
				},
				{
					"id": 870,
					"width": 1024,
					"paths": [
						"M416 480h192v224h-192v-224zM416 448h192v-128h-192v128zM800 160v704c0 53.024-42.976 96-96 96h-384c-53.024 0-96-42.976-96-96v-704c0-53.024 42.976-96 96-96h384c53.024 0 96 42.976 96 96zM480 192c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32s-32 14.336-32 32zM544 832c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM640 320c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v384c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"switch",
						"light",
						"control",
						"flip"
					],
					"grid": 32
				},
				{
					"id": 1152,
					"width": 1024,
					"paths": [
						"M605.376 73.664c-10.080-42.208-48.128-73.664-93.376-73.664s-83.296 31.456-93.376 73.664c-222.112 43.968-386.624 241.824-386.624 470.336 0 264.672 215.328 480 480 480s480-215.328 480-480c0-228.512-164.512-426.368-386.624-470.336zM480 96c0-17.632 14.368-32 32-32s32 14.368 32 32v224c0 17.632-14.368 32-32 32s-32-14.368-32-32v-224zM512 384c35.36 0 64-28.64 64-64v-89.472c146.048 29.664 256 158.656 256 313.472 0 176.736-143.264 320-320 320s-320-143.264-320-320c0-154.816 109.952-283.808 256-313.472v89.472c0 35.36 28.64 64 64 64zM512 960c-229.376 0-416-186.624-416-416 0-203.744 151.040-379.232 352-410.368v64.448c-163.616 30.176-288 173.696-288 345.92 0 194.080 157.92 352 352 352s352-157.92 352-352c0-172.224-124.384-315.744-288-345.92v-64.448c200.96 31.136 352 206.624 352 410.368 0 229.376-186.624 416-416 416z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"switch",
						"sleep"
					],
					"grid": 32
				},
				{
					"id": 2640,
					"paths": [
						"M1005.254 914.746l-201.372-201.37 146.746-146.746c12.498-12.496 12.498-32.758 0-45.254l-64-64c-12.496-12.496-32.758-12.496-45.254 0l-105.374 105.37-553.372-553.374c-6.002-6-14.14-9.372-22.628-9.372h-128c-17.672 0-32 14.328-32 32v128c0 8.488 3.372 16.626 9.372 22.628l553.374 553.372-105.376 105.374c-12.496 12.496-12.496 32.76 0 45.256l64 64c6.252 6.246 14.442 9.37 22.63 9.37s16.376-3.124 22.624-9.376l146.746-146.746 201.376 201.376c24.99 24.994 65.516 24.994 90.508 0s24.992-65.516 0-90.508zM608 704l-560-560 32-32 560 560-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sword",
						"weapon",
						"war"
					],
					"defaultCode": 60475,
					"grid": 16
				},
				{
					"id": 193,
					"paths": [
						"M1016.501 442.698c-9.997-9.997-26.206-9.997-36.203 0l-58.832 58.832c-2.63-105.486-44.947-204.27-119.835-279.16-77.362-77.365-180.222-119.97-289.63-119.97-152.28 0-291.122 83.699-362.342 218.435-6.606 12.499-1.83 27.989 10.669 34.597 12.498 6.606 27.989 1.83 34.597-10.669 62.33-117.914 183.826-191.163 317.077-191.163 194.014 0 352.501 154.966 358.224 347.619l-58.522-58.522c-9.997-9.997-26.206-9.997-36.203 0-9.998 9.998-9.998 26.206 0 36.205l102.4 102.4c4.998 4.998 11.549 7.498 18.101 7.498s13.102-2.499 18.101-7.499l102.4-102.4c9.998-9.997 9.998-26.205 0-36.203z",
						"M863.674 668.566c-12.502-6.603-27.99-1.832-34.597 10.669-62.328 117.915-183.826 191.165-317.077 191.165-194.016 0-352.502-154.966-358.224-347.621l58.522 58.522c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.102-7.499c9.997-9.997 9.997-26.206 0-36.203l-102.4-102.4c-9.998-9.997-26.206-9.997-36.205 0l-102.4 102.4c-9.997 9.997-9.997 26.206 0 36.203s26.206 9.997 36.205 0l58.83-58.832c2.63 105.488 44.946 204.272 119.835 279.162 77.365 77.363 180.224 119.97 289.632 119.97 152.28 0 291.12-83.699 362.342-218.435 6.608-12.501 1.829-27.99-10.669-34.598z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sync",
						"spinner",
						"loading",
						"arrows"
					],
					"defaultCode": 59490,
					"grid": 20
				},
				{
					"id": 871,
					"width": 1024,
					"paths": [
						"M768 320c0-141.376-114.624-256-256-256-119.712 0-219.936 82.304-247.936 193.312-112.448 11.968-200.064 107.072-200.064 222.688 0 117.888 91.136 214.304 206.752 223.136l448.448 0.64c-8.096 107.328-97.824 192.224-207.2 192.224-73.344 0-137.536-38.464-174.56-96h62.56c8.832 0 16-7.168 16-16s-7.168-16-16-16h-112v112c0 8.832 7.168 16 16 16s16-7.168 16-16v-49.152c43.712 58.72 113.152 97.152 192 97.152 127.2 0 231.040-99.040 239.2-224.192l20.128 0.032c104.48-1.792 188.672-86.912 188.672-191.84 0-106.048-85.952-192-192-192zM760.864 672h-456.064c8.224-107.232 97.888-192 207.2-192 73.376 0 137.632 38.432 174.624 96h-62.624c-8.832 0-16 7.168-16 16s7.168 16 16 16h112v-112c0-8.832-7.168-16-16-16s-16 7.168-16 16v48.992c-43.712-58.656-113.184-96.992-192-96.992-126.752 0-230.304 98.336-239.136 222.88-73.568-5.664-140.064-51.424-164.736-121.568-44.512-126.528 39.264-247.392 159.328-260.16l22.176-2.368 3.776-14.944c22.656-89.792 95.552-161.216 187.296-173.696 137.376-18.72 255.296 88.064 255.296 221.856v32h32c93.504 0 168.512 80.608 159.232 175.968-8.128 83.136-82.848 144.032-166.368 144.032z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sync",
						"save",
						"commit"
					],
					"grid": 32
				},
				{
					"id": 872,
					"width": 1024,
					"paths": [
						"M960 512c0 104.928-84.192 190.048-188.672 191.84l-20.128-0.032c-8.16 125.152-112 224.192-239.2 224.192-78.848 0-148.288-38.432-192-97.152v49.152c0 8.832-7.168 16-16 16s-16-7.168-16-16v-112h112c8.832 0 16 7.168 16 16s-7.168 16-16 16h-62.56c37.024 57.536 101.184 96 174.56 96 109.376 0 199.104-84.896 207.2-192.256l-414.304-0.576c-0.416-5.024-0.896-10.048-0.896-15.168 0-114.688 93.312-208 208-208 73.344 0 137.536 38.464 174.528 96h-62.528c-8.832 0-16 7.168-16 16s7.168 16 16 16h112v-112c0-8.832-7.168-16-16-16s-16 7.168-16 16v48.896c-43.712-58.656-113.216-96.896-192-96.896-132.544 0-240 107.456-240 240 0 5.12 0.32 10.112 0.704 15.136h-1.952c-115.616-8.832-206.752-105.248-206.752-223.136 0-115.616 87.616-210.72 200.064-222.688 28-111.008 128.224-193.312 247.936-193.312 141.376 0 256 114.624 256 256 106.048 0 192 85.952 192 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sync",
						"save",
						"commit"
					],
					"grid": 32
				},
				{
					"id": 1153,
					"width": 1024,
					"paths": [
						"M512 0c-141.376 0-269.376 57.312-362.048 149.952l-95.328-95.328c-6.528-6.528-14.528-9.44-22.4-9.44-16.448 0-32.224 12.768-32.224 32.064 0 0 0 413.024 0 434.752 0 282.784 229.216 512 512 512 141.376 0 269.376-57.312 362.048-149.952l95.328 95.328c6.528 6.528 14.528 9.44 22.4 9.44 16.448 0 32.224-12.768 32.224-32.064v-370.752c0 0 0-42.272 0-64 0-282.784-229.216-512-512-512zM874.048 783.52l-45.248 45.28c-84.64 84.608-197.12 131.2-316.8 131.2-247.040 0-448-200.96-448-448v-64h64v64c0 212.064 171.936 384 384 384 130.080 0 244.864-64.864 314.304-163.808l-124.192-124.192h257.888v261.504l-85.952-85.984zM373.024 421.888l-132.704-132.704c64.608-78.624 162.208-129.184 271.68-129.184 194.080 0 352 157.92 352 352v64h-202.208c-13.632 0-20.448 16.48-10.816 26.112l132.704 132.704c-64.608 78.624-162.208 129.184-271.68 129.184-194.080 0-352-157.92-352-352v-64h202.208c13.632 0 20.448-16.48 10.816-26.112zM896 576v-64c0-212.064-171.936-384-384-384-130.112 0-244.896 64.864-314.336 163.84l124.224 124.16h-257.888v-261.504l85.952 85.952 45.28-45.248c84.608-84.608 197.088-131.2 316.768-131.2 247.040 0 448 200.96 448 448v64h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"sync",
						"refresh",
						"update",
						"synchronize"
					],
					"grid": 32
				},
				{
					"id": 2447,
					"paths": [
						"M992 384l32-128-256-256-128 32 63.030 63.030-104.402 104.402-143.030-143.030-79.196 79.196 96.37 96.37c-2.090 1.622-4.11 3.372-6.026 5.288l-357.492 357.49c-24.89 24.888-24.89 65.62 0 90.508l18.746 18.746v64l41.374 41.374-169.374 169.372 45.254 45.254 169.374-169.374 41.372 41.374h64l18.746 18.746c12.446 12.446 28.85 18.666 45.254 18.666s32.81-6.22 45.254-18.666l357.492-357.492c1.916-1.916 3.666-3.936 5.288-6.026l96.37 96.37 79.196-79.196-143.030-143.030 104.402-104.402 63.028 63.030zM246.68 536.516l1.834-1.836 254.968 226.64-30.164 30.164-226.638-254.968zM471.484 793.32l-30.164 30.164-226.64-254.968 1.834-1.836 254.97 226.64zM278.68 504.516l1.834-1.834 254.968 226.64-30.164 30.164-226.638-254.97zM310.68 472.516l1.834-1.834 254.968 226.64-30.164 30.164-226.638-254.97zM342.68 440.516l1.834-1.834 254.968 226.64-30.164 30.164-226.638-254.97zM374.68 408.516l1.834-1.834 254.968 226.64-30.164 30.164-226.638-254.97zM406.68 376.516l1.834-1.834 254.968 226.64-30.164 30.164-226.638-254.97zM438.68 344.516l1.836-1.836 254.968 226.64-30.164 30.164-226.64-254.968zM470.68 312.516l1.836-1.836 254.968 226.64-30.164 30.164-226.64-254.968zM384 877.412c-1.548 0-3.786-0.392-5.656-2.264l-229.492-229.494c-1.872-1.872-2.264-4.108-2.264-5.654s0.392-3.784 2.266-5.656l3.664-3.664 254.968 226.64-17.826 17.826c-1.874 1.874-4.112 2.266-5.66 2.266zM409.32 855.484l-226.64-254.968 1.834-1.836 254.968 226.64-30.162 30.164zM747.148 517.656l-17.828 17.828-226.64-254.968 3.664-3.664c1.874-1.872 4.11-2.266 5.658-2.266s3.784 0.392 5.656 2.266l229.49 229.49c3.012 3.014 3.014 8.3 0 11.314zM790.626 391.432l-158.058-158.058 104.402-104.402 158.058 158.058-104.402 104.402z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"syringe",
						"health",
						"inject",
						"shot",
						"anti-virus",
						"medicine",
						"vaccine",
						"dualtone"
					],
					"defaultCode": 60282,
					"grid": 16
				},
				{
					"id": 2448,
					"paths": [
						"M992 384l32-128-256-256-128 32 63.030 63.030-104.402 104.402-143.030-143.030-79.196 79.196 96.37 96.37c-2.090 1.622-4.11 3.372-6.026 5.288l-357.492 357.49c-24.89 24.888-24.89 65.62 0 90.508l18.746 18.746v64l41.374 41.374-169.374 169.372 45.254 45.254 169.374-169.374 41.372 41.374h64l18.746 18.746c12.446 12.446 28.85 18.666 45.254 18.666s32.81-6.22 45.254-18.666l357.492-357.492c1.916-1.916 3.666-3.936 5.288-6.026l96.37 96.37 79.196-79.196-143.030-143.030 104.402-104.402 63.028 63.030zM747.148 517.656l-357.49 357.49c-1.874 1.874-4.11 2.266-5.658 2.266s-3.786-0.392-5.656-2.264l-229.492-229.494c-1.872-1.872-2.264-4.108-2.264-5.654s0.392-3.784 2.266-5.656l357.49-357.492c1.874-1.872 4.11-2.266 5.658-2.266s3.784 0.392 5.656 2.266l229.49 229.49c3.012 3.014 3.014 8.3 0 11.314zM790.626 391.432l-158.058-158.058 104.402-104.402 158.058 158.058-104.402 104.402zM399.028 752.978l-128-128 33.94-33.94 128 127.998zM591.028 560.978l-127.998-128 33.94-33.94 128 127.998zM495.028 656.978l-128-128 33.942-33.94 127.998 127.998z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"syringe",
						"health",
						"inject",
						"shot",
						"anti-virus",
						"medicine",
						"vaccine"
					],
					"defaultCode": 60283,
					"grid": 16
				},
				{
					"id": 3162,
					"paths": [
						"M960 0h64v512h-64v-512z",
						"M0 512h64v512h-64v-512z",
						"M320 704h704v128h-704v160l-224-224 224-224v160z",
						"M704 320h-704v-128h704v-160l224 224-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tab",
						"arrows"
					],
					"defaultCode": 60997,
					"grid": 16
				},
				{
					"id": 3267,
					"paths": [
						"M0 192v704h1024v-704h-1024zM384 640v-128h256v128h-256zM640 704v128h-256v-128h256zM640 320v128h-256v-128h256zM320 320v128h-256v-128h256zM64 512h256v128h-256v-128zM704 512h256v128h-256v-128zM704 448v-128h256v128h-256zM64 704h256v128h-256v-128zM704 832v-128h256v128h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"table",
						"wysiwyg"
					],
					"defaultCode": 61102,
					"grid": 16
				},
				{
					"id": 3268,
					"paths": [
						"M0 64v896h1024v-896h-1024zM384 640v-192h256v192h-256zM640 704v192h-256v-192h256zM640 192v192h-256v-192h256zM320 192v192h-256v-192h256zM64 448h256v192h-256v-192zM704 448h256v192h-256v-192zM704 384v-192h256v192h-256zM64 704h256v192h-256v-192zM704 896v-192h256v192h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"table",
						"wysiwyg"
					],
					"defaultCode": 61103,
					"grid": 16
				},
				{
					"id": 1361,
					"width": 950.8579902648926,
					"paths": [
						"M292.571 786.286v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM292.571 566.857v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM585.143 786.286v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM292.571 347.429v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM585.143 566.857v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM877.714 786.286v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM585.143 347.429v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM877.714 566.857v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM877.714 347.429v-109.714q0-8-5.143-13.143t-13.143-5.143h-182.857q-8 0-13.143 5.143t-5.143 13.143v109.714q0 8 5.143 13.143t13.143 5.143h182.857q8 0 13.143-5.143t5.143-13.143zM950.857 164.571v621.714q0 37.714-26.857 64.571t-64.571 26.857h-768q-37.714 0-64.571-26.857t-26.857-64.571v-621.714q0-37.714 26.857-64.571t64.571-26.857h768q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"table"
					],
					"defaultCode": 61646,
					"grid": 14
				},
				{
					"id": 2191,
					"paths": [
						"M800 0h-640c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h640c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM480 992c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.328 32-32 32zM768 896h-576v-768h576v768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tablet",
						"mobile"
					],
					"defaultCode": 60026,
					"grid": 16
				},
				{
					"id": 1417,
					"width": 658.2870674133301,
					"paths": [
						"M365.714 804.571q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM585.143 713.143v-548.571q0-7.429-5.429-12.857t-12.857-5.429h-475.429q-7.429 0-12.857 5.429t-5.429 12.857v548.571q0 7.429 5.429 12.857t12.857 5.429h475.429q7.429 0 12.857-5.429t5.429-12.857zM658.286 164.571v621.714q0 37.714-26.857 64.571t-64.571 26.857h-475.429q-37.714 0-64.571-26.857t-26.857-64.571v-621.714q0-37.714 26.857-64.571t64.571-26.857h475.429q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tablet"
					],
					"defaultCode": 61706,
					"grid": 14
				},
				{
					"id": 154,
					"paths": [
						"M844.8 1024h-665.6c-42.347 0-76.8-34.451-76.8-76.8v-870.4c0-42.347 34.453-76.8 76.8-76.8h665.6c42.349 0 76.8 34.453 76.8 76.8v870.4c0 42.349-34.451 76.8-76.8 76.8zM179.2 51.2c-14.115 0-25.6 11.485-25.6 25.6v870.4c0 14.115 11.485 25.6 25.6 25.6h665.6c14.115 0 25.6-11.485 25.6-25.6v-870.4c0-14.115-11.485-25.6-25.6-25.6h-665.6z",
						"M537.6 921.6h-51.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h51.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M793.6 819.2h-563.2c-14.138 0-25.6-11.461-25.6-25.6v-665.6c0-14.138 11.462-25.6 25.6-25.6h563.2c14.139 0 25.6 11.462 25.6 25.6v665.6c0 14.139-11.461 25.6-25.6 25.6zM256 768h512v-614.4h-512v614.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tablet",
						"mobile"
					],
					"defaultCode": 59451,
					"grid": 20
				},
				{
					"id": 1219,
					"width": 865.7139930725098,
					"paths": [
						"M256 256q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM865.714 585.143q0 30.286-21.143 51.429l-280.571 281.143q-22.286 21.143-52 21.143-30.286 0-51.429-21.143l-408.571-409.143q-21.714-21.143-36.857-57.714t-15.143-66.857v-237.714q0-29.714 21.714-51.429t51.429-21.714h237.714q30.286 0 66.857 15.143t58.286 36.857l408.571 408q21.143 22.286 21.143 52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tag"
					],
					"defaultCode": 61483,
					"grid": 14
				},
				{
					"id": 142,
					"paths": [
						"M384 977.13c-20.554 0-39.84-7.966-54.306-22.43l-260.394-260.395c-14.466-14.464-22.432-33.75-22.432-54.304s7.966-39.84 22.434-54.306l439.594-439.592c24.91-24.914 70.269-43.702 105.504-43.702h230.4c42.349 0 76.8 34.453 76.8 76.8v230.4c0 35.232-18.787 80.59-43.699 105.504l-439.595 439.595c-14.466 14.466-33.752 22.43-54.306 22.43zM614.4 153.6c-21.246 0-54.278 13.682-69.299 28.704l-439.595 439.595c-4.795 4.795-7.435 11.224-7.435 18.101s2.64 13.306 7.435 18.099l260.394 260.397c4.795 4.794 11.224 7.434 18.101 7.434s13.307-2.64 18.102-7.435l439.594-439.592c15.021-15.024 28.704-48.058 28.704-69.302v-230.4c0-14.115-11.485-25.6-25.6-25.6h-230.4z",
						"M742.4 358.4c-42.349 0-76.8-34.453-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.451 76.8-76.8 76.8zM742.4 256c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tag",
						"price"
					],
					"defaultCode": 59439,
					"grid": 20
				},
				{
					"id": 873,
					"width": 1024,
					"paths": [
						"M924.096 540.096l-448-448c-17.984-17.984-42.4-28.096-67.872-28.096h-248.224c-53.024 0-96 42.976-96 96v248.224c0 25.472 10.112 49.888 28.128 67.872l448 448c37.504 37.504 98.272 37.504 135.776 0l248.224-248.224c37.472-37.504 37.472-98.272-0.032-135.776zM901.472 653.248l-248.224 248.224c-24.992 24.992-65.504 24.992-90.496 0l-448-448c-12-12-18.752-28.256-18.752-45.248v-248.224c0-35.36 28.64-64 64-64h248.224c16.96 0 33.248 6.752 45.248 18.752l448 448c24.992 24.992 24.992 65.504 0 90.496zM470.624 384l169.376 169.376c6.24 6.24 6.24 16.384 0 22.624v0c-6.24 6.24-16.384 6.24-22.624 0l-169.376-169.376c-6.24-6.24-6.24-16.384 0-22.624v0c6.24-6.24 16.384-6.24 22.624 0zM406.624 448l169.376 169.376c6.24 6.24 6.24 16.384 0 22.624v0c-6.24 6.24-16.384 6.24-22.624 0l-169.376-169.376c-6.24-6.24-6.24-16.384 0-22.624v0c6.24-6.24 16.384-6.24 22.624 0zM224 160c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM224 256c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tag",
						"label",
						"mark",
						"identify"
					],
					"grid": 32
				},
				{
					"id": 874,
					"width": 1024,
					"paths": [
						"M924.096 540.096l-448-448c-17.984-17.984-42.4-28.096-67.872-28.096h-248.224c-53.024 0-96 42.976-96 96v248.224c0 25.472 10.112 49.888 28.128 67.872l448 448c37.504 37.504 98.272 37.504 135.776 0l248.224-248.224c37.472-37.504 37.472-98.272-0.032-135.776zM224 288c-35.36 0-64-28.64-64-64s28.64-64 64-64c35.36 0 64 28.64 64 64s-28.64 64-64 64zM576 640c-6.24 6.24-16.384 6.24-22.624 0l-169.376-169.376c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l169.376 169.376c6.24 6.24 6.24 16.384 0 22.624zM640 576c-6.24 6.24-16.384 6.24-22.624 0l-169.376-169.376c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l169.376 169.376c6.24 6.24 6.24 16.384 0 22.624zM256 224c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tag",
						"label",
						"mark",
						"identify"
					],
					"grid": 32
				},
				{
					"id": 1154,
					"width": 1024,
					"paths": [
						"M992 0h-434.752c-8.48 0-16.64 3.36-22.624 9.376l-512 512c-12.512 12.512-12.512 32.768 0 45.248l434.752 434.752c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376l512-512c6.016-6.016 9.376-14.144 9.376-22.624v-434.752c0-17.664-14.336-32-32-32zM960 453.504l-480 480-389.504-389.504 480-480h389.504v389.504zM832 256c35.36 0 64-28.64 64-64s-28.64-64-64-64-64 28.64-64 64 28.64 64 64 64zM832 160c17.632 0 32 14.368 32 32s-14.368 32-32 32-32-14.368-32-32 14.368-32 32-32zM340.672 532.672l256-256 22.624 22.624-256 256-22.624-22.624zM404.672 596.672l256-256 22.624 22.624-256 256-22.624-22.624zM468.672 660.672l256-256 22.624 22.624-256 256-22.624-22.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tag",
						"label",
						"mark",
						"identify"
					],
					"grid": 32
				},
				{
					"id": 1220,
					"width": 1085.1428871154785,
					"paths": [
						"M256 256q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM865.714 585.143q0 30.286-21.143 51.429l-280.571 281.143q-22.286 21.143-52 21.143-30.286 0-51.429-21.143l-408.571-409.143q-21.714-21.143-36.857-57.714t-15.143-66.857v-237.714q0-29.714 21.714-51.429t51.429-21.714h237.714q30.286 0 66.857 15.143t58.286 36.857l408.571 408q21.143 22.286 21.143 52zM1085.143 585.143q0 30.286-21.143 51.429l-280.571 281.143q-22.286 21.143-52 21.143-20.571 0-33.714-8t-30.286-25.714l268.571-268.571q21.143-21.143 21.143-51.429 0-29.714-21.143-52l-408.571-408q-21.714-21.714-58.286-36.857t-66.857-15.143h128q30.286 0 66.857 15.143t58.286 36.857l408.571 408q21.143 22.286 21.143 52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tags"
					],
					"defaultCode": 61484,
					"grid": 14
				},
				{
					"id": 1895,
					"paths": [
						"M800 320c-123.71 0-224 100.288-224 224 0 34.358 7.746 66.902 21.57 96h-171.14c13.826-29.098 21.57-61.642 21.57-96 0-123.712-100.288-224-224-224s-224 100.288-224 224c0 123.71 100.288 224 224 224h576c123.71 0 224-100.29 224-224 0-123.712-100.288-224-224-224zM128 544c0-53.020 42.98-96 96-96s96 42.98 96 96-42.98 96-96 96-96-42.98-96-96zM800 640c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tape"
					],
					"defaultCode": 59730,
					"grid": 16
				},
				{
					"id": 875,
					"width": 1024,
					"paths": [
						"M384 416c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM384 512c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM992 416h-11.424c-103.456 0-204.672-19.424-300.832-57.632-22.048-53.44-58.208-99.296-103.744-133.6v-57.856c0-11.776-6.304-22.912-16.768-28.32-52.544-27.072-112.032-42.592-175.232-42.592-1.12 0-2.24 0-3.36 0-202.944 1.792-373.728 168.16-380.416 370.976-5.728 172.736 102.88 320.608 255.776 374.72v22.304c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-1.664c10.592 0.896 21.184 1.664 32 1.664h256c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-12.576c165.536-42.688 288-192.544 288-371.424v-32c0-17.664-14.336-32-32-32zM957.216 447.456c-15.040 91.040-93.92 160.544-189.216 160.544-29.984 0-58.24-7.072-83.488-19.296 12.32-34.016 19.488-70.464 19.488-108.704 0-28.544-3.904-56.16-10.944-82.496 85.056 30.752 173.696 47.488 264.16 49.952zM654.848 382.304l-0.224 0.544 0.544 0.224c10.88 30.304 16.832 62.912 16.832 96.928 0 32.256-5.792 63.040-15.648 92-48.576-34.848-80.352-91.648-80.352-156v-149.728c34.976 31.424 62.496 70.976 78.848 116.032zM992 480c0 194.080-157.92 352-352 352h-256c-96.224 0-186.080-38.112-252.992-107.264-66.88-69.152-101.984-160.32-98.784-256.704 6.112-185.856 162.56-338.4 348.704-340.032h3.072c56.288 0 110.304 13.152 160 38.912v249.088c0 123.52 100.48 224 224 224 112.64 0 206.144-83.584 221.728-192h2.272v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tape",
						"attach",
						"stick"
					],
					"grid": 32
				},
				{
					"id": 876,
					"width": 1024,
					"paths": [
						"M992 416h-11.424c-103.456 0-204.672-19.424-300.832-57.632-16.576-40.192-41.184-76.096-71.744-106.048v163.68c0 61.504 35.264 114.368 86.272 141.152 7.424-25.024 9.728-45.92 9.728-77.152 0-28.544-3.904-56.16-10.944-82.496 85.056 30.752 173.696 47.488 264.128 49.952-15.008 91.040-93.888 160.544-189.184 160.544-106.048 0-192-85.952-192-192v-249.088c0-11.776-6.304-22.912-16.768-28.32-52.544-27.072-112.032-42.592-175.232-42.592-1.12 0-2.24 0-3.36 0-202.944 1.792-373.728 168.16-380.416 370.976-5.728 172.736 102.88 320.608 255.776 374.72v22.304c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-1.664c10.592 0.896 21.184 1.664 32 1.664h256c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-12.576c165.536-42.688 288-192.544 288-371.424v-32c0-17.664-14.336-32-32-32zM384 544c-35.36 0-64-28.64-64-64s28.64-64 64-64 64 28.64 64 64c0 35.36-28.64 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tape",
						"attach",
						"stick"
					],
					"grid": 32
				},
				{
					"id": 2624,
					"paths": [
						"M512 0c-282.312 0-512 229.676-512 512.002 0 282.322 229.688 511.998 512 511.998 282.31 0 512-229.676 512-511.998 0-282.326-229.688-512.002-512-512.002zM512 910.222c-219.578 0-398.22-178.646-398.22-398.22 0-219.58 178.644-398.224 398.22-398.224s398.22 178.644 398.22 398.224c0.006 219.574-178.644 398.22-398.22 398.22zM512 227.554c-156.844 0-284.448 127.602-284.448 284.448 0 156.842 127.602 284.448 284.448 284.448s284.446-127.606 284.446-284.448c0-156.846-127.6-284.448-284.446-284.448zM512 682.668c-94.116 0-170.668-76.554-170.668-170.666 0-94.116 76.552-170.67 170.668-170.67 94.112 0 170.67 76.554 170.67 170.67 0 94.112-76.558 170.666-170.67 170.666zM448 512c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"target",
						"goal",
						"bullseye"
					],
					"defaultCode": 60459,
					"grid": 16
				},
				{
					"id": 2625,
					"paths": [
						"M1024 448h-100.924c-27.64-178.24-168.836-319.436-347.076-347.076v-100.924h-128v100.924c-178.24 27.64-319.436 168.836-347.076 347.076h-100.924v128h100.924c27.64 178.24 168.836 319.436 347.076 347.076v100.924h128v-100.924c178.24-27.64 319.436-168.836 347.076-347.076h100.924v-128zM792.822 448h-99.762c-19.284-54.55-62.51-97.778-117.060-117.060v-99.762c107.514 24.49 192.332 109.31 216.822 216.822zM512 576c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.346 0 64 28.654 64 64s-28.654 64-64 64zM448 231.178v99.762c-54.55 19.282-97.778 62.51-117.060 117.060h-99.762c24.49-107.512 109.31-192.332 216.822-216.822zM231.178 576h99.762c19.282 54.55 62.51 97.778 117.060 117.060v99.762c-107.512-24.49-192.332-109.308-216.822-216.822zM576 792.822v-99.762c54.55-19.284 97.778-62.51 117.060-117.060h99.762c-24.49 107.514-109.308 192.332-216.822 216.822z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"target",
						"goal",
						"location",
						"spot"
					],
					"defaultCode": 60460,
					"grid": 16
				},
				{
					"id": 2626,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM783.53 783.53c-57.21 57.208-129.296 94.122-207.53 107.174v-186.704h-128v186.704c-78.234-13.050-150.32-49.964-207.53-107.174-57.206-57.21-94.122-129.296-107.172-207.53h186.702v-128h-186.702c13.050-78.234 49.966-150.32 107.174-207.53 57.208-57.208 129.294-94.122 207.528-107.174v186.704h128v-186.704c78.234 13.050 150.32 49.966 207.53 107.174 57.208 57.208 94.124 129.294 107.174 207.53h-186.704v128h186.704c-13.052 78.234-49.966 150.32-107.174 207.53z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"target",
						"goal",
						"location",
						"spot"
					],
					"defaultCode": 60461,
					"grid": 16
				},
				{
					"id": 877,
					"width": 1024,
					"paths": [
						"M992 496h-32.8c-8.32-234.592-196.608-422.88-431.2-431.2v-32.8c0-8.832-7.168-16-16-16s-16 7.168-16 16v32.8c-234.592 8.32-422.88 196.608-431.2 431.2h-32.8c-8.832 0-16 7.168-16 16s7.168 16 16 16h32.8c8.32 234.592 196.608 422.88 431.2 431.2v32.8c0 8.832 7.168 16 16 16s16-7.168 16-16v-32.8c234.592-8.32 422.88-196.608 431.2-431.2h32.8c8.832 0 16-7.168 16-16s-7.168-16-16-16zM528 927.2v-31.2c0-8.832-7.168-16-16-16s-16 7.168-16 16v31.2c-216.576-8.32-390.88-182.624-399.2-399.2h31.2c8.832 0 16-7.168 16-16s-7.168-16-16-16h-31.2c8.32-216.576 182.624-390.88 399.2-399.2v31.2c0 8.832 7.168 16 16 16s16-7.168 16-16v-31.2c216.576 8.32 390.88 182.624 399.2 399.2h-31.2c-8.832 0-16 7.168-16 16s7.168 16 16 16h31.2c-8.32 216.576-182.624 390.88-399.2 399.2zM672 496h-33.6c-7.296-57.76-52.64-103.104-110.4-110.4v-33.6c0-8.832-7.168-16-16-16s-16 7.168-16 16v33.6c-57.76 7.296-103.104 52.64-110.4 110.4h-33.6c-8.832 0-16 7.168-16 16s7.168 16 16 16h33.6c7.296 57.76 52.64 103.104 110.4 110.4v33.6c0 8.832 7.168 16 16 16s16-7.168 16-16v-33.6c57.76-7.296 103.104-52.64 110.4-110.4h33.6c8.832 0 16-7.168 16-16s-7.168-16-16-16zM606.368 496h-78.368v-78.368c40.064 6.784 71.584 38.304 78.368 78.368zM496 417.632v78.368h-78.368c6.784-40.064 38.304-71.584 78.368-78.368zM417.632 528h78.368v78.368c-40.064-6.784-71.584-38.304-78.368-78.368zM528 606.368v-78.368h78.368c-6.784 40.064-38.304 71.584-78.368 78.368z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"target",
						"aim",
						"shoot"
					],
					"grid": 32
				},
				{
					"id": 878,
					"width": 1024,
					"paths": [
						"M417.632 496h78.368v-78.368c-40.064 6.784-71.584 38.304-78.368 78.368z",
						"M528 606.368c40.064-6.784 71.584-38.304 78.368-78.368h-78.368v78.368z",
						"M496 606.368v-78.368h-78.368c6.784 40.064 38.304 71.584 78.368 78.368z",
						"M528 417.632v78.368h78.368c-6.784-40.064-38.304-71.584-78.368-78.368z",
						"M992 496h-32.8c-8.32-234.592-196.608-422.88-431.2-431.2v-32.8c0-8.832-7.168-16-16-16s-16 7.168-16 16v32.8c-234.592 8.32-422.88 196.608-431.2 431.2h-32.8c-8.832 0-16 7.168-16 16s7.168 16 16 16h32.8c8.32 234.592 196.608 422.88 431.2 431.2v32.8c0 8.832 7.168 16 16 16s16-7.168 16-16v-32.8c234.592-8.32 422.88-196.608 431.2-431.2h32.8c8.832 0 16-7.168 16-16s-7.168-16-16-16zM672 528h-33.6c-7.296 57.76-52.64 103.104-110.4 110.4v33.6c0 8.832-7.168 16-16 16s-16-7.168-16-16v-33.6c-57.76-7.296-103.104-52.64-110.4-110.4h-33.6c-8.832 0-16-7.168-16-16s7.168-16 16-16h33.6c7.296-57.76 52.64-103.104 110.4-110.4v-33.6c0-8.832 7.168-16 16-16s16 7.168 16 16v33.6c57.76 7.296 103.104 52.64 110.4 110.4h33.6c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"target",
						"aim",
						"shoot"
					],
					"grid": 32
				},
				{
					"id": 1155,
					"width": 1024,
					"paths": [
						"M992.32 480h-33.92c-15.744-221.824-192.576-398.656-414.4-414.4v-33.92c0-17.504-14.176-31.68-31.68-31.68h-0.64c-17.504 0-31.68 14.176-31.68 31.68v33.92c-221.824 15.744-398.656 192.576-414.4 414.4h-33.92c-17.504 0-31.68 14.176-31.68 31.68v0.64c0 17.504 14.176 31.68 31.68 31.68h33.92c15.744 221.824 192.576 398.656 414.4 414.4v33.92c0 17.504 14.176 31.68 31.68 31.68h0.64c17.504 0 31.68-14.176 31.68-31.68v-33.92c221.824-15.712 398.656-192.576 414.4-414.4h33.92c17.504 0 31.68-14.176 31.68-31.68v-0.64c0-17.504-14.176-31.68-31.68-31.68zM894.368 480h-32c-15.232-168.832-149.536-303.136-318.368-318.4v-32c186.208 15.488 334.912 164.192 350.368 350.4zM512 832c-176.448 0-320-143.552-320-320s143.552-320 320-320 320 143.552 320 320-143.552 320-320 320zM480 129.632v32c-168.832 15.232-303.136 149.536-318.4 318.368h-32c15.488-186.208 164.192-334.912 350.4-350.368zM129.632 544h32c15.232 168.832 149.568 303.136 318.4 318.4v32c-186.24-15.488-334.944-164.192-350.4-350.4zM544 894.368v-32c168.832-15.232 303.136-149.568 318.4-318.4h32c-15.488 186.24-164.192 334.944-350.4 350.4zM640 511.68v0.64c0 17.504-14.176 31.68-31.68 31.68h-64.32v64.32c0 17.504-14.176 31.68-31.68 31.68h-0.64c-17.504 0-31.68-14.176-31.68-31.68v-64.32h-64.32c-17.504 0-31.68-14.176-31.68-31.68v-0.64c0-17.504 14.176-31.68 31.68-31.68h64.32v-64.32c0-17.504 14.176-31.68 31.68-31.68h0.64c17.504 0 31.68 14.176 31.68 31.68v64.32h64.32c17.504 0 31.68 14.176 31.68 31.68z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"target",
						"aim"
					],
					"grid": 32
				},
				{
					"id": 1343,
					"width": 1024.0010032653809,
					"paths": [
						"M585.143 804.571h365.714v-73.143h-365.714v73.143zM365.714 512h585.143v-73.143h-585.143v73.143zM731.429 219.429h219.429v-73.143h-219.429v73.143zM1024 694.857v146.286q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714zM1024 402.286v146.286q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714zM1024 109.714v146.286q0 14.857-10.857 25.714t-25.714 10.857h-950.857q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-14.857 10.857-25.714t25.714-10.857h950.857q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tasks"
					],
					"defaultCode": 61614,
					"grid": 14
				},
				{
					"id": 879,
					"width": 1024,
					"paths": [
						"M448 464c0 8.832-7.168 16-16 16h-16v16c0 8.832-7.168 16-16 16s-16-7.168-16-16v-16h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16h16v-16c0-8.832 7.168-16 16-16s16 7.168 16 16v16h16c8.832 0 16 7.168 16 16zM272 384h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v112c0 8.832 7.168 16 16 16s16-7.168 16-16v-128c0-8.832-7.168-16-16-16zM960 800v32c0 17.664-14.336 32-32 32h-832c-17.664 0-32-14.336-32-32v-32c0-17.664 14.336-32 32-32v-512c0-53.024 42.976-96 96-96h640c53.024 0 96 42.976 96 96v512c17.664 0 32 14.336 32 32zM128 768h592.352c-10.112-13.408-16.352-29.92-16.352-48 0-38.688 27.488-70.976 64-78.4v-17.6c0-8.832 7.168-16 16-16s16 7.168 16 16v17.6c36.512 7.424 64 39.68 64 78.4 0 18.080-6.24 34.592-16.352 48h48.352v-512c0-35.36-28.64-64-64-64h-640c-35.36 0-64 28.64-64 64v512zM784 672c-26.464 0-48 21.536-48 48s21.536 48 48 48 48-21.536 48-48-21.536-48-48-48zM928 800h-832v32h832v-32zM656 448h64c8.832 0 16-7.168 16-16s-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16s7.168 16 16 16zM736 496c0-8.832-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16s7.168 16 16 16h64c8.832 0 16-7.168 16-16zM560 384h-32c-8.832 0-16 7.168-16 16s7.168 16 16 16h16v112c0 8.832 7.168 16 16 16s16-7.168 16-16v-128c0-8.832-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"teach",
						"add",
						"write",
						"draw"
					],
					"grid": 32
				},
				{
					"id": 880,
					"width": 1024,
					"paths": [
						"M720.352 736c-10.112-13.408-16.352-29.92-16.352-48 0-38.688 27.488-70.976 64-78.4v-17.6c0-8.832 7.168-16 16-16s16 7.168 16 16v17.6c36.512 7.424 64 39.68 64 78.4 0 18.080-6.24 34.592-16.352 48h80.352v-480c0-53.024-42.976-96-96-96h-640c-53.024 0-96 42.976-96 96v480h624.352zM656 416h64c8.832 0 16 7.168 16 16s-7.168 16-16 16h-64c-8.832 0-16-7.168-16-16s7.168-16 16-16zM656 480h64c8.832 0 16 7.168 16 16s-7.168 16-16 16h-64c-8.832 0-16-7.168-16-16s7.168-16 16-16zM528 384h32c8.832 0 16 7.168 16 16v128c0 8.832-7.168 16-16 16s-16-7.168-16-16v-112h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16zM368 448h16v-16c0-8.832 7.168-16 16-16s16 7.168 16 16v16h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16v16c0 8.832-7.168 16-16 16s-16-7.168-16-16v-16h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16zM240 384h32c8.832 0 16 7.168 16 16v128c0 8.832-7.168 16-16 16s-16-7.168-16-16v-112h-16c-8.832 0-16-7.168-16-16s7.168-16 16-16zM960 800v32c0 17.664-14.336 32-32 32h-832c-17.664 0-32-14.336-32-32v-32c0-17.664 14.336-32 32-32h832c17.664 0 32 14.336 32 32zM784 736c-26.464 0-48-21.536-48-48s21.536-48 48-48 48 21.536 48 48-21.536 48-48 48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"teach",
						"add",
						"write",
						"draw"
					],
					"grid": 32
				},
				{
					"id": 2529,
					"width": 1216,
					"paths": [
						"M1040 384c-48.85 0-93.098 20.020-125.014 52.268-69.8-71.672-167.274-116.268-274.986-116.268-96.1 0-188.374 36.034-259.826 101.464-48.522 44.432-84.466 99.604-105.23 160.318-1.664-1.86-3.386-3.71-5.174-5.554-41.332-42.618-99.796-64.228-173.77-64.228h-64c-17.672 0-32 14.326-32 32v32c0 17.674 14.328 32 32 32 47.016 0 83.070 18.13 113.462 57.060 28.99 37.132 48.406 86.9 67.182 135.030 15.086 38.668 29.334 75.192 48.074 103.618 24.626 37.352 55.338 56.292 91.282 56.292h576c8.486 0 16.626-3.372 22.626-9.374 35.536-35.536 53.832-80.292 63.284-123.886 40.162-10.592 83.154-36.652 118.898-73.16 53.648-54.792 83.192-123.54 83.192-193.58 0-97.046-78.952-176-176-176zM1064.214 686.42c-13.116 13.394-27.034 24.15-40.248 32.184 0.032-5.128 0.036-10.032 0.036-14.604 0-68.744-18.174-133.318-49.946-189.196 14.426-21 38.596-34.804 65.944-34.804 44.112 0 80 35.888 80 80 0 60.418-34.952 105.138-55.786 126.42z",
						"M704 256c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"teapot",
						"drink",
						"breakfast"
					],
					"defaultCode": 60364,
					"grid": 16
				},
				{
					"id": 3337,
					"paths": [
						"M512 0c-282.8 0-512 229.2-512 512s229.2 512 512 512 512-229.2 512-512-229.2-512-512-512zM763.6 351l-84 395.8c-5.8 28.2-22.8 34.8-46.4 21.8l-128-94.6-61.4 59.8c-7.2 7-12.8 12.8-25.6 12.8-16.6 0-13.8-6.2-19.4-22l-43.6-143.2-126.6-39.4c-27.4-8.4-27.6-27.2 6.2-40.6l493.2-190.4c22.4-10.2 44.2 5.4 35.6 40z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"telegram",
						"brand",
						"social"
					],
					"defaultCode": 61172,
					"grid": 16
				},
				{
					"id": 1745,
					"width": 1097.1460151672363,
					"paths": [
						"M1024 713.143v-548.571q0-7.429-5.429-12.857t-12.857-5.429h-914.286q-7.429 0-12.857 5.429t-5.429 12.857v548.571q0 7.429 5.429 12.857t12.857 5.429h914.286q7.429 0 12.857-5.429t5.429-12.857zM1097.143 164.571v548.571q0 37.714-26.857 64.571t-64.571 26.857h-420.571v73.143h201.143q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-475.429q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h201.143v-73.143h-420.571q-37.714 0-64.571-26.857t-26.857-64.571v-548.571q0-37.714 26.857-64.571t64.571-26.857h914.286q37.714 0 64.571 26.857t26.857 64.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"television",
						"tv"
					],
					"defaultCode": 62060,
					"grid": 14
				},
				{
					"id": 2771,
					"paths": [
						"M384 657.166v-401.166c0-35.346-28.654-64-64-64s-64 28.654-64 64v401.166c-38.248 22.134-64 63.462-64 110.834 0 70.694 57.308 128 128 128 70.694 0 128-57.306 128-128 0-47.372-25.752-88.7-64-110.834z",
						"M320 1024c-141.16 0-256-114.842-256-256 0-62.908 22.632-122.534 64-169.338v-406.662c0-105.87 86.13-192 192-192s192 86.13 192 192l0.002 406.662c41.368 46.804 63.998 106.43 63.998 169.338 0 141.158-114.842 256-256 256zM320 64c-70.58 0-128 57.42-128 128v419.234c0 8.376-3.284 16.416-9.144 22.396-35.374 36.1-54.856 83.82-54.856 134.37 0 105.87 86.13 192 192 192s192-86.13 192-192c0-50.55-19.48-98.27-54.854-134.37-5.862-5.982-9.144-14.022-9.144-22.396l-0.002-419.234c0-70.58-57.42-128-128-128z",
						"M928 128h-256c-17.674 0-32-14.328-32-32s14.326-32 32-32h256c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M864 256h-192c-17.674 0-32-14.328-32-32s14.326-32 32-32h192c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M928 384h-256c-17.674 0-32-14.328-32-32s14.326-32 32-32h256c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M864 512h-192c-17.674 0-32-14.328-32-32s14.326-32 32-32h192c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M928 640h-256c-17.674 0-32-14.326-32-32s14.326-32 32-32h256c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"temperature",
						"weather",
						"thermometer"
					],
					"defaultCode": 60606,
					"grid": 16
				},
				{
					"id": 2772,
					"paths": [
						"M800 128h-192c-17.674 0-32-14.328-32-32s14.326-32 32-32h192c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M736 256h-128c-17.674 0-32-14.328-32-32s14.326-32 32-32h128c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M800 384h-192c-17.674 0-32-14.328-32-32s14.326-32 32-32h192c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M736 512h-128c-17.674 0-32-14.328-32-32s14.326-32 32-32h128c17.674 0 32 14.328 32 32s-14.326 32-32 32z",
						"M800 640h-192c-17.674 0-32-14.326-32-32s14.326-32 32-32h192c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
						"M457.146 633.63c-5.862-5.982-9.144-14.022-9.144-22.396l-0.002-483.234c0-70.58-57.42-128-128-128s-128 57.42-128 128v483.234c0 8.376-3.284 16.416-9.144 22.396-35.374 36.1-54.856 83.82-54.856 134.37 0 105.87 86.13 192 192 192s192-86.13 192-192c0-50.55-19.48-98.27-54.854-134.37zM320 64c35.29 0 64 28.71 64 64v192h-128v-192c0-35.29 28.71-64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"temperature",
						"weather",
						"thermometer"
					],
					"defaultCode": 60607,
					"grid": 16
				},
				{
					"id": 1605,
					"width": 731.4310913085938,
					"paths": [
						"M481.143 326.857q0 45.714-32.571 78t-77.714 32.286q-34.286 0-63.429-20-35.429 38.286-65.714 83.429-141.143 212-115.429 490.857 0.571 12.571-7.143 22t-19.714 10.571h-2.857q-11.429 0-20-7.714t-9.714-19.143q-8-72-2-141.429t16.857-124 30.857-106.286 39.429-88.857 42.286-71.429q34.857-51.429 75.429-94.286-9.143-20-9.143-44 0-45.714 32.286-78t78-32.286 78 32.286 32.286 78zM698.857 333.143q0 90.286-44.571 166.857t-121.429 121.143-167.143 44.571q-36.571 0-74.857-8-12-2.857-18.571-13.429t-3.714-22.571q2.857-11.429 13.143-18t22.286-4.286q29.143 7.429 61.714 7.429 55.429 0 106.286-21.714t87.429-58.286 58.286-87.429 21.714-106.286-21.714-106.286-58.286-87.429-87.429-58.286-106.286-21.714-106.286 21.714-87.429 58.286-58.286 87.429-21.714 106.286q0 65.143 29.714 124.571 5.714 11.429 2 22.857t-14.571 17.143-22.571 1.714-17.429-14.857q-36.571-70.286-36.571-151.429 0-68 26.571-129.714t71.143-106.286 106.286-70.857 129.143-26.286q90.286 0 167.143 44.571t121.429 121.429 44.571 167.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tencent-weibo"
					],
					"defaultCode": 61909,
					"grid": 14
				},
				{
					"id": 2641,
					"paths": [
						"M832 736c-64-64-64-160-64.018-288l-0.010 0.018c0.078-107.622-46.096-222.214-135.934-312.054-89.77-89.772-204.234-135.972-311.784-135.964-86.406 0.006-168.362 29.84-229.388 90.866-136.988 136.988-116.796 379.276 45.098 541.172 89.77 89.77 204.234 135.962 311.782 135.962 128.254 0 224.254 0 288.254 64l192 192c64 0 96-32 96-96l-192-192zM512 131.096c24.52 15.758 47.774 34.424 69.126 55.778 21.34 21.34 40.006 44.476 55.826 69.124h-124.952v-124.902zM256 636.902c-24.52-15.758-47.772-34.424-69.124-55.776-21.34-21.34-40.008-44.476-55.83-69.126h124.954v124.902zM256 448h-158.174c-13.56-33.388-21.882-67.564-24.74-101.868-0.734-8.816-1.076-17.528-1.074-26.132h183.988v128zM256 256h-176.788c10.304-44.052 31.484-83.14 62.566-114.222 22.722-22.724 49.736-40.25 80.29-52.096 10.958-4.25 22.288-7.728 33.932-10.452v176.77zM448 695.998c-0.084 0-0.168 0.002-0.254 0.002-42.894 0-86.278-8.966-127.746-25.802v-158.198h128v183.998zM448 448h-128v-128h128v128zM448 256h-128v-183.998c0.090 0 0.178-0.002 0.268-0.002h0.014c42.882 0 86.256 8.966 127.718 25.8v158.2zM626.222 626.222c-22.724 22.724-49.738 40.254-80.292 52.098-10.958 4.25-22.288 7.728-33.932 10.454v-176.774h176.788c-10.302 44.052-31.482 83.14-62.564 114.222zM512 448v-128h158.174c13.562 33.388 21.882 67.562 24.74 101.868 0.734 8.816 1.076 17.528 1.074 26.132h-183.988z",
						"M192 864c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tennis",
						"sports",
						"game"
					],
					"defaultCode": 60476,
					"grid": 16
				},
				{
					"id": 2543,
					"width": 1024,
					"paths": [
						"M1023.99 896c0-13.102-4.012-26.138-11.912-37.2l-421.428-526 165.428-231.6c20.544-28.762 13.882-68.734-14.878-89.278-28.764-20.546-68.734-13.88-89.278 14.88l-139.922 195.888-139.92-195.89c-20.544-28.764-60.516-35.424-89.278-14.88s-35.424 60.516-14.88 89.278l165.43 231.6-421.43 526.002c-7.9 11.060-11.91 24.098-11.912 37.2h-0.006v128h511.996v-512l256 512h256v-128h-0.010z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tent",
						"camping"
					],
					"defaultCode": 60378,
					"grid": 16
				},
				{
					"id": 3305,
					"paths": [
						"M0 64v896h1024v-896h-1024zM960 896h-896v-768h896v768zM896 192h-768v640h768v-640zM448 512h-64v64h-64v64h-64v-64h64v-64h64v-64h-64v-64h-64v-64h64v64h64v64h64v64zM704 640h-192v-64h192v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"terminal",
						"console",
						"cmd",
						"command-line"
					],
					"defaultCode": 61140,
					"grid": 16
				},
				{
					"id": 1435,
					"width": 958.2859897613525,
					"paths": [
						"M334.286 561.714l-266.286 266.286q-5.714 5.714-13.143 5.714t-13.143-5.714l-28.571-28.571q-5.714-5.714-5.714-13.143t5.714-13.143l224.571-224.571-224.571-224.571q-5.714-5.714-5.714-13.143t5.714-13.143l28.571-28.571q5.714-5.714 13.143-5.714t13.143 5.714l266.286 266.286q5.714 5.714 5.714 13.143t-5.714 13.143zM950.857 822.857v36.571q0 8-5.143 13.143t-13.143 5.143h-548.571q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h548.571q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"terminal"
					],
					"defaultCode": 61728,
					"grid": 14
				},
				{
					"id": 248,
					"paths": [
						"M896 256h-768c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M793.6 409.6h-563.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h563.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 563.2h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M793.6 716.8h-563.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h563.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 870.4h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-align-center",
						"typography",
						"paragraph"
					],
					"defaultCode": 59545,
					"grid": 20
				},
				{
					"id": 250,
					"paths": [
						"M896 256h-768c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 409.6h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 563.2h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 716.8h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 870.4h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-align-justify",
						"typography",
						"paragraph"
					],
					"defaultCode": 59547,
					"grid": 20
				},
				{
					"id": 247,
					"paths": [
						"M896 256h-768c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M691.2 409.6h-563.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h563.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 563.2h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M691.2 716.8h-563.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h563.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 870.4h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-align-left",
						"typography",
						"paragraph"
					],
					"defaultCode": 59544,
					"grid": 20
				},
				{
					"id": 249,
					"paths": [
						"M896 256h-768c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 409.6h-563.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h563.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 563.2h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 716.8h-563.2c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h563.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M896 870.4h-768c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h768c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-align-right",
						"typography",
						"paragraph"
					],
					"defaultCode": 59546,
					"grid": 20
				},
				{
					"id": 3263,
					"paths": [
						"M322.018 832l57.6-192h264.764l57.6 192h113.632l-191.996-640h-223.236l-192 640h113.636zM475.618 320h72.764l57.6 192h-187.964l57.6-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-color",
						"wysiwyg"
					],
					"defaultCode": 61098,
					"grid": 16
				},
				{
					"id": 239,
					"paths": [
						"M844.8 972.8h-716.8c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h716.8c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M817.13 783.515l-131.562-306.978c-0.032-0.075-0.064-0.149-0.098-0.224l-175.539-409.598c-4.035-9.413-13.291-15.515-23.531-15.515s-19.496 6.102-23.531 15.515l-175.539 409.594c-0.034 0.078-0.067 0.155-0.099 0.232l-131.562 306.974c-5.568 12.995 0.451 28.045 13.446 33.614 12.992 5.57 28.045-0.451 33.614-13.445l125.008-291.685h317.325l125.008 291.685c4.16 9.707 13.61 15.523 23.542 15.522 3.365 0 6.784-0.667 10.072-2.077 12.995-5.568 19.016-20.619 13.445-33.614zM349.68 460.8l136.72-319.013 136.72 319.013h-273.44z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-format",
						"typography"
					],
					"defaultCode": 59536,
					"grid": 20
				},
				{
					"id": 240,
					"paths": [
						"M691.2 51.2h-614.4c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h276.981l-97.432 584.592c-2.325 13.946 7.098 27.134 21.043 29.459 1.426 0.237 2.842 0.354 4.24 0.354 12.288 0 23.133-8.875 25.221-21.397l98.834-593.008h285.514c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6z",
						"M537.6 819.2h-460.8c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h460.8c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6z",
						"M804.203 844.8l84.299-84.299c9.998-9.997 9.998-26.206 0-36.203-9.997-9.997-26.206-9.997-36.203 0l-84.299 84.299-84.299-84.299c-9.997-9.997-26.206-9.997-36.203 0-9.998 9.997-9.998 26.206 0 36.203l84.299 84.299-84.299 84.299c-9.998 9.997-9.998 26.206 0 36.203 5 4.998 11.55 7.498 18.102 7.498s13.102-2.499 18.101-7.499l84.299-84.298 84.299 84.299c4.998 4.998 11.549 7.498 18.101 7.498s13.102-2.499 18.101-7.499c9.998-9.997 9.998-26.206 0-36.203l-84.298-84.298z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-format-remove",
						"typography"
					],
					"defaultCode": 59537,
					"grid": 20
				},
				{
					"id": 3240,
					"paths": [
						"M896 768h128l-160 192-160-192h128v-512h-128l160-192 160 192h-128zM640 64v256l-64-128h-192v704h128v64h-384v-64h128v-704h-192l-64 128v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-height",
						"wysiwyg"
					],
					"defaultCode": 61075,
					"grid": 16
				},
				{
					"id": 1228,
					"width": 1025.7170944213867,
					"paths": [
						"M996.571 804.571q18.857 0 24 10.571t-6.286 25.429l-72 92.571q-11.429 14.857-28 14.857t-28-14.857l-72-92.571q-11.429-14.857-6.286-25.429t24-10.571h45.714v-585.143h-45.714q-18.857 0-24-10.571t6.286-25.429l72-92.571q11.429-14.857 28-14.857t28 14.857l72 92.571q11.429 14.857 6.286 25.429t-24 10.571h-45.714v585.143h45.714zM46.286 73.714l30.857 15.429q6.857 2.857 120.571 2.857 25.143 0 75.429-1.143t75.429-1.143q20.571 0 61.429 0.286t61.429 0.286h167.429q3.429 0 12 0.286t11.714 0 9.143-1.714 10-5.143 8.571-10l24-0.571q2.286 0 8 0.286t8 0.286q1.143 64 1.143 192 0 45.714-2.857 62.286-22.286 8-38.857 10.286-14.286-25.143-30.857-73.143-1.714-5.143-6.286-27.429t-8.286-42-4.286-20.286q-3.429-4.571-6.857-7.143t-8.857-3.429-7.429-1.429-10.286-0.286-9.429 0.286q-9.714 0-38-0.286t-42.571-0.286-36.571 1.143-40.571 3.429q-5.143 46.286-4.571 77.714 0 53.714 1.143 221.714t1.143 260q0 9.143-1.429 40.857t0 52.286 7.143 39.429q22.857 12 70.857 24.286t68.571 21.429q2.857 22.857 2.857 28.571 0 8-1.714 16.571l-19.429 0.571q-43.429 1.143-124.571-4.571t-118.286-5.714q-28.571 0-86.286 5.143t-86.857 5.143q-1.714-29.143-1.714-29.714v-5.143q9.714-15.429 35.143-24.571t56.286-16.571 44.571-15.429q10.857-24 10.857-218.857 0-57.714-1.714-173.143t-1.714-173.143v-66.857q0-1.143 0.286-8.857t0.286-14.286-0.571-14.571-1.714-13.714-2.857-8q-6.286-6.857-92.571-6.857-18.857 0-53.143 6.857t-45.714 14.857q-10.857 7.429-19.429 41.429t-18 63.429-24.286 30.571q-24-14.857-32-25.143v-218.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-height"
					],
					"defaultCode": 61492,
					"grid": 14
				},
				{
					"id": 241,
					"paths": [
						"M356.331 834.715l-65.734-153.381c-0.030-0.072-0.061-0.144-0.093-0.216l-87.773-204.803c-4.035-9.413-13.291-15.515-23.531-15.515s-19.496 6.102-23.531 15.515l-87.771 204.803c-0.032 0.072-0.062 0.144-0.093 0.216l-65.736 153.381c-5.568 12.995 0.451 28.045 13.446 33.614 12.997 5.57 28.046-0.451 33.614-13.445l59.179-138.085h141.781l59.179 138.085c4.162 9.707 13.61 15.523 23.542 15.522 3.363 0 6.784-0.667 10.072-2.077 12.997-5.568 19.016-20.619 13.448-33.614zM130.251 665.6l48.949-114.213 48.949 114.213h-97.898z",
						"M1022.032 834.954l-106.669-256.003c-0.029-0.069-0.056-0.138-0.085-0.205l-149.246-358.192c-3.976-9.539-13.298-15.754-23.632-15.754s-19.656 6.214-23.632 15.754l-149.243 358.184c-0.032 0.075-0.061 0.149-0.093 0.222l-106.664 255.994c-5.438 13.051 0.733 28.038 13.784 33.478 13.048 5.435 28.040-0.734 33.477-13.784l100.104-240.248h264.533l100.102 240.246c4.098 9.832 13.616 15.76 23.642 15.76 3.282 0 6.618-0.634 9.835-1.974 13.053-5.44 19.224-20.427 13.787-33.478zM631.467 563.2l110.933-266.24 110.933 266.24h-221.866z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-size",
						"typography",
						"font-size"
					],
					"defaultCode": 59538,
					"grid": 20
				},
				{
					"id": 3241,
					"paths": [
						"M256 896v128l-192-160 192-160v128h512v-128l192 160-192 160v-128zM832 64v256l-64-128h-192v448h128v64h-384v-64h128v-448h-192l-64 128v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-width",
						"wysiwyg"
					],
					"defaultCode": 61076,
					"grid": 16
				},
				{
					"id": 1229,
					"width": 877.7141494750977,
					"paths": [
						"M46.286 73.714l30.857 15.429q6.857 2.857 120.571 2.857 25.143 0 75.429-1.143t75.429-1.143q40 0 140.857-0.571t174-0.286 141.143 2.571q18.857 0.571 32-17.714l24-0.571q2.286 0 8 0.286t8 0.286q1.143 64 1.143 192 0 45.714-2.857 62.286-22.286 8-38.857 10.286-14.286-25.143-30.857-73.143-1.714-5.143-6.286-27.143t-8.571-42-4-20.571q-5.714-7.429-15.429-10.857-2.857-1.143-37.714-1.143-17.143 0-53.143-0.571t-58.857-0.571-53.714 1.143-54.857 4q-5.143 46.286-4.571 77.714l0.571 86.857v-29.714q0 31.429 0.571 88t0.857 102.857 0.286 87.429q0 9.143-1.429 40.857t0 52.286 7.143 39.429q22.857 12 70.857 24.286t68.571 21.429q2.857 22.857 2.857 28.571 0 8-1.714 16.571l-19.429 0.571q-43.429 1.143-124.571-4.571t-118.286-5.714q-28.571 0-86.286 5.143t-86.857 5.143q-1.714-29.143-1.714-29.714v-5.143q9.714-15.429 35.143-24.571t56.286-16.571 44.571-15.429q4-9.143 6.571-42.286t3.429-83.143 0.857-88.571-0.286-87.714-0.286-50.857q0-4-1.429-12.286t-1.429-12.857q0-4 0.286-25.143t0.571-41.714 0-43.714-1.714-38.571-3.714-18.286q-6.286-6.857-92.571-6.857-23.429 0-93.143 7.714t-78.857 14q-10.857 6.857-19.429 40.857t-18 63.714-24.286 30.857q-24-14.857-32-25.143v-218.857zM748.571 806.286q6.857 0 24 11.143t32.857 23.714 34 28 20.571 17.143q14.857 12 14.857 28t-14.857 28q-2.286 1.714-20.571 17.143t-34 28-32.857 23.714-24 11.143q-7.429 0-11.714-6t-5.714-16.286-1.429-19.143 0.857-18.857 0.857-11.143h-585.143q0 1.143 0.857 11.143t0.857 18.857-1.429 19.143-5.714 16.286-11.714 6q-6.857 0-24-11.143t-32.857-23.714-34-28-20.571-17.143q-14.857-12-14.857-28t14.857-28q2.286-1.714 20.571-17.143t34-28 32.857-23.714 24-11.143q7.429 0 11.714 6t5.714 16.286 1.429 19.143-0.857 18.857-0.857 11.143h585.143q0-1.143-0.857-11.143t-0.857-18.857 1.429-19.143 5.714-16.286 11.714-6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"text-width"
					],
					"defaultCode": 61493,
					"grid": 14
				},
				{
					"id": 1189,
					"width": 1024.0000534057617,
					"paths": [
						"M292.571 713.143v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM292.571 420.571v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM658.286 713.143v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM292.571 128v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM658.286 420.571v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM1024 713.143v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM658.286 128v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM1024 420.571v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM1024 128v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"th"
					],
					"defaultCode": 61450,
					"grid": 14
				},
				{
					"id": 1188,
					"width": 950.8570175170898,
					"paths": [
						"M438.857 585.143v219.429q0 29.714-21.714 51.429t-51.429 21.714h-292.571q-29.714 0-51.429-21.714t-21.714-51.429v-219.429q0-29.714 21.714-51.429t51.429-21.714h292.571q29.714 0 51.429 21.714t21.714 51.429zM438.857 146.286v219.429q0 29.714-21.714 51.429t-51.429 21.714h-292.571q-29.714 0-51.429-21.714t-21.714-51.429v-219.429q0-29.714 21.714-51.429t51.429-21.714h292.571q29.714 0 51.429 21.714t21.714 51.429zM950.857 585.143v219.429q0 29.714-21.714 51.429t-51.429 21.714h-292.571q-29.714 0-51.429-21.714t-21.714-51.429v-219.429q0-29.714 21.714-51.429t51.429-21.714h292.571q29.714 0 51.429 21.714t21.714 51.429zM950.857 146.286v219.429q0 29.714-21.714 51.429t-51.429 21.714h-292.571q-29.714 0-51.429-21.714t-21.714-51.429v-219.429q0-29.714 21.714-51.429t51.429-21.714h292.571q29.714 0 51.429 21.714t21.714 51.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"th-large"
					],
					"defaultCode": 61449,
					"grid": 14
				},
				{
					"id": 1190,
					"width": 1024.0000534057617,
					"paths": [
						"M292.571 713.143v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM292.571 420.571v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM1024 713.143v109.714q0 22.857-16 38.857t-38.857 16h-548.571q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h548.571q22.857 0 38.857 16t16 38.857zM292.571 128v109.714q0 22.857-16 38.857t-38.857 16h-182.857q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h182.857q22.857 0 38.857 16t16 38.857zM1024 420.571v109.714q0 22.857-16 38.857t-38.857 16h-548.571q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h548.571q22.857 0 38.857 16t16 38.857zM1024 128v109.714q0 22.857-16 38.857t-38.857 16h-548.571q-22.857 0-38.857-16t-16-38.857v-109.714q0-22.857 16-38.857t38.857-16h548.571q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"th-list"
					],
					"defaultCode": 61451,
					"grid": 14
				},
				{
					"id": 881,
					"width": 1024,
					"paths": [
						"M534.624 457.376l88.608-88.608c26.4-26.4 26.752-69.92 0.8-96.736l-0.064-0.064c-13.248-13.248-30.592-19.872-47.968-19.872s-34.72 6.624-47.968 19.872l-16.032 16.032-16.032-16.032c-13.248-13.248-30.592-19.872-47.968-19.872s-34.72 6.624-47.968 19.872l-0.064 0.064c-25.952 26.816-25.6 70.336 0.8 96.736l88.608 88.608c12.48 12.48 32.768 12.48 45.248 0zM422.656 294.592c6.784-6.752 15.776-10.496 25.344-10.496s18.56 3.744 25.344 10.496l38.656 38.656 38.656-38.656c6.784-6.752 15.776-10.496 25.344-10.496s18.56 3.744 25.408 10.56c6.752 6.784 10.496 15.776 10.496 25.344s-3.744 18.56-10.496 25.344l-89.408 89.408-89.408-89.408c-6.784-6.784-10.496-15.776-10.496-25.344s3.744-18.56 10.56-25.408zM896 192h-32v-32c0-53.024-42.976-96-96-96h-512c-53.024 0-96 42.976-96 96v32h-32c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM896 224c11.84 0 22.784 3.456 32.32 9.056l-64.32 64.32v-73.376h32zM256 96h512c35.296 0 64 28.704 64 64v169.376l-320 320-320-320v-169.376c0-35.296 28.704-64 64-64zM128 224h32v73.376l-64.32-64.32c9.536-5.6 20.48-9.056 32.32-9.056zM64 864v-576c0-11.84 3.456-22.784 9.056-32.32l320.32 320.32-320.32 320.32c-5.6-9.536-9.056-20.48-9.056-32.32zM896 928h-768c-11.84 0-22.784-3.456-32.32-9.056l320.32-320.32 73.376 73.376c12.512 12.512 32.768 12.512 45.248 0l73.376-73.376 320.32 320.32c-9.536 5.6-20.48 9.056-32.32 9.056zM960 864c0 11.84-3.456 22.784-9.056 32.32l-320.32-320.32 320.32-320.32c5.6 9.536 9.056 20.48 9.056 32.32v576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thank",
						"send"
					],
					"grid": 32
				},
				{
					"id": 882,
					"width": 1024,
					"paths": [
						"M422.592 345.344c-6.784-6.784-10.496-15.776-10.496-25.344s3.744-18.56 10.56-25.408c6.784-6.752 15.776-10.496 25.344-10.496s18.56 3.744 25.344 10.496l38.656 38.656 38.656-38.656c6.784-6.752 15.776-10.496 25.344-10.496s18.56 3.744 25.408 10.56c6.752 6.784 10.496 15.776 10.496 25.344s-3.744 18.56-10.496 25.344l-89.408 89.408-89.408-89.408zM160 160c0-53.024 42.976-96 96-96h512c53.024 0 96 42.976 96 96v137.376l-352 352-352-352v-137.376zM400.768 368.768l88.608 88.608c12.512 12.512 32.768 12.512 45.248 0l88.608-88.608c26.4-26.4 26.752-69.92 0.8-96.736l-0.064-0.064c-13.248-13.248-30.592-19.872-47.968-19.872s-34.72 6.624-47.968 19.872l-16.032 16.032-16.032-16.032c-13.248-13.248-30.592-19.872-47.968-19.872s-34.72 6.624-47.968 19.872l-0.064 0.064c-25.952 26.816-25.6 70.336 0.8 96.736zM896 192v73.376l20.672-20.672c6.24-6.24 16.384-6.24 22.624 0s6.24 16.384 0 22.624l-308.672 308.672 308.672 308.672c6.24 6.24 6.24 16.384 0 22.624-3.104 3.136-7.2 4.704-11.296 4.704s-8.192-1.568-11.328-4.672l-308.672-308.704-84.672 84.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672l-84.672-84.704-308.672 308.672c-3.136 3.136-7.232 4.704-11.328 4.704s-8.192-1.568-11.328-4.672c-6.24-6.24-6.24-16.384 0-22.624l308.704-308.704-308.704-308.672c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0l20.704 20.672v-73.376c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thank",
						"send"
					],
					"grid": 32
				},
				{
					"id": 2064,
					"width": 1088,
					"paths": [
						"M1086.546 0c-110.14 39.084-241.496 77.788-382.546 77.788s-272.406-38.704-382.546-77.788c-0.96 20.362-1.454 40.968-1.454 61.788 0 390.030 171.922 706.212 384 706.212s384-316.182 384-706.212c0-20.82-0.494-41.426-1.454-61.788zM448 256c0-35.346 42.98-64 96-64s96 28.654 96 64h-192zM704 640c-84.116 0-155.586-81.138-181.548-194.082 46.368 40.812 110.584 66.082 181.548 66.082s135.18-25.27 181.548-66.082c-25.962 112.944-97.432 194.082-181.548 194.082zM768 256c0-35.346 42.98-64 96-64s96 28.654 96 64h-192z",
						"M507.868 773.694c-54.038-42.034-101.868-100.922-142.164-175.030-35.988-66.186-64.538-142.044-84.93-224.156-102.232-6.142-197.278-25.352-279.44-54.508-0.88 18.664-1.334 37.554-1.334 56.638 0 357.53 157.596 647.362 352 647.362 99.008 0 188.454-75.208 252.41-196.216-33.306-11.946-65.568-29.996-96.542-54.090zM128 512h128c0 35.348-28.654 64-64 64s-64-28.652-64-64zM352 830c-42.98 0-83.752 8.382-120.384 23.386 29.326-53.558 72.384-87.386 120.384-87.386s91.058 33.828 120.384 87.386c-36.632-15.004-77.404-23.386-120.384-23.386z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"theater",
						"show",
						"faces"
					],
					"defaultCode": 59899,
					"grid": 16
				},
				{
					"id": 1810,
					"width": 1023.9979648590088,
					"paths": [
						"M486.857 176.571q0 16.571-9.714 30t-25.714 13.429-25.714-13.429-9.714-30 9.714-30 25.714-13.429 25.714 13.429 9.714 30zM393.143 962.857v-65.143q0-17.143-11.714-29.429t-28.857-12.286-28.571 12.286-11.429 29.429v65.143q0 17.143 11.714 29.714t28.286 12.571q17.143 0 28.857-12.571t11.714-29.714zM491.429 962.857v-65.143q0-17.143-11.429-29.429t-28.571-12.286-28.857 12.286-11.714 29.429v65.143q0 17.143 11.714 29.714t28.857 12.571q16.571 0 28.286-12.571t11.714-29.714zM590.857 962.857v-65.143q0-17.143-11.714-29.429t-28.857-12.286-28.857 12.286-11.714 29.429v65.143q0 17.143 11.714 29.714t28.857 12.571 28.857-12.571 11.714-29.714zM690.286 962.857v-65.143q0-17.143-11.714-29.429t-28.857-12.286-28.857 12.286-11.714 29.429v65.143q0 17.143 11.714 29.714t28.857 12.571 28.857-12.571 11.714-29.714zM843.429 572q-48 91.429-132.571 148.286t-184.571 56.857q-70.286 0-131.143-29.429t-102-78.286-64.571-112.857-23.429-132.571q0-50.286 12-99.429-59.429 100-59.429 222.857 0 92.571 37.143 178.286t105.714 143.429q17.143-32.571 52-32.571 32 0 49.143 28.571 18.286-28.571 49.714-28.571 32 0 49.143 28.571 18.286-28.571 49.714-28.571t49.714 28.571q17.143-28.571 49.143-28.571 16 0 30 8.857t21.429 23.143q64-53.714 101.143-132.286t41.714-164.286zM757.714 555.429q0-42.857-41.143-42.857-9.714 0-26.857 3.429-54.286 10.857-85.143 10.857-129.143 0-129.143-138.857 0-49.143 17.143-116.571-47.429 72.571-47.429 157.143 0 85.714 50.857 148.857t134.286 63.143q63.429 0 120-40 7.429-27.429 7.429-45.143zM505.143 178.857q0-28.571-18.286-51.143t-46.286-22.571-46.286 22.571-18.286 51.143q0 29.143 18 51.714t46.571 22.571 46.571-22.571 18-51.714zM864.571 372.571q0-54.857-21.429-102.286t-64.571-78.286-99.143-30.857q-44 0-85.143 20t-72.571 53.714q-27.429 90.857-27.429 153.143 0 59.429 26 89.714t84.286 30.286q30.286 0 81.143-10.857 20.571-3.429 30.286-3.429 29.143 0 44.286 16t15.143 45.714q0 14.857-2.286 26.286 42.857-38.857 67.143-94.571t24.286-114.571zM1024 496.571q0 63.429-19.143 142.571t-53.429 116.857q-33.143 36.571-111.429 81.429t-130.286 59.714l-2.286 0.571v65.143q0 24.571-16.857 42.857t-41.429 18.286q-32 0-49.143-28.571-18.286 28.571-49.714 28.571t-49.714-28.571q-17.143 28.571-49.143 28.571-31.429 0-49.714-28.571-17.143 28.571-49.143 28.571-26.857 0-42.857-19.143t-16-46.571q-51.429 38.857-113.143 38.857-67.429 0-120.571-45.714 30.857-0.571 60.571-11.429-64.571-17.714-104-72.571 18.286 4 40.571 4 50.857 0 93.714-26.286-109.714-109.714-137.143-174.857-13.714-32-13.714-91.429 0-32.571 5.143-71.714t18-83.714 31.429-80.571 49.429-60 68.571-24q33.714 0 46.286 29.714 10.857-16.571 24-30.857 1.143-1.714 6.857-7.429t7.429-9.143q5.714-8.571 13.143-21.714t14.286-24 16-22.286q49.714-63.429 120.857-101.143t148.857-37.714q20 0 35.429 2.286 33.714-36.571 83.429-36.571 47.429 0 80 32.571 2.857 2.857 2.857 6.857 0 2.857-3.429 7.714t-7.143 9.143-9.143 9.714l-6 6q9.714 3.429 20.571 10.286t10.857 13.714q0 3.429-9.143 14.286 89.714 78.857 112.571 216 14.286-17.143 34.286-17.143 25.714 0 57.143 28 51.429 45.714 51.429 159.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"themeisle"
					],
					"defaultCode": 62130,
					"grid": 14
				},
				{
					"id": 883,
					"width": 1024,
					"paths": [
						"M640 432v0c0 8.832-7.168 16-16 16h-224c-8.832 0-16-7.168-16-16v0c0-8.832 7.168-16 16-16h224c8.832 0 16 7.168 16 16zM400 512h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM400 576h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM960 512c0-63.104-30.592-118.912-77.568-153.92 8.192-57.76-9.216-118.432-53.632-162.848-37.344-37.344-86.176-55.616-135.104-55.616-9.28 0-18.56 0.672-27.744 1.952-35.040-46.976-90.848-77.568-153.952-77.568s-118.912 30.592-153.92 77.568c-9.216-1.312-18.496-1.952-27.744-1.952-48.928 0-97.76 18.272-135.104 55.616-44.416 44.416-61.856 105.088-53.664 162.848-46.976 35.008-77.568 90.816-77.568 153.92s30.592 118.912 77.568 153.92c-8.192 57.76 9.216 118.432 53.632 162.848 37.344 37.344 86.176 55.616 135.104 55.616 9.28 0 18.56-0.672 27.744-1.952 35.040 46.976 90.848 77.568 153.952 77.568s118.912-30.592 153.92-77.568c9.216 1.312 18.496 1.952 27.744 1.952 48.928 0 97.76-18.272 135.104-55.616 44.416-44.416 61.856-105.12 53.632-162.848 47.008-35.008 77.6-90.816 77.6-153.92zM863.296 640.256l-15.232 11.36 2.688 18.816c7.2 50.72-9.056 100.192-44.576 135.744-29.824 29.824-69.76 46.24-112.48 46.24-7.744 0-15.552-0.544-23.264-1.632l-18.816-2.688-11.36 15.232c-30.624 41.088-77.376 64.672-128.256 64.672s-97.632-23.584-128.256-64.704l-11.36-15.232-18.816 2.688c-7.68 1.088-15.52 1.632-23.264 1.632-42.72 0-82.656-16.416-112.48-46.24-35.552-35.552-51.776-85.024-44.576-135.744l2.688-18.816-15.232-11.36c-41.12-30.592-64.704-77.344-64.704-128.224 0-50.912 23.584-97.632 64.704-128.256l15.232-11.36-2.688-18.816c-7.2-50.72 9.056-100.192 44.608-135.712 29.824-29.824 69.76-46.24 112.48-46.24 7.744 0 15.584 0.544 23.264 1.632l18.816 2.688 11.36-15.232c30.592-41.12 77.344-64.704 128.224-64.704s97.632 23.584 128.256 64.672l11.36 15.232 18.816-2.688c7.68-1.088 15.52-1.632 23.264-1.632 42.72 0 82.656 16.416 112.48 46.24 35.552 35.552 51.776 85.024 44.576 135.744l-2.688 18.816 15.232 11.36c41.12 30.624 64.704 77.344 64.704 128.256 0 50.88-23.584 97.632-64.704 128.256zM64 992c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM128 832c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM128 925.536c-16.288 0-29.536-13.248-29.536-29.536s13.248-29.536 29.536-29.536 29.536 13.248 29.536 29.536c0 16.288-13.248 29.536-29.536 29.536z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"think",
						"consider",
						"ponder",
						"wonder"
					],
					"grid": 32
				},
				{
					"id": 884,
					"width": 1024,
					"paths": [
						"M192 896c0 35.36-28.64 64-64 64s-64-28.64-64-64c0-35.36 28.64-64 64-64s64 28.64 64 64zM32 960c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM882.432 665.92c8.192 57.76-9.216 118.432-53.632 162.848-37.344 37.344-86.176 55.616-135.104 55.616-9.28 0-18.56-0.672-27.744-1.952-35.040 46.976-90.848 77.568-153.952 77.568s-118.912-30.592-153.92-77.568c-9.216 1.312-18.464 1.952-27.744 1.952-48.928 0-97.76-18.272-135.104-55.616-44.416-44.416-61.856-105.12-53.632-162.848-47.008-35.008-77.6-90.816-77.6-153.92s30.592-118.912 77.568-153.92c-8.192-57.76 9.248-118.432 53.664-162.88 37.344-37.344 86.176-55.616 135.104-55.616 9.28 0 18.56 0.672 27.744 1.952 35.008-46.944 90.816-77.536 153.92-77.536s118.912 30.592 153.92 77.568c9.216-1.312 18.464-1.952 27.744-1.952 48.928 0 97.76 18.272 135.104 55.616 44.416 44.416 61.856 105.12 53.632 162.848 47.008 35.008 77.6 90.816 77.6 153.92s-30.592 118.912-77.568 153.92zM640 560c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM640 496c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM640 432c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"think",
						"consider",
						"ponder",
						"wonder"
					],
					"grid": 32
				},
				{
					"id": 1156,
					"width": 1024,
					"paths": [
						"M512 0c-212.064 0-384 171.936-384 384 0 154.912 91.904 288.032 224 348.736v195.264c0 17.664 14.336 32 32 32h64c0 35.36 28.64 64 64 64s64-28.64 64-64h64c17.664 0 32-14.336 32-32v-195.264c132.096-60.704 224-193.856 224-348.736 0-212.064-171.936-384-384-384zM608 896h-93.12l93.12-34.912v34.912zM608 826.912l-184.224 69.088h-7.776v-26.912l192-72v29.824zM608 762.912l-192 72v-29.856l192-72v29.856zM416 770.912v-48.512c29.76 8.416 61.056 13.248 93.472 13.472l-93.472 35.040zM512 704c-176.448 0-320-143.552-320-320s143.552-320 320-320 320 143.552 320 320-143.552 320-320 320zM365.856 156.8c-24.32 0-53.12 12.768-76.704 36.352-37.504 37.504-47.616 88.16-22.624 113.152 9.28 9.248 22.080 13.696 36.416 13.696 24.32 0 53.12-12.768 76.704-36.352 37.504-37.504 47.616-88.16 22.624-113.152-9.248-9.248-22.048-13.696-36.416-13.696zM383.040 216.128c-3.008 15.008-12.48 31.392-25.984 44.896-19.904 19.904-40.992 26.976-54.112 26.976-4.32 0-10.208-0.736-13.792-4.352-4.16-4.16-5.408-12.736-3.36-22.976 3.008-15.008 12.48-31.392 25.984-44.896 19.872-19.872 40.96-26.976 54.080-26.976 4.32 0 10.208 0.736 13.792 4.352 4.16 4.16 5.44 12.736 3.392 22.976z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"think",
						"light",
						"consider",
						"ponder",
						"wonder",
						"innovate"
					],
					"grid": 32
				},
				{
					"id": 1312,
					"width": 658.2890281677246,
					"paths": [
						"M274.286 493.714v-256q0-8-5.143-13.143t-13.143-5.143-13.143 5.143-5.143 13.143v256q0 8 5.143 13.143t13.143 5.143 13.143-5.143 5.143-13.143zM658.286 694.857q0 14.857-10.857 25.714t-25.714 10.857h-245.143l-29.143 276q-1.143 6.857-6 11.714t-11.714 4.857h-0.571q-15.429 0-18.286-15.429l-43.429-277.143h-230.857q-14.857 0-25.714-10.857t-10.857-25.714q0-70.286 44.857-126.571t101.429-56.286v-292.571q-29.714 0-51.429-21.714t-21.714-51.429 21.714-51.429 51.429-21.714h365.714q29.714 0 51.429 21.714t21.714 51.429-21.714 51.429-51.429 21.714v292.571q56.571 0 101.429 56.286t44.857 126.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumb-tack"
					],
					"defaultCode": 61581,
					"grid": 14
				},
				{
					"id": 2827,
					"paths": [
						"M32 416c0 32.916 17.956 61.954 45.308 79.248-8.444 14.292-13.308 30.952-13.308 48.752 0 53.020 42.98 96 96 96h187.808c-22.456 80.91-33.808 164.592-33.808 250 0 73.888 60.112 134 134 134 73.886 0 134-60.112 134-134 0-103.972 38.722-183.95 115.090-237.71 21-14.784 44.742-27.486 70.91-38.066v89.776h256v-640h-256v62.998c-59.89-3.932-88.968-18.922-117.19-33.494-28.088-14.506-57.132-29.504-106.81-29.504h-320c-53.020 0-96 42.98-96 96 0 12.498 2.414 24.426 6.76 35.376-40.77 11.086-70.76 48.342-70.76 92.624 0 17.8 4.864 34.46 13.308 48.752-27.352 17.294-45.308 46.332-45.308 79.248zM352 576h-192c-17.644 0-32-14.356-32-32s14.356-32 32-32h192c17.644 0 32 14.356 32 32s-14.356 32-32 32zM466.91 369.376c27.074-16.974 45.090-47.064 45.090-81.376 0-34-17.692-63.85-44.354-80.906 7.852-13.916 12.354-29.974 12.354-47.094 0-11.222-1.946-21.988-5.484-32h69.484c34.128 0 52.298 9.382 77.446 22.37 31.748 16.392 70.386 36.32 146.554 40.728v342.222c-42.936 14.428-81.428 33.43-114.658 56.824-96.392 67.856-147.342 171.544-147.342 299.856 0 31.982-26.020 58-58 58s-58-26.018-58-58c0-85.66 12.414-169.412 36.96-250 6.66-24.74 12.94-49.228 16.876-67.99 2.542-8.34 3.96-17.164 4.122-26.294 0.030-0.602 0.042-1.18 0.042-1.71 0-17.8-4.864-34.458-13.308-48.752 27.35-17.3 45.308-46.338 45.308-79.254 0-16.924-4.762-32.816-13.090-46.624zM224 128h160c17.644 0 32 14.356 32 32s-14.356 32-32 32h-160c-17.644 0-32-14.356-32-32s14.356-32 32-32zM160 256h256c17.644 0 32 14.356 32 32s-14.356 32-32 32h-256c-17.644 0-32-14.356-32-32s14.356-32 32-32zM136 384h240c21.682 0 40 14.654 40 32s-18.318 32-40 32h-240c-21.682 0-40-14.654-40-32s18.318-32 40-32zM896 160c0-17.674 14.328-32 32-32s32 14.326 32 32-14.328 32-32 32-32-14.326-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-down",
						"dislike",
						"vote-down",
						"rate"
					],
					"defaultCode": 60662,
					"grid": 16
				},
				{
					"id": 2828,
					"paths": [
						"M32 416c0 32.916 17.956 61.954 45.308 79.248-8.444 14.292-13.308 30.952-13.308 48.752 0 53.020 42.98 96 96 96h187.808c-22.456 80.91-33.808 164.592-33.808 250 0 73.888 60.112 134 134 134 73.886 0 134-60.112 134-134 0-103.972 38.722-183.95 115.090-237.71 21-14.784 44.742-27.486 70.91-38.066v89.776h256v-640h-256v62.998c-59.89-3.932-88.968-18.922-117.19-33.494-28.088-14.506-57.132-29.504-106.81-29.504h-320c-53.020 0-96 42.98-96 96 0 12.498 2.414 24.426 6.76 35.376-40.77 11.086-70.76 48.342-70.76 92.624 0 17.8 4.864 34.46 13.308 48.752-27.352 17.294-45.308 46.332-45.308 79.248zM928 128c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32zM136 384h56v-64h-32c-17.644 0-32-14.356-32-32s14.356-32 32-32h64v-64c-17.644 0-32-14.356-32-32s14.356-32 32-32h320c34.128 0 52.298 9.382 77.446 22.37 31.748 16.392 70.386 36.32 146.554 40.728v342.222c-42.936 14.428-81.428 33.43-114.658 56.824-96.392 67.856-147.342 171.544-147.342 299.856 0 31.982-26.020 58-58 58s-58-26.018-58-58c0-85.66 12.414-169.412 36.96-250 6.198-23.018 12.066-45.826 16.024-64h-282.984c-17.644 0-32-14.356-32-32s14.356-32 32-32h32v-64h-56c-21.682 0-40-14.654-40-32s18.318-32 40-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-down",
						"dislike",
						"vote-down",
						"rate"
					],
					"defaultCode": 60663,
					"grid": 16
				},
				{
					"id": 2830,
					"paths": [
						"M96 448c-73 0-32-192 32-192-32 0 0-160 64-160 0-64 64-96 128-96 270.352 0 175.264 67.65 448 96v512c-240.922 72.268-480 253.424-480 416-53 0-192-64 0-384 0 0-160 0-192 0-96 0-64-192 0-192zM832 608v-512h-64v-32h128c35.2 0 64 43.2 64 96v384c0 52.8-28.8 96-64 96h-128v-32h64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-down",
						"dislike",
						"vote-down",
						"rate"
					],
					"defaultCode": 60665,
					"grid": 16
				},
				{
					"id": 1500,
					"width": 914.2870445251465,
					"paths": [
						"M146.286 329.143q0 14.857-10.857 25.714t-25.714 10.857q-15.429 0-26-10.857t-10.571-25.714q0-15.429 10.571-26t26-10.571q14.857 0 25.714 10.571t10.857 26zM237.714 621.714v-365.714q0-14.857-10.857-25.714t-25.714-10.857h-164.571q-14.857 0-25.714 10.857t-10.857 25.714v365.714q0 14.857 10.857 25.714t25.714 10.857h164.571q14.857 0 25.714-10.857t10.857-25.714zM882.857 536.571q31.429 34.857 31.429 85.143-0.571 44.571-32.857 77.143t-76.857 32.571h-158.286q2.286 8 4.571 13.714t6.286 12.571 5.714 10.286q10.286 21.143 15.429 32.571t10.857 33.429 5.714 43.714q0 13.714-0.286 22.286t-2.857 25.714-6.857 28.571-13.714 25.714-22.857 23.143-34.286 14.857-47.143 6q-14.857 0-25.714-10.857-11.429-11.429-19.429-28.571t-11.143-29.714-7.143-34.857q-5.143-24-7.714-34.571t-10-27.714-17.714-27.429q-18.857-18.857-57.714-68.571-28-36.571-57.714-69.143t-43.429-33.714q-14.286-1.143-24.571-11.714t-10.286-24.857v-366.286q0-14.857 10.857-25.429t25.714-11.143q20-0.571 90.286-25.143 44-14.857 68.857-22.571t69.429-16.571 82.286-8.857h73.714q76 1.143 112.571 44.571 33.143 39.429 28 103.429 22.286 21.143 30.857 53.714 9.714 34.857 0 66.857 26.286 34.857 24.571 78.286 0 18.286-8.571 43.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-down"
					],
					"defaultCode": 61797,
					"grid": 14
				},
				{
					"id": 205,
					"paths": [
						"M968.517 450.149c22.662 26.155 35.565 69.381 35.565 110.541 0 27.17-5.899 50.974-17.056 68.842-14.526 23.259-37.762 36.069-65.426 36.069h-134.053c72.966 132.683 91.408 232.587 54.766 297.302-25.534 45.096-72.366 61.098-104.714 61.098-12.811 0-23.65-9.469-25.368-22.165-9.147-67.554-60.811-148.131-141.742-221.074-77.518-69.869-172.765-125.768-270.642-159.208-12.317 26.010-38.811 44.046-69.448 44.046h-153.6c-42.347 0-76.8-34.453-76.8-76.8v-460.8c0-42.347 34.453-76.8 76.8-76.8h153.6c32.437 0 60.222 20.226 71.459 48.718 100.421-12.57 138.195-32.754 174.794-52.314 45.802-24.482 89.062-47.605 230.547-47.605 36.854 0 71.587 9.624 97.8 27.101 25.61 17.074 41.968 41.006 47.4 68.755 20.414 8.283 38.544 27.426 52.454 55.893 13.53 27.688 22.272 63.077 22.272 90.166 0 5.069-0.296 9.726-0.89 14.014 12.944 9.528 24.56 24.243 34.152 43.592 13.837 27.912 22.099 62.866 22.099 93.494 0 21.694-4.027 39.802-11.968 53.822-0.645 1.128-1.312 2.234-2.003 3.31zM230.4 102.4h-153.6c-14.115 0-25.6 11.485-25.6 25.6v460.8c0 14.115 11.485 25.6 25.6 25.6h153.6c14.115 0 25.6-11.485 25.6-25.6v-460.738c0-0.022 0-0.043 0-0.066-0.002-14.114-11.486-25.597-25.6-25.597zM938.944 497.986c-7.739-15.546-15.57-21.186-18.944-21.186-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6c2.149 0 3.699 0 5.971-4.008 3.378-5.965 5.315-16.382 5.315-28.582 0-22.77-6.427-49.883-16.771-70.754-10.131-20.437-20.451-27.856-24.915-27.856-14.139 0-25.6-11.461-25.6-25.6 0-9.067 4.715-17.034 11.827-21.582 1.581-16.206-5.976-59.629-25.627-87.947-7.438-10.722-15.238-16.87-21.4-16.87-14.139 0-25.6-11.461-25.6-25.6 0-45.072-49.765-65.6-96-65.6-128.659 0-164.691 19.259-206.413 41.56-38.992 20.84-82.864 44.29-193.587 58.085v419.179c107.558 35.258 212.589 96.114 297.566 172.704 81.554 73.502 135.12 152.979 153.286 226.603 13.933-4.477 29.651-13.896 39.706-31.656 17.096-30.192 29.896-107.299-76.43-284.506-4.746-7.909-4.87-17.758-0.325-25.784s13.053-12.987 22.277-12.987h178.32c10.17 0 16.749-3.586 21.998-11.99 5.986-9.586 9.283-24.402 9.283-41.72 0-21.733-5.211-45.174-13.938-62.702z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-down",
						"dislike"
					],
					"defaultCode": 59502,
					"grid": 20
				},
				{
					"id": 1307,
					"width": 877.7149429321289,
					"paths": [
						"M146.286 256q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM804.571 585.143q0-20-12.286-46.286t-30.571-26.857q8.571-9.714 14.286-27.143t5.714-31.714q0-39.429-30.286-68 10.286-18.286 10.286-39.429t-10-42-27.143-30q2.857-17.143 2.857-32 0-48.571-28-72t-77.714-23.429h-73.143q-74.857 0-195.429 41.714-2.857 1.143-16.571 6t-20.286 7.143-20 6.571-21.714 6.286-18.857 3.714-18 1.714h-18.286v365.714h18.286q9.143 0 20.286 5.143t22.857 15.429 22 20.286 22.857 25.143 19.714 24.286 18 23.429 13.143 17.143q31.429 38.857 44 52 23.429 24.571 34 62.571t17.429 71.714 21.714 48.571q54.857 0 73.143-26.857t18.286-82.857q0-33.714-27.429-91.714t-27.429-91.143h201.143q28.571 0 50.857-22t22.286-51.143zM877.714 585.714q0 58.857-43.429 102.286t-102.857 43.429h-100.571q27.429 56.571 27.429 109.714 0 67.429-20 106.286-20 39.429-58.286 58t-86.286 18.571q-29.143 0-51.429-21.143-19.429-18.857-30.857-46.857t-14.571-51.714-10-48.286-17.714-36.571q-27.429-28.571-61.143-72.571-57.714-74.857-78.286-88.571h-156.571q-30.286 0-51.714-21.429t-21.429-51.714v-365.714q0-30.286 21.429-51.714t51.714-21.429h164.571q12.571 0 78.857-22.857 73.143-25.143 127.429-37.714t114.286-12.571h64q80 0 129.429 45.143t48.857 123.429v2.857q34.286 44 34.286 101.714 0 12.571-1.714 24.571 21.714 38.286 21.714 82.286 0 20.571-5.143 39.429 28 42.286 28 93.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-o-down"
					],
					"defaultCode": 61576,
					"grid": 14
				},
				{
					"id": 1306,
					"width": 877.7181167602539,
					"paths": [
						"M146.286 768q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM804.571 438.857q0-29.143-22.286-51.143t-50.857-22h-201.143q0-33.143 27.429-91.143t27.429-91.714q0-56-18.286-82.857t-73.143-26.857q-14.857 14.857-21.714 48.571t-17.429 71.714-34 62.571q-12.571 13.143-44 52-2.286 2.857-13.143 17.143t-18 23.429-19.714 24.286-22.857 25.143-22 20.286-22.857 15.429-20.286 5.143h-18.286v365.714h18.286q7.429 0 18 1.714t18.857 3.714 21.714 6.286 20 6.571 20.286 7.143 16.571 6q120.571 41.714 195.429 41.714h69.143q109.714 0 109.714-95.429 0-14.857-2.857-32 17.143-9.143 27.143-30t10-42-10.286-39.429q30.286-28.571 30.286-68 0-14.286-5.714-31.714t-14.286-27.143q18.286-0.571 30.571-26.857t12.286-46.286zM877.714 438.286q0 50.857-28 93.143 5.143 18.857 5.143 39.429 0 44-21.714 82.286 1.714 12 1.714 24.571 0 57.714-34.286 101.714 0.571 79.429-48.571 125.429t-129.714 46h-73.714q-54.857 0-108.286-12.857t-123.714-37.429q-66.286-22.857-78.857-22.857h-164.571q-30.286 0-51.714-21.429t-21.429-51.714v-365.714q0-30.286 21.429-51.714t51.714-21.429h156.571q20.571-13.714 78.286-88.571 33.143-42.857 61.143-73.143 13.714-14.286 20.286-48.857t17.429-72.286 35.429-61.714q22.286-21.143 51.429-21.143 48 0 86.286 18.571t58.286 58 20 106.286q0 53.143-27.429 109.714h100.571q59.429 0 102.857 43.429t43.429 102.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-o-up"
					],
					"defaultCode": 61575,
					"grid": 14
				},
				{
					"id": 2825,
					"paths": [
						"M992 672c0-32.916-17.956-61.954-45.308-79.248 8.444-14.292 13.308-30.952 13.308-48.752 0-53.020-42.98-96-96-96h-187.808c22.456-80.91 33.808-164.592 33.808-250 0-73.888-60.112-134-134-134-73.886 0-134 60.112-134 134 0 103.972-38.722 183.95-115.090 237.71-21 14.784-44.742 27.486-70.91 38.066v-89.776h-256v640h256v-62.998c59.89 3.932 88.968 18.922 117.19 33.494 28.088 14.506 57.132 29.504 106.81 29.504h320c53.020 0 96-42.98 96-96 0-12.498-2.414-24.426-6.76-35.376 40.77-11.086 70.76-48.342 70.76-92.624 0-17.8-4.864-34.46-13.308-48.752 27.352-17.294 45.308-46.332 45.308-79.248zM672 512h192c17.644 0 32 14.356 32 32s-14.356 32-32 32h-192c-17.644 0-32-14.356-32-32s14.356-32 32-32zM557.090 718.624c-27.074 16.974-45.090 47.064-45.090 81.376 0 34 17.692 63.85 44.354 80.906-7.852 13.916-12.354 29.974-12.354 47.094 0 11.222 1.946 21.988 5.484 32h-69.484c-34.128 0-52.298-9.382-77.446-22.37-31.748-16.392-70.386-36.32-146.554-40.728v-342.222c42.936-14.428 81.428-33.43 114.658-56.824 96.392-67.856 147.342-171.544 147.342-299.856 0-31.982 26.020-58 58-58s58 26.018 58 58c0 85.66-12.414 169.412-36.96 250-6.66 24.74-12.94 49.228-16.876 67.99-2.542 8.34-3.96 17.164-4.122 26.294-0.030 0.602-0.042 1.18-0.042 1.71 0 17.8 4.864 34.458 13.308 48.752-27.35 17.3-45.308 46.338-45.308 79.254 0 16.924 4.762 32.816 13.090 46.624zM800 960h-160c-17.644 0-32-14.356-32-32s14.356-32 32-32h160c17.644 0 32 14.356 32 32s-14.356 32-32 32zM864 832h-256c-17.644 0-32-14.356-32-32s14.356-32 32-32h256c17.644 0 32 14.356 32 32s-14.356 32-32 32zM888 704h-240c-21.682 0-40-14.654-40-32s18.318-32 40-32h240c21.682 0 40 14.654 40 32s-18.318 32-40 32zM128 928c0 17.674-14.328 32-32 32s-32-14.326-32-32 14.328-32 32-32 32 14.326 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-up",
						"like",
						"vote-up",
						"rate"
					],
					"defaultCode": 60660,
					"grid": 16
				},
				{
					"id": 2826,
					"paths": [
						"M992 672c0-32.916-17.956-61.954-45.308-79.248 8.444-14.292 13.308-30.952 13.308-48.752 0-53.020-42.98-96-96-96h-187.808c22.456-80.91 33.808-164.592 33.808-250 0-73.888-60.112-134-134-134-73.886 0-134 60.112-134 134 0 103.972-38.722 183.95-115.090 237.71-21 14.784-44.742 27.486-70.91 38.066v-89.776h-256v640h256v-62.998c59.89 3.932 88.968 18.922 117.19 33.494 28.088 14.506 57.132 29.504 106.81 29.504h320c53.020 0 96-42.98 96-96 0-12.498-2.414-24.426-6.76-35.376 40.77-11.086 70.76-48.342 70.76-92.624 0-17.8-4.864-34.46-13.308-48.752 27.352-17.294 45.308-46.332 45.308-79.248zM96 960c-17.672 0-32-14.326-32-32s14.328-32 32-32 32 14.326 32 32-14.328 32-32 32zM888 704h-56v64h32c17.644 0 32 14.356 32 32s-14.356 32-32 32h-64v64c17.644 0 32 14.356 32 32s-14.356 32-32 32h-320c-34.128 0-52.298-9.382-77.446-22.37-31.748-16.392-70.386-36.32-146.554-40.728v-342.222c42.936-14.428 81.428-33.43 114.658-56.824 96.392-67.856 147.342-171.544 147.342-299.856 0-31.982 26.020-58 58-58s58 26.018 58 58c0 85.66-12.414 169.412-36.96 250-6.198 23.018-12.066 45.826-16.024 64h282.984c17.644 0 32 14.356 32 32s-14.356 32-32 32h-32v64h56c21.682 0 40 14.654 40 32s-18.318 32-40 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-up",
						"like",
						"vote-up",
						"rate"
					],
					"defaultCode": 60661,
					"grid": 16
				},
				{
					"id": 2829,
					"paths": [
						"M928 576c73 0 32 192-32 192 32 0 0 160-64 160 0 64-64 96-128 96-270.352 0-175.264-67.65-448-96v-512c240.922-72.268 480-253.424 480-416 53 0 192 64 0 384 0 0 160 0 192 0 96 0 64 192 0 192zM192 416v512h64v32h-128c-35.2 0-64-43.2-64-96v-384c0-52.8 28.8-96 64-96h128v32h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-up",
						"like",
						"vote-up",
						"rate"
					],
					"defaultCode": 60664,
					"grid": 16
				},
				{
					"id": 1499,
					"width": 914.2880821228027,
					"paths": [
						"M146.286 768q0-14.857-10.857-25.714t-25.714-10.857q-15.429 0-26 10.857t-10.571 25.714q0 15.429 10.571 26t26 10.571q14.857 0 25.714-10.571t10.857-26zM237.714 475.429v365.714q0 14.857-10.857 25.714t-25.714 10.857h-164.571q-14.857 0-25.714-10.857t-10.857-25.714v-365.714q0-14.857 10.857-25.714t25.714-10.857h164.571q14.857 0 25.714 10.857t10.857 25.714zM914.286 475.429q0 49.143-31.429 85.143 8.571 25.143 8.571 43.429 1.714 43.429-24.571 78.286 9.714 32 0 66.857-8.571 32.571-30.857 53.714 5.143 64-28 103.429-36.571 43.429-112.571 44.571h-73.714q-37.714 0-82.286-8.857t-69.429-16.571-68.857-22.571q-70.286-24.571-90.286-25.143-14.857-0.571-25.714-11.143t-10.857-25.429v-366.286q0-14.286 10.286-24.857t24.571-11.714q13.714-1.143 43.429-33.714t57.714-69.143q38.857-49.714 57.714-68.571 10.286-10.286 17.714-27.429t10-27.714 7.714-34.571q4-22.286 7.143-34.857t11.143-29.714 19.429-28.571q10.857-10.857 25.714-10.857 26.286 0 47.143 6t34.286 14.857 22.857 23.143 13.714 25.714 6.857 28.571 2.857 25.714 0.286 22.286q0 21.714-5.429 43.429t-10.857 34.286-15.714 32q-1.714 3.429-5.714 10.286t-6.286 12.571-4.571 13.714h158.286q44.571 0 77.143 32.571t32.571 77.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-up"
					],
					"defaultCode": 61796,
					"grid": 14
				},
				{
					"id": 204,
					"paths": [
						"M968.517 573.851c22.662-26.155 35.565-69.381 35.565-110.541 0-27.17-5.899-50.974-17.056-68.842-14.526-23.259-37.762-36.069-65.426-36.069h-134.053c72.966-132.683 91.408-232.587 54.766-297.302-25.534-45.096-72.366-61.098-104.714-61.098-12.811 0-23.65 9.469-25.368 22.165-9.147 67.554-60.811 148.131-141.742 221.074-77.518 69.869-172.765 125.768-270.642 159.208-12.317-26.010-38.811-44.046-69.448-44.046h-153.6c-42.347 0-76.8 34.453-76.8 76.8v460.8c0 42.347 34.453 76.8 76.8 76.8h153.6c32.437 0 60.222-20.226 71.459-48.718 100.421 12.57 138.195 32.754 174.794 52.314 45.802 24.482 89.062 47.605 230.547 47.605 36.854 0 71.587-9.624 97.8-27.101 25.61-17.074 41.968-41.006 47.4-68.755 20.414-8.283 38.544-27.426 52.454-55.893 13.53-27.688 22.272-63.077 22.272-90.166 0-5.069-0.296-9.726-0.89-14.014 12.944-9.528 24.56-24.243 34.152-43.592 13.837-27.912 22.099-62.866 22.099-93.494 0-21.694-4.027-39.802-11.968-53.822-0.645-1.128-1.312-2.234-2.003-3.31zM230.4 921.6h-153.6c-14.115 0-25.6-11.485-25.6-25.6v-460.8c0-14.115 11.485-25.6 25.6-25.6h153.6c14.115 0 25.6 11.485 25.6 25.6v460.738c0 0.022 0 0.043 0 0.066-0.002 14.114-11.486 25.597-25.6 25.597zM938.944 526.014c-7.739 15.546-15.57 21.186-18.944 21.186-14.139 0-25.6 11.461-25.6 25.6s11.461 25.6 25.6 25.6c2.149 0 3.699 0 5.971 4.008 3.378 5.965 5.315 16.382 5.315 28.582 0 22.77-6.427 49.883-16.771 70.754-10.131 20.437-20.451 27.856-24.915 27.856-14.139 0-25.6 11.461-25.6 25.6 0 9.067 4.715 17.034 11.827 21.582 1.581 16.206-5.976 59.629-25.627 87.947-7.438 10.722-15.238 16.87-21.4 16.87-14.139 0-25.6 11.461-25.6 25.6 0 45.072-49.765 65.6-96 65.6-128.659 0-164.691-19.259-206.413-41.56-38.992-20.84-82.864-44.29-193.587-58.085v-419.179c107.558-35.258 212.589-96.114 297.566-172.704 81.554-73.502 135.12-152.979 153.286-226.603 13.933 4.477 29.651 13.896 39.706 31.656 17.096 30.192 29.896 107.299-76.43 284.506-4.746 7.909-4.87 17.758-0.325 25.784s13.053 12.987 22.277 12.987h178.32c10.17 0 16.749 3.586 21.998 11.99 5.986 9.586 9.283 24.402 9.283 41.72 0 21.733-5.211 45.174-13.938 62.702z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thumbs-up",
						"like"
					],
					"defaultCode": 59501,
					"grid": 20
				},
				{
					"id": 885,
					"width": 1024,
					"paths": [
						"M768 288c0-141.376-114.624-256-256-256-119.712 0-219.936 82.304-247.936 193.312-117.152 12.448-207.36 115.168-199.584 237.312 7.52 118.592 109.184 209.376 228.032 209.376h75.488l-62.624 125.28c-8 15.968 3.616 34.72 21.44 34.72h57.184l-43.392 108.48c-5.952 14.912 11.296 28.32 24.256 18.88l247.424-179.968c18.816-13.664 9.152-43.392-14.080-43.392h-22.208l64-64h123.68c104.8 0 193.568-82.176 196.256-186.944 2.784-108.352-84.224-197.056-191.936-197.056zM498.752 768h74.848l-182.656 132.832 40.32-100.832h-91.488l64-128h190.976l-96 96zM768 640h-480c-105.856 0-192-86.144-192-192 0-98.432 73.696-180.48 171.424-190.848l22.176-2.368 5.472-21.632c25.12-99.584 114.336-169.152 216.928-169.152 123.52 0 224 100.48 224 224v32h32c88.224 0 160 71.776 160 160s-71.776 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thunder",
						"rain",
						"storm"
					],
					"grid": 32
				},
				{
					"id": 886,
					"width": 1024,
					"paths": [
						"M64.48 462.624c-7.776-122.144 82.432-224.864 199.584-237.312 28-111.008 128.224-193.312 247.936-193.312 141.376 0 256 114.624 256 256 107.712 0 194.72 88.704 191.936 197.056-2.688 104.768-91.456 186.944-196.256 186.944h-471.168c-118.848 0-220.512-90.784-228.032-209.376zM598.208 736h-22.208l32-32h-256l-46.624 93.28c-8 15.968 3.616 34.72 21.44 34.72h57.184l-43.392 108.48c-5.952 14.912 11.296 28.32 24.256 18.88l247.424-179.968c18.816-13.664 9.152-43.392-14.080-43.392z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"thunder",
						"rain",
						"storm"
					],
					"grid": 32
				},
				{
					"id": 2062,
					"paths": [
						"M575.996 320l127.998 127.998-255.994 255.994-127.998-127.998zM1001.526 297.504l-73.516-73.516-32.008 32.008c-16.378 16.38-39.010 26.51-64 26.51-49.988 0-90.514-40.522-90.514-90.51 0-25.002 10.14-47.638 26.534-64.018l31.988-31.986-73.518-73.516c-29.968-29.968-79.008-29.968-108.976 0l-595.040 595.038c-29.966 29.968-29.966 79.010 0 108.976l73.52 73.518 31.962-31.964c16.382-16.406 39.030-26.552 64.044-26.552 49.988 0 90.51 40.524 90.51 90.51 0 25.006-10.14 47.64-26.534 64.022l-31.984 31.986 73.516 73.518c29.966 29.966 79.008 29.966 108.976 0l595.040-595.040c29.964-29.976 29.964-79.016 0-108.984zM448.002 831.996l-256-256 384-384 256 256-384 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ticket",
						"theater",
						"cinema"
					],
					"defaultCode": 59897,
					"grid": 16
				},
				{
					"id": 2063,
					"width": 1088,
					"paths": [
						"M1024 384v-144c0-26.4-21.6-48-48-48h-736c8.836 0 16 7.164 16 16s-7.164 16-16 16-16-7.164-16-16 7.164-16 16-16h-192c-26.4 0-48 21.6-48 48v144c70.694 0 128 57.308 128 128 0 70.694-57.306 128-128 128v144c0 26.4 21.6 48 48 48h192c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.164 16-16 16h736c26.4 0 48-21.6 48-48v-144c-70.694 0-128-57.306-128-128 0-70.692 57.308-128 128-128zM240 768c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.162 16-16 16zM240 704c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.162 16-16 16zM240 640c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.162 16-16 16zM240 576c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.162 16-16 16zM240 480c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.162 16-16 16zM240 416c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.162 16-16 16zM240 352c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.162 16-16 16zM240 288c-8.836 0-16-7.164-16-16s7.164-16 16-16 16 7.164 16 16-7.162 16-16 16zM663.854 676.964l-119.854-87.082-119.856 87.082 45.782-140.896-119.854-87.078h148.146l45.782-140.898 45.78 140.898h148.148l-119.856 87.078 45.782 140.896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ticket",
						"theater",
						"cinema"
					],
					"defaultCode": 59898,
					"grid": 16
				},
				{
					"id": 1470,
					"width": 1024.5710105895996,
					"paths": [
						"M585.143 258.286l180.571 180.571-326.857 326.857-180.571-180.571zM464.571 817.714l353.143-353.143q10.857-10.857 10.857-25.714t-10.857-25.714l-206.857-206.857q-10.286-10.286-25.714-10.286t-25.714 10.286l-353.143 353.143q-10.857 10.857-10.857 25.714t10.857 25.714l206.857 206.857q10.286 10.286 25.714 10.286t25.714-10.286zM972.571 453.714l-518.286 518.857q-21.143 21.143-51.714 21.143t-51.714-21.143l-72-72q32-32 32-77.714t-32-77.714-77.714-32-77.714 32l-71.429-72q-21.143-21.143-21.143-51.714t21.143-51.714l518.286-517.714q21.143-21.143 51.714-21.143t51.714 21.143l71.429 71.429q-32 32-32 77.714t32 77.714 77.714 32 77.714-32l72 71.429q21.143 21.143 21.143 51.714t-21.143 51.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ticket"
					],
					"defaultCode": 61765,
					"grid": 14
				},
				{
					"id": 2345,
					"paths": [
						"M512 1026.744c-9.024 0-17.63-3.81-23.696-10.492l-157.262-173.262c-6.824-7.518-9.674-17.828-7.684-27.784l124.204-621.018-120.158-141.474c-8.074-9.506-9.888-22.834-4.652-34.152 5.236-11.316 16.57-18.562 29.042-18.562h320.414c12.47 0 23.804 7.246 29.042 18.564 5.236 11.318 3.42 24.648-4.652 34.152l-120.16 141.474 124.206 621.018c1.99 9.956-0.862 20.266-7.684 27.784l-157.264 173.262c-6.066 6.68-14.67 10.49-23.696 10.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tie"
					],
					"defaultCode": 60180,
					"grid": 16
				},
				{
					"id": 887,
					"width": 1024,
					"paths": [
						"M895.648 252.352c-19.040 0-38.56 5.76-56.096 18.528l-177.152 128.832c-19.072-46.72-64.832-79.712-118.4-79.712h-64c-53.568 0-99.328 32.992-118.4 79.712l-177.12-128.832c-17.568-12.768-37.088-18.528-56.128-18.528-49.76 0-96.352 39.424-96.352 96.16v326.944c0 56.768 46.56 96.16 96.352 96.16 19.040 0 38.56-5.76 56.096-18.528l177.12-128.832c19.104 46.752 64.864 79.744 118.432 79.744h64c53.568 0 99.328-32.992 118.4-79.712l177.12 128.832c17.568 12.768 37.056 18.528 56.096 18.528 49.792 0 96.352-39.424 96.352-96.16v-326.976c0.032-56.736-46.56-96.16-96.32-96.16zM64 348.512c0-39.648 33.408-64.16 64.352-64.16 13.216 0 26.112 4.288 37.28 12.416l15.616 11.36-117.248 117.248v-76.864zM64 470.624l143.456-143.456 66.432 48.32-209.888 209.888v-114.752zM352 591.712l-186.368 135.52c-11.168 8.128-24.064 12.416-37.28 12.416-4.032 0-8.096-0.448-12.128-1.28l235.776-235.744v89.088zM352 457.376l-266.080 266.080c-12.896-11.136-21.92-27.488-21.92-47.968v-44.864l236.096-236.096 51.904 37.76v25.088zM384 448c0-52.928 43.072-96 96-96h9.376l-105.376 105.376v-9.376zM390.72 610.656c-4.192-10.784-6.72-22.4-6.72-34.656v-73.376l150.624-150.624h9.376c28.864 0 54.464 13.056 72.096 33.28l-225.376 225.376zM640 576c0 52.928-43.072 96-96 96h-9.376l105.376-105.376v9.376zM640 521.376l-150.624 150.624h-9.376c-28.864 0-54.464-13.056-72.096-33.28l225.376-225.376c4.192 10.784 6.72 22.4 6.72 34.656v73.376zM672 432.288l186.368-135.52c11.168-8.128 24.064-12.416 37.28-12.416 4.032 0 8.096 0.448 12.128 1.28l-235.776 235.744v-89.088zM960 675.488c0 39.648-33.408 64.16-64.352 64.16-13.216 0-26.112-4.288-37.28-12.416l-15.616-11.36 117.248-117.248v76.864zM960 553.376l-143.456 143.456-66.432-48.32 209.888-209.888v114.752zM960 393.376l-236.096 236.096-51.904-37.76v-25.088l266.080-266.080c12.896 11.136 21.92 27.488 21.92 47.968v44.864z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tie",
						"groom",
						"dress"
					],
					"grid": 32
				},
				{
					"id": 888,
					"width": 1024,
					"paths": [
						"M544 320h-64c-70.688 0-128 57.312-128 128v128c0 70.688 57.312 128 128 128h64c70.688 0 128-57.312 128-128v-128c0-70.688-57.312-128-128-128zM384 464.064v-0.448c0-4.192 1.664-8.224 4.64-11.2l95.872-95.872c2.976-2.976 7.008-4.64 11.2-4.64h0.448c14.112 0 21.184 17.056 11.2 27.040l-96.32 96.32c-9.984 9.984-27.040 2.912-27.040-11.2zM421.088 625.216c-7.584 7.552-20.128 5.504-25.28-3.872-0.064-0.096-0.096-0.192-0.16-0.288-3.328-6.080-2.016-13.664 2.88-18.528l204.288-204.256c7.232-7.232 19.584-6.016 24.672 2.848 0.256 0.416 0.48 0.832 0.704 1.28 3.36 6.080 2.048 13.696-2.848 18.592l-204.256 204.224zM640 559.296v0.448c0 4.192-1.664 8.224-4.64 11.2l-96.32 96.32c-2.976 2.976-7.008 4.64-11.2 4.64h-0.448c-14.112 0-21.184-17.056-11.2-27.040l96.768-96.768c9.984-9.984 27.040-2.912 27.040 11.2zM335.392 380.64l-150.912-109.76c-63.456-46.144-152.48-0.832-152.48 77.632v326.944c0 78.464 89.024 123.776 152.48 77.632l150.912-109.76c-9.632-20.512-15.392-43.2-15.392-67.328v-128c0-24.128 5.76-46.816 15.392-67.36zM64 431.68c0-4.256 1.696-8.32 4.672-11.328l102.784-102.784c5.568-5.568 14.368-6.24 20.736-1.632v0c7.936 5.792 8.864 17.312 1.888 24.256l-102.784 102.784c-10.080 10.080-27.296 2.944-27.296-11.296v0zM288 559.68c0 4.256-1.696 8.32-4.672 11.328l-160.576 160.544c-4.32 4.32-10.784 5.984-16.512 3.84-0.416-0.16-0.864-0.32-1.28-0.512-10.432-4.16-12.8-18.016-4.832-25.952l160.576-160.576c10.080-10.048 27.296-2.912 27.296 11.328v0zM284.32 409.984l-193.024 192.992c-10.080 10.080-27.296 2.944-27.296-11.296v0c0-4.256 1.696-8.32 4.672-11.328l193.024-192.992c6.528-6.528 17.248-6.176 23.328 0.768 5.568 6.336 5.248 15.904-0.704 21.856zM839.52 270.88l-150.912 109.76c9.632 20.544 15.392 43.232 15.392 67.36v128c0 24.128-5.76 46.816-15.392 67.36l150.912 109.76c63.456 46.144 152.48 0.832 152.48-77.632v-326.976c0-78.464-89.024-123.776-152.48-77.632zM736 463.584c0-4.192 1.664-8.192 4.608-11.136l160.448-160.416c4.256-4.256 10.592-5.888 16.224-3.808 0.576 0.224 1.184 0.448 1.76 0.672 10.304 4.128 12.64 17.76 4.8 25.6l-160.928 160.928c-9.952 9.92-26.912 2.88-26.912-11.168v-0.672zM960 591.776c0 4.192-1.664 8.192-4.608 11.136l-103.232 103.232c-5.472 5.472-14.144 6.176-20.416 1.6l-0.384-0.288c-7.84-5.696-8.736-17.056-1.888-23.904l103.648-103.616c9.92-9.92 26.912-2.88 26.912 11.136v0.704zM960 431.776c0 4.192-1.664 8.192-4.608 11.136l-193.952 193.92c-6.368 6.368-16.8 6.112-22.848-0.576-0.096-0.128-0.224-0.224-0.32-0.352-5.632-6.24-5.376-15.776 0.544-21.728l194.272-194.24c9.952-9.888 26.912-2.848 26.912 11.168v0.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tie",
						"groom",
						"dress"
					],
					"grid": 32
				},
				{
					"id": 1157,
					"width": 1024,
					"paths": [
						"M678.432 575.168c-4.48-66.304-14.016-132.704-28.352-197.312l-28.672-128.96c32.032-27.040 50.592-64.896 50.592-104.896 0-144-92.48-144-160-144-45.984 0-93.536 0-126.368 33.312-23.36 23.68-33.632 52.192-33.632 111.136 0 39.744 19.136 77.344 50.656 104.192l-28.736 129.216c-14.336 64.608-23.872 131.008-28.352 197.344l-19.904 298.688c-4.224 63.872 39.904 121.472 102.624 134.016l14.656 2.944c22.688 4.576 45.92 6.848 69.056 6.848s46.368-2.272 69.024-6.848l14.688-2.944c62.72-12.544 106.848-70.112 102.624-134.016l-19.904-298.72zM606.080 935.456l-206.592-206.592 3.168-47.584 226.432 226.432c-4.896 11.2-12.8 20.896-23.008 27.744zM527.488 952.864l-134.016-134.016 3.168-47.584 175.968 175.968-4.16 0.832c-13.472 2.688-27.2 4.064-40.96 4.8zM405.824 639.2l-0.384 0.384 3.232-48.288 220.032 220.032 1.248-1.248 3.808 57.056-227.936-227.936zM416 143.552c-0.48-32.64 4.64-54.592 15.2-65.312 12.864-13.056 40.224-14.080 72.288-14.176l-86.56 86.56c-0.256-2.368-0.896-4.672-0.928-7.072zM548.224 64.576c18.336 0.992 31.712 3.84 41.152 11.392l-132.736 132.768c-11.072-6.72-20.224-15.392-27.136-25.408l118.72-118.752zM608 144c0 4.352-0.736 8.544-1.536 12.704l-62.368 62.368c-10.080 3.008-20.8 4.928-32.096 4.928-7.872 0-15.424-1.056-22.784-2.592l115.776-115.776c2.048 10.144 3.008 22.656 3.008 38.368zM587.584 391.712c4.064 18.24 6.88 36.864 10.112 55.36l-142.016-142.016 9.216-41.536 121.12 121.12 1.568 7.072zM447.456 342.080l158.848 158.848c2.464 18.848 4.352 37.792 5.952 56.704l-174.048-174.048 9.248-41.504zM501.728 255.104c3.424 0.224 6.752 0.896 10.272 0.896 15.456 0 30.112-2.784 43.808-7.168l17.248 77.632-71.328-71.36zM616.416 607.040l3.616 54.368-196.928-196.928c2.304-14.4 5.024-28.672 7.84-42.912l185.472 185.472zM623.264 709.888l3.616 54.368-214.336-214.336c1.408-15.328 2.88-30.656 4.832-45.92l205.888 205.888zM440.832 945.12c-31.36-6.272-53.44-35.072-51.328-67.008l1.12-16.832 90.624 90.624c-8.64-0.928-17.248-2.144-25.728-3.84l-14.688-2.944z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tie",
						"wear"
					],
					"grid": 32
				},
				{
					"id": 1261,
					"width": 877.7139282226562,
					"paths": [
						"M656.571 641.143q0-14.857-10.857-25.714l-103.429-103.429 103.429-103.429q10.857-10.857 10.857-25.714 0-15.429-10.857-26.286l-51.429-51.429q-10.857-10.857-26.286-10.857-14.857 0-25.714 10.857l-103.429 103.429-103.429-103.429q-10.857-10.857-25.714-10.857-15.429 0-26.286 10.857l-51.429 51.429q-10.857 10.857-10.857 26.286 0 14.857 10.857 25.714l103.429 103.429-103.429 103.429q-10.857 10.857-10.857 25.714 0 15.429 10.857 26.286l51.429 51.429q10.857 10.857 26.286 10.857 14.857 0 25.714-10.857l103.429-103.429 103.429 103.429q10.857 10.857 25.714 10.857 15.429 0 26.286-10.857l51.429-51.429q10.857-10.857 10.857-26.286zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"times-circle"
					],
					"defaultCode": 61527,
					"grid": 14
				},
				{
					"id": 1266,
					"width": 877.7139282226562,
					"paths": [
						"M626.857 616.571l-83.429 83.429q-5.714 5.714-13.143 5.714t-13.143-5.714l-78.286-78.286-78.286 78.286q-5.714 5.714-13.143 5.714t-13.143-5.714l-83.429-83.429q-5.714-5.714-5.714-13.143t5.714-13.143l78.286-78.286-78.286-78.286q-5.714-5.714-5.714-13.143t5.714-13.143l83.429-83.429q5.714-5.714 13.143-5.714t13.143 5.714l78.286 78.286 78.286-78.286q5.714-5.714 13.143-5.714t13.143 5.714l83.429 83.429q5.714 5.714 5.714 13.143t-5.714 13.143l-78.286 78.286 78.286 78.286q5.714 5.714 5.714 13.143t-5.714 13.143zM749.714 512q0-84.571-41.714-156t-113.143-113.143-156-41.714-156 41.714-113.143 113.143-41.714 156 41.714 156 113.143 113.143 156 41.714 156-41.714 113.143-113.143 41.714-156zM877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"times-circle-o"
					],
					"defaultCode": 61532,
					"grid": 14
				},
				{
					"id": 1242,
					"width": 585.1460418701172,
					"paths": [
						"M292.571 658.286q0-20.571-11.429-39.429-0.571-0.571-8.857-12.857t-14.571-21.714-14.286-25.143-12-28.857q-2.286-9.143-12-9.143t-12 9.143q-4 13.143-12 28.857t-14.286 25.143-14.571 21.714-8.857 12.857q-11.429 18.857-11.429 39.429 0 30.286 21.429 51.714t51.714 21.429 51.714-21.429 21.429-51.714zM585.143 585.143q0 121.143-85.714 206.857t-206.857 85.714-206.857-85.714-85.714-206.857q0-82.857 46.286-157.143 3.429-5.143 35.714-51.714t57.714-86.286 56.857-101.714 47.429-115.143q5.143-17.143 19.429-26.857t29.143-9.714 29.429 9.714 19.143 26.857q16 53.143 47.429 115.143t56.857 101.714 57.714 86.286 35.714 51.714q46.286 72.571 46.286 157.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tint"
					],
					"defaultCode": 61507,
					"grid": 14
				},
				{
					"id": 889,
					"width": 1024,
					"paths": [
						"M918.848 849.824c-4.416-7.648-14.208-10.272-21.856-5.856l-83.136 48-144.8-250.816c50.624-38.432 66.4-108.992 33.792-165.44l-43.040-74.56 123.040-213.12c8.832-15.296 3.584-34.88-11.712-43.712l-166.272-96c-15.296-8.832-34.88-3.584-43.712 11.712l-49.152 85.088-49.152-85.12c-8.832-15.296-28.416-20.544-43.712-11.712l-166.272 96c-15.296 8.832-20.544 28.416-11.712 43.712l123.040 213.12-43.040 74.56c-32.608 56.48-16.832 127.040 33.792 165.44l-144.8 250.816-83.136-48c-7.648-4.416-17.44-1.792-21.856 5.856s-1.792 17.44 5.856 21.856l193.984 112c7.648 4.416 17.44 1.792 21.856-5.856s1.792-17.44-5.856-21.856l-83.136-48 144.8-250.816c43.808 18.432 93.28 10.816 129.12-17.76 35.904 28.704 85.664 36.224 129.568 17.76l144.8 250.816-83.136 48c-7.648 4.416-10.272 14.208-5.856 21.856s14.208 10.272 21.856 5.856l193.984-112c7.648-4.384 10.272-14.176 5.856-21.824zM641.344 369.12l-28.384-49.12h56.736l-28.352 49.12zM588.864 76l166.272 96-66.944 116h-93.696l-64-110.848 58.368-101.152zM268.864 172l166.272-96 122.4 212h-221.696l-66.976-116zM384 622.848c-45.856-26.464-61.6-85.312-35.136-131.136l33.824-58.56 98.464 170.56c2.496 4.288 5.536 8 8.448 11.904-29.824 22.656-71.168 27.104-105.6 7.232zM640 622.848c-45.856 26.464-104.672 10.688-131.136-35.136l-154.56-267.712h221.696l99.136 171.712c26.464 45.824 10.72 104.672-35.136 131.136z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"toast",
						"celebrate",
						"drink"
					],
					"grid": 32
				},
				{
					"id": 890,
					"width": 1024,
					"paths": [
						"M678.304 369.12l-147.808-256 30.656-53.088c8.832-15.296 28.416-20.544 43.712-11.712l166.272 96c15.296 8.832 20.544 28.416 11.712 43.712l-104.544 181.088zM345.696 433.184l-24.544 42.528c-32.608 56.48-16.832 127.040 33.792 165.44l-144.8 250.816-83.136-48c-7.648-4.416-17.44-1.792-21.856 5.856s-1.792 17.44 5.856 21.856l193.984 112c7.648 4.416 17.44 1.792 21.856-5.856s1.792-17.44-5.856-21.856l-83.136-48 144.8-250.816c32.576 13.696 68.256 12.96 99.168-0.064-9.344-8.736-17.888-18.176-24.288-29.088l-111.84-194.816zM702.912 475.648l-240-415.68c-8.832-15.328-28.384-20.544-43.712-11.712l-166.272 96c-15.296 8.832-20.544 28.384-11.712 43.712l237.248 410.912c32.832 56.864 103.008 83.84 163.104 58.496l144.64 250.528-96.992 56c-7.648 4.416-10.272 14.208-5.856 21.856s14.208 10.272 21.856 5.856l207.84-120c7.648-4.416 10.272-14.208 5.856-21.856s-14.208-10.272-21.856-5.856l-83.136 48-144.512-250.336c50.752-38.368 66.144-109.376 33.504-165.92z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"toast",
						"celebrate",
						"drink"
					],
					"grid": 32
				},
				{
					"id": 1158,
					"width": 1024,
					"paths": [
						"M880 804.288l-83.136 48-81.44-141.056c70.848-58.592 91.488-161.568 44-243.776l-25.76-44.544 119.424-206.88c8.832-15.328 3.584-34.88-11.712-43.712l-277.12-160c-7.36-4.224-16.16-5.344-24.288-3.2-8.224 2.176-15.2 7.552-19.424 14.912l-8.544 14.848-8.576-14.848c-4.256-7.328-11.232-12.704-19.424-14.912-8.192-2.144-16.928-1.024-24.288 3.2l-277.12 160c-15.296 8.832-20.576 28.384-11.712 43.712l119.424 206.88-25.76 44.544c-47.488 82.24-26.848 185.184 44 243.776l-81.44 141.056-83.136-48-32 55.424 221.696 128 32-55.424-83.136-48 81.6-141.28c47.584 17.28 101.696 15.36 147.84-6.304 25.824 12.128 53.984 18.464 82.4 18.464 22.4 0 44.544-4.32 65.504-12.064l81.536 141.184-83.136 48 32 55.424 221.696-128-31.968-55.424zM560 83.744l221.696 128-25.536 44.256h-55.104c1.792-5.024 2.944-10.368 2.944-16 0-26.464-21.536-48-48-48s-48 21.536-48 48c0 5.632 1.152 10.976 2.944 16h-37.888c-6.624-18.592-24.224-32-45.056-32s-38.432 13.408-45.056 32h-22.4l99.456-172.256zM640 240c0-8.832 7.168-16 16-16s16 7.168 16 16c0 8.832-7.168 16-16 16s-16-7.168-16-16zM544 272c0 8.832-7.168 16-16 16s-16-7.168-16-16c0-8.832 7.168-16 16-16s16 7.168 16 16zM242.304 211.744l221.696-128 29.504 51.168-69.888 121.088h-155.776l-25.536-44.256zM286.336 288h118.784l-59.392 102.88-59.392-102.88zM430.688 691.488c-22.304 0-44.384-5.952-63.84-17.184-29.6-17.088-50.784-44.704-59.648-77.728-8.832-33.024-4.32-67.52 12.8-97.12l122.080-211.456h40.864c6.624 18.592 24.224 32 45.056 32s38.432-13.408 45.056-32h164.64l-195.968 339.456c-22.816 39.488-65.344 64.032-111.040 64.032zM657.152 674.272c-35.168 20.352-79.104 21.696-116.192 5.088 10.88-10.336 20.576-22.272 28.448-35.936l108.864-188.544 25.728 44.544c17.088 29.632 21.664 64.096 12.8 97.12-8.864 33.056-30.016 60.64-59.648 77.728zM592 416c26.464 0 48-21.536 48-48s-21.536-48-48-48-48 21.536-48 48 21.536 48 48 48zM592 352c8.832 0 16 7.168 16 16s-7.168 16-16 16c-8.832 0-16-7.168-16-16s7.168-16 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"toast",
						"drink",
						"indulge"
					],
					"grid": 32
				},
				{
					"id": 1858,
					"paths": [
						"M896 384v-224c0-17.672-14.326-32-32-32h-224v-128l-160 160 160 160v-128h192v192h-128l160 160 160-160h-128z",
						"M720 512h-208v-208c0-26.4-21.6-48-48-48h-416c-26.4 0-48 21.6-48 48v416c0 26.4 21.6 48 48 48h208v208c0 26.4 21.6 48 48 48h416c26.4 0 48-21.6 48-48v-416c0-26.4-21.6-48-48-48zM704 960h-384v-192h144c26.4 0 48-21.6 48-48v-144h192v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"toggle",
						"switch"
					],
					"defaultCode": 59693,
					"grid": 16
				},
				{
					"id": 3210,
					"paths": [
						"M672 384c59.832 0 116.084 23.3 158.392 65.608s65.608 98.56 65.608 158.392-23.3 116.084-65.608 158.392c-42.308 42.308-98.56 65.608-158.392 65.608h-320c-59.832 0-116.084-23.3-158.392-65.608s-65.608-98.56-65.608-158.392 23.3-116.084 65.608-158.392c42.308-42.308 98.56-65.608 158.392-65.608h320zM672 256h-320c-194.404 0-352 157.596-352 352s157.596 352 352 352h320c194.404 0 352-157.596 352-352s-157.596-352-352-352v0z",
						"M512 608c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.366 71.634-160 160-160s160 71.634 160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"toggle-off"
					],
					"defaultCode": 61045,
					"grid": 16
				},
				{
					"id": 1649,
					"width": 1170.2871932983398,
					"paths": [
						"M658.286 512q0-59.429-23.143-113.429t-62.571-93.429-93.429-62.571-113.429-23.143-113.429 23.143-93.429 62.571-62.571 93.429-23.143 113.429 23.143 113.429 62.571 93.429 93.429 62.571 113.429 23.143 113.429-23.143 93.429-62.571 62.571-93.429 23.143-113.429zM1097.143 512q0-59.429-23.143-113.429t-62.571-93.429-93.429-62.571-113.429-23.143h-220.571q68 51.429 107.714 128t39.714 164.571-39.714 164.571-107.714 128h220.571q59.429 0 113.429-23.143t93.429-62.571 62.571-93.429 23.143-113.429zM1170.286 512q0 74.286-29.143 142t-78 116.571-116.571 78-142 29.143h-438.857q-74.286 0-142-29.143t-116.571-78-78-116.571-29.143-142 29.143-142 78-116.571 116.571-78 142-29.143h438.857q74.286 0 142 29.143t116.571 78 78 116.571 29.143 142z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"toggle-off"
					],
					"defaultCode": 61956,
					"grid": 14
				},
				{
					"id": 3209,
					"paths": [
						"M672 256h-320c-194.404 0-352 157.596-352 352s157.596 352 352 352h320c194.404 0 352-157.596 352-352s-157.596-352-352-352zM672 768c-88.366 0-160-71.632-160-160 0-88.366 71.634-160 160-160s160 71.634 160 160c0 88.368-71.634 160-160 160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"toggle-on"
					],
					"defaultCode": 61044,
					"grid": 16
				},
				{
					"id": 1650,
					"width": 1170.2848930358887,
					"paths": [
						"M0 512q0-74.286 29.143-142t78-116.571 116.571-78 142-29.143h438.857q74.286 0 142 29.143t116.571 78 78 116.571 29.143 142-29.143 142-78 116.571-116.571 78-142 29.143h-438.857q-74.286 0-142-29.143t-116.571-78-78-116.571-29.143-142zM804.571 804.571q59.429 0 113.429-23.143t93.429-62.571 62.571-93.429 23.143-113.429-23.143-113.429-62.571-93.429-93.429-62.571-113.429-23.143-113.429 23.143-93.429 62.571-62.571 93.429-23.143 113.429 23.143 113.429 62.571 93.429 93.429 62.571 113.429 23.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"toggle-on"
					],
					"defaultCode": 61957,
					"grid": 14
				},
				{
					"id": 2577,
					"paths": [
						"M973.758 175.416c-35.924-71.848-86.268-111.416-141.758-111.416h-640c-55.492 0-105.834 39.568-141.758 111.416-32.398 64.796-50.242 150.238-50.242 240.584s17.842 175.788 50.242 240.584c35.924 71.848 86.268 111.416 141.758 111.416h128v224c0 12.944 7.796 24.612 19.754 29.564 11.956 4.954 25.72 2.216 34.874-6.938l41.372-41.372 41.374 41.374c12.496 12.496 32.758 12.496 45.254 0l41.372-41.374 41.374 41.374c12.496 12.496 32.758 12.496 45.254 0l41.372-41.374 41.374 41.374c12.496 12.496 32.758 12.496 45.254 0l41.372-41.374 41.374 41.374c12.496 12.496 32.758 12.496 45.254 0l41.372-41.374 41.374 41.374c6.122 6.124 14.304 9.376 22.634 9.376 4.122-0.002 8.28-0.798 12.238-2.438 11.958-4.954 19.754-16.622 19.754-29.566v-576c0-90.346-17.844-175.788-50.242-240.584zM64 416c0-169.722 67.458-288 128-288s128 118.278 128 288-67.458 288-128 288-128-118.278-128-288zM960 914.746l-9.374-9.374c-12.496-12.496-32.758-12.496-45.254 0l-41.372 41.374-41.374-41.374c-12.496-12.496-32.758-12.496-45.254 0l-41.372 41.374-41.374-41.374c-12.496-12.496-32.758-12.496-45.254 0l-41.372 41.374-41.374-41.374c-12.496-12.496-32.758-12.496-45.254 0l-41.372 41.374-41.374-41.374c-12.496-12.496-32.758-12.496-45.254 0l-9.372 9.374v-498.746c0-90.346-17.842-175.788-50.242-240.584-8.916-17.834-18.722-33.67-29.274-47.416h527.516c60.542 0 128 118.278 128 288v498.746z",
						"M256 416c0 53.019-28.654 96-64 96s-64-42.981-64-96c0-53.019 28.654-96 64-96s64 42.981 64 96z",
						"M512 416c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M640 416c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M768 416c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
						"M896 416c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"toiletpaper",
						"toilet",
						"paper"
					],
					"defaultCode": 60412,
					"grid": 16
				},
				{
					"id": 2843,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM256 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM640 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM768 576v64h-64v96c0 53.020-42.98 96-96 96s-96-42.98-96-96v-96h-256v-64h512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tongue",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60678,
					"grid": 16
				},
				{
					"id": 2844,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM320 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM768 640h-64v96c0 53.020-42.98 96-96 96s-96-42.98-96-96v-96h-256v-64h512v64zM704 384c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tongue",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60679,
					"grid": 16
				},
				{
					"id": 2890,
					"paths": [
						"M864 1024h-608c-11.034 0-21.288-5.684-27.136-15.040l-160-256c-9.172-14.678-5.014-33.986 9.386-43.586l96-64c13.608-9.074 31.864-6.422 42.334 6.138l103.416 124.104v-487.616c0-17.672 14.328-32 32-32h128c17.672 0 32 14.328 32 32v199.016l359.762 89.94c14.244 3.562 24.238 16.36 24.238 31.044v384c0 17.674-14.326 32-32 32zM273.736 960h558.264v-327.016l-64-16v183.016c0 17.674-14.326 32-32 32s-32-14.326-32-32v-199.016l-64-16v151.016c0 17.674-14.326 32-32 32s-32-14.326-32-32v-167.016l-64-16v247.016c0 17.674-14.328 32-32 32s-32-14.326-32-32v-480h-64v544c0 13.472-8.438 25.502-21.106 30.088-12.666 4.594-26.85 0.746-35.476-9.602l-141.592-169.91-46.22 30.812 134.13 214.612z",
						"M639.97 444.038c-5.252 0-10.578-1.294-15.496-4.024-15.456-8.576-21.032-28.054-12.456-43.508 18.306-32.99 27.982-70.51 27.982-108.506 0-123.514-100.486-224-224-224s-224 100.486-224 224c0 37.996 9.674 75.516 27.978 108.5 8.576 15.454 3 34.932-12.454 43.508-15.454 8.574-34.932 2.998-43.506-12.456-23.564-42.462-36.018-90.718-36.018-139.552 0-158.804 129.196-288 288-288s288 129.196 288 288c0 48.834-12.456 97.090-36.020 139.558-5.846 10.534-16.76 16.48-28.010 16.48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"touch",
						"finger",
						"pointer",
						"drag",
						"hand"
					],
					"defaultCode": 60725,
					"grid": 16
				},
				{
					"id": 2893,
					"paths": [
						"M999.762 576.956l-359.762-89.94v-199.016c0-17.672-14.326-32-32-32h-128c-17.672 0-32 14.328-32 32v520.538l-207.984-120.24c-13.948-8.066-31.708-4.504-41.47 8.31l-64 84c-10.278 13.488-8.248 32.652 4.628 43.69l224 192c5.8 4.97 13.186 7.704 20.826 7.704h608c17.674 0 32-14.326 32-32v-384.002c0-14.684-9.994-27.482-24.238-31.044zM960 960h-564.162l-192.076-164.636 28.616-37.556 231.606 133.896c9.9 5.724 22.102 5.728 32.008 0.014 9.906-5.716 16.008-16.282 16.008-27.718v-544h64v480c0 17.674 14.326 32 32 32s32-14.326 32-32v-247.014l64 15.998v167.016c0 17.674 14.326 32 32 32s32-14.326 32-32v-151.016l64 16v199.016c0 17.674 14.326 32 32 32s32-14.326 32-32v-183.016l64 16v327.016z",
						"M374.628 393.368l-47.998-47.998 50.698-50.698c8.854-8.856 8.854-23.21 0-32.064s-23.208-8.854-32.064 0c-0.424 0.424-0.81 0.872-1.194 1.32l-49.44 49.44-48.002-48.002c-9.154-9.154-22.916-11.888-34.874-6.938-11.958 4.954-19.754 16.624-19.754 29.564v128c0 17.674 14.328 32 32 32h128c12.942 0 24.612-7.796 29.564-19.754s2.216-25.718-6.936-34.87z",
						"M9.374 502.626l47.998 47.998-50.698 50.696c-8.854 8.856-8.854 23.21 0 32.066 8.854 8.854 23.208 8.854 32.064 0 0.424-0.426 0.81-0.874 1.194-1.32l49.44-49.442 48.002 48.004c9.154 9.152 22.916 11.886 34.874 6.938 11.958-4.954 19.754-16.624 19.754-29.566v-128c0-17.674-14.328-32-32-32h-128c-12.942 0-24.612 7.796-29.564 19.754s-2.216 25.72 6.936 34.872z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"touch-pinch",
						"finger",
						"hand"
					],
					"defaultCode": 60728,
					"grid": 16
				},
				{
					"id": 2892,
					"paths": [
						"M999.762 576.956l-359.762-89.94v-199.016c0-17.672-14.326-32-32-32h-128c-17.672 0-32 14.328-32 32v520.538l-207.984-120.24c-13.948-8.066-31.708-4.504-41.47 8.31l-64 84c-10.278 13.488-8.248 32.652 4.628 43.69l224 192c5.8 4.97 13.186 7.704 20.826 7.704h608c17.674 0 32-14.326 32-32v-384.002c0-14.684-9.994-27.482-24.238-31.044zM960 960h-564.162l-192.076-164.636 28.616-37.556 231.606 133.896c9.9 5.724 22.102 5.728 32.008 0.014 9.906-5.716 16.008-16.282 16.008-27.718v-544h64v480c0 17.674 14.326 32 32 32s32-14.326 32-32v-247.014l64 15.998v167.016c0 17.674 14.326 32 32 32s32-14.326 32-32v-151.016l64 16v199.016c0 17.674 14.326 32 32 32s32-14.326 32-32v-183.016l64 16v327.016z",
						"M352.002 256h-128c-12.942 0-24.612 7.796-29.564 19.754s-2.214 25.72 6.938 34.874l48 48-146.748 146.748-48-48c-9.154-9.154-22.916-11.888-34.874-6.938-11.956 4.95-19.754 16.62-19.754 29.562v128c0 17.674 14.328 32 32 32h128c12.942 0 24.612-7.796 29.564-19.754s2.214-25.72-6.938-34.874l-48-48 146.748-146.748 48 48c9.154 9.154 22.916 11.888 34.874 6.938 11.958-4.954 19.754-16.624 19.754-29.564v-128c0-17.672-14.328-31.998-32-31.998z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"touch-zoom",
						"finger",
						"hand"
					],
					"defaultCode": 60727,
					"grid": 16
				},
				{
					"id": 891,
					"width": 1024,
					"paths": [
						"M864 216.224v-120.224c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-64v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-64v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-64v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v120.224c0 25.472 10.112 49.888 28.128 67.872l33.088 33.088-51.2 537.696c-5.376 56.384 38.944 105.12 95.552 105.12h492.832c56.608 0 100.928-48.736 95.552-105.088l-51.2-537.696 33.088-33.088c18.048-18.016 28.16-42.432 28.16-67.904zM805.76 907.040c-12.256 13.536-29.088 20.96-47.328 20.96h-492.864c-18.24 0-35.072-7.424-47.36-20.96-12.288-13.504-18.080-30.944-16.352-49.12l51.232-537.92h517.792l51.232 537.92c1.76 18.176-4.064 35.616-16.352 49.12zM832 216.224c0 17.088-6.656 33.152-18.752 45.248l-26.496 26.528h-549.504l-26.496-26.496c-12.096-12.096-18.752-28.16-18.752-45.28v-120.224h64v64h128v-64h64v64h128v-64h64v64h128v-64h64v120.224zM512 416c-35.36 0-64 28.64-64 64v128c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-128c0-35.36-28.64-64-64-64zM544 608h-64v-128c0-17.632 14.368-32 32-32s32 14.368 32 32v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tower",
						"protect",
						"accommodate",
						"defend"
					],
					"grid": 32
				},
				{
					"id": 892,
					"width": 1024,
					"paths": [
						"M544 480v128h-64v-128c0-17.632 14.368-32 32-32s32 14.368 32 32zM221.216 320h581.568l33.088-33.088c18.016-18.016 28.128-42.432 28.128-67.904v-123.008c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-64v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-64v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-64v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v123.008c0 25.472 10.112 49.888 28.128 67.904l33.088 33.088zM806.080 352l47.904 502.912c5.376 56.352-38.944 105.088-95.552 105.088h-492.864c-56.608 0-100.928-48.736-95.584-105.088l47.936-502.912h588.16zM576 480c0-35.36-28.64-64-64-64s-64 28.64-64 64v128c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tower",
						"protect",
						"accommodate",
						"defend"
					],
					"grid": 32
				},
				{
					"id": 1730,
					"width": 1127.4270839691162,
					"paths": [
						"M489.714 310.857v66.857q0 7.429-5.429 12.571t-12.857 5.143h-170.286v464q0 7.429-5.143 12.857t-12.571 5.429h-77.143q-7.429 0-12.857-5.143t-5.429-13.143v-464h-169.714q-7.429 0-12.857-5.143t-5.429-12.571v-66.857q0-8 5.143-13.143t13.143-5.143h453.143q7.429 0 12.857 5.429t5.429 12.857zM1082.857 309.143l44 549.143q0.571 7.429-4.571 13.714-5.714 5.714-13.143 5.714h-76.571q-6.857 0-12-4.857t-5.714-11.714l-26.286-336-108 242.857q-4.571 10.857-16.571 10.857h-68.571q-11.429 0-16.571-10.857l-107.429-244-25.714 337.143q-0.571 6.857-5.714 11.714t-12 4.857h-77.143q-7.429 0-13.143-5.714-5.143-5.714-5.143-13.714l44.571-549.143q0.571-6.857 5.714-11.714t12-4.857h81.143q11.429 0 16.571 10.857l125.714 297.143q5.714 13.714 11.429 29.143 1.714-4 5.429-14t6-15.143l126.286-297.143q5.143-10.857 16.571-10.857h80.571q7.429 0 12.571 4.857t5.714 11.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trademark"
					],
					"defaultCode": 62044,
					"grid": 14
				},
				{
					"id": 2451,
					"paths": [
						"M896 896l-268.416-835.070c-10.772-33.512-41.184-60.93-67.584-60.93s-69.6 0-96 0-56.814 27.418-67.584 60.93l-268.416 835.070h-128v128h1024v-128h-128zM421.51 192h180.978l41.144 128h-263.264l41.142-128zM339.226 448h345.55l41.142 128h-427.836l41.144-128zM215.796 832l41.142-128h510.122l41.142 128h-592.406z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"traffic-cone",
						"construction",
						"road"
					],
					"defaultCode": 60286,
					"grid": 16
				},
				{
					"id": 2452,
					"paths": [
						"M832 640l96-192h-160v-64h64l96-192h-160v-64c0-35.2-28.8-64-64-64h-448c-35.2 0-64 28.8-64 64v64h-160l96 192h64v64h-160l96 192h64v64h-160l96 192h64v64c0 35.2 28.8 64 64 64h448c35.2 0 64-28.8 64-64v-64h64l96-192h-160v-64h64zM480 896c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96zM480 640c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96zM480 384c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"traffic-lights",
						"lights",
						"road"
					],
					"defaultCode": 60287,
					"grid": 16
				},
				{
					"id": 2599,
					"paths": [
						"M832 544v-84c0-42-32-76-72-76h-56v-192l64-128h-256l64 128v192h-320v-128h-256v576h64c0 70.694 57.306 128 128 128s128-57.306 128-128c0 70.694 57.306 128 128 128s128-57.306 128-128c0 70.694 57.306 128 128 128s128-57.306 128-128h192l-192-288zM192 896c-35.346 0-64-28.652-64-64s28.654-64 64-64 64 28.652 64 64-28.654 64-64 64zM448 896c-35.346 0-64-28.652-64-64s28.654-64 64-64 64 28.652 64 64-28.654 64-64 64zM704 896c-35.348 0-64-28.652-64-64s28.652-64 64-64 64 28.652 64 64-28.652 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"train",
						"travel",
						"transport"
					],
					"defaultCode": 60434,
					"grid": 16
				},
				{
					"id": 2600,
					"paths": [
						"M896 704v-640c0-35.2-28.8-64-64-64h-704c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h96l-153.584 204.834c-4.010 5.348-6.416 11.966-6.416 19.166 0 17.664 14.314 31.984 31.974 31.998l0.002 0.004c0.012 0 0.022-0.002 0.034-0.002h767.98c0.012 0 0.024 0.002 0.036 0.002 6.68 0 13.418-2.086 19.174-6.402 14.138-10.604 17.004-30.662 6.4-44.798l-153.6-204.802h96c35.2 0 64-28.8 64-64zM832 224v256c0 17.672-14.326 32-32 32h-288v-320h288c17.674 0 32 14.328 32 32zM320 64h320v64h-320v-64zM128 224c0-17.672 14.328-32 32-32h288v320h-288c-17.672 0-32-14.328-32-32v-256zM128 640c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64zM800 960h-640l48-64h544l48 64zM704 832h-448l48-64h352l48 64zM768 704c-35.348 0-64-28.654-64-64s28.652-64 64-64 64 28.654 64 64-28.652 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"train",
						"travel",
						"transport",
						"subway"
					],
					"defaultCode": 60435,
					"grid": 16
				},
				{
					"id": 1696,
					"width": 877.7129516601562,
					"paths": [
						"M621.714 0q105.714 0 180.857 53.429t75.143 129.429v512q0 74.286-71.714 126.857t-174.571 55.429l121.714 115.429q9.143 8.571 4.571 20t-17.143 11.429h-603.429q-12.571 0-17.143-11.429t4.571-20l121.714-115.429q-102.857-2.857-174.571-55.429t-71.714-126.857v-512q0-76 75.143-129.429t180.857-53.429h365.714zM438.857 768q45.714 0 77.714-32t32-77.714-32-77.714-77.714-32-77.714 32-32 77.714 32 77.714 77.714 32zM768 438.857v-292.571h-658.286v292.571h658.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"train"
					],
					"defaultCode": 62008,
					"grid": 14
				},
				{
					"id": 174,
					"paths": [
						"M742.4 768h-512c-70.579 0-128-57.421-128-128v-512c0-70.579 57.421-128 128-128h512c70.579 0 128 57.421 128 128v512c0 70.579-57.421 128-128 128zM230.4 51.2c-42.347 0-76.8 34.453-76.8 76.8v512c0 42.349 34.453 76.8 76.8 76.8h512c42.349 0 76.8-34.451 76.8-76.8v-512c0-42.347-34.451-76.8-76.8-76.8h-512z",
						"M970.098 986.952l-102.4-204.8c-6.32-12.645-21.696-17.77-34.346-11.448-12.645 6.322-17.771 21.699-11.448 34.346l7.075 14.152h-685.157l7.075-14.152c6.323-12.645 1.197-28.024-11.45-34.346-12.645-6.322-28.024-1.198-34.346 11.448l-102.4 204.8c-6.323 12.645-1.197 28.024 11.45 34.346 3.675 1.837 7.581 2.709 11.429 2.709 9.39 0 18.432-5.187 22.917-14.158l18.525-37.048h838.757l18.525 37.048c4.485 8.971 13.525 14.158 22.917 14.158 3.846 0 7.754-0.872 11.429-2.709 12.645-6.323 17.771-21.701 11.448-34.346zM92.622 921.6l25.6-51.2h736.357l25.6 51.2h-787.557z",
						"M281.6 665.6c-42.347 0-76.8-34.451-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.453 76.8-76.8 76.8zM281.6 563.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M691.2 665.6c-42.349 0-76.8-34.451-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.451 76.8 76.8-34.451 76.8-76.8 76.8zM691.2 563.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z",
						"M640 153.6h-307.2c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h307.2c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M742.4 204.8h-512c-14.138 0-25.6 11.462-25.6 25.6v204.8c0 14.138 11.462 25.6 25.6 25.6h512c14.139 0 25.6-11.462 25.6-25.6v-204.8c0-14.138-11.461-25.6-25.6-25.6zM256 256h204.8v153.6h-204.8v-153.6zM716.8 409.6h-204.8v-153.6h204.8v153.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"train",
						"travel",
						"metro"
					],
					"defaultCode": 59471,
					"grid": 20
				},
				{
					"id": 1679,
					"width": 950.854941368103,
					"paths": [
						"M731.429 18.286q0-8 5.143-13.143t13.143-5.143h164.571q14.857 0 25.714 10.857t10.857 25.714v164.571q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-76.571l-145.143 145.714q72 90.286 72 205.143 0 126.286-84.286 219.714t-208.286 107.143v75.429h54.857q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857v54.857q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-54.857h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h54.857v-75.429q-124-13.714-208.286-107.143t-84.286-219.714q0-114.857 72-205.143l-29.714-30.286-57.714 63.429q-5.143 5.714-12.571 6t-13.143-4.286l-27.429-25.143q-5.714-4.571-6-12.286t4.857-13.429l60-65.714-63.429-64v76.571q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-164.571q0-14.857 10.857-25.714t25.714-10.857h164.571q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-76l60.571 61.143 49.143-53.714q5.143-5.714 12.571-6t13.143 4.286l27.429 25.143q5.714 4.571 6 12.286t-4.857 13.429l-51.429 56.571 32.571 32q90.286-72 205.143-72t205.143 72l145.714-145.143h-76.571q-8 0-13.143-5.143t-5.143-13.143v-36.571zM475.429 731.429q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857 75.143 180.857 180.857 75.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"transgender-alt"
					],
					"defaultCode": 61989,
					"grid": 14
				},
				{
					"id": 3163,
					"paths": [
						"M768 384h-704v-128h704v-160l224 224-224 224zM256 640h704v128h-704v160l-224-224 224-224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"transmission",
						"arrows"
					],
					"defaultCode": 60998,
					"grid": 16
				},
				{
					"id": 3164,
					"paths": [
						"M704 608v-224h-704v-128h704v-224l288 288-288 288zM320 640h704v128h-704v224l-288-288 288-288v224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"transmission",
						"arrows"
					],
					"defaultCode": 60999,
					"grid": 16
				},
				{
					"id": 893,
					"width": 1024,
					"paths": [
						"M832.032 448h32c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v32c0 17.664 14.304 32 32 32zM832.032 384h32v32h-32v-32zM1000.928 544h-40.928v-224h16c8.832 0 16-7.168 16-16s-7.168-16-16-16h-256c-8.832 0-16 7.168-16 16s7.168 16 16 16h11.52l-24.096 224h-35.424v-160c0-17.664-14.336-32-32-32h-160v-96c0-17.664-14.336-32-32-32h-352c-17.664 0-32 14.304-32 32v224h-40.352c-11.328 0-19.072 11.424-14.848 21.952l103.136 257.824c9.696 24.288 33.248 40.224 59.392 40.224h712.32c26.688 0 50.56-16.544 59.936-41.536l72.32-192.864c3.936-10.432-3.808-21.6-14.976-21.6zM928 320v224h-188.384l24-224h164.384zM480 384h160v96h-160v-96zM480 512h160v32h-160v-32zM288 256h160v96h-160v-96zM288 384h160v96h-160v-96zM448 512v32h-144l-16-32h160zM96 256h160v96h-160v-96zM96 384h160v96h-160v-96zM913.632 747.232c-4.704 12.512-16.64 20.768-29.984 20.768h-712.288c-13.088 0-24.864-7.968-29.696-20.128l-17.6-43.872h805.76l-16.192 43.232zM941.824 672h-830.56l-64-160h208.736l32 64h689.824l-36 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"transport",
						"move",
						"travel",
						"ship"
					],
					"grid": 32
				},
				{
					"id": 894,
					"width": 1024,
					"paths": [
						"M64 448v-192c0-17.664 14.336-32 32-32h352c17.664 0 32 14.336 32 32v96h160c17.664 0 32 14.336 32 32v128h-348.224l-23.168-46.336c-5.408-10.816-16.512-17.664-28.608-17.664h-208zM864 384h-32v32h32v-32zM1015.904 565.632l-72.32 192.864c-9.376 24.96-33.248 41.504-59.936 41.504h-712.32c-26.176 0-49.696-15.936-59.424-40.224l-103.136-257.824c-4.192-10.528 3.552-21.952 14.88-21.952h248.352l32 64h403.424l24.096-224h-11.52c-8.832 0-16-7.168-16-16s7.168-16 16-16h256c8.832 0 16 7.168 16 16s-7.168 16-16 16h-16v224h40.896c11.2 0 18.944 11.168 15.008 21.632zM800 416c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v32zM928 688c0-8.832-7.168-16-16-16h-768c-8.832 0-16 7.168-16 16s7.168 16 16 16h768c8.832 0 16-7.168 16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"transport",
						"move",
						"travel",
						"ship"
					],
					"grid": 32
				},
				{
					"id": 1638,
					"width": 804.5710134506226,
					"paths": [
						"M292.571 786.286v-402.286q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v402.286q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM438.857 786.286v-402.286q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v402.286q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM585.143 786.286v-402.286q0-8-5.143-13.143t-13.143-5.143h-36.571q-8 0-13.143 5.143t-5.143 13.143v402.286q0 8 5.143 13.143t13.143 5.143h36.571q8 0 13.143-5.143t5.143-13.143zM274.286 219.429h256l-27.429-66.857q-4-5.143-9.714-6.286h-181.143q-5.714 1.143-9.714 6.286zM804.571 237.714v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857v541.714q0 47.429-26.857 82t-64.571 34.571h-475.429q-37.714 0-64.571-33.429t-26.857-80.857v-544h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h176.571l40-95.429q8.571-21.143 30.857-36t45.143-14.857h182.857q22.857 0 45.143 14.857t30.857 36l40 95.429h176.571q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trash"
					],
					"defaultCode": 61944,
					"grid": 14
				},
				{
					"id": 1198,
					"width": 804.5710134506226,
					"paths": [
						"M292.571 420.571v329.143q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-329.143q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143zM438.857 420.571v329.143q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-329.143q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143zM585.143 420.571v329.143q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-329.143q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143zM658.286 834.286v-541.714h-512v541.714q0 12.571 4 23.143t8.286 15.429 6 4.857h475.429q1.714 0 6-4.857t8.286-15.429 4-23.143zM274.286 219.429h256l-27.429-66.857q-4-5.143-9.714-6.286h-181.143q-5.714 1.143-9.714 6.286zM804.571 237.714v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857v541.714q0 47.429-26.857 82t-64.571 34.571h-475.429q-37.714 0-64.571-33.429t-26.857-80.857v-544h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h176.571l40-95.429q8.571-21.143 30.857-36t45.143-14.857h182.857q22.857 0 45.143 14.857t30.857 36l40 95.429h176.571q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trash-o"
					],
					"defaultCode": 61460,
					"grid": 14
				},
				{
					"id": 112,
					"paths": [
						"M793.6 102.4h-179.2v-25.6c0-42.347-34.453-76.8-76.8-76.8h-102.4c-42.347 0-76.8 34.453-76.8 76.8v25.6h-179.2c-42.347 0-76.8 34.453-76.8 76.8v51.2c0 33.373 21.403 61.829 51.2 72.397v644.403c0 42.349 34.453 76.8 76.8 76.8h512c42.349 0 76.8-34.451 76.8-76.8v-644.403c29.797-10.568 51.2-39.024 51.2-72.397v-51.2c0-42.347-34.451-76.8-76.8-76.8zM409.6 76.8c0-14.115 11.485-25.6 25.6-25.6h102.4c14.115 0 25.6 11.485 25.6 25.6v25.6h-153.6v-25.6zM742.4 972.8h-512c-14.115 0-25.6-11.485-25.6-25.6v-640h563.2v640c0 14.115-11.485 25.6-25.6 25.6zM819.2 230.4c0 14.115-11.485 25.6-25.6 25.6h-614.4c-14.115 0-25.6-11.485-25.6-25.6v-51.2c0-14.115 11.485-25.6 25.6-25.6h614.4c14.115 0 25.6 11.485 25.6 25.6v51.2z",
						"M640 358.4c-14.139 0-25.6 11.462-25.6 25.6v512c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-512c0-14.138-11.461-25.6-25.6-25.6z",
						"M486.4 358.4c-14.138 0-25.6 11.462-25.6 25.6v512c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-512c0-14.138-11.462-25.6-25.6-25.6z",
						"M332.8 358.4c-14.138 0-25.6 11.462-25.6 25.6v512c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-512c0-14.138-11.462-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trash",
						"bin",
						"remove",
						"waste"
					],
					"defaultCode": 59409,
					"grid": 20
				},
				{
					"id": 895,
					"width": 1024,
					"paths": [
						"M640 848v-512c0-8.832 7.168-16 16-16s16 7.168 16 16v512c0 8.832-7.168 16-16 16s-16-7.168-16-16zM896 160v32c0 17.664-14.336 32-32 32l-59.104 709.312c-2.784 33.184-30.496 58.688-63.776 58.688h-458.24c-33.28 0-61.024-25.504-63.776-58.688l-59.104-709.312c-17.664 0-32-14.336-32-32v-32c0-35.36 28.64-64 64-64h224v-32c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32v32h224c35.36 0 64 28.64 64 64zM448 96h128v-32h-128v32zM831.904 224h-639.808l58.88 706.656c1.408 16.576 15.264 29.344 31.904 29.344h458.24c16.64 0 30.496-12.768 31.904-29.344l58.88-706.656zM864 160c0-17.664-14.336-32-32-32h-640c-17.664 0-32 14.336-32 32v32h704v-32zM560 864c8.832 0 16-7.168 16-16v-512c0-8.832-7.168-16-16-16s-16 7.168-16 16v512c0 8.832 7.168 16 16 16zM464 864c8.832 0 16-7.168 16-16v-512c0-8.832-7.168-16-16-16s-16 7.168-16 16v512c0 8.832 7.168 16 16 16zM368 864c8.832 0 16-7.168 16-16v-512c0-8.832-7.168-16-16-16s-16 7.168-16 16v512c0 8.832 7.168 16 16 16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trash",
						"discard",
						"delete",
						"remove",
						"recycle",
						"destroy"
					],
					"grid": 32
				},
				{
					"id": 896,
					"width": 1024,
					"paths": [
						"M160 224h704c17.664 0 32-14.336 32-32v-32c0-35.36-28.64-64-64-64h-224v-32c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v32h-224c-35.36 0-64 28.64-64 64v32c0 17.664 14.336 32 32 32zM448 64h128v32h-128v-32zM162.656 256l56.448 677.312c2.784 33.184 30.496 58.688 63.776 58.688h458.24c33.28 0 61.024-25.504 63.776-58.688l56.448-677.312h-698.688zM384 848c0 8.832-7.168 16-16 16s-16-7.168-16-16v-480c0-8.832 7.168-16 16-16s16 7.168 16 16v480zM480 848c0 8.832-7.168 16-16 16s-16-7.168-16-16v-480c0-8.832 7.168-16 16-16s16 7.168 16 16v480zM576 848c0 8.832-7.168 16-16 16s-16-7.168-16-16v-480c0-8.832 7.168-16 16-16s16 7.168 16 16v480zM672 848c0 8.832-7.168 16-16 16s-16-7.168-16-16v-480c0-8.832 7.168-16 16-16s16 7.168 16 16v480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trash",
						"discard",
						"delete",
						"remove",
						"recycle",
						"destroy"
					],
					"grid": 32
				},
				{
					"id": 897,
					"width": 1024,
					"paths": [
						"M768 288h-128v-160c17.664 0 32-14.336 32-32 0-53.024-42.976-96-96-96h-128c-53.024 0-96 42.976-96 96 0 17.664 14.336 32 32 32v160h-128c-53.024 0-96 42.976-96 96v448c0 53.024 42.976 96 96 96h8.864c-8 13.76-11.52 30.496-6.624 48.576 6.432 23.84 26.432 42.464 50.784 46.496 40.192 6.688 74.976-24.128 74.976-63.072 0-11.712-3.392-22.56-8.864-32h273.76c-8 13.76-11.52 30.496-6.624 48.576 6.432 23.84 26.432 42.464 50.784 46.496 40.16 6.688 74.944-24.128 74.944-63.072 0-11.712-3.392-22.56-8.864-32h8.864c53.024 0 96-42.976 96-96v-448c0-53.024-42.976-96-96-96zM448 32h128c35.36 0 64 28.64 64 64h-32c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32h-32c0-35.36 28.64-64 64-64zM608 128v160h-192v-160c17.664 0 32-14.336 32-32h128c0 17.664 14.336 32 32 32zM320 992c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM704 992c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM832 832c0 35.36-28.64 64-64 64h-512c-35.36 0-64-28.64-64-64v-320h256v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32h256v320zM480 544v-96h64v96h-64zM832 480h-256v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-256v-96c0-35.36 28.64-64 64-64h512c35.36 0 64 28.64 64 64v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"travel",
						"pack",
						"work",
						"roll"
					],
					"grid": 32
				},
				{
					"id": 898,
					"width": 1024,
					"paths": [
						"M576 512h288v320c0 53.024-42.976 96-96 96h-512c-53.024 0-96-42.976-96-96v-320h288v32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-32zM544 448h-64v96h64v-96zM864 384v96h-288v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-288v-96c0-53.024 42.976-96 96-96h128v-160c-17.664 0-32-14.336-32-32 0-53.024 42.976-96 96-96h128c53.024 0 96 42.976 96 96 0 17.664-14.336 32-32 32v160h128c53.024 0 96 42.976 96 96zM608 128c-17.664 0-32-14.336-32-32h-128c0 17.664-14.336 32-32 32v160h192v-160zM704 1024c35.36 0 64-28.64 64-64h-128c0 35.36 28.64 64 64 64zM320 1024c35.36 0 64-28.64 64-64h-128c0 35.36 28.64 64 64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"travel",
						"pack",
						"work",
						"roll"
					],
					"grid": 32
				},
				{
					"id": 1159,
					"width": 1024,
					"paths": [
						"M992 192h-320v-96c0-17.664-14.336-32-32-32h-256c-17.664 0-32 14.336-32 32v96h-320c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM416 128h192v64h-192v-64zM960 896h-896v-448h96v64h128v-64h448v64h128v-64h96v448zM192 480v-96h64v96h-64zM768 480v-96h64v96h-64zM960 416h-96v-64h-128v64h-448v-64h-128v64h-96v-160h896v160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"travel",
						"pack",
						"work"
					],
					"grid": 32
				},
				{
					"id": 899,
					"width": 1024,
					"paths": [
						"M416 288c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM803.36 658.944c6.048 15.584 12.352 46.080 12.576 105.824 29.088 23.488 48.064 58.976 48.064 99.232 0 70.688-57.312 128-128 128-39.84 0-74.976-18.56-98.432-47.104-40.64 9.6-83.072 14.56-125.568 14.56s-84.928-4.96-125.568-14.56c-23.456 28.544-58.592 47.104-98.432 47.104-70.688 0-128-57.312-128-128 0-40.256 18.976-75.744 48.064-99.232 0.256-59.744 6.528-90.24 12.576-105.824-35.872-18.656-60.64-55.744-60.64-98.976 0-40.928 22.176-76.352 54.912-95.872l-1.76-11.328c-3.424-22.144-5.152-45.312-5.152-68.768 0-39.328 4.832-75.552 13.728-108.576-36.512-18.368-61.728-55.744-61.728-99.424 0-61.856 50.144-112 112-112 32.736 0 61.472 14.688 81.92 37.12 44.288-24.096 97.376-37.12 158.080-37.12s113.792 13.024 158.080 37.12c20.448-22.432 49.184-37.12 81.92-37.12 61.856 0 112 50.144 112 112 0 43.68-25.216 81.056-61.728 99.424 8.896 33.024 13.728 69.248 13.728 108.576 0 22.784-1.632 45.28-4.864 66.88l-1.984 13.248c32.704 19.552 54.848 54.976 54.848 95.84 0 43.232-24.768 80.32-60.64 98.976zM697.536 118.4c42.624 30.528 74.848 73.152 94.784 126.112 23.616-13.856 39.68-39.2 39.68-68.512 0-44.096-35.904-80-80-80-21.28 0-40.192 8.768-54.464 22.4zM231.68 244.512c19.936-52.96 52.16-95.584 94.784-126.112-14.272-13.632-33.184-22.4-54.464-22.4-44.096 0-80 35.904-80 80 0 29.312 16.064 54.656 39.68 68.512zM272 639.968c44.096 0 80-35.872 80-80 0-44.096-35.904-80-80-80s-80 35.904-80 80c0 44.128 35.904 80 80 80zM384 864c0-52.928-43.072-96-96-96s-96 43.072-96 96c0 52.928 43.072 96 96 96 36.576 0 68.032-20.768 84.256-50.944l0.128-0.48 0.128 0.032c7.072-13.376 11.488-28.416 11.488-44.608zM608 864c0-70.688 57.312-128 128-128 16.864 0 32.864 3.456 47.616 9.376-1.472-47.744-7.232-68.192-10.208-75.552-6.944 1.344-14.048 2.144-21.376 2.144-61.856 0-112-50.144-112-112s50.144-112 112-112c9.248 0 18.080 1.44 26.656 3.552l0.8-5.408c3.008-20.032 4.512-40.928 4.512-62.112 0-177.664-104.224-288-272-288s-272 110.336-272 288c0 21.856 1.6 43.328 4.8 63.904l0.576 3.616c8.576-2.112 17.408-3.552 26.656-3.552 61.856 0 112 50.144 112 112s-50.144 112-112 112c-7.328 0-14.464-0.8-21.376-2.144-2.976 7.328-8.736 27.808-10.208 75.552 14.688-5.92 30.688-9.376 47.552-9.376 70.688 0 128 57.312 128 128 0 18.592-4.16 36.16-11.296 52.128 69.888 14.88 144.768 14.88 214.592 0-7.136-15.968-11.296-33.536-11.296-52.128zM736 768c-52.928 0-96 43.072-96 96 0 16.192 4.416 31.232 11.52 44.608l0.128-0.032 0.128 0.48c16.192 30.176 47.648 50.944 84.224 50.944 52.928 0 96-43.072 96-96s-43.072-96-96-96zM832 559.968c0-44.096-35.904-80-80-80s-80 35.904-80 80c0 44.128 35.904 80 80 80s80-35.872 80-80zM672 288c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM576 416c0 35.36-28.64 64-64 64s-64-28.64-64-64c0-35.36 28.64-64 64-64s64 28.64 64 64zM544 416c0-17.632-14.368-32-32-32s-32 14.368-32 32 14.368 32 32 32 32-14.368 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"treat",
						"eat",
						"indulge",
						"chew"
					],
					"grid": 32
				},
				{
					"id": 900,
					"width": 1024,
					"paths": [
						"M320 560c0 44.192-35.808 80-80 80s-80-35.808-80-80 35.808-80 80-80 80 35.808 80 80zM784 480c-44.192 0-80 35.808-80 80s35.808 80 80 80 80-35.808 80-80-35.808-80-80-80zM752 768c-61.856 0-112 50.144-112 112s50.144 112 112 112 112-50.144 112-112-50.144-112-112-112zM272 768c-61.856 0-112 50.144-112 112s50.144 112 112 112 112-50.144 112-112-50.144-112-112-112zM512 384c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM802.272 275.424c8.896 33.024 13.728 69.248 13.728 108.576 0 22.784-1.632 45.28-4.864 66.88l-0.128 0.8c-8.704-2.176-17.664-3.68-27.008-3.68-61.76 0-112 50.24-112 112s50.24 112 112 112c7.808 0 15.424-0.832 22.752-2.336 4.32 15.904 8.128 41.376 8.96 81.888-19.296-9.632-40.736-15.552-63.712-15.552-79.392 0-144 64.608-144 144 0 24.48 6.72 47.168 17.504 67.36-36.96 7.84-75.168 12.096-113.504 12.096s-76.544-4.256-113.504-12.096c10.784-20.192 17.504-42.88 17.504-67.36 0-79.392-64.608-144-144-144-22.976 0-44.416 5.92-63.712 15.52 0.832-40.48 4.64-65.984 8.96-81.888 7.328 1.536 14.944 2.368 22.752 2.368 61.76 0 112-50.24 112-112s-50.24-112-112-112c-9.344 0-18.272 1.504-26.944 3.648-3.328-21.824-5.056-44.576-5.056-67.648 0-39.328 4.832-75.552 13.728-108.576-36.512-18.368-61.728-55.744-61.728-99.424 0-61.856 50.144-112 112-112 32.736 0 61.472 14.688 81.92 37.12 44.288-24.096 97.376-37.12 158.080-37.12s113.792 13.024 158.080 37.12c20.448-22.432 49.184-37.12 81.92-37.12 61.856 0 112 50.144 112 112 0 43.68-25.216 81.056-61.728 99.424zM416 288c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM576 416c0-35.36-28.64-64-64-64s-64 28.64-64 64c0 35.36 28.64 64 64 64s64-28.64 64-64zM672 288c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"treat",
						"eat",
						"indulge",
						"chew"
					],
					"grid": 32
				},
				{
					"id": 1160,
					"width": 1024,
					"paths": [
						"M966.464 184.96c-18.336-40.768-62.848-64-106.912-54.912l-422.944 86.56-25.504-76.576c-13.312-39.872-49.088-65.632-91.104-65.632s-77.792 25.76-91.072 65.6l-167.168 501.632c-9.92 29.6-5.088 61.152 13.152 86.496s46.624 39.872 77.856 39.872h290.752l169.984 191.68c18.176 20.544 44.352 32.32 71.744 32.32 34.752 0 65.888-17.952 83.232-48l167.232-289.6c15.616-27.040 17.216-58.88 4.416-87.36-12.8-28.512-37.728-48.416-68.32-54.656l-101.824-20.832 180.64-203.712c25.408-28.704 31.456-68.128 15.84-102.88zM881.76 593.248c4.256 9.504 3.744 20.096-1.472 29.12l-167.2 289.6c-5.792 10.016-16.16 16-27.808 16-9.216 0-17.696-3.84-23.872-10.784l-82.432-92.96 158.272-274.144 121.728 24.896c10.208 2.144 18.496 8.8 22.784 18.272zM556.608 799.008l-111.904-126.176 94.272-163.264 165.216 33.824-147.584 255.616zM122.432 661.888l39.296-117.888h125.952l141.888 160h-276.768c-10.4 0-19.872-4.832-25.952-13.28-6.112-8.448-7.712-18.976-4.416-28.832zM350.368 160.256l53.248 159.744h-167.232l53.248-159.744c6.784-20.288 24.96-21.856 30.368-21.856s23.584 1.568 30.368 21.856zM414.272 352l35.552 106.656-102.432-20.96c-4.672-0.96-9.216-1.408-13.632-1.408-40.768 0-68.832 38.592-61.952 75.712h-99.424l53.344-160h188.544zM425.408 284.224l50.688-10.368 124.512 215.648-114.592-23.456-60.608-181.824zM422.336 647.584l-111.712-125.984c-12.384-13.984-7.872-28.512-5.376-34.112 6.016-13.408 19.296-21.856 35.712-18.464l164.96 33.76-83.584 144.8zM509.152 267.072l165.216-33.824 94.272 163.264-95.584 107.776-30.56-6.24-133.344-230.976zM707.424 226.528l164.96-33.76c16.448-3.36 29.696 5.056 35.712 18.464 2.528 5.6 7.040 20.128-5.376 34.112l-111.712 125.984-83.584-144.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"treat",
						"eat",
						"indulge"
					],
					"grid": 32
				},
				{
					"id": 2535,
					"paths": [
						"M888.744 843.658l-152.744-203.658h64c0.016 0.002 0.032 0.002 0.040 0 17.674 0 32-14.326 32-32 0-7.724-2.736-14.812-7.294-20.342l-152.746-203.658h64c12.3 0 23.514-7.050 28.842-18.138s3.83-24.248-3.854-33.852l-256-320c-6.074-7.592-15.268-12.010-24.988-12.010s-18.916 4.418-24.988 12.010l-256 320c-7.684 9.606-9.182 22.766-3.854 33.852 5.33 11.088 16.542 18.138 28.842 18.138h64l-153.6 204.8c-7.272 9.696-8.442 22.67-3.022 33.51 5.422 10.842 16.502 17.69 28.622 17.69h64l-153.6 204.8c-7.272 9.696-8.442 22.67-3.022 33.51 5.422 10.842 16.502 17.69 28.622 17.69h288v96c0 17.674 14.328 32 32 32h128c17.674 0 32-14.326 32-32v-96h288c0.016 0 0.030 0 0.040 0 17.674 0 32-14.326 32-32 0-7.724-2.736-14.812-7.296-20.342z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tree",
						"nature",
						"green",
						"woods"
					],
					"defaultCode": 60370,
					"grid": 16
				},
				{
					"id": 2536,
					"paths": [
						"M888.744 843.658l-152.744-203.658h64c0.016 0.002 0.032 0.002 0.040 0 17.674 0 32-14.326 32-32 0-7.724-2.736-14.812-7.294-20.342l-152.746-203.658h64c12.3 0 23.514-7.050 28.842-18.138s3.83-24.248-3.854-33.852l-256-320c-6.074-7.592-15.268-12.010-24.988-12.010s-18.916 4.418-24.988 12.010l-256 320c-7.684 9.606-9.182 22.766-3.854 33.852 5.33 11.088 16.542 18.138 28.842 18.138h64l-153.6 204.8c-7.272 9.696-8.442 22.67-3.022 33.51 5.422 10.842 16.502 17.69 28.622 17.69h64l-153.6 204.8c-7.272 9.696-8.442 22.67-3.022 33.51 5.422 10.842 16.502 17.69 28.622 17.69h288v96c0 17.674 14.328 32 32 32h128c17.674 0 32-14.326 32-32v-96h288c0.016 0 0.030 0 0.040 0 17.674 0 32-14.326 32-32 0-7.724-2.736-14.812-7.296-20.342zM512 960h-64v-64h64v64zM160 832l153.6-204.8c7.272-9.696 8.442-22.67 3.022-33.51-5.42-10.842-16.5-17.69-28.622-17.69h-64l153.6-204.8c7.272-9.696 8.442-22.67 3.022-33.51-5.42-10.842-16.5-17.69-28.622-17.69h-61.42l189.42-236.776 189.42 236.776h-61.42c-12.122 0-23.202 6.848-28.622 17.69-5.422 10.84-4.252 23.814 3.022 33.51l153.6 204.8h-64c-12.122 0-23.202 6.848-28.622 17.69-5.422 10.84-4.252 23.814 3.022 33.51l153.6 204.8h-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tree",
						"nature",
						"green",
						"woods"
					],
					"defaultCode": 60371,
					"grid": 16
				},
				{
					"id": 2537,
					"paths": [
						"M758.53 214.678c-32.512-123.404-145.054-214.678-278.53-214.678-133.474 0-246.018 91.274-278.53 214.678-121.022 48.252-201.468 166.16-201.468 297.322 0 176.45 143.552 320 320 320 21.738 0 43.154-2.23 64-6.47v166.47c0 17.674 14.328 32 32 32h128c17.674 0 32-14.326 32-32v-166.46c20.914 4.246 42.326 6.46 64.002 6.46 176.446 0 319.996-143.55 319.996-320 0-131.824-80.234-249.084-201.47-297.322z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tree",
						"nature",
						"green",
						"woods"
					],
					"defaultCode": 60372,
					"grid": 16
				},
				{
					"id": 2538,
					"paths": [
						"M758.53 214.678c-32.512-123.404-145.054-214.678-278.53-214.678-133.474 0-246.018 91.274-278.53 214.678-121.022 48.252-201.468 166.16-201.468 297.322 0 176.45 143.552 320 320 320h64v160c0 17.674 14.328 32 32 32h128c17.674 0 32-14.326 32-32v-160h64.002c176.446 0 319.996-143.55 319.996-320 0-131.824-80.234-249.084-201.47-297.322zM512 960h-64v-128h64v128zM640.002 768h-320c-141.16 0-256-114.842-256-256 0-92.44 49.962-176.616 128.034-221.75 0.182 23.604 3.204 47.052 9.042 69.728 3.718 14.44 16.716 24.030 30.968 24.030 2.64 0 5.324-0.33 8-1.018 17.116-4.406 27.418-21.852 23.012-38.966-4.684-18.188-7.058-37.038-7.058-56.024 0-123.514 100.486-224 224-224s224 100.486 224 224c0 18.986-2.374 37.834-7.056 56.022-4.404 17.116 5.898 34.562 23.014 38.966 17.102 4.408 34.56-5.896 38.966-23.012 5.844-22.706 8.868-46.186 9.042-69.822 78.196 45.030 128.034 128.912 128.034 221.846 0 141.158-114.84 256-255.998 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tree",
						"nature",
						"green",
						"woods"
					],
					"defaultCode": 60373,
					"grid": 16
				},
				{
					"id": 2681,
					"paths": [
						"M976 704h-100.822l-235.178-391.96v-200.040c0-26.4-21.6-48-48-48h-160c-26.4 0-48 21.6-48 48v200.038l-235.176 391.962h-100.824c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-200.040l235.176-391.96h41.646l235.178 391.96v200.040c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tree",
						"branches",
						"inheritance",
						"binary-tree"
					],
					"defaultCode": 60516,
					"grid": 16
				},
				{
					"id": 2682,
					"paths": [
						"M976 768h-16v-208c0-61.756-50.242-112-112-112h-272v-128h16c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-160c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h16v128h-272c-61.756 0-112 50.244-112 112v208h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-192h256v192h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-192h256v192h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tree",
						"branches",
						"inheritance"
					],
					"defaultCode": 60517,
					"grid": 16
				},
				{
					"id": 2683,
					"paths": [
						"M976 768h-16v-208c0-61.756-50.242-112-112-112h-272v-128h16c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-160c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h16v128h-272c-61.756 0-112 50.244-112 112v208h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-192h256v192h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48h-16v-192h256v192h-16c-26.4 0-48 21.6-48 48v160c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48v-160c0-26.4-21.6-48-48-48zM192 960h-128v-128h128v128zM576 960h-128v-128h128v128zM448 256v-128h128v128h-128zM960 960h-128v-128h128v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tree",
						"branches",
						"inheritance"
					],
					"defaultCode": 60518,
					"grid": 16
				},
				{
					"id": 1581,
					"width": 877.7201156616211,
					"paths": [
						"M859.429 841.143q0 14.857-10.857 25.714t-25.714 10.857h-264q0.571 9.714 3.429 50t2.857 62q0 14.286-10.286 24.286t-24.571 10h-182.857q-14.286 0-24.571-10t-10.286-24.286q0-21.714 2.857-62t3.429-50h-264q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714l229.714-230.286h-130.857q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714l229.714-230.286h-112.571q-14.857 0-25.714-10.857t-10.857-25.714 10.857-25.714l219.429-219.429q10.857-10.857 25.714-10.857t25.714 10.857l219.429 219.429q10.857 10.857 10.857 25.714t-10.857 25.714-25.714 10.857h-112.571l229.714 230.286q10.857 10.857 10.857 25.714t-10.857 25.714-25.714 10.857h-130.857l229.714 230.286q10.857 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tree"
					],
					"defaultCode": 61883,
					"grid": 14
				},
				{
					"id": 3367,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM448 768c0 35.2-28.8 64-64 64h-128c-35.2 0-64-28.8-64-64v-512c0-35.2 28.8-64 64-64h128c35.2 0 64 28.8 64 64v512zM832 576c0 35.2-28.8 64-64 64h-128c-35.2 0-64-28.8-64-64v-320c0-35.2 28.8-64 64-64h128c35.2 0 64 28.8 64 64v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trello",
						"brand"
					],
					"defaultCode": 61202,
					"grid": 16
				},
				{
					"id": 1526,
					"width": 877.7149925231934,
					"paths": [
						"M402.286 768v-585.143q0-8-5.143-13.143t-13.143-5.143h-274.286q-8 0-13.143 5.143t-5.143 13.143v585.143q0 8 5.143 13.143t13.143 5.143h274.286q8 0 13.143-5.143t5.143-13.143zM786.286 548.571v-365.714q0-8-5.143-13.143t-13.143-5.143h-274.286q-8 0-13.143 5.143t-5.143 13.143v365.714q0 8 5.143 13.143t13.143 5.143h274.286q8 0 13.143-5.143t5.143-13.143zM877.714 109.714v804.571q0 14.857-10.857 25.714t-25.714 10.857h-804.571q-14.857 0-25.714-10.857t-10.857-25.714v-804.571q0-14.857 10.857-25.714t25.714-10.857h804.571q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trello"
					],
					"defaultCode": 61825,
					"grid": 14
				},
				{
					"id": 901,
					"width": 1024,
					"paths": [
						"M800 304c0 8.832 7.168 16 16 16h25.376l-73.056 73.056c-13.664-8.032-30.272-11.616-48.224-7.008-18.144 4.672-33.184 17.728-41.472 34.528-7.232 14.624-7.84 28.32-5.152 40.8l-81.44 40.704c-12.832-14.72-32.064-23.712-53.568-21.856-23.584 2.016-43.968 17.92-53.344 39.648-5.792 13.376-6.112 25.952-3.648 37.504l-81.408 40.704c-11.776-13.408-28.832-22.080-48.064-22.080-33.408 0-60.544 25.696-63.424 58.368l-70.080 11.68c-11.84-26.624-41.28-43.648-73.408-36.352-23.936 5.44-43.36 25.664-47.904 49.792-7.776 41.248 23.904 76.96 63.552 76.512 33.152-0.384 59.808-26.016 62.688-58.336l70.176-11.68c9.824 22.016 31.648 37.536 57.216 38.016 19.712 0.352 37.792-9.824 50.112-25.216 15.872-19.872 16.928-37.152 13.472-52.768l81.312-40.48c11.552 13.44 28.416 22.176 47.456 22.464 24.896 0.352 46.752-15.008 58.144-37.152 7.552-14.656 7.872-28.128 5.184-40.48l81.44-40.544c14.272 16.384 36.448 25.728 60.896 20.928 23.584-4.64 43.2-23.552 49.152-46.816 4.64-18.144 0.992-35.008-7.296-48.736l73.312-72.8v25.6c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16zM160.384 704c-17.664 0.192-32.192-13.984-32.384-31.616-0.192-17.664 13.984-32.192 31.616-32.384 17.664-0.192 32.192 13.984 32.384 31.616 0.192 17.664-13.984 32.16-31.616 32.384zM352 672c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM544 576c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM736 480c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM896 160h-768c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96v-512c0-53.024-42.976-96-96-96zM960 768c0 35.296-28.704 64-64 64h-768c-35.296 0-64-28.704-64-64v-512c0-35.296 28.704-64 64-64h768c35.296 0 64 28.704 64 64v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trend",
						"chart",
						"grow",
						"diagram",
						"project",
						"visualize"
					],
					"grid": 32
				},
				{
					"id": 902,
					"width": 1024,
					"paths": [
						"M576 544c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM352 608c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM159.616 640c-17.632 0.192-31.808 14.72-31.616 32.384 0.192 17.632 14.72 31.808 32.384 31.616 17.632-0.224 31.808-14.72 31.616-32.384-0.192-17.632-14.72-31.808-32.384-31.616zM736 416c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM992 256v512c0 53.024-42.976 96-96 96h-768c-53.024 0-96-42.976-96-96v-512c0-53.024 42.976-96 96-96h768c53.024 0 96 42.976 96 96zM896 304c0-8.832-7.168-16-16-16h-64c-8.832 0-16 7.168-16 16s7.168 16 16 16h25.376l-73.056 73.056c-13.664-8.032-30.272-11.616-48.224-7.008-18.144 4.672-33.184 17.728-41.472 34.528-7.232 14.624-7.84 28.32-5.152 40.8l-81.44 40.704c-12.832-14.72-32.064-23.712-53.568-21.856-23.584 2.016-43.968 17.92-53.344 39.648-5.792 13.376-6.112 25.952-3.648 37.504l-81.408 40.704c-11.776-13.408-28.832-22.080-48.064-22.080-33.408 0-60.544 25.696-63.424 58.368l-70.080 11.68c-11.84-26.624-41.28-43.648-73.408-36.352-23.936 5.44-43.36 25.664-47.904 49.792-7.776 41.248 23.904 76.96 63.552 76.512 33.152-0.384 59.808-26.016 62.688-58.336l70.176-11.68c9.824 22.016 31.648 37.536 57.216 38.016 19.712 0.352 37.792-9.824 50.112-25.216 15.872-19.872 16.928-37.152 13.472-52.768l81.312-40.48c11.552 13.44 28.416 22.176 47.456 22.464 24.896 0.352 46.752-15.008 58.144-37.152 7.552-14.656 7.872-28.128 5.184-40.48l81.44-40.544c14.272 16.384 36.448 25.728 60.896 20.928 23.584-4.64 43.2-23.552 49.152-46.816 4.64-18.144 0.992-35.008-7.296-48.736l73.312-72.8v25.6c0 8.832 7.168 16 16 16s16-7.168 16-16v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trend",
						"chart",
						"grow",
						"diagram",
						"project",
						"visualize"
					],
					"grid": 32
				},
				{
					"id": 1161,
					"width": 1024,
					"paths": [
						"M960 160h-896c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h896c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32zM928 864h-832v-640h832v640zM256 736h-128v96h128v-96zM224 800h-64v-32h64v32zM288 832h128v-160h-128v160zM320 704h64v96h-64v-96zM448 832h128v-224h-128v224zM480 640h64v160h-64v-160zM608 832h128v-288h-128v288zM640 576h64v224h-64v-224zM768 832h128v-352h-128v352zM800 512h64v288h-64v-288zM843.392 386.624l-715.392 286.944v-34.784l703.968-282.048-28.576-14.304 14.304-28.64 78.304 39.2-39.168 78.304-28.64-14.304 15.2-30.368z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trend",
						"chart",
						"grow",
						"diagram",
						"project",
						"visualize"
					],
					"grid": 32
				},
				{
					"id": 3199,
					"paths": [
						"M512 265.192l345.722 598.808h-691.444l345.722-598.808zM512 73.192l-512 886.808h1024l-512-886.808z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"triangle"
					],
					"defaultCode": 61034,
					"grid": 16
				},
				{
					"id": 3200,
					"paths": [
						"M512 73.192l-512 886.808h1024z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"triangle"
					],
					"defaultCode": 61035,
					"grid": 16
				},
				{
					"id": 1735,
					"width": 1316.5710525512695,
					"paths": [
						"M372 569.714q0 22.286-15.714 38t-37.429 15.714q-22.286 0-38-15.714t-15.714-38q0-21.714 15.714-37.429t38-15.714q21.714 0 37.429 15.714t15.714 37.429zM1031.429 569.143q0 22.286-15.714 38t-38 15.714-38-15.714-15.714-38 15.714-37.714 38-15.429 38 15.429 15.714 37.714zM437.143 569.714q0-45.143-32.286-77.714t-78-32.571-78 32.286-32.286 78 32.286 78 78 32.286 78-32.286 32.286-78zM1096 569.143q0-45.714-32.286-78t-78-32.286q-45.143 0-77.714 32.286t-32.571 78 32.286 78 78 32.286 78-32.286 32.286-78zM485.714 569.714q0 66.286-46.571 112.857t-112.286 46.571q-66.286 0-112.857-46.857t-46.571-112.571 46.857-112.286 112.571-46.571 112.286 46.571 46.571 112.286zM1145.143 569.143q0 65.714-46.571 112.286t-112.857 46.571q-65.714 0-112.286-46.571t-46.571-112.286 46.571-112.286 112.286-46.571q66.286 0 112.857 46.571t46.571 112.286zM594.286 570.857q0-109.143-77.429-186.571t-186.571-77.429q-71.429 0-132 35.429t-96 96.286-35.429 132.286 35.429 132.286 96 96.286 132 35.429q109.143 0 186.571-77.429t77.429-186.571zM976 243.429q-145.143-63.429-317.714-63.429-182.286 0-327.429 62.857 66.857 0 127.429 26t104.286 70 69.714 104.571 26 127.429q0-65.714 24.857-125.429t67.429-103.143 101.429-70.286 124-28.571zM1249.714 570.857q0-109.143-77.143-186.571t-186.286-77.429-186.571 77.429-77.429 186.571 77.429 186.571 186.571 77.429 186.286-77.429 77.143-186.571zM1097.714 247.429h218.857q-25.143 29.143-42.857 65.429t-22.857 65.429q62.857 86.286 62.857 192.571 0 89.143-44 164.571t-119.429 119.143-164 43.714q-76 0-142.286-32t-112-88.571q-26.857 32-73.714 102.286-6.286-12.571-30.571-47.143t-42.571-55.714q-45.714 56.571-112.286 88.857t-142.571 32.286q-88.571 0-164-43.714t-119.429-119.143-44-164.571q0-106.286 62.857-192.571-5.143-29.143-22.857-65.429t-42.857-65.429h208.571q85.143-57.143 202.857-89.429t246.857-32.286q128 0 240.571 32t198.857 89.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tripadvisor"
					],
					"defaultCode": 62050,
					"grid": 14
				},
				{
					"id": 2491,
					"paths": [
						"M1024 64c-64 0-320 0-320 0v128h-384v-128c0 0-256 0-320 0 0 320 256 694.376 448 752v80c-64 0-128 32-128 64h384c0-32-64-64-128-64v-80c192-57.624 448-432 448-752zM767.7 226.454l0.3-34.454v-64h188.454c-5.574 51.678-17.71 106.256-36.28 162.99-24.544 74.998-60.116 151.82-102.866 222.164-41.118 67.652-87.792 127.718-134.976 173.704-4.532 4.416-9.042 8.672-13.53 12.782 84.836-170.116 97.12-382.996 98.898-473.186zM341.668 686.856c-47.186-45.984-93.86-106.050-134.976-173.704-42.75-70.344-78.322-147.166-102.866-222.164-18.568-56.732-30.706-111.31-36.28-162.988h188.454v64l0.3 34.454c1.778 90.192 14.062 303.070 98.896 473.184-4.486-4.11-8.998-8.366-13.528-12.782z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trophy",
						"cup",
						"prize",
						"award",
						"winner",
						"tournament"
					],
					"defaultCode": 60326,
					"grid": 16
				},
				{
					"id": 2492,
					"paths": [
						"M832 192v-128h-640v128h-192v128c0 106.038 85.958 192 192 192 20.076 0 39.43-3.086 57.62-8.802 46.174 66.008 116.608 113.796 198.38 130.396v198.406h-64c-70.694 0-128 57.306-128 128h512c0-70.694-57.306-128-128-128h-64v-198.406c81.772-16.6 152.206-64.386 198.38-130.396 18.19 5.716 37.544 8.802 57.62 8.802 106.042 0 192-85.962 192-192v-128h-192zM192 436c-63.962 0-116-52.038-116-116v-64h116v64c0 40.186 7.43 78.632 20.954 114.068-6.802 1.246-13.798 1.932-20.954 1.932zM948 320c0 63.962-52.038 116-116 116-7.156 0-14.152-0.686-20.954-1.932 13.524-35.436 20.954-73.882 20.954-114.068v-64h116v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trophy",
						"cup",
						"prize",
						"award",
						"winner",
						"tournament"
					],
					"defaultCode": 60327,
					"grid": 16
				},
				{
					"id": 2493,
					"paths": [
						"M832 192v-128h-640v128h-192v128c0 106.038 85.958 192 192 192 20.076 0 39.43-3.086 57.62-8.802 46.174 66.008 116.608 113.796 198.38 130.396v198.406h-64c-70.694 0-128 57.306-128 128h512c0-70.694-57.306-128-128-128h-64v-198.406c81.772-16.6 152.206-64.386 198.38-130.396 18.19 5.716 37.544 8.802 57.62 8.802 106.042 0 192-85.962 192-192v-128h-192zM192 436c-63.962 0-116-52.038-116-116v-64h116v64c0 40.186 7.43 78.632 20.954 114.068-6.802 1.246-13.798 1.932-20.954 1.932zM609.414 371.194l61.020 186.416-158.434-115.642-158.432 115.642 61.018-186.416-158.936-114.944 196.144 0.428 60.206-186.678 60.208 186.678 196.142-0.428-158.936 114.944zM948 320c0 63.962-52.038 116-116 116-7.156 0-14.152-0.686-20.954-1.932 13.524-35.436 20.954-73.882 20.954-114.068v-64h116v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trophy",
						"cup",
						"prize",
						"award",
						"winner",
						"tournament"
					],
					"defaultCode": 60328,
					"grid": 16
				},
				{
					"id": 2496,
					"paths": [
						"M832 128h-640l-192 256 512 576-142.222-512h284.446l-142.224 512 512-576-192-256zM80 384l146.042-194.724 108.18 194.724h-254.222zM369.778 384l106.666-192h71.11l106.668 192h-284.444zM797.958 189.276l146.042 194.724h-254.222l108.18-194.724z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trophy",
						"gem",
						"prize",
						"award",
						"winner",
						"tournament"
					],
					"defaultCode": 60331,
					"grid": 16
				},
				{
					"id": 1315,
					"width": 950.8559875488281,
					"paths": [
						"M261.714 504.571q-42.286-92.571-42.286-212h-146.286v54.857q0 44.571 54 92.571t134.571 64.571zM877.714 347.429v-54.857h-146.286q0 119.429-42.286 212 80.571-16.571 134.571-64.571t54-92.571zM950.857 274.286v73.143q0 40.571-23.714 81.714t-64 74.286-98.857 55.714-123.143 25.429q-24 30.857-54.286 54.286-21.714 19.429-30 41.429t-8.286 51.143q0 30.857 17.429 52t55.714 21.143q42.857 0 76.286 26t33.429 65.429v36.571q0 8-5.143 13.143t-13.143 5.143h-475.429q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-39.429 33.429-65.429t76.286-26q38.286 0 55.714-21.143t17.429-52q0-29.143-8.286-51.143t-30-41.429q-30.286-23.429-54.286-54.286-64.571-2.857-123.143-25.429t-98.857-55.714-64-74.286-23.714-81.714v-73.143q0-22.857 16-38.857t38.857-16h164.571v-54.857q0-37.714 26.857-64.571t64.571-26.857h329.143q37.714 0 64.571 26.857t26.857 64.571v54.857h164.571q22.857 0 38.857 16t16 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trophy"
					],
					"defaultCode": 61585,
					"grid": 14
				},
				{
					"id": 2596,
					"paths": [
						"M1024 576l-128-256h-192v-128c0-35.2-28.8-64-64-64h-576c-35.2 0-64 28.8-64 64v512l64 64h81.166c-10.898 18.832-17.166 40.678-17.166 64 0 70.692 57.308 128 128 128s128-57.308 128-128c0-23.322-6.268-45.168-17.166-64h354.334c-10.898 18.832-17.168 40.678-17.168 64 0 70.692 57.308 128 128 128s128-57.308 128-128c0-23.322-6.27-45.168-17.168-64h81.168v-192zM704 576v-192h132.668l96 192h-228.668z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"truck",
						"transit",
						"transport",
						"delivery",
						"vehicle"
					],
					"defaultCode": 60431,
					"grid": 16
				},
				{
					"id": 1363,
					"width": 1060.5699462890625,
					"paths": [
						"M365.714 804.571q0-29.714-21.714-51.429t-51.429-21.714-51.429 21.714-21.714 51.429 21.714 51.429 51.429 21.714 51.429-21.714 21.714-51.429zM146.286 512h219.429v-146.286h-90.286q-7.429 0-12.571 5.143l-111.429 111.429q-5.143 5.143-5.143 12.571v17.143zM877.714 804.571q0-29.714-21.714-51.429t-51.429-21.714-51.429 21.714-21.714 51.429 21.714 51.429 51.429 21.714 51.429-21.714 21.714-51.429zM1024 182.857v585.143q0 8.571-2.286 15.143t-7.714 10.571-9.429 6.571-13.429 3.429-12.857 1.143-14.571 0-12.857-0.286q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429h-219.429q0 60.571-42.857 103.429t-103.429 42.857-103.429-42.857-42.857-103.429h-36.571q-1.714 0-12.857 0.286t-14.571 0-12.857-1.143-13.429-3.429-9.429-6.571-7.714-10.571-2.286-15.143q0-14.857 10.857-25.714t25.714-10.857v-182.857q0-4.571-0.286-20t0-21.714 1.429-19.714 3.714-21.143 8-17.429 12.857-17.143l113.143-113.143q10.857-10.857 28.857-18.286t33.429-7.429h91.429v-109.714q0-14.857 10.857-25.714t25.714-10.857h585.143q14.857 0 25.714 10.857t10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"truck"
					],
					"defaultCode": 61649,
					"grid": 14
				},
				{
					"id": 1898,
					"paths": [
						"M992 192c-17.674 0-32 14.328-32 32 0 81.372-47.27 133.116-86.924 162.196-53.56 39.276-126.848 61.804-201.076 61.804h-32v-96c0-17.672-14.326-32-32-32s-32 14.328-32 32v96h-64v-96c0-17.672-14.328-32-32-32s-32 14.328-32 32v96h-64v-96c0-17.672-14.328-32-32-32s-32 14.328-32 32v96h-256v-32c0-17.672-14.328-32-32-32s-32 14.328-32 32v192c0 17.674 14.328 32 32 32s32-14.326 32-32v-32h138.982c-7.102 20.028-10.982 41.568-10.982 64 0 105.87 86.13 192 192 192h192c105.87 0 192-86.13 192-192 0-18.488-2.634-36.37-7.534-53.298 41.88 10.292 80.738 27.73 112.61 51.104 39.654 29.078 86.924 80.822 86.924 162.194 0 17.674 14.326 32 32 32s32-14.326 32-32v-576c0-17.672-14.326-32-32-32zM576 704h-192c-35.29 0-64-28.71-64-64s28.71-64 64-64h192c35.29 0 64 28.71 64 64s-28.71 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"trumpet",
						"music",
						"song",
						"musical-instrument"
					],
					"defaultCode": 59733,
					"grid": 16
				},
				{
					"id": 1545,
					"width": 658.2902088165283,
					"paths": [
						"M658.286 475.429q0 109.143-54 201.714t-146.571 146.571-201.714 54h-91.429q-8 0-13.143-5.143t-5.143-13.143v-349.143l-122.857 37.714q-1.714 0.571-5.143 0.571-5.714 0-10.857-3.429-7.429-5.714-7.429-14.857v-73.143q0-13.143 13.143-17.714l133.143-40.571v-53.143l-122.857 37.714q-1.714 0.571-5.143 0.571-5.714 0-10.857-3.429-7.429-5.714-7.429-14.857v-73.143q0-13.143 13.143-17.714l133.143-40.571v-142.857q0-8 5.143-13.143t13.143-5.143h91.429q8 0 13.143 5.143t5.143 13.143v103.429l214.286-66.286q8.571-2.857 16 2.857t7.429 14.857v73.143q0 13.143-13.143 17.714l-224.571 69.143v53.143l214.286-66.286q8.571-2.857 16 2.857t7.429 14.857v73.143q0 13.143-13.143 17.714l-224.571 69.143v278.286q107.429-7.429 181.714-86.286t74.286-187.429q0-8 5.143-13.143t13.143-5.143h91.429q8 0 13.143 5.143t5.143 13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"try",
						"turkish-lira"
					],
					"defaultCode": 61845,
					"grid": 14
				},
				{
					"id": 2347,
					"paths": [
						"M697.952 128l326.048 64v256h-192v512h-640v-512h-192v-256l326.048-64c21.316 82.81 96.486 144 185.952 144s164.638-61.19 185.952-144z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tshirt",
						"shirt",
						"team",
						"member"
					],
					"defaultCode": 60182,
					"grid": 16
				},
				{
					"id": 1619,
					"width": 1024.0020666122437,
					"paths": [
						"M256 749.714v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM146.286 530.286v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM475.429 749.714v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM365.714 530.286v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM37.714 438.857q-16 0-26.857-10.857t-10.857-26.286v-73.714h293.714v73.714q0 15.429-10.857 26.286t-26.286 10.857h-218.857zM694.857 749.714v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM585.143 530.286v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM914.286 749.714v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM804.571 530.286v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM1024 297.143v7.429h-293.714v-5.714q0-59.429-218.286-58.286-218.286 0.571-218.286 58.286v5.714h-293.714v-7.429q0-9.714 4.857-24.571t19.429-36.571 37.429-43.143 63.143-43.429 91.429-38.571 128-27.143 167.714-10.571 167.429 10.571 128 27.143 91.714 38.571 63.143 43.429 37.429 43.143 19.429 36.571 4.857 24.571zM1024 530.286v109.714q0 8-5.143 13.143t-13.143 5.143h-109.714q-8 0-13.143-5.143t-5.143-13.143v-109.714q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143zM1024 328v73.714q0 15.429-10.857 26.286t-26.286 10.857h-219.429q-15.429 0-26.286-10.857t-10.857-26.286v-73.714h293.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tty"
					],
					"defaultCode": 61924,
					"grid": 14
				},
				{
					"id": 3373,
					"paths": [
						"M576.032 448l-0.002 234.184c0 59.418-0.77 93.656 5.53 110.5 6.25 16.754 21.918 34.146 38.99 44.202 22.684 13.588 48.542 20.376 77.708 20.376 51.854 0 82.478-6.848 133.742-40.54v153.944c-43.7 20.552-81.866 32.594-117.324 40.922-35.5 8.242-73.86 12.406-115.064 12.406-46.828 0-74.456-5.886-110.41-17.656-35.958-11.868-66.66-28.806-92.020-50.54-25.45-21.922-43.022-45.208-52.848-69.832-9.826-24.636-14.716-60.414-14.716-107.244v-359.1h-137.426v-145.006c40.208-13.042 85.164-31.788 113.78-56.152 28.754-24.45 51.766-53.706 69.106-87.944 17.392-34.146 29.348-77.712 35.872-130.516h165.084l-0.002 255.996h255.968v192h-255.968z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tumblr",
						"brand",
						"social"
					],
					"defaultCode": 61208,
					"grid": 16
				},
				{
					"id": 1514,
					"width": 877.7129821777344,
					"paths": [
						"M649.143 834.857l-35.429-104.571q-25.143 12.571-58.857 12.571-20.571 0.571-35.429-6t-22-18-10-23.143-2.857-24.857v-227.429h146.857v-110.857h-146.286v-186.286h-107.429q-4.571 0-5.143 5.714-2.857 25.143-10 49.714t-22.286 54.286-44 54.286-67.714 38.857v94.286h74.286v238.857q0 32.571 12.286 65.714t37.143 63.429 69.143 48.857 100.857 17.429q39.429-0.571 78-14.286t48.857-28.571zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tumblr-square"
					],
					"defaultCode": 61812,
					"grid": 14
				},
				{
					"id": 3374,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM731.8 824.6c-30.2 14.2-57.6 24.2-82 30-24.4 5.6-51 8.6-79.4 8.6-32.4 0-51.4-4-76.2-12.2s-46-19.8-63.6-34.8c-17.6-15.2-29.6-31.2-36.4-48.2s-10.2-41.6-10.2-74v-247.8h-96v-100c27.8-9 60-22 79.6-38.8 19.8-16.8 35.8-37 47.6-60.6 12-23.6 20.2-53.6 24.8-90h100.4v163.2h163.6v126.2h-163.4v181.2c0 41-0.6 64.6 3.8 76.2s15.2 23.6 27 30.4c15.6 9.4 33.6 14 53.6 14 35.8 0 71.4-11.6 106.8-34.8v111.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tumblr",
						"brand",
						"social"
					],
					"defaultCode": 61209,
					"grid": 16
				},
				{
					"id": 1513,
					"width": 623.9989624023438,
					"paths": [
						"M539.429 759.429l45.714 135.429q-13.143 20-63.429 37.714t-101.143 18.286q-59.429 1.143-108.857-14.857t-81.429-42.286-54.286-60.571-31.714-68.571-9.429-67.429v-310.857h-96v-122.857q41.143-14.857 73.714-39.714t52-51.429 33.143-58.286 19.429-56.571 8.571-50.571q0.571-2.857 2.571-4.857t4.286-2h139.429v242.286h190.286v144h-190.857v296q0 17.143 3.714 32t12.857 30 28.286 23.714 46.571 8q44.571-1.143 76.571-16.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tumblr"
					],
					"defaultCode": 61811,
					"grid": 14
				},
				{
					"id": 1162,
					"width": 1024,
					"paths": [
						"M704 448c-88.352 0-160 71.648-160 160s71.648 160 160 160 160-71.648 160-160-71.648-160-160-160zM704 736c-70.592 0-128-57.408-128-128s57.408-128 128-128 128 57.408 128 128c0 70.592-57.408 128-128 128zM608 800h32v32h-32v-32zM768 800h32v32h-32v-32zM704 544c-35.36 0-64 28.64-64 64s28.64 64 64 64 64-28.64 64-64c0-35.36-28.64-64-64-64zM704 640c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM192 544h224v32h-224v-32zM192 608h224v32h-224v-32zM192 672h224v32h-224v-32zM992 320h-128v-256c0-17.664-14.336-32-32-32s-32 14.336-32 32v256h-768c-17.664 0-32 14.336-32 32v576c0 17.664 14.336 32 32 32h32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h640c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32h32c17.664 0 32-14.336 32-32v-576c0-17.664-14.336-32-32-32zM960 896h-896v-512h896v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tune",
						"listen",
						"sound"
					],
					"grid": 32
				},
				{
					"id": 903,
					"width": 1024,
					"paths": [
						"M864 64h-704c-53.024 0-96 42.976-96 96v704c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-704c0-53.024-42.976-96-96-96zM928 864c0 35.296-28.704 64-64 64h-704c-35.296 0-64-28.704-64-64v-704c0-35.296 28.704-64 64-64h704c35.296 0 64 28.704 64 64v704zM608 672c88.352 0 160-71.648 160-160s-71.648-160-160-160-160 71.648-160 160 71.648 160 160 160zM513.6 527.68c2.464 14.752 8.16 28.32 16.544 40-0.416 0.352-0.928 0.48-1.312 0.864l-21.504 21.504c-13.728-17.664-22.752-38.816-25.696-62.080h30.368c0.576 0.032 1.024-0.224 1.6-0.288zM608 448c35.36 0 64 28.64 64 64s-28.64 64-64 64c-35.36 0-64-28.64-64-64s28.64-64 64-64zM551.424 591.2c0.384-0.384 0.544-0.896 0.864-1.312 11.68 8.384 25.248 14.080 40 16.544-0.064 0.544-0.32 1.024-0.32 1.6v30.368c-23.264-2.944-44.416-11.968-62.080-25.664l21.536-21.536zM623.68 606.432c14.752-2.464 28.32-8.16 40-16.544 0.352 0.416 0.48 0.928 0.864 1.312l21.504 21.504c-17.664 13.728-38.816 22.72-62.080 25.664v-30.368c0.032-0.576-0.224-1.024-0.288-1.568zM664.576 432.8c-0.384 0.384-0.544 0.896-0.864 1.312-11.68-8.384-25.248-14.080-40-16.544 0.064-0.544 0.32-1.024 0.32-1.568v-30.368c23.264 2.944 44.416 11.968 62.080 25.664l-21.536 21.504zM592.32 417.6c-14.752 2.464-28.32 8.16-40 16.544-0.352-0.416-0.48-0.928-0.864-1.312l-21.504-21.504c17.664-13.728 38.816-22.72 62.080-25.664v30.336c-0.032 0.576 0.224 1.024 0.288 1.6zM708.704 590.080l-21.504-21.504c-0.384-0.384-0.896-0.544-1.312-0.864 8.384-11.68 14.080-25.248 16.544-40 0.544 0.064 1.024 0.32 1.6 0.32h30.368c-2.976 23.232-11.968 44.384-25.696 62.048zM734.368 496h-30.368c-0.576 0-1.024 0.256-1.568 0.32-2.432-14.752-8.16-28.32-16.544-40 0.416-0.352 0.928-0.48 1.312-0.864l21.504-21.504c13.728 17.632 22.72 38.784 25.664 62.048zM507.296 433.92l21.504 21.504c0.384 0.384 0.896 0.544 1.312 0.864-8.384 11.68-14.080 25.248-16.544 40-0.544-0.032-0.992-0.288-1.568-0.288h-30.368c2.944-23.264 11.936-44.416 25.664-62.080zM832 160h-640c-17.664 0-32 14.336-32 32v64c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32v192c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32v64c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-640c0-17.664-14.336-32-32-32zM160 288h32v96h-32v-96zM160 640h32v96h-32v-96zM832 832h-640v-64c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32v-192c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32v-64h640v640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"turn",
						"keep",
						"lock",
						"save",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 904,
					"width": 1024,
					"paths": [
						"M685.888 456.32c0.416-0.352 0.928-0.48 1.312-0.864l21.504-21.504c13.728 17.664 22.752 38.816 25.696 62.080h-30.4c-0.576 0-1.024 0.256-1.568 0.32-2.464-14.784-8.16-28.352-16.544-40.032zM192 288h-32v96h32v-96zM664.576 432.8l21.504-21.504c-17.664-13.728-38.816-22.72-62.080-25.664v30.368c0 0.576-0.256 1.024-0.32 1.568 14.752 2.432 28.32 8.16 40 16.544 0.352-0.416 0.512-0.928 0.896-1.312zM702.4 527.68c-2.464 14.752-8.16 28.32-16.544 40 0.416 0.352 0.928 0.48 1.312 0.864l21.504 21.504c13.728-17.664 22.752-38.816 25.696-62.080h-30.368c-0.576 0.032-1.024-0.224-1.6-0.288zM192 640h-32v96h32v-96zM551.424 591.2l-21.504 21.504c17.664 13.728 38.816 22.72 62.080 25.664v-30.368c0-0.576 0.256-1.024 0.32-1.6-14.752-2.464-28.32-8.16-40-16.544-0.352 0.448-0.512 0.96-0.896 1.344zM663.68 589.888c-11.68 8.384-25.248 14.080-40 16.544 0.064 0.544 0.32 1.024 0.32 1.568v30.368c23.264-2.944 44.416-11.968 62.080-25.664l-21.504-21.504c-0.384-0.384-0.544-0.896-0.896-1.312zM544 512c0 35.36 28.64 64 64 64s64-28.64 64-64-28.64-64-64-64c-35.36 0-64 28.64-64 64zM192 192h640v640h-640v-64c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32v-192c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32v-64zM448 512c0 88.352 71.648 160 160 160s160-71.648 160-160-71.648-160-160-160-160 71.648-160 160zM960 160v704c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-704c0-53.024 42.976-96 96-96h704c53.024 0 96 42.976 96 96zM864 192c0-17.664-14.336-32-32-32h-640c-17.664 0-32 14.336-32 32v64c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32v192c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32v64c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-640zM528.8 568.576c0.384-0.384 0.896-0.544 1.312-0.864-8.384-11.68-14.080-25.248-16.544-40-0.544 0.064-1.024 0.32-1.6 0.32h-30.368c2.944 23.264 11.968 44.416 25.696 62.080l21.504-21.536zM552.32 434.112c11.68-8.384 25.248-14.080 40-16.544-0.064-0.544-0.32-1.024-0.32-1.6v-30.368c-23.264 2.944-44.416 11.968-62.080 25.664l21.504 21.504c0.384 0.416 0.544 0.928 0.896 1.344zM513.568 496.32c2.464-14.752 8.16-28.32 16.544-40-0.416-0.352-0.928-0.48-1.312-0.864l-21.504-21.504c-13.728 17.664-22.752 38.816-25.696 62.080h30.4c0.576-0.032 1.024 0.224 1.568 0.288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"turn",
						"keep",
						"lock",
						"save",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 3377,
					"paths": [
						"M567.656 736.916c-81.944 38.118-158.158 37.716-209.34 34.020-61.052-4.41-110.158-21.124-131.742-35.732-13.3-9.006-31.384-5.522-40.39 7.782-9.004 13.302-5.52 31.386 7.782 40.39 34.698 23.486 96.068 40.954 160.162 45.58 10.866 0.784 22.798 1.278 35.646 1.278 55.782 0 126.626-5.316 202.42-40.57 14.564-6.778 20.878-24.074 14.104-38.64-6.776-14.566-24.076-20.872-38.642-14.108zM890.948 693.816c2.786-252.688 28.762-730.206-454.97-691.612-477.6 38.442-350.964 542.968-358.082 711.95-6.308 89.386-35.978 198.648-77.896 309.846h129.1c13.266-47.122 23.024-93.72 27.232-138.15 7.782 5.428 16.108 10.674 24.994 15.7 14.458 8.518 26.884 19.844 40.040 31.834 30.744 28.018 65.59 59.774 133.712 63.752 4.572 0.262 9.174 0.394 13.676 0.394 68.896 0 116.014-30.154 153.878-54.382 18.14-11.612 33.818-21.64 48.564-26.452 41.91-13.12 78.532-34.296 105.904-61.252 4.276-4.208 8.242-8.538 11.962-12.948 15.246 55.878 36.118 118.758 59.288 181.504h275.65c-66.174-102.224-134.436-202.374-133.052-330.184zM124.11 556.352c0-0.016 0-0.030-0.002-0.046-4.746-82.462 34.71-151.832 88.126-154.936 53.412-3.106 100.56 61.228 105.304 143.692 0 0.014 0.004 0.030 0.004 0.044 0.256 4.446 0.368 8.846 0.37 13.206-16.924 4.256-32.192 10.436-45.872 17.63-0.052-0.612-0.092-1.216-0.152-1.83 0-0.008 0-0.018 0-0.026-4.57-46.81-29.572-82.16-55.852-78.958-26.28 3.204-43.88 43.75-39.312 90.558 0 0.010 0.004 0.018 0.004 0.026 1.992 20.408 7.868 38.636 16.042 52.444-2.034 1.604-7.784 5.812-14.406 10.656-4.97 3.634-11.020 8.058-18.314 13.43-19.882-26.094-33.506-63.58-35.94-105.89zM665.26 760.178c-1.9 43.586-58.908 84.592-111.582 101.044l-0.296 0.096c-21.9 7.102-41.428 19.6-62.104 32.83-34.732 22.224-70.646 45.208-122.522 45.208-3.404 0-6.894-0.104-10.326-0.296-47.516-2.778-69.742-23.032-97.88-48.676-14.842-13.526-30.19-27.514-49.976-39.124l-0.424-0.244c-42.706-24.104-69.212-54.082-70.908-80.194-0.842-12.98 4.938-24.218 17.182-33.4 26.636-19.972 44.478-33.022 56.284-41.658 13.11-9.588 17.068-12.48 20-15.264 2.096-1.986 4.364-4.188 6.804-6.562 24.446-23.774 65.36-63.562 128.15-63.562 38.404 0 80.898 14.8 126.17 43.902 21.324 13.878 39.882 20.286 63.38 28.4 16.156 5.578 34.468 11.902 58.992 22.404l0.396 0.164c22.88 9.404 49.896 26.564 48.66 54.932zM652.646 657.806c-4.4-2.214-8.974-4.32-13.744-6.286-22.106-9.456-39.832-15.874-54.534-20.998 8.116-15.894 13.16-35.72 13.624-57.242 0-0.010 0-0.022 0-0.030 1.126-52.374-25.288-94.896-58.996-94.976-33.71-0.078-61.95 42.314-63.076 94.686 0 0.010 0 0.018 0 0.028-0.038 1.714-0.042 3.416-0.020 5.11-20.762-9.552-41.18-16.49-61.166-20.76-0.092-1.968-0.204-3.932-0.244-5.92 0-0.016 0-0.036 0-0.050-1.938-95.412 56.602-174.39 130.754-176.402 74.15-2.014 135.828 73.7 137.772 169.11 0 0.018 0 0.038 0 0.052 0.874 43.146-10.66 82.866-30.37 113.678z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tux",
						"brand",
						"linux"
					],
					"defaultCode": 61212,
					"grid": 16
				},
				{
					"id": 2193,
					"paths": [
						"M981.188 288.108c-88.808-12.768-183.382-22.016-282.076-27.22l164.888-164.888-64-64-224.558 224.556c-21.006-0.368-42.156-0.556-63.442-0.556v0l-256-256-64 64 194.196 194.196c-120.922 4.242-236.338 14.524-343.386 29.912-27.532 107.726-42.81 226.752-42.81 351.892s15.278 244.166 42.804 351.89c143.642 20.652 302.34 32.11 469.196 32.11s325.55-11.458 469.188-32.11c27.534-107.724 42.812-226.75 42.812-351.89s-15.278-244.166-42.812-351.892zM863.892 874.594c-107.73 13.766-226.75 21.406-351.892 21.406s-244.166-7.64-351.892-21.406c-20.648-71.816-32.108-151.166-32.108-234.594 0-83.43 11.458-162.78 32.108-234.596 107.726-13.766 226.75-21.404 351.892-21.404 125.136 0 244.162 7.638 351.886 21.404 20.656 71.816 32.114 151.166 32.114 234.596 0 83.428-11.458 162.778-32.108 234.594z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tv",
						"television",
						"show"
					],
					"defaultCode": 60028,
					"grid": 16
				},
				{
					"id": 905,
					"width": 1024,
					"paths": [
						"M448 320c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM212.672 372.672l-30.816-30.816c-15.968-32.48-49.44-54.816-88.32-53.824-49.824 1.248-91.392 42.080-93.472 91.872-2.272 54.88 41.568 100.096 95.936 100.096 37.824 0 70.24-22.080 85.856-53.856l30.816-30.816c6.272-6.272 6.272-16.384 0-22.656zM155.488 407.264l-2.336 4.736c-10.912 22.208-32.832 36-57.152 36-35.296 0-64-28.704-64-64s28.704-64 64-64c24.32 0 46.24 13.792 57.152 36l2.336 4.768 23.264 23.232-23.264 23.264zM990.4 416h-142.88l-71.776-71.776c-23.2-23.2-51.040-38.336-80.384-47.168-23.84-86.816-95.296-156.192-187.392-167.36-9.408-1.152-18.752-1.696-27.968-1.696-112.832 0-205.888 83.488-221.44 192h-47.232c-7.136 0-10.688 8.608-5.664 13.664l50.336 50.336-50.336 50.336c-5.056 5.056-1.472 13.664 5.664 13.664h47.392c19.264 172.704 148.32 316.544 317.28 346.016v85.984c0 8.832 7.168 16 16 16s16-7.168 16-16v-81.824c8.224 0.704 16.416 1.6 24.8 1.76 2.4 0.032 4.832 0.064 7.2 0.064v80c0 8.832 7.168 16 16 16s16-7.168 16-16v-81.6c185.472-15.328 333.6-162.176 350.4-347.2 1.728-18.88-13.056-35.2-32-35.2zM753.152 366.848l113.12 113.152-113.12 113.152c-30.24 30.208-70.4 46.848-113.152 46.848s-82.912-16.64-113.152-46.848-46.848-70.4-46.848-113.152c0-42.752 16.64-82.912 46.848-113.152 30.24-30.208 70.4-46.848 113.152-46.848s82.912 16.64 113.152 46.848zM640 768l-6.592-0.064c-190.464-3.488-345.408-167.072-345.408-364.672v-51.264c0-51.296 19.968-99.52 56.224-135.776s84.48-56.224 135.776-56.224c8 0 16.096 0.48 24.16 1.472 72.384 8.768 131.136 59.936 155.552 128.416v0c-6.592-0.672-13.12-1.888-19.712-1.888-49.152 0-98.272 18.752-135.776 56.224-74.976 74.976-74.976 196.544 0 271.52 37.504 37.504 86.624 56.256 135.776 56.256s98.272-18.752 135.776-56.224l114.144-114.112c5.376-5.568 8.832-13.216 8.832-21.632 0-8.288-3.264-15.744-8.48-21.28l-10.752-10.752h111.040c-16.224 179.168-167.232 320-350.56 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tweet",
						"sing",
						"speak"
					],
					"grid": 32
				},
				{
					"id": 906,
					"width": 1024,
					"paths": [
						"M212.672 395.328l-30.816 30.816c-15.616 31.776-48.032 53.856-85.856 53.856-54.368 0-98.208-45.216-95.904-100.096 2.080-49.792 43.616-90.624 93.472-91.872 38.88-0.992 72.352 21.344 88.32 53.824l30.816 30.816c6.24 6.272 6.24 16.384-0.032 22.656zM526.848 366.848c-30.208 30.24-46.848 70.4-46.848 113.152s16.64 82.912 46.848 113.152 70.4 46.848 113.152 46.848c42.752 0 82.912-16.64 113.152-46.848l113.12-113.152-113.152-113.152c-30.208-30.208-70.368-46.848-113.12-46.848s-82.912 16.64-113.152 46.848zM1022.4 451.2c-16.8 184.992-164.928 331.84-350.4 347.2v81.6c0 8.832-7.168 16-16 16s-16-7.168-16-16v-80c-2.368 0-4.8-0.032-7.2-0.064-8.384-0.16-16.576-1.056-24.8-1.76v81.824c0 8.832-7.168 16-16 16s-16-7.168-16-16v-85.984c-168.96-29.472-298.016-173.312-317.28-346.016h-47.392c-7.136 0-10.688-8.608-5.664-13.664l50.336-50.336-50.336-50.336c-5.056-5.056-1.472-13.664 5.664-13.664h47.232c15.552-108.512 108.608-192 221.44-192 9.216 0 18.56 0.544 28 1.696 91.712 11.104 162.88 80 187.040 166.304-17.664-5.248-36.128-8-55.040-8-51.296 0-99.488 19.968-135.776 56.224-36.256 36.288-56.224 84.48-56.224 135.776s19.968 99.488 56.224 135.776 84.48 56.224 135.776 56.224 99.488-19.968 135.776-56.224l113.12-113.152c12.512-12.512 12.512-32.768 0-45.248l-41.376-41.376h142.88c18.944 0 33.728 16.32 32 35.2zM448 320c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"tweet",
						"sing",
						"speak"
					],
					"grid": 32
				},
				{
					"id": 3347,
					"paths": [
						"M96 0l-96 160v736h256v128h128l128-128h160l288-288v-608h-864zM832 544l-160 160h-160l-128 128v-128h-192v-576h640v416z",
						"M608 256h96v256h-96v-256z",
						"M416 256h96v256h-96v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"twitch",
						"brand",
						"social"
					],
					"defaultCode": 61182,
					"grid": 16
				},
				{
					"id": 1623,
					"width": 1023.9989929199219,
					"paths": [
						"M512 248v248h-82.857v-248h82.857zM739.429 248v248h-82.857v-248h82.857zM739.429 682.286l144.571-145.143v-454.286h-682.286v599.429h186.286v124l124-124h227.429zM966.857 0v578.857l-248 248h-186.286l-124 124h-124v-124h-227.429v-661.714l62.286-165.143h847.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"twitch"
					],
					"defaultCode": 61928,
					"grid": 14
				},
				{
					"id": 3338,
					"paths": [
						"M1024 226.4c-37.6 16.8-78.2 28-120.6 33 43.4-26 76.6-67.2 92.4-116.2-40.6 24-85.6 41.6-133.4 51-38.4-40.8-93-66.2-153.4-66.2-116 0-210 94-210 210 0 16.4 1.8 32.4 5.4 47.8-174.6-8.8-329.4-92.4-433-219.6-18 31-28.4 67.2-28.4 105.6 0 72.8 37 137.2 93.4 174.8-34.4-1-66.8-10.6-95.2-26.2 0 0.8 0 1.8 0 2.6 0 101.8 72.4 186.8 168.6 206-17.6 4.8-36.2 7.4-55.4 7.4-13.6 0-26.6-1.4-39.6-3.8 26.8 83.4 104.4 144.2 196.2 146-72 56.4-162.4 90-261 90-17 0-33.6-1-50.2-3 93.2 59.8 203.6 94.4 322.2 94.4 386.4 0 597.8-320.2 597.8-597.8 0-9.2-0.2-18.2-0.6-27.2 41-29.4 76.6-66.4 104.8-108.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"twitter",
						"brand",
						"tweet",
						"social"
					],
					"defaultCode": 61173,
					"grid": 16
				},
				{
					"id": 1300,
					"width": 877.7129821777344,
					"paths": [
						"M731.429 348.571q-32 14.286-69.143 19.429 38.857-22.857 53.143-66.857-37.143 21.714-76.571 29.143-34.857-37.714-87.429-37.714-49.714 0-84.857 35.143t-35.143 84.857q0 16.571 2.857 27.429-73.714-4-138.286-37.143t-109.714-88.571q-16.571 28.571-16.571 60.571 0 65.143 52 100-26.857-0.571-57.143-14.857v1.143q0 42.857 28.571 76.286t70.286 41.429q-16.571 4.571-29.143 4.571-7.429 0-22.286-2.286 12 36 42.571 59.429t69.429 24q-66.286 51.429-149.143 51.429-14.857 0-28.571-1.714 84.571 53.714 184 53.714 64 0 120-20.286t96-54.286 68.857-78.286 42.857-92.571 14-96.286q0-10.286-0.571-15.429 36-25.714 60-62.286zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"twitter-square"
					],
					"defaultCode": 61569,
					"grid": 14
				},
				{
					"id": 1323,
					"width": 950.8560180664062,
					"paths": [
						"M925.714 233.143q-38.286 56-92.571 95.429 0.571 8 0.571 24 0 74.286-21.714 148.286t-66 142-105.429 120.286-147.429 83.429-184.571 31.143q-154.857 0-283.429-82.857 20 2.286 44.571 2.286 128.571 0 229.143-78.857-60-1.143-107.429-36.857t-65.143-91.143q18.857 2.857 34.857 2.857 24.571 0 48.571-6.286-64-13.143-106-63.714t-42-117.429v-2.286q38.857 21.714 83.429 23.429-37.714-25.143-60-65.714t-22.286-88q0-50.286 25.143-93.143 69.143 85.143 168.286 136.286t212.286 56.857q-4.571-21.714-4.571-42.286 0-76.571 54-130.571t130.571-54q80 0 134.857 58.286 62.286-12 117.143-44.571-21.143 65.714-81.143 101.714 53.143-5.714 106.286-28.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"twitter"
					],
					"defaultCode": 61593,
					"grid": 14
				},
				{
					"id": 907,
					"width": 1024,
					"paths": [
						"M480 608c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM416 640c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM512 736c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM416 736c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM592 192h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16zM592 256h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16zM592 320h-160c-8.832 0-16 7.168-16 16s7.168 16 16 16h160c8.832 0 16-7.168 16-16s-7.168-16-16-16zM608 640c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM608 736c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM320 640c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM704 768h-384c-17.664 0-32 14.304-32 32s14.336 32 32 32h384c17.664 0 32-14.304 32-32s-14.336-32-32-32zM800 672c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM704 576c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM800 768c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM800 576c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM928 416v416c0 53.024-42.976 96-96 96h-640c-53.024 0-96-42.976-96-96v-416c0-53.024 42.976-96 96-96h64v-192c0-35.36 28.64-64 64-64h384c35.36 0 64 28.64 64 64v192h64c53.024 0 96 42.976 96 96zM288 448h448v-320c0-17.632-14.368-32-32-32h-384c-17.632 0-32 14.368-32 32v320zM896 416c0-35.36-28.64-64-64-64h-64v96h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-544c-8.832 0-16-7.168-16-16s7.168-16 16-16h16v-96h-64c-35.36 0-64 28.64-64 64v416c0 35.36 28.64 64 64 64h640c35.36 0 64-28.64 64-64v-416zM704 672c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM224 768c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM224 672c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM224 576c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM320 736c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"type",
						"write"
					],
					"grid": 32
				},
				{
					"id": 908,
					"width": 1024,
					"paths": [
						"M256 448h512v-320c0-35.36-28.64-64-64-64h-384c-35.36 0-64 28.64-64 64v320zM432 192h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16zM432 256h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16zM432 320h160c8.832 0 16 7.168 16 16s-7.168 16-16 16h-160c-8.832 0-16-7.168-16-16s7.168-16 16-16zM832 320h-32v128h16c8.832 0 16 7.168 16 16s-7.168 16-16 16h-608c-8.832 0-16-7.168-16-16s7.168-16 16-16h16v-128h-32c-53.024 0-96 42.976-96 96v416c0 53.024 42.976 96 96 96h640c53.024 0 96-42.976 96-96v-416c0-53.024-42.976-96-96-96zM608 576c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM608 672c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM512 576c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM512 672c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM416 576c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM416 672c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM320 576c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM320 672c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM224 832c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM224 736c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM224 640c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM704 832h-384c-17.664 0-32-14.304-32-32s14.336-32 32-32h384c17.664 0 32 14.304 32 32s-14.336 32-32 32zM704 736c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM704 640c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM800 832c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM800 736c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM800 640c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"type",
						"write"
					],
					"grid": 32
				},
				{
					"id": 1163,
					"width": 1024,
					"paths": [
						"M992 128h-960c-17.664 0-32 14.336-32 32v672c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-672c0-17.664-14.336-32-32-32zM960 192v128h-96v-128h96zM800 480h-128v-128h128v128zM640 480h-128v-128h128v128zM480 480h-128v-128h128v128zM320 480h-128v-128h128v128zM160 480h-96v-128h96v128zM224 512v128h-160v-128h160zM256 512h128v128h-128v-128zM416 512h128v128h-128v-128zM576 512h128v128h-128v-128zM736 512h224v128h-224v-128zM832 480v-128h128v128h-128zM832 192v128h-128v-128h128zM672 192v128h-128v-128h128zM512 192v128h-128v-128h128zM352 192v128h-128v-128h128zM192 192v128h-128v-128h128zM64 800v-128h128v128h-128zM224 800v-128h576v128h-576zM832 800v-128h128v128h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"type",
						"work",
						"write"
					],
					"grid": 32
				},
				{
					"id": 2183,
					"paths": [
						"M256 384v-320h402.746l109.254 109.254v210.746h64v-224c0-8.488-3.372-16.626-9.374-22.626l-128-128c-5.998-6.002-14.14-9.374-22.626-9.374h-448c-17.672 0-32 14.328-32 32v352h64z",
						"M1019.422 847.568l0.018-0.032-162.922-271.536h103.482v-128h-896v128h103.482l-162.902 271.57c-2.89 4.806-4.58 10.414-4.58 16.43v128c0 17.674 14.328 32 32 32h960c17.674 0 32-14.326 32-32v-128c0-6.016-1.69-11.624-4.578-16.432zM672 576h64c17.674 0 32 14.328 32 32s-14.326 32-32 32h-64c-17.674 0-32-14.328-32-32s14.326-32 32-32zM672 704h64c17.674 0 32 14.326 32 32s-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32s14.326-32 32-32zM480 576h64c17.674 0 32 14.328 32 32s-14.326 32-32 32h-64c-17.672 0-32-14.328-32-32s14.328-32 32-32zM480 704h64c17.674 0 32 14.326 32 32s-14.326 32-32 32h-64c-17.672 0-32-14.326-32-32s14.328-32 32-32zM288 576h64c17.672 0 32 14.328 32 32s-14.328 32-32 32h-64c-17.672 0-32-14.328-32-32s14.328-32 32-32zM288 704h64c17.672 0 32 14.326 32 32s-14.328 32-32 32h-64c-17.672 0-32-14.326-32-32s14.328-32 32-32zM864 896h-704c-17.672 0-32-14.326-32-32s14.328-32 32-32h704c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
						"M352 192h256c17.674 0 32-14.328 32-32s-14.326-32-32-32h-256c-17.672 0-32 14.328-32 32s14.328 32 32 32z",
						"M672 256h-320c-17.672 0-32 14.328-32 32s14.328 32 32 32h320c17.674 0 32-14.328 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"typewriter",
						"typing"
					],
					"defaultCode": 60018,
					"grid": 16
				},
				{
					"id": 3239,
					"paths": [
						"M64 0v320l128-192h256v832h-128l-64 64h512l-64-64h-128v-832h256l128 192v-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"typography",
						"wysiwyg"
					],
					"defaultCode": 61074,
					"grid": 16
				},
				{
					"id": 2794,
					"paths": [
						"M575.866 67.96c252.626 31.436 448.134 246.9 448.134 508.040h-17.164c-22.134-38.248-63.462-64-110.834-64-47.37 0-88.698 25.752-110.832 64h-34.336c-22.134-38.248-63.462-64-110.832-64-23.324 0-45.176 6.254-64 17.158v334.842c0 88.224-71.776 160-160 160s-160-71.776-160-160c0-35.346 28.654-64 64-64s64 28.654 64 64c0 17.644 14.356 32 32 32s32-14.356 32-32v-334.844c-18.826-10.902-40.676-17.156-64-17.156-47.372 0-88.7 25.752-110.834 64h-34.334c-22.136-38.248-63.464-64-110.834-64s-88.698 25.752-110.834 64h-17.166c0-261.14 195.508-476.604 448.134-508.040-0.080-1.31-0.134-2.628-0.134-3.96 0-35.346 28.654-64 64-64s64 28.654 64 64c0 1.332-0.054 2.65-0.134 3.96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"umbrella",
						"weather",
						"rainy"
					],
					"defaultCode": 60629,
					"grid": 16
				},
				{
					"id": 1386,
					"width": 950.8559665679932,
					"paths": [
						"M512 473.143v331.429q0 59.429-43.429 102.857t-102.857 43.429-102.857-43.429-43.429-102.857q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857 10.857 25.714q0 28.571 22.286 50.857t50.857 22.286 50.857-22.286 22.286-50.857v-331.429q18.857-6.286 36.571-6.286t36.571 6.286zM950.857 488.571q0 7.429-5.429 12.857t-12.857 5.429q-6.286 0-13.143-5.714-28-26.286-53.143-39.429t-58.286-13.143q-38.857 0-73.143 21.143t-58.857 55.429q-4 5.714-10 16t-8.286 13.714q-6.286 9.714-16 9.714-10.286 0-16.571-9.714-2.286-3.429-8.286-13.714t-10-16q-24.571-34.286-58.571-55.429t-72.857-21.143-72.857 21.143-58.571 55.429q-4 5.714-10 16t-8.286 13.714q-6.286 9.714-16.571 9.714-9.714 0-16-9.714-2.286-3.429-8.286-13.714t-10-16q-24.571-34.286-58.857-55.429t-73.143-21.143q-33.143 0-58.286 13.143t-53.143 39.429q-6.857 5.714-13.143 5.714-7.429 0-12.857-5.429t-5.429-12.857q0-2.857 0.571-4 25.714-104.571 98.571-182.571t170.286-116.857 206-38.857q80 0 156.857 22.857t140.857 64.857 111.143 106.857 66 143.714q0.571 1.143 0.571 4zM512 73.143v56q-24-1.143-36.571-1.143t-36.571 1.143v-56q0-14.857 10.857-25.714t25.714-10.857 25.714 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"umbrella"
					],
					"defaultCode": 61673,
					"grid": 14
				},
				{
					"id": 3245,
					"paths": [
						"M128 896h768v128h-768zM704 0h192v64h-64v448c0 176.73-143.27 320-320 320-176.732 0-320-143.27-320-320v-448h-64v-64h256v64h-64v448c0 105.87 100.486 200 224 200s224-94.13 224-200v-448h-64v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"underline",
						"wysiwyg"
					],
					"defaultCode": 61080,
					"grid": 16
				},
				{
					"id": 3251,
					"paths": [
						"M704 64h128v416c0 159.058-143.268 288-320 288-176.73 0-320-128.942-320-288v-416h128v416c0 40.166 18.238 78.704 51.354 108.506 36.896 33.204 86.846 51.494 140.646 51.494s103.75-18.29 140.646-51.494c33.116-29.802 51.354-68.34 51.354-108.506v-416zM192 832h640v128h-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"underline",
						"wysiwyg"
					],
					"defaultCode": 61086,
					"grid": 16
				},
				{
					"id": 1360,
					"width": 877.716025352478,
					"paths": [
						"M27.429 127.429q-21.143-1.143-25.714-2.286l-1.714-50.286q7.429-0.571 22.857-0.571 34.286 0 64 2.286 75.429 4 94.857 4 49.143 0 96-1.714 66.286-2.286 83.429-2.857 32 0 49.143-1.143l-0.571 8 1.143 36.571v5.143q-34.286 5.143-70.857 5.143-34.286 0-45.143 14.286-7.429 8-7.429 75.429 0 7.429 0.286 18.571t0.286 14.571l0.571 130.857 8 160q3.429 70.857 29.143 115.429 20 33.714 54.857 52.571 50.286 26.857 101.143 26.857 59.429 0 109.143-16 32-10.286 56.571-29.143 27.429-20.571 37.143-36.571 20.571-32 30.286-65.143 12-41.714 12-130.857 0-45.143-2-73.143t-6.286-70-7.714-91.143l-2.286-33.714q-2.857-38.286-13.714-50.286-19.429-20-44-19.429l-57.143 1.143-8-1.714 1.143-49.143h48l117.143 5.714q43.429 1.714 112-5.714l10.286 1.143q3.429 21.714 3.429 29.143 0 4-2.286 17.714-25.714 6.857-48 7.429-41.714 6.286-45.143 9.714-8.571 8.571-8.571 23.429 0 4 0.857 15.429t0.857 17.714q4.571 10.857 12.571 226.286 3.429 111.429-8.571 173.714-8.571 43.429-23.429 69.714-21.714 37.143-64 70.286-42.857 32.571-104 50.857-62.286 18.857-145.714 18.857-95.429 0-162.286-26.286-68-26.857-102.286-69.714-34.857-43.429-47.429-111.429-9.143-45.714-9.143-135.429v-190.286q0-107.429-9.714-121.714-14.286-20.571-84-22.286zM877.714 932.571v-36.571q0-8-5.143-13.143t-13.143-5.143h-841.143q-8 0-13.143 5.143t-5.143 13.143v36.571q0 8 5.143 13.143t13.143 5.143h841.143q8 0 13.143-5.143t5.143-13.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"underline"
					],
					"defaultCode": 61645,
					"grid": 14
				},
				{
					"id": 244,
					"paths": [
						"M742.4 921.6h-460.8c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h460.8c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M512 768c-141.158 0-256-114.84-256-256v-384c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v384c0 112.926 91.872 204.8 204.8 204.8 112.926 0 204.8-91.874 204.8-204.8v-384c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v384c0 141.16-114.84 256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"underline",
						"typography"
					],
					"defaultCode": 59541,
					"grid": 20
				},
				{
					"id": 2234,
					"paths": [
						"M512 64c-141.384 0-269.376 57.32-362.032 149.978l-149.968-149.978v384h384l-143.532-143.522c69.496-69.492 165.492-112.478 271.532-112.478 212.068 0 384 171.924 384 384 0 114.696-50.292 217.636-130.018 288l84.666 96c106.302-93.816 173.352-231.076 173.352-384 0-282.77-229.23-512-512-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"undo",
						"ccw",
						"arrow"
					],
					"defaultCode": 60069,
					"grid": 16
				},
				{
					"id": 2260,
					"paths": [
						"M761.862 1024c113.726-206.032 132.888-520.306-313.862-509.824v253.824l-384-384 384-384v248.372c534.962-13.942 594.57 472.214 313.862 775.628z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"undo",
						"left",
						"arrow-left"
					],
					"defaultCode": 60095,
					"grid": 16
				},
				{
					"id": 191,
					"paths": [
						"M896.533 229.867c-82.198-82.198-191.488-127.467-307.733-127.467s-225.534 45.269-307.733 127.467-127.467 191.486-127.467 307.733v66.197l-109.899-109.899c-9.997-9.997-26.206-9.997-36.203 0s-9.998 26.206 0 36.203l153.6 153.6c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.101-7.499l153.6-153.6c9.998-9.997 9.998-26.206 0-36.203s-26.206-9.997-36.203 0l-109.898 109.899v-66.197c0-211.738 172.262-384 384-384 211.739 0 384 172.262 384 384s-172.261 384-384 384c-14.139 0-25.6 11.461-25.6 25.6s11.461 25.6 25.6 25.6c116.245 0 225.534-45.269 307.733-127.467s127.467-191.488 127.467-307.733c0-116.246-45.269-225.534-127.467-307.733z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"undo",
						"ccw",
						"arrow"
					],
					"defaultCode": 59488,
					"grid": 20
				},
				{
					"id": 1164,
					"width": 1024,
					"paths": [
						"M512 0c-141.376 0-269.376 57.312-362.048 149.952l-95.328-95.328c-6.528-6.528-14.528-9.44-22.4-9.44-16.448 0-32.224 12.768-32.224 32.064v370.752c0 0 0 42.272 0 64 0 282.784 229.216 512 512 512s512-229.216 512-512-229.216-512-512-512zM512 960c-247.040 0-448-200.96-448-448v-63.296h70.176c-3.584 20.64-6.176 41.632-6.176 63.296 0 211.744 172.256 384 384 384s384-172.256 384-384-172.256-384-384-384c-129.952 0-244.8 65.024-314.336 164.096 0 0 22.88 22.496 22.912 22.464l102.144 102.144h-258.72v-262.208l85.952 85.952 45.28-45.248c84.608-84.608 197.088-131.2 316.768-131.2 247.040 0 448 200.96 448 448s-200.96 448-448 448zM372.672 421.376l-132.384-132.416c64.544-78.56 162.080-128.96 271.712-128.96 194.4 0 352 157.6 352 352s-157.6 352-352 352-352-157.6-352-352c0-21.664 2.272-43.456 6.112-64h195.264c14.24 0 21.376-16.544 11.296-26.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"undo",
						"reverse"
					],
					"grid": 32
				},
				{
					"id": 3219,
					"paths": [
						"M384 464c0 26.4-21.6 48-48 48h-96c-26.4 0-48-21.6-48-48v-96c0-26.4 21.6-48 48-48h96c26.4 0 48 21.6 48 48v96z",
						"M704 464c0 26.4-21.6 48-48 48h-96c-26.4 0-48-21.6-48-48v-96c0-26.4 21.6-48 48-48h96c26.4 0 48 21.6 48 48v96z",
						"M384 784c0 26.4-21.6 48-48 48h-96c-26.4 0-48-21.6-48-48v-96c0-26.4 21.6-48 48-48h96c26.4 0 48 21.6 48 48v96z",
						"M704 784c0 26.4-21.6 48-48 48h-96c-26.4 0-48-21.6-48-48v-96c0-26.4 21.6-48 48-48h96c26.4 0 48 21.6 48 48v96z",
						"M912.082 160l111.918-111.916v-48.084h-48.082l-111.918 111.916-111.918-111.916h-48.082v48.084l111.918 111.916-111.918 111.916v48.084h48.082l111.918-111.916 111.918 111.916h48.082v-48.084z",
						"M0 768h64v128h-64v-128z",
						"M0 576h64v128h-64v-128z",
						"M832 448h64v128h-64v-128z",
						"M832 832h64v128h-64v-128z",
						"M832 640h64v128h-64v-128z",
						"M0 384h64v128h-64v-128z",
						"M0 192h64v128h-64v-128z",
						"M512 128h128v64h-128v-64z",
						"M320 128h128v64h-128v-64z",
						"M128 128h128v64h-128v-64z",
						"M448 960h128v64h-128v-64z",
						"M640 960h128v64h-128v-64z",
						"M256 960h128v64h-128v-64z",
						"M64 960h128v64h-128v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"ungroup"
					],
					"defaultCode": 61054,
					"grid": 16
				},
				{
					"id": 0,
					"width": 256.4,
					"paths": [
						"M128 819.2c-14.138 0-25.6-11.461-25.6-25.6v-51.2c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v51.2c0 14.139-11.462 25.6-25.6 25.6z",
						"M128 614.4c-14.138 0-25.6-11.461-25.6-25.6v-409.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v409.6c0 14.139-11.462 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"exclam"
					],
					"defaultCode": 33,
					"grid": 20
				},
				{
					"id": 1,
					"width": 256,
					"paths": [
						"M76.8 307.2c-14.138 0-25.6-11.461-25.6-25.6v-153.6c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v153.6c0 14.139-11.461 25.6-25.6 25.6z",
						"M179.2 307.2c-14.138 0-25.6-11.461-25.6-25.6v-153.6c0-14.139 11.462-25.6 25.6-25.6 14.139 0 25.6 11.461 25.6 25.6v153.6c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"quote"
					],
					"defaultCode": 34,
					"grid": 20
				},
				{
					"id": 2,
					"width": 717,
					"paths": [
						"M640 307.2h-97.779l20.632-123.792c2.325-13.946-7.098-27.136-21.043-29.461-13.931-2.326-27.134 7.098-29.459 21.043l-22.037 132.21h-204.093l20.632-123.792c2.325-13.946-7.098-27.136-21.043-29.461-13.928-2.326-27.134 7.098-29.459 21.043l-22.037 132.21h-106.314c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h97.781l-42.667 256h-106.314c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h97.781l-20.632 123.792c-2.325 13.946 7.098 27.134 21.043 29.459 1.426 0.237 2.842 0.354 4.24 0.354 12.288 0 23.133-8.875 25.221-21.397l22.034-132.208h204.096l-20.634 123.792c-2.325 13.946 7.098 27.134 21.043 29.459 1.424 0.237 2.84 0.354 4.238 0.354 12.288 0 23.133-8.875 25.221-21.397l22.035-132.208h106.314c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-97.781l42.667-256h106.314c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6zM439.114 614.4h-204.094l42.667-256h204.094l-42.667 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"#"
					],
					"defaultCode": 35,
					"grid": 20
				},
				{
					"id": 3,
					"width": 563,
					"paths": [
						"M435.299 512.288c-41.55-24.238-95.406-37.702-147.49-50.723-115.363-28.842-185.41-51.899-185.41-128.765 0-17.578 3.72-51.198 28.629-78.874 29.338-32.598 79.997-49.126 150.571-49.126 117.798 0 189.96 46.48 190.6 46.901 11.763 7.842 27.656 4.664 35.501-7.101 7.843-11.763 4.664-27.658-7.101-35.501-3.176-2.118-74.501-48.76-193.4-54.842v-77.458c0-14.138-11.461-25.6-25.6-25.6-14.138 0-25.6 11.462-25.6 25.6v77.51c-72.832 4.078-127.606 26.006-163.029 65.363-36.344 40.384-41.771 88.211-41.771 113.126 0 55.056 25.806 98.024 76.701 127.712 41.55 24.238 95.406 37.702 147.491 50.723 115.362 28.842 185.408 51.899 185.408 128.765 0 17.578-3.718 51.198-28.629 78.875-29.338 32.597-79.997 49.125-150.571 49.125-117.274 0-189.315-46.067-190.661-46.941-11.757-7.792-27.61-4.605-35.44 7.141-7.842 11.765-4.664 27.658 7.101 35.501 3.178 2.118 74.501 48.762 193.4 54.843v77.456c0 14.139 11.462 25.6 25.6 25.6 14.139 0 25.6-11.461 25.6-25.6v-77.51c72.83-4.078 127.608-26.008 163.029-65.365 36.344-40.382 41.771-88.21 41.771-113.125 0-55.054-25.806-98.024-76.701-127.712z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"$"
					],
					"defaultCode": 36,
					"grid": 20
				},
				{
					"id": 4,
					"width": 717,
					"paths": [
						"M127.981 819.202c-5.346 0-10.734-1.667-15.341-5.122-11.31-8.483-13.603-24.528-5.12-35.838l460.8-614.4c8.482-11.31 24.53-13.605 35.838-5.12 11.31 8.483 13.603 24.53 5.12 35.84l-460.8 614.4c-5.027 6.704-12.715 10.24-20.498 10.24z",
						"M537.6 819.2c-55.090 0-92.939-19.834-112.498-58.952-15.502-31.005-15.502-67.789-15.502-94.648s0-63.643 15.502-94.648c19.558-39.118 57.408-58.952 112.498-58.952s92.939 19.834 112.499 58.952c15.502 31.005 15.502 67.789 15.502 94.648s0 63.643-15.502 94.648c-19.56 39.118-57.41 58.952-112.499 58.952zM537.6 563.2c-71.454 0-76.8 40.546-76.8 102.4s5.346 102.4 76.8 102.4c71.456 0 76.802-40.546 76.802-102.4s-5.346-102.4-76.802-102.4z",
						"M179.2 460.8c-55.090 0-92.939-19.834-112.498-58.952-15.502-31.005-15.502-67.789-15.502-94.648s0-63.643 15.502-94.648c19.558-39.118 57.408-58.952 112.498-58.952s92.939 19.834 112.499 58.95c15.502 31.005 15.502 67.79 15.502 94.65s0 63.643-15.502 94.65c-19.56 39.117-57.41 58.95-112.499 58.95zM179.2 204.8c-71.454 0-76.8 40.544-76.8 102.4s5.346 102.4 76.8 102.4c71.456 0 76.802-40.544 76.802-102.4s-5.346-102.4-76.802-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"#"
					],
					"defaultCode": 37,
					"grid": 20
				},
				{
					"id": 5,
					"width": 563,
					"paths": [
						"M486.4 768h-37.091l-16.208-25.662c15.49-26.245 24.358-59.584 26.898-100.762l0.048-0.787v-154.389c0-14.138-11.461-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v152.797c-1.264 19.765-4.070 36.728-8.533 51.227l-246.627-390.494c0.787-32.454 6.992-54.45 19.352-68.869 15.144-17.67 42.282-26.261 82.962-26.261 36.237 0 62.491 7.131 78.032 21.194 13.37 12.099 20.798 30.53 23.373 57.997 1.318 14.077 13.814 24.41 27.877 23.099 14.077-1.32 24.419-13.8 23.099-27.878-7.925-84.523-57.768-125.611-152.381-125.611-56.525 0-96.378 14.438-121.837 44.139-21.67 25.283-31.763 60.064-31.763 109.461 0 4.838 1.371 9.579 3.957 13.67l62.614 99.139c-35.323 10.099-62.125 27.704-81.344 53.299-24.512 32.646-36.427 78.795-36.427 141.091 0 72.73 15.602 122.205 49.099 155.701s82.971 49.099 155.701 49.099c63.443 0 108.786-11.77 141.766-36.933l15.79 25.003c4.688 7.427 12.859 11.93 21.643 11.93h51.2c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6zM256 768c-58.261 0-96.234-10.835-119.499-34.101s-34.101-61.238-34.101-119.499c0-50.8 8.562-86.896 26.17-110.347 14.792-19.699 37.034-32.062 69.259-38.35l172.424 273.005c-23.334 19.707-60.712 29.293-114.253 29.293z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"&"
					],
					"defaultCode": 38,
					"grid": 20
				},
				{
					"id": 6,
					"width": 154,
					"paths": [
						"M76.8 307.2c-14.138 0-25.6-11.461-25.6-25.6v-153.6c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v153.6c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"apostrophe"
					],
					"defaultCode": 39,
					"grid": 20
				},
				{
					"id": 7,
					"width": 307.20000000000005,
					"paths": [
						"M230.411 972.8c-7.214 0-14.386-3.034-19.448-8.939-1.653-1.928-40.904-48.099-80.261-126.813-36.269-72.538-79.502-187.813-79.502-325.048 0-137.237 43.234-252.51 79.502-325.048 39.357-78.714 78.608-124.885 80.261-126.811 9.202-10.734 25.365-11.978 36.098-2.776 10.734 9.2 11.978 25.363 2.776 36.098-0.352 0.413-37.488 44.294-74.059 117.83-33.474 67.309-73.378 174.12-73.378 300.707 0 243.71 145.963 416.821 147.437 418.539 9.202 10.736 7.958 26.898-2.776 36.099-4.827 4.136-10.754 6.162-16.65 6.162z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"("
					],
					"defaultCode": 40,
					"grid": 20
				},
				{
					"id": 8,
					"width": 307.20000000000005,
					"paths": [
						"M76.789 972.8c7.214 0 14.386-3.034 19.448-8.939 1.653-1.928 40.904-48.099 80.261-126.813 36.269-72.538 79.502-187.813 79.502-325.048 0-137.237-43.234-252.51-79.502-325.048-39.357-78.714-78.608-124.885-80.261-126.811-9.202-10.734-25.365-11.978-36.098-2.776-10.734 9.2-11.978 25.363-2.776 36.098 0.352 0.413 37.488 44.294 74.059 117.83 33.474 67.309 73.378 174.12 73.378 300.707 0 243.71-145.963 416.821-147.437 418.539-9.202 10.736-7.958 26.898 2.776 36.099 4.827 4.136 10.754 6.162 16.65 6.162z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						")"
					],
					"defaultCode": 41,
					"grid": 20
				},
				{
					"id": 9,
					"width": 461,
					"paths": [
						"M398.2 260.299l-121.648-81.099 121.648-81.099c11.765-7.843 14.944-23.738 7.101-35.501-7.843-11.765-23.738-14.944-35.501-7.101l-113.8 75.867v-105.766c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v105.766l-113.8-75.867c-11.765-7.84-27.658-4.664-35.501 7.101-7.842 11.763-4.664 27.658 7.101 35.501l121.648 81.099-121.648 81.099c-11.765 7.843-14.942 23.738-7.101 35.501 4.933 7.4 13.051 11.402 21.325 11.402 4.878 0 9.813-1.392 14.176-4.301l113.8-75.867v105.766c0 14.138 11.462 25.6 25.6 25.6s25.6-11.462 25.6-25.6v-105.766l113.8 75.867c4.365 2.909 9.298 4.301 14.176 4.301 8.272 0 16.39-4.003 21.323-11.402 7.845-11.763 4.666-27.658-7.099-35.501z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"*"
					],
					"defaultCode": 42,
					"grid": 20
				},
				{
					"id": 10,
					"width": 563.1999999999996,
					"paths": [
						"M486.4 512h-179.2v-179.2c0-14.138-11.461-25.6-25.6-25.6-14.138 0-25.6 11.462-25.6 25.6v179.2h-179.2c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h179.2v179.2c0 14.139 11.462 25.6 25.6 25.6 14.139 0 25.6-11.461 25.6-25.6v-179.2h179.2c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"+"
					],
					"defaultCode": 43,
					"grid": 20
				},
				{
					"id": 11,
					"width": 205,
					"paths": [
						"M153.6 742.4c0-14.139-11.461-25.6-25.6-25.6h-51.2c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h24.408c-6.859 72.272-41.037 108.376-42.648 110.037l0.13-0.13c-4.627 4.634-7.49 11.029-7.49 18.093 0 14.139 11.462 25.6 25.6 25.6 7.075 0 13.478-2.87 18.112-7.509 2.494-2.498 58.688-60.074 58.688-171.691z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"comma"
					],
					"defaultCode": 44,
					"grid": 20
				},
				{
					"id": 12,
					"width": 358,
					"paths": [
						"M307.2 588.8c0 14.138-11.461 25.6-25.6 25.6h-204.8c-14.139 0-25.6-11.462-25.6-25.6s11.461-25.6 25.6-25.6h204.8c14.139 0 25.6 11.461 25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dash"
					],
					"defaultCode": 45,
					"grid": 20
				},
				{
					"id": 13,
					"width": 154,
					"paths": [
						"M76.8 819.2c-14.138 0-25.6-11.461-25.6-25.6v-51.2c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v51.2c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"dot"
					],
					"defaultCode": 46,
					"grid": 20
				},
				{
					"id": 14,
					"width": 410,
					"paths": [
						"M76.803 921.606c-2.685 0-5.413-0.426-8.099-1.32-13.413-4.47-20.662-18.968-16.19-32.381l256-768c4.469-13.413 18.965-20.664 32.381-16.19 13.413 4.47 20.662 18.968 16.19 32.381l-256 768c-3.574 10.726-13.563 17.51-24.282 17.51z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"slash"
					],
					"defaultCode": 47,
					"grid": 20
				},
				{
					"id": 15,
					"width": 563.1999999999996,
					"paths": [
						"M281.6 819.2c-84.912 0-144.349-29.058-181.709-88.832-33.219-53.15-48.691-130.672-48.691-243.968 0-113.294 15.472-190.818 48.691-243.968 37.36-59.774 96.797-88.832 181.709-88.832s144.35 29.058 181.709 88.832c33.219 53.15 48.691 130.674 48.691 243.968 0 113.296-15.472 190.818-48.691 243.968-37.358 59.774-96.797 88.832-181.709 88.832zM281.6 204.8c-66.731 0-110.674 20.581-138.291 64.768-27.528 44.043-40.909 114.97-40.909 216.832s13.381 172.787 40.909 216.832c27.618 44.187 71.56 64.768 138.291 64.768s110.674-20.581 138.291-64.768c27.528-44.045 40.909-114.97 40.909-216.832s-13.381-172.789-40.909-216.832c-27.618-44.187-71.56-64.768-138.291-64.768z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 48,
					"grid": 20
				},
				{
					"id": 16,
					"width": 255.99999999999966,
					"paths": [
						"M179.2 819.2c-14.139 0-25.6-11.461-25.6-25.6v-552.597l-58.698 58.699c-9.998 9.997-26.206 9.997-36.205 0-9.997-9.998-9.997-26.206 0-36.205l102.4-102.4c7.32-7.32 18.331-9.512 27.899-5.549 9.566 3.962 15.803 13.298 15.803 23.651v614.4c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 49,
					"grid": 20
				},
				{
					"id": 17,
					"width": 563.1999999999996,
					"paths": [
						"M486.4 819.2h-409.6c-14.138 0-25.6-11.461-25.6-25.6 0-92.686 26.022-161.15 79.552-209.304 46.221-41.578 104.634-61.328 161.125-80.429 46.35-15.67 90.13-30.474 121.131-55.778 20.515-16.746 47.792-46.917 47.792-115.29 0-45.749-11.182-76.002-35.192-95.21-27.581-22.064-74.686-32.79-144.008-32.79s-116.427 10.726-144.008 32.79c-24.010 19.208-35.192 49.461-35.192 95.21 0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6c0-123.933 71.058-179.2 230.4-179.2s230.4 55.267 230.4 179.2c0 67.68-21.79 118.366-66.618 154.955-38.189 31.17-88.477 48.171-137.106 64.616-51.576 17.437-104.907 35.469-143.282 69.989-37.894 34.088-57.824 80.771-61.834 145.64h383.238c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 50,
					"grid": 20
				},
				{
					"id": 18,
					"width": 563.1999999999996,
					"paths": [
						"M427.883 486.4c57.394-27.448 84.117-77.614 84.117-153.6 0-123.933-71.058-179.2-230.4-179.2-76.179 0-131.2 12.499-168.21 38.208-28.338 19.686-47.166 47.843-55.965 83.69-3.37 13.731 5.030 27.595 18.762 30.965 13.733 3.37 27.595-5.030 30.965-18.762 5.898-24.029 17.162-41.138 35.45-53.843 28.146-19.554 73.613-29.058 138.998-29.058 69.322 0 116.427 10.726 144.008 32.79 15.107 12.086 35.192 35.106 35.192 95.21s-20.085 83.123-35.192 95.21c-27.581 22.064-74.686 32.79-144.008 32.79h-51.2c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h51.2c69.322 0 116.427 10.726 144.008 32.79 15.107 12.086 35.192 35.106 35.192 95.21s-20.085 83.123-35.192 95.21c-27.581 22.064-74.686 32.79-144.008 32.79-135.795 0-164.387-41.904-174.446-82.896-3.37-13.731-17.23-22.133-30.965-18.762-13.731 3.37-22.131 17.234-18.762 30.965 10.322 42.056 34.458 73.443 71.741 93.291 36.154 19.246 86.014 28.602 152.432 28.602 159.342 0 230.4-55.267 230.4-179.2 0-75.986-26.723-126.152-84.117-153.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 51,
					"grid": 20
				},
				{
					"id": 19,
					"width": 614.3999999999996,
					"paths": [
						"M435.2 819.2c-14.139 0-25.6-11.461-25.6-25.6v-128h-332.8c-9.778 0-18.701-5.568-22.997-14.354-4.296-8.782-3.213-19.245 2.79-26.965l358.4-460.8c6.715-8.634 18.171-12.048 28.515-8.498s17.291 13.28 17.291 24.216v435.2h76.8c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6h-76.8v128c0 14.139-11.461 25.6-25.6 25.6zM129.142 614.4h280.458v-360.587l-280.458 360.587z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 52,
					"grid": 20
				},
				{
					"id": 20,
					"width": 563.1999999999996,
					"paths": [
						"M281.6 819.2c-123.254 0-192.77-37.675-218.771-118.566-4.326-13.461 3.077-27.88 16.538-32.206 13.461-4.331 27.878 3.078 32.206 16.538 9.077 28.242 24.894 47.574 49.774 60.845 27.995 14.933 67.33 22.19 120.253 22.19 68.574 0 115.197-12.402 142.533-37.915 25.016-23.349 36.667-60.109 36.667-115.685s-11.651-92.338-36.667-115.685c-27.336-25.514-73.958-37.915-142.533-37.915h-153.6c-7.234 0-14.128-3.059-18.981-8.422s-7.211-12.53-6.491-19.726l25.6-256c1.307-13.085 12.32-23.051 25.472-23.051h332.8c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6h-309.632l-20.48 204.8h125.312c159.342 0 230.4 63.163 230.4 204.8s-71.058 204.8-230.4 204.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 53,
					"grid": 20
				},
				{
					"id": 21,
					"width": 563.1999999999996,
					"paths": [
						"M281.6 409.6c-82.733 0-141.656 17.037-179.2 53.235v-104.435c0-55.576 11.651-92.336 36.667-115.685 27.336-25.514 73.958-37.915 142.533-37.915 53.307 0 92.843 7.366 120.867 22.518 24.904 13.467 40.662 33.128 49.587 61.87 4.192 13.501 18.531 21.051 32.040 16.858 13.501-4.194 21.048-18.538 16.856-32.040-25.507-82.146-95.206-120.406-219.35-120.406-159.342 0-230.4 63.163-230.4 204.8v256c0 141.637 71.058 204.8 230.4 204.8s230.4-63.163 230.4-204.8-71.058-204.8-230.4-204.8zM424.133 730.085c-27.336 25.514-73.958 37.915-142.533 37.915s-115.197-12.402-142.533-37.915c-25.016-23.349-36.667-60.109-36.667-115.685s11.651-92.338 36.667-115.685c27.334-25.514 73.958-37.915 142.533-37.915s115.197 12.402 142.533 37.915c25.016 23.347 36.667 60.109 36.667 115.685s-11.651 92.336-36.667 115.685z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 54,
					"grid": 20
				},
				{
					"id": 22,
					"width": 563.1999999999996,
					"paths": [
						"M179.181 819.206c-3.848 0-7.754-0.872-11.429-2.709-12.646-6.322-17.771-21.699-11.45-34.346l288.675-577.352h-368.178c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h409.6c8.872 0 17.112 4.594 21.776 12.141s5.090 16.971 1.12 24.907l-307.2 614.4c-4.483 8.971-13.526 14.157-22.915 14.158z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 55,
					"grid": 20
				},
				{
					"id": 23,
					"width": 563.1999999999996,
					"paths": [
						"M427.883 486.4c57.394-27.448 84.117-77.614 84.117-153.6 0-123.933-71.058-179.2-230.4-179.2s-230.4 55.267-230.4 179.2c0 75.986 26.723 126.152 84.117 153.6-57.394 27.448-84.117 77.614-84.117 153.6 0 123.933 71.058 179.2 230.4 179.2s230.4-55.267 230.4-179.2c0-75.986-26.723-126.152-84.117-153.6zM137.592 428.010c-15.107-12.086-35.192-35.106-35.192-95.21s20.085-83.123 35.192-95.21c27.581-22.064 74.686-32.79 144.008-32.79s116.427 10.726 144.008 32.79c15.107 12.086 35.192 35.106 35.192 95.21s-20.085 83.123-35.192 95.21c-27.581 22.064-74.686 32.79-144.008 32.79s-116.427-10.726-144.008-32.79zM425.608 735.21c-27.581 22.064-74.686 32.79-144.008 32.79s-116.427-10.726-144.008-32.79c-15.107-12.086-35.192-35.106-35.192-95.21s20.085-83.123 35.192-95.21c27.581-22.064 74.686-32.79 144.008-32.79s116.427 10.726 144.008 32.79c15.107 12.086 35.192 35.106 35.192 95.21s-20.085 83.123-35.192 95.21z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 56,
					"grid": 20
				},
				{
					"id": 24,
					"width": 563.1999999999996,
					"paths": [
						"M281.6 153.6c-159.342 0-230.4 63.163-230.4 204.8s71.058 204.8 230.4 204.8c82.733 0 141.656-17.037 179.2-53.235v104.435c0 55.576-11.651 92.336-36.667 115.685-27.336 25.514-73.958 37.915-142.533 37.915-53.307 0-92.843-7.366-120.867-22.518-24.904-13.467-40.662-33.126-49.589-61.872-4.194-13.501-18.538-21.045-32.040-16.856-13.502 4.194-21.050 18.538-16.856 32.040 25.509 82.147 95.21 120.406 219.352 120.406 159.342 0 230.4-63.163 230.4-204.8v-256c0-141.637-71.058-204.8-230.4-204.8zM424.133 474.085c-27.336 25.514-73.958 37.915-142.533 37.915s-115.198-12.402-142.533-37.915c-25.016-23.349-36.667-60.107-36.667-115.685s11.651-92.336 36.667-115.685c27.334-25.514 73.958-37.915 142.533-37.915s115.197 12.402 142.533 37.915c25.016 23.349 36.667 60.107 36.667 115.685s-11.651 92.336-36.667 115.685z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"svg"
					],
					"defaultCode": 57,
					"grid": 20
				},
				{
					"id": 25,
					"width": 205.2,
					"paths": [
						"M76.8 460.8c-14.138 0-25.6-11.461-25.6-25.6v-51.2c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v51.2c0 14.139-11.461 25.6-25.6 25.6z",
						"M76.8 819.2c-14.138 0-25.6-11.461-25.6-25.6v-51.2c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v51.2c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"colon"
					],
					"defaultCode": 58,
					"grid": 20
				},
				{
					"id": 26,
					"width": 205,
					"paths": [
						"M153.6 742.4c0-14.139-11.461-25.6-25.6-25.6h-51.2c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h24.408c-6.859 72.272-41.037 108.376-42.648 110.037l0.13-0.13c-4.627 4.634-7.49 11.029-7.49 18.093 0 14.139 11.462 25.6 25.6 25.6 7.075 0 13.478-2.87 18.112-7.509 2.494-2.498 58.688-60.074 58.688-171.691z",
						"M128 460.8c-14.138 0-25.6-11.461-25.6-25.6v-51.2c0-14.139 11.462-25.6 25.6-25.6 14.139 0 25.6 11.461 25.6 25.6v51.2c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"semi-colon"
					],
					"defaultCode": 59,
					"grid": 20
				},
				{
					"id": 27,
					"width": 563.1999999999996,
					"paths": [
						"M486.379 768.006c-3.846 0-7.754-0.872-11.429-2.709l-409.6-204.8c-8.672-4.336-14.15-13.2-14.15-22.898s5.478-18.562 14.152-22.898l409.6-204.8c12.65-6.32 28.026-1.195 34.346 11.45 6.323 12.645 1.197 28.022-11.448 34.346l-363.806 181.902 363.805 181.902c12.645 6.322 17.771 21.699 11.448 34.346-4.483 8.971-13.526 14.157-22.917 14.158z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"<"
					],
					"defaultCode": 60,
					"grid": 20
				},
				{
					"id": 28,
					"width": 563.1999999999996,
					"paths": [
						"M486.4 665.6h-409.6c-14.138 0-25.6-11.461-25.6-25.6s11.462-25.6 25.6-25.6h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M486.4 460.8h-409.6c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h409.6c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"="
					],
					"defaultCode": 61,
					"grid": 20
				},
				{
					"id": 29,
					"width": 563.1999999999996,
					"paths": [
						"M76.821 768.006c-9.392 0-18.432-5.186-22.918-14.158-6.323-12.645-1.197-28.024 11.45-34.346l363.805-181.902-363.805-181.902c-12.646-6.323-17.771-21.701-11.45-34.346 6.323-12.645 21.701-17.773 34.346-11.45l409.6 204.8c8.674 4.336 14.152 13.2 14.152 22.898s-5.478 18.562-14.152 22.898l-409.6 204.8c-3.674 1.837-7.581 2.707-11.427 2.709z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						">"
					],
					"defaultCode": 62,
					"grid": 20
				},
				{
					"id": 30,
					"width": 512,
					"paths": [
						"M230.4 665.6c-14.138 0-25.6-11.461-25.6-25.6v-102.4c0-14.139 11.462-25.6 25.6-25.6h25.6c58.261 0 96.234-10.835 119.499-34.101s34.101-61.238 34.101-119.499-10.835-96.232-34.101-119.499c-23.266-23.266-61.238-34.101-119.499-34.101-53.882 0-91.402 9.702-114.704 29.664-23.070 19.763-35.206 51.51-38.194 99.912-0.87 14.112-13.006 24.827-27.128 23.974-14.112-0.87-24.845-13.016-23.974-27.128 3.843-62.294 22.157-106.664 55.989-135.643 33.434-28.64 80.466-41.979 148.011-41.979 72.73 0 122.205 15.602 155.701 49.099 33.498 33.496 49.099 82.971 49.099 155.701s-15.602 122.205-49.099 155.701c-33.496 33.498-82.971 49.099-155.701 49.099v76.8c0 14.139-11.462 25.6-25.6 25.6z",
						"M230.4 819.2c-14.138 0-25.6-11.461-25.6-25.6v-51.2c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v51.2c0 14.139-11.462 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"?"
					],
					"defaultCode": 63,
					"grid": 20
				},
				{
					"id": 31,
					"width": 870,
					"paths": [
						"M718.901 305.099c-66.552-66.554-162.002-100.299-283.701-100.299s-217.149 33.746-283.701 100.299c-66.554 66.552-100.299 162.003-100.299 283.701s33.746 217.149 100.299 283.701c66.552 66.554 162.003 100.299 283.701 100.299 115.237 0 207.158-30.381 273.205-90.299 10.472-9.501 11.259-25.691 1.762-36.163-9.501-10.472-25.693-11.259-36.162-1.76-56.336 51.11-136.682 77.022-238.805 77.022-107.626 0-190.896-28.701-247.499-85.301-56.6-56.603-85.301-139.874-85.301-247.499s28.701-190.896 85.301-247.499c56.603-56.6 139.874-85.301 247.499-85.301s190.896 28.701 247.499 85.301c56.6 56.603 85.301 139.874 85.301 247.499v51.2c0 42.349-34.451 76.8-76.8 76.8s-76.8-34.451-76.8-76.8v-204.8c0-14.138-11.461-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v21.456c-31.742-30.821-75.79-47.056-128-47.056-55.602 0-101.949 18.411-134.030 53.245-29.55 32.086-45.17 75.64-45.17 125.955s15.619 93.869 45.17 125.955c32.082 34.832 78.429 53.245 134.030 53.245s101.949-18.413 134.032-53.245c3.635-3.947 7.058-8.070 10.267-12.355 21.931 39.101 63.768 65.6 111.701 65.6 70.579 0 128-57.421 128-128v-51.2c0-121.698-33.746-217.149-100.299-283.701zM435.2 716.8c-40.914 0-74.238-12.701-96.37-36.731-20.693-22.467-31.63-54.029-31.63-91.269s10.938-68.802 31.63-91.269c22.131-24.030 55.456-36.731 96.37-36.731s74.238 12.701 96.368 36.731c20.694 22.467 31.632 54.029 31.632 91.269s-10.938 68.802-31.632 91.269c-22.13 24.030-55.454 36.731-96.368 36.731z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"@"
					],
					"defaultCode": 64,
					"grid": 20
				},
				{
					"id": 32,
					"width": 666,
					"paths": [
						"M612.432 783.754l-256-614.4c-3.976-9.539-13.298-15.754-23.632-15.754s-19.656 6.214-23.632 15.754l-256 614.4c-5.438 13.051 0.733 28.038 13.784 33.478 13.050 5.437 28.040-0.734 33.477-13.784l78.771-189.048h307.2l78.768 189.046c4.098 9.832 13.616 15.76 23.642 15.76 3.282 0 6.618-0.634 9.835-1.974 13.053-5.44 19.224-20.427 13.787-33.478zM200.533 563.2l132.267-317.44 132.266 317.44h-264.533z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"A"
					],
					"defaultCode": 65,
					"grid": 20
				},
				{
					"id": 33,
					"width": 614,
					"paths": [
						"M307.2 819.2h-230.4c-14.138 0-25.6-11.461-25.6-25.6v-614.4c0-14.138 11.462-25.6 25.6-25.6h204.8c159.342 0 230.4 55.267 230.4 179.2 0 66.309-20.336 112.957-63.656 142.003 17.131 4.762 31.755 10.816 44.555 18.283 47.306 27.597 70.301 75.651 70.301 146.914s-22.995 119.317-70.301 146.912c-38.797 22.632-94.333 32.288-185.699 32.288zM102.4 768h204.8c81.664 0 129.485-7.57 159.901-25.312 20.904-12.194 44.899-34.886 44.899-102.688s-23.995-90.494-44.899-102.688c-30.416-17.742-78.237-25.312-159.901-25.312v-0.507c-8.266 0.339-16.798 0.507-25.6 0.507h-179.2v256zM102.4 460.8h179.2c69.322 0 116.427-10.726 144.008-32.79 24.010-19.208 35.192-49.461 35.192-95.21s-11.182-76.002-35.192-95.21c-27.581-22.064-74.686-32.79-144.008-32.79h-179.2v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"B"
					],
					"defaultCode": 66,
					"grid": 20
				},
				{
					"id": 34,
					"width": 666,
					"paths": [
						"M384 819.2c-108.958 0-192.566-28.363-248.502-84.299-55.936-55.934-84.298-139.542-84.298-248.501s28.362-192.566 84.298-248.502c55.936-55.936 139.544-84.298 248.502-84.298 91.707 0 165.701 20.126 219.923 59.821 11.408 8.352 13.886 24.37 5.534 35.778s-24.368 13.886-35.778 5.534c-45.261-33.133-109.078-49.933-189.68-49.933-94.886 0-166.312 23.317-212.298 69.302s-69.302 117.413-69.302 212.298c0 94.886 23.317 166.312 69.302 212.299 45.986 45.984 117.411 69.301 212.298 69.301 80.602 0 144.419-16.8 189.68-49.933 11.408-8.352 27.429-5.874 35.778 5.534 8.352 11.408 5.874 27.427-5.534 35.778-54.222 39.694-128.216 59.821-219.923 59.821z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"C"
					],
					"defaultCode": 67,
					"grid": 20
				},
				{
					"id": 35,
					"width": 666,
					"paths": [
						"M281.6 819.2h-204.8c-14.138 0-25.6-11.461-25.6-25.6v-614.4c0-14.138 11.462-25.6 25.6-25.6h204.8c108.958 0 192.566 28.362 248.501 84.298 55.936 55.936 84.299 139.544 84.299 248.502s-28.363 192.566-84.299 248.501-139.542 84.299-248.501 84.299zM102.4 768h179.2c94.886 0 166.312-23.317 212.299-69.301 45.984-45.987 69.301-117.413 69.301-212.299s-23.317-166.312-69.301-212.298c-45.987-45.986-117.413-69.302-212.299-69.302h-179.2v563.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"D"
					],
					"defaultCode": 68,
					"grid": 20
				},
				{
					"id": 36,
					"width": 614,
					"paths": [
						"M537.6 768h-435.2v-256h384c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6h-384v-256h435.2c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6h-460.8c-14.138 0-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6h460.8c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"E"
					],
					"defaultCode": 69,
					"grid": 20
				},
				{
					"id": 37,
					"width": 614,
					"paths": [
						"M537.6 153.6h-460.8c-14.138 0-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-281.6h384c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6h-384v-256h435.2c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"F"
					],
					"defaultCode": 70,
					"grid": 20
				},
				{
					"id": 38,
					"width": 666,
					"paths": [
						"M384 819.2c-108.958 0-192.566-28.363-248.501-84.299-55.938-55.934-84.299-139.542-84.299-248.501s28.362-192.566 84.299-248.502c55.934-55.936 139.542-84.298 248.501-84.298 91.706 0 165.699 20.126 219.923 59.819 11.408 8.352 13.886 24.37 5.534 35.779s-24.37 13.885-35.778 5.534c-45.261-33.133-109.080-49.933-189.68-49.933-94.885 0-166.312 23.317-212.299 69.302-45.984 45.986-69.301 117.413-69.301 212.298s23.317 166.312 69.301 212.299c45.987 45.984 117.414 69.301 212.299 69.301 74.566 0 134.768-14.379 179.202-42.766l-0.002-213.234h-76.8c-14.139 0-25.6-11.462-25.6-25.6s11.461-25.6 25.6-25.6h102.4c14.139 0 25.6 11.462 25.6 25.6l0.002 252.323c0 8.163-3.893 15.834-10.478 20.656-54.222 39.694-128.216 59.821-219.923 59.821z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"G"
					],
					"defaultCode": 71,
					"grid": 20
				},
				{
					"id": 39,
					"width": 614,
					"paths": [
						"M537.6 153.6c-14.139 0-25.6 11.462-25.6 25.6v281.6h-409.6v-281.6c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-281.6h409.6v281.6c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-614.4c0-14.138-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"H"
					],
					"defaultCode": 72,
					"grid": 20
				},
				{
					"id": 40,
					"width": 154,
					"paths": [
						"M76.8 819.2c-14.138 0-25.6-11.461-25.6-25.6v-614.4c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v614.4c0 14.139-11.462 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"I"
					],
					"defaultCode": 73,
					"grid": 20
				},
				{
					"id": 41,
					"width": 563,
					"paths": [
						"M256 819.2c-89.2 0-149.486-18.634-189.725-58.643-10.026-9.968-10.072-26.176-0.104-36.203s26.178-10.075 36.203-0.102c30.021 29.848 78.835 43.749 153.626 43.749 115.056 0 151.445-34.613 170.291-64.768 28.64-45.824 34.509-119.822 34.509-216.832v-307.2c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v307.2c0 108.843-7.075 187.622-42.291 243.968-37.877 60.605-105.786 88.832-213.709 88.832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"J"
					],
					"defaultCode": 74,
					"grid": 20
				},
				{
					"id": 42,
					"width": 563,
					"paths": [
						"M502.392 773.61l-359.013-287.21 359.013-287.21c11.040-8.834 12.83-24.942 3.998-35.982-8.834-11.042-24.942-12.826-35.982-3.998l-368.008 294.406v-274.416c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-274.416l368.008 294.406c4.72 3.776 10.366 5.611 15.976 5.611 7.509 0 14.95-3.29 20.006-9.61 8.832-11.040 7.043-27.15-3.998-35.982z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"K"
					],
					"defaultCode": 75,
					"grid": 20
				},
				{
					"id": 43,
					"width": 614,
					"paths": [
						"M537.6 819.2h-460.8c-14.138 0-25.6-11.461-25.6-25.6v-614.4c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v588.8h435.2c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"L"
					],
					"defaultCode": 76,
					"grid": 20
				},
				{
					"id": 44,
					"width": 870,
					"paths": [
						"M793.568 819.205c-12.288 0-23.133-8.874-25.221-21.395l-87.763-526.576-221.752 532.211c-3.976 9.541-13.298 15.755-23.632 15.755s-19.656-6.214-23.632-15.755l-221.754-532.211-87.763 526.576c-2.323 13.946-15.502 23.366-29.461 21.042-13.946-2.323-23.366-15.514-21.043-29.461l102.4-614.4c1.877-11.259 10.979-19.915 22.318-21.222 11.338-1.306 22.173 5.050 26.563 15.586l232.371 557.686 232.368-557.686c4.39-10.538 15.229-16.896 26.565-15.586 11.339 1.307 20.442 9.965 22.318 21.222l102.4 614.4c2.325 13.947-7.098 27.138-21.042 29.461-1.426 0.238-2.843 0.352-4.242 0.354z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"M"
					],
					"defaultCode": 77,
					"grid": 20
				},
				{
					"id": 45,
					"width": 614,
					"paths": [
						"M537.603 819.202c-7.904 0-15.555-3.67-20.483-10.242l-414.72-552.96v537.6c0 14.139-11.462 25.6-25.6 25.6s-25.6-11.461-25.6-25.6v-614.4c0-11.019 7.051-20.802 17.504-24.286 10.453-3.486 21.965 0.11 28.574 8.926l414.722 552.96v-537.6c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v614.4c0 11.019-7.051 20.802-17.504 24.286-2.662 0.886-5.394 1.315-8.093 1.315z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"N"
					],
					"defaultCode": 78,
					"grid": 20
				},
				{
					"id": 46,
					"width": 717,
					"paths": [
						"M358.4 819.2c-97.602 0-173.867-28.562-226.677-84.891-53.43-56.994-80.523-140.403-80.523-247.909s27.093-190.915 80.523-247.909c52.81-56.33 129.075-84.891 226.677-84.891s173.867 28.562 226.677 84.891c53.43 56.994 80.523 140.403 80.523 247.909s-27.093 190.915-80.523 247.909c-52.81 56.33-129.075 84.891-226.677 84.891zM358.4 204.8c-82.885 0-146.581 23.117-189.323 68.709-44.243 47.192-66.677 118.819-66.677 212.891s22.434 165.699 66.677 212.891c42.742 45.592 106.438 68.709 189.323 68.709s146.581-23.117 189.323-68.709c44.243-47.192 66.677-118.819 66.677-212.891s-22.434-165.699-66.677-212.891c-42.742-45.592-106.438-68.709-189.323-68.709z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"O"
					],
					"defaultCode": 79,
					"grid": 20
				},
				{
					"id": 47,
					"width": 563,
					"paths": [
						"M76.8 819.2c-14.138 0-25.6-11.461-25.6-25.6v-614.4c0-14.138 11.462-25.6 25.6-25.6h204.8c159.342 0 230.4 55.267 230.4 179.2s-71.058 179.2-230.4 179.2h-179.2v281.6c0 14.139-11.462 25.6-25.6 25.6zM102.4 460.8h179.2c69.322 0 116.427-10.726 144.008-32.79 24.010-19.208 35.192-49.461 35.192-95.21s-11.182-76.002-35.192-95.21c-27.581-22.064-74.686-32.79-144.008-32.79h-179.2v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"P"
					],
					"defaultCode": 80,
					"grid": 20
				},
				{
					"id": 48,
					"width": 717,
					"paths": [
						"M585.077 238.491c-52.81-56.33-129.075-84.891-226.677-84.891s-173.867 28.562-226.677 84.891c-53.43 56.994-80.523 140.403-80.523 247.909s27.093 190.915 80.523 247.909c48.382 51.606 116.464 79.888 202.592 84.27 3.718 30.352 14.374 57.034 31.877 79.538 17.555 22.568 41.685 40.539 71.723 53.413 49.066 21.029 97.642 21.27 99.685 21.27 14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6c-0.395 0-40.003-0.195-79.515-17.13-41.685-17.866-65.442-46.157-72.114-86.069 84.485-4.962 151.378-33.181 199.106-84.093 53.43-56.994 80.523-140.403 80.523-247.909s-27.093-190.915-80.523-247.909zM547.723 699.291c-42.742 45.592-106.438 68.709-189.323 68.709-82.883 0-146.581-23.117-189.323-68.709-44.243-47.192-66.677-118.819-66.677-212.891s22.434-165.699 66.677-212.891c42.742-45.592 106.44-68.709 189.323-68.709 82.885 0 146.581 23.117 189.323 68.709 44.243 47.192 66.677 118.819 66.677 212.891s-22.434 165.699-66.677 212.891z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"Q"
					],
					"defaultCode": 81,
					"grid": 20
				},
				{
					"id": 49,
					"width": 563,
					"paths": [
						"M507.699 779.4l-179.466-269.2c126.638-10.382 183.766-66.291 183.766-177.4 0-123.933-71.058-179.2-230.4-179.2h-204.8c-14.138 0-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-281.6h165.499l197.2 295.8c4.933 7.4 13.050 11.403 21.323 11.403 4.88 0 9.813-1.394 14.176-4.302 11.766-7.843 14.946-23.736 7.101-35.501zM102.4 204.8h179.2c69.322 0 116.427 10.726 144.008 32.79 24.010 19.208 35.192 49.461 35.192 95.21s-11.182 76.002-35.192 95.21c-27.581 22.064-74.686 32.79-144.008 32.79h-179.2v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"R"
					],
					"defaultCode": 82,
					"grid": 20
				},
				{
					"id": 50,
					"width": 563,
					"paths": [
						"M281.6 819.2c-134.208 0-215.6-53.234-219-55.501-11.765-7.842-14.942-23.736-7.101-35.501 7.83-11.746 23.683-14.933 35.44-7.141 1.346 0.875 73.387 46.942 190.661 46.942 70.574 0 121.234-16.528 150.571-49.125 24.91-27.677 28.629-61.298 28.629-78.875 0-76.866-70.046-99.923-185.408-128.765-52.083-13.021-105.939-26.485-147.491-50.723-50.894-29.688-76.701-72.656-76.701-127.712 0-24.915 5.427-72.742 41.771-113.126 39.461-43.843 102.923-66.074 188.629-66.074 134.208 0 215.602 53.234 219 55.499 11.765 7.843 14.944 23.738 7.101 35.501-7.843 11.765-23.738 14.942-35.501 7.101-0.64-0.421-72.802-46.901-190.6-46.901-70.574 0-121.234 16.528-150.571 49.126-24.909 27.675-28.629 61.296-28.629 78.874 0 76.866 70.046 99.923 185.408 128.765 52.083 13.021 105.939 26.485 147.49 50.723 50.896 29.688 76.702 72.658 76.702 127.712 0 24.915-5.427 72.742-41.771 113.125-39.461 43.843-102.925 66.075-188.629 66.075z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"S"
					],
					"defaultCode": 83,
					"grid": 20
				},
				{
					"id": 51,
					"width": 563,
					"paths": [
						"M486.4 153.6h-409.6c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h179.2v588.8c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-588.8h179.2c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"T"
					],
					"defaultCode": 84,
					"grid": 20
				},
				{
					"id": 52,
					"width": 614,
					"paths": [
						"M307.2 819.2c-107.923 0-175.83-28.227-213.709-88.832-35.216-56.346-42.291-135.125-42.291-243.968v-307.2c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v307.2c0 97.010 5.869 171.008 34.509 216.832 35.878 57.405 109.854 64.768 170.291 64.768 115.056 0 151.443-34.613 170.291-64.768 28.64-45.824 34.509-119.822 34.509-216.832v-307.2c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v307.2c0 108.843-7.075 187.622-42.291 243.968-37.877 60.605-105.786 88.832-213.709 88.832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"U"
					],
					"defaultCode": 85,
					"grid": 20
				},
				{
					"id": 53,
					"width": 666,
					"paths": [
						"M332.8 819.2c-10.334 0-19.656-6.214-23.632-15.754l-256-614.4c-5.438-13.051 0.733-28.038 13.784-33.477 13.050-5.437 28.038 0.733 33.477 13.784l232.371 557.686 232.368-557.686c5.437-13.050 20.416-19.224 33.478-13.784 13.050 5.437 19.222 20.426 13.784 33.477l-256 614.4c-3.974 9.539-13.296 15.754-23.63 15.754z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"V"
					],
					"defaultCode": 86,
					"grid": 20
				},
				{
					"id": 54,
					"width": 870,
					"paths": [
						"M639.992 819.2c-10.978 0-20.784-7.021-24.278-17.504l-180.514-541.542-180.514 541.542c-3.598 10.798-13.928 17.933-25.267 17.486-11.373-0.437-21.093-8.33-23.854-19.371l-153.6-614.4c-3.429-13.715 4.91-27.614 18.627-31.045 13.717-3.426 27.616 4.91 31.045 18.627l132.278 529.114 176.998-531.003c3.485-10.453 13.267-17.504 24.286-17.504s20.802 7.051 24.286 17.504l177 531 132.278-529.114c3.43-13.715 17.328-22.059 31.045-18.627 13.715 3.43 22.054 17.33 18.627 31.045l-153.6 614.4c-2.762 11.042-12.48 18.934-23.853 19.371-0.333 0.014-0.664 0.021-0.992 0.021z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"W"
					],
					"defaultCode": 87,
					"grid": 20
				},
				{
					"id": 55,
					"width": 614,
					"paths": [
						"M339.2 486.4l218.88-291.84c8.483-11.31 6.19-27.357-5.12-35.84-11.309-8.485-27.358-6.192-35.838 5.12l-209.922 279.894-209.92-279.894c-8.482-11.312-24.53-13.603-35.84-5.12s-13.603 24.53-5.12 35.84l218.88 291.84-218.88 291.84c-8.483 11.31-6.192 27.357 5.12 35.838 4.605 3.454 9.995 5.122 15.341 5.122 7.782 0 15.47-3.536 20.499-10.242l209.92-279.893 209.92 279.894c5.030 6.706 12.715 10.242 20.499 10.242 5.344 0 10.734-1.669 15.339-5.122 11.31-8.483 13.603-24.528 5.12-35.838l-218.878-291.842z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"X"
					],
					"defaultCode": 88,
					"grid": 20
				},
				{
					"id": 56,
					"width": 563,
					"paths": [
						"M499.101 156.973c-12.278-7.014-27.914-2.75-34.928 9.526l-182.573 319.501-182.573-319.501c-7.014-12.275-22.651-16.538-34.928-9.526-12.275 7.014-16.541 22.653-9.526 34.928l201.427 352.499v249.2c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-249.202l201.427-352.498c7.014-12.275 2.749-27.914-9.526-34.928z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"Y"
					],
					"defaultCode": 89,
					"grid": 20
				},
				{
					"id": 57,
					"width": 614,
					"paths": [
						"M537.6 819.2h-460.8c-9.698 0-18.562-5.478-22.898-14.152-4.336-8.672-3.4-19.051 2.418-26.808l430.080-573.44h-409.6c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h460.8c9.698 0 18.562 5.478 22.898 14.152 4.338 8.672 3.402 19.051-2.418 26.808l-430.080 573.44h409.6c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"Z"
					],
					"defaultCode": 90,
					"grid": 20
				},
				{
					"id": 58,
					"width": 307.20000000000005,
					"paths": [
						"M230.4 972.8h-153.6c-14.138 0-25.6-11.461-25.6-25.6v-870.4c0-14.138 11.462-25.6 25.6-25.6h153.6c14.139 0 25.6 11.462 25.6 25.6s-11.461 25.6-25.6 25.6h-128v819.2h128c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"["
					],
					"defaultCode": 91,
					"grid": 20
				},
				{
					"id": 59,
					"width": 410,
					"paths": [
						"M332.797 921.606c2.685 0 5.413-0.426 8.099-1.32 13.414-4.47 20.661-18.968 16.19-32.381l-256-768c-4.469-13.413-18.965-20.664-32.381-16.19-13.413 4.47-20.662 18.968-16.19 32.381l256 768c3.574 10.726 13.563 17.51 24.282 17.51z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"backslash"
					],
					"defaultCode": 92,
					"grid": 20
				},
				{
					"id": 60,
					"width": 307.20000000000005,
					"paths": [
						"M76.8 972.8h153.6c14.138 0 25.6-11.461 25.6-25.6v-870.4c0-14.138-11.462-25.6-25.6-25.6h-153.6c-14.139 0-25.6 11.462-25.6 25.6s11.461 25.6 25.6 25.6h128v819.2h-128c-14.139 0-25.6 11.461-25.6 25.6s11.461 25.6 25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"]"
					],
					"defaultCode": 93,
					"grid": 20
				},
				{
					"id": 61,
					"width": 460.7999999999996,
					"paths": [
						"M384.024 460.803c-8.698 0-17.176-4.432-21.976-12.434l-131.648-219.411-131.648 219.413c-7.274 12.125-22.997 16.056-35.123 8.781-12.123-7.274-16.054-23-8.781-35.123l153.6-256c4.627-7.71 12.96-12.429 21.952-12.429s17.325 4.718 21.952 12.429l153.6 256c7.274 12.123 3.342 27.848-8.781 35.123-4.123 2.474-8.666 3.651-13.147 3.651z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"^"
					],
					"defaultCode": 94,
					"grid": 20
				},
				{
					"id": 62,
					"width": 512,
					"paths": [
						"M512 998.4c0 14.138-11.461 25.6-25.6 25.6h-460.8c-14.139 0-25.6-11.462-25.6-25.6s11.461-25.6 25.6-25.6h460.8c14.139 0 25.6 11.461 25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"underscore"
					],
					"defaultCode": 95,
					"grid": 20
				},
				{
					"id": 63,
					"width": 307,
					"paths": [
						"M179.224 256.002c-8.274 0-16.39-4.002-21.323-11.402l-102.4-153.6c-7.842-11.763-4.664-27.658 7.101-35.501 11.766-7.842 27.659-4.662 35.501 7.101l102.4 153.6c7.843 11.763 4.664 27.658-7.101 35.501-4.366 2.909-9.299 4.301-14.178 4.301z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"`"
					],
					"defaultCode": 96,
					"grid": 20
				},
				{
					"id": 64,
					"width": 512,
					"paths": [
						"M403.965 396.312c-22.557-18.747-57.774-37.912-147.965-37.912-61.11 0-106.598 7.562-139.064 23.117-12.75 6.109-18.134 21.398-12.026 34.149 6.11 12.752 21.398 18.136 34.149 12.026 25.408-12.174 63.658-18.091 116.941-18.091 58.773 0 93.235 7.802 115.235 26.088 26.174 21.754 38.365 62.272 38.365 127.512v18.269c-29.362-13.003-75.347-18.269-153.6-18.269-60.051 0-105.666 8.211-139.448 25.102-42.754 21.378-65.352 56.958-65.352 102.898s22.598 81.52 65.352 102.898c33.782 16.891 79.397 25.102 139.448 25.102 80.037 0 125.712-4.978 154.843-17.733 3.322 10.286 12.965 17.733 24.357 17.733 14.139 0 25.6-11.461 25.6-25.6v-230.4c0-81.629-18.061-134.658-56.835-166.888zM397.92 750.368c-21.878 15.627-87.338 17.632-141.92 17.632-51.198 0-90.411-6.627-116.552-19.698-25.275-12.638-37.048-30.782-37.048-57.102s11.773-44.464 37.048-57.102c26.141-13.070 65.354-19.698 116.552-19.698 53.243 0 117.29 2.029 140.123 17.845 11.528 7.986 13.477 21.723 13.477 58.955 0 37.651-0.957 51.509-11.68 59.168z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"a"
					],
					"defaultCode": 97,
					"grid": 20
				},
				{
					"id": 65,
					"width": 563,
					"paths": [
						"M449.221 409.858c-38.088-34.626-92.918-51.458-167.621-51.458s-129.533 16.832-167.621 51.458c-4.062 3.693-7.918 7.574-11.579 11.643v-242.301c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-37.501c3.662 4.067 7.518 7.95 11.579 11.642 38.088 34.627 92.918 51.459 167.621 51.459s129.533-16.832 167.621-51.458c42.243-38.403 62.779-96.936 62.779-178.942s-20.536-140.538-62.779-178.942zM414.779 729.858c-28.232 25.666-71.795 38.142-133.179 38.142s-104.947-12.477-133.179-38.142c-30.968-28.152-46.021-74.291-46.021-141.058s15.053-112.906 46.021-141.058c28.232-25.666 71.795-38.142 133.179-38.142s104.947 12.477 133.179 38.142c30.968 28.152 46.021 74.291 46.021 141.058s-15.053 112.906-46.021 141.058z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"b"
					],
					"defaultCode": 98,
					"grid": 20
				},
				{
					"id": 66,
					"width": 512,
					"paths": [
						"M281.6 819.2c-74.702 0-129.533-16.832-167.621-51.458-42.245-38.403-62.779-96.936-62.779-178.942s20.534-140.538 62.779-178.942c38.088-34.626 92.918-51.458 167.621-51.458 77.173 0 133.245 18 171.419 55.027 10.149 9.843 10.397 26.051 0.554 36.2-9.843 10.147-26.050 10.397-36.2 0.552-28.152-27.306-72.563-40.579-135.773-40.579-61.384 0-104.947 12.477-133.179 38.142-30.968 28.152-46.021 74.291-46.021 141.058s15.053 112.906 46.021 141.058c28.232 25.666 71.795 38.142 133.179 38.142 63.211 0 107.624-13.275 135.776-40.582 10.147-9.84 26.355-9.597 36.2 0.554 9.843 10.149 9.595 26.355-0.554 36.2-38.176 37.029-94.25 55.029-171.422 55.029z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"c"
					],
					"defaultCode": 99,
					"grid": 20
				},
				{
					"id": 67,
					"width": 563,
					"paths": [
						"M486.4 153.6c-14.139 0-25.6 11.462-25.6 25.6v242.301c-3.661-4.067-7.518-7.95-11.579-11.643-38.088-34.626-92.918-51.458-167.621-51.458s-129.533 16.832-167.621 51.458c-42.245 38.405-62.779 96.936-62.779 178.942s20.534 140.539 62.779 178.942c38.088 34.626 92.918 51.458 167.621 51.458s129.533-16.832 167.621-51.458c4.061-3.693 7.918-7.574 11.579-11.642v37.499c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-614.4c0-14.138-11.461-25.6-25.6-25.6zM414.779 729.858c-28.232 25.666-71.795 38.142-133.179 38.142s-104.947-12.477-133.179-38.142c-30.968-28.152-46.021-74.291-46.021-141.058s15.053-112.906 46.021-141.058c28.232-25.666 71.795-38.142 133.179-38.142s104.947 12.477 133.179 38.142c30.968 28.152 46.021 74.291 46.021 141.058s-15.053 112.906-46.021 141.058z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"d"
					],
					"defaultCode": 100,
					"grid": 20
				},
				{
					"id": 68,
					"width": 563,
					"paths": [
						"M281.6 819.2c-74.702 0-129.533-16.832-167.621-51.458-42.245-38.403-62.779-96.936-62.779-178.942s20.534-140.538 62.779-178.942c38.088-34.626 92.918-51.458 167.621-51.458s129.533 16.832 167.621 51.458c42.243 38.405 62.779 96.936 62.779 178.942 0 14.139-11.461 25.6-25.6 25.6h-383.197c3.491 53.147 18.376 91.056 45.216 115.458 28.234 25.666 71.797 38.142 133.181 38.142 65.19 0 110.498-14.173 138.507-43.33 9.797-10.194 26.002-10.518 36.197-0.725 10.195 9.795 10.52 26 0.725 36.197-38.178 39.739-95.562 59.058-175.429 59.058zM103.203 563.2h356.792c-3.49-53.146-18.374-91.058-45.216-115.458-28.232-25.666-71.795-38.142-133.179-38.142s-104.947 12.477-133.179 38.142c-26.842 24.4-41.726 62.312-45.218 115.458z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"e"
					],
					"defaultCode": 101,
					"grid": 20
				},
				{
					"id": 69,
					"width": 307,
					"paths": [
						"M230.4 358.4h-128v-51.2c0-35.325 5.933-61.541 17.632-77.92 15.672-21.942 41.274-24.48 59.168-24.48 18.589 0 32.899 1.602 43.754 4.899 13.522 4.112 27.826-3.526 31.934-17.054s-3.526-27.826-17.054-31.934c-15.749-4.784-34.928-7.11-58.634-7.11-45.142 0-79.067 15.45-100.832 45.92-18.282 25.595-27.168 60.816-27.168 107.68v486.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-384h128c14.138 0 25.6-11.462 25.6-25.6s-11.462-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"f"
					],
					"defaultCode": 102,
					"grid": 20
				},
				{
					"id": 70,
					"width": 563,
					"paths": [
						"M486.4 358.4c-14.139 0-25.6 11.462-25.6 25.6v37.501c-3.661-4.067-7.518-7.95-11.579-11.643-38.088-34.626-92.918-51.458-167.621-51.458s-129.533 16.832-167.621 51.458c-42.245 38.405-62.779 96.936-62.779 178.942s20.534 140.539 62.779 178.942c38.088 34.626 92.918 51.458 167.621 51.458s129.533-16.832 167.621-51.458c4.061-3.693 7.918-7.574 11.579-11.642v37.499c0 72.338-11.504 116.099-37.301 141.899-25.8 25.797-69.562 37.301-141.899 37.301-67.39 0-110.904-10.395-136.942-32.714-10.733-9.198-26.894-7.957-36.098 2.776-9.202 10.736-7.958 26.898 2.776 36.099 36.341 31.147 88.853 45.038 170.264 45.038 167.955 0 230.4-62.445 230.4-230.4v-409.6c0-14.138-11.461-25.6-25.6-25.6zM414.779 729.858c-28.232 25.666-71.795 38.142-133.179 38.142s-104.947-12.477-133.179-38.142c-30.968-28.152-46.021-74.291-46.021-141.058s15.053-112.906 46.021-141.058c28.232-25.666 71.795-38.142 133.179-38.142s104.947 12.477 133.179 38.142c30.968 28.152 46.021 74.291 46.021 141.058s-15.053 112.906-46.021 141.058z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"g"
					],
					"defaultCode": 103,
					"grid": 20
				},
				{
					"id": 71,
					"width": 512,
					"paths": [
						"M402.101 410.699c-34.701-34.704-83.858-52.299-146.101-52.299s-111.4 17.595-146.101 52.299c-2.586 2.586-5.082 5.272-7.499 8.042v-239.541c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-204.8c0-65.158 14.702-112.899 43.701-141.899 24.754-24.75 61.728-37.301 109.899-37.301s85.147 12.55 109.899 37.301c28.998 29 43.701 76.741 43.701 141.899v204.8c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-204.8c0-79.23-19.749-139.154-58.699-178.101z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"h"
					],
					"defaultCode": 104,
					"grid": 20
				},
				{
					"id": 72,
					"width": 154,
					"paths": [
						"M76.8 819.2c-14.138 0-25.6-11.461-25.6-25.6v-409.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v409.6c0 14.139-11.461 25.6-25.6 25.6z",
						"M76.8 256c-14.138 0-25.6-11.462-25.6-25.6v-51.2c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v51.2c0 14.138-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"i"
					],
					"defaultCode": 105,
					"grid": 20
				},
				{
					"id": 73,
					"width": 256,
					"paths": [
						"M25.578 1023.334c-13.498 0-24.792-10.56-25.539-24.2-0.773-14.117 10.043-26.189 24.162-26.963 48.941-2.68 81.779-14.104 100.39-34.925 19.792-22.139 29.010-59.648 29.010-118.046v-435.2c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v435.2c0 71.736-13.358 120.090-42.038 152.17-28.526 31.914-71.667 48.414-135.762 51.925-0.477 0.027-0.95 0.040-1.422 0.040z",
						"M179.2 256c-14.139 0-25.6-11.462-25.6-25.6v-51.2c0-14.138 11.461-25.6 25.6-25.6s25.6 11.462 25.6 25.6v51.2c0 14.138-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"j"
					],
					"defaultCode": 106,
					"grid": 20
				},
				{
					"id": 74,
					"width": 410,
					"paths": [
						"M164.203 588.8l186.698-186.699c9.998-9.997 9.998-26.206 0-36.203s-26.206-9.998-36.203 0l-212.298 212.299v-398.997c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-194.197l212.299 212.299c4.998 4.998 11.549 7.498 18.101 7.498s13.102-2.499 18.101-7.499c9.998-9.997 9.998-26.206 0-36.203l-186.698-186.698z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"k"
					],
					"defaultCode": 107,
					"grid": 20
				},
				{
					"id": 75,
					"width": 154,
					"paths": [
						"M128.302 768.302c-0.102 0-0.2 0.014-0.302 0.016v-0.318l0.302 0.003c-2.269-0.058-9.459-0.925-15.405-4.2-5.192-2.858-10.498-7.637-10.498-21.403v-563.2c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v563.2c0 56.347 45.93 76.8 76.8 76.8v-0.318c0.101 0.002 0.2 0.016 0.302 0.016 13.971 0 25.298-11.326 25.298-25.298s-11.326-25.298-25.298-25.298z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"l"
					],
					"defaultCode": 108,
					"grid": 20
				},
				{
					"id": 76,
					"width": 870,
					"paths": [
						"M760.501 410.699c-34.701-34.704-83.858-52.299-146.101-52.299s-111.4 17.595-146.101 52.299c-13.27 13.27-24.307 28.981-33.099 47.054-8.79-18.074-19.829-33.784-33.099-47.054-34.701-34.704-83.858-52.299-146.101-52.299s-111.4 17.595-146.101 52.299c-2.586 2.586-5.082 5.272-7.499 8.042v-34.741c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v409.6c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-204.8c0-65.158 14.702-112.899 43.701-141.899 24.754-24.75 61.728-37.301 109.899-37.301s85.147 12.55 109.899 37.301c28.998 29 43.701 76.741 43.701 141.899v204.8c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-204.8c0-65.158 14.702-112.899 43.701-141.899 24.752-24.75 61.728-37.301 109.899-37.301s85.147 12.55 109.899 37.301c28.998 29 43.701 76.741 43.701 141.899v204.8c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-204.8c0-79.23-19.749-139.154-58.699-178.101z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"m"
					],
					"defaultCode": 109,
					"grid": 20
				},
				{
					"id": 77,
					"width": 512,
					"paths": [
						"M402.101 410.699c-34.701-34.704-83.858-52.299-146.101-52.299s-111.4 17.595-146.101 52.299c-2.586 2.586-5.082 5.272-7.499 8.042v-34.741c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v409.6c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-204.8c0-65.158 14.702-112.899 43.701-141.899 24.754-24.75 61.728-37.301 109.899-37.301s85.147 12.55 109.899 37.301c28.998 29 43.701 76.741 43.701 141.899v204.8c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-204.8c0-79.23-19.749-139.154-58.699-178.101z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"n"
					],
					"defaultCode": 110,
					"grid": 20
				},
				{
					"id": 78,
					"width": 563,
					"paths": [
						"M281.6 819.2c-74.702 0-129.533-16.832-167.621-51.458-42.245-38.403-62.779-96.936-62.779-178.942s20.534-140.538 62.779-178.942c38.088-34.626 92.918-51.458 167.621-51.458s129.533 16.832 167.621 51.458c42.243 38.405 62.779 96.936 62.779 178.942s-20.536 140.539-62.779 178.942c-38.088 34.626-92.918 51.458-167.621 51.458zM281.6 409.6c-61.384 0-104.947 12.477-133.179 38.142-30.968 28.152-46.021 74.291-46.021 141.058s15.053 112.906 46.021 141.058c28.232 25.666 71.795 38.142 133.179 38.142s104.947-12.477 133.179-38.142c30.968-28.152 46.021-74.291 46.021-141.058s-15.053-112.906-46.021-141.058c-28.232-25.666-71.795-38.142-133.179-38.142z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"o"
					],
					"defaultCode": 111,
					"grid": 20
				},
				{
					"id": 79,
					"width": 563,
					"paths": [
						"M449.221 409.858c-38.088-34.626-92.918-51.458-167.621-51.458s-129.533 16.832-167.621 51.458c-4.062 3.693-7.918 7.574-11.579 11.643v-37.501c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v614.4c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-242.301c3.662 4.067 7.518 7.95 11.579 11.642 38.088 34.627 92.918 51.459 167.621 51.459s129.533-16.832 167.621-51.458c42.243-38.403 62.779-96.936 62.779-178.942s-20.536-140.538-62.779-178.942zM414.779 729.858c-28.232 25.666-71.795 38.142-133.179 38.142s-104.947-12.477-133.179-38.142c-30.968-28.152-46.021-74.291-46.021-141.058s15.053-112.906 46.021-141.058c28.232-25.666 71.795-38.142 133.179-38.142s104.947 12.477 133.179 38.142c30.968 28.152 46.021 74.291 46.021 141.058s-15.053 112.906-46.021 141.058z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"p"
					],
					"defaultCode": 112,
					"grid": 20
				},
				{
					"id": 80,
					"width": 563,
					"paths": [
						"M486.4 358.4c-14.139 0-25.6 11.462-25.6 25.6v37.501c-3.661-4.067-7.518-7.95-11.579-11.643-38.088-34.626-92.918-51.458-167.621-51.458s-129.533 16.832-167.621 51.458c-42.245 38.405-62.779 96.936-62.779 178.942s20.534 140.539 62.779 178.942c38.088 34.626 92.918 51.458 167.621 51.458s129.533-16.832 167.621-51.458c4.061-3.693 7.918-7.574 11.579-11.642v242.299c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-614.4c0-14.138-11.461-25.6-25.6-25.6zM414.779 729.858c-28.232 25.666-71.795 38.142-133.179 38.142s-104.947-12.477-133.179-38.142c-30.968-28.152-46.021-74.291-46.021-141.058s15.053-112.906 46.021-141.058c28.232-25.666 71.795-38.142 133.179-38.142s104.947 12.477 133.179 38.142c30.968 28.152 46.021 74.291 46.021 141.058s-15.053 112.906-46.021 141.058z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"q"
					],
					"defaultCode": 113,
					"grid": 20
				},
				{
					"id": 81,
					"width": 307,
					"paths": [
						"M255.888 382.771c-1.312-14.077-13.784-24.422-27.867-23.114-43.136 4.022-90.698 19.018-125.621 58.971v-34.629c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v409.6c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-204.8c0-60.166 12.541-105.55 37.272-134.893 21.293-25.261 51.746-39.414 93.102-43.269 14.078-1.314 24.426-13.789 23.114-27.867z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"r"
					],
					"defaultCode": 114,
					"grid": 20
				},
				{
					"id": 82,
					"width": 461,
					"paths": [
						"M347.794 599.83c-31.525-16.366-72.083-26.294-111.307-35.896-80.995-19.827-134.086-35.826-134.086-75.934 0-25.448 0-78.4 128-78.4 89.373 0 133.79 42.050 135.637 43.84l-0.13-0.13c4.634 4.627 11.029 7.49 18.093 7.49 14.139 0 25.6-11.462 25.6-25.6 0-7.075-2.87-13.478-7.509-18.112-2.498-2.494-60.074-58.688-171.691-58.688-118.909 0-179.2 43.603-179.2 129.6 0 38.28 20.795 68.483 61.805 89.77 31.525 16.366 72.085 26.294 111.307 35.896 80.997 19.827 134.088 35.826 134.088 75.934 0 25.446 0 78.4-128 78.4-89.374 0-133.79-42.050-135.637-43.84l0.13 0.13c-4.632-4.627-11.029-7.49-18.093-7.49-14.138 0-25.6 11.461-25.6 25.6 0 7.075 2.87 13.48 7.51 18.112 2.498 2.498 60.075 58.688 171.69 58.688 118.907 0 179.2-43.603 179.2-129.6 0-38.28-20.794-68.483-61.806-89.77z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"s"
					],
					"defaultCode": 115,
					"grid": 20
				},
				{
					"id": 83,
					"width": 307,
					"paths": [
						"M254.888 780.155c-4.109-13.528-18.411-21.165-31.934-17.054-10.854 3.296-25.165 4.899-43.754 4.899-17.894 0-43.496-2.538-59.168-24.48-11.699-16.379-17.632-42.595-17.632-77.92v-256h127.994c14.138 0 25.6-11.462 25.6-25.6s-11.462-25.6-25.6-25.6h-127.994v-179.2c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v486.4c0 46.862 8.886 82.086 27.168 107.68 21.765 30.47 55.69 45.92 100.832 45.92 23.706 0 42.885-2.325 58.634-7.109 13.53-4.11 21.165-18.408 17.054-31.936z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"t"
					],
					"defaultCode": 116,
					"grid": 20
				},
				{
					"id": 84,
					"width": 512,
					"paths": [
						"M435.2 358.4c-14.139 0-25.6 11.462-25.6 25.6v204.8c0 65.158-14.702 112.899-43.701 141.899-24.752 24.75-61.728 37.301-109.899 37.301s-85.146-12.55-109.899-37.301c-28.998-29-43.701-76.741-43.701-141.899v-204.8c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v204.8c0 79.232 19.749 139.154 58.699 178.101 34.701 34.704 83.858 52.299 146.101 52.299s111.4-17.595 146.101-52.299c2.586-2.586 5.082-5.272 7.499-8.042v34.741c0 14.139 11.461 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-409.6c0-14.138-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"u"
					],
					"defaultCode": 117,
					"grid": 20
				},
				{
					"id": 85,
					"width": 461,
					"paths": [
						"M230.4 819.2c-10.67 0-20.224-6.619-23.97-16.611l-153.6-409.6c-4.965-13.238 1.742-27.995 14.981-32.96 13.238-4.966 27.995 1.742 32.96 14.981l129.629 345.682 129.63-345.68c4.966-13.237 19.73-19.942 32.96-14.981 13.237 4.965 19.946 19.722 14.981 32.96l-153.6 409.6c-3.747 9.99-13.301 16.61-23.971 16.61z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"v"
					],
					"defaultCode": 118,
					"grid": 20
				},
				{
					"id": 86,
					"width": 768,
					"paths": [
						"M700.189 360.030c-13.234-4.962-27.994 1.744-32.96 14.981l-129.629 345.68-129.654-345.672c-2.507-6.678-7.755-12.288-14.958-14.99-13.23-4.962-27.992 1.744-32.96 14.981l-129.627 345.682-129.63-345.68c-4.965-13.238-19.722-19.947-32.96-14.981-13.238 4.965-19.946 19.722-14.981 32.96l153.6 409.6c3.747 9.99 13.301 16.61 23.971 16.61s20.224-6.619 23.97-16.611l129.63-345.678 129.63 345.678c3.746 9.992 13.298 16.611 23.97 16.611s20.224-6.619 23.97-16.611l153.6-409.6c4.965-13.238-1.742-27.994-14.981-32.958z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"w"
					],
					"defaultCode": 119,
					"grid": 20
				},
				{
					"id": 87,
					"width": 461,
					"paths": [
						"M262.4 588.8l142.080-189.44c8.483-11.31 6.19-27.357-5.12-35.84-11.309-8.485-27.358-6.192-35.838 5.12l-133.122 177.494-133.12-177.494c-8.482-11.31-24.53-13.605-35.84-5.12-11.31 8.483-13.603 24.53-5.12 35.84l142.080 189.44-142.080 189.44c-8.483 11.309-6.192 27.357 5.12 35.838 4.605 3.454 9.995 5.122 15.341 5.122 7.782 0 15.47-3.536 20.499-10.242l133.12-177.493 133.12 177.494c5.030 6.706 12.715 10.242 20.499 10.242 5.344 0 10.734-1.669 15.339-5.122 11.31-8.483 13.603-24.53 5.12-35.838l-142.078-189.442z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"x"
					],
					"defaultCode": 120,
					"grid": 20
				},
				{
					"id": 88,
					"width": 461,
					"paths": [
						"M392.989 360.030c-13.23-4.962-27.992 1.744-32.96 14.981l-129.629 345.68-129.63-345.68c-4.965-13.238-19.722-19.947-32.96-14.981-13.238 4.965-19.946 19.722-14.981 32.96l150.227 400.606c-55.442 147.589-70.306 179.203-126.256 179.203-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6c47.219 0 78.686-16.77 105.219-56.078 23.291-34.502 42.808-86.55 72.352-165.333l153.6-409.6c4.963-13.238-1.744-27.994-14.982-32.958z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"y"
					],
					"defaultCode": 121,
					"grid": 20
				},
				{
					"id": 89,
					"width": 461,
					"paths": [
						"M384 819.2h-307.2c-9.698 0-18.562-5.478-22.898-14.152s-3.4-19.051 2.418-26.808l276.48-368.64h-256c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h307.2c9.698 0 18.562 5.478 22.898 14.152 4.338 8.672 3.402 19.051-2.418 26.808l-276.48 368.64h256c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"z"
					],
					"defaultCode": 122,
					"grid": 20
				},
				{
					"id": 90,
					"width": 358.20000000000005,
					"paths": [
						"M281.6 921.6h-25.6c-28.232 0-51.2-22.968-51.2-51.2v-307.2c0-30.563-13.475-58.021-34.776-76.8 21.301-18.779 34.776-46.237 34.776-76.8v-256c0-28.232 22.968-51.2 51.2-51.2h25.6c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6h-25.6c-56.464 0-102.4 45.936-102.4 102.4v256c0 28.232-22.968 51.2-51.2 51.2h-25.6c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6h25.6c28.232 0 51.2 22.968 51.2 51.2v307.2c0 56.464 45.936 102.4 102.4 102.4h25.6c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"{"
					],
					"defaultCode": 123,
					"grid": 20
				},
				{
					"id": 91,
					"width": 256,
					"paths": [
						"M128 972.8c-14.138 0-25.6-11.461-25.6-25.6v-870.4c0-14.138 11.462-25.6 25.6-25.6 14.139 0 25.6 11.462 25.6 25.6v870.4c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"|"
					],
					"defaultCode": 124,
					"grid": 20
				},
				{
					"id": 92,
					"width": 358.20000000000005,
					"paths": [
						"M76.8 921.6h25.6c28.232 0 51.2-22.968 51.2-51.2v-307.2c0-30.563 13.475-58.021 34.776-76.8-21.301-18.779-34.776-46.237-34.776-76.8v-256c0-28.232-22.968-51.2-51.2-51.2h-25.6c-14.139 0-25.6-11.462-25.6-25.6s11.461-25.6 25.6-25.6h25.6c56.464 0 102.4 45.936 102.4 102.4v256c0 28.232 22.968 51.2 51.2 51.2h25.6c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-25.6c-28.232 0-51.2 22.968-51.2 51.2v307.2c0 56.464-45.936 102.4-102.4 102.4h-25.6c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"}"
					],
					"defaultCode": 125,
					"grid": 20
				},
				{
					"id": 93,
					"width": 563.1999999999996,
					"paths": [
						"M76.813 614.406c-2.33 0-4.694-0.32-7.045-0.99-13.595-3.885-21.467-18.054-17.582-31.648 17.014-59.549 46.867-96.282 88.728-109.179 74.101-22.832 153.723 42.552 157.077 45.346 17.011 14.059 69.898 47.952 109.328 35.717 24.205-7.512 42.531-32.504 54.467-74.283 3.885-13.594 18.056-21.467 31.648-17.582 13.595 3.885 21.466 18.053 17.582 31.648-17.014 59.549-46.867 96.282-88.728 109.179-10.976 3.381-22.083 4.829-33.035 4.83-62.987 0.003-121.184-47.795-124.042-50.174-17.010-14.059-69.898-47.954-109.328-35.717-24.205 7.512-42.531 32.504-54.467 74.283-3.214 11.242-13.464 18.571-24.603 18.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"~"
					],
					"defaultCode": 126,
					"grid": 20
				},
				{
					"id": 3306,
					"paths": [
						"M1024 640h-192v-192h-64v192h-192v64h192v192h64v-192h192z",
						"M384 256v512c0 70.58-57.42 128-128 128s-128-57.42-128-128v-512h-128v512c0 141.384 114.616 256 256 256s256-114.616 256-256v-512h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unicode"
					],
					"defaultCode": 61141,
					"grid": 16
				},
				{
					"id": 2250,
					"paths": [
						"M704 256v-256h-704v704h256v320h768v-768h-320zM640 328h-320v-8h320v8zM896 392h-192v-8h192v8zM320 632h320v8h-320v-8zM128 568h128v8h-128v-8zM256 376v16h-128v-16h128zM128 360v-16h128v16h-128zM256 408v16h-128v-16h128zM320 520v-16h320v16h-320zM640 536v16h-320v-16h320zM320 488v-16h320v16h-320zM320 456v-16h320v16h-320zM320 424v-16h320v16h-320zM256 440v16h-128v-16h128zM256 472v16h-128v-16h128zM256 504v16h-128v-16h128zM256 536v16h-128v-16h128zM320 568h320v16h-320v-16zM640 600v16h-320v-16h320zM384 896v-8h512v8h-512zM384 872v-16h512v16h-512zM384 840v-16h512v16h-512zM384 808v-16h512v16h-512zM384 776v-16h512v16h-512zM384 744v-16h512v16h-512zM384 712v-8h320v-8h192v16h-512zM704 680v-16h192v16h-192zM704 648v-16h192v16h-192zM704 616v-16h192v16h-192zM704 584v-16h192v16h-192zM704 552v-16h192v16h-192zM704 520v-16h192v16h-192zM704 488v-16h192v16h-192zM704 456v-16h192v16h-192zM704 424v-16h192v16h-192zM640 392h-320v-16h320v16zM320 360v-16h320v16h-320zM256 328h-128v-16h128v16zM576 128v8h-448v-8h448zM576 152v16h-448v-16h448zM576 184v16h-448v-16h448zM576 216v16h-448v-16h448zM576 248v8h-320v8h-128v-16h448zM256 280v16h-128v-16h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unite",
						"boolean-operation",
						"dualtone"
					],
					"defaultCode": 60085,
					"grid": 16
				},
				{
					"id": 1788,
					"width": 1024,
					"paths": [
						"M785.143 375.429q-3.429-14.857-16.286-22.571t-27.714-4.286q-149.143 35.429-229.143 35.429t-229.143-35.429q-14.857-3.429-27.714 4.286t-16.286 22.571 4.286 27.714 22.571 16.286q110.857 26.286 173.143 33.143-1.143 90.286-8.857 153.714t-15.143 88.857-23.429 66l-5.143 12q-5.714 14.286 0.571 28t20.571 19.429q5.143 2.286 13.143 2.286 25.143 0 34.286-23.429l4.571-11.429q30.857-79.429 40.571-148h24q9.714 68.571 40.571 148l4.571 11.429q9.143 23.429 34.286 23.429 8 0 13.143-2.286 14.286-5.714 20.571-19.429t0.571-28l-5.143-12q-16-40.571-23.429-66t-15.143-88.857-8.857-153.714q62.286-6.857 173.143-33.143 14.857-3.429 22.571-16.286t4.286-27.714zM585.143 292.571q0-30.286-21.429-51.714t-51.714-21.429-51.714 21.429-21.429 51.714 21.429 51.714 51.714 21.429 51.714-21.429 21.429-51.714zM914.286 512q0 81.714-31.714 156.286t-85.714 128.571-128.571 85.714-156.286 31.714-156.286-31.714-128.571-85.714-85.714-128.571-31.714-156.286 31.714-156.286 85.714-128.571 128.571-85.714 156.286-31.714 156.286 31.714 128.571 85.714 85.714 128.571 31.714 156.286zM512 73.143q-89.143 0-170.286 34.857t-140 93.714-93.714 140-34.857 170.286 34.857 170.286 93.714 140 140 93.714 170.286 34.857 170.286-34.857 140-93.714 93.714-140 34.857-170.286-34.857-170.286-93.714-140-140-93.714-170.286-34.857zM1024 512q0 104-40.571 198.857t-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571 198.857 40.571 163.429 109.143 109.143 163.429 40.571 198.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"universal-access"
					],
					"defaultCode": 62106,
					"grid": 14
				},
				{
					"id": 2735,
					"paths": [
						"M440.236 635.766c-13.31 0-26.616-5.076-36.77-15.23-95.134-95.136-95.134-249.934 0-345.070l192-192c46.088-46.086 107.36-71.466 172.534-71.466s126.448 25.38 172.536 71.464c95.132 95.136 95.132 249.934 0 345.070l-87.766 87.766c-20.308 20.308-53.23 20.308-73.54 0-20.306-20.306-20.306-53.232 0-73.54l87.766-87.766c54.584-54.586 54.584-143.404 0-197.99-26.442-26.442-61.6-41.004-98.996-41.004s-72.552 14.562-98.996 41.006l-192 191.998c-54.586 54.586-54.586 143.406 0 197.992 20.308 20.306 20.306 53.232 0 73.54-10.15 10.152-23.462 15.23-36.768 15.23z",
						"M256 1012c-65.176 0-126.45-25.38-172.534-71.464-95.134-95.136-95.134-249.934 0-345.070l87.764-87.764c20.308-20.306 53.234-20.306 73.54 0 20.308 20.306 20.308 53.232 0 73.54l-87.764 87.764c-54.586 54.586-54.586 143.406 0 197.992 26.44 26.44 61.598 41.002 98.994 41.002s72.552-14.562 98.998-41.006l192-191.998c54.584-54.586 54.584-143.406 0-197.992-20.308-20.308-20.306-53.232 0-73.54 20.306-20.306 53.232-20.306 73.54 0.002 95.132 95.134 95.132 249.932 0.002 345.068l-192.002 192c-46.090 46.088-107.364 71.466-172.538 71.466z",
						"M928 832c-8.19 0-16.378-3.124-22.626-9.374l-128-128c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.496 32.758-12.496 45.254 0l128 128c12.498 12.496 12.498 32.758 0 45.254-6.248 6.25-14.438 9.374-22.628 9.374z",
						"M992 640h-128c-17.674 0-32-14.326-32-32s14.326-32 32-32h128c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
						"M736 896c-17.674 0-32-14.326-32-32v-127.998c0-17.674 14.326-32 32-32s32 14.326 32 32v127.998c0 17.674-14.326 32-32 32z",
						"M160 448h-128c-17.672 0-32-14.328-32-32s14.328-32 32-32h128c17.672 0 32 14.328 32 32s-14.326 32-32 32z",
						"M224 384c-8.19 0-16.378-3.124-22.626-9.374l-128-128c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.498 32.758-12.498 45.254 0l128 128c12.498 12.496 12.498 32.758 0 45.254-6.248 6.25-14.438 9.374-22.628 9.374z",
						"M288 320c-17.672 0-32-14.328-32-32v-128c0-17.672 14.328-32 32-32s32 14.328 32 32v128c0 17.672-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlink",
						"link",
						"break"
					],
					"defaultCode": 60570,
					"grid": 16
				},
				{
					"id": 2737,
					"paths": [
						"M476.888 675.114c4.56 9.048 6.99 19.158 6.99 29.696 0 17.616-6.744 34.058-18.992 46.308l-163.38 163.38c-12.248 12.248-28.696 18.992-46.308 18.992s-34.060-6.744-46.308-18.992l-99.38-99.38c-12.248-12.25-18.992-28.696-18.992-46.308s6.744-34.060 18.992-46.308l163.38-163.382c12.248-12.246 28.696-18.992 46.308-18.992 10.538 0 20.644 2.43 29.696 6.988l65.338-65.336c-27.87-21.41-61.44-32.16-95.034-32.16-39.986 0-79.972 15.166-110.308 45.502l-163.38 163.382c-60.67 60.67-60.67 159.95 0 220.618l99.38 99.382c30.334 30.332 70.32 45.5 110.306 45.5 39.988 0 79.974-15.168 110.308-45.502l163.38-163.38c55.82-55.82 60.238-144.298 13.344-205.346l-65.34 65.338zM978.496 144.884l-99.38-99.382c-30.334-30.336-70.32-45.502-110.308-45.502-39.986 0-79.97 15.166-110.306 45.502l-163.382 163.382c-55.82 55.82-60.238 144.298-13.342 205.342l65.338-65.34c-4.558-9.050-6.988-19.16-6.988-29.694 0-17.616 6.744-34.060 18.992-46.308l163.382-163.382c12.246-12.248 28.694-18.994 46.306-18.994 17.616 0 34.060 6.746 46.308 18.994l99.38 99.382c12.248 12.248 18.992 28.694 18.992 46.308s-6.744 34.060-18.992 46.308l-163.38 163.382c-12.248 12.248-28.694 18.992-46.308 18.992-10.536 0-20.644-2.43-29.696-6.99l-65.338 65.338c27.872 21.41 61.44 32.16 95.034 32.16 39.988 0 79.974-15.168 110.308-45.504l163.38-163.38c60.672-60.666 60.672-159.944 0-220.614zM233.368 278.624l-191.994-191.994 45.256-45.256 191.994 191.994zM384 0h64v192h-64zM0 384h192v64h-192zM790.632 745.376l191.996 191.996-45.256 45.256-191.996-191.996zM576 832h64v192h-64zM832 576h192v64h-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlink",
						"link",
						"break"
					],
					"defaultCode": 60572,
					"grid": 16
				},
				{
					"id": 2739,
					"paths": [
						"M288 1024c-158.804 0-288-129.196-288-288s129.196-288 288-288c35.346 0 64 28.654 64 64s-28.654 64-64 64c-88.224 0-160 71.776-160 160s71.776 160 160 160 160-71.776 160-160c0-35.346 28.654-64 64-64s64 28.654 64 64c0 158.804-129.196 288-288 288z",
						"M736 576c-35.346 0-64-28.654-64-64s28.654-64 64-64c88.224 0 160-71.776 160-160s-71.776-160-160-160-160 71.776-160 160c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-158.804 129.196-288 288-288s288 129.196 288 288-129.196 288-288 288z",
						"M224 256c-8.19 0-16.378-3.124-22.626-9.374l-128-128c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.498 32.758-12.498 45.254 0l128 128c12.498 12.496 12.498 32.758 0 45.254-6.25 6.25-14.438 9.374-22.628 9.374z",
						"M352 192c-17.672 0-32-14.328-32-32v-128c0-17.672 14.328-32 32-32s32 14.328 32 32v128c0 17.672-14.328 32-32 32z",
						"M160 384h-128c-17.672 0-32-14.328-32-32s14.328-32 32-32h128c17.672 0 32 14.328 32 32s-14.328 32-32 32z",
						"M928 960c-8.19 0-16.378-3.124-22.626-9.374l-128-128c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.496 32.758-12.496 45.254 0l128 128c12.498 12.496 12.498 32.758 0 45.254-6.25 6.25-14.438 9.374-22.628 9.374z",
						"M992 704h-128c-17.674 0-32-14.326-32-32s14.326-32 32-32h128c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
						"M672 1024c-17.674 0-32-14.326-32-32v-128c0-17.674 14.326-32 32-32s32 14.326 32 32v128c0 17.674-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlink",
						"link",
						"break"
					],
					"defaultCode": 60574,
					"grid": 16
				},
				{
					"id": 2741,
					"paths": [
						"M517.49 677.49l-183.352 183.352c-22.672 22.672-53.068 35.158-85.59 35.158-32.482 0-62.832-12.46-85.46-35.090-22.632-22.634-35.094-52.994-35.088-85.486 0.006-32.51 12.492-62.898 35.158-85.564l183.354-183.352-90.51-90.508-183.354 183.35c-96.838 96.84-96.868 255.27-0.068 352.070 48.38 48.382 112.18 72.58 175.968 72.58 63.836 0 127.664-24.212 176.1-72.65l183.352-183.35-90.51-90.51z",
						"M677.49 517.492l183.352-183.354c22.672-22.672 35.158-53.066 35.158-85.588 0-32.482-12.46-62.832-35.090-85.458-22.634-22.636-52.994-35.098-85.486-35.092-32.51 0.006-62.898 12.492-85.564 35.156l-183.352 183.356-90.508-90.51 183.35-183.354c96.84-96.836 255.27-96.868 352.070-0.068 48.382 48.382 72.58 112.18 72.58 175.97 0 63.836-24.212 127.662-72.65 176.1l-183.35 183.35-90.51-90.508z",
						"M832 640h192v64h-192v-64z",
						"M640 832h64v192h-64v-192z",
						"M320 0h64v192h-64v-192z",
						"M0 320h192v64h-192v-64z",
						"M806.629 761.362l175.999 175.999-45.253 45.253-175.999-175.999 45.253-45.253z",
						"M86.629 41.372l175.999 175.999-45.253 45.253-175.999-175.999 45.253-45.253z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlink",
						"link",
						"break"
					],
					"defaultCode": 60576,
					"grid": 16
				},
				{
					"id": 2743,
					"width": 1088,
					"paths": [
						"M448 768h-192c-141.16 0-256-114.842-256-256 0-141.16 114.84-256 256-256h192c35.346 0 64 28.654 64 64s-28.654 64-64 64h-192c-70.58 0-128 57.42-128 128s57.42 128 128 128h192c35.346 0 64 28.654 64 64s-28.654 64-64 64z",
						"M832 768h-192c-35.346 0-64-28.654-64-64s28.654-64 64-64h192c70.58 0 128-57.42 128-128s-57.42-128-128-128h-192c-35.346 0-64-28.654-64-64s28.654-64 64-64h192c141.158 0 256 114.84 256 256 0 141.158-114.842 256-256 256z",
						"M544 192c-17.674 0-32-14.328-32-32v-128c0-17.672 14.326-32 32-32s32 14.328 32 32v128c0 17.672-14.326 32-32 32z",
						"M736 192c-8.19 0-16.378-3.124-22.626-9.374-12.498-12.496-12.498-32.758 0-45.254l128-128c12.496-12.498 32.758-12.498 45.254 0 12.498 12.496 12.498 32.758 0 45.254l-128 128c-6.25 6.25-14.438 9.374-22.628 9.374z",
						"M352 192c-8.19 0-16.378-3.124-22.626-9.374l-128-128c-12.498-12.496-12.498-32.758 0-45.254 12.496-12.498 32.758-12.498 45.254 0l128 128c12.498 12.496 12.498 32.758 0 45.254-6.25 6.25-14.438 9.374-22.628 9.374z",
						"M544 832c17.676 0 32 14.326 32 32v128c0 17.672-14.324 32-32 32-17.672 0-32-14.328-32-32v-128c0-17.674 14.328-32 32-32z",
						"M352 832c8.19 0 16.378 3.124 22.626 9.372 12.498 12.496 12.498 32.758 0 45.254l-128 128c-12.496 12.5-32.758 12.5-45.254 0-12.498-12.496-12.498-32.758 0-45.254l128-128c6.25-6.248 14.44-9.372 22.628-9.372z",
						"M736 832c8.192 0 16.378 3.124 22.628 9.372l128 128.002c12.496 12.496 12.496 32.758 0 45.254-12.496 12.498-32.758 12.498-45.254 0l-128-128.002c-12.498-12.496-12.498-32.758 0-45.254 6.248-6.248 14.438-9.372 22.626-9.372z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlink",
						"link",
						"break"
					],
					"defaultCode": 60578,
					"grid": 16
				},
				{
					"id": 203,
					"paths": [
						"M691.2 588.8c-6.552 0-13.102-2.499-18.101-7.499-9.998-9.997-9.998-26.206 0-36.203l157.083-157.083c25.936-25.936 40.221-60.421 40.221-97.099s-14.285-71.162-40.221-97.098c-53.539-53.538-140.654-53.541-194.197 0l-157.083 157.082c-9.997 9.998-26.206 9.998-36.203 0-9.998-9.997-9.998-26.206 0-36.203l157.083-157.083c73.504-73.502 193.104-73.499 266.603 0 35.608 35.606 55.218 82.947 55.218 133.302s-19.61 97.696-55.218 133.302l-157.083 157.082c-5 5.002-11.55 7.501-18.102 7.501z",
						"M239.717 972.802c-50.355 0-97.696-19.61-133.302-55.218-73.501-73.501-73.501-193.101 0-266.603l157.083-157.083c9.997-9.998 26.206-9.998 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-157.082 157.083c-53.538 53.541-53.538 140.658 0 194.197 25.936 25.936 60.419 40.221 97.098 40.221s71.162-14.285 97.098-40.221l157.083-157.083c9.997-9.997 26.206-9.997 36.203 0 9.998 9.997 9.998 26.206 0 36.203l-157.083 157.083c-35.605 35.608-82.946 55.218-133.301 55.218z",
						"M281.6 358.4c-6.552 0-13.102-2.499-18.101-7.499l-102.4-102.4c-9.998-9.997-9.998-26.206 0-36.203 9.997-9.998 26.206-9.998 36.203 0l102.4 102.4c9.998 9.997 9.998 26.206 0 36.203-5 5-11.55 7.499-18.102 7.499z",
						"M384 307.2c-14.138 0-25.6-11.462-25.6-25.6v-153.6c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v153.6c0 14.138-11.462 25.6-25.6 25.6z",
						"M230.4 460.8h-153.6c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h153.6c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M793.6 870.4c-6.552 0-13.102-2.499-18.101-7.499l-102.4-102.4c-9.998-9.997-9.998-26.206 0-36.203 9.997-9.997 26.206-9.997 36.203 0l102.4 102.4c9.998 9.997 9.998 26.206 0 36.203-5 5-11.55 7.499-18.102 7.499z",
						"M896.002 665.6h-153.602c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h153.602c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6z",
						"M588.8 972.8c-14.139 0-25.6-11.461-25.6-25.6v-153.6c0-14.139 11.461-25.6 25.6-25.6s25.6 11.461 25.6 25.6v153.6c0 14.139-11.461 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlink",
						"url"
					],
					"defaultCode": 59500,
					"grid": 20
				},
				{
					"id": 1326,
					"width": 950.8590621948242,
					"paths": [
						"M950.857 329.143v146.286q0 14.857-10.857 25.714t-25.714 10.857h-36.571q-14.857 0-25.714-10.857t-10.857-25.714v-146.286q0-60.571-42.857-103.429t-103.429-42.857-103.429 42.857-42.857 103.429v109.714h54.857q22.857 0 38.857 16t16 38.857v329.143q0 22.857-16 38.857t-38.857 16h-548.571q-22.857 0-38.857-16t-16-38.857v-329.143q0-22.857 16-38.857t38.857-16h384v-109.714q0-105.714 75.143-180.857t180.857-75.143 180.857 75.143 75.143 180.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlock"
					],
					"defaultCode": 61596,
					"grid": 14
				},
				{
					"id": 1464,
					"width": 658.2870407104492,
					"paths": [
						"M603.429 438.857q22.857 0 38.857 16t16 38.857v329.143q0 22.857-16 38.857t-38.857 16h-548.571q-22.857 0-38.857-16t-16-38.857v-329.143q0-22.857 16-38.857t38.857-16h18.286v-182.857q0-105.714 75.143-180.857t180.857-75.143 180.857 75.143 75.143 180.857q0 14.857-10.857 25.714t-25.714 10.857h-36.571q-14.857 0-25.714-10.857t-10.857-25.714q0-60.571-42.857-103.429t-103.429-42.857-103.429 42.857-42.857 103.429v182.857h420.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlock-alt"
					],
					"defaultCode": 61758,
					"grid": 14
				},
				{
					"id": 909,
					"width": 1024,
					"paths": [
						"M512 64c-35.296 0-64 28.704-64 64s28.704 64 64 64c35.296 0 64-28.704 64-64s-28.704-64-64-64zM512 160c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM608 0h-192c-106.048 0-192 85.952-192 192v64c0 106.048 85.952 192 192 192v0 466.752c0 8.48 3.36 16.64 9.376 22.624l64.512 64.512c12.288 12.288 32.16 12.512 44.736 0.512l84.64-80.864c12.992-12.416 13.216-33.056 0.512-45.76l-43.776-43.776 41.376-41.376c12.512-12.512 12.512-32.768 0-45.248l-41.376-41.376 41.376-41.376c12.512-12.512 12.512-32.768 0-45.248l-9.376-9.376v-160c106.048 0 192-85.952 192-192v-64c0-106.048-85.952-192-192-192zM768 256c0 88.352-71.648 160-160 160h-32v205.248l18.752 18.752-41.376 41.376c-12.512 12.512-12.512 32.768 0 45.248l41.376 41.376-41.376 41.376c-12.512 12.512-12.512 32.768 0 45.248l43.744 43.776-84.608 80.864-0.512-0.512v-546.752c0-8.832-7.168-16-16-16s-16 7.168-16 16v514.752l-32-32v-498.752h-32c-88.352 0-160-71.648-160-160v-64c0-88.352 71.648-160 160-160h192c88.352 0 160 71.648 160 160v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlock",
						"lock",
						"open",
						"release"
					],
					"grid": 32
				},
				{
					"id": 910,
					"width": 1024,
					"paths": [
						"M544 128c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM800 192v64c0 106.048-85.952 192-192 192v160l9.376 9.376c12.512 12.512 12.512 32.768 0 45.248l-41.376 41.376 41.376 41.376c12.512 12.512 12.512 32.768 0 45.248l-41.376 41.376 43.776 43.744c12.704 12.704 12.448 33.344-0.512 45.76l-84.64 80.864c-12.576 12-32.448 11.776-44.736-0.512l-64.512-64.512c-6.016-5.984-9.376-14.112-9.376-22.592v-466.752c-106.048 0-192-85.952-192-192v-64c0-106.048 85.952-192 192-192h192c106.048 0 192 85.952 192 192zM512 464c0-8.832-7.168-16-16-16s-16 7.168-16 16v480c0 8.832 7.168 16 16 16s16-7.168 16-16v-480zM576 128c0-35.296-28.704-64-64-64s-64 28.704-64 64c0 35.296 28.704 64 64 64s64-28.704 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlock",
						"lock",
						"open",
						"release"
					],
					"grid": 32
				},
				{
					"id": 1165,
					"width": 1024,
					"paths": [
						"M448 832c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-88.928c19.52-17.568 32-42.752 32-71.072 0-53.024-42.976-96-96-96-5.632 0-11.392 0.48-17.248 1.504-38.784 6.752-70.496 38.656-77.28 77.44-6.144 35.168 7.168 67.104 30.496 88.128v88.928zM449.024 660.448c4.448-25.408 25.984-47.040 51.232-51.424 3.904-0.672 7.872-1.024 11.744-1.024 35.296 0 64 28.704 64 64 0 18.080-7.616 34.88-21.408 47.296l-10.592 9.536v103.168h-64v-103.168l-10.592-9.536c-16.832-15.168-24.256-36.608-20.384-58.848zM864 416h-416v-160c0-35.36 28.64-64 64-64s64 28.64 64 64v64c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-64c0-141.376-114.624-256-256-256s-256 114.624-256 256v160h-96c-17.664 0-32 14.336-32 32v544c0 17.664 14.336 32 32 32h704c17.664 0 32-14.336 32-32v-544c0-17.664-14.336-32-32-32zM320 256c0-105.856 86.144-192 192-192s192 86.144 192 192v32h-64v-32c0-70.592-57.408-128-128-128s-128 57.408-128 128v192h-64v-192zM832 960h-640v-480h640v480z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlock",
						"lock",
						"open",
						"release"
					],
					"grid": 32
				},
				{
					"id": 2409,
					"paths": [
						"M768 64c105.87 0 192 86.13 192 192v192h-128v-192c0-35.29-28.71-64-64-64h-128c-35.29 0-64 28.71-64 64v192h16c26.4 0 48 21.6 48 48v480c0 26.4-21.6 48-48 48h-544c-26.4 0-48-21.6-48-48v-480c0-26.4 21.6-48 48-48h400v-192c0-105.87 86.13-192 192-192h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlocked",
						"lock-open"
					],
					"defaultCode": 60244,
					"grid": 16
				},
				{
					"id": 2411,
					"paths": [
						"M768 64h-128c-105.87 0-192 86.13-192 192v192h-400c-26.4 0-48 21.6-48 48v480c0 26.4 21.6 48 48 48h544c26.4 0 48-21.6 48-48v-480c0-26.4-21.6-48-48-48h-16v-192c0-35.29 28.71-64 64-64h128c35.29 0 64 28.71 64 64v192h128v-192c0-105.87-86.13-192-192-192zM384 896h-128l27.84-139.2c-16.808-11.532-27.84-30.874-27.84-52.8 0-35.346 28.654-64 64-64s64 28.654 64 64c0 21.926-11.032 41.268-27.84 52.8l27.84 139.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"unlocked",
						"lock-open"
					],
					"defaultCode": 60246,
					"grid": 16
				},
				{
					"id": 2205,
					"paths": [
						"M448 576h128v-256h192l-256-256-256 256h192zM640 432v98.712l293.066 109.288-421.066 157.018-421.066-157.018 293.066-109.288v-98.712l-384 144v256l512 192 512-192v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"arrow"
					],
					"defaultCode": 60040,
					"grid": 16
				},
				{
					"id": 2725,
					"paths": [
						"M448 192v320h64v-320h160l-192-192-192 192z",
						"M576 294.4v68.93l301.004 120.402-397.004 211.732-397.004-211.732 301.004-120.402v-68.93l-384 153.6v320l480 256 480-256v-320l-384-153.6zM448 934.4l-384-204.8v-183.466l384 204.8v183.466zM896 729.6l-384 204.8v-183.466l384-204.8v183.466z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"open"
					],
					"defaultCode": 60560,
					"grid": 16
				},
				{
					"id": 1317,
					"width": 950.858024597168,
					"paths": [
						"M731.429 841.143q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM877.714 841.143q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM950.857 713.143v182.857q0 22.857-16 38.857t-38.857 16h-841.143q-22.857 0-38.857-16t-16-38.857v-182.857q0-22.857 16-38.857t38.857-16h244q12 32 40.286 52.571t63.143 20.571h146.286q34.857 0 63.143-20.571t40.286-52.571h244q22.857 0 38.857 16t16 38.857zM765.143 342.857q-9.714 22.857-33.714 22.857h-146.286v256q0 14.857-10.857 25.714t-25.714 10.857h-146.286q-14.857 0-25.714-10.857t-10.857-25.714v-256h-146.286q-24 0-33.714-22.857-9.714-22.286 8-39.429l256-256q10.286-10.857 25.714-10.857t25.714 10.857l256 256q17.714 17.143 8 39.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload"
					],
					"defaultCode": 61587,
					"grid": 14
				},
				{
					"id": 197,
					"paths": [
						"M896 972.8h-819.2c-42.347 0-76.8-34.451-76.8-76.8v-102.4c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v102.4c0 14.115 11.485 25.6 25.6 25.6h819.2c14.115 0 25.6-11.485 25.6-25.6v-102.4c0-14.139 11.461-25.6 25.6-25.6s25.6 11.461 25.6 25.6v102.4c0 42.349-34.451 76.8-76.8 76.8z",
						"M760.501 442.698l-256-256c-9.998-9.997-26.206-9.997-36.205 0l-256 256c-9.997 9.998-9.997 26.206 0 36.203s26.206 9.997 36.205 0l212.299-212.298v526.997c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-526.997l212.299 212.298c4.998 5 11.549 7.499 18.101 7.499s13.102-2.499 18.101-7.499c9.998-9.997 9.998-26.205 0-36.203z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"up",
						"arrow"
					],
					"defaultCode": 59494,
					"grid": 20
				},
				{
					"id": 1166,
					"width": 1024,
					"paths": [
						"M862.656 354.432c-14.976-162.656-152.16-290.432-318.656-290.432-140.128 0-264.128 92.768-305.376 224.48-136.32-8.384-252 108.192-237.376 247.296 12.16 115.648 115.904 200.224 232.192 200.224h150.56v192c0 17.664 14.336 32 32 32h192c17.664 0 32-14.336 32-32v-192h185.216c95.68 0 181.888-67.104 196.448-161.696 16.704-108.48-58.144-203.616-159.008-219.872zM576 672v224h-128v-224h-82.752l146.752-146.752 146.752 146.752h-82.752zM827.392 672h-123.392l-169.376-169.376c-12.512-12.512-32.768-12.512-45.248 0l-169.376 169.376h-88.864c-83.52 0-158.24-60.896-166.368-144-9.312-95.36 65.728-176 159.232-176 11.040 0 22.176 1.152 33.056 3.424 17.088 3.552 33.12-8.768 36.832-25.824 25.312-116.896 130.336-201.6 250.112-201.6 140.64 0 255.168 114.016 256 254.464 0.096 17.856 14.176 33.536 32.032 33.536 76.64 0.032 137.76 67.744 126.656 146.496-8.992 63.808-66.88 109.504-131.296 109.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"save",
						"transfer"
					],
					"grid": 32
				},
				{
					"id": 2708,
					"paths": [
						"M160 384l352-352 352 352h-224v384h-256v-384z",
						"M896 512v384h-768v-384h-128v416c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-416h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"open"
					],
					"defaultCode": 60543,
					"grid": 16
				},
				{
					"id": 2709,
					"paths": [
						"M864 384l-352-352-352 352h224v384h256v-384z",
						"M18.178 984h987.644c3.614-4.998 6.754-10.352 9.366-16h-1006.376c2.61 5.648 5.754 11.002 9.366 16z",
						"M57.79 1016h908.422c9.194-4.024 17.638-9.45 25.078-16h-958.58c7.44 6.55 15.886 11.976 25.080 16z",
						"M3.058 952h1017.882c1.346-5.178 2.24-10.53 2.698-16h-1023.276c0.456 5.47 1.352 10.822 2.696 16z",
						"M1016 904v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-784v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-16v-392h-16v392h-8v16h1024v-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"open",
						"dualtone"
					],
					"defaultCode": 60544,
					"grid": 16
				},
				{
					"id": 2713,
					"paths": [
						"M896 704v128h-768v-128h-128v256h1024v-256zM256 448h192v320h128v-320h192l-256-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"open",
						"outbox",
						"arrow"
					],
					"defaultCode": 60548,
					"grid": 16
				},
				{
					"id": 2715,
					"paths": [
						"M128 768h768v192h-768v-192z",
						"M384 384v320h256v-320h224l-352-352-352 352z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"open",
						"arrow"
					],
					"defaultCode": 60550,
					"grid": 16
				},
				{
					"id": 2717,
					"paths": [
						"M192 1024h640c106.038 0 192-85.962 192-192h-1024c0 106.038 85.962 192 192 192zM832 896h64v64h-64v-64zM224 320l288-288 288 288h-224v192h-128v-192zM1022.8 737.23c4.908 16.924-5.694 30.77-23.56 30.77h-974.482c-17.864 0-28.466-13.846-23.558-30.77l112.084-322.462c4.908-16.922 23.542-30.768 41.406-30.768h229.31v192h256v-192h229.31c17.866 0 36.498 13.846 41.406 30.768l112.084 322.462z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"open"
					],
					"defaultCode": 60552,
					"grid": 16
				},
				{
					"id": 2719,
					"paths": [
						"M0 896h1024v64h-1024zM1024 768v64h-1024v-64l128-256h256v128h256v-128h256zM224 320l288-288 288 288h-224v256h-128v-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"open"
					],
					"defaultCode": 60554,
					"grid": 16
				},
				{
					"id": 2721,
					"paths": [
						"M480 704h-480v256h960v-256h-480zM896 832h-128v-64h128v64zM224 320l256-256 256 256h-160v320h-192v-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"open"
					],
					"defaultCode": 60556,
					"grid": 16
				},
				{
					"id": 2723,
					"paths": [
						"M448 640h128v-256h224l-288-256-288 256h224zM640 518.048v33.244c149.138 17.572 256 64.976 256 120.708 0 70.694-171.922 128-384 128s-384-57.306-384-128c0-55.73 106.862-103.132 256-120.708v-33.244c-220.83 21.316-384 96.488-384 185.952 0 106.040 229.23 192 512 192s512-85.96 512-192c0-89.464-163.172-164.636-384-185.952z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"upload",
						"load",
						"open",
						"arrow"
					],
					"defaultCode": 60558,
					"grid": 16
				},
				{
					"id": 911,
					"width": 1024,
					"paths": [
						"M864 288h-192v-96c0-53.024-42.976-96-96-96h-128c-53.024 0-96 42.976-96 96v288h-192c-53.024 0-96 42.976-96 96v288c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-480c0-53.024-42.976-96-96-96zM192 928v-128h64v128h-64zM352 928h-64v-128c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v128c-35.296 0-64-28.704-64-64v-288c0-35.296 28.704-64 64-64h192v416zM480 928v-128h64v128h-64zM640 928h-64v-128c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v128h-64v-736c0-35.296 28.704-64 64-64h128c35.296 0 64 28.704 64 64v736zM768 928v-128h64v128h-64zM928 864c0 35.296-28.704 64-64 64v-128c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v128h-64v-608h192c35.296 0 64 28.704 64 64v480zM160 672c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64zM192 608h64v64h-64v-64zM544 576h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM544 672h-64v-64h64v64zM544 384h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM544 480h-64v-64h64v64zM832 576h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM832 672h-64v-64h64v64zM832 384h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM832 480h-64v-64h64v64zM544 192h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32zM544 288h-64v-64h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"urbanize",
						"build"
					],
					"grid": 32
				},
				{
					"id": 912,
					"width": 1024,
					"paths": [
						"M768 800h64v160h-64v-160zM480 480h64v-64h-64v64zM480 672h64v-64h-64v64zM192 672h64v-64h-64v64zM192 960h64v-160h-64v160zM480 960h64v-160h-64v160zM960 384v480c0 53.024-42.976 96-96 96v-160c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v160h-160v-160c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v160h-160v-160c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v160c-53.024 0-96-42.976-96-96v-288c0-53.024 42.976-96 96-96h192v-288c0-53.024 42.976-96 96-96h128c53.024 0 96 42.976 96 96v96h192c53.024 0 96 42.976 96 96zM288 608c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM576 608c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM576 416c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM576 224c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM864 608c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM864 416c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64zM768 672h64v-64h-64v64zM768 480h64v-64h-64v64zM480 288h64v-64h-64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"urbanize",
						"build"
					],
					"grid": 32
				},
				{
					"id": 1770,
					"width": 1316.5721130371094,
					"paths": [
						"M1307.429 460q9.143 4.571 9.143 15.429t-9.143 15.429l-182.857 109.714q-4.571 2.857-9.143 2.857-5.143 0-9.143-2.286-9.143-5.714-9.143-16v-73.143h-490.286q21.143 33.143 47.429 94.286 9.143 21.143 14 31.429t13.714 28 15.429 26.857 15.429 19.429 18 14.857 18.857 4.571h54.857v-54.857q0-8 5.143-13.143t13.143-5.143h182.857q8 0 13.143 5.143t5.143 13.143v182.857q0 8-5.143 13.143t-13.143 5.143h-182.857q-8 0-13.143-5.143t-5.143-13.143v-54.857h-54.857q-18.286 0-34.857-5.714t-29.143-13.429-25.714-23.143-21.143-26.286-19.143-32.571-16.286-32.857-16-34.571q-13.143-30.286-21.143-46.571t-20.571-37.143-25.429-30.571-26.571-9.714h-205.714q-12.571 48-52 78.857t-89.714 30.857q-60.571 0-103.429-42.857t-42.857-103.429 42.857-103.429 103.429-42.857q50.286 0 89.714 30.857t52 78.857h59.429q13.714 0 26.571-9.714t25.429-30.571 20.571-37.143 21.143-46.571q10.857-23.429 16-34.571t16.286-32.857 19.143-32.571 21.143-26.286 25.714-23.143 29.143-13.429 34.857-5.714h61.143q12-32.571 40-52.857t63.429-20.286q45.714 0 77.714 32t32 77.714-32 77.714-77.714 32q-35.429 0-63.429-20.286t-40-52.857h-61.143q-9.714 0-18.857 4.571t-18 14.857-15.429 19.429-15.429 26.857-13.714 28-14 31.429q-26.286 61.143-47.429 94.286h636.571v-73.143q0-10.286 9.143-16t18.286 0.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"usb"
					],
					"defaultCode": 62087,
					"grid": 14
				},
				{
					"id": 2213,
					"paths": [
						"M416 128c-17.672 0-32 14.328-32 32v64c0 17.672 14.328 32 32 32s32-14.328 32-32v-64c0-17.672-14.326-32-32-32z",
						"M544 128c-17.674 0-32 14.328-32 32v64c0 17.672 14.326 32 32 32s32-14.328 32-32v-64c0-17.672-14.326-32-32-32z",
						"M736 320h-32v-288c0-17.672-14.326-32-32-32h-384c-17.672 0-32 14.328-32 32v288h-32c-17.672 0-32 14.328-32 32v600c64 96 512 96 576 0v-600c0-17.672-14.326-32-32-32zM320 864c0 17.674-14.328 32-32 32s-32-14.326-32-32v-384c0-17.672 14.328-32 32-32s32 14.328 32 32v384zM640 320h-320v-256h320v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"usb-stick",
						"flash-memory"
					],
					"defaultCode": 60048,
					"grid": 16
				},
				{
					"id": 913,
					"width": 1024,
					"paths": [
						"M908.128 880.48l-19.68-78.656c-15.296-61.248-59.744-111.040-118.848-133.216l-159.264-59.712-0.448-0.896h94.112c53.024 0 96-42.976 96-96v-160c0-159.072-128.928-288-288-288s-288 128.928-288 288v160c0 53.024 42.976 96 96 96h94.112l-0.448 0.864-159.264 59.744c-59.104 22.176-103.552 71.968-118.848 133.216l-19.68 78.656c-10.080 40.384 20.448 79.52 62.112 79.52h668.064c41.632 0 72.16-39.136 62.080-79.52zM326.4 303.68c46.624 31.776 112.416 48.32 185.6 48.32s138.976-16.544 185.6-48.32c4.032 15.488 6.4 31.616 6.4 48.32 0 103.584-83.872 224-192 224s-192-120.416-192-224c0-16.704 2.368-32.832 6.4-48.32zM337.44 272.512c30.304-66.272 97.056-112.512 174.56-112.512s144.256 46.24 174.56 112.512c-44.64 33.76-112.608 47.488-174.56 47.488s-129.92-13.728-174.56-47.488zM454.848 598.112c18.272 6.176 37.376 9.888 57.152 9.888s38.88-3.712 57.152-9.888l16.256 32.48-73.408 73.408-73.408-73.408 16.256-32.48zM256 512v-160c0-141.152 114.848-256 256-256s256 114.848 256 256v160c0 35.296-28.704 64-64 64h-89.28c72-46.656 121.28-137.344 121.28-224 0-123.712-100.288-224-224-224s-224 100.288-224 224c0 86.656 49.28 177.344 121.28 224h-89.28c-35.296 0-64-28.704-64-64zM871.264 915.68c-6.112 7.84-15.296 12.32-25.248 12.32h-668.032c-9.92 0-19.104-4.48-25.216-12.32-6.112-7.808-8.224-17.824-5.824-27.456l19.68-78.656c12.768-51.040 49.792-92.544 99.040-111.008l142.304-53.376 81.44 81.44c12.512 12.512 32.768 12.512 45.248 0l81.44-81.44 142.304 53.376c49.248 18.464 86.272 59.968 99.040 111.008l19.68 78.656c2.368 9.632 0.224 19.648-5.856 27.456zM576 416c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM384 416c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"use",
						"be"
					],
					"grid": 32
				},
				{
					"id": 914,
					"width": 1024,
					"paths": [
						"M224 512v-160c0-157.184 125.92-284.96 282.368-287.936 161.472-3.104 293.632 132.128 293.632 293.632v154.304c0 53.024-42.976 96-96 96h-64v-50.912c57.984-49.792 96-129.024 96-205.088 0-18.976-2.464-37.312-6.976-54.88-3.712-14.528-16.928-24.608-31.936-24.608v0c-6.528 0-12.864 1.984-18.304 5.568-19.136 12.512-73.952 41.92-166.784 41.92s-147.648-29.408-166.816-41.952c-5.44-3.584-11.776-5.568-18.304-5.568v0c-15.008 0-28.192 10.080-31.936 24.608-4.48 17.6-6.944 35.936-6.944 54.912 0 76.096 38.016 155.296 96 205.088v50.912h-64c-53.024 0-96-42.976-96-96zM512 576c-108.128 0-192-120.416-192-224 0-16.672 2.368-32.768 6.368-48.192 21.728 14.56 82.752 48.192 185.632 48.192s163.904-33.632 185.632-48.192c4 15.424 6.368 31.52 6.368 48.192 0 103.584-83.872 224-192 224zM448 416c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM640 416c0-17.664-14.336-32-32-32s-32 14.336-32 32c0 17.664 14.336 32 32 32s32-14.336 32-32zM908.128 880.48l-19.68-78.656c-15.296-61.248-59.744-111.040-118.848-133.216l-128.704-48.256-106.272 106.272c-12.512 12.512-32.768 12.512-45.248 0l-106.272-106.272-128.704 48.256c-59.104 22.176-103.552 71.968-118.848 133.216l-19.68 78.656c-10.080 40.384 20.448 79.52 62.112 79.52h668.064c41.632 0 72.16-39.136 62.080-79.52zM416 580.064v27.936l96 96 96-95.968v-27.968c-29.12 17.44-61.6 27.936-96 27.936s-66.88-10.496-96-27.936z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"use",
						"be"
					],
					"grid": 32
				},
				{
					"id": 1167,
					"width": 1024,
					"paths": [
						"M991.040 984.256l-43.648-174.592c-15.456-61.824-66.112-108.576-128.96-119.040l-119.712-19.936c-15.424-2.56-26.72-15.936-26.72-31.552v-35.904c81.536-71.712 128-180.48 128-300.992 0-175.136-121.12-302.24-288-302.24s-288 127.104-288 302.208c0 120.544 46.464 229.28 128 300.992v35.904c0 15.648-11.328 28.992-26.752 31.552l-119.712 19.936c-62.848 10.464-113.504 57.216-128.96 119.040l-43.616 174.624c-5.056 20.192 10.208 39.744 31.040 39.744h896c20.832 0 36.096-19.552 31.040-39.744zM288 302.208c0-140.256 92.096-238.208 224-238.208s224 97.952 224 238.208c0 186.688-132.672 305.792-224 305.792-91.488 0-224-119.008-224-305.792zM104.992 960l33.696-134.848c9.28-37.056 39.648-65.088 77.344-71.392l119.776-19.936c46.464-7.808 80.192-47.616 80.192-94.688v-28.928c32.544 19.296 65.952 29.792 96 29.792s63.456-10.496 96-29.792v28.928c0 47.104 33.728 86.912 80.224 94.688l119.712 19.936c37.728 6.304 68.096 34.336 77.376 71.392l33.696 134.848h-814.016z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"use"
					],
					"grid": 32
				},
				{
					"id": 2316,
					"paths": [
						"M576 706.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60151,
					"grid": 16
				},
				{
					"id": 2321,
					"width": 1024,
					"paths": [
						"M384 736c0-151.234 95.874-280.486 230.032-330.2 16.28-36.538 25.968-77.164 25.968-117.8 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h397.306c-8.664-30.53-13.306-62.732-13.306-96z",
						"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288c159.056 0 288-128.942 288-288s-128.942-288-288-288zM512 736c0-123.71 100.29-224 224-224 48.862 0 94.062 15.656 130.88 42.208l-312.67 312.672c-26.554-36.818-42.21-82.018-42.21-130.88zM736 960c-48.862 0-94.062-15.656-130.88-42.208l312.672-312.672c26.552 36.818 42.208 82.018 42.208 130.88 0 123.71-100.288 224-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-block",
						"user",
						"user-ban",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60156,
					"grid": 16
				},
				{
					"id": 2330,
					"paths": [
						"M480 1024h-446.536c-8.986 0-17.558-3.78-23.622-10.412s-9.056-15.51-8.25-24.46c7.042-78.104 37.426-151.238 87.874-211.5 44.578-53.25 101.778-92.938 166.528-115.774l0.002-30.394c-35.944-24.612-66.358-59.274-88.638-101.218-25.748-48.48-39.358-104.582-39.358-162.242 0-80.058 25.892-155.586 72.906-212.676 48.5-58.892 113.524-91.324 183.094-91.324 135.644 0 247.91 125.834 255.58 286.474 0.844 17.654-12.784 32.648-30.436 33.49-17.698 0.838-32.646-12.786-33.49-30.438-6.040-126.462-90.224-225.526-191.654-225.526-105.87 0-192 107.664-192 240 0 93.25 43.958 178.862 111.986 218.104 9.908 5.714 16.012 16.284 16.010 27.72l-0.004 71.432c0 14.318-9.512 26.892-23.29 30.79-61.908 17.514-116.598 53.014-158.164 102.664-34.422 41.12-57.632 89.42-68.126 141.292h409.588c17.672 0 32 14.326 32 32s-14.326 31.998-32 31.998z",
						"M736 448c-158.804 0-288 129.196-288 288s129.196 288 288 288 288-129.196 288-288-129.194-288-288-288zM512 736c0-123.514 100.486-224 224-224 50.242 0 96.672 16.628 134.078 44.668l-313.41 313.41c-28.038-37.406-44.668-83.836-44.668-134.078zM736 960c-50.242 0-96.672-16.628-134.078-44.668l313.41-313.41c28.040 37.406 44.668 83.836 44.668 134.078 0 123.514-100.486 224-224 224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-block",
						"user",
						"user-ban",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60165,
					"grid": 16
				},
				{
					"id": 2320,
					"width": 1024,
					"paths": [
						"M384 736c0-151.234 95.874-280.486 230.032-330.2 16.28-36.538 25.968-77.164 25.968-117.8 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h397.306c-8.664-30.53-13.306-62.732-13.306-96z",
						"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288c159.056 0 288-128.942 288-288s-128.942-288-288-288zM889.456 838.544c14.060 14.058 14.060 36.852 0 50.91-7.030 7.030-16.242 10.546-25.456 10.546s-18.426-3.516-25.456-10.544l-102.544-102.546-102.544 102.544c-7.030 7.030-16.242 10.546-25.456 10.546s-18.426-3.516-25.456-10.544c-14.060-14.058-14.060-36.852 0-50.91l102.546-102.546-102.544-102.544c-14.060-14.058-14.060-36.852 0-50.91 14.058-14.058 36.852-14.058 50.91 0l102.544 102.544 102.544-102.544c14.058-14.058 36.852-14.058 50.91 0 14.060 14.058 14.060 36.852 0 50.91l-102.544 102.544 102.546 102.544z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-cancel",
						"user",
						"user-remove",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60155,
					"grid": 16
				},
				{
					"id": 2329,
					"paths": [
						"M480 1024h-446.536c-8.986 0-17.558-3.78-23.622-10.412s-9.056-15.51-8.25-24.46c7.042-78.104 37.426-151.238 87.874-211.5 44.578-53.25 101.778-92.938 166.528-115.774l0.002-30.394c-35.944-24.612-66.358-59.274-88.638-101.218-25.748-48.48-39.358-104.582-39.358-162.242 0-80.058 25.892-155.586 72.906-212.676 48.5-58.892 113.524-91.324 183.094-91.324 135.644 0 247.91 125.834 255.58 286.474 0.844 17.654-12.784 32.648-30.436 33.49-17.698 0.838-32.646-12.786-33.49-30.438-6.040-126.462-90.224-225.526-191.654-225.526-105.87 0-192 107.664-192 240 0 93.25 43.958 178.862 111.986 218.104 9.908 5.714 16.012 16.284 16.010 27.72l-0.004 71.432c0 14.318-9.512 26.892-23.29 30.79-61.908 17.514-116.598 53.014-158.164 102.664-34.422 41.12-57.632 89.42-68.126 141.292h409.588c17.672 0 32 14.326 32 32s-14.326 31.998-32 31.998z",
						"M736 1024c-158.804 0-288-129.196-288-288s129.196-288 288-288 288 129.196 288 288-129.194 288-288 288zM736 512c-123.514 0-224 100.486-224 224s100.486 224 224 224 224-100.486 224-224-100.486-224-224-224z",
						"M781.254 736l105.374-105.374c12.498-12.496 12.498-32.758 0-45.254-12.496-12.496-32.758-12.496-45.254 0l-105.374 105.374-105.374-105.374c-12.496-12.496-32.758-12.496-45.254 0-12.498 12.496-12.498 32.758 0 45.254l105.374 105.374-105.374 105.374c-12.498 12.496-12.498 32.758 0 45.254 6.25 6.248 14.44 9.372 22.628 9.372s16.378-3.124 22.626-9.374l105.374-105.372 105.374 105.374c6.248 6.248 14.438 9.372 22.626 9.372s16.378-3.124 22.626-9.374c12.498-12.496 12.498-32.758 0-45.254l-105.372-105.372z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-cancel",
						"user",
						"user-remove",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60164,
					"grid": 16
				},
				{
					"id": 2323,
					"width": 1024,
					"paths": [
						"M960 608l-288 288-96-96-64 64 160 160 352-352z",
						"M448 768h320v-115.128c-67.22-39.2-156.308-66.11-256-74.26v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h448v-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-check",
						"user",
						"user-tick",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60158,
					"grid": 16
				},
				{
					"id": 2332,
					"paths": [
						"M416 1024h-382.536c-8.986 0-17.558-3.78-23.622-10.412s-9.056-15.51-8.25-24.46c7.042-78.104 37.426-151.238 87.874-211.5 44.578-53.25 101.778-92.938 166.528-115.774l0.002-30.394c-35.944-24.612-66.358-59.274-88.638-101.218-25.748-48.48-39.358-104.582-39.358-162.242 0-80.058 25.892-155.586 72.906-212.676 48.5-58.892 113.524-91.324 183.094-91.324s134.594 32.432 183.094 91.324c47.014 57.090 72.906 132.618 72.906 212.676 0 57.66-13.61 113.76-39.358 162.236-22.28 41.948-52.694 76.61-88.638 101.218l-0.004 40.55c-0.002 17.67-14.33 31.996-32 31.996-0.002 0 0 0-0.002 0-17.674-0.002-32-14.33-31.998-32.004l0.006-58.182c0-11.436 6.104-22 16.010-27.714 68.028-39.244 111.984-124.854 111.984-218.1 0-132.336-86.13-240-192-240s-192 107.664-192 240c0 93.25 43.958 178.862 111.986 218.104 9.908 5.714 16.012 16.284 16.010 27.72l-0.004 71.432c0 14.318-9.512 26.892-23.29 30.79-61.908 17.514-116.6 53.014-158.164 102.664-34.422 41.12-57.632 89.42-68.126 141.292h345.588c17.672 0 32 14.326 32 32s-14.326 31.998-32 31.998z",
						"M640 1024c-8.19 0-16.378-3.124-22.626-9.374l-128-128c-12.496-12.496-12.496-32.758 0-45.254 12.498-12.496 32.758-12.496 45.254 0l105.372 105.372 297.374-297.372c12.496-12.496 32.758-12.496 45.254 0 12.498 12.496 12.498 32.758 0 45.254l-320 320c-6.248 6.25-14.438 9.374-22.628 9.374z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-check",
						"user",
						"user-tick",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60167,
					"grid": 16
				},
				{
					"id": 2322,
					"paths": [
						"M976 704h-16v-64c0-70.58-57.422-128-128-128-70.58 0-128 57.42-128 128v64h-16c-26.4 0-48 21.6-48 48v224c0 26.4 21.6 48 48 48h288c26.398 0 48-21.6 48-48v-224c0-26.4-21.602-48-48-48zM768 640c0-35.29 28.708-64 64-64 35.29 0 64 28.71 64 64v64h-128v-64z",
						"M576 586.636c-20.748-3.528-42.114-6.236-64-8.026v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.75-384 124.422-384 253.39h576v-245.364z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-lock",
						"user",
						"user-private",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60157,
					"grid": 16
				},
				{
					"id": 2331,
					"paths": [
						"M480 1024h-446.536c-8.986 0-17.558-3.78-23.622-10.412s-9.056-15.51-8.25-24.46c7.042-78.104 37.426-151.238 87.874-211.5 44.578-53.25 101.778-92.938 166.528-115.774l0.002-30.394c-35.944-24.612-66.358-59.274-88.638-101.218-25.748-48.48-39.358-104.582-39.358-162.242 0-80.058 25.892-155.586 72.906-212.676 48.5-58.892 113.524-91.324 183.094-91.324s134.594 32.432 183.094 91.324c47.014 57.090 72.906 132.618 72.906 212.676 0 17.668-1.284 35.38-3.814 52.642-2.564 17.486-18.806 29.598-36.306 27.018-17.484-2.564-29.582-18.818-27.018-36.304 2.082-14.196 3.138-28.784 3.138-43.356 0-132.336-86.13-240-192-240s-192 107.664-192 240c0 93.25 43.958 178.862 111.986 218.104 9.908 5.714 16.012 16.284 16.010 27.72l-0.004 71.432c0 14.318-9.512 26.892-23.29 30.79-61.908 17.514-116.6 53.014-158.164 102.664-34.422 41.12-57.632 89.42-68.126 141.292h409.588c17.672 0 32 14.326 32 32s-14.326 31.998-32 31.998z",
						"M992 640h-32v-32c0-88.224-71.776-160-160-160s-160 71.776-160 160v32h-32c-17.674 0-32 14.326-32 32v320c0 17.674 14.326 32 32 32h384c17.674 0 32-14.326 32-32v-320c0-17.674-14.326-32-32-32zM704 608c0-52.934 43.066-96 96-96s96 43.066 96 96v32h-192v-32zM960 960h-320v-256h320v256z",
						"M800 896c-17.674 0-32-14.326-32-32v-64c0-17.674 14.326-32 32-32s32 14.326 32 32v64c0 17.674-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-lock",
						"user",
						"user-private",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60166,
					"grid": 16
				},
				{
					"id": 1392,
					"width": 804.5709991455078,
					"paths": [
						"M219.429 768q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857-10.857-25.714 10.857-25.714 25.714-10.857 25.714 10.857 10.857 25.714zM804.571 802.857q0 69.143-41.714 108.571t-110.857 39.429h-499.429q-69.143 0-110.857-39.429t-41.714-108.571q0-38.857 3.143-74.857t13.714-78.857 27.143-75.714 46.286-58.857 68.571-34.571q-12.571 29.714-12.571 68.571v116q-33.143 11.429-53.143 40t-20 63.429q0 45.714 32 77.714t77.714 32 77.714-32 32-77.714q0-34.857-20.286-63.429t-52.857-40v-116q0-35.429 14.286-53.143 75.429 59.429 168.571 59.429t168.571-59.429q14.286 17.714 14.286 53.143v36.571q-60.571 0-103.429 42.857t-42.857 103.429v50.857q-18.286 16.571-18.286 40.571 0 22.857 16 38.857t38.857 16 38.857-16 16-38.857q0-24-18.286-40.571v-50.857q0-29.714 21.714-51.429t51.429-21.714 51.429 21.714 21.714 51.429v50.857q-18.286 16.571-18.286 40.571 0 22.857 16 38.857t38.857 16 38.857-16 16-38.857q0-24-18.286-40.571v-50.857q0-38.857-19.714-72.857t-53.429-53.429q0-5.714 0.286-24.286t0-27.429-1.429-23.714-4-26.857-7.429-22.857q38.857 8.571 68.571 34.571t46.286 58.857 27.143 75.714 13.714 78.857 3.143 74.857zM621.714 292.571q0 90.857-64.286 155.143t-155.143 64.286-155.143-64.286-64.286-155.143 64.286-155.143 155.143-64.286 155.143 64.286 64.286 155.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-md"
					],
					"defaultCode": 61680,
					"grid": 14
				},
				{
					"id": 2319,
					"width": 1024,
					"paths": [
						"M384 736c0-151.234 95.874-280.486 230.032-330.2 16.28-36.538 25.968-77.164 25.968-117.8 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h397.306c-8.664-30.53-13.306-62.732-13.306-96z",
						"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288c159.056 0 288-128.942 288-288s-128.942-288-288-288zM896 768h-320v-64h320v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-minus",
						"user",
						"user-remove",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60154,
					"grid": 16
				},
				{
					"id": 2328,
					"paths": [
						"M480 1024h-446.536c-8.986 0-17.558-3.78-23.622-10.412s-9.056-15.51-8.25-24.46c7.042-78.104 37.426-151.238 87.874-211.5 44.578-53.25 101.778-92.938 166.528-115.774l0.002-30.394c-35.944-24.612-66.358-59.274-88.638-101.218-25.748-48.48-39.358-104.582-39.358-162.242 0-80.058 25.892-155.586 72.906-212.676 48.5-58.892 113.524-91.324 183.094-91.324 135.644 0 247.91 125.834 255.58 286.474 0.844 17.654-12.784 32.648-30.436 33.49-17.698 0.838-32.646-12.786-33.49-30.438-6.040-126.462-90.224-225.526-191.654-225.526-105.87 0-192 107.664-192 240 0 93.25 43.958 178.862 111.986 218.104 9.908 5.714 16.012 16.284 16.010 27.72l-0.004 71.432c0 14.318-9.512 26.892-23.29 30.79-61.908 17.514-116.598 53.014-158.164 102.664-34.422 41.12-57.632 89.42-68.126 141.292h409.588c17.672 0 32 14.326 32 32s-14.326 31.998-32 31.998z",
						"M736 1024c-158.804 0-288-129.196-288-288s129.196-288 288-288 288 129.196 288 288-129.194 288-288 288zM736 512c-123.514 0-224 100.486-224 224s100.486 224 224 224 224-100.486 224-224-100.486-224-224-224z",
						"M864 704h-256c-17.674 0-32 14.326-32 32s14.326 32 32 32h256c17.674 0 32-14.326 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-minus",
						"user",
						"user-remove",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60163,
					"grid": 16
				},
				{
					"id": 2318,
					"width": 1024,
					"paths": [
						"M384 736c0-151.234 95.874-280.486 230.032-330.2 16.28-36.538 25.968-77.164 25.968-117.8 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h397.306c-8.664-30.53-13.306-62.732-13.306-96z",
						"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288c159.056 0 288-128.942 288-288s-128.942-288-288-288zM896 768h-128v128h-64v-128h-128v-64h128v-128h64v128h128v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-plus",
						"user",
						"user-add",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60153,
					"grid": 16
				},
				{
					"id": 2327,
					"paths": [
						"M480 1024h-446.536c-8.986 0-17.558-3.78-23.622-10.412s-9.056-15.51-8.25-24.46c7.042-78.104 37.426-151.238 87.874-211.5 44.578-53.25 101.778-92.938 166.528-115.774l0.002-30.394c-35.944-24.612-66.358-59.274-88.638-101.218-25.748-48.48-39.358-104.582-39.358-162.242 0-80.058 25.892-155.586 72.906-212.676 48.5-58.892 113.524-91.324 183.094-91.324 135.644 0 247.91 125.834 255.58 286.474 0.844 17.654-12.784 32.648-30.436 33.49-17.698 0.838-32.646-12.786-33.49-30.438-6.040-126.462-90.224-225.526-191.654-225.526-105.87 0-192 107.664-192 240 0 93.25 43.958 178.862 111.986 218.104 9.908 5.714 16.012 16.284 16.010 27.72l-0.004 71.432c0 14.318-9.512 26.892-23.29 30.79-61.908 17.514-116.598 53.014-158.164 102.664-34.422 41.12-57.632 89.42-68.126 141.292h409.588c17.672 0 32 14.326 32 32s-14.326 31.998-32 31.998z",
						"M736 1024c-158.804 0-288-129.196-288-288s129.196-288 288-288 288 129.196 288 288-129.194 288-288 288zM736 512c-123.514 0-224 100.486-224 224s100.486 224 224 224 224-100.486 224-224-100.486-224-224-224z",
						"M864 704h-96v-96c0-17.674-14.326-32-32-32s-32 14.326-32 32v96h-96c-17.674 0-32 14.326-32 32s14.326 32 32 32h96v96c0 17.674 14.326 32 32 32s32-14.326 32-32v-96h96c17.674 0 32-14.326 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-plus",
						"user",
						"user-add",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60162,
					"grid": 16
				},
				{
					"id": 1692,
					"width": 1170.2870025634766,
					"paths": [
						"M402.286 512q-90.857 0-155.143-64.286t-64.286-155.143 64.286-155.143 155.143-64.286 155.143 64.286 64.286 155.143-64.286 155.143-155.143 64.286zM950.857 585.143h201.143q7.429 0 12.857 5.429t5.429 12.857v109.714q0 7.429-5.429 12.857t-12.857 5.429h-201.143v201.143q0 7.429-5.429 12.857t-12.857 5.429h-109.714q-7.429 0-12.857-5.429t-5.429-12.857v-201.143h-201.143q-7.429 0-12.857-5.429t-5.429-12.857v-109.714q0-7.429 5.429-12.857t12.857-5.429h201.143v-201.143q0-7.429 5.429-12.857t12.857-5.429h109.714q7.429 0 12.857 5.429t5.429 12.857v201.143zM530.286 713.143q0 29.714 21.714 51.429t51.429 21.714h146.286v136q-38.857 28.571-97.714 28.571h-499.429q-69.143 0-110.857-39.429t-41.714-108.571q0-30.286 2-59.143t8-62.286 15.143-62 24.571-55.714 35.429-46.286 48.857-30.571 63.714-11.429q10.857 0 22.286 9.714 45.143 34.857 88.286 52.286t94 17.429 94-17.429 88.286-52.286q11.429-9.714 22.286-9.714 75.429 0 124 54.857h-127.429q-29.714 0-51.429 21.714t-21.714 51.429v109.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-plus"
					],
					"defaultCode": 62004,
					"grid": 14
				},
				{
					"id": 1671,
					"width": 804.5750885009766,
					"paths": [
						"M329.143 877.714l54.857-256-54.857-73.143-73.143-36.571zM475.429 877.714l73.143-365.714-73.143 36.571-54.857 73.143zM566.857 300.571q-1.143-2.286-2.286-3.429-5.714-4.571-54.857-4.571-40 0-95.429 10.857-4 1.143-12 1.143t-12-1.143q-55.429-10.857-95.429-10.857-49.143 0-54.857 4.571-1.143 1.143-2.286 3.429 1.143 10.286 2.286 15.429 1.143 1.714 4.286 3.714t4.286 6q1.143 2.286 4.286 11.714t4 11.714 4.286 9.714 4.857 9.714 5.143 8 6.857 7.714 8 5.429 10 4.571 11.714 2.286 14 1.143q20.571 0 33.714-7.143t18.571-17.143 8.286-19.714 6.571-16.857 10-7.143h6.857q6.286 0 10 7.143t6.571 16.857 8.286 19.714 18.571 17.143 33.714 7.143q7.429 0 14-1.143t11.714-2.286 10-4.571 8-5.429 6.857-7.714 5.143-8 4.857-9.714 4.286-9.714 4-11.714 4.286-11.714q1.143-4 4.286-6t4.286-3.714q1.143-5.143 2.286-15.429zM804.571 802.857q0 69.143-41.714 108.571t-110.857 39.429h-499.429q-69.143 0-110.857-39.429t-41.714-108.571q0-34.857 2.571-67.429t10.857-71.714 21.429-70.571 36.286-59.143 53.429-42.571l-51.429-125.714h122.286q-12.571-36.571-12.571-73.143 0-6.857 1.143-18.286-110.857-22.857-110.857-54.857 0-32.571 120-56.571 9.714-35.429 29.429-76.571t40.286-65.143q18.286-21.143 43.429-21.143 17.143 0 48 17.714t48 17.714 48-17.714 48-17.714q25.143 0 43.429 21.143 20.571 24 40.286 65.143t29.429 76.571q120 24 120 56.571 0 32-110.857 54.857 4 46.286-11.429 91.429h122.286l-46.857 128.571q36 18.857 61.429 55.143t37.429 82 16.571 86.571 4.571 84.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-secret"
					],
					"defaultCode": 61979,
					"grid": 14
				},
				{
					"id": 2338,
					"paths": [
						"M320 192c0-106.039 85.961-192 192-192s192 85.961 192 192c0 106.039-85.961 192-192 192s-192-85.961-192-192zM768.078 448h-35.424l-199.104 404.244 74.45-372.244-96-96-96 96 74.45 372.244-199.102-404.244h-35.424c-127.924 0-127.924 85.986-127.924 192v320h768v-320c0-106.014 0-192-127.922-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-tie",
						"user",
						"user-employee",
						"profile",
						"avatar",
						"person",
						"member",
						"job",
						"official"
					],
					"defaultCode": 60173,
					"grid": 16
				},
				{
					"id": 1693,
					"width": 1165.1429595947266,
					"paths": [
						"M402.286 512q-90.857 0-155.143-64.286t-64.286-155.143 64.286-155.143 155.143-64.286 155.143 64.286 64.286 155.143-64.286 155.143-155.143 64.286zM1017.714 694.857l142.286 142.286q5.143 5.143 5.143 13.143 0 7.429-5.143 12.571l-77.714 77.714q-5.143 5.143-12.571 5.143-8 0-13.143-5.143l-142.286-142.286-142.286 142.286q-5.143 5.143-13.143 5.143-7.429 0-12.571-5.143l-77.714-77.714q-5.143-5.143-5.143-12.571 0-8 5.143-13.143l142.286-142.286-142.286-142.286q-5.143-5.143-5.143-13.143 0-7.429 5.143-12.571l77.714-77.714q5.143-5.143 12.571-5.143 8 0 13.143 5.143l142.286 142.286 142.286-142.286q5.143-5.143 13.143-5.143 7.429 0 12.571 5.143l77.714 77.714q5.143 5.143 5.143 12.571 0 8-5.143 13.143zM733.143 694.857l-103.429 103.429q-21.143 21.143-21.143 52 0 30.286 21.143 51.429l47.429 47.429q-12 1.714-25.143 1.714h-499.429q-69.143 0-110.857-39.429t-41.714-108.571q0-30.286 2-59.143t8-62.286 15.143-62 24.571-55.714 35.429-46.286 48.857-30.571 63.714-11.429q10.857 0 22.286 9.714 88 69.714 182.286 69.714t182.286-69.714q11.429-9.714 22.286-9.714 16 0 32.571 3.429-16 15.429-23.429 28.571t-7.429 32q0 30.857 21.143 52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user-times"
					],
					"defaultCode": 62005,
					"grid": 14
				},
				{
					"id": 2325,
					"paths": [
						"M862.538 1024h-701.074c-8.986 0-17.558-3.78-23.622-10.412s-9.056-15.51-8.25-24.46c7.042-78.104 37.426-151.238 87.874-211.5 44.578-53.25 101.778-92.938 166.528-115.774l0.002-30.394c-35.944-24.612-66.358-59.274-88.638-101.218-25.748-48.48-39.358-104.582-39.358-162.242 0-80.058 25.892-155.586 72.906-212.676 48.5-58.892 113.524-91.324 183.094-91.324s134.594 32.432 183.094 91.324c47.014 57.090 72.906 132.618 72.906 212.676 0 57.66-13.61 113.76-39.358 162.236-22.28 41.944-52.694 76.608-88.636 101.216l0.002 30.4c64.75 22.836 121.95 62.524 166.528 115.774 50.446 60.262 80.832 133.396 87.874 211.5 0.806 8.952-2.188 17.828-8.25 24.46s-14.636 10.414-23.622 10.414zM198.414 960h627.174c-10.496-51.872-33.706-100.172-68.126-141.292-41.564-49.65-96.256-85.15-158.162-102.664-13.778-3.896-23.29-16.47-23.29-30.79l-0.004-71.436c0-11.438 6.104-22.006 16.010-27.72 68.028-39.242 111.984-124.852 111.984-218.098 0-132.336-86.13-240-192-240s-192 107.664-192 240c0 93.25 43.958 178.862 111.986 218.104 9.908 5.714 16.012 16.284 16.010 27.72l-0.004 71.432c0 14.318-9.512 26.892-23.29 30.79-61.908 17.514-116.598 53.014-158.164 102.664-34.42 41.118-57.63 89.418-68.124 141.29z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60160,
					"grid": 16
				},
				{
					"id": 2333,
					"paths": [
						"M256 320c0-141.385 114.615-256 256-256s256 114.615 256 256c0 141.385-114.615 256-256 256s-256-114.615-256-256zM768 640h-512c-141.384 0-256 114.618-256 256v64h1024v-64c0-141.382-114.616-256-256-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60168,
					"grid": 16
				},
				{
					"id": 2334,
					"paths": [
						"M512 128c105.87 0 192 86.13 192 192s-86.13 192-192 192-192-86.13-192-192 86.13-192 192-192zM512 64c-141.384 0-256 114.616-256 256s114.616 256 256 256 256-114.616 256-256-114.616-256-256-256v0zM768 704c105.87 0 192 86.13 192 192h-896c0-105.87 86.13-192 192-192h512zM768 640h-512c-141.384 0-256 114.618-256 256v64h1024v-64c0-141.382-114.616-256-256-256v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60169,
					"grid": 16
				},
				{
					"id": 2335,
					"paths": [
						"M512 576c141.384 0 256-114.616 256-256s-114.616-256-256-256-256 114.616-256 256 114.616 256 256 256zM320 320c0-2.68 0.070-5.346 0.18-8h383.64c0.11 2.654 0.18 5.32 0.18 8s-0.070 5.346-0.18 8h-383.64c-0.11-2.654-0.18-5.32-0.18-8zM376.606 184h270.79c5.080 5.058 9.874 10.404 14.368 16h-299.524c4.492-5.596 9.284-10.942 14.366-16zM394.842 168c7.662-5.92 15.782-11.274 24.298-16h185.718c8.516 4.726 16.636 10.080 24.298 16h-234.314zM673.322 216c3.344 5.168 6.446 10.506 9.29 16h-341.224c2.844-5.494 5.946-10.832 9.29-16h322.644zM689.978 248c2.122 5.224 4.022 10.56 5.684 16h-367.324c1.662-5.44 3.562-10.776 5.682-16h355.958zM699.796 280c1.12 5.258 2.030 10.594 2.706 16h-381.004c0.678-5.406 1.586-10.742 2.706-16h375.592zM702.502 344c-0.676 5.406-1.586 10.742-2.706 16h-375.592c-1.12-5.258-2.028-10.594-2.706-16h381.004zM695.662 376c-1.662 5.44-3.562 10.776-5.684 16h-355.956c-2.122-5.224-4.020-10.56-5.682-16h367.322zM682.612 408c-2.844 5.494-5.946 10.832-9.29 16h-322.644c-3.344-5.168-6.446-10.506-9.29-16h341.224zM647.394 456h-270.788c-5.082-5.058-9.874-10.404-14.366-16h299.522c-4.494 5.596-9.288 10.942-14.368 16zM629.158 472c-7.662 5.92-15.784 11.274-24.298 16h-185.72c-8.516-4.726-16.636-10.080-24.298-16h234.316zM457.136 504h109.726c-17.39 5.196-35.804 8-54.864 8s-37.47-2.804-54.862-8zM566.864 136h-109.726c17.392-5.196 35.804-8 54.864-8s37.47 2.804 54.862 8zM768 640h-512c-141.384 0-256 114.618-256 256v64h1024v-64c0-141.382-114.616-256-256-256zM120.606 760h782.79c5.080 5.058 9.874 10.404 14.368 16h-811.524c4.492-5.596 9.284-10.942 14.366-16zM138.842 744c7.662-5.92 15.782-11.274 24.298-16h697.72c8.516 4.726 16.636 10.080 24.298 16h-746.316zM929.322 792c3.344 5.168 6.446 10.508 9.29 16h-853.224c2.844-5.492 5.946-10.832 9.29-16h834.644zM945.978 824c2.122 5.224 4.022 10.56 5.684 16h-879.324c1.662-5.44 3.562-10.776 5.682-16h867.958zM955.796 856c1.12 5.258 2.030 10.594 2.706 16h-893.004c0.678-5.406 1.586-10.742 2.706-16h887.592zM768 704c19.058 0 37.472 2.804 54.864 8h-621.728c17.392-5.196 35.804-8 54.864-8h512zM64 896c0-2.682 0.070-5.346 0.18-8h895.64c0.11 2.654 0.18 5.318 0.18 8h-896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user",
						"profile",
						"avatar",
						"person",
						"member",
						"dualtone"
					],
					"defaultCode": 60170,
					"grid": 16
				},
				{
					"id": 2336,
					"paths": [
						"M736 352c0 159.058-100.288 288-224 288s-224-128.942-224-288c0-159.058 100.288-288 224-288s224 128.942 224 288z",
						"M448 571h128v133h-128v-133z",
						"M64 768c0-70.694 200.576-128 448-128s448 57.306 448 128z",
						"M64 768h896v128h-896v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60171,
					"grid": 16
				},
				{
					"id": 2339,
					"paths": [
						"M320 256c0-106.039 85.961-192 192-192s192 85.961 192 192c0 106.039-85.961 192-192 192s-192-85.961-192-192zM512 512c-212.078 0-384 200.578-384 448h128c0-176.73 114.614-320 256-320 141.382 0 256 143.27 256 320h128c0-247.422-171.924-448-384-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 60174,
					"grid": 16
				},
				{
					"id": 1186,
					"width": 804.5709991455078,
					"paths": [
						"M804.571 802.857q0 68.571-41.714 108.286t-110.857 39.714h-499.429q-69.143 0-110.857-39.714t-41.714-108.286q0-30.286 2-59.143t8-62.286 15.143-62 24.571-55.714 35.429-46.286 48.857-30.571 63.714-11.429q5.143 0 24 12.286t42.571 27.429 61.714 27.429 76.286 12.286 76.286-12.286 61.714-27.429 42.571-27.429 24-12.286q34.857 0 63.714 11.429t48.857 30.571 35.429 46.286 24.571 55.714 15.143 62 8 62.286 2 59.143zM621.714 292.571q0 90.857-64.286 155.143t-155.143 64.286-155.143-64.286-64.286-155.143 64.286-155.143 155.143-64.286 155.143 64.286 64.286 155.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user"
					],
					"defaultCode": 61447,
					"grid": 14
				},
				{
					"id": 137,
					"paths": [
						"M486.4 563.2c-155.275 0-281.6-126.325-281.6-281.6s126.325-281.6 281.6-281.6 281.6 126.325 281.6 281.6-126.325 281.6-281.6 281.6zM486.4 51.2c-127.043 0-230.4 103.357-230.4 230.4s103.357 230.4 230.4 230.4c127.042 0 230.4-103.357 230.4-230.4s-103.358-230.4-230.4-230.4z",
						"M896 1024h-819.2c-42.347 0-76.8-34.451-76.8-76.8 0-3.485 0.712-86.285 62.72-168.96 36.094-48.126 85.514-86.36 146.883-113.634 74.957-33.314 168.085-50.206 276.797-50.206 108.71 0 201.838 16.893 276.797 50.206 61.37 27.275 110.789 65.507 146.883 113.634 62.008 82.675 62.72 165.475 62.72 168.96 0 42.349-34.451 76.8-76.8 76.8zM486.4 665.6c-178.52 0-310.267 48.789-381 141.093-53.011 69.174-54.195 139.904-54.2 140.61 0 14.013 11.485 25.498 25.6 25.498h819.2c14.115 0 25.6-11.485 25.6-25.6-0.006-0.603-1.189-71.333-54.198-140.507-70.734-92.304-202.483-141.093-381.002-141.093z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"user",
						"persona",
						"profile",
						"avatar"
					],
					"defaultCode": 59434,
					"grid": 20
				},
				{
					"id": 2317,
					"width": 1152,
					"paths": [
						"M768 770.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z",
						"M327.196 795.328c55.31-36.15 124.080-63.636 199.788-80.414-15.054-17.784-28.708-37.622-40.492-59.020-30.414-55.234-46.492-116.058-46.492-175.894 0-86.042 0-167.31 30.6-233.762 29.706-64.504 83.128-104.496 159.222-119.488-16.914-76.48-61.94-126.75-181.822-126.75-192 0-192 128.942-192 288 0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h279.006c14.518-12.91 30.596-25.172 48.19-36.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"users",
						"group",
						"team",
						"members",
						"community",
						"collaborate"
					],
					"defaultCode": 60152,
					"grid": 16
				},
				{
					"id": 2324,
					"width": 1152,
					"paths": [
						"M768 770.614v-52.782c70.496-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.782c-217.102 17.746-384 124.418-384 253.386h896c0-128.968-166.898-235.64-384-253.386z",
						"M207.498 616c-13.554 4.938-26.606 10.284-39.116 16h306.044c-2.456-5.294-4.79-10.628-6.99-16h-259.938z",
						"M27.2 744c-3.366 5.254-6.438 10.59-9.208 16h373.4c12.264-5.682 24.928-11.022 37.958-16h-402.15z",
						"M87.52 680c-6.71 5.188-13.088 10.524-19.112 16h443.694c-3.82-5.202-7.53-10.532-11.108-16h-413.474z",
						"M336.676 584c-27.154 3.968-53.32 9.344-78.23 16h202.854c-1.9-5.306-3.67-10.64-5.32-16h-119.304z",
						"M384 552v16h67.426c-1.378-5.316-2.614-10.652-3.746-16h-63.68z",
						"M374.466 520c3.152 2.048 6.326 4.024 9.536 5.832v10.168h60.63c-0.876-5.326-1.588-10.662-2.218-16h-67.948z",
						"M1.946 808c-0.862 5.288-1.416 10.624-1.704 16h288.084c6.556-5.46 13.394-10.798 20.526-16h-306.906z",
						"M109.986 664h381.106c-1.562-2.676-3.096-5.376-4.598-8.106-1.44-2.616-2.818-5.254-4.192-7.894h-345.738c-9.252 5.114-18.122 10.452-26.578 16z",
						"M256.34 232c-0.098 5.282-0.166 10.618-0.216 16h213.696c0.264-0.586 0.512-1.178 0.782-1.762 2.252-4.892 4.66-9.628 7.186-14.238h-221.448z",
						"M10.782 776c-2.060 5.274-3.842 10.608-5.322 16h326.984c8.732-5.54 17.75-10.89 27.1-16h-348.762z",
						"M297.16 56h301.654c-4.488-5.72-9.462-11.068-14.986-16h-271.662c-5.526 4.936-10.514 10.276-15.006 16z",
						"M38.546 728h438.050c16.396-4.888 33.202-9.278 50.39-13.086-0.81-0.958-1.6-1.946-2.404-2.914h-472.378c-4.866 5.228-9.424 10.564-13.658 16z",
						"M336.34 488c5.438 5.694 11.048 11.046 16.822 16h87.716c-0.378-5.336-0.616-10.67-0.744-16h-103.794z",
						"M310.266 456c3.854 5.524 7.852 10.872 12.002 16h117.734c0.002-5.354 0.008-10.688 0.024-16h-129.76z",
						"M272.352 104c-1.698 5.182-3.216 10.52-4.58 16h360.458c-1.364-5.486-2.902-10.812-4.602-16h-351.276z",
						"M264.302 136c-0.982 5.226-1.852 10.558-2.616 16h296.024c11.48-6.244 23.802-11.582 36.966-16h-330.374z",
						"M257.386 200c-0.262 5.272-0.48 10.602-0.652 16h230.738c3.722-5.576 7.678-10.908 11.862-16h-241.948z",
						"M259.756 168c-0.54 5.25-1.002 10.586-1.396 16h255.65c5.878-5.714 12.116-11.048 18.712-16h-272.966z",
						"M375.446 8c-15.558 3.962-29.090 9.342-40.86 16h226.826c-11.78-6.666-25.348-12.036-40.928-16h-145.038z",
						"M290.816 424c2.872 5.456 5.888 10.792 9.042 16h140.258c0.048-5.36 0.116-10.694 0.21-16h-149.51z",
						"M286.394 72c-2.942 5.11-5.602 10.446-8.002 16h339.206c-2.4-5.556-5.070-10.888-8.012-16h-323.192z",
						"M265.736 360c1.44 5.384 3.040 10.718 4.768 16h171.696c0.352-5.376 0.766-10.708 1.242-16h-177.706z",
						"M276.234 392c2.106 5.414 4.356 10.75 6.746 16h157.726c0.16-5.368 0.36-10.7 0.604-16h-165.076z",
						"M256.026 264c-0.016 5.294-0.024 10.628-0.026 16h201.92c1.63-5.412 3.41-10.746 5.352-16h-207.246z",
						"M256.146 296c0.166 5.342 0.512 10.676 0.998 16h192.916c1.052-5.398 2.228-10.728 3.514-16h-197.428z",
						"M259.072 328c0.806 5.36 1.742 10.698 2.848 16h183.186c0.642-5.382 1.36-10.718 2.172-16h-188.206z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"users",
						"group",
						"team",
						"members",
						"community",
						"collaborate",
						"dualtone"
					],
					"defaultCode": 60159,
					"grid": 16
				},
				{
					"id": 2326,
					"paths": [
						"M990.538 1024h-701.074c-8.986 0-17.558-3.78-23.622-10.412s-9.056-15.51-8.25-24.46c7.042-78.104 37.426-151.238 87.874-211.5 44.578-53.25 101.778-92.938 166.528-115.774l0.002-30.394c-35.944-24.612-66.358-59.274-88.638-101.218-25.748-48.48-39.358-104.582-39.358-162.242 0-80.058 25.892-155.586 72.906-212.676 48.5-58.892 113.524-91.324 183.094-91.324s134.594 32.432 183.094 91.324c47.014 57.090 72.906 132.618 72.906 212.676 0 57.66-13.61 113.76-39.358 162.236-22.28 41.944-52.694 76.608-88.636 101.216l0.002 30.4c64.75 22.836 121.95 62.524 166.528 115.774 50.446 60.262 80.832 133.396 87.874 211.5 0.806 8.952-2.188 17.828-8.25 24.46s-14.636 10.414-23.622 10.414zM326.414 960h627.174c-10.496-51.872-33.706-100.172-68.126-141.292-41.564-49.65-96.256-85.15-158.162-102.664-13.778-3.896-23.29-16.47-23.29-30.79l-0.004-71.436c0-11.438 6.104-22.006 16.010-27.72 68.028-39.242 111.984-124.852 111.984-218.098 0-132.336-86.13-240-192-240s-192 107.664-192 240c0 93.25 43.958 178.862 111.986 218.104 9.908 5.714 16.012 16.284 16.010 27.72l-0.004 71.432c0 14.318-9.512 26.892-23.29 30.79-61.906 17.514-116.598 53.014-158.164 102.664-34.42 41.118-57.63 89.418-68.124 141.29z",
						"M290.258 731.41c33.066-39.498 72.372-72.95 116.070-99.074-17.724-20.598-33.396-43.546-46.554-68.322-31.254-58.842-47.774-126.622-47.774-196.014 0-96.714 31.724-188.5 89.328-258.448 27.458-33.344 59.244-60.090 94.016-79.6-34.228-19.606-72.060-29.952-111.344-29.952-69.572 0-134.594 32.432-183.094 91.324-47.014 57.090-72.906 132.618-72.906 212.676 0 57.66 13.61 113.762 39.358 162.24 22.28 41.946 52.694 76.608 88.638 101.218l-0.002 30.394c-64.75 22.836-121.95 62.524-166.528 115.774-50.446 60.262-80.832 133.398-87.874 211.5-0.806 8.952 2.188 17.828 8.25 24.46s14.636 10.414 23.622 10.414h155.048c11.826-84.254 46.734-162.876 101.746-228.59z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"users",
						"group",
						"team",
						"members",
						"community",
						"collaborate"
					],
					"defaultCode": 60161,
					"grid": 16
				},
				{
					"id": 2337,
					"width": 1408,
					"paths": [
						"M768 705.306v-13.256c92.524-35.408 160-145.59 160-276.050 0-159.058-100.29-288-224-288-123.712 0-224 128.942-224 288 0 130.46 67.476 240.642 160 276.050v13.256c-217.102 8.874-384 62.21-384 126.694v128h896v-128c0-64.484-166.898-117.82-384-126.694z",
						"M1152 448.592v-5.078c73.032-20.754 128-111.146 128-219.514 0-123.712-71.634-224-160-224s-160 100.288-160 224c0 108.37 54.968 198.76 128 219.514v5.078c-31.81 1.172-62.054 4.074-89.878 8.412-6.28 68.208-28.092 131.24-61.738 182.996h471.616v-96c0-49.414-112.006-90.1-256-95.408z",
						"M409.878 457.004c-27.824-4.338-58.070-7.24-89.878-8.412v-5.078c73.032-20.754 128-111.146 128-219.514 0-123.712-71.634-224-160-224s-160 100.288-160 224c0 108.37 54.968 198.76 128 219.514v5.078c-143.994 5.308-256 45.994-256 95.408v96h471.618c-33.646-51.756-55.458-114.788-61.74-182.996z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"users",
						"group",
						"team",
						"members",
						"community",
						"collaborate"
					],
					"defaultCode": 60172,
					"grid": 16
				},
				{
					"id": 2340,
					"paths": [
						"M192 384c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM576 192c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM320 576c-176.73 0-320 171.922-320 384h96c0-40.942 6.624-80.494 19.688-117.558 12.31-34.922 29.732-66.046 51.788-92.514 41.878-50.252 96.044-77.928 152.524-77.928s110.648 27.676 152.526 77.928c22.054 26.466 39.478 57.592 51.788 92.514 13.064 37.064 19.686 76.616 19.686 117.558h96c0-212.078-143.268-384-320-384zM704 384c-94.176 0-178.846 48.826-237.402 126.528 7.196 3.118 14.336 6.456 21.41 10.044 21.754 11.042 42.48 24.094 62.074 39.070 0.466-0.57 0.924-1.15 1.394-1.714 41.878-50.252 96.046-77.928 152.524-77.928 56.48 0 110.648 27.676 152.526 77.928 22.054 26.466 39.478 57.592 51.788 92.514 13.064 37.064 19.686 76.616 19.686 117.558h96c0-212.078-143.268-384-320-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"users",
						"group",
						"team",
						"members",
						"community",
						"collaborate"
					],
					"defaultCode": 60175,
					"grid": 16
				},
				{
					"id": 138,
					"paths": [
						"M947.2 921.6h-563.2c-42.347 0-76.8-34.453-76.8-76.8 0-2.461 0.538-60.952 47.331-118.544 26.883-33.088 63.541-59.31 108.952-77.941 54.856-22.504 122.858-33.915 202.117-33.915s147.261 11.411 202.117 33.915c45.411 18.63 82.067 44.853 108.952 77.941 46.794 57.592 47.331 116.083 47.331 118.544 0 42.347-34.453 76.8-76.8 76.8zM358.4 844.931c0.072 14.056 11.528 25.469 25.6 25.469h563.2c14.072 0 25.528-11.413 25.6-25.469-0.048-1.786-1.656-45.802-37.851-88.786-49.88-59.235-143.019-90.546-269.349-90.546s-219.469 31.31-269.349 90.546c-36.194 42.984-37.803 87-37.851 88.786z",
						"M665.6 563.2c-112.926 0-204.8-91.874-204.8-204.8 0-112.928 91.874-204.8 204.8-204.8s204.8 91.872 204.8 204.8c0 112.926-91.874 204.8-204.8 204.8zM665.6 204.8c-84.696 0-153.6 68.904-153.6 153.6s68.904 153.6 153.6 153.6 153.6-68.904 153.6-153.6-68.904-153.6-153.6-153.6z",
						"M230.4 921.6h-153.6c-42.347 0-76.8-34.451-76.8-76.8 0-1.915 0.386-47.446 33.92-92.16 19.373-25.832 45.778-46.299 78.483-60.834 39.126-17.389 87.438-26.206 143.597-26.206 9.16 0 18.232 0.235 26.962 0.701 14.118 0.754 24.954 12.81 24.2 26.928-0.752 14.117-12.781 24.96-26.928 24.2-7.826-0.418-15.979-0.629-24.234-0.629-199.366 0-204.666 121.826-204.8 128.131 0.072 14.054 11.528 25.469 25.6 25.469h153.6c14.138 0 25.6 11.461 25.6 25.6s-11.462 25.6-25.6 25.6z",
						"M256 614.4c-84.696 0-153.6-68.904-153.6-153.6s68.904-153.6 153.6-153.6 153.6 68.904 153.6 153.6-68.904 153.6-153.6 153.6zM256 358.4c-56.464 0-102.4 45.936-102.4 102.4s45.936 102.4 102.4 102.4 102.4-45.936 102.4-102.4c0-56.464-45.936-102.4-102.4-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"users",
						"group",
						"team",
						"people"
					],
					"defaultCode": 59435,
					"grid": 20
				},
				{
					"id": 2342,
					"paths": [
						"M896 192h-768c-70.4 0-128 57.6-128 128v448c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-448c0-70.4-57.6-128-128-128zM128 768c0-141.382 71.634-256 160-256-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96c88.366 0 160 114.618 160 256h-320zM896 768h-320v-64h320v64zM896 640h-320v-64h320v64zM896 512h-320v-64h320v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vcard",
						"card",
						"contact"
					],
					"defaultCode": 60177,
					"grid": 16
				},
				{
					"id": 3220,
					"paths": [
						"M320 320v149.696c-120.244 152.508-192 345.022-192 554.304h64c0-112.348 21.99-221.3 65.356-323.832 28.632-67.696 65.73-130.676 110.732-188.168h143.912v-143.912c57.492-45.002 120.472-82.098 188.168-110.732 102.532-43.366 211.484-65.356 323.832-65.356v-64c-209.282 0-401.798 71.756-554.304 192h-149.696zM320 960h128v64h-128v-64zM576 960h128v64h-128v-64zM960 832v128h-128v64h192v-192h-64zM960 320h64v128h-64v-128zM960 576h64v128h-64v-128z",
						"M64 320c-35.346 0-64 28.654-64 64s28.654 64 64 64v576h64v-640c0-35.346-28.654-64-64-64z",
						"M448 64c0-35.346-28.654-64-64-64s-64 28.654-64 64 28.654 64 64 64h640v-64h-576z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vector",
						"bezier",
						"curve",
						"path"
					],
					"defaultCode": 61055,
					"grid": 16
				},
				{
					"id": 3221,
					"paths": [
						"M744.666 512c28.152-17.602 52.794-38.784 73.794-63.572 52.706-62.218 72.090-134.9 78.246-192.428h63.294v-192h-192v192h64.036c-5.904 46.752-22.172 103.784-62.768 151.482-43.742 51.396-108.552 83.982-193.268 97.424v-56.906h-192v64h-256c0-35.346-28.654-64-64-64s-64 28.654-64 64v64h215.334c-28.152 17.602-52.794 38.784-73.794 63.572-52.704 62.216-72.096 134.9-78.254 192.428h-63.286v192h192v-192h-64.036c5.906-46.754 22.172-103.784 62.768-151.482 43.742-51.398 108.554-83.986 193.268-97.43v56.912h192v-64h320c0 35.346 28.654 64 64 64s64-28.654 64-64v-64h-279.334zM832 192v-64h64v64h-64zM128 896v64h-64v-64h64zM512 576h-64v-64h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vector",
						"bezier",
						"curve",
						"path"
					],
					"defaultCode": 61056,
					"grid": 16
				},
				{
					"id": 1675,
					"width": 652.5710144042969,
					"paths": [
						"M658.286 329.143q0 126.286-84.286 219.714t-208.286 107.143v148.571h128q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-128v128q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-128h-128q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h128v-148.571q-85.714-9.143-155.143-58.857t-106.286-128-30-166.857q6.286-76.571 46-142.286t104-107.429 140.286-50.286q97.143-10.857 182.286 30.857t134.857 121.143 49.714 174.857zM73.143 329.143q0 105.714 75.143 180.857t180.857 75.143 180.857-75.143 75.143-180.857-75.143-180.857-180.857-75.143-180.857 75.143-75.143 180.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"venus"
					],
					"defaultCode": 61985,
					"grid": 14
				},
				{
					"id": 1680,
					"width": 1023.9989318847656,
					"paths": [
						"M1022.857 302.286q6.857 88.571-30 166.857t-106.286 128-155.143 58.857v148.571h128q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-128v128q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-128h-292.571v128q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-128h-128q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h128v-148.571q-85.714-9.143-155.143-58.857t-106.286-128-30-166.857q9.714-117.714 94-203.714t201.429-96.857q117.714-12 215.429 53.714 97.714-65.714 215.429-53.714 117.143 10.857 201.429 96.857t94 203.714zM512 508q73.143-74.857 73.143-178.857t-73.143-178.857q-73.143 74.857-73.143 178.857t73.143 178.857zM329.143 585.143q65.714 0 124.571-32.571-88-94.286-88-223.429 0-128 88-223.429-58.857-32.571-124.571-32.571-105.714 0-180.857 75.143t-75.143 180.857 75.143 180.857 180.857 75.143zM658.286 804.571v-148.571q-78.286-8.571-146.286-53.714-68 45.143-146.286 53.714v148.571h292.571zM694.857 585.143q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143q-65.714 0-124.571 32.571 88 95.429 88 223.429 0 129.143-88 223.429 58.857 32.571 124.571 32.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"venus-double"
					],
					"defaultCode": 61990,
					"grid": 14
				},
				{
					"id": 1682,
					"width": 1160.5712280273438,
					"paths": [
						"M950.857 18.286q0-8 5.143-13.143t13.143-5.143h164.571q14.857 0 25.714 10.857t10.857 25.714v164.571q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-76.571l-145.143 145.714q43.429 54.286 61.429 122.286t5.429 141.143q-18.286 102.857-94 177.143t-179.143 89.714q-127.429 19.429-233.714-51.429-66.857 44.571-146.286 53.143v75.429h54.857q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143h-54.857v54.857q0 8-5.143 13.143t-13.143 5.143h-36.571q-8 0-13.143-5.143t-5.143-13.143v-54.857h-54.857q-8 0-13.143-5.143t-5.143-13.143v-36.571q0-8 5.143-13.143t13.143-5.143h54.857v-75.429q-88.571-9.714-159.714-62.571t-106.857-135.714-22.571-175.429q14.286-106.857 91.143-184.286t183.143-94q128-19.429 234.286 51.429 83.429-55.429 182.857-55.429 114.857 0 205.143 72l145.714-145.143h-76.571q-8 0-13.143-5.143t-5.143-13.143v-36.571zM512 654.286q73.143-74.857 73.143-178.857t-73.143-178.857q-73.143 74.857-73.143 178.857t73.143 178.857zM73.143 475.429q0 105.714 75.143 180.857t180.857 75.143q66.857 0 124.571-32.571-88-95.429-88-223.429t88-223.429q-57.714-32.571-124.571-32.571-105.714 0-180.857 75.143t-75.143 180.857zM694.857 731.429q105.714 0 180.857-75.143t75.143-180.857-75.143-180.857-180.857-75.143q-66.857 0-124.571 32.571 88 95.429 88 223.429t-88 223.429q57.714 32.571 124.571 32.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"venus-mars"
					],
					"defaultCode": 61992,
					"grid": 14
				},
				{
					"id": 1695,
					"width": 877.7139892578125,
					"paths": [
						"M877.714 0l-109.714 256h109.714v109.714h-156.571l-31.429 73.143h188v109.714h-234.857l-204 475.429-204-475.429h-234.857v-109.714h188l-31.429-73.143h-156.571v-109.714h109.714l-109.714-256h146.286l184.571 438.857h216l184.571-438.857h146.286zM438.857 694.857l61.714-146.286h-123.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"viacoin"
					],
					"defaultCode": 62007,
					"grid": 14
				},
				{
					"id": 1802,
					"width": 730.2849731445312,
					"paths": [
						"M600 632q0 122.857-84 213.714-84.571 92-216 92-132.571 0-216-92-84-90.857-84-213.714 0-84 38.857-154.571t108-112.286 153.143-41.714q54.857 0 104 17.714-18.286 35.429-22.286 72-37.714-16-81.714-16-95.429 0-160.286 70.286t-64.857 166.286q0 97.143 64.286 164.857t160.857 67.714 160.571-67.714 64-164.857q0-50.857-18.286-94.857 37.714-7.429 70.286-28 23.429 56 23.429 121.143zM483.429 524q0 109.714-45.429 197.143t-136.286 144.571l-8 0.571q-16.571 0-35.429-2.857 47.429-18.286 83.714-58.571t56.857-88.286 33.429-108 17.143-110 4.286-102q0-39.429-1.714-58.857 31.429 91.429 31.429 186.286zM452 336.571v1.143q-41.714-122.286-117.714-251.429 50.286 33.714 81.429 106.571t36.286 143.714zM591.429 452.571q-47.429 0-91.429-42.857 124.571-68.571 165.714-141.143 10.857-21.143 12-32-24 53.714-79.714 95.143t-116.857 55.714q-20-30.857-20-64.571 0-21.143 9.714-45.143t24.571-38.857q26.286-25.143 89.714-42.286 33.714-9.143 60.571-33.429t42.286-57.429q42.286 60 42.286 144.571 0 62.286-13.714 97.143-18.286 44-50.571 74.571t-74.571 30.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"viadeo"
					],
					"defaultCode": 62121,
					"grid": 14
				},
				{
					"id": 1803,
					"width": 877.7129821777344,
					"paths": [
						"M600 594.857q0-44.571-16-84-23.429 14.286-48.571 19.429 12.571 28.571 12.571 65.143 0 66.857-44 113.429t-110.286 46.571-110.571-46.571-44.286-113.429q0-65.714 44.571-114t110.286-48.286q30.286 0 56 10.857 2.286-24.571 15.429-49.714-34.286-12-71.429-12-88 0-147.143 62t-59.143 150.571 59.143 149.143 147.143 60.571 147.143-60.857 59.143-148.857zM498.286 392q1.143 13.714 1.143 40.571 0 36-2.857 70.286t-11.714 75.714-23.143 74.286-39.143 60.571-57.429 40.286q12 1.714 24 1.714h5.714q125.143-79.429 125.143-234.857 0-66.286-21.714-128.571zM498.286 392q-2.286-45.714-25.143-98t-56-74.571q52.571 89.143 81.143 172.571zM689.714 332q0-58.286-29.143-99.429-23.429 49.143-70.857 62.286-39.429 10.857-62.286 30.571t-22.857 56.857q0 22.857 13.714 44 42.286-9.714 80.286-38.286t54.571-65.714q-2.286 29.714-42.571 63.714t-79.143 55.714q29.714 29.714 62.857 29.714 29.143 0 51.429-21.143t34.286-51.429q9.714-24.571 9.714-66.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"viadeo-square"
					],
					"defaultCode": 62122,
					"grid": 14
				},
				{
					"id": 1911,
					"paths": [
						"M384 288c0-88.366 71.634-160 160-160s160 71.634 160 160c0 88.366-71.634 160-160 160s-160-71.634-160-160zM0 288c0-88.366 71.634-160 160-160s160 71.634 160 160c0 88.366-71.634 160-160 160s-160-71.634-160-160zM768 608v-96c0-35.2-28.8-64-64-64h-640c-35.2 0-64 28.8-64 64v320c0 35.2 28.8 64 64 64h640c35.2 0 64-28.8 64-64v-96l256 160v-448l-256 160zM640 768h-512v-192h512v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"video-camera",
						"video",
						"media",
						"film",
						"movie"
					],
					"defaultCode": 59746,
					"grid": 16
				},
				{
					"id": 1913,
					"paths": [
						"M96 192c-52.8 0-96 43.2-96 96v448c0 23.126 8.29 44.412 22.042 61.032l403.354-605.032h-329.396z",
						"M978.84 256.252c-10.588 0-21.458 3.722-31.438 10.766l-179.402 126.614v-105.632c0-52.8-43.202-96-96-96h-16.978l88.916-133.374-79.876-53.252-640 960 79.876 53.25 124.418-186.624h443.644c52.798 0 96-43.2 96-96v-105.628l179.4 126.614c9.978 7.042 20.85 10.764 31.436 10.766 0.002 0 0.002 0 0.006 0 14.088 0 26.954-6.496 35.292-17.822 6.458-8.77 9.87-20.052 9.87-32.634v-410.586c-0.004-33.126-22.722-50.458-45.164-50.458z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"video-camera-slash",
						"video",
						"media",
						"film",
						"movie"
					],
					"defaultCode": 59748,
					"grid": 16
				},
				{
					"id": 1916,
					"paths": [
						"M978.84 256.252c-10.588 0-21.458 3.722-31.438 10.766l-179.402 126.614v-105.632c0-52.8-43.202-96-96-96h-13.65l103.456-141.076c10.452-14.252 7.372-34.278-6.88-44.728-14.252-10.452-34.276-7.372-44.728 6.88l-131.214 178.924h-482.984c-52.8 0-96 43.2-96 96v448c0 52.8 43.2 96 96 96h13.652l-103.456 141.076c-10.452 14.252-7.372 34.278 6.88 44.728 5.704 4.182 12.33 6.198 18.898 6.198 9.846 0 19.562-4.53 25.83-13.078l131.212-178.924h482.984c52.798 0 96-43.2 96-96v-105.628l179.4 126.614c9.978 7.042 20.85 10.764 31.436 10.766 0.002 0 0.002 0 0.006 0 14.088 0 26.954-6.496 35.292-17.822 6.458-8.77 9.87-20.052 9.87-32.634v-410.586c-0.004-33.126-22.722-50.458-45.164-50.458zM96 768c-17.346 0-32-14.654-32-32v-448c0-17.346 14.654-32 32-32h436.050l-375.466 512h-60.584zM960 687.54l-158.042-111.54h-97.958v160c0 17.346-14.654 32-32 32h-436.050l375.466-512h60.584c17.346 0 32 14.654 32 32v160h97.958l158.042-111.54v351.080z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"video-camera-slash",
						"video",
						"media",
						"film",
						"movie"
					],
					"defaultCode": 59751,
					"grid": 16
				},
				{
					"id": 1912,
					"paths": [
						"M978.84 256.252c-10.588 0-21.458 3.722-31.436 10.766l-179.404 126.614v-105.632c0-52.8-43.2-96-96-96h-576c-52.8 0-96 43.2-96 96v448c0 52.8 43.2 96 96 96h576c52.8 0 96-43.2 96-96v-105.63l179.402 126.614c9.978 7.042 20.848 10.764 31.434 10.766 0.002 0 0.002 0 0.006 0 14.088 0 26.954-6.496 35.292-17.822 6.456-8.77 9.868-20.054 9.868-32.636v-410.582c-0.002-33.126-22.72-50.458-45.162-50.458z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"video-camera",
						"video",
						"media",
						"film",
						"movie"
					],
					"defaultCode": 59747,
					"grid": 16
				},
				{
					"id": 1914,
					"paths": [
						"M978.84 256.252c-10.588 0-21.458 3.722-31.436 10.766l-179.404 126.614v-105.632c0-52.8-43.2-96-96-96h-576c-52.8 0-96 43.2-96 96v448c0 52.8 43.2 96 96 96h576c52.8 0 96-43.2 96-96v-105.628l179.402 126.614c9.978 7.042 20.848 10.764 31.434 10.766 0.002 0 0.002 0 0.006 0 14.088 0 26.956-6.496 35.292-17.822 6.456-8.77 9.868-20.052 9.868-32.634v-410.586c-0.002-33.126-22.72-50.458-45.162-50.458zM256 704v-384l320 192-320 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"video-camera",
						"video",
						"media",
						"film",
						"movie"
					],
					"defaultCode": 59749,
					"grid": 16
				},
				{
					"id": 1915,
					"paths": [
						"M978.84 256.252c-10.588 0-21.458 3.722-31.436 10.766l-179.404 126.614v-105.632c0-52.8-43.2-96-96-96h-576c-52.8 0-96 43.2-96 96v448c0 52.8 43.2 96 96 96h576c52.8 0 96-43.2 96-96v-105.63l179.402 126.614c9.978 7.042 20.848 10.764 31.434 10.766 0.002 0 0.002 0 0.006 0 14.088 0 26.954-6.496 35.292-17.822 6.456-8.77 9.868-20.054 9.868-32.636v-410.582c-0.002-33.126-22.72-50.458-45.162-50.458zM960 687.54l-158.042-111.54h-97.958v160c0 17.346-14.654 32-32 32h-576c-17.346 0-32-14.654-32-32v-448c0-17.346 14.654-32 32-32h576c17.346 0 32 14.654 32 32v160h97.958l158.042-111.54v351.080z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"video-camera",
						"video",
						"media",
						"film",
						"movie"
					],
					"defaultCode": 59750,
					"grid": 16
				},
				{
					"id": 1917,
					"paths": [
						"M978.84 256.252c-10.588 0-21.458 3.722-31.436 10.766l-179.404 126.614v-105.632c0-52.8-43.2-96-96-96h-576c-52.8 0-96 43.2-96 96v448c0 52.8 43.2 96 96 96h576c52.8 0 96-43.2 96-96v-105.628l179.402 126.614c9.978 7.042 20.848 10.764 31.434 10.766 0.002 0 0.002 0 0.006 0 14.088 0 26.956-6.496 35.292-17.822 6.456-8.77 9.868-20.052 9.868-32.634v-410.586c-0.002-33.126-22.72-50.458-45.162-50.458zM960 687.54l-158.042-111.54h-97.958v160c0 17.346-14.654 32-32 32h-576c-17.346 0-32-14.654-32-32v-448c0-17.346 14.654-32 32-32h576c17.346 0 32 14.654 32 32v160h97.958l158.042-111.54v351.080z",
						"M256 320l320 192-320 192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"video-camera",
						"video",
						"media",
						"film",
						"movie"
					],
					"defaultCode": 59752,
					"grid": 16
				},
				{
					"id": 1237,
					"width": 1023.9979553222656,
					"paths": [
						"M1024 201.143v621.714q0 24-22.286 33.714-7.429 2.857-14.286 2.857-15.429 0-25.714-10.857l-230.286-230.286v94.857q0 68-48.286 116.286t-116.286 48.286h-402.286q-68 0-116.286-48.286t-48.286-116.286v-402.286q0-68 48.286-116.286t116.286-48.286h402.286q68 0 116.286 48.286t48.286 116.286v94.286l230.286-229.714q10.286-10.857 25.714-10.857 6.857 0 14.286 2.857 22.286 9.714 22.286 33.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"video-camera"
					],
					"defaultCode": 61501,
					"grid": 14
				},
				{
					"id": 915,
					"width": 1024,
					"paths": [
						"M576 192h-64v-32h64v32zM967.712 441.856c14.272 3.52 24.288 16.352 24.288 31.040v174.176c0 14.688-9.92 27.584-24.128 31.168-8.608 2.176-17.184 4.256-25.76 6.336-3.84 26.336-7.968 52.64-13.184 78.752l-17.504 87.488c-8.96 44.896-48.352 77.184-94.112 77.184h-546.592c-45.76 0-85.152-32.288-94.144-77.184l-17.504-87.488c-5.216-26.112-9.312-52.416-13.184-78.752-8.576-2.080-17.152-4.16-25.76-6.336-14.208-3.584-24.128-16.48-24.128-31.168v-174.176c0-14.688 10.016-27.52 24.288-31.040 2.56-0.64 5.152-1.28 7.712-1.92v-10.144c-31.712-20.448-57.984-48.576-74.72-82.72-37.44-13.312-62.24-53.344-50.24-97.472 7.040-25.856 27.392-46.72 53.152-54.176 42.432-12.288 81.664 9.6 96.992 44.416l2.656 7.776c15.392-33.056 48.544-55.616 86.688-55.616h73.824c58.016-59.008 138.336-96 227.648-96s169.632 36.992 227.648 96h73.088c47.776 0 88.288 35.136 95.040 82.432l20.224 141.568v23.936c2.56 0.64 5.152 1.28 7.712 1.92zM359.2 195.904c66.432 36.928 125.664 55.584 184.8 55.584s118.368-18.656 184.8-55.584c-50.080-42.144-114.368-67.904-184.8-67.904s-134.72 25.76-184.8 67.904zM242.528 224c-29.12 0-53.952 19.648-61.504 47.104l-21.024 147.168v13.76c133.088-31.232 258.56-46.912 384-46.912s250.912 15.712 384 46.912v-13.76l-19.904-139.328c-4.512-31.52-31.52-54.944-63.36-54.944h-100.352c-72.896 40.544-136.768 59.488-200.384 59.488s-127.456-18.944-200.384-59.488h-101.088zM131.2 393.632l5.472-38.432c-6.304-6.368-12.256-13.152-17.28-20.864l-11.584-17.824 11.936-17.6c5.408-7.968 8.256-17.28 8.256-26.912 0-26.464-21.536-48-48-48s-48 21.536-48 48c0 20.064 12.864 38.112 32.032 44.928l12.256 4.384 5.728 11.712c11.936 24.32 28.992 44.608 49.184 60.608zM908.8 692.256c-125.952 28.288-245.44 42.656-364.8 42.656s-238.848-14.368-364.8-42.656c3.392 21.696 6.976 43.328 11.264 64.832l17.504 87.488c5.952 29.888 32.224 51.424 62.72 51.424h546.592c30.496 0 56.768-21.536 62.752-51.456l17.504-87.488c4.32-21.472 7.872-43.136 11.264-64.8zM960 472.736c-146.88-37.408-283.232-55.616-416-55.616s-269.12 18.208-416 55.616v174.56c146.88 37.408 283.232 55.616 416 55.616s269.12-18.208 416-55.616v-174.56zM608 608v-96c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32v96c0 17.664-14.336 32-32 32h-128c-17.664 0-32-14.336-32-32zM640 608h128v-96h-128v96zM480 512v96c0 17.664-14.336 32-32 32h-128c-17.664 0-32-14.336-32-32v-96c0-17.664 14.336-32 32-32h128c17.664 0 32 14.336 32 32zM448 512h-128v96h128v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"view",
						"play",
						"watch"
					],
					"grid": 32
				},
				{
					"id": 916,
					"width": 1024,
					"paths": [
						"M129.344 406.592l18.88-132.16c1.312-9.088 4.032-18.24 7.456-27.232l0.16 0.448c15.392-33.088 48.544-55.648 86.688-55.648h65.6c62.496 56.64 145.088 91.488 235.872 91.488s173.376-34.848 235.872-91.488h64.864c47.776 0 88.288 35.136 95.040 82.432l18.88 132.16c-145.632-35.84-281.536-53.472-414.656-53.472-133.12-0.032-269.024 17.632-414.656 53.472v0zM544 251.488c-79.616 0-152.288-29.248-208.288-77.376 55.968-48.416 128.48-78.112 208.288-78.112s152.32 29.696 208.288 78.112c-56 48.096-128.672 77.376-208.288 77.376zM512 192h64v-32h-64v32zM97.664 402.048l18.88-132.16c2.816-19.648 10.496-37.504 21.152-53.152-19.488-20.416-49.6-30.528-81.504-21.28-25.76 7.424-46.112 28.288-53.152 54.144-12 44.128 12.8 84.16 50.24 97.472 10.88 22.208 26.016 41.696 43.872 58.368l0.512-3.392zM640 608h128v-96h-128v96zM992 472.736v174.56c0 14.624-9.92 27.392-24.096 31.008-149.568 38.080-288.224 56.608-423.904 56.608s-274.336-18.528-423.904-56.608c-14.176-3.616-24.096-16.384-24.096-31.040v-174.56c0-14.624 9.92-27.392 24.096-31.008 2.592-0.672 5.088-1.184 7.68-1.856 0.032 0 0.224 0.064 0.224 0.064v-0.096c146.528-36.736 282.752-54.72 416-54.72s269.472 17.984 416 54.72v0.096c0.096 0.032 0.48 0.032 0.704 0.064 2.4 0.608 4.768 1.12 7.2 1.728 14.176 3.648 24.096 16.416 24.096 31.040zM480 512c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-96zM800 512c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-96zM320 608h128v-96h-128v96zM151.616 718.784c2.4 14.88 4.512 29.792 7.456 44.576l17.504 87.488c8.96 44.864 48.352 77.152 94.144 77.152h546.592c45.76 0 85.152-32.288 94.144-77.184l17.504-87.488c2.944-14.784 5.056-29.696 7.456-44.576-137.248 32.224-266.080 48.128-392.384 48.128-126.336 0.032-255.168-15.872-392.416-48.096z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"view",
						"play",
						"watch"
					],
					"grid": 32
				},
				{
					"id": 3348,
					"paths": [
						"M1023.6 274c-4.6 99.6-74.2 236.2-208.8 409.4-139.2 180.8-257 271.4-353.4 271.4-59.6 0-110.2-55-151.4-165.2-27.6-101-55-202-82.6-303-30.6-110.2-63.4-165.2-98.6-165.2-7.6 0-34.4 16.2-80.4 48.2l-48.2-62c50.6-44.4 100.4-88.8 149.4-133.2 67.4-58.2 118-88.8 151.8-92 79.6-7.6 128.8 46.8 147.2 163.4 19.8 125.8 33.6 204 41.4 234.6 23 104.4 48.2 156.6 75.8 156.6 21.4 0 53.6-33.8 96.6-101.6 42.8-67.6 65.8-119.2 69-154.6 6.2-58.4-16.8-87.8-69-87.8-24.6 0-49.8 5.6-75.8 16.8 50.4-164.8 146.4-244.8 288.4-240.2 105 2.8 154.6 71 148.6 204.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vimeo",
						"brand",
						"social"
					],
					"defaultCode": 61183,
					"grid": 16
				},
				{
					"id": 1544,
					"width": 877.7129821777344,
					"paths": [
						"M738.286 364.571q5.714-123.429-92-126.857-132-4.571-178.286 149.143 25.143-10.857 46.857-10.857 48.571 0 42.286 54.857-2.286 32.571-42.286 95.429t-60 62.857q-24.571 0-46.857-96.571-7.429-30.857-25.714-145.714-17.143-108-91.429-101.143-33.714 4-93.714 57.143l-92.571 82.286 29.714 38.286q43.429-29.714 49.714-29.714 32.571 0 61.143 102.286 8.571 31.429 25.714 94t25.714 94q38.857 102.286 93.714 102.286 89.714 0 218.857-168 125.714-161.714 129.143-253.714zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vimeo-square"
					],
					"defaultCode": 61844,
					"grid": 14
				},
				{
					"id": 3349,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM861.6 340c-3.2 72-53.6 170.6-151 295.8-100.6 130.8-185.8 196.2-255.4 196.2-43.2 0-79.6-39.8-109.4-119.4-20-73-39.8-146-59.8-219-22-79.6-45.8-119.4-71.2-119.4-5.6 0-25 11.6-58 34.8l-34.8-44.8c36.6-32 72.6-64.2 108-96.2 48.8-42 85.2-64.2 109.6-66.4 57.6-5.6 93 33.8 106.4 118 14.4 91 24.4 147.4 30 169.6 16.6 75.4 34.8 113 54.8 113 15.4 0 38.8-24.4 69.8-73.4s47.6-86.2 49.8-111.8c4.4-42.2-12.2-63.4-49.8-63.4-17.8 0-36 4-54.8 12.2 36.4-119 105.8-177 208.4-173.6 76 2.2 111.8 51.4 107.4 147.8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vimeo",
						"brand",
						"social"
					],
					"defaultCode": 61184,
					"grid": 16
				},
				{
					"id": 1761,
					"width": 1031.9999694824219,
					"paths": [
						"M976.571 296q-5.714 134.857-189.714 372-190.286 246.286-321.143 246.286-81.143 0-137.143-150.286-25.143-91.429-75.429-275.429-41.143-149.714-89.714-149.714-10.286 0-72.571 43.429l-44-56q13.714-12 61.714-55.143t74.286-66q89.143-78.857 137.714-83.429 54.286-5.143 87.429 31.714t46.286 116.286q25.143 164 37.714 213.143 31.429 142.286 68.571 142.286 29.143 0 88-92 57.714-92 62.286-140.571 7.429-79.429-62.286-79.429-32.571 0-69.143 14.857 68.571-224.571 262.286-218.286 143.429 4.571 134.857 186.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vimeo"
					],
					"defaultCode": 62077,
					"grid": 14
				},
				{
					"id": 3339,
					"paths": [
						"M960.8 509c-26.4 6-51.8 8.8-74.8 8.8-129.2 0-228.6-90.2-228.6-247.2 0-77 29.8-116.8 71.8-116.8 40 0 66.6 35.8 66.6 108.6 0 41.4-11 86.8-19.2 113.6 0 0 39.8 69.4 148.6 48.2 23.2-51.4 35.6-117.8 35.6-176 0-156.8-80-248.2-226.6-248.2-150.8 0-239 115.8-239 268.6 0 151.4 70.8 281.2 187.4 340.4-49 98.2-111.4 184.6-176.6 249.8-118-142.8-224.8-333.2-268.6-705h-174.2c80.6 619.2 320.4 816.4 384 854.2 35.8 21.6 66.8 20.6 99.6 2 51.6-29.2 206.2-184 292-365 36 0 79.2-4.2 122.2-14v-122z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vine",
						"brand",
						"social"
					],
					"defaultCode": 61174,
					"grid": 16
				},
				{
					"id": 1595,
					"width": 877.7171783447266,
					"paths": [
						"M855.429 472.571v113.143q-57.714 13.143-113.143 13.143-37.143 77.714-94.571 154.857t-103.714 123.143-73.143 60.857q-45.714 25.714-92.571-1.714-16-9.714-34.571-24.857t-48.571-47.714-58.571-73.429-61.429-105.143-60.286-139.429-52.286-179.714-40.286-222.857h161.714q14.857 124.571 40 227.714t59.714 181.143 69.429 134.571 80 111.429q96.571-96.571 164-232-81.143-41.143-127.429-125.714t-46.286-190.286q0-109.714 59.429-179.714t162.286-70q101.714 0 156 60.286t54.286 170q0 90.857-33.143 163.429-4 0.571-11.143 1.714t-26.286 1.143-36-3.429-35.429-14.571-28.857-29.429q17.714-58.857 17.714-105.143 0-49.714-16.571-75.429t-45.143-25.714q-30.286 0-48.571 28.286t-18.286 80.286q0 106.286 60 167.714t152.571 61.429q35.429 0 69.143-8z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vine"
					],
					"defaultCode": 61898,
					"grid": 14
				},
				{
					"id": 1168,
					"width": 1024,
					"paths": [
						"M512 32c-264.672 0-480 215.328-480 480s215.328 480 480 480 480-215.328 480-480-215.328-480-480-480zM926.368 480h-382.368v-382.368c203.84 15.616 366.752 178.528 382.368 382.368zM96 512c0-229.376 186.624-416 416-416v416l156.032 385.376c-48.224 19.584-100.832 30.624-156.032 30.624-229.376 0-416-186.624-416-416zM697.152 884l-133.088-329.28 246.432 246.432c-32.672 33.664-70.976 61.664-113.344 82.848zM832.032 777.408l-265.408-265.408h361.376c0 100.832-36.096 193.344-95.968 265.408z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"visualize",
						"chart",
						"divide",
						"share",
						"split"
					],
					"grid": 32
				},
				{
					"id": 3340,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM829.4 716.8l-93.6 1.4c0 0-20.2 4-46.6-14.2-35-24-68-86.6-93.8-78.4-26 8.2-25.2 64.4-25.2 64.4s0.2 12-5.8 18.4c-6.4 7-19.2 8.4-19.2 8.4h-41.8c0 0-92.4 5.6-173.8-79.2-88.8-92.4-167.2-275.8-167.2-275.8s-4.6-12 0.4-17.8c5.6-6.6 20.6-7 20.6-7l100.2-0.6c0 0 9.4 1.6 16.2 6.6 5.6 4 8.6 11.8 8.6 11.8s16.2 41 37.6 78c41.8 72.2 61.4 88 75.6 80.4 20.6-11.2 14.4-102.2 14.4-102.2s0.4-33-10.4-47.6c-8.4-11.4-24.2-14.8-31-15.6-5.6-0.8 3.6-13.8 15.6-19.8 18-8.8 49.8-9.4 87.4-9 29.2 0.2 37.8 2.2 49.2 4.8 34.6 8.4 22.8 40.6 22.8 117.8 0 24.8-4.4 59.6 13.4 71 7.6 5 26.4 0.8 73.4-79 22.2-37.8 39-82.2 39-82.2s3.6-8 9.2-11.4c5.8-3.4 13.6-2.4 13.6-2.4l105.4-0.6c0 0 31.6-3.8 36.8 10.6 5.4 15-11.8 50-54.8 107.4-70.6 94.2-78.6 85.4-19.8 139.8 56 52 67.6 77.4 69.6 80.6 22.8 38.4-26 41.4-26 41.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vk",
						"brand",
						"social"
					],
					"defaultCode": 61175,
					"grid": 16
				},
				{
					"id": 1534,
					"width": 1107.9998188018799,
					"paths": [
						"M1095.429 297.143q13.143 36.571-85.714 168-13.714 18.286-37.143 48.571-44.571 57.143-51.429 74.857-9.714 23.429 8 46.286 9.714 12 46.286 46.857h0.571l2.286 2.286q80.571 74.857 109.143 126.286 1.714 2.857 3.714 7.143t4 15.143-0.286 19.429-14.286 15.714-33.714 7.143l-146.286 2.286q-13.714 2.857-32-2.857t-29.714-12.571l-11.429-6.857q-17.143-12-40-36.571t-39.143-44.286-34.857-33.143-32.286-8.857q-1.714 0.571-4.571 2t-9.714 8.286-12.286 16.857-9.714 29.714-3.714 44.286q0 8.571-2 15.714t-4.286 10.571l-2.286 2.857q-10.286 10.857-30.286 12.571h-65.714q-40.571 2.286-83.429-9.429t-75.143-30.286-58.857-37.714-40.286-32.857l-14.286-13.714q-5.714-5.714-15.714-17.143t-40.857-52-60.571-86.286-70-120.571-74.571-155.429q-3.429-9.143-3.429-15.429t1.714-9.143l2.286-3.429q8.571-10.857 32.571-10.857l156.571-1.143q6.857 1.143 13.143 3.714t9.143 4.857l2.857 1.714q9.143 6.286 13.714 18.286 11.429 28.571 26.286 59.143t23.429 46.571l9.143 16.571q16.571 34.286 32 59.429t27.714 39.143 23.714 22 19.429 8 15.429-2.857q1.143-0.571 2.857-2.857t6.857-12.571 7.714-26.857 5.429-46.286 0-71.429q-1.143-22.857-5.143-41.714t-8-26.286l-3.429-6.857q-14.286-19.429-48.571-24.571-7.429-1.143 2.857-13.714 9.714-10.857 21.714-17.143 30.286-14.857 136.571-13.714 46.857 0.571 77.143 7.429 11.429 2.857 19.143 7.714t11.714 13.714 6 18.286 2 26-0.571 31.429-1.429 40.286-0.857 47.143q0 6.286-0.571 24t-0.286 27.429 2 23.143 6.571 22.286 12.857 14q4.571 1.143 9.714 2.286t14.857-6.286 21.714-19.714 29.714-38.286 38.857-61.429q34.286-59.429 61.143-128.571 2.286-5.714 5.714-10t6.286-6l2.286-1.714 2.857-1.429t7.429-1.714 11.429-0.286l164.571-1.143q22.286-2.857 36.571 1.429t17.714 9.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"vk"
					],
					"defaultCode": 61833,
					"grid": 14
				},
				{
					"id": 917,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM212.512 800c-15.36-15.968-29.504-33.056-42.176-51.296l89.408-44.704h504.48l89.44 44.704c-12.672 18.24-26.816 35.328-42.176 51.296h-598.976zM288 672v-509.984c38.784-24.896 81.888-43.424 128-54.4v564.384h-128zM256 526.784l-156.992-62.816c4.608-39.84 14.624-78.048 29.696-113.664l127.296 50.976v125.504zM608 672v-564.384c46.112 10.944 89.216 29.472 128 54.4v509.984h-128zM768 401.248l127.296-50.944c15.072 35.616 25.088 73.824 29.696 113.664l-156.992 62.816v-125.536zM881.344 321.408l-113.344 45.376v-182.016c46.912 36.8 85.696 83.296 113.344 136.64zM576 101.44v570.56h-128v-570.56c20.928-3.232 42.176-5.44 64-5.44s43.072 2.208 64 5.44zM256 184.768v182.016l-113.344-45.376c27.616-53.344 66.432-99.84 113.344-136.64zM96.736 497.536l159.264 63.744v108.832l-102.816 51.392c-36.096-61.632-57.184-133.056-57.184-209.504 0-4.896 0.576-9.632 0.736-14.464zM246.56 832h530.848c-72.096 59.904-164.608 96-265.44 96s-193.312-36.096-265.408-96zM870.784 721.504l-102.784-51.392v-108.864l159.264-63.712c0.16 4.832 0.736 9.568 0.736 14.464 0 76.448-21.088 147.904-57.216 209.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volley",
						"game",
						"play"
					],
					"grid": 32
				},
				{
					"id": 918,
					"width": 1024,
					"paths": [
						"M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM777.44 832.544c-0.128 0.096-0.256 0.224-0.384 0.32-2.848 2.4-6.496 3.68-10.24 3.68h-509.632c-3.744 0-7.36-1.28-10.24-3.68-0.128-0.096-0.256-0.224-0.384-0.32-11.296-9.536-4.544-28 10.24-28h510.432c14.752 0.032 21.504 18.496 10.208 28zM913.76 507.488l-145.76 58.304v108.864l84.672 42.336c8.352 4.192 11.36 14.688 6.368 22.592-0.064 0.096-0.128 0.192-0.16 0.288-4.352 6.88-13.248 9.376-20.512 5.728l-74.112-37.056h-504.512l-74.080 37.056c-7.296 3.648-16.16 1.152-20.544-5.728-0.064-0.096-0.128-0.192-0.16-0.288-4.992-7.904-2.016-18.432 6.368-22.592l84.672-42.336v-108.832l-145.76-58.336c-6.24-2.496-10.272-8.64-9.952-15.328 0-0.224 0.032-0.448 0.032-0.704 0.544-10.784 11.68-17.76 21.696-13.728l133.984 53.6v-125.536l-108.928-43.616c-8.544-3.424-12.448-13.408-8.384-21.664 0.064-0.096 0.096-0.192 0.16-0.288 3.648-7.456 12.448-10.848 20.16-7.744l96.992 38.848v-170.432c0-4.928 2.24-9.632 6.176-12.608 0.096-0.096 0.224-0.16 0.32-0.256 10.432-7.936 25.504-0.512 25.504 12.64v475.904h128v-548.384c0-7.584 5.376-14.080 12.832-15.584 0.096-0.032 0.224-0.032 0.32-0.064 9.76-1.952 18.848 5.632 18.848 15.584v548.416h128v-548.416c0-9.952 9.088-17.536 18.848-15.584 0.096 0.032 0.224 0.032 0.32 0.064 7.456 1.504 12.832 8 12.832 15.584v548.352h128v-475.872c0-13.12 15.072-20.544 25.504-12.608 0.096 0.096 0.224 0.16 0.32 0.256 3.936 2.976 6.176 7.648 6.176 12.576v170.4l97.024-38.816c7.712-3.072 16.512 0.32 20.16 7.744 0.064 0.096 0.096 0.192 0.16 0.288 4.032 8.256 0.16 18.24-8.384 21.664l-108.96 43.616v125.536l133.952-53.6c10.016-4 21.152 2.944 21.696 13.728 0 0.224 0.032 0.448 0.032 0.704 0.32 6.688-3.712 12.832-9.92 15.328z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volley",
						"game",
						"play"
					],
					"grid": 32
				},
				{
					"id": 188,
					"paths": [
						"M417.291 164.216c-12.64 0-25.318 5.33-37.682 15.838l-209.819 178.346h-92.99c-42.347 0-76.8 34.453-76.8 76.8v204.8c0 42.349 34.453 76.8 76.8 76.8h92.989l209.821 178.346c12.363 10.509 25.040 15.838 37.68 15.838 0 0 0 0 0.002 0 13.931 0 26.429-6.762 34.288-18.55 6.118-9.178 9.221-20.898 9.221-34.834v-640c0-36.877-21.853-53.384-43.509-53.384zM51.2 640v-204.8c0-14.115 11.485-25.6 25.6-25.6h76.8v256h-76.8c-14.115 0-25.6-11.485-25.6-25.6zM409.6 853.442l-204.8-174.080v-283.523l204.8-174.078v631.682z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume",
						"speaker"
					],
					"defaultCode": 59485,
					"grid": 20
				},
				{
					"id": 3002,
					"paths": [
						"M0 320h192l320-320v1024l-320-320h-192v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-0",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60837,
					"grid": 16
				},
				{
					"id": 3001,
					"paths": [
						"M576 832h448v128h-448zM0 320v384h192l320 320v-1024l-320 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-1",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60836,
					"grid": 16
				},
				{
					"id": 3000,
					"paths": [
						"M576 640h448v128h-448zM576 832h448v128h-448zM0 320v384h192l320 320v-1024l-320 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-2",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60835,
					"grid": 16
				},
				{
					"id": 2999,
					"paths": [
						"M576 448h448v128h-448zM576 640h448v128h-448zM576 832h448v128h-448zM0 320v384h192l320 320v-1024l-320 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-3",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60834,
					"grid": 16
				},
				{
					"id": 2998,
					"paths": [
						"M576 256h448v128h-448zM576 448h448v128h-448zM576 640h448v128h-448zM576 832h448v128h-448zM0 320v384h192l320 320v-1024l-320 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-4",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60833,
					"grid": 16
				},
				{
					"id": 2997,
					"paths": [
						"M576 64h448v128h-448zM576 256h448v128h-448zM576 448h448v128h-448zM576 640h448v128h-448zM576 832h448v128h-448zM0 320v384h192l320 320v-1024l-320 320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-5",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60832,
					"grid": 16
				},
				{
					"id": 1793,
					"width": 804.5720672607422,
					"paths": [
						"M352.571 965.143q0-6.286-7.429-33.143t-17.714-61.143-11.429-39.429q-0.571-2.286-2.857-15.143t-4.857-20.571-7.714-12.286q-8.571-8-29.143-8-13.143 0-40 3.143t-40.571 3.143q-19.429 0-26.857-6.286-3.429-2.857-6.286-8.857t-4.286-11.429-3.714-13.714-2.857-10.571q-21.143-73.143-21.143-145.714t21.143-145.714q0.571-2.286 2.857-10.571t3.714-13.714 4.286-11.429 6.286-8.857q7.429-6.286 26.857-6.286 13.714 0 40.571 3.143t40 3.143q20.571 0 29.143-8 5.143-4.571 7.714-12.286t4.857-20.571 2.857-15.143q1.143-5.143 11.429-39.429t17.714-61.143 7.429-33.143q0-12.571-24.857-30t-43.143-24.286q-11.429-4.571-25.714-4.571-19.429 0-56 10.286-32.571 9.714-55.143 23.143t-40.571 37.714-26.286 40-26 54q-3.429 6.857-5.143 10.857-28 61.143-38.857 123.429t-10.857 139.429 10.857 139.429 38.857 123.429q32 69.714 47.429 92 36 52 102.286 72.571l3.429 1.143q36.571 10.286 56 10.286 14.286 0 25.714-4.571 18.286-6.857 43.143-24.286t24.857-30zM443.429 443.429q-14.857 0-25.714-10.857t-10.857-26 10.857-26q21.143-21.143 21.143-51.429 0-29.714-21.143-52-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857 25.714 10.857q42.857 42.857 42.857 103.429t-42.857 103.429q-12 10.857-25.714 10.857zM546.857 546.857q-15.429 0-25.714-10.857-10.857-10.857-10.857-25.714t10.857-25.714q64-65.143 64-155.429t-64-155.429q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857 25.714 10.857q85.714 85.714 85.714 206.857t-85.714 206.857q-10.286 10.857-25.714 10.857zM650.286 650.286q-15.429 0-25.714-10.857-10.857-10.857-10.857-25.714t10.857-25.714q51.429-52 79.143-118.857t27.714-140-27.714-140-79.143-118.857q-10.857-10.857-10.857-25.714t10.857-25.714 25.714-10.857 25.714 10.857q62.286 62.286 95.429 142.286t33.143 168-33.143 168-95.429 142.286q-10.286 10.857-25.714 10.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-control-phone"
					],
					"defaultCode": 62112,
					"grid": 14
				},
				{
					"id": 2988,
					"paths": [
						"M512 448h512v128h-512v-128z",
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-decrease",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60823,
					"grid": 16
				},
				{
					"id": 2995,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436zM64 640h96c8.488 0 16.626 3.372 22.628 9.374l201.372 201.37v-677.49l-201.372 201.374c-6.002 6-14.14 9.372-22.628 9.372h-96v256z",
						"M928 576h-384c-17.674 0-32-14.326-32-32s14.326-32 32-32h384c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-decrease",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60830,
					"grid": 16
				},
				{
					"id": 2996,
					"paths": [
						"M1014.626 73.372c-12.496-12.496-32.758-12.496-45.254 0l-265.372 265.374v-242.746c0-12.942-7.796-24.612-19.754-29.564-11.958-4.954-25.72-2.216-34.876 6.936l-246.624 246.628h-114.746c-17.672 0-32 14.328-32 32v320c0 17.674 14.328 32 32 32h50.746l-201.374 201.374c-12.496 12.496-12.496 32.758 0 45.254 6.25 6.248 14.438 9.372 22.628 9.372s16.378-3.124 22.628-9.374l233.372-233.372 233.372 233.374c6.124 6.124 14.308 9.374 22.636 9.374 4.122 0 8.28-0.796 12.238-2.436 11.958-4.954 19.754-16.622 19.754-29.566v-498.746l310.626-310.626c12.498-12.498 12.498-32.758 0-45.256zM320 640v-256h96c8.488 0 16.626-3.372 22.628-9.372l201.372-201.374v229.49l-237.254 237.256h-82.746zM640 850.744l-178.746-178.744 178.746-178.746v357.49z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-decrease",
						"volume",
						"speaker",
						"media control",
						"audio"
					],
					"defaultCode": 60831,
					"grid": 16
				},
				{
					"id": 1215,
					"width": 658.2870140075684,
					"paths": [
						"M438.857 201.143v621.714q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-190.286-190.286h-149.714q-14.857 0-25.714-10.857t-10.857-25.714v-219.429q0-14.857 10.857-25.714t25.714-10.857h149.714l190.286-190.286q10.857-10.857 25.714-10.857t25.714 10.857 10.857 25.714zM658.286 512q0 43.429-24.286 80.857t-64.286 53.429q-5.714 2.857-14.286 2.857-14.857 0-25.714-10.571t-10.857-26q0-12 6.857-20.286t16.571-14.286 19.429-13.143 16.571-20.286 6.857-32.571-6.857-32.571-16.571-20.286-19.429-13.143-16.571-14.286-6.857-20.286q0-15.429 10.857-26t25.714-10.571q8.571 0 14.286 2.857 40 15.429 64.286 53.143t24.286 81.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-down"
					],
					"defaultCode": 61479,
					"grid": 14
				},
				{
					"id": 2980,
					"width": 1088,
					"paths": [
						"M890.040 922.040c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.746-18.744-49.136 0-67.882 87.638-87.642 135.904-204.16 135.904-328.1 0-123.938-48.266-240.458-135.904-328.098-18.744-18.746-18.744-49.138 0-67.882s49.138-18.744 67.882 0c105.77 105.772 164.022 246.4 164.022 395.98s-58.252 290.208-164.022 395.98c-9.372 9.372-21.656 14.058-33.94 14.058zM719.53 831.53c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.744-18.744-49.136 0-67.882 131.006-131.006 131.006-344.17 0-475.176-18.744-18.746-18.744-49.138 0-67.882 18.744-18.742 49.138-18.744 67.882 0 81.594 81.59 126.53 190.074 126.53 305.466 0 115.39-44.936 223.876-126.53 305.47-9.372 9.374-21.656 14.060-33.94 14.060v0zM549.020 741.020c-12.286 0-24.568-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054z",
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-high",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60815,
					"grid": 16
				},
				{
					"id": 2989,
					"width": 1024,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436zM64 640h96c8.488 0 16.626 3.372 22.628 9.374l201.372 201.37v-677.49l-201.372 201.374c-6.002 6-14.14 9.372-22.628 9.372h-96v256z",
						"M544 640c-17.674 0-32-14.326-32-32v-192c0-17.672 14.326-32 32-32s32 14.328 32 32v192c0 17.674-14.326 32-32 32z",
						"M672 768c-17.674 0-32-14.326-32-32v-448c0-17.672 14.326-32 32-32s32 14.328 32 32v448c0 17.674-14.326 32-32 32z",
						"M800 896c-17.674 0-32-14.326-32-32v-704c0-17.672 14.326-32 32-32s32 14.328 32 32v704c0 17.674-14.326 32-32 32z",
						"M928 1024c-17.674 0-32-14.326-32-32v-960c0-17.672 14.326-32 32-32s32 14.328 32 32v960c0 17.674-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-high",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60824,
					"grid": 16
				},
				{
					"id": 185,
					"paths": [
						"M699.050 761.893c-7.438 0-14.816-3.227-19.875-9.446-8.922-10.968-7.262-27.093 3.704-36.014 54.096-44.003 85.122-109.187 85.122-178.832s-31.026-134.827-85.12-178.834c-10.968-8.922-12.627-25.046-3.704-36.014s25.046-12.626 36.014-3.702c66.099 53.771 104.010 133.43 104.010 218.55 0 85.122-37.91 164.779-104.011 218.55-4.749 3.862-10.462 5.742-16.139 5.742z",
						"M795.915 881.107c-7.438 0-14.814-3.227-19.875-9.446-8.922-10.966-7.264-27.091 3.704-36.014 90.152-73.338 141.856-181.971 141.856-298.046 0-116.077-51.704-224.71-141.854-298.046-10.968-8.922-12.627-25.046-3.704-36.013 8.92-10.968 25.045-12.627 36.014-3.704 102.155 83.101 160.744 206.211 160.744 337.763 0 131.55-58.589 254.661-160.746 337.766-4.747 3.861-10.462 5.741-16.139 5.741z",
						"M602.19 642.677c-7.438 0-14.814-3.227-19.875-9.446-8.922-10.966-7.264-27.093 3.704-36.014 18.037-14.672 28.381-36.4 28.381-59.616 0-23.218-10.346-44.949-28.382-59.621-10.966-8.922-12.627-25.046-3.704-36.014s25.045-12.626 36.014-3.704c30.040 24.44 47.272 60.645 47.272 99.339 0 38.691-17.23 74.898-47.27 99.334-4.747 3.861-10.462 5.742-16.139 5.742z",
						"M417.291 164.216c-12.64 0-25.318 5.33-37.682 15.838l-209.819 178.346h-92.99c-42.347 0-76.8 34.453-76.8 76.8v204.8c0 42.349 34.453 76.8 76.8 76.8h92.989l209.821 178.346c12.363 10.509 25.040 15.838 37.68 15.838 0 0 0 0 0.002 0 13.931 0 26.429-6.762 34.288-18.55 6.118-9.178 9.221-20.898 9.221-34.834v-640c0-36.877-21.853-53.384-43.509-53.384zM51.2 640v-204.8c0-14.115 11.485-25.6 25.6-25.6h76.8v256h-76.8c-14.115 0-25.6-11.485-25.6-25.6zM409.6 853.442l-204.8-174.080v-283.523l204.8-174.078v631.682z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-high",
						"speaker"
					],
					"defaultCode": 59482,
					"grid": 20
				},
				{
					"id": 2987,
					"paths": [
						"M1024 576h-192v192h-128v-192h-192v-128h192v-192h128v192h192v128z",
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-increase",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60822,
					"grid": 16
				},
				{
					"id": 2994,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436zM64 640h96c8.488 0 16.626 3.372 22.628 9.374l201.372 201.37v-677.49l-201.372 201.374c-6.002 6-14.14 9.372-22.628 9.372h-96v256z",
						"M928 512h-160v-160c0-17.674-14.326-32-32-32s-32 14.326-32 32v160h-160c-17.674 0-32 14.326-32 32s14.326 32 32 32h160v160c0 17.674 14.326 32 32 32s32-14.326 32-32v-160h160c17.674 0 32-14.326 32-32s-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-increase",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60829,
					"grid": 16
				},
				{
					"id": 2982,
					"paths": [
						"M549.020 741.020c-12.286 0-24.566-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054z",
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-low",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60817,
					"grid": 16
				},
				{
					"id": 2992,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436zM64 640h96c8.488 0 16.626 3.372 22.628 9.374l201.372 201.37v-677.49l-201.372 201.374c-6.002 6-14.14 9.372-22.628 9.372h-96v256z",
						"M544 640c-17.674 0-32-14.326-32-32v-192c0-17.672 14.326-32 32-32s32 14.328 32 32v192c0 17.674-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-low",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60827,
					"grid": 16
				},
				{
					"id": 187,
					"paths": [
						"M602.19 642.677c-7.438 0-14.814-3.227-19.875-9.446-8.922-10.966-7.264-27.093 3.704-36.014 18.037-14.672 28.381-36.4 28.381-59.616 0-23.218-10.346-44.949-28.382-59.621-10.966-8.922-12.627-25.046-3.704-36.014s25.045-12.626 36.014-3.704c30.040 24.44 47.272 60.645 47.272 99.339 0 38.691-17.23 74.898-47.27 99.334-4.747 3.861-10.462 5.742-16.139 5.742z",
						"M417.291 164.216c-12.64 0-25.318 5.33-37.682 15.838l-209.819 178.346h-92.99c-42.347 0-76.8 34.453-76.8 76.8v204.8c0 42.349 34.453 76.8 76.8 76.8h92.989l209.821 178.346c12.363 10.509 25.040 15.838 37.68 15.838 0 0 0 0 0.002 0 13.931 0 26.429-6.762 34.288-18.55 6.118-9.178 9.221-20.898 9.221-34.834v-640c0-36.877-21.853-53.384-43.509-53.384zM51.2 640v-204.8c0-14.115 11.485-25.6 25.6-25.6h76.8v256h-76.8c-14.115 0-25.6-11.485-25.6-25.6zM409.6 853.442l-204.8-174.080v-283.523l204.8-174.078v631.682z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-low",
						"speaker"
					],
					"defaultCode": 59484,
					"grid": 20
				},
				{
					"id": 2981,
					"paths": [
						"M719.53 831.53c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.744-18.744-49.136 0-67.882 131.006-131.006 131.006-344.17 0-475.176-18.744-18.746-18.744-49.138 0-67.882 18.744-18.742 49.138-18.744 67.882 0 81.594 81.59 126.53 190.074 126.53 305.466 0 115.39-44.936 223.876-126.53 305.47-9.372 9.374-21.656 14.060-33.94 14.060v0zM549.020 741.020c-12.286 0-24.566-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054z",
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-medium",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60816,
					"grid": 16
				},
				{
					"id": 2990,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436zM64 640h96c8.488 0 16.626 3.372 22.628 9.374l201.372 201.37v-677.49l-201.372 201.374c-6.002 6-14.14 9.372-22.628 9.372h-96v256z",
						"M544 640c-17.674 0-32-14.326-32-32v-192c0-17.672 14.326-32 32-32s32 14.328 32 32v192c0 17.674-14.326 32-32 32z",
						"M672 768c-17.674 0-32-14.326-32-32v-448c0-17.672 14.326-32 32-32s32 14.328 32 32v448c0 17.674-14.326 32-32 32z",
						"M800 896c-17.674 0-32-14.326-32-32v-704c0-17.672 14.326-32 32-32s32 14.328 32 32v704c0 17.674-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-medium",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60825,
					"grid": 16
				},
				{
					"id": 2991,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436zM64 640h96c8.488 0 16.626 3.372 22.628 9.374l201.372 201.37v-677.49l-201.372 201.374c-6.002 6-14.14 9.372-22.628 9.372h-96v256z",
						"M544 640c-17.674 0-32-14.326-32-32v-192c0-17.672 14.326-32 32-32s32 14.328 32 32v192c0 17.674-14.326 32-32 32z",
						"M672 768c-17.674 0-32-14.326-32-32v-448c0-17.672 14.326-32 32-32s32 14.328 32 32v448c0 17.674-14.326 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-medium",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60826,
					"grid": 16
				},
				{
					"id": 186,
					"paths": [
						"M699.050 761.893c-7.438 0-14.816-3.227-19.875-9.446-8.922-10.968-7.262-27.093 3.704-36.014 54.096-44.003 85.122-109.187 85.122-178.832s-31.026-134.827-85.12-178.834c-10.968-8.922-12.627-25.046-3.704-36.014s25.046-12.626 36.014-3.702c66.099 53.771 104.010 133.43 104.010 218.55 0 85.122-37.91 164.779-104.011 218.55-4.749 3.862-10.462 5.742-16.139 5.742z",
						"M602.19 642.677c-7.438 0-14.814-3.227-19.875-9.446-8.922-10.966-7.264-27.093 3.704-36.014 18.037-14.672 28.381-36.4 28.381-59.616 0-23.218-10.346-44.949-28.382-59.621-10.966-8.922-12.627-25.046-3.704-36.014s25.045-12.626 36.014-3.704c30.040 24.44 47.272 60.645 47.272 99.339 0 38.691-17.23 74.898-47.27 99.334-4.747 3.861-10.462 5.742-16.139 5.742z",
						"M417.291 164.216c-12.64 0-25.318 5.33-37.682 15.838l-209.819 178.346h-92.99c-42.347 0-76.8 34.453-76.8 76.8v204.8c0 42.349 34.453 76.8 76.8 76.8h92.989l209.821 178.346c12.363 10.509 25.040 15.838 37.68 15.838 0 0 0 0 0.002 0 13.931 0 26.429-6.762 34.288-18.55 6.118-9.178 9.221-20.898 9.221-34.834v-640c0-36.877-21.853-53.384-43.509-53.384zM51.2 640v-204.8c0-14.115 11.485-25.6 25.6-25.6h76.8v256h-76.8c-14.115 0-25.6-11.485-25.6-25.6zM409.6 853.442l-204.8-174.080v-283.523l204.8-174.078v631.682z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-medium",
						"speaker"
					],
					"defaultCode": 59483,
					"grid": 20
				},
				{
					"id": 2983,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-mute",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60818,
					"grid": 16
				},
				{
					"id": 2986,
					"paths": [
						"M960 619.148v84.852h-84.852l-107.148-107.148-107.148 107.148h-84.852v-84.852l107.148-107.148-107.148-107.148v-84.852h84.852l107.148 107.148 107.148-107.148h84.852v84.852l-107.148 107.148 107.148 107.148z",
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-mute",
						"volume",
						"audio",
						"player"
					],
					"defaultCode": 60821,
					"grid": 16
				},
				{
					"id": 2993,
					"paths": [
						"M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436zM64 640h96c8.488 0 16.626 3.372 22.628 9.374l201.372 201.37v-677.49l-201.372 201.374c-6.002 6-14.14 9.372-22.628 9.372h-96v256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-mute",
						"volume",
						"speaker",
						"media control",
						"audio",
						"mute"
					],
					"defaultCode": 60828,
					"grid": 16
				},
				{
					"id": 3003,
					"paths": [
						"M0 320h192l320-320v1024l-320-320h-192v-384zM916.852 512l107.148 107.148v84.852h-84.852l-107.148-107.148-107.148 107.148h-84.852v-84.852l107.148-107.148-107.148-107.148v-84.852h84.852l107.148 107.148 107.148-107.148h84.852v84.852l-107.148 107.148z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-mute",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60838,
					"grid": 16
				},
				{
					"id": 3004,
					"paths": [
						"M704 0l-320 320h-192v384l512-512zM954.176 69.824l-884.352 884.352 69.824 69.824 282.176-282.176 282.176 282.176v-564.354l320-320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-mute",
						"volume",
						"audio",
						"speaker",
						"player"
					],
					"defaultCode": 60839,
					"grid": 16
				},
				{
					"id": 1214,
					"width": 438.85802841186523,
					"paths": [
						"M438.857 201.143v621.714q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-190.286-190.286h-149.714q-14.857 0-25.714-10.857t-10.857-25.714v-219.429q0-14.857 10.857-25.714t25.714-10.857h149.714l190.286-190.286q10.857-10.857 25.714-10.857t25.714 10.857 10.857 25.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-off"
					],
					"defaultCode": 61478,
					"grid": 14
				},
				{
					"id": 1216,
					"width": 950.8590354919434,
					"paths": [
						"M438.857 201.143v621.714q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857l-190.286-190.286h-149.714q-14.857 0-25.714-10.857t-10.857-25.714v-219.429q0-14.857 10.857-25.714t25.714-10.857h149.714l190.286-190.286q10.857-10.857 25.714-10.857t25.714 10.857 10.857 25.714zM658.286 512q0 43.429-24.286 80.857t-64.286 53.429q-5.714 2.857-14.286 2.857-14.857 0-25.714-10.571t-10.857-26q0-12 6.857-20.286t16.571-14.286 19.429-13.143 16.571-20.286 6.857-32.571-6.857-32.571-16.571-20.286-19.429-13.143-16.571-14.286-6.857-20.286q0-15.429 10.857-26t25.714-10.571q8.571 0 14.286 2.857 40 15.429 64.286 53.143t24.286 81.143zM804.571 512q0 87.429-48.571 161.429t-128.571 107.714q-7.429 2.857-14.286 2.857-15.429 0-26.286-10.857t-10.857-25.714q0-22.286 22.286-33.714 32-16.571 43.429-25.143 42.286-30.857 66-77.429t23.714-99.143-23.714-99.143-66-77.429q-11.429-8.571-43.429-25.143-22.286-11.429-22.286-33.714 0-14.857 10.857-25.714t25.714-10.857q7.429 0 14.857 2.857 80 33.714 128.571 107.714t48.571 161.429zM950.857 512q0 131.429-72.571 241.429t-193.143 162q-7.429 2.857-14.857 2.857-14.857 0-25.714-10.857t-10.857-25.714q0-20.571 22.286-33.714 4-2.286 12.857-6t12.857-6q26.286-14.286 46.857-29.143 70.286-52 109.714-129.714t39.429-165.143-39.429-165.143-109.714-129.714q-20.571-14.857-46.857-29.143-4-2.286-12.857-6t-12.857-6q-22.286-13.143-22.286-33.714 0-14.857 10.857-25.714t25.714-10.857q7.429 0 14.857 2.857 120.571 52 193.143 162t72.571 241.429z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"volume-up"
					],
					"defaultCode": 61480,
					"grid": 14
				},
				{
					"id": 919,
					"width": 1024,
					"paths": [
						"M544 800c0 17.664-14.336 32-32 32s-32-14.336-32-32c0-17.664 14.336-32 32-32s32 14.336 32 32zM512 256c17.664 0 32-14.336 32-32s-14.336-32-32-32-32 14.336-32 32c0 17.664 14.336 32 32 32zM224 480c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM896 512c0 211.744-172.256 384-384 384s-384-172.256-384-384 172.256-384 384-384 384 172.256 384 384zM864 512c0-194.4-157.6-352-352-352s-352 157.6-352 352 157.6 352 352 352 352-157.6 352-352zM800 480c-17.664 0-32 14.336-32 32s14.336 32 32 32 32-14.336 32-32c0-17.664-14.336-32-32-32zM960 512c0 247.424-200.576 448-448 448s-448-200.576-448-448 200.576-448 448-448 448 200.576 448 448zM928 512c0-229.376-186.624-416-416-416s-416 186.624-416 416 186.624 416 416 416 416-186.624 416-416zM542.432 519.808c0.64-2.56 1.568-5.056 1.568-7.808 0-11.712-6.592-21.536-16-27.104v-164.896c0-8.832-7.168-16-16-16s-16 7.168-16 16v164.896c-9.408 5.568-16 15.392-16 27.104 0 17.664 14.336 32 32 32 2.752 0 5.248-0.928 7.808-1.568l172.896 172.896c3.104 3.104 7.2 4.672 11.296 4.672s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-172.896-172.896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wait",
						"schedule",
						"time"
					],
					"grid": 32
				},
				{
					"id": 920,
					"width": 1024,
					"paths": [
						"M512 160c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zM224 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM512 192c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32c0-17.664 14.336-32 32-32zM512 832c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM715.328 715.328c-3.136 3.104-7.232 4.672-11.328 4.672s-8.192-1.568-11.328-4.672l-172.896-172.896c-2.528 0.64-5.024 1.568-7.776 1.568-17.664 0-32-14.336-32-32 0-11.712 6.592-21.536 16-27.104v-164.896c0-8.832 7.168-16 16-16s16 7.168 16 16v164.896c9.408 5.568 16 15.392 16 27.104 0 2.752-0.928 5.248-1.568 7.808l172.896 172.896c6.24 6.24 6.24 16.352 0 22.624zM800 544c-17.664 0-32-14.336-32-32s14.336-32 32-32 32 14.336 32 32c0 17.664-14.336 32-32 32zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wait",
						"schedule",
						"time"
					],
					"grid": 32
				},
				{
					"id": 1169,
					"width": 1024,
					"paths": [
						"M512 0c-282.304 0-512 229.696-512 512s229.696 512 512 512 512-229.696 512-512-229.696-512-512-512zM512 960c-247.040 0-448-200.96-448-448s200.96-448 448-448 448 200.96 448 448-200.96 448-448 448zM512 96c-229.76 0-416 186.24-416 416s186.24 416 416 416 416-186.24 416-416-186.24-416-416-416zM512 896c-211.744 0-384-172.256-384-384s172.256-384 384-384 384 172.256 384 384-172.256 384-384 384zM567.136 480c-5.6-9.6-13.536-17.536-23.136-23.136v-200.864h-64v200.864c-19.040 11.072-32 31.488-32 55.136 0 35.36 28.64 64 64 64 23.616 0 44.032-12.96 55.136-32h296.864v-64h-296.864zM512 544c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM480 800h64v64h-64v-64zM160 480h64v64h-64v-64zM544 224h-64v-64h64v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wait",
						"schedule",
						"time"
					],
					"grid": 32
				},
				{
					"id": 2961,
					"paths": [
						"M0 832h256v128h-256v-128z",
						"M320 832h256v128h-256v-128z",
						"M640 832h384v128h-384v-128z",
						"M0 640h384v128h-384v-128z",
						"M448 640h256v128h-256v-128z",
						"M768 640h256v128h-256v-128z",
						"M0 448h256v128h-256v-128z",
						"M320 448h256v128h-256v-128z",
						"M640 448h384v128h-384v-128z",
						"M0 256h384v128h-384v-128z",
						"M448 256h256v128h-256v-128z",
						"M768 256h256v128h-256v-128z",
						"M0 64h256v128h-256v-128z",
						"M320 64h256v128h-256v-128z",
						"M640 64h384v128h-384v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wall",
						"bricks"
					],
					"defaultCode": 60796,
					"grid": 16
				},
				{
					"id": 2085,
					"width": 1088,
					"paths": [
						"M960 128h-832c-70.692 0-128 57.308-128 128v640c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64v-64h64c35.2 0 64-28.8 64-64v-576c0-35.2-28.8-64-64-64zM64 384h32v64h-32v-64zM64 512h32v64h-32v-64zM64 640h32v64h-32v-64zM64 768h32v64h-32v-64zM128 896h-64v-32h64v32zM128 352h-64v-32h64v32zM256 896h-64v-32h64v32zM256 352h-64v-32h64v32zM384 896h-64v-32h64v32zM384 352h-64v-32h64v32zM512 896h-64v-32h64v32zM512 352h-64v-32h64v32zM640 896h-64v-32h64v32zM768 896h-64v-32h64v32zM960 448h-256v192h256v127.884c-0.034 0.040-0.076 0.082-0.116 0.116h-63.884v-64h-256v-320h256v-64c0-35.2-28.8-64-64-64h-768c0-35.29 28.71-64 64-64h831.884c0.040 0.034 0.082 0.076 0.116 0.116v255.884zM832 544c0 17.674-14.326 32-32 32s-32-14.326-32-32 14.326-32 32-32 32 14.326 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wallet",
						"money",
						"cash",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59920,
					"grid": 16
				},
				{
					"id": 921,
					"width": 1024,
					"paths": [
						"M992 160h-64c-17.664 0-32 14.336-32 32h-32v-32c0-35.36-28.64-64-64-64s-64 28.64-64 64v32h-32v-32c0-35.36-28.64-64-64-64s-64 28.64-64 64v32h-32v-32c0-35.36-28.64-64-64-64s-64 28.64-64 64v32h-32v-32c0-35.36-28.64-64-64-64s-64 28.64-64 64v32h-32v-32c0-35.36-28.64-64-64-64s-64 28.64-64 64v32h-32c-17.664 0-32 14.336-32 32-17.664 0-32 14.336-32 32s14.336 32 32 32c0 17.664 14.336 32 32 32h32v384h-32c-17.664 0-32 14.336-32 32-17.664 0-32 14.336-32 32s14.336 32 32 32c0 17.664 14.336 32 32 32h32v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h32v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h32v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h32v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h32v32c0 35.36 28.64 64 64 64s64-28.64 64-64v-32h32c17.664 0 32-14.336 32-32 17.664 0 32-14.336 32-32s-14.336-32-32-32c0-17.664-14.336-32-32-32h-32v-384h32c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM736 224v64h-32v-64h32zM736 320v384h-32v-384h32zM576 224v64h-32v-64h32zM576 320v384h-32v-384h32zM416 224v64h-32v-64h32zM416 320v384h-32v-384h32zM256 224v64h-32v-64h32zM256 320v384h-32v-384h32zM64 288v-64h32v64h-32zM64 800v-64h32v64h-32zM192 864c0 17.632-14.368 32-32 32s-32-14.368-32-32v-704c0-17.632 14.368-32 32-32s32 14.368 32 32v704zM224 800v-64h32v64h-32zM352 864c0 17.632-14.368 32-32 32s-32-14.368-32-32v-704c0-17.632 14.368-32 32-32s32 14.368 32 32v704zM384 800v-64h32v64h-32zM512 864c0 17.632-14.368 32-32 32s-32-14.368-32-32v-704c0-17.632 14.368-32 32-32s32 14.368 32 32v704zM544 800v-64h32v64h-32zM672 864c0 17.632-14.368 32-32 32s-32-14.368-32-32v-704c0-17.632 14.368-32 32-32s32 14.368 32 32v704zM704 800v-64h32v64h-32zM896 736v64h-32v-64h32zM832 704v160c0 17.632-14.368 32-32 32s-32-14.368-32-32v-704c0-17.632 14.368-32 32-32s32 14.368 32 32v544zM864 288v-64h32v64h-32zM992 320h-64v-128h64v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"warm",
						"heat",
						"radiate"
					],
					"grid": 32
				},
				{
					"id": 922,
					"width": 1024,
					"paths": [
						"M384 864c0 35.36-28.64 64-64 64s-64-28.64-64-64v-704c0-35.36 28.64-64 64-64s64 28.64 64 64v704zM224 160c0-35.36-28.64-64-64-64s-64 28.64-64 64v704c0 35.36 28.64 64 64 64s64-28.64 64-64v-704zM64 704c-17.664 0-32 14.336-32 32-17.664 0-32 14.336-32 32s14.336 32 32 32c0 17.664 14.336 32 32 32v-128zM32 288c0 17.664 14.336 32 32 32v-128c-17.664 0-32 14.336-32 32-17.664 0-32 14.336-32 32s14.336 32 32 32zM704 160c0-35.36-28.64-64-64-64s-64 28.64-64 64v704c0 35.36 28.64 64 64 64s64-28.64 64-64v-704zM992 160h-64c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM928 736c0-17.664-14.336-32-32-32v128c17.664 0 32-14.336 32-32 17.664 0 32-14.336 32-32s-14.336-32-32-32zM864 160c0-35.36-28.64-64-64-64s-64 28.64-64 64v704c0 35.36 28.64 64 64 64s64-28.64 64-64v-704zM544 160c0-35.36-28.64-64-64-64s-64 28.64-64 64v704c0 35.36 28.64 64 64 64s64-28.64 64-64v-704z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"warm",
						"heat",
						"radiate"
					],
					"grid": 32
				},
				{
					"id": 1170,
					"width": 1024,
					"paths": [
						"M864 224h-88.032c-52.416-134.912-181.376-224-327.968-224-132.736 0-253.536 74.688-313.44 192h-102.56c-11.104 0-21.376 5.728-27.232 15.168-5.824 9.44-6.368 21.216-1.408 31.136l92.64 185.248v568.448c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-608h32v320c0 17.664 14.336 32 32 32h96c17.664 0 32-14.336 32-32v-352c0-70.592-57.408-128-128-128zM160 896h576v64h-576v-64zM160 864v-512c0-33.696 6.112-65.92 16.8-96h542.4c10.688 30.080 16.8 62.304 16.8 96v512h-576zM448 64c112.8 0 210.368 65.344 257.6 160h-515.2c47.232-94.656 144.8-160 257.6-160zM142.688 256c-8.864 28.224-13.696 58.176-14.336 89.152v0l-44.576-89.152h58.912zM761.568 288h102.432c35.296 0 64 28.704 64 64v320h-32v-320c0-17.664-14.336-32-32-32h-97.6c-1.088-10.848-2.688-21.504-4.832-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"warm",
						"boil",
						"heat",
						"brew"
					],
					"grid": 32
				},
				{
					"id": 2916,
					"paths": [
						"M512 92.774l429.102 855.226h-858.206l429.104-855.226zM512 0c-22.070 0-44.14 14.882-60.884 44.648l-437.074 871.112c-33.486 59.532-5 108.24 63.304 108.24h869.308c68.3 0 96.792-48.708 63.3-108.24h0.002l-437.074-871.112c-16.742-29.766-38.812-44.648-60.882-44.648v0z",
						"M576 832c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
						"M512 704c-35.346 0-64-28.654-64-64v-192c0-35.346 28.654-64 64-64s64 28.654 64 64v192c0 35.346-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"warning",
						"sign"
					],
					"defaultCode": 60751,
					"grid": 16
				},
				{
					"id": 2917,
					"paths": [
						"M1009.956 915.76v0l-437.074-871.112c-16.742-29.766-38.812-44.648-60.882-44.648s-44.14 14.882-60.884 44.648l-437.074 871.112c-33.486 59.532-5 108.24 63.304 108.24h869.308c68.302 0 96.792-48.708 63.302-108.24zM512 896c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.348 0 64 28.652 64 64s-28.652 64-64 64zM576 640c0 35.346-28.654 64-64 64s-64-28.654-64-64v-192c0-35.346 28.654-64 64-64s64 28.654 64 64v192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"warning",
						"sign"
					],
					"defaultCode": 60752,
					"grid": 16
				},
				{
					"id": 219,
					"paths": [
						"M947.2 972.8h-921.6c-9.094 0-17.507-4.826-22.099-12.677s-4.672-17.547-0.214-25.474l460.8-819.2c4.536-8.061 13.066-13.050 22.314-13.050s17.778 4.989 22.312 13.050l460.8 819.2c4.459 7.926 4.376 17.624-0.214 25.474-4.592 7.851-13.002 12.677-22.098 12.677zM69.371 921.6h834.056l-417.027-741.382-417.029 741.382z",
						"M486.4 716.8c-14.138 0-25.6-11.461-25.6-25.6v-256c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v256c0 14.139-11.462 25.6-25.6 25.6z",
						"M486.4 870.4c-14.138 0-25.6-11.461-25.6-25.6v-51.2c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v51.2c0 14.139-11.462 25.6-25.6 25.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"warning",
						"alert"
					],
					"defaultCode": 59516,
					"grid": 20
				},
				{
					"id": 923,
					"width": 1024,
					"paths": [
						"M640 290.208v-66.208c0-17.664-14.336-32-32-32h-32v-64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-256c-17.664 0-32 14.336-32 32v5.76c0 15.264 10.752 28.384 25.728 31.392l134.272 26.848v64h-32c-17.664 0-32 14.336-32 32v66.208c-126.24 15.776-224 123.264-224 253.792v352c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-352c0-130.528-97.76-238.016-224-253.792zM320 64h256v32h-124.832l-131.168-26.24v-5.76zM480 128h64v64h-64v-64zM416 224h192v64h-192v-64zM416 320h192c123.52 0 224 100.48 224 224h-640c0-123.52 100.48-224 224-224zM768 960h-512c-35.296 0-64-28.704-64-64v-320h640v320c0 35.296-28.704 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wash",
						"clean",
						"cleanse"
					],
					"grid": 32
				},
				{
					"id": 924,
					"width": 1024,
					"paths": [
						"M288 69.76v-5.76c0-17.664 14.336-32 32-32h256c17.664 0 32 14.336 32 32v32c0 17.664-14.336 32-32 32v32h-128v-32l-134.272-26.848c-14.976-3.008-25.728-16.128-25.728-31.392zM160 576v320c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-320h-704zM640 290.208v-66.208c0-17.664-14.336-32-32-32h-192c-17.664 0-32 14.336-32 32v66.208c-126.24 15.776-224 123.264-224 253.792h704c0-130.528-97.76-238.016-224-253.792z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wash",
						"clean",
						"cleanse"
					],
					"grid": 32
				},
				{
					"id": 1171,
					"width": 1024,
					"paths": [
						"M416 640h-32v-64h32v64zM640 576h-32v64h32v-64zM992 384v512c0 17.664-14.336 32-32 32h-96v32c0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32v-32h-512v32c0 17.664-14.336 32-32 32h-32c-17.664 0-32-14.336-32-32v-32h-96c-17.664 0-32-14.336-32-32v-512c0-17.664 14.336-32 32-32h264.16c-25.824-37.024-40.16-81.472-40.16-128v-32c0-17.664 14.336-32 32-32h64v-32c0-17.696 14.304-32 32-32s32 14.304 32 32v32h32v-96c0-17.696 14.304-32 32-32s32 14.304 32 32v96h32v-32c0-17.696 14.304-32 32-32s32 14.304 32 32v32h64c17.664 0 32 14.336 32 32v32c0 46.528-14.336 90.976-40.16 128h264.16c17.664 0 32 14.336 32 32zM928 416h-352v448h352v-448zM448 864v-448h-352v448h352zM352 224c0 88.224 71.776 160 160 160s160-71.776 160-160h-320zM480 416v448h64v-448h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wash",
						"clean",
						"cleanse",
						"rinse"
					],
					"grid": 32
				},
				{
					"id": 2150,
					"paths": [
						"M704 192h-32l-32-192h-320l-32 192h-32c-70.4 0-128 48-128 106.666v426.666c0 58.668 57.6 106.668 128 106.668h32l32 192h320l32-192h32c70.4 0 128-48 128-106.666v-426.668c0-58.666-57.6-106.666-128-106.666zM768 725.334c0 12.202-9.128 21.63-14.572 26.166-12.582 10.486-30.598 16.5-49.428 16.5h-448c-18.83 0-36.846-6.014-49.428-16.5-5.442-4.536-14.572-13.964-14.572-26.166v-426.668c0-12.202 9.13-21.632 14.572-26.166 12.584-10.486 30.598-16.5 49.428-16.5h448c18.83 0 36.846 6.014 49.428 16.5 5.444 4.534 14.572 13.964 14.572 26.166v426.668z",
						"M416 384h-128c-17.672 0-32 14.328-32 32s14.328 32 32 32h96v64h-96c-17.672 0-32 14.326-32 32v128c0 17.674 14.328 32 32 32h128c17.672 0 32-14.326 32-32s-14.328-32-32-32h-96v-64h96c17.672 0 32-14.326 32-32v-128c0-17.672-14.326-32-32-32z",
						"M672 384c-17.674 0-32 14.328-32 32v96h-64v-96c0-17.672-14.326-32-32-32s-32 14.328-32 32v128c0 17.674 14.326 32 32 32h96v96c0 17.674 14.326 32 32 32s32-14.326 32-32v-256c0-17.672-14.326-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"watch",
						"time",
						"wrist-watch",
						"clock"
					],
					"defaultCode": 59985,
					"grid": 16
				},
				{
					"id": 2151,
					"paths": [
						"M608 512h-96v-160c0-17.672-14.328-32-32-32s-32 14.328-32 32v192c0 17.674 14.328 32 32 32h128c17.674 0 32-14.326 32-32s-14.326-32-32-32z",
						"M896 512c0-154.982-91.832-288.482-224.036-349.15h0.036l-32-162.85h-256l-32 162.85h0.036c-132.204 60.666-224.036 194.166-224.036 349.15 0 154.978 91.826 288.476 224.026 349.144l-0.028 0.004 32.002 162.852h256l32-162.852h-0.034c132.202-60.666 224.034-194.168 224.034-349.148zM512 800c-159.058 0-288-128.942-288-288s128.942-288 288-288c159.056 0 288 128.942 288 288s-128.942 288-288 288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"watch",
						"time",
						"wrist-watch",
						"clock"
					],
					"defaultCode": 59986,
					"grid": 16
				},
				{
					"id": 925,
					"width": 1024,
					"paths": [
						"M768 192h-672c-17.664 0-32 14.336-32 32v576c0 17.664 14.336 32 32 32h672c17.664 0 32-14.336 32-32v-576c0-17.664-14.336-32-32-32zM768 800h-672v-576h672v576zM928 128h-832c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h832c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM992 800c0 35.36-28.64 64-64 64h-832c-35.36 0-64-28.64-64-64v-576c0-35.36 28.64-64 64-64h832c35.36 0 64 28.64 64 64v576zM896 224c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM896 320c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32zM896 384c-35.36 0-64 28.64-64 64s28.64 64 64 64c35.36 0 64-28.64 64-64s-28.64-64-64-64zM896 480c-17.632 0-32-14.368-32-32s14.368-32 32-32 32 14.368 32 32-14.368 32-32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"watch",
						"view"
					],
					"grid": 32
				},
				{
					"id": 926,
					"width": 1024,
					"paths": [
						"M928 448c0 17.632-14.368 32-32 32s-32-14.368-32-32 14.368-32 32-32 32 14.368 32 32zM896 256c-17.632 0-32 14.368-32 32s14.368 32 32 32 32-14.368 32-32-14.368-32-32-32zM96 800h672v-576h-672v576zM1024 224v576c0 53.024-42.976 96-96 96h-832c-53.024 0-96-42.976-96-96v-576c0-53.024 42.976-96 96-96h832c53.024 0 96 42.976 96 96zM800 224c0-17.664-14.336-32-32-32h-672c-17.664 0-32 14.336-32 32v576c0 17.664 14.336 32 32 32h672c17.664 0 32-14.336 32-32v-576zM960 448c0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64c35.36 0 64-28.64 64-64zM960 288c0-35.36-28.64-64-64-64s-64 28.64-64 64 28.64 64 64 64c35.36 0 64-28.672 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"watch",
						"view"
					],
					"grid": 32
				},
				{
					"id": 1172,
					"width": 1024,
					"paths": [
						"M566.624 160l116.672-116.672-22.624-22.624-139.296 139.296h-18.752l-139.328-139.328-22.624 22.624 116.704 116.704h-425.376c-17.664 0-32 14.336-32 32v704c0 17.664 14.336 32 32 32h960c17.664 0 32-14.336 32-32v-704c0-17.664-14.336-32-32-32h-425.376zM960 864h-896v-640h896v640zM928 256h-832v512h832v-512zM896 736h-768v-448h768v448zM128 832h-32v-32h32v32zM160 800h32v32h-32v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"watch",
						"view"
					],
					"grid": 32
				},
				{
					"id": 3014,
					"paths": [
						"M832 320h128v384c0 34.502-6.786 68.042-20.17 99.686-12.9 30.5-31.342 57.866-54.81 81.334s-50.834 41.91-81.334 54.81c-31.644 13.384-65.182 20.17-99.686 20.17s-68.042-6.786-99.686-20.17c-30.5-12.9-57.866-31.342-81.334-54.81s-41.91-50.834-54.81-81.334c-13.384-31.644-20.17-65.182-20.17-99.686v-384c0-70.692-57.308-128-128-128s-128 57.308-128 128v384h-128v-384c0-34.502 6.786-68.042 20.17-99.686 12.9-30.5 31.342-57.864 54.81-81.334 23.47-23.468 50.834-41.91 81.334-54.81 31.644-13.384 65.184-20.17 99.686-20.17s68.042 6.786 99.686 20.17c30.5 12.9 57.864 31.342 81.334 54.81 23.468 23.47 41.91 50.834 54.81 81.334 13.384 31.644 20.17 65.184 20.17 99.686v384c0 70.694 57.308 128 128 128s128-57.308 128-128v-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wave"
					],
					"defaultCode": 60849,
					"grid": 16
				},
				{
					"id": 3015,
					"width": 1152,
					"paths": [
						"M1024 256h128v512c0 105.87-86.13 192-192 192s-192-86.13-192-192v-512c0-35.29-28.71-64-64-64s-64 28.71-64 64v512c0 105.87-86.13 192-192 192s-192-86.13-192-192v-512c0-35.29-28.71-64-64-64s-64 28.71-64 64v512h-128v-512c0-105.87 86.13-192 192-192s192 86.13 192 192v512c0 35.29 28.71 64 64 64s64-28.71 64-64v-512c0-105.87 86.13-192 192-192s192 86.13 192 192v512c0 35.29 28.71 64 64 64s64-28.71 64-64v-512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wave"
					],
					"defaultCode": 60850,
					"grid": 16
				},
				{
					"id": 927,
					"width": 1024,
					"paths": [
						"M964.704 453.088c-18.144-21.088-43.424-31.584-68.704-31.584-23.168 0-46.336 8.832-64 26.496v-56.736c0-93.664-64-178.432-156-195.872-63.232-12-121.856 8.64-164 45.76-34.016-29.888-74.368-47.328-120.448-49.024-109.664-4.064-199.552 90.304-199.552 200.032v55.84c-17.664-17.664-40.832-26.496-64-26.496-25.28 0-50.56 10.528-68.704 31.584-31.456 36.512-25.952 92.256 8.096 126.336l92.608 92.576v128c0 53.024 42.976 96 96 96h512c53.024 0 96-42.976 96-96v-128l92.608-92.608c34.080-34.080 39.552-89.824 8.096-126.304zM86.624 553.376c-22.816-22.816-22.816-59.936 0-82.752 11.040-11.040 25.76-17.12 41.376-17.12s30.336 6.080 41.376 17.152l54.624 54.592v-141.248c0-88.224 71.776-160 160-160 40.672 0 76.864 15.040 105.664 40.8-25.664 32.672-41.664 74.112-41.664 119.2v288h-242.752l-118.624-118.624zM192 800v-96h256v96c0 24.704 9.6 46.976 24.928 64h-216.928c-35.36 0-64-28.64-64-64zM832 800c0 35.36-28.64 64-64 64h-224c-35.36 0-64-28.64-64-64v-96h352v96zM937.376 553.376l-118.624 118.624h-338.752v-288c0-88.224 71.776-160 160-160s160 71.776 160 160v141.248l54.624-54.624c11.040-11.040 25.728-17.152 41.376-17.152s30.336 6.080 41.376 17.152c22.816 22.816 22.816 59.936 0 82.752z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wear",
						"match",
						"warm",
						"cover"
					],
					"grid": 32
				},
				{
					"id": 928,
					"width": 1024,
					"paths": [
						"M416 672h-256l-92.608-92.608c-34.080-34.080-39.552-89.824-8.096-126.336 18.144-21.056 43.424-31.552 68.704-31.552 23.168 0 46.336 8.832 64 26.496v-55.84c0-109.728 89.888-204.096 199.552-200.032 34.912 1.312 66.496 11.68 94.56 29.6-43.072 40.8-70.112 98.272-70.112 162.272v288zM416 800c0 38.464 17.312 72.544 44.128 96h-204.128c-53.024 0-96-42.976-96-96v-96h256v96zM256 752c0-8.832-7.168-16-16-16s-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64zM320 752c0-8.832-7.168-16-16-16s-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64zM384 752c0-8.832-7.168-16-16-16s-16 7.168-16 16v64c0 8.832 7.168 16 16 16s16-7.168 16-16v-64zM964.704 453.088c-18.144-21.088-43.424-31.584-68.704-31.584-23.168 0-46.336 8.832-64 26.496v-56.736c0-93.664-64-178.432-156-195.872-63.232-12-121.856 8.64-164 45.76l0.064 0.064c-39.2 35.2-64.064 86.080-64.064 142.784v288h416l92.608-92.608c34.080-34.080 39.552-89.824 8.096-126.304zM448 704h416v96c0 53.024-42.976 96-96 96h-224.032c-52.928-0.032-95.968-43.072-95.968-96v-96zM768 816c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16s-16 7.168-16 16v64zM704 816c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16s-16 7.168-16 16v64zM640 816c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16s-16 7.168-16 16v64zM576 816c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16s-16 7.168-16 16v64zM512 816c0 8.832 7.168 16 16 16s16-7.168 16-16v-64c0-8.832-7.168-16-16-16s-16 7.168-16 16v64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wear",
						"match",
						"warm",
						"cover"
					],
					"grid": 32
				},
				{
					"id": 1173,
					"width": 1024,
					"paths": [
						"M928 480h-55.744l55.488-444.032c1.152-9.088-1.696-18.24-7.744-25.152-6.080-6.88-14.816-10.816-24-10.816h-768c-9.184 0-17.92 3.936-24 10.816-6.048 6.912-8.896 16.064-7.744 25.152l55.488 444.032h-55.744c-17.696 0-32 14.304-32 32v160c0 17.696 14.304 32 32 32h72.256c33.184 195.392 165.664 320 343.744 320s310.56-124.608 343.744-320h72.256c17.696 0 32-14.304 32-32v-160c0-17.696-14.304-32-32-32zM859.744 64l-44 352h-607.488l-44-352h695.488zM804.608 512h-31.712l35.296-35.296-3.904 31.328c-0.224 1.344 0.32 2.624 0.32 3.968zM212.256 448h36.32l-32.288 32.288-4.032-32.288zM293.824 448h45.248l-64 64h-45.248l64-64zM384.32 448h45.248l-64 64h-45.248l64-64zM474.848 448h45.248l-64 64h-45.248l64-64zM565.344 448h45.248l-64 64h-45.248l64-64zM655.872 448h45.248l-64 64h-45.248l64-64zM746.368 448h45.248l-64 64h-45.248l64-64zM512 960c-150.848 0-261.792-112.96-283.648-288h567.296c-21.856 175.040-132.8 288-283.648 288zM896 640h-768v-96h768v96zM448 864h128v32h-128v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wear",
						"cover"
					],
					"grid": 32
				},
				{
					"id": 2781,
					"paths": [
						"M891.004 680.062c76.314 18.578 132.996 87.392 132.996 169.48 0 96.234-77.872 174.262-174.010 174.446v0.012h-656.26c-106.996 0-193.73-86.786-193.73-193.848 0-107.056 86.734-193.844 193.734-193.844 11.8 0 23.348 1.116 34.566 3.14-0.882-6.196-1.364-12.52-1.364-18.956 0-73.846 59.832-133.722 133.642-133.722 43.018 0 81.266 20.362 105.708 51.96 43.59-55.236 111.064-90.73 186.856-90.73 129.404 0 234.62 103.364 237.862 232.062v0z",
						"M360.58 438.772c37.8 0 73.708 11.472 103.73 32.456 48.416-42.768 109.732-67.822 175.136-70.9-8.048-116.398-105.002-208.328-223.446-208.328-123.71 0-224 100.29-224 224 0 34.824 7.948 67.79 22.124 97.186 33.090-45.076 86.4-74.414 146.456-74.414z",
						"M416 0c17.672 0 32 14.328 32 32v64c0 17.672-14.328 32-32 32s-32-14.328-32-32v-64c0-17.672 14.328-32 32-32z",
						"M0 416c0-17.672 14.328-32 32-32h64c17.674 0 32 14.328 32 32s-14.326 32-32 32h-64c-17.672 0-32-14.328-32-32z",
						"M672 192c-8.19 0-16.378-3.124-22.626-9.372-12.498-12.498-12.498-32.758 0-45.256l64-64c12.496-12.496 32.758-12.496 45.254 0 12.498 12.498 12.498 32.758 0 45.256l-64 64c-6.248 6.248-14.438 9.372-22.628 9.372z",
						"M160 192c-8.19 0-16.378-3.124-22.628-9.372l-64-64c-12.496-12.498-12.496-32.758 0-45.256 12.498-12.496 32.758-12.496 45.256 0l64 64c12.496 12.498 12.496 32.758 0 45.256-6.248 6.248-14.438 9.372-22.628 9.372z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-cloud-sun",
						"weather"
					],
					"defaultCode": 60616,
					"grid": 16
				},
				{
					"id": 2782,
					"paths": [
						"M416 0c17.672 0 32 14.328 32 32v64c0 17.672-14.328 32-32 32s-32-14.328-32-32v-64c0-17.672 14.328-32 32-32z",
						"M0 416c0-17.672 14.328-32 32-32h64c17.674 0 32 14.328 32 32s-14.326 32-32 32h-64c-17.672 0-32-14.328-32-32z",
						"M672 192c-8.19 0-16.378-3.124-22.626-9.372-12.498-12.498-12.498-32.758 0-45.256l64-64c12.496-12.496 32.758-12.496 45.254 0 12.498 12.498 12.498 32.758 0 45.256l-64 64c-6.248 6.248-14.438 9.372-22.628 9.372z",
						"M160 192c-8.19 0-16.378-3.124-22.628-9.372l-64-64c-12.496-12.498-12.496-32.758 0-45.256 12.498-12.496 32.758-12.496 45.256 0l64 64c12.496 12.498 12.496 32.758 0 45.256-6.248 6.248-14.438 9.372-22.628 9.372z",
						"M768 512c-24.634 0-48.706 3.458-71.688 10.118-10.28-35.132-30.338-66.020-56.936-89.626 0.4-5.488 0.624-10.994 0.624-16.49 0-123.514-100.486-224-224-224s-224 100.484-224 223.998c0 39.166 10.19 77.188 29.224 110.656-54.962 25.354-93.224 80.948-93.224 145.344 0 11.674 1.294 23.252 3.786 34.542-74.808 13.372-131.786 78.864-131.786 157.458 0 88.224 71.776 160 160 160h608c68.38 0 132.668-26.628 181.018-74.98 48.354-48.352 74.982-112.64 74.982-181.020 0-141.158-114.842-256-256-256zM256 416c0-88.224 71.776-160 160-160 80.924 0 147.964 60.402 158.512 138.482-19.64-6.79-40.68-10.482-62.512-10.482-85.432 0-158 56.092-182.836 133.378-13.366-3.55-27.21-5.378-41.164-5.378-0.002 0-0.006 0-0.008 0-20.72-27.588-31.992-61.162-31.992-96zM903.762 903.764c-36.262 36.264-84.476 56.236-135.762 56.236h-608c-52.934 0-96-43.064-96-96s43.066-96 96-96h64c17.672 0 32-14.326 32-32s-14.328-32-32-32h-26.516c-3.602-10.216-5.484-21.036-5.484-32 0-52.936 43.066-96 96-96 10.988 0 21.84 1.91 32.086 5.536 0.32 11.154 1.592 22.272 3.814 33.124 3.1 15.15 16.432 25.592 31.318 25.592 2.124 0 4.284-0.212 6.446-0.654 17.316-3.542 28.48-20.452 24.938-37.766-1.726-8.436-2.6-17.126-2.6-25.832 0-70.58 57.42-128 128-128 60.6 0 112.066 42.568 124.902 99.99-18.69 11.188-36.084 24.85-51.76 40.848-12.37 12.624-12.164 32.882 0.458 45.252 12.624 12.372 32.884 12.166 45.252-0.458 15.71-16.034 33.712-28.95 53.278-38.464 0.882-0.374 1.746-0.78 2.584-1.228 25.1-11.742 52.688-17.94 81.284-17.94 105.87 0 192 86.13 192 192 0 51.286-19.972 99.5-56.238 135.764z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-cloud-sun",
						"weather"
					],
					"defaultCode": 60617,
					"grid": 16
				},
				{
					"id": 2779,
					"paths": [
						"M272.198 827.904c-84.964 0-169.99-21.090-254.49-63.274-15.812-7.894-22.232-27.112-14.338-42.924s27.112-22.23 42.924-14.338c75.272 37.58 151.274 56.632 225.894 56.632 74.606 0 150.47-19.046 225.484-56.614 169.040-84.384 340.164-84.378 508.658 0 15.802 7.914 22.198 27.14 14.286 42.942-7.916 15.802-27.14 22.196-42.942 14.286-75.016-37.568-150.878-56.614-225.486-56.614-74.622 0-150.624 19.052-225.894 56.63-84.232 42.182-169.132 63.274-254.096 63.274z",
						"M272.198 1019.904c-84.964 0-169.99-21.090-254.49-63.274-15.812-7.894-22.232-27.112-14.338-42.924s27.112-22.228 42.924-14.338c75.272 37.58 151.274 56.632 225.894 56.632 74.606 0 150.47-19.046 225.484-56.614 169.040-84.384 340.164-84.378 508.658 0 15.802 7.914 22.198 27.14 14.286 42.942-7.916 15.802-27.14 22.196-42.942 14.286-75.016-37.568-150.878-56.614-225.486-56.614-74.622 0-150.624 19.052-225.894 56.63-84.232 42.182-169.132 63.274-254.096 63.274z",
						"M891.004 232.062c76.314 18.58 132.996 87.392 132.996 169.48 0 96.236-77.872 174.262-174.010 174.446v0.012h-656.26c-106.996 0-193.73-86.786-193.73-193.848 0-107.056 86.734-193.844 193.734-193.842 11.8 0 23.348 1.114 34.566 3.138-0.882-6.194-1.364-12.518-1.364-18.954 0-73.846 59.832-133.722 133.642-133.722 43.018 0 81.266 20.362 105.708 51.96 43.59-55.238 111.064-90.732 186.856-90.732 129.404 0 234.62 103.362 237.862 232.062v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-cloud-wind",
						"weather"
					],
					"defaultCode": 60614,
					"grid": 16
				},
				{
					"id": 2780,
					"paths": [
						"M768 128c-24.634 0-48.706 3.458-71.688 10.118-23.424-80.076-97.658-138.118-184.312-138.118-85.432 0-158 56.092-182.836 133.378-13.366-3.548-27.208-5.378-41.164-5.378-88.224 0-160 71.776-160 160 0 11.672 1.294 23.252 3.786 34.542-74.808 13.372-131.786 78.864-131.786 157.458 0 88.224 71.776 160 160 160h192c17.672 0 32-14.326 32-32s-14.328-32-32-32h-192c-52.934 0-96-43.066-96-96s43.066-96 96-96h64c17.672 0 32-14.328 32-32s-14.328-32-32-32h-26.516c-3.602-10.216-5.484-21.036-5.484-32 0-52.934 43.066-96 96-96 10.99 0 21.842 1.91 32.086 5.534 0.32 11.154 1.592 22.272 3.814 33.126 3.1 15.152 16.432 25.592 31.318 25.592 2.124 0 4.284-0.212 6.446-0.656 17.316-3.542 28.48-20.45 24.938-37.764-1.726-8.434-2.6-17.126-2.6-25.832 0-70.58 57.42-128 128-128 60.6 0 112.066 42.566 124.902 99.99-18.69 11.188-36.084 24.85-51.76 40.848-12.37 12.624-12.164 32.882 0.458 45.252 12.624 12.37 32.884 12.166 45.252-0.458 36.418-37.166 85.124-57.632 137.146-57.632 105.87 0 192 86.13 192 192 0 51.286-19.972 99.5-56.236 135.762-12.496 12.498-12.498 32.758-0.002 45.256 6.25 6.25 14.438 9.374 22.628 9.374s16.378-3.124 22.626-9.372c48.356-48.352 74.984-112.64 74.984-181.020 0-141.16-114.842-256-256-256z",
						"M272.198 827.904c-84.964 0-169.99-21.090-254.49-63.274-15.812-7.894-22.232-27.112-14.338-42.924s27.112-22.23 42.924-14.338c75.272 37.58 151.274 56.632 225.894 56.632 74.606 0 150.47-19.046 225.484-56.614 169.040-84.384 340.164-84.378 508.658 0 15.802 7.914 22.198 27.14 14.286 42.942-7.916 15.802-27.14 22.196-42.942 14.286-75.016-37.568-150.878-56.614-225.486-56.614-74.622 0-150.624 19.052-225.894 56.63-84.232 42.182-169.132 63.274-254.096 63.274z",
						"M272.198 1019.904c-84.964 0-169.99-21.090-254.49-63.274-15.812-7.894-22.232-27.112-14.338-42.924s27.112-22.228 42.924-14.338c75.272 37.58 151.274 56.632 225.894 56.632 74.606 0 150.47-19.046 225.484-56.614 169.040-84.384 340.164-84.378 508.658 0 15.802 7.914 22.198 27.14 14.286 42.942-7.916 15.802-27.14 22.196-42.942 14.286-75.016-37.568-150.878-56.614-225.486-56.614-74.622 0-150.624 19.052-225.894 56.63-84.232 42.182-169.132 63.274-254.096 63.274z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-cloud-wind",
						"weather"
					],
					"defaultCode": 60615,
					"grid": 16
				},
				{
					"id": 2783,
					"paths": [
						"M168.57 509.528c21.126-86.428 99.2-150.756 192.010-150.756 36.858 0 72.062 10.022 102.484 28.532 53.23-43.32 119.78-67.302 190.078-67.302 79.328 0 154.256 30.544 210.984 86.006 45.726 44.708 75.574 101.618 86.402 163.536 9.246 4.338 18.196 9.288 26.814 14.766 28.946-31.146 46.658-72.882 46.658-118.768 0-82.088-56.682-150.9-132.996-169.48-3.242-128.7-108.458-232.062-237.862-232.062-75.792 0-143.266 35.494-186.854 90.732-24.442-31.598-62.69-51.96-105.708-51.96-73.81 0-133.642 59.876-133.642 133.722 0 6.436 0.48 12.76 1.364 18.954-11.218-2.024-22.766-3.138-34.566-3.138-107.002-0.002-193.736 86.786-193.736 193.842 0 43.016 14.010 82.75 37.702 114.906 37.062-28.288 81.988-46.768 130.868-51.53z",
						"M891.004 616.062c76.314 18.578 132.996 87.392 132.996 169.48 0 96.234-77.872 174.262-174.010 174.446v0.012h-656.26c-106.996 0-193.73-86.786-193.73-193.848 0-107.056 86.734-193.844 193.734-193.844 11.8 0 23.348 1.116 34.566 3.14-0.882-6.196-1.364-12.52-1.364-18.956 0-73.846 59.832-133.722 133.642-133.722 43.018 0 81.266 20.362 105.708 51.96 43.59-55.236 111.064-90.73 186.856-90.73 129.404 0 234.62 103.362 237.862 232.062v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-cloudy",
						"weather"
					],
					"defaultCode": 60618,
					"grid": 16
				},
				{
					"id": 2784,
					"paths": [
						"M131.784 706.542c-0.386-1.754-0.744-3.512-1.070-5.278-74.28-13.802-130.714-79.046-130.714-157.264 0-78.594 56.976-144.086 131.786-157.458-2.492-11.29-3.786-22.87-3.786-34.542 0-88.224 71.776-160 160-160 13.956 0 27.796 1.83 41.164 5.378 24.838-77.286 97.404-133.378 182.836-133.378 86.654 0 160.886 58.042 184.312 138.118 22.982-6.66 47.052-10.118 71.688-10.118 141.158 0 256 114.84 256 256 0 58.944-19.802 114.834-56.232 160.11 35.162 43.842 56.232 99.446 56.232 159.89 0 141.158-114.84 256-256 256h-608c-88.224 0-160-71.776-160-160 0-78.594 56.976-144.086 131.784-157.458zM768 256c-52.024 0-100.73 20.466-137.146 57.63-12.37 12.624-32.63 12.828-45.252 0.458-12.624-12.37-12.83-32.628-0.46-45.252 15.676-15.998 33.070-29.66 51.76-40.848-12.838-57.422-64.302-99.988-124.902-99.988-70.58 0-128 57.42-128 128 0 8.706 0.876 17.398 2.602 25.832 3.542 17.316-7.624 34.222-24.938 37.764-2.164 0.444-4.32 0.656-6.448 0.656-14.884 0-28.218-10.442-31.318-25.592-2.218-10.854-3.494-21.972-3.812-33.126-10.244-3.624-21.096-5.534-32.086-5.534-52.936 0-96 43.066-96 96 0 10.964 1.88 21.784 5.484 32h26.516c17.674 0 32 14.328 32 32s-14.326 32-32 32h-64c-52.934 0-96 43.066-96 96 0 43.256 28.764 79.908 68.164 91.872 16.43-70.876 80.038-123.872 155.836-123.872 13.956 0 27.796 1.828 41.164 5.378 24.838-77.286 97.404-133.378 182.836-133.378 86.654 0 160.884 58.042 184.312 138.118 22.982-6.66 47.052-10.118 71.688-10.118 57.564 0 110.75 19.104 153.556 51.296 24.942-33.072 38.444-73.144 38.444-115.296 0-105.87-86.132-192-192-192zM160 960h608c105.87 0 192-86.13 192-192s-86.13-192-192-192c-52.024 0-100.73 20.466-137.146 57.63-12.368 12.624-32.63 12.83-45.252 0.458-12.624-12.37-12.83-32.628-0.46-45.252 15.676-15.998 33.070-29.66 51.76-40.848-12.838-57.422-64.302-99.988-124.902-99.988-70.58 0-128 57.42-128 128 0 8.706 0.876 17.396 2.602 25.832 3.542 17.314-7.624 34.222-24.938 37.766-2.164 0.442-4.32 0.654-6.448 0.654-14.884 0-28.218-10.442-31.318-25.592-2.218-10.854-3.492-21.97-3.812-33.124-10.244-3.626-21.098-5.536-32.086-5.536-52.936 0-96 43.064-96 96 0 10.964 1.88 21.784 5.484 32h26.516c17.674 0 32 14.326 32 32s-14.326 32-32 32h-64c-52.936 0-96 43.064-96 96s43.064 96 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-cloudy",
						"weather"
					],
					"defaultCode": 60619,
					"grid": 16
				},
				{
					"id": 2773,
					"paths": [
						"M891.004 296.062c-3.242-128.7-108.458-232.062-237.864-232.062-75.792 0-143.264 35.494-186.852 90.732-24.442-31.6-62.69-51.96-105.708-51.96-73.81 0-133.642 59.876-133.642 133.722 0 6.436 0.48 12.76 1.364 18.954-11.22-2.024-22.766-3.138-34.568-3.138-107-0.002-193.734 86.786-193.734 193.842 0 107.062 86.734 193.848 193.73 193.848h165.474l42.666-128h341.684l-64 128 170.438-0.014c96.138-0.182 174.008-78.208 174.008-174.444 0-82.088-56.68-150.9-132.996-169.48zM640 576h-192l-64 192h128l-64 192 256-256h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-lightning",
						"weather",
						"lightning"
					],
					"defaultCode": 60608,
					"grid": 16
				},
				{
					"id": 2774,
					"paths": [
						"M768 192c-24.634 0-48.706 3.458-71.688 10.118-23.424-80.076-97.658-138.118-184.312-138.118-85.432 0-158 56.092-182.836 133.378-13.366-3.548-27.208-5.378-41.164-5.378-88.224 0-160 71.776-160 160 0 11.672 1.294 23.252 3.786 34.542-74.808 13.372-131.786 78.864-131.786 157.458 0 88.224 71.776 160 160 160h192c17.672 0 32-14.326 32-32s-14.328-32-32-32h-192c-52.934 0-96-43.064-96-96 0-52.934 43.066-96 96-96h64c17.672 0 32-14.328 32-32s-14.328-32-32-32h-26.516c-3.602-10.216-5.484-21.036-5.484-32 0-52.934 43.066-96 96-96 10.99 0 21.842 1.91 32.086 5.534 0.32 11.154 1.592 22.272 3.814 33.126 3.1 15.152 16.432 25.592 31.318 25.592 2.124 0 4.284-0.212 6.446-0.656 17.316-3.542 28.48-20.45 24.938-37.764-1.726-8.434-2.6-17.126-2.6-25.832 0-70.58 57.42-128 128-128 60.6 0 112.066 42.566 124.902 99.99-18.69 11.188-36.084 24.85-51.76 40.848-12.37 12.624-12.164 32.882 0.458 45.252 12.624 12.37 32.886 12.164 45.252-0.46 36.418-37.164 85.124-57.63 137.146-57.63 105.87 0 192 86.13 192 192 0 51.286-19.972 99.5-56.238 135.764-36.262 36.264-84.476 56.236-135.762 56.236h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32h32c68.38 0 132.668-26.628 181.018-74.982 48.354-48.35 74.982-112.638 74.982-181.018 0-141.16-114.842-256-256-256z",
						"M544.004 960.008c-3.354 0-6.766-0.532-10.124-1.65-16.766-5.588-25.828-23.71-20.238-40.476l49.96-149.882h-83.602c-10.286 0-19.946-4.946-25.96-13.29-6.014-8.346-7.65-19.072-4.398-28.83l64-192c5.586-16.766 23.706-25.832 40.476-20.238 16.766 5.588 25.828 23.71 20.238 40.476l-49.958 149.882h83.602c10.288 0 19.946 4.946 25.958 13.29 6.016 8.346 7.652 19.072 4.398 28.83l-64 192c-4.466 13.408-16.954 21.888-30.352 21.888z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-lightning",
						"weather",
						"lightning"
					],
					"defaultCode": 60609,
					"grid": 16
				},
				{
					"id": 2775,
					"paths": [
						"M891.004 296.062c76.314 18.58 132.996 87.392 132.996 169.48 0 96.236-77.872 174.262-174.010 174.446v0.012h-656.26c-106.996 0-193.73-86.786-193.73-193.848 0-107.056 86.734-193.844 193.734-193.842 11.8 0 23.348 1.114 34.566 3.138-0.882-6.194-1.364-12.518-1.364-18.954 0-73.846 59.832-133.722 133.642-133.722 43.018 0 81.266 20.362 105.708 51.96 43.59-55.238 111.064-90.732 186.856-90.732 129.404 0 234.62 103.362 237.862 232.062v0z",
						"M895.918 924.724c-0.28-8.288-1.604-16.304-3.854-23.93-18.034-73.408-92.064-196.794-92.064-196.794s-74.030 123.386-92.064 196.794c-2.25 7.624-3.574 15.642-3.854 23.93-0.050 1.118-0.082 2.212-0.082 3.276 0 53.020 42.98 96 96 96s96-42.98 96-96c0-1.064-0.030-2.158-0.082-3.276z",
						"M607.918 860.724c-0.28-8.288-1.604-16.304-3.854-23.93-18.034-73.408-92.064-196.794-92.064-196.794s-74.030 123.386-92.064 196.794c-2.25 7.624-3.574 15.642-3.854 23.93-0.050 1.118-0.082 2.212-0.082 3.276 0 53.020 42.98 96 96 96s96-42.98 96-96c0-1.064-0.030-2.158-0.082-3.276z",
						"M319.918 924.724c-0.28-8.288-1.604-16.304-3.854-23.93-18.034-73.408-92.064-196.794-92.064-196.794s-74.030 123.386-92.064 196.794c-2.25 7.624-3.574 15.642-3.854 23.93-0.050 1.118-0.082 2.212-0.082 3.276 0 53.020 42.98 96 96 96s96-42.98 96-96c0-1.064-0.030-2.158-0.082-3.276z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-rain",
						"weather",
						"rainy"
					],
					"defaultCode": 60610,
					"grid": 16
				},
				{
					"id": 2776,
					"paths": [
						"M0 544c0 88.224 71.776 160 160 160h608c68.378 0 132.668-26.628 181.020-74.982 48.352-48.35 74.98-112.638 74.98-181.018 0-141.16-114.84-256-256-256-24.634 0-48.706 3.458-71.688 10.118-23.424-80.076-97.658-138.118-184.312-138.118-85.432 0-157.998 56.092-182.836 133.378-13.366-3.548-27.208-5.378-41.164-5.378-88.224 0-160 71.776-160 160 0 11.672 1.294 23.252 3.786 34.542-74.808 13.372-131.786 78.864-131.786 157.458zM64 544c0-52.934 43.064-96 96-96h64c17.674 0 32-14.328 32-32s-14.326-32-32-32h-26.516c-3.602-10.216-5.484-21.036-5.484-32 0-52.934 43.064-96 96-96 10.99 0 21.842 1.91 32.086 5.534 0.318 11.154 1.594 22.272 3.812 33.126 3.1 15.15 16.434 25.592 31.318 25.592 2.126 0 4.284-0.212 6.448-0.656 17.314-3.542 28.478-20.45 24.938-37.764-1.726-8.434-2.602-17.126-2.602-25.832 0-70.58 57.42-128 128-128 60.6 0 112.066 42.566 124.902 99.99-18.692 11.188-36.084 24.85-51.762 40.848-12.368 12.624-12.162 32.882 0.46 45.252 12.622 12.368 32.882 12.164 45.252-0.46 36.418-37.164 85.126-57.63 137.148-57.63 105.87 0 192 86.13 192 192 0 51.286-19.972 99.5-56.234 135.764-36.266 36.264-84.48 56.236-135.766 56.236h-608c-52.936 0-96-43.064-96-96z",
						"M224 1024c-52.934 0-96-43.064-96-96 0-16.876 4.452-33.486 12.872-48.040l55.416-95.962c5.716-9.9 16.28-15.998 27.71-15.998s21.996 6.098 27.71 15.998l55.434 95.992c8.408 14.526 12.858 31.134 12.858 48.010 0 52.936-43.064 96-96 96zM224 863.99l-27.72 48.002c-2.844 4.916-4.28 10.294-4.28 16.008 0 17.644 14.356 32 32 32s32-14.356 32-32c0-5.714-1.434-11.092-4.264-15.982l-27.736-48.028z",
						"M864 1024c-52.934 0-96-43.064-96-96 0-16.876 4.452-33.486 12.872-48.040l55.418-95.962c5.714-9.9 16.28-15.998 27.71-15.998s21.996 6.098 27.71 15.998l55.434 95.992c8.408 14.526 12.856 31.134 12.856 48.010 0 52.936-43.066 96-96 96zM864 863.99l-27.72 48.002c-2.846 4.916-4.28 10.292-4.28 16.008 0 17.644 14.356 32 32 32s32-14.356 32-32c0-5.714-1.434-11.092-4.264-15.982l-27.736-48.028z",
						"M544 960c-52.934 0-96-43.064-96-96 0-16.876 4.452-33.486 12.872-48.040l55.418-95.962c5.714-9.9 16.28-15.998 27.71-15.998s21.996 6.098 27.71 15.998l55.434 95.992c8.408 14.526 12.856 31.134 12.856 48.010 0 52.936-43.066 96-96 96zM544 799.99l-27.72 48.002c-2.846 4.916-4.28 10.292-4.28 16.008 0 17.644 14.356 32 32 32s32-14.356 32-32c0-5.714-1.434-11.092-4.264-15.982l-27.736-48.028z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-rain",
						"weather",
						"rainy"
					],
					"defaultCode": 60611,
					"grid": 16
				},
				{
					"id": 2777,
					"paths": [
						"M891.004 296.062c76.316 18.58 132.996 87.392 132.996 169.48 0 96.236-77.87 174.262-174.008 174.446v0.012h-656.262c-106.996 0-193.73-86.786-193.73-193.848 0-107.056 86.734-193.844 193.734-193.842 11.802 0 23.348 1.114 34.568 3.138-0.884-6.194-1.364-12.518-1.364-18.954 0-73.846 59.832-133.722 133.642-133.722 43.018 0 81.266 20.362 105.708 51.96 43.588-55.238 111.062-90.732 186.854-90.732 129.404 0 234.62 103.362 237.862 232.062zM895.968 808.168c0.306 4.996-1.686 8.484-5.984 10.488l-110.844 45.348 110.844 45.778c4.3 1.706 6.292 5.058 5.984 10.042-0.292 5.004-3.97 13.052-11.042 24.174-7.068 11.408-12.816 18.398-17.256 20.96-4.442 2.572-8.508 2.572-12.188 0l-97.984-66.31 12.88 112.094c0.928 4.272-1.1 7.55-5.99 9.832-4.906 2.284-14.414 3.426-28.526 3.426-14.104 0-23.614-1.148-28.498-3.426-4.918-2.282-6.918-5.56-6-9.832l12.886-112.094-97.532 66.31c-3.68 2.572-7.828 2.572-12.414 0-4.602-2.562-10.438-9.552-17.482-20.96-7.084-11.122-10.662-19.17-10.818-24.174-0.158-4.984 1.912-8.334 6.22-10.042l110.85-45.778-110.85-45.348c-4.308-1.996-6.378-5.492-6.22-10.488 0.156-4.986 3.734-13.044 10.818-24.166 7.050-11.116 12.874-17.95 17.482-20.52 4.602-2.564 8.734-2.564 12.414 0l97.532 65.86-12.886-111.65c-0.918-4.566 1.082-7.978 6-10.252 4.894-2.298 14.394-3.44 28.498-3.44 14.112 0 23.62 1.156 28.526 3.44 4.89 2.268 6.918 5.686 5.99 10.252l-12.88 111.65 97.984-65.86c3.68-2.564 7.752-2.564 12.188 0 4.44 2.572 10.188 9.552 17.256 20.948 7.074 10.832 10.736 18.742 11.042 23.738zM447.968 808.168c0.306 4.996-1.686 8.484-5.984 10.488l-110.844 45.348 110.844 45.778c4.3 1.706 6.292 5.058 5.984 10.042-0.292 5.004-3.97 13.052-11.042 24.174-7.068 11.408-12.816 18.398-17.256 20.96-4.442 2.572-8.508 2.572-12.188 0l-97.984-66.31 12.88 112.094c0.928 4.272-1.1 7.55-5.99 9.832-4.906 2.284-14.414 3.426-28.526 3.426-14.104 0-23.614-1.148-28.498-3.426-4.918-2.282-6.918-5.56-6-9.832l12.886-112.094-97.532 66.31c-3.68 2.572-7.828 2.572-12.414 0-4.602-2.562-10.438-9.552-17.482-20.96-7.084-11.122-10.662-19.17-10.818-24.174-0.158-4.984 1.912-8.334 6.22-10.042l110.85-45.778-110.85-45.348c-4.308-1.996-6.378-5.492-6.22-10.488 0.156-4.986 3.734-13.044 10.818-24.166 7.050-11.116 12.874-17.95 17.482-20.52 4.602-2.564 8.734-2.564 12.414 0l97.532 65.86-12.886-111.65c-0.918-4.566 1.082-7.978 6-10.252 4.894-2.298 14.394-3.44 28.498-3.44 14.112 0 23.62 1.156 28.526 3.44 4.89 2.268 6.918 5.686 5.99 10.252l-12.88 111.65 97.984-65.86c3.68-2.564 7.752-2.564 12.188 0 4.44 2.572 10.188 9.552 17.256 20.948 7.074 10.832 10.736 18.742 11.042 23.738z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-snow",
						"weather",
						"snow"
					],
					"defaultCode": 60612,
					"grid": 16
				},
				{
					"id": 2778,
					"paths": [
						"M0 480c0 88.222 71.776 160 160 160h608c68.376 0 132.668-26.628 181.020-74.982 48.352-48.35 74.98-112.64 74.98-181.018 0-141.16-114.842-256-256-256-24.634 0-48.708 3.458-71.69 10.118-23.422-80.076-97.656-138.118-184.31-138.118-85.432 0-157.998 56.092-182.836 133.378-13.366-3.548-27.208-5.378-41.164-5.378-88.224 0-160 71.776-160 160 0 11.672 1.292 23.252 3.786 34.542-74.808 13.372-131.786 78.864-131.786 157.458zM64 480c0-52.934 43.064-96 96-96h64c17.674 0 32-14.328 32-32s-14.326-32-32-32h-26.516c-3.602-10.216-5.484-21.036-5.484-32 0-52.934 43.064-96 96-96 10.99 0 21.842 1.91 32.086 5.534 0.318 11.154 1.594 22.272 3.812 33.126 3.1 15.15 16.434 25.592 31.316 25.592 2.126 0 4.286-0.212 6.45-0.656 17.312-3.542 28.476-20.45 24.938-37.764-1.726-8.434-2.602-17.126-2.602-25.832 0-70.58 57.42-128 128-128 60.6 0 112.064 42.566 124.9 99.99-18.692 11.188-36.082 24.85-51.762 40.848-12.368 12.624-12.162 32.882 0.46 45.252 12.622 12.368 32.88 12.164 45.252-0.46 36.42-37.164 85.128-57.63 137.15-57.63 105.87 0 192 86.13 192 192 0 51.286-19.972 99.5-56.234 135.764-36.266 36.264-84.48 56.236-135.766 56.236h-608c-52.936 0-96-43.064-96-96z",
						"M895.968 808.168c0.306 4.996-1.686 8.484-5.984 10.488l-110.844 45.348 110.844 45.778c4.3 1.708 6.292 5.058 5.984 10.042-0.292 5.004-3.97 13.052-11.042 24.174-7.068 11.408-12.816 18.398-17.256 20.96-4.444 2.57-8.51 2.57-12.19 0l-97.984-66.31 12.88 112.094c0.928 4.272-1.1 7.55-5.99 9.832-4.906 2.284-14.414 3.426-28.526 3.426-14.104 0-23.616-1.148-28.498-3.426-4.918-2.282-6.918-5.56-6-9.832l12.886-112.094-97.534 66.308c-3.68 2.572-7.828 2.572-12.414 0-4.602-2.56-10.438-9.55-17.48-20.958-7.084-11.124-10.662-19.17-10.818-24.174-0.158-4.984 1.912-8.334 6.218-10.042l110.85-45.778-110.85-45.348c-4.306-1.996-6.376-5.492-6.218-10.488 0.156-4.986 3.734-13.044 10.818-24.166 7.048-11.116 12.874-17.952 17.48-20.52 4.604-2.564 8.734-2.564 12.414 0l97.534 65.86-12.886-111.65c-0.918-4.566 1.082-7.976 6-10.252 4.894-2.298 14.394-3.44 28.498-3.44 14.112 0 23.62 1.156 28.526 3.44 4.89 2.268 6.918 5.686 5.99 10.252l-12.88 111.65 97.984-65.86c3.68-2.564 7.752-2.564 12.19 0 4.44 2.572 10.188 9.552 17.256 20.948 7.074 10.832 10.734 18.742 11.042 23.738v0zM447.968 808.168c0.306 4.996-1.686 8.484-5.982 10.488l-110.846 45.348 110.846 45.778c4.298 1.708 6.292 5.058 5.982 10.042-0.292 5.004-3.968 13.052-11.042 24.174-7.068 11.408-12.816 18.398-17.256 20.96-4.444 2.57-8.508 2.57-12.188 0l-97.984-66.31 12.878 112.094c0.928 4.272-1.1 7.55-5.99 9.832-4.904 2.284-14.414 3.426-28.526 3.426-14.104 0-23.614-1.148-28.498-3.426-4.918-2.282-6.918-5.56-6-9.832l12.886-112.094-97.534 66.308c-3.68 2.572-7.828 2.572-12.414 0-4.602-2.56-10.438-9.55-17.48-20.958-7.084-11.124-10.662-19.17-10.818-24.174-0.158-4.984 1.912-8.334 6.218-10.042l110.852-45.778-110.852-45.348c-4.306-1.996-6.376-5.492-6.218-10.488 0.156-4.986 3.734-13.044 10.818-24.166 7.048-11.116 12.874-17.952 17.48-20.52 4.604-2.564 8.734-2.564 12.414 0l97.534 65.86-12.886-111.65c-0.918-4.566 1.082-7.976 6-10.252 4.894-2.298 14.394-3.44 28.498-3.44 14.112 0 23.622 1.156 28.526 3.44 4.89 2.268 6.918 5.686 5.99 10.252l-12.878 111.65 97.984-65.86c3.68-2.564 7.752-2.564 12.188 0 4.44 2.572 10.188 9.552 17.256 20.948 7.074 10.832 10.736 18.742 11.042 23.738v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-snow",
						"weather",
						"snow"
					],
					"defaultCode": 60613,
					"grid": 16
				},
				{
					"id": 2785,
					"paths": [
						"M416 640c123.712 0 224-100.29 224-224s-100.286-224-224-224c-123.71 0-224 100.29-224 224 0 123.712 100.29 224 224 224v0z",
						"M416 0c17.672 0 32 14.328 32 32v64c0 17.672-14.328 32-32 32s-32-14.328-32-32v-64c0-17.672 14.328-32 32-32z",
						"M704 416c0-17.674 14.328-32 32-32h64c17.672 0 32 14.326 32 32s-14.328 32-32 32h-64c-17.672 0-32-14.328-32-32z",
						"M0 416c0-17.672 14.328-32 32-32h64c17.674 0 32 14.328 32 32s-14.326 32-32 32h-64c-17.672 0-32-14.328-32-32z",
						"M272.198 827.904c-84.964 0-169.99-21.090-254.49-63.274-15.812-7.894-22.232-27.112-14.338-42.924s27.112-22.23 42.924-14.338c75.272 37.58 151.274 56.632 225.894 56.632 74.606 0 150.47-19.046 225.484-56.614 169.040-84.384 340.164-84.378 508.658 0 15.802 7.914 22.198 27.14 14.286 42.942-7.916 15.802-27.14 22.196-42.942 14.286-75.016-37.568-150.878-56.614-225.486-56.614-74.622 0-150.624 19.052-225.894 56.63-84.232 42.182-169.132 63.274-254.096 63.274z",
						"M272.198 1019.904c-84.964 0-169.99-21.090-254.49-63.274-15.812-7.894-22.232-27.112-14.338-42.924s27.112-22.228 42.924-14.338c75.272 37.58 151.274 56.632 225.894 56.632 74.606 0 150.47-19.046 225.484-56.614 169.040-84.384 340.164-84.378 508.658 0 15.802 7.914 22.198 27.14 14.286 42.942-7.916 15.802-27.14 22.196-42.942 14.286-75.016-37.568-150.878-56.614-225.486-56.614-74.622 0-150.624 19.052-225.894 56.63-84.232 42.182-169.132 63.274-254.096 63.274z",
						"M672 192c-8.19 0-16.378-3.124-22.626-9.372-12.498-12.498-12.498-32.758 0-45.256l64-64c12.496-12.496 32.758-12.496 45.254 0 12.498 12.498 12.498 32.758 0 45.256l-64 64c-6.248 6.248-14.438 9.372-22.628 9.372z",
						"M160 192c-8.19 0-16.378-3.124-22.628-9.372l-64-64c-12.496-12.498-12.496-32.758 0-45.256 12.498-12.496 32.758-12.496 45.256 0l64 64c12.496 12.498 12.496 32.758 0 45.256-6.248 6.248-14.438 9.372-22.628 9.372z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-sun-wind",
						"weather"
					],
					"defaultCode": 60620,
					"grid": 16
				},
				{
					"id": 2786,
					"paths": [
						"M416 576c-88.222 0-160-71.778-160-160s71.778-160 160-160c88.224 0 160 71.778 160 160s-71.774 160-160 160zM416 640c123.712 0 224-100.29 224-224s-100.286-224-224-224c-123.71 0-224 100.29-224 224 0 123.712 100.29 224 224 224v0z",
						"M416 0c17.672 0 32 14.328 32 32v64c0 17.672-14.328 32-32 32s-32-14.328-32-32v-64c0-17.672 14.328-32 32-32z",
						"M704 416c0-17.674 14.328-32 32-32h64c17.672 0 32 14.326 32 32s-14.328 32-32 32h-64c-17.672 0-32-14.328-32-32z",
						"M0 416c0-17.672 14.328-32 32-32h64c17.674 0 32 14.328 32 32s-14.326 32-32 32h-64c-17.672 0-32-14.328-32-32z",
						"M272.198 827.904c-84.964 0-169.99-21.090-254.49-63.274-15.812-7.894-22.232-27.112-14.338-42.924s27.112-22.23 42.924-14.338c75.272 37.58 151.274 56.632 225.894 56.632 74.606 0 150.47-19.046 225.484-56.614 169.040-84.384 340.164-84.378 508.658 0 15.802 7.914 22.198 27.14 14.286 42.942-7.916 15.802-27.14 22.196-42.942 14.286-75.016-37.568-150.878-56.614-225.486-56.614-74.622 0-150.624 19.052-225.894 56.63-84.232 42.182-169.132 63.274-254.096 63.274z",
						"M272.198 1019.904c-84.964 0-169.99-21.090-254.49-63.274-15.812-7.894-22.232-27.112-14.338-42.924s27.112-22.228 42.924-14.338c75.272 37.58 151.274 56.632 225.894 56.632 74.606 0 150.47-19.046 225.484-56.614 169.040-84.384 340.164-84.378 508.658 0 15.802 7.914 22.198 27.14 14.286 42.942-7.916 15.802-27.14 22.196-42.942 14.286-75.016-37.568-150.878-56.614-225.486-56.614-74.622 0-150.624 19.052-225.894 56.63-84.232 42.182-169.132 63.274-254.096 63.274z",
						"M672 192c-8.19 0-16.378-3.124-22.626-9.372-12.498-12.498-12.498-32.758 0-45.256l64-64c12.496-12.496 32.758-12.496 45.254 0 12.498 12.498 12.498 32.758 0 45.256l-64 64c-6.248 6.248-14.438 9.372-22.628 9.372z",
						"M160 192c-8.19 0-16.378-3.124-22.628-9.372l-64-64c-12.496-12.498-12.496-32.758 0-45.256 12.498-12.496 32.758-12.496 45.256 0l64 64c12.496 12.498 12.496 32.758 0 45.256-6.248 6.248-14.438 9.372-22.628 9.372z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-sun-wind",
						"weather"
					],
					"defaultCode": 60621,
					"grid": 16
				},
				{
					"id": 2792,
					"paths": [
						"M672 320c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96c0 4.61-0.346 9.138-0.972 13.576l63.35 9.050c1.048-7.396 1.622-14.942 1.622-22.626 0-88.366-71.634-160-160-160s-160 71.634-160 160 71.634 160 160 160h352v-64h-352zM128 768c0 106.038 85.962 192 192 192s192-85.962 192-192c0-16.064-1.984-31.662-5.702-46.574l-62.112 15.528c2.48 9.94 3.814 20.338 3.814 31.046 0 70.694-57.308 128-128 128s-128-57.306-128-128 57.308-128 128-128h704v-64h-704c-106.038 0-192 85.958-192 192zM64 288c0-88.366 71.634-160 160-160s160 71.634 160 160c0 23.622-5.16 46.024-14.348 66.206l58.314 26.506c12.864-28.254 20.034-59.644 20.034-92.712 0-123.712-100.288-224-224-224s-224 100.288-224 224c0 123.71 100.288 224 224 224h800v-64h-800c-88.364 0-160-71.634-160-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weather-windy",
						"weather"
					],
					"defaultCode": 60627,
					"grid": 16
				},
				{
					"id": 929,
					"width": 1024,
					"paths": [
						"M960 320v-128c0-17.664-14.336-32-32-32h-64v-64c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v64h-64v-64c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v64h-64v-64c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v64h-64c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h64v64h-64c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h64v64h-64c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h64v64c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-64h64v64c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-64h64v64c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-64h64c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-64v-64h64c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-64v-64h64c17.664 0 32-14.336 32-32zM928 192v128h-64v-128h64zM448 96h128v64h-128v-64zM672 192v128h-320v-128h320zM576 672h-128v-320h128v320zM608 608h64v64h-64v-64zM416 672h-64v-64h64v64zM416 416h-64v-64h64v64zM608 352h64v64h-64v-64zM96 320v-128h64v128h-64zM192 96h128v320h-128v-320zM96 576v-128h320v128h-320zM96 832v-128h64v128h-64zM320 928h-128v-320h128v320zM576 928h-128v-64h128v64zM352 832v-128h320v128h-320zM928 704v128h-64v-128h64zM832 928h-128v-320h128v320zM928 448v128h-320v-128h320zM832 416h-128v-320h128v320z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weave",
						"make"
					],
					"grid": 32
				},
				{
					"id": 930,
					"width": 1024,
					"paths": [
						"M896 160h32c17.664 0 32 14.336 32 32v128c0 17.664-14.336 32-32 32h-32v-192zM640 352v-192h-256v192h256zM416 640h192v-256h-192v256zM640 416v192h288c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32h-288zM384 608v-192h-288c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h288zM384 672v192h256v-192h-256zM608 128v-32c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v32h192zM864 640h-192v288c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-288zM928 672h-32v192h32c17.664 0 32-14.336 32-32v-128c0-17.664-14.336-32-32-32zM416 896v32c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-32h-192zM672 384h192v-288c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v288zM128 672h-32c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h32v-192zM160 640v288c0 17.664 14.336 32 32 32h128c17.664 0 32-14.336 32-32v-288h-192zM128 160h-32c-17.664 0-32 14.336-32 32v128c0 17.664 14.336 32 32 32h32v-192zM320 64h-128c-17.664 0-32 14.336-32 32v288h192v-288c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weave",
						"make"
					],
					"grid": 32
				},
				{
					"id": 1607,
					"width": 1170.2891235351562,
					"paths": [
						"M331.429 263.429q0-23.429-14.286-37.714t-37.714-14.286q-24.571 0-43.429 14.571t-18.857 37.429q0 22.286 18.857 36.857t43.429 14.571q23.429 0 37.714-14t14.286-37.429zM756 553.143q0-16-14.571-28.571t-37.429-12.571q-15.429 0-28.286 12.857t-12.857 28.286q0 16 12.857 28.857t28.286 12.857q22.857 0 37.429-12.571t14.571-29.143zM621.143 263.429q0-23.429-14-37.714t-37.429-14.286q-24.571 0-43.429 14.571t-18.857 37.429q0 22.286 18.857 36.857t43.429 14.571q23.429 0 37.429-14t14-37.429zM984 553.143q0-16-14.857-28.571t-37.143-12.571q-15.429 0-28.286 12.857t-12.857 28.286q0 16 12.857 28.857t28.286 12.857q22.286 0 37.143-12.571t14.857-29.143zM832 326.286q-17.714-2.286-40-2.286-96.571 0-177.714 44t-127.714 119.143-46.571 164.286q0 44.571 13.143 86.857-20 1.714-38.857 1.714-14.857 0-28.571-0.857t-31.429-3.714-25.429-4-31.143-6-28.571-6l-144.571 72.571 41.143-124.571q-165.714-116-165.714-280 0-96.571 55.714-177.714t150.857-127.714 207.714-46.571q100.571 0 190 37.714t149.714 104.286 78 148.857zM1170.286 646.857q0 66.857-39.143 127.714t-106 110.571l31.429 103.429-113.714-62.286q-85.714 21.143-124.571 21.143-96.571 0-177.714-40.286t-127.714-109.429-46.571-150.857 46.571-150.857 127.714-109.429 177.714-40.286q92 0 173.143 40.286t130 109.714 48.857 150.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wechat",
						"weixin"
					],
					"defaultCode": 61911,
					"grid": 14
				},
				{
					"id": 1535,
					"width": 1033.1429443359375,
					"paths": [
						"M385.714 733.714q12-19.429 6.286-39.429t-25.714-28.571q-19.429-8-41.714-0.571t-34.286 26.286q-12.571 19.429-7.429 39.143t24.571 28.857 42.571 1.429 35.714-27.143zM439.429 664.571q4.571-7.429 2-15.143t-10-10.571q-8-2.857-16.286 0.286t-12.286 10.571q-9.714 17.714 7.429 25.714 8 2.857 16.571-0.286t12.571-10.571zM538.857 725.714q-25.714 58.286-90.286 85.714t-128 6.857q-61.143-19.429-84.286-72.286t3.714-107.143q26.857-53.143 86.571-79.429t120.286-10.857q63.429 16.571 90.571 68.286t1.429 108.857zM717.143 634.286q-5.143-54.857-50.857-97.143t-119.143-62.286-156.857-12q-127.429 13.143-211.143 80.857t-75.714 151.143q5.143 54.857 50.857 97.143t119.143 62.286 156.857 12q127.429-13.143 211.143-80.857t75.714-151.143zM893.143 636.571q0 38.857-21.143 79.714t-62.286 78.286-96.286 67.143-129.143 47.429-154.571 17.714-157.143-19.143-137.429-53.143-98-86.286-37.143-114q0-65.714 39.714-140t112.857-147.429q96.571-96.571 195.143-134.857t140.857 4q37.143 36.571 11.429 119.429-2.286 8-0.571 11.429t5.714 4 8.286-0.286 7.714-2l3.429-1.143q79.429-33.714 140.571-33.714t87.429 34.857q25.714 36 0 101.714-1.143 7.429-2.571 11.429t2.571 7.143 6.857 4.286 9.714 3.429q32.571 10.286 58.857 26.857t45.714 46.571 19.429 66.571zM850.857 280q24 26.857 31.143 62t-3.714 67.143q-4.571 13.143-16.857 19.429t-25.429 2.286q-13.143-4.571-19.429-16.857t-2.286-25.429q11.429-36-13.714-63.429t-61.143-20q-13.714 2.857-25.714-4.571t-14.286-21.143q-2.857-13.714 4.571-25.429t21.143-14.571q34.286-7.429 68 3.143t57.714 37.429zM954.286 186.857q49.714 54.857 64.286 127.143t-7.714 138q-5.143 15.429-19.429 22.857t-29.714 2.286-22.857-19.429-2.857-29.714q16-46.857 5.714-98.286t-45.714-90.286q-35.429-39.429-84.571-54.571t-98.857-4.857q-16 3.429-29.714-5.429t-17.143-24.857 5.429-29.429 24.857-16.857q70.286-14.857 139.429 6.571t118.857 76.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weibo"
					],
					"defaultCode": 61834,
					"grid": 14
				},
				{
					"id": 931,
					"width": 1024,
					"paths": [
						"M864 192h-171.168c-26.368-74.528-97.28-128-180.832-128s-154.464 53.472-180.832 128h-171.168c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h704c53.024 0 96-42.976 96-96v-576c0-53.024-42.976-96-96-96zM928 864c0 35.296-28.704 64-64 64h-704c-35.296 0-64-28.704-64-64v-576c0-35.296 28.704-64 64-64h171.168c13.568 0 25.632-8.544 30.176-21.312 22.56-63.808 83.136-106.688 150.656-106.688s128.096 42.88 150.688 106.688c4.512 12.768 16.608 21.312 30.144 21.312h171.168c35.296 0 64 28.704 64 64v576zM512 128c-70.688 0-128 57.312-128 128s57.312 128 128 128 128-57.312 128-128-57.312-128-128-128zM512 352c-52.928 0-96-43.072-96-96s43.072-96 96-96c20.704 0 39.744 6.752 55.456 17.92l-50.752 50.752c-6.24 6.24-6.24 16.384 0 22.624 3.104 3.136 7.2 4.704 11.296 4.704s8.192-1.568 11.328-4.672l50.752-50.752c11.168 15.68 17.92 34.72 17.92 55.424 0 52.928-43.072 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weigh",
						"measure"
					],
					"grid": 32
				},
				{
					"id": 932,
					"width": 1024,
					"paths": [
						"M590.080 200.544c11.168 15.712 17.92 34.752 17.92 55.456 0 52.928-43.072 96-96 96s-96-43.072-96-96 43.072-96 96-96c20.704 0 39.744 6.752 55.456 17.92l-50.752 50.752c-6.24 6.24-6.24 16.384 0 22.624 3.104 3.136 7.2 4.704 11.296 4.704s8.192-1.568 11.328-4.672l50.752-50.784zM960 288v576c0 53.024-42.976 96-96 96h-704c-53.024 0-96-42.976-96-96v-576c0-53.024 42.976-96 96-96h171.168c26.4-74.528 97.28-128 180.832-128s154.464 53.472 180.832 128h171.168c53.024 0 96 42.976 96 96zM640 256c0-70.688-57.312-128-128-128s-128 57.312-128 128 57.312 128 128 128 128-57.312 128-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weigh",
						"measure"
					],
					"grid": 32
				},
				{
					"id": 1174,
					"width": 1024,
					"paths": [
						"M928 0h-64c0 46.24-110.144 96-352 96s-352-49.76-352-96h-64c0 121.408 198.24 152.736 352 158.752v71.008c-181.536 30.528-320 188.032-320 378.24 0 157.568 94.976 292.8 230.752 352h-166.752v64h640v-64h-166.752c135.776-59.2 230.752-194.432 230.752-352 0-190.208-138.464-347.712-320-378.24v-71.008c153.76-6.016 352-37.344 352-158.752zM832 608c0 176.448-143.552 320-320 320s-320-143.552-320-320c0-176.448 143.552-320 320-320s320 143.552 320 320zM224 608c0 159.072 128.928 288 288 288s288-128.928 288-288c0-159.072-128.928-288-288-288s-288 128.928-288 288zM768 608c0 141.152-114.848 256-256 256s-256-114.848-256-256c0-141.152 114.848-256 256-256s256 114.848 256 256zM500.672 596.672l160-160 22.624 22.624-160 160-22.624-22.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weigh",
						"measure"
					],
					"grid": 32
				},
				{
					"id": 933,
					"width": 1024,
					"paths": [
						"M896 320h-64v-96c0-88.352-71.648-160-160-160h-320c-88.352 0-160 71.648-160 160v96h-64c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h64v96.64c0 42.144 4.16 84.192 12.416 125.504l36.128 180.672c8.992 44.896 48.384 77.184 94.144 77.184h354.592c45.76 0 85.152-32.288 94.144-77.184l36.128-180.672c8.288-41.344 12.448-83.36 12.448-125.504v-96.64h64c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32zM224 224c0-70.592 57.408-128 128-128h320c70.592 0 128 57.408 128 128v160h-32v-64c0-35.36-28.64-64-64-64h-384c-35.36 0-64 28.64-64 64v64h-32v-160zM736 320v160c0 17.632-14.368 32-32 32h-384c-17.632 0-32-14.368-32-32v-160c0-17.632 14.368-32 32-32h384c17.632 0 32 14.368 32 32zM128 448v-96h64v96h-64zM800 576.64c0 39.936-3.968 80.064-11.808 119.232l-36.128 180.672c-5.984 29.824-32.352 51.456-62.752 51.456h-354.624c-30.4 0-56.8-21.632-62.752-51.456l-36.128-180.672c-7.84-39.168-11.808-79.296-11.808-119.232v-160.64h32v64c0 35.36 28.64 64 64 64h384c35.36 0 64-28.64 64-64v-64h32v160.64zM896 448h-64v-96h64v96zM320 480h384v-160h-384v160zM352 352h320v96h-320v-96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weld",
						"create",
						"make",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 934,
					"width": 1024,
					"paths": [
						"M160 480h-32c-17.664 0-32-14.336-32-32v-96c0-17.664 14.336-32 32-32h32v160zM672 352h-320v96h320v-96zM736 320v160c0 17.632-14.368 32-32 32h-384c-17.632 0-32-14.368-32-32v-160c0-17.632 14.368-32 32-32h384c17.632 0 32 14.368 32 32zM704 320h-384v160h384v-160zM832 576.64c0 42.144-4.16 84.192-12.416 125.504l-36.128 180.672c-8.992 44.896-48.384 77.184-94.144 77.184h-354.624c-45.76 0-85.152-32.288-94.144-77.184l-36.128-180.672c-8.256-41.344-12.416-83.36-12.416-125.504v-352.64c0-88.352 71.648-160 160-160h320c88.352 0 160 71.648 160 160v352.64zM768 320c0-35.296-28.704-64-64-64h-384c-35.296 0-64 28.704-64 64v160c0 35.296 28.704 64 64 64h384c35.296 0 64-28.704 64-64v-160zM896 320h-32v160h32c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"weld",
						"create",
						"make",
						"protect"
					],
					"grid": 32
				},
				{
					"id": 3335,
					"paths": [
						"M873 148.8c-95.8-96-223.2-148.8-359-148.8-279.6 0-507.2 227.6-507.2 507.4 0 89.4 23.4 176.8 67.8 253.6l-72 263 269-70.6c74.2 40.4 157.6 61.8 242.4 61.8h0.2c0 0 0 0 0 0 279.6 0 507.4-227.6 507.4-507.4 0-135.6-52.8-263-148.6-359zM514.2 929.6v0c-75.8 0-150-20.4-214.8-58.8l-15.4-9.2-159.6 41.8 42.6-155.6-10-16c-42.4-67-64.6-144.6-64.6-224.4 0-232.6 189.2-421.8 422-421.8 112.6 0 218.6 44 298.2 123.6 79.6 79.8 123.4 185.6 123.4 298.4-0.2 232.8-189.4 422-421.8 422zM745.4 613.6c-12.6-6.4-75-37-86.6-41.2s-20-6.4-28.6 6.4c-8.4 12.6-32.8 41.2-40.2 49.8-7.4 8.4-14.8 9.6-27.4 3.2s-53.6-19.8-102-63c-37.6-33.6-63.2-75.2-70.6-87.8s-0.8-19.6 5.6-25.8c5.8-5.6 12.6-14.8 19-22.2s8.4-12.6 12.6-21.2c4.2-8.4 2.2-15.8-1-22.2s-28.6-68.8-39-94.2c-10.2-24.8-20.8-21.4-28.6-21.8-7.4-0.4-15.8-0.4-24.2-0.4s-22.2 3.2-33.8 15.8c-11.6 12.6-44.4 43.4-44.4 105.8s45.4 122.6 51.8 131.2c6.4 8.4 89.4 136.6 216.6 191.4 30.2 13 53.8 20.8 72.2 26.8 30.4 9.6 58 8.2 79.8 5 24.4-3.6 75-30.6 85.6-60.2s10.6-55 7.4-60.2c-3-5.6-11.4-8.8-24.2-15.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"whatsapp",
						"brand",
						"social"
					],
					"defaultCode": 61170,
					"grid": 16
				},
				{
					"id": 1690,
					"width": 877.716064453125,
					"paths": [
						"M562.857 556.571q7.429 0 55.714 25.143t51.143 30.286q1.143 2.857 1.143 8.571 0 18.857-9.714 43.429-9.143 22.286-40.571 37.429t-58.286 15.143q-32.571 0-108.571-35.429-56-25.714-97.143-67.429t-84.571-105.714q-41.143-61.143-40.571-110.857v-4.571q1.714-52 42.286-90.286 13.714-12.571 29.714-12.571 3.429 0 10.286 0.857t10.857 0.857q10.857 0 15.143 3.714t8.857 15.714q4.571 11.429 18.857 50.286t14.286 42.857q0 12-19.714 32.857t-19.714 26.571q0 4 2.857 8.571 19.429 41.714 58.286 78.286 32 30.286 86.286 57.714 6.857 4 12.571 4 8.571 0 30.857-27.714t29.714-27.714zM446.857 859.429q72.571 0 139.143-28.571t114.571-76.571 76.571-114.571 28.571-139.143-28.571-139.143-76.571-114.571-114.571-76.571-139.143-28.571-139.143 28.571-114.571 76.571-76.571 114.571-28.571 139.143q0 116 68.571 210.286l-45.143 133.143 138.286-44q90.286 59.429 197.143 59.429zM446.857 69.714q87.429 0 167.143 34.286t137.429 92 92 137.429 34.286 167.143-34.286 167.143-92 137.429-137.429 92-167.143 34.286q-111.429 0-208.571-53.714l-238.286 76.571 77.714-231.429q-61.714-101.714-61.714-222.286 0-87.429 34.286-167.143t92-137.429 137.429-92 167.143-34.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"whatsapp"
					],
					"defaultCode": 62002,
					"grid": 14
				},
				{
					"id": 1543,
					"width": 930.8569946289062,
					"paths": [
						"M584.571 678.286l58.286 116.571q-33.143 102.286-120 165.714t-193.714 63.429q-89.143 0-164.857-44.286t-120-120-44.286-164.857q0-103.429 59.714-188.571t156.857-120.571l9.714 74.857q-69.714 30.857-111.429 94.571t-41.714 139.714q0 105.714 75.143 180.857t180.857 75.143q72 0 132.857-37.143t94.286-100.286 28.286-135.143zM897.714 735.429l33.143 65.143-146.286 73.143q-7.429 4-16.571 4-22.857 0-32.571-20l-136.571-272.571h-269.714q-13.714 0-24.286-9.429t-12.286-23.143l-54.857-445.143q-1.143-9.143 3.429-24 8-29.143 32.571-47.143t55.429-18q37.714 0 64.571 26.857t26.857 64.571q0 39.429-29.714 67.143t-68.571 23.714l21.143 165.143h241.714v73.143h-232.571l9.143 73.143h260q22.857 0 32.571 20l130.286 260z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wheelchair"
					],
					"defaultCode": 61843,
					"grid": 14
				},
				{
					"id": 1789,
					"width": 880.0000381469727,
					"paths": [
						"M821.714 464.571q19.429 20 16.571 46.857l-25.143 314.857q-2.286 24-19.714 40t-40.857 16q-3.429 0-5.143-0.571-25.143-1.714-41.429-20.857t-14.571-44.286l20-245.143-81.714 4.571q31.429 64.571 31.429 137.143 0 123.429-84.571 212.571l-78.286-78.286q52-57.714 52-134.286 0-82.857-58.571-141.714t-141.429-58.857q-76.571 0-134.857 52.571l-78.286-78.857q68.571-65.143 162.286-80.571l150.857-171.429-85.143-49.714-103.429 92q-18.857 17.143-44 15.714t-41.714-20.286-15.143-44 19.714-41.714l136.571-121.714q14.857-13.143 34.286-15.143t36.571 8.286l278.857 161.714q20.571 12 27.429 38.857 9.714 38.286-14.857 66.857l-117.143 132.571 212-11.429q28-1.714 47.429 18.286zM708.571 203.429q-42.286 0-72-29.714t-29.714-72 29.714-72 72-29.714 72.286 29.714 30 72-30 72-72.286 29.714zM350.286 913.143q60.571 0 112-34.857l79.429 79.429q-83.429 66.286-191.429 66.286-84.571 0-156.286-41.714t-113.429-113.143-41.714-156q0-107.429 66.286-192l79.429 79.429q-34.286 50.286-34.286 112.571 0 82.857 58.571 141.429t141.429 58.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wheelchair-alt"
					],
					"defaultCode": 62107,
					"grid": 14
				},
				{
					"id": 176,
					"paths": [
						"M914.101 673.099c-9.997-9.997-26.206-9.997-36.203 0l-33.344 33.342-139.749-135.987c-0.082-0.078-0.17-0.144-0.251-0.222-0.366-0.346-0.746-0.67-1.13-0.994-0.282-0.235-0.56-0.478-0.848-0.701-0.33-0.254-0.674-0.488-1.016-0.726-0.362-0.251-0.718-0.507-1.090-0.739-0.288-0.178-0.586-0.336-0.88-0.502-0.434-0.246-0.864-0.498-1.309-0.715-0.282-0.139-0.573-0.258-0.861-0.386-0.461-0.206-0.92-0.419-1.389-0.597-0.347-0.131-0.701-0.234-1.054-0.352-0.418-0.138-0.832-0.286-1.254-0.4-0.45-0.125-0.909-0.216-1.366-0.314-0.336-0.072-0.667-0.158-1.005-0.218-0.518-0.091-1.043-0.146-1.57-0.205-0.29-0.032-0.576-0.077-0.867-0.099-0.51-0.038-1.029-0.045-1.546-0.053-0.32-0.005-0.64-0.021-0.962-0.014-0.45 0.010-0.902 0.048-1.355 0.083-0.402 0.030-0.803 0.054-1.203 0.102-0.374 0.046-0.749 0.114-1.123 0.178-0.483 0.080-0.965 0.165-1.442 0.272-0.114 0.026-0.229 0.035-0.342 0.064l-201.984 48.779c-5.45 1.314-10.174 0.683-13.304-1.781-3.13-2.467-4.854-6.91-4.854-12.515v-86.4h179.2c14.139 0 25.6-11.462 25.6-25.6s-11.461-25.6-25.6-25.6h-179.2v-156.176c8.275 1.686 16.834 2.576 25.6 2.576 70.579 0 128-57.421 128-128s-57.421-128-128-128-128 57.421-128 128c0 41.786 20.131 78.954 51.2 102.331v316.869c0 21.32 8.888 40.544 24.386 52.744 11.181 8.802 25.104 13.402 39.779 13.4 5.664 0 11.442-0.686 17.214-2.080l188.248-45.462 147.72 143.746c4.971 4.838 11.413 7.253 17.851 7.253 6.555 0 13.109-2.502 18.102-7.499l51.2-51.2c9.998-9.997 9.998-26.205 0-36.202zM486.4 102.4c42.347 0 76.8 34.453 76.8 76.8s-34.453 76.8-76.8 76.8c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8z",
						"M384 1024c-183.506 0-332.8-149.294-332.8-332.8 0-79.186 28.286-155.91 79.65-216.043 50.784-59.454 121-99.285 197.712-112.155 13.947-2.336 27.144 7.069 29.483 21.011 2.339 13.944-7.067 27.144-21.011 29.483-135.955 22.81-234.634 139.602-234.634 277.704 0 155.275 126.325 281.6 281.6 281.6 138.104 0 254.898-98.678 277.706-234.635 2.339-13.944 15.541-23.347 29.483-21.011 13.944 2.339 23.35 15.539 21.011 29.483-12.87 76.712-52.701 146.93-112.155 197.714-60.133 51.362-136.858 79.65-216.045 79.65z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wheelchair",
						"disabled",
						"accessibility"
					],
					"defaultCode": 59473,
					"grid": 20
				},
				{
					"id": 3243,
					"paths": [
						"M256 896v128l-192-160 192-160v128h512v-128l192 160-192 160v-128zM832 192h-640v320h640v-320zM960 64v0 576h-896v-576h896z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"width",
						"size"
					],
					"defaultCode": 61078,
					"grid": 16
				},
				{
					"id": 1626,
					"width": 1170.285774230957,
					"paths": [
						"M585.143 870.286q-11.429 0-53.143-42t-41.714-53.429q0-18.286 35.714-30.857t59.143-12.571 59.143 12.571 35.714 30.857q0 11.429-41.714 53.429t-53.143 42zM739.429 715.429q-1.143 0-22.857-14.286t-58-28.571-73.429-14.286-73.429 14.286-57.714 28.571-23.143 14.286q-10.286 0-53.429-42.857t-43.143-53.143q0-7.429 5.714-13.143 44.571-44 112-69.143t133.143-25.143 133.143 25.143 112 69.143q5.714 5.714 5.714 13.143 0 10.286-43.143 53.143t-53.429 42.857zM895.429 560q-6.286 0-13.143-4.571-77.714-60-144-88.286t-153.143-28.286q-48.571 0-97.429 12.571t-85.143 30.286-64.857 35.429-45.143 30.286-17.714 12.571q-9.714 0-52.571-42.857t-42.857-53.143q0-6.857 5.714-12.571 75.429-75.429 182.857-117.143t217.143-41.714 217.143 41.714 182.857 117.143q5.714 5.714 5.714 12.571 0 10.286-42.857 53.143t-52.571 42.857zM1050.286 405.143q-6.286 0-12.571-5.143-102.286-89.714-212.286-135.143t-240.286-45.429-240.286 45.429-212.286 135.143q-6.286 5.143-12.571 5.143-9.714 0-52.857-42.857t-43.143-53.143q0-7.429 5.714-13.143 106.857-106.286 254.286-164.571t301.143-58.286 301.143 58.286 254.286 164.571q5.714 5.714 5.714 13.143 0 10.286-43.143 53.143t-52.857 42.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wifi"
					],
					"defaultCode": 61931,
					"grid": 14
				},
				{
					"id": 3388,
					"paths": [
						"M966.8 233.6c0 3.2-1 6.2-3 9-2 2.6-4.2 4-6.8 4-20 2-36.4 8.4-49 19.2-12.8 10.8-25.8 31.8-39.2 62.4l-206.4 465.4c-1.4 4.4-5.2 6.4-11.4 6.4-4.8 0-8.6-2.2-11.4-6.4l-115.8-242-133.2 242c-2.8 4.4-6.4 6.4-11.4 6.4-6 0-9.8-2.2-11.8-6.4l-202.6-465.2c-12.6-28.8-26-49-40-60.4s-33.6-18.6-58.6-21.2c-2.2 0-4.2-1.2-6-3.4-2-2.2-2.8-4.8-2.8-7.8 0-7.6 2.2-11.4 6.4-11.4 18 0 37 0.8 56.8 2.4 18.4 1.6 35.6 2.4 51.8 2.4 16.4 0 36-0.8 58.4-2.4 23.4-1.6 44.2-2.4 62.4-2.4 4.4 0 6.4 3.8 6.4 11.4s-1.4 11.2-4 11.2c-18 1.4-32.4 6-42.8 13.8s-15.6 18-15.6 30.8c0 6.4 2.2 14.6 6.4 24.2l167.4 378.4 95.2-179.6-88.6-185.8c-16-33.2-29-54.6-39.2-64.2s-25.8-15.4-46.6-17.6c-2 0-3.6-1.2-5.4-3.4s-2.6-4.8-2.6-7.8c0-7.6 1.8-11.4 5.6-11.4 18 0 34.6 0.8 49.8 2.4 14.6 1.6 30 2.4 46.6 2.4 16.2 0 33.2-0.8 51.4-2.4 18.6-1.6 37-2.4 55-2.4 4.4 0 6.4 3.8 6.4 11.4s-1.2 11.2-4 11.2c-36.2 2.4-54.2 12.8-54.2 30.8 0 8 4.2 20.6 12.6 37.6l58.6 119 58.4-108.8c8-15.4 12.2-28.4 12.2-38.8 0-24.8-18-38-54.2-39.6-3.2 0-4.8-3.8-4.8-11.2 0-2.8 0.8-5.2 2.4-7.6s3.2-3.6 4.8-3.6c13 0 28.8 0.8 47.8 2.4 18 1.6 33 2.4 44.6 2.4 8.4 0 20.6-0.8 36.8-2 20.4-1.8 37.6-2.8 51.4-2.8 3.2 0 4.8 3.2 4.8 9.6 0 8.6-3 13-8.8 13-21 2.2-38 8-50.8 17.4s-28.8 30.8-48 64.4l-78.2 143.2 105.2 214.4 155.4-361.4c5.4-13.2 8-25.4 8-36.4 0-26.4-18-40.4-54.2-42.2-3.2 0-4.8-3.8-4.8-11.2 0-7.6 2.4-11.4 7.2-11.4 13.2 0 28.8 0.8 47 2.4 16.8 1.6 30.8 2.4 42 2.4 12 0 25.6-0.8 41.2-2.4 16.2-1.6 30.8-2.4 43.8-2.4 4 0 6 3.2 6 9.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wikipedia",
						"brand"
					],
					"defaultCode": 61223,
					"grid": 16
				},
				{
					"id": 1739,
					"width": 1316.568097114563,
					"paths": [
						"M853.714 936.571l-168.571-397.143q-14.286 28-90.571 174.571t-113.429 222.571q-0.571 0.571-15.714 0.286t-15.143-0.857q-46.857-110.286-146-335.429t-148.286-340.571q-12-28.571-38-61.429t-59.143-57.429-58.286-24.571q0-2.857-0.286-13.714t-0.286-15.429h333.143v28.571q-22.286 1.143-45.429 9.143t-38 24.571-5.714 36.571q14.857 33.714 123.714 285.143t134.571 308.571q17.714-34.857 80-152.286t74.857-141.429q-10.857-22.286-72-160.571t-77.714-168.571q-21.714-39.429-114.857-40.571v-28.571l293.143 0.571v26.857q-34.286 1.143-53.429 14.286t-7.143 39.429q18.857 40 49.714 108.286t49.143 107.143q62.857-122.286 98.857-207.429 13.714-31.429-5.714-45.429t-73.714-15.143q0.571-4 0.571-14.286v-13.714q36.571 0 97.429-0.286t102.857-0.571 52.857-0.286v28q-35.429 1.143-68 18.857t-51.429 46.286l-121.714 252.571q7.429 18.857 72.857 165.714t69.429 156.571l252-581.143q-8-21.714-28.286-35.714t-37.143-18-31.714-4.571v-28.571l262.857 2.286 0.571 1.143-0.571 25.143q-79.429 2.286-114.857 82.857-300.571 694.857-319.429 737.714h-28z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wikipedia-w"
					],
					"defaultCode": 62054,
					"grid": 14
				},
				{
					"id": 935,
					"width": 1024,
					"paths": [
						"M288 64c-52.928 0-96 43.072-96 96s43.072 96 96 96h32.032v-192h-32.032zM288 224c-35.36 0-64-28.64-64-64s28.64-64 64-64v128zM352 768v96c0 17.664 14.336 32 32 32h256c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-256c-17.664 0-32 14.336-32 32zM640 864h-256v-96h256v96zM544 544c105.952 0 191.872-85.824 192-191.776l0.032-32.224c93.568 0 168.352-80.288 159.232-175.712-7.936-83.2-82.56-144.288-166.112-144.288h-434.272c-83.552 0-158.208 61.088-166.144 144.288-9.088 95.424 65.696 175.712 159.264 175.712l0.032 32.192c0.128 105.952 86.048 191.776 192 191.776h15.968v63.968h-48c-17.664 0-32 14.336-32 32v32.064h-32c-53.024 0-96 42.976-96 96v160h-32c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h512c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-32v-160c0-53.024-42.976-96-96-96h-32v-32.032c0-17.664-14.336-32-32-32h-48v-64h16zM768 960v32h-512v-32h512zM640 704c35.36 0 64 28.64 64 64v160h-384v-160c0-35.36 28.64-64 64-64h256zM576 639.968v32h-128v-32h128zM480.032 512c-88.224 0-160-71.776-160-160v-64h-33.664c-69.856-0.896-126.368-57.952-126.368-128 0-70.592 57.408-128 128-128h448.032c70.592 0 128 57.408 128 128 0 70.048-56.512 127.104-126.368 128h-33.664v64c0 88.224-71.776 160-160 160h-63.968zM832.032 160c0-52.928-43.072-96-96-96h-32.032v192h32.032c52.928 0 96-43.072 96-96zM736.032 96c35.36 0 64 28.64 64 64s-28.64 64-64 64v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"win",
						"succeed",
						"reward"
					],
					"grid": 32
				},
				{
					"id": 936,
					"width": 1024,
					"paths": [
						"M529.184 544h13.6c106.624 0 193.088-86.368 193.184-192.992l0.032-29.888c0-0.64 0.512-1.12 1.152-1.152 92.672-0.64 166.624-80.096 158.208-174.688-7.456-83.808-83.104-145.28-167.264-145.28h-440.096c-88.352 0-160 71.648-160 160s71.648 160 160 160v0 30.784c0 106.72 86.496 193.216 193.184 193.216h13.6c0.672 0 1.184 0.544 1.184 1.184v61.6c0 0.672-0.544 1.184-1.184 1.184h-45.6c-18.336 0-33.184 14.848-33.184 33.184v29.632c0 0.672-0.512 1.216-1.184 1.216h-29.632c-53.664 0-97.184 43.52-97.184 97.184v157.6c0 0.672-0.544 1.216-1.184 1.216h-29.632c-18.336 0-33.184 14.848-33.184 33.184v29.6c0 18.368 14.848 33.216 33.184 33.216h509.6c18.368 0 33.216-14.848 33.216-33.184v-29.6c0-18.368-14.848-33.216-33.184-33.216h-29.6c-0.672 0-1.216-0.544-1.216-1.184v-157.6c0-53.696-43.52-97.216-97.184-97.216h-29.632c-0.672 0-1.184-0.544-1.184-1.184v-29.632c0-18.336-14.848-33.184-33.184-33.184h-45.6c-0.672 0-1.184-0.544-1.184-1.184v-61.6c-0.032-0.672 0.512-1.216 1.152-1.216zM736 64c53.024 0 96 42.976 96 96s-42.976 96-96 96v-192zM288 256c-53.024 0-96-42.976-96-96s42.976-96 96-96v192zM638.816 736c18.336 0 33.184 14.848 33.184 33.184v93.6c0 18.368-14.848 33.216-33.184 33.216h-253.6c-18.368 0-33.216-14.848-33.216-33.184v-93.6c0-18.368 14.848-33.216 33.184-33.216h253.632z",
						"M384 769.184v93.6c0 0.672 0.544 1.216 1.184 1.216h253.6c0.672 0 1.216-0.544 1.216-1.184v-93.6c0-0.672-0.544-1.216-1.184-1.216h-253.6c-0.672 0-1.216 0.544-1.216 1.184z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"win",
						"succeed",
						"reward"
					],
					"grid": 32
				},
				{
					"id": 1175,
					"width": 1024,
					"paths": [
						"M768 864v-224c0-17.664-14.336-32-32-32h-128v-48.608c111.712-39.648 192-146.272 192-271.392v-256c0-17.664-14.336-32-32-32h-512c-17.664 0-32 14.336-32 32v245.824c0 126.432 78.624 239.584 192 281.152v49.024h-128c-17.664 0-32 14.336-32 32v224h-32c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h576c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32h-32zM768 960h-512v-32h512v32zM480 576h64v64h-64v-64zM288 64h448v64h-448v-64zM288 288v-128h448v128c0 123.52-100.48 224-224 224s-224-100.48-224-224zM320 672h384v224h-384v-224zM384 736h256v32h-256v-32zM384 800h256v32h-256v-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"win",
						"succeed",
						"reward"
					],
					"grid": 32
				},
				{
					"id": 3381,
					"paths": [
						"M412.23 511.914c-47.708-24.518-94.086-36.958-137.88-36.958-5.956 0-11.952 0.18-17.948 0.708-55.88 4.624-106.922 19.368-139.75 30.828-8.708 3.198-17.634 6.576-26.83 10.306l-89.822 311.394c61.702-22.832 116.292-33.938 166.27-33.938 80.846 0 139.528 30.208 187.992 61.304 22.962-77.918 78.044-266.090 94.482-322.324-11.95-7.284-24.076-14.57-36.514-21.32zM528.348 591.070l-90.446 314.148c26.832 15.372 117.098 64.050 186.212 64.050 55.792 0 118.252-14.296 190.834-43.792l86.356-301.976c-58.632 18.922-114.876 28.52-167.464 28.52-95.95 0-163.114-31.098-205.492-60.95zM292.822 368.79c77.118 0.798 134.152 30.208 181.416 60.502l92.752-317.344c-19.546-11.196-70.806-39.094-107.858-48.6-24.386-5.684-50.020-8.616-77.204-8.616-51.796 0.976-108.388 13.946-172.888 39.8l-88.44 310.596c64.808-24.436 120.644-36.34 172.086-36.34 0.046 0.002 0.136 0.002 0.136 0.002zM1024 198.124c-58.814 22.832-116.208 34.466-171.028 34.466-91.686 0-159.292-31.802-203.094-62.366l-91.95 318.236c61.746 39.708 128.29 59.878 198.122 59.878 56.948 0 115.94-13.68 175.462-40.688l-0.182-2.222 3.734-0.886 88.936-306.418z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"windows",
						"brand",
						"os"
					],
					"defaultCode": 61216,
					"grid": 16
				},
				{
					"id": 1520,
					"width": 950.8569946289062,
					"paths": [
						"M389.714 574.857v372l-389.714-53.714v-318.286h389.714zM389.714 150.286v376.571h-389.714v-322.857zM950.857 574.857v449.143l-518.286-71.429v-377.714h518.286zM950.857 73.143v453.714h-518.286v-382.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"windows"
					],
					"defaultCode": 61818,
					"grid": 14
				},
				{
					"id": 3382,
					"paths": [
						"M0.35 512l-0.35-312.074 384-52.144v364.218zM448 138.482l511.872-74.482v448h-511.872zM959.998 576l-0.126 448-511.872-72.016v-375.984zM384 943.836l-383.688-52.594-0.020-315.242h383.708z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"windows8",
						"brand",
						"os"
					],
					"defaultCode": 61217,
					"grid": 16
				},
				{
					"id": 2847,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM542.74 711.028c140.248-27.706 249.11-91.542 288.454-176.594-21.654 167.956-161.518 297.566-330.85 297.566-119.242 0-223.858-64.282-282.892-160.948 70.41 55.058 194.534 65.808 325.288 39.976zM640 352c0-53.019 28.654-96 64-96s64 42.981 64 96c0 53.019-28.654 96-64 96s-64-42.981-64-96zM352 371.5c-41.796 0-77.334 15.656-90.516 37.5-3.54-5.866-5.484-32.174-5.484-38.75 0-31.066 42.98-56.25 96-56.25s96 25.184 96 56.25c0 6.576-1.944 32.884-5.484 38.75-13.182-21.844-48.72-37.5-90.516-37.5z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wink",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60682,
					"grid": 16
				},
				{
					"id": 2848,
					"paths": [
						"M512 0c-282.77 0-512 229.228-512 512 0 282.77 229.228 512 512 512 282.77 0 512-229.23 512-512 0-282.772-229.23-512-512-512zM704 256c35.346 0 64 42.98 64 96s-28.654 96-64 96-64-42.98-64-96 28.654-96 64-96zM352 312.062c59.646 0 102 22.332 102 57.282 0 7.398 3.812 42.994-0.17 49.594-14.828-24.576-54.81-42.188-101.83-42.188s-87.002 17.612-101.83 42.188c-3.982-6.6-0.17-42.196-0.17-49.594 0-34.95 42.354-57.282 102-57.282zM500.344 832c-119.242 0-223.858-64.28-282.892-160.952 70.41 55.060 194.534 65.81 325.288 39.978 140.248-27.706 249.11-91.542 288.454-176.594-21.654 167.96-161.518 297.568-330.85 297.568z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wink",
						"emoticon",
						"smiley",
						"face"
					],
					"defaultCode": 60683,
					"grid": 16
				},
				{
					"id": 2833,
					"paths": [
						"M576 96c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M719 512l49-35.5-133.286-206.116c-5.92-8.98-15.958-14.384-26.714-14.384h-256c-10.756 0-20.792 5.404-26.714 14.384l-133.286 206.116 49 35.5 110.644-143.596 38.458 89.74-134.102 245.856h122.666l21.334 320h64v-320h32v320h64l21.334-320h122.666l-134.104-245.858 38.458-89.74 110.646 143.598z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"woman",
						"female",
						"gender",
						"sex"
					],
					"defaultCode": 60668,
					"grid": 16
				},
				{
					"id": 2867,
					"paths": [
						"M512 1024c282.77 0 512-229.23 512-512s-229.23-512-512-512-512 229.23-512 512 229.23 512 512 512zM512 96c229.75 0 416 186.25 416 416s-186.25 416-416 416-416-186.25-416-416 186.25-416 416-416zM745.74 601.62l22.488 76.776-437.008 128.002-22.488-76.776zM256 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM640 320c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wondering",
						"emoticon",
						"smiley",
						"face",
						"question"
					],
					"defaultCode": 60702,
					"grid": 16
				},
				{
					"id": 2868,
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM704 256c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM256 320c0-35.346 28.654-64 64-64s64 28.654 64 64-28.654 64-64 64-64-28.654-64-64zM331.244 806.386l-22.488-76.774 437-128 22.488 76.774-437 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wondering",
						"emoticon",
						"smiley",
						"face",
						"question"
					],
					"defaultCode": 60703,
					"grid": 16
				},
				{
					"id": 3368,
					"paths": [
						"M128 511.992c0 148.026 88.322 275.968 216.43 336.578l-183.178-488.784c-21.308 46.508-33.252 97.982-33.252 152.206zM771.228 493.128c0-46.234-17.054-78.236-31.654-103.142-19.458-30.82-37.72-56.894-37.72-87.716 0-34.374 26.766-66.376 64.486-66.376 1.704 0 3.32 0.204 4.976 0.302-68.316-60.97-159.34-98.196-259.308-98.196-134.16 0-252.186 67.046-320.844 168.568 9.010 0.282 17.506 0.454 24.712 0.454 40.154 0 102.34-4.752 102.34-4.752 20.69-1.182 23.132 28.434 2.458 30.822 0 0-20.81 2.368-43.952 3.55l139.834 405.106 84.044-245.456-59.822-159.65c-20.688-1.184-40.278-3.55-40.278-3.55-20.702-1.192-18.272-32.002 2.438-30.822 0 0 63.4 4.752 101.134 4.752 40.146 0 102.35-4.752 102.35-4.752 20.702-1.182 23.14 28.434 2.446 30.822 0 0-20.834 2.372-43.948 3.55l138.78 402.018 38.312-124.632c16.58-51.75 29.216-88.9 29.216-120.9zM518.742 544.704l-115.226 326.058c34.416 9.858 70.794 15.238 108.488 15.238 44.716 0 87.604-7.518 127.518-21.2-1.018-1.602-1.974-3.304-2.75-5.154l-118.030-314.942zM848.962 332.572c1.652 11.91 2.588 24.686 2.588 38.458 0 37.93-7.292 80.596-29.202 133.95l-117.286 330.272c114.162-64.828 190.938-185.288 190.938-323.258 0-65.030-17.060-126.16-47.038-179.422zM512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 960c-247.424 0-448-200.576-448-448s200.576-448 448-448 448 200.576 448 448-200.576 448-448 448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wordpress",
						"brand",
						"social",
						"cms"
					],
					"defaultCode": 61203,
					"grid": 16
				},
				{
					"id": 1550,
					"width": 1024,
					"paths": [
						"M72.571 512q0-93.143 38.286-178.857l209.714 574.286q-112-54.286-180-160.571t-68-234.857zM808.571 489.714q0 10.857-1.429 22t-5.714 28.286-6.571 25.143-10 33.714-10 33.143l-43.429 146.286-158.857-472q26.286-1.714 50.286-4.571 10.857-1.143 14.857-10.571t-1.429-17.714-16.286-7.714l-117.143 5.714q-42.857-0.571-115.429-5.714-6.857-0.571-11.714 2.857t-6.571 8.571-0.857 10.571 5.143 9.429 11.143 4.571l45.714 4.571 68.571 187.429-96 288-160-475.429q26.286-1.714 50.286-4.571 10.857-1.143 14.857-10.571t-1.429-17.714-16.286-7.714l-117.143 5.714q-4 0-13.143-0.286t-14.857-0.286q60-91.429 156.857-144.857t210-53.429q84 0 160.286 30.286t136.286 85.143h-5.714q-31.429 0-52.571 23.143t-21.143 54.571q0 6.857 1.143 13.714t2.286 12.286 4.571 13.143 5.143 12 6.857 12.857 7.143 12 8.286 13.714 8 13.143q36 61.143 36 121.143zM519.429 550.286l135.429 369.714q0.571 3.429 2.857 6.286-72 25.143-145.714 25.143-64 0-124-18.286zM897.143 301.143q54.286 99.429 54.286 210.857 0 119.429-59.429 220.286t-159.429 159.143l134.286-387.429q33.714-96.571 33.714-157.714 0-24-3.429-45.143zM512 0q104 0 198.857 40.571t163.429 109.143 109.143 163.429 40.571 198.857-40.571 198.857-109.143 163.429-163.429 109.143-198.857 40.571-198.857-40.571-163.429-109.143-109.143-163.429-40.571-198.857 40.571-198.857 109.143-163.429 163.429-109.143 198.857-40.571zM512 1000.571q98.857 0 189.429-38.857t156-104.286 104.286-156 38.857-189.429-38.857-189.429-104.286-156-156-104.286-189.429-38.857-189.429 38.857-156 104.286-104.286 156-38.857 189.429 38.857 189.429 104.286 156 156 104.286 189.429 38.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wordpress"
					],
					"defaultCode": 61850,
					"grid": 14
				},
				{
					"id": 937,
					"width": 1024,
					"paths": [
						"M640 400v0c0 8.832 7.168 16 16 16h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16zM656 480h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM656 544h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM656 608h224c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16zM512 576v-192c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v192h-32v-128c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v128h-32v-160c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v160h-16c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h384c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-16zM224 576h-32v-160h32v160zM352 576h-32v-128h32v128zM480 576h-32v-192h32v192zM928 128h-832c-53.024 0-96 42.976-96 96v512c0 53.024 42.976 96 96 96h288v96h-48c-8.832 0-16 7.168-16 16v0c0 8.832 7.168 16 16 16h352c8.832 0 16-7.168 16-16v0c0-8.832-7.168-16-16-16h-48v-96h288c53.024 0 96-42.976 96-96v-512c0-53.024-42.976-96-96-96zM608 928h-192v-96h192v96zM992 736c0 35.36-28.64 64-64 64h-832c-35.36 0-64-28.64-64-64v-512c0-35.36 28.64-64 64-64h832c35.36 0 64 28.64 64 64v512z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"work",
						"chart",
						"write",
						"compute"
					],
					"grid": 32
				},
				{
					"id": 938,
					"width": 1024,
					"paths": [
						"M320 448h32v128h-32v-128zM1024 224v512c0 53.024-42.976 96-96 96h-832c-53.024 0-96-42.976-96-96v-512c0-53.024 42.976-96 96-96h832c53.024 0 96 42.976 96 96zM544 592c0-8.832-7.168-16-16-16h-16v-192c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v192h-32v-128c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v128h-32v-160c0-17.664-14.336-32-32-32h-32c-17.664 0-32 14.336-32 32v160h-16c-8.832 0-16 7.168-16 16s7.168 16 16 16h384c8.832 0 16-7.168 16-16zM896 592c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM896 528c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM896 464c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM896 400c0-8.832-7.168-16-16-16h-224c-8.832 0-16 7.168-16 16s7.168 16 16 16h224c8.832 0 16-7.168 16-16zM448 576h32v-192h-32v192zM192 576h32v-160h-32v160zM688 928h-48v-64h-256v64h-48c-8.832 0-16 7.168-16 16s7.168 16 16 16h352c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"work",
						"chart",
						"write",
						"compute"
					],
					"grid": 32
				},
				{
					"id": 1176,
					"width": 1024,
					"paths": [
						"M928 160h-832v576h832v-576zM896 704h-768v-512h768v512zM992.32 64h-960.64c-17.504 0-31.68 14.176-31.68 31.68v704.64c0 17.504 14.176 31.68 31.68 31.68h320.32v64h-32.32c-17.504 0-31.68 14.176-31.68 31.68v0.64c0 17.504 14.176 31.68 31.68 31.68h384.64c17.504 0 31.68-14.176 31.68-31.68v-0.64c0-17.504-14.176-31.68-31.68-31.68h-32.32v-64h320.32c17.504 0 31.68-14.176 31.68-31.68v-704.64c0-17.504-14.176-31.68-31.68-31.68zM608 896h-192v-96h192v96zM960 768h-896v-640h896v640zM672 384h-320v-32h320v32zM672 448h-320v-32h320v32zM672 512h-320v-32h320v32zM192 256h-32v-32h32v32zM256 256h-32v-32h32v32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"work",
						"write",
						"compute"
					],
					"grid": 32
				},
				{
					"id": 939,
					"width": 1024,
					"paths": [
						"M842.944 549.472l-138.944-69.472v-36.672c0-36.352-20.544-69.6-53.056-85.856l-74.944-37.472v-96h32c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-32v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-32c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h32v96l-74.944 37.472c-32.512 16.256-53.056 49.504-53.056 85.856v36.672l-138.944 69.472c-32.512 16.256-53.056 49.504-53.056 85.856v228.672c0 53.024 42.976 96 96 96h576c53.024 0 96-42.976 96-96v-228.672c0-36.352-20.544-69.6-53.056-85.856zM416 192v-64h64v-64h64v64h64v64h-64v128h-64v-128h-64zM387.392 386.080l68.16-34.080h112.896l68.192 34.080c21.792 10.912 35.36 32.864 35.36 57.248v36.672h-320v-36.672c0-24.384 13.568-46.336 35.392-57.248zM576 928h-128v-192h128v192zM864 864c0 35.296-28.704 64-64 64h-192v-192c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v192h-192c-35.296 0-64-28.704-64-64v-228.672c0-24.384 13.568-46.336 35.392-57.248l132.16-66.080h368.896l132.192 66.080c21.792 10.912 35.36 32.864 35.36 57.248v228.672zM320 704h-64c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32zM320 832h-64v-96h64v96zM768 704h-64c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-96c0-17.664-14.336-32-32-32zM768 832h-64v-96h64v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"worship",
						"gather",
						"pray"
					],
					"grid": 32
				},
				{
					"id": 940,
					"width": 1024,
					"paths": [
						"M448 736h128v224h-128v-224zM704 448v-4.672c0-36.352-20.544-69.6-53.056-85.856l-74.944-37.472v-96h32c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-32v-32c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v32h-32c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h32v96l-74.944 37.472c-32.512 16.256-53.056 49.504-53.056 85.856v4.672h384zM256 832h64v-96h-64v96zM896 635.328v228.672c0 53.024-42.976 96-96 96h-192v-224c0-17.664-14.336-32-32-32h-128c-17.664 0-32 14.336-32 32v224h-192c-53.024 0-96-42.976-96-96v-228.672c0-36.352 20.544-69.6 53.056-85.856l138.944-69.472h384l138.944 69.472c32.512 16.256 53.056 49.504 53.056 85.856zM352 736c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-96zM800 736c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v96c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-96zM704 832h64v-96h-64v96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"worship",
						"gather",
						"pray"
					],
					"grid": 32
				},
				{
					"id": 1785,
					"width": 1024.002052307129,
					"paths": [
						"M219.429 475.429h91.429v-128h-91.429v128zM697.714 665.143v-52.571q-59.429 20.571-138.857 21.714-77.143 0.571-148.286-26.571t-126-70l0.571 54.857q50.286 45.714 121.143 73.429t155.429 27.143q73.714 0 136-28zM365.714 475.429h365.714v-128h-365.714v128zM1024 457.143q0 106.857-56.571 201.143 50.857 58.286 50.857 130.857 0 89.714-74 153.143t-179.143 63.429q-69.714 0-128.571-30t-92-80.286q-10.857 0.571-32.571 0.571t-32.571-0.571q-33.143 50.286-92 80.286t-128.571 30q-105.143 0-179.143-63.429t-74-153.143q0-72.571 50.857-130.857-56.571-94.286-56.571-201.143 0-119.429 68.571-220.286t186.571-159.714 256.857-58.857 256.857 58.857 186.571 159.714 68.571 220.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wpbeginner"
					],
					"defaultCode": 62103,
					"grid": 14
				},
				{
					"id": 1786,
					"width": 877.7149963378906,
					"paths": [
						"M294.286 520.571v73.143h-144v-73.143h144zM294.286 374.857v72.571h-144v-72.571h144zM727.429 666.857v73.143h-194.857v-73.143h194.857zM727.429 520.571v73.143h-384v-73.143h384zM727.429 374.857v72.571h-384v-72.571h384zM804.571 866.286v-708.571q0-4.571-3.429-8t-8-3.429h-18.286l-216 146.286-120-97.714-120 97.714-216-146.286h-18.286q-4.571 0-8 3.429t-3.429 8v708.571q0 4.571 3.429 8t8 3.429h708.571q4.571 0 8-3.429t3.429-8zM316 232l105.714-85.714h-232zM561.714 232l126.286-85.714h-232zM877.714 157.714v708.571q0 35.429-24.571 60t-60 24.571h-708.571q-35.429 0-60-24.571t-24.571-60v-708.571q0-35.429 24.571-60t60-24.571h708.571q35.429 0 60 24.571t24.571 60z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wpforms"
					],
					"defaultCode": 62104,
					"grid": 14
				},
				{
					"id": 2413,
					"paths": [
						"M1002.934 817.876l-460.552-394.76c21.448-40.298 33.618-86.282 33.618-135.116 0-159.058-128.942-288-288-288-29.094 0-57.172 4.332-83.646 12.354l166.39 166.39c24.89 24.89 24.89 65.62 0 90.51l-101.49 101.49c-24.89 24.89-65.62 24.89-90.51 0l-166.39-166.39c-8.022 26.474-12.354 54.552-12.354 83.646 0 159.058 128.942 288 288 288 48.834 0 94.818-12.17 135.116-33.62l394.76 460.552c22.908 26.724 62.016 28.226 86.904 3.338l101.492-101.492c24.888-24.888 23.386-63.994-3.338-86.902z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wrench",
						"tool",
						"fix",
						"settings",
						"control",
						"options",
						"preferences"
					],
					"defaultCode": 60248,
					"grid": 16
				},
				{
					"id": 2414,
					"paths": [
						"M840.876 1024c0 0 0 0 0 0-25.362 0-49.568-11.272-66.414-30.924l-354.15-413.176c-37.218 15.82-77.642 24.1-118.312 24.1-166.524 0-302-135.476-302-302 0-29.816 4.36-59.322 12.956-87.698l15.486-51.116 193.758 193.758c5.242 5.242 12.274 8.128 19.8 8.128s14.558-2.886 19.8-8.128l95.146-95.148c10.916-10.916 10.916-28.682 0-39.6l-193.758-193.752 51.114-15.488c28.374-8.596 57.88-12.956 87.698-12.956 166.524 0 302 135.478 302 302 0 40.662-8.28 81.086-24.1 118.31l413.176 354.15c18.962 16.256 29.922 38.67 30.862 63.114 0.938 24.442-8.272 47.626-25.932 65.286l-95.148 95.148c-16.76 16.762-38.774 25.992-61.982 25.992zM436.276 500.182l386.78 451.242c4.74 5.532 11.068 8.576 17.822 8.576 4.324 0 10.736-1.258 16.726-7.246l95.148-95.15c4.91-4.91 7.478-11.152 7.232-17.576-0.248-6.426-3.288-12.454-8.56-16.974l-451.236-386.776 12.048-22.64c18.162-34.13 27.764-72.734 27.764-111.638 0-131.234-106.766-238-238-238-4.152 0-8.294 0.108-12.426 0.32l112.626 112.626c35.87 35.872 35.87 94.238 0 130.108l-95.146 95.146c-17.33 17.33-40.432 26.874-65.054 26.874-24.62 0-47.724-9.544-65.054-26.874l-112.626-112.624c-0.212 4.132-0.32 8.274-0.32 12.424 0 131.234 106.766 238 238 238 38.912 0 77.514-9.602 111.634-27.764l22.642-12.054z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wrench",
						"tool",
						"fix",
						"settings",
						"control",
						"options",
						"preferences"
					],
					"defaultCode": 60249,
					"grid": 16
				},
				{
					"id": 2415,
					"paths": [
						"M136.234 40.236l119.766 119.764-128 128-119.766-119.764c-5.348 17.65-8.234 36.368-8.234 55.764 0 106.042 85.96 192 192 192 19.394 0 38.114-2.884 55.764-8.232l368.47 368.468c-5.348 17.65-8.234 36.368-8.234 55.764 0 106.042 85.96 192 192 192 19.394 0 38.116-2.884 55.764-8.234l-119.764-119.766 128-128 119.764 119.766c5.348-17.652 8.236-36.37 8.236-55.766 0-106.042-85.962-192-192-192-19.396 0-38.118 2.886-55.766 8.236l-368.47-368.468c5.348-17.654 8.236-36.372 8.236-55.768 0-106.040-85.962-192-192-192-19.396 0-38.116 2.888-55.766 8.236z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wrench",
						"tool",
						"fix",
						"settings",
						"control",
						"options",
						"preferences"
					],
					"defaultCode": 60250,
					"grid": 16
				},
				{
					"id": 1342,
					"width": 961.7181167602539,
					"paths": [
						"M219.429 841.143q0-14.857-10.857-25.714t-25.714-10.857-25.714 10.857-10.857 25.714 10.857 25.714 25.714 10.857 25.714-10.857 10.857-25.714zM587.429 601.143l-389.714 389.714q-21.143 21.143-51.429 21.143-29.714 0-52-21.143l-60.571-61.714q-21.714-20.571-21.714-51.429 0-30.286 21.714-52l389.143-389.143q22.286 56 65.429 99.143t99.143 65.429zM949.714 352.571q0 22.286-13.143 60.571-26.857 76.571-94 124.286t-147.714 47.714q-105.714 0-180.857-75.143t-75.143-180.857 75.143-180.857 180.857-75.143q33.143 0 69.429 9.429t61.429 26.571q9.143 6.286 9.143 16t-9.143 16l-167.429 96.571v128l110.286 61.143q2.857-1.714 45.143-27.714t77.429-46.286 40.286-20.286q8.571 0 13.429 5.714t4.857 14.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"wrench"
					],
					"defaultCode": 61613,
					"grid": 14
				},
				{
					"id": 941,
					"width": 1024,
					"paths": [
						"M608 0h-192c-53.024 0-96 42.976-96 96v704c0 17.664 14.336 32 32 32l128 128v30.624c0 16.704 12.224 31.648 28.864 33.216 19.072 1.824 35.136-13.12 35.136-31.84v-32l128-128c17.664 0 32-14.336 32-32v-704c0-53.024-42.976-96-96-96zM530.752 928h-37.472l-96-96h229.504l-96.032 96zM672 800h-320v-448h32v128c0 35.36 28.64 64 64 64s64-28.64 64-64v-128h160v448zM672 320h-192v160c0 17.632-14.368 32-32 32s-32-14.368-32-32v-160h-64v-224c0-35.36 28.64-64 64-64h192c35.36 0 64 28.64 64 64v224z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"write",
						"edit",
						"compose"
					],
					"grid": 32
				},
				{
					"id": 942,
					"width": 1024,
					"paths": [
						"M704 320h-224v160c0 17.664-14.336 32-32 32s-32-14.336-32-32v-160h-96v-224c0-53.024 42.976-96 96-96h192c53.024 0 96 42.976 96 96v224zM704 800v-448h-192v128c0 17.088-6.656 33.152-18.752 45.248s-28.16 18.752-45.248 18.752c-35.296 0-64-28.704-64-64v-128h-64v448c0 17.664 14.336 32 32 32h320c17.664 0 32-14.336 32-32zM384 864l96 96v30.624c0 16.704 12.224 31.648 28.864 33.216 19.072 1.824 35.136-13.12 35.136-31.84v-32l96-96h-256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"write",
						"edit",
						"compose"
					],
					"grid": 32
				},
				{
					"id": 1177,
					"width": 1024,
					"paths": [
						"M982.624 297.376l-150.624-150.624v-114.752c0-17.664-14.336-32-32-32h-704c-17.664 0-32 14.336-32 32v960c0 17.664 14.336 32 32 32h704c17.664 0 32-14.336 32-32v-498.752l150.624-150.624c12.512-12.48 12.512-32.768 0-45.248zM381.472 564.096l142.464 142.464-166.208 23.744 23.744-166.208zM548.672 686.048l-146.752-146.752 265.376-265.376 146.752 146.752-265.376 265.376zM836.672 398.048l-146.752-146.752 78.080-78.048 146.752 146.752-78.080 78.048zM128 960v-896h640v64l-128 128h-384v32h352l-64 64h-288v32h256l-64 64h-192v32h160l-56.448 56.448c-2.208 2.208-3.968 4.8-5.44 7.552h-98.112v32h91.424l-9.152 64h-82.272v32h77.728l-9.152 64h-68.576v32h64l213.44-30.496c6.848-0.992 13.216-4.16 18.112-9.056l216.448-216.448v448h-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"write",
						"edit",
						"compose"
					],
					"grid": 32
				},
				{
					"id": 3399,
					"paths": [
						"M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM312.6 666h-110.6c-6.6 0-11.6-3-14.4-7.6-3-4.8-3-10.8 0-17l117.6-207.6c0.2-0.2 0.2-0.4 0-0.6l-74.8-129.6c-3-6.2-3.6-12.2-0.6-17 2.8-4.6 8.4-7 15.2-7h110.8c17 0 25.4 11 30.8 20.8 0 0 75.6 132 76.2 132.8-4.4 8-119.6 211.4-119.6 211.4-6 10.4-14 21.4-30.6 21.4zM836.4 152.2l-245.2 433.6c-0.2 0.2-0.2 0.6 0 0.8l156.2 285.2c3 6.2 3.2 12.4 0.2 17.2-2.8 4.6-8 7-14.8 7h-110.6c-17 0-25.4-11.2-31-21 0 0-157-288-157.4-288.8 7.8-13.8 246.4-437 246.4-437 6-10.6 13.2-21 29.6-21h112.2c6.6 0 12 2.6 14.8 7 2.8 4.6 2.8 10.8-0.4 17z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"xing",
						"brand",
						"social"
					],
					"defaultCode": 61234,
					"grid": 16
				},
				{
					"id": 1504,
					"width": 877.7129821777344,
					"paths": [
						"M391.429 437.143q0-0.571-72-126.857-12-19.429-29.714-19.429h-105.143q-10.286 0-14.857 6.286-4 6.857 0.571 16.571l71.429 123.429v0.571l-112 197.714q-5.143 8 0 16 4.571 7.429 13.714 7.429h105.714q17.714 0 28.571-20.571zM748 153.143q-4-6.857-13.714-6.857h-106.857q-17.143 0-28 20l-234.857 416.571q0.571 1.143 149.714 274.857 11.429 20 29.714 20h105.143q10.286 0 14.286-6.857 4.571-7.429-0.571-16l-148.571-272v-0.571l233.714-413.143q4.571-9.143 0-16zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"xing-square"
					],
					"defaultCode": 61801,
					"grid": 14
				},
				{
					"id": 3400,
					"paths": [
						"M155.6 202.2c-8.8 0-16.4 3.2-20.2 9.2-3.8 6.4-3.2 14.4 0.8 22.6l99.8 172.8c0.2 0.4 0.2 0.6 0 0.8l-156.8 277.2c-4 8.2-3.8 16.4 0 22.6 3.8 6 10.4 10 19.2 10h147.6c22 0 32.8-15 40.2-28.6 0 0 153.4-271.4 159.4-282-0.6-1-101.6-177-101.6-177-7.4-13-18.4-27.6-41.2-27.6h-147.2z",
						"M776 0c-22 0-31.6 13.8-39.6 28.2 0 0-318.2 564.2-328.6 582.8 0.6 1 209.8 385 209.8 385 7.4 13 18.6 28.2 41.2 28.2h147.6c8.8 0 15.8-3.4 19.6-9.4 4-6.4 3.8-14.6-0.4-22.8l-208-380.6c-0.2-0.4-0.2-0.6 0-1l327-578.2c4-8.2 4.2-16.4 0.4-22.8-3.8-6-10.8-9.4-19.6-9.4h-149.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"xing",
						"brand",
						"social"
					],
					"defaultCode": 61235,
					"grid": 16
				},
				{
					"id": 1503,
					"width": 805.1440277099609,
					"paths": [
						"M341.143 381.143q-5.714 10.286-146.857 260.571-15.429 26.286-37.143 26.286h-136.571q-12 0-17.714-9.714t0-20.571l144.571-256q0.571 0 0-0.571l-92-159.429q-6.857-12.571-0.571-21.143 5.143-8.571 18.286-8.571h136.571q22.857 0 37.714 25.714zM801.714 14.286q6.286 9.143 0 21.143l-301.714 533.714v0.571l192 351.429q6.286 11.429 0.571 21.143-5.714 8.571-18.286 8.571h-136.571q-24 0-37.714-25.714l-193.714-355.429q10.286-18.286 303.429-538.286 14.286-25.714 36.571-25.714h137.714q12.571 0 17.714 8.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"xing"
					],
					"defaultCode": 61800,
					"grid": 14
				},
				{
					"id": 1699,
					"width": 877.7139892578125,
					"paths": [
						"M462.286 573.714l152-285.143h-64l-89.714 178.286q-13.714 27.429-25.143 52.571l-24-52.571-88.571-178.286h-68.571l150.286 281.714v185.143h57.714v-181.714zM877.714 73.143v877.714h-877.714v-877.714h877.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"y-combinator",
						"yc"
					],
					"defaultCode": 62011,
					"grid": 14
				},
				{
					"id": 3375,
					"paths": [
						"M568.2 589v0c112.6-197.6 298.6-520 349.6-589-22.4 15-56.8 22.6-88.4 29.8l-47.8-29.8c-38.4 71.6-180 303-270.2 451.2-91.4-151.4-199.6-326.2-270.2-451.2-56 12-79.2 12.6-135 0v0 0c0 0 0 0 0 0v0c110.8 166.8 288.2 484.6 348.6 589v0l-8.2 435 64.8-29.8v-0.8l64.8 30.6-8-435z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"yahoo",
						"brand",
						"social"
					],
					"defaultCode": 61210,
					"grid": 16
				},
				{
					"id": 3376,
					"paths": [
						"M513.2 69.6c-181 0-352-23.8-513.2-69.6 0 361.8 0 933.2 0 1024 161.4-45.8 332.4-69.6 513.2-69.6 178.8 0 349.4 23.2 510.8 69.6 0-348.4 0-649.8 0-1024-161.4 46.4-331.8 69.6-510.8 69.6zM796.8 157l-6.2 9.8c-5.8 9.2-11 17-18.2 28-9.6 14.4-27.6 43-49.2 79.8-6 10.2-13.4 22.4-21 35.6-14.6 24.6-31 52.4-44 74.4-5.4 9.4-10.8 19-16.4 28.6-14.4 25-29.2 50.8-43.4 75.6-14.6 25.8-29 51.2-43.4 76.4v25.4c0 35.2 0.8 73.6 2 107.8 0.6 15.6 1.2 43.4 2 72.8 0.8 35 1.6 71.2 2.6 89.6l0.2 5.6v0.6l-6-1.6c-2.4-0.6-4.6-1.2-7-1.8-7.2-1.6-15-2.8-22.6-3.6-4.6-0.4-9.4-0.6-14.2-0.6 0 0 0 0 0 0s0 0 0 0c-4.8 0-9.6 0.2-14.2 0.6-7.6 0.8-15.4 2-22.6 3.6-2.4 0.6-4.8 1.2-7 1.8l-6 1.6v-0.6l0.2-5.6c0.8-18.2 1.8-54.6 2.6-89.6 0.6-29.4 1.4-57.2 2-72.8 1.4-34.4 2-72.6 2-107.8v-25.4c-14.4-25.4-28.8-50.6-43.4-76.4-14.2-25-29-50.6-43.2-75.6-5.6-9.6-11-19.2-16.4-28.6-12.8-22.2-29.4-50-44-74.4-7.8-13-15.2-25.4-21-35.6-21.6-36.8-39.6-65.2-49.2-79.8-7.2-11-12.4-18.8-18.2-28l-6.2-9.8 11.2 3.2c14.2 4 28.8 6 44.4 6s30.6-2 44.6-6l3.4-1 1.8 3c27.6 49.8 101.8 171.8 146.2 244.8 15.2 25.2 27.4 45 33.4 55.2 0 0 0 0 0-0.2 0 0 0 0 0 0.2 6-10 18.2-30 33.4-55.2 44.4-72.8 118.6-194.8 146.2-244.8l1.8-3 3.4 1c14 4 29 6 44.6 6s30.2-2 44.4-6l10.6-3.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"yahoo"
					],
					"defaultCode": 61211,
					"grid": 16
				},
				{
					"id": 1554,
					"width": 877.7159729003906,
					"paths": [
						"M490.857 546.857l7.429 404q-35.429-6.286-60-6.286-23.429 0-60 6.286l7.429-404q-22.857-39.429-96.286-168.857t-123.714-214-103.429-164q33.143 8.571 61.714 8.571 24.571 0 63.429-8.571 36 63.429 76.286 131.143t95.429 158 79.143 129.714q21.143-34.857 62.571-101.429t67.143-108.571 60-100.571 61.143-108.286q30.857 8 61.143 8 32 0 65.143-8v0q-16 22.286-34.286 50.571t-28.286 44.857-32.286 54.857-28 48q-83.429 141.714-201.714 348.571z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"yahoo"
					],
					"defaultCode": 61854,
					"grid": 14
				},
				{
					"id": 1178,
					"width": 1024,
					"paths": [
						"M992.064 74.848c-3.008 0-6.080 0.416-9.152 1.344l-822.912 243.808h-128c-17.664 0-32 14.336-32 32v288c0 17.664 14.336 32 32 32h128l128 42.656v181.344c0 17.664 14.336 32 32 32h288c17.664 0 32-14.336 32-32v-64l341.888 113.952c3.392 1.12 6.816 1.664 10.176 1.664 16.992 0 31.936-13.76 31.936-32.032v-808.736c0-18.176-14.88-32-31.936-32zM192 377.28l640-189.632v640.896l-640-213.344v-237.92zM64 608v-224h96v224h-96zM576 864h-224v-128l224 74.656v53.344zM960 871.2l-96-32v-661.056l96-28.448v721.504z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"yell",
						"broadcast",
						"shout"
					],
					"grid": 32
				},
				{
					"id": 3403,
					"paths": [
						"M608.876 653.468c-17.282 17.426-2.668 49.128-2.668 49.128l130.090 217.218c0 0 21.36 28.64 39.864 28.64 18.59 0 36.954-15.27 36.954-15.27l102.844-147.008c0 0 10.36-18.546 10.598-34.792 0.372-23.106-34.454-29.434-34.454-29.434l-243.488-78.192c-0.002 0.004-23.858-6.328-39.74 9.71zM596.532 543.984c12.46 21.128 46.828 14.972 46.828 14.972l242.938-71.006c0 0 33.106-13.466 37.832-31.418 4.64-17.954-5.46-39.622-5.46-39.622l-116.098-136.752c0 0-10.062-17.292-30.938-19.032-23.016-1.958-37.18 25.898-37.18 25.898l-137.27 216.010c0 0.004-12.134 21.516-0.652 40.95zM481.754 459.768c28.608-7.044 33.148-48.604 33.148-48.604l-1.944-345.87c0 0-4.314-42.666-23.486-54.232-30.070-18.242-38.982-8.718-47.596-7.444l-201.696 74.944c0 0-19.754 6.536-30.042 23.018-14.69 23.352 14.928 57.544 14.928 57.544l209.644 285.756c0 0 20.69 21.396 47.044 14.888zM431.944 599.738c0.722-26.676-32.030-42.7-32.030-42.7l-216.796-109.524c0 0-32.126-13.246-47.722-4.016-11.95 7.060-22.536 19.84-23.572 31.134l-14.12 173.812c0 0-2.116 30.114 5.69 43.82 11.054 19.442 47.428 5.902 47.428 5.902l253.096-55.942c9.832-6.61 27.074-7.204 28.026-42.486zM494.88 693.542c-21.726-11.156-47.724 11.95-47.724 11.95l-169.468 186.566c0 0-21.144 28.528-15.768 46.050 5.066 16.418 13.454 24.578 25.318 30.328l170.192 53.726c0 0 20.634 4.286 36.258-0.242 22.18-6.43 18.094-41.152 18.094-41.152l3.848-252.602c-0.002 0.002-0.868-24.334-20.75-34.624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"yelp",
						"brand",
						"social"
					],
					"defaultCode": 61238,
					"grid": 16
				},
				{
					"id": 1624,
					"width": 878.2870407104492,
					"paths": [
						"M441.714 753.714v72.571q-0.571 166.857-3.429 174.286-6.857 18.286-29.143 22.857-30.857 5.143-103.714-21.714t-92.857-50.857q-7.429-8.571-9.714-20.571-0.571-6.857 2.286-14.857 2.286-5.714 19.429-26.857t103.429-123.429q0.571 0 34.286-40 8.571-10.857 22.571-14t28.286 2q13.714 5.714 21.429 16.571t7.143 24zM356.571 610.286q-1.714 31.429-29.714 40l-68.571 22.286q-157.143 50.286-166.857 50.286-20-1.143-30.857-20.571-6.857-14.286-9.714-42.857-4.571-43.429 0.571-95.143t17.143-71.143 32-18.286q7.429 0 115.429 44 40 16.571 65.714 26.857l48 19.429q13.143 5.143 20.286 17.429t6.571 27.714zM828.571 780q-4 30.857-52.286 92t-77.429 72.571q-21.143 8-36-4-8-5.714-105.143-164l-26.857-44q-8-12-6.571-26.286t11.143-26.286q20-24.571 47.429-14.857 0.571 0.571 68 22.857 116 37.714 138.286 45.429t26.857 11.714q16 12.571 12.571 34.857zM444.571 418.857q2.857 58.286-30.857 69.714-33.143 9.714-65.143-40.571l-216-341.714q-4.571-20 10.857-35.429 23.429-24.571 118.571-51.143t128.286-18q22.857 5.714 28 25.714 1.714 10.286 12.571 174.571t13.714 216.857zM822.857 480.571q1.714 22.286-14.857 33.714-8.571 5.714-188 49.143-38.286 8.571-52 13.143l0.571-1.143q-13.143 3.429-26.286-2.286t-21.143-18.286q-17.143-26.857 0-49.714 0.571-0.571 42.857-58.286 71.429-97.714 85.714-116.571t19.429-22.286q16-10.857 37.143-1.143 27.429 13.143 70.286 76.286t46.286 95.714v1.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"yelp"
					],
					"defaultCode": 61929,
					"grid": 14
				},
				{
					"id": 2838,
					"paths": [
						"M448 256c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zM512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 832c-35.348 0-64-28.652-64-64s28.652-64 64-64c35.346 0 64 28.652 64 64s-28.654 64-64 64zM512 512c-114.876 0-208 93.124-208 208s93.124 208 208 208c-229.75 0-416-186.25-416-416s186.25-416 416-416c114.876 0 208 93.124 208 208s-93.124 208-208 208z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"yin-yang"
					],
					"defaultCode": 60673,
					"grid": 16
				},
				{
					"id": 1809,
					"width": 950.8579940795898,
					"paths": [
						"M193.714 124.571h394.857l-14.857 41.143h-380q-62.857 0-107.714 45.143t-44.857 108v440.571q0 54.286 34.571 96.857t87.714 53.429q13.143 2.857 56 2.857v41.143h-25.714q-80 0-136.857-57.143t-56.857-137.143v-440.571q0-80 56.857-137.143t136.857-57.143zM680 0h141.143l-275.429 739.429q-13.143 34.857-23.143 59.143t-25.714 56-30.857 53.429-36.857 44.857-45.429 37.143-54.571 23.429-66.286 10.571v-111.429q93.143-14.857 125.714-104 11.429-29.714 11.429-60 0-30.857-11.429-60.571l-162.857-418.857h130.286l106.857 334.286zM950.857 318.857v634.857h-454.286q21.143-31.429 25.714-41.714h387.429v-593.143q0-48.571-28.286-88.571t-74-56.571l14.286-38.286q57.714 19.429 93.429 70.571t35.714 112.857z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"yoast"
					],
					"defaultCode": 62129,
					"grid": 14
				},
				{
					"id": 3345,
					"paths": [
						"M1013.8 307.2c0 0-10-70.6-40.8-101.6-39-40.8-82.6-41-102.6-43.4-143.2-10.4-358.2-10.4-358.2-10.4h-0.4c0 0-215 0-358.2 10.4-20 2.4-63.6 2.6-102.6 43.4-30.8 31-40.6 101.6-40.6 101.6s-10.2 82.8-10.2 165.8v77.6c0 82.8 10.2 165.8 10.2 165.8s10 70.6 40.6 101.6c39 40.8 90.2 39.4 113 43.8 82 7.8 348.2 10.2 348.2 10.2s215.2-0.4 358.4-10.6c20-2.4 63.6-2.6 102.6-43.4 30.8-31 40.8-101.6 40.8-101.6s10.2-82.8 10.2-165.8v-77.6c-0.2-82.8-10.4-165.8-10.4-165.8zM406.2 644.8v-287.8l276.6 144.4-276.6 143.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"youtube",
						"brand",
						"social"
					],
					"defaultCode": 61180,
					"grid": 16
				},
				{
					"id": 1505,
					"width": 1024.0000309944153,
					"paths": [
						"M731.429 512q0-21.143-17.143-30.857l-292.571-182.857q-17.714-11.429-37.143-1.143-18.857 10.286-18.857 32v365.714q0 21.714 18.857 32 9.143 4.571 17.714 4.571 11.429 0 19.429-5.714l292.571-182.857q17.143-9.714 17.143-30.857zM1024 512q0 54.857-0.571 85.714t-4.857 78-12.857 84.286q-9.143 41.714-39.429 70.286t-70.857 33.143q-126.857 14.286-383.429 14.286t-383.429-14.286q-40.571-4.571-71.143-33.143t-39.714-70.286q-8-37.143-12.286-84.286t-4.857-78-0.571-85.714 0.571-85.714 4.857-78 12.857-84.286q9.143-41.714 39.429-70.286t70.857-33.143q126.857-14.286 383.429-14.286t383.429 14.286q40.571 4.571 71.143 33.143t39.714 70.286q8 37.143 12.286 84.286t4.857 78 0.571 85.714z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"youtube-play"
					],
					"defaultCode": 61802,
					"grid": 14
				},
				{
					"id": 1501,
					"width": 877.7129821777344,
					"paths": [
						"M525.143 744.571v-89.714q0-28.571-16.571-28.571-9.714 0-18.857 9.143v128q9.143 9.143 18.857 9.143 16.571 0 16.571-28zM630.286 674.857h37.714v-19.429q0-29.143-18.857-29.143t-18.857 29.143v19.429zM304 522.857v40h-45.714v241.714h-42.286v-241.714h-44.571v-40h132.571zM418.857 594.857v209.714h-38.286v-22.857q-22.286 25.714-43.429 25.714-18.857 0-24-16-3.429-9.143-3.429-30.857v-165.714h37.714v154.286q0 13.714 0.571 14.857 0.571 8.571 8.571 8.571 11.429 0 24-17.714v-160h38.286zM562.857 658.286v83.429q0 29.714-4 41.714-6.857 24-30.286 24-20 0-38.857-23.429v20.571h-38.286v-281.714h38.286v92q18.286-22.857 38.857-22.857 23.429 0 30.286 24 4 12 4 42.286zM706.286 732v5.143q0 16.571-1.143 24.571-1.714 12.571-8.571 22.857-15.429 22.857-45.714 22.857-29.714 0-46.286-21.714-12-15.429-12-49.143v-73.714q0-33.714 11.429-49.143 16.571-21.714 45.714-21.714t44.571 21.714q12 16 12 49.143v43.429h-76v37.143q0 29.143 19.429 29.143 13.714 0 17.143-14.857 0-0.571 0.286-4t0.286-9.429v-12.286h38.857zM448.571 261.143v89.143q0 29.143-18.286 29.143t-18.286-29.143v-89.143q0-29.714 18.286-29.714t18.286 29.714zM753.143 668.571q0-101.143-10.857-148.571-5.714-25.143-24.571-42t-43.429-19.714q-77.714-8.571-235.429-8.571-157.143 0-234.857 8.571-25.143 2.857-43.714 19.714t-24.286 42q-11.429 49.714-11.429 148.571 0 100.571 11.429 148.571 5.714 24.571 24.286 41.714t43.143 20q78.286 8.571 235.429 8.571t235.429-8.571q24.571-2.857 43.143-20t24.286-41.714q11.429-48 11.429-148.571zM321.714 296.571l51.429-169.143h-42.857l-29.143 111.429-30.286-111.429h-44.571l13.714 39.429t13.143 39.429q20 58.857 26.286 90.286v114.857h42.286v-114.857zM486.857 342.857v-74.286q0-33.143-12-49.714-16.571-21.714-44.571-21.714-29.143 0-44.571 21.714-12 16.571-12 49.714v74.286q0 33.143 12 49.714 15.429 21.714 44.571 21.714 28 0 44.571-21.714 12-15.429 12-49.714zM590.286 411.429h38.286v-211.429h-38.286v161.714q-12.571 17.714-24 17.714-8.571 0-9.143-9.143-0.571-1.143-0.571-14.857v-155.429h-38.286v167.429q0 21.143 3.429 31.429 6.286 15.429 24.571 15.429 20.571 0 44-25.714v22.857zM877.714 237.714v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"youtube-square"
					],
					"defaultCode": 61798,
					"grid": 14
				},
				{
					"id": 3346,
					"width": 2569,
					"paths": [
						"M344.012 169.399c0.209-0.865 0.344-1.479 0.388-1.8l1.042-7.559-47.349-0.267c-42.779-0.242-55.87 0.007-57.047 1.084-0.565 0.516-15.333 56.633-41.655 158.273-12.556 48.484-23.124 87.206-23.487 86.051s-15.391-56.498-33.397-122.98c-18.006-66.482-33.104-121.243-33.55-121.692-0.623-0.623-57.98-0.9-104.417-0.502-6.735 0.056-10.477-13.11 60.021 211.133 9.759 31.041 24.371 74.997 32.469 97.679 9.333 26.141 15.989 46.323 20.534 63.173 8.038 32.067 8.319 52.163 6.565 75.625-2.026 27.101-2.321 218.438-0.342 221.638 1.512 2.449 91.223 3.589 99.712 1.268 1.358-0.372 2.265-1.691 2.87-8.928 2.119-6.219 2.286-30.969 2.286-133.744v-131.281l5.742-18.112c3.756-11.849 13.201-42.995 20.989-69.22 7.789-26.222 17.21-57.619 20.938-69.771 33.834-110.319 66.14-218.831 66.994-225.011l0.693-5.056z",
						"M846.122 328.651l-0.021 6.838-1.065 0.014-0.595 188.993-0.577 183.227-14.666 14.929c-16.424 16.719-29.585 23.101-41.488 20.113-12.963-3.254-12.64 1.8-13.722-214.768l-0.998-199.347h-94.316v6.851h-1.086v216.289c0 231.737-0.007 231.599 11.752 254.875 9.366 18.536 23.010 27.559 46.391 30.671h0.002c30.79 4.1 64.001-9.849 94.77-39.809l13.373-13.022v22.445c0 19.396 0.554 22.601 4.070 23.58 5.756 1.605 77.173 1.707 84.89 0.126l6.396-1.314v-6.628l1.086-0.223v-495.098l-94.195 1.258z",
						"M606.892 426.33c-8.935-38.341-25.68-64.115-53.233-81.939-43.281-27.999-92.718-30.957-138.586-8.291-33.425 16.515-54.951 43.914-66.071 84.083-1.326 4.786-2.298 8.812-3.033 14.815-2.83 14.184-3.163 35.351-3.889 133.951-1.121 151.928 0.616 170.003 19.643 204.51 18.664 33.848 57.403 58.661 99.572 63.782 12.696 1.54 38.43-0.858 53.23-4.961 33.632-9.326 65.864-35.906 80.118-66.078 6.158-13.033 9.875-22.096 12.115-38.651 4.175-22.617 4.47-59.175 4.47-152.375-0.002-118.875-0.379-131.862-4.337-148.847zM499.34 736.003c-7.907 6.028-21.734 8.649-32.983 6.249-8.656-1.847-20.338-15.419-23.934-27.801-4.479-15.436-4.823-229.985-0.954-272.059 6.379-21.054 24.19-32.050 43.635-26.813 15.157 4.082 22.915 13.575 27.336 33.457 3.282 14.754 3.67 33.129 2.972 141.26-0.46 71.701-0.716 106.742-3.058 125.553-2.382 11.87-6.319 15.047-13.015 20.154z",
						"M2300.389 534.137h45.57l-0.726-41.281c-0.705-37.869-1.263-42.2-6.324-52.472-7.982-16.21-19.759-23.401-38.446-23.401-22.448 0-36.678 10.849-43.388 33.141-2.858 9.486-5.863 74.685-3.707 80.308 1.205 3.144 7.724 3.705 47.021 3.705z",
						"M1995.795 440.237c-6.077-12.247-17.385-18.278-30.525-17.806-10.221 0.365-21.561 4.677-32.488 13.010l-8.14 6.177v296.598l8.14 6.177c18.429 14.052 38.674 17.031 52.619 7.703 5.519-3.691 9.117-8.779 11.919-16.861 3.647-10.524 3.965-24.003 3.489-148.772-0.495-130.043-0.781-137.702-5.014-146.226z",
						"M2560.878 306.633c-9.080-108.842-16.303-144.165-38.751-189.544-29.729-60.101-72.692-91.788-133.876-98.747-47.309-5.379-225.315-12.97-390.044-16.631-285.188-6.338-754.057 5.858-813.939 21.173-27.673 7.077-48.426 19.11-70.022 40.604-37.844 37.662-60.391 91.679-69.452 166.396-20.692 170.606-21.134 376.727-1.188 553.515 8.577 76.041 26.243 125.443 59.41 166.159 20.694 25.406 56.352 46.998 88.26 53.442 22.385 4.523 134.42 10.798 297.605 16.668 24.306 0.874 88.667 2.379 143.030 3.344 113.301 2.012 321.627 0.821 440.719-2.519 80.127-2.249 226.201-8.172 253.5-10.282 7.677-0.593 25.469-1.728 39.537-2.523 47.277-2.67 77.353-12.568 105.596-34.76 36.553-28.718 64.857-81.795 76.815-144.037 11.314-58.894 18.887-163.773 20.422-282.851 1.284-99.491-0.426-153.175-7.621-239.409zM1425.273 267.192l-52.982 0.654-2.326 565.143-45.932 0.581c-35.525 0.488-46.307-0.044-47.167-2.326-0.616-1.626-1.356-129.020-1.672-283.153l-0.581-280.246-103.493-1.307v-88.304l305.829 1.235 1.307 87.069-52.982 0.654zM1750.216 591.117v243.035h-83.725v-25.583c0-19.247-0.735-25.583-2.979-25.583-1.64 0-9.226 6.344-16.861 14.098-16.557 16.817-36.171 30.367-52.91 36.63-34.662 12.968-67.589 5.4-81.618-18.75-12.838-22.11-13.082-27.052-13.082-256.335v-210.547h83.653l0.654 198.265c0.623 194.821 0.714 198.393 5.377 206.333 6.182 10.521 15.608 13.347 30.597 9.231 8.817-2.423 14.836-6.707 29.143-20.931l18.024-17.952v-374.946h83.725v243.035zM2076.757 799.41c-7.372 16.424-23.806 32.509-37.283 36.485-35.167 10.382-63.375 1.923-95.935-28.708-10.103-9.505-19.51-17.224-20.931-17.224-1.712 0-2.616 7.449-2.616 22.094v22.094h-83.725v-655.845h83.725v106.982c0 58.84 0.786 106.982 1.744 106.982s9.789-7.807 19.624-17.298c22.629-21.841 41.548-31.399 65.557-33.213 42.811-3.24 68.327 18.794 80.018 69.117 3.647 15.696 3.998 33.625 3.998 179.078-0.002 177.178-0.021 177.918-14.175 209.457zM2430.99 702.168c-0.744 18.226-2.954 39.137-4.942 46.514-11.642 43.167-42.635 73.731-87.432 86.269-60.315 16.878-126.704-10.777-153.205-63.812-14.875-29.769-15.408-35.706-15.408-181.185 0-118.617 0.419-133.171 4.214-149.354 10.747-45.788 37.392-75.422 82.49-91.865 13.068-4.765 26.708-7.207 40.337-7.486 48.672-0.998 96.984 25.18 117.229 67.808 13.659 28.76 15.35 41.060 16.717 122.099l1.235 72.678-178.497 1.235-0.654 48.84c-0.93 68.901 3.716 90.088 22.313 102.621 15.645 10.54 39.679 9.745 52.765-1.744 12.263-10.768 15.726-22.336 16.933-56.107l1.091-29.653h86.195l-1.381 33.143z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"youtube",
						"brand",
						"social"
					],
					"defaultCode": 61181,
					"grid": 16
				},
				{
					"id": 1502,
					"width": 877.7149772644043,
					"paths": [
						"M554.857 710.857v120.571q0 38.286-22.286 38.286-13.143 0-25.714-12.571v-172q12.571-12.571 25.714-12.571 22.286 0 22.286 38.286zM748 711.429v26.286h-51.429v-26.286q0-38.857 25.714-38.857t25.714 38.857zM196 586.857h61.143v-53.714h-178.286v53.714h60v325.143h57.143v-325.143zM360.571 912h50.857v-282.286h-50.857v216q-17.143 24-32.571 24-10.286 0-12-12-0.571-1.714-0.571-20v-208h-50.857v223.429q0 28 4.571 41.714 6.857 21.143 33.143 21.143 27.429 0 58.286-34.857v30.857zM605.714 827.429v-112.571q0-41.714-5.143-56.571-9.714-32-40.571-32-28.571 0-53.143 30.857v-124h-50.857v378.857h50.857v-27.429q25.714 31.429 53.143 31.429 30.857 0 40.571-31.429 5.143-15.429 5.143-57.143zM798.857 821.714v-7.429h-52q0 29.143-1.143 34.857-4 20.571-22.857 20.571-26.286 0-26.286-39.429v-49.714h102.286v-58.857q0-45.143-15.429-66.286-22.286-29.143-60.571-29.143-38.857 0-61.143 29.143-16 21.143-16 66.286v98.857q0 45.143 16.571 66.286 22.286 29.143 61.714 29.143 41.143 0 61.714-30.286 10.286-15.429 12-30.857 1.143-5.143 1.143-33.143zM451.429 300v-120q0-39.429-24.571-39.429t-24.571 39.429v120q0 40 24.571 40t24.571-40zM862.286 729.143q0 133.714-14.857 200-8 33.714-33.143 56.571t-58.286 26.286q-105.143 12-317.143 12t-317.143-12q-33.143-3.429-58.571-26.286t-32.857-56.571q-14.857-64-14.857-200 0-133.714 14.857-200 8-33.714 33.143-56.571t58.857-26.857q104.571-11.429 316.571-11.429t317.143 11.429q33.143 4 58.571 26.857t32.857 56.571q14.857 64 14.857 200zM292 0h58.286l-69.143 228v154.857h-57.143v-154.857q-8-42.286-34.857-121.143-21.143-58.857-37.143-106.857h60.571l40.571 150.286zM503.429 190.286v100q0 46.286-16 67.429-21.143 29.143-60.571 29.143-38.286 0-60-29.143-16-21.714-16-67.429v-100q0-45.714 16-66.857 21.714-29.143 60-29.143 39.429 0 60.571 29.143 16 21.143 16 66.857zM694.857 97.714v285.143h-52v-31.429q-30.286 35.429-58.857 35.429-26.286 0-33.714-21.143-4.571-13.714-4.571-42.857v-225.143h52v209.714q0 18.857 0.571 20 1.714 12.571 12 12.571 15.429 0 32.571-24.571v-217.714h52z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"youtube"
					],
					"defaultCode": 61799,
					"grid": 14
				},
				{
					"id": 943,
					"width": 1024,
					"paths": [
						"M480 288c0-17.664 14.336-32 32-32s32 14.336 32 32c0 17.664-14.336 32-32 32s-32-14.336-32-32zM608 0h-32c-17.664 0-32 14.336-32 32v32h-64v-32c0-17.664-14.336-32-32-32h-32c-53.024 0-96 42.976-96 96v832c0 53.024 42.976 96 96 96h192c53.024 0 96-42.976 96-96v-832c0-53.024-42.976-96-96-96zM474.24 96h75.52l35.904 179.456c3.776 18.88-1.056 38.24-13.248 53.12-12.224 14.88-30.272 23.424-49.504 23.424h-21.792c-19.264 0-37.28-8.544-49.504-23.424-12.192-14.88-17.024-34.24-13.248-53.12l35.872-179.456zM544 992h-128c-35.36 0-64-28.64-64-64v-832c0-35.36 28.64-64 64-64h32v46.112c-2.368 3.456-4.288 7.296-5.152 11.616l-35.904 179.456c-7.968 39.84 10.176 77.472 41.024 98.208v48.608c0 17.664 14.336 32 32 32h64v32h-64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h64v32h-64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h64v32h-64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h64v32h-64c-17.664 0-32 14.336-32 32v32c0 17.664 14.336 32 32 32h64v32zM672 928c0 35.36-28.64 64-64 64h-32v-32c0-17.664-14.336-32-32-32h-64v-32h64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-64v-32h64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-64v-32h64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-64v-32h64c17.664 0 32-14.336 32-32v-32c0-17.664-14.336-32-32-32h-64v-34.4c6.784 1.504 13.824 2.4 21.088 2.4h21.792c60.576 0 106.016-55.424 94.144-114.816l-35.904-179.456c-0.832-4.352-2.752-8.16-5.12-11.616v-46.112h32c35.36 0 64 28.64 64 64v832z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"zip",
						"close",
						"fasten"
					],
					"grid": 32
				},
				{
					"id": 944,
					"width": 1024,
					"paths": [
						"M608 0h-32c-17.664 0-32 14.336-32 32v32h-64v-32c0-17.664-14.336-32-32-32h-32c-53.024 0-96 42.976-96 96v832c0 53.024 42.976 96 96 96h128v-64h-80c-8.832 0-16-7.168-16-16v-64c0-8.832 7.168-16 16-16h80v-32h-80c-8.832 0-16-7.168-16-16v-64c0-8.832 7.168-16 16-16h80v-32h-80c-8.832 0-16-7.168-16-16v-64c0-8.832 7.168-16 16-16h80v-32h-80c-8.832 0-16-7.168-16-16v-64c0-8.832 7.168-16 16-16h80v-32h-80c-8.832 0-16-7.168-16-16v-64h0.992c9.536 6.24 19.84 11.168 31.008 13.664v34.336h80c8.832 0 16 7.168 16 16v64c0 8.832-7.168 16-16 16h-80v32h80c8.832 0 16 7.168 16 16v64c0 8.832-7.168 16-16 16h-80v32h80c8.832 0 16 7.168 16 16v64c0 8.832-7.168 16-16 16h-80v32h80c8.832 0 16 7.168 16 16v64c0 8.832-7.168 16-16 16h-80v32h80c8.832 0 16 7.168 16 16v80h32c53.024 0 96-42.976 96-96v-832c0-53.024-42.976-96-96-96zM572.384 328.576c-12.192 14.88-30.24 23.424-49.472 23.424h-21.792c-19.264 0-37.28-8.544-49.504-23.424-12.192-14.88-17.024-34.24-13.248-53.12l35.872-179.456h75.52l35.904 179.456c3.776 18.88-1.056 38.24-13.28 53.12zM544 288c0 17.664-14.336 32-32 32s-32-14.336-32-32 14.336-32 32-32c17.664 0 32 14.336 32 32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"zip",
						"close",
						"fasten"
					],
					"grid": 32
				},
				{
					"id": 2374,
					"paths": [
						"M1024 864l-300.486-300.486c28.384-53.576 44.486-114.66 44.486-179.514 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c64.854 0 125.938-16.102 179.514-44.486l300.486 300.486 160-160zM128 384c0-141.384 114.616-256 256-256s256 114.616 256 256-114.616 256-256 256-256-114.616-256-256z",
						"M576 320h-128v-128h-128v128h-128v128h128v128h128v-128h128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"zoom-in",
						"magnifier",
						"magnifier-plus",
						"enlarge"
					],
					"defaultCode": 60209,
					"grid": 16
				},
				{
					"id": 2377,
					"paths": [
						"M384 192h-64v128h-128v64h128v128h64v-128h128v-64h-128zM637.542 557.848c41.806-57.89 66.458-128.984 66.458-205.848 0-194.404-157.596-352-352-352s-352 157.596-352 352 157.596 352 352 352c76.864 0 147.958-24.652 205.848-66.458l338.152 386.458 128-128-386.458-338.152zM352 608c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"zoom-in",
						"magnifier",
						"magnifier-plus",
						"enlarge"
					],
					"defaultCode": 60212,
					"grid": 16
				},
				{
					"id": 2381,
					"paths": [
						"M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.068 91.842-154.078 91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c95.098 0 182.108-34.586 249.176-91.844-1 21.662 9.36 48.478 31.926 73.552l206.294 242.552c35.322 39.246 93.022 42.554 128.22 7.356s31.892-92.898-7.354-128.22zM384 640c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256zM448 192h-128v128h-128v128h128v128h128v-128h128v-128h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"zoom-in",
						"magnifier",
						"magnifier-plus",
						"enlarge"
					],
					"defaultCode": 60216,
					"grid": 16
				},
				{
					"id": 2375,
					"paths": [
						"M1024 864l-300.486-300.486c28.384-53.576 44.486-114.66 44.486-179.514 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c64.854 0 125.938-16.102 179.514-44.486l300.486 300.486 160-160zM128 384c0-141.384 114.616-256 256-256s256 114.616 256 256-114.616 256-256 256-256-114.616-256-256z",
						"M192 320h384v128h-384v-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"zoom-out",
						"magnifier",
						"magnifier-minus",
						"reduce"
					],
					"defaultCode": 60210,
					"grid": 16
				},
				{
					"id": 2378,
					"paths": [
						"M192 320h320v64h-320zM637.542 557.848c41.806-57.89 66.458-128.984 66.458-205.848 0-194.404-157.596-352-352-352s-352 157.596-352 352 157.596 352 352 352c76.864 0 147.958-24.652 205.848-66.458l338.152 386.458 128-128-386.458-338.152zM352 608c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"zoom-out",
						"magnifier",
						"magnifier-minus",
						"reduce"
					],
					"defaultCode": 60213,
					"grid": 16
				},
				{
					"id": 2382,
					"paths": [
						"M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.068 91.842-154.078 91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c95.098 0 182.108-34.586 249.176-91.844-1 21.662 9.36 48.478 31.926 73.552l206.294 242.552c35.322 39.246 93.022 42.554 128.22 7.356s31.892-92.898-7.354-128.22zM384 640c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256zM192 320h384v128h-384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"tags": [
						"zoom-out",
						"magnifier",
						"magnifier-minus",
						"reduce"
					],
					"defaultCode": 60217,
					"grid": 16
				}
			],
			"colorThemes": [],
			"invisible": false
		}
	],
	"uid": 94492,
	"premium": true,
	"preferences": {
		"showGlyphs": true,
		"showCodes": false,
		"showQuickUse": true,
		"showQuickUse2": true,
		"showSVGs": true,
		"fontPref": {
			"prefix": "qd-",
			"metadata": {
				"fontFamily": "quodeck",
				"majorVersion": 1,
				"minorVersion": 0
			},
			"metrics": {
				"emSize": 1024,
				"baseline": 6.25,
				"whitespace": 50
			},
			"embed": false,
			"showSelector": true,
			"showMetrics": true,
			"showMetadata": false,
			"showVersion": true,
			"noie8": true,
			"ie7": false,
			"autoHost": true
		},
		"imagePref": {
			"prefix": "icon-",
			"png": true,
			"useClassSelector": true,
			"color": 0,
			"bgColor": 16777215
		},
		"historySize": 100,
		"showLiga": false,
		"quickUsageToken": {
			"QuoDeck": false
		}
	},
	"time": 1467356606588
}